
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("h1Y8a", function(module, exports) {
/**
 * @generated SignedSource<<1b4f02e7263ffdbf99d8f7524bb6fd9f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0b5629b07134c74a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "FullPageEditorComponentReadFragment",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "EDITOR"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"EDITOR\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$0b5629b07134c74a$var$node.hash = "9c9352ccf1b8c8a448af05f4d82f86d8";
var $0b5629b07134c74a$export$2e2bcd8739ae039 = $0b5629b07134c74a$var$node;


/**
 * @generated SignedSource<<05a0667d673a6e238f5d882c8f652941>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c51db01a6bc02cc7$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "FullPageEditorComponentReadFragmentWithAppKey",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "EDITOR"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appKey"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"EDITOR\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$c51db01a6bc02cc7$var$node.hash = "408702134304d89a181c7bc6576d7cb4";
var $c51db01a6bc02cc7$export$2e2bcd8739ae039 = $c51db01a6bc02cc7$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2XqLN = parcelRequire("2XqLN");


var $a4TK8 = parcelRequire("a4TK8");


var $ibzAc = parcelRequire("ibzAc");


var $2v1PW = parcelRequire("2v1PW");


var $inPa6 = parcelRequire("inPa6");


var $eiA8Z = parcelRequire("eiA8Z");


var $bre0g = parcelRequire("bre0g");


var $iu6m9 = parcelRequire("iu6m9");


var $lxDfD = parcelRequire("lxDfD");


var $fbPMY = parcelRequire("fbPMY");


var $4tOXV = parcelRequire("4tOXV");


var $3mVfX = parcelRequire("3mVfX");


var $5fMeR = parcelRequire("5fMeR");


var $frIzR = parcelRequire("frIzR");








var $8aF6s = parcelRequire("8aF6s");


var $3jwuS = parcelRequire("3jwuS");


var $hPTbh = parcelRequire("hPTbh");


var $bUH8D = parcelRequire("bUH8D");


var $jxXkP = parcelRequire("jxXkP");

const $59950bb13ffc10fc$export$88533b05a0c6a0b9 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, editorAPIRef: editorAPIRef } = t0;
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t1;
    if ($[0] !== contentId || $[1] !== editorAPIRef || $[2] !== fireButtonClickedAnalytic || $[3] !== isLivePage || $[4] !== showModal || $[5] !== spaceId || $[6] !== spaceKey) {
        t1 = (origin)=>{
            const editorAPI = editorAPIRef?.current;
            if (!editorAPI) return;
            const actions = editorAPI.selectionExtension?.actions;
            const document = actions?.getDocumentFromSelection?.();
            const docAdf = document?.selectedNodeAdf;
            const adfContent = docAdf?.content?.filter($59950bb13ffc10fc$var$_temp);
            if (!adfContent || adfContent.length === 0) return;
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).CREATE_SNIPPET, {
                origin: origin,
                pageMode: isLivePage ? (0, $hPTbh.ANALYTICS_PAGE_MODE).LIVE : (0, $hPTbh.ANALYTICS_PAGE_MODE).EDIT,
                selectionLength: JSON.stringify(adfContent)?.length
            });
            showModal((0, $bUH8D.CreateSnippetModal), {
                adf: docAdf,
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                editorAPI: editorAPI,
                analyticsOrigin: origin
            });
        };
        $[0] = contentId;
        $[1] = editorAPIRef;
        $[2] = fireButtonClickedAnalytic;
        $[3] = isLivePage;
        $[4] = showModal;
        $[5] = spaceId;
        $[6] = spaceKey;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
function $59950bb13ffc10fc$var$_temp(content) {
    return content !== undefined;
}



var $cYuYM = parcelRequire("cYuYM");





var $isFEX = parcelRequire("isFEX");


var $6mKj3 = parcelRequire("6mKj3");




const $3e829d70fd4a50e0$var$messages = (0, $aXWIB.defineMessages)({
    createBlockTemplate: {
        id: "snippets.createBlockTemplate",
        defaultMessage: "Create block template"
    },
    createBlockTemplateLozenge: {
        id: "snippets.createBlockTemplateLozenge",
        defaultMessage: "New"
    }
});
const $3e829d70fd4a50e0$export$be35007b21bd127c = ({ formatMessage: formatMessage, onCreateSnippet: onCreateSnippet })=>{
    if (!(0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) return [];
    const toolbarConfiguration = {
        getMenuItems: ()=>{
            return [
                {
                    label: formatMessage($3e829d70fd4a50e0$var$messages.createBlockTemplate),
                    lozenge: {
                        label: formatMessage($3e829d70fd4a50e0$var$messages.createBlockTemplateLozenge)
                    },
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($isFEX))),
                    onClick: ()=>onCreateSnippet((0, $hPTbh.ANALYTICS_ORIGIN).CONTEXTUAL_TOOLBAR)
                }
            ];
        }
    };
    /**
   * placement: 'featured' allows the button to show up on the top level of the
   * block menu, instead of under the Turn Into -> Create subsection
   */ const blockMenuConfiguration = {
        placement: 'featured',
        getMenuItems: ()=>{
            return [
                {
                    label: formatMessage($3e829d70fd4a50e0$var$messages.createBlockTemplate),
                    lozenge: {
                        label: formatMessage($3e829d70fd4a50e0$var$messages.createBlockTemplateLozenge)
                    },
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($isFEX))),
                    onClick: ()=>onCreateSnippet((0, $hPTbh.ANALYTICS_ORIGIN).BLOCK_MENU)
                }
            ];
        }
    };
    return [
        {
            key: 'create-snippet',
            source: 'first-party',
            inlineToolbar: toolbarConfiguration,
            blockMenu: blockMenuConfiguration
        }
    ];
};


const $0e1c17ea1b1a2ab6$export$94cce102debd6a0e = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, editorAPIRef: editorAPIRef } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isCreateEnabled = (0, $cYuYM.useIsSnippetCreateEnabled)();
    let t1;
    if ($[0] !== contentId || $[1] !== editorAPIRef || $[2] !== spaceId || $[3] !== spaceKey) {
        t1 = {
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey,
            editorAPIRef: editorAPIRef
        };
        $[0] = contentId;
        $[1] = editorAPIRef;
        $[2] = spaceId;
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    const handleCreateSnippet = (0, $59950bb13ffc10fc$export$88533b05a0c6a0b9)(t1);
    if (!isCreateEnabled) {
        let t2;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = [];
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    let t2;
    if ($[6] !== formatMessage || $[7] !== handleCreateSnippet) {
        t2 = (0, $3e829d70fd4a50e0$export$be35007b21bd127c)({
            formatMessage: formatMessage,
            onCreateSnippet: handleCreateSnippet
        });
        $[6] = formatMessage;
        $[7] = handleCreateSnippet;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};





var $dLc9m = parcelRequire("dLc9m");




var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $8SCD6 = parcelRequire("8SCD6");


var $fIKxq = parcelRequire("fIKxq");


var $5vi32 = parcelRequire("5vi32");


var $9wGTI = parcelRequire("9wGTI");


var $iNYtG = parcelRequire("iNYtG");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");

function $9747c27e818a1963$export$a9e17b56b1093c49() {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPaidEdition = edition !== (0, $euL71.ConfluenceEdition).FREE;
    // Must be paid edition
    if (!isPaidEdition) return false;
    return true;
}






var $398ES = parcelRequire("398ES");


var $2JYae = parcelRequire("2JYae");


var $8i27m = parcelRequire("8i27m");


var $gGHFp = parcelRequire("gGHFp");


var $lfmjq = parcelRequire("lfmjq");


var $ecUYt = parcelRequire("ecUYt");


var $hd53J = parcelRequire("hd53J");


var $NYiei = parcelRequire("NYiei");


var $8S5Nq = parcelRequire("8S5Nq");


var $iz4WO = parcelRequire("iz4WO");


var $jOYfu = parcelRequire("jOYfu");


var $jXhAV = parcelRequire("jXhAV");


var $fSC8h = parcelRequire("fSC8h");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $3d5UI = parcelRequire("3d5UI");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $iWI3x = parcelRequire("iWI3x");


var $6OEkb = parcelRequire("6OEkb");


var $bRTjQ = parcelRequire("bRTjQ");


var $foQ4a = parcelRequire("foQ4a");





var $7mpOv = parcelRequire("7mpOv");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7aRa9 = parcelRequire("7aRa9");


var $inDu6 = parcelRequire("inDu6");


var $jSnXV = parcelRequire("jSnXV");





var $6qdjm = parcelRequire("6qdjm");


var $hYoU4 = parcelRequire("hYoU4");

const $f9dc71ade1ee2d5f$export$9745d8c24b40881d = /*#__PURE__*/ (0, $42omo.createContext)({
    isSaving: false,
    savedTime: new Date()
});
const $f9dc71ade1ee2d5f$export$df7407750199bb6d = /*#__PURE__*/ (0, $42omo.createContext)({
    triggerSaveIndicator: ()=>{}
});
const $f9dc71ade1ee2d5f$var$DEBOUNCE_SAVE_PERIOD = 1200;
const $f9dc71ade1ee2d5f$var$COMMIT_STATUS_DEBOUNCE = 500;
const $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL = 500;
const $f9dc71ade1ee2d5f$export$b5e4a2fe6178c584 = ({ editorApi: editorApi, children: children })=>{
    const [isSaving, setIsSaving] = (0, $42omo.useState)(false);
    const [savedTime, setSavedTime] = (0, $42omo.useState)(new Date());
    const saveAttemptCallbackId = (0, $42omo.useRef)(0);
    const saveCompleteCallbackId = (0, $42omo.useRef)(0);
    const pollIntervalId = (0, $42omo.useRef)(0);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const previousBodyChangeTimeRef = (0, $42omo.useRef)(undefined);
    // These window functions are used here as performance efficient callback throttlers
    // requestIdleCallback is not supported by all browsers, hence fallback to requestAnimationFrame
    const throttledCallback = window.requestIdleCallback || window.requestAnimationFrame;
    const cancelThrottle = (0, $42omo.useCallback)((id)=>{
        if (throttledCallback === window.requestIdleCallback) window.cancelIdleCallback(id);
        else window.cancelAnimationFrame(id);
    }, [
        throttledCallback
    ]);
    const onSaveSuccess = (0, $42omo.useCallback)(()=>{
        if (saveCompleteCallbackId.current) cancelThrottle(saveCompleteCallbackId.current);
        const id = throttledCallback(()=>{
            setSavedTime(new Date());
            setIsSaving(false);
            clearInterval(pollIntervalId.current);
            pollIntervalId.current = 0;
            saveCompleteCallbackId.current = 0;
        });
        saveCompleteCallbackId.current = id;
    }, [
        cancelThrottle,
        throttledCallback
    ]);
    const pollForStepsSaved = (0, $42omo.useCallback)(()=>{
        if (!collabEditProvider) return;
        const unconfirmedSteps = collabEditProvider.getUnconfirmedSteps();
        if (!unconfirmedSteps || unconfirmedSteps.length === 0) onSaveSuccess();
    }, [
        collabEditProvider,
        onSaveSuccess
    ]);
    const onSaveAttempt = (0, $42omo.useCallback)(()=>{
        if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
        if (pollIntervalId.current) clearInterval(pollIntervalId.current);
        const attemptId = throttledCallback(()=>{
            setIsSaving(true);
            saveAttemptCallbackId.current = 0;
            const id = setInterval(pollForStepsSaved, $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL);
            pollIntervalId.current = id;
        });
        saveAttemptCallbackId.current = attemptId;
    }, [
        throttledCallback,
        cancelThrottle,
        pollForStepsSaved
    ]);
    // Update polling interval callback with new poll() whenever it updates
    // Because setInterval callback does not track state changes (i.e. isSaving)
    (0, $42omo.useEffect)(()=>{
        if (pollIntervalId.current) {
            clearInterval(pollIntervalId.current);
            pollIntervalId.current = setInterval(pollForStepsSaved, $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL);
        }
    }, [
        pollForStepsSaved
    ]);
    const debouncedOnChange = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onSaveAttempt, $f9dc71ade1ee2d5f$var$COMMIT_STATUS_DEBOUNCE, {
            leading: true,
            trailing: false
        }), [
        onSaveAttempt
    ]);
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        if (!collabEditState?.initialised || !lastChangeTime) return;
        if (lastChangeTime !== previousBodyChangeTimeRef.current) {
            previousBodyChangeTimeRef.current = lastChangeTime;
            debouncedOnChange();
        }
    });
    // Cancel any awaiting callbacks on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (pollIntervalId.current) clearInterval(pollIntervalId.current);
            if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
            if (saveCompleteCallbackId.current) cancelThrottle(saveCompleteCallbackId.current);
        };
    // eslint-disable-next-line
    }, []);
    // display save indicator with auto resolve to saved, for changes outside document body
    const triggerSaving = (0, $42omo.useCallback)(()=>{
        let autoSuccessTimeoutId;
        if (!isSaving) {
            if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
            const attemptId = throttledCallback(()=>{
                setIsSaving(true);
                saveAttemptCallbackId.current = 0;
                autoSuccessTimeoutId = setTimeout(onSaveSuccess, $f9dc71ade1ee2d5f$var$DEBOUNCE_SAVE_PERIOD);
            });
            saveAttemptCallbackId.current = attemptId;
        }
        return ()=>{
            if (autoSuccessTimeoutId) clearTimeout(autoSuccessTimeoutId);
        };
    }, [
        isSaving,
        throttledCallback,
        cancelThrottle,
        onSaveSuccess
    ]);
    const saveIndicatorContextValue = (0, $42omo.useMemo)(()=>({
            isSaving: isSaving,
            savedTime: savedTime
        }), [
        isSaving,
        savedTime
    ]);
    const saveIndicatorTriggerContextValue = (0, $42omo.useMemo)(()=>({
            triggerSaveIndicator: triggerSaving
        }), [
        triggerSaving
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f9dc71ade1ee2d5f$export$9745d8c24b40881d.Provider, {
        value: saveIndicatorContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f9dc71ade1ee2d5f$export$df7407750199bb6d.Provider, {
        value: saveIndicatorTriggerContextValue
    }, children));
};



var $iPdtV = parcelRequire("iPdtV");


var $2xS8W = parcelRequire("2xS8W");


var $70pcM = parcelRequire("70pcM");


var $cEgMD = parcelRequire("cEgMD");


var $85rxh = parcelRequire("85rxh");


var $fjhaB = parcelRequire("fjhaB");


var $9EvUR = parcelRequire("9EvUR");


var $98Cy1 = parcelRequire("98Cy1");


var $l3Dp5 = parcelRequire("l3Dp5");


var $e9owJ = parcelRequire("e9owJ");


var $7BsWq = parcelRequire("7BsWq");


var $1NbQn = parcelRequire("1NbQn");




const $0642f0591024f070$export$f31ae08e8dcbd049 = (0, $2XqLN.default)(()=>{
    return {
        allowMatchCase: true
    };
});



var $fBnV3 = parcelRequire("fBnV3");

/**
 * @generated SignedSource<<f73d98ac5e0fc2c48fe21784cbf189f6>>
 * @relayHash ee79f0b035646a81a51ce55b170adc14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8612a596bb7980422cb34932d5fffbf145a512fc8013ef9d7bca17d608208dd7
const $080e9111fe6dad1a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "appearanceDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "content-appearance-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"content-appearance-draft\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInjectDraftContentgetDraftContentAppearancePropertyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInjectDraftContentgetDraftContentAppearancePropertyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee79f0b035646a81a51ce55b170adc14",
            "id": "8612a596bb7980422cb34932d5fffbf145a512fc8013ef9d7bca17d608208dd7",
            "metadata": {},
            "name": "useInjectDraftContentgetDraftContentAppearancePropertyQuery",
            "operationKind": "query",
            "text": "query useInjectDraftContentgetDraftContentAppearancePropertyQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,appearanceDraft:properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$080e9111fe6dad1a$var$node.hash = "a656f76b91560e5a2b68c51b9c99aa0c";
var $080e9111fe6dad1a$export$2e2bcd8739ae039 = $080e9111fe6dad1a$var$node;


/**
 * @generated SignedSource<<19c5381582cb6a815eeb9f6f3ac461ed>>
 * @relayHash bf6325c2edd11bd3321be86df9129cf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3aafa734739fbf9b352677446fd07dae3aa7a5c110d707c67e99502394997b8c
const $08991ec04a9e77c1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "value"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "alias": "appearanceDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "content-appearance-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"content-appearance-draft\")"
                        },
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "atlas_doc_format",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInjectDraftContentConfluenceDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInjectDraftContentConfluenceDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "bf6325c2edd11bd3321be86df9129cf8",
            "id": "3aafa734739fbf9b352677446fd07dae3aa7a5c110d707c67e99502394997b8c",
            "metadata": {},
            "name": "useInjectDraftContentConfluenceDraftQuery",
            "operationKind": "query",
            "text": "query useInjectDraftContentConfluenceDraftQuery($contentId:ID!,$status:[String]!){content(id:$contentId,status:$status){nodes{appearanceDraft:properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}},id,type,status,title,body{atlas_doc_format{value}}}}}"
        }
    };
}();
$08991ec04a9e77c1$var$node.hash = "532dc301ea1496d62e464496efa31b13";
var $08991ec04a9e77c1$export$2e2bcd8739ae039 = $08991ec04a9e77c1$var$node;









var $7W8i8 = parcelRequire("7W8i8");


var $dPJCf = parcelRequire("dPJCf");





var $nIvaQ = parcelRequire("nIvaQ");








var $fqIt3 = parcelRequire("fqIt3");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");

const $9a6aed826f4ffb4d$var$logger = (0, $7W8i8.getLogger)('native-collab');
const $9a6aed826f4ffb4d$var$parseMonolithContent = (data, editorActions)=>{
    const content = data?.content?.nodes?.[0];
    const contentBody = content?.body?.atlas_doc_format?.value;
    const contentTitle = content?.title;
    let contentAppearance = null;
    try {
        const appearance = content?.appearanceDraft?.nodes?.[0]?.value;
        if (appearance) contentAppearance = JSON.parse(appearance);
    } catch (e) {
        $9a6aed826f4ffb4d$var$logger.error`Error parsing content appearance: ${e}`;
    }
    // at this point since we are getting data after the editor has mounted we need to
    // set the content in the editor through editorActions
    if (contentBody && editorActions) editorActions.replaceDocument(contentBody);
    return {
        draftBody: contentBody ?? null,
        draftTitle: contentTitle ?? null,
        draftAppearance: contentAppearance
    };
};
const $9a6aed826f4ffb4d$var$parseCollabDraftBody = (draftData, appearanceData)=>{
    const draft = draftData?.collabDraft;
    const appearanceContent = appearanceData?.content?.nodes?.[0];
    const draftAppearance = appearanceContent?.appearanceDraft?.nodes?.[0]?.value;
    return {
        draftBody: draft?.document ?? null,
        draftTitle: draft?.metadata?.title ?? null,
        draftAppearance: draftAppearance ? JSON.parse(draftAppearance) : null
    };
};
const $9a6aed826f4ffb4d$export$48c0f85d55b51110 = ({ contentId: contentId, draftShareId: draftShareId, collabEditInitialized: collabEditInitialized, editorActions: editorActions, isUnrecoverableCollabEditError: isUnrecoverableCollabEditError })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const isInitialLoad = !transitionId;
    const shouldPreloadForSSR = isInitialLoad;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Determine if we should bypass cache and fetch fresh data.
    // Cache is considered stale when its timestamp has been cleared (e.g., after adding a comment).
    // This ensures the editor fetches fresh content with comment annotations if the user
    // hovers the edit button (preloading the draft), adds a comment, then clicks edit.
    const shouldBypassCache = contentId && (0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) && (0, $9wGTI.fg)('confluence_fe_invalidate_collab_draft_cache');
    const bodyPreloadingEnabled = shouldPreloadForSSR || isLivePage;
    const draftLoadTime = (0, $42omo.useRef)(null);
    const getMonolithContentTimeout = (0, $42omo.useRef)(null);
    let initialDraft = {
        draftBody: null,
        draftTitle: null,
        draftAppearance: null
    };
    const [getMonolithContent, { data: monolithDraftData, loading: monolithContentLoading, error: monolithContentError }] = (0, $lvOsp.useLazyQueryInterop)((0, $08991ec04a9e77c1$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            status: [
                'draft',
                'current'
            ]
        }
    });
    const hasConfluenceDraftQueryLoaded = !monolithContentLoading && !monolithContentError && !!monolithDraftData;
    const { data: collabDraftData, loading: collabDraftLoading, error: collabDraftError } = (0, $jMyy4.useQueryInterop)((0, $nIvaQ.getCollabDraftQuery)(), {
        fetchPolicy: shouldBypassCache ? 'network-only' : 'cache-first',
        variables: {
            id: contentId,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined,
            hydrateAdf: true
        },
        skip: !bodyPreloadingEnabled
    });
    const { data: appearanceData, loading: appearanceLoading, error: appearanceError } = (0, $jMyy4.useQueryInterop)((0, $080e9111fe6dad1a$export$2e2bcd8739ae039), {
        fetchPolicy: shouldBypassCache ? 'network-only' : 'cache-first',
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        skip: !bodyPreloadingEnabled
    });
    const hasCollabDraftQueryLoaded = !collabDraftLoading && !!collabDraftData?.collabDraft && !!appearanceData && !appearanceLoading;
    initialDraft = (0, $42omo.useMemo)(()=>{
        return hasConfluenceDraftQueryLoaded ? $9a6aed826f4ffb4d$var$parseMonolithContent(monolithDraftData, editorActions) : $9a6aed826f4ffb4d$var$parseCollabDraftBody(collabDraftData, appearanceData);
    }, [
        collabDraftData,
        appearanceData,
        monolithDraftData,
        hasConfluenceDraftQueryLoaded,
        editorActions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isUnrecoverableCollabEditError) {
            if (getMonolithContentTimeout.current) clearTimeout(getMonolithContentTimeout.current);
            getMonolithContent();
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'monolithFallback',
                    actionSubject: 'nativeEditor',
                    source: 'confluenceFrontend',
                    objectId: contentId,
                    attributes: {
                        timeout: 0
                    }
                }
            }).fire();
        }
    }, [
        isUnrecoverableCollabEditError,
        getMonolithContentTimeout,
        getMonolithContent,
        createAnalyticsEvent,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getMonolithContentTimeout.current && !hasCollabDraftQueryLoaded) getMonolithContentTimeout.current = window.setTimeout(()=>{
            getMonolithContent();
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'monolithFallback',
                    actionSubject: 'nativeEditor',
                    source: 'confluenceFrontend',
                    objectId: contentId,
                    attributes: {
                        timeout: (0, $6mKj3.expVal)('confluence_editor_monolith_fallback_timer', 'value', 10000)
                    }
                }
            }).fire();
        }, (0, $6mKj3.expVal)('confluence_editor_monolith_fallback_timer', 'value', 10000));
    }, [
        hasCollabDraftQueryLoaded,
        getMonolithContentTimeout,
        getMonolithContent,
        createAnalyticsEvent,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (getMonolithContentTimeout.current && (hasCollabDraftQueryLoaded || collabEditInitialized)) {
            clearTimeout(getMonolithContentTimeout.current);
            getMonolithContentTimeout.current = null;
        }
    }, [
        getMonolithContentTimeout,
        hasCollabDraftQueryLoaded,
        collabEditInitialized
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (getMonolithContentTimeout.current) clearTimeout(getMonolithContentTimeout.current);
        };
    }, [
        getMonolithContentTimeout
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!bodyPreloadingEnabled) return;
        if (!collabDraftError && hasCollabDraftQueryLoaded && !appearanceError) {
            draftLoadTime.current = performance.now();
            $9a6aed826f4ffb4d$var$logger.debug`Draft content retrieved from CollabDraftQuery at ${performance.now() / 1000}`;
        }
    }, [
        hasCollabDraftQueryLoaded,
        collabDraftError,
        appearanceError,
        bodyPreloadingEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collabEditInitialized && !!draftLoadTime.current) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'editorContentVisibleDisabledTime',
                actionSubject: 'nativeEditor',
                source: 'confluenceFrontend',
                objectId: contentId,
                attributes: {
                    timeDiff: performance.now() - draftLoadTime.current
                }
            }
        }).fire();
    // don't depend on createAnalyticsEvent to avoid unnecessary re-triggers of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInitialized,
        contentId
    ]);
    return initialDraft;
};



var $bjxK7 = parcelRequire("bjxK7");


var $aIZFY = parcelRequire("aIZFY");


var $hfIjM = parcelRequire("hfIjM");


var $3W9OD = parcelRequire("3W9OD");


var $beK3g = parcelRequire("beK3g");


var $foVrt = parcelRequire("foVrt");


var $f6GmT = parcelRequire("f6GmT");







const $349687d7e88d726e$export$f95232bf2d33b362 = ()=>{
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const aiProviders = (0, $42omo.useRef)({});
    const onAIProviderChanged = (0, $42omo.useCallback)((source, provider)=>{
        if (!collabEditConnected || !collabEditProvider) return;
        let agentId = provider?.agent?.id;
        const agentIdPrefix = 'agent:';
        const action = agentId ? 'add' : 'remove';
        // Fetch the previously enabled provider's ID as it isn't provided
        // when unsetting the selected provider
        if (aiProviders.current[source]) agentId = aiProviders.current[source];
        aiProviders.current[source] = provider?.agent?.id;
        if (agentId) {
            const providerId = `${agentIdPrefix}${agentId}`;
            collabEditProvider.sendMessage({
                type: 'ai-provider:change',
                action: action,
                providerId: providerId
            });
        }
        collabEditProvider.setAIProviderActiveIds(Object.values(aiProviders.current).filter((id)=>!!id).map((id)=>`${agentIdPrefix}${id}`));
    }, [
        collabEditConnected,
        collabEditProvider
    ]);
    return {
        onAIProviderChanged: onAIProviderChanged
    };
};





const $92561710d62f83c7$export$4e0e446ffa50ddc0 = ()=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(document?.visibilityState === 'visible');
    const delay = 2000; // 2 seconds delay
    (0, $42omo.useEffect)(()=>{
        let timer;
        const handleVisibilityChange = ()=>{
            clearTimeout(timer);
            if (document?.visibilityState === 'visible') timer = setTimeout(()=>{
                setIsActive(true);
            }, delay);
            else setIsActive(false);
        };
        document?.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            clearTimeout(timer);
            document?.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return isActive;
};


/**
 * @generated SignedSource<<214fb1a9df4c03bd40f7a1197e5dfb38>>
 * @relayHash 427b91af5539a42807aedc698e06b0b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4036680aedddf3d43be10fb7f19ed27fa860e3e3584ff02d8f8163fc2ccbc766
const $589d588e480a1981$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "EditorDraftSyncPayload",
                    "kind": "LinkedField",
                    "name": "editorDraftSyncAction",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "EditorDraftSyncPayload",
                    "kind": "LinkedField",
                    "name": "editorDraftSyncAction",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "427b91af5539a42807aedc698e06b0b0",
            "id": "4036680aedddf3d43be10fb7f19ed27fa860e3e3584ff02d8f8163fc2ccbc766",
            "metadata": {},
            "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
            "operationKind": "mutation",
            "text": "mutation useEditorDraftSyncActionEditorDraftSyncActionMutation($input:EditorDraftSyncInput!){editorDraftSyncAction(input:$input){success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$589d588e480a1981$var$node.hash = "714c0f41fd977a5eb40bd778315e24d8";
var $589d588e480a1981$export$2e2bcd8739ae039 = $589d588e480a1981$var$node;












var $91bcx = parcelRequire("91bcx");











var $4VJDS = parcelRequire("4VJDS");








var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");





var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $bMmYR = parcelRequire("bMmYR");


var $b4kc6 = parcelRequire("b4kc6");


var $9F9dn = parcelRequire("9F9dn");


var $308Wd = parcelRequire("308Wd");


var $gxtki = parcelRequire("gxtki");

const $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR = 'Unknown Error from useEditorDraftSyncAction Mutation';
const $a59bf23b6ef769dd$var$DRAFT_SYNC_DEBOUNCE_TIME = 2500;
const $a59bf23b6ef769dd$var$parseSyncStatus = (syncStatus)=>{
    // syncStatus is expected to follow this pattern: pending-{stepVersionNumber} | synced-{stepVersionNumber}
    if (typeof syncStatus !== 'string') return undefined;
    const parsed = syncStatus.split('-');
    return {
        status: parsed[0],
        version: Number(parsed[1])
    };
};
const $a59bf23b6ef769dd$export$7a6d63ee0185f0fd = ({ contentId: contentId, editorPresetAPI: editorPresetAPI, editorActions: editorActions, isFirstParticipant: isFirstParticipant, onDraftSyncSuccess: onDraftSyncSuccess, flags: flags })=>{
    const intl = (0, $aXWIB.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }, { setIsDraftSyncPending: setIsDraftSyncPending }] = (0, $hYoU4.useNativeCollabState)();
    const draftSyncDebounceMaxWait = (0, $4VJDS.default).getNumber('draft_sync_debounce_max_wait', 0);
    const [draftSyncActionError, setDraftSyncActionError] = (0, $42omo.useState)(null);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousOfflineStatusRef = (0, $42omo.useRef)(false);
    const submitErrorToMonitoringSystem = (0, $42omo.useCallback)((error)=>{
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: contentId
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }, [
        contentId
    ]);
    const [editorDraftSyncActionMutation] = (0, $308Wd.useMutationInterop)((0, $589d588e480a1981$export$2e2bcd8739ae039));
    const executeDraftSyncActionMutation = (0, $42omo.useCallback)(async ()=>{
        const currentStep = collabEditProvider?.getCurrentPmVersion();
        // Fallback adf should only be sent by a single user to avoid conflict errors on the BE
        const latestAdf = isFirstParticipant ? await editorActions.getValue() : null;
        const { data: data } = await editorDraftSyncActionMutation({
            variables: {
                input: {
                    contentId: contentId,
                    ncsStepVersion: currentStep,
                    doSetRelations: true,
                    // Collaborator relation is an entity on the backend used to indicate if a user made changes to that version
                    latestAdf: latestAdf && JSON.stringify(latestAdf)
                }
            }
        });
        return data;
    }, [
        contentId,
        editorDraftSyncActionMutation,
        collabEditProvider,
        editorActions,
        isFirstParticipant
    ]);
    const saveDraft = (0, $42omo.useCallback)(async ()=>{
        setIsDraftSyncPending(true);
        try {
            const data = await (0, $bMmYR.retry)(executeDraftSyncActionMutation, {
                maxAttempts: 2,
                timeout: 2000
            });
            const result = data?.editorDraftSyncAction;
            if (result?.success) {
                // After draft is saved, save source sync blocks and reference synced blocks on the document
                if (editorPresetAPI?.syncedBlock && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) {
                    const flushSyncBlockSuccess = await editorPresetAPI.syncedBlock.actions.flushBodiedSyncBlocks();
                    if (flags && !flushSyncBlockSuccess) (0, $b4kc6.showFlushSyncBlockErrorFlag)(flags, intl, editorPresetAPI.syncedBlock.actions.flushBodiedSyncBlocks);
                    editorPresetAPI.syncedBlock.actions.flushSyncedBlocks();
                }
                setDraftSyncActionError(null);
                setIsDraftSyncPending(false);
                onDraftSyncSuccess?.();
                return;
            }
            if (result?.errors?.length && result?.errors?.length > 0) {
                const errors = (0, $gxtki.mutationErrorExtensionsAggCompat)((result.errors ?? []).map((error)=>({
                        ...error,
                        __typename: 'MutationError'
                    })));
                errors.forEach((error, index)=>{
                    const originalError = result.errors?.[index];
                    const typedError = error;
                    const errorExtensionData = typedError?.extensions?.[0];
                    const errorMessage = originalError?.message ?? typedError?.message;
                    if (errorMessage && errorExtensionData?.statusCode) setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(errorMessage, errorExtensionData.statusCode));
                    else setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(errorMessage || $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR, undefined));
                    submitErrorToMonitoringSystem(originalError || typedError);
                });
                return;
            }
        } catch (error) {
            setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(error?.message || $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR, Number((0, $aMcHK.getStatusCode)(error))));
            submitErrorToMonitoringSystem(error);
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        editorPresetAPI,
        submitErrorToMonitoringSystem,
        setIsDraftSyncPending,
        executeDraftSyncActionMutation,
        onDraftSyncSuccess,
        flags,
        intl
    ]);
    const onUpdate = (0, $42omo.useCallback)(()=>{
        if (!isLivePage || !collabEditProvider || !collabEditInitialized) return;
        const metadata = collabEditProvider.getMetadata();
        const collabSyncStatus = $a59bf23b6ef769dd$var$parseSyncStatus(metadata['syncStatus']);
        if (collabSyncStatus) {
            const currentStatus = collabSyncStatus['status'];
            if (currentStatus === 'synced') // BE is not currently saving, so send request
            saveDraft();
            if (currentStatus === 'pending') // implies BE is already saving, so we don't send a new request
            return;
        } else // collabSyncStatus is set by the BE as a result of draft sync. If it doesn't exist, BE needs to save and set it.
        saveDraft();
    }, [
        isLivePage,
        collabEditProvider,
        collabEditInitialized,
        saveDraft
    ]);
    const debouncedOnUpdate = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, $a59bf23b6ef769dd$var$DRAFT_SYNC_DEBOUNCE_TIME, {
            trailing: true,
            ...draftSyncDebounceMaxWait > 0 && {
                maxWait: draftSyncDebounceMaxWait
            }
        }), [
        onUpdate,
        draftSyncDebounceMaxWait
    ]);
    const triggerUpdate = (0, $42omo.useCallback)(()=>{
        if (isLivePage) debouncedOnUpdate();
    }, [
        debouncedOnUpdate,
        isLivePage
    ]);
    const cancelUpdate = (0, $42omo.useCallback)(()=>debouncedOnUpdate.cancel(), [
        debouncedOnUpdate
    ]);
    const flushUpdate = (0, $42omo.useCallback)(()=>{
        debouncedOnUpdate.flush();
    }, [
        debouncedOnUpdate
    ]);
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const handlePluginStateEffect = (0, $42omo.useCallback)(({ collabEditState: collabEditState, connectivityState: connectivityState })=>{
        if (!isLivePage) return;
        if ((0, $91bcx.isOfflineMode)(connectivityState?.mode)) {
            previousOfflineStatusRef.current = true;
            return;
        } else if (connectivityState?.mode === 'online') {
            // reset any draft sync errors upon coming back online
            if (previousOfflineStatusRef.current === true) setDraftSyncActionError(null);
            previousOfflineStatusRef.current = false;
        }
        const currentBodyChangeAt = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const prevBodyChangeAt = previousLocalChangeTimeRef.current;
        if (currentBodyChangeAt && currentBodyChangeAt !== prevBodyChangeAt) {
            previousLocalChangeTimeRef.current = currentBodyChangeAt;
            triggerUpdate();
            return;
        }
        // When a synced block is edited inside an embed of the same page, the edit arrives
        // in the outer editor as a remote change (via NativeCollab). The iframe that
        // processed the edit gets destroyed before its debounced flush can fire.
        // To handle this, we flush synced blocks when remote organic body changes arrive,
        // since updateSyncBlockData marks blocks as dirty in the outer editor's store too.
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('platform_synced_block_patch_8') && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) {
            const currentRemoteBodyChangeAt = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
            const prevRemoteBodyChangeAt = previousRemoteChangeTimeRef.current;
            if (currentRemoteBodyChangeAt && currentRemoteBodyChangeAt !== prevRemoteBodyChangeAt) {
                previousRemoteChangeTimeRef.current = currentRemoteBodyChangeAt;
                editorPresetAPI?.syncedBlock?.actions.flushBodiedSyncBlocks();
            }
        }
    }, [
        isLivePage,
        triggerUpdate,
        editorPresetAPI
    ]);
    (0, $6qdjm.usePluginStateEffect)(editorPresetAPI, [
        'collabEdit',
        'connectivity'
    ], handlePluginStateEffect);
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage || !collabEditProvider || !collabEditInitialized) return;
        window.addEventListener('beforeunload', flushUpdate);
        return ()=>{
            window.removeEventListener('beforeunload', flushUpdate);
        };
    }, [
        collabEditInitialized,
        collabEditProvider,
        isLivePage,
        flushUpdate
    ]);
    return {
        triggerUpdate: triggerUpdate,
        cancelUpdate: cancelUpdate,
        flushUpdate: flushUpdate,
        draftSyncActionError: draftSyncActionError
    };
};








const $83a5ab04c7ded94b$export$f6774c6023dca75e = (fetchNativeCollab)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasPreloadedResult = (0, $42omo.useRef)(false);
    // Fetch native collab data into cache
    const preloadNativeCollabRefetch = (0, $42omo.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'preloaded',
                actionSubject: 'refetchNativeCollab',
                source: 'useRefetchNativeCollab'
            }
        }).fire();
        try {
            const data = await fetchNativeCollab(false);
            hasPreloadedResult.current = true;
            return data;
        } catch (error) {
            hasPreloadedResult.current = false;
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fetchNativeCollab
    ]);
    const refetchNativeCollab = (0, $42omo.useCallback)(async (shouldCheckCache)=>{
        // Use cache if preloaded, otherwise use the provided value
        const checkCache = hasPreloadedResult.current || !!shouldCheckCache;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'fetched',
                actionSubject: 'refetchNativeCollab',
                source: 'useRefetchNativeCollab',
                attributes: {
                    checkCache: checkCache,
                    hasPreloadedResult: hasPreloadedResult.current
                }
            }
        }).fire();
        try {
            return await fetchNativeCollab(checkCache);
        } catch (error) {
            hasPreloadedResult.current = false;
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fetchNativeCollab
    ]);
    return {
        refetchNativeCollab: refetchNativeCollab,
        preloadNativeCollabRefetch: preloadNativeCollabRefetch
    };
};



var $btQhd = parcelRequire("btQhd");


var $8uySb = parcelRequire("8uySb");


var $lmEhP = parcelRequire("lmEhP");


var $cvzKy = parcelRequire("cvzKy");


var $2dIEg = parcelRequire("2dIEg");


var $i8Ylv = parcelRequire("i8Ylv");


var $3plmx = parcelRequire("3plmx");


var $3IZob = parcelRequire("3IZob");


var $awIbt = parcelRequire("awIbt");


var $dWbBL = parcelRequire("dWbBL");


var $dE9mB = parcelRequire("dE9mB");


var $2KWDO = parcelRequire("2KWDO");


var $bAGpj = parcelRequire("bAGpj");


var $5IgBW = parcelRequire("5IgBW");


var $aUU0C = parcelRequire("aUU0C");


var $k8e76 = parcelRequire("k8e76");


var $WheoQ = parcelRequire("WheoQ");


var $OCz5m = parcelRequire("OCz5m");


var $aPQsP = parcelRequire("aPQsP");


var $bcv7k = parcelRequire("bcv7k");


var $32x2E = parcelRequire("32x2E");


var $brsfB = parcelRequire("brsfB");








var $kyKWe = parcelRequire("kyKWe");


var $a3fRD = parcelRequire("a3fRD");





var $b4wUN = parcelRequire("b4wUN");


var $esRft = parcelRequire("esRft");


var $b3j2Y = parcelRequire("b3j2Y");











var $a7SsH = parcelRequire("a7SsH");

/**
 * @generated SignedSource<<04cfc5e6dedb75444c1d67244979ef1d>>
 * @relayHash 682006a4717140cff09b61df1192c4ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83c9bb559f2ee12740a46e0dc8d69d0dc2ebd36452507787134a290ae0257b2a
const $46e0cf9c3dce3323$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ContentPermissionsPayload",
            "kind": "LinkedField",
            "name": "updateContentPermissions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "682006a4717140cff09b61df1192c4ea",
            "id": "83c9bb559f2ee12740a46e0dc8d69d0dc2ebd36452507787134a290ae0257b2a",
            "metadata": {},
            "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
            "operationKind": "mutation",
            "text": "mutation useUsersContentPermissionsUpdateContentPermissionsMutation($contentId:ID!,$input:[UpdateContentPermissionsInput]!){updateContentPermissions(contentId:$contentId,input:$input){status}}"
        }
    };
}();
$46e0cf9c3dce3323$var$node.hash = "69f9fc40c10deb46af31d8102cad6d9e";
var $46e0cf9c3dce3323$export$2e2bcd8739ae039 = $46e0cf9c3dce3323$var$node;


/**
 * @generated SignedSource<<5d01eabb656b1923f419e365c104bc3e>>
 * @relayHash 1f8968d814ecf9ca0dc936ee80d421ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e045e26a8668ba5a7a377f709fbc209c3901d0a44e48c18a533b066fcb360c56
const $22ddb50ea6694114$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permission"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceType"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "permission",
                "variableName": "permission"
            },
            {
                "kind": "Variable",
                "name": "principalIds",
                "variableName": "accountIds"
            },
            {
                "kind": "Variable",
                "name": "resourceId",
                "variableName": "resourceId"
            },
            {
                "kind": "Variable",
                "name": "resourceType",
                "variableName": "resourceType"
            }
        ],
        "concreteType": "ConfluenceUsersHavePermissionList",
        "kind": "LinkedField",
        "name": "confluence_usersHavePermission",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceUserHasPermission",
                "kind": "LinkedField",
                "name": "usersHavePermissionList",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    }
                ]
            }
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1f8968d814ecf9ca0dc936ee80d421ff",
            "id": "e045e26a8668ba5a7a377f709fbc209c3901d0a44e48c18a533b066fcb360c56",
            "metadata": {},
            "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
            "operationKind": "query",
            "text": "query useUsersContentPermissionsNewUserHasRestrictionsQuery($cloudId:ID!,$accountIds:[String]!,$resourceId:ID!,$resourceType:String!,$permission:String!){confluence_usersHavePermission(cloudId:$cloudId,principalIds:$accountIds,resourceId:$resourceId,resourceType:$resourceType,permission:$permission){usersHavePermissionList{principalId,hasPermission}},confluenceUsers(accountIds:$accountIds){nodes{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}"
        }
    };
}();
$22ddb50ea6694114$var$node.hash = "574ff7b442e7a8af2643d4ece91556c9";
var $22ddb50ea6694114$export$2e2bcd8739ae039 = $22ddb50ea6694114$var$node;


/**
 * @generated SignedSource<<890aa87d08929b8eba3005ad2fd239b7>>
 * @relayHash 1e11714ae08776671ab5c43bd95e63c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7796a686a40381dc088a041f5845ef2b6be6d6e42cfc99dcf5219f541bd9ecec
const $f6e8679dfbb7a153$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = [
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "ContentPermissions",
            "kind": "LinkedField",
            "name": "contentPermissions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentAccess"
                },
                {
                    "concreteType": "PaginatedSubjectUserOrGroupList",
                    "kind": "LinkedField",
                    "name": "subjectsWithEffectiveContentPermissions",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SubjectUserOrGroup",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "UserWithRestrictions",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                v1 /*: any*/ 
            ],
            "concreteType": "UserWithRestrictions",
            "kind": "LinkedField",
            "name": "usersWithContentRestrictions",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasSpaceViewPermission"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "restrictingContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUsersContentPermissionsContentPermissionsQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUsersContentPermissionsContentPermissionsQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1e11714ae08776671ab5c43bd95e63c2",
            "id": "7796a686a40381dc088a041f5845ef2b6be6d6e42cfc99dcf5219f541bd9ecec",
            "metadata": {},
            "name": "useUsersContentPermissionsContentPermissionsQuery",
            "operationKind": "query",
            "text": "query useUsersContentPermissionsContentPermissionsQuery($accountIds:[String]!,$contentId:ID!){contentPermissions(contentId:$contentId){contentAccess,subjectsWithEffectiveContentPermissions{nodes{id,displayName,user{profilePicture{path}}}}},usersWithContentRestrictions(accountIds:$accountIds,contentId:$contentId){hasSpaceViewPermission,restrictingContent{id,hasRestrictions},accountId,displayName,profilePicture{path}}}"
        }
    };
}();
$f6e8679dfbb7a153$var$node.hash = "17ce6feb201fcfab95a8a2ed98133b5c";
var $f6e8679dfbb7a153$export$2e2bcd8739ae039 = $f6e8679dfbb7a153$var$node;


















var $c0rhi = parcelRequire("c0rhi");


var $hdxAi = parcelRequire("hdxAi");

const $a429a791ecef3570$var$useUsersContentPermissionsContentPermissionsQuery = (0, $f6e8679dfbb7a153$export$2e2bcd8739ae039);
const $a429a791ecef3570$var$useUsersContentPermissionsNewUserHasRestrictionsQuery = (0, $22ddb50ea6694114$export$2e2bcd8739ae039);
const $a429a791ecef3570$var$useUsersContentPermissionsUpdateContentPermissionsMutation = (0, $46e0cf9c3dce3323$export$2e2bcd8739ae039);
const $a429a791ecef3570$export$d525ee52d361179f = async ({ accountIds: accountIds, contentId: contentId, cloudId: cloudId, setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks })=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: $a429a791ecef3570$var$useUsersContentPermissionsNewUserHasRestrictionsQuery,
            variables: {
                cloudId: cloudId,
                accountIds: accountIds,
                resourceId: contentId,
                resourceType: 'PAGE',
                permission: 'VIEW'
            },
            fetchPolicy: 'network-only' // we'll need to check user's permissions everytime to correctly display the correct flag contents in case the user's permission changed
        });
        const usersWithViewPermissions = new Set(data?.confluence_usersHavePermission?.usersHavePermissionList?.filter((user)=>user?.hasPermission).map((user)=>user?.principalId));
        return data?.confluenceUsers?.nodes?.reduce((acc, user)=>{
            const accountId = user?.accountId;
            if (user && accountId && usersWithViewPermissions.has(accountId)) acc.push({
                id: accountId,
                hasViewRestrictions: false,
                displayName: user?.displayName ?? '',
                userPhoto: user?.profilePicture?.path ?? ''
            });
            return acc;
        }, []);
    } catch  {
        //reset state so query won't keep erroring out on same data
        setAddedMentions([]);
        setAddedTasks([]);
        return [];
    }
};
const $a429a791ecef3570$export$a5b8a857cb669f1f = ({ contentId: contentId, isUpdatedMentionsInLivePagesEnabled: isUpdatedMentionsInLivePagesEnabled, isLivePage: isLivePage, currentUserId: currentUserId, mentionsToDisplay: mentionsToDisplay, source: source })=>{
    //TODO: save the permissions of users in a separate state if it's already available, so that we don't have to query forit again
    const mentionedUserIds = (0, $42omo.useMemo)(()=>{
        const allUniqueMentionedUserIds = new Set(mentionsToDisplay.map((mention)=>mention.id));
        return Array.from(allUniqueMentionedUserIds);
    }, [
        mentionsToDisplay
    ]);
    const [unrestrictedUsers, setUnrestrictedUsers] = (0, $42omo.useState)([]);
    const [isUnrestrictedUsersLoading, setIsUnrestrictedUsersLoading] = (0, $42omo.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks, addUnrestrictedMentions: addUnrestrictedMentions, addParentSpaceRestrictedMentions: addParentSpaceRestrictedMentions, addPageRestrictedMentions: addPageRestrictedMentions, addParentSpaceRestrictedTasks: addParentSpaceRestrictedTasks, addPageRestrictedTasks: addPageRestrictedTasks, addUnrestrictedTasks: addUnrestrictedTasks } = (0, $hdxAi.useMentionsNotificationsActions)();
    //useLazyQuery is being used here because skip was not being respected in useQuery. Known issue in react-apollo: https://github.com/apollographql/react-apollo/issues/3492
    const [getContentPermissions, { data: updatedContentPermissionsData, error: updatedUsersContentPermissionsError, loading: updatedUsersContentPermissionsLoading }] = (0, $lvOsp.useLazyQueryInterop)($a429a791ecef3570$var$useUsersContentPermissionsContentPermissionsQuery, {
        variables: {
            contentId: contentId,
            accountIds: mentionedUserIds
        },
        fetchPolicy: 'network-only',
        // we'll need to check user's permissions everytime to correctly display the correct flag contents in case the user's permission changed
        onError: ()=>{
            //reset state so query won't keep erroring out on same data
            setAddedMentions([]);
            setAddedTasks([]);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (isUpdatedMentionsInLivePagesEnabled && mentionedUserIds.length) getContentPermissions({
            variables: {
                contentId: contentId,
                accountIds: mentionedUserIds
            }
        });
    }, [
        contentId,
        isUpdatedMentionsInLivePagesEnabled,
        mentionedUserIds,
        getContentPermissions
    ]);
    (0, $42omo.useEffect)(()=>{
        const fetchUnrestrictedUsers = async ()=>{
            if (isUpdatedMentionsInLivePagesEnabled && mentionedUserIds.length) {
                setIsUnrestrictedUsersLoading(true);
                try {
                    const usersWithViewPermissions = await $a429a791ecef3570$export$d525ee52d361179f({
                        accountIds: mentionedUserIds,
                        contentId: contentId,
                        cloudId: cloudId,
                        setAddedMentions: setAddedMentions,
                        setAddedTasks: setAddedTasks
                    });
                    setUnrestrictedUsers(usersWithViewPermissions ?? []);
                } finally{
                    setIsUnrestrictedUsersLoading(false);
                }
            }
        };
        fetchUnrestrictedUsers();
    }, [
        contentId,
        isUpdatedMentionsInLivePagesEnabled,
        mentionedUserIds,
        cloudId,
        setAddedMentions,
        setAddedTasks
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [updateUsersContentPermissionMutation] = (0, $308Wd.useMutationInterop)($a429a791ecef3570$var$useUsersContentPermissionsUpdateContentPermissionsMutation, {
        onCompleted: ()=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'updateContentPermissions',
                    action: 'succeeded',
                    source: source,
                    attributes: {
                        contentId: contentId,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onError: (error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'updateContentPermissions',
                    action: 'failed',
                    source: source,
                    attributes: {
                        contentId: contentId,
                        error: error.message,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        }
    });
    const mentionsWithSpaceRestrictions = [];
    const usersWithSpaceRestrictionsIds = new Set();
    const mentionsWithParentPageRestrictions = [];
    const usersWithParentPageRestrictionsIds = new Set();
    const usersWithSpaceOrParentRestrictionsIds = new Set();
    const usersWithCurrentPageRestrictionsIds = new Set();
    const usersWithUnrestrictedPageAccessIds = new Set();
    const accountIdToDisplayNameMap = new Map();
    (0, $42omo.useEffect)(()=>{
        if (updatedContentPermissionsData && mentionsToDisplay?.length && !isUnrestrictedUsersLoading) {
            const { contentPermissions: contentPermissions, usersWithContentRestrictions: contentRestrictions } = updatedContentPermissionsData;
            if (contentPermissions?.contentAccess === 'EVERYONE_NO_ACCESS') {
                contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes?.forEach((user)=>{
                    if (!user?.id || user.id === currentUserId) return;
                    usersWithUnrestrictedPageAccessIds.add(user.id);
                    accountIdToDisplayNameMap.set(user.id, {
                        displayName: user.displayName ?? '',
                        userPhoto: user?.user?.profilePicture?.path ?? ''
                    });
                });
                unrestrictedUsers.forEach((user)=>{
                    usersWithUnrestrictedPageAccessIds.add(user.id);
                    accountIdToDisplayNameMap.set(user.id, {
                        displayName: user.displayName ?? '',
                        userPhoto: user.userPhoto ?? ''
                    });
                });
            }
            contentRestrictions?.forEach((user)=>{
                if (!user?.accountId) return;
                accountIdToDisplayNameMap.set(user.accountId, {
                    displayName: user.displayName ?? '',
                    userPhoto: user?.profilePicture?.path ?? ''
                });
                if (!user.hasSpaceViewPermission) {
                    //has space level restriction
                    usersWithSpaceRestrictionsIds.add(user.accountId);
                    usersWithSpaceOrParentRestrictionsIds.add(user.accountId);
                } else if (user.restrictingContent?.hasRestrictions) {
                    //has parent page level restriction
                    usersWithParentPageRestrictionsIds.add(user.accountId);
                    usersWithSpaceOrParentRestrictionsIds.add(user.accountId);
                } else if (contentPermissions?.contentAccess === 'EVERYONE_NO_ACCESS') //might have page level restriction
                {
                    if (!usersWithUnrestrictedPageAccessIds.has(user.accountId)) usersWithCurrentPageRestrictionsIds.add(user.accountId);
                }
            });
            mentionsToDisplay.forEach((mention)=>{
                const mentionToAdd = {
                    ...mention,
                    displayName: accountIdToDisplayNameMap.get(mention.id)?.displayName ?? '',
                    userPhoto: accountIdToDisplayNameMap.get(mention.id)?.userPhoto ?? ''
                };
                if (mention?.taskLocalId) {
                    //Buckets added task mentions into different permission groups
                    if (usersWithSpaceRestrictionsIds.has(mention.id)) //Users who dont have access to the page due to space restrictions
                    addParentSpaceRestrictedTasks([
                        mentionToAdd
                    ]);
                    else if (usersWithParentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to parent page restrictions
                    addParentSpaceRestrictedTasks([
                        mentionToAdd
                    ]);
                    else if (usersWithCurrentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to current page restrictions
                    addPageRestrictedTasks([
                        mentionToAdd
                    ]);
                    else //Users who have access to the page
                    addUnrestrictedTasks([
                        mentionToAdd
                    ]);
                } else {
                    //Buckets added general mentions into different permission groups
                    if (usersWithSpaceRestrictionsIds.has(mention.id)) {
                        //Users who dont have access to the page due to space restrictions
                        mentionsWithSpaceRestrictions.push(mentionToAdd);
                        addParentSpaceRestrictedMentions([
                            mentionToAdd
                        ]);
                    } else if (usersWithParentPageRestrictionsIds.has(mention.id)) {
                        //Users who don't have access to the page due to parent page restrictions
                        mentionsWithParentPageRestrictions.push(mentionToAdd);
                        addParentSpaceRestrictedMentions([
                            mentionToAdd
                        ]);
                    } else if (usersWithCurrentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to current page restrictions
                    addPageRestrictedMentions([
                        mentionToAdd
                    ]);
                    else //Users who have access to the page
                    addUnrestrictedMentions([
                        mentionToAdd
                    ]);
                }
            });
            setAddedMentions([]);
            setAddedTasks([]);
            setUnrestrictedUsers([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updatedContentPermissionsData,
        isUnrestrictedUsersLoading,
        unrestrictedUsers
    ]);
    return {
        updatedUsersContentPermissionsError: updatedUsersContentPermissionsError,
        updatedUsersContentPermissionsLoading: updatedUsersContentPermissionsLoading,
        updateUsersContentPermissionMutation: updateUsersContentPermissionMutation
    };
};


/**
 * @generated SignedSource<<c7c97b394b778a625ef580f4be650a9b>>
 * @relayHash 325893057a9ae854264a36ff297497e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a892b2c57a89b01f2776ec740d6ff77b66ea51267eda656a864b2dae081cd69
const $6e80834bd13fce7f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "mentions"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "mentions",
                            "variableName": "mentions"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "CreateContentMentionNotificationActionPayload",
            "kind": "LinkedField",
            "name": "createContentMentionNotificationAction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "325893057a9ae854264a36ff297497e4",
            "id": "7a892b2c57a89b01f2776ec740d6ff77b66ea51267eda656a864b2dae081cd69",
            "metadata": {},
            "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
            "operationKind": "mutation",
            "text": "mutation useMentionNotificationMutationCreateContentMentionNotificationActionMutation($contentId:ID!,$mentions:[ContentMention]!){createContentMentionNotificationAction(input:{contentId:$contentId,mentions:$mentions}){contentId,success,errors{message}}}"
        }
    };
}();
$6e80834bd13fce7f$var$node.hash = "d2cb21a69b28359ca54e883cea95094b";
var $6e80834bd13fce7f$export$2e2bcd8739ae039 = $6e80834bd13fce7f$var$node;











const $05c7f8c23696cebd$var$useMentionNotificationMutationCreateContentMentionNotificationActionMutation = (0, $6e80834bd13fce7f$export$2e2bcd8739ae039);
const $05c7f8c23696cebd$export$82f89b951e37c769 = ({ contentId: contentId, setError: setError, showDontNotifyFailedFlag: showDontNotifyFailedFlag })=>{
    const [createContentMentionNotificationAction, { error: contentMentionNotificationError }] = (0, $308Wd.useMutationInterop)($05c7f8c23696cebd$var$useMentionNotificationMutationCreateContentMentionNotificationActionMutation);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendMentionNotification = (0, $42omo.useCallback)(({ mentions: mentions })=>{
        const fireAnalyticsEvent = (action)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: action,
                    actionSubject: 'mentionInputMutation',
                    attributes: {
                        mentions: mentions.map((mention)=>({
                                mentionedUserId: mention.mentionedUserAccountId,
                                mentionId: mention.mentionLocalId
                            })),
                        contentId: contentId
                    }
                }
            }).fire();
        };
        // NCS draft syncs need to happen prior to mutation in order for
        // email content to show up. A 15 second buffer after user closes
        // the flag notification will give draft syncs a chance to happen.
        setTimeout(()=>{
            // tells backend to send notificiation for the list of mention IDs
            createContentMentionNotificationAction({
                variables: {
                    contentId: contentId,
                    mentions: mentions
                }
            }).then(()=>{
                fireAnalyticsEvent('succeeded');
            }).catch(()=>{
                //TODO: create new error flag that handles multiple names
                fireAnalyticsEvent('failed');
            });
        }, 15000);
    }, [
        contentId,
        createAnalyticsEvent,
        createContentMentionNotificationAction
    ]);
    const sendCancelMentionNotification = (0, $42omo.useCallback)(({ mentions: mentions })=>{
        createContentMentionNotificationAction({
            variables: {
                contentId: contentId,
                mentions: mentions
            }
        }).catch((error)=>{
            setError(error);
            showDontNotifyFailedFlag();
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createContentMentionNotificationAction
    ]);
    return {
        sendMentionNotification: sendMentionNotification,
        sendCancelMentionNotification: sendCancelMentionNotification,
        contentMentionNotificationError: contentMentionNotificationError
    };
};


/**
 * @generated SignedSource<<15b82d796ab0dea364d877992ac9d9ff>>
 * @relayHash 029e76bfcd70279acd22d488125dc454
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 936914f8502bab28553df0f472fa4f87cbb23cb871cb9a825222f522face951d
const $5360cbc6d166638c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tasks"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "tasks",
                            "variableName": "tasks"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "CreateInlineTaskNotificationPayload",
            "kind": "LinkedField",
            "name": "createInlineTaskNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "029e76bfcd70279acd22d488125dc454",
            "id": "936914f8502bab28553df0f472fa4f87cbb23cb871cb9a825222f522face951d",
            "metadata": {},
            "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation($contentId:ID!,$tasks:[IndividualInlineTaskNotificationInput]!){createInlineTaskNotification(input:{contentId:$contentId,tasks:$tasks}){contentId,success,errors{message}}}"
        }
    };
}();
$5360cbc6d166638c$var$node.hash = "fca74fc99391b016271338a6b81b557d";
var $5360cbc6d166638c$export$2e2bcd8739ae039 = $5360cbc6d166638c$var$node;











const $204e1c50e8dfb669$var$useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation = (0, $5360cbc6d166638c$export$2e2bcd8739ae039);
const $204e1c50e8dfb669$export$bb50e46e1081bc7f = ({ contentId: contentId, setError: setError, showDontNotifyFailedFlag: showDontNotifyFailedFlag })=>{
    const [createInlineTaskNotificationMutation, { error: createTaskNotificationError }] = (0, $308Wd.useMutationInterop)($204e1c50e8dfb669$var$useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendCreateInlineTaskNotifications = (0, $42omo.useCallback)(({ tasks: tasks })=>{
        const fireAnalyticsEvent = (action)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: action,
                    actionSubject: 'createInlineTaskMention',
                    attributes: {
                        contentId: contentId,
                        mentions: tasks?.map((task)=>({
                                taskId: task.taskId,
                                mentionId: task.recipientMentionLocalId,
                                mentionedUserId: task.recipientAccountId
                            }))
                    }
                }
            }).fire();
        };
        // NCS draft syncs need to happen prior to mutation in order for
        // email content to show up. A 15 second buffer after user closes
        // the flag notification will give draft syncs a chance to happen.
        setTimeout(()=>{
            createInlineTaskNotificationMutation({
                variables: {
                    contentId: contentId,
                    tasks: tasks ?? []
                }
            }).then(()=>{
                fireAnalyticsEvent('succeeded');
            }).catch((error)=>{
                fireAnalyticsEvent('failed');
                setError(error);
            });
        }, 15000);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createAnalyticsEvent,
        createInlineTaskNotificationMutation
    ]);
    const cancelInlineTaskNotifications = (0, $42omo.useCallback)(({ tasks: tasks })=>{
        createInlineTaskNotificationMutation({
            variables: {
                contentId: contentId,
                tasks: tasks ?? []
            }
        }).catch(()=>{
            showDontNotifyFailedFlag();
        });
    }, [
        contentId,
        createInlineTaskNotificationMutation,
        showDontNotifyFailedFlag
    ]);
    return {
        sendCreateInlineTaskNotifications: sendCreateInlineTaskNotifications,
        cancelInlineTaskNotifications: cancelInlineTaskNotifications,
        createTaskNotificationError: createTaskNotificationError
    };
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $55e2d13107c6bf2d$export$4fd34ed002cf6bfb = /*#__PURE__*/ function(ContentRole) {
    ContentRole["DEFAULT"] = "DEFAULT";
    ContentRole["EDITOR"] = "EDITOR";
    ContentRole["VIEWER"] = "VIEWER";
    return ContentRole;
}({});
var $55e2d13107c6bf2d$export$aa5f3445d469c06b = /*#__PURE__*/ function(ConfluencePrincipalType) {
    ConfluencePrincipalType["GROUP"] = "GROUP";
    ConfluencePrincipalType["USER"] = "USER";
    return ConfluencePrincipalType;
}({});


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $1acca270709c231c$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["ASSIGNED"] = "ASSIGNED";
    Operation["COMPLETE"] = "COMPLETE";
    Operation["DELETED"] = "DELETED";
    Operation["IN_COMPLETE"] = "IN_COMPLETE";
    Operation["REWORDED"] = "REWORDED";
    Operation["UNASSIGNED"] = "UNASSIGNED";
    return Operation;
}({});





const $7af36150ec4f5d3b$export$b059320aeb0e91e6 = (0, $aXWIB.defineMessages)({
    mentionFlagTitle: {
        id: "mentions-notifications.mention.flag.title",
        defaultMessage: "{displayName} will be notified"
    },
    mentionFlagTitleTwoMentions: {
        id: "mentions-notifications.mention.flag.title.two.mentions",
        defaultMessage: "{displayName} and {somebodyElse} will be notified"
    },
    mentionFlagTitleMultipleMentions: {
        id: "mentions-notifications.mention.flag.title.multiple.mentions",
        defaultMessage: "{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} will be notified"
    },
    mentionFlagDescription: {
        id: "mentions-notifications.mention.flag.description",
        defaultMessage: "We\u2019ll let them know you mentioned them."
    },
    taskMentionFlagTitle: {
        id: "mentions-notifications.task.mention.flag.title",
        defaultMessage: "We\u2019ll notify {displayName}"
    },
    taskMentionFlagDescription: {
        id: "mentions-notifications.task.mention.flag.description",
        defaultMessage: "We\u2019ll let them know you assigned them a task."
    },
    mentionFlagFailedTitle: {
        id: "mentions-notifications.mention.flag.failed.title",
        defaultMessage: "We weren\u2019t able to notify {displayName}"
    },
    mentionFlagFailedTitleWithoutDisplayName: {
        id: "mentions-notifications.mention.flag.failed.generic.title",
        defaultMessage: "We weren\u2019t able to notify the user"
    },
    mentionFlagFailedDescription: {
        id: "mentions-notifications.mention.flag.failed.description",
        defaultMessage: "In order to notify them, you\u2019ll need to @ mention them again."
    },
    mentionFlagDoNotNotifyButton: {
        id: "mentions-notifications.mention.flag.do.not.notify.button",
        defaultMessage: "Don\u2019t notify"
    },
    mentionFlagAcknowledgeButton: {
        id: "mentions-notifications.mention.flag.acknowledge.button",
        defaultMessage: "OK"
    },
    mentionFlagNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.title",
        defaultMessage: "Share with {displayName}?"
    },
    mentionFlagTwoNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.two.mentions.title",
        defaultMessage: "Share with {displayName} and {somebodyElse}?"
    },
    mentionFlagMultipleNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.multiple.mentions.title",
        defaultMessage: "Share with {displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}}"
    },
    mentionFlagNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.title",
        defaultMessage: "{displayName} won\u2019t be notified"
    },
    mentionFlagTwoNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.two.mentions.title",
        defaultMessage: "{displayName} and {somebodyElse} won\u2019t be notified"
    },
    mentionFlagMultipleNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.multiple.mentions.title",
        defaultMessage: "{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} won\u2019t be notified"
    },
    taskMentionFlagNoPermissionsTitle: {
        id: "mentions-notifications.task.mention.flag.no.permissions.title",
        defaultMessage: "Share with {displayName}?"
    },
    mentionFlagNoSpaceOrParentPermissionsDescription: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.description",
        defaultMessage: "They need space or parent access, so we can\u2019t let them know you mentioned them."
    },
    mentionFlagNoPermissionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.description",
        defaultMessage: "They don\u2019t have access to this content, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.description",
        defaultMessage: "They don\u2019t have access to this content, so we can\u2019t assign them a task or notify them."
    },
    mentionFlagNoPermissionsParentRestrictionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.parent.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsParentRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.parent.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item, so we can\u2019t assign them a task or notify them."
    },
    mentionFlagNoPermissionsSpaceRestrictionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to the space, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsSpaceRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to the space, so we can\u2019t assign them a task or notify them."
    },
    taskMentionFlagNoPermissionsParentSpaceRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.parent.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item or space, so we can\u2019t assign them this task or notify them."
    },
    mentionFlagShareNowButton: {
        id: "mentions-notifications.mention.flag.share.now.button",
        defaultMessage: "Share now"
    },
    mentionFlagDontShareButton: {
        id: "mentions-notifications.mention.flag.dont.share.button",
        defaultMessage: "Don\u2019t share"
    },
    mentionFlagShareFailedTitle: {
        id: "mentions-notifications.mention.flag.share.failed.title",
        defaultMessage: "We weren\u2019t able to share this content with {displayName}"
    },
    mentionFlagShareFailedDescription: {
        id: "mentions-notifications.mention.flag.share.failed.description",
        defaultMessage: "Please try again later."
    },
    deletedMentionFlagTitle: {
        id: "mentions-notifications.mention.flag.deleted.title",
        defaultMessage: "You just removed an @ mention"
    },
    deletedMentionFlagDescription: {
        id: "mentions-notifications.mention.flag.deleted.description",
        defaultMessage: "{name} won\u2019t be notified anymore"
    },
    deletedMentionFlagConfirmation: {
        id: "mentions-notifications.mention.flag.deleted.confirmation",
        defaultMessage: "Got it"
    },
    dontNotifyFailureTitle: {
        id: "mentions-notifications.mention.flag.do.not.notify.failure.title",
        defaultMessage: "Something went wrong"
    },
    dontNotifyFailureDescription: {
        id: "mentions-notifications.mention.flag.do.not.notify.failure.description",
        defaultMessage: "Due to an error, we weren\u2019t able to cancel this notification. "
    }
});






var $cAdj8 = parcelRequire("cAdj8");

const $4363b504cf9a037b$export$d8cade7866e82605 = ()=>{
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const canEditPageRestrictions = (0, $42omo.useMemo)(()=>{
        if (pageInfo) {
            const pageType = pageInfo.type ?? '';
            const operations = pageInfo.operations || [];
            const userCanEditRestrictions = operations.some((o)=>o?.operation === 'restrict_content' && o?.targetType === pageType);
            return userCanEditRestrictions;
        }
        return false;
    }, [
        pageInfo
    ]);
    return canEditPageRestrictions;
};





const $2b2a9498abd1ee19$export$406377d40397a2f7 = (startTime)=>{
    const endTime = Date.now();
    let elapsedTimeInSeconds = 0;
    if (startTime.current !== null) elapsedTimeInSeconds = (endTime - startTime.current) / 1000; // Convert to seconds
    return elapsedTimeInSeconds;
};


const $36be47a9ed41f8db$var$getDisplayNames = (mentions)=>{
    const displayNames = new Set(mentions.map((mention)=>mention.displayName));
    const iterator = displayNames.values();
    const displayName = iterator.next().value ?? '';
    const somebodyElse = iterator.next().value ?? '';
    return {
        displayNames: displayNames,
        displayName: displayName,
        somebodyElse: somebodyElse
    };
};
const $36be47a9ed41f8db$export$fdb0a5f78dc34be6 = ({ flags: flags, contentId: contentId, isLivePage: isLivePage, isMentionsNotificationsEnabled: isMentionsNotificationsEnabled, editorActions: editorActions })=>{
    const [{ addedMentions: addedMentions, deletedMentions: deletedMentions, addedTasks: addedTasks, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks, deletedTasks: deletedTasks, mentionsAdded: mentionsAdded, tasksAdded: tasksAdded }, { setAddedMentions: setAddedMentions, setDeletedMentions: setDeletedMentions, setUnrestrictedMentions: setUnrestrictedMentions, setParentSpaceRestrictedMentions: setParentSpaceRestrictedMentions, setPageRestrictedMentions: setPageRestrictedMentions, setUnrestrictedTasks: setUnrestrictedTasks, setPageRestrictedTasks: setPageRestrictedTasks, setParentSpaceRestrictedTasks: setParentSpaceRestrictedTasks, setDeletedTasks: setDeletedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded }] = (0, $hdxAi.useMentionsNotifications)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    //General Mention Flag IDs
    const [currentAddedMentionFlagId, setCurrentAddedMentionFlagId] = (0, $42omo.useState)('');
    const [currentSpaceOrParentRestrictionMentionFlagId, setCurrentSpaceOrParentRestrictionMentionFlagId] = (0, $42omo.useState)('');
    const [currentPageRestrictionMentionFlagId, setCurrentPageRestrictionMentionFlagId] = (0, $42omo.useState)('');
    //Task Mentions Flag IDs
    const [currentAddedTaskFlagId, setCurrentAddedTaskFlagId] = (0, $42omo.useState)('');
    const [currentPageRestrictionTaskFlagId, setCurrentPageRestrictionTaskFlagId] = (0, $42omo.useState)('');
    const [currentSpaceOrParentRestrictionTaskFlagId, setCurrentSpaceOrParentRestrictionTaskFlagId] = (0, $42omo.useState)('');
    //General Mention Timeouts
    const addedUnrestrictedMentionFlagTimeout = (0, $42omo.useRef)();
    const pageRestrictedMentionFlagTimeout = (0, $42omo.useRef)();
    const spaceParentRestrictedMentionFlagTimeout = (0, $42omo.useRef)();
    //Task Mention Timeouts
    const addedUnrestrictedTaskFlagTimeout = (0, $42omo.useRef)();
    const pageRestrictedTaskFlagTimeout = (0, $42omo.useRef)();
    const spaceParentRestrictedTaskFlagTimeout = (0, $42omo.useRef)();
    const [error, setError] = (0, $42omo.useState)(null);
    const mentionsToDisplay = (0, $42omo.useMemo)(()=>[
            ...addedMentions,
            ...addedTasks
        ], [
        addedMentions,
        addedTasks
    ]);
    const { updatedUsersContentPermissionsError: updatedUsersContentPermissionsError, updatedUsersContentPermissionsLoading: updatedUsersContentPermissionsLoading, updateUsersContentPermissionMutation: updateUsersContentPermissionMutation } = (0, $a429a791ecef3570$export$a5b8a857cb669f1f)({
        contentId: contentId,
        isUpdatedMentionsInLivePagesEnabled: isMentionsNotificationsEnabled,
        isLivePage: isLivePage,
        currentUserId: currentUserId,
        mentionsToDisplay: mentionsToDisplay,
        source: 'mentionNoAccessFlag'
    });
    const canEditPageRestrictions = (0, $4363b504cf9a037b$export$d8cade7866e82605)();
    (0, $42omo.useEffect)(()=>{
        const getDuplicateMentions = async (mentions)=>{
            const duplicateMentions = new Set();
            if (mentions.length > 0) {
                const mentionCounts = new Map();
                const editorContent = await editorActions?.getValue();
                editorContent?.content?.forEach((node)=>{
                    node?.content?.forEach((content)=>{
                        if (content.type === 'mention') {
                            if (mentionCounts.has(content.attrs.id)) mentionCounts.set(content.attrs.id, mentionCounts.get(content.attrs.id) + 1);
                            else mentionCounts.set(content.attrs.id, 1);
                        }
                    });
                });
                mentions.forEach((mention)=>{
                    if (mentionCounts.get(mention.id) > 1) duplicateMentions.add(mention.id);
                });
            }
            return duplicateMentions;
        };
        getDuplicateMentions(mentionsToDisplay).then((duplicateMentions)=>{
            if (duplicateMentions.size > 0) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: 'created',
                    actionSubject: 'mention',
                    attributes: {
                        isDuplicate: true
                    }
                }
            }).fire();
        }).catch((e)=>{
            setError(e);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionsToDisplay
    ]);
    const mentionsFlagStartTime = (0, $42omo.useRef)(null);
    const tasksFlagStartTime = (0, $42omo.useRef)(null);
    // `showCustomFlag` for confirmation flags without CTA
    const showCustomFlag = (0, $42omo.useCallback)(({ title: title, description: description, userPhoto: userPhoto, autoDismiss: autoDismiss = true, id: id, handleOnClose: handleOnClose })=>{
        flags.showCustomFlag({
            id: id ?? undefined,
            title: title,
            description: description,
            isAutoDismiss: autoDismiss,
            customIcon: userPhoto ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: userPhoto,
                label: "mention"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                spacing: "spacious",
                label: "mention"
            }),
            onClose: handleOnClose
        });
    }, [
        flags
    ]);
    const showDontNotifyFailedFlag = (0, $42omo.useCallback)(()=>{
        flags.showCustomFlag({
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).dontNotifyFailureTitle),
            description: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).dontNotifyFailureDescription),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                spacing: "spacious",
                label: "error"
            }),
            isAutoDismiss: true
        });
    }, [
        flags,
        formatMessage
    ]);
    const { sendMentionNotification: sendMentionNotification, sendCancelMentionNotification: sendCancelMentionNotification, contentMentionNotificationError: contentMentionNotificationError } = (0, $05c7f8c23696cebd$export$82f89b951e37c769)({
        contentId: contentId,
        setError: setError,
        showDontNotifyFailedFlag: showDontNotifyFailedFlag
    });
    const { sendCreateInlineTaskNotifications: sendCreateInlineTaskNotifications, cancelInlineTaskNotifications: cancelInlineTaskNotifications, createTaskNotificationError: createTaskNotificationError } = (0, $204e1c50e8dfb669$export$bb50e46e1081bc7f)({
        contentId: contentId,
        setError: setError,
        showDontNotifyFailedFlag: showDontNotifyFailedFlag
    });
    // `showCustomFlagWithAction` for:
    // - unrestricted users with "do not notify" CTA
    // - share now for restricted users
    // - deleted mention flag
    const showCustomFlagWithActions = (0, $42omo.useCallback)(({ title: title, description: description, userPhoto: userPhoto, actions: actions, handleOnClose: handleOnClose, autoDismiss: autoDismiss = true, id: id })=>{
        flags.showCustomFlag({
            title: title,
            description: description,
            isAutoDismiss: autoDismiss,
            customIcon: userPhoto ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: userPhoto,
                label: "mention"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                spacing: "spacious",
                label: "mention"
            }),
            onClose: handleOnClose && handleOnClose,
            actions: actions,
            id: id ?? undefined
        });
    }, [
        flags
    ]);
    const displayNoPermissionsFlag = (0, $42omo.useCallback)(({ displayNames: displayNames, flagFields: flagFields, displayName: displayName, somebodyElse: somebodyElse, flagId: flagId, restrictedLevel: restrictedLevel = 'page', hasAction: hasAction = false, userPhoto: userPhoto })=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'triggered',
                actionSubject: 'mentionNoAccessFlag',
                source: 'page',
                attributes: {
                    restrictedLevel: restrictedLevel,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        const hasPageRestrictionsAndCanEdit = restrictedLevel === 'page' && canEditPageRestrictions;
        const showFlagFn = hasAction ? showCustomFlagWithActions : showCustomFlag;
        if (displayNames.size === 1) showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoPermissionsTitle, {
                displayName: displayName
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoSpaceOrParentPermissionsTitle, {
                displayName: displayName
            }),
            id: flagId,
            userPhoto: userPhoto
        });
        else if (displayNames.size === 2) showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTwoNoPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTwoNoSpaceOrParentPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }),
            id: flagId
        });
        else //3 or more mentioned users
        showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagMultipleNoPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagMultipleNoSpaceOrParentPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }),
            id: flagId
        });
    }, [
        createAnalyticsEvent,
        formatMessage,
        showCustomFlag,
        showCustomFlagWithActions,
        isLivePage,
        canEditPageRestrictions
    ]);
    const getNotificationPayload = (notifyAction, mentions, type)=>{
        const mentionsWithNotificationAction = [];
        const tasksWithNotificationAction = [];
        mentions.forEach((mention)=>{
            if (type === 'standard') mentionsWithNotificationAction.push({
                mentionedUserAccountId: mention.id,
                mentionLocalId: mention.localId,
                notificationAction: notifyAction
            });
            else if (type === 'task') tasksWithNotificationAction.push({
                notificationAction: notifyAction,
                operation: (0, $1acca270709c231c$export$ab5aad00225c5662).ASSIGNED,
                recipientAccountId: mention.id,
                recipientMentionLocalId: mention.localId,
                taskId: mention.taskLocalId ?? ''
            });
        });
        return {
            mentionsWithNotificationAction: mentionsWithNotificationAction,
            tasksWithNotificationAction: tasksWithNotificationAction
        };
    };
    const sendNotificationFn = (mentions, type, closeFlagFn)=>{
        const { mentionsWithNotificationAction: mentionsWithNotificationAction, tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).NOTIFY, mentions, type);
        if (type === 'standard') sendMentionNotification({
            mentions: mentionsWithNotificationAction
        });
        else if (type === 'task') sendCreateInlineTaskNotifications({
            tasks: tasksWithNotificationAction
        });
        closeFlagFn?.();
    };
    const showUnrestrictedPageAccessFlag = (0, $42omo.useCallback)(({ type: type, mentions: mentions, userPhoto: userPhoto })=>{
        const analyticsPayload = mentions.map((mention)=>{
            if (type === 'standard') return {
                mentionedUserId: mention.id,
                mentionId: mention.localId
            };
            else if (type === 'task') return {
                taskId: mention.taskLocalId,
                mentionId: mention.localId,
                mentionedUserId: mention.id
            };
        });
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const handleFlag = (currentFlagId, setCurrentFlagId, flagStartTime)=>{
            if (currentFlagId) addedMentionFlagId = currentFlagId;
            else {
                setCurrentFlagId(addedMentionFlagId);
                flagStartTime.current = Date.now();
            }
        };
        if (type === 'standard') handleFlag(currentAddedMentionFlagId, setCurrentAddedMentionFlagId, mentionsFlagStartTime);
        else if (type === 'task') handleFlag(currentAddedTaskFlagId, setCurrentAddedTaskFlagId, tasksFlagStartTime);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                setCurrentAddedMentionFlagId('');
                setUnrestrictedMentions([]);
                mentionsFlagStartTime.current = null;
            } else if (type === 'task') {
                setCurrentAddedTaskFlagId('');
                setUnrestrictedTasks([]);
                tasksFlagStartTime.current = null;
            }
        };
        const sendDontNotifyFn = ()=>{
            const { mentionsWithNotificationAction: mentionsWithNotificationAction, tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, mentions, type);
            if (type === 'standard') {
                sendCancelMentionNotification({
                    mentions: mentionsWithNotificationAction
                });
                clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
            } else if (type === 'task') {
                cancelInlineTaskNotifications({
                    tasks: tasksWithNotificationAction
                });
                clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
            }
        };
        const handleClose = ()=>{
            //when "X" is clicked, or user acknowledges the flag
            const elapsedTimeInSeconds = type === 'standard' ? (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(mentionsFlagStartTime) : (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(tasksFlagStartTime);
            closeFlag();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: type === 'standard' ? 'dismissMentionsNotifications' : 'dismissTaskMentionsNotifications',
                    attributes: {
                        contentId: contentId,
                        elapsedTimeInSeconds: elapsedTimeInSeconds,
                        mentions: analyticsPayload
                    }
                }
            }).fire();
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
            addedUnrestrictedMentionFlagTimeout.current = setTimeout(()=>{
                sendNotificationFn(mentions, type, closeFlag);
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
            addedUnrestrictedTaskFlagTimeout.current = setTimeout(()=>{
                sendNotificationFn(mentions, type, closeFlag);
            }, 8000);
        }
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagDescription),
            actions: [
                {
                    content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagAcknowledgeButton),
                    onClick: handleClose
                },
                {
                    content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDoNotNotifyButton),
                    onClick: ()=>{
                        //On clicking "don't notify"
                        const elapsedTimeInSeconds = type === 'standard' ? (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(mentionsFlagStartTime) : (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(tasksFlagStartTime);
                        sendDontNotifyFn();
                        closeFlag();
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                source: 'mentionsNotifications',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: type === 'standard' ? 'doNotNotify' : 'doNotAssign',
                                attributes: {
                                    contentId: contentId,
                                    mentions: analyticsPayload,
                                    elapsedTimeInSeconds: elapsedTimeInSeconds
                                }
                            }
                        }).fire();
                    }
                }
            ],
            handleOnClose: handleClose,
            autoDismiss: false
        };
        if (displayNames.size === 1) showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitle, {
                displayName: displayName
            }),
            id: addedMentionFlagId,
            userPhoto: userPhoto
        });
        else if (displayNames.size === 2) showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitleTwoMentions, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }),
            id: addedMentionFlagId
        });
        else //3 or more mentioned users
        showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitleMultipleMentions, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }),
            id: addedMentionFlagId
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createAnalyticsEvent,
        currentAddedMentionFlagId,
        flags,
        formatMessage,
        sendCancelMentionNotification,
        sendMentionNotification,
        setUnrestrictedMentions,
        showCustomFlagWithActions,
        currentAddedTaskFlagId,
        sendCreateInlineTaskNotifications,
        setUnrestrictedTasks,
        cancelInlineTaskNotifications,
        mentionsFlagStartTime,
        tasksFlagStartTime
    ]);
    const showPageRestrictionsFlag = (0, $42omo.useCallback)(({ type: type, mentions: mentions })=>{
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        //If a flag ID is already in local state, that means the respective flag is currently open. If not, we generate a uuid to set on the flag which is about to be opened. Having a uuid on the flag allows us to update the content without closing the flag
        if (type === 'standard' && currentPageRestrictionMentionFlagId) addedMentionFlagId = currentPageRestrictionMentionFlagId;
        else if (type === 'task' && currentPageRestrictionTaskFlagId) addedMentionFlagId = currentPageRestrictionTaskFlagId;
        if (type === 'standard' && !currentPageRestrictionMentionFlagId) setCurrentPageRestrictionMentionFlagId(addedMentionFlagId);
        if (type === 'task' && !currentPageRestrictionTaskFlagId) setCurrentPageRestrictionTaskFlagId(addedMentionFlagId);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                clearTimeout(pageRestrictedMentionFlagTimeout.current);
                setCurrentPageRestrictionMentionFlagId('');
                setPageRestrictedMentions([]);
            } else if (type === 'task') {
                clearTimeout(pageRestrictedTaskFlagTimeout.current);
                setCurrentPageRestrictionTaskFlagId('');
                setPageRestrictedTasks([]);
            }
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(pageRestrictedMentionFlagTimeout.current);
            pageRestrictedMentionFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(pageRestrictedTaskFlagTimeout.current);
            pageRestrictedTaskFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        }
        const flagActions = [
            {
                content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareNowButton),
                onClick: ()=>{
                    //On clicking "share now" - Update page permissions
                    closeFlag();
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: 'mentionNoAccessFlag',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'shareNowButton',
                            attributes: {
                                mentionType: type,
                                isLivePage: isLivePage
                            }
                        }
                    }).fire();
                    updateUsersContentPermissionMutation({
                        variables: {
                            contentId: contentId,
                            input: mentions?.map((user)=>({
                                    contentRole: (0, $55e2d13107c6bf2d$export$4fd34ed002cf6bfb).VIEWER,
                                    principalId: user.id,
                                    confluencePrincipalType: (0, $55e2d13107c6bf2d$export$aa5f3445d469c06b).USER
                                }))
                        }
                    }).then(()=>{
                        // Only send immediate notification for Live Pages
                        if (isLivePage) sendNotificationFn(mentions, type, closeFlag);
                    }).catch((e)=>{
                        setError(e);
                        showCustomFlag({
                            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareFailedTitle),
                            description: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareFailedDescription)
                        });
                    });
                }
            },
            {
                content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDontShareButton),
                onClick: ()=>{
                    closeFlag();
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: 'mentionNoAccessFlag',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'dontShareButton',
                            attributes: {
                                mentionType: type,
                                isLivePage: isLivePage
                            }
                        }
                    }).fire();
                }
            }
        ];
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoPermissionsDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagNoPermissionsDescription),
            actions: canEditPageRestrictions ? flagActions : undefined,
            handleOnClose: ()=>{
                closeFlag();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'mentionNoAccessFlag',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'dismissButton',
                        attributes: {
                            mentionType: type,
                            restrictedLevel: 'page',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            },
            autoDismiss: false
        };
        displayNoPermissionsFlag({
            displayNames: displayNames,
            flagFields: {
                ...sharedFlagFields,
                title: ''
            },
            displayName: displayName,
            somebodyElse: somebodyElse,
            flagId: addedMentionFlagId,
            restrictedLevel: 'page',
            hasAction: true,
            userPhoto: mentions[0]?.userPhoto
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        canEditPageRestrictions,
        contentId,
        createAnalyticsEvent,
        currentPageRestrictionMentionFlagId,
        currentPageRestrictionTaskFlagId,
        displayNoPermissionsFlag,
        flags,
        formatMessage,
        setPageRestrictedMentions,
        setPageRestrictedTasks,
        showCustomFlag,
        updateUsersContentPermissionMutation
    ]);
    const showParentSpaceRestrictedFlag = (0, $42omo.useCallback)(({ type: type, mentions: mentions })=>{
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        //If a flag ID is already in local state, that means the respective flag is currently open. If not, we generate a uuid to set on the flag which is about to be opened. Having a uuid on the flag allows us to update the content without closing the flag
        if (type === 'standard' && currentSpaceOrParentRestrictionMentionFlagId) addedMentionFlagId = currentSpaceOrParentRestrictionMentionFlagId;
        else if (type === 'task' && currentSpaceOrParentRestrictionTaskFlagId) addedMentionFlagId = currentSpaceOrParentRestrictionTaskFlagId;
        if (type === 'standard' && !currentSpaceOrParentRestrictionMentionFlagId) setCurrentSpaceOrParentRestrictionMentionFlagId(addedMentionFlagId);
        if (type === 'task' && !currentSpaceOrParentRestrictionTaskFlagId) setCurrentSpaceOrParentRestrictionTaskFlagId(addedMentionFlagId);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
                setCurrentSpaceOrParentRestrictionMentionFlagId('');
                setParentSpaceRestrictedMentions([]);
            } else if (type === 'task') {
                clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
                setCurrentSpaceOrParentRestrictionTaskFlagId('');
                setParentSpaceRestrictedTasks([]);
            }
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
            spaceParentRestrictedMentionFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
            spaceParentRestrictedTaskFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        }
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoSpaceOrParentPermissionsDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagNoPermissionsParentSpaceRestrictionsDescription),
            handleOnClose: ()=>{
                closeFlag();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'mentionNoAccessFlag',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'dismissButton',
                        attributes: {
                            mentionType: type,
                            restrictedLevel: 'parent',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            },
            autoDismiss: false
        };
        displayNoPermissionsFlag({
            displayNames: displayNames,
            flagFields: {
                ...sharedFlagFields,
                title: '',
                actionContent: '',
                actionOnClick: ()=>{}
            },
            displayName: displayName,
            somebodyElse: somebodyElse,
            restrictedLevel: 'parent',
            flagId: addedMentionFlagId,
            userPhoto: mentions[0]?.userPhoto
        });
    }, [
        createAnalyticsEvent,
        currentSpaceOrParentRestrictionMentionFlagId,
        currentSpaceOrParentRestrictionTaskFlagId,
        formatMessage,
        displayNoPermissionsFlag,
        flags,
        setParentSpaceRestrictedMentions,
        setParentSpaceRestrictedTasks,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        //Handling deleted mentions
        if (deletedMentions.length > 0) {
            //Handles updating content of current open mention flags
            const deletedMentionsLocalIds = new Set(deletedMentions.map((mention)=>mention.localId));
            //Filter out deleted mentions from current open general mention flag
            const remainingUnrestrictedStandardMentions = unrestrictedMentions.filter((unrestrictedMention)=>!deletedMentionsLocalIds.has(unrestrictedMention.localId));
            const remainingParentSpaceRestrictedStandardMentions = parentSpaceRestrictedMentions.filter((parentSpaceRestrictedMention)=>!deletedMentionsLocalIds.has(parentSpaceRestrictedMention.localId));
            const remainingPageRestrictedStandardMentions = pageRestrictedMentions.filter((pageRestrictedMention)=>!deletedMentionsLocalIds.has(pageRestrictedMention.localId));
            //Close general mention flag if none remain
            if (remainingUnrestrictedStandardMentions?.length === 0) {
                clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentAddedMentionFlagId);
                setCurrentAddedMentionFlagId('');
            }
            if (remainingParentSpaceRestrictedStandardMentions?.length === 0) {
                clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentSpaceOrParentRestrictionMentionFlagId);
                setCurrentSpaceOrParentRestrictionMentionFlagId('');
            }
            if (remainingPageRestrictedStandardMentions?.length === 0) {
                clearTimeout(pageRestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentPageRestrictionMentionFlagId);
                setCurrentPageRestrictionMentionFlagId('');
            }
            setUnrestrictedMentions(remainingUnrestrictedStandardMentions);
            setParentSpaceRestrictedMentions(remainingParentSpaceRestrictedStandardMentions);
            setPageRestrictedMentions(remainingPageRestrictedStandardMentions);
            setDeletedMentions([]);
        }
        if (deletedTasks.length > 0) {
            //Handles updating content of current open task flags
            const deletedTasksLocalIds = new Set(deletedTasks.map((mention)=>mention.localId));
            //Filter out deleted mentions from current open task mention flag
            const remainingUnrestrictedTasks = unrestrictedTasks.filter((unrestrictedTask)=>!deletedTasksLocalIds.has(unrestrictedTask.localId));
            const remainingParentSpaceRestrictedTasks = parentSpaceRestrictedTasks.filter((parentSpaceRestrictedTask)=>!deletedTasksLocalIds.has(parentSpaceRestrictedTask.localId));
            const remainingPageRestrictedTasks = pageRestrictedTasks.filter((pageRestrictedTask)=>!deletedTasksLocalIds.has(pageRestrictedTask.localId));
            //Close task mention flag if none remain
            if (remainingUnrestrictedTasks?.length === 0) {
                clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentAddedTaskFlagId);
                setCurrentAddedTaskFlagId('');
            }
            if (remainingParentSpaceRestrictedTasks?.length === 0) {
                clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentSpaceOrParentRestrictionTaskFlagId);
                setCurrentSpaceOrParentRestrictionTaskFlagId('');
            }
            if (remainingPageRestrictedTasks?.length === 0) {
                clearTimeout(pageRestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentPageRestrictionTaskFlagId);
                setCurrentPageRestrictionTaskFlagId('');
            }
            setUnrestrictedTasks(remainingUnrestrictedTasks);
            setParentSpaceRestrictedTasks(remainingParentSpaceRestrictedTasks);
            setPageRestrictedTasks(remainingPageRestrictedTasks);
            setDeletedTasks([]);
        }
    //leaving addedMentions out of the dependency array otherwise the deleted flag will be displayed twice
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setDeletedMentions,
        flags,
        showCustomFlagWithActions,
        formatMessage,
        setAddedMentions,
        deletedMentions,
        setDeletedTasks,
        deletedTasks
    ]);
    const checkPastedMentions = (mentions)=>{
        return mentions.some((mention)=>mention.method === 'pasted');
    };
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && unrestrictedMentions?.length) {
            if (isLivePage) {
                if (checkPastedMentions(unrestrictedMentions)) // When mention is pasted, show flag
                showUnrestrictedPageAccessFlag({
                    type: 'standard',
                    mentions: unrestrictedMentions,
                    userPhoto: unrestrictedMentions[0]?.userPhoto
                });
                else {
                    // When mention is typed, only send notification
                    sendNotificationFn(unrestrictedMentions, 'standard');
                    setUnrestrictedMentions([]);
                }
            } else setUnrestrictedMentions([]);
        }
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unrestrictedMentions,
        updatedUsersContentPermissionsLoading,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && unrestrictedTasks?.length) {
            if (isLivePage) {
                if (checkPastedMentions(unrestrictedTasks)) // When mention is pasted, show flag
                showUnrestrictedPageAccessFlag({
                    type: 'task',
                    mentions: unrestrictedTasks,
                    userPhoto: unrestrictedTasks[0]?.userPhoto
                });
                else {
                    // When mention is typed, only send notification
                    sendNotificationFn(unrestrictedTasks, 'task');
                    setUnrestrictedTasks([]);
                }
            } else setUnrestrictedTasks([]);
        }
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unrestrictedTasks,
        updatedUsersContentPermissionsLoading,
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && parentSpaceRestrictedMentions?.length) showParentSpaceRestrictedFlag({
            type: 'standard',
            mentions: parentSpaceRestrictedMentions
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags,
        parentSpaceRestrictedMentions,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && parentSpaceRestrictedTasks?.length) showParentSpaceRestrictedFlag({
            type: 'task',
            mentions: parentSpaceRestrictedTasks
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags,
        parentSpaceRestrictedTasks,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && pageRestrictedMentions?.length) showPageRestrictionsFlag({
            type: 'standard',
            mentions: pageRestrictedMentions
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        canEditPageRestrictions,
        flags,
        pageRestrictedMentions,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && pageRestrictedTasks?.length) showPageRestrictionsFlag({
            type: 'task',
            mentions: pageRestrictedTasks
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        canEditPageRestrictions,
        flags,
        pageRestrictedTasks,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $42omo.useEffect)(()=>{
        if (mentionsAdded.currentUser.length > 0) {
            if (isLivePage) {
                const { mentionsWithNotificationAction: mentionsWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, mentionsAdded.currentUser, 'standard');
                sendCancelMentionNotification({
                    mentions: mentionsWithNotificationAction
                });
            }
            setMentionsAdded({
                currentUser: []
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionsAdded.currentUser
    ]);
    (0, $42omo.useEffect)(()=>{
        if (tasksAdded.currentUser.length > 0) {
            if (isLivePage) {
                const { tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, tasksAdded.currentUser, 'task');
                cancelInlineTaskNotifications({
                    tasks: tasksWithNotificationAction
                });
            }
            setTasksAdded({
                currentUser: []
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tasksAdded.currentUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), createTaskNotificationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: createTaskNotificationError
    }), contentMentionNotificationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentMentionNotificationError
    }), updatedUsersContentPermissionsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: updatedUsersContentPermissionsError
    }));
};
const $36be47a9ed41f8db$export$6124ca97c5c9fe4d = ({ children: children, flags: flags, contentId: contentId, isLivePage: isLivePage, isMentionsNotificationsEnabled: isMentionsNotificationsEnabled, editorActions: editorActions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36be47a9ed41f8db$export$fdb0a5f78dc34be6, {
        flags: flags,
        contentId: contentId,
        isLivePage: isLivePage,
        isMentionsNotificationsEnabled: isMentionsNotificationsEnabled,
        editorActions: editorActions
    })), children);
};



var $hwk5r = parcelRequire("hwk5r");

parcelRequire("kGaEh");
var $lWVgZ = parcelRequire("lWVgZ");
var $kGaEh = parcelRequire("kGaEh");


var $2HGN8 = parcelRequire("2HGN8");


var $c4PY4 = parcelRequire("c4PY4");


var $e8Lxy = parcelRequire("e8Lxy");


var $hMRhJ = parcelRequire("hMRhJ");


var $gKaeO = parcelRequire("gKaeO");


var $fE1Ao = parcelRequire("fE1Ao");


var $a1uFh = parcelRequire("a1uFh");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");

/* ApprovalInProgressEditorBlocker.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $laFNM = parcelRequire("laFNM");


var $6zK0v = parcelRequire("6zK0v");

const $79befcd2c8d3c320$var$i18n = (0, $aXWIB.defineMessages)({
    approvalInProgressBannerPrefix: {
        id: "approvals.editor.approval-in-progress.banner.prefix",
        defaultMessage: "Reminder: editing is locked while an approval is pending."
    },
    approvalInProgressCancelCta: {
        id: "approvals.editor.approval-in-progress.banner.cancel-cta",
        defaultMessage: "Cancel approval"
    },
    approvedBannerPrefix: {
        id: "approvals.editor.approved.banner.prefix",
        defaultMessage: "Reminder: You cannot edit an approved page without clearing the approval."
    },
    approvedClearCta: {
        id: "approvals.editor.approved.banner.clear-cta",
        defaultMessage: "Clear approval"
    }
});
const $79befcd2c8d3c320$var$styles = {
    banner: "_1rjc1b66 _18zrv47k _4t3i1ylp _bfhkhfxm"
}; /**
    * When approval is in progress (isDraftLockedForEditing), shows a banner explaining that editing
    * is not allowed. Renders nothing when there is no approval in progress or when changes are
    * requested (DENIED status) — in that case editing is permitted.
    *
    * - PENDING: "Reminder: editing is locked while an approval is pending. Cancel approval"
    * - APPROVED: "Reminder: You cannot edit an approved page without clearing the approval. Clear approval."
    * - DENIED / no lock: renders nothing
    */ 
const $79befcd2c8d3c320$export$8626b7a3aacc0076 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isDraftLockedForEditing: isDraftLockedForEditing, approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const { cancelWorkflowApplication: cancelWorkflowApplication } = (0, $laFNM.useApprovalsDispatch)();
    if (!isDraftLockedForEditing) return null;
    const handleCancelWorkflowApplication = ()=>{
        cancelWorkflowApplication();
    };
    const reviewStatus = approvalRequest?.review?.reviewStatus;
    if (reviewStatus === 'APPROVED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $79befcd2c8d3c320$var$styles.banner,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($79befcd2c8d3c320$var$i18n.approvedBannerPrefix), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zK0v.PressableLink), {
        onClick: handleCancelWorkflowApplication
    }, formatMessage($79befcd2c8d3c320$var$i18n.approvedClearCta))));
    // reviewStatus === 'PENDING' (the only remaining locked state)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $79befcd2c8d3c320$var$styles.banner,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($79befcd2c8d3c320$var$i18n.approvalInProgressBannerPrefix), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zK0v.PressableLink), {
        onClick: handleCancelWorkflowApplication
    }, formatMessage($79befcd2c8d3c320$var$i18n.approvalInProgressCancelCta))));
};









var $lEVfb = parcelRequire("lEVfb");





var $3wSkK = parcelRequire("3wSkK");

/* EditorConnectionBannerOfflineMode.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $b3YrF = parcelRequire("b3YrF");





var $bQ6eU = parcelRequire("bQ6eU");


var $fVUfS = parcelRequire("fVUfS");





var $aJv6Q = parcelRequire("aJv6Q");


var $bT0se = parcelRequire("bT0se");


var $g01A4 = parcelRequire("g01A4");











var $18HQ4 = parcelRequire("18HQ4");

/* CreateOfflineCopy.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove entire file when platform_editor_offline_editing_web_ga_fixes is cleaned up
// This component is only used in the old conflict message (with saveCopy parameter)




var $T1bCI = parcelRequire("T1bCI");











var $h9yJL = parcelRequire("h9yJL");








var $7xVCs = parcelRequire("7xVCs");




const $129ea4f2daae19f3$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.error-flag.title",
        defaultMessage: "We failed to create a copy"
    },
    errorFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.error-flag.description",
        defaultMessage: "Check your network connection or try again."
    },
    copyCreatedFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.title",
        defaultMessage: "Copy created"
    },
    copyCreatedFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.description",
        defaultMessage: "We copied your offline edits into a new page. All changes were saved."
    },
    copyCreatedFlagViewPage: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.view-page-link",
        defaultMessage: "View page"
    },
    createCopyFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.title",
        defaultMessage: "Issue syncing offline edits"
    },
    createCopyFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.description",
        defaultMessage: "We found conflicting edits when syncing to the cloud. View merged edits here or create a copy of your offline changes."
    },
    createCopyFlagCreateAction: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.create-action",
        defaultMessage: "Create copy"
    },
    createCopyFlagNoAction: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.no-action",
        defaultMessage: "I don\u2019t need a copy"
    }
});



var $f7B1p = parcelRequire("f7B1p");

const $0045511f0064ab73$export$eea1b38e4aaafc7d = (spaceId, contentId, adf, isLivePage = false)=>{
    return (0, $f7B1p.cfetch)('/wiki/api/v2/pages', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            spaceId: spaceId,
            parentId: contentId,
            status: 'draft',
            body: {
                representation: 'atlas_doc_format',
                value: JSON.stringify(adf)
            },
            ...isLivePage && {
                subtype: 'live'
            }
        })
    });
};


const $f917592567f31a69$var$styles = {
    saveCopyLink: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c8wadc _4bfu1r31 _1hms8stv _ajmmnqa1 _bfhk1j28 _k48pwu06 _syaz1rpy _irr319yr",
    saveCopyLinkA11y: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c8wadc _4bfu1r31 _1hms8stv _ajmmnqa1 _bfhk1j28 _k48pwu06 _syazazsu _irr319yr"
};
const $f917592567f31a69$export$3e0f67bf0e97b95a = (0, $7aRa9.withFlags)(({ flags: flags, chunks: chunks, api: api, contentId: contentId, spaceId: spaceId, setIsLoading: setIsLoading, isLivePage: isLivePage = false })=>{
    const isCreatingPage = (0, $42omo.useRef)(false);
    const offlineDoc = (0, $b3YrF.useSharedPluginStateSelector)(api, 'collabEdit.lastReconnectionConflictMetadata')?.offlineDoc;
    const [shouldUpdatePageTree, setShouldUpdatePageTree] = (0, $42omo.useState)(false);
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        testId: "offline-conflict-create-page-copy",
        onClick: async ()=>{
            if (isCreatingPage.current || !offlineDoc || !spaceId) return;
            isCreatingPage.current = true;
            setIsLoading(true);
            try {
                const response = await (0, $0045511f0064ab73$export$eea1b38e4aaafc7d)(spaceId, contentId, new (0, $h9yJL.JSONTransformer)().encode(offlineDoc), isLivePage);
                if (!response.ok) {
                    flags.showFlag($f917592567f31a69$var$createErrorFlag(intl));
                    return;
                }
                setShouldUpdatePageTree(true);
                flags.hideFlag('editor_reconnection_conflict');
                const data = await response.json();
                flags.showFlag($f917592567f31a69$var$createCopySuccessFlag(`${data._links.base}${data._links.edituiv2}`, intl));
            } catch  {
                flags.showFlag($f917592567f31a69$var$createErrorFlag(intl));
            } finally{
                isCreatingPage.current = false;
                setIsLoading(false);
            }
        },
        xcss: (0, $9wGTI.fg)('platform_editor_offline_banner_color_contrast_a11y') ? $f917592567f31a69$var$styles.saveCopyLinkA11y : $f917592567f31a69$var$styles.saveCopyLink
    }, chunks), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageStateUpdater)=>{
        // Make sure we only push the update once
        if (shouldUpdatePageTree && contentId) {
            // Requests that we fetch the page tree with the newly restored page.
            pageStateUpdater.setForceFetchPageId(contentId);
            setShouldUpdatePageTree(false);
        }
        return null;
    }));
});
const $f917592567f31a69$var$createErrorFlag = (intl)=>({
        id: 'editor-reconnection-conflict-copy-failed',
        type: 'error',
        title: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).errorFlagTitle),
        description: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).errorFlagDescription),
        close: 'auto'
    });
const $f917592567f31a69$var$createCopySuccessFlag = (href, intl)=>({
        id: 'editor-reconnection-conflict-copy-created',
        type: 'success',
        title: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagTitle),
        description: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagDescription),
        close: 'auto',
        actions: [
            {
                content: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagViewPage),
                href: href
            }
        ]
    });



var $kVuKK = parcelRequire("kVuKK");




function $8f9742f0ad2c6b9c$export$22acf644c7b26688(initialValue, risingEdgeDelay, fallingEdgeDelay) {
    const [value, setValue] = (0, $42omo.useState)(initialValue);
    const risingEdgeTimeout = (0, $42omo.useRef)(null);
    const fallingEdgeTimeout = (0, $42omo.useRef)(null);
    const updateValue = (0, $42omo.useCallback)((newValue)=>{
        if (newValue === true) {
            // Clear any pending falling edge timeout
            if (fallingEdgeTimeout.current !== null) {
                clearTimeout(fallingEdgeTimeout.current);
                fallingEdgeTimeout.current = null;
            }
            // If there is a rising edge pending already, or the value is already true, do nothing
            if (risingEdgeTimeout.current !== null || value === true) return;
            // If there is no delay, update the value immediately
            if (risingEdgeDelay === 0) setValue(true);
            else // Otherwise set a new rising edge timeout
            risingEdgeTimeout.current = window.setTimeout(()=>{
                risingEdgeTimeout.current = null;
                setValue(true);
            }, risingEdgeDelay);
        } else {
            // Clear any pending rising edge timeout
            if (risingEdgeTimeout.current !== null) {
                clearTimeout(risingEdgeTimeout.current);
                risingEdgeTimeout.current = null;
            }
            // If there is a falling edge pending already, or the value is already false, do nothing
            if (fallingEdgeTimeout.current !== null || value === false) return;
            // If there is no delay, update the value immediately
            if (fallingEdgeDelay === 0) setValue(false);
            else // Otherwise set a new falling edge timeout
            fallingEdgeTimeout.current = window.setTimeout(()=>{
                fallingEdgeTimeout.current = null;
                setValue(false);
            }, fallingEdgeDelay);
        }
    }, [
        fallingEdgeDelay,
        risingEdgeDelay,
        value
    ]);
    return [
        value,
        updateValue
    ];
}
function $8f9742f0ad2c6b9c$export$c40112cb03d4ce32(value, risingEdgeDelay, fallingEdgeDelay) {
    const [delayedValue, setDelayedValue] = $8f9742f0ad2c6b9c$export$22acf644c7b26688(value, risingEdgeDelay, fallingEdgeDelay);
    (0, $42omo.useEffect)(()=>{
        setDelayedValue(value);
    }, [
        value,
        setDelayedValue
    ]);
    return delayedValue;
}


const $ceee0e5a959b634f$var$AnimatedEllipsis = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.EllipsisContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18HQ4.AnimatedDot), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$export$884d2f68355ca9c8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v564gu18 _1e0c11p5 _kqswstnw _1bsb1osq _1bah1h6o _4cvr1h6o _y3gn1h6o _1ltvze3t _ca0q12x7 _n3td12x7 _bfhkysee _8hrzjp4b _1pby1nn1",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154i1ady",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_19111ady",
            __cmplp.className
        ])
    });
});
const $ceee0e5a959b634f$export$31ea92f3997410dd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _ect41kw7 _k48pwu06 _syaz1rpy _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$var$FadingSpanInternal = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _v564ayzn _nd5l1ekt _1e0c1txw _4cvr1h6o _1bah1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $ceee0e5a959b634f$var$backgroundColor = {
    online: "_v564glyw _bfhk1y9u _t9ecp8ia",
    offline: "_bfhkysee",
    conflicts: "_bfhkysee"
};
const $ceee0e5a959b634f$var$styles = {
    conflictLink: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c8wadc _bfhk1j28 _k48pwu06 _syaz1rpy _1doce4h9 _1o3i1b2s _1il9gq9o _irr319yr",
    conflictLinkA11y: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c8wadc _bfhk1j28 _k48pwu06 _syazazsu _1doce4h9 _1o3i1b2s _1il9gq9o _irr319yr",
    placeholder: "_1bsbdlk8"
};
const $ceee0e5a959b634f$var$isMessageDescriptor = (msg)=>{
    return !!msg && typeof msg === 'object' && msg.id !== undefined && msg.defaultMessage !== undefined;
}; /**
    * Custom hook to manage the state of banner variants and provide a consistent interface for their usage.
    * @param variant - The variant definition to use. This should ideally be a constant defined outside of the component to prevent re-renders.
    * @param props - The props to pass to the variant condition function. This should be treated as a dependency array, and values should be kept in the same order.
    * @returns The current state of the banner variant.
    *
    * @privateRemarks
    *
    * Within this hook, the react-hooks/exhaustive-deps rule is disabled in a few places.
    * This is because we track the dependencies provided by the props argument as their values instead of the overall reference.
    * This is done to prevent the need to memoize the props object without causing unnecessary re-renders.
    * By directly depending on the values in this array, we can ensure that the hook will only re-run when the values change, not the array itself.
    *
    * This does however have the caveat that we lose static analysis of the dependencies, so extra care should be taken when working in this function.
    */ 
function $ceee0e5a959b634f$export$dd92d6ba26bc2ad5(variant, props, triggerAnalyticsEvent) {
    const { condition: conditionFn, onConditionChange: onConditionChange, onVisibilityChange: onVisibilityChange, message: message } = variant;
    const [condition, setCondition] = (0, $42omo.useState)(conditionFn(...props));
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const lastConditionChange = (0, $42omo.useRef)(performance.now());
    const lastVisibilityChange = (0, $42omo.useRef)(performance.now());
    const fireConditionChange = (0, $42omo.useCallback)((newConditionValue)=>{
        if (onConditionChange) {
            const timing = {
                startTime: lastConditionChange.current,
                endTime: performance.now(),
                duration: performance.now() - lastConditionChange.current
            };
            lastConditionChange.current = performance.now();
            onConditionChange(newConditionValue, timing, triggerAnalyticsEvent, ...props);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        onConditionChange,
        triggerAnalyticsEvent,
        ...props
    ]);
    (0, $42omo.useEffect)(()=>{
        const newConditionValue = conditionFn(...props);
        if (condition !== newConditionValue) {
            setCondition(newConditionValue);
            fireConditionChange(newConditionValue);
        } // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    }, [
        conditionFn,
        onConditionChange,
        condition,
        triggerAnalyticsEvent,
        ...props
    ]); // Fire condition change event on the first render to maintain consistency with previous behaviour for analytics
    const hasExecutedFirstRender = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasExecutedFirstRender.current) {
            hasExecutedFirstRender.current = true;
            fireConditionChange(condition);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        fireConditionChange,
        condition
    ]);
    const wrappedOnVisibilityChange = (0, $42omo.useCallback)((visibilityValue)=>{
        if (onVisibilityChange) {
            const timing = {
                startTime: lastVisibilityChange.current,
                endTime: performance.now(),
                duration: performance.now() - lastVisibilityChange.current
            };
            lastVisibilityChange.current = performance.now();
            onVisibilityChange(visibilityValue, timing, triggerAnalyticsEvent, ...props);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        onVisibilityChange,
        triggerAnalyticsEvent,
        ...props
    ]);
    const messageValue = (0, $42omo.useMemo)(()=>{
        if (typeof message === 'function') return message(...props);
        else if ($ceee0e5a959b634f$var$isMessageDescriptor(message)) return formatMessage(message);
        return null; // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    }, [
        message,
        ...props
    ]);
    return {
        id: variant.id,
        condition: condition,
        message: messageValue,
        wrapperStyleKey: variant.wrapperStyleKey,
        onVisibilityChange: wrappedOnVisibilityChange
    };
}
const $ceee0e5a959b634f$export$6484431ecffbb42d = {
    id: 'back-online-banner',
    condition: (isBackOnline)=>isBackOnline,
    message: (0, $kVuKK.i18n).editorEnabledOfflineMode,
    wrapperStyleKey: 'online'
};
const $ceee0e5a959b634f$export$fdc43f78fadf92e6 = {
    id: 'offline-disabled-banner',
    condition: (isOfflineStorageUnavailable)=>isOfflineStorageUnavailable,
    message: (0, $kVuKK.i18n).editorDisabled,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$export$e3d57ca72010d8b5 = {
    id: 'offline-banner',
    condition: (isOffline)=>isOffline,
    message: (0, $kVuKK.i18n).editorDisabledOfflineMode,
    wrapperStyleKey: 'offline',
    onConditionChange: (newCondition, _timing, triggerAnalyticsEvent, _isOffline, offlineData, editorType, restrictionUpdate)=>{
        if (newCondition) {
            // Save browser network status and document visibility state when the user goes offline
            offlineData.current.browserNetworkStatus = navigator.onLine;
            offlineData.current.documentVisibilityState = document.visibilityState; // Fire analytics event when the offline banner is now active (though it may not be visible yet)
            triggerAnalyticsEvent('offline.banner.show.indicator', {
                editorType: editorType,
                restrictionUpdate: restrictionUpdate
            });
        }
    },
    onVisibilityChange: (isVisible, timing, triggerAnalyticsEvent, _isOffline, onlineData, editorType, _restrictionUpdate)=>{
        if (!isVisible) // Fire analytics event when the offline banner has been displayed
        triggerAnalyticsEvent('offline.banner.displayed', {
            browserNetworkStatus: onlineData.current.browserNetworkStatus,
            editorType: editorType,
            documentVisibilityState: onlineData.current.documentVisibilityState,
            duration: timing.duration
        });
    }
};
const $ceee0e5a959b634f$export$5b93469ec56d27bf = {
    id: 'connection-timeout-banner',
    condition: (connectionTimedOut)=>connectionTimedOut,
    message: (0, $kVuKK.i18n).collabEditConnectionTimeout,
    wrapperStyleKey: 'offline',
    onConditionChange: (newCondition, _timing, triggerAnalyticsEvent, _connectionTimedOut, offlineData, { contentId: contentId, contentType: contentType })=>{
        if (newCondition) {
            // Save browser network status and document visibility state when the user goes offline
            offlineData.current.browserNetworkStatus = navigator.onLine;
            offlineData.current.documentVisibilityState = document.visibilityState; // Fire analytics event when the connection timeout banner is now active (though it may not be visible yet)
            triggerAnalyticsEvent('collab.edit.connection.timeout.show.indicator', {
                contentId: contentId,
                contentType: contentType
            });
        }
    },
    onVisibilityChange: (isVisible, timing, triggerAnalyticsEvent, _connectionTimedOut, offlineData, { editorType: editorType })=>{
        if (!isVisible) // Fire analytics event when the connection timeout banner has been displayed
        triggerAnalyticsEvent('connection.timeout.banner.displayed', {
            browserNetworkStatus: offlineData.current.browserNetworkStatus,
            editorType: editorType,
            documentVisibilityState: offlineData.current.documentVisibilityState,
            duration: timing.duration
        });
    }
};
const $ceee0e5a959b634f$export$865dd254943cb7d0 = {
    id: 'restriction-update-banner',
    condition: (restrictionUpdate, willEditorDisable)=>restrictionUpdate && willEditorDisable,
    message: (0, $kVuKK.i18n).editorDisabledDueToPermissionChange,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$export$d8b1b94ede519079 = {
    id: 'conflict-banner',
    condition: (conflicts)=>conflicts !== undefined && (conflicts.deleted.length > 0 || conflicts.inserted.length > 0),
    wrapperStyleKey: 'conflicts',
    message: (conflicts, formatMessage, fullPageEditorPresetAPI, contentId, spaceId, setIsLoading, isLivePage)=>{
        const messageKey = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? (0, $kVuKK.i18n).editorSyncFailedDueToConflictsUpdated : (0, $kVuKK.i18n).editorSyncFailedDueToConflicts;
        const conflictCount = conflicts !== undefined ? conflicts.deleted.length + conflicts.inserted.length : 0;
        let saveCopy;
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) saveCopy = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f917592567f31a69$export$3e0f67bf0e97b95a), {
                api: fullPageEditorPresetAPI,
                chunks: chunks,
                contentId: contentId,
                spaceId: spaceId,
                setIsLoading: setIsLoading,
                isLivePage: isLivePage
            });
        return formatMessage(messageKey, {
            conflictIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bQ6eU))), {
                label: "",
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }),
            conflictLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                    onClick: ()=>{
                        if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) fullPageEditorPresetAPI?.core?.actions.execute(fullPageEditorPresetAPI?.conflictResolutionUI?.commands.startResolvingConflicts);
                        else fullPageEditorPresetAPI?.core?.actions.execute(fullPageEditorPresetAPI?.conflictResolutionUI?.commands.navigateToFirstConflict);
                    },
                    xcss: (0, $9wGTI.fg)('platform_editor_offline_banner_color_contrast_a11y') ? $ceee0e5a959b634f$var$styles.conflictLinkA11y : $ceee0e5a959b634f$var$styles.conflictLink,
                    testId: "offline-conflict-navigate-to-first-conflict"
                }, chunks),
            saveCopy: saveCopy,
            conflictCount: conflictCount
        });
    }
};
const $ceee0e5a959b634f$export$989f13cb92705548 = {
    id: 'resyncing-editor-disabled-banner',
    condition: (resyncingEditorDisabled)=>resyncingEditorDisabled,
    message: (0, $kVuKK.i18n).resyncingEditorDisabled,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$var$EditorConnectionBannerComponent = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})((0, $aXWIB.injectIntl)(({ editorType: editorType, contentType: contentType, contentId: contentId, spaceId: spaceId, triggerAnalyticsEvent: triggerAnalyticsEvent, collabEditState: collabEditState, willEditorDisable: willEditorDisable = false, fullPageEditorPresetAPI: fullPageEditorPresetAPI, intl: { formatMessage: formatMessage }, isLivePage: isLivePage, isEditorToolbarHidden: isEditorToolbarHidden })=>{
    const [isFirstRender, setIsFirstRender] = (0, $42omo.useState)(true); // Timeout values for showing and hiding the banners
    const SHOW_TIMEOUT = 3000;
    const HIDE_TIMEOUT = 3000; // Track conflict state
    const conflicts = (0, $b3YrF.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'conflictResolutionUI.conflicts');
    const isOfflineStorageDisabled = Boolean((0, $b3YrF.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'editorOfflineStorage.disabled'));
    const offlineStorageIsInactiveSyncing = (0, $b3YrF.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'editorOfflineStorage.inactiveSyncing') ?? false;
    const connectivityMode = (0, $b3YrF.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'connectivity.mode');
    const internetLost = connectivityMode !== undefined && (0, $91bcx.isOfflineMode)(connectivityMode); // Track if the user is online
    const hasInternet = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? true : !(internetLost && willEditorDisable), SHOW_TIMEOUT, HIDE_TIMEOUT);
    const connectionTimedOut = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? false : collabEditState.collabEditConnectionTimedOut && willEditorDisable, SHOW_TIMEOUT, HIDE_TIMEOUT);
    const isOfflineStorageUnavailable = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? false : isOfflineStorageDisabled && !willEditorDisable && internetLost, 0, 0);
    const isOnline = !isOfflineStorageDisabled ? hasInternet && !connectionTimedOut : !internetLost && !connectionTimedOut; // Track when the user goes back online
    const [isBackOnline, setIsBackOnline] = (0, $42omo.useState)(false);
    const lastOnlineState = (0, $42omo.useRef)(isOnline);
    const backOnlineBannerTimeout = (0, $42omo.useRef)(null);
    const SHOW_BACK_ONLINE_TIMEOUT = 3000; // Show the back online banner for 3 seconds
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false); // Track restriction updates (permission changes)
    const [restrictionUpdate, setRestrictionUpdate] = (0, $8f9742f0ad2c6b9c$export$22acf644c7b26688)(false, 0, // Restriction updates should be shown immediately
    HIDE_TIMEOUT);
    const onRestrictionUpdatedEvent = (0, $42omo.useCallback)(()=>{
        triggerAnalyticsEvent('offline.banner.restriction.updated', {
            editorType: editorType,
            restrictionUpdate: restrictionUpdate
        });
        if (editorType === 'classic') setRestrictionUpdate(true);
    }, [
        editorType,
        restrictionUpdate,
        setRestrictionUpdate,
        triggerAnalyticsEvent
    ]);
    const onRestrictionUpdatedPubSubEvent = (0, $42omo.useCallback)(()=>{
        if (![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '')) || !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false)) onRestrictionUpdatedEvent();
    }, [
        onRestrictionUpdatedEvent
    ]); // Listen for restriction update events (permission changes)
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId,
        contentType: contentType,
        eventName: `restrictionUpdated:${contentType}`,
        onEvent: onRestrictionUpdatedPubSubEvent,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    (0, $g01A4.useContentRestrictionSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        callback: onRestrictionUpdatedEvent,
        subscriberId: 'EditorConnectionBannerOfflineModeSubscription'
    }); // Reset restriction update when editor reconnects so the default message is shown next time the editor goes offline
    (0, $42omo.useEffect)(()=>{
        if (!willEditorDisable) setRestrictionUpdate(false);
    }, [
        setRestrictionUpdate,
        willEditorDisable
    ]);
    (0, $42omo.useEffect)(()=>{
        // If the user has gone back online after being offline, show the banner for a short time
        if (!lastOnlineState.current && isOnline) {
            setIsBackOnline(true); // Clear any existing timeout to avoid hiding the banner too early
            if (backOnlineBannerTimeout.current) clearTimeout(backOnlineBannerTimeout.current);
            backOnlineBannerTimeout.current = window.setTimeout(()=>{
                setIsBackOnline(false);
                backOnlineBannerTimeout.current = null;
            }, SHOW_BACK_ONLINE_TIMEOUT);
        } else if (lastOnlineState.current && !isOnline) {
            setIsBackOnline(false); // Strictly speaking this isn't necessary, the callback now has no effect, but I figure it's good to clean the timeout up anyway
            if (backOnlineBannerTimeout.current) clearTimeout(backOnlineBannerTimeout.current);
        }
        lastOnlineState.current = isOnline;
    }, [
        isOnline,
        setIsBackOnline
    ]); // Create the banner variant states and manage their visibility
    const backOnlineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$6484431ecffbb42d, [
        isBackOnline
    ], triggerAnalyticsEvent);
    const offlineData = (0, $42omo.useRef)({
        browserNetworkStatus: true,
        documentVisibilityState: ''
    });
    const offlineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$e3d57ca72010d8b5, [
        !hasInternet,
        offlineData,
        editorType,
        restrictionUpdate
    ], triggerAnalyticsEvent); // Use a memoized editor info object to avoid unnecessary re-renders
    const editorInfo = (0, $42omo.useMemo)(()=>({
            contentId: contentId,
            contentType: contentType,
            editorType: editorType
        }), [
        contentId,
        contentType,
        editorType
    ]);
    const connectionTimeoutBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$5b93469ec56d27bf, [
        connectionTimedOut,
        offlineData,
        editorInfo
    ], triggerAnalyticsEvent);
    const restrictionUpdateBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$865dd254943cb7d0, [
        restrictionUpdate,
        willEditorDisable
    ], triggerAnalyticsEvent);
    const disabledOfflineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$fdc43f78fadf92e6, [
        isOfflineStorageUnavailable
    ], triggerAnalyticsEvent);
    const conflictBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$d8b1b94ede519079, [
        conflicts,
        formatMessage,
        fullPageEditorPresetAPI,
        contentId,
        spaceId,
        setIsLoading,
        isLivePage
    ], triggerAnalyticsEvent);
    const resyncingEditorDisabledBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$989f13cb92705548, [
        offlineStorageIsInactiveSyncing
    ], triggerAnalyticsEvent); // Banner list is ordered by priority, so the first valid banner will be shown
    const banners = [
        conflictBanner,
        disabledOfflineBanner,
        resyncingEditorDisabledBanner,
        backOnlineBanner,
        restrictionUpdateBanner,
        offlineBanner,
        connectionTimeoutBanner
    ]; // Track the most recent banner to detect changes in visibility (separately from tracking if each banner's condition has changed)
    const lastBanner = (0, $42omo.useRef)(undefined);
    const currentBanner = banners.find((banner)=>banner.condition);
    if (currentBanner?.id !== lastBanner.current) {
        // Fire a visibility change event for the banner that was previously visible
        if (lastBanner.current !== undefined) {
            // We can assume that the last ID is in the list of banners, as the banner list is constant, so we'll mark the result type as non-null
            const lastBannerInstance = banners.find((banner)=>banner.id === lastBanner.current);
            if (lastBannerInstance.onVisibilityChange !== undefined) lastBannerInstance.onVisibilityChange(false);
        } // Fire a visibility change event for the banner that is now visible (if any)
        if (currentBanner?.onVisibilityChange !== undefined) currentBanner.onVisibilityChange(true);
        lastBanner.current = currentBanner?.id;
    }
    (0, $42omo.useEffect)(()=>{
        if (isFirstRender) setIsFirstRender(false);
    }, [
        isFirstRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$export$26d1be1a3667a472, {
        isLoading: isLoading,
        currentBanner: currentBanner,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
}));
const $ceee0e5a959b634f$export$26d1be1a3667a472 = ({ currentBanner: currentBanner, isLoading: isLoading, isEditorToolbarHidden: isEditorToolbarHidden })=>{
    // Get the message to display in the banner (if any) and format it if necessary
    const CurrentMessage = (0, $42omo.useMemo)(()=>currentBanner?.message, [
        currentBanner
    ]);
    const LoadingIndicator = (0, $42omo.useMemo)(()=>{
        if (currentBanner?.wrapperStyleKey !== 'conflicts') return null;
         // Show loading ellipsis for conflicts only for now
        // Show a placeholder when not loading to avoid layout shift
        return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$var$AnimatedEllipsis, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: (0, $gMc0m.default)([
                $ceee0e5a959b634f$var$styles.placeholder
            ])
        });
    }, [
        isLoading,
        currentBanner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$export$884d2f68355ca9c8, {
        "data-testid": "status-indicator",
        show: currentBanner !== undefined,
        toolbarHidden: isEditorToolbarHidden,
        className: (0, $gMc0m.default)([
            currentBanner?.wrapperStyleKey === 'online' && $ceee0e5a959b634f$var$backgroundColor['online'],
            currentBanner?.wrapperStyleKey === 'offline' && $ceee0e5a959b634f$var$backgroundColor['offline'],
            currentBanner?.wrapperStyleKey === 'conflicts' && $ceee0e5a959b634f$var$backgroundColor['conflicts']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$export$bb5d4b172e6970cd, {
        "data-testid": "status-indicator-text",
        role: "alert",
        show: currentBanner !== undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceee0e5a959b634f$export$31ea92f3997410dd, {
        "data-testid": "status-text"
    }, CurrentMessage), LoadingIndicator));
};
const $ceee0e5a959b634f$export$2d7f5da98593df5c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($ceee0e5a959b634f$var$EditorConnectionBannerComponent);


const $5b566a57f88868ac$export$6d9f0d80d291faa5 = ({ triggerAnalyticsEvent: triggerAnalyticsEvent, collabEditInternetLost: collabEditInternetLost, collabEditConnectionTimedOut: collabEditConnectionTimedOut, willEditorDisable: willEditorDisable, contentType: contentType, contentId: contentId, spaceId: spaceId, fullPageEditorPresetAPI: fullPageEditorPresetAPI, collabEditState: collabEditState, isDesktop: isDesktop, isLivePage: isLivePage, isViewMode: isViewMode })=>{
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)({
        defaultDockedAtTop: !isLivePage
    });
    const isEditorToolbarHidden = isViewMode || !isEditorToolbarDockedAtTop;
    if (isDesktop || (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ceee0e5a959b634f$export$2d7f5da98593df5c), {
        editorType: "next",
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        collabEditState: collabEditState,
        willEditorDisable: willEditorDisable,
        contentType: contentType,
        contentId: contentId,
        spaceId: spaceId,
        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wSkK.EditorConnectionBanner), {
        editorType: "next",
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        collabEditInternetLost: collabEditInternetLost,
        collabEditConnectionTimedOut: collabEditConnectionTimedOut,
        willEditorDisable: willEditorDisable,
        contentType: contentType,
        contentId: contentId,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
};



var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");





var $6LguK = parcelRequire("6LguK");


var $e6u60 = parcelRequire("e6u60");

const $6eee7623ad82c8da$export$386b0ae74d3f86a0 = (triggerAnalyticsEvent)=>{
    // log time of keypress
    const now = performance?.now();
    // grab the array of fmp & tti metrics
    const fmpMetrics = performance?.getEntriesByName('browser-metric:fmp');
    const ttiMetrics = performance?.getEntriesByName('browser-metric:tti');
    // grab the most recently added fmp & tti metrics
    const fmpEnd = fmpMetrics[fmpMetrics.length - 1]?.startTime + fmpMetrics[fmpMetrics.length - 1]?.duration;
    const ttiEnd = ttiMetrics[ttiMetrics.length - 1]?.startTime + ttiMetrics[ttiMetrics.length - 1]?.duration;
    // if now (keypress time), fmp, and tti all exist, fire the measure time to edit analytics event
    if (now && fmpEnd && ttiEnd) triggerAnalyticsEvent('measure.time.to.edit', {
        keypressTime: now,
        fmpTimeToEdit: now - fmpEnd,
        ttiTimeToEdit: now - ttiEnd,
        fmpEnd: fmpEnd,
        ttiEnd: ttiEnd
    });
};






var $gkIgp = parcelRequire("gkIgp");


var $S6mif = parcelRequire("S6mif");


var $kXAjP = parcelRequire("kXAjP");
var $39X8O = parcelRequire("39X8O");


var $6dTPw = parcelRequire("6dTPw");





var $jmjWc = parcelRequire("jmjWc");


const $5fed17fe09649c6f$export$be5a95ae7f8387c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "k58TW",
    name: "MarketplaceAppsContainer",
    loader: async ()=>(await (parcelRequire("kQMK8"))).MarketplaceAppsContainer
});


const $f9a65503f42ecec3$export$bc75c05af9bceb4a = ({ searchTerm: searchTerm, mode: mode })=>{
    if (!searchTerm) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5fed17fe09649c6f$export$be5a95ae7f8387c0), {
        searchTerm: searchTerm,
        mode: mode
    });
};



var $4ri4I = parcelRequire("4ri4I");





const $11b8024921ea2f1a$export$a1cd66d9f8e156b1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gzpgy",
    name: "ConditionalPublish",
    loader: async ()=>(await (parcelRequire("c0BUW"))).ConditionalPublish
});



var $9sGCn = parcelRequire("9sGCn");





var $cmBjr = parcelRequire("cmBjr");


var $kXsBa = parcelRequire("kXsBa");


var $1B6Lx = parcelRequire("1B6Lx");


var $14ugT = parcelRequire("14ugT");


var $3o3i5 = parcelRequire("3o3i5");


var $kSPGK = parcelRequire("kSPGK");








var $bAIqi = parcelRequire("bAIqi");





const $ee7c889194e6f932$export$c43bb192f22b2458 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8Gtxn",
    name: "LazyEditorContextCustomSitesConfigPanel",
    loader: async ()=>(await (parcelRequire("3y90h"))).EditorContextCustomSitesConfigPanel
});


const $f04c510354797dd3$export$7a4297a73e39e6ad = /*#__PURE__*/ (0, $42omo.memo)(({ localId: localId, closeSelf: closeSelf, editorApi: editorApi, contentId: contentId, upsellModalSource: upsellModalSource, setUpsellModalSource: setUpsellModalSource })=>{
    if (upsellModalSource) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bAIqi.ExtensionInsertUpsellLoader), {
        setUpsellModalSource: setUpsellModalSource,
        feature: upsellModalSource
    });
    if (localId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee7c889194e6f932$export$c43bb192f22b2458), {
        localId: localId,
        closeSelf: closeSelf,
        editorApi: editorApi,
        contentId: contentId
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));





var $ks2lK = parcelRequire("ks2lK");





var $kcoxM = parcelRequire("kcoxM");


var $5Ac5G = parcelRequire("5Ac5G");


var $4cOi8 = parcelRequire("4cOi8");

var $cNwLI = parcelRequire("cNwLI");


var $lf1vG = parcelRequire("lf1vG");


var $cVaAA = parcelRequire("cVaAA");


var $bl1ay = parcelRequire("bl1ay");

const $b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS = [
    (0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE),
    (0, $5Ac5G.carouselExtensionType),
    (0, $kcoxM.CARDS_EXTENSION_TYPE),
    (0, $cVaAA.LINKS_MENU_EXTENSION_TYPE),
    (0, $cNwLI.SECTION_EXTENSION_TYPE),
    (0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
    (0, $lf1vG.SEARCH_EXTENSION_TYPE)
];
const $b5ea4fb4260f4ec5$export$bdd538c0d43098c3 = (editorActions)=>{
    const [activeNodeLocalId, setActiveNodeLocalId] = (0, $42omo.useState)(null);
    // when upsellModalSource is undefined, we use it to close the upsell modal in ModalUpsellWrapper.
    const [upsellModalSource, setUpsellModalSource] = (0, $42omo.useState)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const openConfigPanel = (0, $42omo.useCallback)((localId)=>{
        if (!localId) return;
        const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
        const editorView = editorActions._privateGetEditorView();
        const selection = editorView?.state?.selection;
        if (selection instanceof (0, $ks2lK.NodeSelection)) {
            if ($b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS.includes(extensionType)) setActiveNodeLocalId(localId);
        } else {
            if (type !== 'multiBodiedExtension' || !editorView?.state) return;
            // Handle MultiBodiedExtension config panel
            let multiBodiedExtensionPosition = editorView.state.selection.from;
            editorView.state.tr.doc.descendants((node, pos)=>{
                if (node.attrs?.localId === localId) {
                    multiBodiedExtensionPosition = pos;
                    return;
                }
            });
            editorView.dispatch(editorView.state.tr?.setSelection?.((0, $ks2lK.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
            if ($b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS.includes(extensionType)) setActiveNodeLocalId(localId);
        }
        if (!!extensionKey && !!extensionType) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editExtension',
                source: `${extensionKey}ExtensionConfig`,
                attributes: {
                    extensionType: extensionType
                }
            }
        }).fire();
    }, [
        setActiveNodeLocalId,
        createAnalyticsEvent,
        editorActions
    ]);
    const closeConfigPanel = (0, $42omo.useCallback)(()=>{
        const selectedNode = editorActions.getSelectedNode()?.toJSON();
        if (activeNodeLocalId && selectedNode?.attrs?.localId === activeNodeLocalId && selectedNode?.attrs?.extensionType === (0, $kcoxM.CARDS_EXTENSION_TYPE)) {
            const parameters = selectedNode.attrs.parameters || {};
            if (parameters.renderVariant === (0, $4cOi8.RenderVariant).MANUAL) {
                delete parameters.filters;
                delete parameters.cardCount;
            }
            if (parameters.renderVariant === (0, $4cOi8.RenderVariant).DYNAMIC) parameters.cards = [];
            editorActions.replaceSelection({
                ...selectedNode,
                attrs: {
                    ...selectedNode.attrs,
                    parameters: {
                        ...parameters
                    }
                }
            }, true);
        }
        setActiveNodeLocalId(null);
    }, [
        activeNodeLocalId,
        editorActions,
        setActiveNodeLocalId
    ]);
    return (0, $42omo.useMemo)(()=>({
            activeNodeLocalId: activeNodeLocalId,
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel,
            upsellModalSource: upsellModalSource,
            setUpsellModalSource: setUpsellModalSource
        }), [
        activeNodeLocalId,
        openConfigPanel,
        closeConfigPanel,
        upsellModalSource,
        setUpsellModalSource
    ]);
};



var $cQhbe = parcelRequire("cQhbe");


var $sLZsl = parcelRequire("sLZsl");










const $6b433f129bb94645$var$PrimaryToolbarContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6b433f129bb94645$var$memoizeDeepEq = (0, $2XqLN.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
function $6b433f129bb94645$export$5acade271146d69c({ children: children, value: value }) {
    const memoizedValue = $6b433f129bb94645$var$memoizeDeepEq(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b433f129bb94645$var$PrimaryToolbarContext.Provider, {
        value: memoizedValue
    }, children);
}
function $6b433f129bb94645$export$87f05b83083ffee2() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($6b433f129bb94645$var$PrimaryToolbarContext);
    if (!context) throw new Error('usePrimaryToolbarContext must be used within a PrimaryToolbarContextProvider');
    return context;
}


/**
 * @generated SignedSource<<f436e4793e5f5d35389f65020f5b781d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab1e224d72963101$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "EditorPrimaryToolbarComponentsGetDraftParentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            }
        ],
        "type": "Content"
    };
}();
$ab1e224d72963101$var$node.hash = "8d1e74aac7d44af0e715791d1017e102";
var $ab1e224d72963101$export$2e2bcd8739ae039 = $ab1e224d72963101$var$node;









var $gabmL = parcelRequire("gabmL");





var $1Vx7O = parcelRequire("1Vx7O");


var $1ch0f = parcelRequire("1ch0f");


var $2unW6 = parcelRequire("2unW6");


var $6yCgm = parcelRequire("6yCgm");

parcelRequire("aYZaZ");
var $iQb1R = parcelRequire("iQb1R");
var $aYZaZ = parcelRequire("aYZaZ");





var $6tSjb = parcelRequire("6tSjb");


const $088b8a15e556cc8e$export$ad9980f718bbeeb6 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TEbaC",
    name: "LivePagesEllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("jwT8k"))).LivePagesEllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});





















var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");





var $jacyh = parcelRequire("jacyh");


var $5rEAe = parcelRequire("5rEAe");


var $3mmDo = parcelRequire("3mmDo");


var $lHzSp = parcelRequire("lHzSp");


var $atF9V = parcelRequire("atF9V");


var $fFmJj = parcelRequire("fFmJj");

const $02a52aafb1fafdd7$var$EditorPrimaryToolbarComponentsFunction = ({ forceDisabled: forceDisabled, userOffline: userOffline, collabLimitReached: collabLimitReached, contentId: contentId, contentType: contentType, isContentCreationPanelOpen: isContentCreationPanelOpen, isUnpublishedDraft: isUnpublishedDraft, onClickPublish: onClickPublish, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onPreviewClicked: onPreviewClicked, saveDraft: saveDraft, spaceKey: spaceKey, title: title, showRevertDialog: showRevertDialog, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isPublishingContent: isPublishingContent, editorActions: editorActions, isSingleUserSession: isSingleUserSession, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, shouldRenderPreview: shouldRenderPreview, shouldShowRecentSpotlight: shouldShowRecentSpotlight, flags: flags, viewMode: viewMode, pageTreeStateUpdater: pageTreeStateUpdater, hasEditPermission: hasEditPermission, ellipsisEditorActions: ellipsisEditorActions, allowInlineComments: allowInlineComments = true, allowPageComments: allowPageComments = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ab1e224d72963101$export$2e2bcd8739ae039)
    });
    const { emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState } = (0, $lHzSp.useEmojiTitleCoverPictureAndContentState)();
    const { hasRestrictionsSubscription: hasRestrictionsSubscription, hasRestrictions: hasRestrictions } = (0, $atF9V.useRestrictions)();
    const publicLinkData = (0, $gabmL.usePublicLinkPageDataProvider)({
        pageId: contentId,
        fetchPolicy: 'cache-and-network'
    });
    const hasLabels = (0, $2unW6.useLabels)(contentId);
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const shouldDisableActions = isPublishingContent || userOffline || !!forceDisabled;
    const areMainButtonsDisabled = shouldDisableActions || publicLinkData.isLoading;
    const isPublishDisabledForPublishModal = shouldDisableActions || Boolean(collabLimitReached);
    const hasTitle = Boolean(title);
    const hasBody = !editorActions.isDocumentEmpty();
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const willDeleteBlankDraftOnClose = (0, $3mmDo.useWillDeleteBlankDraftOnClose)({
        isUnpublishedDraft: isUnpublishedDraft,
        isSingleUserSession: isSingleUserSession,
        hasTitle: hasTitle,
        hasBody: hasBody,
        hasEmoji: hasEmoji,
        hasCoverPicture: hasCoverPicture,
        hasContentState: hasContentState,
        hasRestrictions: hasRestrictions,
        hasLabels: hasLabels
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    // Data is not used so we don't worry about errors here
    (0, $42omo.useEffect)(()=>{
        for (const error of publicLinkData.errors)(0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        publicLinkData.errors
    ]);
    const publishButtonDisabledReason = (0, $1Vx7O.getPublishButtonDisabledReason)({
        title: title,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        forceDisabled: forceDisabled
    });
    const onClose = async ()=>{
        if (contentType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.EDITOR_CLOSE_BUTTON_CLICK));
        if (shouldShowRecentSpotlight) setOnboardingState({
            key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN,
            value: 'true'
        });
        if (willDeleteBlankDraftOnClose) {
            triggerAnalyticsEvent('close', {
                discarded: true
            });
            (0, $1ch0f.deleteDraft)({
                contentId: contentId,
                deleteOnlyIfBlank: true
            }).then(async ({ data: data })=>{
                if (contentType === 'blogpost') // refreshes blog tree on discard close of blog draft
                forceRefetchBlogTree();
                triggerAnalyticsEvent('draftDiscarded', {
                    wasDeleted: !!data?.deleteContent?.wasDeleted
                });
                const parentId = await (0, $5rEAe.getParentOfDraft)(contentId, readFragmentInterop);
                if (parentId) pageTreeStateUpdater.setForceFetchPageId(parentId);
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'notFound',
                        actionSubject: 'discardedDraftParent',
                        objectType: contentType,
                        objectId: contentId
                    }
                }).fire();
            });
            navigateOnClose({
                isDiscarding: true
            });
        } else {
            triggerAnalyticsEvent('close');
            saveDraft({
                isOnClose: true
            }).then(()=>navigateOnClose());
        }
    };
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const allowedEllipsisButtons = !isCompanyHub ? [
        (0, $iQb1R.Buttons).PUBLISH_WITHOUT_NOTIFY,
        (0, $iQb1R.Buttons).DELETE_DRAFT,
        (0, $iQb1R.Buttons).EDIT_LABELS,
        (0, $iQb1R.Buttons).MOVE_PAGE,
        (0, $iQb1R.Buttons).PREVIEW,
        (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
        (0, $iQb1R.Buttons).TEMPLATE_BROWSER,
        (0, $iQb1R.Buttons).VIEW_CHANGES,
        (0, $iQb1R.Buttons).SWITCH_TO_LIVE_EDIT,
        (0, $iQb1R.Buttons).CLASSIFY_CONTENT
    ] : [
        (0, $iQb1R.Buttons).DELETE_DRAFT,
        (0, $iQb1R.Buttons).PREVIEW,
        (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
        (0, $iQb1R.Buttons).VIEW_CHANGES
    ];
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEmbedded = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showEllipsisDropdown = !isEmbedded;
    const ellipsisDropdownProps = {
        contentId: contentId,
        contentType: contentType,
        isDisabled: areMainButtonsDisabled || userOffline || collabLimitReached,
        isUnpublishedDraft: isUnpublishedDraft,
        isShowingLabelsDialog: false,
        onPreviewClicked: onPreviewClicked,
        onClickPublish: onClickPublish,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        saveDraft: saveDraft,
        tooltipDisabledState: publishButtonDisabledReason,
        spaceKey: spaceKey,
        isContentCreationPanelShown: isContentCreationPanelOpen,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        showRevertDialog: showRevertDialog,
        allowedEllipsisButtons: allowedEllipsisButtons,
        hasEditPermission: hasEditPermission,
        editorActions: ellipsisEditorActions
    };
    // allowCopyLink and allowRestrictions are contingent on if user is not in Company hub space
    // Only inline comments button is whitelisted for Company hub editors to remain consistent with whitelisted actions in the EllipsisDropdown
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, emojiCoverPictureAndContentStateSubscription, hasRestrictionsSubscription, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yCgm.MainButtons), {
        allowWebItems: true,
        allowCopyLink: !isCompanyHub && !isEmbedded,
        allowInlineComments: allowInlineComments,
        allowPageComments: allowPageComments,
        allowRestrictions: !isCompanyHub && !isEmbedded,
        allowStar: isLivePage && !isEmbedded,
        allowWatch: isLivePage && !isEmbedded,
        areMainButtonsDisabled: areMainButtonsDisabled,
        contentId: contentId,
        contentType: contentType,
        isPublishDisabled: !title || !title?.trim() || areMainButtonsDisabled || collabLimitReached || !collabEditConnected,
        isCloseButtonDisabled: shouldDisableActions,
        isPublishDisabledForPublishModal: isPublishDisabledForPublishModal,
        isUnpublishedDraft: isUnpublishedDraft,
        discardOnCloseEnabled: willDeleteBlankDraftOnClose,
        onClose: onClose,
        onClickPreview: onPreviewClicked,
        onClickPublish: onClickPublish,
        publishButtonDisabledReason: publishButtonDisabledReason,
        isPublishingContent: isPublishingContent,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        shouldRenderPreview: shouldRenderPreview,
        flags: flags,
        saveDraft: saveDraft,
        title: title,
        subsequentNode: showEllipsisDropdown && (isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $088b8a15e556cc8e$export$ad9980f718bbeeb6), {
            contentId: contentId,
            spaceKey: spaceKey,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            onClickPublish: onClickPublish,
            saveDraft: saveDraft,
            isViewMode: viewMode && !hasEditPermission,
            onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
            isDisabled: areMainButtonsDisabled || userOffline || collabLimitReached
        }) : //@ts-ignore
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aYZaZ.EllipsisDropdownComponent), ellipsisDropdownProps)),
        spaceKey: spaceKey,
        editorActions: editorActions,
        viewMode: viewMode
    }));
};
const $02a52aafb1fafdd7$export$170e4ca3217957a2 = (0, $ecUYt.withPageTreeStateUpdater)($02a52aafb1fafdd7$var$EditorPrimaryToolbarComponentsFunction);











const $82bb8752b1a17b39$export$3bc2a95151a4db09 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $82bb8752b1a17b39$var$memoizeDeepEq = (0, $2XqLN.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
function $82bb8752b1a17b39$export$f7b2b60e23c443f6({ children: children, value: value }) {
    const memoizedValue = $82bb8752b1a17b39$var$memoizeDeepEq(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82bb8752b1a17b39$export$3bc2a95151a4db09.Provider, {
        value: memoizedValue
    }, children);
}
function $82bb8752b1a17b39$export$69a815b52f63537() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($82bb8752b1a17b39$export$3bc2a95151a4db09);
    if (!context) throw new Error('useContentComponentsContext must be used within a ContentComponentsContextProvider');
    return context;
}


/* EditorActionBar.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $cgsIj = parcelRequire("cgsIj");

















var $ktUCG = parcelRequire("ktUCG");


var $i5zxs = parcelRequire("i5zxs");











var $ebrpi = parcelRequire("ebrpi");


var $3gadb = parcelRequire("3gadb");








var $cF2C3 = parcelRequire("cF2C3");

const $878360c0a07026f6$var$i18n = (0, $aXWIB.defineMessages)({
    savingMessage: {
        id: "save-indicator.saving",
        defaultMessage: "Saving"
    },
    allChangesSavedMessage: {
        id: "save-indicator.all.changes.saved",
        defaultMessage: "Saved"
    },
    savedTooltipMessage: {
        id: "save-indicator.all.changes.saved.tooltip",
        defaultMessage: "Every change is saved. The last change was {time}."
    },
    errorTooltipMessage: {
        id: "save-indicator.error.tooltip",
        defaultMessage: "We couldn\u2019t save the latest changes. The last save was {time}."
    }
});
const $878360c0a07026f6$var$saveIndicatorStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    cursor: 'default',
    marginLeft: 'space.050',
    marginRight: 'space.050',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $878360c0a07026f6$var$saveIndicatorTextStyles = (0, $ecnYn.xcss)({
    minWidth: '44px'
});
const $878360c0a07026f6$var$STATUSES = {
    DISABLED: 'disabled',
    ERROR: 'error',
    SAVING: 'saving',
    SAVED: 'saved'
};
const $878360c0a07026f6$export$944e361a93f068b6 = ({ editorActions: editorActions, saveError: saveError, title: title, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, selectingEmojiTitle: selectingEmojiTitle, selectingCoverPicture: selectingCoverPicture, formatMessage: formatMessage })=>{
    const { isSaving: isSaving, savedTime: savedTime } = (0, $42omo.useContext)((0, $f9dc71ade1ee2d5f$export$9745d8c24b40881d));
    const [status, setStatus] = (0, $42omo.useState)(null);
    const [tooltip, setTooltip] = (0, $42omo.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasSentFeatureExposed = (0, $42omo.useRef)(false);
    const sendFeatureExposed = (0, $42omo.useCallback)(()=>{
        if (!hasSentFeatureExposed.current) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'feature',
                    action: 'exposed',
                    source: 'SaveIndicatorTooltip'
                }
            }).fire();
            hasSentFeatureExposed.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    // Update save indicator text
    (0, $42omo.useEffect)(()=>{
        if (editorActions?.isDocumentEmpty() && !title && !hasEmoji && !hasCoverPicture) setStatus($878360c0a07026f6$var$STATUSES.DISABLED);
        else if (saveError) setStatus($878360c0a07026f6$var$STATUSES.ERROR);
        else if (isSaving || selectingEmojiTitle || selectingCoverPicture) setStatus($878360c0a07026f6$var$STATUSES.SAVING);
        else setStatus($878360c0a07026f6$var$STATUSES.SAVED);
    }, [
        title,
        hasEmoji,
        hasCoverPicture,
        editorActions,
        saveError,
        isSaving,
        selectingEmojiTitle,
        selectingCoverPicture,
        setStatus
    ]);
    // Update tooltip with last saved timestamp
    const refreshTooltip = (0, $42omo.useCallback)(()=>{
        if (status === $878360c0a07026f6$var$STATUSES.SAVING) setTooltip('');
        else if (status === $878360c0a07026f6$var$STATUSES.ERROR) {
            sendFeatureExposed();
            setTooltip(formatMessage($878360c0a07026f6$var$i18n.errorTooltipMessage, {
                time: (0, $cF2C3.timeFormatter)(savedTime, formatMessage)
            }));
        } else {
            sendFeatureExposed();
            setTooltip(formatMessage($878360c0a07026f6$var$i18n.savedTooltipMessage, {
                time: (0, $cF2C3.timeFormatter)(savedTime, formatMessage)
            }));
        }
    }, [
        status,
        setTooltip,
        sendFeatureExposed,
        formatMessage,
        savedTime
    ]);
    // Responsive save indicator, show icon instead of strings when viewport is small
    const getResponsiveSaveIndicator = (0, $42omo.useCallback)(()=>{
        if (status === $878360c0a07026f6$var$STATUSES.ERROR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            spacing: "spacious",
            label: "error"
        });
        else if (status === $878360c0a07026f6$var$STATUSES.SAVING) return formatMessage($878360c0a07026f6$var$i18n.savingMessage);
        else if (status === $878360c0a07026f6$var$STATUSES.SAVED) return formatMessage($878360c0a07026f6$var$i18n.allChangesSavedMessage);
    }, [
        status,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        onShow: refreshTooltip,
        content: tooltip,
        testId: "save-indicator-tooltip",
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "save-indicator",
        "aria-label": tooltip,
        tabIndex: 0,
        role: "button",
        paddingInline: "space.050",
        xcss: [
            $878360c0a07026f6$var$saveIndicatorStyles,
            (status === $878360c0a07026f6$var$STATUSES.SAVING || status === $878360c0a07026f6$var$STATUSES.SAVED) && $878360c0a07026f6$var$saveIndicatorTextStyles
        ]
    }, getResponsiveSaveIndicator()));
};


const $785e82a3520d8bdd$var$SaveIndicatorWrapper = ({ editorActions: editorActions, saveError: saveError, title: title })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $ktUCG.EmojiTitleStateContainer),
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (emojiTitleState, coverPictureState)=>{
        const selectingEmojiTitle = emojiTitleState.state.isUpdatingEmoji;
        const selectingCoverPicture = coverPictureState.state.isUploadingPicture || coverPictureState.state.isRemovingPicture || coverPictureState.state.isRepositioningPicture;
        const hasEmoji = !!emojiTitleState.state.selectedEmoji;
        const hasCoverPicture = coverPictureState.state.hasCoverPicture;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $878360c0a07026f6$export$944e361a93f068b6), {
            editorActions: editorActions,
            saveError: saveError,
            title: title,
            hasEmoji: hasEmoji,
            hasCoverPicture: hasCoverPicture,
            selectingEmojiTitle: selectingEmojiTitle,
            selectingCoverPicture: selectingCoverPicture,
            formatMessage: formatMessage
        });
    });
};
const $785e82a3520d8bdd$export$7ceebdb305e167df = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_MODES
})($785e82a3520d8bdd$var$SaveIndicatorWrapper);



var $40pD8 = parcelRequire("40pD8");


var $knzfV = parcelRequire("knzfV");


var $3u0dr = parcelRequire("3u0dr");




const $29f7b817e5a3be3c$export$c206229737fbecf5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const { contentClassificationMetadata: contentClassificationMetadata } = props;
    const { hasNoClassification: hasNoClassification, contentLevelLoading: contentLevelLoading } = contentClassificationMetadata;
    const classificationEnabledFinalEvaluation = contentClassificationMetadata?.featureEnabled ?? false;
    let t0;
    bb0: {
        if (!classificationEnabledFinalEvaluation) {
            t0 = false;
            break bb0;
        }
        if (hasNoClassification) {
            t0 = false;
            break bb0;
        }
        if (contentLevelLoading) {
            t0 = false;
            break bb0;
        }
        t0 = true;
    }
    return t0;
} : (props)=>{
    const { contentClassificationMetadata: contentClassificationMetadata } = props;
    const { hasNoClassification: hasNoClassification, contentLevelLoading: contentLevelLoading } = contentClassificationMetadata;
    const classificationEnabledFinalEvaluation = contentClassificationMetadata?.featureEnabled ?? false;
    return (0, $42omo.useMemo)(()=>{
        if (!classificationEnabledFinalEvaluation) return false;
        if (hasNoClassification) return false;
        if (contentLevelLoading) return false;
        return true;
    }, [
        contentLevelLoading,
        hasNoClassification,
        classificationEnabledFinalEvaluation
    ]);
};


















const $ae28c0eef32d4b04$export$1ea7d51d1b0f817f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Y65XF",
    name: "EditorClassificationTagWrapper",
    loader: async ()=>(await (parcelRequire("fy4lc"))).EditorClassificationTagWrapper,
    loading: (props)=>{
        const { shouldRenderPlaceholder: shouldRenderPlaceholder } = props;
        if (!shouldRenderPlaceholder) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
            const $ = (0, $frIzR.c)(13);
            let T0;
            let t1;
            let t2;
            let t3;
            let t4;
            if ($[0] !== __cmplr || $[1] !== t0) {
                const { as: t5, style: __cmpls, ...__cmplp } = t0;
                const C = t5 === undefined ? "div" : t5;
                T0 = C;
                t1 = __cmplp;
                t2 = __cmpls;
                t3 = __cmplr;
                t4 = (0, $gMc0m.default)([
                    "_4t3i1ou6",
                    __cmplp.className
                ]);
                $[0] = __cmplr;
                $[1] = t0;
                $[2] = T0;
                $[3] = t1;
                $[4] = t2;
                $[5] = t3;
                $[6] = t4;
            } else {
                T0 = $[2];
                t1 = $[3];
                t2 = $[4];
                t3 = $[5];
                t4 = $[6];
            }
            let t5;
            if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
                    ...t1,
                    style: t2,
                    ref: t3,
                    className: t4
                });
                $[7] = T0;
                $[8] = t1;
                $[9] = t2;
                $[10] = t3;
                $[11] = t4;
                $[12] = t5;
            } else t5 = $[12];
            return t5;
        } : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $gMc0m.default)([
                    "_4t3i1ou6",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});










var $9YwaJ = parcelRequire("9YwaJ");




const $c564822da305b5a7$var$i18n = (0, $aXWIB.defineMessages)({
    requestToEdit: {
        defaultMessage: "Request to edit",
        id: "no-permission.request.to.edit.button.placeholder.label"
    }
});
const $c564822da305b5a7$var$RequestToEditPlaceholder = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        isDisabled: true
    }, intl.formatMessage($c564822da305b5a7$var$i18n.requestToEdit));
};

const $c564822da305b5a7$export$8d3bd7292e9c1665 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nHgfY",
    name: "RequestToEditLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("d6K5N"))).RequestToEdit,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c564822da305b5a7$var$RequestToEditPlaceholder, null)
});



var $bLtXM = parcelRequire("bLtXM");


var $26Yfd = parcelRequire("26Yfd");

// Update EDITOR_ACTION_BAR_HEIGHT in EditorDisplayWrapper and EditorHelpCenterComponent and EditorDraftBannerStyles
const $127f29c854fd1c7d$var$editorActionBarWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'relative',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    borderBottomColor: 'color.border',
    borderBottomStyle: 'solid',
    borderBottomWidth: 'border.width',
    minHeight: '36px',
    // editor inline coment sidebar has a zIndex of 501, and editor toolbar has a zIndex of 510, set a slighly higher zIndex would fix overlap issue with popups from inline comments and invite to share popup.
    zIndex: 'flag',
    backgroundColor: 'elevation.surface',
    paddingLeft: 'space.150',
    maxHeight: 'unset',
    alignItems: 'center',
    gap: 'space.025'
});
const $127f29c854fd1c7d$var$hiddenStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $127f29c854fd1c7d$var$overflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden'
});
const $127f29c854fd1c7d$var$breadcrumbsAndClassificationTagWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    flex: '0 1 auto',
    overflow: 'hidden',
    justifyContent: 'start',
    minWidth: 'fit-content',
    gap: 'space.050',
    [(0, $bWLcG.media).above.xs]: {
        minWidth: '96px'
    }
});
const $127f29c854fd1c7d$var$componentsWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    minWidth: 'fit-content',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexBasis: 'unset',
    marginLeft: 'auto'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $127f29c854fd1c7d$var$VerticalSeparator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81cy0 _1kl71uh4 _1e0c1o8l _1bsbt94y _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $127f29c854fd1c7d$var$ButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx12x7",
            __cmplp.className
        ])
    });
});
const $127f29c854fd1c7d$var$EditorActionBar = ({ spaceKey: spaceKey, editorActions: editorActions, collabEditState: collabEditState, title: title, forceDisabled: forceDisabled, userOffline: userOffline, contentId: contentId, contentType: contentType, isContentCreationPanelOpen: isContentCreationPanelOpen, isUnpublishedDraft: isUnpublishedDraft, onClickPublish: onClickPublish, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onPreviewClicked: onPreviewClicked, saveDraft: saveDraft, collabLimitReached: collabLimitReached, showRevertDialog: showRevertDialog, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isPublishingContent: isPublishingContent, isSingleUserSession: isSingleUserSession, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, shouldRenderPreview: shouldRenderPreview, shouldShowRecentSpotlight: shouldShowRecentSpotlight, checkIfConditionPreventingPublish: checkIfConditionPreventingPublish, flags: flags, hasEditPermission: hasEditPermission, editorDisabled: editorDisabled, isTitleFocused: isTitleFocused, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, isLivePage: isLivePage, requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission, ellipsisEditorActions: ellipsisEditorActions })=>{
    const isDataClassificationEnabledForOrg = contentClassificationMetadata?.featureEnabled ?? false;
    const classificationProps = {
        isDataClassificationEnabledForOrg: isDataClassificationEnabledForOrg,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        contentClassificationMetadata: contentClassificationMetadata,
        hasEditPermission: hasEditPermission,
        isLivePage: isLivePage,
        userOffline: userOffline
    };
    const shouldRenderClassificationPlaceholder = (0, $29f7b817e5a3be3c$export$c206229737fbecf5)(classificationProps);
    const isCollabNetworkUnreachable = (editorDisabled || collabLimitReached) && !isTitleFocused && !userOffline;
    const hideSaveIndicator = viewMode || isCollabNetworkUnreachable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $127f29c854fd1c7d$var$editorActionBarWrapperStyles,
            shouldRenderPreview && $127f29c854fd1c7d$var$hiddenStyles
        ],
        testId: "editor-action-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40pD8.ClassificationModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $knzfV.ClassificationEditModal), {
        contentId: contentId,
        spaceKey: spaceKey,
        contentClassificationMetadata: contentClassificationMetadata
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $127f29c854fd1c7d$var$breadcrumbsAndClassificationTagWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $127f29c854fd1c7d$var$overflowStyles,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.Breadcrumbs), {
        contentId: contentId,
        spaceKey: spaceKey,
        contentTitle: title ?? undefined,
        testId: "editor-breadcrumbs-container"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ae28c0eef32d4b04$export$1ea7d51d1b0f817f), {
        ...classificationProps,
        shouldRenderPlaceholder: shouldRenderClassificationPlaceholder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $127f29c854fd1c7d$var$componentsWrapperStyles
    }, !hideSaveIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $785e82a3520d8bdd$export$7ceebdb305e167df), {
        editorActions: editorActions,
        saveError: !!collabEditState.collabEditError || userOffline,
        title: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bLtXM.ContentHeaderPresence), {
        contentId: contentId,
        contentType: contentType,
        isViewMode: viewMode,
        analyticSource: "editPageScreen"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($127f29c854fd1c7d$var$VerticalSeparator, null), !hasEditPermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($127f29c854fd1c7d$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c564822da305b5a7$export$8d3bd7292e9c1665), {
        contentId: contentId,
        requestToEditContent: requestToEditContent,
        hasRequestedEditPermission: hasRequestedEditPermission
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02a52aafb1fafdd7$export$170e4ca3217957a2), {
        forceDisabled: forceDisabled,
        userOffline: userOffline,
        contentId: contentId,
        contentType: contentType,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isUnpublishedDraft: isUnpublishedDraft,
        onClickPublish: onClickPublish,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        onPreviewClicked: onPreviewClicked,
        saveDraft: saveDraft,
        spaceKey: spaceKey,
        title: title,
        collabLimitReached: collabLimitReached,
        showRevertDialog: showRevertDialog,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        isPublishingContent: isPublishingContent,
        editorActions: editorActions,
        isSingleUserSession: isSingleUserSession,
        navigateOnClose: navigateOnClose,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        shouldRenderPreview: shouldRenderPreview,
        shouldShowRecentSpotlight: shouldShowRecentSpotlight,
        checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
        flags: flags,
        viewMode: viewMode,
        hasEditPermission: hasEditPermission,
        ellipsisEditorActions: ellipsisEditorActions
    }))));
};
const $127f29c854fd1c7d$var$MemoEditorActionBar = /*#__PURE__*/ (0, $42omo.memo)($127f29c854fd1c7d$var$EditorActionBar);
const $127f29c854fd1c7d$export$97f4d50961f98e6a = (props)=>{
    const showRevertDialog = (0, $26Yfd.useStableCallback)(props.showRevertDialog);
    const onClickPublish = (0, $26Yfd.useStableCallback)(props.onClickPublish);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($127f29c854fd1c7d$var$MemoEditorActionBar, {
        ...props,
        showRevertDialog: showRevertDialog,
        onClickPublish: onClickPublish
    });
};



var $fwwrH = parcelRequire("fwwrH");


var $JJ6wk = parcelRequire("JJ6wk");


var $7QM6o = parcelRequire("7QM6o");


var $eD8ha = parcelRequire("eD8ha");





var $hV9Q1 = parcelRequire("hV9Q1");


var $bUiJC = parcelRequire("bUiJC");


var $ixblh = parcelRequire("ixblh");


var $c06us = parcelRequire("c06us");

const $ccf3ae46461db7a4$export$5690797982203811 = ({ spaceKey: spaceKey })=>{
    const [previewHovered, setPreviewHovered] = (0, $42omo.useState)(false);
    const { templates: templates, templateIndex: templateIndex, buttonHovered: buttonHovered } = (0, $c06us.useBlankPageQuickActionsContext)();
    const shouldShowTemplatePreview = buttonHovered || previewHovered;
    const { width: width } = (0, $bUiJC.useEditorWidthObserver)({});
    (0, $42omo.useEffect)(()=>{
        // we need to preload the TemplatePreview
        // component or the rendering will flicker between
        // skeleton & loaded states
        (0, $hV9Q1.TemplatePreview).preload();
    }, []);
    return shouldShowTemplatePreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ixblh.BlankPageQuickActionsTemplatePreviewWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ixblh.BlankPageQuickActionsTemplatePreviewContainer), {
        editorWidth: width,
        shouldShowTemplatePreview: shouldShowTemplatePreview,
        onMouseEnter: ()=>{
            setPreviewHovered(true);
        },
        onMouseLeave: ()=>{
            setPreviewHovered(false);
        },
        "data-testid": "bpqa-full-size-template-preview-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hV9Q1.TemplatePreview), {
        spaceKey: spaceKey,
        templates: templates.map((template)=>({
                name: template.name ?? null,
                contentBlueprintId: template.contentBlueprintId ?? null,
                templateId: template.templateId ?? null,
                blueprintModuleCompleteKey: template.blueprintModuleCompleteKey ?? null,
                itemModuleCompleteKey: template.itemModuleCompleteKey ?? null,
                iconURL: template.iconURL ?? null,
                darkModeIconURL: template.darkModeIconURL,
                styleClass: template.styleClass ?? null
            })),
        currentTemplateIndex: templateIndex,
        numPreviewsToFetchAtOnce: 3
    }))) : null;
};












var $d925B = parcelRequire("d925B");











var $g5gZt = parcelRequire("g5gZt");





var $h7YX1 = parcelRequire("h7YX1");


var $hw7wB = parcelRequire("hw7wB");





var $lJDEI = parcelRequire("lJDEI");


var $bxEVw = parcelRequire("bxEVw");




/* BOEQuickActionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1Whri = parcelRequire("1Whri");




/* ShortcutLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $u9agA = parcelRequire("u9agA");

const $1f065e260c5902bd$var$styles = {
    lozenge: "_2rko12b0 _11c8wadc _bozg12x7 _y4ti12x7 _1q51v77o _85i5v77o _bfhki8nm _syazazsu _k48pi7a9"
};
const $1f065e260c5902bd$export$992dee387d429413 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: $1f065e260c5902bd$var$styles.lozenge
    }, children);


const $10905f5372d5a787$var$styles = {
    button: "_zulp1b66 _2rko1qi0 _1e0c1txw _4cvr1h6o _bozgu2gc _y4tiu2gc _1q5112x7 _85i512x7 _bfhkvuon _80omtlke _1dbz130s",
    active: "_bfhkfcek"
};
const $10905f5372d5a787$export$b7c8aa160ad6fd8c = ({ children: children, shortcut: shortcut, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isDisabled: isDisabled, isActive: isActive, testId: testId, analyticsButtonType: analyticsButtonType, isLivePage: isLivePage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (analyticsButtonType) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'BlankObjectExperienceButtons',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createWithRovoBlankObject',
                attributes: {
                    variant: 'variant1',
                    contentType: isLivePage ? 'liveDoc' : 'page',
                    buttonType: analyticsButtonType
                }
            }
        }).fire();
        onClick?.();
    }, [
        onClick,
        createAnalyticsEvent,
        analyticsButtonType,
        isLivePage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        testId: testId,
        onClick: handleClick,
        onMouseEnter: onMouseEnter,
        isDisabled: isDisabled,
        xcss: (0, $1Whri.cx)($10905f5372d5a787$var$styles.button, isActive && $10905f5372d5a787$var$styles.active),
        style: {
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
        }
    }, icon?.(), children, shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f065e260c5902bd$export$992dee387d429413), null, shortcut));
};


// Icon components hoisted outside to avoid recreating on every render
const $1441818b1f852262$var$CreateWithRovoIcon = ({ disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))), {
        label: "Create with Rovo",
        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
    });
const $1441818b1f852262$var$AllTemplatesIcon = ({ disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isFEX))), {
        label: "All templates",
        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
    });
const $1441818b1f852262$var$MoreElementsIcon = ({ disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        size: "medium",
        label: "",
        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
    });
const $1441818b1f852262$var$ImportIcon = ({ disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
        label: "Import",
        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
    });
// Create hooks for our query params
const $1441818b1f852262$var$useInEditorTemplatesPanelParam = (0, $dPJCf.createSingleQueryParamHook)((0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME));
const $1441818b1f852262$var$useContextPanelTabTargetParam = (0, $dPJCf.createSingleQueryParamHook)((0, $lJDEI.CONTEXT_PANEL_TAB_TARGET));
const $1441818b1f852262$export$5b6edddf72525f99 = ({ disabled: disabled, editorPresetAPI: editorPresetAPI, isTitleFocused: isTitleFocused, focusEditor: focusEditor, isAIEnabled: isAIEnabled, isLivePage: isLivePage, onCreateWithRovoClick: onCreateWithRovoClick, onCreateWithRovoHover: onCreateWithRovoHover })=>{
    const [isOnImportTab, setIsOnImportTab] = (0, $42omo.useState)(false);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasTrackedInitialRenderRef = (0, $42omo.useRef)(false);
    // Fire analytics on first render only (initial page load)
    (0, $42omo.useEffect)(()=>{
        if (!hasTrackedInitialRenderRef.current) {
            hasTrackedInitialRenderRef.current = true;
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'blankObjectExperienceButtons',
                    attributes: {
                        contentType: isLivePage ? 'liveDoc' : 'page'
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        isLivePage
    ]);
    // Get query param values for the templates panel
    const inEditorTemplatesPanelValue = $1441818b1f852262$var$useInEditorTemplatesPanelParam();
    const contextPanelTabTargetValue = $1441818b1f852262$var$useContextPanelTabTargetParam();
    // Helper to get all query params (for compatibility with isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen)
    const getQueryParams = (0, $42omo.useCallback)(()=>({
            [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: inEditorTemplatesPanelValue,
            [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: contextPanelTabTargetValue
        }), [
        inEditorTemplatesPanelValue,
        contextPanelTabTargetValue
    ]);
    // Add elements slash menu active state
    const isTypeAheadOpen = // @ts-ignore -- typeAhead.isOpen selector path typing is difficult with plugin state selector. These errors exist in old BPQA as well
    (0, $b3YrF.useSharedPluginStateSelector)(editorPresetAPI, 'typeAhead.isOpen') ?? false;
    // Templates panel active state
    const isPanelOpen = (0, $lJDEI.isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen)(getQueryParams);
    // Templates button is active when panel is open but NOT on import tab
    const isAllTemplatesLinkActive = isPanelOpen && !isOnImportTab;
    // Import button is active when panel is open AND on import tab
    const isImportActive = isPanelOpen && isOnImportTab;
    // Handle create with rovo click
    const handleCreateWithRovoClick = (0, $42omo.useCallback)(()=>{
        onCreateWithRovoClick();
    }, [
        onCreateWithRovoClick
    ]);
    // Handle all templates click
    const handleAllTemplatesClick = (0, $42omo.useCallback)(async ()=>{
        if (isAllTemplatesLinkActive) // Close panel if templates panel is already open
        (0, $lJDEI.removeInEditorTemplatesQueryParam)(setQueryParams, isAIEnabled);
        else {
            // Open templates tab (panel will reactively update to templates mode)
            // Clear the contextPanelTabTarget so it defaults to templates
            setQueryParams({
                [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: null
            }, true);
            (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN), undefined, isAIEnabled);
        }
        setIsOnImportTab(false);
    }, [
        setQueryParams,
        isAllTemplatesLinkActive,
        isAIEnabled
    ]);
    // Handle import click
    const handleImportClick = (0, $42omo.useCallback)(()=>{
        if (isImportActive) // Close panel if already on import tab
        (0, $lJDEI.removeInEditorTemplatesQueryParam)(setQueryParams, isAIEnabled);
        else // Open import tab (panel will reactively update)
        (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN), 'import', isAIEnabled);
        setIsOnImportTab(!isImportActive);
    }, [
        setQueryParams,
        isImportActive,
        isAIEnabled
    ]);
    // Handle more elements click
    const handleMoreElementsClick = (0, $42omo.useCallback)(async ()=>{
        if (isTitleFocused) await focusEditor();
        if (isTypeAheadOpen) editorPresetAPI?.typeAhead.actions.close({
            insertCurrentQueryAsRawText: true
        });
        else editorPresetAPI?.quickInsert.actions.openTypeAhead((0, $d925B.INPUT_METHOD).QUICK_INSERT);
    }, [
        editorPresetAPI,
        isTitleFocused,
        focusEditor,
        isTypeAheadOpen
    ]);
    // Hide the entire BPQA when the slash command menu (typeahead) is open
    if (isTypeAheadOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        gap: "space.100"
    }, isAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10905f5372d5a787$export$b7c8aa160ad6fd8c), {
        testId: "create-with-rovo-button",
        onClick: handleCreateWithRovoClick,
        onMouseEnter: onCreateWithRovoHover,
        isDisabled: disabled,
        analyticsButtonType: "cwr",
        isLivePage: isLivePage,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1441818b1f852262$var$CreateWithRovoIcon, {
                disabled: disabled
            }),
        shortcut: "Space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ixblh.ButtonText), {
        isDisabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bxEVw.i18n).createWithRovo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10905f5372d5a787$export$b7c8aa160ad6fd8c), {
        testId: "blank-page-quick-actions-all-templates-link",
        onClick: handleAllTemplatesClick,
        isDisabled: disabled,
        analyticsButtonType: "template",
        isLivePage: isLivePage,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1441818b1f852262$var$AllTemplatesIcon, {
                disabled: disabled
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ixblh.ButtonText), {
        isDisabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bxEVw.i18n).chooseATemplate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10905f5372d5a787$export$b7c8aa160ad6fd8c), {
        testId: "blank-page-quick-actions-more-elements-link",
        onClick: handleMoreElementsClick,
        isDisabled: disabled,
        isActive: !!isTypeAheadOpen,
        analyticsButtonType: "pageElements",
        isLivePage: isLivePage,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1441818b1f852262$var$MoreElementsIcon, {
                disabled: disabled
            }),
        shortcut: "/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ixblh.ButtonText), {
        isDisabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bxEVw.i18n).addElements))), !isAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10905f5372d5a787$export$b7c8aa160ad6fd8c), {
        testId: "import-button",
        isDisabled: disabled,
        isActive: isImportActive,
        analyticsButtonType: "import",
        isLivePage: isLivePage,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1441818b1f852262$var$ImportIcon, {
                disabled: disabled
            }),
        onClick: handleImportClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ixblh.ButtonText), {
        isDisabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bxEVw.i18n).import))));
};



var $99ISI = parcelRequire("99ISI");


var $lG7DR = parcelRequire("lG7DR");


var $bFMG7 = parcelRequire("bFMG7");


var $l2hqi = parcelRequire("l2hqi");


var $liGyh = parcelRequire("liGyh");


var $6tkbf = parcelRequire("6tkbf");


var $aHcFH = parcelRequire("aHcFH");





var $cb6fO = parcelRequire("cb6fO");


var $1NBp8 = parcelRequire("1NBp8");




const $5c5c39eb3a311fda$export$5972bbfae42d8829 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, title: title, createdDate: createdDate, isUnpublishedDraft: isUnpublishedDraft })=>{
    const titleRef = (0, $42omo.useRef)(title);
    const createdDateRef = (0, $42omo.useRef)(createdDate);
    (0, $42omo.useEffect)(()=>{
        titleRef.current = title;
    }, [
        title
    ]);
    (0, $42omo.useEffect)(()=>{
        createdDateRef.current = createdDate;
    }, [
        createdDate
    ]);
    const getHeadingLinkPath = (0, $42omo.useCallback)(()=>{
        const isUnpublishedPage = contentType === 'page' && isUnpublishedDraft;
        const isUnpublishedBlog = contentType === 'blogpost' && isUnpublishedDraft;
        const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        if (isUnpublishedPage) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'pages'
        });
        if (isUnpublishedBlog) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'blog'
        });
        if (contentType === 'blogpost' && !createdDateRef.current) return (0, $1NBp8.VIEW_BLOG).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            slug: (0, $cb6fO.generateSlug)(titleRef.current)
        });
        if (isCompanyHub) return (0, $1NBp8.COMPANY_HUB).toUrl();
        return (0, $cb6fO.buildContentPath)(spaceKey, contentId, contentType, createdDateRef.current ?? '', (0, $cb6fO.generateSlug)(titleRef.current));
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft
    ]);
    return {
        getHeadingLinkPath: getHeadingLinkPath
    };
};



var $7f6xB = parcelRequire("7f6xB");


var $fMO7O = parcelRequire("fMO7O");


var $6gbpH = parcelRequire("6gbpH");


var $iKSlH = parcelRequire("iKSlH");







var $1l6y9 = parcelRequire("1l6y9");




var $ewVsQ = parcelRequire("ewVsQ");


var $kRAnY = parcelRequire("kRAnY");


var $kDhla = parcelRequire("kDhla");

/* PageFooterComments.tsx generated by @compiled/babel-plugin v0.36.1 */ 





parcelRequire("b1pD4");
var $3ACqI = parcelRequire("3ACqI");


var $jTxSS = parcelRequire("jTxSS");


var $xQxzY = parcelRequire("xQxzY");


var $l5y3Y = parcelRequire("l5y3Y");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $04e9M = parcelRequire("04e9M");





var $2i3To = parcelRequire("2i3To");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");

















var $deTj5 = parcelRequire("deTj5");


var $7zgzO = parcelRequire("7zgzO");


var $hrEV9 = parcelRequire("hrEV9");








var $ftXPY = parcelRequire("ftXPY");





var $86okN = parcelRequire("86okN");

'use no memo';
const $fdbc46c13e75ea1d$var$loadingPageCommentWrapperStyles = null;
const $fdbc46c13e75ea1d$var$pageCommentWrapperStyles = null;
const $fdbc46c13e75ea1d$var$pageCommentStyle = null;
const $fdbc46c13e75ea1d$var$pageCommentWiderStyles = null;
const $fdbc46c13e75ea1d$var$pageCommentAbsoluteWrapperStyles = null;
const $fdbc46c13e75ea1d$var$PageCommentAbsoluteWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1ltvidpf _1bsbkest"
        ])
    }, children);
const $fdbc46c13e75ea1d$var$sendKeyboardShortcutAnalytics = ({ source: source, shortcut: shortcut })=>{
    let pageMode;
    if (source === (0, $cD1qu.PageMode).VIEW) pageMode = 'viewPage';
    else if (source === (0, $cD1qu.PageMode).LIVE) pageMode = 'livePages';
    (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
        analyticsClient.sendUIEvent({
            source: pageMode,
            action: 'pressed',
            actionSubject: 'keyboardShortcut',
            actionSubjectId: 'createComment',
            attributes: {
                key: shortcut
            }
        });
    });
}; /**
    * @deprecated This component is deprecated and will be removed in a future version.
    * It is used to render legacy page comments but is no longer needed as part of modernization.
    */ 
const $fdbc46c13e75ea1d$var$LazyLoadablePageComments = ({ children: children, shouldLazyLoad: shouldLazyLoad, renderPlaceholder: renderPlaceholder, loadPageCommentsCallback: loadPageCommentsCallback, isCommentsReady: isCommentsReady })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const wrapperRef = (0, $42omo.useRef)(null);
    const observerRef = (0, $42omo.useRef)(null);
    const [commentSectionTop, setCommentSectionTop] = (0, $42omo.useState)(undefined); // load comments immediately if not lazy load, otherwise wait until it is in the viewport
    const [loadPageComments, setLoadPageComments] = (0, $42omo.useState)(!shouldLazyLoad);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    (0, $42omo.useEffect)(()=>{
        const editorTextArea = document.getElementById('ak-editor-textarea');
        if (editorTextArea) {
            // Create a ResizeObserver to watch for size changes
            const resizeObserver = new ResizeObserver((entries)=>{
                const newTop = (0, $aHcFH.getCommentPositionTopOfSectionEditor)(entries); // Warning temporary to unblock modernisation release (see COMMENTS-3668)
                (0, $jTxSS.flushSync)(()=>{
                    newTop && setCommentSectionTop(newTop);
                });
            }); // Start observing the editorTextArea and documentContent for size changes
            resizeObserver.observe(editorTextArea); // Cleanup function to disconnect the observer on unmount
            return ()=>resizeObserver.disconnect();
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        observerRef.current = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) {
                // show page comments when the wrapper is in viewport
                setLoadPageComments(true);
                observerRef.current?.disconnect();
            }
        }); // Remove the observer as soon as the component is unmounted
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (wrapperRef.current && !loadPageComments) // attach intersection observer after content is ready
        observerRef.current?.observe(wrapperRef.current);
    }, [
        loadPageComments
    ]);
    (0, $42omo.useEffect)(()=>{
        if (loadPageComments) loadPageCommentsCallback?.();
    }, [
        loadPageComments,
        loadPageCommentsCallback
    ]); // render placeholder only in SSR
    const shouldRenderPageComments = loadPageComments;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: wrapperRef,
        className: (0, $gMc0m.default)([
            !isCommentsReady && "_1yt4pxbi _1e0c1txw _1bsb1wug _1bah1h6o _n3tdv47k _kqswstnw _94n5idpf _1pbyjwwv"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdbc46c13e75ea1d$var$PageCommentAbsoluteWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "page-comment-wrapper",
        style: {
            visibility: isCommentsReady ? 'visible' : 'hidden',
            top: isCommentsReady ? commentSectionTop : undefined
        },
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1w8u _p12f2q5v _1ul9e0nm",
            isCommentsReady ? "_kqswh2mm _1pbyjwwv _1e0c1txw _1bah1h6o" : "_1yt4pxbi _1e0c1txw _1bsb1wug _1bah1h6o _n3tdv47k _kqswstnw _94n5idpf _1pbyjwwv"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>{
            e.preventDefault();
            if (document.querySelector('[data-testid="editor-floating-toolbar"]')) return;
            if (!isCommentsReady) {
                setQueryParams({
                    showCommentArea: 'true'
                }); //This will scroll to and load the page comments section if its not available (e.g. on long pages)
                wrapperRef.current?.scrollIntoView && wrapperRef.current?.scrollIntoView({
                    block: 'end',
                    behavior: 'smooth'
                });
            } else window.dispatchEvent(new Event('openPageCommentEditor'));
            $fdbc46c13e75ea1d$var$sendKeyboardShortcutAnalytics({
                source: pageMode,
                shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _11rm1hrf _1bsb1osq _2lx21bp4 _1e0c1txw _1bah1yb4 _4cvr1y6m _p12fn7od _1ul9118a"
        ])
    }, shouldRenderPageComments ? children : renderPlaceholder?.()))));
};
const $fdbc46c13e75ea1d$var$PageFooterCommentsComponent = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, loadingPriority: loadingPriority })=>{
    /* Preload CommentsSectionQuery - We preload CommentsSectionQuery as part of next/packages/query-preloaders/src/index.ts,
     but its bestEffort Preloading - meaning if it exceeds the threshold it wont wait for query to finish
     Adding preloading here as well to ensure data is ready once user scrolls*/ const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const { error: error } = (0, $xQxzY.useQuery)(isReactionsEnabled ? (0, $86okN.toDocumentNode)((0, $ftXPY.CommentsSectionQuery)) : (0, $86okN.toDocumentNode)((0, $ftXPY.CommentsSectionWithoutReactionsQuery)), {
        variables: {
            contentId: contentId,
            offset: '',
            first: (0, $2i3To.DEFAULT_LIMIT)
        },
        fetchPolicy: 'cache-and-network',
        skip: !contentId
    }); /*  Marking all graphql errors here as handled since we are only preloading query. The CommentsSectionFabric component
         where the query data is used has exhaustive error handling*/ 
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { focusedCommentId: focusedCommentId, replyToComment: replyToComment, showCommentArea: showCommentArea, editComment: editComment, commentId: commentId } = getQueryParams(); /* check for query params - If anyone of these are true just load Page comments */ 
    const isFocusedComment = Boolean(focusedCommentId || replyToComment || showCommentArea || editComment === 'true' && commentId);
    const [isCommentsReady, setIsCommentsReady] = (0, $42omo.useState)(false);
    const startExperienceTracker = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
            attributes: {
                isConditionalRenderingOn: true,
                isFocusedComment: isFocusedComment,
                editor: 'FABRIC',
                contentId: contentId
            }
        });
    }, [
        experienceTracker,
        isFocusedComment,
        contentId
    ]); // Display comment Placeholder
    const renderCommentPlaceholder = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), {
            showPlaceholder: true
        });
    };
    const windowHeight = window.innerHeight;
    const editorProseMirrorHeight = document.querySelector('.ak-editor-content-area .ProseMirror')?.scrollHeight || 0;
    const contentHeight = editorProseMirrorHeight / windowHeight; // The placeholder isn't in view if the content takes up more than 30% and less than 2% of the screen
    const shouldRenderPlaceholder = contentHeight < 0.3 && contentHeight > 0.02;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdbc46c13e75ea1d$var$LazyLoadablePageComments, {
        shouldLazyLoad: !isFocusedComment,
        renderPlaceholder: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        shouldRenderPlaceholder ? renderCommentPlaceholder : undefined,
        loadPageCommentsCallback: startExperienceTracker,
        isCommentsReady: isCommentsReady
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, // Important! Here, the renderCommentPlaceholder() must match the renderPlaceholder
    // in LazyLoadPageComments to ensure the initial hydration matches the SSR render result
    !isCommentsReady && !isLivePage && renderCommentPlaceholder(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hrEV9.CommentsSectionLoader), {
        contentId: contentId,
        classicComments: (0, $3ACqI.CommentsSectionLoader),
        handlePageCommentsRender: ()=>setIsCommentsReady(true),
        loadingPriority: loadingPriority || (0, $398ES.LoadingPriority).PAINT
    })));
});
const $fdbc46c13e75ea1d$export$f9d737bcf2a1ec12 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COLLABORATION
})($fdbc46c13e75ea1d$var$PageFooterCommentsComponent);






const $4f7d3262c48387ee$export$c0bc8bbccc993b75 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "tsrw0",
    name: "PublishModalKeyboardShortcuts",
    loader: async ()=>{
        return (await (parcelRequire("6XpHo"))).PublishModalKeyboardShortcuts;
    }
});






const $73d7c23c9a6a572e$export$b112826b6cf719c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "XmBDy",
    name: "PublishModalMountPoint",
    loader: async ()=>{
        return (await (parcelRequire("76Au3"))).PublishModalMountPoint;
    }
});



var $1N2OF = parcelRequire("1N2OF");


var $6pob4 = parcelRequire("6pob4");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");





var $8uM2K = parcelRequire("8uM2K");


var $jFkNO = parcelRequire("jFkNO");





var $bK3oZ = parcelRequire("bK3oZ");


var $88Nzy = parcelRequire("88Nzy");


var $dA1Sn = parcelRequire("dA1Sn");


var $8HrX3 = parcelRequire("8HrX3");


var $lmNXu = parcelRequire("lmNXu");


var $1AJi3 = parcelRequire("1AJi3");


var $hR4U4 = parcelRequire("hR4U4");





const $44282712d6713830$export$895eee10ef701154 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kOmOd",
    name: "CreateWithRovoExperience",
    loader: async ()=>(await (parcelRequire("flriQ"))).CreateWithRovoExperience
});






const $badeeeba932732aa$export$1683fadeb44552c5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0-DzZ",
    name: "CreateWithRovoExperienceDismissText",
    loader: async ()=>(await (parcelRequire("1n6r5"))).CreateWithRovoExperienceDismissText
});



var $BjpgS = parcelRequire("BjpgS");











var $amg3z = parcelRequire("amg3z");


var $eWgCZ = parcelRequire("eWgCZ");

const $2a156e74b04ef78c$export$122559bc1a8888a4 = (editorAPI)=>{
    const { detectedLinks: detectedLinks, newLinkTypes: newLinkTypes, newLinks: newLinks, shouldShowSpotlight: shouldShowSpotlight, closeSpotlight: closeSpotlight, setInitialContent: setInitialContent, handlePastedLinks: handlePastedLinks } = (0, $eWgCZ.useIntegrationLinkSpotlight)();
    const hasSetBaselineRef = (0, $42omo.useRef)(false);
    const editorAPIRef = (0, $42omo.useRef)(editorAPI);
    // Reset baseline flag when editorAPI changes
    (0, $42omo.useEffect)(()=>{
        if (editorAPIRef.current !== editorAPI) {
            editorAPIRef.current = editorAPI;
            hasSetBaselineRef.current = false;
        }
    }, [
        editorAPI
    ]);
    // Baseline: when editor is ready, capture initial document so we can compute delta later.
    (0, $42omo.useEffect)(()=>{
        if (!editorAPI?.core?.actions?.requestDocument || !(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        editorAPI.core.actions.requestDocument((doc)=>{
            if (hasSetBaselineRef.current) return;
            hasSetBaselineRef.current = true;
            setInitialContent(doc);
        }, {
            alwaysFire: true
        });
    }, [
        editorAPI,
        setInitialContent
    ]);
    // On paste: extract links from pasted slice only (efficient - no full doc traversal).
    (0, $6qdjm.usePluginStateEffect)(editorAPI, [
        'paste'
    ], ({ pasteState: pasteState })=>{
        const lastPasted = pasteState?.lastContentPasted;
        if (!lastPasted?.pastedSlice || !(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        // Extract links from ONLY the pasted slice (not entire document)
        const pastedUrls = (0, $amg3z.extractLinksFromSlice)(lastPasted.pastedSlice);
        const pastedLinks = (0, $amg3z.getDetectedLinksFromUrls)(pastedUrls);
        // Use handlePastedLinks to process just the pasted links
        handlePastedLinks(pastedLinks);
    });
    return {
        detectedLinks: detectedLinks,
        newLinkTypes: newLinkTypes,
        newLinks: newLinks,
        shouldShowSpotlight: shouldShowSpotlight,
        closeSpotlight: closeSpotlight
    };
};






const $46e670f6dbd146ec$export$83ad660b287906ed = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Ls2sx",
    name: "IntegrationLinkSpotlightLoadable",
    loader: async ()=>(await (parcelRequire("hfKvg"))).IntegrationLinkSpotlight,
    loading: ()=>null
});












var $jyA9t = parcelRequire("jyA9t");

const $d255586da55d4698$export$f34b0c6dc5eb5a35 = (editorActions)=>{
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }] = (0, $kDhla.useFullPageEditorApi)();
    // Use a ref so the submit callback always reads the latest API value at invocation time,
    // rather than the stale value captured when the useCallback was last created.
    const fullPageEditorPresetAPIRef = (0, $42omo.useRef)(fullPageEditorPresetAPI);
    (0, $42omo.useEffect)(()=>{
        fullPageEditorPresetAPIRef.current = fullPageEditorPresetAPI;
    }, [
        fullPageEditorPresetAPI
    ]);
    const { openModal: openSmartCreationModalBase } = (0, $jyA9t.useSmartCreationModalActions)();
    return (0, $42omo.useCallback)(({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, content: content })=>{
        if (entryPoint === 'editorQuickInsert') {
            const submitWithInsertLink = async ({ baseUrl: baseUrl, path: path })=>{
                const fullUrl = baseUrl + path;
                const view = editorActions._privateGetEditorView?.();
                // insert hyperlink at the current cursor position
                if (view && fullPageEditorPresetAPIRef.current?.hyperlink?.actions?.insertLink) {
                    const { from: from } = view.state.selection;
                    const cmd = fullPageEditorPresetAPIRef.current.hyperlink.actions.insertLink((0, $d925B.INPUT_METHOD).TYPEAHEAD, from, from, fullUrl, undefined, fullUrl, true);
                    cmd(view.state, view.dispatch);
                }
                window.open(fullUrl, '_blank', 'noopener,noreferrer');
            };
            openSmartCreationModalBase({
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent,
                content: content,
                submitCallback: submitWithInsertLink
            });
        }
    }, [
        openSmartCreationModalBase,
        editorActions
    ]);
};









var $fWGpT = parcelRequire("fWGpT");


var $5Za2S = parcelRequire("5Za2S");


var $j7xMJ = parcelRequire("j7xMJ");


var $cLo2u = parcelRequire("cLo2u");


var $39rFu = parcelRequire("39rFu");


var $2VZOl = parcelRequire("2VZOl");





var $8KbKw = parcelRequire("8KbKw");

var $1sAC2 = parcelRequire("1sAC2");





var $ek3aD = parcelRequire("ek3aD");











var $iUV81 = parcelRequire("iUV81");


var $7PuC4 = parcelRequire("7PuC4");




















var $7sfG4 = parcelRequire("7sfG4");





var $2ZJmt = parcelRequire("2ZJmt");





var $9ohnn = parcelRequire("9ohnn");


var $16o3K = parcelRequire("16o3K");





var $dTb09 = parcelRequire("dTb09");







const $c907e804706c3ad7$export$34125ddc34657a7f = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('aifc_create_enabled'), (api)=>{
    const aiIsStreaming = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiExperience.isStreaming', {
        disabled: !api
    }) ?? false;
    return {
        aiIsStreaming: aiIsStreaming
    };
}, (_api)=>{
    return {
        aiIsStreaming: false
    };
});











const $3c299c6e2ce2bea1$export$31b32c1906537e24 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true), (api)=>{
    const hasUnsavedBodiedSyncBlockChanges = (0, $b3YrF.useSharedPluginStateSelector)(api, 'syncedBlock.hasUnsavedBodiedSyncBlockChanges', {
        disabled: !api
    }) ?? false;
    return {
        hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges
    };
}, (_api)=>{
    return {
        hasUnsavedBodiedSyncBlockChanges: false
    };
});


const $f8ea506e3a40865e$var$i18n = (0, $aXWIB.defineMessages)({
    lockoutMessage: {
        id: "full-page-editor.navigation-lockout-message",
        defaultMessage: "Changes made just now may not be saved."
    }
});
const $f8ea506e3a40865e$var$DEBOUNCE_TIMEOUT = 1000;
const $f8ea506e3a40865e$export$d85ed874af6294e9 = ({ contentId: contentId, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI })=>{
    const [unsavedChanges, setUnsavedChanges] = (0, $42omo.useState)(false);
    const [{ isDraftSyncPending: isDraftSyncPending }] = (0, $hYoU4.useNativeCollabDraftSync)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    const [{ isPageBeingRemoved: isPageBeingRemoved }] = (0, $7sfG4.usePageRemovalState)();
    const { hasEditorContentChangedByAnyUser: hasEditorContentChangedByAnyUser } = (0, $16o3K.useHasEditorContentChanged)({
        editorPresetAPI: editorPresetAPI
    });
    const { isCollabProviderConnected: isCollabProviderConnected } = (0, $9ohnn.useConnected)(collabEditProvider, contentId);
    /**
   * - Draft sync is handled by first participant, so leaving should not be prevented for subsequent participants
   * - Publishing is an exception because it handles syncing on its own before transition
   * - The editor content has to have changed for unsaved changes to exist
   * - Page removal is an exception because the page is being intentionally removed
   */ const isExceptionConditionMet = !isFirstParticipant || isPublishingContent || !hasEditorContentChangedByAnyUser || isPageBeingRemoved && (0, $6mKj3.expValEquals)('confluence_page_removal_nav_lockout_exception', 'isEnabled', true);
    const checkCollabProviderSteps = (0, $42omo.useCallback)(({ status: status })=>{
        if (!collabEditProvider || !collabEditInitialized) {
            setUnsavedChanges(false);
            return;
        }
        if (status === 'attempt' || status === 'success') {
            const unconfirmedSteps = collabEditProvider.getUnconfirmedSteps();
            setUnsavedChanges(!!(unconfirmedSteps && unconfirmedSteps.length > 0));
        } else // implies status === "failure"
        setUnsavedChanges(true);
    }, [
        collabEditProvider,
        collabEditInitialized
    ]);
    const debouncedCheckCollabProviderSteps = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(checkCollabProviderSteps, $f8ea506e3a40865e$var$DEBOUNCE_TIMEOUT), [
        checkCollabProviderSteps
    ]);
    // Collab provider commit listener
    (0, $42omo.useEffect)(()=>{
        if (isExceptionConditionMet || !collabEditProvider || !collabEditInitialized) {
            setUnsavedChanges(false);
            return;
        }
        collabEditProvider.on('commit-status', debouncedCheckCollabProviderSteps);
        return ()=>{
            collabEditProvider.off('commit-status', debouncedCheckCollabProviderSteps);
        };
    }, [
        collabEditProvider,
        collabEditInitialized,
        isExceptionConditionMet,
        debouncedCheckCollabProviderSteps
    ]);
    const [hasOfflineConflicts, setHasOfflineConflicts] = (0, $42omo.useState)(false);
    (0, $6qdjm.usePluginStateEffect)(editorPresetAPI, [
        'collabEdit',
        'connectivity',
        'conflictResolutionUI'
    ], ({ collabEditState: collabEditState, connectivityState: connectivityState, conflictResolutionUIState: conflictResolutionUIState })=>{
        if (!isCollabProviderConnected && !!collabEditState?.initialised?.lastLocalOrganicBodyChangeAt) setUnsavedChanges(!!collabEditProvider?.getUnconfirmedSteps()?.length);
        if ((0, $91bcx.isOfflineMode)(connectivityState?.mode)) setUnsavedChanges(!!collabEditProvider?.getUnconfirmedSteps()?.length);
        if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) {
            const hasConflicts = conflictResolutionUIState?.conflicts && (conflictResolutionUIState?.conflicts.inserted?.length > 0 || conflictResolutionUIState?.conflicts.deleted?.length > 0);
            if (hasConflicts) setHasOfflineConflicts(true);
            else if (hasOfflineConflicts && !hasConflicts) setHasOfflineConflicts(false);
        }
    });
    const { aiIsStreaming: aiIsStreaming } = (0, $c907e804706c3ad7$export$34125ddc34657a7f)(editorPresetAPI);
    const { hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges } = (0, $3c299c6e2ce2bea1$export$31b32c1906537e24)(editorPresetAPI);
    /*
   * unsavedChanges is an internal state controlled by listening to collab provider commmit events while isDraftSyncPending is a separate state controlled by draft sync hooks
   */ const shouldRenderLockout = unsavedChanges || isDraftSyncPending;
    return !isExceptionConditionMet && shouldRenderLockout || hasOfflineConflicts || aiIsStreaming || hasUnsavedBodiedSyncBlockChanges && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true);
};
const $f8ea506e3a40865e$export$28f25e906763db1e = ({ contentId: contentId, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // TODO do we want this in the hook or in this component?
    (0, $42omo.useEffect)(()=>{
        const deferIdle = (cb)=>{
            if ('requestIdleCallback' in window) requestIdleCallback(cb, {
                timeout: 5000
            });
            else requestAnimationFrame(cb);
        };
        // force load of NavigationLockout on idle so it's available if the
        // connection goes offline
        deferIdle(()=>{
            (0, $2ZJmt.NavigationLockout).preload();
        });
    }, []);
    const hasUnsavedChanges = $f8ea506e3a40865e$export$d85ed874af6294e9({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: editorPresetAPI
    });
    const isSeamlessTransition = (transitionCallbackIds)=>{
        return (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionCallbackIds.includes('live_doc_preloading_transition_callback_id') : false;
    };
    /**
   * We do not want to trigger the lockout if the upcoming location is the same route with the same contentId
   * If the above conditions are true, the user is still editing the page, but the url has changed
   * Which implies the user is not exiting the editor, so we shouldn't block navigation.
   */ const isSameRoute = (currentRoute, nextRoute)=>{
        const contentIdMatch = 'contentId' in nextRoute.params && nextRoute.params['contentId'] === contentId;
        const routeNameMatch = currentRoute.name === nextRoute.name;
        return contentIdMatch && routeNameMatch;
    };
    const isSafeTransition = ({ currentRoute: currentRoute, nextRoute: nextRoute, transitionCallbackIds: transitionCallbackIds })=>{
        return isSameRoute(currentRoute, nextRoute) || transitionCallbackIds && transitionCallbackIds.length > 0 && isSeamlessTransition(transitionCallbackIds);
    };
    return hasUnsavedChanges ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), {
        message: intl.formatMessage($f8ea506e3a40865e$var$i18n.lockoutMessage),
        isSafeTransition: isSafeTransition,
        onActivate: (message, currentRoute, nextRoute)=>{
            // message===true tells react-router not to block the transition.
            // We only want to fire an event when a transition was blocked, so we make sure message !== true
            if (message !== true) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'navigationLockoutPrompt',
                    action: 'shown',
                    source: 'NavigationLockout',
                    attributes: {
                        nextRoute: nextRoute?.name ?? '',
                        currentRoute: currentRoute?.name ?? '',
                        contentId: contentId
                    }
                }
            }).fire();
        }
    }) : null;
};


const $d2e739e403a90913$export$1da4922e40f79365 = ({ contentId: contentId, collabEditProvider: collabEditProvider, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI, isLivePage: isLivePage, hasEditPermission: hasEditPermission, isFastLoadedLiveDoc: isFastLoadedLiveDoc })=>{
    const hasUnsavedChanges = (0, $f8ea506e3a40865e$export$d85ed874af6294e9)({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: editorPresetAPI
    });
    // Create a promise that resolves when we're no longer waiting for unsaved changes. The latest promise will always be used by the transition callback when it's invoked, to ensure we don't transition until there are no unsaved changes.
    // Holds the resolve function for the current pending promise, so we can resolve it from the useEffect when hasUnsavedChanges becomes false.
    const isWaitingForUnsavedChangesPromiseResolveRef = (0, $42omo.useRef)(null);
    // Holds the promise itself, which the transition callback awaits. Resolved when there are no unsaved changes.
    const isWaitingForUnsavedChangesPromiseRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // Resolve the promise once hasUnsavedChanges is false if it didn't immediately resolve
        if (!hasUnsavedChanges && isWaitingForUnsavedChangesPromiseResolveRef.current) {
            isWaitingForUnsavedChangesPromiseResolveRef.current();
            isWaitingForUnsavedChangesPromiseResolveRef.current = null;
        }
        // Every time hasUnsavedChanges changes to true, we need to update
        // isWaitingForUnsavedChangesPromiseRef.current in order to ensure
        // we wait for these unsaved changes.
        // Without updating isWaitingForUnsavedChangesPromiseRef, the promise ref
        // may think there are no unsaved changes if `hasUnsavedChanges` was originally `false`
        // but has since changed to `true`.
        if (hasUnsavedChanges && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) isWaitingForUnsavedChangesPromiseRef.current = new Promise((resolve)=>{
            isWaitingForUnsavedChangesPromiseResolveRef.current = resolve;
        });
    }, [
        hasUnsavedChanges
    ]);
    if (!isWaitingForUnsavedChangesPromiseRef.current) isWaitingForUnsavedChangesPromiseRef.current = new Promise((resolve)=>{
        if (!hasUnsavedChanges) resolve();
        else isWaitingForUnsavedChangesPromiseResolveRef.current = resolve;
    });
    const { client: fetchUsersClient } = (0, $j7xMJ.useFetchUsersClient)();
    const { setCollabEditProvider: setCollabEditProvider, setHasInitialDraft: setHasInitialDraft, resetNativeCollabState: resetNativeCollabState } = (0, $hYoU4.useNativeCollabActions)();
    const { nativeEditorComponentsPreloader: nativeEditorComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const { userId: userId, cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $42omo.useRef)(presenceId);
    presenceIdRef.current = presenceId;
    const [isTransitionPreloading, setIsTransitionPreloading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage || !(0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) return;
        (0, $ek3aD.getGlobalTransitionPreloader)().registerTransitionCallback({
            id: 'live_doc_preloading_transition_callback_id',
            callback: ({ match: match })=>new Promise(async (resolve)=>{
                    setIsTransitionPreloading(true);
                    try {
                        if (match?.params?.contentId) {
                            // TODO When updating this preloading callback to run on non-livedoc routes as we transition into a live doc:
                            //      Also preload the live doc components. Reference how LivePagePreloader.tsx does this
                            // We destroy collab provider as early as possible to reduce the risk of rare race conditions where
                            //    we end up on a different page than expected after awaiting below promises, and then problematically destroy collab edit provider
                            if (collabEditProvider) {
                                collabEditProvider?.destroy?.();
                                // Clear the memoized function. If the user goes back to editing the same page,
                                // then we don't run into problem trying to talk to the old (destroyed) collab provider.
                                if ((0, $fWGpT.getCollabEditProvider)?.cache?.clear) (0, $fWGpT.getCollabEditProvider).cache.clear();
                            }
                            resetNativeCollabState();
                            (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
                            const preloadLivePageRoutePromise = (0, $iUV81.preloadLivePageRoute)(match, match.url);
                            await Promise.all([
                                preloadLivePageRoutePromise,
                                nativeEditorComponentsPreloader()
                            ]);
                            // Ensure we're not waiting for unsaved changes before unblocking transition
                            if (isWaitingForUnsavedChangesPromiseRef.current) await isWaitingForUnsavedChangesPromiseRef.current;
                        }
                    } catch (err) {
                        (0, $7W8i8.getLogger)('useLiveDocTransitionCallback').error`Error preloading live doc: ${err}`;
                    }
                    setIsTransitionPreloading(false);
                    resolve();
                }),
            onlyCalledIfFunc: ({ match: match })=>{
                // Don't seamlessly transition if the current live doc is not fast loaded, as non-fast-loaded -> fast-loaded live docs
                //   trigger a remount that breaks NCS on seamless transition
                if (match?.params?.contentId && isFastLoadedLiveDoc) {
                    const { subType: subType } = (0, $9sGCn.getCachedPageData)(match.params.contentId);
                    if (subType === 'live') return true;
                }
                return false;
            },
            onPerformanceMetricStart: ({ match: match })=>{
                if (match?.params?.contentId) (0, $7PuC4.startLivePageLoadMetrics)({
                    userId: userId ?? undefined
                });
            },
            onRouteContinueCallback: ({ match: match })=>new Promise(async (resolve)=>{
                    const nextContentId = match?.params?.contentId;
                    const { subType: subType } = (0, $9sGCn.getCachedPageData)(nextContentId);
                    if (subType !== 'live') return;
                    const draft = await (0, $5Za2S.getDraft)(nextContentId); // This is performant as it's already cached because our callback promise retrieved CollabDraftQuery in `preloadLivePageRoute`
                    const ncsProvider = (0, $fWGpT.getCollabEditProvider)({
                        contentId: nextContentId,
                        cloudId: cloudId,
                        activationId: activationId,
                        contentType: 'page',
                        permissionTokenRefresh: (0, $8KbKw.fetchCollabPermissionToken)(nextContentId, undefined),
                        initialDraft: draft,
                        isLivePage: true,
                        presenceId: presenceIdRef.current,
                        presenceActivity: hasEditPermission ? 'editor' : 'viewer',
                        userId: userId,
                        fetchUsersClient: fetchUsersClient
                    });
                    setCollabEditProvider(ncsProvider);
                    // @ts-ignore
                    const hasInitialDraft = Boolean(ncsProvider?.initialDraft);
                    setHasInitialDraft(hasInitialDraft);
                    resolve();
                })
        });
    }, [
        activationId,
        contentId,
        isLivePage,
        collabEditProvider,
        setCollabEditProvider,
        setHasInitialDraft,
        cloudId,
        nativeEditorComponentsPreloader,
        spaceKey,
        userId,
        hasEditPermission,
        presenceIdRef,
        fetchUsersClient,
        resetNativeCollabState,
        isFastLoadedLiveDoc
    ]);
    return {
        isTransitionPreloading: isTransitionPreloading
    };
};






var $fthpM = parcelRequire("fthpM");








var $1JdaQ = parcelRequire("1JdaQ");


var $7541v = parcelRequire("7541v");


















var $9uAPw = parcelRequire("9uAPw");




const $04e4e4b928c4520b$export$9ac42f814ec8d6c6 = ({ mentionChanges: mentionChanges, deletedMentions: deletedMentions, addedMentions: addedMentions, setDeletedMentions: setDeletedMentions, setAddedMentions: setAddedMentions, userId: userId, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, addedTasks: addedTasks, deletedTasks: deletedTasks, setAddedTasks: setAddedTasks, setDeletedTasks: setDeletedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded })=>{
    // Process added mentions first
    const addedMentionsExcludingCurrentUser = [];
    const addedTasksExcludingCurrentUser = [];
    const currentUserAddedMentions = []; // user mentioned themselves
    const currentUserAddedTasks = [];
    mentionChanges.forEach((mentionChange)=>{
        // we add user mentioning themselves so that we let backend know not to notify them
        if (mentionChange.id === userId) {
            if (mentionChange.type === 'added') {
                if (mentionChange?.taskLocalId) currentUserAddedTasks.push(mentionChange);
                else currentUserAddedMentions.push(mentionChange);
            }
        } else if (mentionChange.type === 'added') {
            if (mentionChange?.taskLocalId) addedTasksExcludingCurrentUser.push(mentionChange);
            else addedMentionsExcludingCurrentUser.push(mentionChange);
        }
    });
    if (currentUserAddedMentions.length > 0) setMentionsAdded({
        currentUser: currentUserAddedMentions
    });
    if (currentUserAddedTasks.length > 0) setTasksAdded({
        currentUser: currentUserAddedTasks
    });
    const currentAndNewAddedMentions = [
        ...addedMentions,
        ...addedMentionsExcludingCurrentUser
    ];
    const currentAndNewAddedTasks = [
        ...addedTasks,
        ...addedTasksExcludingCurrentUser
    ];
    if (addedMentionsExcludingCurrentUser.length > 0) setAddedMentions(currentAndNewAddedMentions);
    if (addedTasksExcludingCurrentUser.length > 0) setAddedTasks(currentAndNewAddedTasks);
    const currentAddedMentionsLocalIds = new Set([
        ...unrestrictedMentions.map((mention)=>mention.localId),
        ...parentSpaceRestrictedMentions.map((mention)=>mention.localId),
        ...pageRestrictedMentions.map((mention)=>mention.localId)
    ]);
    const currentAddedTasksLocalIds = new Set([
        ...unrestrictedTasks.map((mention)=>mention.localId),
        ...parentSpaceRestrictedTasks.map((mention)=>mention.localId),
        ...pageRestrictedTasks.map((mention)=>mention.localId)
    ]);
    // Process deleted mentions next, but only if they exist in the added mentions
    const validDeletedMentions = [];
    const validDeletedTasks = [];
    mentionChanges.forEach((mentionChange)=>{
        if (mentionChange.id !== userId) {
            if (mentionChange.type === 'deleted') {
                if (currentAddedMentionsLocalIds.has(mentionChange.localId)) validDeletedMentions.push(mentionChange);
                else if (currentAddedTasksLocalIds.has(mentionChange.localId)) validDeletedTasks.push(mentionChange);
            }
        }
    });
    if (validDeletedMentions.length > 0) setDeletedMentions([
        ...deletedMentions,
        ...validDeletedMentions
    ]);
    if (validDeletedTasks.length > 0) setDeletedTasks([
        ...deletedTasks,
        ...validDeletedTasks
    ]);
};



var $aWwYt = parcelRequire("aWwYt");





var $9Zt9E = parcelRequire("9Zt9E");


var $3GtBN = parcelRequire("3GtBN");


var $ijGoX = parcelRequire("ijGoX");


var $bDgLc = parcelRequire("bDgLc");








var $yuV6Z = parcelRequire("yuV6Z");







function $78d13d0c9995dbf8$export$7274b8e5fdf0c8bf() {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $42omo.useMemo)(()=>{
        return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn
    ]);
    const emojiNodeDataProvider = (0, $32x2E.getEmojiNodeDataProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (emojiNodeDataProvider) {
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData['emojiNodeDataProvider'];
        emojiNodeDataProvider.setSSRData(ssrData);
    }
    return emojiNodeDataProvider;
}
























var $jdPfT = parcelRequire("jdPfT");


var $gj7hi = parcelRequire("gj7hi");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $9fBoq = parcelRequire("9fBoq");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");


var $2Awp2 = parcelRequire("2Awp2");




























var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");





var $ep3mz = parcelRequire("ep3mz");


var $6uUjl = parcelRequire("6uUjl");


var $lsxnT = parcelRequire("lsxnT");













// I'm optimizing for single byline as most instances have an average of 2 - 3 apps in the byline and shouldn't be multiline
const $b54e9ea534ca36ea$var$PAGE_PADDING_TOP = 135; // Rough estimate for cover picture avg height - doesn't need to be exact since the popup will float in editor
const $b54e9ea534ca36ea$var$COVER_PICTURE_PADDING_TOP = 275;
const $b54e9ea534ca36ea$var$popupWrapperStyle = (0, $ecnYn.xcss)({
    padding: 'space.250',
    maxWidth: '500px',
    maxHeight: '500px'
});
const $b54e9ea534ca36ea$var$triggerStyles = null;
const $b54e9ea534ca36ea$export$8b1e2d0f3ad73269 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { contentId: contentId, forgeExtension: forgeExtension, onClose: onClose, selection: selection } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== forgeExtension?.appId || $[3] !== forgeExtension?.appOwner || $[4] !== forgeExtension?.appVersion || $[5] !== forgeExtension?.id || $[6] !== forgeExtension?.key || $[7] !== isLivePage) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: "editorActionsToolbarMenu",
                    action: "shown",
                    actionSubject: "forgeApp",
                    actionSubjectId: "editorActionsMenuForgeApp",
                    attributes: {
                        contentId: contentId,
                        isLivePage: isLivePage,
                        appInfo: {
                            id: forgeExtension?.id,
                            appId: forgeExtension?.appId,
                            key: forgeExtension?.key,
                            appVersion: forgeExtension?.appVersion,
                            appOwner: forgeExtension?.appOwner
                        }
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = forgeExtension?.appId;
        $[3] = forgeExtension?.appOwner;
        $[4] = forgeExtension?.appVersion;
        $[5] = forgeExtension?.id;
        $[6] = forgeExtension?.key;
        $[7] = isLivePage;
        $[8] = t2;
    } else t2 = $[8];
    const handleInitialRender = t2;
    let t3;
    if ($[9] !== onClose) {
        t3 = (0, $9wGTI.fg)("platform-forge-ui-remove-redundant-onclose") ? {
            close: onClose
        } : {
            onClose: onClose,
            close: onClose
        };
        $[9] = onClose;
        $[10] = t3;
    } else t3 = $[10];
    const memoedBridge = t3;
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            (0, $i5zxs.CoverPictureStateContainer)
        ];
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== Popup || $[13] !== contentId || $[14] !== forgeExtension || $[15] !== handleInitialRender || $[16] !== isLivePage || $[17] !== memoedBridge || $[18] !== onClose || $[19] !== routeName || $[20] !== selection.coords.bottom || $[21] !== selection.coords.left || $[22] !== selection.coords.right || $[23] !== selection.coords.top || $[24] !== selection.text || $[25] !== spaceId || $[26] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t4
        }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $b54e9ea534ca36ea$var$popupWrapperStyle,
                        testId: "forge-editor-popup-content"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContextMenuForgeApp), {
                        app: forgeExtension,
                        extensionData: {
                            type: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
                            selectedText: selection.text,
                            content: {
                                id: contentId || "",
                                type: (0, $hIaUw.getContentType)(routeName),
                                subtype: isLivePage ? "live" : null
                            },
                            space: {
                                key: spaceKey,
                                id: spaceId
                            }
                        },
                        onInitialRender: handleInitialRender,
                        onTearDown: onClose,
                        bridge: memoedBridge
                    }))),
                trigger: (t6)=>{
                    const { ref: ref } = t6;
                    const sideNavWidth = document.getElementById("side-navigation")?.offsetWidth || 0;
                    const leftCoords = selection.coords.left - sideNavWidth;
                    const topCoords = coverPictureState.state.hasCoverPicture ? selection.coords.top + $b54e9ea534ca36ea$var$COVER_PICTURE_PADDING_TOP - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP : selection.coords.top - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                        "data-testid": "forge-editor-action-selection",
                        ref: ref,
                        style: {
                            top: topCoords,
                            left: leftCoords,
                            width: selection.coords.right - selection.coords.left,
                            height: selection.coords.bottom - selection.coords.top
                        },
                        className: (0, $gMc0m.default)([
                            "_kqswstnw _lcxvglyw"
                        ])
                    });
                },
                isOpen: true,
                placement: "bottom"
            }));
        $[12] = Popup;
        $[13] = contentId;
        $[14] = forgeExtension;
        $[15] = handleInitialRender;
        $[16] = isLivePage;
        $[17] = memoedBridge;
        $[18] = onClose;
        $[19] = routeName;
        $[20] = selection.coords.bottom;
        $[21] = selection.coords.left;
        $[22] = selection.coords.right;
        $[23] = selection.coords.top;
        $[24] = selection.text;
        $[25] = spaceId;
        $[26] = spaceKey;
        $[27] = t5;
    } else t5 = $[27];
    return t5;
} : ({ contentId: contentId, forgeExtension: forgeExtension, onClose: onClose, selection: selection })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleInitialRender = ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'editorActionsToolbarMenu',
                action: 'shown',
                actionSubject: 'forgeApp',
                actionSubjectId: 'editorActionsMenuForgeApp',
                attributes: {
                    contentId: contentId,
                    isLivePage: isLivePage,
                    appInfo: {
                        id: forgeExtension?.id,
                        appId: forgeExtension?.appId,
                        key: forgeExtension?.key,
                        appVersion: forgeExtension?.appVersion,
                        appOwner: forgeExtension?.appOwner
                    }
                }
            }
        }).fire();
    };
    // Bridge needs to be memoised here.
    // Otherwise the useMemo hook in NativeUIRenderer will trigger an infinite rerender loop on ContextMenuForgeApp when using the Frame component.
    const memoedBridge = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('platform-forge-ui-remove-redundant-onclose') ? {
            close: onClose
        } : {
            onClose: onClose,
            close: onClose
        }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $b54e9ea534ca36ea$var$popupWrapperStyle,
                    testId: "forge-editor-popup-content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContextMenuForgeApp), {
                    app: forgeExtension,
                    extensionData: {
                        type: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
                        selectedText: selection.text,
                        content: {
                            id: contentId || '',
                            type: (0, $hIaUw.getContentType)(routeName),
                            subtype: isLivePage ? 'live' : null
                        },
                        space: {
                            key: spaceKey,
                            id: spaceId
                        }
                    },
                    onInitialRender: handleInitialRender,
                    onTearDown: onClose,
                    bridge: memoedBridge
                }))),
            trigger: ({ ref: ref })=>{
                // Adjust left position based on if side nav is open or not - it will push the content too left if we don't check
                const sideNavWidth = document.getElementById('side-navigation')?.offsetWidth || 0;
                const leftCoords = selection.coords.left - sideNavWidth; // Adjust top position based on if cover picture is present or not - it will be too high otherwise
                const topCoords = coverPictureState.state.hasCoverPicture ? selection.coords.top + $b54e9ea534ca36ea$var$COVER_PICTURE_PADDING_TOP - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP : selection.coords.top - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    "data-testid": "forge-editor-action-selection",
                    ref: ref,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning based on selection coordinates
                        top: topCoords,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning based on selection coordinates
                        left: leftCoords,
                        width: selection.coords.right - selection.coords.left,
                        height: selection.coords.bottom - selection.coords.top
                    },
                    className: (0, $gMc0m.default)([
                        "_kqswstnw _lcxvglyw"
                    ])
                });
            },
            isOpen: true,
            placement: "bottom"
        }));
};


const $263e225aef982cc6$var$iconImageStyle = null; // Need this to satisfy the toolbar extension API which expects a label prop type
const $263e225aef982cc6$var$ImageIcon = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { label: label, src: src } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== label || $[2] !== src) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: src,
            alt: label,
            className: t1
        }));
        $[1] = label;
        $[2] = src;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ label: label, src: src })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: src,
        alt: label,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg"
        ])
    }));
const $263e225aef982cc6$export$a3c406cbb96a0e18 = (contentId, shouldFetch = false)=>{
    // Need ref since these are fetched and updated asynchronously so the API uses a ref to track this
    const extensionsRef = (0, $42omo.useRef)([]); // Forge items
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
        queryOptions: {
            fetchPolicy: 'cache-first'
        },
        skipQuery: !shouldFetch
    });
    // Connect items
    const { webItems: webItems } = (0, $6ld6a.useWebItemLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ACTION_PANEL),
        skipQuery: !shouldFetch
    });
    const filteredWebItems = webItems.filter((item)=>!(0, $2Awp2.DROPDOWN_EXCLUDED_ITEMS).includes(item.completeKey || ''));
    const connectItems = filteredWebItems.map((item_0)=>({
            label: item_0?.label,
            icon: item_0?.icon?.path ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($263e225aef982cc6$var$ImageIcon, {
                    label: item_0?.label || '',
                    src: item_0?.icon?.path
                }) : (0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))),
            onClick: ()=>{
                if (item_0?.url) window.open(item_0.url, '_blank');
            }
        }));
    const forgeItems = extensions.map((extension)=>({
            label: (0, $9fBoq.extensionTitle)(extension),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))),
            contentComponent: ({ selection: selection, closeExtension: closeExtension })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b54e9ea534ca36ea$export$8b1e2d0f3ad73269), {
                    key: extension.key,
                    contentId: contentId,
                    forgeExtension: extension,
                    onClose: closeExtension,
                    selection: selection
                });
            }
        }));
    extensionsRef.current = [
        ...connectItems,
        ...forgeItems
    ];
    return [
        {
            key: 'external-extensions',
            source: 'external',
            inlineToolbar: {
                getMenuItems: ()=>{
                    return [
                        ...extensionsRef.current
                    ];
                }
            }
        }
    ];
};









var $2qVkt = parcelRequire("2qVkt");





var $1mDVg = parcelRequire("1mDVg");

parcelRequire("aiS08");
var $1L1jV = parcelRequire("1L1jV");










const $304811a46258dbff$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    singleCreateWorkItemName: {
        id: "jira-work-create-extension.single-create-work-item.name",
        defaultMessage: "Create Jira work item"
    },
    // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
    // New message with updated wording. To clean up: remove old message and feature flag check when flag is removed.
    singleCreateWorkItemNameUpdated: {
        id: "jira-work-create-extension.single-create-work-item.name.updated",
        defaultMessage: "Jira work item"
    },
    bulkCreateWorkItemName: {
        id: "jira-work-create-extension.bulk-create-work-item.name",
        defaultMessage: "Create Jira work items"
    },
    // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
    // New message with updated wording. To clean up: remove old message and feature flag check when flag is removed.
    bulkCreateWorkItemNameUpdated: {
        id: "jira-work-create-extension.bulk-create-work-item.name.updated",
        defaultMessage: "Jira work items"
    }
});



var $aUTn5 = parcelRequire("aUTn5");


var $UNr39 = parcelRequire("UNr39");


var $3TWPv = parcelRequire("3TWPv");

const $7a3ce11c17355349$export$5e8df502ba998c83 = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, isActionItemInSelection: isActionItemInSelection, pageMode: pageMode, editorAPI: editorAPI })=>{
    if (!contentId) return;
    if (editorAPI !== null && editorAPI !== undefined) {
        actions.setEditorAPI(editorAPI);
        const selectionResult = editorAPI.selectionExtension?.actions?.getSelectionAdf?.();
        actions.setSelectedAdf(selectionResult?.selectedNodeAdf ?? undefined);
    }
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        selectionAdfResult: selectionAdfResult,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
};
const $7a3ce11c17355349$export$494c35a67fd7a49e = ({ rightSidebarContext: rightSidebarContext, actions: actions, editorAPI: editorAPI })=>{
    if (editorAPI !== null && editorAPI !== undefined) actions.setEditorAPI(editorAPI);
    rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
};


const $dc24c60db4dc9ba4$var$WorkItemCreationType = {
    SINGLE_WORK_ITEM: 'SINGLE_ISSUE',
    MULTIPLE_WORK_ITEM: 'MULTIPLE_ISSUE',
    AI_WORK_ITEM: 'AI_ISSUE'
};
const $dc24c60db4dc9ba4$export$d32eae3898223fdf = ({ rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireCreateWorkItemButtonClickedAnalytics = (0, $42omo.useCallback)((workItemCreationType, isCreatedFromTable)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: workItemCreationType,
                    // Set to false because a dropdown or flyout is not implemented at this entry point.
                    // TODO: Update this value if a dropdown or flyout is added in the future.
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    pageMode: pageModeRef.current,
                    hasEditPermission: hasEditPermissionRef.current
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageModeRef,
        hasEditPermissionRef
    ]);
    const handleSingleCreateClick = (0, $42omo.useCallback)(async ()=>{
        actions.setHasEditPermission(hasEditPermissionRef.current);
        const activeSelection = window.getSelection();
        const container = document.querySelector('div#ak-editor-textarea');
        fireCreateWorkItemButtonClickedAnalytics($dc24c60db4dc9ba4$var$WorkItemCreationType.SINGLE_WORK_ITEM, // Set to false because bulk creation from the table is not yet available at this entry point.
        // TODO: Update this value if bulk creation functionality is added in the future.
        false);
        (0, $7a3ce11c17355349$export$5e8df502ba998c83)({
            activeSelection: activeSelection,
            container: container,
            contentId: contentId,
            contentType: contentType,
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            pageMode: pageModeRef.current,
            editorAPI: undefined
        });
    }, [
        fireCreateWorkItemButtonClickedAnalytics,
        contentId,
        contentType,
        rightSidebarContextRef,
        actions,
        pageModeRef,
        hasEditPermissionRef
    ]);
    // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
    // Changes wording from "Create Jira work item" to "Jira work item" for conciseness.
    // To clean up: remove conditional, keep only the updated message.
    const label = (0, $9wGTI.fg)('platform_editor_block_menu_v2_patch_3') ? (0, $304811a46258dbff$export$defe85febe8b728c).singleCreateWorkItemNameUpdated : (0, $304811a46258dbff$export$defe85febe8b728c).singleCreateWorkItemName;
    return {
        name: formatMessage(label),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        onClick: ()=>{
            handleSingleCreateClick();
        },
        isDisabled: ()=>{
            const currentSidebar = rightSidebarContextRef?.current?.getCurrent();
            return currentSidebar?.panelId === (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID);
        }
    };
};












var $7ZcJJ = parcelRequire("7ZcJJ");










parcelRequire("aiS08");















var $2ViZo = parcelRequire("2ViZo");


var $hq2Sz = parcelRequire("hq2Sz");


var $cSSgB = parcelRequire("cSSgB");



const $a8cc1d5c0eec455b$export$ccdc6b8dc23bf978 = (editorAPI)=>{
    if (!editorAPI?.selectionExtension?.actions?.getSelectionAdf) return false;
    const selectionResult = editorAPI.selectionExtension.actions.getSelectionAdf();
    // Determine if multiple table rows are selected
    return selectionResult?.selectedNodeAdf?.type === 'table' && !!selectionResult?.selectionRanges && selectionResult.selectionRanges.length > 1;
};


const $8055735e114abbc3$var$WorkItemCreationType = {
    SINGLE_WORK_ITEM: 'SINGLE_ISSUE',
    MULTIPLE_WORK_ITEM: 'MULTIPLE_ISSUE',
    AI_WORK_ITEM: 'AI_ISSUE'
};
const $8055735e114abbc3$export$f0c80e15dd78dd09 = ({ rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef, editorAPIRef: editorAPIRef })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const actions = (0, $1mDVg.useIssueCreateSidePanelActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const lastModified = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    const setSelectedTableAdf = (0, $hq2Sz.useSetSelectedTableAdf)();
    const fireCreateWorkItemButtonClickedAnalytics = (0, $42omo.useCallback)((workItemCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: workItemCreationType,
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    pageMode: pageModeRef.current,
                    hasEditPermission: hasEditPermissionRef.current
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageModeRef,
        hasEditPermissionRef
    ]);
    const initializeCreateState = (0, $42omo.useCallback)(()=>{
        actions.setHasEditPermission(hasEditPermissionRef.current);
        const activeSelection = window.getSelection();
        const selectionAdfResult = editorAPIRef.current?.selectionExtension?.actions?.getSelectionAdf?.();
        const container = document.querySelector('div#ak-editor-textarea');
        return {
            activeSelection: activeSelection,
            selectionAdfResult: selectionAdfResult,
            container: container
        };
    }, [
        actions,
        hasEditPermissionRef,
        editorAPIRef
    ]);
    const handleSingleCreateClick = (0, $42omo.useCallback)(()=>{
        const { activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, container: container } = initializeCreateState();
        const actionItemSelectionIfPresent = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection, pageModeRef.current);
        fireCreateWorkItemButtonClickedAnalytics($8055735e114abbc3$var$WorkItemCreationType.SINGLE_WORK_ITEM, false, !!actionItemSelectionIfPresent);
        (0, $7a3ce11c17355349$export$5e8df502ba998c83)({
            activeSelection: activeSelection,
            container: container,
            contentId: contentId,
            contentType: contentType,
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            isActionItemInSelection: !!actionItemSelectionIfPresent,
            pageMode: pageModeRef.current,
            editorAPI: editorAPIRef.current,
            selectionAdfResult: selectionAdfResult
        });
    }, [
        initializeCreateState,
        contentId,
        actions,
        pageModeRef,
        rightSidebarContextRef,
        fireCreateWorkItemButtonClickedAnalytics,
        contentType,
        editorAPIRef
    ]);
    const handleBulkCreateClick = (0, $42omo.useCallback)(()=>{
        const { activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, container: container } = initializeCreateState();
        if (!contentId) //We'd always expect a contentId to be returned from the page context.
        //In the unexpected case where it is not, the button press will be a no-op and the user can try clicking again,
        //upon which the contentId should hopefully be populated.
        return;
        const result = (0, $2ViZo.prepareBulkCreateFromSelection)({
            actions: actions,
            activeSelection: activeSelection,
            contentId: contentId,
            container: container,
            lastModified: lastModified,
            pageMode: pageModeRef.current,
            hasEditPermission: hasEditPermissionRef.current,
            setIsCreatedFromTable: setIsCreatedFromTable,
            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat,
            selectionAdfResult: selectionAdfResult
        });
        if (result === (0, $2ViZo.BulkSelectionResult).Table) {
            const tableAdf = selectionAdfResult?.selectedNodeAdf;
            setSelectedTableAdf(tableAdf ?? undefined);
        }
        if (result === (0, $2ViZo.BulkSelectionResult).None) {
            //In the unexpected case where the selection cannot be prepared for bulk create, we fall back to the single create experience
            handleSingleCreateClick();
            return;
        }
        fireCreateWorkItemButtonClickedAnalytics($8055735e114abbc3$var$WorkItemCreationType.MULTIPLE_WORK_ITEM, result === (0, $2ViZo.BulkSelectionResult).Table, result === (0, $2ViZo.BulkSelectionResult).ActionItems);
        (0, $7a3ce11c17355349$export$494c35a67fd7a49e)({
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            editorAPI: editorAPIRef.current
        });
    }, [
        initializeCreateState,
        actions,
        contentId,
        lastModified,
        pageModeRef,
        hasEditPermissionRef,
        rightSidebarContextRef,
        setIsCreatedFromTable,
        setIsCreatedFromActionItems,
        setSelectedTableAdf,
        editorAPIRef,
        handleSingleCreateClick,
        fireCreateWorkItemButtonClickedAnalytics
    ]);
    if (!(0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) return [];
    const getMenuItemsFactory = (keyPrefix)=>()=>{
            const currentSidebar = rightSidebarContextRef?.current?.getCurrent();
            const isDisabled = currentSidebar?.panelId === (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID) || currentSidebar?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
            // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
            // Changes wording from "Create Jira work item(s)" to "Jira work item(s)" for conciseness.
            // To clean up: remove conditional, keep only the updated message.
            const bulkLabel = (0, $9wGTI.fg)('platform_editor_block_menu_v2_patch_3') ? (0, $304811a46258dbff$export$defe85febe8b728c).bulkCreateWorkItemNameUpdated : (0, $304811a46258dbff$export$defe85febe8b728c).bulkCreateWorkItemName;
            const singleLabel = (0, $9wGTI.fg)('platform_editor_block_menu_v2_patch_3') ? (0, $304811a46258dbff$export$defe85febe8b728c).singleCreateWorkItemNameUpdated : (0, $304811a46258dbff$export$defe85febe8b728c).singleCreateWorkItemName;
            const makeBulkCreateMenuItem = ()=>({
                    key: `${keyPrefix}-bulk-create`,
                    label: formatMessage(bulkLabel),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))),
                    onClick: ()=>handleBulkCreateClick(),
                    isDisabled: isDisabled
                });
            const makeSingleCreateMenuItem = ()=>({
                    key: `${keyPrefix}-single-create`,
                    label: formatMessage(singleLabel),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
                    onClick: ()=>handleSingleCreateClick(),
                    isDisabled: isDisabled
                });
            return (0, $a8cc1d5c0eec455b$export$ccdc6b8dc23bf978)(editorAPIRef?.current) ? [
                makeBulkCreateMenuItem()
            ] : [
                makeSingleCreateMenuItem()
            ];
        };
    const blockMenuConfiguration = {
        getMenuItems: getMenuItemsFactory('jira-work-create-block-menu')
    };
    const toolbarConfiguration = {
        getMenuItems: getMenuItemsFactory('jira-work-create-toolbar')
    };
    return [
        {
            key: 'jira-work-create',
            source: 'first-party',
            inlineToolbar: toolbarConfiguration,
            ...(0, $9wGTI.fg)('confluence-editor-jira-work-create-block-menu') ? {
                blockMenu: blockMenuConfiguration
            } : {}
        }
    ];
};











const $35edf49399d0e0f7$var$hasMeaningfulSelection = (selectionState, editorApi)=>{
    const selection = selectionState?.selection ?? editorApi?.selection?.sharedState?.currentState?.()?.selection;
    return Boolean(selection && !selection.empty);
};
const $35edf49399d0e0f7$export$f3934d75c6e134b7 = ({ contentId: contentId, isEnabled: isEnabled, editorAPIRef: editorAPIRef })=>{
    const [shouldFetchExternalExtensions, setShouldFetchExternalExtensions] = (0, $42omo.useState)(false);
    const [subscriptionRetryCount, setSubscriptionRetryCount] = (0, $42omo.useState)(0);
    const previousContentIdRef = (0, $42omo.useRef)(contentId);
    const previousIsEnabledRef = (0, $42omo.useRef)(isEnabled);
    // Reset the fetch gate when contentId or isEnabled changes (e.g. page transition).
    // This allows the query to run once after first selection on the new page.
    (0, $42omo.useEffect)(()=>{
        if (previousContentIdRef.current !== contentId || previousIsEnabledRef.current !== isEnabled) {
            setShouldFetchExternalExtensions(false);
            previousContentIdRef.current = contentId;
            previousIsEnabledRef.current = isEnabled;
        }
    }, [
        contentId,
        isEnabled
    ]);
    // Wait for editor API, then set the fetch gate to true once: either immediately if there is
    // already a meaningful selection, or on first selection change. Early-return when the gate is
    // already true so repeated selections do not re-fire the external extensions query.
    (0, $42omo.useEffect)(()=>{
        if (!isEnabled || shouldFetchExternalExtensions) return;
        const resolvedEditorApi = editorAPIRef.current;
        if (!resolvedEditorApi) {
            // The editor ref can still be null/undefined while the editor is mounting, so we retry on
            // the next tick to give the ref a chance to be populated and the selection subscription to attach.
            const retryTimer = setTimeout(()=>{
                setSubscriptionRetryCount((currentRetryCount)=>currentRetryCount + 1);
            }, 0);
            return ()=>{
                clearTimeout(retryTimer);
            };
        }
        if ($35edf49399d0e0f7$var$hasMeaningfulSelection(undefined, resolvedEditorApi)) {
            setShouldFetchExternalExtensions(true);
            return;
        }
        // Return the unsubscribe from onChange so React runs it on cleanup (unmount or deps change).
        return resolvedEditorApi.selection?.sharedState?.onChange?.(({ nextSharedState: nextSharedState })=>{
            if ($35edf49399d0e0f7$var$hasMeaningfulSelection(nextSharedState, resolvedEditorApi)) setShouldFetchExternalExtensions(true);
        });
    }, [
        editorAPIRef,
        contentId,
        isEnabled,
        shouldFetchExternalExtensions,
        subscriptionRetryCount
    ]);
    return shouldFetchExternalExtensions;
};












var $lpGuF = parcelRequire("lpGuF");


var $dMbwP = parcelRequire("dMbwP");




const $e9e6a29a0deabfc6$export$1a972864ed9252e6 = (0, $aXWIB.defineMessages)({
    successTitle: {
        id: "highlight-actions.trello.create.success",
        defaultMessage: "Trello card created"
    },
    errorTitle: {
        id: "highlight-actions.trello.create.error",
        defaultMessage: "Couldn't create Trello card. Try again later."
    },
    openCard: {
        id: "highlight-actions.trello.openCard",
        defaultMessage: "Open card"
    }
});



var $9ujb2 = parcelRequire("9ujb2");

const $32f76a2196ddc2ab$var$messages = (0, $aXWIB.defineMessages)({
    menuItemLabel: {
        id: "editor-features.trello-inbox.create-card",
        defaultMessage: "Send to your Trello Inbox"
    }
});
const $32f76a2196ddc2ab$var$handleCreateTrelloCard = async (contentId, flags, formatMessage)=>{
    if (!flags) return;
    try {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) return;
        const selectedText = selection.toString().trim();
        if (!selectedText) return;
        const result = await (0, $lpGuF.createTrelloCardHandle)({
            text: selectedText,
            contentId: contentId
        });
        if (result?.cardUrl) {
            const titleNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).successTitle));
            flags.showFlag({
                id: `trello-inbox-create-success-${Date.now()}`,
                title: titleNode,
                appearance: 'success',
                actions: [
                    {
                        content: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).openCard),
                        href: result.cardUrl,
                        target: '_blank'
                    }
                ]
            });
        } else flags.showFlag({
            id: `trello-inbox-create-error-${Date.now()}`,
            title: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).errorTitle),
            appearance: 'error'
        });
    } catch  {
        flags.showFlag({
            id: `trello-inbox-create-error-${Date.now()}`,
            title: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).errorTitle),
            appearance: 'error'
        });
    }
};
const $32f76a2196ddc2ab$export$b4751a4560935df = (contentId, _editorAPIRef, flags)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { hasTrelloAccess: hasTrelloAccess, loading: loading } = (0, $9ujb2.useTrelloAccess)();
    const accessRef = (0, $42omo.useRef)({
        hasTrelloAccess: hasTrelloAccess,
        loading: loading
    });
    accessRef.current = {
        hasTrelloAccess: hasTrelloAccess,
        loading: loading
    };
    return {
        key: 'trello-inbox',
        source: 'first-party',
        inlineToolbar: {
            getMenuItems: ()=>{
                if (!flags || accessRef.current.loading || !accessRef.current.hasTrelloAccess) return [];
                const label = formatMessage($32f76a2196ddc2ab$var$messages.menuItemLabel);
                return [
                    {
                        label: label,
                        icon: (0, $dMbwP.TrelloInboxIcon),
                        onClick: ()=>$32f76a2196ddc2ab$var$handleCreateTrelloCard(contentId || '', flags, formatMessage)
                    }
                ];
            }
        }
    };
};


const $0826d4545dd61f1d$export$69326c9b91111e89 = ({ isSidePanelOpenRef: isSidePanelOpenRef, rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef, contentId: contentId, editorAPIRef: editorAPIRef, flags: flags, snippetExtensionList: snippetExtensionList = [] })=>{
    const jiraWorkCreateSelectionExtension = (0, $dc24c60db4dc9ba4$export$d32eae3898223fdf)({
        isSidePanelOpenRef: isSidePanelOpenRef,
        rightSidebarContextRef: rightSidebarContextRef,
        pageModeRef: pageModeRef,
        hasEditPermissionRef: hasEditPermissionRef
    });
    const jiraWorkCreateExtensionV2 = (0, $8055735e114abbc3$export$f0c80e15dd78dd09)({
        rightSidebarContextRef: rightSidebarContextRef,
        pageModeRef: pageModeRef,
        hasEditPermissionRef: hasEditPermissionRef,
        editorAPIRef: editorAPIRef
    });
    // Read without auto-exposure and fire exposure once so we can inline at both call sites (linter) without double exposure.
    (0, $42omo.useEffect)(()=>{
        (0, $6mKj3.manuallyLogExpExposure)('confluence_enable_2p_toolbar_apps');
    }, []);
    const shouldFetchExternalExtensions = (0, $35edf49399d0e0f7$export$f3934d75c6e134b7)({
        contentId: contentId,
        isEnabled: (0, $6mKj3.UNSAFE_expValNoExposure)('confluence_enable_2p_toolbar_apps', 'isEnabled', false),
        editorAPIRef: editorAPIRef
    });
    const useExternalExtensionsWithContentId = ()=>(0, $263e225aef982cc6$export$a3c406cbb96a0e18)(contentId, shouldFetchExternalExtensions);
    const useConditionalExternalExtensions = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.UNSAFE_expValNoExposure)('confluence_enable_2p_toolbar_apps', 'isEnabled', false), useExternalExtensionsWithContentId, ()=>[]);
    const externalExtensions = useConditionalExternalExtensions();
    const useTrelloExtensionWithArgs = ()=>[
            (0, $32f76a2196ddc2ab$export$b4751a4560935df)(contentId, editorAPIRef, flags)
        ];
    const useConditionalTrelloExtension = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('quick_capture_trello_inbox'), useTrelloExtensionWithArgs, ()=>[]);
    const trelloExtensionList = useConditionalTrelloExtension();
    const jiraWorkCreateExtensionList = (0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false) ? jiraWorkCreateExtensionV2 : [];
    const extensionList = [
        ...snippetExtensionList,
        ...externalExtensions,
        ...jiraWorkCreateExtensionList,
        ...trelloExtensionList
    ];
    return {
        extensions: (0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false) ? {} : {
            firstParty: [
                jiraWorkCreateSelectionExtension
            ]
        },
        extensionList: extensionList
    };
};






var $ai7NK = parcelRequire("ai7NK");




const $9d48445854f70eb8$export$8b02a744327cd19 = (viewMode, isLivePage, hasEditPermission)=>{
    if (isLivePage) {
        if (viewMode === 'edit' && hasEditPermission) return (0, $1mDVg.PageMode).LIVE_EDIT;
        return (0, $1mDVg.PageMode).LIVE_VIEW;
    }
    if (viewMode === 'edit' && hasEditPermission) return (0, $1mDVg.PageMode).EDIT;
    return (0, $1mDVg.PageMode).VIEW;
};



var $jln20 = parcelRequire("jln20");


var $a37Yb = parcelRequire("a37Yb");


var $jO6sX = parcelRequire("jO6sX");








var $8TW6I = parcelRequire("8TW6I");


var $2pBiX = parcelRequire("2pBiX");


var $4R3wx = parcelRequire("4R3wx");


var $hMfsx = parcelRequire("hMfsx");


var $8Q0mA = parcelRequire("8Q0mA");


var $6T0Pj = parcelRequire("6T0Pj");


var $5i3ci = parcelRequire("5i3ci");










const $6c1b58cebd0e5cea$var$ENTRYPOINT_ID = 'loom-confluence-page-editor-toolbar';
const $6c1b58cebd0e5cea$var$SOURCE_COMPONENT = 'loomConfluencePageEditorToolbar';
const $6c1b58cebd0e5cea$var$SOURCE_CONTEXT = 'confluencePageEditorToolbarRecordAVideo';
const $6c1b58cebd0e5cea$var$i18n = (0, $aXWIB.defineMessages)({
    crossSellPopupCardDescription: {
        id: "editor-presets.full-page-editor.crossSellPopupCardDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough of this page."
    },
    crossSellPopupCardTitle: {
        id: "editor-presets.full-page-editor.crossSellPopupCardTitle",
        defaultMessage: "Share your work with video"
    }
});
const $6c1b58cebd0e5cea$var$EditorLoomButtonComponent = ({ buttonComponent: ButtonComponent, flags: flags })=>{
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expVal)('platform_editor_toolbar_aifc_confluence', 'isEnabled', false);
    const intl = (0, $aXWIB.useIntl)();
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)({
        flags: flags
    });
    if (entryPointVariant === 'BETA' || isNewToolbarEnabled && entryPointVariant === 'CO_USE') // Fall back to the plugin's default behavior when in a recorder-eligible state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
        onClickBeforeInit: loomEntryPointErrorCallback
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
        isDisabled: true
    });
    if (entryPointVariant === 'CROSS_FLOW') {
        if (isNewToolbarEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMfsx.CrossFlowMenuItem), {
            buttonComponent: ButtonComponent,
            sourceActionSubjectId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            sourceComponent: $6c1b58cebd0e5cea$var$SOURCE_COMPONENT,
            sourceContext: $6c1b58cebd0e5cea$var$SOURCE_CONTEXT
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T0Pj.LoomCrossFlowPopupCard), {
            description: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardDescription),
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            placement: "bottom-end",
            spotlightPlacement: "bottom-start",
            // Render in a Portal to isolate from conflicts caused by editor-based CSS + keyboard & focus behavior
            shouldRenderToParent: false,
            sourceActionSubjectId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            sourceComponent: $6c1b58cebd0e5cea$var$SOURCE_COMPONENT,
            sourceContext: $6c1b58cebd0e5cea$var$SOURCE_CONTEXT,
            title: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardTitle),
            trigger: ({ isSelected: isSelected, onClick: onClick, ...otherTriggerProps })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
                    onClickBeforeInit: onClick,
                    selected: isSelected,
                    ...otherTriggerProps
                }));
            }
        });
    }
    if (entryPointVariant === 'CROSS_JOIN') {
        if (isNewToolbarEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMfsx.CrossJoinMenuItem), {
            buttonComponent: ButtonComponent,
            sourceActionSubjectId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
            description: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardDescription),
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            placement: "bottom-end",
            // Render in a Portal to isolate from conflicts caused by editor-based CSS + keyboard & focus behavior
            shouldRenderToParent: false,
            sourceActionSubjectId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            title: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardTitle),
            triggerLink: (href, { onClick: onClick, ...otherTriggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
                    ...otherTriggerProps,
                    href: href,
                    onClickBeforeInit: onClick,
                    rel: "noreferrer",
                    target: "_blank"
                })),
            flags: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? flags : undefined
        });
    }
    if (entryPointVariant === 'CO_USE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, null);
    return null;
};
const $6c1b58cebd0e5cea$export$6aeb215a2a3b0ff0 = (0, $7aRa9.withFlags)($6c1b58cebd0e5cea$var$EditorLoomButtonComponent);



var $diJQD = parcelRequire("diJQD");

/**
 * @generated SignedSource<<149715b98439b2d02f34aff3a62ed6da>>
 * @relayHash 5a1d2a8721165ce24041feea77ad6191
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 493421411c87b8da0a902f2fd0fdaf1aa02d7a6c53b445cd55daa0b7d60b52cd
const $536f6d43a856cca5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "parentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAppend",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMauiMoveMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMauiMoveMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5a1d2a8721165ce24041feea77ad6191",
            "id": "493421411c87b8da0a902f2fd0fdaf1aa02d7a6c53b445cd55daa0b7d60b52cd",
            "metadata": {},
            "name": "useMauiMoveMutation",
            "operationKind": "mutation",
            "text": "mutation useMauiMoveMutation($pageId:ID!,$parentId:ID!){movePageAppend(input:{pageId:$pageId,parentId:$parentId}){page{id,links{webui,editui}}}}"
        }
    };
}();
$536f6d43a856cca5$var$node.hash = "842e5a7eb645f50ae941c352d1aa0834";
var $536f6d43a856cca5$export$2e2bcd8739ae039 = $536f6d43a856cca5$var$node;


/**
 * @generated SignedSource<<c636e51b59fb539e368961128f607bde>>
 * @relayHash b6049b445825365ddab1e4c53fe645b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5885f319bdb44acd258139bdd3bf49e62421b9eea5c5941f6ce559adf0e60c1
const $781229575c51b3d0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "targetSpaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageTopLevel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMauiMoveTopLevelMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMauiMoveTopLevelMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b6049b445825365ddab1e4c53fe645b5",
            "id": "e5885f319bdb44acd258139bdd3bf49e62421b9eea5c5941f6ce559adf0e60c1",
            "metadata": {},
            "name": "useMauiMoveTopLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useMauiMoveTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id,links{webui,editui}}}}"
        }
    };
}();
$781229575c51b3d0$var$node.hash = "40a91a5003b294a2f81375f46e2a6f63";
var $781229575c51b3d0$export$2e2bcd8739ae039 = $781229575c51b3d0$var$node;









var $Yuf8j = parcelRequire("Yuf8j");

function $5a41b21aa32f6f22$export$89a6bfbee9f0e814(targetSpaceKey, cloudId) {
    const [commitMoveTopLevel] = (0, $308Wd.useMutationInterop)((0, $781229575c51b3d0$export$2e2bcd8739ae039));
    const [commitMoveAppend] = (0, $308Wd.useMutationInterop)((0, $536f6d43a856cca5$export$2e2bcd8739ae039));
    const moveWhiteboardToPage = (0, $42omo.useCallback)(async (whiteboardContentId, targetParentPageId)=>{
        if (!targetSpaceKey) throw new Error('Target space key is not available.');
        // Step 1: Move whiteboard to the top level of the target space.
        // This avoids the "only space admins can move content to another space"
        // permission error that movePageAppend alone would throw for cross-space moves.
        const topLevelResult = await commitMoveTopLevel({
            variables: {
                pageId: whiteboardContentId,
                spaceKey: targetSpaceKey
            }
        });
        if (!topLevelResult.data?.movePageTopLevel?.page) throw new Error("We couldn't move this diagram to your page. It won't be visible to other users until it's moved out of its temporary space.");
        // Step 2: Reparent whiteboard under the target page (now within the same space).
        const appendResult = await commitMoveAppend({
            variables: {
                pageId: whiteboardContentId,
                parentId: targetParentPageId
            }
        });
        if (!appendResult.data?.movePageAppend?.page) throw new Error("We couldn't move this diagram to your page. It won't be visible to other users until it's moved out of its temporary space.");
    }, [
        commitMoveAppend,
        commitMoveTopLevel,
        targetSpaceKey
    ]);
    const duplicateMauiApp = (0, $42omo.useCallback)((appId, containerContentId)=>{
        return (0, $Yuf8j.duplicateMauiApp)(appId, containerContentId, cloudId);
    }, [
        cloudId
    ]);
    return {
        moveWhiteboardToPage: moveWhiteboardToPage,
        duplicateMauiApp: duplicateMauiApp
    };
}


function $9661ce7f5a08c58b$export$2272e89b7d3ccec0(props) {
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar, hideObjectSidebarByPanelId: hideObjectSidebarByPanelId } = (0, $aWwYt.useObjectSidebarActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const { userId: userId, cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const [{ deletedMentions: deletedMentions, addedMentions: addedMentions, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, addedTasks: addedTasks, deletedTasks: deletedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks }, { setDeletedMentions: setDeletedMentions, setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks, setDeletedTasks: setDeletedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded }] = (0, $hdxAi.useMentionsNotifications)();
    const [mentionChanges, setMentionChanges] = (0, $42omo.useState)([]);
    const previousEditorProps = (0, $7541v.default)(props);
    const isClassicMentionsNotificationsEnrolled = (0, $9747c27e818a1963$export$a9e17b56b1093c49)();
    const isLivePageRef = (0, $42omo.useRef)(isLivePage);
    isLivePageRef.current = isLivePage;
    const getCurrentIsLivePage = (0, $42omo.useCallback)(()=>{
        return isLivePageRef.current;
    }, []);
    const { confluenceEditorPreferencesProvider: confluenceEditorPreferencesProvider, editorPreferencesProvider: editorPreferencesProvider } = (0, $jO6sX.useEditorPreferencesProvider)({
        getCurrentIsLivePage: getCurrentIsLivePage
    });
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isSidePanelOpenRef = (0, $42omo.useRef)(isSidePanelOpen);
    isSidePanelOpenRef.current = isSidePanelOpen;
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const rightSidebarContextRef = (0, $42omo.useRef)(rightSidebarContext);
    rightSidebarContextRef.current = rightSidebarContext;
    const hasEditPermission = props.hasEditPermission || false;
    const hasEditPermissionRef = (0, $42omo.useRef)(hasEditPermission);
    hasEditPermissionRef.current = hasEditPermission;
    const pageMode = (0, $9d48445854f70eb8$export$8b02a744327cd19)(props.viewMode, props.__livePage, props.hasEditPermission);
    const pageModeRef = (0, $42omo.useRef)(pageMode);
    pageModeRef.current = pageMode;
    (0, $42omo.useEffect)(()=>{
        const isMentionNotificationsEnabled = isLivePage || !isLivePage && isClassicMentionsNotificationsEnrolled;
        if (mentionChanges.length && isMentionNotificationsEnabled) {
            (0, $04e4e4b928c4520b$export$9ac42f814ec8d6c6)({
                mentionChanges: mentionChanges,
                deletedMentions: deletedMentions,
                addedMentions: addedMentions,
                setDeletedMentions: setDeletedMentions,
                setAddedMentions: setAddedMentions,
                userId: userId,
                unrestrictedMentions: unrestrictedMentions,
                parentSpaceRestrictedMentions: parentSpaceRestrictedMentions,
                pageRestrictedMentions: pageRestrictedMentions,
                unrestrictedTasks: unrestrictedTasks,
                addedTasks: addedTasks,
                deletedTasks: deletedTasks,
                setAddedTasks: setAddedTasks,
                setDeletedTasks: setDeletedTasks,
                pageRestrictedTasks: pageRestrictedTasks,
                parentSpaceRestrictedTasks: parentSpaceRestrictedTasks,
                setMentionsAdded: setMentionsAdded,
                setTasksAdded: setTasksAdded
            });
            setMentionChanges([]);
        }
    // We only need to trigger the handler function when mentionChanges gets updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionChanges
    ]);
    const editorAPIRef = (0, $42omo.useRef)(null);
    const { isPluginEnabled: isLoomPluginEnabled, pluginOptions: loomPluginOptions } = (0, $9Zt9E.useLoomPluginOptions)({
        EditorButtonComponent: (0, $6c1b58cebd0e5cea$export$6aeb215a2a3b0ff0),
        editorAPIRef: editorAPIRef,
        // [ED-27497] IMPORTANT: If you change the code below, please also update the
        // platform/packages/editor/editor-presets-confluence/src/presets/full-page/loomPluginOptions.ts
        ...(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? {
            editorShouldShowToolbarLoomButton: false
        } : {}
    });
    const { pluginOptions: trackChangesPluginOptions } = (0, $a37Yb.useTrackChangesPlugin)({
        editorAPIRef: editorAPIRef
    });
    const { moveWhiteboardToPage: moveWhiteboardToPage, duplicateMauiApp: duplicateMauiApp } = (0, $5a41b21aa32f6f22$export$89a6bfbee9f0e814)(props.spaceKey, cloudId);
    const { config: editorEngagementPlatformPluginConfig } = (0, $ijGoX.useEditorEngagementPlatform)();
    const editorPluginAIDefinitionsEnabled = (0, $bDgLc.useEditorPluginAIDefinitionsEnabled)();
    const editorPluginAIDefinitionsConfig = (0, $bDgLc.useEditorPluginAIDefinitionsConfig)();
    const selectionExtensionPluginOptions = (0, $0826d4545dd61f1d$export$69326c9b91111e89)({
        isSidePanelOpenRef: isSidePanelOpenRef,
        rightSidebarContextRef: rightSidebarContextRef,
        pageModeRef: pageModeRef,
        hasEditPermissionRef: hasEditPermissionRef,
        contentId: props.contentId,
        editorAPIRef: editorAPIRef,
        flags: props.flags,
        snippetExtensionList: props.snippetExtensionList
    });
    const limitedModePluginOptions = {
        contentId: props.contentId,
        showFlag: props.flags.showFlag,
        killSwitchEnabled: (0, $4VJDS.default).isKillSwitchOn('cc_editor_perf_mode_kill_switch')
    };
    const intl = (0, $aXWIB.useIntl)();
    const emojiNodeDataProvider = (0, $78d13d0c9995dbf8$export$7274b8e5fdf0c8bf)();
    const presetFunction = (0, $42omo.useCallback)(()=>{
        const { __livePage: __livePage, __rendererExtensionOptions: __rendererExtensionOptions, allowFindReplace: allowFindReplace, annotationProviders: annotationProviders, appearance: appearance, autoformattingProvider: autoformattingProvider, editorPluginAIOptions: editorPluginAIOptions, collabEdit: collabEdit, contextIdentifierProvider: contextIdentifierProvider, elementBrowser: elementBrowser, emojiProvider: emojiProvider, extensionHandlers: extensionHandlers, getExtensionHeight: getExtensionHeight, getHeadingLinkPath: getHeadingLinkPath, hasRequestedEditPermission: hasRequestedEditPermission, isAIEnabledForContent: isAIEnabledForContent, linking: linking, media: media, mention: mention, mentionProvider: mentionProvider, quickInsert: quickInsert, referentialityContext: referentialityContext, requestToEditContent: requestToEditContent, taskDecisionProvider: taskDecisionProvider, viewMode: viewMode, disabled: disabled, blockLinkHashPrefix: blockLinkHashPrefix, showDiffPluginParams: showDiffPluginParams, syncedBlockProvider: syncedBlockProvider, syncedBlockEventHandlers: syncedBlockEventHandlers, disableFloatingToolbar: disableFloatingToolbar, disableToolbar: disableToolbar, contentId: contentId, spaceKey: spaceKey, contentMode: contentMode } = props;
        // IMPORTANT: Don't add spread operator (`...props`) here because it will make impossible to
        //            understand which props are used in the preset.
        const presetOptions = {
            __isRemixHidden: props.__isRemixHidden,
            // @ts-expect-error — property should be __isRovoLLMEnabled in CreateFullPageEditorPresetProps
            __isRovoLLMEnabled: props.__isRovoLLMEnabled,
            __remixDisabledReason: props.__remixDisabledReason,
            __livePage: __livePage,
            __rendererExtensionOptions: __rendererExtensionOptions,
            allowFindReplace: allowFindReplace,
            annotationProviders: annotationProviders,
            appearance: appearance,
            autoformattingProvider: autoformattingProvider,
            collabEdit: collabEdit,
            contextIdentifierProvider: contextIdentifierProvider,
            contextPanelOptions: {
                objectSideBar: {
                    showPanel: showObjectSidebar,
                    closePanel: hideObjectSidebar,
                    closePanelById: hideObjectSidebarByPanelId
                }
            },
            contentId: contentId,
            spaceKey: spaceKey,
            contentMode: contentMode,
            editorEngagementPlatformPluginConfig: editorEngagementPlatformPluginConfig,
            editorPluginAIDefinitionsConfig: editorPluginAIDefinitionsConfig,
            editorPluginAIDefinitionsEnabled: editorPluginAIDefinitionsEnabled,
            editorPluginAIOptions: editorPluginAIOptions,
            elementBrowser: elementBrowser,
            emojiProvider: emojiProvider,
            emojiNodeDataProvider: emojiNodeDataProvider,
            extensionHandlers: extensionHandlers,
            flags: props.flags,
            getExtensionHeight: getExtensionHeight,
            getHeadingLinkPath: getHeadingLinkPath,
            handleMentionsChanged: (changes)=>{
                if (changes.length) setMentionChanges(changes);
            },
            currentUserId: userId || undefined,
            hasEditPermission: props.hasEditPermission,
            hasRequestedEditPermission: hasRequestedEditPermission,
            intl: intl,
            isAIEnabledForContent: isAIEnabledForContent,
            isCompanyHub: props.isCompanyHub || false,
            isDesktop: isDesktop,
            isLoomPluginEnabled: isLoomPluginEnabled,
            limitedModePluginOptions: limitedModePluginOptions,
            linking: linking,
            loomPluginOptions: loomPluginOptions,
            media: media,
            mention: mention,
            mentionProvider: mentionProvider,
            prevAppearance: previousEditorProps?.appearance,
            quickInsert: quickInsert,
            referentialityContext: referentialityContext,
            requestToEditContent: requestToEditContent,
            selectionExtensionPluginOptions: selectionExtensionPluginOptions,
            taskDecisionProvider: taskDecisionProvider,
            userPreferencesProvider: confluenceEditorPreferencesProvider,
            userPreferencesProviderNext: editorPreferencesProvider,
            viewMode: viewMode,
            contextualFormattingEnabled: props.contextualFormattingEnabled,
            disabled: disabled,
            blockLinkHashPrefix: blockLinkHashPrefix,
            showDiffPluginParams: showDiffPluginParams,
            syncedBlockProvider: syncedBlockProvider,
            syncedBlockEventHandlers: syncedBlockEventHandlers,
            disableFloatingToolbar: disableFloatingToolbar,
            disableToolbar: disableToolbar,
            trackChangesPluginOptions: trackChangesPluginOptions,
            isEmbeddedConfluence: props.isEmbeddedConfluence ?? false,
            moveWhiteboardToPage: moveWhiteboardToPage,
            duplicateMauiApp: duplicateMauiApp,
            isRovoLLMEnabled: isRovoLLMEnabled
        };
        return (0, $diJQD.createFullPageEditorPreset)(presetOptions);
    // The dependency array should mirror the dependencies we pass to usePreset.
    // Refactor this to only use one usePreset when cleaning up confluence_frontend_transition_preloading_system FG
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.appearance,
        props.contentId
    ]);
    const { preset: presetStandard, editorApi: editorApiStandard } = (0, $1JdaQ.usePreset)(presetFunction, [
        // WARNING: Adding this dependency array causes the editor plugins to all recreate
        // This can be very expensive. Be very careful adding to this, avoid if possible!
        // Generally we can update props via their plugin APIs (see `placeholder` as an example)
        // update preset based on props change, originally from packages/editor/editor-core/src/create-editor/preset-utils.ts
        // persistScrollGutter not used, allowUndoRedoButtons and sanitizePrivateContent always true
        props.appearance
    ]);
    const { preset: presetSmootherTransitionsFG, editorApi: editorApiSmootherTransitionsFG } = (0, $1JdaQ.usePreset)(presetFunction, [
        props.appearance,
        props.contentId
    ]);
    const isPresetRerunningOnTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLivePage;
    const editorApi = isPresetRerunningOnTransition ? editorApiSmootherTransitionsFG : editorApiStandard;
    const preset = isPresetRerunningOnTransition ? presetSmootherTransitionsFG : presetStandard;
    (0, $42omo.useEffect)(()=>{
        editorApi?.core?.actions.execute(editorApi?.placeholder?.commands.setPlaceholder(props.placeholder ?? ''));
    }, [
        editorApi,
        props.placeholder
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) editorApi?.media?.actions.setProvider(props.media?.provider);
    }, [
        editorApi,
        props.media?.provider
    ]);
    const { setEditorAPI: setEditorAPI } = props;
    (0, $42omo.useEffect)(()=>{
        if (!setEditorAPI) return;
        editorAPIRef.current = editorApi;
        setEditorAPI(editorApi);
    }, [
        editorApi,
        setEditorAPI
    ]);
    (0, $42omo.useEffect)(()=>{
        if (props.viewMode === undefined) return;
        editorApi?.core?.actions?.execute(editorApi?.editorViewMode?.commands?.updateViewMode(props.viewMode));
    }, [
        props.viewMode,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        editorApi?.core?.actions?.execute(editorApi?.taskDecision?.commands?.updateEditPermission(props.hasEditPermission));
    }, [
        props.hasEditPermission,
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        editorApi?.core?.actions?.execute(editorApi?.taskDecision?.commands?.updateHasRequestedEditPermission(props.hasRequestedEditPermission || false));
    }, [
        props.hasRequestedEditPermission,
        editorApi
    ]);
    // Register callback to capture limited mode status in INSM events
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc_editor_limited_mode_expanded', 'isEnabled', true)) return;
        if (editorApi && (0, $2v1PW.insm).session) (0, $2v1PW.insm).session.addProperties(()=>({
                limitedModeEnabled: editorApi?.limitedMode?.sharedState.currentState()?.enabled ?? false
            }));
    }, [
        editorApi
    ]);
    const { openLoomRecorder: openLoomRecorder } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        flags: props.flags,
        entryPointLocation: 'editor-toolbar',
        resetInsertFunctionOnUnmount: true
    });
    const loomProviderConfig = (0, $42omo.useMemo)(()=>({
            openLoomRecorder: openLoomRecorder
        }), [
        openLoomRecorder
    ]);
    (0, $3GtBN.useInitializeLoomPlugin)({
        loomPlugin: editorApi?.loom,
        providerConfig: loomProviderConfig
    });
    return preset;
}








const $639a5b7d5146574b$var$hydrationContainerStyles = {
    height: '100%'
};
function $639a5b7d5146574b$export$3b07c6dfbdf7e5bd({ ...props }) {
    const fullPagePreset = (0, $9661ce7f5a08c58b$export$2272e89b7d3ccec0)({
        appearance: props.appearance,
        featureFlags: props.featureFlags,
        onSave: props.onSave,
        linking: props.linking,
        contextIdentifierProvider: props.contextIdentifierProvider,
        media: props.media,
        placeholder: props.placeholder,
        collabEdit: props.collabEdit,
        primaryToolbarComponents: props.primaryToolbarComponents,
        waitForMediaUpload: props.waitForMediaUpload,
        mention: props.mention,
        allowFindReplace: props.allowFindReplace,
        allowExtension: props.allowExtension,
        extensionHandlers: props.extensionHandlers,
        referentialityContext: props.referentialityContext,
        emojiProvider: props.emojiProvider,
        mentionProvider: props.mentionProvider,
        annotationProviders: props.annotationProviders,
        autoformattingProvider: props.autoformattingProvider,
        taskDecisionProvider: props.taskDecisionProvider,
        editorPluginAIOptions: props.editorPluginAIOptions,
        aiGlobalOptIn: props.aiGlobalOptIn,
        editorPluginAIFeedbackHandlers: props.editorPluginAIFeedbackHandlers,
        elementBrowser: props.elementBrowser,
        setEditorAPI: props.setEditorAPI,
        viewMode: props.viewMode,
        hasEditPermission: props.hasEditPermission,
        requestToEditContent: props.requestToEditContent,
        hasRequestedEditPermission: props.hasRequestedEditPermission,
        getHeadingLinkPath: props.getHeadingLinkPath,
        __rendererExtensionOptions: props.__rendererExtensionOptions,
        __isRemixHidden: props.__isRemixHidden,
        __isRovoLLMEnabled: props.__isRovoLLMEnabled,
        __remixDisabledReason: props.__remixDisabledReason,
        __livePage: props.__livePage,
        flags: props.flags,
        quickInsert: props.quickInsert,
        contextPanelOptions: props.contextPanelOptions,
        spaceId: props.spaceId,
        spaceKey: props.spaceKey,
        contentId: props.contentId,
        isAIEnabledForContent: props.isAIEnabledForContent,
        getExtensionHeight: props.getExtensionHeight,
        collabEditProvider: props.collabEditProvider,
        disabled: props.disabled,
        contextualFormattingEnabled: !!props.showEmbeddedModernHeader,
        isCompanyHub: props.isCompanyHub,
        syncedBlockProvider: props.syncedBlockProvider,
        contentMode: props.contentMode,
        snippetExtensionList: props.snippetExtensionList,
        syncedBlockEventHandlers: props.syncedBlockEventHandlers,
        isEmbeddedConfluence: props.isEmbeddedConfluence
    });
    const editorProps = {
        preset: fullPagePreset,
        defaultValue: props.defaultValue,
        disabled: props.disabled,
        // Providers
        mentionProvider: props.mentionProvider,
        contextIdentifierProvider: props.contextIdentifierProvider,
        searchProvider: props.searchProvider,
        activityProvider: props.activityProvider,
        annotationProviders: props.annotationProviders,
        collabEditProvider: props.collabEditProvider,
        collabEdit: props.collabEdit,
        extensionProviders: props.extensionProviders,
        // Other props
        shouldFocus: props.shouldFocus,
        quickInsert: props.quickInsert,
        secondaryToolbarComponents: props.secondaryToolbarComponents,
        featureFlags: props.featureFlags,
        primaryToolbarComponents: props.primaryToolbarComponents,
        contextPanel: props.contextPanel,
        contentComponents: props.contentComponents,
        primaryToolbarIconBefore: props.primaryToolbarIconBefore,
        sanitizePrivateContent: props.sanitizePrivateContent,
        __livePage: props.__livePage,
        // Callbacks
        // @ts-expect-error - We don't allow `EditorView` to be passed in the new API
        onChange: props.onChange,
        onEditorReady: props.onEditorReady,
        onSSRMeasure: props.onSSRMeasure,
        appearance: props.appearance,
        contentMode: props.contentMode,
        getExtensionHeight: props.getExtensionHeight
    };
    if ((0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fthpM.FullPageEditor), editorProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "full-page-editor",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $639a5b7d5146574b$var$hydrationContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fthpM.FullPageEditor), editorProps));
}






var $cauOq = parcelRequire("cauOq");

var $7WFax = parcelRequire("7WFax");


var $hQDqA = parcelRequire("hQDqA");








var $i4dNk = parcelRequire("i4dNk");




const $022566d7a48da434$export$4d07d1c131526670 = ({ contentId: contentId, version: version, spaceKey: spaceKey, editorApi: editorApi, isContentCreationPanelOpen: isContentCreationPanelOpen, isShowingOfflineBanner: isShowingOfflineBanner, editorActions: editorActions, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, handleTitleChange: handleTitleChange })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isInCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { areBannersHidden: areBannersHidden } = (0, $i4dNk.useCfind4473CreationFocusedNav)(); // simplify the nav for D0 experience
    /**
	 * Editor Help Center conflicts with the OnboardingEditorBanner and should be suppressed when the banner is shown
	 * The banner has queries that need to fully resolve before the banner knows if it should render itself
	 * To prevent the help center from flashing on the screen, we hide it until the banner queries and logic are complete
	 *
	 * Since we don't render the OnboardingEditorBanner on live pages, loaded state should always be true for live pages to render the Help Manager.
	 */ const [isOnboardingBannerDataLoaded, setIsOnboardingBannerDataLoaded] = (0, $42omo.useState)(isLivePage);
    const [isHelpMenuOpen, setIsHelpMenuOpen] = (0, $42omo.useState)(false);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const openHelpDialog = ()=>{
        editorApi?.helpDialog?.actions.openHelp();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !areBannersHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7WFax.HelpWidget), {
        contentId: contentId,
        openHelpDialog: openHelpDialog,
        isNCSEditor: true,
        isCompanyHub: isCompanyHub,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isOpen: isHelpMenuOpen,
        setIsOpen: setIsHelpMenuOpen
    }), isOnboardingBannerDataLoaded && !(0, $6mKj3.expVal)('cc_fd_help_center_no_changeboarding', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cauOq.EditorHelpCenter), {
        contentId: contentId,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isCompanyHub: isCompanyHub,
        setIsOpen: setIsHelpMenuOpen
    }), !isLivePage && !isInCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hQDqA.OnboardingEditorBanner), {
        contentId: contentId,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isShowingOfflineBanner: isShowingOfflineBanner,
        version: version,
        spaceKey: spaceKey,
        editorActions: editorActions,
        setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        handleTitleChange: handleTitleChange
    })) : null);
};






var $9WAeG = parcelRequire("9WAeG");

/**
 * Handler for recording SSR measurements in confluence.
 * This is the SSR implementation that writes to SSRMeasures.
 */ function $1fcefd278c33801b$var$recordSSRMeasureImpl(measure) {
    if (!(0, $9wGTI.fg)('platform_editor_better_editor_ssr_spans')) return;
    // Only record on server-side and during SSR
    (0, $9WAeG.SSRMeasures).addMeasureWithData(measure.segmentName, {
        startTime: measure.startTimestamp,
        duration: measure.endTimestamp - measure.startTimestamp
    });
}
/**
 * No-op handler for client builds.
 * This version does nothing and is tree-shakeable.
 */ function $1fcefd278c33801b$var$recordSSRMeasureNoOp() {
// No-op on client
}
const $1fcefd278c33801b$export$5dc6b08aaa4bcf54 = $1fcefd278c33801b$var$recordSSRMeasureNoOp;


const $9b9cd112fc8297b9$export$2319941692274211 = 'editor.content.placeholder.11';
const $9b9cd112fc8297b9$export$f7109619a5e9e0d6 = 'next-FullPageEditorComponent';
const $9b9cd112fc8297b9$export$b7b0d81eceb7980e = 'editor.content.placeholder.easy.mentions';
const $9b9cd112fc8297b9$export$a86989c71e454d74 = 'Type / for all elements or @ to mention someone.';
const $9b9cd112fc8297b9$export$7f03b831e2e40b16 = 'editor.content.placeholder.ai';
const $9b9cd112fc8297b9$export$b24394dc8739ac79 = 'editor.content.placeholder.controls';
const $9b9cd112fc8297b9$export$6a44b93c4f739392 = "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we\u2019ll let them know).";
const $9b9cd112fc8297b9$export$e57dbc13424cb25a = 'Select + or type / to insert elements';


/* eslint-disable check-file/filename-blocklist */ 


const $48dba10f6de5f65d$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    placeholderBracketHint: {
        id: "full-page-editor.place.holder.bracket.hint",
        defaultMessage: "Any element can be quickly inserted by typing /"
    },
    blogpostPermissionsNotice: {
        id: "full-page-editor.permissions.blogpost-access",
        defaultMessage: "Default access to this blog is now in effect."
    },
    editorEmptyDocumentPlaceholder: {
        id: "full-page-editor.content.placeholder.empty.doc",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "full-page-editor.content.placeholder.empty.doc.ai",
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "full-page-editor.content.placeholder.space-shortcut",
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    commentLinkNotFoundFlagTitle: {
        id: "full-page-editor.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "full-page-editor.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    },
    commentRemovedByRovoTitle: {
        id: "full-page-editor.rovo.removed.flag.title",
        defaultMessage: "Comments deleted"
    },
    commentRemovedByRovoDescription: {
        id: "full-page-editor.rovo.removed.flag.description",
        defaultMessage: "One or more comments were deleted in your latest edit with Rovo."
    },
    commentRemovedByRovoViewCommentCTA: {
        id: "full-page-editor.rovo.removed.flag.cta.view-comment",
        defaultMessage: "Go to comment"
    }
});









var $9VJDA = parcelRequire("9VJDA");





var $j0gZR = parcelRequire("j0gZR");




const $8dcb77f48242281e$var$i18n = (0, $aXWIB.defineMessages)({
    fallbackFlagTitle: {
        id: "full-page-editor.unsupported-macro.fallback-flag.title",
        defaultMessage: "This element may require you to publish"
    },
    fallbackFlagDescription: {
        id: "full-page-editor.unsupported-macro.fallback-flag.description",
        defaultMessage: "To fully display and use this element, publish your page via the <menuIcon></menuIcon> menu on the toolbar."
    },
    fallbackFlagLivePageDescription: {
        id: "full-page-editor.unsupported-macro.fallback-flag.live-page.description",
        defaultMessage: "The results of this element aren\u2019t visible when editing a live doc. Convert this doc to a page and publish it via the <menuIcon></menuIcon> menu to display it fully."
    },
    fallbackFlagLearnMoreAction: {
        id: "full-page-editor.unsupported-macro.fallback-flag.action",
        defaultMessage: "Learn more about this EAP"
    }
});
const $8dcb77f48242281e$export$210750141a74fdf7 = (flags, isLivePage)=>{
    const intl = (0, $aXWIB.useIntl)();
    const macroFallbackUiAllowlist = (0, $42omo.useMemo)(()=>{
        const allowlist = (0, $4VJDS.default).getStringList('confluence_frontend_macro_fallback_ui_allowlist', []);
        return allowlist.map((m)=>m.trim().toLowerCase());
    }, []);
    const showMacroFallbackFlag = (0, $42omo.useCallback)(async ({ macro: macro, isBodiedExtension: isBodiedExtension })=>{
        if (!macroFallbackUiAllowlist || !macro || !isLivePage || macroFallbackUiAllowlist[0] === 'allow_all') return;
        const macroKey = macro.toLowerCase();
        const is2PNonBodied = !(0, $j0gZR.is1PMacro)(macroKey) && !isBodiedExtension;
        if (is2PNonBodied || isBodiedExtension) return;
        // If macro is in the allowlist don't show the warning
        if (macroFallbackUiAllowlist.includes(macroKey)) return;
        await flags.showFlag({
            type: 'warning',
            close: 'auto',
            title: intl.formatMessage($8dcb77f48242281e$var$i18n.fallbackFlagTitle),
            description: intl.formatMessage(isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $8dcb77f48242281e$var$i18n.fallbackFlagLivePageDescription : $8dcb77f48242281e$var$i18n.fallbackFlagDescription, {
                menuIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "Icon for publish menu"
                    })
            }),
            messageType: 'transactional',
            messageId: 'editor-macro-fallback-flag'
        });
    }, [
        flags,
        macroFallbackUiAllowlist,
        intl,
        isLivePage
    ]);
    return {
        showMacroFallbackFlag: showMacroFallbackFlag
    };
};



var $eLnQS = parcelRequire("eLnQS");









var $7vJCW = parcelRequire("7vJCW");


var $5RPbY = parcelRequire("5RPbY");


var $fY437 = parcelRequire("fY437");


var $9iTNj = parcelRequire("9iTNj");












var $gjEAi = parcelRequire("gjEAi");



var $38qvz = parcelRequire("38qvz");








var $bMPhU = parcelRequire("bMPhU");




const $08a4a4f0ffa330f8$export$4907a23e9e92d796 = ({ contentId: contentId, cloudId: cloudId, linkCreation: linkCreation, focusEditor: focusEditor, onFocusChanged: onFocusChanged, debounceOnChange: debounceOnChange, userOffline: userOffline, templateSuggestionsRef: templateSuggestionsRef, templateButtonRef: templateButtonRef, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, version: version, isEditorEmpty: isEditorEmpty, editorApi: editorApi, editorSessionId: editorSessionId, isSeamlessTransitionInProgress: isSeamlessTransitionInProgress = false, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, customPlaceholderOverride: customPlaceholderOverride })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const { collabEditState: collabEditState, contentType: contentType, shouldRenderPreview: shouldRenderPreview, isPublishingContent: isPublishingContent, isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey } = (0, $6b433f129bb94645$export$87f05b83083ffee2)();
    const { contentComponentsTitle: contentComponentsTitle, contentComponentsDisabled: contentComponentsDisabled, isDraftLockedForEditing: isDraftLockedForEditing, handleTitleChange: handleTitleChange, breadcrumbsClickHandler: breadcrumbsClickHandler } = (0, $82bb8752b1a17b39$export$69a815b52f63537)();
    const { isKnowledgeBaseSpace: isKnowledgeBaseSpace } = (0, $38qvz.useSpaceType)({
        spaceKey: spaceKey
    });
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const isSpaceOverview = homepageId === contentId;
    const transitionId = (0, $dPJCf.useTransitionId)();
    const isInitialLoad = !transitionId;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const ssrOrInitial = isInitialLoad && window.__SSR_RENDERED__;
    // For Live Pages, title component doesn't send metadata to NCS via client websocket message broadcast, hence is not dependent on collab being connected
    const disableTitleAsNotConnected = contentComponentsDisabled || !isLivePage && !collabEditConnected;
    const isTitleDisabled = !ssrOrInitial && (disableTitleAsNotConnected || linkCreation);
    const [isTitleGenerating, setIsTitleGenerating] = (0, $42omo.useState)(false);
    const handleTitleGeneratingChange = (0, $42omo.useCallback)((isGenerating)=>{
        setIsTitleGenerating(isGenerating);
    }, []);
    const EditorAppearanceButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RPbY.EditorAppearanceButtonNext), {
        contentId: contentId,
        disabled: contentComponentsDisabled || !collabEditConnected,
        isStatusDisconnected: collabEditState.collabEditInternetLost
    });
    const breadcrumbsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7vJCW.EditorBreadcrumbs), {
        key: "breadcrumbs-line",
        contentId: contentId,
        contentType: contentType,
        EditContentAppearanceButton: EditorAppearanceButton,
        breadcrumbsClickHandler: breadcrumbsClickHandler,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        collabEditInitialized: collabEditState.collabEditInitialized,
        moveLocationConfig: {
            spaceKey: spaceKey,
            isUnpublishedDraft: isUnpublishedDraft
        },
        isKnowledgeBaseSpace: isKnowledgeBaseSpace
    });
    const shouldShowEditorByLine = isEmbeddedConfluence ? hasByLineContributors || hasByLineExtensions || hasReactions : true;
    const editorByLineComponent = shouldShowEditorByLine ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fY437.EditorByLineArea), {
        contentId: contentId,
        contentType: contentType,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        editorAppearanceButton: EditorAppearanceButton,
        isLivePage: isLivePage,
        isKnowledgeBaseSpace: isKnowledgeBaseSpace,
        viewMode: viewMode,
        editorApi: editorApi,
        isUnpublishedDraft: isUnpublishedDraft,
        isSpaceOverview: isSpaceOverview,
        hasByLineContributors: hasByLineContributors,
        hasByLineExtensions: hasByLineExtensions,
        hasReactions: hasReactions
    }), (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gjEAi.ApprovalBanner), null))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9iTNj.TitleAreaContentComponents), {
        key: "title-area-content-components",
        title: contentComponentsTitle,
        breadcrumbsComponent: breadcrumbsComponent,
        contentId: contentId,
        cloudId: cloudId,
        isDisabled: isTitleDisabled,
        onChange: handleTitleChange,
        focusEditor: focusEditor,
        onFocusChanged: onFocusChanged,
        debounceOnChange: debounceOnChange,
        contentType: contentType,
        userOffline: userOffline,
        isInPreview: shouldRenderPreview,
        isPublishingContent: isPublishingContent,
        isUnpublishedDraft: isUnpublishedDraft,
        templateSuggestionsRef: templateSuggestionsRef,
        templateButtonRef: templateButtonRef,
        contentTopperComponent: editorByLineComponent,
        linkCreation: linkCreation,
        viewMode: viewMode,
        contentClassificationMetadata: contentClassificationMetadata,
        version: version,
        isEditorEmpty: isEditorEmpty,
        contentComponentsDisabled: contentComponentsDisabled,
        isDraftLockedForEditing: isDraftLockedForEditing,
        isStatusDisconnected: collabEditState.collabEditInternetLost,
        editorApi: editorApi,
        editorSessionId: editorSessionId,
        isSeamlessTransitionInProgress: isSeamlessTransitionInProgress,
        isTitleGenerating: isTitleGenerating,
        onTitleGeneratingChange: handleTitleGeneratingChange,
        isEmbeddedConfluence: isEmbeddedConfluence,
        customPlaceholderOverride: customPlaceholderOverride
    });
};




















const $df142c0f7d22fd62$export$f08b3cfa3cbddb9c = ({ contentId: contentId })=>{
    const wasStartedRef = (0, $42omo.useRef)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    return (0, $42omo.useCallback)(()=>{
        if (!wasStartedRef.current && isLivePage) {
            experienceTracker.start({
                name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                attributes: {
                    contentId: contentId,
                    isLivePage: isLivePage
                }
            });
            wasStartedRef.current = true;
        }
    }, [
        wasStartedRef,
        experienceTracker,
        isLivePage,
        contentId
    ]);
};





function $b3e3043e802ac415$export$befb12a9d0ae7ad9({ editorApi: editorApi, contentId: contentId }) {
    const startLivePageEditExperience = (0, $df142c0f7d22fd62$export$f08b3cfa3cbddb9c)({
        contentId: contentId
    });
    const { hasEditorContentChangedByLocalUserExcludingComments: hasEditorContentChangedByLocalUserExcludingComments } = (0, $16o3K.useHasEditorContentChanged)({
        editorPresetAPI: editorApi
    });
    const { setEditorApi: setEditorApi } = (0, $kDhla.useFullPageEditorApiActions)();
    (0, $42omo.useEffect)(()=>{
        if (editorApi) // FIXME: https://product-fabric.atlassian.net/browse/ED-25722
        // @ts-expect-error
        setEditorApi(editorApi);
    }, [
        editorApi,
        setEditorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (editorApi && hasEditorContentChangedByLocalUserExcludingComments) startLivePageEditExperience();
    }, [
        editorApi,
        startLivePageEditExperience,
        hasEditorContentChangedByLocalUserExcludingComments
    ]);
}














const $aa4689242ad06a0b$export$dc599391a17e1b5b = ({ disabled: disabled, collabEditInternetLost: collabEditInternetLost, internetDisconnected: internetDisconnected, api: api })=>{
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const isOfflineStorageDisabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'editorOfflineStorage.disabled', {
        disabled: !(isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false))
    }) ?? false;
    const inactiveSyncing = (0, $b3YrF.useSharedPluginStateSelector)(api, 'editorOfflineStorage.inactiveSyncing', {
        disabled: !(isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false))
    }) ?? false;
    return (0, $42omo.useMemo)(()=>{
        if (isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) {
            if (inactiveSyncing) return true;
            if (isOfflineStorageDisabled) return disabled;
            return disabled && !(collabEditInternetLost || internetDisconnected);
        }
        return disabled;
    }, [
        isDesktop,
        collabEditInternetLost,
        internetDisconnected,
        disabled,
        isOfflineStorageDisabled,
        inactiveSyncing
    ]);
};








const $767f50cadbc92220$export$4da6e3f66c58b328 = (editorFullPagePresetAPI)=>{
    const historyCanUndo = (0, $b3YrF.useSharedPluginStateSelector)(editorFullPagePresetAPI, 'history.canUndo');
    const historyCanRedo = (0, $b3YrF.useSharedPluginStateSelector)(editorFullPagePresetAPI, 'history.canRedo');
    const canUndo = editorFullPagePresetAPI?.undoRedoPlugin?.actions.undo && historyCanUndo || false;
    const canRedo = editorFullPagePresetAPI?.undoRedoPlugin?.actions.redo && historyCanRedo || false;
    const undo = (0, $42omo.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.undoRedoPlugin?.actions) return false;
        return editorFullPagePresetAPI.undoRedoPlugin.actions.undo();
    }, [
        editorFullPagePresetAPI
    ]);
    const redo = (0, $42omo.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.undoRedoPlugin?.actions) return false;
        return editorFullPagePresetAPI.undoRedoPlugin.actions.redo();
    }, [
        editorFullPagePresetAPI
    ]);
    const activateFindReplace = (0, $42omo.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.findReplace?.actions) return false;
        return editorFullPagePresetAPI.findReplace.actions.activateFindReplace();
    }, [
        editorFullPagePresetAPI
    ]);
    return {
        canUndo: canUndo,
        canRedo: canRedo,
        undo: undo,
        redo: redo,
        activateFindReplace: activateFindReplace
    };
};





/* EditorControlsBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $5nBzc = parcelRequire("5nBzc");


var $2Nwuj = parcelRequire("2Nwuj");


var $fpGTa = parcelRequire("fpGTa");



var $bUlM5 = parcelRequire("bUlM5");

var $cwkWT = parcelRequire("cwkWT");

var $5dK2X = parcelRequire("5dK2X");







var $luv00 = parcelRequire("luv00");


var $j5cB3 = parcelRequire("j5cB3");


var $dcvq8 = parcelRequire("dcvq8");


var $lx6jn = parcelRequire("lx6jn");










const $3faf0024169aae07$var$BannerImageLight = ({ title: title, titleId: titleId, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 81",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M-68.35-87.55c.706 3.65 1.105 7.55 1.162 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.55 38.086-.142.036-.292.079-.434.114-.613.157-1.226.307-1.853.45-.192.042-.392.092-.584.135-.769.164-1.546.32-2.337.463a68.966 68.966 0 0 1-8.422.949c-.969.05-1.945.085-2.935.1a74.01 74.01 0 0 1-5.059-.115c-.427-.021-.855-.042-1.282-.07a71.101 71.101 0 0 1-5.508-.607 56.036 56.036 0 0 1-2.23-.385 15.078 15.078 0 0 1-.549-.114 66.927 66.927 0 0 1-1.717-.364 11.145 11.145 0 0 1-.47-.114 41.712 41.712 0 0 1-1.91-.492c-.057-.014-.114-.028-.164-.042-12.141-3.366-21.823-10.374-27.88-20.67-4.125 6.98-9.953 12.47-17.114 16.32l.406.15a50.29 50.29 0 0 1-2.323 1.198c-.149-.05-.306-.107-.456-.157l-.52.243c.193.07.335.135.414.178-.008 0-.015.007-.029.014l-.463-.157a53.928 53.928 0 0 1-8.322 2.966c-.142.036-.292.079-.435.114a70.62 70.62 0 0 1-1.852.45c-.193.042-.392.092-.584.135-.77.164-1.547.32-2.337.463a68.969 68.969 0 0 1-8.422.948c-.969.05-1.945.086-2.936.1a73.98 73.98 0 0 1-5.058-.114 76.37 76.37 0 0 1-1.311-.071 70.424 70.424 0 0 1-5.48-.606c-.256-.036-.505-.086-.755-.128l.107.356a62.432 62.432 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a64.599 64.599 0 0 1-1.132-.25 10.069 10.069 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.043-13.096-3.607-23.32-11.457-29.241-23.092v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138.285-1.497.613-2.945.983-4.363a61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.236.192-.364.335-.649.67-1.305 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 59.73 59.73 0 0 1 6.484-3.55 58.52 58.52 0 0 1 2.472-1.112 71.218 71.218 0 0 1 8.564-2.988c.114-.035.235-.057.349-.092l.727-.193c.228-.057.449-.121.677-.178.406-.107.805-.221 1.211-.314 6.961-1.69 14.215-2.495 22.323-2.495 1.161 0 2.308.014 3.455.05.342.007.677.028 1.019.042 1.112.043 2.223.1 3.321.179 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542v-.007c.178.057.356.107.534.157h-.014c.092-.029.185-.057.285-.079l.256.086c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.12 7.593 6.385 2.816 12.028 6.431 16.816 10.958 10.26 9.796 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.579c5.45-6.83 8.208-17.639 8.393-33.075l40.391-.114v.007h.221c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.414-17.703 8.607-33.346h.491v-.007l40.392-.114c.278 15.764 3.078 26.693 8.678 33.46h63.904c-6.897-11.893-11.863-24.505-11.863-36.069 0-2.346.086-4.663.25-6.959.498-6.873 2.073-12.997 4.496-18.38.313-.699.641-1.376.983-2.046.1-.2.206-.399.306-.599.185-.349.378-.699.57-1.041 6.562-11.771 17.428-19.485 29.647-23.121a56.626 56.626 0 0 1 3.912-1.006 59.845 59.845 0 0 1 11.151-1.397c.427-.014.862-.036 1.289-.036v-.043c.086 0 .164.022.25.022.085 0 .163-.022.249-.022v.043c.292 0 .584.022.869.029a59.49 59.49 0 0 1 11.792 1.461 54.24 54.24 0 0 1 1.532.364c.199.05.392.107.591.164 1.069.285 2.124.599 3.171.941 6.192 2.046 11.998 5.155 17.022 9.333a46.662 46.662 0 0 1 7.003 7.222c5.722 7.315 9.548 16.683 10.382 28.126.163 2.296.249 4.62.249 6.959 0 2.203-.185 4.442-.52 6.709-.036.242-.079.485-.121.72-.036.235-.079.463-.121.699-.079.449-.164.891-.257 1.34-1.788 8.791-5.8 17.888-10.851 26.601H425v-292.23c-3.142 2.788-6.548 5.234-10.175 7.372-19.173 11.294-44.36 14.01-67.787 14.01h-65.001c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a224.095 224.095 0 0 1-.492-11.885 325.16 325.16 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.022-.342.036-.506.028-.392.05-.784.078-1.17.107-1.44.242-2.851.406-4.241.727-6.267 1.988-12.078 3.791-17.418a69.698 69.698 0 0 1 2.707-6.852c.25-.549.513-1.09.777-1.625a60.153 60.153 0 0 1 2.558-4.67 54.424 54.424 0 0 1 1.902-2.938 57.44 57.44 0 0 1 4.254-5.454c.157-.178.328-.356.484-.534.221-.25.449-.5.677-.742a57.671 57.671 0 0 1 7.759-6.901c9.377-6.945 21.261-11.486 35.554-13.518 4.289-.606 8.785-.991 13.502-1.14 1.575-.05 3.171-.08 4.788-.08h74.442c1.211 0 2.38-.035 3.527-.1l.648-.042c13.039-.87 21.881-6.01 25.771-16.961.043-.122.093-.243.136-.364.164-.478.32-.97.463-1.476.035-.114.064-.235.092-.349.307-1.098.563-2.246.777-3.451H101.425c-4.51 20.719-12.005 37.659-23.056 50.635a292.48 292.48 0 0 1 21.24 2.467l-9.59 63.396C43.434-8.347 21.482 3.46 16.687 35.151l-61.952-9.383c4.018-26.55 12.155-47.74 25.372-63.261a292.481 292.481 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.826c10.502 6.531 17.79 16.976 20.498 30.936l-.021-.007Zm171.407 305.704c-1.61.264-3.299.406-5.059.414a32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.23 32.23 0 0 1 5.266-.442c1.76 0 3.448.129 5.059.385 9.447 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.421 15.7-17.876 17.261l.007-.007Zm121.524-17.546c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Zm20.748-40.953c.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563v64.58c-23.278 6.488-68.5.286-68.5.286v-.008ZM362.065 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563Zm-401.572 98.154c.498-9.982 2.707-18.416 6.198-25.517 7.646-15.55 21.668-24.533 38.825-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.887 57.887 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a46.87 46.87 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.163 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.022.179.043.271.072.114.028.228.056.342.092.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.094 52.094 0 0 1 3.078 2.673 48.977 48.977 0 0 1 3.67 3.836c.292.342.577.691.862 1.04.192.236.378.478.57.714.556.713 1.09 1.44 1.61 2.181a49.36 49.36 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412c-2.429-4.906-3.691-12.185-4.346-18.744-3.719.264-7.545.321-11.429.192-.691-.021-1.382-.043-2.073-.071h-.071l-.684-.043c-.185-.007-.364-.021-.549-.035-7.787-.478-15.283-1.754-22.237-3.872-.955 3.28-2.137 6.353-3.541 9.197-7.695 15.621-21.852 24.626-38.86 28.319-7.923 1.718-16.444 2.31-25.215 1.868-4.631-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.209l-36.871-9.154s7.053-11.151 8.143-24.519c-5.856-5.219-10.445-11.7-13.373-19.571-2.73-7.336-4.062-15.827-3.57-25.666l-.021.007Zm-79.829 28.19 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.272-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.585-.727.213-1.461.406-2.202.563-.242-.207-.484-.414-.719-.621-5.045.97-10.46.628-16.01-1.019a45.598 45.598 0 0 1-6.926-2.695 46.789 46.789 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668l-.235-.043-.121-.021a29.164 29.164 0 0 1-1.347-2.51c.086.014.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.307-7.98-.592-11.528-.82l.449-.228c-.969.107-1.852.121-2.707.1-.072.313-.136.62-.221.934a22.197 22.197 0 0 1-1.411 3.721 22.65 22.65 0 0 1-1.995 3.38c-4.389 6.081-11.001 7.964-18.005 5.889a24.096 24.096 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.621-10.544-6.626-17.738a22.485 22.485 0 0 1 1.396-3.672 22.022 22.022 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.454a24.473 24.473 0 0 1 3.342 1.947c5.03 3.522 7.687 8.57 7.21 14.395 1.845.163 3.171.313 3.171.313l5.4.05s2.722.079 4.938.057a34.23 34.23 0 0 1 1.161-6.438c.642-2.31 1.532-4.663 2.679-7.051a43.12 43.12 0 0 1 3.898-6.58c5.885-8.107 13.822-12.3 22.664-12.77.492-8.17.948-16.398 2.231-22.059.748 2.638.071-6.46.591-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.122-35.584 35.568-5.126 5.122 35.584-20.206 2.909c-.549 6.901-1.225 13.51-1.468 14.23-.064-.12.121-.706-.292-.734-.085 1.034-.071 2.125-.15 3.223.649-.286.321-1.64.528-1.74.071 4.1-.584 12.42-1.233 17.018 3.043.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.787 45.491 45.491 0 0 1 6.419 3.744c3.912 2.737 7.076 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.88 5.88 0 0 0-.392.491.854.854 0 0 1 .079.136c1.218-.685 8.949-7.593 9.796-7.743-.035.057-.292.47-.334.542 1.018-.371 2.999-2.802 3.726-2.396.185-.128.506-.392.919-.748-3.049-3.865-4.104-8.691-2.636-13.989a22.577 22.577 0 0 1 1.396-3.672 22.022 22.022 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.462 24.462 0 0 1 3.342 1.946c5.978 4.185 8.628 10.517 6.612 17.753a22.221 22.221 0 0 1-1.41 3.722 22.698 22.698 0 0 1-1.996 3.38c-4.389 6.08-11 7.963-18.005 5.888a24.072 24.072 0 0 1-3.605-1.404 24.246 24.246 0 0 1-3.477-2.04 20.03 20.03 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.623 29.08 29.08 0 0 1 1.397 2.902c.114.264.228.528.335.791v.03c2.166 5.738 2.451 12.198.534 19.085-.648 2.339-1.553 4.72-2.714 7.144-.015.029-.036.064-.05.093.149.092.299.178.449.271-.05.107-.093.213-.143.313a46.63 46.63 0 0 1-1.054 2.047c-.157-.093-.321-.186-.478-.286a42.937 42.937 0 0 1-1.966 3.187c3.021 1.512 7.303 4.107 9.497 5.725-.335-.071-1.083-.37-1.859-.834l-.143.214c1.824 1.012 3.249 2.995 5.422 3.151 0 0-2.109-1.561-2.486-2.003l.028-.014-.014-.043c4.261 2.189 9.17 5.183 13.416 7.65l17.97-14.224 22.294 28.198-28.18 22.309-22.294-28.198v.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M197.242 10.71a493.5 493.5 0 0 1-.064-1.547v-.17a227.753 227.753 0 0 1-.1-3.416c0-.121 0-.242-.007-.37l-.022-1.32c0-.2 0-.399-.007-.599 0-.399-.007-.798-.014-1.204V-.333c0-.92.014-1.826.036-2.731a40.67 40.67 0 0 1-4.696 1.362c-2.75.599-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311.046 311.046 0 0 1-.164-3.202v-.07.006ZM178.96-.348c-7.944-.014-15.689-1.098-23.256-2.445a667.71 667.71 0 0 1-.107-1.448c.535 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.275-1.098-1.902-1.655A311.884 311.884 0 0 1 178.96-.348Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M181.946.023c.327.278 2.379 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.726-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.678-1.247a40.672 40.672 0 0 0 4.696-1.362c.021-.877.05-1.74.085-2.602l-.484.192c-.477.185-.976.32-1.454.478-.962.335-1.952.57-2.921.805-3.911.927-7.788 1.29-11.329 1.412-.434.014-.869.029-1.296.036a421.776 421.776 0 0 1-6.726-6.916c-5.601-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.954 1.327 1.703 2.368 2.315 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.582 19.014a409.898 409.898 0 0 0 5.757 6.01c-1.859-.02-3.583-.092-5.144-.156-5.336-.456-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.107 1.448 7.567 1.34 15.311 2.424 23.256 2.445a312.468 312.468 0 0 0 13.373 12.67c.627.556 1.269 1.105 1.903 1.654h2.857c-1.375-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91h-.035Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M197.05 3.887c0 .45.015.884.022 1.32l-.022-1.32Zm.028 1.69c.029 1.176.057 2.31.1 3.415-.043-1.098-.071-2.239-.1-3.415Zm-.05-3.494c0 .407.007.806.014 1.205 0-.399-.007-.798-.014-1.205ZM372.866-38.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.002c-.912 0-1.802.021-2.679.071-13.124.72-21.966 6.945-21.966 21.575 0 4.534 1.005 11.578 1.503 17.11h-19.522a321.858 321.858 0 0 1-.164-3.2c.05 1.104.1 2.167.164 3.2.513 8.934 1.439 15.265 2.123 20.42h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01A64.662 64.662 0 0 0 425-25.744v-92.749h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068h-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M383.126-107.549c0 9.411-1.909 16.491-5.557 21.582-3.086 4.306-7.425 7.193-12.904 8.855-.178.056-.37.1-.556.156-.826.236-1.667.45-2.543.635a48.078 48.078 0 0 1-6.876.884c-.605.036-1.225.064-1.852.078-.627.022-1.261.029-1.91.029h-74.599c-1.567 0-3.106.028-4.631.078-1.574.05-3.121.129-4.645.228-.763.05-1.518.107-2.266.172-.399.035-.798.07-1.197.114-.342.035-.691.064-1.04.1-.043 0-.079.007-.121.014l-.357.042-.791.086c-1.04.121-2.073.25-3.092.392a95.256 95.256 0 0 0-6.619 1.162 87.502 87.502 0 0 0-3.256.742 86.423 86.423 0 0 0-7.317 2.146c-4.204 1.44-8.116 3.18-11.728 5.204a63.718 63.718 0 0 0-5.201 3.244 58.442 58.442 0 0 0-2.815 2.082 36.5 36.5 0 0 0-.805.656 60.45 60.45 0 0 0-2.173 1.861c-4.631 4.178-8.522 9.048-11.657 14.609-.106.185-.206.378-.313.57-.093.171-.192.342-.285.513-.257.47-.506.956-.748 1.433-3.064 6.068-5.294 12.884-6.655 20.434a94.997 94.997 0 0 0-.527 3.294 105.5 105.5 0 0 0-.962 10.509c-.036.863-.064 1.725-.086 2.602a117.4 117.4 0 0 0-.035 2.73v2.418c0 .406.007.805.014 1.205 0 .2 0 .399.007.599 0 .449.014.884.022 1.319a242.213 242.213 0 0 0 .106 3.786v.17l.065 1.548v.071c.049 1.105.099 2.167.163 3.201h19.523c-.499-5.54-1.503-12.584-1.503-17.11 0-14.63 8.842-20.855 21.966-21.575.876-.05 1.767-.072 2.679-.072h65.001c23.42 0 48.607-2.716 67.788-14.01 18.703-11.015 31.692-30.2 31.692-63.068v-16.662h-21.432v10.944h.028Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M78.347-67.858C58.354-44.373 26.719-33.878-19.921-37.5a90.81 90.81 0 0 1 1.895-2.153 93.243 93.243 0 0 0-1.902 2.153C-33.145-21.98-41.282-.79-45.3 25.76l61.952 9.384C21.447 3.459 43.399-8.354 89.982-2.002l9.59-63.396c-7.403-1.12-14.478-1.94-21.24-2.467a220.48 220.48 0 0 0-4.167-.286c1.375.086 2.764.179 4.168.286l.014.007Zm215.217 83.666s.499 65.85 0 65.422c0 0 15.127 2.074 32.384 2.573v-3.437l-.043-9.646v-.02c0-.52 0-1.04-.007-1.554v-5.27c-.057-9.504-.107-16.584-.107-16.584.677.236 1.354.457 2.03.67l.485.15a67.963 67.963 0 0 0 2.202.65 90.53 90.53 0 0 0 1.909.505c.157.043.314.079.47.121.677.172 1.361.329 2.038.485.093.022.178.036.271.057a82.64 82.64 0 0 0 2.28.471c.691.135 1.375.257 2.066.378.1.014.2.035.299.05a94.24 94.24 0 0 0 1.896.3c.106.013.213.035.32.05.698.099 1.397.192 2.102.284.093.014.192.022.285.036.67.078 1.332.157 1.995.22.057 0 .114.015.171.022.713.072 1.432.136 2.138.193.078 0 .163.014.242.021 1.446.114 2.878.2 4.303.264h.164c1.454.057 2.886.093 4.304.1h.064c1.446.007 2.871 0 4.275-.043V16.371s-36.908 10.43-68.5-.563h-.036Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M348.713 51.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021Zm-22.757 31.869c.05 15.1.029 29.104-.199 28.911 0 0 45.222 6.203 68.5-.285v-64.58s-14.03 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.11 2.852l-.007.007Zm-.199-36.518s.057 7.08.107 16.584c-.057-9.504-.107-16.584-.107-16.584Zm11.264 3.037c.135.029.27.058.413.079a7.366 7.366 0 0 0-.413-.079Zm9.375 1.398c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021Zm-14.021-2.453c.157.043.313.079.47.121-.157-.035-.313-.078-.47-.12Zm-2.08-.556c.057.014.114.029.178.05-.057-.014-.114-.028-.178-.05Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M357.727 52.319c-1.418-.007-2.85-.043-4.304-.1h-.164c-1.425-.057-2.857-.15-4.303-.264-.079 0-.164-.014-.242-.021-.713-.057-1.425-.121-2.138-.193-.057 0-.114-.014-.171-.021-.663-.071-1.332-.143-1.995-.221-.093-.014-.192-.021-.285-.036a74.149 74.149 0 0 1-2.102-.285c-.107-.014-.214-.035-.32-.05a86.6 86.6 0 0 1-1.896-.3c-.099-.014-.199-.035-.299-.05a99.632 99.632 0 0 1-2.066-.377 6.563 6.563 0 0 0-.413-.078 78.608 78.608 0 0 1-1.867-.393c-.093-.02-.178-.035-.271-.057a70.267 70.267 0 0 1-2.508-.606c-.634-.164-1.275-.328-1.909-.506-.057-.014-.114-.028-.179-.05-.676-.192-1.346-.392-2.023-.599l-.485-.15a68.617 68.617 0 0 1-2.03-.67s.057 7.087.107 16.584v5.269c0 .513 0 1.034.007 1.554v.022l.043 9.646v3.436c12.582.364 26.298-.12 36.109-2.852V52.283c-1.404.036-2.829.05-4.275.043h-.064l.043-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M66.278 67.07c-2.536-4.534-4.945-9.097-7.317-13.66-.036.078-.079.15-.121.22-1.397 2.824-2.58 5.868-3.534 9.134.463.142.919.285 1.375.427a73.413 73.413 0 0 1 9.604 3.872l-.007.007Zm93.473 9.204c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.464-.4.962-.82.25-.214.499-.42.677-.592a27.2 27.2 0 0 0 .314-.292 59.792 59.792 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65.376 65.376 0 0 0 2.565 4.734c3.683 6.082 8.407 11.172 13.594 14.901a43.937 43.937 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.984-.15 1.447-.214.27-.043.527-.078.783-.114.399-.791.77-1.604 1.162-2.396 1.047-2.074 1.874-4.249 2.786-6.388.427-1.076.805-2.181 1.211-3.265l.598-1.633c.193-.549.357-1.105.535-1.654l1.054-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.378-2.274.57-3.408.157-1.14.314-2.274.47-3.415l.235-1.704.186-1.711c.128-1.14.249-2.275.377-3.408.798-9.098 1.361-18.188.813-27.022 0-.042-.008-.085-.008-.128a48.965 48.965 0 0 0-3.669-3.836 40.232 40.232 0 0 1-.556 5.968c-1.938 10.701-6.284 20.512-11.906 29.025l-.014-.022Zm-58.638-49.066c.342-.663.513-.962.484-.97-.021-.006-.242.279-.591.835-.342.563-.87 1.369-1.46 2.424-1.226 2.096-2.808 5.169-4.425 8.905-1.61 3.743-3.2 8.178-4.568 12.926-2.743 9.51-4.374 20.276-5.272 28.953a439.59 439.59 0 0 1-.171 1.697c3.042 3.872 5.536 8.263 7.374 13.204.4 1.077.77 2.182 1.112 3.308.035.029.071.05.1.079.812.584 1.631 1.183 2.515 1.704.434.263.855.556 1.31.798.45.243.906.478 1.361.72.45.257.92.464 1.397.663l1.418.614 1.468.499.733.249.749.186 1.503.37h.007c0-1.091 0-2.189.043-3.287.335-11.15 2.786-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.431-29.51a165.508 165.508 0 0 1 5.187-6.651c1.809-2.168 3.74-4.285 5.942-6.16l.128-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.295-.064-19.565.855a84.868 84.868 0 0 0-3.798 5.975c.706-1.419 1.276-2.403 1.618-3.066v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M176.851 52.989c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.84-4.712 1.246-7.115.699-4.813 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M178.738 61.324c-.826 16.583-3.37 33.288-8.528 47.832a111.022 111.022 0 0 1-4.96 11.828l2.679-.399a37.628 37.628 0 0 0-.427 1.961c-.036.178-.064.356-.1.527a42.736 42.736 0 0 0-.249 1.612c-.014.121-.036.242-.05.37-.057.485-.1.97-.142 1.455a44.29 44.29 0 0 0 2.422.599c-2.636-.271-2.337-.129-.342.285.05.007.107.021.157.028 5.272-4.327 9.661-9.71 12.882-16.284 3.448-7.022 5.629-15.343 6.12-25.174.499-9.982-.848-18.594-3.612-26.01a49.36 49.36 0 0 0-5.665-10.886c.114 4.085.022 8.185-.185 12.263v-.007Zm-16.75 10.786a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13ZM86.99 59.598c.192-.97.491-2.21.883-3.8.499-2.281 1.653-6.032 2.807-9.333 1.155-3.308 2.26-6.188 2.202-6.958-1.097 2.873-2.7 6.987-3.883 10.873-1.204 3.878-2.002 7.507-2.01 9.225v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M69.933 69.016c5.038 2.91 9.505 6.46 13.267 10.688l.043-.4c1.104-9.667 2.771-18.936 5.215-27.427 2.409-8.499 5.658-16.177 9.355-22.715a86.122 86.122 0 0 1 2.672-4.406 72.13 72.13 0 0 0-2.843.563c-16.017 3.486-29.511 11.714-37.463 25.795 2.658 5.07 5.337 10.117 8.144 15.093.527.942 1.076 1.868 1.618 2.802l-.008.007Zm61.14 17.233c.755 3.885 1.866 7.785 3.355 11.521.157-.085.307-.178.464-.264-1.219-3.065-2.501-7.436-3.285-11.763-.898-4.55-1.211-8.998-1.817-11.643.15 3.9.506 8.014 1.283 12.156v-.007Zm14.178-58.706.05-.057c.163-.157.313-.306.456-.442a5.425 5.425 0 0 1-.342-.093 12.67 12.67 0 0 0-.35.414l.179.178h.007ZM129.042 66.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.314.078-1.02.107-1.625.028-.6.057-1.098-.157-1.006h-.007Zm2.308-6.246c-.342 1.29-.862 3.187-1.125 5.183-.357 1.99-.414 4.064-.407 5.618l.25.05.192-3.28c.029-.784.157-1.554.221-2.131.071-.578.128-.963.15-.97l-.05-.035c.1-.079.306-.065.299-.528.663-3.33 1.019-4.934 1.09-5.397.064-.464-.256.192-.62 1.476v.014ZM110.367 78.57l.2.228c1.332-4.898 3.177-9.91 5.108-14.387l-.178-.221c-1.995 4.605-3.769 9.39-5.13 14.38Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M145.885 29.953c-2.472 2.816-4.56 6.039-6.369 9.44-3.577 6.837-6.171 14.33-7.439 22.023-.142.963-.342 1.918-.435 2.888l-.313 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.541 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.054-2.723 5.273-3.621.591-.47 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.049-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.148.349-.742.876-1.804 1.432-3.145a73.816 73.816 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.015-.235-.05-.463-.072-.698-5.799-4.656-12.696-8.178-20.356-10.66-.256-.085-.52-.156-.776-.235a36.996 36.996 0 0 0-2.124 2.232v.007Zm-25.656 23.913c-1.832 3.244-3.164 6.132-2.843 6.203l.114-.236c1.503-2.866 2.743-5.104 3.968-7.329 1.247-2.21 2.494-4.413 4.204-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.273 8.634l.008-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M137.314 33.418a141.537 141.537 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.404 21.596-3.456 7.771-6.099 16.106-7.539 24.804a90.711 90.711 0 0 0-1.232 15.457c.135.007.271.014.406.029l1.532.092c.513.007 1.019-.028 1.524-.035.506-.029 1.012 0 1.518-.093 1.005-.136 1.995-.214 2.985-.435 6.384-1.184 12.028-3.479 16.367-5.803-.52-1.227-.962-2.496-1.433-3.758-.313-.827-.527-1.69-.79-2.538-.25-.856-.528-1.697-.706-2.574l-.598-2.602c-.186-.87-.307-1.754-.456-2.624-.335-1.74-.442-3.508-.642-5.24-.213-3.48-.299-6.902-.021-10.16.435-6.523 1.746-12.355 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.763-6.025 2.63-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.408-15.8 0 0-.62.735-1.504 1.926a56.993 56.993 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.928 5.447-.414.848-.784 1.618-1.105 2.267l-.691 1.569v-.079l-.085.15c1.539-4.021 3.398-8.078 5.835-11.957 1.617-2.595 3.498-5.111 5.686-7.407-.242-.064-.485-.129-.734-.193-2.586 1.818-4.909 4.171-7.104 6.73l-.007-.02ZM62.78 58.436c.74 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.774-8.384-3.028-4.79Zm106.789-9.539c.285-1.255.492-2.802.627-3.594.086-1.554.021-2.139-.043-2.103-.078.036-.149.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.136.35.449-.606.727-1.86Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M69.933 69.016a567.385 567.385 0 0 1-1.617-2.802c-2.808-4.976-5.487-10.03-8.144-15.093-.42.749-.834 1.512-1.226 2.296 2.373 4.563 4.788 9.126 7.318 13.66a64.022 64.022 0 0 1 3.662 1.947l.007-.008Zm-4.118-5.796c-.606-.627-2.294-3.436-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791Zm109.268 9.047c-.128 1.134-.249 2.275-.377 3.409l-.185 1.71-.236 1.705-.47 3.415c-.192 1.133-.377 2.267-.57 3.408l-.285 1.704-.335 1.697-.677 3.393-.79 3.373-.399 1.69-.456 1.675-.92 3.351-1.054 3.315c-.178.549-.342 1.112-.534 1.654l-.599 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.762 1.604-1.161 2.396.285-.043.555-.086.826-.122.349-.663.72-1.361 1.097-2.117.414-1.005.613-.934.784-1.098.029-.093.021-.135-.021-.078 0 0 .035-.057.085-.15.05-.1.121-.243.214-.421.164-.37.392-.905.663-1.54.527-1.283 1.303-2.959 1.909-4.727 1.347-3.479 2.394-7.136 2.515-7.4l.214.171c-.52 1.775-1.083 3.857-1.91 5.996-.399 1.069-.783 2.189-1.246 3.287-.478 1.09-.955 2.196-1.433 3.294-.456 1.105-1.033 2.153-1.546 3.186-.263.507-.513 1.013-.769 1.512.37-.057.719-.107 1.054-.157.129-.257.257-.513.378-.77l.142.292-.213.428c.156-.021.299-.043.449-.064a109.76 109.76 0 0 0 4.959-11.828c5.158-14.544 7.702-31.25 8.528-47.833.2-4.078.299-8.177.185-12.263a45.124 45.124 0 0 0-1.61-2.181c.093 2.16.136 4.327.107 6.488-.043 5.083-.37 10.145-.769 15.136-.385 4.998-1.012 9.917-1.71 14.73-.399 2.395-.763 4.784-1.247 7.115-.421 2.346-.969 4.634-1.475 6.894.997-6.26 2.878-16.768 3.748-27.834.463-5.525.833-11.172.883-16.426.029-2.375 0-4.663-.107-6.823-.285-.35-.57-.7-.862-1.041 0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021l.028.014Zm-6.462 40.311c-.292.813-.442.999-.812 1.804-.299.157.164-.919.62-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078h.007Zm-33.937-80.515c-1.803 2.168-3.505 4.392-5.187 6.652-6.662 9.07-12.347 18.965-16.43 29.51-4.083 10.53-6.534 21.703-6.869 32.853a83.783 83.783 0 0 0-.042 3.287h-.008l-1.503-.371-.748-.185-.734-.25-1.468-.499-1.418-.613a12.374 12.374 0 0 1-1.396-.663l-1.36-.72c-.45-.242-.877-.535-1.312-.798-.876-.514-1.696-1.113-2.515-1.704-.036-.029-.071-.05-.1-.079.357 1.17.67 2.367.955 3.593 1.41.899 2.85 1.704 4.31 2.403 2.373 1.148 4.86 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.112 2.702 2.508 5.34 4.232 7.735.186.015.364.029.549.036a37.958 37.958 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.599-2.303c-.171-.684-.285-1.283-.399-1.775l-.335-1.533c.428 1.64.841 3.287 1.361 4.926a60.26 60.26 0 0 0 1.66 4.913c1.24 3.251 2.8 6.466 4.881 9.382.192.271.392.535.598.799.691.035 1.383.05 2.074.071-.064-.078-.136-.143-.193-.221-2.835-3.458-4.788-7.614-6.227-11.914a78.003 78.003 0 0 1-3.071-13.239c-.42-2.916-.655-5.839-.762-8.755.399.028.791.057 1.183.078.313.014.627.05.94.043l.933-.029c.62-.028 1.247-.014 1.86-.078 2.494-.25 4.817-.72 7.161-1.312 2.337-.599 4.638-1.383 6.932-2.303a53.42 53.42 0 0 0 6.228-3.001c-.15-.336-.314-.656-.456-.991a19.15 19.15 0 0 1-.506-1.134c-4.339 2.324-9.99 4.62-16.366 5.803-.991.221-1.981.3-2.986.435-.499.086-1.004.064-1.517.093-.506.007-1.019.05-1.525.036l-1.532-.093c-.135-.007-.271-.021-.406-.029a90.711 90.711 0 0 1 1.232-15.457c1.433-8.698 4.083-17.032 7.539-24.804 3.455-7.77 7.709-14.986 12.404-21.595a141.92 141.92 0 0 1 7.353-9.468c2.188-2.56 4.518-4.905 7.104-6.73a94.78 94.78 0 0 0-3.662-.892l-.128.107c-2.209 1.875-4.133 4-5.943 6.16l-.007.029Zm-32.141 72.274c-.37-.114-.577-.214-.705-.314-.257-.207-.235-.371-.677-.72.72.392 3.527 1.304 2.878 1.29l.236.1c-.827-.064-1.354-.249-1.732-.349v-.007Zm4.347 8.683c-.264-1.803-.321-3.222-.378-4.192-.007-.977.021-1.518.078-1.583.114-.128.235 1.64.527 5.576l.022.178-.249.014v.007Zm3.676-34.222-.2-.228c1.361-4.99 3.135-9.775 5.13-14.38l.179.22c-1.931 4.478-3.777 9.49-5.109 14.388Zm10.908-26.301c-1.225 2.224-2.465 4.463-3.968 7.33l-.114.235c-.314-.072 1.012-2.96 2.843-6.203 1.809-3.251 4.146-6.83 5.272-8.634l.178.192c-1.71 2.66-2.957 4.863-4.203 7.073l-.008.007Zm46.206-.257a74.31 74.31 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145a21.583 21.583 0 0 1-.563 1.147c-1.154 2.318-2.451 4.57-3.804 6.78-1.404 2.182-2.865 4.328-4.454 6.389-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.757-5.572 5.433 0 0-.156.142-.47.385-.313.25-.776.613-1.368 1.09-1.218.906-2.964 2.225-5.272 3.623-.15.092-.307.185-.456.278.292.706.605 1.397.912 2.089a59.741 59.741 0 0 0 4.788-3.366s-.136.122-.314.293c-.178.17-.434.378-.677.591-.491.421-.94.799-.962.82 3.933-2.659 7.674-5.874 11.023-9.46a84.977 84.977 0 0 0 9.362-11.757c5.622-8.513 9.975-18.316 11.906-29.025a38.45 38.45 0 0 0 .556-5.968 55.617 55.617 0 0 0-3.078-2.673c.021.235.057.463.071.699.313 4.128-.42 8.748-1.532 12.925l.007-.007Zm-5.693 19.87c-3.854 6.21-.064-.94 1.618-3.13a38.878 38.878 0 0 1-1.618 3.13Zm8.173-28.91c.057-.036.128.542.042 2.103-.135.792-.349 2.346-.627 3.594-.277 1.254-.584 2.21-.726 1.86.206-1.226.783-4.106 1.019-5.946.142-.92.213-1.575.292-1.611Zm-81.703 8.677c-2.443 8.491-4.11 17.76-5.215 27.428l-.043.399c.656.741 1.29 1.497 1.903 2.281.057-.556.114-1.12.17-1.697.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.118-1.868 1.46-2.424.35-.563.57-.841.592-.834.028.007-.143.306-.485.97-.342.662-.912 1.646-1.617 3.065a86.22 86.22 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86.09 86.09 0 0 0-2.672 4.406c-3.697 6.538-6.946 14.216-9.355 22.715l.007-.007Zm2.224-5.412c-1.155 3.309-2.309 7.052-2.808 9.333-.392 1.59-.69 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.054 3.65-2.202 6.958v.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "m133.631 46.251.093-.15v.08c.164-.364.399-.906.691-1.57.313-.648.691-1.418 1.104-2.267.784-1.704 1.853-3.636 2.929-5.447a56.7 56.7 0 0 1 3.092-4.662c.883-1.191 1.503-1.925 1.503-1.925-3.177 4.784-6.013 10.124-8.407 15.799-2.373 5.668-4.24 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.454 4.5-2.758 10.331-3.199 16.855-.278 3.258-.193 6.68.021 10.16.2 1.732.306 3.493.641 5.24.157.87.271 1.754.456 2.623l.599 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.47 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.306.663.456.991a42.843 42.843 0 0 0 1.824 3.614 54.512 54.512 0 0 0 2.608 4.221c1.824 2.667 3.79 5.055 5.771 7.087a47.549 47.549 0 0 0 5.828 5.069c-.128-.228-1.389-1.112-2.622-2.21-.634-.535-1.225-1.148-1.731-1.69-.485-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.916-.286 2.835-.421a40.901 40.901 0 0 1-3.583-2.317c-5.187-3.729-9.911-8.819-13.595-14.901a61.437 61.437 0 0 1-2.565-4.734 55.475 55.475 0 0 0-.506-1.14c-.306-.692-.62-1.384-.912-2.09a27.164 27.164 0 0 1-.698-1.825c-.684-1.711-1.169-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.933.128-3.865.242-5.804l.313-2.902c.093-.97.293-1.925.435-2.887 1.268-7.693 3.855-15.186 7.439-22.023 1.809-3.401 3.897-6.624 6.369-9.44a36.996 36.996 0 0 1 2.124-2.232 76.062 76.062 0 0 0-2.252-.677c-.142.135-.285.285-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.043-.271-.071-2.187 2.296-4.068 4.813-5.685 7.408-2.437 3.885-4.297 7.935-5.836 11.956l-.007.021Zm-4.424 21.36c-.029.6-.107 1.305-.107 1.626-.057-.449-.25-1.283-.221-1.803.028-.364.1-.457.164-.828.221-.092.185.407.156 1.006h.008Zm10.466 41.973c-.399-.349-.791-.92-1.161-1.512-.356-.598-.67-1.219-.955-1.654.164-.092.834.799 1.418 1.647.584.849 1.054 1.669.698 1.519Zm-8.065-23.849c.783 4.328 2.066 8.698 3.284 11.764.064.164.129.335.193.492.242.52.498 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.271 1.047 1.319 2.08 2.566 3.113 3.643.357.392.756.784 1.176 1.183.413.414.855.827 1.339 1.248-5.279-4.057-10.217-10.402-13.444-17.724-.207-.47-.407-.941-.599-1.419-.1-.235-.192-.478-.285-.713-1.489-3.729-2.601-7.636-3.356-11.522-.776-4.142-1.133-8.256-1.282-12.156.598 2.646.912 7.095 1.817 11.643l.007.007Zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.2.442-.299.528l.05.035s-.079.385-.15.97c-.057.577-.192 1.347-.221 2.132-.093 1.561-.185 3.158-.192 3.28l-.25-.05c-.007-1.555.05-3.637.406-5.619.264-1.996.784-3.9 1.126-5.183.364-1.283.684-1.94.62-1.476v-.014Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#F8EEFE",
        d: "M-22.564 159.762c0-.078.014-.156.022-.235a42.24 42.24 0 0 0 .092-1.654c0-.121.014-.235.014-.356.022-.656.022-1.312.008-1.975 0-.122-.008-.25-.015-.371a31.618 31.618 0 0 0-.085-1.633l-.043-.542a31.502 31.502 0 0 0-.228-1.989l7.959 2.025c1.225.314 2.536.642 3.911.991.549.143 1.105.278 1.675.421.57.142 1.14.285 1.71.435 1.154.292 2.322.584 3.491.877 1.168.292 2.337.591 3.491.876.577.143 1.147.286 1.71.428 2.537.635 4.93 1.234 6.983 1.733.228.057.449.114.67.164.876.214 1.674.406 2.38.577.527.129 1.011.243 1.424.342.42.1.777.179 1.069.243.584.128.898.185.883.157v.071c0 .043-.007.1-.014.171v.029c0 .071-.014.164-.021.263 0 .029 0 .05-.007.079-.007.107-.022.221-.036.349 0 .029 0 .057-.007.086-.014.142-.028.299-.05.47v.022c-.021.178-.036.363-.064.57 0 .029 0 .05-.007.071-.022.193-.043.407-.071.621 0 .05-.015.092-.015.142-.028.221-.05.449-.078.685 0 .05-.014.1-.021.149-.029.243-.065.492-.093.756l-.021.178a86.63 86.63 0 0 0-.107.842.35.35 0 0 1-.015.085c-.035.293-.078.592-.12.899 0 .035-.015.078-.015.114-.043.313-.093.627-.135.955-.007.064-.022.128-.029.193l-.15.969c-.014.079-.02.15-.035.228-.05.335-.107.67-.164 1.02-.014.071-.021.142-.036.214-.056.356-.12.72-.185 1.083-.007.05-.021.1-.028.15a59.38 59.38 0 0 1-.2 1.112c0 .036-.014.065-.021.1-.071.385-.143.777-.221 1.177-.014.064-.021.128-.036.192l-.17.856c4.353.755 8.87 1.24 13.494 1.475 8.77.443 17.293-.149 25.215-1.867 17.008-3.686 31.165-12.691 38.86-28.319 1.404-2.845 2.58-5.911 3.541-9.198.328-1.133.627-2.302.905-3.493a63.012 63.012 0 0 1-.912 3.508 51.202 51.202 0 0 1-1.425-.449 70.453 70.453 0 0 1-8.927-3.558c-.47-.228-.94-.464-1.411-.699a58.693 58.693 0 0 1-9.141-5.746 78.108 78.108 0 0 1-1.198-.949 50.902 50.902 0 0 1-5.507-5.211 44.277 44.277 0 0 1-1.974-2.317 49.002 49.002 0 0 1-4.318-6.367 47.006 47.006 0 0 1-1.46-2.781 51.454 51.454 0 0 1-.67-1.44 55.956 55.956 0 0 1-1.225-2.987 56.355 56.355 0 0 1-1.789-5.718 60.546 60.546 0 0 1-1.439-7.786 70.579 70.579 0 0 1-.463-6.759c-.036-1.754 0-3.55.085-5.39.3-5.982 1.219-11.4 2.658-16.312-7.332-2.239-15.255-3.55-23.498-3.964-9.22-.464-18.084.128-26.256 1.896-17.157 3.708-31.179 12.698-38.824 28.24-3.491 7.102-5.7 15.529-6.199 25.518-.491 9.838.84 18.33 3.57 25.666 2.928 7.871 7.517 14.352 13.373 19.571l-.014.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#EED7FC",
        d: "M52.612 79.148a76.4 76.4 0 0 0-.086 5.39c.043 2.331.2 4.584.463 6.758a59.35 59.35 0 0 0 1.44 7.786 55.746 55.746 0 0 0 1.788 5.718 48.21 48.21 0 0 0 1.225 2.987 48.458 48.458 0 0 0 2.13 4.221 48.245 48.245 0 0 0 4.318 6.367 51.701 51.701 0 0 0 1.974 2.317 51.018 51.018 0 0 0 6.705 6.16c2.821 2.174 5.878 4.085 9.141 5.746.463.236.933.471 1.41.699 2.844 1.369 5.83 2.545 8.928 3.558.47.157.948.299 1.425.449.335-1.141.635-2.31.912-3.508.05-.214.1-.435.143-.656.192-.884.37-1.782.534-2.695.072-.392.136-.784.2-1.183a64.732 64.732 0 0 0 .513-3.929c.035-.342.064-.698.092-1.041.079-.912.15-1.832.2-2.773 0-.093.014-.185.021-.278v-.064c.357-7.03-.213-13.383-1.546-19.115a60.208 60.208 0 0 0-.955-3.593 52.976 52.976 0 0 0-1.111-3.308 48.869 48.869 0 0 0-9.277-15.486c-3.762-4.228-8.23-7.778-13.267-10.687a61.548 61.548 0 0 0-3.662-1.947 70.724 70.724 0 0 0-9.604-3.87c-.456-.15-.912-.293-1.375-.429h-.015l-.021.079c-1.44 4.912-2.358 10.33-2.658 16.312l.015.015Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M58.287-54H477.02v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#F0F1F2",
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M101 31h342v8H101zM91 51h352v8H91zm0 21h161v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#505258",
        fillRule: "evenodd",
        clipPath: "url(#g)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#B3B9C4",
        d: "M55.525 29.792h21.919v5.023H55.525z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M82.924 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        d: "M89.545 31.961h2.969v-2.853h.684V35.5h-.684v-2.853h-2.97V35.5h-.684v-6.392h.685v2.853Zm5.465.721c.213 0 .399.031.555.093a.822.822 0 0 1 .363.259c.085.11.128.239.128.388v.004a.559.559 0 0 1-.278.496.809.809 0 0 1-.27.108v.014a.837.837 0 0 1 .481.189.53.53 0 0 1 .177.417v.003a.741.741 0 0 1-.14.452.882.882 0 0 1-.396.294 1.672 1.672 0 0 1-.614.101 1.44 1.44 0 0 1-.577-.107.935.935 0 0 1-.391-.303.877.877 0 0 1-.165-.463l-.002-.024h.748l.003.022a.27.27 0 0 0 .06.135c.032.04.075.073.13.097a.483.483 0 0 0 .192.035.45.45 0 0 0 .19-.037.3.3 0 0 0 .122-.104.278.278 0 0 0 .043-.152v-.003a.233.233 0 0 0-.107-.208.56.56 0 0 0-.312-.072h-.275V33.8h.275c.082 0 .151-.01.208-.031a.289.289 0 0 0 .13-.09.231.231 0 0 0 .046-.144v-.003a.25.25 0 0 0-.152-.242.389.389 0 0 0-.172-.036c-.07 0-.13.013-.182.037a.286.286 0 0 0-.12.102.325.325 0 0 0-.054.151l-.002.017h-.707l.002-.027a.858.858 0 0 1 .153-.452.879.879 0 0 1 .366-.294 1.31 1.31 0 0 1 .544-.106Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m99.834 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M109.865 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 1.027,
        d: "M119.797 32.304c.788 0 1.427-.553 1.427-1.341 0-.789-.639-1.342-1.427-1.342h-2.112v2.683m2.112 0h.457c.788 0 1.427.553 1.427 1.341 0 .788-.639 1.342-1.427 1.342h-2.569v-2.683m2.112 0h-2.112"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M133.154 29.108h2.968v.684h-1.1l-1.205 5.023h1.163v.685h-2.968v-.684h1.1l1.206-5.024h-1.164v-.684Zm8.233 2.269 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M151.419 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "M159.067 33.674v-.171l.586-1.541m3.296 1.712v-.171l-.583-1.541m0 0-1.121-2.969h-.465l-1.127 2.969m2.713 0h-2.713"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#44546F",
        strokeWidth: 1.37,
        d: "M164.662 35.272h-7.307"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m168.329 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "m183.269 31.048-.57 1.598.285.286m.285-1.884 2.829-1.975a.286.286 0 0 1 .366.032l.575.575a.285.285 0 0 1 .032.366l-1.975 2.829m-1.827-1.827 1.827 1.827m0 0-1.598.57-.286-.285m-.228-.228-.514.514.229.228.513-.514m-.228-.228.228.228"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#172B4D",
        strokeWidth: 1.37,
        d: "M188.407 35.272h-7.306"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m192.074 31.377 1.812 1.813 1.813-1.813.484.484-2.054 2.055a.343.343 0 0 1-.485 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M202.105 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M214.891 30.25h-6.392v-.686h6.392v.685Zm0 2.397h-6.392v-.685h6.392v.685Zm-3.196 2.397h-3.196v-.685h3.196v.685Zm7.32-3.667 1.813 1.813 1.812-1.813.485.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Zm14.142-1.47a.57.57 0 1 1 1.141-.001.57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.685h4.567v.685Zm-6.393 2.055a.57.57 0 1 1 1.141 0 .57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.684h4.567v.684Zm-6.393 2.055a.57.57 0 1 1 1.14 0 .57.57 0 0 1-1.14 0Zm6.393.343h-4.567v-.685h4.567v.685Zm4.123-3.667 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M253.705 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M263.396 29.664a1.795 1.795 0 1 1 2.539 2.54l-1.028 1.027-.484-.484 1.027-1.028a1.11 1.11 0 1 0-1.57-1.57l-1.028 1.027-.484-.484 1.028-1.028Zm1.397 1.626-2.511 2.512-.485-.484 2.512-2.512.484.484Zm-4.137 1.114 1.027-1.027.485.484-1.028 1.028a1.11 1.11 0 1 0 1.571 1.57l1.027-1.027.484.484-1.027 1.027a1.795 1.795 0 1 1-2.539-2.539Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M272.427 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M278.364 30.078c0-.662.536-1.199 1.198-1.199h4.909a1.2 1.2 0 0 1 1.199 1.199v3.767a1.2 1.2 0 0 1-1.199 1.199h-4.076l-1.519.868a.343.343 0 0 1-.512-.297v-5.537Zm1.198-.514a.514.514 0 0 0-.513.514v4.946l1.165-.665h4.257c.284 0 .514-.23.514-.514v-3.767a.514.514 0 0 0-.514-.514h-4.909Zm4.282 2.055h-3.654v-.685h3.654v.685Zm-1.37 1.37h-2.284v-.685h2.284v.685Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#B3B9C4",
        d: "M288.41 29.793h21.919v5.023H288.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M315.808 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M321.744 32.304a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M334.529 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#44546F",
        d: "M342.91 28.65a.628.628 0 0 0-.579.872l.041.08.377.628v1.587a2.22 2.22 0 0 0-.541.279c-.419.297-.829.823-.829 1.692 0 .19.153.343.342.343h2.055v1.826h.685V34.13h2.055a.343.343 0 0 0 .343-.342c0-.869-.411-1.395-.83-1.692a2.25 2.25 0 0 0-.54-.28V30.23l.376-.628a.628.628 0 0 0-.538-.951h-2.417Zm1.942 1.309a.34.34 0 0 0-.048.176v1.94c0 .168.121.311.286.339h.004l.03.007a1.552 1.552 0 0 1 .509.234c.211.15.428.39.508.79h-4.045c.08-.4.297-.64.508-.79a1.556 1.556 0 0 1 .51-.234l.03-.007h.003a.342.342 0 0 0 .287-.338v-1.941a.342.342 0 0 0-.049-.176l-.374-.623h2.215l-.374.623Z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#292A2E",
        d: "M143.186 68.735c.141 0 .586 3.665.305 5.157.482.302.897 1.064.875 1.858 2.034 1.56.772-2.411.352-3.645-.342.828-.07-1.266-.333-1.589.016.178-.352-3.375-1.016-2.393-.085-.11-.354.712-.185.61l.002.002Zm-7.937 3.73c.135.784-.204 1.446-.751 2.075.334 2.71 2.44-1.575 2.936-2.62 0 0 .912-1.817.922-1.593.352-.138 2.323-2.659 1.016-2.603-.373.393-.718 1.363-1.123 1.35-.904.194-1.934 2.682-2.999 3.395l-.001-.004Zm-6.428-7.115c-.435 1.7 2.805.443 4.076.388 0 0 1.318.014 1.68-.215-.191-.002 4.487-.226 2.034-1.145-.066.023-1.686.097-1.686.097-2.117-.528-4.351.11-6.106.877l.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#0C66E4",
        fillOpacity: 0.14,
        d: "M314 47.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 45h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M149.798 43.71a6.006 6.006 0 0 0-3.969 1.339 6.026 6.026 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.143-2.287 1.143h-1.143v3.431h1.143a6.026 6.026 0 0 0 3.968-1.338 5.965 5.965 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V52.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V43.71h-1.212Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#000",
        d: "M149.798 45.998v-1.143a4.574 4.574 0 0 0-3.969 1.875 4.574 4.574 0 0 0-3.968-1.875v1.143a3.213 3.213 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.635 4.635 0 0 0 3.968-1.864 4.636 4.636 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.211 3.211 0 0 1 3.362-2.115Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M0 0h477v81H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-259-118.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -54,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M31.03-25.464a3.932 3.932 0 0 1 3.932-3.932h487.581v374.861H31.03V-25.464Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M45.48 28.65h7.306v7.307H45.48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "e",
        width: 324.211,
        height: 29.225,
        x: 34.52,
        y: 21.345,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 3.653
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 0.228
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "effect1_dropShadow_13247_133684",
        result: "effect2_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13247_133684",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "h",
        width: 14.866,
        height: 25.095,
        x: 138.431,
        y: 42.565,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13247_133684",
        result: "shape"
    }))));
};
const $3faf0024169aae07$var$BannerImageDark = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 81",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "c",
        width: 686,
        height: 389,
        x: -260,
        y: -119.5,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-260-119.5h686v389h-686z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#48245D",
        strokeWidth: 2,
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z",
        mask: "url(#c)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M178.953-.348c-7.944-.014-15.689-1.098-23.256-2.445l-.107-1.448c.535 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.275-1.098-1.902-1.655A311.884 311.884 0 0 1 178.953-.348Zm18.289 11.129v-.07c-.022-.507-.043-1.027-.064-1.548v-.171a227.748 227.748 0 0 1-.1-3.415c0-.121 0-.242-.007-.37l-.022-1.32c0-.2 0-.4-.007-.599 0-.399-.007-.798-.014-1.205V-.333c0-.92.014-1.826.036-2.731a40.672 40.672 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311.19 311.19 0 0 1-.164-3.202v.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M181.937.023c.328.278 2.38 2.039 2.644 2.267-.342-.406-1.269-1.333-2.608-2.688h.249c-.477-.15.727-.292 1.846-.285h-.015l-.37.228c3.035-.242 5.921-.649 8.678-1.247a40.67 40.67 0 0 0 4.696-1.362c.021-.877.049-1.74.085-2.602l-.484.192c-.478.185-.969.32-1.454.478-.962.335-1.952.57-2.921.805-3.912.927-7.788 1.29-11.329 1.412-.435.014-.869.029-1.297.036a430.203 430.203 0 0 1-6.726-6.916c-5.6-5.882-12.162-13.425-17.435-21.11-.028.37-.064.74-.092 1.118-.029.386-.05.785-.079 1.17.243.335.471.656.684.94.955 1.327 1.703 2.368 2.316 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.488 6.43 9.782 12.783 15.582 19.014a409.898 409.898 0 0 0 5.757 6.01c-1.86-.02-3.584-.092-5.144-.156-5.337-.456-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.106 1.448 7.567 1.34 15.312 2.424 23.256 2.445a311.916 311.916 0 0 0 13.374 12.67c.627.556 1.268 1.105 1.902 1.654h2.858c-1.376-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91h-.036Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M197.171 8.985c-.022-.556-.036-1.112-.057-1.69l-.043-1.725c.028 1.176.057 2.31.1 3.415Zm-.15-6.902c0 .407.007.806.014 1.205 0-.399-.007-.798-.014-1.204ZM372.866-38.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.001c-8.208 0-14.977 1.91-19.338 6.36-.484.491-.94 1.02-1.36 1.575-.214.278-.414.563-.613.863-2.152 3.244-3.342 7.479-3.342 12.847 0 4.25.884 10.702 1.404 16.056.035.357.071.706.1 1.056h-19.523a321.835 321.835 0 0 1-.164-3.202c.05 1.106.1 2.168.164 3.202.513 8.933 1.439 15.264 2.123 20.419h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01a64.67 64.67 0 0 0 10.175-7.372v-92.749h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068ZM197.043 3.887c0 .45.014.884.021 1.32l-.021-1.32Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M383.126-107.549c0 8.691-1.632 15.386-4.752 20.37-1.561 2.488-3.492 4.555-5.786 6.216a23.495 23.495 0 0 1-3.705 2.203c-1.482.72-3.078 1.305-4.781 1.79-.869.25-1.767.47-2.693.663-3.178.649-6.676.963-10.481.963h-74.599c-.755 0-1.51 0-2.251.021-3.62.057-7.111.25-10.488.57-.385.036-.777.072-1.154.114l-.357.043-.79.086c-3.235.37-6.363.855-9.363 1.469-4.068.834-7.923 1.889-11.556 3.172-.513.178-1.019.37-1.525.556-.1.036-.207.079-.307.114-.306.114-.605.243-.912.364-6.483 2.567-12.219 5.889-17.178 9.939a60.552 60.552 0 0 0-2.173 1.86c-4.631 4.178-8.522 9.048-11.657 14.61-.106.184-.206.377-.313.57-.093.17-.192.342-.285.513-.257.47-.506.955-.748 1.433-3.064 6.067-5.294 12.883-6.655 20.433a94.92 94.92 0 0 0-.527 3.294c-.029.214-.064.42-.093.628a107.939 107.939 0 0 0-.869 9.874 156.42 156.42 0 0 0-.086 2.603c-.021.905-.035 1.81-.035 2.73V2.07c0 .406.007.806.014 1.205 0 .2 0 .4.007.599 0 .45.014.884.022 1.319a1907.277 1907.277 0 0 0 .049 2.096c.015.57.036 1.134.057 1.69v.17l.065 1.548v.071c.049 1.105.099 2.168.163 3.202h19.523c-.029-.35-.064-.7-.1-1.056-.52-5.354-1.403-11.814-1.403-16.056 0-5.361 1.189-9.596 3.341-12.847.193-.293.399-.585.613-.863a15.88 15.88 0 0 1 1.361-1.576c4.353-4.449 11.129-6.36 19.337-6.36h65.001c23.42 0 48.607-2.716 67.788-14.009 18.703-11.015 31.692-30.201 31.692-63.069v-16.626h-21.432v10.944h.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        stroke: "#35243F",
        d: "M78.564-67.346c6.518.516 13.329 1.303 20.446 2.368L89.568-2.562C66.492-5.657 49.39-4.285 37.425 1.862 25.46 8.01 18.722 18.886 16.243 34.575l-60.965-9.233c4.02-26.155 12.06-47.013 25.019-62.325 46.462 3.56 78.159-6.886 98.267-30.363Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M293.564 15.808s.499 65.85 0 65.422c0 0 15.127 2.074 32.384 2.573-.05-15.749-.171-32.675-.193-35.94v-.57a75.38 75.38 0 0 0 2.515.82 66.27 66.27 0 0 0 2.202.648c.634.178 1.268.35 1.909.506.157.043.314.079.471.122.677.17 1.361.328 2.037.484.093.022.179.036.271.058.627.135 1.247.27 1.874.392.135.028.271.057.406.078.691.135 1.382.257 2.066.378.1.014.2.036.3.05.634.107 1.268.207 1.895.3.107.014.214.035.321.05.698.099 1.403.192 2.101.284.093.015.193.022.285.036.67.078 1.333.157 1.995.221.057 0 .114.014.171.021.713.072 1.433.136 2.138.193.078 0 .164.014.242.021 1.447.114 2.879.2 4.304.264h.164c1.453.057 2.885.093 4.303.1h.064c1.447.007 2.872 0 4.275-.043V16.371s-36.907 10.431-68.5-.563Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M348.705 51.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021Zm-11.691-1.612c.135.029.27.058.406.079a8.538 8.538 0 0 0-.406-.079Zm-4.646-1.055c.157.043.314.079.47.121a11.683 11.683 0 0 1-.47-.12Zm-4.588-1.304c.164.05.328.1.485.15-.164-.05-.328-.1-.485-.15Zm2.507.748c.057.014.114.029.178.05-.057-.014-.114-.028-.178-.05Zm16.109 3.009c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021Zm-20.448 32.083c.049 15.1.028 29.104-.2 28.911 0 0 45.222 6.203 68.5-.285v-64.58s-14.029 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.109 2.852l-.007.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M357.718 52.319c-1.418-.007-2.85-.043-4.304-.1h-.163a111.47 111.47 0 0 1-4.304-.264c-.078 0-.164-.014-.242-.021-.713-.057-1.425-.121-2.138-.193-.057 0-.114-.014-.171-.021a196.13 196.13 0 0 1-1.995-.221c-.092-.014-.192-.021-.285-.036a74.149 74.149 0 0 1-2.102-.285c-.106-.014-.213-.035-.32-.05a87.475 87.475 0 0 1-1.895-.3c-.1-.014-.2-.035-.3-.05a95.943 95.943 0 0 1-2.472-.455c-.627-.122-1.247-.257-1.874-.393-.093-.02-.178-.035-.271-.057a69.432 69.432 0 0 1-2.508-.606c-.634-.164-1.275-.328-1.909-.506-.057-.014-.114-.028-.178-.05-.677-.192-1.347-.392-2.024-.599-.164-.05-.328-.1-.484-.15a75.03 75.03 0 0 1-2.031-.67v.571c.021 3.265.143 20.198.192 35.94 12.583.364 26.299-.12 36.11-2.852V52.283c-1.404.036-2.829.05-4.275.043h-.064l.007-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M86.99 59.598c.192-.97.491-2.21.883-3.8.499-2.281 1.653-6.032 2.807-9.333 1.155-3.308 2.26-6.188 2.202-6.958-1.097 2.873-2.7 6.987-3.883 10.873-1.204 3.878-2.002 7.507-2.01 9.225v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M69.927 69.016c5.037 2.91 9.504 6.46 13.266 10.688l.043-.4c1.104-9.667 2.772-18.936 5.215-27.427 2.409-8.499 5.658-16.177 9.356-22.715a86.304 86.304 0 0 1 2.671-4.406c-.954.17-1.902.356-2.842.563-16.017 3.486-29.512 11.714-37.464 25.795 2.658 5.069 5.337 10.117 8.144 15.093.528.941 1.076 1.868 1.618 2.802l-.007.007Zm61.146 17.233c.755 3.885 1.866 7.785 3.355 11.521.157-.085.307-.178.464-.264-1.219-3.065-2.501-7.436-3.285-11.764-.898-4.548-1.211-8.997-1.817-11.642.15 3.9.506 8.013 1.283 12.156v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M137.307 33.418a141.891 141.891 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.404 21.596-3.456 7.771-6.099 16.106-7.538 24.804a90.61 90.61 0 0 0-1.233 15.457c.135.007.271.014.406.028l1.532.093c.513.007 1.019-.028 1.525-.036.506-.028 1.011 0 1.51-.092 1.005-.136 1.995-.214 2.986-.435 6.384-1.184 12.027-3.479 16.366-5.804-.52-1.226-.962-2.495-1.432-3.757-.314-.827-.528-1.69-.791-2.538-.25-.856-.528-1.697-.706-2.574l-.598-2.602c-.185-.87-.307-1.754-.456-2.624-.335-1.74-.442-3.508-.641-5.24-.214-3.48-.3-6.902-.022-10.16.435-6.523 1.746-12.356 3.199-16.854-.399 1.84-1.596 6.373-2.28 11.592l.243.122c.762-6.025 2.629-12.07 5.001-17.739 2.394-5.675 5.23-11.015 8.408-15.8 0 0-.62.735-1.504 1.926a56.993 56.993 0 0 0-3.092 4.663c-1.076 1.81-2.144 3.736-2.928 5.447-.413.848-.791 1.618-1.105 2.267l-.691 1.568v-.078l-.085.15c1.539-4.021 3.398-8.078 5.835-11.957 1.618-2.595 3.499-5.112 5.686-7.407a69.887 69.887 0 0 0-.734-.193c-2.586 1.818-4.909 4.17-7.104 6.73v-.02Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M131.343 60.354c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.157-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.019-4.934 1.09-5.397.064-.464-.257.192-.62 1.476v.014ZM66.27 67.07c-2.537-4.534-4.945-9.097-7.317-13.66a2.11 2.11 0 0 1-.122.22c-1.396 2.824-2.572 5.868-3.534 9.134.464.142.92.285 1.376.427a73.399 73.399 0 0 1 9.604 3.872l-.007.007Zm-3.49-8.634c.74 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.774-8.384-3.028-4.79Zm54.72 1.397c1.503-2.866 2.743-5.105 3.969-7.329 1.246-2.21 2.493-4.413 4.203-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.272 8.634-1.831 3.244-3.164 6.132-2.843 6.203l.114-.236.007-.007Zm-1.825 4.577-.178-.22c-1.995 4.605-3.769 9.39-5.13 14.38l.2.228c1.332-4.898 3.177-9.91 5.108-14.387Zm29.569-36.867.05-.057c.164-.157.313-.306.456-.442a5.425 5.425 0 0 1-.342-.093c-.114.129-.228.264-.349.414l.178.178h.007Zm31.607 25.446c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.847-4.712 1.246-7.115.699-4.813 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M178.738 61.324c-.826 16.583-3.37 33.288-8.528 47.832a111.022 111.022 0 0 1-4.96 11.828l2.679-.399a37.628 37.628 0 0 0-.427 1.961c-.036.178-.064.356-.1.527a45.054 45.054 0 0 0-.249 1.612c-.014.121-.036.242-.05.363-.057.485-.1.97-.142 1.455.812.221 1.617.427 2.422.598-2.636-.27-2.337-.128-.342.286.05.007.107.021.157.028 5.272-4.327 9.661-9.71 12.882-16.284 3.448-7.023 5.629-15.343 6.12-25.175.499-9.981-.848-18.594-3.612-26.009a49.36 49.36 0 0 0-5.665-10.887c.114 4.086.022 8.185-.185 12.264Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M159.743 76.274c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.463-.4.962-.82.249-.214.499-.42.677-.592.185-.17.306-.285.313-.292a59.435 59.435 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65.376 65.376 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a43.595 43.595 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.528-.078.784-.114.399-.791.77-1.604 1.161-2.396 1.048-2.074 1.874-4.249 2.786-6.388.428-1.076.805-2.181 1.212-3.265l.598-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.377-2.274.57-3.408l.47-3.415.235-1.704.185-1.711c.129-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.022 0-.042-.007-.085-.007-.128a49.15 49.15 0 0 0-3.669-3.836c-.022 2.025-.235 4.022-.556 5.968-1.938 10.701-6.284 20.512-11.906 29.025l-.014-.022ZM129.035 66.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.314.079-1.02.107-1.625.029-.6.057-1.098-.157-1.006h-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M161.988 72.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13Zm-16.109-42.157c-2.473 2.816-4.56 6.039-6.37 9.44-3.577 6.837-6.17 14.33-7.439 22.023-.142.963-.342 1.918-.434 2.888l-.314 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.535 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.055-2.723 5.273-3.621.591-.47 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.05-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.148.349-.742.876-1.804 1.432-3.145a73.816 73.816 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.014-.235-.05-.463-.071-.698-5.8-4.656-12.697-8.178-20.357-10.66-.256-.085-.52-.156-.776-.235a36.67 36.67 0 0 0-2.123 2.232v.007Zm23.683 18.944c.285-1.255.492-2.802.627-3.594.086-1.554.022-2.139-.043-2.103-.078.036-.149.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.136.35.449-.606.72-1.86h.007Zm-68.458-21.689c.342-.663.513-.962.485-.97-.022-.007-.242.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.807 5.169-4.425 8.905-1.61 3.743-3.199 8.177-4.567 12.926-2.743 9.51-4.375 20.276-5.272 28.953-.057.578-.114 1.14-.171 1.697 3.042 3.871 5.536 8.263 7.374 13.204a57.52 57.52 0 0 1 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.263.855.556 1.311.798.45.243.905.478 1.361.72.45.257.92.464 1.397.663l1.418.613 1.467.499.734.25.748.185 1.504.371h.007c0-1.091 0-2.189.043-3.287.334-11.15 2.785-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.43-29.51 1.682-2.26 3.385-4.477 5.187-6.651 1.81-2.168 3.741-4.285 5.943-6.16l.128-.107c-5.693-1.262-11.685-2.047-17.898-2.353-6.719-.335-13.295-.064-19.565.855a84.573 84.573 0 0 0-3.798 5.975c.705-1.419 1.275-2.403 1.617-3.066v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M175.076 72.267c-.128 1.134-.249 2.275-.377 3.409l-.186 1.71-.235 1.705c-.157 1.133-.313 2.274-.47 3.415-.185 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.697-.677 3.393-.791 3.373-.399 1.69-.456 1.675-.919 3.351-1.054 3.315c-.178.549-.342 1.112-.535 1.654l-.598 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.763 1.604-1.162 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15.05-.1.121-.243.214-.421.164-.37.392-.905.662-1.54.528-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.214.171c-.52 1.775-1.083 3.857-1.91 5.996-.399 1.069-.784 2.189-1.247 3.287-.477 1.09-.954 2.196-1.432 3.294-.456 1.105-1.033 2.153-1.546 3.186-.264.507-.513 1.013-.769 1.512.37-.057.719-.107 1.054-.157.128-.257.257-.513.378-.77l.142.292-.214.428c.157-.021.3-.043.449-.064a109.559 109.559 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45.124 45.124 0 0 0-1.61-2.181c.093 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.384 4.998-1.011 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.474 6.894.997-6.26 2.878-16.768 3.747-27.834.463-5.525.834-11.172.884-16.426a118.14 118.14 0 0 0-.107-6.823c-.285-.35-.57-.7-.862-1.041 0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021l.028.014Zm-6.462 40.311c-.292.813-.442.999-.812 1.804-.3.157.163-.919.627-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078Zm-.941-60.338a74.31 74.31 0 0 1-3.641 10.616c-.562 1.34-1.083 2.403-1.432 3.145-.342.741-.563 1.147-.563 1.147-1.154 2.318-2.451 4.57-3.804 6.78-1.404 2.182-2.865 4.328-4.453 6.389-1.596 2.046-3.249 4.057-5.031 5.953-1.774 1.904-3.598 3.757-5.571 5.433 0 0-.157.142-.471.385-.313.25-.776.613-1.368 1.09-1.218.906-2.964 2.225-5.272 3.623-.15.092-.307.185-.456.278.292.706.605 1.397.912 2.089a59.741 59.741 0 0 0 4.788-3.366s-.136.122-.314.293c-.178.17-.434.378-.677.591-.491.421-.933.799-.961.82 3.933-2.659 7.673-5.874 11.022-9.46a84.976 84.976 0 0 0 9.362-11.757c5.622-8.513 9.975-18.316 11.906-29.025a38.45 38.45 0 0 0 .556-5.968 55.617 55.617 0 0 0-3.078-2.673c.021.235.057.463.071.699.314 4.128-.42 8.748-1.532 12.925l.007-.007Zm-5.685 19.87c-3.855 6.21-.065-.94 1.617-3.13a38.858 38.858 0 0 1-1.617 3.13Zm8.165-28.91c.057-.036.128.542.043 2.103-.136.792-.35 2.346-.627 3.594-.278 1.254-.585 2.21-.72 1.86.207-1.226.784-4.106 1.019-5.946.142-.92.214-1.575.292-1.611h-.007ZM88.45 51.877c-2.444 8.491-4.111 17.76-5.215 27.428l-.043.399a48.92 48.92 0 0 1 1.902 2.281c.057-.556.114-1.12.171-1.697.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.617-3.736 3.199-6.809 4.424-8.905.592-1.062 1.119-1.868 1.461-2.424.349-.563.57-.841.592-.834.028.007-.143.306-.485.97-.342.662-.912 1.646-1.617 3.065a86.36 86.36 0 0 1 3.797-5.974 74.35 74.35 0 0 0-2.807.456 85.949 85.949 0 0 0-2.672 4.406c-3.698 6.538-6.947 14.216-9.355 22.715l.007-.007Zm2.23-5.412c-1.154 3.309-2.308 7.052-2.807 9.333-.392 1.59-.691 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.055 3.65-2.202 6.958v.007Zm21.988 82.747a78.014 78.014 0 0 1-3.071-13.24 82.354 82.354 0 0 1-.762-8.755c.399.029.79.057 1.182.078.314.015.627.05.941.043l.933-.028c.62-.029 1.247-.015 1.86-.079 2.494-.249 4.816-.72 7.161-1.312 2.337-.598 4.638-1.383 6.932-2.302a53.578 53.578 0 0 0 6.227-3.002c-.149-.335-.313-.656-.456-.991-.178-.37-.349-.749-.506-1.134-4.339 2.325-9.989 4.62-16.366 5.804-.99.221-1.98.299-2.985.435-.499.085-1.005.064-1.511.092-.505.008-1.018.05-1.524.036l-1.532-.093c-.136-.007-.271-.021-.406-.028a90.712 90.712 0 0 1 1.232-15.457c1.432-8.698 4.083-17.033 7.539-24.804 3.455-7.771 7.709-14.987 12.404-21.596a141.563 141.563 0 0 1 7.353-9.468c2.188-2.56 4.517-4.905 7.104-6.73a94.78 94.78 0 0 0-3.662-.891c-.043.035-.086.07-.129.107-2.208 1.875-4.132 4-5.942 6.16-1.803 2.167-3.505 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.43 29.51-4.083 10.53-6.534 21.703-6.869 32.853a83.783 83.783 0 0 0-.042 3.287h-.008l-1.503-.371-.748-.185-.734-.25-1.468-.499-1.418-.613a12.374 12.374 0 0 1-1.396-.663l-1.36-.72c-.45-.242-.877-.535-1.312-.798-.876-.514-1.696-1.113-2.515-1.704-.036-.029-.071-.05-.1-.079.357 1.17.67 2.367.955 3.593 1.41.899 2.85 1.704 4.31 2.403 2.373 1.148 4.86 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.112 2.702 2.508 5.34 4.232 7.735.186.015.364.029.549.036a37.958 37.958 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.599-2.303c-.171-.685-.285-1.283-.399-1.775l-.335-1.533c.428 1.64.841 3.287 1.361 4.926a60.26 60.26 0 0 0 1.66 4.913c1.24 3.251 2.8 6.466 4.881 9.382.192.271.392.535.598.799.691.035 1.383.05 2.074.071-.064-.078-.136-.143-.193-.221-2.835-3.458-4.788-7.614-6.227-11.914l-.014.029Zm7.559-75.346c1.81-3.251 4.147-6.83 5.273-8.634l.178.193c-1.71 2.659-2.957 4.862-4.204 7.072-1.225 2.225-2.465 4.463-3.968 7.33l-.114.235c-.314-.072 1.011-2.96 2.843-6.203l-.008.007Zm-4.738 10.324.178.22c-1.93 4.478-3.776 9.49-5.108 14.388l-.2-.228c1.361-4.99 3.135-9.774 5.13-14.38Zm-12.953 40.147c-.37-.114-.577-.214-.705-.314-.257-.207-.235-.371-.677-.72.719.392 3.527 1.305 2.878 1.29l.235.1c-.826-.064-1.353-.249-1.731-.349v-.007Zm4.346 8.684c-.263-1.804-.32-3.223-.377-4.193-.007-.976.021-1.518.078-1.582.114-.129.235 1.639.527 5.575l.022.178-.25.014v.008ZM69.926 69.016a562.81 562.81 0 0 1-1.617-2.802c-2.807-4.976-5.486-10.031-8.144-15.093a53.76 53.76 0 0 0-1.225 2.296c2.372 4.563 4.787 9.126 7.317 13.66a63.866 63.866 0 0 1 3.662 1.947l.007-.008Zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "m133.622 46.251.093-.15v.08c.164-.364.399-.906.691-1.57.314-.648.691-1.418 1.105-2.267.783-1.704 1.852-3.636 2.928-5.447a56.958 56.958 0 0 1 3.092-4.662c.884-1.191 1.504-1.925 1.504-1.925-3.178 4.784-6.014 10.124-8.408 15.799-2.373 5.668-4.239 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.453 4.5-2.757 10.331-3.199 16.855-.278 3.258-.192 6.68.021 10.16.2 1.732.307 3.493.642 5.24.156.87.27 1.754.456 2.623l.598 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.471 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.307.663.456.991a43.144 43.144 0 0 0 1.824 3.614 54.821 54.821 0 0 0 2.608 4.221 53.39 53.39 0 0 0 5.771 7.087 47.479 47.479 0 0 0 5.829 5.069c-.129-.228-1.39-1.112-2.622-2.21-.635-.535-1.226-1.148-1.732-1.69-.484-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.917-.286 2.836-.421a40.767 40.767 0 0 1-3.584-2.317c-5.187-3.729-9.911-8.819-13.595-14.901a61.437 61.437 0 0 1-2.565-4.734 55.475 55.475 0 0 0-.506-1.14c-.306-.692-.619-1.384-.912-2.09a27.164 27.164 0 0 1-.698-1.825c-.684-1.711-1.168-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.933.128-3.865.242-5.804l.314-2.902c.092-.97.299-1.925.434-2.887 1.269-7.693 3.855-15.186 7.439-22.023 1.81-3.401 3.897-6.624 6.37-9.44a36.67 36.67 0 0 1 2.123-2.232 74.296 74.296 0 0 0-2.252-.677 13.84 13.84 0 0 1-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.043-.27-.071-2.181 2.296-4.069 4.813-5.686 7.408-2.437 3.885-4.296 7.935-5.835 11.956l-.008.021Zm-4.424 21.36c-.029.6-.107 1.305-.107 1.626-.057-.449-.249-1.283-.221-1.803.029-.364.1-.457.164-.828.221-.092.185.407.157 1.006h.007Zm10.466 41.973c-.399-.349-.79-.92-1.161-1.512-.356-.598-.67-1.219-.955-1.654.164-.092.834.799 1.418 1.647.584.849 1.055 1.669.698 1.519Zm-8.065-23.849c.784 4.328 2.066 8.698 3.285 11.764.064.164.128.335.192.492.242.52.499 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.271 1.047 1.319 2.08 2.566 3.114 3.643.356.392.755.784 1.175 1.183.413.414.855.827 1.34 1.248-5.28-4.057-10.218-10.402-13.445-17.724a50.49 50.49 0 0 1-.599-1.419c-.099-.235-.192-.478-.285-.713-1.489-3.729-2.6-7.636-3.356-11.522-.776-4.142-1.132-8.256-1.282-12.156.598 2.646.912 7.095 1.817 11.643l.007.007Zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.199.442-.299.528l.05.035s-.079.385-.15.97c-.057.577-.192 1.347-.221 2.132l-.192 3.28-.249-.05c-.008-1.555.049-3.637.406-5.619.263-1.996.783-3.9 1.125-5.183.364-1.283.684-1.94.62-1.476v-.014Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243F",
        d: "M93.459 137.325a45.18 45.18 0 0 1-1.425-.449 72.597 72.597 0 0 1-6.042-2.253 62.083 62.083 0 0 1-2.886-1.304 69.158 69.158 0 0 1-2.793-1.426c-10.523-5.704-18.824-14.11-23.52-25.574-.206-.499-.398-1.006-.59-1.512a56.423 56.423 0 0 1-2.473-8.748 60.143 60.143 0 0 1-.755-4.763c-.456-3.807-.592-7.85-.378-12.156.3-5.981 1.218-11.4 2.658-16.312-7.332-2.239-15.255-3.55-23.499-3.964-9.22-.464-18.083.128-26.255 1.896C-11.656 64.468-25.68 73.458-33.323 89c-3.492 7.102-5.7 15.529-6.2 25.518-.49 9.839.842 18.33 3.57 25.666 2.929 7.871 7.517 14.352 13.374 19.571 0-.078.014-.157.021-.235.043-.549.072-1.098.093-1.654 0-.121.014-.235.014-.357.022-.656.022-1.311.008-1.975 0-.121-.008-.249-.015-.37a31.844 31.844 0 0 0-.085-1.633l-.043-.542a31.428 31.428 0 0 0-.228-1.989s37.542 9.575 37.356 9.276v.071c0 .043-.007.1-.014.171v.029c0 .071-.014.164-.021.263 0 .029 0 .05-.007.079-.008.107-.022.221-.036.349 0 .029 0 .057-.007.086-.014.142-.029.299-.05.47v.029c-.021.171-.036.356-.057.556 0 .028 0 .057-.007.085-.021.2-.043.407-.071.628 0 .043-.008.085-.015.135-.028.221-.05.449-.078.685 0 .057-.014.107-.021.164-.029.242-.064.499-.093.755 0 .05-.014.1-.021.157-.036.278-.072.556-.114.849a.637.637 0 0 1-.015.114c-.035.285-.078.577-.12.877 0 .043-.015.078-.015.121-.043.314-.093.627-.135.955-.008.065-.022.129-.029.193-.05.321-.1.649-.15.984-.014.071-.02.142-.035.214-.05.335-.107.677-.164 1.026a1.84 1.84 0 0 1-.036.193c-.057.363-.12.727-.185 1.098-.007.05-.021.107-.028.157-.065.363-.129.734-.2 1.105 0 .035-.014.071-.021.1-.072.392-.15.784-.221 1.183-.014.057-.021.121-.036.178l-.17.863c4.353.756 8.87 1.241 13.494 1.476 8.77.442 17.292-.15 25.215-1.868 17.008-3.686 31.165-12.691 38.86-28.319 1.404-2.845 2.58-5.911 3.541-9.197.328-1.134.627-2.303.905-3.494a62.925 62.925 0 0 1-.912 3.508l-.014.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245D",
        d: "M52.605 79.147c-.214 4.307-.078 8.35.378 12.157a60.226 60.226 0 0 0 .755 4.763 56.211 56.211 0 0 0 2.472 8.747c.193.514.385 1.013.591 1.512 4.696 11.464 12.996 19.87 23.52 25.574A65.93 65.93 0 0 0 86 134.63a75.19 75.19 0 0 0 6.042 2.253c.47.157.947.3 1.425.449.335-1.14.634-2.31.912-3.507.05-.214.1-.435.142-.656a72.775 72.775 0 0 0 .734-3.886 64.059 64.059 0 0 0 .513-3.928c.036-.35.064-.699.1-1.056.078-.905.15-1.818.2-2.752 0-.099.014-.199.02-.306v-.057c.357-7.03-.213-13.382-1.545-19.115a60.129 60.129 0 0 0-.955-3.593 52.91 52.91 0 0 0-1.112-3.308c-1.838-4.941-4.332-9.326-7.374-13.204a48.92 48.92 0 0 0-1.902-2.282c-3.762-4.228-8.23-7.778-13.267-10.687a61.698 61.698 0 0 0-3.662-1.947 70.724 70.724 0 0 0-9.605-3.87c-.456-.15-.912-.293-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312l.007.007Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1D2125",
        d: "M58.287-54H477.02v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#303134",
        clipPath: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M101 31h342v8H101zM91 51h352v8H91zm0 21h161v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#22272B",
        rx: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#505258",
        fillRule: "evenodd",
        clipPath: "url(#h)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#454F59",
        d: "M55.525 29.792h21.919v5.023H55.525z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M82.924 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        d: "M89.545 31.961h2.969v-2.853h.684V35.5h-.684v-2.853h-2.97V35.5h-.684v-6.392h.685v2.853Zm5.465.721c.213 0 .399.031.555.093a.822.822 0 0 1 .363.259c.085.11.128.239.128.388v.004a.559.559 0 0 1-.278.496.809.809 0 0 1-.27.108v.014a.837.837 0 0 1 .481.189.53.53 0 0 1 .177.417v.003a.741.741 0 0 1-.14.452.882.882 0 0 1-.396.294 1.672 1.672 0 0 1-.614.101 1.44 1.44 0 0 1-.577-.107.935.935 0 0 1-.391-.303.877.877 0 0 1-.165-.463l-.002-.024h.748l.003.022a.27.27 0 0 0 .06.135c.032.04.075.073.13.097a.483.483 0 0 0 .192.035.45.45 0 0 0 .19-.037.3.3 0 0 0 .122-.104.278.278 0 0 0 .043-.152v-.003a.233.233 0 0 0-.107-.208.56.56 0 0 0-.312-.072h-.275V33.8h.275c.082 0 .151-.01.208-.031a.289.289 0 0 0 .13-.09.231.231 0 0 0 .046-.144v-.003a.25.25 0 0 0-.152-.242.389.389 0 0 0-.172-.036c-.07 0-.13.013-.182.037a.286.286 0 0 0-.12.102.325.325 0 0 0-.054.151l-.002.017h-.707l.002-.027a.858.858 0 0 1 .153-.452.879.879 0 0 1 .366-.294 1.31 1.31 0 0 1 .544-.106Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m99.834 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M109.865 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 1.027,
        d: "M119.797 32.304c.788 0 1.427-.553 1.427-1.341 0-.789-.639-1.342-1.427-1.342h-2.112v2.683m2.112 0h.457c.788 0 1.427.553 1.427 1.341 0 .788-.639 1.342-1.427 1.342h-2.569v-2.683m2.112 0h-2.112"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M133.154 29.108h2.968v.684h-1.1l-1.205 5.023h1.163v.685h-2.968v-.684h1.1l1.206-5.024h-1.164v-.684Zm8.233 2.269 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M151.419 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "M159.067 33.674v-.171l.586-1.541m3.296 1.712v-.171l-.583-1.541m0 0-1.121-2.969h-.465l-1.127 2.969m2.713 0h-2.713"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#9FADBC",
        strokeWidth: 1.37,
        d: "M164.662 35.272h-7.307"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m168.329 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "m183.269 31.048-.57 1.598.285.286m.285-1.884 2.829-1.975a.286.286 0 0 1 .366.032l.575.575a.285.285 0 0 1 .032.366l-1.975 2.829m-1.827-1.827 1.827 1.827m0 0-1.598.57-.286-.285m-.228-.228-.514.514.229.228.513-.514m-.228-.228.228.228"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#B6C2CF",
        strokeWidth: 1.37,
        d: "M188.407 35.272h-7.306"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m192.074 31.377 1.812 1.813 1.813-1.813.484.484-2.054 2.055a.343.343 0 0 1-.485 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M202.105 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M214.891 30.25h-6.392v-.686h6.392v.685Zm0 2.397h-6.392v-.685h6.392v.685Zm-3.196 2.397h-3.196v-.685h3.196v.685Zm7.32-3.667 1.813 1.813 1.812-1.813.485.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Zm14.142-1.47a.57.57 0 1 1 1.141-.001.57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.685h4.567v.685Zm-6.393 2.055a.57.57 0 1 1 1.141 0 .57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.684h4.567v.684Zm-6.393 2.055a.57.57 0 1 1 1.14 0 .57.57 0 0 1-1.14 0Zm6.393.343h-4.567v-.685h4.567v.685Zm4.123-3.667 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M253.705 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M263.395 29.664a1.795 1.795 0 1 1 2.539 2.54l-1.028 1.027-.484-.484 1.027-1.028a1.11 1.11 0 1 0-1.57-1.57l-1.027 1.027-.485-.484 1.028-1.028Zm1.397 1.626-2.511 2.512-.485-.484 2.512-2.512.484.484Zm-4.137 1.114 1.027-1.027.485.484-1.028 1.028a1.11 1.11 0 1 0 1.571 1.57l1.027-1.027.484.484-1.027 1.027a1.795 1.795 0 1 1-2.539-2.539Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M272.427 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M278.364 30.078c0-.662.536-1.199 1.198-1.199h4.909a1.2 1.2 0 0 1 1.199 1.199v3.767a1.2 1.2 0 0 1-1.199 1.199h-4.076l-1.519.868a.343.343 0 0 1-.512-.297v-5.537Zm1.198-.514a.514.514 0 0 0-.513.514v4.946l1.165-.665h4.257c.284 0 .514-.23.514-.514v-3.767a.514.514 0 0 0-.514-.514h-4.909Zm4.282 2.055h-3.654v-.685h3.654v.685Zm-1.37 1.37h-2.284v-.685h2.284v.685Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#454F59",
        d: "M288.41 29.793h21.919v5.023H288.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M315.808 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M321.744 32.304a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M334.529 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#9FADBC",
        d: "M342.91 28.65a.628.628 0 0 0-.579.872l.041.08.377.628v1.587a2.22 2.22 0 0 0-.541.279c-.419.297-.829.823-.829 1.692 0 .19.153.343.342.343h2.055v1.826h.685V34.13h2.055a.343.343 0 0 0 .343-.342c0-.869-.411-1.395-.83-1.692a2.25 2.25 0 0 0-.54-.28V30.23l.376-.628a.628.628 0 0 0-.538-.951h-2.417Zm1.942 1.309a.34.34 0 0 0-.048.176v1.94c0 .168.121.311.286.339h.004l.03.007a1.552 1.552 0 0 1 .509.234c.211.15.428.39.508.79h-4.045c.08-.4.297-.64.508-.79a1.556 1.556 0 0 1 .51-.234l.03-.007h.003a.342.342 0 0 0 .287-.338v-1.941a.342.342 0 0 0-.049-.176l-.374-.623h2.215l-.374.623Z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#CECFD2",
        d: "M143.186 68.735c.141 0 .586 3.665.305 5.157.482.302.897 1.064.875 1.858 2.034 1.56.772-2.411.352-3.645-.342.828-.07-1.266-.333-1.589.016.178-.352-3.375-1.016-2.393-.085-.11-.354.712-.185.61l.002.002Zm-7.937 3.73c.135.784-.204 1.446-.751 2.075.334 2.71 2.44-1.575 2.936-2.62 0 0 .912-1.817.922-1.593.352-.138 2.323-2.659 1.016-2.603-.373.393-.718 1.363-1.123 1.35-.904.194-1.934 2.682-2.999 3.395l-.001-.004Zm-6.428-7.115c-.435 1.7 2.805.443 4.076.388 0 0 1.318.014 1.68-.215-.191-.002 4.487-.226 2.034-1.145-.066.023-1.686.097-1.686.097-2.117-.528-4.351.11-6.106.877l.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#669DF1",
        fillOpacity: 0.14,
        d: "M314 47.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 45h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#i)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1F1F21",
        d: "M149.798 43.71a6.006 6.006 0 0 0-3.969 1.339 6.026 6.026 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.143-2.287 1.143h-1.143v3.431h1.143a6.026 6.026 0 0 0 3.968-1.338 5.965 5.965 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V52.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V43.71h-1.212Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#CECFD2",
        d: "M149.798 45.998v-1.143a4.574 4.574 0 0 0-3.969 1.875 4.574 4.574 0 0 0-3.968-1.875v1.143a3.213 3.213 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.635 4.635 0 0 0 3.968-1.864 4.636 4.636 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.211 3.211 0 0 1 3.362-2.115Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M0 0h477v81H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-259-118.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -54,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M31.03-25.464a3.932 3.932 0 0 1 3.932-3.932h487.581v374.861H31.03V-25.464Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M45.48 28.65h7.306v7.307H45.48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "f",
        width: 324.211,
        height: 29.225,
        x: 34.52,
        y: 21.345,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 3.653
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.36 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 0.228
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "effect1_dropShadow_13247_134475",
        result: "effect2_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13247_134475",
        result: "shape"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feMorphology", {
        in: "SourceAlpha",
        radius: 0.457,
        result: "effect3_innerShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feComposite", {
        in2: "hardAlpha",
        k2: -1,
        k3: 1,
        operator: "arithmetic"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.737255 0 0 0 0 0.839216 0 0 0 0 0.941176 0 0 0 0.12 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "shape",
        result: "effect3_innerShadow_13247_134475"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "i",
        width: 14.866,
        height: 25.095,
        x: 138.431,
        y: 42.565,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13247_134475",
        result: "shape"
    }))));
const $3faf0024169aae07$var$NewToolbarBannerImageLight = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 56",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M-68.35-100.55c.706 3.65 1.105 7.55 1.162 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.55 38.086-.142.036-.292.079-.434.114-.613.157-1.226.307-1.853.45-.192.042-.392.092-.584.135q-1.152.247-2.337.463a69 69 0 0 1-8.422.949q-1.452.076-2.935.1a74 74 0 0 1-5.059-.115q-.641-.03-1.282-.07a71 71 0 0 1-5.508-.607 56 56 0 0 1-2.23-.385 15 15 0 0 1-.549-.114 67 67 0 0 1-1.717-.364 11 11 0 0 1-.47-.114 42 42 0 0 1-1.91-.492q-.087-.021-.164-.042c-12.141-3.366-21.823-10.374-27.88-20.67-4.125 6.98-9.953 12.47-17.114 16.32l.406.15a50.29 50.29 0 0 1-2.323 1.198c-.149-.05-.306-.107-.456-.157l-.52.243c.193.07.335.135.414.178-.008 0-.015.007-.029.014l-.463-.157a54 54 0 0 1-8.322 2.966c-.143.036-.292.079-.435.114a70.62 70.62 0 0 1-1.852.45c-.193.042-.392.092-.584.135q-1.154.247-2.337.463a69 69 0 0 1-8.422.948q-1.452.077-2.936.1a74 74 0 0 1-5.058-.114 76 76 0 0 1-1.311-.071 70 70 0 0 1-5.48-.606c-.256-.036-.505-.086-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a65 65 0 0 1-1.132-.25q-.235-.051-.471-.114a42 42 0 0 1-1.909-.492q-.087-.021-.164-.042c-13.096-3.608-23.32-11.458-29.241-23.093v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138.285-1.497.613-2.945.984-4.363a61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249.064-.121.128-.236.192-.364.335-.649.67-1.305 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 60 60 0 0 1 6.484-3.55 59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c.114-.035.235-.057.349-.092l.727-.193c.228-.057.449-.121.677-.178.406-.107.805-.221 1.211-.314 6.961-1.69 14.215-2.495 22.323-2.495 1.161 0 2.308.014 3.455.05.342.007.677.028 1.019.042 1.112.043 2.223.1 3.321.179 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542v-.007q.267.084.534.157h-.014q.137-.045.285-.079l.256.086c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.12 7.593 6.385 2.816 12.028 6.431 16.816 10.958 10.26 9.796 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.579c5.45-6.83 8.208-17.639 8.393-33.075l40.391-.114v.007h.221c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.414-17.703 8.607-33.346h.491v-.007l40.392-.114c.278 15.764 3.078 26.694 8.678 33.46h63.904c-6.897-11.893-11.863-24.505-11.863-36.069 0-2.346.086-4.663.25-6.959.498-6.873 2.073-12.997 4.496-18.38.313-.699.641-1.376.983-2.046.1-.2.207-.399.306-.599.185-.349.378-.699.57-1.041 6.562-11.771 17.428-19.485 29.647-23.121a57 57 0 0 1 3.912-1.006 60 60 0 0 1 11.151-1.397c.427-.014.862-.036 1.289-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .584.022.869.029a59.5 59.5 0 0 1 11.792 1.461 54 54 0 0 1 1.532.364c.199.05.392.107.591.164q1.602.428 3.171.941c6.192 2.046 11.998 5.155 17.022 9.333a46.7 46.7 0 0 1 7.003 7.222c5.722 7.315 9.548 16.683 10.382 28.126.164 2.296.249 4.62.249 6.959 0 2.203-.185 4.442-.52 6.709-.036.242-.078.485-.121.72-.036.235-.079.463-.121.699-.079.449-.164.891-.257 1.34-1.788 8.791-5.8 17.888-10.851 26.601H425v-292.23c-3.142 2.788-6.548 5.234-10.175 7.372-19.173 11.294-44.36 14.01-67.787 14.01h-65.001c-14.592 0-24.646 6.04-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.216a224 224 0 0 1-.492-11.886 325 325 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.022-.342.036-.506.028-.392.05-.784.078-1.17q.16-2.158.406-4.241c.727-6.267 1.988-12.078 3.791-17.418a70 70 0 0 1 2.707-6.852c.25-.549.513-1.09.777-1.625a60 60 0 0 1 2.558-4.67 54 54 0 0 1 1.902-2.937q.492-.715 1.005-1.42a57 57 0 0 1 3.249-4.035c.157-.178.328-.356.484-.534q.333-.377.677-.742a57.7 57.7 0 0 1 7.759-6.901c9.377-6.945 21.261-11.486 35.554-13.518a125 125 0 0 1 13.502-1.141q2.362-.076 4.788-.078h74.442c1.211 0 2.38-.036 3.527-.1l.648-.043c13.039-.87 21.881-6.01 25.771-16.961.043-.122.093-.243.136-.364q.247-.717.463-1.476c.036-.114.064-.235.093-.349a37 37 0 0 0 .776-3.451H101.425c-4.51 20.719-12.005 37.659-23.056 50.635a293 293 0 0 1 21.24 2.467l-9.59 63.396C43.434-21.347 21.482-9.54 16.687 22.151l-61.952-9.383c4.018-26.55 12.155-47.74 25.372-63.261a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.826c10.502 6.531 17.79 16.976 20.498 30.936zm171.407 305.704c-1.61.264-3.299.406-5.059.414a32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.059.385c9.447 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.421 15.7-17.876 17.261zm121.524-17.546c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133zm20.748-40.953c.499.421 0-65.421 0-65.421 31.592 11 68.5.563 68.5.563v64.58c-23.278 6.488-68.5.286-68.5.286zM362.065 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563m-401.572 98.154c.498-9.982 2.707-18.416 6.198-25.517 7.646-15.55 21.668-24.533 38.825-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221q.586-1.176 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.353 1.233.27 2.458.57 3.663.89.242.065.491.129.733.193.086.022.179.043.271.072.114.028.228.056.342.092.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836q.436.515.862 1.04c.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412c-2.429-4.906-3.691-12.185-4.346-18.744-3.719.264-7.545.321-11.429.192q-1.037-.03-2.073-.071h-.071l-.684-.043c-.185-.007-.364-.021-.549-.035-7.787-.478-15.283-1.754-22.237-3.872-.955 3.28-2.137 6.353-3.541 9.197-7.695 15.621-21.852 24.626-38.86 28.319-7.923 1.718-16.444 2.31-25.215 1.868-4.631-.235-9.141-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.209l-36.871-9.154s7.053-11.151 8.143-24.519c-5.856-5.219-10.445-11.7-13.373-19.571-2.73-7.336-4.062-15.827-3.57-25.666zm-79.829 28.19 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.272-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.585-.727.213-1.461.406-2.202.563q-.365-.31-.719-.621c-5.045.97-10.46.628-16.01-1.019a45.6 45.6 0 0 1-6.926-2.695 47 47 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668l-.235-.043-.121-.021a29 29 0 0 1-1.347-2.51q.128.02.257.05c-1.96-3.836-3.021-8.028-3.092-12.491-4.076-.307-7.98-.592-11.529-.82l.449-.228a20 20 0 0 1-2.707.1c-.072.313-.136.62-.221.934a22 22 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.081-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.405 24 24 0 0 1-3.477-2.039c-5.978-4.22-8.621-10.544-6.626-17.738a22.5 22.5 0 0 1 1.396-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.454a24.5 24.5 0 0 1 3.342 1.947c5.03 3.522 7.687 8.57 7.21 14.395 1.845.163 3.171.313 3.171.313l5.4.05s2.722.079 4.938.057a34.2 34.2 0 0 1 1.161-6.438c.642-2.31 1.532-4.663 2.679-7.051a43 43 0 0 1 3.898-6.58c5.885-8.107 13.822-12.3 22.664-12.77.492-8.17.948-16.398 2.231-22.059.748 2.638.071-6.46.591-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.122-35.584 35.568-5.126 5.123 35.584-20.207 2.909c-.549 6.901-1.225 13.51-1.468 14.23-.064-.12.121-.706-.292-.734-.085 1.034-.071 2.125-.15 3.223.649-.286.321-1.64.528-1.74.071 4.1-.585 12.42-1.233 17.018 3.043.086 6.177.585 9.355 1.512a47.4 47.4 0 0 1 7.218 2.787 45.5 45.5 0 0 1 6.419 3.743c3.912 2.738 7.076 5.947 9.398 9.547.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .079.136c1.218-.685 8.949-7.593 9.796-7.743-.035.057-.292.47-.334.542 1.019-.371 2.999-2.802 3.726-2.396.185-.128.506-.392.919-.748-3.049-3.865-4.104-8.691-2.636-13.989a22.6 22.6 0 0 1 1.396-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.4 24.4 0 0 1 3.342 1.946c5.978 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.41 3.722 22.7 22.7 0 0 1-1.996 3.38c-4.389 6.08-11 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.623 29.08 29.08 0 0 1 1.397 2.902q.173.396.335.791v.03c2.166 5.738 2.451 12.198.534 19.085q-.972 3.508-2.714 7.144c-.015.029-.036.064-.05.093.149.092.299.178.449.271-.05.107-.093.213-.143.313a47 47 0 0 1-1.054 2.047c-.157-.093-.321-.186-.478-.286a43 43 0 0 1-1.966 3.187c3.021 1.512 7.303 4.107 9.497 5.725-.335-.071-1.083-.37-1.859-.834l-.143.214c1.824 1.012 3.249 2.995 5.422 3.151 0 0-2.109-1.561-2.486-2.003l.028-.014-.014-.043c4.261 2.189 9.17 5.183 13.416 7.65l17.97-14.224 22.294 28.198-28.18 22.309-22.294-28.198z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M197.242-2.29a493.5 493.5 0 0 1-.064-1.547v-.17a228 228 0 0 1-.1-3.416q.002-.18-.007-.37l-.022-1.32q.002-.3-.007-.599-.002-.597-.014-1.205v-2.416c0-.92.014-1.826.036-2.731a41 41 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311 311 0 0 1-.164-3.202v-.07zM178.96-13.348c-7.945-.014-15.69-1.098-23.256-2.445-.036-.478-.072-.956-.107-1.448.534 7.793 1.353 13.497 1.98 18.217h36.659c-.635-.55-1.276-1.098-1.903-1.654a311 311 0 0 1-13.373-12.67"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M181.946-12.977c.327.278 2.379 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.726-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.678-1.247a41 41 0 0 0 4.696-1.362c.021-.877.05-1.74.085-2.602l-.484.192c-.477.185-.976.32-1.454.478-.962.335-1.952.57-2.921.805-3.911.927-7.788 1.29-11.329 1.412a80 80 0 0 1-1.296.036 422 422 0 0 1-6.726-6.916c-5.601-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.954 1.327 1.703 2.368 2.315 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.582 19.014a410 410 0 0 0 5.757 6.01c-1.859-.02-3.583-.092-5.144-.156-5.336-.457-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.107 1.448 7.567 1.34 15.311 2.424 23.256 2.445a312 312 0 0 0 13.373 12.67c.627.556 1.269 1.105 1.903 1.654h2.857c-1.375-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M372.866-51.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.002c-.912 0-1.802.021-2.679.071-13.124.72-21.966 6.945-21.966 21.575 0 4.534 1.005 11.578 1.503 17.11h-19.522a322 322 0 0 1-.164-3.2c.05 1.105.1 2.167.164 3.2.513 8.934 1.439 15.265 2.123 20.42h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01A64.7 64.7 0 0 0 425-38.742v-92.75h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M383.126-120.549c0 9.411-1.909 16.491-5.557 21.582-3.086 4.306-7.425 7.193-12.904 8.855-.178.056-.37.1-.556.156-.826.236-1.667.45-2.543.635q-.075.009-.15.028a48 48 0 0 1-6.726.856q-.91.055-1.852.078-.939.031-1.91.029h-74.599c-1.567 0-3.106.028-4.631.078-1.574.05-3.121.129-4.645.228q-1.144.075-2.266.172c-.399.035-.798.07-1.197.114-.342.035-.691.064-1.04.1-.043 0-.079.007-.121.014l-.357.042-.791.086q-1.562.18-3.092.392a95 95 0 0 0-6.619 1.162 88 88 0 0 0-3.256.742 86 86 0 0 0-7.317 2.146c-4.204 1.44-8.116 3.18-11.728 5.204a64 64 0 0 0-5.201 3.244 58 58 0 0 0-2.815 2.082q-.408.323-.805.656a61 61 0 0 0-2.173 1.861c-4.631 4.178-8.522 9.048-11.657 14.609-.106.185-.206.378-.313.57-.093.171-.192.342-.285.513-.257.47-.506.956-.748 1.433-3.064 6.068-5.294 12.884-6.655 20.434a95 95 0 0 0-.527 3.294 106 106 0 0 0-.962 10.509c-.036.863-.064 1.725-.086 2.602a117.4 117.4 0 0 0-.035 2.73v2.418q.002.608.014 1.205-.002.3.007.599c0 .449.014.884.022 1.319a242.218 242.218 0 0 0 .106 3.786v.17l.065 1.548v.071c.049 1.105.099 2.167.163 3.201h19.523c-.499-5.54-1.503-12.584-1.503-17.11 0-14.63 8.842-20.855 21.966-21.575q1.313-.074 2.679-.072h65.001c23.42 0 48.607-2.716 67.788-14.01 18.703-11.015 31.692-30.2 31.692-63.068v-16.662h-21.432v10.944z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M78.348-80.858C58.355-57.373 26.72-46.878-19.922-50.5a91 91 0 0 1 1.896-2.153 93 93 0 0 0-1.903 2.153C-33.144-34.98-41.28-13.79-45.3 12.76l61.952 9.384C21.447-9.541 43.4-21.354 89.982-15.003l9.59-63.396c-7.402-1.12-14.477-1.94-21.239-2.467a221 221 0 0 0-4.168-.286q2.063.127 4.168.286zM293.564 2.808s.499 65.85 0 65.421c0 0 15.127 2.075 32.384 2.574v-3.437l-.043-9.646v-.02q.002-.782-.007-1.554v-5.27c-.057-9.503-.107-16.583-.107-16.583q1.016.352 2.03.67l.485.15a67.963 67.963 0 0 0 2.202.65 90.53 90.53 0 0 0 1.909.505c.157.043.314.079.47.121.677.172 1.361.329 2.038.485.093.022.178.036.271.057a82.64 82.64 0 0 0 2.28.471c.691.135 1.375.257 2.066.378.1.014.2.035.299.05a94 94 0 0 0 1.896.3c.106.013.213.035.32.05q1.046.147 2.102.284c.093.014.192.022.285.036.67.078 1.332.157 1.995.22.057 0 .114.015.171.022.713.072 1.432.136 2.138.193.078 0 .163.014.242.021q2.167.17 4.303.264h.164q2.179.087 4.304.1h.064c1.446.007 2.871 0 4.275-.043V3.371s-36.908 10.43-68.5-.563z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M348.713 38.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021m-22.757 31.869c.05 15.1.029 29.103-.199 28.91 0 0 45.222 6.204 68.5-.284v-64.58s-14.03 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.11 2.852zm-.199-36.518s.057 7.08.107 16.584c-.057-9.504-.107-16.584-.107-16.584m11.264 3.038c.135.028.27.057.413.078a7.366 7.366 0 0 0-.413-.079m9.375 1.398c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021m-14.021-2.453c.157.043.313.079.47.121-.157-.035-.313-.078-.47-.12m-2.08-.557q.084.02.178.05a2 2 0 0 1-.178-.05"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M357.727 39.319q-2.125-.012-4.304-.1h-.164c-1.425-.057-2.857-.15-4.303-.264-.079 0-.164-.014-.242-.021q-1.069-.085-2.138-.193c-.057 0-.114-.014-.171-.021-.663-.071-1.332-.143-1.995-.221-.093-.014-.192-.022-.285-.036a75 75 0 0 1-2.102-.285c-.107-.014-.214-.036-.32-.05a86 86 0 0 1-1.896-.3c-.099-.014-.199-.035-.299-.05a99.632 99.632 0 0 1-2.479-.456 70.958 70.958 0 0 1-1.867-.392c-.093-.021-.178-.035-.271-.057a70 70 0 0 1-2.038-.484q-.234-.056-.47-.122c-.634-.164-1.275-.328-1.909-.506a110.499 110.499 0 0 1-2.202-.649l-.485-.15a69 69 0 0 1-2.03-.67s.057 7.087.107 16.584v5.269q-.002.771.007 1.554v.021l.043 9.647v3.436c12.582.364 26.298-.121 36.109-2.852V39.283q-2.106.054-4.275.043h-.064z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M66.278 54.07c-2.536-4.535-4.945-9.097-7.317-13.66q-.056.116-.121.22c-1.397 2.824-2.58 5.868-3.534 9.134q.693.214 1.375.427a73.4 73.4 0 0 1 9.604 3.872zm93.473 9.204c-2.808 4.264-5.978 8.185-9.363 11.757-3.355 3.586-7.089 6.802-11.022 9.461.021-.021.463-.4.962-.82.249-.214.499-.42.677-.591l.313-.293a59 59 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65 65 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a43 43 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.527-.078.784-.114.399-.791.769-1.604 1.161-2.395 1.048-2.075 1.874-4.25 2.786-6.389.428-1.076.805-2.181 1.211-3.265l.599-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.372.677-3.394.335-1.697.285-1.704c.192-1.134.377-2.274.569-3.408l.471-3.415.235-1.704.185-1.711c.128-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.021 0-.043-.007-.086-.007-.129a49 49 0 0 0-3.669-3.836 40.4 40.4 0 0 1-.556 5.968c-1.938 10.702-6.284 20.512-11.906 29.025zm-58.639-49.066c.342-.663.513-.962.485-.97-.022-.006-.243.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.808 5.169-4.425 8.905-1.61 3.743-3.2 8.178-4.567 12.926-2.743 9.51-4.375 20.277-5.273 28.953l-.17 1.697c3.042 3.872 5.535 8.263 7.374 13.204q.599 1.617 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.264.855.556 1.311.798.449.243.905.478 1.361.72.449.257.92.464 1.397.663l1.417.614 1.468.499.734.25.748.184 1.503.371h.008c0-1.09 0-2.189.042-3.287.335-11.15 2.786-22.322 6.869-32.853 4.083-10.545 9.775-20.448 16.43-29.51a167 167 0 0 1 5.187-6.651c1.81-2.168 3.741-4.285 5.942-6.16l.129-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.296-.064-19.566.855a85 85 0 0 0-3.797 5.975c.705-1.419 1.275-2.403 1.617-3.066z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M176.851 39.989c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.84-4.712 1.246-7.115.699-4.812 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M178.739 48.324c-.827 16.583-3.371 33.288-8.529 47.832a111 111 0 0 1-4.959 11.828l2.679-.399a38 38 0 0 0-.428 1.961c-.035.178-.064.356-.099.527a43 43 0 0 0-.25 1.612c-.014.121-.035.242-.05.37-.057.485-.099.97-.142 1.455a44 44 0 0 0 2.422.599c-2.636-.271-2.337-.129-.342.285.05.007.107.021.157.028 5.273-4.327 9.662-9.71 12.882-16.284 3.449-7.022 5.629-15.343 6.121-25.175.498-9.981-.848-18.594-3.613-26.008a49.4 49.4 0 0 0-5.664-10.887c.114 4.085.021 8.185-.185 12.263zM161.988 59.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13M86.99 46.598c.192-.97.49-2.21.883-3.8.498-2.281 1.653-6.032 2.807-9.333 1.154-3.308 2.259-6.188 2.202-6.958-1.098 2.873-2.7 6.987-3.883 10.872-1.205 3.879-2.003 7.508-2.01 9.226z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M69.933 56.016c5.037 2.91 9.505 6.46 13.267 10.688l.042-.4c1.105-9.667 2.772-18.936 5.216-27.427 2.408-8.499 5.657-16.177 9.355-22.715a86 86 0 0 1 2.672-4.406q-1.433.254-2.843.563C81.625 15.805 68.13 24.033 60.179 38.114c2.657 5.07 5.336 10.117 8.144 15.093.527.941 1.076 1.868 1.617 2.802zm75.318-41.473.05-.057q.243-.237.456-.442a6 6 0 0 1-.342-.092q-.169.19-.35.413l.179.178zM129.042 53.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.313.078-1.02.107-1.625.028-.6.057-1.098-.157-1.005zm2.308-6.246c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.156-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.018-4.934 1.09-5.397.064-.464-.257.192-.62 1.476zM110.367 65.57l.2.228c1.332-4.898 3.177-9.91 5.108-14.387l-.178-.221c-1.995 4.605-3.769 9.39-5.13 14.38m35.518-48.617c-2.472 2.816-4.56 6.039-6.369 9.44-3.577 6.837-6.171 14.33-7.439 22.023-.142.963-.342 1.918-.435 2.888l-.313 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.541 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.054-2.723 5.273-3.621.591-.471 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.049-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.149.349-.741.876-1.803 1.432-3.144a74 74 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.015-.235-.05-.463-.072-.698-5.799-4.656-12.696-8.178-20.356-10.66-.256-.085-.52-.156-.776-.235a37 37 0 0 0-2.124 2.232zm-25.656 23.913c-1.832 3.244-3.164 6.132-2.843 6.203l.114-.236c1.503-2.866 2.743-5.104 3.968-7.329 1.247-2.21 2.494-4.413 4.204-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.273 8.634z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M137.314 20.418a141 141 0 0 0-7.353 9.468c-4.696 6.61-8.949 13.825-12.405 21.596s-6.099 16.106-7.538 24.804a90.7 90.7 0 0 0-1.233 15.457c.136.007.271.014.406.029l1.532.092c.513.007 1.019-.028 1.525-.035.506-.029 1.012 0 1.518-.093 1.004-.136 1.995-.214 2.985-.435 6.384-1.183 12.027-3.48 16.366-5.803-.52-1.227-.962-2.496-1.432-3.758-.313-.827-.527-1.69-.791-2.538-.249-.856-.527-1.697-.705-2.574l-.599-2.602c-.185-.87-.306-1.754-.456-2.624-.335-1.74-.442-3.508-.641-5.24-.214-3.48-.299-6.902-.021-10.16.434-6.523 1.745-12.355 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.762-6.025 2.629-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.407-15.8 0 0-.62.735-1.503 1.926a57 57 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.929 5.447-.413.848-.784 1.618-1.104 2.267l-.691 1.568v-.078l-.086.15c1.539-4.021 3.399-8.078 5.836-11.957 1.617-2.595 3.498-5.111 5.685-7.407l-.733-.193c-2.587 1.818-4.91 4.171-7.104 6.73zM62.78 45.436c.741 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.773-8.384-3.028-4.79m106.79-9.54c.285-1.255.491-2.802.627-3.594.085-1.554.021-2.139-.043-2.103-.079.036-.15.692-.292 1.611-.235 1.84-.813 4.727-1.019 5.946.135.35.449-.606.727-1.86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M69.933 56.016a567 567 0 0 1-1.617-2.801c-2.808-4.977-5.487-10.032-8.144-15.094-.42.749-.834 1.511-1.226 2.296 2.373 4.563 4.788 9.126 7.318 13.66a64 64 0 0 1 3.662 1.947zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791m109.268 9.048c-.128 1.133-.249 2.274-.378 3.407l-.185 1.712-.235 1.704c-.157 1.133-.313 2.274-.47 3.415-.193 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.696-.677 3.394-.791 3.372-.399 1.69-.456 1.676-.919 3.35-1.055 3.316c-.178.549-.342 1.112-.534 1.654l-.598 1.633c-.407 1.09-.784 2.188-1.212 3.265-.912 2.139-1.738 4.313-2.786 6.388-.391.799-.762 1.604-1.161 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15q.075-.152.213-.421c.164-.371.392-.905.663-1.54.527-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.213.17c-.52 1.776-1.083 3.858-1.909 5.997-.399 1.07-.784 2.189-1.247 3.287-.477 1.09-.955 2.195-1.432 3.293-.456 1.106-1.033 2.154-1.546 3.187-.264.507-.513 1.013-.77 1.512.371-.057.72-.107 1.055-.157q.194-.385.377-.77l.143.292-.214.428c.157-.021.299-.043.449-.064a110 110 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45 45 0 0 0-1.61-2.181c.092 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.385 4.998-1.012 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.475 6.894.998-6.26 2.879-16.769 3.748-27.834.463-5.525.834-11.172.884-16.426.028-2.375 0-4.663-.107-6.824q-.426-.525-.862-1.04c0 .042.007.085.007.128.548 8.834-.015 17.917-.813 27.021zm-6.462 40.31c-.293.813-.442.999-.813 1.804-.299.157.164-.92.62-2.274.485-1.34 1.098-2.902 1.333-3.608-.285 1.02-.72 2.916-1.148 4.078zm-33.936-80.514c-1.803 2.167-3.506 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.431 29.51-4.082 10.53-6.533 21.703-6.868 32.853a84 84 0 0 0-.043 3.287h-.007l-1.503-.37-.749-.186-.733-.25-1.468-.499-1.418-.613c-.477-.2-.948-.406-1.397-.663l-1.36-.72c-.45-.242-.877-.535-1.311-.798-.877-.514-1.696-1.113-2.515-1.704-.036-.029-.072-.05-.1-.079.356 1.17.67 2.367.954 3.593a40.651 40.651 0 0 0 4.311 2.403c2.373 1.148 4.859 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.111 2.702 2.508 5.34 4.232 7.735.185.015.363.029.548.036a39 39 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.598-2.303c-.171-.684-.285-1.283-.399-1.775l-.335-1.533c.427 1.64.84 3.287 1.361 4.926a60 60 0 0 0 1.66 4.913c1.239 3.251 2.8 6.466 4.88 9.382q.289.405.599.799c.691.035 1.382.05 2.073.071-.064-.078-.135-.143-.192-.221-2.836-3.458-4.788-7.614-6.227-11.914a78 78 0 0 1-3.071-13.239c-.421-2.916-.656-5.84-.763-8.755.399.028.791.057 1.183.078.314.014.627.05.941.043l.933-.029c.62-.028 1.247-.014 1.86-.078 2.493-.25 4.816-.72 7.16-1.312 2.337-.599 4.639-1.383 6.933-2.303a53.5 53.5 0 0 0 6.227-3.001c-.15-.336-.313-.656-.456-.991q-.269-.557-.506-1.134c-4.339 2.324-9.989 4.62-16.366 5.803-.99.221-1.981.3-2.985.435-.499.086-1.005.065-1.518.093-.506.007-1.019.05-1.525.036l-1.532-.093c-.135-.007-.27-.021-.406-.028a90.7 90.7 0 0 1 1.233-15.458c1.432-8.698 4.083-17.032 7.538-24.804 3.456-7.77 7.709-14.986 12.405-21.595a141 141 0 0 1 7.353-9.468c2.187-2.56 4.517-4.905 7.103-6.73a94 94 0 0 0-3.662-.892l-.128.107c-2.209 1.875-4.133 4-5.942 6.16zm-32.141 72.273c-.371-.115-.577-.214-.706-.314-.256-.207-.235-.37-.677-.72.72.392 3.527 1.305 2.879 1.29l.235.1c-.826-.064-1.354-.25-1.731-.35zm4.346 8.683c-.264-1.803-.321-3.222-.378-4.192-.007-.977.022-1.518.079-1.582.114-.129.235 1.64.527 5.575l.021.178-.249.014zm3.676-34.222-.199-.228c1.361-4.99 3.135-9.775 5.13-14.38l.178.22c-1.931 4.478-3.776 9.49-5.109 14.388m10.909-26.301c-1.226 2.224-2.465 4.463-3.969 7.33l-.114.235c-.313-.072 1.012-2.96 2.843-6.203 1.81-3.251 4.147-6.83 5.273-8.634l.178.192c-1.71 2.66-2.957 4.863-4.204 7.073zm46.206-.257a74.4 74.4 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145a22 22 0 0 1-.563 1.148c-1.154 2.317-2.451 4.57-3.805 6.78-1.404 2.181-2.864 4.327-4.453 6.388-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.757-5.572 5.433 0 0-.157.142-.47.385-.314.25-.777.613-1.368 1.09-1.219.906-2.964 2.225-5.273 3.623-.149.092-.306.185-.456.278.292.706.606 1.397.912 2.089a60 60 0 0 0 4.788-3.366s-.135.122-.313.293-.435.378-.677.591c-.492.421-.941.799-.962.82 3.933-2.659 7.674-5.874 11.022-9.46a85 85 0 0 0 9.363-11.757c5.621-8.513 9.975-18.316 11.905-29.025.328-1.947.535-3.943.556-5.968a55 55 0 0 0-3.078-2.673c.022.235.057.463.071.698.314 4.129-.42 8.749-1.531 12.927zm-5.693 19.87c-3.855 6.21-.064-.94 1.617-3.13a39 39 0 0 1-1.617 3.13m8.172-28.91c.057-.036.128.542.043 2.103-.135.792-.349 2.346-.627 3.594-.278 1.254-.584 2.21-.727 1.86.207-1.226.784-4.106 1.019-5.946.143-.92.214-1.575.292-1.611m-81.702 8.677c-2.444 8.491-4.112 17.76-5.216 27.428l-.043.399c.656.741 1.29 1.497 1.903 2.281q.086-.833.17-1.697c.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.118-1.868 1.46-2.424.35-.563.57-.841.592-.834.028.007-.143.306-.485.97s-.912 1.646-1.617 3.065a86 86 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86 86 0 0 0-2.672 4.406c-3.697 6.538-6.946 14.216-9.355 22.715zm2.222-5.412c-1.154 3.309-2.308 7.052-2.807 9.333-.392 1.59-.69 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.054 3.65-2.202 6.958z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "m133.631 33.252.093-.15v.078c.164-.363.399-.905.691-1.568.313-.65.691-1.42 1.104-2.268.784-1.704 1.853-3.636 2.929-5.447a57 57 0 0 1 3.092-4.662c.883-1.191 1.503-1.925 1.503-1.925-3.177 4.784-6.013 10.124-8.407 15.799-2.373 5.668-4.24 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.454 4.5-2.758 10.331-3.199 16.855-.278 3.258-.193 6.68.021 10.16.2 1.732.306 3.493.641 5.24.157.87.271 1.754.456 2.624l.599 2.602c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.47 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.306.663.456.99a43 43 0 0 0 1.824 3.615 55 55 0 0 0 2.608 4.221c1.824 2.667 3.79 5.055 5.771 7.087a47.6 47.6 0 0 0 5.828 5.069c-.128-.228-1.389-1.112-2.622-2.21-.634-.535-1.225-1.148-1.731-1.69-.485-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387l2.835-.421a41 41 0 0 1-3.583-2.317c-5.187-3.729-9.911-8.82-13.595-14.901a61 61 0 0 1-2.565-4.734q-.248-.576-.506-1.14c-.306-.692-.62-1.384-.912-2.09a27 27 0 0 1-.698-1.825c-.684-1.711-1.169-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.932.128-3.864.242-5.804l.313-2.902c.093-.97.293-1.925.435-2.887 1.268-7.693 3.855-15.186 7.439-22.024 1.809-3.4 3.897-6.623 6.369-9.44a37 37 0 0 1 2.124-2.23 76 76 0 0 0-2.252-.678c-.142.136-.285.285-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.042-.271-.071-2.187 2.296-4.068 4.813-5.685 7.408-2.437 3.885-4.297 7.935-5.836 11.956zm-4.424 21.36c-.029.599-.107 1.305-.107 1.625-.057-.449-.25-1.283-.221-1.803.028-.364.1-.457.164-.827.221-.093.185.406.156 1.005zm10.466 41.972c-.399-.35-.791-.92-1.161-1.511-.356-.6-.67-1.22-.955-1.655.164-.092.834.799 1.418 1.647.584.849 1.054 1.669.698 1.519m-8.065-23.849c.783 4.328 2.066 8.698 3.284 11.764.064.164.129.335.193.492.242.52.498 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.27 1.047 1.32 2.08 2.567 3.113 3.644.357.392.756.784 1.176 1.183.413.414.855.827 1.339 1.248-5.279-4.057-10.217-10.402-13.444-17.724q-.31-.703-.599-1.419c-.1-.235-.192-.478-.285-.713-1.489-3.729-2.601-7.636-3.356-11.521-.776-4.143-1.133-8.257-1.282-12.156.598 2.645.912 7.094 1.817 11.642zm.363-26.857c-.071.464-.42 2.068-1.09 5.397.007.464-.2.442-.299.528l.05.035s-.079.385-.15.97c-.057.578-.192 1.348-.221 2.132-.093 1.561-.185 3.158-.192 3.28l-.25-.05c-.007-1.555.05-3.637.406-5.619.264-1.996.784-3.9 1.126-5.183.364-1.283.684-1.94.62-1.476z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#f8eefe",
        d: "M-22.563 146.762c0-.078.014-.157.021-.235a42 42 0 0 0 .093-1.654c0-.121.014-.235.014-.356q.03-.982.007-1.975c0-.122-.007-.25-.014-.371a32 32 0 0 0-.086-1.633l-.042-.542a32 32 0 0 0-.228-1.989l7.958 2.025c1.226.314 2.537.642 3.912.991.549.143 1.104.278 1.674.421q.855.212 1.71.435c1.154.292 2.323.584 3.491.876s2.337.592 3.492.877q.865.215 1.71.428c2.536.635 4.93 1.234 6.982 1.733q.341.087.67.164c.876.214 1.674.406 2.38.577.527.129 1.011.243 1.425.342q.63.149 1.068.243c.585.128.898.185.884.157v.071q-.002.065-.014.171v.029c0 .071-.015.164-.022.263 0 .029 0 .05-.007.079q-.012.159-.035.349.002.043-.008.086-.019.213-.05.47v.022c-.02.178-.035.363-.064.57 0 .029 0 .05-.007.071-.021.193-.042.407-.07.621 0 .05-.015.092-.015.142-.029.221-.05.449-.079.685 0 .05-.014.099-.02.149-.03.243-.065.492-.094.756l-.02.178q-.055.404-.108.842a.4.4 0 0 1-.014.085q-.055.439-.121.899c0 .035-.014.078-.014.114-.043.313-.093.627-.136.955-.007.064-.021.128-.028.192l-.15.97c-.014.079-.021.15-.036.228-.05.335-.106.67-.163 1.02-.015.071-.022.142-.036.214-.057.356-.121.72-.185 1.083-.007.05-.022.1-.029.15a59 59 0 0 1-.2 1.112c0 .036-.014.064-.02.1-.072.385-.143.777-.222 1.177-.014.064-.02.128-.035.192l-.171.856c4.353.755 8.87 1.24 13.495 1.475 8.77.442 17.292-.149 25.215-1.868 17.007-3.686 31.165-12.69 38.86-28.318 1.403-2.845 2.579-5.911 3.54-9.198a63.012 63.012 0 0 1-.007.015 48 48 0 0 1-1.424-.45 70 70 0 0 1-8.928-3.557c-.47-.228-.94-.464-1.41-.699a58.7 58.7 0 0 1-9.142-5.746 78 78 0 0 1-1.197-.949 51 51 0 0 1-5.508-5.211 44 44 0 0 1-1.973-2.318 49 49 0 0 1-4.318-6.366 47 47 0 0 1-1.46-2.78 49.41 49.41 0 0 1-.67-1.441 56 56 0 0 1-1.226-2.987 56 56 0 0 1-1.788-5.718 61 61 0 0 1-1.44-7.786 71 71 0 0 1-.463-6.759c-.035-1.754 0-3.55.086-5.39.3-5.982 1.218-11.4 2.657-16.312-7.331-2.24-15.254-3.55-23.498-3.964-9.22-.464-18.083.128-26.255 1.896-17.157 3.707-31.18 12.698-38.825 28.24-3.49 7.102-5.7 15.529-6.198 25.517-.492 9.839.84 18.331 3.57 25.667 2.928 7.871 7.516 14.352 13.373 19.571z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#eed7fc",
        d: "M52.612 66.148a76 76 0 0 0-.085 5.39c.042 2.331.2 4.584.463 6.758a59 59 0 0 0 1.439 7.786 56 56 0 0 0 1.788 5.718c.378 1.02.791 2.018 1.226 2.987a48.81 48.81 0 0 0 2.13 4.22 48 48 0 0 0 4.318 6.368 52 52 0 0 0 1.974 2.317 50.993 50.993 0 0 0 6.705 6.16c2.82 2.174 5.877 4.085 9.14 5.746q.696.355 1.411.699c2.843 1.369 5.829 2.545 8.928 3.558.47.157.948.299 1.425.449.335-1.141.634-2.31.912-3.508q.077-.323.142-.656.288-1.326.535-2.695c.071-.392.135-.784.2-1.183q.115-.73.22-1.469c.114-.806.207-1.626.292-2.46.036-.342.064-.698.093-1.041.078-.912.15-1.832.2-2.773 0-.093.014-.185.02-.278v-.064c.357-7.03-.213-13.383-1.545-19.115a60 60 0 0 0-.955-3.593 53 53 0 0 0-1.112-3.308A48.869 48.869 0 0 0 83.2 66.675c-3.761-4.228-8.229-7.778-13.266-10.687a62 62 0 0 0-3.662-1.947 71 71 0 0 0-9.605-3.87q-.682-.225-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M58.287-67h418.734v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#f0f1f2",
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M101 18h342v8H101zM91 38h352v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 299.5,
        height: 18,
        x: 40,
        y: 10.171,
        fill: "#fff",
        rx: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        d: "M47.69 16.256a.68.68 0 0 1 .669.006l1.625.938.385.222a.68.68 0 0 1 .34.588v2.32a.677.677 0 0 1-.34.588l-1.51.872a1 1 0 0 0 .052-.3v-2.32a.89.89 0 0 0-.447-.771l-.279-.161-.847-.489v-.898a.68.68 0 0 1 .34-.587z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        d: "m47.178 16.553-1.51.871a.68.68 0 0 0-.34.589v2.319c0 .242.13.467.34.589l.358.206 1.652.953a.682.682 0 0 0 1.02-.588v-.899l-.874-.504-.252-.145a.89.89 0 0 1-.446-.772v-2.319a.9.9 0 0 1 .052-.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1868db",
        fillRule: "evenodd",
        d: "m47.824 20.09-1.798 1.037-.358-.206a.68.68 0 0 1-.34-.589v-2.32c0-.243.129-.467.34-.588l1.51-.872-.01.029a.9.9 0 0 0-.042.272v2.32c0 .318.17.612.446.77z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        fillRule: "evenodd",
        d: "m48.185 18.238-.847-.489v-.898a.68.68 0 0 1 .34-.587l.012-.008a.68.68 0 0 1 .669.006l1.625.938z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fca700",
        fillRule: "evenodd",
        d: "m50.369 17.422-.385-.222-1.799 1.038.28.16a.89.89 0 0 1 .446.772v2.32a.9.9 0 0 1-.053.3l1.511-.872a.68.68 0 0 0 .34-.588v-2.32a.68.68 0 0 0-.34-.588",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#82b536",
        fillRule: "evenodd",
        d: "m47.824 20.09-1.798 1.037 1.652.953a.682.682 0 0 0 1.02-.588v-.899z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 31,
        height: 5,
        x: 54,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#6b6e76",
        d: "m94.337 18.617-1.687 1.688a.21.21 0 0 1-.282.014l-.016-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M106.501 16.398a.75.75 0 0 1 1.061 0l.462.462a.75.75 0 0 1 0 1.06l-3.037 3.037a.75.75 0 0 1-.383.205l-1.268.254a.282.282 0 0 1-.331-.331l.254-1.267a.75.75 0 0 1 .205-.384zm.663.397a.187.187 0 0 0-.265 0l-.36.36.727.728.36-.36a.186.186 0 0 0 0-.266zm-.296 1.486-.727-.728-2.279 2.28a.2.2 0 0 0-.052.095l-.17.854.853-.171a.2.2 0 0 0 .096-.051zm.555 1.45a.282.282 0 0 1 .529 0l.231.633.632.23a.281.281 0 0 1 0 .53l-.632.23-.231.632a.282.282 0 0 1-.529 0l-.23-.632-.633-.23a.281.281 0 0 1 0-.53l.633-.23z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 38.5,
        height: 5,
        x: 112,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#0b1228",
        fillOpacity: 0.06,
        d: "M156.5 10.171h.5v18h-.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M166.805 17.109H165v-.563h4.125v.563h-1.758v4.687h-.562zm2.695 1.5v-.938h.562v.938H171v.562h-.938v1.875c0 .104.084.188.188.188h.75v.562h-.75a.75.75 0 0 1-.75-.75v-1.875h-.75v-.562z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M181.125 16.968c0-.233.189-.422.422-.422h1.734c.845 0 1.594.61 1.594 1.524 0 .367-.121.685-.321.934.414.261.696.708.696 1.269 0 .914-.749 1.523-1.594 1.523h-2.109a.42.42 0 0 1-.422-.422zm2.156 1.781c.45 0 .75-.299.75-.68 0-.38-.3-.679-.75-.679h-1.312v1.36zm-1.312.844h1.687c.45 0 .75.3.75.68s-.3.68-.75.68h-1.687z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#6b6e76",
        d: "m196.837 18.617-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M206.188 17.765a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m0 2.813a.562.562 0 1 1 1.124-.002.562.562 0 0 1-1.124.002M212 18.046h-3.75v-.562H212zm0 2.813h-3.75v-.563H212z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#6b6e76",
        d: "m222.837 18.617-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M238.625 17.484h-5.25v-.563h5.25zm0 1.968h-5.25v-.562h5.25zM236 21.423h-2.625v-.563H236z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 10.135,
        height: 10.135,
        x: 246.932,
        y: 14.104,
        stroke: "#0b1228",
        strokeOpacity: 0.14,
        strokeWidth: 0.365,
        rx: 2.068
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#505258",
        strokeLinejoin: "round",
        strokeWidth: 0.637,
        d: "M249.938 21.609v-.179l.609-1.605m3.433 1.784v-.179l-.606-1.605m0 0-1.169-3.091h-.484l-1.174 3.091m2.827 0h-2.827"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M268.082 17.004a1.475 1.475 0 0 1 2.086 2.085l-.844.844-.398-.398.844-.844a.912.912 0 0 0-1.29-1.29l-.844.844-.397-.398zm1.148 1.335-2.062 2.062-.398-.397 2.062-2.063zm-3.398.915.844-.844.398.398-.844.843a.912.912 0 0 0 1.29 1.29l.844-.844.397.398-.843.844a1.475 1.475 0 0 1-2.086-2.085M280 17.343c0-.544.441-.984.984-.984h4.032c.543 0 .984.44.984.984v3.094a.985.985 0 0 1-.984.984h-3.348l-1.247.713a.282.282 0 0 1-.421-.244zm.984-.422a.42.42 0 0 0-.422.422v4.062l.957-.546h3.497a.42.42 0 0 0 .422-.422v-3.094a.42.42 0 0 0-.422-.422zm3.516 1.688h-3v-.563h3zm-1.125 1.125H281.5v-.563h1.875z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 29.5,
        height: 5,
        x: 289,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M327.5 19.171a.562.562 0 1 1 1.125 0 .562.562 0 0 1-1.125 0m2.438 0a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m2.437 0a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#0c66e4",
        fillOpacity: 0.14,
        d: "M314 34.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 32h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M149.798 30.711a6 6 0 0 0-3.969 1.338 6.03 6.03 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.144-2.287 1.144h-1.143v3.43h1.143a6.03 6.03 0 0 0 3.968-1.338 5.97 5.97 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V39.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V30.71z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#000",
        d: "M149.798 32.998v-1.143a4.57 4.57 0 0 0-3.969 1.875 4.57 4.57 0 0 0-3.968-1.875v1.143a3.21 3.21 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.64 4.64 0 0 0 3.968-1.864 4.64 4.64 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.21 3.21 0 0 1 3.362-2.115"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-259-131.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -67,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M31.03-38.464a3.93 3.93 0 0 1 3.932-3.932h487.582v374.861H31.03z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 57,
        height: 14,
        x: 42,
        y: 12.171,
        fill: "#fff",
        rx: 2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M177 14.171a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M203 14.171a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "d",
        width: 311.5,
        height: 30,
        x: 34,
        y: 8.171,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 0.25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "effect1_dropShadow_13945_18711",
        result: "effect2_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13945_18711",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "h",
        width: 14.292,
        height: 24.521,
        x: 138.718,
        y: 29.708,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13945_18711",
        result: "shape"
    }))));
const $3faf0024169aae07$var$NewToolbarBannerImageDark = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 56",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "b",
        width: 686,
        height: 389,
        x: -260,
        y: -132.5,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-260-132.5h686v389h-686z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563M103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563M103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#48245d",
        strokeWidth: 2,
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M178.953-13.348c-7.945-.014-15.69-1.098-23.256-2.445-.036-.478-.072-.956-.107-1.448.534 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.276-1.098-1.903-1.654a312 312 0 0 1-13.373-12.67m18.289 11.13v-.072a493.5 493.5 0 0 1-.064-1.547v-.171a228 228 0 0 1-.1-3.415q.002-.18-.007-.37l-.022-1.32q.002-.3-.007-.599c0-.399-.007-.798-.014-1.205v-2.416c0-.92.014-1.826.036-2.731a41 41 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311 311 0 0 1-.164-3.202z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M181.937-12.977c.328.278 2.38 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.727-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.679-1.247a41 41 0 0 0 4.695-1.362c.021-.877.05-1.74.086-2.602l-.485.192c-.477.185-.969.32-1.453.478-.962.335-1.953.57-2.922.805-3.911.927-7.787 1.29-11.328 1.412-.435.014-.87.028-1.297.036a426 426 0 0 1-6.726-6.916c-5.6-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.955 1.327 1.703 2.368 2.316 3.138-.756-.656-1.832-1.932-3.029-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.583 19.014a405 405 0 0 0 5.757 6.01c-1.86-.02-3.584-.092-5.145-.156-5.336-.457-10.637-1.234-15.917-2.182.021.285.036.563.057.841l.107 1.448c7.567 1.34 15.312 2.424 23.256 2.445a312 312 0 0 0 13.374 12.67c.627.556 1.268 1.105 1.902 1.654h2.857c-1.375-1.191-2.992-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M372.866-51.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.001c-8.208 0-14.977 1.91-19.338 6.36-.484.492-.94 1.02-1.36 1.575a15 15 0 0 0-.613.863c-2.152 3.244-3.342 7.479-3.342 12.848 0 4.249.884 10.701 1.404 16.055.035.357.071.706.1 1.056h-19.523a322 322 0 0 1-.164-3.202c.05 1.106.1 2.168.164 3.202.513 8.933 1.439 15.264 2.123 20.419h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01a64.7 64.7 0 0 0 10.175-7.371v-92.75h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M383.126-120.549c0 8.691-1.632 15.386-4.752 20.369-1.561 2.489-3.492 4.556-5.786 6.218a23.62 23.62 0 0 1-3.705 2.203c-1.482.72-3.078 1.304-4.781 1.79q-1.304.374-2.693.662c-3.178.649-6.676.963-10.481.963h-74.599c-.755 0-1.51 0-2.251.021-3.62.057-7.111.25-10.488.57-.385.036-.777.072-1.154.115l-.357.042-.79.086c-3.235.37-6.363.855-9.363 1.469-4.068.834-7.923 1.889-11.556 3.172-.513.178-1.019.371-1.525.556-.1.036-.207.079-.307.114-.306.114-.605.243-.912.364-6.483 2.567-12.219 5.89-17.178 9.939a61 61 0 0 0-2.173 1.86c-4.631 4.179-8.522 9.048-11.657 14.61-.106.184-.206.377-.313.57-.093.17-.192.342-.285.513-.257.47-.506.955-.748 1.433-3.064 6.067-5.294 12.883-6.655 20.433a95 95 0 0 0-.527 3.294c-.029.214-.064.421-.093.628a108 108 0 0 0-.869 9.874 156.42 156.42 0 0 0-.086 2.603c-.021.905-.035 1.81-.035 2.73v2.417c0 .407.007.806.014 1.205q-.002.3.007.599c0 .45.014.884.022 1.319a1907.277 1907.277 0 0 0 .049 2.096q.024.856.057 1.69v.17l.065 1.548v.071c.049 1.105.099 2.168.163 3.202h19.523q-.045-.523-.1-1.056c-.52-5.354-1.403-11.813-1.403-16.056 0-5.361 1.189-9.596 3.341-12.847.193-.293.399-.585.613-.863a15.77 15.77 0 0 1 1.361-1.575c4.353-4.45 11.129-6.36 19.337-6.36h65.001c23.42 0 48.607-2.717 67.788-14.01 18.703-11.015 31.692-30.201 31.692-63.069v-16.626h-21.432v10.944z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        stroke: "#35243f",
        d: "M78.564-80.346c6.518.516 13.329 1.303 20.446 2.368l-9.442 62.416c-23.076-3.095-40.179-1.723-52.143 4.424C25.46-4.99 18.722 5.886 16.243 21.575l-60.965-9.233c4.02-26.155 12.06-47.013 25.019-62.325 46.462 3.56 78.159-6.886 98.267-30.363Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M293.564 2.808s.499 65.85 0 65.421c0 0 15.127 2.075 32.384 2.574-.05-15.749-.171-32.675-.193-35.94v-.571a75 75 0 0 0 2.515.82 66 66 0 0 0 2.202.65c.634.177 1.268.349 1.909.505.157.043.314.079.471.122.677.17 1.361.328 2.037.484.093.022.179.036.271.058.627.135 1.247.27 1.874.392.135.028.271.057.406.078.691.135 1.382.257 2.066.378.1.014.2.035.3.05q.953.16 1.895.3c.107.014.214.035.321.05.698.099 1.403.192 2.101.284.093.015.193.022.285.036.67.078 1.333.157 1.995.221.057 0 .114.014.171.021.713.072 1.433.136 2.138.193.078 0 .164.014.242.021 1.447.114 2.879.2 4.304.264h.164q2.178.088 4.303.1h.064c1.447.007 2.872 0 4.275-.043V3.371s-36.907 10.43-68.5-.563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M348.705 38.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021m-11.691-1.611c.135.028.27.057.406.078q-.204-.045-.406-.079m-4.646-1.055c.157.043.314.079.47.121a12 12 0 0 1-.47-.12m-4.588-1.305q.248.075.485.15-.248-.075-.485-.15m2.507.748q.084.02.178.05a2 2 0 0 1-.178-.05m16.109 3.009c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021m-20.448 32.083c.049 15.1.028 29.103-.2 28.91 0 0 45.222 6.204 68.5-.284v-64.58s-14.029 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.109 2.852z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M357.718 39.319c-1.418-.007-2.85-.043-4.304-.1h-.163a111.47 111.47 0 0 1-4.304-.264c-.078 0-.164-.014-.242-.021q-1.069-.085-2.138-.193c-.057 0-.114-.014-.171-.021a196.13 196.13 0 0 1-1.995-.221c-.092-.014-.192-.022-.285-.036a75 75 0 0 1-2.102-.285c-.106-.014-.213-.036-.32-.05a87 87 0 0 1-1.895-.3c-.1-.014-.2-.035-.3-.05a96 96 0 0 1-2.472-.456c-.627-.12-1.247-.256-1.874-.392-.093-.021-.178-.035-.271-.057a69 69 0 0 1-2.037-.484q-.236-.056-.471-.122c-.634-.164-1.275-.328-1.909-.506a108.306 108.306 0 0 1-2.202-.649c-.164-.05-.328-.1-.484-.15a75 75 0 0 1-2.031-.67v.571c.021 3.265.143 20.198.192 35.94 12.583.364 26.299-.121 36.11-2.852V39.283q-2.106.054-4.275.043h-.064z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M86.99 46.598c.192-.97.49-2.21.883-3.8.498-2.281 1.653-6.032 2.807-9.333 1.154-3.308 2.259-6.188 2.202-6.958-1.098 2.873-2.7 6.987-3.883 10.873-1.205 3.878-2.003 7.507-2.01 9.225z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M69.926 56.016c5.037 2.91 9.505 6.46 13.267 10.688q.02-.205.043-.4c1.104-9.667 2.771-18.936 5.215-27.427 2.408-8.499 5.657-16.177 9.355-22.715a86 86 0 0 1 2.672-4.406q-1.432.254-2.843.563c-16.017 3.486-29.512 11.714-37.463 25.795 2.658 5.069 5.337 10.117 8.144 15.093.527.941 1.076 1.868 1.617 2.802zm67.381-35.598a141 141 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.405 21.596s-6.099 16.106-7.538 24.804a90.7 90.7 0 0 0-1.233 15.457q.204.009.407.028l1.531.093c.513.007 1.019-.028 1.525-.035.506-.03 1.012 0 1.511-.093 1.004-.136 1.995-.214 2.985-.435 6.384-1.184 12.027-3.48 16.366-5.804-.52-1.226-.962-2.495-1.432-3.757-.313-.827-.527-1.69-.791-2.538-.249-.856-.527-1.697-.705-2.574l-.599-2.602c-.185-.87-.306-1.754-.456-2.624-.335-1.74-.441-3.508-.641-5.24-.214-3.48-.299-6.902-.021-10.16.434-6.524 1.745-12.356 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.762-6.025 2.629-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.407-15.8 0 0-.62.735-1.503 1.926a57 57 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.929 5.447-.413.848-.791 1.618-1.104 2.267l-.691 1.568v-.078l-.086.15c1.539-4.021 3.399-8.078 5.836-11.957 1.617-2.595 3.498-5.112 5.685-7.407l-.733-.193c-2.587 1.818-4.91 4.17-7.104 6.73z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M131.343 47.354c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.157-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.019-4.934 1.09-5.397.064-.464-.257.192-.62 1.476zM66.27 54.07c-2.536-4.534-4.944-9.097-7.317-13.66q-.055.116-.121.22c-1.397 2.824-2.572 5.868-3.534 9.134q.693.213 1.375.428a73.4 73.4 0 0 1 9.605 3.871zm-3.49-8.634c.741 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.773-8.384-3.028-4.79m54.72 1.396c1.503-2.866 2.743-5.105 3.969-7.329 1.246-2.21 2.493-4.413 4.203-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.272 8.634-1.831 3.244-3.164 6.132-2.843 6.203l.114-.236zm-1.825 4.577-.178-.22c-1.995 4.605-3.769 9.39-5.13 14.38l.2.228c1.332-4.898 3.177-9.91 5.108-14.387m29.569-36.868.05-.057c.164-.157.313-.306.456-.442a6 6 0 0 1-.342-.092q-.17.19-.349.413l.178.178zm31.607 25.446c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.847-4.712 1.246-7.115.699-4.812 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M178.739 48.324c-.827 16.583-3.371 33.288-8.529 47.832a111 111 0 0 1-4.959 11.828l2.679-.399a38 38 0 0 0-.428 1.961c-.035.178-.064.356-.099.527a45 45 0 0 0-.25 1.612c-.014.121-.035.242-.05.363-.057.485-.099.97-.142 1.455.812.221 1.617.427 2.422.598-2.636-.27-2.337-.128-.342.286.05.007.107.021.157.028 5.273-4.327 9.662-9.71 12.882-16.284 3.449-7.023 5.629-15.343 6.121-25.175.498-9.981-.848-18.594-3.613-26.009a49.4 49.4 0 0 0-5.664-10.887c.114 4.086.021 8.185-.185 12.264"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M159.743 63.274c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.463-.4.962-.82.249-.214.499-.42.677-.592.185-.17.306-.285.313-.292a59 59 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65 65 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a44 44 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.528-.078.784-.114.399-.791.77-1.604 1.161-2.396 1.048-2.074 1.874-4.249 2.786-6.388.428-1.076.805-2.181 1.212-3.265l.598-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.377-2.274.57-3.408l.47-3.415.235-1.704.185-1.711c.129-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.022 0-.042-.007-.085-.007-.128a49 49 0 0 0-3.669-3.836c-.022 2.025-.235 4.022-.556 5.968-1.938 10.701-6.284 20.512-11.906 29.025zM129.035 53.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.313.079-1.02.107-1.625.029-.6.057-1.098-.157-1.006z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M161.988 59.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13m-16.109-42.157c-2.473 2.816-4.56 6.039-6.37 9.44-3.577 6.837-6.17 14.33-7.439 22.023-.142.963-.342 1.918-.434 2.888l-.314 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.535 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.055-2.723 5.273-3.621.591-.471 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.05-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.149.349-.741.876-1.803 1.432-3.144a74 74 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.014-.235-.05-.463-.071-.698-5.8-4.656-12.697-8.178-20.357-10.66-.256-.085-.52-.156-.776-.235a37 37 0 0 0-2.123 2.232zm23.683 18.944c.285-1.255.491-2.802.627-3.594.085-1.554.021-2.139-.043-2.103-.078.036-.15.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.135.35.449-.606.72-1.86zm-68.458-21.689c.342-.663.513-.962.485-.97-.022-.007-.242.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.807 5.169-4.425 8.905-1.61 3.743-3.199 8.177-4.567 12.926-2.743 9.51-4.375 20.276-5.272 28.953-.057.578-.114 1.14-.171 1.697 3.042 3.871 5.536 8.263 7.374 13.204q.599 1.617 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.263.855.556 1.311.798.45.243.905.478 1.361.72.45.257.92.464 1.397.663l1.418.614 1.467.499.734.25.748.184 1.504.371h.007c0-1.09 0-2.189.043-3.287.334-11.15 2.785-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.43-29.51 1.682-2.26 3.385-4.477 5.187-6.651 1.81-2.168 3.741-4.285 5.943-6.16l.128-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.295-.064-19.565.855a85 85 0 0 0-3.798 5.975c.705-1.419 1.275-2.403 1.617-3.066z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M175.076 59.268c-.128 1.133-.249 2.274-.377 3.407l-.186 1.712-.235 1.704c-.157 1.133-.313 2.274-.47 3.415-.185 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.696-.677 3.394-.791 3.372-.399 1.69-.456 1.676-.919 3.35-1.054 3.316c-.178.549-.342 1.112-.535 1.654l-.598 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.763 1.604-1.162 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15q.075-.152.214-.421c.164-.371.392-.905.662-1.54.528-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.214.17c-.52 1.776-1.083 3.858-1.91 5.997-.399 1.07-.784 2.189-1.247 3.287-.477 1.09-.954 2.195-1.432 3.293-.456 1.106-1.033 2.154-1.546 3.187-.264.507-.513 1.013-.769 1.512q.553-.084 1.054-.157c.128-.257.257-.513.378-.77l.142.292-.214.428c.157-.021.3-.043.449-.064a110 110 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45 45 0 0 0-1.61-2.181c.093 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.384 4.998-1.011 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.474 6.894.997-6.26 2.878-16.769 3.747-27.834.463-5.525.834-11.172.884-16.426.028-2.375-.007-4.663-.107-6.824q-.426-.525-.862-1.04c0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021zm-6.462 40.31c-.292.813-.442.999-.812 1.804-.3.157.163-.92.627-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078m-.94-60.338a74.4 74.4 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145-.342.741-.563 1.148-.563 1.148-1.154 2.317-2.451 4.57-3.805 6.78-1.403 2.182-2.864 4.328-4.453 6.388-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.758-5.572 5.433 0 0-.157.142-.47.385-.314.25-.777.613-1.368 1.09-1.219.906-2.964 2.225-5.273 3.623-.149.092-.306.185-.456.278.292.706.606 1.397.912 2.089a59 59 0 0 0 4.788-3.366s-.135.122-.313.293-.435.378-.677.592c-.492.42-.933.798-.962.82 3.933-2.66 7.674-5.875 11.022-9.461a85 85 0 0 0 9.363-11.757c5.621-8.513 9.975-18.316 11.906-29.025.327-1.946.534-3.943.555-5.968a55 55 0 0 0-3.078-2.673c.022.235.057.463.072.699.313 4.128-.421 8.748-1.532 12.926zm-5.686 19.87c-3.855 6.21-.064-.94 1.617-3.13a39 39 0 0 1-1.617 3.13m8.165-28.91c.057-.036.129.542.043 2.103-.135.792-.349 2.346-.627 3.594-.278 1.255-.584 2.21-.72 1.86.207-1.226.784-4.106 1.019-5.946.143-.92.214-1.575.292-1.61zM88.45 38.877c-2.443 8.491-4.11 17.76-5.215 27.428q-.02.204-.043.399a49 49 0 0 1 1.903 2.281q.086-.833.17-1.697c.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.119-1.868 1.461-2.424.349-.563.57-.841.591-.834.028.007-.143.306-.485.97s-.911 1.646-1.617 3.065a87 87 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86 86 0 0 0-2.671 4.406c-3.698 6.538-6.947 14.216-9.356 22.715zm2.23-5.412c-1.154 3.309-2.308 7.052-2.806 9.333-.392 1.59-.692 2.83-.884 3.8.007-1.718.812-5.347 2.01-9.225 1.182-3.886 2.785-7.993 3.882-10.873.057.763-1.054 3.65-2.201 6.958zm21.988 82.747a78 78 0 0 1-3.071-13.24c-.42-2.916-.655-5.839-.762-8.755q.597.045 1.183.079c.313.014.627.05.94.042l.934-.028c.62-.029 1.247-.014 1.859-.079 2.494-.25 4.817-.72 7.161-1.311 2.337-.6 4.638-1.384 6.933-2.303a54 54 0 0 0 6.227-3.002c-.15-.335-.314-.656-.456-.991q-.269-.556-.506-1.134c-4.339 2.325-9.989 4.62-16.366 5.804-.991.22-1.981.3-2.986.435-.498.085-1.004.064-1.51.093-.506.007-1.019.05-1.525.035l-1.532-.093c-.135-.007-.27-.02-.406-.028a90.7 90.7 0 0 1 1.233-15.457c1.432-8.698 4.082-17.033 7.538-24.804s7.709-14.987 12.405-21.596a141 141 0 0 1 7.353-9.468c2.187-2.56 4.517-4.905 7.103-6.73a94 94 0 0 0-3.662-.891l-.128.107c-2.209 1.875-4.133 4-5.942 6.16-1.803 2.167-3.506 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.431 29.51-4.082 10.53-6.533 21.703-6.868 32.853a84 84 0 0 0-.043 3.287h-.007l-1.503-.37-.749-.186-.733-.25-1.468-.499-1.418-.613c-.477-.2-.948-.406-1.397-.663l-1.36-.72c-.45-.242-.877-.535-1.311-.799-.877-.513-1.696-1.112-2.515-1.703-.036-.029-.072-.05-.1-.079.356 1.17.67 2.367.954 3.594a41 41 0 0 0 4.311 2.402c2.373 1.148 4.859 1.882 7.332 2.374.285 9.183 1.988 18.216 5.294 26.594 1.111 2.702 2.508 5.34 4.232 7.735.185.015.363.029.548.036a39 39 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.598-2.303c-.171-.685-.285-1.283-.399-1.775l-.335-1.533c.427 1.64.84 3.287 1.361 4.926a60 60 0 0 0 1.66 4.913c1.239 3.251 2.8 6.466 4.88 9.382q.289.405.599.799c.691.035 1.382.05 2.073.071-.064-.078-.135-.143-.192-.221-2.836-3.458-4.788-7.614-6.227-11.914zm7.56-75.346c1.81-3.251 4.147-6.83 5.272-8.634l.179.193c-1.71 2.659-2.957 4.862-4.204 7.072-1.226 2.225-2.465 4.463-3.969 7.33l-.114.235c-.313-.072 1.012-2.96 2.843-6.203zM115.49 51.19l.178.22c-1.931 4.478-3.776 9.49-5.109 14.388l-.199-.228c1.361-4.99 3.135-9.774 5.13-14.38m-12.953 40.147c-.371-.114-.578-.214-.706-.314-.256-.207-.235-.37-.677-.72.72.392 3.527 1.305 2.879 1.29l.235.1c-.827-.064-1.354-.25-1.731-.35zm4.346 8.684c-.264-1.804-.321-3.223-.378-4.193-.007-.976.022-1.518.079-1.582.114-.129.235 1.64.527 5.575l.021.178-.249.014zM69.926 56.016a563 563 0 0 1-1.617-2.802c-2.807-4.976-5.486-10.031-8.144-15.093a54 54 0 0 0-1.225 2.296c2.372 4.563 4.787 9.126 7.317 13.66a64 64 0 0 1 3.662 1.947zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "m133.622 33.251.093-.15v.08c.164-.364.399-.906.691-1.57.314-.648.691-1.418 1.105-2.267.783-1.704 1.852-3.636 2.928-5.447a57 57 0 0 1 3.092-4.662c.884-1.191 1.504-1.925 1.504-1.925-3.178 4.784-6.014 10.124-8.408 15.799-2.373 5.668-4.239 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.453 4.5-2.757 10.331-3.199 16.855-.278 3.258-.192 6.68.021 10.16.2 1.732.307 3.493.642 5.24.156.87.27 1.754.456 2.623l.598 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.471 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.307.663.456.99a43 43 0 0 0 1.824 3.615 55 55 0 0 0 2.608 4.221 53.39 53.39 0 0 0 5.771 7.087 47.5 47.5 0 0 0 5.829 5.069c-.129-.228-1.39-1.112-2.622-2.21-.635-.535-1.226-1.148-1.732-1.69-.484-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.917-.286 2.836-.421a41 41 0 0 1-3.584-2.317c-5.187-3.729-9.911-8.82-13.595-14.901a62 62 0 0 1-2.565-4.734 56 56 0 0 0-.506-1.14c-.306-.692-.619-1.384-.912-2.09a27 27 0 0 1-.698-1.825c-.684-1.711-1.168-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.932.128-3.865.242-5.804l.314-2.902c.092-.97.299-1.925.434-2.887 1.269-7.693 3.855-15.186 7.439-22.024 1.81-3.4 3.897-6.623 6.37-9.44a37 37 0 0 1 2.123-2.23 74 74 0 0 0-2.252-.678 14 14 0 0 1-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.042-.27-.071-2.181 2.296-4.069 4.813-5.686 7.408-2.437 3.885-4.296 7.935-5.835 11.956zm-4.424 21.36c-.029.6-.107 1.306-.107 1.626-.057-.449-.249-1.283-.221-1.803.029-.364.1-.457.164-.828.221-.092.185.407.157 1.006zm10.466 41.973c-.399-.35-.79-.92-1.161-1.511-.356-.6-.67-1.22-.955-1.655.164-.092.834.799 1.418 1.647.584.849 1.055 1.669.698 1.519m-8.065-23.849c.784 4.328 2.066 8.698 3.285 11.764.064.164.128.335.192.492.242.52.499 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.27 1.047 1.32 2.08 2.567 3.114 3.644.356.392.755.784 1.175 1.183.413.414.855.827 1.34 1.248-5.28-4.057-10.218-10.402-13.445-17.724a51 51 0 0 1-.599-1.419c-.099-.235-.192-.478-.285-.713-1.489-3.729-2.6-7.636-3.356-11.522-.776-4.142-1.132-8.256-1.282-12.155.598 2.645.912 7.094 1.817 11.642zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.199.442-.299.528l.05.035s-.079.385-.15.97c-.057.578-.192 1.348-.221 2.132l-.192 3.28-.249-.05c-.008-1.555.049-3.637.406-5.619.263-1.996.783-3.9 1.125-5.183.364-1.283.684-1.94.62-1.476z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#35243f",
        d: "M93.46 124.325a45 45 0 0 1-1.426-.449 73 73 0 0 1-6.042-2.253 62 62 0 0 1-2.885-1.304 69 69 0 0 1-2.793-1.426c-10.524-5.704-18.824-14.11-23.52-25.574-.206-.5-.399-1.006-.591-1.512a56.4 56.4 0 0 1-2.473-8.748 60 60 0 0 1-.755-4.763c-.456-3.807-.591-7.85-.378-12.156.3-5.981 1.219-11.4 2.658-16.312-7.332-2.239-15.254-3.55-23.498-3.964-9.22-.464-18.083.128-26.256 1.896C-11.656 51.468-25.678 60.458-33.323 76c-3.491 7.102-5.7 15.53-6.199 25.518-.491 9.839.841 18.33 3.57 25.666 2.928 7.871 7.517 14.352 13.374 19.571 0-.078.014-.157.021-.235.043-.549.071-1.098.093-1.654 0-.121.014-.235.014-.357.021-.656.021-1.311.007-1.975 0-.121-.007-.249-.014-.37a32 32 0 0 0-.086-1.633l-.043-.542a32 32 0 0 0-.228-1.989s37.542 9.575 37.357 9.276v.071q-.002.065-.014.171v.029c0 .071-.015.164-.022.263 0 .029 0 .05-.007.079q-.012.159-.036.349.002.043-.007.086-.019.213-.05.47v.029c-.02.171-.035.356-.056.556q.002.042-.008.085-.03.298-.07.628c0 .043-.008.085-.015.135-.029.221-.05.449-.078.685 0 .057-.015.107-.022.164-.028.242-.064.499-.092.755 0 .05-.015.1-.022.157-.036.278-.071.556-.114.849a1 1 0 0 1-.014.114c-.036.285-.079.577-.121.877 0 .043-.014.078-.014.121-.043.314-.093.627-.136.955-.007.065-.021.129-.028.193q-.075.482-.15.984c-.014.071-.021.142-.036.214q-.076.502-.163 1.026a2 2 0 0 1-.036.193q-.087.543-.185 1.098c-.008.05-.022.107-.029.157q-.094.546-.2 1.105c0 .035-.014.071-.02.1-.072.392-.15.784-.222 1.183-.014.057-.021.121-.035.178l-.171.863c4.353.756 8.87 1.241 13.495 1.476 8.77.442 17.292-.15 25.215-1.868 17.007-3.686 31.165-12.691 38.86-28.319 1.403-2.845 2.579-5.911 3.54-9.197a62.925 62.925 0 0 1-.007.014z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#48245d",
        d: "M52.605 66.148c-.214 4.306-.078 8.348.378 12.156a60.226 60.226 0 0 0 .755 4.763 56 56 0 0 0 2.472 8.747c.193.514.385 1.013.591 1.512 4.696 11.464 12.996 19.87 23.52 25.574.912.499 1.846.969 2.793 1.426q1.422.684 2.886 1.304a75 75 0 0 0 6.042 2.253c.47.157.947.3 1.425.449.335-1.14.634-2.31.912-3.507q.077-.323.142-.656a73 73 0 0 0 .734-3.886q.117-.728.221-1.476c.114-.805.207-1.618.292-2.452.036-.35.064-.699.1-1.056.078-.905.15-1.818.2-2.752 0-.099.014-.199.02-.306v-.057c.357-7.03-.213-13.382-1.545-19.115a60 60 0 0 0-.955-3.593 53 53 0 0 0-1.112-3.308c-1.838-4.941-4.332-9.326-7.374-13.204a49 49 0 0 0-1.902-2.282c-3.762-4.228-8.23-7.778-13.267-10.687a62 62 0 0 0-3.662-1.947 71 71 0 0 0-9.605-3.87q-.682-.225-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1d2125",
        d: "M58.287-67h418.734v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "#303134",
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M101 18h342v8H101zM91 38h352v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 299.5,
        height: 18,
        x: 40,
        y: 9.271,
        fill: "#2b2c2f",
        rx: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        d: "M47.69 15.356a.68.68 0 0 1 .669.006l1.625.937.385.223a.68.68 0 0 1 .34.588v2.32a.677.677 0 0 1-.34.588l-1.51.872.009-.028a.9.9 0 0 0 .043-.273V18.27a.89.89 0 0 0-.447-.771l-.279-.161-.847-.489v-.898a.68.68 0 0 1 .34-.587z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        d: "m47.178 15.652-1.51.872a.68.68 0 0 0-.34.589v2.319c0 .242.13.467.34.589l.358.206 1.652.953a.682.682 0 0 0 1.02-.588v-.899l-.874-.504-.252-.145a.89.89 0 0 1-.446-.772v-2.319a.9.9 0 0 1 .052-.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1868db",
        fillRule: "evenodd",
        d: "m47.824 19.19-1.798 1.037-.358-.206a.68.68 0 0 1-.34-.589v-2.32c0-.243.129-.467.34-.588l1.51-.872-.01.029a.9.9 0 0 0-.042.272v2.32c0 .318.17.612.446.77z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#bf63f3",
        fillRule: "evenodd",
        d: "m48.185 17.338-.847-.489v-.898a.68.68 0 0 1 .34-.587l.012-.008a.68.68 0 0 1 .669.006l1.625.937z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fca700",
        fillRule: "evenodd",
        d: "m50.369 16.522-.385-.223-1.799 1.039.28.16a.89.89 0 0 1 .446.772v2.32a.9.9 0 0 1-.053.3l1.511-.872a.68.68 0 0 0 .34-.588v-2.32a.68.68 0 0 0-.34-.588",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#82b536",
        fillRule: "evenodd",
        d: "m47.824 19.19-1.798 1.037 1.652.953a.682.682 0 0 0 1.02-.588v-.899z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 31,
        height: 5,
        x: 54,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#96999e",
        d: "m94.337 17.717-1.687 1.688a.21.21 0 0 1-.282.014l-.016-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M106.501 15.498a.75.75 0 0 1 1.061 0l.462.462a.75.75 0 0 1 0 1.06l-3.037 3.037a.75.75 0 0 1-.383.205l-1.268.254a.282.282 0 0 1-.331-.331l.254-1.267a.75.75 0 0 1 .205-.383zm.663.397a.187.187 0 0 0-.265 0l-.36.36.727.728.36-.36a.186.186 0 0 0 0-.266zm-.296 1.486-.727-.728-2.279 2.28a.2.2 0 0 0-.052.095l-.17.854.853-.171a.2.2 0 0 0 .096-.051zm.555 1.45a.282.282 0 0 1 .529 0l.231.633.632.23a.281.281 0 0 1 0 .53l-.632.23-.231.632a.282.282 0 0 1-.529 0l-.23-.632-.633-.23a.281.281 0 0 1 0-.53l.633-.23z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 38.5,
        height: 5,
        x: 112,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#0b1228",
        fillOpacity: 0.06,
        d: "M156.5 9.271h.5v18h-.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M166.805 16.209H165v-.563h4.125v.563h-1.758v4.687h-.562zm2.695 1.5v-.938h.562v.938H171v.562h-.938v1.875c0 .104.084.188.188.188h.75v.562h-.75a.75.75 0 0 1-.75-.75v-1.875h-.75v-.562z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M181.125 16.068c0-.233.189-.422.422-.422h1.734c.845 0 1.594.61 1.594 1.524 0 .367-.121.685-.321.934.414.261.696.708.696 1.269 0 .914-.749 1.523-1.594 1.523h-2.109a.42.42 0 0 1-.422-.422zm2.156 1.781c.45 0 .75-.299.75-.68 0-.38-.3-.679-.75-.679h-1.312v1.36zm-1.312.844h1.687c.45 0 .75.3.75.68s-.3.68-.75.68h-1.687z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#96999e",
        d: "m196.837 17.717-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M206.188 16.865a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m0 2.813a.562.562 0 1 1 1.124-.002.562.562 0 0 1-1.124.002M212 17.146h-3.75v-.562H212zm0 2.813h-3.75v-.563H212z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#96999e",
        d: "m222.837 17.717-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M238.625 16.584h-5.25v-.563h5.25zm0 1.968h-5.25v-.562h5.25zM236 20.522h-2.625v-.563H236z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 10.135,
        height: 10.135,
        x: 246.932,
        y: 13.204,
        stroke: "#e3e4f2",
        strokeOpacity: 0.12,
        strokeWidth: 0.365,
        rx: 2.068
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        stroke: "#a9abaf",
        strokeLinejoin: "round",
        strokeWidth: 0.637,
        d: "M249.938 20.709v-.179l.609-1.605m3.433 1.784v-.179l-.606-1.605m0 0-1.169-3.091h-.484l-1.174 3.091m2.827 0h-2.827"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M268.082 16.104a1.475 1.475 0 0 1 2.086 2.085l-.844.844-.398-.398.844-.844a.912.912 0 0 0-1.29-1.29l-.844.844-.397-.398zm1.148 1.335-2.062 2.062-.398-.397 2.062-2.063zm-3.398.915.844-.844.398.398-.844.843a.912.912 0 0 0 1.29 1.29l.844-.844.397.398-.843.844a1.475 1.475 0 0 1-2.086-2.085M280 16.443c0-.544.441-.984.984-.984h4.032c.543 0 .984.44.984.984v3.094a.984.984 0 0 1-.984.984h-3.348l-1.247.713a.282.282 0 0 1-.421-.244zm.984-.422a.42.42 0 0 0-.422.422v4.062l.957-.546h3.497a.42.42 0 0 0 .422-.422v-3.094a.42.42 0 0 0-.422-.422zm3.516 1.688h-3v-.563h3zm-1.125 1.125H281.5v-.563h1.875z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 29.5,
        height: 5,
        x: 289,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M327.5 18.271a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0m2.438 0a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m2.437 0a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#669df1",
        fillOpacity: 0.14,
        d: "M314 34.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 32h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        filter: "url(#i)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#1f1f21",
        d: "M149.798 30.711a6 6 0 0 0-3.969 1.338 6.03 6.03 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.144-2.287 1.144h-1.143v3.43h1.143a6.03 6.03 0 0 0 3.968-1.338 5.97 5.97 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V39.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V30.71z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#cecfd2",
        d: "M149.798 32.998v-1.143a4.57 4.57 0 0 0-3.969 1.875 4.57 4.57 0 0 0-3.968-1.875v1.143a3.21 3.21 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.64 4.64 0 0 0 3.968-1.864 4.64 4.64 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.21 3.21 0 0 1 3.362-2.115"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M-259-131.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -67,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M31.03-38.464a3.93 3.93 0 0 1 3.932-3.932h487.582v374.861H31.03z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: 57,
        height: 14,
        x: 42,
        y: 11.271,
        fill: "#fff",
        rx: 2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M177 13.271a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#fff",
        d: "M203 13.271a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "e",
        width: 311.5,
        height: 30,
        x: 34,
        y: 7.271,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 0.25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "effect1_dropShadow_13945_18829",
        result: "effect2_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13945_18829",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "i",
        width: 14.292,
        height: 24.521,
        x: 138.718,
        y: 29.708,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13945_18829",
        result: "shape"
    }))));
const $3faf0024169aae07$export$6196548d78d8d0b4 = /*#__PURE__*/ (0, $42omo.memo)($3faf0024169aae07$var$BannerImageLight);
const $3faf0024169aae07$export$b164ab6127963004 = /*#__PURE__*/ (0, $42omo.memo)($3faf0024169aae07$var$BannerImageDark);
const $3faf0024169aae07$export$79b5c2b53f30d5cc = /*#__PURE__*/ (0, $42omo.memo)($3faf0024169aae07$var$NewToolbarBannerImageLight);
const $3faf0024169aae07$export$c074d09e35c0419e = /*#__PURE__*/ (0, $42omo.memo)($3faf0024169aae07$var$NewToolbarBannerImageDark);


const $17ecc52f8acaba5c$var$layoutArea = 'editor-controls-changeboarding-layout-area';
const $17ecc52f8acaba5c$var$feedbackBannerStyles = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    color: 'color.text.subtle',
    padding: 'space.150',
    backgroundColor: 'color.background.accent.purple.subtlest',
    alignItems: 'center',
    justifyItems: 'end'
});
const $17ecc52f8acaba5c$var$breakpointContainerQuery = `@container ${$17ecc52f8acaba5c$var$layoutArea} (min-width: 67.5rem)`;
const $17ecc52f8acaba5c$var$shortChangeBoardingImageAddStyles = null;
const $17ecc52f8acaba5c$var$feedbackBannerNewPinningStyles = (0, $ecnYn.xcss)({
    containerType: 'inline-size',
    containerName: $17ecc52f8acaba5c$var$layoutArea,
    padding: 'space.0'
});
const $17ecc52f8acaba5c$var$feedbackBannerLayerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal'
});
const $17ecc52f8acaba5c$var$feedbackBannerMessageStyles = (0, $ecnYn.xcss)({
    gridArea: 'message',
    textAlign: 'center',
    display: 'inline-block',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.100',
    wordBreak: 'break-word'
});
const $17ecc52f8acaba5c$var$shortFeedbackBannerMessagePinningStyles = null;
const $17ecc52f8acaba5c$var$closeButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifySelf: 'end',
    gridArea: 'close',
    paddingRight: 'space.150'
});
const $17ecc52f8acaba5c$var$i18n = (0, $aXWIB.defineMessages)({
    bannerClose: {
        id: "editor-action-bar.editor-controls-onboarding.close",
        defaultMessage: "Close"
    },
    lozengeMessage: {
        id: "editor-action-bar.editor-controls-onboarding.lozenge",
        defaultMessage: "New"
    },
    collectorCommunityGroup: {
        id: "editor-action-bar.feedback-collector.community-group",
        defaultMessage: "Community group"
    },
    imageAltText: {
        id: "editor-action-bar.editor-controls-onboarding.image-alt-text",
        defaultMessage: "New formatting toolbar button"
    },
    bannerMessageForPinningTopToolbarShort: {
        id: "editor-action-bar.editor-controls-onboarding.message-pinning-inline-toolbar-short",
        defaultMessage: "Try the <link>inline toolbar</link>. Unpin it. Select text to edit."
    },
    bannerMessageForPinningInlineToolbarShort: {
        id: "editor-action-bar.editor-controls-onboarding.message-pinning-top-toolbar-short",
        defaultMessage: "<link>Inline toolbar</link>. Select text to edit. Or pin back to the top."
    },
    shareYourFeedbackShort: {
        id: "editor-action-bar.editor-controls-onboarding.share-your-feedback-short",
        defaultMessage: "<feedback>Feedback</feedback>"
    }
});
const $17ecc52f8acaba5c$export$1666b5647a488a02 = 'https://support.atlassian.com/confluence-cloud/docs/how-to-use-the-new-toolbar-and-insert-elements/';
const $17ecc52f8acaba5c$export$101e4e78d861fa81 = 'https://community.atlassian.com/forums/Confluence-articles/Live-Docs-Beta-update-Control-where-the-edit-tool-bar-lives/ba-p/3005144#M13863';
const $17ecc52f8acaba5c$var$getShortPinningBannerMessage = (bannerType)=>{
    if (bannerType === 'toolbar-inline') return $17ecc52f8acaba5c$var$i18n.bannerMessageForPinningInlineToolbarShort;
    return $17ecc52f8acaba5c$var$i18n.bannerMessageForPinningTopToolbarShort;
};
const $17ecc52f8acaba5c$var$BannerStyleWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_nd5l13um _1yt4utpp _1e0c116y _4cvr1h6o _1bah1h6o _1nmz1hna _1n261g80 _12qsutpp _o5amu2gc"
        ])
    }, children);
const $17ecc52f8acaba5c$var$BannerImageStyleWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_nd5l1sq2 _10fpv2br _1e0cglyw _17vm11p5"
        ])
    }, children);
const $17ecc52f8acaba5c$export$e465eaad07815d4e = ({ onDismiss: onDismiss, triggerAnalyticsEvent: triggerAnalyticsEvent, isLivePage: isLivePage, isEmbeddedConfluence: isEmbeddedConfluence, bannerType: bannerType })=>{
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [showFeedbackCollector, setShowFeedbackCollector] = (0, $42omo.useState)(false);
    const { areBannersHidden: areBannersHidden } = (0, $i4dNk.useCfind4473CreationFocusedNav)(); // simplify the nav for D0 experience
    (0, $42omo.useEffect)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('controls.banner.displayed', {
            isLivePage: isLivePage
        });
    }, [
        triggerAnalyticsEvent,
        isLivePage
    ]);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const handleOnClickClose = ()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('controls.banner.dismissed', {
            isLivePage: isLivePage
        });
        onDismiss();
    };
    const handleOnClickFeedbackButton = ()=>{
        setShowFeedbackCollector(true);
    };
    const handleSubmitFeedback = ()=>{
        handleOnClickClose();
        setShowFeedbackCollector(false);
    };
    if (isEmbeddedConfluence) return null;
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const NewToolbarBannerImage = isDarkMode ? (0, $3faf0024169aae07$export$c074d09e35c0419e) : (0, $3faf0024169aae07$export$79b5c2b53f30d5cc);
    const ChangeBoardingImage = isDarkMode ? (0, $3faf0024169aae07$export$b164ab6127963004) : (0, $3faf0024169aae07$export$6196548d78d8d0b4);
    const BannerImage = isNewToolbarEnabled ? NewToolbarBannerImage : ChangeBoardingImage;
    if (areBannersHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "editor-controls-onboarding-banner",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        templateAreas: [
            'image message close'
        ],
        templateColumns: "minmax(max-content, 1fr) auto 1fr",
        xcss: [
            $17ecc52f8acaba5c$var$feedbackBannerStyles,
            $17ecc52f8acaba5c$var$feedbackBannerLayerStyles,
            $17ecc52f8acaba5c$var$feedbackBannerNewPinningStyles
        ],
        testId: "editor-controls-onboarding-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17ecc52f8acaba5c$var$BannerImageStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BannerImage, {
        title: formatMessage($17ecc52f8acaba5c$var$i18n.imageAltText),
        titleId: `onboarding-banner-image-${isDarkMode ? 'dark' : 'light'}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17ecc52f8acaba5c$var$BannerStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $17ecc52f8acaba5c$var$feedbackBannerMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "new",
        isBold: true
    }, formatMessage($17ecc52f8acaba5c$var$i18n.lozengeMessage)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$17ecc52f8acaba5c$var$getShortPinningBannerMessage(bannerType),
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                    href: $17ecc52f8acaba5c$export$1666b5647a488a02,
                    target: "_blank"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                    weight: "bold"
                }, chunks)
        }
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$17ecc52f8acaba5c$var$i18n.shareYourFeedbackShort,
        values: {
            feedback: (chunks)=>// eslint-disable-next-line @atlassian/a11y/anchor-is-valid
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "#",
                    onClick: handleOnClickFeedbackButton
                }, chunks)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $17ecc52f8acaba5c$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($17ecc52f8acaba5c$var$i18n.bannerClose),
        onClick: handleOnClickClose
    }))), showFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcvq8.LazyGlobalFeedbackCollector), {
        onClose: ()=>setShowFeedbackCollector(false),
        onCloseComplete: ()=>{},
        onSubmit: handleSubmitFeedback,
        feedbackSource: (0, $lx6jn.FeedbackSource).EDITOR_CONTROLS,
        additionalFields: {
            source: 'editor-controls-feedback-banner'
        }
    }));
};












var $lmtWR = parcelRequire("lmtWR");

const $3b7f1197d4985005$export$e3fd0f06dd598301 = (isLivePage)=>{
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)({
        defaultDockedAtTop: !isLivePage
    });
    const bannerType = (0, $lmtWR.getBannerType)(isEditorToolbarDockedAtTop);
    const [isControlsBannerDismissed, setIsControlsBannerDismissed] = (0, $42omo.useState)(()=>(0, $lmtWR.isBannerDismissedInLocalStorage)(bannerType));
    (0, $42omo.useEffect)(()=>{
        setIsControlsBannerDismissed((0, $lmtWR.isBannerDismissedInLocalStorage)(bannerType));
    }, [
        bannerType
    ]);
    const onDismiss = (0, $42omo.useCallback)(()=>{
        setIsControlsBannerDismissed(true);
        (0, $lmtWR.persistBannerDismissalNewPinning)(bannerType);
    }, [
        bannerType
    ]);
    return {
        isControlsBannerDismissed: isControlsBannerDismissed,
        onDismiss: onDismiss,
        bannerType: bannerType
    };
};



var $1wNUR = parcelRequire("1wNUR");








var $dlSEv = parcelRequire("dlSEv");

var $cFEpk = parcelRequire("cFEpk");





var $1uFM6 = parcelRequire("1uFM6");


var $7LI3Q = parcelRequire("7LI3Q");





var $f7MuR = parcelRequire("f7MuR");


var $6vgLy = parcelRequire("6vgLy");




const $f7052e6541e23622$export$efe806c5aa871995 = ({ onExclude: onExclude })=>{
    const hasFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasFiredRef.current) {
            hasFiredRef.current = true;
            onExclude?.();
        }
    }, [
        onExclude
    ]);
    return null;
};


const $f70a72dbc1235d39$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $f70a72dbc1235d39$var$EMBEDDED_CONFLUENCE_FIRST_ACTIVE_TRAIT = 'embedded_confluence_user_first_active';
const $f70a72dbc1235d39$export$7baca885d79a7d1e = ({ children: children, activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate, excludeEmbeddedConfluence: excludeEmbeddedConfluence = false, onExclude: onExclude })=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)();
    const attributes = data?.attributes ?? null;
    const confluenceFirstActive = attributes?.find(({ name: name })=>name === $f70a72dbc1235d39$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const embeddedConfluenceFirstActive = attributes?.find(({ name: name })=>name === $f70a72dbc1235d39$var$EMBEDDED_CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActive = excludeEmbeddedConfluence ? confluenceFirstActive : $f70a72dbc1235d39$var$getEarliestDate(confluenceFirstActive, embeddedConfluenceFirstActive);
    const firstActiveDate = firstActive ? new Date(firstActive) : null;
    const { shouldExclude: shouldExclude } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return null;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $7LI3Q.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    if (shouldExclude) return onExclude ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7052e6541e23622$export$efe806c5aa871995), {
        onExclude: onExclude
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
/**
 * Returns the earliest valid date from two date strings, or null if neither is valid
 */ const $f70a72dbc1235d39$var$getEarliestDate = (date1, date2)=>{
    const validDates = [
        date1,
        date2
    ].filter(Boolean).map((date)=>new Date(date || '')).filter((0, $cFEpk.default));
    if (validDates.length === 0) return null;
    if (validDates.length === 1) return validDates[0].toISOString();
    return (0, $dlSEv.default)(validDates[0], validDates[1]) ? validDates[0].toISOString() : validDates[1].toISOString();
};


const $642dd5941c63cbaa$export$4a2ff2a211b229b0 = /*#__PURE__*/ (0, $42omo.memo)(({ isLivePage: isLivePage, isEmbeddedConfluence: isEmbeddedConfluence, viewMode: viewMode, spaceKey: spaceKey, triggerAnalyticsEvent: triggerAnalyticsEvent, contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner })=>{
    const { isControlsBannerDismissed: isControlsBannerDismissed, onDismiss: onDismiss, bannerType: bannerType } = (0, $3b7f1197d4985005$export$e3fd0f06dd598301)(isLivePage);
    const { isVisible: isOnboardingEditorDraftBannerVisible } = (0, $1wNUR.useOnboardingBannerLogic)({
        contentId: contentId,
        version: version,
        isShowingOfflineBanner: isShowingOfflineBanner,
        spaceKey: spaceKey,
        setIsOnboardingBannerDataLoaded: ()=>{}
    });
    const shouldShowControlsBanner = !viewMode && !isControlsBannerDismissed && spaceKey !== 'XFLOW' && !isOnboardingEditorDraftBannerVisible && !(0, $9wGTI.fg)('platform_editor_control_remove_banner'); // remove change boarding banner for all customers. Remove the EditorControlsBanner completely when cleaning up the flag.
    if (shouldShowControlsBanner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f70a72dbc1235d39$export$7baca885d79a7d1e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $17ecc52f8acaba5c$export$e465eaad07815d4e), {
        onDismiss: onDismiss,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        isLivePage: isLivePage,
        isEmbeddedConfluence: isEmbeddedConfluence,
        bannerType: bannerType
    }));
    if (spaceKey !== 'XFLOW' && !isLivePage && (0, $9wGTI.fg)('aifc_create_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
        contentType: "page"
    });
});



var $3FLes = parcelRequire("3FLes");





var $lrMxq = parcelRequire("lrMxq");


function $1e65a39b95334039$export$7d2a7d16db4db259({ editorApi: editorApi, hasAiButton: hasAiButton, hasAudioButton: hasAudioButton, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, isUnpublishedDraft: isUnpublishedDraft, disabled: disabled, isEditorEmpty: isEditorEmpty }) {
    const { aiIsStreaming: aiIsStreaming } = (0, $c907e804706c3ad7$export$34125ddc34657a7f)(editorApi);
    const getAdfDocument = (0, $42omo.useCallback)(()=>{
        return new Promise((resolve)=>{
            if (editorApi?.core?.actions?.requestDocument) editorApi.core.actions.requestDocument((doc)=>{
                resolve(doc);
            });
            else resolve(null);
        });
    }, [
        editorApi
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lrMxq.ObjectSidebarControl), {
        key: "object-sidebar-control",
        hasCommentsButton: true,
        hasDetailsButton: true,
        hasLoomButton: true,
        hasAiButton: hasAiButton,
        hasRemixButton: true,
        hasAudioButton: hasAudioButton,
        aiIsStreaming: aiIsStreaming,
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        contentTitle: contentTitle,
        isUnpublishedDraft: isUnpublishedDraft,
        disabled: disabled,
        isEditorEmpty: isEditorEmpty,
        getAdfDocument: getAdfDocument
    });
}






var $8Psje = parcelRequire("8Psje");


var $wtSEP = parcelRequire("wtSEP");




const $ea0f0e1bfeeed9fe$export$72f7c3354b160bdb = (Component)=>{
    return (props)=>{
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('aifc_create_enabled') && (0, $8Psje.isRovoSystemSpaceKey)(props.spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wtSEP.NotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
    };
};



















var $jARmo = parcelRequire("jARmo");





var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");

const $455b0e3615badc4d$export$257c6c9e28c0ad4b = (collabEditProvider)=>{
    const handleConnecting = ()=>{
        // tracking time between when provider is created in the FE and when channel initialization starts
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_PRE_CONNECTED);
        // tracking time between when provider's channel is initialized and when connected event is fired
        (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
    };
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        // @ts-ignore
        collabEditProvider.on('connecting', handleConnecting);
        return ()=>{
            // @ts-ignore
            collabEditProvider.off('connecting', handleConnecting);
        };
    }, [
        collabEditProvider
    ]);
};









var $dWCFT = parcelRequire("dWCFT");


var $3Vbz9 = parcelRequire("3Vbz9");


var $duCvb = parcelRequire("duCvb");


var $ge2sX = parcelRequire("ge2sX");


var $i9VoI = parcelRequire("i9VoI");




/**
 * @generated SignedSource<<6f0d9a2052a0aecb96c046f157f990dc>>
 * @relayHash 03e3dbfe626dfb1a261be6353a81c32c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50e03e82c9f8e6fb9d603fc0cfdc43bd1b639e1540416b979719945a94563a0d
const $f79e9585268baf8c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "schedulePublishDate"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentSchedulePublishQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentSchedulePublishQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "03e3dbfe626dfb1a261be6353a81c32c",
            "id": "50e03e82c9f8e6fb9d603fc0cfdc43bd1b639e1540416b979719945a94563a0d",
            "metadata": {},
            "name": "ContentSchedulePublishQuery",
            "operationKind": "query",
            "text": "query ContentSchedulePublishQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,schedulePublishDate}}}"
        }
    };
}();
$f79e9585268baf8c$var$node.hash = "f718f8310d58df9ba0bc961934043932";
var $f79e9585268baf8c$export$2e2bcd8739ae039 = $f79e9585268baf8c$var$node;


const $f9205d97e0969451$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    rescheduleUpdateWithSpaceName: {
        id: "editor-schedule-publish.success.reschedule.update.with.space.name",
        defaultMessage: "{pageTitle} has been rescheduled to update on {date} at {time} in the {spaceName} space"
    },
    rescheduleUpdate: {
        id: "editor-schedule-publish.success.reschedule.update",
        defaultMessage: "{pageTitle} has been rescheduled to update on {date} at {time}"
    },
    reschedulePublishWithSpaceName: {
        id: "editor-schedule-publish.success.reschedule.publish.with.space.name",
        defaultMessage: "{pageTitle} has been rescheduled to publish on {date} at {time} in the {spaceName} space"
    },
    reschedulePublish: {
        id: "editor-schedule-publish.success.reschedule.publish",
        defaultMessage: "{pageTitle} has been rescheduled to publish on {date} at {time}"
    },
    scheduleUpdateWithSpaceName: {
        id: "editor-schedule-publish.success.schedule.update.message.with.space.name",
        defaultMessage: "{pageTitle} will be updated on {date} at {time} in the {spaceName} space"
    },
    scheduleUpdate: {
        id: "editor-schedule-publish.success.schedule.update.message",
        defaultMessage: "{pageTitle} will be updated on {date} at {time}"
    },
    schedulePublishWithSpaceName: {
        id: "editor-schedule-publish.success.schedule.publish.message.with.space.name",
        defaultMessage: "{pageTitle} will be published on {date} at {time} in the {spaceName} space"
    },
    schedulePublish: {
        id: "editor-schedule-publish.success.schedule.publish.message",
        defaultMessage: "{pageTitle} will be published on {date} at {time}"
    },
    scheduleUpdateTitle: {
        id: "editor-schedule-publish.success.schedule.update.title",
        defaultMessage: "Update scheduled"
    },
    schedulePublishTitle: {
        id: "editor-schedule-publish.success.schedule.publish.title",
        defaultMessage: "Publish scheduled"
    }
});
const $f9205d97e0969451$export$206997a838ea4b9d = ({ contentId: contentId, contentType: contentType, title: title, isUnpublishedDraft: isUnpublishedDraft, flags: flags, isSchedulePublishEnabled: // TODO MODES-3970 isSchedulePublishEnabled should be removed when when its consumer(FullPageEditorComponent) doesn't have to support the use case of schedule publish being disabled.
// This is set to true when on a live page. Live pages currently use FullPageEditorComponent and do not support scheduling publishes.
isSchedulePublishEnabled = true })=>{
    const [currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate] = (0, $42omo.useState)(null);
    const [spaceName] = (0, $42omo.useState)();
    const intl = (0, $aXWIB.useIntl)();
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [getContent, { data: contentData }] = (0, $lvOsp.useLazyQueryInterop)((0, $f79e9585268baf8c$export$2e2bcd8739ae039), {
        fetchPolicy: 'network-only'
    });
    /**
   * Store refs to state values used in handleSchedulePublish, because putting them
   * directly into the callback causes the memoized function to be recreated several
   * times rapidly, resulting in issues with PubSub subscribe/unsubscribing properly
   */ const flagDataRef = (0, $42omo.useRef)({
        spaceName: spaceName,
        title: title,
        isUnpublishedDraft: isUnpublishedDraft,
        currentlyScheduledPublishDate: currentlyScheduledPublishDate
    });
    /**
   * Returns the object received by intl.formatMessage for the schedule publish success flag's content
   */ const getFlagMessage = (0, $42omo.useCallback)(()=>{
        const updating = !flagDataRef.current.isUnpublishedDraft;
        if (flagDataRef.current.currentlyScheduledPublishDate) {
            // Rescheduling
            if (updating) {
                if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.rescheduleUpdateWithSpaceName;
                return $f9205d97e0969451$export$a7357cdd1f0b0168.rescheduleUpdate;
            } else {
                // Publishing
                if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.reschedulePublishWithSpaceName;
                return $f9205d97e0969451$export$a7357cdd1f0b0168.reschedulePublish;
            }
        } else // Scheduling (for first time)
        if (updating) {
            if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdateWithSpaceName;
            return $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdate;
        } else {
            // Publishing
            if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublishWithSpaceName;
            return $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublish;
        }
    }, []);
    const handleSchedulePublish = (0, $42omo.useCallback)((_delta, response)=>{
        const { eventType: eventType, publishTime: publishTime } = response?.schedulePublished || {};
        const { accountId: accountId } = response;
        if (!isSchedulePublishEnabled) return;
        switch(eventType){
            case 'scheduled':
                const scheduledPublishDate = new Date(publishTime);
                const monthDayRegex = /[^,]*$/g; // selects everything after comma ","
                const updating = !flagDataRef.current.isUnpublishedDraft;
                flags.showFlag({
                    type: 'success-circle',
                    close: 'auto',
                    title: intl.formatMessage(updating ? $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdateTitle : $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublishTitle),
                    description: intl.formatMessage(getFlagMessage(), {
                        pageTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, flagDataRef.current.title),
                        date: (0, $dWCFT.default)(scheduledPublishDate, 'PP').replace(monthDayRegex, ''),
                        time: (0, $3Vbz9.format)(scheduledPublishDate, 'h:mm aaaa z'),
                        spaceName: flagDataRef.current.spaceName
                    })
                }).finally(()=>{
                    setCurrentlyScheduledPublishDate(scheduledPublishDate);
                });
                break;
            case 'unscheduled':
                setCurrentlyScheduledPublishDate(null);
                break;
            case 'published':
                (0, $ge2sX.getSessionData)().then(({ userId: userId })=>{
                    if (accountId === userId) (0, $duCvb.showPublishSuccessFlags)({
                        isFirstTimePublish: isUnpublishedDraft,
                        shouldTimeout: false,
                        spaceName: flagDataRef.current.spaceName,
                        flags: flags,
                        title: flagDataRef.current.title,
                        intl: intl
                    });
                });
        }
    }, [
        getFlagMessage,
        isUnpublishedDraft,
        intl,
        flags,
        isSchedulePublishEnabled
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'useSchedulePublishFlagsWatcher',
        delta: 'schedulePublished',
        onDataReceived: handleSchedulePublish
    });
    (0, $42omo.useEffect)(()=>{
        if (!isSchedulePublishEnabled) return;
        const params = {
            contentId: contentId,
            status: [
                isUnpublishedDraft ? 'draft' : 'current'
            ]
        };
        getContent({
            variables: params
        });
    }, [
        getContent,
        contentId,
        isUnpublishedDraft,
        isSchedulePublishEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isSchedulePublishEnabled) return;
        const contentSchedulePublishDate = contentData?.content?.nodes?.[0]?.schedulePublishDate;
        const date = contentSchedulePublishDate ? new Date(contentSchedulePublishDate) : null;
        setCurrentlyScheduledPublishDate(date);
    // The spaceName used to be set here, but it was sometimes invalid.
    // Please re-add calling `setSpaceName` here after GENI-2960 is completed.
    }, [
        contentData,
        isSchedulePublishEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        flagDataRef.current = {
            spaceName: spaceName,
            title: title,
            isUnpublishedDraft: isUnpublishedDraft,
            currentlyScheduledPublishDate: currentlyScheduledPublishDate
        };
    }, [
        spaceName,
        title,
        isUnpublishedDraft,
        currentlyScheduledPublishDate
    ]);
};



var $9ovft = parcelRequire("9ovft");


var $essql = parcelRequire("essql");


var $cHANb = parcelRequire("cHANb");

/**
 * @generated SignedSource<<42e95c226aaf91f7bf2451592ec91c0f>>
 * @relayHash a9cd468cc7d0e510656c933a0f5cfc19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9fa48921cef6083855f0594c590f0a4623a1bf99ebe36fdf36903e4ee8b64caf
const $ccdedf646f6a728d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sendContentAgeAnalyticsGetContentAgeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sendContentAgeAnalyticsGetContentAgeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a9cd468cc7d0e510656c933a0f5cfc19",
            "id": "9fa48921cef6083855f0594c590f0a4623a1bf99ebe36fdf36903e4ee8b64caf",
            "metadata": {},
            "name": "sendContentAgeAnalyticsGetContentAgeQuery",
            "operationKind": "query",
            "text": "query sendContentAgeAnalyticsGetContentAgeQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,history{createdDate},version{when}}}}"
        }
    };
}();
$ccdedf646f6a728d$var$node.hash = "b714b9334919637eb6a47f1f5260ef2d";
var $ccdedf646f6a728d$export$2e2bcd8739ae039 = $ccdedf646f6a728d$var$node;














const $6fc6623dec610eba$export$ea50f0fba62a9f14 = async (createAnalyticsEvent, { contentId: contentId, collabService: collabService })=>{
    if (!createAnalyticsEvent || !contentId) return;
    try {
        const result = await (0, $c0rhi.queryInterop)({
            query: (0, $ccdedf646f6a728d$export$2e2bcd8739ae039),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        let utcCreatedDate = result.data?.content?.nodes?.[0]?.history?.createdDate;
        let isUnpublishedDraft = false;
        if (!utcCreatedDate) {
            if (!!result.data?.content?.nodes?.[0]?.version?.when) {
                // unpublished draft, so use draft creation date
                utcCreatedDate = result.data?.content?.nodes?.[0]?.version?.when;
                isUnpublishedDraft = true;
            } else return;
        }
        const { shard: shard, edition: edition } = await (0, $ge2sX.getSessionData)();
        // get created and current date in UTC ms time
        const createdDate = new Date(utcCreatedDate).getTime();
        const currentDate = Date.now();
        // number of days between this (latest) edit and page creation
        const daysSinceCreated = Math.floor((currentDate - createdDate) / 86400000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                actionSubject: 'editor',
                action: 'trackPageLifetime',
                source: 'editorComponent',
                attributes: {
                    contentId: contentId,
                    daysSinceCreated: daysSinceCreated,
                    collabService: collabService,
                    isUnpublishedDraft: isUnpublishedDraft,
                    shard: shard,
                    edition: edition
                }
            }
        }).fire();
    } catch  {
        return;
    }
};
const $6fc6623dec610eba$export$f46ffb959d708168 = ({ contentId: contentId, collabService: collabService })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        $6fc6623dec610eba$export$ea50f0fba62a9f14(createAnalyticsEvent, {
            contentId: contentId,
            collabService: collabService
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
};














const $30f609f1a737209e$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        // Only re-run if value is updated
        ref.current = value;
    }, [
        value
    ]);
    // Return previous value (happens before the update in useEffect)
    return ref.current;
};


const $b332f5d2fa8005d6$var$getDisabledReason = ({ shouldRenderPreview: shouldRenderPreview, isTitleFocused: isTitleFocused, collabEditError: collabEditError, collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, saveDraftError: saveDraftError })=>{
    if (shouldRenderPreview) return 'should-render-preview';
    else if (isTitleFocused) return 'title-focused';
    else if (collabLimitReached) return 'collab-limit-reached';
    else if (collabEditError) return collabEditError.code;
    else if (heartbeatError) return heartbeatError.reason;
    else if (saveDraftError) return `Draft sync returned status ${saveDraftError?.statusCode}`;
    return '';
};
const $b332f5d2fa8005d6$export$d2b5179b7b1bfa0e = ({ contentId: contentId, disabled: disabled, shouldRenderPreview: shouldRenderPreview, isTitleFocused: isTitleFocused, collabEditError: collabEditError, collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, saveDraftError: saveDraftError })=>{
    // Navigator.onLine: https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
    // Document.visibilityState: https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
    const onLine = navigator.onLine;
    const visibilityState = document.visibilityState;
    const disabledReason = $b332f5d2fa8005d6$var$getDisabledReason({
        shouldRenderPreview: shouldRenderPreview,
        isTitleFocused: isTitleFocused,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError,
        saveDraftError: saveDraftError
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const prevDisabled = (0, $30f609f1a737209e$export$5cae361ad82dce8b)(disabled);
    // Ref to keep track of enabled/disabled transition start/end and duration
    const enabledTransitionStart = (0, $42omo.useRef)();
    const disabledTransitionStart = (0, $42omo.useRef)();
    const disabledTransitionId = (0, $42omo.useRef)();
    const sinceDisabled = ()=>{
        return !disabled && typeof disabledTransitionStart.current === 'number' ? performance.now() - disabledTransitionStart.current : undefined;
    };
    const sinceEnabled = ()=>{
        return disabled && typeof enabledTransitionStart.current === 'number' ? performance.now() - enabledTransitionStart.current : undefined;
    };
    const disabledChanged = typeof disabled === 'boolean' && typeof prevDisabled === 'boolean' && disabled !== prevDisabled;
    (0, $42omo.useEffect)(()=>{
        if (disabledChanged) {
            // fire analytics event
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'editor',
                    action: disabled ? 'disabled' : 'enabled',
                    source: 'editorComponent',
                    attributes: {
                        contentId: contentId,
                        transitionId: disabledTransitionId.current,
                        visibilityState: visibilityState,
                        onLine: onLine,
                        disabledReason: disabledReason,
                        disabledDuration: sinceDisabled(),
                        enabledDuration: sinceEnabled()
                    }
                }
            }).fire();
            // transition from enabled -> disabled
            if (!prevDisabled && disabled) {
                disabledTransitionStart.current = performance.now();
                enabledTransitionStart.current = undefined;
            // transition from disabled -> enabled
            } else {
                disabledTransitionId.current = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                enabledTransitionStart.current = performance.now();
                disabledTransitionStart.current = undefined;
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        disabledChanged,
        disabled
    ]);
};






var $QU6QS = parcelRequire("QU6QS");





var $cQJcI = parcelRequire("cQJcI");

var $bBdDv = parcelRequire("bBdDv");


var $1oCLl = parcelRequire("1oCLl");





var $202oG = parcelRequire("202oG");

const $6424f127b1220946$export$dd44f1f1b7b8d6af = (editorAPI, blockId)=>{
    if (!editorAPI?.core?.actions?.execute) return;
    // Catch the following potential errors when trying to set selection on the synced block:
    // tr.doc.resolve(...) - Can throw throw a RangeError
    // tr.setSelection(...) - Can throw
    try {
        editorAPI.core.actions.execute(({ tr: tr })=>{
            const doc = tr.doc;
            // Find first top-level node matching the block ID and of type 'bodiedSyncBlock'.
            let syncedBlockPos = -1;
            doc.descendants((node, pos, parent)=>{
                if (syncedBlockPos < 0 && // already found the block or not a top-level node, skip further checks
                parent?.type.name === 'doc' && node.attrs?.localId === blockId && node.type?.name === 'bodiedSyncBlock') syncedBlockPos = pos;
                // Don't descend into this node's children
                // as synced blocks cannot be nested and we only want the first match at the top level.
                return false;
            });
            if (syncedBlockPos >= 0) {
                const safePos = Math.max(0, Math.min(syncedBlockPos + 1, tr.doc.content.size));
                // Set selection to the first position inside the synced block node.
                const $pos = tr.doc.resolve(safePos);
                editorAPI.core?.actions?.focus();
                tr.setSelection((0, $ks2lK.Selection).near($pos));
                return tr;
            }
            return null;
        });
    } catch  {
    // Silently fail if selection cannot be set
    }
};
const $6424f127b1220946$export$3873199fd2fe1b43 = (hasProseMirrorRendered, blockLinkHashPrefix = (0, $cQJcI.DEFAULT_BLOCK_LINK_HASH_PREFIX), editorAPI)=>{
    const { hash: hash } = (0, $QU6QS.useLocation)();
    (0, $42omo.useEffect)(()=>{
        if (!hasProseMirrorRendered || !hash) return;
        // Store cleanup function to cancel pending operations on unmount or hash change.
        let cancelExpandAndScroll = null;
        let selectionTimeoutId = null;
        // Handle block links when block menu feature is enabled.
        if ((0, $1oCLl.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) {
            const blockId = (0, $cQJcI.extractBlockIdFromLinkHash)(hash, blockLinkHashPrefix);
            if (blockId) {
                const element = (0, $bBdDv.getLocalIdSelector)(blockId, document.body);
                if (element) {
                    // Handle block links with expand support.
                    // Capture cleanup function to cancel pending timeouts on unmount/hash change.
                    if ((0, $9wGTI.fg)('platform_editor_block_menu_v2_patch_4')) cancelExpandAndScroll = (0, $bBdDv.expandAllParentsThenScroll)(element, 0, (el)=>{
                        el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    });
                    else cancelExpandAndScroll = (0, $bBdDv.expandAllParentsThenScroll)(element);
                    // Set selection on synced block if editor API is available
                    // Small delay to ensure scroll/expand completes before setting selection
                    if ((0, $1oCLl.expValEquals)('platform_synced_block', 'isEnabled', true)) selectionTimeoutId = setTimeout(()=>{
                        $6424f127b1220946$export$dd44f1f1b7b8d6af(editorAPI, blockId);
                    }, 100); // Delay to ensure scroll completes
                }
                // Return cleanup function to cancel pending operations.
                return ()=>{
                    if (cancelExpandAndScroll) cancelExpandAndScroll();
                    if (selectionTimeoutId) clearTimeout(selectionTimeoutId);
                };
            }
        }
        // Handle regular anchor links and heading links.
        const id = hash.slice(1);
        const anchorElement = document.getElementById(id);
        // Indicates anchor.
        if (anchorElement) anchorElement.scrollIntoView();
        const headingIdToElement = (0, $202oG.getHeadingIdsToElements)();
        const scrollContainer = document.getElementsByClassName('fabric-editor-popup-scroll-parent')?.[0];
        // The top of the heading element.
        const headingTop = headingIdToElement.get(id)?.getBoundingClientRect()?.top;
        // The top of the scroll container.
        const scrollContainerTop = scrollContainer?.getBoundingClientRect()?.top;
        // The current scroll position.
        const offset = scrollContainer?.scrollTop;
        if (headingTop === undefined || scrollContainerTop === undefined || offset === undefined) return;
        // Subtract the scroll container position from the heading position to get the scroll distance
        // and add the offset to account for current scroll position.
        const scrollToY = headingTop - scrollContainerTop + offset;
        scrollContainer?.scrollTo({
            left: 0,
            top: scrollToY,
            behavior: 'smooth'
        });
    }, [
        hash,
        blockLinkHashPrefix,
        hasProseMirrorRendered,
        editorAPI
    ]);
};











function $6941dd20a463270a$export$7d308a2b14d43346({ isActive: isActive, isRovoLLMEnabled: isRovoLLMEnabled, onSpaceKeyPressed: onSpaceKeyPressed, isLivePage: isLivePage }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSpaceKeyPressedRef = (0, $42omo.useRef)(onSpaceKeyPressed);
    onSpaceKeyPressedRef.current = onSpaceKeyPressed;
    (0, $42omo.useEffect)(()=>{
        if (!isActive || !isRovoLLMEnabled || !(0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1')) return;
        const handleSpaceKeyCapture = (e)=>{
            // Only intercept the bare space key (no modifiers)
            if (e.key !== ' ' || e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
            // Only intercept when the target is within the ProseMirror editor
            const target = e.target;
            if (!target?.closest?.('.ProseMirror')) return;
            // Prevent ProseMirror from handling the space key (which would open inline Rovo)
            e.preventDefault();
            e.stopPropagation();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'BlankObjectExperienceButtons',
                    action: 'used',
                    actionSubject: 'shortcut',
                    actionSubjectId: 'createWithRovoBlankObject',
                    attributes: {
                        variant: 'variant1',
                        contentType: isLivePage ? 'liveDoc' : 'page',
                        buttonType: 'cwr'
                    }
                }
            }).fire();
            // Show the CWR experience
            onSpaceKeyPressedRef.current();
        };
        // Use capture phase to intercept before ProseMirror's keymap handler
        document.addEventListener('keydown', handleSpaceKeyCapture, true);
        return ()=>{
            document.removeEventListener('keydown', handleSpaceKeyCapture, true);
        };
    }, [
        isActive,
        isRovoLLMEnabled,
        createAnalyticsEvent,
        isLivePage
    ]);
}



var $iwNka = parcelRequire("iwNka");


var $7oCdN = parcelRequire("7oCdN");





var $4L9ve = parcelRequire("4L9ve");














var $cZa7r = parcelRequire("cZa7r");





var $fFa3V = parcelRequire("fFa3V");




const $7aceeeaf0148bdde$export$166cbf4b2438db83 = (isLivePage)=>{
    (0, $42omo.useEffect)(()=>{
        if (isLivePage || (0, $6mKj3.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) {
            const mainContent = document.getElementById('AkMainContent');
            // If the main content area is not found, or it already has a tabIndex set,
            // don't mess with tabIndex at all.
            if (!mainContent || mainContent.hasAttribute('tabIndex')) return;
            // Two-stage hydration previously masked a React execution order bug by causing this to be rendered and fired
            //  before the title component was mounted. With two-stage hydration removed, we now need to ensure that
            //  we correctly handle focus. React will fire the title component's useEffect before this one as it is on
            //  a child component of the editor. Therefore, we check here if the title is focused already, and if so,
            //  we do not steal focus away.
            if (document.activeElement?.getAttribute?.('name') === 'livepages-title' && (0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return;
            mainContent.setAttribute('tabIndex', '-1');
            const unbind = (0, $fFa3V.bind)(mainContent, {
                type: 'blur',
                listener: ()=>{
                    mainContent.removeAttribute('tabIndex');
                    unbind();
                }
            });
            mainContent.focus();
            return unbind;
        }
    }, [
        isLivePage
    ]);
};


/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");








var $9FoVw = parcelRequire("9FoVw");


var $fHAwL = parcelRequire("fHAwL");














var $lb2Lp = parcelRequire("lb2Lp");

/**
 * @generated SignedSource<<e9a86803f0639bc2dab372633167789e>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $69af2cdb1717ff4e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});


function $39cea118bb4c75f1$export$1a19d181d558cc48({ commentId: commentId, contentId: contentId, annotationState: annotationState, handleGqlError: handleGqlError }) {
    // New comments data manager hook - only used when experiment is enabled
    const newCommentsDataResult = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId,
        options: {
            skip: !commentId || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
            onError: handleGqlError
        }
    });
    // Legacy query - only used when experiment is disabled
    const { data: legacyData } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useFocusedCommentInlineCommentMarkerRefQuery($commentId:ID!$pageId:ID!$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId pageId:$pageId contentStatus:$contentStatus){nodes{id location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved}}}parentId}}}`, {
        variables: {
            commentId: commentId || '',
            pageId: contentId,
            contentStatus: [
                (0, $69af2cdb1717ff4e$export$b634e5de755b7d35).DRAFT,
                (0, $69af2cdb1717ff4e$export$b634e5de755b7d35).CURRENT
            ]
        },
        skip: !commentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onError: handleGqlError,
        fetchPolicy: 'cache-first'
    });
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const hasOpenedFocusedComment = (0, $42omo.useRef)(false);
    const { isUpdatingUnreadComments: isUpdatingUnreadComments } = (0, $fHAwL.useUnreadCommentsState)();
    // Reset hasOpenedFocusedComment when commentId changes
    (0, $42omo.useEffect)(()=>{
        if (hasOpenedFocusedComment.current) hasOpenedFocusedComment.current = false;
    }, [
        commentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasOpenedFocusedComment.current) return;
        // Pull from comments_data_manager when experiment is enabled
        const focusedComment = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? newCommentsDataResult.comment ?? null : legacyData?.comments?.nodes?.[0] ?? null;
        if (commentId && focusedComment && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || !isUpdatingUnreadComments)) {
            const markerRef = focusedComment.location.inlineMarkerRef ?? '';
            const isResolved = Boolean(focusedComment.location.inlineResolveProperties?.resolved);
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (markerRef) {
                    setCurrentlySelectedThreadKey(markerRef);
                    setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                    hasOpenedFocusedComment.current = true;
                }
            } else if (// dangling comment
            markerRef && annotationState?.annotationsLoaded && !(markerRef in annotationState.annotations) && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                setCurrentlySelectedThreadKey(markerRef);
                setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                hasOpenedFocusedComment.current = true; // to prevent focused comment from being opened again. We may need a better way to handle this
            } else {
                const commentElement = document.getElementById(markerRef);
                if (commentElement && markerRef !== '') {
                    // Use unified navigation for deep linking
                    const success = (0, $9FoVw.handleDeepLinkNavigation)({
                        scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                        context: (0, $9FoVw.NavigationContext).EDITOR,
                        block: 'center',
                        inline: 'nearest',
                        markElement: commentElement,
                        commentId: commentId
                    });
                    if (success) hasOpenedFocusedComment.current = true;
                }
            }
        }
        return ()=>{
            hasOpenedFocusedComment.current = false;
        };
    }, [
        commentId,
        newCommentsDataResult.comment,
        annotationState?.annotations,
        annotationState?.annotationsLoaded,
        isUpdatingUnreadComments,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        setCommentContainerToFocus,
        legacyData
    ]);
}





const $e5418cfc53a98775$export$c0a34c12e787105e = ({ collabEditInternetLost: collabEditInternetLost, internetDisconnected: internetDisconnected, editorFullPagePresetAPI: editorFullPagePresetAPI })=>{
    (0, $42omo.useEffect)(()=>{
        if (internetDisconnected) // Internet is actually disconnected (network issue)
        editorFullPagePresetAPI?.core.actions.execute(editorFullPagePresetAPI?.connectivity?.commands.setMode('internet-offline'));
        else if (collabEditInternetLost) // Collaboration connection lost but internet might be available
        editorFullPagePresetAPI?.core.actions.execute(editorFullPagePresetAPI?.connectivity?.commands.setMode('collab-offline'));
        else // Both are false, we're online
        editorFullPagePresetAPI?.core.actions.execute(editorFullPagePresetAPI?.connectivity?.commands.setMode('online'));
    }, [
        collabEditInternetLost,
        internetDisconnected,
        editorFullPagePresetAPI
    ]);
};












var $ikPi2 = parcelRequire("ikPi2");




const $57b1365ec21ea4d6$export$12026d53c57123e6 = (editorPresetAPI)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    // FIXME: https://product-fabric.atlassian.net/browse/ED-25722
    const [loomInsertUrlState, loomInsertUrlActions] = (0, $ikPi2.useLoomInsertUrlState)();
    (0, $42omo.useEffect)(()=>{
        try {
            /**
			 * Insert Loom video at the top of the editor.
			 * Ensure the collab service plugin and editorPresetAPI have been initialized
			 * and the Loom video is present, to prevent premature Loom video insertion.
			 * After insertion, delete the Loom video to ensure no more insertions occur.
			 */ if (collabEditInitialized && editorPresetAPI && loomInsertUrlState.fullPageEditorLoomUrl) {
                editorPresetAPI?.loom?.actions.insertLoom({
                    sharedUrl: loomInsertUrlState.fullPageEditorLoomUrl.sharedUrl,
                    title: loomInsertUrlState.fullPageEditorLoomUrl.title || ''
                }, 'start');
                loomInsertUrlActions.updateFullPageEditorLoomUrl(undefined);
                experienceTracker.succeed({
                    name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
                    attributes: {
                        inserted: true
                    }
                });
            }
        } catch (error) {
            loomInsertUrlActions.updateFullPageEditorLoomUrl(undefined);
            experienceTracker.fail({
                name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
                error: error
            });
        }
    }, [
        collabEditInitialized,
        editorPresetAPI,
        experienceTracker,
        loomInsertUrlActions,
        loomInsertUrlState.fullPageEditorLoomUrl
    ]);
};


const $310b15d05f913bec$export$c2c72aeadce38f04 = ({ contentId: contentId, contentType: contentType, isLivePage: isLivePage, isUnpublishedDraft: isUnpublishedDraft, title: title, draftTitle: draftTitle, isAIEnabledForContent: isAIEnabledForContent, handleTitleChange: handleTitleChange, collabEditInternetLost: collabEditInternetLost, internetDisconnected: internetDisconnected, extractedCollabEditProvider: extractedCollabEditProvider, fullPageEditorPresetAPI: fullPageEditorPresetAPI, isDocumentActive: isDocumentActive, focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, handleUseFocusedCommentGQLError: handleUseFocusedCommentGQLError, annotationStateRef: annotationStateRef, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, updateUnresolvedInlineCommentFn: updateUnresolvedInlineCommentFn, triggerAnalyticsEvent: triggerAnalyticsEvent, proseMirrorRenderedData: proseMirrorRenderedData, showBlankPageQuickActions: showBlankPageQuickActions, hasSubmittedCwrPrompt: hasSubmittedCwrPrompt, shouldShowCreateWithRovoExperience: shouldShowCreateWithRovoExperience, isRovoLLMEnabled: isRovoLLMEnabled, onSpaceKeyPressed: onSpaceKeyPressed, flags: flags, intl: intl, disabled: disabled, isTitleFocused: isTitleFocused, shouldRenderPreview: shouldRenderPreview, collabEditError: collabEditError, collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, removeCommentQueryParams: removeCommentQueryParams, setEditorAnnotations: setEditorAnnotations, getSortedMarkerRefs: getSortedMarkerRefs, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, editorAnnotationsRef: editorAnnotationsRef })=>{
    // Get locally-scoped actions from their respective contexts/stores
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { clearCommentsData: clearCommentsData } = (0, $8i27m.useCommentsDataActions)();
    const { clearProcessedData: clearProcessedData } = (0, $4L9ve.useProcessedCommentsDataActions)();
    const { clearMentionsFlags: clearMentionsFlags } = (0, $hdxAi.useMentionsNotificationsActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    // Side effect: Setup native embed client
    (0, $jARmo.usePageNativeEmbedClient)();
    // Side effect: Space key shortcut override for CWR
    (0, $6941dd20a463270a$export$7d308a2b14d43346)({
        isActive: showBlankPageQuickActions && !hasSubmittedCwrPrompt && !shouldShowCreateWithRovoExperience,
        isRovoLLMEnabled: isRovoLLMEnabled,
        onSpaceKeyPressed: onSpaceKeyPressed,
        isLivePage: isLivePage
    });
    // Side effect: Expose Google Meet screen share
    (0, $iwNka.useExposeGoogleMeetScreenShare)();
    // Side effect: Scroll on URL change
    (0, $6424f127b1220946$export$3873199fd2fe1b43)(proseMirrorRenderedData !== null, undefined, fullPageEditorPresetAPI);
    // Side effect: Print cover injector
    (0, $7oCdN.usePrintCoverInjector)((0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true), intl);
    // Side effect: Focused comment handling
    (0, $39cea118bb4c75f1$export$1a19d181d558cc48)({
        commentId: focusedCommentId || replyToCommentId,
        contentId: contentId,
        handleGqlError: handleUseFocusedCommentGQLError,
        annotationState: annotationStateRef.current
    });
    // Side effect: Inline comments PubSub
    (0, $9ovft.useEditorInlineCommentsPubSub)({
        contentId: contentId,
        contentType: contentType,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn,
        isDocumentActive: isDocumentActive,
        storedCommentData: storedCommentData,
        setStoredCommentData: setStoredCommentData,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    });
    // Side effect: Unread comments setup
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'edit'
        }
    });
    // Side effect: Collab edit connectivity sync
    (0, $e5418cfc53a98775$export$c0a34c12e787105e)({
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        editorFullPagePresetAPI: fullPageEditorPresetAPI
    });
    // Side effect: Native collab connecting state
    (0, $455b0e3615badc4d$export$257c6c9e28c0ad4b)(extractedCollabEditProvider);
    // Side effect: Full page auto focus
    (0, $7aceeeaf0148bdde$export$166cbf4b2438db83)(isLivePage);
    // Side effect: AI replacing title
    (0, $cHANb.useEditorAIReplacingTitle)({
        enabled: isAIEnabledForContent,
        title: title || draftTitle || '',
        handleNewTitle: handleTitleChange,
        canFireUnifiedAIAnalyticsEvent: true
    });
    // Side effect: Send content age analytics
    (0, $6fc6623dec610eba$export$f46ffb959d708168)({
        contentId: contentId,
        collabService: 'ncs'
    });
    // Side effect: Disabled analytics
    (0, $b332f5d2fa8005d6$export$d2b5179b7b1bfa0e)({
        contentId: contentId,
        disabled: isTitleFocused || disabled,
        shouldRenderPreview: shouldRenderPreview,
        isTitleFocused: isTitleFocused,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError
    });
    // Side effect: Schedule publish flags watcher
    (0, $f9205d97e0969451$export$206997a838ea4b9d)({
        contentId: contentId,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft,
        title: title ?? draftTitle,
        flags: flags,
        isSchedulePublishEnabled: !isLivePage
    });
    // Side effect: Full page editor loom insertion
    (0, $57b1365ec21ea4d6$export$12026d53c57123e6)(fullPageEditorPresetAPI);
    // Side effect: Plugin state effect for annotations
    (0, $6qdjm.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'annotation'
    ], ({ annotationState: annotationState })=>{
        const annotations = annotationState?.annotations;
        const { selectedAnnotations: selectedAnnotations, mouseData: mouseData } = annotationState || {};
        annotationStateRef.current = annotationState;
        const handleCommentQueryParams = ()=>{
            if (selectedAnnotations && selectedAnnotations.length > 0 && mouseData?.isSelecting && (focusedCommentId || replyToCommentId)) removeCommentQueryParams();
        };
        const setAnnotations = ()=>{
            const editorAnnotationsToSet = annotations ? Object.keys(annotations) : [];
            setEditorAnnotations(getSortedMarkerRefs(editorAnnotationsToSet, 'edit'), contentId);
            editorAnnotationsRef.current = editorAnnotationsToSet;
            const activeEditorAnnotationsToSet = annotations ? Object.keys(annotations).filter((key)=>annotations[key] === false) : [];
            setOrderedActiveAnnotationIdList(getSortedMarkerRefs(activeEditorAnnotationsToSet, 'edit'));
        };
        handleCommentQueryParams();
        setAnnotations();
    });
    // Side effect: Hide object sidebar on content change
    (0, $42omo.useEffect)(()=>{
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    // Side effect: Comments cleanup on unmount or content change when side effects are isolated
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            resetInitialDataLoadedMap();
            clearCommentsData();
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) clearProcessedData();
            clearMentionsFlags();
            setActiveHighlight(null);
        };
    }, [
        contentId,
        resetInitialDataLoadedMap,
        clearCommentsData,
        clearProcessedData,
        clearMentionsFlags,
        setActiveHighlight
    ]);
    return null;
};


const $a00e1ed200f6db86$export$d1f7cc0755451204 = (props)=>{
    if (!(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $310b15d05f913bec$export$c2c72aeadce38f04), props);
};


/**
 * Conditional hook wrappers for side effects using conditionalHooksFactory.
 *
 * When the 'platform_editor_isolate_side_effects_experiment' feature flag is enabled:
 * - These hooks return no-ops (empty functions/undefined)
 * - The side effects are handled by FullPageEditorSideEffects component instead
 *
 * When the feature flag is disabled:
 * - These hooks execute normally (original behavior)
 * - All side effects remain in FullPageEditorComponent
 */ 






















































const $cf1996529f024723$export$ee581ede78ce7214 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), ()=>{
// Flag enabled: no-op
}, ()=>{
    // Flag disabled: run original hook
    (0, $jARmo.usePageNativeEmbedClient)();
});
const $cf1996529f024723$export$7d308a2b14d43346 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    (0, $6941dd20a463270a$export$7d308a2b14d43346)(props);
});
const $cf1996529f024723$export$1a20dd7f74852e6b = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), ()=>{
// Flag enabled: no-op
}, ()=>{
    // Flag disabled: run original hook
    (0, $iwNka.useExposeGoogleMeetScreenShare)();
});
const $cf1996529f024723$export$3873199fd2fe1b43 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (..._args)=>{
// Flag enabled: no-op
}, (...args)=>{
    // Flag disabled: run original hook
    (0, $6424f127b1220946$export$3873199fd2fe1b43)(...args);
});
const $cf1996529f024723$export$4b3266eb0ec6c746 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (..._args)=>{
// Flag enabled: no-op
}, (...args)=>{
    // Flag disabled: run original hook
    (0, $7oCdN.usePrintCoverInjector)(...args);
});
const $cf1996529f024723$export$1a19d181d558cc48 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    (0, $39cea118bb4c75f1$export$1a19d181d558cc48)(props);
});
const $cf1996529f024723$export$7d464c122ca911c0 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    return (0, $9ovft.useEditorInlineCommentsPubSub)(props);
});
const $cf1996529f024723$export$ede9be424e8ef89a = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), ()=>{
    // Flag enabled: no-op — return empty shape matching useAnnotations return type
    return {
        storedCommentData: undefined
    };
}, ()=>{
    // Flag disabled: run original hook
    return (0, $cZa7r.useAnnotations)();
});
const $cf1996529f024723$export$3be336e5c3e78567 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), ()=>{
    // Flag enabled: no-op — return empty shape matching useAnnotationsDispatch return type
    return {
        setStoredCommentData: undefined
    };
}, ()=>{
    // Flag disabled: run original hook
    return (0, $cZa7r.useAnnotationsDispatch)();
});
const $cf1996529f024723$export$3c5a4187b7dbe412 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    (0, $essql.useUnreadCommentsSetup)(props);
});
const $cf1996529f024723$export$257c6c9e28c0ad4b = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_provider)=>{
// Flag enabled: no-op
}, (provider)=>{
    // Flag disabled: run original hook
    (0, $455b0e3615badc4d$export$257c6c9e28c0ad4b)(provider);
});
const $cf1996529f024723$export$166cbf4b2438db83 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_isLivePage)=>{
// Flag enabled: no-op
}, (isLivePage)=>{
    // Flag disabled: run original hook
    (0, $7aceeeaf0148bdde$export$166cbf4b2438db83)(isLivePage);
});
const $cf1996529f024723$export$ff041132f32feaf3 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    (0, $cHANb.useEditorAIReplacingTitle)(props);
});
const $cf1996529f024723$export$f46ffb959d708168 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    (0, $6fc6623dec610eba$export$f46ffb959d708168)(props);
});
const $cf1996529f024723$export$d2b5179b7b1bfa0e = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    (0, $b332f5d2fa8005d6$export$d2b5179b7b1bfa0e)(props);
});
const $cf1996529f024723$export$206997a838ea4b9d = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    (0, $f9205d97e0969451$export$206997a838ea4b9d)(props);
});
const $cf1996529f024723$export$12026d53c57123e6 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_api)=>{
// Flag enabled: no-op
}, (api)=>{
    // Flag disabled: run original hook
    (0, $57b1365ec21ea4d6$export$12026d53c57123e6)(api);
});
const $cf1996529f024723$export$c0a34c12e787105e = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_props)=>{
// Flag enabled: no-op
}, (props)=>{
    // Flag disabled: run original hook
    (0, $e5418cfc53a98775$export$c0a34c12e787105e)(props);
});
const $cf1996529f024723$export$9178b120e06dfd53 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_api, _keys, _callback)=>{
// Flag enabled: no-op
}, (api, keys, callback)=>{
    // Flag disabled: run original hook
    (0, $6qdjm.usePluginStateEffect)(api, keys, callback);
});
const $cf1996529f024723$export$3bcfd3dcf4c2b277 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_contentId)=>{
// Flag enabled: no-op (handled in SideEffects component)
}, (contentId)=>{
    // Flag disabled: run original effect with hook
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    (0, $42omo.useEffect)(()=>{
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
});
const $cf1996529f024723$export$6947f9bfb458da4f = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_editor_isolate_side_effects_experiment', 'isEnabled', true), (_contentId, _resetInitialDataLoadedMap, _clearCommentsData)=>{
// Flag enabled: no-op (handled in SideEffects component)
}, (contentId, resetInitialDataLoadedMap, clearCommentsData)=>{
    // Flag disabled: run original effect with hooks
    const { clearProcessedData: clearProcessedData } = (0, $4L9ve.useProcessedCommentsDataActions)();
    const { clearMentionsFlags: clearMentionsFlags } = (0, $hdxAi.useMentionsNotificationsActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            resetInitialDataLoadedMap();
            clearCommentsData();
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) clearProcessedData();
            clearMentionsFlags();
            setActiveHighlight(null);
        };
    }, [
        contentId,
        resetInitialDataLoadedMap,
        clearCommentsData,
        clearProcessedData,
        clearMentionsFlags,
        setActiveHighlight
    ]);
});


const $b56facd6a98e9621$var$ConditionalTwoStageHydration = ({ children: children })=>{
    if ((0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "full-page-editor-contentcomponents-after"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $b56facd6a98e9621$var$SSR_TRACE_SEGMENT_NAME = 'ssr-app/render/fullPageEditor';
const $b56facd6a98e9621$var$recordSSRMeasureWithPrefix = ({ segmentName: segmentName, ...rest })=>(0, $1fcefd278c33801b$export$5dc6b08aaa4bcf54)({
        segmentName: `${$b56facd6a98e9621$var$SSR_TRACE_SEGMENT_NAME}/${segmentName}`,
        ...rest
    });
const $b56facd6a98e9621$var$FullPageEditorWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19121cl4",
            __cmplp.className
        ])
    });
}); // IMPORTANT: If you change the code below, please also update the
const $b56facd6a98e9621$var$CARD_OPTIONS = {
    allowDatasource: true
};
const $b56facd6a98e9621$var$useLinkCreationQueryParam = (0, $dPJCf.createSingleQueryParamHook)('linkCreation');
const $b56facd6a98e9621$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $b56facd6a98e9621$var$useFocusedMentionIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedMentionId');
const $b56facd6a98e9621$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $b56facd6a98e9621$var$useVersionOverrideQueryParam = (0, $dPJCf.createSingleQueryParamHook)('versionOverride');
const $b56facd6a98e9621$var$usePageVersionQueryParam = (0, $dPJCf.createSingleQueryParamHook)('pageVersion'); // Content components are displayed below the editor tool bar
const $b56facd6a98e9621$var$_getContentComponents = (0, $2XqLN.default)(({ contentId: contentId, cloudId: cloudId, debounceTitleChangeUpdates: debounceTitleChangeUpdates, focusEditor: focusEditor, onFocusChanged: onFocusChanged, userOffline: userOffline, linkCreation: linkCreation, editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers, isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEnabledForContent: isAIEnabledForContent, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, hideSpinner: hideSpinner, templateSuggestionsRef: templateSuggestionsRef, templateButtonRef: templateButtonRef, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, spaceKey: spaceKey, isUnpublishedDraft: isUnpublishedDraft, showBlankPageQuickActions: showBlankPageQuickActions, isLivePage: isLivePage, version: version, isEditorEmpty: isEditorEmpty, shouldRenderPreview: shouldRenderPreview, isEditorAnnotationProviderManagersEnabled: isEditorAnnotationProviderManagersEnabled, editorApi: editorApi, contentType: contentType, editorActions: editorActions, disabled: disabled, isTitleFocused: isTitleFocused, appearance: appearance, title: title, onTitleChange: onTitleChange, cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, showSpinner: showSpinner, loadingPriority: loadingPriority, isRovoButtonEnabled: isRovoButtonEnabled, editorSessionId: editorSessionId, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, hasPageComments: hasPageComments, isEmbeddedConfluence: isEmbeddedConfluence, isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled, isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled, isSeamlessTransitionInProgress: isSeamlessTransitionInProgress = false, isRovoLLMEnabled: isRovoLLMEnabled, customPlaceholderOverride: customPlaceholderOverride, onCreateWithRovoClick: onCreateWithRovoClick, shouldShowCreateWithRovoExperience: shouldShowCreateWithRovoExperience, onPromptMouseEnter: onPromptMouseEnter, onPromptMouseLeave: onPromptMouseLeave, onPromptClick: onPromptClick, onPromptSubmit: onPromptSubmit, onDismissCwr: onDismissCwr, hasSubmittedCwrPrompt: hasSubmittedCwrPrompt, onInputEmpty: onInputEmpty })=>{
    const titleAreaContentComponents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
        key: "reactions-provider",
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $08a4a4f0ffa330f8$export$4907a23e9e92d796), {
        isEditorEmpty: isEditorEmpty,
        contentId: contentId,
        cloudId: cloudId,
        focusEditor: focusEditor,
        onFocusChanged: onFocusChanged,
        debounceOnChange: debounceTitleChangeUpdates,
        userOffline: userOffline,
        templateSuggestionsRef: templateSuggestionsRef,
        templateButtonRef: templateButtonRef,
        linkCreation: linkCreation,
        hideSpinner: hideSpinner,
        viewMode: viewMode,
        contentClassificationMetadata: contentClassificationMetadata,
        version: version,
        editorApi: editorApi,
        editorSessionId: editorSessionId,
        isSeamlessTransitionInProgress: isSeamlessTransitionInProgress,
        hasByLineContributors: hasByLineContributors,
        hasByLineExtensions: hasByLineExtensions,
        hasReactions: hasReactions,
        customPlaceholderOverride: customPlaceholderOverride
    }));
    let blankPageQuickActionsTemplatePreview;
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey); // show BPQA full size template preview when we
    // are not previewing the editor, BPQA should show and it's either
    // an unpublished draft or a live page
    const shouldShowFullPageTemplatePreview = !shouldRenderPreview && showBlankPageQuickActions && (isUnpublishedDraft || isLivePage);
    if (shouldShowFullPageTemplatePreview) blankPageQuickActionsTemplatePreview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccf3ae46461db7a4$export$5690797982203811), {
        key: "blank-page-quick-actions-template-preview",
        spaceKey: spaceKey
    });
    const isEmbeddedBpqaEnabled = isEmbeddedConfluence ? (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? isBlankPageQuickActionsEnabled || isTemplateBrowserEnabled : isTemplateBrowserEnabled : true;
    const shouldRenderBPQA = isEmbeddedBpqaEnabled && !shouldRenderPreview && showBlankPageQuickActions && !isCompanyHub;
    const shouldRenderPageFooterComments = isEmbeddedConfluence ? hasPageComments : true; // The footer is pinned to the bottom on small live pages (see ObjectCommentContainer)
    // However, this can only happen on first paint in SPA (useEffect + the DOM aren't available in SSR), so the SSR'd version doesn't match the SPA version
    // Until we have a styling only fix, we should prevent rendering this in SSR (but keep preloading, etc to improve TTVC)
    const shouldRenderObjectCommentWrapper = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    true;
    const shouldShowEOPRecommendations = contentType === 'page' && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) && // Hide Related content / Send feedback (EOP recommendations) for embedded pages
    // when cc-maui-experiment is enabled.
    !(isEmbeddedConfluence && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true));
    return {
        before: [
            !isCompanyHub && titleAreaContentComponents,
            isAdminHubAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2dIEg.EditorPluginAIWithFeedback), {
                key: "editor-ai-feedback-collector",
                editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers
            }),
            isEditorAnnotationProviderManagersEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5IgBW.EditorAnnotationProviderComponents), {
                key: "editorAnnotationProviderComponents"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fbPMY.EditorForgeExtensionConfigHelperRenderer), {
                key: "editorForgeExtensionConfigHelperRenderer"
            }),
            !isCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
                key: "object-sidebar-control-full-page-editor",
                name: "object-sidebar-control-full-page-editor",
                enabled: (0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true),
                ssrPlaceholder: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e65a39b95334039$export$7d2a7d16db4db259), {
                hasAiButton: isLivePage || isRovoButtonEnabled,
                hasAudioButton: (0, $3FLes.getHasAudioButton)({
                    isAIEnabledForContent: isAIEnabledForContent,
                    isAIEarlyAccessEnabled: isAIEarlyAccessEnabled
                }),
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                contentTitle: title,
                editorApi: editorApi,
                isUnpublishedDraft: isUnpublishedDraft,
                disabled: disabled,
                isEditorEmpty: isEditorEmpty
            })),
            shouldRenderBPQA && shouldShowCreateWithRovoExperience && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $badeeeba932732aa$export$1683fadeb44552c5), {
                key: "create-with-rovo-experience-dismiss-text"
            }),
            shouldRenderBPQA && (!isRovoLLMEnabled || !(0, $6mKj3.isExperimentEnabled)('cwr_blank_object_experiment')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eD8ha.BlankPageQuickActions), {
                key: "blank-page-quick-actions",
                editorActions: editorActions,
                disabled: disabled,
                isTitleFocused: isTitleFocused,
                focusEditor: focusEditor,
                appearance: appearance,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                title: title,
                onTitleChange: onTitleChange,
                contentId: contentId,
                cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
                showSpinner: showSpinner,
                hideSpinner: hideSpinner,
                isAIEnabled: isAdminHubAIEnabled,
                editorPresetAPI: editorApi,
                isTemplateBrowserEnabled: !isEmbeddedConfluence || isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled
            }),
            // Variant2: show CreateWithRovoExperience in place of the old BPQA
            shouldRenderBPQA && !hasSubmittedCwrPrompt && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44282712d6713830$export$895eee10ef701154), {
                key: "create-with-rovo-experience-variant2",
                spaceKey: spaceKey,
                cloudId: cloudId,
                contentId: contentId,
                editorApi: editorApi,
                onPromptMouseEnter: onPromptMouseEnter,
                onPromptMouseLeave: onPromptMouseLeave,
                onPromptClick: onPromptClick,
                onPromptSubmit: onPromptSubmit,
                onInputEmpty: onInputEmpty,
                smartPromptsPosition: "above",
                placement: "bottom",
                contentType: isLivePage ? 'liveDoc' : 'page',
                variant: "variant2"
            })
        ],
        after: [
            shouldRenderBPQA && !hasSubmittedCwrPrompt && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1441818b1f852262$export$5b6edddf72525f99), {
                key: "create-with-rovo-buttons",
                disabled: disabled,
                editorPresetAPI: editorApi,
                isTitleFocused: isTitleFocused,
                focusEditor: focusEditor,
                isAIEnabled: isAdminHubAIEnabled,
                isLivePage: isLivePage,
                onCreateWithRovoClick: onCreateWithRovoClick
            }),
            // Variant1: show CreateWithRovoExperience after clicking the CWR button
            shouldRenderBPQA && shouldShowCreateWithRovoExperience && !hasSubmittedCwrPrompt && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44282712d6713830$export$895eee10ef701154), {
                key: "create-with-rovo-experience",
                spaceKey: spaceKey,
                cloudId: cloudId,
                contentId: contentId,
                editorApi: editorApi,
                onPromptMouseEnter: onPromptMouseEnter,
                onPromptMouseLeave: onPromptMouseLeave,
                onPromptClick: onPromptClick,
                onPromptSubmit: onPromptSubmit,
                onDismiss: onDismissCwr,
                onInputEmpty: onInputEmpty,
                contentType: isLivePage ? 'liveDoc' : 'page',
                variant: "variant1"
            }),
            blankPageQuickActionsTemplatePreview,
            shouldRenderPageFooterComments && !shouldRenderBPQA && isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56facd6a98e9621$var$ConditionalTwoStageHydration, {
                key: "conditional-two-stage-hydration"
            }, shouldShowEOPRecommendations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
                name: "end-of-page-recommendation-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fIKxq.EndOfPageRecommendationLoader), {
                entityType: contentType,
                entityId: contentId,
                spaceKey: spaceKey ?? '',
                pageWidthType: `"max-width"`,
                isLivePage: isLivePage
            })), !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
                name: "editor-footer-comments"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdbc46c13e75ea1d$export$f9d737bcf2a1ec12), {
                key: contentId,
                contentId: contentId,
                loadingPriority: loadingPriority
            })), shouldRenderObjectCommentWrapper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
                name: "editor-footer-comments"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70pcM.ObjectCommentWrapper), {
                showGeneralComment: true,
                showLabels: true,
                loadingPriority: (0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $398ES.LoadingPriority).PAINT : loadingPriority,
                key: `ObjectCommentWrapper-${contentId}`,
                hasReactions: hasReactions,
                editorIsUserOffline: userOffline
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2xS8W.StickyDraftCommentContainer), null)))
        ]
    };
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $b56facd6a98e9621$var$_getContextPanelComponent = (0, $2XqLN.default)(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2KWDO.EditorContextPanelView), null);
});
const $b56facd6a98e9621$var$_getEditorContextConnectionsPanel = (0, $2XqLN.default)(({ referentialityContext: referentialityContext, connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId, closeConnectionsPanel: closeConnectionsPanel })=>{
    if (connectionsPanelActiveNodeLocalId && referentialityContext?.api) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXAjP.EditorContextConnectionsPanel), {
        api: referentialityContext.api,
        activeNodeLocalId: connectionsPanelActiveNodeLocalId,
        setActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
        closeConnectionsPanel: closeConnectionsPanel
    });
    return null;
});
const $b56facd6a98e9621$var$_getEditorContextSmartButtonConfigPanel = (0, $2XqLN.default)(({ smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId, closeSmartButtonConfigPanel: closeSmartButtonConfigPanel, fullPageEditorPresetAPI: fullPageEditorPresetAPI })=>{
    if (smartButtonActiveNodeLocalId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8S5Nq.SmartButtonConfigPanel), {
        localId: smartButtonActiveNodeLocalId,
        closeSelf: closeSmartButtonConfigPanel,
        editorApi: fullPageEditorPresetAPI
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/placeholderPluginOptions/placeholderPluginOptions.ts
const $b56facd6a98e9621$var$_getPlaceholderText = (0, $2XqLN.default)((placeholderTextParam)=>{
    const isAIEnabledForContent = placeholderTextParam.isAIEnabledForContent;
    if (isAIEnabledForContent && (0, $9wGTI.fg)('aifc_create_enabled')) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholder;
    if (isAIEnabledForContent && (0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true)) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI;
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholder;
    const key = `${isAIEnabledForContent ? 'AI' : 'noAI'}`;
    const placeholders = {
        AI: {
            //  Placeholder text when AI is enabled
            id: (0, $9b9cd112fc8297b9$export$7f03b831e2e40b16),
            defaultMessage: (0, $9b9cd112fc8297b9$export$6a44b93c4f739392)
        },
        noAI: {
            //  Placeholder text when AI is not enabled
            id: (0, $9b9cd112fc8297b9$export$b7b0d81eceb7980e),
            defaultMessage: (0, $9b9cd112fc8297b9$export$a86989c71e454d74)
        }
    };
    return placeholders[key];
});
const $b56facd6a98e9621$var$withEditorContext = (component)=>(0, $3plmx.withSmartCardProviderContext)((0, $gKaeO.withRevertContext)((0, $6LguK.withEditorModalContext)(component)));
const $b56facd6a98e9621$var$getContentAppearance = (0, $2XqLN.default)((appearance, draftAppearance)=>{
    // if the appearance is default value (version 0), reference the draftAppearance if it exists; otherwise, use appearance
    const contentAppearance = appearance.version === 0 && draftAppearance ? draftAppearance : appearance.appearance;
    return (0, $c4PY4.getContentAppearanceForAtlaskit)(contentAppearance);
}); // If updating please update in DiffEditor.tsx as well

const $b56facd6a98e9621$var$_createLCMExtensionProvider = async (outerEditorView, outerEditorApi, propOverrides)=>{
    const { createManifest: createManifest } = await (parcelRequire("dRPxE"));
    return new (0, $bre0g.default)([
        createManifest(outerEditorView, outerEditorApi, propOverrides)
    ]);
};
const $b56facd6a98e9621$var$FullPageEditorComponentImpl = (props)=>{
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $42omo.useRef)(performance.now());
    const { contentId: // Props from Loader
    contentId, spaceKey: spaceKey, collabEditProvider: collabEditProvider, collabEdit: collabEdit, collabEditState: collabEditState, heartbeatData: heartbeatData, contentType: contentType, disabled: disabled, setForceDisabled: setForceDisabled, internetDisconnected: internetDisconnected, forceDisabled: forceDisabled, draftShareId: draftShareId, refetchNativeCollab: refetchNativeCollab, isFirstParticipant: isFirstParticipant, isSingleUserSession: isSingleUserSession, isUnpublishedDraft: isUnpublishedDraft, isOverviewPage: isOverviewPage, onTitleChange: onTitleChange, title: title, version: version, viewMode: viewMode, onPublishUpdateTitleInPageTree: onPublishUpdateTitleInPageTree, optimisticDeleteItemInTree: optimisticDeleteItemInTree, customPerfData: customPerfData, editorActions: // Props from editor-core
    editorActions, extensionContextProvider: // Context Provider for macro
    extensionContextProvider, flags: flags, dialogs: dialogs, handleDocChange: handleDocChange, pageTreeStateUpdater: pageTreeStateUpdater, hasEditPermission: /**
     * defaults to true
     * used by live pages as live pages render editor on view only mode
     */ hasEditPermission = true, createdDate: createdDate, onDraftSyncSuccess: onDraftSyncSuccess, loadingPriority: loadingPriority, isFastLoadedLiveDoc: isFastLoadedLiveDoc, hasByLineContributors: hasByLineContributors = true, hasByLineExtensions: hasByLineExtensions = true, hasReactions: hasReactions = true, hasPageComments: hasPageComments = true, hasInlineComments: hasInlineComments = true } = props;
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }, { setEditorApi: setEditorApi, resetEditorApi: resetEditorApi }] = (0, $kDhla.useFullPageEditorApi)();
    const { detectedLinks: detectedLinks, newLinkTypes: newLinkTypes, newLinks: newLinks, shouldShowSpotlight: shouldShowSpotlight, closeSpotlight: closeSpotlight } = (0, $2a156e74b04ef78c$export$122559bc1a8888a4)(fullPageEditorPresetAPI); // Ensures editorApi sweet state is cleared on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            resetEditorApi();
        };
    }, [
        resetEditorApi
    ]); // Recommended way of accessing collabEditProvider without promise wrapper.
    const [{ collabEditProvider: extractedCollabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const { isDraftLockedForEditing: isDraftLockedForEditing } = (0, $laFNM.useApprovals)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const editorAPIRef = (0, $42omo.useRef)(fullPageEditorPresetAPI);
    (0, $42omo.useEffect)(()=>{
        editorAPIRef.current = fullPageEditorPresetAPI;
    }, [
        fullPageEditorPresetAPI
    ]);
    const snippetExtensionList = (0, $0e1c17ea1b1a2ab6$export$94cce102debd6a0e)({
        contentId: contentId,
        spaceId: spaceId ?? '',
        spaceKey: spaceKey,
        editorAPIRef: editorAPIRef
    });
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)({
        contentId: contentId,
        contentType: contentType,
        subject: 'editPage',
        source: (0, $9b9cd112fc8297b9$export$f7109619a5e9e0d6),
        version: version,
        collabService: 'ncs'
    });
    const { requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission } = (0, $ewVsQ.useRequestToEditContent)({
        contentId: contentId,
        flags: flags,
        triggerAnalyticsEvent: triggerAnalyticsEvent
    });
    const isClassicMentionsNotificationsEnrolled = (0, $9747c27e818a1963$export$a9e17b56b1093c49)();
    const { setEditorAnnotations: setEditorAnnotations } = (0, $aUU0C.useEditorAnnotationsActions)();
    const isDocumentActive = (0, $92561710d62f83c7$export$4e0e446ffa50ddc0)();
    const { isSmartButtonAllowed: isSmartButtonAllowed } = (0, $iz4WO.useSmartButtonPremiumGate)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $6mKj3.expValEquals)('confluence_fetch_appkey_field', 'isEnabled', true) ? (0, $c51db01a6bc02cc7$export$2e2bcd8739ae039) : (0, $0b5629b07134c74a$export$2e2bcd8739ae039)
    });
    const { updateTitle: updateContentTypesTitle } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title || '');
    const { collabEditInitialized: collabEditInitialized, collabEditError: collabEditError, collabEditInternetLost: collabEditInternetLost, collabEditConnectionTimedOut: collabEditConnectionTimedOut } = collabEditState;
    const intl = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition, orgId: orgId, environment: environment, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, overrideUFORouteName: overrideUFORouteName } = (0, $dPJCf.useRouteActions)();
    const linkCreation = $b56facd6a98e9621$var$useLinkCreationQueryParam();
    const focusedCommentId = $b56facd6a98e9621$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $b56facd6a98e9621$var$useReplyToCommentIdQueryParam();
    const focusedMentionId = $b56facd6a98e9621$var$useFocusedMentionIdQueryParam();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { triggerSaveIndicator: triggerSaveIndicator } = (0, $42omo.useContext)((0, $f9dc71ade1ee2d5f$export$df7407750199bb6d));
    const isEditorEmpty = (0, $eiA8Z.useSharedPluginStateWithSelector)(fullPageEditorPresetAPI, // @ts-ignore @ts-expect-error
    [
        'empty'
    ], // @ts-ignore @ts-expect-error
    (states)=>!!states?.emptyState?.editorIsEmpty) ?? editorActions?.isDocumentEmpty();
    const showBlankPageQuickActions = (0, $99ISI.useShouldShowBlankPageQuickActions)({
        contentType: contentType,
        collabEditInitialized: collabEditInitialized,
        isEditorEmpty: isEditorEmpty,
        viewMode: viewMode
    });
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const versionOverride = $b56facd6a98e9621$var$useVersionOverrideQueryParam();
    const pageVersion = $b56facd6a98e9621$var$usePageVersionQueryParam();
    const isVersionHistoryView = versionOverride != null || pageVersion != null;
    const isArchived = (0, $9sGCn.getCachedPageData)(contentId)?.isArchived ?? false;
    const remixDisabledReason = isArchived ? 'archived' : isVersionHistoryView ? 'version-history' : undefined;
    (0, $cf1996529f024723$export$ee581ede78ce7214)();
    const templateSuggestionsRef = (0, $42omo.useRef)(null);
    const templateButtonRef = (0, $42omo.useRef)(null);
    const [{ editSource: editSource }] = (0, $4ri4I.useEditSource)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)(); // State for Create with Rovo experience
    const [shouldShowCreateWithRovoExperience, setShouldShowCreateWithRovoExperience] = (0, $42omo.useState)(false);
    const [hasSubmittedCwrPrompt, setHasSubmittedCwrPrompt] = (0, $42omo.useState)(false);
    const [customPlaceholderOverride, setCustomPlaceholderOverride] = (0, $42omo.useState)(undefined); // Handler for Create with Rovo button click
    const handleCreateWithRovo = (0, $42omo.useCallback)(()=>{
        setShouldShowCreateWithRovoExperience(true);
    }, []); // open "Create with Rovo" modal via quick insert
    const openSmartCreationModalFromQuickInsert = (0, $d255586da55d4698$export$f34b0c6dc5eb5a35)(editorActions); // Track whether a prompt has been clicked so hover-off doesn't clear it
    const isPromptSelectedRef = (0, $42omo.useRef)(false); // Handlers for smart prompt hover to update title placeholder
    const onPromptMouseEnter = (0, $42omo.useCallback)((prompt)=>{
        if (!isPromptSelectedRef.current) setCustomPlaceholderOverride(prompt.label);
    }, []);
    const onPromptMouseLeave = (0, $42omo.useCallback)(()=>{
        if (!isPromptSelectedRef.current) setCustomPlaceholderOverride(undefined);
    }, []); // When a prompt is clicked, persist its label as the title placeholder
    const onPromptClick = (0, $42omo.useCallback)((prompt)=>{
        isPromptSelectedRef.current = true;
        setCustomPlaceholderOverride(prompt.label);
    }, []); // When a prompt is submitted, hide the CWR experience and the buttons
    const onPromptSubmit = (0, $42omo.useCallback)(()=>{
        setShouldShowCreateWithRovoExperience(false);
        setHasSubmittedCwrPrompt(true);
    }, []); // Open Rovo chat sidebar when CWR streaming completes
    const { toggleConversationAssistant: toggleConversationAssistant, mode: conversationAssistantMode } = (0, $1AJi3.useToggleConversationAssistant)();
    const onCwrStreamEnd = (0, $42omo.useCallback)(()=>{
        if (hasSubmittedCwrPrompt && conversationAssistantMode !== (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR && ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') || (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2'))) toggleConversationAssistant('sidebar');
    }, [
        hasSubmittedCwrPrompt,
        toggleConversationAssistant,
        conversationAssistantMode
    ]); // When the user clicks outside the CWR experience, dismiss it and reset the title placeholder
    const onDismissCwr = (0, $42omo.useCallback)(()=>{
        setShouldShowCreateWithRovoExperience(false);
        setCustomPlaceholderOverride(undefined);
        isPromptSelectedRef.current = false;
    }, []); // When the user clears the prompt input, reset the title placeholder
    const onInputEmpty = (0, $42omo.useCallback)(()=>{
        isPromptSelectedRef.current = false;
        setCustomPlaceholderOverride(undefined);
    }, []); // For cwr_blank_object_experiment variant1: intercept the space key shortcut
    // to show the CWR experience instead of opening inline Rovo
    (0, $cf1996529f024723$export$7d308a2b14d43346)({
        isActive: showBlankPageQuickActions && !hasSubmittedCwrPrompt && !shouldShowCreateWithRovoExperience,
        isRovoLLMEnabled: isRovoLLMEnabled,
        onSpaceKeyPressed: handleCreateWithRovo,
        isLivePage: isLivePage
    });
    const handleGqlError = (0, $42omo.useCallback)((error, isCommentNotFound = false)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error,
            attributes: {
                mode: isLivePage ? (0, $l2hqi.InlineCommentMode).LIVE : (0, $l2hqi.InlineCommentMode).EDIT,
                stopPoint: 'full-page-editor/FullPageEditorComponent',
                commentNotFound: isCommentNotFound
            }
        });
    }, [
        experienceTracker,
        isLivePage
    ]); // Note that this will detect missing inline and footer comments because the query will
    // find either type of comment - so if the comment doesn't exist, we will get the "not
    // found" error
    const handleUseFocusedCommentGQLError = (0, $42omo.useCallback)((error)=>{
        const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message) : false;
        if (flags && isCommentNotFound) {
            const commentId = focusedCommentId || replyToCommentId;
            const FULLPAGEEDITOR_COMMMENT_LINK_NOT_FOUND_FLAG_ID = `fullpageeditor-comment-link-not-found-${commentId}`;
            flags.showWarningFlag({
                id: FULLPAGEEDITOR_COMMMENT_LINK_NOT_FOUND_FLAG_ID,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentLinkNotFoundFlagDescription)
            });
        }
        handleGqlError(error, isCommentNotFound);
    }, [
        flags,
        focusedCommentId,
        handleGqlError,
        replyToCommentId
    ]);
    (0, $cf1996529f024723$export$1a20dd7f74852e6b)(); // === Editor State ===
    const [shouldRenderPreview, setShouldRenderPreview] = (0, $42omo.useState)(false);
    const [previewAsBlog, setPreviewAsBlog] = (0, $42omo.useState)(false);
    const [stagedContentId, setStagedContentId] = (0, $42omo.useState)();
    const [stagedSpaceKey, setStagedSpaceKey] = (0, $42omo.useState)();
    const [proseMirrorRenderedData, setProseMirrorRenderedData] = (0, $42omo.useState)(null);
    const [checkIfConditionPreventingPublish, setCheckIfConditionPreventingPublish] = (0, $42omo.useState)();
    const assignConditionalFunction = (0, $42omo.useCallback)((conditionalFunction)=>setCheckIfConditionPreventingPublish(()=>conditionalFunction), []);
    const { updateUnresolvedInlineComment: updateUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)(); // importing the comments data states here as a temporary workaround to fix circular dependency, we need these states to handle dangling and unread from unread-comments package
    // unread-comments package is using comments-data package so we can't import comments-data into unread-comments package
    const { setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, clearCommentsData: clearCommentsData } = (0, $8i27m.useCommentsDataActions)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap, setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    (0, $cf1996529f024723$export$3873199fd2fe1b43)(proseMirrorRenderedData !== null, undefined, fullPageEditorPresetAPI);
    const handleCollabError = (0, $fBnV3.useHandleCollabError)(flags);
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)), !(0, $9wGTI.fg)('cc_onboarding_experience') || version !== 1); // when a user is eligible for contextual invite nudge, tag them before they publish
    (0, $lG7DR.useContextualInviteNudge)();
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, recentSpotlightCompleted: recentSpotlightCompleted } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const shouldShowRecentSpotlight = !onboardingStateLoading && editorOnboardingEligiblity && !recentSpotlightCompleted; // Makes sure recentSpotlightCompleted is not undefined
    const { onEditorReady: onEditorReady, startingLinks: startingLinks } = (0, $1l6y9.useInviteFromLinkExperimentEditor)(); // === Editor common functionalities and providers ===
    const { collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, stopHeartbeatCallback: stopHeartbeatCallback, editorSessionId: editorSessionId } = heartbeatData; // Preloading native collab data for faster refetch when publishing
    const { refetchNativeCollab: refetchNativeCollabWithPreloading, preloadNativeCollabRefetch: preloadNativeCollabRefetch } = (0, $83a5ab04c7ded94b$export$f6774c6023dca75e)(refetchNativeCollab); // Edit page draft syncing
    const { cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, triggerSaveDraft: triggerSaveDraft, navigateOnClose: navigateOnClose, onPublish: onPublish, isPublishingContent: isPublishingContent, saveDraft: saveDraft, saveDraftError: saveDraftError } = (0, $l3Dp5.useDraftSyncAndPublish)({
        contentId: contentId,
        contentType: contentType,
        refetchNativeCollab: (0, $6mKj3.expValEquals)('confluence_publish_ivc_native_collab_query', 'isEnabled', true) ? refetchNativeCollabWithPreloading : refetchNativeCollab,
        isFirstParticipant: isFirstParticipant,
        isUnpublishedDraft: isUnpublishedDraft,
        spaceKey: spaceKey,
        title: title,
        version: version,
        onCollabError: handleCollabError,
        editorActions: editorActions,
        checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
        flags: flags,
        dialogs: dialogs,
        editorPresetAPI: fullPageEditorPresetAPI,
        editorSessionId: editorSessionId,
        onPublishUpdateTitleInPageTree: onPublishUpdateTitleInPageTree,
        optimisticDeleteItemInTree: optimisticDeleteItemInTree,
        startingLinks: startingLinks
    }); // Live doc draft syncing
    const { draftSyncActionError: draftSyncActionError } = (0, $a59bf23b6ef769dd$export$7a6d63ee0185f0fd)({
        contentId: contentId,
        editorPresetAPI: fullPageEditorPresetAPI,
        editorActions: editorActions,
        onDraftSyncSuccess: onDraftSyncSuccess,
        isFirstParticipant: isFirstParticipant,
        flags: flags
    });
    const hasUnsavedChanges = (0, $f8ea506e3a40865e$export$d85ed874af6294e9)({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI
    });
    const printLockout = (0, $88Nzy.usePrintIntercept)({
        enabled: (0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true),
        shouldBlockPrint: ()=>hasUnsavedChanges
    });
    (0, $cf1996529f024723$export$4b3266eb0ec6c746)((0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true), intl);
    const { isTransitionPreloading: isLiveDocSeamlessTransitionPreloading } = (0, $d2e739e403a90913$export$1da4922e40f79365)({
        contentId: contentId,
        collabEditProvider: extractedCollabEditProvider,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI,
        isLivePage: isLivePage,
        hasEditPermission: hasEditPermission,
        isFastLoadedLiveDoc: isFastLoadedLiveDoc
    });
    const [isLiveDocSeamlessTransitioning, setIsLiveDocSeamlessTransitioning] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        let newTransitioningState;
        if (isLivePage) {
            if (!isLiveDocSeamlessTransitioning && isLiveDocSeamlessTransitionPreloading) newTransitioningState = true;
            else if (isLiveDocSeamlessTransitioning && !disabled && !isLiveDocSeamlessTransitionPreloading) newTransitioningState = false;
        } else if (isLiveDocSeamlessTransitioning) newTransitioningState = false;
        if (newTransitioningState !== undefined && newTransitioningState !== isLiveDocSeamlessTransitioning) setIsLiveDocSeamlessTransitioning(newTransitioningState);
    }, [
        contentId,
        disabled,
        isLiveDocSeamlessTransitionPreloading,
        isLivePage,
        isLiveDocSeamlessTransitioning
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage && isOverviewPage && // exposure will only fire for overview pages
        (0, $6mKj3.expValEquals)('cc_editor_ttvc_split_space_overview_edit_page', 'isEnabled', true)) overrideUFORouteName('space-overview-edit-page');
    }, [
        overrideUFORouteName,
        isLivePage,
        isOverviewPage
    ]);
    const [isAutoConverted] = (0, $sLZsl.useAutoConvertState)();
    const { draftTitle: draftTitle, draftBody: draftBody, draftAppearance: draftAppearance } = (0, $9a6aed826f4ffb4d$export$48c0f85d55b51110)({
        contentId: contentId,
        draftShareId: draftShareId,
        collabEditInitialized: collabEditInitialized,
        editorActions: editorActions,
        isUnrecoverableCollabEditError: !!collabEditError && (0, $S6mif.isUnrecoverableError)(collabEditError)
    }); // Get cached title from Apollo cache (e.g., from page tree) to use as initial value
    // while waiting for collab to initialize. This prevents the "Give this page a title"
    // placeholder from flashing during transitional loads.
    const cachedTitle = (0, $42omo.useMemo)(()=>{
        // Skip cache lookup if we already have a title from collab or draft
        if (title || draftTitle) return null;
        if ((0, $6mKj3.expValEquals)('confluence_load_editor_title_on_transition', 'isEnabled', true)) {
            const { title: cached } = (0, $6OEkb.getCachedPageTitle)(contentId);
            return cached ?? null;
        }
        return null;
    }, [
        contentId,
        title,
        draftTitle
    ]);
    const { connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId, openConnectionsPanel: openConnectionsPanel, closeConnectionsPanel: closeConnectionsPanel } = (0, $39X8O.useConnectionsPanel)();
    const { activeNodeLocalId: activeNodeLocalId, openConfigPanel: openConfigPanel, closeConfigPanel: closeConfigPanel, upsellModalSource: upsellModalSource, setUpsellModalSource: setUpsellModalSource } = (0, $b5ea4fb4260f4ec5$export$bdd538c0d43098c3)(editorActions);
    const { smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeSmartButtonConfigPanel: closeSmartButtonConfigPanel } = (0, $jOYfu.useSmartButtonConfigPanel)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const { optInStatus: optInStatus, triggerOptInFlow: triggerOptInFlow, AIOptInModal: AIOptInModal } = (0, $i8Ylv.useEditorAIOptIn)({
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isAIEnabledForContent: isAIEnabledForContent,
        edition: edition,
        orgId: orgId,
        environment: environment
    });
    const aiGlobalOptIn = (0, $42omo.useMemo)(()=>({
            status: optInStatus,
            triggerOptInFlow: triggerOptInFlow
        }), [
        optInStatus,
        triggerOptInFlow
    ]);
    const { editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers } = (0, $f6GmT.useEditorPluginAIFeedbackHandlers)();
    const { onAIProviderChanged: onAIProviderChanged } = (0, $349687d7e88d726e$export$f95232bf2d33b362)();
    const getChannelVariables = (0, $85rxh.useGetChannelVariables)(cloudId, userId || 'anonymous', orgId); // Build media viewer extensions to add the comments button to the preview header
    const mediaViewerExtensions = (0, $BjpgS.useMediaCommentExtensions)({
        isViewPage: false,
        analyticsSource: isLivePage ? 'livePage' : 'editPageScreen',
        flags: flags
    });
    const mediaOptions = (0, $bjxK7.useMediaOptions)({
        contentId: contentId,
        contentType: contentType,
        flags: flags,
        viewMode: viewMode,
        editorAPI: fullPageEditorPresetAPI ?? undefined,
        mediaViewerExtensions: mediaViewerExtensions
    });
    const handleFeedbackClicked = (0, $42omo.useCallback)((props)=>{
        editorPluginAIFeedbackHandlers.current.handleFeedbackClicked(props);
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const handleReviewStateEntered = (0, $42omo.useCallback)(()=>{
        editorPluginAIFeedbackHandlers.current.handleReviewStateEntered();
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const handleExperienceEnded = (0, $42omo.useCallback)(()=>{
        editorPluginAIFeedbackHandlers.current.handleExperienceEnded();
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const editorPluginAIProviders = (0, $42omo.useMemo)(()=>({
            mediaProvider: mediaOptions.provider
        }), [
        mediaOptions.provider
    ]);
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const handleAnnotationsRemovedByAI = (0, $26Yfd.useStableCallback)((ids)=>{
        if (!ids?.length) return;
        if (ids.length) flags?.showInfoFlag({
            id: ids[0],
            title: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoTitle, {
                count: ids.length
            }),
            description: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoDescription, {
                count: ids.length
            }),
            isAutoDismiss: true,
            actions: [
                {
                    content: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoViewCommentCTA, {
                        count: ids.length
                    }),
                    onClick: ()=>{
                        const openWithView = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') ? (0, $3mVfX.ViewValues).DELETED_CONTENT : (0, $3mVfX.ViewValues).OPEN;
                        if (!isCommentsPanelShown) showCommentsPanel({
                            openWithView: openWithView
                        });
                        else setCurrentView(openWithView);
                        flags.hideFlag(flags.state.flags[0]?.id);
                    }
                }
            ]
        });
    });
    const editorPluginAIOptions = (0, $foVrt.useEditorPluginAIOptions)({
        aiGlobalOptIn: aiGlobalOptIn,
        appearance: 'full-page',
        onFeedbackClicked: handleFeedbackClicked,
        onReviewStateEntered: handleReviewStateEntered,
        onExperienceComplete: handleExperienceEnded,
        onAIProviderChanged: onAIProviderChanged,
        getChannelVariables: getChannelVariables,
        providers: editorPluginAIProviders,
        contentId: contentId,
        onAnnotationsRemoved: handleAnnotationsRemovedByAI,
        usePlatformPrompt: (0, $9wGTI.fg)('aifc_create_enabled')
    });
    (0, $cf1996529f024723$export$f46ffb959d708168)({
        contentId: contentId,
        collabService: 'ncs'
    });
    const { isTitleFocused: isTitleFocused, shouldFocusEditor: shouldFocusEditor, debounceTitleChangeUpdates: debounceTitleChangeUpdates, focusEditor: focusEditor, onFocusChanged: onFocusChanged } = (0, $1NbQn.useEditorTitleFocus)({
        contentType: contentType,
        editorActions: editorActions,
        isUnpublishedDraft: isUnpublishedDraft
    }); // Editor Disabled Analytics
    (0, $cf1996529f024723$export$d2b5179b7b1bfa0e)({
        contentId: contentId,
        disabled: isTitleFocused || disabled,
        shouldRenderPreview: shouldRenderPreview,
        isTitleFocused: isTitleFocused,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError
    });
    const updateUnresolvedInlineCommentFn = (0, $WheoQ.useUpdateAnnotations)([
        updateUnresolvedInlineComment,
        setOrderedActiveAnnotationIdList
    ]);
    const annotationProviderOptions = (0, $bAGpj.useEditorAnnotationProviderOptions)({
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        editorActions: editorActions,
        updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn
    });
    const activityProvider = (0, $fjhaB.useActivityProvider)();
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId, undefined, focusedMentionId);
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        cloudId: cloudId,
        featureFlags: featureFlags,
        userId: userId
    });
    const mentionProps = (0, $42omo.useMemo)(()=>{
        return {
            profilecardProvider: profilecardProvider
        };
    }, [
        profilecardProvider
    ]);
    const searchProvider = (0, $3W9OD.useSearchProvider)();
    const findReplaceOptions = (0, $0642f0591024f070$export$f31ae08e8dcbd049)();
    const taskDecisionProvider = (0, $bcv7k.getTaskDecisionProvider)();
    const autoformattingProvider = (0, $9EvUR.useAutoformattingProvider)({
        contentId: contentId,
        spaceKey: spaceKey,
        source: (0, $9b9cd112fc8297b9$export$f7109619a5e9e0d6)
    });
    const emojiProvider = (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId || undefined,
        allowAnonymousAccess: true
    });
    const contextIdentifierProvider = (0, $98Cy1.useContextIdentifierProvider)(spaceId, contentId);
    const syncedBlockProvider = (0, $aIZFY.useMemoizedSyncedBlockProviderForEditor)({
        contentId: contentId,
        contentType: contentType,
        focusedMentionId: focusedMentionId,
        spaceId: spaceId,
        editorActions: editorActions
    });
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const syncedBlockEventHandlers = (0, $42omo.useMemo)(()=>{
        return (0, $lmNXu.createSmartCardEventHandler)({
            matchRoute: matchRoute,
            push: push
        }, true);
    }, [
        matchRoute,
        push
    ]);
    const { showMacroFallbackFlag: showMacroFallbackFlag } = (0, $8dcb77f48242281e$export$210750141a74fdf7)(flags, isLivePage);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { mode: editorContentMode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    const allowCreateWithRovoExtension = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    isRovoButtonEnabled && contentType === 'page' && !isEmbeddedConfluence && (0, $9wGTI.fg)('aifc_create_enabled') && (0, $9wGTI.fg)('cc_fd_cwr_quick_insert_gate'); // Extension V2 API props
    const { extensionOptions: extensionOptions, rendererExtensionOptions: rendererExtensionOptions } = (0, $aPQsP.useExtensionOptions)({
        contentId: contentId,
        contentTitle: title ?? undefined,
        contentType: contentType,
        contentVersion: (0, $9wGTI.fg)('forge-ui-add-contentversion-to-macro-extensiondata') ? version : undefined,
        contentMode: editorContentMode,
        editorActions: editorActions,
        mentionProvider: mentionProvider,
        spaceKey: spaceKey,
        spaceId: spaceId,
        extensionContextProvider: extensionContextProvider,
        openConnectionsPanel: openConnectionsPanel,
        openConfigPanel: openConfigPanel,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        onCompleteCallback: showMacroFallbackFlag,
        isLivePage: isLivePage,
        allowCreateDatabaseExtension: true,
        allowDatabaseQuickInsert: true,
        allowCreateWhiteboardExtension: true,
        allowCreateWithRovoExtension: allowCreateWithRovoExtension,
        openSmartCreationModal: openSmartCreationModalFromQuickInsert,
        flags: flags,
        aiOptInStatus: optInStatus,
        editorAPI: fullPageEditorPresetAPI ?? undefined,
        setUpsellModalSource: setUpsellModalSource,
        isFullPageEditor: true,
        allowCompanyHubExclusiveExtensions: isCompanyHub,
        allowLegacyMacros: true,
        isCollabEditForLiveUpdatesEnabled: true,
        pageTreeStateUpdater: pageTreeStateUpdater
    });
    const extensionProvidersWithLCM = (0, $42omo.useMemo)(()=>{
        const outerEditorView = editorActions._privateGetEditorView();
        const LCMExtension = $b56facd6a98e9621$var$_createLCMExtensionProvider(outerEditorView, fullPageEditorPresetAPI, {
            contentMode: editorContentMode
        });
        return [
            ...extensionOptions.extensionProviders,
            LCMExtension
        ];
    }, [
        editorActions,
        fullPageEditorPresetAPI,
        extensionOptions.extensionProviders,
        editorContentMode
    ]);
    const { showRevertDialog: showRevertDialog } = (0, $gKaeO.useEditorRevertDialogContext)();
    const { showSpinner: showSpinner, hideSpinner: hideSpinner, shouldShowSpinner: shouldShowSpinner } = (0, $beK3g.useSpinner)();
    const editorAnnotationsRef = (0, $42omo.useRef)([]);
    const annotationStateRef = (0, $42omo.useRef)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)(); // Note: useConditionalPluginStateEffect wraps the original usePluginStateEffect
    // When feature flag is enabled, this becomes a no-op (handled in SideEffects component)
    // When flag is disabled, this runs as normal (for backward compatibility)
    (0, $cf1996529f024723$export$9178b120e06dfd53)(fullPageEditorPresetAPI, [
        'annotation'
    ], ({ annotationState: annotationState })=>{
        const annotations = annotationState?.annotations;
        const { selectedAnnotations: selectedAnnotations, mouseData: mouseData } = annotationState || {};
        annotationStateRef.current = annotationState;
        const handleCommentQueryParams = ()=>{
            if (selectedAnnotations && selectedAnnotations.length > 0 && mouseData?.isSelecting && (focusedCommentId || replyToCommentId)) removeCommentQueryParams();
        };
        const setAnnotations = ()=>{
            const editorAnnotationsToSet = annotations ? Object.keys(annotations) : [];
            setEditorAnnotations((0, $aHcFH.getSortedMarkerRefs)(editorAnnotationsToSet, 'edit'), contentId);
            editorAnnotationsRef.current = editorAnnotationsToSet;
            const activeEditorAnnotationsToSet = annotations ? Object.keys(annotations).filter((key)=>annotations[key] === false) : [];
            setOrderedActiveAnnotationIdList((0, $aHcFH.getSortedMarkerRefs)(activeEditorAnnotationsToSet, 'edit'));
        };
        handleCommentQueryParams();
        setAnnotations();
    });
    (0, $cf1996529f024723$export$1a19d181d558cc48)({
        commentId: focusedCommentId || replyToCommentId,
        contentId: contentId,
        handleGqlError: handleUseFocusedCommentGQLError,
        annotationState: annotationStateRef.current
    });
    const { storedCommentData: storedCommentData } = (0, $cf1996529f024723$export$ede9be424e8ef89a)();
    const { setStoredCommentData: setStoredCommentData } = (0, $cf1996529f024723$export$3be336e5c3e78567)();
    const { addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true
        }
    });
    (0, $cf1996529f024723$export$7d464c122ca911c0)({
        contentId: contentId,
        contentType: contentType,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn,
        isDocumentActive: isDocumentActive,
        storedCommentData: storedCommentData,
        setStoredCommentData: setStoredCommentData,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    });
    (0, $cf1996529f024723$export$3c5a4187b7dbe412)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'edit'
        }
    });
    const { retrieveEditorTitleAndContent: retrieveEditorTitleAndContent } = (0, $iWI3x.useRetrieveEditorTitleAndContent)({
        onCollabError: handleCollabError,
        editorActions: editorActions
    }); // TODO: add missing configs/providers (possibly not all):
    // presenceProvider
    // legacyImageUploadProvider
    // placeholderBracketHint
    // allowAnalyticsGASV3
    // onDestroy
    const wrapperProps = {
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS,
        collabEditState: collabEditState,
        contentId: contentId,
        forceDisableEditor: setForceDisabled,
        isUnpublishedDraft: isUnpublishedDraft,
        contentType: contentType,
        editorActions: editorActions,
        heartbeatError: heartbeatError,
        saveDraftError: isLivePage ? draftSyncActionError : saveDraftError,
        stopHeartbeatCallback: stopHeartbeatCallback,
        isLivePage: isLivePage,
        editorDisabled: disabled
    };
    const performanceTrackingOptions = undefined;
    const editorFeatureFlags = (0, $7BsWq.useEditorFeatureFlags)();
    const editorExperiments = (0, $eLnQS.useEditorFullPageExperiments)();
    (0, $cf1996529f024723$export$257c6c9e28c0ad4b)(extractedCollabEditProvider); // Fetch content's classification data
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: isLivePage ? 'current-and-draft' : 'draft-only'
    });
    (0, $42omo.useEffect)(()=>{
        if (collabEditInitialized && !disabled) (0, $e6u60.scrollToLastViewedPosition)(contentId);
    }, [
        collabEditInitialized,
        disabled,
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        // DTR-1401-CFE
        // HOT-103036
        // If a blogpost is selected from in-editor templates panel, any preset restrictions are lost.
        // This lets the user know to update their blog restrictions.
        const showBlogpostAccessFlag = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).BLOGPOST_PERMISSIONS_NOTICE);
        if (flags && showBlogpostAccessFlag === 'true') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).blogpostPermissionsNotice)
            });
            (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).BLOGPOST_PERMISSIONS_NOTICE);
        }
    }, [
        flags
    ]);
    (0, $42omo.useEffect)(()=>{
        document.addEventListener('keydown', ()=>(0, $6eee7623ad82c8da$export$386b0ae74d3f86a0)(triggerAnalyticsEvent), {
            once: true
        });
    }, [
        triggerAnalyticsEvent
    ]); // Close the object sidebar when navigating to a new page
    // Note: useConditionalHideObjectSidebarEffect wraps the original effect
    // When feature flag is enabled, the hook and effect both run in SideEffects component
    // When flag is disabled, this runs as normal (for backward compatibility)
    (0, $cf1996529f024723$export$3bcfd3dcf4c2b277)(contentId); // Comments cleanup on unmount or content change
    // Note: useConditionalCommentsCleanupEffect wraps the original effect
    // When feature flag is enabled, the effect runs in SideEffects component
    // When flag is disabled, this runs as normal (for backward compatibility)
    (0, $cf1996529f024723$export$6947f9bfb458da4f)(contentId, resetInitialDataLoadedMap, clearCommentsData); // Focus the main content area for live pages Full Page Editor mount.
    (0, $cf1996529f024723$export$166cbf4b2438db83)(isLivePage);
    const onProseMirrorRendered = (proseMirrorRenderedAttributes)=>{
        proseMirrorRenderedAttributes = proseMirrorRenderedAttributes || {}; // "distortedDuration" gets a true value if page was loaded in the background
        // in a non-visible tab which can lead to inaccurate duration numbers,
        // this can help us to capture only legitimate durations in our metric dashboards.
        // See https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/editor/editor-common/src/utils/performance/measure-render.ts
        const { proseMirrorRenderedFMP: proseMirrorRenderedFMP, proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp, startTime: startTime, duration: duration, nodes: nodes, nodeSize: nodeSize, nodeSizeBucket: nodeSizeBucket, totalNodes: totalNodes, nodesInViewport: nodesInViewport, distortedDuration: distortedDuration } = proseMirrorRenderedAttributes;
        setProseMirrorRenderedData({
            proseMirrorRenderedFMP: proseMirrorRenderedFMP,
            proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp,
            startTime: startTime,
            duration: duration,
            nodes: nodes,
            nodesInViewport: nodesInViewport,
            distortedDuration: distortedDuration
        });
        if ((0, $6mKj3.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).endHeavyTask('PageLoad');
        if ((0, $6mKj3.expValEquals)('cc_editor_insm_doc_size_stats', 'isEnabled', true)) (0, $2v1PW.insm).session?.addProperties({
            'initial:totalNodes': totalNodes,
            'initial:nodeSize': nodeSize,
            'initial:nodes': nodes,
            'initial:nodesInViewport': nodesInViewport,
            'initial:renderDuration': duration,
            'initial:nodeSizeBucket': nodeSizeBucket
        });
    };
    (0, $42omo.useEffect)(()=>{
        (0, $3d5UI.waitForGlobal)({
            listener: 'FullPageEditorComponent',
            globalProperty: 'AJS.bind'
        }, ()=>{
            window.AJS.bind('createGASv3Event', (_, data)=>{
                createAnalyticsEvent(data).fire();
            });
        });
        return ()=>{
            (0, $3d5UI.waitForGlobal)({
                listener: 'FullPageEditorComponent',
                globalProperty: 'AJS.unbind'
            }, ()=>{
                window.AJS.unbind('createGASv3Event');
            });
        };
    }, [
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        isAutoConverted && (0, $cQhbe.sendEditorConversionAnalyticsPageEvent)(createAnalyticsEvent, {
            pageAction: (0, $cQhbe.AutoConvertEvent).EDITED,
            source: 'FullPageEditorComponent-Next'
        }, (0, $cQhbe.AutoConvertActionSubject).AUTO_CONVERSION);
    }, [
        isAutoConverted,
        createAnalyticsEvent
    ]);
    const { setOptimisticTitle: setOptimisticTitle, optimisticTitle: optimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, title);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    const userOffline = collabEditInternetLost || collabEditConnectionTimedOut;
    const handleTitleChange = (0, $26Yfd.useStableCallback)((newTitle)=>{
        if (isLivePage) {
            /*
      	Live pages immediately persist title changes to the backend and change the page title in the UI,
      	unlike regular pages where changing the title only alters the draft version of the page and
      	it is not fully persisted until the user saves the draft.
      	*/ updateContentTypesTitle(newTitle);
            return;
        }
        setOptimisticTitle(newTitle);
        triggerSaveIndicator();
        onTitleChange(newTitle);
        triggerSaveDraft(); // Update timestamp cache so that Last Edited in object header responsively updates
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) updateTimestampCache({
            contentId: contentId
        });
    });
    (0, $b3e3043e802ac415$export$befb12a9d0ae7ad9)({
        editorApi: fullPageEditorPresetAPI || undefined,
        contentId: contentId
    });
    const { openPublishModal: openPublishModal } = (0, $6pob4.usePublishModalMountActions)();
    const validatePageAndOpenModal = (0, $1N2OF.usePrePublishTitleValidation)({
        contentId: contentId,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft,
        flags: flags,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        onBeforeValidation: (0, $42omo.useCallback)(()=>{
            saveDraft?.();
        }, [
            saveDraft
        ]),
        onValidationSuccess: openPublishModal,
        analyticsSource: 'LivePagesDetailsPanel',
        optimisticTitle: optimisticTitle
    });
    (0, $cf1996529f024723$export$ff041132f32feaf3)({
        enabled: isAIEnabledForContent,
        title: title || draftTitle || '',
        handleNewTitle: handleTitleChange,
        canFireUnifiedAIAnalyticsEvent: true
    });
    const handleBreadcrumbsClick = (0, $42omo.useCallback)((destinationUrl)=>{
        // https://product-fabric.atlassian.net/browse/CEMS-2479
        // sync draft and content title with NCS
        // when user click on breadcrumbs to exit the editor
        // so title is up-to-date in page tree
        return new Promise((resolve)=>{
            saveDraft({
                isOnClose: true
            }).then(()=>{
                push(destinationUrl);
                resolve();
            });
        });
    }, [
        push,
        saveDraft
    ]); // [ED-27497] IMPORTANT: This has been moved to the below function. If you add anything here, also add it to the new function.
    // `quickInsertPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/quickInsertPluginOptions.ts'.
    const elementBrowser = (0, $42omo.useMemo)(()=>({
            showModal: true,
            replacePlusMenu: true,
            emptyStateHandler: (0, $f9a65503f42ecec3$export$bc75c05af9bceb4a)
        }), []); // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    const fullPageEditorFeatureFlags = (0, $42omo.useMemo)(()=>({
            ...editorFeatureFlags,
            ...editorExperiments,
            'basic-text-transformations': // utilise this flag as part of eligibility check to avoid passing AI enablement status as editor prop
            aiGlobalOptIn.status === 'disabled'
        }), [
        editorFeatureFlags,
        editorExperiments,
        aiGlobalOptIn.status
    ]);
    const onPreviewClicked = (0, $42omo.useCallback)((requestingPreviewAsBlog, stagedMoveParams)=>{
        setPreviewAsBlog(requestingPreviewAsBlog === true);
        setShouldRenderPreview(true);
        setStagedContentId(stagedMoveParams?.newParentPageId);
        setStagedSpaceKey(stagedMoveParams?.newSpaceKey);
    }, [
        setPreviewAsBlog,
        setShouldRenderPreview,
        setStagedContentId,
        setStagedSpaceKey
    ]);
    const onHoverPublish = (0, $42omo.useCallback)(()=>{
        if (preloadNativeCollabRefetch && (0, $6mKj3.expValEquals)('confluence_publish_ivc_native_collab_query', 'isEnabled', true)) preloadNativeCollabRefetch();
    }, [
        preloadNativeCollabRefetch
    ]);
    const onClickPublish = (0, $26Yfd.useStableCallback)(onPublish);
    const navigateOnCloseStable = (0, $26Yfd.useStableCallback)(navigateOnClose);
    (0, $cf1996529f024723$export$206997a838ea4b9d)({
        contentId: contentId,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft,
        title: title ?? draftTitle,
        flags: flags,
        isSchedulePublishEnabled: !isLivePage
    }); // Insert Loom video at top of editor page if a Loom url exists
    (0, $cf1996529f024723$export$12026d53c57123e6)(fullPageEditorPresetAPI);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { getHeadingLinkPath: getHeadingLinkPath } = (0, $5c5c39eb3a311fda$export$5972bbfae42d8829)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        title: title,
        createdDate: createdDate,
        isUnpublishedDraft: isUnpublishedDraft
    });
    const editorDisabled = (0, $aa4689242ad06a0b$export$dc599391a17e1b5b)({
        disabled: disabled,
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        api: fullPageEditorPresetAPI
    });
    (0, $cf1996529f024723$export$c0a34c12e787105e)({
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        editorFullPagePresetAPI: fullPageEditorPresetAPI
    });
    const extensionRendererViewOptions = (0, $kRAnY.useExtensionRendererViewOptions)({
        getExtensionHandlers: rendererExtensionOptions?.getExtensionHandlers,
        isLivePage: isLivePage,
        contentId: contentId,
        spaceKey: spaceKey
    });
    const getExtensionHeight = (0, $jFkNO.useExtensionNodeParams)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const finalExtensionProviders = extensionProvidersWithLCM;
    const ssrExtensionHandlers = (0, $OCz5m.useEditorSSRExtensionHandlers)(contentId, spaceKey, finalExtensionProviders);
    const FullPageEditorComponentWrapper = isCompanyHub ? (0, $6gbpH.HubEditorWrapper) : $b56facd6a98e9621$var$FullPageEditorWrapper;
    const { canUndo: canUndo, canRedo: canRedo, undo: undo, redo: redo, activateFindReplace: activateFindReplace } = (0, $767f50cadbc92220$export$4da6e3f66c58b328)(fullPageEditorPresetAPI);
    const editorActionsProps = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? {
        canUndo: canUndo,
        canRedo: canRedo,
        undo: undo,
        redo: redo,
        activateFindReplace: activateFindReplace
    } : undefined;
    const allowInlineComments = isEmbeddedConfluence ? hasInlineComments : true;
    const shouldHideCommentsInEmbeddedLivePage = isLivePage && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const allowPageComments = !isEmbeddedConfluence || hasPageComments && !shouldHideCommentsInEmbeddedLivePage;
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled, isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    const { hasModernHeader: hasModernHeader, hideHelpButton: hideHelpButton } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const showEmbeddedModernHeader = isEmbeddedConfluence ? hasModernHeader : !isEmbeddedConfluence;
    const shouldHideHelpWidget = isEmbeddedConfluence && (hideHelpButton || isLivePage && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true));
    const showHelpWidget = !shouldHideHelpWidget;
    const shouldHideLiveDocEmbeddedEditorToolbar = isLivePage && isEmbeddedConfluence && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const setSsrRenderMark = (0, $42omo.useCallback)(()=>{
        (0, $1fcefd278c33801b$export$5dc6b08aaa4bcf54)({
            segmentName: $b56facd6a98e9621$var$SSR_TRACE_SEGMENT_NAME,
            startTimestamp: firstRenderStartTimestampRef.current,
            endTimestamp: performance.now()
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
        name: "full-page-editor-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f9dc71ade1ee2d5f$export$b5e4a2fe6178c584), {
        editorApi: fullPageEditorPresetAPI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE9mB.EditorContextPanelContextProvider), {
        editorAPI: fullPageEditorPresetAPI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40pD8.ClassificationModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dWbBL.EditorContextContentCreationPanelWrapper), {
        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
        collabEditInitialized: collabEditInitialized,
        contentId: contentId,
        contentType: contentType,
        draftShareId: draftShareId,
        editorActions: editorActions,
        hideSpinner: hideSpinner,
        isUnpublishedDraft: isUnpublishedDraft,
        renderPanel: !shouldRenderPreview,
        showSpinner: showSpinner,
        title: title
    }, ({ isContentCreationPanelOpen: isContentCreationPanelOpen, contentCreationPanelMode: contentCreationPanelMode, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, beforeUpdateRequest: beforeUpdateRequest, postUpdateRequest: postUpdateRequest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2HGN8.ContentAppearanceContextProvider), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2HGN8.ContentAppearanceContextConsumer), null, ({ contentAppearance: contentAppearance })=>{
            let appearance = $b56facd6a98e9621$var$getContentAppearance(contentAppearance, draftAppearance);
            if (isCompanyHub) // Company Hub editors no longer have the option of changing page width,
            // as content topper is removed. For users who had previously set Company
            // Hub page to 'full-width' and can no longer change it back, we force it to
            // 'full-page' to fix unexpected layout issues and allow editors to
            // set the width on individual extension instances.
            appearance = 'full-page';
            const referentialityContext = (0, $6dTPw.getReferentialityContext)(createAnalyticsEvent, contentId, appearance, ssrExtensionHandlers, extensionRendererViewOptions, getExtensionHeight); // IMPORTANT: If you change the code below, please also update the
            // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/placeholderPluginOptions/placeholderPluginOptions.ts
            const placeholderText = !viewMode && $b56facd6a98e9621$var$_getPlaceholderText({
                featureFlags: featureFlags,
                isAIEnabledForContent: isAIEnabledForContent
            });
            const metaKey = (0, $4tOXV.isMac)() ? "\u2318" : 'Ctrl';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FullPageEditorComponentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c06us.BlankPageQuickActionsProvider), {
                spaceKey: spaceKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f6xB.HeadingLinksStyleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btQhd.EditorWrapper), wrapperProps, isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $73d7c23c9a6a572e$export$b112826b6cf719c1), {
                onClickPublish: onClickPublish,
                onClickPreview: onPreviewClicked,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                publishButtonDisabled: false,
                title: title ?? draftTitle,
                userViewingPreview: false,
                isUnpublishedDraft: false,
                contentType: contentType,
                shouldShowWorldIcon: false,
                shouldShowFooterButtons: false,
                isConvertToPageDialog: true,
                onHoverPublish: onHoverPublish
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4f7d3262c48387ee$export$c0bc8bbccc993b75), {
                contentId: contentId,
                contentType: contentType,
                isUnpublishedDraft: isUnpublishedDraft,
                hasEditPermission: hasEditPermission,
                flags: flags,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                saveDraft: saveDraft
            })), (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $642dd5941c63cbaa$export$4a2ff2a211b229b0), {
                isLivePage: isLivePage,
                isEmbeddedConfluence: isEmbeddedConfluence,
                viewMode: viewMode,
                spaceKey: spaceKey,
                editorFullPagePresetAPI: fullPageEditorPresetAPI,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                contentId: contentId,
                version: version,
                isShowingOfflineBanner: collabEditInternetLost
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isLivePage && (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page"
            })), showEmbeddedModernHeader && !shouldHideLiveDocEmbeddedEditorToolbar && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3o3i5.EditorObjectHeaderContextProvider), {
                value: {
                    saveDraft: saveDraft,
                    navigateOnClose: navigateOnClose,
                    triggerAnalyticsEvent: triggerAnalyticsEvent,
                    version: version,
                    editorActions: editorActions,
                    title: title,
                    onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                    isContentCreationPanelOpen: isContentCreationPanelOpen,
                    contentCreationPanelMode: contentCreationPanelMode,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    showRevertDialog: showRevertDialog,
                    onPreviewClicked: onPreviewClicked,
                    hasEditPermission: hasEditPermission,
                    isPublishingContent: isPublishingContent,
                    userOffline: userOffline,
                    forceDisabled: forceDisabled,
                    editorTitle: title ?? draftTitle,
                    collabLimitReached: collabLimitReached,
                    collabEditConnected: collabEditConnected,
                    onClickPublish: onClickPublish,
                    shouldRenderPreview: shouldRenderPreview,
                    isUnpublishedDraft: isUnpublishedDraft,
                    validatePageAndOpenModal: validatePageAndOpenModal,
                    ...editorActionsProps,
                    viewMode: viewMode,
                    onHoverPublish: onHoverPublish
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
                name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JJ6wk.ContentTypesHeader), {
                contentId: contentId
            }), isLivePage && (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $127f29c854fd1c7d$export$97f4d50961f98e6a), {
                spaceKey: spaceKey,
                editorActions: editorActions,
                collabEditState: collabEditState,
                title: title ?? draftTitle,
                forceDisabled: forceDisabled,
                userOffline: userOffline,
                contentId: contentId,
                contentType: contentType,
                isContentCreationPanelOpen: isContentCreationPanelOpen,
                isUnpublishedDraft: isUnpublishedDraft,
                onClickPublish: onClickPublish,
                onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                onPreviewClicked: onPreviewClicked,
                saveDraft: saveDraft,
                collabLimitReached: collabLimitReached,
                showRevertDialog: showRevertDialog,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                isPublishingContent: isPublishingContent,
                isSingleUserSession: isSingleUserSession,
                navigateOnClose: navigateOnCloseStable,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                shouldRenderPreview: shouldRenderPreview,
                shouldShowRecentSpotlight: shouldShowRecentSpotlight,
                checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                hasEditPermission: hasEditPermission,
                editorDisabled: disabled,
                isTitleFocused: isTitleFocused,
                viewMode: viewMode,
                contentClassificationMetadata: contentClassificationMetadata,
                isLivePage: isLivePage,
                requestToEditContent: requestToEditContent,
                hasRequestedEditPermission: hasRequestedEditPermission,
                ellipsisEditorActions: editorActionsProps
            })), !shouldRenderPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $79befcd2c8d3c320$export$8626b7a3aacc0076), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uySb.EditorDisplayWrapper), {
                "data-testid": "full-page-editor-style",
                isHidden: shouldRenderPreview,
                isEditorActionBarRendered: true,
                isToolbarAifcEnabled: (0, $9wGTI.fg)('aifc_create_enabled')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5b566a57f88868ac$export$6d9f0d80d291faa5), {
                editorType: "next",
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                collabEditState: collabEditState,
                collabEditInternetLost: collabEditInternetLost,
                collabEditConnectionTimedOut: collabEditConnectionTimedOut,
                willEditorDisable: !editorDisabled,
                contentType: contentType,
                contentId: contentId,
                spaceId: spaceId,
                fullPageEditorPresetAPI: fullPageEditorPresetAPI,
                isViewMode: viewMode || false,
                isLivePage: isLivePage,
                isDesktop: isDesktop
            }), showHelpWidget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $022566d7a48da434$export$4d07d1c131526670), {
                contentId: contentId,
                isContentCreationPanelOpen: isContentCreationPanelOpen,
                onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                editorActions: editorActions,
                isShowingOfflineBanner: collabEditInternetLost,
                version: version,
                spaceKey: spaceKey,
                editorApi: fullPageEditorPresetAPI,
                handleTitleChange: handleTitleChange
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iPdtV.PageLoadMark), {
                name: "onBeforeEditor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
                contentId: contentId,
                mode: (0, $5kjCz.EDITOR),
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNYtG.PageCommentsPubSubHandler), {
                contentId: contentId,
                contentType: contentType
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bRTjQ.EditorAnalyticsListener), {
                contentId: contentId,
                contentType: contentType,
                source: "pageAndBlogEditor",
                collabService: (0, $gkIgp.CollabServiceProperty).NCS,
                onProseMirrorRendered: onProseMirrorRendered,
                isGuest: isExternalCollaborator
            }, // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            proseMirrorRenderedData && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hd53J.CommentsDataBackgroundLoader), {
                key: `CommentsDataBackgroundLoader-${contentId}`,
                contentId: contentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b433f129bb94645$export$5acade271146d69c), {
                value: {
                    forceDisabled: forceDisabled,
                    userOffline: userOffline,
                    collabLimitReached: collabLimitReached,
                    contentId: contentId,
                    contentType: contentType,
                    isContentCreationPanelOpen: isContentCreationPanelOpen,
                    isUnpublishedDraft: isUnpublishedDraft,
                    onClickPublish: onClickPublish,
                    onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                    onPreviewClicked: onPreviewClicked,
                    saveDraft: saveDraft,
                    spaceKey: spaceKey,
                    showRevertDialog: showRevertDialog,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    isPublishingContent: isPublishingContent,
                    isSingleUserSession: isSingleUserSession,
                    triggerAnalyticsEvent: triggerAnalyticsEvent,
                    navigateOnClose: navigateOnCloseStable,
                    title: title,
                    editorActions: editorActions,
                    disabled: disabled || collabLimitReached,
                    isTitleFocused: isTitleFocused,
                    collabEditState: collabEditState,
                    shouldRenderPreview: shouldRenderPreview,
                    shouldShowRecentSpotlight: shouldShowRecentSpotlight,
                    flags: flags,
                    createAnalyticsEvent: createAnalyticsEvent,
                    hasEditPermission: hasEditPermission,
                    ellipsisEditorActions: editorActionsProps
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82bb8752b1a17b39$export$f7b2b60e23c443f6), {
                value: {
                    contentComponentsTitle: title ?? draftTitle ?? cachedTitle,
                    contentComponentsDisabled: disabled || collabLimitReached || !collabEditInitialized || isDraftLockedForEditing,
                    isDraftLockedForEditing: isDraftLockedForEditing,
                    handleTitleChange: handleTitleChange,
                    breadcrumbsClickHandler: handleBreadcrumbsClick,
                    beforeUpdateRequest: beforeUpdateRequest,
                    postUpdateRequest: postUpdateRequest
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKSlH.MultiMacroQueryContainer), {
                contentId: contentId,
                featureFlags: featureFlags,
                readFragmentInterop: readFragmentInterop,
                contentRendererMode: (0, $5kjCz.EDITOR)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $36be47a9ed41f8db$export$6124ca97c5c9fe4d), {
                contentId: contentId,
                flags: flags,
                isLivePage: isLivePage,
                isMentionsNotificationsEnabled: isLivePage || isClassicMentionsNotificationsEnrolled,
                editorActions: editorActions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9jl6v.InlineCommentsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNzRA.ObjectCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fMO7O.GuestMentionsNotificationsWrapper), {
                dialogs: dialogs,
                flags: flags
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lmEhP.EditorLinkingFeatures), {
                options: $b56facd6a98e9621$var$CARD_OPTIONS,
                viewMode: viewMode,
                isLivePage: isLivePage
            }, (editorLinkingProps)=>{
                // TODO: fix me. ignored to get an unrelated refactor in: React Hooks must be called in a React function component or a custom React Hook function
                /* eslint-disable react-hooks/rules-of-hooks */ const mainButtonsContext = (0, $6b433f129bb94645$export$87f05b83083ffee2)(); /* eslint-enable react-hooks/rules-of-hooks */ 
                const primaryToolBarComponent = !showEmbeddedModernHeader && !shouldHideLiveDocEmbeddedEditorToolbar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02a52aafb1fafdd7$export$170e4ca3217957a2), {
                    ...mainButtonsContext,
                    allowInlineComments: allowInlineComments,
                    allowPageComments: allowPageComments
                }) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jXhAV.QuickReload), {
                    contentId: contentId,
                    contentType: contentType,
                    // package on what a more correct lastPollTime value would be.
                    lastPollTime: Date.now(),
                    pageMode: isLivePage ? (0, $fSC8h.PageMode).LIVE : (0, $fSC8h.PageMode).EDITOR,
                    showCommentsPanel: showCommentsPanel
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                    markErrorCriticalInSSR: true,
                    attribution: (0, $3IBnw.Attribution).EDITOR_CORE
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $639a5b7d5146574b$export$3b07c6dfbdf7e5bd), {
                    onSSRMeasure: $b56facd6a98e9621$var$recordSSRMeasureWithPrefix,
                    setEditorAPI: setEditorApi,
                    // ComposableEditor
                    referentialityContext: referentialityContext,
                    editorPluginAIOptions: editorPluginAIOptions,
                    aiGlobalOptIn: aiGlobalOptIn,
                    editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers,
                    ...extensionOptions,
                    extensionProviders: extensionProvidersWithLCM,
                    getExtensionHeight: getExtensionHeight,
                    allowConfluenceInlineComment: allowInlineComments,
                    allowFindReplace: !collabEditInternetLost && findReplaceOptions,
                    defaultValue: draftBody ?? undefined,
                    elementBrowser: elementBrowser,
                    media: mediaOptions,
                    mention: mentionProps,
                    placeholder: placeholderText && intl.formatMessage(placeholderText, {
                        key: metaKey
                    }),
                    waitForMediaUpload: true,
                    __rendererExtensionOptions: extensionRendererViewOptions,
                    appearance: appearance ?? 'full-page',
                    contentMode: (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'forceAll', true) ? 'compact' : editorContentMode,
                    disabled: isTitleFocused || editorDisabled || collabLimitReached,
                    onChange: handleDocChange,
                    shouldFocus: !!title && shouldFocusEditor,
                    onEditorReady: onEditorReady,
                    activityProvider: activityProvider,
                    annotationProviders: allowInlineComments ? annotationProviderOptions : undefined,
                    autoformattingProvider: autoformattingProvider,
                    collabEditProvider: collabEditProvider,
                    collabEdit: collabEdit,
                    contextIdentifierProvider: contextIdentifierProvider,
                    emojiProvider: emojiProvider,
                    mentionProvider: mentionProvider,
                    searchProvider: searchProvider,
                    taskDecisionProvider: taskDecisionProvider,
                    syncedBlockProvider: syncedBlockProvider,
                    contentComponents: $b56facd6a98e9621$var$_getContentComponents({
                        contentId: contentId,
                        debounceTitleChangeUpdates: debounceTitleChangeUpdates,
                        focusEditor: focusEditor,
                        onFocusChanged: onFocusChanged,
                        userOffline: userOffline,
                        linkCreation: linkCreation === 'true',
                        editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers,
                        isAdminHubAIEnabled: isAdminHubAIEnabled,
                        isAIEnabledForContent: isAIEnabledForContent,
                        isAIEarlyAccessEnabled: isAIEarlyAccessEnabled,
                        hideSpinner: hideSpinner,
                        templateSuggestionsRef: templateSuggestionsRef,
                        templateButtonRef: templateButtonRef,
                        editorActions: editorActions,
                        isTitleFocused: isTitleFocused,
                        disabled: disabled,
                        viewMode: viewMode,
                        contentClassificationMetadata: contentClassificationMetadata,
                        appearance: appearance,
                        spaceKey: spaceKey,
                        title: title,
                        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
                        showSpinner: showSpinner,
                        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                        isUnpublishedDraft: isUnpublishedDraft,
                        featureFlags: featureFlags,
                        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
                        showBlankPageQuickActions: showBlankPageQuickActions,
                        isLivePage: isLivePage,
                        version: version,
                        isEditorEmpty: isEditorEmpty,
                        shouldRenderPreview: shouldRenderPreview,
                        isEditorAnnotationProviderManagersEnabled: (0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager'),
                        editorApi: fullPageEditorPresetAPI,
                        contentType: contentType,
                        onTitleChange: onTitleChange,
                        loadingPriority: loadingPriority,
                        isRovoButtonEnabled: isRovoButtonEnabled,
                        editorSessionId: editorSessionId,
                        editorActionsProps: editorActionsProps,
                        isSeamlessTransitionInProgress: (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning,
                        hasByLineContributors: hasByLineContributors,
                        hasByLineExtensions: hasByLineExtensions,
                        hasReactions: hasReactions,
                        hasPageComments: hasPageComments,
                        isEmbeddedConfluence: isEmbeddedConfluence,
                        isTemplateBrowserEnabled: isTemplateBrowserEnabled,
                        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
                        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
                        isRovoLLMEnabled: isRovoLLMEnabled,
                        ...isRovoLLMEnabled && (0, $6mKj3.isExperimentEnabled)('cwr_blank_object_experiment') && {
                            customPlaceholderOverride: customPlaceholderOverride,
                            onCreateWithRovoClick: handleCreateWithRovo,
                            shouldShowCreateWithRovoExperience: shouldShowCreateWithRovoExperience,
                            onPromptMouseEnter: onPromptMouseEnter,
                            onPromptMouseLeave: onPromptMouseLeave,
                            onPromptClick: onPromptClick,
                            onPromptSubmit: onPromptSubmit,
                            onDismissCwr: onDismissCwr,
                            hasSubmittedCwrPrompt: hasSubmittedCwrPrompt,
                            onInputEmpty: onInputEmpty
                        }
                    }),
                    contextPanel: $b56facd6a98e9621$var$_getContextPanelComponent(),
                    featureFlags: fullPageEditorFeatureFlags,
                    performanceTracking: performanceTrackingOptions,
                    ...editorLinkingProps,
                    viewMode: viewMode || isDraftLockedForEditing ? 'view' : 'edit',
                    __isRemixHidden: !isRovoLLMEnabled,
                    __isRovoLLMEnabled: isRovoLLMEnabled,
                    __remixDisabledReason: remixDisabledReason,
                    __livePage: isLivePage,
                    isEmbeddedConfluence: isEmbeddedConfluence,
                    flags: flags,
                    primaryToolbarComponents: primaryToolBarComponent,
                    hasEditPermission: hasEditPermission,
                    requestToEditContent: requestToEditContent,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    getHeadingLinkPath: getHeadingLinkPath,
                    contentId: contentId,
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    snippetExtensionList: snippetExtensionList,
                    isAIEnabledForContent: isAIEnabledForContent,
                    showEmbeddedModernHeader: showEmbeddedModernHeader,
                    isCompanyHub: isCompanyHub,
                    syncedBlockEventHandlers: syncedBlockEventHandlers
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dLc9m.EditorCommentShortcutListener), {
                    contentId: contentId,
                    viewMode: viewMode,
                    editorApi: fullPageEditorPresetAPI
                }), proseMirrorRenderedData !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8HrX3.TaskScrollComponent), null));
            }))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beK3g.Spinner), {
                shouldShowSpinner: shouldShowSpinner || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning,
                isOverlayTransparent: !shouldShowSpinner && (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AIOptInModal, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fE1Ao.EditorRevertDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                cancelDebouncedSaveDraft: cancelDebouncedSaveDraft
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1uFh.OnboardingEditorModalPrompt), {
                onTitleChange: onTitleChange,
                handlePublish: ()=>onPublish({
                        suppressNotifyWatchers: false
                    })()
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $11b8024921ea2f1a$export$a1cd66d9f8e156b1), {
                contentId: contentId,
                spaceKey: spaceKey,
                setCheckIfConditionPreventingPublish: assignConditionalFunction
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cvzKy.PageLoadWrapper), {
                disabled: disabled,
                contentId: contentId,
                isCreate: isUnpublishedDraft,
                proseMirrorRenderedData: proseMirrorRenderedData,
                editSource: editSource,
                extractedCollabEditProvider: extractedCollabEditProvider,
                isLivePage: isLivePage,
                customPerfData: customPerfData,
                draftBody: draftBody
            }), shouldRenderPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
                value: rendererExtensionOptions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGaEh.PreviewPageComponent), {
                contentId: contentId,
                spaceKey: spaceKey,
                stagedContentId: stagedContentId,
                stagedSpaceKey: stagedSpaceKey,
                contentType: contentType,
                contentAppearance: contentAppearance,
                title: title,
                editorActions: editorActions,
                showTemplateVariablesInPreview: true,
                changeEditorMode: ()=>setShouldRenderPreview(false),
                Renderer: (0, $e8Lxy.PageContentRenderer),
                isPageContentRenderer: true,
                editorType: (0, $lWVgZ.EditorTypes).NCS,
                previewAsBlog: previewAsBlog,
                contentClassificationMetadata: contentClassificationMetadata
            })) : null, contentType === 'page' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmBjr.ConvertToLivePageFlag), null), (0, $6mKj3.expVal)('confluence_modernized_move_dialog', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lfmjq.MovePageSuccessFlag), null), !isEmbeddedConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bK3oZ.RovoBridgeCommandListener), {
                contentId: contentId,
                contentLocation: "global",
                editorAPI: fullPageEditorPresetAPI,
                setEditorDisabled: setForceDisabled,
                mediaProvider: mediaOptions?.provider,
                onTitleChange: hasSubmittedCwrPrompt ? handleTitleChange : undefined,
                onStreamEnd: onCwrStreamEnd,
                isPreviewMode: shouldRenderPreview
            }))), $b56facd6a98e9621$var$_getEditorContextConnectionsPanel({
                referentialityContext: referentialityContext,
                connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId,
                setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
                closeConnectionsPanel: closeConnectionsPanel
            }), // This FF controls if the right rail config panel is available in when editing a page
            isSmartButtonAllowed ? $b56facd6a98e9621$var$_getEditorContextSmartButtonConfigPanel({
                smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId,
                closeSmartButtonConfigPanel: closeSmartButtonConfigPanel,
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f04c510354797dd3$export$7a4297a73e39e6ad), {
                localId: activeNodeLocalId || '',
                closeSelf: closeConfigPanel,
                editorApi: fullPageEditorPresetAPI || undefined,
                contentId: contentId,
                upsellModalSource: upsellModalSource,
                setUpsellModalSource: setUpsellModalSource
            })));
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a00e1ed200f6db86$export$d1f7cc0755451204), {
        contentId: contentId,
        contentType: contentType,
        isLivePage: isLivePage,
        isUnpublishedDraft: isUnpublishedDraft,
        title: title,
        draftTitle: draftTitle,
        isAIEnabledForContent: isAIEnabledForContent,
        handleTitleChange: handleTitleChange,
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        extractedCollabEditProvider: extractedCollabEditProvider,
        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
        isDocumentActive: isDocumentActive,
        focusedCommentId: focusedCommentId,
        replyToCommentId: replyToCommentId,
        handleUseFocusedCommentGQLError: handleUseFocusedCommentGQLError,
        annotationStateRef: annotationStateRef,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache,
        updateUnresolvedInlineCommentFn: updateUnresolvedInlineCommentFn,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        proseMirrorRenderedData: proseMirrorRenderedData,
        showBlankPageQuickActions: showBlankPageQuickActions,
        hasSubmittedCwrPrompt: hasSubmittedCwrPrompt,
        shouldShowCreateWithRovoExperience: shouldShowCreateWithRovoExperience,
        isRovoLLMEnabled: isRovoLLMEnabled,
        onSpaceKeyPressed: handleCreateWithRovo,
        flags: flags,
        intl: intl,
        disabled: disabled,
        isTitleFocused: isTitleFocused,
        shouldRenderPreview: shouldRenderPreview,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError,
        removeCommentQueryParams: removeCommentQueryParams,
        setEditorAnnotations: setEditorAnnotations,
        getSortedMarkerRefs: (0, $aHcFH.getSortedMarkerRefs),
        setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
        editorAnnotationsRef: editorAnnotationsRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hwk5r.DocumentEditPageTitle), {
        contentType: contentType,
        isCreatingNew: isUnpublishedDraft,
        spaceKey: spaceKey,
        title: title,
        isLivePage: isLivePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8ea506e3a40865e$export$28f25e906763db1e), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI
    }), printLockout, undefined, shouldShowSpotlight && newLinkTypes.length > 0 && (0, $9wGTI.fg)('link-paste-spotlight-experiment-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46e670f6dbd146ec$export$83ad660b287906ed), {
        detectedLinks: detectedLinks,
        newLinkTypes: newLinkTypes,
        newLinks: newLinks,
        onClose: closeSpotlight,
        cloudId: cloudId,
        atlassianAccountId: userId ?? null,
        analyticsContext: "editor"
    }), (0, $6mKj3.expValEquals)('confluence_move_to_personal_space_nudge', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $14ugT.MoveToPersonalSpaceFlagTrigger), {
        contentId: contentId,
        contentType: contentType,
        isLivePage: isLivePage,
        spaceKey: spaceKey
    }));
};
const $b56facd6a98e9621$export$63318eb7b01b69fa = (0, $ea0f0e1bfeeed9fe$export$72f7c3354b160bdb)((0, $3IZob.withDocChangeContext)($b56facd6a98e9621$var$withEditorContext((0, $awIbt.withEditorActions)((0, $7aRa9.withFlags)((0, $inDu6.withDialogs)((0, $ecUYt.withPageTreeStateUpdater)($b56facd6a98e9621$var$FullPageEditorComponentImpl)))))));
module.exports["FullPageEditorComponent"] = $b56facd6a98e9621$export$63318eb7b01b69fa;

});

parcelRegister("bre0g", function(module, exports) {

var $2cmfr = parcelRequire("2cmfr");

class $1d9210071da756d7$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $2cmfr.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $1d9210071da756d7$export$2e2bcd8739ae039;

});

parcelRegister("4tOXV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $1Whri = parcelRequire("1Whri");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent;
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_1rjcv77o _1e0c1txw _4cvr1h6o",
    base: "_2rko12b0 _1rjcv77o _18zru2gc _1e0c1o8l _18u0v77o _2hwxv77o",
    contentBefore: "_18u01b66 _2hwxze3t",
    darkBackground: "_bfhk18j9",
    lightBackground: "_bfhkysee"
};
const $05ef07480c610d29$var$i18n = (0, $aXWIB.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $aXWIB.useIntl)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $gdv5Z.default);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $1Whri.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $aXWIB.useIntl)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $42omo.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("3y1ko", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
        if (res.ok) enabled = await res.text() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await $4c06255176f911bc$export$632d1cf1f5c6210f();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("hjhY1"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("2OyAA"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("6PB7O"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("borly"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelFilterMenu
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = (0, $9wGTI.fg)('confluence_embed_hide_close_button') && allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo') && (0, $9wGTI.fg)('jira_linked_confluence_doc_rovo_nudge_gate');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("hpNab", function(module, exports) {

var $kFwgS = parcelRequire("kFwgS");


var $9tQM5 = parcelRequire("9tQM5");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = ()=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
				When opening a new preview panel, if the current panel is of the same type we don't
				want to close the panel, but rather swap out the content. If the panel types don't match
				we close the current panel and open the new one.
				ex: A Goals panel is already open, and user tries to open a different Goals panel.
				Parent Products must pass their preview panel close functions to the Preview Panel provider
				via the `onPreviewPanelClose` prop.
			*/ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)();
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        ...initialPanel && (0, $dh538.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ()=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("gczDe", function(module, exports) {

var $cVw8q = parcelRequire("cVw8q");

let $d31fe98ca852fa54$var$rendererEmitter = undefined;
const $d31fe98ca852fa54$export$894d051c63add88c = ()=>{
    if (!$d31fe98ca852fa54$var$rendererEmitter) $d31fe98ca852fa54$var$rendererEmitter = new (0, $cVw8q.AnnotationUpdateEmitter)();
    return $d31fe98ca852fa54$var$rendererEmitter;
};
module.exports["getRendererAnnotationEventEmitter"] = $d31fe98ca852fa54$export$894d051c63add88c;

});

parcelRegister("cVw8q", function(module, exports) {

var $5rDjV = parcelRequire("5rDjV");


var $fdq1c = parcelRequire("fdq1c");

class $088b66af3518f6bb$export$7cc60aa9ef845515 extends (0, $5rDjV.EventEmitter) {
    on(event, listener) {
        return super.on(event, listener);
    }
    off(event, listener) {
        return super.removeListener(event, listener);
    }
}
function $088b66af3518f6bb$export$3238f27f6e07aed2() {
    return new (0, $fdq1c.SharedAnnotationManager)();
}
module.exports["AnnotationUpdateEmitter"] = $088b66af3518f6bb$export$7cc60aa9ef845515;
module.exports["createAnnotationManager"] = $088b66af3518f6bb$export$3238f27f6e07aed2;

});

parcelRegister("fdq1c", function(module, exports) {

var $5rDjV = parcelRequire("5rDjV");

class $629fc281f4644e5a$export$c7aecf09b7cf478f {
    setPreemptiveGate(handler) {
        this.preemptiveGate = handler;
        return this;
    }
    checkPreemptiveGate() {
        if (this.activePreemptiveGate) // If the preemptive gate check already in flight then just return the promise
        // and don't call the preemptive gate again.
        // This is to prevent multiple calls to the preemptive gate creating multiple
        // promises that will resolve at different times.
        return Promise.resolve(this.activePreemptiveGate);
        const gate = this.activePreemptiveGate = this.preemptiveGate().then((result)=>{
            this.activePreemptiveGate = undefined;
            return result;
        });
        return gate;
    }
    onDraftAnnotationStarted(handler) {
        this.emitter.on('draftAnnotationStarted', handler);
        return this;
    }
    offDraftAnnotationStarted(handler) {
        this.emitter.off('draftAnnotationStarted', handler);
        return this;
    }
    onAnnotationSelectionChange(handler) {
        this.emitter.on('annotationSelectionChanged', handler);
        return this;
    }
    offAnnotationSelectionChange(handler) {
        this.emitter.off('annotationSelectionChanged', handler);
        return this;
    }
    emit(event) {
        this.emitter.emit(event.name, 'data' in event ? event.data : undefined);
        return this;
    }
    hook(method, handler) {
        this.hooks.set(method, handler);
        return this;
    }
    unhook(method, handler) {
        if (!this.hooks.has(method) || this.hooks.get(method) !== handler) return this;
        this.hooks.delete(method);
        return this;
    }
    allowAnnotation() {
        const fn = this.hooks.get('allowAnnotation');
        if (!fn) return false;
        try {
            return fn();
        } catch  {
            return false;
        }
    }
    startDraft() {
        const fn = this.hooks.get('startDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearDraft() {
        const fn = this.hooks.get('clearDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    applyDraft(id) {
        const fn = this.hooks.get('applyDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    getDraft() {
        const fn = this.hooks.get('getDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationSelected(id, isSelected) {
        const fn = this.hooks.get('setIsAnnotationSelected');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            // NOTE: The hook needs to manage the firing the annotationSelectionChanged event when a change is made. This is
            // because the hook is responsible for the state of the selection. The manager is not responsible for the state of
            // the selection.
            return fn(id, isSelected);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationHovered(id, isHovered) {
        const fn = this.hooks.get('setIsAnnotationHovered');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id, isHovered);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearAnnotation(id) {
        const fn = this.hooks.get('clearAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    constructor(){
        /**
     * This is the event emitter that is used to emit events from the manager. It is used to communicate with
     * other parts of the application.
     */ this.emitter = new (0, $5rDjV.EventEmitter)();
        /**
     * This is the map of hooks that can be added to the manager. Hooks are a 1:1 mapping of methods that can be
     * called on the manager. They are used to extend the functionality of the manager.
     */ this.hooks = new Map();
        this.preemptiveGate = ()=>Promise.resolve(true);
        this.activePreemptiveGate = undefined;
    }
}
module.exports["SharedAnnotationManager"] = $629fc281f4644e5a$export$c7aecf09b7cf478f;

});

parcelRegister("gfqXk", function(module, exports) {

var $cVw8q = parcelRequire("cVw8q");

let $d97010bba34874b5$var$editorEmitter = undefined;
const $d97010bba34874b5$export$60921b94e11f8e19 = ()=>{
    if (!$d97010bba34874b5$var$editorEmitter) $d97010bba34874b5$var$editorEmitter = new (0, $cVw8q.AnnotationUpdateEmitter)();
    return $d97010bba34874b5$var$editorEmitter;
};
module.exports["getEditorAnnotationEventEmitter"] = $d97010bba34874b5$export$60921b94e11f8e19;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("htsj6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");

const $feac3235d890b171$export$50af12b79850199d = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, options);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, options);
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<9218c904bebb7f2af51e7e5ebc163850>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $42omo = parcelRequire("42omo");


var $cVw8q = parcelRequire("cVw8q");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$4162754b616020bc = 2000;
const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $42omo.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    commentSidebarContext: null,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $42omo.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider = ({ children: children, value: value })=>{
    if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: value
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $42omo.createContext)({
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    setCommentSidebarContext: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{}
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const [selectionProps, setSelectionProps] = (0, $42omo.useState)(null);
    const [hoverProps, setHoverProps] = (0, $42omo.useState)(null);
    const [viewProps, setViewProps] = (0, $42omo.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $42omo.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $42omo.useState)(null);
    const [showCreateComponent, setShowCreateComponent] = (0, $42omo.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $42omo.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $42omo.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $42omo.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $42omo.useState)();
    const [commentSidebarContext, setCommentSidebarContext] = (0, $42omo.useState)(null);
    const [prevContentId, setPrevContentId] = (0, $42omo.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const annotationManager = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cVw8q.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $42omo.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $42omo.useState)(null);
    // Track active MutationObserver and timeout for cleanup on unmount
    const activeObserverRef = (0, $42omo.useRef)(null);
    const activeTimeoutRef = (0, $42omo.useRef)(null);
    /**
	 * Waits for an annotation element to appear in the DOM using MutationObserver,
	 * then emits annotation selection events. If element doesn't appear within 2 seconds,
	 * fails the VIEW_INLINE_COMMENT_EXPERIENCE.
	 */ const waitForAnnotationElementAndEmit = (0, $42omo.useCallback)((annotationId, emitter)=>{
        // Clean up any existing observer/timeout before creating new ones
        if (activeObserverRef.current) activeObserverRef.current.disconnect();
        if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
        // Use MutationObserver to wait for element to appear in DOM
        activeObserverRef.current = new MutationObserver(()=>{
            const element = document.getElementById(annotationId);
            if (element) {
                if (activeObserverRef.current) activeObserverRef.current.disconnect();
                if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
                activeObserverRef.current = null;
                activeTimeoutRef.current = null;
                // Emit annotation events and check if listeners exist
                if (emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: element
                })) {
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    setNewlyCreatedAnnotationId(annotationId);
                } else // No listeners registered - fail the experience
                experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Failed to emit annotation click')
                });
            }
        });
        // Observe the renderer wrapper for child additions (fallback to document.body for safety)
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper') || document.body;
        activeObserverRef.current.observe(rendererWrapper, {
            childList: true,
            subtree: true
        });
        // Fallback: If element doesn't appear within timeout, fail the experience
        // This almost always happens due to super slow re-renders (slow client on large page)
        activeTimeoutRef.current = setTimeout(()=>{
            if (activeObserverRef.current) activeObserverRef.current.disconnect();
            activeObserverRef.current = null;
            activeTimeoutRef.current = null;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`Annotation element not found in DOM after ${$d99a6317060f344e$export$4162754b616020bc}ms`)
            });
        }, $d99a6317060f344e$export$4162754b616020bc);
    }, [
        experienceTracker,
        setNewlyCreatedAnnotationId
    ]);
    // Cleanup observer and timeout on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (activeObserverRef.current) {
                activeObserverRef.current.disconnect();
                activeObserverRef.current = null;
            }
            if (activeTimeoutRef.current) {
                clearTimeout(activeTimeoutRef.current);
                activeTimeoutRef.current = null;
            }
        };
    }, []);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $42omo.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $42omo.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setCommentSidebarContext(null);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) {
            resetProviderState();
            if ((0, $6mKj3.expValEquals)('confluence_fe_view_inline_comment_page_jump_fix', 'isEnabled', true)) // Deselect any currently selected annotations
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        }
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
	 * NOTE: This function will not be calling setShowCreateComponent because it's
	 *       consumers will not be refreshing themselves with new selectionOptions.
	 *       It will now be the responsibility of the consumers of this function to call
	 *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
	 */ const setSelectionOptionsForCreateEditor = (0, $42omo.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // Narrow pageClass to 'renderer' | 'editor' for the experience attributes
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage') ? pageClassAttr : 'renderer',
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes ?? {}
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            if (!selectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            result = selectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        const ancestorNodeTypes = result?.ancestorNodeTypes ?? [];
        const alphabeticalAncestorNodeTypes = [
            ...ancestorNodeTypes
        ].sort();
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            ancestorNodeTypes: ancestorNodeTypes,
            alphabeticalAncestorNodeTypes: alphabeticalAncestorNodeTypes,
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            setSelectionOptions({
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            });
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $42omo.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        setCommentSidebarContext('create');
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
        // This provides more reliable annotation application, matching the editor implementation
        if (rendererActions && selectionOptions?.step) {
            const step = selectionOptions.step;
            // Extract position from step - use pos if available, otherwise use from/to
            const position = selectionOptions.pos ? {
                to: selectionOptions.pos,
                from: selectionOptions.pos
            } : {
                to: step.to,
                from: step.from
            };
            const annotationResult = rendererActions.applyAnnotation(position, {
                annotationId: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
            });
            if (annotationResult && annotationResult.doc) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                waitForAnnotationElementAndEmit(annotationId, emitter);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // Fallback to original onCreate method
            // Since we generated the uuid ourselves, we need to replace the document generated with
            // the annotationId that we received from the backend so things line up correctly
            result = selectionProps.onCreate(annotationId);
            if (result) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                waitForAnnotationElementAndEmit(annotationId, emitter);
            } else throw new Error('Error ocurred when applying the step to the active document');
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions,
        waitForAnnotationElementAndEmit
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            commentSidebarContext: commentSidebarContext,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        commentSidebarContext,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            setCommentSidebarContext: setCommentSidebarContext,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null)
        }), [
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        setCommentSidebarContext,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $42omo.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'tinyMCE';
    // Pass routeName to isDatabase/isWhiteboard - they will use it to avoid race conditions during SPA transitions
    if ((0, $gEtAQ.isDatabase)(routeName)) return 'database';
    if ((0, $gEtAQ.isWhiteboard)(routeName)) return 'whiteboard';
    if ((0, $gEtAQ.isSlides)(routeName)) return 'slide';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some((selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("4EKKB", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $gykrH = parcelRequire("gykrH");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");

let $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
function $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug(experienceName, experienceStage) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Legacy select debug message: ${error.message || String(error)}`,
            attributes: {
                ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                ...extraAttributes,
                experienceStage: experienceStage
            }
        });
        return;
    }
    return createInlineCommentExperienceDebug;
}
var $d671aa981fcb4da6$var$ExperienceType = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["DOCUMENT"] = "document";
    ExperienceType["DOCUMENT_WITH_PANEL"] = "documentWithPanel";
    ExperienceType["PANEL"] = "panel";
    return ExperienceType;
}($d671aa981fcb4da6$var$ExperienceType || {});
function $d671aa981fcb4da6$var$getExperienceType(entryPoint, sidebarOpenAtStart) {
    switch(entryPoint){
        case 'create-comment':
        case 'comment-navigation':
        case 'unknown:InlineComment':
            return "document";
        case 'annotation-change':
        case 'keyboard-navigation':
        case 'unknown:RendererFocus':
            return sidebarOpenAtStart ? "documentWithPanel" : "document";
        case 'sidebar':
        case 'unknown:CommentsPanelList':
            return "panel";
        default:
            return "document";
    }
}
const $d671aa981fcb4da6$export$e2b3aff7888f2745 = {
    _start: (startAttributes, _options)=>{
        if (startAttributes.pageClass === 'tinyMCE' || startAttributes.pageClass === 'database' || startAttributes.pageClass === 'whiteboard' || startAttributes.pageClass === 'slide') return;
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        const runningExperienceAttributes = experienceState?.attributes;
        if (!experienceState?.hasStopped && runningExperienceAttributes?.annotationId !== undefined && runningExperienceAttributes?.annotationId === startAttributes.annotationId) {
            // If there is an existing (unstopped) experience
            // - and that experience has an annotationId
            //   - keyboard and comment navigation will start experiences without an annotationId -- and these should be restarted on an new start
            // - and that annotationId matches the one in the startAttributes
            // we assume the experience is still active, and don't start a new one.
            // the reason we can hit this is because the selectInlineCommentCompoundExperience._start is called when there is a "select inline comment"
            // signal, and individual signals fire in different orders (sometimes they are the first signal, sometimes they are later).
            // However -- if the second signal has a clearer entry point
            // we update the entry point attribute of the existing experience.
            if (runningExperienceAttributes?.entryPoint?.startsWith('unknown') && !startAttributes.entryPoint.startsWith('unknown')) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                    entryPoint: startAttributes.entryPoint
                });
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint}`
                });
            }
            return;
        }
        if (// When the side bar is open, and the user selects a comment using the keyboard,
        // the keyboard navigation triggers a select annotation first (without an annotationId),
        // followed by the show comment start or select annotation complete (with an annotationId.
        startAttributes.entryPoint === 'unknown:CommentsPanelList' && runningExperienceAttributes?.entryPoint === 'keyboard-navigation' && runningExperienceAttributes?.annotationId === undefined) {
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                annotationId: startAttributes.annotationId
            });
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
            });
            return;
        }
        // First prepare the new attributes without modifying the global state
        // This ensures that any abort of current experiences will use their original attributes
        const newAttributes = {
            pageClass: startAttributes.pageClass,
            commentType: startAttributes.commentType,
            annotationId: 'annotationId' in startAttributes ? startAttributes.annotationId : undefined,
            entryPoint: startAttributes.entryPoint,
            version: 'single-experience'
        };
        // We check if there is a dom element with a testId of "object-sidebar-panel-body" and if so mark the
        // experience as being during a sidebar open experience.
        newAttributes.sidebarOpenAtStart = document.querySelector('[data-testid="object-sidebar-panel-body"]') !== null;
        newAttributes.experienceType = $d671aa981fcb4da6$var$getExperienceType(startAttributes.entryPoint, newAttributes.sidebarOpenAtStart);
        // If the create inline comment experience is running, we want to link the two experiences
        const createInlineCommentExperienceState = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        if (createInlineCommentExperienceState && !createInlineCommentExperienceState.hasStopped) newAttributes.linkedCompoundTaskId = createInlineCommentExperienceState.attributes?.compoundTaskId;
        // Adds a debug point to the last running experience (debug points are only added if there is a running experience)
        // Note:
        // A new experience is followed after this is fired -- so this should always be the last debug point (as the new experience will trigger a fail or abort).
        // In the case there is no running experience, the experience tracker will discard the debugPoint.
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Restarted from ${startAttributes.entryPoint} with annotationId: ${startAttributes.annotationId} (sidebarOpenAtStart: ${newAttributes.sidebarOpenAtStart})`
        });
        // Start press trace if no trace is currently active
        (0, $8Ss4E.startUFOPressTrace)((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        // Then start a new compound experience with the new attributes
        // This will abort any running experiences with the same name, but they'll keep their original attributes
        experienceTracker.start({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...newAttributes,
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
            },
            // If the annotation is not selected and comment shown to the user within 12 seconds -- we assume there has been a failure to select the inline comment
            timeout: (0, $aJPUt.ExperienceTimeout).SELECT_INLINE_COMMMENT,
            collect: (events)=>{
                const isThisCommentBeingResolved = (event)=>{
                    return event.name === (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) && event.action === 'taskStart' && (0, $gykrH.hasAttribute)(event, 'annotationId', $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId);
                };
                events.forEach((event)=>{
                    if (isThisCommentBeingResolved(event)) $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                        abortReason: 'Comment being resolved'
                    });
                });
            }
        });
        if (startAttributes.annotationId === undefined) experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with unknown annotationId`
        });
        else experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
        });
        // Now it's safe to update the global state since any aborts have already happened
        // We reset experience state if we are starting a new experience
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...newAttributes,
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
        };
        // By the time we get a task fail (particularly for timeout aborts) -- the contentId may have changed
        const originalContentId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.attributes?.contentId;
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.originalContentId = originalContentId;
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                originalContentId: originalContentId
            }
        });
    },
    debugPoint: (message, attributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
    },
    addCommonAttributes: (additionalCommonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
            ...additionalCommonAttributes
        };
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: additionalCommonAttributes
        });
    },
    abort: ({ abortReason: abortReason })=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.abort({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            reason: abortReason,
            checkForTimeout: true
        });
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
    },
    selectAnnotation: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'selectAnnotation'),
        /**
     * This is currently used to start from
     * - annotationId unknown
     *   - comment navigation
     *   - keyboard navigation
     * - annotationId known
     *   - create comment
     *   - comment sidebar comment selection
     *
     * These should be separate signals once the multi experience is deprecated.
     */ start: (startAttributes)=>{
            function isUnknownAnnotationId(startAttributes) {
                return startAttributes.entryPoint === 'keyboard-navigation' || startAttributes.entryPoint === 'comment-navigation';
            }
            if (isUnknownAnnotationId(startAttributes)) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes, {
                    annotationUnknown: true
                });
                return;
            }
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
        },
        abort: ({ abortReason: abortReason })=>{
            $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                abortReason: // @ts-ignore the abort reasons have mismatch due to type from the old multi experience. and once that is removed we can remove this cast
                abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        /**
     * Note -- the selectAnnotation does not trigger a completion of the selectInlineComment experience.
     * Instead -- the selectInlineComment experience is completed when the showComment experience completes
     * (which looks for the selected annotation as part of its completion logic).
     *
     * With the single experience -- this is less a complete and rather just an indirect signal that a selection has been made (in case it's not detected by the showComment experience).
     * When the multi selectInlineCommentCompoundExperience is deprecated, this can be renamed to indicate it's a "annotationSelection" signal rather than a "completed" signal.
     */ complete: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
            // There can be cases where no start has been called for the select experience.
            // - When a product consumer of the editor setselectedannotation api calls the select experience
            //   and has not been instrumented.
            // - When the annotation selection is via editor logic (ie. editor selection being moved onto
            //   an annotation).
            if (experienceState === null) {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: 'selectAnnotation completed from no experience - no explicit start point',
                    attributes: startAttributes
                });
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            }
        }
    },
    showComment: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'showComment'),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        },
        start: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: 'showComment start triggered',
                attributes: startAttributes
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                reason: abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        fail: (error, extraAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                    ...extraAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        complete: (completedFrom)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: completedFrom,
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        standaloneSidebarComplete: (commentUIVerticalDistanceFromAnnotation)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `standaloneSidebarComplete triggered`
            });
            if (commentUIVerticalDistanceFromAnnotation > 40) experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `Comment UI is misaligned by >40px pixels`,
                attributes: {
                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                }
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.standaloneSidebarComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`selectInlineCommentCompoundExperience.standaloneSidebarComplete ended without a focused and in viewport annotation.`),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Standalone sidebar inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        },
        sidePanelComplete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `sidePanelComplete triggered`
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete did not result in a visible and focused annotation'),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Side Panel inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        }
    }
};
/**
 *
 * Checks if there is an annotation currently visible in the document.
 *
 * The comment UI is currently opinionated about the comment UI being attached to the first instance of the focused annotation element.
 *
 * So we can safely skip checking if the initial focused annotation is not visible
 *
 * Note: this method causes reflow, and should not be used in performance sensitive code.
 *
 */ function $d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused(annotationId) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const possibleFocusedAnnotationElements = document.querySelectorAll(// This will match the annotation id in either the Editor or Renderer
    `[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"][data-has-focus="true"],
		[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"] .ak-editor-annotation-focus`);
    if (possibleFocusedAnnotationElements.length === 0) {
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `No annotation element found`
        });
        return false;
    }
    /**
   * Annotations can have multiple elements in the dom, with each of the elements having the focus state set to true.
   * Ie. Comments spanning multiple lines will have multiple elements with the focus state set to true.
   *
   * In addition to this -- sometimes there will be "hidden" focused annotation elements where the dom is duplicated
   * such as for annotations on table header cells in the renderer.
   *
   * If the first element is not visible due to being hidden, we continue checking until we reach a visible element, and then check whether it is in the viewport.
   *
   */ for(let i = 0; i < possibleFocusedAnnotationElements.length; i++){
        const element = possibleFocusedAnnotationElements[i];
        if (element instanceof HTMLElement) {
            if (!element.checkVisibility()) {
                // Skip to the next element if the current one is not visible
                // This can happen in scenarios where the dom is duplicated, such as for annotations on table header cells in the renderer.
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element had a hidden focused element, skipping to next element`
                });
                continue;
            }
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            // This is the first visible element -- which should be focused and
            // in the viewport
            if (isVisible) return true;
            else {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element found - but not in viewport`
                });
                return false;
            }
        }
    }
    return false;
}
const $d671aa981fcb4da6$export$b65d55854b7eb069 = {
    debug: $d671aa981fcb4da6$export$e2b3aff7888f2745.debugPoint
};
module.exports["selectInlineCommentCompoundExperience"] = $d671aa981fcb4da6$export$e2b3aff7888f2745;
module.exports["selectInlineComment"] = $d671aa981fcb4da6$export$b65d55854b7eb069;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("8Ss4E", function(module, exports) {

var $5qzNs = parcelRequire("5qzNs");


var $kyKWe = parcelRequire("kyKWe");


var $lMdlY = parcelRequire("lMdlY");


var $4TXTZ = parcelRequire("4TXTZ");


var $1iSzD = parcelRequire("1iSzD");


var $hukUK = parcelRequire("hukUK");


var $c3Qwv = parcelRequire("c3Qwv");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $7v9li = parcelRequire("7v9li");


var $949zl = parcelRequire("949zl");


var $h10mo = parcelRequire("h10mo");

const $8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences = [
    (0, $irVI7.NOT_FOUND_EXPERIENCE),
    (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
];
const $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound = (0, $1A7bE.collectAny)($8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences);
const $8c50530bac3b9ba1$var$stopOnConnectAddon = (0, $1A7bE.collectAny)([
    (0, $irVI7.CONNECT_ADDON_EXPERIENCE)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $8c50530bac3b9ba1$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $8c50530bac3b9ba1$var$redirectRoutesForExperiences = {
    [(0, $irVI7.CREATE_PAGE_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    [(0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)]: [
        (0, $1NBp8.WHITEBOARD_BOARD).name
    ],
    [(0, $irVI7.CREATE_SLIDE_EXPERIENCE)]: [
        (0, $1NBp8.SLIDES_VIEW).name
    ],
    [(0, $irVI7.CREATE_DATABASE_EXPERIENCE)]: [
        (0, $1NBp8.DATABASE_VIEW).name
    ],
    [(0, $irVI7.CREATE_EMBED_EXPERIENCE)]: [
        (0, $1NBp8.EMBED_VIEW).name
    ]
};
const $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
];
const $8c50530bac3b9ba1$export$4b786e0ae0cc0857 = {
    [(0, $1NBp8.SPACE_OVERVIEW).name]: 'space',
    [(0, $1NBp8.COMPANY_HUB).name]: 'space',
    [(0, $1NBp8.EDIT_PAGE_EMBED).name]: 'page',
    [(0, $1NBp8.EDIT_PAGE_V2).name]: 'page',
    [(0, $1NBp8.EDIT_BLOG_V2).name]: 'blog',
    [(0, $1NBp8.VIEW_PAGE).name]: 'page',
    [(0, $1NBp8.VIEW_BLOG).name]: 'blog',
    [(0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name]: 'blog'
};
const $8c50530bac3b9ba1$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.CREATE_PAGE).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $8c50530bac3b9ba1$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fGzMp.captureRouteChange)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $8c50530bac3b9ba1$var$finishLivePageExperiences();
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $8c50530bac3b9ba1$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $7v9li.hasHealthyRunningEditPageExperience)() || name === (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE) && (0, $7v9li.hasHealthyRunningCompanyHubEditExperience)() || name === (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE) && (0, $949zl.hasHealthyRunningViewPageExperience)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: 'Aborted due to SPA started a new experience'
        });
    });
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(e.name);
    });
    if ((0, $9wGTI.fg)('confluence_frontend_abort_exp_on_route_change')) $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $1NBp8.COMPANY_HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.CREATE_PAGE).name:
        case (0, $1NBp8.HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.VIEW_PAGE).name:
        case (0, $1NBp8.VIEW_BLOG).name:
        case (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.contentId, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name:
            $8c50530bac3b9ba1$var$startEditPageSmartCreate(match);
            break;
        case (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $1NBp8.EXTERNAL_SHARE).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $1NBp8.SPACE_OVERVIEW).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $1NBp8.COMPANY_HUB).name:
            const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)(sessionData) || '';
            $8c50530bac3b9ba1$var$startViewContent(spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $1NBp8.HOME).name:
            (0, $h10mo.startHome)();
            break;
        case (0, $1NBp8.EDIT_TEMPLATE_SPACE).name:
        case (0, $1NBp8.EDIT_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.CREATE_TEMPLATE_SPACE).name:
        case (0, $1NBp8.CREATE_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $1NBp8.ADVANCED_SEARCH).name:
            $8c50530bac3b9ba1$var$startAdvancedSearch(match);
            break;
        case (0, $1NBp8.SPACE_ARCHIVED_PAGES).name:
            $8c50530bac3b9ba1$var$startArchivedPagesList();
            break;
        case (0, $1NBp8.SPACE_BULK_TOOLS).name:
            $8c50530bac3b9ba1$var$startContentManager();
            break;
        case (0, $1NBp8.SPACE_DIRECTORY).name:
            $8c50530bac3b9ba1$var$startSpaceDirectory();
            break;
        case (0, $1NBp8.TEMPLATE_GALLERY).name:
            $8c50530bac3b9ba1$var$startTemplateGallery();
            break;
        case (0, $1NBp8.SPACE_PAGES).name:
            $8c50530bac3b9ba1$var$startSpacePages();
            break;
        case (0, $1NBp8.WHITEBOARD_BOARD).name:
            $8c50530bac3b9ba1$var$startWhiteboardBoard(match);
            break;
        case (0, $1NBp8.SLIDES_VIEW).name:
            $8c50530bac3b9ba1$var$startSlideView(match.params.contentId);
            break;
        case (0, $1NBp8.DATABASE_VIEW).name:
            $8c50530bac3b9ba1$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $1NBp8.EMBED_VIEW).name:
            $8c50530bac3b9ba1$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $1NBp8.FOLDER_VIEW).name:
            $8c50530bac3b9ba1$var$startFolderView(match.params.contentId);
            break;
        case (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER).name:
            $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $1NBp8.SPACE_MANAGER).name:
            $8c50530bac3b9ba1$var$startSpaceManager();
            break;
        case (0, $1NBp8.ADMIN_COMPANY_HOME_BUILDER).name:
        case (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name:
            $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $1NBp8.CREATE_CONTENT).name) $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $8c50530bac3b9ba1$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $7v9li.startCreateAndEditPage)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $8c50530bac3b9ba1$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE), (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE),
        id: id,
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_DIALOG_LOAD
    });
}
function $8c50530bac3b9ba1$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $lMdlY.getActiveTrace)();
    if (!activeTrace) (0, $4TXTZ.default)(experienceName.replace(/\//g, '-'));
}
function $8c50530bac3b9ba1$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $aJPUt.ExperienceTimeout).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $8c50530bac3b9ba1$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $8c50530bac3b9ba1$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $gykrH.isStop)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $gykrH.isStop)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $8c50530bac3b9ba1$var$startEditPageSmartCreate(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE),
        id: match.params.contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...$8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $8c50530bac3b9ba1$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    if (match.name === (0, $1NBp8.EDIT_PAGE_EMBED).name) editPageExperienceName = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (isLegacyEditor) editPageExperienceName = (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE);
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $8c50530bac3b9ba1$export$5396770e9da36673(match.name),
            contentType: $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || match?.name === (0, $1NBp8.HUB_EDIT).name,
            contentId: match.params.contentId
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            const closeExperience = events.find((event)=>(0, $gykrH.isStop)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE), (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startTemplateEditPage(id, transitionId) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && event.name === (0, $irVI7.TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startAdvancedSearch(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
        id: (0, $hukUK.objectHash)((0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(match.query, [
            'search_id'
        ]))
    });
}
function $8c50530bac3b9ba1$var$startArchivedPagesList() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_ARCHIVED_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startContentManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CONTENT_MANAGER_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startSpaceDirectory() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_DIRECTORY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).SPACE_DIRECTORY
    });
}
function $8c50530bac3b9ba1$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $irVI7.TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_CARDS_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $1A7bE.collectAll)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $1A7bE.collectAll)([
        (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    ]);
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.TEMPLATE_GALLERY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startSpacePages() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $c3Qwv.getSingleParam)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.WHITEBOARD_EXPERIENCE));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'slide') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_SLIDE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const slideExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.SLIDE_EXPERIENCE));
            if (slideExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'database') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.DATABASE_EXPERIENCE));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_EMBED_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.EMBED_EXPERIENCE));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            contentType: match.params.contentType,
            flow: flow,
            isCreateContentRoute: true,
            isPersonalSpace: isPersonalSpace,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isLivePage: subType?.toLowerCase() === 'live'
        },
        collect: (events, experience)=>{
            const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || event.name === (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE)));
            if (editPageStarted) experience.succeed();
        }
    });
}
function $8c50530bac3b9ba1$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE)
    ];
    const whiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE)
    ];
    const objectHeaderWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const subExperiences = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? objectHeaderWhiteboardSubExperiences : whiteboardSubExperiences;
    const isEmbedded = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const contentId = match.params.contentId;
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.WHITEBOARD_EXPERIENCE), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSlideView(contentId) {
    const slideSubExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const objectHeaderSlideSubExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const subExperiences = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? objectHeaderSlideSubExperiences : slideSubExperiences;
    const embeddedSlideSubExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.SLIDE_EXPERIENCE), isEmbedded ? embeddedSlideSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startDatabaseView(contentId) {
    const databaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const objectHeaderDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const subExperiences = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? objectHeaderDatabaseSubExperiences : databaseSubExperiences;
    const embeddedDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.DATABASE_EXPERIENCE), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const objectHeaderEmbedSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const subExperiences = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? objectHeaderEmbedSubExperiences : embedPageSubExperiences;
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EMBED_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $irVI7.FOLDER_CONTENT_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.FOLDER_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(folderSubExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startSpaceManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_MANAGER_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.COMPANY_HOME_BUILDER_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$finishLivePageExperiences() {
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const livePageExperiencesToSucceed = [
        (0, $irVI7.EDIT_PAGE_EXPERIENCE),
        (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}
module.exports["routeNameToContentTypeMap"] = $8c50530bac3b9ba1$export$4b786e0ae0cc0857;
module.exports["startExperienceForRoute"] = $8c50530bac3b9ba1$export$cac1117e2433d80e;
module.exports["startUFOPressTrace"] = $8c50530bac3b9ba1$export$b9a409823a06b924;
module.exports["startEditorExperiences"] = $8c50530bac3b9ba1$export$478e84e2cc5ff22d;
module.exports["startEditorSubExperience"] = $8c50530bac3b9ba1$export$7df6656d8508e8da;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/** Used for built-in method references. */ var $3e1566926de40aab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e1566926de40aab$var$hasOwnProperty = $3e1566926de40aab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    // Prevent prototype pollution, see: https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    var index = -1, length = path.length;
    if (!length) return true;
    var isRootPrimitive = object == null || typeof object !== 'object' && typeof object !== 'function';
    while(++index < length){
        var key = path[index];
        // skip non-string keys (e.g., Symbols, numbers)
        if (typeof key !== 'string') continue;
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$3e1566926de40aab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block "constructor.prototype" chains
        if (key === 'constructor' && index + 1 < length && typeof path[index + 1] === 'string' && path[index + 1] === 'prototype') {
            // Allow ONLY when the path starts at a primitive root, e.g., _.unset(0, 'constructor.prototype.a')
            if (isRootPrimitive && index === 0) continue;
            return false;
        }
    }
    var obj = $9rfkh(object, path);
    return obj == null || delete obj[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("1A7bE", function(module, exports) {

var $gykrH = parcelRequire("gykrH");

const $812facbbd37978f7$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $gykrH.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $812facbbd37978f7$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...experienceNames)));
module.exports["collectAll"] = $812facbbd37978f7$export$feb7963ae429f97f;
module.exports["collectAny"] = $812facbbd37978f7$export$79dbdd3e43727beb;

});

parcelRegister("h10mo", function(module, exports) {

var $1dnxO = parcelRequire("1dnxO");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

const $49be9d39a158f0e7$var$homeSubExperiences = [
    (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
    (0, $irVI7.HOME_RECENT_EXPERIENCE),
    (0, $irVI7.HOME_STARRED_EXPERIENCE),
    (0, $irVI7.HOME_WATCHING_EXPERIENCE),
    (0, $irVI7.HOME_DRAFTS_EXPERIENCE)
];
function $49be9d39a158f0e7$var$collectHomeNav3(events, experience) {
    const homeExperiences = new Set($49be9d39a158f0e7$var$homeSubExperiences);
    // stop as soon as any sub-experience is failed or aborted
    experience.stopOn(events.find((event)=>(event.action === 'taskFail' || event.action === 'taskAbort') && (homeExperiences.has(event.name) || event.name === (0, $irVI7.HOME_SPACES_EXPERIENCE))));
    // if any of the view experiences succeed AND the spaces experience succeeds, the root home experience should succeed
    let viewExperienceDidSucceed = false;
    let spacesExperienceDidSucceed = false;
    events.forEach((event)=>{
        if ((0, $gykrH.isStop)(event)) {
            if (homeExperiences.has(event.name)) viewExperienceDidSucceed = true;
            if (event.name === (0, $irVI7.HOME_SPACES_EXPERIENCE) && event.action === 'taskSuccess') spacesExperienceDidSucceed = true;
        }
    });
    if (viewExperienceDidSucceed && spacesExperienceDidSucceed) experience.succeed();
}
function $49be9d39a158f0e7$export$4278268ff5675d74() {
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.HOME_EXPERIENCE),
        collect: isNav4Enabled ? (0, $1A7bE.collectAny)($49be9d39a158f0e7$var$homeSubExperiences) : $49be9d39a158f0e7$var$collectHomeNav3
    });
}
module.exports["startHome"] = $49be9d39a158f0e7$export$4278268ff5675d74;

});

parcelRegister("gtj7V", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $da3ef500cf6996c4$export$eb5d3a5abb22f159 = ()=>{
    return {
        newDataManagerEnabled: (0, $6mKj3.UNSAFE_expValNoExposure)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    };
};
module.exports["getCommentsDataManagerExperimentAttributes"] = $da3ef500cf6996c4$export$eb5d3a5abb22f159;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $gtj7V = parcelRequire("gtj7V");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                compoundTaskId: compoundTaskId,
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)([
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint,
            edition: attributes.edition,
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
        };
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("8WQTF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $42omo.useState)(null);
    const [pageId, setPageId] = (0, $42omo.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $42omo.useState)(undefined);
    const providerValue = (0, $42omo.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $9wEpK = parcelRequire("9wEpK");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const baseOptions = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network'
    });
    const { data: data, loading: loading, error: error } = queryResult;
    const networkStatus = 'networkStatus' in queryResult && queryResult.networkStatus !== undefined ? queryResult.networkStatus : (0, $9wEpK.NetworkStatus).ready;
    const refetch = 'refetch' in queryResult && typeof queryResult.refetch === 'function' ? queryResult.refetch : $be6154107952d370$var$noOpRefetch;
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<9576c4641d6e53de65b0b62ec71933b2>>
 * @relayHash 5b33d38d543554afec98c6d129862ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5b33d38d543554afec98c6d129862ca0",
            "id": "c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "aad09466db1f47073b1a0249e54dc3a4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("8FCWK"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("8FCWK", function(module, exports) {

let $65005d03f1075b43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65005d03f1075b43$var$load("hhss7"),
    $65005d03f1075b43$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("bSvtO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $1P1Tu.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $9zUhf.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $9zUhf.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $9zUhf.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("hjhY1", function(module, exports) {

let $c9a225eda4a4bd12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c9a225eda4a4bd12$var$load("4pqtR"),
    $c9a225eda4a4bd12$var$load("5XqRg"),
    $c9a225eda4a4bd12$var$load("evYW1"),
    $c9a225eda4a4bd12$var$load("3Bbwl"),
    $c9a225eda4a4bd12$var$load("7EorR"),
    $c9a225eda4a4bd12$var$load("9AXkC"),
    $c9a225eda4a4bd12$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("2OyAA", function(module, exports) {

let $20cb14f9d5ea3c04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20cb14f9d5ea3c04$var$load("kHOMt"),
    $20cb14f9d5ea3c04$var$load("9AXkC"),
    $20cb14f9d5ea3c04$var$load("4pqtR"),
    $20cb14f9d5ea3c04$var$load("5XqRg"),
    $20cb14f9d5ea3c04$var$load("6wr18"),
    $20cb14f9d5ea3c04$var$load("ffEVr"),
    $20cb14f9d5ea3c04$var$load("gYeBT"),
    $20cb14f9d5ea3c04$var$load("8LtYa"),
    $20cb14f9d5ea3c04$var$load("g9CVe"),
    $20cb14f9d5ea3c04$var$load("3JSgG"),
    $20cb14f9d5ea3c04$var$load("70IPm"),
    $20cb14f9d5ea3c04$var$load("l1BQC"),
    $20cb14f9d5ea3c04$var$load("jlSF3"),
    $20cb14f9d5ea3c04$var$load("evYW1"),
    $20cb14f9d5ea3c04$var$load("h3ABO"),
    $20cb14f9d5ea3c04$var$load("kC80R"),
    $20cb14f9d5ea3c04$var$load("7EorR"),
    $20cb14f9d5ea3c04$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("6PB7O", function(module, exports) {

let $4f944dbe79d36182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f944dbe79d36182$var$load("6wr18"),
    $4f944dbe79d36182$var$load("ffEVr"),
    $4f944dbe79d36182$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("borly", function(module, exports) {

let $84b7261358c2f366$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $84b7261358c2f366$var$load("h3ABO"),
    $84b7261358c2f366$var$load("fPSgL"),
    $84b7261358c2f366$var$load("6wr18"),
    $84b7261358c2f366$var$load("2PePB"),
    $84b7261358c2f366$var$load("lg1HU"),
    $84b7261358c2f366$var$load("1GCFv"),
    $84b7261358c2f366$var$load("4l6RQ"),
    $84b7261358c2f366$var$load("cLmw6"),
    $84b7261358c2f366$var$load("lNrIG"),
    $84b7261358c2f366$var$load("dvUU0"),
    $84b7261358c2f366$var$load("1H5IN"),
    $84b7261358c2f366$var$load("a9w2G"),
    $84b7261358c2f366$var$load("gYeBT"),
    $84b7261358c2f366$var$load("iGCP8"),
    $84b7261358c2f366$var$load("8VT23"),
    $84b7261358c2f366$var$load("6cnH1"),
    $84b7261358c2f366$var$load("lkOIY"),
    $84b7261358c2f366$var$load("dI1Cd"),
    $84b7261358c2f366$var$load("jbxHq"),
    $84b7261358c2f366$var$load("l0dTs"),
    $84b7261358c2f366$var$load("8YSo7"),
    $84b7261358c2f366$var$load("7do1E"),
    $84b7261358c2f366$var$load("77dkW"),
    $84b7261358c2f366$var$load("9ijrN"),
    $84b7261358c2f366$var$load("Wowvf"),
    $84b7261358c2f366$var$load("421lv"),
    $84b7261358c2f366$var$load("3JSgG"),
    $84b7261358c2f366$var$load("cyGuT"),
    $84b7261358c2f366$var$load("ffEVr"),
    $84b7261358c2f366$var$load("9AXkC"),
    $84b7261358c2f366$var$load("28arV"),
    $84b7261358c2f366$var$load("hhss7"),
    $84b7261358c2f366$var$load("3LP1d"),
    $84b7261358c2f366$var$load("5Fany"),
    $84b7261358c2f366$var$load("1cktr"),
    $84b7261358c2f366$var$load("3Oy4g"),
    $84b7261358c2f366$var$load("70IPm"),
    $84b7261358c2f366$var$load("l1BQC"),
    $84b7261358c2f366$var$load("jlSF3"),
    $84b7261358c2f366$var$load("cXoAq"),
    $84b7261358c2f366$var$load("dP7ao"),
    $84b7261358c2f366$var$load("hogcU"),
    $84b7261358c2f366$var$load("31vk5"),
    $84b7261358c2f366$var$load("4pqtR"),
    $84b7261358c2f366$var$load("5XqRg"),
    $84b7261358c2f366$var$load("2uVTT"),
    $84b7261358c2f366$var$load("fGkaB"),
    $84b7261358c2f366$var$load("5wC2D"),
    $84b7261358c2f366$var$load("evYW1"),
    $84b7261358c2f366$var$load("hrqeu"),
    $84b7261358c2f366$var$load("8ublV"),
    $84b7261358c2f366$var$load("3DgZV"),
    $84b7261358c2f366$var$load("a8Rqp"),
    $84b7261358c2f366$var$load("1EWOs"),
    $84b7261358c2f366$var$load("7EorR"),
    $84b7261358c2f366$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("hPTbh", function(module, exports) {
/**
 * Centralized analytics constants for the snippets package.
 *
 * Organized into three sections:
 *   1. Shared    – source, event types, origins, page modes (used by all events)
 *   2. UI        – subjects, actions, subject IDs, modal outcomes (sendUIEvent)
 *   3. Operational – subjects, actions (sendOperationalEvent)
 */ // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  Shared
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
/** Event type used to dispatch analytics events */ var $2394c5239b489cef$export$a0913705d36eb84c = /*#__PURE__*/ function(ANALYTICS_EVENT_TYPE) {
    ANALYTICS_EVENT_TYPE["SEND_UI_EVENT"] = "sendUIEvent";
    ANALYTICS_EVENT_TYPE["SEND_OPERATIONAL_EVENT"] = "sendOperationalEvent";
    return ANALYTICS_EVENT_TYPE;
}({});
var $2394c5239b489cef$export$17897eee0c3e7eb1 = /*#__PURE__*/ function(ANALYTICS_TYPE) {
    ANALYTICS_TYPE["UI"] = "ui";
    ANALYTICS_TYPE["OPERATIONAL"] = "operational";
    return ANALYTICS_TYPE;
}({});
const $2394c5239b489cef$export$f7109619a5e9e0d6 = 'confluenceSnippets';
var $2394c5239b489cef$export$8dd55f56fde129aa = /*#__PURE__*/ function(ANALYTICS_ORIGIN) {
    // snippet CRUD modals
    ANALYTICS_ORIGIN["CREATE_SNIPPET_MODAL"] = "createSnippetModal";
    ANALYTICS_ORIGIN["EDIT_SNIPPET_MODAL"] = "editSnippetModal";
    ANALYTICS_ORIGIN["DUPLICATE_SNIPPET_MODAL"] = "duplicateSnippetModal";
    ANALYTICS_ORIGIN["DELETE_SNIPPET_MODAL"] = "deleteSnippetModal";
    // onboarding
    ANALYTICS_ORIGIN["FIRST_SNIPPET_CREATED_MODAL"] = "firstSnippetCreatedModal";
    // surfaces
    ANALYTICS_ORIGIN["SNIPPET_PANEL"] = "snippetPanel";
    ANALYTICS_ORIGIN["SNIPPET_GALLERY"] = "snippetGallery";
    // toolbars / menus
    ANALYTICS_ORIGIN["CONTEXTUAL_TOOLBAR"] = "contextualToolbar";
    ANALYTICS_ORIGIN["BLOCK_MENU"] = "blockMenu";
    return ANALYTICS_ORIGIN;
}({});
var $2394c5239b489cef$export$b397791890e3384b = /*#__PURE__*/ function(ANALYTICS_CREATE_SOURCE) {
    ANALYTICS_CREATE_SOURCE["EMPTY_PANEL"] = "snippetPanelEmpty";
    ANALYTICS_CREATE_SOURCE["SNIPPET_PANEL_LIST"] = "snippetPanelCreateItem";
    ANALYTICS_CREATE_SOURCE["HIGHLIGHT_VIEW"] = "snippetHighlightView";
    ANALYTICS_CREATE_SOURCE["HIGHLIGHT_EDIT"] = "snippetHighlightEdit";
    return ANALYTICS_CREATE_SOURCE;
}({});
var $2394c5239b489cef$export$a23e6d34a2dcf281 = /*#__PURE__*/ function(ANALYTICS_PAGE_MODE) {
    ANALYTICS_PAGE_MODE["VIEW"] = "view";
    ANALYTICS_PAGE_MODE["EDIT"] = "edit";
    ANALYTICS_PAGE_MODE["LIVE"] = "live";
    return ANALYTICS_PAGE_MODE;
}({});
var $2394c5239b489cef$export$eeb695ba3667fc27 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECT) {
    ANALYTICS_UI_SUBJECT["BUTTON"] = "button";
    ANALYTICS_UI_SUBJECT["MODAL"] = "modal";
    ANALYTICS_UI_SUBJECT["TEXT_FIELD"] = "textField";
    ANALYTICS_UI_SUBJECT["DROPDOWN_ITEM"] = "dropdownItem";
    ANALYTICS_UI_SUBJECT["SNIPPETS"] = "snippets";
    return ANALYTICS_UI_SUBJECT;
}({});
var $2394c5239b489cef$export$2fdff18978b1ec73 = /*#__PURE__*/ function(ANALYTICS_UI_ACTION) {
    ANALYTICS_UI_ACTION["CLICKED"] = "clicked";
    ANALYTICS_UI_ACTION["CLOSED"] = "closed";
    ANALYTICS_UI_ACTION["TYPED"] = "typed";
    return ANALYTICS_UI_ACTION;
}({});
var $2394c5239b489cef$export$f6034aaa561169a2 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECT_ID) {
    // button
    ANALYTICS_UI_SUBJECT_ID["CREATE_SNIPPET"] = "createSnippet";
    ANALYTICS_UI_SUBJECT_ID["DELETE_SNIPPET"] = "deleteSnippet";
    ANALYTICS_UI_SUBJECT_ID["EDIT_SNIPPET"] = "editSnippet";
    ANALYTICS_UI_SUBJECT_ID["DUPLICATE_SNIPPET"] = "duplicateSnippet";
    ANALYTICS_UI_SUBJECT_ID["INSERT_SNIPPET"] = "insertSnippet";
    ANALYTICS_UI_SUBJECT_ID["COPY_SNIPPET_LINK"] = "copySnippetLink";
    ANALYTICS_UI_SUBJECT_ID["USE_SNIPPET_DETAIL_PANEL"] = "useSnippetDetailPanel";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_FAVORITE_TOGGLED"] = "snippetFavoriteToggled";
    // textField / button / dropdownItem (filter-related)
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_CATEGORY_FILTER"] = "snippetCategoryFilter";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_SEARCH"] = "snippetSearch";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_SORT_ORDER"] = "snippetSortOrder";
    // FirstSnippetCreatedModal (use attributes for viewed vs dismissed and dismissalAction)
    ANALYTICS_UI_SUBJECT_ID["FIRST_SNIPPET_CREATED_MODAL"] = "firstSnippetCreatedModal";
    // Empty state primary actions
    ANALYTICS_UI_SUBJECT_ID["EMPTY_MY_TEMPLATES_CALL_TO_ACTION"] = "emptyMyTemplatesCallToAction";
    ANALYTICS_UI_SUBJECT_ID["EMPTY_FAVORITES_CALL_TO_ACTION"] = "emptyFavoritesCallToAction";
    return ANALYTICS_UI_SUBJECT_ID;
}({});
var $2394c5239b489cef$export$4d76a1418128341e = /*#__PURE__*/ function(MODAL_TYPE) {
    MODAL_TYPE["CREATE"] = "CREATE";
    MODAL_TYPE["EDIT"] = "EDIT";
    MODAL_TYPE["DUPLICATE"] = "DUPLICATE";
    return MODAL_TYPE;
}({});
var $2394c5239b489cef$export$42a4ee1a85ef55d2 = /*#__PURE__*/ function(MODAL_OUTCOME) {
    MODAL_OUTCOME["CREATED"] = "created";
    MODAL_OUTCOME["EDITED"] = "edited";
    MODAL_OUTCOME["DUPLICATED"] = "duplicated";
    MODAL_OUTCOME["DELETED"] = "deleted";
    MODAL_OUTCOME["CANCELLED"] = "cancelled";
    MODAL_OUTCOME["CLOSED"] = "closed";
    return MODAL_OUTCOME;
}({});
var $2394c5239b489cef$export$3c94fecf7ead2464 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_SUBJECT) {
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_FAVORITE_TOGGLED"] = "snippetFavoriteToggled";
    ANALYTICS_OPERATIONAL_SUBJECT["INSERT_SNIPPET"] = "insertSnippet";
    // API failures
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_CREATE"] = "snippetApiCreate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_DUPLICATE"] = "snippetApiDuplicate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_UPDATE"] = "snippetApiUpdate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_DELETE"] = "snippetApiDelete";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_FETCH"] = "snippetApiFetch";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_SHARE"] = "snippetApiShare";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_UNSHARE"] = "snippetApiUnshare";
    // API successes
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_SAVE_SUCCESS"] = "snippetApiSaveSuccess";
    // AI metadata
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_AI_METADATA"] = "snippetApiAiMetadata";
    // Client-side errors
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_ADF_SERIALIZATION"] = "snippetAdfSerialization";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_PREVIEW_RENDER"] = "snippetPreviewRender";
    return ANALYTICS_OPERATIONAL_SUBJECT;
}({});
var $2394c5239b489cef$export$2fd2c1b71075f9e9 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_ACTION) {
    ANALYTICS_OPERATIONAL_ACTION["FAILED"] = "failed";
    ANALYTICS_OPERATIONAL_ACTION["SUCCEEDED"] = "succeeded";
    ANALYTICS_OPERATIONAL_ACTION["FETCHED"] = "fetched";
    return ANALYTICS_OPERATIONAL_ACTION;
}({});
module.exports["ANALYTICS_EVENT_TYPE"] = $2394c5239b489cef$export$a0913705d36eb84c;
module.exports["ANALYTICS_TYPE"] = $2394c5239b489cef$export$17897eee0c3e7eb1;
module.exports["ANALYTICS_SOURCE"] = $2394c5239b489cef$export$f7109619a5e9e0d6;
module.exports["ANALYTICS_ORIGIN"] = $2394c5239b489cef$export$8dd55f56fde129aa;
module.exports["ANALYTICS_CREATE_SOURCE"] = $2394c5239b489cef$export$b397791890e3384b;
module.exports["ANALYTICS_PAGE_MODE"] = $2394c5239b489cef$export$a23e6d34a2dcf281;
module.exports["ANALYTICS_UI_SUBJECT"] = $2394c5239b489cef$export$eeb695ba3667fc27;
module.exports["ANALYTICS_UI_ACTION"] = $2394c5239b489cef$export$2fdff18978b1ec73;
module.exports["ANALYTICS_UI_SUBJECT_ID"] = $2394c5239b489cef$export$f6034aaa561169a2;
module.exports["MODAL_TYPE"] = $2394c5239b489cef$export$4d76a1418128341e;
module.exports["MODAL_OUTCOME"] = $2394c5239b489cef$export$42a4ee1a85ef55d2;
module.exports["ANALYTICS_OPERATIONAL_SUBJECT"] = $2394c5239b489cef$export$3c94fecf7ead2464;
module.exports["ANALYTICS_OPERATIONAL_ACTION"] = $2394c5239b489cef$export$2fd2c1b71075f9e9;

});

parcelRegister("bUH8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $8aF6s = parcelRequire("8aF6s");


var $7aRa9 = parcelRequire("7aRa9");


var $5vi32 = parcelRequire("5vi32");


var $ivb8S = parcelRequire("ivb8S");


var $bEwOV = parcelRequire("bEwOV");


var $hPTbh = parcelRequire("hPTbh");


var $cgy0A = parcelRequire("cgy0A");


var $jxXkP = parcelRequire("jxXkP");


var $8JRDD = parcelRequire("8JRDD");


var $8yRiX = parcelRequire("8yRiX");


var $eWCeD = parcelRequire("eWCeD");


var $dZUkS = parcelRequire("dZUkS");


var $ies1q = parcelRequire("ies1q");


var $2u5FB = parcelRequire("2u5FB");


var $6K2yS = parcelRequire("6K2yS");


var $aNHzZ = parcelRequire("aNHzZ");


var $d3Wxa = parcelRequire("d3Wxa");


var $jU9SA = parcelRequire("jU9SA");

const $e0d6fa0d5e247589$var$FORM_KEY = 'create-snippet';
const $e0d6fa0d5e247589$var$CreateSnippetModalWithFlags = (t0)=>{
    const $ = (0, $frIzR.c)(35);
    const { onClose: onClose, onCloseComplete: onCloseComplete, adf: adf, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, flags: flags, editorAPI: editorAPI, analyticsOrigin: analyticsOrigin, createSource: createSource } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const openSnippetPanel = (0, $8yRiX.useOpenSnippetPanel)();
    const { isSnippetSharingForSiteEnabled: t1 } = (0, $dZUkS.useSnippetsState)();
    const isSnippetSharingForSiteEnabled = t1 === undefined ? false : t1;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).CREATE_SNIPPET_MODAL);
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const handleCloseBase = (0, $8JRDD.useSnippetModalClose)(onClose, (0, $hPTbh.ANALYTICS_ORIGIN).CREATE_SNIPPET_MODAL, (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).CREATE_SNIPPET);
    let t2;
    if ($[0] !== createSource || $[1] !== handleCloseBase) {
        t2 = (attrs)=>{
            handleCloseBase({
                ...attrs,
                createSource: createSource
            });
        };
        $[0] = createSource;
        $[1] = handleCloseBase;
        $[2] = t2;
    } else t2 = $[2];
    const handleClose = t2;
    const { isAiSuggestionLoading: isAiSuggestionLoading, aiSuggestedName: aiSuggestedName, aiSuggestedDescription: aiSuggestedDescription } = (0, $cgy0A.useAiSuggestions)(adf, (0, $hPTbh.ANALYTICS_ORIGIN).CREATE_SNIPPET_MODAL);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $bEwOV.SNIPPETS_ONBOARDING).HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL
        ];
        $[3] = t3;
    } else t3 = $[3];
    const { data: onboardingData, loading: onboardingLoading, error: onboardingError } = (0, $ivb8S.useGetOnboardingState)(t3, false);
    let t4;
    if ($[4] !== onboardingData) {
        t4 = (0, $ivb8S.deserializeState)(onboardingData);
        $[4] = onboardingData;
        $[5] = t4;
    } else t4 = $[5];
    const { hasSeenFirstSnippetCreatedModal: hasSeenFirstSnippetCreatedModal } = t4;
    let T0;
    let t5;
    if ($[6] !== adf || $[7] !== aiSuggestedDescription || $[8] !== aiSuggestedName || $[9] !== analyticsOrigin || $[10] !== contentId || $[11] !== createSource || $[12] !== editorAPI || $[13] !== fireFailedAnalytic || $[14] !== fireSuccessAnalytic || $[15] !== flags || $[16] !== handleClose || $[17] !== hasSeenFirstSnippetCreatedModal || $[18] !== intl || $[19] !== isAiSuggestionLoading || $[20] !== isEmbeddedConfluence || $[21] !== isSnippetSharingForSiteEnabled || $[22] !== onCloseComplete || $[23] !== onboardingError || $[24] !== onboardingLoading || $[25] !== openSnippetPanel || $[26] !== showModal || $[27] !== snippetsActions || $[28] !== spaceId || $[29] !== spaceKey) {
        const baseDefaultValues = (0, $aNHzZ.getDefaultFormValues)(isSnippetSharingForSiteEnabled);
        const defaultValues = {
            ...baseDefaultValues,
            snippetName: aiSuggestedName ?? baseDefaultValues.snippetName,
            snippetDescription: aiSuggestedDescription ?? baseDefaultValues.snippetDescription
        };
        const initialAdf = (0, $ies1q.wrapAdfWithDocNode)(adf);
        const title = intl.formatMessage((0, $jU9SA.createSnippetModalMessages).titleCreate);
        const submitLabel = intl.formatMessage((0, $jU9SA.createSnippetModalMessages).createButton);
        const successFlagActions = analyticsOrigin === (0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_GALLERY ? undefined : [
            {
                content: intl.formatMessage((0, $6K2yS.messages).successFlagViewTemplateAction),
                onClick: openSnippetPanel
            }
        ];
        const onSubmit = async (values, currentAdf)=>{
            const bodySize = JSON.stringify(currentAdf).length;
            const isOnboardingStateReady = !onboardingLoading && !onboardingError;
            const shouldShowFirstSnippetCreatedModal = !isEmbeddedConfluence && isOnboardingStateReady && !hasSeenFirstSnippetCreatedModal;
            const newSnippet = await snippetsActions.createSnippet(values.snippetName, currentAdf, values.snippetDescription, {
                flags: flags,
                intl: intl,
                editorAPI: editorAPI ?? undefined,
                isShared: values.isShared,
                successFlagActions: successFlagActions,
                showSuccessFlag: !shouldShowFirstSnippetCreatedModal,
                onShareFailure: (snippetId)=>fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SHARE, {
                        snippetId: snippetId
                    }),
                onSaveFailure: (error)=>{
                    const isBodyTooLarge = (0, $eWCeD.isBodyTooLargeError)(error);
                    fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_CREATE, {
                        ...isBodyTooLarge && {
                            isBodyTooLarge: true,
                            bodySize: bodySize
                        }
                    });
                },
                messages: {
                    successFlagTitle: (0, $jU9SA.createSnippetModalMessages).successFlagTitle,
                    errorFlagTitle: (0, $jU9SA.createSnippetModalMessages).errorFlagTitle,
                    errorFlagDescription: (0, $jU9SA.createSnippetModalMessages).errorFlagDescription
                }
            });
            if (newSnippet) {
                const wasNameSuggestedByAi = aiSuggestedName !== null;
                const wasDescriptionSuggestedByAi = aiSuggestedDescription !== null;
                fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SAVE_SUCCESS, {
                    snippetId: newSnippet.snippetId,
                    bodySize: bodySize,
                    modalType: (0, $hPTbh.MODAL_TYPE).CREATE,
                    createSource: createSource
                });
                handleClose({
                    outcome: (0, $hPTbh.MODAL_OUTCOME).CREATED,
                    snippetId: newSnippet.snippetId,
                    bodySize: bodySize,
                    wasNameSuggestedByAi: wasNameSuggestedByAi,
                    ...wasNameSuggestedByAi && {
                        nameKeptAsSuggested: values.snippetName === aiSuggestedName
                    },
                    wasDescriptionSuggestedByAi: wasDescriptionSuggestedByAi,
                    ...wasDescriptionSuggestedByAi && {
                        descriptionKeptAsSuggested: values.snippetDescription === aiSuggestedDescription
                    },
                    createSource: createSource
                });
                if (shouldShowFirstSnippetCreatedModal) showModal((0, $d3Wxa.FirstSnippetCreatedModal), {});
            }
        };
        T0 = (0, $2u5FB.SnippetBaseModal);
        t5 = (0, $2u5FB.getSnippetBaseModalProps)({
            title: title,
            submitLabel: submitLabel,
            formKey: $e0d6fa0d5e247589$var$FORM_KEY,
            defaultValues: defaultValues,
            initialAdf: initialAdf,
            onSubmit: onSubmit,
            handleClose: handleClose,
            fireFailedAnalytic: fireFailedAnalytic,
            onCloseComplete: onCloseComplete,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled,
            isAiSuggestionLoading: isAiSuggestionLoading
        });
        $[6] = adf;
        $[7] = aiSuggestedDescription;
        $[8] = aiSuggestedName;
        $[9] = analyticsOrigin;
        $[10] = contentId;
        $[11] = createSource;
        $[12] = editorAPI;
        $[13] = fireFailedAnalytic;
        $[14] = fireSuccessAnalytic;
        $[15] = flags;
        $[16] = handleClose;
        $[17] = hasSeenFirstSnippetCreatedModal;
        $[18] = intl;
        $[19] = isAiSuggestionLoading;
        $[20] = isEmbeddedConfluence;
        $[21] = isSnippetSharingForSiteEnabled;
        $[22] = onCloseComplete;
        $[23] = onboardingError;
        $[24] = onboardingLoading;
        $[25] = openSnippetPanel;
        $[26] = showModal;
        $[27] = snippetsActions;
        $[28] = spaceId;
        $[29] = spaceKey;
        $[30] = T0;
        $[31] = t5;
    } else {
        T0 = $[30];
        t5 = $[31];
    }
    let t6;
    if ($[32] !== T0 || $[33] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, t5);
        $[32] = T0;
        $[33] = t5;
        $[34] = t6;
    } else t6 = $[34];
    return t6;
};
const $e0d6fa0d5e247589$export$3336f6e2bcd88a3e = (0, $7aRa9.withFlags)($e0d6fa0d5e247589$var$CreateSnippetModalWithFlags);
module.exports["CreateSnippetModal"] = $e0d6fa0d5e247589$export$3336f6e2bcd88a3e;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("5vi32", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("ivb8S", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $cbOce = parcelRequire("cbOce");


var $9xoMO = parcelRequire("9xoMO");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: (0, $9xoMO.OnboardingKeysCombined)
            }
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: (0, $9xoMO.OnboardingKeysCombined)
        },
        data: {
            onboardingState: newOnboardingState
        }
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key value}}`, {
        update (cache, { data: data }) {
            const states = data.setOnboardingState;
            states.forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                cache.writeFragment({
                    id: `OnboardingState:${key}`,
                    fragment: (0, $eSUdr.default)`fragment myKey on OnboardingState{key value}`,
                    data: {
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: (0, $9xoMO.OnboardingKeysCombined)
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only'
    });
    // Fallback query: used when centralized cache is not available or not applicable
    // This fetches individual keys from the network
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactive && useCentralizedCache && !!reactiveCacheData
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache: use reactiveCacheData (filtered)
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $42omo.useRef)(undefined);
    const data = (0, $42omo.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactive && useCentralizedCache && reactiveCacheData) {
            const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
            if (filtered && prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, filtered.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = filtered;
            return filtered;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    const loading = (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("l1uFv", function(module, exports) {

var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    if ((0, $iffSy.isRelayEnabled)()) throw new Error('[Relay migration] Method not implemented yet');
    else return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("fEmGS", function(module, exports) {

var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return (0, $iffSy.isRelayEnabled)() ? $f0827a369f0dafa9$var$writeQueryInteropRelay(params) : $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("9xoMO", function(module, exports) {

var $dBcar = parcelRequire("dBcar");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $lohHj = parcelRequire("lohHj");


var $b4VFP = parcelRequire("b4VFP");


var $d282Z = parcelRequire("d282Z");


var $d0hiC = parcelRequire("d0hiC");


var $9DBk6 = parcelRequire("9DBk6");


var $isKLx = parcelRequire("isKLx");


var $1gy7x = parcelRequire("1gy7x");


var $h86CY = parcelRequire("h86CY");


var $jbYIt = parcelRequire("jbYIt");


var $ccGoc = parcelRequire("ccGoc");


var $eoU1C = parcelRequire("eoU1C");


var $2wUAJ = parcelRequire("2wUAJ");


var $6eN5W = parcelRequire("6eN5W");


var $kNKrY = parcelRequire("kNKrY");


var $lIcXr = parcelRequire("lIcXr");


var $bPDOf = parcelRequire("bPDOf");


var $eyUJP = parcelRequire("eyUJP");


var $eC276 = parcelRequire("eC276");


var $fsF73 = parcelRequire("fsF73");


var $bEwOV = parcelRequire("bEwOV");


var $gGieN = parcelRequire("gGieN");


var $iTy0f = parcelRequire("iTy0f");

const $af0fb818e1350632$export$1c433575c0d65d05 = [
    ...(0, $2wUAJ.StorageEnforcementOnboardingKeys),
    ...(0, $dBcar.OnboardingKeys),
    ...(0, $gxTpP.ContextualInviteNudgeOnboardingKeys),
    ...(0, $5cryL.EditorOnboardingKeys),
    ...(0, $d282Z.InsightsOnboardingKeys),
    ...(0, $isKLx.SpaceMissionControlOnboardingKeys),
    ...(0, $h86CY.PresenceAdminFeedbackSurveyOnboardingKeys),
    ...(0, $jbYIt.RoleBasedAccessControlOnboardingKeys),
    ...(0, $ccGoc.RovoVideoPlayerStateOnboardingKeys),
    ...(0, $eoU1C.ShareAndRestrictDialogOnboardingKeys),
    ...(0, $6eN5W.TrialComponentsOnboardingKeys),
    ...(0, $1gy7x.PersonalizedTemplatesOnboardingKeys),
    ...(0, $9DBk6.LiveDocsOnboardingKeys),
    ...(0, $b4VFP.HomeTakeoverOnboardingKeys),
    ...(0, $lohHj.FeedOnboardingKeys),
    ...(0, $d0hiC.LandInSpampleSpaceOnboardingKeys),
    ...(0, $kNKrY.CreateIntroFirstStepOnboardingStateKeys),
    ...(0, $lIcXr.NewContentHistoryOnboardingStateKeys),
    ...(0, $bPDOf.AIFCOnboardingKeys),
    ...(0, $eyUJP.NthUserHomeOnboardingRevampKeys),
    ...(0, $eC276.ExportJiraContextToPageTourKeys),
    ...(0, $fsF73.ConfluenceRecapOnboardingKeys),
    ...(0, $gGieN.SuggestWhiteboardBasedOnPageTitleOnboardingKeys),
    ...(0, $bEwOV.SnippetsOnboardingKeys),
    ...(0, $iTy0f.SmartLinkDraggableOnboardingKeys)
];
module.exports["OnboardingKeysCombined"] = $af0fb818e1350632$export$1c433575c0d65d05;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$a651929fa48b856 = 'nthUserOnboardingFlagViewed';
const $3c94963df51c0e13$export$26694bcd9ab12240 = 'nthUserOnboardingPageViewed';
const $3c94963df51c0e13$export$ff82dad92156967f = 'nthUserGSPagePath';
const $3c94963df51c0e13$export$a05aab42c7cc2cd2 = 'nthUserBannerDismissed';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$aae58c16337c3635 = {
    BULK_ACTIONS_CHANGEBOARDING_SPOTLIGHT_DISMISSED: 'content-tree-bulk-actions:isBulkActionsChangeboardingSpotlightDismissed'
};
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible',
    NTH_USER_D0_SIMPLIFIED_NAV_START_AT: 'simplify-nav-new-user:nthUserD0SimplifiedNavStartAt'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    START_AT: 'creation-focused-nav-xflow:startAt'
};
const $3c94963df51c0e13$export$9b71507da8cc81c3 = 'first-ever-view:hasSeenAutoShowAnalytics';
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IMPROVED_GET_STARTED_NTH_USER_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$ff82dad92156967f}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`,
    NTH_USER_ONBOARDING_FLAG_VIEWED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$a651929fa48b856}`,
    NTH_USER_ONBOARDING_PAGE_VIEWED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$26694bcd9ab12240}`,
    NTH_USER_BANNER_DISMISSED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$a05aab42c7cc2cd2}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const { LEGACY_ONBOARDING_STATE: $3c94963df51c0e13$export$66aa87593037fd4a } = $3c94963df51c0e13$export$bfeb2da96277b623;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_START_AT
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$aae58c16337c3635),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    $3c94963df51c0e13$export$9b71507da8cc81c3
];
module.exports["NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP"] = $3c94963df51c0e13$export$275d3dda87d2fa7a;
module.exports["NTH_USER_ONBOARDING_FLAG_VIEWED"] = $3c94963df51c0e13$export$a651929fa48b856;
module.exports["NTH_USER_ONBOARDING_PAGE_VIEWED"] = $3c94963df51c0e13$export$26694bcd9ab12240;
module.exports["IMPROVED_GET_STARTED_NTH_USER_PATH"] = $3c94963df51c0e13$export$ff82dad92156967f;
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CONTENT_TREE_BULK_ACTIONS"] = $3c94963df51c0e13$export$aae58c16337c3635;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["PROMPT_DATABASE_COMPETITOR_LINK"] = $3c94963df51c0e13$export$5b471e2344a37be7;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["HAS_SEEN_AUTO_SHOW_ANALYTICS"] = $3c94963df51c0e13$export$9b71507da8cc81c3;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("gxTpP", function(module, exports) {
const $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab = {
    EXPERIMENT_ELIGIBLE_TAG: 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    WAS_CONFETTI_SEEN: 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
};
const $62a1556a5bf2ef38$export$fdbc8dd83db637ed = [
    ...Object.values($62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab)
];
module.exports["CONTEXTUAL_INVITE_NUDGE"] = $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab;
module.exports["ContextualInviteNudgeOnboardingKeys"] = $62a1556a5bf2ef38$export$fdbc8dd83db637ed;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("lohHj", function(module, exports) {
const $3f26c87821b680a5$export$215d0f9cb557eff8 = 'onboarding-popular-feed-card:isDismissed';
const $3f26c87821b680a5$export$84bf53f359485dfc = [
    $3f26c87821b680a5$export$215d0f9cb557eff8
];
module.exports["FeedOnboardingKeys"] = $3f26c87821b680a5$export$84bf53f359485dfc;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
    AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen',
    REMIX_PANEL_CHANGEBOARDING: 'onboarding-insights:hasRemixPanelChangeboardingBeenSeen'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = [
    ...Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2)
];
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("d0hiC", function(module, exports) {
const $fd31f36c9d251c72$export$3b7e7c8d78a4b783 = {
    hasDismissedBanner: 'land-in-sample-space:hasDismissedBanner',
    hasSeenSampleContentFlag: 'land-in-sample-space:hasSeenSampleContentFlag'
};
const $fd31f36c9d251c72$export$12692b0da4497e60 = [
    ...Object.values($fd31f36c9d251c72$export$3b7e7c8d78a4b783)
];
module.exports["LandInSpampleSpaceOnboardingKeys"] = $fd31f36c9d251c72$export$12692b0da4497e60;

});

parcelRegister("9DBk6", function(module, exports) {
const $d9e19a0d44ee3302$export$b02e3be205ee7739 = {
    LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN: 'live-page-nudge:wasLivePageNudgeSeen',
    // used to limit calls to the invite permissions API
    LIVE_PAGE_INVITE_INELIGIBLE: 'live-page-nudge:livePageNudgeInviteIneligible'
};
const $d9e19a0d44ee3302$export$b3d9533dbdf35d0 = [
    ...Object.values($d9e19a0d44ee3302$export$b02e3be205ee7739)
];
module.exports["LIVE_PAGE_NUDGE"] = $d9e19a0d44ee3302$export$b02e3be205ee7739;
module.exports["LiveDocsOnboardingKeys"] = $d9e19a0d44ee3302$export$b3d9533dbdf35d0;

});

parcelRegister("isKLx", function(module, exports) {
const $d14f8037089c8dc2$export$92d46364e5595a5a = {
    SPACE_SETTINGS_CHANGEBOARDING_FIRST_SEEN_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt',
    SPACE_SETTINGS_CHANGEBOARDING_DISMISSED_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt'
};
const $d14f8037089c8dc2$export$d9eb44525b9507f7 = [
    ...Object.values($d14f8037089c8dc2$export$92d46364e5595a5a)
];
module.exports["ONBOARDING_SPACE_MISSION_CONTROL"] = $d14f8037089c8dc2$export$92d46364e5595a5a;
module.exports["SpaceMissionControlOnboardingKeys"] = $d14f8037089c8dc2$export$d9eb44525b9507f7;

});

parcelRegister("1gy7x", function(module, exports) {
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = [
    ...Object.values($071869849092e495$export$d8593f7ef284bfd8)
];
module.exports["PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS"] = $071869849092e495$export$d8593f7ef284bfd8;
module.exports["PersonalizedTemplatesOnboardingKeys"] = $071869849092e495$export$67c979693bf8551b;

});

parcelRegister("h86CY", function(module, exports) {
const $1dd4a0157170f997$export$f8474b3e5d170456 = {
    PRESENCE_ADMIN_FEEDBACK_SEEN: 'presence-feedback-survey:hasAdminSeenFeedbackSurvey'
};
const $1dd4a0157170f997$export$dcc0ca03f6f8c68d = [
    ...Object.values($1dd4a0157170f997$export$f8474b3e5d170456)
];
module.exports["ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS"] = $1dd4a0157170f997$export$f8474b3e5d170456;
module.exports["PresenceAdminFeedbackSurveyOnboardingKeys"] = $1dd4a0157170f997$export$dcc0ca03f6f8c68d;

});

parcelRegister("jbYIt", function(module, exports) {
const $15e5f1cf9df2e13c$export$67837434b2dea54f = {
    USERS_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:usersTableSpotlightSeen',
    DEFAULTS_ROLE_TABLE_MODAL_SEEN: 'RoleBasedAccessControl:defaultsRoleTableModalSeen',
    PRODUCT_ADMIN_MODAL_SEEN: 'RoleBasedAccessControl:productAdminModalSeen',
    DEFAULT_ROLE_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:defaultRoleTableSpotlightSeen',
    CUSTOM_ROLE_PAGE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:customRolePageSpotlightSeen'
};
const $15e5f1cf9df2e13c$export$134f165f9f20f01c = [
    ...Object.values($15e5f1cf9df2e13c$export$67837434b2dea54f)
];
module.exports["ONBOARDING_ROLE_BASED_ACCESS_CONTROL"] = $15e5f1cf9df2e13c$export$67837434b2dea54f;
module.exports["RoleBasedAccessControlOnboardingKeys"] = $15e5f1cf9df2e13c$export$134f165f9f20f01c;

});

parcelRegister("ccGoc", function(module, exports) {
const $1acbcc6f3166a324$export$fa80c824b7402d9f = {
    ROVO_VIDEO_PLAYER_SEEN: 'onboarding-rovo-video-player:rovoVideoPlayerSeen'
};
const $1acbcc6f3166a324$export$d42bdf2f6333fafd = [
    ...Object.values($1acbcc6f3166a324$export$fa80c824b7402d9f)
];
module.exports["RovoVideoPlayerStateOnboardingKeys"] = $1acbcc6f3166a324$export$d42bdf2f6333fafd;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = [
    ...Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b)
];
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("2wUAJ", function(module, exports) {
const $70d55b678e14166c$export$13e578b1c1856d6f = {
    FLAGS_DISMISSED_FREE_THRESHOLD: 'storage-enforcement-state:flagsDismissedFreeThreshold'
};
const $70d55b678e14166c$export$abe3d9e5b5171ebf = [
    ...Object.values($70d55b678e14166c$export$13e578b1c1856d6f)
];
module.exports["STORAGE_ENFORCEMENT_STATE_KEYS"] = $70d55b678e14166c$export$13e578b1c1856d6f;
module.exports["StorageEnforcementOnboardingKeys"] = $70d55b678e14166c$export$abe3d9e5b5171ebf;

});

parcelRegister("6eN5W", function(module, exports) {
const $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f = {
    ACTION_MENU_OPENED: 'trial-components:actionMenuOpened',
    // The trial grace period is formally known as the "pre-dunning" period
    GRACE_PERIOD_BANNER_DISMISSED: 'trial-components:trialGracePeriodBannerDismissed',
    TRIAL_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial1DayFlag',
    TRIAL_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial3DayFlag',
    GRACE_PERIOD_0_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning0DayFlag',
    GRACE_PERIOD_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning1DayFlag',
    GRACE_PERIOD_2_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning2DayFlag',
    GRACE_PERIOD_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning3DayFlag',
    TRIAL_UNHANDLED_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrialUnhandledDayFlag'
};
const $e04ddb4a5df5bba6$export$8001dc7a7ed753e1 = [
    ...Object.values($e04ddb4a5df5bba6$export$840dd6f6c8ecd45f)
];
module.exports["TRIAL_COMPONENTS_EXPERIENCES"] = $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f;
module.exports["TrialComponentsOnboardingKeys"] = $e04ddb4a5df5bba6$export$8001dc7a7ed753e1;

});

parcelRegister("kNKrY", function(module, exports) {
const $9b3060c835515c41$export$ff14eab135fe9584 = {
    headerSeenAt: 'create-intro-first-step:headerSeenAt',
    headerCompleted: 'create-intro-first-step:headerCompleted',
    headerDismissed: 'create-intro-first-step:headerDismissed'
};
const $9b3060c835515c41$export$1c0fd29b58a87c97 = [
    ...Object.values($9b3060c835515c41$export$ff14eab135fe9584)
];
module.exports["CreateIntroFirstStepOnboardingStateKeys"] = $9b3060c835515c41$export$1c0fd29b58a87c97;

});

parcelRegister("lIcXr", function(module, exports) {
const $06a9ae8b05df4a8c$export$561442d092b808c6 = {
    HAS_SEEN_SPOTLIGHT: 'new-content-history-onboarding:hasSeenSpotlight1'
};
const $06a9ae8b05df4a8c$export$a8854c7bde991ac7 = [
    ...Object.values($06a9ae8b05df4a8c$export$561442d092b808c6)
];
module.exports["NEW_CONTENT_HISTORY_ONBOARDING_STATE_KEYS"] = $06a9ae8b05df4a8c$export$561442d092b808c6;
module.exports["NewContentHistoryOnboardingStateKeys"] = $06a9ae8b05df4a8c$export$a8854c7bde991ac7;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour',
    hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = [
    ...Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575)
];
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("eyUJP", function(module, exports) {
const $37b72543ace58c19$export$a266d7c13575e674 = {
    onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
    areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
    takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
    isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
    templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues'
};
const $37b72543ace58c19$export$f9348e90ce13bd50 = [
    ...Object.values($37b72543ace58c19$export$a266d7c13575e674)
];
module.exports["NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS"] = $37b72543ace58c19$export$a266d7c13575e674;
module.exports["NthUserHomeOnboardingRevampKeys"] = $37b72543ace58c19$export$f9348e90ce13bd50;

});

parcelRegister("eC276", function(module, exports) {
const $6acee6b0894846a1$export$fe11c6170169891b = {
    TOUR_COMPLETED: 'random:ExportJiraContextToPage:tourCompleted',
    TOUR_DISMISSED: 'random:ExportJiraContextToPage:tourDismissed'
};
const $6acee6b0894846a1$export$7eebc92289f9ff40 = [
    ...Object.values($6acee6b0894846a1$export$fe11c6170169891b)
];
module.exports["ExportJiraContextToPageTourKeys"] = $6acee6b0894846a1$export$7eebc92289f9ff40;

});

parcelRegister("fsF73", function(module, exports) {
const $29520d740d888926$export$84bb2ff8e52d4c63 = {
    HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight'
};
const $29520d740d888926$export$42e96b8eba35eec9 = [
    ...Object.values($29520d740d888926$export$84bb2ff8e52d4c63)
];
module.exports["CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS"] = $29520d740d888926$export$84bb2ff8e52d4c63;
module.exports["ConfluenceRecapOnboardingKeys"] = $29520d740d888926$export$42e96b8eba35eec9;

});

parcelRegister("bEwOV", function(module, exports) {
const $91bce0a19c17c87b$export$608e762b0e8c3e5d = {
    HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL: 'snippets:hasSeenFirstSnippetCreatedModal',
    HAS_SEEN_SNIPPETS_TAB_SPOTLIGHT: 'snippets:hasSeenSnippetsTabSpotlight'
};
const $91bce0a19c17c87b$export$cf7ec9d4d7075704 = [
    ...Object.values($91bce0a19c17c87b$export$608e762b0e8c3e5d)
];
module.exports["SNIPPETS_ONBOARDING"] = $91bce0a19c17c87b$export$608e762b0e8c3e5d;
module.exports["SnippetsOnboardingKeys"] = $91bce0a19c17c87b$export$cf7ec9d4d7075704;

});

parcelRegister("gGieN", function(module, exports) {
const $24bab03e25b23f73$export$df82485048e605d4 = {
    hasDismissedFlowChart: 'suggest-whiteboard-based-on-page-title:hasDismissedFlowChart',
    hasDismissedBrainstorming: 'suggest-whiteboard-based-on-page-title:hasDismissedBrainstorming',
    hasDismissedRetro: 'suggest-whiteboard-based-on-page-title:hasDismissedRetro',
    hasDismissedIncidentPostmortem: 'suggest-whiteboard-based-on-page-title:hasDismissedIncidentPostmortem',
    hasDismissedProductRoadmap: 'suggest-whiteboard-based-on-page-title:hasDismissedProductRoadmap',
    hasDismissedPrioritizationMatrix: 'suggest-whiteboard-based-on-page-title:hasDismissedPrioritizationMatrix',
    hasDismissedIcebreakers: 'suggest-whiteboard-based-on-page-title:hasDismissedIcebreakers',
    hasDismissedOrgChart: 'suggest-whiteboard-based-on-page-title:hasDismissedOrgChart',
    hasDismissedStickyNotePack: 'suggest-whiteboard-based-on-page-title:hasDismissedStickyNotePack',
    hasDismissedAllTemplateSuggestions: 'suggest-whiteboard-based-on-page-title:hasDismissedAllTemplateSuggestions'
};
const $24bab03e25b23f73$export$70c9c230d84d75ef = [
    ...Object.values($24bab03e25b23f73$export$df82485048e605d4)
];
module.exports["SUGGEST_WHITEBOARD_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS"] = $24bab03e25b23f73$export$df82485048e605d4;
module.exports["SuggestWhiteboardBasedOnPageTitleOnboardingKeys"] = $24bab03e25b23f73$export$70c9c230d84d75ef;

});

parcelRegister("iTy0f", function(module, exports) {
const $f4695f4ca31fd51c$export$a6cb5d34cb10fc27 = {
    CHANGEBOARD_VIEWED: 'smart-link-draggable:changeboardViewed'
};
const $f4695f4ca31fd51c$export$1a93287f12972b73 = Object.values($f4695f4ca31fd51c$export$a6cb5d34cb10fc27);
module.exports["SmartLinkDraggableOnboardingKeys"] = $f4695f4ca31fd51c$export$1a93287f12972b73;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("cgy0A", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $7u3UL = parcelRequire("7u3UL");


var $ies1q = parcelRequire("ies1q");


var $aUBmi = parcelRequire("aUBmi");

function $4d538ba06d23224f$var$pickBestSuggestion(suggestions) {
    return suggestions.reduce((a, b)=>a.confidence >= b.confidence ? a : b);
}
function $4d538ba06d23224f$var$serializeAdf(adf) {
    return JSON.stringify((0, $ies1q.wrapAdfWithDocNode)(adf));
}
function $4d538ba06d23224f$export$fbb5229d7f17a968(adf, origin) {
    const $ = (0, $frIzR.c)(10);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)(origin);
    const [isAiSuggestionLoading, setIsAiSuggestionLoading] = (0, $42omo.useState)(false);
    const [aiSuggestedName, setAiSuggestedName] = (0, $42omo.useState)(null);
    const [aiSuggestedDescription, setAiSuggestedDescription] = (0, $42omo.useState)(null);
    let t0;
    let t1;
    if ($[0] !== adf || $[1] !== cloudId || $[2] !== fireFailedAnalytic || $[3] !== fireSuccessAnalytic) {
        t0 = ()=>{
            if (!adf || !cloudId) {
                const error = !adf ? "No adf" : "No cloudId";
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_AI_METADATA, {
                    error: error
                });
                return;
            }
            setIsAiSuggestionLoading(true);
            const startTime = performance.now();
            const adfContent = $4d538ba06d23224f$var$serializeAdf(adf);
            const adfBodySize = adfContent.length;
            $7u3UL.fetchSnippetMetadata({
                adfContent: adfContent
            }, cloudId).then((response)=>{
                const durationMs = Math.round(performance.now() - startTime);
                const suggestionCount = response.suggestions?.length ?? 0;
                if (!suggestionCount) {
                    fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_AI_METADATA, {
                        suggestionCount: 0,
                        adfBodySize: adfBodySize,
                        durationMs: durationMs
                    });
                    return;
                }
                const bestSuggestion = $4d538ba06d23224f$var$pickBestSuggestion(response.suggestions);
                fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_AI_METADATA, {
                    suggestionCount: suggestionCount,
                    confidences: response.suggestions.map($4d538ba06d23224f$var$_temp),
                    suggestedNameLength: bestSuggestion.name?.length ?? 0,
                    suggestedDescriptionLength: bestSuggestion.description?.length ?? 0,
                    adfBodySize: adfBodySize,
                    durationMs: durationMs
                });
                setAiSuggestedName(bestSuggestion.name ?? "");
                setAiSuggestedDescription(bestSuggestion.description ?? "");
            }).catch((error_0)=>{
                const durationMs_0 = Math.round(performance.now() - startTime);
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_AI_METADATA, {
                    error: error_0 instanceof Error ? error_0.message : "Unknown error",
                    ...error_0 instanceof (0, $7u3UL.SnippetMetadataError) && {
                        statusCode: error_0.statusCode
                    },
                    adfBodySize: adfBodySize,
                    durationMs: durationMs_0
                });
                (0, $aUBmi.reportError)(error_0);
            }).finally(()=>{
                setIsAiSuggestionLoading(false);
            });
        };
        t1 = [
            adf,
            cloudId,
            fireFailedAnalytic,
            fireSuccessAnalytic
        ];
        $[0] = adf;
        $[1] = cloudId;
        $[2] = fireFailedAnalytic;
        $[3] = fireSuccessAnalytic;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[6] !== aiSuggestedDescription || $[7] !== aiSuggestedName || $[8] !== isAiSuggestionLoading) {
        t2 = {
            isAiSuggestionLoading: isAiSuggestionLoading,
            aiSuggestedName: aiSuggestedName,
            aiSuggestedDescription: aiSuggestedDescription
        };
        $[6] = aiSuggestedDescription;
        $[7] = aiSuggestedName;
        $[8] = isAiSuggestionLoading;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
}
function $4d538ba06d23224f$var$_temp(s) {
    return s.confidence;
}
module.exports["useAiSuggestions"] = $4d538ba06d23224f$export$fbb5229d7f17a968;

});

parcelRegister("jxXkP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $inPa6 = parcelRequire("inPa6");


var $hPTbh = parcelRequire("hPTbh");

const $5d19246504a43db4$export$8076fd3f013c4bb9 = (origin)=>{
    const $ = (0, $frIzR.c)(28);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== origin) {
        t0 = (attributes)=>{
            if (!origin) return attributes;
            return {
                origin: origin,
                ...attributes
            };
        };
        $[0] = origin;
        $[1] = t0;
    } else t0 = $[1];
    const mergeAttributes = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== mergeAttributes) {
        t1 = (data)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_UI_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).UI,
                    ...data,
                    attributes: mergeAttributes(data.attributes)
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = mergeAttributes;
        $[4] = t1;
    } else t1 = $[4];
    const fireUIAnalytic = t1;
    let t2;
    if ($[5] !== createAnalyticsEvent || $[6] !== mergeAttributes) {
        t2 = (data_0)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_OPERATIONAL_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).OPERATIONAL,
                    ...data_0,
                    attributes: mergeAttributes(data_0.attributes)
                }
            }).fire();
        };
        $[5] = createAnalyticsEvent;
        $[6] = mergeAttributes;
        $[7] = t2;
    } else t2 = $[7];
    const fireOperationalAnalytic = t2;
    let t3;
    if ($[8] !== fireUIAnalytic) {
        t3 = (actionSubjectId, attributes_0)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).BUTTON,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId,
                attributes: attributes_0
            });
        };
        $[8] = fireUIAnalytic;
        $[9] = t3;
    } else t3 = $[9];
    const fireButtonClickedAnalytic = t3;
    let t4;
    if ($[10] !== fireUIAnalytic) {
        t4 = (actionSubjectId_0, attributes_1)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).MODAL,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLOSED,
                actionSubjectId: actionSubjectId_0,
                attributes: attributes_1
            });
        };
        $[10] = fireUIAnalytic;
        $[11] = t4;
    } else t4 = $[11];
    const fireModalClosedAnalytic = t4;
    let t5;
    if ($[12] !== fireUIAnalytic) {
        t5 = (actionSubjectId_1, attributes_2)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).TEXT_FIELD,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).TYPED,
                actionSubjectId: actionSubjectId_1,
                attributes: attributes_2
            });
        };
        $[12] = fireUIAnalytic;
        $[13] = t5;
    } else t5 = $[13];
    const fireTextFieldTypedAnalytic = t5;
    let t6;
    if ($[14] !== fireUIAnalytic) {
        t6 = (actionSubjectId_2, attributes_3)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).DROPDOWN_ITEM,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId_2,
                attributes: attributes_3
            });
        };
        $[14] = fireUIAnalytic;
        $[15] = t6;
    } else t6 = $[15];
    const fireDropdownItemClickedAnalytic = t6;
    let t7;
    if ($[16] !== fireOperationalAnalytic) {
        t7 = (actionSubject, attributes_4)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FAILED,
                attributes: attributes_4
            });
        };
        $[16] = fireOperationalAnalytic;
        $[17] = t7;
    } else t7 = $[17];
    const fireFailedAnalytic = t7;
    let t8;
    if ($[18] !== fireOperationalAnalytic) {
        t8 = (actionSubject_0, attributes_5)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject_0,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).SUCCEEDED,
                attributes: attributes_5
            });
        };
        $[18] = fireOperationalAnalytic;
        $[19] = t8;
    } else t8 = $[19];
    const fireSuccessAnalytic = t8;
    let t9;
    if ($[20] !== fireButtonClickedAnalytic || $[21] !== fireDropdownItemClickedAnalytic || $[22] !== fireFailedAnalytic || $[23] !== fireModalClosedAnalytic || $[24] !== fireOperationalAnalytic || $[25] !== fireSuccessAnalytic || $[26] !== fireTextFieldTypedAnalytic) {
        t9 = {
            fireOperationalAnalytic: fireOperationalAnalytic,
            fireButtonClickedAnalytic: fireButtonClickedAnalytic,
            fireModalClosedAnalytic: fireModalClosedAnalytic,
            fireTextFieldTypedAnalytic: fireTextFieldTypedAnalytic,
            fireDropdownItemClickedAnalytic: fireDropdownItemClickedAnalytic,
            fireFailedAnalytic: fireFailedAnalytic,
            fireSuccessAnalytic: fireSuccessAnalytic
        };
        $[20] = fireButtonClickedAnalytic;
        $[21] = fireDropdownItemClickedAnalytic;
        $[22] = fireFailedAnalytic;
        $[23] = fireModalClosedAnalytic;
        $[24] = fireOperationalAnalytic;
        $[25] = fireSuccessAnalytic;
        $[26] = fireTextFieldTypedAnalytic;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
};
module.exports["useSnippetAnalytics"] = $5d19246504a43db4$export$8076fd3f013c4bb9;

});

parcelRegister("7u3UL", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $lLaHL = parcelRequire("lLaHL");

const $e8d3a8559be06eee$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Experience-Id': 'confluence-snippets-metadata',
    'X-Product': 'confluence'
};
const $e8d3a8559be06eee$var$CONVERSATIONAL_AI_PLATFORM_API_URL = '/gateway/api/assist';
const $e8d3a8559be06eee$var$METADATA_PATH = '/api/confluence/v1/snippets/metadata';
class $e8d3a8559be06eee$export$1945c41c4351e1ba extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = void 0;
        this.name = 'SnippetMetadataError';
        this.statusCode = statusCode;
    }
}
const $e8d3a8559be06eee$export$9a61bf75a3648739 = async (snippetMetadataPayload, cloudId)=>{
    let response;
    try {
        response = await (0, $f7B1p.cfetch)(`${$e8d3a8559be06eee$var$CONVERSATIONAL_AI_PLATFORM_API_URL}${$e8d3a8559be06eee$var$METADATA_PATH}`, {
            method: 'POST',
            headers: {
                ...$e8d3a8559be06eee$var$COMMON_HEADERS,
                'X-Cloudid': cloudId
            },
            body: JSON.stringify(snippetMetadataPayload)
        });
    } catch (err) {
        if ((0, $hBkCm.BadStatusError).isBadStatusError(err)) throw new $e8d3a8559be06eee$export$1945c41c4351e1ba(`Snippet metadata request failed: ${err.response.statusText}`, err.response.status);
        throw err;
    }
    const data = await response.json();
    if (!(0, $lLaHL.isValidSnippetMetadataResponse)(data)) throw new $e8d3a8559be06eee$export$1945c41c4351e1ba('Snippet metadata request failed: Invalid response');
    return data;
};
module.exports["SnippetMetadataError"] = $e8d3a8559be06eee$export$1945c41c4351e1ba;
module.exports["fetchSnippetMetadata"] = $e8d3a8559be06eee$export$9a61bf75a3648739;

});

parcelRegister("lLaHL", function(module, exports) {
function $af3686d25f9c79c6$export$96ab9a725de80077(value) {
    return !!value && typeof value === 'object' && 'suggestions' in value && Array.isArray(value.suggestions);
}
module.exports["isValidSnippetMetadataResponse"] = $af3686d25f9c79c6$export$96ab9a725de80077;

});

parcelRegister("ies1q", function(module, exports) {
function $fde34fcb96f8fe70$var$filterValidAdfNodes(nodes) {
    return nodes.filter((node)=>node !== undefined && node !== null);
}
const $fde34fcb96f8fe70$export$4cb5aec6fe7a20df = (content)=>{
    try {
        const parsedContent = JSON.parse(content);
        // Handle fragment (array of nodes without doc wrapper)
        if (Array.isArray(parsedContent)) return $fde34fcb96f8fe70$var$filterValidAdfNodes(parsedContent);
        // Handle single node or doc node
        const adfContent = parsedContent;
        if (adfContent.type === 'doc' && Array.isArray(adfContent.content)) return $fde34fcb96f8fe70$var$filterValidAdfNodes(adfContent.content);
        return adfContent;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error processing snippet ADF:', error);
        return undefined;
    }
};
const $fde34fcb96f8fe70$var$EMPTY_ADF = {
    type: 'doc',
    version: 1,
    content: []
};
const $fde34fcb96f8fe70$export$12649e099d1966de = (adf)=>{
    if (!adf) return $fde34fcb96f8fe70$var$EMPTY_ADF;
    const docType = 'doc';
    const isArray = Array.isArray(adf);
    if (!isArray && adf.type === docType) return adf;
    const content = isArray ? adf : [
        adf
    ];
    return {
        version: 1,
        type: docType,
        content: content
    };
};
module.exports["parseSnippetContent"] = $fde34fcb96f8fe70$export$4cb5aec6fe7a20df;
module.exports["wrapAdfWithDocNode"] = $fde34fcb96f8fe70$export$12649e099d1966de;

});

parcelRegister("aUBmi", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $29dc66e92b22c80c$export$b33b857ad1d9900e = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
};
module.exports["reportError"] = $29dc66e92b22c80c$export$b33b857ad1d9900e;

});

parcelRegister("eWCeD", function(module, exports) {
class $6ad5f72792cdeefd$export$e48d728925b396bf extends Error {
    constructor(message){
        super(`Snippet error: ${message}`);
        this.statusCode = void 0;
    }
}
const $6ad5f72792cdeefd$var$BODY_TOO_LARGE_PATTERN = /body must be \d+\s*KB or less/i;
const $6ad5f72792cdeefd$export$c09a7180561ac878 = (err)=>err instanceof $6ad5f72792cdeefd$export$e48d728925b396bf && err.statusCode === 400 && $6ad5f72792cdeefd$var$BODY_TOO_LARGE_PATTERN.test(err.message);
module.exports["SnippetError"] = $6ad5f72792cdeefd$export$e48d728925b396bf;
module.exports["isBodyTooLargeError"] = $6ad5f72792cdeefd$export$c09a7180561ac878;

});

parcelRegister("dZUkS", function(module, exports) {
/**
 * Snippets Store - Centralized State Management
 *
 * This module provides a centralized store for managing snippets data
 * using react-sweet-state. This replaces the previous pattern of individual hooks
 * (useCreateSnippet, useFetchSnippets) with a single source of truth.
 *
 * Usage:
 * - Wrap your app with <SnippetsProvider> to trigger initial fetch
 * - Use useSnippetsState() for read-only state access
 * - Use useSnippetsActions() when you need to dispatch actions
 * - Use useSnippets() when you need both state and actions
 */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");


var $7DXt6 = parcelRequire("7DXt6");


var $ebSlI = parcelRequire("ebSlI");


var $a6kUr = parcelRequire("a6kUr");

const $bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e = (0, $1P1Tu.createStore)({
    initialState: (0, $ebSlI.getInitialState)(),
    actions: $a6kUr.actions,
    name: 'SnippetsStore'
});
const $bc4bb1bc094c1f8d$export$f6df4e69084aa09f = (0, $9zUhf.createHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$bc515607f82ac38d = (0, $9zUhf.createActionsHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$d2573ca28cf6a6de = (0, $9zUhf.createStateHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$9211bc7cf74ad61b = ()=>{
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
    return storeInstance.storeState.getState();
};
const $bc4bb1bc094c1f8d$export$cf5f21fefd1a9a8a = (0, $7DXt6.onCurrentFetchComplete);
module.exports["useSnippets"] = $bc4bb1bc094c1f8d$export$f6df4e69084aa09f;
module.exports["useSnippetsActions"] = $bc4bb1bc094c1f8d$export$bc515607f82ac38d;
module.exports["useSnippetsState"] = $bc4bb1bc094c1f8d$export$d2573ca28cf6a6de;
module.exports["getSnippetsStateSnapshot"] = $bc4bb1bc094c1f8d$export$9211bc7cf74ad61b;
module.exports["onCurrentFetchComplete"] = $bc4bb1bc094c1f8d$export$cf5f21fefd1a9a8a;

});

parcelRegister("7DXt6", function(module, exports) {
/**
 * Module-level registry for one-time callbacks that fire when the current in-flight fetch completes.
 * These callbacks are cleared after each fetch completes and are NOT triggered by future fetches.
 */ let $840c51e2f085aaa9$var$pendingLoadCallbacks = [];
const $840c51e2f085aaa9$export$cf5f21fefd1a9a8a = (callback)=>{
    $840c51e2f085aaa9$var$pendingLoadCallbacks.push(callback);
};
const $840c51e2f085aaa9$export$3ce7f1b7cae8932a = (snippets)=>{
    const callbacks = $840c51e2f085aaa9$var$pendingLoadCallbacks;
    $840c51e2f085aaa9$var$pendingLoadCallbacks = []; // Clear before invoking to prevent re-registration issues
    callbacks.forEach((cb)=>cb(snippets));
};
module.exports["onCurrentFetchComplete"] = $840c51e2f085aaa9$export$cf5f21fefd1a9a8a;
module.exports["invokePendingLoadCallbacks"] = $840c51e2f085aaa9$export$3ce7f1b7cae8932a;

});

parcelRegister("ebSlI", function(module, exports) {
/**
 * Snippets Store Types
 *
 * Defines the shape of the centralized snippets state for managing snippets data.
 * The `isLoaded` flag is crucial for preventing duplicate fetch requests -
 * once snippets are loaded, subsequent calls to fetchSnippets() will return
 * the cached data immediately.
 *
 * Site configuration:
 * - `isSnippetSharingForSiteEnabled`: Set once on first fetch from site config; used for Access field and refetches.
 *
 * Error state:
 * - `fetchError`: Set when fetching snippets fails
 */ 
var $kBRLU = parcelRequire("kBRLU");


var $gPFNt = parcelRequire("gPFNt");

const $523eaf9335c60db8$export$e88dfa32f0f8be4a = ()=>({
        selectedSnippetId: null,
        selectedCategoryId: (0, $kBRLU.DEFAULT_CATEGORY_ID),
        searchQuery: '',
        sortOrder: (0, $gPFNt.DEFAULT_SNIPPET_SORT_ORDER)
    });
const $523eaf9335c60db8$export$53ac33307b5acee9 = ()=>({
        snippets: [],
        isLoading: false,
        isClaimingShare: false,
        fetchError: null,
        isLoaded: false,
        templateGallery: $523eaf9335c60db8$export$e88dfa32f0f8be4a()
    });
module.exports["getInitialTemplateGalleryState"] = $523eaf9335c60db8$export$e88dfa32f0f8be4a;
module.exports["getInitialState"] = $523eaf9335c60db8$export$53ac33307b5acee9;

});

parcelRegister("kBRLU", function(module, exports) {
/**
 * Snippet Category Constants
 *
 * Defines the available category filter IDs for snippets. Category labels
 * are provided by useSnippetFilterCategories. Categories are used by the
 * SnippetTabContent component and the useSnippetFilterAndSort hook.
 *
 * Category filtering logic:
 * - ALL: Shows all snippets (no filtering)
 * - MY_TEMPLATES: Shows only snippets created by the current user
 * - FAVORITES: Shows only snippets marked as favorites
 */ /** Constant IDs for snippet category filters - used as keys in state and filter logic */ var $9fd8f8887cf22774$export$83f66926d5f092b5 = /*#__PURE__*/ function(SNIPPET_CATEGORY_IDS) {
    SNIPPET_CATEGORY_IDS["ALL"] = "snippets.all";
    SNIPPET_CATEGORY_IDS["MY_TEMPLATES"] = "snippets.my-templates";
    SNIPPET_CATEGORY_IDS["FAVORITES"] = "snippets.favorites";
    return SNIPPET_CATEGORY_IDS;
}({});
const $9fd8f8887cf22774$export$5b046c946c4ab60f = "snippets.all";
module.exports["SNIPPET_CATEGORY_IDS"] = $9fd8f8887cf22774$export$83f66926d5f092b5;
module.exports["DEFAULT_CATEGORY_ID"] = $9fd8f8887cf22774$export$5b046c946c4ab60f;

});

parcelRegister("gPFNt", function(module, exports) {
/**
 * Sort order options for snippet lists.
 *
 * Used by the SnippetSortDropdown and useSnippetFilterAndSort to determine
 * how snippets are ordered in the panel.
 */ var $f130004a9fad02a7$export$1fbcbf3366f925b0 = /*#__PURE__*/ function(SnippetSortOrder) {
    SnippetSortOrder["CREATED_AT"] = "CREATED_AT";
    SnippetSortOrder["LAST_UPDATED"] = "LAST_UPDATED";
    SnippetSortOrder["POPULARITY"] = "POPULARITY";
    SnippetSortOrder["ALPHABETICAL"] = "ALPHABETICAL";
    return SnippetSortOrder;
}({});
const $f130004a9fad02a7$export$c135813ba1be028a = "CREATED_AT";
module.exports["SnippetSortOrder"] = $f130004a9fad02a7$export$1fbcbf3366f925b0;
module.exports["DEFAULT_SNIPPET_SORT_ORDER"] = $f130004a9fad02a7$export$c135813ba1be028a;

});

parcelRegister("a6kUr", function(module, exports) {

var $5NAso = parcelRequire("5NAso");


var $kZ6BG = parcelRequire("kZ6BG");


var $5ogZS = parcelRequire("5ogZS");


var $2Qxf3 = parcelRequire("2Qxf3");


var $adRf2 = parcelRequire("adRf2");


var $gdHn1 = parcelRequire("gdHn1");


var $kvZfs = parcelRequire("kvZfs");


var $cfxyE = parcelRequire("cfxyE");

const $211e3bb4477563d9$export$e324594224ef24da = {
    ...(0, $2Qxf3.fetchActions),
    ...(0, $5NAso.createActions),
    ...(0, $kZ6BG.deleteActions),
    ...(0, $cfxyE.updateActions),
    ...(0, $5ogZS.favoriteActions),
    ...(0, $gdHn1.shareActions),
    ...(0, $adRf2.insertCountActions),
    ...(0, $kvZfs.templateGalleryActions)
};
module.exports["actions"] = $211e3bb4477563d9$export$e324594224ef24da;

});

parcelRegister("5NAso", function(module, exports) {
/**
 * Create Actions - Snippet creation with UI integration
 *
 * This action handles snippet creation (and duplication) with full UI integration:
 * - Creates the snippet via the API
 * - Shows success/error flags
 * - Adds the snippet to the editor's quick insert menu
 * - Refreshes the snippets list
 *
 * Both CreateSnippetModal and DuplicateSnippetModal call createSnippet, each
 * passing their own i18n messages via options.messages.
 */ 
var $jU9SA = parcelRequire("jU9SA");


var $6K2yS = parcelRequire("6K2yS");


var $aUBmi = parcelRequire("aUBmi");


var $3e10B = parcelRequire("3e10B");


var $lIx1f = parcelRequire("lIx1f");


var $eDBud = parcelRequire("eDBud");


var $9gUQP = parcelRequire("9gUQP");

const $d34b4d835ec45f27$export$aad2e27b28b19174 = {
    /**
   * Creates a new snippet and refreshes the snippets list.
   *
   * After successful creation:
   * - Clears the service cache and fetches the updated list
   * - Shows a success flag (if options provided)
   * - Adds the snippet to the quick insert menu
   *
   * On error:
   * - Reports to monitoring
   * - Shows an error flag (if options provided)
   * - Keeps existing snippets visible (doesn't reset isLoaded)
   *
   * @param name - The snippet name (required)
   * @param body - The ADF content body
   * @param description - Optional description text
   * @param options - UI options including flags, intl, editor API ref, and i18n messages
   * @returns Promise resolving to the newly created snippet, or null on failure
   */ createSnippet: (name, body, description, options)=>async (storeApi)=>{
            const { getState: getState, setState: setState } = storeApi;
            const messages = options?.messages ?? (0, $jU9SA.createSnippetModalMessages);
            const params = (0, $9gUQP.buildCreatePayload)(name, body, description);
            setState({
                isLoading: true
            });
            try {
                const snippet = await $3e10B.createSnippet(params);
                const isSnippetSharingForSiteEnabled = getState().isSnippetSharingForSiteEnabled;
                (0, $lIx1f.clearSnippetsCache)();
                const updatedSnippets = await $3e10B.fetchSnippets({
                    isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled
                });
                setState({
                    snippets: updatedSnippets,
                    isLoading: false,
                    isLoaded: true
                });
                if (options) {
                    const { flags: flags, intl: intl, editorAPI: editorAPI, isShared: isShared, onShareFailure: onShareFailure, successFlagActions: successFlagActions, showSuccessFlag: showSuccessFlag = true } = options;
                    if (showSuccessFlag) (0, $eDBud.showSnippetSuccessFlag)(flags, intl.formatMessage(messages.successFlagTitle, {
                        snippetName: snippet.name
                    }), intl.formatMessage((0, $6K2yS.messages).successFlagDescription), successFlagActions);
                    await (0, $9gUQP.addSnippetToQuickInsertAndShare)({
                        snippet: snippet,
                        options: {
                            flags: flags,
                            intl: intl,
                            editorAPI: editorAPI,
                            isShared: isShared
                        },
                        storeApi: storeApi,
                        onShareFailure: onShareFailure
                    });
                }
                return snippet;
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                setState({
                    isLoading: false
                });
                (0, $aUBmi.reportError)(err);
                if (options) {
                    options.onSaveFailure?.(err);
                    const { flagTitle: flagTitle, flagDescription: flagDescription } = (0, $9gUQP.getSnippetErrorFlagMessages)(err, messages.errorFlagTitle, messages.errorFlagDescription);
                    (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage(flagTitle), options.intl.formatMessage(flagDescription));
                    return null;
                }
                throw err;
            }
        }
};
module.exports["createActions"] = $d34b4d835ec45f27$export$aad2e27b28b19174;

});

parcelRegister("jU9SA", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9c872498afbde1b3$export$14b1a9d585ebb136 = (0, $aXWIB.defineMessages)({
    titleCreate: {
        id: "snippets.snippetEditorModal.titleCreate",
        defaultMessage: "Create block template"
    },
    createButton: {
        id: "snippets.snippetEditorModal.createButton",
        defaultMessage: "Create"
    },
    successFlagTitle: {
        id: "snippets.snippetEditorModal.successFlagTitle",
        defaultMessage: "Template \"{snippetName}\" created"
    },
    errorFlagTitle: {
        id: "snippets.snippetEditorModal.errorFlagTitle",
        defaultMessage: "Could not create template"
    },
    errorFlagDescription: {
        id: "snippets.snippetEditorModal.errorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["createSnippetModalMessages"] = $9c872498afbde1b3$export$14b1a9d585ebb136;

});

parcelRegister("6K2yS", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $e858a4f8aa1513e4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    nameLabel: {
        id: "snippets.snippetEditorModal.nameLabel",
        defaultMessage: "Template Name"
    },
    namePlaceholder: {
        id: "snippets.snippetEditorModal.namePlaceholder",
        defaultMessage: "Enter template name"
    },
    nameError: {
        id: "snippets.snippetEditorModal.nameError",
        defaultMessage: "Name is required"
    },
    descriptionLabel: {
        id: "snippets.snippetEditorModal.descriptionLabel",
        defaultMessage: "Description"
    },
    descriptionPlaceholder: {
        id: "snippets.snippetEditorModal.descriptionPlaceholder",
        defaultMessage: "Enter template description"
    },
    saveToLabel: {
        id: "snippets.snippetEditorModal.saveToLabel",
        defaultMessage: "Save to"
    },
    adfError: {
        id: "snippets.snippetEditorModal.adfError",
        defaultMessage: "Something went wrong, please make a new content selection"
    },
    cancelButton: {
        id: "snippets.snippetEditorModal.cancelButton",
        defaultMessage: "Cancel"
    },
    contentTooLargeFlagTitle: {
        id: "snippets.snippetEditorModal.contentTooLargeFlagTitle",
        defaultMessage: "Template content is too large"
    },
    contentTooLargeFlagDescription: {
        id: "snippets.snippetEditorModal.contentTooLargeFlagDescription",
        defaultMessage: "Reduce the content size and try again"
    },
    successFlagViewTemplateAction: {
        id: "snippets.snippetEditorModal.successFlagViewTemplateAction",
        defaultMessage: "View template"
    },
    successFlagDescription: {
        id: "snippets.snippetEditorModal.successFlagDescription",
        defaultMessage: "You can now use it from the / menu"
    }
});
module.exports["messages"] = $e858a4f8aa1513e4$export$defe85febe8b728c;

});

parcelRegister("3e10B", function(module, exports) {

var $bRFwa = parcelRequire("bRFwa");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $aUBmi = parcelRequire("aUBmi");


var $77Hid = parcelRequire("77Hid");


var $eWCeD = parcelRequire("eWCeD");


var $5ra2J = parcelRequire("5ra2J");


var $lIx1f = parcelRequire("lIx1f");


var $jGJP7 = parcelRequire("jGJP7");

const $08eb629ddb2e8bad$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $08eb629ddb2e8bad$var$cfetchSnippet = async (...args)=>{
    try {
        return await (0, $f7B1p.cfetch)(...args);
    } catch (err) {
        if ((0, $hBkCm.BadStatusError).isBadStatusError(err)) {
            const body = await err.response.json().catch(()=>({}));
            const snippetErr = new (0, $eWCeD.SnippetError)(body?.error ?? err.response.statusText);
            snippetErr.statusCode = err.response.status;
            throw snippetErr;
        }
        throw err;
    }
};
const $08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL = '/gateway/api/blocks/v1';
const $08eb629ddb2e8bad$var$SNIPPETS_PATH = '/snippets';
const $08eb629ddb2e8bad$export$a891d387a4e7ba6f = async ()=>{
    try {
        const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL}${$08eb629ddb2e8bad$var$SNIPPETS_PATH}/settings`, {
            method: 'GET',
            headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
        });
        const data = await response.json();
        return data.sharingEnabled;
    } catch (error) {
        (0, $aUBmi.reportError)(error instanceof Error ? error : new (0, $eWCeD.SnippetError)(String(error)));
        return false;
    }
};
const $08eb629ddb2e8bad$export$424a614da735364c = (options)=>{
    return (0, $lIx1f.withSnippetsCache)(async ()=>{
        const isSnippetSharingForSiteEnabled = options?.isSnippetSharingForSiteEnabled !== undefined ? options.isSnippetSharingForSiteEnabled : await $08eb629ddb2e8bad$export$a891d387a4e7ba6f();
        const [userSnippetsResult, globalSnippetsResult, siteSnippetsResult] = await Promise.allSettled([
            $08eb629ddb2e8bad$var$fetchSnippetData((0, $jGJP7.SnippetScope).USER),
            $08eb629ddb2e8bad$var$fetchSnippetData((0, $jGJP7.SnippetScope).GLOBAL),
            isSnippetSharingForSiteEnabled ? $08eb629ddb2e8bad$var$fetchSnippetData((0, $jGJP7.SnippetScope).SITE) : Promise.resolve([])
        ]);
        const userSnippets = userSnippetsResult.status === 'fulfilled' ? await (0, $5ra2J.transformSnippets)(userSnippetsResult.value) : ($08eb629ddb2e8bad$var$logResultError(userSnippetsResult.reason, (0, $jGJP7.SnippetScope).USER), []);
        const globalSnippets = globalSnippetsResult.status === 'fulfilled' ? await (0, $5ra2J.transformSnippets)(globalSnippetsResult.value) : ($08eb629ddb2e8bad$var$logResultError(globalSnippetsResult.reason, (0, $jGJP7.SnippetScope).GLOBAL), []);
        const siteSnippets = siteSnippetsResult.status === 'fulfilled' ? await (0, $5ra2J.transformSnippets)(siteSnippetsResult.value) : ($08eb629ddb2e8bad$var$logResultError(siteSnippetsResult.reason, (0, $jGJP7.SnippetScope).SITE), []);
        return [
            ...userSnippets,
            ...globalSnippets,
            ...siteSnippets
        ];
    });
};
const $08eb629ddb2e8bad$var$fetchSnippetData = async (scope)=>{
    const responseData = await (0, $bRFwa.fetchSnippetsData)({
        format: (0, $77Hid.SnippetBodyFormat).ADF,
        product: (0, $jGJP7.SnippetProduct).CONFLUENCE,
        scope: scope
    });
    if (!responseData.success) return [];
    // Success and error can both be present, so we need to log the error if it is present
    if (Array.isArray(responseData.error) && responseData.error.length > 0) responseData.error.forEach((error)=>{
        $08eb629ddb2e8bad$var$logResultError(error, scope);
    });
    return responseData.success;
};
const $08eb629ddb2e8bad$export$f7bed3a90241a88a = async (params)=>{
    const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify(params)
    });
    const responseData = await response.json();
    const snippet = await (0, $5ra2J.transformSnippet)(responseData);
    // Clear the cache so the newly created snippet appears when fetching snippets again
    // (e.g., when navigating to a different page or when the extension provider rebuilds)
    // Quick insert only adds the new snippet to the current editor instance's menu
    // navigating to a new edit page the extension providers rebuilds and call fetchSnippets which will return the cached data.
    (0, $lIx1f.clearSnippetsCache)();
    if (snippet) return snippet;
    else throw new Error('Unable to transform snippet data after creation');
};
const $08eb629ddb2e8bad$export$ba93a91dd8596775 = async (snippetId)=>{
    await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}`, {
        method: 'DELETE',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
};
const $08eb629ddb2e8bad$export$23a793f970583236 = async (snippetId, snippetPayload)=>{
    const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}`, {
        method: 'PUT',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify(snippetPayload)
    });
    const responseData = await response.json();
    const snippet = await (0, $5ra2J.transformSnippet)(responseData);
    // Clear the cache so the updated snippet appears when fetching snippets again
    // (e.g., when navigating to a different page or when the extension provider rebuilds)
    (0, $lIx1f.clearSnippetsCache)();
    if (snippet) return snippet;
    else throw new Error('Unable to transform snippet data after update');
};
const $08eb629ddb2e8bad$export$d8ad364ff92072df = async (snippetId)=>{
    const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/favorite`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    return response.json();
};
const $08eb629ddb2e8bad$export$8fa65d63d256253e = async (snippetId)=>{
    await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/favorite`, {
        method: 'DELETE',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
};
const $08eb629ddb2e8bad$export$d055ce15e6ca2d50 = async (snippetId)=>{
    try {
        await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/insertCount`, {
            method: 'PUT',
            headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
        });
    } catch (error) {
        (0, $aUBmi.reportError)(error instanceof Error ? error : new (0, $eWCeD.SnippetError)(String(error)));
    }
};
const $08eb629ddb2e8bad$export$694c1dfa19cf1dd0 = async (snippetId)=>{
    await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/share`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    // Clear the cache so the newly created snippet appears when fetching snippets again
    // (e.g., when navigating to a different page or when the extension provider rebuilds)
    // Quick insert only adds the new snippet to the current editor instance's menu
    // navigating to a new edit page the extension providers rebuilds and call fetchSnippets which will return the cached data.
    // TODO: revisit if clearSnippetsCache is needed for create, update, duplicate, etc.
    (0, $lIx1f.clearSnippetsCache)();
};
const $08eb629ddb2e8bad$export$47e429919a88c99 = async (snippetId, shareId)=>{
    const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL}${$08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/share/claim`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify({
            shareId: shareId
        })
    });
    return response.json();
};
const $08eb629ddb2e8bad$export$c0ff842d3c1f78b9 = async (snippetId)=>{
    await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/share`, {
        method: 'DELETE',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    (0, $lIx1f.clearSnippetsCache)();
};
const $08eb629ddb2e8bad$var$logResultError = (reason, scope)=>{
    const reasonString = reason instanceof Error ? reason.message : JSON.stringify(reason);
    const errorToLog = new Error(`Error when fetching ${scope} scoped snippets: ${reasonString}`);
    (0, $aUBmi.reportError)(errorToLog);
};
module.exports["getIsSnippetSharingForSiteEnabled"] = $08eb629ddb2e8bad$export$a891d387a4e7ba6f;
module.exports["fetchSnippets"] = $08eb629ddb2e8bad$export$424a614da735364c;
module.exports["createSnippet"] = $08eb629ddb2e8bad$export$f7bed3a90241a88a;
module.exports["deleteSnippet"] = $08eb629ddb2e8bad$export$ba93a91dd8596775;
module.exports["updateSnippet"] = $08eb629ddb2e8bad$export$23a793f970583236;
module.exports["favoriteSnippet"] = $08eb629ddb2e8bad$export$d8ad364ff92072df;
module.exports["unfavoriteSnippet"] = $08eb629ddb2e8bad$export$8fa65d63d256253e;
module.exports["incrementSnippetInsertCount"] = $08eb629ddb2e8bad$export$d055ce15e6ca2d50;
module.exports["shareSnippet"] = $08eb629ddb2e8bad$export$694c1dfa19cf1dd0;
module.exports["claimSnippetShare"] = $08eb629ddb2e8bad$export$47e429919a88c99;
module.exports["unshareSnippet"] = $08eb629ddb2e8bad$export$c0ff842d3c1f78b9;

});

parcelRegister("bRFwa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dx2GL = parcelRequire("dx2GL");


var $jGJP7 = parcelRequire("jGJP7");


var $duQjP = parcelRequire("duQjP");

const $f53f67e32b6005ed$var$SNIPPETS_PATH = '/snippets';
const $f53f67e32b6005ed$export$a891d387a4e7ba6f = async ()=>{
    try {
        const response = await fetch(`${(0, $dx2GL.BLOCK_SERVICE_API_URL)}${$f53f67e32b6005ed$var$SNIPPETS_PATH}/settings`, {
            method: 'GET'
        });
        const data = await response.json();
        return data.sharingEnabled;
    } catch (error) {
        return false;
    }
};
const $f53f67e32b6005ed$export$424a614da735364c = async (params)=>{
    const isSnippetSharingForSiteEnabled = await $f53f67e32b6005ed$export$a891d387a4e7ba6f();
    const [globalSnippetsResponse, siteSnippetsResponse, userSnippetsResponse] = await Promise.allSettled([
        $f53f67e32b6005ed$export$cf060afb8b9f33e4({
            ...params,
            scope: (0, $jGJP7.SnippetScope).GLOBAL
        }),
        isSnippetSharingForSiteEnabled ? $f53f67e32b6005ed$export$cf060afb8b9f33e4({
            ...params,
            scope: (0, $jGJP7.SnippetScope).SITE
        }) : Promise.resolve({
            success: []
        }),
        $f53f67e32b6005ed$export$cf060afb8b9f33e4({
            format: params.format,
            scope: (0, $jGJP7.SnippetScope).USER
        })
    ]);
    const globalSnippets = globalSnippetsResponse.status === 'fulfilled' ? globalSnippetsResponse.value : {
        success: []
    };
    const siteSnippets = siteSnippetsResponse.status === 'fulfilled' ? siteSnippetsResponse.value : {
        success: []
    };
    const userSnippets = userSnippetsResponse.status === 'fulfilled' ? userSnippetsResponse.value : {
        success: []
    };
    return [
        ...globalSnippets.success,
        ...siteSnippets.success,
        ...userSnippets.success
    ];
};
const $f53f67e32b6005ed$export$cf060afb8b9f33e4 = async (params)=>{
    const queryParams = params.product ? new URLSearchParams({
        format: params.format,
        product: params.product,
        scope: params.scope
    }) : new URLSearchParams({
        format: params.format,
        scope: params.scope
    });
    const response = await fetch(`${(0, $dx2GL.BLOCK_SERVICE_API_URL) + $f53f67e32b6005ed$var$SNIPPETS_PATH}?${queryParams.toString()}`, {
        method: 'GET'
    });
    if (!response.ok) throw new Error(`Failed to fetch snippets for scope: ${params.scope}`);
    return await response.json();
};
const $f53f67e32b6005ed$export$f1c9901b889f5301 = (params)=>({
        getSnippets: ()=>(0, $duQjP.withSnippetsCache)(async ()=>{
                let snippets = await $f53f67e32b6005ed$export$424a614da735364c(params);
                if (!snippets) return [];
                if (!Array.isArray(snippets)) snippets = [
                    snippets
                ];
                return snippets.map((snippet)=>{
                    const snippetBody = $f53f67e32b6005ed$var$parseSnippetContent(snippet.body);
                    if (snippetBody === undefined) return undefined;
                    return {
                        ...snippet,
                        body: snippetBody
                    };
                }).filter((snippet)=>snippet !== undefined);
            })
    });
function $f53f67e32b6005ed$var$filterValidAdfNodes(nodes) {
    return nodes.filter((node)=>node !== undefined && node !== null);
}
const $f53f67e32b6005ed$var$parseSnippetContent = (content)=>{
    try {
        const parsedContent = JSON.parse(content);
        // Handle fragment (array of nodes without doc wrapper)
        if (Array.isArray(parsedContent)) return $f53f67e32b6005ed$var$wrapAdfWithDocNode($f53f67e32b6005ed$var$filterValidAdfNodes(parsedContent));
        const adfContent = parsedContent;
        if (adfContent.type === 'doc' && Array.isArray(adfContent.content)) return {
            ...adfContent,
            content: $f53f67e32b6005ed$var$filterValidAdfNodes(adfContent.content)
        };
        return $f53f67e32b6005ed$var$wrapAdfWithDocNode(adfContent);
    } catch (error) {
        return undefined;
    }
};
const $f53f67e32b6005ed$var$wrapAdfWithDocNode = (adf)=>{
    const docType = 'doc';
    const isArray = Array.isArray(adf);
    if (!isArray && adf.type === docType) return adf;
    const content = isArray ? adf : [
        adf
    ];
    return {
        version: 1,
        type: docType,
        content: content
    };
};
const $f53f67e32b6005ed$export$43bdc2e83cb3f88b = ({ product: product })=>(0, $42omo.useMemo)(()=>({
            snippetsProvider: $f53f67e32b6005ed$export$f1c9901b889f5301({
                format: (0, $jGJP7.SnippetBodyFormat).ADF,
                product: product
            })
        }), [
        product
    ]);
module.exports["fetchSnippetsData"] = $f53f67e32b6005ed$export$cf060afb8b9f33e4;

});

parcelRegister("dx2GL", function(module, exports) {
const $d03628d022234f57$export$733c2045843b0072 = '/gateway/api/blocks/v1';
const $d03628d022234f57$export$73c71f9590626082 = async (snippetId)=>{
    const response = await fetch(`${$d03628d022234f57$export$733c2045843b0072}/snippets/${encodeURIComponent(snippetId)}/media-token`, {
        method: 'GET'
    });
    if (!response.ok) throw new Error(`Failed to fetch snippet media token for snippet ${snippetId}`);
    return response.json();
};
const $d03628d022234f57$export$43d25102300e787d = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return typeof snippetId === 'string' && snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {
        return undefined;
    }
};
module.exports["BLOCK_SERVICE_API_URL"] = $d03628d022234f57$export$733c2045843b0072;

});

parcelRegister("jGJP7", function(module, exports) {
var $6a83baabe1c0a06a$export$4b7b09c17f5ba341 = /*#__PURE__*/ function(SnippetBodyFormat) {
    SnippetBodyFormat["ADF"] = "ADF";
    return SnippetBodyFormat;
}({});
var $6a83baabe1c0a06a$export$e6769779009a1fa2 = /*#__PURE__*/ function(SnippetProduct) {
    SnippetProduct["CONFLUENCE"] = "CONFLUENCE";
    SnippetProduct["JIRA"] = "JIRA";
    return SnippetProduct;
}({});
var $6a83baabe1c0a06a$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["SITE"] = "SITE";
    SnippetScope["USER"] = "USER";
    return SnippetScope;
}({});
var $6a83baabe1c0a06a$export$9826bdf5a11e7016 = /*#__PURE__*/ function(SnippetStatus) {
    SnippetStatus["ACTIVE"] = "active";
    SnippetStatus["DELETED"] = "deleted";
    return SnippetStatus;
}({});
module.exports["SnippetBodyFormat"] = $6a83baabe1c0a06a$export$4b7b09c17f5ba341;
module.exports["SnippetProduct"] = $6a83baabe1c0a06a$export$e6769779009a1fa2;
module.exports["SnippetScope"] = $6a83baabe1c0a06a$export$100829e61c5df591;

});

parcelRegister("duQjP", function(module, exports) {
let $995aacc123ccb350$var$fetchSnippetsPromise = null;
let $995aacc123ccb350$var$cachedSnippets = null;
const $995aacc123ccb350$export$cf490a717245d06 = (fetcher)=>{
    if ($995aacc123ccb350$var$fetchSnippetsPromise) return $995aacc123ccb350$var$fetchSnippetsPromise;
    if ($995aacc123ccb350$var$cachedSnippets !== null) return Promise.resolve($995aacc123ccb350$var$cachedSnippets);
    $995aacc123ccb350$var$fetchSnippetsPromise = (async ()=>{
        try {
            const result = await fetcher();
            $995aacc123ccb350$var$cachedSnippets = result;
            return result;
        } finally{
            $995aacc123ccb350$var$fetchSnippetsPromise = null;
        }
    })();
    return $995aacc123ccb350$var$fetchSnippetsPromise;
};
const $995aacc123ccb350$export$88e3986896305eb8 = ()=>{
    $995aacc123ccb350$var$cachedSnippets = null;
    $995aacc123ccb350$var$fetchSnippetsPromise = null;
};
module.exports["withSnippetsCache"] = $995aacc123ccb350$export$cf490a717245d06;

});

parcelRegister("77Hid", function(module, exports) {
var $0b7d55ca130debf0$export$4b7b09c17f5ba341 = /*#__PURE__*/ function(SnippetBodyFormat) {
    // Only ADF is allowed currently but more will be added:
    // 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
    SnippetBodyFormat["ADF"] = "ADF";
    return SnippetBodyFormat;
}({});
module.exports["SnippetBodyFormat"] = $0b7d55ca130debf0$export$4b7b09c17f5ba341;

});

parcelRegister("5ra2J", function(module, exports) {

var $3fxwO = parcelRequire("3fxwO");


var $aUBmi = parcelRequire("aUBmi");


var $9Gk5O = parcelRequire("9Gk5O");


var $ies1q = parcelRequire("ies1q");


var $kVh3A = parcelRequire("kVh3A");

const $4006419802f3d045$export$e7219ab2842dfbd2 = async (snippets)=>{
    const creatorAccountIds = snippets.map((s)=>s.createdBy).filter(Boolean);
    const creatorMap = await (0, $kVh3A.getCachedOrFetchUserInfos)(creatorAccountIds);
    return snippets.map((snippet)=>$4006419802f3d045$var$transformSnippetData(snippet, creatorMap)).filter((snippet)=>snippet !== undefined);
};
const $4006419802f3d045$export$27f6ce18fbe7c295 = async (snippet)=>{
    const creatorMap = await (0, $kVh3A.getCachedOrFetchUserInfos)([
        snippet.createdBy
    ]);
    return $4006419802f3d045$var$transformSnippetData(snippet, creatorMap);
};
const $4006419802f3d045$var$transformSnippetData = (snippet, creatorMap)=>{
    try {
        const parsedBody = (0, $ies1q.parseSnippetContent)(snippet.body);
        if (parsedBody === undefined) return undefined;
        const createdBy = creatorMap.get(snippet.createdBy) ?? (0, $kVh3A.getDefaultUserInfo)(snippet.createdBy, null);
        // BE returns isShared for USER and SITE scope; fallback when missing (e.g. SITE => true).
        const isShared = snippet.isShared ?? false;
        return {
            ari: (0, $3fxwO.BlocksSnippetAri).parse(snippet.resourceId),
            snippetId: snippet.snippetId,
            name: snippet.name,
            description: snippet.description,
            bodyFormat: snippet.bodyFormat,
            body: parsedBody,
            product: snippet.product,
            isFavorite: Boolean(snippet.isFavorite),
            status: snippet.status,
            scope: snippet.scope,
            isShared: isShared,
            createdBy: createdBy,
            createdAt: new Date(Number(snippet.createdAt)),
            updatedAt: new Date(Number(snippet.updatedAt)),
            insertCount: snippet.insertCount,
            shareUrl: (0, $9Gk5O.getSnippetShareUrl)(snippet.snippetId, snippet.shareId)
        };
    } catch (error) {
        (0, $aUBmi.reportError)(error instanceof Error ? error : new Error(`Failed to transform snippet ${snippet.snippetId}: ${String(error)}`));
        return undefined;
    }
};
module.exports["transformSnippets"] = $4006419802f3d045$export$e7219ab2842dfbd2;
module.exports["transformSnippet"] = $4006419802f3d045$export$27f6ce18fbe7c295;

});

parcelRegister("3fxwO", function(module, exports) {

var $l3omf = parcelRequire("l3omf");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/blocks/snippet/manifest.ts
var $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $l3omf.BlocksSnippetAriResourceOwner),
    resourceType: (0, $l3omf.BlocksSnippetAriResourceType),
    resourceIdSlug: "workspace/{workspaceId}/{snippetId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        snippetId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-7][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/blocks/snippet/index.ts
var $25dcc7d0ac4036c1$export$7140b52dd9778730 = class _BlocksSnippetAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get snippetId() {
        return this._snippetId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.qualifier,
            platformQualifier: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.resourceOwner,
            resourceType: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.resourceType,
            resourceId: `workspace/${opts.workspaceId}/${opts.snippetId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                snippetId: opts.snippetId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts);
        return new _BlocksSnippetAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts);
        return new _BlocksSnippetAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            workspaceId: this.workspaceId,
            snippetId: this.snippetId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._snippetId = opts.resourceIdSegmentValues.snippetId;
    }
};
module.exports["BlocksSnippetAri"] = $25dcc7d0ac4036c1$export$7140b52dd9778730;

});

parcelRegister("l3omf", function(module, exports) {
// src/blocks/snippet/types.ts
var $f53cc5c05a1e57d6$export$c5a78d3da90ef749 = "blocks", $f53cc5c05a1e57d6$export$38b3a184e1acf0da = "snippet";
module.exports["BlocksSnippetAriResourceOwner"] = $f53cc5c05a1e57d6$export$c5a78d3da90ef749;
module.exports["BlocksSnippetAriResourceType"] = $f53cc5c05a1e57d6$export$38b3a184e1acf0da;

});

parcelRegister("9Gk5O", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $1bbe7085ffc2b656$var$TEMPLATE_GALLERY_TAB_BLOCK = 'block';
const $1bbe7085ffc2b656$export$db5a6d7adf00bf9c = (snippetId, shareId)=>{
    const query = {
        tab: $1bbe7085ffc2b656$var$TEMPLATE_GALLERY_TAB_BLOCK,
        snippetId: snippetId
    };
    if (shareId) query.shareId = shareId;
    return (0, $1NBp8.TEMPLATE_GALLERY).toUrl({}, {
        query: query
    });
};
module.exports["getSnippetShareUrl"] = $1bbe7085ffc2b656$export$db5a6d7adf00bf9c;

});

parcelRegister("kVh3A", function(module, exports) {

var $buwvF = parcelRequire("buwvF");


var $7yBUT = parcelRequire("7yBUT");


var $2uxuh = parcelRequire("2uxuh");

const $43931bab9ad90905$var$ATLASSIAN_SNIPPET_OWNER = {
    accountId: (0, $buwvF.ATLASSIAN_ACCOUNT_ID),
    displayName: 'Atlassian'
};
const $43931bab9ad90905$export$c93a1f4a0896e9e1 = (userId)=>{
    return `/wiki/aa-avatar/${encodeURIComponent(userId)}`;
};
const $43931bab9ad90905$export$8cbbf176c5a0d090 = (userId, displayName)=>{
    return {
        accountId: userId,
        displayName: displayName ?? userId,
        avatarUrl: $43931bab9ad90905$export$c93a1f4a0896e9e1(userId)
    };
};
const $43931bab9ad90905$export$f4dafa0b5f6b7602 = async (accountIds)=>{
    const resultMap = new Map();
    const uniqueAccountIds = [
        ...new Set(accountIds.filter(Boolean))
    ];
    const uncachedAccountIds = [];
    for (const id of uniqueAccountIds){
        if (id.toLowerCase() === (0, $buwvF.ATLASSIAN_ACCOUNT_ID).toLowerCase()) {
            resultMap.set(id, $43931bab9ad90905$var$ATLASSIAN_SNIPPET_OWNER);
            continue;
        }
        const cachedSnippetOwner = (0, $2uxuh.USER_CACHE).get(id.toLowerCase());
        if (cachedSnippetOwner) {
            resultMap.set(id, cachedSnippetOwner);
            continue;
        }
        uncachedAccountIds.push(id);
    }
    if (uncachedAccountIds.length > 0) {
        const batchUserData = await (0, $7yBUT.fetchUsersBatch)(uncachedAccountIds);
        for (const userData of batchUserData){
            const owner = {
                accountId: userData.accountId,
                displayName: userData.displayName ?? userData.accountId,
                avatarUrl: userData.avatarUrl ?? $43931bab9ad90905$export$c93a1f4a0896e9e1(userData.accountId)
            };
            (0, $2uxuh.USER_CACHE).set(userData.accountId.toLowerCase(), owner);
        }
        for (const id of uncachedAccountIds){
            const owner = (0, $2uxuh.USER_CACHE).get(id.toLowerCase()) ?? $43931bab9ad90905$export$8cbbf176c5a0d090(id, null);
            resultMap.set(id, owner);
        }
    }
    return resultMap;
};
module.exports["getDefaultUserInfo"] = $43931bab9ad90905$export$8cbbf176c5a0d090;
module.exports["getCachedOrFetchUserInfos"] = $43931bab9ad90905$export$f4dafa0b5f6b7602;

});

parcelRegister("buwvF", function(module, exports) {
const $36c35f590e2b0286$export$7f38f8cc01c20d32 = 'atlassian';
module.exports["ATLASSIAN_ACCOUNT_ID"] = $36c35f590e2b0286$export$7f38f8cc01c20d32;

});

parcelRegister("7yBUT", function(module, exports) {
/**
 * @graphql agg
 *
 * AGG (Atlassian GraphQL Gateway) batch user query.
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $aUBmi = parcelRequire("aUBmi");

const $50afcdaae69a1b61$var$BlockServiceAggUserQueryFetchUsersBatchQuery = (0, $eSUdr.default)`query blockServiceAggUserQueryFetchUsersBatchQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`;
/** Maximum number of account IDs per AGG users batch request. */ const $50afcdaae69a1b61$var$AGG_USERS_BATCH_LIMIT = 90;
function $50afcdaae69a1b61$var$chunk(array, size) {
    const chunks = [];
    for(let i = 0; i < array.length; i += size)chunks.push(array.slice(i, i + size));
    return chunks;
}
function $50afcdaae69a1b61$var$mapUsersToBatchUserInfo(users) {
    if (!users || !Array.isArray(users)) return [];
    return users.filter((user)=>user != null && Boolean(user.accountId)).map((user)=>({
            accountId: user.accountId,
            displayName: user.name ?? user.accountId,
            avatarUrl: user.picture ?? undefined
        }));
}
async function $50afcdaae69a1b61$var$fetchUsersBatchSingle(batchAccountIds) {
    const { data: data, errors: errors } = await (0, $c0rhi.queryInterop)({
        query: $50afcdaae69a1b61$var$BlockServiceAggUserQueryFetchUsersBatchQuery,
        variables: {
            accountIds: batchAccountIds
        },
        interopApolloAggClient: true
    });
    errors?.forEach((error)=>{
        $50afcdaae69a1b61$var$logFetchError(error);
        (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return $50afcdaae69a1b61$var$mapUsersToBatchUserInfo(data?.users);
}
const $50afcdaae69a1b61$export$f79927f290b67443 = async (accountIds)=>{
    if (accountIds.length === 0) return [];
    try {
        const batches = $50afcdaae69a1b61$var$chunk(accountIds, $50afcdaae69a1b61$var$AGG_USERS_BATCH_LIMIT);
        const results = await Promise.all(batches.map($50afcdaae69a1b61$var$fetchUsersBatchSingle));
        return results.flat();
    } catch (error) {
        $50afcdaae69a1b61$var$logFetchError(error);
        (0, $7Sm4c.markErrorAsHandled)(error);
        return [];
    }
};
const $50afcdaae69a1b61$var$logFetchError = (maybeError)=>{
    const error = maybeError instanceof Error ? maybeError : new Error(String(maybeError));
    const errorToLog = new Error(`Error when fetching Snippet owner user details: ${error?.message || JSON.stringify(error)}`);
    (0, $aUBmi.reportError)(errorToLog);
};
module.exports["fetchUsersBatch"] = $50afcdaae69a1b61$export$f79927f290b67443;

});

parcelRegister("2uxuh", function(module, exports) {
const $feaa4bed83d900b4$export$1102191c744ab479 = new Map();
const $feaa4bed83d900b4$export$c93af146ba17833f = ()=>{
    $feaa4bed83d900b4$export$1102191c744ab479.clear();
};
module.exports["USER_CACHE"] = $feaa4bed83d900b4$export$1102191c744ab479;

});

parcelRegister("lIx1f", function(module, exports) {
let $df86535d196acbcf$var$fetchSnippetsPromise = null;
let $df86535d196acbcf$var$cachedSnippets = null;
const $df86535d196acbcf$export$cf490a717245d06 = (fetcher)=>{
    if ($df86535d196acbcf$var$fetchSnippetsPromise) return $df86535d196acbcf$var$fetchSnippetsPromise;
    if ($df86535d196acbcf$var$cachedSnippets !== null) return Promise.resolve($df86535d196acbcf$var$cachedSnippets);
    $df86535d196acbcf$var$fetchSnippetsPromise = (async ()=>{
        try {
            const result = await fetcher();
            $df86535d196acbcf$var$cachedSnippets = result;
            return result;
        } finally{
            $df86535d196acbcf$var$fetchSnippetsPromise = null;
        }
    })();
    return $df86535d196acbcf$var$fetchSnippetsPromise;
};
const $df86535d196acbcf$export$88e3986896305eb8 = ()=>{
    $df86535d196acbcf$var$cachedSnippets = null;
    $df86535d196acbcf$var$fetchSnippetsPromise = null;
};
module.exports["withSnippetsCache"] = $df86535d196acbcf$export$cf490a717245d06;
module.exports["clearSnippetsCache"] = $df86535d196acbcf$export$88e3986896305eb8;

});

parcelRegister("eDBud", function(module, exports) {
const $441c04495869cf24$export$f215cb69de957178 = (flags, title, description, actions)=>{
    if (!flags) return;
    flags.showSuccessFlag({
        title: title,
        description: description ?? '',
        isAutoDismiss: true,
        ...actions && {
            actions: actions
        }
    });
};
const $441c04495869cf24$export$41b17d176beb3ddb = (flags, title, description)=>{
    if (!flags) return;
    flags.showErrorFlag({
        title: title,
        description: description ?? '',
        isAutoDismiss: true
    });
};
module.exports["showSnippetSuccessFlag"] = $441c04495869cf24$export$f215cb69de957178;
module.exports["showSnippetErrorFlag"] = $441c04495869cf24$export$41b17d176beb3ddb;

});

parcelRegister("9gUQP", function(module, exports) {

var $eWCeD = parcelRequire("eWCeD");


var $6K2yS = parcelRequire("6K2yS");


var $5OfFS = parcelRequire("5OfFS");


var $77Hid = parcelRequire("77Hid");


var $lGxKg = parcelRequire("lGxKg");


var $gdHn1 = parcelRequire("gdHn1");

const $83472051e80c3ce9$export$8a3e92c118401aaf = (error, actionErrorFlagTitle, actionErrorFlagDescription)=>{
    const isBodyTooLarge = (0, $eWCeD.isBodyTooLargeError)(error);
    return {
        flagTitle: isBodyTooLarge ? (0, $6K2yS.messages).contentTooLargeFlagTitle : actionErrorFlagTitle,
        flagDescription: isBodyTooLarge ? (0, $6K2yS.messages).contentTooLargeFlagDescription : actionErrorFlagDescription
    };
};
function $83472051e80c3ce9$export$d592730130067dd1(name, body, description) {
    const descriptionValue = description?.trim();
    return {
        name: name,
        ...descriptionValue && {
            description: descriptionValue
        },
        body: JSON.stringify(body),
        bodyFormat: (0, $77Hid.SnippetBodyFormat).ADF,
        product: (0, $lGxKg.SnippetProduct).CONFLUENCE
    };
}
async function $83472051e80c3ce9$export$4badc9912ee9505f({ snippet: snippet, options: options, storeApi: storeApi, onShareFailure: onShareFailure }) {
    const { getState: getState, dispatch: dispatch } = storeApi;
    const { flags: flags, intl: intl, editorAPI: editorAPI, isShared: isShared } = options;
    if (editorAPI) (0, $5OfFS.addSnippetQuickInsertItem)({
        snippet: snippet,
        editorAPI: editorAPI
    });
    if (getState().isSnippetSharingForSiteEnabled && isShared) await dispatch((0, $gdHn1.shareActions).shareSnippet(snippet.snippetId, {
        flags: flags,
        intl: intl,
        editorAPI: editorAPI ?? undefined,
        onShareFailure: onShareFailure
    }));
}
module.exports["getSnippetErrorFlagMessages"] = $83472051e80c3ce9$export$8a3e92c118401aaf;
module.exports["buildCreatePayload"] = $83472051e80c3ce9$export$d592730130067dd1;
module.exports["addSnippetToQuickInsertAndShare"] = $83472051e80c3ce9$export$4badc9912ee9505f;

});

parcelRegister("5OfFS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5SAOw = parcelRequire("5SAOw");


var $isFEX = parcelRequire("isFEX");


var $lCB0R = parcelRequire("lCB0R");

const $e4e416e4fc84d656$export$a72e587fbb595114 = ({ snippet: snippet, editorAPI: editorAPI })=>{
    if (!editorAPI) return;
    const addQuickInsertItem = editorAPI?.quickInsert?.commands?.addQuickInsertItem;
    if (addQuickInsertItem === undefined) return;
    editorAPI.core?.actions.execute(// @ts-expect-error — react-intl v5/v7 type mismatch, will be removed when platform upgrades to react-intl v7
    addQuickInsertItem((intl)=>[
            $e4e416e4fc84d656$export$bf974db7a6bf9b4b({
                snippet: snippet,
                intl: intl
            })
        ]));
};
const $e4e416e4fc84d656$export$942aea5178818d5f = ({ snippet: snippet, editorAPI: editorAPI })=>{
    if (!editorAPI) return;
    const updateQuickInsertItem = editorAPI?.quickInsert?.commands?.updateQuickInsertItem ?? null;
    if (!updateQuickInsertItem) return;
    editorAPI.core?.actions.execute(// @ts-expect-error — react-intl v5/v7 type mismatch, will be removed when platform upgrades to react-intl v7
    updateQuickInsertItem((0, $lCB0R.getSnippetQuickInsertKey)(snippet.snippetId), (intl)=>[
            $e4e416e4fc84d656$export$bf974db7a6bf9b4b({
                snippet: snippet,
                intl: intl
            })
        ]));
};
const $e4e416e4fc84d656$export$bf974db7a6bf9b4b = ({ snippet: snippet, intl: intl })=>{
    return {
        key: (0, $lCB0R.getSnippetQuickInsertKey)(snippet.snippetId),
        title: snippet.name,
        description: (0, $lCB0R.createSnippetDescription)(snippet.createdBy, intl),
        keywords: (0, $lCB0R.extractSnippetKeywords)(snippet.name, intl),
        isDisabledOffline: true,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isFEX))), {
                label: "Snippet"
            }),
        action: (insert, state)=>{
            const body = snippet.body;
            if (!body) return false;
            if (Array.isArray(body)) {
                const fragment = (0, $5SAOw.Fragment).fromJSON(state.schema, body);
                return insert(fragment);
            }
            return insert(body);
        }
    };
};
module.exports["addSnippetQuickInsertItem"] = $e4e416e4fc84d656$export$a72e587fbb595114;
module.exports["updateSnippetInQuickInsertItem"] = $e4e416e4fc84d656$export$942aea5178818d5f;

});

parcelRegister("isFEX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d70b2843323b118c$var$_react = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("42omo")));

var $d70b2843323b118c$var$_baseNew = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d70b2843323b118c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d70b2843323b118c$var$TemplateIcon = (props)=>/*#__PURE__*/ $d70b2843323b118c$var$_react.default.createElement($d70b2843323b118c$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d70b2843323b118c$var$TemplateIcon.displayName = 'TemplateIcon';
var $d70b2843323b118c$var$_default = module.exports.default = $d70b2843323b118c$var$TemplateIcon;

});

parcelRegister("lCB0R", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $buwvF = parcelRequire("buwvF");

const $9362cb4ff6d42180$var$messages = (0, $aXWIB.defineMessages)({
    snippetBy: {
        id: "snippets.quick-insert.by",
        defaultMessage: "by {name}"
    },
    template: {
        id: "snippets.quick-insert.template",
        defaultMessage: "template"
    }
});
/** Prefix for snippet quick insert item keys in the editor. */ const $9362cb4ff6d42180$var$SNIPPET_QUICK_INSERT_KEY_PREFIX = 'snippet-extension:snippet-';
const $9362cb4ff6d42180$export$695a8bc53bbc641e = (snippetId)=>`${$9362cb4ff6d42180$var$SNIPPET_QUICK_INSERT_KEY_PREFIX}${snippetId}`;
const $9362cb4ff6d42180$export$fefb8fa12cc0572f = (name, intl)=>{
    const nameKeywords = name.split(/\s+/).map((word)=>word.toLowerCase().trim()).filter((word)=>word.length > 0);
    const templateKeyword = intl.formatMessage($9362cb4ff6d42180$var$messages.template).toLowerCase();
    const allKeywords = [
        ...nameKeywords,
        templateKeyword
    ];
    return Array.from(new Set(allKeywords));
};
const $9362cb4ff6d42180$export$4a4fbbff52147a2b = (createdBy, intl)=>{
    const name = createdBy.displayName || createdBy.accountId;
    return intl.formatMessage($9362cb4ff6d42180$var$messages.snippetBy, {
        name: name
    });
};
const $9362cb4ff6d42180$var$isValidQuickInsertSnippet = (snippet, userId)=>snippet.createdBy.accountId === userId || snippet.createdBy.accountId === (0, $buwvF.ATLASSIAN_ACCOUNT_ID) || snippet.isFavorite;
const $9362cb4ff6d42180$var$getSortPriority = (snippet, userId)=>{
    // 1st: created by the current user
    if (snippet.createdBy.accountId === userId) return 0;
    // 2nd: favorited (but not created by the current user)
    if (snippet.isFavorite) return 1;
    // 3rd: Atlassian-created (GLOBAL scope) / others that already passed the previous filter
    return 2;
};
const $9362cb4ff6d42180$export$d0e0de50c701304c = (snippets, userId)=>{
    return snippets.filter((snippet)=>$9362cb4ff6d42180$var$isValidQuickInsertSnippet(snippet, userId)).sort((a, b)=>$9362cb4ff6d42180$var$getSortPriority(a, userId) - $9362cb4ff6d42180$var$getSortPriority(b, userId));
};
module.exports["getSnippetQuickInsertKey"] = $9362cb4ff6d42180$export$695a8bc53bbc641e;
module.exports["extractSnippetKeywords"] = $9362cb4ff6d42180$export$fefb8fa12cc0572f;
module.exports["createSnippetDescription"] = $9362cb4ff6d42180$export$4a4fbbff52147a2b;
module.exports["filterAndSort"] = $9362cb4ff6d42180$export$d0e0de50c701304c;

});

parcelRegister("lGxKg", function(module, exports) {
var $ffe8f943ede6b1fa$export$e6769779009a1fa2 = /*#__PURE__*/ function(SnippetProduct) {
    // Only Confluence is allowed currently but more will be added:
    // 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
    SnippetProduct["CONFLUENCE"] = "CONFLUENCE";
    return SnippetProduct;
}({});
module.exports["SnippetProduct"] = $ffe8f943ede6b1fa$export$e6769779009a1fa2;

});

parcelRegister("gdHn1", function(module, exports) {
/**
 * Share Actions - Share/unshare snippets with UI integration
 *
 * Handles POST/DELETE on v1/snippets/{snippetId}/share for setting isShared to true (shared)
 * or back to false (private). On success: updates the snippet in store (isShared) and
 * in the editor quick insert when editorAPI is passed. On error: shows error flag and
 * reports to monitoring.
 *
 * Call these after create/update/duplicate succeeds when the user's isShared differs
 * from the snippet's current value.
 */ 
var $aXWIB = parcelRequire("aXWIB");


var $3e10B = parcelRequire("3e10B");


var $aUBmi = parcelRequire("aUBmi");


var $5OfFS = parcelRequire("5OfFS");


var $eDBud = parcelRequire("eDBud");


var $5ra2J = parcelRequire("5ra2J");


var $7DXt6 = parcelRequire("7DXt6");

const $6ee676e3d95c77de$var$shareActionsMessages = (0, $aXWIB.defineMessages)({
    claimShareErrorFlagTitle: {
        id: "snippets.shareActions.claimShareErrorFlagTitle",
        defaultMessage: "Could not access template"
    },
    claimShareErrorFlagDescription: {
        id: "snippets.shareActions.claimShareErrorFlagDescription",
        defaultMessage: "The share link may be invalid."
    },
    shareErrorFlagTitle: {
        id: "snippets.shareActions.shareErrorFlagTitle",
        defaultMessage: "Could not set template to shared"
    },
    shareErrorFlagDescription: {
        id: "snippets.shareActions.shareErrorFlagDescription",
        defaultMessage: "The template was saved but access update failed. Please try again."
    },
    unshareErrorFlagTitle: {
        id: "snippets.shareActions.unshareErrorFlagTitle",
        defaultMessage: "Could not set template to private"
    },
    unshareErrorFlagDescription: {
        id: "snippets.shareActions.unshareErrorFlagDescription",
        defaultMessage: "The template was saved but access update failed. Please try again."
    }
});
function $6ee676e3d95c77de$var$updateSnippetStoreAndQuickInsert(params) {
    const { getState: getState, setState: setState, snippetId: snippetId, isShared: isShared, options: options } = params;
    const { snippets: snippets } = getState();
    const updatedSnippets = snippets.map((snippet)=>snippet.snippetId === snippetId ? {
            ...snippet,
            isShared: isShared
        } : snippet);
    setState({
        snippets: updatedSnippets
    });
    if (options?.editorAPI) {
        const updatedSnippet = updatedSnippets.find((s)=>s.snippetId === snippetId);
        if (updatedSnippet) (0, $5OfFS.updateSnippetInQuickInsertItem)({
            snippet: updatedSnippet,
            editorAPI: options.editorAPI
        });
    }
}
const $6ee676e3d95c77de$export$d441f4747313fe61 = {
    /**
   * Claims a snippet via a share link. POSTs to the claim endpoint with the shareId.
   * On success: adds the snippet to the store (if not already present) and opens the detail panel.
   * On error: reports to monitoring and shows an error flag when options provided. Does not throw.
   *
   * @param snippetId - The snippet ID from the share URL
   * @param shareId - The share token from the share URL
   * @param options - Optional flags and intl for error flag display
   */ claimSnippetShare: (snippetId, shareId, options)=>async ({ getState: getState, setState: setState })=>{
            setState({
                isClaimingShare: true
            });
            try {
                const snippetData = await $3e10B.claimSnippetShare(snippetId, shareId);
                const snippet = await (0, $5ra2J.transformSnippet)(snippetData);
                if (snippet) {
                    const applyToStore = (currentSnippets)=>{
                        const { templateGallery: templateGallery } = getState();
                        const alreadyExists = currentSnippets.some((s)=>s.snippetId === snippet.snippetId);
                        setState({
                            isClaimingShare: false,
                            snippets: alreadyExists ? currentSnippets : [
                                ...currentSnippets,
                                snippet
                            ],
                            templateGallery: {
                                ...templateGallery,
                                selectedSnippetId: snippet.snippetId
                            }
                        });
                    };
                    if (getState().isLoading) // fetchSnippets is still in flight — defer until it settles so the fetch
                    // result doesn't overwrite the claimed snippet
                    (0, $7DXt6.onCurrentFetchComplete)(applyToStore);
                    else applyToStore(getState().snippets);
                } else setState({
                    isClaimingShare: false
                });
            } catch (error) {
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                setState({
                    isClaimingShare: false
                });
                if (options) (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.claimShareErrorFlagTitle), options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.claimShareErrorFlagDescription));
            }
        },
    /**
   * Shares a snippet with the site.
   * On success: updates the snippet in store (isShared: true) and in quick insert when editorAPI provided.
   * On error: reports to monitoring and shows error flag when options provided. Does not throw.
   *
   * @param snippetId - The snippet ID to share
   * @param options - Optional flags, intl, and editorAPI for UI feedback and quick insert update
   */ shareSnippet: (snippetId, options)=>async ({ getState: getState, setState: setState })=>{
            try {
                await $3e10B.shareSnippet(snippetId);
                $6ee676e3d95c77de$var$updateSnippetStoreAndQuickInsert({
                    getState: getState,
                    setState: setState,
                    snippetId: snippetId,
                    isShared: true,
                    options: options
                });
            } catch (error) {
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                if (options) {
                    (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.shareErrorFlagTitle), options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.shareErrorFlagDescription));
                    options.onShareFailure?.(snippetId, err);
                }
            }
        },
    /**
   * Unshares a snippet.
   * On success: updates the snippet in store (isShared: false) and in quick insert when editorAPI provided.
   * On error: reports to monitoring and shows error flag when options provided. Does not throw.
   *
   * @param snippetId - The snippet ID to unshare
   * @param options - Optional flags, intl, and editorAPI for UI feedback and quick insert update
   */ unshareSnippet: (snippetId, options)=>async ({ getState: getState, setState: setState })=>{
            try {
                await $3e10B.unshareSnippet(snippetId);
                $6ee676e3d95c77de$var$updateSnippetStoreAndQuickInsert({
                    getState: getState,
                    setState: setState,
                    snippetId: snippetId,
                    isShared: false,
                    options: options
                });
            } catch (error) {
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                if (options) {
                    (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.unshareErrorFlagTitle), options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.unshareErrorFlagDescription));
                    options.onUnshareFailure?.(snippetId, err);
                }
            }
        }
};
module.exports["shareActions"] = $6ee676e3d95c77de$export$d441f4747313fe61;

});

parcelRegister("kZ6BG", function(module, exports) {
/**
 * Delete Actions - Snippet deletion with local state update
 *
 * Calls the Block Service API to delete the snippet, then removes it from
 * the react-sweet-state store so the UI updates immediately, and from the
 * quick insert menu when editor API is provided in options. When options (flags, intl)
 * are provided, shows success/error flags like createActions and updateActions.
 */ 
var $3e10B = parcelRequire("3e10B");


var $64ncc = parcelRequire("64ncc");


var $aUBmi = parcelRequire("aUBmi");


var $lCB0R = parcelRequire("lCB0R");


var $eDBud = parcelRequire("eDBud");

const $182883078d656055$export$78632900ecc05c19 = {
    /**
   * Deletes a snippet by ID.
   *
   * - Calls the Block Service API with DELETE
   * - On success: removes the snippet from local state and from quick insert menu; shows success flag if options provided
   * - On error: reports to monitoring, shows error flag if options provided, then re-throws
   *
   * @param snippetId - The snippet ID (uuidv7) to delete
   * @param options - Optional flags and intl for success/error UI feedback
   */ deleteSnippet: (snippetId, options)=>async ({ getState: getState, setState: setState })=>{
            try {
                await $3e10B.deleteSnippet(snippetId);
                const { snippets: snippets } = getState();
                const deletedSnippet = snippets.find((s)=>s.snippetId === snippetId);
                setState({
                    snippets: snippets.filter((s)=>s.snippetId !== snippetId)
                });
                if (options && deletedSnippet) (0, $eDBud.showSnippetSuccessFlag)(options.flags, options.intl.formatMessage((0, $64ncc.messages).deleteTemplateModalSuccessFlagTitle, {
                    snippetName: deletedSnippet.name
                }), options.intl.formatMessage((0, $64ncc.messages).deleteTemplateModalSuccessFlagDescription));
                const editorAPI = options?.editorAPI ?? null;
                const removeQuickInsertItem = editorAPI?.quickInsert?.commands?.removeQuickInsertItem ?? null;
                if (removeQuickInsertItem) editorAPI?.core?.actions.execute(removeQuickInsertItem((0, $lCB0R.getSnippetQuickInsertKey)(snippetId)));
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                (0, $aUBmi.reportError)(err);
                if (options) (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage((0, $64ncc.messages).deleteTemplateModalErrorFlagTitle), options.intl.formatMessage((0, $64ncc.messages).deleteTemplateModalErrorFlagDescription));
                throw err;
            }
        }
};
module.exports["deleteActions"] = $182883078d656055$export$78632900ecc05c19;

});

parcelRegister("64ncc", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $162407a1315c44c9$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    deleteTemplateModalTitle: {
        id: "snippets.deleteTemplateModalTitle",
        defaultMessage: "Delete this template?"
    },
    deleteTemplateModalBody: {
        id: "snippets.deleteTemplateModalBody",
        defaultMessage: "It will no longer appear in search or My templates"
    },
    deleteTemplateModalCancelButton: {
        id: "snippets.deleteTemplateModalCancelButton",
        defaultMessage: "Cancel"
    },
    deleteTemplateModalConfirmButton: {
        id: "snippets.deleteTemplateModalConfirmButton",
        defaultMessage: "Confirm"
    },
    deleteTemplateModalSuccessFlagTitle: {
        id: "snippets.deleteTemplateModalSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" deleted"
    },
    deleteTemplateModalSuccessFlagDescription: {
        id: "snippets.deleteTemplateModalSuccessFlagDescription",
        defaultMessage: "The template has been removed"
    },
    deleteTemplateModalErrorFlagTitle: {
        id: "snippets.deleteTemplateModalErrorFlagTitle",
        defaultMessage: "Could not delete template"
    },
    deleteTemplateModalErrorFlagDescription: {
        id: "snippets.deleteTemplateModalErrorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["messages"] = $162407a1315c44c9$export$defe85febe8b728c;

});

parcelRegister("5ogZS", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $3e10B = parcelRequire("3e10B");


var $aUBmi = parcelRequire("aUBmi");


var $eDBud = parcelRequire("eDBud");

const $370debea7e17b5a6$var$messages = (0, $aXWIB.defineMessages)({
    favoriteErrorFlagTitle: {
        id: "snippets.favoriteActions.favoriteErrorFlagTitle",
        defaultMessage: "Unable to favorite snippet"
    },
    favoriteErrorFlagDescription: {
        id: "snippets.favoriteActions.favoriteErrorFlagDescription",
        defaultMessage: "Please try again later."
    },
    unfavoriteErrorFlagTitle: {
        id: "snippets.favoriteActions.unfavoriteErrorFlagTitle",
        defaultMessage: "Unable to unfavorite snippet"
    },
    unfavoriteErrorFlagDescription: {
        id: "snippets.favoriteActions.unfavoriteErrorFlagDescription",
        defaultMessage: "Please try again later."
    }
});
const $370debea7e17b5a6$export$5ea490dff3e61674 = {
    favoriteSnippet: (snippetId, options)=>async ({ setState: setState, getState: getState })=>{
            const { snippets: previousSnippets } = getState();
            const newSnippetsState = previousSnippets.map((snippet)=>snippet.snippetId === snippetId ? {
                    ...snippet,
                    isFavorite: true
                } : snippet);
            setState({
                snippets: newSnippetsState
            });
            try {
                await $3e10B.favoriteSnippet(snippetId);
                return true;
            } catch (error) {
                setState({
                    snippets: previousSnippets
                });
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                if (options) (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($370debea7e17b5a6$var$messages.favoriteErrorFlagTitle), options.intl.formatMessage($370debea7e17b5a6$var$messages.favoriteErrorFlagDescription));
                return false;
            }
        },
    unfavoriteSnippet: (snippetId, options)=>async ({ setState: setState, getState: getState })=>{
            const { snippets: previousSnippets } = getState();
            const newSnippetsState = previousSnippets.map((snippet)=>snippet.snippetId === snippetId ? {
                    ...snippet,
                    isFavorite: false
                } : snippet);
            setState({
                snippets: newSnippetsState
            });
            try {
                await $3e10B.unfavoriteSnippet(snippetId);
                return true;
            } catch (error) {
                setState({
                    snippets: previousSnippets
                });
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                if (options) (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($370debea7e17b5a6$var$messages.unfavoriteErrorFlagTitle), options.intl.formatMessage($370debea7e17b5a6$var$messages.unfavoriteErrorFlagDescription));
                return false;
            }
        }
};
module.exports["favoriteActions"] = $370debea7e17b5a6$export$5ea490dff3e61674;

});

parcelRegister("2Qxf3", function(module, exports) {
/**
 * Fetch Actions - Data fetching and cache management for snippets
 *
 * These actions handle data fetching and cache management.
 * They interact with the blockServiceClient to make API calls and update the store.
 *
 * Key behaviors:
 * - fetchSnippets: Implements request deduplication via isLoaded/isLoading flags
 * - clearCache: Resets the store to allow fresh data on next fetch
 *
 * For snippet creation with UI feedback, see createActions.ts
 */ 
var $3e10B = parcelRequire("3e10B");


var $lIx1f = parcelRequire("lIx1f");


var $aUBmi = parcelRequire("aUBmi");


var $cga1x = parcelRequire("cga1x");


var $7DXt6 = parcelRequire("7DXt6");

/**
 * Module-level callback for fetch performance metrics.
 * The host (React layer with analytics) can register a callback via setOnFetchComplete
 * to receive performance data after each successful fetch.
 */ let $bd8808f2d9e2200a$var$onFetchCompleteCallback = null;
const $bd8808f2d9e2200a$export$19bcef6f062e1ea9 = (callback)=>{
    $bd8808f2d9e2200a$var$onFetchCompleteCallback = callback;
};
/**
 * Handles error reporting for fetch actions.
 * Sets fetchError state, reports to monitoring, and re-throws.
 */ const $bd8808f2d9e2200a$var$handleError = (error, setState, resetIsLoaded = true)=>{
    const err = error instanceof Error ? error : new Error(String(error));
    setState({
        isLoading: false,
        fetchError: err,
        ...resetIsLoaded && {
            isLoaded: false
        }
    });
    (0, $aUBmi.reportError)(err);
    throw err;
};
const $bd8808f2d9e2200a$export$4286ff85d0f23d31 = {
    /**
   * Fetches snippets from the server.
   *
   * Implements request deduplication: if snippets are already loaded (isLoaded=true)
   * or a request is in progress (isLoading=true), returns cached data immediately.
   * This allows multiple components to call fetchSnippets() without causing
   * redundant API requests.
   *
   * Resolves site config (isSnippetSharingForSiteEnabled) and fetches user, global,
   * and optionally site-scoped snippets; stores the config in state for later use.
   *
   * @returns Promise resolving to the snippets array
   */ fetchSnippets: ()=>async ({ getState: getState, setState: setState })=>{
            const { isLoaded: isLoaded, isLoading: isLoading } = getState();
            // Request deduplication: return cached data if already loaded or currently loading
            if (isLoaded || isLoading) return getState().snippets;
            setState({
                isLoading: true,
                fetchError: null
            });
            try {
                const fetchStart = performance.now();
                const isSnippetSharingForSiteEnabled = await $3e10B.getIsSnippetSharingForSiteEnabled();
                const snippets = await $3e10B.fetchSnippets({
                    isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled
                });
                const durationMs = Math.round(performance.now() - fetchStart);
                setState({
                    snippets: snippets,
                    isLoading: false,
                    fetchError: null,
                    isLoaded: true,
                    isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled
                });
                // Fire performance metrics callback if registered
                if ($bd8808f2d9e2200a$var$onFetchCompleteCallback) {
                    const siteScopeCount = snippets.filter((s)=>s.scope === (0, $cga1x.SnippetScope).SITE).length;
                    const globalScopeCount = snippets.filter((s)=>s.scope === (0, $cga1x.SnippetScope).GLOBAL).length;
                    $bd8808f2d9e2200a$var$onFetchCompleteCallback({
                        snippetCount: snippets.length,
                        userScopeCount: snippets.length - globalScopeCount - siteScopeCount,
                        siteScopeCount: siteScopeCount,
                        globalScopeCount: globalScopeCount,
                        payloadSizeBytes: new Blob([
                            JSON.stringify(snippets)
                        ]).size,
                        durationMs: durationMs
                    });
                }
                // Invoke any one-time callbacks registered while this fetch was in progress
                (0, $7DXt6.invokePendingLoadCallbacks)(snippets);
                return snippets;
            } catch (thrownError) {
                return $bd8808f2d9e2200a$var$handleError(thrownError, setState, true);
            }
        },
    /**
   * Clears both the service cache and store state.
   *
   * Use this when you need to force a fresh fetch on the next request,
   * such as after external changes to snippets data.
   */ clearCache: ()=>({ setState: setState })=>{
            (0, $lIx1f.clearSnippetsCache)();
            setState({
                snippets: [],
                isLoaded: false
            });
        }
};
module.exports["setOnFetchComplete"] = $bd8808f2d9e2200a$export$19bcef6f062e1ea9;
module.exports["fetchActions"] = $bd8808f2d9e2200a$export$4286ff85d0f23d31;

});

parcelRegister("cga1x", function(module, exports) {
/** Define the source of the snippets */ var $bd320fc30ef678ce$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["USER"] = "USER";
    SnippetScope["SITE"] = "SITE";
    return SnippetScope;
}({});
module.exports["SnippetScope"] = $bd320fc30ef678ce$export$100829e61c5df591;

});

parcelRegister("adRf2", function(module, exports) {
/**
 * Insert count actions - record snippet insert (API + local state)
 *
 * When a user inserts a snippet, we call the block service to increment insertCount
 * and optimistically update the snippet's insertCount in the store. The API call is
 * fire-and-forget; we do not await it.
 */ 
var $3e10B = parcelRequire("3e10B");

const $0d3ff23b1ebce84c$export$9ca6d5c974158b4f = {
    /**
   * Records that a snippet was inserted: increments insertCount in the store immediately
   * and calls the block service in the background (fire-and-forget).
   */ recordSnippetInsert: (snippetId)=>({ setState: setState, getState: getState })=>{
            const { snippets: snippets } = getState();
            const updatedSnippets = snippets.map((s)=>s.snippetId === snippetId ? {
                    ...s,
                    insertCount: (s.insertCount ?? 0) + 1
                } : s);
            setState({
                snippets: updatedSnippets
            });
            $3e10B.incrementSnippetInsertCount(snippetId);
        }
};
module.exports["insertCountActions"] = $0d3ff23b1ebce84c$export$9ca6d5c974158b4f;

});

parcelRegister("kvZfs", function(module, exports) {

var $ebSlI = parcelRequire("ebSlI");

let $58a5e61b68092aa3$var$urlSyncHandler = null;
const $58a5e61b68092aa3$export$783efc75f48cc7cc = (handler)=>{
    $58a5e61b68092aa3$var$urlSyncHandler = handler;
};
const $58a5e61b68092aa3$export$fade6508a7236815 = {
    setTemplateGallerySelectedSnippetId: (id)=>({ getState: getState, setState: setState })=>{
            setState({
                templateGallery: {
                    ...getState().templateGallery,
                    selectedSnippetId: id
                }
            });
            $58a5e61b68092aa3$var$urlSyncHandler?.(id);
        },
    setTemplateGalleryCategoryFilter: (selectedCategoryId)=>({ getState: getState, setState: setState })=>{
            setState({
                templateGallery: {
                    ...getState().templateGallery,
                    selectedCategoryId: selectedCategoryId
                }
            });
        },
    setTemplateGallerySearchQuery: (searchQuery)=>({ getState: getState, setState: setState })=>{
            setState({
                templateGallery: {
                    ...getState().templateGallery,
                    searchQuery: searchQuery
                }
            });
        },
    setTemplateGallerySortOrder: (sortOrder)=>({ getState: getState, setState: setState })=>{
            setState({
                templateGallery: {
                    ...getState().templateGallery,
                    sortOrder: sortOrder
                }
            });
        },
    resetTemplateGalleryFilters: ()=>({ getState: getState, setState: setState })=>{
            const { selectedSnippetId: selectedSnippetId } = getState().templateGallery;
            setState({
                templateGallery: {
                    ...(0, $ebSlI.getInitialTemplateGalleryState)(),
                    selectedSnippetId: selectedSnippetId
                }
            });
        }
};
module.exports["setUrlSyncHandler"] = $58a5e61b68092aa3$export$783efc75f48cc7cc;
module.exports["templateGalleryActions"] = $58a5e61b68092aa3$export$fade6508a7236815;

});

parcelRegister("cfxyE", function(module, exports) {
/**
 * Update Actions - Snippet editing with UI integration
 *
 * This action handles snippet updates with full UI integration:
 * - Updates the snippet via the API
 * - Shows success/error flags
 * - Updates the snippet in the editor's quick insert menu
 * - Updates the snippet in the store in place (preserves list order)
 *
 * Separated from fetchActions because it has UI dependencies (flags, intl, editor API)
 * that the pure data operations don't need.
 */ 
var $8pLNp = parcelRequire("8pLNp");


var $5OfFS = parcelRequire("5OfFS");


var $3e10B = parcelRequire("3e10B");


var $aUBmi = parcelRequire("aUBmi");


var $eDBud = parcelRequire("eDBud");


var $gdHn1 = parcelRequire("gdHn1");


var $9gUQP = parcelRequire("9gUQP");

const $ee05d86412439e5a$export$17a216d338159b9 = {
    /**
   * Updates an existing snippet and updates the store in place (preserves list order).
   *
   * On success:
   * - Replaces the snippet in the store with the API response
   * - Shows a success flag (if options provided)
   * - Adds/updates the snippet in the quick insert menu
   *
   * On error:
   * - Reports to monitoring
   * - Shows an error flag (if options provided)
   * - Keeps existing snippets visible (doesn't reset isLoaded)
   *
   * @param snippetId - The ID of the snippet to update
   * @param name - The name of the snippet
   * @param body - The body of the snippet
   * @param description - Optional description text
   * @param options - UI options including flags, intl, and editor API
   * @returns Promise resolving to the updated snippet, or null on failure
   */ updateSnippet: (snippetId, name, body, description, options)=>async (storeApi)=>{
            const { getState: getState, setState: setState, dispatch: dispatch } = storeApi;
            const descriptionValue = description?.trim();
            const params = {
                name: name,
                ...descriptionValue ? {
                    description: descriptionValue
                } : {},
                body: JSON.stringify(body)
            };
            try {
                const snippet = await $3e10B.updateSnippet(snippetId, params);
                const currentSnippets = getState().snippets;
                const updatedSnippets = currentSnippets.map((s)=>s.snippetId === snippet.snippetId ? snippet : s);
                setState({
                    snippets: updatedSnippets
                });
                if (options) {
                    const { flags: flags, intl: intl, editorAPI: editorAPI, isShared: isShared } = options;
                    (0, $eDBud.showSnippetSuccessFlag)(flags, intl.formatMessage((0, $8pLNp.editSnippetModalMessages).editSuccessFlagTitle, {
                        snippetName: snippet.name
                    }), '');
                    if (editorAPI) (0, $5OfFS.updateSnippetInQuickInsertItem)({
                        snippet: snippet,
                        editorAPI: editorAPI
                    });
                    if (getState().isSnippetSharingForSiteEnabled) {
                        const hasSharedChanged = isShared != options.previousIsShared;
                        const shareOrUnshare = isShared && !options.previousIsShared ? (0, $gdHn1.shareActions).shareSnippet : (0, $gdHn1.shareActions).unshareSnippet;
                        if (hasSharedChanged) await dispatch(shareOrUnshare(snippetId, {
                            flags: flags,
                            intl: intl,
                            editorAPI: editorAPI ?? undefined,
                            onShareFailure: options.onShareFailure,
                            onUnshareFailure: options.onUnshareFailure
                        }));
                    }
                }
                return snippet;
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                (0, $aUBmi.reportError)(err);
                if (options) {
                    options.onSaveFailure?.(err);
                    const { flagTitle: flagTitle, flagDescription: flagDescription } = (0, $9gUQP.getSnippetErrorFlagMessages)(err, (0, $8pLNp.editSnippetModalMessages).editErrorFlagTitle, (0, $8pLNp.editSnippetModalMessages).editErrorFlagDescription);
                    (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage(flagTitle), options.intl.formatMessage(flagDescription));
                    return null;
                }
                throw err;
            }
        }
};
module.exports["updateActions"] = $ee05d86412439e5a$export$17a216d338159b9;

});

parcelRegister("8pLNp", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $be403b9494ea3648$export$b61e52cb99dfc21a = (0, $aXWIB.defineMessages)({
    titleEdit: {
        id: "snippets.snippetEditorModal.titleEdit",
        defaultMessage: "Edit block template"
    },
    saveButton: {
        id: "snippets.snippetEditorModal.saveButton",
        defaultMessage: "Save"
    },
    editSuccessFlagTitle: {
        id: "snippets.snippetEditorModal.editSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" updated"
    },
    editErrorFlagTitle: {
        id: "snippets.snippetEditorModal.editErrorFlagTitle",
        defaultMessage: "Could not update the template"
    },
    editErrorFlagDescription: {
        id: "snippets.snippetEditorModal.editErrorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["editSnippetModalMessages"] = $be403b9494ea3648$export$b61e52cb99dfc21a;

});

parcelRegister("d3Wxa", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hArLp = parcelRequire("hArLp");


var $ccHMk = parcelRequire("ccHMk");


var $cO1el = parcelRequire("cO1el");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $lsxnT = parcelRequire("lsxnT");


var $ivb8S = parcelRequire("ivb8S");


var $bEwOV = parcelRequire("bEwOV");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $hPTbh = parcelRequire("hPTbh");


var $8yRiX = parcelRequire("8yRiX");


var $jxXkP = parcelRequire("jxXkP");


var $4Vwd5 = parcelRequire("4Vwd5");


var $bUxVg = parcelRequire("bUxVg");

const $ba74060991560bb5$var$styles = {
    headerContainer: "_ca0qxy5q _u5f3xy5q _19bvxy5q",
    illustrationWrapper: "_1e0c1txw _1bah1h6o _n3tdu2gc"
};
const $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS = {
    ACTION_VIEWED: 'viewed',
    ACTION_DISMISSED: 'dismissed',
    DISMISSAL_CLOSE: 'close',
    DISMISSAL_VIEW_TEMPLATES: 'viewTemplates'
};
const $ba74060991560bb5$export$27aea554c0492dfd = (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { onClose: onClose, onCloseComplete: onCloseComplete } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const openSnippetPanel = (0, $8yRiX.useOpenSnippetPanel)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isViewMode = pageMode === (0, $cD1qu.PageMode).VIEW;
    const { fireModalClosedAnalytic: fireModalClosedAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).FIRST_SNIPPET_CREATED_MODAL);
    let t1;
    let t2;
    if ($[0] !== fireModalClosedAnalytic) {
        t1 = ()=>{
            fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).FIRST_SNIPPET_CREATED_MODAL, {
                action: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.ACTION_VIEWED
            });
        };
        t2 = [
            fireModalClosedAnalytic
        ];
        $[0] = fireModalClosedAnalytic;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[3] !== fireModalClosedAnalytic || $[4] !== onClose || $[5] !== setOnboardingState) {
        t3 = ()=>{
            fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).FIRST_SNIPPET_CREATED_MODAL, {
                action: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.ACTION_DISMISSED,
                dismissalAction: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.DISMISSAL_CLOSE
            });
            setOnboardingState({
                key: (0, $bEwOV.SNIPPETS_ONBOARDING).HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL,
                value: "true"
            });
            onClose();
        };
        $[3] = fireModalClosedAnalytic;
        $[4] = onClose;
        $[5] = setOnboardingState;
        $[6] = t3;
    } else t3 = $[6];
    const handleDismiss = t3;
    let t4;
    if ($[7] !== fireModalClosedAnalytic || $[8] !== onClose || $[9] !== openSnippetPanel || $[10] !== setOnboardingState) {
        t4 = ()=>{
            fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).FIRST_SNIPPET_CREATED_MODAL, {
                action: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.ACTION_DISMISSED,
                dismissalAction: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.DISMISSAL_VIEW_TEMPLATES
            });
            setOnboardingState({
                key: (0, $bEwOV.SNIPPETS_ONBOARDING).HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL,
                value: "true"
            });
            openSnippetPanel();
            onClose();
        };
        $[7] = fireModalClosedAnalytic;
        $[8] = onClose;
        $[9] = openSnippetPanel;
        $[10] = setOnboardingState;
        $[11] = t4;
    } else t4 = $[11];
    const handleViewTemplate = t4;
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalTitle));
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ba74060991560bb5$var$styles.headerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalSubtitle))));
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $ba74060991560bb5$var$styles.illustrationWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($4Vwd5))),
            alt: "",
            width: 554,
            height: 253,
            "data-testid": "first-snippet-created-illustration"
        })));
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== handleDismiss || $[16] !== handleViewTemplate || $[17] !== isViewMode) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, isViewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalOkButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: handleDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalCloseButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleViewTemplate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalViewButton)))));
        $[15] = handleDismiss;
        $[16] = handleViewTemplate;
        $[17] = isViewMode;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== Modal || $[20] !== handleDismiss || $[21] !== onCloseComplete || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            onClose: handleDismiss,
            onCloseComplete: onCloseComplete,
            width: "medium"
        }, t6, t7, t8);
        $[19] = Modal;
        $[20] = handleDismiss;
        $[21] = onCloseComplete;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
};
module.exports["FirstSnippetCreatedModal"] = $ba74060991560bb5$export$27aea554c0492dfd;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("4Vwd5", function(module, exports) {
module.exports = new URL("FirstSnippetCreatedIllustration.e21b8838.svg", import.meta.url).toString();

});

parcelRegister("bUxVg", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $83855988ed16504b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    firstSnippetCreatedModalTitle: {
        id: "snippets.firstSnippetCreatedModalTitle",
        defaultMessage: "Nice! You created your first template."
    },
    firstSnippetCreatedModalSubtitle: {
        id: "snippets.firstSnippetCreatedModalSubtitle",
        defaultMessage: "Type \"/template\" or favorite templates for quick access."
    },
    firstSnippetCreatedModalCloseButton: {
        id: "snippets.firstSnippetCreatedModalCloseButton",
        defaultMessage: "Close"
    },
    firstSnippetCreatedModalViewButton: {
        id: "snippets.firstSnippetCreatedModalViewButton",
        defaultMessage: "View my template"
    },
    firstSnippetCreatedModalOkButton: {
        id: "snippets.firstSnippetCreatedModalOkButton",
        defaultMessage: "Ok"
    }
});
module.exports["messages"] = $83855988ed16504b$export$defe85febe8b728c;

});

parcelRegister("cYuYM", function(module, exports) {

var $5vi32 = parcelRequire("5vi32");


var $9bL1w = parcelRequire("9bL1w");

const $955ee3c4efc889bc$export$349f17fbd3b37cd1 = ()=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    return !!(isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled);
};
module.exports["useIsSnippetCreateEnabled"] = $955ee3c4efc889bc$export$349f17fbd3b37cd1;

});

parcelRegister("inDu6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $kRW4Y = parcelRequire("kRW4Y");

function $34458177b4f70747$export$69f1ef99d32d73a0(InnerComponent) {
    var _WithDialogs;
    return _WithDialogs = class WithDialogs extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $kRW4Y.DialogsStateContainer)
                ]
            }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    dialogs: dialogs
                }));
        }
    }, _WithDialogs.displayName = `withDialogs(${InnerComponent.displayName || InnerComponent.name})`, _WithDialogs;
}
module.exports["withDialogs"] = $34458177b4f70747$export$69f1ef99d32d73a0;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $21K7m = parcelRequire("21K7m");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6mKj3 = parcelRequire("6mKj3");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$var$CommentType = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}($0343eaf78527fd4c$var$CommentType || {});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
var $0343eaf78527fd4c$export$368ed1d84e0ae668 = /*#__PURE__*/ function(CommentNavigationStatus) {
    CommentNavigationStatus["FOUND_IN_DOM"] = "FOUND_IN_DOM";
    CommentNavigationStatus["DELETED_CONTENT"] = "DELETED_CONTENT";
    CommentNavigationStatus["RESOLVED"] = "RESOLVED";
    CommentNavigationStatus["UNKNOWN"] = "UNKNOWN";
    CommentNavigationStatus["REMOVED_BY_ANOTHER_USER"] = "REMOVED_BY_ANOTHER_USER";
    return CommentNavigationStatus;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if the top edge of an element is visible in the viewport
 * Used to determine if scrolling is needed based on element visibility
 */ const $0343eaf78527fd4c$var$isElementTopVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
};
/**
 * Wait for an element to finish scrolling into view
 * Returns a Promise that resolves when the element is reasonably visible or times out
 */ const $0343eaf78527fd4c$var$waitForScrollCompletion = (element, timeout = 3000)=>{
    return new Promise((resolve)=>{
        const startTime = Date.now();
        const check = ()=>{
            if ($0343eaf78527fd4c$var$isElementTopVisible(element)) // Add a small delay after element becomes visible to let scrolling settle
            setTimeout(()=>resolve(true), 150);
            else if (Date.now() - startTime > timeout) resolve(false);
            else requestAnimationFrame(check);
        };
        // Small delay to let scroll animation start
        setTimeout(check, 16);
    });
};
/**
 * Helper function for viewport checking - returns true if should skip scrolling due to viewport visibility
 */ const $0343eaf78527fd4c$var$checkAndHandleViewportVisibility = (element, shouldScrollIfCommentIsInViewport)=>{
    if (!shouldScrollIfCommentIsInViewport) {
        const commentIsInViewport = $0343eaf78527fd4c$var$isElementTopVisible(element);
        if (commentIsInViewport) return true;
    }
    return false;
};
/**
 * Handle scroll completion based on awaitScrollCompletion flag and scroll behavior
 */ const $0343eaf78527fd4c$var$handleScrollCompletion = (awaitScrollCompletion, scrollBehavior, element)=>{
    if (awaitScrollCompletion) return scrollBehavior === "smooth" ? $0343eaf78527fd4c$var$waitForScrollCompletion(element) : Promise.resolve(true);
    return true;
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(commentThreadElement, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        // For panel navigation, always return Promise when awaitScrollCompletion is true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, commentThreadElement);
    }
    // Use optimized observer to watch for comment thread container creation
    commentId && (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
    if (existingComment) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(existingComment, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        // Wait for scroll completion when awaitScrollCompletion is true, otherwise return true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, existingComment);
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    }
    // we need to click on the annotation in the editor if the comment is not yet rendered
    if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
        targetElement: markElement,
        targetElementID: markElement.id,
        shouldScroll: false
    });
    // Comment not yet rendered, use DOM resolver to watch for it
    (0, $aHcFH.watchForCommentRepliesAndScroll)({
        targetCommentId: commentId,
        onScrollReady: (commentElement)=>{
            commentElement.scrollIntoView({
                behavior: scrollBehavior,
                block: block,
                inline: inline
            });
        },
        markElement: markElement
    });
    return true;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved, previousAnnotationId: previousAnnotationId } = options;
    // Get the mark element for both inline navigation and annotation events
    let markElement = document.getElementById(annotationId);
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    // Get the previous comment element for difference-based scrolling
    const previousCommentElement = previousAnnotationId ? document.getElementById(previousAnnotationId) : null;
    // Check if the mark element is in a sticky table header and adjust if needed
    const isInStickyTableHeader = markElement?.closest && markElement.closest('.pm-table-sticky-wrapper');
    if (isInStickyTableHeader && markElement && (0, $6mKj3.expValEquals)('confluence_comment_enable_table_header_navigation', 'isEnabled', true)) // Get the real element from the non-sticky table using getNodeForTableORMacro
    markElement = (0, $aHcFH.getNodeForTableORMacro)(markElement) || markElement;
    if (commentType === 'FOOTER') $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === 'INLINE' && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For standalone navigation (comments panel closed), expand the element if needed
    if (commentType === 'INLINE' && context === "renderer") (0, $aHcFH.checkElementExpand)(markElement, true);
    // Use difference-based scrolling if we have both previous and next elements
    if (previousCommentElement && markElement && previousCommentElement !== markElement && (0, $6mKj3.expValEquals)('confluence_comment_use_kbs_exp', 'isEnabled', true)) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between next and previous comment positions
                const nextRect = markElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = nextRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment with difference-based scrolling
        (0, $aHcFH.scrollToComment)(markElement, previousCommentElement, true, false);
        return true;
    }
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
/**
 * Calculate the height of media comment placeholder to adjust scroll offset.
 * When the media comment placeholder is visible, it pushes the contents of the page down,
 * so we need to scroll a bit less to keep the cursor over the navigation arrow icon.
 */ const $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight = (options)=>{
    const { previousCommentElement: previousCommentElement, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === totalComments - 1;
    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
        return mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
    }
    return 0;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    // Get the next comment element
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    const previousCommentElement = document.getElementById(previousMarkerRef);
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        const heightOfMediaCommentSelectedPlaceholder = $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight({
            previousCommentElement: previousCommentElement,
            action: action,
            nextCommentIndex: nextCommentIndex,
            totalComments: totalComments
        });
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions using calculateElementOffset
                // This handles special cases like sticky table headers
                const previousOffset = (0, $aHcFH.calculateElementOffset)(previousCommentElement);
                const nextOffset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const differenceOffset = nextOffset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
/**
 * Wait for a comment marker element to appear in the DOM.
 * Resolves immediately if the element already exists, otherwise waits via MutationObserver until timeout.
 */ const $0343eaf78527fd4c$var$waitForCommentElement = ({ markerRef: markerRef, timeoutMs: timeoutMs })=>{
    const existingElement = document.getElementById(markerRef);
    if (existingElement) return Promise.resolve(existingElement);
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            const element = document.getElementById(markerRef);
            if (!element) return;
            observer.disconnect();
            resolve(element);
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            observer.disconnect();
            const fallbackElement = document.getElementById(markerRef);
            resolve(fallbackElement);
        }, timeoutMs);
    });
};
const $0343eaf78527fd4c$export$6591627df1eb1f44 = async ({ markerRef: markerRef, commentId: commentId, timeoutMs: timeoutMs = 3000, getCommentThreadsRemovedByOtherUsers: getCommentThreadsRemovedByOtherUsers })=>{
    let element = null;
    if (markerRef) element = await $0343eaf78527fd4c$var$waitForCommentElement({
        markerRef: markerRef,
        timeoutMs: timeoutMs
    });
    // Check if comment was removed by another user BEFORE checking processed state
    // This check happens early because it's a specific known state
    // NOTE - we can't import the official type here due to circular dep concerns
    if (commentId) {
        const commentThreadsRemovedByOtherUsers = getCommentThreadsRemovedByOtherUsers?.();
        if (commentThreadsRemovedByOtherUsers?.[commentId] === 'deleted') return {
            status: "REMOVED_BY_ANOTHER_USER",
            element: undefined
        };
    }
    // Read processed state after DOM wait to avoid stale classification.
    const state = (0, $4L9ve.getProcessedCommentsDataState)();
    const rootComment = state.isDataProcessed && markerRef ? state.flatMarkerRefMap[markerRef] : undefined;
    if (element) {
        if (rootComment && (0, $kgNLQ.isCommentResolved)(rootComment)) return {
            status: "RESOLVED",
            element: undefined
        };
        return {
            status: "FOUND_IN_DOM",
            element: element
        };
    }
    // Comment marker is missing from the DOM — classify as DELETED_CONTENT or UNKNOWN.
    // Note: classification depends on cc_comments_new_comments_data_manager being enabled.
    // When disabled, state isn't populated so are forced into FOUND_IN_DOM or UNKNOWN
    if (!state.isDataProcessed) return {
        status: "UNKNOWN",
        element: undefined
    };
    const existsInData = rootComment || commentId && state.flatCommentsMap[commentId];
    return existsInData ? {
        status: "DELETED_CONTENT",
        element: undefined
    } : {
        status: "UNKNOWN",
        element: undefined
    };
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["CommentNavigationStatus"] = $0343eaf78527fd4c$export$368ed1d84e0ae668;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;
module.exports["waitForCommentStatus"] = $0343eaf78527fd4c$export$6591627df1eb1f44;

});

parcelRegister("4L9ve", function(module, exports) {
/**
 * Sweet state store for processed comments data.
 * This store should ONLY be updated by CommentsDataBackgroundLoader.
 * All other consumers should use the state/actions hooks to read data.
 */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");


var $kgNLQ = parcelRequire("kgNLQ");

const $20eb19f7ec5706e8$export$53ac33307b5acee9 = ()=>({
        lastProcessedData: null,
        allComments: [],
        allFilteredComments: [],
        openInlineComments: [],
        openFooterComments: [],
        resolvedComments: [],
        openComments: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        flatCommentsMap: {},
        flatMarkerRefMap: {},
        hasNestedComments: false,
        isDataProcessed: false,
        commentCount: 0,
        hasAnyComments: false,
        error: undefined,
        refetch: undefined
    });
const $20eb19f7ec5706e8$export$e324594224ef24da = {
    /**
	 * Updates all processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 * Note: refetch is set separately via setRefetch, so it's not included here.
	 */ setProcessedData: (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...data,
                error: undefined,
                // Keep existing refetch if it exists, don't overwrite it
                refetch: currentState.refetch
            });
        },
    /**
	 * Sets an error state for processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setError: (error)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                error: error,
                isDataProcessed: true
            });
        },
    /**
	 * Clears error and resets isDataProcessed to initial values.
	 * Skips setState when already at initial values to avoid unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearErrorAndResetIsDataProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const initialState = $20eb19f7ec5706e8$export$53ac33307b5acee9();
            if (currentState.error === initialState.error && currentState.isDataProcessed === initialState.isDataProcessed) return;
            setState({
                ...currentState,
                error: initialState.error,
                isDataProcessed: initialState.isDataProcessed
            });
        },
    /**
	 * Sets isDataProcessed to true without changing other state.
	 * Only updates if isDataProcessed is currently false to prevent unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setDataToProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isDataProcessed) return;
            setState({
                ...currentState,
                isDataProcessed: true
            });
        },
    /**
	 * Sets the refetch function from useAllCommentsData.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setRefetch: (refetch)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                refetch: refetch
            });
        },
    /**
	 * Clears all processed comments data and resets to initial state.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearProcessedData: ()=>({ setState: setState })=>{
            setState($20eb19f7ec5706e8$export$53ac33307b5acee9());
        },
    /**
	 * Processes the raw comments data if it hasn't already been processed and updates the store with
	 * categorized comments. Can be used with output from useAllCommentsData() hook (that is, the full
	 * comments data query result) or the full comments data cache (for when we need to synchronously
	 * process updated cache data).
	 *
	 * Note that for Apollo GQL, if the data hasn't changed then readQuery() will return the same
	 * data reference as the full comment query does. So it is safe to compare data references from
	 * real queries and cache reads to avoid unnecessary reprocessing.
	 *
	 */ // TODO: Verify the data reference behavior for Relay GQL when we start enabling Relay support.
    processCommentsData: ({ data: data, pageMode: pageMode })=>({ setState: setState, getState: getState })=>{
            // Nothing to process if data is null
            if (!data) return;
            // Don't process the same data twice - if the data reference is the same as the last processed
            const currentState = getState();
            if (currentState.isDataProcessed && currentState.lastProcessedData === data) return;
            // Filter out null nodes and create array (empty array if no data)
            const allComments = (data?.comments?.nodes || []).filter((node)=>node !== null);
            // Categorize comments using default contentStatus filters
            const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
            const categorizedData = (0, $kgNLQ.categorizeComments)(allComments, contentStatusFilters);
            // Update the store with categorized comments
            setState({
                ...currentState,
                ...categorizedData,
                allComments: allComments,
                lastProcessedData: data,
                error: undefined,
                isDataProcessed: true
            });
        }
};
const $20eb19f7ec5706e8$export$4be6ac988c62a591 = (0, $1P1Tu.createStore)({
    initialState: $20eb19f7ec5706e8$export$53ac33307b5acee9(),
    actions: $20eb19f7ec5706e8$export$e324594224ef24da,
    name: 'ProcessedCommentsDataStore'
});
const $20eb19f7ec5706e8$export$421cff7071854c91 = (0, $9zUhf.createHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$2919c8d01260d4fe = (0, $9zUhf.createActionsHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$93d43ef0fc9d136b = (0, $9zUhf.createStateHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
// Non-React utility for accessing store outside of React components
const $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance = (0, $4HDYO.defaultRegistry).getStore($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$db6951977b558d4d = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.storeState.getState();
};
const $20eb19f7ec5706e8$export$ae4b56ccf0bbe776 = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.actions;
};
module.exports["useProcessedCommentsData"] = $20eb19f7ec5706e8$export$421cff7071854c91;
module.exports["useProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$2919c8d01260d4fe;
module.exports["useProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$93d43ef0fc9d136b;
module.exports["getProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$db6951977b558d4d;
module.exports["getProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$ae4b56ccf0bbe776;

});

parcelRegister("kgNLQ", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $jbF1h = parcelRequire("jbF1h");

var $344a24116515d334$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $344a24116515d334$export$c6a7031105fdebc = (commentData, commentId)=>{
    // Search in retreived comments and their replies
    for (const comment of commentData){
        // Check if this is the comment we're looking for
        if (comment?.id === commentId) return comment;
        // Check if it's in the replies
        if (comment?.replies) {
            const foundReply = comment.replies.find((reply)=>reply?.id === commentId);
            if (foundReply) return foundReply;
        }
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$fb9051669482cbe0 = (condition, trueFn, falseFn)=>condition ? trueFn : falseFn;
const $344a24116515d334$export$6ba3a6375d12d24f = (commentData, replyParentId)=>{
    // Search through each root level comment's replies
    for (const comment of commentData){
        // Return this comment if it is the parent of the reply, else check if this comment has replies
        // and if any of them have the matching parentId
        if (comment?.id === replyParentId || comment?.replies.find((reply)=>reply?.id === replyParentId)) return comment;
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$3e4a472ec0de2dc6 = (commentData, markerRef)=>{
    // Search in retrieved comments and their replies
    for (const comment of commentData){
        // Check if this comment's marker ref matches
        const location = comment?.location;
        if (location?.inlineMarkerRef === markerRef) return comment;
    }
    return undefined;
};
const $344a24116515d334$export$499492f953d5abba = (comments, commentId, markerRef, contentStatus)=>{
    if (comments.length === 0) return undefined;
    let foundComment;
    if (commentId) foundComment = $344a24116515d334$export$c6a7031105fdebc(comments, commentId);
    else if (markerRef) foundComment = $344a24116515d334$export$3e4a472ec0de2dc6(comments, markerRef);
    if (!foundComment) return undefined;
    // Filter by contentStatus before returning
    const matchesContentStatusFilter = (comment)=>{
        if (!comment || !comment.contentStatus) return false;
        // Convert comment's contentStatus to uppercase to match GraphQLContentStatus format
        const commentStatus = comment.contentStatus.toUpperCase();
        return contentStatus.includes(commentStatus);
    };
    if (matchesContentStatusFilter(foundComment)) return foundComment;
    return undefined;
};
const $344a24116515d334$export$4d95f4b945556294 = (comment, mutationResult)=>{
    const resolveInlineComment = mutationResult?.data?.resolveInlineComment;
    const mutationStatus = resolveInlineComment?.status ?? false;
    const resolveProperties = resolveInlineComment?.resolveProperties ?? undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$d81a62b32f0e420f = (comment, mutationResult)=>{
    const commentResolutionStates = mutationResult?.data?.confluence_resolveComments?.commentResolutionStates;
    if ((commentResolutionStates?.length ?? 0) > 1) throw new Error('resolveCommentInCacheCallback() only supports one comment resolution state per mutation call');
    const firstResolutionState = commentResolutionStates?.[0] ?? undefined;
    const mutationStatus = firstResolutionState?.status ?? false;
    const partialResolveProperties = firstResolutionState?.resolveProperties ?? undefined;
    // We need to ensure that resolveProperties contains all non-optional properties so we can safely
    // spread it into the comment location resolve properties, so choose defaults for any missing
    // ones.  This is needed because some of the mutations don't request all the properties in their
    // responses.
    const resolveProperties = partialResolveProperties ? {
        resolved: true,
        isDangling: false,
        // These are nullable in the schema, but included to make Typescript happy
        resolvedUser: undefined,
        resolvedFriendlyDate: undefined,
        resolvedTime: undefined,
        // Add any non-null/undefined properties from the mutation result
        ...partialResolveProperties
    } : undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$aa65246494e3c3e0 = (comment, mutationResult)=>{
    // (The property is called "commentResolutionStates" but there is only one item per mutation call)
    const commentResolutionStates = mutationResult?.data?.confluence_reopenComment?.commentResolutionStates;
    if (commentResolutionStates) {
        const mutationStatus = commentResolutionStates.status ?? false;
        const partialResolveProperties = commentResolutionStates.resolveProperties ?? undefined;
        // We need to ensure that resolveProperties contains all non-optional properties so we can safely
        // spread it into the comment location resolve properties, so choose defaults for any missing
        // ones. This is needed because some of the mutations don't request all the properties - or even
        // the commentResolutionStates property at all in their responses.
        const resolveProperties = {
            resolved: false,
            isDangling: false,
            // These are nullable in the schema, but included to make Typescript happy
            resolvedUser: undefined,
            resolvedFriendlyDate: undefined,
            resolvedTime: undefined,
            // Add any non-null/undefined properties from the mutation result
            ...partialResolveProperties
        };
        return (0, $jbF1h.resolveCommentInCache)({
            comment: comment,
            mutationStatus: mutationStatus,
            resolveProperties: resolveProperties
        });
    }
    // Else commentResolutionStates wasn't returned - assume failure to reopen
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: false,
        resolveProperties: undefined
    });
};
const $344a24116515d334$export$e237bdee87974d46 = (pageMode)=>{
    // On view pages, exclude draft comments
    if (pageMode === (0, $cD1qu.PageMode).VIEW) return [
        'CURRENT',
        'ARCHIVED'
    ];
    // On edit and live pages, include all statuses
    return [
        'CURRENT',
        'ARCHIVED',
        'DRAFT'
    ];
};
const $344a24116515d334$export$70df9f207ee9869d = (comment)=>{
    const location = comment?.location;
    if (location) {
        if ('inlineResolveProperties' in location) return location.inlineResolveProperties?.resolved ?? false;
        else if ('commentResolveProperties' in location) return location.commentResolveProperties?.resolved ?? false;
    }
    return false;
};
const $344a24116515d334$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply && reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $344a24116515d334$export$2fa0b601110c277b = (comments, contentStatusFilters)=>{
    const allFilteredComments = [];
    const openComments = [];
    const openInlineComments = [];
    const openFooterComments = [];
    const resolvedComments = [];
    // Transform array-based data to map structure for legacy compatibility
    const commentsDataMap = {
        inline: {},
        general: {}
    };
    // Build flat map of all comments (including replies) for O(1) lookup by commentId
    const flatCommentsMap = {};
    // Build flat map of inline comments keyed by markerRef for O(1) lookup
    const flatMarkerRefMap = {};
    for (const comment of comments)// Filter by content status, which is a string literal type (that is, a set of allowed
    // strings), so be cautious if the definitions or schema change
    if (comment && contentStatusFilters.includes(comment.contentStatus?.toUpperCase())) {
        allFilteredComments.push(comment);
        // Add comment to flat map by commentId
        if (comment?.id) flatCommentsMap[comment.id] = comment;
        // Add inline parent comment to flatMarkerRefMap by markerRef (only parent comments, not replies)
        if (comment?.location?.type === 'INLINE' && !comment?.parentId) {
            const location = comment.location;
            if (location?.inlineMarkerRef) flatMarkerRefMap[location.inlineMarkerRef] = comment;
        }
        // Add all replies to flat map
        if (comment?.replies) {
            for (const reply of comment.replies)if (reply?.id) flatCommentsMap[reply.id] = reply;
        }
        const isOpen = !$344a24116515d334$export$70df9f207ee9869d(comment);
        const commentType = comment.location?.type === 'INLINE' ? "inline" : "general";
        const commentWithProperties = {
            ...comment,
            type: commentType,
            isOpen: isOpen,
            wasRemovedByAnotherUser: false,
            replies: comment.replies?.filter((reply)=>reply !== null && reply !== undefined).map((reply)=>({
                    ...reply,
                    wasRemovedByAnotherUser: false
                }))
        };
        if (isOpen) {
            openComments.push(comment);
            if (comment?.location?.type === 'INLINE') openInlineComments.push(comment);
            else if (comment?.location?.type === 'FOOTER') openFooterComments.push(comment);
        // else unknown or missing location type, do nothing
        } else resolvedComments.push(comment);
        if (comment.location?.type === 'INLINE') {
            const threadKey = 'inlineMarkerRef' in comment.location ? comment.location.inlineMarkerRef || comment.id : comment.id;
            commentsDataMap.inline[threadKey] = commentWithProperties;
        } else if (comment.location?.type === 'FOOTER') commentsDataMap.general[comment.id] = commentWithProperties;
    }
    const hasNestedComments = $344a24116515d334$export$6036c2c532b2fa41(commentsDataMap);
    const commentCount = allFilteredComments.length;
    const hasAnyComments = commentCount > 0;
    return {
        allFilteredComments: allFilteredComments,
        openComments: openComments,
        openInlineComments: openInlineComments,
        openFooterComments: openFooterComments,
        resolvedComments: resolvedComments,
        commentsDataMap: commentsDataMap,
        flatCommentsMap: flatCommentsMap,
        flatMarkerRefMap: flatMarkerRefMap,
        hasNestedComments: hasNestedComments,
        commentCount: commentCount,
        hasAnyComments: hasAnyComments
    };
};
module.exports["findCommentInData"] = $344a24116515d334$export$c6a7031105fdebc;
module.exports["selectUpdateFunction"] = $344a24116515d334$export$fb9051669482cbe0;
module.exports["findRootCommentForReply"] = $344a24116515d334$export$6ba3a6375d12d24f;
module.exports["findAndFilterComment"] = $344a24116515d334$export$499492f953d5abba;
module.exports["resolveInlineCommentInCacheCallback"] = $344a24116515d334$export$4d95f4b945556294;
module.exports["resolveCommentInCacheCallback"] = $344a24116515d334$export$d81a62b32f0e420f;
module.exports["reopenCommentInCacheCallback"] = $344a24116515d334$export$aa65246494e3c3e0;
module.exports["buildDefaultCommentsContentStatusFilters"] = $344a24116515d334$export$e237bdee87974d46;
module.exports["isCommentResolved"] = $344a24116515d334$export$70df9f207ee9869d;
module.exports["categorizeComments"] = $344a24116515d334$export$2fa0b601110c277b;

});

parcelRegister("jbF1h", function(module, exports) {

var $82R8R = parcelRequire("82R8R");


var $6nYhN = parcelRequire("6nYhN");


var $42omo = parcelRequire("42omo");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");







// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/useCommentById.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this function - or at least the cache updating parts for the function
// - into the useAllCommentsData.ts file.
const $bd790562493588ff$var$updateCommentInCacheFragment = (0, $6nYhN.default);
// Fragment for reply comments (matches the replies schema from the main fragment)
const $bd790562493588ff$var$updateReplyInCacheFragment = (0, $82R8R.default);
// Type guard to check if a comment is a top-level comment (has replies field)
const $bd790562493588ff$var$isTopLevelComment = (comment)=>{
    return 'replies' in comment;
};
const $bd790562493588ff$export$8ce65958c48a9ac3 = ()=>{
    const readFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment
    });
    const writeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $6nYhN.default),
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment
    });
    const readReplyFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment
    });
    const writeReplyFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $82R8R.default),
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment
    });
    /**
   * Function to update a comment in the Apollo cache.
   * @param mutationResult - The result of the mutation that triggered the cache update
   * @param commentId - ID of the comment to update
   * @param updateCallback - Callback function that receives the current comment data
   *                         and returns the updated comment data
   * @param onError - Optional error callback to handle errors during the update process
   * @param isReply - Whether this comment is a reply (true) or top-level comment (false)
   */ const updateCommentInCache = (0, $42omo.useCallback)(({ mutationResult: mutationResult, commentId: commentId, updateCallback: updateCallback, onError: onError, isReply: isReply = false })=>{
        if (!commentId) {
            onError?.(new Error('Cannot update comment in cache: comment ID is missing'));
            return;
        }
        try {
            // The fragment ID format for Apollo cache
            const fragmentId = `Comment:${commentId}`;
            let cachedComment = null;
            if (isReply) cachedComment = readReplyFragment({
                id: fragmentId
            });
            else cachedComment = readFragment({
                id: fragmentId
            });
            if (!cachedComment) {
                // (There is a slight chance the comment is not in cache - but the mutation that calls
                // this function would have to completed successfully to call us, so presumably the
                // comment existed then. Thus the only legit reason for it to be missing from the cache
                // now is if another user deleted the comment in between the mutation and this cache
                // update call. That is unlikely, so let's log this as an error and return. If in
                // the future we find the legit use case is happening more often, we can change to a
                // warning instead.)
                onError?.(new Error(`Cannot update comment in cache: comment with ID ${commentId} not found in cache`));
                return;
            }
            // Apply the update callback on a copy of the cached comment
            // (Note that the updateCallback should return a new object, not mutate the original - so
            //  make copies of any nested objects you need to change also)
            const updatedComment = updateCallback({
                ...cachedComment
            }, mutationResult);
            // Write the updated comment back to cache using appropriate fragment
            if (isReply) writeReplyFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
            else writeFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when updating cached comment data: ${err}`));
            return;
        }
    }, [
        readFragment,
        writeFragment,
        readReplyFragment,
        writeReplyFragment
    ]);
    return {
        updateCommentInCache: updateCommentInCache
    };
};
const $bd790562493588ff$export$9e04af313e7174f4 = ({ comment: comment, mutationStatus: mutationStatus, resolveProperties: resolveProperties })=>{
    if (!mutationStatus || !resolveProperties) // Mutation result is missing or incomplete - so just return the comment unchanged
    return comment;
    // Extract isDangling separately since it is handled differently, and exclude __typename since we
    // don't need it and Typescript would complain about it being included in the spread below.
    const { __typename: __typename, isDangling: isDangling, ...otherResolveProperties } = resolveProperties;
    // Mark the comment as resolved in the cache, but how to do that depends on the comment type
    const location = comment.location;
    const newLocation = {
        ...location,
        ...'commentResolveProperties' in location ? {
            commentResolveProperties: {
                ...location.commentResolveProperties,
                ...otherResolveProperties
            }
        } : {},
        ...'inlineResolveProperties' in location ? {
            inlineResolveProperties: {
                ...location.inlineResolveProperties,
                ...otherResolveProperties,
                isDangling: isDangling
            }
        } : {}
    };
    return {
        ...comment,
        location: newLocation
    };
};
const $bd790562493588ff$export$df3d27666bd765d5 = (comment, mutationResult)=>{
    const newBodyValue = mutationResult?.data?.updateComment?.body?.value;
    const updatedBody = {
        ...comment.body,
        // Remember that an empty string is a valid body value, so only skip updating if newBodyValue
        // is null or undefined
        ...newBodyValue || newBodyValue === '' ? {
            value: newBodyValue
        } : {}
    };
    const newVersion = mutationResult?.data?.updateComment?.version;
    const newDisplayName = newVersion?.by?.displayName;
    // If the existing comment's version doesn't have a "by" field, we don't want to add just part
    // of it - so set it to undefined so it won't be included in the updated comment. This probably
    // won't actually ever happen, but it makes Typescript happy just in case.
    const updatedBy = comment.version?.by ? {
        ...{
            ...comment.version?.by
        },
        ...newDisplayName ? {
            displayName: newDisplayName
        } : {}
    } : undefined;
    const updatedVersion = {
        ...comment.version,
        ...newVersion?.number ? {
            number: newVersion.number
        } : {},
        ...newVersion?.when ? {
            when: newVersion.when
        } : {},
        ...updatedBy ? {
            by: {
                ...updatedBy
            }
        } : {}
    };
    const baseUpdatedComment = {
        ...comment,
        body: updatedBody,
        version: {
            ...updatedVersion
        }
    };
    // Return with appropriate type casting based on comment type
    return $bd790562493588ff$var$isTopLevelComment(comment) ? baseUpdatedComment : baseUpdatedComment;
};
module.exports["useUpdateCommentInCache"] = $bd790562493588ff$export$8ce65958c48a9ac3;
module.exports["resolveCommentInCache"] = $bd790562493588ff$export$9e04af313e7174f4;
module.exports["updateCommentBodyInCacheCallback"] = $bd790562493588ff$export$df3d27666bd765d5;

});

parcelRegister("82R8R", function(module, exports) {
/**
 * @generated SignedSource<<a28c33873372435f34422a806f024f7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ee66e0478f0211a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v4 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheReplyFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            }
                        ],
                        "type": "KnownUser"
                    },
                    {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "profilePicture",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "path"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "representation",
                        "value": "ATLAS_DOC_FORMAT"
                    }
                ],
                "concreteType": "DocumentBody",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": v2 /*: any*/ ,
                "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "createdAt",
                "plural": false,
                "selections": v2 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "createdAtNonLocalized"
            },
            {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "commentResolveProperties",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "FooterComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "inlineMarkerRef"
                            },
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "inlineResolveProperties",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDangling"
                                    },
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "inlineText"
                            }
                        ],
                        "type": "InlineComment"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "parentId"
            },
            {
                "concreteType": "CommentPermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRemovable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isResolvable"
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$6ee66e0478f0211a$var$node.hash = "d793bb57d64855b11bf515ef7082e802";
var $6ee66e0478f0211a$export$2e2bcd8739ae039 = $6ee66e0478f0211a$var$node;
module.exports["default"] = $6ee66e0478f0211a$export$2e2bcd8739ae039;

});

parcelRegister("6nYhN", function(module, exports) {
/**
 * @generated SignedSource<<7d3802295084914a69fb8fc043a13c00>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d633d5b65e9f4e8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v10 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v11 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v12 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "number"
    }, v21 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ 
                ]
            },
            v8 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v6 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    },
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ]
                            },
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v2 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "type": "Comment"
    };
}();
$1d633d5b65e9f4e8$var$node.hash = "b050d36387ca001aa3988c3e0f6d32bb";
var $1d633d5b65e9f4e8$export$2e2bcd8739ae039 = $1d633d5b65e9f4e8$var$node;
module.exports["default"] = $1d633d5b65e9f4e8$export$2e2bcd8739ae039;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') return "[annotationtype='inlineComment']";
    else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$var$isHighlightCandidateVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(element);
    return element.isConnected && computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true' && (rect.width > 0 || rect.height > 0);
};
const $a78c261c3211f7d6$export$c36aa9f15eddb765 = (markerRef)=>{
    if (!markerRef) return null;
    const allHighlights = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    const visibleHighlight = allHighlights.find((element)=>$a78c261c3211f7d6$var$isHighlightCandidateVisible(element));
    return visibleHighlight || $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$82eb6662255613e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadContainerId: commentThreadContainerId, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    const behavior = useInstantScroll ? 'instant' : 'smooth';
    if (isCommentsPanel) {
        const element = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
        const commentThreadParentElement = element.getBoundingClientRect().top;
        const commentThreadSelector = document.querySelector(`[data-testid='comments-panel-list-container']`);
        const inlineCommentPosition = element?.getBoundingClientRect();
        const documentContent = document.getElementById('content');
        const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
        const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && Math.floor(inlineCommentPosition.top) < Math.floor(documentContentTopPosition);
        const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        /**
     * Determine which panel or section needs to be scrolled:
     * the content area or the comments panel.
     * We need to find out if the highlight or panel is above or below the viewport.
     * This will help us decide which one to scroll.
     */ if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) // if the comment highlight is above or below viewport use content area to scroll;
        scrollRootElement.scrollBy({
            top: window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top),
            behavior: behavior
        });
        else if (commentThreadSelector && (commentAboveViewport || commentBelowViewport || window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top) < 0)) // if the comment thread is above or below viewport or
        // there is difference in top of comment thread and highlight if completely visible in the viewport
        //  use commentThreadSelector as an element to scroll ;
        commentThreadSelector.scrollBy({
            top: window.innerHeight - targetCommentHighlight.top - (window.innerHeight - commentThreadParentElement),
            behavior: behavior
        });
        else scrollRootElement.scrollBy({
            top: targetCommentHighlight.top - commentThreadParentElement,
            behavior: behavior
        });
    } else {
        // We may be in an iframe so use window.top
        const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
        const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
        // If the position of the highlight is more than halfway down the screen, reposition it to the center
        if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
            const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
            scrollRootElement.scrollTo({
                top: offset - windowOffset,
                behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
            });
        }
    //If comment is in expand, open respective expand
    }
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadAnnotationId: commentThreadAnnotationId, isCommentsPanel: isCommentsPanel })=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        const commentThreadContainerId = `comment-thread-${commentThreadAnnotationId}-container`;
        $a78c261c3211f7d6$export$82eb6662255613e({
            commentElement: commentElement,
            isFabricPage: isFabricPage,
            useInstantScroll: useInstantScroll,
            isAbove: isAbove,
            commentThreadContainerId: commentThreadContainerId,
            isCommentsPanel: isCommentsPanel
        });
        return;
    }
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$59a770a0e59b0dd2 = (container)=>{
    const selector = [
        'button:not([disabled])',
        'a[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[contenteditable="true"]',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.from(container.querySelectorAll(selector)).filter((element)=>!element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true');
};
const $a78c261c3211f7d6$export$642e21ba866d02df = (container, element)=>{
    if (!element) return false;
    return $a78c261c3211f7d6$export$59a770a0e59b0dd2(container)[0] === element;
};
const $a78c261c3211f7d6$export$876aeb5dffd449af = (container, element)=>{
    if (!element) return false;
    const tabbableElements = $a78c261c3211f7d6$export$59a770a0e59b0dd2(container);
    return tabbableElements[tabbableElements.length - 1] === element;
};
const $a78c261c3211f7d6$export$cfa8eefe354167cd = (element, focusOptions)=>{
    element.setAttribute('tabIndex', '-1');
    element.focus(focusOptions);
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // new sticky header implementation
    if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false)) {
        if (relativeToElement && nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('tr.pm-table-row-native-sticky-active')) {
            const elementRect = nodeToMeasure.getBoundingClientRect();
            const containerRect = relativeToElement.getBoundingClientRect();
            return elementRect.top - containerRect.top;
        }
    }
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper') && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$bec1a1359bf081c5 = ()=>window.clipboardData && typeof window.clipboardData.setData === 'function';
const $a78c261c3211f7d6$export$dcc703cd1f894b4c = (textToCopy)=>new Promise((resolve, reject)=>{
        if ($a78c261c3211f7d6$export$bec1a1359bf081c5()) {
            window.clipboardData.setData('text', textToCopy);
            resolve();
        } else reject('IE clipboard api is not supported');
    });
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$d26ca9d0d4cbdbe9 = (text, ref)=>new Promise((res, rej)=>{
        if (!ref) {
            rej();
            return;
        }
        const textarea = document.createElement('textarea');
        textarea.readOnly = true;
        textarea.defaultValue = text;
        ref.appendChild(textarea);
        textarea.select();
        const wasCopied = document.execCommand('copy');
        ref.removeChild(textarea);
        wasCopied ? res() : rej();
    });
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = (entries)=>{
    const windowHeight = window.innerHeight;
    if ((0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
        if (!(0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
            // When fg is ON, we would have verified that there's no
            // endOfPageRecommendations before adding this ResizeObserver.
            // So no need to check it here.
            const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
            if (endOfPageRecommendations) return 0;
        }
        const editorTextArea = document.getElementById('ak-editor-textarea');
        const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
        if (editorBottom && windowHeight) {
            // The minimum spacing between bottom of editor content and top of footer is 120px
            const minimumSpacing = 120;
            // - There's an existing fixed 24px margin below editor content.
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px to make it visually distinct
            //   when a short LiveDoc has some vs zero existing footer comment.
            const editorBottomMargin = 24;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
            const currentScroll = editorScrollParent?.scrollTop ?? 0;
            const editorBottomUnscrolled = editorBottom + currentScroll;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
            return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
        }
    } else {
        // The calculation is
        // 15px of marginTop on the comment container
        // 2px full-page-editor-style bottom which above the viewport
        // 1px border which is cumulates to 120px
        const thresholdTop = 102;
        const editorEntry = entries.find((entry)=>entry.target.id === 'ak-editor-textarea');
        const editorBottom = editorEntry?.target.getBoundingClientRect().bottom;
        const editorContentHeight = document.querySelector(`.ak-editor-content-area .ProseMirror`)?.getBoundingClientRect().height;
        const documentContentBottom = document.querySelector(`[data-testid='full-page-editor-style']`)?.getBoundingClientRect().bottom;
        if (editorContentHeight) {
            // If the document content is larger than the window height, just set it to a static 120 to keep the proper spacing
            if (editorContentHeight > windowHeight) return 120;
            if (documentContentBottom && editorBottom) {
                const verticalDistance = documentContentBottom - editorBottom;
                if (verticalDistance >= thresholdTop && editorContentHeight <= windowHeight) return verticalDistance - thresholdTop;
                else if (verticalDistance <= thresholdTop) return thresholdTop;
            }
        }
    }
};
const $a78c261c3211f7d6$export$e3a17b46d43aa5f6 = ()=>{
    // This is deprecated, and will be replaced by a new approach that works in SSR.
    let newTop = 0;
    const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
    const legacyLabels = document.querySelector('[data-vc="view-page-labels-container"]');
    // no extra spacing if the page shows end-of-page recommendations or legacy labels
    if (!endOfPageRecommendations && !legacyLabels) {
        const rendererContent = document.getElementById('main-content');
        const rendererContentBottom = rendererContent?.getBoundingClientRect()?.bottom ?? 0;
        if (rendererContentBottom) {
            // - There's an existing fixed 80px margin below Page content (See
            //   next/packages/view-page-common/src/ViewPageContent.tsx).
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px (matching Editor version ^)
            //   to make it visually distinct when a short Page has some vs zero
            //   existing footer comment.
            const contentBottomMargin = 80;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // Find the current scroll offset on the Page.
            // This is similar to implementation in getDimensionsForNav4(),
            // but when the window is very narrow, nav4ScrollParent.scrollTop
            // can be 0 (nav4ScrollParent element itself exists on page) while
            // window.scrollY is positive.
            // So this is a more robust implementation. Will explore whether
            // getDimensionsForNav4() can be updated to use this implementation
            // in a separate PR.
            const nav4ScrollParent = document.getElementById('AkMainContent');
            const currentPageOffset = (nav4ScrollParent?.scrollTop ?? 0) + (window.scrollY ?? window.top?.scrollY ?? 0);
            const rendererContentBottomUnscrolled = rendererContentBottom + currentPageOffset;
            const windowHeight = window.innerHeight;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - rendererContentBottomUnscrolled - contentBottomMargin;
            newTop = Math.max(verticalDistanceFromWindowBottomUnscrolled - addFooterCommentHeight - extraFooterCommentHeightToShow, 0);
        }
    }
    return newTop;
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = scrollRootElement instanceof Window ? 0 // Window doesn't have a bounding rect; its top is always 0
     : scrollRootElement.getBoundingClientRect().top;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        // Look for the comment element directly
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default,
 *  this is the div with id=AkMainContent, if the id exists in the DOM
 */ function $a78c261c3211f7d6$var$getScrollRootContext() {
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const scrollRootElement = nav4ScrollRootElement || window;
    const scrollRootOffset = nav4ScrollRootElement ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        else return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    if (pageMode !== (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width_ld') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) ? endOfPageRecommendationsMaxWidth : '100%'
    };
    // Base case: when the fg for the current pageMode isn't ON, i.e. either of:
    // - pageMode === PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // - pageMode !== PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width_ld') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // This block can be removed entirely once both fgs are rolled out.
    let maxWidth = '100%';
    if (pageWidthType) maxWidth = JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? '1000px' : 'unset';
    return {
        width: '100%',
        maxWidth: maxWidth
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["getFocusableElementFromMarkerRef"] = $a78c261c3211f7d6$export$c36aa9f15eddb765;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollPageCommentIntoView"] = $a78c261c3211f7d6$export$858fd2398afb28e4;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["getNodeForTableORMacro"] = $a78c261c3211f7d6$export$ee0755cb593feed6;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["isFirstTabbableElement"] = $a78c261c3211f7d6$export$642e21ba866d02df;
module.exports["isLastTabbableElement"] = $a78c261c3211f7d6$export$876aeb5dffd449af;
module.exports["focusElementAndUpdateTabIndex"] = $a78c261c3211f7d6$export$cfa8eefe354167cd;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["isClipboardApiSupported"] = $a78c261c3211f7d6$export$b401b3c3a0774fd7;
module.exports["isIEClipboardApiSupported"] = $a78c261c3211f7d6$export$bec1a1359bf081c5;
module.exports["copyToClipboardIE"] = $a78c261c3211f7d6$export$dcc703cd1f894b4c;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["legacyCopyToClipboard"] = $a78c261c3211f7d6$export$d26ca9d0d4cbdbe9;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["getCommentPositionTopOfSectionRenderer"] = $a78c261c3211f7d6$export$e3a17b46d43aa5f6;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $42omo.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint && (0, $9wGTI.fg)("confluence_fe_add_page_comment_exp_coverage")) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else {
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
    }
    let t7;
    if ($[11] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[11] = t2;
        $[12] = t7;
    } else t7 = $[12];
    const dispatchProviderValue = t7;
    let t8;
    if ($[13] !== children || $[14] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[13] = children;
        $[14] = dispatchProviderValue;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== providerValue || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[16] = providerValue;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const providerValue = (0, $42omo.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint && (0, $9wGTI.fg)('confluence_fe_add_page_comment_exp_coverage')) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $42omo = parcelRequire("42omo");


var $ag6aQ = parcelRequire("ag6aQ");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $9wGTI = parcelRequire("9wGTI");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $42omo.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $42omo.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $42omo.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $42omo.useState)(false);
    const firstHighlightClicked = (0, $42omo.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $42omo.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $42omo.useState)(null);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $42omo.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = document.getElementById(nextThreadKey) || ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? document.getElementById(`footer-comment-thread-${nextThreadKey}-container`) : null);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("dkkKv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $7c240d799ee287c0$export$1369688a638bab5e = ({ pageId: pageId, skip: skip = false, type: type, onCompletedFn: onCompletedFn, returnNativeLoading: returnNativeLoading = false, useStableCommentsDataUpdates: useStableCommentsDataUpdates = false, fetchPolicy: fetchPolicy, isPreload: isPreload = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap, setFooterCommentsLoadingState: setFooterCommentsLoadingState }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Using preload variables isn't 100% necessary since we write to the full cache,
    // but should be more stable in the event the full cache update fails
    const queryVariables = isPreload ? (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(pageId, isArchived) : (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
        pageId: pageId,
        type: type,
        isArchived: isArchived
    });
    const cacheUpdateFailedFetchPolicy = cacheUpdateFailed && (0, $9wGTI.fg)('confluence_comment_donot_use_cache') ? 'network-only' : undefined;
    const defaultFetchPolicy = skipQuery || isPreload ? 'cache-only' : 'cache-and-network'; // TODO: Cache and network probably not perfect, used to ensure consistency on the panel
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $b1hSc.default), {
        variables: queryVariables,
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: fetchPolicy || cacheUpdateFailedFetchPolicy || defaultFetchPolicy,
        skip: skipQuery,
        onCompleted: (result)=>{
            // onCompleted doesn't fire as expected after multiple cache reads
            if (!useStableCommentsDataUpdates && result) {
                (0, $3ZsvI.updateCommentsDataState)({
                    data: result,
                    updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                    pageMode: pageMode,
                    currentUserId: currentUserId ?? '',
                    isOpen: true
                });
                if (!skipQuery) // Don't update loading state if the query is skipped
                // onCompleted will still get called in some circumstances with skip = true
                (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
            }
            setLoading(false);
            if (result) onCompletedFn && onCompletedFn();
        },
        onError: undefined,
        errorPolicy: 'all'
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
            setLoading(false);
        }
    }, [
        error
    ]);
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    let returnLoading = queryLoading;
    // If we're not returning the native loading out of apollo, update returnLoading to our tracked version
    if (!returnNativeLoading) returnLoading = !skipQuery ? loading : false;
    // We set totalCount to ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG when preload is loading
    // We should respect this regardless of context, since the query really is loading behind the scenes
    const isPreloadLoading = data?.comments?.totalCount === (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG);
    returnLoading = isPreloadLoading || returnLoading;
    (0, $42omo.useEffect)(()=>{
        // onCompleted gets fired on the first cache-read only, which as you can imagine causes a lot of race conditions during transition
        // This is the recommended way to deal with complex scenarios involving cache + network reads
        // onCompleted will also fire incorrectly for concurrent calls on the same page, since it has an outdated copy of hasAlreadyFetchedInitialData telescoped in before some calls complete
        if (!skipQuery && isPreloadLoading) // Mark this as preloading to prevent race conditions where loading is not yet set in caller
        setFooterCommentsLoadingState((0, $8i27m.FooterCommentsLoadingStateType).PRELOADING);
        if (useStableCommentsDataUpdates && !isPreloadLoading && !skipQuery && data) {
            // Preload updates data, which we don't want
            (0, $3ZsvI.updateCommentsDataState)({
                data: data,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            // Don't update loading state if the query is skipped
            (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
        }
    }, [
        data,
        useStableCommentsDataUpdates,
        hasAlreadyFetchedInitialData,
        addNewCommentThreads,
        setCommentsDataMap,
        pageMode,
        currentUserId,
        skipQuery,
        type,
        setFooterCommentsLoadingState,
        isPreloadLoading
    ]);
    return {
        loading: returnLoading,
        data: data,
        error: error,
        refetch: refetch
    };
};
module.exports["useActiveCommentsQuery"] = $7c240d799ee287c0$export$1369688a638bab5e;

});

parcelRegister("aqBZ0", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("9rE3H", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $5b808dc3cc2fdcb5$export$3816ffab97d6707 = 3;
const $5b808dc3cc2fdcb5$export$c2458e66b06ab105 = -1; // We can't do cache.evict based on apollo version, so use -1 as a flag
const $5b808dc3cc2fdcb5$export$ed108990552755bd = 2000;
const $5b808dc3cc2fdcb5$export$37f798be419840d9 = (contentId, isArchived)=>{
    return {
        pageId: contentId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        type: [
            'FOOTER'
        ],
        first: $5b808dc3cc2fdcb5$export$3816ffab97d6707
    };
};
const $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef = ({ pageId: pageId, type: type, isArchived: isArchived = false })=>{
    return {
        pageId: pageId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        first: $5b808dc3cc2fdcb5$export$ed108990552755bd,
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        ...(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && type && {
            type: [
                type
            ]
        }
    };
};
module.exports["ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG"] = $5b808dc3cc2fdcb5$export$c2458e66b06ab105;
module.exports["buildConsistentActiveCommentsQueryPreloadVariables"] = $5b808dc3cc2fdcb5$export$37f798be419840d9;
module.exports["buildConsistentActiveCommentsQueryVariables"] = $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef;

});

parcelRegister("b1hSc", function(module, exports) {
/**
 * @generated SignedSource<<9ab41dc45703244000b6f4f95f4c39b0>>
 * @relayHash 51e15b77790c5d8cdaef4df99503fbf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386
const $4bf9442691f65266$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "commentState",
                    "value": "UNRESOLVED"
                },
                {
                    "kind": "Variable",
                    "name": "commentType",
                    "variableName": "type"
                }
            ],
            "kind": "ObjectValue",
            "name": "confluenceCommentFilter"
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "singleThreaded",
            "value": true
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v6 /*: any*/ ,
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "type"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v21 /*: any*/ ,
                    v20 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v26 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "when"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v35 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v34 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v35 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v36 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "51e15b77790c5d8cdaef4df99503fbf3",
            "id": "3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386",
            "metadata": {},
            "name": "ActiveCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$type:[CommentType],$first:Long)@allowHigherTimeout{comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:$type},singleThreaded:true,type:$type,first:$first){__typename,nodes{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},replies{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}},totalCount}}"
        }
    };
}();
$4bf9442691f65266$var$node.hash = "37d97577cf19b12ed92bf7d36576353c";
var $4bf9442691f65266$export$2e2bcd8739ae039 = $4bf9442691f65266$var$node;
module.exports["default"] = $4bf9442691f65266$export$2e2bcd8739ae039;

});

parcelRegister("8i27m", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $a4TK8 = parcelRequire("a4TK8");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $3ZsvI = parcelRequire("3ZsvI");

const $33a0cfbfba499043$var$logger = (0, $7W8i8.getLogger)('comments-data');
var $33a0cfbfba499043$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
var $33a0cfbfba499043$export$74159dff405238c0 = /*#__PURE__*/ function(CommentActionType) {
    CommentActionType["CREATE_COMMENT"] = "created";
    CommentActionType["DELETE_COMMENT"] = "deleted";
    CommentActionType["RESOLVE_COMMENT_THREAD"] = "resolved";
    CommentActionType["REOPEN_COMMENT_THREAD"] = "reopened";
    CommentActionType["REATTACH_COMMENT"] = "reattach";
    return CommentActionType;
}({});
var $33a0cfbfba499043$export$2021eb0669e47276 = /*#__PURE__*/ function(FooterCommentsLoadingStateType) {
    FooterCommentsLoadingStateType["NOT_LOADED"] = "not_loaded";
    FooterCommentsLoadingStateType["PRELOADING"] = "preloading";
    FooterCommentsLoadingStateType["PARTIALLY_LOADED"] = "partially_loaded";
    FooterCommentsLoadingStateType["FULLY_LOADED"] = "fully_loaded";
    return FooterCommentsLoadingStateType;
}({});
const $33a0cfbfba499043$export$53ac33307b5acee9 = ()=>({
        orderedActiveAnnotationIdList: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        removedThreadsMap: {
            inline: {},
            general: {}
        },
        commentThreadsRemovedByOtherUsers: {},
        hasNestedComments: false,
        cacheUpdateFailed: false,
        footerCommentsLoadingState: "not_loaded"
    });
const $33a0cfbfba499043$export$e324594224ef24da = {
    setCommentsDataMap: (newCommentsDataMap)=>({ getState: getState, setState: setState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            const parentCommentThreadKeys = new Set(Object.keys(newCommentsDataMap.inline));
            // Update the loaded status of annotations based on newCommentsDataMap
            const updatedAnnotationList = orderedActiveAnnotationIdList.map((annotation)=>({
                    ...annotation,
                    isLoaded: parentCommentThreadKeys.has(annotation.threadKey)
                }));
            const hasNestedComments = (0, $3ZsvI.parseHasNestedComments)(newCommentsDataMap);
            setState({
                commentsDataMap: newCommentsDataMap,
                orderedActiveAnnotationIdList: updatedAnnotationList,
                hasNestedComments: hasNestedComments
            });
        },
    setOrderedActiveAnnotationIdList: (newCommentsList)=>({ getState: getState, setState: setState })=>{
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            if (!newCommentsList || newCommentsList.length === 0) {
                // Only update state if the current list is not already empty
                if (orderedActiveAnnotationIdList.length > 0) setState({
                    orderedActiveAnnotationIdList: []
                });
                return;
            }
            // Create a map of existing annotationId to their isLoaded states for quick lookup
            const existingAnnotationsMap = new Map(orderedActiveAnnotationIdList.map(({ threadKey: threadKey, isLoaded: isLoaded })=>[
                    threadKey,
                    isLoaded
                ]));
            // Use a Set to ensure unique annotation IDs
            const uniqueCommentsSet = new Set(newCommentsList);
            // Map the unique comments set to the new state, preserving isLoaded where possible
            const updatedAnnotationList = Array.from(uniqueCommentsSet).map((threadKey)=>({
                    threadKey: threadKey,
                    isLoaded: existingAnnotationsMap.get(threadKey) ?? false
                }));
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(orderedActiveAnnotationIdList, updatedAnnotationList)) setState({
                orderedActiveAnnotationIdList: updatedAnnotationList
            });
        },
    updateReactionsSummary: (emojiId, actionType, commentId, commentType, readReactionsSummaryFragment, writeReactionsSummaryFragment, pageId, threadKey)=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const updateReactionsForComment = (commentData, emojiId, actionType)=>{
                const { reactionsSummary: reactionsSummary } = commentData || {};
                if (!reactionsSummary) return;
                const reactionsAri = reactionsSummary?.ari || '';
                const reactionsContainerAri = reactionsSummary?.containerAri || '';
                const reactionsNodes = reactionsSummary?.reactionsSummaryForEmoji || [];
                let updatedReactionsNodes = reactionsNodes.map((item)=>item ? {
                        ...item
                    } : item);
                const updatedReactionsSummary = {
                    ...reactionsSummary
                };
                if (actionType === 'add') {
                    const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
                    // If the reaction exists and the user has not reacted, add the user and increment the count
                    if (reactionIdx !== -1 && updatedReactionsNodes[reactionIdx] && !updatedReactionsNodes[reactionIdx].reacted) updatedReactionsNodes[reactionIdx] = {
                        ...updatedReactionsNodes[reactionIdx],
                        count: updatedReactionsNodes[reactionIdx].count + 1,
                        reacted: true
                    };
                    else if (reactionIdx === -1) // If the reaction does not exist, create a new reaction
                    updatedReactionsNodes.push({
                        emojiId: emojiId,
                        count: 1,
                        reacted: true,
                        id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`
                    });
                } else if (actionType === 'delete') {
                    const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
                    // If the reaction exists, update its attributes
                    if (reactionIdx !== -1) {
                        const reaction = updatedReactionsNodes[reactionIdx];
                        // If the reaction exists and the user has reacted, remove the user and decrement the count
                        if (reaction && reaction.reacted) updatedReactionsNodes[reactionIdx] = {
                            ...reaction,
                            count: reaction.count - 1,
                            reacted: false
                        };
                        // If the reaction exists and has no reactions, remove the reaction
                        if (updatedReactionsNodes[reactionIdx] && updatedReactionsNodes[reactionIdx].count <= 0) updatedReactionsNodes = [
                            ...updatedReactionsNodes.slice(0, reactionIdx),
                            ...updatedReactionsNodes.slice(reactionIdx + 1)
                        ];
                    }
                }
                updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
                updatedReactionsSummary.reactionsCount = updatedReactionsNodes.reduce((total, reaction)=>total + (reaction?.count || 0), 0);
                if (commentData) commentData.reactionsSummary = updatedReactionsSummary;
            };
            try {
                const reactionsSummaryId = `$Comment:${commentId}.reactionsSummary(${JSON.stringify({
                    childType: 'comment',
                    contentType: 'page',
                    pageId: pageId
                })})`;
                const reactionsSummary = readReactionsSummaryFragment({
                    id: reactionsSummaryId
                });
                if (reactionsSummary) {
                    const commentReactionsSummary = {
                        ...reactionsSummary
                    };
                    updateReactionsForComment(commentReactionsSummary, emojiId, actionType);
                    writeReactionsSummaryFragment({
                        fragmentId: reactionsSummaryId,
                        data: commentReactionsSummary
                    });
                }
                const repliesReactionsSummaryId = `$Comment:${commentId}.replies.reactionsSummary(${JSON.stringify({
                    childType: 'comment',
                    contentType: 'page',
                    pageId: pageId
                })})`;
                const repliesReactionsSummary = readReactionsSummaryFragment({
                    id: repliesReactionsSummaryId
                });
                if (repliesReactionsSummary) {
                    const updatedRepliesReactionsSummary = {
                        reactionsSummary: repliesReactionsSummary
                    };
                    updateReactionsForComment(repliesReactionsSummary, emojiId, actionType);
                    writeReactionsSummaryFragment({
                        fragmentId: repliesReactionsSummaryId,
                        data: updatedRepliesReactionsSummary
                    });
                }
            } catch (err) {
                $33a0cfbfba499043$var$logger.error`An error occurred when updating comments panel cache - ${err}`;
            }
            // Update the comment datasource
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedMap = {
                ...commentsDataMap
            };
            if (!threadKey) return;
            const comment = updatedMap[commentType][threadKey];
            let reply;
            // If the comment doesn't exist in the map, just return
            if (!comment) return;
            // If the comment IDs don't match, this is a reply, find it and use that
            if (comment.id !== commentId) {
                reply = comment.replies.find((r)=>r.id === commentId);
                // If we don't find the reply after that, just return
                if (!reply) return;
            }
            updateReactionsForComment(reply || comment, emojiId, actionType);
            setState({
                commentsDataMap: updatedMap
            });
        },
    addNewCommentThreads: (newCommentThreads)=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, hasNestedComments: hasNestedComments } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            // Add the comment threads for inline
            for(const threadKey in newCommentThreads.inline){
                const newCommentThread = newCommentThreads.inline[threadKey];
                updatedCommentsDataMap.inline[threadKey] = newCommentThread;
            }
            // Add the comment threads for general
            for(const threadKey in newCommentThreads.general){
                const newCommentThread = newCommentThreads.general[threadKey];
                updatedCommentsDataMap.general[threadKey] = newCommentThread;
            }
            // Update the loaded status of annotations
            const updatedAnnotationList = orderedActiveAnnotationIdList.map((annotation)=>({
                    ...annotation,
                    isLoaded: Object.keys(newCommentThreads).includes(annotation.threadKey) ? true : annotation.isLoaded
                }));
            // No need to reparse if we've already found a case
            const newHasNestedComments = hasNestedComments || (0, $3ZsvI.parseHasNestedComments)(updatedCommentsDataMap);
            setState({
                commentsDataMap: updatedCommentsDataMap,
                orderedActiveAnnotationIdList: updatedAnnotationList,
                hasNestedComments: newHasNestedComments
            });
        },
    addReplyToCommentThread: (threadKey, reply, commentType, sortReplies = false)=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                // Ensure replies array exists
                const existingReplies = parentCommentThread.replies || [];
                // due to the nature of how we are sending multiple pubsub events are being sent for comment creation, we have to check for a duplicate before adding a reply
                const replyExists = existingReplies.some((existingReply)=>existingReply.id === reply.id);
                if (!replyExists) {
                    const updatedReplies = [
                        ...existingReplies,
                        reply
                    ];
                    if (sortReplies && (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false)) // sort replies by createdAtNonLocalized in ascending order
                    // each createdAtNonLocalized is a string in ISO format, e.g. "2026-01-02T03:45:67.890Z"
                    updatedReplies.sort((a, b)=>a.createdAtNonLocalized.localeCompare(b.createdAtNonLocalized));
                    const updatedParentCommentThread = {
                        ...parentCommentThread,
                        replies: updatedReplies
                    };
                    updatedCommentsDataMap[commentType][threadKey] = updatedParentCommentThread;
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                }
            }
        },
    getCurrentCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setFooterCommentsLoadingState: (footerCommentsLoadingState)=>({ setState: setState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            setState({
                footerCommentsLoadingState: footerCommentsLoadingState
            });
        },
    updateCommentBody: (commentId, threadKey, newBodyValue, commentType, displayName = null)=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            // Find the comment in the map
            const { commentsDataMap: commentsDataMap } = getState();
            // Make a copy of the map so if looks like a new object in shallow comparisons and also
            // avoids mutating the original map
            const updatedMap = {
                ...commentsDataMap
            };
            // The "parentComment" is either the comment itself (if a top-level comment) or the parent of
            // the reply thread
            const parentComment = updatedMap[commentType][threadKey];
            if (parentComment) {
                // If the modified comment is a top-level comment, update the body value
                if (parentComment.id === commentId) {
                    // Make a copy of the comment and update the body value, then put it back into the map
                    const updatedComment = {
                        ...parentComment,
                        body: {
                            value: newBodyValue
                        },
                        version: {
                            ...parentComment.version,
                            by: {
                                ...parentComment.version?.by,
                                displayName: displayName
                            },
                            number: (parentComment.version?.number ?? 0) + 1,
                            when: new Date().toISOString()
                        }
                    };
                    updatedMap[commentType][threadKey] = updatedComment;
                    setState({
                        commentsDataMap: updatedMap
                    });
                } else // Else we didn't find the comment at the top-level, check the replies
                for(let replyIndex = 0; replyIndex < parentComment.replies.length; replyIndex++){
                    const reply = parentComment.replies[replyIndex];
                    if (reply.id === commentId) {
                        // Make a copy of the comment and update the reply's body value, then put it back into the map
                        const updatedReply = {
                            ...reply,
                            body: {
                                value: newBodyValue
                            },
                            version: {
                                ...reply.version,
                                by: {
                                    ...reply.version?.by,
                                    displayName: displayName
                                },
                                number: (reply.version?.number ?? 0) + 1,
                                when: new Date().toISOString()
                            }
                        };
                        // (A reminder that ... does a shallow copy, so we need to copy the replies array as well)
                        const updatedComment = {
                            ...parentComment,
                            replies: [
                                ...parentComment.replies
                            ]
                        };
                        updatedComment.replies[replyIndex] = updatedReply;
                        updatedMap[commentType][threadKey] = updatedComment;
                        setState({
                            commentsDataMap: updatedMap
                        });
                        break;
                    }
                }
            }
        },
    // keep track of removed annotations as well as update removed comments with wasRemovedByAnotherUser
    updateRemovedCommentIdsMap: ({ threadKey: threadKey, commentId: commentId, commentActionType: commentActionType, isReply: isReply, commentType: commentType, resolvedProperties: resolvedProperties })=>({ setState: setState, getState: getState })=>{
            const { commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                const { commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap } = getState();
                const updatedCommentsDataMap = {
                    ...commentsDataMap
                };
                const commentThread = updatedCommentsDataMap[commentType][threadKey];
                if (commentThread) {
                    if (isReply) {
                        const updatedCommentThreadReplies = commentThread.replies.map((r)=>{
                            if (r.id === commentId) return {
                                ...r,
                                wasRemovedByAnotherUser: commentActionType
                            };
                            return r;
                        });
                        updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            replies: updatedCommentThreadReplies
                        };
                    } else if (resolvedProperties) {
                        if ((commentType === "inline" || !(0, $9wGTI.fg)('confluence_gen_comments_resolve_pubsub')) && resolvedProperties.inlineResolveProperties) updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            location: {
                                type: 'INLINE',
                                inlineMarkerRef: threadKey,
                                inlineResolveProperties: resolvedProperties.inlineResolveProperties,
                                inlineText: resolvedProperties.inlineText || ''
                            },
                            isOpen: false,
                            wasRemovedByAnotherUser: commentActionType
                        };
                        else updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            location: {
                                commentResolveProperties: {
                                    resolved: resolvedProperties.resolved || false,
                                    resolvedFriendlyDate: resolvedProperties.resolvedFriendlyDate || '',
                                    resolvedTime: resolvedProperties.resolvedTime || 0,
                                    resolvedUser: resolvedProperties.resolvedUser || ''
                                },
                                type: 'GENERAL'
                            },
                            isOpen: false,
                            wasRemovedByAnotherUser: commentActionType
                        };
                    } else updatedCommentsDataMap[commentType][threadKey] = {
                        ...commentThread,
                        isOpen: false,
                        wasRemovedByAnotherUser: commentActionType
                    };
                    const updatedRemovedThreadsMap = {
                        ...removedThreadsMap
                    };
                    let threadKeyId = -1;
                    if (commentType === "inline") {
                        // since orderedActiveAnnotationIdList will not include previously removed annotations, we need to add in annotations in removedThreadsMap
                        // so that we can correctly find the index of the removed annotation
                        const inlineThreadKeyList = [
                            ...orderedActiveAnnotationIdList.map((a)=>a.threadKey)
                        ];
                        Object.entries(updatedRemovedThreadsMap.inline).forEach(([index, key])=>{
                            const position = parseInt(index, 10); // Ensure the index is treated as a number
                            inlineThreadKeyList.splice(position, 0, key);
                        });
                        threadKeyId = inlineThreadKeyList.findIndex((key)=>key === threadKey);
                    } else {
                        // General comments are ordered correctly in the map by timestamp
                        const orderedGeneralThreadKeyList = Object.keys(commentsDataMap.general);
                        threadKeyId = orderedGeneralThreadKeyList.findIndex((key)=>key === threadKey);
                    }
                    if (threadKeyId !== -1) updatedRemovedThreadsMap[commentType][threadKeyId] = threadKey;
                    setState({
                        commentsDataMap: updatedCommentsDataMap,
                        removedThreadsMap: updatedRemovedThreadsMap
                    });
                }
            }
            // Update commentThreadsRemovedByOtherUsers map
            const updatedRemovedComments = {
                ...commentThreadsRemovedByOtherUsers
            };
            updatedRemovedComments[commentId] = commentActionType;
            // Internally, this will be batched with the other state updates when cc_comments_new_comments_data_manager is disabled
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    handleRemovingComments: ({ threadKey: threadKey, commentId: commentId, action: action, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                if (action === "resolved" && parentCommentThread.id === commentId) {
                    // If the action is to resolve the thread and the commentId matches the parent, remove the thread
                    delete updatedCommentsDataMap[commentType][threadKey];
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                } else if (action === "deleted") {
                    // If the action is to delete a reply, filter out the reply with the specified commentId
                    const updatedReplies = parentCommentThread.replies.filter((reply)=>reply.id !== commentId);
                    updatedCommentsDataMap[commentType][threadKey] = {
                        ...parentCommentThread,
                        replies: updatedReplies
                    };
                    // Update the parent comment thread with the filtered replies
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                }
            }
        },
    resolveParentComment: ({ threadKey: threadKey, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                parentCommentThread.isOpen = false;
                setState({
                    commentsDataMap: updatedCommentsDataMap
                });
            }
        },
    reopenParentComment: ({ threadKey: threadKey, commentType: commentType, parentCommentId: parentCommentId })=>({ setState: setState, getState: getState })=>{
            // With new data manager enabled we ONLY update commentThreadsRemovedByOtherUsers.
            // Once the experiment is out, we should probably rename this function
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (!parentCommentId) return;
                const { commentThreadsRemovedByOtherUsers: currentRemovedComments } = getState();
                const updatedRemovedComments = {
                    ...currentRemovedComments
                };
                delete updatedRemovedComments[parentCommentId];
                setState({
                    commentThreadsRemovedByOtherUsers: updatedRemovedComments
                });
                return;
            }
            const { commentsDataMap: commentsDataMap, commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                parentCommentThread.isOpen = true;
                // Remove from commentThreadsRemovedByOtherUsers when reopened
                const updatedRemovedComments = {
                    ...commentThreadsRemovedByOtherUsers
                };
                delete updatedRemovedComments[parentCommentThread.id];
                setState({
                    commentsDataMap: updatedCommentsDataMap,
                    commentThreadsRemovedByOtherUsers: updatedRemovedComments
                });
            }
        },
    deleteParentComment: ({ threadKey: threadKey, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                delete updatedCommentsDataMap[commentType][threadKey];
                setState({
                    commentsDataMap: updatedCommentsDataMap
                });
            }
        },
    clearRemovedComments: ()=>({ getState: getState, setState: setState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                setState({
                    commentThreadsRemovedByOtherUsers: {}
                });
                return;
            }
            const { commentsDataMap: commentsDataMap } = getState();
            const commentsDataMapCopy = {
                ...commentsDataMap
            };
            // Filter out deleted / resolved comments for the legacy comments data map
            const updatedInlineCommentsDataMap = Object.fromEntries(Object.entries(commentsDataMapCopy.inline).filter(([_, commentData])=>!commentData.wasRemovedByAnotherUser).map(([key, commentData])=>[
                    key,
                    {
                        ...commentData,
                        replies: (commentData.replies || []).filter((reply)=>!reply.wasRemovedByAnotherUser)
                    }
                ]));
            const updatedGeneralCommentsDataMap = Object.fromEntries(Object.entries(commentsDataMapCopy.general).filter(([_, commentData])=>!commentData.wasRemovedByAnotherUser).map(([key, commentData])=>[
                    key,
                    {
                        ...commentData,
                        replies: (commentData.replies || []).filter((reply)=>!reply.wasRemovedByAnotherUser)
                    }
                ]));
            setState({
                removedThreadsMap: {
                    inline: {},
                    general: {}
                },
                commentThreadsRemovedByOtherUsers: {},
                commentsDataMap: {
                    inline: updatedInlineCommentsDataMap,
                    general: updatedGeneralCommentsDataMap
                }
            });
        },
    clearCommentsData: ()=>({ setState: setState })=>{
            setState($33a0cfbfba499043$export$53ac33307b5acee9());
        },
    setCacheUpdateFailed: (failed)=>({ setState: setState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            setState({
                cacheUpdateFailed: failed
            });
        }
};
const $33a0cfbfba499043$export$13b7c646235a7fd4 = (0, $1P1Tu.createStore)({
    initialState: $33a0cfbfba499043$export$53ac33307b5acee9(),
    actions: $33a0cfbfba499043$export$e324594224ef24da,
    name: 'CommentsDataStore'
});
const $33a0cfbfba499043$export$80f09eb388fa70f9 = (0, $9zUhf.createHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$b5e3986841a4e13f = (0, $9zUhf.createActionsHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$c14a8182bd597724 = (0, $9zUhf.createStateHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
module.exports["CommentType"] = $33a0cfbfba499043$export$ffa1150e6a48f9cd;
module.exports["CommentActionType"] = $33a0cfbfba499043$export$74159dff405238c0;
module.exports["FooterCommentsLoadingStateType"] = $33a0cfbfba499043$export$2021eb0669e47276;
module.exports["useCommentsData"] = $33a0cfbfba499043$export$80f09eb388fa70f9;
module.exports["useCommentsDataActions"] = $33a0cfbfba499043$export$b5e3986841a4e13f;
module.exports["useCommentsDataState"] = $33a0cfbfba499043$export$c14a8182bd597724;

});

parcelRegister("3ZsvI", function(module, exports) {

var $86okN = parcelRequire("86okN");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");

const $d2d2318c0a6737a0$export$c616a7cf09d59df6 = ({ comment: comment, isOpen: isOpen, type: type })=>{
    return {
        ...comment,
        wasRemovedByAnotherUser: false,
        isOpen: isOpen,
        type: type,
        replies: comment.replies?.map((reply)=>{
            return {
                ...reply,
                reactionsSummary: reply.reactionsSummary ?? null,
                type: type,
                wasRemovedByAnotherUser: false
            };
        })
    };
};
const $d2d2318c0a6737a0$export$e8d1c15bdf6a3ce8 = ({ data: data, pageMode: pageMode, currentUserId: currentUserId, updateData: updateData, isOpen: isOpen = true })=>{
    const inlineCommentThreadsToAdd = {};
    const generalCommentThreadsToAdd = {};
    const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
    data?.comments?.nodes?.forEach((commentNode)=>{
        // Filter out null values
        if (!commentNode) return;
        const comment = {
            ...commentNode,
            reactionsSummary: commentNode?.reactionsSummary ?? null
        };
        // We only want top level comments
        if (comment && !comment.parentId) {
            if (comment.contentStatus === (0, $cD1qu.ContentStatus).DRAFT && pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
            const commentType = comment.location.type;
            if (commentType === 'INLINE') {
                const threadKey = comment.location.inlineMarkerRef;
                if (threadKey) inlineCommentThreadsToAdd[threadKey] = $d2d2318c0a6737a0$export$c616a7cf09d59df6({
                    comment: comment,
                    currentUserId: currentUserId,
                    isOpen: isOpen,
                    type: (0, $8i27m.CommentType).INLINE
                });
            } else if (commentType === 'FOOTER' && loadFooterComments) {
                const threadKey = comment.id;
                generalCommentThreadsToAdd[threadKey] = $d2d2318c0a6737a0$export$c616a7cf09d59df6({
                    comment: comment,
                    currentUserId: currentUserId,
                    isOpen: isOpen,
                    type: (0, $8i27m.CommentType).GENERAL
                });
            }
        }
    });
    updateData({
        inline: inlineCommentThreadsToAdd,
        general: generalCommentThreadsToAdd
    });
};
const $d2d2318c0a6737a0$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $d2d2318c0a6737a0$export$f60efc56f0412906 = (activeCommentsQueryResult, updateFn)=>{
    // This should only ever be called with data - however if it isn't we should update state to NOT_LOADED
    if (activeCommentsQueryResult?.comments?.totalCount === undefined) {
        updateFn((0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED);
        return;
    }
    const loadedCommentCount = activeCommentsQueryResult?.comments?.nodes?.reduce((acc, comment)=>{
        return acc + (comment?.replies?.length || 0) + 1; // return parent + reply count
    }, 0) ?? 0;
    // The BE sometimes will give us mismatched numbers for complex nested scenarios, as long as > 0 call it good
    // This case is super rare (should be <<1% of pages), but if it significantly affects metrics will need another special case
    const allLoaded = loadedCommentCount === activeCommentsQueryResult?.comments?.totalCount;
    if (allLoaded) updateFn((0, $8i27m.FooterCommentsLoadingStateType).FULLY_LOADED);
    else updateFn((0, $8i27m.FooterCommentsLoadingStateType).PARTIALLY_LOADED);
};
const $d2d2318c0a6737a0$export$74e9552da989b708 = (commentsDataMap, commentId)=>{
    // Check if our ID is one of the parent comments, if so return the parent comment
    const findParent = Object.values(commentsDataMap.general).find((comment)=>comment.id === commentId || comment.replies?.some((reply)=>reply.id === commentId));
    if (!findParent) return null;
    if (findParent?.id === commentId) return findParent;
    else return findParent.replies?.find((reply)=>reply.id === commentId);
};
const $d2d2318c0a6737a0$export$92c95f9748a31706 = (commentsDataMap, commentId)=>{
    return Object.values(commentsDataMap.general).find((comment)=>comment.id === commentId || comment.replies?.some((reply)=>reply.id === commentId));
};
const $d2d2318c0a6737a0$export$f41a637cf0ebe6d7 = (commentsDataMap, commentType, threadKey, addNewCommentThreads)=>{
    $d2d2318c0a6737a0$var$setCommentIsOpenInDataMap(false, commentsDataMap, commentType, threadKey, addNewCommentThreads);
};
const $d2d2318c0a6737a0$export$906b5ebcd439e0e3 = (commentsDataMap, commentType, threadKey, addNewCommentThreads)=>{
    $d2d2318c0a6737a0$var$setCommentIsOpenInDataMap(true, commentsDataMap, commentType, threadKey, addNewCommentThreads);
};
const $d2d2318c0a6737a0$var$setCommentIsOpenInDataMap = (isOpen, commentsDataMap, commentType, threadKey, addNewCommentThreads)=>{
    const commentsDataMapClone = {
        ...commentsDataMap
    };
    const commentInMap = commentsDataMapClone[commentType][threadKey];
    if (commentInMap) {
        commentInMap.isOpen = isOpen;
        if (isOpen) commentInMap.wasRemovedByAnotherUser = false;
        // Handle both cases of when comment is Inline or General.
        // Only one of the following two properties will be present.
        const commentLocation = commentInMap.location;
        if (commentLocation && 'commentResolveProperties' in commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = !isOpen;
        if (commentLocation && 'inlineResolveProperties' in commentLocation && commentLocation.inlineResolveProperties && // This helper function was extracted from
        // next/packages/comments-panel/src/components/Comment.tsx, where
        // this fg is required only when reopening a comment but not when
        // resolving. It's unclear why, but leaving it as is for now.
        // This can be cleaned up entirely after fg is rolled out.
        (!isOpen || (0, $9wGTI.fg)('confluence_frontend_content_wrapper'))) commentLocation.inlineResolveProperties.resolved = !isOpen;
        addNewCommentThreads(commentsDataMapClone);
    }
};
const $d2d2318c0a6737a0$export$fa74ef5ad1b77480 = ({ cache: cache, commentId: commentId, query: query, queryVariables: queryVariables, cacheUpdateFailed: cacheUpdateFailed, setCacheUpdateFailed: setCacheUpdateFailed, source: source, logger: logger })=>{
    // readQuery can still return null which complicates TS lint errors with optional chaining
    // once we move to v3 of the apollo client we can move to cache.modify
    try {
        let dataProxy = undefined;
        try {
            dataProxy = cache.readQuery({
                query: (0, $86okN.toDocumentNode)(query),
                variables: queryVariables
            });
        } catch (err) {
            // It's possible that the cache does not contain a matchign entry for `query`.
            // In this case, an error "Invariant Violation: Invariant Violation: 8"
            // is thrown, which we can safely ignore and skip this cache update.
            if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                logger.warn`Unable to read cache for ${source} resolve - ${err}`;
                return;
            } else throw err;
        }
        const commentsToWrite = Object.assign({}, dataProxy?.comments);
        let totalCount = commentsToWrite.totalCount || 0;
        const commentsList = commentsToWrite.nodes?.filter((n)=>n !== null);
        const idxToRemove = commentsList.findIndex((c)=>c.id === commentId);
        // Remove the newly resolved comment from the list if we can find it.
        if (idxToRemove !== -1) {
            commentsList.splice(idxToRemove, 1);
            totalCount--;
        }
        // Otherwise, no need to update the cache.
        // Merge with if block above after shipping this experiment.
        if (idxToRemove !== -1 || !(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) cache.writeQuery({
            query: (0, $86okN.toDocumentNode)(query),
            variables: queryVariables,
            data: {
                comments: {
                    nodes: commentsList,
                    totalCount: totalCount,
                    __typename: 'PaginatedCommentList'
                }
            }
        });
        // cache updated successfuly
        // now check if previous cache update was failed
        if (cacheUpdateFailed) setCacheUpdateFailed(false);
    } catch (err) {
        logger.error`An error occurred when updating cache for ${source} resolve - ${err}`;
        setCacheUpdateFailed(true);
    }
};
module.exports["normalizeCommentData"] = $d2d2318c0a6737a0$export$c616a7cf09d59df6;
module.exports["updateCommentsDataState"] = $d2d2318c0a6737a0$export$e8d1c15bdf6a3ce8;
module.exports["parseHasNestedComments"] = $d2d2318c0a6737a0$export$6036c2c532b2fa41;
module.exports["updateFooterCommentsLoadingState"] = $d2d2318c0a6737a0$export$f60efc56f0412906;
module.exports["resolveCommentInDataMap"] = $d2d2318c0a6737a0$export$f41a637cf0ebe6d7;
module.exports["reopenCommentInDataMap"] = $d2d2318c0a6737a0$export$906b5ebcd439e0e3;
module.exports["updateCommentsQueryCacheForResolve"] = $d2d2318c0a6737a0$export$fa74ef5ad1b77480;

});

parcelRegister("cgy29", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aWwYt = parcelRequire("aWwYt");


var $cMvMc = parcelRequire("cMvMc");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cZa7r = parcelRequire("cZa7r");


var $4DJgG = parcelRequire("4DJgG");

const $dacb5f0322f4a333$export$5ae138a5a05281f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics } = t0;
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $42omo.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            content.current = document.querySelector("div#content");
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== commentToReattach || $[3] !== contentId || $[4] !== createComment || $[5] !== hideObjectSidebar || $[6] !== isFabric || $[7] !== isObjectSidebarShown || $[8] !== setSelectionOptionsForCreateEditor) {
        t3 = (t4)=>{
            const { experienceAttributes: experienceAttributes } = t4 === undefined ? {} : t4;
            if (isObjectSidebarShown) hideObjectSidebar();
            if (isFabric) setSelectionOptionsForCreateEditor({
                experienceAttributes: experienceAttributes
            });
            else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach
            }));
        };
        $[2] = commentToReattach;
        $[3] = contentId;
        $[4] = createComment;
        $[5] = hideObjectSidebar;
        $[6] = isFabric;
        $[7] = isObjectSidebarShown;
        $[8] = setSelectionOptionsForCreateEditor;
        $[9] = t3;
    } else t3 = $[9];
    const createReactInlineCommentHighlight = t3;
    let t4;
    if ($[10] !== createReactInlineCommentHighlight || $[11] !== hasContentChanged || $[12] !== sendKeyboardShortcutAnalytics) {
        const handleCommentButtonClick = (t5)=>{
            const { dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 } = t5;
            if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>createReactInlineCommentHighlight({
                        experienceAttributes: experienceAttributes_0
                    })
            });
            else createReactInlineCommentHighlight({
                experienceAttributes: experienceAttributes_0
            });
            if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
        };
        t4 = {
            handleCommentButtonClick: handleCommentButtonClick
        };
        $[10] = createReactInlineCommentHighlight;
        $[11] = hasContentChanged;
        $[12] = sendKeyboardShortcutAnalytics;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        content.current = document.querySelector('div#content');
    }, []);
    const createReactInlineCommentHighlight = ({ experienceAttributes: experienceAttributes } = {})=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) setSelectionOptionsForCreateEditor({
            experienceAttributes: experienceAttributes
        });
        else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach
        }));
    };
    const handleCommentButtonClick = ({ dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 })=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight({
                    experienceAttributes: experienceAttributes_0
                })
        });
        else createReactInlineCommentHighlight({
            experienceAttributes: experienceAttributes_0
        });
        if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
    };
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};
module.exports["useCreateCommentAction"] = $dacb5f0322f4a333$export$5ae138a5a05281f1;

});

parcelRegister("brNvA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $42omo.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $42omo.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    const [commentToReattach, setCommentToReattach] = (0, $42omo.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] !== commentToReattach) {
        t1 = ()=>Boolean(commentToReattach);
        $[0] = commentToReattach;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== commentToReattach || $[3] !== reattachHighlight || $[4] !== t1) {
        t2 = {
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: t1
        };
        $[2] = commentToReattach;
        $[3] = reattachHighlight;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const providerValue = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        };
        $[6] = t3;
    } else t3 = $[6];
    const dispatchProviderValue = t3;
    let t4;
    if ($[7] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
            value: dispatchProviderValue
        }, children);
        $[7] = children;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== providerValue || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
            value: providerValue
        }, t4);
        $[9] = providerValue;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $42omo.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $42omo.useState)(null);
    const providerValue = (0, $42omo.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
} : ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
} : ()=>{
    return (0, $42omo.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("4DJgG", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $917b9bb03b3149d5$var$logger = (0, $7W8i8.getLogger)('inline-comment');
const $917b9bb03b3149d5$export$dbde27c406dff8e8 = ({ content: content, contentId: contentId, commentToReattach: commentToReattach, actions: actions })=>{
    let selectionObj = {
        numMatches: 0,
        matchIndex: -1,
        selectedText: '',
        timestamp: 0
    };
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
        $917b9bb03b3149d5$var$logger.debug`No text selected. Creating inline comment at cursor position.`;
        return selectionObj;
    }
    if (selection) {
        // TODO clean up after above FG is removed
        const range = selection.getRangeAt(0);
        const legacySelection = (0, $aUTn5.convertSelectionToLegacyFormat)(content.current, range, contentId);
        const { searchText: { numMatches: numMatches, index: matchIndex, selectedText: selectedText } } = legacySelection;
        selectionObj = {
            numMatches: numMatches,
            matchIndex: matchIndex,
            selectedText: selectedText,
            timestamp: Date.now()
        };
        /**
     * We generate the annotation step for the upcoming new collab service
     * to consume. This means we will eventually started sending markerRef
     * ids from the FE.
     */ try {
            const markerRef = commentToReattach ? commentToReattach.inlineMarkerRef : (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            if (actions) {
                const proseMirrorStep = actions.annotate(range, markerRef, 'inlineComment');
                const { step: { from: from, to: to, mark: mark } } = proseMirrorStep;
                selectionObj['step'] = {
                    from: from,
                    to: to,
                    mark: {
                        type: 'annotation',
                        attrs: {
                            key: mark.attrs?.annotationType,
                            value: mark.attrs?.id
                        }
                    }
                };
            }
        } catch (e) {
            $917b9bb03b3149d5$var$logger.error`An error occurred when generating a step - ${e}`;
        }
    }
    return selectionObj;
};
module.exports["getLegacyConvertedSelectionObj"] = $917b9bb03b3149d5$export$dbde27c406dff8e8;

});

parcelRegister("aUTn5", function(module, exports) {
/* eslint-disable no-restricted-globals */ 
var $9wGTI = parcelRequire("9wGTI");


var $2zMIV = parcelRequire("2zMIV");


var $kbVzJ = parcelRequire("kbVzJ");

const $92069b7b1bcb2285$export$c5bc138cfa79c2b2 = [
    // Legacy mention
    '.user-mention',
    // Fabric mention
    '[data-mention-id]',
    // Connect macro
    '.ap-container',
    // Links
    'a[href^="/"]',
    // Macros that doesn't have body
    '.conf-macro[data-hasbody="false"]',
    // Normal status
    '.status-lozenge-span',
    // Date will get rendered as "Today" in fabric
    '.date-lozenger-container',
    // Inline Smart Card/Jira issue link
    '[data-inline-card="true"]',
    '.inlineCardView-content-wrap',
    '.smart-link-title-wrapper',
    // Actual jira issue macro
    '.jira-issue',
    // Title for expand
    '.ak-renderer-extension-overflow-container button',
    '[data-node-type="expand"] > button',
    '[data-node-type="nestedExpand"] > button',
    // JIRA Macro
    '.jira-issues',
    // datasource table for new JIM macro
    '.datasource-table',
    // Inline file attachments
    "[data-type='file']",
    // Fabric code snippets
    '.code-block',
    // Legacy code snippets
    '.conf-macro[data-macro-name="code"]',
    // Sticky table headers (WS-2345 - Sticky header comment flow is strange for now, restrict until we can find a better solution)
    '.pm-table-sticky-wrapper',
    // Block cards
    '.blockCardView-content-wrap',
    // Excerpt Includes (WS-2563)
    '.ak-excerpt-include',
    // View All Container
    '#view-all-inline-comments-container',
    // Strikethrough
    's',
    // Emoji
    '[data-emoji-id]',
    // Charts
    "[data-mark-type='dataConsumer']",
    // Reattach Dialog
    '#reattach-container',
    // BEGIN EDITOR EXCLUSIONS
    //
    // Gadget?
    "[extensionkey='gadget']",
    // placeholder content
    'span[data-placeholder]',
    // covers most macros, would this be too encompassing?
    "[contenteditable='false']",
    // page include macro
    "[data-node-type='include']",
    // page properties report adf macro
    '.page-properties-report'
].join(',');
function $92069b7b1bcb2285$var$getSelectionHTML(selectionRange) {
    if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
        const div = document.createElement('div');
        div.appendChild(selectionRange.cloneContents());
        return div.innerHTML;
    } else return $('<div>').append(selectionRange.cloneContents()).html();
}
function $92069b7b1bcb2285$var$getContainingElement(selectionRange) {
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
}
function $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects) {
    // In Chrome triple clicking text will cause all the text in an element to be selected. When calling
    // getClientRects after a triple click, the array will contain rects for each line of highlighted text
    // in the highlighted element and also a clientRects for the adjacent sibling element even though no text
    // is highlighted inside it. If the endOffset is zero, we ignore this final clientRect because no text
    // is highlighted inside of it.
    //
    // Also, in Chrome, Safari and Firefox, get client rects return a clientRects representing each inline element
    // including rectangles for all nested elements. IE8 return many less rects, maybe just one for the ancestor
    // element containing the highlight or a clientRects for each line of highlight without individual rects for each
    // inline element
    const rects = {
        first: clientRects[0],
        last: clientRects[clientRects.length - 1]
    };
    if (selectionRange.endOffset !== 'undefined') //In IE, if we highlight on resolved inline comment, we will length of clientRects is 1
    {
        if (selectionRange.endOffset === 0 && clientRects.length > 1) rects.last = clientRects[clientRects.length - 2];
    }
    return rects;
}
function $92069b7b1bcb2285$var$getSelectionRects(selectionRange) {
    // if using documentation theme, get scrolltop of documentation theme content which is fixed size
    // certain browsers give the scrollTop on html element, some give it on the body element. this works in both.
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    let clientRects = selectionRange.getClientRects();
    // IE fails to provide client rects when highlighting a paragraph containing only an image or triple clicking to
    // highlight any paragraph containing content other than plain text. In this case, it is safe to assume parent
    // element dimensions will represent the highlighted area
    if (!clientRects.length && selectionRange.parentElement && selectionRange.parentElement()) {
        if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
            const parentElement = selectionRange.parentElement();
            const rect = parentElement.getBoundingClientRect();
            clientRects = [
                {
                    top: rect.top,
                    left: rect.left,
                    bottom: rect.top + scrollTop + rect.height,
                    right: rect.left + scrollLeft + rect.width
                }
            ];
        } else {
            const $parentElement = $(selectionRange.parentElement());
            const parentOffset = $parentElement.offset();
            if (parentOffset) clientRects = [
                {
                    top: parentOffset.top - scrollTop,
                    left: parentOffset.left - scrollLeft,
                    bottom: parentOffset.top + ($parentElement.height() || 0),
                    right: parentOffset.left + ($parentElement.width() || 0)
                }
            ];
        }
    }
    const rects = $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects);
    /*
   * Calculates Create Issue dialog target area
   */ const getOverlap = function(firstRect, lastRect) {
        const overlap = {};
        overlap.top = firstRect.top;
        overlap.left = (firstRect.left || 0) + scrollLeft;
        overlap.bottom = lastRect.bottom;
        if (firstRect.left !== undefined && firstRect.right !== undefined && lastRect.left !== undefined && lastRect.right !== undefined) {
            if (firstRect.left >= lastRect.right) overlap.right = firstRect.right;
            else overlap.right = lastRect.right;
        }
        overlap.right = (overlap.right || 0) + scrollLeft;
        // adjust top for doc theme
        overlap.top = (overlap.top || 0) + scrollTop;
        overlap.bottom = (overlap.bottom || 0) + scrollTop;
        // set width and height
        overlap.width = overlap.right - overlap.left;
        overlap.height = overlap.bottom - overlap.top;
        return overlap;
    };
    /*
   * Calculates the action panel target area
   */ const getHighlightStart = function(rect) {
        const highlight = {};
        if (!rect) return highlight;
        highlight.width = rect.right - rect.left;
        highlight.height = rect.bottom - rect.top;
        highlight.left = rect.left + scrollLeft;
        highlight.right = rect.right + scrollLeft;
        highlight.top = rect.top + scrollTop;
        highlight.bottom = rect.bottom + scrollTop;
        return highlight;
    };
    return {
        first: getHighlightStart(rects.first),
        average: getOverlap(rects.first, rects.last)
    };
}
function $92069b7b1bcb2285$var$getSelectionText(selectionRange) {
    return (0, $2zMIV.textNormalize)(String(selectionRange));
}
/**
 * Generates javascript object containing the context of the selected text to help locate in storage format
 *
 * @param root container of content which can be selected
 * @param selectedText text that currently highlighted
 * @param selected range object representing the current selection
 * @param pageId the page id we're currently on
 * @param includeTraceForMatches a boolean stating whether or not to include a tree trace for each match
 * @return object containing metadata about the location of the selected text
 */ function $92069b7b1bcb2285$var$computeSearchTextObject(root, selectedText, selected, pageId, includeTraceForMatches) {
    // WS-2345 - Sticky header create comment flow is strange for now, disabling it until a better solution is found
    // https://product-fabric.atlassian.net/browse/CEMS-1100
    //
    // sticky headers create duplicate tables to work, which causes duplicate
    // text content to end up in the inline comment text string. ignore sticky
    // table content when not visible, and vice versa.
    // const inSticky = findStickyHeader(selected.startContainer);
    // const ignoreTable: HTMLElement[] = Array.from(
    //   inSticky
    //     ? root.querySelectorAll(
    //         ".pm-table-container .pm-table-wrapper tr:first-of-type"
    //       )
    //     : root.querySelectorAll(".pm-table-sticky-wrapper")
    // );
    const ignoreTable = Array.from(root.querySelectorAll('.pm-table-sticky-wrapper'));
    const ignoredNodes = Array.from(root.querySelectorAll($92069b7b1bcb2285$export$c5bc138cfa79c2b2));
    const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(root, [
        ...ignoredNodes,
        ...ignoreTable
    ]);
    const { index: index, numMatches: numMatches, matchTraceList: matchTraceList } = (0, $kbVzJ.findMatches)(text, selectedText, selected.startContainer, selected.startOffset, nodesStartPos, nodes, includeTraceForMatches);
    const searchTextObj = {
        pageId: pageId,
        selectedText: selectedText,
        index: index,
        numMatches: numMatches
    };
    if (matchTraceList) searchTextObj.matchTraceList = matchTraceList;
    return searchTextObj;
}
function $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, lastModified, getTraceForMatches) {
    const rawText = $92069b7b1bcb2285$var$getSelectionText(selectionRange);
    const text = rawText.trim();
    let searchText;
    // It finds all the occurrences of selected text.
    // Since if I select word "is" there maybe a lot occurrences on the page.
    // searchText.index tells the backend which one is really the one I selected.
    // That is among, for example 20 matches, the 5th match is my selection.
    if (text) searchText = $92069b7b1bcb2285$var$computeSearchTextObject(contentContainer, // It is important to pass raw text here
    rawText, selectionRange, pageId, getTraceForMatches);
    return getTraceForMatches ? searchText.matchTraceList : {
        text: text,
        searchText: searchText,
        area: $92069b7b1bcb2285$var$getSelectionRects(selectionRange),
        html: $92069b7b1bcb2285$var$getSelectionHTML(selectionRange),
        containingElement: $92069b7b1bcb2285$var$getContainingElement(selectionRange),
        range: selectionRange,
        lastModified: lastModified
    };
}
function $92069b7b1bcb2285$export$b297c7070f7a854(contentContainer, selectionRange, pageId) {
    const matchTraceList = $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, null, true);
    return matchTraceList || [];
}
module.exports["IGNORE_SELECTORS"] = $92069b7b1bcb2285$export$c5bc138cfa79c2b2;
module.exports["convertSelectionToLegacyFormat"] = $92069b7b1bcb2285$export$4ba66d628a1e5980;
module.exports["getMatchTraces"] = $92069b7b1bcb2285$export$b297c7070f7a854;

});

parcelRegister("2zMIV", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $15cdccae323ae129$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $15cdccae323ae129$export$4042f14350dc38e1 = (container, contentId)=>{
    const selection = window.getSelection();
    // getSelection() only returns null for iframes in firefox; in all other cases the type field is set to "None"
    if (!selection || selection?.type === 'None') return false;
    let legacyHighlight;
    try {
        legacyHighlight = (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId);
    } catch (err) {
        $15cdccae323ae129$var$logger.error`An error occurred while highlighting content - ${err}`;
    }
    if (!legacyHighlight || !legacyHighlight.searchText) return false;
    const { searchText: { selectedText: selectedText, index: index, numMatches: numMatches } } = legacyHighlight;
    /*
   * A valid highlight contains:
   *
   *   A selection that has a length (non-empty)
   *   A matched index (-1 means not found)
   *   A positive non-zero number of matches
   *   A match index that is less than the number of matches
   *
   */ return selectedText.replace(/\n/g, '').length > 0 && index !== -1 && numMatches > 0 && index < numMatches;
};
const $15cdccae323ae129$export$6c73cedfcc8a18f2 = ()=>{
    const selection = window.getSelection();
    if (!selection || selection?.type === 'None') return false;
    const range = $15cdccae323ae129$export$fef151b94550e9f5();
    if (!range) return false;
    const parentElement = $15cdccae323ae129$export$ab738b211369230e(range);
    return parentElement instanceof HTMLElement && Boolean(parentElement.closest('table'));
};
const $15cdccae323ae129$export$42b4db950c80743f = (s)=>{
    /*
    CONF-36789: on IE, selectionRange.toString() always convert all &nbsp; to normal space
    on other browsers, it does not. So we must convert manually to made consistency across all browsers
    */ return s.replace(/\u00a0/g, '\u0020');
};
const $15cdccae323ae129$export$fef151b94550e9f5 = ()=>{
    const selection = window.getSelection();
    // no selection made webkit
    if (!selection || selection.isCollapsed) return null;
    const selectionRange = selection.getRangeAt(0);
    // Don't show popup if selection is white space
    if (!String(selectionRange).trim()) return null;
    return selectionRange;
};
const $15cdccae323ae129$export$cfa2225e87938781 = (node)=>{
    const TEXT_NODE_TYPE = 3;
    if (!node) return null;
    if (node.nodeType !== TEXT_NODE_TYPE && node.scrollWidth > node.clientWidth) return node;
    else return $15cdccae323ae129$export$cfa2225e87938781(node.parentNode);
};
const $15cdccae323ae129$export$6fc0706fcfa876ec = (node)=>{
    const ELEMENT_NODE_TYPE = 1;
    if (!node) return null;
    if (node.nodeType === ELEMENT_NODE_TYPE) {
        if (node.classList.contains('pm-table-sticky-wrapper')) return node;
    }
    if (node.parentElement) return $15cdccae323ae129$export$6fc0706fcfa876ec(node.parentElement);
    return null;
};
const $15cdccae323ae129$export$ab738b211369230e = (selectionRange)=>{
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
    return null;
};
module.exports["isHighlightValidForInlineComment"] = $15cdccae323ae129$export$4042f14350dc38e1;
module.exports["isHighlightValidForBulkCreateJiraIssues"] = $15cdccae323ae129$export$6c73cedfcc8a18f2;
module.exports["getRange"] = $15cdccae323ae129$export$fef151b94550e9f5;
module.exports["getContainingElement"] = $15cdccae323ae129$export$ab738b211369230e;
module.exports["textNormalize"] = $15cdccae323ae129$export$42b4db950c80743f;
module.exports["findStickyHeader"] = $15cdccae323ae129$export$6fc0706fcfa876ec;

});

parcelRegister("kbVzJ", function(module, exports) {
// eslint-disable-next-line import/no-cycle

var $2zMIV = parcelRequire("2zMIV");

const $567297790b62d2d4$var$TEXT_NODE_TYPE = 3;
function $567297790b62d2d4$export$2a4369abc54086f5(list, search, from) {
    const startPosInRange = Math.min(from, list.length - 1);
    let l = startPosInRange;
    let r = list.length;
    while(l < r){
        // This is a LEGACY disable statement after rule addition. Use `Math.floor((l+r)/2)` next time
        // eslint-disable-next-line no-bitwise
        const mid = l + r >> 1;
        if (list[mid] <= search) l = mid + 1;
        else r = mid;
    }
    return Math.max(l - 1, startPosInRange);
}
function $567297790b62d2d4$export$2605a3f2b4d7f885(root, ignoredNodes) {
    let textNode;
    let text = '';
    const nodesStartPos = [];
    const nodes = [];
    const nodeFilter = (textNode)=>{
        /**
     * If the text node is a descendent of one of the ignored node.
     * It means the text was rendered by maybe a macro.
     * Ignore these text nodes.
     */ return ignoredNodes.some((node)=>node === textNode || node.contains(textNode)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
    // createNodeIterator accepts an object with acceptNode field as node filter.
    // However IE 11 is expecting a function directly.
    nodeFilter.acceptNode = nodeFilter;
    const iter = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, nodeFilter, false);
    while(textNode = iter.nextNode()){
        const normalizedText = (0, $2zMIV.textNormalize)(textNode.nodeValue);
        // WS-2885 - \u0020 represents the spacebar character so this regex handles any number of space only characters
        //           that may exist as their own nodes. We don't need to worry about only commenting on a space here
        //           because the popup has logic to only show itself if more than just a space is selected.
        if (/^\u0020+$/.test(normalizedText) || normalizedText.trim()) {
            // If it is not completely empty
            nodesStartPos.push(text.length);
            nodes.push(textNode);
            text += normalizedText;
        }
    }
    return {
        text: text,
        nodesStartPos: nodesStartPos,
        nodes: nodes
    };
}
function $567297790b62d2d4$var$getNodeTextLength(node) {
    return node && node.nodeValue ? node.nodeValue.length : 0;
}
function $567297790b62d2d4$export$f4585c00f32d9257(text, rawSelectedText, startContainer, startOffset, nodesStartPos, nodes, includeTraceForMatches) {
    const matchTraceList = [];
    if (!startContainer) return {
        numMatches: 0,
        index: -1,
        matchTraceList: null
    };
    let start = 0;
    let nodeStart = 0;
    let found = 0;
    let index = -1;
    let numMatches = 0;
    // loop through the provided text body string, starting from the beginning,
    // and update the index to search from until the rawSelectedtext can
    // no longer be found
    while((found = text.indexOf(rawSelectedText, start)) !== -1){
        // nodesStartPos is built by slowly concatenanting each non-empty text node value
        // together into a single string, and storing the index number at which the next string starts
        // with the matched index, find the nearest index value but return that index-1.
        // For example, if our match index is 10 and nodesStartPos = [0, 5, 11, 13],
        // we return index 1 (11 is the nearest but we want the index-1, 5).
        const pos = $567297790b62d2d4$export$2a4369abc54086f5(nodesStartPos, found, nodeStart);
        const textNode = nodes[pos];
        // In Firefox there is a case that startOffset is the end of a text node.
        // In this case it means the selection is actually starting from the next sibling node.
        let startNode = startContainer;
        if (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && startOffset >= $567297790b62d2d4$var$getNodeTextLength(startNode)) {
            startOffset -= $567297790b62d2d4$var$getNodeTextLength(startNode);
            startNode = startContainer.nextSibling;
        }
        if (startNode && (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && textNode === startNode || // Text node in IE 11 doesn't have contains method
        startNode.nodeType !== $567297790b62d2d4$var$TEXT_NODE_TYPE && startNode.contains(textNode))) {
            // The current text node might be the one we are selecting.
            // However a single text may have more than one match of the selected text.
            // We need to double check if the offset is correct.
            const offsetForCurrentFoundText = found - nodesStartPos[pos];
            if (offsetForCurrentFoundText <= startOffset) index = numMatches;
        }
        // Trace the text node back to the root if the flag is true
        if (includeTraceForMatches) {
            let element = textNode.parentElement;
            const parentElements = [];
            // We want to loop and record all the elements up to the div#content node
            while(element && element.getAttribute('id') !== 'content'){
                let classes = '';
                let attributes = '';
                const { tagName: tagName } = element;
                const classList = element.classList ? element.classList.value : '';
                const dataAttributes = element.getAttributeNames().filter((attribute)=>attribute.indexOf('data-') !== -1);
                // Handle classes
                if (classList.length) classes = `.${classList.split(' ').join('.')}`;
                // Handle data attributes
                if (dataAttributes.length) dataAttributes.forEach((attribute)=>{
                    // We don't want to get the value of the data-macro-body and data-title attributes
                    // because they can contain user information and we don't want to record it
                    if (attribute !== 'data-macro-body' && attribute !== 'data-title') {
                        // While it's "possible", we'll never actually get here if element is null
                        const value = element?.getAttribute(attribute);
                        attributes += `[${attribute}="${value}"]`;
                    } else attributes += `[${attribute}]`;
                });
                parentElements.unshift(`${tagName}${classes}${attributes}`);
                element = element.parentElement;
            }
            matchTraceList.push(parentElements.join(' > '));
        }
        numMatches++;
        start = found + 1;
        nodeStart = pos;
    }
    return {
        numMatches: numMatches,
        index: index,
        matchTraceList: matchTraceList.length ? matchTraceList : null
    };
}
module.exports["indexTextNodes"] = $567297790b62d2d4$export$2605a3f2b4d7f885;
module.exports["findMatches"] = $567297790b62d2d4$export$f4585c00f32d9257;

});

parcelRegister("liGyh", function(module, exports) {

var $dIPzP = parcelRequire("dIPzP");


var $42omo = parcelRequire("42omo");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");


var $jMyy4 = parcelRequire("jMyy4");


var $1rdvc = parcelRequire("1rdvc");

const $ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery = (0, $dIPzP.default);
const $ba57c93125c5375a$var$logger = (0, $7W8i8.getLogger)('comment-query-params');
const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location, queryArchivedContent: queryArchivedContent = false } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: legacyData, error: legacyError } = (0, $jMyy4.useQueryInterop)($ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery, {
        variables: {
            commentId: targetCommentId,
            contentStatus: [
                queryArchivedContent ? (0, $1rdvc.GraphQLContentStatus).ARCHIVED : (0, $1rdvc.GraphQLContentStatus).DRAFT,
                (0, $1rdvc.GraphQLContentStatus).CURRENT
            ]
        },
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    if (legacyError) $ba57c93125c5375a$var$logger.error`Error: Unable to query comment location for ${commentId}`;
    // Determine error state - use new flow error or old flow error
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? commentError : legacyError;
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    // Extract location and container ID from either new or old flow
    const commentLocation = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location?.type : legacyData?.comments?.nodes?.[0]?.location?.type;
    // Extract container ID from either new or old flow
    let commentContainerId;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
        commentContainerId = comment.container?.id;
        else commentContainerId = undefined;
    } else commentContainerId = legacyData?.comments?.nodes?.[0]?.container?.id;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === commentLocation) && (pageId === commentContainerId || commentContainerId === undefined && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false));
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParamsCallback = (0, $42omo.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const removeCommentQueryParams = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? removeCommentQueryParamsCallback : removeCommentQueryParamsFunction;
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("dIPzP", function(module, exports) {
/**
 * @generated SignedSource<<a4b8af8281cf365b777f3e53bbd6ba7b>>
 * @relayHash ab6c713571991d15a172cc151a881572
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae
const $c1e2aac1eea196bd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ]
                        },
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentQueryParamsCommentLocationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentQueryParamsCommentLocationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ab6c713571991d15a172cc151a881572",
            "id": "f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae",
            "metadata": {},
            "name": "useCommentQueryParamsCommentLocationQuery",
            "operationKind": "query",
            "text": "query useCommentQueryParamsCommentLocationQuery($commentId:ID,$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId,contentStatus:$contentStatus){nodes{container{id},location{__typename,type},id}}}"
        }
    };
}();
$c1e2aac1eea196bd$var$node.hash = "60bed37eee2f8a7739db095067b4457b";
var $c1e2aac1eea196bd$export$2e2bcd8739ae039 = $c1e2aac1eea196bd$var$node;
module.exports["default"] = $c1e2aac1eea196bd$export$2e2bcd8739ae039;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");

const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: explicitlySkipped = false } = options;
    // Skip queries if experiment is disabled or explicitly skipped through options
    const skip = explicitlySkipped || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $42omo.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && processedCommentsData.isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $42omo.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (processedCommentsData.isDataProcessed) {
            if (commentId) {
                const cachedComment = processedCommentsData.flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = processedCommentsData.flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.map((node)=>node).filter((node)=>node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        processedCommentsData.flatCommentsMap,
        processedCommentsData.flatMarkerRefMap,
        processedCommentsData.isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $42omo.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && processedCommentsData.isDataProcessed && !oneCommentData.loading && !processedCommentsData.error && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        processedCommentsData.isDataProcessed,
        processedCommentsData.error,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $42omo.useMemo)(()=>{
        return validationError || processedCommentsData.error || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsData.error,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $42omo.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !processedCommentsData.isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<92885808ea2867c0651c4a23f755c501>>
 * @relayHash 80f6dc5113d6aef8927adf669909b48e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "80f6dc5113d6aef8927adf669909b48e",
            "id": "a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "ed7145a8b5d08f815e716de36a4b73ca";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a1c5d5765ca44631 = [
    'DRAFT',
    'CURRENT',
    'ARCHIVED',
    'DELETED'
];
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: $bd3b81debc212a33$export$a1c5d5765ca44631,
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    const updatedRootComments = [
        ...cachedRootComments
    ];
    let updatedTotalCount = totalCount;
    // If there is already a comment with the same ID in the root array, replace it
    // Normally this shouldn't happen because new comments should always have unique IDs, but there
    // is a case were this can happen with replies (see below) - so let's be safe and handle it just
    // in case it ever happens with root comments as well.
    const existingRootIndex = updatedRootComments.findIndex((comment)=>newComment?.id && comment?.id === newComment?.id);
    if (existingRootIndex !== -1) updatedRootComments[existingRootIndex] = newComment;
    else {
        // Else add the newly added comment to the end of the root comments list
        updatedRootComments.push(newComment);
        // Increment total count. Note that we can only add individual comments without any replies, but
        // let's be safe and adjust for any replies in case this ever changes
        updatedTotalCount += repliesCount + 1;
    }
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies
        ];
        // If there is already a reply with the same ID in the parent's replies, replace it
        // Normally this shouldn't happen because new comments should always have unique IDs, but there
        // is a case were this can happen - when we're in edit mode and another user who is also in
        // edit mode also adds a reply to comment on the new text and then Updates the page -> we get
        // the new reply via the pubsub events and again when the new text is added by the Update.
        const existingReplyIndex = updatedReplies.findIndex((reply)=>newComment?.id && reply?.id === newComment?.id);
        if (existingReplyIndex !== -1) updatedReplies[existingReplyIndex] = newComment;
        else {
            // Else add the new  reply to the array
            updatedReplies.push(newComment);
            // Increment total count. We can only add individual comments without any replies, but let's be
            // safe and adjust for any replies in case this ever changes
            updatedTotalCount += 1 + repliesCount;
        }
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: parentOnCompleted, onError: onError } = options;
    // Shared handling for query errors (initial load and refetch): mark certain errors as handled, then invoke callback.
    // WS-3494 / COMMENTS-188
    const applyQueryErrorHandling = (0, $42omo.useCallback)((error, callback)=>{
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        callback?.(error);
    }, []);
    const handleQueryError = (0, $42omo.useCallback)((error)=>applyQueryErrorHandling(error, onError), [
        applyQueryErrorHandling,
        onError
    ]);
    // Skip query if experiment is disabled, no content ID, or explicitly skipped
    const shouldSkip = !contentId || !!options.skip || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        context: {
            single: true
        },
        fetchPolicy: // We auto-batch queries that fire within 10ms of eachother. Since this query is slow, this unbatches it to avoid slowing down everything else
        fetchPolicy,
        onCompleted: (data)=>{
            parentOnCompleted?.(data);
        },
        onError: handleQueryError
    });
    const refetch = (0, $42omo.useCallback)(async ({ onError: refetchOnError } = {})=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            applyQueryErrorHandling(error, refetchOnError ?? onError);
        }
    }, [
        queryResponse,
        applyQueryErrorHandling,
        onError
    ]);
    const addCommentInCache = (0, $42omo.useCallback)(({ newComment: newComment, onError: onError })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                }
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $42omo.useCallback)(({ commentId: commentId, onError: onError })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return false;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                }
            });
            return true;
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
            return false;
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        data: queryResponse.data,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
const $bd3b81debc212a33$export$713a041e7ad7d7c4 = (contentId)=>{
    const dataProxy = (0, $l1uFv.readQueryInterop)({
        query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId)
    });
    return dataProxy;
};
module.exports["MAX_COMMENTS_TO_RETURN"] = $bd3b81debc212a33$export$ef1591875b2a95ef;
module.exports["allContentStatuses"] = $bd3b81debc212a33$export$a1c5d5765ca44631;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;
module.exports["getCommentsDataFromCache"] = $bd3b81debc212a33$export$713a041e7ad7d7c4;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<bbc652d817ee7ec6a834c089f3daf214>>
 * @relayHash 9e9dce87233142bdde0be6a1e1389db3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca81297f1557d2f17e9e2311bb04d63937ce1bd7af490b89946ebdfc85fc61e9
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v11 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v14 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v11 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v21 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v23 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "number"
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v27 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v27 /*: any*/ 
        },
        "params": {
            "cacheID": "9e9dce87233142bdde0be6a1e1389db3",
            "id": "ca81297f1557d2f17e9e2311bb04d63937ce1bd7af490b89946ebdfc85fc61e9",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "f3f3f95ad61519f75dd5ba8d0cde2302";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("1rdvc", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $39a1d37ae379d69e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $39a1d37ae379d69e$export$b634e5de755b7d35;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("fHAwL", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $9zUhf.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $9zUhf.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $9zUhf.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("izhdc", function(module, exports) {

var $8i27m = parcelRequire("8i27m");

const $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b = (currentlyRenderedThreads, unresolvedInlineComments)=>{
    // Grab everything on the screen as a set for quick access
    const allRenderedInlineCommentIds = new Set(unresolvedInlineComments);
    // Grab all of the refs for inline comments that are available on the panel
    const panelCommentRefs = currentlyRenderedThreads.map((comment)=>{
        if (comment.type === 'INLINE') {
            if ('inlineMarkerRef' in comment && comment.inlineMarkerRef) return {
                ref: comment.inlineMarkerRef,
                type: (0, $8i27m.CommentType).INLINE
            };
            else return {
                ref: '',
                type: (0, $8i27m.CommentType).INLINE
            };
        } else return {
            ref: comment.id,
            type: (0, $8i27m.CommentType).GENERAL
        };
    }).filter((comment)=>{
        return comment.ref !== '';
    });
    // Grab the refs that we can navigate too (aka the ones rendered on the page, so open (i.e. not resolved) comments)
    const navigableInlineCommentRefs = new Set(panelCommentRefs.map((comment)=>{
        if (comment.type === (0, $8i27m.CommentType).INLINE) return allRenderedInlineCommentIds.has(comment.ref) ? comment.ref : '';
        else return comment.ref;
    }));
    return {
        panelCommentRefs: panelCommentRefs,
        navigableInlineCommentRefs: navigableInlineCommentRefs
    };
};
const $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29 = (action, panelCommentRefs, currentlySelectedThreadKey)=>{
    let nextIndex = panelCommentRefs.findIndex((comment)=>{
        return comment.ref === currentlySelectedThreadKey;
    });
    if (nextIndex === -1) nextIndex = 0;
    else if (action === 'next') nextIndex = (nextIndex + 1) % panelCommentRefs.length;
    else nextIndex = (nextIndex - 1 + panelCommentRefs.length) % panelCommentRefs.length;
    return panelCommentRefs[nextIndex];
};
module.exports["parsePanelAndInlineRefs"] = $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b;
module.exports["getNextRef"] = $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29;

});

parcelRegister("gSkOQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aSsfA = parcelRequire("aSsfA");


var $6lAIr = parcelRequire("6lAIr");


var $i6UMJ = parcelRequire("i6UMJ");


var $9wGTI = parcelRequire("9wGTI");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $89de80864b4e19fe$export$618f651f678380bf = ()=>{
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, removedThreadsMap: removedThreadsMap } = (0, $8i27m.useCommentsDataState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    return (0, $42omo.useMemo)(()=>{
        const footerCommentThreads = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $6lAIr.getVisibleCommentThreads)({
            includeGeneralComments: true,
            commentsDataMap: commentsDataMap,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        }) : (0, $i6UMJ.getOpenCommentThreads)({
            commentsDataMap: commentsDataMap,
            showInlineComments: false,
            showGeneralComments: true,
            location: (0, $i6UMJ.LocationValue).FOOTER,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            removedThreadsMap: removedThreadsMap
        });
        const footerCommentIds = footerCommentThreads.map((thread)=>thread.id);
        return {
            footerCommentIds: footerCommentIds,
            footerCommentThreads: footerCommentThreads
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode,
        removedThreadsMap
    ]);
};
module.exports["useFooterComments"] = $89de80864b4e19fe$export$618f651f678380bf;

});

parcelRegister("6lAIr", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");

const $475d5d8641a18b80$var$isParentCommentOpen = (commentData)=>commentData.isOpen;
const $475d5d8641a18b80$var$wasCommentRemovedByAnotherUser = (comment)=>Boolean(comment.wasRemovedByAnotherUser);
const $475d5d8641a18b80$var$wasCommentDeletedByAnotherUser = (comment)=>comment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
const $475d5d8641a18b80$var$isInlineLocation = (location)=>{
    return location && 'inlineMarkerRef' in location;
};
const $475d5d8641a18b80$var$isParentComment = (comment)=>'isOpen' in comment;
const $475d5d8641a18b80$var$getVisibleGeneralComments = ({ isCommentValid: isCommentValid, comments: comments })=>Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter((reply)=>reply && isCommentValid(reply))
        });
        return acc;
    }, []);
const $475d5d8641a18b80$var$getNextInlineResolveProperties = (inlineResolveProperties, isDangling)=>{
    if (!inlineResolveProperties) return {};
    return {
        inlineResolveProperties: {
            ...inlineResolveProperties,
            isDangling: isDangling
        }
    };
};
const $475d5d8641a18b80$var$updateCommentLocation = (comment, isDangling)=>{
    const commentLocation = comment.location;
    if (!$475d5d8641a18b80$var$isInlineLocation(commentLocation)) return commentLocation;
    return {
        ...commentLocation,
        ...$475d5d8641a18b80$var$getNextInlineResolveProperties(commentLocation.inlineResolveProperties, isDangling)
    };
};
const $475d5d8641a18b80$var$getNextComment = (comment, isDangling)=>{
    const { replies: replies, ...rest } = comment;
    return {
        ...rest,
        replies: replies,
        location: $475d5d8641a18b80$var$updateCommentLocation(comment, isDangling)
    };
};
const $475d5d8641a18b80$var$getVisibleInlineComments = (isCommentValid, comments, orderedAnnotationIds, _isNewDanglingCommentExperienceEnabled)=>{
    const activeMarkerRefs = new Set(orderedAnnotationIds);
    const nonDangling = [];
    const dangling = [];
    const validComments = Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter(isCommentValid)
        });
        return acc;
    }, []);
    for (const comment of validComments){
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        const isDangling = !inlineMarkerRef || !activeMarkerRefs.has(inlineMarkerRef);
        const updatedComment = $475d5d8641a18b80$var$getNextComment(comment, isDangling);
        if (isDangling) dangling.push(updatedComment);
        else nonDangling.push(updatedComment);
    }
    return [
        nonDangling,
        dangling
    ];
};
const $475d5d8641a18b80$export$70df9f207ee9869d = (comment)=>{
    if ($475d5d8641a18b80$var$wasCommentDeletedByAnotherUser(comment)) return false;
    return $475d5d8641a18b80$var$isParentComment(comment) ? !$475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
};
const $475d5d8641a18b80$export$28d3eb19856355d7 = (comment)=>{
    if ($475d5d8641a18b80$var$wasCommentRemovedByAnotherUser(comment)) return false;
    return $475d5d8641a18b80$var$isParentComment(comment) ? $475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
};
const $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList = (comments, orderedAnnotationIds)=>{
    const commentsByMarkerRef = new Map(comments.map((comment)=>{
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        return [
            inlineMarkerRef,
            comment
        ];
    }));
    return orderedAnnotationIds.map((id)=>commentsByMarkerRef.get(id)).filter((comment)=>comment !== undefined);
};
const $475d5d8641a18b80$var$getVisibleInlineThreadsForView = (currentView, sortedNonDanglingComments, danglingComments)=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).OPEN:
            return sortedNonDanglingComments;
        case (0, $3mVfX.ViewValues).DELETED_CONTENT:
            return danglingComments;
        default:
            return [
                ...sortedNonDanglingComments,
                ...danglingComments
            ];
    }
};
const $475d5d8641a18b80$var$getVisibleInlineThreads = ({ isCommentValid: isCommentValid, commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, currentView: currentView, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled })=>{
    const [nonDanglingComments, danglingComments] = $475d5d8641a18b80$var$getVisibleInlineComments(isCommentValid, commentsDataMap.inline, orderedAnnotationIds, isNewDanglingCommentExperienceEnabled);
    const sortedNonDanglingComments = $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList(nonDanglingComments, orderedAnnotationIds);
    const visibleInlineThreadsForView = isNewDanglingCommentExperienceEnabled ? $475d5d8641a18b80$var$getVisibleInlineThreadsForView(currentView, sortedNonDanglingComments, danglingComments) : [
        ...sortedNonDanglingComments,
        ...danglingComments
    ];
    return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? visibleInlineThreadsForView : sortedNonDanglingComments;
};
const $475d5d8641a18b80$var$getIsCommentValid = ({ currentView: currentView })=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).RESOLVED:
            return $475d5d8641a18b80$export$70df9f207ee9869d;
        default:
            return $475d5d8641a18b80$export$28d3eb19856355d7;
    }
};
// Determine if general comments are enabled based on the user's selection and - if using the new
// Comments Data Manager -  the user is not in Edit mode. In the legacy commments data management,
// general comments were not loaded into the commentsDataMap when the page is in Edit mode and thus
// not added to the visible threads list. But in the Comments Data Manager, all comments are loaded
// regardless of the page mode, and since we still don't want to have general comments in the list
// in Edit mode we need to explicitly hide them.
const $475d5d8641a18b80$var$isGeneralCommentsEnabled = ({ includeGeneralComments: includeGeneralComments, pageMode: pageMode })=>(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? includeGeneralComments && pageMode !== (0, $cD1qu.PageMode).EDIT : includeGeneralComments;
const $475d5d8641a18b80$export$cbe812921774e978 = ({ commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, includeInlineComments: includeInlineComments, includeGeneralComments: includeGeneralComments, currentView: currentView = (0, $3mVfX.ViewValues).OPEN, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux'), isCommentValid: providedIsCommentValid, pageMode: pageMode })=>{
    const threads = [];
    const isCommentValid = providedIsCommentValid ?? $475d5d8641a18b80$var$getIsCommentValid({
        currentView: currentView
    });
    if (includeInlineComments) {
        const inlineThreads = $475d5d8641a18b80$var$getVisibleInlineThreads({
            isCommentValid: isCommentValid,
            commentsDataMap: commentsDataMap,
            orderedAnnotationIds: orderedAnnotationIds,
            currentView: currentView,
            isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled
        });
        threads.push(...inlineThreads);
    }
    if ($475d5d8641a18b80$var$isGeneralCommentsEnabled({
        includeGeneralComments: includeGeneralComments,
        pageMode: pageMode
    })) {
        const generalThreads = $475d5d8641a18b80$var$getVisibleGeneralComments({
            isCommentValid: isCommentValid,
            comments: commentsDataMap.general
        }).sort((0, $i6UMJ.getCommentsSortedOldestToNewest));
        threads.push(...generalThreads);
    }
    return threads;
};
module.exports["getVisibleCommentThreads"] = $475d5d8641a18b80$export$cbe812921774e978;

});

parcelRegister("i6UMJ", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $422HI = parcelRequire("422HI");


var $7Oxky = parcelRequire("7Oxky");


var $8i27m = parcelRequire("8i27m");


var $6faGq = parcelRequire("6faGq");


var $9wGTI = parcelRequire("9wGTI");


var $3mVfX = parcelRequire("3mVfX");

const $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $6ed006a18ff2d87d$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $6ed006a18ff2d87d$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
var $6ed006a18ff2d87d$export$50c823aead020a09 = /*#__PURE__*/ function(LocationValue) {
    LocationValue["PANEL"] = "panel";
    LocationValue["FOOTER"] = "footer";
    LocationValue["STANDALONE"] = "standalone";
    return LocationValue;
}({});
const $6ed006a18ff2d87d$export$68e3ad656cdca3ec = (orderedActiveAnnotationIdList)=>{
    return orderedActiveAnnotationIdList.slice(0, Math.min(orderedActiveAnnotationIdList.length, (0, $7Oxky.COMMENT_BATCH_SIZE))).filter((item)=>!item.isLoaded) // only get the ones that are not loaded yet
    .map((item)=>item.threadKey);
};
const $6ed006a18ff2d87d$var$getDanglingComments = ({ commentsDataMap: commentsDataMap, annotationsSet: annotationsSet, openCommentThreads: openCommentThreads })=>{
    // Add dangling comments and handle real-time changes
    for(const threadKey in commentsDataMap.inline){
        const commentThread = commentsDataMap.inline[threadKey];
        const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling;
        if (commentThread?.isOpen) {
            // if the comment is already dangling, we want to add it to the list
            if (isDanglingComment) {
                const markerRef = commentThread?.location?.inlineMarkerRef;
                // comment is no longer dangling if it has a marker ref and is in the annotations set
                if (markerRef && annotationsSet && annotationsSet.has(markerRef)) {
                    const inlineLocation = commentThread.location;
                    const updatedCommentThread = {
                        ...commentThread,
                        location: {
                            ...commentThread.location,
                            inlineResolveProperties: {
                                ...inlineLocation.inlineResolveProperties,
                                isDangling: false
                            }
                        }
                    };
                    openCommentThreads.push(updatedCommentThread);
                } else openCommentThreads.push(commentThread);
                continue;
            }
            // check for real time dangling comments
            const markerRef = commentThread?.location?.inlineMarkerRef;
            // comment is dangling if it has a marker ref and is not in the annotations set
            // deleted and resolved comments are not in commentsDataMap so we know it's only dangling scenario
            // we do this here so the view will update immediately, but the actual mutation is handled in useDanglingOperations
            if (markerRef && annotationsSet && !annotationsSet.has(markerRef)) {
                const inlineLocation = commentThread.location;
                const updatedCommentThread = {
                    ...commentThread,
                    location: {
                        ...commentThread.location,
                        inlineResolveProperties: {
                            ...inlineLocation.inlineResolveProperties,
                            isDangling: true
                        }
                    }
                };
                openCommentThreads.push(updatedCommentThread);
            }
        }
    }
};
const $6ed006a18ff2d87d$export$aa9a5ed6405f18d6 = ({ commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const openCommentThreads = [];
    const annotationsSet = new Set(orderedActiveAnnotationIdList.map((item)=>item.threadKey));
    // inline comments
    if (showInlineComments && location === "panel") {
        const removedAnnotationIds = new Set(Object.values(removedThreadsMap.inline));
        const filteredActiveAnnotationIds = orderedActiveAnnotationIdList.filter((item)=>!removedAnnotationIds.has(item.threadKey));
        const totalAnnotationsCount = filteredActiveAnnotationIds.length + Object.keys(removedThreadsMap).length;
        let activeIndex = 0; // Track position in filteredActiveAnnotationIds
        for(let i = 0; i < totalAnnotationsCount; i++){
            let threadKey = '';
            if (removedThreadsMap.inline.hasOwnProperty(i)) {
                threadKey = removedThreadsMap.inline[i];
                const commentThread = commentsDataMap.inline[threadKey];
                if (commentThread) openCommentThreads.push(commentThread);
            } else if (activeIndex < filteredActiveAnnotationIds.length) {
                threadKey = filteredActiveAnnotationIds[activeIndex].threadKey;
                const commentThread = commentsDataMap.inline[threadKey];
                // dangling comments had a marker ref and will be inside commentsDataMap, so we want to ignore these first
                const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                // Don't add if it's dangling or might become dangling (has marker ref but not in annotations set)
                const markerRef = commentThread?.location?.inlineMarkerRef;
                const mightBecomeDangling = markerRef && annotationsSet && !annotationsSet.has(markerRef);
                if (commentThread?.isOpen && !isDanglingComment && !mightBecomeDangling) openCommentThreads.push(commentThread);
                activeIndex++;
            }
        }
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) $6ed006a18ff2d87d$var$getDanglingComments({
            commentsDataMap: commentsDataMap,
            openCommentThreads: openCommentThreads,
            annotationsSet: annotationsSet
        });
    }
    // general comments
    if (showGeneralComments || location === "footer") {
        // We can just push these in the order we have them because we have no concept of "active"
        const generalComments = Object.values(commentsDataMap.general).filter((generalComment)=>{
            return generalComment.isOpen || generalComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
        });
        openCommentThreads.push(...generalComments);
    }
    return openCommentThreads;
};
const $6ed006a18ff2d87d$export$4fc364cd63a9b204 = ({ commentsDataMap: commentsDataMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const resolvedCommentThreads = [];
    // inline comments
    if (showInlineComments && location === "panel") for(const key in commentsDataMap.inline){
        const comment = commentsDataMap.inline[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    // general comments
    if (showGeneralComments) for(const key in commentsDataMap.general){
        const comment = commentsDataMap.general[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    return resolvedCommentThreads;
};
const $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime = (comment)=>{
    const commentLocation = comment.location;
    const resolvedTime = commentLocation?.inlineResolveProperties?.resolvedTime || commentLocation?.commentResolveProperties?.resolvedTime; // from the BE, this is for both reopened and resolved time, in milliseconds
    return resolvedTime || (0, $6faGq.getValidDate)(comment.createdAtNonLocalized).getTime(); // getTime() returns milliseconds
};
const $6ed006a18ff2d87d$export$d2935240a910e26e = (currentSort, commentThreads)=>{
    if (currentSort === (0, $3mVfX.SortValues).MOST_RECENT) return [
        ...commentThreads
    ].sort((a, b)=>$6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(b) - $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(a));
    return commentThreads;
};
const $6ed006a18ff2d87d$export$47f9a121266175f = (annotations)=>annotations.map((annotation)=>annotation.threadKey);
const $6ed006a18ff2d87d$export$7119b2a60583b6dc = (marks = [])=>marks.map((mark)=>mark.attrs.id);
const $6ed006a18ff2d87d$export$b02d74cde949c060 = (commentA, commentB)=>(0, $6faGq.getValidDate)(commentA?.createdAtNonLocalized).getTime() - (0, $6faGq.getValidDate)(commentB?.createdAtNonLocalized).getTime();
const $6ed006a18ff2d87d$export$5425fcea1abfd6f7 = (error)=>{
    if (!error) // if falsy, consider it as NOT containing non-reactionsSummary errors
    return true;
    else if (error instanceof (0, $422HI.ApolloErrorInterop) || error instanceof (0, $9wEpK.ApolloError)) {
        // TODO we will need to migrate to ApolloRelayInterops to get proper error type of ApolloErrorInterop instead of ApolloError
        // after migration, we can remove the instanceof ApolloError check here
        const hasOtherGqlErrors = error.graphQLErrors?.filter((e)=>!e.path?.includes('reactionsSummary'))?.length > 0;
        return !hasOtherGqlErrors && !error.networkError;
    } else // if truthy but not an ApolloErrorInterop, consider it as containing non-reactionsSummary errors
    return false;
};
module.exports["LocationValue"] = $6ed006a18ff2d87d$export$50c823aead020a09;
module.exports["getOpenCommentThreads"] = $6ed006a18ff2d87d$export$aa9a5ed6405f18d6;
module.exports["getResolvedCommentThreads"] = $6ed006a18ff2d87d$export$4fc364cd63a9b204;
module.exports["getSortedCommentThreads"] = $6ed006a18ff2d87d$export$d2935240a910e26e;
module.exports["getAnnotationThreadKeys"] = $6ed006a18ff2d87d$export$47f9a121266175f;
module.exports["getMarkIds"] = $6ed006a18ff2d87d$export$7119b2a60583b6dc;
module.exports["getCommentsSortedOldestToNewest"] = $6ed006a18ff2d87d$export$b02d74cde949c060;
module.exports["onlyHasReactionsSummaryErrors"] = $6ed006a18ff2d87d$export$5425fcea1abfd6f7;

});

parcelRegister("7Oxky", function(module, exports) {

var $9j86J = parcelRequire("9j86J");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $jMyy4 = parcelRequire("jMyy4");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery = (0, $9j86J.default);
const $9d95853344936385$export$e8d93aa39e79e9aa = 1000; // setting to 1000 for now until we implement infinite scroll for the comments panel
const $9d95853344936385$export$6ddede7674b6d70f = ({ pageId: pageId, markerRefList: markerRefList, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || markerRefList.length === 0 || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery, {
        variables: {
            pageId: pageId,
            inlineMarkerRefList: markerRefList,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        // We want to utilize the cache as much as possible, but keep the list up to date if it changes
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["COMMENT_BATCH_SIZE"] = $9d95853344936385$export$e8d93aa39e79e9aa;

});

parcelRegister("9j86J", function(module, exports) {
/**
 * @generated SignedSource<<f0e3e253fd60ce0c9c079f1a840e7d71>>
 * @relayHash 7f2f5b1f8eabf86158412fc6d30f35d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13f41a7981b1d0d7a2ba4907ee0baedf14ff9510a934a126d5407f86dc09ff15
const $1a28e5c1a6e6a8b1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7f2f5b1f8eabf86158412fc6d30f35d6",
            "id": "13f41a7981b1d0d7a2ba4907ee0baedf14ff9510a934a126d5407f86dc09ff15",
            "metadata": {},
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query useActiveInlineCommentsQueryActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$1a28e5c1a6e6a8b1$var$node.hash = "55c0fbf12929f614cd8832ad8c70d69e";
var $1a28e5c1a6e6a8b1$export$2e2bcd8739ae039 = $1a28e5c1a6e6a8b1$var$node;
module.exports["default"] = $1a28e5c1a6e6a8b1$export$2e2bcd8739ae039;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $aXWIB.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $42omo.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $42omo.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $42omo.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("9Z1sw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eq95w = parcelRequire("eq95w");


var $42omo = parcelRequire("42omo");


var $iRRvH = parcelRequire("iRRvH");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    if (!panelHasContent) return children;
    const t1 = `web-panel-${locationName}`;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: t1
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $42omo.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    }, ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    }));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<18bcbcb83c5ea4dff2cddc5f86dc7a4b>>
 * @relayHash 833a199280e17468b888b75415571623
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 757c41bf66d4b23344db601f044d5ddb1c4983731abd0744dfca530decb91fa2
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "833a199280e17468b888b75415571623",
            "id": "757c41bf66d4b23344db601f044d5ddb1c4983731abd0744dfca530decb91fa2",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$contentId:ID,$spaceKey:String){webPanels(location:$location,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "d375ecd281e94a7575edd0ac7360eb54";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $frIzR.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $42omo.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $42omo.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $42omo.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

const $68e0b10beef6f399$export$1db2f2faaee8467f = (0, $3u0dr.isReactCompilerActiveV2)() ? function ActivatableComponent(t0) {
    const $ = (0, $frIzR.c)(26);
    const { children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9s45p.makeGate)();
        $[0] = t1;
    } else t1 = $[0];
    const gate = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[1] !== children) {
        t2 = ()=>children;
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    const renderChildren = t2;
    let t3;
    if ($[3] !== analyticsName || $[4] !== createAnalyticsEvent || $[5] !== id || $[6] !== onActivate || $[7] !== triggers) {
        t3 = (reason)=>{
            if (gate?.getStatus() === "suspended") {
                onActivate?.(reason);
                if (analyticsName) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "activatableComponent",
                        action: "activated",
                        actionSubject: "activatableComponent",
                        attributes: {
                            analyticsName: analyticsName,
                            triggers: triggers,
                            boundaryId: id,
                            activationReason: reason
                        }
                    }
                }).fire();
                gate.resolve();
            }
        };
        $[3] = analyticsName;
        $[4] = createAnalyticsEvent;
        $[5] = id;
        $[6] = onActivate;
        $[7] = triggers;
        $[8] = t3;
    } else t3 = $[8];
    const activateComponent = t3;
    let t4;
    if ($[9] !== activateComponent || $[10] !== analyticsName || $[11] !== id || $[12] !== triggers) {
        t4 = {
            triggers: triggers,
            gate: gate,
            activateComponent: activateComponent,
            boundaryId: id,
            analyticsName: analyticsName
        };
        $[9] = activateComponent;
        $[10] = analyticsName;
        $[11] = id;
        $[12] = triggers;
        $[13] = t4;
    } else t4 = $[13];
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)(t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = gate?.getStatus?.();
        $[14] = t5;
    } else t5 = $[14];
    const t6 = analyticsName || id;
    let t7;
    if ($[15] !== activateComponent || $[16] !== id || $[17] !== renderChildren || $[18] !== ssrSuccess || $[19] !== t6 || $[20] !== triggers) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
            gate: gate,
            id: id,
            render: renderChildren,
            ssrSuccess: ssrSuccess,
            activateComponent: activateComponent,
            resolved: t5 === "resolved",
            boundaryName: t6,
            triggers: triggers
        });
        $[15] = activateComponent;
        $[16] = id;
        $[17] = renderChildren;
        $[18] = ssrSuccess;
        $[19] = t6;
        $[20] = triggers;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== hostRefWithActivation || $[23] !== id || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": id
        }, t7);
        $[22] = hostRefWithActivation;
        $[23] = id;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function ActivatableComponent({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $42omo.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const renderChildren = (0, $42omo.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $42omo.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
};
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $flWvL = parcelRequire("flWvL");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage) && ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true));
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !(0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') && !(0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || !contentId // avoid starting network flow
    });
    let serverModeRaw;
    if ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true)) {
        const contentProps = data?.content?.nodes?.[0]?.contentProperties;
        if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
        else serverModeRaw = contentProps?.latest?.contentMode;
    } else serverModeRaw = undefined;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isLoading: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? Boolean(loading) : false,
            error: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? error ?? null : null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<46e6847c14af3668e8bf3fe82f5b303a>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("lfmjq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7aRa9 = parcelRequire("7aRa9");

const $0d3a7c976c53fe50$export$687b1508b29e79eb = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const moved = urlParams.get('moved');
        if (moved === 'success') {
            // Show the success flag
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0d3a7c976c53fe50$var$i18n.movePageItemMovedTitle),
                isAutoDismiss: true
            });
            // Clean up URL parameters without causing a page reload
            urlParams.delete('moved');
            const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
            const newUrl = `${window.location.pathname}${newParams}${window.location.hash}`;
            window.history.replaceState({}, '', newUrl);
        }
    }, [
        flags,
        intl
    ]);
    return null;
});
const $0d3a7c976c53fe50$var$i18n = (0, $aXWIB.defineMessages)({
    movePageItemMovedTitle: {
        id: "page-tree.move-page.flag.success",
        defaultMessage: "Item moved"
    }
});
module.exports["MovePageSuccessFlag"] = $0d3a7c976c53fe50$export$687b1508b29e79eb;

});

parcelRegister("ecUYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("hd53J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $aSsfA = parcelRequire("aSsfA");


var $gtj7V = parcelRequire("gtj7V");


var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");

// Initiates the loading of all comment data for the specified page in the background
// This component is also responsible for processing the raw comments data and updating
// the ProcessedCommentsDataStore with categorized results using default contentStatus filters.
// Experience tracking constants
const $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE = 'comments-data-background-load';
const $52b7f7492d78c524$export$bdd232a9ca677e73 = ({ contentId: contentId })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ lastProcessedData: lastProcessedData }, { setProcessedData: setProcessedData, setError: setError, setRefetch: setRefetch, clearErrorAndResetIsDataProcessed: clearErrorAndResetIsDataProcessed, setDataToProcessed: setDataToProcessed, processCommentsData: processCommentsData }] = (0, $4L9ve.useProcessedCommentsData)();
    // Track refetch count to force effect to run after every refetch
    const [refetchCount, setRefetchCount] = (0, $42omo.useState)(0);
    // Call the hook to load all comments - should only when content has settled and is ready so we
    // don't impact loading times
    // Always fetch with network-only to ensure we get fresh data
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: !contentId,
            fetchPolicy: 'network-only'
        }
    });
    // Set refetch function in store whenever it changes.
    // Wrap refetch so that when the view calls it (e.g. Retry), we clear error/processed state first.
    // Increment refetchCount in .then() to force the processing effect to run.
    // On refetch failure we always setError, then call the caller's onError if they passed one.
    (0, $42omo.useEffect)(()=>{
        if (refetch) {
            const wrappedRefetch = ({ onError: callerOnError } = {})=>{
                clearErrorAndResetIsDataProcessed();
                return refetch({
                    onError: (err)=>{
                        setError(err instanceof Error ? err : new Error(String(err)));
                        callerOnError?.(err);
                    }
                }).then((result)=>{
                    setRefetchCount((c)=>c + 1);
                    return result;
                });
            };
            setRefetch(wrappedRefetch);
        }
    }, [
        refetch,
        setRefetch,
        clearErrorAndResetIsDataProcessed,
        setError
    ]);
    // Process and update the ProcessedCommentsDataStore when data changes or refetch completes
    // This is the ONLY place where the processed data store should be updated
    // Depends on refetchCount to ensure effect runs after every refetch
    (0, $42omo.useEffect)(()=>{
        // Don't process data while loading
        if (loading) return;
        if (error) {
            setError(error);
            return;
        }
        // When data is undefined (e.g. refetch failed and error was set in the wrapper catch),
        // don't call setProcessedData or we'd overwrite that error with error: undefined.
        if (data === undefined) return;
        // Fast path: if data reference is same as last processed (cached data from refetch),
        // just flip isDataProcessed to true without reprocessing
        if (data === lastProcessedData) {
            setDataToProcessed();
            return;
        }
        processCommentsData({
            data: data,
            pageMode: pageMode
        });
    }, [
        data,
        loading,
        error,
        pageMode,
        setProcessedData,
        setError,
        contentId,
        refetchCount,
        lastProcessedData,
        setDataToProcessed,
        processCommentsData
    ]);
    // Experience tracking: Handle success/failure when loading completes
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        // Only track completion if we're not still loading
        if (!loading) {
            if (error) // Experience failed due to error
            experienceTracker.fail({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
                error: error
            });
            else // Experience succeeded - comments data loaded successfully
            experienceTracker.succeed({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE
            });
        }
    }, [
        loading,
        error,
        contentId,
        experienceTracker
    ]);
    // This component only triggers the hook, doesn't render anything other than the ExperienceStart,
    // which handles being rendered multiple times with the same props gracefully
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
        attributes: {
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
            contentId: contentId
        }
    });
};
module.exports["CommentsDataBackgroundLoader"] = $52b7f7492d78c524$export$bdd232a9ca677e73;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("8S5Nq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $218fb6be7858ca8d$export$c96c4e8509a478b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "OOALz",
    name: "SmartButtonConfigPanel",
    loader: async ()=>(await (parcelRequire("hjjpp"))).SmartButtonConfigPanel
});
module.exports["SmartButtonConfigPanel"] = $218fb6be7858ca8d$export$c96c4e8509a478b;

});

parcelRegister("hjjpp", function(module, exports) {

let $c9a34431be381461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c9a34431be381461$var$load("1MlIV"),
    $c9a34431be381461$var$load("7o5Pu"),
    $c9a34431be381461$var$load("6wr18"),
    $c9a34431be381461$var$load("gctwz"),
    $c9a34431be381461$var$load("7f9Fz"),
    $c9a34431be381461$var$load("lhkXg"),
    $c9a34431be381461$var$load("7EorR"),
    $c9a34431be381461$var$load("ffEVr"),
    $c9a34431be381461$var$load("hjl2g")
]).then(()=>parcelRequire('cN6V7'));

});

parcelRegister("iz4WO", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");

const $a33c6d5d862efa17$export$cb03d08131b95fd = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    return {
        isSmartButtonAllowed: isPremium || (0, $9wGTI.fg)('a4c_free_and_standard_editions')
    };
};
module.exports["useSmartButtonPremiumGate"] = $a33c6d5d862efa17$export$cb03d08131b95fd;

});

parcelRegister("jOYfu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5aeb329f1887f8c3$export$f82678483d6187c3 = ()=>{
    const [smartButtonActiveNodeLocalId, setSmartButtonActiveNodeLocalId] = (0, $42omo.useState)(null);
    const openSmartButtonConfigPanel = (0, $42omo.useCallback)((localId)=>{
        setSmartButtonActiveNodeLocalId(localId);
    }, [
        setSmartButtonActiveNodeLocalId
    ]);
    const closeSmartButtonConfigPanel = (0, $42omo.useCallback)(()=>{
        setSmartButtonActiveNodeLocalId(null);
    }, [
        setSmartButtonActiveNodeLocalId
    ]);
    return (0, $42omo.useMemo)(()=>({
            smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            closeSmartButtonConfigPanel: closeSmartButtonConfigPanel
        }), [
        smartButtonActiveNodeLocalId,
        openSmartButtonConfigPanel,
        closeSmartButtonConfigPanel
    ]);
};
module.exports["useSmartButtonConfigPanel"] = $5aeb329f1887f8c3$export$f82678483d6187c3;

});

parcelRegister("jXhAV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d2180b659da4cd23$export$cace184d1f5b9f1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "QfGBR",
    name: "QuickReload",
    loader: async ()=>{
        const { QuickReload: QuickReload } = await (parcelRequire("94UMP"));
        return QuickReload;
    }
});
module.exports["QuickReload"] = $d2180b659da4cd23$export$cace184d1f5b9f1;

});

parcelRegister("94UMP", function(module, exports) {

let $69c0896c5257e18a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $69c0896c5257e18a$var$load("4pqtR"),
    $69c0896c5257e18a$var$load("5XqRg"),
    $69c0896c5257e18a$var$load("6wr18"),
    $69c0896c5257e18a$var$load("fzXjm"),
    $69c0896c5257e18a$var$load("ffEVr"),
    $69c0896c5257e18a$var$load("7XFs3")
]).then(()=>parcelRequire('1EPbu'));

});

parcelRegister("fSC8h", function(module, exports) {
var $aa49ff5a5783772f$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["POLLING_ONLY"] = 0] = "POLLING_ONLY";
    PubSubState[PubSubState["PUBSUB_ONLY"] = 1] = "PUBSUB_ONLY";
    PubSubState[PubSubState["ACTIVE"] = 2] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 3] = "TERMINATED";
    return PubSubState;
}({});
const $aa49ff5a5783772f$export$5a33be95ac52bdad = 2000;
var $aa49ff5a5783772f$export$8f29965b50c50222 = /*#__PURE__*/ function(PubSubFlagType) {
    PubSubFlagType[PubSubFlagType["COMMENT"] = 0] = "COMMENT";
    PubSubFlagType[PubSubFlagType["EDIT"] = 1] = "EDIT";
    return PubSubFlagType;
}({});
var $aa49ff5a5783772f$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode[PageMode["EDITOR"] = 0] = "EDITOR";
    PageMode[PageMode["LIVE"] = 1] = "LIVE";
    PageMode[PageMode["RENDERER"] = 2] = "RENDERER";
    return PageMode;
}({});
module.exports["PubSubState"] = $aa49ff5a5783772f$export$c51d39001809fe3e;
module.exports["INACTIVE_TAB_WAIT_INTERVAL"] = $aa49ff5a5783772f$export$5a33be95ac52bdad;
module.exports["PubSubFlagType"] = $aa49ff5a5783772f$export$8f29965b50c50222;
module.exports["PageMode"] = $aa49ff5a5783772f$export$6ea4b0c62affbe44;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("6OEkb", function(module, exports) {

var $7br77 = parcelRequire("7br77");


var $lWOeJ = parcelRequire("lWOeJ");


var $2GT4I = parcelRequire("2GT4I");


var $2XqLN = parcelRequire("2XqLN");


var $86okN = parcelRequire("86okN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");

// Fragments for reading cached page title from different GraphQL types
const $5e2eb46b901e6cea$var$PTPageTitleFragment = (0, $2GT4I.default);
const $5e2eb46b901e6cea$var$ContentTitleFragment = (0, $lWOeJ.default);
const $5e2eb46b901e6cea$var$SearchConfluencePageBlogAttachmentTitleFragment = (0, $7br77.default);
var $5e2eb46b901e6cea$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($5e2eb46b901e6cea$var$Client || {});
const $5e2eb46b901e6cea$var$FRAGMENTS_BY_TYPE = [
    {
        // Page tree stores pages as PTPage
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: $5e2eb46b901e6cea$var$PTPageTitleFragment
    },
    {
        // Current page, pages from Recents, Home's Discover feed, etc.
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: $5e2eb46b901e6cea$var$ContentTitleFragment
    },
    {
        // Search query uses AGG graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: $5e2eb46b901e6cea$var$SearchConfluencePageBlogAttachmentTitleFragment
    }
];
const $5e2eb46b901e6cea$export$3726046076a35f2c = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) return {
        title: undefined,
        source: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let title;
    let source;
    $5e2eb46b901e6cea$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // This approach is duplicated in /confluence/next/packages/live-pages-utils/src/getCachedPageData.ts
            // and should be migrated to readFragmentInterop.
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: (0, $86okN.toDocumentNode)(fragment)
            });
            if (fragmentData?.title) {
                title = fragmentData.title;
                source = gqlType;
                return true;
            }
        } catch  {
        // Fragment not found in cache, continue to next type
        }
        return false;
    });
    return {
        title: title,
        source: source
    };
});
module.exports["getCachedPageTitle"] = $5e2eb46b901e6cea$export$3726046076a35f2c;

});

parcelRegister("7br77", function(module, exports) {
/**
 * @generated SignedSource<<f48f782f9c911bcc733df803c321c344>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e54bf7229bfc419$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageTitle_SearchTitleFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$4e54bf7229bfc419$var$node.hash = "d90150d434d564e9cfbe7d4d09a5bba7";
var $4e54bf7229bfc419$export$2e2bcd8739ae039 = $4e54bf7229bfc419$var$node;
module.exports["default"] = $4e54bf7229bfc419$export$2e2bcd8739ae039;

});

parcelRegister("lWOeJ", function(module, exports) {
/**
 * @generated SignedSource<<593482054cc26e05ab0094bb52cbfd70>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1d105b77e8b3188$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageTitle_ContentTitleFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ],
    "type": "Content"
};
$c1d105b77e8b3188$var$node.hash = "1115adb3266e3c279996feed3d6fdcd5";
var $c1d105b77e8b3188$export$2e2bcd8739ae039 = $c1d105b77e8b3188$var$node;
module.exports["default"] = $c1d105b77e8b3188$export$2e2bcd8739ae039;

});

parcelRegister("2GT4I", function(module, exports) {
/**
 * @generated SignedSource<<dc997c7cc5cfb5683f53e6ac29bd40ab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d72376c6388be165$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageTitle_PageTreeTitleFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ],
    "type": "PTPage"
};
$d72376c6388be165$var$node.hash = "5ea3936d33c7a82bf109180867502c4b";
var $d72376c6388be165$export$2e2bcd8739ae039 = $d72376c6388be165$var$node;
module.exports["default"] = $d72376c6388be165$export$2e2bcd8739ae039;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("7mpOv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: shouldShowRovo
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("85rxh", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $bf7e99398a94595e$export$2cbe7bfb10d82597 = (cloudId, userId, orgId)=>{
    return (0, $42omo.useCallback)((purpose)=>{
        if (purpose === 'rovo-agent') return {
            contentURL: window.location.origin + window.location.pathname,
            cloudId: cloudId,
            userId: userId,
            orgId: orgId
        };
        return null;
    }, [
        cloudId,
        userId,
        orgId
    ]);
};
module.exports["useGetChannelVariables"] = $bf7e99398a94595e$export$2cbe7bfb10d82597;

});

parcelRegister("fjhaB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $7Ryt2 = parcelRequire("7Ryt2");

function $cb89921c47be68ab$export$78c2bbd50206cc7f() {
    const [activityProvider, setActivityProvider] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        setActivityProvider((0, $7Ryt2.getActivityProvider)(cloudId));
    }, [
        cloudId
    ]);
    return activityProvider;
}
module.exports["useActivityProvider"] = $cb89921c47be68ab$export$78c2bbd50206cc7f;

});

parcelRegister("7Ryt2", function(module, exports) {

var $iooNr = parcelRequire("iooNr");

const $7a079a70f1242941$var$ACTIVITY_URL = '/gateway/api/graphql';
async function $7a079a70f1242941$export$a2b55b950e46bdd9(cloudId) {
    return Promise.resolve(new (0, $iooNr.default)($7a079a70f1242941$var$ACTIVITY_URL, cloudId));
}
module.exports["getActivityProvider"] = $7a079a70f1242941$export$a2b55b950e46bdd9;

});

parcelRegister("iooNr", function(module, exports) {

var $6hu6G = parcelRequire("6hu6G");


var $2S07V = parcelRequire("2S07V");

/**
 * Currently the underlying FE service can only retrieve the first page of results, which is limited at 100 results.
 * See ACT-3418 for upcoming fix.
 */ const $a08e15a2b85e2ea8$var$DEFAULT_ACTIVITY_COUNT = 100;
class $a08e15a2b85e2ea8$export$2e2bcd8739ae039 {
    async getRecentItems(limit = $a08e15a2b85e2ea8$var$DEFAULT_ACTIVITY_COUNT) {
        if (!this.recentPromise) this.recentPromise = this.client.fetchActivities([
            50
        ], {
            rootContainerIds: [
                this.cloudId
            ],
            limit: limit
        }, [
            'viewed'
        ]);
        try {
            const response = await this.recentPromise;
            return response.viewed.map((node)=>({
                    objectId: node.object.id,
                    name: node.object.name || '',
                    container: this.getContainerName(node.containers),
                    url: node.object.url,
                    iconUrl: node.object.icon?.type === 'EMOJI' && node.object.icon.fallback ? node.object.icon.fallback : node.object.icon?.value || '',
                    type: node.object.type,
                    viewedTimestamp: node.timestamp
                })).filter((item)=>Boolean(item.name));
        } catch (err) {
            throw new (0, $2S07V.ActivityError)(err.message, err.code);
        }
    }
    async searchRecent(query) {
        const items = await this.getRecentItems();
        return this.filterItems(items, query);
    }
    /**
   * It should return the closet container's name
   */ getContainerName(containers) {
        for(let i = containers.length - 1; i >= 0; --i){
            const containerName = containers[i].name;
            if (containerName) return containerName;
        }
        return '';
    }
    filterItems(items, searchTerm) {
        if (!searchTerm) return [];
        return items.filter((item)=>{
            return item.name?.toLowerCase()?.includes(searchTerm.toLowerCase());
        });
    }
    /**
   *
   * @param url
   * @param cloudId - this will be transformed into an ARI
   * @param options - @deprecated this is no longer used
   */ constructor(url, cloudId, options = {}){
        this.cloudId = void 0;
        this.client = void 0;
        this.recentPromise = void 0;
        this.cloudId = `ari:cloud:platform::site/${cloudId}`;
        this.client = (0, $6hu6G.createActivityClient)('v3', 'editor', undefined, url);
    }
}
module.exports["default"] = $a08e15a2b85e2ea8$export$2e2bcd8739ae039;

});

parcelRegister("6hu6G", function(module, exports) {

var $89ZxY = parcelRequire("89ZxY");


var $8AdqG = parcelRequire("8AdqG");

let $ab62de022060b56f$var$previousClientVersion;
const $ab62de022060b56f$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($ab62de022060b56f$var$previousClientVersion && $ab62de022060b56f$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $ab62de022060b56f$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $89ZxY.ActivityClientV2)(product, baseUrl);
    return new (0, $8AdqG.ActivityClientV3)(product, baseUrl, logger, configFetch);
};
module.exports["createActivityClient"] = $ab62de022060b56f$export$224367b01f71f2aa;

});

parcelRegister("89ZxY", function(module, exports) {

var $1kGOm = parcelRequire("1kGOm");


var $aMbzE = parcelRequire("aMbzE");


var $9Zwww = parcelRequire("9Zwww");

class $d9872470f8564e9f$export$330ab0047f2fb745 extends (0, $aMbzE.ActivityClient) {
    constructor(_product, baseUrl){
        super('v2', _product, undefined, baseUrl);
        this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $1kGOm.fetchActivitiesWithExperience)((experience)=>(0, $9Zwww.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        };
        this.setProduct = (product)=>{
            this.product = product;
        };
    }
}
module.exports["ActivityClientV2"] = $d9872470f8564e9f$export$330ab0047f2fb745;

});

parcelRegister("1kGOm", function(module, exports) {

var $8vHBJ = parcelRequire("8vHBJ");


var $lsrrn = parcelRequire("lsrrn");


var $agkwD = parcelRequire("agkwD");

async function $32117be304c7c4e1$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $agkwD.recentWorkClientExperienceV2)() : (0, $agkwD.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $lsrrn.packageName,
            packageVersion: $lsrrn.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $32117be304c7c4e1$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $32117be304c7c4e1$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $8vHBJ.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};
module.exports["fetchActivitiesWithExperience"] = $32117be304c7c4e1$export$4a906f16800734f3;

});

parcelRegister("8vHBJ", function(module, exports) {
class $2e5e077062c7732f$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.message = void 0;
        this.method = void 0;
        this.path = void 0;
        this.statusCode = void 0;
        this.xRequestId = void 0;
        this.headers = void 0;
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $2e5e077062c7732f$export$97b788730ba59845 = (e)=>e instanceof $2e5e077062c7732f$export$2e2bcd8739ae039;
module.exports["default"] = $2e5e077062c7732f$export$2e2bcd8739ae039;

});

parcelRegister("lsrrn", function(module, exports) {
const $5fc4693544cc0e9d$export$9345d7360ffe0722 = "platform-pkg";
const $5fc4693544cc0e9d$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageName"] = $5fc4693544cc0e9d$export$9345d7360ffe0722;
module.exports["packageVersion"] = $5fc4693544cc0e9d$export$91546b032799aa40;

});

parcelRegister("agkwD", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $a4fb49f1c23260ee$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $a4fb49f1c23260ee$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($a4fb49f1c23260ee$var$keyToTiming);
const $a4fb49f1c23260ee$export$d7769758f5eaa63b = ()=>{
    return new (0, $5aVN7.UFOExperience)('client', {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $a4fb49f1c23260ee$var$timings
    });
};
const $a4fb49f1c23260ee$export$9e32a4ed888f4717 = ()=>new (0, $5aVN7.UFOExperience)('client-v3', {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $a4fb49f1c23260ee$var$timings
    });
module.exports["recentWorkClientExperienceV2"] = $a4fb49f1c23260ee$export$d7769758f5eaa63b;
module.exports["recentWorkClientExperienceV3"] = $a4fb49f1c23260ee$export$9e32a4ed888f4717;

});

parcelRegister("aMbzE", function(module, exports) {

var $lJ9dF = parcelRequire("lJ9dF");

class $cfb0c7d09d50e5a4$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.clientVersion = void 0;
        this.product = 'unknown';
        this.headers = void 0;
        this.baseUrl = (0, $lJ9dF.GRAPHQL_GATEWAY_PATH);
        this.fetchActivities = void 0;
        this.setProduct = void 0;
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}
module.exports["ActivityClient"] = $cfb0c7d09d50e5a4$export$157740f5433f3dbe;

});

parcelRegister("lJ9dF", function(module, exports) {
const $328c904cbc4ce376$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $328c904cbc4ce376$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SMARTLINK_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SMARTLINK_CLICKED"] = "sl-clicked";
    return VIEWED_EVENT;
}({});
var $328c904cbc4ce376$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $328c904cbc4ce376$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    // 3P Graph types below
    ActivityObjectType["DOCUMENT"] = "document";
    ActivityObjectType["PULL_REQUEST"] = "pull-request";
    ActivityObjectType["REMOTE_LINK"] = "remote-link";
    return ActivityObjectType;
}({});
module.exports["GRAPHQL_GATEWAY_PATH"] = $328c904cbc4ce376$export$851c5df667ca24c8;
module.exports["VIEWED_EVENT"] = $328c904cbc4ce376$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $328c904cbc4ce376$export$eb4e9f525aef1cc3;
module.exports["ActivityObjectType"] = $328c904cbc4ce376$export$d02a56686be43f69;

});

parcelRegister("9Zwww", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $flhdq = parcelRequire("flhdq");


var $8ONYO = parcelRequire("8ONYO");


var $2w7rF = parcelRequire("2w7rF");

const $e96892609f021260$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $e96892609f021260$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $e96892609f021260$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $e96892609f021260$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $e96892609f021260$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $8ONYO.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $e96892609f021260$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $flhdq.postResource)(baseUrl, {
            operationName: (0, $9M6Bq.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($e96892609f021260$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $2w7rF.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $2w7rF.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $2w7rF.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $2w7rF.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $2w7rF.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};
module.exports["fetchActivitiesV2"] = $e96892609f021260$export$750ec7816fdd2f9e;

});

parcelRegister("9M6Bq", function(module, exports) {

var $5nZsM = parcelRequire("5nZsM");

const $6478cdf7ffdfed6b$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(product);
};
const $6478cdf7ffdfed6b$export$41bca9dc6871dd4e = (product)=>{
    return `${$6478cdf7ffdfed6b$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};
module.exports["getOperationName"] = $6478cdf7ffdfed6b$export$41bca9dc6871dd4e;

});

parcelRegister("flhdq", function(module, exports) {
parcelRequire("jjbGD");
var $99X6x = parcelRequire("99X6x");
var $jjbGD = parcelRequire("jjbGD");


var $g6Nhv = parcelRequire("g6Nhv");


var $8vHBJ = parcelRequire("8vHBJ");

const $50a49ab2b7b0fd3b$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $g6Nhv.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $99X6x.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $50a49ab2b7b0fd3b$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $8vHBJ.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $50a49ab2b7b0fd3b$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $50a49ab2b7b0fd3b$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return text ? JSON.parse(text) : {};
};
const $50a49ab2b7b0fd3b$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $jjbGD.retryOnException)(()=>$50a49ab2b7b0fd3b$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $50a49ab2b7b0fd3b$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}
module.exports["postResource"] = $50a49ab2b7b0fd3b$export$2ff3e1f219ccfad6;

});

parcelRegister("jjbGD", function(module, exports) {
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("99X6x")).default);

var $ugvwf = parcelRequire("ugvwf");


var $8r8H1 = parcelRequire("8r8H1");


var $99X6x = parcelRequire("99X6x");

const $e6bcc9a5af5d2f35$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $e6bcc9a5af5d2f35$var$NO_CALLS_ERROR = 'No calls made';
const $e6bcc9a5af5d2f35$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $8r8H1.NO_RETRIES), retryOn: retryOn = [
    (0, $99X6x.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($e6bcc9a5af5d2f35$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $e6bcc9a5af5d2f35$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $e6bcc9a5af5d2f35$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $ugvwf.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};
module.exports["retryOnException"] = $e6bcc9a5af5d2f35$export$1d94629c94e7a17f;

});

parcelRegister("ugvwf", function(module, exports) {
const $b720f8bd3e196adc$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $b720f8bd3e196adc$export$2e2bcd8739ae039 = $b720f8bd3e196adc$var$convertToError;
module.exports["default"] = $b720f8bd3e196adc$export$2e2bcd8739ae039;

});

parcelRegister("8r8H1", function(module, exports) {
const $3648e78e1eff0ebe$export$a0a1c8f90becc136 = [];
const $3648e78e1eff0ebe$export$972171517b12aa4 = [
    0,
    0
];
const $3648e78e1eff0ebe$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $3648e78e1eff0ebe$export$f6858378b665f957 = [
    100,
    500,
    1000
];
module.exports["NO_RETRIES"] = $3648e78e1eff0ebe$export$a0a1c8f90becc136;

});

parcelRegister("99X6x", function(module, exports) {
class $96df690c33121e3a$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.method = void 0;
        this.originalName = void 0;
        this.path = void 0;
        this.stack = void 0;
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}
module.exports["default"] = $96df690c33121e3a$export$2e2bcd8739ae039;

});

parcelRegister("g6Nhv", function(module, exports) {
const $ed7d1e76b1f471ae$var$urlRegex = new RegExp(/^https?:\/\//);
function $ed7d1e76b1f471ae$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($ed7d1e76b1f471ae$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}
module.exports["getFullUrl"] = $ed7d1e76b1f471ae$export$2414511207262909;

});

parcelRegister("8ONYO", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $tyUdU = parcelRequire("tyUdU");

const $5e56b4855b8ddd4f$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $5e56b4855b8ddd4f$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$5e56b4855b8ddd4f$var$ACTIVITIES}
   }
`;
const $5e56b4855b8ddd4f$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$5e56b4855b8ddd4f$var$ACTIVITIES}
   }
`;
const $5e56b4855b8ddd4f$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$5e56b4855b8ddd4f$var$ACTIVITIES}
    }
`;
const $5e56b4855b8ddd4f$var$activityQueryMap = new Map([
    [
        'workedOn',
        $5e56b4855b8ddd4f$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $5e56b4855b8ddd4f$var$VIEWED__QUERY
    ],
    [
        'all',
        $5e56b4855b8ddd4f$var$ALL__QUERY
    ]
]);
const $5e56b4855b8ddd4f$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $5e56b4855b8ddd4f$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $9M6Bq.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $5e56b4855b8ddd4f$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $5e56b4855b8ddd4f$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$5e56b4855b8ddd4f$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $5e56b4855b8ddd4f$var$getActivitiesQuery(product, $5e56b4855b8ddd4f$var$getMyActivitiesQuery(activityQueries.map((query)=>$5e56b4855b8ddd4f$var$activityQueryMap.get(query)))),
        queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};
module.exports["generateActivityQueryWithFilters"] = $5e56b4855b8ddd4f$export$855cd08371c65b8c;

});

parcelRegister("tyUdU", function(module, exports) {

var $jcjam = parcelRequire("jcjam");


var $bOQQO = parcelRequire("bOQQO");

const $3ce1f7f21e6b0975$export$5201d39848130041 = {
    v2: (0, $jcjam.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $bOQQO.ACTIVITY_FILTER_V3_MAP)
};
module.exports["ACTIVITY_FILTER_COLLECTION"] = $3ce1f7f21e6b0975$export$5201d39848130041;

});

parcelRegister("jcjam", function(module, exports) {

var $g1YDs = parcelRequire("g1YDs");


var $f8Fj5 = parcelRequire("f8Fj5");

const $a229434d184cb046$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $f8Fj5.default)
    ],
    [
        'activities',
        (0, $g1YDs.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V2_MAP"] = $a229434d184cb046$export$1dca7bc1ec360897;

});

parcelRegister("g1YDs", function(module, exports) {

var $2dGYV = parcelRequire("2dGYV");

/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $aa3e39d5302b5352$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $2dGYV.generateActivityFiltersV2)(restFilters);
};
var $aa3e39d5302b5352$export$2e2bcd8739ae039 = $aa3e39d5302b5352$var$generateV2ActivitiesFilters;
module.exports["default"] = $aa3e39d5302b5352$export$2e2bcd8739ae039;

});

parcelRegister("2dGYV", function(module, exports) {

var $cfWcp = parcelRequire("cfWcp");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $91acf2a102fe0c9f$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $91acf2a102fe0c9f$export$ebef9c1f1e15c057 = (filters = {})=>(0, $cfWcp.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $91acf2a102fe0c9f$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM.has(originalkey) ? $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });
module.exports["generateActivityFiltersV2"] = $91acf2a102fe0c9f$export$ebef9c1f1e15c057;

});

parcelRegister("cfWcp", function(module, exports) {
const $b77a537090dafa9a$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};
module.exports["generateActivityFilters"] = $b77a537090dafa9a$export$23c75313f46dd54e;

});

parcelRegister("f8Fj5", function(module, exports) {

var $2dGYV = parcelRequire("2dGYV");

/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $0a24d92d27935207$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $2dGYV.generateActivityFiltersV2)(restFilters);
};
var $0a24d92d27935207$export$2e2bcd8739ae039 = $0a24d92d27935207$var$generateV2MyActivityFilters;
module.exports["default"] = $0a24d92d27935207$export$2e2bcd8739ae039;

});

parcelRegister("bOQQO", function(module, exports) {

var $dQITg = parcelRequire("dQITg");


var $jBMZs = parcelRequire("jBMZs");

const $68c8b19d94c6d0af$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $jBMZs.default)
    ],
    [
        'activities',
        (0, $dQITg.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V3_MAP"] = $68c8b19d94c6d0af$export$9a1782843b6e99d2;

});

parcelRegister("dQITg", function(module, exports) {

var $cYpDV = parcelRequire("cYpDV");

/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $c500a5dd90aab1cd$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $cYpDV.generateActivityFiltersV3)(restFilters);
};
var $c500a5dd90aab1cd$export$2e2bcd8739ae039 = $c500a5dd90aab1cd$var$generateV3ActivityFilters;
module.exports["default"] = $c500a5dd90aab1cd$export$2e2bcd8739ae039;

});

parcelRegister("cYpDV", function(module, exports) {

var $cfWcp = parcelRequire("cfWcp");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $a9947c270139ebd0$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $a9947c270139ebd0$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $a9947c270139ebd0$export$e73fe7ded3fe2664 = (filters = {})=>(0, $cfWcp.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $a9947c270139ebd0$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $a9947c270139ebd0$var$ROOT_LEVEL_FILTERS);
module.exports["generateActivityFiltersV3"] = $a9947c270139ebd0$export$e73fe7ded3fe2664;

});

parcelRegister("jBMZs", function(module, exports) {

var $cYpDV = parcelRequire("cYpDV");

/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $233cbacaae2fcf7a$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $cYpDV.generateActivityFiltersV3)(restFilters);
};
var $233cbacaae2fcf7a$export$2e2bcd8739ae039 = $233cbacaae2fcf7a$var$generateV3MyActivityFilters;
module.exports["default"] = $233cbacaae2fcf7a$export$2e2bcd8739ae039;

});

parcelRegister("2w7rF", function(module, exports) {
const $75279b3aeb424623$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $75279b3aeb424623$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$75279b3aeb424623$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}
module.exports["transformActivitiesItems"] = $75279b3aeb424623$export$306a8b649360ca6f;

});

parcelRegister("8AdqG", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $jjbGD = parcelRequire("jjbGD");


var $dh538 = parcelRequire("dh538");


var $lJ9dF = parcelRequire("lJ9dF");


var $lsrrn = parcelRequire("lsrrn");


var $1kGOm = parcelRequire("1kGOm");


var $flhdq = parcelRequire("flhdq");


var $8slu7 = parcelRequire("8slu7");


var $1HpcN = parcelRequire("1HpcN");


var $fX414 = parcelRequire("fX414");


var $a3sLS = parcelRequire("a3sLS");


var $l4NdO = parcelRequire("l4NdO");


var $h4NLj = parcelRequire("h4NLj");


var $aMbzE = parcelRequire("aMbzE");


var $dB4CM = parcelRequire("dB4CM");


var $9t27K = parcelRequire("9t27K");


var $2OHoP = parcelRequire("2OHoP");

const $0954b34b93e72b05$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $0954b34b93e72b05$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $0954b34b93e72b05$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $0954b34b93e72b05$var$DEFAULT_TAGS = {
    source: (0, $lsrrn.packageName),
    sourcePackageVersion: (0, $lsrrn.packageVersion)
};
class $0954b34b93e72b05$export$3c3c237c92ca1fb9 extends (0, $aMbzE.ActivityClient) {
    constructor(_product, baseUrl, logger, configFetch){
        super('v3', _product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl);
        this.hydratorConfigClient = void 0;
        this.clientHandlers = void 0;
        this.setProduct = (product)=>{
            this.product = product;
        };
        this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$0954b34b93e72b05$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$0954b34b93e72b05$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig();
        this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $1HpcN.GraphQLJSError)(err));
                    const invalidFragment = (0, $dB4CM.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        };
        this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $jjbGD.retryOnException)(async ()=>{
                    const request = (0, $9t27K.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $2OHoP.filtersToMetadata)(filters)
                    });
                    const res = await (0, $flhdq.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $2OHoP.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $8slu7.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $8slu7.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$0954b34b93e72b05$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$0954b34b93e72b05$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $2OHoP.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $fX414.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $0954b34b93e72b05$var$transformActivityItem('workedOn', (0, $2OHoP.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $0954b34b93e72b05$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $0954b34b93e72b05$var$transformActivityItem('all', (0, $2OHoP.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $2OHoP.rollupActivitiesData)(activities) : activities;
        };
        this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $1kGOm.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $h4NLj.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, _product, configFetch);
    }
}
const $0954b34b93e72b05$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $l4NdO.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc) return (0, $l4NdO.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    if (object.product === 'graph' && (0, $l4NdO.isThirdPartyARI)(object.id)) {
        const product = (0, $l4NdO.parseThirdPartyProduct)(object.id).split('.').at(1);
        return (0, $l4NdO.hydrate3pIcon)(product, hydratedData.icon, hydratedData.staticFallbacks);
    }
    return $0954b34b93e72b05$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $l4NdO.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $l4NdO.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
const $0954b34b93e72b05$var$setStatusHydration = (hydratedData)=>{
    const value = (0, $l4NdO.hydratedValueToString)(hydratedData.statusValue);
    const score = (0, $l4NdO.hydratedValueToString)(hydratedData.statusScore);
    const color = (0, $l4NdO.hydratedValueToString)(hydratedData.statusColor);
    return value || score || color ? {
        value: value,
        score: score,
        color: color
    } : undefined;
};
function $0954b34b93e72b05$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            let product = object.product;
            if (object.product === 'graph' || object.id.startsWith('ari:cloud:graph::pull-request')) product = (0, $2OHoP.getThirdPartyGraphProvider)(object);
            const isSmartlinkViewedType = item.node.event.eventType === (0, $lJ9dF.VIEWED_EVENT).SMARTLINK_VIEWED;
            const isRemoteLinkGateDisabled = !(0, $dh538.fg)('recent_work_client_enable_graph_remote_links');
            const isSmartlinkViewedGateEnabled = (0, $dh538.fg)('platform_recent_work_enable_sl-viewed_results');
            const isExternalRemoteLink = item.node.object.data?.__typename === 'ExternalRemoteLink';
            const isExternalPullRequest = item.node.object.data?.__typename === 'ExternalPullRequest';
            const isGithubRecentsEnabled = (0, $c6GJD.default).getExperimentValue('add-github-activityplatform-recentworkitem', 'isEnabled', false);
            if (isSmartlinkViewedType && !isSmartlinkViewedGateEnabled) // Don't return any `sl-viewed` event results
            return acc;
            if (isExternalRemoteLink && isRemoteLinkGateDisabled) // Don't return Remote Link result if not rolled out to product yet
            return acc;
            if (isExternalPullRequest && product === 'github' && !isGithubRecentsEnabled) // Don't return GitHub pull request results until the feature gate is enabled
            return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $a3sLS.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $l4NdO.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $l4NdO.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $lJ9dF.WORKED_EVENT).CREATED ? (0, $lJ9dF.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $2OHoP.parseRootContainerARI)(object.rootContainerId),
                        icon: $0954b34b93e72b05$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $l4NdO.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $l4NdO.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $l4NdO.hydratedValueToString)(hydratedData.name, ' '),
                        product: product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: (0, $l4NdO.hydratedValueToString)(hydratedData.subtype) || object.data.subtype,
                        url: (0, $l4NdO.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $l4NdO.hydratedValueToString)(hydratedData.objectTypeName),
                        creator: (0, $l4NdO.hydratedValueToString)(hydratedData.creator),
                        providerId: (0, $l4NdO.hydratedValueToString)(hydratedData.providerId),
                        status: $0954b34b93e72b05$var$setStatusHydration(hydratedData),
                        __typename: object.data.__typename
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}
module.exports["ActivityClientV3"] = $0954b34b93e72b05$export$3c3c237c92ca1fb9;

});

parcelRegister("8slu7", function(module, exports) {
class $d9ab8e53f4fb0597$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}
module.exports["GraphQLFragmentError"] = $d9ab8e53f4fb0597$export$2d1b192199788179;

});

parcelRegister("1HpcN", function(module, exports) {
class $6d47e15a0e40ba32$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.error = void 0;
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}
module.exports["GraphQLJSError"] = $6d47e15a0e40ba32$export$8d4af49ee2a0fbe2;

});

parcelRegister("fX414", function(module, exports) {
class $5d9f0e5a45afc0ec$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.errors = void 0;
        this.errorMessages = void 0;
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}
module.exports["GraphQLNoResultsError"] = $5d9f0e5a45afc0ec$export$3f19ff30d409b70;

});

parcelRegister("a3sLS", function(module, exports) {

var $kkhbp = parcelRequire("kkhbp");


var $2fnPs = parcelRequire("2fnPs");

const $24f658990005dffd$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $24f658990005dffd$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $2fnPs.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $2fnPs.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $2fnPs.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $24f658990005dffd$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $24f658990005dffd$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($kkhbp)))(object, path);
}
function $24f658990005dffd$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $24f658990005dffd$var$getOrSearch(current, split);
    return current;
}
function $24f658990005dffd$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($kkhbp)))(edge, fieldId) === searchValue);
}
function $24f658990005dffd$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$24f658990005dffd$var$resolvePath(object, path));
}
const $24f658990005dffd$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $24f658990005dffd$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};
module.exports["hydratePolymorphicData"] = $24f658990005dffd$export$d658049bf1a63492;

});

parcelRegister("2fnPs", function(module, exports) {
class $88b1285615459d57$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        this.originalName = void 0;
        this.originalMessage = void 0;
        this.stack = void 0;
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}
module.exports["default"] = $88b1285615459d57$export$2e2bcd8739ae039;

});

parcelRegister("l4NdO", function(module, exports) {
const $5fe052f51633fc0f$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $5fe052f51633fc0f$var$isURL(icon) {
    return typeof icon === 'string';
}
function $5fe052f51633fc0f$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $5fe052f51633fc0f$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $5fe052f51633fc0f$export$4578ef3572b21f34 = (ari)=>{
    const result = $5fe052f51633fc0f$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$5fe052f51633fc0f$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $5fe052f51633fc0f$export$fccbae65febb6fd4 = (ari)=>$5fe052f51633fc0f$var$thirdPartyRegex.test(ari);
const $5fe052f51633fc0f$export$c60ec7b3c8b44fe1 = (product, icons, fallbacks, fallbackKey = 'icon')=>{
    if (fallbacks?.[fallbackKey] && product) {
        const thirdPartyLogo = fallbacks['thirdPartyIconPath']?.replace('{replaceProductName}', product) ?? fallbacks[fallbackKey];
        return {
            type: 'URL',
            value: thirdPartyLogo,
            fallbackIcon: fallbacks[fallbackKey]
        };
    }
    return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
};
const $5fe052f51633fc0f$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $5fe052f51633fc0f$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($5fe052f51633fc0f$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($5fe052f51633fc0f$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $5fe052f51633fc0f$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks?.[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};
module.exports["hydratedValueToString"] = $5fe052f51633fc0f$export$c5cea44a1f75b431;
module.exports["parseThirdPartyProduct"] = $5fe052f51633fc0f$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $5fe052f51633fc0f$export$fccbae65febb6fd4;
module.exports["hydrate3pIcon"] = $5fe052f51633fc0f$export$c60ec7b3c8b44fe1;
module.exports["hydrateIcon"] = $5fe052f51633fc0f$export$a328b2bb0d21d984;
module.exports["hydrateConfluenceIcon"] = $5fe052f51633fc0f$export$86b9f44277b105a6;

});

parcelRegister("h4NLj", function(module, exports) {

var $g58eM = parcelRequire("g58eM");


var $hwkRt = parcelRequire("hwkRt");

const $3f0e325881d700a2$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $3f0e325881d700a2$var$FD_ENVIRONMENT = 'prod';
const $3f0e325881d700a2$export$c270c412a04ff3e6 = {
    name: $3f0e325881d700a2$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $3f0e325881d700a2$var$FD_ENVIRONMENT
    }
};
class $3f0e325881d700a2$export$2e2bcd8739ae039 {
    async fetchArtifact() {
        if (this.artifactFetch) return 0, $hwkRt.default;
        // We're using the bundled artifact temporarily as FD caching is broken and does not expire for 365 days
        // https://atlassian.slack.com/archives/C01UV3QT21F/p1753393679628199
        return 0, $hwkRt.default;
    }
    constructor(handlers, product, artifactFetch){
        this.artifactFetch = artifactFetch;
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        new (0, $g58eM.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $3f0e325881d700a2$var$FD_ENVIRONMENT
                },
                value: (0, $hwkRt.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
}
module.exports["FD_CLIENT_FETCH_PROPS"] = $3f0e325881d700a2$export$c270c412a04ff3e6;
module.exports["default"] = $3f0e325881d700a2$export$2e2bcd8739ae039;

});

parcelRegister("g58eM", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $jjbGD = parcelRequire("jjbGD");


var $kt8c2 = parcelRequire("kt8c2");


var $6yH3R = parcelRequire("6yH3R");

var $jmRYU = parcelRequire("jmRYU");


var $h2xad = parcelRequire("h2xad");


var $kvSko = parcelRequire("kvSko");


var $5Wn20 = parcelRequire("5Wn20");

function $bb5380b95425c19e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bb5380b95425c19e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bb5380b95425c19e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bb5380b95425c19e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $bb5380b95425c19e$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $bb5380b95425c19e$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $bb5380b95425c19e$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $jjbGD.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $6yH3R.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $h2xad.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$bb5380b95425c19e$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $5Wn20.flightDeckClientExperience)() : new (0, $jmRYU.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $bb5380b95425c19e$var$_objectSpread($bb5380b95425c19e$var$_objectSpread({}, artifact), {}, {
                key: (0, $kvSko.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $5Wn20.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $iLaQ6.default)(this, "fallbackArtifactMap", new Map());
        (0, $iLaQ6.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $kt8c2.default)($bb5380b95425c19e$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $kvSko.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
}
module.exports["default"] = $bb5380b95425c19e$export$2e2bcd8739ae039;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("6yH3R", function(module, exports) {

var $eoZW1 = parcelRequire("eoZW1");


var $4Nb0k = parcelRequire("4Nb0k");


var $gnjN9 = parcelRequire("gnjN9");


var $exN00 = parcelRequire("exN00");


var $5F2TE = parcelRequire("5F2TE");


var $jmRYU = parcelRequire("jmRYU");


var $1uJFJ = parcelRequire("1uJFJ");

/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $4c6752261483d0e7$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $4c6752261483d0e7$var$defaultPerimeter = "commercial";
async function $4c6752261483d0e7$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $4c6752261483d0e7$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $4c6752261483d0e7$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $4c6752261483d0e7$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $eoZW1.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $4c6752261483d0e7$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $4c6752261483d0e7$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $4c6752261483d0e7$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $4c6752261483d0e7$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $4c6752261483d0e7$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $4c6752261483d0e7$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $jmRYU.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $jmRYU.getVersionMetadataFetchExperience)();
    return new (0, $5F2TE.ConfigClient)(new (0, $gnjN9.BifrostDataSource)(new (0, $exN00.BifrostHttpClientImpl)(env, perimeter), (0, $4Nb0k.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $4c6752261483d0e7$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}
module.exports["fetchFlightDeckConfiguration"] = $4c6752261483d0e7$export$6026918e023c9101;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("4Nb0k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $1l7nm = parcelRequire("1l7nm");

Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $1l7nm.Either;
    }
});

var $dQfUU = parcelRequire("dQfUU");

Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $dQfUU.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $dQfUU.tryGetArtifactData;
    }
});

var $56c1N = parcelRequire("56c1N");

Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $56c1N.parseArtifactManifest;
    }
});

var $4rmqH = parcelRequire("4rmqH");

Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $4rmqH.parseVersionMetadata;
    }
});

var $ejfcn = parcelRequire("ejfcn");

Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $ejfcn.checkManifest;
    }
});

var $ecQWM = parcelRequire("ecQWM");

Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $ecQWM.ConfigRegistryDataSource;
    }
});

var $keTF5 = parcelRequire("keTF5");

Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $keTF5.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $keTF5.Versions;
    }
});

});

parcelRegister("1l7nm", function(module, exports) {
"use strict";
var $0f9d7946bab332da$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $0f9d7946bab332da$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $0f9d7946bab332da$var$Right(value);
    };
    Either.left = function(error) {
        return new $0f9d7946bab332da$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $0f9d7946bab332da$var$Either;
var $0f9d7946bab332da$var$Right = /** @class */ function(_super) {
    $0f9d7946bab332da$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $0f9d7946bab332da$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $0f9d7946bab332da$var$Either.right(this.right);
    };
    return Right;
}($0f9d7946bab332da$var$Either);
var $0f9d7946bab332da$var$Left = /** @class */ function(_super) {
    $0f9d7946bab332da$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $0f9d7946bab332da$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $0f9d7946bab332da$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $0f9d7946bab332da$var$Either.left(f(this.left));
    };
    return Left;
}($0f9d7946bab332da$var$Either);

});

parcelRegister("dQfUU", function(module, exports) {
"use strict";
var $0299bfe91f926726$var$__assign = module.exports && module.exports.__assign || function() {
    $0299bfe91f926726$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0299bfe91f926726$var$__assign.apply(this, arguments);
};
var $0299bfe91f926726$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0299bfe91f926726$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $0299bfe91f926726$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $0299bfe91f926726$var$tryGetArtifactData;

var $e1gYo = parcelRequire("e1gYo");


var $4Nb0k = parcelRequire("4Nb0k");


var $gtZqo = parcelRequire("gtZqo");


var $9kSKy = parcelRequire("9kSKy");


var $4245y = parcelRequire("4245y");

function $0299bfe91f926726$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $0299bfe91f926726$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $0299bfe91f926726$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $0299bfe91f926726$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $0299bfe91f926726$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $4Nb0k.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $gtZqo.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $0299bfe91f926726$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $9kSKy.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $0299bfe91f926726$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $0299bfe91f926726$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $0299bfe91f926726$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $e1gYo.interpolateTagScheme)(manifest.tagScheme, $0299bfe91f926726$var$__assign($0299bfe91f926726$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $0299bfe91f926726$var$__awaiter(_this, void 0, void 0, function() {
                                return $0299bfe91f926726$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $0299bfe91f926726$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $4245y.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $4245y.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $9kSKy.assertUnreachable)(artifact);
    }
}

});

parcelRegister("e1gYo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $a34e5329a6d15964$var$interpolateTagScheme;
module.exports.generateTagScheme = $a34e5329a6d15964$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $a34e5329a6d15964$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $a34e5329a6d15964$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $a34e5329a6d15964$var$getVersionMetadataTag;
const $a34e5329a6d15964$var$TAG_SCHEME_VERSION = 2;
function $a34e5329a6d15964$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($a34e5329a6d15964$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $a34e5329a6d15964$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $a34e5329a6d15964$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $a34e5329a6d15964$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $a34e5329a6d15964$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $a34e5329a6d15964$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $a34e5329a6d15964$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $a34e5329a6d15964$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("gtZqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $bfff0076b2a38448$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $bfff0076b2a38448$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("9kSKy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $6cc0738327f40e2f$var$assertUnreachable;
function $6cc0738327f40e2f$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("4245y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $2efa854173b183a4$var$toJson;
module.exports.toPrettyJson = $2efa854173b183a4$var$toPrettyJson;
function $2efa854173b183a4$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $2efa854173b183a4$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("56c1N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $3b66d7c76b5a6f30$var$parseArtifactManifest;

var $7YiFT = parcelRequire("7YiFT");

function $3b66d7c76b5a6f30$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $7YiFT.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $7YiFT.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $3b66d7c76b5a6f30$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $7YiFT.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $3b66d7c76b5a6f30$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $3b66d7c76b5a6f30$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $7YiFT.parseUnknownObject)(dimensions);
    var supported = (0, $7YiFT.parseArray)(unparsedDimensions.supported).map($7YiFT.parseString);
    var fallback = (0, $7YiFT.parseUndefinedOr)($7YiFT.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $3b66d7c76b5a6f30$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $7YiFT.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $3b66d7c76b5a6f30$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $3b66d7c76b5a6f30$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $7YiFT.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $7YiFT.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $7YiFT.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $7YiFT.parseUndefinedOr)($7YiFT.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $3b66d7c76b5a6f30$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $3b66d7c76b5a6f30$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});

parcelRegister("7YiFT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $5cdc9f61297a7705$var$parseString;
module.exports.parseArray = $5cdc9f61297a7705$var$parseArray;
module.exports.parseBoolean = $5cdc9f61297a7705$var$parseBoolean;
module.exports.parseUnknownObject = $5cdc9f61297a7705$var$parseUnknownObject;
module.exports.parseUndefinedOr = $5cdc9f61297a7705$var$parseUndefinedOr;
function $5cdc9f61297a7705$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $5cdc9f61297a7705$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $5cdc9f61297a7705$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $5cdc9f61297a7705$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $5cdc9f61297a7705$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});

parcelRegister("4rmqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $33bb15189e2a597d$var$parseVersionMetadata;

var $7YiFT = parcelRequire("7YiFT");

function $33bb15189e2a597d$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $7YiFT.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $7YiFT.parseString)(unknownObject.version);
    var publishTime = new Date((0, $7YiFT.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $7YiFT.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("ejfcn", function(module, exports) {
"use strict";
var $a6aea1303ef4c284$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $a6aea1303ef4c284$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $a6aea1303ef4c284$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $a6aea1303ef4c284$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("ecQWM", function(module, exports) {
"use strict";
var $a57b41e342284c93$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a57b41e342284c93$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $e1gYo = parcelRequire("e1gYo");


var $1l7nm = parcelRequire("1l7nm");


var $56c1N = parcelRequire("56c1N");


var $4rmqH = parcelRequire("4rmqH");

var $a57b41e342284c93$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $e1gYo.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($56c1N.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $1l7nm.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $e1gYo.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $4rmqH.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $a57b41e342284c93$var$ConfigRegistryDataSource;

});

parcelRegister("keTF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $ebc04ab7747b3e03$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $ebc04ab7747b3e03$var$BaseUrls;
var $ebc04ab7747b3e03$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $ebc04ab7747b3e03$var$Versions;

});

parcelRegister("gnjN9", function(module, exports) {

var $4Nb0k = parcelRequire("4Nb0k");


var $e1gYo = parcelRequire("e1gYo");

class $bebe258c209dced8$export$2cb8d79200775058 {
    async getLatestVersionMetadata() {
        const tag = (0, $e1gYo.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $4Nb0k.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $4Nb0k.parseVersionMetadata)(response);
                return (0, $4Nb0k.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $4Nb0k.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $e1gYo.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $4Nb0k.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $4Nb0k.parseArtifactManifest)(response);
                return (0, $4Nb0k.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $4Nb0k.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
}
module.exports["BifrostDataSource"] = $bebe258c209dced8$export$2cb8d79200775058;

});

parcelRegister("exN00", function(module, exports) {

var $4Nb0k = parcelRequire("4Nb0k");

function $a96a27f8779f7f59$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $a96a27f8779f7f59$export$45c6d12ca9c14f83 {
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $4Nb0k.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $4Nb0k.Either).right(json)));
            }).catch((error)=>resolve((0, $4Nb0k.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
    constructor(env, perimeter){
        this.baseUrl = $a96a27f8779f7f59$export$f654b28f82155665(env, perimeter);
    }
}
module.exports["BifrostHttpClientImpl"] = $a96a27f8779f7f59$export$45c6d12ca9c14f83;

});

parcelRegister("5F2TE", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $4Nb0k = parcelRequire("4Nb0k");


var $iLqQe = parcelRequire("iLqQe");

function $41f3074aaceffd34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41f3074aaceffd34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41f3074aaceffd34$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41f3074aaceffd34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $41f3074aaceffd34$export$8489e2f039bfcc4c {
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $41f3074aaceffd34$var$_objectSpread($41f3074aaceffd34$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $4Nb0k.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $4Nb0k.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $iLqQe.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
}
module.exports["ConfigClient"] = $41f3074aaceffd34$export$8489e2f039bfcc4c;

});

parcelRegister("iLqQe", function(module, exports) {
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $da916feb1601e8a8$export$1cc944571619e6e8 {
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
}
module.exports["ExperienceDataSourceWrapper"] = $da916feb1601e8a8$export$1cc944571619e6e8;

});

parcelRegister("jmRYU", function(module, exports) {
const $03a383e7109b9e96$var$SAMPLING_RATE = 10;
class $03a383e7109b9e96$var$UFOExperienceWrapper {
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
    constructor(experience){
        this.experience = experience;
    }
}
class $03a383e7109b9e96$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $03a383e7109b9e96$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $03a383e7109b9e96$var$SAMPLING_RATE) return new $03a383e7109b9e96$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("649YS"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $03a383e7109b9e96$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $03a383e7109b9e96$export$5e7536cf7bc56fee();
    }
}
const $03a383e7109b9e96$export$a3006f8f221c0a3b = ()=>$03a383e7109b9e96$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $03a383e7109b9e96$export$c3ac7702bfd47c1b = ()=>$03a383e7109b9e96$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});
module.exports["MockExperience"] = $03a383e7109b9e96$export$5e7536cf7bc56fee;
module.exports["getFlightDeckFetchExperience"] = $03a383e7109b9e96$export$a3006f8f221c0a3b;
module.exports["getVersionMetadataFetchExperience"] = $03a383e7109b9e96$export$c3ac7702bfd47c1b;

});

parcelRegister("649YS", function(module, exports) {

let $46aadbccc4f1e03a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46aadbccc4f1e03a$var$load("h05Zl").then(()=>parcelRequire('1pDeP'));

});

parcelRegister("1uJFJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $Eff3A = parcelRequire("Eff3A");

Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $Eff3A.parseConfigWithTargeting;
    }
});

var $eqS6f = parcelRequire("eqS6f");

Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $eqS6f.TargetedConfig;
    }
});

});

parcelRegister("Eff3A", function(module, exports) {
"use strict";
var $078f8f416dfc8880$var$__assign = module.exports && module.exports.__assign || function() {
    $078f8f416dfc8880$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $078f8f416dfc8880$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $078f8f416dfc8880$var$parseConfigWithTargeting;

var $eqS6f = parcelRequire("eqS6f");

/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $078f8f416dfc8880$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $078f8f416dfc8880$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $eqS6f.TargetedConfig({
                defaultConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $078f8f416dfc8880$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $eqS6f.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $078f8f416dfc8880$var$__assign($078f8f416dfc8880$var$__assign({}, accObject), (_a = {}, _a[key] = $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $078f8f416dfc8880$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $078f8f416dfc8880$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $078f8f416dfc8880$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $078f8f416dfc8880$var$parseIdentifierList(target.orgIds),
            siteIds: $078f8f416dfc8880$var$parseIdentifierList(target.siteIds),
            userIds: $078f8f416dfc8880$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $078f8f416dfc8880$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});

parcelRegister("eqS6f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $a81d757bffb50f80$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
   * Determines whether to use the targeted configuration value or the default value
   * depending on whether the specified values match any of the target's rules.
   *
   * @param target the values to use to evaluate the config
   * @returns the {@link TargetingResult}, which would be the default value
   *     if the specified target did not match, or the targeted value if there
   *     was a match
   */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $a81d757bffb50f80$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $a81d757bffb50f80$var$TargetedConfig;
function $a81d757bffb50f80$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});

parcelRegister("h2xad", function(module, exports) {
class $c67c5938243bac5e$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $c67c5938243bac5e$export$1d76d155060824c9 = (e)=>e instanceof $c67c5938243bac5e$export$2e2bcd8739ae039;
module.exports["default"] = $c67c5938243bac5e$export$2e2bcd8739ae039;

});

parcelRegister("kvSko", function(module, exports) {
const $eef0d84a095af3e3$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};
module.exports["artifactKey"] = $eef0d84a095af3e3$export$e3553dc63541d477;

});

parcelRegister("5Wn20", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

function $45343c0ee8becd11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45343c0ee8becd11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45343c0ee8becd11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45343c0ee8becd11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $45343c0ee8becd11$export$1e3a41a51f6457c5 = ()=>new (0, $5aVN7.UFOExperience)("retrieve-artifact", {
        type: (0, $9NDUe.ExperienceTypes).Operation,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $45343c0ee8becd11$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $45343c0ee8becd11$var$_objectSpread($45343c0ee8becd11$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};
module.exports["flightDeckClientExperience"] = $45343c0ee8becd11$export$1e3a41a51f6457c5;
module.exports["exceptionToMetadata"] = $45343c0ee8becd11$export$f33622abb5224195;

});

parcelRegister("hwkRt", function(module, exports) {
/* Fetch the latest artifact via: atlas fd get-artifact recent-work-service */ const $1fd3741f1fad91b0$var$_default_1 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-viewed': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            clicked: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-clicked': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'status.value'
                ],
                statusScore: [
                    'status.score'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'state.value'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceWhiteboard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'whiteboardId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceDatabase: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'databaseId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/database.svg'
            }
        },
        ConfluenceEmbed: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'embedId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/embed.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'key'
                ],
                statusValue: [
                    'fieldsByIdOrAlias(fieldId: "status").status.name'
                ],
                statusColor: [
                    'fieldsByIdOrAlias(fieldId: "status").status.statusCategory.colorName'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        TrelloBoard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'boardName'
                ],
                url: [
                    'boardUrl'
                ],
                containers: [
                    'workspace.displayName'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/board.svg'
            }
        },
        TrelloCard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'cardName'
                ],
                url: [
                    'cardUrl'
                ],
                containers: [
                    'list.name',
                    'list.board.name'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/card.svg'
            }
        },
        DevOpsDocument: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ],
                icon: [
                    'type.iconUrl'
                ]
            }
        },
        DevOpsPullRequestDetails: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                url: [
                    'url'
                ],
                containers: [
                    'repositoryName'
                ],
                key: [
                    'providerName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg'
            }
        },
        DevOpsDesign: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/design.svg'
            }
        },
        ExternalDocument: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'type.category'
                ],
                key: [
                    'parent.displayName'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalRemoteLink: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'category'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        MercuryFocusArea: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'focusAreaType.name'
                ],
                icon: [
                    'icon.url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/focus-area.svg'
            }
        },
        MercuryPortfolio: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'label'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/view.svg'
            }
        },
        RadarPosition: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'worker.preferredName'
                ],
                url: [
                    'url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/talent/position.svg'
            }
        },
        RadarView: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'viewName'
                ],
                url: [
                    'url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/talent/view.svg'
            }
        },
        CompassComponent: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'typeMetadata.iconUrl'
                ],
                key: [
                    'typeMetadata.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/compass/logo.svg'
            }
        },
        BitbucketPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'pullRequestTitle'
                ],
                url: [
                    'href'
                ],
                key: [
                    'pullRequestTitle'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/bitbucket/logo.svg'
            }
        },
        LoomVideo: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'loomUrl'
                ],
                key: [
                    'owner.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/loom/logo.svg'
            }
        },
        AssetsObject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'label'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'avatar.url48'
                ],
                containers: [
                    'objectType.schema.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsObjectType: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsObjectTypeName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'assetsObjectTypeIcon.url48'
                ],
                containers: [
                    'schema.assetsSchemaName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsSchema: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsSchemaName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n    status {\n      value\n      score\n    }\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n    state {\n      value\n    }\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    subtype\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceWhiteboard on ConfluenceWhiteboard {\n    id\n    title\n    whiteboardId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceDatabase on ConfluenceDatabase {\n    id\n    title\n    databaseId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceEmbed on ConfluenceEmbed {\n    id\n    title\n    embedId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n  fieldsByIdOrAlias(idsOrAliases: ["status"]) @optIn(to: "JiraIssueFieldsByIdOrAlias") {\n    __typename\n    fieldId\n    ...jiraStatusField\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    name\n    avatar {\n      medium\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\nfragment jiraStatusField on JiraStatusField {\n  status {\n    name\n    statusCategory {\n      colorName\n    }\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment trelloBoard on TrelloBoard {\n  id\n  objectId\n  boardName: name\n  boardUrl: url\n  workspace {\n    id\n    displayName\n  }\n}\n\n\nfragment trelloCard on TrelloCard {\n  id\n  objectId\n  cardName: name\n  cardUrl: url\n  list {\n    id\n    name\n    board @optIn(to: "TrelloListBoard") {\n      id\n      name\n    }\n  }\n}\n\n\n        fragment graphDevOpsDocument on DevOpsDocument {\n          id\n          displayName\n          webUrl: url\n          type {\n            iconUrl\n          }\n        }\n    \n\n        fragment graphExternalDocument on ExternalDocument {\n            id\n            type {\n                category\n            }\n            displayName\n            parent @optIn(to: "ExternalDataDepotQueryV2"){\n                ...on ExternalDocument {\n                    displayName\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            thirdPartyId\n        }\n    \n\nfragment graphPullRequest on DevOpsPullRequestDetails {\n  id\n  title\n  url\n  repositoryName\n  providerName\n}\n\n\nfragment graphExternalPullRequest on ExternalPullRequest {\n  id\n  displayName\n  url\n  pullRequestStatus: status\n  provider {\n    providerId\n  }\n}\n\n\nfragment graphDesign on DevOpsDesign {\n  id\n  displayName\n  webUrl: url\n}\n\n\n        fragment graphExternalRemoteLink on ExternalRemoteLink {\n            id\n            displayName\n            category\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            thirdPartyId\n        }\n    \n\n    fragment mercuryFocusArea on MercuryFocusArea {\n        id\n        name\n        url\n        focusAreaType {\n            name\n        }\n        icon {\n            url\n        }\n    }\n    \n\n    fragment mercuryPortfolio on MercuryPortfolio {\n        id\n        name\n        url\n        label\n    }\n    \n\n    fragment radarPosition on RadarPosition {\n        id\n        worker {\n            preferredName\n        }\n        url\n    }\n    \n\n    fragment radarView on RadarView {\n        id\n        viewName\n        url\n    }\n    \n\nfragment compassComponent on CompassComponent {\n  id\n  name\n  url\n  typeMetadata {\n    iconUrl\n    name\n  }\n}\n\n\nfragment bitbucketPullRequest on BitbucketPullRequest {\n  id\n  pullRequestTitle: title\n  href\n  author {\n    picture\n  }\n}\n\n\nfragment loomVideo on LoomVideo {\n  id\n  name\n  loomUrl: url\n  owner {\n    name\n    picture\n  }\n}\n\n\n    fragment assetsObject on AssetsObject {\n      id\n      label\n      objectKey\n      links {\n        web\n      }\n      avatar {\n        url48\n      }\n      objectType {\n        name\n        schema {\n          name\n        }\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsObjectType on AssetsObjectType {\n      id\n      assetsObjectTypeName: name\n      links {\n        web\n      }\n      assetsObjectTypeIcon: icon {\n        url48\n      }\n      schema {\n        id\n        assetsSchemaName: name\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsSchema on AssetsSchema {\n      id\n      assetsSchemaKey: key\n      assetsSchemaName: name\n      links {\n        web\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceWhiteboard\n\t...confluenceDatabase\n\t...confluenceEmbed\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n\t...trelloBoard\n\t...trelloCard\n\t...graphDevOpsDocument\n\t...graphExternalDocument\n\t...graphPullRequest\n\t...graphExternalPullRequest\n\t...graphDesign\n\t...graphExternalRemoteLink\n\t...mercuryFocusArea\n\t...mercuryPortfolio\n\t...radarPosition\n\t...radarView\n\t...compassComponent\n\t...bitbucketPullRequest\n\t...loomVideo\n\t...assetsObject\n\t...assetsObjectType\n\t...assetsSchema\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};
var $1fd3741f1fad91b0$export$2e2bcd8739ae039 = $1fd3741f1fad91b0$var$_default_1;
module.exports["default"] = $1fd3741f1fad91b0$export$2e2bcd8739ae039;

});

parcelRegister("dB4CM", function(module, exports) {

var $42tRz = parcelRequire("42tRz");

const $ed61875d80ed744a$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $42tRz.default)
    ]
]);
const $ed61875d80ed744a$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $ed61875d80ed744a$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $ed61875d80ed744a$export$2e2bcd8739ae039 = $ed61875d80ed744a$var$graphQLErrorHandler;
module.exports["default"] = $ed61875d80ed744a$export$2e2bcd8739ae039;

});

parcelRegister("42tRz", function(module, exports) {
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $67eeec4a0df79f16$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $67eeec4a0df79f16$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $67eeec4a0df79f16$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $67eeec4a0df79f16$export$2e2bcd8739ae039 = $67eeec4a0df79f16$var$validationErrorHandler;
module.exports["default"] = $67eeec4a0df79f16$export$2e2bcd8739ae039;

});

parcelRegister("9t27K", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $tyUdU = parcelRequire("tyUdU");

const $54cb9195043b6c70$var$ACTIVITIES_LIMIT = 50;
const $54cb9195043b6c70$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $54cb9195043b6c70$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $54cb9195043b6c70$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $54cb9195043b6c70$var$activityQueryMap = new Map([
    [
        'workedOn',
        $54cb9195043b6c70$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $54cb9195043b6c70$var$VIEWED__QUERY
    ],
    [
        'all',
        $54cb9195043b6c70$var$ALL__QUERY
    ]
]);
const $54cb9195043b6c70$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $54cb9195043b6c70$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $9M6Bq.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $54cb9195043b6c70$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $54cb9195043b6c70$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$54cb9195043b6c70$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $54cb9195043b6c70$var$getActivitiesQuery(product, $54cb9195043b6c70$var$getMyActivitiesQuery(activityQueries.map((query)=>$54cb9195043b6c70$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $54cb9195043b6c70$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $54cb9195043b6c70$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $54cb9195043b6c70$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $9M6Bq.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};
module.exports["generateGraphQLRequest"] = $54cb9195043b6c70$export$7489a6ef09862e48;

});

parcelRegister("2OHoP", function(module, exports) {

var $fBDYu = parcelRequire("fBDYu");

function $f8c057548f88677e$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $f8c057548f88677e$var$rollUpActivityItems(all),
        viewed: $f8c057548f88677e$var$rollUpActivityItems(viewed),
        workedOn: $f8c057548f88677e$var$rollUpActivityItems(workedOn)
    };
}
function $f8c057548f88677e$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $f8c057548f88677e$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$f8c057548f88677e$var$fragmentName(key)} on ${$f8c057548f88677e$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $f8c057548f88677e$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $f8c057548f88677e$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $f8c057548f88677e$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $f8c057548f88677e$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $f8c057548f88677e$var$containerMapTypes = new Map([
    [
        $f8c057548f88677e$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $f8c057548f88677e$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $f8c057548f88677e$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $f8c057548f88677e$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $f8c057548f88677e$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $f8c057548f88677e$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$f8c057548f88677e$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($f8c057548f88677e$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $f8c057548f88677e$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $f8c057548f88677e$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$f8c057548f88677e$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $f8c057548f88677e$export$884573c560ed3600(response.data);
}
function $f8c057548f88677e$export$884573c560ed3600(queryData) {
    return !queryData.activity || $f8c057548f88677e$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $f8c057548f88677e$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}
function $f8c057548f88677e$export$618af76292d5645c(object) {
    const ari = object.id;
    let product = 'graph';
    if (ari.startsWith('ari:cloud:graph::pull-request') && object.data?.providerName) product = object.data?.providerName || 'graph';
    else if ((0, $fBDYu.isThirdPartyARI)(ari)) product = (0, $fBDYu.parseThirdPartyProduct)(ari).split('.')[1];
    return product.toLowerCase();
}
module.exports["rollupActivitiesData"] = $f8c057548f88677e$export$750d93207e30f59a;
module.exports["activityRoot"] = $f8c057548f88677e$export$ea55e8e0446efa94;
module.exports["parseRootContainerARI"] = $f8c057548f88677e$export$788e6013936a6bb4;
module.exports["filtersToMetadata"] = $f8c057548f88677e$export$e8f56bed6776c7ea;
module.exports["filterInvalidFragments"] = $f8c057548f88677e$export$e22863ec502608d2;
module.exports["isEmptyActivitiesWithErrorsResponse"] = $f8c057548f88677e$export$c939d6148e47244a;
module.exports["getThirdPartyGraphProvider"] = $f8c057548f88677e$export$618af76292d5645c;

});

parcelRegister("fBDYu", function(module, exports) {
const $3421cba56261eeed$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $3421cba56261eeed$export$4578ef3572b21f34 = (ari)=>{
    const result = $3421cba56261eeed$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$3421cba56261eeed$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $3421cba56261eeed$export$fccbae65febb6fd4 = (ari)=>$3421cba56261eeed$var$thirdPartyRegex.test(ari);
module.exports["parseThirdPartyProduct"] = $3421cba56261eeed$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $3421cba56261eeed$export$fccbae65febb6fd4;

});

parcelRegister("2S07V", function(module, exports) {
class $73d177391dbdc800$export$16bbef74695765fd extends Error {
    constructor(message, status){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        this.status = void 0;
        Object.setPrototypeOf(this, $73d177391dbdc800$export$16bbef74695765fd.prototype);
        this.status = status;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
module.exports["ActivityError"] = $73d177391dbdc800$export$16bbef74695765fd;

});

parcelRegister("9EvUR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dJyLC = parcelRequire("dJyLC");

function $9c03756095734add$export$e412939fa65e9b05({ contentId: contentId, spaceKey: spaceKey, source: source }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useMemo)(()=>Promise.resolve((0, $dJyLC.createConfluenceAutoformattingProvider)(spaceKey, contentId, createAnalyticsEvent, source)), [
        contentId,
        createAnalyticsEvent,
        spaceKey,
        source
    ]);
}
module.exports["useAutoformattingProvider"] = $9c03756095734add$export$e412939fa65e9b05;

});

parcelRegister("dJyLC", function(module, exports) {
const $80210b0d46d06b49$var$_isBlankOrEmpty = (str)=>!str || /^\s*$/.test(str);
const $80210b0d46d06b49$var$_sendAnalyticsEvent = (site, contentId, action, reason, createAnalyticsEvent, caller)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'autoformat',
            actionSubjectId: 'undefinedLink autoformat',
            source: 'AutoformattingProvider',
            attributes: {
                site: site,
                contentId: contentId,
                reason: reason,
                caller: caller
            }
        }
    }).fire();
};
const $80210b0d46d06b49$export$79f57d12dd4f5b6b = (spaceKey, contentId, createAnalyticsEvent, caller)=>({
        '\\[(.*?)\\]\\(\\)': (match)=>{
            // If testing locally, you will need to set 'site' to an actual server such as "https://pug.jira-dev.com". Smart cards don't work with "localhost:8080".
            const site = location.origin;
            const title = match[1];
            if ($80210b0d46d06b49$var$_isBlankOrEmpty(title)) {
                $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'failed', 'empty title', createAnalyticsEvent, caller);
                return Promise.resolve({
                    type: ''
                });
            }
            if (!site || !spaceKey || !contentId) {
                $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'failed', 'missing site name, spaceKey or contentId', createAnalyticsEvent, caller);
                return Promise.resolve({
                    type: ''
                });
            }
            const encodedTitle = encodeURIComponent(title);
            const url = `${site}/wiki/pages/createpage.action?spaceKey=${spaceKey}&title=${encodedTitle}&linkCreation=true&fromPageId=${contentId}`;
            $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'success', 'autoformat succeeded', createAnalyticsEvent, caller);
            return Promise.resolve({
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            });
        }
    });
const $80210b0d46d06b49$export$56f76dd14b7b11cc = (spaceKey, contentId, createAnalyticsEvent, caller)=>({
        getRules: ()=>Promise.resolve({
                ...$80210b0d46d06b49$export$79f57d12dd4f5b6b(spaceKey, contentId, createAnalyticsEvent, caller)
            })
    });
module.exports["createConfluenceAutoformattingProvider"] = $80210b0d46d06b49$export$56f76dd14b7b11cc;

});

parcelRegister("1NbQn", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $53f32890288a0cee$export$72a52078406bf49d({ isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, editorActions: editorActions, editorType: editorType, initialShouldFocusEditor: initialShouldFocusEditor = true }) {
    // TODO: replace some of these arbitrary state values from graphQL query
    /**
	 * @todo CTE-268 typing in title is slow with in-editor templates (long term solution)
	 * For now, we are solving this by debouncing calls to the onTitleChange function inside EditorTitle
	 * Debouncing has some drawbacks for collaborators, so we only want this optimization when
	 * the template panel could be open
	 */ const debounceTitleChangeUpdates = isUnpublishedDraft && contentType === 'page';
    const isTemplateEditor = editorType === 'template';
    const [isTitleFocused, setIsTitleFocused] = (0, $42omo.useState)(null);
    const [shouldFocusEditor, setShouldFocusEditor] = (0, $42omo.useState)(initialShouldFocusEditor);
    // This function is only called when "tab" or "enter" is pressed when focused in the title
    const focusEditor = (0, $42omo.useCallback)(()=>{
        setIsTitleFocused(false);
        setShouldFocusEditor(true);
    }, []);
    const onFocusChanged = (0, $42omo.useCallback)((_isTitleFocused)=>{
        setIsTitleFocused(_isTitleFocused);
        // we disable editor when title is focused
        // re-enabling editor leads to force focus set on it
        // this leads to focus bugs when clicking on other inputs
        // so we explicitly disable editor focus here
        setShouldFocusEditor(false);
    }, []);
    (0, $42omo.useEffect)(()=>{
        // focus editor ONLY when forced to.
        // Losing title focus should NOT require forcing an editor focus
        // (in the case of backtabbing or clicking on a different button)
        // TODO: CTE-2423 remove editorType check once Confluence adopts editor version Rambo (with media focus bug fix)
        if (!isTitleFocused && shouldFocusEditor && !isTemplateEditor) editorActions.focus({
            scrollIntoView: false
        });
    }, [
        editorActions,
        isTitleFocused,
        shouldFocusEditor,
        isTemplateEditor
    ]);
    return (0, $42omo.useMemo)(()=>({
            isTitleFocused: isTitleFocused,
            shouldFocusEditor: shouldFocusEditor,
            debounceTitleChangeUpdates: debounceTitleChangeUpdates,
            focusEditor: focusEditor,
            onFocusChanged: onFocusChanged
        }), [
        isTitleFocused,
        shouldFocusEditor,
        debounceTitleChangeUpdates,
        focusEditor,
        onFocusChanged
    ]);
}
module.exports["useEditorTitleFocus"] = $53f32890288a0cee$export$72a52078406bf49d;

});

parcelRegister("nIvaQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fXb84 = parcelRequire("fXb84");


var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $6mKj3.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true) ? (0, $fXb84.CollabDraftWithRelevanceQuery) : (0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("fXb84", function(module, exports) {

var $kiLxw = parcelRequire("kiLxw");

const $abbff5e8c5475947$export$fb92c84fb9714700 = (0, $kiLxw.default);
module.exports["CollabDraftWithRelevanceQuery"] = $abbff5e8c5475947$export$fb92c84fb9714700;

});

parcelRegister("kiLxw", function(module, exports) {
/**
 * @generated SignedSource<<ed1da0f487d4ec7fd1c400d04bb2ada3>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1
const $ff1e82bf0b897703$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relevance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
            "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
            "metadata": {},
            "name": "CollabDraftWithRelevanceQuery",
            "operationKind": "query",
            "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
        }
    };
}();
$ff1e82bf0b897703$var$node.hash = "c0bfcca7b64103265224238d7c18d9b1";
var $ff1e82bf0b897703$export$2e2bcd8739ae039 = $ff1e82bf0b897703$var$node;
module.exports["default"] = $ff1e82bf0b897703$export$2e2bcd8739ae039;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<00faa284694db21a3e13849cb62f2bdf>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("fqIt3", function(module, exports) {
const $3014a7cdda499b2d$var$collabDraftFetchTimestamps = new Map();
// TTL for CollabDraftQuery cached data
// This prevents stale data during SPA transitions while still allowing
// cache-first for SSR-rendered pages within the TTL window
const $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS = 15000;
/**
 * Creates a composite cache key that includes both contentId and draftShareId.
 * This aligns with how Apollo caches queries by their variables.
 */ const $3014a7cdda499b2d$var$getCacheKey = (contentId, draftShareId)=>{
    return `${contentId}:${draftShareId || ''}`;
};
function $3014a7cdda499b2d$export$76901333d647261(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    const lastFetchTime = $3014a7cdda499b2d$var$collabDraftFetchTimestamps.get(key);
    if (!lastFetchTime) return true;
    return Date.now() - lastFetchTime > $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS;
}
function $3014a7cdda499b2d$export$85437e97168f99bc(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.set(key, Date.now());
}
function $3014a7cdda499b2d$export$5f725cb33e7218ab(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.delete(key);
}
function $3014a7cdda499b2d$export$a379bfa68f31645e() {
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.clear();
}
module.exports["isCollabDraftCacheStale"] = $3014a7cdda499b2d$export$76901333d647261;
module.exports["markCollabDraftFetched"] = $3014a7cdda499b2d$export$85437e97168f99bc;
module.exports["clearCollabDraftTimestamp"] = $3014a7cdda499b2d$export$5f725cb33e7218ab;

});

parcelRegister("lvOsp", function(module, exports) {

var $jxs8y = parcelRequire("jxs8y");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");

function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    if ((0, $iffSy.isRelayEnabled)()) throw new Error('[Relay migration] Method not implemented yet');
    else {
        if (!(0, $9wGTI.fg)('cc-fd-lazy-query-interop-agg')) return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), options);
        const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
        return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
            ...apolloOptions,
            ...interopApolloAggClient ? {
                client: window['GLOBAL_APOLLO_AGG_CLIENT']
            } : {},
            context: {
                ...apolloOptions?.context,
                requestId: query.params?.id
            }
        });
    }
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("bjxK7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $bQm3c = parcelRequire("bQm3c");


var $2vVvv = parcelRequire("2vVvv");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $cLo2u = parcelRequire("cLo2u");


var $e2Vf0 = parcelRequire("e2Vf0");


var $6mKj3 = parcelRequire("6mKj3");

const $8ad336116c673b49$export$74fedad14355d824 = ({ contentId: contentId, contentType: contentType, editorAPI: editorAPI, flags: flags, viewMode: viewMode, mediaViewerExtensions: mediaViewerExtensions })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    const { isExternalShareRequest: isExternalShare } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const ssrMediaConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey ?? undefined,
        isExternalShare: isExternalShare
    });
    const resolver = (0, $42omo.useRef)();
    // Store a stable Promise that will be resolved once when mediaProvider is created
    // This avoids race conditions when ssrMediaProvider changes after the effect has run
    const mediaProviderPromiseRef = (0, $42omo.useRef)();
    if (!mediaProviderPromiseRef.current && (0, $6mKj3.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) mediaProviderPromiseRef.current = new Promise((resolve)=>{
        resolver.current = resolve;
    });
    // Keep most recent option values so dynamic provider getters don't close over stale ones
    const latestParamsRef = (0, $42omo.useRef)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShare,
        contentType: contentType,
        viewMode: viewMode
    });
    latestParamsRef.current = {
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShare,
        contentType: contentType,
        viewMode: viewMode
    };
    const showAttachmentLimitReachedFlag = (0, $42omo.useCallback)((data)=>{
        if (flags && data) flags.showErrorFlag((0, $2vVvv.getAttachmentSizeLimitErrorFlag)(data, intl)).then(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'nextEditorAttachmentTooLargeFlag'
                }
            }).fire();
        });
        return !!data;
    }, [
        flags,
        intl,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        const createMediaProvider = ()=>{
            if (viewMode) return (0, $dh538.fg)('confluence_frontend_transition_preloading_system') ? (0, $4IoVL.createRendererMediaProviderDynamic)(()=>({
                    contentId: latestParamsRef.current.contentId,
                    spaceKey: latestParamsRef.current.spaceKey,
                    isExternalShare: latestParamsRef.current.isExternalShare
                })) : (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare
            });
            if (contentType) return (0, $dh538.fg)('confluence_frontend_transition_preloading_system') ? (0, $4IoVL.createEditorMediaProviderDynamic)(()=>({
                    contentId: latestParamsRef.current.contentId,
                    spaceKey: latestParamsRef.current.spaceKey,
                    contentType: latestParamsRef.current.contentType,
                    isExternalShare: latestParamsRef.current.isExternalShare,
                    // Passing undefined will allow us to use the default atlaskit size limit error behavior
                    onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
                })) : (0, $4IoVL.createEditorMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                isExternalShare: isExternalShare,
                // Passing undefined will allow us to use the default atlaskit size limit error behavior
                onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
            });
        };
        const mediaProvider = createMediaProvider();
        if (mediaProvider) {
            editorAPI?.media?.actions.setProvider(mediaProvider);
            if (resolver.current) resolver.current(mediaProvider);
        }
    }, [
        contentId,
        contentType,
        spaceKey,
        isExternalShare,
        viewMode,
        flags,
        showAttachmentLimitReachedFlag,
        featureFlags,
        editorAPI
    ]);
    const ssrMediaProvider = (0, $42omo.useMemo)(()=>{
        if ((0, $6mKj3.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) {
            if (!ssrMediaConfig) return undefined;
            return {
                viewMediaClientConfig: ssrMediaConfig.config
            };
        }
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMediaConfig;
        return undefined;
        return {
            viewMediaClientConfig: ssrMediaConfig.config
        };
    }, [
        ssrMediaConfig
    ]);
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
    return (0, $42omo.useMemo)(()=>(0, $e2Vf0.getMediaOptions)({
            mediaProvider: (0, $6mKj3.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) ? mediaProviderPromiseRef.current : new Promise((resolve)=>resolver.current = resolve),
            ssrMediaProvider: ssrMediaProvider,
            intl: intl,
            featureFlags: featureFlags,
            mediaViewerExtensions: mediaViewerExtensions
        }), [
        intl,
        featureFlags,
        ssrMediaProvider,
        mediaViewerExtensions
    ]);
};
module.exports["useMediaOptions"] = $8ad336116c673b49$export$74fedad14355d824;

});

parcelRegister("2vVvv", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $57725dc45b51a081$var$attachmentSizeErrorFlagI18n = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "fabric-media-support.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    }
});
const $57725dc45b51a081$var$sizeLimitLearnMoreLink = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
const $57725dc45b51a081$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    const k = 1024;
    const decimals = 2;
    const units = [
        'bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    let maxIndex = units.length - 1;
    let exponent = Math.floor(Math.log(bytes) / Math.log(k));
    if (maxMagnitude && maxMagnitude < maxIndex) maxIndex = maxMagnitude;
    exponent = exponent > maxIndex ? maxIndex : exponent;
    return `${parseFloat((bytes / Math.pow(k, exponent)).toFixed(decimals))} ${units[exponent]}`;
};
const $57725dc45b51a081$export$1c61cf0ed486df46 = (data, intl)=>{
    if (data.reason === 'fileSizeLimitExceeded') return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorDescription, {
            size: $57725dc45b51a081$export$f2d538a5633fea72(data.limit)
        }),
        actions: [
            {
                content: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.learnMore),
                onClick: ()=>{
                    window.open($57725dc45b51a081$var$sizeLimitLearnMoreLink, '_blank');
                }
            }
        ]
    };
    else return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorDescription)
    };
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $57725dc45b51a081$export$1c61cf0ed486df46;

});

parcelRegister("iP9x4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $5yfLD = parcelRequire("5yfLD");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        }
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentAri: contentAri, contentId: contentId, contentProduct: contentProduct, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && (!!spaceKey || contentProduct === 'jira-work-item')) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        }
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$export$85decadf1b9d641b = (0, $2XqLN.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($5yfLD))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$export$85decadf1b9d641b(config);
};
module.exports["getMediaSSRModeAndAuthConfigMemoized"] = $2c59df77bd212c3d$export$85decadf1b9d641b;
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("4IoVL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $eGqQQ = parcelRequire("eGqQQ");


var $3aeMC = parcelRequire("3aeMC");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $2TuWI = parcelRequire("2TuWI");


var $cga1x = parcelRequire("cga1x");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $I0A3i = parcelRequire("I0A3i");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, contentAri: contentAri, contentProduct: contentProduct, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $3aeMC.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    }) && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false) && (0, $9wGTI.fg)('platform_synced_block_cross_product_auth')) return (0, $3aeMC.fetchTokenForSourceProduct)({
        contentAri: contentAri ?? contentId,
        contentId: contentId,
        sourceProduct: contentProduct
    });
    if (isExternalShare && shareToken && (0, $6mKj3.expValEquals)('add_anonid_in_media_token', 'cohort', 'test')) {
        const tokenResponse = await (0, $I0A3i.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $I0A3i.fetchExternalShareMediaToken) : (0, $I0A3i.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async ()=>{
        const data = await dataGetter();
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter());
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$6cb774192b5cd093 = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {} // not JSON or not a SnippetContextId.
};
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId, contentProduct, contentAri)=>{
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $3aeMC.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    }) && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false) && (0, $9wGTI.fg)('platform_synced_block_cross_product_auth')) {
        const auth = await (0, $3aeMC.fetchTokenForSourceProduct)({
            contentAri: contentAri ?? contextId,
            contentId: contextId,
            sourceProduct: contentProduct
        });
        return {
            clientId: auth.config.clientId || '',
            token: auth.token || '',
            baseUrl: auth.config.fileStoreUrl || ''
        };
    }
    if ((0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) {
        const snippetContext = $17b0f8a5b73de479$export$6cb774192b5cd093(contextId);
        if (snippetContext && snippetContext.scope !== (0, $cga1x.SnippetScope).GLOBAL) {
            const auth = await (0, $2TuWI.fetchSnippetMediaToken)(snippetContext.snippetId);
            return {
                clientId: auth.clientId,
                token: auth.token,
                baseUrl: auth.baseUrl
            };
        }
    }
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $I0A3i.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? await (0, $I0A3i.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $I0A3i.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $I0A3i.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    if (!(0, $9wGTI.fg)('dlp_allow_content_dsp_check_without_space_details')) {
        // Note: If you can't provide spaceKey, you can't enable downloads in media viewer
        if (!spaceKey) return true;
    }
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch  {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async ()=>{
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: options.contentId,
            contentAri: options.contentAri,
            contentProduct: options.contentProduct,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $eGqQQ.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $eGqQQ.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    // We deliberately do NOT register the global listener dynamically each token fetch.
    // Instead we register once per provider creation with the then-current options snapshot.
    // If you need the listener to react to changed options, recreate the provider instead.
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadMediaClientConfig(opts);
        })(),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadCollectionId(opts);
        })()
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: initialOptions.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("3aeMC", function(module, exports) {

var $haHYm = parcelRequire("haHYm");


var $hceZu = parcelRequire("hceZu");

const $6a7b95e6b4c9360c$export$8953ee4427cc19a2 = ({ hostProduct: hostProduct, sourceProduct: sourceProduct })=>{
    return !!sourceProduct && sourceProduct !== hostProduct;
};
const $6a7b95e6b4c9360c$export$9f88fc74c33fbfe = ({ contentAri: contentAri, contentId: contentId, sourceProduct: sourceProduct })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return (0, $haHYm.fetchMediaToken)(contentId);
        case 'jira-work-item':
            return (0, $hceZu.fetchJiraMediaToken)(contentAri);
        default:
            throw new Error(`Unsupported source product for token fetch: ${sourceProduct}`);
    }
};
module.exports["requiresCrossProductAuth"] = $6a7b95e6b4c9360c$export$8953ee4427cc19a2;
module.exports["fetchTokenForSourceProduct"] = $6a7b95e6b4c9360c$export$9f88fc74c33fbfe;

});

parcelRegister("haHYm", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $k2in1 = parcelRequire("k2in1");

const $ef717af67d2dc416$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $ef717af67d2dc416$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $ef717af67d2dc416$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME = 'MediaUploadTokenQuery';
const $ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_QUERY = `query ${$ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME}($contentId: ID!) {
	contentMediaSession(contentId: $contentId) {
		token {
			value
		}
		configuration {
			clientId
			fileStoreUrl
		}
		collection
	}
}`;
const $ef717af67d2dc416$var$getContentMediaSession = async (contentId)=>{
    const bodyData = {
        query: $ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_QUERY,
        operationName: $ef717af67d2dc416$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME,
        variables: {
            contentId: contentId
        }
    };
    const response = await (0, $k2in1.fetchWithRetry)($ef717af67d2dc416$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$ef717af67d2dc416$var$COMMON_HEADERS,
            ...$ef717af67d2dc416$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get content media session: ${response.statusText}`);
    const result = await response.json();
    return result;
};
const $ef717af67d2dc416$export$2b7fb70f168591f8 = async (contentId)=>{
    try {
        const response = await $ef717af67d2dc416$var$getContentMediaSession(contentId);
        const contentData = response.data?.contentMediaSession;
        const token = contentData?.token?.value;
        const configuration = contentData?.configuration;
        const collection = contentData?.collection;
        if (!token || !configuration || !collection) throw new Error('Failed to get content media session data');
        return {
            config: configuration,
            token: token,
            collectionId: collection
        };
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-synced-block-provider/fetchMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get content media session: ${errorMsg}`);
    }
};
module.exports["fetchMediaToken"] = $ef717af67d2dc416$export$2b7fb70f168591f8;

});

parcelRegister("k2in1", function(module, exports) {
const $70107457754d8ab2$var$MAX_RETRY_DELAY = 30000;
const $70107457754d8ab2$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $70107457754d8ab2$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $70107457754d8ab2$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $70107457754d8ab2$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $70107457754d8ab2$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $70107457754d8ab2$export$cffaac380b94df26;

});

parcelRegister("hceZu", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $k2in1 = parcelRequire("k2in1");

const $4613ccfbf32aa608$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $4613ccfbf32aa608$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $4613ccfbf32aa608$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $4613ccfbf32aa608$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH = 2048;
const $4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_JIRA_MEDIA_TOKEN';
const $4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY = `query ${$4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME}($issueAri: ID!, $maxTokenLength: Int!) {
  jira {
    issueById(id: $issueAri) {
      mediaReadToken(maxTokenLength: $maxTokenLength) @optIn(to: "JiraMediaReadTokenInIssue") {
        clientId
        endpointUrl
        tokenLifespanInSeconds
        tokensWithFiles {
          edges {
            node {
              token
            }
          }
        }
      }
    }
  }
}`;
const $4613ccfbf32aa608$var$getJiraMediaReadToken = async (issueAri)=>{
    const bodyData = {
        query: $4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY,
        operationName: $4613ccfbf32aa608$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME,
        variables: {
            issueAri: issueAri,
            maxTokenLength: $4613ccfbf32aa608$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH
        }
    };
    const response = await (0, $k2in1.fetchWithRetry)($4613ccfbf32aa608$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$4613ccfbf32aa608$var$COMMON_HEADERS,
            ...$4613ccfbf32aa608$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get Jira media read token: ${response.statusText}`);
    return await response.json();
};
const $4613ccfbf32aa608$export$5bc7dcc953e26849 = async (issueAri)=>{
    try {
        const response = await $4613ccfbf32aa608$var$getJiraMediaReadToken(issueAri);
        const mediaReadToken = response.data?.jira?.issueById?.mediaReadToken;
        const clientId = mediaReadToken?.clientId;
        const endpointUrl = mediaReadToken?.endpointUrl;
        // Use the first available token from tokensWithFiles, or fall back to empty string.
        // A generic read token (without specific file IDs) is sufficient for rendering.
        const token = mediaReadToken?.tokensWithFiles?.edges?.[0]?.node?.token ?? '';
        if (!clientId || !endpointUrl) throw new Error('Missing clientId or endpointUrl');
        return {
            config: {
                clientId: clientId,
                fileStoreUrl: endpointUrl
            },
            token: token
        };
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-synced-block-provider/fetchJiraMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get Jira media read token: ${errorMsg}`);
    }
};
module.exports["fetchJiraMediaToken"] = $4613ccfbf32aa608$export$5bc7dcc953e26849;

});

parcelRegister("2TuWI", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';
const $15f98e0699368f56$export$73c71f9590626082 = async (snippetId)=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${$15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const collectionId = data.collectionNames?.[snippetId];
        return {
            clientId: data.config.clientId,
            token: data.token,
            baseUrl: data.config.fileStoreUrl,
            ...collectionId !== undefined && {
                collectionId: collectionId
            }
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        throw error;
    }
};
module.exports["fetchSnippetMediaToken"] = $15f98e0699368f56$export$73c71f9590626082;

});

parcelRegister("kzNtP", function(module, exports) {

var $9ILXP = parcelRequire("9ILXP");


var $a4TK8 = parcelRequire("a4TK8");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $9ILXP.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $6UhpO = parcelRequire("6UhpO");


var $23pnW = parcelRequire("23pnW");


var $c0rhi = parcelRequire("c0rhi");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $6UhpO.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only'
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $23pnW.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache'
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("6UhpO", function(module, exports) {
/**
 * @generated SignedSource<<afde12195035fc9524b5ea370ff6202a>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1
const $ba0dcc1d393f4102$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "downloadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "7da80c4186ab379cb41cda405bebee65",
            "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
            "metadata": {},
            "name": "TemplateMediaSessionDownloadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
        }
    };
}();
$ba0dcc1d393f4102$var$node.hash = "cb69ec0c674b12c3415c2289771f970f";
var $ba0dcc1d393f4102$export$2e2bcd8739ae039 = $ba0dcc1d393f4102$var$node;
module.exports["default"] = $ba0dcc1d393f4102$export$2e2bcd8739ae039;

});

parcelRegister("23pnW", function(module, exports) {
/**
 * @generated SignedSource<<ddd0c2456e449fb97d066cca25b52275>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059
const $d22835c5674bcb0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "uploadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
            "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
            "metadata": {},
            "name": "TemplateMediaSessionUploadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
        }
    };
}();
$d22835c5674bcb0e$var$node.hash = "1d0108dcbf48addfcc8b1c4145c7178d";
var $d22835c5674bcb0e$export$2e2bcd8739ae039 = $d22835c5674bcb0e$var$node;
module.exports["default"] = $d22835c5674bcb0e$export$2e2bcd8739ae039;

});

parcelRegister("I0A3i", function(module, exports) {

var $iTcHJ = parcelRequire("iTcHJ");


var $bS81H = parcelRequire("bS81H");


var $5d9b4 = parcelRequire("5d9b4");


var $9ILXP = parcelRequire("9ILXP");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");


var $lUobS = parcelRequire("lUobS");


var $62FVQ = parcelRequire("62FVQ");


var $6mmMU = parcelRequire("6mmMU");


var $egLSs = parcelRequire("egLSs");


var $dqLCu = parcelRequire("dqLCu");

const $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery = (0, $bS81H.default);
const $1fd47ba2b01e31e6$var$FetchMediaTokenQuery = (0, $iTcHJ.default);
let $1fd47ba2b01e31e6$var$isFirstLoad = true;
const $1fd47ba2b01e31e6$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment' && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint')) // Hard disable drag-and-drop upload functionality for comments
    return;
    // Use regular mutation for normal uploads (file browser, copy-paste, etc.)
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $1fd47ba2b01e31e6$export$2b7fb70f168591f8 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$FetchMediaTokenQuery,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoad ? 'cache-first' : 'network-only'
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoad = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(value?.errors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((_cacheKey)=>{
    /**
   * The errors that happened last time. The `GraphQLError` instances are big
   * and are not trivial to compare so `prevErrors` caches partial info.
   */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
       * The new/current errors which will become `prevErrors` at the end of
       * this iteration.
       */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $1fd47ba2b01e31e6$export$e5e77dc812ab6e52 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $lUobS.default),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only'
    });
const $1fd47ba2b01e31e6$export$db4c125247d46dd = (shareToken)=>(0, $c0rhi.queryInterop)({
        query: (0, $dqLCu.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only'
    });
const $1fd47ba2b01e31e6$export$2b96f2ad626f63d2 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache'
    });
const $1fd47ba2b01e31e6$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $1fd47ba2b01e31e6$export$2b96f2ad626f63d2(contentId);
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $62FVQ.default),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
};
const $1fd47ba2b01e31e6$export$4205291ac54c446e = async (contentId, cloudId)=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $6mmMU.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $6mmMU.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
};
const $1fd47ba2b01e31e6$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    const action = (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
    const variables = {
        action: action,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        ...spaceKey && {
            spaceKey: spaceKey
        }
    };
    /* Note -> relay compatible query replacement available, in @confluence/data-security package.
   * Using queryInterop for compatibility with Relay migration
   */ return (0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery,
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first'
    });
};
module.exports["setAttachment"] = $1fd47ba2b01e31e6$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $1fd47ba2b01e31e6$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $1fd47ba2b01e31e6$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $1fd47ba2b01e31e6$export$db4c125247d46dd;
module.exports["getUploadToken"] = $1fd47ba2b01e31e6$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $1fd47ba2b01e31e6$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $1fd47ba2b01e31e6$export$4777fc7c5d601381;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<ad7f8916cadafdf5756ee8bd1ad40682>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("bS81H", function(module, exports) {
/**
 * @generated SignedSource<<e48b7b9ea45c35fb1578fdd724edbbc1>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8
const $5a2ebb253ede159a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "611f36fd3ab140915814f503f8503110",
            "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
            "metadata": {},
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$5a2ebb253ede159a$var$node.hash = "c488c053b9896d7e6d5b6c4474dd396b";
var $5a2ebb253ede159a$export$2e2bcd8739ae039 = $5a2ebb253ede159a$var$node;
module.exports["default"] = $5a2ebb253ede159a$export$2e2bcd8739ae039;

});

parcelRegister("lUobS", function(module, exports) {
/**
 * @generated SignedSource<<8dfdd8a5a875a39c8a51a64564f5341f>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e
const $2624e38a54eebf0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea7172d4f00c5846ec23ab207abff057",
            "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
            "metadata": {},
            "name": "ExternalShareMediaDownloadTokenQuery",
            "operationKind": "query",
            "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$2624e38a54eebf0f$var$node.hash = "3592e1b2dcd3aa2c38a177d9b363dafe";
var $2624e38a54eebf0f$export$2e2bcd8739ae039 = $2624e38a54eebf0f$var$node;
module.exports["default"] = $2624e38a54eebf0f$export$2e2bcd8739ae039;

});

parcelRegister("62FVQ", function(module, exports) {
/**
 * @generated SignedSource<<b8eac4f78d040ec0ffd5cdc9ff2556f4>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c
const $15e95f80a91466f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
            "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
            "metadata": {},
            "name": "MediaUploadTokenQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$15e95f80a91466f9$var$node.hash = "1f89a4aaada59e040e6317ae1cdc704c";
var $15e95f80a91466f9$export$2e2bcd8739ae039 = $15e95f80a91466f9$var$node;
module.exports["default"] = $15e95f80a91466f9$export$2e2bcd8739ae039;

});

parcelRegister("6mmMU", function(module, exports) {
/**
 * @generated SignedSource<<d69e882a22ed693fa50af2811b78fba2>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37
const $39c17bb60e74ced3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "alias": "contentMediaSession",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "confluence_commentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c06482aa2ab100620d21019ae889668d",
            "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
            "metadata": {},
            "name": "MediaUploadTokenQueryCommentQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$39c17bb60e74ced3$var$node.hash = "ecbc3538cd4e4434bac2e03ab7969cd8";
var $39c17bb60e74ced3$export$2e2bcd8739ae039 = $39c17bb60e74ced3$var$node;
module.exports["default"] = $39c17bb60e74ced3$export$2e2bcd8739ae039;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $lMdlY = parcelRequire("lMdlY");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, null, null, null, originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("dqLCu", function(module, exports) {
/**
 * @generated SignedSource<<eece35aa07385d739e1f6212cf239b97>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255
const $b85e553ccc70de04$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
            "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
            "metadata": {},
            "name": "ExternalContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
        }
    };
}();
$b85e553ccc70de04$var$node.hash = "73d645a33a55cbb7625d57b6d5cf2a1a";
var $b85e553ccc70de04$export$2e2bcd8739ae039 = $b85e553ccc70de04$var$node;
module.exports["default"] = $b85e553ccc70de04$export$2e2bcd8739ae039;

});

parcelRegister("kQiXs", function(module, exports) {

var $I0A3i = parcelRequire("I0A3i");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $I0A3i.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isShareableLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("e2Vf0", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $2XqLN = parcelRequire("2XqLN");


var $kBU5m = parcelRequire("kBU5m");

const $ec33dccf9bb2dcb4$var$i18n = (0, $aXWIB.defineMessages)({
    invalidAltText: {
        id: "editor-features.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});
const $ec33dccf9bb2dcb4$export$cbb71ca960bf2b80 = (0, $2XqLN.default)(({ mediaProvider: mediaProvider, ssrMediaProvider: ssrMediaProvider, intl: intl, featureFlags: featureFlags, mediaViewerExtensions: mediaViewerExtensions })=>{
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
    return {
        provider: mediaProvider,
        syncProvider: ssrMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage($ec33dccf9bb2dcb4$var$i18n.invalidAltText)
            ];
            return [];
        },
        featureFlags: (0, $kBU5m.getMediaFeatureFlags)(featureFlags),
        mediaViewerExtensions: mediaViewerExtensions
    };
});
module.exports["getMediaOptions"] = $ec33dccf9bb2dcb4$export$cbb71ca960bf2b80;

});

parcelRegister("kBU5m", function(module, exports) {
// featureFlags should come from getSessionData in @confluence/session-data
// IMPORTANT: If you change the code below, please also update the
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
function $d887a76516ca8f8c$export$88f94a4dc797781a(featureFlags) {
    return featureFlags ? {
        mediaInline: true
    } : {};
}
module.exports["getMediaFeatureFlags"] = $d887a76516ca8f8c$export$88f94a4dc797781a;

});

parcelRegister("hfIjM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $jubk3 = parcelRequire("jubk3");

var $fN9wG = parcelRequire("fN9wG");


var $hSHWm = parcelRequire("hSHWm");


var $koZ31 = parcelRequire("koZ31");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $ew8wg = parcelRequire("ew8wg");


var $5UhfH = parcelRequire("5UhfH");

function $cb04a18914327c7b$export$601d5e9e674a7c4a(spaceId, withAnalyticsEventProps, focusedMentionId) {
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    const { isEligibleXProductUserInvite: isEligibleXProductUserInvite, onXProductUserInviteClick: onXProductUserInviteClick } = (0, $42omo.useContext)((0, $fN9wG.XProductUserInviteContext)); // check if user is eligible for XProductUserInvite
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { title: pageTitle } = (0, $ew8wg.usePageTitle)({
        contentId: contentId || ''
    });
    const spaceIdPromise = (0, $5UhfH.useSpaceIdPromise)(spaceId);
    return (0, $42omo.useMemo)(()=>{
        const onInviteItemClick = ()=>{
            openCoreInvites?.((0, $koZ31.CoreInvitesSource).MENTION, undefined, [], pageTitle ? {
                pageTitle: pageTitle
            } : undefined);
        };
        return spaceIdPromise.then((resolvedSpaceId)=>{
            return (0, $jubk3.createFabricMentionResource)(cloudId, resolvedSpaceId, userId, withAnalyticsEventProps, (0, $9wGTI.fg)('twcg-1239-contextual-ra-note-gate') ? onInviteItemClick : openCoreInvites, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cloudId,
        userId,
        withAnalyticsEventProps,
        openCoreInvites,
        userRole,
        isEligibleXProductUserInvite,
        onXProductUserInviteClick
    ]);
}
module.exports["useMentionProvider"] = $cb04a18914327c7b$export$601d5e9e674a7c4a;

});

parcelRegister("jubk3", function(module, exports) {

var $kN1ON = parcelRequire("kN1ON");

var $ly0vw = parcelRequire("ly0vw");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $46J5o = parcelRequire("46J5o");


var $80Dol = parcelRequire("80Dol");


var $g2yI6 = parcelRequire("g2yI6");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $kN1ON.DefaultMentionNameResolver)(new (0, $46J5o.MentionNameClient)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite, includeAgents) {
    let includeExternalCollaborators = false;
    const data = await (0, $g2yI6.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = data ? (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true : false;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents ?? false);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $ly0vw.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("kN1ON", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");

class $68b29c117af189b3$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $6mYMS.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $6mYMS.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $68b29c117af189b3$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $3jsXx.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
/**
 * Merge the two queues making sure to merge callback arrays for items in queueB already in queueA.
 * This addresses [this ticket](https://product-fabric.atlassian.net/browse/QS-3789).
 */ $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll = 800;
function $68b29c117af189b3$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["DefaultMentionNameResolver"] = $68b29c117af189b3$export$2ae0434dccdcb77e;

});

parcelRegister("6mYMS", function(module, exports) {
var $4e350b6bba0e5c59$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $4e350b6bba0e5c59$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $4e350b6bba0e5c59$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $4e350b6bba0e5c59$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $4e350b6bba0e5c59$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $4e350b6bba0e5c59$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $4e350b6bba0e5c59$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $4e350b6bba0e5c59$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $4e350b6bba0e5c59$export$81124e6148ca5db0[0];
}
function $4e350b6bba0e5c59$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[1];
}
function $4e350b6bba0e5c59$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[2];
}
function $4e350b6bba0e5c59$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $4e350b6bba0e5c59$export$8436e53e45ffe15b[3];
}
function $4e350b6bba0e5c59$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $4e350b6bba0e5c59$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $4e350b6bba0e5c59$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $4e350b6bba0e5c59$export$81124e6148ca5db0;
module.exports["UserType"] = $4e350b6bba0e5c59$export$8436e53e45ffe15b;
module.exports["SliNames"] = $4e350b6bba0e5c59$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $4e350b6bba0e5c59$export$5c42d9dea6d035c1;
module.exports["Actions"] = $4e350b6bba0e5c59$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $4e350b6bba0e5c59$export$b8fa67dc54502853;
module.exports["isRestricted"] = $4e350b6bba0e5c59$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $4e350b6bba0e5c59$export$37b8dcac6198c514;
module.exports["isAppMention"] = $4e350b6bba0e5c59$export$eb590c844d13454c;
module.exports["isTeamMention"] = $4e350b6bba0e5c59$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $4e350b6bba0e5c59$export$d13d4f976b36a397;
module.exports["isPromise"] = $4e350b6bba0e5c59$export$4369c812aac99591;

});

parcelRegister("3jsXx", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $ElsUb = parcelRequire("ElsUb");


var $6mYMS = parcelRequire("6mYMS");

const $43ca455672da960d$var$packageName = "platform-pkg";
const $43ca455672da960d$var$packageVersion = "0.0.0-use.local";
const $43ca455672da960d$export$245097525aef1262 = 'sli';
const $43ca455672da960d$export$c724588856bbfbcf = 'smart';
const $43ca455672da960d$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            attributes: {
                packageName: $43ca455672da960d$var$packageName,
                packageVersion: $43ca455672da960d$var$packageVersion,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $6mYMS.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        return event;
    };
const $43ca455672da960d$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $43ca455672da960d$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
const $43ca455672da960d$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $43ca455672da960d$var$packageName,
            packageVersion: $43ca455672da960d$var$packageVersion,
            componentName: (0, $6mYMS.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $43ca455672da960d$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $6mYMS.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $43ca455672da960d$var$packageName,
                    packageVersion: $43ca455672da960d$var$packageVersion,
                    componentName: (0, $6mYMS.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ElsUb.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $43ca455672da960d$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $43ca455672da960d$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$43ca455672da960d$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $6mYMS.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $43ca455672da960d$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $43ca455672da960d$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $43ca455672da960d$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $43ca455672da960d$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $43ca455672da960d$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $43ca455672da960d$export$91b2fa6a0fe06408;

});

parcelRegister("ElsUb", function(module, exports) {
const $cc0765a5d08d319a$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $cc0765a5d08d319a$export$d821aa4c8afb384e;

});

parcelRegister("ly0vw", function(module, exports) {

var $2UZI2 = parcelRequire("2UZI2");


var $jaPjp = parcelRequire("jaPjp");


var $bqMS3 = parcelRequire("bqMS3");

class $c68c97e41ce8434f$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $c68c97e41ce8434f$export$7b4524ed61cc8203 extends (0, $bqMS3.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $c68c97e41ce8434f$var$PresenceResource extends $c68c97e41ce8434f$export$7b4524ed61cc8203 {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const atlAttributionHeader = (0, $2UZI2.buildAtlAttributionHeaderValue)({
            cloudId: this.config.cloudId,
            productId: this.config.productId,
            activationId: this.config.activationId
        });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...atlAttributionHeader,
                ...this.config.headers
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $c68c97e41ce8434f$var$PresenceResource.cleanUrl(config.url);
        this.presenceCache = config.cache || new $c68c97e41ce8434f$export$f962b6f1aaaafaf5(config.cacheExpiry);
        this.presenceParser = config.parser || new $c68c97e41ce8434f$export$80bae4549cafd20d();
    }
}
class $c68c97e41ce8434f$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $c68c97e41ce8434f$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
class $c68c97e41ce8434f$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $c68c97e41ce8434f$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($c68c97e41ce8434f$export$80bae4549cafd20d.isFocusState(presence)) return $c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
var $c68c97e41ce8434f$export$2e2bcd8739ae039 = $c68c97e41ce8434f$var$PresenceResource;
module.exports["default"] = $c68c97e41ce8434f$export$2e2bcd8739ae039;

});

parcelRegister("2UZI2", function(module, exports) {
function $bbe34607a1cf1c94$export$9df8b8301f41e4b7(config) {
    const { cloudId: cloudId, activationId: activationId, productId: productId = 'platform' } = config;
    const value = {
        tenantId: cloudId,
        product: productId
    };
    if (activationId) value.atlWorkspaceId = `ari:cloud:${productId}:${cloudId}:workspace/${activationId}`;
    return {
        'atl-attribution': JSON.stringify(value)
    };
}
module.exports["buildAtlAttributionHeaderValue"] = $bbe34607a1cf1c94$export$9df8b8301f41e4b7;

});

parcelRegister("jaPjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7f0f11694d4a0f0$export$2e2bcd8739ae039);
let $f7f0f11694d4a0f0$var$debugEnabled = false;
let $f7f0f11694d4a0f0$var$stacktracesEnabled = false;
function $f7f0f11694d4a0f0$export$748ada60eaf985cc(enable) {
    $f7f0f11694d4a0f0$var$debugEnabled = enable;
}
function $f7f0f11694d4a0f0$export$4f7017086af31c25(enable) {
    $f7f0f11694d4a0f0$var$stacktracesEnabled = enable;
}
function $f7f0f11694d4a0f0$export$2a858f450a2f66d() {
    if ($f7f0f11694d4a0f0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $f7f0f11694d4a0f0$export$2e2bcd8739ae039(msg, ...args) {
    if ($f7f0f11694d4a0f0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("bqMS3", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $6mYMS = parcelRequire("6mYMS");


var $jaPjp = parcelRequire("jaPjp");


var $3jsXx = parcelRequire("3jsXx");


var $jSnXV = parcelRequire("jSnXV");

const $298721003a2aaba7$var$MAX_QUERY_ITEMS = 100;
const $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS = 20;
const $298721003a2aaba7$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $298721003a2aaba7$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $298721003a2aaba7$export$8576ba1ed2760927 extends $298721003a2aaba7$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $jaPjp.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $jaPjp.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $298721003a2aaba7$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $298721003a2aaba7$export$5a4331e3e1c43553 extends $298721003a2aaba7$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $jaPjp.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $6mYMS.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $298721003a2aaba7$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const configHeaders = this.config.headers;
        const options = {
            path: 'bootstrap',
            queryParams: queryParams,
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).INITIAL_STATE, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const configHeaders = this.config.headers;
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $298721003a2aaba7$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            },
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $dwp40.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), (0, $6mYMS.SliNames).SEARCH, (0, $6mYMS.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $6mYMS.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $6mYMS.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.filter, this.config.debounceTime);
    }
}
class $298721003a2aaba7$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $298721003a2aaba7$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $298721003a2aaba7$export$2e2bcd8739ae039 = $298721003a2aaba7$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $298721003a2aaba7$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $298721003a2aaba7$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $298721003a2aaba7$export$ae1fce5f69858ef3;
module.exports["default"] = $298721003a2aaba7$export$2e2bcd8739ae039;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("46J5o", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $k1vn7 = parcelRequire("k1vn7");

class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $k1vn7.MENTIONS_LOOKUP_LIMIT;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $k1vn7.preloadMentionsUsers)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $6mYMS.MentionNameStatus).OK
                })));
    }
}
module.exports["MentionNameClient"] = $71c2faaa98a432d0$export$82da878d725997a7;

});

parcelRegister("k1vn7", function(module, exports) {

var $1ZEfa = parcelRequire("1ZEfa");


var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery = (0, $1ZEfa.default);
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (0, $dYU3e.queryAgg)({
        query: $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery,
        variables: {
            ids: ids
        }
    });
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await $ed0e2cb9f5186ade$var$getUserData(ids);
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};
module.exports["MENTIONS_LOOKUP_LIMIT"] = $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
module.exports["preloadMentionsUsers"] = $ed0e2cb9f5186ade$export$3adfff745266e959;

});

parcelRegister("1ZEfa", function(module, exports) {
/**
 * @generated SignedSource<<24ebe00000492c7932f135d73afc4d2b>>
 * @relayHash f1566d2dfc3b1c8e62dbd552d1d5ea7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f
const $2c3903aefb77a74c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "ids"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f1566d2dfc3b1c8e62dbd552d1d5ea7b",
            "id": "9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f",
            "metadata": {},
            "name": "preloadMentionsUsersUsersQuery",
            "operationKind": "query",
            "text": "query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){__typename,id,name}}"
        }
    };
}();
$2c3903aefb77a74c$var$node.hash = "3783fdf735e372b90adc93c9f8ad8005";
var $2c3903aefb77a74c$export$2e2bcd8739ae039 = $2c3903aefb77a74c$var$node;
module.exports["default"] = $2c3903aefb77a74c$export$2e2bcd8739ae039;

});

parcelRegister("dYU3e", function(module, exports) {


var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");




var $7Lnfv = parcelRequire("7Lnfv");



var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    let single = true;
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch(true)
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client.__isAGGClient === true;
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return client.query({
        query: query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext
    }).then((result)=>{
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
        return {
            ...result,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)()) (0, $fEmGS.writeQueryInterop)(options);
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["UNEXPECTED_RESPONSE"] = $b5dd42974905c1cd$export$974b1060e58e0a3f;
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("80Dol", function(module, exports) {

var $bqMS3 = parcelRequire("bqMS3");


var $3jsXx = parcelRequire("3jsXx");


var $6mYMS = parcelRequire("6mYMS");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
const $76cb501321125a14$var$MAX_RESULTS = 20;
// URS filter to include agents (app accounts with agent app type) alongside regular users
const $76cb501321125a14$var$INCLUDE_AGENTS_FILTER = 'account_type:atlassian OR (account_type:app AND app_type:agent)';
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bqMS3.default) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const response = await this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isAgent(recommended)) return this.convertToAgentMention(recommended);
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            if (this.isTeam(recommended)) return this.convertToTeamMention(recommended);
            // Fallback to user mention for unknown types
            return this.convertToUserMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        return {
            query: query,
            mentions: [
                ...mentions,
                ...jiraMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {},
                    ...this.includeAgents ? {
                        filter: $76cb501321125a14$var$INCLUDE_AGENTS_FILTER
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isAgent(recommended) {
        // Agents are returned as USER entity type with appType 'agent'
        return recommended.entityType === 'USER' && recommended.appType === 'agent';
    }
    convertToAgentMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: 'APP',
            // Mark as app/agent type
            appType: 'agent'
        };
    }
    isUser(recommended) {
        // Regular users have entityType USER but no agent appType
        return recommended.entityType === 'USER' && recommended.appType !== 'agent';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
            userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents = false){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.includeAgents = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.includeAgents = includeAgents;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $aXWIB.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("j5rtD", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});

parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<ec8b8771c872e1973d243f6a7b0cb62a>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("fN9wG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $iXCQx = parcelRequire("iXCQx");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $17wUi = parcelRequire("17wUi");


var $b5SMr = parcelRequire("b5SMr");


var $elPdM = parcelRequire("elPdM");


var $c0rhi = parcelRequire("c0rhi");

const $bd929afc952baa40$var$INVITE_CAPABILITIES_URL = '/gateway/api/v3/invitations/capabilities';
const $bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY = 'confluence_invite_capabilities_direct_invite_mode';
const $bd929afc952baa40$var$i18n = (0, $aXWIB.defineMessages)({
    inviteSuccessTitle: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.title",
        defaultMessage: "Successfully added"
    },
    inviteSuccessDescription: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.description",
        defaultMessage: "We sent an email to <b>{name}</b> confirming you added them to Confluence."
    }
});
const $bd929afc952baa40$export$3bdfaf8c811be72d = /*#__PURE__*/ (0, $42omo.createContext)({});
const $bd929afc952baa40$var$hasDirectInviteCapabilities = async (cloudId, createAnalyticsEvent)=>{
    try {
        const canUserAccessJira = await $bd929afc952baa40$var$hasJiraSoftwareAccess(cloudId) ?? false;
        let directInviteMode;
        let invitePendingApprovalMode;
        if (canUserAccessJira) {
            //Call invite capabilities endpoint only if directInviteMode value is not available from local storage
            directInviteMode = (0, $17wUi.confluenceLocalStorageInstance).getItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY);
            if (!directInviteMode) {
                const response = await (0, $f7B1p.cfetch)(`${$bd929afc952baa40$var$INVITE_CAPABILITIES_URL}?resource=ari:cloud:platform::site/${cloudId}`, {
                    method: 'GET',
                    headers: {
                        ACCEPT: 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
                const data = await response.json();
                for (const item of data)if (item?.resourceARI?.includes('confluence')) {
                    directInviteMode = item?.directInvite?.mode;
                    invitePendingApprovalMode = item?.invitePendingApproval?.mode;
                    break;
                }
                createAnalyticsEvent && createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'editor',
                        action: 'fetched',
                        actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                        attributes: {
                            directInviteMode: directInviteMode,
                            invitePendingApprovalMode: invitePendingApprovalMode
                        }
                    }
                }).fire();
                if (!!directInviteMode) (0, $17wUi.confluenceLocalStorageInstance).setItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY, directInviteMode, 86400);
            }
        }
        return directInviteMode === 'ANYONE';
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        createAnalyticsEvent && createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'editor',
                action: 'errored',
                actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                attributes: {
                    errorMessage: errorMessage
                }
            }
        }).fire();
        return false;
    }
};
const $bd929afc952baa40$var$hasJiraSoftwareAccess = async (cloudId)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $b5SMr.default),
        variables: {
            resourceId: `ari:cloud:jira::site/${cloudId}`,
            permissionId: 'write'
        }
    }).then(({ data: data })=>{
        const hasJira = data?.confluence_tenantContext?.licensedProducts.some((product)=>product?.productKey?.toLowerCase().includes('jira-software') && product?.licenseStatus === (0, $elPdM.LicenseStatus).ACTIVE);
        return !!hasJira && data?.permitted;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return false;
    });
};
const $bd929afc952baa40$export$266d732058715003 = ({ children: children, flags: flags })=>{
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const promiseRef = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleXProductUserInvite = (0, $42omo.useCallback)(()=>{
        //check the eligibility criteria only once per SPA
        if (promiseRef.current) return promiseRef.current;
        promiseRef.current = (async ()=>{
            try {
                if (!(0, $9wGTI.fg)('cc_virality_x_product_user_invite_kill_switch') || !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS)) return false;
                return await $bd929afc952baa40$var$hasDirectInviteCapabilities(cloudId, createAnalyticsEvent);
            } catch  {
                return false;
            }
        })();
        return promiseRef.current;
    }, [
        accessStatus,
        cloudId,
        createAnalyticsEvent
    ]);
    const showSuccessFlag = (0, $42omo.useCallback)((name, isSuccess)=>{
        if (isSuccess) flags.showFlag({
            id: `x-product-user-invite-success`,
            title: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessTitle),
            description: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessDescription, {
                name: name,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                        weight: "bold"
                    }, chunks)
            }),
            type: 'success-circle'
        });
    }, [
        flags,
        formatMessage
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            isEligibleXProductUserInvite: isEligibleXProductUserInvite,
            onXProductUserInviteClick: (name, isSuccess)=>{
                showSuccessFlag(name, isSuccess);
            }
        }), [
        isEligibleXProductUserInvite,
        showSuccessFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bd929afc952baa40$export$3bdfaf8c811be72d.Provider, {
        value: value
    }, children);
};
const $bd929afc952baa40$export$363c701b8b10381c = (0, $7aRa9.withFlags)($bd929afc952baa40$export$266d732058715003);
module.exports["XProductUserInviteContext"] = $bd929afc952baa40$export$3bdfaf8c811be72d;
module.exports["XProductUserInviteProvider"] = $bd929afc952baa40$export$363c701b8b10381c;

});

parcelRegister("b5SMr", function(module, exports) {
/**
 * @generated SignedSource<<ce453492d5227ced88f261326342f6db>>
 * @relayHash 0799e7283121eb71f27f154269c35d2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff
const $0dd0647641a6eb7a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v2 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "permissionId",
                    "variableName": "permissionId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "kind": "ScalarField",
            "name": "permitted"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GetUserAccessQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GetUserAccessQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0799e7283121eb71f27f154269c35d2f",
            "id": "f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff",
            "metadata": {},
            "name": "GetUserAccessQuery",
            "operationKind": "query",
            "text": "query GetUserAccessQuery($resourceId:String!,$permissionId:String!){confluence_tenantContext{licensedProducts{licenseStatus,productKey}},permitted(resourceId:$resourceId,permissionId:$permissionId)}"
        }
    };
}();
$0dd0647641a6eb7a$var$node.hash = "32bb5d7171ecf6d04700c4e127e76256";
var $0dd0647641a6eb7a$export$2e2bcd8739ae039 = $0dd0647641a6eb7a$var$node;
module.exports["default"] = $0dd0647641a6eb7a$export$2e2bcd8739ae039;

});

parcelRegister("elPdM", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ad8e722f7df5268a$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $ad8e722f7df5268a$export$902181cb056f3d0b;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("ew8wg", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $duklN = parcelRequire("duklN");


var $42omo = parcelRequire("42omo");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $df587a746afa9e84$export$4882d379d640c470 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $duklN.default), t1);
    let t2;
    let t3;
    if ($[2] !== error) {
        t2 = ()=>{
            if (error && ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error))) (0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            error
        ];
        $[2] = error;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $42omo.useEffect)(t2, t3);
    const t4 = data?.singleContent?.title;
    let t5;
    if ($[5] !== error || $[6] !== t4) {
        t5 = {
            title: t4,
            error: error
        };
        $[5] = error;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
module.exports["usePageTitle"] = $df587a746afa9e84$export$4882d379d640c470;

});

parcelRegister("duklN", function(module, exports) {
/**
 * @generated SignedSource<<da89cb632be3a889b86eac8faea94e6e>>
 * @relayHash 512d3c288e476ca23b45061d9102b2d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b
const $78d6c4b2c14ab559$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "512d3c288e476ca23b45061d9102b2d6",
            "id": "e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b",
            "metadata": {},
            "name": "usePageTitlePageTitleQuery",
            "operationKind": "query",
            "text": "query usePageTitlePageTitleQuery($contentId:ID!){singleContent(id:$contentId){id,title}}"
        }
    };
}();
$78d6c4b2c14ab559$var$node.hash = "49163e20c25d3da0c01ad2e924f87c37";
var $78d6c4b2c14ab559$export$2e2bcd8739ae039 = $78d6c4b2c14ab559$var$node;
module.exports["default"] = $78d6c4b2c14ab559$export$2e2bcd8739ae039;

});

parcelRegister("5UhfH", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $6f81802f32398f24$export$49fef1783eef7e2a(spaceId) {
    const resolveFnRef = (0, $42omo.useRef)(null);
    const spaceIdPromiseRef = (0, $42omo.useRef)(null);
    if (!spaceIdPromiseRef.current) spaceIdPromiseRef.current = new Promise((resolve)=>{
        resolveFnRef.current = resolve;
    });
    (0, $42omo.useEffect)(()=>{
        if (spaceId || spaceId === '') resolveFnRef.current(spaceId);
    }, [
        spaceId
    ]);
    return spaceIdPromiseRef.current;
}
module.exports["useSpaceIdPromise"] = $6f81802f32398f24$export$49fef1783eef7e2a;

});

parcelRegister("3W9OD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7dyLS = parcelRequire("7dyLS");


var $2fkag = parcelRequire("2fkag");


var $bQm3c = parcelRequire("bQm3c");

function $267ba6a0568e3ab0$export$ffe8c124580b6e44() {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useMemo)(()=>Promise.resolve((0, $2fkag.createSearchProvider)(cloudId, (0, $7dyLS.Scope).ConfluencePageBlog, undefined, undefined, true)), [
        cloudId
    ]);
}
module.exports["useSearchProvider"] = $267ba6a0568e3ab0$export$ffe8c124580b6e44;

});

parcelRegister("7dyLS", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $lEY55 = parcelRequire("lEY55");


var $iUYhn = parcelRequire("iUYhn");


var $eFiFf = parcelRequire("eFiFf");


var $3YFt4 = parcelRequire("3YFt4");

var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};
module.exports["Scope"] = $ff4c1fab1412a389$export$775b6bb06e53a214;

});

parcelRegister("lEY55", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $31e4730094d25be0$export$775b6bb06e53a214;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("eFiFf", function(module, exports) {
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $e9e0239fba21ef53$export$775b6bb06e53a214;

});

parcelRegister("3YFt4", function(module, exports) {
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa;

});

parcelRegister("2fkag", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dIeDA = parcelRequire("dIeDA");

const $f41289c0cfd3ba69$export$31a7d81156fc4fa1 = (cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri)=>{
    return new (0, $dIeDA.default)(cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri);
};
module.exports["createSearchProvider"] = $f41289c0cfd3ba69$export$31a7d81156fc4fa1;

});

parcelRegister("dIeDA", function(module, exports) {

var $3paC4 = parcelRequire("3paC4");


var $7dyLS = parcelRequire("7dyLS");


var $7MEO5 = parcelRequire("7MEO5");

const $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER = 'editor-quick-search';
class $2b54566fbe30c20f$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                })
            }));
    }
    jiraIssueResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                // The `item.url` here for Jira Issue is the absolute url
                url: item.url,
                container: item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], item.attributes.issueTypeName),
                updatedTimestamp: item.attributes.updated,
                objectId: this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: 'issue',
                    resourceId: item.id
                })
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    default:
                        return 'jira.issue';
                }
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit
        });
        switch(this.scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.confluencePageBlogResponseTransformer(scopeResult);
                }
            case (0, $7dyLS.Scope).JiraIssue:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.jiraIssueResponseTransformer(scopeResult);
                }
            default:
                throw new Error(`Unsupported scope - ${this.scope}`);
        }
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).JiraIssue:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}
module.exports["default"] = $2b54566fbe30c20f$export$2e2bcd8739ae039;

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("7MEO5", function(module, exports) {
"use strict";
var $5aacab81e886bd11$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $5aacab81e886bd11$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dxnq4 = parcelRequire("dxnq4");


$5aacab81e886bd11$var$__export((parcelRequire("3lrmR")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $5aacab81e886bd11$var$InvalidAriError = /** @class */ function(_super) {
    $5aacab81e886bd11$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $5aacab81e886bd11$var$InvalidAriError;
function $5aacab81e886bd11$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $5aacab81e886bd11$var$basicCharConstraint = $dxnq4.pattern(/^[a-z][a-z.-]*$/);
var $5aacab81e886bd11$var$resourceOwnerConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$resourceTypeConstraints = [
    $dxnq4.lengthBetween(3, 255),
    $5aacab81e886bd11$var$basicCharConstraint
];
var $5aacab81e886bd11$var$cloudIdConstraints = [
    $dxnq4.lengthBetween(36, 255)
];
var $5aacab81e886bd11$var$siteResourceType = 'site';
var $5aacab81e886bd11$var$resourceIdChars = /[\w-._~:@#]/.source;
var $5aacab81e886bd11$var$resourceIdConstraints = [
    $dxnq4.pattern(new RegExp("^" + $5aacab81e886bd11$var$resourceIdChars + "+(/" + $5aacab81e886bd11$var$resourceIdChars + "*)*(;v=" + $5aacab81e886bd11$var$resourceIdChars + "*)*$"))
]; /**
                                                                                                                                                          * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                                          * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                                          */ 
function $5aacab81e886bd11$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $5aacab81e886bd11$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $5aacab81e886bd11$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $5aacab81e886bd11$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $5aacab81e886bd11$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $5aacab81e886bd11$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $5aacab81e886bd11$var$parse(decodeURIComponent(encodedAriString));
    }; /**
      * Converts this Ari to a string.
      */ 
    ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $5aacab81e886bd11$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $5aacab81e886bd11$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    }; /**
      * Converts this object to its json representation
      */ 
    ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    }; /**
      * Checks if this context is the same as another context
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
      */ 
    ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }; /**
      * This method checks if the current context contains the other context.
      *
      * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
      * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
      *
      * @param {Ari} other
      * @returns {boolean}
      */ 
    ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    }; /**
      * Checks if this context is the same as or contains the provided context.
      *
      * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
      *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
      *
      * e.g.
      * ```
      * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
      * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
      */ 
    ResourceIdentifier.prototype.matches = function(other) {
        return $5aacab81e886bd11$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $5aacab81e886bd11$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $5aacab81e886bd11$var$siteResourceType && !!other.resourceType || $5aacab81e886bd11$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $5aacab81e886bd11$var$siteResourceType && !cloudId) return new $dxnq4.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $dxnq4.validateField(this, 'resourceOwner', $5aacab81e886bd11$var$resourceOwnerConstraints),
            $dxnq4.validateField(this, 'resourceType', $5aacab81e886bd11$var$resourceTypeConstraints),
            $dxnq4.validateField(this, 'resourceId', $5aacab81e886bd11$var$resourceIdConstraints),
            $dxnq4.validateField(this, 'cloudId', $5aacab81e886bd11$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $5aacab81e886bd11$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $5aacab81e886bd11$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $5aacab81e886bd11$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $5aacab81e886bd11$var$parse(ariString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $5aacab81e886bd11$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $5aacab81e886bd11$var$parseEncoded(encodedAriString) {
    return $5aacab81e886bd11$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $5aacab81e886bd11$var$parseEncoded;

});

parcelRegister("dxnq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9db08607176ba86f$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $9db08607176ba86f$var$LengthConstraint;
var $9db08607176ba86f$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $9db08607176ba86f$var$RegexConstraint;
var $9db08607176ba86f$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $9db08607176ba86f$var$GeneralValidationError;
var $9db08607176ba86f$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $9db08607176ba86f$var$ConstraintViolation;
function $9db08607176ba86f$var$lengthBetween(min, max) {
    return new $9db08607176ba86f$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $9db08607176ba86f$var$lengthBetween;
function $9db08607176ba86f$var$pattern(regex) {
    return new $9db08607176ba86f$var$RegexConstraint(regex);
}
module.exports.pattern = $9db08607176ba86f$var$pattern;
function $9db08607176ba86f$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $9db08607176ba86f$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $9db08607176ba86f$var$validateField;

});

parcelRegister("3lrmR", function(module, exports) {
"use strict";
var $26f88fee2c23b642$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3uwoy = parcelRequire("3uwoy");

var $26f88fee2c23b642$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($26f88fee2c23b642$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $26f88fee2c23b642$var$AppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $26f88fee2c23b642$var$AppFamilyAriError;
var $26f88fee2c23b642$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $26f88fee2c23b642$var$NotAppFamilyAriError;
var $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $26f88fee2c23b642$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($26f88fee2c23b642$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $26f88fee2c23b642$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $26f88fee2c23b642$var$parseAppAri(ari) {
    return $3uwoy.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $26f88fee2c23b642$var$parseAppAri;
function $26f88fee2c23b642$var$createAppAri(json) {
    return new $3uwoy.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $26f88fee2c23b642$var$createAppAri;

});

parcelRegister("3uwoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3lrmR = parcelRequire("3lrmR");


var $7MEO5 = parcelRequire("7MEO5");

var $28ad4d654e27c81d$var$versionPrefix = ';v=';
var $28ad4d654e27c81d$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $3lrmR.AppFamilyAri.resourceOwner) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $3lrmR.AppFamilyAri.resourceOwner);
        if (!resourceType || $3lrmR.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $3lrmR.NotAppFamilyAriError(ari, "resourceType must be one of " + $3lrmR.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $3lrmR.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($28ad4d654e27c81d$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($28ad4d654e27c81d$var$versionPrefix) > versionIndex) throw new $3lrmR.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($28ad4d654e27c81d$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($28ad4d654e27c81d$var$stripToUndefined);
        if (segments.length > 4) throw new $3lrmR.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $3lrmR.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType || resourceType === $3lrmR.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $3lrmR.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $3lrmR.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        else if (resourceType === $3lrmR.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $3lrmR.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $3lrmR.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $3lrmR.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $3lrmR.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $28ad4d654e27c81d$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $7MEO5.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $3lrmR.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $28ad4d654e27c81d$var$AppFamilyAriImpl;
function $28ad4d654e27c81d$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("bMmYR", function(module, exports) {
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};
module.exports["retry"] = $e3747894d76f1f8c$export$9369b12211e1fce4;

});

parcelRegister("gxtki", function(module, exports) {
function $249d0e770ebf7c87$export$4163f075d4b10c85(mutationErrors) {
    return mutationErrors.map((e)=>({
            ...e,
            // The Array check is a workaround for the fact that the GraphQL schema
            // can be different during __runtime__ between AGG and cc-graphql, which
            // is controlled by the `ATL-AGG-Confluence-MutationError-Compat: false` header.
            extensions: Array.isArray(e.extensions) ? e.extensions : e.extensions != null ? [
                e.extensions
            ] : undefined
        }));
}
module.exports["mutationErrorExtensionsAggCompat"] = $249d0e770ebf7c87$export$4163f075d4b10c85;

});

parcelRegister("8uySb", function(module, exports) {
/* EditorDisplayWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $a680464f54a8caa4$var$baseStyles = null; /* hide the editor when the page is being previewed */ 
const $a680464f54a8caa4$var$hiddenStyles = null;
const $a680464f54a8caa4$var$visibleStyles = null;
const $a680464f54a8caa4$var$overflowHiddenStyles = null;
const $a680464f54a8caa4$var$toolbarMarginStyles = null;
const $a680464f54a8caa4$var$toolbarNoMarginStyles = null; /**
                                     * Component wrapping the editor to apply styling overrides
                                     */ 
const $a680464f54a8caa4$export$1a692c35a5e9cddf = ({ isHidden: isHidden, isEditorActionBarRendered: isEditorActionBarRendered, isToolbarAifcEnabled: isToolbarAifcEnabled, ...props })=>{
    const shouldApplyToolbarMargin = isEditorActionBarRendered && !isToolbarAifcEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _kqswh2mm _19jk1jfw _kibh1jfw _bq9y1f4h _yovj1ejb _1dmjpxbi _1k07v47k _1iwipxbi _1jpz1b66",
            isHidden ? "_1e0cglyw" : "_1e0cn7od",
            isEditorActionBarRendered && "_18m915vq",
            shouldApplyToolbarMargin ? "_1i191ejb" : "_1i19ze3t"
        ])
    });
};
module.exports["EditorDisplayWrapper"] = $a680464f54a8caa4$export$1a692c35a5e9cddf;

});

parcelRegister("lmEhP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jhcFr = parcelRequire("jhcFr");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $vLw8x = parcelRequire("vLw8x");


var $7zgzO = parcelRequire("7zgzO");


var $etKOR = parcelRequire("etKOR");


/**
 * Lazily loaded adapter that maps the editor's LinkPickerProps interface to RovoLinkPicker.
 * Loaded only when the `confluence_rovo_link_picker_experiment` experiment is enabled (TREX-1074),
 * keeping @atlassian/rovo-link-picker and its heavy transitive deps out of the baseline editor bundle.
 */ const $87c86ebe3b41800e$var$RovoLinkPickerAdapter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AgDGk",
    name: "RovoLinkPickerAdapter",
    loader: async ()=>(await (parcelRequire("8Jda0"))).RovoLinkPickerAdapter
});
const $87c86ebe3b41800e$export$78db118acf87bd21 = (options, viewMode, isChromelessEditor, isLivePage)=>{
    const config = (0, $etKOR.useLinkingOptions)(options, isChromelessEditor);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // TODO MODES-4363 Once getSpaTransitionDetails & its consumers are refactored to not use RoutesContext, use RouteState instead of RoutesContext
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const productConfig = (0, $42omo.useMemo)(()=>({
            product: 'confluence',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    /**
   * Store live page state props in refs so the onClickCallback has a stable reference
   * The onClickCallback passed to editor (and consumed within the useUniversalPreset hook)
   * is not updated when the live page state changes.
   */ const isLivePageRef = (0, $42omo.useRef)(isLivePage);
    const viewModeRef = (0, $42omo.useRef)(viewMode);
    (0, $42omo.useEffect)(()=>{
        isLivePageRef.current = isLivePage;
        viewModeRef.current = viewMode;
    }, [
        isLivePage,
        viewMode
    ]);
    /**
   * By passing a callback we circumvent the default link click handling within platform
   *
   * We only want to allow smart links in live edit mode to navigte when this platform FF
   * is enabled. The guarded behaviour can be instilled as the default on clean up (alongside
   * removing the viewMode prop).
   */ const onClickCallback = (0, $42omo.useCallback)(({ event: event, url: url })=>{
        if (viewModeRef.current && url) (0, $vLw8x.smartCardEventHandler)(routesContext, event, url);
    }, [
        routesContext
    ]);
    // Always called (rules of hooks); result discarded in treatment — useLinkPickerEditorProps
    // replaces `component` with its own wrapper, which RovoLinkPicker doesn't need.
    const defaultLinkPickerProps = (0, $jhcFr.useLinkPickerEditorProps)(undefined, (0, $6mKj3.expVal)('confluence_rovo_link_picker_experiment', 'isEnabled', false) ? undefined : productConfig);
    return (0, $42omo.useMemo)(()=>({
            linking: {
                ...config.linking,
                linkPicker: (0, $6mKj3.expVal)('confluence_rovo_link_picker_experiment', 'isEnabled', false) ? {
                    ...config.linking?.linkPicker,
                    component: $87c86ebe3b41800e$var$RovoLinkPickerAdapter
                } : {
                    ...config.linking?.linkPicker,
                    ...defaultLinkPickerProps
                },
                smartLinks: {
                    ...config.linking?.smartLinks,
                    onClickCallback: onClickCallback
                }
            }
        }), // expVal is stable per session (experiment assignment doesn't change during a render lifecycle),
    // so it's intentionally omitted from dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        config,
        defaultLinkPickerProps,
        onClickCallback
    ]);
};
const $87c86ebe3b41800e$export$9b0cf83b2bedfd63 = ({ children: children, options: options, viewMode: viewMode = false, isChromelessEditor: isChromelessEditor = false, isLivePage: isLivePage = false })=>{
    const mergedProps = $87c86ebe3b41800e$export$78db118acf87bd21(options, viewMode, isChromelessEditor, isLivePage);
    return children(mergedProps);
};
module.exports["useLinkingFeatures"] = $87c86ebe3b41800e$export$78db118acf87bd21;
module.exports["EditorLinkingFeatures"] = $87c86ebe3b41800e$export$9b0cf83b2bedfd63;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.SHAREABLE_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("jibmA", function(module, exports) {
/**
 * This is a temporary exception list which is used to determine if the link
 * is pointing to either Jira, a different instance or outside of Atlassian
 * entirely.
 */ const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = window.location.hostname;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        urlObject = url && new URL(url);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("etKOR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kWKYj = parcelRequire("kWKYj");

const $5353808f826c81c2$export$535281304894bcdc = (cardOptions, isChromelessEditor = false)=>{
    const baseSmartLinks = (0, $kWKYj.useSmartCards)(isChromelessEditor);
    return (0, $42omo.useMemo)(()=>({
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        }), [
        baseSmartLinks,
        cardOptions
    ]);
};
module.exports["useLinkingOptions"] = $5353808f826c81c2$export$535281304894bcdc;

});

parcelRegister("kWKYj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ctpOV = parcelRequire("ctpOV");

const $11b3acfee7e9c227$export$5681a80d8b7b2bfb = (isChromelessEditor = false)=>{
    return (0, $42omo.useMemo)(()=>{
        return (0, $ctpOV.getSmartCardOptions)(isChromelessEditor);
    }, [
        isChromelessEditor
    ]);
};
module.exports["useSmartCards"] = $11b3acfee7e9c227$export$5681a80d8b7b2bfb;

});

parcelRegister("ctpOV", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $iGhtC = parcelRequire("iGhtC");


var $6GQtz = parcelRequire("6GQtz");

const $97182487d32399bc$export$2a89c15ccab17d33 = (0, $2XqLN.default)((enableChromelessEditorCardProvider)=>{
    /**
   * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
   * (only supports Cloud single-issue URLs right now)
   */ const smartLinksBeforeMacros = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
    const cardProvider = enableChromelessEditorCardProvider ? new (0, $iGhtC.InlineCommentEditorCardProvider)() : new (0, $6GQtz.ConfluenceEditorCardProvider)();
    if (!enableChromelessEditorCardProvider) {
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData[cardProvider.name];
        cardProvider.setSSRData(ssrData);
    }
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
    return {
        provider: Promise.resolve(cardProvider),
        resolveBeforeMacros: smartLinksBeforeMacros,
        allowBlockCards: true,
        allowEmbeds: true
    };
});
module.exports["getSmartCardOptions"] = $97182487d32399bc$export$2a89c15ccab17d33;

});

parcelRegister("iGhtC", function(module, exports) {

var $6GQtz = parcelRequire("6GQtz");

const $6f3acea258be288a$var$isLoomUrl = (url)=>{
    return url.match(// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
    RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})"));
};
class $6f3acea258be288a$export$d4825e69ed899a33 extends (0, $6GQtz.ConfluenceEditorCardProvider) {
    getHardCodedAppearance(url) {
        if ($6f3acea258be288a$var$isLoomUrl(url)) return 'embed';
    }
}
module.exports["InlineCommentEditorCardProvider"] = $6f3acea258be288a$export$d4825e69ed899a33;

});

parcelRegister("6GQtz", function(module, exports) {

var $477dG = parcelRequire("477dG");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $477dG.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if ((0, $6mKj3.isExperimentEnabled)('confluence_smartlink_default_display_types')) {
            if (this.shouldDisplayAsEmbed(url)) return 'embed';
            if (this.shouldDisplayAsCard(url)) return 'block';
        }
        return super.getHardCodedAppearance(url);
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("477dG", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $79vw2 = parcelRequire("79vw2");


var $i0VEL = parcelRequire("i0VEL");


var $1oCLl = parcelRequire("1oCLl");


var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");


var $1bFdN = parcelRequire("1bFdN");


var $5nJCu = parcelRequire("5nJCu");


var $k00oi = parcelRequire("k00oi");


var $dh538 = parcelRequire("dh538");


var $lEzf1 = parcelRequire("lEzf1");


var $egwA4 = parcelRequire("egwA4");

const $807e27f9bf9a8610$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
const $807e27f9bf9a8610$var$isPolarisView = (url)=>url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
const $807e27f9bf9a8610$var$isJwmView = (url)=>url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
const $807e27f9bf9a8610$var$isJiraList = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/);
const $807e27f9bf9a8610$var$isGiphyMedia = (url)=>url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
const $807e27f9bf9a8610$var$isProformaView = (url)=>url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
const $807e27f9bf9a8610$var$isConfluenceWhiteboard = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
const $807e27f9bf9a8610$var$isConfluenceDatabase = (url)=>url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/);
const $807e27f9bf9a8610$var$isYoutubeVideo = (url)=>url.match(/^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/);
const $807e27f9bf9a8610$var$isLoomUrl = (url)=>{
    return url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})"));
};
const $807e27f9bf9a8610$var$isJiraDashboard = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/);
};
const $807e27f9bf9a8610$var$isJiraBacklog = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/);
};
const $807e27f9bf9a8610$var$isJiraBoard = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraPlan = (url)=>{
    return(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?")));
};
const $807e27f9bf9a8610$var$isJiraVersion = (url)=>{
    return url.match(/https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/);
};
const $807e27f9bf9a8610$var$isJiraForm = (url)=>{
    return url.match(/https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/);
};
const $807e27f9bf9a8610$var$isJiraSummary = (url)=>{
    return url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/);
};
const $807e27f9bf9a8610$var$isRovoAgentProfilePage = (url)=>{
    return url.match(/^https:\/\/.*?\/people\/agent\/.+$/);
};
const $807e27f9bf9a8610$var$isCustomer360LandingPage = (url)=>url.match(/^https:\/\/customer\.atlassian\.com\/.*$/);
const $807e27f9bf9a8610$var$isConfluenceTeamCalendars = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)"));
const $807e27f9bf9a8610$var$isJiraIssueNavigator = (url)=>url.match(/^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/);
const $807e27f9bf9a8610$var$isAvpVisualizationView = (url)=>url.match(/^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/);
const $807e27f9bf9a8610$export$6a9668b99d8a1708 = (url)=>/\/browse\/((?:\w+)-(?:\d+))/i.test(url);
const $807e27f9bf9a8610$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $807e27f9bf9a8610$var$isJiraRoadmapOrTimeline,
    isPolarisView: $807e27f9bf9a8610$var$isPolarisView,
    isJwmView: $807e27f9bf9a8610$var$isJwmView,
    isJiraList: $807e27f9bf9a8610$var$isJiraList,
    isConfluenceWhiteboard: $807e27f9bf9a8610$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $807e27f9bf9a8610$var$isConfluenceDatabase,
    isJiraDashboard: $807e27f9bf9a8610$var$isJiraDashboard,
    isJiraBacklog: $807e27f9bf9a8610$var$isJiraBacklog,
    isJiraBoard: $807e27f9bf9a8610$var$isJiraBoard,
    isJiraPlan: $807e27f9bf9a8610$var$isJiraPlan,
    isJiraVersion: $807e27f9bf9a8610$var$isJiraVersion,
    isJiraForm: $807e27f9bf9a8610$var$isJiraForm,
    isJiraSummary: $807e27f9bf9a8610$var$isJiraSummary,
    isRovoAgentProfilePage: $807e27f9bf9a8610$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $807e27f9bf9a8610$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $807e27f9bf9a8610$var$isJiraIssueNavigator
};
function $807e27f9bf9a8610$export$4006295459a20a0(url) {
    return Object.values($807e27f9bf9a8610$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $807e27f9bf9a8610$export$78234eee43b97e81(url) {
    return !$807e27f9bf9a8610$export$4006295459a20a0(url);
}
function $807e27f9bf9a8610$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $807e27f9bf9a8610$export$e4635c0135e1a519 extends (0, $i0VEL.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        if ((0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false) // if local cache feature flag is disabled, fall back to the base implementation
        return super.getData(node, callback);
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        if (details) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        const cacheStatus = this.getCacheStatusForNode(jsonNode);
        if (cacheStatus === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            if (payload.data && !payload.error) this.smartCardLocalCacheClient.setItem(key, payload.data);
            callback(payload);
        });
    }
    nodeDataKey(node) {
        // We can use URL as a key here, because CardClient returns the same data for the same URL
        // regardless of the type of card (inline, block, embed).
        return node.attrs.url;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            return this.cardClient.fetchData(url);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$807e27f9bf9a8610$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $btw9C.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $lEzf1.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $807e27f9bf9a8610$var$isJiraPlan(url);
        const isJiraFormEvaluated = $807e27f9bf9a8610$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $807e27f9bf9a8610$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $dh538.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $807e27f9bf9a8610$var$isConfluenceTeamCalendars(url);
        if ($807e27f9bf9a8610$var$isJiraRoadmapOrTimeline(url) || $807e27f9bf9a8610$var$isPolarisView(url) || $807e27f9bf9a8610$var$isJwmView(url) || $807e27f9bf9a8610$var$isJiraList(url) || $807e27f9bf9a8610$var$isGiphyMedia(url) || $807e27f9bf9a8610$var$isProformaView(url) || $807e27f9bf9a8610$var$isConfluenceWhiteboard(url) || $807e27f9bf9a8610$var$isConfluenceDatabase(url) || $807e27f9bf9a8610$var$isYoutubeVideo(url) || $807e27f9bf9a8610$var$isLoomUrl(url) || $807e27f9bf9a8610$var$isJiraDashboard(url) || $807e27f9bf9a8610$var$isJiraBacklog(url) || $807e27f9bf9a8610$var$isJiraBoard(url) || $807e27f9bf9a8610$var$isRovoAgentProfilePage(url) || $807e27f9bf9a8610$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $807e27f9bf9a8610$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $807e27f9bf9a8610$var$isJiraIssueNavigator(url) || $807e27f9bf9a8610$var$isAvpVisualizationView(url) && (0, $dh538.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $btw9C.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $79vw2.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $dh538.fg)('issue-link-suggestions-in-comments')) {
                if ($807e27f9bf9a8610$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference && (0, $dh538.fg)('platform_sl_3p_unauth_paste_as_block_card_gate')) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') {
                            const isUnauthPasteAsBlockCardEnabled = !(0, $1oCLl.expValEquals)('platform_sl_3p_unauth_paste_as_block_card', 'cohort', 'control', 'control');
                            if (isUnauthPasteAsBlockCardEnabled) return this.transformer.toSmartlinkAdf(url, 'block');
                        }
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $egwA4.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $5nJCu.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $807e27f9bf9a8610$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $k00oi.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $807e27f9bf9a8610$export$b7c3c9a99f7959f5 = new $807e27f9bf9a8610$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $807e27f9bf9a8610$export$4006295459a20a0;
module.exports["isExternalUrl"] = $807e27f9bf9a8610$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $807e27f9bf9a8610$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $807e27f9bf9a8610$export$b7c3c9a99f7959f5;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("dDhJe", function(module, exports) {
const $acfecaf0839e2c0b$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $acfecaf0839e2c0b$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $acfecaf0839e2c0b$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $acfecaf0839e2c0b$export$e2b040f052407032 = {
    dev: $acfecaf0839e2c0b$var$devBaseUrl,
    development: $acfecaf0839e2c0b$var$devBaseUrl,
    stg: $acfecaf0839e2c0b$var$stgBaseUrl,
    staging: $acfecaf0839e2c0b$var$stgBaseUrl,
    prd: $acfecaf0839e2c0b$var$prodBaseUrl,
    prod: $acfecaf0839e2c0b$var$prodBaseUrl,
    production: $acfecaf0839e2c0b$var$prodBaseUrl
};
const $acfecaf0839e2c0b$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $acfecaf0839e2c0b$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $acfecaf0839e2c0b$export$e2b040f052407032 ? $acfecaf0839e2c0b$export$e2b040f052407032[envKey] : $acfecaf0839e2c0b$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $acfecaf0839e2c0b$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $acfecaf0839e2c0b$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $acfecaf0839e2c0b$export$2e2bcd8739ae039 = $acfecaf0839e2c0b$export$e2b040f052407032;
module.exports["getBaseUrl"] = $acfecaf0839e2c0b$export$f654b28f82155665;
module.exports["getResolverUrl"] = $acfecaf0839e2c0b$export$dc37652c1696f231;

});

parcelRegister("5nJCu", function(module, exports) {
class $b839f3682b6db3a9$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b839f3682b6db3a9$export$f993aef960936087;

});

parcelRegister("k00oi", function(module, exports) {

var $1bFdN = parcelRequire("1bFdN");


var $Gi9G7 = parcelRequire("Gi9G7");


var $abpX2 = parcelRequire("abpX2");


var $jHnts = parcelRequire("jHnts");

var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");

var $gmi3X = parcelRequire("gmi3X");


var $97i3I = parcelRequire("97i3I");


var $9trs7 = parcelRequire("9trs7");


var $6a9Hv = parcelRequire("6a9Hv");


var $dh538 = parcelRequire("dh538");

const $542f7628c45b2158$var$MAX_BATCH_SIZE = 50;
const $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE = 100;
const $542f7628c45b2158$export$d6a66073b5d79eb3 = new (0, $9trs7.LRUMap)($542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE);
class $542f7628c45b2158$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $jHnts.InvalidUrlError)(error);
        }
    }
    async resolveUrl(url, force = false) {
        const hostname = this.getHostName(url);
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $542f7628c45b2158$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            if ((0, $dh538.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined
                });
            } else responsePromise = loader.load(url);
            $542f7628c45b2158$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $97i3I.isSuccessfulResponse)(response) || (0, $btw9C.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $97i3I.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $97i3I.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $97i3I.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $97i3I.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $97i3I.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $gmi3X.NetworkError)) return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $jHnts.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $jHnts.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $jHnts.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $jHnts.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.loadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $542f7628c45b2158$export$2e2bcd8739ae039;

});

parcelRegister("Gi9G7", function(module, exports) {
// Packages

var $bfRrZ = parcelRequire("bfRrZ");

function $07f201957e3f51a5$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $bfRrZ.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $07f201957e3f51a5$var$retry;

});

parcelRegister("bfRrZ", function(module, exports) {

module.exports = (parcelRequire("2CRnP"));

});

parcelRegister("2CRnP", function(module, exports) {

var $jWveU = parcelRequire("jWveU");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $jWveU(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("jWveU", function(module, exports) {
function $e84baaa017e10274$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $e84baaa017e10274$var$RetryOperation;
$e84baaa017e10274$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$e84baaa017e10274$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$e84baaa017e10274$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$e84baaa017e10274$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = $e84baaa017e10274$var$RetryOperation.prototype.try;
$e84baaa017e10274$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$e84baaa017e10274$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("abpX2", function(module, exports) {
'use strict';
class $769f0fd050ef86b5$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $769f0fd050ef86b5$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $769f0fd050ef86b5$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $769f0fd050ef86b5$var$pThrottle;
module.exports.AbortError = $769f0fd050ef86b5$var$AbortError;

});

parcelRegister("gmi3X", function(module, exports) {
const $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $ffe0c3b764a3e96a$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $ffe0c3b764a3e96a$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $ffe0c3b764a3e96a$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["NetworkError"] = $ffe0c3b764a3e96a$export$bae979e68e4dc802;
module.exports["request"] = $ffe0c3b764a3e96a$export$b5fe3f66a567bec0;

});

parcelRegister("97i3I", function(module, exports) {
const $e30f485c735f2746$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $e30f485c735f2746$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isSuccessfulResponse"] = $e30f485c735f2746$export$1b59fe731a28a49d;
module.exports["isErrorResponse"] = $e30f485c735f2746$export$bea7bee8a87e7c52;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("lEzf1", function(module, exports) {
const $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $73e1dba18235f000$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $73e1dba18235f000$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $73e1dba18235f000$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $73e1dba18235f000$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $73e1dba18235f000$export$b5fe3f66a567bec0;

});

parcelRegister("egwA4", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");

var $7a3952f20342cebe$var$_SmartCardLocalCacheClient;
const $7a3952f20342cebe$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $7a3952f20342cebe$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $7a3952f20342cebe$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$7a3952f20342cebe$export$1987ad1ab31f2528.instance) $7a3952f20342cebe$export$1987ad1ab31f2528.instance = new $7a3952f20342cebe$export$1987ad1ab31f2528(maxItems);
        return $7a3952f20342cebe$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $7a3952f20342cebe$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $7a3952f20342cebe$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $kt8c2.default)($7a3952f20342cebe$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url in storage
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached in storage
     */ this.setItem = (url, response)=>{
            // Add or update the item in the cache with current timestamp
            this.memoryCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            // Apply FIFO behavior if cache exceeds maxItems
            const cacheKeys = Object.keys(this.memoryCache);
            if (cacheKeys.length > this.maxItems) {
                // Sort keys by timestamp (oldest first) and remove the oldest items
                const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.memoryCache[key];
                });
            }
            // Write through to storage asynchronously (non-blocking)
            // Debounced to batch multiple rapid calls into a single write
            if (!this.pendingWrite) {
                this.pendingWrite = true;
                queueMicrotask(()=>{
                    try {
                        this.storageClient.setItemWithExpiry($7a3952f20342cebe$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                    } catch (_) {
                    // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                    // Cache will still function in-memory for the session, but won't persist
                    } finally{
                        this.pendingWrite = false;
                    }
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url from storage (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            const response = this.memoryCache?.[url]?.data;
            return response;
        };
        /**
     * Checks if a cached entry exists for the provided url in storage
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        // Load cache from storage into memory on instantiation
        const stored = this.storageClient.getItem($7a3952f20342cebe$var$SMART_CARD_CACHE_KEY, {
            useExpiredItem: true
        });
        this.memoryCache = stored ? JSON.parse(stored) : {};
    }
}
$7a3952f20342cebe$var$_SmartCardLocalCacheClient = $7a3952f20342cebe$export$1987ad1ab31f2528;
$7a3952f20342cebe$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $7a3952f20342cebe$export$1987ad1ab31f2528;

});

parcelRegister("8Jda0", function(module, exports) {

let $65acbc10f41e211e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65acbc10f41e211e$var$load("k3jER"),
    $65acbc10f41e211e$var$load("6nOMd"),
    $65acbc10f41e211e$var$load("rHjvY"),
    $65acbc10f41e211e$var$load("kJSLa"),
    $65acbc10f41e211e$var$load("bGpE6"),
    $65acbc10f41e211e$var$load("6wr18"),
    $65acbc10f41e211e$var$load("ffEVr"),
    $65acbc10f41e211e$var$load("4RbVd"),
    $65acbc10f41e211e$var$load("1YMDo")
]).then(()=>parcelRequire('2pRIg'));

});

parcelRegister("i8Ylv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $2Nwuj = parcelRequire("2Nwuj");


var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $5spQU = parcelRequire("5spQU");


var $5kEnh = parcelRequire("5kEnh");


var $42MJM = parcelRequire("42MJM");


var $48ubT = parcelRequire("48ubT");


var $euL71 = parcelRequire("euL71");


var $lsxnT = parcelRequire("lsxnT");


var $lbPWE = parcelRequire("lbPWE");


var $bdMSP = parcelRequire("bdMSP");


var $3GzdC = parcelRequire("3GzdC");


var $lwir9 = parcelRequire("lwir9");

const $618e6728be00f8eb$var$WAC_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $618e6728be00f8eb$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "editor-features.ai-optin-modal.title",
        defaultMessage: "Elevate your team\u2019s writing"
    },
    description: {
        id: "editor-features.ai-optin-modal.description",
        defaultMessage: "Help enhance your team\u2019s writing with Rovo. Let AI improve clarity, maintain a professional tone, or craft concise content."
    },
    readMoreText: {
        id: "editor-features.ai-optin-modal.learn-more.link.text",
        defaultMessage: "<a>Read about Rovo</a>"
    },
    adminTurnOnText: {
        id: "editor-features.ai-optin-modal.admin-turn-on-text",
        defaultMessage: "Turn on Rovo features for your users from Atlassian Administration."
    },
    closeCTAText: {
        id: "editor-features.ai-optin-modal.close-cta-text",
        defaultMessage: "Maybe later"
    },
    getStartCTAText: {
        id: "editor-features.ai-optin-modal.get-started-cta-text",
        defaultMessage: "Get started"
    },
    learnMoreText: {
        id: "editor-features.ai-optin-modal.learn-more-cta-text",
        defaultMessage: "Learn more"
    },
    upgradePlanText: {
        id: "editor-features.ai-optin-modal.upgrade-plan-text",
        defaultMessage: "To start using Rovo in your products, upgrade your plan."
    },
    upsellText: {
        id: "editor-features.ai-optin-modal.upsell-text",
        defaultMessage: "With Rovo (AI), your team can craft concise, clear, and professional content faster than ever."
    },
    freePlanText: {
        id: "editor-features.ai-optin-modal.free-plan-text",
        defaultMessage: "You\u2019re on the free plan."
    },
    standardPlanText: {
        id: "editor-features.ai-optin-modal.standard-plan-text",
        defaultMessage: "You\u2019re on the standard plan."
    }
});
const $618e6728be00f8eb$var$OptInModal = ({ onClose: onClose, edition: edition, isSiteAdmin: isSiteAdmin, orgId: orgId, environment: environment })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const adminLink = $618e6728be00f8eb$var$getOptInDeepLink(orgId, environment);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { isEligible: isAiInEditorEligible, loading: isAiInEditorLoading, error: hasAiInEditorError, experienceUrl: aiInEditorExperienceUrl } = (0, $lbPWE.useIsEligibleForAiInEditor)();
    const { isABTreatment: isAiInEditorABTreatment } = (0, $bdMSP.useEnrolledAIInEditorModalsExperiment)({
        isEligible: isAiInEditorEligible && !isAiInEditorLoading && !hasAiInEditorError,
        touchpoint: 'ai-in-editor'
    });
    const onOptInReadMoreClick = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editorAIOptInReadMoreLink',
                attributes: {
                    product: 'confluence',
                    isOrgAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin
    ]);
    const showUpsell = edition !== (0, $euL71.ConfluenceEdition).PREMIUM;
    /**
   * HOT-116592 - https://atlassian.enterprise.slack.com/archives/C08MHDT1KLJ
   * This is used to track if the AIUpsell and / or AIOptIn components are rendered
   */ const onRender = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'triggerOptInFlowModalRendered',
                actionSubject: 'editorAIOptInDialog',
                actionSubjectId: 'editorAIModalRendered',
                attributes: {
                    product: 'confluence',
                    isOrgAdmin: isSiteAdmin,
                    edition: edition,
                    env: environment,
                    upsell: showUpsell
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showUpsell,
        edition,
        environment
    ]);
    if (isAiInEditorLoading) return null;
    if (!hasAiInEditorError && isAiInEditorABTreatment && aiInEditorExperienceUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3GzdC.ConfluenceAiInEditorModalWithErrorBoundaryLoadable), {
        experienceUrl: aiInEditorExperienceUrl,
        onClose: onClose,
        onRender: onRender
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: "fit-content",
        onClose: onClose,
        testId: showUpsell ? 'editor-ai-upsell-modal' : 'editor-ai-opt-in-modal',
        /**
   * HOT-116592 - https://atlassian.enterprise.slack.com/archives/C08MHDT1KLJ
   * Mark this modal as transactional as its a critical part of the ai upsell / opt in
   */ messageType: "transactional",
        messageId: "editor-ai-opt-in-modal"
    }, showUpsell ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42MJM.AIUpsell), {
        feature: "editorAI",
        title: formatMessage($618e6728be00f8eb$var$messages.title),
        body: `${formatMessage($618e6728be00f8eb$var$messages.upsellText)}
				<p></p>
				<p>${edition === (0, $euL71.ConfluenceEdition).FREE ? formatMessage($618e6728be00f8eb$var$messages.freePlanText) : formatMessage($618e6728be00f8eb$var$messages.standardPlanText)} ${formatMessage($618e6728be00f8eb$var$messages.upgradePlanText)}</p>`,
        image: {
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($lwir9))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($lwir9)))
            },
            alt: 'editor-ai-opt-in-banner'
        },
        learnMoreLink: {
            message: formatMessage($618e6728be00f8eb$var$messages.learnMoreText),
            href: $618e6728be00f8eb$var$WAC_LINK
        },
        onRender: onRender
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5kEnh.default), {
        source: "editorAI",
        product: "confluence",
        isOrgAdmin: true,
        onAdminClose: onClose,
        // TODO: Update the attribute below so it is translated.
        // eslint-disable-next-line no-restricted-syntax
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lwir9))),
            height: "96px",
            alt: "editor-ai-opt-in-banner"
        }),
        adminLink: adminLink,
        adminHeaderText: formatMessage($618e6728be00f8eb$var$messages.title),
        adminCloseCTAText: formatMessage($618e6728be00f8eb$var$messages.closeCTAText),
        adminCTAText: formatMessage($618e6728be00f8eb$var$messages.getStartCTAText),
        adminBodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($618e6728be00f8eb$var$messages.description), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$618e6728be00f8eb$var$messages.readMoreText,
            values: {
                a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: $618e6728be00f8eb$var$WAC_LINK,
                        target: "_blank",
                        onClick: onOptInReadMoreClick,
                        rel: "noopener noreferrer"
                    }, s)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($618e6728be00f8eb$var$messages.adminTurnOnText))),
        onRender: onRender
    }));
};
const $618e6728be00f8eb$var$getOptInDeepLink = (orgId, environment)=>{
    if (!orgId || !environment) return undefined;
    if (orgId) {
        if (environment === 'PRODUCTION') return `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
        else if (environment === 'STAGING') return `https://admin.stg.atlassian.com/o/${orgId}/atlassian-intelligence`;
    }
};
const $618e6728be00f8eb$var$getOptInStatus = (isAdminHubAIEnabled, isAIEnabledForContent, isSiteAdmin, edition)=>{
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    if (!isAIFeatureEnabled) return 'disabled';
    if (!isAIEnabledForContent && isAdminHubAIEnabled) return 'disabled';
    if (isAdminHubAIEnabled) return 'enabled';
    if (edition === null) return 'disabled';
    if (isSiteAdmin) return 'disabled-opt-in';
    return 'disabled';
};
const $618e6728be00f8eb$var$defaultEmptyTrigger = ()=>{};
const $618e6728be00f8eb$var$defaultEmptyComponent = ()=>null;
const $618e6728be00f8eb$export$90c93708fff010b3 = ({ isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEnabledForContent: isAIEnabledForContent = true, edition: edition, orgId: orgId, environment: environment })=>{
    const isSiteAdmin = (0, $48ubT.useIsSiteAdmin)().isSiteAdmin;
    const optInStatus = $618e6728be00f8eb$var$getOptInStatus(isAdminHubAIEnabled, isAIEnabledForContent, isSiteAdmin, edition);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (optInStatus === 'disabled-opt-in') {
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                (0, (/*@__PURE__*/$parcel$interopDefault($lwir9)))
            ]);
        }
    }, [
        optInStatus
    ]);
    const [showOptInModal, setShowOptInModal] = (0, $42omo.useState)(false);
    const triggerOptInFlow = (0, $42omo.useCallback)(()=>{
        if (edition !== null) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'triggerOptInFlow',
                actionSubject: 'editorAIOptInDialog',
                actionSubjectId: 'editorAIOptInTrigger',
                attributes: {
                    isOrgAdmin: isSiteAdmin,
                    optInType: edition === (0, $euL71.ConfluenceEdition).PREMIUM ? 'AIOptIn' : 'AIUpsell'
                }
            }
        }).fire();
        setShowOptInModal(true);
    }, [
        setShowOptInModal,
        createAnalyticsEvent,
        edition,
        isSiteAdmin
    ]);
    const AIOptInModal = (0, $42omo.useCallback)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        return showOptInModal && edition !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($618e6728be00f8eb$var$OptInModal, {
            onClose: onCloseModal,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            orgId: orgId,
            environment: environment
        }) : null;
    }, [
        showOptInModal,
        edition,
        isSiteAdmin,
        orgId,
        environment
    ]);
    if (optInStatus === 'disabled-opt-in') return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: AIOptInModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: $618e6728be00f8eb$var$defaultEmptyTrigger,
        AIOptInModal: $618e6728be00f8eb$var$defaultEmptyComponent
    };
};
const $618e6728be00f8eb$export$aa96168180a4e542 = (isAdminHubAIEnabled)=>{
    return isAdminHubAIEnabled ? 'enabled' : 'disabled';
};
module.exports["useEditorAIOptIn"] = $618e6728be00f8eb$export$90c93708fff010b3;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("5kEnh", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $3ouAo = parcelRequire("3ouAo");


var $gVzI4 = parcelRequire("gVzI4");


var $hA5CC = parcelRequire("hA5CC");


var $4LzvV = parcelRequire("4LzvV");

const $ad79fa1eeebb4272$var$VisibleTextOrgAdminStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $ad79fa1eeebb4272$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: (0, $gVzI4.AI_LINK),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $l998X.jsx)("a", {
                href: (0, $gVzI4.AI_LINK),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $l998X.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $hA5CC.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $42omo.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($3ouAo)))
        ]);
    }, []);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ouAo))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $ad79fa1eeebb4272$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $hA5CC.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4LzvV.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $l998X.jsxs)((0, $4LzvV.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $gVzI4.ADMIN_LINK),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $ad79fa1eeebb4272$export$2e2bcd8739ae039 = $ad79fa1eeebb4272$var$AiOptIn;
module.exports["default"] = $ad79fa1eeebb4272$export$2e2bcd8739ae039;

});

parcelRegister("3ouAo", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.cf053e66.svg", import.meta.url).toString();

});

parcelRegister("gVzI4", function(module, exports) {
const $30266e962d22c479$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $30266e962d22c479$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';
module.exports["AI_LINK"] = $30266e962d22c479$export$550fac1a4ec3d365;
module.exports["ADMIN_LINK"] = $30266e962d22c479$export$bae9a077d7ed5dfe;

});

parcelRegister("hA5CC", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $55820977c77a8e8c$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    /**
   * Messages for the AI Global Opt-in component
   */ aiOptInDialogHeaderText: {
        id: "ai-opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiOptInDialogBodyText: {
        id: "ai-opt-in.dialog.body.text",
        defaultMessage: "Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    aiOptInDialogLearnMoreLinkText: {
        id: "ai-opt-in.dialog.learn-more.link.text",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    aiOptInDialogAdminBodyText: {
        id: "ai-opt-in.dialog.admin.body.text",
        defaultMessage: "Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: "ai-opt-in.dialog.admin.maybe-later.button.text",
        defaultMessage: "Maybe later"
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: "ai-opt-in.dialog.admin.get-started.button.text",
        defaultMessage: "Get started"
    },
    aiOptInBannerBodyText: {
        id: "ai-opt-in.banner.body.text",
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it."
    },
    aiOptInBannerLearnMoreText: {
        id: "ai-opt-in.banner.learn.more.text",
        defaultMessage: "Learn more"
    },
    aiOptInAdminBannerBodyText: {
        id: "ai-opt-in.banner.admin.body.text",
        defaultMessage: "Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration."
    },
    aiOptInAdminOnlyVisible: {
        id: "ai-opt-in.admin.only.visible.text",
        defaultMessage: "This message is only visible to org admins."
    }
});
module.exports["messages"] = $55820977c77a8e8c$export$defe85febe8b728c;

});

parcelRegister("4LzvV", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $3161983b4d5922a4$export$24c280970213bb11 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $7sObp.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _11q71lxv _16qs130s _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1cku _1e0c1txw _1biu1cku _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81e3o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$14966827497f4695 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});
module.exports["OptInBackgroundBorder"] = $3161983b4d5922a4$export$24c280970213bb11;
module.exports["OptInContainer"] = $3161983b4d5922a4$export$a0fab83bea8ccf2e;
module.exports["ImageWrapper"] = $3161983b4d5922a4$export$75f07c36086c2c81;
module.exports["ContentContainer"] = $3161983b4d5922a4$export$9d2b4227a95687cc;
module.exports["HeaderWrapper"] = $3161983b4d5922a4$export$960a49cc3d27a090;
module.exports["BodyWrapper"] = $3161983b4d5922a4$export$14966827497f4695;
module.exports["ButtonContainer"] = $3161983b4d5922a4$export$eddf54ea3db8d0f0;

});

parcelRegister("42MJM", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cOrQJ = parcelRequire("cOrQJ");


var $inPa6 = parcelRequire("inPa6");


var $lHQAj = parcelRequire("lHQAj");


var $euL71 = parcelRequire("euL71");


var $cHKtk = parcelRequire("cHKtk");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20dc6939391e7f10$var$UpsellBackgroundBorder = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _1yt4v77o _11q7kwyp _16qs130s _1bsb1kdj _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _1yt4v77o _11q7kwyp _16qs130s _1bsb1kdj _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$var$UpsellContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20dc6939391e7f10$var$ImageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1cku _4t3iys9h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1cku _4t3iys9h",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zbay22hw _155npxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zbay22hw _155npxbi",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$export$38f23d3987aa9723 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { title: title, body: body, feature: feature, image: image, learnMoreLink: learnMoreLink, onRender: onRender } = t0;
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(`${feature}UpsellScreen`);
    let t1;
    if ($[0] !== learnMoreLink.message || $[1] !== showRequestUpgradeButton) {
        t1 = showRequestUpgradeButton ? {
            id: "change-edition.ai-upsell.learn-more.with-end-user-request-button",
            defaultMessage: "Learn more",
            description: "Learn more link label when end user request upgrade button is present"
        } : {
            id: "change-edition.ai-upsell.learn-more",
            defaultMessage: learnMoreLink.message
        };
        $[0] = learnMoreLink.message;
        $[1] = showRequestUpgradeButton;
        $[2] = t1;
    } else t1 = $[2];
    const learnMoreLinkMessageDescriptor = t1;
    const bannerImage = colorMode === "dark" ? image?.src.dark : image?.src.default;
    let t2;
    let t3;
    if ($[3] !== onRender) {
        t2 = ()=>{
            if (onRender) onRender();
        };
        t3 = [
            onRender
        ];
        $[3] = onRender;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== bannerImage) {
        t4 = ()=>{
            if (bannerImage) {
                const preloadImages = $20dc6939391e7f10$var$_temp2;
                preloadImages([
                    bannerImage
                ]);
            }
        };
        t5 = [
            bannerImage
        ];
        $[6] = bannerImage;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[9] !== createAnalyticsEvent || $[10] !== feature) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "aiUpsellDialog",
                    attributes: {
                        feature: feature
                    }
                }
            }).fire();
        };
        t7 = [
            createAnalyticsEvent,
            feature
        ];
        $[9] = createAnalyticsEvent;
        $[10] = feature;
        $[11] = t6;
        $[12] = t7;
    } else {
        t6 = $[11];
        t7 = $[12];
    }
    (0, $42omo.useEffect)(t6, t7);
    const t8 = `${feature}LearnMore`;
    let t9;
    if ($[13] !== learnMoreLink || $[14] !== learnMoreLinkMessageDescriptor || $[15] !== t8) {
        t9 = {
            ...learnMoreLink,
            messageDescriptor: learnMoreLinkMessageDescriptor,
            actionSubjectId: t8
        };
        $[13] = learnMoreLink;
        $[14] = learnMoreLinkMessageDescriptor;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    const t10 = `${feature}UpsellScreen`;
    const t11 = `${feature}TryPremium`;
    let t12;
    if ($[17] !== bannerImage) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ImageWrapper, {
            src: bannerImage
        });
        $[17] = bannerImage;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== body || $[20] !== loading || $[21] !== showRequestUpgradeButton || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t9 || $[26] !== title) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellBackgroundBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
            title: title,
            body: body,
            learnMoreLink: t9,
            source: t10,
            targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
            upgradeEditionActionSubjectId: t11,
            isLoadingRequestUpgradeButton: loading,
            showRequestUpgradeButton: showRequestUpgradeButton
        }, t12))));
        $[19] = body;
        $[20] = loading;
        $[21] = showRequestUpgradeButton;
        $[22] = t10;
        $[23] = t11;
        $[24] = t12;
        $[25] = t9;
        $[26] = title;
        $[27] = t13;
    } else t13 = $[27];
    return t13;
} : ({ title: title, body: body, feature: feature, image: image, learnMoreLink: learnMoreLink, onRender: onRender })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(`${feature}UpsellScreen`);
    const learnMoreLinkMessageDescriptor = (0, $42omo.useMemo)(()=>{
        return showRequestUpgradeButton ? {
            id: 'change-edition.ai-upsell.learn-more.with-end-user-request-button',
            defaultMessage: 'Learn more',
            description: 'Learn more link label when end user request upgrade button is present'
        } : {
            id: 'change-edition.ai-upsell.learn-more',
            defaultMessage: learnMoreLink.message
        };
    }, [
        showRequestUpgradeButton,
        learnMoreLink.message
    ]);
    const bannerImage = colorMode === 'dark' ? image?.src.dark : image?.src.default;
    (0, $42omo.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    (0, $42omo.useEffect)(()=>{
        if (bannerImage) {
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                bannerImage
            ]);
        }
    }, [
        bannerImage
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiUpsellDialog',
                attributes: {
                    feature: feature
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        feature
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellBackgroundBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$UpsellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
        title: title,
        body: body,
        learnMoreLink: {
            ...learnMoreLink,
            messageDescriptor: learnMoreLinkMessageDescriptor,
            actionSubjectId: `${feature}LearnMore`
        },
        source: `${feature}UpsellScreen`,
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        upgradeEditionActionSubjectId: `${feature}TryPremium`,
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($20dc6939391e7f10$var$ImageWrapper, {
        src: bannerImage
    })))));
};
function $20dc6939391e7f10$var$_temp(path) {
    const img = new Image();
    img.src = path;
}
function $20dc6939391e7f10$var$_temp2(paths) {
    paths.forEach($20dc6939391e7f10$var$_temp);
}
module.exports["AIUpsell"] = $20dc6939391e7f10$export$38f23d3987aa9723;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("4WmbV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");


var $5u7Ox = parcelRequire("5u7Ox");


var $kpYGL = parcelRequire("kpYGL");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(65);
    let footer;
    let grandfathered;
    let headerButton;
    let learnMoreLink;
    let onRequestUpgradeButtonClick;
    let onUpFlowOpen;
    let props;
    let secondaryLink;
    let source;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let targetEdition;
    if ($[0] !== t0) {
        ({ canShowUpgradeButton: t1, buttonConfig: t2, upgradeEditionActionSubjectId: t3, grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: t4, isLoadingRequestUpgradeButton: t5, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick, requestUpgradeButtonIsLoading: t6, ...props } = t0);
        $[0] = t0;
        $[1] = footer;
        $[2] = grandfathered;
        $[3] = headerButton;
        $[4] = learnMoreLink;
        $[5] = onRequestUpgradeButtonClick;
        $[6] = onUpFlowOpen;
        $[7] = props;
        $[8] = secondaryLink;
        $[9] = source;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = targetEdition;
    } else {
        footer = $[1];
        grandfathered = $[2];
        headerButton = $[3];
        learnMoreLink = $[4];
        onRequestUpgradeButtonClick = $[5];
        onUpFlowOpen = $[6];
        props = $[7];
        secondaryLink = $[8];
        source = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
        t6 = $[15];
        targetEdition = $[16];
    }
    const canShowUpgradeButton = t1 === undefined ? true : t1;
    const buttonConfig = t2 === undefined ? "default" : t2;
    const upgradeEditionActionSubjectId = t3 === undefined ? "freeTryNow" : t3;
    const showRequestUpgradeButton = t4 === undefined ? false : t4;
    const isLoadingRequestUpgradeButton = t5 === undefined ? false : t5;
    const requestUpgradeButtonIsLoading = t6 === undefined ? false : t6;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const t7 = Boolean(grandfathered);
    let t8;
    if ($[17] !== isSiteAdmin || $[18] !== t7) {
        t8 = {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: t7
        };
        $[17] = isSiteAdmin;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const CTAAnalyticsAttributes = t8;
    let t9;
    if ($[20] !== CTAAnalyticsAttributes || $[21] !== source) {
        t9 = (actionSubjectId)=>({
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: CTAAnalyticsAttributes
            });
        $[20] = CTAAnalyticsAttributes;
        $[21] = source;
        $[22] = t9;
    } else t9 = $[22];
    const generateCTAAnalyticsProps = t9;
    let t10;
    if ($[23] !== CTAAnalyticsAttributes || $[24] !== createAnalyticsEvent || $[25] !== source) {
        t10 = (clickEventActionSubjectId, linkMessage)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: clickEventActionSubjectId,
                    source: source,
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        linkMessage: linkMessage
                    }
                }
            }).fire();
        };
        $[23] = CTAAnalyticsAttributes;
        $[24] = createAnalyticsEvent;
        $[25] = source;
        $[26] = t10;
    } else t10 = $[26];
    const triggerLinkClickAnalytics = t10;
    let t11;
    if ($[27] !== secondaryLink || $[28] !== triggerLinkClickAnalytics) {
        t11 = ()=>{
            const link = secondaryLink;
            if (link) {
                triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
                if (typeof link.onClick === "function") link.onClick();
            }
        };
        $[27] = secondaryLink;
        $[28] = triggerLinkClickAnalytics;
        $[29] = t11;
    } else t11 = $[29];
    const handleSecondaryLinkClick = t11;
    let t12;
    let t13;
    if ($[30] !== CTAAnalyticsAttributes || $[31] !== createAnalyticsEvent || $[32] !== source) {
        t12 = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "changeEditionGatewayScreen",
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        source: source
                    }
                }
            }).fire();
        };
        t13 = [
            createAnalyticsEvent,
            CTAAnalyticsAttributes,
            source
        ];
        $[30] = CTAAnalyticsAttributes;
        $[31] = createAnalyticsEvent;
        $[32] = source;
        $[33] = t12;
        $[34] = t13;
    } else {
        t12 = $[33];
        t13 = $[34];
    }
    (0, $42omo.useEffect)(t12, t13);
    let T0;
    let t14;
    if ($[35] !== buttonConfig || $[36] !== canShowUpgradeButton || $[37] !== generateCTAAnalyticsProps || $[38] !== handleSecondaryLinkClick || $[39] !== isLoadingRequestUpgradeButton || $[40] !== isSiteAdmin || $[41] !== learnMoreLink || $[42] !== onRequestUpgradeButtonClick || $[43] !== onUpFlowOpen || $[44] !== props || $[45] !== requestUpgradeButtonIsLoading || $[46] !== secondaryLink || $[47] !== showRequestUpgradeButton || $[48] !== source || $[49] !== targetEdition || $[50] !== upgradeEditionActionSubjectId) {
        const renderButtons = ()=>{
            if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
                testId: "loading-end-user-request-upgrade-button-skeleton",
                width: "200px",
                height: "32px"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
                isSiteAdmin: isSiteAdmin,
                canShowUpgradeButton: canShowUpgradeButton,
                shouldShowLearnMore: !Boolean(secondaryLink),
                showRequestUpgradeButton: showRequestUpgradeButton
            }, (t15)=>{
                const { showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA } = t15;
                let primary;
                const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                    analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                    onUpFlowOpen: onUpFlowOpen,
                    targetEdition: targetEdition,
                    ...props
                }) : null;
                if (upgradeEditionButton) primary = upgradeEditionButton;
                else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                    source: source,
                    onRequestUpgradeButtonClick: onRequestUpgradeButtonClick,
                    requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading
                });
                let secondaries;
                if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                    if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                            appearance: "link"
                        })
                    ];
                    else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
            });
        };
        const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
            const withIcon = Boolean(learnMoreLink?.icon);
            const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || "default" : "link";
            const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
                appearance: learnMoreAppearance
            }) : null;
            const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                key: "secondLink",
                appearance: secondaryLink.appearance || "default",
                href: secondaryLink.href ? secondaryLink.href : undefined,
                id: "secondaryLink",
                spacing: "default",
                target: secondaryLink.target || "_blank",
                onClick: handleSecondaryLinkClick,
                testId: (0, $k4Vdy.calculateTestId)({
                    source: source,
                    actionSubjectId: secondaryLink.actionSubjectId
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryLink.messageDescriptor)) : null;
            return secondaryLink?.appearance === "primary" && learnMoreAppearance !== "primary" ? [
                secondaryLinkComponent,
                learnMoreButton
            ] : [
                learnMoreButton,
                secondaryLinkComponent
            ];
        };
        const renderLearnMoreLink = (t16)=>{
            const { children: children, ...learnMoreProps } = t16;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
                key: "learnMore",
                analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || "freeLearnMore"),
                appearance: learnMoreLink?.appearance || "default",
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                inProductHelpId: learnMoreLink?.inProductHelpId,
                inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
                href: learnMoreLink?.href,
                icon: learnMoreLink?.icon,
                ariaLabel: learnMoreLink?.ariaLabel,
                ...learnMoreProps,
                onClick: learnMoreLink?.onClick
            }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
        };
        T0 = (0, $bhvFb.EditionSectionMessage);
        t14 = buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined;
        $[35] = buttonConfig;
        $[36] = canShowUpgradeButton;
        $[37] = generateCTAAnalyticsProps;
        $[38] = handleSecondaryLinkClick;
        $[39] = isLoadingRequestUpgradeButton;
        $[40] = isSiteAdmin;
        $[41] = learnMoreLink;
        $[42] = onRequestUpgradeButtonClick;
        $[43] = onUpFlowOpen;
        $[44] = props;
        $[45] = requestUpgradeButtonIsLoading;
        $[46] = secondaryLink;
        $[47] = showRequestUpgradeButton;
        $[48] = source;
        $[49] = targetEdition;
        $[50] = upgradeEditionActionSubjectId;
        $[51] = T0;
        $[52] = t14;
    } else {
        T0 = $[51];
        t14 = $[52];
    }
    let t15;
    if ($[53] !== footer || $[54] !== isSiteAdmin) {
        t15 = isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null;
        $[53] = footer;
        $[54] = isSiteAdmin;
        $[55] = t15;
    } else t15 = $[55];
    let t16;
    if ($[56] !== headerButton) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton);
        $[56] = headerButton;
        $[57] = t16;
    } else t16 = $[57];
    let t17;
    if ($[58] !== T0 || $[59] !== props || $[60] !== t14 || $[61] !== t15 || $[62] !== t16 || $[63] !== targetEdition) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            actions: t14,
            edition: targetEdition,
            footer: t15,
            headerButton: t16,
            ...props
        });
        $[58] = T0;
        $[59] = props;
        $[60] = t14;
        $[61] = t15;
        $[62] = t16;
        $[63] = targetEdition;
        $[64] = t17;
    } else t17 = $[64];
    return t17;
} : ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick, requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            testId: "loading-end-user-request-upgrade-button-skeleton",
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !Boolean(secondaryLink),
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                source: source,
                onRequestUpgradeButtonClick: onRequestUpgradeButtonClick,
                requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading
            });
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("iJ9aA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $bsrY7 = parcelRequire("bsrY7");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(40);
    let { analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: t1, isGrandfathered: t2, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps } = t0;
    const targetEdition = t1 === undefined ? (0, $euL71.ConfluenceEdition).STANDARD : t1;
    const isGrandfathered = t2 === undefined ? false : t2;
    const intl = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    let t3;
    if ($[0] !== children) {
        t3 = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
        $[0] = children;
        $[1] = t3;
    } else t3 = $[1];
    const message = t3;
    const iconOnly = icon && !message;
    let t4;
    let t5;
    if ($[2] !== experienceTracker || $[3] !== showUpFlow) {
        t4 = ()=>()=>{
                if (!showUpFlow) experienceTracker.abort({
                    name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                    reason: "Canceled by user"
                });
            };
        t5 = [
            experienceTracker,
            showUpFlow
        ];
        $[2] = experienceTracker;
        $[3] = showUpFlow;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== actionSubjectId || $[7] !== analyticsProps || $[8] !== createAnalyticsEvent || $[9] !== edition || $[10] !== experienceTracker || $[11] !== isSiteAdmin || $[12] !== showUpFlow || $[13] !== source || $[14] !== targetEdition) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "freeLearnMore",
                    ...analyticsProps,
                    attributes: {
                        currentEdition: edition,
                        isSiteAdmin: isSiteAdmin,
                        linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                        targetEdition: targetEdition,
                        ...analyticsProps.attributes
                    }
                }
            }).fire();
            experienceTracker.start({
                name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: edition,
                    linkClicked: actionSubjectId || "freeLearnMore",
                    source: source,
                    targetEdition: targetEdition
                }
            });
        };
        $[6] = actionSubjectId;
        $[7] = analyticsProps;
        $[8] = createAnalyticsEvent;
        $[9] = edition;
        $[10] = experienceTracker;
        $[11] = isSiteAdmin;
        $[12] = showUpFlow;
        $[13] = source;
        $[14] = targetEdition;
        $[15] = t6;
    } else t6 = $[15];
    const fireClickAnalytics = t6;
    let t7;
    if ($[16] !== onUpFlowOpen) {
        t7 = ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) setIsUpFlowOpen(false);
        };
        $[16] = onUpFlowOpen;
        $[17] = t7;
    } else t7 = $[17];
    const onUpFlowClose = t7;
    const renderLearnMoreButton = (t8)=>{
        const props = t8 === undefined ? {} : t8;
        if (appearance === "inline-link") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            className: appearance === "subtle-link" ? undefined : "primaryButton",
            id: "learnMoreLink",
            spacing: iconOnly ? "none" : "default",
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    let t9;
    if ($[18] !== createAnalyticsEvent || $[19] !== inProductHelpId) {
        t9 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "helpLink",
                    source: "adminKeyUpSell",
                    attributes: {
                        targetArticleId: inProductHelpId,
                        isSPA: true
                    }
                }
            }).fire();
        };
        $[18] = createAnalyticsEvent;
        $[19] = inProductHelpId;
        $[20] = t9;
    } else t9 = $[20];
    const fireAnalyticsEvent = t9;
    if (isGrandfathered && !isSiteAdmin) return null;
    if (!href) href = showUpFlow ? "#" : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith("#") ? undefined : "_blank";
    let t10;
    if ($[21] !== fireClickAnalytics || $[22] !== onClick || $[23] !== showUpFlow || $[24] !== target) {
        t10 = (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        };
        $[21] = fireClickAnalytics;
        $[22] = onClick;
        $[23] = showUpFlow;
        $[24] = target;
        $[25] = t10;
    } else t10 = $[25];
    const buttonProps = {
        target: target,
        href: href,
        onClick: t10,
        "aria-label": ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    const t11 = !showUpFlow && inProductHelpId && inProductHelpTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps);
    let t12;
    if ($[26] !== cloudId || $[27] !== edition || $[28] !== isSiteAdmin || $[29] !== isUpFlowOpen || $[30] !== onUpFlowClose || $[31] !== onUpFlowOpen || $[32] !== showUpFlow || $[33] !== source || $[34] !== targetEdition || $[35] !== userId) {
        t12 = showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            cloudId: cloudId,
            atlassianAccountId: userId || undefined,
            canChangeEdition: isSiteAdmin,
            currentEdition: edition || undefined,
            targetEdition: targetEdition,
            flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
            product: "confluence",
            touchpointId: source,
            onClose: onUpFlowClose,
            onOpen: onUpFlowOpen,
            isExperienceTrackerEnabled: true,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
        $[26] = cloudId;
        $[27] = edition;
        $[28] = isSiteAdmin;
        $[29] = isUpFlowOpen;
        $[30] = onUpFlowClose;
        $[31] = onUpFlowOpen;
        $[32] = showUpFlow;
        $[33] = source;
        $[34] = targetEdition;
        $[35] = userId;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== t11 || $[38] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t11, t12);
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
} : ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $42omo.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("gYAjp"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("gYAjp", function(module, exports) {

let $c5be6abedcfce6ba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5be6abedcfce6ba$var$load("6jGZ7"),
    $c5be6abedcfce6ba$var$load("82QsP")
]).then(()=>parcelRequire('lcEzf'));

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("f7Bnv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("iC1wS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== internalData) {
        t0 = (data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData);
        $[0] = internalData;
        $[1] = t0;
    } else t0 = $[1];
    const wrapAnalyticsEventPayload = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== wrapAnalyticsEventPayload) {
        t1 = (initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        $[2] = createAnalyticsEvent;
        $[3] = wrapAnalyticsEventPayload;
        $[4] = t1;
    } else t1 = $[4];
    const wrappedCreateAnalyticsEvent = t1;
    let t2;
    if ($[5] !== wrapAnalyticsEventPayload || $[6] !== wrappedCreateAnalyticsEvent) {
        t2 = {
            createAnalyticsEvent: wrappedCreateAnalyticsEvent,
            wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
        };
        $[5] = wrapAnalyticsEventPayload;
        $[6] = wrappedCreateAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $42omo.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, customAttributes: t1 } = t0;
    const customAttributes = t1 === undefined ? $8ea1c6a3abbe8170$var$emptyAttributes : t1;
    let t2;
    if ($[0] !== customAttributes) {
        t2 = {
            customAttributes: customAttributes
        };
        $[0] = customAttributes;
        $[1] = t2;
    } else t2 = $[1];
    const editionsAnalyticsContextValue = t2;
    let t3;
    if ($[2] !== children || $[3] !== editionsAnalyticsContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
            value: editionsAnalyticsContextValue
        }, children);
        $[2] = children;
        $[3] = editionsAnalyticsContextValue;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $42omo.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
        const $ = (0, $frIzR.c)(3);
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        let t0;
        if ($[0] !== context || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                ...props,
                ...context
            });
            $[0] = context;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $12IaO = parcelRequire("12IaO");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($12IaO)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("ki6F7", function(module, exports) {

var $ey6Pt = parcelRequire("ey6Pt");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4KS7f = parcelRequire("4KS7f");


var $ccHMk = parcelRequire("ccHMk");


var $izVB4 = parcelRequire("izVB4");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $ij4CE = parcelRequire("ij4CE");


var $2UjZJ = parcelRequire("2UjZJ");


var $gsZdA = parcelRequire("gsZdA");


var $5M47w = parcelRequire("5M47w");


var $dqdrq = parcelRequire("dqdrq");


var $ktelT = parcelRequire("ktelT");


var $l0DoV = parcelRequire("l0DoV");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $fDbEj = parcelRequire("fDbEj");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");




const $3615035320db7a8b$var$i18n = (0, $aXWIB.defineMessages)({
    tryItFree: {
        id: "change-edition.upgrade.try.free",
        defaultMessage: "Try it free"
    },
    tryItNow: {
        id: "change-edition.upgrade.try.now",
        defaultMessage: "Try it now"
    },
    tryPremium: {
        id: "change-edition.upgrade.try.premium",
        defaultMessage: "Try Premium"
    }
});
const $3615035320db7a8b$var$editionMap = {
    [(0, $euL71.ConfluenceEdition).FREE]: (0, $5M47w.CommerceDeepLinksTargetEdition).FREE,
    [(0, $euL71.ConfluenceEdition).STANDARD]: (0, $5M47w.CommerceDeepLinksTargetEdition).STANDARD,
    [(0, $euL71.ConfluenceEdition).PREMIUM]: (0, $5M47w.CommerceDeepLinksTargetEdition).PREMIUM
};
const $3615035320db7a8b$var$determineButtonComponent = (appearance)=>{
    if (appearance === 'primary') return 0, $dqdrq.GradientCTAButton;
    if (appearance === 'subtle-link') return 0, $ktelT.GradientSubtleLinkButton;
    return 0, $4KS7f.default;
};
const $3615035320db7a8b$var$extractUpsellDeepLink = (deepLink)=>{
    // If deepLink is not a string, return error type for debugging
    if (!deepLink) return undefined;
    if (typeof deepLink !== 'string') return `ERROR_TYPE:${typeof deepLink}`;
    // Extract the base URL without query parameters
    return deepLink.split('?')[0];
};
const $3615035320db7a8b$export$2f4bd8d23e81b246 = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const [openUpFlow, setOpenUpFlow] = (0, $42omo.useState)(false);
    const [pollingError, setPollingError] = (0, $42omo.useState)();
    const { cloudId: cloudId, edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $ey6Pt.default),
        fragmentArtifact: (0, $ey6Pt.default)
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // free -> standard: upflow spa;
    // free/standard -> premium: adminhub
    const showUpFlow = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD;
    const { cohort: upflowV2ExperimentCohort, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, loading: upflowV2EligibilityHookLoading } = (0, $2UjZJ.useUpflowV2ConfluenceStandardFGsExperiment)({
        skip: !showUpFlow || !openUpFlow,
        touchpointId: source,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    const { commerceBackendName: commerceBackendName, planConsentDeepLink: planConsentDeepLink, errorMessage: commerceDeepLinksError } = (0, $5M47w.useCommerceDeepLinks)({
        targetEdition: $3615035320db7a8b$var$editionMap[targetEdition],
        skipDeepLinks: showUpFlow
    });
    (0, $42omo.useEffect)(()=>()=>{
            // 1. With upflow enabled, when the user clicks on the upgrade CTA, the
            //    upflow dialog opens and this component unmounts; the upsell experience
            //    continues and experience tracking is subsequently handled by the
            //    UpFlow component.
            // or
            // 2. With upflow DISabled, unmounting here simply means user navigated away
            //    from the upsell UI and we DO want to signal an aborted experience.
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    (0, $42omo.useEffect)(()=>{
        // Using a TRACK event for tacking the traffic to the UpgradeEditionButton.
        // This will help us gauage Commerce API traffic to compute the deep links.
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition
                }
            }
        }).fire();
    // We only need this to fire once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireClickAnalytics = ()=>{
        if (attributes) {
            attributes.currentEdition = currentEdition;
            attributes.targetEdition = targetEdition;
            attributes.commerceBackend = commerceBackendName;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: attributes
            }
        }).fire();
        if (commerceDeepLinksError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'useCommerceDeepLinks',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    upsellDeepLink: $3615035320db7a8b$var$extractUpsellDeepLink(planConsentDeepLink),
                    errorMessage: commerceDeepLinksError
                }
            }
        }).fire();
    };
    const onTryWithoutUpFlowClick = async ()=>{
        if (onUpgradeButtonClick) onUpgradeButtonClick();
        // start polling and reload the page when done
        try {
            const updatedEdition = await (0, $fDbEj.waitForEditionChange)(currentEdition, writeFragmentInterop);
            experienceTracker.succeed({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: currentEdition,
                    targetEdition: updatedEdition
                }
            });
            // Default behavior
            window.location.reload();
        } catch (error) {
            if (error === (0, $fDbEj.TimeoutError)) // We don't expect the user to always proceed to upgrade in Admin Hub after seeing the estimated billing info.
            experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Possibly canceled by user'
            });
            else {
                (0, $fGzMp.stopExperienceOnError)((0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE), error);
                setPollingError(error);
            }
        }
    };
    const onUpFlowClose = ()=>{
        setOpenUpFlow(false);
    };
    const onTryButtonClick = ()=>{
        // we always want to fire both the exposure event as well as the click event
        fireClickAnalytics();
        // start the experience tracker
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition,
                linkClicked: actionSubjectId,
                source: source,
                targetEdition: targetEdition
            }
        });
        // then handle the click behaviour based on FF
        if (showUpFlow) setOpenUpFlow(true);
        else onTryWithoutUpFlowClick();
    };
    const buttonProps = {
        appearance: appearance,
        className: 'primaryButton',
        href: showUpFlow ? undefined : planConsentDeepLink,
        onClick: onTryButtonClick,
        target: showUpFlow ? undefined : '_blank',
        iconBefore: appearance === 'primary' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined,
        testId: (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        })
    };
    const upflowV2ExperimentButtonProps = {
        appearance: appearance,
        testId: 'upflowV2ExperimentLoadingButton',
        isDisabled: true,
        isLoading: true,
        iconBefore: appearance === 'primary' ? (0, (/*@__PURE__*/$parcel$interopDefault($izVB4))) : undefined
    };
    const buttonChildren = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3615035320db7a8b$var$i18n.tryItFree);
    const ButtonComponent = $3615035320db7a8b$var$determineButtonComponent(appearance);
    const renderModalContent = ()=>{
        if (upflowV2EligibilityHookLoading) return null;
        if (upflowV2ExperimentCohort === 'variation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l0DoV.TryStandardUpflowV2ExperimentTreatmentModalLoadable), {
            isOpen: openUpFlow,
            closeModal: onUpFlowClose,
            touchpointId: source,
            targetEdition: targetEdition,
            isBillingAdmin: isBillingAdmin,
            isSiteAdmin: isSiteAdmin,
            currentEdition: currentEdition
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            canChangeEdition: true // this component should only ever be used for site admins
            ,
            cloudId: cloudId,
            currentEdition: currentEdition || undefined,
            atlassianAccountId: userId || undefined,
            flow: "upgrade",
            product: "confluence",
            targetEdition: targetEdition,
            touchpointId: source,
            isExperienceTrackerEnabled: true,
            onClose: // Note: onUpFlowOpen function closes the parent component which
            // means we don't need to trigger the onClose.
            onUpFlowOpen ? undefined : onUpFlowClose,
            onOpen: onUpFlowOpen,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pollingError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: pollingError
    }) : null, upflowV2EligibilityHookLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), upflowV2ExperimentButtonProps, buttonChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, buttonProps, buttonChildren), showUpFlow && openUpFlow ? renderModalContent() : null);
};
module.exports["UpgradeEditionButton"] = $3615035320db7a8b$export$2f4bd8d23e81b246;

});

parcelRegister("ey6Pt", function(module, exports) {
/**
 * @generated SignedSource<<fc69fbf29eae12ee72060bd72bafc119>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $377a05a3faea70b3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "UpgradeEditionButtonFragment",
        "selections": [
            {
                "concreteType": "Editions",
                "kind": "LinkedField",
                "name": "editions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "confluence"
                    },
                    v0 /*: any*/ 
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "ConfluenceTenantContext"
    };
}();
$377a05a3faea70b3$var$node.hash = "bee007bb99f1be1656322a1f41effd37";
var $377a05a3faea70b3$export$2e2bcd8739ae039 = $377a05a3faea70b3$var$node;
module.exports["default"] = $377a05a3faea70b3$export$2e2bcd8739ae039;

});

parcelRegister("izVB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a9109095f0a9b69c0b01202dc3ed5e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8682c67cc42b6ad$var$_react = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8682c67cc42b6ad$var$_baseNew = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8682c67cc42b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8682c67cc42b6ad$var$EditionsIcon = (props)=>/*#__PURE__*/ $d8682c67cc42b6ad$var$_react.default.createElement($d8682c67cc42b6ad$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$d8682c67cc42b6ad$var$EditionsIcon.displayName = 'EditionsIcon';
var $d8682c67cc42b6ad$var$_default = module.exports.default = $d8682c67cc42b6ad$var$EditionsIcon;

});

parcelRegister("2UjZJ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $gXR0B = parcelRequire("gXR0B");


var $f1B2z = parcelRequire("f1B2z");

const $dd8da84ad086336b$export$2bbc11bf12d076a0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition } = t0;
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] !== currentEdition || $[1] !== skip || $[2] !== targetEdition) {
        t1 = {
            skip: skip,
            currentEdition: currentEdition,
            targetEdition: targetEdition
        };
        $[0] = currentEdition;
        $[1] = skip;
        $[2] = targetEdition;
        $[3] = t1;
    } else t1 = $[3];
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)(t1);
    let t2;
    let t3;
    if ($[4] !== currentEdition || $[5] !== eligibilityHookError || $[6] !== fireExperimentExposureEvent || $[7] !== isBillingAdmin || $[8] !== isEligible || $[9] !== isSiteAdmin || $[10] !== targetEdition || $[11] !== touchpointId) {
        t2 = ()=>{
            if (isEligible) {
                fireExperimentExposureEvent({
                    flagKey: "grw-1930_confluence_upv2_standard_ab",
                    cohort: (0, $6mKj3.expVal)("grw-1930_confluence_upv2_standard_ab", "cohort", "not-enrolled"),
                    growthInitiative: "luna",
                    touchpointId: touchpointId,
                    additionalAttributes: {
                        currentEdition: currentEdition,
                        targetEdition: targetEdition,
                        isSiteAdmin: isSiteAdmin,
                        isBillingAdmin: isBillingAdmin
                    }
                });
                setAbCohort((0, $6mKj3.expVal)("grw-1930_confluence_upv2_standard_ab", "cohort", "not-enrolled"));
            } else if (eligibilityHookError) setAbCohort(null);
            else setAbCohort("not-enrolled");
        };
        t3 = [
            fireExperimentExposureEvent,
            isEligible,
            eligibilityHookError,
            currentEdition,
            targetEdition,
            isSiteAdmin,
            isBillingAdmin,
            touchpointId
        ];
        $[4] = currentEdition;
        $[5] = eligibilityHookError;
        $[6] = fireExperimentExposureEvent;
        $[7] = isBillingAdmin;
        $[8] = isEligible;
        $[9] = isSiteAdmin;
        $[10] = targetEdition;
        $[11] = touchpointId;
        $[12] = t2;
        $[13] = t3;
    } else {
        t2 = $[12];
        t3 = $[13];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[14] !== abCohort || $[15] !== eligibilityHookError || $[16] !== eligibilityHookLoading || $[17] !== isBillingAdmin || $[18] !== isSiteAdmin) {
        t4 = {
            cohort: abCohort,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin,
            loading: eligibilityHookLoading,
            error: eligibilityHookError
        };
        $[14] = abCohort;
        $[15] = eligibilityHookError;
        $[16] = eligibilityHookLoading;
        $[17] = isBillingAdmin;
        $[18] = isSiteAdmin;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : ({ skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $42omo.useState)(null);
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)({
        skip: skip,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    (0, $42omo.useEffect)(()=>{
        if (isEligible) {
            fireExperimentExposureEvent({
                flagKey: 'grw-1930_confluence_upv2_standard_ab',
                cohort: (0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'),
                growthInitiative: 'luna',
                touchpointId: touchpointId,
                additionalAttributes: {
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    isSiteAdmin: isSiteAdmin,
                    isBillingAdmin: isBillingAdmin
                }
            });
            setAbCohort((0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'));
        } else if (eligibilityHookError) // Error occurred, reset to null
        setAbCohort(null);
        else setAbCohort('not-enrolled');
    }, [
        fireExperimentExposureEvent,
        isEligible,
        eligibilityHookError,
        currentEdition,
        targetEdition,
        isSiteAdmin,
        isBillingAdmin,
        touchpointId
    ]);
    return {
        cohort: abCohort,
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: eligibilityHookLoading,
        error: eligibilityHookError
    };
};
module.exports["useUpflowV2ConfluenceStandardFGsExperiment"] = $dd8da84ad086336b$export$2bbc11bf12d076a0;

});

parcelRegister("gXR0B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $c07cc869290551b6$export$5218ddb3d9c658c0 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const sentFlagKeys = (0, $42omo.useRef)(t0);
    let t1;
    if ($[1] !== createAnalyticsEvent) {
        t1 = (t2)=>{
            const { flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: t3 } = t2;
            const additionalAttributes = t3 === undefined ? {} : t3;
            const flagTouchpointKey = `${flagKey}:${touchpointId}`;
            if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "exposed",
                    actionSubject: "experiment",
                    actionSubjectId: `${flagKey}-exposed`,
                    source: flagKey,
                    attributes: {
                        cohort: cohort,
                        touchpointId: touchpointId,
                        growthInitiative: growthInitiative,
                        ...additionalAttributes
                    }
                }
            }).fire();
            sentFlagKeys.current.push(flagTouchpointKey);
        };
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sentFlagKeys = (0, $42omo.useRef)([]);
    // This ensures the experiment exposure event is only fired once per flagKey / touchpoint combination.
    return (0, $42omo.useCallback)(({ flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: additionalAttributes = {} })=>{
        const flagTouchpointKey = `${flagKey}:${touchpointId}`;
        if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'experiment',
                actionSubjectId: `${flagKey}-exposed`,
                source: flagKey,
                attributes: {
                    cohort: cohort,
                    touchpointId: touchpointId,
                    growthInitiative: growthInitiative,
                    ...additionalAttributes
                }
            }
        }).fire();
        sentFlagKeys.current.push(flagTouchpointKey);
    }, [
        createAnalyticsEvent
    ]);
};
module.exports["useFeatureExposedAnalytics"] = $c07cc869290551b6$export$5218ddb3d9c658c0;

});

parcelRegister("f1B2z", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $iFJDd = parcelRequire("iFJDd");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $1ytiN = parcelRequire("1ytiN");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $euL71 = parcelRequire("euL71");


var $jMyy4 = parcelRequire("jMyy4");

const $26baada861c32413$var$extractBillingAdminStatus = (billingData)=>{
    return billingData?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
};
const $26baada861c32413$export$6da6d4db5c51c32 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { skip: t1, currentEdition: currentEdition, targetEdition: targetEdition } = t0;
    const skip = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gKr8t.getAGGClient)();
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== cloudId) {
        t3 = {
            cloudId: cloudId
        };
        $[1] = cloudId;
        $[2] = t3;
    } else t3 = $[2];
    const t4 = skip || !isBasicEligible;
    let t5;
    if ($[3] !== t3 || $[4] !== t4) {
        t5 = {
            client: t2,
            variables: t3,
            skip: t4
        };
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $iFJDd.default), t5);
    let t6;
    let t7;
    if ($[6] !== billingAdminQueryError || $[7] !== createAnalyticsEvent) {
        t6 = ()=>{
            if (billingAdminQueryError) {
                const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                    product: (0, $gwZbZ.Product).CONFLUENCE,
                    team: (0, $6o7wX.Team).GROWTH_LUNA,
                    experimentMeta: {
                        experimentKey: "grw-1930_confluence_upv2_standard_ab"
                    },
                    errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                    errorMessage: billingAdminQueryError.message,
                    source: "useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook",
                    severity: (0, $gwZbZ.Severity).HIGH
                });
                createAnalyticsEvent(eventPayload).fire();
            }
        };
        t7 = [
            billingAdminQueryError,
            createAnalyticsEvent
        ];
        $[6] = billingAdminQueryError;
        $[7] = createAnalyticsEvent;
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[10] !== billingAdminData) {
        t8 = $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
        $[10] = billingAdminData;
        $[11] = t8;
    } else t8 = $[11];
    const isBillingAdmin = t8;
    const t9 = Boolean(isBasicEligible && isBillingAdmin);
    let t10;
    if ($[12] !== billingAdminQueryError || $[13] !== isBillingAdmin || $[14] !== isBillingAdminQueryLoading || $[15] !== isSiteAdmin || $[16] !== t9) {
        t10 = {
            isEligible: t9,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin,
            loading: isBillingAdminQueryLoading,
            error: billingAdminQueryError
        };
        $[12] = billingAdminQueryError;
        $[13] = isBillingAdmin;
        $[14] = isBillingAdminQueryLoading;
        $[15] = isSiteAdmin;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ skip: skip = false, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $iFJDd.default), {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            cloudId: cloudId
        },
        skip: skip || !isBasicEligible
    });
    (0, $42omo.useEffect)(()=>{
        if (billingAdminQueryError) {
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'grw-1930_confluence_upv2_standard_ab'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: billingAdminQueryError.message,
                source: 'useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook',
                severity: (0, $gwZbZ.Severity).HIGH
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, [
        billingAdminQueryError,
        createAnalyticsEvent
    ]);
    const isBillingAdmin = (0, $42omo.useMemo)(()=>{
        return $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
    }, [
        billingAdminData
    ]);
    return {
        isEligible: Boolean(isBasicEligible && isBillingAdmin),
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: isBillingAdminQueryLoading,
        error: billingAdminQueryError
    };
};
module.exports["useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment"] = $26baada861c32413$export$6da6d4db5c51c32;

});

parcelRegister("iFJDd", function(module, exports) {
/**
 * @generated SignedSource<<2d2eb55a6d40c6755a6ab9f268f6755e>>
 * @relayHash f9ca0c6d46f517f6d908bd327972e2da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3e73d4b2171a44acf3020206988b6e04ee509d46422cdee27046a9cfd3e6cd6
const $a78c8196dfce8e13$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f9ca0c6d46f517f6d908bd327972e2da",
            "id": "d3e73d4b2171a44acf3020206988b6e04ee509d46422cdee27046a9cfd3e6cd6",
            "metadata": {},
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlement{__typename,id,transactionAccount{__typename,...on Node{__isNode:__typename,id,__typename},isCurrentUserBillingAdmin}}}}}"
        }
    };
}();
$a78c8196dfce8e13$var$node.hash = "5ffb5864cc8b6acf0f584617c954e009";
var $a78c8196dfce8e13$export$2e2bcd8739ae039 = $a78c8196dfce8e13$var$node;
module.exports["default"] = $a78c8196dfce8e13$export$2e2bcd8739ae039;

});

parcelRegister("8hmrm", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $gvWCD = parcelRequire("gvWCD");


var $3HIy9 = parcelRequire("3HIy9");


var $39G0n = parcelRequire("39G0n");

const $31b517e9b4290477$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $39G0n.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $gvWCD.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $gwZbZ.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $gwZbZ.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $3HIy9.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $3HIy9.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $gwZbZ.Product).CONFLUENCE:
            return {
                type: (0, $gwZbZ.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $31b517e9b4290477$export$8c06ae8e7f403dea;

});

parcelRegister("gwZbZ", function(module, exports) {
const $64e202edaa8eb03b$export$ec4825154d679381 = 'error';
const $64e202edaa8eb03b$export$a924d1f92c0e2e78 = 'growth-experiment';
const $64e202edaa8eb03b$export$e5025d93161b0712 = 'sendOperationalEvent';
const $64e202edaa8eb03b$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $64e202edaa8eb03b$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $64e202edaa8eb03b$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $64e202edaa8eb03b$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $64e202edaa8eb03b$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $64e202edaa8eb03b$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $64e202edaa8eb03b$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $64e202edaa8eb03b$export$e5025d93161b0712;
module.exports["Product"] = $64e202edaa8eb03b$export$264ad599d7cef668;
module.exports["ErrorType"] = $64e202edaa8eb03b$export$dba1278861bf0dc1;
module.exports["Severity"] = $64e202edaa8eb03b$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $64e202edaa8eb03b$export$a61493d7ab73936;

});

parcelRegister("gvWCD", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");

const $d2a9f5f63821177b$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $gwZbZ.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $gwZbZ.ERROR_ACTION),
        actionSubject: (0, $gwZbZ.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $gwZbZ.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $d2a9f5f63821177b$export$f2a94361d01a626c;

});

parcelRegister("3HIy9", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $8hmrm = parcelRequire("8hmrm");

const $de70a0c4deb210a2$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $de70a0c4deb210a2$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $de70a0c4deb210a2$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $gwZbZ.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $de70a0c4deb210a2$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $de70a0c4deb210a2$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $de70a0c4deb210a2$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $de70a0c4deb210a2$export$2144cc21b87dd554;

});

parcelRegister("39G0n", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $34ecc222054f7431$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $34ecc222054f7431$export$7fa6b5da621cbeb2;

});

parcelRegister("6o7wX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $7d6dde24ede24951$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $7d6dde24ede24951$export$3e5d0af8e738b082;

});

parcelRegister("5M47w", function(module, exports) {

var $63Hn9 = parcelRequire("63Hn9");


var $jJ96k = parcelRequire("jJ96k");


var $42omo = parcelRequire("42omo");


var $6Co6F = parcelRequire("6Co6F");


var $6bHqX = parcelRequire("6bHqX");


var $lzcvT = parcelRequire("lzcvT");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $lh1MN = parcelRequire("lh1MN");


var $hfUvC = parcelRequire("hfUvC");


var $jMyy4 = parcelRequire("jMyy4");

var $ae96eb60e6557b8b$export$92b15cc7e26a62fb = /*#__PURE__*/ function(CommerceDeepLinksTargetEdition) {
    CommerceDeepLinksTargetEdition["FREE"] = "free";
    CommerceDeepLinksTargetEdition["STANDARD"] = "standard";
    CommerceDeepLinksTargetEdition["PREMIUM"] = "premium";
    return CommerceDeepLinksTargetEdition;
}({});
const $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS = {
    PRODUCTION: 'https://admin.atlassian.com',
    STAGING: 'https://admin.stg.atlassian.com'
};
const $ae96eb60e6557b8b$export$16287b6da0e34b4e = '/admin/billing/applications/change-edition/confluence.ondemand';
const $ae96eb60e6557b8b$export$4591cf268e289775 = '/admin/billing/applications';
const $ae96eb60e6557b8b$var$addAtlOriginToUrl = (url)=>{
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
const $ae96eb60e6557b8b$export$39685ba9de2c4192 = ({ cloudId: cloudId, environment: environment, orgId: orgId })=>{
    const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
    if (orgId || cloudId) return orgId ? `${CLOUD_ADMIN_URL}/o/${orgId}/billing-preview` : `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
    // In an extreme case where we cannot detect cloudId or orgId, we route user to main AdminHub page.
    return CLOUD_ADMIN_URL;
};
const $ae96eb60e6557b8b$var$buildPlanSelectionLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, transactionAccountId: transactionAccountId, orgId: orgId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$16287b6da0e34b4e;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?referrer=[referrer]
        // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=confluence`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildPlanConsentLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, entitlementId: entitlementId, environment: environment, orgId: orgId, transactionAccountId: transactionAccountId, targetEdition: targetEdition } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}/${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?offeringName=[offering name]&referrer=[referrer]
    // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2820329173/How+to+Deeplink+change+plan+consent
    return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}&offeringName=${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildSubscriptionDetailsLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, orgId: orgId, transactionAccountId: transactionAccountId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$4591cf268e289775;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
// (Concept is adopted from Kent C. Dodds here:
//  https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript)
const $ae96eb60e6557b8b$var$getErrorMessage = (label, error)=>{
    const message = error instanceof Error ? error.message : String(error);
    return `${label}: ${message}`;
};
const $ae96eb60e6557b8b$export$91505ae0b86ded0b = ({ targetEdition: targetEdition, skipDeepLinks: skipDeepLinks = false })=>{
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    if (!isSiteAdmin || !cloudId) skipDeepLinks = true;
    /**
   * The best practice advocates for one graphql per component and ideally no graphql quries in a hook
   * but to construct the deeplink, we need to:
   * 1. first call Commerce API to retrieve the Confluence instance backend service (CCP or HAMS),
   * 2. for CCP, call ccgraphql to retrieve the ccpEntitlementId
   * 3. for CCP, call AGG to retrieve the CCP transaction account Id using the ccpEntitlementId retrieved in step #2.
   *
   * This is a stop gap solution while we work with Commerce to eventually have one AGG query
   * to provide everything we need with just a CloudId and the product key (e.g. confluence
   */ const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $hfUvC.useCommerceRolloutInformation)(skipDeepLinks || (0, $lzcvT.isFedRamp)());
    // If it is in FedRamp, we can assume it is CCP backend.
    // More details -> https://atlassian.slack.com/archives/C04LF8UKAE4/p1734981625650579
    const isCcpBackend = commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) || (0, $lzcvT.isFedRamp)();
    const { data: ccpEntitlementIdData, loading: ccpEntitlementIdLoading, error: ccpEntitlementIdError } = (0, $jMyy4.useQueryInterop)(/** @schema cc */ (0, $jJ96k.default), {
        skip: skipDeepLinks || !isCcpBackend
    });
    const ccpEntitlementId = !ccpEntitlementIdLoading ? (0, $lh1MN.getCcpEntitlementFromQuery)(ccpEntitlementIdData) : undefined;
    const { data: ccpEntitlementTxaIdData, loading: ccpEntitlementTxaIdLoading, error: ccpEntitlementTxaIdError } = (0, $jMyy4.useQueryInterop)(/** @schema agg */ (0, $63Hn9.default), {
        variables: {
            entitlementId: ccpEntitlementId || '',
            targetEditionName: targetEdition || ''
        },
        skip: skipDeepLinks || !isCcpBackend || !ccpEntitlementId,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (skipDeepLinks) return {
        commerceBackendName: null,
        planSelectionDeepLink: undefined,
        planConsentDeepLink: undefined,
        subscriptionDetailsDeepLink: undefined,
        loading: false,
        errorMessage: undefined
    };
    let errorMessage;
    let planSelectionDeepLink;
    let planConsentDeepLink;
    let subscriptionDetailsDeepLink;
    let changeOfferingDeepLink;
    try {
        const entitlementId = ccpEntitlementId;
        const transactionAccountId = ccpEntitlementTxaIdData?.ccp?.entitlement?.transactionAccountId;
        // format -> https://admin.stg.atlassian.com/billing/UUID/entitlement/TWC-UUID-OR-CONF/change-plan?requireAtlOrigin=true&referrer=confluence
        // Note: if product is TWC Confluence, then there is no referrer param added from ccp-graphql
        const changeOfferingExperienceUrl = ccpEntitlementTxaIdData?.ccp?.entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? undefined;
        const commerceParams = {
            cloudId: cloudId,
            commerceBackendName: commerceBackendName,
            environment: environment,
            entitlementId: entitlementId,
            orgId: orgId,
            transactionAccountId: transactionAccountId || undefined
        };
        planSelectionDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanSelectionLink(commerceParams));
        planConsentDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanConsentLink({
            targetEdition: targetEdition,
            ...commerceParams
        }));
        if (changeOfferingExperienceUrl) {
            if ((0, $6mKj3.expValEquals)('confluence_fix_referrer_param_commerce_deeplinks', 'cohort', 'variation')) {
                const url = new URL(changeOfferingExperienceUrl);
                url.searchParams.set('referrer', 'confluence');
                changeOfferingDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl(url.toString());
            } else changeOfferingDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl(`${changeOfferingExperienceUrl}confluence`);
        }
        subscriptionDetailsDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildSubscriptionDetailsLink(commerceParams));
        // Mark all graphql errors as handled since we will return the fallback plan selection url
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementIdError);
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementTxaIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementTxaIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementTxaIdError);
        if (commerceBackendNameError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving Commerce Backend Service', commerceBackendNameError);
        else if (ccpEntitlementIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Entitlement Id', ccpEntitlementIdError);
        else if (ccpEntitlementTxaIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Transaction Account Id', ccpEntitlementTxaIdError);
    } catch (e) {
        errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error in useCommerceDeepLinks', e);
    }
    const loading = commerceBackendNameLoading || ccpEntitlementIdLoading || ccpEntitlementTxaIdLoading;
    return {
        commerceBackendName: commerceBackendName,
        planSelectionDeepLink: planSelectionDeepLink,
        planConsentDeepLink: changeOfferingDeepLink || planConsentDeepLink,
        subscriptionDetailsDeepLink: subscriptionDetailsDeepLink,
        loading: loading,
        errorMessage: errorMessage
    };
};
module.exports["CommerceDeepLinksTargetEdition"] = $ae96eb60e6557b8b$export$92b15cc7e26a62fb;
module.exports["useCommerceDeepLinks"] = $ae96eb60e6557b8b$export$91505ae0b86ded0b;

});

parcelRegister("63Hn9", function(module, exports) {
/**
 * @generated SignedSource<<7043f6bc124435616d75a994f90b6db4>>
 * @relayHash 1550b53499cc9c4c43997e297fa050c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10738af8cd0e26e61c93e96a9aa88d2a81fd8fade160ae57f575778fdf62b7c5
const $9dd5459212e2b154$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entitlementId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "targetEditionName"
        }
    ], v1 = [
        {
            "concreteType": "CcpQueryApi",
            "kind": "LinkedField",
            "name": "ccp",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "entitlementId"
                        }
                    ],
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "transactionAccountId"
                        },
                        {
                            "concreteType": "CcpEntitlementExperienceCapabilities",
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "offeringName",
                                            "variableName": "targetEditionName"
                                        }
                                    ],
                                    "concreteType": "CcpChangeOfferingExperienceCapability",
                                    "kind": "LinkedField",
                                    "name": "changeOfferingV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "experienceUrl"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1550b53499cc9c4c43997e297fa050c5",
            "id": "10738af8cd0e26e61c93e96a9aa88d2a81fd8fade160ae57f575778fdf62b7c5",
            "metadata": {},
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "operationKind": "query",
            "text": "query useCommerceDeepLinksCcpTransactionAccountIdQuery($entitlementId:ID!,$targetEditionName:String){ccp{entitlement(id:$entitlementId){transactionAccountId,experienceCapabilities{changeOfferingV2(offeringName:$targetEditionName){experienceUrl}},id}}}"
        }
    };
}();
$9dd5459212e2b154$var$node.hash = "0078d9648e47947324143eae530f4046";
var $9dd5459212e2b154$export$2e2bcd8739ae039 = $9dd5459212e2b154$var$node;
module.exports["default"] = $9dd5459212e2b154$export$2e2bcd8739ae039;

});

parcelRegister("jJ96k", function(module, exports) {
/**
 * @generated SignedSource<<e40aa066e3afb32b389a7a04b48ada9c>>
 * @relayHash 7b6d56299e8bad23570ed5580bdc5641
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a5e4f4a4d3d13a42fadcbccaa10e14ae28ca67b7e22b87a8246aa660c4e7797
const $edae1a4299d7e8da$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicenseStates",
                    "kind": "LinkedField",
                    "name": "licenseStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "LicenseState",
                            "kind": "LinkedField",
                            "name": "confluence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ccpEntitlementId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Tenant",
            "kind": "LinkedField",
            "name": "tenant",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7b6d56299e8bad23570ed5580bdc5641",
            "id": "6a5e4f4a4d3d13a42fadcbccaa10e14ae28ca67b7e22b87a8246aa660c4e7797",
            "metadata": {},
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "operationKind": "query",
            "text": "query useCommerceDeepLinksCcpEntitlementQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}},tenant{cloudId}}"
        }
    };
}();
$edae1a4299d7e8da$var$node.hash = "f1b8b946a65b7c16eb6735dad6d5b323";
var $edae1a4299d7e8da$export$2e2bcd8739ae039 = $edae1a4299d7e8da$var$node;
module.exports["default"] = $edae1a4299d7e8da$export$2e2bcd8739ae039;

});

parcelRegister("6bHqX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6H9BA = parcelRequire("6H9BA");


var $4Twfb = parcelRequire("4Twfb");


var $3yFL2 = parcelRequire("3yFL2");

var $3SLm1 = parcelRequire("3SLm1");

var $cEhot = parcelRequire("cEhot");


var $1Y5Zp = parcelRequire("1Y5Zp");

const $30c48f23b8aa47be$export$56507f8f3f7349a5 = 'HAMS';
const $30c48f23b8aa47be$export$9a39331b1bb2f849 = 'CCP';
const $30c48f23b8aa47be$export$49ab1426acf387e4 = async (_params, _options)=>{
    return {
        payload: {
            commerceBackend: 'CCP',
            ccp: {}
        },
        error: undefined,
        exception: undefined
    };
};
const $30c48f23b8aa47be$export$532017a098b73852 = (params, options)=>{
    const fetch = (0, $6H9BA.useCommerceFetch)();
    const effectiveOptions = (0, $42omo.useMemo)(()=>({
            fetch: fetch,
            ...options
        }), [
        fetch,
        options
    ]);
    const startTask = (0, $cEhot.useTaskTracker)({
        action: 'fetched',
        actionSubject: 'commerceRolloutInformation',
        source: 'unknown'
    });
    return (0, $4Twfb.useFetchService)((0, $42omo.useCallback)(async ()=>{
        const taskResult = await startTask(async ()=>{
            const result = await $30c48f23b8aa47be$export$49ab1426acf387e4(params, effectiveOptions);
            if ((0, $1Y5Zp.isSuccessful)(result)) return {
                succeed: {
                    payload: result.payload
                }
            };
            else if ((0, $1Y5Zp.isException)(result)) // fetch can sometimes throw, but most likely this is a bug
            return {
                fail: {
                    payload: result.exception,
                    loggablePayload: result.exception,
                    responsibleService: (0, $3SLm1).COMMERCE_LIBRARIES,
                    probabilityOfBug: (0, $3yFL2).GUARANTEED
                }
            };
            return {
                // Failed response from server.
                fail: {
                    payload: result.error,
                    responsibleService: (0, $3SLm1).BILLING_API_GATEWAY,
                    // TODO: Review HTTP codes to differentiate between bug and normal errors
                    probabilityOfBug: (0, $3yFL2).MAYBE
                }
            };
        });
        if (taskResult.succeed !== undefined) return taskResult.succeed.payload;
        throw taskResult.fail.payload;
    }, [
        startTask,
        params,
        effectiveOptions
    ]));
};
module.exports["COMMERCE_BACKEND_HAMS"] = $30c48f23b8aa47be$export$56507f8f3f7349a5;
module.exports["COMMERCE_BACKEND_CCP"] = $30c48f23b8aa47be$export$9a39331b1bb2f849;
module.exports["fetchCommerceRolloutInformation"] = $30c48f23b8aa47be$export$49ab1426acf387e4;

});

parcelRegister("6H9BA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $goqBE = parcelRequire("goqBE");


var $bIMHH = parcelRequire("bIMHH");


var $1cK19 = parcelRequire("1cK19");


var $1EMUC = parcelRequire("1EMUC");


var $lzJ3V = parcelRequire("lzJ3V");

const $5f57f8a421838b9c$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $1EMUC.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $bIMHH.useSentryExceptionDispatch)();
    return (0, $42omo.useCallback)(async (...args)=>{
        const startTime = performance.now();
        const [fetchInput] = args;
        const sanitizedUrl = (0, $1cK19.sanitizeUrlString)((0, $lzJ3V.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            (0, $4u5NT.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now(), JSON.stringify(response).length);
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) return error.stack ?? error.toString();
                else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $5f57f8a421838b9c$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $goqBE.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) return error.stack ?? error.toString();
            else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });
module.exports["useCommerceFetch"] = $5f57f8a421838b9c$export$5f844fc0012b62a;

});

parcelRegister("goqBE", function(module, exports) {
class $de24e055bcb736b9$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.statusCode = void 0;
        this.body = void 0;
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $de24e055bcb736b9$export$d2f2761cbe9cebf2.prototype);
    }
}
const $de24e055bcb736b9$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $de24e055bcb736b9$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};
module.exports["HttpResponseError"] = $de24e055bcb736b9$export$d2f2761cbe9cebf2;
module.exports["rejectOnHttpError"] = $de24e055bcb736b9$export$a4c208475de70990;

});

parcelRegister("bIMHH", function(module, exports) {

var $aNwpq = parcelRequire("aNwpq");


var $k6lJw = parcelRequire("k6lJw");


var $6YLhE = parcelRequire("6YLhE");

const $48dc7deec6188f73$export$3c3f21d4489e178a = (0, $aNwpq.internalGasV3UIEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$5e75c4fb0a07e6f4 = (0, $aNwpq.internalGasV3ScreenEventChannel).useEventDispatch;
const $48dc7deec6188f73$export$eb1dac57abae25e8 = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$ab6d20b2228c09c6 = (0, $aNwpq.internalGasV3OperationalEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$cf4d833c52e18bed = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$8eb9a37a282b8ea6 = (0, $k6lJw.createAtlaskitToEventChannelRepackager)($48dc7deec6188f73$export$3c3f21d4489e178a);
const $48dc7deec6188f73$export$d6cab26720f11779 = (0, $aNwpq.breadcrumbMountedEventChannel).Listener;
const $48dc7deec6188f73$export$794ea2871d096951 = (Component, name, attributes)=>(0, $6YLhE.withBreadcrumb)(Component, (0, $aNwpq.Breadcrumb), name, attributes);
module.exports["useSentryExceptionDispatch"] = $48dc7deec6188f73$export$cf4d833c52e18bed;

});

parcelRegister("aNwpq", function(module, exports) {

var $6YLhE = parcelRequire("6YLhE");


var $eUjEX = parcelRequire("eUjEX");

const $48f3d8edf25a7fa7$var$breadcrumbAPI = (0, $6YLhE.createBreadcrumbAPI)();
const $48f3d8edf25a7fa7$export$1622e7b9340efb0 = $48f3d8edf25a7fa7$var$breadcrumbAPI.breadcrumbMountedEventChannel;
const $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc = $48f3d8edf25a7fa7$var$breadcrumbAPI.Breadcrumb;
const $48f3d8edf25a7fa7$export$a841c408695b0137 = $48f3d8edf25a7fa7$var$breadcrumbAPI.useGetBreadcrumbs;
const $48f3d8edf25a7fa7$export$58a908b728d2cddc = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$34eb9485fd3a664a = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$fb5e587076f78057 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$f92d259194a988f8 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$d9c23c680d73705d = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$b7973f9532f3f87f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$5a78c7e669ed705e = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$90a2fbbf51eb525f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$d9101fe70b7457a1 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
module.exports["breadcrumbMountedEventChannel"] = $48f3d8edf25a7fa7$export$1622e7b9340efb0;
module.exports["Breadcrumb"] = $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc;
module.exports["internalGasV3UIEventChannel"] = $48f3d8edf25a7fa7$export$b7973f9532f3f87f;
module.exports["internalGasV3ScreenEventChannel"] = $48f3d8edf25a7fa7$export$5a78c7e669ed705e;
module.exports["internalGasV3TrackEventChannel"] = $48f3d8edf25a7fa7$export$90a2fbbf51eb525f;
module.exports["internalGasV3OperationalEventChannel"] = $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91;
module.exports["internalSentryExceptionChannel"] = $48f3d8edf25a7fa7$export$d9101fe70b7457a1;

});

parcelRegister("6YLhE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eUjEX = parcelRequire("eUjEX");

const $098bf883a354e4d9$var$emptyObject = {};
const $098bf883a354e4d9$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $42omo.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $eUjEX.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $42omo.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $42omo.useRef)(castBreadcrumbPayload);
        (0, $42omo.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $42omo.useCallback)(()=>({
                breadcrumbs: [
                    ...getParentBreadcrumbs()?.breadcrumbs ?? [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            }), [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(EmitEventOnMount, {
                    name: breadcrumbPayload.name,
                    getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
                    value: getMountedBreadcrumbPayload,
                    children: children
                })
            ]
        });
    };
    return {
        breadcrumbMountedEventChannel: /**
		 * An event channel whos event represents that a breadcrumb was mounted
		 */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $098bf883a354e4d9$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $eUjEX.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $42omo.useCallback)((payload)=>eventDispatch({
                breadcrumbs: getParentBreadcrumbs()?.breadcrumbs ?? [],
                payload: payload
            }), [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $098bf883a354e4d9$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $098bf883a354e4d9$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, $l998X.jsx)(Breadcrumb, {
            ...breadcrumbFields,
            name: name,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    return ComponentWithBreadcrumb;
};
module.exports["createBreadcrumbAPI"] = $098bf883a354e4d9$export$783e5d823c500873;
module.exports["createBreadcrumbedEventChannel"] = $098bf883a354e4d9$export$d3653322274df895;
module.exports["withBreadcrumb"] = $098bf883a354e4d9$export$794ea2871d096951;

});

parcelRegister("eUjEX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $42omo.useContext)(context);
        const fireEventCallback = (0, $42omo.useCallback)((event)=>{
            onEventCallback?.(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
            value: onEvent,
            children: children
        });
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: wrappedChildren
        });
    };
    return CombinedListener;
};
const $e0bd124d99ee3c1b$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $e0bd124d99ee3c1b$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $42omo.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(InboundListener, {
            onEvent: transformFn,
            children: children
        });
    };
    return Transformer;
};
const $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $42omo.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $e0bd124d99ee3c1b$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $42omo.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $e0bd124d99ee3c1b$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: onEvent,
            children: wrappedChildren
        });
    }
    return wrappedChildren;
};
module.exports["createCatchingEventChannel"] = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e;
module.exports["createEventChannel"] = $e0bd124d99ee3c1b$export$7b182ad6fa711a33;

});

parcelRegister("k6lJw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");

const $39d282bcf5375d57$var$ATLASKIT_CHANNEL = 'atlaskit';
const $39d282bcf5375d57$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $42omo.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent,
            children: children
        });
    };
    return RepackageAnalyticsNextEvent;
};
const $39d282bcf5375d57$export$1ec809871e34d2f0 = (// TODO: Technically, we can make the type more specific than just UIAnalyticsPayload
useEventDispatch)=>{
    const RepackageAtlaskitEvent = $39d282bcf5375d57$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $39d282bcf5375d57$export$ad0c43fbe23d07ab = (Listener, channel = $39d282bcf5375d57$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $42omo.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: fireAsAtlaskitEvent,
            children: children
        });
    };
};
module.exports["createAtlaskitToEventChannelRepackager"] = $39d282bcf5375d57$export$1ec809871e34d2f0;

});

parcelRegister("1cK19", function(module, exports) {
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $3031758fc3a9c9bd$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};
module.exports["sanitizeUrlString"] = $3031758fc3a9c9bd$export$ceb09b958e605eff;

});

parcelRegister("1EMUC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9Bcp3 = parcelRequire("9Bcp3");

const $fb2833db791c8fde$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $42omo.useState)(()=>new Map(overrides));
    (0, $42omo.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$fb2833db791c8fde$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Bcp3.overrideContext).Provider, {
        value: registry,
        children: children
    });
};
const $fb2833db791c8fde$export$edb6244a86733174 = ()=>(0, $42omo.useContext)((0, $9Bcp3.overrideContext));
const $fb2833db791c8fde$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $fb2833db791c8fde$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $fb2833db791c8fde$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $fb2833db791c8fde$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $fb2833db791c8fde$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];
module.exports["useCommerceOverride"] = $fb2833db791c8fde$export$cf6f15ae0c6d3b84;

});

parcelRegister("9Bcp3", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $0f5923cabface8ba$export$81b0387840a1a60c = (0, $42omo.createContext)(new Map());
module.exports["overrideContext"] = $0f5923cabface8ba$export$81b0387840a1a60c;

});

parcelRegister("lzJ3V", function(module, exports) {
const $8b805f09b2bef0e7$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
module.exports["getRequestUrl"] = $8b805f09b2bef0e7$export$14619c0eed01a470;

});

parcelRegister("4Twfb", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $b022c09cd7385a9a$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $42omo.useState)(initialState);
    const fetchData = (0, $42omo.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $b022c09cd7385a9a$export$ff7e5879ade03276 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $42omo.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$18e513c1248d8ad5 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$d9765c5cd98039 = (request)=>{
    const service = $b022c09cd7385a9a$export$18e513c1248d8ad5(request);
    return (0, $42omo.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$7077fee76310bc60 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};
module.exports["useFetchService"] = $b022c09cd7385a9a$export$ff7e5879ade03276;
module.exports["useUpdateService"] = $b022c09cd7385a9a$export$18e513c1248d8ad5;

});

parcelRegister("3yFL2", function(module, exports) {
/**
 * For when the code is meant to only ever executed when a bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - A top-level try-catch whos only purpose is to prevent your entire application from crashing when random exceptions are thrown
 * - HTTP 500 status code handling logic (assuming 500s only happen when the server has experienced a bug/crash)
 * - Server responses that signal that the JSON payload frontend sent was completely wrong
 * - Part of your app unexpectedly crashes
 * - Any response bodys/HTTP statuses you were not expecting to receive
 */ const $46d5cbdb1ec76aac$export$6af268b89fae390b = 'guaranteed';
const $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf = 'maybe';
const $46d5cbdb1ec76aac$export$c53d0f541b41b88e = 'none';
module.exports["GUARANTEED"] = $46d5cbdb1ec76aac$export$6af268b89fae390b;
module.exports["MAYBE"] = $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf;
module.exports["NONE"] = $46d5cbdb1ec76aac$export$c53d0f541b41b88e;

});

parcelRegister("3SLm1", function(module, exports) {
/**
 * Note: If you add a service here please name after what's mentioned in Microscope.
 * It'll make figuring out who to page (if we need to) easier. See: https://microscope.prod.atl-paas.net/services/commerce-libraries
 *
 * TODO: Probably worth adding some sort of build check to make sure this is enforced
 */ /**
 * It's not enforced, but if you add a service here
 */ /**
 * Generally, you'll want to use this value if you're not 100% sure who can cause the error.
 */ const $a2df338368098843$export$78244dbb77cfa6b6 = 'unknown';
const $a2df338368098843$export$aed27a6561cc0f5c = 'unknown-external';
const $a2df338368098843$export$983d8427a452c1b = 'commerce-libraries';
const $a2df338368098843$export$d5a5208541f78b0 = 'hams';
const $a2df338368098843$export$856303030f6df405 = 'billing-api-gateway';
module.exports["UNKNOWN"] = $a2df338368098843$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_EXTERNAL"] = $a2df338368098843$export$aed27a6561cc0f5c;
module.exports["COMMERCE_LIBRARIES"] = $a2df338368098843$export$983d8427a452c1b;
module.exports["HAMS"] = $a2df338368098843$export$d5a5208541f78b0;
module.exports["BILLING_API_GATEWAY"] = $a2df338368098843$export$856303030f6df405;

});

parcelRegister("cEhot", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3yFL2 = parcelRequire("3yFL2");


var $aNwpq = parcelRequire("aNwpq");


var $in0Xj = parcelRequire("in0Xj");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $d09c0c9679eec46e$export$9a00dee1beb8f576 = (actionSubject)=>{
    return actionSubject.charAt(0).toUpperCase() + actionSubject.substring(1);
};
const $d09c0c9679eec46e$export$4903c942fa101973 = {
    TASK_FAILURE: 'fe.user.task.failure',
    TASK_SUCCESS: 'fe.user.task.success'
};
const $d09c0c9679eec46e$export$b921bb722afe30af = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, histogramBuckets: _histogramBuckets = '4000' })=>{
    const dispatchGasV3Track = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch();
    const dispatchSentry = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch();
    const task = actionSubjectId ? `${actionSubjectId}` : `${action}${$d09c0c9679eec46e$export$9a00dee1beb8f576(actionSubject)}`;
    return (0, $42omo.useCallback)((payload)=>{
        const sharedGasV3Payload = {
            ...payload
        };
        const sendSentryEvent = (loggablePayload, eventName, eventTaskId, exceptionTags)=>{
            if (loggablePayload === undefined && [
                (0, $3yFL2.MAYBE),
                (0, $3yFL2.NONE)
            ].includes(exceptionTags.probabilityOfBug)) // Don't bother sending a payload if it's undefined and the probability of bug isn't guaranteed
            // TODO: Should enforce that it's never undefined for ProbabilityOfBug.GUARANTEED
            return;
            dispatchSentry({
                exception: loggablePayload,
                scopeContext: (0, $in0Xj.withTelemetryInfoScopeContext)({
                    tags: {
                        task: task,
                        eventName: eventName,
                        ...exceptionTags,
                        ...eventTaskId !== undefined ? {
                            eventTaskId: eventTaskId
                        } : undefined,
                        ...payload.actionSubjectId !== undefined ? {
                            actionSubjectId: payload.actionSubjectId
                        } : undefined
                    }
                })
            });
        };
        const fail = ({ loggablePayload: loggablePayload, probabilityOfBug: probabilityOfBug = (0, $3yFL2.MAYBE), eventTaskId: baseEventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            const eventTaskId = (()=>{
                if (baseEventTaskId !== undefined) return baseEventTaskId;
                if (probabilityOfBug === (0, $3yFL2.GUARANTEED)) {
                    if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'guaranteed-bug';
                    return 'external-bug';
                }
                // Not sending any other values in fear of cardinality problems
                return undefined;
            })();
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_FAILURE, eventTaskId, {
                probabilityOfBug: probabilityOfBug,
                responsibleService: responsibleService
            });
        // TODO: Consider sending some sort of GasV3 failure information
        };
        const succeed = ({ loggablePayload: loggablePayload, eventTaskId: eventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_SUCCESS, eventTaskId, {
                probabilityOfBug: (0, $3yFL2.NONE),
                responsibleService: responsibleService
            });
            dispatchGasV3Track(sharedGasV3Payload);
        };
        return {
            fail: fail,
            succeed: succeed
        };
    }, [
        dispatchGasV3Track,
        dispatchSentry,
        task
    ]);
};
const $d09c0c9679eec46e$export$94273a7593441cd3 = (x)=>x.succeed !== undefined;
const $d09c0c9679eec46e$export$8ea5335bded027a0 = (taskInfo)=>{
    const startTask = $d09c0c9679eec46e$export$b921bb722afe30af(taskInfo);
    const taskInfoRef = (0, $42omo.useRef)(taskInfo);
    // TODO: replace by useEvent once it is available. Ponyfilling with useRef for now
    const higherLevelStartTask = (0, $42omo.useCallback)(/**
		 * Please note that thrown errors will be interpreted as guaranteed buggy failures.
		 * @param payload This data passed into this function will be shared between both failure and successful tasks
		 */ async (callback, payload)=>{
        const { fail: fail, succeed: succeed } = startTask(payload || taskInfoRef.current);
        try {
            const result = await callback();
            if (result.succeed !== undefined) succeed(result.succeed);
            else if (result.fail !== undefined) fail(result.fail);
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: {
                    result: result,
                    error: new Error('Could not find succeed nor fail')
                }
            });
            return result;
        } catch (err) {
            if (err instanceof TypeError && err.message === 'Failed to fetch') fail({
                probabilityOfBug: (0, $3yFL2.MAYBE),
                loggablePayload: err
            });
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: err
            });
            throw err;
        }
    }, [
        startTask
    ]);
    return higherLevelStartTask;
};
module.exports["useTaskTracker"] = $d09c0c9679eec46e$export$8ea5335bded027a0;

});

parcelRegister("in0Xj", function(module, exports) {

var $3yFL2 = parcelRequire("3yFL2");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $2cec5ac4f8c71665$export$bf5f90a1a9d2de58 = ({ probabilityOfBug: probabilityOfBug, responsibleService: responsibleService })=>{
    switch(probabilityOfBug){
        case 0, $3yFL2.GUARANTEED:
            if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'fatal';
            return 'error';
        case 0, $3yFL2.MAYBE:
            return 'warning';
        case 0, $3yFL2.NONE:
            return 'log';
        default:
            // Should never happen so sending critical :3
            return 'fatal';
    }
};
const $2cec5ac4f8c71665$var$severityOrdering = new Map([
    [
        'fatal',
        0
    ],
    [
        'fatal',
        1
    ],
    [
        'error',
        2
    ],
    [
        'warning',
        3
    ],
    [
        'info',
        4
    ],
    [
        'log',
        5
    ],
    [
        undefined,
        6
    ]
]);
const $2cec5ac4f8c71665$export$cae73843c52c598b = (severity1, severity2)=>{
    if ($2cec5ac4f8c71665$var$severityOrdering.get(severity1) <= $2cec5ac4f8c71665$var$severityOrdering.get(severity2)) return severity1;
    return severity2;
};
const $2cec5ac4f8c71665$export$c7063fd1387b3458 = (scopeContext)=>{
    const tags = {
        ...scopeContext.tags,
        responsibleService: scopeContext.tags.responsibleService ?? (0, $3SLm1.UNKNOWN)
    };
    return {
        ...scopeContext,
        tags: tags,
        level: $2cec5ac4f8c71665$export$bf5f90a1a9d2de58(tags)
    };
};
module.exports["withTelemetryInfoScopeContext"] = $2cec5ac4f8c71665$export$c7063fd1387b3458;

});

parcelRegister("jVQXW", function(module, exports) {

var $3SLm1 = parcelRequire("3SLm1");

const $d91c14f6a33096f8$export$6d5fcf71bce583e2 = (responsibleService)=>responsibleService === (0, $3SLm1.COMMERCE_LIBRARIES) || responsibleService === (0, $3SLm1.UNKNOWN);
module.exports["responsibleServiceIncludesCommerceLibraries"] = $d91c14f6a33096f8$export$6d5fcf71bce583e2;

});

parcelRegister("1Y5Zp", function(module, exports) {
const $1fb762876766bde5$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $1fb762876766bde5$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $1fb762876766bde5$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $1fb762876766bde5$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $1fb762876766bde5$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $1fb762876766bde5$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $1fb762876766bde5$export$a7324067d5b1efd6;

});

parcelRegister("lh1MN", function(module, exports) {
const $7f1ee6750f4adf66$export$db45730c9afae012 = (data)=>{
    if (!data) return undefined;
    return data.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || undefined;
};
module.exports["getCcpEntitlementFromQuery"] = $7f1ee6750f4adf66$export$db45730c9afae012;

});

parcelRegister("hfUvC", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $6bHqX = parcelRequire("6bHqX");


var $bXe73 = parcelRequire("bXe73");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $e7daf7179cc3ad9e$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation = (0, $2XqLN.default)(async (cloudId)=>{
    const rolloutInfoResult = await (0, $6bHqX.fetchCommerceRolloutInformation)({
        cloudId: cloudId,
        productKey: $e7daf7179cc3ad9e$export$b65b36d21c9a62a9
    }, {
        fetch: (0, $f7B1p.cfetch)
    });
    return rolloutInfoResult;
});
const $e7daf7179cc3ad9e$export$44d1450d6b2633f0 = (skip = false)=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const [commerceBackendName, setCommerceBackendName] = (0, $42omo.useState)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    if (!cloudId) skip = true;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        const fetchCommerceRolloutInformation = async ()=>{
            try {
                const rolloutInfoResult = await $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation(cloudId);
                if ((0, $bXe73.isSuccessful)(rolloutInfoResult)) setCommerceBackendName(rolloutInfoResult.payload.commerceBackend);
                else {
                    const error_1 = (0, $bXe73.isException)(rolloutInfoResult) ? rolloutInfoResult.exception : rolloutInfoResult.error;
                    setError(error_1);
                }
            } catch (error_0) {
                error_0.message = `useCommerceBackendName: ${error_0.message}`;
                setError(error_0);
            } finally{
                setLoading(false);
            }
        };
        fetchCommerceRolloutInformation();
    }, [
        cloudId,
        skip
    ]);
    return {
        commerceBackendName: skip ? null : commerceBackendName,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};
module.exports["useCommerceRolloutInformation"] = $e7daf7179cc3ad9e$export$44d1450d6b2633f0;

});

parcelRegister("bXe73", function(module, exports) {
const $f975479e12996987$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $f975479e12996987$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $f975479e12996987$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $f975479e12996987$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $f975479e12996987$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $f975479e12996987$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $f975479e12996987$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $f975479e12996987$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $f975479e12996987$export$a7324067d5b1efd6;

});

parcelRegister("dqdrq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $izVB4 = parcelRequire("izVB4");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? (0, $6J7Bn.ButtonBase) : t2;
        let t3;
        let t4;
        let t5;
        let t6;
        let t7;
        let t8;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START));
            t4 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END));
            t5 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START));
            t6 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END));
            t7 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START));
            t8 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END));
            $[3] = t3;
            $[4] = t4;
            $[5] = t5;
            $[6] = t6;
            $[7] = t7;
            $[8] = t8;
        } else {
            t3 = $[3];
            t4 = $[4];
            t5 = $[5];
            t6 = $[6];
            t7 = $[7];
            t8 = $[8];
        }
        let t9;
        if ($[9] !== __cmpls) {
            t9 = {
                ...__cmpls,
                "--_iozncj": t3,
                "--_id2ec3": t4,
                "--_1wa1xp5": t5,
                "--_1ck0ygl": t6,
                "--_1jf6nc6": t7,
                "--_1kksnqn": t8
            };
            $[9] = __cmpls;
            $[10] = t9;
        } else t9 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: t9,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let buttonProps;
    let children;
    if ($[0] !== t0) {
        ({ children: children, ...buttonProps } = t0);
        $[0] = t0;
        $[1] = buttonProps;
        $[2] = children;
    } else {
        buttonProps = $[1];
        children = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        });
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children);
        $[4] = children;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== buttonProps || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
            iconBefore: t1,
            ...buttonProps
        }, t2);
        $[6] = buttonProps;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};
module.exports["GradientCTAButton"] = $ce55fe36479bc4cf$export$d1aef6466b5ecaa5;

});

parcelRegister("j4WDj", function(module, exports) {
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #AF59E1)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #357DE8)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #964AC0)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #1868DB)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #803FA5)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #1558BC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #AF59E1)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #357DE8)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #673286)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #123263)";
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_START"] = $67193f3c2d75b820$export$3ff4048780acdec9;
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_END"] = $67193f3c2d75b820$export$ac8ee41608bff6f4;
module.exports["GRADIENT_CTA_BUTTON_HOVER_START"] = $67193f3c2d75b820$export$12fbdde791205cea;
module.exports["GRADIENT_CTA_BUTTON_HOVER_END"] = $67193f3c2d75b820$export$7653c62635354aaf;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_START"] = $67193f3c2d75b820$export$d4accc94291dcf84;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_END"] = $67193f3c2d75b820$export$16a15d5a9b73591b;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_START"] = $67193f3c2d75b820$export$fca70c3c81bb0f58;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_END"] = $67193f3c2d75b820$export$f737ffc625de304f;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_START"] = $67193f3c2d75b820$export$b1ab5fb618714abb;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_END"] = $67193f3c2d75b820$export$7a262e0e9c5a1e2a;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_START"] = $67193f3c2d75b820$export$71b6aed4f8256b2;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_END"] = $67193f3c2d75b820$export$c9d89eb8e0b59a5a;

});

parcelRegister("6J7Bn", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $eEA8O.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});
module.exports["ButtonBase"] = $e9beab952dc913a3$export$b0bb876e969289cd;

});

parcelRegister("ktelT", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $izVB4 = parcelRequire("izVB4");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const $903332396267b541$var$LinkWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q71879 _11c8fhey _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pwu06 _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71879 _11c8fhey _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pwu06 _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ])
    });
});
const $903332396267b541$export$7e6e2bf13161f2a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { href: href, onClick: onClick, target: target, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== href || $[3] !== onClick || $[4] !== target) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($903332396267b541$var$LinkWrapper, {
            href: href,
            onClick: onClick,
            target: target,
            role: "link"
        }, t1, children);
        $[1] = children;
        $[2] = href;
        $[3] = onClick;
        $[4] = target;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ href: href, onClick: onClick, target: target, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($903332396267b541$var$LinkWrapper, {
        href: href,
        onClick: onClick,
        target: target,
        role: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: ""
    }), children);
};
module.exports["GradientSubtleLinkButton"] = $903332396267b541$export$7e6e2bf13161f2a;

});

parcelRegister("l0DoV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $537ed6b0b56c707f$export$5422bd88477f90e5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uHF1j",
    name: "TryStandardUpflowV2ExperimentTreatmentModalLoadable",
    loader: async ()=>(await (parcelRequire("h8KKf"))).TryStandardUpflowV2ExperimentTreatmentModalWithErrorBoundary
});
module.exports["TryStandardUpflowV2ExperimentTreatmentModalLoadable"] = $537ed6b0b56c707f$export$5422bd88477f90e5;

});

parcelRegister("h8KKf", function(module, exports) {

let $c7a7719aef0253be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c7a7719aef0253be$var$load("6wr18"),
    $c7a7719aef0253be$var$load("eeaKR"),
    $c7a7719aef0253be$var$load("ffEVr"),
    $c7a7719aef0253be$var$load("31vk5"),
    $c7a7719aef0253be$var$load("hhss7"),
    $c7a7719aef0253be$var$load("fYFVU")
]).then(()=>parcelRequire('h60zh'));

});

parcelRegister("fDbEj", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $gQY3Y = parcelRequire("gQY3Y");


var $jKFU9 = parcelRequire("jKFU9");

const $3737157ebbad3bf6$var$timeNow = ()=>new Date().getTime();
const $3737157ebbad3bf6$export$66d311bf29d5c89c = new Error('TIMEOUT');
const $3737157ebbad3bf6$export$d63cfb67ca7b2a0 = (currentEdition, writeFragmentInterop)=>{
    if (!currentEdition) return Promise.reject(new Error('No currentEdition supplied'));
    const pollEndTime = new Date($3737157ebbad3bf6$var$timeNow() + (0, $jKFU9.CHANGE_EDITION_POLL_DURATION_MINS) * 60000).getTime();
    const pollAndResolve = (resolve, reject)=>{
        if ($3737157ebbad3bf6$var$timeNow() > pollEndTime) reject($3737157ebbad3bf6$export$66d311bf29d5c89c);
        (0, $c0rhi.queryInterop)({
            query: (0, $gQY3Y.waitForEditionChangeQuery),
            errorPolicy: 'all',
            fetchPolicy: 'network-only'
        }).then((response)=>{
            const polledEdition = response.data?.tenant?.editions?.confluence;
            if (polledEdition && currentEdition !== polledEdition) {
                // Write the latest edition to cache.
                writeFragmentInterop({
                    fragmentId: '$ROOT_QUERY.confluence_tenantContext',
                    data: {
                        editions: {
                            confluence: polledEdition,
                            __typename: 'ConfluenceEditions'
                        },
                        __typename: 'Tenant'
                    }
                });
                resolve(polledEdition);
            } else setTimeout(()=>{
                pollAndResolve(resolve, reject);
            }, (0, $jKFU9.CHANGE_EDITION_POLL_INTERVAL_SECS) * 1000);
        }).catch(reject);
    };
    return new Promise((resolve, reject)=>pollAndResolve(resolve, reject));
};
module.exports["TimeoutError"] = $3737157ebbad3bf6$export$66d311bf29d5c89c;
module.exports["waitForEditionChange"] = $3737157ebbad3bf6$export$d63cfb67ca7b2a0;

});

parcelRegister("gQY3Y", function(module, exports) {

var $cLzsY = parcelRequire("cLzsY");

const $1047f6c600fde1f6$export$291c2fa2b3781c67 = (0, $cLzsY.default);
module.exports["waitForEditionChangeQuery"] = $1047f6c600fde1f6$export$291c2fa2b3781c67;

});

parcelRegister("cLzsY", function(module, exports) {
/**
 * @generated SignedSource<<80c3e4c3c39c78fad9dff32935c8ec0c>>
 * @relayHash 1f96316e590a2b194e51c68e90ba41fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 241b0a4ae1b4aa71513dc33dc53ca7f3c35e7c5a3662ea814901abd521642ef3
const $5953893bb8ead2fa$var$node = function() {
    var v0 = [
        {
            "alias": "tenant",
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "waitForEditionChangeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "waitForEditionChangeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1f96316e590a2b194e51c68e90ba41fe",
            "id": "241b0a4ae1b4aa71513dc33dc53ca7f3c35e7c5a3662ea814901abd521642ef3",
            "metadata": {},
            "name": "waitForEditionChangeQuery",
            "operationKind": "query",
            "text": "query waitForEditionChangeQuery{tenant:confluence_tenantContext{editions{confluence}}}"
        }
    };
}();
$5953893bb8ead2fa$var$node.hash = "6fd7b1d4e0dd25a6c39ba6c8851caa63";
var $5953893bb8ead2fa$export$2e2bcd8739ae039 = $5953893bb8ead2fa$var$node;
module.exports["default"] = $5953893bb8ead2fa$export$2e2bcd8739ae039;

});

parcelRegister("jKFU9", function(module, exports) {
const $97f7046950ca68f7$export$4f9b7eb5b7999045 = 3;
const $97f7046950ca68f7$export$6925031fb600919f = 1;
module.exports["CHANGE_EDITION_POLL_INTERVAL_SECS"] = $97f7046950ca68f7$export$4f9b7eb5b7999045;
module.exports["CHANGE_EDITION_POLL_DURATION_MINS"] = $97f7046950ca68f7$export$6925031fb600919f;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("bhvFb", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3HQYo = parcelRequire("3HQYo");


var $9wGTI = parcelRequire("9wGTI");


var $gsZdA = parcelRequire("gsZdA");

const $1848832735763b59$var$contentContainerStyles = {
    regular: "_1e0c1txw _2lx21bp4 _16jlkb7n _p12f1lk2",
    isCard: "_p12f1osq"
};
const $1848832735763b59$var$sectionMessageTitleStyles = {
    regular: "_11c81e3o _19pkidpf _syazi7uo",
    regularNew: "_11c81af2 _k48p1wq8 _19pkidpf _syazi7uo",
    inlineModal: "_11c81af2 _19pkze3t _n3tdpxbi"
};
const $1848832735763b59$var$sectionMessageBodyStyles = {
    withTitle: "_19pku2gc",
    noTitle: "_19pkidpf"
};
const $1848832735763b59$var$sectionMessageHeaderButtonStyles = {
    regular: "_1e0c1txw _1bahesu3 _kqswstnw _154ipxbi _1xi21ejb",
    default: "_154ixy5q _1xi2oahv",
    isCardDefault: "_1xi2xy5q",
    isCard: "_1xi2pxbi"
};
const $1848832735763b59$var$sectionMessageActionRowStyles = {
    default: "_1e0c1txw _19pkpxbi",
    right: "_1bahesu3 _166l1sbv _6ufw1q9c",
    inlineModal: "_19pk16xz _1e0c1txw"
};
const $1848832735763b59$var$sectionMessageFooterStyles = {
    default: "_x3do1uh4 _19pkpxbi _otyrpxbi _ca0qutpp"
};
const $1848832735763b59$var$sectionMessageContainerStyles = {
    regular: "_2rkofajl _19pkidpf _2hwx1wug _otyridpf _18u01wug _bfhk1bhr _1e0c1txw _16jlkb7n",
    withTasteAndToneStyling: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk1j28",
    default: "_1yt44ar7 _16qs130s _p12fasau",
    flat: "_1yt44ar7 _p12fasau",
    inline: "_11c8fhey",
    inlineModal: "_p12f1kdj"
};
const $1848832735763b59$export$d8126cfce410377d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(35);
    const { actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: t1, buttonGroupAlignment: t2 } = t0;
    const withTasteAndToneStyling = t1 === undefined ? false : t1;
    const buttonGroupAlignment = t2 === undefined ? "left" : t2;
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === "right");
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    const t3 = withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles.withTasteAndToneStyling;
    const t4 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles["default"];
    const t5 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles.flat;
    const t6 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles.inline;
    const t7 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles.inlineModal;
    let t8;
    if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7) {
        t8 = (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageContainerStyles.regular,
            t3,
            t4,
            t5,
            t6,
            t7
        ]);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
    } else t8 = $[5];
    const t9 = isCard && $1848832735763b59$var$contentContainerStyles.isCard;
    let t10;
    if ($[6] !== t9) {
        t10 = (0, $gMc0m.default)([
            $1848832735763b59$var$contentContainerStyles.regular,
            t9
        ]);
        $[6] = t9;
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] !== title || $[9] !== updatedAppearanceType || $[10] !== withTitle) {
        t11 = withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)("ten_active_boards_in_standard") ? "regularNew" : "regular"],
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles.inlineModal
            ])
        }, title);
        $[8] = title;
        $[9] = updatedAppearanceType;
        $[10] = withTitle;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== body || $[13] !== withTitle) {
        t12 = typeof body === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($3HQYo))).sanitize(body)
            },
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }, body);
        $[12] = body;
        $[13] = withTitle;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== headerButton || $[16] !== isCard || $[17] !== updatedAppearanceType) {
        t13 = headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageHeaderButtonStyles.regular,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles["default"],
                isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCard,
                isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCardDefault
            ])
        }, headerButton);
        $[15] = headerButton;
        $[16] = isCard;
        $[17] = updatedAppearanceType;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== actions || $[20] !== buttonGroupAlignment || $[21] !== updatedAppearanceType) {
        t14 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageActionRowStyles["default"],
                buttonGroupAlignment === "right" && $1848832735763b59$var$sectionMessageActionRowStyles.right,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles.inlineModal,
                "actionButtons"
            ])
        }, actions);
        $[19] = actions;
        $[20] = buttonGroupAlignment;
        $[21] = updatedAppearanceType;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== footer) {
        t15 = footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageFooterStyles["default"]
            ])
        }, footer);
        $[23] = footer;
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t10
        }, t11, t12, t13, t14, t15);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
        $[28] = t13;
        $[29] = t14;
        $[30] = t15;
        $[31] = t16;
    } else t16 = $[31];
    let t17;
    if ($[32] !== t16 || $[33] !== t8) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "edition-section-message",
            className: t8
        }, t16);
        $[32] = t16;
        $[33] = t8;
        $[34] = t17;
    } else t17 = $[34];
    return t17;
} : ({ actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: withTasteAndToneStyling = false, buttonGroupAlignment: buttonGroupAlignment = 'left' })=>{
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === 'right');
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "edition-section-message",
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageContainerStyles['regular'],
            withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles['withTasteAndToneStyling'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles['default'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles['flat'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles['inline'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles['inlineModal']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$contentContainerStyles['regular'],
            isCard && $1848832735763b59$var$contentContainerStyles['isCard']
        ])
    }, withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)('ten_active_boards_in_standard') ? 'regularNew' : 'regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles['inlineModal']
        ])
    }, title), typeof body === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // See https://hello.atlassian.net/browse/APOLLO-3511
    , {
        // and other code tagged with this ticket
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($3HQYo))).sanitize(body)
        },
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }, body), headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageHeaderButtonStyles['regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['default'],
            isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCard'],
            isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCardDefault']
        ])
    }, headerButton), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageActionRowStyles['default'],
            buttonGroupAlignment === 'right' && $1848832735763b59$var$sectionMessageActionRowStyles['right'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles['inlineModal'],
            "actionButtons"
        ])
    }, actions), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageFooterStyles['default']
        ])
    }, footer)));
};
module.exports["EditionSectionMessage"] = $1848832735763b59$export$d8126cfce410377d;

});

parcelRegister("3HQYo", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("5u7Ox", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $6xdDU = parcelRequire("6xdDU");


var $inPa6 = parcelRequire("inPa6");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $9wGTI = parcelRequire("9wGTI");


var $TCbX7 = parcelRequire("TCbX7");


var $bZmiL = parcelRequire("bZmiL");

const $125b05aca1e71376$export$ccc7e3a47fa3a9b0 = ({ source: source, requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading = false, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const hasSentViewedEvent = (0, $42omo.useRef)(false);
    const [showModal, setShowModal] = (0, $42omo.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleCloseModal = ()=>{
        setShowModal(false);
    };
    const handleOpenModal = ()=>{
        if (onRequestUpgradeButtonClick && (0, $9wGTI.fg)('twcg-1169_ceurs2p_createspacedrawer_fix')) // If onRequestUpgradeButtonClick is provided, call it let it handle the modal opening
        onRequestUpgradeButtonClick();
        else {
            setIsLoadingModal(true);
            setShowModal(true);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    };
    (0, $42omo.useEffect)(()=>{
        if (hasSentViewedEvent.current) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
        hasSentViewedEvent.current = true;
    }, [
        createAnalyticsEvent,
        edition,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: edition === (0, $d9tcB.ConfluenceEdition).STANDARD ? 'growth-luna' : 'growth-transmuters'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: "experiment-confluence-enable-end-user-request.request-upgrade-button",
        onClick: handleOpenModal,
        appearance: "primary",
        isLoading: isLoadingModal || requestUpgradeButtonIsLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "experiment-confluence-enable-end-user-request.request-upgrade-button.label",
        defaultMessage: "Request to try"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $TCbX7.EndUserRequestUpgradeModalEntrypoint), {
        source: source,
        handleCloseModal: handleCloseModal,
        setIsLoadingModal: setIsLoadingModal
    })));
};
module.exports["EndUserRequestUpgradeButton"] = $125b05aca1e71376$export$ccc7e3a47fa3a9b0;

});

parcelRegister("TCbX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2d60c82434c5c2c8$export$8512e09daabbe9d7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i-AMj",
    name: "EndUserRequestUpgradeModalEntrypoint",
    loader: async ()=>(await (parcelRequire("G1neD"))).EndUserRequestUpgradeModal
});
module.exports["EndUserRequestUpgradeModalEntrypoint"] = $2d60c82434c5c2c8$export$8512e09daabbe9d7;

});

parcelRegister("G1neD", function(module, exports) {

let $07e4fd287f55fc06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07e4fd287f55fc06$var$load("6wr18"),
    $07e4fd287f55fc06$var$load("9anPW"),
    $07e4fd287f55fc06$var$load("50ame"),
    $07e4fd287f55fc06$var$load("Wowvf"),
    $07e4fd287f55fc06$var$load("ffEVr"),
    $07e4fd287f55fc06$var$load("31vk5"),
    $07e4fd287f55fc06$var$load("hhss7"),
    $07e4fd287f55fc06$var$load("eRrWU")
]).then(()=>parcelRequire('4YFRT'));

});

parcelRegister("bZmiL", function(module, exports) {

var $7L1H0 = parcelRequire("7L1H0");

const $ac662e4699f149b2$export$a6ecd874f477affc = (edition)=>({
        currentProductEdition: (0, $7L1H0.mapConfluenceEditionToSupportedCurrentEdition)(edition)
    });
module.exports["editionAnalytics"] = $ac662e4699f149b2$export$a6ecd874f477affc;

});

parcelRegister("7L1H0", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $4f5583827653668a$var$supportedCurrentEditionsMap = {
    [(0, $d9tcB.ConfluenceEdition).FREE]: 'free',
    [(0, $d9tcB.ConfluenceEdition).STANDARD]: 'standard'
};
const $4f5583827653668a$var$isSupportedEdition = (edition)=>{
    return edition in $4f5583827653668a$var$supportedCurrentEditionsMap;
};
const $4f5583827653668a$export$b48897de0c2497d9 = (edition)=>{
    if (!edition || !$4f5583827653668a$var$isSupportedEdition(edition)) return undefined;
    return $4f5583827653668a$var$supportedCurrentEditionsMap[edition];
};
module.exports["mapConfluenceEditionToSupportedCurrentEdition"] = $4f5583827653668a$export$b48897de0c2497d9;

});

parcelRegister("cHKtk", function(module, exports) {

var $hG9ZM = parcelRequire("hG9ZM");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $7tXrp = parcelRequire("7tXrp");


var $bZmiL = parcelRequire("bZmiL");

const $0db05c5b00b76da2$export$4af81e07a25a3fcc = (source)=>{
    // TODO: During productionization replace with EligibleTouchpoints type for source
    const { cloudId: cloudId, edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const eligibleTouchpoint = (0, $7tXrp.getEligibleTouchpointForEdition)(source, edition);
    const offeringName = eligibleTouchpoint?.requestedEdition ?? 'standard';
    const { isEnabledStandardEdition: isEnabledStandardEdition, isFreeOrStandardEdition: isFreeOrStandardEdition } = (0, $42omo.useMemo)(()=>{
        return {
            isEnabledStandardEdition: (0, $9wGTI.fg)('twcg-1169_ceurs2p_end_user_requests_kill_switch') && edition === (0, $d9tcB.ConfluenceEdition).STANDARD,
            isFreeOrStandardEdition: edition === (0, $d9tcB.ConfluenceEdition).FREE || edition === (0, $d9tcB.ConfluenceEdition).STANDARD
        };
    }, [
        edition
    ]);
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $hG9ZM.default), {
        variables: {
            cloudId: cloudId,
            offeringName: offeringName,
            shouldCheckForTrial: isEnabledStandardEdition
        },
        fetchPolicy: 'cache-first',
        skip: !isFreeOrStandardEdition || // Skip if not free or standard edition
        !isEnabledStandardEdition || // Skip if standard edition is not enabled
        isSiteAdmin || !eligibleTouchpoint,
        client: (0, $gKr8t.getAGGClient)()
    });
    const { isEligibleForEndUserRequestStandard: isEligibleForEndUserRequestStandard } = (0, $42omo.useMemo)(()=>{
        const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
        const isInCollection = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION')?.entitlementId;
        const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
        const changeOfferingExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
        const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingExperienceUrl);
        const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
        const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
        const entitlementId = entitlementInfo?.entitlementId;
        const transactionAccountId = entitlement?.transactionAccount?.key;
        // Additional eligibility checks for Standard
        const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft;
        const isInTrial = Boolean(trialTimeLeft && trialTimeLeft > 0);
        const invoiceableStatus = typeof entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable === 'boolean' ? entitlement.subscription.accountDetails.invoiceGroup.invoiceable ? 'INVOICEABLE' : 'NOT_INVOICEABLE' : 'UNKNOWN';
        const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && invoiceableStatus === 'NOT_INVOICEABLE';
        return {
            isEligibleForEndUserRequestStandard: Boolean(!loading && !isInCollection && isEnabledStandardEdition && hasPaymentDetailsEntered && !canUpgrade && Boolean(userId) && Boolean(changeOfferingExperienceUrl) && Boolean(transactionAccountId) && Boolean(entitlementId) && !isInTrial && !isInPredunning)
        };
    }, [
        data,
        loading,
        isEnabledStandardEdition,
        userId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isEligibleForEndUserRequestStandard) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'useEnableEndUserRequestUpgrade',
                attributes: {
                    cohort: (0, $6mKj3.expVal)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'not-enrolled'),
                    flagKey: 'twcg-1169_ceurs2p_end_user_requests',
                    touchpoint: source,
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    }, [
        edition,
        isEligibleForEndUserRequestStandard,
        createAnalyticsEvent,
        source
    ]);
    return {
        showRequestUpgradeButton: // Standard Edition
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequestStandard && (0, $6mKj3.expValEquals)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'variation'),
        loading: loading
    };
};
module.exports["useEnableEndUserRequestUpgrade"] = $0db05c5b00b76da2$export$4af81e07a25a3fcc;

});

parcelRegister("hG9ZM", function(module, exports) {
/**
 * @generated SignedSource<<3566b1065bbfe80593a6707992c628d5>>
 * @relayHash 95c17f8ab13d7575aa221eba1b6971a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2
const $a3d3dc9056ba2c7e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldCheckForTrial"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v11 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v14 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v15 = [
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v15 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v15 /*: any*/ ,
                                                                            "type": "CcpInvoiceGroup"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v15 /*: any*/ ,
                                                            "type": "CcpSubscription"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "95c17f8ab13d7575aa221eba1b6971a5",
            "id": "e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2",
            "metadata": {},
            "name": "useEnableEndUserRequestUpgradeQuery",
            "operationKind": "query",
            "text": "query useEnableEndUserRequestUpgradeQuery($cloudId:ID!,$offeringName:String!,$shouldCheckForTrial:Boolean!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlementId,entitlement{id,__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$offeringName){__typename,isAvailableToUser,experienceUrl}},transactionAccount{__typename,key,isBillToPresent,...on Node{__isNode:__typename,id}},relatesFromEntitlements{__typename,entitlementId,relationshipType},preDunning@include(if:$shouldCheckForTrial){__typename,status}\n        subscription@include(if:$shouldCheckForTrial){__typename,trial{__typename,timeLeft},accountDetails{__typename,invoiceGroup{__typename,invoiceable,...on CcpInvoiceGroup{id}}},...on CcpSubscription{id}}}}}}"
        }
    };
}();
$a3d3dc9056ba2c7e$var$node.hash = "ab7d869d4ea7e269d66f1403bf66098f";
var $a3d3dc9056ba2c7e$export$2e2bcd8739ae039 = $a3d3dc9056ba2c7e$var$node;
module.exports["default"] = $a3d3dc9056ba2c7e$export$2e2bcd8739ae039;

});

parcelRegister("7tXrp", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
// When cleaning up twcg-1169_ceurs2p_createspacedrawer_fix add in createSpaceDrawer
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCardsConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-unsetDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-viewOnlyButton': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
// When cleaning up twcg-1169_ceurs2p_createspacedrawer_fix this can be removed and createSpaceDrawer added to STANDARD_TOUCHPOINTS
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS_WITH_CREATE_SPACE_DRAWER = {
    ...$f4962613d517e76c$var$STANDARD_TOUCHPOINTS,
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return (0, $9wGTI.fg)('twcg-1169_ceurs2p_createspacedrawer_fix') ? $f4962613d517e76c$var$STANDARD_TOUCHPOINTS_WITH_CREATE_SPACE_DRAWER[source] : $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("48ubT", function(module, exports) {

var $05h0Q = parcelRequire("05h0Q");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $w033M = parcelRequire("w033M");


var $jMyy4 = parcelRequire("jMyy4");

const $cfdb58fabb92c022$export$f9f8a5cdb0c565ef = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $jMyy4.useQueryInterop)((0, $05h0Q.default));
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(data);
    return {
        isSiteAdmin: isSiteAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsSiteAdmin"] = $cfdb58fabb92c022$export$f9f8a5cdb0c565ef;

});

parcelRegister("05h0Q", function(module, exports) {
/**
 * @generated SignedSource<<81c0f29f574660ea837fb26bf316133d>>
 * @relayHash 4434db08f18656b277e4683bc4dcaf5d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 049c6ec4db12d273730e8108ab3e3697ea427432281cceb660f908b10068087b
const $ea94449346330325$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "4434db08f18656b277e4683bc4dcaf5d",
            "id": "049c6ec4db12d273730e8108ab3e3697ea427432281cceb660f908b10068087b",
            "metadata": {},
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "operationKind": "query",
            "text": "query useIsSiteAdminUseIsSiteAdminQuery{isSiteAdmin}"
        }
    };
}();
$ea94449346330325$var$node.hash = "ce32420547b7702bc996599bbe635142";
var $ea94449346330325$export$2e2bcd8739ae039 = $ea94449346330325$var$node;
module.exports["default"] = $ea94449346330325$export$2e2bcd8739ae039;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("lbPWE", function(module, exports) {

var $3awkC = parcelRequire("3awkC");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $jMyy4 = parcelRequire("jMyy4");


var $gKr8t = parcelRequire("gKr8t");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $gjUkr = parcelRequire("gjUkr");


var $inPa6 = parcelRequire("inPa6");

const $8cc93be0f89e75f1$export$cca3cdecfca1276f = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const skip = !isLoggedIn || !cloudId || edition !== (0, $euL71.ConfluenceEdition).FREE || !(0, $dh538.fg)('twcg-530_confluence_ai_in_editor_eot_gate');
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $3awkC.default), {
        variables: {
            cloudId: cloudId
        },
        skip: skip,
        fetchPolicy: 'cache-first',
        client: (0, $gKr8t.getAGGClient)(),
        onError: (error)=>{
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'twcg-530_confluence_ai_in_editor_eot'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: error?.message,
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: 'useIsEligibleForAiInEditor',
                additionalAttributes: {
                    cloudId: cloudId
                }
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    });
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const tenantContext = data?.tenantContexts?.[0];
    const entitlementInfo = tenantContext?.entitlementInfo;
    const entitlement = entitlementInfo?.entitlement;
    const experienceCapabilities = entitlement?.experienceCapabilities;
    const changeOfferingV2 = experienceCapabilities?.changeOfferingV2;
    const transactionAccount = entitlement?.transactionAccount;
    const hasCCPBillingSystem = data?.license?.billingSourceSystem === 'CCP';
    const canUpgradeToPremium = changeOfferingV2?.isAvailableToUser === true;
    const hasPaymentDetails = transactionAccount?.isBillToPresent === true;
    const experienceUrl = (0, $gjUkr.addAtlOriginToUrl)(changeOfferingV2?.experienceUrl || '');
    const isEligible = (0, $42omo.useMemo)(()=>{
        return isFreeEdition && isLoggedIn && Boolean(cloudId) && hasCCPBillingSystem && canUpgradeToPremium && !hasPaymentDetails;
    }, [
        isFreeEdition,
        isLoggedIn,
        cloudId,
        hasCCPBillingSystem,
        canUpgradeToPremium,
        hasPaymentDetails
    ]);
    return {
        isEligible: isEligible,
        edition: edition,
        canUpgrade: canUpgradeToPremium,
        loading: loading,
        error: error?.message || null,
        experienceUrl: experienceUrl
    };
};
module.exports["useIsEligibleForAiInEditor"] = $8cc93be0f89e75f1$export$cca3cdecfca1276f;

});

parcelRegister("3awkC", function(module, exports) {
/**
 * @generated SignedSource<<ff4be1e51ccf9e43c181ca5c8ca69de0>>
 * @relayHash e20833603f55baf33c05d488de093039
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 051a217822c4ed932215d5dd2b311bc3f2cbc59380ffd0c24208e2de834610ee
const $d5e8f70541d1b89c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "License",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "billingSourceSystem"
            }
        ]
    }, v2 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleForAiInEditorQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleForAiInEditorQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e20833603f55baf33c05d488de093039",
            "id": "051a217822c4ed932215d5dd2b311bc3f2cbc59380ffd0c24208e2de834610ee",
            "metadata": {},
            "name": "useIsEligibleForAiInEditorQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForAiInEditorQuery($cloudId:ID!){license{billingSourceSystem},tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlement{__typename,transactionAccount{__typename,isBillToPresent,...on Node{__isNode:__typename,id}},experienceCapabilities{__typename,changeOfferingV2(offeringName:\"Premium\"){__typename,isAvailableToUser,experienceUrl}},id}}}}"
        }
    };
}();
$d5e8f70541d1b89c$var$node.hash = "0d75dc71c4b33da642ee318f10fa7971";
var $d5e8f70541d1b89c$export$2e2bcd8739ae039 = $d5e8f70541d1b89c$var$node;
module.exports["default"] = $d5e8f70541d1b89c$export$2e2bcd8739ae039;

});

parcelRegister("gjUkr", function(module, exports) {

var $6Co6F = parcelRequire("6Co6F");

const $10cc0a048087d5da$export$27aa48a6b5521530 = (url)=>{
    if (!url) return '';
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
module.exports["addAtlOriginToUrl"] = $10cc0a048087d5da$export$27aa48a6b5521530;

});

parcelRegister("bdMSP", function(module, exports) {
/* eslint-disable confluence-feature-gating/prefer-exp-val-equals */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");

const $81f1ccd13ae0eba6$export$c2005d7fb3853502 = ({ touchpoint: touchpoint, isEligible: isEligible, extraAnalyticsAttributes: extraAnalyticsAttributes = {}, trialDaysLeft: trialDaysLeft })=>{
    const memoizedAnalyticsAttributes = (0, $42omo.useMemo)(()=>extraAnalyticsAttributes, [
        extraAnalyticsAttributes
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredEventsRef = (0, $42omo.useRef)({
        ab: new Set()
    });
    const experimentValues = (0, $42omo.useMemo)(()=>{
        if (!isEligible) return {
            isABTreatment: false
        };
        if ((0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') !== 'not-enrolled') return {
            isABTreatment: (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') === 'treatment'
        };
        return {
            isABTreatment: false
        };
    }, [
        isEligible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isEligible) return;
        if (!hasFiredEventsRef.current.ab.has(touchpoint) && (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled') !== 'not-enrolled') {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'exposed',
                    actionSubject: 'experiment',
                    actionSubjectId: `twcg-530_confluence_ai_in_editor_eot-exposed`,
                    attributes: {
                        cohort: (0, $6mKj3.expVal)('twcg-530_confluence_ai_in_editor_eot', 'cohort', 'not-enrolled'),
                        touchpoint: touchpoint,
                        trialDaysLeft: trialDaysLeft,
                        ...memoizedAnalyticsAttributes
                    },
                    source: 'twcg-530_confluence_ai_in_editor_eot'
                }
            }).fire();
            hasFiredEventsRef.current.ab.add(touchpoint);
        }
    }, [
        isEligible,
        touchpoint,
        memoizedAnalyticsAttributes,
        createAnalyticsEvent,
        trialDaysLeft
    ]);
    return experimentValues;
};
module.exports["useEnrolledAIInEditorModalsExperiment"] = $81f1ccd13ae0eba6$export$c2005d7fb3853502;

});

parcelRegister("3GzdC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c547a909ee5be0f8$export$91166c510522d36c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "jS4Zm",
    name: "ConfluenceAiInEditorModalWithErrorBoundaryLoadable",
    loader: async ()=>(await (parcelRequire("3OAlF"))).ConfluenceAiInEditorModalWithErrorBoundary
});
module.exports["ConfluenceAiInEditorModalWithErrorBoundaryLoadable"] = $c547a909ee5be0f8$export$91166c510522d36c;

});

parcelRegister("3OAlF", function(module, exports) {

let $2c723ca6d4c1166c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c723ca6d4c1166c$var$load("6wr18"),
    $2c723ca6d4c1166c$var$load("daaDV"),
    $2c723ca6d4c1166c$var$load("ffEVr"),
    $2c723ca6d4c1166c$var$load("9anPW"),
    $2c723ca6d4c1166c$var$load("iAqyW"),
    $2c723ca6d4c1166c$var$load("dHQ6a")
]).then(()=>parcelRequire('Mz1Cd'));

});

parcelRegister("lwir9", function(module, exports) {
module.exports = new URL("editor-ai-opt-in-banner.523b2454.svg", import.meta.url).toString();

});

parcelRegister("3IZob", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $10e4e925e54c9160$var$DocChangeContext = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribeDocChange: ()=>{},
    unsubscribeDocChange: ()=>{}
});
const $10e4e925e54c9160$var$DocChangeContextProvider = ({ children: children })=>{
    const subscriptions = (0, $42omo.useRef)(new Set());
    const handleDocChange = (0, $42omo.useCallback)((editorView)=>{
        subscriptions.current.forEach((callback)=>{
            callback(editorView);
        });
    }, []);
    const subscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.add(callback);
    }, []);
    const unsubscribeDocChange = (0, $42omo.useCallback)((callback)=>{
        subscriptions.current.delete(callback);
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange
        }), [
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContext.Provider, {
        value: value
    }, children({
        handleDocChange: handleDocChange
    }));
};
const $10e4e925e54c9160$export$82deeccbd0ef6b25 = ()=>(0, $42omo.useContext)($10e4e925e54c9160$var$DocChangeContext);
function $10e4e925e54c9160$export$9747c97496f7b432(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10e4e925e54c9160$var$DocChangeContextProvider, null, ({ handleDocChange: handleDocChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                ...props,
                handleDocChange: handleDocChange
            }));
}
module.exports["useDocChangeContext"] = $10e4e925e54c9160$export$82deeccbd0ef6b25;
module.exports["withDocChangeContext"] = $10e4e925e54c9160$export$9747c97496f7b432;

});

parcelRegister("awIbt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5AtW0 = parcelRequire("5AtW0");


var $auTg8 = parcelRequire("auTg8");

function $44be53440eeaa295$export$7deec7951f922f64(WrappedComponent) {
    function withEditorActions(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auTg8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5AtW0.default), {
            render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                    editorActions: editorActions,
                    ...props
                })
        }));
    }
    return withEditorActions;
}
module.exports["withEditorActions"] = $44be53440eeaa295$export$7deec7951f922f64;

});

parcelRegister("5AtW0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jZrBc = parcelRequire("jZrBc");

class $8777d177426e798b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsNew, this.props);
    }
    constructor(props){
        super(props);
    }
}
function $8777d177426e798b$var$WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jZrBc.EditorContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8777d177426e798b$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $8777d177426e798b$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}
module.exports["default"] = $8777d177426e798b$export$2e2bcd8739ae039;

});

parcelRegister("dE9mB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4oS56 = parcelRequire("4oS56");

const $e37f3b5c00f62365$export$1eb912906fa8f246 = ({ children: children, editorAPI: editorAPI })=>{
    const [item, setItem] = (0, $42omo.useState)(null);
    const setNewItem = (0, $42omo.useCallback)((newItem)=>{
        setItem((prevItem)=>{
            if (prevItem && prevItem.itemName !== newItem.itemName) prevItem.close();
            return newItem;
        });
    }, []);
    const removeItem = (0, $42omo.useCallback)((itemName)=>{
        setItem((prevItem)=>prevItem?.itemName === itemName ? null : prevItem);
    }, []);
    const providerValue = (0, $42omo.useMemo)(()=>({
            item: item,
            setItem: setNewItem,
            removeItem: removeItem,
            editorAPI: editorAPI
        }), [
        item,
        removeItem,
        setNewItem,
        editorAPI
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4oS56.EditorContextPanelContext).Provider, {
        value: providerValue
    }, children);
};
module.exports["EditorContextPanelContextProvider"] = $e37f3b5c00f62365$export$1eb912906fa8f246;

});

parcelRegister("4oS56", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a02892cdeb8a3601$export$be6a93f320014444 = (0, $42omo.createContext)({
    item: null,
    setItem: ()=>{},
    removeItem: ()=>{},
    editorAPI: undefined
});
module.exports["EditorContextPanelContext"] = $a02892cdeb8a3601$export$be6a93f320014444;

});

parcelRegister("2KWDO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $auRzv = parcelRequire("auRzv");


var $aWwYt = parcelRequire("aWwYt");


var $8uM2K = parcelRequire("8uM2K");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jvYFk = parcelRequire("jvYFk");


var $6KaG6 = parcelRequire("6KaG6");


var $4oS56 = parcelRequire("4oS56");


var $1vpkQ = parcelRequire("1vpkQ");


var $laFNM = parcelRequire("laFNM");


var $jln20 = parcelRequire("jln20");

const $954086d867f34b7e$export$863fb2cf408343cd = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const panelWidth = (0, $aWwYt.usePanelWidth)();
    const panel = (0, $aWwYt.usePanel)();
    const { item: contextPanelItem, editorAPI: editorAPI } = (0, $42omo.useContext)((0, $4oS56.EditorContextPanelContext));
    const { contentId: contentId, contentStatus: contentStatus } = (0, $laFNM.useApprovals)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const isSidebarApprovalsPaneOpen = rightSidebarContext.getCurrent()?.panelId === (0, $1vpkQ.APPROVALS_PANE_ID);
    const approvalsPaneContextKey = (0, $1vpkQ.getApprovalsPaneContextKey)({
        contentId: contentId,
        contentStatus: contentStatus
    });
    const rightSidebarContextRef = (0, $42omo.useRef)(rightSidebarContext);
    rightSidebarContextRef.current = rightSidebarContext;
    (0, $42omo.useEffect)(()=>{
        (0, $1vpkQ.syncApprovalsPaneContextOwnership)({
            isApprovalsExperimentEnabled: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen,
            contextKey: approvalsPaneContextKey,
            closeApprovalsPane: ()=>rightSidebarContextRef.current.close((0, $1vpkQ.APPROVALS_PANE_ID))
        });
    }, [
        approvalsPaneContextKey,
        isSidebarApprovalsPaneOpen
    ]);
    // Previously, the pattern was to set state in EditorContextPanelContext in order to render components here.
    // Now, we render components directly in EditorContextPanelView to avoid bugs like https://hello.jira.atlassian.cloud/browse/DISCO-4183
    //
    // When the panel system flag is on, comments/details/jira panels render via navigation-system Panel in
    // PageLayout.tsx. Extension panels (ToC, etc.) always render here in ContextPanel.
    if (isObjectSidebarShown && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled) && !((0, $9wGTI.fg)('ads-panel-system-confluence-object-sidebar') && (0, $jvYFk.isMigratedToPanelSystem)(panel?.id))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auRzv.ContextPanel), {
        visible: true,
        editorAPI: editorAPI ?? undefined,
        hasPadding: false,
        customWidth: (panel?.id === 'proactive-ai-panel' || panel?.id.startsWith && panel?.id.startsWith('extensions-panel') || panel?.id === 'editor-element-insert-sidebar-panel') && (0, $9wGTI.fg)('platform_editor_ai_object_sidebar_injection') ? panelWidth || (0, $aWwYt.MIN_PANEL_WIDTH) : (0, $aWwYt.MIN_PANEL_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6KaG6.ObjectSidebarPanel), null));
    let component;
    let hasPadding;
    let customWidth;
    if (contextPanelItem) {
        component = contextPanelItem.component;
        hasPadding = contextPanelItem.hasPadding;
        customWidth = contextPanelItem.customWidth;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auRzv.ContextPanel), {
        visible: !!contextPanelItem,
        editorAPI: editorAPI ?? undefined,
        hasPadding: hasPadding,
        customWidth: customWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, component));
});
module.exports["EditorContextPanelView"] = $954086d867f34b7e$export$863fb2cf408343cd;

});

parcelRegister("8uM2K", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("6KaG6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ce38ba3becf24406$export$877a45ed8043e865 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9Gzp",
    name: "ObjectSidebarPanel",
    loader: async ()=>(await (parcelRequire("kVuRZ"))).ObjectSidebarPanelWrapper
});
module.exports["ObjectSidebarPanel"] = $ce38ba3becf24406$export$877a45ed8043e865;

});

parcelRegister("kVuRZ", function(module, exports) {

let $f3c113a3cc30c721$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f3c113a3cc30c721$var$load("cXoAq"),
    $f3c113a3cc30c721$var$load("geNwN"),
    $f3c113a3cc30c721$var$load("gr9Xf")
]).then(()=>parcelRequire('iFpSu'));

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("laFNM", function(module, exports) {

var $lKLmX = parcelRequire("lKLmX");


var $fenUZ = parcelRequire("fenUZ");


var $2WqwD = parcelRequire("2WqwD");


var $chVEh = parcelRequire("chVEh");


var $lygOH = parcelRequire("lygOH");


var $8V29N = parcelRequire("8V29N");


var $l5Ac1 = parcelRequire("l5Ac1");


var $dzmR0 = parcelRequire("dzmR0");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $jln20 = parcelRequire("jln20");


var $i9VoI = parcelRequire("i9VoI");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");


var $1vpkQ = parcelRequire("1vpkQ");


var $lKfPX = parcelRequire("lKfPX");

const $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS = 'DRAFT';
const $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS = 'CURRENT';
// errorType values returned by confluence_createContentApproval that represent
// known, expected failure conditions. These are marked as handled so they do not
// surface as unexpected errors in monitoring.
const $e450e61f37c9899d$var$EXPECTED_CREATE_APPROVAL_ERROR_TYPES = new Set([
    'BAD_REQUEST',
    'ACCESS_DENIED',
    'NOT_FOUND'
]);
// GraphQL Mutations - AGG Ready
// Mutation: Create Workflow Application
const $e450e61f37c9899d$var$createWorkflowApplicationMutation = (0, $dzmR0.default);
// Mutation: Create Workflow Review
const $e450e61f37c9899d$var$createWorkflowReviewMutation = (0, $l5Ac1.default);
// Mutation: Update Workflow Application
const $e450e61f37c9899d$var$updateWorkflowApplicationMutation = (0, $8V29N.default);
// Mutation: Update Reviewer Decision (Approve/Deny)
const $e450e61f37c9899d$var$updateReviewerDecisionMutation = (0, $lygOH.default);
// Mutation: Update Workflow Review (add/remove reviewers, update status)
const $e450e61f37c9899d$var$updateWorkflowReviewMutation = (0, $chVEh.default);
// Mutation: Resolve Approval Agent
const $e450e61f37c9899d$var$resolveApprovalAgentMutation = (0, $2WqwD.default);
// Mutation: Remove Content Approval Reviewer
const $e450e61f37c9899d$var$removeContentApprovalReviewerMutation = (0, $fenUZ.default);
// GraphQL Query - Combined: active workflow application + available workflow statuses
// Single query for preloading and runtime; fetches both confluence_getActiveWorkflowApplication
// and confluence_contentApprovalStatuses (transitionType: null returns all statuses)
const $e450e61f37c9899d$var$approvalsDataQuery = (0, $lKLmX.default);
// Default context values
const $e450e61f37c9899d$var$defaultContextValue = {
    approvalRequest: null,
    approvalRequestLoading: false,
    availableWorkflowStatuses: [],
    contentId: '',
    contentStatus: $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS,
    isCurrentUserRequestor: false,
    isCurrentUserApprover: false,
    currentUserApprover: null,
    approvalProgress: {
        current: 0,
        total: 0
    },
    hasEditPermission: false,
    isDraftLockedForEditing: false,
    otherModeReviewStatus: null
};
const $e450e61f37c9899d$var$defaultDispatchValue = {
    createWorkflowApplication: async ()=>{
        throw new Error('createWorkflowApplication not implemented');
    },
    cancelWorkflowApplication: async ()=>{
        throw new Error('cancelWorkflowApplication not implemented');
    },
    clearApprovalRequestOptimistically: ()=>{},
    startApproval: async ()=>{
        throw new Error('startApproval not implemented');
    },
    updateApprovalStatus: async ()=>{
        throw new Error('updateApprovalStatus not implemented');
    },
    addApprover: async ()=>{
        throw new Error('addApprover not implemented');
    },
    removeApprover: async ()=>{
        throw new Error('removeApprover not implemented');
    },
    cancelApproval: async ()=>{
        throw new Error('cancelApproval not implemented');
    },
    resolveApprovalAgent: async ()=>''
};
const $e450e61f37c9899d$export$eb47cecb126081cc = /*#__PURE__*/ (0, $42omo.createContext)($e450e61f37c9899d$var$defaultContextValue);
$e450e61f37c9899d$export$eb47cecb126081cc.displayName = 'ApprovalsContext';
const $e450e61f37c9899d$export$a8239efa8a51a660 = /*#__PURE__*/ (0, $42omo.createContext)($e450e61f37c9899d$var$defaultDispatchValue);
$e450e61f37c9899d$export$a8239efa8a51a660.displayName = 'ApprovalsDispatchContext';
/**
 * DefaultApprovalsProvider - Returns default/empty approval context
 */ const $e450e61f37c9899d$var$DefaultApprovalsProvider = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$export$eb47cecb126081cc.Provider, {
        value: $e450e61f37c9899d$var$defaultContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$export$a8239efa8a51a660.Provider, {
        value: $e450e61f37c9899d$var$defaultDispatchValue
    }, children));
const $e450e61f37c9899d$export$c720d3c28af710a = ({ children: children, contentId: contentIdProp })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contentIdProp || pageContentId;
    if (!cloudId || !contentId || !(0, $9wGTI.fg)('confluence_approvals_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$var$DefaultApprovalsProvider, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$var$ApprovalsProviderComponent, {
        contentId: contentId
    }, children);
};
/**
 * This provider:
 * 1. Fetches approval data using GraphQL query
 * 2. Exposes data through read context (ApprovalsContext)
 * 3. Exposes mutations through write context (ApprovalsDispatchContext)
 * 4. Handles cache updates and refetching after mutations
 */ const $e450e61f37c9899d$var$ApprovalsProviderComponent = ({ children: children, contentId: contentId })=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentStatus = pageMode === (0, $cD1qu.PageMode).EDIT ? $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS : $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS;
    // The content status that is opposite of the current status
    const otherContentStatus = contentStatus === $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS ? $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS : $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS;
    const { close: closeRightSidebar } = (0, $jln20.useRightSidebarContext)();
    const [isOptimisticallyCancelled, setIsOptimisticallyCancelled] = (0, $42omo.useState)(false);
    const [optimisticWorkflowStatus, setOptimisticWorkflowStatus] = (0, $42omo.useState)(null);
    // Tracks whether a cancelWorkflowApplication mutation is currently in flight.
    // Used to prevent the workflowApplicationChanged subscription from resetting
    // isOptimisticallyCancelled before the cancel mutation has completed on the backend,
    // which would cause a flash of stale workflow status data.
    const isCancellationInFlightRef = (0, $42omo.useRef)(false);
    // Track whether we've received data for the current content/mode pair. This ensures
    // approvalRequestLoading stays true from the moment contentId or contentStatus changes until
    // fresh data has actually arrived — even if useQueryInteropRelay's loading flag flips true→false
    // within a single React batch (e.g. when the Relay store has cached normalized data).
    const currentContentCacheKey = `${contentId}:${contentStatus}`;
    const lastSettledContentCacheKeyRef = (0, $42omo.useRef)(null);
    const shouldForceNetworkFetch = lastSettledContentCacheKeyRef.current !== currentContentCacheKey;
    // Reset optimistic state when navigating to a different page or switching content status (View ↔ Edit).
    (0, $42omo.useEffect)(()=>{
        setIsOptimisticallyCancelled(false);
        setOptimisticWorkflowStatus(null);
    }, [
        contentId,
        contentStatus
    ]);
    const canEdit = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId,
        operation: (0, $lfBMY.OperationTypes).UPDATE,
        status: contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? (0, $cD1qu.CURRENT_STATUS) : (0, $cD1qu.DRAFT_STATUS)
    });
    const hasEditPermission = canEdit ?? false;
    // Query for available workflow statuses and active workflow application
    const { data: approvalsData, loading: approvalsLoading, refetch: refetchApprovalsData } = (0, $jMyy4.useQueryInterop)($e450e61f37c9899d$var$approvalsDataQuery, {
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            transitionType: null,
            otherContentStatus: // null returns all statuses
            otherContentStatus
        },
        ...shouldForceNetworkFetch ? {
            fetchPolicy: 'network-only'
        } : {},
        skip: !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)
    });
    // Detect when approvalsData belongs to a previously-viewed page. useQueryInteropRelay keeps old
    // data in state while a refetch with new variables is in flight, so without this guard the UI
    // would render Page A's fully-interactive workflow/review data while viewing Page B.
    const isDataStale = (0, $42omo.useMemo)(()=>{
        const responseContentId = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.contentId;
        // If the response contains a workflow application for a different page, data is stale.
        // When responseContentId is null/undefined/empty (no active workflow or falsy defaults),
        // there is nothing stale to hide.
        return !!responseContentId && responseContentId !== contentId;
    }, [
        approvalsData,
        contentId
    ]);
    if (!approvalsLoading && !isDataStale) lastSettledContentCacheKeyRef.current = currentContentCacheKey;
    const isAwaitingFreshData = lastSettledContentCacheKeyRef.current !== currentContentCacheKey;
    const availableWorkflowStatuses = (0, $42omo.useMemo)(()=>{
        if (isDataStale || !approvalsData?.confluence_contentApprovalStatuses) return [];
        return approvalsData.confluence_contentApprovalStatuses.reduce((acc, status)=>{
            if (status === null || status === undefined) return acc;
            acc.push({
                id: status.id || '',
                name: status.displayProperties?.name || '',
                allowsReviews: status.allowsReviews || false,
                color: status.displayProperties?.color || undefined
            });
            return acc;
        }, []);
    }, [
        isDataStale,
        approvalsData
    ]);
    const contentVersion = (0, $42omo.useMemo)(()=>{
        const fromWorkflow = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.contentVersion;
        if (fromWorkflow !== undefined && fromWorkflow !== null) return fromWorkflow;
        return approvalsData?.content?.nodes?.[0]?.version?.number ?? 0;
    }, [
        approvalsData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (optimisticWorkflowStatus && approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.workflowStatusId === optimisticWorkflowStatus.id) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setOptimisticWorkflowStatus(null);
    }, [
        approvalsData,
        optimisticWorkflowStatus
    ]);
    const approvalRequest = (0, $42omo.useMemo)(()=>{
        if (isDataStale) return null;
        if (isOptimisticallyCancelled) return null;
        const application = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication;
        if (optimisticWorkflowStatus && application?.workflowStatusId !== optimisticWorkflowStatus.id) return {
            application: {
                contentId: contentId,
                contentVersion: contentVersion,
                contentStatus: contentStatus,
                applicationId: '',
                isActive: true,
                workflowStatusId: optimisticWorkflowStatus.id
            },
            review: null
        };
        const review = approvalsData?.confluence_getActiveWorkflowApplication?.workflowReviewWithDecisions;
        if (!application) return null;
        return {
            application: {
                contentId: application.contentId || contentId,
                contentVersion: application.contentVersion || 1,
                contentStatus: application.contentStatus || '',
                // NOTE: This indicates draft (DRAFT) or published (CURRENT)
                applicationId: application.id || '',
                isActive: application.isActive || false,
                workflowStatusId: application.workflowStatusId || '',
                ...application.modifier && {
                    applicationLastModifiedBy: {
                        displayName: application.modifier.displayName || '',
                        avatarUrl: application.modifier.photos?.find((p)=>p?.isPrimary)?.value || undefined,
                        userId: application.modifier.id || ''
                    }
                },
                applicationLastModifiedDate: application.lastModificationDate?.value || ''
            },
            // There can be an application without a review; return review: null in that case
            review: review !== null && review !== undefined ? {
                reviewId: review.id || '',
                reviewCreationDate: review.creationDate?.value || '',
                requestorId: review.creatorAaid || '',
                requestorName: review.creator?.displayName || '',
                requestorAvatarUrl: review.creator?.photos?.find((p)=>p?.isPrimary)?.value || '',
                reviewLastModifiedDate: review.reviewLastModified?.value || '',
                // milliseconds since epoch
                reviewComment: review.reviewComment || undefined,
                reviewStatus: review.reviewStatus || 'PENDING',
                approvers: review.reviewerDecisions?.reduce((acc, reviewerDecision)=>{
                    if (reviewerDecision == null) return acc;
                    acc.push({
                        decisionId: reviewerDecision.decisionId || '',
                        reviewerId: reviewerDecision.reviewerId || '',
                        isRequired: reviewerDecision.required ?? true,
                        principalId: reviewerDecision.principalId || '',
                        principalType: reviewerDecision.principalType || 'USER',
                        name: reviewerDecision.user?.displayName || '',
                        avatarUrl: reviewerDecision.user?.photos?.find((p)=>p?.isPrimary)?.value || '',
                        status: reviewerDecision.reviewerDecisionStatus || 'PENDING_REVIEW',
                        decisionComment: reviewerDecision.comment || '',
                        responseLastModifiedDate: reviewerDecision?.lastModifiedDate?.value || ''
                    });
                    return acc;
                }, [])
            } : null
        };
    }, [
        isDataStale,
        isOptimisticallyCancelled,
        optimisticWorkflowStatus,
        contentVersion,
        contentStatus,
        approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication,
        approvalsData?.confluence_getActiveWorkflowApplication?.workflowReviewWithDecisions,
        contentId
    ]);
    const isCurrentUserRequestor = (0, $42omo.useMemo)(()=>{
        return approvalRequest?.review?.requestorId === userId;
    }, [
        approvalRequest,
        userId
    ]);
    const currentUserApprover = (0, $42omo.useMemo)(()=>{
        return approvalRequest?.review?.approvers?.find((approver)=>approver.principalId === userId) || null;
    }, [
        approvalRequest,
        userId
    ]);
    const onWorkflowApplicationChanged = (0, $42omo.useCallback)((_eventName, response)=>{
        const eventData = response?.workflowApplicationChanged;
        const eventContentStatus = eventData?.contentStatus;
        if (eventContentStatus !== contentStatus) return;
        // Always refetch to pick up the latest data from the server.
        refetchApprovalsData({
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            transitionType: null,
            otherContentStatus: otherContentStatus
        });
        // Reset the optimistic cancellation state when a live update arrives from another user.
        // Without this, if User 1 clears the review status (setting isOptimisticallyCancelled=true)
        // and User 2 then adds the review status back, User 1 would never see the new review
        // because isOptimisticallyCancelled would still be true, causing approvalRequest to
        // remain null even after the refetch returns fresh data with the new review.
        //
        // However, skip resetting when a cancellation mutation is in flight — the subscription
        // event may arrive before the mutation completes, meaning the refetch would return stale
        // data that still shows the old workflow status. This causes a flash where the old status
        // briefly reappears before the cancel mutation settles and the correct state is shown.
        // The cancel mutation's own completion path handles clearing isCancellationInFlightRef
        // and triggering a final refetch with up-to-date data.
        if (!isCancellationInFlightRef.current) setIsOptimisticallyCancelled(false);
    }, [
        refetchApprovalsData,
        cloudId,
        contentId,
        contentStatus,
        otherContentStatus
    ]);
    // Subscribe to real-time approval status changes (from backend workflowApplicationChanged events)
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'ApprovalsProviderWorkflowApplicationChanged',
        delta: 'workflowApplicationChanged',
        contentId: contentId,
        contentType: contentType || 'page',
        skip: !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
        onDataReceived: onWorkflowApplicationChanged
    });
    // When the other mode's workflow changes (e.g. a DRAFT review is started while viewing the
    // published page), refetch so that otherModeReviewStatus reflects the latest state and any
    // banners or warnings dependent on it update accordingly.
    const onOtherModeWorkflowApplicationChanged = (0, $42omo.useCallback)((_eventName, response)=>{
        const eventData = response?.workflowApplicationChanged;
        const eventContentStatus = eventData?.contentStatus;
        if (eventContentStatus !== otherContentStatus) return;
        refetchApprovalsData({
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            transitionType: null,
            otherContentStatus: otherContentStatus
        });
    }, [
        refetchApprovalsData,
        cloudId,
        contentId,
        contentStatus,
        otherContentStatus
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'ApprovalsProviderOtherModeWorkflowApplicationChanged',
        delta: 'workflowApplicationChanged',
        contentId: contentId,
        contentType: contentType || 'page',
        skip: !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
        onDataReceived: onOtherModeWorkflowApplicationChanged
    });
    const approvalProgress = (0, $42omo.useMemo)(()=>{
        if (!approvalRequest) return {
            current: 0,
            total: 0
        };
        const responded = approvalRequest.review?.approvers?.filter((a)=>a.status !== null && a.status !== 'PENDING_REVIEW').length;
        return {
            current: responded ?? 0,
            total: approvalRequest.review?.approvers?.length ?? 0
        };
    }, [
        approvalRequest
    ]);
    // GraphQL Mutations
    const [createWorkflowApplicationMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$createWorkflowApplicationMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [createWorkflowReviewMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$createWorkflowReviewMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [updateWorkflowApplicationMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateWorkflowApplicationMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [updateReviewerDecisionMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateReviewerDecisionMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [updateWorkflowReviewMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateWorkflowReviewMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [removeContentApprovalReviewerMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$removeContentApprovalReviewerMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: {
                    cloudId: cloudId,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    transitionType: null,
                    otherContentStatus: otherContentStatus
                }
            }
        ]
    });
    const [resolveApprovalAgentMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$resolveApprovalAgentMutation);
    // Wrapped mutation functions
    // Resolves the approval agent ID. If the mutation fails, returns an empty string
    // so the caller can fall back to invoking regular Rovo instead of the agent.
    const resolveApprovalAgent = (0, $42omo.useCallback)(async ()=>{
        try {
            const result = await resolveApprovalAgentMutationFn({
                variables: {
                    cloudId: cloudId
                }
            });
            const response = result?.data?.confluence_resolveApprovalAgent;
            if (!response?.success || response.errors?.length > 0) return '';
            return response.agent?.id ?? '';
        } catch  {
            return '';
        }
    }, [
        cloudId,
        resolveApprovalAgentMutationFn
    ]);
    const createWorkflowApplication = (0, $42omo.useCallback)(async (status)=>{
        setIsOptimisticallyCancelled(false);
        setOptimisticWorkflowStatus(status);
        try {
            const result = await createWorkflowApplicationMutationFn({
                variables: {
                    cloudId: cloudId,
                    createWorkflowApplicationRequestInput: {
                        contentId: contentId,
                        contentStatus: contentStatus,
                        workflowId: 1,
                        workflowStatusId: 1,
                        // hardcoded -- backend assigns status on creation
                        isActive: true
                    }
                }
            });
            const workflowStatus = result.data?.confluence_createWorkflowApplication?.workflowStatus;
            return {
                applicationId: result.data?.confluence_createWorkflowApplication?.workflowApplication?.id,
                workflowStatusId: workflowStatus?.id ?? '1',
                name: workflowStatus?.displayProperties?.name || '',
                allowsReviews: workflowStatus?.allowsReviews || false
            };
        } catch (error) {
            setOptimisticWorkflowStatus(null);
            throw error;
        }
    }, [
        cloudId,
        contentId,
        contentStatus,
        createWorkflowApplicationMutationFn
    ]);
    /** Variables are optional: if not provided, this will cancel the workflow application for
  the latest content version for the current content status */ const cancelWorkflowApplication = (0, $42omo.useCallback)(async (variables)=>{
        closeRightSidebar((0, $1vpkQ.APPROVALS_PANE_ID));
        isCancellationInFlightRef.current = true;
        try {
            await updateWorkflowApplicationMutationFn({
                variables: {
                    cloudId: cloudId,
                    updateWorkflowApplicationRequestInput: {
                        contentId: variables?.contentId ? parseInt(variables.contentId, 10) : parseInt(contentId, 10),
                        contentStatus: variables?.contentStatus ?? contentStatus,
                        version: variables?.version ?? (contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? contentVersion : 1),
                        workflowStatusId: parseInt(variables?.workflowStatusId ?? approvalRequest?.application?.workflowStatusId ?? '1', 10),
                        isActive: false,
                        workflowId: 1
                    }
                }
            });
        } catch (error) {
            setIsOptimisticallyCancelled(false);
            (0, $7Sm4c.markErrorAsHandled)(error);
        // TODO: Add error handling
        } finally{
            isCancellationInFlightRef.current = false;
        }
    }, [
        cloudId,
        contentId,
        contentStatus,
        contentVersion,
        approvalRequest?.application?.workflowStatusId,
        updateWorkflowApplicationMutationFn,
        closeRightSidebar
    ]);
    const clearApprovalRequestOptimistically = (0, $42omo.useCallback)(()=>{
        setIsOptimisticallyCancelled(true);
        setOptimisticWorkflowStatus(null);
    }, []);
    const startApproval = (0, $42omo.useCallback)(async (variables)=>{
        const result = await createWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                createContentApprovalRequestInput: {
                    contentId: contentId,
                    contentStatus: contentStatus,
                    version: contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? contentVersion : 1,
                    // DRAFT version is always 1,
                    comment: variables.message,
                    reviewers: variables.approvers
                }
            }
        });
        const response = result.data?.confluence_createContentApproval;
        if (response && !response.success) {
            const firstError = response.errors?.[0];
            const errorMessage = firstError?.message || 'Failed to start approval';
            const errorType = firstError?.extensions?.errorType;
            // Attach extensions to the error so callers (e.g. getFailureStatusCode in
            // analytics) can read the statusCode without access to the raw response.
            const error = Object.assign(new Error(errorMessage), {
                extensions: firstError?.extensions
            });
            if (errorType && $e450e61f37c9899d$var$EXPECTED_CREATE_APPROVAL_ERROR_TYPES.has(errorType)) // Known, expected error — mark as handled so it is not reported to monitoring.
            (0, $7Sm4c.markErrorAsHandled)(error);
            else // Unexpected error — report to monitoring before surfacing to the caller.
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
            });
            throw error;
        }
        return response?.contentApproval ?? undefined;
    }, [
        cloudId,
        contentId,
        contentStatus,
        contentVersion,
        createWorkflowReviewMutationFn
    ]);
    const updateApprovalStatus = (0, $42omo.useCallback)(async (variables)=>{
        const decisionStatus = variables.status;
        const result = await updateReviewerDecisionMutationFn({
            variables: {
                cloudId: cloudId,
                confluenceUpdateReviewerDecisionInput: {
                    reviewerId: parseInt(variables.reviewerId, 10),
                    decisionStatus: decisionStatus,
                    comment: variables.comment || null
                }
            }
        });
        const response = result.data?.confluence_updateReviewerDecision;
        if (response && !response.success) {
            const errorMessage = response.errors?.[0]?.message || 'Failed to update reviewer decision';
            throw new Error(errorMessage);
        }
    }, [
        cloudId,
        updateReviewerDecisionMutationFn
    ]);
    const addApprover = (0, $42omo.useCallback)(async (variables)=>{
        if (!approvalRequest?.application || !approvalRequest?.review) throw new Error('approval request with review is required');
        const existingReviewers = approvalRequest.review.approvers.map((a)=>({
                principalId: a.principalId,
                principalType: a.principalType === 'GROUP' ? 'GROUP' : 'USER',
                isRequired: a.isRequired
            }));
        const existingIds = new Set(existingReviewers.map((r)=>r.principalId));
        const mergedReviewers = [
            ...existingReviewers
        ];
        for (const r of variables.approvers)if (!existingIds.has(r.principalId)) {
            mergedReviewers.push({
                principalId: r.principalId,
                principalType: r.principalType,
                isRequired: r.isRequired
            });
            existingIds.add(r.principalId);
        }
        await updateWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                updateContentApprovalGraphQLInput: {
                    workflowApplicationId: parseInt(approvalRequest.application.applicationId, 10),
                    contentApprovalReviewId: parseInt(approvalRequest.review.reviewId, 10),
                    reviewers: mergedReviewers.map((a)=>({
                            principalId: a.principalId,
                            principalType: a.principalType === 'GROUP' ? 'GROUP' : 'USER',
                            isRequired: a.isRequired
                        }))
                }
            }
        });
    }, [
        approvalRequest,
        cloudId,
        updateWorkflowReviewMutationFn
    ]);
    const removeApprover = (0, $42omo.useCallback)(async (variables)=>{
        if (!approvalRequest?.application || !approvalRequest?.review) throw new Error('approval request with review is required');
        const approver = approvalRequest.review.approvers.find((a)=>a.principalId === variables.principalId);
        if (!approver) throw new Error('Approver not found in current review');
        await removeContentApprovalReviewerMutationFn({
            variables: {
                cloudId: cloudId,
                removeContentApprovalReviewerInput: {
                    workflowApplicationId: approvalRequest.application.applicationId,
                    contentApprovalReviewId: approvalRequest.review.reviewId,
                    principalId: variables.principalId,
                    principalType: approver.principalType
                }
            }
        });
    }, [
        approvalRequest,
        cloudId,
        removeContentApprovalReviewerMutationFn
    ]);
    const cancelApproval = (0, $42omo.useCallback)(async (variables)=>{
        closeRightSidebar((0, $1vpkQ.APPROVALS_PANE_ID));
        await updateWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                updateContentApprovalGraphQLInput: {
                    workflowApplicationId: parseInt(variables.workflowApplicationId, 10),
                    contentApprovalReviewId: parseInt(variables.contentApprovalReviewId, 10),
                    approvalStatus: 'CANCELED'
                }
            }
        });
    }, [
        cloudId,
        updateWorkflowReviewMutationFn,
        closeRightSidebar
    ]);
    const otherModeReviewStatus = (0, $42omo.useMemo)(()=>{
        if (isDataStale) return null;
        return approvalsData?.confluence_getActiveWorkflowApplicationForOtherStatus?.workflowReviewWithDecisions?.reviewStatus ?? null;
    }, [
        isDataStale,
        approvalsData?.confluence_getActiveWorkflowApplicationForOtherStatus
    ]);
    const isDraftLockedForEditing = (0, $42omo.useMemo)(()=>{
        if (contentStatus !== $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS) return false;
        const review = approvalRequest?.review;
        if (review == null) return false;
        return review.reviewStatus === 'PENDING' || review.reviewStatus === 'APPROVED';
    }, [
        contentStatus,
        approvalRequest?.review
    ]);
    // Context values - memoized to prevent unnecessary re-renders
    const contextValue = (0, $42omo.useMemo)(()=>({
            approvalRequest: approvalRequest,
            approvalRequestLoading: approvalsLoading || isDataStale || isAwaitingFreshData,
            contentVersion: contentVersion,
            availableWorkflowStatuses: availableWorkflowStatuses,
            contentId: contentId,
            contentStatus: contentStatus,
            isCurrentUserRequestor: isCurrentUserRequestor,
            isCurrentUserApprover: !!currentUserApprover,
            currentUserApprover: currentUserApprover,
            approvalProgress: approvalProgress,
            hasEditPermission: hasEditPermission,
            isDraftLockedForEditing: isDraftLockedForEditing,
            otherModeReviewStatus: otherModeReviewStatus
        }), [
        approvalRequest,
        approvalsLoading,
        isDataStale,
        isAwaitingFreshData,
        contentVersion,
        availableWorkflowStatuses,
        contentId,
        contentStatus,
        isCurrentUserRequestor,
        currentUserApprover,
        approvalProgress,
        hasEditPermission,
        isDraftLockedForEditing,
        otherModeReviewStatus
    ]);
    const dispatchValue = (0, $42omo.useMemo)(()=>({
            createWorkflowApplication: createWorkflowApplication,
            cancelWorkflowApplication: cancelWorkflowApplication,
            clearApprovalRequestOptimistically: clearApprovalRequestOptimistically,
            startApproval: startApproval,
            updateApprovalStatus: updateApprovalStatus,
            addApprover: addApprover,
            removeApprover: removeApprover,
            cancelApproval: cancelApproval,
            resolveApprovalAgent: resolveApprovalAgent
        }), [
        createWorkflowApplication,
        cancelWorkflowApplication,
        clearApprovalRequestOptimistically,
        startApproval,
        updateApprovalStatus,
        addApprover,
        removeApprover,
        cancelApproval,
        resolveApprovalAgent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$export$eb47cecb126081cc.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e450e61f37c9899d$export$a8239efa8a51a660.Provider, {
        value: dispatchValue
    }, children, (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lKfPX.ApprovalCtaFlag), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
        name: "approvals",
        types: [
            (0, $c0urc.ReloadType).content
        ],
        reload: refetchApprovalsData
    }))));
};
const $e450e61f37c9899d$export$38d1715f438e155f = ()=>{
    return (0, $42omo.useContext)($e450e61f37c9899d$export$eb47cecb126081cc);
};
const $e450e61f37c9899d$export$ff5d1fbbfb1fe9d8 = ()=>{
    return (0, $42omo.useContext)($e450e61f37c9899d$export$a8239efa8a51a660);
};
module.exports["ApprovalsProvider"] = $e450e61f37c9899d$export$c720d3c28af710a;
module.exports["useApprovals"] = $e450e61f37c9899d$export$38d1715f438e155f;
module.exports["useApprovalsDispatch"] = $e450e61f37c9899d$export$ff5d1fbbfb1fe9d8;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<85c10c3297d9370c832c39704b0be624>>
 * @relayHash f5d07637afe71c7ca06b7f159493ea94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "otherContentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "transitionType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            v4 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v7 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v8 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v9 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v10 = [
        v4 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "success"
    }, v12 = {
        "kind": "ScalarField",
        "name": "message"
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v14 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v15 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v17 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = [
        v4 /*: any*/ ,
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v23 = [
        v5 /*: any*/ ,
        v20 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v21 /*: any*/ ,
                v22 /*: any*/ 
            ]
        }
    ], v24 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v23 /*: any*/ 
    }, v25 = [
        v21 /*: any*/ 
    ], v26 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v23 /*: any*/ 
            }
        ]
    }, v27 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            v16 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v25 /*: any*/ 
            },
            v24 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v25 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            v20 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v22 /*: any*/ ,
                                    v21 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v28 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v5 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v10 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v15 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v15 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v10 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v28 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v28 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f5d07637afe71c7ca06b7f159493ea94",
            "id": "e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType){content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "a2315c6dd75143b0285f57068b70bc22";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("fenUZ", function(module, exports) {
/**
 * @generated SignedSource<<df6dc189b4b8d3de81de424f7d095d1b>>
 * @relayHash 1c45745cc12810ecdbcde25f697fac8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ffe21b74af26001371a0042d20b490c10d31e8bdd61af3f5ec29791965fdf02
const $51700bb24bdc6b5f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "removeContentApprovalReviewerInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "removeContentApprovalReviewerInput",
            "variableName": "removeContentApprovalReviewerInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_removeContentApprovalReviewer",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_removeContentApprovalReviewer",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1c45745cc12810ecdbcde25f697fac8e",
            "id": "1ffe21b74af26001371a0042d20b490c10d31e8bdd61af3f5ec29791965fdf02",
            "metadata": {},
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextRemoveContentApprovalReviewerMutation($cloudId:ID!,$removeContentApprovalReviewerInput:ConfluenceRemoveContentApprovalReviewerInput!){confluence_removeContentApprovalReviewer(cloudId:$cloudId,removeContentApprovalReviewerInput:$removeContentApprovalReviewerInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$51700bb24bdc6b5f$var$node.hash = "697e5f36bdc5f862fd4fb3d7c42a7b48";
var $51700bb24bdc6b5f$export$2e2bcd8739ae039 = $51700bb24bdc6b5f$var$node;
module.exports["default"] = $51700bb24bdc6b5f$export$2e2bcd8739ae039;

});

parcelRegister("2WqwD", function(module, exports) {
/**
 * @generated SignedSource<<f776f6c3eea0f56a6c9304b5300135fa>>
 * @relayHash 7e7e86c50393bd91ccd31140eb439adb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9bcae1436f9202c13d56dc45389fd2497c967083f8c60073ee6be35e8a9b328
const $e3200d7e3785782c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceApprovalAgentPayload",
            "kind": "LinkedField",
            "name": "confluence_resolveApprovalAgent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceApprovalAgent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e7e86c50393bd91ccd31140eb439adb",
            "id": "b9bcae1436f9202c13d56dc45389fd2497c967083f8c60073ee6be35e8a9b328",
            "metadata": {},
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextResolveApprovalAgentMutation($cloudId:ID!){confluence_resolveApprovalAgent(cloudId:$cloudId){success,agent{id},errors{message}}}"
        }
    };
}();
$e3200d7e3785782c$var$node.hash = "e4cb35491d152f5cba04815adf8e599d";
var $e3200d7e3785782c$export$2e2bcd8739ae039 = $e3200d7e3785782c$var$node;
module.exports["default"] = $e3200d7e3785782c$export$2e2bcd8739ae039;

});

parcelRegister("chVEh", function(module, exports) {
/**
 * @generated SignedSource<<51c3cf76e3d3f25d80af6115771e17b4>>
 * @relayHash 27144a0bed02bf89bd05934de4bc8547
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b58a57226e51cf212c8f99536a985edea6c86fe3250346eb71ececf9680043a1
const $340575ae55838f10$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateContentApprovalGraphQLInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "updateContentApprovalGraphQLInput",
            "variableName": "updateContentApprovalGraphQLInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "concreteType": "ConfluenceWorkflowReview",
        "kind": "LinkedField",
        "name": "contentApproval",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewStatus"
            },
            {
                "kind": "ScalarField",
                "name": "comment"
            },
            {
                "concreteType": "ConfluenceWorkflowReviewer",
                "kind": "LinkedField",
                "name": "reviewers",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "displayName"
                            },
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "AtlassianUserEmail",
                                "kind": "LinkedField",
                                "name": "emails",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "27144a0bed02bf89bd05934de4bc8547",
            "id": "b58a57226e51cf212c8f99536a985edea6c86fe3250346eb71ececf9680043a1",
            "metadata": {},
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateWorkflowReviewMutation($cloudId:ID!,$updateContentApprovalGraphQLInput:ConfluenceUpdateContentApprovalRequestInput!){confluence_updateContentApproval(cloudId:$cloudId,updateContentApprovalGraphQLInput:$updateContentApprovalGraphQLInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},contentApproval{id,reviewStatus,comment,reviewers{principalType,principalId,isRequired,user{id,displayName,photos{isPrimary,value},emails{isPrimary,value}}}}}}"
        }
    };
}();
$340575ae55838f10$var$node.hash = "6e686f80296d6e3ef707726180b7464e";
var $340575ae55838f10$export$2e2bcd8739ae039 = $340575ae55838f10$var$node;
module.exports["default"] = $340575ae55838f10$export$2e2bcd8739ae039;

});

parcelRegister("lygOH", function(module, exports) {
/**
 * @generated SignedSource<<943ce0ee83e0cbf80915334217734bbe>>
 * @relayHash afa8664360527d902e240ba8f2439caa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9b07106aa2dedfbc69fa47c92f7f5096395d3f5d08fc7e76614f3b76ac0fde
const $0aa9e770fdcc2607$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "confluenceUpdateReviewerDecisionInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "confluenceUpdateReviewerDecisionInput",
            "variableName": "confluenceUpdateReviewerDecisionInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowReviewerDecisionPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateReviewerDecision",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowReviewerDecisionPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateReviewerDecision",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "afa8664360527d902e240ba8f2439caa",
            "id": "3f9b07106aa2dedfbc69fa47c92f7f5096395d3f5d08fc7e76614f3b76ac0fde",
            "metadata": {},
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateReviewerDecisionMutation($cloudId:ID!,$confluenceUpdateReviewerDecisionInput:ConfluenceUpdateReviewerDecisionInput!){confluence_updateReviewerDecision(cloudId:$cloudId,confluenceUpdateReviewerDecisionInput:$confluenceUpdateReviewerDecisionInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$0aa9e770fdcc2607$var$node.hash = "60408e64e95523cddd0fb83ab25da2c7";
var $0aa9e770fdcc2607$export$2e2bcd8739ae039 = $0aa9e770fdcc2607$var$node;
module.exports["default"] = $0aa9e770fdcc2607$export$2e2bcd8739ae039;

});

parcelRegister("8V29N", function(module, exports) {
/**
 * @generated SignedSource<<48d4c9d6960208675b0db28fc2038901>>
 * @relayHash dc259a2e51a1b01648a5dcdfa8b8904f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9164e05993bece776e7f69fa933f1d4c717c8c04a05c0017bd93c6332bf95fd6
const $f7bc745188f2b8be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateWorkflowApplicationRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "updateWorkflowApplicationRequestInput",
            "variableName": "updateWorkflowApplicationRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dc259a2e51a1b01648a5dcdfa8b8904f",
            "id": "9164e05993bece776e7f69fa933f1d4c717c8c04a05c0017bd93c6332bf95fd6",
            "metadata": {},
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateWorkflowApplicationMutation($cloudId:ID!,$updateWorkflowApplicationRequestInput:ConfluenceUpdateWorkflowApplicationRequestInput!){confluence_updateWorkflowApplication(cloudId:$cloudId,updateWorkflowApplicationRequestInput:$updateWorkflowApplicationRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$f7bc745188f2b8be$var$node.hash = "cc3c6f7f13981af43e98d2ff646b92b8";
var $f7bc745188f2b8be$export$2e2bcd8739ae039 = $f7bc745188f2b8be$var$node;
module.exports["default"] = $f7bc745188f2b8be$export$2e2bcd8739ae039;

});

parcelRegister("l5Ac1", function(module, exports) {
/**
 * @generated SignedSource<<6c75cde3a5d126879e5a47c30b223167>>
 * @relayHash dcc67a3c302bf1451aa072fa5b312aec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43f604e8c261aebb7a014bc621255865be5532c76b95bb916a3188eab46880eb
const $8c79d69cd01688c2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createContentApprovalRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "createContentApprovalRequestInput",
            "variableName": "createContentApprovalRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "concreteType": "ConfluenceWorkflowReview",
        "kind": "LinkedField",
        "name": "contentApproval",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowApplicationId"
            },
            {
                "kind": "ScalarField",
                "name": "reviewStatus"
            },
            {
                "kind": "ScalarField",
                "name": "comment"
            },
            {
                "concreteType": "ConfluenceWorkflowReviewer",
                "kind": "LinkedField",
                "name": "reviewers",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "displayName"
                            },
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "AtlassianUserEmail",
                                "kind": "LinkedField",
                                "name": "emails",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dcc67a3c302bf1451aa072fa5b312aec",
            "id": "43f604e8c261aebb7a014bc621255865be5532c76b95bb916a3188eab46880eb",
            "metadata": {},
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextCreateWorkflowReviewMutation($cloudId:ID!,$createContentApprovalRequestInput:ConfluenceCreateContentApprovalRequestInput!){confluence_createContentApproval(cloudId:$cloudId,createContentApprovalRequestInput:$createContentApprovalRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},contentApproval{id,workflowApplicationId,reviewStatus,comment,reviewers{principalType,principalId,isRequired,user{id,displayName,photos{isPrimary,value},emails{isPrimary,value}}}}}}"
        }
    };
}();
$8c79d69cd01688c2$var$node.hash = "7aac889eeb2c9a4140e4c54a84dd5a22";
var $8c79d69cd01688c2$export$2e2bcd8739ae039 = $8c79d69cd01688c2$var$node;
module.exports["default"] = $8c79d69cd01688c2$export$2e2bcd8739ae039;

});

parcelRegister("dzmR0", function(module, exports) {
/**
 * @generated SignedSource<<604e90251aa7c49b2049b976391f3655>>
 * @relayHash 1e9445150784f0b413d2dfb9d66ed41b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed205a119d56079a8af470bc8da947b40a588f347acb2d591ba9e50a0228a7ab
const $2c0c245b53785143$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createWorkflowApplicationRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "createWorkflowApplicationRequestInput",
            "variableName": "createWorkflowApplicationRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "workflowStatus",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "icon"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v7 /*: any*/ ,
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1e9445150784f0b413d2dfb9d66ed41b",
            "id": "ed205a119d56079a8af470bc8da947b40a588f347acb2d591ba9e50a0228a7ab",
            "metadata": {},
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextCreateWorkflowApplicationMutation($cloudId:ID!,$createWorkflowApplicationRequestInput:ConfluenceCreateWorkflowApplicationRequestInput!){confluence_createWorkflowApplication(cloudId:$cloudId,createWorkflowApplicationRequestInput:$createWorkflowApplicationRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id},workflowStatus{id,allowsReviews,displayProperties{name,description,color,icon}}}}"
        }
    };
}();
$2c0c245b53785143$var$node.hash = "3ee5dcab7b3bf9faa65315741af6e60b";
var $2c0c245b53785143$export$2e2bcd8739ae039 = $2c0c245b53785143$var$node;
module.exports["default"] = $2c0c245b53785143$export$2e2bcd8739ae039;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        }
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        }
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<ad0100fe29e950a1379a2ddc53821b8d>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<47caf30fb1e1105daac0e1107cd5ed40>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<f845cfcec4db37305d62ff3698bca4f3>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<bba9a13a8c149665bd220be9731de503>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $7hXu9 = parcelRequire("7hXu9");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $7hXu9.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}workflowApplicationChanged{contentId changeType newWorkflowStatusId contentStatus version __typename}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}contentAccessDecisionMade{contentId decision __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("3Xs1I", function(module, exports) {

var $1SNEF = parcelRequire("1SNEF");

const $cf20926a3ed5ce71$export$b107cc869756fe73 = (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
};
module.exports["QuickReloadSubscriber"] = $cf20926a3ed5ce71$export$b107cc869756fe73;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("lKfPX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7aRa9 = parcelRequire("7aRa9");


var $jln20 = parcelRequire("jln20");


var $laFNM = parcelRequire("laFNM");


var $1vpkQ = parcelRequire("1vpkQ");

const $bc82d16866a75c79$var$SOURCE_CONFLUENCE_APPROVALS_PARAM = 'source_confluence_approvals';
const $bc82d16866a75c79$var$i18n = (0, $aXWIB.defineMessages)({
    alreadyApprovedTitle: {
        id: "approvals.flag.already-approved.title",
        defaultMessage: "You've already approved this page"
    },
    alreadyRequestedChangesTitle: {
        id: "approvals.flag.already-requested-changes.title",
        defaultMessage: "You've already requested changes on this page"
    },
    changeDecisionAction: {
        id: "approvals.flag.already-responded.change-decision",
        defaultMessage: "Change your decision"
    },
    approvalUnavailableTitle: {
        id: "approvals.flag.approval-unavailable.title",
        defaultMessage: "This approval request is no longer available"
    },
    approvalUnavailableDescription: {
        id: "approvals.flag.approval-unavailable.description",
        defaultMessage: "It may have been deleted."
    }
});
const $bc82d16866a75c79$var$removeSourceConfluenceApprovalsParam = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete($bc82d16866a75c79$var$SOURCE_CONFLUENCE_APPROVALS_PARAM);
    const newSearch = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
    const newUrl = `${window.location.pathname}${newSearch}${window.location.hash}`;
    window.history.replaceState({}, '', newUrl);
};
const $bc82d16866a75c79$var$ApprovalCtaFlagComponent = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { approvalRequestLoading: approvalRequestLoading, isCurrentUserApprover: isCurrentUserApprover, currentUserApprover: currentUserApprover, approvalRequest: approvalRequest, contentId: contentId, contentStatus: contentStatus } = (0, $laFNM.useApprovals)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const openApprovalsPane = (0, $42omo.useCallback)(()=>{
        (0, $1vpkQ.openApprovalsPaneForContext)({
            contentId: contentId,
            contentStatus: contentStatus,
            rightSidebarContext: rightSidebarContext
        });
    }, [
        contentId,
        contentStatus,
        rightSidebarContext
    ]);
    (0, $42omo.useEffect)(()=>{
        if (approvalRequestLoading) return;
        const urlParams = new URLSearchParams(window.location.search);
        const isFromApprovalsCta = urlParams.has($bc82d16866a75c79$var$SOURCE_CONFLUENCE_APPROVALS_PARAM);
        if (!isFromApprovalsCta) return;
        $bc82d16866a75c79$var$removeSourceConfluenceApprovalsParam();
        let state = 'none';
        if (!isCurrentUserApprover) state = 'unavailable';
        else if (currentUserApprover && currentUserApprover.status !== 'PENDING_REVIEW') state = 'already-responded';
        if (state === 'unavailable') {
            flags.showWarningFlag({
                title: formatMessage($bc82d16866a75c79$var$i18n.approvalUnavailableTitle),
                description: formatMessage($bc82d16866a75c79$var$i18n.approvalUnavailableDescription),
                isAutoDismiss: true
            });
            return;
        }
        if (state === 'already-responded' && currentUserApprover) {
            const isApprovalInProgress = approvalRequest?.review?.reviewStatus === 'PENDING';
            const title = currentUserApprover.status === 'REVIEWER_APPROVED' ? formatMessage($bc82d16866a75c79$var$i18n.alreadyApprovedTitle) : formatMessage($bc82d16866a75c79$var$i18n.alreadyRequestedChangesTitle);
            flags.showInfoFlag({
                title: title,
                isAutoDismiss: true,
                ...isApprovalInProgress && {
                    actions: [
                        {
                            content: formatMessage($bc82d16866a75c79$var$i18n.changeDecisionAction),
                            onClick: openApprovalsPane
                        }
                    ]
                }
            });
        }
    }, [
        approvalRequestLoading,
        isCurrentUserApprover,
        currentUserApprover,
        approvalRequest,
        flags,
        formatMessage,
        openApprovalsPane
    ]);
    return null;
};
const $bc82d16866a75c79$export$34defb28b3191b49 = (0, $7aRa9.withFlags)($bc82d16866a75c79$var$ApprovalCtaFlagComponent);
module.exports["ApprovalCtaFlag"] = $bc82d16866a75c79$export$34defb28b3191b49;

});

parcelRegister("bAGpj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dcoGt = parcelRequire("dcoGt");


var $cZa7r = parcelRequire("cZa7r");


var $9wGTI = parcelRequire("9wGTI");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");

const $16e040c4263f7228$export$665978abdb00663c = ({ pageId: pageId, editorActions: editorActions, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageId);
    const canAddCommentsRef = (0, $42omo.useRef)(canAddComments);
    canAddCommentsRef.current = canAddComments;
    const getCanAddComments = (0, $42omo.useCallback)(()=>canAddCommentsRef.current, []);
    return (0, $42omo.useMemo)(()=>({
            inlineComment: (0, $dcoGt.getEditorInlineCommentOptions)({
                pageId: pageId,
                editorActions: editorActions,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment,
                setEditorCreateProps: setEditorCreateProps,
                setEditorViewProps: setEditorViewProps,
                editorAnnotationProviderManagersEnabled: (0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager'),
                getCanAddComments: getCanAddComments,
                contentType: contentType
            }),
            annotationManager: annotationManager
        }), [
        pageId,
        triggerAnalyticsEvent,
        editorActions,
        updateUnresolvedInlineComment,
        setEditorCreateProps,
        setEditorViewProps,
        annotationManager,
        contentType,
        getCanAddComments
    ]);
};
module.exports["useEditorAnnotationProviderOptions"] = $16e040c4263f7228$export$665978abdb00663c;

});

parcelRegister("dcoGt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hXzKU = parcelRequire("hXzKU");


var $jmjWc = parcelRequire("jmjWc");


var $gfqXk = parcelRequire("gfqXk");


var $kDIns = parcelRequire("kDIns");


var $gYgF0 = parcelRequire("gYgF0");


var $fS1ba = parcelRequire("fS1ba");


const $74da12b96ee2cb30$var$CreateComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lDg6H",
    name: "CreateComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("4tTm9")))).CreateComponent
});

const $74da12b96ee2cb30$var$ViewComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bZUjL",
    name: "ViewComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("3omFm")))).ViewComponent
});
const $74da12b96ee2cb30$var$ViewComponentMemoized = ({ pageId: pageId, editorActions: editorActions })=>/*#__PURE__*/ (0, $42omo.memo)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74da12b96ee2cb30$var$ViewComponent, {
            pageId: pageId,
            editorActions: editorActions,
            ...props
        });
    });
const $74da12b96ee2cb30$var$CreateComponentMemoized = ({ pageId: pageId })=>/*#__PURE__*/ (0, $42omo.memo)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74da12b96ee2cb30$var$CreateComponent, {
            pageId: pageId,
            ...props
        });
    });
const $74da12b96ee2cb30$export$e453b02e89d48d2b = ({ pageId: pageId, editorActions: editorActions, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, editorAnnotationProviderManagersEnabled: editorAnnotationProviderManagersEnabled, getCanAddComments: getCanAddComments, contentType: contentType })=>{
    let updateSubscriber = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    if (!updateSubscriber?.off) updateSubscriber = null;
    return {
        viewComponent: editorAnnotationProviderManagersEnabled ? (0, $fS1ba.ViewManager)({
            pageId: pageId,
            editorActions: editorActions
        }) : $74da12b96ee2cb30$var$ViewComponentMemoized({
            pageId: pageId,
            editorActions: editorActions
        }),
        createComponent: editorAnnotationProviderManagersEnabled ? (0, $gYgF0.CreateManager)({
            pageId: pageId
        }) : $74da12b96ee2cb30$var$CreateComponentMemoized({
            pageId: pageId
        }),
        getState: (annotations)=>(0, $kDIns.getEditorResolvedState)({
                annotations: annotations,
                pageId: pageId,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment
            }),
        updateSubscriber: updateSubscriber,
        disallowOnWhitespace: true,
        isToolbarAbove: true,
        supportedBlockNodes: [
            'media'
        ],
        onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload(),
        getCanAddComments: getCanAddComments,
        contentType: contentType
    };
};
module.exports["getEditorInlineCommentOptions"] = $74da12b96ee2cb30$export$e453b02e89d48d2b;

});

parcelRegister("hXzKU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("3cEVV"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("3cEVV"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("3cEVV"))).CommentEditor,
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _19itia51 _2rkofajl _11c8fhey _4t3i1ul9 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("3cEVV", function(module, exports) {

let $25523e944f0970d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $25523e944f0970d8$var$load("7do1E"),
    $25523e944f0970d8$var$load("77dkW"),
    $25523e944f0970d8$var$load("9hYRW"),
    $25523e944f0970d8$var$load("kpm7S"),
    $25523e944f0970d8$var$load("3LP1d"),
    $25523e944f0970d8$var$load("5Fany"),
    $25523e944f0970d8$var$load("l1BQC"),
    $25523e944f0970d8$var$load("jlSF3"),
    $25523e944f0970d8$var$load("cXen0"),
    $25523e944f0970d8$var$load("a8Rqp"),
    $25523e944f0970d8$var$load("1EWOs"),
    $25523e944f0970d8$var$load("2YffH"),
    $25523e944f0970d8$var$load("fCyiY"),
    $25523e944f0970d8$var$load("jOdEL"),
    $25523e944f0970d8$var$load("ObV65"),
    $25523e944f0970d8$var$load("72YPP"),
    $25523e944f0970d8$var$load("i1up4"),
    $25523e944f0970d8$var$load("6cnH1"),
    $25523e944f0970d8$var$load("1GvGi"),
    $25523e944f0970d8$var$load("d4u0p"),
    $25523e944f0970d8$var$load("i4UWb"),
    $25523e944f0970d8$var$load("4RWFL"),
    $25523e944f0970d8$var$load("3XJd1"),
    $25523e944f0970d8$var$load("iSp49"),
    $25523e944f0970d8$var$load("hwT9D"),
    $25523e944f0970d8$var$load("j4Bpe"),
    $25523e944f0970d8$var$load("cD6Zr"),
    $25523e944f0970d8$var$load("lkOIY"),
    $25523e944f0970d8$var$load("daVFX"),
    $25523e944f0970d8$var$load("6m3ID"),
    $25523e944f0970d8$var$load("fPSgL"),
    $25523e944f0970d8$var$load("8nbmv"),
    $25523e944f0970d8$var$load("901NJ"),
    $25523e944f0970d8$var$load("gUo8V"),
    $25523e944f0970d8$var$load("iEDHw"),
    $25523e944f0970d8$var$load("9wzNh"),
    $25523e944f0970d8$var$load("5uHxI"),
    $25523e944f0970d8$var$load("9ldRJ"),
    $25523e944f0970d8$var$load("9anPW"),
    $25523e944f0970d8$var$load("klllM"),
    $25523e944f0970d8$var$load("5pvpJ"),
    $25523e944f0970d8$var$load("hshEG"),
    $25523e944f0970d8$var$load("6iz6l"),
    $25523e944f0970d8$var$load("4SCW2"),
    $25523e944f0970d8$var$load("aXHNO"),
    $25523e944f0970d8$var$load("kmvek"),
    $25523e944f0970d8$var$load("Wowvf"),
    $25523e944f0970d8$var$load("6wr18"),
    $25523e944f0970d8$var$load("kjZZD"),
    $25523e944f0970d8$var$load("7cDV0"),
    $25523e944f0970d8$var$load("ijD5W"),
    $25523e944f0970d8$var$load("3JSgG"),
    $25523e944f0970d8$var$load("cyGuT"),
    $25523e944f0970d8$var$load("ffEVr"),
    $25523e944f0970d8$var$load("1qlDN"),
    $25523e944f0970d8$var$load("1yVM6"),
    $25523e944f0970d8$var$load("hhss7"),
    $25523e944f0970d8$var$load("1cktr"),
    $25523e944f0970d8$var$load("3Oy4g"),
    $25523e944f0970d8$var$load("31vk5"),
    $25523e944f0970d8$var$load("4pqtR"),
    $25523e944f0970d8$var$load("5XqRg"),
    $25523e944f0970d8$var$load("fGkaB"),
    $25523e944f0970d8$var$load("7EorR"),
    $25523e944f0970d8$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("kDIns", function(module, exports) {

var $kmYOg = parcelRequire("kmYOg");


var $2XqLN = parcelRequire("2XqLN");


var $a4TK8 = parcelRequire("a4TK8");


var $cUycv = parcelRequire("cUycv");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $vNBpg = parcelRequire("vNBpg");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $gtj7V = parcelRequire("gtj7V");


var $cD1qu = parcelRequire("cD1qu");


var $c0rhi = parcelRequire("c0rhi");

const $655a1f23a26f4e27$export$c53aa0aa4a7c5e4 = (0, $kmYOg.default);
const $655a1f23a26f4e27$export$7037a4d88a618a89 = (contentId, pageMode)=>({
        pageId: contentId,
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        first: (0, $NYiei.MAX_COMMENTS_TO_RETURN)
    });
const $655a1f23a26f4e27$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:state-resolver');
const $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData = async ({ contentId: contentId, pageMode: pageMode })=>{
    if (!contentId) return [];
    // Check if processed comments data is available
    const processedData = (0, $4L9ve.getProcessedCommentsDataState)();
    // If data is processed, use it directly
    if (processedData.isDataProcessed) return processedData.openInlineComments;
    // Data not processed yet - fetch fresh data directly with network-only
    // This is simpler (albeit slightly slower) than preloading and guarantees fresh data
    // If we do preload in the future - keep in mind that we have to satisfy the following use cases
    // 1. We load in SSR and preload fails --> no cache data
    // 2. We load in SPA and preload hasn't completed before we check the cache value
    // 3. We load in SPA and have a stale value in the cache
    // If preloading you can also show stale data initially and refresh by manually updating annotations states
    // However if you do this, be careful for integrations w/ focused comments
    try {
        const result = await (0, $c0rhi.queryInterop)({
            query: $655a1f23a26f4e27$export$c53aa0aa4a7c5e4,
            variables: $655a1f23a26f4e27$export$7037a4d88a618a89(contentId, pageMode),
            fetchPolicy: 'network-only'
        });
        return result?.data?.comments?.nodes?.filter((node)=>node?.location) || [];
    } catch  {
        return [];
    }
};
const $655a1f23a26f4e27$export$8f0e4480674935ab = (0, $2XqLN.default)((annotations, validAnnotationsCallback, states)=>{
    const rendererAnnotationMap = {};
    const annotationState = [];
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Renderer
        rendererAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: (0, $cUycv.AnnotationMarkStates).RESOLVED
        });
    });
    states?.forEach((state)=>{
        const isResolved = Boolean(state.location?.inlineResolveProperties?.resolved);
        // mark all unresolved annotations to be displayed by the renderer
        if (!isResolved) {
            const annotationId = state.location.inlineMarkerRef;
            if (annotationId) {
                const index = rendererAnnotationMap[annotationId];
                /**
         * If the BE returns an annotation that the Renderer did not
         * provide, we could error here. Also account for 0 index.
         */ if (index || index === 0) annotationState[index].state = (0, $cUycv.AnnotationMarkStates).ACTIVE;
            }
        }
    });
    const validAnnotations = annotations.filter((annotation)=>{
        const index = rendererAnnotationMap[annotation];
        return annotationState[index].state === (0, $cUycv.AnnotationMarkStates).ACTIVE;
    });
    // Record the valid annotations to use for navigation and query params
    validAnnotationsCallback(validAnnotations);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $655a1f23a26f4e27$export$228a0d958905d789 = (0, $2XqLN.default)((annotations, states, updateUnresolvedInlineComment)=>{
    /**
   * Build a map of annotation states with a default of true for resolved.
   * This is to accommodate deleted annotations that still exist in the ADF.
   */ const editorAnnotationMap = {};
    const annotationState = [];
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Editor
        editorAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: {
                resolved: true
            }
        });
    });
    states.forEach((state)=>{
        const isResolved = Boolean(state?.location?.inlineResolveProperties?.resolved);
        // mark all unresolved annotations to be displayed by the editor
        if (!isResolved) {
            const annotationId = state?.location?.inlineMarkerRef || '';
            const index = editorAnnotationMap[annotationId];
            /**
       * If the BE returns an annotation that the Editor did not
       * provide, we could error here. Also account for 0 index.
       */ if (index || index === 0) annotationState[index].state.resolved = false;
        }
    });
    //Ordered list of unresolved inline comments
    const unresolvedInlineComments = annotations.filter((annotationId)=>{
        const index = editorAnnotationMap[annotationId];
        if (!annotationState[index].state.resolved) return annotationId;
    });
    updateUnresolvedInlineComment(unresolvedInlineComments);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $655a1f23a26f4e27$export$38c1ce6adefc79a5 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    if (!annotations.length) {
        updateUnresolvedInlineComment([]);
        return Promise.resolve([]);
    }
    try {
        let annotationStateNodes;
        // Check if we should use the new comments data manager flow
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Use preload-aware annotations data utility
        annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).LIVE // same as PageMode.EDIT for our case
        });
        else {
            // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
            const data = await (0, $c0rhi.queryInterop)({
                query: (0, $vNBpg.AnnotationStateQuery),
                fetchPolicy: 'network-only',
                variables: {
                    pageId: pageId,
                    // @ts-ignore - Legacy contentStatus values passed before typecheck changes
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ]
                }
            });
            // Filter null elements
            annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        }
        // Common logic: map annotation state nodes to editor states
        return $655a1f23a26f4e27$export$228a0d958905d789(annotations, annotationStateNodes, updateUnresolvedInlineComment);
    } catch (error) {
        // COMMENTS-211 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                data: {
                    source: 'editorComponent',
                    action: 'failed',
                    actionSubject: 'annotationState',
                    actionSubjectId: 'inlineComments',
                    attributes: {
                        errorName: error.name,
                        errorMessage: error.message
                    }
                },
                type: 'sendOperationalEvent'
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
let $655a1f23a26f4e27$var$rendererAnnotationsIds;
const $655a1f23a26f4e27$export$a0fcca613dd8b2c7 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, validAnnotationsCallback: validAnnotationsCallback, isNestedRender: isNestedRender })=>{
    // We need to have the page level renderer annotations
    // When the page renders the value of isNestedRender is false as per PageContentRendererFabrics
    // Later, when the macro renders isNestedRender is true
    // so, we will hold the value of annotations for the page renderer when isNestedRender is false
    if (!annotations.length) {
        validAnnotationsCallback([]);
        return Promise.resolve([]);
    }
    if (!isNestedRender) $655a1f23a26f4e27$var$rendererAnnotationsIds = annotations;
    try {
        let annotationStateNodes;
        // Check if we should use the new comments data manager flow
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Use preload-aware annotations data utility
        annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).VIEW
        });
        else {
            // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
            const data = await (0, $c0rhi.queryInterop)({
                query: (0, $vNBpg.AnnotationStateQuery),
                fetchPolicy: isNestedRender ? 'cache-first' : 'network-only',
                variables: {
                    pageId: pageId
                }
            });
            // Filter null elements
            annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        }
        // Common logic: map annotation state nodes to renderer states
        return $655a1f23a26f4e27$export$8f0e4480674935ab($655a1f23a26f4e27$var$rendererAnnotationsIds, validAnnotationsCallback, annotationStateNodes);
    } catch (error) {
        // COMMENTS-1131 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                source: 'rendererComponent',
                action: 'failed',
                actionSubject: 'annotationState',
                actionSubjectId: 'inlineComments',
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    errorName: error.name,
                    errorMessage: error.message
                }
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
module.exports["getEditorResolvedState"] = $655a1f23a26f4e27$export$38c1ce6adefc79a5;
module.exports["getRendererAnnotationStates"] = $655a1f23a26f4e27$export$a0fcca613dd8b2c7;

});

parcelRegister("kmYOg", function(module, exports) {
/**
 * @generated SignedSource<<0295e484764e81861adef8774e52fbb8>>
 * @relayHash d689c46cc95f36419f19f207f3ceb687
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f
const $f5022931ec1c887f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "INLINE"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "INLINE"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "inlineMarkerRef"
                                        },
                                        {
                                            "concreteType": "InlineCommentResolveProperties",
                                            "kind": "LinkedField",
                                            "name": "inlineResolveProperties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "resolved"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "InlineComment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v3 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "d689c46cc95f36419f19f207f3ceb687",
            "id": "da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f",
            "metadata": {},
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "operationKind": "query",
            "text": "query stateResolverPreloadAnnotationsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:INLINE},type:[INLINE],depth:ROOT,first:$first){nodes{id,contentStatus,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}},totalCount,__typename}}"
        }
    };
}();
$f5022931ec1c887f$var$node.hash = "af92d028ec6cef46bb981d53522dfe18";
var $f5022931ec1c887f$export$2e2bcd8739ae039 = $f5022931ec1c887f$var$node;
module.exports["default"] = $f5022931ec1c887f$export$2e2bcd8739ae039;

});

parcelRegister("vNBpg", function(module, exports) {

var $hRVfm = parcelRequire("hRVfm");

const $951c06b69b244c75$export$dedc8dce0be2f721 = (0, $hRVfm.default);
module.exports["AnnotationStateQuery"] = $951c06b69b244c75$export$dedc8dce0be2f721;

});

parcelRegister("hRVfm", function(module, exports) {
/**
 * @generated SignedSource<<3d7f93fcbfe5191f8239cff9bd27488c>>
 * @relayHash 0a59fed9dfa6599d230495f1a47dbc7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26bdeb44b2916ab641fa116a225079027626cb4cc6f97c58a4313672060fb97b
const $791a5813533710f7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1500
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": [
                "INLINE",
                "UNRESOLVED"
            ]
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AnnotationStateQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AnnotationStateQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0a59fed9dfa6599d230495f1a47dbc7c",
            "id": "26bdeb44b2916ab641fa116a225079027626cb4cc6f97c58a4313672060fb97b",
            "metadata": {},
            "name": "AnnotationStateQuery",
            "operationKind": "query",
            "text": "query AnnotationStateQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,type:[INLINE,UNRESOLVED],depth:ROOT,first:1500){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved,resolvedUser}}}}}}"
        }
    };
}();
$791a5813533710f7$var$node.hash = "40ea3762a17ce85bcac23a6ef83d3cbe";
var $791a5813533710f7$export$2e2bcd8739ae039 = $791a5813533710f7$var$node;
module.exports["default"] = $791a5813533710f7$export$2e2bcd8739ae039;

});

parcelRegister("gYgF0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cZa7r = parcelRequire("cZa7r");


var $aWwYt = parcelRequire("aWwYt");


var $bSvtO = parcelRequire("bSvtO");


var $gfqXk = parcelRequire("gfqXk");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $9wGTI = parcelRequire("9wGTI");

const $a70e629208b21e04$export$3fa94ae7388781e0 = ({ pageId: pageId, onCreate: onCreate, onClose: onClose, dom: dom, textSelection: textSelection, inlineNodeTypes: inlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, isOffline: isOfflineFromProps, wasNewAnnotationSelected: wasNewAnnotationSelected })=>{
    const { editorViewProps: editorViewProps } = (0, $cZa7r.useAnnotations)();
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps, setIsOffline: setIsOffline, setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const editorAnnotationEventEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isShowingComment = editorViewProps && editorViewProps.annotations.length > 0;
    const handleClose = (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_comments_api_manager')) annotationManager?.clearDraft();
        else onClose && onClose();
        setEditorCreateProps(null);
    }, [
        onClose,
        setEditorCreateProps,
        annotationManager
    ]);
    const handleCreate = (0, $42omo.useCallback)((id, commentData)=>{
        if (commentData) setStoredCommentData(commentData);
        if ((0, $9wGTI.fg)('platform_editor_comments_api_manager')) return annotationManager?.applyDraft(id);
        else return onCreate && onCreate(id);
    }, [
        onCreate,
        annotationManager,
        setStoredCommentData
    ]);
    const closeObjectSidebar = (0, $42omo.useCallback)(()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
    }, [
        isObjectSidebarShown,
        hideObjectSidebar
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_annotation_prompt_edit_discard')) {
            if (wasNewAnnotationSelected) {
                const onDiscardEdit = ()=>{
                    resetContentChanged();
                    handleClose();
                    setEditorViewProps(null);
                    closeObjectSidebar();
                };
                if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: onDiscardEdit,
                    onCancel: ()=>{
                        editorAnnotationEventEmitter.emit('setselectedannotation', '');
                    }
                });
                else onDiscardEdit();
            }
        }
    }, [
        closeObjectSidebar,
        handleClose,
        hasContentChanged,
        wasNewAnnotationSelected,
        editorAnnotationEventEmitter,
        resetContentChanged,
        setEditorViewProps,
        showModal
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleSetEditorCreateProps = ()=>{
            setEditorViewProps(null);
            setEditorCreateProps({
                pageId: pageId,
                textSelection: textSelection,
                dom: dom,
                onCreate: handleCreate,
                onClose: handleClose,
                inlineNodeTypes: inlineNodeTypes,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
                closeObjectSidebar: closeObjectSidebar
            });
        };
        if (isShowingComment && hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                setEditorViewProps(null);
                handleSetEditorCreateProps();
                closeObjectSidebar();
            },
            onCancel: ()=>{
                // If the user cancels, then cancel out the highlight
                handleClose();
            }
        });
        else handleSetEditorCreateProps();
    // We only want to listen to changes that signifies a new comment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dom,
        textSelection
    ]);
    (0, $42omo.useEffect)(()=>{
        // This is effectively gated by the platform_editor_offline_editing_web experiment, via platform/packages/editor/editor-plugin-annotation/src/ui/InlineCommentView.tsx
        setIsOffline(isOfflineFromProps === true);
    }, [
        isOfflineFromProps,
        setIsOffline
    ]);
    return null;
};
const $a70e629208b21e04$export$a455823a9487ea0 = ({ pageId: pageId })=>/*#__PURE__*/ (0, $42omo.memo)((createComponentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a70e629208b21e04$export$3fa94ae7388781e0, {
            pageId: pageId,
            ...createComponentProps
        }));
module.exports["CreateManager"] = $a70e629208b21e04$export$a455823a9487ea0;

});

parcelRegister("fS1ba", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bSvtO = parcelRequire("bSvtO");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $gfqXk = parcelRequire("gfqXk");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $aJPUt = parcelRequire("aJPUt");


var $gtj7V = parcelRequire("gtj7V");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $5fMeR = parcelRequire("5fMeR");

const $9dbfd76fc543be2b$var$relativeFilePath = 'annotation-provider-inline-comments/editor/ViewManager';
const $9dbfd76fc543be2b$export$76599b5777b5fa44 = ({ pageId: pageId, editorActions: editorActions, newlySelectedAnnotationId: newlySelectedAnnotationId, annotations: annotations, annotationsList: annotationsList, getInlineNodeTypes: getInlineNodeTypes, onClose: onClose, onDelete: onDelete, onResolve: onResolve, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, isOffline: isOfflineFromProps })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { setEditorViewProps: setEditorViewProps, setIsOffline: setIsOffline, clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    // Clear stored comment data when annotation changes (before new component renders)
    (0, $42omo.useEffect)(()=>{
        if (storedCommentData) {
            const currentAnnotationId = annotations?.[0]?.id;
            const storedAnnotationId = storedCommentData?.location?.inlineMarkerRef;
            // Clear stored data if we're viewing a different annotation
            if (currentAnnotationId && storedAnnotationId && currentAnnotationId !== storedAnnotationId) clearStoredCommentData();
        }
    }, [
        annotations,
        storedCommentData,
        clearStoredCommentData
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        // NOTE: Any logic added to the handleClose function will need to be duplicated to EditorCommentShortcutListener.tsx. To revisit - create a shared function so the close inline comment logic can be reused
        // When closing the sidebar, return focus to the previously selected annotation element
        setTimeout(()=>{
            // Use scrollIntoView: false to prevent unwanted page scroll when focus is restored
            editorActions?.focus({
                scrollIntoView: !(0, $6mKj3.expValEquals)('confluence_comment_disable_scroll_onfocus', 'isEnabled', true)
            });
        }, 100);
        onClose && onClose();
        setEditorViewProps(null);
        if (storedCommentData) clearStoredCommentData();
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_editor')) experienceTracker.abort({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            reason: 'Inline comment was closed',
            checkForTimeout: true,
            publishDebugPoints: true,
            attributes: {
                stopPoint: $9dbfd76fc543be2b$var$relativeFilePath
            }
        });
    }, [
        editorActions,
        onClose,
        setEditorViewProps,
        experienceTracker,
        storedCommentData,
        clearStoredCommentData
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleSetEditorViewProps = ()=>{
            setEditorViewProps({
                pageId: pageId,
                editorActions: editorActions,
                annotations: annotations,
                annotationsList: annotationsList,
                getInlineNodeTypes: getInlineNodeTypes,
                onClose: handleClose,
                onDelete: onDelete,
                onResolve: onResolve,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
            });
            // Only start the experience if the comments panel is closed to track the core view-inline-comment experience
            if (!isCommentsPanelShown && annotations[0]?.id && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_editor')) {
                const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                /*
				 * Note: This logic runs after certain entrypoints start the view-inline-comment experience.
				 * We don't start a new experience if the annotation ID of the running experience is the same
				 * as the current annotation to avoid duplicating and aborting experiences.
				 */ if (experienceState === null || experienceState?.hasStopped || experienceState?.hasStopped === false && experienceState?.attributes?.annotationId !== annotations[0]?.id) experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        annotationId: annotations[0]?.id,
                        entryPoint: $9dbfd76fc543be2b$var$relativeFilePath,
                        pageClass: 'editor'
                    }
                });
            }
            if (editorCreateProps) experienceTracker.succeed({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
            });
        };
        // The annotation currently being shown
        const currentlyShownAnnotationId = editorViewProps && editorViewProps.annotations.length > 0 ? editorViewProps.annotations[0].id : undefined;
        // We only want to do anything if a new annotation has been clicked/selected
        if (newlySelectedAnnotationId !== currentlyShownAnnotationId) {
            // We only want to show the dialog if a new annotation has been selected AND content has changed
            // if a new annotation has not been selected, the onClose() function will handle the changed dialog
            // COMMENTS-3216 - With Concurrent Mode the rendering cycle is optimized to show things sooner
            //				   causing this component to mount before the state change for the comment content
            //				   is registered and thus causes the user to be prompted. We will never have a case
            //				   that currentlyShownAnnotationId is undefined AND there are changes, so this is safe
            if (hasContentChanged && currentlyShownAnnotationId !== undefined) {
                let abortedExperience = false;
                let abortedExperienceEntrypoint = '';
                if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) {
                    const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                    /*
					 * If a keyboard shortcut or comment navigation is used to navigate when the content has changed,
					 * we abort and restart the experience on confirm because we can't predict if the user will
					 * confirm the navigation, or how long the user will take to confirm.
					 */ if (experienceState !== null && experienceState?.hasStopped === false && (experienceState?.attributes?.entryPoint === 'comments-shortcuts/EditorCommentShortcutListener' || experienceState?.attributes?.entryPoint === 'inline-comments-common/CommentNavigation')) {
                        abortedExperienceEntrypoint = experienceState?.attributes?.entryPoint;
                        experienceTracker.abort({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            reason: 'Comment warning dialog displayed',
                            checkForTimeout: true,
                            publishDebugPoints: true,
                            attributes: {
                                stopPoint: $9dbfd76fc543be2b$var$relativeFilePath
                            }
                        });
                        abortedExperience = true;
                    }
                }
                showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        if (abortedExperience) {
                            experienceTracker.start({
                                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                                attributes: {
                                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                                    annotationId: annotations.length && annotations[0].id,
                                    entryPoint: $9dbfd76fc543be2b$var$relativeFilePath,
                                    pageClass: 'editor'
                                }
                            });
                            (0, $4EKKB.selectInlineComment).debug(`Restarting experience after comment was discarded from comment warning dialog. Initial entrypoint: ${abortedExperienceEntrypoint}`);
                        }
                        // On confirm, activate the newly clicked one
                        if (annotations.length > 0) emitter.emit('setselectedannotation', annotations[0].id);
                        resetContentChanged();
                        handleSetEditorViewProps();
                    },
                    onCancel: ()=>{
                        // If we have a previously shown annotationId we want to keep it highlighted until the user makes their choice
                        if (currentlyShownAnnotationId) emitter.emit('setselectedannotation', currentlyShownAnnotationId);
                    }
                });
            } else handleSetEditorViewProps();
        }
    // We only want to listen to changes that signifies a new comment click
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newlySelectedAnnotationId
    ]);
    (0, $42omo.useEffect)(()=>{
        // This is effectively gated by the platform_editor_offline_editing_web experiment, via platform/packages/editor/editor-plugin-annotation/src/ui/InlineCommentView.tsx
        setIsOffline(isOfflineFromProps === true);
    }, [
        isOfflineFromProps,
        setIsOffline
    ]);
    return null;
};
const $9dbfd76fc543be2b$export$e2fb22396d3bf4b8 = ({ pageId: pageId, editorActions: editorActions })=>/*#__PURE__*/ (0, $42omo.memo)((viewComponentProps)=>{
        // TODO: Handle multiple annotations
        const newlySelectedAnnotationId = viewComponentProps.annotations.length > 0 ? viewComponentProps.annotations[0].id : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9dbfd76fc543be2b$export$76599b5777b5fa44, {
            pageId: pageId,
            editorActions: editorActions,
            newlySelectedAnnotationId: newlySelectedAnnotationId,
            ...viewComponentProps
        });
    });
module.exports["ViewManager"] = $9dbfd76fc543be2b$export$e2fb22396d3bf4b8;

});

parcelRegister("aUU0C", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6b57ff110c624a89$var$initialState = {
    annotations: []
};
const $6b57ff110c624a89$var$actions = {
    setEditorAnnotations: (newAnnotations, pageId)=>({ getState: getState, setState: setState })=>{
            const { annotations: annotations } = getState();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(newAnnotations, annotations)) setState({
                annotations: newAnnotations,
                pageId: pageId
            });
        }
};
const $6b57ff110c624a89$var$EditorAnnotationsStore = (0, $1P1Tu.createStore)({
    initialState: $6b57ff110c624a89$var$initialState,
    actions: $6b57ff110c624a89$var$actions,
    name: 'EditorAnnotationsStore'
});
const $6b57ff110c624a89$export$af3b3e68acbfeb43 = (0, $9zUhf.createHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
const $6b57ff110c624a89$export$72e98d7f4c892f01 = (0, $9zUhf.createActionsHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
module.exports["useEditorAnnotations"] = $6b57ff110c624a89$export$af3b3e68acbfeb43;
module.exports["useEditorAnnotationsActions"] = $6b57ff110c624a89$export$72e98d7f4c892f01;

});

parcelRegister("k8e76", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $j1v0l = parcelRequire("j1v0l");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $9zUhf.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $9zUhf.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $9zUhf.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $j1v0l.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("WheoQ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b0ecc354fcdb9645$export$23b7aa19be1bc1ad = (callbacks)=>(0, $42omo.useCallback)((annotationsList)=>{
        callbacks.forEach((callback)=>callback(annotationsList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, callbacks);
module.exports["useUpdateAnnotations"] = $b0ecc354fcdb9645$export$23b7aa19be1bc1ad;

});

parcelRegister("aPQsP", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2xIMp = parcelRequire("2xIMp");


var $inPa6 = parcelRequire("inPa6");


var $bre0g = parcelRequire("bre0g");


var $9ZD6n = parcelRequire("9ZD6n");


var $ke0mx = parcelRequire("ke0mx");


var $1iSzD = parcelRequire("1iSzD");


var $f2DFf = parcelRequire("f2DFf");


var $01djA = parcelRequire("01djA");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7PHx9 = parcelRequire("7PHx9");

var $1M1t5 = parcelRequire("1M1t5");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $iz4WO = parcelRequire("iz4WO");


var $jRxDI = parcelRequire("jRxDI");


var $iONqR = parcelRequire("iONqR");


var $dZUkS = parcelRequire("dZUkS");


var $fxClS = parcelRequire("fxClS");


var $euL71 = parcelRequire("euL71");


var $6b7RE = parcelRequire("6b7RE");


var $gH8jv = parcelRequire("gH8jv");


var $2YtTU = parcelRequire("2YtTU");


var $4U6ec = parcelRequire("4U6ec");


var $3IZob = parcelRequire("3IZob");


var $giS6h = parcelRequire("giS6h");


var $fgd2r = parcelRequire("fgd2r");


var $1kHsc = parcelRequire("1kHsc");


var $aQw7y = parcelRequire("aQw7y");


var $bfil7 = parcelRequire("bfil7");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $1JyKZ = parcelRequire("1JyKZ");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $lJDEI = parcelRequire("lJDEI");


var $9bL1w = parcelRequire("9bL1w");


var $lvKPs = parcelRequire("lvKPs");


var $aIqlA = parcelRequire("aIqlA");

const $f03f53a782506f81$var$noop = ()=>{};
const $f03f53a782506f81$var$_getClassicEditorProviders = (0, $2XqLN.default)(({ cloudId: cloudId, contentId: contentId, contentTitle: contentTitle, contentType: contentType, contentVersion: contentVersion, spaceKey: spaceKey, spaceId: spaceId, contentMode: contentMode, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent, mentionProvider: mentionProvider, intlNext: intlNext, openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, setActiveModal: setActiveModal, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, extensionContextProvider: extensionContextProvider, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, onCompleteCallback: onCompleteCallback, analyticsContext: analyticsContext, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, allowCreateWithRovoExtension: allowCreateWithRovoExtension, openSmartCreationModal: openSmartCreationModal, flags: flags, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, hideGlassPaneForForge: hideGlassPaneForForge, isFullPageEditor: isFullPageEditor, allowLegacyMacros: allowLegacyMacros, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled, setQueryParams: setQueryParams, isBlockTemplateQuickInsertEnabled: isBlockTemplateQuickInsertEnabled, snippets: snippets, pageTreeStateUpdater: pageTreeStateUpdater, experienceTracker: experienceTracker, edition: edition, isSmartButtonAllowed: isSmartButtonAllowed, isAdmin: isAdmin, userId: userId, isPublishedPage: isPublishedPage })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const pageContext = {
        contentId: contentId,
        contentTitle: contentTitle,
        spaceKey: spaceKey,
        spaceId: spaceId,
        features: {
            configPanel: {
                enabled: true,
                optedOut: (0, $fgd2r.getOptedOutMacros)()
            },
            elementBrowser: true
        }
    };
    const extensionHandlers = (0, $lvKPs.getFullPageExtensionHandlers)({
        contentId: contentId,
        spaceKey: spaceKey,
        extensionContextProvider: extensionContextProvider,
        editorActions: editorActions,
        subscribeDocChange: subscribeDocChange,
        unsubscribeDocChange: unsubscribeDocChange,
        isLivePage: isLivePage,
        isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled
    });
    const macroConfig = {
        contentId: contentId,
        setActiveModal: setActiveModal,
        closeActiveModal: closeActiveModal
    };
    const hideCreateContentMacros = isCompanyHub && (0, $9wGTI.fg)('company-hub-hide-create-content-macros');
    const confluenceMacroExtensionProviderForEditor = (0, $bfil7.getConfluenceMacrosExtensionProviderForEditor)(pageContext, extensionHandlers, editorAPI ?? undefined, editorActions, macroConfig, getMigrationExtensionManifest || $f03f53a782506f81$var$noop, openMacroBrowserToEditExistingMacro || $f03f53a782506f81$var$noop, openMacroBrowserForInitialConfiguration || $f03f53a782506f81$var$noop, intlNext, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, experienceTracker, contentType, allowCreateDatabaseExtension && !hideCreateContentMacros, allowDatabaseQuickInsert, allowCreateWhiteboardExtension && !hideCreateContentMacros, allowCreateWithRovoExtension, openSmartCreationModal, allowLegacyMacros, isCompanyHub, pageTreeStateUpdater);
    const extensionProvidersList = [];
    extensionProvidersList.push(confluenceMacroExtensionProviderForEditor);
    const extensions = [];
    extensions.push((0, $9ZD6n.default)({
        appKey: (0, $4U6ec.DROPBOX_APP_KEY),
        canMountinIframe: false
    }));
    if (!hideCreateContentMacros) extensions.push((0, $ke0mx.manifest)({
        // @ts-expect-error — react-intl v5/v7 type mismatch, will be removed when platform upgrades to react-intl v7
        intl: intlNext,
        defaultCloudId: cloudId,
        defaultFormValues: {
            'confluence-page': {
                parentId: contentId,
                spaceId: spaceId
            }
        },
        analyticsContext: analyticsContext,
        pageContext: {
            isLivePage: isLivePage,
            isBlogpost: contentType === 'blogpost',
            isFullPageEditor: isFullPageEditor
        },
        location: 'confluence-page',
        allowConfluenceEditViewEmbed: true,
        flags: {
            showSuccess: ({ title: title, description: description, actions: actions })=>{
                flags?.showSuccessFlag({
                    title: title,
                    description: description,
                    actions: actions,
                    isAutoDismiss: true
                });
            },
            showFailure: ({ title: title, description: description, actions: actions })=>{
                flags?.showErrorFlag({
                    title: title,
                    description: description,
                    actions: actions,
                    isAutoDismiss: true
                });
            }
        }
    }));
    extensionProvidersList.push(new (0, $bre0g.default)(extensions));
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const showPremiumExtensions = isAdmin || isPremium;
    const premiumExtensions = showPremiumExtensions ? (0, $gH8jv.createPremiumExtensionManifests)({
        contentId: contentId,
        editorActions: editorActions,
        openConfigPanel: openConfigPanel,
        // @ts-expect-error — react-intl v5/v7 type mismatch, will be removed when platform upgrades to react-intl v7
        intl: intlNext,
        setUpsellModalSource: setUpsellModalSource,
        allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions
    }) : [];
    extensionProvidersList.push(new (0, $bre0g.default)(premiumExtensions));
    // Don't add the Smart Button extension if we're in the Company Hub,
    // the company-hub-migration-prevent-1p-macro experiment is enabled,
    // and the company-hub-prevent-1p-macro-via-tap-trait gate returns false.
    // company-hub-prevent-1p-macro-via-tap-trait is controlled by a tap trait that checks if a tenant's company hub
    // has been published with unsupported 1p macros in the last 4 months,
    // in which case we will allow them to insert Smart Button, an unsupported 1p macro.
    if (!isCompanyHub || !(0, $6mKj3.expVal)('company-hub-migration-prevent-1p-macro', 'isEnabled', false) || (0, $9wGTI.fg)('company-hub-prevent-1p-macro-via-tap-trait')) extensionProvidersList.push((0, $jRxDI.smartButtonExtensionProvider)({
        contentId: contentId,
        editorActions: editorActions,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        intl: intlNext,
        isSmartButtonAllowed: isSmartButtonAllowed,
        contentType: contentType
    }));
    extensionProvidersList.push((0, $6b7RE.projectLinkerExtensionProvider)({
        cloudId: cloudId,
        intl: intlNext,
        editorActions: editorActions,
        createAnalyticsEvent: createAnalyticsEvent
    }));
    extensionProvidersList.push((0, $7PHx9.connectChartExtensionProvider)(intlNext, editorActions, openConnectionsPanel, createAnalyticsEvent));
    extensionProvidersList.push((0, $1M1t5.referentialityExtensionProvider)({
        intl: intlNext,
        openConnectionsPanel: openConnectionsPanel,
        createAnalyticsEvent: createAnalyticsEvent
    }));
    if ((0, $6mKj3.expVal)('cc-maui-experiment', 'isEnabled', false)) {
        const nativeEmbedExtension = (0, $f2DFf.createManifest)(isPublishedPage, editorAPI ?? undefined);
        extensionProvidersList.push(new (0, $bre0g.default)([
            nativeEmbedExtension
        ], nativeEmbedExtension.modules?.autoConvert?.url ?? []));
    } else if ((0, $9wGTI.fg)('platform_editor_native_embeds_fallback_transform')) extensionProvidersList.push(new (0, $bre0g.default)([
        (0, $01djA.createNativeEmbedsFallbackManifest)(editorAPI ?? undefined)
    ]));
    if ((0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) {
        const shouldAddBlockTemplateQuickInsert = isBlockTemplateQuickInsertEnabled && (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false);
        const onOpenTemplatePanel = ()=>{
            if (setQueryParams) (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN), (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK));
        };
        extensionProvidersList.push((0, $iONqR.snippetExtensionProvider)(intlNext, snippets, shouldAddBlockTemplateQuickInsert ? onOpenTemplatePanel : undefined, userId));
    }
    extensionProvidersList.push((0, $aIqlA.getForgeExtensionHandler)({
        spaceKey: spaceKey,
        spaceId: spaceId,
        contentId: contentId,
        contentType: contentType,
        contentVersion: contentVersion,
        contentMode: contentMode,
        mentionProvider: mentionProvider,
        isEditing: true,
        connectExtensionProvider: confluenceMacroExtensionProviderForEditor,
        editorActions: editorActions,
        hideGlassPaneForForge: hideGlassPaneForForge,
        intl: intlNext,
        locale: intlNext.locale,
        isLivePage: !!isLivePage,
        editorAPI: editorAPI,
        useGetContextToken: $1JyKZ.useGetContextToken
    }));
    return extensionProvidersList;
});
const $f03f53a782506f81$var$_getExtensionRelatedProps = (0, $2XqLN.default)(({ cloudId: cloudId, contentId: contentId, contentTitle: contentTitle, contentType: contentType, contentVersion: contentVersion, contentMode: contentMode, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent, mentionProvider: mentionProvider, spaceKey: spaceKey, spaceId: spaceId, openMacroBrowserToEditExistingMacro: // Props from ClassicEditorContext
openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, setActiveModal: setActiveModal, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, extensionContextProvider: extensionContextProvider, intlNext: intlNext, featureFlagClient: featureFlagClient, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, onCompleteCallback: onCompleteCallback, analyticsContext: analyticsContext, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, allowCreateWithRovoExtension: allowCreateWithRovoExtension, openSmartCreationModal: openSmartCreationModal, flags: flags, aiOptInStatus: aiOptInStatus, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, hideGlassPaneForForge: hideGlassPaneForForge, isFullPageEditor: isFullPageEditor, allowLegacyMacros: allowLegacyMacros, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled, setQueryParams: setQueryParams, isBlockTemplateQuickInsertEnabled: isBlockTemplateQuickInsertEnabled, snippets: snippets, pageTreeStateUpdater: pageTreeStateUpdater, experienceTracker: experienceTracker, edition: edition, isSmartButtonAllowed: isSmartButtonAllowed, isAdmin: isAdmin, userId: userId, isPublishedPage: isPublishedPage })=>{
    const extensionProviders = $f03f53a782506f81$var$_getClassicEditorProviders({
        cloudId: cloudId,
        contentId: contentId,
        contentTitle: contentTitle,
        contentType: contentType,
        contentVersion: contentVersion,
        contentMode: contentMode,
        spaceKey: spaceKey,
        spaceId: spaceId,
        editorActions: editorActions,
        createAnalyticsEvent: createAnalyticsEvent,
        mentionProvider: mentionProvider,
        intlNext: intlNext,
        featureFlagClient: featureFlagClient,
        openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro,
        openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration,
        setActiveModal: setActiveModal,
        openConnectionsPanel: openConnectionsPanel,
        openConfigPanel: openConfigPanel,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        closeActiveModal: closeActiveModal,
        getMigrationExtensionManifest: getMigrationExtensionManifest,
        extensionContextProvider: extensionContextProvider,
        subscribeDocChange: subscribeDocChange,
        unsubscribeDocChange: unsubscribeDocChange,
        onCompleteCallback: onCompleteCallback,
        analyticsContext: analyticsContext,
        isLivePage: isLivePage,
        allowCreateDatabaseExtension: allowCreateDatabaseExtension,
        allowDatabaseQuickInsert: allowDatabaseQuickInsert,
        allowCreateWhiteboardExtension: allowCreateWhiteboardExtension,
        allowCreateWithRovoExtension: allowCreateWithRovoExtension,
        openSmartCreationModal: openSmartCreationModal,
        flags: flags,
        snippets: snippets,
        aiOptInStatus: aiOptInStatus,
        editorAPI: editorAPI,
        setUpsellModalSource: setUpsellModalSource,
        hideGlassPaneForForge: hideGlassPaneForForge,
        isFullPageEditor: isFullPageEditor,
        allowLegacyMacros: allowLegacyMacros,
        allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions,
        isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled,
        setQueryParams: setQueryParams,
        isBlockTemplateQuickInsertEnabled: isBlockTemplateQuickInsertEnabled,
        pageTreeStateUpdater: pageTreeStateUpdater,
        experienceTracker: experienceTracker,
        edition: edition,
        isSmartButtonAllowed: isSmartButtonAllowed,
        isAdmin: isAdmin,
        userId: userId,
        isPublishedPage: isPublishedPage
    });
    const allowExtension = {
        allowBreakout: true,
        allowExtendFloatingToolbars: true
    };
    return {
        allowExtension: allowExtension,
        extensionProviders: extensionProviders
    };
});
const $f03f53a782506f81$export$d22e3badff9938a7 = ({ contentId: contentId, contentTitle: contentTitle, contentType: contentType, contentVersion: contentVersion, editorActions: editorActions, mentionProvider: mentionProvider, spaceKey: spaceKey, spaceId: spaceId, contentMode: contentMode, extensionContextProvider: extensionContextProvider, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, onCompleteCallback: onCompleteCallback, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, allowCreateWithRovoExtension: allowCreateWithRovoExtension, openSmartCreationModal: openSmartCreationModal, flags: flags, aiOptInStatus: aiOptInStatus, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, isFullPageEditor: isFullPageEditor = false, allowLegacyMacros: allowLegacyMacros = false, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions = false, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    const { openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro, loadMacroBrowserResources: loadMacroBrowserResources, setActiveModal: setActiveModal, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders } = (0, $42omo.useContext)((0, $giS6h.ClassicEditorContext));
    const { cloudId: cloudId, featureFlagClient: featureFlagClient, edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSmartButtonAllowed: isSmartButtonAllowed } = (0, $iz4WO.useSmartButtonPremiumGate)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isAdmin = (0, $8Lx5S.useIsAdmin)();
    const shouldShowPremiumUpsell = (0, $2YtTU.usePremiumGate)();
    const intlNext = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    // Trigger loading of macro browser resources
    (0, $42omo.useEffect)(()=>{
        if (loadMacroBrowserResources) loadMacroBrowserResources();
    }, [
        loadMacroBrowserResources
    ]);
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    const analyticsContext = (0, $42omo.useContext)((0, $2xIMp.default));
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    // Enable block template quick insert when we are not in embedded Confluence or when in embedded Confluence andthe template browser is enabled
    const isBlockTemplateQuickInsertEnabled = !isEmbeddedConfluence || !!isTemplateBrowserEnabled;
    // Get snippets snapshot without subscribing to avoid re-renders
    const { snippets: snippets, isLoading: snippetsLoading, isLoaded: snippetsLoaded } = (0, $dZUkS.getSnippetsStateSnapshot)();
    // If snippets are still loading, register a callback to add them to quick insert when done.
    // Only register when quick insert is enabled (not gated off in Embedded Confluence).
    (0, $42omo.useEffect)(()=>{
        if (isBlockTemplateQuickInsertEnabled && snippetsLoading && !snippetsLoaded && editorAPI) (0, $fxClS.registerSnippetsQuickInsertOnLoad)(editorAPI, userId);
    // Only watch editorAPI - we check the loading state from the snapshot at render time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorAPI
    ]);
    // TODO: Currently, Forge macros can only be non-bodied, but there's work
    // underway to allow for bodied macros. When that's complete, we'll need
    // to update this to be contingent on the macro type.
    const hideGlassPaneForForge = (0, $aQw7y.useShouldHideOverlay)('forge', false);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isPublishedPage = pageMode === (0, $cD1qu.PageMode).VIEW;
    const extensionOptions = (0, $42omo.useMemo)(()=>$f03f53a782506f81$var$_getExtensionRelatedProps({
            cloudId: cloudId,
            contentId: contentId,
            contentTitle: contentTitle,
            contentType: contentType,
            contentVersion: contentVersion,
            contentMode: contentMode,
            editorActions: editorActions,
            createAnalyticsEvent: createAnalyticsEvent,
            mentionProvider: mentionProvider,
            spaceKey: spaceKey,
            spaceId: spaceId,
            openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration,
            openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro,
            setActiveModal: setActiveModal,
            openConnectionsPanel: openConnectionsPanel,
            openConfigPanel: openConfigPanel,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            closeActiveModal: closeActiveModal,
            getMigrationExtensionManifest: getMigrationExtensionManifest,
            extensionContextProvider: extensionContextProvider,
            intlNext: intlNext,
            featureFlagClient: featureFlagClient,
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange,
            onCompleteCallback: onCompleteCallback,
            analyticsContext: analyticsContext,
            isLivePage: isLivePage,
            allowCreateDatabaseExtension: allowCreateDatabaseExtension,
            allowDatabaseQuickInsert: allowDatabaseQuickInsert,
            allowCreateWhiteboardExtension: allowCreateWhiteboardExtension,
            allowCreateWithRovoExtension: allowCreateWithRovoExtension,
            openSmartCreationModal: openSmartCreationModal,
            flags: flags,
            aiOptInStatus: aiOptInStatus,
            editorAPI: editorAPI,
            setUpsellModalSource: shouldShowPremiumUpsell ? setUpsellModalSource : undefined,
            hideGlassPaneForForge: hideGlassPaneForForge,
            isFullPageEditor: isFullPageEditor,
            allowLegacyMacros: allowLegacyMacros,
            allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions,
            isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled,
            setQueryParams: setQueryParams,
            isBlockTemplateQuickInsertEnabled: isBlockTemplateQuickInsertEnabled,
            snippets: snippets,
            pageTreeStateUpdater: pageTreeStateUpdater,
            experienceTracker: experienceTracker,
            edition: edition,
            isSmartButtonAllowed: isSmartButtonAllowed,
            isAdmin: isAdmin,
            userId: userId,
            isPublishedPage: isPublishedPage
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        contentTitle,
        contentVersion,
        spaceKey,
        editorAPI,
        spaceId,
        pageTreeStateUpdater
    ]);
    return {
        extensionOptions: extensionOptions,
        rendererExtensionOptions: {
            getExtensionHandlers: getExtensionHandlers,
            populateExtensionProviders: populateExtensionProviders
        }
    };
};
module.exports["useExtensionOptions"] = $f03f53a782506f81$export$d22e3badff9938a7;

});

parcelRegister("9ZD6n", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $2FNjD = parcelRequire("2FNjD");


var $5x0y1 = parcelRequire("5x0y1");


var $1oCLl = parcelRequire("1oCLl");


var $kTtIX = parcelRequire("kTtIX");


var $dwj5l = parcelRequire("dwj5l");


async function $8264492e60b066c8$var$pickFromDropbox(appKey, canMountinIframe) {
    await (0, $kTtIX.default)(appKey);
    let popupMountPoint;
    let root = null;
    // BC - as of 2020-01-21 this does not work, as no dropbox app we have is authorised
    // to iframe in the picker - we are currently waiting for permissions.
    // To test the picker, comment out the render call, and the `iframe` and `winowName` options
    if (canMountinIframe) {
        const Modal = await (parcelRequire("l4EvG"));
        // The decision has been made to simply append our modal to the body
        // Using the passed in popupMountPoint has the potential to cause
        // problems, and several users pass down document.body anyway
        //
        // We want to append it and attach it to a new div so we have complete control.
        popupMountPoint = document.getElementById((0, $dwj5l.POPUP_MOUNTPOINT));
        if (!popupMountPoint) {
            popupMountPoint = document.createElement('div');
            popupMountPoint.id = (0, $dwj5l.POPUP_MOUNTPOINT);
            document.body.appendChild(popupMountPoint);
        }
        if ((0, $1oCLl.expValEquals)('platform_editor_react19_migration', 'isEnabled', true)) {
            root = (0, $2FNjD.createRoot)(popupMountPoint);
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            root.render(/*#__PURE__*/ (0, $l998X.jsx)(Modal.default, {
                onClose: ()=>{}
            }));
        } else // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, $l998X.jsx)(Modal.default, {
            onClose: ()=>{}
        }), popupMountPoint);
    }
    let files;
    try {
        files = await new Promise((resolve, reject)=>{
            window.Dropbox.choose({
                iframe: canMountinIframe,
                windowName: canMountinIframe ? (0, $dwj5l.DROPBOX_IFRAME_NAME) : undefined,
                success: resolve,
                cancel: reject
            });
        });
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        if ((0, $1oCLl.expValEquals)('platform_editor_react19_migration', 'isEnabled', true)) {
            if (root) root.unmount();
        } else if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
        return;
    }
    let node;
    if (!files.length) {
        if ((0, $1oCLl.expValEquals)('platform_editor_react19_migration', 'isEnabled', true)) {
            if (root) root.unmount();
        } else if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
        return;
    }
    const newNodes = files.map((file)=>(0, $5x0y1.inlineCard)({
            url: file.link
        }));
    if (newNodes.length === 1) node = newNodes[0];
    else // NOTE: we are not currently passing in `multiselect`, so this is not a possible state,
    // but we likely want to allow multiselect in the future so doing some future-proofing
    node = {
        type: 'paragraph',
        content: newNodes
    };
    if ((0, $1oCLl.expValEquals)('platform_editor_react19_migration', 'isEnabled', true)) {
        if (root) root.unmount();
    } else if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
    return node;
}



const $8264492e60b066c8$var$manifestFunction = ({ appKey: appKey, canMountinIframe: canMountinIframe })=>({
        title: 'Dropbox',
        type: 'com.dropbox.fabric',
        key: 'dropbox',
        description: 'Embed Dropbox file to collaborate with your team',
        icons: {
            '16': ()=>(parcelRequire("oeyro")).then((mod)=>mod.default),
            '24': ()=>(parcelRequire("oeyro")).then((mod)=>mod.default),
            '48': ()=>(parcelRequire("oeyro")).then((mod)=>mod.default)
        },
        modules: {
            quickInsert: [
                {
                    key: 'item',
                    action: ()=>// eslint-disable-next-line no-async-promise-executor
                        new Promise(async (resolve, reject)=>{
                            try {
                                const newNode = await $8264492e60b066c8$var$pickFromDropbox(appKey, canMountinIframe);
                                if (!newNode) reject();
                                else resolve(newNode);
                            } catch (e) {
                                reject(e);
                            }
                        })
                }
            ]
        }
    });
var $8264492e60b066c8$export$2e2bcd8739ae039 = $8264492e60b066c8$var$manifestFunction;
module.exports["default"] = $8264492e60b066c8$export$2e2bcd8739ae039;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("kTtIX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ba0b0705ccaf171$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line require-await

var $8ba0b0705ccaf171$export$2e2bcd8739ae039 = async (appKey)=>{
    if (!window.Dropbox) // The dropbox script is in no way typescript, and is not our code
    // It attached the `Dropbox` property to window.
    // @ts-ignore
    return (parcelRequire("6ENnI")).then(()=>{
        window.Dropbox.appKey = appKey;
    });
    else {
        window.Dropbox.appKey = appKey;
        return Promise.resolve();
    }
};

});

parcelRegister("6ENnI", function(module, exports) {

let $4d8cc89e711b5ba3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d8cc89e711b5ba3$var$load("9n0AM").then(()=>parcelRequire('12tqw'));

});

parcelRegister("dwj5l", function(module, exports) {
const $2db8f6b12db59ced$export$6a428e19cddf769b = 'twp-dropbox-popup-mount-point';
const $2db8f6b12db59ced$export$5719e9fb73d0a1be = 'twp-dropboxjs-iframe';
module.exports["POPUP_MOUNTPOINT"] = $2db8f6b12db59ced$export$6a428e19cddf769b;
module.exports["DROPBOX_IFRAME_NAME"] = $2db8f6b12db59ced$export$5719e9fb73d0a1be;

});

parcelRegister("l4EvG", function(module, exports) {

let $f579652900415be3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f579652900415be3$var$load("17JTB").then(()=>parcelRequire('3H9Ht'));

});

parcelRegister("oeyro", function(module, exports) {

let $048d8839b5559430$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $048d8839b5559430$var$load("cMAQT").then(()=>parcelRequire('fqMQg'));

});

parcelRegister("ke0mx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");
var $jyd5r = parcelRequire("jyd5r");


var $aXWIB = parcelRequire("aXWIB");


var $jTxSS = parcelRequire("jTxSS");


var $bYRk6 = parcelRequire("bYRk6");


var $dh538 = parcelRequire("dh538");


var $d7ZU3 = parcelRequire("d7ZU3");


var $c6GJD = parcelRequire("c6GJD");


var $cYYWV = parcelRequire("cYYWV");


var $4XKEZ = parcelRequire("4XKEZ");


var $9pBtT = parcelRequire("9pBtT");

// as const so that values can be looked up for i18n in ./ui/messages/keywords
const $8b2ff5afb7b4d3e5$var$JIRA_KEYWORDS = [
    'create',
    'issue',
    'ticket',
    'raise',
    'new'
];
const $8b2ff5afb7b4d3e5$var$CONFLUENCE_KEYWORDS = [
    'create',
    'page',
    'new',
    'space',
    'publish'
];
// categories will put us into tabs in the quick insert browser (the plus menu)
const $8b2ff5afb7b4d3e5$var$JIRA_CATEGORIES = [
    'development',
    'external-content'
];
const $8b2ff5afb7b4d3e5$var$CONFLUENCE_CATEGORIES = [
    'confluence-content'
];



const $8b2ff5afb7b4d3e5$export$e538f94cc8cf4db8 = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, analyticsContext: analyticsContext, location: location, gatewayBaseUrl: gatewayBaseUrl, flags: flags, defaultFormValues: defaultFormValues, pageContext: pageContext, allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed })=>{
    const formatMessage = (descriptor)=>{
        return intl?.formatMessage(descriptor) ?? descriptor.defaultMessage;
    };
    return {
        title: 'Link create editor extension',
        type: 'extension',
        key: 'com.atlassian.linking-platform.create',
        description: 'Configures quick insert commands for creating objects, like Jira issues and Confluence pages as links',
        icons: {
            '48': ()=>(parcelRequire("pKBxY")).then((mod)=>mod.default)
        },
        modules: {
            quickInsert: [
                {
                    key: 'linking-platform-create-jira-issue',
                    title: formatMessage((0, $dh538.fg)('jira-issue-terminology-update-m4') ? (0, $4XKEZ.jiraExtensionMessages).extensionTitleIssueTerminologyRefreshM4 : (0, $4XKEZ.jiraExtensionMessages).extensionTitle),
                    description: formatMessage((0, $dh538.fg)('jira-issue-terminology-update-m4') ? (0, $4XKEZ.jiraExtensionMessages).extensionDescriptionIssueTerminologyRefreshM4 : (0, $4XKEZ.jiraExtensionMessages).extensionDescription),
                    featured: true,
                    categories: $8b2ff5afb7b4d3e5$var$JIRA_CATEGORIES,
                    keywords: [
                        'jira',
                        ...$8b2ff5afb7b4d3e5$var$JIRA_KEYWORDS.map((keyword)=>formatMessage((0, $4XKEZ.keywords)[keyword]))
                    ],
                    icon: ()=>(parcelRequire("pKBxY")).then((mod)=>mod.default),
                    action: async ()=>$8b2ff5afb7b4d3e5$var$showCreateModal({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            entityKey: 'jira-issue',
                            gatewayBaseUrl: gatewayBaseUrl,
                            location: location,
                            flags: flags,
                            defaultFormValues: defaultFormValues
                        })
                },
                {
                    key: 'linking-platform-create-confluence-page',
                    title: formatMessage((0, $4XKEZ.confluenceExtensionMessages).extensionTitle),
                    description: formatMessage((0, $4XKEZ.confluenceExtensionMessages).extensionDescription),
                    featured: true,
                    categories: $8b2ff5afb7b4d3e5$var$CONFLUENCE_CATEGORIES,
                    keywords: [
                        'confluence',
                        ...$8b2ff5afb7b4d3e5$var$CONFLUENCE_KEYWORDS.map((keyword)=>formatMessage((0, $4XKEZ.keywords)[keyword]))
                    ],
                    icon: ()=>Promise.resolve((parcelRequire("8jHAi"))).then((mod)=>mod.default),
                    action: async ()=>{
                        // Only do one step page creation if we are
                        // 1. in the full page editor
                        // 2. in a published page OR (on a live doc and enrolled in the experiment)
                        // 3. not in a blogpost
                        // 4. not using Safari
                        const shouldUseOneStepCreate = location === 'confluence-page' && pageContext?.isFullPageEditor && !pageContext?.isBlogpost && !(0, $d7ZU3.getBrowserInfo)().safari;
                        if (shouldUseOneStepCreate) {
                            // Enable one step page creation on live pages if user is enrolled in the experiment
                            const isOneStepEnabledOnLivePage = pageContext?.isLivePage // Limit experiment exposure to users on a live page
                             ? (0, $c6GJD.default).getExperimentValue('confluence_live_docs_inline_create_page_one_step', 'isEnabled', false) : false;
                            if (!pageContext?.isLivePage || isOneStepEnabledOnLivePage) return $8b2ff5afb7b4d3e5$var$oneStepCreate({
                                intl: intl,
                                intlLocale: intlLocale,
                                defaultCloudId: defaultCloudId,
                                analyticsContext: analyticsContext,
                                gatewayBaseUrl: gatewayBaseUrl,
                                flags: flags,
                                defaultFormValues: defaultFormValues
                            });
                        }
                        return $8b2ff5afb7b4d3e5$var$showCreateModal({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            entityKey: 'confluence-page',
                            gatewayBaseUrl: gatewayBaseUrl,
                            location: location,
                            flags: flags,
                            defaultFormValues: defaultFormValues,
                            allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed
                        });
                    }
                }
            ]
        }
    };
};
const $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE = 'en';
const $8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID = 'link-create-mount-point';
const $8b2ff5afb7b4d3e5$var$getMountPoint = ()=>{
    let modalEl = document.getElementById(`${$8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID}`);
    if (modalEl === null) {
        modalEl = document.createElement('div');
        modalEl.id = $8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID;
        document.body.appendChild(modalEl);
    }
    return modalEl;
};
const $8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper = ({ children: children, value: value })=>{
    if (value === undefined) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cYYWV.LinkCreateModalProvider), {
        value: value,
        children: children
    });
};

const $8b2ff5afb7b4d3e5$var$LazyEditorExtensionLinkCreate = (0, $96msn.lazy)(()=>(parcelRequire("c5Yzi")).then(({ EditorExtensionLinkCreate: EditorExtensionLinkCreate })=>({
            default: EditorExtensionLinkCreate
        })));

const $8b2ff5afb7b4d3e5$var$LazyOneStepLinkCreate = (0, $96msn.lazy)(()=>(parcelRequire("6Nkev")).then(({ OneStepLinkCreate: OneStepLinkCreate })=>({
            default: OneStepLinkCreate
        })));
/*
 * Rather than rendering a modal and requesting user input, this function
 * creates a new page and immediately inserts it without any user input.
 * The title is generated on the backend so the new page is just created
 * and inserted as a smartlink. This is part of the Confluence Inline Create
 * One Step experiment.
 */ const $8b2ff5afb7b4d3e5$var$oneStepCreate = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, gatewayBaseUrl: gatewayBaseUrl, analyticsContext: analyticsContext, flags: flags, defaultFormValues: defaultFormValues })=>{
    return new Promise(async (res)=>{
        const mountPoint = $8b2ff5afb7b4d3e5$var$getMountPoint();
        const handleCreate = (payload)=>{
            res({
                type: 'inlineCard',
                attrs: {
                    url: payload.url
                }
            });
            // Open the draft in a new tab and show the success flag
            const parentId = defaultFormValues?.['confluence-page']?.parentId ?? '';
            window.name = parentId;
            // createdFrom param indicates to the new draft window to show a success flag on load
            const url = new URL(payload.linkToOpen ?? payload.url);
            url.searchParams.set('createdFrom', parentId);
            window.open(url, '_blank');
        };
        const handleComplete = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(mountPoint);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, $l998X.jsx)($8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper, {
            value: analyticsContext,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
                messages: intl?.messages ?? {},
                locale: intl?.locale ?? intlLocale ?? 'en',
                defaultLocale: $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE,
                onError: intl?.onError,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: {
                        source: 'inlineCreateOneStep',
                        attributes: {
                            component: 'editorExtensionLinkCreate',
                            location: 'confluence-page',
                            triggeredFrom: 'quick-insert'
                        }
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9pBtT.ErrorBoundary), {
                        flags: flags,
                        onError: ()=>{
                            /**
             * If something goes wrong, resolve the promise to editor,
             * and unmount the component mountpoint
             */ res();
                            handleComplete();
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $l998X.jsx)($8b2ff5afb7b4d3e5$var$LazyOneStepLinkCreate, {
                                onCreate: handleCreate,
                                gatewayBaseUrl: gatewayBaseUrl,
                                defaultCloudId: defaultCloudId,
                                defaultFormValues: defaultFormValues
                            })
                        })
                    })
                })
            })
        }), mountPoint);
    });
};
const $8b2ff5afb7b4d3e5$var$showCreateModal = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, entityKey: entityKey, gatewayBaseUrl: gatewayBaseUrl, location: location, analyticsContext: analyticsContext, flags: flags, defaultFormValues: defaultFormValues, allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed })=>new Promise(async (res)=>{
        const mountPoint = $8b2ff5afb7b4d3e5$var$getMountPoint();
        const handleCreate = (payload)=>{
            res({
                type: 'inlineCard',
                attrs: {
                    url: payload.url
                }
            });
        };
        const handleCancel = ()=>{
            res();
        };
        const handleCloseComplete = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(mountPoint);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, $l998X.jsx)($8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper, {
            value: analyticsContext,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
                messages: intl?.messages ?? {},
                locale: intl?.locale ?? intlLocale ?? 'en',
                defaultLocale: $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE,
                onError: intl?.onError,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: {
                        attributes: {
                            component: 'editorExtensionLinkCreate',
                            location: location,
                            triggeredFrom: 'quick-insert'
                        }
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9pBtT.ErrorBoundary), {
                        flags: flags,
                        onError: ()=>{
                            /**
           * If something goes wrong, resolve the promise to editor,
           * and unmount the component mountpoint
           */ res();
                            handleCloseComplete();
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $l998X.jsx)($8b2ff5afb7b4d3e5$var$LazyEditorExtensionLinkCreate, {
                                defaultCloudId: defaultCloudId,
                                gatewayBaseUrl: gatewayBaseUrl,
                                defaultFormValues: defaultFormValues,
                                entityKey: entityKey,
                                onCreate: handleCreate,
                                onCancel: handleCancel,
                                onCloseComplete: handleCloseComplete,
                                flags: flags,
                                allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed
                            })
                        })
                    })
                })
            })
        }), mountPoint);
    });
module.exports["manifest"] = $8b2ff5afb7b4d3e5$export$e538f94cc8cf4db8;

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("lhchg", function(module, exports) {

var $89YVk = parcelRequire("89YVk");


var $8dgvm = parcelRequire("8dgvm");

parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $89YVk.collect)();
    }
};

});

parcelRegister("89YVk", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");


var $8lfql = parcelRequire("8lfql");


var $3iPPT = parcelRequire("3iPPT");

const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $8lfql.cloneElements)(markers[i], lazyBegin) : (0, $3iPPT.refElements)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $5f0e6c234ea4c71a$export$bb44f104e3c54dae;

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("8lfql", function(module, exports) {
const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $612c3fc5c2a28c4f$export$c42217d53a7ebafb;

});

parcelRegister("3iPPT", function(module, exports) {
const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $267b431587227d50$export$c69443129766a7fc;

});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $1r9rN = parcelRequire("1r9rN");


var $2niqO = parcelRequire("2niqO");


var $aAlyb = parcelRequire("aAlyb");


var $1C3RC = parcelRequire("1C3RC");


var $1Bcgq = parcelRequire("1Bcgq");


var $fLvpO = parcelRequire("fLvpO");

function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $2niqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $1r9rN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $aAlyb.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $1Bcgq.retry)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $1C3RC.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("1r9rN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $k001K = parcelRequire("k001K");


var $fLvpO = parcelRequire("fLvpO");


var $8VyCG = parcelRequire("8VyCG");


var $femay = parcelRequire("femay");


var $1C3RC = parcelRequire("1C3RC");


var $iYRNV = parcelRequire("iYRNV");


var $36I1o = parcelRequire("36I1o");

function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $36I1o.useSubscription)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $36I1o.useSubscription)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $1C3RC.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8VyCG.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $femay.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $10bfa415480e5081$export$6898b5504b58699a;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("8VyCG", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $67fe80fcd34326f0$export$d55db778a3e1446b;

});

parcelRegister("femay", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");

function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4;

});

parcelRegister("1C3RC", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");


var $27zaj = parcelRequire("27zaj");


var $k001K = parcelRequire("k001K");


var $1J5yR = parcelRequire("1J5yR");


var $iYRNV = parcelRequire("iYRNV");

function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1J5yR.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1J5yR.insertLinkTag)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}
module.exports["preloadAsset"] = $12cc564e7e862135$export$25bad4aa00c45355;

});

parcelRegister("1J5yR", function(module, exports) {

var $iYRNV = parcelRequire("iYRNV");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");

function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $141e4ec3ad408220$export$6610512821c8a4ce;

});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("36I1o", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $2434146821c65301$export$368b4214baeb914c;

});

parcelRegister("2niqO", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $27zaj = parcelRequire("27zaj");


var $fLvpO = parcelRequire("fLvpO");

function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $1bac06d947c9671a$export$eb2e4b04351cdd9e;

});

parcelRegister("aAlyb", function(module, exports) {
const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $7b4dfb9d7bf38586$export$e673efccd97e4223;

});

parcelRegister("1Bcgq", function(module, exports) {
const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $12a2c288067cec34$export$9369b12211e1fce4;

});

parcelRegister("cYYWV", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $2xIMp = parcelRequire("2xIMp");

const $71e94db7c7ca5154$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
class $71e94db7c7ca5154$export$9e8ad10df3086be2 extends (0, $42omo.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2xIMp.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.contextValue = void 0;
        this.getChildContext = ()=>{
            return this.contextValue;
        };
        const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext, getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers } = this.props.value;
        this.contextValue = {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }
}
$71e94db7c7ca5154$export$9e8ad10df3086be2.contextTypes = $71e94db7c7ca5154$var$ContextTypes;
$71e94db7c7ca5154$export$9e8ad10df3086be2.childContextTypes = $71e94db7c7ca5154$var$ContextTypes;
module.exports["LinkCreateModalProvider"] = $71e94db7c7ca5154$export$9e8ad10df3086be2;

});

parcelRegister("4XKEZ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $822de4fa2e7d82c6$export$eebaaf2b24d91f63 = (0, $aXWIB.defineMessages)({
    create: {
        id: "editorExtensionLinkCreate.keyword.create",
        defaultMessage: "create"
    },
    issue: {
        id: "editorExtensionLinkCreate.keyword.issue",
        defaultMessage: "work item"
    },
    ticket: {
        id: "editorExtensionLinkCreate.keyword.ticket",
        defaultMessage: "ticket"
    },
    raise: {
        id: "editorExtensionLinkCreate.keyword.raise",
        defaultMessage: "raise"
    },
    new: {
        id: "editorExtensionLinkCreate.keyword.new",
        defaultMessage: "new"
    },
    space: {
        id: "editorExtensionLinkCreate.keyword.space",
        defaultMessage: "space"
    },
    publish: {
        id: "editorExtensionLinkCreate.keyword.publish",
        defaultMessage: "publish"
    },
    page: {
        id: "editorExtensionLinkCreate.keyword.page",
        defaultMessage: "page"
    }
});
const $822de4fa2e7d82c6$export$1578873c8519570a = (0, $aXWIB.defineMessages)({
    extensionTitle: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.title",
        defaultMessage: "Create Jira issue"
    },
    extensionTitleIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4",
        defaultMessage: "Create Jira work item"
    },
    extensionDescription: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.description",
        defaultMessage: "Create an issue inline and insert the issue as a link"
    },
    extensionDescriptionIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4",
        defaultMessage: "Create a work item inline and insert the work item as a link"
    }
});
const $822de4fa2e7d82c6$export$5d64ddc7566152fc = (0, $aXWIB.defineMessages)({
    extensionTitle: {
        id: "editorExtensionLinkCreate.confluencePage.quickInsert.title",
        defaultMessage: "Create Confluence page"
    },
    extensionDescription: {
        id: "editorExtensionLinkCreate.confluencePage.quickInsert.description",
        defaultMessage: "Create a new page and insert it as a link"
    }
});
const $822de4fa2e7d82c6$export$52fbd4579940dbd3 = (0, $aXWIB.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.jiraIssue.title",
        defaultMessage: "Create new issue"
    },
    titleIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4",
        defaultMessage: "Create new work item"
    },
    successFlagTitle: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.title",
        defaultMessage: "Issue created"
    },
    successFlagTitleIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4",
        defaultMessage: "Work item created"
    },
    successFlagDescription: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.description",
        defaultMessage: "Your issue has been created"
    },
    successFlagDescriptionIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4",
        defaultMessage: "Your work item has been created"
    },
    successFlagActionOpen: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.action.open",
        defaultMessage: "Open in Jira"
    }
});
const $822de4fa2e7d82c6$export$87a972c4338ba7c0 = (0, $aXWIB.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.confluencePage.title",
        defaultMessage: "Create new page"
    },
    newDraftTitle: {
        id: "editorExtensionLinkCreate.confluencePage.newDraftTitle",
        defaultMessage: "Untitled page"
    },
    successFlagTitle: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.title",
        defaultMessage: "Page created"
    },
    successFlagDescription: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.description",
        defaultMessage: "Your page has been created"
    },
    successFlagActionOpen: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.action.open",
        defaultMessage: "Open in Confluence"
    }
});
module.exports["keywords"] = $822de4fa2e7d82c6$export$eebaaf2b24d91f63;
module.exports["jiraExtensionMessages"] = $822de4fa2e7d82c6$export$1578873c8519570a;
module.exports["confluenceExtensionMessages"] = $822de4fa2e7d82c6$export$5d64ddc7566152fc;
module.exports["jiraIssueMessages"] = $822de4fa2e7d82c6$export$52fbd4579940dbd3;
module.exports["confluencePageMessages"] = $822de4fa2e7d82c6$export$87a972c4338ba7c0;

});

parcelRegister("9pBtT", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hdKel = parcelRequire("hdKel");


var $ebpq7 = parcelRequire("ebpq7");


var $krp7k = parcelRequire("krp7k");


var $eZpnB = parcelRequire("eZpnB");

const $8d3a3fbbacd63515$var$NullFallback = ()=>null;
const $8d3a3fbbacd63515$var$getErrorType = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $8d3a3fbbacd63515$export$e926676385687eaf = ({ flags: flags, children: children, onError: onError })=>{
    const { fireEvent: fireEvent } = (0, $ebpq7.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $krp7k.BaseErrorBoundary), {
        errorComponent: /*#__PURE__*/ (0, $l998X.jsx)($8d3a3fbbacd63515$var$NullFallback, {}),
        onError: (error)=>{
            // Capture exception to Sentry
            if (error instanceof Error) (0, $hdKel.captureException)(error, 'editor-extension-link-create');
            flags?.showFailure?.({
                title: intl.formatMessage((0, $eZpnB.messages).title),
                description: intl.formatMessage((0, $eZpnB.messages).description)
            });
            fireEvent('operational.editorExtensionLinkCreateExperience.failed', {
                errorType: $8d3a3fbbacd63515$var$getErrorType(error)
            });
            onError?.();
        },
        children: children
    });
};
module.exports["ErrorBoundary"] = $8d3a3fbbacd63515$export$e926676385687eaf;

});

parcelRegister("hdKel", function(module, exports) {
const $98cbbeecc3c59dff$export$f5282963edea4a68 = async (_error, _packageName, _tags)=>{
    // Re-introduce in EDM-9682
    return;
};
module.exports["captureException"] = $98cbbeecc3c59dff$export$f5282963edea4a68;

});

parcelRegister("ebpq7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::ec329f21e6a5f943251e1d4a495988fb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen editor-extension-link-create
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $gw7I8 = parcelRequire("gw7I8");


var $d5rV1 = parcelRequire("d5rV1");

const $76d4605a9bf2a846$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $d5rV1.default)(...params));
        event.fire((0, $gw7I8.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $76d4605a9bf2a846$export$5bf35293e545f20c;

});

parcelRegister("gw7I8", function(module, exports) {
const $0e4ab8979da74ddc$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $0e4ab8979da74ddc$export$3f072f06b90c3985;

});

parcelRegister("d5rV1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::34a5c56e53d2f2c68cac8363edc2b0d0>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen editor-extension-link-create
 */ const $06f66ac78f70af1b$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $06f66ac78f70af1b$export$2e2bcd8739ae039 = $06f66ac78f70af1b$var$createEventPayload;
module.exports["default"] = $06f66ac78f70af1b$export$2e2bcd8739ae039;

});

parcelRegister("krp7k", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $d96537c513bf058f$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, errorComponent: errorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && errorComponent) return errorComponent;
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $d96537c513bf058f$export$688779ac61ee945f;

});

parcelRegister("eZpnB", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $6e0f7e34e90ca9be$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.genericError.title",
        defaultMessage: "Something went wrong"
    },
    description: {
        id: "editorExtensionLinkCreate.genericError.description",
        defaultMessage: "Refresh the page and try again."
    }
});
module.exports["messages"] = $6e0f7e34e90ca9be$export$defe85febe8b728c;

});

parcelRegister("pKBxY", function(module, exports) {

let $04d67c9dc5f31a45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $04d67c9dc5f31a45$var$load("6wr18"),
    $04d67c9dc5f31a45$var$load("ffEVr"),
    $04d67c9dc5f31a45$var$load("hXu5I")
]).then(()=>parcelRequire('hlE0H'));

});

parcelRegister("c5Yzi", function(module, exports) {

let $8ce4ef469a85e894$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ce4ef469a85e894$var$load("6iz6l"),
    $8ce4ef469a85e894$var$load("4SCW2"),
    $8ce4ef469a85e894$var$load("hhss7"),
    $8ce4ef469a85e894$var$load("dek7I"),
    $8ce4ef469a85e894$var$load("6wr18"),
    $8ce4ef469a85e894$var$load("ffEVr"),
    $8ce4ef469a85e894$var$load("kjZZD"),
    $8ce4ef469a85e894$var$load("ajMch"),
    $8ce4ef469a85e894$var$load("a0oMZ")
]).then(()=>parcelRequire('BkPha'));

});

parcelRegister("6Nkev", function(module, exports) {

let $4f270384a97e916a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f270384a97e916a$var$load("ja1FH").then(()=>parcelRequire('cDh22'));

});

parcelRegister("01djA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3jQ9y = parcelRequire("3jQ9y");


var $8Yt3t = parcelRequire("8Yt3t");


var $eSg31 = parcelRequire("eSg31");

const $4fad2c7cdc34331e$var$experienceIds = [
    'whiteboard',
    'database',
    'maui',
    'page'
];
const $4fad2c7cdc34331e$var$convertNativeEmbedNodeToCard = ({ api: api, localId: localId, url: url })=>{
    if (!localId) return;
    // If there is no URL, delete the node
    if (!url) {
        api?.core?.actions?.execute?.(({ tr: tr })=>{
            const targetNode = api?.localId?.actions?.getNode({
                localId: localId
            });
            if (!targetNode) return tr;
            return tr.delete(targetNode.pos, targetNode.pos + targetNode.node.nodeSize);
        });
        return;
    }
    const schema = api?.core?.sharedState.currentState()?.schema;
    if (!schema) return;
    // Convert the native embed node to an inline card
    const inlineCard = schema.nodeFromJSON({
        type: 'paragraph',
        content: [
            {
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            }
        ]
    });
    api?.localId?.actions?.replaceNode({
        localId: localId,
        value: inlineCard
    });
};
const $4fad2c7cdc34331e$export$bde152d863179cd9 = (api)=>{
    return {
        title: 'Native Embed Fallback',
        type: (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE),
        key: (0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY),
        description: 'Converts native-embed extension into a smart card, when fallback is required.',
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>(props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eSg31.NativeEmbedsFallbackExtension), {
                                ...props,
                                onConvert: ()=>{
                                    $4fad2c7cdc34331e$var$convertNativeEmbedNodeToCard({
                                        api: api,
                                        localId: props.node.localId,
                                        url: (0, $8Yt3t.getParameters)(props.node.parameters, 'url')
                                    });
                                }
                            }),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                },
                ...Object.fromEntries($4fad2c7cdc34331e$var$experienceIds.map((experienceId)=>[
                        experienceId,
                        {
                            type: 'extension',
                            render: async ()=>(props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eSg31.NativeEmbedsFallbackExtension), {
                                        ...props,
                                        onConvert: ()=>{
                                            $4fad2c7cdc34331e$var$convertNativeEmbedNodeToCard({
                                                api: api,
                                                localId: props.node.localId,
                                                url: (0, $8Yt3t.getParameters)(props.node.parameters, 'url')
                                            });
                                        }
                                    }),
                            __hideFrame: true
                        }
                    ]))
            }
        }
    };
};
module.exports["createNativeEmbedsFallbackManifest"] = $4fad2c7cdc34331e$export$bde152d863179cd9;

});

parcelRegister("eSg31", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $cO1el = parcelRequire("cO1el");


var $9pS9R = parcelRequire("9pS9R");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

const $70598f63f679b9f5$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "native-embeds-fallback-editor-extension.title",
        defaultMessage: "Embed failed to load."
    },
    description: {
        id: "native-embeds-fallback-editor-extension.description",
        defaultMessage: "Something went wrong while loading the content."
    },
    refresh: {
        id: "native-embeds-fallback-editor-extension.refresh",
        defaultMessage: "Refresh"
    }
});
const $70598f63f679b9f5$var$styles = {
    container: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _4t3i1osq _1tke68cl _bfhkvuon"
};
const $70598f63f679b9f5$export$6273057fe14fbe87 = ({ onConvert: onConvert })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "native-embeds-fallback-extension",
        xcss: $70598f63f679b9f5$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                    size: "small",
                    children: formatMessage($70598f63f679b9f5$var$messages.title)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    children: formatMessage($70598f63f679b9f5$var$messages.description)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9pS9R))),
                    onClick: onConvert,
                    children: formatMessage($70598f63f679b9f5$var$messages.refresh)
                })
            ]
        })
    });
};
module.exports["NativeEmbedsFallbackExtension"] = $70598f63f679b9f5$export$6273057fe14fbe87;

});

parcelRegister("7PHx9", function(module, exports) {

var $bre0g = parcelRequire("bre0g");


var $fPsyy = parcelRequire("fPsyy");


var $1M1t5 = parcelRequire("1M1t5");


var $872OF = parcelRequire("872OF");

const $d6233c6a28189b9d$export$7e6e8089e041148 = async (intl, editorActions, openConnectionsPanel, createAnalyticsEvent)=>{
    return new (0, $bre0g.default)([
        await (0, $fPsyy.createChartsExtension)({
            intl: intl,
            editorActions: editorActions,
            createAnalyticsEvent: createAnalyticsEvent,
            externalToolbarItems: openConnectionsPanel ? [
                (0, $1M1t5.getConnectionsToolbarItem)({
                    intl: intl,
                    openConnectionsPanel: openConnectionsPanel,
                    fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
                })
            ] : []
        })
    ]);
};
module.exports["connectChartExtensionProvider"] = $d6233c6a28189b9d$export$7e6e8089e041148;

});

parcelRegister("1M1t5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bre0g = parcelRequire("bre0g");


var $7O0l1 = parcelRequire("7O0l1");


var $3IXUB = parcelRequire("3IXUB");


var $8pcS0 = parcelRequire("8pcS0");


var $872OF = parcelRequire("872OF");

const $8f8eb5112d081276$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    toolbarItemLabel: {
        id: "app-referentiality.provider.toolbar.item.label",
        defaultMessage: "Manage connected data"
    }
});
const $8f8eb5112d081276$export$1b65aa3790d4a1ee = ({ intl: intl, openConnectionsPanel: openConnectionsPanel, fireAnalytics: fireAnalytics })=>({
        key: 'connections',
        label: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel),
        display: 'icon',
        tooltip: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel),
        icon: ()=>{
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7O0l1))), {
                    spacing: "spacious",
                    label: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel)
                });
        },
        action: async (adf)=>{
            const localId = adf.attrs?.localId;
            if (localId) {
                openConnectionsPanel(localId);
                fireAnalytics(adf);
            }
        }
    });
const $8f8eb5112d081276$var$getTableContextualToolbar = ({ intl: intl, openConnectionsPanel: openConnectionsPanel, createAnalyticsEvent: createAnalyticsEvent })=>({
        context: {
            type: 'node',
            nodeType: 'table'
        },
        toolbarItems: [
            $8f8eb5112d081276$export$1b65aa3790d4a1ee({
                intl: intl,
                openConnectionsPanel: openConnectionsPanel,
                fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
            })
        ]
    });
const $8f8eb5112d081276$var$getConnectContextualToolbars = async ({ intl: intl, openConnectionsPanel: openConnectionsPanel, createAnalyticsEvent: createAnalyticsEvent })=>{
    const allMacros = await (0, $3IXUB.getMacroMetaData)();
    // All macros support referentiality
    const allMacrosWithRefDataSchema = allMacros.filter((macro)=>macro.pluginKey === 'com.atlassian.plugins.atlassian-connect-plugin' && (macro.refDataSchema?.inputType || macro.refDataSchema?.outputType));
    return allMacrosWithRefDataSchema.reduce((acc, macro)=>{
        const context = {
            type: 'extension',
            nodeType: 'extension',
            extensionKey: macro.macroName,
            extensionType: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE
        };
        return [
            ...acc,
            {
                context: context,
                toolbarItems: [
                    $8f8eb5112d081276$export$1b65aa3790d4a1ee({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
                    })
                ]
            }
        ];
    }, []);
};

const $8f8eb5112d081276$export$43c4531a8498e016 = async ({ intl: intl, openConnectionsPanel: openConnectionsPanel = ()=>null, createAnalyticsEvent: createAnalyticsEvent })=>{
    return new (0, $bre0g.default)([
        {
            title: 'Referentiality',
            type: 'com.atlassian.confluence.referentiality',
            key: 'referentiality',
            icons: {
                '48': ()=>Promise.resolve((parcelRequire("jdPfT")))
            },
            modules: {
                contextualToolbars: [
                    $8f8eb5112d081276$var$getTableContextualToolbar({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        createAnalyticsEvent: createAnalyticsEvent
                    }),
                    ...await $8f8eb5112d081276$var$getConnectContextualToolbars({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        createAnalyticsEvent: createAnalyticsEvent
                    })
                ]
            }
        }
    ]);
};
module.exports["getConnectionsToolbarItem"] = $8f8eb5112d081276$export$1b65aa3790d4a1ee;
module.exports["referentialityExtensionProvider"] = $8f8eb5112d081276$export$43c4531a8498e016;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    const defaultWrmResources = $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES;
    const staticConnectWrmResources = $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES;
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...defaultWrmResources
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...defaultWrmResources,
            ...staticConnectWrmResources,
            ...contexts,
            ...keys
        ];
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $6g1oe = parcelRequire("6g1oe");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    // fetch ADF structure of JIM, and modify it to provide to editor later
    const jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, jiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("foRF9", function(module, exports) {

var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl } = options;
    const results = await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)({
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    });
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("aMlgD", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $9wGTI = parcelRequire("9wGTI");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $aXWIB.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a link to anywhere"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items (Child pages)"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "Display a custom list of content nested under a page or live doc."
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties (Page properties)"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Enter a table of summary information in this macro and display it on another page or live doc using a content properties report macro. You will need to add a label to this content and specify it in the report macro."
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree (Page tree)"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree."
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content (Include page)"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Display the full contents of a page or live doc."
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report (Page properties report)"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Display a table of pages and live docs that contain a content properties macro and a specific label. The table includes a link to each item and the summary from the macro on that page or doc."
    },
    jiraMacroTitle: {
        id: "fabric-extension-lib.jira.title",
        defaultMessage: "Jira Data Center"
    },
    jiraMacroDescription: {
        id: "fabric-extension-lib.jira.description",
        defaultMessage: "Insert Jira work items from Data Center via JQL"
    },
    jiraChartMacroTitle: {
        id: "fabric-extension-lib.jirachart.title",
        defaultMessage: "Jira Chart Data Center"
    },
    jiraChartMacroDescription: {
        id: "fabric-extension-lib.jirachart.description",
        defaultMessage: "Insert Jira Charts from Data Center via JQL"
    }
});
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroTitle);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRACHART && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraChartMacroTitle);
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroDescription);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRACHART && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraChartMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = Boolean(attrs?.parameters) ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    if (adf.attrs?.parameters) adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams || {}
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("872OF", function(module, exports) {

var $9fBoq = parcelRequire("9fBoq");


var $8pcS0 = parcelRequire("8pcS0");

const $6089ca8d25fc98f0$var$fireAnalyticsEvent = (createAnalyticsEvent, sourceNode, targetAttributes)=>{
    if (!createAnalyticsEvent) return;
    const sourceAttributes = {
        sourceNodeType: sourceNode.type
    };
    // Source is Connect macro
    if (sourceNode.type === 'extension' && sourceNode.attrs?.extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE) Object.assign(sourceAttributes, {
        sourceExtensionType: sourceNode.attrs?.extensionType,
        sourceExtensionKey: sourceNode.attrs?.extensionKey,
        sourceExtensionTitle: sourceNode.attrs?.parameters?.macroMetadata?.title,
        sourceExtensionParameters: sourceNode.attrs?.parameters
    });
    // Source is a Table
    if (sourceNode.type === 'table') Object.assign(sourceAttributes, {
        sourceExtensionType: 'table'
    });
    // Source is a Chart
    if (sourceNode.type === 'extension' && sourceNode.attrs?.extensionType === 'com.atlassian.chart') Object.assign(sourceAttributes, {
        sourceExtensionType: sourceNode.attrs?.extensionType,
        sourceExtensionKey: sourceNode.attrs?.extensionKey,
        sourceExtensionTitle: sourceNode.attrs?.parameters?.extensionTitle,
        sourceExtensionParameters: sourceNode.attrs?.parameters
    });
    const analyticsData = {
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createReference',
            source: 'editorFloatingToolbar',
            attributes: {
                ...sourceAttributes,
                ...targetAttributes
            }
        }
    };
    createAnalyticsEvent(analyticsData).fire();
};
const $6089ca8d25fc98f0$export$ab05b910337771f7 = (createAnalyticsEvent, sourceNode, targetMacro)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, sourceNode, {
        targetNodeType: 'extension',
        targetExtensionType: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE,
        targetExtensionKey: targetMacro.macroName,
        targetExtensionTitle: targetMacro.title,
        targetMacro: targetMacro
    });
};
const $6089ca8d25fc98f0$export$6fc4be8bb74a5f0 = (createAnalyticsEvent, sourceNode, targetMacro)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, sourceNode, {
        targetNodeType: 'extension',
        targetExtensionType: 'com.atlassian.ecosystem',
        targetExtensionKey: targetMacro.id.replace('ari:cloud:ecosystem::extension/', ''),
        targetExtensionTitle: (0, $9fBoq.extensionTitle)(targetMacro),
        targetMacro: targetMacro
    });
};
const $6089ca8d25fc98f0$export$6546d4aebb1728df = (createAnalyticsEvent, node)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, node, {});
};
module.exports["fireAnalyticsEventForConnectionsButton"] = $6089ca8d25fc98f0$export$6546d4aebb1728df;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("jRxDI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bre0g = parcelRequire("bre0g");


var $jmjWc = parcelRequire("jmjWc");


var $au7xi = parcelRequire("au7xi");


const $8c4ed19546fbbebf$var$SmartButtonExtension = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8Gy08",
    name: "SmartButtonExtension",
    loader: async ()=>(await (parcelRequire("9MR7j"))).SmartButtonExtension
});
const $8c4ed19546fbbebf$var$i18n = (0, $aXWIB.defineMessages)({
    extensionName: {
        id: "automation-extensions.smart-button.name",
        defaultMessage: "Smart Button"
    },
    extensionDescription: {
        id: "automation-extensions.smart-button.description",
        defaultMessage: "Enables users to create smart buttons to run automation rules"
    }
});

// "Manifest" of the extension
// Describes extension properties and how it hooks into other parts of editor
const $8c4ed19546fbbebf$var$getSmartButtonExtensionManifest = ({ contentId: contentId, editorActions: editorActions, openSmartButtonConfigPanel: openSmartButtonConfigPanel, isSmartButtonAllowed: isSmartButtonAllowed, intl: intl, contentType: contentType, isTemplateEditor: isTemplateEditor = false })=>({
        title: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionName),
        type: (0, $au7xi.smartButtonExtensionType),
        key: 'smart-button',
        description: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionDescription),
        icons: {
            // 48 is the pixel size of the icon
            '48': ()=>(parcelRequire("7yens")).then((mod)=>mod.AutomationIcon)
        },
        // automation icon to run rule from button toolbar can be added here - see code remove for A4C-2519
        modules: {
            // This governs the / menu and + menu insertion
            // We disable extension insertion from both menus by setting this as undefined
            quickInsert: isSmartButtonAllowed && contentType === 'page' ? [
                {
                    key: 'quick-insert',
                    keywords: [
                        'automation'
                    ],
                    action: ()=>Promise.resolve({
                            type: 'inlineExtension',
                            key: 'smart-button',
                            attrs: {
                                extensionType: (0, $au7xi.smartButtonExtensionType),
                                extensionKey: 'smart-button',
                                parameters: {
                                    extensionTitle: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionName)
                                }
                            }
                        })
                }
            ] : undefined,
            // This is the actual node inserted into the content
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8c4ed19546fbbebf$var$SmartButtonExtension, {
                                extensionNode: node,
                                editorActions: editorActions,
                                openSmartButtonConfigPanel: openSmartButtonConfigPanel,
                                contentId: contentId,
                                contentType: contentType,
                                isTemplateEditor: isTemplateEditor
                            });
                        },
                    update: async ()=>{
                        const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                        const selectedLocalId = selectedNode?.attrs?.localId;
                        if (!!selectedLocalId && openSmartButtonConfigPanel) openSmartButtonConfigPanel(selectedLocalId);
                    }
                }
            }
        }
    });
const $8c4ed19546fbbebf$export$5d6127d5858c50c9 = async ({ contentId: contentId, editorActions: editorActions, openSmartButtonConfigPanel: openSmartButtonConfigPanel, isSmartButtonAllowed: isSmartButtonAllowed, intl: intl, contentType: contentType, isTemplateEditor: isTemplateEditor = false })=>new (0, $bre0g.default)([
        $8c4ed19546fbbebf$var$getSmartButtonExtensionManifest({
            contentId: contentId,
            editorActions: editorActions,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            isSmartButtonAllowed: isSmartButtonAllowed,
            intl: intl,
            contentType: contentType,
            isTemplateEditor: isTemplateEditor
        })
    ]);
module.exports["smartButtonExtensionProvider"] = $8c4ed19546fbbebf$export$5d6127d5858c50c9;

});

parcelRegister("9MR7j", function(module, exports) {

let $7201ccb0216488bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7201ccb0216488bc$var$load("6wr18"),
    $7201ccb0216488bc$var$load("gctwz"),
    $7201ccb0216488bc$var$load("7f9Fz"),
    $7201ccb0216488bc$var$load("lhkXg"),
    $7201ccb0216488bc$var$load("ffEVr"),
    $7201ccb0216488bc$var$load("fgNp8")
]).then(()=>parcelRequire('6ncRx'));

});

parcelRegister("7yens", function(module, exports) {

let $57f6dc6f33ede5cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57f6dc6f33ede5cd$var$load("6wr18"),
    $57f6dc6f33ede5cd$var$load("ffEVr"),
    $57f6dc6f33ede5cd$var$load("djlDY")
]).then(()=>parcelRequire('iFAjt'));

});

parcelRegister("iONqR", function(module, exports) {

var $bre0g = parcelRequire("bre0g");


var $51WxS = parcelRequire("51WxS");

const $c614caf6b183de5b$export$e1aa62d66c6fe261 = (intl, snippets, onOpenTemplatePanel, userId)=>{
    if (!onOpenTemplatePanel && (!snippets || snippets.length === 0)) return new (0, $bre0g.default)([]);
    const manifest = (0, $51WxS.snippetExtensionManifest)({
        snippets: snippets || [],
        intl: intl,
        onOpenTemplatePanel: onOpenTemplatePanel,
        userId: userId
    });
    return new (0, $bre0g.default)([
        manifest
    ]);
};
module.exports["snippetExtensionProvider"] = $c614caf6b183de5b$export$e1aa62d66c6fe261;

});

parcelRegister("51WxS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $isFEX = parcelRequire("isFEX");


var $lCB0R = parcelRequire("lCB0R");

const $3f665bc0c658edea$var$messages = (0, $aXWIB.defineMessages)({
    snippetsQuickInsertTitle: {
        id: "snippets.snippetsQuickInsertTitle",
        defaultMessage: "Block Template Gallery"
    },
    newLozenge: {
        id: "snippets.quickInsert.newLozenge",
        defaultMessage: "New"
    },
    snippetIconLabel: {
        id: "snippets.snippetIconLabel",
        defaultMessage: "Block template icon"
    },
    snippetQuickInsertDescription: {
        id: "snippets.snippetQuickInsertDescription",
        defaultMessage: "Create, discover, & insert block templates"
    }
});

const $3f665bc0c658edea$export$bc0a2249d0f8fcd = ({ snippets: snippets, intl: intl, onOpenTemplatePanel: onOpenTemplatePanel, userId: userId })=>{
    const snippetsQuickInsertTitle = intl.formatMessage($3f665bc0c658edea$var$messages.snippetsQuickInsertTitle);
    const snippetIconLabel = intl.formatMessage($3f665bc0c658edea$var$messages.snippetIconLabel);
    const snippetQuickInsertDescription = intl.formatMessage($3f665bc0c658edea$var$messages.snippetQuickInsertDescription);
    const quickInsert = (0, $lCB0R.filterAndSort)(snippets, userId).map((snippet)=>({
            key: `snippet-${snippet.snippetId}`,
            title: snippet.name,
            description: (0, $lCB0R.createSnippetDescription)(snippet.createdBy, intl),
            keywords: (0, $lCB0R.extractSnippetKeywords)(snippet.name, intl),
            icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isFEX))), {
                        label: snippetIconLabel
                    }),
            action: async ()=>snippet.body
        }));
    // Add "Block Template" quick insert item if callback is provided
    if (onOpenTemplatePanel) quickInsert.unshift({
        key: 'block-template',
        title: snippetsQuickInsertTitle,
        description: snippetQuickInsertDescription,
        keywords: (0, $lCB0R.extractSnippetKeywords)($3f665bc0c658edea$var$messages.snippetsQuickInsertTitle.defaultMessage, intl),
        icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isFEX))), {
                    label: snippetIconLabel
                }),
        lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, intl.formatMessage($3f665bc0c658edea$var$messages.newLozenge)),
        action: async ()=>{
            onOpenTemplatePanel();
        }
    });
    return {
        title: snippetsQuickInsertTitle,
        description: snippetQuickInsertDescription,
        type: 'com.atlassian.confluence.macro.core',
        key: 'snippet-extension',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>Promise.resolve((parcelRequire("isFEX")))
        },
        modules: {
            quickInsert: quickInsert
        }
    };
};
module.exports["snippetExtensionManifest"] = $3f665bc0c658edea$export$bc0a2249d0f8fcd;

});

parcelRegister("fxClS", function(module, exports) {

var $dZUkS = parcelRequire("dZUkS");


var $5OfFS = parcelRequire("5OfFS");


var $lCB0R = parcelRequire("lCB0R");

const $14685d8ced03c929$export$81c899ea0c3802a0 = (editorAPI, userId)=>{
    if (!editorAPI) return;
    (0, $dZUkS.onCurrentFetchComplete)((loadedSnippets)=>{
        (0, $lCB0R.filterAndSort)(loadedSnippets, userId).forEach((snippet)=>{
            (0, $5OfFS.addSnippetQuickInsertItem)({
                snippet: snippet,
                editorAPI: editorAPI
            });
        });
    });
};
module.exports["registerSnippetsQuickInsertOnLoad"] = $14685d8ced03c929$export$81c899ea0c3802a0;

});

parcelRegister("6b7RE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bre0g = parcelRequire("bre0g");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");

const $9e56fbf670b6dc1e$export$858ce1ee8936577f = async (args)=>new (0, $bre0g.default)([
        $9e56fbf670b6dc1e$var$getProjectLinkerExtensionManifest(args)
    ]);
const $9e56fbf670b6dc1e$var$getProjectLinkerExtensionManifest = ({ cloudId: cloudId, intl: intl, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent })=>({
        title: intl.formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? $9e56fbf670b6dc1e$var$i18n.titleGalaxia : $9e56fbf670b6dc1e$var$i18n.title),
        type: 'com.atlassian.confluence.project-linker',
        key: 'project-linker',
        description: intl.formatMessage($9e56fbf670b6dc1e$var$i18n.description),
        icons: {
            '48': async ()=>({
                    default: ()=>null
                })
        },
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9e56fbf670b6dc1e$var$ProjectLinkerLoader, {
                                cloudId: cloudId,
                                editorActions: editorActions,
                                createAnalyticsEvent: createAnalyticsEvent
                            }),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                }
            }
        }
    });

const $9e56fbf670b6dc1e$var$ProjectLinkerLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mj056",
    name: "ProjectLinkerLoader",
    loader: async ()=>(await (parcelRequire("9uksS"))).ProjectLinkerWrapper
});
const $9e56fbf670b6dc1e$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-space.project-linker.extension.title",
        defaultMessage: "Project linker"
    },
    titleGalaxia: {
        id: "create-space.project-linker.extension.title-galaxia",
        defaultMessage: "Space linker"
    },
    description: {
        id: "create-space.project-linker.extension.description",
        defaultMessage: "Provides a convenient way to link to projects on space overview"
    }
});
module.exports["projectLinkerExtensionProvider"] = $9e56fbf670b6dc1e$export$858ce1ee8936577f;

});

parcelRegister("9uksS", function(module, exports) {

let $6e86ca41962e6e4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6e86ca41962e6e4f$var$load("jg5LT"),
    $6e86ca41962e6e4f$var$load("bGpE6"),
    $6e86ca41962e6e4f$var$load("4RbVd"),
    $6e86ca41962e6e4f$var$load("9wzNh"),
    $6e86ca41962e6e4f$var$load("9ldRJ"),
    $6e86ca41962e6e4f$var$load("dek7I"),
    $6e86ca41962e6e4f$var$load("jiFtb"),
    $6e86ca41962e6e4f$var$load("kjZZD"),
    $6e86ca41962e6e4f$var$load("6wr18"),
    $6e86ca41962e6e4f$var$load("7EorR"),
    $6e86ca41962e6e4f$var$load("ffEVr"),
    $6e86ca41962e6e4f$var$load("Wowvf"),
    $6e86ca41962e6e4f$var$load("hhss7"),
    $6e86ca41962e6e4f$var$load("4pqtR"),
    $6e86ca41962e6e4f$var$load("5XqRg"),
    $6e86ca41962e6e4f$var$load("c0JsV"),
    $6e86ca41962e6e4f$var$load("8AwXG")
]).then(()=>parcelRequire('cIFHL'));

});

parcelRegister("4U6ec", function(module, exports) {
/**
 * @deprecated This should be removed once we migrate away from using Synchrony
 */ var $5137e303faa24d7f$export$9c28bc693ca74328 = /*#__PURE__*/ function(SYNC_STATUS_KEY) {
    SYNC_STATUS_KEY["CONNECTED"] = "connected";
    SYNC_STATUS_KEY["DISCONNECTED"] = "disconnected";
    SYNC_STATUS_KEY["ERROR"] = "error";
    SYNC_STATUS_KEY["COLLAB_LIMIT"] = "collab-limit";
    SYNC_STATUS_KEY["PERMISSION_CHANGED"] = "permission-changed";
    return SYNC_STATUS_KEY;
}({});
const $5137e303faa24d7f$export$40bf0201c34f0600 = 'l5albia6lf64r4n';
const $5137e303faa24d7f$export$92a4a783381b2c9 = 'confluence.fabric.page.optin.page.has.been.migrated';
const $5137e303faa24d7f$export$6a9702599c19f55f = 8000;
const $5137e303faa24d7f$export$11e4ffbb7072caae = 'https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor/#Convertpagestotheneweditor-WhatACTUALLYhappenswhenyourcontentisconverted';
module.exports["DROPBOX_APP_KEY"] = $5137e303faa24d7f$export$40bf0201c34f0600;
module.exports["learnMoreURL"] = $5137e303faa24d7f$export$11e4ffbb7072caae;

});

parcelRegister("giS6h", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a6c7790f33c3e831$export$bbe9955f93d6ed27 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["ClassicEditorContext"] = $a6c7790f33c3e831$export$bbe9955f93d6ed27;

});

parcelRegister("fgd2r", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $ee57e9dbd4a15340$export$41ec0510c4ed436a = (flagName, defaultValue, map)=>(featureFlags)=>{
        const maybeValue = featureFlags[flagName];
        if (typeof maybeValue === 'string') try {
            const value = JSON.parse(maybeValue);
            return map ? map(value) : value;
        } catch (err) {
            return defaultValue;
        }
        return defaultValue;
    };
const $ee57e9dbd4a15340$export$395b7f16d1fbd63c = ()=>{
    const optedOutMacros = [
        'create-from-template',
        'auibutton',
        'cfm-progress-bar-hyperlink-step',
        'decisionreport',
        'viewpdf',
        'viewdoc',
        'viewxls',
        'viewppt',
        'cqlmacro1',
        'detailssummary',
        'contentbylabel'
    ];
    if (!(0, $9wGTI.fg)('confluence_frontend_blog_posts_macro_in_side_panel')) optedOutMacros.push('blog-posts');
    return optedOutMacros;
};
module.exports["getOptedOutMacros"] = $ee57e9dbd4a15340$export$395b7f16d1fbd63c;

});

parcelRegister("1JyKZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $9wGTI = parcelRequire("9wGTI");


var $8a9Dm = parcelRequire("8a9Dm");

var $765515c26d11d063$var$_ContextTokenCache;
class $765515c26d11d063$var$ContextTokenCache {
    static getInstance() {
        if (!$765515c26d11d063$var$ContextTokenCache.instance) $765515c26d11d063$var$ContextTokenCache.instance = new $765515c26d11d063$var$ContextTokenCache();
        return $765515c26d11d063$var$ContextTokenCache.instance;
    }
    get(key) {
        return this.promiseCache.get(key);
    }
    set(key, value) {
        this.promiseCache.set(key, value);
    }
    delete(key) {
        this.promiseCache.delete(key);
    }
    constructor(){
        this.promiseCache = void 0;
        this.promiseCache = new Map();
    }
}
$765515c26d11d063$var$_ContextTokenCache = $765515c26d11d063$var$ContextTokenCache;
$765515c26d11d063$var$ContextTokenCache.instance = void 0;
const $765515c26d11d063$var$EXTRA_BUFFER_MS = 30000; // extra 30 seconds buffer for clock skew
// GraphQL mutation to get context token
const $765515c26d11d063$var$UseGetContextTokenMutation = (0, $eSUdr.gql)`
	mutation useGetContextTokenMutation(
		$cloudId: ID!
		$input: ConfluenceForgeContextTokenRequestInput!
	) {
		confluence_generateForgeContextToken(cloudId: $cloudId, input: $input) {
			success
			errors {
				message
			}
			forgeContextToken {
				jwt
				expiresAt
				extensionId
			}
		}
	}
`;
const $765515c26d11d063$export$42cd66ed92f75ea0 = ({ extension: extension, extensionData: extensionData, localId: localId, contextIds: contextIds, cachingEnabled: cachingEnabled = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [runMutation] = (0, $308Wd.useMutationInterop)($765515c26d11d063$var$UseGetContextTokenMutation, {
        client: (0, $gKr8t.getAGGClient)()
    });
    return (0, $42omo.useMemo)(()=>{
        const fetchTokenFromServer = async (effectiveContextIds, effectiveExtension, effectiveLocalId, cache, cacheKey)=>{
            try {
                // Build the input according to the schema
                const input = {
                    contextIds: effectiveContextIds,
                    extensionSpecificContexts: {
                        appVersion: effectiveExtension.appVersion,
                        context: {
                            appVersion: effectiveExtension.appVersion,
                            environmentId: effectiveExtension.environmentId,
                            environmentType: effectiveExtension.environmentType,
                            siteUrl: window?.location?.origin,
                            extension: {
                                location: undefined,
                                content: extensionData?.content ? {
                                    id: extensionData.content.id,
                                    type: extensionData.content.type,
                                    subtype: extensionData.content.subtype,
                                    ...(0, $9wGTI.fg)('forge-ui-add-contentversion-to-macro-extensiondata') ? {
                                        version: extensionData.content?.version
                                    } : {}
                                } : undefined,
                                isEditing: extensionData?.isEditing,
                                macro: extensionData?.macro ? {
                                    isConfiguring: extensionData.macro.isConfiguring,
                                    isInserting: extensionData.macro.isInserting,
                                    layout: extensionData.macro.layout
                                } : undefined,
                                space: extensionData?.space ? {
                                    id: extensionData.space.id,
                                    key: extensionData.space.key
                                } : undefined,
                                ...extensionData?.template?.id && {
                                    template: {
                                        id: extensionData.template.id
                                    }
                                },
                                type: extensionData.type,
                                selectedText: extensionData?.selectedText
                            },
                            localId: effectiveLocalId,
                            moduleKey: (0, $8a9Dm.getModuleKey)(effectiveExtension)
                        },
                        extensionId: effectiveExtension.id,
                        extensionType: effectiveExtension.type,
                        installationId: effectiveExtension.installationId
                    }
                };
                const { data: data } = await runMutation({
                    variables: {
                        cloudId: cloudId,
                        input: input
                    }
                });
                if (!data?.confluence_generateForgeContextToken?.success) {
                    const errors = data?.confluence_generateForgeContextToken?.errors || [];
                    const errorMessage = errors.map((e)=>e.message).join(', ') || 'Unknown error';
                    throw new Error(`Token generation failed: ${errorMessage}`);
                }
                const forgeContextToken = data.confluence_generateForgeContextToken.forgeContextToken;
                if (!forgeContextToken?.jwt) throw new Error('No JWT token received from GraphQL endpoint');
                // Update cache with expiry info if available
                if (cachingEnabled) {
                    const cachedEntry = cache.get(cacheKey);
                    if (cachedEntry && forgeContextToken.expiresAt) cachedEntry.expiresAt = Number(forgeContextToken.expiresAt);
                }
                return forgeContextToken.jwt;
            } catch (error) {
                // Remove from cache on error so next call will retry
                if (cachingEnabled) cache.delete(cacheKey);
                throw new Error(`Failed to get context token: ${error.message}`);
            }
        };
        // Original implementation - only supports contextIdsOverride
        async function getForgeContextTokenLegacy(options) {
            if (!cloudId) throw new Error('CloudId is required but not available');
            const { contextIdsOverride: contextIdsOverride } = options ?? {};
            const effectiveContextIds_0 = contextIdsOverride ?? contextIds;
            const cacheKey_0 = JSON.stringify({
                id: localId || extension.id,
                data: extensionData,
                contextIds: effectiveContextIds_0
            });
            const cache_0 = $765515c26d11d063$var$ContextTokenCache.getInstance();
            const cached = cache_0.get(cacheKey_0);
            if (cachingEnabled) {
                if (cached) {
                    if (typeof cached.expiresAt !== 'number') return cached.promise;
                    if (Date.now() + $765515c26d11d063$var$EXTRA_BUFFER_MS < cached.expiresAt) return cached.promise;
                }
                const issuedAt = Date.now();
                const tokenPromise = fetchTokenFromServer(effectiveContextIds_0, extension, localId, cache_0, cacheKey_0);
                cache_0.set(cacheKey_0, {
                    promise: tokenPromise,
                    expiresAt: undefined,
                    issuedAt: issuedAt
                });
                return tokenPromise;
            }
            return fetchTokenFromServer(effectiveContextIds_0, extension, localId, cache_0, cacheKey_0);
        }
        // New implementation - supports both contextIdsOverride and extensionOverride for embedded macros
        async function getForgeContextTokenWithExtensionOverride(options_0) {
            if (!cloudId) throw new Error('CloudId is required but not available');
            const { contextIdsOverride: contextIdsOverride_0, extensionOverride: extensionOverride } = options_0 ?? {};
            // Use override values if provided (for embedded macros), otherwise use parent values
            const effectiveExtension_0 = extensionOverride?.extension ?? extension;
            const effectiveLocalId_0 = extensionOverride?.localId ?? localId;
            const effectiveContextIds_1 = contextIdsOverride_0 ?? contextIds;
            const cacheKey_1 = JSON.stringify({
                id: effectiveLocalId_0 || effectiveExtension_0.id,
                data: extensionData,
                contextIds: effectiveContextIds_1
            });
            const cache_1 = $765515c26d11d063$var$ContextTokenCache.getInstance();
            const cached_0 = cache_1.get(cacheKey_1);
            if (cachingEnabled) {
                if (cached_0) {
                    if (typeof cached_0.expiresAt !== 'number') return cached_0.promise;
                    if (Date.now() + $765515c26d11d063$var$EXTRA_BUFFER_MS < cached_0.expiresAt) return cached_0.promise;
                }
                const issuedAt_0 = Date.now();
                const tokenPromise_0 = fetchTokenFromServer(effectiveContextIds_1, effectiveExtension_0, effectiveLocalId_0, cache_1, cacheKey_1);
                cache_1.set(cacheKey_1, {
                    promise: tokenPromise_0,
                    expiresAt: undefined,
                    issuedAt: issuedAt_0
                });
                return tokenPromise_0;
            }
            return fetchTokenFromServer(effectiveContextIds_1, effectiveExtension_0, effectiveLocalId_0, cache_1, cacheKey_1);
        }
        return (0, $9wGTI.fg)('platform_embedded_macro_fct_override') ? getForgeContextTokenWithExtensionOverride // once FG rolled out rename to getForgeContextToken and remove the legacy function
         : getForgeContextTokenLegacy;
    }, [
        extension,
        extensionData,
        localId,
        cloudId,
        runMutation,
        contextIds,
        cachingEnabled
    ]);
};
module.exports["useGetContextToken"] = $765515c26d11d063$export$42cd66ed92f75ea0;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either cc_snippets or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either cc_snippets or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("lvKPs", function(module, exports) {
/*
Not to be confused for comment-macro-extension-handler.tsx in the same package which is used specifically
for the comment editor. This MacroExtensionHandler file is used for creating extension handlers
for next/full-page-editor
*/ 
var $42omo = parcelRequire("42omo");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $8pcS0 = parcelRequire("8pcS0");


var $eS4Za = parcelRequire("eS4Za");


var $Qcu7n = parcelRequire("Qcu7n");


var $e8Lxy = parcelRequire("e8Lxy");


var $e1Stz = parcelRequire("e1Stz");


var $5a4cC = parcelRequire("5a4cC");


var $9m03g = parcelRequire("9m03g");


var $4EIU1 = parcelRequire("4EIU1");


var $8Ksv7 = parcelRequire("8Ksv7");


var $dgMPt = parcelRequire("dgMPt");


var $fuLIO = parcelRequire("fuLIO");


var $6mKj3 = parcelRequire("6mKj3");


var $6aEhm = parcelRequire("6aEhm");


var $c8uPc = parcelRequire("c8uPc");


var $ahrsq = parcelRequire("ahrsq");


var $5h7sn = parcelRequire("5h7sn");


var $7NX4e = parcelRequire("7NX4e");


var $8jP8e = parcelRequire("8jP8e");


var $kvJ5e = parcelRequire("kvJ5e");

const $0e80447918933d7e$export$ea8f3f4f30a7109d = ({ contentId: contentId, spaceKey: spaceKey, extensionContextProvider: extensionContextProvider, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isLivePage: isLivePage, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    return {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $0e80447918933d7e$export$9270a983db609799({
            contentId: contentId,
            spaceKey: spaceKey,
            extensionContextProvider: extensionContextProvider,
            editorActions: editorActions,
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange,
            isLivePage: isLivePage,
            isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled
        }),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $5h7sn.getMigrationExtHandlerForEditor)({
            contentId: contentId,
            contextProviders: {}
        })
    };
};
const $0e80447918933d7e$export$9270a983db609799 = ({ contentId: contentId, spaceKey: spaceKey, extensionContextProvider: extensionContextProvider = {
    ClassicEditorContextProvider: ({ children: children, isWithinEditor: _isWithinEditor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)
}, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isLivePage: isLivePage, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>(0, $eS4Za.createMacroExtensionHandler)((extension, doc)=>{
        const resolvedExtensionKey = (0, $Qcu7n.resolveQuestionsMacroExtensionKey)(extension.extensionKey);
        const extensionKey = resolvedExtensionKey;
        // Update extension if key was resolved to a different value
        if (resolvedExtensionKey !== extension.extensionKey) extension = {
            ...extension,
            extensionKey: resolvedExtensionKey
        };
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const { ClassicEditorContextProvider: ClassicEditorContextProvider } = extensionContextProvider;
        const macroDefaultProps = {
            node: extension,
            references: doc?.[0]?.references || [],
            contentId: contentId,
            spaceKey: spaceKey,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: attributes,
            multiBodiedExtensionActions: doc?.[0]?.actions
        };
        let implementation;
        const legacyMacroRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps));
        switch(extensionKey){
            // blocklist - block extensions - we want to show the editor's placeholder frame, so return empty div
            case 'toc':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jP8e.TableOfContentsLiveComponent), {
                    macroDefaultProps: macroDefaultProps,
                    editorActions: editorActions,
                    subscribeDocChange: subscribeDocChange,
                    unsubscribeDocChange: unsubscribeDocChange,
                    isCollabEditForLiveUpdatesEnabled: !!isCollabEditForLiveUpdatesEnabled
                });
                break;
            case 'create-from-template':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahrsq.CreateFromTemplate), macroDefaultProps);
                break;
            // blocklist - inline extensions - the editor doesn't render a placeholder frame, so we need to display something
            case 'pagetree':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8uPc.DeadMacroRenderer), macroDefaultProps);
                break;
            case 'anchor':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6aEhm.AnchorMacroRenderer), macroDefaultProps);
                break;
            case 'excerpt-include':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7NX4e.ExcerptIncludeExtensionHandler), {
                    ...macroDefaultProps,
                    isLivePage: isLivePage,
                    Renderer: (0, $e8Lxy.PageContentRenderer)
                }));
                break;
            case 'detailssummary':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1Stz.PagePropertiesReportRenderer), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams,
                    openAnchorsInNewTab: true
                }));
                break;
            case 'blog-posts':
                if ((0, $6mKj3.expValEquals)('cc_rewrite_blog_posts_legacy_macro', 'isEnabled', true)) implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Ksv7.BlogPostsMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                else implementation = legacyMacroRenderer;
                break;
            case 'profile-picture':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            case 'profile':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            case 'include':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps));
                break;
            case 'livesearch':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJ5e.LiveSearchHandler), {
                    macroDefaultProps: macroDefaultProps
                });
                break;
            case 'questionslist-macro':
                implementation = legacyMacroRenderer;
                break;
            case 'questionslist-macro-native':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dgMPt.GlobalQuestionsListMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            case 'contributors':
                implementation = (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4EIU1.ContributorsMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                }) : legacyMacroRenderer;
                break;
            // generic macro renderer
            default:
                implementation = legacyMacroRenderer;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.EDITOR), extension),
            contentId: contentId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), implementation);
    });
module.exports["getFullPageExtensionHandlers"] = $0e80447918933d7e$export$ea8f3f4f30a7109d;

});

parcelRegister("5kjCz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $2XqLN.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $42omo.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $42omo.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("d8GNm"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("d8GNm", function(module, exports) {

let $990d37f4d14ab271$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $990d37f4d14ab271$var$load("gdPWB"),
    $990d37f4d14ab271$var$load("9AXkC"),
    $990d37f4d14ab271$var$load("4pqtR"),
    $990d37f4d14ab271$var$load("5XqRg"),
    $990d37f4d14ab271$var$load("6wr18"),
    $990d37f4d14ab271$var$load("ffEVr"),
    $990d37f4d14ab271$var$load("hhss7"),
    $990d37f4d14ab271$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});

parcelRegister("6aEhm", function(module, exports) {
/* AnchorMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $9tVje = parcelRequire("9tVje");

const $0c2b5b61ad0a1759$var$i18n = (0, $aXWIB.defineMessages)({
    anchorMacroLabel: {
        id: "fabric-extension-handlers.inline-extension.valid-anchor-macro.icon.label",
        defaultMessage: "Anchor link"
    }
});
const $0c2b5b61ad0a1759$var$highlightAnimation = null;
const $0c2b5b61ad0a1759$var$animationStyles = null;
const $0c2b5b61ad0a1759$var$macroWrapperStyles = null;
const $0c2b5b61ad0a1759$export$16f5c11d6d7adab1 = (props)=>{
    const intl = (0, $aXWIB.useIntl)();
    const [shouldPlayHighlightAnimation, setShouldPlayHighlightAnimation] = (0, $42omo.useState)(false);
    const [isMacroVisible, setIsMacroVisible] = (0, $42omo.useState)(false);
    const macroRef = (0, $42omo.useRef)(null);
    const anchorName = props?.node?.parameters?.macroParams[''].value;
    let anchorValid = true;
    if (!anchorName || anchorName.includes(' ')) anchorValid = false;
    if (anchorValid) try {
        decodeURIComponent(anchorName);
    } catch  {
        anchorValid = false;
    }
    (0, $42omo.useEffect)(()=>{
        setShouldPlayHighlightAnimation(anchorValid && window.location.hash === `#${anchorName}`);
        const handleOnHashChange = ()=>{
            setIsMacroVisible(false);
            setShouldPlayHighlightAnimation(anchorValid && window.location.hash === `#${anchorName}`);
        }; // There is a case where a url hash change occurs but does not reload the page.
        // To account for this, so we can still trigger the animation as expected when
        // the related anchor is scrolled to, we need to listen to the event.
        window.addEventListener('hashchange', handleOnHashChange);
        return ()=>{
            window.removeEventListener('hashchange', handleOnHashChange);
        };
    }, [
        anchorName,
        anchorValid,
        setShouldPlayHighlightAnimation
    ]);
    (0, $42omo.useEffect)(()=>{
        {
            /**
       * IntersectionObserver doesn't work for SSR pages.
       * Escaped using process.env.REACT_SSR above, per rule,
       * and silenced eslint warning safely below.
       */ // eslint-disable-next-line
            const observer = new IntersectionObserver(([entry])=>{
                if (!isMacroVisible) setIsMacroVisible(entry.isIntersecting);
            }, {
                threshold: 1.0
            });
            if (macroRef?.current) observer.observe(macroRef.current);
             // Remove the observer as soon as the component is unmounted
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        isMacroVisible,
        setIsMacroVisible,
        macroRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: macroRef,
        id: anchorValid ? anchorName : undefined,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko12b0 _1e0c1txw _1bah1h6o _4cvr1h6o _bfhki8nm _1bsb1tcg _4t3igktf _vchhusvi",
            shouldPlayHighlightAnimation && isMacroVisible && "",
            shouldPlayHighlightAnimation && isMacroVisible && "_y44vwhg8"
        ])
    }, anchorValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        label: intl.formatMessage($0c2b5b61ad0a1759$var$i18n.anchorMacroLabel),
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9tVje.AnchorMacroPlaceholder), null));
};
module.exports["AnchorMacroRenderer"] = $0c2b5b61ad0a1759$export$16f5c11d6d7adab1;

});

parcelRegister("ahrsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $cYJC5 = parcelRequire("cYJC5");


var $bQm3c = parcelRequire("bQm3c");

const $78b48bb386aef67d$export$a6c71275c6598127 = ({ ...macroDefaultProps })=>{
    const { contentId: contentId, extensionKey: extensionKey, node: node, mode: mode } = macroDefaultProps;
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
        userId: userId || '',
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
module.exports["CreateFromTemplate"] = $78b48bb386aef67d$export$a6c71275c6598127;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("8jP8e", function(module, exports) {
/* TableOfContentsLiveComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jSnXV = parcelRequire("jSnXV");


var $h9yJL = parcelRequire("h9yJL");


var $6qdjm = parcelRequire("6qdjm");


var $9hlns = parcelRequire("9hlns");


var $kDhla = parcelRequire("kDhla");


var $fDdWw = parcelRequire("fDdWw");


var $dwS6P = parcelRequire("dwS6P");


var $bQm3c = parcelRequire("bQm3c");


var $djaPL = parcelRequire("djaPL");

const $57df12aecf845afb$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ajq _bfhksm61",
            __cmplp.className
        ])
    });
});
const $57df12aecf845afb$var$Centered = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $57df12aecf845afb$export$7345e257c3f26650 = ({ macroDefaultProps: macroDefaultProps, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    const [isInitialLoadComplete, setIsInitialLoadComplete] = (0, $42omo.useState)(false);
    const [adf, setAdf] = (0, $42omo.useState)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const debounceMs = 400;
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousADF = (0, $42omo.useRef)();
    // Provided by the LCM extension-handler when this ToC is rendered inside a Legacy Content Macro.
    // When inside an LCM, editorActions is scoped to the LCM's nested editor and therefore only shows headings within the LCM.
    // Use the outerEditorView to show all page headings in this case.
    // outerEditorView be undefined when rendered outside an LCM so we'll use normal editorActions in this case.
    const outerEditorView = (0, $42omo.useContext)((0, $djaPL.OuterEditorViewContext));
    const getEffectiveEditorView = (0, $42omo.useCallback)(()=>{
        return outerEditorView ?? editorActions._privateGetEditorView();
    }, [
        outerEditorView,
        editorActions
    ]);
    const updateAdf = (0, $42omo.useCallback)((editorView)=>{
        const effectiveView = outerEditorView ?? editorView;
        const doc = effectiveView?.state?.doc;
        if (doc) {
            const editorTransformer = new (0, $h9yJL.JSONTransformer)();
            const _adf = editorTransformer.encode(doc);
            if (isCollabEditForLiveUpdatesEnabled) {
                const shouldUpdateADF = previousADF.current ? !(0, $fDdWw.checkIsEqual)(previousADF.current, _adf) : true;
                previousADF.current = _adf;
                if (shouldUpdateADF) setAdf(_adf);
            } else setAdf(_adf);
        }
    }, [
        isCollabEditForLiveUpdatesEnabled,
        outerEditorView
    ]);
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const debouncedUpdateADF = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            updateAdf(getEffectiveEditorView());
        }, debounceMs), [
        getEffectiveEditorView,
        updateAdf
    ]);
    (0, $6qdjm.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            if (isCollabEditForLiveUpdatesEnabled) debouncedUpdateADF();
        }
    });
    (0, $42omo.useEffect)(()=>{
        const debouncedHandleDocChange = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(updateAdf, debounceMs);
        if (!isCollabEditForLiveUpdatesEnabled) subscribeDocChange(debouncedHandleDocChange);
        return ()=>{
            if (!isCollabEditForLiveUpdatesEnabled) unsubscribeDocChange(debouncedHandleDocChange);
        };
    }, [
        subscribeDocChange,
        unsubscribeDocChange,
        debounceMs,
        updateAdf,
        isCollabEditForLiveUpdatesEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        // Ideally we would rely on the doc change handler to populate the ADF
        // but the doc change handler is sometimes not called on initial load.
        updateAdf(getEffectiveEditorView());
        setIsInitialLoadComplete(true);
    }, [
        getEffectiveEditorView,
        updateAdf
    ]);
    if (!isInitialLoadComplete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($57df12aecf845afb$var$Centered, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: "table-of-contents-live-component"
    }));
    else if (!adf) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($57df12aecf845afb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.TableOfContentsLoader), {
        isInEditMode: true,
        userId: userId ?? '',
        cloudId: cloudId ?? '',
        adf: adf,
        macroDefaultProps: macroDefaultProps
    }));
};
module.exports["TableOfContentsLiveComponent"] = $57df12aecf845afb$export$7345e257c3f26650;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("fDdWw", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $6jPem = parcelRequire("6jPem");

const $b1a5d5594ebd3d9f$export$b502f7a77e1faf1e = (prevADF, nextADF)=>{
    const prevHeadings = [];
    const nextHeadings = [];
    // Go through the ADF and push any headings
    // to a new array
    (0, $6jPem.traverse)(prevADF || {}, {
        heading: (node)=>{
            prevHeadings.push(node);
        }
    });
    (0, $6jPem.traverse)(nextADF || {}, {
        heading: (node)=>{
            nextHeadings.push(node);
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevHeadings, nextHeadings);
};
module.exports["checkIsEqual"] = $b1a5d5594ebd3d9f$export$b502f7a77e1faf1e;

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("j9Va5"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("j9Va5"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("j9Va5", function(module, exports) {

let $df2b32b2887845d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $df2b32b2887845d4$var$load("5qNrc"),
    $df2b32b2887845d4$var$load("4pqtR"),
    $df2b32b2887845d4$var$load("5XqRg"),
    $df2b32b2887845d4$var$load("8ublV"),
    $df2b32b2887845d4$var$load("9qfB8"),
    $df2b32b2887845d4$var$load("9ZB2D"),
    $df2b32b2887845d4$var$load("jXx9i"),
    $df2b32b2887845d4$var$load("hhss7"),
    $df2b32b2887845d4$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("djaPL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $606d3debb709f372$export$d7ea9fce87103426 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
module.exports["OuterEditorViewContext"] = $606d3debb709f372$export$d7ea9fce87103426;

});

parcelRegister("kvJ5e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $l7BGZ = parcelRequire("l7BGZ");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $6mEZ3 = parcelRequire("6mEZ3");

const $638330f188c4cca8$export$e8ac5007ab7a695a = ({ macroDefaultProps: macroDefaultProps })=>{
    const { contentId: contentId, extensionKey: extensionKey, node: node, mode: mode } = macroDefaultProps;
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l7BGZ.LiveSearchLoader), {
        macroNode: (0, $6mEZ3.extensionToADF)(node)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
module.exports["LiveSearchHandler"] = $638330f188c4cca8$export$e8ac5007ab7a695a;

});

parcelRegister("bcv7k", function(module, exports) {
/**
 * We shouldn't really need this file, as the editor shouldn't require us to pass in
 * a task and decision provider. But for now it does. So this whole thing is a stub.
 */ 
var $2XqLN = parcelRequire("2XqLN");

class $eaaab3ad8fc788e2$var$Provider {
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) this._toggleTaskCallback(objectKey, state);
        return Promise.resolve(state);
    }
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    constructor(toggleTask){
        this._toggleTaskCallback = void 0;
        this._toggleTaskCallback = toggleTask;
    }
}
const $eaaab3ad8fc788e2$export$5405ecb032439dfe = (0, $2XqLN.default)(async (toggleTaskCallback)=>{
    return new $eaaab3ad8fc788e2$var$Provider(toggleTaskCallback);
});
module.exports["getTaskDecisionProvider"] = $eaaab3ad8fc788e2$export$5405ecb032439dfe;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("a7SsH", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $92a679059989a896$export$fb999f8a83c64817 = /*#__PURE__*/ function(NotificationAction) {
    NotificationAction["NOTIFY"] = "NOTIFY";
    NotificationAction["DONT_NOTIFY"] = "DONT_NOTIFY";
    return NotificationAction;
}({});
module.exports["NotificationAction"] = $92a679059989a896$export$fb999f8a83c64817;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<acb8ba2772f142dd719427fed7f658a6>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("kGaEh", function(module, exports) {
$parcel$export(module.exports, "EditorTypes", () => (parcelRequire("lWVgZ")).EditorTypes);
$parcel$export(module.exports, "PreviewPageComponent", () => $93081da57503141f$export$376eaf8a4000eb1e);
$parcel$export(module.exports, "PreviewWithRenderer", () => $93081da57503141f$export$702c4e944f9180d3);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");

parcelRequire("lWVgZ");


const $93081da57503141f$export$376eaf8a4000eb1e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uDcJD",
    name: "PreviewPageComponent",
    loader: async ()=>(await (parcelRequire("3F1yH"))).PreviewPageComponent
});

const $93081da57503141f$export$702c4e944f9180d3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "UqJvA",
    name: "PreviewWithRenderer",
    loader: async ()=>// NOTE: placed into the same chunk as this component is used by Tiny editor and also used internally by PreviewPageComponent
        (await (parcelRequire("do8Np"))).PreviewWithRenderer
});

});

parcelRegister("3F1yH", function(module, exports) {

let $2aa668edbfae6fd1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2aa668edbfae6fd1$var$load("dtpmo"),
    $2aa668edbfae6fd1$var$load("lUs3J"),
    $2aa668edbfae6fd1$var$load("5odbj"),
    $2aa668edbfae6fd1$var$load("9GDly"),
    $2aa668edbfae6fd1$var$load("lPQcc"),
    $2aa668edbfae6fd1$var$load("6lM2n")
]).then(()=>parcelRequire('esDVy'));

});

parcelRegister("do8Np", function(module, exports) {

let $9bf456ec76386770$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9bf456ec76386770$var$load("dtpmo"),
    $9bf456ec76386770$var$load("lUs3J"),
    $9bf456ec76386770$var$load("5odbj"),
    $9bf456ec76386770$var$load("9GDly"),
    $9bf456ec76386770$var$load("lPQcc"),
    $9bf456ec76386770$var$load("6lM2n")
]).then(()=>parcelRequire('cPug3'));

});

parcelRegister("lWVgZ", function(module, exports) {
var $65441210bfcb6bd9$export$bb6127f23acfd41c = /*#__PURE__*/ function(EditorTypes) {
    EditorTypes["NCS"] = "ncs";
    EditorTypes["SYNCHRONY"] = "synchrony";
    EditorTypes["TEMPLATE"] = "template";
    return EditorTypes;
}({});
module.exports["EditorTypes"] = $65441210bfcb6bd9$export$bb6127f23acfd41c;

});

parcelRegister("2HGN8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $42omo.useState)();
    // Clear the override state when navigating to a different page
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_appearance_override_reset')) setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const editorWidth = metadata?.editorWidth;
            const widthValue = editorWidth?.value;
            const version = editorWidth?.version;
            if (widthValue && version !== undefined) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
		Previous check was:
		const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
		which always returns contentAppearanceQuery
	*/ const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        }
    });
    const context = (0, $42omo.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        // Under certain circumstances due to a previous bug with the content appearance during legacy editor autoconvert, an incorrect value may have been sent to collab service.
        // In this circumstance favour the initial content appearance value.
        const shouldUseInitial = contentAppearanceOverride && initialContentAppearance && contentAppearanceOverride.version === initialContentAppearance.version && contentAppearanceOverride.appearance !== initialContentAppearance.appearance && (0, $9wGTI.fg)('confluence_favour_gql_over_collab_appearance');
        return {
            contentAppearance: shouldUseInitial ? initialContentAppearance : contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $42omo.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && !(0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("hMRhJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $14a9ee80cba83190$export$4eaca3ef6119646c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["RendererExtensionContext"] = $14a9ee80cba83190$export$4eaca3ef6119646c;

});

parcelRegister("a1uFh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $4noo5 = parcelRequire("4noo5");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8FvpY = parcelRequire("8FvpY");

var $6LguK = parcelRequire("6LguK");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $lsxnT = parcelRequire("lsxnT");


var $8ul25 = parcelRequire("8ul25");


var $btgif = parcelRequire("btgif");

const $6e7c2a3fd79ba2ce$var$i18n = (0, $aXWIB.defineMessages)({
    editorModalTitle: {
        id: "onboarding-editor.modal.title",
        defaultMessage: "This page needs a title"
    },
    editorModalDescription: {
        id: "onboarding-editor.modal.description",
        defaultMessage: "Before you can publish this page, you\u2019ll need to give it a title."
    },
    editorModalPlaceholder: {
        id: "onboarding-editor.modal.placeholder",
        defaultMessage: "Enter title"
    },
    editorModalPublish: {
        id: "onboarding-editor.modal.button.publish",
        defaultMessage: "Publish"
    },
    editorModalClose: {
        id: "onboarding-editor.modal.button.close",
        defaultMessage: "Close"
    }
});
const $6e7c2a3fd79ba2ce$export$9265b150937a5ee1 = (props)=>{
    const { onTitleChange: onTitleChange, handlePublish: handlePublish } = props;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [title, setTitle] = (0, $42omo.useState)('');
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { modal: modal, hideEditorModal: hideEditorModal } = (0, $6LguK.useEditorModalContext)();
    const showModal = modal?.[(0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL] || false;
    const { fireEditorModalPromptClosed: fireEditorModalPromptClosed, fireEditorModalPromptPublished: fireEditorModalPromptPublished } = (0, $8ul25.useEditorOnboardingEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE),
            collect (events, experience) {
                // Fail or abort ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE as soon as EDIT_PAGE_PUBLISH_EXPERIENCE fails or aborts:
                experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && name === (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)));
            }
        });
    }, [
        experienceTracker
    ]);
    const endExperienceTracker = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE)
        });
    };
    const onClose = ()=>{
        hideEditorModal((0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL);
        fireEditorModalPromptClosed();
        endExperienceTracker();
    };
    const onClickPublish = ()=>{
        // There needs to be a title before publishing is possible
        onTitleChange(title);
        return Promise.resolve(hideEditorModal((0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL)).then(()=>{
            handlePublish();
        }).then(()=>{
            // set hasUserPublished to true
            setOnboardingState({
                key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
                value: 'true'
            });
            fireEditorModalPromptPublished();
            endExperienceTracker();
        });
    };
    return showModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        key: "onboarding-editor-modal",
        onClose: onClose,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true,
        width: 480,
        messageType: "transactional",
        messageId: "onboarding-editor-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6e7c2a3fd79ba2ce$var$i18n.editorModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btgif.ModalDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6e7c2a3fd79ba2ce$var$i18n.editorModalDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        testId: "editor-modal-prompt-textfield",
        autoFocus: true,
        onChange: (e)=>{
            setTitle(e.target.value);
        },
        placeholder: intl.formatMessage($6e7c2a3fd79ba2ce$var$i18n.editorModalPlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onClose,
        autoFocus: false,
        appearance: "subtle",
        testId: "editor-modal-prompt-close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6e7c2a3fd79ba2ce$var$i18n.editorModalClose)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onClickPublish,
        type: "submit",
        autoFocus: false,
        onSubmit: onClickPublish,
        isDisabled: title.length === 0,
        appearance: "primary",
        testId: "editor-modal-prompt-publish-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6e7c2a3fd79ba2ce$var$i18n.editorModalPublish)))) : null;
};
module.exports["OnboardingEditorModalPrompt"] = $6e7c2a3fd79ba2ce$export$9265b150937a5ee1;

});

parcelRegister("8FvpY", function(module, exports) {
const $1f6c26e8b75dac6d$export$66ebbe2730dd348f = {
    ONBOARDING_EDITOR_MODAL: 'onboarding-editor-modal'
};
module.exports["ALLOWED_EDITOR_MODAL"] = $1f6c26e8b75dac6d$export$66ebbe2730dd348f;

});

parcelRegister("6LguK", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a5f0fa1f60ef7a3d$export$f094ef697e0046b5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    showEditorModal: ()=>{},
    hideEditorModal: ()=>{},
    modal: {}
});
const $a5f0fa1f60ef7a3d$export$43769d91a63d8617 = ({ children: children })=>{
    const [modal, setModal] = (0, $42omo.useState)({});
    const showEditorModal = (0, $42omo.useCallback)((modalName)=>{
        setModal({
            ...modal,
            [modalName]: true
        });
    }, [
        modal
    ]);
    const hideEditorModal = (0, $42omo.useCallback)((modalName)=>{
        setModal({
            ...modal,
            [modalName]: false
        });
    }, [
        modal
    ]);
    const editorModalContextValue = (0, $42omo.useMemo)(()=>({
            showEditorModal: showEditorModal,
            hideEditorModal: hideEditorModal,
            modal: modal
        }), [
        showEditorModal,
        hideEditorModal,
        modal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a5f0fa1f60ef7a3d$export$f094ef697e0046b5.Provider, {
        value: editorModalContextValue
    }, children);
};
function $a5f0fa1f60ef7a3d$export$25df5f37bf8e13e4(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a5f0fa1f60ef7a3d$export$43769d91a63d8617, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
}
const $a5f0fa1f60ef7a3d$export$452d9698d6861523 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($a5f0fa1f60ef7a3d$export$f094ef697e0046b5);
module.exports["withEditorModalContext"] = $a5f0fa1f60ef7a3d$export$25df5f37bf8e13e4;
module.exports["useEditorModalContext"] = $a5f0fa1f60ef7a3d$export$452d9698d6861523;

});

parcelRegister("8ul25", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $37973aa3dd0a7e4f$export$4da26a7e02cd5140 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireGetEditorOnboardingStateFailed = (0, $42omo.useCallback)((source)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'getOnboardingState',
                actionSubjectId: 'editorOnboarding',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorPublishSuccessFlagViewed = (0, $42omo.useCallback)((type)=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'onboardingEditorPublishSuccessFlag',
                attributes: {
                    type: type
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorModalPromptClosed = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'onboardingEditorModalPrompt',
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'closeButton'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorModalPromptPublished = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'onboardingEditorModalPrompt',
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'publishButton'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireGetEditorOnboardingStateFailed: fireGetEditorOnboardingStateFailed,
        fireEditorPublishSuccessFlagViewed: fireEditorPublishSuccessFlagViewed,
        fireEditorModalPromptClosed: fireEditorModalPromptClosed,
        fireEditorModalPromptPublished: fireEditorModalPromptPublished
    };
};
module.exports["useEditorOnboardingEvents"] = $37973aa3dd0a7e4f$export$4da26a7e02cd5140;

});

parcelRegister("btgif", function(module, exports) {
/* EditorModalPromptStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8387ef6c90ca0a23$export$f50a68e3694789ee = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81af2 _syazi7uo _n3tdpxbi _1e0c1txw _1bah1yb4 _4cvr1h6o _z6mmtlke _10pb1tcg",
            __cmplp.className
        ])
    });
});
const $8387ef6c90ca0a23$export$70584796f9410aa4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazi7uo _n3tdpxbi",
            __cmplp.className
        ])
    });
});
module.exports["ModalDescription"] = $8387ef6c90ca0a23$export$70584796f9410aa4;

});

parcelRegister("6zK0v", function(module, exports) {
/* PressableLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

const $89ea01e4247ccb78$var$styles = {
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4bfu1r31 _1hms8stv _ajmmnqa1 _bfhk1j28 _4bfu1rpy _syaz1rpy _30l3i7uo _9h8h12zz"
};
const $89ea01e4247ccb78$export$12e82d6c56cc7acc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        ref: ref,
        xcss: $89ea01e4247ccb78$var$styles.root,
        onClick: onClick,
        ...rest
    }, children));
$89ea01e4247ccb78$export$12e82d6c56cc7acc.displayName = 'PressableLink';
module.exports["PressableLink"] = $89ea01e4247ccb78$export$12e82d6c56cc7acc;

});

parcelRegister("g01A4", function(module, exports) {

var $i9VoI = parcelRequire("i9VoI");


var $9wGTI = parcelRequire("9wGTI");


var $4VJDS = parcelRequire("4VJDS");


var $6mKj3 = parcelRequire("6mKj3");

const $e0f671e8616dafd9$export$c6d4df78386dbff6 = ({ callback: callback, subscriberId: subscriberId, contentId: contentId, contentType: contentType })=>{
    (0, $i9VoI.useSubscriptionEvent)({
        onDataReceived: callback,
        delta: 'contentRestrictionUpdated',
        subscriberId: subscriberId,
        contentType: contentType,
        contentId: contentId,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') || ![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $4VJDS.default).getString('confluence-migrate-fps-to-graphql-subscription', ''))
    });
};
module.exports["useContentRestrictionSubscriptionEvent"] = $e0f671e8616dafd9$export$c6d4df78386dbff6;

});

parcelRegister("18HQ4", function(module, exports) {
/* BrowserIndicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $4dfb2d8a6603cd21$export$adb584737d712b70 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v56417u1 _1e0c1txw _kqswstnw _1bsb1osq _1pbykb7n _1bah1h6o _4cvr1h6o _1ltvze3t _4t3ixy5q _bfhkysee _8hrzjp4b",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154i1ady",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_19111ady",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b4f88f0ca5784eef = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $4dfb2d8a6603cd21$export$adb584737d712b70, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1pby1fw0",
            __cmplp.show && __cmplp.showOnlineBackground ? "_bfhk1y9u" : "_bfhkysee",
            __cmplp.className
        ])
    });
}); // TODO: Figure out why @compiled is having trouble with the @media lambda function below.
const $4dfb2d8a6603cd21$export$31ea92f3997410dd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { mediaMaxWidth: mediaMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1enk3bj": (0, $7sObp.default)(__cmplp.mediaMaxWidth)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ect41kw7 _k48pwu06 _1wyb1crf _syaz1rpy _18u0u2gc _o5721q9c _1hma11y2",
            __cmplp.className
        ])
    });
});
$4dfb2d8a6603cd21$export$31ea92f3997410dd.defaultProps = {
    mediaMaxWidth: '650px'
};
const $4dfb2d8a6603cd21$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dfb2d8a6603cd21$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dfb2d8a6603cd21$var$FadingSpanInternal = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v564ayzn _1e0c1txw _4cvr1h6o _kqswstnw",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$91672a4b819b5126 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvresu3 _4t3iu2gc _18u0v77o",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$c30cc6d619162254 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _11q71rpy _y44v1dpe _1e0c1o8l _1bsbv77o _4t3iv77o _2hwxv77o _1dvn10n5 _8rwrg43g",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b9ead157d7292e86 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _k48pwu06 _syaz1oa5",
            __cmplp.className
        ])
    });
});
module.exports["StatusIndicator"] = $4dfb2d8a6603cd21$export$b4f88f0ca5784eef;
module.exports["StyledText"] = $4dfb2d8a6603cd21$export$31ea92f3997410dd;
module.exports["FadingSpan"] = $4dfb2d8a6603cd21$export$bb5d4b172e6970cd;
module.exports["EllipsisContainer"] = $4dfb2d8a6603cd21$export$91672a4b819b5126;
module.exports["AnimatedDot"] = $4dfb2d8a6603cd21$export$c30cc6d619162254;
module.exports["StyledRefreshLink"] = $4dfb2d8a6603cd21$export$b9ead157d7292e86;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("S6mif", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $h3X17 = parcelRequire("h3X17");


var $inPa6 = parcelRequire("inPa6");


var $422HI = parcelRequire("422HI");


var $bMmYR = parcelRequire("bMmYR");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hBkCm = parcelRequire("hBkCm");


var $aMcHK = parcelRequire("aMcHK");


var $fJlJm = parcelRequire("fJlJm");


var $3jwuS = parcelRequire("3jwuS");

class $03a48f98bcaadc9f$export$26130dc3dd4c1286 extends Error {
    constructor(message, status, traceId){
        super(message), this.message = message, this.status = status, this.traceId = traceId;
        this.status = status;
        this.traceId = traceId;
    }
}
const $03a48f98bcaadc9f$var$isNotPermittedError = (error)=>{
    return error.code === (0, $h3X17.PROVIDER_ERROR_CODE).NO_PERMISSION_ERROR && 'EXPIRED_TOKEN' !== error.reason || error.code === (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_NOT_FOUND;
};
const $03a48f98bcaadc9f$export$fab3177d2bcbd98a = (error)=>{
    return !error.recoverable && (0, $h3X17.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR !== error.code;
};
const $03a48f98bcaadc9f$var$getStatusCodeFromApolloError = (error)=>{
    return (0, $422HI.isApolloError)(error) && (0, $hBkCm.BadStatusError).isBadStatusError(error?.graphQLErrors?.[0]?.originalError) ? Number((0, $aMcHK.getStatusCodeError)(error.graphQLErrors[0].originalError)) : null;
};
const $03a48f98bcaadc9f$var$isTenantSuspendedError = (error)=>error.status === 423;
const $03a48f98bcaadc9f$export$5027865de34f9ec6 = (collabEditProvider, resetCollabService, contentId, contentType)=>{
    const [error, setError] = (0, $42omo.useState)(null);
    const [recoveryError, setRecoveryError] = (0, $42omo.useState)(null);
    const hasResetRef = (0, $42omo.useRef)({
        resetInProgress: false,
        resetCount: 0
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentEditorPageLoadExperienceName = isLivePage ? (0, $irVI7.VIEW_PAGE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
    const stopExperienceOnRecoveryError = (0, $42omo.useCallback)((recoveryErrorForAnalytics)=>{
        if (!!recoveryErrorForAnalytics?.status && recoveryErrorForAnalytics?.status < 500) {
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: `Recovery failed with error status ${recoveryErrorForAnalytics.status}`,
                attributes: {
                    errorStatus: recoveryErrorForAnalytics?.status,
                    traceId: recoveryErrorForAnalytics?.traceId,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage
                }
            });
            return;
        }
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: recoveryErrorForAnalytics,
            attributes: {
                ...recoveryErrorForAnalytics?.status ? {
                    errorStatus: recoveryErrorForAnalytics.status
                } : {},
                errorType: 'Recovery failed',
                traceId: recoveryErrorForAnalytics?.traceId,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage
            }
        });
    }, [
        contentId,
        contentType,
        experienceTracker,
        currentEditorPageLoadExperienceName,
        isLivePage
    ]);
    const setErrorAndDisconnect = (0, $42omo.useCallback)((newError)=>{
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError) || $03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError) || $03a48f98bcaadc9f$var$isTenantSuspendedError(newError)) setError(newError);
        const experienceState = experienceTracker.getExperienceState(currentEditorPageLoadExperienceName);
        if (!experienceState || experienceState.hasStopped) {
            // initialisation completed but we received an error later
            if (!$03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
                if ($03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError)) experienceTracker.stopOnError({
                    name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                    error: {
                        name: newError.code,
                        message: newError.message
                    },
                    attributes: {
                        errorStatus: newError.status,
                        objectId: contentId,
                        objectType: contentType,
                        isLivePage: isLivePage
                    }
                });
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'nativeEditor',
                        source: 'confluenceFrontend',
                        objectId: contentId,
                        objectType: contentType,
                        attributes: {
                            errorName: newError.code,
                            errorMessage: newError.message,
                            errorStatus: newError.status,
                            isRecoverable: true,
                            reason: 'reason' in newError ? newError.reason : 'unknown',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            }
            return;
        }
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
            // expected 403 for restricted page or deleted page
            // for deleted page, 403 is returned with reason "RESOURCE_DELETED"
            let newErrorReason;
            if ('reason' in newError) newErrorReason = newError.reason;
            collabEditProvider.disconnect();
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: newErrorReason ?? 'page restricted or deleted',
                attributes: {
                    errorStatus: newError.status,
                    errorName: newError.code,
                    errorMessage: newError.message,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage
                }
            });
        } else if ($03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError)) // unhandled/unexpected errors
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: {
                name: newError.code,
                message: newError.message
            },
            attributes: {
                errorStatus: newError.status,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage
            }
        });
    }, [
        collabEditProvider,
        experienceTracker,
        createAnalyticsEvent,
        contentId,
        contentType,
        currentEditorPageLoadExperienceName,
        isLivePage
    ]);
    const collabRecovery = (0, $42omo.useCallback)(async ()=>{
        if (hasResetRef.current.resetInProgress) return;
        else if (hasResetRef.current.resetCount > 0) {
            // recovery has already been attempted but we've received another 404d
            const error = new $03a48f98bcaadc9f$export$26130dc3dd4c1286(`Collab recovery unsuccessful`);
            setRecoveryError(error);
            stopExperienceOnRecoveryError(error);
            return;
        }
        hasResetRef.current = {
            resetInProgress: true,
            resetCount: hasResetRef.current.resetCount += 1
        };
        const shouldRetryPredicate = async (error)=>{
            const statusCode = $03a48f98bcaadc9f$var$getStatusCodeFromApolloError(error);
            return !!statusCode && statusCode >= 500;
        };
        try {
            await (0, $bMmYR.retry)(resetCollabService, {
                maxAttempts: 2,
                timeout: 2000
            }, shouldRetryPredicate); // kick off page recovery, with retry
            hasResetRef.current.resetInProgress = false;
        } catch (e) {
            // page recovery has failed, editor is empty... fatal error
            let recoveryError = e; // "public" error used by other components
            const statusCode = $03a48f98bcaadc9f$var$getStatusCodeFromApolloError(e);
            if (!!statusCode) recoveryError = new $03a48f98bcaadc9f$export$26130dc3dd4c1286(`Collab recovery responded with ${statusCode}`, statusCode, (0, $fJlJm.getTraceIdFromApolloError)(e) ?? undefined);
            setRecoveryError(recoveryError);
            stopExperienceOnRecoveryError(recoveryError);
            hasResetRef.current.resetInProgress = false;
        }
    }, [
        resetCollabService,
        stopExperienceOnRecoveryError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleError = (emittedError)=>{
            if (emittedError.status == 404) // 404 means that collab service doesn't have the document but Confluence does
            // try reset the document before displaying error (will be created in collab service if it doesn't exist). Currently only attempt reset once (no retry)
            collabRecovery();
            else setErrorAndDisconnect(emittedError);
        };
        collabEditProvider.on('error', handleError);
        return ()=>{
            collabEditProvider.off('error', handleError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditProvider,
        resetCollabService
    ]);
    return {
        error: error,
        recoveryError: recoveryError
    };
};
module.exports["CollabRecoveryErrorType"] = $03a48f98bcaadc9f$export$26130dc3dd4c1286;
module.exports["isUnrecoverableError"] = $03a48f98bcaadc9f$export$fab3177d2bcbd98a;
module.exports["useError"] = $03a48f98bcaadc9f$export$5027865de34f9ec6;

});

parcelRegister("kXAjP", function(module, exports) {
$parcel$export(module.exports, "useConnectionsPanel", () => (parcelRequire("39X8O")).useConnectionsPanel);

var $jmjWc = parcelRequire("jmjWc");


var $39X8O = parcelRequire("39X8O");


const $a2d4e70bef17fdaf$export$2dabaf13426958f5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "B5cUO",
    name: "EditorContextConnectionsPanel",
    loader: async ()=>(await (parcelRequire("c6Noq"))).EditorContextConnectionsPanel
});
module.exports["EditorContextConnectionsPanel"] = $a2d4e70bef17fdaf$export$2dabaf13426958f5;

});

parcelRegister("39X8O", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d49dc00c3f0d1c58$export$7e80a76e7cd27a75 = ()=>{
    const [connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId] = (0, $42omo.useState)(null);
    const openConnectionsPanel = (0, $42omo.useCallback)((localId)=>{
        setConnectionsPanelActiveNodeLocalId(localId);
    }, [
        setConnectionsPanelActiveNodeLocalId
    ]);
    const closeConnectionsPanel = (0, $42omo.useCallback)((localId)=>{
        if (!localId || localId && localId !== connectionsPanelActiveNodeLocalId) setConnectionsPanelActiveNodeLocalId(null);
    }, [
        connectionsPanelActiveNodeLocalId,
        setConnectionsPanelActiveNodeLocalId
    ]);
    return (0, $42omo.useMemo)(()=>({
            connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId,
            setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
            openConnectionsPanel: openConnectionsPanel,
            closeConnectionsPanel: closeConnectionsPanel
        }), [
        connectionsPanelActiveNodeLocalId,
        setConnectionsPanelActiveNodeLocalId,
        openConnectionsPanel,
        closeConnectionsPanel
    ]);
};
module.exports["useConnectionsPanel"] = $d49dc00c3f0d1c58$export$7e80a76e7cd27a75;

});

parcelRegister("c6Noq", function(module, exports) {

let $8d0c5bfa1af85aca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8d0c5bfa1af85aca$var$load("fiOV9"),
    $8d0c5bfa1af85aca$var$load("lPQcc"),
    $8d0c5bfa1af85aca$var$load("cHQ50"),
    $8d0c5bfa1af85aca$var$load("WlGjZ")
]).then(()=>parcelRequire('gUdsz'));

});

parcelRegister("6dTPw", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $dx8CK = parcelRequire("dx8CK");


var $hS1eb = parcelRequire("hS1eb");


var $fySJw = parcelRequire("fySJw");

const $dffc47041c3d315b$export$fdfa01513f7f82e4 = (0, $2XqLN.default)((createAnalyticsEvent, contentId, appearance = 'full-page', extensionHandlers, __rendererExtensionOptions, getExtensionHeight)=>{
    const editorAnalyticsAPI = (0, $hS1eb.getEditorAnalyticsAPI)(contentId, createAnalyticsEvent);
    const options = {
        editorAnalyticsAPI: editorAnalyticsAPI,
        appearance: appearance,
        featureFlags: {
            confluence_frontend_macro_interaction_design: true
        },
        externalObservers: [
            (0, $fySJw.getConnectDataListener)()
        ],
        extensionHandlers: extensionHandlers,
        __rendererExtensionOptions: __rendererExtensionOptions,
        getExtensionHeight: getExtensionHeight
    };
    return {
        ...(0, $dx8CK.createReferentiality)(options),
        options: options
    };
});
module.exports["getReferentialityContext"] = $dffc47041c3d315b$export$fdfa01513f7f82e4;

});

parcelRegister("hS1eb", function(module, exports) {

var $f0QSp = parcelRequire("f0QSp");

const $126cb09ff218d79b$export$a46cea14076acdff = (contentId, createAnalyticsEvent)=>(0, $f0QSp.editorAnalyticsAPI).analyticsCallback(contentId, createAnalyticsEvent);
module.exports["getEditorAnalyticsAPI"] = $126cb09ff218d79b$export$a46cea14076acdff;

});

parcelRegister("f0QSp", function(module, exports) {
const $b9a08ec7cb2f821d$var$normalizePayload = (payload)=>{
    const typeMap = {
        operational: 'sendOperationalEvent',
        screen: 'sendScreenEvent',
        track: 'sendTrackEvent',
        ui: 'sendUIEvent'
    };
    return {
        //adding "type" and "source", as they're originally omitted but expected by createAnalyticsEvent
        data: {
            ...payload,
            source: 'editorComponent'
        },
        type: typeMap[payload.eventType]
    };
};
const $b9a08ec7cb2f821d$export$5affe9476a7b3d5b = {
    analyticsCallback: (contentId, createAnalyticsEvent)=>{
        const fireAnalyticsEvent = (payload)=>{
            if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function' && createAnalyticsEvent) window.requestAnimationFrame(()=>{
                const analyticsPayload = $b9a08ec7cb2f821d$var$normalizePayload(payload);
                if (contentId) analyticsPayload.data.attributes = {
                    ...analyticsPayload.data.attributes,
                    objectId: contentId
                };
                createAnalyticsEvent(analyticsPayload).fire();
            });
        };
        const attachAnalyticsEvent = (payload)=>{
            fireAnalyticsEvent(payload);
            return (_tr)=>{
                return true;
            };
        };
        return {
            attachAnalyticsEvent: attachAnalyticsEvent,
            fireAnalyticsEvent: fireAnalyticsEvent
        };
    }
};
module.exports["editorAnalyticsAPI"] = $b9a08ec7cb2f821d$export$5affe9476a7b3d5b;

});

parcelRegister("fySJw", function(module, exports) {

var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("fNtDT"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            this.emit(localId, data.eventData);
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("fNtDT", function(module, exports) {

let $b8026cfc4781e004$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8026cfc4781e004$var$load("iEvs6").then(()=>parcelRequire('bppNh'));

});

parcelRegister("kQMK8", function(module, exports) {

let $f2de795a1beda015$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2de795a1beda015$var$load("gt1ja").then(()=>parcelRequire('98w9o'));

});

parcelRegister("4ri4I", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $9zUhf.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $9zUhf.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("c0BUW", function(module, exports) {

let $8be2e5baac3b35a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8be2e5baac3b35a8$var$load("kD057").then(()=>parcelRequire('KcDfp'));

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $2XqLN = parcelRequire("2XqLN");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $2XqLN.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<34081095f351c632b5c7f6a48a856531>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<da5cfc67a1415713a060abd033946dcb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<99bf881c6efd8312ff9d65a4878761ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3e2b4706208bc59168d9b7bd4bd3d395>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("kXsBa", function(module, exports) {

var $cXQmG = parcelRequire("cXQmG");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $1KmJq = parcelRequire("1KmJq");


var $cgpF0 = parcelRequire("cgpF0");


var $ij4CE = parcelRequire("ij4CE");


var $9wGTI = parcelRequire("9wGTI");




const $563fbe27571904a7$export$57b25de3525e313f = (contentId, currentTitle)=>{
    const [isEditing, setIsEditing] = (0, $42omo.useState)(false);
    const [updatedTitleFromPubsub, setUpdatedTitleFromPubsub] = (0, $42omo.useState)(undefined);
    const isProcessingTitleUpdate = (0, $42omo.useRef)(false);
    const onMutationComplete = ()=>{
        setUpdateError(undefined);
        setIsEditing(false);
    };
    const [updateError, setUpdateError] = (0, $42omo.useState)(undefined);
    const [updateContentTitle, { loading: updateLoading }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useContentTypesTitleUpdateContentTitleMutation($contentId:ID!$title:String){updateTitle(contentId:$contentId title:$title){id title links{editui webui}}}`, {
        onCompleted: onMutationComplete,
        onError: setUpdateError
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $cXQmG.default),
        fragmentSpec: (0, $cXQmG.default)
    });
    const updateCache = (0, $42omo.useCallback)((value)=>{
        writeFragmentInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                id: contentId,
                title: value,
                __typename: 'Content'
            }
        });
    }, [
        contentId,
        writeFragmentInterop
    ]);
    const updateTitle = (0, $42omo.useCallback)(async (value_0)=>{
        if (value_0 === currentTitle) {
            setIsEditing(false);
            // We have to manually clear the error here because it is no longer relevant to this most recent call to `updateTitle`,
            // since we're now attempting to set the title back to the current title, which should be valid.
            setUpdateError(undefined);
            if (updatedTitleFromPubsub && updatedTitleFromPubsub !== currentTitle) {
                updateCache(updatedTitleFromPubsub);
                setUpdatedTitleFromPubsub(undefined);
            }
            if (!isProcessingTitleUpdate.current) return;
        }
        try {
            await updateContentTitle({
                variables: {
                    contentId: contentId,
                    title: value_0
                }
            });
        } catch  {
        // error handled by useMutation result updateError
        }
    }, [
        contentId,
        currentTitle,
        updateCache,
        updateContentTitle,
        updatedTitleFromPubsub
    ]);
    /**
   * The following section is a mutation queue to ensure that title updates are processed sequentially and that the
   * latest title is always the one that gets applied.
   * This is important because multiple title updates can be triggered in quick succession when AI inline streaming
   * occurs and we want to avoid stale state errors from the GQL store, but also ensure the latest title is the one that
   * gets applied.
   */ const latestCachedTitle = (0, $42omo.useRef)();
    const processQueue = (0, $42omo.useCallback)(async ()=>{
        if (isProcessingTitleUpdate.current) return;
        isProcessingTitleUpdate.current = true;
        let nextTitle = latestCachedTitle.current;
        latestCachedTitle.current = undefined;
        // We keep updating the title until there are no more titles in the cache
        while(!!nextTitle){
            await updateTitle(nextTitle);
            nextTitle = latestCachedTitle.current;
            latestCachedTitle.current = undefined;
        }
        isProcessingTitleUpdate.current = false;
    }, [
        updateTitle
    ]);
    const enqueueTitle = (0, $42omo.useCallback)(async (title)=>{
        latestCachedTitle.current = title;
        if (!isProcessingTitleUpdate.current) await processQueue();
    }, [
        processQueue
    ]);
    // Set the title change handler when the component mounts
    // Content types use this method to update the title from within the iframe
    (0, $42omo.useEffect)(()=>{
        (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(updateTitle);
        return ()=>{
            (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(()=>{});
        };
    }, [
        updateTitle
    ]);
    return {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub,
        updateLoading: updateLoading,
        updateError: updateError,
        updateTitle: (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? enqueueTitle : updateTitle,
        updateCache: updateCache
    };
};
module.exports["useContentTypesTitleUpdate"] = $563fbe27571904a7$export$57b25de3525e313f;

});

parcelRegister("cXQmG", function(module, exports) {
/**
 * @generated SignedSource<<48a02deb309da4f281075267b22d9f71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d6b675ba61ab7de1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentTypesTitleUpdateContentTitleWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$d6b675ba61ab7de1$var$node.hash = "3d624df929b7f5b6bedfdab8b98fb427";
var $d6b675ba61ab7de1$export$2e2bcd8739ae039 = $d6b675ba61ab7de1$var$node;
module.exports["default"] = $d6b675ba61ab7de1$export$2e2bcd8739ae039;

});

parcelRegister("cgpF0", function(module, exports) {
class $ef2bdef46a40b8c0$export$b44304baa0bf4e7b {
    updateTitle(title) {
        this.titleChangeHandler(title);
    }
    setTitleChangeHandler(cb) {
        this.titleChangeHandler = cb;
    }
    constructor(){
        this.titleChangeHandler = void 0;
        this.titleChangeHandler = ()=>{};
    }
}
const $ef2bdef46a40b8c0$export$6450770420296206 = new $ef2bdef46a40b8c0$export$b44304baa0bf4e7b();
module.exports["contentTypesTitleServiceSingleton"] = $ef2bdef46a40b8c0$export$6450770420296206;

});

parcelRegister("1B6Lx", function(module, exports) {

var $hm7Pp = parcelRequire("hm7Pp");


var $fgrom = parcelRequire("fgrom");


var $1dRHU = parcelRequire("1dRHU");


var $ej7SU = parcelRequire("ej7SU");


var $42omo = parcelRequire("42omo");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");








var $ep3mz = parcelRequire("ep3mz");


var $de2j9 = parcelRequire("de2j9");


var $6mKj3 = parcelRequire("6mKj3");

const $42cdb37fcd4a7f68$export$751dd0cb1bbd0638 = ()=>{
    const readLastEditedDraftVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ej7SU.default)
    });
    const readLastEditedVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $1dRHU.default)
    });
    const writeLastEditedDraftVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $fgrom.default),
        fragmentArtifact: (0, $fgrom.default)
    });
    const writeLastEditedVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $hm7Pp.default),
        fragmentArtifact: (0, $hm7Pp.default)
    });
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [currentPageContentId] = (0, $ep3mz.usePageContentId)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const updateTimestampCache = ({ contentId: contentId })=>{
        const newWhen = new Date().toISOString();
        const isEditingThisContent = isOnEditRoute && contentId === currentPageContentId;
        const id = `$Content:${contentId}.${isEditingThisContent ? 'draftVersion' : 'version'}`;
        let prevTypename = 'KnownUser';
        try {
            const readFragmentInterop = isEditingThisContent ? readLastEditedDraftVersionFragmentFragmentInterop : readLastEditedVersionFragmentFragmentInterop;
            const prevCache = readFragmentInterop({
                id: id
            });
            if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
        } catch  {
        // silently fallback to default typename "KnownUser"
        }
        try {
            const writeFragmentInterop = isEditingThisContent ? writeLastEditedDraftVersionFragmentFragmentInterop : writeLastEditedVersionFragmentFragmentInterop;
            writeFragmentInterop({
                fragmentId: id,
                data: {
                    by: {
                        displayName: displayName,
                        __typename: prevTypename
                    },
                    when: newWhen,
                    __typename: 'Version'
                }
            });
        } catch  {
        // silently fail write to cache
        }
    };
    const updateTimestampCacheWithCallback = (0, $42omo.useCallback)(updateTimestampCache, [
        currentPageContentId,
        isOnEditRoute,
        displayName,
        readLastEditedDraftVersionFragmentFragmentInterop,
        readLastEditedVersionFragmentFragmentInterop,
        writeLastEditedDraftVersionFragmentFragmentInterop,
        writeLastEditedVersionFragmentFragmentInterop
    ]);
    if ((0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true)) return updateTimestampCacheWithCallback;
    return updateTimestampCache;
};
module.exports["useUpdateLastEditedTimestampVersionCache"] = $42cdb37fcd4a7f68$export$751dd0cb1bbd0638;

});

parcelRegister("hm7Pp", function(module, exports) {
/**
 * @generated SignedSource<<79b8869ae8758daa9bc9ae47cdbe0284>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03557d594dff4afc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$03557d594dff4afc$var$node.hash = "c18ed3f2e877d3ca1cd623e5a0859ba4";
var $03557d594dff4afc$export$2e2bcd8739ae039 = $03557d594dff4afc$var$node;
module.exports["default"] = $03557d594dff4afc$export$2e2bcd8739ae039;

});

parcelRegister("fgrom", function(module, exports) {
/**
 * @generated SignedSource<<eb715cbaa870e495a1eb2a68624a3c40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61389ca52d0a73e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$61389ca52d0a73e1$var$node.hash = "f2546d473e081d7f407ad1cb2c10a7c2";
var $61389ca52d0a73e1$export$2e2bcd8739ae039 = $61389ca52d0a73e1$var$node;
module.exports["default"] = $61389ca52d0a73e1$export$2e2bcd8739ae039;

});

parcelRegister("1dRHU", function(module, exports) {
/**
 * @generated SignedSource<<469fe079691d1e2689c7111ac9e94a51>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $342531e247c7cf4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$342531e247c7cf4b$var$node.hash = "e1d2099945c80fbb0be34791a561397b";
var $342531e247c7cf4b$export$2e2bcd8739ae039 = $342531e247c7cf4b$var$node;
module.exports["default"] = $342531e247c7cf4b$export$2e2bcd8739ae039;

});

parcelRegister("ej7SU", function(module, exports) {
/**
 * @generated SignedSource<<8828c568dea0c80d73da4a83dabb66bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4982d7036fccc1ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$4982d7036fccc1ba$var$node.hash = "52ad41feb7c48850dc9ff2da1dd55879";
var $4982d7036fccc1ba$export$2e2bcd8739ae039 = $4982d7036fccc1ba$var$node;
module.exports["default"] = $4982d7036fccc1ba$export$2e2bcd8739ae039;

});

parcelRegister("14ugT", function(module, exports) {

var $at96P = parcelRequire("at96P");


var $iEC7X = parcelRequire("iEC7X");


var $lwpIT = parcelRequire("lwpIT");


var $3om4W = parcelRequire("3om4W");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $irVI7 = parcelRequire("irVI7");


var $3XjWl = parcelRequire("3XjWl");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

parcelRequire("8nle6");
var $jLyos = parcelRequire("jLyos");

const $20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID = 'move-to-personal-space-flag';
// All global create dropdown flows share this prefix in their `source` URL param.
const $20ab76b3ff88654d$var$GLOBAL_CREATE_DROPDOWN_PREFIX = 'globalCreateDropdown';
/**
 * Returns the create experience name for the given content type.
 * Each content type has its own tracked experience during creation.
 */ function $20ab76b3ff88654d$var$getCreateExperienceName(contentType) {
    switch(contentType){
        case 'page':
        case 'blogpost':
            return 0, $irVI7.CREATE_PAGE_EXPERIENCE;
        case 'whiteboard':
            return 0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE;
        case 'database':
            return 0, $irVI7.CREATE_DATABASE_EXPERIENCE;
        default:
            return '';
    }
}
function $20ab76b3ff88654d$var$getPostMoveUrl(contentType, spaceKey, contentId, isLivePage = false) {
    if (isLivePage) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    switch(contentType){
        case 'blogpost':
            return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                spaceKey: spaceKey,
                contentType: 'blog',
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        default:
            return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                spaceKey: spaceKey,
                contentType: 'pages',
                contentId: contentId
            });
    }
}
// Module-level set to track which contentIds have already shown the flag this session.
// Prevents re-showing after component remounts (e.g. navigation away and back).
// Resets on full page refresh — same lifecycle as the experience tracker state.
const $20ab76b3ff88654d$var$shownContentIds = new Set();
const $20ab76b3ff88654d$export$907f7ef55acee39a = $20ab76b3ff88654d$var$shownContentIds;
/**
 * Returns an ICU select key for the given content type.
 * Used as the {contentType} variable in i18n messages that use ICU select syntax
 * so translators can provide locale-specific labels for each content type.
 */ function $20ab76b3ff88654d$var$getContentTypeKey(contentType, isLivePage) {
    if (isLivePage) return 'liveDoc';
    switch(contentType){
        case 'page':
            return 'page';
        case 'blogpost':
            return 'blog';
        case 'whiteboard':
            return 'whiteboard';
        case 'database':
            return 'database';
        default:
            return 'other';
    }
}
const $20ab76b3ff88654d$var$i18nMessages = (0, $aXWIB.defineMessages)({
    flagTitle: {
        id: "content-types-utils.move-to-personal-space-flag.title",
        defaultMessage: "Do you want to move this to your own space?"
    },
    flagDescription: {
        id: "content-types-utils.move-to-personal-space-flag.description",
        defaultMessage: "This {contentType, select, page {page} blog {blog} whiteboard {whiteboard} database {database} liveDoc {live doc} other {content}} was created in a shared space. You can move it to your personal space instead."
    },
    moveAction: {
        id: "content-types-utils.move-to-personal-space-flag.move-action",
        defaultMessage: "Move to my space"
    },
    keepAction: {
        id: "content-types-utils.move-to-personal-space-flag.keep-action",
        defaultMessage: "Keep here"
    },
    moveSuccessTitle: {
        id: "content-types-utils.move-to-personal-space-flag.move-success-title",
        defaultMessage: "{contentType, select, page {Page} blog {Blog} whiteboard {Whiteboard} database {Database} liveDoc {Live doc} other {Content}} moved to your space"
    },
    moveErrorTitle: {
        id: "content-types-utils.move-to-personal-space-flag.move-error-title",
        defaultMessage: "Couldn't move {contentType, select, page {page} blog {blog} whiteboard {whiteboard} database {database} liveDoc {live doc} other {content}}"
    },
    moveErrorDescription: {
        id: "content-types-utils.move-to-personal-space-flag.move-error-description",
        defaultMessage: "Something went wrong. Please try moving it manually."
    }
});
const $20ab76b3ff88654d$var$MOVE_PAGE_APPEND_MUTATION = (0, $3om4W.default);
const $20ab76b3ff88654d$var$MOVE_PAGE_TOP_LEVEL_MUTATION = (0, $lwpIT.default);
const $20ab76b3ff88654d$var$MOVE_BLOG_MUTATION = (0, $iEC7X.default);
const $20ab76b3ff88654d$var$SPACE_HOMEPAGE_QUERY = (0, $at96P.default);
const $20ab76b3ff88654d$var$MoveToPersonalSpaceFlagTriggerComponent = ({ contentId: contentId, contentType: contentType, isLivePage: isLivePage, spaceKey: spaceKey, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const contentTypeKey = $20ab76b3ff88654d$var$getContentTypeKey(contentType, isLivePage);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const createExperienceName = $20ab76b3ff88654d$var$getCreateExperienceName(contentType);
    const createExperienceState = (0, $3XjWl.useExperienceState)(createExperienceName);
    // True if content was just created via the global create dropdown and the experience
    // has not failed or been aborted. Excludes page tree and space-level contextual creates.
    // Note: for pages/blogs the experience stops with taskSuccess before the editor mounts,
    // so we allow taskSuccess stops and only guard against taskFail and taskAbort.
    const isNewlyGloballyCreated = !!createExperienceState && createExperienceState.stopState !== 'taskFail' && createExperienceState.stopState !== 'taskAbort' && createExperienceState.attributes?.flow?.startsWith($20ab76b3ff88654d$var$GLOBAL_CREATE_DROPDOWN_PREFIX);
    // Re-use the preloaded personal space query — this data is preloaded during
    // preloadHomeRoute so it should be available in cache instantly.
    // Skip the query entirely when the page is not newly created to avoid
    // unnecessary network requests on regular page visits.
    const { data: personalSpaceDetailsData, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $jLyos.preloadPersonalSpaceDetailsQuery), {
        skip: !isNewlyGloballyCreated
    });
    // If the user has a personal space, space will be non-null with a key and id.
    // If personal spaces are disabled or user hasn't created one, space will be null.
    const personalSpaceKey = personalSpaceDetailsData?.user?.confluence?.space?.key ?? null;
    const personalSpaceId = personalSpaceDetailsData?.user?.confluence?.space?.id ?? null;
    const hasPersonalSpace = personalSpaceKey !== null && personalSpaceId !== null;
    // Fetch the homepage (overview) page of the user's personal space so we can
    // move the content under it instead of at the space root level
    const { data: homepageData, loading: homepageLoading } = (0, $jMyy4.useQueryInterop)($20ab76b3ff88654d$var$SPACE_HOMEPAGE_QUERY, {
        variables: {
            spaceKey: personalSpaceKey || ''
        },
        skip: !isNewlyGloballyCreated || !hasPersonalSpace
    });
    const personalSpaceHomepageId = homepageData?.space?.homepage?.id ?? null;
    const [movePageAppend] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_PAGE_APPEND_MUTATION);
    const [movePageTopLevel] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_PAGE_TOP_LEVEL_MUTATION);
    const [moveBlog] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_BLOG_MUTATION);
    // Use refs to avoid stale closures in flag action callbacks
    const personalSpaceKeyRef = (0, $42omo.useRef)(personalSpaceKey);
    personalSpaceKeyRef.current = personalSpaceKey;
    const personalSpaceIdRef = (0, $42omo.useRef)(personalSpaceId);
    personalSpaceIdRef.current = personalSpaceId;
    const personalSpaceHomepageIdRef = (0, $42omo.useRef)(personalSpaceHomepageId);
    personalSpaceHomepageIdRef.current = personalSpaceHomepageId;
    const moveContent = (0, $42omo.useCallback)(async ()=>{
        const homepageId = personalSpaceHomepageIdRef.current;
        const targetSpaceId = personalSpaceIdRef.current;
        const targetSpaceKey = personalSpaceKeyRef.current;
        switch(contentType){
            case 'blogpost':
                {
                    if (!targetSpaceId) return null;
                    // blogPostId and spaceId are typed as Long! but come as strings — cast as any
                    // to match the pattern used in MoveBlogModal
                    const moveBlogResult = await moveBlog({
                        variables: {
                            blogPostId: contentId,
                            spaceId: targetSpaceId
                        }
                    });
                    return moveBlogResult?.data?.moveBlog?.content?.id ?? null;
                }
            case 'database':
            case 'whiteboard':
            case 'page':
                {
                    if (homepageId) {
                        // Move under the overview/homepage page if it exists
                        const movePageAppendResult = await movePageAppend({
                            variables: {
                                pageId: contentId,
                                parentId: homepageId
                            }
                        });
                        return movePageAppendResult?.data?.movePageAppend?.page?.id ?? null;
                    }
                    if (!targetSpaceKey) return null;
                    // Fall back to top-level move if no homepage exists
                    const movePageTopLevelResult = await movePageTopLevel({
                        variables: {
                            pageId: contentId,
                            spaceKey: targetSpaceKey
                        }
                    });
                    return movePageTopLevelResult?.data?.movePageTopLevel?.page?.id ?? null;
                }
            default:
                return null;
        }
    }, [
        contentType,
        contentId,
        moveBlog,
        movePageAppend,
        movePageTopLevel
    ]);
    const handleMoveToPersonalSpace = (0, $42omo.useCallback)(async ()=>{
        const targetSpaceKey = personalSpaceKeyRef.current;
        flags.hideFlag($20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'moveToPersonalSpaceConfirm',
                source: 'moveToPersonalSpaceFlag',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey,
                    targetSpaceKey: targetSpaceKey
                }
            }
        }).fire();
        try {
            const movedPageId = await moveContent();
            if (!movedPageId || !targetSpaceKey) throw new Error('Missing move result or target space key');
            flags.showSuccessFlag({
                id: 'move-to-personal-space-success-flag',
                title: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveSuccessTitle, {
                    contentType: contentTypeKey
                }),
                isAutoDismiss: true
            });
            push($20ab76b3ff88654d$var$getPostMoveUrl(contentType, targetSpaceKey, movedPageId, isLivePage));
        } catch  {
            flags.showErrorFlag({
                id: 'move-to-personal-space-error-flag',
                title: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveErrorTitle, {
                    contentType: contentTypeKey
                }),
                description: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveErrorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        flags,
        formatMessage,
        createAnalyticsEvent,
        moveContent,
        push,
        contentId,
        spaceKey,
        contentType,
        isLivePage,
        contentTypeKey
    ]);
    const handleKeepHere = (0, $42omo.useCallback)(()=>{
        flags.hideFlag($20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'moveToPersonalSpaceDismiss',
                source: 'moveToPersonalSpaceFlag',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        flags,
        createAnalyticsEvent,
        contentId,
        spaceKey
    ]);
    const showFlag = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'moveToPersonalSpaceFlagScreen',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey
                }
            }
        }).fire();
        flags.showInfoFlag({
            id: $20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID,
            title: formatMessage($20ab76b3ff88654d$var$i18nMessages.flagTitle),
            description: formatMessage($20ab76b3ff88654d$var$i18nMessages.flagDescription, {
                contentType: contentTypeKey
            }),
            actions: [
                {
                    content: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveAction),
                    onClick: handleMoveToPersonalSpace
                },
                {
                    content: formatMessage($20ab76b3ff88654d$var$i18nMessages.keepAction),
                    onClick: handleKeepHere
                }
            ]
        });
    }, [
        flags,
        formatMessage,
        createAnalyticsEvent,
        contentId,
        spaceKey,
        handleMoveToPersonalSpace,
        handleKeepHere,
        contentTypeKey
    ]);
    (0, $42omo.useEffect)(()=>{
        // Only trigger for newly created pages, and wait for all data to be ready
        if (!isNewlyGloballyCreated || loading || homepageLoading || !contentId || !spaceKey) return;
        // Don't show duplicate flags for the same contentId (survives remounts via module-level Set)
        if ($20ab76b3ff88654d$var$shownContentIds.has(contentId)) return;
        // Don't show if user doesn't have a personal space (personal spaces disabled)
        if (!hasPersonalSpace) return;
        // Don't show if content was created in a personal space (starts with ~)
        if (spaceKey.startsWith('~')) return;
        // Don't show if content was created in the user's personal space
        if (spaceKey === personalSpaceKey) return;
        $20ab76b3ff88654d$var$shownContentIds.add(contentId);
        showFlag();
    }, [
        isNewlyGloballyCreated,
        loading,
        homepageLoading,
        contentId,
        spaceKey,
        hasPersonalSpace,
        personalSpaceKey,
        showFlag
    ]);
    return null;
};
const $20ab76b3ff88654d$export$f3508a833a19ce8c = (0, $7aRa9.withFlags)($20ab76b3ff88654d$var$MoveToPersonalSpaceFlagTriggerComponent);
module.exports["MoveToPersonalSpaceFlagTrigger"] = $20ab76b3ff88654d$export$f3508a833a19ce8c;

});

parcelRegister("at96P", function(module, exports) {
/**
 * @generated SignedSource<<f2bae6422f31240cf2bca7254f8d2a2e>>
 * @relayHash 4b5e9dde5572ad2b72b3d90ce64b430b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39a3fc8907cb86d55c6ae136031c14763a4ab02065d1f2219030a30119b932af
const $4fa5689684608def$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4b5e9dde5572ad2b72b3d90ce64b430b",
            "id": "39a3fc8907cb86d55c6ae136031c14763a4ab02065d1f2219030a30119b932af",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "operationKind": "query",
            "text": "query MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery($spaceKey:String!){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$4fa5689684608def$var$node.hash = "b2693b9e2134a1e0b43171db1726ae37";
var $4fa5689684608def$export$2e2bcd8739ae039 = $4fa5689684608def$var$node;
module.exports["default"] = $4fa5689684608def$export$2e2bcd8739ae039;

});

parcelRegister("iEC7X", function(module, exports) {
/**
 * @generated SignedSource<<34176bcddb8c0db6c90433f2b33037a9>>
 * @relayHash a681ca4341eb62abd94f1e002744692a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f19dca02a8c6c08d36848966e224cc2b9ece80fd54f2c467d2e7b7657bc7699
const $f919ec06c3c52f3b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "blogPostId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "targetSpaceId",
                    "variableName": "spaceId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "alias"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "MoveBlogPayload",
                    "kind": "LinkedField",
                    "name": "moveBlog",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "MoveBlogPayload",
                    "kind": "LinkedField",
                    "name": "moveBlog",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a681ca4341eb62abd94f1e002744692a",
            "id": "8f19dca02a8c6c08d36848966e224cc2b9ece80fd54f2c467d2e7b7657bc7699",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMoveBlogMutation($blogPostId:Long!,$spaceId:Long!){moveBlog(input:{blogPostId:$blogPostId,targetSpaceId:$spaceId}){content{id,space{key,alias,id}}}}"
        }
    };
}();
$f919ec06c3c52f3b$var$node.hash = "93b9a44f4c2595f8a579191b1566d4aa";
var $f919ec06c3c52f3b$export$2e2bcd8739ae039 = $f919ec06c3c52f3b$var$node;
module.exports["default"] = $f919ec06c3c52f3b$export$2e2bcd8739ae039;

});

parcelRegister("lwpIT", function(module, exports) {
/**
 * @generated SignedSource<<75bc76948dcf24826cd019d8c3943e16>>
 * @relayHash f7117689bdd81ee360f2b94043895ce4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b2d43333b298e4930cccff4151dc09b53b23a75941daf6c976d142b379957e2
const $92d8d4dd49e2504c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "targetSpaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageTopLevel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f7117689bdd81ee360f2b94043895ce4",
            "id": "3b2d43333b298e4930cccff4151dc09b53b23a75941daf6c976d142b379957e2",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id}}}"
        }
    };
}();
$92d8d4dd49e2504c$var$node.hash = "55c2c510926003ccb21aa81ad404b906";
var $92d8d4dd49e2504c$export$2e2bcd8739ae039 = $92d8d4dd49e2504c$var$node;
module.exports["default"] = $92d8d4dd49e2504c$export$2e2bcd8739ae039;

});

parcelRegister("3om4W", function(module, exports) {
/**
 * @generated SignedSource<<0f070f6cea199c95d239dfe94eeaab49>>
 * @relayHash af579b7ccd18225f53e0ba7e5997759c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a304af1dcdc7cca397f23a09fa40f823a65f467687010593a4d8d90c922bb448
const $4e5e2421f46e2759$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "parentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAppend",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "af579b7ccd18225f53e0ba7e5997759c",
            "id": "a304af1dcdc7cca397f23a09fa40f823a65f467687010593a4d8d90c922bb448",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMovePageAppendMutation($pageId:ID!,$parentId:ID!){movePageAppend(input:{pageId:$pageId,parentId:$parentId}){page{id}}}"
        }
    };
}();
$4e5e2421f46e2759$var$node.hash = "79cbc17b214968c2ed046eeef92a15d0";
var $4e5e2421f46e2759$export$2e2bcd8739ae039 = $4e5e2421f46e2759$var$node;
module.exports["default"] = $4e5e2421f46e2759$export$2e2bcd8739ae039;

});

parcelRegister("3XjWl", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $a5d6810b007644fc$export$4a4fb33de7d01f75 = (experienceName)=>{
    const $ = (0, $frIzR.c)(7);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t0;
    if ($[0] !== experienceName || $[1] !== experienceTracker) {
        t0 = experienceTracker.getExperienceState(experienceName);
        $[0] = experienceName;
        $[1] = experienceTracker;
        $[2] = t0;
    } else t0 = $[2];
    const [experienceState, setExperienceState] = (0, $42omo.useState)(t0);
    let t1;
    let t2;
    if ($[3] !== experienceName || $[4] !== experienceTracker) {
        t1 = ()=>experienceTracker.subscribe((e)=>{
                if (e.name === experienceName) setExperienceState(experienceTracker.getExperienceState(experienceName));
            });
        t2 = [
            experienceName,
            experienceTracker
        ];
        $[3] = experienceName;
        $[4] = experienceTracker;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $42omo.useEffect)(t1, t2);
    return experienceState;
};
module.exports["useExperienceState"] = $a5d6810b007644fc$export$4a4fb33de7d01f75;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);

var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '')=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: (0, $6mKj3.expVal)('aifc_space_typeSettings', 'isEnabled', false)
        }
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '')=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<8c1a55dfb419e6d6f54156fff7f33a1c>>
 * @relayHash b1b0a620158868bcb3097f7e64a244c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a1d17515e1fb690dbf5fe3eb1e13c307177dbb996cb2b63f61f4a76aac6006a
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "b1b0a620158868bcb3097f7e64a244c4",
            "id": "2a1d17515e1fb690dbf5fe3eb1e13c307177dbb996cb2b63f61f4a76aac6006a",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "26bee6732f3eb74dc67a3b0c0b99c4b3";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<02d29beca2cb9366deb48db0e552c3e7>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("bgmQP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3hOY6 = parcelRequire("3hOY6");

var $6T8v4 = parcelRequire("6T8v4");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $g5lKx = parcelRequire("g5lKx");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $aXWIB.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_zulp1b66 _1e0c1txw _2lx21bp4"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $g5lKx.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $g5lKx.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6T8v4.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("kSPGK", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $frIzR.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("3y90h", function(module, exports) {

let $295b87ff6e69ddb5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $295b87ff6e69ddb5$var$load("jDjSj"),
    $295b87ff6e69ddb5$var$load("d9TJ0"),
    $295b87ff6e69ddb5$var$load("cgmWe"),
    $295b87ff6e69ddb5$var$load("1wZEW"),
    $295b87ff6e69ddb5$var$load("2B6wT"),
    $295b87ff6e69ddb5$var$load("gKYwM"),
    $295b87ff6e69ddb5$var$load("nFBKt"),
    $295b87ff6e69ddb5$var$load("3L4o4"),
    $295b87ff6e69ddb5$var$load("iJogx"),
    $295b87ff6e69ddb5$var$load("lPQcc"),
    $295b87ff6e69ddb5$var$load("e68tO"),
    $295b87ff6e69ddb5$var$load("7cDV0"),
    $295b87ff6e69ddb5$var$load("ijD5W"),
    $295b87ff6e69ddb5$var$load("3JSgG"),
    $295b87ff6e69ddb5$var$load("4pqtR"),
    $295b87ff6e69ddb5$var$load("5XqRg"),
    $295b87ff6e69ddb5$var$load("dChec"),
    $295b87ff6e69ddb5$var$load("2YffH"),
    $295b87ff6e69ddb5$var$load("3RdRc"),
    $295b87ff6e69ddb5$var$load("98UJI"),
    $295b87ff6e69ddb5$var$load("b0cmi"),
    $295b87ff6e69ddb5$var$load("51haJ"),
    $295b87ff6e69ddb5$var$load("eBRUf"),
    $295b87ff6e69ddb5$var$load("jg5LT"),
    $295b87ff6e69ddb5$var$load("9wzNh"),
    $295b87ff6e69ddb5$var$load("7f9Fz"),
    $295b87ff6e69ddb5$var$load("9ldRJ"),
    $295b87ff6e69ddb5$var$load("6iz6l"),
    $295b87ff6e69ddb5$var$load("4SCW2"),
    $295b87ff6e69ddb5$var$load("aXHNO"),
    $295b87ff6e69ddb5$var$load("kmvek"),
    $295b87ff6e69ddb5$var$load("Wowvf"),
    $295b87ff6e69ddb5$var$load("6wr18"),
    $295b87ff6e69ddb5$var$load("kjZZD"),
    $295b87ff6e69ddb5$var$load("ffEVr"),
    $295b87ff6e69ddb5$var$load("7EorR"),
    $295b87ff6e69ddb5$var$load("9AXkC"),
    $295b87ff6e69ddb5$var$load("28arV"),
    $295b87ff6e69ddb5$var$load("hhss7"),
    $295b87ff6e69ddb5$var$load("f35QR"),
    $295b87ff6e69ddb5$var$load("eVYW1"),
    $295b87ff6e69ddb5$var$load("ls0Um"),
    $295b87ff6e69ddb5$var$load("020xd"),
    $295b87ff6e69ddb5$var$load("eTBsW"),
    $295b87ff6e69ddb5$var$load("bYxCZ"),
    $295b87ff6e69ddb5$var$load("6HBYC"),
    $295b87ff6e69ddb5$var$load("eDqo1"),
    $295b87ff6e69ddb5$var$load("1oiJ6"),
    $295b87ff6e69ddb5$var$load("huUvS"),
    $295b87ff6e69ddb5$var$load("bTmOC"),
    $295b87ff6e69ddb5$var$load("8j9XC"),
    $295b87ff6e69ddb5$var$load("lFZaH"),
    $295b87ff6e69ddb5$var$load("byA95"),
    $295b87ff6e69ddb5$var$load("6nDfv"),
    $295b87ff6e69ddb5$var$load("keUAv")
]).then(()=>parcelRequire('jeJjF'));

});

parcelRegister("4cOi8", function(module, exports) {
var $c7f67cb608b5916f$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $c7f67cb608b5916f$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $c7f67cb608b5916f$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $c7f67cb608b5916f$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $c7f67cb608b5916f$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c7f67cb608b5916f$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $c7f67cb608b5916f$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $c7f67cb608b5916f$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $c7f67cb608b5916f$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $c7f67cb608b5916f$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $c7f67cb608b5916f$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $c7f67cb608b5916f$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $c7f67cb608b5916f$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $c7f67cb608b5916f$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $c7f67cb608b5916f$export$a6e645fda5339bf8;
module.exports["Height"] = $c7f67cb608b5916f$export$8954cfac7c08d16a;
module.exports["Alignment"] = $c7f67cb608b5916f$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $c7f67cb608b5916f$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $c7f67cb608b5916f$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $c7f67cb608b5916f$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $c7f67cb608b5916f$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $c7f67cb608b5916f$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $c7f67cb608b5916f$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $c7f67cb608b5916f$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $c7f67cb608b5916f$export$bf7ebf7fed6e7189;

});

parcelRegister("cQhbe", function(module, exports) {
var $3ddd96eb421fb45c$export$c184dc244f9dacf4 = /*#__PURE__*/ function(AutoConvertEvent) {
    AutoConvertEvent["VIEWED"] = "pageViewed";
    AutoConvertEvent["EDITED"] = "pageEdited";
    AutoConvertEvent["PUBLISHED"] = "pagePublished";
    AutoConvertEvent["NOTIFICATION_SHOWN"] = "notificationShown";
    AutoConvertEvent["NOTIFICATION_ERROR"] = "notificationError";
    return AutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$a248ed70ead7ff08 = /*#__PURE__*/ function(AutoConvertActionSubject) {
    AutoConvertActionSubject["AUTO_CONVERSION"] = "autoConversion";
    AutoConvertActionSubject["AUTO_CONVERSION_BYLINE"] = "autoConversionByLine";
    return AutoConvertActionSubject;
}({});
var $3ddd96eb421fb45c$export$d8b435b7aa875953 = /*#__PURE__*/ function(RevertAutoConvertEvent) {
    RevertAutoConvertEvent["DIALOG_OPEN"] = "revertDialogOpen";
    RevertAutoConvertEvent["CLICKED"] = "revertClicked";
    RevertAutoConvertEvent["CANCELLED"] = "revertCancelled";
    RevertAutoConvertEvent["CONFIRMED"] = "revertConfirmed";
    RevertAutoConvertEvent["ERROR"] = "revertError";
    return RevertAutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$b22548c36d783030 = /*#__PURE__*/ function(AutoConvertPanelEvent) {
    AutoConvertPanelEvent["VIEWED"] = "panelViewed";
    AutoConvertPanelEvent["SUPPORTED"] = "panelSupported";
    AutoConvertPanelEvent["NONE"] = "panelNone";
    AutoConvertPanelEvent["GET_ERROR"] = "panelGetError";
    AutoConvertPanelEvent["SET_ERROR"] = "panelSetError";
    return AutoConvertPanelEvent;
}({});
var $3ddd96eb421fb45c$export$e8dbd545dc7c3af0 = /*#__PURE__*/ function(AutoConversionByLineEvent) {
    AutoConversionByLineEvent["CLICKED"] = "bylineClicked";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_OPENED"] = "newEditorModalOpened";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_CLOSED"] = "newEditorModalClosed";
    return AutoConversionByLineEvent;
}({});
const $3ddd96eb421fb45c$export$b4535793cfa6d80a = (createAnalyticsEvent, analytics, actionSubject)=>{
    const { pageAction: pageAction, source: source, setting: setting } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'triggered',
            actionSubject: actionSubject,
            source: source,
            actionSubjectId: 'page',
            attributes: {
                pageAction: pageAction,
                setting: setting
            }
        }
    }).fire();
};
const $3ddd96eb421fb45c$export$e045315387fc4262 = (createAnalyticsEvent, analytics)=>{
    const { level: level, panelAction: panelAction, source: source } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'autoConversion',
            source: source,
            actionSubjectId: 'panel',
            attributes: {
                level: level,
                panelAction: panelAction
            }
        }
    }).fire();
};
module.exports["AutoConvertEvent"] = $3ddd96eb421fb45c$export$c184dc244f9dacf4;
module.exports["AutoConvertActionSubject"] = $3ddd96eb421fb45c$export$a248ed70ead7ff08;
module.exports["RevertAutoConvertEvent"] = $3ddd96eb421fb45c$export$d8b435b7aa875953;
module.exports["AutoConvertPanelEvent"] = $3ddd96eb421fb45c$export$b22548c36d783030;
module.exports["AutoConversionByLineEvent"] = $3ddd96eb421fb45c$export$e8dbd545dc7c3af0;
module.exports["sendEditorConversionAnalyticsPageEvent"] = $3ddd96eb421fb45c$export$b4535793cfa6d80a;
module.exports["sendEditorConversionAnalyticsPanelEvent"] = $3ddd96eb421fb45c$export$e045315387fc4262;

});

parcelRegister("sLZsl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9e73f43295b80088$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        isAutoConverted: false
    },
    actions: {
        setIsAutoConverted: (isAutoConverted)=>({ setState: setState })=>{
                setState({
                    isAutoConverted: isAutoConverted
                });
            }
    },
    name: 'isAutoConverted'
});
const $9e73f43295b80088$var$getAutoConvertState = (state)=>{
    return state.isAutoConverted;
};
const $9e73f43295b80088$export$dc84155a8aa7f285 = (0, $9zUhf.createHook)($9e73f43295b80088$var$Store, {
    selector: $9e73f43295b80088$var$getAutoConvertState
});
module.exports["useAutoConvertState"] = $9e73f43295b80088$export$dc84155a8aa7f285;

});

parcelRegister("gabmL", function(module, exports) {

var $9eNhQ = parcelRequire("9eNhQ");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $jMyy4 = parcelRequire("jMyy4");


var $hC6vw = parcelRequire("hC6vw");


var $1X7PR = parcelRequire("1X7PR");


var $bgRei = parcelRequire("bgRei");

const $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES = [
    'This is a Standard/Premium feature. You are currently subscribed to the Free plan.',
    'Anonymous access is not permitted'
];
const $b34fb09a67265b07$var$i18n = (0, $aXWIB.defineMessages)({
    publicLinkUrlPathError: {
        id: "public-links.usePublicLinkDataProvider.sharePathError.message",
        defaultMessage: "publicLinkStatus was ON, but no publicLinkUrlPath was provided"
    }
});
const $b34fb09a67265b07$var$computeData = (pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)=>{
    // Are Public Links allowed for this content type
    const isPublicLinkAllowedForContentType = !contentData.error && contentData.data !== undefined && enrolledContentTypes.includes(contentData.data.contentType);
    // Are Editable Public Links allowed for this content type
    const isPublicLinkEditAllowedForContentType = isPublicLinkAllowedForContentType && edition === (0, $euL71.ConfluenceEdition).PREMIUM && contentData.data?.contentType === 'whiteboard';
    // Can current user edit Public Link status
    const canEditPublicLink = !contentData.error && contentData.data?.canEditPublicLink === true;
    // Value for if the Public Link has edit permissions i.e. Editable Public Whiteboards
    const isEditPublicLink = !!(!permissionsData.error && permissionsData.data?.hasEditPermission);
    // Are Public Links enabled by admins at Site and Space levels
    const isPublicLinkAdminEnabled = isPublicLinkStatusOnForContent || !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).OFF;
    // Is Public Link allowed for content type, admin enabled, and status ON
    const isPublicLinkFullyEnabled = isPublicLinkStatusOnForContent && isPublicLinkAdminEnabled && isPublicLinkAllowedForContentType;
    const refetch = (dataToFetch = 'all')=>{
        // if dataToFetch !== permission, it means it's either all or public-link
        if (dataToFetch !== 'permission') pageData.refetch();
        // if dataToFetch !== public-link, it means it's either all or permission
        if (dataToFetch !== 'public-link') isPublicLinkEditAllowedForContentType && permissionsData.refetch();
    };
    return {
        isPublicLinkAdminEnabled: isPublicLinkAdminEnabled,
        isPublicLinkFullyEnabled: isPublicLinkFullyEnabled,
        isPublicLinkAllowedForContentType: isPublicLinkAllowedForContentType,
        isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType,
        isEditPublicLink: isEditPublicLink,
        canEditPublicLink: canEditPublicLink,
        publicLinkStatus: pageData.data?.pageStatus,
        publicLinkSharePath: pageData.data?.publicLinkUrlPath,
        refetch: refetch
    };
};
const $b34fb09a67265b07$export$4725159de576f61f = (props)=>{
    const publicLinkData = $b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: props.contentId,
        ...props
    });
    return publicLinkData.isLoading ? {
        isPublicLinkFullyEnabled: false,
        isPublicLinkAdminEnabled: false,
        isPublicLinkAllowedForContentType: false,
        isPublicLinkEditAllowedForContentType: false,
        canEditPublicLink: false,
        publicLinkStatus: undefined,
        publicLinkSharePath: undefined,
        isEditPublicLink: false,
        refetch: ()=>{},
        ...publicLinkData
    } : publicLinkData;
};
const $b34fb09a67265b07$export$b7ccc28cc819be23 = (props)=>{
    const enrolledContentTypes = [
        'page',
        'whiteboard'
    ];
    const intl = (0, $aXWIB.useIntl)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    let contentData = (0, $1X7PR.usePublicLinkContentQuery)({
        contentId: props.pageId,
        skip: props.contentQueryProps?.skip
    });
    const contentType = props.contentQueryProps?.skip ? props.contentQueryProps?.contentType : contentData?.data?.contentType;
    contentData = {
        ...contentData,
        data: {
            ...contentData?.data,
            canEditPublicLink: contentData?.data?.canEditPublicLink ?? false,
            contentType: contentType ?? ''
        }
    };
    const shouldSkip = props.skip || !enrolledContentTypes.includes(contentData?.data?.contentType || '') || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE;
    const rawPageData = (0, $jMyy4.useQueryInterop)((0, $9eNhQ.default), {
        variables: {
            pageId: props.pageId
        },
        fetchPolicy: props.fetchPolicy,
        skip: shouldSkip
    });
    const permissionsData = (0, $bgRei.usePublicLinkPermissionsForObject)({
        objectId: props.pageId,
        skip: shouldSkip || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || contentData?.data?.contentType !== 'whiteboard'
    });
    const pageData = (0, $42omo.useMemo)(()=>({
            isLoading: rawPageData.loading,
            data: rawPageData.data?.publicLinkPage,
            error: rawPageData.error,
            refetch: rawPageData.refetch
        }), [
        rawPageData.loading,
        rawPageData.data,
        rawPageData.error,
        rawPageData.refetch
    ]);
    if ((0, $1uFM6.isUnauthorizedError)(rawPageData.error) || // We currently aren't being given error types by the backend.
    // When we do, we can better parse these expected errors.
    // https://product-fabric.atlassian.net/browse/CPE-1991
    $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES.some((msg)=>rawPageData.error?.message?.includes(msg))) (0, $7Sm4c.markErrorAsHandled)(rawPageData.error);
    // Is Public Link Status for page ON
    const isPublicLinkStatusOnForContent = !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).ON;
    const loading = pageData.isLoading || contentData.isLoading || permissionsData.isLoading;
    const errors = (0, $42omo.useMemo)(()=>[
            pageData,
            contentData,
            permissionsData
        ].map((query)=>!query.isLoading && query.error).filter((err)=>Boolean(err)), [
        pageData,
        contentData,
        permissionsData
    ]);
    if (isPublicLinkStatusOnForContent && pageData.data?.publicLinkUrlPath === null) errors.push(new Error(intl.formatMessage($b34fb09a67265b07$var$i18n.publicLinkUrlPathError)));
    return loading ? {
        isLoading: true,
        errors: errors
    } : {
        isLoading: false,
        errors: errors,
        ...$b34fb09a67265b07$var$computeData(pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)
    };
};
const $b34fb09a67265b07$export$b86a4cadf4c50ae1 = ({ contentId: contentId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children($b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: contentId
    })));
module.exports["usePublicLinkData"] = $b34fb09a67265b07$export$4725159de576f61f;
module.exports["usePublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b7ccc28cc819be23;
module.exports["PublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b86a4cadf4c50ae1;

});

parcelRegister("9eNhQ", function(module, exports) {
/**
 * @generated SignedSource<<d949c2178560b24617fa214625d9924b>>
 * @relayHash 3f5a736f4dd660a89b02a4452e465d11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184
const $858700f9e1edfc48$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "concreteType": "PublicLinkPage",
            "kind": "LinkedField",
            "name": "publicLinkPage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "pageStatus"
                },
                {
                    "kind": "ScalarField",
                    "name": "publicLinkUrlPath"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3f5a736f4dd660a89b02a4452e465d11",
            "id": "d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184",
            "metadata": {},
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId,pageStatus,publicLinkUrlPath}}"
        }
    };
}();
$858700f9e1edfc48$var$node.hash = "c030204610be720b223484d4a8d871cf";
var $858700f9e1edfc48$export$2e2bcd8739ae039 = $858700f9e1edfc48$var$node;
module.exports["default"] = $858700f9e1edfc48$export$2e2bcd8739ae039;

});

parcelRegister("hC6vw", function(module, exports) {
/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d0a960900d3ff81b$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});
module.exports["PublicLinkPageStatus"] = $d0a960900d3ff81b$export$cb24eb3958583602;

});

parcelRegister("1X7PR", function(module, exports) {

var $OoVEI = parcelRequire("OoVEI");


var $42omo = parcelRequire("42omo");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $cLo2u = parcelRequire("cLo2u");


var $foQ4a = parcelRequire("foQ4a");


var $jMyy4 = parcelRequire("jMyy4");

const $3e0fb5c21944a86f$var$computeData = (data, isExternalCollaborator)=>{
    const contentType = data?.content?.nodes?.[0]?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const isSpaceAdmin = Boolean(data?.space?.currentUser?.isAdmin);
    const canEditPage = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
    return {
        contentType: contentType,
        canEditPublicLink: (isSpaceAdmin || canEditPage) && !isExternalCollaborator
    };
};
const $3e0fb5c21944a86f$export$13a7a098bd5c2599 = (props)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $OoVEI.default), {
        skip: props.skip,
        variables: {
            contentId: props.contentId,
            hasSpaceKey: Boolean(spaceKey),
            spaceKey: spaceKey ?? ''
        }
    });
    (0, $42omo.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return loading ? {
        isLoading: true
    } : {
        isLoading: false,
        error: error,
        data: error ? undefined : $3e0fb5c21944a86f$var$computeData(data, isExternalCollaborator)
    };
};
module.exports["usePublicLinkContentQuery"] = $3e0fb5c21944a86f$export$13a7a098bd5c2599;

});

parcelRegister("OoVEI", function(module, exports) {
/**
 * @generated SignedSource<<5d7ecc81c9cd67ab11655e2c7b4680c1>>
 * @relayHash 6ab077a19d911ef98a26d3adbdc3fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da
const $77c51ddc0082b191$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSpaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "hasSpaceKey",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAdmin"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "6ab077a19d911ef98a26d3adbdc3fb56",
            "id": "d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da",
            "metadata": {},
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "operationKind": "query",
            "text": "query usePublicLinkContentQueryPublicLinkContentQuery($contentId:ID!,$spaceKey:String!,$hasSpaceKey:Boolean!){content(id:$contentId){nodes{id,type,operations{operation,targetType}}},space(key:$spaceKey)@include(if:$hasSpaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$77c51ddc0082b191$var$node.hash = "59655c56a4e7fa1ddec49b3697d04128";
var $77c51ddc0082b191$export$2e2bcd8739ae039 = $77c51ddc0082b191$var$node;
module.exports["default"] = $77c51ddc0082b191$export$2e2bcd8739ae039;

});

parcelRegister("bgRei", function(module, exports) {

var $8lkfF = parcelRequire("8lkfF");


var $42omo = parcelRequire("42omo");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");


var $j0YKV = parcelRequire("j0YKV");

const $6b8bec8977e1e896$export$c2d35981ca787f77 = ({ objectId: objectId, objectType: objectType = (0, $j0YKV.PublicLinkPermissionsObjectType).CONTENT, skip: skip })=>{
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8lkfF.default), {
        variables: {
            objectId: objectId,
            objectType: objectType
        },
        skip: skip
    });
    (0, $42omo.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    const hasEditPermission = data?.publicLinkPermissionsForObject?.permissions?.includes((0, $j0YKV.PublicLinkPermissionsType).EDIT) ?? false;
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        refetch: refetch,
        data: error ? undefined : {
            hasEditPermission: hasEditPermission,
            permissions: data?.publicLinkPermissionsForObject?.permissions ?? []
        }
    };
};
module.exports["usePublicLinkPermissionsForObject"] = $6b8bec8977e1e896$export$c2d35981ca787f77;

});

parcelRegister("8lkfF", function(module, exports) {
/**
 * @generated SignedSource<<67e7675afc07b494be8c894f710bfb17>>
 * @relayHash f71176804f0f8510a7464cc538777917
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1
const $5d187f97ac5d0d36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "objectId",
                    "variableName": "objectId"
                },
                {
                    "kind": "Variable",
                    "name": "objectType",
                    "variableName": "objectType"
                }
            ],
            "concreteType": "PublicLinkPermissions",
            "kind": "LinkedField",
            "name": "publicLinkPermissionsForObject",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "permissions"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f71176804f0f8510a7464cc538777917",
            "id": "52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1",
            "metadata": {},
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!,$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId,objectType:$objectType){permissions}}"
        }
    };
}();
$5d187f97ac5d0d36$var$node.hash = "374477f8db79649c77f638ae2ac0ca9b";
var $5d187f97ac5d0d36$export$2e2bcd8739ae039 = $5d187f97ac5d0d36$var$node;
module.exports["default"] = $5d187f97ac5d0d36$export$2e2bcd8739ae039;

});

parcelRegister("j0YKV", function(module, exports) {
/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d2563be1c2ded005$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $d2563be1c2ded005$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $d2563be1c2ded005$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $d2563be1c2ded005$export$1d899d09218cc934;

});

parcelRegister("6yCgm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


const $41e0b21c174fc489$var$MainButtonsLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4iG9v",
    name: "MainButtonsLoader",
    loader: async ()=>{
        return (await (parcelRequire("bHkhW"))).MainButtons;
    }
});

const $41e0b21c174fc489$var$MainButtonsSSRLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "g2Qnu",
    name: "MainButtonsSSRLoader",
    loader: async ()=>{
        return (await (parcelRequire("bHkhW"))).MainButtons;
    }
});
const $41e0b21c174fc489$export$f636d1325d93ee35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41e0b21c174fc489$var$MainButtonsLoader, props) : (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41e0b21c174fc489$var$MainButtonsSSRLoader, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41e0b21c174fc489$var$MainButtonsLoader, props));
const $41e0b21c174fc489$export$4fca0dd91afb40c6 = async ()=>$41e0b21c174fc489$var$MainButtonsLoader.preload();
module.exports["MainButtons"] = $41e0b21c174fc489$export$f636d1325d93ee35;
module.exports["loadMainButtons"] = $41e0b21c174fc489$export$4fca0dd91afb40c6;

});

parcelRegister("bHkhW", function(module, exports) {

let $884372b9927010af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $884372b9927010af$var$load("9zOlm"),
    $884372b9927010af$var$load("cHIVi"),
    $884372b9927010af$var$load("lUs3J"),
    $884372b9927010af$var$load("2vQEy"),
    $884372b9927010af$var$load("4pqtR"),
    $884372b9927010af$var$load("5XqRg"),
    $884372b9927010af$var$load("5wC2D"),
    $884372b9927010af$var$load("6Xh6J"),
    $884372b9927010af$var$load("3nozt"),
    $884372b9927010af$var$load("4t77a"),
    $884372b9927010af$var$load("8LtYa"),
    $884372b9927010af$var$load("iGCP8"),
    $884372b9927010af$var$load("i1fe2"),
    $884372b9927010af$var$load("6jGZ7"),
    $884372b9927010af$var$load("6wr18"),
    $884372b9927010af$var$load("ffEVr"),
    $884372b9927010af$var$load("5dkX4"),
    $884372b9927010af$var$load("jXx9i"),
    $884372b9927010af$var$load("fZt2F"),
    $884372b9927010af$var$load("2vAWg"),
    $884372b9927010af$var$load("7cABH"),
    $884372b9927010af$var$load("evYW1"),
    $884372b9927010af$var$load("Wowvf"),
    $884372b9927010af$var$load("5RR9C"),
    $884372b9927010af$var$load("3DgZV"),
    $884372b9927010af$var$load("7EorR"),
    $884372b9927010af$var$load("9qfB8"),
    $884372b9927010af$var$load("9ZB2D"),
    $884372b9927010af$var$load("hhss7"),
    $884372b9927010af$var$load("lP66B")
]).then(()=>parcelRequire('dcfqD'));

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("1r4vl"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4KS7f = parcelRequire("4KS7f");


var $9VJDA = parcelRequire("9VJDA");

const $565f8db62106cdff$var$i18n = (0, $aXWIB.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("1r4vl", function(module, exports) {

let $10bbce98e45bc65d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10bbce98e45bc65d$var$load("9GDly"),
    $10bbce98e45bc65d$var$load("6wr18"),
    $10bbce98e45bc65d$var$load("ffEVr"),
    $10bbce98e45bc65d$var$load("lUs3J"),
    $10bbce98e45bc65d$var$load("Wowvf"),
    $10bbce98e45bc65d$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("jwT8k", function(module, exports) {

let $e37bc5c94fcb745c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e37bc5c94fcb745c$var$load("4sZyu").then(()=>parcelRequire('3iK0z'));

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("jacyh", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $1P1Tu.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $9zUhf.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $9zUhf.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);
module.exports["useBlogTreeStore"] = $d9bb792bb433dc50$export$9638016a54f09a07;
module.exports["useBlogTreeActions"] = $d9bb792bb433dc50$export$861bc4451e1cbefa;

});

parcelRegister("cgsIj", function(module, exports) {
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderContainer);

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $eCJDV = parcelRequire("eCJDV");


var $8MMdp = parcelRequire("8MMdp");


const $b7f6794681d506d9$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z3pve",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $b7f6794681d506d9$export$2dc68d50d56fbbd = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
const $b7f6794681d506d9$export$8bb26699ba16d6a3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MMdp.Breadcrumbs), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8MMdp.Breadcrumbs), props);

const $b7f6794681d506d9$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G1kJd",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).FixedBreadcrumbsNavForPageLayout
});
module.exports["BreadcrumbsLoader"] = $b7f6794681d506d9$export$74cf87e24679ef23;
module.exports["Breadcrumbs"] = $b7f6794681d506d9$export$2dc68d50d56fbbd;
module.exports["BreadcrumbsNonLoadable"] = $b7f6794681d506d9$export$8bb26699ba16d6a3;
module.exports["FixedBreadcrumbsNavForPageLayoutLoader"] = $b7f6794681d506d9$export$f979c33d59431f8e;

});

parcelRegister("eCJDV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fwDOR = parcelRequire("fwDOR");

const $0c4308f795e44815$export$98d1f051069dd73b = (0, $3u0dr.isReactCompilerActiveV2)() ? function BreadcrumbsPlaceholder() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "BreadcrumbsPlaceholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "breadcrumbs-placeholder",
            "data-vc": "breadcrumbs-placeholder"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function BreadcrumbsPlaceholder() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
};
module.exports["BreadcrumbsPlaceholder"] = $0c4308f795e44815$export$98d1f051069dd73b;

});

parcelRegister("8MMdp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $inPa6 = parcelRequire("inPa6");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $6mKj3 = parcelRequire("6mKj3");


var $5Vf1r = parcelRequire("5Vf1r");

const $6d14bad88596319b$var$hideDuringPdfPrint = null;

const $6d14bad88596319b$var$CompanyHubBreadcrumbs = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rj-y7",
    name: "CompanyHubBreadcrumbs",
    loader: async ()=>(await (parcelRequire("5bUM9"))).CompanyHubBreadcrumbs
}); // Keep this in sync with entry-points/breadcrumbsConstants.ts
const $6d14bad88596319b$var$BREADCRUMB_HEADER_HEIGHT = 56; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d14bad88596319b$export$ba9528a5a0141231 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1ji2brd": (0, $7sObp.default)(__cmplp.justifyContent || "space-between")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_n7zlglyw _4t3i8vuz _1pby1ial _p12f18ua _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1ltv1d4h _1bah1vxp",
                __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
                __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
                __cmplp.shouldShowAifcCreateBanner ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ji2brd": (0, $7sObp.default)(__cmplp.justifyContent || 'space-between')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlglyw _4t3i8vuz _1pby1ial _p12f18ua _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1ltv1d4h _1bah1vxp",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.shouldShowAifcCreateBanner ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $6d14bad88596319b$var$SpaceHeaderWithBannerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi _1ltv1d4h _18u0idpf",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi _1ltv1d4h _18u0idpf",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d14bad88596319b$var$SpaceHeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulpv77o _4t3i8vuz _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpv77o _4t3i8vuz _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.className
        ])
    });
});
function $6d14bad88596319b$export$2dc68d50d56fbbd({ contentId: contentId, contentTitle: contentTitle, spaceKey: spaceKey, testId: testId, showInlineRename: showInlineRename, shouldDisableMoveButton: shouldDisableMoveButton, displayMode: displayMode = (0, $5Vf1r.BREADCRUMBS_MODES).FULL, contentLink: contentLink, contentType: contentType, subType: subType }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!spaceKey) return null;
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$CompanyHubBreadcrumbs, null);
    const fireBreadcrumbError = (error)=>{
        let err;
        let nativeError;
        try {
            err = JSON.stringify(error, Object.getOwnPropertyNames(error)); // https://stackoverflow.com/a/26199752
            nativeError = JSON.stringify(error['nativeError']);
        } catch  {
            // if no error, means it failed to stringify so just set as empty string
            if (!err) err = '';
            if (!nativeError) nativeError = '';
        } finally{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'breadcrumbs',
                    action: 'errored',
                    actionSubject: 'viewPageBreadcrumbs',
                    attributes: {
                        message: error.message,
                        error: err,
                        nativeError: nativeError
                    }
                }
            }).fire();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Vf1r.BreadcrumbsWithSpaceNameDropdown), {
        contentTitle: contentTitle,
        spaceKey: spaceKey || '',
        contentId: contentId,
        testId: testId,
        showInlineRename: showInlineRename,
        shouldDisableMoveButton: shouldDisableMoveButton,
        displayMode: displayMode,
        contentLink: contentLink,
        contentType: contentType,
        subType: subType
    })));
}
const $6d14bad88596319b$export$7d2750c639212b06 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
            spaceKey: spaceKey
        }));
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
        spaceKey: spaceKey
    }));
};
const $6d14bad88596319b$export$5adc3a1912461c1e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            (0, $6mKj3.expValEquals)("afm-hide-elements-from-pdf-print", "isEnabled", true) && "_24zuglyw"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== isThemed || $[4] !== shouldHavePadding || $[5] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
            isThemed: isThemed,
            "data-testid": testId,
            isObjectHeaderEnabled: t2,
            shouldHavePadding: shouldHavePadding
        }, children);
        $[2] = children;
        $[3] = isThemed;
        $[4] = shouldHavePadding;
        $[5] = testId;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== banner || $[8] !== isFullWidth || $[9] !== isThemed || $[10] !== isTransparent || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
            isThemed: isThemed,
            isFullWidth: isFullWidth,
            isTransparent: isTransparent,
            className: t1
        }, banner, t3);
        $[7] = banner;
        $[8] = isFullWidth;
        $[9] = isThemed;
        $[10] = isTransparent;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
        isThemed: isThemed,
        isFullWidth: isFullWidth,
        isTransparent: isTransparent,
        className: (0, $gMc0m.default)([
            (0, $6mKj3.expValEquals)('afm-hide-elements-from-pdf-print', 'isEnabled', true) && "_24zuglyw"
        ])
    }, banner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
        isThemed: isThemed,
        "data-testid": testId,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        shouldHavePadding: shouldHavePadding
    }, children));
};
module.exports["FixedSpaceHeaderContainer"] = $6d14bad88596319b$export$ba9528a5a0141231;
module.exports["Breadcrumbs"] = $6d14bad88596319b$export$2dc68d50d56fbbd;
module.exports["FixedBreadcrumbsNavForPageLayout"] = $6d14bad88596319b$export$7d2750c639212b06;
module.exports["FixedSpaceHeaderWithBannerContainer"] = $6d14bad88596319b$export$5adc3a1912461c1e;

});

parcelRegister("5Vf1r", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $bMPhU = parcelRequire("bMPhU");


var $kqIWy = parcelRequire("kqIWy");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bCECL = parcelRequire("bCECL");


var $kM55L = parcelRequire("kM55L");


var $1jQpq = parcelRequire("1jQpq");


var $6mKj3 = parcelRequire("6mKj3");


var $ePiuX = parcelRequire("ePiuX");


var $hzkzq = parcelRequire("hzkzq");


const $7c978e5ad74fbe60$var$BreadcrumbsDropdownContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "d_JWZ",
    name: "BreadcrumbsDropdownContent",
    loader: async ()=>(await (parcelRequire("9ynBm"))).BreadcrumbsDropdownContent
});

const $7c978e5ad74fbe60$var$BreadcrumbsPlaceholder = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YZZqh",
    name: "BreadcrumbsPlaceholder",
    loader: async ()=>(await Promise.resolve((parcelRequire("eCJDV")))).BreadcrumbsPlaceholder
});
const $7c978e5ad74fbe60$var$separatorStyles = null;
const $7c978e5ad74fbe60$var$hiddenStyles = null;
const $7c978e5ad74fbe60$var$hiddenContentTitleStyles = null;
const $7c978e5ad74fbe60$var$hideSeparatorStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbsStyles = (0, $ecnYn.xcss)({
    minWidth: '32px',
    // needed for responsive breadcrumbs, 32px is the width of the chevron button
    alignItems: 'center',
    flex: '0 1 auto',
    gap: 'space.100'
});
const $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles = (0, $ecnYn.xcss)({
    flex: '0 0 auto'
});
const $7c978e5ad74fbe60$var$fadedSpaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$spaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$noEllipsisStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthBreadcrumbsDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$onlySpaceNameTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthOnlyContentTitleTriggerStyles = null;
const $7c978e5ad74fbe60$var$currentPageBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$currentPageLinkBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$contentTitleStyles = null;
const $7c978e5ad74fbe60$var$dropdownLessContentTitleStyles = null;
const $7c978e5ad74fbe60$var$chevronBaseStyles = (0, $ecnYn.xcss)({
    width: '32px',
    minWidth: '32px',
    height: '32px',
    borderRadius: "var(--ds-radius-small, 4px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral.subtle'
});
const $7c978e5ad74fbe60$var$chevronHoverStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $7c978e5ad74fbe60$export$14e8342ddf0a4616 = /*#__PURE__*/ function(BREADCRUMBS_MODES) {
    BREADCRUMBS_MODES["ONLY_CONTENT_TITLE"] = "ONLY_CONTENT_TITLE";
    BREADCRUMBS_MODES["ONLY_SPACE_NAME"] = "ONLY_SPACE_NAME";
    BREADCRUMBS_MODES["FULL"] = "FULL";
    BREADCRUMBS_MODES["HIDDEN"] = "HIDDEN";
    return BREADCRUMBS_MODES;
}({});
const $7c978e5ad74fbe60$export$c71a066c29807b48 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(56);
    const { contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: t1, showInlineRename: t2, shouldDisableMoveButton: t3, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType } = t0;
    const testId = t1 === undefined ? "breadcrumbs-with-space-name-dropdown" : t1;
    const showInlineRename = t2 === undefined ? false : t2;
    const shouldDisableMoveButton = t3 === undefined ? false : t3;
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $42omo.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const [t4] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t4;
    let t5;
    if ($[0] !== isCollabOffline) {
        t5 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t5;
    } else t5 = $[1];
    const isNetworkDisabled = t5;
    if (error || !spaceData) {
        let t6;
        if ($[2] !== error) {
            t6 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
                error: error
            }));
            $[2] = error;
            $[3] = t6;
        } else t6 = $[3];
        let t7;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null);
            $[4] = t7;
        } else t7 = $[4];
        let t8;
        if ($[5] !== t6) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t6, t7);
            $[5] = t6;
            $[6] = t8;
        } else t8 = $[6];
        return t8;
    }
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    let T0;
    let renderContentTitle;
    let shouldShowCurrentContentTitle;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[7] !== contentId || $[8] !== contentLink || $[9] !== contentTitle || $[10] !== contentType || $[11] !== createAnalyticsEvent || $[12] !== displayMode || $[13] !== experienceTracker || $[14] !== intl || $[15] !== isBreadcrumbsPopupOpen || $[16] !== isModernEmbeddedConfluence || $[17] !== isNetworkDisabled || $[18] !== isSpaceNameLongerThan6Letters || $[19] !== push || $[20] !== shouldDisableMoveButton || $[21] !== showInlineRename || $[22] !== spaceData.alias || $[23] !== spaceHomepageId || $[24] !== spaceKey || $[25] !== spaceName || $[26] !== ssrPlaceholderIdProp || $[27] !== subType || $[28] !== testId) {
        const contentTitleToRender = contentTitle === "" ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
        const shouldOpenDropdown = contentTitleToRender || showInlineRename;
        shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
        let t10;
        if ($[36] !== spaceData.alias || $[37] !== spaceHomepageId || $[38] !== spaceKey) {
            t10 = (0, $hzkzq.buildContentPath)({
                contentType: "page",
                isSpaceOverview: true,
                query: spaceHomepageId ? {
                    [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
                } : undefined,
                spaceAlias: spaceData.alias,
                spaceKey: spaceKey
            });
            $[36] = spaceData.alias;
            $[37] = spaceHomepageId;
            $[38] = spaceKey;
            $[39] = t10;
        } else t10 = $[39];
        const spaceOverviewPath = t10;
        const handleBreadcrumbDropdownTriggerClick = ()=>{
            if (shouldOpenDropdown) {
                if (!isBreadcrumbsPopupOpen) {
                    experienceTracker.start({
                        name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                    });
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "opened",
                            actionSubject: "breadcrumbsDropdown",
                            source: "breadcrumbs",
                            attributes: {
                                isContentWrapper: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                            }
                        }
                    }).fire();
                }
                setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
            } else push(spaceOverviewPath);
        };
        const popupContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
                spaceKey: spaceKey,
                contentId: contentId,
                closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
                spaceOverviewPath: spaceOverviewPath,
                shouldDisableMoveButton: shouldDisableMoveButton,
                contentTitle: contentTitleToRender
            });
        const closeDropdownOnClickOfBreadcrumbItem = ()=>{
            setIsBreadcrumbsPopupOpen(false);
        };
        let t11;
        if ($[40] !== contentId || $[41] !== spaceKey) {
            t11 = ()=>{
                (0, $ePiuX.preloadBreadcrumbsDropdown)({
                    spaceKey: spaceKey,
                    contentId: contentId
                });
            };
            $[40] = contentId;
            $[41] = spaceKey;
            $[42] = t11;
        } else t11 = $[42];
        const preloadBreadcrumbsDropdownOnSpaceNameHover = t11;
        const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                isOpen: isBreadcrumbsPopupOpen,
                onClose: ()=>setIsBreadcrumbsPopupOpen(false),
                placement: "bottom-start",
                content: popupContent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                        id: "breadcrumbs-dropdown-chevron-button",
                        "data-testid": "breadcrumbs-dropdown-chevron-button",
                        disabled: isNetworkDisabled,
                        onClick: handleBreadcrumbDropdownTriggerClick,
                        onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                        onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                        "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                        ...triggerProps,
                        ...ssrPlaceholderIdProp,
                        className: (0, $gMc0m.default)([
                            "_2rko12b0 _19it1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhksm61 _syaz1rpy _1vnv1r31 _1b5cglyw _1avfnqa1 _10fu1rpy _j5dh73ad _f8pjazsu _mizu1v1w _1ah3v77o _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _9h8hi7uo",
                            shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                            displayMode === "ONLY_SPACE_NAME" && "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _p12f1kdj _1bsbn7od _8fz61kdj",
                            displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                            displayMode === "HIDDEN" && "_1e0cglyw"
                        ])
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                        alignItems: "center",
                        gap: "space.100"
                    }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                        content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                        hideTooltipOnClick: true
                    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: [
                                $7c978e5ad74fbe60$var$chevronBaseStyles,
                                !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                            ],
                            ...tooltipProps
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)",
                            size: "small"
                        }))), renderSpaceName()))
            }), shouldOpenDropdown && renderSeparator());
        renderContentTitle = ()=>{
            const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: contentLink,
                className: (0, $gMc0m.default)([
                    "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1053i7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1vhvi7uo _1m0aglyw"
                ])
            }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1m0aglyw"
                ])
            }, contentTitleToRender);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                id: "breadcrumbs-content-title",
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                    (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf",
                    isModernEmbeddedConfluence && "_bozgu2gc"
                ])
            }, (contentType === "page" || contentType === "blogpost") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                type: contentType,
                subType: subType,
                color: "var(--ds-text, #292A2E)"
            }), titleElement);
        };
        const renderSpaceName = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                id: "breadcrumbs-space-name",
                className: (0, $gMc0m.default)([
                    "_1reo15vq _18m915vq _11c8fhey _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                    shouldOpenDropdown && displayMode === "FULL" && "_1bton7od",
                    shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_1nwpsavl _1w80savl",
                    (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_1e0cglyw"
                ])
            }, spaceName);
        const renderSeparator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                id: "breadcrumbs-separator",
                className: (0, $gMc0m.default)([
                    "_syazazsu _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                    !showInlineRename && "_1m0aglyw",
                    displayMode != "FULL" && "_1e0cglyw"
                ])
            }, "/");
        T0 = (0, $bUlM5.default);
        const t12 = showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles;
        if ($[43] !== t12) {
            t6 = [
                $7c978e5ad74fbe60$var$breadcrumbsStyles,
                t12
            ];
            $[43] = t12;
            $[44] = t6;
        } else t6 = $[44];
        t7 = testId;
        t8 = testId;
        t9 = !isModernEmbeddedConfluence && renderPopup();
        $[7] = contentId;
        $[8] = contentLink;
        $[9] = contentTitle;
        $[10] = contentType;
        $[11] = createAnalyticsEvent;
        $[12] = displayMode;
        $[13] = experienceTracker;
        $[14] = intl;
        $[15] = isBreadcrumbsPopupOpen;
        $[16] = isModernEmbeddedConfluence;
        $[17] = isNetworkDisabled;
        $[18] = isSpaceNameLongerThan6Letters;
        $[19] = push;
        $[20] = shouldDisableMoveButton;
        $[21] = showInlineRename;
        $[22] = spaceData.alias;
        $[23] = spaceHomepageId;
        $[24] = spaceKey;
        $[25] = spaceName;
        $[26] = ssrPlaceholderIdProp;
        $[27] = subType;
        $[28] = testId;
        $[29] = T0;
        $[30] = renderContentTitle;
        $[31] = shouldShowCurrentContentTitle;
        $[32] = t6;
        $[33] = t7;
        $[34] = t8;
        $[35] = t9;
    } else {
        T0 = $[29];
        renderContentTitle = $[30];
        shouldShowCurrentContentTitle = $[31];
        t6 = $[32];
        t7 = $[33];
        t8 = $[34];
        t9 = $[35];
    }
    let t10;
    if ($[45] !== renderContentTitle || $[46] !== shouldShowCurrentContentTitle) {
        t10 = shouldShowCurrentContentTitle && renderContentTitle();
        $[45] = renderContentTitle;
        $[46] = shouldShowCurrentContentTitle;
        $[47] = t10;
    } else t10 = $[47];
    let t11;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
        });
        $[48] = t11;
    } else t11 = $[48];
    let t12;
    if ($[49] !== T0 || $[50] !== t10 || $[51] !== t6 || $[52] !== t7 || $[53] !== t8 || $[54] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t6,
            testId: t7,
            "data-vc": t8
        }, t9, t10, t11);
        $[49] = T0;
        $[50] = t10;
        $[51] = t6;
        $[52] = t7;
        $[53] = t8;
        $[54] = t9;
        $[55] = t12;
    } else t12 = $[55];
    return t12;
} : ({ contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: testId = 'breadcrumbs-with-space-name-dropdown', showInlineRename: showInlineRename = false, shouldDisableMoveButton: shouldDisableMoveButton = false, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $42omo.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override'); // Note don't check for loading as when refreshing data we will get data={...} and loading=true
    // In this case if we display the placeholder it will flash before the data is displayed
    // We should continue render with existing data and then update when the new data is available
    if (error || !spaceData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null));
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    const contentTitleToRender = contentTitle === '' ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
    const shouldOpenDropdown = contentTitleToRender || showInlineRename;
    const shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
    const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
        contentType: 'page',
        isSpaceOverview: true,
        query: spaceHomepageId ? {
            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
        } : undefined,
        spaceAlias: spaceData.alias,
        spaceKey: spaceKey
    });
    const handleBreadcrumbDropdownTriggerClick = ()=>{
        if (shouldOpenDropdown) {
            if (!isBreadcrumbsPopupOpen) {
                experienceTracker.start({
                    name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'breadcrumbsDropdown',
                        source: 'breadcrumbs',
                        attributes: {
                            isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                        }
                    }
                }).fire();
            }
            setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
        } else push(spaceOverviewPath);
    };
    const popupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
            spaceKey: spaceKey,
            contentId: contentId,
            closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
            spaceOverviewPath: spaceOverviewPath,
            shouldDisableMoveButton: shouldDisableMoveButton,
            contentTitle: contentTitleToRender
        });
    };
    const closeDropdownOnClickOfBreadcrumbItem = ()=>{
        setIsBreadcrumbsPopupOpen(false);
    };
    const preloadBreadcrumbsDropdownOnSpaceNameHover = ()=>{
        (0, $ePiuX.preloadBreadcrumbsDropdown)({
            spaceKey: spaceKey,
            contentId: contentId
        });
    }; /* TODO: Add `shouldRenderToParent` to resolve accessibility issues. See https://a11y.atlassian.net/browse/JCATS-788 */ 
    const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isBreadcrumbsPopupOpen,
            onClose: ()=>setIsBreadcrumbsPopupOpen(false),
            placement: "bottom-start",
            content: popupContent,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                    id: "breadcrumbs-dropdown-chevron-button",
                    "data-testid": "breadcrumbs-dropdown-chevron-button",
                    disabled: isNetworkDisabled,
                    onClick: handleBreadcrumbDropdownTriggerClick,
                    onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                    ...triggerProps,
                    ...ssrPlaceholderIdProp,
                    className: (0, $gMc0m.default)([
                        "_2rko12b0 _19it1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhksm61 _syaz1rpy _1vnv1r31 _1b5cglyw _1avfnqa1 _10fu1rpy _j5dh73ad _f8pjazsu _mizu1v1w _1ah3v77o _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _9h8hi7uo",
                        shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                        displayMode === "ONLY_SPACE_NAME" && "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _p12f1kdj _1bsbn7od _8fz61kdj",
                        displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                        displayMode === "HIDDEN" && "_1e0cglyw"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    alignItems: "center",
                    gap: "space.100"
                }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                    hideTooltipOnClick: true
                }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: [
                            $7c978e5ad74fbe60$var$chevronBaseStyles,
                            !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                        ],
                        ...tooltipProps
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    }))), renderSpaceName()))
        }), shouldOpenDropdown && renderSeparator());
    const renderContentTitle = ()=>{
        const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: contentLink,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1053i7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1vhvi7uo _1m0aglyw"
            ])
        }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1m0aglyw"
            ])
        }, contentTitleToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: "breadcrumbs-content-title",
            className: (0, $gMc0m.default)([
                "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf",
                isModernEmbeddedConfluence && "_bozgu2gc"
            ])
        }, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #292A2E)"
        }), titleElement);
    };
    const renderSpaceName = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "breadcrumbs-space-name",
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _11c8fhey _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                shouldOpenDropdown && displayMode === "FULL" && "_1bton7od",
                shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_1nwpsavl _1w80savl",
                (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_1e0cglyw"
            ])
        }, spaceName);
    };
    const renderSeparator = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "breadcrumbs-separator",
            className: (0, $gMc0m.default)([
                "_syazazsu _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                !showInlineRename && "_1m0aglyw",
                displayMode != "FULL" && "_1e0cglyw"
            ])
        }, "/");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: [
            $7c978e5ad74fbe60$var$breadcrumbsStyles,
            showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles
        ],
        testId: testId,
        "data-vc": testId
    }, !isModernEmbeddedConfluence && renderPopup(), shouldShowCurrentContentTitle && renderContentTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }));
};
const $7c978e5ad74fbe60$var$i18n = (0, $aXWIB.defineMessages)({
    breadcrumbsChevronButtonAriaLabel: {
        id: "breadcrumbs.dropdown.button.chevron.aria-label",
        defaultMessage: "Breadcrumbs"
    },
    untitledPage: {
        id: "breadcrumbs.dropdown.untitled-page.default-title",
        defaultMessage: "Untitled"
    },
    breadcrumbsChevronButtonTooltip: {
        id: "breadcrumbs.dropdown.button.chevron.tooltip",
        defaultMessage: "Show navigation path"
    }
});
module.exports["BREADCRUMBS_MODES"] = $7c978e5ad74fbe60$export$14e8342ddf0a4616;
module.exports["BreadcrumbsWithSpaceNameDropdown"] = $7c978e5ad74fbe60$export$c71a066c29807b48;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("bMPhU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), t2);
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<560475f7b94ff8b73d41c9418925ef8b>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("kqIWy", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t2 = emoji || "";
        let t3;
        if ($[0] !== height || $[1] !== t2 || $[2] !== type) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t2,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t2;
            $[2] = type;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions.liveDoc : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t2;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("ehs71"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("ehs71", function(module, exports) {

let $a65875bcaabf2fbb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a65875bcaabf2fbb$var$load("4pqtR"),
    $a65875bcaabf2fbb$var$load("5XqRg"),
    $a65875bcaabf2fbb$var$load("ajMch"),
    $a65875bcaabf2fbb$var$load("6wr18"),
    $a65875bcaabf2fbb$var$load("ffEVr"),
    $a65875bcaabf2fbb$var$load("kjZZD"),
    $a65875bcaabf2fbb$var$load("5qNrc"),
    $a65875bcaabf2fbb$var$load("4izLy"),
    $a65875bcaabf2fbb$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("1jQpq", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $cxu5H = parcelRequire("cxu5H");

const $951eaa69b00dd6e9$export$f183b986124d184 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasModernHeader: hasModernHeader } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    return isEmbeddedConfluence && hasModernHeader;
};
module.exports["useEmbeddedModernHeader"] = $951eaa69b00dd6e9$export$f183b986124d184;

});

parcelRegister("ePiuX", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $f4Qot = parcelRequire("f4Qot");

function $e956eba1dd4bb7db$export$e5d3f19aa88b9c61({ spaceKey: spaceKey, contentId: contentId }) {
    return (0, $dYU3e.query)({
        query: (0, $f4Qot.default),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        }
    });
}
module.exports["preloadBreadcrumbsDropdown"] = $e956eba1dd4bb7db$export$e5d3f19aa88b9c61;

});

parcelRegister("f4Qot", function(module, exports) {
/**
 * @generated SignedSource<<a009d774dae8837e0addf18ef51f2feb>>
 * @relayHash eacc72b6f9ecbeb5ab52a1b74d6064a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4
const $ef0655697d43d9a3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipContent"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "condition": "skipContent",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "current",
                                "draft",
                                "archived"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-published",
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v7 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "emoji-title-published"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": v7 /*: any*/ ,
                                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "eacc72b6f9ecbeb5ab52a1b74d6064a5",
            "id": "4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4",
            "metadata": {},
            "name": "BreadcrumbsDropdownContentQuery",
            "operationKind": "query",
            "text": "query BreadcrumbsDropdownContentQuery($spaceKey:String!,$contentId:ID,$skipContent:Boolean!){space(key:$spaceKey){alias,id,name,icon{path},homepage{id}},content(id:$contentId,status:[\"current\",\"draft\",\"archived\"])@skip(if:$skipContent){nodes{id,type,subType,status,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},ancestors{id,type,subType,title,status,properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}}"
        }
    };
}();
$ef0655697d43d9a3$var$node.hash = "3e4a9d4b445d7d646b220e3bab421884";
var $ef0655697d43d9a3$export$2e2bcd8739ae039 = $ef0655697d43d9a3$var$node;
module.exports["default"] = $ef0655697d43d9a3$export$2e2bcd8739ae039;

});

parcelRegister("hzkzq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $b055c0b5c16164d3$export$41b2e06f27dfe96e = 'archived';
const $b055c0b5c16164d3$export$6b45500787cf696 = ({ contentId: contentId, contentSlug: contentSlug, contentType: contentType, isSpaceOverview: isSpaceOverview, query: query, spaceAlias: spaceAlias, spaceKey: spaceKey })=>{
    if (contentType === 'folder') return '#';
    let route;
    if (isSpaceOverview) route = (0, $1NBp8.SPACE_OVERVIEW);
    else switch(contentType){
        case 'blogpost':
            route = (0, $1NBp8.VIEW_BLOG);
            break;
        case 'page':
            route = (0, $1NBp8.VIEW_PAGE);
            break;
        case 'whiteboard':
            route = (0, $1NBp8.WHITEBOARD_BOARD);
            break;
        case 'slide':
            route = (0, $1NBp8.SLIDES_VIEW);
            break;
        case 'database':
            route = (0, $1NBp8.DATABASE_VIEW);
            break;
        case 'embed':
            route = (0, $1NBp8.EMBED_VIEW);
            break;
        default:
            throw new Error(`Received an unexpected content type: '${contentType}'`);
    }
    return route.toUrl({
        contentId: contentId,
        contentSlug: contentSlug,
        spaceKey: spaceAlias || spaceKey
    }, {
        query: query
    });
};
const $b055c0b5c16164d3$export$d3865786a3f7be67 = ({ ancestors: ancestors, status: status }, spaceHomepageId)=>{
    if (!ancestors) return [];
    // If current page is archived, filter out non-archived ancestors
    if (status === $b055c0b5c16164d3$export$41b2e06f27dfe96e) ancestors = ancestors.filter((ancestor)=>ancestor && ancestor.status === $b055c0b5c16164d3$export$41b2e06f27dfe96e);
    else // technically array elements can be null
    ancestors = ancestors.filter((node)=>node);
    // Filter out ancestors with null type when experiment is enabled
    ancestors = ancestors.filter((node)=>{
        if (!node) return false;
        if (!node.type && (0, $9wGTI.fg)('confluence_ufo_trace_ct_err')) return false;
        return true;
    });
    // Filter out ancestors with null id to prevent TypeError from path-to-regexp
    if ((0, $6mKj3.expVal)('confluence_fix_expected_contentid_to_be_string', 'isEnabled', false)) ancestors = ancestors.filter((node)=>node && node.id);
    if (!ancestors.length) return ancestors;
    if (ancestors[0].id !== spaceHomepageId && ancestors[ancestors.length - 1].id === spaceHomepageId) return [
        ...ancestors
    ].reverse().slice(1);
    if (ancestors[0].id === spaceHomepageId) return ancestors.slice(1);
    return ancestors;
};
const $b055c0b5c16164d3$export$f6641c501f8a1aee = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$e1cb12562674727b = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$52c8bba571728790 = (textRef)=>{
    if (textRef.current) return textRef.current.scrollWidth > textRef.current.clientWidth;
    return false;
};
module.exports["buildContentPath"] = $b055c0b5c16164d3$export$6b45500787cf696;
module.exports["filterAncestors"] = $b055c0b5c16164d3$export$d3865786a3f7be67;
module.exports["getEmojiFromPublishedPageProperties"] = $b055c0b5c16164d3$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $b055c0b5c16164d3$export$e1cb12562674727b;
module.exports["getIsTextTruncated"] = $b055c0b5c16164d3$export$52c8bba571728790;

});

parcelRegister("9ynBm", function(module, exports) {

let $6f4998cd99c7a650$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6f4998cd99c7a650$var$load("lUs3J"),
    $6f4998cd99c7a650$var$load("6wr18"),
    $6f4998cd99c7a650$var$load("hhss7"),
    $6f4998cd99c7a650$var$load("ffEVr"),
    $6f4998cd99c7a650$var$load("7EorR"),
    $6f4998cd99c7a650$var$load("1GyAj")
]).then(()=>parcelRequire('auDgK'));

});

parcelRegister("5bUM9", function(module, exports) {

let $3c7a054721a12b05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3c7a054721a12b05$var$load("6wr18"),
    $3c7a054721a12b05$var$load("ffEVr"),
    $3c7a054721a12b05$var$load("hhss7"),
    $3c7a054721a12b05$var$load("Wowvf"),
    $3c7a054721a12b05$var$load("b6JBs")
]).then(()=>parcelRequire('g3Wvh'));

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $8rneB = parcelRequire("8rneB");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $T1bCI.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("i5zxs", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $e6a27c260ce1aef4$export$edf095fb7f09a5c0 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            hasCoverPicture: false,
            isUploadingPicture: false,
            isModalOpen: false,
            isRemovingPicture: false,
            isRepositioningPicture: false,
            isAddHeaderImageButtonFocused: false,
            coverPictureId: '',
            shouldShowReposition: false,
            isChangingPicture: false,
            coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            isAIUnsplashImage: false,
            aiSuggestedUnsplashImages: undefined,
            shouldShowAIUnsplashHeaderToolbar: false,
            shouldShowAIImageAcceptanceFlow: false,
            lastAIGenerationParams: null,
            isCurrentAIFCAutoImage: false
        };
        this.setHasCoverPicture = (hasCoverPicture)=>this.setState({
                hasCoverPicture: hasCoverPicture
            });
        this.toggleCoverPictureWidthButton = (coverPictureWidth)=>this.setState({
                coverPictureWidth: coverPictureWidth
            });
        this.setCoverPictureId = (coverPictureId)=>this.setState({
                coverPictureId: coverPictureId
            });
        this.setIsUploadingPicture = (isUploadingPicture)=>this.setState({
                isUploadingPicture: isUploadingPicture
            });
        this.setIsModalOpen = (isModalOpen)=>this.setState({
                isModalOpen: isModalOpen
            });
        this.setIsChangingPicture = (isChangingPicture)=>this.setState({
                isChangingPicture: isChangingPicture
            });
        this.setIsRemovingPicture = (isRemovingPicture)=>this.setState({
                isRemovingPicture: isRemovingPicture
            });
        this.setIsRepositioningPicture = (isRepositioningPicture)=>this.setState({
                isRepositioningPicture: isRepositioningPicture
            });
        this.setShouldShowReposition = (shouldShowReposition)=>this.setState({
                shouldShowReposition: shouldShowReposition
            });
        this.setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused)=>this.setState({
                isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused
            });
        this.setIsAIUnsplashImage = (isAIUnsplashImage)=>this.setState({
                isAIUnsplashImage: isAIUnsplashImage
            });
        this.setAISuggestedUnsplashImages = (aiSuggestedUnsplashImages)=>this.setState({
                aiSuggestedUnsplashImages: aiSuggestedUnsplashImages
            });
        this.setShouldShowAIUnsplashHeaderToolbar = (shouldShowAIUnsplashHeaderToolbar)=>this.setState({
                shouldShowAIUnsplashHeaderToolbar: shouldShowAIUnsplashHeaderToolbar
            });
        this.setShouldShowAIImageAcceptanceFlow = (shouldShowAIImageAcceptanceFlow)=>this.setState({
                shouldShowAIImageAcceptanceFlow: shouldShowAIImageAcceptanceFlow
            });
        this.setLastAIGenerationParams = (lastAIGenerationParams)=>this.setState({
                lastAIGenerationParams: lastAIGenerationParams
            });
        this.setIsCurrentAIFCAutoImage = (isCurrentAIFCAutoImage)=>this.setState({
                isCurrentAIFCAutoImage: isCurrentAIFCAutoImage
            });
        this.resetToDefaults = ()=>{
            this.setIsModalOpen(false);
            this.setIsAddHeaderImageButtonFocused(false);
            this.setIsUploadingPicture(false);
            this.setIsChangingPicture(false);
            this.setIsRemovingPicture(false);
            this.setShouldShowReposition(false);
            this.toggleCoverPictureWidthButton((0, $jVylI.COVERPICTUREWIDTH).FULL);
            this.setIsAIUnsplashImage(false);
            this.setAISuggestedUnsplashImages(undefined);
            this.setShouldShowAIUnsplashHeaderToolbar(false);
            this.setShouldShowAIImageAcceptanceFlow(false);
            this.setLastAIGenerationParams(null);
            this.setIsCurrentAIFCAutoImage(false);
        };
    }
}
module.exports["CoverPictureStateContainer"] = $e6a27c260ce1aef4$export$edf095fb7f09a5c0;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("cF2C3", function(module, exports) {

var $dWCFT = parcelRequire("dWCFT");


var $aXWIB = parcelRequire("aXWIB");

const $9428fa9f64a90dcf$var$i18n = (0, $aXWIB.defineMessages)({
    aMomentAgo: {
        id: "save-indicator.tooltip.time.aMomentAgo",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "save-indicator.tooltip.time.lessThanAMinuteAgo",
        defaultMessage: "less than a minute ago"
    },
    oneMinuteAgo: {
        id: "save-indicator.tooltip.time.oneMinuteAgo",
        defaultMessage: "a minute ago"
    },
    xMinutesAgo: {
        id: "save-indicator.tooltip.time.xMinutesAgo",
        defaultMessage: "{time} minutes ago"
    },
    oneHourAgo: {
        id: "save-indicator.tooltip.time.oneHourAgo",
        defaultMessage: "about an hour ago"
    },
    xHoursAgo: {
        id: "save-indicator.tooltip.time.xHoursAgo",
        defaultMessage: "about {time} hours ago"
    },
    yesterday: {
        id: "save-indicator.tooltip.time.yesterday",
        defaultMessage: "yesterday at {time}"
    }
});
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_SECONDS = 1000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES = 60000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR = 3600000;
const $9428fa9f64a90dcf$var$MILLISECONDS_TO_DAY = 86400000;
const $9428fa9f64a90dcf$export$5a00511f040384d7 = (savedTime, formatMessage)=>{
    let formattedTime;
    const timeNow = new Date();
    const timeDifference = timeNow.getTime() - savedTime.getTime();
    if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_SECONDS < 4) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.aMomentAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 1) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.lessThanAMinuteAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 2) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.oneMinuteAgo);
    else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 50) {
        const roundedMinutes = Math.round(timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES);
        formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.xMinutesAgo, {
            time: roundedMinutes
        });
    } else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_MINUTES < 90) formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.oneHourAgo);
    else {
        const yesterday = timeNow;
        yesterday.setDate(timeNow.getDate() - 1);
        const savedTimeWasYesterday = yesterday.toLocaleDateString() === savedTime.toLocaleDateString();
        if (savedTimeWasYesterday && timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR > 5) // yesterday and more than 5 hours ago
        formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.yesterday, {
            time: (0, $dWCFT.default)(savedTime, 'p')
        });
        else if (timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_DAY < 1) {
            const roundedHours = Math.round(timeDifference / $9428fa9f64a90dcf$var$MILLISECONDS_TO_HOUR);
            formattedTime = formatMessage($9428fa9f64a90dcf$var$i18n.xHoursAgo, {
                time: roundedHours
            });
        } else formattedTime = (0, $dWCFT.default)(savedTime, 'PP');
    }
    return formattedTime;
};
module.exports["timeFormatter"] = $9428fa9f64a90dcf$export$5a00511f040384d7;

});

parcelRegister("40pD8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $42omo.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== isClassificationModalOpen) {
        t1 = {
            isClassificationModalOpen: isClassificationModalOpen
        };
        $[0] = isClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const contextValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchContextValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
            value: dispatchContextValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contextValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
            value: contextValue
        }, t3);
        $[5] = contextValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $42omo.useState)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $42omo.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$var$ClassificationModalContext);
} : ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
} : ()=>{
    return (0, $42omo.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};
module.exports["ClassificationModalContextProvider"] = $512bc11813ea6463$export$dd63fef46bf243c2;
module.exports["useClassificationModalContext"] = $512bc11813ea6463$export$3e27c86e4ac00950;
module.exports["useClassificationModalDispatchContext"] = $512bc11813ea6463$export$6c62639a7ca504f5;

});

parcelRegister("knzfV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $40pD8 = parcelRequire("40pD8");


var $fGQzQ = parcelRequire("fGQzQ");


var $earLp = parcelRequire("earLp");


const $5cd13874f5033207$var$LazyClassificationEditModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "oT96U",
    name: "LazyClassificationEditModalContent",
    loader: async ()=>(await (parcelRequire("ctS5p"))).ClassificationEditModalContent
});
const $5cd13874f5033207$export$d7e008c8afea1e79 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata } = t0;
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    let t1;
    if ($[0] !== contentClassificationMetadata || $[1] !== contentId) {
        t1 = {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata
        };
        $[0] = contentClassificationMetadata;
        $[1] = contentId;
        $[2] = t1;
    } else t1 = $[2];
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)(t1);
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    let t2;
    if ($[3] !== handleSubmit || $[4] !== setIsClassificationModalOpen) {
        t2 = (classificationOption)=>{
            handleSubmit(classificationOption);
            setIsClassificationModalOpen(false);
        };
        $[3] = handleSubmit;
        $[4] = setIsClassificationModalOpen;
        $[5] = t2;
    } else t2 = $[5];
    const onEditSubmit = t2;
    let t3;
    if ($[6] !== setIsClassificationModalOpen) {
        t3 = ()=>{
            setIsClassificationModalOpen(false);
        };
        $[6] = setIsClassificationModalOpen;
        $[7] = t3;
    } else t3 = $[7];
    const onEditCancel = t3;
    let t4;
    let t5;
    if ($[8] !== isClassificationModalOpen || $[9] !== trackEditPopupViewed) {
        t4 = ()=>{
            if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
        };
        t5 = [
            isClassificationModalOpen,
            trackEditPopupViewed
        ];
        $[8] = isClassificationModalOpen;
        $[9] = trackEditPopupViewed;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $42omo.useEffect)(t4, t5);
    if (!isClassificationModalOpen) return null;
    let t6;
    if ($[12] !== setIsClassificationModalOpen) {
        t6 = ()=>setIsClassificationModalOpen(false);
        $[12] = setIsClassificationModalOpen;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = defaultSelectedEditOption ?? undefined;
    let t8;
    if ($[14] !== contentId || $[15] !== onEditCancel || $[16] !== onEditSubmit || $[17] !== spaceKey || $[18] !== t6 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cd13874f5033207$var$LazyClassificationEditModalContent, {
            onClose: t6,
            onEditSubmit: onEditSubmit,
            onEditCancel: onEditCancel,
            selectedOption: t7,
            spaceKey: spaceKey,
            contentId: contentId
        });
        $[14] = contentId;
        $[15] = onEditCancel;
        $[16] = onEditSubmit;
        $[17] = spaceKey;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    const onEditSubmit = (0, $42omo.useCallback)((classificationOption)=>{
        handleSubmit(classificationOption);
        setIsClassificationModalOpen(false);
    }, [
        handleSubmit,
        setIsClassificationModalOpen
    ]);
    const onEditCancel = (0, $42omo.useCallback)(()=>{
        setIsClassificationModalOpen(false);
    }, [
        setIsClassificationModalOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
    }, [
        isClassificationModalOpen,
        trackEditPopupViewed
    ]);
    if (!isClassificationModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cd13874f5033207$var$LazyClassificationEditModalContent, {
        onClose: ()=>setIsClassificationModalOpen(false),
        onEditSubmit: onEditSubmit,
        onEditCancel: onEditCancel,
        selectedOption: defaultSelectedEditOption ?? undefined,
        spaceKey: spaceKey,
        contentId: contentId
    });
};
module.exports["ClassificationEditModal"] = $5cd13874f5033207$export$d7e008c8afea1e79;

});

parcelRegister("fGQzQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7tHGa = parcelRequire("7tHGa");


var $in5LX = parcelRequire("in5LX");


var $4oYaK = parcelRequire("4oYaK");


var $3tzmY = parcelRequire("3tzmY");


var $45d60 = parcelRequire("45d60");


var $fcQxC = parcelRequire("fcQxC");

const $3ebf4e9018306b37$export$9756cece5bf0eb59 = (contentStatus)=>{
    switch(contentStatus){
        case (0, $7tHGa.ContentStatus).DRAFT:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).DRAFT;
        default:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).CURRENT;
    }
};
const $3ebf4e9018306b37$export$94cbb2414d06bc8b = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { contentId: contentId, contentClassificationMetadata: contentClassificationMetadata } = t0;
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    let t1;
    if ($[0] !== contentId || $[1] !== contentStatusContext || $[2] !== deleteClassificationMutation || $[3] !== setFlagStatus || $[4] !== setSubmittedClassification || $[5] !== updateClassificationMutation) {
        t1 = (classificationOption)=>{
            if (!classificationOption?.id) return;
            setFlagStatus((0, $in5LX.FlagStatus).LOADING);
            const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? "current-only");
            const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
            const baseVariables = {
                id: parseInt(contentId),
                contentStatuses: contentStatuses
            };
            const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
            const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
            const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
            if (shouldDeleteClassification) {
                if (optionIsNoClassificationOption) setSubmittedClassification(null);
                if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
                deleteClassificationMutation({
                    variables: baseVariables
                });
            } else {
                setSubmittedClassification(classificationOption);
                updateClassificationMutation({
                    variables: {
                        ...baseVariables,
                        classificationLevelId: classificationOption.id
                    }
                });
            }
        };
        $[0] = contentId;
        $[1] = contentStatusContext;
        $[2] = deleteClassificationMutation;
        $[3] = setFlagStatus;
        $[4] = setSubmittedClassification;
        $[5] = updateClassificationMutation;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ contentId: contentId, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    return (0, $42omo.useCallback)((classificationOption)=>{
        // Provides type safety for the mutation variables
        if (!classificationOption?.id) return;
        setFlagStatus((0, $in5LX.FlagStatus).LOADING);
        const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? 'current-only');
        const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
        const baseVariables = {
            id: parseInt(contentId),
            contentStatuses: contentStatuses
        };
        const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
        const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
        const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
        if (shouldDeleteClassification) {
            if (optionIsNoClassificationOption) setSubmittedClassification(null);
            if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
            deleteClassificationMutation({
                variables: baseVariables
            });
        } else {
            setSubmittedClassification(classificationOption);
            updateClassificationMutation({
                variables: {
                    ...baseVariables,
                    classificationLevelId: classificationOption.id
                }
            });
        }
    }, [
        contentId,
        setFlagStatus,
        contentStatusContext,
        updateClassificationMutation,
        deleteClassificationMutation,
        setSubmittedClassification
    ]);
};
module.exports["useEditSubmitCallback"] = $3ebf4e9018306b37$export$94cbb2414d06bc8b;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("in5LX", function(module, exports) {
var $4e391701f1805c48$export$4417bd7c8606be45 = /*#__PURE__*/ function(FlagStatus) {
    FlagStatus["NONE"] = "NONE";
    FlagStatus["SUCCESS"] = "SUCCESS";
    FlagStatus["ERROR"] = "ERROR";
    FlagStatus["LOADING"] = "LOADING";
    return FlagStatus;
}({});
module.exports["FlagStatus"] = $4e391701f1805c48$export$4417bd7c8606be45;

});

parcelRegister("4oYaK", function(module, exports) {
const $8d28ed91f3c96188$export$ea52aaec0b4536b2 = 'data-classification.no-classification-option';
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $8d28ed91f3c96188$export$ea52aaec0b4536b2;

});

parcelRegister("3tzmY", function(module, exports) {
const $1cdd6556a0b2e638$export$8942d0d7876f8b98 = 'data-classification.space-default-classification-option';
module.exports["SPACE_DEFAULT_CLASSIFICATION_OPTION_ID"] = $1cdd6556a0b2e638$export$8942d0d7876f8b98;

});

parcelRegister("45d60", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d94436a169325872$export$8be450ac125d65b9 = /*#__PURE__*/ function(ContentDataClassificationMutationContentStatus) {
    ContentDataClassificationMutationContentStatus["CURRENT"] = "CURRENT";
    ContentDataClassificationMutationContentStatus["DRAFT"] = "DRAFT";
    return ContentDataClassificationMutationContentStatus;
}({});
module.exports["ContentDataClassificationMutationContentStatus"] = $d94436a169325872$export$8be450ac125d65b9;

});

parcelRegister("fcQxC", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $304e5e6450715c84$export$20226314cf99189a = (context)=>{
    let readContext;
    let writeContext;
    switch(context){
        case 'draft-only':
            readContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        case 'current-only':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
            break;
        case 'current-and-draft':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        default:
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
    }
    return {
        readContext: readContext,
        writeContext: writeContext
    };
};
module.exports["getReadAndWriteContextFromQueryContext"] = $304e5e6450715c84$export$20226314cf99189a;

});

parcelRegister("earLp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

var $a91836006a246f35$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    ActionSubjectId["EDITOR_TITLE_DATA_CLASSIFICATION_POPUP"] = "editorTitleDataClassificationPopup";
    ActionSubjectId["CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP"] = "contentTypeTitleDataClassificationPopup";
    ActionSubjectId["GENERIC_DATA_CLASSIFICATION_MODAL_POPUP"] = "genericDataClassificationModalPopup";
    return ActionSubjectId;
}({});
const $a91836006a246f35$var$getEditPopupViewedScreenEvent = ({ cloudId: cloudId, spaceId: spaceId, orgId: orgId, actionSubjectId: actionSubjectId })=>({
        type: 'sendScreenEvent',
        data: {
            name: 'dataClassificationEditPopup',
            action: 'viewed',
            actionSubject: 'popup',
            actionSubjectId: actionSubjectId,
            attributes: {
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId
            }
        }
    });
const $a91836006a246f35$export$c5f7a48280d6f361 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== cloudId || $[1] !== createAnalyticsEvent || $[2] !== orgId || $[3] !== spaceId) {
        t0 = {
            trackEditPopupViewed: (actionSubjectId)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                    cloudId: cloudId,
                    spaceId: spaceId,
                    orgId: orgId,
                    actionSubjectId: actionSubjectId
                })).fire();
            },
            trackRenderTagError: (errorMessage)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "failed",
                        actionSubject: "dataClassificationTagRender",
                        source: "confluence-frontend",
                        attributes: {
                            cloudId: cloudId,
                            spaceId: spaceId,
                            orgId: orgId,
                            error: errorMessage
                        }
                    }
                }).fire();
            }
        };
        $[0] = cloudId;
        $[1] = createAnalyticsEvent;
        $[2] = orgId;
        $[3] = spaceId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return {
        trackEditPopupViewed: (actionSubjectId)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId,
                actionSubjectId: actionSubjectId
            })).fire();
        },
        trackRenderTagError: (errorMessage)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'dataClassificationTagRender',
                    source: 'confluence-frontend',
                    attributes: {
                        cloudId: cloudId,
                        spaceId: spaceId,
                        orgId: orgId,
                        error: errorMessage
                    }
                }
            }).fire();
        }
    };
};
module.exports["ActionSubjectId"] = $a91836006a246f35$export$cb7d54f314e067cb;
module.exports["useTrackClassificationAnalytics"] = $a91836006a246f35$export$c5f7a48280d6f361;

});

parcelRegister("ctS5p", function(module, exports) {

let $916225d9cb0b81df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $916225d9cb0b81df$var$load("cZdQT"),
    $916225d9cb0b81df$var$load("58UdM"),
    $916225d9cb0b81df$var$load("20qsp")
]).then(()=>parcelRequire('enSER'));

});

parcelRegister("fy4lc", function(module, exports) {

let $b51d660309970b0f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b51d660309970b0f$var$load("cZdQT"),
    $b51d660309970b0f$var$load("5odbj"),
    $b51d660309970b0f$var$load("9wTW2")
]).then(()=>parcelRequire('dFOTO'));

});

parcelRegister("d6K5N", function(module, exports) {

let $98af96e55caa3c47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98af96e55caa3c47$var$load("4eWEr").then(()=>parcelRequire('2YWxz'));

});

parcelRegister("fwwrH", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0XSep",
    name: "SmartCreateFeedbackBannerLoader",
    loader: async ()=>(await (parcelRequire("2kSdH"))).SmartCreateFeedbackBanner
});
module.exports["SmartCreateFeedbackBannerLoader"] = $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44;

});

parcelRegister("2kSdH", function(module, exports) {

let $1b3781f6295511f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b3781f6295511f3$var$load("hhss7"),
    $1b3781f6295511f3$var$load("hzVe9")
]).then(()=>parcelRequire('dSB3l'));

});

parcelRegister("hV9Q1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $42a2f15877153857$export$48a171bbad47b95a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kR_kE",
    name: "TemplatePreview",
    loader: async ()=>(await (parcelRequire("lYojD"))).TemplatePreview
});
module.exports["TemplatePreview"] = $42a2f15877153857$export$48a171bbad47b95a;

});

parcelRegister("lYojD", function(module, exports) {

let $fff210244864549d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fff210244864549d$var$load("e1cuZ"),
    $fff210244864549d$var$load("6kXh6"),
    $fff210244864549d$var$load("hvHZS")
]).then(()=>parcelRequire('5QLLH'));

});

parcelRegister("bUiJC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $22ad974994dfbc0b$var$applyDefaultWidth = ()=>{
    const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollParent) return editorScrollParent.clientWidth || 0;
    return 0;
};
const $22ad974994dfbc0b$export$5308d1e625847f03 = ({ isFixedWidth: isFixedWidth = false })=>{
    const defaultWidth = $22ad974994dfbc0b$var$applyDefaultWidth();
    const [width, setWidth] = (0, $42omo.useState)(defaultWidth);
    const observerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
        if (editorScrollParent && !isFixedWidth) {
            observerRef.current = new ResizeObserver((entries)=>{
                setWidth(Math.floor(entries[0]?.target.clientWidth));
            });
            observerRef.current.observe(editorScrollParent);
            return ()=>observerRef?.current?.disconnect();
        }
    }, [
        observerRef,
        isFixedWidth
    ]);
    return {
        width: width,
        observerRef: observerRef.current
    };
};
module.exports["useEditorWidthObserver"] = $22ad974994dfbc0b$export$5308d1e625847f03;

});

parcelRegister("ixblh", function(module, exports) {
/* bpqaStyled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2932c138a6a4fe83$export$899fff719d224ef5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zs12fajl _kewefbnq _xlob1h6o",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$5f734e3a73651e57 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _k48pi7a9",
            __cmplp.isDisabled ? "_syaz1gmx" : "_syazazsu",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$25a86e6d831757c1 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1tcg _4t3i1tcg _wh9on7od _1an5n7od",
            __cmplp.isDisabled ? "_tzy41ou4" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$2285fc416017f7ef = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx21bp4 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$61367bcbe6096b19 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTemplatesPanelOpen: isTemplatesPanelOpen, shouldAdjustForContextPanel: shouldAdjustForContextPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _19itia51 _zulputpp _2rko1mok _2lx21bp4 _1e0c1txw _94n51ejb _bfhkvuon _1pbycs5v",
            __cmplp.isTemplatesPanelOpen && __cmplp.shouldAdjustForContextPanel ? "_2hwxa3o1" : "_2hwxidpf",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$17a2f9655d167e3f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _1e0c1txw _1bsb1wug _1bah1h6o _n3tdv47k _kqswstnw _94n5idpf",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$f8e573bbc82f4efb = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1osq _1bah1h6o _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zs12fajl _kewefbnq _xlob1h6o",
            __cmplp.isActive ? "_jmnr9yc7" : "_jmnrmzrp",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$f4922e2dc59c62b7 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowTemplatePreview: shouldShowTemplatePreview, editorWidth: editorWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _n3td68cl _bfhkvuon _1bsb1osq _1pbykb7n _1e0oidpf _jvszidpf _d7r2idpf _uhh2idpf _kvd7n7od _1oxg1osq _pnc7vuon _gdo5idpf _1jndidpf _1h8zidpf _1hblidpf _uzron7od _169tglyw _10pb1wug _1cpl1jfw _fkwnvuon",
            __cmplp.shouldShowTemplatePreview ? "_1e0c1wug" : "_1e0cglyw",
            __cmplp.editorWidth < 500 ? "_154i1bdq" : __cmplp.editorWidth < 820 ? "_154i1cg9" : "_154ikfja",
            __cmplp.className
        ])
    });
});
module.exports["QuickCardContainer"] = $2932c138a6a4fe83$export$899fff719d224ef5;
module.exports["ButtonText"] = $2932c138a6a4fe83$export$5f734e3a73651e57;
module.exports["QuickCardIcon"] = $2932c138a6a4fe83$export$25a86e6d831757c1;
module.exports["QuickCardColumn"] = $2932c138a6a4fe83$export$2285fc416017f7ef;
module.exports["BlankPageQuickActionsCardContainer"] = $2932c138a6a4fe83$export$61367bcbe6096b19;
module.exports["BlankPageQuickActionsWrapper"] = $2932c138a6a4fe83$export$17a2f9655d167e3f;
module.exports["BlankPageQuickActionsTemplatePreviewWrapper"] = $2932c138a6a4fe83$export$f8e573bbc82f4efb;
module.exports["Link"] = $2932c138a6a4fe83$export$a6c7ac8248d6e38a;
module.exports["BlankPageQuickActionsTemplatePreviewContainer"] = $2932c138a6a4fe83$export$f4922e2dc59c62b7;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("lG7DR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $30D0J = parcelRequire("30D0J");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $2FNNv = parcelRequire("2FNNv");


var $4krqA = parcelRequire("4krqA");


var $9DBk6 = parcelRequire("9DBk6");

const $4eb4c2cd5aab6b56$var$CONFLUENCE_KEY = 'confluence';
const $4eb4c2cd5aab6b56$export$8334391e845b66cf = ()=>{
    const [isEligibleTag, setIsEligibleTag] = (0, $42omo.useState)(false);
    // Contexts and hooks
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // Onboarding state
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).EXPERIMENT_ELIGIBLE_TAG,
        (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).WAS_CONFETTI_SEEN,
        (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
        (0, $9DBk6.LIVE_PAGE_NUDGE).LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN
    ], !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const onboardingState = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { contextualInviteNudgeEligibleTag: contextualInviteNudgeEligibleTag, hasUserPublished: hasUserPublished, wasLivePageNudgeSeen: wasLivePageNudgeSeen } = onboardingState;
    const skip = !isLicensed || onboardingStateLoading || Boolean(contextualInviteNudgeEligibleTag) || Boolean(hasUserPublished) || Boolean(wasLivePageNudgeSeen) || !(0, $9wGTI.fg)('cc_onboarding_experience');
    // User personalization query for isEstablishedUser
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        variables: {
            userId: userId ?? ''
        },
        skip: skip
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    // Combined loading and error states
    const loading = userPersonalizationQueryLoading || onboardingStateLoading;
    const error = userPersonalizationQueryError || onboardingStateError;
    (0, $42omo.useEffect)(()=>{
        if (skip || loading || error || isEstablishedUser) return;
        const fetchInvitePermsAndSetEligibility = async ()=>{
            const response = await (0, $4krqA.memoizedGetInvitePermissions)(cloudId);
            if (response instanceof Error) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'editorOrViewPage',
                    action: 'failed',
                    actionSubject: 'getInvitePermissions',
                    attributes: {
                        message: response?.message
                    }
                }
            }).fire();
            const canInviteToConfluence = [
                ...response?.directInvite ?? [],
                ...response?.invitePendingApproval ?? []
            ].some((item)=>item.includes($4eb4c2cd5aab6b56$var$CONFLUENCE_KEY));
            if (canInviteToConfluence) {
                setOnboardingState({
                    key: (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).EXPERIMENT_ELIGIBLE_TAG,
                    value: 'true'
                });
                setIsEligibleTag(true);
            }
        };
        fetchInvitePermsAndSetEligibility();
    }, [
        error,
        loading,
        skip,
        cloudId,
        contextualInviteNudgeEligibleTag,
        isEstablishedUser,
        setOnboardingState,
        createAnalyticsEvent
    ]);
    return {
        contextualInviteNudgeEligibleTag: Boolean(isEligibleTag || contextualInviteNudgeEligibleTag),
        onboardingState: onboardingState
    };
};
module.exports["useContextualInviteNudge"] = $4eb4c2cd5aab6b56$export$8334391e845b66cf;

});

parcelRegister("30D0J", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
        method: 'GET',
        parseResult: (response)=>({
                experimentalUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables
    });
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("4krqA", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $f7B1p = parcelRequire("f7B1p");

const $205c154f2fef63b0$export$ab2f49a861856bab = '/gateway/api';
const $205c154f2fef63b0$export$df4d1d71f09676b7 = '/v3/invitations/capabilities';
function $205c154f2fef63b0$var$handleCapabilitiesResponse(response) {
    const directInvite = new Set();
    const invitePendingApproval = new Set();
    if (Array.isArray(response)) response.forEach((entry)=>{
        if (!directInvite.has(entry.resourceARI) && 'NONE' !== entry.directInvite.mode) directInvite.add(entry.resourceARI);
        if (!invitePendingApproval.has(entry.resourceARI) && 'NONE' !== entry.invitePendingApproval.mode) invitePendingApproval.add(entry.resourceARI);
    });
    return {
        directInvite: [
            ...directInvite
        ],
        invitePendingApproval: [
            ...invitePendingApproval
        ]
    };
}
// This closely follows the implementation of the client from the Invite People package
// platform/packages/people-and-teams/invite-people/src/clients/InviteApiClient.ts
// This logic is subject to change at any time and should only be used for experimental purposes
const $205c154f2fef63b0$var$getInvitePermissions = async (cloudId)=>{
    const resource = `ari:cloud:platform::site/${cloudId}`;
    try {
        const response = await (0, $f7B1p.cfetch)(`${$205c154f2fef63b0$export$ab2f49a861856bab}${$205c154f2fef63b0$export$df4d1d71f09676b7}?resource=${resource}`);
        const inviteResponse = await response.json();
        return $205c154f2fef63b0$var$handleCapabilitiesResponse(inviteResponse);
    } catch (error) {
        return error;
    }
};
const $205c154f2fef63b0$export$669226fe425132b5 = (0, $2XqLN.default)($205c154f2fef63b0$var$getInvitePermissions);
module.exports["memoizedGetInvitePermissions"] = $205c154f2fef63b0$export$669226fe425132b5;

});

parcelRegister("bFMG7", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $5dyIT = parcelRequire("5dyIT");


var $cod3r = parcelRequire("cod3r");


var $79mss = parcelRequire("79mss");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $e4o8D = parcelRequire("e4o8D");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $1cYlh = parcelRequire("1cYlh");


var $in5LX = parcelRequire("in5LX");


var $kknEZ = parcelRequire("kknEZ");


var $gSfo4 = parcelRequire("gSfo4");


var $fcQxC = parcelRequire("fcQxC");


var $lwZTW = parcelRequire("lwZTW");

const $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery = (0, $79mss.default);
const $8f8b1f599c43d665$export$160e6dbb5cf9582 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus } = t0;
    let t1;
    let t2;
    if ($[0] !== flagStatus || $[1] !== setClassification || $[2] !== setFlagStatus || $[3] !== submittedClassification) {
        t1 = ()=>{
            if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
                setClassification(submittedClassification ?? null);
                setFlagStatus((0, $in5LX.FlagStatus).NONE);
            }
        };
        t2 = [
            flagStatus,
            submittedClassification,
            setClassification,
            setFlagStatus
        ];
        $[0] = flagStatus;
        $[1] = setClassification;
        $[2] = setFlagStatus;
        $[3] = submittedClassification;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ({ flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus })=>{
    // Updates the classification state with the value of submittedClassification
    // on flag success, ensuring consistent behavior across edit tag & edit modal
    (0, $42omo.useEffect)(()=>{
        if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
            setClassification(submittedClassification ?? null);
            setFlagStatus((0, $in5LX.FlagStatus).NONE);
        }
    }, [
        flagStatus,
        submittedClassification,
        setClassification,
        setFlagStatus
    ]);
};
const $8f8b1f599c43d665$export$e948ce957637ade5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(39);
    const { contentId: contentId, contentStatusContext: t1, shouldSkipQueries: t2, shouldPreloadData: t3, shouldReadFromQueries: t4 } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldSkipQueries = t2 === undefined ? false : t2;
    const shouldPreloadData = t3 === undefined ? false : t3;
    const shouldReadFromQueries = t4 === undefined ? false : t4;
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const [flagStatus, setFlagStatus] = (0, $42omo.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $42omo.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $42omo.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $42omo.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    let t5;
    if ($[0] !== flagStatus || $[1] !== submittedClassification) {
        t5 = {
            flagStatus: flagStatus,
            submittedClassification: submittedClassification,
            setClassification: setClassification,
            setFlagStatus: setFlagStatus
        };
        $[0] = flagStatus;
        $[1] = submittedClassification;
        $[2] = t5;
    } else t5 = $[2];
    $8f8b1f599c43d665$export$160e6dbb5cf9582(t5);
    let t6;
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        };
        t7 = (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: t6,
        onCompleted: t7,
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    let t8;
    let t9;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        };
        t9 = (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[5] = t8;
        $[6] = t9;
    } else {
        t8 = $[5];
        t9 = $[6];
    }
    const [deleteContentDataClassificationLevel, t10] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: t8,
        onCompleted: t9,
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    const { loading: deleteLoading } = t10;
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const t11 = contentId ?? "";
    const t12 = (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext);
    let t13;
    if ($[7] !== t11 || $[8] !== t12) {
        t13 = {
            contentId: t11,
            lowerCaseContentStatusArray: t12
        };
        $[7] = t11;
        $[8] = t12;
        $[9] = t13;
    } else t13 = $[9];
    const t14 = shouldPreloadContentClassificationData ? "cache-first" : "network-only";
    let t15;
    if ($[10] !== shouldSkipQueriesForClassification || $[11] !== t13 || $[12] !== t14) {
        t15 = {
            variables: t13,
            skip: shouldSkipQueriesForClassification,
            errorPolicy: "all",
            fetchPolicy: t14
        };
        $[10] = shouldSkipQueriesForClassification;
        $[11] = t13;
        $[12] = t14;
        $[13] = t15;
    } else t15 = $[13];
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, t15);
    const classificationLevelDetails = objectLevelData?.singleContent?.classificationLevelDetails;
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const contentLevelLoading = objectLevelLoading;
    const contentLevelError = objectLevelError;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === "CONTENT";
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    let t16;
    let t17;
    if ($[14] !== classification || $[15] !== contentId || $[16] !== updatedClassification) {
        t16 = ()=>{
            if (updatedClassification !== classification) {
                setClassification(updatedClassification ?? null);
                setCurrentContentId(contentId);
            }
        };
        t17 = [
            updatedClassification,
            classification,
            contentId
        ];
        $[14] = classification;
        $[15] = contentId;
        $[16] = updatedClassification;
        $[17] = t16;
        $[18] = t17;
    } else {
        t16 = $[17];
        t17 = $[18];
    }
    (0, $42omo.useEffect)(t16, t17);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(objectLevelData?.singleContent?.classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    let t18;
    if ($[19] !== objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted) {
        t18 = (objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[19] = objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted;
        $[20] = t18;
    } else t18 = $[20];
    const isReclassificationPermitted = t18;
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    const t19 = classificationValue ?? null;
    const t20 = classificationLevelDetails?.source;
    const t21 = classificationLevelDetails?.canManageSpaceSettings;
    const t22 = classificationLevelDetails?.classificationControlSetting;
    const t23 = classificationLevelDetails?.userOverrideSetting;
    let t24;
    if ($[21] !== classificationFeatureEnabled || $[22] !== contentLevelError || $[23] !== contentLevelLoading || $[24] !== contentStatusContext || $[25] !== deleteContentDataClassificationLevel || $[26] !== errorState || $[27] !== flagStatus || $[28] !== hasNoClassification || $[29] !== isReclassificationPermitted || $[30] !== shouldDisplayClassification || $[31] !== spaceDefaultIsOverridden || $[32] !== t19 || $[33] !== t20 || $[34] !== t21 || $[35] !== t22 || $[36] !== t23 || $[37] !== updateContentDataClassificationLevel) {
        t24 = {
            classification: t19,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: t20,
            canManageSpaceSettings: t21,
            classificationControlSetting: t22,
            userOverrideSetting: t23
        };
        $[21] = classificationFeatureEnabled;
        $[22] = contentLevelError;
        $[23] = contentLevelLoading;
        $[24] = contentStatusContext;
        $[25] = deleteContentDataClassificationLevel;
        $[26] = errorState;
        $[27] = flagStatus;
        $[28] = hasNoClassification;
        $[29] = isReclassificationPermitted;
        $[30] = shouldDisplayClassification;
        $[31] = spaceDefaultIsOverridden;
        $[32] = t19;
        $[33] = t20;
        $[34] = t21;
        $[35] = t22;
        $[36] = t23;
        $[37] = updateContentDataClassificationLevel;
        $[38] = t24;
    } else t24 = $[38];
    return t24;
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldSkipQueries: shouldSkipQueries = false, shouldPreloadData: shouldPreloadData = false, shouldReadFromQueries: shouldReadFromQueries = false })=>{
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const [flagStatus, setFlagStatus] = (0, $42omo.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $42omo.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $42omo.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $42omo.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    $8f8b1f599c43d665$export$160e6dbb5cf9582({
        flagStatus: flagStatus,
        submittedClassification: submittedClassification,
        setClassification: setClassification,
        setFlagStatus: setFlagStatus
    });
    // The following two mutation functions are returned by this hook, behavior upon completion is handled within the hook
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        },
        onCompleted: (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    const [deleteContentDataClassificationLevel, { loading: deleteLoading }] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        },
        onCompleted: (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ]
    });
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        variables: {
            contentId: contentId ?? '',
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
        },
        skip: shouldSkipQueriesForClassification,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadContentClassificationData ? 'cache-first' : 'network-only'
    });
    const classificationLevelDetails = objectLevelData?.singleContent?.classificationLevelDetails;
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const contentLevelLoading = objectLevelLoading;
    const contentLevelError = objectLevelError;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === 'CONTENT';
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    // Determine whether to set classification either content level classification, or space default classification, or null through a series of booleans.
    // Cases where we should not display content classification:
    // 1. If "No classification" option is selected as content classification
    // 2. If content classification was archived
    // 3. If classification value from state hook is null (i.e. classification was deleted) and delete mutation is still loading
    // 4. If delete was successful and classification value from state hook is null
    // 5. If there was an error fetching content level classification
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    // This ternary determines whether to display content classification value from query or from state hook.
    // Checks whether content ID has changed since the last render, and if it has then we display the classification value from query.
    // (Resolves bug where classification wasn't properly updating when navigating between pages via page tree)
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    // Ultimately, we'll be displaying one of the two values as a content's current classification (in order of priority):
    // 1. Content level classification
    // 2. No classification (may render Add Classification button instead)
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    (0, $42omo.useEffect)(()=>{
        if (updatedClassification !== classification) {
            setClassification(updatedClassification ?? null);
            setCurrentContentId(contentId);
        }
    }, [
        updatedClassification,
        classification,
        contentId
    ]);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(objectLevelData?.singleContent?.classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    const isReclassificationPermitted = (objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)('dlp_auto_classifications_enabled', 'isEnabled', false);
    //useEffect is not run during SSR, so we can't use classification from the state.
    //we cant use setClassification either as it causes side effects which causes unnecessary re-renders.
    //Instead, we can use updatedClassification for initial load for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    return (0, $42omo.useMemo)(()=>({
            classification: classificationValue ?? null,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: classificationLevelDetails?.source,
            canManageSpaceSettings: classificationLevelDetails?.canManageSpaceSettings,
            classificationControlSetting: classificationLevelDetails?.classificationControlSetting,
            userOverrideSetting: classificationLevelDetails?.userOverrideSetting
        }), [
        classificationValue,
        spaceDefaultIsOverridden,
        contentLevelLoading,
        contentLevelError,
        updateContentDataClassificationLevel,
        deleteContentDataClassificationLevel,
        setSubmittedClassification,
        flagStatus,
        setFlagStatus,
        errorState,
        shouldDisplayClassification,
        hasNoClassification,
        contentStatusContext,
        classificationFeatureEnabled,
        isReclassificationPermitted,
        classificationLevelDetails
    ]);
};
module.exports["useContentClassification"] = $8f8b1f599c43d665$export$e948ce957637ade5;

});

parcelRegister("5dyIT", function(module, exports) {
/**
 * @generated SignedSource<<7c752eb6f323bf964c21b2559df1876a>>
 * @relayHash ee02cd6160cc1cfee6fa6d1fba84a159
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2
const $916e4ca779bc282e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkDeleteContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkDeleteContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee02cd6160cc1cfee6fa6d1fba84a159",
            "id": "4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2",
            "metadata": {},
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkDeleteContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!){bulkDeleteContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses}){success,errors{message}}}"
        }
    };
}();
$916e4ca779bc282e$var$node.hash = "482a842e925e6082fc32c6749e95ba4b";
var $916e4ca779bc282e$export$2e2bcd8739ae039 = $916e4ca779bc282e$var$node;
module.exports["default"] = $916e4ca779bc282e$export$2e2bcd8739ae039;

});

parcelRegister("cod3r", function(module, exports) {
/**
 * @generated SignedSource<<78d1fb405fb334be892fbd3a5bfc9b17>>
 * @relayHash e435d6d2ef1fb5eebfc9d5c505f1e65c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba
const $cca7f8f2e7a5e122$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "classificationLevelId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "classificationLevelId",
                            "variableName": "classificationLevelId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkUpdateContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkUpdateContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "e435d6d2ef1fb5eebfc9d5c505f1e65c",
            "id": "c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba",
            "metadata": {},
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkUpdateContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!,$classificationLevelId:ID!){bulkUpdateContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses,classificationLevelId:$classificationLevelId}){success,errors{message}}}"
        }
    };
}();
$cca7f8f2e7a5e122$var$node.hash = "9839fe96ab36e63f6aab91bb7d0d00f7";
var $cca7f8f2e7a5e122$export$2e2bcd8739ae039 = $cca7f8f2e7a5e122$var$node;
module.exports["default"] = $cca7f8f2e7a5e122$export$2e2bcd8739ae039;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<7dfc9ee594b400f8b5c43163ad98b1d7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("1cYlh", function(module, exports) {

var $kknEZ = parcelRequire("kknEZ");

const $e02e634ce8a36ce5$export$44086dc4ad5eb01b = 'NO_CLASSIFICATION';
const $e02e634ce8a36ce5$export$ea52aaec0b4536b2 = 'NO_CLASSIFICATION_OPTION';
const $e02e634ce8a36ce5$export$89b67151eed9295a = {
    id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
    name: 'No default',
    order: 0,
    definition: "Pages in this space aren\u2019t classified by default.",
    color: 'NONE',
    status: (0, $kknEZ.Status).PUBLISHED
};
module.exports["NO_CLASSIFICATION"] = $e02e634ce8a36ce5$export$44086dc4ad5eb01b;
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $e02e634ce8a36ce5$export$ea52aaec0b4536b2;
module.exports["NO_CLASSIFICATION_OPTION"] = $e02e634ce8a36ce5$export$89b67151eed9295a;

});

parcelRegister("kknEZ", function(module, exports) {
var $ac489c3aaa697fba$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["PUBLISHED"] = "PUBLISHED";
    Status["ARCHIVED"] = "ARCHIVED";
    Status["DRAFT"] = "DRAFT";
    return Status;
}({});
module.exports["Status"] = $ac489c3aaa697fba$export$96e9906d6d93a972;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("lwZTW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $79yie = parcelRequire("79yie");

const $68e08446abc76753$export$a992cfb755534ea3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (currentClassification, spaceLevelError, contentLevelError)=>{
    const $ = (0, $frIzR.c)(5);
    const [errorState, setErrorState] = (0, $42omo.useState)((0, $79yie.ErrorState).NO_ERROR);
    let t0;
    let t1;
    if ($[0] !== contentLevelError || $[1] !== currentClassification || $[2] !== spaceLevelError) {
        t0 = ()=>{
            if (!currentClassification) {
                if (spaceLevelError || contentLevelError) {
                    if ((0, $aMcHK.isStatusCodeError)(contentLevelError, "404") || (0, $aMcHK.isStatusCodeError)(spaceLevelError, "404")) {
                        (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                        (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                        setErrorState((0, $79yie.ErrorState).NULL);
                    } else setErrorState((0, $79yie.ErrorState).MESSAGE);
                }
            } else {
                if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                setErrorState((0, $79yie.ErrorState).NO_ERROR);
            }
        };
        t1 = [
            currentClassification,
            spaceLevelError,
            contentLevelError
        ];
        $[0] = contentLevelError;
        $[1] = currentClassification;
        $[2] = spaceLevelError;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $42omo.useEffect)(t0, t1);
    return errorState;
} : (currentClassification, spaceLevelError, contentLevelError)=>{
    const [errorState, setErrorState] = (0, $42omo.useState)((0, $79yie.ErrorState).NO_ERROR);
    (0, $42omo.useEffect)(()=>{
        // If error exists, display corresponding components
        if (!currentClassification) {
            if (spaceLevelError || contentLevelError) {
                if ((0, $aMcHK.isStatusCodeError)(contentLevelError, '404') || (0, $aMcHK.isStatusCodeError)(spaceLevelError, '404')) {
                    (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                    (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                    // If there is a handled error (404), return nothing
                    setErrorState((0, $79yie.ErrorState).NULL);
                } else // If there is an unhandled error (a non-404 error), return error message with error displays
                setErrorState((0, $79yie.ErrorState).MESSAGE);
            }
        } else {
            // If there's a content classification, we don't want to render null nor an error message for a space level error. We'll just mark the error as handled.
            if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
            setErrorState((0, $79yie.ErrorState).NO_ERROR);
        }
    }, [
        currentClassification,
        spaceLevelError,
        contentLevelError
    ]);
    return errorState;
};
module.exports["useClassificationErrorState"] = $68e08446abc76753$export$a992cfb755534ea3;

});

parcelRegister("79yie", function(module, exports) {
var $b3b9916290115f64$export$c1ed4f415b9e7023 = /*#__PURE__*/ function(ErrorState) {
    ErrorState["NULL"] = "NULL";
    ErrorState["MESSAGE"] = "MESSAGE";
    ErrorState["NO_ERROR"] = "NO_ERROR";
    return ErrorState;
}({});
module.exports["ErrorState"] = $b3b9916290115f64$export$c1ed4f415b9e7023;

});

parcelRegister("l2hqi", function(module, exports) {
var $d6376875f96c1896$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $d6376875f96c1896$export$2df6d049e5bad28e;

});

parcelRegister("fMO7O", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3pfAb = parcelRequire("3pfAb");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8Lx5S = parcelRequire("8Lx5S");


var $lyF5K = parcelRequire("lyF5K");


var $ftdAe = parcelRequire("ftdAe");


var $dUYlk = parcelRequire("dUYlk");


var $e8W3S = parcelRequire("e8W3S");


var $ebwTS = parcelRequire("ebwTS");

const $f160a6540be71b28$var$TRACK_EVENT = 'sendTrackEvent';
const $f160a6540be71b28$var$ANALYTICS_SOURCE = 'guestAttemptedMention';
const $f160a6540be71b28$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    mentionFlagTitle: {
        id: "external-collab-ui.guest-mention.restricted.flag.title",
        defaultMessage: "You can\u2019t mention people as a guest"
    },
    mentionFlagDescription: {
        id: "external-collab-ui.guest-mention.restricted.flag.description",
        defaultMessage: "To mention people, you need full access to Confluence."
    },
    learnMoreButton: {
        id: "external-collab-ui.guest-mention.learn-more-button",
        defaultMessage: "Learn more"
    },
    flagSuccessTitle: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-success-title",
        defaultMessage: "Licensed user request sent!"
    },
    flagSuccessDescription: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-success-description",
        defaultMessage: "If approved, you\u2019ll get a confirmation message from admin"
    },
    flagErrorTitle: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-error-title",
        defaultMessage: "Request not sent"
    },
    flagErrorDescription: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-error-description",
        defaultMessage: "Refresh the page to resubmit your request, or try again later."
    }
});
const $f160a6540be71b28$var$requestButtonContainerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.150',
    marginTop: 'space.negative.025'
});
const $f160a6540be71b28$var$learnMoreButtonContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.025'
});
const $f160a6540be71b28$export$f9673a1f06bb6e52 = ({ children: children, dialogs: dialogs, flags: flags, suppressListener: suppressListener = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [attemptedMention, setAttemptedMention] = (0, $42omo.useState)(false);
    const [flagNeedsUpdate, setFlagNeedsUpdate] = (0, $42omo.useState)(false);
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const shouldDisplayGuestUpgradeFlow = isGuest && attemptedMention;
    const handleFlagClose = (0, $42omo.useCallback)(()=>{
        flags.hideAllFlags();
        setAttemptedMention(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'flag',
                actionSubjectId: 'guestMentionRequestAccess',
                source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                attributes: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        flags
    ]);
    const showErrorFlag = (0, $42omo.useCallback)((submissionError)=>{
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.flagErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.flagErrorDescription)
        });
        experienceTracker.fail({
            name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE),
            error: submissionError
        });
    }, [
        experienceTracker,
        flags
    ]);
    const onGuestUpgradeRequestSubmitted = (0, $42omo.useCallback)(()=>{
        handleFlagClose();
        flags.showSuccessFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.flagSuccessTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.flagSuccessDescription)
        });
        experienceTracker.succeed({
            name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE)
        });
    }, [
        experienceTracker,
        flags,
        handleFlagClose
    ]);
    const handleOnSubmit = (error)=>{
        createAnalyticsEvent({
            type: $f160a6540be71b28$var$TRACK_EVENT,
            data: {
                action: !!error ? 'failed' : 'requested',
                actionSubject: 'productAccess',
                source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                attributes: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            }
        }).fire();
        if (!error) onGuestUpgradeRequestSubmitted();
        else showErrorFlag(error);
    };
    const [submitGuestUpgradeRequest, { loading: guestUpgradeRequestIsLoading, isSubmitted: guestUpgradeSubmitted }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: handleOnSubmit
    });
    const { upgradeStatus: upgradeStatus, loading: permissionLoading } = (0, $lyF5K.useGuestRequestToUpgradeStatus)(!shouldDisplayGuestUpgradeFlow);
    const permissionDenied = upgradeStatus === (0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL;
    const requestPending = guestUpgradeSubmitted || upgradeStatus === (0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING;
    (0, $42omo.useEffect)(()=>{
        if (permissionLoading || !shouldDisplayGuestUpgradeFlow) return;
        const submitGuestUpgradeRequestWithAnalytics = (_, analyticsEvent)=>{
            setFlagNeedsUpdate(true);
            const analyticsAttributes = {
                ...analyticsEvent.payload.attributes,
                touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
            };
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    ...analyticsEvent.payload,
                    actionSubjectId: 'submitGuestUpgradeRequest',
                    source: 'guestRequestAccess',
                    attributes: analyticsAttributes
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE)
            });
            submitGuestUpgradeRequest();
        };
        const handleOnSubmit = (error)=>{
            createAnalyticsEvent({
                type: $f160a6540be71b28$var$TRACK_EVENT,
                data: {
                    action: !!error ? 'failed' : 'requested',
                    actionSubject: 'productAccess',
                    source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                    attributes: {
                        touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                    }
                }
            }).fire();
            if (!error) onGuestUpgradeRequestSubmitted();
            else showErrorFlag(error);
        };
        const openLearnMoreModal = (_, analyticsEvent)=>{
            handleFlagClose();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    ...analyticsEvent.payload,
                    actionSubjectId: 'guestUpgradeRequestLearnMore',
                    source: 'guestRequestAccess',
                    attributes: {
                        requested: requestPending
                    }
                }
            }).fire();
            dialogs.showModal((0, $dUYlk.GuestRequestToUpgradeLearnMoreDialogModal), {
                onSubmit: handleOnSubmit,
                requestPending: requestPending,
                analytics: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            });
        };
        const requestUpgradeFlagId = 'guest-request-upgrade-flag';
        if (attemptedMention && flags.state.flags.length === 0) {
            flags.showCustomFlag({
                id: requestUpgradeFlagId,
                title: formatMessage($f160a6540be71b28$export$a7357cdd1f0b0168.mentionFlagTitle),
                description: formatMessage($f160a6540be71b28$export$a7357cdd1f0b0168.mentionFlagDescription),
                isAutoDismiss: false,
                onClose: handleFlagClose,
                actions: permissionDenied ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: $f160a6540be71b28$var$requestButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
                            appearance: "link",
                            requestPending: requestPending,
                            loading: guestUpgradeRequestIsLoading,
                            onClick: submitGuestUpgradeRequestWithAnalytics
                        }))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: $f160a6540be71b28$var$learnMoreButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                            appearance: "link",
                            onClick: openLearnMoreModal
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.learnMoreButton)))
                    }
                ]
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'button',
                    actionSubjectId: 'submitGuestUpgradeRequest',
                    source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                    attributes: {
                        touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                    }
                }
            }).fire();
        } else if (flagNeedsUpdate && guestUpgradeRequestIsLoading && flags.state.flags.length === 1) {
            flags.updateFlag(requestUpgradeFlagId, {
                actions: permissionDenied ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: $f160a6540be71b28$var$requestButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
                            appearance: "link",
                            requestPending: requestPending,
                            loading: guestUpgradeRequestIsLoading,
                            onClick: submitGuestUpgradeRequestWithAnalytics
                        }))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                            xcss: $f160a6540be71b28$var$learnMoreButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                            appearance: "link",
                            onClick: openLearnMoreModal
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.learnMoreButton)))
                    }
                ]
            });
            setFlagNeedsUpdate(false);
        }
    }, [
        attemptedMention,
        createAnalyticsEvent,
        dialogs,
        experienceTracker,
        flags,
        flagNeedsUpdate,
        formatMessage,
        guestUpgradeRequestIsLoading,
        handleFlagClose,
        onGuestUpgradeRequestSubmitted,
        permissionDenied,
        permissionLoading,
        requestPending,
        setFlagNeedsUpdate,
        shouldDisplayGuestUpgradeFlow,
        showErrorFlag,
        submitGuestUpgradeRequest
    ]);
    const handleGuestMentionEvent = (event)=>{
        const { actionSubject: actionSubject, actionSubjectId: actionSubjectId } = event.payload;
        if (actionSubject === 'typeAhead' && actionSubjectId === 'mentionTypeAhead') setTimeout(()=>{
            setAttemptedMention(true);
        }, 5);
    };
    if (!isGuest || suppressListener) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleGuestMentionEvent,
        channel: (0, $3pfAb.FabricChannel).editor
    }, children);
};
module.exports["GuestMentionsNotificationsWrapper"] = $f160a6540be71b28$export$f9673a1f06bb6e52;

});

parcelRegister("lyF5K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $f7B1p = parcelRequire("f7B1p");


var $ebwTS = parcelRequire("ebwTS");

const $14503a2aea2a4136$export$1ee9ed72ffc111c1 = [
    // If a guest has "direct access", they will simply upgrade to a user immediately upon submitting a request without needing admin approval.
    (0, $ebwTS.CapabilityValues).DIRECT_ACCESS,
    // ... otherwise, they have the ability to request access, and wait for admin approval.
    (0, $ebwTS.CapabilityValues).REQUEST_ACCESS
];
const $14503a2aea2a4136$export$3ed095546414dc67 = [
    // The ones a Guest should never get, but technically exist on the endpoint:
    (0, $ebwTS.CapabilityValues).ACCESS_EXISTS,
    (0, $ebwTS.CapabilityValues).APPROVED_REQUEST_EXISTS,
    // The ones we expect to potentially get:
    (0, $ebwTS.CapabilityValues).DENIED_REQUEST_EXISTS,
    (0, $ebwTS.CapabilityValues).FORBIDDEN
];
const $14503a2aea2a4136$export$4e4260b083de0708 = 'product/member';
const $14503a2aea2a4136$export$d3e4104c62036f39 = (skip = false)=>{
    // if skip is true, we are not going to fetch the status, so we're not loading anything and it can be false
    // if skip is false, we are going to fetch the status and invoke API immediately, so loading can be true (same as previous implementation)
    const [loading, setLoading] = (0, $42omo.useState)(!skip);
    const [error, setError] = (0, $42omo.useState)();
    const [upgradeStatus, setUpgradeStatus] = (0, $42omo.useState)(undefined);
    const [upgradeStatusReason, setUpgradeStatusReason] = (0, $42omo.useState)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fetchGuestUpgradeRequestStatus = (0, $42omo.useCallback)(async ()=>{
        setLoading(true);
        const resource = `ari:cloud:confluence::site/${cloudId}`;
        const params = new URLSearchParams({
            resource: resource
        });
        return (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>{
            const statusArray = data.resultsV2[resource];
            const userCapabilityEntry = statusArray.find((entry)=>entry.role === $14503a2aea2a4136$export$4e4260b083de0708) || {};
            const status = userCapabilityEntry.accessMode;
            setUpgradeStatusReason(status);
            if ($14503a2aea2a4136$export$3ed095546414dc67.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            else if (status === (0, $ebwTS.CapabilityValues).PENDING_REQUEST_EXISTS) setUpgradeStatus((0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING);
            else if ($14503a2aea2a4136$export$1ee9ed72ffc111c1.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).CAN_REQUEST);
            else // We didn't get a valid value
            throw Error(`Did not receive a valid value for the accessMode status: ${status}.`);
        }).catch((caughtError)=>{
            // If anything fails, we just state you're not eligible, because we can't confirm it.
            setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            setError(caughtError instanceof Error ? caughtError : new Error('Guest request to upgrade status load error', {
                cause: caughtError
            }));
        }).finally(()=>setLoading(false));
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        fetchGuestUpgradeRequestStatus();
    }, [
        fetchGuestUpgradeRequestStatus,
        skip
    ]);
    return {
        upgradeStatus: upgradeStatus,
        upgradeStatusReason: upgradeStatusReason,
        loading: loading,
        error: error
    };
};
module.exports["useGuestRequestToUpgradeStatus"] = $14503a2aea2a4136$export$d3e4104c62036f39;

});

parcelRegister("ebwTS", function(module, exports) {
const $2f24b685c1e47a17$export$408edfc5a854220e = {
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    APPROVED_REQUEST_EXISTS: 'APPROVED_REQUEST_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
var $2f24b685c1e47a17$export$309264bca7eef03f = /*#__PURE__*/ function(UpgradeStatus) {
    UpgradeStatus["CAN_REQUEST"] = "CAN_REQUEST";
    UpgradeStatus["AN_UPGRADE_REQUEST_IS_PENDING"] = "AN_UPGRADE_REQUEST_IS_PENDING";
    UpgradeStatus["NOT_ELIGIBLE_TO_UPGRADE_AT_ALL"] = "NOT_ELIGIBLE_TO_UPGRADE_AT_ALL";
    return UpgradeStatus;
}({});
module.exports["CapabilityValues"] = $2f24b685c1e47a17$export$408edfc5a854220e;
module.exports["UpgradeStatus"] = $2f24b685c1e47a17$export$309264bca7eef03f;

});

parcelRegister("ftdAe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9YwaJ = parcelRequire("9YwaJ");

const $141cc20ec350ae53$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    requestToUpgradeButton: {
        id: "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-button",
        defaultMessage: "Request full access"
    },
    requestToUpgradePendingButton: {
        id: "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-pending-button",
        defaultMessage: "Request pending approval"
    }
});
const $141cc20ec350ae53$export$2e85b5934aa19199 = ({ appearance: appearance, requestPending: requestPending, loading: loading, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        appearance: appearance,
        isDisabled: requestPending,
        isLoading: loading,
        onClick: onClick
    }, requestPending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $141cc20ec350ae53$export$a7357cdd1f0b0168.requestToUpgradePendingButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $141cc20ec350ae53$export$a7357cdd1f0b0168.requestToUpgradeButton));
module.exports["GuestRequestUpgradeButton"] = $141cc20ec350ae53$export$2e85b5934aa19199;

});

parcelRegister("dUYlk", function(module, exports) {
/* GuestRequestToUpgradeLearnMoreModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $cO1el = parcelRequire("cO1el");


var $8TTLA = parcelRequire("8TTLA");

var $8o1lj = parcelRequire("8o1lj");


var $eEA8O = parcelRequire("eEA8O");


var $5nBzc = parcelRequire("5nBzc");


var $3sFtD = parcelRequire("3sFtD");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $lsxnT = parcelRequire("lsxnT");


var $7pv6k = parcelRequire("7pv6k");


var $eveQW = parcelRequire("eveQW");


var $ftdAe = parcelRequire("ftdAe");


var $e8W3S = parcelRequire("e8W3S");

const $6f1a718cab8b04f2$var$i18n = (0, $aXWIB.defineMessages)({
    guestRequestToUpgradeLearnMoreModalTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-title",
        defaultMessage: "Request licensed user access to join your teammates"
    },
    guestRequestToUpgradeLearnMoreModalTitleSpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-title-spaces-menu",
        defaultMessage: "Request full access"
    },
    guestRequestToUpgradeLearnMoreModalCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-copy",
        defaultMessage: "You are a guest on this Confluence site. Request licensed user access to unlock new features, and an admin will review your request."
    },
    guestRequestToUpgradeLearnMoreModalCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-copy-spaces-menu",
        defaultMessage: "As a guest, you have limited access to this Confluence site but can request full access to unlock new ways to collaborate."
    },
    guestRequestToUpgradeLearnMoreModalGuestCardTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-title",
        defaultMessage: "Guest"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-title-lozenge",
        defaultMessage: "YOU"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-copy",
        defaultMessage: "Your admin may further restrict your functionality from these default settings."
    },
    guestRequestToUpgradeLearnMoreModalGuestCardCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-copy-spaces-menu",
        defaultMessage: "Your access is limited to:"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowOne: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-benefit-row-one",
        defaultMessage: "View, create, and edit in this space"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowTwo: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-benefit-row-two",
        defaultMessage: "Leave comments in this space"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-title",
        defaultMessage: "Licensed user"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardTitleSpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-title-spaces-menu",
        defaultMessage: "Full access"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-copy",
        defaultMessage: "Everything in guest plus,"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-copy-spaces-menu",
        defaultMessage: "Unlocks:"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowOne: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-one",
        defaultMessage: "Create your own space"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowTwo: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-two",
        defaultMessage: "View and collaborate in other spaces"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowThree: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-three",
        defaultMessage: "See other people\u2019s profiles"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFour: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-four",
        defaultMessage: "Mention other people"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFive: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-five",
        defaultMessage: "Create and join teams"
    },
    guestRequestToUpgradeLearnMoreModalFooterSecondaryButton: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-footer-secondary-button",
        defaultMessage: "Maybe later"
    },
    guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-footer-secondary-button-when-primary-disabled",
        defaultMessage: "Close"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1bsb1osq _vchhusvi _y3gn1h6o _ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalCopy = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8kzvm _1yt45gjp _p12f1lk4 _vchhusvi _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$ValuePropCardContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1ejb _1yt45gjp _1e0c1txw _1n261q9c _otyrv77o _dl4n1g80",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$ValuePropCard = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itno8c _2rkog72m _16jlkb7n _1o9zkb7n _i0dl5x59 _vchhusvi _1e0c1txw _2lx21bp4 _1n261g80 _4cvr1y6m _1tke7ivc _16qst7xp",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardTitleImage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8glhf _1bsb1osq _4t3ixncg",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81af2 _zulpu2gc _1yt41big _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _vchhusvi _y3gn1h6o _19pkidpf",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardContent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt45gjp _y3gn1e5h",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardCopy = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyrv47k _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$BenefitRowContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _otyru2gc",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$GUEST_BENEFITS = [
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowOne
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowTwo
    }
];
const $6f1a718cab8b04f2$var$USER_BENEFITS = [
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowOne,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowTwo,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowThree,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFour,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFive,
        highlighted: true
    }
];
const $6f1a718cab8b04f2$var$BenefitRow = ({ highlighted: highlighted = false, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        color: highlighted ? "var(--ds-icon-success, #6A9A23)" : "var(--ds-icon-accent-gray, #7D818A)",
        spacing: "none",
        label: ""
    }), children);
};
const $6f1a718cab8b04f2$var$determineCloseTrigger = (event, analyticsEvent)=>{
    return analyticsEvent.payload.actionSubject === 'button' ? 'closeButton' : analyticsEvent.payload.actionSubject === 'modalDialog' ? event instanceof KeyboardEvent && event.key === 'Escape' ? 'escapeKey' : 'outsideClick' : 'unknown';
};
const $6f1a718cab8b04f2$export$adda263aa585eebf = ({ onSubmit: onSubmit, requestPending: requestPending, closeModal: closeModal, analytics: analytics })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const headerRef = (0, $42omo.useRef)(null);
    const [submitGuestUpgradeRequest, { loading: loading }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: onSubmit
    });
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analytics
    ]);
    const scrollToTop = ()=>headerRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    const submitGuestUpgradeRequestWithAnalytics = async (_, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                ...analyticsEvent.payload,
                actionSubjectId: 'submitGuestUpgradeRequest',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        experienceTracker.start({
            name: (0, $irVI7.SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE)
        });
        await submitGuestUpgradeRequest();
        closeModal();
    };
    const closeModalWithAnalytics = (event, analyticsEvent)=>{
        closeModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'guestRequestAccessValuePropModal',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    requested: requestPending,
                    closeTrigger: $6f1a718cab8b04f2$var$determineCloseTrigger(event, analyticsEvent),
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    };
    const secondaryButtonCopy = requestPending ? $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled : $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pv6k)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopy)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eveQW)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    })));
};
const $6f1a718cab8b04f2$export$c9be8187bfbfd769 = ({ onClose: onClose, onCloseComplete: onCloseComplete, onSubmit: onSubmit, requestPending: requestPending, analytics: analytics, isSpacesMenu: isSpacesMenu = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const headerRef = (0, $42omo.useRef)(null);
    const [submitGuestUpgradeRequest, { loading: loading }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: onSubmit
    });
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analytics
    ]);
    const scrollToTop = ()=>headerRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    const submitGuestUpgradeRequestWithAnalytics = async (_, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                ...analyticsEvent.payload,
                actionSubjectId: 'submitGuestUpgradeRequest',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        experienceTracker.start({
            name: (0, $irVI7.SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE)
        });
        await submitGuestUpgradeRequest();
        onClose();
    };
    const closeModalWithAnalytics = (event, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'guestRequestAccessValuePropModal',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    requested: requestPending,
                    closeTrigger: $6f1a718cab8b04f2$var$determineCloseTrigger(event, analyticsEvent),
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        onClose();
    };
    const secondaryButtonCopy = requestPending ? $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled : $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButton;
    return isSpacesMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onCloseComplete: onCloseComplete,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitleSpacesMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopySpacesMenu)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pv6k)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopySpacesMenu)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eveQW)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitleSpacesMenu)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopySpacesMenu)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onCloseComplete: onCloseComplete,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pv6k)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopy)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eveQW)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    })));
};
const $6f1a718cab8b04f2$export$aa10072a5720d721 = (args)=>(closeModal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f1a718cab8b04f2$export$adda263aa585eebf, {
            ...args,
            closeModal: closeModal
        });
module.exports["GuestRequestToUpgradeLearnMoreModal"] = $6f1a718cab8b04f2$export$adda263aa585eebf;
module.exports["GuestRequestToUpgradeLearnMoreDialogModal"] = $6f1a718cab8b04f2$export$c9be8187bfbfd769;
module.exports["GuestRequestToUpgradeLearnMoreModalFactory"] = $6f1a718cab8b04f2$export$aa10072a5720d721;

});

parcelRegister("7pv6k", function(module, exports) {
module.exports = new URL("Guest-Avatar.ebdf69f1.svg", import.meta.url).toString();

});

parcelRegister("eveQW", function(module, exports) {
module.exports = new URL("Team-Avatars.4f1b07ad.svg", import.meta.url).toString();

});

parcelRegister("e8W3S", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bQm3c = parcelRequire("bQm3c");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $eh0mb = parcelRequire("eh0mb");

const $b1ebfcc93144065b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    upgradeRequestNote: {
        id: "external-collab-ui.guest-request-to-upgrade.upgrade-request-note",
        defaultMessage: "This guest requested a Confluence license"
    }
});
const $b1ebfcc93144065b$export$4f101f8b41ecae81 = (cloudId, upgradeRequestNote)=>JSON.stringify({
        resource: `ari:cloud:confluence::site/${cloudId}`,
        note: upgradeRequestNote
    });
const $b1ebfcc93144065b$export$1fcc21aa81264365 = '/gateway/api/invitations/v1/access-requests/request';
const $b1ebfcc93144065b$export$dce8274ecfbb9f9e = ({ onCompleted: onCompleted })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [{ requestAccessState: requestAccessState }, { setRequestAccessState: setRequestAccessState }] = (0, $eh0mb.useGuestRequestUpgradeStore)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const submitGuestUpgradeRequest = (0, $42omo.useCallback)(async ()=>{
        setRequestAccessState('loading');
        return (0, $f7B1p.cfetch)($b1ebfcc93144065b$export$1fcc21aa81264365, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $b1ebfcc93144065b$export$4f101f8b41ecae81(cloudId, intl.formatMessage($b1ebfcc93144065b$export$a7357cdd1f0b0168.upgradeRequestNote))
        }).then((response)=>{
            if (response.ok && response.status === 200) {
                setRequestAccessState('submitted');
                onCompleted();
            } else {
                setRequestAccessState(undefined);
                throw new (0, $hBkCm.BadStatusError)(`${response.status}: ${response.statusText}`, response);
            }
        }).catch((caughtError)=>{
            setRequestAccessState(undefined);
            onCompleted(caughtError instanceof Error ? caughtError : new Error('Unknown error occurred during submission'));
        });
    }, [
        cloudId,
        intl,
        onCompleted,
        setRequestAccessState
    ]);
    return [
        submitGuestUpgradeRequest,
        {
            loading: requestAccessState === 'loading',
            isSubmitted: requestAccessState === 'submitted'
        }
    ];
};
module.exports["useSubmitGuestUpgradeRequest"] = $b1ebfcc93144065b$export$dce8274ecfbb9f9e;

});

parcelRegister("eh0mb", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4708f874261747c2$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        requestAccessState: undefined
    },
    actions: {
        setRequestAccessState: (value)=>({ setState: setState })=>{
                setState({
                    requestAccessState: value
                });
            }
    },
    name: 'guestRequestUpgradeStore'
});
const $4708f874261747c2$export$b72090e4288882db = (0, $9zUhf.createHook)($4708f874261747c2$var$Store);
module.exports["useGuestRequestUpgradeStore"] = $4708f874261747c2$export$b72090e4288882db;

});

parcelRegister("b1pD4", function(module, exports) {
$parcel$export(module.exports, "CommentsSectionLoader", () => (parcelRequire("3ACqI")).CommentsSectionLoader);

var $3ACqI = parcelRequire("3ACqI");


});

parcelRegister("3ACqI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $hnvzE = parcelRequire("hnvzE");


var $io723 = parcelRequire("io723");


var $7wZQP = parcelRequire("7wZQP");


var $jmjWc = parcelRequire("jmjWc");


var $deTj5 = parcelRequire("deTj5");


var $6Hogt = parcelRequire("6Hogt");


var $2YUV8 = parcelRequire("2YUV8");


var $dDqLo = parcelRequire("dDqLo");


var $3Am3T = parcelRequire("3Am3T");


var $bQm3c = parcelRequire("bQm3c");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


const $bab3bd054370fc67$export$a378d01c696bd81e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZ3wU",
    name: "CommentsSectionFabric",
    // eslint-disable-next-line react/prop-types
    //@ts-ignore
    loading: ({ handlePageCommentsRender: handlePageCommentsRender })=>{
        return !handlePageCommentsRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), null) : null;
    },
    loader: ()=>//@ts-ignore
        (parcelRequire("dFIln"))
});

const $bab3bd054370fc67$export$4740f0dffd11e693 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y3qpe",
    name: "CommentsSectionFabricPaint",
    loader: ()=>//@ts-ignore
        (parcelRequire("dFIln"))
});
const $bab3bd054370fc67$export$2fa3aacacd7711f1 = ({ contentId: contentId, ...props })=>{
    // This information is available in the CommentsCountContext, but it also needs to be available to the legacy class
    // component so passing in directly from the hook as well
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $dDqLo.useCommentCounts)(contentId);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const allowNestedComments = (0, $2YUV8.useAllowNestedComments)();
    const commentsDataActions = (0, $8i27m.useCommentsDataActions)();
    const { refetch: refetchActiveComments } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId
    });
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "page-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC),
        isCustomStart: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7wZQP.PageSegmentLoadMark), {
        markName: "pageCommentsRenderStart",
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC)
    }), (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$4740f0dffd11e693, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: refetchActiveComments
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bab3bd054370fc67$export$a378d01c696bd81e, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: refetchActiveComments
    }))));
};
$bab3bd054370fc67$export$2fa3aacacd7711f1.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired
};
module.exports["CommentsSectionLoader"] = $bab3bd054370fc67$export$2fa3aacacd7711f1;

});

parcelRegister("io723", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1AtJA = parcelRequire("1AtJA");


var $dZzho = parcelRequire("dZzho");

const $cd95c7f874921f86$export$f11db193fdaffcc9 = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dZzho.UFOSegmentLoadStart), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1AtJA.Bm3PageSegmentLoadStart), props);
};
module.exports["PageSegmentLoadStart"] = $cd95c7f874921f86$export$f11db193fdaffcc9;

});

parcelRegister("1AtJA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $2994f14f1333f67a$var$noop = ()=>{};
const $2994f14f1333f67a$var$Bm3PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $2994f14f1333f67a$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $2994f14f1333f67a$export$d807afe46329fe8a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($2994f14f1333f67a$var$Bm3PageSegmentLoadStartComponent);
module.exports["Bm3PageSegmentLoadStart"] = $2994f14f1333f67a$export$d807afe46329fe8a;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("dZzho", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $762a25b728d4d734$var$noop = ()=>{};
const $762a25b728d4d734$var$EMBEDDED_PREFIX = 'embedded-';
const $762a25b728d4d734$var$UFOSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $762a25b728d4d734$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY })=>{
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    const prefixedKey = isEmbedded ? `${$762a25b728d4d734$var$EMBEDDED_PREFIX}${metric.key}` : metric.key;
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
            onComplete();
        }
    }, [
        metric,
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $762a25b728d4d734$export$30c533f25ae06bb = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($762a25b728d4d734$var$UFOSegmentLoadStartComponent);
module.exports["UFOSegmentLoadStart"] = $762a25b728d4d734$export$30c533f25ae06bb;

});

parcelRegister("18R9N", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $42omo.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("deTj5", function(module, exports) {
/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _i0dl1osq _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkizff _1bsbzwfg _4t3izwfg _19pk1b66 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n7zlia51 _1sb2f705 _1e0c1ule _otyrpxbi _ca0qutpp _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _1bsb1osq _4t3i1ylp _syaz1rpy _ca0qze3t _1e0c1o8l _s7n4jp4b _18u0u2gc _16jlkb7n _bfhkizff",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c11p5 _yv0ehpgh _727q19bv _bfhk1j28 _1bsbdgin _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lzmlf _1yt45uws _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nd5lbahz _1yt41h4g _19itglyw _2rkofajl _bfhkizff _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (window.__SSR_RENDERED__ || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};
module.exports["CommentPlaceholder"] = $c27f350b69a05b43$export$46096a93b7c122b2;

});

parcelRegister("6Hogt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});
module.exports["PAGE_COMMENTS_METRIC"] = $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("2YUV8", function(module, exports) {

var $4UfTc = parcelRequire("4UfTc");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $jMyy4 = parcelRequire("jMyy4");

const $d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery = (0, $4UfTc.default);
const $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE = new Date(Date.UTC(2025, 2, 6)); // 6th March 2025. Only month is 0 indexed.
const $d2978a0663607f28$export$3044701888c6e050 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: createdDateData, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: 'current'
        },
        skip: !contentId
    });
    const pageCreatedDate = createdDateData?.content?.nodes?.[0]?.metadata?.createdDate;
    const isLivePage = pageMode === (0, $cD1qu.PageMode).LIVE;
    if (loading || error || !pageCreatedDate) return false;
    const pageCreateDateObject = new Date(pageCreatedDate);
    const isBeforeLaunchDate = pageCreateDateObject < $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE;
    return isBeforeLaunchDate && !isLivePage;
};
module.exports["useAllowNestedComments"] = $d2978a0663607f28$export$3044701888c6e050;

});

parcelRegister("4UfTc", function(module, exports) {
/**
 * @generated SignedSource<<26a195bcd2a94533553d8d2728320939>>
 * @relayHash 1b34c24939127448f5c00dae3686d441
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c221363cc883efefab5cfa0e3ab169a67cfbd5e0421720c08604343009f0248
const $59a2e4a8bcae6006$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "status.0",
                            "variableName": "status"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b34c24939127448f5c00dae3686d441",
            "id": "4c221363cc883efefab5cfa0e3ab169a67cfbd5e0421720c08604343009f0248",
            "metadata": {},
            "name": "useAllowNestedCommentsDetailsPanelContentCreatedDateQuery",
            "operationKind": "query",
            "text": "query useAllowNestedCommentsDetailsPanelContentCreatedDateQuery($contentId:ID!,$status:String!){content(id:$contentId,status:[$status]){nodes{id,metadata{createdDate}}}}"
        }
    };
}();
$59a2e4a8bcae6006$var$node.hash = "654d747af6c04558b92d70397d0023f0";
var $59a2e4a8bcae6006$export$2e2bcd8739ae039 = $59a2e4a8bcae6006$var$node;
module.exports["default"] = $59a2e4a8bcae6006$export$2e2bcd8739ae039;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $dkkKv = parcelRequire("dkkKv");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $aPT9H = parcelRequire("aPT9H");

const $c085ac79a8833850$export$453b7c79178856e5 = (contentId)=>{
    // Always call both hooks to follow React rules, but skip the queries conditionally
    // Legacy implementation using CommentsSectionQuery
    const legacyResult = (0, $aPT9H.useCommentCountsLegacy)(contentId);
    // New comments data manager - get processed data from the store
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // ActiveCommentsQuery implementation - used when cc_comments_new_comments_data_manager is disabled
    // Call without type filter to get both inline and footer comments, then filter by location.type
    const { data: allCommentsData } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        // Don't pass type to get all comment types (both CommentType.INLINE and CommentType.FOOTER)
        skip: !contentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    return (0, $42omo.useMemo)(()=>{
        // Priority 1: Use new comments data manager when enabled
        if (processedCommentsData.isDataProcessed && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            const unresolvedInlineCommentsCount = processedCommentsData.openInlineComments.length;
            const footerCommentsCount = processedCommentsData.openFooterComments.length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 2: Use ActiveCommentsQuery when cc_comments_new_comments_data_manager is disabled
        if (allCommentsData?.comments?.nodes && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // New implementation using ActiveCommentsQuery
            // ActiveCommentsQuery already filters by commentState: UNRESOLVED, so all comments are unresolved
            // Filter comments by location.type to count inline vs footer separately
            const unresolvedInlineCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'INLINE').length;
            const footerCommentsCount = allCommentsData.comments.nodes.filter((node)=>node?.location?.type === 'FOOTER').length;
            return {
                unresolvedInlineCommentsCount: unresolvedInlineCommentsCount,
                footerCommentsCount: footerCommentsCount
            };
        }
        // Priority 3: Legacy implementation using CommentsSectionQuery
        // Return legacy result if available, otherwise return default values
        if (legacyResult && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return legacyResult;
        // Fallback when experiment is enabled but data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        processedCommentsData.isDataProcessed,
        processedCommentsData.openInlineComments.length,
        processedCommentsData.openFooterComments.length,
        allCommentsData?.comments?.nodes,
        legacyResult
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});

parcelRegister("aPT9H", function(module, exports) {

var $k8e76 = parcelRequire("k8e76");


var $ftXPY = parcelRequire("ftXPY");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $l5y3Y = parcelRequire("l5y3Y");


var $jMyy4 = parcelRequire("jMyy4");

const $a2300d29b43bb5dd$export$e32e67cfb7516912 = (contentId)=>{
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    // Instead of requesting 0 comments with the 'first' param here I am reusing the query that is preloaded and fetched
    // for page comments themselves. This allows me to take advantage of the caching and updates that occur in the
    // legacy classes. I've also just marked all errors as handled as we don't particularly care about the results here
    // and the page comments component has much more robust error handling than we'd want to add here.
    const { data: footerCommentsData, error: error } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- This is not preloaded but there is a name collision with a preloaded query
    isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), {
        variables: {
            contentId: contentId,
            offset: '',
            first: 100
        },
        fetchPolicy: window.__SSR_RENDERED__ && (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? 'cache-first' : undefined,
        skip: (0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !contentId
    });
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    // Return undefined when feature gate or experiment is enabled
    if ((0, $9wGTI.fg)('confluence_comment_use_active_comment_query') || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return undefined;
    return {
        unresolvedInlineCommentsCount: (unresolvedInlineComments && unresolvedInlineComments.length) ?? 0,
        footerCommentsCount: (footerCommentsData && footerCommentsData.comments?.totalCount) ?? 0
    };
};
module.exports["useCommentCountsLegacy"] = $a2300d29b43bb5dd$export$e32e67cfb7516912;

});

parcelRegister("ftXPY", function(module, exports) {

var $Tbcfi = parcelRequire("Tbcfi");


var $f4AIb = parcelRequire("f4AIb");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $f4AIb.default);
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $Tbcfi.default);
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("Tbcfi", function(module, exports) {
/**
 * @generated SignedSource<<7207e04783d25c645f010526101734ac>>
 * @relayHash 4e66a1ed92ecc98e74128ce3557c84b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d7c6c79929eb2196d98aff2b51eba75c385f34e79e699de05c60f756a38000c
const $c6cf5a908bbe58bf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "offset"
        },
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "FOOTER"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v5 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v14 = {
        "kind": "ScalarField",
        "name": "value"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v15 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v18 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v15 /*: any*/ 
    }, v19 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v20 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v24 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "kind": "ScalarField",
        "name": "when"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v33 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v35 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v36 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v37 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    },
                    v14 /*: any*/ 
                ]
            },
            v7 /*: any*/ 
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v34 /*: any*/ ,
                                v7 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v37 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v34 /*: any*/ ,
                                v7 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v37 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "4e66a1ed92ecc98e74128ce3557c84b1",
            "id": "8d7c6c79929eb2196d98aff2b51eba75c385f34e79e699de05c60f756a38000c",
            "metadata": {},
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "operationKind": "query",
            "text": "query CommentsSectionQueryWithoutReactionsQuery($offset:String,$first:Long,$contentId:ID!){comments(pageId:$contentId,type:FOOTER,depth:ALL,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER},first:$first,after:$offset){totalCount,pageInfo{hasNextPage,endCursor},edges{cursor,node{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}},content(id:$contentId){nodes{subType,id,operations{operation,targetType},space{id,homepageId},type,history{createdBy{__typename,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){displayName,photos{isPrimary,value},id}}"
        }
    };
}();
$c6cf5a908bbe58bf$var$node.hash = "c124efaee0103dd309c2e510586b845f";
var $c6cf5a908bbe58bf$export$2e2bcd8739ae039 = $c6cf5a908bbe58bf$var$node;
module.exports["default"] = $c6cf5a908bbe58bf$export$2e2bcd8739ae039;

});

parcelRegister("f4AIb", function(module, exports) {
/**
 * @generated SignedSource<<99b989f69f9fa0df269ae70a3a14d9d4>>
 * @relayHash ddb1eba379ed1544bae77ce8070be56f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8e74d715fec5fddbd3512bf92f9a13ef034b327df28b13fd1a6534cdc3677e0
const $55379995f0cb8cff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "contentId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "offset"
        },
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "FOOTER"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v8 /*: any*/ 
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v12 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v16 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v18 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v19 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v16 /*: any*/ 
    }, v20 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v21 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v24 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v25 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v28 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v29 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v31 = {
        "kind": "ScalarField",
        "name": "number"
    }, v32 = {
        "kind": "ScalarField",
        "name": "when"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v34 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v35 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v37 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v38 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v39 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    },
                    v15 /*: any*/ 
                ]
            },
            v8 /*: any*/ 
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v40 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentsSectionQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v34 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v36 /*: any*/ ,
                                v8 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v33 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentsSectionQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v40 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v34 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v36 /*: any*/ ,
                                v8 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v33 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "ddb1eba379ed1544bae77ce8070be56f",
            "id": "e8e74d715fec5fddbd3512bf92f9a13ef034b327df28b13fd1a6534cdc3677e0",
            "metadata": {},
            "name": "CommentsSectionQuery",
            "operationKind": "query",
            "text": "query CommentsSectionQuery($offset:String,$first:Long,$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId,type:FOOTER,depth:ALL,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER},first:$first,after:$offset){totalCount,pageInfo{hasNextPage,endCursor},edges{cursor,node{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}},content(id:$contentId){nodes{subType,id,operations{operation,targetType},space{id,homepageId},type,history{createdBy{__typename,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){displayName,photos{isPrimary,value},id}}"
        }
    };
}();
$55379995f0cb8cff$var$node.hash = "2dc784a3ffdaa1784c202cee08d95c7c";
var $55379995f0cb8cff$export$2e2bcd8739ae039 = $55379995f0cb8cff$var$node;
module.exports["default"] = $55379995f0cb8cff$export$2e2bcd8739ae039;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $42omo.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("dFIln", function(module, exports) {

let $9f418076fefb04b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f418076fefb04b8$var$load("8VT23"),
    $9f418076fefb04b8$var$load("dvUU0"),
    $9f418076fefb04b8$var$load("gYeBT"),
    $9f418076fefb04b8$var$load("4t77a"),
    $9f418076fefb04b8$var$load("6wr18"),
    $9f418076fefb04b8$var$load("hSkfH"),
    $9f418076fefb04b8$var$load("cf5vC"),
    $9f418076fefb04b8$var$load("lg1HU"),
    $9f418076fefb04b8$var$load("1GCFv"),
    $9f418076fefb04b8$var$load("cLmw6"),
    $9f418076fefb04b8$var$load("lNrIG"),
    $9f418076fefb04b8$var$load("a9w2G"),
    $9f418076fefb04b8$var$load("dI1Cd"),
    $9f418076fefb04b8$var$load("ffEVr"),
    $9f418076fefb04b8$var$load("dP7ao"),
    $9f418076fefb04b8$var$load("2zqtv")
]).then(()=>parcelRequire('kXPQu'));

});

parcelRegister("2i3To", function(module, exports) {
const $a410f94860ee0eb3$export$ebc5ec3267fbcf57 = 100;
const $a410f94860ee0eb3$export$55256f24239e6668 = 0;
module.exports["DEFAULT_LIMIT"] = $a410f94860ee0eb3$export$ebc5ec3267fbcf57;

});

parcelRegister("6XpHo", function(module, exports) {

let $510c30087ef8e8f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $510c30087ef8e8f6$var$load("kXcA7").then(()=>parcelRequire('bAPy4'));

});

parcelRegister("76Au3", function(module, exports) {

let $52c564e080a89576$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $52c564e080a89576$var$load("j8Ant"),
    $52c564e080a89576$var$load("h2HOI")
]).then(()=>parcelRequire('2hWDW'));

});

parcelRegister("1N2OF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1ggpj = parcelRequire("1ggpj");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $3jwuS = parcelRequire("3jwuS");


var $7mpOv = parcelRequire("7mpOv");


var $c0rhi = parcelRequire("c0rhi");


var $f5bZm = parcelRequire("f5bZm");


var $h7eE1 = parcelRequire("h7eE1");


var $jVFPV = parcelRequire("jVFPV");

const $f6c5568d6d5a516f$export$3d87df4b3544fccb = ({ contentId: contentId, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onBeforeValidation: onBeforeValidation, onValidationSuccess: onValidationSuccess, analyticsSource: analyticsSource, optimisticTitle: optimisticTitle })=>{
    const intl = (0, $aXWIB.useIntl)();
    // Changes to EditorTitle are debounced if the page is a draft, which we need to account for
    const titleDebounceTime = isUnpublishedDraft ? (0, $1ggpj.onChangeTitleDebounceTime) : 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f5bZm.usePublishModalAnalyticsEvent)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Since the validatePageAndOpenModal function may be running after this component has unmounted,
    // we have to query the apolloClient directly rather than using useQuery's refetch function.
    const validatePageAndOpenModal = (0, $42omo.useCallback)((actionSubjectId)=>{
        const validatePage = async ()=>{
            // Live Pages only save changes to the `realTitle` when it is valid,
            // so we need to use the `optimisticTitle` here to get what the user
            // has actually typed into the title field, and then show the correct flag.
            const { title: realTitle } = await retrieveEditorTitleAndContent();
            // ?? must be used here to explicitly check null and undefined because we want to use optmisticTitle if it is an empty string, which is also falsey.
            const title = optimisticTitle ?? realTitle;
            try {
                const { data: data } = await (0, $c0rhi.queryInterop)({
                    query: (0, $h7eE1.ValidatePagePublishQuery),
                    errorPolicy: 'all',
                    fetchPolicy: 'network-only',
                    variables: {
                        contentId: contentId ?? '',
                        type: contentType,
                        title: title
                    }
                });
                // This is the same logic used to calculate `isTitleEmpty` in EditorPrimaryToolbarComponents.
                const isTitleEmpty = !title;
                if (!data.validatePagePublish?.isValid) await (0, $jVFPV.displayPublishErrorFlag)({
                    validationMessage: data.validatePagePublish?.message ?? '',
                    isTitleEmpty: isTitleEmpty,
                    flags: flags,
                    formatMessage: intl.formatMessage,
                    publish: validatePageAndOpenModal('PublishButtonInFlag'),
                    isAIEnabledForContent: isAIEnabledForContent,
                    isLivePage: isLivePage
                });
                else onValidationSuccess();
            } catch (error) {
                if (error) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    if (!(0, $6fil2.containsNetworkError)(error) && !(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                        attribution: (0, $3IBnw.Attribution).PAGE_MODES
                    });
                }
            }
        };
        return async ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'button',
                    action: 'clicked',
                    actionSubjectId: actionSubjectId,
                    source: analyticsSource,
                    attributes: {
                        isUnpublishedDraft: isUnpublishedDraft
                    }
                }
            }).fire();
            setTimeout(async ()=>{
                onBeforeValidation();
                await validatePage();
            }, titleDebounceTime);
        };
    }, [
        contentId,
        contentType,
        retrieveEditorTitleAndContent,
        createAnalyticsEvent,
        flags,
        intl.formatMessage,
        titleDebounceTime,
        isUnpublishedDraft,
        analyticsSource,
        onBeforeValidation,
        onValidationSuccess,
        optimisticTitle,
        isAIEnabledForContent,
        isLivePage
    ]);
    return validatePageAndOpenModal;
};
module.exports["usePrePublishTitleValidation"] = $f6c5568d6d5a516f$export$3d87df4b3544fccb;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("f5bZm", function(module, exports) {

var $hw7IX = parcelRequire("hw7IX");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $d6a7ecdd01e28d6c$export$cd6c3e8c6818dcba = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: akCreateAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    /**
   * cache-only since it is utilizing the same query that the PublishButtonWithMoreOptions component
   * is using, so the data should already be available within the cache which is why there is no
   * error or loading checks as well.
   */ const { data: data } = (0, $jMyy4.useQueryInterop)((0, $hw7IX.default), {
        errorPolicy: 'all',
        fetchPolicy: 'cache-only',
        variables: {
            contentId: contentId
        }
    });
    // Setup the rest of the necessary info for our analytics events that came from the query
    const analyticEventData = (0, $42omo.useMemo)(()=>{
        return {
            objectId: contentId,
            objectType: data?.singleContent?.type ?? undefined,
            containerId: data?.singleContent?.space?.id ?? undefined
        };
    }, [
        data,
        contentId
    ]);
    const createAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        payload.data.objectType = analyticEventData.objectType;
        payload.data.objectId = analyticEventData.objectId;
        payload.data.containerType = 'space';
        payload.data.containerId = analyticEventData.containerId;
        return akCreateAnalyticsEvent(payload);
    }, [
        analyticEventData,
        akCreateAnalyticsEvent
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
};
module.exports["usePublishModalAnalyticsEvent"] = $d6a7ecdd01e28d6c$export$cd6c3e8c6818dcba;

});

parcelRegister("hw7IX", function(module, exports) {
/**
 * @generated SignedSource<<354d2cc8509216510080198deb48adda>>
 * @relayHash 5f6af3c9067662d2f2453cffe85e870d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c7db24370db37ea3951c3b608b8a64c7b9652a4a0d6bdc9baf6eff8305f61db
const $40611a622a6050f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "alias": "user",
            "concreteType": "ConfluencePersonConnection",
            "kind": "LinkedField",
            "name": "personConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePersonEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ConfluencePerson",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "permissionType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "publicName"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "profilePicture",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "PaginatedGroupList",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Group",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "SchedulePublishInfo",
                    "kind": "LinkedField",
                    "name": "schedulePublishInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "date"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "versionComment"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "minorEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        },
                        {
                            "concreteType": "TargetLocation",
                            "kind": "LinkedField",
                            "name": "targetLocation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "parentId"
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "destinationSpace",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ScheduledRestrictions",
                            "kind": "LinkedField",
                            "name": "restrictions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScheduledRestriction",
                                    "kind": "LinkedField",
                                    "name": "update",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                },
                                {
                                    "concreteType": "ScheduledRestriction",
                                    "kind": "LinkedField",
                                    "name": "read",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5f6af3c9067662d2f2453cffe85e870d",
            "id": "5c7db24370db37ea3951c3b608b8a64c7b9652a4a0d6bdc9baf6eff8305f61db",
            "metadata": {},
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "operationKind": "query",
            "text": "query usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id,type,space{id},schedulePublishInfo{date,versionComment,minorEdit,targetType,targetLocation{parentId,destinationSpace{id,key,alias}},restrictions{update{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}},read{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}}}}}}"
        }
    };
}();
$40611a622a6050f5$var$node.hash = "a8a0b6dda1e0a34e0ddf825a8ab4995a";
var $40611a622a6050f5$export$2e2bcd8739ae039 = $40611a622a6050f5$var$node;
module.exports["default"] = $40611a622a6050f5$export$2e2bcd8739ae039;

});

parcelRegister("h7eE1", function(module, exports) {

var $lWcGs = parcelRequire("lWcGs");

const $a57349b93ecbf15f$export$6d6976f1200f02ec = (0, $lWcGs.default);
module.exports["ValidatePagePublishQuery"] = $a57349b93ecbf15f$export$6d6976f1200f02ec;

});

parcelRegister("lWcGs", function(module, exports) {
/**
 * @generated SignedSource<<f6217ef0f6963cd143de1161040e64f4>>
 * @relayHash 24fbb3cff8b05eaa1a5b7d5ae6a6a9c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be7633349102d5fe3dc7b73aba34d9c84ef0d7f5adad7bf0d7625ccddc1f8646
const $462ba838f57fbdac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "draft"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                },
                {
                    "kind": "Variable",
                    "name": "type",
                    "variableName": "type"
                }
            ],
            "concreteType": "PageValidationResult",
            "kind": "LinkedField",
            "name": "validatePagePublish",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isValid"
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ValidatePagePublishQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ValidatePagePublishQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24fbb3cff8b05eaa1a5b7d5ae6a6a9c0",
            "id": "be7633349102d5fe3dc7b73aba34d9c84ef0d7f5adad7bf0d7625ccddc1f8646",
            "metadata": {},
            "name": "ValidatePagePublishQuery",
            "operationKind": "query",
            "text": "query ValidatePagePublishQuery($contentId:ID!,$type:String,$title:String){validatePagePublish(id:$contentId,status:\"draft\",type:$type,title:$title){isValid,message}}"
        }
    };
}();
$462ba838f57fbdac$var$node.hash = "8954a1a5f4b5c46209e8bdbdcef7f2f7";
var $462ba838f57fbdac$export$2e2bcd8739ae039 = $462ba838f57fbdac$var$node;
module.exports["default"] = $462ba838f57fbdac$export$2e2bcd8739ae039;

});

parcelRegister("jVFPV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cFEpk = parcelRequire("cFEpk");


var $da71s = parcelRequire("da71s");


var $gsubZ = parcelRequire("gsubZ");


var $aXWIB = parcelRequire("aXWIB");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");


var $cHfGW = parcelRequire("cHfGW");


var $1mHQU = parcelRequire("1mHQU");


var $8mrqR = parcelRequire("8mrqR");


var $6mKj3 = parcelRequire("6mKj3");


var $c6abH = parcelRequire("c6abH");

function $431bc41fbb9babca$export$2d18ca8a66126a1d() {
    const hasWindow = typeof window !== 'undefined';
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
        width: width,
        height: height
    };
}
const $431bc41fbb9babca$var$ALL_TIMES_ARRAY = Array(48).fill(0).map((_, i)=>`${Math.floor(i / 2).toString().padStart(2, '0')}:${i % 2 ? '30' : '00'}`);
const $431bc41fbb9babca$var$i18n = (0, $aXWIB.defineMessages)({
    acceptTitle: {
        id: "publish-modal.flag.accept",
        defaultMessage: "Accept"
    }
});
const $431bc41fbb9babca$export$b182675d91dd4643 = (scheduledDate)=>{
    const currTime = new Date();
    const baseTime = (0, $gsubZ.default)(currTime, 5);
    // Return empty array when it is already 5 minutes until tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (baseTime.toDateString() === tomorrow.toDateString()) return [];
    // Return array of valid time selections
    if (!!scheduledDate && (0, $da71s.default)(scheduledDate).toDateString() === baseTime.toDateString()) {
        // User selected same day, only return time in the future
        const baseHour = baseTime.getHours();
        const nextHour = baseHour + 1;
        // Time array
        const timesArray = Array(48 - nextHour * 2).fill(0).map((_, i)=>`${Math.floor((i + nextHour * 2) / 2).toString().padStart(2, '0')}:${i % 2 ? '30' : '00'}`);
        if (baseTime.getMinutes() < 30) // If current time is in first half of the hour, add {currentHour:30} to the time array
        timesArray.unshift(`${baseHour.toString().padStart(2, '0')}:30`);
        return timesArray;
    } else // User selected future day, return all times array
    return $431bc41fbb9babca$var$ALL_TIMES_ARRAY;
};
const $431bc41fbb9babca$export$6195456a656da885 = (date, time)=>{
    return date && time && (0, $cFEpk.default)(date) && (0, $cFEpk.default)(time) ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()) : undefined;
};
const $431bc41fbb9babca$export$9295f91b059cbee5 = ({ contentId: contentId, schedulePublishDate: schedulePublishDate, fragmentWriterInterop: fragmentWriterInterop })=>{
    try {
        fragmentWriterInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                schedulePublishInfo: {
                    __typename: 'SchedulePublishInfo',
                    date: schedulePublishDate,
                    minorEdit: false,
                    targetType: 'page',
                    versionComment: ''
                },
                __typename: 'Content'
            }
        });
    } catch  {}
};
const $431bc41fbb9babca$export$19a3e0c18ebaf6e6 = async ({ validationMessage: validationMessage, isTitleEmpty: isTitleEmpty, flags: flags, formatMessage: formatMessage, publish: publish, isAIEnabledForContent: isAIEnabledForContent, isLivePage: isLivePage })=>{
    let flagErrorId;
    // Will show a generic error flag if these three conditions not met
    // The validation query results do not differentiate b/w blank and whitespace title so we use isTitleEmpty to do so on the frontend side
    if (isTitleEmpty && validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK && isAIEnabledForContent && !isLivePage && (0, $6mKj3.expValEquals)('confluence_ai_title_generation', 'cohort', 'test')) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE;
    else if (isTitleEmpty && validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED;
    else if (validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE;
    else if (validationMessage === (0, $c6abH.PublishErrorFlagKeys).DUPLICATE_TITLE) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE;
    const flagMessage = (0, $cHfGW.buildEditorFlagMessage)({
        errorData: {
            [flagErrorId]: true
        },
        formatMessage: formatMessage
    });
    if (flagErrorId === (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE) {
        await flags.hideFlag('ai-generated-title-flag');
        await flags.showCustomFlag({
            id: 'ai-generated-title-flag',
            title: flagMessage?.title,
            description: flagMessage?.description,
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                paddingBlockStart: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                label: "",
                size: "xsmall"
            })),
            actions: [
                {
                    content: formatMessage($431bc41fbb9babca$var$i18n.acceptTitle),
                    onClick: publish
                }
            ]
        });
    } else await flags.showErrorFlag({
        title: flagMessage?.title,
        description: flagMessage?.description
    });
};
const $431bc41fbb9babca$export$13107e6716590163 = (gqlRestrictionsInput)=>{
    if (!gqlRestrictionsInput) return undefined;
    return gqlRestrictionsInput;
};
const $431bc41fbb9babca$export$7521340df7373a8f = (scheduledRestrictions)=>{
    const readRestriction = scheduledRestrictions?.read;
    const updateRestriction = scheduledRestrictions?.update;
    const usersWithReadRestriction = readRestriction?.user?.edges ?? [];
    const groupsWithReadRestriction = readRestriction?.group?.edges ?? [];
    const usersWithUpdateRestriction = updateRestriction?.user?.edges ?? [];
    const groupsWithUpdateRestriction = updateRestriction?.group?.edges ?? [];
    const processUserEdgesArray = (userEdgesArray)=>userEdgesArray.map((element)=>(0, $8mrqR.transformUserToREST)({
                ...element.node,
                hasSpaceEditPermission: true,
                hasSpaceViewPermission: true
            }));
    const processGroupEdgesArray = (groupEdgesArray)=>groupEdgesArray.map((element)=>(0, $8mrqR.transformGroupToREST)(element.node));
    const createRestrictionsObject = (operation, users, groups)=>({
            operation: operation,
            restrictions: {
                user: {
                    results: processUserEdgesArray(users)
                },
                group: {
                    results: processGroupEdgesArray(groups)
                }
            }
        });
    const readObj = createRestrictionsObject('read', usersWithReadRestriction, groupsWithReadRestriction);
    const updateObj = createRestrictionsObject('update', usersWithUpdateRestriction, groupsWithUpdateRestriction);
    return [
        readObj,
        updateObj
    ];
};
const $431bc41fbb9babca$export$756388d4cc11ef74 = (scheduledRestrictions)=>{
    const readRestriction = scheduledRestrictions?.read;
    const updateRestriction = scheduledRestrictions?.update;
    const usersWithReadRestriction = readRestriction?.user?.edges ?? [];
    const groupsWithReadRestriction = readRestriction?.group?.edges ?? [];
    const usersWithUpdateRestriction = updateRestriction?.user?.edges ?? [];
    const groupsWithUpdateRestriction = updateRestriction?.group?.edges ?? [];
    return {
        read: {
            user: usersWithReadRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    id: edge?.node?.accountId ?? ''
                })),
            group: groupsWithReadRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    name: edge?.node?.name ?? '',
                    id: edge?.node?.id || undefined
                }))
        },
        update: {
            user: usersWithUpdateRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    id: edge?.node?.accountId ?? ''
                })),
            group: groupsWithUpdateRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    name: edge?.node?.name ?? '',
                    id: edge?.node?.id || undefined
                }))
        }
    };
};
module.exports["getTimesArray"] = $431bc41fbb9babca$export$b182675d91dd4643;
module.exports["mergeDateTime"] = $431bc41fbb9babca$export$6195456a656da885;
module.exports["cacheSchedulePublishTime"] = $431bc41fbb9babca$export$9295f91b059cbee5;
module.exports["displayPublishErrorFlag"] = $431bc41fbb9babca$export$19a3e0c18ebaf6e6;
module.exports["getRestrictionsForPublish"] = $431bc41fbb9babca$export$13107e6716590163;
module.exports["convertRestrictionsObjFromSchedulePublishInfo"] = $431bc41fbb9babca$export$7521340df7373a8f;
module.exports["convertGqlRestrictionsInputFromSchedulePublishInfo"] = $431bc41fbb9babca$export$756388d4cc11ef74;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("gsubZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb6ae770a72c6aa$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $lshox = parcelRequire("lshox");


var $b5utg = parcelRequire("b5utg");

var $bfb6ae770a72c6aa$var$MILLISECONDS_IN_MINUTE = 60000;
function $bfb6ae770a72c6aa$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $lshox.default)(dirtyDate, amount * $bfb6ae770a72c6aa$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("cHfGW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $iXCQx = parcelRequire("iXCQx");


var $9wGTI = parcelRequire("9wGTI");


var $jlIaF = parcelRequire("jlIaF");


var $jhwJP = parcelRequire("jhwJP");


var $1mHQU = parcelRequire("1mHQU");

// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $d33bb643a38eaa5e$var$i18nBase = (0, $aXWIB.defineMessages)({
    duplicatePageTitleHeader: {
        id: "editor-flags.save.page.exist.content.title",
        defaultMessage: "Give your page a unique name"
    },
    duplicateLivePageTitleHeader: {
        id: "editor-flags.save.live.page.exist.content.title",
        defaultMessage: "Give your doc a unique name"
    },
    duplicatePageTitleMessage: {
        id: "editor-flags.save.page.exist.message",
        defaultMessage: "Page names have to be unique within a space. Give your page a different name to publish it."
    },
    duplicateLivePageTitleMessage: {
        id: "editor-flags.save.live.page.exist.message",
        defaultMessage: "Live docs need unique names within a space. Give your doc a different name. "
    },
    duplicateUpdatePageTitleMessage: {
        id: "editor-flags.save.update-page.exist.message",
        defaultMessage: "Page names have to be unique within a space. Give your page a different name to update it."
    },
    pageTitleInvalidTitleHeader: {
        id: "editor-flags.page.title.invalid.header",
        defaultMessage: "Invalid title - try again."
    },
    pageTitleUpdateInvalidTitleHeader: {
        id: "editor-flags.update-page.title.invalid.header",
        defaultMessage: "We can\u2019t update the page with that name."
    },
    pageTitleInvalidTitleMessage: {
        id: "editor-flags.page.title.invalid.message",
        defaultMessage: "Try another title, up to 255 characters."
    },
    pageTitleTooLongHeader: {
        id: "editor-flags.title.too.long.title",
        defaultMessage: "Your title is too long."
    },
    pageTitleTooLongMessage: {
        id: "editor-flags.title.too.long",
        defaultMessage: "The limit for titles is 255 characters."
    },
    duplicateTemplateTitleHeader: {
        id: "editor-flags.template.can.not.save.error.title.duplicate.title",
        defaultMessage: "A template with this name already exists"
    },
    duplicateTemplateTitleMessage: {
        id: "editor-flags.template.can.not.save.error.title.duplicate",
        defaultMessage: "Template names must be unique within a space. Give your template a different name to save it."
    },
    pageTooBigHeader: {
        id: "editor-flags.page.is.too.big.title",
        defaultMessage: "We can\u2019t save your content"
    },
    pageTooBigMessage: {
        id: "editor-flags.page.is.too.big",
        defaultMessage: "Pages larger than the 2MB limit are slow to load. Break your content into a couple pages and use the Include Page macro to display the content here."
    },
    templateTooBigHeader: {
        id: "editor-flags.template.is.too.big.title",
        defaultMessage: "We can\u2019t save your template"
    },
    templateTooBigMessage: {
        id: "editor-flags.template.is.too.big",
        defaultMessage: "Templates larger than the 2MB limit are slow to load. Break your content into a couple of templates."
    },
    connectionErrorHeader: {
        id: "editor-flags.offline.save.error.title",
        defaultMessage: "We\u2019re having trouble connecting right now"
    },
    connectionErrorMessage: {
        id: "editor-flags.offline.save.error",
        defaultMessage: "Give us a few seconds to reconnect, and you can resume your work."
    },
    templateConnectionParsingFailHeader: {
        id: "editor-flags.template.can.not.parse.content.title",
        defaultMessage: "We can\u2019t open this template"
    },
    templateConnectionParsingFailMessage: {
        id: "editor-flags.template.can.not.parse.content",
        defaultMessage: "This happens when a template contains broken or unsupported elements."
    },
    publishIsTakingTooLongHeader: {
        id: "editor-flags.error.delayed.publishing.title",
        defaultMessage: "We\u2019re having trouble publishing"
    },
    updateIsTakingTooLongHeader: {
        id: "editor-flags.error.delayed.updating.title",
        defaultMessage: "We\u2019re having trouble updating"
    },
    publishIsTakingTooLongMessage: {
        id: "editor-flags.error.delayed.publishing",
        defaultMessage: "We\u2019ll continue trying to publish. If it\u2019s taking too long, refresh the page and click {buttonText}."
    },
    updateIsTakingTooLongMessage: {
        id: "editor-flags.error.delayed.updating",
        defaultMessage: "We\u2019ll continue trying to update. If it\u2019s taking too long, refresh the page and click {buttonText}."
    },
    publishText: {
        id: "editor-flags.error.delayed.publishText",
        defaultMessage: "Publish"
    },
    updateText: {
        id: "editor-flags.error.delayed.updateText",
        defaultMessage: "Update"
    },
    schedulePublishErrorHeader: {
        id: "editor-flags.error.schedule.publish.title",
        defaultMessage: "We had an issue setting the schedule time"
    },
    schedulePublishErrorMessage: {
        id: "editor-flags.error.schedule.publish",
        defaultMessage: "Refresh the page and try again."
    },
    cancelScheduledPublishErrorHeader: {
        id: "editor-flags.error.cancel.scheduled.publish.title",
        defaultMessage: "We had an issue cancelling this scheduled publish"
    },
    cancelScheduledUpdateErrorHeader: {
        id: "editor-flags.error.cancel.scheduled.update.title",
        defaultMessage: "We had an issue cancelling this scheduled update"
    },
    cancelScheduledPublishErrorMessage: {
        id: "editor-flags.error.cancel.scheduled.publish",
        defaultMessage: "Refresh the page and try again."
    },
    schedulePublishNoHeaderErrorHeader: {
        id: "editor-flags.error.scheduled.publish.no-title-error.title",
        defaultMessage: "Your page needs a name"
    },
    schedulePublishNoHeaderErrorMessage: {
        id: "editor-flags.error.scheduled.publish.no-title-error",
        defaultMessage: "Add a title, and you can set a date and time for publishing."
    },
    scheduleUpdateNoHeaderErrorMessage: {
        id: "editor-flags.error.scheduled.update.no-title-error",
        defaultMessage: "Add a title, and you can set a date and time for updating."
    },
    defaultPublishErrorHeader: {
        id: "editor-flags.offline.save.error.generic.title",
        defaultMessage: "Your work is safe, but there\u2019s an issue"
    },
    defaultPublishErrorMessage: {
        id: "editor-flags.offline.save.error.generic",
        defaultMessage: "Refresh the page, and click Publish again."
    },
    defaultUpdateErrorMessage: {
        id: "editor-flags.offline.update.save.error.generic",
        defaultMessage: "Refresh the page, and click Update again."
    },
    defaultTemplateSaveErrorHeader: {
        id: "editor-flags.template.save.error.generic.title",
        defaultMessage: "There\u2019s an issue saving your template"
    },
    defaultTemplateSaveErrorMessage: {
        id: "editor-flags.template.save.error.generic.message",
        defaultMessage: "Try clicking Save again."
    },
    duplicateBlogTitleFromEditPageErrorHeader: {
        id: "editor-flags.error.edit-page.duplicate-blog-title-error.title",
        defaultMessage: "A blog with this name already exists"
    },
    duplicateBlogTitleFromEditPageErrorMessage: {
        id: "editor-flags.error.edit-page.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before publishing it as a blog."
    },
    duplicateUpdateBlogTitleFromEditPageErrorMessage: {
        id: "editor-flags.error.edit-page.update.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before updating it as a blog."
    },
    duplicateBlogTitleFromViewPageErrorHeader: {
        id: "editor-flags.error.view-page.duplicate-blog-title-error.title",
        defaultMessage: "A blog with this name already exists"
    },
    duplicateBlogTitleFromViewPageErrorMessage: {
        id: "editor-flags.error.view-page.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before converting it to a blog."
    },
    noAuthorizeMessage: {
        id: "editor-flags.error.no.authorize.message",
        defaultMessage: "Your session has expired. You\u2019ll need to log in again or switch to another account to keep working. {loginLink}"
    },
    loginLink: {
        id: "editor-flags.error.login.link",
        defaultMessage: "Log in or switch to another account"
    },
    noAccessMessage: {
        id: "editor-flags.error.no.access.message",
        defaultMessage: "Your session may have expired. You\u2019ll need to log in again or switch to another account to keep working. {loginLink}"
    },
    pageIsTrashedMessage: {
        id: "editor-flags.error.page.trashed.message",
        defaultMessage: "Copy your content, then add it to a new page or <link>restore this page from the trash</link> and try again."
    },
    livePageIsTrashedMessage: {
        id: "editor-flags.error.live.page.trashed.message",
        defaultMessage: "Copy your content, then add it to a new doc or <link>restore this doc from the trash</link> and try again."
    },
    pageIsTrashedMessageLink: {
        id: "editor-flags.error.page.trashed.message.link",
        defaultMessage: "Restore this content from the trash"
    },
    invalidTemplateVariableMessage: {
        id: "editor-flags.error.invalid.template.variable.message",
        defaultMessage: "Multiple template variables which have the same name \u201C{variableNames}\u201D but different parameters."
    },
    cantRevertPageTitle: {
        id: "editor.discard-to-published.error.title",
        defaultMessage: "Can\u2019t revert to last published version"
    },
    cantRevertPageMessage: {
        id: "editor.discard-to-published.error.message",
        defaultMessage: "We can\u2019t get the last published version of the page at the moment. Give it a few moments then try discarding the draft again."
    },
    parentNotPublishedHeader: {
        id: "editor-flags.error.edit-page.parent-not-published.title",
        defaultMessage: "This draft can\u2019t be published"
    },
    parentNotPublishedMessage: {
        id: "editor-flags.error.edit-page.parent-not-published.message",
        defaultMessage: "A published page can\u2019t exist under a page in the draft state. Publish the <link>parent page</link> first, then publish this page."
    },
    titleRequiredHeader: {
        id: "editor-flags.page.title.required.header",
        defaultMessage: "Title required"
    },
    titleRequiredMessage: {
        id: "editor-flags.page.title.required.message",
        defaultMessage: "Add a title before publishing."
    },
    titleRequiredUpdateMessage: {
        id: "editor-flags.update.page.title.required.update.message",
        defaultMessage: "Add a title before updating."
    },
    titleGeneratedAI: {
        id: "editor-flags.generate.ai.title",
        defaultMessage: "Review your AI-generated title"
    },
    titleGeneratedAIDescription: {
        id: "editor-flags.generate.ai.description",
        defaultMessage: "Rovo is generating a title for this page, as a title is required to publish. Select <bold>Accept</bold> to publish the page with this title or edit the title and publish manually. <Link>Content quality may vary.</Link>"
    },
    titleGeneratedFromPasteAI: {
        id: "editor-flags.generate.ai.from.paste.title",
        defaultMessage: "Rovo wrote a title for you"
    },
    titleGeneratedFromPasteAIDescription: {
        id: "editor-flags.generate.ai.from.paste.description",
        defaultMessage: "It\u2019s based on the text you pasted. <Link>Uses AI. Verify results.</Link>"
    },
    titleGeneratedAIError: {
        id: "editor-flags.generate.ai.error.title",
        defaultMessage: "We couldn\u2019t generate a title for you"
    },
    titleGeneratedAIErrorDescription: {
        id: "editor-flags.generate.ai.error.description",
        defaultMessage: "Rovo was unable to generate a title for you at this time. You can add a title and publish the page manually instead. <Link>Why did this happen?</Link>"
    },
    refreshPageConflictHeader: {
        id: "editor-flags.error.conflict.refresh-page.header",
        defaultMessage: "Refresh this page in order to publish"
    },
    refreshPageUpdateConflictHeader: {
        id: "editor-flags.error.update.conflict.refresh-page.header",
        defaultMessage: "Refresh in order to update"
    },
    refreshPageConflictMessage: {
        id: "editor-flags.error.conflict.refresh-page.message",
        defaultMessage: "This version has been updated by another user. Refresh the page in order to sync and publish your changes."
    },
    refreshUpdatePageConflictMessage: {
        id: "editor-flags.error.update.conflict.refresh-page.message",
        defaultMessage: "This version has been updated by another user. Refresh now in order to sync your changes."
    },
    draftConflictHeader: {
        id: "editor-flags.error.conflict.draft.header",
        defaultMessage: "Unable to publish draft"
    },
    draftConflictMessage: {
        id: "editor-flags.error.conflict.draft.message",
        defaultMessage: "Due to a server error, this draft can\u2019t be published. Copy and paste this content into a new draft in order to publish it."
    },
    duplicatePageNameWithinEditorErrorTitle: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.title",
        defaultMessage: "Give this page a unique title to move"
    },
    duplicateLivePageNameWithinEditorErrorTitle: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.title",
        defaultMessage: "Give this doc a unique title to move"
    },
    duplicatePageNameWithinEditorErrorDescription: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.description",
        defaultMessage: "To move this page to the {destinationSpace} space, give it a unique title and publish it first."
    },
    duplicateLivePageNameWithinEditorErrorDescription: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.description",
        defaultMessage: "To move this live doc to the {destinationSpace} space, give it a unique title."
    },
    duplicatePageNameWithinEditorUpdateErrorDescription: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.update.description",
        defaultMessage: "To move this page to the {destinationSpace} space, give it a unique title and update it first."
    },
    duplicateLivePageNameWithinEditorUpdateErrorDescription: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.update.description",
        defaultMessage: "To move this live doc to the {destinationSpace} space, give it a unique title and update it first."
    },
    collabStatusErrorTitle: {
        id: "editor-flags.collab-status-error.title",
        defaultMessage: "Can\u2019t save changes"
    },
    collabStatusErrorDescription: {
        id: "editor-flags.collab-status-error.description",
        defaultMessage: "Copy your work, then refresh, and we\u2019ll try to reconnect."
    },
    invalidSpaceKeyHeader: {
        id: "editor-flags.template.save.error.spacekey.invalid.header",
        defaultMessage: "There was an issue creating a template in this space"
    },
    invalidSpaceKeyMessage: {
        id: "editor-flags.template.save.error.spacekey.invalid.message",
        defaultMessage: "Check if the space exists and if you have admin permissions to create templates."
    },
    templateBlankTitleErrorHeader: {
        id: "editor-flags.template.can.not.save.error.title.blank.header",
        defaultMessage: "We can\u2019t save this template"
    },
    templateBlankTitleErrorMessage: {
        id: "editor-flags.template.can.not.save.error.title.blank.message",
        defaultMessage: "Templates can\u2019t have blank titles. Give your template a title to publish."
    }
});
const $d33bb643a38eaa5e$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    pageTooBigMessage: {
        id: "editor-flags.page.is.too.big.livedocs",
        defaultMessage: "Content that is larger than the 2MB limit is slow to load. Break your content into a couple of pages or live docs and use the Include Page macro to display the content here."
    }
});
const $d33bb643a38eaa5e$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($d33bb643a38eaa5e$var$i18nBase, $d33bb643a38eaa5e$var$i18nLiveDocs);
const $d33bb643a38eaa5e$var$BOLD_BUTTON_TEXT = ({ isUnpublishedDraft: isUnpublishedDraft })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishText : $d33bb643a38eaa5e$var$i18n.updateText));
const $d33bb643a38eaa5e$var$LOGIN_LINK = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "/login?application=confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d33bb643a38eaa5e$var$i18n.loginLink)));
const $d33bb643a38eaa5e$var$TRASH_LINK = ({ spaceKey: spaceKey, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewtrash.action?key=${spaceKey}`,
        target: "_blank"
    }, text));
const $d33bb643a38eaa5e$var$PARENT_LINK = ({ parentPageId: parentPageId, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, parentPageId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/resumedraft.action?draftId=${parentPageId}`,
        target: "_blank"
    }, text) : text);
const $d33bb643a38eaa5e$var$i18nInitializer = (formatMessage, isLivePage)=>({
        DUPLICATE_PAGE_TITLE: (isUnpublishedDraft)=>{
            const duplicatePageTitleMessage = isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageTitleMessage : $d33bb643a38eaa5e$var$i18n.duplicatePageTitleMessage;
            return {
                title: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? formatMessage($d33bb643a38eaa5e$var$i18n.duplicateLivePageTitleHeader) : formatMessage($d33bb643a38eaa5e$var$i18n.duplicatePageTitleHeader),
                description: formatMessage(isUnpublishedDraft ? duplicatePageTitleMessage : $d33bb643a38eaa5e$var$i18n.duplicateUpdatePageTitleMessage)
            };
        },
        TITLE_TOO_LONG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleTooLongHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleTooLongMessage)
            }),
        DUPLICATE_TEMPLATE_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateTemplateTitleHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateTemplateTitleMessage)
            }),
        PARENT_NOT_PUBLISHED: (parentPageId)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.parentNotPublishedHeader),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.parentNotPublishedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$PARENT_LINK, {
                                parentPageId: parentPageId,
                                text: chunks
                            })
                    }
                })
            }),
        NO_AUTHORIZE: ()=>({
                title: formatMessage({
                    id: "editor.offline.save.noauthorized.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.noAuthorizeMessage,
                    values: {
                        loginLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$LOGIN_LINK, null)
                    }
                })
            }),
        PAGE_CANNOT_BE_ACCESSED: ()=>({
                title: formatMessage({
                    id: "editor.page.can.not.be.accessed.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.noAccessMessage,
                    values: {
                        loginLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$LOGIN_LINK, null)
                    }
                })
            }),
        PAGE_CONFLICT_REFRESH: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.refreshPageConflictHeader : $d33bb643a38eaa5e$var$i18n.refreshPageUpdateConflictHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.refreshPageConflictMessage : $d33bb643a38eaa5e$var$i18n.refreshUpdatePageConflictMessage)
            }),
        PAGE_CONFLICT_DRAFT: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.draftConflictHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.draftConflictMessage)
            }),
        PAGE_TRASHED: (spaceKey)=>({
                title: formatMessage({
                    id: "editor.page.is.trashed.title"
                }),
                description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.livePageIsTrashedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$TRASH_LINK, {
                                spaceKey: spaceKey,
                                text: chunks
                            })
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.pageIsTrashedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$TRASH_LINK, {
                                spaceKey: spaceKey,
                                text: chunks
                            })
                    }
                })
            }),
        PAGE_TOO_BIG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.pageTooBigHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTooBigMessage)
            }),
        TEMPLATE_TOO_BIG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateTooBigHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateTooBigMessage)
            }),
        OFFLINE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.connectionErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.connectionErrorMessage)
            }),
        TEMPLATE_CONTENT_PARSING_FAILURE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateConnectionParsingFailHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateConnectionParsingFailMessage)
            }),
        EMPTY_TITLE: ()=>({
                title: formatMessage({
                    id: "editor.title.is.empty.title"
                }),
                description: formatMessage({
                    id: "editor.title.is.empty"
                })
            }),
        DUPLICATE_EDIT_PAGE_BLOG_TITLE: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromEditPageErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromEditPageErrorMessage : $d33bb643a38eaa5e$var$i18n.duplicateUpdateBlogTitleFromEditPageErrorMessage)
            }),
        DUPLICATE_VIEW_PAGE_BLOG_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromViewPageErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromViewPageErrorMessage)
            }),
        MEDIA_FAILED: ()=>({
                title: formatMessage({
                    id: "editor.cant.publish.changes"
                }),
                description: formatMessage({
                    id: "editor.files.may.be.uploading"
                })
            }),
        INVALID_TEMPLATE_VARIABLE: (errorData)=>({
                title: formatMessage({
                    id: "fabric.template.can.not.save.error.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.invalidTemplateVariableMessage,
                    values: {
                        variableNames: errorData.i18nOptions.variableNames
                    }
                })
            }),
        DUPLICATE_PAGE_TITLE_WITHIN_EDITOR: (destinationSpace, isUnpublishedDraft)=>({
                title: formatMessage(isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorErrorTitle : $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorErrorTitle),
                description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorErrorDescription : $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorUpdateErrorDescription,
                    values: {
                        destinationSpace: destinationSpace
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorErrorDescription : $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorUpdateErrorDescription,
                    values: {
                        destinationSpace: destinationSpace
                    }
                })
            }),
        RECONCILIATION_ERROR: (errorData, nextTryIn)=>{
            const title = formatMessage({
                id: "editor.content.reconciliation.error.title"
            });
            if (nextTryIn != null) return {
                title: title,
                description: (secondsLeft)=>formatMessage({
                        id: "editor.content.reconciliation.error.retrying"
                    }, {
                        0: `${secondsLeft}`
                    })
            };
            const showStagingError = false;
            const messageEnv = showStagingError ? 'staging' : 'prod';
            const i18nDescriptionMessage = {
                id: `editor.content.reconciliation.error.fatal.${messageEnv}`
            };
            const description = formatMessage(i18nDescriptionMessage);
            const details = `${formatMessage({
                id: "editor.content.reconciliation.error.details"
            })} ${errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONTENT_RECONCILIATION]}`;
            return {
                title: title,
                description: description,
                details: details
            };
        },
        PUBLISH_TIME_TOO_LONG_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishIsTakingTooLongHeader : $d33bb643a38eaa5e$var$i18n.updateIsTakingTooLongHeader),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishIsTakingTooLongMessage : $d33bb643a38eaa5e$var$i18n.updateIsTakingTooLongMessage,
                    values: {
                        buttonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$BOLD_BUTTON_TEXT, {
                            isUnpublishedDraft: isUnpublishedDraft
                        })
                    }
                })
            }),
        SCHEDULE_PUBLISH_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishErrorMessage)
            }),
        CANCEL_SCHEDULE_PUBLISH_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.cancelScheduledPublishErrorHeader : $d33bb643a38eaa5e$var$i18n.cancelScheduledUpdateErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.cancelScheduledPublishErrorMessage)
            }),
        SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishNoHeaderErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.schedulePublishNoHeaderErrorMessage : $d33bb643a38eaa5e$var$i18n.scheduleUpdateNoHeaderErrorMessage)
            }),
        DEFAULT_PUBLISH_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultPublishErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.defaultPublishErrorMessage : $d33bb643a38eaa5e$var$i18n.defaultUpdateErrorMessage)
            }),
        DEFAULT_TEMPLATE_SAVE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultTemplateSaveErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.defaultTemplateSaveErrorMessage)
            }),
        REVERT_CONTENT_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.cantRevertPageTitle),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.cantRevertPageMessage)
            }),
        PUBLISH_CONDITION_ERROR: (errorMsg)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultPublishErrorHeader),
                description: errorMsg
            }),
        INVALID_PAGE_TITLE_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.pageTitleInvalidTitleHeader : $d33bb643a38eaa5e$var$i18n.pageTitleUpdateInvalidTitleHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleInvalidTitleMessage)
            }),
        TITLE_REQUIRED: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleRequiredHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.titleRequiredMessage : $d33bb643a38eaa5e$var$i18n.titleRequiredUpdateMessage)
            }),
        AI_GENERATED_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAI),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks)),
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                            weight: "bold"
                        }, " ", chunks, " ")
                })
            }),
        AI_GENERATED_TITLE_FROM_PASTE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedFromPasteAI),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedFromPasteAIDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks)),
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                            weight: "bold"
                        }, " ", chunks, " ")
                })
            }),
        AI_GENERATED_TITLE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIError),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIErrorDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://support.atlassian.com/organization-administration/docs/troubleshoot-atlassian-intelligence/",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks))
                })
            }),
        COLLAB_STATUS_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.collabStatusErrorTitle),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.collabStatusErrorDescription)
            }),
        INVALID_SPACEKEY_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.invalidSpaceKeyHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.invalidSpaceKeyMessage)
            }),
        TEMPLATE_BLANK_TITLE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateBlankTitleErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateBlankTitleErrorMessage)
            })
    });
const $d33bb643a38eaa5e$export$cda5b5526dda47f7 = ({ errorData: errorData, statusCode: statusCode, spaceKey: spaceKey, parentPageId: parentPageId, nextTryIn: nextTryIn, formatMessage: formatMessage, isTemplateEditor: isTemplateEditor = false, isUnpublishedDraft: isUnpublishedDraft = true, isLivePage: isLivePage = false })=>{
    if (!errorData || !Object.keys(errorData).length) return null;
    const i18nFormatter = $d33bb643a38eaa5e$var$i18nInitializer(formatMessage, isLivePage);
    // Http errors from the content api when publishing
    if (statusCode != null) switch(statusCode){
        case 400:
            if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE] || // have to check instead of doing errorData[ALLOWED_FLAG_MESSAGES.DUPLICATE_TITLE_WITH_BAD_EXCEPTION]
            // because BE message would sometimes have extra words at the end of A page with this title already exists
            // eg com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists:
            // A page already exists with the title <PAGE_TITLE> in the space with key <SPACE_KEY>
            Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITH_BAD_EXCEPTION) !== -1) return i18nFormatter.DUPLICATE_PAGE_TITLE(isUnpublishedDraft);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]) return i18nFormatter.INVALID_PAGE_TITLE_ERROR(isUnpublishedDraft);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_TOO_LONG]) return i18nFormatter.TITLE_TOO_LONG();
            else if (Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_TEMPLATE) !== -1) return i18nFormatter.DUPLICATE_TEMPLATE_TITLE();
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED]) return i18nFormatter.PARENT_NOT_PUBLISHED(parentPageId);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_INVALID_SPACEKEY_ERROR]) return i18nFormatter.INVALID_SPACEKEY_ERROR();
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_BLANK_TITLE_ERROR]) return i18nFormatter.TEMPLATE_BLANK_TITLE_ERROR();
            else if (// BadRequestException means something wrong with the request. BE throws this exception on request validation fail
            // This BadRequestException has a message attached to it and we should use it as default message if non of above conditions are met.
            // That's why make sure this "if" block should say at last.
            // We are adding this as part of our PublishCondition implementation. Please go through: https://hello.atlassian.net/wiki/spaces/CCECO/pages/1289257589/Custom+publishing+flow
            // For any further questions please contact ecosystem-ini team.
            Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).ERROR_MESSAGE_WITH_BAD_EXCEPTION) !== -1) {
                // positive look-behind "(?<=expression)" is not supported with str.match() so end up using below pattern.
                const patt = '[^com.atlassian.confluence.api.service.exceptions.api.BadRequestException:].*';
                const errorMsg = Object.keys(errorData)[0].match(patt);
                return i18nFormatter.PUBLISH_CONDITION_ERROR(errorMsg);
            }
            break;
        case 403:
            return i18nFormatter.NO_AUTHORIZE();
        case 404:
            return i18nFormatter.PAGE_CANNOT_BE_ACCESSED();
        case 409:
            if (Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONFLICT_DRAFT_VERSIONING) !== -1) return i18nFormatter.PAGE_CONFLICT_DRAFT();
            return i18nFormatter.PAGE_CONFLICT_REFRESH(isUnpublishedDraft);
        case 410:
            if (isTemplateEditor) return i18nFormatter.DEFAULT_TEMPLATE_SAVE_ERROR();
            return i18nFormatter.PAGE_TRASHED(spaceKey);
        case 413:
            return isTemplateEditor ? i18nFormatter.TEMPLATE_TOO_BIG() : i18nFormatter.PAGE_TOO_BIG();
        case 0:
        case 500:
        case 503:
            return i18nFormatter.OFFLINE_ERROR();
    }
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_CONTENT_PARSING_FAILURE]) return i18nFormatter.TEMPLATE_CONTENT_PARSING_FAILURE();
    // editor errors triggered from within the fabric editor
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).EMPTY_TITLE]) return i18nFormatter.EMPTY_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_VIEW_PAGE_BLOG_TITLE]) return i18nFormatter.DUPLICATE_VIEW_PAGE_BLOG_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITHIN_EDITOR]) return i18nFormatter.DUPLICATE_PAGE_TITLE_WITHIN_EDITOR(errorData.destinationSpace, isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_EDIT_PAGE_BLOG_TITLE]) return i18nFormatter.DUPLICATE_EDIT_PAGE_BLOG_TITLE(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_TEMPLATE]) return i18nFormatter.DUPLICATE_TEMPLATE_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).MEDIA_FAILED]) return i18nFormatter.MEDIA_FAILED();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).FOUND_INVALID_TEMPLATE_VARIABLE]) return i18nFormatter.INVALID_TEMPLATE_VARIABLE(errorData);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONTENT_RECONCILIATION]) return i18nFormatter.RECONCILIATION_ERROR(errorData, nextTryIn);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PUBLISH_TIME_TOO_LONG_ERROR]) return i18nFormatter.PUBLISH_TIME_TOO_LONG_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).SCHEDULE_PUBLISH_ERROR]) return i18nFormatter.SCHEDULE_PUBLISH_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CANCEL_SCHEDULE_PUBLISH_ERROR]) return i18nFormatter.CANCEL_SCHEDULE_PUBLISH_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR]) return i18nFormatter.SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).REVERT_CONTENT_ERROR]) return i18nFormatter.REVERT_CONTENT_ERROR();
    // UX https://product-fabric.atlassian.net/browse/CEMS-2468
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG]) return i18nFormatter.OFFLINE_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED]) return i18nFormatter.TITLE_REQUIRED(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]) return i18nFormatter.AI_GENERATED_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_FROM_PASTE]) return i18nFormatter.AI_GENERATED_TITLE_FROM_PASTE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_ERROR]) return i18nFormatter.AI_GENERATED_TITLE_ERROR();
    // Adding duplicate and invalid page errors outside of status code 400 for use with publish modal buttons (they do not send requests)
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE] || // have to check instead of doing errorData[ALLOWED_FLAG_MESSAGES.DUPLICATE_TITLE_WITH_BAD_EXCEPTION]
    // because BE message would sometimes have extra words at the end of A page with this title already exists
    // eg com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists:
    // A page already exists with the title <PAGE_TITLE> in the space with key <SPACE_KEY>
    Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITH_BAD_EXCEPTION) !== -1) return i18nFormatter.DUPLICATE_PAGE_TITLE(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]) return i18nFormatter.INVALID_PAGE_TITLE_ERROR(isUnpublishedDraft);
    if (isTemplateEditor) return i18nFormatter.DEFAULT_TEMPLATE_SAVE_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_STATUS_ERROR]) return i18nFormatter.COLLAB_STATUS_ERROR();
    return i18nFormatter.DEFAULT_PUBLISH_ERROR(isUnpublishedDraft);
};
module.exports["buildEditorFlagMessage"] = $d33bb643a38eaa5e$export$cda5b5526dda47f7;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("1mHQU", function(module, exports) {
const $bacd8f7695bdf465$export$c4d5263a0e2e072d = {
    DUPLICATE_TITLE: 'A page with this title already exists',
    DUPLICATE_TITLE_WITHIN_EDITOR: 'Give this page a unique title to move',
    DUPLICATE_EDIT_PAGE_BLOG_TITLE: 'Cannot convert draft, a blog with this title already exists',
    DUPLICATE_VIEW_PAGE_BLOG_TITLE: 'Cannot convert page, a blog with this title already exists',
    EMPTY_TITLE: 'empty-title',
    TITLE_REQUIRED: 'title-required',
    AI_GENERATED_TITLE: 'Review your AI-generated title',
    AI_GENERATED_TITLE_FROM_PASTE: 'AI generated title from paste',
    AI_GENERATED_TITLE_ERROR: "We couldn\u2019t generate a title for you",
    INVALID_PAGE_TITLE: 'You need to include the title to update a page.',
    // this error message is returned with status 400 in fabric editor when page with duplicate title is published
    DUPLICATE_TITLE_WITH_BAD_EXCEPTION: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists',
    OTHER_PUBLISH: 'other-publish',
    OTHER_RESTORE: 'other-restore',
    CONTENT_RECONCILIATION: 'content-reconciliation',
    TITLE_TOO_LONG: 'Title cannot be longer than 255 characters.',
    MEDIA_FAILED: "Can't publish changes",
    SYNCHRONY_WAS_NOT_CONNECTED_ERROR: 'An unexpected error occurred after connecting to editing services.',
    SYNCHRONY_WAS_NOT_INITIALIZED_ERROR: 'An unexpected error occurred when connecting to editing services.',
    SYNCHRONY_ACK_MISSING_ERROR: 'An unexpected error occurred after requesting the final editor state.',
    FOUND_INVALID_TEMPLATE_VARIABLE: 'Found multiple variables with the same name but different types',
    DUPLICATE_TITLE_TEMPLATE: 'Template title already used, please use a different name.',
    TEMPLATE_CONTENT_PARSING_FAILURE: 'template-content-parsing-failure',
    SYNCHRONY_UNEXPECTED_ERROR: 'An unexpected error occurred while requesting the final editor state.',
    PUBLISH_TIME_TOO_LONG_ERROR: 'An error occurred and it took too long to publish the page.',
    SCHEDULE_PUBLISH_ERROR: 'An error occurred when scheduling the publish.',
    CANCEL_SCHEDULE_PUBLISH_ERROR: 'An error occured when cancelling the scheduled publish.',
    SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR: 'Add a title, and you can set a date and time for publishing.',
    REVERT_CONTENT_ERROR: 'An error occurred while trying to revert the page.',
    PARENT_NOT_PUBLISHED: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException: Could not publish draft. Parent page has not been published.',
    RESTORE_CONTENT_SUCCESS: 'Page/blogpost has been reverted to last version',
    BLOGIFY_BLOGPOST_SUCCESS: 'Page converted to a blog post',
    TEMPLATE_PUBLISH_TAKING_LONG: 'Bear with us, this is taking a moment.',
    COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG: 'Collab init event is taking too long',
    ERROR_MESSAGE_WITH_BAD_EXCEPTION: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException:',
    CONFLICT_DRAFT_VERSIONING: 'Draft versioning is not supported.',
    COLLAB_STATUS_ERROR: "Can't save changes.",
    TEMPLATE_INVALID_SPACEKEY_ERROR: 'Invalid spaceKeys.',
    TEMPLATE_BLANK_TITLE_ERROR: 'Template title cannot be null or empty string',
    CREATED_FROM_EXTENSION: 'Draft created from create page extension'
};
module.exports["ALLOWED_FLAG_MESSAGES"] = $bacd8f7695bdf465$export$c4d5263a0e2e072d;

});

parcelRegister("8mrqR", function(module, exports) {

var $7CLBv = parcelRequire("7CLBv");


var $c4ECQ = parcelRequire("c4ECQ");


var $9lU4Z = parcelRequire("9lU4Z");

class $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError extends Error {
    constructor(){
        super("Invalid restrictions object provided.  Restrictions objects must contain a 'read' ContentRestriction and an 'update' ContentRestriction.");
    }
}
class $5c6f8af6b02c47e8$var$InvalidGraphQLRestrictionsError extends Error {
    constructor(){
        super('Invalid restrictions were fetched from GraphQL.');
    }
}
const $5c6f8af6b02c47e8$var$restrictionIsEmpty = (contentRestriction)=>{
    return contentRestriction.restrictions.user.results.length === 0 && contentRestriction.restrictions.group.results.length === 0;
};
const $5c6f8af6b02c47e8$export$54aeac99fafa79ed = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    if ($5c6f8af6b02c47e8$var$restrictionIsEmpty(readRestriction) && $5c6f8af6b02c47e8$var$restrictionIsEmpty(updateRestriction)) return (0, $c4ECQ.ContentRestrictionType).NO_RESTRICTIONS;
    else if ($5c6f8af6b02c47e8$var$restrictionIsEmpty(readRestriction)) return (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT;
    else return (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW;
};
const $5c6f8af6b02c47e8$export$b1e5e678c0890199 = (restObj, newRestrictionType, currentUser)=>{
    // This function applies a restrictionType to a RestrictionsRESTObj.
    // Some of the logic here is duplicated by `getPermissionsGroupsBasedOnRestrictionsType`
    // in RestrictionsDialog/restrictions-data-transform-helpers.tsx
    // Be sure that any changes you make to how this logic works are also made in that file.
    const oldRestrictionType = $5c6f8af6b02c47e8$export$54aeac99fafa79ed(restObj);
    const currentUserObj = {
        type: 'known',
        // The `as "known"` is needed to satisfy a Typescript error, since `type` gets assigned the type "string"
        accountId: currentUser.id,
        profilePicture: {
            path: currentUser.profilePicture.path
        },
        displayName: currentUser.displayName,
        publicName: currentUser.displayName,
        isExternalCollaborator: false
    };
    // First make a deep copy of the restObj.
    const restObjCopy = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(restObj);
    const readRestriction = restObjCopy.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObjCopy.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    if (newRestrictionType === (0, $c4ECQ.ContentRestrictionType).NO_RESTRICTIONS) {
        // Empty out update and read arrays.
        readRestriction.restrictions.user.results = [];
        readRestriction.restrictions.group.results = [];
        updateRestriction.restrictions.user.results = [];
        updateRestriction.restrictions.group.results = [];
        return restObjCopy;
    } else if (newRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) {
        if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW) {
            readRestriction.restrictions.user.results = [];
            readRestriction.restrictions.group.results = [];
            return restObjCopy;
        } else if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) return restObjCopy;
        else {
            // oldRestrictionType === ContentRestrictionType.NO_RESTRICTIONS
            updateRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        }
    } else {
        // newRestrictionType === ContentRestrictionType.RESTRICT_VIEW
        if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW) return restObjCopy;
        else if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) {
            readRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        } else {
            // oldRestrictionType === ContentRestrictionType.NO_RESTRICTIONS
            readRestriction.restrictions.user.results.push(currentUserObj);
            updateRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        }
    }
// Permissions levels:
// NO_RESTRICTIONS
// RESTRICT_EDIT
// RESTRICT_VIEW
//
// To move upwards on that list, just empty out the restrictions arrays.
// To move downwards on that list, you have to add the current user into the correct restrictions segment.
};
const $5c6f8af6b02c47e8$var$convertRESTUser = (restUser)=>{
    return {
        key: `USER-${restUser.accountId}`,
        entityType: (0, $c4ECQ.EntityType).USER,
        permissions: [],
        displayName: restUser.displayName,
        accountId: restUser.accountId,
        profilePicture: {
            path: restUser.profilePicture.path
        },
        hasSpaceViewPermission: restUser?.hasSpaceViewPermission ?? true,
        hasSpaceEditPermission: restUser?.hasSpaceEditPermission ?? true,
        permissionType: restUser.isExternalCollaborator ? (0, $9lU4Z.SitePermissionType).EXTERNAL : (0, $9lU4Z.SitePermissionType).INTERNAL
    };
};
const $5c6f8af6b02c47e8$var$convertRESTGroup = (restGroup)=>{
    return {
        key: `GROUP-${restGroup.id}`,
        entityType: (0, $c4ECQ.EntityType).GROUP,
        permissions: [],
        name: restGroup.name,
        permissionType: (0, $9lU4Z.SitePermissionType).INTERNAL
    };
};
const $5c6f8af6b02c47e8$export$a9b84852f592ee6c = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    // TODO It may be possible to re-use some of the logic in
    // restrictions-data-transform-helpers.tsx here.
    // First, make a map from accountIds or group ids to their corresponding objects.
    const userGroupMap = new Map();
    for (const user of readRestriction.restrictions.user.results){
        if (!userGroupMap.has(user.accountId)) userGroupMap.set(user.accountId, $5c6f8af6b02c47e8$var$convertRESTUser(user));
        userGroupMap.get(user.accountId).permissions.push((0, $c4ECQ.PermissionType).VIEW);
    }
    for (const group of readRestriction.restrictions.group.results){
        if (!userGroupMap.has(group.id)) userGroupMap.set(group.id, $5c6f8af6b02c47e8$var$convertRESTGroup(group));
        userGroupMap.get(group.id).permissions.push((0, $c4ECQ.PermissionType).VIEW);
    }
    for (const user of updateRestriction.restrictions.user.results){
        if (!userGroupMap.has(user.accountId)) userGroupMap.set(user.accountId, $5c6f8af6b02c47e8$var$convertRESTUser(user));
        userGroupMap.get(user.accountId).permissions.push((0, $c4ECQ.PermissionType).EDIT);
    }
    for (const group of updateRestriction.restrictions.group.results){
        if (!userGroupMap.has(group.id)) userGroupMap.set(group.id, $5c6f8af6b02c47e8$var$convertRESTGroup(group));
        userGroupMap.get(group.id).permissions.push((0, $c4ECQ.PermissionType).EDIT);
    }
    // Return an array out of all the values from the map.
    // This matches the format of the usersAndGroups object.
    return Array.from(userGroupMap).map(([, value])=>value);
};
const $5c6f8af6b02c47e8$export$dfb1e6e2e25bf061 = (user)=>{
    return {
        type: 'known',
        accountId: user?.accountId ?? '',
        publicName: user?.publicName ?? '',
        profilePicture: {
            path: user?.profilePicture?.path ?? ''
        },
        email: user?.email ?? '',
        displayName: user?.displayName ?? '',
        hasSpaceViewPermission: user?.hasSpaceViewPermission ?? true,
        hasSpaceEditPermission: user?.hasSpaceEditPermission ?? true,
        isExternalCollaborator: user.permissionType === (0, $9lU4Z.SitePermissionType).EXTERNAL
    };
};
const $5c6f8af6b02c47e8$export$354ad6f5846ff4ac = (group)=>{
    return {
        type: 'group',
        name: group?.name ?? '',
        id: group?.id ?? '',
        usageType: group?.usageType ?? null
    };
};
const $5c6f8af6b02c47e8$var$isDefined = (value)=>{
    return value != null;
};
const $5c6f8af6b02c47e8$export$a57b08835223f9b8 = (queryData)=>{
    const readRestriction = queryData?.content?.nodes?.[0]?.restrictions?.read?.restrictions;
    const updateRestriction = queryData?.content?.nodes?.[0]?.restrictions?.update?.restrictions;
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidGraphQLRestrictionsError();
    const readObj = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const updateObj = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    readObj.restrictions.user.results = (readRestriction?.userWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((user)=>$5c6f8af6b02c47e8$export$dfb1e6e2e25bf061(user));
    readObj.restrictions.group.results = (readRestriction?.groupWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((group)=>$5c6f8af6b02c47e8$export$354ad6f5846ff4ac(group));
    updateObj.restrictions.user.results = (updateRestriction?.userWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((user)=>$5c6f8af6b02c47e8$export$dfb1e6e2e25bf061(user));
    updateObj.restrictions.group.results = (updateRestriction?.groupWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((group)=>$5c6f8af6b02c47e8$export$354ad6f5846ff4ac(group));
    return [
        readObj,
        updateObj
    ];
};
const $5c6f8af6b02c47e8$export$9281fb4d0a89ade8 = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    const onlyOneUserCanRead = readRestriction.restrictions.user.results.length === 1;
    const noGroupsCanRead = readRestriction.restrictions.group.results.length === 0;
    const onlyOneUserCanUpdate = updateRestriction.restrictions.user.results.length === 1;
    const noGroupsCanUpdate = updateRestriction.restrictions.group.results.length === 0;
    return onlyOneUserCanRead && noGroupsCanRead && onlyOneUserCanUpdate && noGroupsCanUpdate;
};
module.exports["getRestrictionsTypeFromRESTObj"] = $5c6f8af6b02c47e8$export$54aeac99fafa79ed;
module.exports["getUsersAndGroupsFromRESTObj"] = $5c6f8af6b02c47e8$export$a9b84852f592ee6c;
module.exports["transformUserToREST"] = $5c6f8af6b02c47e8$export$dfb1e6e2e25bf061;
module.exports["transformGroupToREST"] = $5c6f8af6b02c47e8$export$354ad6f5846ff4ac;
module.exports["transformGraphQLQueryToRESTObj"] = $5c6f8af6b02c47e8$export$a57b08835223f9b8;
module.exports["restrictionsArePrivateToYouOnly"] = $5c6f8af6b02c47e8$export$9281fb4d0a89ade8;

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("c4ECQ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $e40ae21eed558c2b$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
    ContentRestrictionType["RESTRICT_EDIT"] = "RESTRICT_EDIT";
    ContentRestrictionType["RESTRICT_VIEW"] = "RESTRICT_VIEW";
    return ContentRestrictionType;
}({});
var $e40ae21eed558c2b$export$7602248773d1f745 = /*#__PURE__*/ function(RestrictionFrom) {
    RestrictionFrom["DIRECT"] = "DIRECT";
    RestrictionFrom["MULTIPLE"] = "MULTIPLE";
    RestrictionFrom["NONE"] = "NONE";
    RestrictionFrom["PAGE_INHERITED"] = "PAGE_INHERITED";
    RestrictionFrom["SPACE"] = "SPACE";
    return RestrictionFrom;
}({});
var $e40ae21eed558c2b$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["GROUP"] = "GROUP";
    EntityType["USER"] = "USER";
    return EntityType;
}({});
var $e40ae21eed558c2b$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["VIEW"] = "VIEW";
    return PermissionType;
}({});
var $e40ae21eed558c2b$export$efe8384a5aa2f235 = /*#__PURE__*/ function(ErrorMessageType) {
    ErrorMessageType["NO_ANCESTOR_VIEW"] = "NO_ANCESTOR_VIEW";
    ErrorMessageType["NO_SPACE_VIEW"] = "NO_SPACE_VIEW";
    ErrorMessageType["NO_SPACE_EDIT"] = "NO_SPACE_EDIT";
    return ErrorMessageType;
}({});
var $e40ae21eed558c2b$export$4ecc254c2ddad822 = /*#__PURE__*/ function(OpenDialogType) {
    OpenDialogType["INSPECT_PERMISSIONS"] = "INSPECT_PERMISSIONS";
    OpenDialogType["ACCESS_DETAILS"] = "ACCESS_DETAILS";
    OpenDialogType["RESTRICTIONS"] = "RESTRICTIONS";
    OpenDialogType["PUBLIC_LINKS_VALIDATION"] = "PUBLIC_LINKS_VALIDATION";
    return OpenDialogType;
}({});
module.exports["ContentRestrictionType"] = $e40ae21eed558c2b$export$91111a1ebace330;
module.exports["RestrictionFrom"] = $e40ae21eed558c2b$export$7602248773d1f745;
module.exports["EntityType"] = $e40ae21eed558c2b$export$8eda7e02f8f033b2;
module.exports["PermissionType"] = $e40ae21eed558c2b$export$af2022a36dc13b47;
module.exports["ErrorMessageType"] = $e40ae21eed558c2b$export$efe8384a5aa2f235;
module.exports["OpenDialogType"] = $e40ae21eed558c2b$export$4ecc254c2ddad822;

});

parcelRegister("9lU4Z", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $4fac0aee9a82e652$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $4fac0aee9a82e652$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $4fac0aee9a82e652$export$8995abb8169b2cb8;

});

parcelRegister("c6abH", function(module, exports) {
const $39da9b0f89d8b5d0$export$e089b3c2861d2024 = '9:00';
const $39da9b0f89d8b5d0$export$c4e1e4e065ff5bd8 = 'HH:mm';
const $39da9b0f89d8b5d0$export$ec93f019c59056da = 5;
const $39da9b0f89d8b5d0$export$45c85543ba71221d = 'yyyy-MM-dd';
var $39da9b0f89d8b5d0$export$377e0d8530a6da1a = /*#__PURE__*/ function(PublishErrorFlagKeys) {
    PublishErrorFlagKeys["TITLE_IS_BLANK"] = "TITLE_IS_BLANK";
    PublishErrorFlagKeys["DUPLICATE_TITLE"] = "TITLE_EXISTS_IN_SPACE";
    return PublishErrorFlagKeys;
}({});
const $39da9b0f89d8b5d0$export$9467f27273d92816 = {
    PMF1: 'PMF1',
    PMF2: 'PMF2',
    USB1: 'USB1',
    PBWMO1: 'PBWMO1',
    PBWMO2: 'PBWMO2',
    PBWMO3: 'PBWMO3',
    PBWMO4: 'PBWMO4',
    PBWMO5: 'PBWMO5',
    PMKS1: 'PMKS1',
    PMKS2: 'PMKS2'
};
module.exports["DEFAULT_TIME"] = $39da9b0f89d8b5d0$export$e089b3c2861d2024;
module.exports["TIME_FORMAT"] = $39da9b0f89d8b5d0$export$c4e1e4e065ff5bd8;
module.exports["MINUTES_IN_FUTURE"] = $39da9b0f89d8b5d0$export$ec93f019c59056da;
module.exports["DATE_FORMAT"] = $39da9b0f89d8b5d0$export$45c85543ba71221d;
module.exports["PublishErrorFlagKeys"] = $39da9b0f89d8b5d0$export$377e0d8530a6da1a;
module.exports["SHORTCUT_KEYS"] = $39da9b0f89d8b5d0$export$9467f27273d92816;

});

parcelRegister("6pob4", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $11195e31c84c0d05$export$f2a208b9886d2628 = (0, $1P1Tu.createStore)({
    name: 'PublishModalMountStore',
    initialState: {
        shouldDisplayPublishModal: false,
        initialFocusTarget: undefined
    },
    actions: {
        openPublishModal: ()=>({ setState: setState })=>setState({
                    shouldDisplayPublishModal: true
                }),
        closePublishModal: ()=>({ setState: setState })=>setState({
                    shouldDisplayPublishModal: false
                }),
        setInitialFocusTarget: (newFocusTarget)=>({ setState: setState })=>setState({
                    initialFocusTarget: newFocusTarget
                })
    }
});
const $11195e31c84c0d05$export$7cf94392fd4ac5a6 = (0, $9zUhf.createStateHook)($11195e31c84c0d05$export$f2a208b9886d2628);
const $11195e31c84c0d05$export$19811b111083a6d = (0, $9zUhf.createActionsHook)($11195e31c84c0d05$export$f2a208b9886d2628);
module.exports["usePublishModalMountStore"] = $11195e31c84c0d05$export$7cf94392fd4ac5a6;
module.exports["usePublishModalMountActions"] = $11195e31c84c0d05$export$19811b111083a6d;

});

parcelRegister("88Nzy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2ZJmt = parcelRequire("2ZJmt");


var $bHWAG = parcelRequire("bHWAG");

const $86935ecd4293d578$var$i18n = (0, $aXWIB.defineMessages)({
    lockoutMessage: {
        id: "pdf-print-utils.navigation-lockout-message",
        defaultMessage: "You have unsaved changes. Please save before printing."
    }
});
function $86935ecd4293d578$var$tryGetAtlToken() {
    try {
        return (0, $bHWAG.getLiveAtlToken)();
    } catch  {
        return null;
    }
}
async function $86935ecd4293d578$export$94dac1f6a6cc2b5b(maxTries = 12, interval = 250) {
    let tries = 0;
    for(;;){
        const t = $86935ecd4293d578$var$tryGetAtlToken();
        if (t) return t;
        tries += 1;
        if (tries >= maxTries) throw new Error('atlToken not available');
        await new Promise((r)=>setTimeout(r, interval));
    }
}
function $86935ecd4293d578$export$36438d970303153({ enabled: enabled, shouldBlockPrint: shouldBlockPrint, onPrintBlocked: onPrintBlocked }) {
    const attachedRef = (0, $42omo.useRef)(false);
    const shouldBlockPrintRef = (0, $42omo.useRef)(shouldBlockPrint);
    const [showLockout, setShowLockout] = (0, $42omo.useState)(false);
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        shouldBlockPrintRef.current = shouldBlockPrint;
    }, [
        shouldBlockPrint
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!enabled) return;
        if (attachedRef.current) return;
        attachedRef.current = true;
        if ((0, $bHWAG.isInsideIframe)()) return;
        const handler = async (e)=>{
            const key = typeof e.key === 'string' ? e.key : '';
            const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
            const isPrintCombo = isMac ? e.metaKey && (key === 'p' || key === 'P' // mac: only cmd+P
            ) : e.ctrlKey && (key === 'p' || key === 'P'); // windows/linux: only ctrl+P
            if (!isPrintCombo) return;
            const shouldBlock = shouldBlockPrintRef.current ? shouldBlockPrintRef.current() : false;
            if (shouldBlock) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                setShowLockout(true);
                onPrintBlocked?.();
                return;
            }
            if (!(0, $bHWAG.isPageViewRoute)(window.location.pathname)) return;
            const pageId = (0, $bHWAG.getPageId)(window.location.pathname);
            if (!pageId) return;
            let atlToken = $86935ecd4293d578$var$tryGetAtlToken();
            if (!atlToken) try {
                atlToken = await $86935ecd4293d578$export$94dac1f6a6cc2b5b();
            } catch  {
                return;
            }
            if (!atlToken || !pageId) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            const params = new URLSearchParams({
                pageId: pageId,
                atl_token: atlToken,
                showPdfBanner: 'true'
            });
            const url = `${window.location.origin}/wiki/spaces/flyingpdf/pdfpageexport.action?${params.toString()}`;
            window.location.assign(url);
        };
        const opts = {
            capture: true,
            passive: false
        };
        window.addEventListener('keydown', handler, opts);
        document.addEventListener('keydown', handler, opts);
        return ()=>{
            window.removeEventListener('keydown', handler, opts);
            document.removeEventListener('keydown', handler, opts);
            attachedRef.current = false;
        };
    }, [
        enabled,
        onPrintBlocked
    ]);
    const lockoutComponent = showLockout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), {
        message: intl.formatMessage($86935ecd4293d578$var$i18n.lockoutMessage)
    }) : null;
    return lockoutComponent;
}
module.exports["usePrintIntercept"] = $86935ecd4293d578$export$36438d970303153;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("618I0"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("618I0", function(module, exports) {

let $4619977a62937b7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4619977a62937b7e$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("bHWAG", function(module, exports) {
function $661369be983dfb69$export$7b6f372ddaf80f4a() {
    // in SSR or non-browser contexts there is no document
    if (typeof document === 'undefined') return null;
    // try the meta tag first: <meta name="ajs-atl-token" content="...">
    // use a typed querySelector so .content is available on HTMLMetaElement
    const metaToken = document.querySelector('meta[name="ajs-atl-token"]')?.content ?? // fallback to attribute read in case DOM typings differ
    document.querySelector('meta[name="ajs-atl-token"]')?.getAttribute('content');
    if (metaToken) return metaToken;
    // fallback to cookies if readable in this environment
    const m = document.cookie.match(/(?:^|;\s*)(atl\.xsrf\.token|atlassian\.account\.xsrf\.token)=([^;]+)/);
    // group 2 is the token value
    return m ? m[2] : null;
}
function $661369be983dfb69$export$2ce6e339a89daf7a(path) {
    const m = path.match(/\/pages\/(\d+)/);
    return m ? m[1] : null;
}
function $661369be983dfb69$export$1ae14b4842b49ade(path) {
    // Manual pathname check instead of using VIEW_PAGE.match() to avoid circular dependency
    // Using @confluence/named-routes -> @confluence/view-page-common creates a circular dependency:
    // @confluence/content-renderer -> @confluence/pdf-export -> @confluence/view-page-common -> @confluence/content-renderer
    // Pattern matches: /spaces/:spaceKey/pages/:contentId(digits)/:contentSlug?
    return path.match(/\/spaces\/[^/]+\/pages\/\d+/) !== null;
}
function $661369be983dfb69$export$bc4e1d0ebda8ad2c() {
    try {
        return window.self !== window.top;
    } catch (e) {
        // accessing window.top can throw in some cross-origin scenarios
        return true;
    }
}
const $661369be983dfb69$export$d8536155e595e20f = (imagePath)=>{
    const img = new Image();
    img.src = imagePath;
};
module.exports["getLiveAtlToken"] = $661369be983dfb69$export$7b6f372ddaf80f4a;
module.exports["getPageId"] = $661369be983dfb69$export$2ce6e339a89daf7a;
module.exports["isPageViewRoute"] = $661369be983dfb69$export$1ae14b4842b49ade;
module.exports["isInsideIframe"] = $661369be983dfb69$export$bc4e1d0ebda8ad2c;
module.exports["preloadImage"] = $661369be983dfb69$export$d8536155e595e20f;

});

parcelRegister("dA1Sn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $42omo.useState)(isNoSSR || !fullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $42omo.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { style: style, name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t3;
            if ($[0] !== name || $[1] !== ssrPlaceholder) {
                t3 = ssrPlaceholder && (0, $6mKj3.expValEquals)("platform_editor_two_stage_hydration_placeholder", "isEnabled", true) ? {
                    "data-ssr-placeholder": name,
                    "data-ssr-placeholder-replace": name
                } : {};
                $[0] = name;
                $[1] = ssrPlaceholder;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== children || $[5] !== name || $[6] !== t3) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    ...t3,
                    style: t4
                }, children);
                $[4] = children;
                $[5] = name;
                $[6] = t3;
                $[7] = t5;
            } else t5 = $[7];
            return t5;
        }
        const innerHTML = fullCycleOutput;
        let t3;
        if ($[8] !== name || $[9] !== ssrPlaceholder) {
            t3 = ssrPlaceholder && (0, $6mKj3.expValEquals)("platform_editor_two_stage_hydration_placeholder", "isEnabled", true) ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[8] = name;
            $[9] = ssrPlaceholder;
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== innerHTML) {
            t4 = {
                __html: innerHTML
            };
            $[11] = innerHTML;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                dangerouslySetInnerHTML: t4,
                style: t5
            });
            $[14] = name;
            $[15] = t3;
            $[16] = t4;
            $[17] = t6;
        } else t6 = $[17];
        return t6;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t3;
    if ($[22] !== innerHTML_0) {
        t3 = {
            __html: innerHTML_0
        };
        $[22] = innerHTML_0;
        $[23] = t3;
    } else t3 = $[23];
    let t4;
    if ($[24] !== name || $[25] !== style || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t3
        });
        $[24] = name;
        $[25] = style;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { name: name, style: style, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("8HrX3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");

const $a7f86182a225a9f3$var$useFocusedTaskIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedTaskId');
const $a7f86182a225a9f3$var$TaskScrollComponentInner = ()=>{
    const focusedTaskId = $a7f86182a225a9f3$var$useFocusedTaskIdQueryParam();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    if (focusedTaskId) {
        const taskElement = document.querySelector(`[data-task-local-id="${focusedTaskId}"]`);
        if (taskElement) {
            taskElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
            // Remove the query param immediately after task scroll is complete
            setQueryParams({
                focusedTaskId: undefined
            });
        }
    }
    return null;
};
const $a7f86182a225a9f3$export$d9ea3940454347d1 = ()=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_focused-task-scroll')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a7f86182a225a9f3$var$TaskScrollComponentInner, null);
};
module.exports["TaskScrollComponent"] = $a7f86182a225a9f3$export$d9ea3940454347d1;

});

parcelRegister("lmNXu", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $vLw8x = parcelRequire("vLw8x");

const $cdf0b5cb977c302e$export$f996105bf70a5c25 = (0, $2XqLN.default)((routesContext, handleLinks)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        },
        ...handleLinks ? {
            link: {
                onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
            }
        } : {}
    } : undefined);
module.exports["createSmartCardEventHandler"] = $cdf0b5cb977c302e$export$f996105bf70a5c25;

});

parcelRegister("1AJi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $hR4U4 = parcelRequire("hR4U4");


var $8unJx = parcelRequire("8unJx");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $42omo.useCallback)((openChatMode = 'sidebar')=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $hR4U4.ConversationAssistantUIModes).MINI_MODAL : (0, $hR4U4.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $76e32f06e038930c$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("hR4U4", function(module, exports) {
const $991dc85317754fda$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $991dc85317754fda$export$bc36ebf73899a71d;

});

parcelRegister("8unJx", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $kPbXZ = parcelRequire("kPbXZ");

const $d1d2403974de0af3$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    initialPrompt: undefined
};
const $d1d2403974de0af3$var$store = (0, $1P1Tu.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $d1d2403974de0af3$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($d1d2403974de0af3$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $d1d2403974de0af3$var$useStore = (0, $9zUhf.createHook)($d1d2403974de0af3$var$store);
const $d1d2403974de0af3$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt }, { reset: reset, clearInitialPrompt: clearInitialPrompt, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $d1d2403974de0af3$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $d1d2403974de0af3$export$66cf76b7e04da11f = (0, $9zUhf.createActionsHook)($d1d2403974de0af3$var$store);
module.exports["useRovoExperienceAPIStore"] = $d1d2403974de0af3$export$37440b51449f7ac6;

});

parcelRegister("kPbXZ", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $053d47555d884138$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $053d47555d884138$export$bc36ebf73899a71d;

});

parcelRegister("2bR8c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $42omo.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("flriQ", function(module, exports) {

let $b2bdfef81ac75584$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2bdfef81ac75584$var$load("akTOz"),
    $b2bdfef81ac75584$var$load("jdWk3"),
    $b2bdfef81ac75584$var$load("04elT"),
    $b2bdfef81ac75584$var$load("cHQ50"),
    $b2bdfef81ac75584$var$load("llcfA"),
    $b2bdfef81ac75584$var$load("bFpW7")
]).then(()=>parcelRequire('l8Gbi'));

});

parcelRegister("1n6r5", function(module, exports) {

let $0ffcee71a2b47db8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ffcee71a2b47db8$var$load("inTWi").then(()=>parcelRequire('9qb5A'));

});

parcelRegister("amg3z", function(module, exports) {
/**
 * Patterns for detecting integration links
 */ const $25b5f997878fea60$var$LINK_PATTERNS = {
    slack: /https?:\/\/[a-z0-9-]+\.slack\.com\/.*/i,
    // Microsoft integration: Teams + SharePoint/OneDrive + Outlook
    microsoft: /https?:\/\/(teams\.microsoft\.com|outlook\.office\.com|outlook\.live\.com|[a-z0-9-]+\.sharepoint\.com|1drv\.ms|onedrive\.live\.com)\/.*/i
};
/**
 * Type guard to check if a node has attrs
 */ const $25b5f997878fea60$var$hasAttrs = (node)=>{
    return node && typeof node === 'object' && 'attrs' in node;
};
/**
 * Type guard to check if a node has marks
 */ const $25b5f997878fea60$var$hasMarks = (node)=>{
    return node && typeof node === 'object' && 'marks' in node && Array.isArray(node.marks);
};
/**
 * Extract all links from ADF content iteratively using a queue
 * Uses 'any' type for node parameter because ADF child nodes have different types
 * than DocNode (text, inlineCard, blockCard, etc.)
 */ const $25b5f997878fea60$var$extractLinksFromAdf = (rootNode)=>{
    if (!rootNode || typeof rootNode !== 'object') return [];
    const links = [];
    const queue = [
        rootNode
    ];
    while(queue.length > 0){
        const node = queue.shift();
        if (!node || typeof node !== 'object') continue;
        // Check if current node is a text node with link marks, or plain-text URLs.
        if (node.type === 'text') {
            const linkMark = $25b5f997878fea60$var$hasMarks(node) ? node.marks.find((mark)=>mark.type === 'link' && mark.attrs?.href) : undefined;
            if (linkMark) links.push(linkMark.attrs.href);
            else if (typeof node.text === 'string') {
                const urlMatches = node.text.match(/https?:\/\/[^\s)\]}>,"']+/gi);
                if (urlMatches) links.push(...urlMatches);
            }
        }
        // Check for smart card nodes (inlineCard, blockCard, embedCard)
        if (node.type === 'inlineCard' || node.type === 'blockCard' || node.type === 'embedCard') {
            if ($25b5f997878fea60$var$hasAttrs(node) && node.attrs.url) links.push(node.attrs.url);
        }
        // Add child nodes to queue
        if (node.content && Array.isArray(node.content)) queue.push(...node.content);
    }
    return links;
};
const $25b5f997878fea60$export$d060694f7c9f2b3a = (slice)=>{
    if (!slice || !slice.content) return [];
    const links = [];
    const queue = [];
    // Add all top-level nodes from the slice to the queue
    slice.content.forEach((node)=>{
        queue.push(node);
    });
    // Process nodes using BFS (same logic as extractLinksFromAdf)
    while(queue.length > 0){
        const node = queue.shift();
        if (!node) continue;
        // Check for text nodes with link marks, or plain-text URLs.
        if (node.type.name === 'text') {
            const linkMark = node.marks?.find((mark)=>mark.type.name === 'link' && mark.attrs?.href);
            if (linkMark) links.push(linkMark.attrs.href);
            else if (typeof node.text === 'string') {
                // Some paste flows provide plain text without a link mark.
                // Best-effort: pull out URLs from the text.
                const urlMatches = node.text.match(/https?:\/\/[^\s)\]}>,"']+/gi);
                if (urlMatches) links.push(...urlMatches);
            }
        }
        // Check for smart card nodes (inlineCard, blockCard, embedCard)
        const nodeName = node.type.name;
        if (nodeName === 'inlineCard' || nodeName === 'blockCard' || nodeName === 'embedCard') {
            if (node.attrs?.url) links.push(node.attrs.url);
        }
        // Add child nodes to queue
        if (node.content) // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        node.content.forEach((childNode)=>{
            queue.push(childNode);
        });
    }
    return links;
};
/**
 * Determine the type of a link based on URL patterns
 */ const $25b5f997878fea60$var$classifyLink = (url)=>{
    for (const [type, pattern] of Object.entries($25b5f997878fea60$var$LINK_PATTERNS)){
        if (pattern.test(url)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return type;
    }
    return 'other';
};
const $25b5f997878fea60$export$a533cc92068f97c3 = (urls)=>{
    const uniqueUrls = new Set(urls);
    const result = [];
    for (const url of uniqueUrls){
        const type = $25b5f997878fea60$var$classifyLink(url);
        if (type !== 'other') result.push({
            url: url,
            type: type
        });
    }
    return result;
};
const $25b5f997878fea60$export$c3604445bd868cb2 = (adfValue)=>{
    const allLinks = $25b5f997878fea60$var$extractLinksFromAdf(adfValue);
    return $25b5f997878fea60$export$a533cc92068f97c3(allLinks);
};
const $25b5f997878fea60$export$f6b1cd37615f37cd = (links)=>{
    if (links.length === 0) return null;
    // Build a set of available types for O(1) lookup
    const availableTypes = new Set(links.map((link)=>link.type));
    // Priority order: Slack > Microsoft
    const priority = [
        'slack',
        'microsoft'
    ];
    for (const type of priority){
        if (availableTypes.has(type)) return type;
    }
    return links[0].type;
};
const $25b5f997878fea60$export$196e8d4958925ab2 = (links)=>{
    const uniqueTypes = new Set();
    for (const link of links)if (link.type !== 'other') uniqueTypes.add(link.type);
    // Return in priority order: Slack, Microsoft
    const priority = [
        'slack',
        'microsoft'
    ];
    return priority.filter((type)=>uniqueTypes.has(type));
};
const $25b5f997878fea60$export$6888e547c88384f6 = (currentLinks, initialLinkTypes)=>{
    const currentTypes = $25b5f997878fea60$export$196e8d4958925ab2(currentLinks);
    const initialSet = new Set(initialLinkTypes);
    // Filter to only include types that weren't in initial content
    return currentTypes.filter((type)=>!initialSet.has(type));
};
module.exports["extractLinksFromSlice"] = $25b5f997878fea60$export$d060694f7c9f2b3a;
module.exports["getDetectedLinksFromUrls"] = $25b5f997878fea60$export$a533cc92068f97c3;
module.exports["detectIntegrationLinks"] = $25b5f997878fea60$export$c3604445bd868cb2;

});

parcelRegister("eWgCZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $amg3z = parcelRequire("amg3z");

const $f85b39b36f718f58$export$8d9836a43c68a9f6 = ()=>{
    const [detectedLinks, setDetectedLinks] = (0, $42omo.useState)([]);
    const [newLinkTypes, setNewLinkTypes] = (0, $42omo.useState)([]);
    const [newLinks, setNewLinks] = (0, $42omo.useState)([]);
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $42omo.useState)(false);
    // Track what URLs existed when editor opened (initial state)
    // This enables URL-level delta detection
    const initialUrlsRef = (0, $42omo.useRef)(new Set());
    /**
	 * Set the initial content when editor opens
	 * Call with existing ADF for edit mode, or null for new content
	 */ const setInitialContent = (0, $42omo.useCallback)((adfValue)=>{
        if (!(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        const initialLinks = (0, $amg3z.detectIntegrationLinks)(adfValue);
        const initialUrls = new Set(initialLinks.map((link)=>link.url));
        initialUrlsRef.current = initialUrls;
    }, []);
    /**
	 * Handle save event - detect NEW links (URL-level) compared to initial content
	 * Key change: If user adds a second Slack link, Slack is still "newly eligible"
	 */ const handleSave = (0, $42omo.useCallback)((adfValue)=>{
        if (!(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        // Detect all integration links in saved content
        const currentLinks = (0, $amg3z.detectIntegrationLinks)(adfValue);
        // Get initial URLs
        const initialUrls = initialUrlsRef.current;
        // Find newly added URLs (not in initial set)
        const newlyAddedLinks = currentLinks.filter((link)=>!initialUrls.has(link.url));
        if (newlyAddedLinks.length > 0) {
            // Get unique types from newly added links
            const newTypes = [
                ...new Set(newlyAddedLinks.map((link)=>link.type))
            ];
            setDetectedLinks(currentLinks);
            setNewLinks(newlyAddedLinks);
            setNewLinkTypes(newTypes);
            setShouldShowSpotlight(true);
        }
    }, []);
    /**
	 * Handle pasted integration links - detect NEW links (URL-level) compared to initial content
	 * More efficient than handleSave as it only processes pasted links, not entire document
	 */ const handlePastedLinks = (0, $42omo.useCallback)((links)=>{
        if (links.length === 0 || !(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        // Get initial URLs
        const initialUrls = initialUrlsRef.current;
        // Find newly added URLs (not in initial set) - DELTA LOGIC
        const newlyAddedLinks = links.filter((link)=>!initialUrls.has(link.url));
        if (newlyAddedLinks.length > 0) {
            // Get unique types from newly added links
            const newTypes = [
                ...new Set(newlyAddedLinks.map((link)=>link.type))
            ];
            setDetectedLinks(newlyAddedLinks);
            setNewLinks(newlyAddedLinks);
            setNewLinkTypes(newTypes);
            setShouldShowSpotlight(true);
        }
    }, []);
    /**
	 * Close the spotlight
	 */ const closeSpotlight = (0, $42omo.useCallback)(()=>{
        setShouldShowSpotlight(false);
        setDetectedLinks([]);
        setNewLinkTypes([]);
        setNewLinks([]);
    }, []);
    return {
        detectedLinks: detectedLinks,
        newLinkTypes: newLinkTypes,
        newLinks: newLinks,
        shouldShowSpotlight: shouldShowSpotlight,
        handleSave: handleSave,
        handlePastedLinks: handlePastedLinks,
        closeSpotlight: closeSpotlight,
        setInitialContent: setInitialContent
    };
};
module.exports["useIntegrationLinkSpotlight"] = $f85b39b36f718f58$export$8d9836a43c68a9f6;

});

parcelRegister("hfKvg", function(module, exports) {

let $c8f7e8f36f4edfd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8f7e8f36f4edfd8$var$load("cKqFC").then(()=>parcelRequire('f337l'));

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialOutcomeType: undefined,
    remixConversationId: null,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialOutcomeType: initialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, remixConversationId: remixConversationIdFromOpen })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialOutcomeType: initialOutcomeType ?? undefined,
                remixConversationId: remixConversationId,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialOutcomeType: undefined,
                remixConversationId: null,
                onCloseCallback: undefined,
                onOpenCallback: undefined
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("fWGpT", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $5d9b4 = parcelRequire("5d9b4");


var $hvdlr = parcelRequire("hvdlr");


var $1iSzD = parcelRequire("1iSzD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $1VB1N = parcelRequire("1VB1N");


var $8VXwD = parcelRequire("8VXwD");


var $bNHtR = parcelRequire("bNHtR");


var $gNjy8 = parcelRequire("gNjy8");

const $6e4f6ea8730b931f$export$1504d130127dbc5f = (options)=>{
    const cloudId = options?.cloudId ?? '';
    const contentId = options?.contentId ?? '';
    const contentType = options?.contentType ?? '';
    const fetchUsersClient = options?.fetchUsersClient ?? '';
    return `${cloudId}_${contentId}_${contentType}_${fetchUsersClient}`;
};
const $6e4f6ea8730b931f$export$3c298c8b4091db27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((options)=>{
    // start measuring duration for initializing the provider
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT);
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH);
    const { contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType, permissionTokenRefresh: permissionTokenRefresh, initialDraft: initialDraft, isLivePage: isLivePage, onUserFetchError: onUserFetchError, presenceId: presenceId, presenceActivity: presenceActivity, userId: userId, fetchUsersClient: fetchUsersClient } = options;
    const url = (0, $1VB1N.getCollabProviderUrl)();
    const path = (0, $6mKj3.expVal)('platform_editor_to_use_pmr_for_collab_edit_none_ic', 'isEnabled', false) ? (0, $1VB1N.getCollabEditServicePath)(cloudId, activationId) : undefined;
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
    const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
    const subProduct = isEmbeddedConfluence ? (0, $jiJCD.parse)(location.search, true).query.parentProduct : isLivePage ? 'live' : undefined;
    const fetchAnonymousAssetCallback = async (id)=>{
        try {
            return await (0, $gNjy8.fetchAnonymousAsset)(id);
        } catch (error) {
            onUserFetchError?.(error);
        }
        return undefined;
    };
    // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
    // This means that anonymous users will still rely on presenceId and not get deduplicated.
    const collaboratorPresenceId = userId ?? presenceId;
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH);
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CREATED);
    // DO NOT add any asynchronous calls/behavior to the collab provider creation. This has caused incidents
    // in the past where the provider promise never resolves and editing breaks.
    // Context: https://hello.atlassian.net/wiki/spaces/~589311246/pages/2554442259/Investigate+async+issue+HOT-103180
    return (0, $hvdlr.createSocketIOCollabProvider)({
        documentAri: documentAri,
        url: url,
        path: path,
        batchProps: {
            getUsers: fetchUsersClient === 'agg' ? (0, $8VXwD.fetchNativeCollabAGGUsers) : (0, $bNHtR.fetchNativeCollabConfluenceUsers),
            batchSize: 50,
            onError: onUserFetchError
        },
        getAnalyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
        permissionTokenRefresh: permissionTokenRefresh,
        need404: true,
        productInfo: {
            product: product,
            subProduct: Array.isArray(subProduct) ? subProduct.join('-') : subProduct
        },
        // either pass the initialDraft that was fetched on hover, or the draftResponse that was fetched on click
        initialDraft: initialDraft || undefined,
        isBufferingEnabled: Boolean(initialDraft),
        __livePage: isLivePage,
        presenceId: collaboratorPresenceId,
        presenceActivity: presenceActivity,
        throwOnNotConnected: true,
        fetchAnonymousAsset: fetchAnonymousAssetCallback
    });
}, $6e4f6ea8730b931f$export$1504d130127dbc5f);
module.exports["getCollabEditProvider"] = $6e4f6ea8730b931f$export$3c298c8b4091db27;

});

parcelRegister("hvdlr", function(module, exports) {

var $1daQW = parcelRequire("1daQW");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eOOPa = parcelRequire("eOOPa");


var $4frCv = parcelRequire("4frCv");


var $1jdMD = parcelRequire("1jdMD");

function $28639aaa801abbd1$export$2326b022d5973f36(url, auth, productInfo, isPresenceOnly, analyticsHelper, path, documentAri) {
    const { pathname: pathname } = new URL(url);
    let socketIOOptions = (0, $1jdMD.SOCKET_IO_OPTIONS);
    // Polling first
    let transports = [
        'polling',
        'websocket'
    ];
    let usePMR = false;
    if (isPresenceOnly) {
        // Presence-specific configuration
        if ((0, $dh538.fg)('platform-editor-presence-websocket-only')) // https://socket.io/docs/v4/client-options/#transports
        // WebSocket first, if fails, try polling
        transports = [
            'websocket'
        ];
        socketIOOptions = (0, $1jdMD.SOCKET_IO_OPTIONS_WITH_HIGH_JITTER);
        usePMR = true;
    } else // PMR routing for edit traffic
    if ((0, $1oCLl.expValEquals)('platform_editor_to_use_pmr_for_collab_edit_none_ic', 'isEnabled', true, false)) usePMR = true;
    const extraHeaders = {
        'x-product': (0, $4frCv.getProduct)(productInfo),
        'x-subproduct': (0, $4frCv.getSubProduct)(productInfo),
        'x-client-platform': 'web'
    };
    const client = (0, $1daQW.io)(url, {
        reconnectionDelayMax: socketIOOptions.RECONNECTION_DELAY_MAX,
        reconnectionDelay: socketIOOptions.RECONNECTION_DELAY,
        randomizationFactor: socketIOOptions.RANDOMIZATION_FACTOR,
        closeOnBeforeunload: false,
        withCredentials: true,
        transports: transports,
        path: usePMR && path ? `${path}/socket.io` : `/${pathname.split('/')[1]}/socket.io`,
        auth: auth,
        extraHeaders: extraHeaders,
        query: {
            sourceId: documentAri?.split('/')[1]
        }
    });
    return client;
}
function $28639aaa801abbd1$export$a301b940c71eb349(config) {
    return new (0, $eOOPa.Provider)({
        ...config,
        createSocket: $28639aaa801abbd1$export$2326b022d5973f36
    });
}
module.exports["createSocketIOCollabProvider"] = $28639aaa801abbd1$export$a301b940c71eb349;

});

parcelRegister("1daQW", function(module, exports) {

var $k7xA3 = parcelRequire("k7xA3");


var $1bCsq = parcelRequire("1bCsq");


var $12VqB = parcelRequire("12VqB");


var $gjFYM = parcelRequire("gjFYM");

/**
 * Managers cache.
 */ const $0e1f6c82808e4270$var$cache = {};
function $0e1f6c82808e4270$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $k7xA3.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $0e1f6c82808e4270$var$cache[id] && path in $0e1f6c82808e4270$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $1bCsq.Manager)(source, opts);
    else {
        if (!$0e1f6c82808e4270$var$cache[id]) $0e1f6c82808e4270$var$cache[id] = new (0, $1bCsq.Manager)(source, opts);
        io = $0e1f6c82808e4270$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($0e1f6c82808e4270$export$841407ceb083bd74, {
    Manager: $1bCsq.Manager,
    Socket: $12VqB.Socket,
    io: $0e1f6c82808e4270$export$841407ceb083bd74,
    connect: $0e1f6c82808e4270$export$841407ceb083bd74
});
module.exports["io"] = $0e1f6c82808e4270$export$841407ceb083bd74;

});

parcelRegister("k7xA3", function(module, exports) {
parcelRequire("3nOvZ");
var $glDPj = parcelRequire("glDPj");

function $ea5e82796b5c2d27$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $glDPj.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}
module.exports["url"] = $ea5e82796b5c2d27$export$128fa18b7194ef;

});

parcelRegister("3nOvZ", function(module, exports) {
$parcel$export(module.exports, "Socket", () => (parcelRequire("iHsSr")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("8LtnI")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("glDPj")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("cDUk6")).nextTick);

var $iHsSr = parcelRequire("iHsSr");


var $cQb3o = parcelRequire("cQb3o");


var $l7SQD = parcelRequire("l7SQD");


var $8LtnI = parcelRequire("8LtnI");


var $glDPj = parcelRequire("glDPj");


var $cDUk6 = parcelRequire("cDUk6");

const $276ab44fafc54dec$export$a51d6b395ff4c65a = (0, $iHsSr.Socket).protocol;

});

parcelRegister("iHsSr", function(module, exports) {

var $l7SQD = parcelRequire("l7SQD");


var $8LtnI = parcelRequire("8LtnI");


var $7TImw = parcelRequire("7TImw");


var $glDPj = parcelRequire("glDPj");


var $1odXU = parcelRequire("1odXU");


var $j2gtm = parcelRequire("j2gtm");


var $cDUk6 = parcelRequire("cDUk6");

class $d9d2a4881db5a9d2$export$4798917dbf149b79 extends (0, $1odXU.Emitter) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $j2gtm.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $l7SQD.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $8LtnI.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $d9d2a4881db5a9d2$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $cDUk6.defaultBinaryType);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $glDPj.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $glDPj.parse)(opts.host).host;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $7TImw.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
}
$d9d2a4881db5a9d2$export$4798917dbf149b79.protocol = (0, $j2gtm.protocol);
module.exports["Socket"] = $d9d2a4881db5a9d2$export$4798917dbf149b79;

});

parcelRegister("l7SQD", function(module, exports) {

var $c68Xz = parcelRequire("c68Xz");


var $br29j = parcelRequire("br29j");


var $kVgT5 = parcelRequire("kVgT5");

const $f614cc0f77cd5157$export$46dec00755c1153b = {
    websocket: (0, $br29j.WS),
    webtransport: (0, $kVgT5.WT),
    polling: (0, $c68Xz.Polling)
};
module.exports["transports"] = $f614cc0f77cd5157$export$46dec00755c1153b;

});

parcelRegister("c68Xz", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $a9lLT = parcelRequire("a9lLT");


var $j2gtm = parcelRequire("j2gtm");


var $epKiJ = parcelRequire("epKiJ");


var $1odXU = parcelRequire("1odXU");


var $8LtnI = parcelRequire("8LtnI");


var $5Y5Gn = parcelRequire("5Y5Gn");

function $8cecfed38aaf6691$var$empty() {}
const $8cecfed38aaf6691$var$hasXHR2 = function() {
    const xhr = new (0, $epKiJ.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $8cecfed38aaf6691$export$265ee5eefd4c309b extends (0, $cQb3o.Transport) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $j2gtm.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $j2gtm.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a9lLT.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $8cecfed38aaf6691$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $8cecfed38aaf6691$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $epKiJ.createCookieJar)();
    }
}
class $8cecfed38aaf6691$export$7fa6c5b6f8193917 extends (0, $1odXU.Emitter) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $8LtnI.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $epKiJ.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $8cecfed38aaf6691$export$7fa6c5b6f8193917.requestsCount++;
            $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $8cecfed38aaf6691$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
}
$8cecfed38aaf6691$export$7fa6c5b6f8193917.requestsCount = 0;
$8cecfed38aaf6691$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $8cecfed38aaf6691$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $5Y5Gn.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $8cecfed38aaf6691$var$unloadHandler, false);
    }
}
function $8cecfed38aaf6691$var$unloadHandler() {
    for(let i in $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests)if ($8cecfed38aaf6691$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $8cecfed38aaf6691$export$7fa6c5b6f8193917.requests[i].abort();
}
module.exports["Polling"] = $8cecfed38aaf6691$export$265ee5eefd4c309b;

});

parcelRegister("cQb3o", function(module, exports) {
parcelRequire("j2gtm");
var $9RqqE = parcelRequire("9RqqE");


var $1odXU = parcelRequire("1odXU");


var $8LtnI = parcelRequire("8LtnI");


var $7TImw = parcelRequire("7TImw");

class $9592ea6a39756981$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $9592ea6a39756981$export$86495b081fef8e52 extends (0, $1odXU.Emitter) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $9592ea6a39756981$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $9RqqE.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $7TImw.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
}
module.exports["Transport"] = $9592ea6a39756981$export$86495b081fef8e52;

});

parcelRegister("j2gtm", function(module, exports) {
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("eDcVq")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("9RqqE")).decodePacket);

var $eDcVq = parcelRequire("eDcVq");


var $9RqqE = parcelRequire("9RqqE");


var $g8mBf = parcelRequire("g8mBf");

const $ddbafb4ec5d26431$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $ddbafb4ec5d26431$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $eDcVq.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($ddbafb4ec5d26431$var$SEPARATOR));
        });
    });
};
const $ddbafb4ec5d26431$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($ddbafb4ec5d26431$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $9RqqE.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $ddbafb4ec5d26431$export$a525fb718e9c623a() {
    // @ts-expect-error
    return new TransformStream({
        transform (packet, controller) {
            (0, $eDcVq.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $ddbafb4ec5d26431$var$TEXT_DECODER;
function $ddbafb4ec5d26431$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $ddbafb4ec5d26431$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $ddbafb4ec5d26431$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$ddbafb4ec5d26431$var$TEXT_DECODER) $ddbafb4ec5d26431$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    // @ts-expect-error
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 1) break;
                    const header = $ddbafb4ec5d26431$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 2) break;
                    const headerArray = $ddbafb4ec5d26431$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < 8) break;
                    const headerArray = $ddbafb4ec5d26431$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $g8mBf.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($ddbafb4ec5d26431$var$totalLength(chunks) < expectedLength) break;
                    const data = $ddbafb4ec5d26431$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $9RqqE.decodePacket)(isBinary ? data : $ddbafb4ec5d26431$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $g8mBf.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $ddbafb4ec5d26431$export$a51d6b395ff4c65a = 4;
module.exports["encodePayload"] = $ddbafb4ec5d26431$export$144d64fe58dad441;
module.exports["decodePayload"] = $ddbafb4ec5d26431$export$d10cc2e7f7566a2d;
module.exports["createPacketEncoderStream"] = $ddbafb4ec5d26431$export$a525fb718e9c623a;
module.exports["createPacketDecoderStream"] = $ddbafb4ec5d26431$export$552d20aac7500f47;
module.exports["protocol"] = $ddbafb4ec5d26431$export$a51d6b395ff4c65a;

});

parcelRegister("eDcVq", function(module, exports) {

var $g8mBf = parcelRequire("g8mBf");

const $aa6ebbe008757ebd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $aa6ebbe008757ebd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $aa6ebbe008757ebd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $aa6ebbe008757ebd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($aa6ebbe008757ebd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $aa6ebbe008757ebd$var$encodeBlobAsBase64(data, callback);
    } else if ($aa6ebbe008757ebd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $aa6ebbe008757ebd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $aa6ebbe008757ebd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $g8mBf.PACKET_TYPES)[type] + (data || ""));
};
const $aa6ebbe008757ebd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $aa6ebbe008757ebd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $aa6ebbe008757ebd$var$TEXT_ENCODER;
function $aa6ebbe008757ebd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($aa6ebbe008757ebd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($aa6ebbe008757ebd$var$toArray).then(callback);
    else if ($aa6ebbe008757ebd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $aa6ebbe008757ebd$var$isView(packet.data))) return callback($aa6ebbe008757ebd$var$toArray(packet.data));
    $aa6ebbe008757ebd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$aa6ebbe008757ebd$var$TEXT_ENCODER) $aa6ebbe008757ebd$var$TEXT_ENCODER = new TextEncoder();
        callback($aa6ebbe008757ebd$var$TEXT_ENCODER.encode(encoded));
    });
}
module.exports["encodePacket"] = $aa6ebbe008757ebd$export$57852049361a8e62;
module.exports["encodePacketToBinary"] = $aa6ebbe008757ebd$export$ec0c9b9013ee0ef5;

});

parcelRegister("g8mBf", function(module, exports) {
const $bbeeec8bf61d59e6$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$bbeeec8bf61d59e6$export$c169aefb7330cccb["open"] = "0";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["close"] = "1";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["ping"] = "2";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["pong"] = "3";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["message"] = "4";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["upgrade"] = "5";
$bbeeec8bf61d59e6$export$c169aefb7330cccb["noop"] = "6";
const $bbeeec8bf61d59e6$export$47791e8004edd485 = Object.create(null);
Object.keys($bbeeec8bf61d59e6$export$c169aefb7330cccb).forEach((key)=>{
    $bbeeec8bf61d59e6$export$47791e8004edd485[$bbeeec8bf61d59e6$export$c169aefb7330cccb[key]] = key;
});
const $bbeeec8bf61d59e6$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};
module.exports["PACKET_TYPES"] = $bbeeec8bf61d59e6$export$c169aefb7330cccb;
module.exports["PACKET_TYPES_REVERSE"] = $bbeeec8bf61d59e6$export$47791e8004edd485;
module.exports["ERROR_PACKET"] = $bbeeec8bf61d59e6$export$c718b5840781f8a7;

});

parcelRegister("9RqqE", function(module, exports) {

var $g8mBf = parcelRequire("g8mBf");


var $ky20u = parcelRequire("ky20u");

const $72dd9088c237fe2b$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $72dd9088c237fe2b$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $72dd9088c237fe2b$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $72dd9088c237fe2b$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $g8mBf.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $g8mBf.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $g8mBf.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $g8mBf.PACKET_TYPES_REVERSE)[type]
    };
};
const $72dd9088c237fe2b$var$decodeBase64Packet = (data, binaryType)=>{
    if ($72dd9088c237fe2b$var$withNativeArrayBuffer) {
        const decoded = (0, $ky20u.decode)(data);
        return $72dd9088c237fe2b$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $72dd9088c237fe2b$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};
module.exports["decodePacket"] = $72dd9088c237fe2b$export$4647901878f33f31;

});

parcelRegister("ky20u", function(module, exports) {
// imported from https://github.com/socketio/base64-arraybuffer
const $ef588a29a27a4f0c$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $ef588a29a27a4f0c$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $ef588a29a27a4f0c$var$chars.length; i++)$ef588a29a27a4f0c$var$lookup[$ef588a29a27a4f0c$var$chars.charCodeAt(i)] = i;
const $ef588a29a27a4f0c$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $ef588a29a27a4f0c$var$chars[bytes[i] >> 2];
        base64 += $ef588a29a27a4f0c$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ef588a29a27a4f0c$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ef588a29a27a4f0c$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $ef588a29a27a4f0c$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i)];
        encoded2 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $ef588a29a27a4f0c$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};
module.exports["decode"] = $ef588a29a27a4f0c$export$2f872c0f2117be69;

});

parcelRegister("1odXU", function(module, exports) {
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $1032dd8c99dcfaba$export$4293555f241ae35a(obj) {
    if (obj) return $1032dd8c99dcfaba$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $1032dd8c99dcfaba$var$mixin(obj) {
    for(var key in $1032dd8c99dcfaba$export$4293555f241ae35a.prototype)obj[key] = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.on = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.off = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeListener = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeAllListeners = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emitReserved = $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $1032dd8c99dcfaba$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};
module.exports["Emitter"] = $1032dd8c99dcfaba$export$4293555f241ae35a;

});

parcelRegister("8LtnI", function(module, exports) {

var $5Y5Gn = parcelRequire("5Y5Gn");

function $6619810c021a58f6$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $6619810c021a58f6$var$NATIVE_SET_TIMEOUT = (0, $5Y5Gn.globalThisShim).setTimeout;
const $6619810c021a58f6$var$NATIVE_CLEAR_TIMEOUT = (0, $5Y5Gn.globalThisShim).clearTimeout;
function $6619810c021a58f6$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $6619810c021a58f6$var$NATIVE_SET_TIMEOUT.bind((0, $5Y5Gn.globalThisShim));
        obj.clearTimeoutFn = $6619810c021a58f6$var$NATIVE_CLEAR_TIMEOUT.bind((0, $5Y5Gn.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $5Y5Gn.globalThisShim).setTimeout.bind((0, $5Y5Gn.globalThisShim));
        obj.clearTimeoutFn = (0, $5Y5Gn.globalThisShim).clearTimeout.bind((0, $5Y5Gn.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $6619810c021a58f6$var$BASE64_OVERHEAD = 1.33;
function $6619810c021a58f6$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $6619810c021a58f6$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $6619810c021a58f6$var$BASE64_OVERHEAD);
}
function $6619810c021a58f6$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
module.exports["pick"] = $6619810c021a58f6$export$357523c63a2253b9;
module.exports["installTimerFunctions"] = $6619810c021a58f6$export$2f67576668b97183;
module.exports["byteLength"] = $6619810c021a58f6$export$a48f0734ac7c2329;

});

parcelRegister("5Y5Gn", function(module, exports) {
const $4586f6c761acbc2b$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
module.exports["globalThisShim"] = $4586f6c761acbc2b$export$394f9358f6231289;

});

parcelRegister("7TImw", function(module, exports) {
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $5c0014e3a134c3e4$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $5c0014e3a134c3e4$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}
module.exports["encode"] = $5c0014e3a134c3e4$export$c564cdbbe6da493;
module.exports["decode"] = $5c0014e3a134c3e4$export$2f872c0f2117be69;

});

parcelRegister("a9lLT", function(module, exports) {
// imported from https://github.com/unshiftio/yeast
'use strict';
const $763ba2042e4d4eb9$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $763ba2042e4d4eb9$var$length = 64, $763ba2042e4d4eb9$var$map = {};
let $763ba2042e4d4eb9$var$seed = 0, $763ba2042e4d4eb9$var$i = 0, $763ba2042e4d4eb9$var$prev;
function $763ba2042e4d4eb9$export$c564cdbbe6da493(num) {
    let encoded = '';
    do {
        encoded = $763ba2042e4d4eb9$var$alphabet[num % $763ba2042e4d4eb9$var$length] + encoded;
        num = Math.floor(num / $763ba2042e4d4eb9$var$length);
    }while (num > 0);
    return encoded;
}
function $763ba2042e4d4eb9$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($763ba2042e4d4eb9$var$i = 0; $763ba2042e4d4eb9$var$i < str.length; $763ba2042e4d4eb9$var$i++)decoded = decoded * $763ba2042e4d4eb9$var$length + $763ba2042e4d4eb9$var$map[str.charAt($763ba2042e4d4eb9$var$i)];
    return decoded;
}
function $763ba2042e4d4eb9$export$5bb64b92cb4135a() {
    const now = $763ba2042e4d4eb9$export$c564cdbbe6da493(+new Date());
    if (now !== $763ba2042e4d4eb9$var$prev) return $763ba2042e4d4eb9$var$seed = 0, $763ba2042e4d4eb9$var$prev = now;
    return now + '.' + $763ba2042e4d4eb9$export$c564cdbbe6da493($763ba2042e4d4eb9$var$seed++);
}
//
// Map each character to its index.
//
for(; $763ba2042e4d4eb9$var$i < $763ba2042e4d4eb9$var$length; $763ba2042e4d4eb9$var$i++)$763ba2042e4d4eb9$var$map[$763ba2042e4d4eb9$var$alphabet[$763ba2042e4d4eb9$var$i]] = $763ba2042e4d4eb9$var$i;
module.exports["yeast"] = $763ba2042e4d4eb9$export$5bb64b92cb4135a;

});

parcelRegister("epKiJ", function(module, exports) {
// browser shim for xmlhttprequest module

var $e5XvD = parcelRequire("e5XvD");


var $5Y5Gn = parcelRequire("5Y5Gn");

function $a7e750ed0f96e195$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $e5XvD.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $5Y5Gn.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $a7e750ed0f96e195$export$19413efcf2fac759() {}
module.exports["XHR"] = $a7e750ed0f96e195$export$a2d42eb087c10497;
module.exports["createCookieJar"] = $a7e750ed0f96e195$export$19413efcf2fac759;

});

parcelRegister("e5XvD", function(module, exports) {
// imported from https://github.com/component/has-cors
let $a42fb1a1e9c41568$var$value = false;
try {
    $a42fb1a1e9c41568$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $a42fb1a1e9c41568$export$5235bbd4a1ef06e = $a42fb1a1e9c41568$var$value;
module.exports["hasCORS"] = $a42fb1a1e9c41568$export$5235bbd4a1ef06e;

});

parcelRegister("br29j", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $a9lLT = parcelRequire("a9lLT");


var $8LtnI = parcelRequire("8LtnI");


var $cDUk6 = parcelRequire("cDUk6");

parcelRequire("j2gtm");
var $eDcVq = parcelRequire("eDcVq");


var $iA9co = parcelRequire("iA9co");

var $8533e219b2af82c1$require$Buffer = $iA9co.Buffer;
// detect ReactNative environment
const $8533e219b2af82c1$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $8533e219b2af82c1$export$911baa0677ac404c extends (0, $cQb3o.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $8533e219b2af82c1$var$isReactNative ? {} : (0, $8LtnI.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $cDUk6.usingBrowserWebSocket) && !$8533e219b2af82c1$var$isReactNative ? protocols ? new (0, $cDUk6.WebSocket)(uri, protocols) : new (0, $cDUk6.WebSocket)(uri) : new (0, $cDUk6.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $eDcVq.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $cDUk6.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $8533e219b2af82c1$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $cDUk6.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $cDUk6.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $a9lLT.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $cDUk6.WebSocket);
    }
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
}
module.exports["WS"] = $8533e219b2af82c1$export$911baa0677ac404c;

});

parcelRegister("cDUk6", function(module, exports) {

var $5Y5Gn = parcelRequire("5Y5Gn");

const $9344d126b47ec216$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $9344d126b47ec216$export$3909fb301d3dc8c9 = (0, $5Y5Gn.globalThisShim).WebSocket || (0, $5Y5Gn.globalThisShim).MozWebSocket;
const $9344d126b47ec216$export$3407ba5dfb7a683d = true;
const $9344d126b47ec216$export$790dcbc41e2d75d5 = "arraybuffer";
module.exports["nextTick"] = $9344d126b47ec216$export$bdd553fddd433dcb;
module.exports["WebSocket"] = $9344d126b47ec216$export$3909fb301d3dc8c9;
module.exports["usingBrowserWebSocket"] = $9344d126b47ec216$export$3407ba5dfb7a683d;
module.exports["defaultBinaryType"] = $9344d126b47ec216$export$790dcbc41e2d75d5;

});

parcelRegister("kVgT5", function(module, exports) {

var $cQb3o = parcelRequire("cQb3o");


var $cDUk6 = parcelRequire("cDUk6");


var $j2gtm = parcelRequire("j2gtm");

class $f3b63b067a93fecb$export$961c930859384407 extends (0, $cQb3o.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $j2gtm.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $j2gtm.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $cDUk6.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}
module.exports["WT"] = $f3b63b067a93fecb$export$961c930859384407;

});

parcelRegister("glDPj", function(module, exports) {
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $be6d803df662636b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $be6d803df662636b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $be6d803df662636b$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $be6d803df662636b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$be6d803df662636b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $be6d803df662636b$var$pathNames(uri, uri['path']);
    uri.queryKey = $be6d803df662636b$var$queryKey(uri, uri['query']);
    return uri;
}
function $be6d803df662636b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $be6d803df662636b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}
module.exports["parse"] = $be6d803df662636b$export$98e6a39c04603d36;

});

parcelRegister("1bCsq", function(module, exports) {
parcelRequire("3nOvZ");
var $8LtnI = parcelRequire("8LtnI");
var $cDUk6 = parcelRequire("cDUk6");
var $iHsSr = parcelRequire("iHsSr");


var $12VqB = parcelRequire("12VqB");


var $gjFYM = parcelRequire("gjFYM");


var $e6joS = parcelRequire("e6joS");


var $liT4p = parcelRequire("liT4p");


var $1odXU = parcelRequire("1odXU");

class $0dd4a65fac43516f$export$d0d38e7dec7a1a61 extends (0, $1odXU.Emitter) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $iHsSr.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $e6joS.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $e6joS.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $e6joS.on)(socket, "ping", this.onping.bind(this)), (0, $e6joS.on)(socket, "data", this.ondata.bind(this)), (0, $e6joS.on)(socket, "error", this.onerror.bind(this)), (0, $e6joS.on)(socket, "close", this.onclose.bind(this)), (0, $e6joS.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $cDUk6.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $12VqB.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $8LtnI.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $liT4p.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $gjFYM;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}
module.exports["Manager"] = $0dd4a65fac43516f$export$d0d38e7dec7a1a61;

});

parcelRegister("12VqB", function(module, exports) {

var $gjFYM = parcelRequire("gjFYM");


var $e6joS = parcelRequire("e6joS");


var $1odXU = parcelRequire("1odXU");

/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $0c32865cdab9ae8e$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $0c32865cdab9ae8e$export$4798917dbf149b79 extends (0, $1odXU.Emitter) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $e6joS.on)(io, "open", this.onopen.bind(this)),
            (0, $e6joS.on)(io, "packet", this.onpacket.bind(this)),
            (0, $e6joS.on)(io, "error", this.onerror.bind(this)),
            (0, $e6joS.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($0c32865cdab9ae8e$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $gjFYM.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $gjFYM.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $gjFYM.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $gjFYM.PacketType).EVENT:
            case (0, $gjFYM.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $gjFYM.PacketType).ACK:
            case (0, $gjFYM.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $gjFYM.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $gjFYM.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $gjFYM.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $gjFYM.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}
module.exports["Socket"] = $0c32865cdab9ae8e$export$4798917dbf149b79;

});

parcelRegister("gjFYM", function(module, exports) {
$parcel$export(module.exports, "PacketType", () => $0310c1ff85201954$export$84d4095e16c6fc19);

var $1odXU = parcelRequire("1odXU");


var $fWhxz = parcelRequire("fWhxz");


var $6qMhJ = parcelRequire("6qMhJ");

/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $0310c1ff85201954$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $0310c1ff85201954$export$a51d6b395ff4c65a = 5;
var $0310c1ff85201954$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($0310c1ff85201954$export$84d4095e16c6fc19 || ($0310c1ff85201954$export$84d4095e16c6fc19 = {}));
class $0310c1ff85201954$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.EVENT || obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.ACK) {
            if ((0, $6qMhJ.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.EVENT ? $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT : $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $fWhxz.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $0310c1ff85201954$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $0310c1ff85201954$export$f9de6ca0bc043724 extends (0, $1odXU.Emitter) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $0310c1ff85201954$export$84d4095e16c6fc19.EVENT : $0310c1ff85201954$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $0310c1ff85201954$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $6qMhJ.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($0310c1ff85201954$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($0310c1ff85201954$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $0310c1ff85201954$export$84d4095e16c6fc19.CONNECT:
                return $0310c1ff85201954$var$isObject(payload);
            case $0310c1ff85201954$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $0310c1ff85201954$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $0310c1ff85201954$var$isObject(payload);
            case $0310c1ff85201954$export$84d4095e16c6fc19.EVENT:
            case $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $0310c1ff85201954$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $0310c1ff85201954$export$84d4095e16c6fc19.ACK:
            case $0310c1ff85201954$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $0310c1ff85201954$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $fWhxz.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}
module.exports["protocol"] = $0310c1ff85201954$export$a51d6b395ff4c65a;
module.exports["Encoder"] = $0310c1ff85201954$export$a50aceb0e02a00aa;
module.exports["Decoder"] = $0310c1ff85201954$export$f9de6ca0bc043724;

});

parcelRegister("fWhxz", function(module, exports) {

var $6qMhJ = parcelRequire("6qMhJ");

function $b9a9e0f6ffd208ba$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $b9a9e0f6ffd208ba$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $b9a9e0f6ffd208ba$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $6qMhJ.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $b9a9e0f6ffd208ba$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $b9a9e0f6ffd208ba$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $b9a9e0f6ffd208ba$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $b9a9e0f6ffd208ba$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $b9a9e0f6ffd208ba$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $b9a9e0f6ffd208ba$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $b9a9e0f6ffd208ba$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}
module.exports["deconstructPacket"] = $b9a9e0f6ffd208ba$export$ac2edb9eb7af56f6;
module.exports["reconstructPacket"] = $b9a9e0f6ffd208ba$export$a00da3b1ec037a04;

});

parcelRegister("6qMhJ", function(module, exports) {
const $4aeaa029a9e7e8ab$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $4aeaa029a9e7e8ab$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $4aeaa029a9e7e8ab$var$toString = Object.prototype.toString;
const $4aeaa029a9e7e8ab$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $4aeaa029a9e7e8ab$var$toString.call(Blob) === "[object BlobConstructor]";
const $4aeaa029a9e7e8ab$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $4aeaa029a9e7e8ab$var$toString.call(File) === "[object FileConstructor]";
function $4aeaa029a9e7e8ab$export$37488ff1135b1696(obj) {
    return $4aeaa029a9e7e8ab$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $4aeaa029a9e7e8ab$var$isView(obj)) || $4aeaa029a9e7e8ab$var$withNativeBlob && obj instanceof Blob || $4aeaa029a9e7e8ab$var$withNativeFile && obj instanceof File;
}
function $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($4aeaa029a9e7e8ab$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($4aeaa029a9e7e8ab$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $4aeaa029a9e7e8ab$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}
module.exports["isBinary"] = $4aeaa029a9e7e8ab$export$37488ff1135b1696;
module.exports["hasBinary"] = $4aeaa029a9e7e8ab$export$5234c529abdb5610;

});

parcelRegister("e6joS", function(module, exports) {
function $a440acb1a369a030$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}
module.exports["on"] = $a440acb1a369a030$export$af631764ddc44097;

});

parcelRegister("liT4p", function(module, exports) {
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $f825ff317086dbca$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $f825ff317086dbca$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};
module.exports["Backoff"] = $f825ff317086dbca$export$2d38012449449c89;

});

parcelRegister("eOOPa", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $hdVgM = parcelRequire("hdVgM");


var $boc9Y = parcelRequire("boc9Y");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $4frCv = parcelRequire("4frCv");


var $aX0Lv = parcelRequire("aX0Lv");


var $gVzjB = parcelRequire("gVzjB");


var $ixa9X = parcelRequire("ixa9X");


var $6Ted9 = parcelRequire("6Ted9");


var $aPvdt = parcelRequire("aPvdt");


var $84uMS = parcelRequire("84uMS");


var $bxMv2 = parcelRequire("bxMv2");


var $eSqCh = parcelRequire("eSqCh");


var $pyHw9 = parcelRequire("pyHw9");


var $8NlH6 = parcelRequire("8NlH6");


var $6MIiQ = parcelRequire("6MIiQ");


var $flwxq = parcelRequire("flwxq");


var $3LSA5 = parcelRequire("3LSA5");


var $h6NFo = parcelRequire("h6NFo");


var $9w9et = parcelRequire("9w9et");


var $b0ow0 = parcelRequire("b0ow0");

const $6136c3b5ee822bdd$var$logger = (0, $4frCv.createLogger)('Provider', 'black');
const $6136c3b5ee822bdd$var$OUT_OF_SYNC_PERIOD = 3000; // 3 seconds
const $6136c3b5ee822bdd$export$5330735bb8365155 = 15;
const $6136c3b5ee822bdd$export$5124359d21eb0335 = 2;
class $6136c3b5ee822bdd$export$2881499e37b75b9a extends (0, $hdVgM.Emitter) {
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Initialisation logic, called by Jira with a dummy getState function, deprecated in favour of the setup method which allows more configuration
   * @param {Function} getState Function that returns the editor state, used to retrieve collab-edit properties and to interact with prosemirror-collab
   * @throws {ProviderInitialisationError} Something went wrong during provider initialisation
   * @deprecated Use setup method instead
   */ initialize(getState) {
        return this.setup({
            getState: getState
        });
    }
    /**
   * Initialisation logic, called by the editor in the collab-edit plugin.
   *
   * @param {Function} options.getState Function that returns the editor state, used to retrieve collab-edit properties and to interact with prosemirror-collab
   * @param options.editorApi
   * @param {SyncUpErrorFunction} options.onSyncUpError (Optional) Function that gets called when the sync of steps fails after retrying 30 times, used by Editor to log to analytics
   * @throws {ProviderInitialisationError} Something went wrong during provider initialisation
   */ setup({ getState: getState, editorApi: _editorApi, onSyncUpError: // eslint says unused vars should start with _
    onSyncUpError }) {
        this.checkForCookies();
        try {
            if (!getState) throw new (0, $ixa9X.ProviderInitialisationError)('Collab provider attempted to initialise, but getState is required');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const collabPlugin = getState().plugins.find((p)=>p.key === 'collab$');
            if (collabPlugin === undefined) throw new (0, $ixa9X.ProviderInitialisationError)('Collab provider attempted to initialise, but Editor state is missing collab plugin');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.clientId = collabPlugin.spec.config.clientID;
            // generate a temporary id as clientId when it is undefined
            // prefix temp-cp- indicates collab-provider
            if (!this.clientId) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            this.clientId = `temp-cp-${(0, $dQl1W.v4)()}`;
            this.documentService.setup({
                getState: getState,
                onSyncUpError: onSyncUpError,
                clientId: this.clientId
            });
            if (this.isBufferingEnabled && this.initialDraft && !this.isProviderInitialized) {
                const { document: document, version: version, metadata: metadata } = this.initialDraft;
                this.updateDocumentAndMetadata({
                    doc: document,
                    version: version,
                    metadata: metadata,
                    caller: 'Provider.setup'
                });
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).PROVIDER_INITIALIZED, (0, $flwxq.EVENT_STATUS).INFO, {
                    isBuffered: true
                });
            }
            if (!this.isChannelInitialized) {
                this.initializeChannel();
                this.isChannelInitialized = true;
            }
        } catch (initError) {
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider');
            // Throw error so consumers are aware the initialisation failed when initialising themselves
            throw new (0, $ixa9X.ProviderInitialisationError)('Provider initialisation error', initError);
        }
        return this;
    }
    // Only used for the presence - opts out of the document service and api service
    setupForPresenceOnly(clientId) {
        this.clientId = clientId;
        this.checkForCookies();
        try {
            if (!this.isChannelInitialized) {
                this.initializeChannel();
                this.isChannelInitialized = true;
            }
        } catch (initError) {
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider');
            // Throw error so consumers are aware the initialisation failed when initialising themselves
            throw new (0, $ixa9X.ProviderInitialisationError)('Provider initialisation error', initError);
        }
        return this;
    }
    checkForCookies() {
        if (!$parcel$global.navigator.cookieEnabled) {
            const initError = new (0, $ixa9X.ProviderInitialisationError)('Cookies are not enabled. Please enable cookies to use collaborative editing.');
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider - cookies disabled');
            throw new (0, $ixa9X.ProviderInitialisationError)('Provider initialisation error - cookies disabled', initError);
        }
    }
    /**
   * Send steps from transaction to NCS (and as a consequence to other participants), called from the collab-edit plugin in the editor
   * @param {Transaction} _tr Deprecated, included to keep API consistent with Synchrony provider
   * @param {EditorState} _oldState Deprecated, included to keep API consistent with Synchrony provider
   * @param {EditorState} newState The editor state after applying the transaction
   * @throws {SendTransactionError} Something went wrong while sending the steps for this transaction
   */ send(_tr, _oldState, newState) {
        try {
            if (this.isViewOnly()) {
                const error = {
                    message: 'Attempted to send steps in view only mode',
                    data: {
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).VIEW_ONLY_STEPS_ERROR
                    }
                };
                (0, $4frCv.logObfuscatedSteps)(_oldState, newState).then((attributes)=>{
                    const stepAttributes = attributes instanceof (0, $ixa9X.CustomError) ? {} : {
                        ...attributes
                    };
                    const stepsError = new (0, $ixa9X.CustomError)(error.message, error, {
                        ...stepAttributes
                    });
                    this.analyticsHelper?.sendErrorEvent(stepsError, stepsError.message);
                }).catch((err)=>this.analyticsHelper?.sendErrorEvent(err, err.message));
                return;
            }
            // Don't send steps while the document is locked (eg. when restoring the document)
            if (this.namespaceService.getIsNamespaceLocked()) {
                $6136c3b5ee822bdd$var$logger('The document is temporary locked');
                return;
            }
            this.documentService.send(_tr, _oldState, newState);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while sending steps for a transaction');
            throw new (0, $ixa9X.SendTransactionError)('Error while sending steps for a transaction', error);
        }
    }
    isViewOnly() {
        return this.permit && // isPermittedToEdit or isPermittedToView can be undefined, must use `===` here.
        this.permit.isPermittedToEdit === false && this.permit.isPermittedToView === true;
    }
    /**
   * Send messages, such as telepointers,  and AI provider changes to NCS and other participants.
   * Only used for telepointer data (text and node selections) in the editor and JWM.
   * JWM does some weird serialisation stuff on the node selections.
   * Silently fails if an error occurs, since Presence isn't a critical functionality and self-restores over time.
   *
   * @param {CollabTelepointerPayload} data Data you want to send to NCS / the other participants
   * @param {string} data.type Can only be 'telepointer' for now, we don't support anything else yet
   * @param {CollabSendableSelection} data.selection Object representing the selected element
   * @param {string} data.sessionId Identifier identifying the session
   */ sendMessage(data) {
        const basePayload = {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            userId: this.userId,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            sessionId: this.sessionId,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            clientId: this.clientId,
            permit: this.permit
        };
        try {
            if (data?.type === 'telepointer') this.channel.broadcast('participant:telepointer', {
                ...basePayload,
                selection: data.selection
            }, (0, $h6NFo.shouldTelepointerBeSampled)() ? (0, $gVzjB.telepointerCallback)(this.config.documentAri) : undefined);
            else if (data?.type === 'ai-provider:change') this.participantsService.sendAIProviderChanged({
                ...basePayload,
                ...data
            });
            else if (data?.type === 'participant:activity') {
                this.setPresenceActivity(data.activity);
                this.participantsService.sendPresenceActivityChanged();
            }
        } catch (error) {
            // We don't want to throw errors for Presence features as they tend to self-restore
            this.analyticsHelper?.sendErrorEvent(error, 'Error while sending message - telepointer');
        }
    }
    setAIProviderActiveIds(ids = []) {
        this.aiProviderActiveIds = ids;
    }
    /**
   * "Destroy" the provider, disconnect it's connection to the back-end service and unsubscribe all event listeners on the provider.
   * Used by Jira products (JWM, JPD) to disable the provider
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ destroy() {
        return this.unsubscribeAll();
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Disconnect the provider, disconnect it's connection to the back-end service and unsubscribe all event listeners on the provider.
   * Used by Confluence to disable the provider when a user doesn't have access to a resource.
   * @deprecated use destroy instead, it does the same thing
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ disconnect() {
        return this.unsubscribeAll();
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Disconnect the provider's connection to the back-end service and unsubscribe from all events emitted by this provider. Kept to keep roughly aligned to Synchrony API, which you need to call for each event.
   * @deprecated use destroy instead, it does the same thing
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ unsubscribeAll() {
        try {
            super.unsubscribeAll();
            this.channel.disconnect();
            if (this.sendStepsTimer) {
                clearInterval(this.sendStepsTimer);
                this.sendStepsTimer = undefined;
            }
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while shutting down the collab provider');
            throw new (0, $ixa9X.DestroyError)('Error while shutting down the collab provider', error);
        }
        this.clearTimers();
        return this;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Update the title of the document in the collab provider and optionally broadcast it to other participants and NCS
   * @deprecated use setMetadata instead, it does the same thing
   * @param {string} title Title you want to set on the document
   * @param {boolean} broadcast (Optional) Flag indicating whether you want to broadcast the title change to the other participants, always true for now (otherwise we would lose title changes)
   * @throws {SetTitleError} Something went wrong while setting the title
   */ setTitle(title, broadcast) {
        try {
            if (this.isViewOnly()) return;
            this.metadataService.setTitle(title, broadcast);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting title');
            throw new (0, $ixa9X.SetTitleError)('Error while setting title', error);
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Set editor width, not used any more
   * @deprecated use setMetadata instead, it does the same thing
   * @param {string} editorWidth string? indicating the editor width
   * @param {boolean} broadcast (Optional) Flag indicating whether you want to broadcast the editor width change
   * @throws {SetEditorWidthError} Something went wrong while setting the editor width
   */ setEditorWidth(editorWidth, broadcast) {
        try {
            this.metadataService.setEditorWidth(editorWidth, broadcast);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting editor width');
            throw new (0, $ixa9X.SetEditorWidthError)('Error while setting editor width', error);
        }
    }
    /**
   * Set the editor width and title and distribute it to all participants. Used by Confluence
   * @param {Metadata} metadata The metadata you want to update
   * @throws {ExampleError} Something went wrong while setting the metadata
   */ setMetadata(metadata) {
        try {
            if (this.isViewOnly()) return;
            this.metadataService.setMetadata(metadata);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting metadata');
            // Don't re-throw for transient connectivity/initialization errors.
            // (e.g. socket not yet ready, user momentarily offline)
            if ((error instanceof (0, $ixa9X.NotInitializedError) || error instanceof (0, $ixa9X.NotConnectedError)) && (0, $1oCLl.expValEquals)('platform_editor_ignore_metadata_connection_errors', 'isEnabled', true)) return;
            throw new (0, $ixa9X.SetMetadataError)('Error while setting metadata', error);
        }
    }
    /**
   * Returns the namespace locking status via true/false
   */ getIsNamespaceLocked() {
        return this.namespaceService.getIsNamespaceLocked();
    }
    constructor(config){
        super();
        this.api = void 0;
        this.channel = void 0;
        this.config = void 0;
        this.analyticsHelper = void 0;
        this.isChannelInitialized = false;
        this.initialDraft = void 0;
        this.isProviderInitialized = false;
        this.isBuffered = false;
        // User permit is used to determine if the user is allowed to view, comment or edit the document
        // Therefore, the initial value is false for all three
        this.permit = {
            isPermittedToView: false,
            isPermittedToComment: false,
            isPermittedToEdit: false
        };
        // isBufferingEnabled is a boolean value passed to the config during provider creation.
        // It determines if the provider should initialize immediately and will only be true if:
        // the feature flag is enabled and the initial draft fetched from NCS is also passed in the config.
        this.isBufferingEnabled = false;
        // SessionID is the unique socket-session.
        this.sessionId = void 0;
        // ClientID is the unique ID for a prosemirror client. Used for step-rebasing.
        this.clientId = void 0;
        // UserID is the users actual account id.
        this.userId = void 0;
        // PresenceId is used to correlate to independent websocket connections together (presence and editor)
        this.presenceId = void 0;
        // PresenceActivity is used to determine if the user is a viewer or editor, only used in the presence connection
        this.presenceActivity = void 0;
        this.presenceUpdateTimeout = void 0;
        this.disconnectedAt = void 0;
        this.sendStepsTimer = void 0;
        this.participantsService = void 0;
        this.metadataService = void 0;
        this.documentService = void 0;
        this.namespaceService = void 0;
        // Local IDs of active AI Providers
        this.aiProviderActiveIds = [];
        /**
     * Wrapper for this.emit, it binds scope for callbacks and waits for initialising of the editor before emitting events.
     * Waiting for the collab provider to become connected to the editor ensures the editor doesn't miss any events.
     * @param evt - Event name to emit to subscribers
     * @param data - Event data to emit to subscribers
     */ // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.emitCallback = (evt, data)=>this.emit(evt, data);
        /**
     * Wrapper to update document and metadata.
     * Catches and logs any errors thrown by document service's updateDocument and updateMetadata methods and destroys the provider in case of errors.
     * Passing the document, metadata, version (either from the initial draft or from collab service)
     */ this.updateDocumentAndMetadata = ({ doc: doc, version: version, metadata: metadata, caller: caller })=>{
            try {
                this.documentService.updateDocument({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    caller: caller
                });
                this.metadataService.updateMetadata(metadata);
                this.isProviderInitialized = true;
            } catch (e) {
                this.analyticsHelper?.sendErrorEvent(e, 'Failed to update with the init document, destroying provider');
                // Stop events and connections to step us trying to talk to the backend with an invalid state.
                this.destroy();
            }
        };
        this.initializeChannel = ()=>{
            this.emit('connecting', {
                initial: true
            });
            // shouldSkipDocumentInit will bypass the NCS draft fetch if the initial draft is passed to the provider
            const shouldSkipDocumentInit = Boolean(this.initialDraft);
            this.channel.on('connected', ({ sid: sid, initialized: initialized })=>{
                this.sessionId = sid;
                this.emit('connected', {
                    sid: sid,
                    initial: !initialized
                });
                const unconfirmedStepsLength = this.documentService.getUnconfirmedSteps()?.length;
                // if buffering is enabled and the provider is initialized before connection,
                // send any unconfirmed steps
                if (this.isBufferingEnabled && this.isProviderInitialized && !this.isBuffered) {
                    this.isBuffered = true; // setting buffering to true so that the sending of unconfirmed steps happens only on first connection
                    this.documentService.sendStepsFromCurrentState(true);
                }
                // Early initialization with initial draft passed via provider
                if (this.initialDraft && initialized && !this.isProviderInitialized) {
                    const { document: document, version: version, metadata: metadata } = this.initialDraft;
                    this.updateDocumentAndMetadata({
                        doc: document,
                        version: version,
                        metadata: metadata,
                        caller: 'connectedHandler'
                    });
                }
                // If already initialized, `connected` means reconnected
                const shouldBypassOutOfSyncGracePeriod = (0, $1oCLl.expValEquals)('collab_bypass_out_of_sync_period_experiment', 'isEnabled', true, false);
                if (initialized && this.disconnectedAt && // Offline longer than `OUT_OF_SYNC_PERIOD`
                (shouldBypassOutOfSyncGracePeriod || Date.now() - this.disconnectedAt >= $6136c3b5ee822bdd$var$OUT_OF_SYNC_PERIOD)) this.documentService.throttledCatchupv2((0, $flwxq.CatchupEventReason).RECONNECTED, {
                    disconnectionPeriodSeconds: Math.floor((Date.now() - this.disconnectedAt) / 1000),
                    offlineStepsLength: (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $b0ow0.getOfflineStepsLength)(this.documentService.getUnconfirmedSteps(), this.documentService.getUnconfirmedStepsOrigins()) : undefined,
                    offlineReplaceStepsLength: (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $b0ow0.getOfflineReplaceStepsLength)(this.documentService.getUnconfirmedSteps(), this.documentService.getUnconfirmedStepsOrigins()) : undefined,
                    unconfirmedStepsLength: unconfirmedStepsLength
                }, this.sessionId);
                else if ((0, $1oCLl.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true)) {
                    // Conditionally run catchup based on CollabDraftMetadata.relevance
                    // Only catch up when relevance is 'STALE' or absent
                    // Skip catchup when relevance is 'LATEST' (draft is up-to-date)
                    const relevance = this.initialDraft?.metadata?.relevance;
                    if (relevance === 'STALE' || relevance === undefined) this.documentService.throttledCatchupv2((0, $flwxq.CatchupEventReason).PROCESS_STEPS);
                }
                this.participantsService.startInactiveRemover(this.sessionId);
                if (this.config.batchProps) {
                    if (this.config.getUser) throw new (0, $ixa9X.ProviderInitialisationError)('Cannot supply getUser and batchProps together');
                    this.participantsService.initializeFirstBatchFetchUsers();
                }
                this.disconnectedAt = undefined;
            }).on('init', ({ doc: doc, version: version, metadata: metadata })=>{
                // Initial document and version
                this.updateDocumentAndMetadata({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    caller: 'initHandler'
                });
            }).on('restore', this.documentService.onRestore).on('permission', (permit)=>{
                this.permit = Object.assign(this.permit, permit);
                this.emit('permission', permit);
            }).on('steps:added', this.documentService.onStepsAdded).on('metadata:changed', this.metadataService.onMetadataChanged).on('participant:telepointer', (payload)=>this.participantsService.onParticipantTelepointer(payload, this.sessionId)).on('presence:joined', this.participantsService.onPresenceJoined).on('presence', this.participantsService.onPresence).on('participant:left', this.participantsService.onParticipantLeft).on('participant:updated', this.participantsService.onParticipantUpdated).on('disconnect', this.onDisconnected.bind(this)).on('error', this.onErrorHandled).on('status', async (status)=>{
                await this.namespaceService.onNamespaceStatusChanged(status);
                const isLocked = this.namespaceService.getIsNamespaceLocked();
                this.emit('namespace-lock:check', {
                    isLocked: isLocked
                });
            }).connect(shouldSkipDocumentInit);
        };
        this.setUserId = (id)=>{
            this.userId = id;
        };
        this.getPresenceData = ()=>{
            return {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                sessionId: this.sessionId,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                userId: this.userId,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                clientId: this.clientId,
                permit: this.permit,
                presenceId: this.presenceId,
                presenceActivity: this.presenceActivity
            };
        };
        this.setPresenceActivity = (activity)=>{
            this.presenceActivity = activity;
        };
        /**
     * @param {InternalError} error The error to handle
     */ this.onErrorHandled = (error)=>{
            // User tried committing steps but they were rejected because:
            // HEAD_VERSION_UPDATE_FAILED: the collab service's latest stored step tail version didn't correspond to the head version of the first step submitted
            // VERSION_NUMBER_ALREADY_EXISTS: while storing the steps there was a conflict meaning someone else wrote steps into the database more quickly
            if (error.data?.code === (0, $6Ted9.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED || error.data?.code === (0, $6Ted9.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS) this.documentService.onStepRejectedError();
            else {
                this.analyticsHelper?.sendErrorEvent(error, error.message);
                const mappedError = (0, $8NlH6.errorCodeMapper)(error);
                // Only emit errors to Confluence very intentionally because they will disconnect the collab provider
                if (mappedError) {
                    this.analyticsHelper?.sendProviderErrorEvent(mappedError);
                    this.emit('error', mappedError);
                }
            }
        };
        this.getAIProviderActiveIds = ()=>{
            return this.aiProviderActiveIds;
        };
        // Note: this gets triggered on page reload for Firefox (not other browsers) because of closeOnBeforeunload: false
        this.onDisconnected = ({ reason: reason })=>{
            this.disconnectedAt = Date.now();
            this.participantsService.disconnect(reason, this.sessionId);
        };
        /**
     * Returns the documents metadata
     */ this.getMetadata = ()=>{
            return this.metadataService.getMetaData();
        };
        /**
     * Return the ADF version of the current draft document, together with it's title and the current step version.
     * Used for draft sync, a process running every 5s for the first editor of a document to sync the document to the Confluence back-end.
     * @throws {GetCurrentStateError} Something went wrong while returning the current state
     */ this.getCurrentState = async ()=>{
            try {
                return await this.documentService.getCurrentState();
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of current draft document');
                throw new (0, $ixa9X.GetCurrentStateError)('Error while returning the current state of the draft document', error); // Reject the promise so the consumer can react to it failing
            }
        };
        /**
     * Return the final acknowledged (by NCS) ADF version of the current draft document, together with it's title and the current step version.
     * Used when returning the document to Confluence on publish.
     * @throws {GetFinalAcknowledgedStateError} Something went wrong while returning the acknowledged state
     */ this.getFinalAcknowledgedState = async (reason)=>{
            try {
                return await this.documentService.getFinalAcknowledgedState(reason);
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of the final draft document');
                throw new (0, $ixa9X.GetFinalAcknowledgedStateError)('Error while returning the final acknowledged state of the draft document', error); // Reject the promise so the consumer can react to it failing
            }
        };
        this.getUnconfirmedSteps = ()=>{
            return this.documentService.getUnconfirmedSteps();
        };
        /**
     * Provides a synchronous method to retreive the version from the Document Service / Editor State
     *
     * @returns {number} Returns the current ProseMirror version from the Editor State
     */ this.getCurrentPmVersion = ()=>{
            return this.documentService.getCurrentPmVersion();
        };
        /**
     * Used when the provider is disconnected or destroyed to prevent perpetual timers from continuously running
     */ this.clearTimers = ()=>{
            clearTimeout(this.presenceUpdateTimeout);
            this.participantsService.clearTimers();
        };
        this.getParticipants = ()=>{
            return this.participantsService.getParticipants();
        };
        this.getUniqueParticipantSize = ()=>{
            return this.participantsService.getUniqueParticipantSize();
        };
        this.getUniqueParticipants = ()=>{
            return this.participantsService.getUniqueParticipants({
                isHydrated: false
            });
        };
        this.getUniqueHydratedParticipants = ()=>{
            return this.participantsService.getUniqueParticipants({
                isHydrated: true
            });
        };
        this.getAIProviderParticipants = ()=>{
            return this.participantsService.getAIProviderParticipants();
        };
        this.fetchMore = async (props)=>{
            if (this.config.batchProps) await this.participantsService.enrichParticipants({
                ...this.config.batchProps,
                batchSize: props?.fetchSize ?? this.config.batchProps.batchSize
            });
            else throw new Error('Must provide batch properties to use fetchMore');
        };
        this.getSessionId = ()=>{
            return this.sessionId;
        };
        this.getDocumentAri = ()=>{
            return this.config.documentAri;
        };
        this.config = config;
        this.analyticsHelper = new (0, $aX0Lv.default)(this.config.documentAri, this.config.productInfo?.subProduct, this.config.analyticsClient, this.config.getAnalyticsWebClient);
        this.channel = new (0, $boc9Y.Channel)(config, this.analyticsHelper);
        this.isChannelInitialized = false;
        this.initialDraft = this.config.initialDraft;
        this.isBufferingEnabled = Boolean(this.config.isBufferingEnabled);
        this.isProviderInitialized = false;
        this.participantsService = new (0, $pyHw9.ParticipantsService)(this.analyticsHelper, undefined, this.emitCallback, this.config.getUser, this.config.batchProps, this.channel.broadcast, this.channel.sendPresenceJoined, this.getPresenceData, this.setUserId, this.getAIProviderActiveIds, this.config.fetchAnonymousAsset);
        this.metadataService = new (0, $aPvdt.MetadataService)(this.emitCallback, this.channel.sendMetadata);
        this.namespaceService = new (0, $eSqCh.NamespaceService)();
        this.presenceId = this.config.presenceId;
        this.presenceActivity = this.config.presenceActivity;
        if (config.isPresenceOnly) {
            // this check is specifically for the presence only
            // This presence feature is only for the confluence view page & jira presence which do not need the document service or api
            this.documentService = new (0, $bxMv2.NullDocumentService)();
            this.api = new (0, $9w9et.NullApi)();
        } else {
            this.documentService = new (0, $84uMS.DocumentService)(this.participantsService, this.analyticsHelper, this.channel.fetchCatchupv2, this.channel.fetchReconcile, this.channel.fetchGeneratedDiffSteps, this.emitCallback, this.channel.broadcast, ()=>this.userId, this.onErrorHandled, this.metadataService, this.namespaceService.getIsNamespaceLocked.bind(this.namespaceService), this.config.enableErrorOnFailedDocumentApply, {
                __livePage: this.config.__livePage || false
            }, this.channel.getConnected);
            this.api = new (0, $3LSA5.Api)(config, this.documentService, this.channel);
        }
        this.sendStepsTimer = setInterval(()=>{
            $6136c3b5ee822bdd$var$logger('Intervally sendStepsFromCurrentState');
            this.documentService.sendStepsFromCurrentState(true, undefined);
        }, 5000);
    }
}
module.exports["MAX_STEP_REJECTED_ERROR"] = $6136c3b5ee822bdd$export$5330735bb8365155;
module.exports["MAX_STEP_REJECTED_ERROR_AGGRESSIVE"] = $6136c3b5ee822bdd$export$5124359d21eb0335;
module.exports["Provider"] = $6136c3b5ee822bdd$export$2881499e37b75b9a;

});

parcelRegister("hdVgM", function(module, exports) {

var $majy4 = parcelRequire("majy4");

class $74d79b69f01a47f7$export$4293555f241ae35a {
    /**
   * Emit events to subscribers
   */ emit(evt, data) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.emit(evt, data);
        return this;
    }
    /**
   * Subscribe to events emitted by this provider
   */ on(evt, handler) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.on(evt, handler);
        return this;
    }
    /**
   * Unsubscribe from events emitted by this provider
   */ off(evt, handler) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.off(evt, handler);
        return this;
    }
    /**
   * Unsubscribe from all events emitted by this provider.
   */ unsubscribeAll(evt) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.removeAllListeners(evt);
        return this;
    }
    constructor(){
        this.eventEmitter = new (0, $majy4.EventEmitter2)();
    }
}
module.exports["Emitter"] = $74d79b69f01a47f7$export$4293555f241ae35a;

});

parcelRegister("boc9Y", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $hdVgM = parcelRequire("hdVgM");


var $4frCv = parcelRequire("4frCv");


var $h6NFo = parcelRequire("h6NFo");


var $flwxq = parcelRequire("flwxq");


var $5TBlQ = parcelRequire("5TBlQ");


var $a5At1 = parcelRequire("a5At1");


var $7W8Hz = parcelRequire("7W8Hz");


var $a0Jyl = parcelRequire("a0Jyl");


var $6MIiQ = parcelRequire("6MIiQ");


var $6Ted9 = parcelRequire("6Ted9");


var $ixa9X = parcelRequire("ixa9X");


var $fFa3V = parcelRequire("fFa3V");

const $2c3ccd3818e40940$var$logger = (0, $4frCv.createLogger)('Channel', 'green');
class $2c3ccd3818e40940$export$cfdacaa37f9b4dd7 extends (0, $hdVgM.Emitter) {
    /**
   * Connect to collab service using websockets
   */ connect(shouldInitialize = false) {
        (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
        // If provider already has access to the initial draft, explicitly set channel as initialized
        // to bypass BE doc retrieval
        if (shouldInitialize) this.initialized = true;
        if (!this.initialized) {
            (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).DOCUMENT_INIT, this.analyticsHelper);
            this.initExperience?.start();
        }
        const { documentAri: documentAri, url: url, path: path, createSocket: createSocket, permissionTokenRefresh: permissionTokenRefresh } = this.config;
        let auth;
        if (permissionTokenRefresh) auth = async (cb)=>{
            // Rebuild authData to ensure values are current
            const authData = {
                // The initialized status. If false, BE will send document, otherwise not.
                initialized: this.initialized,
                // ESS-1009 Allow to opt-in into 404 response
                need404: this.config.need404
            };
            try {
                const token = await permissionTokenRefresh();
                if (token) authData.token = token;
                else authData.token = undefined;
                cb(authData);
            } catch (error) {
                // Pass the error back to the consumers so they can deal with exceptional cases themselves (eg. no permissions because the page was deleted)
                const authenticationError = {
                    message: 'Insufficient editing permissions',
                    data: {
                        status: 403,
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).TOKEN_PERMISSION_ERROR,
                        meta: {
                            originalError: error,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            reason: error?.data?.meta?.reason // Should always be 'RESOURCE_DELETED' Temporary, until Confluence Cloud removes their hack
                        }
                    }
                };
                this.emit('error', authenticationError);
            }
        };
        else // Ignored via go/ees005
        // eslint-disable-next-line require-await
        auth = async (cb)=>{
            // Rebuild authData to ensure values are current
            const authData = {
                // The initialized status. If false, BE will send document, otherwise not.
                initialized: this.initialized,
                // ESS-1009 Allow to opt-in into 404 response
                need404: this.config.need404
            };
            cb(authData);
        };
        this.socket = createSocket(`${url}/session/${documentAri}`, auth, this.config.productInfo, this.config.isPresenceOnly, this.analyticsHelper, path, documentAri);
        // Due to https://github.com/socketio/socket.io-client/issues/1473,
        // reconnect no longer fired on the socket.
        // We should use `connect` for better cross platform compatibility(Mobile/Web).
        this.socket.on('connect', this.onConnect);
        this.socket.on('data', this.onReceiveData);
        this.socket.on('permission', (permit)=>{
            this.emit('permission', permit);
        });
        this.socket.on('steps:added', (data)=>{
            this.emit('steps:added', data);
        });
        this.socket.on('participant:telepointer', ({ timestamp: timestamp, data: data })=>{
            // data is TelepointerPayload without timestamp
            this.emit('participant:telepointer', {
                timestamp: timestamp,
                ...data
            });
        });
        this.socket.on('presence:joined', (data)=>{
            this.emit('presence:joined', data);
        });
        this.socket.on('presence', (data)=>{
            this.emit('presence', data);
        });
        this.socket.on('participant:left', (data)=>{
            this.emit('participant:left', data);
        });
        this.socket.on('participant:updated', ({ sessionId: sessionId, timestamp: timestamp, data: data, clientId: clientId })=>{
            this.emit('participant:updated', {
                sessionId: sessionId,
                timestamp: timestamp,
                clientId: clientId,
                ...data
            });
        });
        this.socket.on('metadata:changed', (payload)=>{
            this.emit('metadata:changed', payload);
        });
        // ESS-2916 namespace status event - lock/unlock
        this.socket.on('status', (data)=>{
            this.emit('status', data);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.socket.on('disconnect', async (reason)=>{
            this.connected = false;
            $2c3ccd3818e40940$var$logger(`disconnect reason: ${reason}`);
            this.emit('disconnect', {
                reason: reason
            });
            if (reason === (0, $7W8Hz.socketIOReasons).IO_SERVER_DISCONNECT && this.socket) // The disconnection was initiated by the server, we need to reconnect manually.
            try {
                this.socket.connect();
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while reconnecting the channel');
                const reconnectionError = {
                    message: 'Caught error during reconnection',
                    data: {
                        status: 500,
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).RECONNECTION_ERROR
                    }
                };
                this.emit('error', reconnectionError);
            }
        });
        // Socket error, including errors from `packetMiddleware`, `controllers` and `onconnect` and more. Parameter is a plain JSON object.
        this.socket.on('error', (socketError)=>{
            this.emit('error', socketError);
        });
        // `connect_error`'s parameter type is `Error`.
        // Ensure the error emit to the provider has the same structure, so we can handle them unified.
        this.socket.on('connect_error', this.onConnectError);
        this.socket.on('permission:invalidateToken', this.handlePermissionInvalidateToken);
        this.socket.onAnyOutgoing((_, ...args)=>this.onAnyOutgoingHandler(Date.now(), args));
        // To trigger reconnection when browser comes back online
        if (!this.network) this.network = new (0, $a0Jyl.default)({
            onlineCallback: this.onOnlineHandler
        });
        // Helper class to track reconnection issues, to emit an error if too many failed reconnection attempts happen
        this.reconnectHelper = new (0, $5TBlQ.default)();
        // Fired upon a reconnection attempt error (from Socket.IO Manager)
        this.socket.io.on('reconnect_error', this.onReconnectError);
        // Automatic disconnect on tab background with delay, to keep presence UX accurate
        // and reduce wasted connections. Reconnects upon tab becoming active again
        this.addVisiblityListener();
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onAnyOutgoingHandler(currentTimeMs, args) {
        const rateLimitType = this.config.rateLimitType || this.RATE_LIMIT_TYPE_NONE;
        if (rateLimitType === this.RATE_LIMIT_TYPE_NONE) return;
        const stepLimit = this.config.rateLimitStepCount || 0;
        const stepSizeLimit = this.config.rateLimitTotalStepSize || 0;
        const maxStepSizeLimit = this.config.rateLimitMaxStepSize || 0;
        for (const arg of args)if (arg.type === 'steps:commit') {
            if (currentTimeMs - this.rateLimitWindowStartMs > this.rateLimitWindowDurationMs) {
                // Start a new window
                this.rateLimitWindowStartMs = currentTimeMs;
                this.stepCounter = 0;
                this.stepSizeCounter = 0;
                this.maxStepSize = 0;
            }
            this.stepCounter += arg.steps.length;
            for (const step of arg.steps){
                const stepSize = JSON.stringify(step).length;
                this.stepSizeCounter += stepSize;
                if (stepSize > this.maxStepSize) this.maxStepSize = stepSize;
            }
            if (this.isLimitExceeded(stepLimit, stepSizeLimit, maxStepSizeLimit)) {
                const rateLimitError = {
                    message: 'Rate limited',
                    data: {
                        code: (0, $6Ted9.NCS_ERROR_CODE).RATE_LIMIT_ERROR,
                        status: 500,
                        meta: {
                            rateLimitType: rateLimitType,
                            maxStepSize: this.maxStepSize,
                            stepSizeCounter: this.stepSizeCounter,
                            stepCounter: this.stepCounter
                        }
                    }
                };
                if (rateLimitType === this.RATE_LIMIT_TYPE_HARD) {
                    this.emit('error', rateLimitError);
                    throw new Error();
                } else if (rateLimitType === this.RATE_LIMIT_TYPE_SOFT) this.analyticsHelper?.sendErrorEvent(rateLimitError, 'Rate limited');
            }
        }
    }
    async commonHeaders() {
        return {
            ...this.config.permissionTokenRefresh ? {
                'x-token': await this.getChannelToken()
            } : {},
            'x-product': (0, $4frCv.getProduct)(this.config.productInfo),
            'x-subproduct': (0, $4frCv.getSubProduct)(this.config.productInfo)
        };
    }
    isLimitExceeded(stepLimit, stepSizeLimit, maxStepSizeLimit) {
        return stepLimit > 0 && this.stepCounter > stepLimit || stepSizeLimit > 0 && this.stepSizeCounter > stepSizeLimit || maxStepSizeLimit > 0 && this.maxStepSize > maxStepSizeLimit;
    }
    /**
   * Adds an event listener for visibilitychange events to automatically close the socket
   * connection  if tab is in background for longer than disconnectDelay
   */ addVisiblityListener() {
        const disconnectDelay = 60;
        if (this.config.isPresenceOnly) this.unbindVisibilityListener = (0, $fFa3V.bind)(document, {
            type: 'visibilitychange',
            listener: ()=>{
                this.disconnectTimer = this.autoDisconnect(this.disconnectTimer, disconnectDelay);
            }
        });
    }
    disconnect() {
        this.unsubscribeAll();
        this.cleanupAutoDisconnect();
        this.network?.destroy();
        this.network = null;
        if (this.socket) {
            this.socket.close();
            this.socket = null;
            this.reconnectHelper?.destroy();
        }
    }
    constructor(config, analyticsHelper){
        super();
        this.RATE_LIMIT_TYPE_NONE = 0;
        this.RATE_LIMIT_TYPE_SOFT = 1;
        this.RATE_LIMIT_TYPE_HARD = 2;
        this.connected = false;
        this.config = void 0;
        this.socket = null;
        this.reconnectHelper = null;
        this.initialized = false;
        this.analyticsHelper = void 0;
        this.initExperience = void 0;
        this.token = void 0;
        this.network = null;
        this.disconnectTimer = void 0;
        this.rateLimitWindowDurationMs = 60000;
        this.rateLimitWindowStartMs = 0;
        this.stepCounter = 0;
        this.stepSizeCounter = 0;
        this.maxStepSize = 0;
        // read-only getters used for tests
        this.getInitialized = ()=>this.initialized;
        this.getConnected = ()=>this.connected;
        this.getSocket = ()=>this.socket;
        this.getToken = ()=>this.token;
        // Used to retrieve the x-token for API requests
        this.getChannelToken = async ()=>{
            if (this.token) return this.token;
            if (!this.config.permissionTokenRefresh) return undefined;
            const token = await this.config.permissionTokenRefresh() ?? undefined;
            return token;
        };
        this.handlePermissionInvalidateToken = (data)=>{
            $2c3ccd3818e40940$var$logger('Received permission invalidate event ', data);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).INVALIDATE_TOKEN, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                reason: data.reason,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
        };
        this.onConnectError = (error)=>{
            const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CONNECTION, (0, $flwxq.EVENT_STATUS).FAILURE, {
                latency: measure?.duration,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
            this.analyticsHelper?.sendErrorEvent(error, 'Error while establishing connection');
            // If error received with `data`, it means the connection is rejected
            // by the server on purpose for example no permission, so no need to
            // keep the underneath connection, need to close. But some error like
            // `xhr polling error` needs to retry.
            const errorData = error.data;
            if (errorData) this.socket?.close();
            const connectionError = {
                message: error.message ?? 'Connection error without message',
                data: {
                    // @ts-expect-error I bet we'll see some connection errors, for the Socket IO errors
                    code: errorData?.code ?? (0, $6MIiQ.INTERNAL_ERROR_CODE).CONNECTION_ERROR,
                    ...errorData
                }
            };
            this.emit('error', connectionError);
        };
        this.onReconnectError = (error)=>{
            this.reconnectHelper?.countReconnectError();
            if (this.reconnectHelper?.isLikelyNetworkIssue()) {
                this.analyticsHelper?.sendErrorEvent(error, 'Likely network issue while reconnecting the channel');
                const reconnectionError = {
                    message: 'Reconnection failed 8 times when browser was offline, likely there was a network issue',
                    data: {
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).RECONNECTION_NETWORK_ISSUE
                    }
                };
                this.emit('error', reconnectionError);
            }
        };
        this.onConnect = ()=>{
            this.connected = true;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $2c3ccd3818e40940$var$logger('Connected.', this.socket.id);
            const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CONNECTION, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                latency: measure?.duration,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
            this.emit('connected', {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                sid: this.socket.id,
                initialized: this.initialized
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReceiveData = (data)=>{
            $2c3ccd3818e40940$var$logger('Received data', data);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $2c3ccd3818e40940$var$logger('Session ID is', this.socket.id);
            if (data.type === 'initial') {
                if (!this.initialized) {
                    const { doc: doc, version: version, userId: userId, metadata: metadata } = data;
                    const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).DOCUMENT_INIT, this.analyticsHelper);
                    this.initExperience?.success();
                    this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).DOCUMENT_INIT, // TODO: ED-26957 - detect when document init fails and fire corresponding event for it
                    (0, $flwxq.EVENT_STATUS).SUCCESS, {
                        latency: measure?.duration,
                        resetReason: data.resetReason,
                        hasTitle: !!data.metadata?.title
                    });
                    this.initialized = true;
                    this.emit('init', {
                        doc: doc,
                        version: version,
                        userId: userId,
                        metadata: metadata
                    });
                } else {
                    // Page has just been restored, need to fix all the participants as well.
                    const { doc: doc, version: version, userId: userId, metadata: metadata, targetClientId: targetClientId } = data;
                    this.emit('restore', {
                        doc: doc,
                        version: version,
                        userId: userId,
                        metadata: metadata,
                        targetClientId: targetClientId
                    });
                }
            } else this.emit('steps:added', data);
        };
        this.fetchCatchupv2 = async (fromVersion, clientId, catchUpOutofSync, reason, sessionId)=>{
            try {
                const { steps: steps, metadata: metadata } = await (0, $dwp40.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/catchupv2`,
                    queryParams: {
                        version: fromVersion,
                        clientId: clientId,
                        catchUpOutofSync: catchUpOutofSync,
                        reason: reason,
                        sessionId: sessionId
                    },
                    requestInit: {
                        headers: await this.commonHeaders()
                    }
                });
                return {
                    steps: steps,
                    metadata: metadata
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (error.code === 404) {
                    const errorNotFound = {
                        message: 'The requested document is not found',
                        data: {
                            status: error.code,
                            code: (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_NOT_FOUND
                        }
                    };
                    this.emit('error', errorNotFound);
                    return {};
                }
                $2c3ccd3818e40940$var$logger("Can't fetch the catchupv2", error.message);
                const errorCatchupv2 = {
                    message: 'Cannot fetch catchupv2 from collab service',
                    data: {
                        status: error.status,
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).CATCHUP_FAILED
                    }
                };
                this.emit('error', errorCatchupv2);
                throw error;
            }
        };
        this.fetchReconcile = async (currentStateDoc, reason)=>{
            try {
                const reqBody = JSON.stringify({
                    doc: currentStateDoc,
                    productId: 'ccollab',
                    reason: reason
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const reconcileResponse = await (0, $dwp40.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/reconcile`,
                    requestInit: {
                        headers: {
                            ...await this.commonHeaders(),
                            'Content-Type': 'application/json'
                        },
                        method: 'POST',
                        body: reqBody
                    }
                });
                return reconcileResponse;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching reconciled document');
                throw error;
            }
        };
        /**
     * Fetch generated diff steps from the back-end service
     * @param currentStateDoc - The current state document
     * @param reason - The reason for generating diff steps
     * @returns {Promise<GenerateDiffStepsResponseBody>} - The generated diff steps response body
     */ this.fetchGeneratedDiffSteps = async (currentStateDoc, reason)=>{
            try {
                const reqBody = JSON.stringify({
                    doc: currentStateDoc,
                    productId: 'ccollab',
                    reason: reason
                });
                const reconcileResponse = await (0, $dwp40.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/generate-diff-steps`,
                    requestInit: {
                        headers: {
                            ...await this.commonHeaders(),
                            'Content-Type': 'application/json'
                        },
                        method: 'POST',
                        body: reqBody
                    }
                });
                return reconcileResponse;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching generated steps from the BE server');
                throw error;
            }
        };
        /**
     * Send message to the back-end service over the channel. Timestamp will be added server side.
     * @throws {NotInitializedError} Channel not initialized
     * @throws {NotConnectedError} Channel not connected
     */ this.broadcast = (type, data, callback)=>{
            if (!this.socket) throw new (0, $ixa9X.NotInitializedError)('Cannot broadcast, not initialized yet');
            if (!this.connected) {
                if (this.config.throwOnNotConnected) throw new (0, $ixa9X.NotConnectedError)('Cannot broadcast, currently offline.');
                return;
            }
            this.socket.emit('broadcast', {
                type: type,
                ...data
            }, callback);
        };
        /**
     * Send metadata to the back-end service over the channel
     * @throws {NotInitializedError} Channel not initialized
     * @throws {NotConnectedError} Channel not connected
     */ this.sendMetadata = (metadata)=>{
            if (!this.socket) throw new (0, $ixa9X.NotInitializedError)('Cannot send metadata, not initialized yet');
            if (!this.connected) {
                if (this.config.throwOnNotConnected) throw new (0, $ixa9X.NotConnectedError)('Cannot send metadata, currently offline.');
            }
            this.socket.emit('metadata', metadata);
        };
        this.sendPresenceJoined = ()=>{
            if (!this.connected || !this.socket) return;
            this.socket.emit('presence:joined');
        };
        this.onOnlineHandler = ()=>{
            // Force an immediate reconnect, the socket must first be closed to reset reconnection delay logic
            if (!this.connected) {
                this.socket?.close();
                this.socket?.connect();
            }
        };
        /**
     * Unbinds event listeners and timers used when handling connection auto-close when tab is hidden
     */ this.cleanupAutoDisconnect = ()=>{
            this.unbindVisibilityListener();
            if (this.disconnectTimer) {
                clearTimeout(this.disconnectTimer);
                this.disconnectTimer = undefined;
            }
        };
        /**
     * Cleanup the visiblitychange listener upon Collab Provider destroy
     * Value set when the listener is binded in addVisiblityListener
     */ this.unbindVisibilityListener = ()=>{};
        this.autoDisconnect = (disconnectTimer, disconnectDelay)=>{
            if (document.hidden) {
                $2c3ccd3818e40940$var$logger('visibilitychange: hidden');
                return setTimeout(()=>{
                    $2c3ccd3818e40940$var$logger('visibilitychange: closing connection');
                    this.socket?.close();
                }, disconnectDelay || disconnectDelay === 0 ? disconnectDelay * 1000 : 60000);
            } else {
                $2c3ccd3818e40940$var$logger('visibilitychange: visible');
                if (disconnectTimer) clearTimeout(disconnectTimer);
                $2c3ccd3818e40940$var$logger('visibilitychange: re-connecting');
                this.socket?.connect();
                return;
            }
        };
        this.config = config;
        this.analyticsHelper = analyticsHelper;
        this.initExperience = (0, $a5At1.createDocInitExp)(this.analyticsHelper);
    }
}
module.exports["Channel"] = $2c3ccd3818e40940$export$cfdacaa37f9b4dd7;

});

parcelRegister("4frCv", function(module, exports) {

var $8BTgu = parcelRequire("8BTgu");


var $9NwnH = parcelRequire("9NwnH");


var $ixa9X = parcelRequire("ixa9X");


var $iA9co = parcelRequire("iA9co");

var $d7309fc3556f972b$require$Buffer = $iA9co.Buffer;
const $d7309fc3556f972b$export$fe2e61603b61130d = (prefix, color = 'blue')=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (msg, data = null)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.COLLAB_PROVIDER_LOGGER) // eslint-disable-next-line no-console
        console.log(`%cCollab-${prefix}: ${msg}`, `color: ${color}; font-weight: bold`, data);
    };
function $d7309fc3556f972b$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
const $d7309fc3556f972b$export$5cf1c5fc6dfa8400 = (id)=>typeof id === 'string' && id.startsWith('agent:');
const $d7309fc3556f972b$export$e2005c9600188ac7 = (productInfo)=>productInfo?.product ?? 'unknown';
const $d7309fc3556f972b$export$1cc4a77342446611 = (productInfo)=>productInfo?.subProduct ?? (!!productInfo?.product ? 'none' : 'unknown');
const $d7309fc3556f972b$export$cbe99aded6131d03 = (step)=>{
    let stepJson;
    try {
        stepJson = step.toJSON();
    } catch (e) {
        return {
            type: 'unknown',
            contentTypes: '',
            stepSizeInBytes: $d7309fc3556f972b$require$Buffer.byteLength(JSON.stringify(step))
        };
    }
    let contentTypes = '';
    if (stepJson.slice?.content && Array.isArray(stepJson.slice?.content)) contentTypes = stepJson.slice.content// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((c)=>{
        return c?.type || 'unknown';
    }).join(', ');
    return {
        type: stepJson.stepType || 'unknown',
        contentTypes: contentTypes,
        stepSizeInBytes: $d7309fc3556f972b$require$Buffer.byteLength(JSON.stringify(step))
    };
};
const $d7309fc3556f972b$var$stepWithNextDocument = (stepJson)=>{
    return stepJson.stepType === 'override-document' && 'nextDocument' in stepJson;
};
const $d7309fc3556f972b$var$stepWithMark = (stepJson)=>{
    return stepJson.stepType === 'addMark' || stepJson.stepType === 'addNodeMark';
};
const $d7309fc3556f972b$var$stepWithAttrs = (stepJson)=>{
    return stepJson.stepType === 'setAttrs' && 'attrs' in stepJson;
};
const $d7309fc3556f972b$var$stepWithBatchAttrs = (stepJson)=>{
    return stepJson.stepType === 'batchAttrs' && 'data' in stepJson;
};
const $d7309fc3556f972b$var$stepWithFromTo = (stepJson)=>{
    return 'from' in stepJson && typeof stepJson.from === 'number' && 'to' in stepJson && typeof stepJson.to === 'number';
};
const $d7309fc3556f972b$var$stepWithGapFromTo = (stepJson)=>{
    return 'gapFrom' in stepJson && typeof stepJson.gapFrom === 'number' && 'gapTo' in stepJson && typeof stepJson.gapTo === 'number';
};
const $d7309fc3556f972b$var$stepWithInsert = (stepJson)=>{
    return 'insert' in stepJson && typeof stepJson.insert === 'number';
};
const $d7309fc3556f972b$var$stepWithPos = (stepJson)=>{
    return 'pos' in stepJson && typeof stepJson.pos === 'number';
};
const $d7309fc3556f972b$var$stepWithSlice = (stepJson)=>{
    return 'slice' in stepJson && Array.isArray(stepJson.slice?.content);
};
const $d7309fc3556f972b$export$c3999f755e5119b6 = (stepJson)=>{
    let contentTypes = null;
    if ($d7309fc3556f972b$var$stepWithSlice(stepJson)) contentTypes = stepJson.slice.content.map((c)=>{
        return c?.type || 'unknown';
    }).join(', ');
    return {
        type: stepJson.stepType || 'unknown',
        contentTypes: contentTypes
    };
};
const $d7309fc3556f972b$export$5a4db1b11509b097 = (stepJson)=>{
    const stepContentAsAdf = $d7309fc3556f972b$var$stepToAdf(stepJson);
    if (!stepContentAsAdf) return null;
    const scrubbedSteps = stepContentAsAdf.map((adf)=>(0, $8BTgu.default)(adf)).filter((adf)=>!!adf);
    return scrubbedSteps;
};
const $d7309fc3556f972b$export$c34327e5d6b409e1 = (doc)=>{
    const docJson = doc.toJSON();
    const scrubbedDoc = (0, $8BTgu.default)(docJson);
    if (!scrubbedDoc) return null;
    return scrubbedDoc;
};
const $d7309fc3556f972b$export$2afb2cb2393bffc = (docJson)=>{
    const scrubbedDoc = (0, $8BTgu.default)(docJson);
    if (!scrubbedDoc) return null;
    return scrubbedDoc;
};
const $d7309fc3556f972b$export$5332347b0103ece3 = (stepJson)=>{
    return {
        ...$d7309fc3556f972b$var$stepWithFromTo(stepJson) && {
            from: stepJson.from,
            to: stepJson.to
        },
        ...$d7309fc3556f972b$var$stepWithGapFromTo(stepJson) && {
            gapFrom: stepJson.gapFrom,
            gapTo: stepJson.gapTo
        },
        ...$d7309fc3556f972b$var$stepWithInsert(stepJson) && {
            insert: stepJson.insert
        },
        ...$d7309fc3556f972b$var$stepWithPos(stepJson) && {
            pos: stepJson.pos
        }
    };
};
/**
 * Returns the metadata for Step
 * @description metadata is applied by transform overrides [here](https://bitbucket.org/atlassian/adf-schema/src/e13bbece84ede8f245067dc53dd7ce694f427eda/packages/editor-prosemirror/src/transform-override.ts#lines-12)
 */ const $d7309fc3556f972b$var$getStepMetadata = (stepJson)=>{
    return stepJson.metadata;
};
const $d7309fc3556f972b$export$4b189f5a6c196cb1 = (steps, endIndex)=>{
    return steps.slice(0, endIndex).map((step)=>{
        return {
            stepType: $d7309fc3556f972b$export$c3999f755e5119b6(step),
            stepContent: $d7309fc3556f972b$export$5a4db1b11509b097(step),
            stepPositions: $d7309fc3556f972b$export$5332347b0103ece3(step),
            stepMetadata: $d7309fc3556f972b$var$getStepMetadata(step)
        };
    });
};
const $d7309fc3556f972b$var$stepToAdf = (step)=>{
    if ($d7309fc3556f972b$var$stepWithSlice(step)) return [
        {
            type: 'doc',
            content: step.slice.content.filter((el)=>el !== null)
        }
    ];
    else if ($d7309fc3556f972b$var$stepWithNextDocument(step)) return [
        {
            type: 'doc',
            content: step.nextDocument.content
        }
    ];
    else if ($d7309fc3556f972b$var$stepWithMark(step) && step.mark) return [
        {
            type: 'doc',
            marks: [
                {
                    type: step.mark.type || 'unknown',
                    attrs: step.mark.attrs
                }
            ]
        }
    ];
    else if ($d7309fc3556f972b$var$stepWithAttrs(step)) return [
        {
            type: 'doc',
            attrs: step.attrs
        }
    ];
    else if ($d7309fc3556f972b$var$stepWithBatchAttrs(step)) return step.data.map((stepData)=>{
        return {
            type: 'doc',
            attrs: stepData.attrs
        };
    });
    return [];
};
async function $d7309fc3556f972b$export$66e82726d1c3b152(oldState, newState) {
    try {
        let stepsFromOldState = '', stepsFromNewState = '';
        const states = {
            old: oldState ? (0, $9NwnH.sendableSteps)(oldState) : null,
            new: (0, $9NwnH.sendableSteps)(newState)
        };
        if (states.new?.steps) stepsFromNewState = await $d7309fc3556f972b$export$86b85b7b97208cd9(states.new.steps);
        if (states.old?.steps) stepsFromOldState = await $d7309fc3556f972b$export$86b85b7b97208cd9(states.old.steps);
        return {
            stepsFromOldState: stepsFromOldState,
            stepsFromNewState: stepsFromNewState
        };
    } catch (err) {
        return new (0, $ixa9X.CustomError)('Failed to obfuscate steps', err);
    }
}
async function $d7309fc3556f972b$export$86b85b7b97208cd9(steps) {
    const _steps = await Promise.resolve(steps.slice().map((s)=>s.toJSON()));
    return JSON.stringify($d7309fc3556f972b$export$4b189f5a6c196cb1(_steps));
}
module.exports["createLogger"] = $d7309fc3556f972b$export$fe2e61603b61130d;
module.exports["sleep"] = $d7309fc3556f972b$export$e772c8ff12451969;
module.exports["isAIProviderID"] = $d7309fc3556f972b$export$5cf1c5fc6dfa8400;
module.exports["getProduct"] = $d7309fc3556f972b$export$e2005c9600188ac7;
module.exports["getSubProduct"] = $d7309fc3556f972b$export$1cc4a77342446611;
module.exports["getStepUGCFreeDetails"] = $d7309fc3556f972b$export$cbe99aded6131d03;
module.exports["getDocAdfWithObfuscation"] = $d7309fc3556f972b$export$c34327e5d6b409e1;
module.exports["getDocAdfWithObfuscationFromJSON"] = $d7309fc3556f972b$export$2afb2cb2393bffc;
module.exports["getObfuscatedSteps"] = $d7309fc3556f972b$export$4b189f5a6c196cb1;
module.exports["logObfuscatedSteps"] = $d7309fc3556f972b$export$66e82726d1c3b152;

});

parcelRegister("8BTgu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f289a9a961759679$export$2e2bcd8739ae039);

var $6jPem = parcelRequire("6jPem");


var $4QzBR = parcelRequire("4QzBR");


var $5u0tf = parcelRequire("5u0tf");


var $3CUWl = parcelRequire("3CUWl");

var $f289a9a961759679$export$2e2bcd8739ae039 = (adf, options = {})=>{
    const nodeReplacements = {
        ...(0, $5u0tf.defaultNodeReplacements),
        ...options.nodeReplacements
    };
    const valueReplacements = {
        ...(0, $3CUWl.defaultValueReplacements),
        ...options.valueReplacements
    };
    return (0, $6jPem.traverse)(adf, {
        any: (node, parent)=>{
            const replacement = nodeReplacements[node.type];
            if (typeof replacement === 'function') {
                const result = replacement(node, {
                    parent: parent,
                    valueReplacements: valueReplacements
                });
                if (result !== false) return result;
            }
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const updatedNode = {};
            Object.entries(node).forEach(([key, value])=>{
                if ([
                    'version',
                    'type',
                    'content',
                    'marks'
                ].includes(key)) updatedNode[key] = value;
            });
            if (node.text && node.marks) updatedNode.marks = (0, $4QzBR.scrubLink)(node.marks ?? [], {
                valueReplacements: valueReplacements
            });
            if (node.text) updatedNode.text = (0, $4QzBR.scrubStr)(node.text);
            if (node.attrs) updatedNode.attrs = (0, $4QzBR.scrubAttrs)(node.type, node.attrs);
            return updatedNode;
        }
    });
};

});

parcelRegister("4QzBR", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $55e912ee1103ff6a$var$DUMMY_TEXT = `Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est laborum`;
const $55e912ee1103ff6a$var$DUMMY_DIGITS = [
    '2',
    '7',
    '4',
    '3',
    '5',
    '9',
    '1',
    '8',
    '0',
    '5'
];
const $55e912ee1103ff6a$var$BYPASS_ATTR_LIST = {
    bodiedExtension: [
        'extensionKey',
        'extensionType',
        'layout'
    ],
    codeBlock: [
        'language'
    ],
    decisionItem: [
        'state'
    ],
    embedCard: [
        'layout',
        'originalHeight',
        'originalWidth',
        'width'
    ],
    extension: [
        'extensionKey',
        'extensionType',
        'layout',
        'type'
    ],
    heading: [
        'level'
    ],
    inlineExtension: [
        'extensionKey',
        'extensionType',
        'layout'
    ],
    layoutColumn: [
        'width'
    ],
    media: [
        '__fileMimeType',
        '__fileSize',
        'height',
        'width',
        'type'
    ],
    mediaSingle: [
        'layout',
        'width',
        'widthType'
    ],
    orderedList: [
        'order'
    ],
    panel: [
        'panelType'
    ],
    status: [
        'color',
        'style'
    ],
    table: [
        'isNumberColumnEnabled',
        'layout',
        'width'
    ],
    tableCell: [
        'background',
        'colspan',
        'colwidth',
        'defaultMarks',
        'rowspan'
    ],
    tableHeader: [
        'background',
        'colspan',
        'colwidth',
        'defaultMarks',
        'rowspan'
    ],
    tableRow: [
        'defaultMarks'
    ],
    taskItem: [
        'state'
    ],
    blockTaskItem: [
        'state'
    ]
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $55e912ee1103ff6a$var$fromEntries = (iterable)=>{
    return [
        ...iterable
    ].reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
};
const $55e912ee1103ff6a$var$scrubNum = (val, start = 0)=>{
    return parseInt(val.toString().split('').map((_, index)=>{
        const base = start + index;
        const len = $55e912ee1103ff6a$var$DUMMY_DIGITS.length - 1;
        return $55e912ee1103ff6a$var$DUMMY_DIGITS[base % len];
    }).join(''), 10);
};
const $55e912ee1103ff6a$export$f8a660e92bd813ff = (val, offset = 0)=>{
    const base = $55e912ee1103ff6a$var$DUMMY_TEXT.repeat(Math.ceil((offset + val.length) / $55e912ee1103ff6a$var$DUMMY_TEXT.length));
    // using [...val] splits emoji character pairs correctly, compared to
    // something like "".split('')
    return [
        ...val
    ].map((char, index, chars)=>{
        // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
        if (RegExp("^\\p{Nd}$", "u").test(char)) // Decimal digits
        return $55e912ee1103ff6a$var$scrubNum(parseInt(char, 10), index).toString();
        else if (RegExp("^\\p{So}$", "u").test(char)) // Emoji
        return chars[index - 1]?.codePointAt(0) === 8205 ? '' : "\u2B50\uFE0F";
        else if (RegExp("^\\p{Sc}$", "u").test(char)) // Currency
        return '$';
        else if (RegExp("^[\\p{P}\\p{Z}\\p{C}]$", "u").test(char)) // Punctuation, Seperators, Control
        return char;
        else if (char.codePointAt(0) === 65039 && RegExp("^\\p{So}$", "u").test(chars[index - 1])) // Ingore compound emoji control char
        return '';
        else {
            // Everything else
            // modulo to ensure wrapping occurs around base string (no OOB access)
            const correction = base[offset % base.length] === ' ' ? 1 : 0;
            const raw = (0, $dh538.fg)('platform_adf-utils_fix-dummy-text-index-oob') ? base[(offset + correction) % base.length] : base[offset + correction];
            const isLower = char.toLowerCase() === char;
            const result = isLower ? raw.toLowerCase() : raw.toUpperCase();
            offset += 1 + correction;
            return result;
        }
    }).join('');
};
const $55e912ee1103ff6a$export$efa6f3a45942fa49 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, { valueReplacements: valueReplacements })=>{
    return marks.map((mark)=>{
        if (mark.type === 'link' && mark.attrs.href) return {
            ...mark,
            attrs: {
                ...mark.attrs,
                href: valueReplacements.href(mark.attrs.href)
            }
        };
        return mark;
    });
};
const $55e912ee1103ff6a$var$scrubObj = (nodeType, attrsObj)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const entries = Object.entries(attrsObj).map(([key, value])=>$55e912ee1103ff6a$var$BYPASS_ATTR_LIST[nodeType]?.includes(key) ? [
            key,
            value
        ] : [
            key,
            $55e912ee1103ff6a$export$e7384e231c3a8592(nodeType, value)
        ]);
    return $55e912ee1103ff6a$var$fromEntries(entries);
};
const $55e912ee1103ff6a$export$e7384e231c3a8592 = (nodeType, attrs, offset = 0)=>{
    if (typeof attrs === 'number') return $55e912ee1103ff6a$var$scrubNum(attrs, offset);
    if (typeof attrs === 'string') return $55e912ee1103ff6a$export$f8a660e92bd813ff(attrs, offset);
    if (typeof attrs === 'boolean') return attrs;
    if (!attrs) return attrs;
    const attrsObj = attrs;
    if (attrsObj && attrsObj.constructor === Object && Object.keys(attrsObj).length === 0) return {};
    if (typeof attrsObj === 'object' && !Array.isArray(attrsObj)) return $55e912ee1103ff6a$var$scrubObj(nodeType, attrsObj);
    if (Array.isArray(attrsObj)) return attrsObj.map((el)=>{
        return typeof el === 'object' ? $55e912ee1103ff6a$var$scrubObj(nodeType, el) : $55e912ee1103ff6a$export$e7384e231c3a8592(nodeType, el);
    });
    throw new TypeError(`scrubAttrs: encountered unsupported attributes type "${typeof attrsObj}"
    of value ${JSON.stringify(attrsObj)}`);
};
module.exports["scrubStr"] = $55e912ee1103ff6a$export$f8a660e92bd813ff;
module.exports["scrubLink"] = $55e912ee1103ff6a$export$efa6f3a45942fa49;
module.exports["scrubAttrs"] = $55e912ee1103ff6a$export$e7384e231c3a8592;

});

parcelRegister("5u0tf", function(module, exports) {

var $4QzBR = parcelRequire("4QzBR");

const $725cb18ca25f70fb$var$card = (node, { valueReplacements: valueReplacements })=>({
        type: node.type,
        attrs: {
            ...node.attrs || {},
            url: valueReplacements.href(node.attrs?.url)
        }
    });
const $725cb18ca25f70fb$var$mediaParent = (node)=>({
        type: node.type,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: node.attrs ? (0, $4QzBR.scrubAttrs)(node.type, node.attrs) : undefined,
        content: node.content?.filter((c)=>c?.type === 'media')
    });
const $725cb18ca25f70fb$export$9ead654a0051b376 = {
    emoji: ()=>({
            type: 'emoji',
            attrs: {
                shortName: ':blue_star:',
                id: 'atlassian-blue_star',
                text: ':blue_star:'
            }
        }),
    date: ()=>({
            type: 'date',
            attrs: {
                timestamp: new Date('2020-01-01').getTime()
            }
        }),
    mention: ()=>({
            type: 'mention',
            attrs: {
                id: 'error:NotFound',
                text: '@Nemo',
                accessLevel: 'CONTAINER'
            }
        }),
    inlineCard: $725cb18ca25f70fb$var$card,
    blockCard: $725cb18ca25f70fb$var$card,
    mediaSingle: $725cb18ca25f70fb$var$mediaParent,
    mediaGroup: $725cb18ca25f70fb$var$mediaParent,
    media: (node, { parent: parent })=>{
        const defaults = parent.node?.type === 'mediaSingle' ? {
            width: 600,
            height: 400
        } : {
            width: 150,
            height: 125
        };
        const width = node.attrs?.width ?? defaults.width;
        const height = node.attrs?.height ?? defaults.height;
        return {
            type: 'media',
            attrs: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ...(0, $4QzBR.scrubAttrs)('media', node.attrs),
                type: 'external',
                url: `https://dummyimage.com/${width}x${height}/f4f5f7/a5adba`
            }
        };
    }
};
module.exports["defaultNodeReplacements"] = $725cb18ca25f70fb$export$9ead654a0051b376;

});

parcelRegister("3CUWl", function(module, exports) {

var $5fEks = parcelRequire("5fEks");

const $8fe8606b28501032$export$be3aa623e32b055f = {
    href: (href)=>`https://hello.atlassian.net/wiki/spaces/ET/pages/968692273?${(0, $5fEks.hash)(href)}`
};
module.exports["defaultValueReplacements"] = $8fe8606b28501032$export$be3aa623e32b055f;

});

parcelRegister("5fEks", function(module, exports) {
// djb2 hashing algorithm www.cse.yorku.ca/~oz/hash.html
const $33376f9878629398$export$d6af199866bfb566 = (input)=>{
    let result = 5381;
    let index = input.length;
    while(index > 0)result = result * 33 ^ input.charCodeAt(--index);
    return (result >>> 0).toString();
};
module.exports["hash"] = $33376f9878629398$export$d6af199866bfb566;

});

parcelRegister("9NwnH", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $ks2lK = parcelRequire("ks2lK");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $5jGZY = parcelRequire("5jGZY");

class $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $c4b7da7a59ba31a1$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $5jGZY.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $c4b7da7a59ba31a1$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $c4b7da7a59ba31a1$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $c4b7da7a59ba31a1$var$collabKey = new (0, $ks2lK.PluginKey)('collab');
function $c4b7da7a59ba31a1$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $dQl1W.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $ks2lK.Plugin)({
        key: $c4b7da7a59ba31a1$var$collabKey,
        state: {
            init: ()=>new $c4b7da7a59ba31a1$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($c4b7da7a59ba31a1$var$collabKey);
                if (newState) {
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) return new $c4b7da7a59ba31a1$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $c4b7da7a59ba31a1$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($c4b7da7a59ba31a1$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $c4b7da7a59ba31a1$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $c4b7da7a59ba31a1$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, newUnconfirmed));
}
function $c4b7da7a59ba31a1$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $c4b7da7a59ba31a1$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $ks2lK.TextSelection)) {
        tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, newCollabState);
}
function $c4b7da7a59ba31a1$export$4da2109e7644e6c2(state) {
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $c4b7da7a59ba31a1$export$971539697c176258(state) {
    return $c4b7da7a59ba31a1$var$collabKey.getState(state);
}
module.exports["Rebaseable"] = $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd;
module.exports["rebaseSteps"] = $c4b7da7a59ba31a1$export$bced9e015fcf3afa;
module.exports["collab"] = $c4b7da7a59ba31a1$export$995d9de96d1b2e26;
module.exports["getDocBeforeUnconfirmedSteps"] = $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e;
module.exports["syncFromAnotherSource"] = $c4b7da7a59ba31a1$export$852bd88de4de2d35;
module.exports["receiveTransaction"] = $c4b7da7a59ba31a1$export$7581d8ca0d559ec6;
module.exports["sendableSteps"] = $c4b7da7a59ba31a1$export$4da2109e7644e6c2;
module.exports["getCollabState"] = $c4b7da7a59ba31a1$export$971539697c176258;

});

parcelRegister("5jGZY", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

// Iterate from the specified starting index down to 0
const $33dcd085767efb3e$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $jy7VG.AnalyticsStep))) return i;
    }
};
const $33dcd085767efb3e$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $33dcd085767efb3e$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $33dcd085767efb3e$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $33dcd085767efb3e$var$isReplaceTypeStep = (step)=>step instanceof (0, $aXG5V.ReplaceStep);
const $33dcd085767efb3e$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $33dcd085767efb3e$var$isReplaceTypeStep(previousRebaseableStep.step) && $33dcd085767efb3e$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $33dcd085767efb3e$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$33dcd085767efb3e$var$isReplaceTypeStep(previousStep) || mapped && !$33dcd085767efb3e$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof previousStep?.from === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $33dcd085767efb3e$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $aXG5V.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $5SAOw.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $aXG5V.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $33dcd085767efb3e$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}
module.exports["mapStep"] = $33dcd085767efb3e$export$798cdecdcbbf9755;

});

parcelRegister("ixa9X", function(module, exports) {
class $1307bfb35243cc15$export$f7a70f5f17339408 extends Error {
    toJSON() {
        return {
            name: this.name,
            message: this.message
        };
    }
    constructor(message, error, extraEventAttributes){
        super(message);
        this.extraEventAttributes = void 0;
        this.getExtraErrorEventAttributes = ()=>this.extraEventAttributes;
        if (typeof error?.message === 'string') this.message = error.message;
        if (extraEventAttributes) this.extraEventAttributes = extraEventAttributes;
    }
}
class $1307bfb35243cc15$export$ee94a7f51f58b1f0 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'NotConnectedError';
    }
}
class $1307bfb35243cc15$export$92624542437ba748 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'NotInitializedError';
    }
}
class $1307bfb35243cc15$export$f96efbf9586f7f39 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'ProviderInitialisationError';
    }
}
class $1307bfb35243cc15$export$121e803f723b3045 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SendTransactionError';
    }
}
class $1307bfb35243cc15$export$be0713d3b74f5c22 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'DestroyError';
    }
}
class $1307bfb35243cc15$export$a444b7fe9d0904eb extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetTitleError';
    }
}
class $1307bfb35243cc15$export$70274e29104db434 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetEditorWidthError';
    }
}
class $1307bfb35243cc15$export$c72e7ac58ad6e295 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetMetadataError';
    }
}
class $1307bfb35243cc15$export$29880dc4d51a91ac extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'GetCurrentStateError';
    }
}
class $1307bfb35243cc15$export$5d0dd2f3f3417c74 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'GetFinalAcknowledgedStateError';
    }
}
class $1307bfb35243cc15$export$b8b1b847e9447ca7 extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(message, extraAttributes){
        super(message, undefined, extraAttributes);
        this.name = 'UpdateDocumentError';
    }
}
class $1307bfb35243cc15$export$a2465e73e4ff8efe extends $1307bfb35243cc15$export$f7a70f5f17339408 {
    constructor(message, extraAttributes){
        super(message, undefined, extraAttributes);
        this.name = 'CantSyncUpError';
    }
}
module.exports["CustomError"] = $1307bfb35243cc15$export$f7a70f5f17339408;
module.exports["NotConnectedError"] = $1307bfb35243cc15$export$ee94a7f51f58b1f0;
module.exports["NotInitializedError"] = $1307bfb35243cc15$export$92624542437ba748;
module.exports["ProviderInitialisationError"] = $1307bfb35243cc15$export$f96efbf9586f7f39;
module.exports["SendTransactionError"] = $1307bfb35243cc15$export$121e803f723b3045;
module.exports["DestroyError"] = $1307bfb35243cc15$export$be0713d3b74f5c22;
module.exports["SetTitleError"] = $1307bfb35243cc15$export$a444b7fe9d0904eb;
module.exports["SetEditorWidthError"] = $1307bfb35243cc15$export$70274e29104db434;
module.exports["SetMetadataError"] = $1307bfb35243cc15$export$c72e7ac58ad6e295;
module.exports["GetCurrentStateError"] = $1307bfb35243cc15$export$29880dc4d51a91ac;
module.exports["GetFinalAcknowledgedStateError"] = $1307bfb35243cc15$export$5d0dd2f3f3417c74;
module.exports["UpdateDocumentError"] = $1307bfb35243cc15$export$b8b1b847e9447ca7;
module.exports["CantSyncUpError"] = $1307bfb35243cc15$export$a2465e73e4ff8efe;

});

parcelRegister("h6NFo", function(module, exports) {
// Initialize the random sampling rate
const $79f52cb3897d035a$var$TELEPOINTER_SAMPLE_RATE = 0.0001;
var $79f52cb3897d035a$export$5cb1f459478c70e = /*#__PURE__*/ function(MEASURE_NAME) {
    MEASURE_NAME["SOCKET_CONNECT"] = "socketConnect";
    MEASURE_NAME["DOCUMENT_INIT"] = "documentInit";
    MEASURE_NAME["COMMIT_UNCONFIRMED_STEPS"] = "commitUnconfirmedSteps";
    MEASURE_NAME["PUBLISH_PAGE"] = "publishPage";
    MEASURE_NAME["GET_CURRENT_STATE"] = "getCurrentState";
    return MEASURE_NAME;
}({});
const $79f52cb3897d035a$export$b5717a625dd4a3eb = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (api)=>!!performance[api]);
};
const $79f52cb3897d035a$export$3ebda12358c8b9c = new Map();
function $79f52cb3897d035a$export$b62aa2130c86b59b(measureName, analyticsHelper) {
    try {
        if (!$79f52cb3897d035a$export$b5717a625dd4a3eb()) return;
        performance.mark(`${measureName}::start`);
        $79f52cb3897d035a$export$3ebda12358c8b9c.set(measureName, performance.now());
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when marking the start');
    }
}
function $79f52cb3897d035a$export$37c25be427bec097(measureName, analyticsHelper, onMeasureComplete) {
    let start;
    try {
        if (!$79f52cb3897d035a$export$b5717a625dd4a3eb()) return;
        // `startMeasure` is not called with `measureName` before.
        if (!$79f52cb3897d035a$export$3ebda12358c8b9c.get(measureName)) return;
        performance.mark(`${measureName}::end`);
        start = onMeasureComplete ? $79f52cb3897d035a$export$3ebda12358c8b9c.get(measureName) : undefined;
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when marking the end');
    }
    try {
        const entry = performance.getEntriesByName(measureName).pop();
        $79f52cb3897d035a$var$clearMeasure(measureName);
        let measure;
        if (entry) measure = {
            duration: entry.duration,
            startTime: entry.startTime
        };
        else if (start) measure = {
            duration: performance.now() - start,
            startTime: start
        };
        if (measure && onMeasureComplete) onMeasureComplete(measure.duration, measure.startTime);
        return measure;
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when completing the measurement');
    }
}
function $79f52cb3897d035a$var$clearMeasure(measureName) {
    if (!$79f52cb3897d035a$export$b5717a625dd4a3eb()) return;
    $79f52cb3897d035a$export$3ebda12358c8b9c.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
const $79f52cb3897d035a$export$2afa64d53a381f1a = ()=>// At peak usage, telepointer we had 200M events per day. The goal is to sample 1:10000 of the events. (20k per day)
    // Math.random() generates a random floating-point number between 0 (inclusive) and 1 (exclusive).
    // The condition Math.random() < TELEPOINTER_SAMPLE_RATE (0.0001) will be true approximately 0.01% of the time.
    // This means that approximately 1 in 10,000 events will be sampled.
    Math.random() < $79f52cb3897d035a$var$TELEPOINTER_SAMPLE_RATE;
module.exports["MEASURE_NAME"] = $79f52cb3897d035a$export$5cb1f459478c70e;
module.exports["startMeasure"] = $79f52cb3897d035a$export$b62aa2130c86b59b;
module.exports["stopMeasure"] = $79f52cb3897d035a$export$37c25be427bec097;
module.exports["shouldTelepointerBeSampled"] = $79f52cb3897d035a$export$2afa64d53a381f1a;

});

parcelRegister("flwxq", function(module, exports) {
var $75e91bfdfa7553f9$export$9282cde89f62615f = /*#__PURE__*/ function(EVENT_ACTION) {
    EVENT_ACTION["CONNECTION"] = "connection";
    EVENT_ACTION["CATCHUP"] = "catchup";
    EVENT_ACTION["DOCUMENT_INIT"] = "documentInit";
    EVENT_ACTION["ADD_STEPS"] = "addSteps";
    EVENT_ACTION["UPDATE_PARTICIPANTS"] = "updateParticipants";
    EVENT_ACTION["UPDATE_DOCUMENT"] = "updateDocument";
    EVENT_ACTION["COMMIT_UNCONFIRMED_STEPS"] = "commitUnconfirmedSteps";
    EVENT_ACTION["REINITIALISE_DOCUMENT"] = "reinitialiseDocument";
    EVENT_ACTION["ERROR"] = "error";
    EVENT_ACTION["PUBLISH_PAGE"] = "publishPage";
    EVENT_ACTION["GET_CURRENT_STATE"] = "getCurrentState";
    EVENT_ACTION["INVALIDATE_TOKEN"] = "invalidateToken";
    EVENT_ACTION["SEND_STEPS_RETRY"] = "sendStepsRetry";
    EVENT_ACTION["CATCHUP_AFTER_MAX_SEND_STEPS_RETRY"] = "catchupAfterMaxSendStepsRetry";
    EVENT_ACTION["DROPPED_STEPS"] = "droppedStepInCatchup";
    EVENT_ACTION["WEBSOCKET_MESSAGE_VOLUME_METRIC"] = "websocketMessageVolumeMetric";
    EVENT_ACTION["PROVIDER_INITIALIZED"] = "providerInitialized";
    EVENT_ACTION["RECONNECTION"] = "providerReconnection";
    EVENT_ACTION["PROVIDER_SETUP"] = "providerSetup";
    EVENT_ACTION["HAS_UNCONFIRMED_STEPS"] = "hasUnconfirmedSteps";
    EVENT_ACTION["OUT_OF_SYNC"] = "outOfSync";
    EVENT_ACTION["STEPS_REBASED"] = "stepsRebased";
    EVENT_ACTION["POLLING_FALLBACK"] = "pollingFallback";
    EVENT_ACTION["PROCESS_STEPS"] = "processSteps";
    return EVENT_ACTION;
}({});
var $75e91bfdfa7553f9$export$5ab9b99d22ba6de0 = /*#__PURE__*/ function(EVENT_STATUS) {
    EVENT_STATUS["SUCCESS"] = "SUCCESS";
    EVENT_STATUS["FAILURE"] = "FAILURE";
    EVENT_STATUS["INFO"] = "INFO";
    EVENT_STATUS["SUCCESS_10x_SAMPLED"] = "SUCCESS_10x_SAMPLED";
    return EVENT_STATUS;
}({});
var $75e91bfdfa7553f9$export$4026f1a4d5b398bb = /*#__PURE__*/ function(ADD_STEPS_TYPE) {
    ADD_STEPS_TYPE["ACCEPTED"] = "ACCEPTED";
    ADD_STEPS_TYPE["REJECTED"] = "REJECTED";
    ADD_STEPS_TYPE["ERROR"] = "ERROR";
    return ADD_STEPS_TYPE;
}({});
const $75e91bfdfa7553f9$export$20f6a175f3aa35a2 = 60;
const $75e91bfdfa7553f9$export$c811f21c9ad05dc2 = 'confluence';
var $75e91bfdfa7553f9$export$2df0974445100a00 = /*#__PURE__*/ function(CatchupEventReason) {
    CatchupEventReason["STEPS_ADDED"] = "onStepsAdded";
    CatchupEventReason["STEPS_REJECTED"] = "onStepsRejected";
    CatchupEventReason["PROCESS_STEPS"] = "processSteps";
    CatchupEventReason["RECONNECTED"] = "reconnected";
    return CatchupEventReason;
}({});
module.exports["EVENT_ACTION"] = $75e91bfdfa7553f9$export$9282cde89f62615f;
module.exports["EVENT_STATUS"] = $75e91bfdfa7553f9$export$5ab9b99d22ba6de0;
module.exports["ADD_STEPS_TYPE"] = $75e91bfdfa7553f9$export$4026f1a4d5b398bb;
module.exports["ACK_MAX_TRY"] = $75e91bfdfa7553f9$export$20f6a175f3aa35a2;
module.exports["CatchupEventReason"] = $75e91bfdfa7553f9$export$2df0974445100a00;

});

parcelRegister("5TBlQ", function(module, exports) {

var $a0Jyl = parcelRequire("a0Jyl");


var $dPDqN = parcelRequire("dPDqN");

// Calculation for max 8 offline reconnect attempts, with reconnection delay 200ms, randomization factor 0.5, reconnection delay max 128s
// Min: 800ms, Avg: 51s, Max: 6m
const $f69c85fac4dc7f60$var$FAILED_RECONNECTS_WHILE_OFFLINE_THRESHOLD = 8;
class $f69c85fac4dc7f60$export$2e2bcd8739ae039 {
    countReconnectError() {
        // Only count the reconnection attempts when offline
        if ((0, $dPDqN.network).getStatus() === (0, $a0Jyl.NetworkStatus).OFFLINE) this.failedReconnectCount++;
    }
    isLikelyNetworkIssue() {
        const isLikelyNetworkIssue = this.failedReconnectCount >= $f69c85fac4dc7f60$var$FAILED_RECONNECTS_WHILE_OFFLINE_THRESHOLD;
        return isLikelyNetworkIssue;
    }
    destroy() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('online', this.onlineHandler);
    }
    constructor(){
        this.failedReconnectCount = 0;
        this.onlineHandler = ()=>{
            this.failedReconnectCount = 0;
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('online', this.onlineHandler);
    }
}
module.exports["default"] = $f69c85fac4dc7f60$export$2e2bcd8739ae039;

});

parcelRegister("a0Jyl", function(module, exports) {
var $edeb3c1a6e44827d$export$bd096ddbd246c79c = /*#__PURE__*/ function(NetworkStatus) {
    NetworkStatus["ONLINE"] = "ONLINE";
    NetworkStatus["OFFLINE"] = "OFFLINE";
    return NetworkStatus;
}({});
class $edeb3c1a6e44827d$export$2e2bcd8739ae039 {
    getStatus() {
        return this.status || null;
    }
    destroy() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('offline', this.offlineHandler);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('online', this.onlineHandler);
    }
    constructor(props){
        this.status = void 0;
        this.onlineCallback = void 0;
        this.offlineHandler = ()=>{
            this.status = "OFFLINE";
        };
        this.onlineHandler = ()=>{
            this.status = "ONLINE";
            if (this.onlineCallback) this.onlineCallback();
        };
        if (props?.initialStatus) this.status = props.initialStatus;
        if (props?.onlineCallback) this.onlineCallback = props.onlineCallback;
        if (typeof window !== 'undefined') {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('offline', this.offlineHandler);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('online', this.onlineHandler);
        }
    }
}
module.exports["NetworkStatus"] = $edeb3c1a6e44827d$export$bd096ddbd246c79c;
module.exports["default"] = $edeb3c1a6e44827d$export$2e2bcd8739ae039;

});

parcelRegister("dPDqN", function(module, exports) {

var $a0Jyl = parcelRequire("a0Jyl");

// Assume the connection is established at first
const $76ee835a3a594506$export$21fcfd9d5c6ebbd4 = new (0, $a0Jyl.default)({
    initialStatus: (0, $a0Jyl.NetworkStatus).ONLINE
});
module.exports["network"] = $76ee835a3a594506$export$21fcfd9d5c6ebbd4;

});

parcelRegister("a5At1", function(module, exports) {

var $iqaft = parcelRequire("iqaft");

var $4SCyD = parcelRequire("4SCyD");

const $5cb013b01c4605d1$var$createDocumentInitExperience = ()=>new (0, $4SCyD.UFOExperience)('collab-provider.document-init', {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).Custom,
        performanceConfig: {
            histogram: {
                [(0, $iqaft.ExperiencePerformanceTypes).Custom]: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            }
        }
    });
const $5cb013b01c4605d1$var$withErrorHandling = (createExperience, analyticsHelper)=>{
    let initExperience;
    try {
        initExperience = createExperience();
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while initialising a UFO experience');
    }
    return initExperience;
};
const $5cb013b01c4605d1$export$41daeddae2dd4619 = (analyticsHelper)=>$5cb013b01c4605d1$var$withErrorHandling($5cb013b01c4605d1$var$createDocumentInitExperience, analyticsHelper);
module.exports["createDocInitExp"] = $5cb013b01c4605d1$export$41daeddae2dd4619;

});

parcelRegister("7W8Hz", function(module, exports) {

var $h3X17 = parcelRequire("h3X17");

const $a6d9eece4894f88c$export$f9a0e0c2c8938695 = {
    IO_CLIENT_DISCONNECT: 'io client disconnect',
    IO_SERVER_DISCONNECT: 'io server disconnect',
    TRANSPORT_CLOSED: 'transport close',
    TRANSPORT_ERROR: 'transport error',
    PING_TIMEOUT: 'ping timeout'
};
const $a6d9eece4894f88c$export$5a38c81d972d63e3 = (reason)=>{
    switch(reason){
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.IO_CLIENT_DISCONNECT:
            return (0, $h3X17.DisconnectReason).CLIENT_DISCONNECT;
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.IO_SERVER_DISCONNECT:
            return (0, $h3X17.DisconnectReason).SERVER_DISCONNECT;
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.TRANSPORT_CLOSED:
            return (0, $h3X17.DisconnectReason).SOCKET_CLOSED;
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.TRANSPORT_ERROR:
            return (0, $h3X17.DisconnectReason).SOCKET_ERROR;
        case $a6d9eece4894f88c$export$f9a0e0c2c8938695.PING_TIMEOUT:
            return (0, $h3X17.DisconnectReason).SOCKET_TIMEOUT;
        default:
            return (0, $h3X17.DisconnectReason).UNKNOWN_DISCONNECT;
    }
};
module.exports["socketIOReasons"] = $a6d9eece4894f88c$export$f9a0e0c2c8938695;
module.exports["disconnectedReasonMapper"] = $a6d9eece4894f88c$export$5a38c81d972d63e3;

});

parcelRegister("6MIiQ", function(module, exports) {
var $9cd382ee64cec7e1$export$c14aa697065dcc24 = /*#__PURE__*/ function(INTERNAL_ERROR_CODE) {
    INTERNAL_ERROR_CODE["TOKEN_PERMISSION_ERROR"] = "TOKEN_PERMISSION_ERROR";
    INTERNAL_ERROR_CODE["RECONNECTION_NETWORK_ISSUE"] = "RECONNECTION_NETWORK_ISSUE";
    INTERNAL_ERROR_CODE["CONNECTION_ERROR"] = "CONNECTION_ERROR";
    INTERNAL_ERROR_CODE["RECONNECTION_ERROR"] = "RECONNECTION_ERROR";
    INTERNAL_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    INTERNAL_ERROR_CODE["CATCHUP_FAILED"] = "CATCHUP_FAILED";
    INTERNAL_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    INTERNAL_ERROR_CODE["ADD_STEPS_ERROR"] = "ADD_STEPS_ERROR";
    INTERNAL_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    INTERNAL_ERROR_CODE["VIEW_ONLY_STEPS_ERROR"] = "VIEW_ONLY_STEPS_ERROR";
    INTERNAL_ERROR_CODE["OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT"] = "OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT";
    return INTERNAL_ERROR_CODE;
}({});
 /*
 * This is what a generic ProviderError type would look like:
 * type ProviderError = {
 *   // Unique code, identifies the specific emitted error
 *   // Also exposed as a PROVIDER_ERROR_CODE enum to allow subscribers to use them
 *   code: PROVIDER_ERROR_CODE;
 *   // Informative message describing what went wrong
 *   message: string;
 *   // Flag indicating whether an error is recoverable or not
 *   // used by consumers to disable the provider and show an error message
 *   recoverable: boolean;
 *   // A reason code used to give more detail about why a certain error was thrown
 *   reason?: string;
 * }
 */ module.exports["INTERNAL_ERROR_CODE"] = $9cd382ee64cec7e1$export$c14aa697065dcc24;

});

parcelRegister("6Ted9", function(module, exports) {
// NCS error coded (generated by NCS)
var $7e69bc8716b47ec2$export$168e5dfca773ce7a = /*#__PURE__*/ function(NCS_ERROR_CODE) {
    NCS_ERROR_CODE["HEAD_VERSION_UPDATE_FAILED"] = "HEAD_VERSION_UPDATE_FAILED";
    NCS_ERROR_CODE["VERSION_NUMBER_ALREADY_EXISTS"] = "VERSION_NUMBER_ALREADY_EXISTS";
    NCS_ERROR_CODE["INSUFFICIENT_EDITING_PERMISSION"] = "INSUFFICIENT_EDITING_PERMISSION";
    NCS_ERROR_CODE["FORBIDDEN_USER_TOKEN"] = "FORBIDDEN_USER_TOKEN";
    NCS_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    NCS_ERROR_CODE["INIT_DATA_LOAD_FAILED"] = "INIT_DATA_LOAD_FAILED";
    NCS_ERROR_CODE["ERROR_MAPPING_ERROR"] = "ERROR_MAPPING_ERROR";
    NCS_ERROR_CODE["NAMESPACE_INVALID"] = "NAMESPACE_INVALID";
    NCS_ERROR_CODE["NAMESPACE_NOT_FOUND"] = "NAMESPACE_NOT_FOUND";
    NCS_ERROR_CODE["TENANT_INSTANCE_MAINTENANCE"] = "TENANT_INSTANCE_MAINTENANCE";
    NCS_ERROR_CODE["LOCKED_DOCUMENT"] = "LOCKED_DOCUMENT";
    NCS_ERROR_CODE["EMPTY_BROADCAST"] = "EMPTY_BROADCAST";
    NCS_ERROR_CODE["DYNAMO_ERROR"] = "DYNAMO_ERROR";
    NCS_ERROR_CODE["INVALID_ACTIVATION_ID"] = "INVALID_ACTIVATION_ID";
    NCS_ERROR_CODE["INVALID_DOCUMENT_ARI"] = "INVALID_DOCUMENT_ARI";
    NCS_ERROR_CODE["INVALID_CLOUD_ID"] = "INVALID_CLOUD_ID";
    NCS_ERROR_CODE["RATE_LIMIT_ERROR"] = "RATE_LIMIT_ERROR";
    NCS_ERROR_CODE["PROSEMIRROR_SCHEMA_VALIDATION_ERROR"] = "PROSEMIRROR_SCHEMA_VALIDATION_ERROR";
    return NCS_ERROR_CODE;
}({});
module.exports["NCS_ERROR_CODE"] = $7e69bc8716b47ec2$export$168e5dfca773ce7a;

});

parcelRegister("aX0Lv", function(module, exports) {

var $flwxq = parcelRequire("flwxq");


var $dmolA = parcelRequire("dmolA");


var $dPDqN = parcelRequire("dPDqN");


var $ixa9X = parcelRequire("ixa9X");

const $47363a476d445944$var$EVENT_SUBJECT = 'collab';
const $47363a476d445944$var$loggableErrorName = [
    'RangeError',
    'TypeError',
    'TransformError',
    'NodeNestingTransformError'
];
var $47363a476d445944$var$COLLAB_SERVICE = /*#__PURE__*/ function(COLLAB_SERVICE) {
    COLLAB_SERVICE["NCS"] = "ncs";
    COLLAB_SERVICE["SYNCHRONY"] = "synchrony";
    return COLLAB_SERVICE;
}($47363a476d445944$var$COLLAB_SERVICE || {});
const $47363a476d445944$var$triggerAnalyticsEvent = (analyticsEvent, analyticsClient)=>{
    if (!analyticsClient) return;
    const payload = {
        actionSubject: $47363a476d445944$var$EVENT_SUBJECT,
        attributes: {
            packageName: $dmolA.name,
            packageVersion: $dmolA.version,
            collabService: "ncs",
            network: {
                status: (0, $dPDqN.network).getStatus()
            },
            ...analyticsEvent.attributes
        },
        tags: [
            'editor'
        ],
        action: analyticsEvent.eventAction,
        source: 'unknown' // Adds zero analytics value, but event validation throws an error if you don't add it :-(
    };
    if (analyticsEvent.eventAction === (0, $flwxq.EVENT_ACTION).ERROR) {
        payload.nonPrivacySafeAttributes = analyticsEvent.nonPrivacySafeAttributes;
        try {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const requestIdleCallbackFunction = window.requestIdleCallback;
            const runItLater = typeof requestIdleCallbackFunction === 'function' ? requestIdleCallbackFunction : window.requestAnimationFrame;
            runItLater(()=>{
                analyticsClient.sendTrackEvent(payload);
            });
        } catch (error) {
        // silently fail for now https://product-fabric.atlassian.net/browse/ESS-3112
        }
    } else // Let the browser figure out
    // when it should send those events
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const requestIdleCallbackFunction = window.requestIdleCallback;
        const runItLater = typeof requestIdleCallbackFunction === 'function' ? requestIdleCallbackFunction : window.requestAnimationFrame;
        runItLater(()=>{
            analyticsClient.sendOperationalEvent(payload);
        });
    } catch (error) {
    // silently fail for now https://product-fabric.atlassian.net/browse/ESS-3112
    }
};
class $47363a476d445944$export$2e2bcd8739ae039 {
    sendErrorEvent(error, errorMessage) {
        let errorExtraAttributes = {};
        if (error instanceof (0, $ixa9X.CustomError)) errorExtraAttributes = error.getExtraErrorEventAttributes() || {};
        const errorAnalyticsEvent = {
            eventAction: (0, $flwxq.EVENT_ACTION).ERROR,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                errorMessage: errorMessage,
                errorName: error instanceof Error ? error.name : undefined,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                errorCode: error.data?.code ?? undefined,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                errorStatus: error.data?.status ?? undefined,
                errorStack: error instanceof Error && $47363a476d445944$var$loggableErrorName.includes(error.name) ? error.stack : undefined,
                originalErrorMessage: this.getUGCFreeErrorMessage(error),
                ...errorExtraAttributes
            },
            nonPrivacySafeAttributes: {
                error: error
            }
        };
        this.sendEvent(errorAnalyticsEvent);
    }
    sendProviderErrorEvent(error) {
        const errorAnalyticsEvent = {
            eventAction: (0, $flwxq.EVENT_ACTION).ERROR,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                errorMessage: 'Error emitted',
                originalErrorMessage: error.message,
                errorCode: error.code,
                mappedError: error
            }
        };
        this.sendEvent(errorAnalyticsEvent);
    }
    sendActionEvent(action, status, attributes // This breaks discriminated unions, because there is no obvious field to discriminate against any more
    ) {
        const analyticsEvent = {
            eventAction: action,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                eventStatus: status,
                ...attributes
            }
        };
        this.sendEvent(analyticsEvent);
    }
    async sendEvent(event) {
        if (this.getAnalyticsClient && !this.analyticsClient) try {
            this.analyticsClient = await this.getAnalyticsClient;
        } catch (error) {
        // fail silently
        }
        $47363a476d445944$var$triggerAnalyticsEvent(event, this.analyticsClient);
    }
    getUGCFreeErrorMessage(error) {
        if (error instanceof Error && $47363a476d445944$var$loggableErrorName.includes(error.name)) return error.message;
        else return undefined;
    }
    constructor(documentAri, subProduct, analyticsClient, getAnalyticsClient){
        this.analyticsClient = void 0;
        this.getAnalyticsClient = void 0;
        this.documentAri = void 0;
        this.subProduct = void 0;
        this.documentAri = documentAri;
        this.subProduct = subProduct;
        this.analyticsClient = analyticsClient;
        this.getAnalyticsClient = getAnalyticsClient;
    }
}
module.exports["default"] = $47363a476d445944$export$2e2bcd8739ae039;

});

parcelRegister("dmolA", function(module, exports) {
const $824a7fe97f9fcc7b$export$a8ff84c12d48cfa6 = "platform-pkg";
const $824a7fe97f9fcc7b$export$83d89fbfd8236492 = "0.0.0-use.local";
const $824a7fe97f9fcc7b$export$49a9c95426e73961 = ()=>{
    return [
        Number($824a7fe97f9fcc7b$export$83d89fbfd8236492.split('.')[0]) + 1,
        0,
        0
    ].join('.');
};
module.exports["name"] = $824a7fe97f9fcc7b$export$a8ff84c12d48cfa6;
module.exports["version"] = $824a7fe97f9fcc7b$export$83d89fbfd8236492;

});

parcelRegister("gVzjB", function(module, exports) {

var $4frCv = parcelRequire("4frCv");


var $iqaft = parcelRequire("iqaft");

var $4SCyD = parcelRequire("4SCyD");


var $fdOBD = parcelRequire("fdOBD");

const $f7b6fd07244084eb$var$logger = (0, $4frCv.createLogger)('Telepointer', 'green');
const $f7b6fd07244084eb$export$eaaa064fda0476c4 = (participants, step)=>{
    const [participant] = participants.filter((p)=>p.clientId === step.clientId);
    if (participant) {
        const { stepType: stepType, to: to, from: from, slice: slice = {
            content: []
        } } = step;
        const [node] = slice.content;
        if (to && from && stepType === 'replace' && to === from && slice.content.length === 1 && node?.type === 'text' && node?.text?.length === 1) return {
            sessionId: participant.sessionId,
            selection: {
                type: 'textSelection',
                anchor: from + 1,
                head: to + 1
            },
            type: 'telepointer'
        };
    }
};
const $f7b6fd07244084eb$export$8aee63d4597b3f93 = (documentAri)=>{
    const telepointerExperience = new (0, $4SCyD.UFOExperience)('collab-provider.telepointer', {
        type: (0, $iqaft.ExperienceTypes).Operation,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).Custom,
        performanceConfig: {
            histogram: {
                [(0, $iqaft.ExperiencePerformanceTypes).Custom]: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            }
        }
    });
    telepointerExperience.addMetadata({
        documentAri: documentAri
    });
    telepointerExperience.start();
    return (response)=>{
        if (response.type === (0, $fdOBD.AcknowledgementResponseTypes).SUCCESS) telepointerExperience.success();
        else if (response.type === (0, $fdOBD.AcknowledgementResponseTypes).ERROR) {
            const errorMessage = response.error;
            telepointerExperience.addMetadata({
                error: errorMessage
            });
            $f7b6fd07244084eb$var$logger('Error from collab service with telepointer broadcast', errorMessage);
            telepointerExperience.failure();
        } else {
            $f7b6fd07244084eb$var$logger('Invalid ACK from collab service with telepointer broadcast');
            telepointerExperience.addMetadata({
                error: 'Invalid ACK from collab service with telepointer broadcast'
            });
            telepointerExperience.failure();
        }
    };
};
module.exports["telepointerFromStep"] = $f7b6fd07244084eb$export$eaaa064fda0476c4;
module.exports["telepointerCallback"] = $f7b6fd07244084eb$export$8aee63d4597b3f93;

});

parcelRegister("fdOBD", function(module, exports) {
var $1e717904817dfc51$export$49ed9ecf1b22773d = /*#__PURE__*/ function(AcknowledgementResponseTypes) {
    AcknowledgementResponseTypes["SUCCESS"] = "SUCCESS";
    AcknowledgementResponseTypes["ERROR"] = "ERROR";
    return AcknowledgementResponseTypes;
}({});
module.exports["AcknowledgementResponseTypes"] = $1e717904817dfc51$export$49ed9ecf1b22773d;

});

parcelRegister("aPvdt", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");

class $488feb4a36d568ce$export$b732ab16be80c4ec {
    setTitle(title, broadcast) {
        if (broadcast) this.broadcastMetadata({
            title: title
        });
        this.metadata.title = title;
    }
    setEditorWidth(editorWidth, broadcast) {
        if (broadcast) this.broadcastMetadata({
            editorWidth: editorWidth
        });
        this.metadata.editorWidth = editorWidth;
    }
    constructor(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providerEmitCallback, broadcastMetadata){
        this.providerEmitCallback = providerEmitCallback;
        this.broadcastMetadata = broadcastMetadata;
        this.metadata = {};
        this.getMetaData = ()=>this.metadata;
        this.getTitle = ()=>{
            return this.metadata.title?.toString();
        };
        /**
     * Called when a metadata is changed externally from other clients/backend.
     */ this.onMetadataChanged = (metadata)=>{
            if (metadata !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.metadata, metadata) && Object.keys(metadata).length > 0) {
                this.metadata = metadata;
                this.providerEmitCallback('metadata:changed', metadata);
            }
        };
        /**
     * Updates the local metadata and broadcasts the metadata to other clients/backend.
     * @param metadata
     */ this.setMetadata = (metadata)=>{
            this.broadcastMetadata(metadata);
            this.metadata = metadata;
        };
        /**
     * Emits a change in document's metadata
     * @param metadata
     */ this.updateMetadata = (metadata)=>{
            if (metadata && Object.keys(metadata).length > 0) {
                this.metadata = metadata;
                this.providerEmitCallback('metadata:changed', metadata);
            }
        };
    }
}
module.exports["MetadataService"] = $488feb4a36d568ce$export$b732ab16be80c4ec;

});

parcelRegister("84uMS", function(module, exports) {

var $8Yfbq = parcelRequire("8Yfbq");


var $cO9ey = parcelRequire("cO9ey");


var $9NwnH = parcelRequire("9NwnH");


var $ks2lK = parcelRequire("ks2lK");


var $h9yJL = parcelRequire("h9yJL");


var $iu6m9 = parcelRequire("iu6m9");


var $1oCLl = parcelRequire("1oCLl");


var $flwxq = parcelRequire("flwxq");


var $h6NFo = parcelRequire("h6NFo");


var $6MIiQ = parcelRequire("6MIiQ");


var $4frCv = parcelRequire("4frCv");


var $eOOPa = parcelRequire("eOOPa");


var $enTxz = parcelRequire("enTxz");


var $ixa9X = parcelRequire("ixa9X");


var $86Ccb = parcelRequire("86Ccb");


var $3QAb4 = parcelRequire("3QAb4");


var $c7fJY = parcelRequire("c7fJY");

const $18b8a2fb76cb9149$var$CATCHUP_THROTTLE = 1000; // 1 second
const $18b8a2fb76cb9149$var$noop = ()=>{};
const $18b8a2fb76cb9149$var$logger = (0, $4frCv.createLogger)('documentService', 'red');
class $18b8a2fb76cb9149$export$136703b96b9b8f33 {
    getVersionFromCollabState(state, resource) {
        const collabState = (0, $9NwnH.getCollabState)(state);
        if (!collabState) {
            this.analyticsHelper?.sendErrorEvent(new Error('No collab state when calling ProseMirror function'), `${resource} called without collab state`);
            return 0;
        }
        // This should not happen in usual, just add error event in case it happens
        if (collabState.version === undefined) {
            this.analyticsHelper?.sendErrorEvent(new Error('Collab state missing version info when calling ProseMirror function'), `${resource} called with collab state missing version info`);
            return 0;
        }
        return collabState.version;
    }
    /**
   * In the event we reconnect check if we have existing unconfirmed steps and if so
   * notify the editor that we have a potential conflict to resolve on the frontend.
   *
   * @param data remote steps payload
   * @param steps
   * @example
   */ notifyReconnectionConflict(steps) {
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', false)) return;
        const state = this.getState?.();
        const unconfirmedSteps = state ? (0, $9NwnH.getCollabState)(state)?.unconfirmed : undefined;
        if (steps.length > 0 && state && unconfirmedSteps && unconfirmedSteps.length > 0) {
            const { schema: schema, tr: tr } = state;
            const remoteSteps = steps.map((s)=>(0, $cO9ey.Step).fromJSON(schema, s));
            const conflicts = (0, $c7fJY.getConflictChanges)({
                localSteps: unconfirmedSteps,
                remoteSteps: remoteSteps,
                tr: tr
            });
            if (conflicts.deleted.length > 0 || conflicts.inserted.length > 0) this.providerEmitCallback('data:conflict', {
                offlineDoc: state.doc,
                ...conflicts
            });
        }
    }
    processQueue() {
        if (this.stepQueue.isPaused()) {
            $18b8a2fb76cb9149$var$logger(`Queue is paused. Aborting.`);
            return;
        }
        $18b8a2fb76cb9149$var$logger(`Looking for processable data.`);
        if (this.stepQueue.getQueue().length > 0) {
            const firstItem = this.stepQueue.shift();
            const currentVersion = this.getCurrentPmVersion();
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const expectedVersion = currentVersion + firstItem.steps.length;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (firstItem.version === expectedVersion) {
                $18b8a2fb76cb9149$var$logger(`Applying data from queue!`);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.processSteps(firstItem);
                // recur
                this.processQueue();
            }
        }
    }
    processSteps(data) {
        const { version: version, steps: steps } = data;
        $18b8a2fb76cb9149$var$logger(`Processing data. Version "${version}".`);
        if (steps?.length) try {
            const clientIds = steps.map(({ clientId: clientId })=>clientId);
            this.providerEmitCallback('data', {
                json: steps,
                version: version,
                userIds: clientIds
            });
            // If steps can apply to local editor successfully, no need to accumulate the error counter.
            this.stepRejectCounter = 0;
            this.participantsService.emitTelepointersFromSteps(steps);
            // Resend local steps if none of the received steps originated with us!
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (clientIds.indexOf(this.clientId) === -1) setTimeout(()=>this.sendStepsFromCurrentState(), 100);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).PROCESS_STEPS, (0, $flwxq.EVENT_STATUS).SUCCESS);
        } catch (error) {
            // ESS-6421: log if error processing steps when there are steps from the same userId but not the same clientId
            const userIdMatch = this.isStepsFromNewClientIdForSameUserId(steps);
            $18b8a2fb76cb9149$var$logger(`Processing steps failed with error: ${error}. Triggering catch up call.`);
            this.analyticsHelper?.sendErrorEvent(error, userIdMatch ? `Error while processing steps with new clientId` : `Error while processing steps`);
            this.throttledCatchupv2((0, $flwxq.CatchupEventReason).PROCESS_STEPS);
        }
    }
    /**
   *
   * @example
   */ getIsNamespaceLocked() {
        return this.isNameSpaceLocked();
    }
    /**
   *
   * @param root0
   * @param root0.getState
   * @param root0.onSyncUpError
   * @param root0.clientId
   * @example
   */ setup({ getState: getState, onSyncUpError: onSyncUpError, clientId: clientId }) {
        this.getState = getState;
        this.onSyncUpError = onSyncUpError || $18b8a2fb76cb9149$var$noop;
        this.clientId = clientId;
        return this;
    }
    /**
   * We can use this function to throttle/delay
   * Any send steps operation
   *
   * The getState function will return the current EditorState
   * from the EditorView.
   * @param sendAnalyticsEvent
   * @param reason
   * @example
   */ sendStepsFromCurrentState(sendAnalyticsEvent, reason) {
        const state = this.getState?.();
        if (!state) {
            this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'sendStepsFromCurrentState called without state');
            return;
        }
        this.send(null, null, state, sendAnalyticsEvent, reason);
    }
    /**
   * Send steps from transaction to other participants
   * It needs the superfluous arguments because we keep the interface of the send API the same as the Synchrony plugin
   * @param tr
   * @param _oldState
   * @param newState
   * @param sendAnalyticsEvent
   * @param reason
   * @example
   */ send(tr, _oldState, _newState, sendAnalyticsEvent, reason // only used for publish and draft-sync events - when called through getFinalAcknowledgedState
    ) {
        const offlineEditingEnabled = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true);
        const onlineStepMergingEnabled = (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true);
        // We don't trust `_newState` not to be stale
        // ED-29051 - the `onEditorViewStateUpdated` can have a stale state in edge cases. We need
        // to always ensure we're sending the latest state and unconfirmed steps so we use the state
        // from editorView directly (via getState).
        const newState = onlineStepMergingEnabled ? this.getState?.() ?? _newState : _newState;
        // Don't send any steps before we're ready.
        if (offlineEditingEnabled || onlineStepMergingEnabled) {
            const enableOnlineStepMerging = onlineStepMergingEnabled && !this.commitStepService.getReadyToCommitStatus();
            if (!this.getConnected() || enableOnlineStepMerging) return;
        }
        const unconfirmedStepsData = (0, $9NwnH.sendableSteps)(newState);
        const version = this.getVersionFromCollabState(newState, 'collab-provider: send');
        if (!unconfirmedStepsData) return;
        if (offlineEditingEnabled || onlineStepMergingEnabled) this.lockStepOrigins(unconfirmedStepsData.origins);
        const unconfirmedSteps = unconfirmedStepsData.steps;
        // sendAnalyticsEvent is only true when buffering is enabled,
        // to ensure that analytics events with the number of unconfirmed steps is only
        // sent once on connection (as opposed to on every step)
        if (sendAnalyticsEvent) this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).HAS_UNCONFIRMED_STEPS, (0, $flwxq.EVENT_STATUS).INFO, {
            numUnconfirmedSteps: unconfirmedSteps?.length || 0
        });
        if (!unconfirmedSteps?.length) return;
        const rebased = tr?.getMeta('rebasedData');
        if (rebased) {
            const obfuscatedUnconfirmedSteps = this.obfuscateStepsAndState(rebased.unconfirmedSteps).obfuscatedSteps;
            const obfuscatedRemoteSteps = this.obfuscateStepsAndState(rebased.remoteSteps);
            const obfuscatedRebasedSteps = this.obfuscateStepsAndState(unconfirmedSteps).obfuscatedSteps;
            // send analtyics on unconfirmed steps
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).STEPS_REBASED, (0, $flwxq.EVENT_STATUS).INFO, {
                obfuscatedUnconfirmedSteps: obfuscatedUnconfirmedSteps,
                obfuscatedRemoteSteps: obfuscatedRemoteSteps,
                obfuscatedRebasedSteps: obfuscatedRebasedSteps,
                clientID: this.clientId,
                userId: this.getUserId(),
                versionBefore: rebased.versionBefore,
                versionAfter: version
            });
        }
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            const containsOfflineSteps = unconfirmedStepsData?.origins.some((tr)=>{
                return tr instanceof (0, $ks2lK.Transaction) ? tr.getMeta('isOffline') ?? false : false;
            });
            if (containsOfflineSteps && !this.timeoutExceeded) {
                // Only start timer if we're online and don't already have one running
                if (this.getConnected() && !this.timeout) this.timeout = setTimeout(()=>{
                    // If the timer expires and we're still online, handle the offline steps.
                    // Otherwise, clear the timer so it can restart when we're online again.
                    if (this.getConnected()) {
                        this.timeoutExceeded = true;
                        const updatedUnconfirmedStepsData = (0, $9NwnH.sendableSteps)(newState);
                        updatedUnconfirmedStepsData?.origins.forEach((origin)=>{
                            if (origin instanceof (0, $ks2lK.Transaction) && origin.getMeta('isOffline')) origin.setMeta('isOffline', false);
                        });
                    } else this.timeout = undefined;
                }, 6000);
                return;
            } else if (this.timeoutExceeded) {
                this.timeoutExceeded = false;
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = undefined;
                }
            }
        }
        // Avoid reference issues using a
        // method outside of the provider
        // scope
        this.commitStepService.commitStepQueue({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            userId: this.getUserId(),
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            clientId: this.clientId,
            steps: unconfirmedSteps,
            version: version,
            onStepsAdded: this.onStepsAdded,
            __livePage: this.options.__livePage,
            hasRecovered: this.hasRecovered,
            collabMode: this.participantsService.getCollabMode(),
            reason: reason,
            lockSteps: this.lockSteps,
            stepOrigins: unconfirmedStepsData.origins
        });
    }
    /**
   *
   * @param participantsService - The participants service, used when users are detected active when making changes to the document
   * and to emit their telepointers from steps they add
   * @param analyticsHelper - Helper for analytics events
   * @param fetchCatchupv2 - Step based - Function to fetch "catchupv2" data, data required to rebase current steps to the latest version.
   * @param fetchReconcile - Function to call "reconcile" from NCS backend
   * @param fetchGeneratedDiffSteps - Function to call "generateDiffSteps" from NCS backend
   * @param providerEmitCallback - Callback for emitting events to listeners on the provider
   * @param broadcast - Callback for broadcasting events to other clients
   * @param getUserId - Callback to fetch the current user's ID
   * @param onErrorHandled - Callback to handle
   * @param metadataService
   * @param isNameSpaceLocked
   * @param enableErrorOnFailedDocumentApply - Enable failed document update exceptions.
   * @param options.__livePage
   * @param options
   * @param getConnected - if the channel is currently connected
   * @example
   */ constructor(participantsService, analyticsHelper, fetchCatchupv2, fetchReconcile, fetchGeneratedDiffSteps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providerEmitCallback, broadcast, getUserId, onErrorHandled, metadataService, isNameSpaceLocked, enableErrorOnFailedDocumentApply = false, options = {
        __livePage: false
    }, getConnected){
        this.participantsService = participantsService;
        this.analyticsHelper = analyticsHelper;
        this.fetchCatchupv2 = fetchCatchupv2;
        this.fetchReconcile = fetchReconcile;
        this.fetchGeneratedDiffSteps = fetchGeneratedDiffSteps;
        this.providerEmitCallback = providerEmitCallback;
        this.broadcast = broadcast;
        this.getUserId = getUserId;
        this.metadataService = metadataService;
        this.isNameSpaceLocked = isNameSpaceLocked;
        this.enableErrorOnFailedDocumentApply = enableErrorOnFailedDocumentApply;
        this.options = options;
        this.getConnected = getConnected;
        this.getState = void 0;
        // Fires analytics to editor when collab editor cannot sync up
        this.onSyncUpError = void 0;
        this.stepQueue = void 0;
        this.stepRejectCounter = 0;
        this.aggressiveCatchup = false;
        this.catchUpOutofSync = false;
        this.hasRecovered = false;
        this.commitStepService = void 0;
        this.timeout = void 0;
        this.timeoutExceeded = false;
        // ClientID is the unique ID for a prosemirror client. Used for step-rebasing.
        this.clientId = void 0;
        this.onErrorHandled = void 0;
        /**
     * To prevent calling catchup to often, use lodash throttle to reduce the frequency
     * @param reason - optional reason to attach.
     */ this.throttledCatchupv2 = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))((reason, reconnectionMetadata, sessionId)=>this.catchupv2(reason, reconnectionMetadata, sessionId), $18b8a2fb76cb9149$var$CATCHUP_THROTTLE, {
            leading: false,
            // TODO: ED-26957 - why shouldn't this be leading?
            trailing: true
        });
        /**
     * Called when:
     *   * session established(offline -> online)
     *   * try to accept steps but version is behind.
     * @param reason - optional reason to attach.
     * @param reconnectionMetadata
     * @example
     */ this.catchupv2 = async (reason, reconnectionMetadata, sessionId)=>{
            const start = new Date().getTime();
            // if the queue is already paused, we are busy with something else, so don't proceed.
            if (this.stepQueue.isPaused()) {
                $18b8a2fb76cb9149$var$logger(`Queue is paused. Aborting.`);
                return;
            }
            /**
       * If the database is in a transitionary state (i.e locked),
       * it likely that another user may already be in the process of catching up.
       *
       * If multiple users are trying to catch up at the same time, it can lead to
       * the database being stuck in a transitionary state due to duplicated page recovery requests.
       * We don't wanna be stuck in a transitionary state as that will cause issues with
       * content reconciliation and other operations.
       */ // check if the document is locked -> noop
            if (this.isNameSpaceLocked()) {
                $18b8a2fb76cb9149$var$logger(`catchupv2: Document is locked. Aborting.`);
                return;
            }
            this.stepQueue.pauseQueue();
            try {
                /**
         * We have two options when out of sync:
         * - Check a boolean that ensures we reset the document next time we catchup
         * - Immediately catchup
         *
         * Immediately catching up has some complexity invovled with it - do we call catchupv2 again, fetchCatchupv2 again, or documentService.catchupV2 again?
         * If we call either catchupv2 or documentService.catchupv2, we run the risk of creating an infinite loop of reset catchup requests.
         * We can slow down the loop by calling throttledCatchupv2, and can add booleans that check if we're already doing a reset catchup request.
         *
         * But this all adds complexity that can be avoided by choosing the first option.
         * Collab provider will already call catchup again, so this time we can ensure we call it with reset.
         */ this.catchUpOutofSync = await (0, $86Ccb.catchupv2)({
                    getCurrentPmVersion: this.getCurrentPmVersion,
                    fetchCatchupv2: this.fetchCatchupv2,
                    updateMetadata: this.metadataService.updateMetadata,
                    analyticsHelper: this.analyticsHelper,
                    clientId: this.clientId,
                    onStepsAdded: this.onStepsAdded,
                    catchUpOutofSync: this.catchUpOutofSync,
                    reason: reason,
                    sessionId: sessionId,
                    onCatchupComplete: (steps)=>{
                        // We want to capture the number of steps made while offline vs. online
                        if (reason === (0, $flwxq.CatchupEventReason).RECONNECTED) {
                            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).RECONNECTION, (0, $flwxq.EVENT_STATUS).INFO, {
                                ...reconnectionMetadata,
                                remoteStepsLength: steps?.length ?? 0
                            });
                            this.notifyReconnectionConflict(steps);
                        }
                    },
                    getState: this.getState
                });
                const latency = new Date().getTime() - start;
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CATCHUP, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    latency: latency,
                    version: this.getCurrentPmVersion()
                });
            } catch (error) {
                const latency = new Date().getTime() - start;
                // Skip client side errors; TypeErrors are client side errors https://developer.mozilla.org/en-US/docs/Web/API/Window/fetch
                const errorMessage = error instanceof Error ? error.message : String(error);
                if (!errorMessage.includes('TypeError') && !(error instanceof TypeError)) this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CATCHUP, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    latency: latency,
                    reason: reason,
                    unconfirmedStepsLength: reconnectionMetadata?.unconfirmedStepsLength,
                    disconnectionPeriodSeconds: reconnectionMetadata?.disconnectionPeriodSeconds
                });
            } finally{
                this.stepQueue.resumeQueue();
                this.processQueue();
                this.sendStepsFromCurrentState(); // this will eventually retry catchup as it calls throttledCommitStep which will either catchup on onStepsAdded or onErrorHandled
                this.stepRejectCounter = 0;
            }
        };
        this.getCurrentPmVersion = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getCurrentPmVersion called without state');
                return 0;
            }
            return this.getVersionFromCollabState(state, 'collab-provider: getCurrentPmVersion');
        };
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.getCurrentState = async ()=>{
            try {
                (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                // Convert ProseMirror document in Editor state to ADF document
                if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'getCurrentState called without state');
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const state = this.getState();
                const adfDocument = new (0, $h9yJL.JSONTransformer)().encode(state.doc);
                const version = this.getVersionFromCollabState(state, 'collab-provider: getCurrentState');
                const currentState = {
                    content: adfDocument,
                    title: this.metadataService.getTitle(),
                    stepVersion: version
                };
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).GET_CURRENT_STATE, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    latency: measure?.duration
                });
                return currentState;
            } catch (error) {
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).GET_CURRENT_STATE, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of current draft document');
                throw error; // Reject the promise so the consumer can react to it failing
            }
        };
        this.isStepsFromNewClientIdForSameUserId = (steps)=>{
            try {
                if (!Array.isArray(steps) || steps.length === 0) return false;
                const clientIds = new Set(steps.map(({ clientId: clientId })=>clientId));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (!clientIds.has(this.clientId)) {
                    const userIds = new Set(steps.map(({ userId: userId })=>userId));
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (userIds.has(this.getUserId())) return true;
                }
                return false;
            } catch (err) {
                this.analyticsHelper?.sendErrorEvent(err, 'Error while checking for new clientId for same userId in steps');
                return false;
            }
        };
        this.getUnconfirmedStepsOrigins = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getUnconfirmedStepsOrigins called without state');
                return;
            }
            return (0, $9NwnH.sendableSteps)(state)?.origins;
        };
        this.getUnconfirmedSteps = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getUnconfirmedSteps called without state');
                return;
            }
            return (0, $9NwnH.sendableSteps)(state)?.steps;
        };
        this.applyLocalSteps = (steps)=>{
            // Re-apply local steps
            this.providerEmitCallback('local-steps', {
                steps: steps
            });
        };
        /**
     * Called when we receive steps from the service
     * @param data
     * @example
     */ this.onStepsAdded = (data)=>{
            $18b8a2fb76cb9149$var$logger(`Received steps`, {
                steps: data.steps,
                version: data.version
            });
            if (!data.steps) {
                $18b8a2fb76cb9149$var$logger(`No steps.. waiting..`);
                return;
            }
            const ADD_STEPS_PROVIDER_ERROR_MSG = 'Error while adding steps in the provider';
            try {
                const currentVersion = this.getCurrentPmVersion();
                const expectedVersion = currentVersion + data.steps.length;
                if (data.version <= currentVersion) $18b8a2fb76cb9149$var$logger(`Received steps we already have. Ignoring.`);
                else if (data.version === expectedVersion) this.processSteps(data);
                else if (data.version > expectedVersion) {
                    $18b8a2fb76cb9149$var$logger(`Version too high. Expected "${expectedVersion}" but got "${data.version}. Current local version is ${currentVersion}.`);
                    this.stepQueue.queueSteps(data);
                    this.throttledCatchupv2((0, $flwxq.CatchupEventReason).STEPS_ADDED);
                }
                this.participantsService.updateLastActive(data.steps.map(({ userId: userId })=>userId));
            } catch (stepsAddedError) {
                this.analyticsHelper?.sendErrorEvent(stepsAddedError, ADD_STEPS_PROVIDER_ERROR_MSG);
                this.onErrorHandled({
                    message: ADD_STEPS_PROVIDER_ERROR_MSG,
                    data: {
                        status: 500,
                        // Meaningless, remove when we review error structure
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).ADD_STEPS_ERROR
                    }
                });
                // eslint-disable-next-line no-console
                console.error(ADD_STEPS_PROVIDER_ERROR_MSG);
            }
        };
        this.obfuscateStepsAndState = (unconfirmedSteps, currentState)=>{
            let obfuscatedSteps;
            try {
                obfuscatedSteps = unconfirmedSteps ? (0, $4frCv.getObfuscatedSteps)(unconfirmedSteps.map((pmStep)=>pmStep.toJSON())) : 'None';
            } catch (error) {
                // Note that we do not log this error immediately - this string will be logged later.
                // This avoids double logging and keeps this function pure.
                obfuscatedSteps = 'Failed to obfuscate steps';
            }
            let obfuscatedDoc;
            if (currentState) try {
                obfuscatedDoc = (0, $4frCv.getDocAdfWithObfuscationFromJSON)(currentState.content);
            } catch (error) {
                obfuscatedDoc = 'Failed to obfuscate doc';
            }
            return {
                obfuscatedSteps: obfuscatedSteps,
                obfuscatedDoc: obfuscatedDoc
            };
        };
        // Triggered when page recovery has emitted an 'init' event on a page client is currently connected to.
        this.onRestore = async ({ doc: doc, version: version, metadata: metadata, targetClientId: targetClientId })=>{
            if (!targetClientId) this.hasRecovered = true;
            if (targetClientId && this.clientId !== targetClientId) return;
            // We preserve these as they will be lost apon this.updateDocument. This is because we are using document recovery.
            // We can then reconcile the document with the preserved state.
            const unconfirmedSteps = this.getUnconfirmedSteps();
            const currentState = await this.getCurrentState();
            let useReconcile = Boolean(unconfirmedSteps?.length && currentState && !targetClientId);
            const { obfuscatedSteps: obfuscatedSteps, obfuscatedDoc: obfuscatedDoc } = this.obfuscateStepsAndState(unconfirmedSteps, currentState);
            try {
                // Reset the editor,
                //  - Replace the document, keep in sync with the server
                //  - Replace the version number, so editor is in sync with NCS server and can commit new changes.
                //  - Replace the metadata
                //  - Reserve the cursor position, in case a cursor jump.
                this.updateDocument({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    reserveCursor: true,
                    caller: 'onRestore'
                });
                this.metadataService.updateMetadata(metadata);
                try {
                    this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).INFO, {
                        numUnconfirmedSteps: unconfirmedSteps?.length,
                        obfuscatedSteps: obfuscatedSteps,
                        obfuscatedDoc: obfuscatedDoc,
                        hasTitle: !!metadata?.title,
                        clientId: this.clientId,
                        targetClientId: targetClientId,
                        triggeredByCatchup: !!targetClientId
                    });
                    if (unconfirmedSteps?.length) this.applyLocalSteps(unconfirmedSteps);
                } catch (applyLocalStepsError) {
                    // Extract generatedSteps from fetchReconcile response
                    // and apply them to the editor state.
                    this.onErrorHandled({
                        message: `Content synced with your team's edits. You may want to check for conflicting edits that could override your changes.`,
                        data: {
                            code: (0, $6MIiQ.INTERNAL_ERROR_CODE).OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT,
                            meta: {
                                reason: 'fe-restore-fetch-generated-steps'
                            }
                        }
                    });
                    useReconcile = false;
                    try {
                        const generatedDiffStepsResponse = await this.fetchGeneratedDiffSteps(JSON.stringify(currentState.content), 'fe-restore-fetch-generated-steps');
                        const { generatedSteps: generatedSteps } = generatedDiffStepsResponse;
                        const state = this.getState?.();
                        if (state?.schema) {
                            const stepsToBeApplied = generatedSteps?.map((s)=>(0, $cO9ey.Step).fromJSON(state.schema, s));
                            if (stepsToBeApplied && stepsToBeApplied.length > 0) {
                                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).INFO, {
                                    stepsCount: stepsToBeApplied.length
                                });
                                this.applyLocalSteps(stepsToBeApplied);
                            } else this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).INFO, {
                                reason: 'fetchGeneratedDiffSteps returned no steps'
                            });
                        }
                    } catch (reconcileError) {
                        this.analyticsHelper?.sendErrorEvent(reconcileError, `Error fetchGeneratedDiffSteps with steps-only mode`);
                    }
                }
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    numUnconfirmedSteps: unconfirmedSteps?.length,
                    hasTitle: !!metadata?.title,
                    useReconcile: useReconcile,
                    clientId: this.clientId,
                    targetClientId: targetClientId,
                    triggeredByCatchup: !!targetClientId
                });
            } catch (restoreError) {
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    numUnconfirmedSteps: unconfirmedSteps?.length,
                    useReconcile: useReconcile,
                    clientId: this.clientId,
                    targetClientId: targetClientId,
                    triggeredByCatchup: !!targetClientId
                });
                this.analyticsHelper?.sendErrorEvent(restoreError, `Error while reinitialising document. Use Reconcile: ${useReconcile}`);
                this.onErrorHandled({
                    message: 'Caught error while trying to recover the document',
                    data: {
                        status: 500,
                        // Meaningless, remove when we review error structure
                        code: (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_RESTORE_ERROR
                    }
                });
            }
        };
        this.getFinalAcknowledgedState = async (reason)=>{
            this.aggressiveCatchup = true;
            try {
                (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                let finalAcknowledgedState;
                try {
                    await this.commitUnconfirmedSteps(reason);
                    finalAcknowledgedState = await this.getCurrentState();
                } catch (error) {
                    // if fails to commit unconfirmed steps, send reconcile request to NCS BE and return the doc to CC
                    const currentState = await this.getCurrentState();
                    const reconcileResponse = await this.fetchReconcile(JSON.stringify(currentState.content), 'fe-final-ack');
                    finalAcknowledgedState = {
                        content: JSON.parse(reconcileResponse.document),
                        title: currentState.title,
                        stepVersion: reconcileResponse.version
                    };
                }
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).PUBLISH_PAGE, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    latency: measure?.duration
                });
                this.aggressiveCatchup = false;
                return finalAcknowledgedState;
            } catch (error) {
                this.aggressiveCatchup = false;
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).PUBLISH_PAGE, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of the final draft document');
                throw error; // Reject the promise so the consumer can react to it failing
            }
        };
        this.updateDocument = ({ doc: doc, version: version, metadata: metadata, reserveCursor: reserveCursor, caller: caller })=>{
            this.providerEmitCallback('init', {
                doc: doc,
                version: version,
                metadata: metadata,
                ...reserveCursor ? {
                    reserveCursor: reserveCursor
                } : {}
            });
            this.updateDocumentAnalytics(doc, version, caller);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.updateDocumentAnalytics = (doc, version, caller)=>{
            const updatedVersion = this.getCurrentPmVersion();
            const isDocContentValid = this.validatePMJSONDocument(doc);
            // ESS-5023: only emit error event if updated client version is still behind server version
            // client version could become higher than server version due to user editing or plugin adding steps
            if (updatedVersion < version) {
                const error = new (0, $ixa9X.UpdateDocumentError)('Failed to update the document', {
                    newVersion: version,
                    editorVersion: updatedVersion,
                    isDocTruthy: !!doc,
                    docHasContent: doc?.content?.length >= 1,
                    isDocContentValid: isDocContentValid,
                    caller: caller
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Failed to update the document in document service');
                if (this.enableErrorOnFailedDocumentApply) {
                    this.onErrorHandled({
                        message: 'The provider failed to apply changes to the editor',
                        data: {
                            code: (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_UPDATE_ERROR,
                            meta: {
                                newVersion: version,
                                editorVersion: updatedVersion
                            },
                            status: 500
                        }
                    });
                    throw error;
                }
            // Otherwise just fail silently for now
            } else this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).UPDATE_DOCUMENT, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                newVersion: version,
                editorVersion: updatedVersion,
                isDocTruthy: !!doc,
                docHasContent: doc?.content?.length >= 1,
                isDocContentValid: isDocContentValid
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.validatePMJSONDocument = (doc)=>{
            try {
                if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'validatePMJSONDocument called without state');
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const state = this.getState();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch (error) {
                        return false;
                    }
                    return true;
                });
            } catch (e) {
                return false;
            }
        };
        /**
     * Commit the unconfirmed local steps to the back-end service
     * @param reason
     * @throws {Error} Couldn't sync the steps after retrying 30 times
     * @example
     */ this.commitUnconfirmedSteps = async (reason)=>{
            const unconfirmedSteps = this.getUnconfirmedSteps();
            try {
                if (unconfirmedSteps?.length) {
                    (0, $h6NFo.startMeasure)((0, $h6NFo.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                    let count = 0;
                    // We use origins here as steps can be rebased. When steps are rebased a new step is created.
                    // This means that we can not track if it has been removed from the unconfirmed array or not.
                    // Origins points to the original transaction that the step was created in. This is never changed
                    // and gets passed down when a step is rebased.
                    const unconfirmedTrs = this.getUnconfirmedStepsOrigins();
                    const lastTr = unconfirmedTrs?.[unconfirmedTrs.length - 1];
                    let isLastTrConfirmed = false;
                    if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'commitUnconfirmedSteps called without state');
                    while(!isLastTrConfirmed){
                        // this makes all commitUnconfirmedSteps skip the waiting time, which means draft-sync is sped up too.
                        this.sendStepsFromCurrentState(undefined, 'publish');
                        await (0, $4frCv.sleep)(500);
                        const nextUnconfirmedSteps = this.getUnconfirmedSteps();
                        if (nextUnconfirmedSteps?.length) {
                            const nextUnconfirmedTrs = this.getUnconfirmedStepsOrigins();
                            isLastTrConfirmed = !nextUnconfirmedTrs?.some((tr)=>tr === lastTr);
                        } else isLastTrConfirmed = true;
                        if (!isLastTrConfirmed && count++ >= (0, $flwxq.ACK_MAX_TRY)) {
                            if (this.onSyncUpError) {
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                const state = this.getState();
                                const version = this.getVersionFromCollabState(state, 'collab-provider: commitUnconfirmedSteps');
                                this.onSyncUpError({
                                    lengthOfUnconfirmedSteps: nextUnconfirmedSteps?.length,
                                    tries: count,
                                    maxRetries: (0, $flwxq.ACK_MAX_TRY),
                                    clientId: this.clientId,
                                    version: version
                                });
                            }
                            const unconfirmedStepsInfoUGCRemoved = this.getUnconfirmedSteps()?.map((step)=>(0, $4frCv.getStepUGCFreeDetails)(step));
                            const error = new (0, $ixa9X.CantSyncUpError)("Can't sync up with Collab Service: unable to send unconfirmed steps and max retry reached", {
                                unconfirmedStepsInfo: unconfirmedStepsInfoUGCRemoved ? JSON.stringify(unconfirmedStepsInfoUGCRemoved) : 'Unable to generate UGC removed step info'
                            });
                            throw error;
                        }
                    }
                    const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                    this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).COMMIT_UNCONFIRMED_STEPS, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                        latency: measure?.duration,
                        // upon success, emit the total number of unconfirmed steps we synced
                        numUnconfirmedSteps: unconfirmedSteps?.length
                    });
                }
            } catch (error) {
                const measure = (0, $h6NFo.stopMeasure)((0, $h6NFo.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).COMMIT_UNCONFIRMED_STEPS, (0, $flwxq.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration,
                    numUnconfirmedSteps: unconfirmedSteps?.length
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while committing unconfirmed steps');
                throw error;
            }
        };
        this.onStepRejectedError = ()=>{
            this.stepRejectCounter++;
            $18b8a2fb76cb9149$var$logger(`Steps rejected (tries=${this.stepRejectCounter})`);
            this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).SEND_STEPS_RETRY, (0, $flwxq.EVENT_STATUS).INFO, {
                count: this.stepRejectCounter
            });
            const maxRetries = this.aggressiveCatchup ? (0, $eOOPa.MAX_STEP_REJECTED_ERROR_AGGRESSIVE) : (0, $eOOPa.MAX_STEP_REJECTED_ERROR);
            if (this.stepRejectCounter >= maxRetries) {
                $18b8a2fb76cb9149$var$logger(`The steps were rejected too many times (tries=${this.stepRejectCounter}, limit=${(0, $eOOPa.MAX_STEP_REJECTED_ERROR)}). Trying to catch-up.`);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).CATCHUP_AFTER_MAX_SEND_STEPS_RETRY, (0, $flwxq.EVENT_STATUS).INFO);
                this.throttledCatchupv2((0, $flwxq.CatchupEventReason).STEPS_REJECTED);
            } else // If committing steps failed try again automatically in 1s
            // This makes it more likely that unconfirmed steps trigger a catch-up
            // within 15s even if there is no one editing actively (or draft sync polling)
            // reducing the risk of data loss at the expense of step commits
            setTimeout(()=>this.sendStepsFromCurrentState(), 1000);
        };
        /**
     * If we are going to commit unconfirmed steps
     * we need to lock them to ensure they don't get
     * mutated in: `packages/editor/editor-plugin-collab-edit/src/pm-plugins/mergeUnconfirmed.ts`
     */ this.lockSteps = ()=>{
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) {
                const currentState = this.getState?.();
                if (currentState) this.lockStepOrigins((0, $9NwnH.sendableSteps)(currentState)?.origins ?? []);
            }
        };
        this.lockStepOrigins = (origins)=>{
            origins?.forEach((origin)=>{
                if (origin instanceof (0, $ks2lK.Transaction)) return origin.setMeta('mergeIsLocked', true);
            });
        };
        this.stepQueue = new (0, $3QAb4.StepQueueState)();
        this.onErrorHandled = onErrorHandled;
        this.commitStepService = new (0, $enTxz.CommitStepService)(this.broadcast, this.analyticsHelper, this.providerEmitCallback, this.onErrorHandled);
    }
}
module.exports["DocumentService"] = $18b8a2fb76cb9149$export$136703b96b9b8f33;

});

parcelRegister("enTxz", function(module, exports) {

var $3GH4X = parcelRequire("3GH4X");


var $flwxq = parcelRequire("flwxq");


var $fdOBD = parcelRequire("fdOBD");


var $6Ted9 = parcelRequire("6Ted9");


var $4frCv = parcelRequire("4frCv");


var $1oCLl = parcelRequire("1oCLl");

const $24a15250db2473e6$var$logger = (0, $4frCv.createLogger)('commit-step', 'black');
const $24a15250db2473e6$export$e52e10f4c6d18d66 = 5000;
class $24a15250db2473e6$export$1507ea63539b16e5 {
    commitStepQueue({ steps: steps, version: version, userId: userId, clientId: clientId, onStepsAdded: onStepsAdded, __livePage: __livePage, hasRecovered: hasRecovered, collabMode: collabMode, reason: reason, lockSteps: lockSteps, stepOrigins: stepOrigins }) {
        // this timer is for waiting to send the next batch in between acks from the BE
        let commitWaitTimer;
        // if publishing and not waiting for an ACK, then clear the commit timer and proceed, skipping the timer
        if (reason === 'publish' && this.lastBroadcastRequestAcked) {
            clearTimeout(commitWaitTimer);
            lockSteps();
            this.readyToCommit = true;
        }
        if (!this.readyToCommit) {
            $24a15250db2473e6$var$logger('Not ready to commit, skip');
            return;
        }
        // Block other sending request, before ACK
        this.readyToCommit = false;
        this.lastBroadcastRequestAcked = false;
        // this timer is a fallback for if an ACK from BE is lost - stop the queue from getting indefinitely locked
        const fallbackTimer = setTimeout(()=>{
            lockSteps();
            this.readyToCommit = true;
            this.lastBroadcastRequestAcked = true;
            $24a15250db2473e6$var$logger('reset readyToCommit by timer');
        }, $24a15250db2473e6$export$e52e10f4c6d18d66);
        let stepsWithClientAndUserId = steps.map((step)=>({
                ...step.toJSON(),
                clientId: clientId,
                userId: userId
            }));
        // Mutate steps to ignore expand expand/collapse changes in live pages
        // This is expected to be a temporary divergence from standard editor behaviour
        // and will be removed in Q4 when editor and live view pages align on a single
        // behaviour for expands.
        // While not recommended by the Editor content services team, this has been discussed
        // as being low risk as the expand change via a setAttrs step;
        // - doesn't impact any indexes,
        // - is setup for last write wins,
        // - and is just a boolean -- so no real risk of data loss.
        if (__livePage) stepsWithClientAndUserId = stepsWithClientAndUserId.map((step)=>{
            if (this.isExpandChangeStep(step)) // The title is also updated via this step, which we do want to send to the server.
            // so we strip out the __expanded attribute from the step.
            return {
                ...step,
                attrs: {
                    title: step.attrs.title
                }
            };
            return step;
        });
        // tag unconfirmed steps sent after page has been recovered during client's editing session
        if (hasRecovered) stepsWithClientAndUserId = stepsWithClientAndUserId.map((step)=>{
            step.metadata = {
                ...step.metadata,
                unconfirmedStepAfterRecovery: true
            };
            return step;
        });
        if ((0, $1oCLl.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) stepsWithClientAndUserId = this.addOfflineMetadata(stepsWithClientAndUserId, stepOrigins);
        const start = new Date().getTime();
        const ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG = 'Error while adding steps - Invalid Acknowledgement';
        const ADD_STEPS_BROADCAST_ERROR_MSG = 'Error while adding steps - Broadcast threw exception';
        this.emit('commit-status', {
            status: 'attempt',
            version: version
        });
        try {
            this.broadcast('steps:commit', {
                collabMode: collabMode,
                steps: stepsWithClientAndUserId,
                version: version,
                userId: userId
            }, (response)=>{
                this.lastBroadcastRequestAcked = true;
                const latency = new Date().getTime() - start;
                // this most closely replicates the BE ack delay behaviour. 500ms hardcoded + 180ms network delay (tested on hello)
                // more context: https://hello.atlassian.net/wiki/spaces/CEPS/pages/5020556010/Spike+Moving+BE+delay+to+the+FE
                // to be switched over to backpressure delay sent from the BE in https://hello.jira.atlassian.cloud/browse/CEPS-1030
                let delay = latency < 680 ? 680 - latency : 1;
                if (response.delay) delay = response.delay;
                 // if backpressure delay is sent, overwrite it
                clearTimeout(fallbackTimer); // clear the fallback timer, ack was successfully sent/recieved
                commitWaitTimer = setTimeout(()=>{
                    lockSteps();
                    // unlock the queue after waiting for delay
                    this.readyToCommit = true;
                    $24a15250db2473e6$var$logger('reset readyToCommit');
                }, delay);
                if (response.type === (0, $fdOBD.AcknowledgementResponseTypes).SUCCESS) {
                    onStepsAdded({
                        steps: stepsWithClientAndUserId,
                        version: response.version
                    });
                    this.sendSuccessAnalytics(latency, stepsWithClientAndUserId);
                    this.emit('commit-status', {
                        status: 'success',
                        version: response.version
                    });
                } else if (response.type === (0, $fdOBD.AcknowledgementResponseTypes).ERROR) {
                    this.onErrorHandled(response.error);
                    this.sendFailureAnalytics(response, latency);
                    this.emit('commit-status', {
                        status: 'failure',
                        version: version
                    });
                    // eslint-disable-next-line no-console
                    console.error(ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                } else {
                    this.analyticsHelper?.sendErrorEvent(// @ts-expect-error We didn't type the invalid type case
                    new Error(`Response type: ${response?.type || 'No response type'}`), ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                    this.emit('commit-status', {
                        status: 'failure',
                        version: version
                    });
                    // eslint-disable-next-line no-console
                    console.error(ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                }
            });
        } catch (error) {
            // if the broadcast failed for any reason, we shouldn't keep the queue locked as the BE has not recieved any message
            lockSteps();
            this.readyToCommit = true;
            this.analyticsHelper?.sendErrorEvent(error, ADD_STEPS_BROADCAST_ERROR_MSG);
            this.emit('commit-status', {
                status: 'failure',
                version: version
            });
            // eslint-disable-next-line no-console
            console.error(ADD_STEPS_BROADCAST_ERROR_MSG);
        }
    }
    isExpandChangeStep(step) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (step.stepType === 'setAttrs' && '__expanded' in step.attrs) return true;
        return false;
    }
    addOfflineMetadata(stepsWithClientAndUserId, origins) {
        if (origins.some((s)=>s.getMeta('isOffline') === true || s.getMeta('wasOffline') === true)) return stepsWithClientAndUserId.map((step, idx)=>{
            const origin = origins[idx];
            if (!origin) return step;
            const createdOffline = origin.getMeta('isOffline') || origin.getMeta('wasOffline');
            if (createdOffline === true) step.metadata = {
                ...step.metadata,
                createdOffline: createdOffline
            };
            return step;
        });
        return stepsWithClientAndUserId;
    }
    sendSuccessAnalytics(latency, stepsWithClientAndUserId) {
        // Sample only 10% of add steps events to avoid overwhelming the analytics
        if (Math.random() < 0.1) this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).ADD_STEPS, (0, $flwxq.EVENT_STATUS).SUCCESS_10x_SAMPLED, {
            type: (0, $flwxq.ADD_STEPS_TYPE).ACCEPTED,
            latency: latency,
            stepType: (0, (/*@__PURE__*/$parcel$interopDefault($3GH4X)))(stepsWithClientAndUserId, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (stepWithClientAndUserId)=>stepWithClientAndUserId.stepType)
        });
    }
    sendFailureAnalytics(response, latency) {
        this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).ADD_STEPS, (0, $flwxq.EVENT_STATUS).FAILURE, {
            // User tried committing steps but they were rejected because:
            // - HEAD_VERSION_UPDATE_FAILED: the collab service's latest stored step tail version didn't correspond to the head version of the first step submitted
            // - VERSION_NUMBER_ALREADY_EXISTS: while storing the steps there was a conflict meaning someone else wrote steps into the database more quickly
            type: response.error.data.code === (0, $6Ted9.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED || response.error.data.code === (0, $6Ted9.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS ? (0, $flwxq.ADD_STEPS_TYPE).REJECTED : (0, $flwxq.ADD_STEPS_TYPE).ERROR,
            latency: latency
        });
        this.analyticsHelper?.sendErrorEvent(response.error, 'Error while adding steps - Acknowledgement Error');
    }
    getReadyToCommitStatus() {
        return this.readyToCommit;
    }
    /**
   * @param broadcast - Callback for broadcasting events to other clients
   * @param analyticsHelper - Helper for analytics events
   * @param emit - Callback for emitting events to listeners on the provider
   * @param onErrorHandled - Callback to handle
   */ constructor(broadcast, analyticsHelper, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    emit, onErrorHandled){
        this.broadcast = broadcast;
        this.analyticsHelper = analyticsHelper;
        this.emit = emit;
        this.onErrorHandled = onErrorHandled;
        this.readyToCommit = void 0;
        this.lastBroadcastRequestAcked = void 0;
        this.readyToCommit = true;
        this.lastBroadcastRequestAcked = true;
    }
}
module.exports["CommitStepService"] = $24a15250db2473e6$export$1507ea63539b16e5;

});

parcelRegister("3GH4X", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $2af6b5f2fc42996a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2af6b5f2fc42996a$var$hasOwnProperty = $2af6b5f2fc42996a$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $2af6b5f2fc42996a$var$countBy = $77wHb(function(result, value, key) {
    if ($2af6b5f2fc42996a$var$hasOwnProperty.call(result, key)) ++result[key];
    else $3PAnx(result, key, 1);
});
module.exports = $2af6b5f2fc42996a$var$countBy;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("86Ccb", function(module, exports) {

var $flwxq = parcelRequire("flwxq");


var $4frCv = parcelRequire("4frCv");

const $a77c90d12a129f65$var$logger = (0, $4frCv.createLogger)('Catchupv2', 'red');
const $a77c90d12a129f65$export$f32ba3eea9c226f8 = async (opt)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let steps;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let metadata;
    const fromVersion = opt.getCurrentPmVersion();
    try {
        ({ steps: steps, metadata: metadata } = await opt.fetchCatchupv2(fromVersion, opt.clientId, opt.catchUpOutofSync, opt.reason, opt.sessionId));
    } catch (error) {
        opt.analyticsHelper?.sendErrorEvent(error, 'Error while fetching catchupv2 from server');
        $a77c90d12a129f65$var$logger(`Fetch catchupv2 from server failed:`, error.message);
        throw error;
    }
    try {
        opt.onCatchupComplete?.(steps);
        // skip onStepsAdded if steps are undefined or empty
        if (!steps || steps.length === 0) {
            opt.updateMetadata(metadata);
            return false;
        }
        const version = fromVersion + steps.length;
        const stepsPayload = {
            version: version,
            steps: steps
        };
        opt.onStepsAdded(stepsPayload);
        opt.updateMetadata(metadata);
        const clientOutOfSync = Boolean(opt.clientId && $a77c90d12a129f65$export$f11b7fb226059e83(fromVersion, opt.getCurrentPmVersion(), steps, opt.clientId));
        if (clientOutOfSync) $a77c90d12a129f65$var$logObfuscatedSteps(steps, opt);
        return clientOutOfSync;
    } catch (error) {
        opt.analyticsHelper?.sendErrorEvent(error, 'Failed to apply catchupv2 result in the editor');
        $a77c90d12a129f65$var$logger(`Apply catchupv2 steps failed:`, error.message);
        throw error;
    }
};
const $a77c90d12a129f65$var$logObfuscatedSteps = (steps, opt)=>{
    const state = opt.getState?.();
    opt.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).OUT_OF_SYNC, (0, $flwxq.EVENT_STATUS).FAILURE, {
        obfuscatedSteps: (0, $4frCv.getObfuscatedSteps)(steps),
        obfuscatedDoc: state ? (0, $4frCv.getDocAdfWithObfuscation)(state.doc) : null,
        catchupReason: opt.reason
    });
};
const $a77c90d12a129f65$export$f11b7fb226059e83 = (fromVersion, currentVersion, steps, clientId)=>// If version number hasn't increased, and steps are not from our client, we're out of sync
    Boolean(fromVersion >= currentVersion && steps.some((step)=>step.clientId !== clientId));
module.exports["catchupv2"] = $a77c90d12a129f65$export$f32ba3eea9c226f8;

});

parcelRegister("3QAb4", function(module, exports) {

var $4frCv = parcelRequire("4frCv");

const $00615c02e15b50b9$var$logger = (0, $4frCv.createLogger)('documentService-queue', 'black');
class $00615c02e15b50b9$export$ec73f9ac65128a78 {
    queueSteps(data) {
        $00615c02e15b50b9$var$logger(`Queueing data for version "${data.version}".`);
        const orderedQueue = [
            ...this.queue,
            data
        ].sort((a, b)=>a.version > b.version ? 1 : -1);
        this.queue = orderedQueue;
    }
    constructor(){
        this.queuePaused = false;
        this.queue = [];
        this.getQueue = ()=>{
            return this.queue;
        };
        this.filterQueue = (condition)=>{
            this.queue = this.queue.filter(condition);
        };
        /**
     * Get whether the document service has stopped processing new steps whilst it carries out processes such as catchup.
     * Exposed for testing
     */ this.isPaused = ()=>this.queuePaused;
        this.pauseQueue = ()=>{
            this.queuePaused = true;
        };
        this.resumeQueue = ()=>{
            this.queuePaused = false;
        };
        this.shift = ()=>{
            return this.queue.shift();
        };
    }
}
module.exports["StepQueueState"] = $00615c02e15b50b9$export$ec73f9ac65128a78;

});

parcelRegister("c7fJY", function(module, exports) {

var $6rMOj = parcelRequire("6rMOj");


var $9NwnH = parcelRequire("9NwnH");

const $4989f81e598a2973$var$simplifySteps = (steps)=>{
    return steps.reduce((acc, step)=>{
        const lastStep = acc[acc.length - 1];
        if (lastStep) {
            const mergedStep = lastStep.merge(step);
            if (mergedStep) {
                acc[acc.length - 1] = mergedStep;
                return acc;
            }
        }
        return acc.concat(step);
    }, []);
};
function $4989f81e598a2973$var$findContentChanges(doc, steps) {
    let changes = (0, $6rMOj.ChangeSet).create(doc);
    let latestDoc = doc;
    $4989f81e598a2973$var$simplifySteps(steps).forEach((step, index)=>{
        const stepResult = step.apply(latestDoc);
        if (stepResult.failed !== null || stepResult.doc === null) return;
        latestDoc = stepResult.doc;
        changes = changes.addSteps(latestDoc, [
            step.getMap()
        ], {
            step: index
        });
    });
    return changes;
}
/**
 * Iterate through the changesets to find overlapping regions that indicate conflicting
 * changes
 */ const $4989f81e598a2973$var$getConflicts = ({ localChanges: localChanges, localDoc: localDoc, remoteChanges: remoteChanges, remoteDoc: remoteDoc })=>{
    const conflictingChanges = [];
    localChanges.changes.forEach((localChange)=>{
        remoteChanges.changes.forEach((remoteChange)=>{
            if (// Local change is inside remote change
            localChange.fromA >= remoteChange.fromA && localChange.toA <= remoteChange.toA || // Remote change is inside local change
            remoteChange.fromA >= localChange.fromA && remoteChange.toA <= localChange.toA || // Partial overlap with the end
            localChange.fromA >= remoteChange.fromA && localChange.fromA < remoteChange.toA && localChange.toA > remoteChange.toA || // Partial overlap with the start
            localChange.fromA < remoteChange.fromA && localChange.toA > remoteChange.fromA && localChange.toA <= remoteChange.toA || // One of the edges match
            localChange.fromA === remoteChange.toA || remoteChange.fromA === localChange.toA) {
                const remoteSlice = remoteDoc.slice(remoteChange.fromB, remoteChange.toB);
                const isDeletion = remoteSlice.size === 0;
                conflictingChanges.push({
                    from: Math.min(localChange.fromA, remoteChange.fromA),
                    to: Math.max(localChange.toA, remoteChange.toA),
                    // We only want to capture the exact slice deleted (without parents) so we can display and insert as expected
                    local: localDoc.slice(localChange.fromB, localChange.toB, !isDeletion),
                    remote: remoteSlice
                });
            }
        });
    });
    return conflictingChanges;
};
/**
 * This runs a collab rebase (that is run synchronously after this)
 * and extracts the local doc (before changes), remote doc and the
 * mapping to determine any conflicts.
 * See: `packages/editor/prosemirror-collab/src/index.ts`
 */ const $4989f81e598a2973$var$rebaseSteps = ({ localSteps: localSteps, remoteSteps: remoteSteps, tr: tr })=>{
    const originalMapsLength = tr.mapping.maps?.length;
    const originalDocsLength = tr.docs.length;
    (0, $9NwnH.rebaseSteps)(localSteps, remoteSteps, tr);
    /**
	 * `tr.docs` contains the documents before each change.
	 *
	 * To get "originalDoc" we need to get the document immediately after the local steps are inverted
	 * which is the equal to the number of local steps. If there are no remote steps this will be undefined and
	 * the most current document is appropriate
	 *
	 * To get the "remoteDoc" we need to get the document immediately after the local steps have been inverted
	 * and the remote steps re-applied. If there are no local steps or they are all lost in rebase this will be
	 * undefined and the most current document is appropriate
	 *
	 */ const originalDoc = tr.docs[originalDocsLength + localSteps.length] ?? tr.doc;
    const remoteDoc = tr.docs[originalDocsLength + localSteps.length + remoteSteps.length] ?? tr.doc;
    const mapStart = originalMapsLength + localSteps.length;
    return {
        mapStart: mapStart,
        originalDoc: originalDoc,
        remoteDoc: remoteDoc
    };
};
function $4989f81e598a2973$export$daa1eb0d72f5b266({ localSteps: localSteps, remoteSteps: remoteSteps, tr: tr }) {
    const localDoc = tr.doc;
    const { originalDoc: originalDoc, remoteDoc: remoteDoc, mapStart: mapStart } = $4989f81e598a2973$var$rebaseSteps({
        localSteps: localSteps,
        remoteSteps: remoteSteps,
        tr: tr
    });
    const localChanges = $4989f81e598a2973$var$findContentChanges(originalDoc, localSteps.map((s)=>s.step));
    const remoteChanges = $4989f81e598a2973$var$findContentChanges(originalDoc, remoteSteps);
    // This is the mapping between the original document and our final one which can be used to
    // map conflict positions (which are based on the original doc)
    const mapping = tr.mapping.slice(mapStart);
    // Find the overlapping conflicts - these are based on the positions of the original document so are
    // common to both local and remote documents.
    // The above mapping allows us to bring these positions to where they are in the current document
    const conflictingChanges = $4989f81e598a2973$var$getConflicts({
        localChanges: localChanges,
        localDoc: localDoc,
        remoteDoc: remoteDoc,
        remoteChanges: remoteChanges
    });
    const isConflictChange = (value)=>Boolean(value);
    // Prevent duplicate ranges occuring
    const seenInsertions = new Set();
    return {
        inserted: conflictingChanges.filter((i)=>i.remote.size !== 0).map((i)=>({
                ...i,
                from: mapping.map(i.from, -1),
                to: mapping.map(i.to)
            })).filter((i)=>{
            const identifier = `${i.from}-${i.to}`;
            if (seenInsertions.has(identifier)) return false;
            seenInsertions.add(identifier);
            return isConflictChange(i);
        }),
        deleted: conflictingChanges.filter((d)=>d.remote.size === 0).map((d)=>({
                ...d,
                from: mapping.map(d.from),
                to: mapping.map(d.to)
            })).filter(isConflictChange)
    };
}
module.exports["getConflictChanges"] = $4989f81e598a2973$export$daa1eb0d72f5b266;

});

parcelRegister("6rMOj", function(module, exports) {
function $4b1b2076c473e44f$var$typeID(type) {
    let cache = type.schema.cached.changeSetIDs || (type.schema.cached.changeSetIDs = Object.create(null));
    let id = cache[type.name];
    if (id == null) cache[type.name] = id = Object.keys(type.schema.nodes).indexOf(type.name) + 1;
    return id;
}
// The default token encoder, which encodes node open tokens are
// encoded as strings holding the node name, characters as their
// character code, and node close tokens as negative numbers.
const $4b1b2076c473e44f$var$DefaultEncoder = {
    encodeCharacter: (char)=>char,
    encodeNodeStart: (node)=>node.type.name,
    encodeNodeEnd: (node)=>-$4b1b2076c473e44f$var$typeID(node.type),
    compareTokens: (a, b)=>a === b
};
// Convert the given range of a fragment to tokens.
function $4b1b2076c473e44f$var$tokens(frag, encoder, start, end, target) {
    for(let i = 0, off = 0; i < frag.childCount; i++){
        let child = frag.child(i), endOff = off + child.nodeSize;
        let from = Math.max(off, start), to = Math.min(endOff, end);
        if (from < to) {
            if (child.isText) for(let j = from; j < to; j++)target.push(encoder.encodeCharacter(child.text.charCodeAt(j - off), child.marks));
            else if (child.isLeaf) target.push(encoder.encodeNodeStart(child));
            else {
                if (from == off) target.push(encoder.encodeNodeStart(child));
                $4b1b2076c473e44f$var$tokens(child.content, encoder, Math.max(off + 1, from) - off - 1, Math.min(endOff - 1, to) - off - 1, target);
                if (to == endOff) target.push(encoder.encodeNodeEnd(child));
            }
        }
        off = endOff;
    }
    return target;
}
// The code below will refuse to compute a diff with more than 5000
// insertions or deletions, which takes about 300ms to reach on my
// machine. This is a safeguard against runaway computations.
const $4b1b2076c473e44f$var$MAX_DIFF_SIZE = 5000;
// This obscure mess of constants computes the minimum length of an
// unchanged range (not at the start/end of the compared content). The
// idea is to make it higher in bigger replacements, so that you don't
// get a diff soup of coincidentally identical letters when replacing
// a paragraph.
function $4b1b2076c473e44f$var$minUnchanged(sizeA, sizeB) {
    return Math.min(15, Math.max(2, Math.floor(Math.max(sizeA, sizeB) / 10)));
}
function $4b1b2076c473e44f$var$computeDiff(fragA, fragB, range, encoder = $4b1b2076c473e44f$var$DefaultEncoder) {
    let tokA = $4b1b2076c473e44f$var$tokens(fragA, encoder, range.fromA, range.toA, []);
    let tokB = $4b1b2076c473e44f$var$tokens(fragB, encoder, range.fromB, range.toB, []);
    // Scan from both sides to cheaply eliminate work
    let start = 0, endA = tokA.length, endB = tokB.length;
    let cmp = encoder.compareTokens;
    while(start < tokA.length && start < tokB.length && cmp(tokA[start], tokB[start]))start++;
    if (start == tokA.length && start == tokB.length) return [];
    while(endA > start && endB > start && cmp(tokA[endA - 1], tokB[endB - 1]))endA--, endB--;
    // If the result is simple _or_ too big to cheaply compute, return
    // the remaining region as the diff
    if (endA == start || endB == start || endA == endB && endA == start + 1) return [
        range.slice(start, endA, start, endB)
    ];
    // This is an implementation of Myers' diff algorithm
    // See https://neil.fraser.name/writing/diff/myers.pdf and
    // https://blog.jcoglan.com/2017/02/12/the-myers-diff-algorithm-part-1/
    let lenA = endA - start, lenB = endB - start;
    let max = Math.min($4b1b2076c473e44f$var$MAX_DIFF_SIZE, lenA + lenB), off = max + 1;
    let history = [];
    let frontier = [];
    for(let len = off * 2, i = 0; i < len; i++)frontier[i] = -1;
    for(let size = 0; size <= max; size++){
        for(let diag = -size; diag <= size; diag += 2){
            let next = frontier[diag + 1 + max], prev = frontier[diag - 1 + max];
            let x = next < prev ? prev : next + 1, y = x + diag;
            while(x < lenA && y < lenB && cmp(tokA[start + x], tokB[start + y]))x++, y++;
            frontier[diag + max] = x;
            // Found a match
            if (x >= lenA && y >= lenB) {
                // Trace back through the history to build up a set of changed ranges.
                let diff = [], minSpan = $4b1b2076c473e44f$var$minUnchanged(endA - start, endB - start);
                // Used to add steps to a diff one at a time, back to front, merging
                // ones that are less than minSpan tokens apart
                let fromA = -1, toA = -1, fromB = -1, toB = -1;
                let add = (fA, tA, fB, tB)=>{
                    if (fromA > -1 && fromA < tA + minSpan) {
                        fromA = fA;
                        fromB = fB;
                    } else {
                        if (fromA > -1) diff.push(range.slice(fromA, toA, fromB, toB));
                        fromA = fA;
                        toA = tA;
                        fromB = fB;
                        toB = tB;
                    }
                };
                for(let i = size - 1; i >= 0; i--){
                    let next = frontier[diag + 1 + max], prev = frontier[diag - 1 + max];
                    if (next < prev) {
                        diag--;
                        x = prev + start;
                        y = x + diag;
                        add(x, x, y, y + 1);
                    } else {
                        diag++;
                        x = next + start;
                        y = x + diag;
                        add(x, x + 1, y, y);
                    }
                    frontier = history[i >> 1];
                }
                if (fromA > -1) diff.push(range.slice(fromA, toA, fromB, toB));
                return diff.reverse();
            }
        }
        // Since only either odd or even diagonals are read from each
        // frontier, we only copy them every other iteration.
        if (size % 2 == 0) history.push(frontier.slice());
    }
    // The loop exited, meaning the maximum amount of work was done.
    // Just return a change spanning the entire range.
    return [
        range.slice(start, endA, start, endB)
    ];
}
/**
Stores metadata for a part of a change.
*/ class $4b1b2076c473e44f$export$5f1714a13ed34c01 {
    /**
    @internal
    */ cut(length) {
        return length == this.length ? this : new $4b1b2076c473e44f$export$5f1714a13ed34c01(length, this.data);
    }
    /**
    @internal
    */ static slice(spans, from, to) {
        if (from == to) return $4b1b2076c473e44f$export$5f1714a13ed34c01.none;
        if (from == 0 && to == $4b1b2076c473e44f$export$5f1714a13ed34c01.len(spans)) return spans;
        let result = [];
        for(let i = 0, off = 0; off < to; i++){
            let span = spans[i], end = off + span.length;
            let overlap = Math.min(to, end) - Math.max(from, off);
            if (overlap > 0) result.push(span.cut(overlap));
            off = end;
        }
        return result;
    }
    /**
    @internal
    */ static join(a, b, combine) {
        if (a.length == 0) return b;
        if (b.length == 0) return a;
        let combined = combine(a[a.length - 1].data, b[0].data);
        if (combined == null) return a.concat(b);
        let result = a.slice(0, a.length - 1);
        result.push(new $4b1b2076c473e44f$export$5f1714a13ed34c01(a[a.length - 1].length + b[0].length, combined));
        for(let i = 1; i < b.length; i++)result.push(b[i]);
        return result;
    }
    /**
    @internal
    */ static len(spans) {
        let len = 0;
        for(let i = 0; i < spans.length; i++)len += spans[i].length;
        return len;
    }
    /**
    @internal
    */ constructor(/**
    The length of this span.
    */ length, /**
    The data associated with this span.
    */ data){
        this.length = length;
        this.data = data;
    }
}
/**
@internal
*/ $4b1b2076c473e44f$export$5f1714a13ed34c01.none = [];
/**
A replaced range with metadata associated with it.
*/ class $4b1b2076c473e44f$export$fb8e829a68c430bd {
    /**
    @internal
    */ get lenA() {
        return this.toA - this.fromA;
    }
    /**
    @internal
    */ get lenB() {
        return this.toB - this.fromB;
    }
    /**
    @internal
    */ slice(startA, endA, startB, endB) {
        if (startA == 0 && startB == 0 && endA == this.toA - this.fromA && endB == this.toB - this.fromB) return this;
        return new $4b1b2076c473e44f$export$fb8e829a68c430bd(this.fromA + startA, this.fromA + endA, this.fromB + startB, this.fromB + endB, $4b1b2076c473e44f$export$5f1714a13ed34c01.slice(this.deleted, startA, endA), $4b1b2076c473e44f$export$5f1714a13ed34c01.slice(this.inserted, startB, endB));
    }
    /**
    This merges two changesets (the end document of x should be the
    start document of y) into a single one spanning the start of x to
    the end of y.
    */ static merge(x, y, combine) {
        if (x.length == 0) return y;
        if (y.length == 0) return x;
        let result = [];
        // Iterate over both sets in parallel, using the middle coordinate
        // system (B in x, A in y) to synchronize.
        for(let iX = 0, iY = 0, curX = x[0], curY = y[0];;){
            if (!curX && !curY) return result;
            else if (curX && (!curY || curX.toB < curY.fromA)) {
                let off = iY ? y[iY - 1].toB - y[iY - 1].toA : 0;
                result.push(off == 0 ? curX : new $4b1b2076c473e44f$export$fb8e829a68c430bd(curX.fromA, curX.toA, curX.fromB + off, curX.toB + off, curX.deleted, curX.inserted));
                curX = iX++ == x.length ? null : x[iX];
            } else if (curY && (!curX || curY.toA < curX.fromB)) {
                let off = iX ? x[iX - 1].toB - x[iX - 1].toA : 0;
                result.push(off == 0 ? curY : new $4b1b2076c473e44f$export$fb8e829a68c430bd(curY.fromA - off, curY.toA - off, curY.fromB, curY.toB, curY.deleted, curY.inserted));
                curY = iY++ == y.length ? null : y[iY];
            } else {
                // The rules for merging ranges are that deletions from the
                // old set and insertions from the new are kept. Areas of the
                // middle document covered by a but not by b are insertions
                // from a that need to be added, and areas covered by b but
                // not a are deletions from b that need to be added.
                let pos = Math.min(curX.fromB, curY.fromA);
                let fromA = Math.min(curX.fromA, curY.fromA - (iX ? x[iX - 1].toB - x[iX - 1].toA : 0)), toA = fromA;
                let fromB = Math.min(curY.fromB, curX.fromB + (iY ? y[iY - 1].toB - y[iY - 1].toA : 0)), toB = fromB;
                let deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.none, inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.none;
                // Used to prevent appending ins/del range for the same Change twice
                let enteredX = false, enteredY = false;
                // Need to have an inner loop since any number of further
                // ranges might be touching this group
                for(;;){
                    let nextX = !curX ? 2e8 : pos >= curX.fromB ? curX.toB : curX.fromB;
                    let nextY = !curY ? 2e8 : pos >= curY.fromA ? curY.toA : curY.fromA;
                    let next = Math.min(nextX, nextY);
                    let inX = curX && pos >= curX.fromB, inY = curY && pos >= curY.fromA;
                    if (!inX && !inY) break;
                    if (inX && pos == curX.fromB && !enteredX) {
                        deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(deleted, curX.deleted, combine);
                        toA += curX.lenA;
                        enteredX = true;
                    }
                    if (inX && !inY) {
                        inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(inserted, $4b1b2076c473e44f$export$5f1714a13ed34c01.slice(curX.inserted, pos - curX.fromB, next - curX.fromB), combine);
                        toB += next - pos;
                    }
                    if (inY && pos == curY.fromA && !enteredY) {
                        inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(inserted, curY.inserted, combine);
                        toB += curY.lenB;
                        enteredY = true;
                    }
                    if (inY && !inX) {
                        deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(deleted, $4b1b2076c473e44f$export$5f1714a13ed34c01.slice(curY.deleted, pos - curY.fromA, next - curY.fromA), combine);
                        toA += next - pos;
                    }
                    if (inX && next == curX.toB) {
                        curX = iX++ == x.length ? null : x[iX];
                        enteredX = false;
                    }
                    if (inY && next == curY.toA) {
                        curY = iY++ == y.length ? null : y[iY];
                        enteredY = false;
                    }
                    pos = next;
                }
                if (fromA < toA || fromB < toB) result.push(new $4b1b2076c473e44f$export$fb8e829a68c430bd(fromA, toA, fromB, toB, deleted, inserted));
            }
        }
    }
    /**
    @internal
    */ constructor(/**
    The start of the range deleted/replaced in the old document.
    */ fromA, /**
    The end of the range in the old document.
    */ toA, /**
    The start of the range inserted in the new document.
    */ fromB, /**
    The end of the range in the new document.
    */ toB, /**
    Data associated with the deleted content. The length of these
    spans adds up to `this.toA - this.fromA`.
    */ deleted, /**
    Data associated with the inserted content. Length adds up to
    `this.toB - this.fromB`.
    */ inserted){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
        this.deleted = deleted;
        this.inserted = inserted;
    }
}
let $4b1b2076c473e44f$var$letter;
// If the runtime support unicode properties in regexps, that's a good
// source of info on whether something is a letter.
try {
    $4b1b2076c473e44f$var$letter = new RegExp("[\\p{Alphabetic}_]", "u");
} catch (_) {}
// Otherwise, we see if the character changes when upper/lowercased,
// or if it is part of these common single-case scripts.
const $4b1b2076c473e44f$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
function $4b1b2076c473e44f$var$isLetter(code) {
    if (code < 128) return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 79 && code <= 122;
    let ch = String.fromCharCode(code);
    if ($4b1b2076c473e44f$var$letter) return $4b1b2076c473e44f$var$letter.test(ch);
    return ch.toUpperCase() != ch.toLowerCase() || $4b1b2076c473e44f$var$nonASCIISingleCaseWordChar.test(ch);
}
// Convert a range of document into a string, so that we can easily
// access characters at a given position. Treat non-text tokens as
// spaces so that they aren't considered part of a word.
function $4b1b2076c473e44f$var$getText(frag, start, end) {
    let out = "";
    function convert(frag, start, end) {
        for(let i = 0, off = 0; i < frag.childCount; i++){
            let child = frag.child(i), endOff = off + child.nodeSize;
            let from = Math.max(off, start), to = Math.min(endOff, end);
            if (from < to) {
                if (child.isText) out += child.text.slice(Math.max(0, start - off), Math.min(child.text.length, end - off));
                else if (child.isLeaf) out += " ";
                else {
                    if (from == off) out += " ";
                    convert(child.content, Math.max(0, from - off - 1), Math.min(child.content.size, end - off));
                    if (to == endOff) out += " ";
                }
            }
            off = endOff;
        }
    }
    convert(frag, start, end);
    return out;
}
// The distance changes have to be apart for us to not consider them
// candidates for merging.
const $4b1b2076c473e44f$var$MAX_SIMPLIFY_DISTANCE = 30;
/**
Simplifies a set of changes for presentation. This makes the
assumption that having both insertions and deletions within a word
is confusing, and, when such changes occur without a word boundary
between them, they should be expanded to cover the entire set of
words (in the new document) they touch. An exception is made for
single-character replacements.
*/ function $4b1b2076c473e44f$export$eaf5c9077675701a(changes, doc) {
    let result = [];
    for(let i = 0; i < changes.length; i++){
        let end = changes[i].toB, start = i;
        while(i < changes.length - 1 && changes[i + 1].fromB <= end + $4b1b2076c473e44f$var$MAX_SIMPLIFY_DISTANCE)end = changes[++i].toB;
        $4b1b2076c473e44f$var$simplifyAdjacentChanges(changes, start, i + 1, doc, result);
    }
    return result;
}
function $4b1b2076c473e44f$var$simplifyAdjacentChanges(changes, from, to, doc, target) {
    let start = Math.max(0, changes[from].fromB - $4b1b2076c473e44f$var$MAX_SIMPLIFY_DISTANCE);
    let end = Math.min(doc.content.size, changes[to - 1].toB + $4b1b2076c473e44f$var$MAX_SIMPLIFY_DISTANCE);
    let text = $4b1b2076c473e44f$var$getText(doc.content, start, end);
    for(let i = from; i < to; i++){
        let startI = i, last = changes[i], deleted = last.lenA, inserted = last.lenB;
        while(i < to - 1){
            let next = changes[i + 1], boundary = false;
            let prevLetter = last.toB == end ? false : $4b1b2076c473e44f$var$isLetter(text.charCodeAt(last.toB - 1 - start));
            for(let pos = last.toB; !boundary && pos < next.fromB; pos++){
                let nextLetter = pos == end ? false : $4b1b2076c473e44f$var$isLetter(text.charCodeAt(pos - start));
                if ((!prevLetter || !nextLetter) && pos != changes[startI].fromB) boundary = true;
                prevLetter = nextLetter;
            }
            if (boundary) break;
            deleted += next.lenA;
            inserted += next.lenB;
            last = next;
            i++;
        }
        if (inserted > 0 && deleted > 0 && !(inserted == 1 && deleted == 1)) {
            let from = changes[startI].fromB, to = changes[i].toB;
            if (from < end && $4b1b2076c473e44f$var$isLetter(text.charCodeAt(from - start))) while(from > start && $4b1b2076c473e44f$var$isLetter(text.charCodeAt(from - 1 - start)))from--;
            if (to > start && $4b1b2076c473e44f$var$isLetter(text.charCodeAt(to - 1 - start))) while(to < end && $4b1b2076c473e44f$var$isLetter(text.charCodeAt(to - start)))to++;
            let joined = $4b1b2076c473e44f$var$fillChange(changes.slice(startI, i + 1), from, to);
            let last = target.length ? target[target.length - 1] : null;
            if (last && last.toA == joined.fromA) target[target.length - 1] = new $4b1b2076c473e44f$export$fb8e829a68c430bd(last.fromA, joined.toA, last.fromB, joined.toB, last.deleted.concat(joined.deleted), last.inserted.concat(joined.inserted));
            else target.push(joined);
        } else for(let j = startI; j <= i; j++)target.push(changes[j]);
    }
    return changes;
}
function $4b1b2076c473e44f$var$combine(a, b) {
    return a === b ? a : null;
}
function $4b1b2076c473e44f$var$fillChange(changes, fromB, toB) {
    let fromA = changes[0].fromA - (changes[0].fromB - fromB);
    let last = changes[changes.length - 1];
    let toA = last.toA + (toB - last.toB);
    let deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.none, inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.none;
    let delData = (changes[0].deleted.length ? changes[0].deleted : changes[0].inserted)[0].data;
    let insData = (changes[0].inserted.length ? changes[0].inserted : changes[0].deleted)[0].data;
    for(let posA = fromA, posB = fromB, i = 0;; i++){
        let next = i == changes.length ? null : changes[i];
        let endA = next ? next.fromA : toA, endB = next ? next.fromB : toB;
        if (endA > posA) deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(deleted, [
            new $4b1b2076c473e44f$export$5f1714a13ed34c01(endA - posA, delData)
        ], $4b1b2076c473e44f$var$combine);
        if (endB > posB) inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(inserted, [
            new $4b1b2076c473e44f$export$5f1714a13ed34c01(endB - posB, insData)
        ], $4b1b2076c473e44f$var$combine);
        if (!next) break;
        deleted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(deleted, next.deleted, $4b1b2076c473e44f$var$combine);
        inserted = $4b1b2076c473e44f$export$5f1714a13ed34c01.join(inserted, next.inserted, $4b1b2076c473e44f$var$combine);
        if (deleted.length) delData = deleted[deleted.length - 1].data;
        if (inserted.length) insData = inserted[inserted.length - 1].data;
        posA = next.toA;
        posB = next.toB;
    }
    return new $4b1b2076c473e44f$export$fb8e829a68c430bd(fromA, toA, fromB, toB, deleted, inserted);
}
/**
A change set tracks the changes to a document from a given point
in the past. It condenses a number of step maps down to a flat
sequence of replacements, and simplifies replacments that
partially undo themselves by comparing their content.
*/ class $4b1b2076c473e44f$export$29d7fbdcb1f8b71c {
    /**
    Computes a new changeset by adding the given step maps and
    metadata (either as an array, per-map, or as a single value to be
    associated with all maps) to the current set. Will not mutate the
    old set.
    
    Note that due to simplification that happens after each add,
    incrementally adding steps might create a different final set
    than adding all those changes at once, since different document
    tokens might be matched during simplification depending on the
    boundaries of the current changed ranges.
    */ addSteps(newDoc, maps, data) {
        // This works by inspecting the position maps for the changes,
        // which indicate what parts of the document were replaced by new
        // content, and the size of that new content. It uses these to
        // build up Change objects.
        //
        // These change objects are put in sets and merged together using
        // Change.merge, giving us the changes created by the new steps.
        // Those changes can then be merged with the existing set of
        // changes.
        //
        // For each change that was touched by the new steps, we recompute
        // a diff to try to minimize the change by dropping matching
        // pieces of the old and new document from the change.
        let stepChanges = [];
        // Add spans for new steps.
        for(let i = 0; i < maps.length; i++){
            let d = Array.isArray(data) ? data[i] : data;
            let off = 0;
            maps[i].forEach((fromA, toA, fromB, toB)=>{
                stepChanges.push(new $4b1b2076c473e44f$export$fb8e829a68c430bd(fromA + off, toA + off, fromB, toB, fromA == toA ? $4b1b2076c473e44f$export$5f1714a13ed34c01.none : [
                    new $4b1b2076c473e44f$export$5f1714a13ed34c01(toA - fromA, d)
                ], fromB == toB ? $4b1b2076c473e44f$export$5f1714a13ed34c01.none : [
                    new $4b1b2076c473e44f$export$5f1714a13ed34c01(toB - fromB, d)
                ]));
                off = toB - fromB - (toA - fromA);
            });
        }
        if (stepChanges.length == 0) return this;
        let newChanges = $4b1b2076c473e44f$var$mergeAll(stepChanges, this.config.combine);
        let changes = $4b1b2076c473e44f$export$fb8e829a68c430bd.merge(this.changes, newChanges, this.config.combine);
        let updated = changes;
        // Minimize changes when possible
        for(let i = 0; i < updated.length; i++){
            let change = updated[i];
            if (change.fromA == change.toA || change.fromB == change.toB || // Only look at changes that touch newly added changed ranges
            !newChanges.some((r)=>r.toB > change.fromB && r.fromB < change.toB)) continue;
            let diff = $4b1b2076c473e44f$var$computeDiff(this.config.doc.content, newDoc.content, change, this.config.encoder);
            // Fast path: If they are completely different, don't do anything
            if (diff.length == 1 && diff[0].fromB == 0 && diff[0].toB == change.toB - change.fromB) continue;
            if (updated == changes) updated = changes.slice();
            if (diff.length == 1) updated[i] = diff[0];
            else {
                updated.splice(i, 1, ...diff);
                i += diff.length - 1;
            }
        }
        return new $4b1b2076c473e44f$export$29d7fbdcb1f8b71c(this.config, updated);
    }
    /**
    The starting document of the change set.
    */ get startDoc() {
        return this.config.doc;
    }
    /**
    Map the span's data values in the given set through a function
    and construct a new set with the resulting data.
    */ map(f) {
        let mapSpan = (span)=>{
            let newData = f(span);
            return newData === span.data ? span : new $4b1b2076c473e44f$export$5f1714a13ed34c01(span.length, newData);
        };
        return new $4b1b2076c473e44f$export$29d7fbdcb1f8b71c(this.config, this.changes.map((ch)=>{
            return new $4b1b2076c473e44f$export$fb8e829a68c430bd(ch.fromA, ch.toA, ch.fromB, ch.toB, ch.deleted.map(mapSpan), ch.inserted.map(mapSpan));
        }));
    }
    /**
    Compare two changesets and return the range in which they are
    changed, if any. If the document changed between the maps, pass
    the maps for the steps that changed it as second argument, and
    make sure the method is called on the old set and passed the new
    set. The returned positions will be in new document coordinates.
    */ changedRange(b, maps) {
        if (b == this) return null;
        let touched = maps && $4b1b2076c473e44f$var$touchedRange(maps);
        let moved = touched ? touched.toB - touched.fromB - (touched.toA - touched.fromA) : 0;
        function map(p) {
            return !touched || p <= touched.fromA ? p : p + moved;
        }
        let from = touched ? touched.fromB : 2e8, to = touched ? touched.toB : -200000000;
        function add(start, end = start) {
            from = Math.min(start, from);
            to = Math.max(end, to);
        }
        let rA = this.changes, rB = b.changes;
        for(let iA = 0, iB = 0; iA < rA.length && iB < rB.length;){
            let rangeA = rA[iA], rangeB = rB[iB];
            if (rangeA && rangeB && $4b1b2076c473e44f$var$sameRanges(rangeA, rangeB, map)) {
                iA++;
                iB++;
            } else if (rangeB && (!rangeA || map(rangeA.fromB) >= rangeB.fromB)) {
                add(rangeB.fromB, rangeB.toB);
                iB++;
            } else {
                add(map(rangeA.fromB), map(rangeA.toB));
                iA++;
            }
        }
        return from <= to ? {
            from: from,
            to: to
        } : null;
    }
    /**
    Create a changeset with the given base object and configuration.
    
    The `combine` function is used to compare and combine metadata—it
    should return null when metadata isn't compatible, and a combined
    version for a merged range when it is.
    
    When given, a token encoder determines how document tokens are
    serialized and compared when diffing the content produced by
    changes. The default is to just compare nodes by name and text
    by character, ignoring marks and attributes.
    */ static create(doc, combine = (a, b)=>a === b ? a : null, tokenEncoder = $4b1b2076c473e44f$var$DefaultEncoder) {
        return new $4b1b2076c473e44f$export$29d7fbdcb1f8b71c({
            combine: combine,
            doc: doc,
            encoder: tokenEncoder
        }, []);
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ config, /**
    Replaced regions.
    */ changes){
        this.config = config;
        this.changes = changes;
    }
}
/**
Exported for testing @internal
*/ $4b1b2076c473e44f$export$29d7fbdcb1f8b71c.computeDiff = $4b1b2076c473e44f$var$computeDiff;
// Divide-and-conquer approach to merging a series of ranges.
function $4b1b2076c473e44f$var$mergeAll(ranges, combine, start = 0, end = ranges.length) {
    if (end == start + 1) return [
        ranges[start]
    ];
    let mid = start + end >> 1;
    return $4b1b2076c473e44f$export$fb8e829a68c430bd.merge($4b1b2076c473e44f$var$mergeAll(ranges, combine, start, mid), $4b1b2076c473e44f$var$mergeAll(ranges, combine, mid, end), combine);
}
function $4b1b2076c473e44f$var$endRange(maps) {
    let from = 2e8, to = -200000000;
    for(let i = 0; i < maps.length; i++){
        let map = maps[i];
        if (from != 2e8) {
            from = map.map(from, -1);
            to = map.map(to, 1);
        }
        map.forEach((_s, _e, start, end)=>{
            from = Math.min(from, start);
            to = Math.max(to, end);
        });
    }
    return from == 2e8 ? null : {
        from: from,
        to: to
    };
}
function $4b1b2076c473e44f$var$touchedRange(maps) {
    let b = $4b1b2076c473e44f$var$endRange(maps);
    if (!b) return null;
    let a = $4b1b2076c473e44f$var$endRange(maps.map((m)=>m.invert()).reverse());
    return {
        fromA: a.from,
        toA: a.to,
        fromB: b.from,
        toB: b.to
    };
}
function $4b1b2076c473e44f$var$sameRanges(a, b, map) {
    return map(a.fromB) == b.fromB && map(a.toB) == b.toB && $4b1b2076c473e44f$var$sameSpans(a.deleted, b.deleted) && $4b1b2076c473e44f$var$sameSpans(a.inserted, b.inserted);
}
function $4b1b2076c473e44f$var$sameSpans(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i].length != b[i].length || a[i].data !== b[i].data) return false;
    return true;
}
module.exports["simplifyChanges"] = $4b1b2076c473e44f$export$eaf5c9077675701a;
module.exports["ChangeSet"] = $4b1b2076c473e44f$export$29d7fbdcb1f8b71c;

});

parcelRegister("bxMv2", function(module, exports) {
class $a01622ae08ff8e07$export$e38ee16b142fca71 {
    updateDocument() {}
    onRestore() {}
    onStepsAdded() {}
    onStepRejectedError() {}
    send() {}
    sendStepsFromCurrentState() {}
    throttledCatchupv2() {}
    getCurrentState() {
        return Promise.resolve({});
    }
    getFinalAcknowledgedState(reason) {
        return Promise.resolve({});
    }
    getIsNamespaceLocked() {
        return false;
    }
    getUnconfirmedSteps() {
        return undefined;
    }
    getUnconfirmedStepsOrigins() {
        return undefined;
    }
    getCurrentPmVersion() {
        return -1;
    }
    constructor(){
        this.setup = ()=>{
            return this;
        };
        this.onErrorHandled = ()=>{};
    }
}
module.exports["NullDocumentService"] = $a01622ae08ff8e07$export$e38ee16b142fca71;

});

parcelRegister("eSqCh", function(module, exports) {

var $4frCv = parcelRequire("4frCv");

const $da3d455a97c05426$var$logger = (0, $4frCv.createLogger)('Provider', 'orange');
class $da3d455a97c05426$export$a3879ef7b3971bae {
    constructor(isNamespaceLocked = false){
        this.isNamespaceLocked = isNamespaceLocked;
        // Primitive values are always copied
        this.getIsNamespaceLocked = ()=>this.isNamespaceLocked;
        /**
     * ESS-2916 namespace status event- lock/unlock
     */ // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.onNamespaceStatusChanged = async ({ isLocked: isLocked, waitTimeInMs: waitTimeInMs, timestamp: timestamp })=>{
            const start = Date.now();
            $da3d455a97c05426$var$logger(`Received a namespace status changed event `, {
                isLocked: isLocked,
                waitTimeInMs: waitTimeInMs,
                timestamp: timestamp
            });
            if (isLocked && waitTimeInMs) {
                this.isNamespaceLocked = true;
                $da3d455a97c05426$var$logger(`Received a namespace status change event `, {
                    isLocked: isLocked
                });
                // To protect the collab editing process from locked out due to BE
                setTimeout(()=>{
                    $da3d455a97c05426$var$logger(`The namespace lock has expired`, {
                        waitTime: Date.now() - start,
                        timestamp: timestamp
                    });
                    this.isNamespaceLocked = false;
                }, waitTimeInMs);
                return;
            }
            this.isNamespaceLocked = false;
            $da3d455a97c05426$var$logger(`The page lock has expired`);
        };
    }
}
module.exports["NamespaceService"] = $da3d455a97c05426$export$a3879ef7b3971bae;

});

parcelRegister("pyHw9", function(module, exports) {

var $7W8Hz = parcelRequire("7W8Hz");


var $flwxq = parcelRequire("flwxq");


var $gVzjB = parcelRequire("gVzjB");


var $8Gmho = parcelRequire("8Gmho");


var $fFg2r = parcelRequire("fFg2r");


var $4frCv = parcelRequire("4frCv");

const $702978599b8486be$var$logger = (0, $4frCv.createLogger)('PresenceService', 'pink');
const $702978599b8486be$var$SEND_PRESENCE_INTERVAL = 150000; // 150 seconds
const $702978599b8486be$var$DEFAULT_FETCH_USERS_INTERVAL = 500; // 0.5 second
const $702978599b8486be$var$UNIDENTIFIED = 'unidentified';
const $702978599b8486be$export$b293c70097dddf3c = 'single';
const $702978599b8486be$export$e39d952916d6fd50 = 'collab';
class $702978599b8486be$export$b15b55f2d386264 {
    /**
   * Called on receiving steps, emits each step's telepointer
   * @param steps Steps to extract telepointers from
   * @example
   */ emitTelepointersFromSteps(steps) {
        steps.forEach((step)=>{
            const event = (0, $gVzjB.telepointerFromStep)(this.participantsState.getParticipants(), step);
            if (event) this.emitTelepointer(event, 'emitting telepointers from steps');
        });
    }
    /**
   * Wrapper function to emit with error handling and analytics
   * @param data Data to emit
   * @param errorMessage Error message for analytics
   * @example
   */ emitPresenceActivityChange(data, errorMessage) {
        try {
            this.emit('presence:changed', data);
        } catch (error) {
            // We don't want to throw errors for Presence features as they tend to self-restore
            this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
        }
    }
    /**
   * constructor
   *
   * @param analyticsHelper
   * @param participantsState
   * @param emit
   * @param getUser
   * @param batchProps
   * @param channelBroadcast
   * @param sendPresenceJoined
   * @param getPresenceData
   * @param setUserId
   * @param getAIProviderActiveIds
   * @param fetchAnonymousAsset
   * @example
   */ constructor(analyticsHelper, participantsState = new (0, $fFg2r.ParticipantsState)(), emit, getUser, batchProps, channelBroadcast, sendPresenceJoined, getPresenceData, setUserId, getAIProviderActiveIds, fetchAnonymousAsset){
        this.analyticsHelper = analyticsHelper;
        this.participantsState = participantsState;
        this.emit = emit;
        this.getUser = getUser;
        this.batchProps = batchProps;
        this.channelBroadcast = channelBroadcast;
        this.sendPresenceJoined = sendPresenceJoined;
        this.getPresenceData = getPresenceData;
        this.setUserId = setUserId;
        this.getAIProviderActiveIds = getAIProviderActiveIds;
        this.fetchAnonymousAsset = fetchAnonymousAsset;
        this.participantUpdateTimeout = void 0;
        this.presenceUpdateTimeout = void 0;
        this.presenceFetchTimeout = void 0;
        this.currentlyPollingFetchUsers = true;
        this.hasBatchFetchError = false;
        this.sendPresenceActivityChanged = ()=>{
            this.sendPresence();
        };
        this.sendAIProviderChanged = (payload)=>{
            if (payload.providerId) {
                for(const propKey in payload.permit)if (payload.permit.hasOwnProperty(propKey)) payload.permit[propKey] = false;
                const presencePayload = this.buildAIProviderPresencePayload(payload.providerId);
                if (payload.action === 'add') this.sendAIProviderParticipantUpdated(presencePayload);
                else if (payload.action === 'remove') this.sendAIProviderParticipantLeft(presencePayload);
            }
        };
        this.buildAIProviderPresencePayload = (providerId)=>{
            const defaultPresenceData = this.getPresenceData();
            const presencePayload = {
                sessionId: `${providerId}::${defaultPresenceData.sessionId}`,
                userId: providerId,
                clientId: `${providerId}::${defaultPresenceData.clientId}`,
                permit: {
                    isPermittedToComment: false,
                    isPermittedToEdit: false,
                    isPermittedToView: false
                },
                timestamp: Date.now()
            };
            return presencePayload;
        };
        this.sendAIProviderParticipantUpdated = (payload)=>{
            this.channelBroadcast('participant:updated', payload);
        };
        this.sendAIProviderParticipantLeft = (payload)=>{
            this.channelBroadcast('participant:left', payload);
        };
        // Refresh current AI providers
        this.sendAIProvidersPresence = ()=>{
            if (this.getAIProviderActiveIds) this.getAIProviderActiveIds().forEach((aiProviderId)=>{
                const presenceData = this.buildAIProviderPresencePayload(aiProviderId);
                this.sendAIProviderParticipantUpdated(presenceData);
            });
        };
        this.hasPresenceActivityChanged = (previous, current)=>{
            return previous.presenceActivity !== current.presenceActivity;
        };
        this.handleAnonymousUser = async (payload)=>{
            const { sessionId: sessionId } = payload;
            const previousParticipant = this.participantsState.getBySessionId(sessionId);
            let asset;
            let name = previousParticipant?.name ?? '';
            if (!previousParticipant && this.fetchAnonymousAsset) {
                try {
                    asset = await this.fetchAnonymousAsset(payload.presenceId);
                } catch (error) {
                    this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching anonymous assets');
                }
                name = asset?.name ?? name;
            }
            const participant = {
                ...payload,
                lastActive: payload.timestamp,
                name: name,
                avatar: previousParticipant?.avatar ?? asset?.src ?? '',
                email: '',
                userId: $702978599b8486be$var$UNIDENTIFIED,
                isHydrated: true
            };
            this.participantsState.setBySessionId(sessionId, participant);
            this.emitPresence({
                joined: [
                    participant
                ]
            }, 'handling updated anonymous participant');
        };
        /**
     * Carries out 3 things: 1) enriches the participant with user data, 2) updates the participantsState, 3) emits the presence event
     * @param payload Payload from incoming socket event
     * @example
     */ this.updateParticipantEager = async (payload)=>{
            const { userId: userId } = payload;
            if (!userId || userId === $702978599b8486be$var$UNIDENTIFIED) {
                await this.handleAnonymousUser(payload);
                return;
            }
            let participant;
            // getUser is a failable callback, hence try-catch
            try {
                participant = await (0, $8Gmho.createParticipantFromPayload)(// userId _must_ be defined, this lets the compiler know
                {
                    ...payload,
                    userId: userId
                }, this.getUser);
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while enriching participant');
            }
            if (!participant) return;
            const previousParticipant = this.participantsState.getBySessionId(participant.sessionId);
            this.participantsState.setBySessionId(participant.sessionId, participant);
            if (previousParticipant) {
                if (this.hasPresenceActivityChanged(previousParticipant, participant)) this.emitPresenceActivityChange({
                    type: 'participant:activity',
                    activity: participant.presenceActivity
                }, 'handling participant activity changed event');
                return;
            }
            // Only emit the joined presence event if this is a new participant
            this.emitPresence({
                joined: [
                    participant
                ]
            }, 'handling participant updated event');
        };
        /**
     * Will update participant state without attempting to hydrate the participant, which is handled in {@link #batchFetchUsers}
     * Here's the TLDR of what this method handles
     *
     * 1. If participant that joined is anonymous, update state, emit event and return
     * 2. If incoming participant is new, update state and emit event
     * 3. If incoming participant is not new, update previous state with new values (timestamp, activity)
     *
     * @param payload Payload from incoming socket event
     * @example
     */ this.updateParticipantLazy = async (payload)=>{
            const { userId: userId, sessionId: sessionId } = payload;
            // anonymous users always skip hydration but are marked as hydrated since we don't want to attempt to fetch data
            // this can cause interesting behavior if batchProps.participantsLimit exists
            // for example if limit = 5 and we've hydrated 5 real users and 2 anonymous users join, it'll look like we've hydrated 7 users
            if (!userId || userId === $702978599b8486be$var$UNIDENTIFIED) {
                await this.handleAnonymousUser(payload);
                return;
            }
            const previousParticipant = this.participantsState.getBySessionId(sessionId);
            if (!previousParticipant) {
                const participant = {
                    ...payload,
                    lastActive: payload.timestamp,
                    name: '',
                    avatar: '',
                    email: '',
                    userId: userId
                };
                this.participantsState.setBySessionId(sessionId, participant);
                if ((0, $4frCv.isAIProviderID)(userId)) {
                    this.emitPresence({
                        joined: [
                            participant
                        ]
                    }, 'handling updated new agent lazy');
                    return;
                }
                // prevent running multiple debounces concurrently
                if (!this.currentlyPollingFetchUsers) this.batchFetchUsers();
                // while this doesn't completely eliminate extra events from firing, it does help reduce it.
                // batchFetchUsers will always emitPresence when no participantsLimit is present;
                // however, if the limit has been reached, we need to ensure we emit the joined participants
                // current alternatives to this logic would add even more complexity
                if (this.batchProps?.participantsLimit) this.emitPresence({
                    joined: [
                        participant
                    ]
                }, 'handling updated new participant lazy');
                return;
            }
            // would handle activity and lastActive changes
            const participant = {
                ...previousParticipant,
                presenceActivity: payload.presenceActivity,
                lastActive: payload.timestamp
            };
            if (this.hasPresenceActivityChanged(previousParticipant, participant)) {
                this.participantsState.setBySessionId(sessionId, participant);
                this.emitPresenceActivityChange({
                    type: 'participant:activity',
                    activity: participant.presenceActivity
                }, 'handling participant activity changed event');
            }
            return;
        };
        this.onParticipantUpdated = async (payload)=>{
            if (this.batchProps) this.updateParticipantLazy(payload);
            else await this.updateParticipantEager(payload);
        };
        /**
     * Called when a participant leaves the session.
     * We emit the `presence` event to update the active avatars in the editor.
     * @param payload
     * @example
     */ this.onParticipantLeft = (payload)=>{
            let sessionId = payload.sessionId;
            // When an agent leaves a session, the backend service returns the original user's
            // session ID accompanied by a payload containing the agent's session ID.
            // If the user session leaves, we also want to remove all agent sessions associated.
            if (payload?.data?.sessionId && (0, $4frCv.isAIProviderID)(payload.data.sessionId)) sessionId = payload.data.sessionId;
            else {
                const associatedAgents = this.getAIProviderParticipants().filter((ap)=>ap.sessionId.endsWith(sessionId));
                associatedAgents.forEach((agent)=>{
                    this.onParticipantLeft({
                        sessionId: sessionId,
                        timestamp: payload.timestamp,
                        data: agent,
                        userId: undefined,
                        clientId: ''
                    });
                });
            }
            this.participantsState.removeBySessionId(sessionId);
            this.emitPresence({
                left: [
                    {
                        sessionId: sessionId
                    }
                ]
            }, 'participant leaving');
        };
        this.disconnect = (reason, sessionId)=>{
            const left = this.participantsState.getParticipants();
            this.participantsState.clear();
            try {
                this.emit('disconnected', {
                    reason: (0, $7W8Hz.disconnectedReasonMapper)(reason),
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sid: sessionId
                });
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while emitting disconnected data');
            }
            if (left.length) this.emitPresence({
                left: left
            }, 'emitting presence update on disconnect');
        };
        /**
     * Updates when users were last active
     * @param userIds Users in most recent steps
     * @example
     */ this.updateLastActive = (userIds = [])=>this.participantsState.updateLastActive(Date.now(), userIds);
        /**
     * Called when we receive a telepointer update from another
     * participant.
     * @param payload
     * @param thisSessionId
     * @example
     */ this.onParticipantTelepointer = (payload, thisSessionId)=>{
            const { sessionId: sessionId, selection: selection, timestamp: timestamp } = payload;
            const participant = this.participantsState.getBySessionId(sessionId);
            if (sessionId === thisSessionId || // Ignore old telepointer events
            participant && participant.lastActive > timestamp) return;
            const userId = payload.userId ? [
                payload.userId
            ] : undefined;
            // Set last active
            this.updateLastActive(userId);
            this.emitTelepointer({
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            }, 'handling participant telepointer event');
        };
        /**
     * Every 5 minutes (PARTICIPANT_UPDATE_INTERVAL), removes inactive participants and emits the update to other participants.
     * Needs to be kicked off in the Provider.
     * @param sessionId SessionId from provider's connection
     * @example
     */ this.startInactiveRemover = (sessionId)=>{
            clearTimeout(this.participantUpdateTimeout);
            try {
                this.filterInactive(sessionId);
            } catch (err) {
                this.analyticsHelper?.sendErrorEvent(err, 'Failed filtering inactive participants');
            }
            this.participantUpdateTimeout = window.setTimeout(()=>this.startInactiveRemover(sessionId), (0, $8Gmho.PARTICIPANT_UPDATE_INTERVAL));
        };
        this.enrichParticipants = async (props)=>{
            try {
                const participants = await (0, $8Gmho.fetchParticipants)(this.participantsState, props);
                if (participants.length) this.emitPresence({
                    joined: participants
                }, 'handling participant updated event');
            } catch (err) {
                props.onError?.(err);
                this.hasBatchFetchError = true;
                this.analyticsHelper?.sendErrorEvent(err, 'Failed while fetching participants');
            }
        };
        /**
     * a debounce so we can wait until participants join before hydrating the user and perform batch calls in a timely manner.
     *
     * if {@link BatchProps#participantsLimit} is supplied
     *  1. Fetch users until we've reached the participantsLimit
     *  2. If there are no more participants to hydrate and we haven't reached the participantsLimit, stop polling
     *  3. If we've reached our participantLimit, stop polling
     *
     * if no {@link BatchProps#participantsLimit} is supplied
     *  1. Fetch users until there are no more participants to hydrate
     * @example
     */ this.batchFetchUsers = async ()=>{
            if (!this.batchProps) return;
            if (this.hasBatchFetchError) {
                // no retry logic yet
                $702978599b8486be$var$logger('Cannot continue to fetch users due to fetch error');
                clearTimeout(this.presenceFetchTimeout);
                return;
            }
            this.currentlyPollingFetchUsers = true;
            clearTimeout(this.presenceFetchTimeout);
            const { debounceTime: debounceTime, participantsLimit: participantsLimit } = this.batchProps;
            if (participantsLimit) {
                const size = this.participantsState.getUniqueParticipants({
                    isHydrated: true
                }).length;
                if (size < participantsLimit) {
                    await this.enrichParticipants({
                        ...this.batchProps,
                        batchSize: participantsLimit
                    });
                    this.currentlyPollingFetchUsers = this.participantsState.hasMoreParticipantsToHydrate();
                } else this.currentlyPollingFetchUsers = false;
            } else if (!participantsLimit) {
                await this.enrichParticipants(this.batchProps);
                this.currentlyPollingFetchUsers = this.participantsState.hasMoreParticipantsToHydrate();
            }
            if (this.currentlyPollingFetchUsers) this.presenceFetchTimeout = window.setTimeout(()=>this.batchFetchUsers(), debounceTime ?? $702978599b8486be$var$DEFAULT_FETCH_USERS_INTERVAL);
        };
        /**
     * We want to give some time for users to initially join before attempting to fetch users
     * otherwise we'll always make at least 2 calls if there's more than 1 participant
     * @example
     */ this.initializeFirstBatchFetchUsers = async ()=>{
            await new Promise((r)=>window.setTimeout(r, this.batchProps?.debounceTime ?? $702978599b8486be$var$DEFAULT_FETCH_USERS_INTERVAL));
            this.batchFetchUsers();
        };
        /**
     * Keep list of participants up to date. Filter out inactive users etc.
     * @param sessionId
     * @example
     */ this.filterInactive = (sessionId)=>{
            const now = Date.now();
            const left = this.participantsState.getParticipants().filter((p)=>p.sessionId !== sessionId && now - p.lastActive > (0, $8Gmho.PARTICIPANT_UPDATE_INTERVAL));
            left.forEach((p)=>this.participantsState.removeBySessionId(p.sessionId));
            left.length && this.emitPresence({
                left: left
            }, 'filtering inactive participants');
        };
        /**
     * Wrapper function to emit with error handling and analytics
     * @param data Data to emit
     * @param emit Emit function from Provider
     * @param errorMessage
     * @example
     */ this.emitPresence = (data, errorMessage)=>{
            try {
                this.emit('presence', data);
                this.analyticsHelper?.sendActionEvent((0, $flwxq.EVENT_ACTION).UPDATE_PARTICIPANTS, (0, $flwxq.EVENT_STATUS).SUCCESS, {
                    participants: this.participantsState.size()
                });
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
            }
        };
        /**
     * Wrapper function to emit with error handling and analytics
     * @param data Data to emit
     * @param emit Emit function from Provider
     * @param errorMessage
     * @example
     */ this.emitTelepointer = (data, errorMessage)=>{
            try {
                this.emit('telepointer', data);
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
            }
        };
        /**
     * Used when the provider is disconnected or destroyed to prevent perpetual timers from continuously running
     * @example
     */ this.clearTimers = ()=>{
            clearTimeout(this.participantUpdateTimeout);
            clearTimeout(this.presenceFetchTimeout);
        };
        this.sendPresence = ()=>{
            try {
                clearTimeout(this.presenceUpdateTimeout);
                const data = this.getPresenceData();
                this.channelBroadcast('participant:updated', data);
                this.presenceUpdateTimeout = window.setTimeout(()=>this.sendPresence(), $702978599b8486be$var$SEND_PRESENCE_INTERVAL);
                // Expose existing AI providers to the newly joined user
                this.sendAIProvidersPresence();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while sending presence');
            }
        };
        /**
     * Called when a participant joins the session.
     *
     * We keep track of participants internally, and emit the `presence` event to update
     * the active avatars in the editor.
     * This method will be triggered from backend to notify all participants to exchange presence
     * @param payload
     * @example
     */ this.onPresenceJoined = (payload)=>{
            try {
                $702978599b8486be$var$logger('Participant joined with session: ', payload.sessionId);
                // This expose existing users to the newly joined user
                this.sendPresence();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while joining presence');
            }
        };
        /**
     * Called when the current user joins the session.
     *
     * This will send both a 'presence' event and a 'participant:updated' event.
     * This updates both the avatars and the participants list.
     * @param payload
     * @example
     */ this.onPresence = (payload)=>{
            try {
                $702978599b8486be$var$logger('onPresence userId: ', payload.userId);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.setUserId(payload.userId);
                this.sendPresence();
                this.sendPresenceJoined();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while receiving presence');
            }
        };
        this.getParticipants = ()=>{
            return this.participantsState.getParticipants();
        };
        this.getUniqueParticipantSize = ()=>{
            return this.participantsState.getUniqueParticipantSize();
        };
        this.getUniqueParticipants = (filter)=>{
            return this.participantsState.getUniqueParticipants(filter);
        };
        this.getAIProviderParticipants = ()=>{
            return this.participantsState.getAIProviderParticipants();
        };
        this.getCollabMode = ()=>{
            return this.participantsState.size() > 1 ? $702978599b8486be$export$e39d952916d6fd50 : $702978599b8486be$export$b293c70097dddf3c;
        };
    }
}
module.exports["ParticipantsService"] = $702978599b8486be$export$b15b55f2d386264;

});

parcelRegister("8Gmho", function(module, exports) {
const $0320d5ed697c9c23$export$488470c175a39c99 = 300000; // 300 seconds
const $0320d5ed697c9c23$var$DEFAULT_BATCH_FETCH_SIZE = 25;
const $0320d5ed697c9c23$export$8c7e237b2e82904f = async (// userId must be defined, unlike in PresencePayload
payload, getUser)=>{
    const { sessionId: sessionId, timestamp: timestamp, clientId: clientId, userId: userId, permit: permit, presenceId: presenceId, presenceActivity: presenceActivity } = payload;
    const user = await getUser?.(userId);
    const participant = {
        name: user?.name || '',
        avatar: user?.avatar || '',
        email: user?.email || '',
        sessionId: sessionId,
        lastActive: timestamp,
        userId: userId,
        clientId: clientId,
        permit: permit,
        isGuest: user?.isGuest,
        presenceId: presenceId,
        presenceActivity: presenceActivity,
        isHydrated: !!user
    };
    return participant;
};
const $0320d5ed697c9c23$export$f481f329110b897f = async (participantsState, batchProps)=>{
    const { batchSize: batchSize = $0320d5ed697c9c23$var$DEFAULT_BATCH_FETCH_SIZE, getUsers: getUsers } = batchProps;
    const participantsToHydrate = participantsState.getUniqueParticipants({
        isHydrated: false
    });
    const participants = participantsToHydrate.splice(0, batchSize);
    if (!participants.length) return [];
    const aaids = new Set();
    participants.forEach((p)=>{
        aaids.add(p.userId);
    });
    const users = await getUsers?.([
        ...aaids.values()
    ]);
    const hydratedParticipants = [];
    users?.forEach((user)=>{
        // find all sessions of the user we just hydrated and populate data
        participantsState.getParticipants().filter((p)=>p.userId === user.userId).forEach((participant)=>{
            const { sessionId: sessionId } = participant;
            const hydratedParticipant = {
                name: user.name,
                avatar: user.avatar,
                email: user.email,
                userId: user.userId,
                isGuest: user.isGuest,
                sessionId: sessionId,
                lastActive: participant.lastActive,
                clientId: participant.clientId,
                permit: participant.permit,
                presenceId: participant.presenceId,
                presenceActivity: participant.presenceActivity,
                isHydrated: true
            };
            participantsState.setBySessionId(sessionId, hydratedParticipant);
            hydratedParticipants.push(hydratedParticipant);
        });
    });
    return hydratedParticipants;
};
module.exports["PARTICIPANT_UPDATE_INTERVAL"] = $0320d5ed697c9c23$export$488470c175a39c99;
module.exports["createParticipantFromPayload"] = $0320d5ed697c9c23$export$8c7e237b2e82904f;
module.exports["fetchParticipants"] = $0320d5ed697c9c23$export$f481f329110b897f;

});

parcelRegister("fFg2r", function(module, exports) {

var $4frCv = parcelRequire("4frCv");

class $d1e24f6ec89df86f$export$a4f3536b6f975d50 {
    constructor(baseParticipants = new Map()){
        this.participants = void 0;
        this.getBySessionId = (sessionId)=>{
            const participant = this.participants.get(sessionId);
            // Spread to ensure we get a deep copy
            return participant ? {
                ...participant
            } : undefined;
        };
        this.setBySessionId = (sessionId, participant)=>{
            this.participants.set(sessionId, participant);
        };
        this.getParticipants = ()=>// Spread to get deep copy
            [
                ...this.participants.values()
            ].filter((p)=>!(0, $4frCv.isAIProviderID)(p.userId)).map((p)=>({
                    ...p
                }));
        this.getAIProviderParticipants = ()=>// Spread to get deep copy
            [
                ...this.participants.values()
            ].filter((p)=>(0, $4frCv.isAIProviderID)(p.userId)).map((p)=>({
                    ...p
                }));
        /**
     * A user may contain multiple sessions, only return the unique users based on aaid.
     * If multiple participants with same aaid exist, will return the most recent entry
     * @param filter additional filter to narrow down results
     * @param filter.isHydrated
     */ this.getUniqueParticipants = ({ isHydrated: isHydrated = false })=>{
            const uniqueParticipants = new Map();
            const participants = this.getParticipants();
            participants.forEach((p)=>{
                if (!!p.isHydrated === isHydrated) {
                    const previous = uniqueParticipants.get(p.userId);
                    uniqueParticipants.set(p.userId, previous ? {
                        ...previous,
                        lastActive: p.lastActive,
                        sessionId: p.sessionId,
                        presenceActivity: p.presenceActivity
                    } : p);
                }
            });
            return [
                ...uniqueParticipants.values()
            ];
        };
        this.hasMoreParticipantsToHydrate = ()=>{
            return this.getUniqueParticipants({
                isHydrated: false
            }).length > 0;
        };
        this.removeBySessionId = (sessionId)=>this.participants.delete(sessionId);
        this.clear = ()=>this.participants.clear();
        this.doesntHave = (sessionId)=>!this.participants.has(sessionId);
        this.size = ()=>this.participants.size;
        this.getUniqueParticipantSize = ()=>{
            const result = new Set();
            this.getParticipants().forEach((p)=>result.add(p.userId));
            return result.size;
        };
        // If userId of participant in userIds, set lastActive to now
        this.updateLastActive = (now, userIds)=>this.participants.forEach((p)=>{
                p.lastActive = userIds.includes(p.userId) ? now : p.lastActive;
            });
        this.participants = baseParticipants;
    }
}
module.exports["ParticipantsState"] = $d1e24f6ec89df86f$export$a4f3536b6f975d50;

});

parcelRegister("8NlH6", function(module, exports) {

var $6Ted9 = parcelRequire("6Ted9");


var $6MIiQ = parcelRequire("6MIiQ");


var $h3X17 = parcelRequire("h3X17");

const $91627c828403cd19$export$b222f35b2c811336 = (error)=>{
    switch(error.data?.code){
        case (0, $6Ted9.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED:
        case (0, $6Ted9.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS:
            // This should never be called with these errors
            return;
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).ADD_STEPS_ERROR:
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).RECONNECTION_ERROR:
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).CONNECTION_ERROR:
            // These errors shouldn't be emitted, we're hoping the provider self-recovers over time
            return;
        case (0, $6Ted9.NCS_ERROR_CODE).INSUFFICIENT_EDITING_PERMISSION:
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).TOKEN_PERMISSION_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).NO_PERMISSION_ERROR,
                message: 'User does not have permissions to access this document or document is not found',
                reason: error.data.meta.reason,
                recoverable: true,
                status: 403
            };
        case (0, $6Ted9.NCS_ERROR_CODE).FORBIDDEN_USER_TOKEN:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INVALID_USER_TOKEN,
                message: 'The user token was invalid',
                recoverable: true,
                status: 403
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_NOT_FOUND:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_NOT_FOUND,
                message: 'The requested document is not found',
                recoverable: true,
                status: 404
            };
        case (0, $6Ted9.NCS_ERROR_CODE).TENANT_INSTANCE_MAINTENANCE:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).LOCKED,
                message: 'The document is currently not available, please try again later',
                recoverable: true,
                status: 423
            };
        case (0, $6Ted9.NCS_ERROR_CODE).LOCKED_DOCUMENT:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).LOCKED,
                message: 'The document is currently not available, please try again later',
                recoverable: true
            };
        case (0, $6Ted9.NCS_ERROR_CODE).DYNAMO_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).FAIL_TO_SAVE,
                message: 'Collab service is not able to save changes',
                recoverable: false,
                status: 500
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_RESTORE_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_RESTORE_ERROR,
                message: 'Collab service unable to restore document',
                recoverable: false,
                status: 500
            };
        case (0, $6Ted9.NCS_ERROR_CODE).INIT_DATA_LOAD_FAILED:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INITIALISATION_ERROR,
                message: "The initial document couldn't be loaded from the collab service",
                recoverable: false,
                status: 500
            };
        case (0, $6Ted9.NCS_ERROR_CODE).PROSEMIRROR_SCHEMA_VALIDATION_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INITIALISATION_ERROR,
                message: "The initial document couldn't be loaded from the collab service due to a prosemirror schema validation error",
                recoverable: false
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).DOCUMENT_UPDATE_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).DOCUMENT_UPDATE_ERROR,
                message: 'The provider failed to apply changes to the editor',
                recoverable: false,
                status: 500
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).RECONNECTION_NETWORK_ISSUE:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).NETWORK_ISSUE,
                message: "Couldn't reconnect to the collab service due to network issues",
                recoverable: true,
                status: 500
            };
        case (0, $6Ted9.NCS_ERROR_CODE).NAMESPACE_INVALID:
        case (0, $6Ted9.NCS_ERROR_CODE).INVALID_ACTIVATION_ID:
        case (0, $6Ted9.NCS_ERROR_CODE).INVALID_DOCUMENT_ARI:
        case (0, $6Ted9.NCS_ERROR_CODE).INVALID_CLOUD_ID:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INVALID_PROVIDER_CONFIGURATION,
                message: 'Invalid provider configuration',
                recoverable: false,
                reason: error.data?.code,
                status: 400
            };
        case (0, $6Ted9.NCS_ERROR_CODE).NAMESPACE_NOT_FOUND:
        case (0, $6Ted9.NCS_ERROR_CODE).ERROR_MAPPING_ERROR:
        case (0, $6Ted9.NCS_ERROR_CODE).EMPTY_BROADCAST:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR,
                message: 'Collab Provider experienced an unrecoverable error',
                recoverable: true,
                reason: error.data?.code,
                status: 500
            };
        case (0, $6MIiQ.INTERNAL_ERROR_CODE).CATCHUP_FAILED:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR,
                message: 'Collab Provider experienced an unrecoverable error',
                recoverable: true,
                reason: error.data?.code,
                status: 500
            };
        case (0, $6Ted9.NCS_ERROR_CODE).RATE_LIMIT_ERROR:
            return {
                code: (0, $h3X17.PROVIDER_ERROR_CODE).FAIL_TO_SAVE,
                message: 'Document rate limit',
                recoverable: false
            };
        default:
            return;
    }
};
module.exports["errorCodeMapper"] = $91627c828403cd19$export$b222f35b2c811336;

});

parcelRegister("3LSA5", function(module, exports) {

var $4frCv = parcelRequire("4frCv");


var $lMdlY = parcelRequire("lMdlY");

const $7d130921f7e0d933$var$logger = (0, $4frCv.createLogger)('Api', 'blue');
class $7d130921f7e0d933$var$AddCommentError extends Error {
    constructor(message, status, meta){
        super(message);
        this.status = void 0;
        this.meta = void 0;
        this.name = 'AddCommentError';
        this.status = status;
        this.meta = meta;
    }
}
class $7d130921f7e0d933$export$bf71da7aebe9ddc1 {
    async addComment(steps) {
        const stepVersion = this.documentService.getCurrentPmVersion();
        try {
            const response = await this.submitComment(steps, stepVersion);
            const status = response.status;
            const { message: message, meta: meta } = await response.json();
            // If the HTTP status code is 201, then the operation was successful
            if (status === 201) {
                $7d130921f7e0d933$var$logger(`NCS response: ${message}`);
                return {
                    message: message
                };
            }
            // If the HTTP status code is between 400 and 499, then there was a client error
            if (status >= 400 && status <= 499) {
                $7d130921f7e0d933$var$logger(`NCS error meta: ${JSON.stringify(meta)}`);
                // Include details in error response
                throw new $7d130921f7e0d933$var$AddCommentError(`Failed to add comment - Client error: ${message}`, status, JSON.stringify(meta));
            }
            // If the code execution reaches this point, then there was a server error
            throw new $7d130921f7e0d933$var$AddCommentError(`Failed to add comment - Server error`, status);
        } catch (err) {
            if (err instanceof $7d130921f7e0d933$var$AddCommentError) throw err;
            else throw new Error(`Error submitting comment: ${err}`);
        }
    }
    constructor(config, documentService, channel){
        this.config = void 0;
        this.documentService = void 0;
        this.channel = void 0;
        this.submitComment = async (steps, version)=>{
            const reqBody = JSON.stringify({
                productId: 'ccollab',
                version: version,
                steps: steps
            });
            const url = `${this.config.url}/document/${encodeURIComponent(this.config.documentAri)}/comment`;
            $7d130921f7e0d933$var$logger(`Request url: `, url);
            const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)(url);
            const fetchOptions = {
                credentials: 'include',
                headers: {
                    ...this.config.permissionTokenRefresh ? {
                        'x-token': await this.channel.getChannelToken()
                    } : {},
                    'x-product': (0, $4frCv.getProduct)(this.config.productInfo),
                    'x-subproduct': (0, $4frCv.getSubProduct)(this.config.productInfo),
                    'Content-Type': 'application/json',
                    ...tracingHeaders
                },
                method: 'POST',
                body: reqBody
            };
            return await fetch(url, fetchOptions);
        };
        this.config = config;
        this.documentService = documentService;
        this.channel = channel;
    }
}
module.exports["Api"] = $7d130921f7e0d933$export$bf71da7aebe9ddc1;

});

parcelRegister("9w9et", function(module, exports) {
// A mock for the actual Api class designed for the experiment teammate presence (ATLAS-53155)
class $0cdcfe7cd8acc14c$export$fe345bbcb4b3b9fe {
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    async addComment() {
        return;
    }
}
module.exports["NullApi"] = $0cdcfe7cd8acc14c$export$fe345bbcb4b3b9fe;

});

parcelRegister("b0ow0", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

function $22e87c8266a2e784$var$getOfflineSteps(steps, origins) {
    if (!steps || !origins || steps.length !== origins.length) return undefined;
    if (origins.some((s)=>s?.getMeta('isOffline') === true || s?.getMeta('wasOffline') === true)) {
        const mapped = steps.filter((step, idx)=>{
            const origin = origins[idx];
            if (!origin) return false;
            const createdOffline = origin.getMeta('isOffline') || origin.getMeta('wasOffline');
            return createdOffline;
        });
        return mapped;
    }
}
function $22e87c8266a2e784$export$4cdf4b1fc99387ca(steps, origins) {
    return $22e87c8266a2e784$var$getOfflineSteps(steps, origins)?.length;
}
function $22e87c8266a2e784$export$4d647e09fb4b200d(steps, origins) {
    return $22e87c8266a2e784$var$getOfflineSteps(steps, origins)?.filter((s)=>s instanceof (0, $aXG5V.ReplaceStep)).length;
}
module.exports["getOfflineStepsLength"] = $22e87c8266a2e784$export$4cdf4b1fc99387ca;
module.exports["getOfflineReplaceStepsLength"] = $22e87c8266a2e784$export$4d647e09fb4b200d;

});

parcelRegister("1jdMD", function(module, exports) {
/**
 * https://socket.io/docs/v4/client-options/#randomizationfactor
 * 1st reconnection attempt happens between 100 - 300 ms
 * 2nd reconnection attempt happens between 200 - 600 ms
 * 3rd reconnection attempt happens between 400 - 1200 ms
 * 4th 800 - 2400 ms
 * 5th 1600 - 4800 ms
 * 6th 3200 - 9600 ms
 * 7th 6400 - 19200 ms
 * 8th 12800 - 38400 ms
 * 9th 25600 - 76800 ms
 * 10th 51200 - 128000 ms (capped at max delay)
 * nth 128000 ms
 */ const $f64b9931b63de03f$export$33eb5f668d5e0d74 = {
    RECONNECTION_DELAY_MAX: 128000,
    RECONNECTION_DELAY: 200,
    RANDOMIZATION_FACTOR: 0.5
};
const $f64b9931b63de03f$export$273323b1c5196ad5 = {
    RECONNECTION_DELAY_MAX: 128000,
    RECONNECTION_DELAY: 1000,
    RANDOMIZATION_FACTOR: 0.75
};
module.exports["SOCKET_IO_OPTIONS"] = $f64b9931b63de03f$export$33eb5f668d5e0d74;
module.exports["SOCKET_IO_OPTIONS_WITH_HIGH_JITTER"] = $f64b9931b63de03f$export$273323b1c5196ad5;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("1VB1N", function(module, exports) {
const $aa17610eab1e6010$var$COLLAB_PATH = 'ccollab'; // the extra c is for Confluence
const $aa17610eab1e6010$export$33a46e9ce425ca1f = ()=>{
    return `${window.location.origin}/${$aa17610eab1e6010$var$COLLAB_PATH}`;
};
const $aa17610eab1e6010$export$2fa932d5a7c03848 = (cloudId, activationId)=>{
    const editPrefix = '/ncs';
    return `${editPrefix}/${cloudId}/${activationId}/confluence`;
};
module.exports["getCollabProviderUrl"] = $aa17610eab1e6010$export$33a46e9ce425ca1f;
module.exports["getCollabEditServicePath"] = $aa17610eab1e6010$export$2fa932d5a7c03848;

});

parcelRegister("8VXwD", function(module, exports) {

var $iifuv = parcelRequire("iifuv");


var $c0rhi = parcelRequire("c0rhi");

const $b6adfd51a2226747$export$c510c686c47533e5 = (accountIds)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $iifuv.default),
        interopApolloAggClient: true,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                id: user.id,
                name: user.name ?? '',
                userId: user.accountId
            })) ?? [];
    });
};
module.exports["fetchNativeCollabAGGUsers"] = $b6adfd51a2226747$export$c510c686c47533e5;

});

parcelRegister("iifuv", function(module, exports) {
/**
 * @generated SignedSource<<5de3c47272df5adc7ab822d6f41f63ef>>
 * @relayHash 0fd4072175c8fe4b70be5b778b8275d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d99fca6262af9031d992216d6a26bb187ea304a8a6bd9a8187762df24a999afe
const $a9e245ecc19d863b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchNativeCollabAGGUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchNativeCollabAGGUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0fd4072175c8fe4b70be5b778b8275d1",
            "id": "d99fca6262af9031d992216d6a26bb187ea304a8a6bd9a8187762df24a999afe",
            "metadata": {},
            "name": "fetchNativeCollabAGGUsersQuery",
            "operationKind": "query",
            "text": "query fetchNativeCollabAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){__typename,accountId,name,picture,id}}"
        }
    };
}();
$a9e245ecc19d863b$var$node.hash = "06df0642dffe62239e8db6cdf41fa76d";
var $a9e245ecc19d863b$export$2e2bcd8739ae039 = $a9e245ecc19d863b$var$node;
module.exports["default"] = $a9e245ecc19d863b$export$2e2bcd8739ae039;

});

parcelRegister("bNHtR", function(module, exports) {

var $cpHSm = parcelRequire("cpHSm");


var $c0rhi = parcelRequire("c0rhi");

const $5bd57447223249dc$export$1db9c46a0728e686 = (accountIds)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $cpHSm.default),
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.profilePicture?.path ?? '',
                email: '',
                isGuest: undefined,
                name: user.displayName ?? '',
                userId: user.accountId
            })) ?? [];
    });
};
module.exports["fetchNativeCollabConfluenceUsers"] = $5bd57447223249dc$export$1db9c46a0728e686;

});

parcelRegister("cpHSm", function(module, exports) {
/**
 * @generated SignedSource<<3dae70845bd687a41f1fa3a09a7461f9>>
 * @relayHash 323b4708c921b4390cda5d42e5653f96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36ccd9407258ecbab8e4d25ef3d8dd06ef957b601b4a6430917e55a6d8c81331
const $e40b2bace6883fb5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "RELATIVE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"RELATIVE\")"
            }
        ]
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": v3 /*: any*/ ,
        "type": "KnownUser"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": v3 /*: any*/ ,
        "type": "UnknownUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchNativeCollabConfluenceUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchNativeCollabConfluenceUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "323b4708c921b4390cda5d42e5653f96",
            "id": "36ccd9407258ecbab8e4d25ef3d8dd06ef957b601b4a6430917e55a6d8c81331",
            "metadata": {},
            "name": "fetchNativeCollabConfluenceUsersQuery",
            "operationKind": "query",
            "text": "query fetchNativeCollabConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{__typename,profilePicture{isDefault,path(type:RELATIVE)},...on KnownUser{accountId},...on UnknownUser{accountId},displayName}}}"
        }
    };
}();
$e40b2bace6883fb5$var$node.hash = "e9ca85d4f438ea6a9fa558a7a23119a8";
var $e40b2bace6883fb5$export$2e2bcd8739ae039 = $e40b2bace6883fb5$var$node;
module.exports["default"] = $e40b2bace6883fb5$export$2e2bcd8739ae039;

});

parcelRegister("gNjy8", function(module, exports) {

var $jyw2s = parcelRequire("jyw2s");

var $aFUXX = parcelRequire("aFUXX");


var $83Vfg = parcelRequire("83Vfg");

const $f7e4e12795ac08a6$export$e42cca8419da94fc = (presenceId)=>{
    const hashCode = presenceId ? (0, $jyw2s.getHashCode)(presenceId) : 0;
    const primaryIndex = hashCode;
    const secondaryIndex = hashCode % (0, $aFUXX.participantColors).length;
    const svgBackgroundColor = (0, $aFUXX.participantColors)[secondaryIndex].svgBackgroundColor;
    return (0, $83Vfg.getAnonymousAvatarWithStyling)({
        styleProperties: {
            'background-color': svgBackgroundColor
        },
        index: primaryIndex
    });
};
module.exports["fetchAnonymousAsset"] = $f7e4e12795ac08a6$export$e42cca8419da94fc;

});

parcelRegister("jyw2s", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");

function $514d44140915e951$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $514d44140915e951$export$60ba61eca4eb64f2(str) {
    const index = $514d44140915e951$export$c14f61804029af13(str) % (0, $aFUXX.participantColors).length;
    return {
        index: index,
        color: (0, $aFUXX.participantColors)[index]
    };
}
module.exports["getHashCode"] = $514d44140915e951$export$c14f61804029af13;
module.exports["getParticipantColor"] = $514d44140915e951$export$60ba61eca4eb64f2;

});

parcelRegister("83Vfg", function(module, exports) {

var $8ocXC = parcelRequire("8ocXC");


var $fDtVg = parcelRequire("fDtVg");


var $99F08 = parcelRequire("99F08");

const $eeb5105c6a539702$export$101d00feadd67b75 = (svgRoot)=>{
    // by this point we have a safe SVG string: we can safely string interpolate to encode as a
    // data:image to enable passing it to an <img> src attribute
    return `data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(svgRoot))}`;
};
const $eeb5105c6a539702$export$ad5dfe87b2150403 = (cssProperties)=>{
    let styleString = '';
    Object.keys(cssProperties).forEach((key)=>{
        styleString += `${key}: ${cssProperties[key]}; `;
    });
    return styleString;
};
const $eeb5105c6a539702$export$1ce458cf91bd8e41 = (svgRoot, cssProperties)=>{
    const styleRule = new CSSStyleSheet();
    const styleString = $eeb5105c6a539702$export$ad5dfe87b2150403(cssProperties);
    // even if styling is malicious, it will be sanitized by the CSSStyleSheet with the string being empty, ensuring safety
    styleRule.insertRule(`svg { ${styleString} }`);
    // we need to cast to CSSStyleRule to access the .style property
    const styleRuleString = styleRule.cssRules[0].style.cssText;
    svgRoot.setAttribute('style', styleRuleString);
};
const $eeb5105c6a539702$export$7572e098f6cf1a37 = (index)=>{
    return index !== undefined ? index % (0, $8ocXC.ANONYMOUS_ASSETS).length : Math.floor(Math.random() * (0, $8ocXC.ANONYMOUS_ASSETS).length);
};
const $eeb5105c6a539702$export$e79675c646a31542 = (svgString)=>{
    return new DOMParser().parseFromString(svgString, 'image/svg+xml');
};
const $eeb5105c6a539702$export$65fe496f5eb91c21 = async (props)=>{
    const index = $eeb5105c6a539702$export$7572e098f6cf1a37(props?.index);
    const { id: id, messageDescriptor: messageDescriptor, src: src } = (0, $8ocXC.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $fDtVg.getIntl)();
    const response = await (0, $99F08.fetchWithRetry)({
        url: src,
        shouldRetryOnApiError: true,
        retries: props.retries || 3,
        options: props.options,
        baseDelay: props.baseDelay,
        maxDelay: props.maxDelay
    });
    const svgString = await response.result?.text();
    if (!response.success) throw new Error(`Error while fetching svg ${id} with src ${src}`);
    if (!svgString) throw new Error(`svg returned null with svg ${id} with src ${src}`);
    const doc = $eeb5105c6a539702$export$e79675c646a31542(svgString);
    const svg = doc.documentElement;
    $eeb5105c6a539702$export$1ce458cf91bd8e41(svg, props.styleProperties);
    return {
        id: id,
        name: intl.formatMessage(messageDescriptor),
        src: $eeb5105c6a539702$export$101d00feadd67b75(svg)
    };
};
const $eeb5105c6a539702$export$da26b707e2b53fcf = async (props)=>{
    const index = $eeb5105c6a539702$export$7572e098f6cf1a37(props?.index);
    const asset = (0, $8ocXC.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $fDtVg.getIntl)();
    return {
        ...asset,
        name: intl.formatMessage(asset.messageDescriptor)
    };
};
const $eeb5105c6a539702$export$aa51d138a7f855d7 = async ()=>{
    const intl = await (0, $fDtVg.getIntl)();
    return (0, $8ocXC.ANONYMOUS_ASSETS).map((asset)=>({
            id: asset.id,
            name: intl.formatMessage(asset.messageDescriptor),
            src: asset.src
        }));
};
module.exports["getAnonymousAvatarWithStyling"] = $eeb5105c6a539702$export$65fe496f5eb91c21;

});

parcelRegister("8ocXC", function(module, exports) {

var $lfFy6 = parcelRequire("lfFy6");


var $45p5c = parcelRequire("45p5c");

var $66aLS = parcelRequire("66aLS");

var $eA5k9 = parcelRequire("eA5k9");

var $dLHML = parcelRequire("dLHML");

var $5QM3U = parcelRequire("5QM3U");

var $1zbJy = parcelRequire("1zbJy");

var $absgL = parcelRequire("absgL");

var $i9wU3 = parcelRequire("i9wU3");

var $7BD8h = parcelRequire("7BD8h");

var $ipNYr = parcelRequire("ipNYr");

var $5Fo99 = parcelRequire("5Fo99");

var $futbp = parcelRequire("futbp");

var $1tL0q = parcelRequire("1tL0q");

var $gsqYV = parcelRequire("gsqYV");

var $aV0Ix = parcelRequire("aV0Ix");

var $7f8BP = parcelRequire("7f8BP");

var $w2g3p = parcelRequire("w2g3p");

var $7pNkU = parcelRequire("7pNkU");

var $3saEQ = parcelRequire("3saEQ");

var $bBrvm = parcelRequire("bBrvm");

var $2MJ1F = parcelRequire("2MJ1F");

var $62PyO = parcelRequire("62PyO");

var $ct5mQ = parcelRequire("ct5mQ");

var $geCWF = parcelRequire("geCWF");

var $cA6yA = parcelRequire("cA6yA");

var $gE9fP = parcelRequire("gE9fP");

var $6Cmrb = parcelRequire("6Cmrb");

var $7Za1I = parcelRequire("7Za1I");

var $kgPFA = parcelRequire("kgPFA");

var $2hRuV = parcelRequire("2hRuV");

var $8H1nG = parcelRequire("8H1nG");

var $jfdMm = parcelRequire("jfdMm");

var $jAnMk = parcelRequire("jAnMk");

var $kiped = parcelRequire("kiped");

var $ijRK6 = parcelRequire("ijRK6");

var $hQTrZ = parcelRequire("hQTrZ");

var $3ussC = parcelRequire("3ussC");

var $bfQlR = parcelRequire("bfQlR");

var $g2zNl = parcelRequire("g2zNl");

var $dnUXX = parcelRequire("dnUXX");

var $ldCFU = parcelRequire("ldCFU");

var $gcvuo = parcelRequire("gcvuo");

var $3aulr = parcelRequire("3aulr");

var $jj7JF = parcelRequire("jj7JF");

var $gFh8H = parcelRequire("gFh8H");

var $ib1i9 = parcelRequire("ib1i9");

var $7vWf2 = parcelRequire("7vWf2");

var $MAw5A = parcelRequire("MAw5A");

var $4R6fR = parcelRequire("4R6fR");

var $3G8sv = parcelRequire("3G8sv");

var $5L3ZL = parcelRequire("5L3ZL");

var $1tIXy = parcelRequire("1tIXy");

var $gIr5o = parcelRequire("gIr5o");

var $jMi9Z = parcelRequire("jMi9Z");

var $5fTd1 = parcelRequire("5fTd1");

var $70IXo = parcelRequire("70IXo");

var $k45BN = parcelRequire("k45BN");

var $5t7IX = parcelRequire("5t7IX");

var $7y9m7 = parcelRequire("7y9m7");

var $kRP7t = parcelRequire("kRP7t");

var $dLJHp = parcelRequire("dLJHp");

var $MvguA = parcelRequire("MvguA");

var $i2wVj = parcelRequire("i2wVj");

var $bqNy3 = parcelRequire("bqNy3");

var $5RzHY = parcelRequire("5RzHY");

var $jN43s = parcelRequire("jN43s");

var $018bO = parcelRequire("018bO");

var $c3T8r = parcelRequire("c3T8r");

var $h0256 = parcelRequire("h0256");

var $8O3eM = parcelRequire("8O3eM");

var $8BcsQ = parcelRequire("8BcsQ");

var $ctuOo = parcelRequire("ctuOo");

var $9wms3 = parcelRequire("9wms3");

var $1j7TY = parcelRequire("1j7TY");

var $4ux8O = parcelRequire("4ux8O");

var $44Sb4 = parcelRequire("44Sb4");

var $dQMZo = parcelRequire("dQMZo");

var $zYoHs = parcelRequire("zYoHs");

var $04PGh = parcelRequire("04PGh");

var $ddSO1 = parcelRequire("ddSO1");

var $ivVMv = parcelRequire("ivVMv");

var $eJnd2 = parcelRequire("eJnd2");

var $98ut7 = parcelRequire("98ut7");

var $9q1Vk = parcelRequire("9q1Vk");

var $eMHgQ = parcelRequire("eMHgQ");

var $3LKHJ = parcelRequire("3LKHJ");

var $3ZCOi = parcelRequire("3ZCOi");

var $5xoX8 = parcelRequire("5xoX8");

var $5qhol = parcelRequire("5qhol");

var $dGRYO = parcelRequire("dGRYO");

var $6dhVt = parcelRequire("6dhVt");

var $ighEF = parcelRequire("ighEF");

var $jiyfa = parcelRequire("jiyfa");

var $aRWto = parcelRequire("aRWto");

var $3VNps = parcelRequire("3VNps");

var $62BuW = parcelRequire("62BuW");

var $54a3y = parcelRequire("54a3y");

var $cjnzF = parcelRequire("cjnzF");

var $faukZ = parcelRequire("faukZ");

var $Ox4am = parcelRequire("Ox4am");

var $hembw = parcelRequire("hembw");

var $5gEBh = parcelRequire("5gEBh");

var $76eQq = parcelRequire("76eQq");

var $68Yx0 = parcelRequire("68Yx0");

var $l08I5 = parcelRequire("l08I5");

const $40b74b738da6af36$export$4522d3d70312bbdc = [
    {
        id: 'alligator',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2hRuV))),
        messageDescriptor: (0, $lfFy6.messages).alligator
    },
    {
        id: 'alpaca',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70IXo))),
        messageDescriptor: (0, $lfFy6.messages).alpaca
    },
    {
        id: 'ape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).ape
    },
    {
        id: 'apple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($45p5c))),
        messageDescriptor: (0, $lfFy6.messages).apple
    },
    {
        id: 'avocado',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66aLS))),
        messageDescriptor: (0, $lfFy6.messages).avocado
    },
    {
        id: 'baboon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).baboon
    },
    {
        id: 'badger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eA5k9))),
        messageDescriptor: (0, $lfFy6.messages).badger
    },
    {
        id: 'bat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLHML))),
        messageDescriptor: (0, $lfFy6.messages).bat
    },
    {
        id: 'bear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5QM3U))),
        messageDescriptor: (0, $lfFy6.messages).bear
    },
    {
        id: 'beaver',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1zbJy))),
        messageDescriptor: (0, $lfFy6.messages).beaver
    },
    {
        id: 'bee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($absgL))),
        messageDescriptor: (0, $lfFy6.messages).bee
    },
    {
        id: 'bird',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($018bO))),
        messageDescriptor: (0, $lfFy6.messages).bird
    },
    {
        id: 'bison',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i9wU3))),
        messageDescriptor: (0, $lfFy6.messages).bison
    },
    {
        id: 'blobfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).blobfish
    },
    {
        id: 'blossom',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7BD8h))),
        messageDescriptor: (0, $lfFy6.messages).blossom
    },
    {
        id: 'blowfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ipNYr))),
        messageDescriptor: (0, $lfFy6.messages).blowfish
    },
    {
        id: 'blueberries',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Fo99))),
        messageDescriptor: (0, $lfFy6.messages).blueberries
    },
    {
        id: 'boar',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($futbp))),
        messageDescriptor: (0, $lfFy6.messages).boar
    },
    {
        id: 'broccoli',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1tL0q))),
        messageDescriptor: (0, $lfFy6.messages).broccoli
    },
    {
        id: 'buffalo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i9wU3))),
        messageDescriptor: (0, $lfFy6.messages).buffalo
    },
    {
        id: 'bug',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gsqYV))),
        messageDescriptor: (0, $lfFy6.messages).bug
    },
    {
        id: 'bull',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Za1I))),
        messageDescriptor: (0, $lfFy6.messages).bull
    },
    {
        id: 'bunny',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($zYoHs))),
        messageDescriptor: (0, $lfFy6.messages).bunny
    },
    {
        id: 'butterfly',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gsqYV))),
        messageDescriptor: (0, $lfFy6.messages).butterfly
    },
    {
        id: 'cactus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aV0Ix))),
        messageDescriptor: (0, $lfFy6.messages).cactus
    },
    {
        id: 'camel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7f8BP))),
        messageDescriptor: (0, $lfFy6.messages).camel
    },
    {
        id: 'candy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($w2g3p))),
        messageDescriptor: (0, $lfFy6.messages).candy
    },
    {
        id: 'cantaloupe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7y9m7))),
        messageDescriptor: (0, $lfFy6.messages).cantaloupe
    },
    {
        id: 'capsicum',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7pNkU))),
        messageDescriptor: (0, $lfFy6.messages).capsicum
    },
    {
        id: 'carrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3saEQ))),
        messageDescriptor: (0, $lfFy6.messages).carrot
    },
    {
        id: 'cat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBrvm))),
        messageDescriptor: (0, $lfFy6.messages).cat
    },
    {
        id: 'caterpiller',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2MJ1F))),
        messageDescriptor: (0, $lfFy6.messages).caterpiller
    },
    {
        id: 'chameleon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).chameleon
    },
    {
        id: 'cherry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62PyO))),
        messageDescriptor: (0, $lfFy6.messages).cherry
    },
    {
        id: 'chili',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ct5mQ))),
        messageDescriptor: (0, $lfFy6.messages).chili
    },
    {
        id: 'chimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).chimp
    },
    {
        id: 'chimpanzee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).chimpanzee
    },
    {
        id: 'clover',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($geCWF))),
        messageDescriptor: (0, $lfFy6.messages).clover
    },
    {
        id: 'clownfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ox4am))),
        messageDescriptor: (0, $lfFy6.messages).clownfish
    },
    {
        id: 'cobra',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).cobra
    },
    {
        id: 'coconut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cA6yA))),
        messageDescriptor: (0, $lfFy6.messages).coconut
    },
    {
        id: 'cod',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).cod
    },
    {
        id: 'cookie',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gE9fP))),
        messageDescriptor: (0, $lfFy6.messages).cookie
    },
    {
        id: 'corn',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Cmrb))),
        messageDescriptor: (0, $lfFy6.messages).corn
    },
    {
        id: 'cow',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Za1I))),
        messageDescriptor: (0, $lfFy6.messages).cow
    },
    {
        id: 'crab',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kgPFA))),
        messageDescriptor: (0, $lfFy6.messages).crab
    },
    {
        id: 'crocodile',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2hRuV))),
        messageDescriptor: (0, $lfFy6.messages).crocodile
    },
    {
        id: 'deer',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8H1nG))),
        messageDescriptor: (0, $lfFy6.messages).deer
    },
    {
        id: 'dinosaur',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jfdMm))),
        messageDescriptor: (0, $lfFy6.messages).dinosaur
    },
    {
        id: 'dodo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jAnMk))),
        messageDescriptor: (0, $lfFy6.messages).dodo
    },
    {
        id: 'dog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kiped))),
        messageDescriptor: (0, $lfFy6.messages).dog
    },
    {
        id: 'dolphin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ijRK6))),
        messageDescriptor: (0, $lfFy6.messages).dolphin
    },
    {
        id: 'donut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hQTrZ))),
        messageDescriptor: (0, $lfFy6.messages).donut
    },
    {
        id: 'dragon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ussC))),
        messageDescriptor: (0, $lfFy6.messages).dragon
    },
    {
        id: 'duck',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bfQlR))),
        messageDescriptor: (0, $lfFy6.messages).duck
    },
    {
        id: 'elephant',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g2zNl))),
        messageDescriptor: (0, $lfFy6.messages).elephant
    },
    {
        id: 'elk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8H1nG))),
        messageDescriptor: (0, $lfFy6.messages).elk
    },
    {
        id: 'fish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).fish
    },
    {
        id: 'flamingo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ldCFU))),
        messageDescriptor: (0, $lfFy6.messages).flamingo
    },
    {
        id: 'fox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gcvuo))),
        messageDescriptor: (0, $lfFy6.messages).fox
    },
    {
        id: 'frog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3aulr))),
        messageDescriptor: (0, $lfFy6.messages).frog
    },
    {
        id: 'gecko',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).gecko
    },
    {
        id: 'giraffe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jj7JF))),
        messageDescriptor: (0, $lfFy6.messages).giraffe
    },
    {
        id: 'gorilla',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gFh8H))),
        messageDescriptor: (0, $lfFy6.messages).gorilla
    },
    {
        id: 'grape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ib1i9))),
        messageDescriptor: (0, $lfFy6.messages).grape
    },
    {
        id: 'hammerhead',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMHgQ))),
        messageDescriptor: (0, $lfFy6.messages).hammerhead
    },
    {
        id: 'hedgehog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7vWf2))),
        messageDescriptor: (0, $lfFy6.messages).hedgehog
    },
    {
        id: 'hippo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MAw5A))),
        messageDescriptor: (0, $lfFy6.messages).hippo
    },
    {
        id: 'kangaroo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4R6fR))),
        messageDescriptor: (0, $lfFy6.messages).kangaroo
    },
    {
        id: 'kitten',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBrvm))),
        messageDescriptor: (0, $lfFy6.messages).kitten
    },
    {
        id: 'kiwi',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3G8sv))),
        messageDescriptor: (0, $lfFy6.messages).kiwi
    },
    {
        id: 'koala',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5L3ZL))),
        messageDescriptor: (0, $lfFy6.messages).koala
    },
    {
        id: 'lemon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1tIXy))),
        messageDescriptor: (0, $lfFy6.messages).lemon
    },
    {
        id: 'leopard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62BuW))),
        messageDescriptor: (0, $lfFy6.messages).leopard
    },
    {
        id: 'lettuce',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gIr5o))),
        messageDescriptor: (0, $lfFy6.messages).lettuce
    },
    {
        id: 'lion',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jMi9Z))),
        messageDescriptor: (0, $lfFy6.messages).lion
    },
    {
        id: 'lizard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5fTd1))),
        messageDescriptor: (0, $lfFy6.messages).lizard
    },
    {
        id: 'llama',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70IXo))),
        messageDescriptor: (0, $lfFy6.messages).llama
    },
    {
        id: 'lobster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($k45BN))),
        messageDescriptor: (0, $lfFy6.messages).lobster
    },
    {
        id: 'macaque',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).macaque
    },
    {
        id: 'mango',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5t7IX))),
        messageDescriptor: (0, $lfFy6.messages).mango
    },
    {
        id: 'melon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($76eQq))),
        messageDescriptor: (0, $lfFy6.messages).melon
    },
    {
        id: 'millipede',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2MJ1F))),
        messageDescriptor: (0, $lfFy6.messages).millipede
    },
    {
        id: 'monkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kRP7t))),
        messageDescriptor: (0, $lfFy6.messages).monkey
    },
    {
        id: 'mouse',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLJHp))),
        messageDescriptor: (0, $lfFy6.messages).mouse
    },
    {
        id: 'octopus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MvguA))),
        messageDescriptor: (0, $lfFy6.messages).octopus
    },
    {
        id: 'olive',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i2wVj))),
        messageDescriptor: (0, $lfFy6.messages).olive
    },
    {
        id: 'orange',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bqNy3))),
        messageDescriptor: (0, $lfFy6.messages).orange
    },
    {
        id: 'orangutan',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5RzHY))),
        messageDescriptor: (0, $lfFy6.messages).orangutan
    },
    {
        id: 'otter',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jN43s))),
        messageDescriptor: (0, $lfFy6.messages).otter
    },
    {
        id: 'owl',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($018bO))),
        messageDescriptor: (0, $lfFy6.messages).owl
    },
    {
        id: 'ox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3T8r))),
        messageDescriptor: (0, $lfFy6.messages).ox
    },
    {
        id: 'oyster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h0256))),
        messageDescriptor: (0, $lfFy6.messages).oyster
    },
    {
        id: 'panda',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8O3eM))),
        messageDescriptor: (0, $lfFy6.messages).panda
    },
    {
        id: 'parrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8BcsQ))),
        messageDescriptor: (0, $lfFy6.messages).parrot
    },
    {
        id: 'peacock',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ctuOo))),
        messageDescriptor: (0, $lfFy6.messages).peacock
    },
    {
        id: 'pear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9wms3))),
        messageDescriptor: (0, $lfFy6.messages).pear
    },
    {
        id: 'penguin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1j7TY))),
        messageDescriptor: (0, $lfFy6.messages).penguin
    },
    {
        id: 'pig',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4ux8O))),
        messageDescriptor: (0, $lfFy6.messages).pig
    },
    {
        id: 'pineapple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($44Sb4))),
        messageDescriptor: (0, $lfFy6.messages).pineapple
    },
    {
        id: 'poodle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dQMZo))),
        messageDescriptor: (0, $lfFy6.messages).poodle
    },
    {
        id: 'puppy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kiped))),
        messageDescriptor: (0, $lfFy6.messages).puppy
    },
    {
        id: 'python',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).python
    },
    {
        id: 'rabbit',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($zYoHs))),
        messageDescriptor: (0, $lfFy6.messages).rabbit
    },
    {
        id: 'raccoon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($04PGh))),
        messageDescriptor: (0, $lfFy6.messages).raccoon
    },
    {
        id: 'rat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dLJHp))),
        messageDescriptor: (0, $lfFy6.messages).rat
    },
    {
        id: 'rhino',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ddSO1))),
        messageDescriptor: (0, $lfFy6.messages).rhino
    },
    {
        id: 'robot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ivVMv))),
        messageDescriptor: (0, $lfFy6.messages).robot
    },
    {
        id: 'rose',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eJnd2))),
        messageDescriptor: (0, $lfFy6.messages).rose
    },
    {
        id: 'seal',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($98ut7))),
        messageDescriptor: (0, $lfFy6.messages).seal
    },
    {
        id: 'seedling',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9q1Vk))),
        messageDescriptor: (0, $lfFy6.messages).seedling
    },
    {
        id: 'shark',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMHgQ))),
        messageDescriptor: (0, $lfFy6.messages).shark
    },
    {
        id: 'shrimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3LKHJ))),
        messageDescriptor: (0, $lfFy6.messages).shrimp
    },
    {
        id: 'skunk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3ZCOi))),
        messageDescriptor: (0, $lfFy6.messages).skunk
    },
    {
        id: 'sloth',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5xoX8))),
        messageDescriptor: (0, $lfFy6.messages).sloth
    },
    {
        id: 'snail',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5qhol))),
        messageDescriptor: (0, $lfFy6.messages).snail
    },
    {
        id: 'snake',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dGRYO))),
        messageDescriptor: (0, $lfFy6.messages).snake
    },
    {
        id: 'snowman',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6dhVt))),
        messageDescriptor: (0, $lfFy6.messages).snowman
    },
    {
        id: 'squid',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ighEF))),
        messageDescriptor: (0, $lfFy6.messages).squid
    },
    {
        id: 'squirrel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jiyfa))),
        messageDescriptor: (0, $lfFy6.messages).squirrel
    },
    {
        id: 'strawberry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aRWto))),
        messageDescriptor: (0, $lfFy6.messages).strawberry
    },
    {
        id: 'sunfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($Ox4am))),
        messageDescriptor: (0, $lfFy6.messages).sunfish
    },
    {
        id: 'sunflower',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3VNps))),
        messageDescriptor: (0, $lfFy6.messages).sunflower
    },
    {
        id: 'tiger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($62BuW))),
        messageDescriptor: (0, $lfFy6.messages).tiger
    },
    {
        id: 'tomato',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($54a3y))),
        messageDescriptor: (0, $lfFy6.messages).tomato
    },
    {
        id: 'tortoise',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gEBh))),
        messageDescriptor: (0, $lfFy6.messages).tortoise
    },
    {
        id: 'tree',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cjnzF))),
        messageDescriptor: (0, $lfFy6.messages).tree
    },
    {
        id: 'trex',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($faukZ))),
        messageDescriptor: (0, $lfFy6.messages).trex
    },
    {
        id: 'trout',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dnUXX))),
        messageDescriptor: (0, $lfFy6.messages).trout
    },
    {
        id: 'turkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hembw))),
        messageDescriptor: (0, $lfFy6.messages).turkey
    },
    {
        id: 'turtle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gEBh))),
        messageDescriptor: (0, $lfFy6.messages).turtle
    },
    {
        id: 'wasp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($absgL))),
        messageDescriptor: (0, $lfFy6.messages).wasp
    },
    {
        id: 'watermelon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($76eQq))),
        messageDescriptor: (0, $lfFy6.messages).watermelon
    },
    {
        id: 'whale',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($68Yx0))),
        messageDescriptor: (0, $lfFy6.messages).whale
    },
    {
        id: 'wolf',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l08I5))),
        messageDescriptor: (0, $lfFy6.messages).wolf
    }
];
module.exports["ANONYMOUS_ASSETS"] = $40b74b738da6af36$export$4522d3d70312bbdc;

});

parcelRegister("lfFy6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $11f365f4e13bb9e0$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    alligator: {
        id: "platform.anonymous-asset-name.alligator",
        defaultMessage: "Anonymous Alligator"
    },
    alpaca: {
        id: "platform.anonymous-asset-name.alpaca",
        defaultMessage: "Anonymous Alpaca"
    },
    ape: {
        id: "platform.anonymous-asset-name.ape",
        defaultMessage: "Anonymous Ape"
    },
    apple: {
        id: "platform.anonymous-asset-name.apple",
        defaultMessage: "Anonymous Apple"
    },
    avocado: {
        id: "platform.anonymous-asset-name.avocado",
        defaultMessage: "Anonymous Avocado"
    },
    baboon: {
        id: "platform.anonymous-asset-name.baboon",
        defaultMessage: "Anonymous Baboon"
    },
    badger: {
        id: "platform.anonymous-asset-name.badger",
        defaultMessage: "Anonymous Badger"
    },
    bat: {
        id: "platform.anonymous-asset-name.bat",
        defaultMessage: "Anonymous Bat"
    },
    bear: {
        id: "platform.anonymous-asset-name.bear",
        defaultMessage: "Anonymous Bear"
    },
    beaver: {
        id: "platform.anonymous-asset-name.beaver",
        defaultMessage: "Anonymous Beaver"
    },
    bee: {
        id: "platform.anonymous-asset-name.bee",
        defaultMessage: "Anonymous Bee"
    },
    bird: {
        id: "platform.anonymous-asset-name.bird",
        defaultMessage: "Anonymous Bird"
    },
    bison: {
        id: "platform.anonymous-asset-name.bison",
        defaultMessage: "Anonymous Bison"
    },
    blobfish: {
        id: "platform.anonymous-asset-name.blobfish",
        defaultMessage: "Anonymous Blobfish"
    },
    blossom: {
        id: "platform.anonymous-asset-name.blossom",
        defaultMessage: "Anonymous Blossom"
    },
    blowfish: {
        id: "platform.anonymous-asset-name.blowfish",
        defaultMessage: "Anonymous Blowfish"
    },
    blueberries: {
        id: "platform.anonymous-asset-name.blueberries",
        defaultMessage: "Anonymous Blueberries"
    },
    boar: {
        id: "platform.anonymous-asset-name.boar",
        defaultMessage: "Anonymous Boar"
    },
    broccoli: {
        id: "platform.anonymous-asset-name.broccoli",
        defaultMessage: "Anonymous Broccoli"
    },
    buffalo: {
        id: "platform.anonymous-asset-name.buffalo",
        defaultMessage: "Anonymous Buffalo"
    },
    bug: {
        id: "platform.anonymous-asset-name.bug",
        defaultMessage: "Anonymous Bug"
    },
    bull: {
        id: "platform.anonymous-asset-name.bull",
        defaultMessage: "Anonymous Bull"
    },
    bunny: {
        id: "platform.anonymous-asset-name.bunny",
        defaultMessage: "Anonymous Bunny"
    },
    butterfly: {
        id: "platform.anonymous-asset-name.butterfly",
        defaultMessage: "Anonymous Butterfly"
    },
    cactus: {
        id: "platform.anonymous-asset-name.cactus",
        defaultMessage: "Anonymous Cactus"
    },
    camel: {
        id: "platform.anonymous-asset-name.camel",
        defaultMessage: "Anonymous Camel"
    },
    candy: {
        id: "platform.anonymous-asset-name.candy",
        defaultMessage: "Anonymous Candy"
    },
    cantaloupe: {
        id: "platform.anonymous-asset-name.cantaloupe",
        defaultMessage: "Anonymous Cantaloupe"
    },
    capsicum: {
        id: "platform.anonymous-asset-name.capsicum",
        defaultMessage: "Anonymous Capsicum"
    },
    carrot: {
        id: "platform.anonymous-asset-name.carrot",
        defaultMessage: "Anonymous Carrot"
    },
    cat: {
        id: "platform.anonymous-asset-name.cat",
        defaultMessage: "Anonymous Cat"
    },
    caterpiller: {
        id: "platform.anonymous-asset-name.caterpiller",
        defaultMessage: "Anonymous Caterpiller"
    },
    chameleon: {
        id: "platform.anonymous-asset-name.chameleon",
        defaultMessage: "Anonymous Chameleon"
    },
    cherry: {
        id: "platform.anonymous-asset-name.cherry",
        defaultMessage: "Anonymous Cherry"
    },
    chili: {
        id: "platform.anonymous-asset-name.chili",
        defaultMessage: "Anonymous Chili"
    },
    chimp: {
        id: "platform.anonymous-asset-name.chimp",
        defaultMessage: "Anonymous Chimp"
    },
    chimpanzee: {
        id: "platform.anonymous-asset-name.chimpanzee",
        defaultMessage: "Anonymous Chimpanzee"
    },
    clover: {
        id: "platform.anonymous-asset-name.clover",
        defaultMessage: "Anonymous Clover"
    },
    clownfish: {
        id: "platform.anonymous-asset-name.clownfish",
        defaultMessage: "Anonymous Clownfish"
    },
    cobra: {
        id: "platform.anonymous-asset-name.cobra",
        defaultMessage: "Anonymous Cobra"
    },
    coconut: {
        id: "platform.anonymous-asset-name.coconut",
        defaultMessage: "Anonymous Coconut"
    },
    cod: {
        id: "platform.anonymous-asset-name.cod",
        defaultMessage: "Anonymous Cod"
    },
    cookie: {
        id: "platform.anonymous-asset-name.cookie",
        defaultMessage: "Anonymous Cookie"
    },
    corn: {
        id: "platform.anonymous-asset-name.corn",
        defaultMessage: "Anonymous Corn"
    },
    cow: {
        id: "platform.anonymous-asset-name.cow",
        defaultMessage: "Anonymous Cow"
    },
    crab: {
        id: "platform.anonymous-asset-name.crab",
        defaultMessage: "Anonymous Crab"
    },
    crocodile: {
        id: "platform.anonymous-asset-name.crocodile",
        defaultMessage: "Anonymous Crocodile"
    },
    deer: {
        id: "platform.anonymous-asset-name.deer",
        defaultMessage: "Anonymous Deer"
    },
    dinosaur: {
        id: "platform.anonymous-asset-name.dinosaur",
        defaultMessage: "Anonymous Dinosaur"
    },
    dodo: {
        id: "platform.anonymous-asset-name.dodo",
        defaultMessage: "Anonymous Dodo"
    },
    dog: {
        id: "platform.anonymous-asset-name.dog",
        defaultMessage: "Anonymous Dog"
    },
    dolphin: {
        id: "platform.anonymous-asset-name.dolphin",
        defaultMessage: "Anonymous Dolphin"
    },
    donut: {
        id: "platform.anonymous-asset-name.donut",
        defaultMessage: "Anonymous Donut"
    },
    dragon: {
        id: "platform.anonymous-asset-name.dragon",
        defaultMessage: "Anonymous Dragon"
    },
    duck: {
        id: "platform.anonymous-asset-name.duck",
        defaultMessage: "Anonymous Duck"
    },
    elephant: {
        id: "platform.anonymous-asset-name.elephant",
        defaultMessage: "Anonymous Elephant"
    },
    elk: {
        id: "platform.anonymous-asset-name.elk",
        defaultMessage: "Anonymous Elk"
    },
    fish: {
        id: "platform.anonymous-asset-name.fish",
        defaultMessage: "Anonymous Fish"
    },
    flamingo: {
        id: "platform.anonymous-asset-name.flamingo",
        defaultMessage: "Anonymous Flamingo"
    },
    fox: {
        id: "platform.anonymous-asset-name.fox",
        defaultMessage: "Anonymous Fox"
    },
    frog: {
        id: "platform.anonymous-asset-name.frog",
        defaultMessage: "Anonymous Frog"
    },
    gecko: {
        id: "platform.anonymous-asset-name.gecko",
        defaultMessage: "Anonymous Gecko"
    },
    giraffe: {
        id: "platform.anonymous-asset-name.giraffe",
        defaultMessage: "Anonymous Giraffe"
    },
    gorilla: {
        id: "platform.anonymous-asset-name.gorilla",
        defaultMessage: "Anonymous Gorilla"
    },
    grape: {
        id: "platform.anonymous-asset-name.grape",
        defaultMessage: "Anonymous Grape"
    },
    hammerhead: {
        id: "platform.anonymous-asset-name.hammerhead",
        defaultMessage: "Anonymous Hammerhead"
    },
    hedgehog: {
        id: "platform.anonymous-asset-name.hedgehog",
        defaultMessage: "Anonymous Hedgehog"
    },
    hippo: {
        id: "platform.anonymous-asset-name.hippo",
        defaultMessage: "Anonymous Hippo"
    },
    kangaroo: {
        id: "platform.anonymous-asset-name.kangaroo",
        defaultMessage: "Anonymous Kangaroo"
    },
    kitten: {
        id: "platform.anonymous-asset-name.kitten",
        defaultMessage: "Anonymous Kitten"
    },
    kiwi: {
        id: "platform.anonymous-asset-name.kiwi",
        defaultMessage: "Anonymous Kiwi"
    },
    koala: {
        id: "platform.anonymous-asset-name.koala",
        defaultMessage: "Anonymous Koala"
    },
    lemon: {
        id: "platform.anonymous-asset-name.lemon",
        defaultMessage: "Anonymous Lemon"
    },
    leopard: {
        id: "platform.anonymous-asset-name.leopard",
        defaultMessage: "Anonymous Leopard"
    },
    lettuce: {
        id: "platform.anonymous-asset-name.lettuce",
        defaultMessage: "Anonymous Lettuce"
    },
    lion: {
        id: "platform.anonymous-asset-name.lion",
        defaultMessage: "Anonymous Lion"
    },
    lizard: {
        id: "platform.anonymous-asset-name.lizard",
        defaultMessage: "Anonymous Lizard"
    },
    llama: {
        id: "platform.anonymous-asset-name.llama",
        defaultMessage: "Anonymous Llama"
    },
    lobster: {
        id: "platform.anonymous-asset-name.lobster",
        defaultMessage: "Anonymous Lobster"
    },
    macaque: {
        id: "platform.anonymous-asset-name.macaque",
        defaultMessage: "Anonymous Macaque"
    },
    mango: {
        id: "platform.anonymous-asset-name.mango",
        defaultMessage: "Anonymous Mango"
    },
    melon: {
        id: "platform.anonymous-asset-name.melon",
        defaultMessage: "Anonymous Melon"
    },
    millipede: {
        id: "platform.anonymous-asset-name.millipede",
        defaultMessage: "Anonymous Millipede"
    },
    monkey: {
        id: "platform.anonymous-asset-name.monkey",
        defaultMessage: "Anonymous Monkey"
    },
    mouse: {
        id: "platform.anonymous-asset-name.mouse",
        defaultMessage: "Anonymous Mouse"
    },
    octopus: {
        id: "platform.anonymous-asset-name.octopus",
        defaultMessage: "Anonymous Octopus"
    },
    olive: {
        id: "platform.anonymous-asset-name.olive",
        defaultMessage: "Anonymous Olive"
    },
    orange: {
        id: "platform.anonymous-asset-name.orange",
        defaultMessage: "Anonymous Orange"
    },
    orangutan: {
        id: "platform.anonymous-asset-name.orangutan",
        defaultMessage: "Anonymous Orangutan"
    },
    otter: {
        id: "platform.anonymous-asset-name.otter",
        defaultMessage: "Anonymous Otter"
    },
    owl: {
        id: "platform.anonymous-asset-name.owl",
        defaultMessage: "Anonymous Owl"
    },
    ox: {
        id: "platform.anonymous-asset-name.ox",
        defaultMessage: "Anonymous Ox"
    },
    oyster: {
        id: "platform.anonymous-asset-name.oyster",
        defaultMessage: "Anonymous Oyster"
    },
    panda: {
        id: "platform.anonymous-asset-name.panda",
        defaultMessage: "Anonymous Panda"
    },
    parrot: {
        id: "platform.anonymous-asset-name.parrot",
        defaultMessage: "Anonymous Parrot"
    },
    peacock: {
        id: "platform.anonymous-asset-name.peacock",
        defaultMessage: "Anonymous Peacock"
    },
    pear: {
        id: "platform.anonymous-asset-name.pear",
        defaultMessage: "Anonymous Pear"
    },
    penguin: {
        id: "platform.anonymous-asset-name.penguin",
        defaultMessage: "Anonymous Penguin"
    },
    pig: {
        id: "platform.anonymous-asset-name.pig",
        defaultMessage: "Anonymous Pig"
    },
    pineapple: {
        id: "platform.anonymous-asset-name.pineapple",
        defaultMessage: "Anonymous Pineapple"
    },
    poodle: {
        id: "platform.anonymous-asset-name.poodle",
        defaultMessage: "Anonymous Poodle"
    },
    puppy: {
        id: "platform.anonymous-asset-name.puppy",
        defaultMessage: "Anonymous Puppy"
    },
    python: {
        id: "platform.anonymous-asset-name.python",
        defaultMessage: "Anonymous Python"
    },
    rabbit: {
        id: "platform.anonymous-asset-name.rabbit",
        defaultMessage: "Anonymous Rabbit"
    },
    raccoon: {
        id: "platform.anonymous-asset-name.raccoon",
        defaultMessage: "Anonymous Raccoon"
    },
    rat: {
        id: "platform.anonymous-asset-name.rat",
        defaultMessage: "Anonymous Rat"
    },
    rhino: {
        id: "platform.anonymous-asset-name.rhino",
        defaultMessage: "Anonymous Rhino"
    },
    robot: {
        id: "platform.anonymous-asset-name.robot",
        defaultMessage: "Anonymous Robot"
    },
    rose: {
        id: "platform.anonymous-asset-name.rose",
        defaultMessage: "Anonymous Rose"
    },
    seal: {
        id: "platform.anonymous-asset-name.seal",
        defaultMessage: "Anonymous Seal"
    },
    seedling: {
        id: "platform.anonymous-asset-name.seedling",
        defaultMessage: "Anonymous Seedling"
    },
    shark: {
        id: "platform.anonymous-asset-name.shark",
        defaultMessage: "Anonymous Shark"
    },
    shrimp: {
        id: "platform.anonymous-asset-name.shrimp",
        defaultMessage: "Anonymous Shrimp"
    },
    skunk: {
        id: "platform.anonymous-asset-name.skunk",
        defaultMessage: "Anonymous Skunk"
    },
    sloth: {
        id: "platform.anonymous-asset-name.sloth",
        defaultMessage: "Anonymous Sloth"
    },
    snail: {
        id: "platform.anonymous-asset-name.snail",
        defaultMessage: "Anonymous Snail"
    },
    snake: {
        id: "platform.anonymous-asset-name.snake",
        defaultMessage: "Anonymous Snake"
    },
    snowman: {
        id: "platform.anonymous-asset-name.snowman",
        defaultMessage: "Anonymous Snowman"
    },
    squid: {
        id: "platform.anonymous-asset-name.squid",
        defaultMessage: "Anonymous Squid"
    },
    squirrel: {
        id: "platform.anonymous-asset-name.squirrel",
        defaultMessage: "Anonymous Squirrel"
    },
    strawberry: {
        id: "platform.anonymous-asset-name.strawberry",
        defaultMessage: "Anonymous Strawberry"
    },
    sunfish: {
        id: "platform.anonymous-asset-name.sunfish",
        defaultMessage: "Anonymous Sunfish"
    },
    sunflower: {
        id: "platform.anonymous-asset-name.sunflower",
        defaultMessage: "Anonymous Sunflower"
    },
    tiger: {
        id: "platform.anonymous-asset-name.tiger",
        defaultMessage: "Anonymous Tiger"
    },
    tomato: {
        id: "platform.anonymous-asset-name.tomato",
        defaultMessage: "Anonymous Tomato"
    },
    tortoise: {
        id: "platform.anonymous-asset-name.tortoise",
        defaultMessage: "Anonymous Tortoise"
    },
    tree: {
        id: "platform.anonymous-asset-name.tree",
        defaultMessage: "Anonymous Tree"
    },
    trex: {
        id: "platform.anonymous-asset-name.trex",
        defaultMessage: "Anonymous T-rex"
    },
    trout: {
        id: "platform.anonymous-asset-name.trout",
        defaultMessage: "Anonymous Trout"
    },
    turkey: {
        id: "platform.anonymous-asset-name.turkey",
        defaultMessage: "Anonymous Turkey"
    },
    turtle: {
        id: "platform.anonymous-asset-name.turtle",
        defaultMessage: "Anonymous Turtle"
    },
    wasp: {
        id: "platform.anonymous-asset-name.wasp",
        defaultMessage: "Anonymous Wasp"
    },
    watermelon: {
        id: "platform.anonymous-asset-name.watermelon",
        defaultMessage: "Anonymous Watermelon"
    },
    whale: {
        id: "platform.anonymous-asset-name.whale",
        defaultMessage: "Anonymous Whale"
    },
    wolf: {
        id: "platform.anonymous-asset-name.wolf",
        defaultMessage: "Anonymous Wolf"
    }
});
module.exports["messages"] = $11f365f4e13bb9e0$export$defe85febe8b728c;

});

parcelRegister("45p5c", function(module, exports) {
module.exports = new URL("apple.ee886279.svg", import.meta.url).toString();

});

parcelRegister("66aLS", function(module, exports) {
module.exports = new URL("avocado.8855629b.svg", import.meta.url).toString();

});

parcelRegister("eA5k9", function(module, exports) {
module.exports = new URL("badger.0fb3ff8d.svg", import.meta.url).toString();

});

parcelRegister("dLHML", function(module, exports) {
module.exports = new URL("bat.3a3e8172.svg", import.meta.url).toString();

});

parcelRegister("5QM3U", function(module, exports) {
module.exports = new URL("bear.6250dade.svg", import.meta.url).toString();

});

parcelRegister("1zbJy", function(module, exports) {
module.exports = new URL("beaver.72239cbc.svg", import.meta.url).toString();

});

parcelRegister("absgL", function(module, exports) {
module.exports = new URL("bee.1d8bfe50.svg", import.meta.url).toString();

});

parcelRegister("i9wU3", function(module, exports) {
module.exports = new URL("bison.4fe77735.svg", import.meta.url).toString();

});

parcelRegister("7BD8h", function(module, exports) {
module.exports = new URL("blossom.90b2a1c3.svg", import.meta.url).toString();

});

parcelRegister("ipNYr", function(module, exports) {
module.exports = new URL("blowfish.8afad7f1.svg", import.meta.url).toString();

});

parcelRegister("5Fo99", function(module, exports) {
module.exports = new URL("blueberries.688d225d.svg", import.meta.url).toString();

});

parcelRegister("futbp", function(module, exports) {
module.exports = new URL("boar.15310caf.svg", import.meta.url).toString();

});

parcelRegister("1tL0q", function(module, exports) {
module.exports = new URL("broccoli.fa9fd55e.svg", import.meta.url).toString();

});

parcelRegister("gsqYV", function(module, exports) {
module.exports = new URL("butterfly.f41d19d4.svg", import.meta.url).toString();

});

parcelRegister("aV0Ix", function(module, exports) {
module.exports = new URL("cactus.0c5c265c.svg", import.meta.url).toString();

});

parcelRegister("7f8BP", function(module, exports) {
module.exports = new URL("camel.6111d481.svg", import.meta.url).toString();

});

parcelRegister("w2g3p", function(module, exports) {
module.exports = new URL("candy.ffd5e59f.svg", import.meta.url).toString();

});

parcelRegister("7pNkU", function(module, exports) {
module.exports = new URL("capsicum.30f76734.svg", import.meta.url).toString();

});

parcelRegister("3saEQ", function(module, exports) {
module.exports = new URL("carrot.6193f6d7.svg", import.meta.url).toString();

});

parcelRegister("bBrvm", function(module, exports) {
module.exports = new URL("cat.154e1595.svg", import.meta.url).toString();

});

parcelRegister("2MJ1F", function(module, exports) {
module.exports = new URL("caterpiller.1b6fd239.svg", import.meta.url).toString();

});

parcelRegister("62PyO", function(module, exports) {
module.exports = new URL("cherry.087938da.svg", import.meta.url).toString();

});

parcelRegister("ct5mQ", function(module, exports) {
module.exports = new URL("chili.27401d1a.svg", import.meta.url).toString();

});

parcelRegister("geCWF", function(module, exports) {
module.exports = new URL("clover.296ea840.svg", import.meta.url).toString();

});

parcelRegister("cA6yA", function(module, exports) {
module.exports = new URL("coconut.69480f00.svg", import.meta.url).toString();

});

parcelRegister("gE9fP", function(module, exports) {
module.exports = new URL("cookie.099bb841.svg", import.meta.url).toString();

});

parcelRegister("6Cmrb", function(module, exports) {
module.exports = new URL("corn.f527dc60.svg", import.meta.url).toString();

});

parcelRegister("7Za1I", function(module, exports) {
module.exports = new URL("cow.e41482e6.svg", import.meta.url).toString();

});

parcelRegister("kgPFA", function(module, exports) {
module.exports = new URL("crab.39812367.svg", import.meta.url).toString();

});

parcelRegister("2hRuV", function(module, exports) {
module.exports = new URL("crocodile.221fa99c.svg", import.meta.url).toString();

});

parcelRegister("8H1nG", function(module, exports) {
module.exports = new URL("deer.3662e324.svg", import.meta.url).toString();

});

parcelRegister("jfdMm", function(module, exports) {
module.exports = new URL("dinosaur.e5c6efb5.svg", import.meta.url).toString();

});

parcelRegister("jAnMk", function(module, exports) {
module.exports = new URL("dodo.a7114237.svg", import.meta.url).toString();

});

parcelRegister("kiped", function(module, exports) {
module.exports = new URL("dog.6630bd37.svg", import.meta.url).toString();

});

parcelRegister("ijRK6", function(module, exports) {
module.exports = new URL("dolphin.3052ec02.svg", import.meta.url).toString();

});

parcelRegister("hQTrZ", function(module, exports) {
module.exports = new URL("donut.e4649522.svg", import.meta.url).toString();

});

parcelRegister("3ussC", function(module, exports) {
module.exports = new URL("dragon.4b6d8278.svg", import.meta.url).toString();

});

parcelRegister("bfQlR", function(module, exports) {
module.exports = new URL("duck.e8819dfa.svg", import.meta.url).toString();

});

parcelRegister("g2zNl", function(module, exports) {
module.exports = new URL("elephant.f64545b1.svg", import.meta.url).toString();

});

parcelRegister("dnUXX", function(module, exports) {
module.exports = new URL("fish.91063cf4.svg", import.meta.url).toString();

});

parcelRegister("ldCFU", function(module, exports) {
module.exports = new URL("flamingo.2d59f884.svg", import.meta.url).toString();

});

parcelRegister("gcvuo", function(module, exports) {
module.exports = new URL("fox.c1068dfa.svg", import.meta.url).toString();

});

parcelRegister("3aulr", function(module, exports) {
module.exports = new URL("frog.4c69f05a.svg", import.meta.url).toString();

});

parcelRegister("jj7JF", function(module, exports) {
module.exports = new URL("giraffe.65216e18.svg", import.meta.url).toString();

});

parcelRegister("gFh8H", function(module, exports) {
module.exports = new URL("gorilla.51f05093.svg", import.meta.url).toString();

});

parcelRegister("ib1i9", function(module, exports) {
module.exports = new URL("grapes.6a50728f.svg", import.meta.url).toString();

});

parcelRegister("7vWf2", function(module, exports) {
module.exports = new URL("hedgehog.4cc9668b.svg", import.meta.url).toString();

});

parcelRegister("MAw5A", function(module, exports) {
module.exports = new URL("hippo.81684e99.svg", import.meta.url).toString();

});

parcelRegister("4R6fR", function(module, exports) {
module.exports = new URL("kangaroo.099f9dd4.svg", import.meta.url).toString();

});

parcelRegister("3G8sv", function(module, exports) {
module.exports = new URL("kiwi.13ce1a05.svg", import.meta.url).toString();

});

parcelRegister("5L3ZL", function(module, exports) {
module.exports = new URL("koala.730a01eb.svg", import.meta.url).toString();

});

parcelRegister("1tIXy", function(module, exports) {
module.exports = new URL("lemon.7d7dfe19.svg", import.meta.url).toString();

});

parcelRegister("gIr5o", function(module, exports) {
module.exports = new URL("lettuce.39b86ec6.svg", import.meta.url).toString();

});

parcelRegister("jMi9Z", function(module, exports) {
module.exports = new URL("lion.191125b1.svg", import.meta.url).toString();

});

parcelRegister("5fTd1", function(module, exports) {
module.exports = new URL("lizard.de3c3103.svg", import.meta.url).toString();

});

parcelRegister("70IXo", function(module, exports) {
module.exports = new URL("llama.d767d641.svg", import.meta.url).toString();

});

parcelRegister("k45BN", function(module, exports) {
module.exports = new URL("lobster.2b4a4d94.svg", import.meta.url).toString();

});

parcelRegister("5t7IX", function(module, exports) {
module.exports = new URL("mango.6b9252cb.svg", import.meta.url).toString();

});

parcelRegister("7y9m7", function(module, exports) {
module.exports = new URL("melon.9c97f1e1.svg", import.meta.url).toString();

});

parcelRegister("kRP7t", function(module, exports) {
module.exports = new URL("monkey.423f2177.svg", import.meta.url).toString();

});

parcelRegister("dLJHp", function(module, exports) {
module.exports = new URL("mouse.3d0aefe8.svg", import.meta.url).toString();

});

parcelRegister("MvguA", function(module, exports) {
module.exports = new URL("octopus.2c0d1056.svg", import.meta.url).toString();

});

parcelRegister("i2wVj", function(module, exports) {
module.exports = new URL("olive.3e3e2c53.svg", import.meta.url).toString();

});

parcelRegister("bqNy3", function(module, exports) {
module.exports = new URL("orange.ed5e97f9.svg", import.meta.url).toString();

});

parcelRegister("5RzHY", function(module, exports) {
module.exports = new URL("orangutan.9fa13362.svg", import.meta.url).toString();

});

parcelRegister("jN43s", function(module, exports) {
module.exports = new URL("otter.1b9e17fe.svg", import.meta.url).toString();

});

parcelRegister("018bO", function(module, exports) {
module.exports = new URL("owl.13d3c4d9.svg", import.meta.url).toString();

});

parcelRegister("c3T8r", function(module, exports) {
module.exports = new URL("ox.0ed06fd3.svg", import.meta.url).toString();

});

parcelRegister("h0256", function(module, exports) {
module.exports = new URL("oyster.ad23795d.svg", import.meta.url).toString();

});

parcelRegister("8O3eM", function(module, exports) {
module.exports = new URL("panda.0b0047af.svg", import.meta.url).toString();

});

parcelRegister("8BcsQ", function(module, exports) {
module.exports = new URL("parrot.6fd92eec.svg", import.meta.url).toString();

});

parcelRegister("ctuOo", function(module, exports) {
module.exports = new URL("peacock.80ac60a6.svg", import.meta.url).toString();

});

parcelRegister("9wms3", function(module, exports) {
module.exports = new URL("pear.c8d37fb0.svg", import.meta.url).toString();

});

parcelRegister("1j7TY", function(module, exports) {
module.exports = new URL("penguin.6577e559.svg", import.meta.url).toString();

});

parcelRegister("4ux8O", function(module, exports) {
module.exports = new URL("pig.2ba131ea.svg", import.meta.url).toString();

});

parcelRegister("44Sb4", function(module, exports) {
module.exports = new URL("pineapple.61ebb967.svg", import.meta.url).toString();

});

parcelRegister("dQMZo", function(module, exports) {
module.exports = new URL("poodle.b40487d6.svg", import.meta.url).toString();

});

parcelRegister("zYoHs", function(module, exports) {
module.exports = new URL("rabbit.b4ce71c1.svg", import.meta.url).toString();

});

parcelRegister("04PGh", function(module, exports) {
module.exports = new URL("raccoon.16b4372e.svg", import.meta.url).toString();

});

parcelRegister("ddSO1", function(module, exports) {
module.exports = new URL("rhino.6dcdebb2.svg", import.meta.url).toString();

});

parcelRegister("ivVMv", function(module, exports) {
module.exports = new URL("robot.fdf311ba.svg", import.meta.url).toString();

});

parcelRegister("eJnd2", function(module, exports) {
module.exports = new URL("rose.22a6e8e6.svg", import.meta.url).toString();

});

parcelRegister("98ut7", function(module, exports) {
module.exports = new URL("seal.de226e3b.svg", import.meta.url).toString();

});

parcelRegister("9q1Vk", function(module, exports) {
module.exports = new URL("seedling.562f3bc0.svg", import.meta.url).toString();

});

parcelRegister("eMHgQ", function(module, exports) {
module.exports = new URL("shark.af44e0c5.svg", import.meta.url).toString();

});

parcelRegister("3LKHJ", function(module, exports) {
module.exports = new URL("shrimp.116d9eea.svg", import.meta.url).toString();

});

parcelRegister("3ZCOi", function(module, exports) {
module.exports = new URL("skunk.a5578a4f.svg", import.meta.url).toString();

});

parcelRegister("5xoX8", function(module, exports) {
module.exports = new URL("sloth.f3e9da22.svg", import.meta.url).toString();

});

parcelRegister("5qhol", function(module, exports) {
module.exports = new URL("snail.06380b65.svg", import.meta.url).toString();

});

parcelRegister("dGRYO", function(module, exports) {
module.exports = new URL("snake.3ead898b.svg", import.meta.url).toString();

});

parcelRegister("6dhVt", function(module, exports) {
module.exports = new URL("snowman.cdcd9574.svg", import.meta.url).toString();

});

parcelRegister("ighEF", function(module, exports) {
module.exports = new URL("squid.0638299b.svg", import.meta.url).toString();

});

parcelRegister("jiyfa", function(module, exports) {
module.exports = new URL("squirrel.e3a31ee3.svg", import.meta.url).toString();

});

parcelRegister("aRWto", function(module, exports) {
module.exports = new URL("strawberry.4111dfb6.svg", import.meta.url).toString();

});

parcelRegister("3VNps", function(module, exports) {
module.exports = new URL("sunflower.ff291a55.svg", import.meta.url).toString();

});

parcelRegister("62BuW", function(module, exports) {
module.exports = new URL("tiger.2ba2da26.svg", import.meta.url).toString();

});

parcelRegister("54a3y", function(module, exports) {
module.exports = new URL("tomato.e755033f.svg", import.meta.url).toString();

});

parcelRegister("cjnzF", function(module, exports) {
module.exports = new URL("tree.e62f2602.svg", import.meta.url).toString();

});

parcelRegister("faukZ", function(module, exports) {
module.exports = new URL("t-rex.d85831fb.svg", import.meta.url).toString();

});

parcelRegister("Ox4am", function(module, exports) {
module.exports = new URL("tropical-fish.797d455e.svg", import.meta.url).toString();

});

parcelRegister("hembw", function(module, exports) {
module.exports = new URL("turkey.a79defab.svg", import.meta.url).toString();

});

parcelRegister("5gEBh", function(module, exports) {
module.exports = new URL("turtle.acbe0058.svg", import.meta.url).toString();

});

parcelRegister("76eQq", function(module, exports) {
module.exports = new URL("watermelon.199e013c.svg", import.meta.url).toString();

});

parcelRegister("68Yx0", function(module, exports) {
module.exports = new URL("whale.cc048b8e.svg", import.meta.url).toString();

});

parcelRegister("l08I5", function(module, exports) {
module.exports = new URL("wolf.a39956da.svg", import.meta.url).toString();

});

parcelRegister("fDtVg", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $hTKp4 = parcelRequire("hTKp4");


var $eUBDm = parcelRequire("eUBDm");


var $hFOxw = parcelRequire("hFOxw");

const $9e6967f04f453315$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $9e6967f04f453315$var$intlCacheMap = new Map();
const $9e6967f04f453315$export$51771ec7613ad564 = async ()=>{
    const key = (0, $hTKp4.getDocument)()?.documentElement?.lang || 'en-US';
    if (!$9e6967f04f453315$var$intlCacheMap.has(key)) {
        const messages = await $9e6967f04f453315$var$fetchMessages(key);
        const cache = (0, $aXWIB.createIntlCache)();
        const intl = (0, $aXWIB.createIntl)({
            locale: key,
            messages: messages
        }, cache);
        $9e6967f04f453315$var$intlCacheMap.set(key, intl);
    }
    return $9e6967f04f453315$var$intlCacheMap.get(key);
};
const $9e6967f04f453315$var$fetchMessages = async (locale)=>{
    try {
        const targetLocale = ($9e6967f04f453315$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $eUBDm.locales)) {
            const messages = await (0, $eUBDm.locales)[targetLocale]();
            return messages.default;
        }
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $eUBDm.locales)) {
            const messages = await (0, $eUBDm.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return 0, $hFOxw.default;
};
module.exports["getIntl"] = $9e6967f04f453315$export$51771ec7613ad564;

});

parcelRegister("eUBDm", function(module, exports) {




























const $6e63713db070a09c$export$df1c34db1371eeed = {
    en: ()=>Promise.resolve((parcelRequire("hFOxw"))),
    cs: ()=>(parcelRequire("kc8TR")),
    da: ()=>(parcelRequire("l3Kdd")),
    de: ()=>(parcelRequire("69yb2")),
    en_GB: ()=>(parcelRequire("cSOaW")),
    en_ZZ: ()=>(parcelRequire("ctTgM")),
    es: ()=>(parcelRequire("7UFmH")),
    fi: ()=>(parcelRequire("9H5BD")),
    fr: ()=>(parcelRequire("gXf6j")),
    hr: ()=>(parcelRequire("3qf4b")),
    hu: ()=>(parcelRequire("d7gDR")),
    it: ()=>(parcelRequire("l2XrF")),
    ja: ()=>(parcelRequire("VVLwh")),
    ko: ()=>(parcelRequire("8mka3")),
    nb: ()=>(parcelRequire("16UCW")),
    nl: ()=>(parcelRequire("6xRKn")),
    pl: ()=>(parcelRequire("1tICX")),
    pt_BR: ()=>(parcelRequire("1nGwo")),
    ru: ()=>(parcelRequire("aVCyQ")),
    sr_RS: ()=>(parcelRequire("gJHrP")),
    sr_YR: ()=>(parcelRequire("lmyN0")),
    sv: ()=>(parcelRequire("fgOYH")),
    th: ()=>(parcelRequire("iASA2")),
    tr: ()=>(parcelRequire("gK9Le")),
    uk: ()=>(parcelRequire("5TJ1f")),
    vi: ()=>(parcelRequire("aaIRG")),
    zh: ()=>(parcelRequire("9nWlJ")),
    zh_TW: ()=>(parcelRequire("4oaks"))
};
module.exports["locales"] = $6e63713db070a09c$export$df1c34db1371eeed;

});

parcelRegister("kc8TR", function(module, exports) {

let $eb3bd4f74933f558$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb3bd4f74933f558$var$load("jMBLi").then(()=>parcelRequire('7ZLoJ'));

});

parcelRegister("l3Kdd", function(module, exports) {

let $f54db99165770b8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f54db99165770b8b$var$load("dKSPa").then(()=>parcelRequire('aEN3l'));

});

parcelRegister("69yb2", function(module, exports) {

let $0127f821ddfc863b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0127f821ddfc863b$var$load("aNGGp").then(()=>parcelRequire('33xoI'));

});

parcelRegister("cSOaW", function(module, exports) {

let $961172f85f6e3edb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $961172f85f6e3edb$var$load("16eqk").then(()=>parcelRequire('kWJx6'));

});

parcelRegister("ctTgM", function(module, exports) {

let $916310dbaec8ddd8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $916310dbaec8ddd8$var$load("smHwh").then(()=>parcelRequire('dbZYo'));

});

parcelRegister("7UFmH", function(module, exports) {

let $5c2dd99cb70ac8a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c2dd99cb70ac8a2$var$load("lLAhl").then(()=>parcelRequire('9KFoy'));

});

parcelRegister("9H5BD", function(module, exports) {

let $70ec7a6fe087c63a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70ec7a6fe087c63a$var$load("7lUpZ").then(()=>parcelRequire('4qdbO'));

});

parcelRegister("gXf6j", function(module, exports) {

let $c57ddebbf836b105$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c57ddebbf836b105$var$load("iFuRL").then(()=>parcelRequire('bIVe0'));

});

parcelRegister("3qf4b", function(module, exports) {

let $27df7cab7356feaf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27df7cab7356feaf$var$load("bwpap").then(()=>parcelRequire('8NtSc'));

});

parcelRegister("d7gDR", function(module, exports) {

let $98c8d68f3df49e25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98c8d68f3df49e25$var$load("2qkmI").then(()=>parcelRequire('cGCVy'));

});

parcelRegister("l2XrF", function(module, exports) {

let $f527e57b693e6f21$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f527e57b693e6f21$var$load("kxYID").then(()=>parcelRequire('9bmhY'));

});

parcelRegister("VVLwh", function(module, exports) {

let $0ae221fff906b001$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ae221fff906b001$var$load("iHsNL").then(()=>parcelRequire('51o1K'));

});

parcelRegister("8mka3", function(module, exports) {

let $6160045ed2e1ab4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6160045ed2e1ab4f$var$load("jGOT0").then(()=>parcelRequire('gLajM'));

});

parcelRegister("16UCW", function(module, exports) {

let $0cf246f0069fd885$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cf246f0069fd885$var$load("3s5dS").then(()=>parcelRequire('2zKQ5'));

});

parcelRegister("6xRKn", function(module, exports) {

let $4c3f843445da2586$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c3f843445da2586$var$load("ffRdF").then(()=>parcelRequire('1nf4f'));

});

parcelRegister("1tICX", function(module, exports) {

let $113b1df702e7a97e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $113b1df702e7a97e$var$load("bS9i1").then(()=>parcelRequire('8l63g'));

});

parcelRegister("1nGwo", function(module, exports) {

let $1018ec47e040097d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1018ec47e040097d$var$load("3ydLu").then(()=>parcelRequire('asVO6'));

});

parcelRegister("aVCyQ", function(module, exports) {

let $7f4d23afc1ab1ef8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f4d23afc1ab1ef8$var$load("lqmbR").then(()=>parcelRequire('FrAje'));

});

parcelRegister("gJHrP", function(module, exports) {

let $c2f28d20061ad1be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2f28d20061ad1be$var$load("3px1j").then(()=>parcelRequire('54f3C'));

});

parcelRegister("lmyN0", function(module, exports) {

let $f8d6a37afb93b948$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8d6a37afb93b948$var$load("1NiRW").then(()=>parcelRequire('3pGwL'));

});

parcelRegister("fgOYH", function(module, exports) {

let $b1dfe4ceecde867c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1dfe4ceecde867c$var$load("auBTD").then(()=>parcelRequire('5D8Rs'));

});

parcelRegister("iASA2", function(module, exports) {

let $d895ed4bca06a46b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d895ed4bca06a46b$var$load("fxn2i").then(()=>parcelRequire('aWxTt'));

});

parcelRegister("gK9Le", function(module, exports) {

let $c30883821cb64545$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c30883821cb64545$var$load("adwGb").then(()=>parcelRequire('34LZI'));

});

parcelRegister("5TJ1f", function(module, exports) {

let $44b502b0c10ff069$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44b502b0c10ff069$var$load("guUGa").then(()=>parcelRequire('2u29z'));

});

parcelRegister("aaIRG", function(module, exports) {

let $767da3c31aa6ce24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $767da3c31aa6ce24$var$load("9bAgX").then(()=>parcelRequire('clDBP'));

});

parcelRegister("9nWlJ", function(module, exports) {

let $01c369634d8d2eb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01c369634d8d2eb9$var$load("HLzfe").then(()=>parcelRequire('9dypO'));

});

parcelRegister("4oaks", function(module, exports) {

let $33216a6e72302c57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33216a6e72302c57$var$load("in5qk").then(()=>parcelRequire('2iJQj'));

});

parcelRegister("hFOxw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1afed9367fc4c445$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $1afed9367fc4c445$export$2e2bcd8739ae039 = {
    'platform.anonymous-asset-name.alligator': 'Anonymous Alligator',
    'platform.anonymous-asset-name.alpaca': 'Anonymous Alpaca',
    'platform.anonymous-asset-name.ape': 'Anonymous Ape',
    'platform.anonymous-asset-name.apple': 'Anonymous Apple',
    'platform.anonymous-asset-name.avocado': 'Anonymous Avocado',
    'platform.anonymous-asset-name.baboon': 'Anonymous Baboon',
    'platform.anonymous-asset-name.badger': 'Anonymous Badger',
    'platform.anonymous-asset-name.bat': 'Anonymous Bat',
    'platform.anonymous-asset-name.bear': 'Anonymous Bear',
    'platform.anonymous-asset-name.beaver': 'Anonymous Beaver',
    'platform.anonymous-asset-name.bee': 'Anonymous Bee',
    'platform.anonymous-asset-name.bird': 'Anonymous Bird',
    'platform.anonymous-asset-name.bison': 'Anonymous Bison',
    'platform.anonymous-asset-name.blobfish': 'Anonymous Blobfish',
    'platform.anonymous-asset-name.blossom': 'Anonymous Blossom',
    'platform.anonymous-asset-name.blowfish': 'Anonymous Blowfish',
    'platform.anonymous-asset-name.blueberries': 'Anonymous Blueberries',
    'platform.anonymous-asset-name.boar': 'Anonymous Boar',
    'platform.anonymous-asset-name.broccoli': 'Anonymous Broccoli',
    'platform.anonymous-asset-name.buffalo': 'Anonymous Buffalo',
    'platform.anonymous-asset-name.bug': 'Anonymous Bug',
    'platform.anonymous-asset-name.bull': 'Anonymous Bull',
    'platform.anonymous-asset-name.bunny': 'Anonymous Bunny',
    'platform.anonymous-asset-name.butterfly': 'Anonymous Butterfly',
    'platform.anonymous-asset-name.cactus': 'Anonymous Cactus',
    'platform.anonymous-asset-name.camel': 'Anonymous Camel',
    'platform.anonymous-asset-name.candy': 'Anonymous Candy',
    'platform.anonymous-asset-name.cantaloupe': 'Anonymous Cantaloupe',
    'platform.anonymous-asset-name.capsicum': 'Anonymous Capsicum',
    'platform.anonymous-asset-name.carrot': 'Anonymous Carrot',
    'platform.anonymous-asset-name.cat': 'Anonymous Cat',
    'platform.anonymous-asset-name.caterpiller': 'Anonymous Caterpiller',
    'platform.anonymous-asset-name.chameleon': 'Anonymous Chameleon',
    'platform.anonymous-asset-name.cherry': 'Anonymous Cherry',
    'platform.anonymous-asset-name.chili': 'Anonymous Chili',
    'platform.anonymous-asset-name.chimp': 'Anonymous Chimp',
    'platform.anonymous-asset-name.chimpanzee': 'Anonymous Chimpanzee',
    'platform.anonymous-asset-name.clover': 'Anonymous Clover',
    'platform.anonymous-asset-name.clownfish': 'Anonymous Clownfish',
    'platform.anonymous-asset-name.cobra': 'Anonymous Cobra',
    'platform.anonymous-asset-name.coconut': 'Anonymous Coconut',
    'platform.anonymous-asset-name.cod': 'Anonymous Cod',
    'platform.anonymous-asset-name.cookie': 'Anonymous Cookie',
    'platform.anonymous-asset-name.corn': 'Anonymous Corn',
    'platform.anonymous-asset-name.cow': 'Anonymous Cow',
    'platform.anonymous-asset-name.crab': 'Anonymous Crab',
    'platform.anonymous-asset-name.crocodile': 'Anonymous Crocodile',
    'platform.anonymous-asset-name.deer': 'Anonymous Deer',
    'platform.anonymous-asset-name.dinosaur': 'Anonymous Dinosaur',
    'platform.anonymous-asset-name.dodo': 'Anonymous Dodo',
    'platform.anonymous-asset-name.dog': 'Anonymous Dog',
    'platform.anonymous-asset-name.dolphin': 'Anonymous Dolphin',
    'platform.anonymous-asset-name.donut': 'Anonymous Donut',
    'platform.anonymous-asset-name.dragon': 'Anonymous Dragon',
    'platform.anonymous-asset-name.duck': 'Anonymous Duck',
    'platform.anonymous-asset-name.elephant': 'Anonymous Elephant',
    'platform.anonymous-asset-name.elk': 'Anonymous Elk',
    'platform.anonymous-asset-name.fish': 'Anonymous Fish',
    'platform.anonymous-asset-name.flamingo': 'Anonymous Flamingo',
    'platform.anonymous-asset-name.fox': 'Anonymous Fox',
    'platform.anonymous-asset-name.frog': 'Anonymous Frog',
    'platform.anonymous-asset-name.gecko': 'Anonymous Gecko',
    'platform.anonymous-asset-name.giraffe': 'Anonymous Giraffe',
    'platform.anonymous-asset-name.gorilla': 'Anonymous Gorilla',
    'platform.anonymous-asset-name.grape': 'Anonymous Grape',
    'platform.anonymous-asset-name.hammerhead': 'Anonymous Hammerhead',
    'platform.anonymous-asset-name.hedgehog': 'Anonymous Hedgehog',
    'platform.anonymous-asset-name.hippo': 'Anonymous Hippo',
    'platform.anonymous-asset-name.kangaroo': 'Anonymous Kangaroo',
    'platform.anonymous-asset-name.kitten': 'Anonymous Kitten',
    'platform.anonymous-asset-name.kiwi': 'Anonymous Kiwi',
    'platform.anonymous-asset-name.koala': 'Anonymous Koala',
    'platform.anonymous-asset-name.lemon': 'Anonymous Lemon',
    'platform.anonymous-asset-name.leopard': 'Anonymous Leopard',
    'platform.anonymous-asset-name.lettuce': 'Anonymous Lettuce',
    'platform.anonymous-asset-name.lion': 'Anonymous Lion',
    'platform.anonymous-asset-name.lizard': 'Anonymous Lizard',
    'platform.anonymous-asset-name.llama': 'Anonymous Llama',
    'platform.anonymous-asset-name.lobster': 'Anonymous Lobster',
    'platform.anonymous-asset-name.macaque': 'Anonymous Macaque',
    'platform.anonymous-asset-name.mango': 'Anonymous Mango',
    'platform.anonymous-asset-name.melon': 'Anonymous Melon',
    'platform.anonymous-asset-name.millipede': 'Anonymous Millipede',
    'platform.anonymous-asset-name.monkey': 'Anonymous Monkey',
    'platform.anonymous-asset-name.mouse': 'Anonymous Mouse',
    'platform.anonymous-asset-name.octopus': 'Anonymous Octopus',
    'platform.anonymous-asset-name.olive': 'Anonymous Olive',
    'platform.anonymous-asset-name.orange': 'Anonymous Orange',
    'platform.anonymous-asset-name.orangutan': 'Anonymous Orangutan',
    'platform.anonymous-asset-name.otter': 'Anonymous Otter',
    'platform.anonymous-asset-name.owl': 'Anonymous Owl',
    'platform.anonymous-asset-name.ox': 'Anonymous Ox',
    'platform.anonymous-asset-name.oyster': 'Anonymous Oyster',
    'platform.anonymous-asset-name.panda': 'Anonymous Panda',
    'platform.anonymous-asset-name.parrot': 'Anonymous Parrot',
    'platform.anonymous-asset-name.peacock': 'Anonymous Peacock',
    'platform.anonymous-asset-name.pear': 'Anonymous Pear',
    'platform.anonymous-asset-name.penguin': 'Anonymous Penguin',
    'platform.anonymous-asset-name.pig': 'Anonymous Pig',
    'platform.anonymous-asset-name.pineapple': 'Anonymous Pineapple',
    'platform.anonymous-asset-name.poodle': 'Anonymous Poodle',
    'platform.anonymous-asset-name.puppy': 'Anonymous Puppy',
    'platform.anonymous-asset-name.python': 'Anonymous Python',
    'platform.anonymous-asset-name.rabbit': 'Anonymous Rabbit',
    'platform.anonymous-asset-name.raccoon': 'Anonymous Raccoon',
    'platform.anonymous-asset-name.rat': 'Anonymous Rat',
    'platform.anonymous-asset-name.rhino': 'Anonymous Rhino',
    'platform.anonymous-asset-name.robot': 'Anonymous Robot',
    'platform.anonymous-asset-name.rose': 'Anonymous Rose',
    'platform.anonymous-asset-name.seal': 'Anonymous Seal',
    'platform.anonymous-asset-name.seedling': 'Anonymous Seedling',
    'platform.anonymous-asset-name.shark': 'Anonymous Shark',
    'platform.anonymous-asset-name.shrimp': 'Anonymous Shrimp',
    'platform.anonymous-asset-name.skunk': 'Anonymous Skunk',
    'platform.anonymous-asset-name.sloth': 'Anonymous Sloth',
    'platform.anonymous-asset-name.snail': 'Anonymous Snail',
    'platform.anonymous-asset-name.snake': 'Anonymous Snake',
    'platform.anonymous-asset-name.snowman': 'Anonymous Snowman',
    'platform.anonymous-asset-name.squid': 'Anonymous Squid',
    'platform.anonymous-asset-name.squirrel': 'Anonymous Squirrel',
    'platform.anonymous-asset-name.strawberry': 'Anonymous Strawberry',
    'platform.anonymous-asset-name.sunfish': 'Anonymous Sunfish',
    'platform.anonymous-asset-name.sunflower': 'Anonymous Sunflower',
    'platform.anonymous-asset-name.tiger': 'Anonymous Tiger',
    'platform.anonymous-asset-name.tomato': 'Anonymous Tomato',
    'platform.anonymous-asset-name.tortoise': 'Anonymous Tortoise',
    'platform.anonymous-asset-name.tree': 'Anonymous Tree',
    'platform.anonymous-asset-name.trex': 'Anonymous T-rex',
    'platform.anonymous-asset-name.trout': 'Anonymous Trout',
    'platform.anonymous-asset-name.turkey': 'Anonymous Turkey',
    'platform.anonymous-asset-name.turtle': 'Anonymous Turtle',
    'platform.anonymous-asset-name.wasp': 'Anonymous Wasp',
    'platform.anonymous-asset-name.watermelon': 'Anonymous Watermelon',
    'platform.anonymous-asset-name.whale': 'Anonymous Whale',
    'platform.anonymous-asset-name.wolf': 'Anonymous Wolf'
};

});

parcelRegister("99F08", function(module, exports) {
const $a1227471ca9b2621$export$435a991cb82816ff = (retryCount, initialDelay = 1000, maxDelay = 30000, factor = 2)=>{
    // Calculate exponential backoff
    const delay = Math.min(initialDelay * Math.pow(factor, retryCount), maxDelay);
    // Add random jitter (between 0 and current delay value)
    return Math.floor(Math.random() * delay);
};
const $a1227471ca9b2621$export$cffaac380b94df26 = async ({ url: url, options: options, shouldRetryOnApiError: shouldRetryOnApiError, retries: retries = 3, baseDelay: baseDelay = 300, maxDelay: maxDelay = 10000 })=>{
    try {
        const response = await fetch(url, options);
        if (response.ok) return {
            success: true,
            result: response
        };
        if (shouldRetryOnApiError) throw new Error('Failed request with an error');
        const errorBody = await response.json();
        return {
            success: false,
            error: new Error(errorBody)
        };
    } catch (error) {
        if (retries > 0) {
            const retryDelay = $a1227471ca9b2621$export$435a991cb82816ff(retries, baseDelay, maxDelay);
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return $a1227471ca9b2621$export$cffaac380b94df26({
                url: url,
                options: options,
                shouldRetryOnApiError: shouldRetryOnApiError,
                retries: retries - 1,
                baseDelay: baseDelay,
                maxDelay: maxDelay
            });
        }
        const newError = error instanceof Error ? error : new Error('An unknown error occurred');
        return {
            success: false,
            error: newError
        };
    }
};
module.exports["fetchWithRetry"] = $a1227471ca9b2621$export$cffaac380b94df26;

});

parcelRegister("5Za2S", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $747ya = parcelRequire("747ya");


var $iby4Y = parcelRequire("iby4Y");

const $8ae4f0f25e352c24$var$STATUS_NOT_FOUND = 404;
const $8ae4f0f25e352c24$var$performRecovery = async (contentId)=>{
    return (0, $iby4Y.experimentalResetCollabServiceMutate)({
        variables: {
            behind: 'COLLAB',
            contentId: contentId
        }
    });
};
const $8ae4f0f25e352c24$var$fireDraftFailureEvent = (error, recoverySucceeded, recoveryError)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'NativeCollabProvider',
            action: 'getDraft',
            actionSubject: 'failure',
            attributes: {
                error: error,
                recoverySucceeded: recoverySucceeded,
                recoveryError: recoveryError
            }
        });
    });
};
const $8ae4f0f25e352c24$var$fireDraftFetchEvent = (state)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'NativeCollabProvider',
            action: 'sentRequest',
            actionSubject: 'NcsDraftEndpoint',
            attributes: {
                state: state
            }
        });
    });
};
const $8ae4f0f25e352c24$var$fetchDraftPromiseWithMetrics = (fetchDraftPromise)=>{
    return fetchDraftPromise.then((response)=>{
        if (response.error) $8ae4f0f25e352c24$var$fireDraftFetchEvent('failure');
        else $8ae4f0f25e352c24$var$fireDraftFetchEvent('success');
        return response;
    }).catch((error)=>{
        $8ae4f0f25e352c24$var$fireDraftFetchEvent('failure');
        throw error;
    });
};
const $8ae4f0f25e352c24$export$1a473231c51c1d5b = (contentId, draftShareId)=>$8ae4f0f25e352c24$export$9a3b244f90691dba(contentId, (0, $747ya.fetchDraft)(contentId, draftShareId));
const $8ae4f0f25e352c24$export$9a3b244f90691dba = (contentId, fetchDraftPromise)=>{
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
    return $8ae4f0f25e352c24$var$fetchDraftPromiseWithMetrics(fetchDraftPromise).then(async ({ draft: draft })=>{
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
        if (draft) {
            const version = draft?.version;
            if (!version) {
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        source: 'NativeCollabProvider',
                        action: 'getDraft',
                        actionSubject: 'version is 0',
                        attributes: {
                            version: version
                        }
                    });
                });
                return null;
            }
            return draft;
        }
        return null;
    }).catch((error)=>{
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
        if (error instanceof (0, $hBkCm.BadStatusError) && error?.response?.status === $8ae4f0f25e352c24$var$STATUS_NOT_FOUND) return $8ae4f0f25e352c24$var$performRecovery(contentId).then((_recoveryResponse)=>{
            $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, true);
            return null;
        }).catch((recoveryError)=>{
            $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, false, recoveryError);
            return null;
        });
        $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, null);
        return null;
    });
};
module.exports["getDraft"] = $8ae4f0f25e352c24$export$1a473231c51c1d5b;
module.exports["getDraftFromPromise"] = $8ae4f0f25e352c24$export$9a3b244f90691dba;

});

parcelRegister("747ya", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $6mKj3 = parcelRequire("6mKj3");


var $fqIt3 = parcelRequire("fqIt3");


var $nIvaQ = parcelRequire("nIvaQ");

async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    // Use cache-first only if SSR rendered AND cache is not stale (within TTL)
    // This prevents stale data during SPA transitions while still benefiting from SSR cache
    const shouldUseCache = (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? window.__SSR_RENDERED__ || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) : window.__SSR_RENDERED__;
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: shouldUseCache ? 'cache-first' : 'network-only'
    });
    const { data: data, errors: errors } = response;
    if (errors && errors.length > 0 || !data?.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}
module.exports["fetchDraft"] = $67d2826966f59cb2$export$af6160a01d539948;

});

parcelRegister("iby4Y", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

var $9kGfD = parcelRequire("9kGfD");


var $b4EKK = parcelRequire("b4EKK");

const $41df7c78720ad922$export$6d7c9d246960833d = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/collab/1.0/content/${variables.contentId}/reset?behind=${variables.behind || 'COLLAB'}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResponseOnSuccess: (response)=>({
                traceId: (0, $9kGfD.getTraceIdFromResponse)(response) ?? ''
            }),
        parseResult: (response)=>({
                experimentalResetCollabService: {
                    traceId: response.traceId
                }
            })
    }).catch(async (error)=>{
        const response = error instanceof (0, $hBkCm.BadStatusError) ? error.response : undefined;
        if (response) throw (0, $b4EKK.getErrorWithResponse)(error, response);
        throw error;
    });
};
module.exports["experimentalResetCollabServiceMutate"] = $41df7c78720ad922$export$6d7c9d246960833d;

});

parcelRegister("b4EKK", function(module, exports) {
function $9a7b0181c65e47f8$export$d882ca6820b0f4f3(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    return error;
}
module.exports["getErrorWithResponse"] = $9a7b0181c65e47f8$export$d882ca6820b0f4f3;

});

parcelRegister("j7xMJ", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");

const $8264c3c0961f9494$export$5ca6730fa0e353e8 = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const client = isGuest || !isLoggedIn || !isLicensed ? 'agg' : 'ccgraphql';
    return {
        client: client
    };
};
module.exports["useFetchUsersClient"] = $8264c3c0961f9494$export$5ca6730fa0e353e8;

});

parcelRegister("2VZOl", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $FOT9i.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $1P1Tu.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $9zUhf.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("8KbKw", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7Sm4c = parcelRequire("7Sm4c");


var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");


var $c0rhi = parcelRequire("c0rhi");


var $lR7wI = parcelRequire("lR7wI");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $2XqLN.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const result = await (0, $c0rhi.queryInterop)({
                query: (0, $lR7wI.default),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                }
            });
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            return result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
        } catch (e) {
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("lR7wI", function(module, exports) {
/**
 * @generated SignedSource<<211def110a73ba9b55b694817b4e12e8>>
 * @relayHash bd2d61cdca16378a4f1f566700b1fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69
const $4abe7e20c4ebe0be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "CollabTokenResponse",
            "kind": "LinkedField",
            "name": "collabToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bd2d61cdca16378a4f1f566700b1fb56",
            "id": "5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69",
            "metadata": {},
            "name": "CollabPermissionTokenQuery",
            "operationKind": "query",
            "text": "query CollabPermissionTokenQuery($contentId:ID!,$draftShareId:String){collabToken(id:$contentId,draftShareId:$draftShareId){token}}"
        }
    };
}();
$4abe7e20c4ebe0be$var$node.hash = "f88c8dd0f4e61065305cc9c5b9a3253b";
var $4abe7e20c4ebe0be$export$2e2bcd8739ae039 = $4abe7e20c4ebe0be$var$node;
module.exports["default"] = $4abe7e20c4ebe0be$export$2e2bcd8739ae039;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("7PuC4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $lSOAM = parcelRequire("lSOAM");

var $i3c1S = parcelRequire("i3c1S");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");


var $1q7H7 = parcelRequire("1q7H7");


var $gw4Bt = parcelRequire("gw4Bt");


var $aWrnw = parcelRequire("aWrnw");


var $fgdVB = parcelRequire("fgdVB");


var $5qUgM = parcelRequire("5qUgM");


var $3VbV8 = parcelRequire("3VbV8");


var $9wGTI = parcelRequire("9wGTI");

const $dcbb265953b20b9a$var$baseConfig = {
    histogram: {
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        }
    ]
};
const $dcbb265953b20b9a$var$NOOP = ()=>{};
const $dcbb265953b20b9a$export$2d5e2a82ee58820b = ({ isAnonymous: isAnonymous, isInitialLoad: isInitialLoad, viewMode: viewMode })=>{
    const segments = [
        (0, $3VbV8.EDITOR_METRIC)
    ];
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC), (0, $1q7H7.PAGE_TREE_METRIC));
    if (!isAnonymous && viewMode === false) segments.push((0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD));
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $dcbb265953b20b9a$var$fmpAsUntilStopTimeMetrics = ()=>{
    return [
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
        (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
    ];
};
const $dcbb265953b20b9a$export$53cdaf364e318f0b = ({ viewMode: viewMode, userId: userId })=>{
    const _isInitialLoad = (0, $6VdZc.isInitial)();
    const expectedPageSegments = $dcbb265953b20b9a$export$2d5e2a82ee58820b({
        isAnonymous: Boolean(!userId),
        isInitialLoad: _isInitialLoad,
        viewMode: viewMode
    });
    const untilExperienceMetricNames = $dcbb265953b20b9a$var$fmpAsUntilStopTimeMetrics();
    // Create a list of untilPageSegments
    // This wraps the segments into an UntilExperience, so that @atlassian/browser-metrics can handle useFmpAsUntilStopTime gracefully
    // Note - this only affect initial load since transitions are not SSR'd, hence page-segments do not have fmp marks
    // More information why useFmpAsUntilStopTime can be found here
    // https://hello.atlassian.net/wiki/spaces/~484600559/pages/1515596554/Toolings+Update+Browser-Metrics+FMP+TTI
    const untilPageSegments = expectedPageSegments.map((segment)=>({
            experience: segment,
            useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
        }));
    const pageLoadMetric = (0, $lSOAM.createPageLoadMetric)({
        ...$dcbb265953b20b9a$var$baseConfig,
        key: (0, $1UCmC.LIVE_PAGE_LOAD_KEY),
        timings: [
            ...$dcbb265953b20b9a$var$baseConfig.timings,
            ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
        ],
        include: expectedPageSegments,
        until: untilPageSegments,
        reactUFOName: (0, $1UCmC.LIVE_PAGE_REACT_UFO_LOAD_KEY)
    });
    if (!_isInitialLoad) // Make sure all segments are re-started and not currently marked as finished from a previous navigation
    expectedPageSegments.forEach((m)=>m.startFromPageLoad());
    pageLoadMetric.startPageLoad();
    pageLoadMetric.onStop(()=>{
        (0, $7fw2E.markBrowserMetricEnd)(pageLoadMetric);
    }, $dcbb265953b20b9a$var$NOOP);
    pageLoadMetric.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
    return pageLoadMetric;
};
const $dcbb265953b20b9a$export$22d97e8b0fdc8888 = ({ contentId: contentId, viewMode: viewMode })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        const pageLoadMetric = $dcbb265953b20b9a$export$53cdaf364e318f0b({
            viewMode: viewMode,
            userId: userId ?? undefined
        });
        return ()=>{
            pageLoadMetric?.cancel();
        };
    }, [
        contentId,
        userId,
        viewMode
    ]);
    return null;
};
module.exports["startLivePageLoadMetrics"] = $dcbb265953b20b9a$export$53cdaf364e318f0b;
module.exports["StartLivePageLoad"] = $dcbb265953b20b9a$export$22d97e8b0fdc8888;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["PUBLIC_LINKS_SPACE_SETTINGS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$4716363caa82a23b;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("8w1c1", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("gw4Bt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("aWrnw", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("fgdVB", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $70b3fb0961586b52$export$ac619e1da09d5f80 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["OBJECT_SIDEBAR_CONTROL_METRIC"] = $70b3fb0961586b52$export$ac619e1da09d5f80;

});

parcelRegister("5qUgM", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $15M40 = parcelRequire("15M40");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("7d41Y", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("15M40", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $8336b070b3684358$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $8336b070b3684358$export$8fdec53caa79133c;

});

parcelRegister("3VbV8", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $1UCmC = parcelRequire("1UCmC");

var $jX1qB = parcelRequire("jX1qB");

var $fd6g2 = parcelRequire("fd6g2");

const $3fce579e2620525b$export$dfd790981c086398 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.FABRIC_PUBLISH_PAGE_KEY),
    histogram: {
        duration: '1000_2000_3000_4000_5000_6000_7000_8000_9000'
    }
});
const $3fce579e2620525b$export$5ac2615d36b4500c = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.EDIT_PAGE_LOAD_KEY),
    timings: [
        {
            key: 'onBeforeEditor',
            endMark: 'onBeforeEditor'
        },
        {
            key: 'editorRendered',
            startMark: 'onBeforeEditor'
        }
    ]
});
const $3fce579e2620525b$export$c5146b9e6a61ee5f = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_SEGMENT_KEY)
});
const $3fce579e2620525b$export$af294f5bd71dc2d = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.NCS_CONNECTED_FMP_KEY)
});
const $3fce579e2620525b$export$f9b776b1c66e5f0e = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.EMBEDDED_EDIT_PAGE_LOAD_KEY)
});
module.exports["FABRIC_PUBLISH_PAGE_METRIC"] = $3fce579e2620525b$export$dfd790981c086398;
module.exports["EDIT_PAGE_LOAD"] = $3fce579e2620525b$export$5ac2615d36b4500c;
module.exports["EDITOR_METRIC"] = $3fce579e2620525b$export$c5146b9e6a61ee5f;
module.exports["EMBEDDED_EDIT_PAGE_LOAD"] = $3fce579e2620525b$export$f9b776b1c66e5f0e;

});

parcelRegister("7sfG4", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $b8665882fb9937b5$var$actions = {
    setIsPageBeingRemoved: (isPageBeingRemoved)=>({ setState: setState })=>{
            setState({
                isPageBeingRemoved: isPageBeingRemoved
            });
        }
};
const $b8665882fb9937b5$var$pageRemovalStore = (0, $1P1Tu.createStore)({
    initialState: {
        isPageBeingRemoved: false
    },
    actions: $b8665882fb9937b5$var$actions,
    name: 'pageRemovalState'
});
const $b8665882fb9937b5$export$119fb6f7943a4824 = (0, $9zUhf.createHook)($b8665882fb9937b5$var$pageRemovalStore);
const $b8665882fb9937b5$export$8b0a971a28ad31af = (0, $9zUhf.createActionsHook)($b8665882fb9937b5$var$pageRemovalStore);
module.exports["usePageRemovalState"] = $b8665882fb9937b5$export$119fb6f7943a4824;
module.exports["usePageRemovalStateActions"] = $b8665882fb9937b5$export$8b0a971a28ad31af;

});

parcelRegister("9ohnn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hYoU4 = parcelRequire("hYoU4");


var $1sAC2 = parcelRequire("1sAC2");

const $173e9417c57854b2$export$2257bd3a33884363 = (collabEditProvider, contentId)=>{
    const [{ collabEditConnected: collabEditConnected }, nativeCollabActions] = (0, $hYoU4.useNativeCollabConnected)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = ()=>{
            nativeCollabActions.setCollabEditConnected(true);
            (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
            // tracking time between when 'init' event is fired and connection has been established
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT_DOC);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
                message: 'NCS Connected'
            });
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider,
        nativeCollabActions,
        contentId,
        experienceTracker
    ]);
    return {
        isCollabProviderConnected: collabEditConnected
    };
};
module.exports["useConnected"] = $173e9417c57854b2$export$2257bd3a33884363;

});

parcelRegister("dTb09", function(module, exports) {
// Shorthand alias for the global cache map key because it's (intentionally) a long name
const $7b24741974f5c34f$var$CACHE_MAP_KEY = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
// Initialize the global cache map once
globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] || new WeakMap();
function $7b24741974f5c34f$export$e328888e5cffce88() {
    globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = new WeakMap();
}
function $7b24741974f5c34f$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $7b24741974f5c34f$export$691e93bad45e6f07;

});

parcelRegister("9uAPw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7dgT3 = parcelRequire("7dgT3");


var $cl98v = parcelRequire("cl98v");


var $jHGaM = parcelRequire("jHGaM");


var $4R3wx = parcelRequire("4R3wx");

const $a5710166add0079d$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorTitleRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.title.recording-already-in-progress",
        defaultMessage: "Recording already in progress"
    },
    errorTitleNotReady: {
        id: "loom-utils.error-flag.title.not-ready",
        defaultMessage: "The Loom recorder wasn\u2019t ready"
    },
    errorIncompatibleBrowser: {
        id: "loom-utils.error-flag.description.incompatible-browser",
        defaultMessage: "The browser you\u2019re currently using isn\u2019t compatible with Loom (or you could be trying to use it in private/incognito mode). <a>Which browsers are compatible?</a>"
    },
    errorThirdPartyCookieDisabled: {
        id: "loom-utils.error-flag.description.third-party-cookie-disabled",
        defaultMessage: "Check that you have third-party cookies enabled, then try again."
    },
    errorNoMediaStreamSupport: {
        id: "loom-utils.error-flag.description.no-media-stream-support",
        defaultMessage: "You might need to try a different browser. <a>Which browsers are compatible?</a>"
    },
    errorSDKNotInitialized: {
        id: "loom-utils.error-flag.description.sdk-not-initialized",
        defaultMessage: "Try to start recording again now."
    },
    errorBackendFFNotEnabledYet: {
        id: "loom-utils.error-flag.description.be-ff-not-enabled-yet",
        defaultMessage: "Loom was recently enabled. Try again in a few minutes."
    },
    errorUnexpectedAuthTokenFailure: {
        id: "loom-utils.error-flag.description.unexpected-auth-token-failure",
        defaultMessage: "Something went wrong with the Loom recorder. Try again later, or contact Atlassian Support for help."
    },
    errorLoomUserNotCreatedYet: {
        id: "loom-utils.error-flag.description.loom-user-not-created-yet",
        defaultMessage: "Loom is enabled, just give us a few minutes to set everything up. You can try recording again in a bit."
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    },
    errorRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.description.recording-already-in-progress",
        defaultMessage: "Finish your current Loom video so you can start another."
    }
});
const $a5710166add0079d$var$LoomSDKSupportLink = 'https://support.loom.com/hc/en-us/articles/360020667617-loomSDK-FAQ';
function $a5710166add0079d$var$getUnsupportedSDKErrorDescription(error) {
    if (error === 'third-party-cookies-disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorThirdPartyCookieDisabled);
    else if (error === 'no-media-streams-support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorNoMediaStreamSupport,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
    else if (error === 'incompatible-browser') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorIncompatibleBrowser,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
}
const $a5710166add0079d$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, flags: flags, resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount = false })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const [singletonLoomSDK, { initLoomSDK: initLoomSDK }] = (0, $jHGaM.useLoomEntryPointGlobalState)();
    const [isOpeningRecorder, setIsOpeningRecorder] = (0, $42omo.useState)(false);
    const runningSDKButton = (0, $42omo.useRef)(null);
    // the call site for openLoomRecorder might be outside of React lifecycle
    // (e.g. editor DOM button onclick) so we need to ensure we maintain reference
    const singletonLoomSDKRef = (0, $42omo.useRef)(singletonLoomSDK);
    singletonLoomSDKRef.current = singletonLoomSDK;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') initLoomSDK({
            cloudId: cloudId,
            environment: environment,
            entryPointLocation: entryPointLocation
        });
    }, [
        initLoomSDK,
        cloudId,
        createAnalyticsEvent,
        environment,
        entryPointVariant,
        entryPointLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (resetInsertFunctionOnUnmount && runningSDKButton.current && singletonLoomSDKRef.current.initializedLoomSDK) {
                singletonLoomSDKRef.current.initializedLoomSDK.updateConfig({
                    config: {
                        insertButtonText: 'Open on Loom'
                    }
                });
                runningSDKButton.current.off('insert-click');
                runningSDKButton.current.on('insert-click', (video)=>{
                    window.open(video.sharedUrl, '_blank');
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            inserted: true,
                            insertFunctionWasReset: true
                        }
                    });
                    /**
           * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
           * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
           */ createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: entryPointLocation,
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'insertVideoLink',
                            attributes: {
                                insertFunctionWasReset: true
                            }
                        }
                    }).fire();
                });
            }
        };
    }, [
        entryPointLocation,
        resetInsertFunctionOnUnmount,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const openLoomRecorder = (0, $42omo.useCallback)(async (loomRecorderParams)=>{
        if (singletonLoomSDKRef.current.initializedLoomSDK && singletonLoomSDKRef.current.initializedLoomSDK.status().state === 'active-recording') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleRecordingAlreadyInProgress),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorRecordingAlreadyInProgress)
            });
            return;
        }
        experienceTracker.start({
            name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (singletonLoomSDKRef.current.isInitializing) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleNotReady),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKNotInitialized)
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: 'SDK has not been configured yet.'
            });
            return;
        }
        // TODO CTIA- 2019: fire a clicked UI event here
        if (singletonLoomSDKRef.current.isLoomSDKSupportedError) {
            const description = $a5710166add0079d$var$getUnsupportedSDKErrorDescription(singletonLoomSDKRef.current.isLoomSDKSupportedError);
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: description
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: `SDK not supported: ${singletonLoomSDKRef.current.isLoomSDKSupportedError}.`
            });
            return;
        }
        if (!singletonLoomSDKRef.current.hasRecordingAccess) {
            const noRecordingAccessReason = singletonLoomSDKRef.current.noRecordingAccessReason;
            if (noRecordingAccessReason === 'backendFF') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorBackendFFNotEnabledYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'loom enablement in progress'
                });
            } else if (noRecordingAccessReason === 'not-created') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorLoomUserNotCreatedYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'user not created yet'
                });
            } else if (noRecordingAccessReason === 'not-mastered' || noRecordingAccessReason === 'not-mastered-enterprise') {
                // mastering for enterprise users is not available until M3
                const isMasteringFlowEnabledForEdition = noRecordingAccessReason !== 'not-mastered-enterprise';
                showModal((0, $7dgT3.NonMasteredUserModalLoader), {
                    isMasteringFlowEnabled: isMasteringFlowEnabledForEdition
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'Does not have access to record looms from Confluence.',
                    attributes: {
                        noRecordingAccessReason: noRecordingAccessReason
                    }
                });
            } else {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorUnexpectedAuthTokenFailure)
                });
                experienceTracker.fail({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    error: singletonLoomSDKRef.current.authTokenError || new Error('unexpected error from Loom auth token or Loom user status')
                });
            }
            return;
        }
        if (!singletonLoomSDKRef.current.initializedLoomSDK || !singletonLoomSDKRef.current.initializedLoomSDK.status().success) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKFailedToInitialize)
            });
            experienceTracker.fail({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                error: singletonLoomSDKRef.current.initializedLoomSDKError || new Error('Loom SDK did not successfully initialize.'),
                attributes: {
                    loomSDKSuccessStatus: singletonLoomSDKRef.current.initializedLoomSDK?.status()?.success
                }
            });
            return;
        }
        (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        setIsOpeningRecorder(true);
        createAnalyticsEvent({
            // a track event is fired once recorder is opened, this event is speficially used for monitoring in StatSig
            type: 'sendTrackEvent',
            data: {
                source: entryPointLocation,
                action: 'opened',
                actionSubject: 'loomSdkRecorder'
            }
        }).fire();
        const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current.initializedLoomSDK;
        const sdkButton = configureButton();
        updateConfig({
            config: {
                insertButtonText: loomRecorderParams ? loomRecorderParams.insertButtonText : undefined,
                entryPointName: entryPointLocation
            }
        });
        if (loomRecorderParams) sdkButton.on('insert-click', async (video_0)=>{
            // TODO CTIA-2019: fire a inserted track event here
            loomRecorderParams.onInsert(video_0.sharedUrl, video_0);
            experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    inserted: true
                }
            });
            /**
         * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
         * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
         */ createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'insertVideoLink',
                    attributes: {
                        insertFunctionWasReset: false
                    }
                }
            }).fire();
        });
        sdkButton.on('start', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingStart'
                }
            }).fire();
        });
        sdkButton.on('recording-start', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'started',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('cancel', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingCancel'
                }
            }).fire();
        });
        sdkButton.on('complete', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingComplete',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('recording-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('upload-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'uploaded',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('lifecycle-update', (lifecycleState)=>{
            if (lifecycleState === 'pre-recording') {
                (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                setIsOpeningRecorder(false);
            } else if (lifecycleState === 'closed') {
                runningSDKButton.current = null;
                experienceTracker.succeed({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        closed: true,
                        insertFunctionDefined: loomRecorderParams !== undefined
                    }
                });
            } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    cascaded: true,
                    entryPointLocation: entryPointLocation
                }
            });
        });
        sdkButton.openPreRecordPanel();
        runningSDKButton.current = sdkButton;
    }, [
        entryPointLocation,
        experienceTracker,
        flags,
        showModal,
        createAnalyticsEvent
    ]);
    return {
        openLoomRecorder: openLoomRecorder,
        isOpeningRecorder: isOpeningRecorder,
        isLoomRecorderInitialized: !singletonLoomSDKRef.current.isInitializing,
        hasRecordingAccess: singletonLoomSDKRef.current.hasRecordingAccess
    };
};
module.exports["useLoomRecorderEntryPoint"] = $a5710166add0079d$export$c8d9dc913e9e33ec;

});

parcelRegister("7dgT3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n2Ktr",
    name: "NonMasteredUserModalLoader",
    loader: async ()=>(await (parcelRequire("g2fKo"))).NonMasteredUserModal
});
module.exports["NonMasteredUserModalLoader"] = $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f;

});

parcelRegister("g2fKo", function(module, exports) {

let $bac90c565c4e75f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bac90c565c4e75f7$var$load("hhss7"),
    $bac90c565c4e75f7$var$load("np2ZB")
]).then(()=>parcelRequire('6i2Ga'));

});

parcelRegister("cl98v", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $dd21d598b55c38cc$export$873f91e3be81ab94 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.OPEN_LOOM_RECORDER_SDK_INTERACTION)
});
const $dd21d598b55c38cc$export$bf1068aa9f020d8f = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION)
});
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$873f91e3be81ab94;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$bf1068aa9f020d8f;

});

parcelRegister("jHGaM", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cl98v = parcelRequire("cl98v");


var $3d6VZ = parcelRequire("3d6VZ");


var $gmNpb = parcelRequire("gmNpb");


var $38NxZ = parcelRequire("38NxZ");

const $82feff28757ef801$var$initialState = {
    isInitializing: true,
    initializedLoomSDK: null,
    _hasLoomSDKInitializationStarted: false,
    hasRecordingAccess: false,
    noRecordingAccessReason: undefined,
    authTokenError: undefined,
    isLoomSDKSupportedError: undefined,
    initializedLoomSDKError: null
};


const $82feff28757ef801$var$initSDK = ({ cloudId: cloudId, environment: environment, entryPointLocation: entryPointLocation })=>async ({ getState: getState, setState: setState })=>{
        if (getState().initializedLoomSDK || getState()._hasLoomSDKInitializationStarted) // singleton: only want 1 Loom SDK instance
        return;
        setState({
            _hasLoomSDKInitializationStarted: true
        });
        (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        try {
            const { isSupported: isSupported } = await (parcelRequire("aWuvK"));
            const { supported: supported, error: isLoomSDKSupportedError } = await isSupported();
            if (!supported) {
                setState({
                    isLoomSDKSupportedError: isLoomSDKSupportedError,
                    isInitializing: false
                });
                (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                return;
            }
        } catch  {
            // If SDK isSupported import/exec fails: treat as incompatible browser
            setState({
                isLoomSDKSupportedError: 'incompatible-browser',
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        const { recorderToken: recorderToken, tokenError: tokenError } = await (0, $3d6VZ.getAuthToken)();
        if (!recorderToken || tokenError) {
            const noRecordingAccessReason = await (0, $38NxZ.getNoRecordingAccessReason)(tokenError);
            setState({
                isInitializing: false,
                noRecordingAccessReason: noRecordingAccessReason,
                authTokenError: tokenError
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        setState({
            hasRecordingAccess: true
        });
        try {
            const { createInstance: createInstance } = await (parcelRequire("3NILU"));
            const initializedLoomSDK = await createInstance((0, $gmNpb.getLoomInstanceDataByEnvironment)({
                environment: environment,
                jws: recorderToken,
                siteId: cloudId,
                entryPointName: entryPointLocation
            }));
            setState({
                initializedLoomSDK: initializedLoomSDK,
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
        } catch (err) {
            setState({
                isInitializing: false,
                initializedLoomSDKError: err
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        }
    };
const $82feff28757ef801$var$actions = {
    initLoomSDK: $82feff28757ef801$var$initSDK
};
const $82feff28757ef801$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: $82feff28757ef801$var$initialState,
    actions: $82feff28757ef801$var$actions,
    name: 'loomEntryPointGlobalStateStore'
});
const $82feff28757ef801$export$160753b85ca93fc7 = (0, $9zUhf.createHook)($82feff28757ef801$export$6f57813fe9f31bf9);
module.exports["useLoomEntryPointGlobalState"] = $82feff28757ef801$export$160753b85ca93fc7;

});

parcelRegister("3d6VZ", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $e01Lp = parcelRequire("e01Lp");


var $55UbZ = parcelRequire("55UbZ");

const $000d418a80b56fba$export$38e1f53b76ec7fed = async ()=>{
    try {
        const tokenQuery = await (0, $c0rhi.queryInterop)({
            query: (0, $e01Lp.LoomAuthTokenQuery),
            fetchPolicy: 'network-only'
        });
        return {
            recorderToken: tokenQuery.data.loomToken?.token
        };
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return {
            tokenError: e
        };
    }
};
const $000d418a80b56fba$export$36491da625b5403b = async ()=>{
    try {
        const authStateQuery = await (0, $c0rhi.queryInterop)({
            query: (0, $55UbZ.LoomAuthStateQuery)
        });
        return authStateQuery.data.loomUserStatus ?? undefined;
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return undefined;
    }
};
module.exports["getAuthToken"] = $000d418a80b56fba$export$38e1f53b76ec7fed;
module.exports["getAuthState"] = $000d418a80b56fba$export$36491da625b5403b;

});

parcelRegister("e01Lp", function(module, exports) {

var $ja27m = parcelRequire("ja27m");

const $eeb31b52c8d53ac0$export$68069cc596b806b = (0, $ja27m.default);
module.exports["LoomAuthTokenQuery"] = $eeb31b52c8d53ac0$export$68069cc596b806b;

});

parcelRegister("ja27m", function(module, exports) {
/**
 * @generated SignedSource<<6d7aa48f14ef5e7adeefdaf3e212165c>>
 * @relayHash c1b04759e5b09153deee6b2b9fb9afcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374
const $4984e0489bd92eb4$var$node = function() {
    var v0 = [
        {
            "concreteType": "LoomToken",
            "kind": "LinkedField",
            "name": "loomToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "LoomAuthTokenQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoomAuthTokenQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c1b04759e5b09153deee6b2b9fb9afcf",
            "id": "9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374",
            "metadata": {},
            "name": "LoomAuthTokenQuery",
            "operationKind": "query",
            "text": "query LoomAuthTokenQuery{loomToken{token}}"
        }
    };
}();
$4984e0489bd92eb4$var$node.hash = "cc249b7610e84f631da05d42ccd02363";
var $4984e0489bd92eb4$export$2e2bcd8739ae039 = $4984e0489bd92eb4$var$node;
module.exports["default"] = $4984e0489bd92eb4$export$2e2bcd8739ae039;

});

parcelRegister("55UbZ", function(module, exports) {

var $bj1zQ = parcelRequire("bj1zQ");

const $80afd1194d3d0c84$export$ee3fd3c5221b99c = (0, $bj1zQ.default);
module.exports["LoomAuthStateQuery"] = $80afd1194d3d0c84$export$ee3fd3c5221b99c;

});

parcelRegister("bj1zQ", function(module, exports) {
/**
 * @generated SignedSource<<065e048a6863c47e4cc7a794a3874874>>
 * @relayHash 92b5f865f5d3e169ae4c9331a8c93231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63
const $c5c9d2025b35af51$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "loomUserStatus"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "LoomAuthStateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoomAuthStateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "92b5f865f5d3e169ae4c9331a8c93231",
            "id": "b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63",
            "metadata": {},
            "name": "LoomAuthStateQuery",
            "operationKind": "query",
            "text": "query LoomAuthStateQuery{loomUserStatus}"
        }
    };
}();
$c5c9d2025b35af51$var$node.hash = "b0b71e4c1a4d03a9f0016476ce67cefb";
var $c5c9d2025b35af51$export$2e2bcd8739ae039 = $c5c9d2025b35af51$var$node;
module.exports["default"] = $c5c9d2025b35af51$export$2e2bcd8739ae039;

});

parcelRegister("gmNpb", function(module, exports) {
const $39913087ba6f73e2$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $39913087ba6f73e2$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: 'Confluence',
            entryPointName: entryPointName
        }
    };
    if (environment === 'DEVELOPMENT') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    if (environment === 'STAGING') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.staging,
        environment: 'staging' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $39913087ba6f73e2$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
};
module.exports["getLoomInstanceDataByEnvironment"] = $39913087ba6f73e2$export$c150e4a8d8a3ab35;

});

parcelRegister("38NxZ", function(module, exports) {

var $3d6VZ = parcelRequire("3d6VZ");


var $dn8bs = parcelRequire("dn8bs");

const $0e5a08ec05b30096$var$graphqlErrorHasMessage = (error, messageMatch)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>message.includes(messageMatch));
    return false;
};
const $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE = 'Attempted to fetch Loom token without feature flag enabled';
const $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE = 'Failed to fetch loom auth token. Status code: 404';
const $0e5a08ec05b30096$export$5a9a2c39ccb5534c = async (tokenError)=>{
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE)) return 'backendFF';
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE)) {
        const authState = await (0, $3d6VZ.getAuthState)();
        if (authState === (0, $dn8bs.LoomUserStatus).NOT_FOUND) return 'not-created';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED) return 'not-mastered';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED_ENTERPRISE) return 'not-mastered-enterprise';
    }
    return 'unexpected';
};
module.exports["getNoRecordingAccessReason"] = $0e5a08ec05b30096$export$5a9a2c39ccb5534c;

});

parcelRegister("dn8bs", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $80735413f00f04fc$export$9d643cbb1392f8e6 = /*#__PURE__*/ function(LoomUserStatus) {
    LoomUserStatus["LINKED"] = "LINKED";
    LoomUserStatus["LINKED_ENTERPRISE"] = "LINKED_ENTERPRISE";
    LoomUserStatus["MASTERED"] = "MASTERED";
    LoomUserStatus["NOT_FOUND"] = "NOT_FOUND";
    return LoomUserStatus;
}({});
module.exports["LoomUserStatus"] = $80735413f00f04fc$export$9d643cbb1392f8e6;

});

parcelRegister("aWuvK", function(module, exports) {

let $7f76fd05798145a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f76fd05798145a7$var$load("lwKXH"),
    $7f76fd05798145a7$var$load("4byV5")
]).then(()=>parcelRequire('3f9PV'));

});

parcelRegister("3NILU", function(module, exports) {

let $2c48ad74de33276c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2c48ad74de33276c$var$load("lkOIY"),
    $2c48ad74de33276c$var$load("4pqtR"),
    $2c48ad74de33276c$var$load("5XqRg"),
    $2c48ad74de33276c$var$load("6wr18"),
    $2c48ad74de33276c$var$load("a3Uq6"),
    $2c48ad74de33276c$var$load("fFJCh"),
    $2c48ad74de33276c$var$load("jle6Z"),
    $2c48ad74de33276c$var$load("4drdS"),
    $2c48ad74de33276c$var$load("lLK0D"),
    $2c48ad74de33276c$var$load("ffqKi"),
    $2c48ad74de33276c$var$load("wIOhQ"),
    $2c48ad74de33276c$var$load("kHsGR"),
    $2c48ad74de33276c$var$load("28l1x"),
    $2c48ad74de33276c$var$load("lwKXH"),
    $2c48ad74de33276c$var$load("1okAQ"),
    $2c48ad74de33276c$var$load("fisfU"),
    $2c48ad74de33276c$var$load("9a2oY"),
    $2c48ad74de33276c$var$load("ffEVr"),
    $2c48ad74de33276c$var$load("7EorR"),
    $2c48ad74de33276c$var$load("btYwu")
]).then(()=>parcelRequire('fIeud'));

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, t4);
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<ce6a8bce73876f32a04d2f7fd2550f0b>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $42omo.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7bddefba16e0e3fb2655c6e8a82785c2>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $5spQU = parcelRequire("5spQU");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("9Zt9E", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $4R3wx = parcelRequire("4R3wx");

const $bd6eb7a689d25f96$var$shouldRenderButton = (entryPointVariant, appearance)=>{
    if (appearance === 'comment') return entryPointVariant !== 'NONE' && entryPointVariant !== 'CROSS_FLOW';
    return entryPointVariant !== 'NONE';
};
const $bd6eb7a689d25f96$export$4e56214a02095203 = ({ EditorButtonComponent: EditorButtonComponent, editorAPIRef: editorAPIRef, editorShouldShowToolbarLoomButton: editorShouldShowToolbarLoomButton, appearance: appearance })=>{
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const entryPointVariantRef = (0, $42omo.useRef)(entryPointVariant);
    /**
	 * The Loom plugin should be enabled for all non-disabled Loom entrypoints.
	 *
	 * This has to be determined on the initial call of the hook (due to the way plugin initialization works).
	 * It should also still be OK if the plugin is enabled even for edge cases where the entrypoint is
	 * asynchronously determined to be disabled (e.g., when a site has opted out of cross-flow ads) because:
	 *
	 * `useInitializeLoomPlugin` will handle the conditions for initializing the plugin (to enable recording) and
	 * `EditorButtonComponent` will handle conditional rendering (in some cases, even returning `null` to dynamically
	 * hide the button)
	 */ const isPluginEnabled = entryPointVariant !== 'DISABLED';
    // [ED-27497] IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/loomPluginOptions.ts
    const pluginOptions = (0, $42omo.useMemo)(()=>{
        return {
            renderButton: (ButtonComponent)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditorButtonComponent, {
                    buttonComponent: ButtonComponent,
                    editorAPIRef: editorAPIRef
                });
            },
            shouldRenderButton: (0, $6mKj3.expVal)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', false) ? ()=>$bd6eb7a689d25f96$var$shouldRenderButton(entryPointVariantRef.current, appearance) : undefined,
            ...editorShouldShowToolbarLoomButton !== undefined ? {
                shouldShowToolbarButton: editorShouldShowToolbarLoomButton
            } : {}
        };
    // Intentionally not recreating/updating the plugin options in order to remain consistent with
    // the behavior of the editor preset that uses this hook to generate the loom plugin options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        isPluginEnabled: isPluginEnabled,
        pluginOptions: pluginOptions
    };
};
module.exports["useLoomPluginOptions"] = $bd6eb7a689d25f96$export$4e56214a02095203;

});

parcelRegister("3GtBN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cnJLk = parcelRequire("cnJLk");


var $4R3wx = parcelRequire("4R3wx");

const $3144bf078b5ec5f7$export$a8d5ff7665612fc7 = ({ loomPlugin: loomPlugin, providerConfig: providerConfig })=>{
    const hasInitialized = (0, $42omo.useRef)(false);
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const isLoomRecordingEligible = [
        'BETA',
        'CO_USE'
    ].includes(entryPointVariant);
    const initLoom = loomPlugin?.actions.initLoom;
    (0, $42omo.useEffect)(()=>{
        if (!hasInitialized.current && initLoom && isLoomRecordingEligible) {
            hasInitialized.current = true;
            initLoom({
                loomProvider: (0, $cnJLk.getLoomProvider)(providerConfig)
            });
        }
    }, [
        initLoom,
        isLoomRecordingEligible,
        providerConfig
    ]);
};
module.exports["useInitializeLoomPlugin"] = $3144bf078b5ec5f7$export$a8d5ff7665612fc7;

});

parcelRegister("cnJLk", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $7ac005878fa67dea$export$c58a153e42b1c02d = (0, $2XqLN.default)((config)=>{
    return {
        getClient: async ()=>({
                status: 'loaded',
                client: {
                    attachToButton: ({ button: button, onInsert: onInsert })=>{
                        button.addEventListener('click', ()=>{
                            config.openLoomRecorder({
                                onInsert: (_, video)=>{
                                    onInsert(video);
                                },
                                // intentionally not localized because Loom RecordSDK does not support i18n
                                insertButtonText: 'Insert Loom video'
                            });
                        });
                    }
                }
            })
    };
});
module.exports["getLoomProvider"] = $7ac005878fa67dea$export$c58a153e42b1c02d;

});

parcelRegister("yuV6Z", function(module, exports) {
const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>`${$378a693b2c26358e$export$ca6dda5263526f75}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== returnBlockedExtensions || $[6] !== skipQuery || $[7] !== spaceContextOnly || $[8] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = returnBlockedExtensions;
        $[6] = skipQuery;
        $[7] = spaceContextOnly;
        $[8] = spaceKey;
        $[9] = t3;
    } else t3 = $[9];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[10] !== extsError || $[11] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[10] = extsError;
        $[11] = spaceError;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[14] !== extsData || $[15] !== extsError || $[16] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[14] = extsData;
        $[15] = extsError;
        $[16] = extsLoading;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("7zIsq", function(module, exports) {

var $gNyf6 = parcelRequire("gNyf6");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $xQxzY = parcelRequire("xQxzY");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");


var $8VYSW = parcelRequire("8VYSW");

const $f6a9c96fc0de3888$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $f6a9c96fc0de3888$export$88e0391b02a3c5c9 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $f6a9c96fc0de3888$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $xQxzY.useQuery)((0, $39Ajm.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $f6a9c96fc0de3888$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $f6a9c96fc0de3888$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
const $f6a9c96fc0de3888$var$fetchRequests = new Map();
const $f6a9c96fc0de3888$export$f55e1916fecb1860 = ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types })=>{
    const environment = (0, $irOoi.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $42omo.useState)(null);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$f6a9c96fc0de3888$var$fetchRequests.has(cacheKey)) {
            const extensions = new Promise((resolve, reject)=>{
                (0, $irOoi.fetchQuery)(environment, (0, $gNyf6.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($f6a9c96fc0de3888$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error)=>{
                        $f6a9c96fc0de3888$var$fetchRequests.delete(cacheKey);
                        reject(error);
                    }
                });
            });
            $f6a9c96fc0de3888$var$fetchRequests.set(cacheKey, extensions);
        }
        $f6a9c96fc0de3888$var$fetchRequests.get(cacheKey).then((extensions)=>{
            setExtensions(extensions);
            setLoading(false);
        }).catch((error)=>{
            setError(error);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment
    ]);
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $grQpA.isRelayNetworkError)(error)) {
            const err = error.source.errors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $f6a9c96fc0de3888$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $f6a9c96fc0de3888$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $f6a9c96fc0de3888$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $f6a9c96fc0de3888$export$f55e1916fecb1860;

});

parcelRegister("gNyf6", function(module, exports) {
/**
 * @generated SignedSource<<5a4744b7a88e0a5ddae9ca9a72dfab68>>
 * @relayHash 57057313f17699c6ffabb286b9a1141a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b
const $c701b66f5c3386e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c701b66f5c3386e6$var$node.hash = "d028e6b4d01b71cf67c24b6983fbfddf";
var $c701b66f5c3386e6$export$2e2bcd8739ae039 = $c701b66f5c3386e6$var$node;
module.exports["default"] = $c701b66f5c3386e6$export$2e2bcd8739ae039;

});

parcelRegister("grQpA", function(module, exports) {
var $3afb5a6a58db13d7$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $3afb5a6a58db13d7$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $3afb5a6a58db13d7$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $3afb5a6a58db13d7$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $3afb5a6a58db13d7$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $3afb5a6a58db13d7$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $3afb5a6a58db13d7$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $3afb5a6a58db13d7$export$9c0545f564a8227f;

});

parcelRegister("5U2YR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQK66 = parcelRequire("hQK66");


var $jIiuI = parcelRequire("jIiuI");

const $a50a0967117e6a0e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $42omo.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $a50a0967117e6a0e$export$163ecee29aa3a8f = ({ value: value, children: children })=>{
    const envFromContext = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $hQK66.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a50a0967117e6a0e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $a50a0967117e6a0e$export$dba2dab0d0f39612 = ()=>{
    return (0, $42omo.useContext)($a50a0967117e6a0e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $a50a0967117e6a0e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $a50a0967117e6a0e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $a50a0967117e6a0e$export$dba2dab0d0f39612;

});

parcelRegister("jIiuI", function(module, exports) {

var $42omo = parcelRequire("42omo");

parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $669e2d348d1011a7$export$6a671bebd9daad64 = (0, $42omo.createContext)((0, $1Aku8.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $669e2d348d1011a7$export$6a671bebd9daad64;

});

parcelRegister("39Ajm", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dh538 = parcelRequire("dh538");

const $2ce486181186726b$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2ce486181186726b$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $dh538.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2ce486181186726b$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $eSUdr.default)`${query}`;
};
const $2ce486181186726b$export$54ff27488d768aba = (0, $eSUdr.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2ce486181186726b$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2ce486181186726b$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2ce486181186726b$export$54ff27488d768aba;

});

parcelRegister("3Spjc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $7TH2w = parcelRequire("7TH2w");

const $ee4a4828226e63ce$export$d28801614368e543 = 'forge-ui';
const $ee4a4828226e63ce$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $7TH2w.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $7TH2w.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $7TH2w.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $7TH2w.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $ee4a4828226e63ce$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $ee4a4828226e63ce$var$ForgeUIAnalyticsListener = ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $ee4a4828226e63ce$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $ee4a4828226e63ce$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: listenerHandler,
        channel: $ee4a4828226e63ce$export$d28801614368e543
    }, children);
};
var $ee4a4828226e63ce$export$2e2bcd8739ae039 = $ee4a4828226e63ce$var$ForgeUIAnalyticsListener;
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $ee4a4828226e63ce$export$d28801614368e543;
module.exports["sendEvent"] = $ee4a4828226e63ce$export$7329bcdc3edcd90e;
module.exports["default"] = $ee4a4828226e63ce$export$2e2bcd8739ae039;

});

parcelRegister("1Igmn", function(module, exports) {
// our service
const $0be0f811af274f82$var$SERVICE = 'forge-ui';
const $0be0f811af274f82$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $0be0f811af274f82$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $0be0f811af274f82$export$14ef296862e3705e;

});

parcelRegister("8VYSW", function(module, exports) {
parcelRequire("1c598");
var $2JC3k = parcelRequire("2JC3k");

const $2303076e1c638c7b$var$cache = new Map();
const $2303076e1c638c7b$export$9ff84ea1b2ab439c = (extensions)=>{
    const extensionsIds = (extensions || []).map((ext)=>ext.id).join(',');
    if ($2303076e1c638c7b$var$cache.has(extensionsIds)) return $2303076e1c638c7b$var$cache.get(extensionsIds);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2JC3k.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2JC3k.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (_error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $2303076e1c638c7b$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $2303076e1c638c7b$var$cache.set(extensionsIds, result);
    return result;
};
const $2303076e1c638c7b$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $2303076e1c638c7b$export$9ff84ea1b2ab439c;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("6ld6a", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipQuery || $[9] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery
        };
        $[8] = skipQuery;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[11] = t8;
            $[12] = t9;
        } else {
            t8 = $[11];
            t9 = $[12];
        }
        let t10;
        if ($[13] !== error || $[14] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[13] = error;
            $[14] = loading;
            $[15] = t10;
        } else t10 = $[15];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[16] !== allowedWebItems || $[17] !== data || $[18] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[16] = allowedWebItems;
        $[17] = data;
        $[18] = notAllowedWebItems;
        $[19] = webItems;
        $[20] = webSections;
    } else {
        webItems = $[19];
        webSections = $[20];
    }
    let t8;
    if ($[21] !== error || $[22] !== webItems || $[23] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[21] = error;
        $[22] = webItems;
        $[23] = webSections;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("kxhju", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<7e9a878d08bf5ce37193671bfd42e66e>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("1gjU5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("2Awp2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $ccHMk = parcelRequire("ccHMk");


var $1yB28 = parcelRequire("1yB28");

var $8tSmd = parcelRequire("8tSmd");

var $48SU7 = parcelRequire("48SU7");

var $7ERUE = parcelRequire("7ERUE");

var $kDB94 = parcelRequire("kDB94");

var $iIVVb = parcelRequire("iIVVb");


var $g5gZt = parcelRequire("g5gZt");








var $lAFHW = parcelRequire("lAFHW");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $8dvlB = parcelRequire("8dvlB");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $inPa6 = parcelRequire("inPa6");


var $2Rith = parcelRequire("2Rith");


var $1iSzD = parcelRequire("1iSzD");


var $abUsF = parcelRequire("abUsF");


var $5qqdA = parcelRequire("5qqdA");


var $eqKgz = parcelRequire("eqKgz");


var $aWwYt = parcelRequire("aWwYt");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");


var $2A8CJ = parcelRequire("2A8CJ");


var $hrAmX = parcelRequire("hrAmX");


var $hl1Kw = parcelRequire("hl1Kw");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cMvMc = parcelRequire("cMvMc");


var $dANtQ = parcelRequire("dANtQ");


var $kRW4Y = parcelRequire("kRW4Y");


var $jmjWc = parcelRequire("jmjWc");


var $7W8i8 = parcelRequire("7W8i8");


var $2Jxlo = parcelRequire("2Jxlo");


var $a3Fla = parcelRequire("a3Fla");

parcelRequire("9ikgN");
var $cR1lV = parcelRequire("cR1lV");
var $9ikgN = parcelRequire("9ikgN");


var $7rLBD = parcelRequire("7rLBD");


var $bjVRl = parcelRequire("bjVRl");


var $9oxdN = parcelRequire("9oxdN");


var $7Sm4c = parcelRequire("7Sm4c");


var $eDk57 = parcelRequire("eDk57");


var $98CLM = parcelRequire("98CLM");

parcelRequire("aiS08");
var $1L1jV = parcelRequire("1L1jV");


var $jln20 = parcelRequire("jln20");


var $7mpOv = parcelRequire("7mpOv");


var $lJlG6 = parcelRequire("lJlG6");


var $6mKj3 = parcelRequire("6mKj3");


var $4VJDS = parcelRequire("4VJDS");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $cZa7r = parcelRequire("cZa7r");


var $b0EGa = parcelRequire("b0EGa");


var $aKDZB = parcelRequire("aKDZB");


var $3b5i6 = parcelRequire("3b5i6");


var $dnbZ2 = parcelRequire("dnbZ2");


var $4DJgG = parcelRequire("4DJgG");


var $6W81y = parcelRequire("6W81y");


var $4oXkq = parcelRequire("4oXkq");


var $9ujb2 = parcelRequire("9ujb2");


var $lEDve = parcelRequire("lEDve");


var $bEdUx = parcelRequire("bEdUx");


var $2W2Mk = parcelRequire("2W2Mk");


var $l4eiF = parcelRequire("l4eiF");


var $2zMIV = parcelRequire("2zMIV");


var $b1ynj = parcelRequire("b1ynj");


var $dj3mI = parcelRequire("dj3mI");


var $6zmDz = parcelRequire("6zmDz");


var $97kfW = parcelRequire("97kfW");


var $joYQz = parcelRequire("joYQz");

const $9755f908a54a6c5b$var$builtInActionsStyles = null;
const $9755f908a54a6c5b$var$builtInActionsWithoutOtherActionsStyles = null;
const $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD = 100;
const $9755f908a54a6c5b$var$BUILT_IN_ITEMS = [
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary',
    'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
];
const $9755f908a54a6c5b$export$9205c47465d0942 = [
    'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary'
];
const $9755f908a54a6c5b$var$i18n = (0, $aXWIB.defineMessages)({
    commentTooltip: {
        id: "highlight-actions.inline.comment.tooltip",
        defaultMessage: "Comment"
    },
    defineTooltip: {
        id: "highlight-actions.define.tooltip",
        defaultMessage: "Define"
    }
});
const $9755f908a54a6c5b$var$logger = (0, $7W8i8.getLogger)('inline-comment');

const $9755f908a54a6c5b$var$ForgeAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wTC7w",
    name: "ForgeAction",
    loader: async ()=>(await (parcelRequire("5iBet"))).ForgeAction
});

const $9755f908a54a6c5b$var$DefinitionAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wKsW8",
    name: "DefinitionAction",
    loader: async ()=>(await (parcelRequire("eJvrZ"))).DefinitionAction
});
const $9755f908a54a6c5b$export$c1823fc1996a2ebd = (evt)=>{
    const highlightActionsToolbar = document.querySelector('[data-testid="highlightActionsPopup"]');
    const focusedElement = document.activeElement;
    if (highlightActionsToolbar && !highlightActionsToolbar?.contains(focusedElement) && evt.key === 'Tab' && !evt.ctrlKey && !evt.altKey) {
        evt.preventDefault();
        document.querySelector('[data-testid="createInlineCommentButton"]')?.focus();
    }
};
function $9755f908a54a6c5b$var$trapFocusInSelectionToolbar(event) {
    const highlightActionsToolbar = document.querySelector('#highlightActionsPopup');
    if (highlightActionsToolbar && event.key === 'Tab' && !event.ctrlKey && !event.altKey) {
        event.preventDefault();
        event.stopPropagation(); // Get all focusable elements in the toolbar
        const elements = Array.from(highlightActionsToolbar.querySelectorAll('button, a')).filter((curr)=>{
            if (curr instanceof HTMLButtonElement) return !curr.disabled;
            if (curr instanceof HTMLAnchorElement) return !!curr.href;
            return false;
        }); // Find the index of the currently focused element
        let idx = event.shiftKey ? elements.length : -1;
        const focusedElement = document.activeElement;
        if (highlightActionsToolbar.contains(focusedElement)) {
            for(let i = 0; i < elements.length; i++)if (elements[i] === focusedElement) {
                idx = i;
                break;
            }
        } // Focus the next element to focus
        event.shiftKey ? idx-- : idx++;
        if (idx < 0) idx = elements.length - 1;
        else if (idx >= elements.length) idx = 0;
        const next = elements[idx];
        if (next && (next instanceof HTMLButtonElement || next instanceof HTMLAnchorElement)) next.focus();
    }
} // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $afneb.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rkofajl _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $afneb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rkofajl _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltipUpdated = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $afneb.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rko12b0 _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $afneb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rko12b0 _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $9755f908a54a6c5b$export$c0b63e9f99a74f33 = (components, hasOtherActions)=>{
    const dividerLast = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.Divider), {
        key: "divider-last",
        "data-testid": "divider-last"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DividerOld), {
        key: "divider-last",
        "data-testid": "divider-last"
    });
    return components.reduce((result, component, i)=>{
        // Add the current component
        result.push(component); // Add a divider after each component except the last one
        if (i < components.length - 1) result.push((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.Divider), {
            key: `divider-${i}`,
            "data-testid": "divider"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DividerOld), {
            key: `divider-${i}`,
            "data-testid": "divider"
        }));
        return result; // If there are other actions, add a divider at the end
    }, []).concat(hasOtherActions ? dividerLast : []);
};
const $9755f908a54a6c5b$export$a6299569dd2a354f = ({ contentId: contentId, children: children, hasInlineComments: hasInlineComments = true, actions: actions, lastModifiedDate: lastModifiedDate, isArchived: isArchived, contentStatusError: contentStatusError, range: range, isAnnotationAllowed: isAnnotationAllowed, onCommentButtonPress: onCommentButtonPress, onRemixButtonPress: onRemixButtonPress, remixDisabledReason: remixDisabledReason, isRemixInProgress: isRemixInProgressProp, isFabric: isFabric, contentType: contentType, inlineNodeTypes: inlineNodeTypes, onCommentButtonMount: onCommentButtonMount, snippetSlots: snippetSlots })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isRemixAvailable = (0, $dnbZ2.useIsRemixAvailable)();
    const [actionStates, setActionStates] = (0, $42omo.useState)({
        firstHighlightShown: false,
        show: false,
        top: 0,
        left: 0,
        forgeExtension: null,
        activeSelection: null,
        selectionRect: null,
        isReadingAidsOpen: false,
        readingAidsChangeboardingStep: 'disabled'
    });
    const [position, setPosition] = (0, $42omo.useState)(null);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach, isInReattachMode: isInReattachMode } = (0, $brNvA.useReattachComment)();
    const { setReattachHighlight: setReattachHighlight } = (0, $brNvA.useReattachCommentDispatch)();
    const { lastModificationDate: lastModificationDate } = (0, $42omo.useContext)((0, $2A8CJ.ContentBodyContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { canAddComments: canAddComments, contentQueryError: contentQueryError } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId);
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
    });
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [isWarningDialogOpen, setIsWarningDialogOpen] = (0, $42omo.useState)(false);
    const [recordedClick, setRecordedClick] = (0, $42omo.useState)(); // Flag to trigger text comment creation after media comment cleanup
    const [pendingTextComment, setPendingTextComment] = (0, $42omo.useState)(false);
    const { setDefineDefinitionOpen: setDefineDefinitionOpen } = (0, $bjVRl.useReadingAidsActions)();
    const { hoverProps: hoverProps } = (0, $cZa7r.useAnnotations)();
    const { setHoverProps: setHoverProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const { isRemixing: isRemixingFromContext } = (0, $aKDZB.useRendererRemixContext)();
    const isRemixing = isRemixInProgressProp || isRemixingFromContext;
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const { firstHighlightShown: firstHighlightShown, show: show, top: top, left: left, forgeExtension: forgeExtension, activeSelection: activeSelection, selectionRect: selectionRect, isReadingAidsOpen: isReadingAidsOpen, readingAidsChangeboardingStep: readingAidsChangeboardingStep } = actionStates;
    const mountedRef = (0, $42omo.useRef)(false);
    const screenEventFiredRef = (0, $42omo.useRef)(false);
    const highlightActionsShownRef = (0, $42omo.useRef)(false);
    const content = (0, $42omo.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const [showReadingAidsChangeboarding, stopReadingAidsChangeboarding] = (0, $9oxdN.useFeatureDiscovery)('highlight-actions.reading-aids.changeboarding');
    const isReadingAidsChangeboardingActive = readingAidsChangeboardingStep.match(/^modal|spotlight/); // Sync popup visibility to OmniBar's visibility store (counter-based)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    const shouldHideOmniBar = show || isReadingAidsOpen || !!forgeExtension;
    (0, $42omo.useLayoutEffect)(()=>{
        if (shouldHideOmniBar && (0, $9wGTI.fg)('cc-engagement-omnibar-hide-highlight-actions')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        shouldHideOmniBar,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    const highlightActionsContextValue = (0, $42omo.useMemo)(()=>({
            firstHighlightShown: firstHighlightShown
        }), [
        firstHighlightShown
    ]); // start the reading aids changeboarding
    (0, $42omo.useEffect)(()=>{
        setActionStates((prevState)=>({
                ...prevState,
                readingAidsChangeboardingStep: showReadingAidsChangeboarding && isAIEnabledForContent ? 'idle' : 'disabled'
            }));
    }, [
        showReadingAidsChangeboarding,
        isAIEnabledForContent
    ]);
    (0, $42omo.useEffect)(()=>{
        // Manually trigger resize to ensure spotlight is properly aligned
        window.setTimeout(()=>window.dispatchEvent(new Event('resize')), 0);
        if (!show) {
            // Force a redraw of portalContainer, which fixes an issue where the popup is removed from DOM but is
            // still visible on the page __in Safari__. (https://product-fabric.atlassian.net/browse/COMMENTS-5335)
            // This rendering issue occurring in Safari's WebKit engine seems to be known and has a long history.
            // Only do this when `show === false`, since the issue only occurs when attepmting to hide the popup.
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
            if (portalContainer) {
                portalContainer.style.transform = 'translateZ(0)'; // This line below reads this layout property, which triggers a reflow + redraw as side effect.
                portalContainer.offsetHeight; // NOSONAR - Sonar would complain: "Expected an assignment or function call and instead saw an expression"
                portalContainer.style.transform = '';
            }
        }
    }, [
        show
    ]); // freeze the user's selection while reading aids changeboarding is active
    (0, $42omo.useEffect)(()=>{
        const akPortalContainer = document.querySelector('.atlaskit-portal-container');
        if (akPortalContainer) {
            if (isReadingAidsChangeboardingActive) {
                akPortalContainer.style.userSelect = 'none';
                return ()=>{
                    akPortalContainer.style.userSelect = 'auto';
                };
            } else akPortalContainer.style.userSelect = 'auto';
        }
    }, [
        isReadingAidsChangeboardingActive
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
            document.addEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
            return ()=>{
                document.removeEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
            };
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('mouseup', onMouseUp);
        window.addEventListener('highlight-actions.container.resized', onContainerResized);
        return ()=>{
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('highlight-actions.container.resized', onContainerResized);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentToReattach,
        isReadingAidsChangeboardingActive,
        isRemixing
    ]); /* When nudgebar improvement is on: hide toolbar when selection was set by comment nudge (e.g. on hover). */ 
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) return;
        const onSelectionChange = ()=>{
            if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && mountedRef.current) setActionStates((prev)=>({
                    ...prev,
                    show: false
                }));
        };
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>document.removeEventListener('selectionchange', onSelectionChange);
    }, []); // Close reading aids popup when navigating to another page
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        };
    }, [
        contentId,
        setDefineDefinitionOpen
    ]); // Handle text comment creation after media comment cleanup is complete
    (0, $42omo.useEffect)(()=>{
        if (pendingTextComment && !hoverProps) {
            setPendingTextComment(false);
            if (isFabric) onCommentButtonPress?.();
            else createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach,
                actions: actions
            }));
        }
    }, [
        pendingTextComment,
        hoverProps,
        isFabric,
        onCommentButtonPress,
        createComment,
        content,
        contentId,
        commentToReattach,
        actions
    ]);
    const onContainerResized = ()=>{
        setActionStates((prevState)=>({
                ...prevState,
                show: false,
                forgeExtension: null
            }));
    };
    function getScrollParent(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE && node.scrollWidth > node.clientWidth) return node;
        else return getScrollParent(node.parentNode);
    }
    function getParentNode(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE) return node;
        else return getParentNode(node.parentNode);
    }
    const getPosition = (range)=>{
        const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
        const portalRect = portalContainer?.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        const { left: leftRect, top: topRect, width: width, height: height } = range.getBoundingClientRect(); // Popup can't be rendered outside the body area
        const contentRect = getParentNode(range.commonAncestorContainer).getBoundingClientRect();
        let leftLimit = contentRect.left;
        let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
        // The popup is limited to be shown within the scrollable area.
        const firstParentThatCanScroll = getScrollParent(range.startContainer);
        if (firstParentThatCanScroll) {
            const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
            leftLimit = Math.max(leftLimit, scrollParentRect.left);
            rightLimit = Math.min(rightLimit, scrollParentRect.right);
        }
        let x = width / 2 + leftRect;
        if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
        return {
            pos: {
                left: x - portalRect.left,
                top: topRect - portalRect.top
            },
            selectionRect: {
                left: x - portalRect.left,
                top: topRect - portalRect.top,
                width: width,
                height: height
            }
        };
    };
    (0, $42omo.useEffect)(()=>{
        if (range) {
            /* When nudgebar improvement is on, never show toolbar for selection set by nudge (range can come from parent when we set selection on comment hover). */ if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && (0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) {
                setPosition(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const { pos: pos, selectionRect: selectionRectangle } = getPosition(range);
            highlightActionsShownRef.current = false;
            setPosition(pos);
            setActionStates((prevState)=>({
                    ...prevState,
                    selectionRect: selectionRectangle,
                    show: true
                }));
        } else {
            setPosition(null);
            setActionStates((prevState)=>({
                    ...prevState,
                    show: false
                }));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const updatePosition = (0, $42omo.useCallback)(()=>{
        if (range) {
            const { pos: pos } = getPosition(range);
            setPosition(pos);
            return pos;
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const prepareAndSetHighlightForReattachMode = ()=>{
        const convertedSelectionObj = (0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }); // Only set the highlight if it's valid
        if (convertedSelectionObj.numMatches > 0 && convertedSelectionObj.matchIndex !== -1) setReattachHighlight(convertedSelectionObj);
    };
    const isDatasourceHighlighted = (range)=>{
        const datasourceContainers = document.querySelectorAll('.datasource-table');
        return Array.from(datasourceContainers).some((container)=>container.contains(range.startContainer) || container.contains(range.endContainer));
    };
    const onMouseUp = (e)=>{
        return requestAnimationFrame(()=>{
            if (!mountedRef.current) return;
            if ((0, $9wGTI.fg)('quick_capture_trello_inbox')) (0, $9ujb2.prefetchTrelloAccess)();
            const range = (0, $2zMIV.getRange)();
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`); // WS-1576/WS-2355 - Ignore any highlights in the Inline Comments sidebar
            const inlineCommentSidebarContainer = document.querySelector('#inline-comment-sidebar'); // InlineCommentNudge handles its own content selection and opening of the Comment Editor.
            // Check both event target and element under cursor so we don't show toolbar when pointer is over nudge (e.g. portal/overlay edge cases).
            const elementUnderCursor = typeof document.elementFromPoint === 'function' ? document.elementFromPoint(e.clientX, e.clientY) : null;
            const isOverCommentNudge = e.target && e.target.closest?.('#inline-comment-nudge') || elementUnderCursor && elementUnderCursor.closest?.('#inline-comment-nudge');
            const isOverRemixNudge = e.target && e.target.closest?.('#inline-remix-nudge') || elementUnderCursor && elementUnderCursor.closest?.('#inline-remix-nudge');
            if (isOverCommentNudge) return;
            if (isOverRemixNudge && (0, $9wGTI.fg)('confluence_remix_button_right_side_block_fg')) return;
             // When nudgebar improvement is on, only show toolbar when user selected text (not when selection was set by nudge hover).
            if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && (0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) return;
             // freeze the actions popup if reading aids changeboarding is active
            if (isReadingAidsChangeboardingActive) return;
             // freeze the actions popup if the input is clicked in the rovo chat more options popup
            if (e.target.closest('#context-menu-rovo-chat-custom-prompt')) return;
            const isCommentButtonDisabledAndClicked = e.target.closest('button[disabled]');
            const isContextMenuOtherAppsButtonClicked = e.target.closest('#context-menu-other-apps');
            const isCreateJiraIssueButtonClicked = e.target.closest('#create-jira-issue-trigger');
            const isRovoChatMoreOptionsButtonClicked = e.target.closest('#context-menu-rovo-chat-more-options');
            const isNotesButtonClicked = e.target.closest('#highlight-actions-notes-button');
            const shouldHideContextMenu = !(isCommentButtonDisabledAndClicked || isContextMenuOtherAppsButtonClicked || isCreateJiraIssueButtonClicked || isRovoChatMoreOptionsButtonClicked || isNotesButtonClicked);
            if (!range || !portalContainer || !content.current || inlineCommentSidebarContainer?.contains(range.startContainer) || inlineCommentSidebarContainer?.contains(range.endContainer) || isDatasourceHighlighted(range) || !content.current.contains(e.target) && content.current !== e.target && shouldHideContextMenu) {
                if (isInReattachMode()) setReattachHighlight(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // COMMENTS-332 - In reattach mode, skip the measuring of the screen, just set the mode with the highlight
            if (isInReattachMode()) {
                prepareAndSetHighlightForReattachMode();
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const portalRect = portalContainer.getBoundingClientRect();
            const contentRect = content.current.getBoundingClientRect();
            const rects = range.getClientRects();
            if (!rects || !rects.length) {
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // Find first selection area that width is not 0
            // Sometimes there is a chance that user is selecting an empty DOM node.
            const rect = Array.from(rects).find((rect)=>rect.width !== 0 && rect.height !== 0);
            if (rect) {
                const { left: left, right: right, top: top, width: width, height: height } = rect;
                const mouseUpX = e.clientX; // This is a LEGACY disable statement after rule addition. Use `Math.floor(width/2)` next time
                // eslint-disable-next-line no-bitwise
                const selectedLineCenter = left + (width >> 1); // Popup can't be rendered outside the body area
                let leftLimit = contentRect.left;
                let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
                // The popup is limited to be shown within the scrollable area.
                const firstParentThatCanScroll = getScrollParent(range.startContainer);
                if (firstParentThatCanScroll) {
                    const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
                    leftLimit = Math.max(leftLimit, scrollParentRect.left);
                    rightLimit = Math.min(rightLimit, scrollParentRect.right);
                } // Use the X-axis position if the center of selected line is POPUP_MOUSEUP_DISTANCE_THRESHOLD away from mouse up position.
                // POPUP_MOUSEUP_DISTANCE_THRESHOLD is an arbitrary number I made up.
                // The idea is the popup will always show up within POPUP_MOUSEUP_DISTANCE_THRESHOLD of the end of the selection.
                // Right near what user selects. However when the selection is too short - like a phase,
                // it will show up at the middle of the selection because it looks better.
                let x = Math.abs(mouseUpX - selectedLineCenter) > $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD && left <= mouseUpX && mouseUpX <= right ? mouseUpX : selectedLineCenter; // However it is still bounded by the left and right boundary of the first line.
                // This is because the mouse up can be off screen.
                // For example: Make selection, then drag on a scroll bar.
                if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
                if (!isFabric) highlightActionsShownRef.current = false;
                setActionStates((prevState)=>({
                        ...prevState,
                        firstHighlightShown: true,
                        // COMMENTS-332 - Don't show the popup when a selection is made in reattach mode
                        show: !isInReattachMode(),
                        left: x - portalRect.left,
                        top: top - portalRect.top,
                        selectionRect: {
                            left: x - portalRect.left,
                            top: top - portalRect.top,
                            width: width,
                            height: height
                        }
                    }));
            }
        });
    };
    const createReactInlineCommentHighlight = ()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
         // Close any existing media create comment when opening a text comment
        if ((0, $6mKj3.expValEquals)('confluence_comment_unmount_onmedia_selection', 'isEnabled', true)) {
            if (hoverProps) {
                // Remove draft annotation from media element if it exists
                hoverProps.removeDraftMode?.(); // Close the hover component (calls renderer's onClose)
                hoverProps.onClose?.(); // Clear hoverProps from context
                setHoverProps(null); // Flag to trigger text comment creation after hoverProps is cleared
                setPendingTextComment(true);
                return;
            }
        } // Proceed with text comment creation immediately if no media comment to clean up
        if (isFabric) onCommentButtonPress?.();
        else createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }));
    };
    const handleCommentButtonClick = (dialogs)=>{
        if (hasContentChanged) dialogs.showDialog((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight()
        });
        else createReactInlineCommentHighlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'highlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createInlineCommentFromHighlightActionsMenu',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    pageMode: 'view',
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                }
            }
        }).fire();
    };
    const extractNodeDetailsToString = (node)=>{
        if (!node) return '';
        while(node?.nodeType === Node.TEXT_NODE || node.tagName === 'MARK')node = node?.parentNode;
        if (node) {
            const elem = node;
            const classListStr = Array.from(elem.classList).join(',');
            let attrListStr = '';
            Object.entries(elem.dataset).forEach((attrEntry, idx)=>{
                if (idx > 0) attrListStr += ',';
                 // COMMENTS-1916 - Remove any emails that are in any values for attributes
                if (attrEntry.length > 1) {
                    const field = attrEntry[0];
                    if (field && field.includes('testMediaName')) attrEntry[1] = '';
                }
                attrListStr += attrEntry.join('=');
            }); // Get the tag name and stringify the class list and attribute list
            return `${elem.tagName}${classListStr.length ? `.${classListStr}` : ''}${attrListStr.length ? `[${attrListStr}]` : ''}`;
        }
        return '';
    };
    const CreateInlineCommentButton = ()=>{
        const { documentNeedsUpdate: documentNeedsUpdate, currentDocumentVersion: currentDocumentVersion, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
        (0, $42omo.useEffect)(()=>{
            if (!(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                document.addEventListener('keydown', $9755f908a54a6c5b$export$c1823fc1996a2ebd);
                return ()=>{
                    document.removeEventListener('keydown', $9755f908a54a6c5b$export$c1823fc1996a2ebd);
                };
            }
        }, []);
        (0, $42omo.useEffect)(()=>{
            onCommentButtonMount && onCommentButtonMount();
        }, []);
        if (!content.current) return null;
        const isHighlightValid = isFabric ? isAnnotationAllowed : (0, $2zMIV.isHighlightValidForInlineComment)(content.current, contentId);
        const shouldDisableCommentWhenDocumentNeedsUpdate = (selectedInlineNodeTypes)=>{
            // If document is outdated, only disable the comment button when selection is exactly 1 of the 4 types below.
            return selectedInlineNodeTypes?.length === 1 && [
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(selectedInlineNodeTypes[0]);
        }; // Cases where we want to disable the create button:
        // 1. The content is archived.
        // 2. The user does not have the "Comment - Add" permission.
        // 3. The highlight was invalid (over elements we don't support commenting on).
        // 4. The document needs to be updated (i.e. is outdated) AND selected node is one of [status, date, mention, inlineCard].
        // This order matters when communicating to users, as checking "Comment - Add" permission for archived pages
        // will return false.
        const needsUpdateToComment = shouldDisableCommentWhenDocumentNeedsUpdate(inlineNodeTypes) && (!!documentNeedsUpdate && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated', 'isEnabled', true) || currentDocumentVersion !== publishedDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true));
        const isCreateButtonEnabled = !isArchived && canAddComments && !needsUpdateToComment && isHighlightValid; // Check if the comment is on a selection that includes an non-text inline node
        const isNonTextInlineNodeIncludedInComment = (inlineNodeTypes ?? []).filter((nodeType)=>nodeType !== 'text').length > 0; // Track the nodes in which the highlight was made on to send in the event
        if (!highlightActionsShownRef.current) {
            highlightActionsShownRef.current = true;
            try {
                const selection = window.getSelection();
                const startingNode = extractNodeDetailsToString(selection?.anchorNode);
                const endingNode = extractNodeDetailsToString(selection?.focusNode); // Track when the menu is shown to users and if it's disabled
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'shown',
                        actionSubject: 'toolbar',
                        actionSubjectId: 'highlightActionsMenu',
                        attributes: {
                            isDisabled: !isCreateButtonEnabled,
                            pageMode: 'view',
                            startingNode: startingNode,
                            endingNode: endingNode,
                            inlineNodeTypes: inlineNodeTypes,
                            isNonTextInlineNodeIncludedInComment: /**
               * This attribute is used as the trigger to display an engagement platform promotion message
               * when isNonTextInlineNodeIncludedInComment is true, and isDisabled is false,
               * A spotlight/flag will be shown to the user to encourage them to comment on inline nodes.
               */ isNonTextInlineNodeIncludedInComment
                        }
                    }
                }).fire();
            } catch (e) {
                $9755f908a54a6c5b$var$logger.error`Unable to send highlight actions event; ${e}`;
            }
        }
        const createButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $kRW4Y.DialogsStateContainer)
            ]
        }, (dialogs)=>{
            const commonCreateButtonProps = {
                'data-key': 'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
                // Needed for integration tests
                isDisabled: !isCreateButtonEnabled,
                testId: 'createInlineCommentButton',
                interactionName: 'start-inline-comment-action',
                onClick: ()=>{
                    handleCommentButtonClick(dialogs);
                },
                id: 'create-inline-comment-button'
            };
            return isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
                ...commonCreateButtonProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    label: "",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...commonCreateButtonProps,
                appearance: "subtle",
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                        label: ""
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            })));
        }); // WS-2802 - We need to wrap the disabled button and put a transparent absolute overlay over the button
        //           in order to show the tooltip correctly as the disabled button swallows all events on the element
        //           and ADG doesn't allow tooltips on disabled buttons for accessibility reasons...
        if (isNewToolbarEnabled) return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
            shortcut: commentShortcutStrings
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            delay: 0,
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
        return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
            shortcut: commentShortcutStrings
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            delay: 0,
            position: "top",
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
    };
    const createJiraIssueButton = (completeKey)=>{
        if (!content.current || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        if (!(0, $4VJDS.default).getBoolean('confluence_legacy_single_jira_work_create', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
            config: {
                // Required configuration
                product: 'confluence',
                subproduct: 'jira',
                aiFeatureName: 'confluenceAiWorkCreation',
                proactiveGeneratedAI: 0,
                userGeneratedAI: 1,
                // Optional configuration
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6W81y.CreateJiraIssueActions), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            container: content.current,
            contentId: contentId,
            contentType: contentType,
            lastModified: lastModifiedDate || lastModificationDate,
            showCreateMultipleIssuesButton: (0, $2zMIV.isHighlightValidForBulkCreateJiraIssues)(),
            setRecordedClick: setRecordedClick,
            setIsWarningDialogOpen: setIsWarningDialogOpen
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                    label: ""
                }),
            "data-key": completeKey,
            testId: "createJiraIssueButton",
            onClick: (0, $2W2Mk.createJiraIssueSummaryHandle)(content.current, contentId, lastModifiedDate || lastModificationDate)
        }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.create-issue-issue-term-refresh",
            defaultMessage: "Create work item"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.create-issue",
            defaultMessage: "Create issue"
        }));
    };
    const createTrelloInboxButton = (completeKey)=>{
        if (!content.current || (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4oXkq.AddToTrelloInboxActions), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            contentId: contentId
        });
    };
    const createReadingAidsDefineButton = ({ selectedRange: selectedRange, selectedText: selectedText, isOverWordLimit: isOverWordLimit })=>{
        if (!content.current) return null;
        const isDisabled = isOverWordLimit && readingAidsChangeboardingStep === 'disabled' || // only check word limit when changeboarding is disabled
        readingAidsChangeboardingStep === 'spotlight'; // always disable when spotlight is active
        const commonDefineButtonProps = {
            testId: 'defineButton',
            isDisabled: isDisabled,
            onClick: ()=>{
                if (!selectedRange) return;
                if (!selectedText) return;
                if (isAIEnabledForContent || isRovoEnabledForContent) experienceTracker.start({
                    name: (0, $irVI7.READING_AIDS_EXPERIENCE),
                    attributes: {
                        contentId: contentId,
                        source: 'defineButton'
                    }
                });
                setDefineDefinitionOpen({
                    defineDefinitionOpen: true
                });
                setActionStates((prevState)=>({
                        ...prevState,
                        ...isOverWordLimit && readingAidsChangeboardingStep === 'idle' ? {
                            readingAidsChangeboardingStep: 'modal-word-count'
                        } : {
                            isReadingAidsOpen: true
                        },
                        show: false,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'defineButton',
                        type: 'ui',
                        attributes: {
                            contentId: contentId,
                            isAIOptedIn: isAIEnabledForContent
                        }
                    }
                }).fire();
            }
        };
        const oldDefineButtonIcon = isRovoEnabledForContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97kfW.AtlassianIntelligenceIcon), {
            size: "large",
            greyed: isDisabled
        });
        const defineButtonIcon = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
            label: ""
        }) : oldDefineButtonIcon;
        const defineButtonContent = isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.defineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
            ...commonDefineButtonProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
                label: "",
                size: "small"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            ...commonDefineButtonProps,
            appearance: "subtle",
            iconBefore: ()=>defineButtonIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        }));
        const defineButton = (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, defineButtonContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: (0, $cR1lV.READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID)
        }, defineButtonContent);
        return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            delay: 0,
            position: "top",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.define.unsupported",
                defaultMessage: "Highlight a term, acronym, or abbreviation"
            }),
            component: (0, $9wGTI.fg)('confluence_comment_border_migration') ? $9755f908a54a6c5b$var$CustomLineWrapTooltipUpdated : $9755f908a54a6c5b$var$CustomLineWrapTooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), defineButton)) : defineButton;
    };
    const handleClickChat = (0, $42omo.useCallback)(()=>{
        const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
        const isChatActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
        if (!isChatActive) rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
    }, [
        rightSidebarContext
    ]);
    const createRovoChatHighlightActionsButton = (selectedADFContent)=>{
        if ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abUsF.RovoChatHighlightActions), {
            selectedContent: selectedADFContent,
            product: "confluence",
            onClickChat: handleClickChat
        });
    };
    const renderBuiltInWebItemActionsOld = (builtInWebItems, hasOtherActions)=>{
        const baseComponents = [];
        if (isRemixAvailable && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b5i6.RemixAction), {
            isNewToolbarEnabled: isNewToolbarEnabled,
            onClick: onRemixButtonPress,
            isDisabled: !onRemixButtonPress,
            isRemixInProgress: isRemixing,
            remixDisabledReason: remixDisabledReason
        }));
        if (hasInlineComments && !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, null));
        if (snippetSlots?.button && (0, $6mKj3.expValEquals)('cc_snippets', 'isEnabled', true)) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "SnippetButton"
        }, snippetSlots.button));
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        if (isRovoEnabledForContent) {
            const selectionString = (0, $joYQz.getHTMLString)(window.getSelection());
            const selectedADFContent = (0, $eqKgz.htmlToADF)(selectionString);
            const itemToPush = isOverWordLimit ? createRovoChatHighlightActionsButton(selectedADFContent) : createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            baseComponents.push(itemToPush);
        } else if (showReadingAidsDefineButton) baseComponents.push(createReadingAidsDefineButton({
            selectedRange: selectedRange,
            selectedText: selectedText,
            isOverWordLimit: isOverWordLimit
        }));
        const builtInComponents = builtInWebItems.map((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') return createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') return createTrelloInboxButton(completeKey);
            return null;
        }).filter(Boolean);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.BuiltInActionsPatch), {
            key: "built-in-actions"
        }, $9755f908a54a6c5b$export$c0b63e9f99a74f33([
            ...baseComponents,
            ...builtInComponents,
            ...isRemixAvailable && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b5i6.RemixAction), {
                    key: "RemixButton",
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    onClick: onRemixButtonPress,
                    isDisabled: !onRemixButtonPress,
                    isRemixInProgress: isRemixing,
                    remixDisabledReason: remixDisabledReason
                })
            ] : [],
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, {
                key: "CreateInlineCommentButton"
            })
        ], hasOtherActions));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.BuiltInActionsOld), {
            key: "built-in-actions"
        }, $9755f908a54a6c5b$export$c0b63e9f99a74f33([
            ...baseComponents,
            ...builtInComponents
        ], hasOtherActions));
    };
    const renderBuiltInWebItemActions = (builtInWebItems, hasOtherActions)=>{
        const componentsAI = [];
        const components = [];
        const showMoreActions = [];
        let defineButton = null;
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        const selectionString = (0, $joYQz.getHTMLString)(window.getSelection());
        const selectedADFContent = (0, $eqKgz.htmlToADF)(selectionString);
        if (isNewToolbarEnabled) {
            if (isRovoEnabledForContent) {
                const askRovoButton = createRovoChatHighlightActionsButton(selectedADFContent);
                if (askRovoButton) {
                    if ((0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(askRovoButton);
                    else components.push(askRovoButton);
                }
            }
            if (showReadingAidsDefineButton && !isOverWordLimit) {
                const defineButton = createReadingAidsDefineButton({
                    selectedRange: selectedRange,
                    selectedText: selectedText,
                    isOverWordLimit: isOverWordLimit
                });
                if (defineButton) {
                    if ((0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(defineButton);
                    else components.push(defineButton);
                }
            }
        } else {
            if (isRovoEnabledForContent) defineButton = isOverWordLimit ? createRovoChatHighlightActionsButton(selectedADFContent) : createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            else if (showReadingAidsDefineButton) defineButton = createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            if (defineButton) components.push(defineButton);
        }
        if (isRemixAvailable && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()) {
            const remixButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b5i6.RemixAction), {
                key: "RemixButton",
                isNewToolbarEnabled: isNewToolbarEnabled,
                onClick: onRemixButtonPress,
                isDisabled: !onRemixButtonPress,
                isRemixInProgress: isRemixing,
                remixDisabledReason: remixDisabledReason
            });
            if (isNewToolbarEnabled && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(remixButton);
            else components.push(remixButton);
        }
        const commentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CreateInlineCommentButton, {
            key: "CreateInlineCommentButton"
        });
        components.push(commentButton);
        let jiraButton = null;
        let trelloButton = null;
        builtInWebItems.forEach((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') jiraButton = createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') trelloButton = createTrelloInboxButton(completeKey);
        });
        if (jiraButton) showMoreActions.push(jiraButton);
        if (trelloButton) showMoreActions.push(trelloButton);
        if (snippetSlots?.dropdownItem && (0, $6mKj3.expValEquals)('cc_snippets', 'isEnabled', true)) showMoreActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "SnippetDropdownItem"
        }, snippetSlots.dropdownItem));
        const _hasOtherActions = Boolean(hasOtherActions || showMoreActions.length > 0);
        if (isNewToolbarEnabled) {
            if (componentsAI.length > 0 && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) // if there are AI components, render them in a ToolbarSection with a separator at the end
            return {
                builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions-ai",
                    hasSeparator: (0, $48SU7.SeparatorPosition).END
                }, componentsAI), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions"
                }, components)),
                showMoreActions: showMoreActions
            };
            return {
                builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), {
                    key: "built-in-actions"
                }, components),
                showMoreActions: showMoreActions
            };
        }
        return {
            builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                key: "built-in-actions",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _ca0q1b66 _n3td1b66 _19bv1b66",
                    !_hasOtherActions && "_u5f31b66"
                ])
            }, $9755f908a54a6c5b$export$c0b63e9f99a74f33(components, _hasOtherActions)),
            showMoreActions: showMoreActions
        };
    };
    const getComponentsForPopup = (webItems, forgeItems = [])=>{
        const webItemsWithTrello = (0, $9wGTI.fg)('quick_capture_trello_inbox') ? [
            ...webItems,
            {
                completeKey: 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
            }
        ] : webItems;
        const builtInWebItems = webItemsWithTrello.filter((item)=>$9755f908a54a6c5b$var$BUILT_IN_ITEMS.includes(item.completeKey));
        const connectItems = webItems.filter((item)=>!$9755f908a54a6c5b$export$9205c47465d0942.includes(item.completeKey));
        const hasOtherActions = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? Boolean(forgeItems?.length || connectItems?.length) : forgeItems?.length || connectItems?.length;
        const { builtInActions: builtInActions, showMoreActions: showMoreActions } = renderBuiltInWebItemActions(builtInWebItems, hasOtherActions);
        const otherActions = (0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48SU7.ToolbarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), {
            key: "other-components"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1ynj.OtherActions), {
            builtInActions: showMoreActions,
            connectItems: connectItems,
            forgeItems: forgeItems,
            selectForgeExtension: (forgeExtension)=>{
                const selectedRange = (0, $2zMIV.getRange)();
                if (!selectedRange) return;
                const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                if (!selectedText) return;
                setActionStates((prevState)=>({
                        ...prevState,
                        forgeExtension: forgeExtension,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), {
            key: "other-components"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1ynj.OtherActions), {
            builtInActions: showMoreActions,
            connectItems: connectItems,
            forgeItems: forgeItems,
            selectForgeExtension: (forgeExtension)=>{
                const selectedRange = (0, $2zMIV.getRange)();
                if (!selectedRange) return;
                const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                if (!selectedText) return;
                setActionStates((prevState)=>({
                        ...prevState,
                        forgeExtension: forgeExtension,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
            }
        }));
        if (isNewToolbarEnabled) return [
            builtInActions,
            otherActions
        ];
        return [
            (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? builtInActions : renderBuiltInWebItemActionsOld(builtInWebItems, hasOtherActions),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1ynj.OtherActions), {
                key: "other-components",
                builtInActions: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? showMoreActions : undefined,
                connectItems: connectItems,
                forgeItems: forgeItems,
                selectForgeExtension: (forgeExtension)=>{
                    const selectedRange = (0, $2zMIV.getRange)();
                    if (!selectedRange) return;
                    const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                    if (!selectedText) return;
                    setActionStates((prevState)=>({
                            ...prevState,
                            forgeExtension: forgeExtension,
                            activeSelection: {
                                selectedText: selectedText,
                                selectedRange: selectedRange
                            }
                        }));
                }
            })
        ];
    };
    const renderPopup = (components)=>components.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer)
            ]
        }, (bannerState)=>{
            // if there's a sticky header we want to position the toolbar below
            // the nav, the page header (if visible) and the sticky header
            let stickyHeaderHeight = 0;
            const range = (0, $2zMIV.getRange)();
            if (range) {
                const header = (0, $2zMIV.findStickyHeader)(range.commonAncestorContainer);
                if (header && bannerState) stickyHeaderHeight = bannerState.getTotalHeight() + header.clientHeight;
            }
            if (!screenEventFiredRef.current) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'highlightActionsMenu',
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            screenEventFiredRef.current = true;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEDve.Popup), {
                top: stickyHeaderHeight + (position?.top ?? top),
                left: position?.left ?? left,
                updatePosition: updatePosition
            }, components), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
            }));
        }) : null;
    const isCreateSingleJiraIssueHandleParams = (params)=>{
        return params?.fireAiAnalytics === undefined;
    };
    const handleConfirm = (0, $42omo.useCallback)(async ()=>{
        const callRightSidebarClose = async ()=>rightSidebarContext.close((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID)); // Need to make sure sidebar is closed before creating a new one issue
        await callRightSidebarClose(); // Sorry this block sucks because of TS types
        if (isCreateSingleJiraIssueHandleParams(recordedClick)) (0, $joYQz.createSingleJiraIssueHandle)(recordedClick);
        else recordedClick && (0, $joYQz.createSingleAiJiraIssueHandle)(recordedClick);
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen,
        recordedClick,
        rightSidebarContext
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen
    ]);
    const contentSection = !isFabric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l4eiF.HighlightActionsContext).Provider, {
        value: highlightActionsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        key: "content-container",
        ref: content
    }, children));
    const popupSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kxhju.WebItemLocation), {
        key: "action-panel",
        contentId: contentId,
        location: (0, $eSLr0.ACTION_PANEL),
        fetchPolicy: "cache-first"
    }, ({ webItems: webItems })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
            moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
            render: (forgeItems, loading, error)=>{
                if (loading) return null;
                if (error) {
                    if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                        error: error
                    });
                    return null;
                }
                return renderPopup(getComponentsForPopup(webItems, forgeItems));
            }
        }))) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onConfirm: handleConfirm,
        onCancel: handleCancel
    }), contentStatusError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentStatusError
    }), contentQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentQueryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
        render: (_apps, _loading, error)=>{
            if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            return null;
        }
    }), forgeExtension && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9755f908a54a6c5b$var$ForgeAction, {
        content: content.current,
        contentId: contentId,
        forgeExtension: forgeExtension,
        activeSelection: activeSelection,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    forgeExtension: null
                }));
        }
    }), (0, $9wGTI.fg)('kd_definitions_confluence_enable_platform') ? isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9755f908a54a6c5b$var$DefinitionAction, {
        contentId: contentId,
        contentType: contentType,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        selectedText: activeSelection.selectedText,
        selectionRect: selectionRect
    }) : isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Jxlo.ReadingAidsPopup), {
        selectedText: activeSelection.selectedText,
        selectionRange: activeSelection.selectedRange,
        selectionRect: selectionRect,
        isReadingAidsOpen: isReadingAidsOpen,
        onClose: ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        contentId: contentId,
        popupPortalContainerId: (0, $bEdUx.popupPortalContainerId),
        onResult: (result)=>{
            if (readingAidsChangeboardingStep === 'idle') {
                if (result?.nlpSearch?.errorState?.startsWith('NO_ANSWER')) setActionStates((prevState)=>({
                        ...prevState,
                        isReadingAidsOpen: false,
                        readingAidsChangeboardingStep: 'modal-undefined'
                    }));
                else stopReadingAidsChangeboarding();
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dvlB.default), null, readingAidsChangeboardingStep.startsWith('modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a3Fla.ReadingAidsChangeboardingModal), {
        onNextClick: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    readingAidsChangeboardingStep: 'spotlight',
                    show: true
                }));
        },
        modalVersion: readingAidsChangeboardingStep,
        contentId: contentId
    }) : null), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: readingAidsChangeboardingStep === 'spotlight',
        placement: "bottom-start",
        dismiss: ()=>void stopReadingAidsChangeboarding()
    }, readingAidsChangeboardingStep === 'spotlight' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ikgN.ReadingAidsChangeboardingSpotlight), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    })), contentSection, popupSection) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, readingAidsChangeboardingStep === 'spotlight' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ikgN.ReadingAidsChangeboardingSpotlight), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    }) : null), contentSection, popupSection));
};
module.exports["DROPDOWN_EXCLUDED_ITEMS"] = $9755f908a54a6c5b$export$9205c47465d0942;
module.exports["HighlightActions"] = $9755f908a54a6c5b$export$a6299569dd2a354f;

});

parcelRegister("8dvlB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce20a225af4b866c$export$2e2bcd8739ae039);
/**
 * We re-export this because products may have multiple versions of
 * `@atlaskit/modal-dialog`.
 *
 * If a consumer uses the onboarding `Modal` with the `ModalTransition` from an
 * incompatible version of `@atlaskit/modal-dialog`, then the modal can get
 * stuck in an open state.
 *
 * See https://product-fabric.atlassian.net/browse/DSP-796 for more details
 * and a reproduction.
 *
 */ 
var $6xdDU = parcelRequire("6xdDU");

var /**
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ $ce20a225af4b866c$export$2e2bcd8739ae039 = (0, $6xdDU.default);

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("abUsF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $9J8UT = parcelRequire("9J8UT");

var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");


var $c6GJD = parcelRequire("c6GJD");


var $fzqvY = parcelRequire("fzqvY");

var $fb3kw = parcelRequire("fb3kw");


var $ghftu = parcelRequire("ghftu");


var $4fdTR = parcelRequire("4fdTR");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $lBFuf = parcelRequire("lBFuf");


var $i25hX = parcelRequire("i25hX");


var $4noo5 = parcelRequire("4noo5");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $kIvLT = parcelRequire("kIvLT");


var $ygGKm = parcelRequire("ygGKm");


var $gncRT = parcelRequire("gncRT");


var $gjr93 = parcelRequire("gjr93");


var $jmorr = parcelRequire("jmorr");

const $157c507ad23459f7$var$styles = {
    popupContainer: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    formWrapper: "_1pfhx0bf",
    sendIconWrapper: "_y4tiutpp",
    rovoChatMoreOptionsButtonContainer: "_ahbqx0bf",
    rovoChatOpenChatIcon: "_bozgv77o"
};
const $157c507ad23459f7$export$1ccbc9113b239d47 = ({ selectedContent: selectedContent, product: product, onClickChat: onClickChat, onClickPromptOverride: onClickPromptOverride, onSubmitCustomPromptOverride: onSubmitCustomPromptOverride })=>{
    (0, $fBMbo.di)((0, $c6GJD.default), (0, $gncRT.useRovoChatHighlightActions));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { setIsMoreOptionsPopupOpen: setIsMoreOptionsPopupOpen } = (0, $gncRT.useRovoChatHighlightActionsActions)();
    const [{ isMoreOptionsPopupOpen: isMoreOptionsPopupOpen }] = (0, $gncRT.useRovoChatHighlightActions)();
    const { insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder } = (0, $gjr93.useHighlightActionsEditorPlaceholder)();
    (0, $42omo.useEffect)(()=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'contextualMenuItem',
            actionSubjectId: 'rovoChatHighlightActions',
            attributes: {
                product: product
            }
        });
    }, [
        sendAnalyticsEvent,
        product
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsMoreOptionsPopupOpen(false);
    }, [
        setIsMoreOptionsPopupOpen
    ]);
    const handleClickChat = (0, $42omo.useCallback)(async ()=>{
        onClickChat();
        insertHighlightActionsEditorPlaceholder(selectedContent);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuRovoChatButton',
            attributes: {
                product: product
            }
        });
    }, [
        onClickChat,
        insertHighlightActionsEditorPlaceholder,
        selectedContent,
        sendAnalyticsEvent,
        product
    ]);
    const handlePromptSubmit = (0, $42omo.useCallback)((values, form)=>{
        const formattedPrompt = (0, $ygGKm.appendADFContent)(selectedContent, values.prompt);
        if (onSubmitCustomPromptOverride) {
            onSubmitCustomPromptOverride(formattedPrompt);
            form.reset();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
                attributes: {
                    product: product
                }
            });
            return;
        }
        publish({
            type: 'chat-new',
            source: `${product}-context-menu`,
            data: {
                name: values.prompt.substring(0, 30),
                dialogues: [],
                prompt: formattedPrompt
            }
        });
        form.reset();
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'highlightActionsMenuSubmitPromptButton',
            attributes: {
                product: product
            }
        });
    }, [
        publish,
        sendAnalyticsEvent,
        product,
        onSubmitCustomPromptOverride,
        selectedContent
    ]);
    const rovoChatPromptOptions = [
        {
            id: 'context-menu-rovo-chat-summarize-option',
            actionType: 'summarize',
            prompt: formatMessage((0, $jmorr.default).rovoChatSummarizePrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatSummarizeOptionText)
        },
        {
            id: 'context-menu-rovo-chat-explain-option',
            actionType: 'explain',
            prompt: formatMessage((0, $jmorr.default).rovoChatExplainPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatExplainOptionText)
        },
        {
            id: 'context-menu-rovo-chat-find-resources-option',
            actionType: 'find-resources',
            prompt: formatMessage((0, $jmorr.default).rovoChatFindResourcesPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatFindResourcesOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-feedback-option',
            actionType: 'give-feedback',
            prompt: formatMessage((0, $jmorr.default).rovoChatGiveFeedbackPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatGiveFeedbackOptionText)
        },
        {
            id: 'context-menu-rovo-chat-give-examples-option',
            actionType: 'give-examples',
            prompt: formatMessage((0, $jmorr.default).rovoChatGiveExamplesPrompt),
            optionText: formatMessage((0, $jmorr.default).rovoChatGiveExamplesOptionText)
        }
    ];
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            testId: "context-menu-rovo-chat-popup",
            xcss: $157c507ad23459f7$var$styles.popupContainer,
            space: "space.150",
            children: [
                rovoChatPromptOptions.map((option)=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
                        testId: option.id,
                        onClick: ()=>{
                            const formattedPrompt = (0, $ygGKm.appendADFContent)(selectedContent, option.prompt);
                            if (onClickPromptOverride) {
                                onClickPromptOverride(formattedPrompt);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                                    attributes: {
                                        actionType: option.actionType,
                                        product: product
                                    }
                                });
                                return;
                            }
                            publish({
                                type: 'chat-new',
                                source: `${product}-context-menu`,
                                data: {
                                    name: option.prompt.substring(0, 30),
                                    dialogues: [],
                                    prompt: formattedPrompt
                                }
                            });
                            sendAnalyticsEvent({
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'highlightActionsMenuConvoStarterButton',
                                attributes: {
                                    actionType: option.actionType,
                                    product: product
                                }
                            });
                        },
                        children: option.optionText
                    }, option.id);
                }),
                (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handlePromptSubmit,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                        name: "prompt",
                        children: ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default // this prevents the highlight actions popup from closing when clicking on the input
                            ), {
                                onClick: (e)=>e.stopPropagation(),
                                ...fieldPropsRest,
                                testId: "context-menu-rovo-chat-custom-prompt",
                                id: "context-menu-rovo-chat-custom-prompt",
                                autoComplete: "off",
                                elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $157c507ad23459f7$var$styles.sendIconWrapper,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        testId: "context-menu-rovo-chat-custom-prompt-submit",
                                        isDisabled: !dirty || !value,
                                        label: formatMessage((0, $jmorr.default).rovoChatCustomPromptSubmitButtonText),
                                        type: "submit",
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                        spacing: "compact"
                                    })
                                }),
                                placeholder: formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder),
                                "aria-label": formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder)
                            })
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                    onSubmit: handlePromptSubmit,
                    children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $157c507ad23459f7$var$styles.formWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("form", {
                                ...formProps,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    name: "prompt",
                                    children: ({ fieldProps: { value: value, ...fieldPropsRest }, meta: { dirty: dirty } })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default // this prevents the highlight actions popup from closing when clicking on the input
                                        ), {
                                            onClick: (e)=>e.stopPropagation(),
                                            ...fieldPropsRest,
                                            testId: "context-menu-rovo-chat-custom-prompt",
                                            id: "context-menu-rovo-chat-custom-prompt",
                                            autoComplete: "off",
                                            elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $157c507ad23459f7$var$styles.sendIconWrapper,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                    testId: "context-menu-rovo-chat-custom-prompt-submit",
                                                    isDisabled: !dirty || !value,
                                                    label: formatMessage((0, $jmorr.default).rovoChatCustomPromptSubmitButtonText),
                                                    type: "submit",
                                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                                    spacing: "compact"
                                                })
                                            }),
                                            placeholder: formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder),
                                            "aria-label": formatMessage((0, $jmorr.default).rovoChatCustomPromptPlaceholder)
                                        })
                                })
                            })
                        })
                })
            ]
        });
    };
    const isToolbarAIFCEnabled = (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true);
    if (product === 'confluence' && isToolbarAIFCEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: formatMessage((0, $jmorr.default).rovoChatOpenChatTooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $9J8UT.AIChatIcon), {
                label: ""
            }),
            onClick: handleClickChat,
            testId: "context-menu-rovo-chat-button",
            children: formatMessage((0, $jmorr.default).rovoChatAskRovoButtonText)
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: formatMessage((0, $jmorr.default).rovoChatOpenChatTooltip),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "subtle",
                    iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            xcss: $157c507ad23459f7$var$styles.rovoChatOpenChatIcon,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                                size: "xsmall"
                            })
                        }),
                    onClick: handleClickChat,
                    testId: "context-menu-rovo-chat-button",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        weight: "medium",
                        children: formatMessage((0, $jmorr.default).rovoChatAskRovoButtonText)
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                placement: "bottom-start",
                isOpen: isMoreOptionsPopupOpen,
                onClose: onClose,
                content: renderPopupContent,
                zIndex: 600,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $157c507ad23459f7$var$styles.rovoChatMoreOptionsButtonContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            ...triggerProps,
                            appearance: "subtle",
                            id: "context-menu-rovo-chat-more-options",
                            testId: "context-menu-rovo-chat-more-options",
                            isTooltipDisabled: false,
                            icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                    ...props,
                                    label: formatMessage((0, $jmorr.default).rovoChatMoreOptionsTooltip),
                                    size: "small"
                                }),
                            label: formatMessage((0, $jmorr.default).rovoChatMoreOptionsTooltip),
                            onClick: ()=>{
                                setIsMoreOptionsPopupOpen(!isMoreOptionsPopupOpen);
                                sendAnalyticsEvent({
                                    action: 'clicked',
                                    actionSubject: 'button',
                                    actionSubjectId: 'highlightActionsMenuRovoChatMoreOptionsButton',
                                    attributes: {
                                        product: product
                                    }
                                });
                            }
                        })
                    })
            })
        ]
    });
};
module.exports["RovoChatHighlightActions"] = $157c507ad23459f7$export$1ccbc9113b239d47;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($568c54c2a75aa99b$export$a775919ebd7dd28a.clear, $568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("9J8UT", function(module, exports) {
/* AIChatIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8aef4f4f02d5b2fe$var$styles = {
    container: "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1crf _1bsb1crf"
};
const $8aef4f4f02d5b2fe$var$ROVO_SVG_PATH = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L10.7381 2.50115C11.1589 2.7437 11.4193 3.1937 11.4193 3.67848V8.31707C11.4193 8.80377 11.1604 9.25178 10.7385 9.4942L7.71671 11.2376C7.72332 11.219 7.72963 11.2003 7.73565 11.1815C7.79172 11.0077 7.82146 10.8241 7.82146 10.6363V5.99777C7.82146 5.36053 7.4823 4.7729 6.92908 4.45501L6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224Z" fill="#FCA700"/>
		<path d="M4.35709 0.762451L1.33533 2.50585C0.91337 2.74828 0.654541 3.19629 0.654541 3.68299V8.32158C0.654541 8.80636 0.914895 9.25633 1.33561 9.49887L2.05206 9.91223L5.35553 11.8182C5.76872 12.0563 6.27717 12.0606 6.69373 11.8308C6.70128 11.825 6.7093 11.8196 6.71781 11.8147C7.01463 11.6435 7.2317 11.3691 7.33376 11.0521C7.3753 10.9211 7.39725 10.7826 7.39725 10.6409V8.84408L5.64872 7.83569L5.14485 7.54513C4.59174 7.22722 4.25234 6.63946 4.25234 6.00228V1.3637C4.25234 1.17625 4.28199 0.992849 4.33793 0.81927C4.344 0.800208 4.35039 0.781265 4.35709 0.762451Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64872 7.83569L2.05206 9.91223L1.33561 9.49887C0.914895 9.25633 0.654541 8.80636 0.654541 8.32158V3.68299C0.654541 3.19629 0.91337 2.74828 1.33533 2.50585L4.35709 0.762451C4.35039 0.781265 4.344 0.800208 4.33793 0.81927C4.28199 0.992849 4.25234 1.17625 4.25234 1.3637V6.00228C4.25234 6.63946 4.59174 7.22722 5.14485 7.54513L5.64872 7.83569Z" fill="#1868DB"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.37094 4.13313L4.67654 3.15598V1.35919C4.67654 1.21761 4.69845 1.0793 4.7399 0.948371C4.8418 0.631497 5.05854 0.357177 5.35505 0.185934L5.35594 0.185415C5.36443 0.180511 5.37252 0.175072 5.38007 0.169224C5.79665 -0.0605531 6.30508 -0.0563317 6.71827 0.181888L9.96761 2.05659L6.37094 4.13313Z" fill="#FCA700"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M10.7381 2.5012L9.9676 2.05664L6.37094 4.13318L6.92907 4.45507C7.48229 4.77296 7.82146 5.36059 7.82146 5.99783V10.6364C7.82146 10.8241 7.79172 11.0078 7.73565 11.1816C7.72963 11.2004 7.72332 11.2191 7.71671 11.2377L10.7385 9.49426C11.1604 9.25184 11.4193 8.80382 11.4193 8.31712V3.67853C11.4193 3.19376 11.1589 2.74376 10.7381 2.5012Z" fill="#AF59E0"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.64873 7.83569L2.05206 9.91224L5.35553 11.8182C5.76873 12.0564 6.27718 12.0606 6.69373 11.8308C6.70128 11.825 6.70931 11.8196 6.71782 11.8147C7.01463 11.6436 7.2317 11.3691 7.33377 11.0521C7.37531 10.9211 7.39726 10.7826 7.39726 10.6409V8.84409L5.64873 7.83569Z" fill="#6A9A23"/>
	</svg>`;
const $8aef4f4f02d5b2fe$var$RovoLogoSVG = ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        role: "img",
        "aria-label": label,
        "data-testid": testId,
        dangerouslySetInnerHTML: {
            __html: $8aef4f4f02d5b2fe$var$ROVO_SVG_PATH
        },
        className: (0, $gMc0m.default)([
            $8aef4f4f02d5b2fe$var$styles.container
        ])
    });
const $8aef4f4f02d5b2fe$export$4476d508de061a72 = ({ label: label, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)($8aef4f4f02d5b2fe$var$RovoLogoSVG, {
        label: label,
        testId: testId
    });
module.exports["AIChatIcon"] = $8aef4f4f02d5b2fe$export$4476d508de061a72;

});

parcelRegister("lBFuf", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $hge3g = parcelRequire("hge3g");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $7Y4kW = parcelRequire("7Y4kW");


var $jz7J7 = parcelRequire("jz7J7");

const $204b57ff8caef44c$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $204b57ff8caef44c$var$styles = {
    button: "_2rko12b0 _11c8fhey _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $204b57ff8caef44c$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7Y4kW.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($204b57ff8caef44c$var$styles.queryText, whiteSpacePreWrap && $204b57ff8caef44c$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $204b57ff8caef44c$export$76b47032dcd9063b = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                xcss: $204b57ff8caef44c$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $204b57ff8caef44c$var$styles.queryText,
                        children: formatMessage((0, $jz7J7.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});
module.exports["ChatPill"] = $204b57ff8caef44c$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $204b57ff8caef44c$export$76b47032dcd9063b;

});

parcelRegister("7Y4kW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");

const $eb50cc4a563796fc$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $eb50cc4a563796fc$export$38f9b635c1c454e7;

});

parcelRegister("jz7J7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $5fc6573ead9ef7c8$var$_default_1 = (0, $aXWIB.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse Agents"
    }
});
var $5fc6573ead9ef7c8$export$2e2bcd8739ae039 = $5fc6573ead9ef7c8$var$_default_1;
module.exports["default"] = $5fc6573ead9ef7c8$export$2e2bcd8739ae039;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("kIvLT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6v6KC = parcelRequire("6v6KC");

var $inPa6 = parcelRequire("inPa6");


var $fYQcF = parcelRequire("fYQcF");


var $1yaYZ = parcelRequire("1yaYZ");


var $TwPkE = parcelRequire("TwPkE");


var $jA9SA = parcelRequire("jA9SA");


var $bQGO7 = parcelRequire("bQGO7");


var $lUZCl = parcelRequire("lUZCl");

const $6e0837af2bd4bfd5$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $6e0837af2bd4bfd5$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $6e0837af2bd4bfd5$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $TwPkE.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $42omo.useCallback)((inputPayload)=>{
        const payload = (0, $6v6KC.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $6e0837af2bd4bfd5$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
    ];
    if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultAdopted: trackAIResultAdopted, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $42omo.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, inProductExperience: inProductExperience, mode: mode, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias } = propertiesRef.current;
        return {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).inProductExperience]: inProductExperience,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).mode]: mode,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $42omo.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
        ];
        if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, scenarioId: scenarioId, pageContext: pageContext, attributes: customAttributes } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributes
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        if (assistanceServiceConfigMinionAlias) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        let libAttributes = {
            ...attributes,
            aiFeatureName: 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0
        };
        switch(payload.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                trackAIResultAction(payload.actionResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'adopted':
                trackAIResultAdopted(payload.actionResult, {
                    attributes: {
                        ...libAttributes,
                        actionKey: payload.actionKey,
                        rovoModifiedObjects: payload.rovoModifiedObjects
                    },
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'feedback':
                trackAIFeedbackSubmit(payload.feedbackResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIResultAdopted,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $42omo.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $6e0837af2bd4bfd5$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        let eventToBeLoggedWithSentry;
        if ((0, $6v6KC.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(payload.context);
            const updatedEvent = payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            });
            updatedEvent.fire((0, $bQGO7.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            const updatedEvent = event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            });
            updatedEvent.fire((0, $bQGO7.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $1yaYZ.addSentryBreadcrumb)(`sendAnalyticsEvent event: ${JSON.stringify(eventToBeLoggedWithSentry)}`);
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["useAnalytics"] = $6e0837af2bd4bfd5$export$e955abb82869dc84;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $1M9Av = parcelRequire("1M9Av");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $42omo.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).adopted, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3pfAb.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $1M9Av.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $42omo.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    return {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
};
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("1M9Av", function(module, exports) {
const $699df07a7cf548d4$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $699df07a7cf548d4$export$e053e424fcbfebe9;

});

parcelRegister("1yaYZ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8Igpw = parcelRequire("8Igpw");


var $j2DyP = parcelRequire("j2DyP");


var $35fh0 = parcelRequire("35fh0");


var $ldpU6 = parcelRequire("ldpU6");


// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $26a7abafe1ae99d6$var$importSentryAsync = async ()=>Promise.resolve((parcelRequire("7hGsm")));
let $26a7abafe1ae99d6$var$sentryClient;
let $26a7abafe1ae99d6$var$accountIdPromise;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $26a7abafe1ae99d6$var$getEnvironment = ()=>{
    return 'production';
};
const $26a7abafe1ae99d6$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $35fh0.getRovoChatProduct)();
    try {
        if ((0, $dh538.fg)('rovo_chat_enable_additional_breadcrumbs')) {
            if (!$26a7abafe1ae99d6$var$accountIdPromise) $26a7abafe1ae99d6$var$accountIdPromise = new Promise((resolve, reject)=>{
                (0, $8Igpw.performHttpFetch)({
                    path: '/gateway/api/me',
                    options: {
                        method: 'GET'
                    }
                }).then((profileData)=>{
                    if (profileData?.account_id) resolve(profileData.account_id);
                    else reject(new Error('Profile data not loaded'));
                }).catch((error)=>{
                    reject(error);
                });
            });
            accountId = await $26a7abafe1ae99d6$var$accountIdPromise;
        } else {
            const profileData = await (0, $8Igpw.performHttpFetch)({
                path: '/gateway/api/me',
                options: {
                    method: 'GET'
                }
            });
            if (profileData?.account_id) accountId = profileData.account_id;
        }
    } catch  {
    // do nothing
    }
    if ($26a7abafe1ae99d6$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $26a7abafe1ae99d6$var$sentryClient.setTag('product', product);
        $26a7abafe1ae99d6$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $26a7abafe1ae99d6$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    importedSentry.init({
        dsn: customSentryDsn || defaultSentryDsn,
        environment: $26a7abafe1ae99d6$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName || '@atlassian/conversation-assistant',
                product: product,
                packageVersion: packageVersion
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $j2DyP.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                updatedEvent.request.url = (0, $ldpU6.normaliseUrl)(updatedEvent.request.url);
            }
            if (updatedEvent.exception?.values) {
                const allMatchedUUIDs = [];
                updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                    const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $ldpU6.normalizeUUID)(exception.value);
                    allMatchedUUIDs.push(...matchedUUIDs);
                    return {
                        ...exception,
                        value: normalized
                    };
                });
                if (allMatchedUUIDs.length > 0) {
                    if (!updatedEvent.tags) updatedEvent.tags = {};
                    updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                }
            }
            return updatedEvent;
        },
        attachStacktrace: true,
        ignoreErrors: ignoreErrors
    });
    $26a7abafe1ae99d6$var$sentryClient = importedSentry;
};
const $26a7abafe1ae99d6$var$getSentryClient = async ()=>{
    if (!$26a7abafe1ae99d6$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $26a7abafe1ae99d6$export$d8bd0edf6c978788();
    return $26a7abafe1ae99d6$var$sentryClient;
};
const $26a7abafe1ae99d6$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') scope.setTag('experience', name);
        sentryClient.captureException(exception, scope);
    });
};
async function $26a7abafe1ae99d6$export$de29810e0b4aa46e(crumb) {
    if (!(0, $dh538.fg)('rovo_chat_enable_additional_breadcrumbs')) // do not add breadcrumbs if the feature flag is disabled
    return;
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.addBreadcrumb(typeof crumb === 'string' ? {
        message: crumb
    } : crumb);
}
module.exports["setupSentryClient"] = $26a7abafe1ae99d6$export$d8bd0edf6c978788;
module.exports["logException"] = $26a7abafe1ae99d6$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $26a7abafe1ae99d6$export$de29810e0b4aa46e;

});

parcelRegister("8Igpw", function(module, exports) {
const $43e5bdc11d95b8bf$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $43e5bdc11d95b8bf$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $43e5bdc11d95b8bf$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $43e5bdc11d95b8bf$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $43e5bdc11d95b8bf$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        const statusCode = err instanceof $43e5bdc11d95b8bf$var$HttpApiError ? err?.errorAttributes?.statusCode : undefined;
        throw new $43e5bdc11d95b8bf$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $43e5bdc11d95b8bf$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $43e5bdc11d95b8bf$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $43e5bdc11d95b8bf$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $43e5bdc11d95b8bf$export$9f229e40eb65abfc;
module.exports["FetchError"] = $43e5bdc11d95b8bf$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $43e5bdc11d95b8bf$export$a38d93aa782475f6;

});

parcelRegister("j2DyP", function(module, exports) {
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $3c7c331d93a4dcee$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $3c7c331d93a4dcee$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.cause.message)));
module.exports["isClientFetchError"] = $3c7c331d93a4dcee$export$2e7adc44463c3f4f;

});

parcelRegister("35fh0", function(module, exports) {
const $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc;

});

parcelRegister("ldpU6", function(module, exports) {
const $62424571d4d73005$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $62424571d4d73005$var$ATLAS_HOST = 'home.atlassian.com';
const $62424571d4d73005$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $62424571d4d73005$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $62424571d4d73005$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $62424571d4d73005$var$ATLAS_HOST || parsedUrl.host === $62424571d4d73005$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$62424571d4d73005$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $62424571d4d73005$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($62424571d4d73005$var$UUID_REGEX) || [];
    const normalized = str.replace($62424571d4d73005$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $62424571d4d73005$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $62424571d4d73005$export$5efaf8444170fe75;

});

parcelRegister("TwPkE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $19e5e9ef880dfbce$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    inProductExperience: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $19e5e9ef880dfbce$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $42omo.createContext)({
    propertiesRef: {
        current: {
            ...$19e5e9ef880dfbce$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $19e5e9ef880dfbce$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $42omo.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $19e5e9ef880dfbce$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $42omo.useRef)({
        ...$19e5e9ef880dfbce$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $42omo.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $19e5e9ef880dfbce$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $42omo.useContext)($19e5e9ef880dfbce$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $42omo.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$1aefd27d2ed3c1c9, {
                mode: mode,
                children: children
            })
        })
    });
};
const $19e5e9ef880dfbce$export$ab8aa3dfd687f012 = ()=>{
    return (0, $42omo.useContext)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $19e5e9ef880dfbce$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $19e5e9ef880dfbce$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $19e5e9ef880dfbce$export$ab8aa3dfd687f012;

});

parcelRegister("jA9SA", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $eb66f40a0f078927$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    inProductExperience: 'inProductExperience',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias'
};
module.exports["AI_MATE_ATTRIBUTES"] = $eb66f40a0f078927$export$8cffc8b2c93affd4;

});

parcelRegister("bQGO7", function(module, exports) {

var $3pfAb = parcelRequire("3pfAb");

const $7940b633dc028a3e$export$85183a312807388d = (0, $3pfAb.FabricChannel).aiMate;
var $7940b633dc028a3e$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    return AUTOSUGGEST_SOURCE;
}({});
module.exports["ANALYTICS_CHANNEL"] = $7940b633dc028a3e$export$85183a312807388d;
module.exports["AUTOSUGGEST_SOURCE"] = $7940b633dc028a3e$export$406073150b1a408;

});

parcelRegister("lUZCl", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $iN5LM = parcelRequire("iN5LM");

const $ee6ebd3561b1c806$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $iN5LM.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $ee6ebd3561b1c806$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$ee6ebd3561b1c806$var$isSourceAndAttributes(x) || x[0, $ffCOo.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $ffCOo.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $ee6ebd3561b1c806$export$d97c97ed77ff09e8;

});

parcelRegister("iN5LM", function(module, exports) {
const $79e4722581e5fb43$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $79e4722581e5fb43$export$e31e24b63b7085fd;

});

parcelRegister("ygGKm", function(module, exports) {
const $604298656c254432$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $604298656c254432$export$f00236a854eaa848;

});

parcelRegister("gncRT", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0d32633bd323405d$var$store = (0, $1P1Tu.createStore)({
    name: 'RovoChatHighlightActionsStore',
    initialState: {
        isMoreOptionsPopupOpen: false
    },
    actions: {
        setIsMoreOptionsPopupOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isMoreOptionsPopupOpen: isOpen
                });
            }
    }
});
const $0d32633bd323405d$export$6c9cf98a64763bb1 = (0, $9zUhf.createHook)($0d32633bd323405d$var$store);
const $0d32633bd323405d$export$f1e33ed2d48967b4 = (0, $9zUhf.createActionsHook)($0d32633bd323405d$var$store);
module.exports["useRovoChatHighlightActions"] = $0d32633bd323405d$export$6c9cf98a64763bb1;
module.exports["useRovoChatHighlightActionsActions"] = $0d32633bd323405d$export$f1e33ed2d48967b4;

});

parcelRegister("gjr93", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $ygGKm = parcelRequire("ygGKm");


var $iUl0E = parcelRequire("iUl0E");

const $574c86f95ed7997c$var$state = (0, $1P1Tu.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder
                });
            }
    }
});
const $574c86f95ed7997c$export$e638cf26ae51308d = (0, $9zUhf.createHook)($574c86f95ed7997c$var$state);
const $574c86f95ed7997c$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $ygGKm.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $574c86f95ed7997c$export$21b2d5ca0689f678 = ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $574c86f95ed7997c$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const insertHighlightActionsEditorPlaceholder = (0, $42omo.useCallback)((prompt)=>{
        const highlightActionsPlaceholderPrompt = formatMessage((0, $iUl0E.default).highlightActionsPlaceholderPrompt);
        const placeholderData = $574c86f95ed7997c$var$getHighlightActionPlaceholderData(prompt, highlightActionsPlaceholderPrompt);
        setHighlightActionsEditorPlaceholder(placeholderData);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $42omo.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $574c86f95ed7997c$export$21b2d5ca0689f678;

});

parcelRegister("iUl0E", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $2fd64f51ce2261f9$var$_default_1 = (0, $aXWIB.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});
var $2fd64f51ce2261f9$export$2e2bcd8739ae039 = $2fd64f51ce2261f9$var$_default_1;
module.exports["default"] = $2fd64f51ce2261f9$export$2e2bcd8739ae039;

});

parcelRegister("jmorr", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1ee4456065df4341$var$_default_1 = (0, $aXWIB.defineMessages)({
    rovoChatAskInChatButtonText: {
        id: "highlight-actions.rovo-chat.ask-in-chat-button-text",
        defaultMessage: "Ask in Chat"
    },
    rovoChatAskRovoButtonText: {
        id: "highlight-actions.rovo-chat.ask-rovo-button-text",
        defaultMessage: "Ask Rovo"
    },
    rovoChatOpenChatTooltip: {
        id: "highlight-actions.rovo-chat-open-chat.tooltip",
        defaultMessage: "Open Chat"
    },
    rovoChatMoreOptionsTooltip: {
        id: "highlight-actions.rovo-chat-more-options.tooltip",
        defaultMessage: "Chat recommendations"
    },
    rovoChatSummarizeOptionText: {
        id: "highlight-actions.rovo-chat-summarize-option.text",
        defaultMessage: "Summarize"
    },
    rovoChatExplainOptionText: {
        id: "highlight-actions.rovo-chat-explain-option.text",
        defaultMessage: "Explain"
    },
    rovoChatFindResourcesOptionText: {
        id: "highlight-actions.rovo-chat-find-resources-option.text",
        defaultMessage: "Find resources"
    },
    rovoChatGiveFeedbackOptionText: {
        id: "highlight-actions.rovo-chat-give-feedback-option.text",
        defaultMessage: "Give feedback"
    },
    rovoChatGiveExamplesOptionText: {
        id: "highlight-actions.rovo-chat-give-examples-option.text",
        defaultMessage: "Give examples"
    },
    rovoChatSummarizePrompt: {
        id: "highlight-actions.rovo-chat-summarize-prompt",
        defaultMessage: "Highlight the key points from this. Focus on essential information and exclude unnecessary details. Provide a concise overview in a single paragraph."
    },
    rovoChatExplainPrompt: {
        id: "highlight-actions.rovo-chat-explain-prompt",
        defaultMessage: "Explain this by rephrasing it and adding additional detail, but use very simple language, short sentences, and provide examples or definitions to any technical terminology used in the original phrasing."
    },
    rovoChatFindResourcesPrompt: {
        id: "highlight-actions.rovo-chat-find-resources-prompt",
        defaultMessage: "Find resources within organizational knowledge only that supports the statements made."
    },
    rovoChatGiveFeedbackPrompt: {
        id: "highlight-actions.rovo-chat-give-feedback-prompt",
        defaultMessage: "Give feedback by reviewing the phrasing of this. Provide commentary on word choice, grammar, punctuation. Be positive and enthusiastic but always provide at least one thing to improve or change."
    },
    rovoChatGiveExamplesPrompt: {
        id: "highlight-actions.rovo-chat-give-examples-prompt",
        defaultMessage: "Give examples of this from organizational resources or public knowledge. If there are no resources to provide attempt to give a metaphorical example that may help someone understand this more."
    },
    rovoChatCustomPromptPlaceholder: {
        id: "highlight-actions.rovo-chat-custom-prompt.placeholder",
        defaultMessage: "Ask AI about this"
    },
    rovoChatCustomPromptSubmitButtonText: {
        id: "highlight-actions.rovo-chat-custom-prompt-submit-button.text",
        defaultMessage: "Send"
    }
});
var $1ee4456065df4341$export$2e2bcd8739ae039 = $1ee4456065df4341$var$_default_1;
module.exports["default"] = $1ee4456065df4341$export$2e2bcd8739ae039;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lYk0G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lYk0G", function(module, exports) {

let $ffeeb920d352edae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffeeb920d352edae$var$load("2PePB"),
    $ffeeb920d352edae$var$load("bIPPg"),
    $ffeeb920d352edae$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("2A8CJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    lastModificationDate: null
});
$dae2c2bf6a5fe745$export$6d9b0a4fb48787a7.displayName = 'ContentBodyContext';
module.exports["ContentBodyContext"] = $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $1dnxO = parcelRequire("1dnxO");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        if (// The increased height change is only applied when FHS is enabled (even if the gate is enabled)
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false) && (0, $9wGTI.fg)('platform_dst_nav4_top_nav_increase_height')) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("2Jxlo", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8c38d1311bce6ee3$export$15b21f0ead27e4bf = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qNGEh",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("3KmKC"))).ReadingAidsPopup
});
module.exports["ReadingAidsPopup"] = $8c38d1311bce6ee3$export$15b21f0ead27e4bf;

});

parcelRegister("3KmKC", function(module, exports) {

let $2ba750d65e797d4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ba750d65e797d4c$var$load("h3ABO"),
    $2ba750d65e797d4c$var$load("9hYRW"),
    $2ba750d65e797d4c$var$load("kpm7S"),
    $2ba750d65e797d4c$var$load("5wC2D"),
    $2ba750d65e797d4c$var$load("2YffH"),
    $2ba750d65e797d4c$var$load("g7ggm"),
    $2ba750d65e797d4c$var$load("eEyVs"),
    $2ba750d65e797d4c$var$load("6mHrv"),
    $2ba750d65e797d4c$var$load("awWN9"),
    $2ba750d65e797d4c$var$load("9CYct"),
    $2ba750d65e797d4c$var$load("fP9Su"),
    $2ba750d65e797d4c$var$load("3KcX6"),
    $2ba750d65e797d4c$var$load("hZtKG"),
    $2ba750d65e797d4c$var$load("dkqvW"),
    $2ba750d65e797d4c$var$load("lVO3w"),
    $2ba750d65e797d4c$var$load("hyzoX"),
    $2ba750d65e797d4c$var$load("h9Ed7"),
    $2ba750d65e797d4c$var$load("eBRUf"),
    $2ba750d65e797d4c$var$load("kbRvk"),
    $2ba750d65e797d4c$var$load("tKhaz"),
    $2ba750d65e797d4c$var$load("hwT9D"),
    $2ba750d65e797d4c$var$load("j4Bpe"),
    $2ba750d65e797d4c$var$load("cD6Zr"),
    $2ba750d65e797d4c$var$load("k3jER"),
    $2ba750d65e797d4c$var$load("9wzNh"),
    $2ba750d65e797d4c$var$load("8YSo7"),
    $2ba750d65e797d4c$var$load("9ldRJ"),
    $2ba750d65e797d4c$var$load("50ame"),
    $2ba750d65e797d4c$var$load("7do1E"),
    $2ba750d65e797d4c$var$load("77dkW"),
    $2ba750d65e797d4c$var$load("1MlIV"),
    $2ba750d65e797d4c$var$load("6iz6l"),
    $2ba750d65e797d4c$var$load("4SCW2"),
    $2ba750d65e797d4c$var$load("aXHNO"),
    $2ba750d65e797d4c$var$load("kmvek"),
    $2ba750d65e797d4c$var$load("Wowvf"),
    $2ba750d65e797d4c$var$load("421lv"),
    $2ba750d65e797d4c$var$load("dek7I"),
    $2ba750d65e797d4c$var$load("3SmkN"),
    $2ba750d65e797d4c$var$load("dYtBN"),
    $2ba750d65e797d4c$var$load("kNV5Y"),
    $2ba750d65e797d4c$var$load("6wr18"),
    $2ba750d65e797d4c$var$load("kjZZD"),
    $2ba750d65e797d4c$var$load("7cDV0"),
    $2ba750d65e797d4c$var$load("ijD5W"),
    $2ba750d65e797d4c$var$load("3JSgG"),
    $2ba750d65e797d4c$var$load("37ldp"),
    $2ba750d65e797d4c$var$load("ffEVr"),
    $2ba750d65e797d4c$var$load("9AXkC"),
    $2ba750d65e797d4c$var$load("28arV"),
    $2ba750d65e797d4c$var$load("hhss7"),
    $2ba750d65e797d4c$var$load("l1BQC"),
    $2ba750d65e797d4c$var$load("jlSF3"),
    $2ba750d65e797d4c$var$load("dP7ao"),
    $2ba750d65e797d4c$var$load("hogcU"),
    $2ba750d65e797d4c$var$load("4pqtR"),
    $2ba750d65e797d4c$var$load("5XqRg"),
    $2ba750d65e797d4c$var$load("7EorR"),
    $2ba750d65e797d4c$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});

parcelRegister("a3Fla", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $371bfa624b8f4825$export$d9088a53cb7c38b4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "W_5EK",
    name: "ReadingAidsChangeboardingModal",
    loader: async ()=>(await (parcelRequire("d7fiu"))).ReadingAidsChangeboardingModal
});
module.exports["ReadingAidsChangeboardingModal"] = $371bfa624b8f4825$export$d9088a53cb7c38b4;

});

parcelRegister("d7fiu", function(module, exports) {

let $98c7cb83b0c6308d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98c7cb83b0c6308d$var$load("6wr18"),
    $98c7cb83b0c6308d$var$load("ffEVr"),
    $98c7cb83b0c6308d$var$load("kwiXK")
]).then(()=>parcelRequire('iPt4B'));

});

parcelRegister("9ikgN", function(module, exports) {
$parcel$export(module.exports, "READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID", () => (parcelRequire("cR1lV")).READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID);

var $jmjWc = parcelRequire("jmjWc");


var $cR1lV = parcelRequire("cR1lV");


const $ade6da7539ba5902$export$1942ca99b3c33b66 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "B2kdC",
    name: "ReadingAidsChangeboardingSpotlight",
    loader: async ()=>(await Promise.resolve((parcelRequire("cR1lV")))).ReadingAidsChangeboardingSpotlight
});
module.exports["ReadingAidsChangeboardingSpotlight"] = $ade6da7539ba5902$export$1942ca99b3c33b66;

});

parcelRegister("cR1lV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $lsxnT = parcelRequire("lsxnT");

const $83df18abc582ef5a$export$a21884ebed08a664 = 'reading-aids-spotlight';
const $83df18abc582ef5a$var$i18n = (0, $aXWIB.defineMessages)({
    changeboardingSpotlightGotItButton: {
        id: "contextual-reading-aids.changeboarding-spotlight.got-it-button",
        defaultMessage: "Got it"
    },
    changeboardingSpotlightText: {
        id: "contextual-reading-aids.changeboarding-spotlight.text",
        defaultMessage: "Remember, this feature works best when you select specific terms, acronyms, or internal project/team names."
    }
});
const $83df18abc582ef5a$export$1942ca99b3c33b66 = ({ contentId: contentId, onGotItClick: onGotItClick })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'readingAidsSpotlightChangeboarding',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'readingAidsSpotlightGotItButton',
                attributes: {
                    contentId: contentId
                }
            }
        });
        onGotItClick();
    };
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        actions: [
            {
                text: intl.formatMessage($83df18abc582ef5a$var$i18n.changeboardingSpotlightGotItButton),
                onClick: handleOnClick
            }
        ],
        target: $83df18abc582ef5a$export$a21884ebed08a664,
        targetRadius: 4
    }, intl.formatMessage($83df18abc582ef5a$var$i18n.changeboardingSpotlightText));
};
module.exports["READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID"] = $83df18abc582ef5a$export$a21884ebed08a664;
module.exports["ReadingAidsChangeboardingSpotlight"] = $83df18abc582ef5a$export$1942ca99b3c33b66;

});

parcelRegister("7rLBD", function(module, exports) {

var $7Zbm6 = parcelRequire("7Zbm6");

const $40851a06f2d6c64a$export$cd08f5c9e05f94dd = (contentId, cloudID, contentType)=>{
    if (!contentType) return '';
    return `ari:cloud:confluence:${cloudID}:${contentType}/${contentId}`;
};
const $40851a06f2d6c64a$export$8530183f316e301c = (activationId, cloudId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
const $40851a06f2d6c64a$export$b381579634332aed = (curatedDefinition)=>{
    const curatedDefinitionReference = curatedDefinition.confluenceEntity;
    return {
        nlpResult: curatedDefinition.definition,
        uniqueSources: curatedDefinitionReference ? [
            {
                id: curatedDefinitionReference?.id || '',
                title: curatedDefinitionReference?.title || '',
                url: curatedDefinition.referenceUrl || '',
                type: curatedDefinitionReference?.type || '',
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: curatedDefinitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: curatedDefinition.editor?.name ? {
            name: curatedDefinition.editor.name || '',
            id: curatedDefinition.editor.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
    };
};
const $40851a06f2d6c64a$export$479750843803fc13 = 5;
const $40851a06f2d6c64a$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["generatePageARI"] = $40851a06f2d6c64a$export$cd08f5c9e05f94dd;
module.exports["generateWorkspaceId"] = $40851a06f2d6c64a$export$8530183f316e301c;
module.exports["READING_AIDS_MAX_WORD_COUNT"] = $40851a06f2d6c64a$export$479750843803fc13;
module.exports["getHighlightCategories"] = $40851a06f2d6c64a$export$f600f3124ea5916b;

});

parcelRegister("7Zbm6", function(module, exports) {
var $313b937e83fff73c$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
var $313b937e83fff73c$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});
var $313b937e83fff73c$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $313b937e83fff73c$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    NLPSearchErrorState["EarlyStop"] = "EARLY_STOP";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    // Value at component initialization
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    // Value if the network call fails
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    // Value if the network call times out
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    return NLPSearchErrorState;
}({});
var $313b937e83fff73c$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
var $313b937e83fff73c$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});
var $313b937e83fff73c$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
var $313b937e83fff73c$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    AIAnswerQueryStreamType["EarlyStop"] = "EARLY_STOP";
    return AIAnswerQueryStreamType;
}({});
var $313b937e83fff73c$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
var $313b937e83fff73c$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
module.exports["NLPSearchResultFormat"] = $313b937e83fff73c$export$e20550b618a28239;
module.exports["NLPSearchJSONResultFormat"] = $313b937e83fff73c$export$eae917983a0398aa;
module.exports["NLPSearchErrorState"] = $313b937e83fff73c$export$9405d23bea8d0d8b;
module.exports["NLPSearchErrorCodes"] = $313b937e83fff73c$export$6b1112c70cca65d3;
module.exports["NLPSearchResultContainerDataTypeContainerType"] = $313b937e83fff73c$export$7c6c2f9c68de2e45;
module.exports["NLPSearchCustomDefinitionType"] = $313b937e83fff73c$export$12b805d25b464b8d;
module.exports["AIAnswerQueryStreamType"] = $313b937e83fff73c$export$130eddddf4243f3f;
module.exports["AIAnswerAPIType"] = $313b937e83fff73c$export$e7b798431c659b80;

});

parcelRegister("bjVRl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $1P1Tu.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $9zUhf.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $9zUhf.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $9wGTI.fg)('confluence_browser_storage_prepended_keys') ? `${featureKey}-featureDiscoveryOverride` : `${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}-${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $42omo.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<1333db28a4b11ca5e337731bdc8887fb>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<232155696f82fbae3aa6e3e0b041a429>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("eDk57", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4aiCO = parcelRequire("4aiCO");


var $1mDVg = parcelRequire("1mDVg");

const $45dbb5af31f3f8d0$export$bc90850968906652 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1mDVg.IssueCreateSidePanelContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4aiCO.IssueCreateWarningDialogContainer), null, children));
};
module.exports["SingleIssueCreateProvidersWrapper"] = $45dbb5af31f3f8d0$export$bc90850968906652;

});

parcelRegister("aiS08", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_ID", () => (parcelRequire("1L1jV")).ISSUE_CREATE_SIDE_PANEL_ID);

var $jmjWc = parcelRequire("jmjWc");


var $1L1jV = parcelRequire("1L1jV");


const $8c03994ca3756429$export$808956d96594cb81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dU97j",
    name: "IssueCreateSidePanel",
    loader: async ()=>(await Promise.resolve((parcelRequire("1L1jV")))).IssueCreateSidePanel
});
module.exports["IssueCreateSidePanel"] = $8c03994ca3756429$export$808956d96594cb81;

});

parcelRegister("1L1jV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $7aRa9 = parcelRequire("7aRa9");


var $ai7NK = parcelRequire("ai7NK");


var $3yh4a = parcelRequire("3yh4a");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $98CLM = parcelRequire("98CLM");


var $kJYUO = parcelRequire("kJYUO");


var $1mDVg = parcelRequire("1mDVg");


var $eDk57 = parcelRequire("eDk57");


var $5Ew1A = parcelRequire("5Ew1A");


var $jwedr = parcelRequire("jwedr");


var $3AAT8 = parcelRequire("3AAT8");


var $hib1D = parcelRequire("hib1D");


var $6pbwW = parcelRequire("6pbwW");

const $7dea7a25aec9b259$export$3318bd9d18742c1e = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$e760a8f02240cc6d = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$d030b92b162b528d = 320;
const $7dea7a25aec9b259$var$sidePanelStyle = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponent = ({ onClose: onClose, flags: flags })=>{
    const { showSidePanel: showSidePanel, hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { isWarningDialogOpen: isWarningDialogOpen, handleConfirm: handleConfirm, handleCancel: handleCancel } = (0, $jwedr.useGetWarningDialogActions)(onClose);
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { aiState: aiState, isCreatedWithAi: isCreatedWithAi, aiAnalyticsContext: aiAnalyticsContext, isCreatedFromActionItems: isCreatedFromActionItems } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const shouldShowAiFooter = isCreatedWithAi && aiState !== 'error';
    const isAiLoading = aiState === 'loading';
    const handleOnClose = (0, $42omo.useCallback)((isCreateSuccess)=>{
        if (isCreatedWithAi && !isCreateSuccess) trackAIInteractionDismiss({
            attributes: aiAnalyticsContext
        });
        if (!isCreateSuccess) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'linkCreate',
                type: 'ui',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    isAiLoading: isAiLoading,
                    aiEnablement: aiIssueCreationEnablement?.enablement,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false
                }
            }
        }).fire();
        hideSidePanel();
        onClose();
        actions.setAiState('idle');
    }, [
        isCreatedWithAi,
        hideSidePanel,
        onClose,
        actions,
        trackAIInteractionDismiss,
        aiAnalyticsContext,
        createAnalyticsEvent,
        state.pageMode,
        isAiLoading,
        aiIssueCreationEnablement?.enablement,
        state.hasEditPermission,
        isCreatedFromActionItems
    ]);
    const handleOnConfirm = (0, $42omo.useCallback)(()=>{
        actions.setAiState('idle');
        handleConfirm();
    }, [
        actions,
        handleConfirm
    ]);
    (0, $42omo.useEffect)(()=>{
        showSidePanel();
    }, [
        showSidePanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: $7dea7a25aec9b259$export$3318bd9d18742c1e,
        xcss: $7dea7a25aec9b259$var$sidePanelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kJYUO.IssueCreateAiLoadingSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pbwW.IssueCreateSidePanelHeader), {
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3AAT8.IssueCreateSidePanelBody), {
        onClose: handleOnClose,
        flags: flags
    }), shouldShowAiFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hib1D.IssueCreateSidePanelFooter), null))), isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onCancel: handleCancel,
        onConfirm: handleOnConfirm,
        issuesCount: 1
    }));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider = ({ onClose: onClose, flags: flags })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7dea7a25aec9b259$var$IssueCreateSidePanelComponent, {
        onClose: onClose,
        flags: flags
    })));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags = (0, $7aRa9.withFlags)($7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider);
const $7dea7a25aec9b259$var$IssueCreateSidePanelWithErrorBoundary = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
})($7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags);
const $7dea7a25aec9b259$export$808956d96594cb81 = (0, $3yh4a.componentWithFG)('jira_ai_aiwc_in_confluence_set_up_error_boundary', $7dea7a25aec9b259$var$IssueCreateSidePanelWithErrorBoundary, $7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags);
module.exports["sidePanelTestId"] = $7dea7a25aec9b259$export$3318bd9d18742c1e;
module.exports["ISSUE_CREATE_SIDE_PANEL_ID"] = $7dea7a25aec9b259$export$e760a8f02240cc6d;
module.exports["ISSUE_CREATE_SIDE_PANEL_WIDTH"] = $7dea7a25aec9b259$export$d030b92b162b528d;
module.exports["IssueCreateSidePanel"] = $7dea7a25aec9b259$export$808956d96594cb81;

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("8YePs", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("kJYUO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1mDVg = parcelRequire("1mDVg");


var $hq2Sz = parcelRequire("hq2Sz");


var $1uJpg = parcelRequire("1uJpg");

const $e4ab54f04ea47f96$export$dcc317fc4f9228b3 = ({ children: children })=>{
    const [{ aiState: aiState, pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const [{ isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiLoading = aiState === 'loading';
    const aiEnablement = aiIssueCreationEnablement?.enablement;
    (0, $42omo.useEffect)(()=>{
        if (isAiLoading) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AI loading state',
                source: 'confluenceHighlightIssueCreate',
                attributes: {
                    aiEnablement: aiEnablement,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    isCreatedFromTable: isCreatedFromTable
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAiLoading,
        aiEnablement,
        pageMode,
        hasEditPermission,
        isCreatedFromActionItems,
        isCreatedFromTable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1uJpg.RainbowLoadingSidebar), {
        isShown: isAiLoading
    }, children);
};
module.exports["IssueCreateAiLoadingSidebar"] = $e4ab54f04ea47f96$export$dcc317fc4f9228b3;

});

parcelRegister("3AAT8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $cfwlu = parcelRequire("cfwlu");


var $fYQcF = parcelRequire("fYQcF");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1mDVg = parcelRequire("1mDVg");


var $5FJ5W = parcelRequire("5FJ5W");


var $3E5yu = parcelRequire("3E5yu");


var $1Q0l6 = parcelRequire("1Q0l6");


var $9K9na = parcelRequire("9K9na");


var $2ay9q = parcelRequire("2ay9q");


var $bImpr = parcelRequire("bImpr");


var $kcLnq = parcelRequire("kcLnq");


var $bZC8A = parcelRequire("bZC8A");


var $jE0Gg = parcelRequire("jE0Gg");


var $aXkRG = parcelRequire("aXkRG");


var $dAg4H = parcelRequire("dAg4H");

const $889e5fc4cfbacead$var$aiContentWrapperBaseStyles = (0, $ecnYn.xcss)({
    display: 'inherit',
    flexGrow: 1
});
const $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $889e5fc4cfbacead$export$b5988d25d9f45521 = ({ onClose: onClose, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { contentId: contentId, contentType: contentType, summary: summary, descriptionAdf: descriptionAdf, aiState: aiState, isCreatedWithAi: isCreatedWithAi, highlightedText: highlightedText, selectedAdf: selectedAdf, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, totalRetries: totalRetries, firstAttempt: firstAttempt, aiAnalyticsContext: aiAnalyticsContext, currentSiteSelection: currentSiteSelection, currentProjectSelection: currentProjectSelection, isGicIframeReady: isGicIframeReady, isCreatedFromActionItems: isCreatedFromActionItems, editorAPI: editorAPI } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId,
        isBulkCreate: false
    });
    const aiError = aiState === 'error';
    // no need to override if it's the same site
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const [overrideCloudIdForSitePicker, setOverrideCloudIdForSitePicker] = (0, $42omo.useState)(persistedOverrideCloudId !== cloudId ? persistedOverrideCloudId : undefined);
    const [overrideProjectId, setOverrideProjectId] = (0, $42omo.useState)(undefined);
    const [showCreateWithAiToggle, setShowCreateWithAiToggle] = (0, $42omo.useState)(false);
    const defaultErrorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescription;
    const [errorMessage, setErrorMessage] = (0, $42omo.useState)(defaultErrorMessage);
    const [errorMessageValues, setErrorMessageValues] = (0, $42omo.useState)();
    const [hideTryAgain, setHideTryAgain] = (0, $42omo.useState)(false);
    (0, $jE0Gg.useMessageListener)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'linkCreateScreen',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                },
                source: 'confluenceHighlightIssueCreate'
            }
        }).fire();
    }, [
        isCreatedWithAi,
        createAnalyticsEvent,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        state.hasEditPermission,
        isCreatedFromActionItems
    ]);
    const isAiLoading = aiState === 'loading';
    const triggerFlag = (0, $9K9na.useTriggerFlagIssueCreated)(flags);
    const handleTryAgain = (0, $42omo.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setAiState('idle');
        // trigger a new AI interaction init event retries
        trackAIInteractionInit({
            attributes: {
                pageMode: state.pageMode,
                totalRetries: totalRetries + 1,
                firstAttempt: false,
                aiEnablement: aiIssueCreationEnablement?.enablement
            }
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: !isCreatedWithAi,
                    tryAgainWithAi: isCreatedWithAi,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
    }, [
        actions,
        trackAIInteractionInit,
        totalRetries,
        aiIssueCreationEnablement?.enablement,
        createAnalyticsEvent,
        state.pageMode,
        isCreatedWithAi,
        aiAnalyticsContext,
        state.hasEditPermission
    ]);
    const handleCreateManually = (0, $42omo.useCallback)(()=>{
        actions.setIsCreatedWithAi(false);
        actions.setAiState('idle');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateWithAi = (0, $42omo.useCallback)(()=>{
        actions.setIsCreatedWithAi(true);
        actions.setAiState('loading');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateManuallyAfterError = (0, $42omo.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setIsCreateManuallyPressed(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: true,
                    tryAgainWithAi: false,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
        handleCreateManually();
    }, [
        actions,
        createAnalyticsEvent,
        state.pageMode,
        state.hasEditPermission,
        totalRetries,
        aiAnalyticsContext,
        handleCreateManually
    ]);
    const onIssueCreateInit = (0, $42omo.useCallback)(()=>{
        setShowCreateWithAiToggle(aiIssueCreationEnablement?.isEnabled ?? false);
        /*
		 * When ConfluenceAI=OFF & JiraAI=ON this component will manually create the issue first until
		 * selected site & project info is available to check Jira's AI enablement.  If JiraAI=ON then
		 * we can setIsCreatedWithAi to what the user's personal AI enablement to trigger a rerender.
		 */ if (aiIssueCreationEnablement?.isEnabled) actions.setIsCreatedWithAi((0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)());
        else actions.setIsCreatedWithAi(false);
        if (!(0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)()) return;
        /*
		 * requiresComponentChange is important since we are switching between manaul create (GicAnywhere) and
		 * ConfluenceAiIssueCreate (which uses GicAnywhere under the hood).  The GicAnywhere has limitations where
		 * changes to overrideCloudId after initial load can cause iframe rendering issues.  A component swap happens only when
		 * the isCreatedWithAi state is changed so we can bundle these prop updates together.
		 */ const requiresComponentChange = aiIssueCreationEnablement?.isEnabled !== isCreatedWithAi;
        if (requiresComponentChange) {
            setOverrideCloudIdForSitePicker(currentSiteSelection);
            setOverrideProjectId(currentProjectSelection?.selectedProjectId);
            // During component switch the iframe will be replaced and there is no event for this.
            // We need to reset it here manually.
            actions.setIsGicIframeReady(false);
        }
        if (currentSiteSelection && currentSiteSelection !== overrideCloudIdForSitePicker) setOverrideProjectId(currentProjectSelection?.selectedProjectId);
    }, [
        aiIssueCreationEnablement?.isEnabled,
        isCreatedWithAi,
        currentSiteSelection,
        overrideCloudIdForSitePicker,
        actions,
        currentProjectSelection?.selectedProjectId
    ]);
    const onAiIssueCreateInit = (0, $42omo.useCallback)(()=>{
        onIssueCreateInit();
        const analyticAttributes = {
            attributes: {
                ...aiAnalyticsContext,
                aiEnablement: aiIssueCreationEnablement?.enablement,
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission
            }
        };
        trackAIResultView({
            actionSubjectId: 'aiIssueCreatOnInitComplete',
            ...analyticAttributes
        });
    }, [
        onIssueCreateInit,
        aiAnalyticsContext,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        trackAIResultView,
        state.hasEditPermission
    ]);
    const isSuggestedIssuesErrorMessage = (error)=>{
        return error && typeof error === 'object' && 'message_template' in error;
    };
    const onFailure = (0, $42omo.useCallback)((error)=>{
        // reset
        if (hideTryAgain) {
            setHideTryAgain(false);
            setErrorMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescription);
            setErrorMessageValues({});
        }
        if (isSuggestedIssuesErrorMessage(error)) {
            const aiIssueCreateError = (0, $bZC8A.handleAiIssueCreateError)(error);
            if (aiIssueCreateError !== undefined) {
                setErrorMessage(aiIssueCreateError.errorMessage);
                setErrorMessageValues(aiIssueCreateError.errorMessageValues);
                setHideTryAgain(aiIssueCreateError.hideTryAgain);
            }
        }
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'error',
                actionSubject: 'globalIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    error: error,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultError({
            aiErrorMessage: error.message
        }, {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                ...aiAnalyticsContext
            }
        });
    }, [
        hideTryAgain,
        createAnalyticsEvent,
        isCreatedWithAi,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        trackAIResultError,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const onSuccess = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'created',
                actionSubject: 'issue',
                actionSubjectId: 'confluenceIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultAction('issue created', {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                isCreatedFromActionItems: isCreatedFromActionItems,
                // We don't invoke table creation from highlighting a single row
                isCreatedFromTable: false,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                issueId: payload?.issueId || '',
                aiEnablement: aiIssueCreationEnablement?.enablement,
                ...aiAnalyticsContext
            }
        });
        triggerFlag(payload, 'success-circle', (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitle);
        // Save the cloud id in localStorage if an issue is created
        (0, $2ay9q.saveCloudIdToLocalStorage)(payload);
        if (insertStorageFragmentRequestPayload && state.hasEditPermission) {
            insertStorageFragmentRequestPayload.xmlModification = isCreatedFromActionItems && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? (0, $1Q0l6.constructBreakContainerTag)((0, $1Q0l6.constructSmartlinkTag)(payload.link)) : (0, $1Q0l6.constructSmartlinkTag)(payload.link);
            (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(insertStorageFragmentRequestPayload, state.pageMode);
            const insertPromise = (0, $1Q0l6.insertSingleWorkItemToEndOfSelection)({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload,
                pageMode: state.pageMode ?? (0, $1mDVg.PageMode).VIEW,
                selectedAdf: selectedAdf,
                editorAPI: editorAPI,
                workItemUrl: payload.link
            });
            insertPromise.then((data)=>{
                // There is a case where the API response is OK, but the response data is false.
                // When this happens, the backend has trouble inserting the ticket to the page and we should show an error toast.
                if (data === false) throw new Error('Failed to insert storage fragment');
                return createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'confluenceHighlightIssueCreate',
                        action: 'created',
                        actionSubject: 'link',
                        actionSubjectId: 'confluenceIssueCreate',
                        attributes: {
                            isManuallyCreated: !isCreatedWithAi,
                            isCreatedWithAi: isCreatedWithAi,
                            pageMode: state.pageMode,
                            hasEditPermission: state.hasEditPermission
                        }
                    }
                }).fire();
            }).then(()=>{
                // Refresh the page only if the current mode is VIEW, as other modes receive live updates.
                if (state.pageMode === (0, $1mDVg.PageMode).VIEW) (0, $1Q0l6.refreshPageWithTimeout)();
            }).catch((_error)=>triggerFlag(payload, 'error', (0, $3E5yu.messages).sidePanelIssueCreateInsertionFailed));
        }
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromActionItems,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        triggerFlag,
        insertStorageFragmentRequestPayload,
        selectedAdf,
        editorAPI,
        trackAIResultAction,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const handleStateChange = (0, $42omo.useCallback)((state, source)=>{
        // Keep loading animation active when get Confluence page completes but field suggestions are still loading
        if (source === 'aiIssueCreateGetConfluencePageState' && (state === 'idle' || state === 'loading')) return;
        actions.setAiState(state);
    }, [
        actions
    ]);
    const onAiToggleChange = (0, $42omo.useCallback)((enabled)=>{
        if (enabled) {
            trackAIInteractionInit({
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            });
            handleCreateWithAi();
        } else handleCreateManually();
    }, [
        trackAIInteractionInit,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        handleCreateWithAi,
        handleCreateManually
    ]);
    if (aiError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: "confluenceHighlightIssueCreate",
        errorMessage: errorMessage,
        errorMessageValues: hideTryAgain ? errorMessageValues : undefined,
        onTryAgain: hideTryAgain ? undefined : handleTryAgain,
        onCreateManually: handleCreateManuallyAfterError,
        isCreatedWithAi: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !isAiLoading && isGicIframeReady && showCreateWithAiToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bImpr.IssueCreateWithAiToggle), {
        onChange: onAiToggleChange
    }), isCreatedWithAi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5FJ5W.IssueCreateAiLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $889e5fc4cfbacead$var$aiContentWrapperBaseStyles,
            isAiLoading && $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kcLnq.ConfluenceAiIssueCreate), {
        cloudId: cloudId,
        contentType: contentType,
        pageId: contentId,
        highlightedTextAdf: highlightedText,
        consumer: "confluence-highlight-issue-create-ai",
        onInit: onAiIssueCreateInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onStateChange: handleStateChange,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectId,
        setAiAnalyticsContext: actions.setAiAnalyticsContext,
        aIIssueCreationEnablement: aiIssueCreationEnablement
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfwlu.GicAnywhere), {
        cloudId: cloudId,
        consumer: "confluence-highlight-issue-create",
        onInit: onIssueCreateInit,
        onSuccess: onSuccess,
        onClose: onClose,
        onFailure: onFailure,
        summary: summary,
        descriptionAdf: descriptionAdf,
        overrideCloudId: overrideCloudIdForSitePicker,
        isPayloadReady: true,
        projectId: overrideProjectId
    }));
};
module.exports["IssueCreateSidePanelBody"] = $889e5fc4cfbacead$export$b5988d25d9f45521;

});

parcelRegister("cfwlu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $b4emg = parcelRequire("b4emg");


var $inPa6 = parcelRequire("inPa6");


var $7p4As = parcelRequire("7p4As");


var $1Whri = parcelRequire("1Whri");


var $abC4X = parcelRequire("abC4X");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fwDOR = parcelRequire("fwDOR");


var $9hlns = parcelRequire("9hlns");


var $cOrQJ = parcelRequire("cOrQJ");


var $fVTNs = parcelRequire("fVTNs");

var $3C50A = parcelRequire("3C50A");

var $bHD89 = parcelRequire("bHD89");


var $liF9q = parcelRequire("liF9q");


var $4KAVh = parcelRequire("4KAVh");


var $0XxK1 = parcelRequire("0XxK1");


var $g5o3i = parcelRequire("g5o3i");


var $7u9UW = parcelRequire("7u9UW");


var $4SDuV = parcelRequire("4SDuV");

const $0e7ff5291d49736a$var$phases = {
    loading: 'loading',
    timeout: 'timeout',
    error: 'error',
    idle: 'idle'
};
const $0e7ff5291d49736a$export$9af19a1ca8685214 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0XxK1.AnalyticsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVTNs.ContextWrapper), {
            sourceType: (0, $bHD89.MODAL),
            sourceName: "gicAnywhere",
            children: /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$c43a9e8a05acb520, {
                ...props
            })
        })
    });
};
const $0e7ff5291d49736a$var$styles = {
    hiddenDisplay: "_1e0cglyw",
    gicAnywhere: "_1bsb1osq _4t3i1osq",
    loadingScreen: "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o"
};
const $0e7ff5291d49736a$export$c43a9e8a05acb520 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, configuration: configuration, summary: summary, assignee: assignee, descriptionAdf: descriptionAdf, consumer: consumer, timeoutMs: timeoutMs = (0, $7u9UW.DEFAULT_TIMEOUT), onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, parentIssueId: parentIssueId, projectId: projectId, issueTypeId: issueTypeId, issueTypes: issueTypes, isPayloadReady: isPayloadReady = false, additionalMappedFields: additionalMappedFields, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    const { availableSites: availableSites, domainName: domainName, isOverrideSiteAvailable: isOverrideSiteAvailable } = (0, $g5o3i.useGetDomainAndAvailableSites)({
        cloudId: cloudId,
        overrideCloudId: overrideCloudId,
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const displaySitePicker = availableSites && availableSites.length > 1;
    const [phase, setPhase] = (0, $42omo.useState)($0e7ff5291d49736a$var$phases.loading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        const timeout = (()=>{
            switch(phase){
                case $0e7ff5291d49736a$var$phases.loading:
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed timedOut', {
                            consumer: consumer,
                            timeoutMs: timeoutMs
                        });
                        setPhase($0e7ff5291d49736a$var$phases.timeout);
                        onTimeout?.();
                    }, timeoutMs);
                case $0e7ff5291d49736a$var$phases.timeout:
                    // if timeoutMs passes again after initial timeout, assume GIC is not loading and set to error state
                    return setTimeout(()=>{
                        (0, $3C50A.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed error', {
                            consumer: consumer,
                            timeoutMs: timeoutMs * 2
                        });
                        setPhase($0e7ff5291d49736a$var$phases.error);
                        onFailure(new Error('GIC has timed out'));
                    }, timeoutMs);
            }
        })(); // set Timeout for loading, reset for any other state.
        return ()=>timeout && clearTimeout(timeout);
    }, [
        consumer,
        createAnalyticsEvent,
        onFailure,
        onTimeout,
        phase,
        timeoutMs
    ]); // we mimic "external callback" for our needs
    const onGICReady = (0, $42omo.useCallback)(()=>{
        setPhase($0e7ff5291d49736a$var$phases.idle);
        return {
            summary: summary ?? 'No summary provided',
            descriptionAdf: descriptionAdf || (0, $b4emg.getEmptyADF)(),
            projectId: projectId,
            parentIssueId: parentIssueId,
            issueTypeId: issueTypeId,
            issueTypes: issueTypes?.join(','),
            assignee: assignee,
            fieldData: additionalMappedFields
        };
    }, [
        summary,
        descriptionAdf,
        projectId,
        parentIssueId,
        issueTypeId,
        issueTypes,
        assignee,
        additionalMappedFields
    ]);
    const renderPhaseInformation = (0, $42omo.useMemo)(()=>{
        switch(phase){
            case $0e7ff5291d49736a$var$phases.timeout:
            case $0e7ff5291d49736a$var$phases.loading:
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-loading",
                    xcss: (0, $1Whri.cx)($0e7ff5291d49736a$var$styles.gicAnywhere, $0e7ff5291d49736a$var$styles.loadingScreen),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: formatMessage(phase === $0e7ff5291d49736a$var$phases.timeout ? (0, $4SDuV.messages).iFrameSlowLoading : (0, $4SDuV.messages).iFrameLoading, {
                                br: /*#__PURE__*/ (0, $l998X.jsx)("br", {})
                            })
                        })
                    ]
                });
            case $0e7ff5291d49736a$var$phases.error:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    testId: "gic-anywhere-error",
                    xcss: $0e7ff5291d49736a$var$styles.gicAnywhere,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
                        header: formatMessage((0, $4SDuV.messages).errorHeader),
                        description: formatMessage((0, $4SDuV.messages).errorBody),
                        primaryAction: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                            onClick: ()=>{
                                onClose();
                            },
                            href: domainName || '/',
                            target: "_blank",
                            appearance: "primary",
                            children: formatMessage((0, $4SDuV.messages).openInJiraButton)
                        }),
                        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($liF9q))),
                        imageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageWidth: (0, $7u9UW.MAX_ERROR_IMAGE_WIDTH),
                        maxImageHeight: (0, $7u9UW.MAX_ERROR_IMAGE_HEIGHT)
                    })
                });
            default:
                return undefined;
        }
    }, [
        phase,
        formatMessage,
        domainName,
        onClose
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            renderPhaseInformation,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                name: "gic-anywhere-iframe-loading",
                hold: phase === $0e7ff5291d49736a$var$phases.loading
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: phase !== $0e7ff5291d49736a$var$phases.idle ? $0e7ff5291d49736a$var$styles.hiddenDisplay : $0e7ff5291d49736a$var$styles.gicAnywhere,
                children: domainName !== undefined && /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$ae3b6dcb03669e81, {
                    domainName: domainName,
                    consumer: consumer,
                    onGICReady: onGICReady,
                    onInit: onInit,
                    onSuccess: onSuccess,
                    onFailure: onFailure,
                    onClose: onClose,
                    configuration: configuration,
                    displaySitePicker: displaySitePicker,
                    isPayloadReady: isPayloadReady,
                    overrideCloudId: isOverrideSiteAvailable ? overrideCloudId : undefined
                })
            })
        ]
    });
};
const $0e7ff5291d49736a$export$ae3b6dcb03669e81 = ({ onGICReady: onGICReady, consumer: consumer, domainName: domainName, overrideCloudId: overrideCloudId, onClose: onClose, onFailure: onFailure, onSuccess: onSuccess, onInit: onInit, configuration: configuration, displaySitePicker: displaySitePicker = true, isPayloadReady: isPayloadReady = false })=>{
    (0, $fBMbo.di)($0e7ff5291d49736a$export$b32b5f1ee4493319);
    const iframeRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const [isCreateSuccess, setIsCreateSuccess] = (0, $42omo.useState)(false);
    const [isGicReady, setIsGicReady] = (0, $42omo.useState)(false);
    const isGicReadyRef = (0, $42omo.useRef)(isGicReady); // we will react on this event only once
    // we dont want to reattach handlers on every render
    const onGICReadyRef = (0, $42omo.useRef)(onGICReady);
    onGICReadyRef.current = onGICReady;
    const params = (0, $42omo.useMemo)(()=>({
            product: consumer,
            actionSource: 'issue-create-anywhere-embed'
        }), [
        consumer
    ]); // Create a debounced version of onInit that will only execute the latest call after 2 seconds
    const debouncedOnInit = (0, $42omo.useMemo)(()=>{
        if (!onInit) return undefined;
        if (!(0, $dh538.fg)('jira_ai_fix_aiwc_duplicated_analytics')) return onInit;
        return (0, $0XxK1.debounce)(()=>onInit(), 2000);
    }, [
        onInit
    ]); // Cleanup the debounced function on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const debouncedFn = debouncedOnInit; // Only call cancel if debouncedOnInit is actually a debounced function
            if (debouncedFn && typeof debouncedFn.cancel === 'function') debouncedFn.cancel();
        };
    }, [
        debouncedOnInit
    ]);
    (0, $42omo.useEffect)(()=>{
        const messageHandler = async (message)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (!iframe) return;
            const eventName = message?.data?.event;
            const event = createAnalyticsEvent({});
            switch(eventName){
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_READY:
                    (0, $3C50A.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed initialised', {
                        consumer: consumer
                    });
                    setIsGicReady(true);
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_SUCCESS:
                    setIsCreateSuccess(true);
                    onSuccess(message.data.payload);
                    (0, $3C50A.fireTrackAnalytics)(event, 'globalIssueCreateEmbed succeeded', {
                        consumer: consumer
                    });
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_FAILURE:
                    onFailure(new Error('issueCreate failed to save'));
                    (0, $3C50A.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed failed', {
                        consumer: consumer
                    });
                    break;
                case 0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    onClose(isCreateSuccess); // GIC sends a closeEvent even when created succesfully. Hence
                    // checking if no issue was created
                    if (!isCreateSuccess) (0, $3C50A.fireUIAnalytics)(event, 'globalIssueCreateEmbed closed', {
                        consumer: consumer
                    });
                    break;
                default:
            }
        }; // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('message', messageHandler);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('message', messageHandler);
        };
    }, [
        iframeRef,
        consumer,
        createAnalyticsEvent,
        onInit,
        onClose,
        onFailure,
        onSuccess,
        isCreateSuccess,
        setIsCreateSuccess,
        setIsGicReady
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isPayloadReady && isGicReady) // Only resolve the Promise if isPayloadReady is true, and the message has been received
        Promise.resolve(onGICReadyRef.current()).then((issuePayload)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (iframe) {
                const { fieldData: fieldData, ...defaultValues } = issuePayload ?? {}; // Send GIC data used for initialization
                iframe.postMessage({
                    event: (0, $4KAVh.JIRA_EMBED_ISSUE_CREATE_INIT),
                    payload: {
                        defaultValues: defaultValues,
                        ...fieldData && {
                            fieldData: {
                                ...fieldData,
                                ...defaultValues
                            }
                        }
                    }
                }, // Broadcast this message to all listeners for now
                '*');
                debouncedOnInit?.();
            }
        });
    }, [
        isPayloadReady,
        isGicReady,
        onGICReadyRef,
        debouncedOnInit
    ]);
    const iframeSrc = (0, $0XxK1.getIframeSrc)({
        colorMode: colorMode,
        domainName: domainName,
        params: params,
        displaySitePicker: displaySitePicker,
        ...configuration,
        overrideCloudId: overrideCloudId
    });
    (0, $42omo.useEffect)(()=>{
        isGicReadyRef.current = isGicReady;
    }, [
        isGicReady
    ]);
    (0, $42omo.useEffect)(()=>{
        // We need to reset the isGicReady state to avoid sending another postMessage to the GIC iframe window
        setIsGicReady(false);
    }, [
        iframeSrc
    ]);
    (0, $42omo.useEffect)(()=>{
        const TIMEOUT_10_SECONDS = 10000;
        const timeout = setTimeout(()=>{
            // We need to use a ref to check if GIC is ready because the isGicReady state is updated asynchronously
            if (!isGicReadyRef.current) // This is a fallback for the case when the GIC iframe window is not initialized
            throw new Error('jira-ai/gic-anywhere: The latest GIC iframe window was not initialized');
        }, TIMEOUT_10_SECONDS);
        return ()=>clearTimeout(timeout);
    }, [
        iframeSrc
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($0e7ff5291d49736a$export$b32b5f1ee4493319, {
        name: "gic-anywhere-iframe",
        sandbox: undefined,
        ref: iframeRef,
        height: "100%",
        width: "100%",
        frameBorder: 0,
        // onError={}
        src: iframeSrc,
        "data-testid": "gic-anywhere"
    });
};
const $0e7ff5291d49736a$export$b32b5f1ee4493319 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("iframe", {
        title: "Jira Embed Global Issue Create",
        ref: ref,
        ...props
    });
});
module.exports["GicAnywhere"] = $0e7ff5291d49736a$export$9af19a1ca8685214;

});

parcelRegister("b4emg", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hbEec = parcelRequire("hbEec");

const $8841f32d2d46ed1f$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });
module.exports["getEmptyADF"] = $8841f32d2d46ed1f$export$d109ab46c9575565;

});

parcelRegister("fVTNs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bYRk6 = parcelRequire("bYRk6");

const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children
        })
    });
};
module.exports["ContextWrapper"] = $c32683c3f1554789$export$34282a1f95511a11;

});

parcelRegister("e7URT", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a48dd4fd18e75a65$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a48dd4fd18e75a65$var$isUndefined;

});

parcelRegister("3C50A", function(module, exports) {

var $apAFY = parcelRequire("apAFY");


var $bHD89 = parcelRequire("bHD89");


var $1J0ov = parcelRequire("1J0ov");

const $24a3efb1cf8e29fc$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $bHD89.ANALYTICS_BRIDGE_CHANNEL));
};
const $24a3efb1cf8e29fc$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $24a3efb1cf8e29fc$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $24a3efb1cf8e29fc$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $24a3efb1cf8e29fc$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $24a3efb1cf8e29fc$export$79f423cc3fd39762;

});

parcelRegister("bHD89", function(module, exports) {
const $f220a889fcad0dca$export$f636b5b56f1d624a = 'Screen';
const $f220a889fcad0dca$export$9d2de6eebf7462b5 = 'Drawer';
const $f220a889fcad0dca$export$1171103ea9083ffa = 'Modal';
const $f220a889fcad0dca$export$cae2783c9279926 = 'InlineDialog';
const $f220a889fcad0dca$export$d1123261ca8831d2 = 'Dropdown';
const $f220a889fcad0dca$export$a1562d08625f5d7e = 'UI';
const $f220a889fcad0dca$export$947dac6c72b26f81 = 'TRACK';
const $f220a889fcad0dca$export$f1d537d508d2945a = 'SCREEN';
const $f220a889fcad0dca$export$12346a674644c156 = 'OPERATIONAL';
const $f220a889fcad0dca$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $f220a889fcad0dca$export$f636b5b56f1d624a;
module.exports["MODAL"] = $f220a889fcad0dca$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $f220a889fcad0dca$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $f220a889fcad0dca$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $f220a889fcad0dca$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $f220a889fcad0dca$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $f220a889fcad0dca$export$2ceccf177fae277c;

});

parcelRegister("1J0ov", function(module, exports) {
const $9c601e99598456fc$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $9c601e99598456fc$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $9c601e99598456fc$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $9c601e99598456fc$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $9c601e99598456fc$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $9c601e99598456fc$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $9c601e99598456fc$export$e6baab532ef8c6bf;

});

parcelRegister("liF9q", function(module, exports) {
module.exports = new URL("error.5fbc7fe9.png", import.meta.url).toString();

});

parcelRegister("4KAVh", function(module, exports) {
// Error messages
const $2ad7ca53e97d3c24$export$bdb28edf034fd38 = 'Jira GIC Anywhere - Iframe Source character limit exceeded';
const $2ad7ca53e97d3c24$export$b342b407e829290 = 'jiraEmbedIssueCreateInit';
const $2ad7ca53e97d3c24$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $2ad7ca53e97d3c24$export$8679ecb6b6b13aa9 = 'jiraEmbedIssueCreateSuccess';
const $2ad7ca53e97d3c24$export$c1caf9536ed579cc = 'jiraEmbedIssueCreateAppFailed';
const $2ad7ca53e97d3c24$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';
module.exports["ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED"] = $2ad7ca53e97d3c24$export$bdb28edf034fd38;
module.exports["JIRA_EMBED_ISSUE_CREATE_INIT"] = $2ad7ca53e97d3c24$export$b342b407e829290;
module.exports["JIRA_EMBED_ISSUE_CREATE_READY"] = $2ad7ca53e97d3c24$export$fa02f6b8f65042dd;
module.exports["JIRA_EMBED_ISSUE_CREATE_SUCCESS"] = $2ad7ca53e97d3c24$export$8679ecb6b6b13aa9;
module.exports["JIRA_EMBED_ISSUE_CREATE_FAILURE"] = $2ad7ca53e97d3c24$export$c1caf9536ed579cc;
module.exports["JIRA_EMBED_ISSUE_CREATE_CLOSE"] = $2ad7ca53e97d3c24$export$a402043ad8e6699;

});

parcelRegister("0XxK1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $a9sR2 = parcelRequire("a9sR2");


var $kDuN4 = parcelRequire("kDuN4");


var $dh538 = parcelRequire("dh538");


var $bHD89 = parcelRequire("bHD89");

var $hzZxz = parcelRequire("hzZxz");


var $4KAVh = parcelRequire("4KAVh");

const $5588f1d8fd0b9255$var$analyticsClientInfo = {
    env: 'prod',
    product: 'jira'
};
const $5588f1d8fd0b9255$var$LIGHT_MODE = 'light';
const $5588f1d8fd0b9255$var$DARK_MODE = 'dark';
const $5588f1d8fd0b9255$var$AUTO = 'auto';
const $5588f1d8fd0b9255$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $5588f1d8fd0b9255$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $5588f1d8fd0b9255$export$a31dd10290664cf6 = 2048;
const $5588f1d8fd0b9255$export$584bd4ae64a8d7e2 = ({ colorMode: colorMode = $5588f1d8fd0b9255$var$AUTO, domainName: domainName = '', overrideCloudId: overrideCloudId, params: params, onFailure: onFailure, displaySitePicker: displaySitePicker, disableProjectDropdown: disableProjectDropdown, displayOnlyRequiredFields: displayOnlyRequiredFields })=>{
    const iframeParams = new URLSearchParams(params);
    iframeParams.append('postMessageInit', '1');
    if (displaySitePicker === false) iframeParams.append('displaySitePicker', 'false');
    if (disableProjectDropdown) iframeParams.append('disableProjectDropdown', 'true');
    if (displayOnlyRequiredFields) iframeParams.append('displayOnlyRequiredFields', 'true');
    if (colorMode) iframeParams.append('themeMode', colorMode);
    if (overrideCloudId) iframeParams.append('overrideCloudId', overrideCloudId);
    /**
	 * We want to use the postMessageInit param to instruct the Jira embed iframe
	 * to wait before mounting Issue Create.
	 * It will send a message back to us when it's ready to receive the init message
	 */ const srcUrl = `${domainName}/jira/issues/create/embed?${iframeParams}`;
    if (srcUrl.length > $5588f1d8fd0b9255$export$a31dd10290664cf6) onFailure?.(new Error((0, $4KAVh.ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED)));
    return srcUrl;
};
const $5588f1d8fd0b9255$export$61874183278c256e = [
    'jira-software.ondemand',
    'jira-core.ondemand',
    'jira-servicedesk.ondemand',
    'jira-product-discovery'
];
async function $5588f1d8fd0b9255$export$5e195155111b6846(baseUrlForAvailableSites) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: $5588f1d8fd0b9255$export$61874183278c256e
        })
    };
    const base = baseUrlForAvailableSites ? baseUrlForAvailableSites.replace(/\/$/, '') : '';
    const availableSitesPath = (0, $dh538.fg)('issue_create_modal_site_picker_api_unit_compliant') ? $5588f1d8fd0b9255$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $5588f1d8fd0b9255$var$AVAILABLE_SITES_PATH;
    const response = await fetch(`${base}${availableSitesPath}`, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
const $5588f1d8fd0b9255$export$1b581a2ec13e37f1 = (props)=>{
    const analyticsClient = (0, $42omo.useRef)(new (0, $a9sR2.default)($5588f1d8fd0b9255$var$analyticsClientInfo, {}));
    const sendEvent = (0, $42omo.useCallback)((event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $bHD89.UI_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendUIEvent(payload);
                break;
            case 0, $bHD89.TRACK_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendTrackEvent(payload);
                break;
            case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendOperationalEvent(payload);
                break;
            case 0, $bHD89.SCREEN_EVENT_TYPE:
                analyticsClient.current.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
        channel: (0, $bHD89.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: (event)=>sendEvent((0, $hzZxz.extractAWCDataFromEvent)(event)),
        children: props.children
    });
};
const $5588f1d8fd0b9255$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    if (!(0, $dh538.fg)('jira_ai_fix_aiwc_duplicated_analytics')) return func;
    const debounced = (...args)=>{
        const later = ()=>{
            timeout = undefined;
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    debounced.cancel = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
};
module.exports["getIframeSrc"] = $5588f1d8fd0b9255$export$584bd4ae64a8d7e2;
module.exports["getAvailableJiraSites"] = $5588f1d8fd0b9255$export$5e195155111b6846;
module.exports["AnalyticsProvider"] = $5588f1d8fd0b9255$export$1b581a2ec13e37f1;
module.exports["debounce"] = $5588f1d8fd0b9255$export$61fc7d43ac8f84b0;

});

parcelRegister("hzZxz", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bHD89 = parcelRequire("bHD89");


var $01od0 = parcelRequire("01od0");

const $50a1a1624abaf5e4$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $01od0.getAnalyticsType)(castedEvent);
    const attributes = (0, $01od0.getAttributes)(castedEvent);
    const source = (0, $01od0.getSource)(castedEvent);
    const actionSubject = (0, $01od0.getActionSubject)(castedEvent);
    if (analyticsType === (0, $bHD89.SCREEN_EVENT_TYPE)) return {
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $bHD89.UI_EVENT_TYPE:
        case 0, $bHD89.TRACK_EVENT_TYPE:
        case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $01od0.getAction)(castedEvent);
                const actionSubjectId = (0, $01od0.getActionSubjectId)(castedEvent);
                const containerId = (0, $01od0.getContainerId)(castedEvent);
                const containerType = (0, $01od0.getContainerType)(castedEvent);
                const objectId = (0, $01od0.getObjectId)(castedEvent);
                const objectType = (0, $01od0.getObjectType)(castedEvent);
                const tags = (0, $01od0.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $50a1a1624abaf5e4$export$1c850cf68c053906;

});

parcelRegister("01od0", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $e7URT = parcelRequire("e7URT");


var $apAFY = parcelRequire("apAFY");


var $lgmus = parcelRequire("lgmus");


var $1j3sF = parcelRequire("1j3sF");


var $da6ky = parcelRequire("da6ky");

const $4b9739432bab74fb$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $4b9739432bab74fb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4b9739432bab74fb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4b9739432bab74fb$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $4b9739432bab74fb$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $4b9739432bab74fb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'source').filter(Boolean));
const $4b9739432bab74fb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4b9739432bab74fb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4b9739432bab74fb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4b9739432bab74fb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4b9739432bab74fb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4b9739432bab74fb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4b9739432bab74fb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4b9739432bab74fb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))((0, (/*@__PURE__*/$parcel$interopDefault($5qOzM)))($4b9739432bab74fb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $4b9739432bab74fb$export$a3569ac53b82a914;
module.exports["getAttributes"] = $4b9739432bab74fb$export$fe94072fee8a6976;
module.exports["getSource"] = $4b9739432bab74fb$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $4b9739432bab74fb$export$6f40cdf6d42c018d;
module.exports["getAction"] = $4b9739432bab74fb$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $4b9739432bab74fb$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $4b9739432bab74fb$export$7c8178cc9001d237;
module.exports["getContainerType"] = $4b9739432bab74fb$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $4b9739432bab74fb$export$fa986b91291934c7;
module.exports["getObjectType"] = $4b9739432bab74fb$export$11cc42aebef2ef3a;
module.exports["getTags"] = $4b9739432bab74fb$export$af63d7414243dad3;

});

parcelRegister("g5o3i", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $0XxK1 = parcelRequire("0XxK1");

const $5909ab59f28be203$export$930bddfd3ad23bb7 = ({ preferredCloudId: preferredCloudId, onComplete: onComplete, onError: onError })=>{
    (0, $fBMbo.di)((0, $0XxK1.getAvailableJiraSites));
    const [domain, setDomain] = (0, $42omo.useState)(undefined);
    const [availableSites, setAvailableSites] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        const fetchAvailableJiraSites = async ()=>{
            setLoading(true);
            try {
                const { sites: sites } = await (0, $0XxK1.getAvailableJiraSites)();
                setAvailableSites(sites ?? []);
                const computedDomain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
                setDomain(computedDomain);
                onComplete?.({
                    domain: computedDomain,
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
    }, [
        preferredCloudId,
        onComplete,
        onError
    ]);
    return {
        domain: domain,
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $5909ab59f28be203$export$7872bb66f9195035 = ({ onComplete: onComplete, onError: onError, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    (0, $fBMbo.di)((0, $0XxK1.getAvailableJiraSites));
    const [availableSites, setAvailableSites] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const hasMount = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasMount.current) return;
        setLoading(true);
        const fetchAvailableJiraSites = async ()=>{
            try {
                const { sites: sites } = await (0, $0XxK1.getAvailableJiraSites)(baseUrlForAvailableSites);
                setAvailableSites(sites ?? []);
                onComplete?.({
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
        hasMount.current = true;
    }, [
        baseUrlForAvailableSites,
        onComplete,
        onError
    ]);
    return {
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $5909ab59f28be203$export$60b2cad7400d36b3 = ({ sites: sites, preferredCloudId: preferredCloudId })=>{
    const domain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
    return {
        domain: domain
    };
};
const $5909ab59f28be203$export$48ca77029c1208c2 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    const { availableSites: availableSites, loading: loading, error: error } = $5909ab59f28be203$export$7872bb66f9195035({
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const { domain: domainName } = $5909ab59f28be203$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: cloudId
    });
    const { domain: isOverrideSiteAvailable } = $5909ab59f28be203$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: overrideCloudId
    });
    if (error) throw new Error('Failed to fetch available sites');
    return loading ? {
        availableSites: [],
        domainName: undefined,
        isOverrideSiteAvailable: undefined
    } : {
        availableSites: availableSites,
        domainName: domainName,
        isOverrideSiteAvailable: isOverrideSiteAvailable
    };
};
module.exports["useGetFirstAvailableSiteDomain"] = $5909ab59f28be203$export$930bddfd3ad23bb7;
module.exports["useGetDomainAndAvailableSites"] = $5909ab59f28be203$export$48ca77029c1208c2;

});

parcelRegister("7u9UW", function(module, exports) {
const $f25a4ef78ed97248$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $f25a4ef78ed97248$export$6dfc55fc5e2544ae = 188;
const $f25a4ef78ed97248$export$85d8afb0902718e2 = 250;
module.exports["DEFAULT_TIMEOUT"] = $f25a4ef78ed97248$export$7bd623b29ec8e1eb;
module.exports["MAX_ERROR_IMAGE_WIDTH"] = $f25a4ef78ed97248$export$6dfc55fc5e2544ae;
module.exports["MAX_ERROR_IMAGE_HEIGHT"] = $f25a4ef78ed97248$export$85d8afb0902718e2;

});

parcelRegister("4SDuV", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $2b8c8c7153d4d991$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    iFrameLoading: {
        id: "jira-ai.gic-anywhere.iframe-loading",
        defaultMessage: "Loading work item details, this might take a few seconds."
    },
    iFrameSlowLoading: {
        id: "jira-ai.gic-anywhere.iframe-slow-loading",
        defaultMessage: "It is taking longer than usual to load your work item.{br}Give it a few more seconds, or try again later."
    },
    openInJiraButton: {
        id: "jira-ai.gic-anywhere.open-in-jira-button",
        defaultMessage: "Log in to Jira to view"
    },
    errorHeader: {
        id: "jira-ai.gic-anywhere.error-header",
        defaultMessage: "Something's gone wrong"
    },
    errorBody: {
        id: "jira-ai.gic-anywhere.error-body",
        defaultMessage: "Try opening this in Jira. If the problem persists, please contact Atlassian support."
    }
});
module.exports["messages"] = $2b8c8c7153d4d991$export$defe85febe8b728c;

});

parcelRegister("9K9na", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $auNCB = parcelRequire("auNCB");

const $c2473cc34e5c9c56$export$8ecee5edd581c23a = (flags)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return (0, $42omo.useCallback)((payload, flagType, message)=>{
        flags.showFlag({
            type: flagType,
            title: formatMessage(message, {
                issueKey: payload?.issueKey,
                issueSummary: payload?.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                        href: payload?.link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage
    ]);
};
module.exports["useTriggerFlagIssueCreated"] = $c2473cc34e5c9c56$export$8ecee5edd581c23a;

});

parcelRegister("kcLnq", function(module, exports) {
/* ConfluenceAiIssueCreate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $caRYB = parcelRequire("caRYB");

var $2FFuS = parcelRequire("2FFuS");


var $gdv5Z = parcelRequire("gdv5Z");


var $fwDOR = parcelRequire("fwDOR");


var $7pE6f = parcelRequire("7pE6f");

var $4sbrV = parcelRequire("4sbrV");


var $2Rith = parcelRequire("2Rith");


var $cfwlu = parcelRequire("cfwlu");


var $cLj22 = parcelRequire("cLj22");


var $1ASvP = parcelRequire("1ASvP");


var $kfViO = parcelRequire("kfViO");


var $9BGuq = parcelRequire("9BGuq");


var $arvSz = parcelRequire("arvSz");


var $gqQUx = parcelRequire("gqQUx");

const $0aab3fed706492b4$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $0aab3fed706492b4$var$style = {
    aiIssueCreateWrapper: "_16jlkb7n"
};
const $0aab3fed706492b4$export$fbdfb25d3cad524a = ({ confluencePage: confluencePage, highlightedText: highlightedText, isReady: isReady, overrideXProduct: overrideXProduct, handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange })=>{
    const streamingHookProps = (0, $arvSz.useStreamingHookProps)({
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        overrideXProduct: overrideXProduct
    });
    const { suggestions: suggestions, isStreaming: isStreaming, error: error, onAIResultView: onAIResultView } = (0, $cLj22.useAiWorkSuggestionStreaming)(streamingHookProps);
    // Transform streaming suggestions to match the expected fields format
    const transformedFields = (0, $42omo.useMemo)(()=>{
        // Only use suggestions when streaming is complete
        if (isStreaming) return {
            summary: '',
            description: ''
        };
        return {
            summary: suggestions?.[0]?.field_values?.Summary || '',
            description: suggestions?.[0]?.field_values?.Description || ''
        };
    }, [
        suggestions,
        isStreaming
    ]);
    const getServiceState = ()=>{
        if (error) return 'error';
        if (isStreaming) return 'loading';
        return 'idle';
    };
    (0, $42omo.useEffect)(()=>{
        if (error) handleAiSuggestedFieldsStateChange({
            state: 'error',
            error: $0aab3fed706492b4$export$98d40c5fd23ef716(error)
        });
        else if (isStreaming) handleAiSuggestedFieldsStateChange({
            state: 'loading',
            fields: transformedFields
        });
        else handleAiSuggestedFieldsStateChange({
            state: 'idle',
            fields: transformedFields
        });
    }, [
        error,
        isStreaming,
        transformedFields,
        handleAiSuggestedFieldsStateChange
    ]);
    if (!isReady) return {
        state: 'loading',
        fields: null
    };
    return {
        state: getServiceState(),
        fields: transformedFields,
        onAIResultView: onAIResultView,
        suggestions: suggestions,
        isStreaming: isStreaming
    };
};
const $0aab3fed706492b4$export$98d40c5fd23ef716 = (error)=>{
    return {
        message_template: error?.message?.message_template,
        statusCode: error?.message?.status_code,
        message: error?.message?.content,
        content: error?.message?.content
    };
};
const $0aab3fed706492b4$export$a653b3ac3dd182f4 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, contentType: contentType, pageId: pageId, pageMode: pageMode, highlightedTextAdf: highlightedTextAdf, timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const [confluencePage, setConfluencePage] = (0, $42omo.useState)('');
    const [idMap, setIdMap] = (0, $42omo.useState)({});
    const [isIdMapReady, setIsIdMapReady] = (0, $42omo.useState)(false);
    // Custom handler to wrap multiple onStateChange calls
    const handleStateChange = (0, $42omo.useCallback)((source, state)=>{
        // trigger error if any state is errored
        if (onFailure && state?.state === 'error') {
            onFailure(state.error, state.message_template);
            fireTrack(`${source} failed`);
        }
        if (onStateChange) {
            onStateChange(state.state, source);
            fireTrack(`${source} updated`, {
                state: state.state
            });
        }
    }, [
        onFailure,
        onStateChange,
        fireTrack
    ]);
    const handleConfluencePageStateChange = (0, $42omo.useCallback)((newState)=>handleStateChange('aiIssueCreateGetConfluencePageState', newState), [
        handleStateChange
    ]);
    // Fetch confluence page
    const { state: confluencePageState, confluencePage: confluencePageAsAdf } = (0, $gqQUx.useGetConfluencePage)({
        cloudId: cloudId,
        contentType: contentType,
        experienceId: 'ai-issue-create-confluence-single',
        pageId: pageId,
        pageMode: pageMode,
        onStateChange: handleConfluencePageStateChange
    });
    // Effect to transform confluence page ADF to markdown after fetching
    (0, $42omo.useEffect)(()=>{
        if (confluencePageState === 'idle' && confluencePageAsAdf) {
            const { markdown: markdown, idMap: newIdMap } = (0, $7pE6f.adfToMarkdownPlus)(confluencePageAsAdf, {
                markdownPlusUseNextLayoutSection: true
            });
            setAiAnalyticsContext && setAiAnalyticsContext('pageContextLength', (0, $kfViO.countADFChars)(confluencePageAsAdf));
            setConfluencePage(markdown);
            setIdMap(newIdMap);
            setIsIdMapReady(true); // Set idMap ready when it's set
        }
    }, [
        confluencePageState,
        confluencePageAsAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $0aab3fed706492b4$var$style.aiIssueCreateWrapper,
        testId: testId ?? 'default-confluence-ai-issue-create'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.adf-to-markdown-plus",
        hold: confluencePageState !== 'loading' && !isIdMapReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.confluence-page-loading",
        hold: confluencePageState === 'loading'
    }), isIdMapReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aab3fed706492b4$export$9da61cee87ff5851, {
        handleStateChange: handleStateChange,
        confluencePageState: confluencePageState,
        confluencePage: confluencePage,
        idMap: idMap,
        useService: $0aab3fed706492b4$export$fbdfb25d3cad524a,
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        pageMode: pageMode,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        onStateChange: onStateChange,
        consumer: consumer,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker
    }) : null));
};
const $0aab3fed706492b4$export$9da61cee87ff5851 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, highlightedTextAdf: highlightedTextAdf = (0, $caRYB.doc)((0, $2FFuS.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, idMap: idMap, confluencePage: confluencePage, confluencePageState: confluencePageState, handleStateChange: handleStateChange, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, useService: useService, aIIssueCreationEnablement: aIIssueCreationEnablement, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker })=>{
    const handleAiSuggestedFieldsStateChange = (0, $42omo.useCallback)((newState)=>handleStateChange('aiIssueCreateFetchSuggestedFieldsState', newState), [
        handleStateChange
    ]);
    const highlightedText = (0, $42omo.useMemo)(()=>{
        return (0, $7pE6f.adfToMarkdownPlus)(highlightedTextAdf, {
            markdownPlusUseNextLayoutSection: true
        }, idMap).markdown;
    }, [
        highlightedTextAdf,
        idMap
    ]);
    // Only call SuggestionComponent when highlightedText is ready
    const { state: suggestedFieldsState, fields: fields, onAIResultView: onAIResultView, isStreaming: isStreaming, suggestions: suggestions } = useService({
        cloudId: cloudId,
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange,
        isReady: highlightedText !== '',
        overrideXProduct: aIIssueCreationEnablement?.enablement
    });
    const isLoading = confluencePageState === 'loading' || suggestedFieldsState === 'loading';
    const isErrored = confluencePageState === 'error' || suggestedFieldsState === 'error';
    const isPayloadReady = confluencePageState === 'idle' && suggestedFieldsState === 'idle';
    const descriptionADF = (0, $42omo.useMemo)(()=>{
        if (isLoading || isErrored || !fields?.description) return (0, $caRYB.doc)((0, $2FFuS.paragraph)(''));
        return (0, $4sbrV.markdownPlusToAdf)({
            markdown: fields.description,
            idMap: idMap
        });
    }, [
        isLoading,
        isErrored,
        fields,
        idMap
    ]);
    (0, $42omo.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('aiResponseLength', (0, $kfViO.countADFChars)(descriptionADF));
    }, [
        descriptionADF,
        setAiAnalyticsContext
    ]);
    (0, $42omo.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('highlightedTextLength', (0, $kfViO.countADFChars)(highlightedTextAdf));
    }, [
        highlightedTextAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "ai-issue-create.suggested-fields-loading",
        hold: suggestedFieldsState === 'loading'
    }), !isErrored && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfwlu.GicAnywhere), {
        cloudId: cloudId,
        summary: fields?.summary || '',
        descriptionAdf: descriptionADF,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        consumer: consumer,
        isPayloadReady: isPayloadReady,
        overrideCloudId: overrideCloudIdForSitePicker,
        projectId: overrideProjectIdForProjectPicker
    }), !isStreaming && Boolean(suggestions?.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ASvP.MountEvent), {
        onMount: onAIResultView
    }));
};
const $0aab3fed706492b4$export$56bb8aafd9fb646e = ({ cloudId: cloudId, contentType: contentType, pageId: pageId, pageMode: pageMode, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, highlightedTextAdf: highlightedTextAdf = (0, $caRYB.doc)((0, $2FFuS.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer = 'confluenceHighlight', setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aab3fed706492b4$export$a653b3ac3dd182f4, {
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        pageMode: pageMode,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        testId: testId,
        onStateChange: onStateChange,
        consumer: consumer,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement
    }));
};
module.exports["ConfluenceAiIssueCreate"] = $0aab3fed706492b4$export$56bb8aafd9fb646e;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("4sbrV", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");


var $hAuc5 = parcelRequire("hAuc5");

const $c4325a25ee151966$var$serializer = new (0, $h9yJL.JSONTransformer)();
function $c4325a25ee151966$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $hAuc5.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $iyDxB.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $c4325a25ee151966$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $c4325a25ee151966$export$dfca419434f7e5a8;

});

parcelRegister("hAuc5", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $1D8rU = parcelRequire("1D8rU");


var $aLtij = parcelRequire("aLtij");


var $1MDnJ = parcelRequire("1MDnJ");


var $dpgtc = parcelRequire("dpgtc");


var $2mgEK = parcelRequire("2mgEK");


var $fMMkB = parcelRequire("fMMkB");


var $6dzgm = parcelRequire("6dzgm");


var $locel = parcelRequire("locel");


var $ip5oL = parcelRequire("ip5oL");


var $ifgRb = parcelRequire("ifgRb");


var $2XcI5 = parcelRequire("2XcI5");


var $9tykg = parcelRequire("9tykg");


var $d5C9r = parcelRequire("d5C9r");


var $2OwON = parcelRequire("2OwON");

function $ce78ef6bb9d33c7d$var$getFragmentBackingArray(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $ce78ef6bb9d33c7d$var$mapFragment(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($ce78ef6bb9d33c7d$var$mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $5SAOw.Fragment)) children.push(...$ce78ef6bb9d33c7d$var$getFragmentBackingArray(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $5SAOw.Fragment).fromArray(children);
}
function $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus } = featureToggles;
    const tokenizer = new (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $1D8rU.PM_SCHEMA_TO_MD_MAPPING)[key])if (schema[key][idx]) tokenizer.enable((0, $1D8rU.PM_SCHEMA_TO_MD_MAPPING)[key][idx]);
    });
    const analyticsAttributes = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {}
    };
    // Remove once markdownPlusAttributeTest is removed
    const markdownPlusAttributeStatus = [];
    if (markdownPlus) {
        tokenizer.use((0, $dpgtc.default), idMap, featureToggles, analyticsAttributes);
        tokenizer.use((0, $fMMkB.default), idMap);
        tokenizer.use((0, $2mgEK.default), idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus);
    }
    tokenizer.use((0, $1MDnJ.default), idMap);
    tokenizer.use((0, $9tykg.default));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $locel.default));
    tokenizer.use((0, $ifgRb.default));
    tokenizer.use((0, $6dzgm.default));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $csam1.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        if (featureToggles.markdownPlusUseNextMediaPlugin) tokenizer.use((0, $2XcI5.default));
        else tokenizer.use((0, $ip5oL.markdownItMedia));
        if (markdownPlus && featureToggles.markdownPlusAddComplexNodes) tokenizer.use((0, $aLtij.default));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $d5C9r.default));
    const markdownParser = new (0, $42JDa.MarkdownParser)(schema, tokenizer, (0, $1D8rU.filterMdToPmSchemaMapping)(schema, (0, $1D8rU.getMdToPmMapping)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        unclosedTokens: {},
        markdownPlusAttributeStatus: [],
        pmFragment: (0, $5SAOw.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    const prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $2OwON.escapeLinks)(markdown));
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    const mappedContent = $ce78ef6bb9d33c7d$var$mapFragment(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') {
            const replacedAttrs = Object.fromEntries(Object.entries(node.attrs).map(([key, value])=>{
                // If value is the literal string 'null', convert it to JS null
                return [
                    key,
                    value === 'null' ? null : value
                ];
            }));
            return schema.nodes.media.createChecked({
                ...replacedAttrs,
                // Adding this attribute results in the media node being rendered
                // initially using the external url, but then triggering an upload
                // of the external url as an atlassian artifact, and this media
                // will then be replaced to use the atlassian artifact.
                //
                // This is done in the media nodeview by checking the attributes
                // when rendering.
                __external: replacedAttrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
        }
        return node;
    });
    return {
        ...analyticsAttributes,
        markdownPlusAttributeStatus: markdownPlusAttributeStatus,
        pmFragment: mappedContent
    };
}
function $ce78ef6bb9d33c7d$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}
module.exports["convertMarkdownToProsemirror"] = $ce78ef6bb9d33c7d$export$b2bf04f78f72b123;
module.exports["backendConvertMarkdownToProsemirrorNode"] = $ce78ef6bb9d33c7d$export$e661a057c2263d64;

});

parcelRegister("1D8rU", function(module, exports) {
function $fe15ff31308e86c4$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $fe15ff31308e86c4$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $fe15ff31308e86c4$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-expect-error
                if (tok.pmAttrs) // @ts-expect-error
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                // When token.pmAttrs is missing it means it's an external image.
                // @ts-expect-error
                if (token.pmAttrs) // @ts-expect-error
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-expect-error
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        placeholder: {
            node: 'placeholder',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-expect-error
                return token.pmAttrs;
            }
        }
    });
module.exports["filterMdToPmSchemaMapping"] = $fe15ff31308e86c4$export$a9d25ff08f358d72;
module.exports["PM_SCHEMA_TO_MD_MAPPING"] = $fe15ff31308e86c4$export$b535e2638dcce02;
module.exports["getMdToPmMapping"] = $fe15ff31308e86c4$export$8f853a1c35ed8bbe;

});

parcelRegister("aLtij", function(module, exports) {
$parcel$export(module.exports, "default", () => $0773845a48a88423$export$2e2bcd8739ae039);
const $0773845a48a88423$var$captionOpen = 'caption_open';
const $0773845a48a88423$var$paragraphOpen = 'paragraph_open';
const $0773845a48a88423$var$paragraphClose = 'paragraph_close';
function $0773845a48a88423$export$eee367902819022(index, tokens) {
    // make sure we have an opening and closing paragraph token
    if (tokens[index]?.type !== $0773845a48a88423$var$paragraphOpen && tokens[index + 2]?.type !== $0773845a48a88423$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    tokens[index + 2]?.type === $0773845a48a88423$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $0773845a48a88423$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            const isWithinCaption = acc[acc.length - 1]?.type === $0773845a48a88423$var$captionOpen;
            if (type === $0773845a48a88423$var$paragraphOpen && isWithinCaption) /**
				 * paragraph_open and paragraph_close tokens get automatically added by markdown-it
				 * around text content. caption nodes do not allow paragraph nodes as children
				 * so we need to prevent these tokens from being added to the acc
				 */ $0773845a48a88423$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("1MDnJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e92fa7dc1daa52ee$export$2e2bcd8739ae039);
function $e92fa7dc1daa52ee$export$2e2bcd8739ae039(md) {
    md.inline.ruler.before('text', 'citation', function(state, silent) {
        const str = state.src.slice(state.pos);
        /**
		 * Matches the following:
		 * [^00^]
		 */ // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const citationRegexp = /^\[\^[^\^]+\^]/;
        const match = citationRegexp.exec(str);
        if (!match) return false;
        if (silent) return true;
        // Just skip citation from parsing and don't render them in the output.
        state.pos += match[0].length;
        return true;
    });
}

});

parcelRegister("dpgtc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cab79ce214481e1$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");


var $hqwd7 = parcelRequire("hqwd7");

// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $4cab79ce214481e1$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $4cab79ce214481e1$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const match = token.content.match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123" />
				 * <custom data-type="smartlink" />
				 * <custom data-type="panel_open" data-id="123" />
				 * <custom data-type="panel_close" />
				 */ // Ignored via go/ees005
            // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
            // eslint-disable-next-line require-unicode-regexp
            RegExp('<custom\\s+data-type="(?<dataType>.*?)"\\s*(data-id="(?<dataId>.*?)"\\s*)?\\/>'));
            const dataType = match?.groups?.dataType;
            if (match && dataType && !$4cab79ce214481e1$var$emptyInlineCustomNodes.includes(dataType)) {
                const dataId = match.groups?.dataId;
                if (dataType) {
                    analyticsAttributes.htmlConvertedToNodes++;
                    const customElementToken = (0, $7MY8y.createToken)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    customElementToken.attrPush([
                        'isCustomBlock',
                        'true'
                    ]);
                    /**
					 * When the custom tag goes through the tokenizer it is transformed into this structure:
					 * paragraph_open
					 * inline
					 * paragraph_close
					 *
					 * so the following section removes the wrapping paragraph tokens
					 */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    analyticsAttributes.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
        const toRemove = (0, $hqwd7.sanitizeCustomBlocks)(state.tokens);
        toRemove.forEach((index)=>{
            const tokenToBeRemoved = state.tokens[index];
            analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] = (analyticsAttributes.unclosedTokens[tokenToBeRemoved.type] || 0) + 1;
        });
        // Remove all indices that have been set in `toRemove`
        if (featureToggles.markdownPlusRemoveUnclosedTokens) state.tokens = state.tokens.filter((_, index)=>!toRemove.has(index));
    });
}

});

parcelRegister("7MY8y", function(module, exports) {
function $6d1436b1813e587d$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}
module.exports["createToken"] = $6d1436b1813e587d$export$c255480b061bd6aa;

});

parcelRegister("hqwd7", function(module, exports) {
function $bb6e978431b17277$export$e717b161ec14d433(tokens) {
    const openTokenIndexMap = new Map();
    const toRemove = new Set();
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // This attribute is set earlier in this file (customElementToken.attrPush(['isCustomBlock', 'true']))
        // So we can identify tokens added by this rule
        if (token.attrGet('isCustomBlock') === 'true') {
            // We split by the last underscore
            const type = token.type.substring(0, token.type.lastIndexOf('_'));
            const prevIndex = openTokenIndexMap.get(type);
            // Only check for removal if type exists
            if (type && token.nesting === 1) {
                if (prevIndex !== undefined) toRemove.add(prevIndex);
                openTokenIndexMap.set(type, i);
            } else if (type && token.nesting === -1) {
                if (prevIndex !== undefined) // If previous open token found, then we've found a match and we can close it
                openTokenIndexMap.delete(type);
                else toRemove.add(i);
            }
        }
    }
    // Anything left in the stack is an unmatched open token
    openTokenIndexMap.forEach((remainingIndex)=>toRemove.add(remainingIndex));
    return toRemove;
}
module.exports["sanitizeCustomBlocks"] = $bb6e978431b17277$export$e717b161ec14d433;

});

parcelRegister("2mgEK", function(module, exports) {
$parcel$export(module.exports, "default", () => $102908d0f0788df0$export$2e2bcd8739ae039);

var $a4TK8 = parcelRequire("a4TK8");

function $102908d0f0788df0$export$2e2bcd8739ae039(md, idMap, featureToggles, analyticsAttributes, markdownPlusAttributeStatus) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        const start = state.pos;
        const origSrc = state.src;
        let match;
        if (featureToggles.markdownPlusAttributeTest) match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 * <custom data-type="status" data-id="id-0" data-attrs='{"text":"test","color":"neutral"}'>test</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(?:\\s+data-type="(?<dataType>[^"]*)")?(?:\\s+data-id="(?<dataId>[^"]*)")?(?:\\s+data-attrs="(?<dataAttrs>\\{.*?\\})")?\\s*>(?<dataContent>.*?)<\\/custom>'));
        else match = state.src.slice(start).match(/**
				 * Matches the following:
				 * <custom data-type="smartlink" data-id="123">content</custom>
				 * <custom data-id="123">content</custom>
				 * <custom data-type="emoji">content</custom>
				 * <custom>content</custom>
				 */ // Ignored via go/ees005
        // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
        // eslint-disable-next-line require-unicode-regexp
        RegExp('<custom(\\sdata-(type|id)="(?<dataType>.*?)")?(\\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\\/custom>'));
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = match.groups?.dataType;
        const dataId = match.groups?.dataId;
        const dataAttrs = match.groups?.dataAttrs;
        const dataContent = match.groups?.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                case 'placeholder':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusAddComplexNodes ? 'mediaInline' : false;
                default:
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (featureToggles.markdownPlusAttributeTest && featureToggles.markdownPlusMentions && !dataId && dataAttrs && customDataType) {
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = dataAttrs;
            }
            if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                analyticsAttributes.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
                if (featureToggles.markdownPlusAttributeTest && dataAttrs) try {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(idMap[dataId].attributes, JSON.parse(dataAttrs))) markdownPlusAttributeStatus.push([
                        customDataType,
                        true
                    ]);
                    else // We need to check this because when you type it calls this function multiple times and the first time its called the current text is not the same
                    if (idMap[dataId].attributes.text === JSON.parse(dataAttrs).text) markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                } catch (e) {
                    markdownPlusAttributeStatus.push([
                        customDataType,
                        false
                    ]);
                }
            } else {
                analyticsAttributes.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}

});

parcelRegister("fMMkB", function(module, exports) {
$parcel$export(module.exports, "default", () => $b85e013b8e2ab0fc$export$2e2bcd8739ae039);
const $b85e013b8e2ab0fc$var$decisionItemOpen = 'decisionItem_open';
const $b85e013b8e2ab0fc$var$paragraphOpen = 'paragraph_open';
const $b85e013b8e2ab0fc$var$paragraphClose = 'paragraph_close';
const $b85e013b8e2ab0fc$var$inline = 'inline';
function $b85e013b8e2ab0fc$var$handleParagraphs(acc, token) {
    /**
	 * Traverse up the acc token array, and if a chain of one or more inline tokens are under
	 * a decisionItem_open token, then it is considered to be a paragraph_close token within
	 * a decision item.
	 *
	 * This also works for a paragraph_open token as inlineCount would be zero meaning that
	 * the conditional applies to when decisionItem_open is right above paragraph_open.
	 */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        const type = acc[i]?.type;
        if (!inlineChainEnded) {
            if (type === $b85e013b8e2ab0fc$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $b85e013b8e2ab0fc$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $b85e013b8e2ab0fc$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $b85e013b8e2ab0fc$var$paragraphOpen || type === $b85e013b8e2ab0fc$var$paragraphClose) $b85e013b8e2ab0fc$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("6dzgm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6de2bb5deb5f668$export$2e2bcd8739ae039);
const $e6de2bb5deb5f668$var$replaceBrWithLineBreak = (text)=>{
    // Matches <br> or <br /> or <br/> with optional trailing space
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/<br\s*\/?>\s?/gi, '\n');
};
const $e6de2bb5deb5f668$var$processInlineChildren = (children)=>{
    for (const child of children)if (child.type === 'text') {
        const newText = $e6de2bb5deb5f668$var$replaceBrWithLineBreak(child.content);
        if (child.content !== newText) child.content = newText;
    }
};
const $e6de2bb5deb5f668$var$brToLineBreak = (state)=>{
    for (const token of state.tokens)if (token.type === 'inline' && token.children) $e6de2bb5deb5f668$var$processInlineChildren(token.children);
};
var $e6de2bb5deb5f668$export$2e2bcd8739ae039 = (md)=>md.core.ruler.after('inline', 'lineBreak', $e6de2bb5deb5f668$var$brToLineBreak);

});

parcelRegister("locel", function(module, exports) {
$parcel$export(module.exports, "default", () => $866d7fb158c265f1$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");


var $2OwON = parcelRequire("2OwON");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $866d7fb158c265f1$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $866d7fb158c265f1$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $866d7fb158c265f1$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($866d7fb158c265f1$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($866d7fb158c265f1$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $81OAa.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $2OwON.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $2OwON.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $866d7fb158c265f1$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$866d7fb158c265f1$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $866d7fb158c265f1$var$linkify);

});

parcelRegister("2OwON", function(module, exports) {
// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
// Ignored via go/ees005
const $7715b3c791c155be$export$893fccbed37586dd = // eslint-disable-next-line require-unicode-regexp
/([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $7715b3c791c155be$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($7715b3c791c155be$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $7715b3c791c155be$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $7715b3c791c155be$export$8acd10161c5f8b07(text) {
    return text.replace(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s]+$/) ? `<${str}>` : str;
    });
}
module.exports["findFilepaths"] = $7715b3c791c155be$export$d37783fe63e2f0fe;
module.exports["isLinkInMatches"] = $7715b3c791c155be$export$5e652e74655163e5;
module.exports["escapeLinks"] = $7715b3c791c155be$export$8acd10161c5f8b07;

});

parcelRegister("ip5oL", function(module, exports) {
// File copied from packages/editor/editor-markdown-transformer/src/media.ts

var $bd943 = parcelRequire("bd943");

function $623b0b26b9c81375$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    // Allow paragraph_close as a valid parent token for cases where a user has an image at the end of a paragraph
    // due to shift+enter
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'paragraph_close'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
                const urlObject = new URL(getUrl(url));
                const params = urlObject.searchParams;
                if (params.toString()) {
                    const pmAttrs = {};
                    for (const [key, value] of params)pmAttrs[key] = value;
                    // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
                    media.pmAttrs = pmAttrs;
                }
            } catch  {}
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens// eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                .map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $623b0b26b9c81375$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $623b0b26b9c81375$var$createRule());
};
module.exports["markdownItMedia"] = $623b0b26b9c81375$export$c8dcbd316b71f8cf;

});

parcelRegister("bd943", function(module, exports) {
const $3b4ff3e4ad90548c$export$53fd140c96bc558 = 'https://media.staging.atl-paas.net';
module.exports["MEDIA_BASE_URL_STAGING"] = $3b4ff3e4ad90548c$export$53fd140c96bc558;

});

parcelRegister("ifgRb", function(module, exports) {
$parcel$export(module.exports, "default", () => $73825321bd2619ae$export$2e2bcd8739ae039);
// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73825321bd2619ae$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$73825321bd2619ae$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $73825321bd2619ae$var$newline);

});

parcelRegister("2XcI5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f17de48a6931d92$export$2e2bcd8739ae039);

var $bd943 = parcelRequire("bd943");


var $7MY8y = parcelRequire("7MY8y");

// eslint-disable-next-line require-unicode-regexp
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $3f17de48a6931d92$var$mediaRegex = /(!\[[^\]]*\]\([^)]+\))|(\[!\[[^\]]*\]\([^)]+\)\]\([^)]+\))/gu;
const $3f17de48a6931d92$var$getUrl = (state, str)=>{
    const res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
    if (res.ok) {
        const href = state.md.normalizeLink(res.str);
        if (state.md.validateLink(href)) return href;
    }
    return '';
};
const $3f17de48a6931d92$var$checkPreviousToken = (type, acc)=>{
    return acc.length > 0 && acc[acc.length - 1].type === type;
};
const $3f17de48a6931d92$var$createMediaTokens = (url, state, acc)=>{
    const mediaSingleOpen = (0, $7MY8y.createToken)(state, 'media_single_open');
    const media = (0, $7MY8y.createToken)(state, 'media');
    media.attrs = [
        [
            'url',
            $3f17de48a6931d92$var$getUrl(state, url)
        ],
        [
            'type',
            'external'
        ]
    ];
    // This is a hack to get internal media to work
    // to recreate the image correctly we need to apply the pmAttrs from the image
    // We store the pmAttrs in the "fake" image url and apply them to the token
    if (url.includes((0, $bd943.MEDIA_BASE_URL_STAGING))) try {
        const urlObject = new URL($3f17de48a6931d92$var$getUrl(state, url));
        const params = urlObject.searchParams;
        if (params.toString()) {
            const pmAttrs = {};
            for (const [key, value] of params)pmAttrs[key] = value;
            // @ts-expect-error - pmAttrs is not a standard markdown-it attribute
            media.pmAttrs = pmAttrs;
        }
    } catch  {}
    const mediaSingleClose = (0, $7MY8y.createToken)(state, 'media_single_close');
    acc.push(mediaSingleOpen, media, mediaSingleClose);
};
const $3f17de48a6931d92$var$createInlineTokens = (content, state, acc)=>{
    const paragraphOpen = (0, $7MY8y.createToken)(state, 'paragraph_open');
    const inline = (0, $7MY8y.createToken)(state, 'inline');
    inline.content = content;
    inline.children = [
        (0, $7MY8y.createToken)(state, 'text')
    ];
    const paragraphClose = (0, $7MY8y.createToken)(state, 'paragraph_close');
    acc.push(paragraphOpen, inline, paragraphClose);
};
/**
 * Splits the content of the inline token
 * Inline tokens can contain multiple media elements as well as regular text
 * We split the content into an array of strings which can then be converted into the correct tokens
 */ const $3f17de48a6931d92$var$findContent = (token)=>{
    let content = [];
    let lastIndex = 0;
    let match;
    $3f17de48a6931d92$var$mediaRegex.lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while((match = $3f17de48a6931d92$var$mediaRegex.exec(token.content)) !== null){
        const matchedString = match[0];
        const matchIndex = match.index;
        if (lastIndex < matchIndex) content.push(token.content.substring(lastIndex, matchIndex));
        content.push(matchedString);
        lastIndex = matchIndex + matchedString.length;
    }
    if (lastIndex < token.content.length) content.push(token.content.substring(lastIndex));
    content = content.filter((item)=>item.length > 0);
    return content;
};
function $3f17de48a6931d92$export$2e2bcd8739ae039(md) {
    md.core.ruler.before('inline', 'media', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'inline' && $3f17de48a6931d92$var$mediaRegex.test(token.content)) {
                // If the previous token is a paragraph_open we want to remove it
                if ($3f17de48a6931d92$var$checkPreviousToken('paragraph_open', acc)) acc.pop();
                const content = $3f17de48a6931d92$var$findContent(token);
                content.forEach((item)=>{
                    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
                    const doesMatch = /!\[[^\]]*\]\([^)]+\)/u.test(item);
                    if (doesMatch) $3f17de48a6931d92$var$createMediaTokens(item, state, acc);
                    else $3f17de48a6931d92$var$createInlineTokens(item, state, acc);
                });
            // If the current token is paragraph close we want to make sure that the previous token isn't a media_single_close
            // or paragraph_close
            } else if (type === 'paragraph_close') {
                if (!$3f17de48a6931d92$var$checkPreviousToken('media_single_close', acc) && !$3f17de48a6931d92$var$checkPreviousToken('paragraph_close', acc)) acc.push(token);
            } else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("9tykg", function(module, exports) {
$parcel$export(module.exports, "default", () => $811470bd95061a4c$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $811470bd95061a4c$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$811470bd95061a4c$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $811470bd95061a4c$var$paragraph);

});

parcelRegister("d5C9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $11bccb76849cfb3f$export$2e2bcd8739ae039);

var $7MY8y = parcelRequire("7MY8y");

const $11bccb76849cfb3f$var$bulletListOpen = 'bullet_list_open';
const $11bccb76849cfb3f$var$bulletListClose = 'bullet_list_close';
const $11bccb76849cfb3f$var$listItemOpen = 'list_item_open';
const $11bccb76849cfb3f$var$listItemClose = 'list_item_close';
const $11bccb76849cfb3f$var$taskListOpen = 'task_list_open';
const $11bccb76849cfb3f$var$taskListClose = 'task_list_close';
const $11bccb76849cfb3f$var$taskItemOpen = 'task_item_open';
const $11bccb76849cfb3f$var$taskItemClose = 'task_item_close';
const $11bccb76849cfb3f$var$paragraphOpen = 'paragraph_open';
const $11bccb76849cfb3f$var$paragraphClose = 'paragraph_close';
function $11bccb76849cfb3f$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    return acc[acc.length + indexOffset]?.type === type;
}
function $11bccb76849cfb3f$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen, $11bccb76849cfb3f$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListClose, $11bccb76849cfb3f$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $11bccb76849cfb3f$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemClose);
    const isPreviousTokenListItemClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$listItemClose);
    const isPreviousTokenTaskListClose = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$bulletListClose));
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListOpen));
        }
        newTaskItemOpen.meta = $11bccb76849cfb3f$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskListClose));
            acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $11bccb76849cfb3f$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $11bccb76849cfb3f$var$checkTypeByIndex(acc, 'inline') && $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $7MY8y.createToken)(state, $11bccb76849cfb3f$var$taskItemClose, $11bccb76849cfb3f$var$getTokenByIndex(acc, -2).level));
    else if (!$11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskListClose)) acc.push(token);
}
function $11bccb76849cfb3f$var$handleInline(token, acc) {
    if (token.children?.[0]) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    token.children[0].content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.children[0].content);
    token.content = $11bccb76849cfb3f$var$removeTodoMarkdown(token.content);
    token.level = $11bccb76849cfb3f$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $11bccb76849cfb3f$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen) || $11bccb76849cfb3f$var$checkTypeByIndex(acc, $11bccb76849cfb3f$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $11bccb76849cfb3f$var$taskItemOpen;
}
function $11bccb76849cfb3f$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $11bccb76849cfb3f$var$removeTodoMarkdown(content) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regex = /(\[x\]\s)|(\[\s\]\s)/;
    return content.replace(regex, '');
}
function $11bccb76849cfb3f$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $11bccb76849cfb3f$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $11bccb76849cfb3f$var$bulletListOpen) $11bccb76849cfb3f$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $11bccb76849cfb3f$var$bulletListClose) $11bccb76849cfb3f$var$handleBulletListClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemOpen) $11bccb76849cfb3f$var$handleListItemOpen(state, token, acc, index);
            else if ($11bccb76849cfb3f$var$isInlineAfterTaskItemOpen(token, acc)) $11bccb76849cfb3f$var$handleInline(token, acc);
            else if (type === $11bccb76849cfb3f$var$listItemClose) $11bccb76849cfb3f$var$handleListItemClose(state, token, acc);
            else if (type === $11bccb76849cfb3f$var$paragraphOpen || type === $11bccb76849cfb3f$var$paragraphClose) $11bccb76849cfb3f$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("cLj22", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fYQcF = parcelRequire("fYQcF");


var $j1XmT = parcelRequire("j1XmT");


var $9ZanP = parcelRequire("9ZanP");

const $4a7a945da70edda5$export$5fe969aa6ed2f349 = ({ analyticsConfig: analyticsConfig, issueConfig: issueConfig, onCompletion: onCompletion, customExperienceTracker: customExperienceTracker, requestHeaderOverrides: requestHeaderOverrides, ...streamingProps })=>{
    // **** setup ****
    const { updateSuggestions: updateSuggestions, suggestions: suggestions, fullSuggestionList: fullSuggestionList, reset: resetSuggestion, hideSuggestion: hideSuggestion } = (0, $j1XmT.useSuggestions)();
    const [error, setError] = (0, $42omo.useState)();
    const analyticsContext = {
        ...analyticsConfig,
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        isAIFeature: 1
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIResultError: trackAIResultError, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)(analyticsContext);
    const onStreamError = (0, $42omo.useCallback)((error)=>{
        customExperienceTracker?.fail?.(error);
        trackAIResultError({
            aiErrorCode: error.message.status_code,
            aiErrorMessage: error.message.message_template
        }, !(0, $9ZanP.isWhitelistedSLOError)(error) ? {
            attributes: {
                aiResultErrorCategory: 'server-error'
            }
        } : undefined);
        setError(error);
    }, [
        trackAIResultError,
        customExperienceTracker
    ]);
    const onStreamInit = (0, $42omo.useCallback)((retryCount)=>{
        resetSuggestion();
        setError(undefined);
        customExperienceTracker?.start?.();
        trackAIInteractionInit({
            attributes: {
                totalRetries: retryCount
            }
        });
    }, [
        trackAIInteractionInit,
        resetSuggestion,
        customExperienceTracker
    ]);
    const onStreamAborted = (0, $42omo.useCallback)(()=>{
        customExperienceTracker?.abort?.();
        trackAIInteractionDismiss();
    }, [
        trackAIInteractionDismiss,
        customExperienceTracker
    ]);
    const { isStreaming: isStreaming, isInitiating: isInitiatingStreaming, reset: resetStreaming, refetch: refetch, getIsStreamingRef: getIsStreamingRef } = (0, $9ZanP.useStreaming)({
        analyticsContext: analyticsContext,
        streamingProps: streamingProps,
        issueConfig: issueConfig,
        requestHeaderOverrides: requestHeaderOverrides,
        onSuggestionStreamUpdated: updateSuggestions,
        onStreamError: onStreamError,
        onStreamInit: onStreamInit,
        onStreamAbortedByInitNew: onStreamAborted
    });
    // **** callbacks ****
    const terminate = (0, $42omo.useCallback)(()=>{
        if (isStreaming) // stream aborted by terminating service
        onStreamAborted();
        resetSuggestion();
        resetStreaming();
        setError(undefined);
    // leave for side effect to invoke `onCompletion`
    }, [
        onStreamAborted,
        isStreaming,
        resetSuggestion,
        resetStreaming
    ]);
    const hideSuggestions = (0, $42omo.useCallback)((ids, action)=>{
        if (action) ids.forEach((_)=>trackAIResultAction(action));
        ids.forEach((id)=>hideSuggestion(id));
    }, [
        trackAIResultAction,
        hideSuggestion
    ]);
    // **** event handlers ****
    const onAIResultView = (0, $42omo.useCallback)(()=>{
        customExperienceTracker?.succeed?.();
        trackAIResultView({
            attributes: {
                suggestedNumber: suggestions.length
            }
        });
    }, [
        trackAIResultView,
        suggestions.length,
        customExperienceTracker
    ]);
    // **** side effects ****
    (0, $42omo.useEffect)(()=>{
        // work is considered done, if
        // - no suggestions are available
        // - no error exist
        // - no streaming is active
        if (!isInitiatingStreaming && !isStreaming && !error && suggestions.length === 0) onCompletion();
    }, [
        error,
        suggestions,
        isStreaming,
        onCompletion,
        isInitiatingStreaming
    ]);
    // report aborted on unmount if still streaming
    (0, $42omo.useEffect)(()=>()=>{
            if (getIsStreamingRef.current()) onStreamAborted();
        }, [
        onStreamAborted,
        getIsStreamingRef
    ]);
    return {
        suggestions: suggestions,
        fullSuggestionList: fullSuggestionList,
        isStreaming: isStreaming,
        error: error,
        onAIResultView: // event handlers
        onAIResultView,
        onAIFeedbackSubmit: trackAIFeedbackSubmit,
        refetch: // callbacks
        refetch,
        hideSuggestions: hideSuggestions,
        terminate: terminate
    };
};
module.exports["useAiWorkSuggestionStreaming"] = $4a7a945da70edda5$export$5fe969aa6ed2f349;

});

parcelRegister("j1XmT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");

const $6264d1e35540fc04$export$378f0080e636ce63 = ()=>{
    const [hiddenSuggestionIds, setHiddenSuggestionIds] = (0, $42omo.useState)(new Set());
    const [fullSuggestionList, setFullSuggestionList] = (0, $42omo.useState)([]);
    // used to avoid calling `setSuggestions` too many times during streaming - could break devtools
    const streamedIssueCount = (0, $42omo.useRef)(0);
    const suggestions = (0, $42omo.useMemo)(()=>fullSuggestionList.filter((suggestion)=>!hiddenSuggestionIds.has(suggestion.localId)), [
        fullSuggestionList,
        hiddenSuggestionIds
    ]);
    const hideSuggestion = (0, $42omo.useCallback)((id)=>{
        setHiddenSuggestionIds((set)=>new Set(set).add(id));
    }, []);
    const reset = (0, $42omo.useCallback)(()=>{
        setFullSuggestionList([]);
        setHiddenSuggestionIds(new Set());
        streamedIssueCount.current = 0;
    }, []);
    const addSuggestion = (0, $42omo.useCallback)((suggestion)=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        setFullSuggestionList((suggestions)=>[
                ...suggestions,
                {
                    ...suggestion,
                    localId: (0, $dQl1W.v4)()
                }
            ]);
    }, []);
    const updateSuggestions = (0, $42omo.useCallback)((newSuggestionList)=>{
        while(streamedIssueCount.current < newSuggestionList.length){
            addSuggestion(newSuggestionList[streamedIssueCount.current]);
            streamedIssueCount.current++;
        }
    }, [
        addSuggestion
    ]);
    return {
        fullSuggestionList: fullSuggestionList,
        suggestions: suggestions,
        hideSuggestion: hideSuggestion,
        updateSuggestions: updateSuggestions,
        reset: reset
    };
};
module.exports["useSuggestions"] = $6264d1e35540fc04$export$378f0080e636ce63;

});

parcelRegister("9ZanP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $93WqG = parcelRequire("93WqG");

var $kAaxz = parcelRequire("kAaxz");

var $d3UlG = parcelRequire("d3UlG");

const $9518a1ee412d4b03$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $93WqG.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $93WqG.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $93WqG.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $93WqG.ConvoAIErrorMessage).NOT_FOUND,
        (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $9518a1ee412d4b03$var$TIMEOUT_DELAY = 60000;
const $9518a1ee412d4b03$export$734279c1f8caf5b9 = ({ analyticsContext: analyticsContext, issueConfig: issueConfig, streamingProps: streamingProps, requestHeaderOverrides: requestHeaderOverrides, onSuggestionStreamUpdated: onSuggestionStreamUpdated, onStreamError: onStreamError, onStreamInit: onStreamInit, onStreamAbortedByInitNew: onStreamAbortedByInitNew })=>{
    const [isStreaming, setIsStreaming] = (0, $42omo.useState)(false);
    const [isInitiating, setIsInitiating] = (0, $42omo.useState)(true);
    const prevResponseState = (0, $42omo.useRef)(null);
    const streamCountRef = (0, $42omo.useRef)(0);
    const getIsStreamingRef = (0, $42omo.useRef)(()=>false);
    getIsStreamingRef.current = ()=>isStreaming;
    const streamingRequest = (0, $42omo.useMemo)(()=>({
            ai_feature_input: {
                ...streamingProps.input,
                suggested_issues_config: issueConfig
            }
        }), [
        issueConfig,
        streamingProps.input
    ]);
    const streamingConfig = (0, $42omo.useMemo)(()=>({
            apiPath: `v2/ai-feature/jira/issue/source-type/${streamingProps.sourceType}/suggestions/stream`,
            enablePartialJson: true,
            enableFollowUp: false,
            headers: {
                'x-experience-id': streamingProps.experienceId,
                'x-product': requestHeaderOverrides?.overrideXProduct ?? analyticsContext.product,
                'x-channel-id': streamingProps?.channelId
            },
            skip: streamingProps.skip ?? false,
            timeoutDelay: $9518a1ee412d4b03$var$TIMEOUT_DELAY
        }), [
        analyticsContext.product,
        streamingProps.experienceId,
        streamingProps.sourceType,
        requestHeaderOverrides?.overrideXProduct,
        streamingProps?.channelId,
        streamingProps?.skip
    ]);
    const onStateChange = (0, $42omo.useCallback)((state)=>{
        if (prevResponseState.current !== state.responseState) {
            if (state.responseState === (0, $kAaxz.ConvoAIResponseState).Initialization) {
                if (isStreaming) onStreamAbortedByInitNew();
                onStreamInit(streamCountRef.current); // argument is "retryCount", so before self-increment
                setIsStreaming(true);
                if (isInitiating) setIsInitiating(false);
                streamCountRef.current++;
            }
            prevResponseState.current = state.responseState;
        }
        if (!isStreaming) return;
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                {
                    const fullyFormedIssues = state.content?.suggested_issues?.slice?.(0, -1) ?? [];
                    onSuggestionStreamUpdated(fullyFormedIssues);
                    break;
                }
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                setIsStreaming(false);
                // builds kept failing when using ConvoAIErrorMessage.SOME_ERROR
                // fixed by typecasting as ConvoAIErrorMessage
                if (!('suggested_issues' in state.content)) {
                    // if there are are no suggested_issues, it's potentially due to bad json
                    // log as an unexpected error as we are unsure if this pops up in ConvoAI
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'UNEXPECTED',
                            content: `Bad JSON: ${Object.keys(state.content).toString()}`,
                            status_code: 500
                        }
                    });
                    break;
                }
                if (state.content?.suggested_issues.length === 0) {
                    // no child issue information came back from the LLM
                    // we clasify this as a not engouh information error
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'NOT_ENOUGH_CONTENT_ERROR',
                            content: 'Not enough content to generate work items from Confluence link.',
                            status_code: 400
                        }
                    });
                    break;
                }
                onSuggestionStreamUpdated(state.content?.suggested_issues);
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                setIsStreaming(false);
                onStreamError(state.error);
                break;
            default:
        }
    }, [
        onSuggestionStreamUpdated,
        onStreamError,
        isStreaming,
        isInitiating,
        onStreamAbortedByInitNew,
        onStreamInit
    ]);
    const [_, refetch] = (0, $d3UlG.useConvoAIStreaming)(streamingRequest, streamingConfig, onStateChange);
    const reset = (0, $42omo.useCallback)(()=>{
        setIsStreaming(false);
    }, []);
    return {
        isInitiating: isInitiating,
        isStreaming: isStreaming,
        getIsStreamingRef: getIsStreamingRef,
        refetch: refetch,
        reset: reset
    };
};
module.exports["isWhitelistedSLOError"] = $9518a1ee412d4b03$export$4177e9b841c72d1e;
module.exports["useStreaming"] = $9518a1ee412d4b03$export$734279c1f8caf5b9;

});

parcelRegister("d3UlG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5NXxU = parcelRequire("5NXxU");


var $iIEgX = parcelRequire("iIEgX");

var $6yCLg = parcelRequire("6yCLg");


var $cPtvM = parcelRequire("cPtvM");


var $kAaxz = parcelRequire("kAaxz");

function $d7c3e272b37735b1$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $42omo.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $5NXxU.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $42omo.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}
module.exports["useConvoAIStreaming"] = $d7c3e272b37735b1$export$d6e2ae1e990d7e71;

});

parcelRegister("6yCLg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXpOY = parcelRequire("aXpOY");

function $725c584c19c66c44$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $aXpOY.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $42omo.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}
module.exports["useStatefulObservableEffect"] = $725c584c19c66c44$export$916f6bbdfa1987d0;

});

parcelRegister("1ASvP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

class $648b40683bbc8a0b$var$MountEventComponent extends (0, $42omo.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $648b40683bbc8a0b$var$MountEventComponentWithHOC = (0, $1DWH0.default)()($648b40683bbc8a0b$var$MountEventComponent);
const $648b40683bbc8a0b$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($648b40683bbc8a0b$var$MountEventComponentWithHOC, {
        ...props
    });
module.exports["MountEvent"] = $648b40683bbc8a0b$export$2c6963927dbc68f1;

});

parcelRegister("kfViO", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

const $1716be1127a34d35$export$2d424d3a12064a81 = (value)=>{
    if (!value) return 0;
    let chars = 0;
    (0, $6jPem.traverse)(value, {
        text: (node)=>{
            if (node.text) chars += node.text.length;
        },
        emoji: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        },
        paragraph: ()=>{
            chars += 1;
        },
        mention: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        }
    });
    // Subtract 1 due to doc node
    return chars ? chars - 1 : chars;
};
module.exports["countADFChars"] = $1716be1127a34d35$export$2d424d3a12064a81;

});

parcelRegister("9BGuq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1mDVg = parcelRequire("1mDVg");

const $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return (0, $42omo.useMemo)(()=>({
            fireTrack: (name, attributes)=>{
                const source = 'aiIssueCreate';
                const [actionSubject, action] = name.split(' ');
                const eventAttributes = {
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    ...attributes
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: source,
                        action: action,
                        actionSubject: actionSubject,
                        attributes: eventAttributes
                    }
                }).fire();
            }
        }), [
        createAnalyticsEvent,
        pageMode,
        hasEditPermission
    ]);
};
module.exports["useAiIssueCreateAnalytics"] = $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e;

});

parcelRegister("arvSz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $93WqG = parcelRequire("93WqG");


var $9BGuq = parcelRequire("9BGuq");

const $5dcd84d787afdff9$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $93WqG.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $93WqG.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $93WqG.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $93WqG.ConvoAIErrorMessage).NOT_FOUND,
        (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $5dcd84d787afdff9$export$8b355f71d361cab7 = ({ confluencePage: confluencePage, highlightedText: highlightedText, overrideXProduct: overrideXProduct })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { locale: locale } = (0, $aXWIB.useIntl)();
    return (0, $42omo.useMemo)(()=>({
            analyticsConfig: {
                aiFeatureName: 'confluenceAiWorkCreationConvoAI',
                product: 'confluence',
                subproduct: 'jira',
                useDefaultGASv3EventSchema: false,
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            },
            requestHeaderOverrides: {
                overrideXProduct: overrideXProduct
            },
            issueConfig: {
                max_issues: 1,
                suggested_issue_field_types: [
                    {
                        issue_type: 'Task',
                        fields: [
                            {
                                field_name: 'Summary',
                                field_type: 'Short-Text'
                            },
                            {
                                field_name: 'Description',
                                field_type: 'Paragraph'
                            }
                        ]
                    }
                ]
            },
            experienceId: 'ai-issue-create-confluence-single',
            sourceType: 'documentation',
            input: {
                source: 'CONFLUENCE',
                context: {
                    primary_text: confluencePage,
                    highlighted_text: highlightedText
                },
                locale: locale
            },
            onCompletion: ()=>{},
            customExperienceTracker: {
                start: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest start', {
                        locale: locale
                    });
                },
                succeed: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest complete', {
                        haveResult: true,
                        locale: locale
                    });
                },
                fail: (convoAIStreamError)=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest fail', {
                        errorMessage: convoAIStreamError?.message?.content,
                        statusCode: convoAIStreamError?.message?.status_code,
                        message_template: convoAIStreamError?.message?.message_template,
                        shouldSlo: !$5dcd84d787afdff9$export$4177e9b841c72d1e(convoAIStreamError),
                        locale: locale
                    });
                },
                abort: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest abort', {
                        locale: locale
                    });
                }
            }
        }), [
        confluencePage,
        highlightedText,
        overrideXProduct,
        fireTrack,
        locale
    ]);
};
module.exports["useStreamingHookProps"] = $5dcd84d787afdff9$export$8b355f71d361cab7;

});

parcelRegister("gqQUx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iY4nM = parcelRequire("iY4nM");


var $kDhla = parcelRequire("kDhla");


var $1mDVg = parcelRequire("1mDVg");


var $9BGuq = parcelRequire("9BGuq");


var $iT03Z = parcelRequire("iT03Z");

const $1a87d70e3d885601$var$getConfluencePageAdf = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, pageMode: pageMode = (0, $1mDVg.PageMode).VIEW, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create', editorApi: editorApi })=>{
    if (pageMode === (0, $1mDVg.PageMode).EDIT || pageMode === (0, $1mDVg.PageMode).LIVE_EDIT || pageMode === (0, $1mDVg.PageMode).LIVE_VIEW) return (0, $iT03Z.getConfluencePageAdfFromEditor)(editorApi);
    return (0, $iY4nM.getConfluencePageAdfFromApi)({
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        signal: signal,
        product: product,
        experienceId: experienceId
    });
};
const $1a87d70e3d885601$export$e411256f856842c7 = ({ cloudId: cloudId, contentType: contentType, experienceId: experienceId, pageId: pageId, pageMode: pageMode, product: product, onStateChange: onStateChange })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const [fetchState, setGetConfluencePageState] = (0, $42omo.useState)({
        state: 'loading',
        confluencePage: undefined
    });
    const abortControllerRef = (0, $42omo.useRef)(null);
    const fetchConfluencePage = (0, $42omo.useCallback)(async ()=>{
        if (abortControllerRef.current) abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        const currentAbortController = abortControllerRef.current;
        setGetConfluencePageState({
            state: 'loading',
            confluencePage: undefined
        });
        try {
            fireTrack('issueCreateSidePanelGetConfluencePageRequest start');
            const confluencePage = await $1a87d70e3d885601$var$getConfluencePageAdf({
                cloudId: cloudId,
                contentType: contentType,
                experienceId: experienceId,
                pageId: pageId,
                pageMode: pageMode,
                product: product,
                signal: currentAbortController.signal,
                editorApi: fullPageEditorPresetAPI
            });
            fireTrack('issueCreateSidePanelGetConfluencePageRequest complete', {
                haveResult: !!confluencePage
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            if (confluencePage) setGetConfluencePageState({
                state: 'idle',
                confluencePage: confluencePage
            });
            else setGetConfluencePageState({
                state: 'error',
                error: new Error('Error on getting confluence page as ADF'),
                confluencePage: undefined
            });
        } catch (e) {
            fireTrack('issueCreateSidePanelGetConfluencePageRequest fail', {
                message: e.message
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            setGetConfluencePageState({
                state: 'error',
                error: e,
                confluencePage: undefined
            });
        }
    }, [
        cloudId,
        contentType,
        experienceId,
        pageId,
        product,
        setGetConfluencePageState,
        fireTrack,
        pageMode,
        fullPageEditorPresetAPI
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchConfluencePage();
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        fetchConfluencePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onStateChange) onStateChange(fetchState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchState.state,
        fetchState.confluencePage,
        onStateChange
    ]);
    return {
        ...fetchState,
        trigger: fetchConfluencePage
    };
};
module.exports["useGetConfluencePage"] = $1a87d70e3d885601$export$e411256f856842c7;

});

parcelRegister("iY4nM", function(module, exports) {
const $98a3645fea1a46e5$export$9ae725848caea23f = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create' })=>{
    try {
        const endpointAPI = contentType === 'blogpost' ? `blogposts` : `pages`;
        const response = await fetch(`/wiki/api/v2/${endpointAPI}/${pageId}?body-format=atlas_doc_format`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': experienceId,
                'X-Product': product,
                'Atl-CloudId': cloudId
            },
            credentials: 'include',
            signal: signal
        });
        const data = await response.json();
        if (!data.body?.atlas_doc_format) throw new Error('No atlas doc format found in confluence page');
        return JSON.parse(data.body.atlas_doc_format.value);
    } catch (error) {
        throw new Error('Request to get confluence page failed');
    }
};
module.exports["getConfluencePageAdfFromApi"] = $98a3645fea1a46e5$export$9ae725848caea23f;

});

parcelRegister("iT03Z", function(module, exports) {
const $12940757b485c304$export$21b6e0bf8d10cc8 = async (editorApi)=>{
    return new Promise((resolve)=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            if (!doc) throw new Error('No adf document found in editor');
            resolve(doc);
        });
    });
};
module.exports["getConfluencePageAdfFromEditor"] = $12940757b485c304$export$21b6e0bf8d10cc8;

});

parcelRegister("bZC8A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3E5yu = parcelRequire("3E5yu");

const $d2ef8f1ef1cac15d$export$844cd257c85281a = (error)=>{
    let errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescription;
    let errorMessageValues;
    let hideTryAgain = false;
    if (error.message_template !== undefined && [
        'ACCEPTABLE_USE_VIOLATIONS',
        'ACCEPTABLE_USE_EVALUATION_EXCEPTION'
    ].includes(error.message_template)) {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).ethicalViolationErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).ethicalViolationErrorDescription;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://www.atlassian.com/legal/acceptable-use-policy",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'RATE_LIMIT') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).rateLimitErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).rateLimitErrorDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).rateLimitErrorDescriptionRebrandToRovo : (0, $3E5yu.messages).rateLimitErrorDescription;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'FE_REQUEST_EXCEEDING_TOKEN_LENGTH') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).exceedingTokenLimitDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).exceedingTokenLimitDescriptionIssueTermRefresh : (0, $6mKj3.expVal)('confluence_work_item_create_ai_rebrand_to_rovo', 'isEnabled', false) ? (0, $3E5yu.messages).exceedingTokenLimitDescriptionRebrandToRovo : (0, $3E5yu.messages).exceedingTokenLimitDescription;
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'NO_ANSWER_SUGGESTED_ISSUES') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).noAnswerSuggestedIssuesIssueTermRefresh : (0, $3E5yu.messages).noAnswerSuggestedIssues;
        hideTryAgain = true;
    }
    return {
        errorMessage: errorMessage,
        errorMessageValues: errorMessageValues,
        hideTryAgain: hideTryAgain
    };
};
module.exports["handleAiIssueCreateError"] = $d2ef8f1ef1cac15d$export$844cd257c85281a;

});

parcelRegister("jE0Gg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3E5yu = parcelRequire("3E5yu");


var $1mDVg = parcelRequire("1mDVg");

const $3fdc1d9372d96a0e$export$2ac688f17b22f89f = ()=>{
    const [{ currentSiteSelection: currentSiteSelection }, { setCurrentSiteSelection: setCurrentSiteSelection, setCurrentProjectSelection: setCurrentProjectSelection, setAiIssueCreationEnablement: setAiIssueCreationEnablement, setIsGicIframeReady: setIsGicIframeReady }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $42omo.useEffect)(()=>{
        const messageHandler = (message)=>{
            const eventName = message?.data?.event;
            const payload = message.data?.payload;
            switch(eventName){
                // Recieve message from GIC anywhere component for current site selection since it is in an inner iframe.
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_SITE_SELECTED:
                    if (payload?.selectedCloudId && payload?.selectedCloudId !== '') {
                        // reset currentProjectSelection on site change since projects are tied per site
                        if (currentSiteSelection && payload?.selectedCloudId !== currentSiteSelection) setCurrentProjectSelection(undefined);
                        setCurrentSiteSelection(payload.selectedCloudId);
                    }
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_PROJECT_SELECTED:
                    const project = {
                        selectedProjectType: payload?.selectedProjectType,
                        selectedProjectId: payload?.selectedProjectId,
                        selectedProjectKey: payload?.selectedProjectKey
                    };
                    setCurrentProjectSelection(project);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_READY:
                    setIsGicIframeReady(true);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    setIsGicIframeReady(false);
                    break;
                default:
            }
        };
        window.addEventListener('message', messageHandler);
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, [
        setCurrentSiteSelection,
        setCurrentProjectSelection,
        currentSiteSelection,
        setAiIssueCreationEnablement,
        setIsGicIframeReady
    ]);
};
module.exports["useMessageListener"] = $3fdc1d9372d96a0e$export$2ac688f17b22f89f;

});

parcelRegister("hib1D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $74xbC = parcelRequire("74xbC");


var $1mDVg = parcelRequire("1mDVg");


var $hiixe = parcelRequire("hiixe");

const $c160271417b290c8$var$footerContainerStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.sunken'
});
const $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID = '5dd040e8-af22-4ef1-803e-136f659a1092';
const $c160271417b290c8$export$5e203ab8a2a5043e = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $c160271417b290c8$var$footerContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $74xbC.IssueCreateAiFeedback), {
        contentId: contentId,
        entrypointId: $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiixe.AiSubFooter), null));
};
module.exports["IssueCreateSidePanelFooter"] = $c160271417b290c8$export$5e203ab8a2a5043e;

});

parcelRegister("6pbwW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $cO1el = parcelRequire("cO1el");


var $hmuev = parcelRequire("hmuev");


var $1qfLF = parcelRequire("1qfLF");


var $lAFHW = parcelRequire("lAFHW");


var $4WZFP = parcelRequire("4WZFP");


var $9wGTI = parcelRequire("9wGTI");


var $3E5yu = parcelRequire("3E5yu");

const $47081d53dba235a2$var$headerMessageStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    font: "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.025'
});
const $47081d53dba235a2$export$7b151ed3fccdded0 = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $47081d53dba235a2$var$headerMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelHeaderIssueTermRefresh : (0, $3E5yu.messages).sidePanelHeader)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: "close-icon",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: ()=>onClose(),
        testId: "close-issue-create-panel-button"
    })));
};
module.exports["IssueCreateSidePanelHeader"] = $47081d53dba235a2$export$7b151ed3fccdded0;

});

parcelRegister("4WZFP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $42omo.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $42omo.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $42omo.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $42omo.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $42omo.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $42omo.useState)(0);
    const providerValue = (0, $42omo.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("b0EGa", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9wGTI = parcelRequire("9wGTI");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0,
    hasReceivedHideRequest: false
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1,
                ...(0, $9wGTI.fg)('cc-engagement-omnibar-transition-fix') && {
                    hasReceivedHideRequest: true
                }
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $1P1Tu.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $9zUhf.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$13aafec54f1ab41c = (0, $9zUhf.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hasReceivedHideRequest
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $9zUhf.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useShouldHideOmniBar"] = $6d5fb7464c13acdf$export$c640b7434448a8d;
module.exports["useHasReceivedOmniBarHideRequest"] = $6d5fb7464c13acdf$export$13aafec54f1ab41c;
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("aKDZB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $2O3ot = parcelRequire("2O3ot");


var $4iTbK = parcelRequire("4iTbK");


var $aXWtB = parcelRequire("aXWtB");


var $1AJi3 = parcelRequire("1AJi3");


var $jyA9t = parcelRequire("jyA9t");


var $3rRes = parcelRequire("3rRes");


var $fj6ez = parcelRequire("fj6ez");


var $7eOZ4 = parcelRequire("7eOZ4");


var $jNS1v = parcelRequire("jNS1v");

const $c9c8b9d550aa1c05$var$constructDynamicUiSource = (adfDocument, selectionContext)=>{
    if (!selectionContext) return undefined;
    return {
        contentType: 'page',
        startLocalId: selectionContext.localIds?.[0] ?? '',
        endLocalId: selectionContext.localIds?.[selectionContext.localIds.length - 1] ?? '',
        startIndex: selectionContext.startIndex ?? 0,
        endIndex: selectionContext.endIndex ?? -1,
        fragmentAdf: (0, $3rRes.filterRemixFragmentNodes)(selectionContext.selectionFragment),
        fullAdf: adfDocument
    };
};
const $c9c8b9d550aa1c05$var$RendererRemixModal = ({ adfDocument: adfDocument, selectionContext: selectionContext, interactionSource: interactionSource, onClose: onClose, onStartThinking: onStartThinking, onStopThinking: onStopThinking, isEphemeralViewVisible: isEphemeralViewVisible })=>{
    const isRemixCancelled = (0, $42omo.useRef)(false);
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const openAIFCStagingModalRef = (0, $42omo.useRef)(()=>{});
    const selectedSubTypeRef = (0, $42omo.useRef)(undefined);
    const { dynamicUiType: dynamicUiType } = (0, $2O3ot.useStagingAreaState)();
    const { toggleConversationAssistant: toggleConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const onActionReady = (0, $42omo.useCallback)(()=>{
        if (!isRemixCancelled.current) {
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).REMIX_START
            });
            // Start as early as possible — before the modal content mounts.
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).REMIX_RENDERS_IN_MODAL,
                id: (0, $16lEl.ExperienceName).REMIX_RENDERS_IN_MODAL,
                attributes: {
                    product: 'confluence',
                    remixType: dynamicUiType,
                    remixSubtype: selectedSubTypeRef.current,
                    entryPoint: 'renderer'
                }
            });
            openAIFCStagingModalRef.current();
            onClose({
                preserveHighlight: true
            });
        }
    }, [
        experienceTracker,
        onClose,
        dynamicUiType
    ]);
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, remixStoreError: remixStoreError, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal } = (0, $7eOZ4.useRemixToAIFC)({
        onActionReady: onActionReady
    });
    openAIFCStagingModalRef.current = openAIFCStagingModal;
    // Abort experience on unmount (overlay closed without selecting an option).
    // Uses a ref so the cleanup always calls the latest tracker reference.
    const experienceTrackerRef = (0, $42omo.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            experienceTrackerRef.current.abort({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                reason: 'User closed remix overlay',
                attributes: {
                    reason: 'User closed remix overlay'
                }
            });
        };
    }, []);
    const onRemixFlowActiveChange = (0, $42omo.useCallback)((active)=>{
        if (active) {
            isRemixCancelled.current = false;
            onStartThinking();
        } else {
            isRemixCancelled.current = true;
            // Abort the current experience before stopping
            experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                reason: 'User cancelled remix thinking',
                attributes: {
                    reason: 'User cancelled remix thinking'
                }
            });
            stopRemixing();
            // Start a new experience for the reopened overlay
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                id: (0, $16lEl.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: 'renderer',
                    remixSource: 'cancelledRemixThinking',
                    originalRemixSource: 'selectionToolbar',
                    product: 'confluence'
                }
            });
            onStopThinking({
                reopenModal: true
            });
        }
    }, [
        onStartThinking,
        stopRemixing,
        onStopThinking,
        experienceTracker
    ]);
    // Fail experience and clean up thinking UI when Rovo encounters an error
    const prevIsRemixError = (0, $42omo.useRef)(isRemixError);
    (0, $42omo.useEffect)(()=>{
        if (!prevIsRemixError.current && isRemixError && !isRemixCancelled.current) {
            const errorMessage = remixStoreError?.content ?? 'Rovo agent error during remix';
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                error: new Error(errorMessage),
                attributes: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId
                }
            });
            onStopThinking({
                reopenModal: true
            });
        }
        prevIsRemixError.current = isRemixError;
    }, [
        isRemixError,
        remixStoreError,
        onStopThinking,
        experienceTracker
    ]);
    // When an error occurs during remix, close the thinking bar and ephemeral
    // preview, then open the Rovo chat sidebar so the user can see the error.
    (0, $42omo.useEffect)(()=>{
        if (!isRemixCancelled.current && isRemixError) {
            // Close the ephemeral preview (staging modal) if it is open
            if (isEphemeralViewVisible) closeAIFCStagingModal();
            // Close the thinking bar and dismiss the remix UI
            onStopThinking();
            onClose();
            // Open the Rovo chat sidebar to display the error information
            toggleConversationAssistant('sidebar');
        }
    }, [
        isRemixError,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        onStopThinking,
        onClose,
        toggleConversationAssistant
    ]);
    const handleOptionSelect = (0, $42omo.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt })=>{
        selectedSubTypeRef.current = subType;
        experienceTracker.updateAttributes({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                remixType: type,
                remixSubtype: subType
            }
        });
        const dynamicUiSource = $c9c8b9d550aa1c05$var$constructDynamicUiSource(adfDocument, selectionContext);
        await sendAIFCPrompt({
            userPrompt: userPrompt,
            dynamicUiType: type,
            dynamicUiSubtype: subType,
            dynamicUiSource: dynamicUiSource,
            interactionSource: interactionSource
        });
    }, [
        sendAIFCPrompt,
        adfDocument,
        selectionContext,
        interactionSource,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iTbK.RemixContainer), {
        onClose: ()=>onClose(),
        onOptionSelect: handleOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        isEphemeralViewVisible: isEphemeralViewVisible
    });
};
const $c9c8b9d550aa1c05$var$RendererRemixContext = /*#__PURE__*/ (0, $42omo.createContext)({
    openRemixModal: ()=>{},
    clearRemixHighlight: ()=>{},
    isRemixDisabled: false,
    isRemixing: false,
    registerOnModalClose: ()=>()=>{}
});
const $c9c8b9d550aa1c05$export$c881c5d3c5870780 = ()=>{
    return (0, $42omo.useContext)($c9c8b9d550aa1c05$var$RendererRemixContext);
};
const $c9c8b9d550aa1c05$var$RendererRemixContainerImpl = ({ children: children })=>{
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [adfDocument, setAdfDocument] = (0, $42omo.useState)(null);
    const [selectionContext, setSelectionContext] = (0, $42omo.useState)(null);
    const [isThinking, setIsThinking] = (0, $42omo.useState)(false);
    const interactionSourceRef = (0, $42omo.useRef)(undefined);
    const { startHighlight: startHighlight, clearHighlight: clearHighlight } = (0, $jNS1v.useRendererRemixHighlight)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const onModalCloseCallbacks = (0, $42omo.useRef)(new Set());
    const registerOnModalClose = (0, $42omo.useCallback)((callback)=>{
        onModalCloseCallbacks.current.add(callback);
        return ()=>{
            onModalCloseCallbacks.current.delete(callback);
        };
    }, []);
    const prevShowSmartCreationModal = (0, $42omo.useRef)(showSmartCreationModal);
    (0, $42omo.useEffect)(()=>{
        if (prevShowSmartCreationModal.current && !showSmartCreationModal) clearHighlight();
        prevShowSmartCreationModal.current = showSmartCreationModal;
    }, [
        showSmartCreationModal,
        clearHighlight
    ]);
    const openModal = (0, $42omo.useCallback)((newAdfDocument, selection, interactionSource)=>{
        setAdfDocument(newAdfDocument);
        startHighlight();
        setSelectionContext(selection);
        interactionSourceRef.current = interactionSource;
        setIsModalOpen(true);
    }, [
        startHighlight
    ]);
    const closeModal = (0, $42omo.useCallback)((options)=>{
        if (!options?.preserveHighlight) clearHighlight();
        onModalCloseCallbacks.current.forEach((cb)=>cb());
        setAdfDocument(null);
        setSelectionContext(null);
        interactionSourceRef.current = undefined;
        setIsModalOpen(false);
        setIsThinking(false);
    }, [
        clearHighlight
    ]);
    const onStartThinking = (0, $42omo.useCallback)(()=>{
        setIsThinking(true);
        setIsModalOpen(false);
    }, []);
    const onStopThinking = (0, $42omo.useCallback)((options)=>{
        setIsThinking(false);
        if (options?.reopenModal) setIsModalOpen(true);
    }, []);
    const context = (0, $42omo.useMemo)(()=>{
        const isRemixing = isModalOpen || isThinking || showSmartCreationModal;
        return {
            openRemixModal: openModal,
            clearRemixHighlight: clearHighlight,
            isRemixDisabled: false,
            isRemixing: isRemixing,
            registerOnModalClose: registerOnModalClose
        };
    }, [
        openModal,
        clearHighlight,
        isModalOpen,
        isThinking,
        showSmartCreationModal,
        registerOnModalClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fj6ez.RendererRemixHighlightStyles), null), children, (isModalOpen || isThinking) && adfDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9c8b9d550aa1c05$var$RendererRemixModal, {
        adfDocument: adfDocument,
        selectionContext: selectionContext,
        interactionSource: interactionSourceRef.current,
        onClose: closeModal,
        onStartThinking: onStartThinking,
        onStopThinking: onStopThinking,
        isEphemeralViewVisible: showSmartCreationModal
    })));
};
const $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue = (reason)=>({
        openRemixModal: ()=>{},
        clearRemixHighlight: ()=>{},
        isRemixDisabled: true,
        isRemixing: false,
        remixDisabledReason: reason,
        registerOnModalClose: ()=>()=>{}
    });
const $c9c8b9d550aa1c05$var$disabledRemixContextValue = $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue();
const $c9c8b9d550aa1c05$export$62131e16a1db8364 = ({ children: children, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason })=>{
    if (isDisabled) {
        const contextValue = remixDisabledReason ? $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue(remixDisabledReason) : $c9c8b9d550aa1c05$var$disabledRemixContextValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
            value: contextValue
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerImpl, null, children);
};
module.exports["useRendererRemixContext"] = $c9c8b9d550aa1c05$export$c881c5d3c5870780;
module.exports["RendererRemixContainer"] = $c9c8b9d550aa1c05$export$62131e16a1db8364;

});

parcelRegister("16lEl", function(module, exports) {
const $99e3e594de94f1bc$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
    STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
    MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
    STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
    THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
    WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
    AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
    REMIX_START: 'aiMateRemixStart',
    FETCH_PROMPTS: 'aiMateFetchPrompts',
    FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
    FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
    REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal'
};
var $99e3e594de94f1bc$export$3615d040a39afa1e = /*#__PURE__*/ function(ExperienceNamePostfix) {
    ExperienceNamePostfix["MINI_MODAL"] = "miniModal";
    return ExperienceNamePostfix;
}({});
const $99e3e594de94f1bc$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $99e3e594de94f1bc$export$233a4307e330ea30 = [
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION
];
const $99e3e594de94f1bc$export$449b821dadec8760 = [
    // Experiences with timeouts must be listed first:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    // Experiences without timeouts:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$99e3e594de94f1bc$export$233a4307e330ea30
];
module.exports["ExperienceName"] = $99e3e594de94f1bc$export$b881bd9f00ed8ed1;
module.exports["ExperienceNamePostfix"] = $99e3e594de94f1bc$export$3615d040a39afa1e;
module.exports["sendMessageExperienceName"] = $99e3e594de94f1bc$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $99e3e594de94f1bc$export$233a4307e330ea30;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $99e3e594de94f1bc$export$449b821dadec8760;

});

parcelRegister("hUyPY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $c6GJD = parcelRequire("c6GJD");


var $4u5NT = parcelRequire("4u5NT");


var $9tntP = parcelRequire("9tntP");


var $j2DyP = parcelRequire("j2DyP");


var $1yaYZ = parcelRequire("1yaYZ");


var $kIvLT = parcelRequire("kIvLT");


var $16lEl = parcelRequire("16lEl");

var $a0b22d0a467d60f5$var$_ExperienceTrackerHandler;
const $a0b22d0a467d60f5$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
class $a0b22d0a467d60f5$export$5a92a056565f01cc {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$a0b22d0a467d60f5$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $c6GJD.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $a0b22d0a467d60f5$export$5a92a056565f01cc.instance = new $a0b22d0a467d60f5$export$5a92a056565f01cc(dropEvents);
        }
        return $a0b22d0a467d60f5$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $a0b22d0a467d60f5$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $9tntP.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $j2DyP.isClientFetchError)(event.error)) preventSendingLogException = true;
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        fastModeEnabled: fastModeEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($a0b22d0a467d60f5$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = attributes?.touchpointSource;
                    const teamName = attributes?.teamName;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $1yaYZ.logException)({
                        exception: error,
                        name: event.name,
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if (event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort') // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $4u5NT.addSpanToAll)('custom', `exp-${event.name}`, $a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    // Only add duration if event is SuccessEvent or FailEvent
                    ...(event.action === 'taskSuccess' || event.action === 'taskFail') && {
                        duration: event.duration
                    },
                    ...event.action === 'taskFail' && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
}
$a0b22d0a467d60f5$var$_ExperienceTrackerHandler = $a0b22d0a467d60f5$export$5a92a056565f01cc;
$a0b22d0a467d60f5$export$5a92a056565f01cc.instance = void 0;
$a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack = [];
const $a0b22d0a467d60f5$export$63af6e7bbb4f375d = ()=>{
    return (0, $42omo.useCallback)((componentLabelStack)=>{
        $a0b22d0a467d60f5$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $a0b22d0a467d60f5$export$412c53791574f6f0 = (params)=>{
    (0, $fBMbo.di)((0, $kIvLT.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent, mode: conversationAssistantUIMode } = (0, $kIvLT.useAnalytics)();
    const getNameOverride = (0, $42omo.useCallback)((name)=>{
        switch(conversationAssistantUIMode){
            case 'mini-modal':
                return `${name}.${(0, $16lEl.ExperienceNamePostfix).MINI_MODAL}`;
            default:
                return name;
        }
    }, [
        conversationAssistantUIMode
    ]);
    (0, $42omo.useMemo)(()=>{
        const experienceTracker = $a0b22d0a467d60f5$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $42omo.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            name: !!failParams.name ? getNameOverride(failParams.name) : failParams.name,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: !!succeedParams.name ? getNameOverride(succeedParams.name) : succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: !!startParams.name ? getNameOverride(startParams.name) : startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: !!abortParams.name ? getNameOverride(abortParams.name) : abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: !!stopOnErrorParams.name ? getNameOverride(stopOnErrorParams.name) : stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($a0b22d0a467d60f5$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource,
        getNameOverride
    ]);
    return experienceTrackerProxy;
};
module.exports["useUFOLabelStackSetter"] = $a0b22d0a467d60f5$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $a0b22d0a467d60f5$export$412c53791574f6f0;

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("2O3ot", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $abb9e481ac8f38e8$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    dynamicUiType: undefined,
    dynamicUiSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $abb9e481ac8f38e8$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSource: dynamicUiSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: undefined,
                dynamicUiType: undefined,
                dynamicUiSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $abb9e481ac8f38e8$var$store = (0, $1P1Tu.createStore)({
    initialState: $abb9e481ac8f38e8$var$initialState,
    actions: $abb9e481ac8f38e8$var$actions
});
const $abb9e481ac8f38e8$export$a2795b51ce92008f = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $abb9e481ac8f38e8$export$916334da9df8d04 = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$8f9a13b17bec42d5 = (0, $9zUhf.createActionsHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$5a57f796673aabea = (0, $9zUhf.createStateHook)($abb9e481ac8f38e8$var$store);
module.exports["useMessageIdSelectedForPreview"] = $abb9e481ac8f38e8$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $abb9e481ac8f38e8$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $abb9e481ac8f38e8$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $abb9e481ac8f38e8$export$5a57f796673aabea;

});

parcelRegister("4iTbK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9hBBk = parcelRequire("9hBBk");


var $7JKd3 = parcelRequire("7JKd3");

function $c818d579c2a95bd2$export$d2a66369b43f5d65({ onClose: onClose, onOptionSelect: onOptionSelect, onRemixFlowActiveChange: onRemixFlowActiveChange, isEphemeralViewVisible: isEphemeralViewVisible = false, skipThinkingTypes: skipThinkingTypes, options: options, subtitle: subtitle, presentation: presentation = 'modal', trigger: trigger, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen = true, popupRepositionKey: popupRepositionKey }) {
    const [isThinking, setIsThinking] = (0, $42omo.useState)(false);
    const [selectedOptionType, setSelectedOptionType] = (0, $42omo.useState)();
    const handleOptionSelect = (0, $42omo.useCallback)((params)=>{
        if (!skipThinkingTypes?.has(params.type)) setIsThinking(true);
        setSelectedOptionType(params.type);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(params);
    }, [
        onOptionSelect,
        onRemixFlowActiveChange,
        skipThinkingTypes
    ]);
    const handleStopThinking = (0, $42omo.useCallback)(()=>{
        setIsThinking(false);
        onRemixFlowActiveChange?.(false);
    }, [
        onRemixFlowActiveChange
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isThinking) return;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') handleStopThinking();
            }
        });
    }, [
        isThinking,
        handleStopThinking
    ]);
    // In popup mode, the trigger must always be rendered so the popup can anchor to it.
    // The popup content visibility is controlled by isPopupOpen.
    if (presentation === 'popup' && trigger) {
        const showThinkingBar = isThinking && !isEphemeralViewVisible;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9hBBk.RemixPopup), {
                    isOpen: isPopupOpen && !isThinking,
                    onClose: onClose,
                    trigger: trigger,
                    placement: popupPlacement,
                    offset: popupOffset,
                    onOptionSelect: handleOptionSelect,
                    options: options,
                    subtitle: subtitle,
                    repositionKey: popupRepositionKey
                }),
                showThinkingBar && /*#__PURE__*/ (0, $l998X.jsx)((0, $7JKd3.RemixThinkingBar), {
                    onStop: handleStopThinking,
                    optionType: selectedOptionType
                })
            ]
        });
    }
    // Modal mode (default)
    // While thinking: show thinking bar only when ephemeral is not yet visible; otherwise show nothing
    if (isThinking) {
        if (!isEphemeralViewVisible) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7JKd3.RemixThinkingBar), {
            onStop: handleStopThinking,
            optionType: selectedOptionType
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hBBk.RemixOverlay), {
        onClose: onClose,
        onOptionSelect: handleOptionSelect,
        options: options,
        subtitle: subtitle
    });
}
module.exports["RemixContainer"] = $c818d579c2a95bd2$export$d2a66369b43f5d65;

});

parcelRegister("9hBBk", function(module, exports) {
$parcel$export(module.exports, "remixOverlayMessages", () => (parcelRequire("h9xA7")).default);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $fzqvY = parcelRequire("fzqvY");


var $cO1el = parcelRequire("cO1el");


var $euUgw = parcelRequire("euUgw");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $gj7hi = parcelRequire("gj7hi");


var $5nBzc = parcelRequire("5nBzc");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $6xdDU = parcelRequire("6xdDU");


var $4Gau4 = parcelRequire("4Gau4");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $9EtP6 = parcelRequire("9EtP6");


var $3gadb = parcelRequire("3gadb");


var $hKEhS = parcelRequire("hKEhS");


var $ks59b = parcelRequire("ks59b");


var $h9xA7 = parcelRequire("h9xA7");


var $gCqjE = parcelRequire("gCqjE");

const $adb20307aac79bd1$var$headerWrapperStyle = null;
const $adb20307aac79bd1$var$labsPositionStyle = null;
const $adb20307aac79bd1$var$headerIconWrapperStyle = null;
const $adb20307aac79bd1$var$subtitleStyle = null; // ── RemixSubTypeGrid styles ────────────────────────────────────────────────
const $adb20307aac79bd1$var$gridStyles = {
    grid: "_zulpu2gc _1e0c11p5 _yv0e1ezz _1bsb1osq",
    tile: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _1bah1h6o _4t3ickbl _bfhk1bhr _80omtlke _4cvx1v1w"
}; // ── RemixAccordionOption styles ────────────────────────────────────────────
const $adb20307aac79bd1$var$accordionStyles = {
    accordionWrapper: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq",
    accordionHeader: "_2rko1mok _189eidpf _1rjcu2gc _1bsb1osq _4t3ickbl _1e0c1txw _4cvr1h6o _1bah1yb4 _bfhksm61 _bozgu2gc _y4tiutpp _80omtlke _mizu1r31 _ra3xglyw _128m1o36",
    expandedContent: "_18zru2gc _85i5u2gc",
    iconContainer: "_2rko1mok _1rjc12x7 _18zr12x7 _1e0c116y _4cvr1h6o _1bah1h6o _bfhkhfxm",
    iconContainerGreen: "_2rko1mok _1rjc12x7 _18zr12x7 _1e0c116y _4cvr1h6o _1bah1h6o _bfhkhfxm",
    iconContainerTeal: "_2rko1mok _1rjc12x7 _18zr12x7 _1e0c116y _4cvr1h6o _1bah1h6o _bfhkhfxm",
    iconContainerPurple: "_2rko1mok _1rjc12x7 _18zr12x7 _1e0c116y _4cvr1h6o _1bah1h6o _bfhkhfxm",
    pickForMeWrapper: "_1q51u2gc"
};
const $adb20307aac79bd1$var$accordionCollapsedStyle = null;
const $adb20307aac79bd1$var$accordionExpandedStyle = null;
const $adb20307aac79bd1$var$revealContentStyle = null;
const $adb20307aac79bd1$var$pickForMeButtonStyle = null; // ── RemixOverlay styles ────────────────────────────────────────────────────
const $adb20307aac79bd1$var$modalContentWrapperStyle = null; // ── RemixPopup styles ──────────────────────────────────────────────────────
const $adb20307aac79bd1$var$popupStyles = {
    contentWrapper: "_1reo15vq _18m915vq _2rko1mok _1e0c1txw _2lx21bp4 _1bsbnklw _bfhkhfxm",
    header: "_18zrpxbi _1e0c1txw _4cvr1h6o _1bah1h6o _1q511ejb _85i5u2gc",
    body: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx21bp4"
};
const $adb20307aac79bd1$var$scrollableBodyStyle = null;
const $adb20307aac79bd1$var$remixStyles = {
    describeInputBorderWrapper: "_1bsb1osq _uwhke4h9 _15a5nqa1 _1i531l7x",
    describeInputWrapper: "_1rjcutpp _18zrpxbi _1bsb1osq _bfhkhfxm",
    describePromptRow: "_zulp12x7 _1e0c1txw _2lx2vrvc _4cvresu3 _1bsb1osq",
    describeTextAreaWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf",
    modalBodyPadding: "_18zrpxbi _1q511b66 _85i5pxbi",
    remixOptionsStack: "_1bsb1osq"
}; // ── RemixOverlayHeader ─────────────────────────────────────────────────────
function $adb20307aac79bd1$var$RemixOverlayHeader({ subtitle: subtitle }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const subtitleMessage = subtitle ?? (0, $h9xA7.default).subtitle;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.100",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: formatMessage((0, $h9xA7.default).labsLozengeTooltip),
                    position: "top",
                    children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                "_kqswstnw _154i1ff9 _1xi21ff9 _80om73ad"
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                                ...tooltipProps,
                                justifyContent: "end",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                    appearance: "new",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $h9xA7.default).labsLozenge
                                    })
                                })
                            })
                        })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "aria-hidden": "true",
                    className: (0, $gMc0m.default)([
                        "_kqswh2mm _1bsbvbgk _4t3ivbgk"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($hKEhS))),
                        alt: formatMessage((0, $h9xA7.default).remixIconAlt),
                        width: "64px"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    alignInline: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "large",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $h9xA7.default).heading
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                "_syaz1rpy"
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...subtitleMessage
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
} // ── RemixSubTypeGrid ───────────────────────────────────────────────────────
function $adb20307aac79bd1$var$RemixSubTypeGrid({ subTypes: subTypes, onSubTypeSelect: onSubTypeSelect }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $adb20307aac79bd1$var$gridStyles.grid,
        children: subTypes.map((subType)=>{
            const IconComponent = (0, $ks59b.SUB_TYPE_ICON_MAP)[subType.value];
            const label = formatMessage(subType.labelMessage);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: label,
                position: "top",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        ...tooltipProps,
                        xcss: $adb20307aac79bd1$var$gridStyles.tile,
                        onClick: ()=>onSubTypeSelect(subType.value),
                        testId: subType.testId,
                        "aria-label": label,
                        children: IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {}) : null
                    })
            }, subType.value);
        })
    });
} // ── RemixAccordionOption ───────────────────────────────────────────────────
const $adb20307aac79bd1$var$animationConfig = {
    duration: ()=>450
};
const $adb20307aac79bd1$var$iconContainerStyles = {
    green: $adb20307aac79bd1$var$accordionStyles.iconContainerGreen,
    teal: $adb20307aac79bd1$var$accordionStyles.iconContainerTeal,
    purple: $adb20307aac79bd1$var$accordionStyles.iconContainerPurple,
    default: $adb20307aac79bd1$var$accordionStyles.iconContainer
};
const $adb20307aac79bd1$var$renderOptionIcon = (option, alt)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: $adb20307aac79bd1$var$iconContainerStyles[option.iconBackgroundColor ?? 'default'],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
            src: option.icon,
            srcDark: option.iconDark,
            alt: alt
        })
    });
};
function $adb20307aac79bd1$var$RemixAccordionOption({ option: option, isExpanded: isExpanded, onToggle: onToggle, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const smoothResizer = (0, $4Gau4.useResizingHeight)($adb20307aac79bd1$var$animationConfig);
    const handleToggle = (0, $42omo.useCallback)(()=>{
        onToggle(option.type);
    }, [
        onToggle,
        option.type
    ]);
    const handleSubTypeSelect = (0, $42omo.useCallback)((subTypeValue)=>{
        onSubTypeSelect(option.type, subTypeValue);
    }, [
        onSubTypeSelect,
        option.type
    ]);
    const handlePickForMe = (0, $42omo.useCallback)(()=>{
        onPickForMe(option.type);
    }, [
        onPickForMe,
        option.type
    ]);
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu)));
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            isExpanded ? "_2rko1mok _bfhk1bhr" : "_v5641s6b _2rko1mok _bfhk1bhr _irr319i6 _1dbz130s"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: $adb20307aac79bd1$var$accordionStyles.accordionWrapper,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
                    xcss: $adb20307aac79bd1$var$accordionStyles.accordionHeader,
                    onClick: handleToggle,
                    testId: option.testId,
                    "aria-expanded": isExpanded,
                    "aria-label": formatMessage(option.labelMessage),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            alignItems: "center",
                            gap: "space.100",
                            children: [
                                $adb20307aac79bd1$var$renderOptionIcon(option, optionIconAlt),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "medium",
                                    children: formatMessage(option.labelMessage)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
                            label: "",
                            color: "var(--ds-icon, #292A2E)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    ref: smoothResizer.ref,
                    className: (0, $gMc0m.default)([
                        "_1reo15vq _18m915vq"
                    ]),
                    children: isExpanded && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: $adb20307aac79bd1$var$accordionStyles.expandedContent,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixSubTypeGrid, {
                                subTypes: option.subTypes,
                                onSubTypeSelect: handleSubTypeSelect
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $adb20307aac79bd1$var$accordionStyles.pickForMeWrapper,
                                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    className: (0, $gMc0m.default)([
                                        "_zs121mok _1q9ti7a9 _14hp1osq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "default",
                                        onClick: handlePickForMe,
                                        testId: `${option.testId}-pick-for-me`,
                                        children: formatMessage((0, $h9xA7.default).pickForMe)
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
const $adb20307aac79bd1$var$RemixFlatOption = ({ option: option, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        onSelect(option.type);
    }, [
        onSelect,
        option.type
    ]);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_v5641s6b _2rko1mok _bfhk1bhr _irr319i6 _1dbz130s"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            xcss: $adb20307aac79bd1$var$accordionStyles.accordionWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                xcss: $adb20307aac79bd1$var$accordionStyles.accordionHeader,
                onClick: handleClick,
                testId: option.testId,
                "aria-label": formatMessage(option.labelMessage),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    alignItems: "center",
                    gap: "space.100",
                    children: [
                        $adb20307aac79bd1$var$renderOptionIcon(option, optionIconAlt),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            weight: "medium",
                            children: formatMessage(option.labelMessage)
                        })
                    ]
                })
            })
        })
    });
};
/**
 * Shared inner content for both RemixOverlay (modal) and RemixPopup (popup).
 * Contains the remix options list, accordion, and describe input.
 */ function $adb20307aac79bd1$var$RemixOverlayContent({ onOptionSelect: onOptionSelect, options: options, subtitle: subtitle }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [describeValue, setDescribeValue] = (0, $42omo.useState)('');
    const [expandedOption, setExpandedOption] = (0, $42omo.useState)(null);
    const resolvedOptions = options ?? (0, $gCqjE.REMIX_OPTIONS);
    const handleDescribeSubmit = (0, $42omo.useCallback)(()=>{
        if (describeValue?.trim()) onOptionSelect?.({
            type: 'custom',
            userPrompt: describeValue
        });
    }, [
        describeValue,
        onOptionSelect
    ]);
    const handleDescribeKeyDown = (0, $42omo.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleDescribeSubmit();
        }
    }, [
        handleDescribeSubmit
    ]);
    const handleToggle = (0, $42omo.useCallback)((type)=>{
        setExpandedOption((prev)=>prev === type ? null : type);
    }, []);
    const handleSubTypeSelect = (0, $42omo.useCallback)((type, subType)=>{
        onOptionSelect?.({
            type: type,
            subType: subType
        });
    }, [
        onOptionSelect
    ]);
    const handlePickForMe = (0, $42omo.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _18m91wug"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $adb20307aac79bd1$var$remixStyles.modalBodyPadding,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        space: "space.100",
                        alignInline: "stretch",
                        xcss: $adb20307aac79bd1$var$remixStyles.remixOptionsStack,
                        children: resolvedOptions.map((option)=>option.subTypes.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixAccordionOption, {
                                option: option,
                                isExpanded: expandedOption === option.type,
                                onToggle: handleToggle,
                                onSubTypeSelect: handleSubTypeSelect,
                                onPickForMe: handlePickForMe
                            }, option.type) : /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixFlatOption, {
                                option: option,
                                onSelect: handlePickForMe
                            }, option.type))
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $adb20307aac79bd1$var$remixStyles.describeInputBorderWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $adb20307aac79bd1$var$remixStyles.describeInputWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                        onSubmit: handleDescribeSubmit,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            xcss: $adb20307aac79bd1$var$remixStyles.describePromptRow,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $adb20307aac79bd1$var$remixStyles.describeTextAreaWrapper,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                        appearance: "none",
                                        placeholder: formatMessage((0, $h9xA7.default).describePlaceholder),
                                        value: describeValue,
                                        onChange: (e)=>setDescribeValue(e.currentTarget.value),
                                        onKeyDown: handleDescribeKeyDown,
                                        isCompact: true,
                                        minimumRows: 1,
                                        maxHeight: "200px",
                                        resize: "smart",
                                        "aria-label": formatMessage((0, $h9xA7.default).describePlaceholder),
                                        testId: "remix-overlay-describe-input",
                                        name: "remix-overlay-describe"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    type: "submit",
                                    appearance: "primary",
                                    isDisabled: !describeValue?.trim(),
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
                                    label: formatMessage((0, $h9xA7.default).describeSubmitLabel),
                                    testId: "remix-overlay-describe-submit"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
} /**
   * RemixOverlay — centered ADS Modal presentation
   */ 
function $adb20307aac79bd1$export$48a746fedb7ffb({ onClose: onClose, onOptionSelect: onOptionSelect, options: options, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            onClose: onClose,
            width: 320,
            testId: "remix-overlay",
            shouldReturnFocus: false,
            autoFocus: false,
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _2rko1kw7 _1e0c1txw _2lx21bp4 _bfhkhfxm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        hasCloseButton: false,
                        children: /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixOverlayHeader, {
                            subtitle: subtitle
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                        hasInlinePadding: false,
                        children: /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixOverlayContent, {
                            onOptionSelect: onOptionSelect,
                            options: options,
                            subtitle: subtitle
                        })
                    })
                ]
            })
        })
    });
} /**
   * Calls the Popup `update` function to reposition the popup whenever `repositionKey` changes.
   */ 
function $adb20307aac79bd1$var$PopupRepositionOnKeyChange({ repositionKey: repositionKey, update: update }) {
    const prevKey = (0, $42omo.useRef)(repositionKey);
    (0, $42omo.useLayoutEffect)(()=>{
        if (prevKey.current !== repositionKey) {
            prevKey.current = repositionKey;
            update();
        }
    }, [
        repositionKey,
        update
    ]);
    return null;
} /**
   * RemixPopup — anchored ADS Popup presentation for contextual entry points (e.g. object-level sidebar).
   * No blanket, anchored to a trigger element.
   */ 
function $adb20307aac79bd1$export$a8b0b54f368ecbb0({ isOpen: isOpen, onClose: onClose, trigger: trigger, onOptionSelect: onOptionSelect, options: options, subtitle: subtitle, placement: placement = 'left-end', offset: offset = [
    8,
    16
], repositionKey: repositionKey }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: placement,
        offset: offset,
        label: "Remix",
        role: "dialog",
        content: ({ update: update })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$PopupRepositionOnKeyChange, {
                        repositionKey: repositionKey,
                        update: update
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: $adb20307aac79bd1$var$popupStyles.contentWrapper,
                        testId: "remix-popup",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $adb20307aac79bd1$var$popupStyles.header,
                                children: /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixOverlayHeader, {
                                    subtitle: subtitle
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $adb20307aac79bd1$var$popupStyles.body,
                                children: /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixOverlayContent, {
                                    onOptionSelect: onOptionSelect,
                                    options: options,
                                    subtitle: subtitle
                                })
                            })
                        ]
                    })
                ]
            }),
        trigger: (triggerProps)=>trigger(triggerProps)
    });
}
module.exports["RemixOverlay"] = $adb20307aac79bd1$export$48a746fedb7ffb;
module.exports["RemixPopup"] = $adb20307aac79bd1$export$a8b0b54f368ecbb0;

});

parcelRegister("4Gau4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7hpmn = parcelRequire("7hpmn");


var $ig6yX = parcelRequire("ig6yX");


var $4c48T = parcelRequire("4c48T");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $4QtAs = parcelRequire("4QtAs");

const $c747837ed372cb4a$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $4c48T.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $ig6yX.easeInOut) } = {})=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $c747837ed372cb4a$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $c747837ed372cb4a$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children(resizing)
    });
};
module.exports["useResizingHeight"] = $c747837ed372cb4a$export$da99457d6430d83;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("hKEhS", function(module, exports) {
module.exports = new URL("Remix-Illustration.7b8c03b3.svg", import.meta.url).toString();

});

parcelRegister("ks59b", function(module, exports) {
/* constants.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cOrQJ = parcelRequire("cOrQJ");


var $6yRkw = parcelRequire("6yRkw");


var $1UTwf = parcelRequire("1UTwf");


var $5lx52 = parcelRequire("5lx52");


var $ierY5 = parcelRequire("ierY5");


var $5lbk8 = parcelRequire("5lbk8");


var $gF767 = parcelRequire("gF767");


var $izHWc = parcelRequire("izHWc");


var $bPXPh = parcelRequire("bPXPh");


var $8RGsa = parcelRequire("8RGsa");


var $2D3Jd = parcelRequire("2D3Jd");


var $ar6wb = parcelRequire("ar6wb");


var $k2LbV = parcelRequire("k2LbV");


var $hJgiH = parcelRequire("hJgiH");


var $2ia9X = parcelRequire("2ia9X");


var $4oZFp = parcelRequire("4oZFp");


var $7HhWN = parcelRequire("7HhWN");


var $WuWCV = parcelRequire("WuWCV");


var $ao0K5 = parcelRequire("ao0K5");


var $bzbxZ = parcelRequire("bzbxZ");


var $8ecbd = parcelRequire("8ecbd");


var $fF2aS = parcelRequire("fF2aS");


var $9lEwL = parcelRequire("9lEwL");


var $kqIaN = parcelRequire("kqIaN");


var $cCmpe = parcelRequire("cCmpe");


var $40UoD = parcelRequire("40UoD");


var $kQWw1 = parcelRequire("kQWw1");


var $jKLit = parcelRequire("jKLit");


var $8S3cy = parcelRequire("8S3cy");


var $eMdco = parcelRequire("eMdco");


var $54k4v = parcelRequire("54k4v");


var $kgfu3 = parcelRequire("kgfu3");


var $cbrll = parcelRequire("cbrll");

const $ed507872123460ec$var$iconStyles = null;
const $ed507872123460ec$var$SubTypeIcon = ({ src: src, srcDark: srcDark, alt: alt })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const resolvedSrc = colorMode === 'dark' ? srcDark : src;
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        src: resolvedSrc,
        alt: alt,
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1osq _5ral1dfr _1e0c1ule"
        ])
    });
};
const $ed507872123460ec$export$e0452922cbc2989f = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cCmpe))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($bPXPh))),
        alt: "Line chart"
    });
const $ed507872123460ec$export$b08434c95e3df48d = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($WuWCV))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6yRkw))),
        alt: "Area chart"
    });
const $ed507872123460ec$export$472946dc5493045a = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ao0K5))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1UTwf))),
        alt: "Bar chart"
    });
const $ed507872123460ec$export$ccba00b0f4d667f3 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fF2aS))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5lbk8))),
        alt: "Funnel chart"
    });
const $ed507872123460ec$export$b86b18d4ddcc0181 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8S3cy))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($k2LbV))),
        alt: "Pie chart"
    });
const $ed507872123460ec$export$a95ef668d7975f40 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9lEwL))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gF767))),
        alt: "Gantt chart"
    }); // Diagrams
const $ed507872123460ec$export$4f7cb0192e7b1016 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($40UoD))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($8RGsa))),
        alt: "Mind map"
    });
const $ed507872123460ec$export$2df60ac16db5f072 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8ecbd))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($ierY5))),
        alt: "Flowchart"
    }); // Infographics
const $ed507872123460ec$export$77864082aab0bbe3 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kQWw1))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($2D3Jd))),
        alt: "Modern style"
    });
const $ed507872123460ec$export$b8c6412fcf2fe65d = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($54k4v))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($2ia9X))),
        alt: "Sketch style"
    }); // Visual aids
const $ed507872123460ec$export$c02ff6805d67acb2 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bzbxZ))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5lx52))),
        alt: "Flip cards"
    });
const $ed507872123460ec$export$368b8c86d4677a50 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMdco))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($hJgiH))),
        alt: "Quadrant"
    });
const $ed507872123460ec$export$23e94ddbc9d88fae = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cbrll))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7HhWN))),
        alt: "Tree map"
    });
const $ed507872123460ec$export$e5aa73ddcf9d62e8 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kgfu3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($4oZFp))),
        alt: "Timeline"
    });
const $ed507872123460ec$export$a18ea9af6c181602 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kqIaN))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($izHWc))),
        alt: "Geographical map"
    });
const $ed507872123460ec$export$84442c0324e009f8 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jKLit))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($ar6wb))),
        alt: "Org chart"
    }); /**
                                                                                                                * Maps each sub-type value to its icon component.
                                                                                                                * Used by the sub-type grid to render the correct icon for each tile.
                                                                                                                *
                                                                                                                * Typed as `Record<KnownSubType, …>` so a missing entry is a compile-time error.
                                                                                                                */ 
const $ed507872123460ec$export$ebd45e32b7708bfa = {
    // Charts
    'line-chart': $ed507872123460ec$export$e0452922cbc2989f,
    'area-chart': $ed507872123460ec$export$b08434c95e3df48d,
    'bar-chart': $ed507872123460ec$export$472946dc5493045a,
    'funnel-chart': $ed507872123460ec$export$ccba00b0f4d667f3,
    'pie-chart': $ed507872123460ec$export$b86b18d4ddcc0181,
    'gantt-chart': $ed507872123460ec$export$a95ef668d7975f40,
    // Diagrams
    mindmap: $ed507872123460ec$export$4f7cb0192e7b1016,
    flowchart: $ed507872123460ec$export$2df60ac16db5f072,
    // Infographics
    'corporate-modern': $ed507872123460ec$export$77864082aab0bbe3,
    'corporate-doodle': $ed507872123460ec$export$b8c6412fcf2fe65d,
    // Visual aids
    'flip-cards': $ed507872123460ec$export$c02ff6805d67acb2,
    quadrant: $ed507872123460ec$export$368b8c86d4677a50,
    'tree-map': $ed507872123460ec$export$23e94ddbc9d88fae,
    'horizontal-timeline': $ed507872123460ec$export$e5aa73ddcf9d62e8,
    map: $ed507872123460ec$export$a18ea9af6c181602,
    'org-chart': $ed507872123460ec$export$84442c0324e009f8
};
module.exports["SUB_TYPE_ICON_MAP"] = $ed507872123460ec$export$ebd45e32b7708bfa;

});

parcelRegister("6yRkw", function(module, exports) {
module.exports = new URL("area-chart.9c61b44f.svg", import.meta.url).toString();

});

parcelRegister("1UTwf", function(module, exports) {
module.exports = new URL("bar-chart.596ed727.svg", import.meta.url).toString();

});

parcelRegister("5lx52", function(module, exports) {
module.exports = new URL("flip-cards.de8fab25.svg", import.meta.url).toString();

});

parcelRegister("ierY5", function(module, exports) {
module.exports = new URL("flowchart.f4030091.svg", import.meta.url).toString();

});

parcelRegister("5lbk8", function(module, exports) {
module.exports = new URL("funnel-chart.67215b20.svg", import.meta.url).toString();

});

parcelRegister("gF767", function(module, exports) {
module.exports = new URL("gantt-chart.2691a11a.svg", import.meta.url).toString();

});

parcelRegister("izHWc", function(module, exports) {
module.exports = new URL("geographical-map.3fc41ac5.svg", import.meta.url).toString();

});

parcelRegister("bPXPh", function(module, exports) {
module.exports = new URL("line-chart.9a6e99c4.svg", import.meta.url).toString();

});

parcelRegister("8RGsa", function(module, exports) {
module.exports = new URL("mindmap.de7b9183.svg", import.meta.url).toString();

});

parcelRegister("2D3Jd", function(module, exports) {
module.exports = new URL("modern.70f1acdb.svg", import.meta.url).toString();

});

parcelRegister("ar6wb", function(module, exports) {
module.exports = new URL("org-chart.4a0eadaa.svg", import.meta.url).toString();

});

parcelRegister("k2LbV", function(module, exports) {
module.exports = new URL("pie-chart.2d6b1a6e.svg", import.meta.url).toString();

});

parcelRegister("hJgiH", function(module, exports) {
module.exports = new URL("quadrant.e36b83d3.svg", import.meta.url).toString();

});

parcelRegister("2ia9X", function(module, exports) {
module.exports = new URL("sketch.56fccc96.svg", import.meta.url).toString();

});

parcelRegister("4oZFp", function(module, exports) {
module.exports = new URL("timeline.1adead9c.svg", import.meta.url).toString();

});

parcelRegister("7HhWN", function(module, exports) {
module.exports = new URL("treemap.435237ac.svg", import.meta.url).toString();

});

parcelRegister("WuWCV", function(module, exports) {
module.exports = new URL("area-chart.f45617c6.svg", import.meta.url).toString();

});

parcelRegister("ao0K5", function(module, exports) {
module.exports = new URL("bar-chart.8bac9e33.svg", import.meta.url).toString();

});

parcelRegister("bzbxZ", function(module, exports) {
module.exports = new URL("flip-cards.82fad937.svg", import.meta.url).toString();

});

parcelRegister("8ecbd", function(module, exports) {
module.exports = new URL("flowchart.9978d7da.svg", import.meta.url).toString();

});

parcelRegister("fF2aS", function(module, exports) {
module.exports = new URL("funnel-chart.9ab1312c.svg", import.meta.url).toString();

});

parcelRegister("9lEwL", function(module, exports) {
module.exports = new URL("gantt-chart.7b05f7e6.svg", import.meta.url).toString();

});

parcelRegister("kqIaN", function(module, exports) {
module.exports = new URL("geographical-map.9ceeb1ee.svg", import.meta.url).toString();

});

parcelRegister("cCmpe", function(module, exports) {
module.exports = new URL("line-chart.781fb81c.svg", import.meta.url).toString();

});

parcelRegister("40UoD", function(module, exports) {
module.exports = new URL("mindmap.959cdeb5.svg", import.meta.url).toString();

});

parcelRegister("kQWw1", function(module, exports) {
module.exports = new URL("modern.3bc135bd.svg", import.meta.url).toString();

});

parcelRegister("jKLit", function(module, exports) {
module.exports = new URL("org-chart.64ceac30.svg", import.meta.url).toString();

});

parcelRegister("8S3cy", function(module, exports) {
module.exports = new URL("pie-chart.bfa5addf.svg", import.meta.url).toString();

});

parcelRegister("eMdco", function(module, exports) {
module.exports = new URL("quadrant.4231debc.svg", import.meta.url).toString();

});

parcelRegister("54k4v", function(module, exports) {
module.exports = new URL("sketch.64f6bd4e.svg", import.meta.url).toString();

});

parcelRegister("kgfu3", function(module, exports) {
module.exports = new URL("timeline.abfd0140.svg", import.meta.url).toString();

});

parcelRegister("cbrll", function(module, exports) {
module.exports = new URL("treemap.1d9c10d0.svg", import.meta.url).toString();

});

parcelRegister("h9xA7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $59c006c6ea12a553$var$messages = (0, $aXWIB.defineMessages)({
    // ── Header ──────────────────────────────────────────────────────────────
    heading: {
        id: "malleable-ui-components.remix.heading",
        defaultMessage: "Remix"
    },
    subtitle: {
        id: "malleable-ui-components.remix.subtitle",
        defaultMessage: "View this content in a new form"
    },
    labsLozenge: {
        id: "malleable-ui-components.remix.labs-lozenge",
        defaultMessage: "LABS"
    },
    labsLozengeTooltip: {
        id: "malleable-ui-components.remix.option.lozenge-tooltip",
        defaultMessage: "Beta: This feature is still in development."
    },
    remixIconAlt: {
        id: "malleable-ui-components.remix.icon-alt",
        defaultMessage: "Remix icon"
    },
    // ── Describe input ─────────────────────────────────────────────────────
    describePlaceholder: {
        id: "malleable-ui-components.remix.describe-placeholder",
        defaultMessage: "Or describe your remix..."
    },
    describeSubmitLabel: {
        id: "malleable-ui-components.remix.describe-submit-label",
        defaultMessage: "Submit"
    },
    // ── Top-level option labels ────────────────────────────────────────────
    remixOptionChart: {
        id: "malleable-ui-components.remix.option.chart",
        defaultMessage: "Chart"
    },
    remixOptionDiagram: {
        id: "malleable-ui-components.remix.option.diagram",
        defaultMessage: "Diagram"
    },
    remixOptionInfographic: {
        id: "malleable-ui-components.remix.option.infographic",
        defaultMessage: "Infographic"
    },
    remixOptionVisualization: {
        id: "malleable-ui-components.remix.option.visualization",
        defaultMessage: "Visualization"
    },
    // ── Top-level option icon alts ─────────────────────────────────────────
    chartIconAlt: {
        id: "malleable-ui-components.remix.option.chart-icon-alt",
        defaultMessage: "Chart icon"
    },
    diagramIconAlt: {
        id: "malleable-ui-components.remix.option.diagram-icon-alt",
        defaultMessage: "Diagram icon"
    },
    infographicIconAlt: {
        id: "malleable-ui-components.remix.option.infographic-icon-alt",
        defaultMessage: "Infographic icon"
    },
    visualizationIconAlt: {
        id: "malleable-ui-components.remix.option.visualization-icon-alt",
        defaultMessage: "Visualization icon"
    },
    // ── Top-level option tooltips ──────────────────────────────────────────
    chartTooltip: {
        id: "malleable-ui-components.remix.option.chart-tooltip",
        defaultMessage: "View your data as a chart or graph"
    },
    diagramTooltip: {
        id: "malleable-ui-components.remix.option.diagram-tooltip",
        defaultMessage: "Show relationships with a diagram"
    },
    infographicTooltip: {
        id: "malleable-ui-components.remix.option.infographic-tooltip",
        defaultMessage: "Summarize key points with an infographic"
    },
    visualizationTooltip: {
        id: "malleable-ui-components.remix.option.visualization-tooltip",
        defaultMessage: "Bring your content to life with a bespoke visual"
    },
    // ── Sub-type labels (charts) ───────────────────────────────────────────
    subTypeLineChart: {
        id: "malleable-ui-components.remix.sub-type.line-chart",
        defaultMessage: "Line chart"
    },
    subTypeAreaChart: {
        id: "malleable-ui-components.remix.sub-type.area-chart",
        defaultMessage: "Area chart"
    },
    subTypeBarChart: {
        id: "malleable-ui-components.remix.sub-type.bar-chart",
        defaultMessage: "Bar chart"
    },
    subTypeFunnelChart: {
        id: "malleable-ui-components.remix.sub-type.funnel-chart",
        defaultMessage: "Funnel chart"
    },
    subTypePieChart: {
        id: "malleable-ui-components.remix.sub-type.pie-chart",
        defaultMessage: "Pie chart"
    },
    subTypeGanttChart: {
        id: "malleable-ui-components.remix.sub-type.gantt-chart",
        defaultMessage: "Gantt chart"
    },
    // ── Sub-type labels (diagrams) ─────────────────────────────────────────
    subTypeMindMap: {
        id: "malleable-ui-components.remix.sub-type.mind-map",
        defaultMessage: "Mindmap"
    },
    subTypeFlowChart: {
        id: "malleable-ui-components.remix.sub-type.flow-chart",
        defaultMessage: "Flowchart"
    },
    // ── Sub-type labels (infographics) ─────────────────────────────────────
    subTypeModernStyle: {
        id: "malleable-ui-components.remix.sub-type.modern-style",
        defaultMessage: "Modern style"
    },
    subTypeSketchStyle: {
        id: "malleable-ui-components.remix.sub-type.sketch-style",
        defaultMessage: "Sketch style"
    },
    // ── Sub-type labels (visual aids) ──────────────────────────────────────
    subTypeFlipCard: {
        id: "malleable-ui-components.remix.sub-type.flip-card",
        defaultMessage: "Flip card"
    },
    subTypeQuadrant: {
        id: "malleable-ui-components.remix.sub-type.quadrant",
        defaultMessage: "Quadrant"
    },
    subTypeTreeMap: {
        id: "malleable-ui-components.remix.sub-type.tree-map",
        defaultMessage: "Tree map"
    },
    subTypeTimeline: {
        id: "malleable-ui-components.remix.sub-type.timeline",
        defaultMessage: "Timeline"
    },
    subTypeGeographicalMap: {
        id: "malleable-ui-components.remix.sub-type.geographical-map",
        defaultMessage: "Geographical map"
    },
    subTypeOrgChart: {
        id: "malleable-ui-components.remix.sub-type.org-chart",
        defaultMessage: "Org chart"
    },
    pageRemixSubtitle: {
        id: "malleable-ui-components.remix.page-remix-subtitle",
        defaultMessage: "Create content inspired by this work"
    },
    remixOptionSlides: {
        id: "malleable-ui-components.remix.option.slides",
        defaultMessage: "Slides"
    },
    remixOptionWhiteboard: {
        id: "malleable-ui-components.remix.option.whiteboard",
        defaultMessage: "Whiteboard"
    },
    remixOptionDatabase: {
        id: "malleable-ui-components.remix.option.database",
        defaultMessage: "Database"
    },
    slidesIconAlt: {
        id: "malleable-ui-components.remix.option.slides-icon-alt",
        defaultMessage: "Slides icon"
    },
    whiteboardIconAlt: {
        id: "malleable-ui-components.remix.option.whiteboard-icon-alt",
        defaultMessage: "Whiteboard icon"
    },
    databaseIconAlt: {
        id: "malleable-ui-components.remix.option.database-icon-alt",
        defaultMessage: "Database icon"
    },
    slidesTooltip: {
        id: "malleable-ui-components.remix.option.slides-tooltip",
        defaultMessage: "Transform your page into a slide deck"
    },
    whiteboardTooltip: {
        id: "malleable-ui-components.remix.option.whiteboard-tooltip",
        defaultMessage: "Visualize your page on a whiteboard"
    },
    databaseTooltip: {
        id: "malleable-ui-components.remix.option.database-tooltip",
        defaultMessage: "Structure your page content as a database"
    },
    // ── Pick for me ────────────────────────────────────────────────────────
    pickForMe: {
        id: "malleable-ui-components.remix.pick-for-me",
        defaultMessage: "Pick for me"
    },
    // ── Unused legacy keys kept for i18n backwards compat ──────────────────
    selectedContent: {
        id: "malleable-ui-components.remix.selected-content",
        defaultMessage: "Selected content"
    },
    noContent: {
        id: "malleable-ui-components.remix.no-content",
        defaultMessage: "No content selected"
    }
});
var $59c006c6ea12a553$export$2e2bcd8739ae039 = $59c006c6ea12a553$var$messages;
module.exports["default"] = $59c006c6ea12a553$export$2e2bcd8739ae039;

});

parcelRegister("gCqjE", function(module, exports) {

var $eXcS3 = parcelRequire("eXcS3");


var $6uOS4 = parcelRequire("6uOS4");


var $3GvsX = parcelRequire("3GvsX");


var $KX93L = parcelRequire("KX93L");


var $eJw33 = parcelRequire("eJw33");


var $j0i6b = parcelRequire("j0i6b");


var $iy5AO = parcelRequire("iy5AO");


var $ldlmH = parcelRequire("ldlmH");


var $3ArrK = parcelRequire("3ArrK");


var $ljWwX = parcelRequire("ljWwX");


var $k9bra = parcelRequire("k9bra");


var $6S5UT = parcelRequire("6S5UT");


var $g9DlN = parcelRequire("g9DlN");


var $kzXif = parcelRequire("kzXif");


var $h9xA7 = parcelRequire("h9xA7");

const $9c8cc259dbbf2fad$export$f0ba07b8deaf6c2d = [
    {
        type: 'chart',
        displayName: 'chart',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldlmH))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($eXcS3))),
        labelMessage: (0, $h9xA7.default).remixOptionChart,
        iconAltMessage: (0, $h9xA7.default).chartIconAlt,
        tooltipMessage: (0, $h9xA7.default).chartTooltip,
        testId: 'remix-overlay-option-chart',
        subTypes: [
            {
                value: 'line-chart',
                displayName: 'line chart',
                labelMessage: (0, $h9xA7.default).subTypeLineChart,
                testId: 'remix-sub-type-line-chart'
            },
            {
                value: 'area-chart',
                displayName: 'area chart',
                labelMessage: (0, $h9xA7.default).subTypeAreaChart,
                testId: 'remix-sub-type-area-chart'
            },
            {
                value: 'bar-chart',
                displayName: 'bar chart',
                labelMessage: (0, $h9xA7.default).subTypeBarChart,
                testId: 'remix-sub-type-bar-chart'
            },
            {
                value: 'funnel-chart',
                displayName: 'funnel chart',
                labelMessage: (0, $h9xA7.default).subTypeFunnelChart,
                testId: 'remix-sub-type-funnel-chart'
            },
            {
                value: 'pie-chart',
                displayName: 'pie chart',
                labelMessage: (0, $h9xA7.default).subTypePieChart,
                testId: 'remix-sub-type-pie-chart'
            },
            {
                value: 'gantt-chart',
                displayName: 'Gantt chart',
                labelMessage: (0, $h9xA7.default).subTypeGanttChart,
                testId: 'remix-sub-type-gantt-chart'
            }
        ]
    },
    {
        type: 'diagram',
        displayName: 'diagram',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljWwX))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($3GvsX))),
        labelMessage: (0, $h9xA7.default).remixOptionDiagram,
        iconAltMessage: (0, $h9xA7.default).diagramIconAlt,
        tooltipMessage: (0, $h9xA7.default).diagramTooltip,
        testId: 'remix-overlay-option-diagram',
        subTypes: [
            {
                value: 'mindmap',
                displayName: 'mind map',
                labelMessage: (0, $h9xA7.default).subTypeMindMap,
                testId: 'remix-sub-type-mindmap'
            },
            {
                value: 'flowchart',
                displayName: 'flowchart',
                labelMessage: (0, $h9xA7.default).subTypeFlowChart,
                testId: 'remix-sub-type-flowchart'
            }
        ]
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k9bra))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($KX93L))),
        labelMessage: (0, $h9xA7.default).remixOptionInfographic,
        iconAltMessage: (0, $h9xA7.default).infographicIconAlt,
        tooltipMessage: (0, $h9xA7.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: [
            {
                value: 'corporate-modern',
                displayName: 'modern style infographic',
                labelMessage: (0, $h9xA7.default).subTypeModernStyle,
                testId: 'remix-sub-type-corporate-modern'
            },
            {
                value: 'corporate-doodle',
                displayName: 'sketch style infographic',
                labelMessage: (0, $h9xA7.default).subTypeSketchStyle,
                testId: 'remix-sub-type-corporate-doodle'
            }
        ]
    },
    {
        type: 'visual-aid',
        displayName: 'visualization',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g9DlN))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($j0i6b))),
        labelMessage: (0, $h9xA7.default).remixOptionVisualization,
        iconAltMessage: (0, $h9xA7.default).visualizationIconAlt,
        tooltipMessage: (0, $h9xA7.default).visualizationTooltip,
        testId: 'remix-overlay-option-visual-aid',
        subTypes: [
            {
                value: 'flip-cards',
                displayName: 'flip card',
                labelMessage: (0, $h9xA7.default).subTypeFlipCard,
                testId: 'remix-sub-type-flip-cards'
            },
            {
                value: 'quadrant',
                displayName: 'quadrant',
                labelMessage: (0, $h9xA7.default).subTypeQuadrant,
                testId: 'remix-sub-type-quadrant'
            },
            {
                value: 'tree-map',
                displayName: 'tree map',
                labelMessage: (0, $h9xA7.default).subTypeTreeMap,
                testId: 'remix-sub-type-tree-map'
            },
            {
                value: 'horizontal-timeline',
                displayName: 'timeline',
                labelMessage: (0, $h9xA7.default).subTypeTimeline,
                testId: 'remix-sub-type-horizontal-timeline'
            },
            {
                value: 'map',
                displayName: 'map',
                labelMessage: (0, $h9xA7.default).subTypeGeographicalMap,
                testId: 'remix-sub-type-map'
            },
            {
                value: 'org-chart',
                displayName: 'org chart',
                labelMessage: (0, $h9xA7.default).subTypeOrgChart,
                testId: 'remix-sub-type-org-chart'
            }
        ]
    }
];
const $9c8cc259dbbf2fad$export$839e8948e17d6e68 = [
    {
        type: 'slides',
        displayName: 'slides',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6S5UT))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($eJw33))),
        labelMessage: (0, $h9xA7.default).remixOptionSlides,
        iconAltMessage: (0, $h9xA7.default).slidesIconAlt,
        tooltipMessage: (0, $h9xA7.default).slidesTooltip,
        testId: 'remix-overlay-option-slides',
        subTypes: [],
        iconBackgroundColor: 'green'
    },
    {
        type: 'whiteboard',
        displayName: 'whiteboard',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kzXif))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($iy5AO))),
        labelMessage: (0, $h9xA7.default).remixOptionWhiteboard,
        iconAltMessage: (0, $h9xA7.default).whiteboardIconAlt,
        tooltipMessage: (0, $h9xA7.default).whiteboardTooltip,
        testId: 'remix-overlay-option-whiteboard',
        subTypes: [],
        iconBackgroundColor: 'teal'
    },
    {
        type: 'database',
        displayName: 'database',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3ArrK))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($6uOS4))),
        labelMessage: (0, $h9xA7.default).remixOptionDatabase,
        iconAltMessage: (0, $h9xA7.default).databaseIconAlt,
        tooltipMessage: (0, $h9xA7.default).databaseTooltip,
        testId: 'remix-overlay-option-database',
        subTypes: [],
        iconBackgroundColor: 'purple'
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k9bra))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($KX93L))),
        labelMessage: (0, $h9xA7.default).remixOptionInfographic,
        iconAltMessage: (0, $h9xA7.default).infographicIconAlt,
        tooltipMessage: (0, $h9xA7.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: [
            {
                value: 'corporate-modern',
                displayName: 'modern style infographic',
                labelMessage: (0, $h9xA7.default).subTypeModernStyle,
                testId: 'remix-sub-type-corporate-modern'
            },
            {
                value: 'corporate-doodle',
                displayName: 'sketch style infographic',
                labelMessage: (0, $h9xA7.default).subTypeSketchStyle,
                testId: 'remix-sub-type-corporate-doodle'
            }
        ]
    }
];
const $9c8cc259dbbf2fad$var$ALL_OPTIONS = [
    ...$9c8cc259dbbf2fad$export$f0ba07b8deaf6c2d,
    ...$9c8cc259dbbf2fad$export$839e8948e17d6e68
];
function $9c8cc259dbbf2fad$export$b3104233810c1e93(typeValue) {
    const match = $9c8cc259dbbf2fad$var$ALL_OPTIONS.find((option)=>option.type === typeValue);
    return match?.displayName ?? typeValue.replace(/-/g, ' ');
}
function $9c8cc259dbbf2fad$export$ca76798d0446453(subTypeValue) {
    for (const option of $9c8cc259dbbf2fad$var$ALL_OPTIONS){
        const match = option.subTypes.find((st)=>st.value === subTypeValue);
        if (match) return match.displayName;
    }
    return subTypeValue.replace(/-/g, ' ');
}
module.exports["REMIX_OPTIONS"] = $9c8cc259dbbf2fad$export$f0ba07b8deaf6c2d;
module.exports["PAGE_REMIX_OPTIONS"] = $9c8cc259dbbf2fad$export$839e8948e17d6e68;
module.exports["getTypeDisplayName"] = $9c8cc259dbbf2fad$export$b3104233810c1e93;
module.exports["getSubTypeDisplayName"] = $9c8cc259dbbf2fad$export$ca76798d0446453;

});

parcelRegister("eXcS3", function(module, exports) {
module.exports = new URL("chart-icon-dark.ca77575e.svg", import.meta.url).toString();

});

parcelRegister("6uOS4", function(module, exports) {
module.exports = new URL("database-icon-dark.d75c616e.svg", import.meta.url).toString();

});

parcelRegister("3GvsX", function(module, exports) {
module.exports = new URL("diagram-icon-dark.3f4564aa.svg", import.meta.url).toString();

});

parcelRegister("KX93L", function(module, exports) {
module.exports = new URL("infographic-dark.f9711bcb.svg", import.meta.url).toString();

});

parcelRegister("eJw33", function(module, exports) {
module.exports = new URL("slides-icon-dark.9bd790a7.svg", import.meta.url).toString();

});

parcelRegister("j0i6b", function(module, exports) {
module.exports = new URL("visual-aid-dark.4d0ae5ae.svg", import.meta.url).toString();

});

parcelRegister("iy5AO", function(module, exports) {
module.exports = new URL("whiteboard-icon-dark.c314fae7.svg", import.meta.url).toString();

});

parcelRegister("ldlmH", function(module, exports) {
module.exports = new URL("chart-icon.a14be180.svg", import.meta.url).toString();

});

parcelRegister("3ArrK", function(module, exports) {
module.exports = new URL("database-icon.99f8adb3.svg", import.meta.url).toString();

});

parcelRegister("ljWwX", function(module, exports) {
module.exports = new URL("diagram-icon.695c35c3.svg", import.meta.url).toString();

});

parcelRegister("k9bra", function(module, exports) {
module.exports = new URL("infographic-light.59c85d21.svg", import.meta.url).toString();

});

parcelRegister("6S5UT", function(module, exports) {
module.exports = new URL("slides-icon.be4b1dd6.svg", import.meta.url).toString();

});

parcelRegister("g9DlN", function(module, exports) {
module.exports = new URL("visual-aid.4cbe3ad7.svg", import.meta.url).toString();

});

parcelRegister("kzXif", function(module, exports) {
module.exports = new URL("whiteboard-icon.d323ae09.svg", import.meta.url).toString();

});

parcelRegister("7JKd3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $5lVpa = parcelRequire("5lVpa");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $6UNNU = parcelRequire("6UNNU");


var $ckeTN = parcelRequire("ckeTN");

const $80dee16929296708$var$messages = (0, $aXWIB.defineMessages)({
    escHint: {
        id: "malleable-ui-components.remix-thinking-bar.esc-hint",
        defaultMessage: "Esc"
    },
    stopLabel: {
        id: "malleable-ui-components.remix-thinking-bar.stop-label",
        defaultMessage: "Stop remixing"
    },
    rovoIsThinking: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-remix",
        defaultMessage: "Structuring your remix"
    },
    designingRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-remix",
        defaultMessage: "Designing your remix"
    },
    addingItAllTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
/**
 * Interval in ms between each rotating thinking message step.
 */ const $80dee16929296708$var$ROTATION_INTERVAL_MS = 4000; /**
                                    * Hook that cycles through an ordered list of strings at a fixed interval,
                                    * advancing sequentially (not shuffled). Stays on the last item once exhausted.
                                    *
                                    * The `texts` array is treated as stable on mount — only the initial value is
                                    * used to set up the interval, so callers should ensure the array does not
                                    * change identity unnecessarily (e.g. by defining it outside the render or
                                    * memoising it).
                                    */ 
function $80dee16929296708$var$useSequentialText(texts) {
    const [index, setIndex] = (0, $42omo.useState)(0);
    const indexRef = (0, $42omo.useRef)(0); // Keep latest texts accessible inside the interval callback without
    // re-creating the interval on every render.
    const textsRef = (0, $42omo.useRef)(texts);
    textsRef.current = texts;
    (0, $42omo.useEffect)(()=>{
        if (textsRef.current.length <= 1) return;
        const interval = setInterval(()=>{
            const next = indexRef.current + 1;
            if (next < textsRef.current.length) {
                indexRef.current = next;
                setIndex(next);
            } else // Sequence exhausted — stay on the last message
            clearInterval(interval);
        }, $80dee16929296708$var$ROTATION_INTERVAL_MS);
        return ()=>clearInterval(interval); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Mount-only: the sequence is fixed for the lifetime of the component
    return textsRef.current[index] ?? textsRef.current[0] ?? '';
}
const $80dee16929296708$var$styles = {
    gradientWrapper: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _y44vh5ps _2rko1tm3 _kqsw1n9t _94n5pxbi _1ltv1b66 _1xi21b66 _1bsb1ns9 _1pbyni7l",
    gradientInner: "_2rko1kw7 _1rjcv77o _18zrv77o _bfhk1bhr _1y1m1ntv _16qs130s",
    fixedWrapper: "_2rko1tm3 _zulpu2gc _18zrpxbi _1rjcu2gc _1e0c1txw _4cvr1h6o _1bah1yb4 _1ul91kdj",
    escBadge: "_2rko12b0 _11c8wadc _18zr1b66 _1rjcv77o _bfhkysee _syaz1rpy"
};
function $80dee16929296708$export$d6f2d83daf5efc44({ onStop: onStop, optionType: _optionType }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const thinkingTexts = [
        formatMessage($80dee16929296708$var$messages.rovoIsThinking),
        formatMessage($80dee16929296708$var$messages.analyzingContent),
        formatMessage($80dee16929296708$var$messages.puttingPiecesTogether),
        formatMessage($80dee16929296708$var$messages.structuringRemix),
        formatMessage($80dee16929296708$var$messages.designingRemix),
        formatMessage($80dee16929296708$var$messages.addingItAllTogether),
        formatMessage($80dee16929296708$var$messages.applyingFinalTouches),
        formatMessage($80dee16929296708$var$messages.almostDone)
    ];
    const thinkingTitle = $80dee16929296708$var$useSequentialText(thinkingTexts);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- gradient background not expressible in cssMap
    , {
        style: {
            background: 'var(--rovo-gradient-background)'
        },
        "data-testid": "remix-thinking-bar-gradient-border",
        className: (0, $gMc0m.default)([
            $80dee16929296708$var$styles.gradientWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ckeTN.RovoGradientKeyframesStyle), {}),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $80dee16929296708$var$styles.gradientInner
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    as: "div",
                    xcss: $80dee16929296708$var$styles.fixedWrapper,
                    testId: "remix-thinking-bar",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6UNNU.RovoThinkingIndicator), {
                            title: thinkingTitle
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    as: "span",
                                    xcss: $80dee16929296708$var$styles.escBadge,
                                    children: formatMessage($80dee16929296708$var$messages.escHint)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    shape: "circle",
                                    onClick: onStop,
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lVpa))), {
                                            ...iconProps,
                                            color: "var(--ds-icon-danger, #C9372C)",
                                            label: ""
                                        }),
                                    label: formatMessage($80dee16929296708$var$messages.stopLabel)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
module.exports["RemixThinkingBar"] = $80dee16929296708$export$d6f2d83daf5efc44;

});

parcelRegister("6UNNU", function(module, exports) {
/* ThinkingIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $gdv5Z = parcelRequire("gdv5Z");


var $4enat = parcelRequire("4enat");


var $6nz1O = parcelRequire("6nz1O");


var $jNtYE = parcelRequire("jNtYE");


var $jHHqB = parcelRequire("jHHqB");

const $68998c8ef6b7e73e$var$styles = {
    root: "_4t3i1tcg _1e0c1txw _2lx2vrvc _1bah1e5h _1n261q9c _4cvr1h6o",
    iconContainer: "_zulpu2gc _2hwxv77o _1e0c1txw _4cvr1h6o",
    text: "_11c8fhey _syazi7uo _1nmz1hna",
    textNoWrap: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _o5721q9c",
    ellipsesContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $68998c8ef6b7e73e$var$getLoadingMorphingIcon = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jHHqB.MorphingShapeLoader), {
        testId: "morphing-loader"
    });
};
const $68998c8ef6b7e73e$var$getIcon = (icon)=>{
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(icon)) return icon;
    else if (icon) return /*#__PURE__*/ (0, $l998X.jsx)((0, $jNtYE.LazyAnimatedRovoIcon), {
        alt: "Rovo",
        testId: "rovo-loading-animation",
        width: "24px",
        height: "24px"
    });
    return null;
};
const $68998c8ef6b7e73e$export$cc468b3595726b51 = ({ title: title, isAnimated: isAnimated = true, icon: icon = true, animation: animation = false, showEllipsis: showEllipsis = true, testId: testId })=>{
    const enableAnimation = animation && (0, $c6GJD.default).getExperimentValue('rovo_chat_thinking_traces_improvements', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $68998c8ef6b7e73e$var$styles.root,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $68998c8ef6b7e73e$var$styles.iconContainer,
                children: [
                    enableAnimation ? $68998c8ef6b7e73e$var$getLoadingMorphingIcon() : $68998c8ef6b7e73e$var$getIcon(icon),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: showEllipsis ? $68998c8ef6b7e73e$var$styles.textNoWrap : $68998c8ef6b7e73e$var$styles.text,
                        children: enableAnimation ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4enat.ShimmerText), {
                            children: title
                        }) : title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $68998c8ef6b7e73e$var$styles.ellipsesContainer,
                children: showEllipsis && /*#__PURE__*/ (0, $l998X.jsx)((0, $6nz1O.EllipsesAnimation), {
                    isAnimated: isAnimated
                })
            })
        ]
    });
};
module.exports["RovoThinkingIndicator"] = $68998c8ef6b7e73e$export$cc468b3595726b51;

});

parcelRegister("4enat", function(module, exports) {
/* ShimmerText.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $iXCQx = parcelRequire("iXCQx");

const $dfdf02a47c71d931$var$shimmerAnimation = null;
const $dfdf02a47c71d931$var$shimmerGradient = null; /** Single-line ellipsis + flex/grid-safe width. */ 
const $dfdf02a47c71d931$var$truncateSingleLine = null;
const $dfdf02a47c71d931$export$f35c7d979dec8662 = ({ children: children, size: size = 'medium', weight: weight = 'regular', truncate: truncate = false })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_11q7gl65 _y44vgcf4 _1lrwm4tz _pjrq1kdv _oo9g1j28 _1y1m1kdv",
            truncate && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1ul9idpf _1bsb1osq _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: size,
            weight: weight,
            color: "color.text.subtlest",
            children: children
        })
    });
};
module.exports["ShimmerText"] = $dfdf02a47c71d931$export$f35c7d979dec8662;

});

parcelRegister("6nz1O", function(module, exports) {
/* EllipsesAnimation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $32fc58aca0fb1b9e$var$animation = null;
const $32fc58aca0fb1b9e$var$animation1 = null;
const $32fc58aca0fb1b9e$var$animation2 = null;
const $32fc58aca0fb1b9e$var$dot1 = null;
const $32fc58aca0fb1b9e$var$dot2 = null;
const $32fc58aca0fb1b9e$var$dot3 = null;
const $32fc58aca0fb1b9e$var$animatedOpacity = null;
const $32fc58aca0fb1b9e$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v1gpk",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v18gg",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44voqx9",
                    isAnimated && $32fc58aca0fb1b9e$var$animatedOpacity
                ]),
                d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
                fill: "#FCA700"
            })
        ]
    });
};
module.exports["EllipsesAnimation"] = $32fc58aca0fb1b9e$export$c0e6915bcce7d1d0;

});

parcelRegister("jNtYE", function(module, exports) {
/* LazyAnimatedRovoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $d19178c9b9dc2956$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("eOMI9")));
const $d19178c9b9dc2956$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($d19178c9b9dc2956$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $d19178c9b9dc2956$export$7ea4e54699cd5224;

});

parcelRegister("eOMI9", function(module, exports) {

let $ac9b85351e52bf24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac9b85351e52bf24$var$load("2MGzj").then(()=>parcelRequire('boWof'));

});

parcelRegister("jHHqB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4zBBx = parcelRequire("4zBBx");


var $5Z2H0 = parcelRequire("5Z2H0");

// Module-level state — persists the current frame across remounts
// so the morphing animation continues smoothly without restarting.
let $30495697657ad4f8$var$savedFrame = 0;
let $30495697657ad4f8$var$hasPlayedBefore = false;
const $30495697657ad4f8$var$CONTAINER_STYLE = {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible'
};
const $30495697657ad4f8$var$LOTTIE_WRAPPER_STYLE = {
    width: 16,
    height: 16
};
const $30495697657ad4f8$export$c07a397cf5c24cd8 = ({ testId: testId })=>{
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const currentRef = containerRef.current;
        if (!currentRef) return;
        const baseAnimationConfig = {
            container: currentRef,
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($5Z2H0))),
            renderer: 'svg',
            loop: true
        };
        let animationInstance;
        if ($30495697657ad4f8$var$hasPlayedBefore) {
            // Remount — resume from saved frame
            animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($4zBBx))).loadAnimation({
                ...baseAnimationConfig,
                autoplay: false
            });
            animationInstance.goToAndPlay($30495697657ad4f8$var$savedFrame, true);
        } else // First mount — start from scratch
        animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($4zBBx))).loadAnimation({
            ...baseAnimationConfig,
            autoplay: true
        });
        $30495697657ad4f8$var$hasPlayedBefore = true;
        return ()=>{
            // Save current frame before destroying
            $30495697657ad4f8$var$savedFrame = animationInstance.currentFrame;
            animationInstance.destroy();
        };
    }, []);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- static styles for lottie container
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: $30495697657ad4f8$var$CONTAINER_STYLE,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: $30495697657ad4f8$var$LOTTIE_WRAPPER_STYLE,
            ref: containerRef
        })
    }));
};
module.exports["MorphingShapeLoader"] = $30495697657ad4f8$export$c07a397cf5c24cd8;

});

parcelRegister("5Z2H0", function(module, exports) {
module.exports = JSON.parse("{\"v\":\"5.7.1\",\"fr\":30,\"ip\":0,\"op\":108,\"w\":100,\"h\":100,\"nm\":\"Shape Morph\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Morph Shape\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[90],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[180],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[360],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[450]}]},\"p\":{\"a\":0,\"k\":[50,50,0]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":0,\"k\":[100,100,100]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-50,-50],[-41.7,-50],[-33.3,-50],[-25,-50],[-16.700000000000003,-50],[-8.299999999999997,-50],[0,-50],[8.299999999999997,-50],[16.700000000000003,-50],[25,-50],[33.3,-50],[41.7,-50],[50,-50],[50,-41.7],[50,-33.3],[50,-25],[50,-16.700000000000003],[50,-8.299999999999997],[50,0],[50,8.299999999999997],[50,16.700000000000003],[50,25],[50,33.3],[50,41.7],[50,50],[41.7,50],[33.3,50],[25,50],[16.700000000000003,50],[8.299999999999997,50],[0,50],[-8.299999999999997,50],[-16.700000000000003,50],[-25,50],[-33.3,50],[-41.7,50],[-50,50],[-50,41.7],[-50,33.3],[-50,25],[-50,16.700000000000003],[-50,8.299999999999997],[-50,0],[-50,-8.299999999999997],[-50,-16.700000000000003],[-50,-25],[-50,-33.3],[-50,-41.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[5.3999999999999915,-46.9],[10.799999999999997,-43.7],[16.200000000000003,-40.6],[21.700000000000003,-37.5],[27.099999999999994,-34.4],[32.5,-31.2],[37.900000000000006,-28.1],[43.3,-25],[43.3,-18.7],[43.3,-12.5],[43.3,-6.200000000000003],[43.3,0],[43.3,6.299999999999997],[43.3,12.5],[43.3,18.799999999999997],[43.3,25],[37.900000000000006,28.099999999999994],[32.5,31.299999999999997],[27.099999999999994,34.400000000000006],[21.700000000000003,37.5],[16.200000000000003,40.599999999999994],[10.799999999999997,43.8],[5.3999999999999915,46.900000000000006],[0,50],[-5.399999999999999,46.900000000000006],[-10.799999999999997,43.8],[-16.200000000000003,40.599999999999994],[-21.699999999999996,37.5],[-27.1,34.400000000000006],[-32.5,31.299999999999997],[-37.9,28.099999999999994],[-43.3,25],[-43.3,18.799999999999997],[-43.3,12.5],[-43.3,6.299999999999997],[-43.3,0],[-43.3,-6.200000000000003],[-43.3,-12.5],[-43.3,-18.8],[-43.3,-25],[-37.9,-28.1],[-32.5,-31.3],[-27.1,-34.4],[-21.699999999999996,-37.5],[-16.200000000000003,-40.6],[-10.799999999999997,-43.7],[-5.399999999999999,-46.9]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[3.1000000000000014,-43.7],[6.299999999999997,-37.5],[9.399999999999999,-31.2],[12.5,-25],[15.599999999999994,-18.7],[18.799999999999997,-12.5],[21.900000000000006,-6.200000000000003],[25,0],[28.099999999999994,6.299999999999997],[31.299999999999997,12.5],[34.400000000000006,18.799999999999997],[37.5,25],[40.599999999999994,31.299999999999997],[43.8,37.5],[46.900000000000006,43.8],[50,50],[43.8,50],[37.5,50],[31.299999999999997,50],[25,50],[18.799999999999997,50],[12.5,50],[6.299999999999997,50],[0,50],[-6.200000000000003,50],[-12.5,50],[-18.7,50],[-25,50],[-31.2,50],[-37.5,50],[-43.7,50],[-50,50],[-46.9,43.8],[-43.7,37.5],[-40.6,31.299999999999997],[-37.5,25],[-34.4,18.799999999999997],[-31.2,12.5],[-28.1,6.299999999999997],[-25,0],[-21.9,-6.200000000000003],[-18.7,-12.5],[-15.600000000000001,-18.7],[-12.5,-25],[-9.399999999999999,-31.2],[-6.200000000000003,-37.5],[-3.1000000000000014,-43.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}]}]},\"nm\":\"Path\",\"mn\":\"ADBE Vector Shape - Group\"},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433]}]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100}}],\"nm\":\"Shape Group\",\"np\":3}],\"ip\":0,\"op\":108,\"st\":0,\"bm\":0}]}");

});

parcelRegister("ckeTN", function(module, exports) {
/**
 * Shared CSS constants for the Rovo animated gradient border.
 *
 * The conic gradient rotates via a CSS custom property (`--gradient-angle`)
 * animated with `@keyframes`. Because `@property` at-rules and `@keyframes`
 * cannot be expressed in `cssMap` / `xcss`, they are injected via `<style>`
 * tags by the components below.
 *
 * The gradient background itself is also set as a CSS custom property
 * (`--rovo-gradient-background`) so consumers can reference it without
 * importing a style value (which would violate no-imported-style-values).
 *
 * Usage in cssMap / style prop:
 *   background: 'var(--rovo-gradient-background)',
 *   animation: 'rovoGradientRotation linear 2s infinite',
 */ 
var $42omo = parcelRequire("42omo");

const $7edf7411c58d98c0$var$ROVO_GRADIENT_CSS = `
:root {
	--rovo-gradient-background: conic-gradient(
		from var(--gradient-angle, 45deg),
		#FCA700 10%,
		#6A9A23 30%,
		#6A9A23 50%,
		#1868DB 70%,
		#AF59E0 90%
	);
}

@property --gradient-angle {
	syntax: "<angle>";
	initial-value: 270deg;
	inherits: false;
}
`;
const $7edf7411c58d98c0$var$ROVO_GRADIENT_KEYFRAMES_CSS = `${$7edf7411c58d98c0$var$ROVO_GRADIENT_CSS}
@keyframes rovoGradientRotation {
	0% { --gradient-angle: 0deg; }
	100% { --gradient-angle: 360deg; }
}
`;
const $7edf7411c58d98c0$export$9a2aea8a6bcbd9f4 = ()=>// eslint-disable-next-line react/no-danger, @atlaskit/ui-styling-standard/no-global-styles -- @property for CSS custom property animation
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement('style', {
        dangerouslySetInnerHTML: {
            __html: $7edf7411c58d98c0$var$ROVO_GRADIENT_CSS
        }
    });
const $7edf7411c58d98c0$export$5df21a6b23721c17 = ()=>// eslint-disable-next-line react/no-danger, @atlaskit/ui-styling-standard/no-global-styles -- @property and @keyframes for CSS custom property animation
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement('style', {
        dangerouslySetInnerHTML: {
            __html: $7edf7411c58d98c0$var$ROVO_GRADIENT_KEYFRAMES_CSS
        }
    });
module.exports["RovoGradientPropertyStyle"] = $7edf7411c58d98c0$export$9a2aea8a6bcbd9f4;
module.exports["RovoGradientKeyframesStyle"] = $7edf7411c58d98c0$export$5df21a6b23721c17;

});

parcelRegister("aXWtB", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $35c87ab817b10787$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceConversationAssistantBundle'
    });
};

const $35c87ab817b10787$export$3ca68d91b1a1bca2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HQN7e",
    name: "ConfluenceConversationAssistant",
    loader: async ()=>(await (parcelRequire("kyOCB"))).ConfluenceConversationAssistant,
    loading: $35c87ab817b10787$var$createLoadingComponent
});
module.exports["ConfluenceConversationAssistant"] = $35c87ab817b10787$export$3ca68d91b1a1bca2;

});

parcelRegister("kyOCB", function(module, exports) {

let $ef7e3fffc9a53862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef7e3fffc9a53862$var$load("4pqtR"),
    $ef7e3fffc9a53862$var$load("5XqRg"),
    $ef7e3fffc9a53862$var$load("hogcU"),
    $ef7e3fffc9a53862$var$load("aoJPa")
]).then(()=>parcelRequire('kaQDe'));

});

parcelRegister("3rRes", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $er2Wy = parcelRequire("er2Wy");

const $b43257b5198523a8$export$cee0b7c2921c06e1 = (nodes)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        const filtered = (0, $6jPem.traverse)(node, {
            any: (adfNode)=>{
                if ((0, $er2Wy.isRemixRestrictedNodeType)(adfNode.type)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
module.exports["filterRemixFragmentNodes"] = $b43257b5198523a8$export$cee0b7c2921c06e1;

});

parcelRegister("er2Wy", function(module, exports) {
/**
 * Remix button visibility for Malleable Content. Canonical deny list and show rules.
 * Use with block-controls activeNode (or a full PM node) and these filters in both edit and view.
 */ 
var $l9G9n = parcelRequire("l9G9n");

const $9531e9c3be1ec0bb$export$d3f1ba79de0d4efe = [
    'mediaSingle',
    'media'
];
const $9531e9c3be1ec0bb$export$7004846771b000c0 = [
    'mediaSingle',
    'mediaGroup',
    'media',
    'image',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'embedCard',
    'blockCard',
    'inlineCard',
    'bodiedSyncBlock'
];
const $9531e9c3be1ec0bb$var$DENY_SET = new Set($9531e9c3be1ec0bb$export$7004846771b000c0);
const $9531e9c3be1ec0bb$export$bf9aef57175a93a2 = (nodeType)=>$9531e9c3be1ec0bb$var$DENY_SET.has(nodeType);
const $9531e9c3be1ec0bb$export$ff7e5ebac3487125 = (context)=>{
    const nodeType = context.node?.type?.name ?? context.nodeType;
    if (nodeType === undefined) return false;
    if ($9531e9c3be1ec0bb$export$bf9aef57175a93a2(nodeType)) return false;
    // With full node, also require non-empty (e.g. don't show Remix on empty paragraphs).
    // Exception: layoutSection is always remixable regardless of content — it can be empty
    // and the user should still be able to remix it to generate content.
    if (context.node !== undefined && nodeType !== 'layoutSection') return !(0, $l9G9n.isNodeEmpty)(context.node);
    return true;
};
module.exports["ASK_ROVO_MEDIA_NODE_TYPES"] = $9531e9c3be1ec0bb$export$d3f1ba79de0d4efe;
module.exports["REMIX_DENY_LIST_V1"] = $9531e9c3be1ec0bb$export$7004846771b000c0;
module.exports["isRemixRestrictedNodeType"] = $9531e9c3be1ec0bb$export$bf9aef57175a93a2;
module.exports["shouldShowRemixForSelectionContext"] = $9531e9c3be1ec0bb$export$ff7e5ebac3487125;

});

parcelRegister("fj6ez", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

function $738409fb11353f61$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $738409fb11353f61$var$rendererHighlightStyles = {
    name: "18r8tnl",
    styles: "::highlight(remix-thinking-renderer){background-color:var(--ds-background-accent-purple-subtler, #EED7FC);text-decoration:underline;text-decoration-style:dotted;text-decoration-thickness:var(--ds-space-025, 2px);text-decoration-color:var(--ds-border-accent-purple, #AF59E1);text-decoration-skip-ink:none;}"
};
const $738409fb11353f61$export$533b8d7a5499bf49 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: $738409fb11353f61$var$rendererHighlightStyles
    }));
};
module.exports["RendererRemixHighlightStyles"] = $738409fb11353f61$export$533b8d7a5499bf49;

});

parcelRegister("7eOZ4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $2O3ot = parcelRequire("2O3ot");


var $bPHr8 = parcelRequire("bPHr8");


var $jEzab = parcelRequire("jEzab");


var $9WfmN = parcelRequire("9WfmN");


var $aouqA = parcelRequire("aouqA");


var $cteoa = parcelRequire("cteoa");


var $gCqjE = parcelRequire("gCqjE");


var $3vCSA = parcelRequire("3vCSA");


var $3jwuS = parcelRequire("3jwuS");


var $jyA9t = parcelRequire("jyA9t");


var $ep3mz = parcelRequire("ep3mz");


var $ew8wg = parcelRequire("ew8wg");


var $6mKj3 = parcelRequire("6mKj3");

const $1e31de274ed01603$var$isActionComplete = (chatMessages)=>{
    // Scan backwards to find ACTION_COMPLETE in the latest turn.
    // If we encounter a HUMAN message first, that marks a turn boundary —
    // any ACTION_COMPLETE before it belongs to a previous turn.
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') return true;
        if ((0, $bPHr8.isStoreHuman)(message)) return false;
    }
    return false;
};
function $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages) {
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') return message.action ? (0, $3vCSA.isRemixGeneratedFlow)(message.action) : false;
    }
    return false;
}
const $1e31de274ed01603$var$isWhiteboardRemixActionKey = (key)=>key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
/**
 * True when the latest matching assistant action is a whiteboard create/update
 * and checks if the action is in the ACTION_PART streaming status.
 * (`MessageAction.status === 'streaming'`).
 */ const $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming = (chatMessages)=>(0, $cteoa.findLastAssistantAction)(chatMessages, (action)=>$1e31de274ed01603$var$isWhiteboardRemixActionKey(action.key) && action.status?.toLowerCase() === 'streaming') !== undefined;
const $1e31de274ed01603$export$cca9e2432f59b3f8 = ({ onActionReady: onActionReady } = {})=>{
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation, setSelectedConversation: setSelectedConversation } = (0, $aouqA.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $2O3ot.useStagingAreaActions)();
    const { preferences: preferences } = (0, $9WfmN.useUserPreferences)();
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { title: contentTitle } = (0, $ew8wg.usePageTitle)({
        contentId: contentId ?? ''
    });
    // Track the conversation ID created by this remix flow. Only when the
    // store's activeConversation matches this ID do we consider it "ours".
    // Stored as state so that setting it triggers a rerender, ensuring
    // derived values (activeRemixConversation, chatMessages, etc.) update
    // immediately rather than waiting for an external rerender.
    const [remixConversationId, setRemixConversationId] = (0, $42omo.useState)(undefined);
    const activeRemixConversation = activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const [chatMessages] = (0, $jEzab.useChatMessages)({
        conversationId: activeRemixConversation?.id ?? ''
    });
    // Extract the first StoreError from chatMessages so callers can surface
    // the specific Rovo error message as an experience attribute.
    const remixStoreError = chatMessages.find((message)=>(0, $bPHr8.isStoreError)(message)) ?? null;
    // Detect whether Rovo encountered an error while processing a remix request.
    // This covers ACTION_ERROR at any stage — both before the ephemeral preview
    // opens (during awaitingResponse) and while it is loading (during typingResponse).
    // Uses the same isStoreError check as the smart-creation staging area.
    const isRemixError = activeRemixConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    // Track whether the onActionReady callback has already been fired for the
    // current conversation to avoid duplicate invocations.
    const actionReadyFired = (0, $42omo.useRef)(false);
    // Reset the fired flag when the active remix conversation changes (new remix flow).
    const prevConversationId = (0, $42omo.useRef)(activeRemixConversation?.id);
    (0, $42omo.useEffect)(()=>{
        if (prevConversationId.current !== activeRemixConversation?.id) {
            actionReadyFired.current = false;
            prevConversationId.current = activeRemixConversation?.id;
        }
    }, [
        activeRemixConversation?.id
    ]);
    // Fire onActionReady when the appropriate message arrives:
    // - For whiteboard create/update: when the action is `streaming`.
    // - For all other actions: when ACTION_COMPLETE appears in chatMessages.
    (0, $42omo.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady) return;
        const whiteboardStreamingDetected = $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming(chatMessages);
        const actionCompleteDetected = $1e31de274ed01603$var$isActionComplete(chatMessages);
        if (whiteboardStreamingDetected || actionCompleteDetected) {
            actionReadyFired.current = true;
            onActionReady();
        }
    }, [
        chatMessages,
        onActionReady
    ]);
    const stopRemixing = (0, $42omo.useCallback)(()=>{
        abortRequests?.({
            conversationId: activeRemixConversation?.id
        });
    }, [
        abortRequests,
        activeRemixConversation?.id
    ]);
    const openAIFCStagingModal = (0, $42omo.useCallback)((options)=>{
        setForceSkipAutoConversationSelection(true);
        // Open the Confluence Smart Creation Modal with stagingAreaActive=true
        // to skip the prompt screen and go straight to the staging area preview.
        //
        // Only keep the ephemeral preview for remix-generated preview content.
        // The shared helper currently treats dynamic UI, image-based remix flows,
        // and remix-generated whiteboards/diagrams as ephemeral-preview candidates.
        // All other ACTION_PREPARE results should open the full AIFC modal.
        //
        // Pass forceFullModal: true to bypass this check
        const shouldUseEphemeralPreview = options?.forceFullModal ? false : $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages);
        openModal({
            entryPoint: 'dynamicUi',
            spaceKey: spaceKey ?? undefined,
            parentContent: contentId ? {
                id: contentId,
                title: contentTitle ?? '',
                contentType: contentType ?? 'page'
            } : undefined,
            stagingAreaActive: true,
            isFloating: shouldUseEphemeralPreview,
            shouldShowBackButton: false,
            ...activeRemixConversation?.id && (0, $6mKj3.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? {
                remixConversationId: activeRemixConversation.id
            } : {},
            content: contentId ? {
                id: contentId,
                type: contentType ?? 'page',
                subType: isLivePage ? 'live' : null
            } : undefined,
            // Pass a no-op submitCallback only for ephemeral (floating) previews to
            // prevent navigating away from the current page. For the full modal flow
            // (e.g. "Add to Confluence"), omit the callback so the default
            // handleSubmitSmartCreate handler runs and redirects to the newly created content.
            ...shouldUseEphemeralPreview ? {
                submitCallback: async ()=>{}
            } : {}
        });
    }, [
        openModal,
        spaceKey,
        contentId,
        contentType,
        contentTitle,
        isLivePage,
        activeRemixConversation?.id,
        setForceSkipAutoConversationSelection,
        chatMessages
    ]);
    const sendAIFCPrompt = (0, $42omo.useCallback)(async ({ userPrompt: userPrompt, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource })=>{
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $gCqjE.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $gCqjE.getTypeDisplayName)(dynamicUiType);
        const promptText = dynamicUiType === 'custom' ? userPrompt ?? defaultPromptText : `Remix the selected content as a ${selectedDisplayName}`;
        // Build the ADF DocNode prompt.
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        // Store the ID so we can identify this conversation as the active remix.
        setRemixConversationId(newConversationId);
        actionReadyFired.current = false;
        await createConversationOptimistically({
            id: newConversationId
        });
        // Send the message to Rovo
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                // Use the same source for follow-ups: Remix doesn't have a separate follow-up entry point, but the "viewed" AIMAU analytics event uses `followUpSource`.
                followUpSource: interactionSource
            },
            productKey: 'confluence',
            contentContext: 'staging-area',
            creationContextParams: {
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource,
                source: 'remix'
            }
        });
        // Store the prompt text for display in the staging area header.
        // Always show "Remix" regardless of the user's custom prompt.
        setPrompt('Remix');
        // Persist the dynamic UI context so the update flow can use
        // the original type/source when sending remix adjustment messages
        setDynamicUiContext(dynamicUiType, dynamicUiSource);
    }, [
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        preferences.storeUserMessages
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        remixStoreError: remixStoreError,
        openAIFCStagingModal: openAIFCStagingModal,
        closeAIFCStagingModal: closeModal,
        remixConversationId: remixConversationId,
        setSelectedConversation: setSelectedConversation
    };
};
module.exports["useRemixToAIFC"] = $1e31de274ed01603$export$cca9e2432f59b3f8;

});

parcelRegister("9WfmN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $cc6UM = parcelRequire("cc6UM");


var $1uunn = parcelRequire("1uunn");

const $326813fdf830e5de$export$205c270e325a7524 = (aaid)=>{
    const preferences = JSON.parse(localStorage.getItem((0, $cc6UM.LS_USER_PREFERENCES_KEY)) || '{}');
    return preferences[aaid];
};
const $326813fdf830e5de$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        preferences: {
            // ideally we want to set the preference in the react component because
            // FF evaluated in module level may not resolve to correct value during SSR
            // however because there is localStorage setting and `firstLoad`, it requires a bit of refactoring to do it
            // this feature is only needed for dogfooding, so may not worth the refactor
            storeUserMessages: (0, $c6GJD.default).initializeCalled() && (0, $c6GJD.default).checkGate('ai_mate_show_store_messages'),
            useEditorContext: true
        },
        firstLoad: true
    },
    actions: {
        updatePreferences: (data)=>({ setState: setState, getState: getState })=>{
                setState({
                    preferences: {
                        ...getState().preferences,
                        ...data
                    },
                    firstLoad: false
                });
            }
    }
});
const $326813fdf830e5de$var$useStore = (0, $9zUhf.createHook)($326813fdf830e5de$var$store);
const $326813fdf830e5de$export$b6472e0d8983f5f5 = ()=>{
    const { aaid: aaid } = (0, $1uunn.useProfileController)();
    const [{ preferences: preferences, firstLoad: firstLoad }, { updatePreferences: storeUpdatePreferences }] = $326813fdf830e5de$var$useStore();
    const updatePreferences = (0, $42omo.useCallback)((data)=>{
        if (!aaid) return;
        storeUpdatePreferences(data);
        localStorage.setItem((0, $cc6UM.LS_USER_PREFERENCES_KEY), JSON.stringify({
            [aaid]: {
                ...preferences,
                ...data
            }
        }));
    }, [
        aaid,
        preferences,
        storeUpdatePreferences
    ]);
    const setStoreUserMessages = (0, $42omo.useCallback)((storeUserMessages)=>{
        updatePreferences({
            storeUserMessages: storeUserMessages
        });
    }, [
        updatePreferences
    ]);
    const setUseEditorContext = (0, $42omo.useCallback)((useEditorContext)=>{
        updatePreferences({
            useEditorContext: useEditorContext
        });
    }, [
        updatePreferences
    ]);
    const setHasSeenFeedbackOptInPrompt = (0, $42omo.useCallback)((hasSeenFeedbackOptInPrompt)=>{
        updatePreferences({
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
        });
    }, [
        updatePreferences
    ]);
    (0, $42omo.useEffect)(()=>{
        if (aaid && firstLoad) {
            const preferences = $326813fdf830e5de$export$205c270e325a7524(aaid);
            if (preferences) updatePreferences(preferences);
        }
    }, [
        aaid,
        firstLoad,
        updatePreferences
    ]);
    return {
        preferences: preferences,
        setStoreUserMessages: setStoreUserMessages,
        setUseEditorContext: setUseEditorContext,
        setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt
    };
};
module.exports["useUserPreferences"] = $326813fdf830e5de$export$b6472e0d8983f5f5;

});

parcelRegister("cc6UM", function(module, exports) {
const $4c20625651a86f0f$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
module.exports["LS_USER_PREFERENCES_KEY"] = $4c20625651a86f0f$export$97d0beb2ccc70a4d;

});

parcelRegister("1uunn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $8gGM0 = parcelRequire("8gGM0");

const $90ef72367fab294b$var$fetchProfileData = (0, $2XqLN.default)(async ()=>{
    const data = await (0, $8gGM0.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email,
        organization: data.extended_profile?.organization
    };
});
const $90ef72367fab294b$export$3c814b55c7cbb1fb = (0, $42omo.createContext)(null);
const $90ef72367fab294b$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $90ef72367fab294b$export$68afc71177137005 = (preFetchedProfileData)=>{
    const [profileData, setProfileData] = (0, $42omo.useState)($90ef72367fab294b$var$emptyProfileData);
    const profileContextData = (0, $42omo.useContext)($90ef72367fab294b$export$3c814b55c7cbb1fb);
    (0, $42omo.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData(preFetchedProfileData);
        else if (profileContextData) setProfileData(profileContextData);
        else $90ef72367fab294b$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($90ef72367fab294b$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["useProfileController"] = $90ef72367fab294b$export$68afc71177137005;

});

parcelRegister("8gGM0", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $2f3ab166c93f3263$export$3e32638432616b6 = async ()=>{
    const response = await (0, $8Igpw.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $2f3ab166c93f3263$export$3e32638432616b6;

});

parcelRegister("aouqA", function(module, exports) {

var $ajfvU = parcelRequire("ajfvU");

function $79be80eb0ef13a18$export$5650c329b9f287fb() {
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $ajfvU.useChatStore)();
    const { createConversationOptimistically: createConversationOptimistically, setSelectedConversation: setSelectedConversation, sendMessage: sendMessage, abortRequests: abortRequests, seedConversation: seedConversation } = (0, $ajfvU.useChatStoreActions)();
    const activeConversation = conversations[currentConversationId];
    return {
        createConversationOptimistically: createConversationOptimistically,
        setSelectedConversation: setSelectedConversation,
        abortRequests: abortRequests,
        activeConversationId: currentConversationId,
        activeConversation: activeConversation,
        sendMessage: sendMessage,
        seedConversation: seedConversation,
        processConversationMessages: $ajfvU.processConversationMessages
    };
}
module.exports["useSmartCreationChatStoreApi"] = $79be80eb0ef13a18$export$5650c329b9f287fb;

});

parcelRegister("3vCSA", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $fgOJ7 = parcelRequire("fgOJ7");


var $l30d8 = parcelRequire("l30d8");


var $eL1ct = parcelRequire("eL1ct");


var $6nGJw = parcelRequire("6nGJw");

function $0c322a09d1b57883$export$a4068a52445901dc(data, props) {
    return data !== null && typeof data === 'object' && props.every((prop)=>data.hasOwnProperty(prop));
}
const $0c322a09d1b57883$export$740b9b28cb05ebd6 = 'dynamic-ui-create';
function $0c322a09d1b57883$export$6da360af78d7e3dd(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'id'
    ]);
}
function $0c322a09d1b57883$export$da7aa926fc604bd7(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'id',
        'previousMauiId',
        'contentType'
    ]) && data.previousMauiId != null;
}
function $0c322a09d1b57883$export$3147e11228ebc102(action) {
    return $0c322a09d1b57883$export$6da360af78d7e3dd(action.data);
}
const $0c322a09d1b57883$export$440c8d4309cb1c9 = (data)=>{
    if (data?.id) return `${window.location.origin}/remix/ui/${encodeURIComponent(data.id)}`;
    return null;
};
const $0c322a09d1b57883$export$4a9884303bce30ff = 'image-create';
function $0c322a09d1b57883$export$ce86c52462376ef2(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'mediaFileId'
    ]);
}
function $0c322a09d1b57883$export$3b2fa4f5aa307773(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'mediaFileId',
        'previousMediaFileId',
        'mediaCollection'
    ]) && data.previousMediaFileId != null;
}
function $0c322a09d1b57883$export$ef033f677befc7d4(action) {
    return action.key === $0c322a09d1b57883$export$4a9884303bce30ff && $0c322a09d1b57883$export$ce86c52462376ef2(action.data);
}
const $0c322a09d1b57883$var$MEDIA_BASE_URL_STAGING = 'https://media.staging.atl-paas.net';
const $0c322a09d1b57883$var$MEDIA_BASE_URL_PROD = 'https://media-cdn.atlassian.com';
const $0c322a09d1b57883$export$4e8e610ccc58ae5b = ({ fileId: fileId, token: token, collection: collection, clientId: clientId, isStaging: isStaging })=>{
    const baseUrl = isStaging ? $0c322a09d1b57883$var$MEDIA_BASE_URL_STAGING : $0c322a09d1b57883$var$MEDIA_BASE_URL_PROD;
    const url = new URL(`${baseUrl}/file/${fileId}/image`);
    url.searchParams.set('token', token);
    url.searchParams.set('issuer', 'micros/convo-ai');
    url.searchParams.set('collection', collection);
    url.searchParams.set('client', clientId);
    return url.toString();
};
const $0c322a09d1b57883$export$7afb9b8acd50eb4e = 'aifc-confluence-page-create';
function $0c322a09d1b57883$export$77c5629325e9aaaf(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'adf' in data && 'contentId' in data;
}
const $0c322a09d1b57883$export$b632d4bc1af2f7d3 = 'aifc-deep-research-confluence-page-create';
function $0c322a09d1b57883$export$3bd74956949aecbc(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'content' in data && 'contentId' in data;
}
function $0c322a09d1b57883$export$d6ad19367a51fe7a(data) {
    return typeof data === 'object' && data !== null && 'contentId' in data;
}
const $0c322a09d1b57883$export$88028308fe524b8a = 'aifc-confluence-page-update';
const $0c322a09d1b57883$export$bb3d6eff667f4678 = 'aifc-adf-update';
const $0c322a09d1b57883$export$7cca3e34118747ef = 'aifc-action-classification-metadata';
function $0c322a09d1b57883$export$4f41f9d38097cf0a(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
function $0c322a09d1b57883$export$1cf42b66f457bc6c(data) {
    return typeof data === 'object' && data !== null && 'toolCalls' in data && 'contentId' in data && typeof data.toolCalls === 'string' && typeof data.contentId === 'string';
}
function $0c322a09d1b57883$export$fbc8213fc156433a(data) {
    return typeof data === 'object' && data !== null && 'promptVersion' in data && typeof data.promptVersion === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$279c9cc61f7f510a = 'aifc-confluence-whiteboard-create';
function $0c322a09d1b57883$export$392158ed2444b56b(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$823e13f43093123d = 'aifc-confluence-slides-create';
function $0c322a09d1b57883$export$ae4ad515c9dd259d(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$49b21a7401bcc85 = 'aifc-confluence-slides-update';
function $0c322a09d1b57883$export$3d6de0a3c3e39cbf(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$d5d2204eeb3fde50 = 'aifc-confluence-whiteboard-update';
function $0c322a09d1b57883$export$35d2029c1a7b307c(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$771989b0afde4911 = 'aifc-confluence-whiteboard-to-page';
const $0c322a09d1b57883$export$325918e7af3a74aa = 'confluence-whiteboard-brainstorming';
function $0c322a09d1b57883$export$48e8bcda6802129c(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$e3c19505945cf210 = 'confluence-whiteboard-diagramming';
const $0c322a09d1b57883$export$c8f288feec1641d9 = 'aifc-confluence-whiteboard-diagramming';
function $0c322a09d1b57883$export$f3a918f4f62365b2(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'diagramType' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$9f1bd612d6abcf5c = 'aifc-confluence-database-create';
function $0c322a09d1b57883$export$4dec930442f5ade2(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$ee0a705006a79cfe = 'aifc-confluence-database-update';
function $0c322a09d1b57883$export$dbed60ca289ab1f3(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
const $0c322a09d1b57883$export$691e9b05e574e32c = 'aifc-confluence-space-create';
function $0c322a09d1b57883$export$545244afe3ae2546(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $0c322a09d1b57883$export$af91dd9bf235f890 = 'aifc-confluence-space-update';
function $0c322a09d1b57883$export$38f648644a8b3072(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $0c322a09d1b57883$export$9f62c3ae716c44b2 = new Set([
    $0c322a09d1b57883$export$7afb9b8acd50eb4e,
    $0c322a09d1b57883$export$771989b0afde4911,
    $0c322a09d1b57883$export$b632d4bc1af2f7d3
]);
const $0c322a09d1b57883$export$aba0c096f5cdcaca = new Set([
    $0c322a09d1b57883$export$279c9cc61f7f510a
]);
const $0c322a09d1b57883$export$b9c5aef93dba02df = new Set([
    $0c322a09d1b57883$export$823e13f43093123d
]);
const $0c322a09d1b57883$export$45a7157715c10f20 = new Set([
    $0c322a09d1b57883$export$9f1bd612d6abcf5c
]);
const $0c322a09d1b57883$var$SPACE_CREATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$691e9b05e574e32c
]);
const $0c322a09d1b57883$var$CREATABLE_ACTION_KEYS = new Set([
    ...$0c322a09d1b57883$export$9f62c3ae716c44b2,
    ...$0c322a09d1b57883$export$aba0c096f5cdcaca,
    ...$0c322a09d1b57883$export$b9c5aef93dba02df,
    ...$0c322a09d1b57883$export$45a7157715c10f20,
    ...$0c322a09d1b57883$var$SPACE_CREATE_ACTIONS
]);
const $0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$88028308fe524b8a,
    $0c322a09d1b57883$export$bb3d6eff667f4678,
    $0c322a09d1b57883$export$740b9b28cb05ebd6,
    $0c322a09d1b57883$export$4a9884303bce30ff
]);
const $0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$d5d2204eeb3fde50,
    $0c322a09d1b57883$export$325918e7af3a74aa,
    $0c322a09d1b57883$export$e3c19505945cf210,
    $0c322a09d1b57883$export$c8f288feec1641d9
]);
const $0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$49b21a7401bcc85
]);
const $0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$ee0a705006a79cfe
]);
const $0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$af91dd9bf235f890
]);
const $0c322a09d1b57883$var$UPDATABLE_ACTION_KEYS = new Set([
    ...$0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS
]);
const $0c322a09d1b57883$export$6c0ed26dac146a75 = (action)=>$0c322a09d1b57883$export$9f62c3ae716c44b2.has(action.key);
const $0c322a09d1b57883$export$eac4577c3e50732a = (action)=>$0c322a09d1b57883$var$CREATABLE_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$a70db46a9e5e9e4a = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) && !!action.data?.metadata?.isExistingContent && (0, $dh538.fg)('confluence_aifc_create_on_existing');
const $0c322a09d1b57883$export$79fc6c76b9755410 = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) && !$0c322a09d1b57883$export$a70db46a9e5e9e4a(action);
const $0c322a09d1b57883$export$53f0114d9f187b14 = (action)=>action.key === $0c322a09d1b57883$export$740b9b28cb05ebd6;
const $0c322a09d1b57883$export$b3dfc475c0b1ff86 = (action)=>action.key === $0c322a09d1b57883$export$4a9884303bce30ff;
const $0c322a09d1b57883$export$dfda1ac7e19cab7b = (action)=>$0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$dcbfc8a9b613cd00 = (action)=>$0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$5d2d4e8984b13e00 = (action)=>$0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$399c9116e9984ca3 = (action)=>$0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$73dc9ed6ed2373f = (action)=>$0c322a09d1b57883$var$UPDATABLE_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$54716060fc6e52ee = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) || $0c322a09d1b57883$export$73dc9ed6ed2373f(action);
// ============================================================================
// CONFLUENCE PREVIEW CARDS
// ============================================================================
const $0c322a09d1b57883$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    $0c322a09d1b57883$export$7afb9b8acd50eb4e,
    $0c322a09d1b57883$export$b632d4bc1af2f7d3,
    $0c322a09d1b57883$export$279c9cc61f7f510a,
    $0c322a09d1b57883$export$823e13f43093123d,
    $0c322a09d1b57883$export$771989b0afde4911,
    $0c322a09d1b57883$export$9f1bd612d6abcf5c
]);
const $0c322a09d1b57883$export$5cb5e5f4b4ce0a33 = (action)=>$0c322a09d1b57883$var$PREVIEW_CARD_ACTION_KEYS.has(action.key) && !$0c322a09d1b57883$export$a70db46a9e5e9e4a(action);
const $0c322a09d1b57883$export$681cf9ea58de88fd = (action, selectedPreviewContentId)=>{
    if (!action?.key) return;
    switch(action.key){
        case $0c322a09d1b57883$export$279c9cc61f7f510a:
            return (0, $6nGJw.getConfluenceWhiteboardClientId)(selectedPreviewContentId);
        case $0c322a09d1b57883$export$823e13f43093123d:
        case $0c322a09d1b57883$export$49b21a7401bcc85:
            return (0, $l30d8.getConfluenceSlidesClientId)(selectedPreviewContentId);
        case $0c322a09d1b57883$export$9f1bd612d6abcf5c:
            return (0, $fgOJ7.getConfluenceDatabaseClientId)(selectedPreviewContentId);
        default:
            return (0, $eL1ct.getConfluenceEditorClientId)(selectedPreviewContentId);
    }
};
const $0c322a09d1b57883$export$bb9f6b0763834612 = (action)=>{
    const actionKey = action.key;
    if ($0c322a09d1b57883$export$9f62c3ae716c44b2.has(actionKey) || $0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-page';
    if ($0c322a09d1b57883$export$aba0c096f5cdcaca.has(actionKey) || $0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS.has(actionKey)) return 'confluence-whiteboard';
    if ($0c322a09d1b57883$export$b9c5aef93dba02df.has(actionKey) || $0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS.has(actionKey)) return 'confluence-slide';
    if ($0c322a09d1b57883$export$45a7157715c10f20.has(actionKey) || $0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-database';
    if ($0c322a09d1b57883$var$SPACE_CREATE_ACTIONS.has(actionKey) || $0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-space';
    return undefined;
};
// This mapping should contain the type guards of those actions that support data
// accumulation as defined below in `getPrimaryAccumulatedValue`.
const $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS = {
    [$0c322a09d1b57883$export$7afb9b8acd50eb4e]: $0c322a09d1b57883$export$77c5629325e9aaaf,
    [$0c322a09d1b57883$export$b632d4bc1af2f7d3]: $0c322a09d1b57883$export$3bd74956949aecbc,
    [$0c322a09d1b57883$export$9f1bd612d6abcf5c]: $0c322a09d1b57883$export$4dec930442f5ade2,
    [$0c322a09d1b57883$export$279c9cc61f7f510a]: $0c322a09d1b57883$export$392158ed2444b56b,
    [$0c322a09d1b57883$export$823e13f43093123d]: $0c322a09d1b57883$export$ae4ad515c9dd259d
};
const $0c322a09d1b57883$export$b95f9369e33f3b4a = (key)=>{
    return key in $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS;
};
const $0c322a09d1b57883$export$898d9c03b4eb5dd5 = (key)=>{
    return $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS[key];
};
const $0c322a09d1b57883$export$240debd921ff9f65 = (action)=>{
    if (!action.data) return undefined;
    if (action.key === $0c322a09d1b57883$export$7afb9b8acd50eb4e && $0c322a09d1b57883$export$77c5629325e9aaaf(action.data)) {
        const key = 'adf';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$b632d4bc1af2f7d3 && $0c322a09d1b57883$export$3bd74956949aecbc(action.data)) {
        const key = 'content';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$279c9cc61f7f510a && $0c322a09d1b57883$export$392158ed2444b56b(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$823e13f43093123d && $0c322a09d1b57883$export$ae4ad515c9dd259d(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$9f1bd612d6abcf5c && $0c322a09d1b57883$export$4dec930442f5ade2(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    }
    return undefined;
};
const $0c322a09d1b57883$var$getAccumulatedData = (prevAction, nextAction)=>{
    const prevPrimary = $0c322a09d1b57883$export$240debd921ff9f65(prevAction);
    const nextPrimary = $0c322a09d1b57883$export$240debd921ff9f65(nextAction);
    if (!prevPrimary || !nextPrimary || prevPrimary.key !== nextPrimary.key) return undefined;
    return {
        [nextPrimary.key]: String(prevPrimary.value ?? '') + String(nextPrimary.value ?? '')
    };
};
function $0c322a09d1b57883$export$5b30faa0f696991d(data) {
    return typeof data === 'object' && data !== null && 'isRemixGenerated' in data && data.isRemixGenerated === true;
}
const $0c322a09d1b57883$var$REMIX_GENERATED_ACTION_KEYS = new Set([
    $0c322a09d1b57883$export$740b9b28cb05ebd6,
    $0c322a09d1b57883$export$4a9884303bce30ff
]);
function $0c322a09d1b57883$export$8eb2b74d04c8d455(action) {
    if ($0c322a09d1b57883$var$REMIX_GENERATED_ACTION_KEYS.has(action.key)) return true;
    if (action.key === $0c322a09d1b57883$export$279c9cc61f7f510a || action.key === $0c322a09d1b57883$export$d5d2204eeb3fde50) return $0c322a09d1b57883$export$5b30faa0f696991d(action.data);
    return false;
}
function $0c322a09d1b57883$export$31b2392386905e76(action) {
    if (!action) return undefined;
    const { key: key, data: data } = action;
    if ($0c322a09d1b57883$export$da7aa926fc604bd7(data)) return 'edit';
    if ($0c322a09d1b57883$export$6da360af78d7e3dd(data)) return 'create';
    if ($0c322a09d1b57883$export$3b2fa4f5aa307773(data)) return 'edit';
    if ($0c322a09d1b57883$export$ce86c52462376ef2(data)) return 'create';
    if (key === $0c322a09d1b57883$export$d5d2204eeb3fde50) return 'edit';
    if (key === $0c322a09d1b57883$export$279c9cc61f7f510a) return 'create';
    return undefined;
}
function $0c322a09d1b57883$export$a549b965e1dff398(action) {
    if (action?.key === $0c322a09d1b57883$export$4a9884303bce30ff) return 'infographic';
    if (action?.data?.type === 'whiteboard') return 'diagram';
    return action?.data?.contentType;
}
function $0c322a09d1b57883$export$ff1c2950f6d5486f(action) {
    return {
        metadataActionKey: action?.key,
        metadataActionType: $0c322a09d1b57883$export$31b2392386905e76(action),
        dynamicUIType: $0c322a09d1b57883$export$a549b965e1dff398(action),
        dynamicUISubType: action?.data?.dynamicUiSubtype
    };
}
const $0c322a09d1b57883$export$64e13fa6a74f5f86 = (prevAction, nextAction)=>{
    if (prevAction.data && nextAction.data) {
        const accumulatedData = $0c322a09d1b57883$var$getAccumulatedData(prevAction, nextAction);
        if (accumulatedData !== undefined) {
            const updatedData = {
                ...nextAction.data,
                ...accumulatedData
            };
            return {
                ...prevAction,
                data: updatedData,
                status: nextAction.status
            };
        }
    }
    return {
        ...prevAction,
        data: nextAction.data,
        status: nextAction.status
    };
};
module.exports["DYNAMIC_UI_CREATE_KEY"] = $0c322a09d1b57883$export$740b9b28cb05ebd6;
module.exports["isDynamicUiCreateData"] = $0c322a09d1b57883$export$6da360af78d7e3dd;
module.exports["isDynamicUiUpdateActionData"] = $0c322a09d1b57883$export$da7aa926fc604bd7;
module.exports["isDynamicUiCreateAction"] = $0c322a09d1b57883$export$3147e11228ebc102;
module.exports["buildDynamicUiPageUrl"] = $0c322a09d1b57883$export$440c8d4309cb1c9;
module.exports["IMAGE_CREATE_KEY"] = $0c322a09d1b57883$export$4a9884303bce30ff;
module.exports["isImageCreateData"] = $0c322a09d1b57883$export$ce86c52462376ef2;
module.exports["isImageUpdateActionData"] = $0c322a09d1b57883$export$3b2fa4f5aa307773;
module.exports["isImageCreateAction"] = $0c322a09d1b57883$export$ef033f677befc7d4;
module.exports["buildImageUrl"] = $0c322a09d1b57883$export$4e8e610ccc58ae5b;
module.exports["CONFLUENCE_AIFC_PAGE_CREATE_KEY"] = $0c322a09d1b57883$export$7afb9b8acd50eb4e;
module.exports["isConfluenceAIFCPageCreateActionData"] = $0c322a09d1b57883$export$77c5629325e9aaaf;
module.exports["CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY"] = $0c322a09d1b57883$export$b632d4bc1af2f7d3;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionData"] = $0c322a09d1b57883$export$3bd74956949aecbc;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionPrepare"] = $0c322a09d1b57883$export$d6ad19367a51fe7a;
module.exports["AIFC_ADF_UPDATE_KEY"] = $0c322a09d1b57883$export$bb3d6eff667f4678;
module.exports["AIFC_ACTION_CLASSIFICATION_METADATA"] = $0c322a09d1b57883$export$7cca3e34118747ef;
module.exports["isAIFCADFUpdateActionData"] = $0c322a09d1b57883$export$1cf42b66f457bc6c;
module.exports["isAIFCADFSetActionClassificationActionData"] = $0c322a09d1b57883$export$fbc8213fc156433a;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY"] = $0c322a09d1b57883$export$279c9cc61f7f510a;
module.exports["isConfluenceAIFCWhiteboardCreateActionData"] = $0c322a09d1b57883$export$392158ed2444b56b;
module.exports["CONFLUENCE_AIFC_SLIDES_CREATE_KEY"] = $0c322a09d1b57883$export$823e13f43093123d;
module.exports["isConfluenceAIFCSlidesCreateActionData"] = $0c322a09d1b57883$export$ae4ad515c9dd259d;
module.exports["CONFLUENCE_AIFC_SLIDES_UPDATE_KEY"] = $0c322a09d1b57883$export$49b21a7401bcc85;
module.exports["isConfluenceAIFCSlidesUpdateActionData"] = $0c322a09d1b57883$export$3d6de0a3c3e39cbf;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY"] = $0c322a09d1b57883$export$d5d2204eeb3fde50;
module.exports["isConfluenceAIFCWhiteboardUpdateActionData"] = $0c322a09d1b57883$export$35d2029c1a7b307c;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY"] = $0c322a09d1b57883$export$771989b0afde4911;
module.exports["CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY"] = $0c322a09d1b57883$export$325918e7af3a74aa;
module.exports["isConfluenceWhiteboardBrainstormingActionData"] = $0c322a09d1b57883$export$48e8bcda6802129c;
module.exports["LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $0c322a09d1b57883$export$e3c19505945cf210;
module.exports["AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $0c322a09d1b57883$export$c8f288feec1641d9;
module.exports["isConfluenceWhiteboardDiagrammingActionData"] = $0c322a09d1b57883$export$f3a918f4f62365b2;
module.exports["CONFLUENCE_AIFC_DATABASE_CREATE_KEY"] = $0c322a09d1b57883$export$9f1bd612d6abcf5c;
module.exports["isConfluenceAIFCDatabaseCreateActionData"] = $0c322a09d1b57883$export$4dec930442f5ade2;
module.exports["CONFLUENCE_AIFC_DATABASE_UPDATE_KEY"] = $0c322a09d1b57883$export$ee0a705006a79cfe;
module.exports["isConfluenceAIFCDatabaseUpdateActionData"] = $0c322a09d1b57883$export$dbed60ca289ab1f3;
module.exports["CONFLUENCE_AIFC_SPACE_CREATE_KEY"] = $0c322a09d1b57883$export$691e9b05e574e32c;
module.exports["isConfluenceAIFCSpaceCreateActionData"] = $0c322a09d1b57883$export$545244afe3ae2546;
module.exports["CONFLUENCE_AIFC_SPACE_UPDATE_KEY"] = $0c322a09d1b57883$export$af91dd9bf235f890;
module.exports["isConfluenceAIFCSpaceUpdateActionData"] = $0c322a09d1b57883$export$38f648644a8b3072;
module.exports["PAGE_CREATE_ACTIONS"] = $0c322a09d1b57883$export$9f62c3ae716c44b2;
module.exports["WHITEBOARD_CREATE_ACTIONS"] = $0c322a09d1b57883$export$aba0c096f5cdcaca;
module.exports["SLIDES_CREATE_ACTIONS"] = $0c322a09d1b57883$export$b9c5aef93dba02df;
module.exports["DATABASE_CREATE_ACTIONS"] = $0c322a09d1b57883$export$45a7157715c10f20;
module.exports["isConfluencePageCreateAction"] = $0c322a09d1b57883$export$6c0ed26dac146a75;
module.exports["isConfluenceCreatableAction"] = $0c322a09d1b57883$export$eac4577c3e50732a;
module.exports["isConfluenceCreateNewAction"] = $0c322a09d1b57883$export$79fc6c76b9755410;
module.exports["isDynamicUiCreatableAction"] = $0c322a09d1b57883$export$53f0114d9f187b14;
module.exports["isImageCreatableAction"] = $0c322a09d1b57883$export$b3dfc475c0b1ff86;
module.exports["isConfluencePageUpdateAction"] = $0c322a09d1b57883$export$dfda1ac7e19cab7b;
module.exports["isConfluenceWhiteboardUpdateAction"] = $0c322a09d1b57883$export$dcbfc8a9b613cd00;
module.exports["isConfluenceDatabaseUpdateAction"] = $0c322a09d1b57883$export$399c9116e9984ca3;
module.exports["isConfluenceUpdatableAction"] = $0c322a09d1b57883$export$73dc9ed6ed2373f;
module.exports["isConfluenceStreamAction"] = $0c322a09d1b57883$export$54716060fc6e52ee;
module.exports["isConfluencePreviewCardAction"] = $0c322a09d1b57883$export$5cb5e5f4b4ce0a33;
module.exports["generateRovoReceiverId"] = $0c322a09d1b57883$export$681cf9ea58de88fd;
module.exports["getConfluenceContentType"] = $0c322a09d1b57883$export$bb9f6b0763834612;
module.exports["isAccumulatedAction"] = $0c322a09d1b57883$export$b95f9369e33f3b4a;
module.exports["getAccumulatedActionTypeGuard"] = $0c322a09d1b57883$export$898d9c03b4eb5dd5;
module.exports["getPrimaryAccumulatedValue"] = $0c322a09d1b57883$export$240debd921ff9f65;
module.exports["isRemixGeneratedAction"] = $0c322a09d1b57883$export$5b30faa0f696991d;
module.exports["isRemixGeneratedFlow"] = $0c322a09d1b57883$export$8eb2b74d04c8d455;
module.exports["getRemixMetadata"] = $0c322a09d1b57883$export$ff1c2950f6d5486f;
module.exports["customActionUpdater"] = $0c322a09d1b57883$export$64e13fa6a74f5f86;

});

parcelRegister("l30d8", function(module, exports) {

var $b9NdB = parcelRequire("b9NdB");

const $9036d8afa9b2002b$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX = 'confluence-slide';
const $9036d8afa9b2002b$export$8ad4475ac322bb70 = (contentId)=>(0, $b9NdB.client)(`${$9036d8afa9b2002b$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX}-${contentId}`);
module.exports["getConfluenceSlidesClientId"] = $9036d8afa9b2002b$export$8ad4475ac322bb70;

});

parcelRegister("jNS1v", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5ae98e04c533e5e9$var$HIGHLIGHT_NAME = 'remix-thinking-renderer';
const $5ae98e04c533e5e9$export$443e8aeb4c392a84 = ()=>{
    const savedRangeRef = (0, $42omo.useRef)(null);
    const [isHighlighting, setIsHighlighting] = (0, $42omo.useState)(false);
    const startHighlight = (0, $42omo.useCallback)(()=>{
        const sel = document.getSelection();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
        const range = sel.getRangeAt(0).cloneRange();
        savedRangeRef.current = range;
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) {
            const highlight = new Highlight(range);
            CSS.highlights.set($5ae98e04c533e5e9$var$HIGHLIGHT_NAME, highlight);
            sel.removeAllRanges();
            setIsHighlighting(true);
        }
    }, []);
    const clearHighlight = (0, $42omo.useCallback)(()=>{
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) CSS.highlights.delete($5ae98e04c533e5e9$var$HIGHLIGHT_NAME);
        savedRangeRef.current = null;
        setIsHighlighting(false);
    }, []);
    return {
        startHighlight: startHighlight,
        clearHighlight: clearHighlight,
        isHighlighting: isHighlighting,
        savedRange: savedRangeRef
    };
};
module.exports["useRendererRemixHighlight"] = $5ae98e04c533e5e9$export$443e8aeb4c392a84;

});

parcelRegister("3b5i6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $jQW4q = parcelRequire("jQW4q");


var $7ERUE = parcelRequire("7ERUE");

var $kDB94 = parcelRequire("kDB94");

var $iIVVb = parcelRequire("iIVVb");

const $62937d50f24b4234$var$messages = (0, $aXWIB.defineMessages)({
    remixInProgressTooltip: {
        id: "highlight-actions.remix-action.in-progress-tooltip",
        defaultMessage: "Remix in progress..."
    },
    remixToolbarTooltip: {
        id: "highlight-actions.remix-action.toolbar-tooltip",
        defaultMessage: "Remix"
    },
    remixToolbarLabel: {
        id: "highlight-actions.remix-action.toolbar-label",
        defaultMessage: "Remix"
    },
    remixDisabledTooltipArchived: {
        id: "highlight-actions.remix-action.disabled-tooltip-archived",
        defaultMessage: "Content on archived pages can't be remixed"
    },
    remixDisabledTooltipVersionHistory: {
        id: "highlight-actions.remix-action.disabled-tooltip-version-history",
        defaultMessage: "Remix is unavailable in version history"
    }
});
const $62937d50f24b4234$var$getRemixDisabledTooltip = (formatMessage, reason)=>{
    switch(reason){
        case 'version-history':
            return formatMessage($62937d50f24b4234$var$messages.remixDisabledTooltipVersionHistory);
        case 'archived':
        default:
            return formatMessage($62937d50f24b4234$var$messages.remixDisabledTooltipArchived);
    }
};
const $62937d50f24b4234$export$750386901eee7bd0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { isNewToolbarEnabled: isNewToolbarEnabled, onClick: onClick, isDisabled: isDisabled, isRemixInProgress: isRemixInProgress, remixDisabledReason: remixDisabledReason } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== isDisabled || $[2] !== isRemixInProgress || $[3] !== remixDisabledReason) {
        t1 = isRemixInProgress ? formatMessage($62937d50f24b4234$var$messages.remixInProgressTooltip) : isDisabled ? $62937d50f24b4234$var$getRemixDisabledTooltip(formatMessage, remixDisabledReason) : formatMessage($62937d50f24b4234$var$messages.remixToolbarTooltip);
        $[0] = formatMessage;
        $[1] = isDisabled;
        $[2] = isRemixInProgress;
        $[3] = remixDisabledReason;
        $[4] = t1;
    } else t1 = $[4];
    const tooltipContent = t1;
    let t2;
    if ($[5] !== isDisabled || $[6] !== isNewToolbarEnabled || $[7] !== isRemixInProgress || $[8] !== onClick || $[9] !== tooltipContent) {
        t2 = isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
                label: "",
                size: "small"
            }),
            testId: "highlight-actions-remix",
            onClick: onClick,
            isDisabled: isDisabled || isRemixInProgress
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
            testId: "highlight-actions-remix",
            onClick: onClick,
            isDisabled: isDisabled || isRemixInProgress
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)));
        $[5] = isDisabled;
        $[6] = isNewToolbarEnabled;
        $[7] = isRemixInProgress;
        $[8] = onClick;
        $[9] = tooltipContent;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ isNewToolbarEnabled: isNewToolbarEnabled, onClick: onClick, isDisabled: isDisabled, isRemixInProgress: isRemixInProgress, remixDisabledReason: remixDisabledReason })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const tooltipContent = isRemixInProgress ? formatMessage($62937d50f24b4234$var$messages.remixInProgressTooltip) : isDisabled ? $62937d50f24b4234$var$getRemixDisabledTooltip(formatMessage, remixDisabledReason) : formatMessage($62937d50f24b4234$var$messages.remixToolbarTooltip);
    return isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            label: "",
            size: "small"
        }),
        testId: "highlight-actions-remix",
        onClick: onClick,
        isDisabled: isDisabled || isRemixInProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
        testId: "highlight-actions-remix",
        onClick: onClick,
        isDisabled: isDisabled || isRemixInProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)));
};
module.exports["RemixAction"] = $62937d50f24b4234$export$750386901eee7bd0;

});

parcelRegister("jQW4q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7739ad8bf36e5bd9a55f1766d10483c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e73feb3a782b379c$var$_react = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("42omo")));

var $e73feb3a782b379c$var$_baseNew = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e73feb3a782b379c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Remix with Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e73feb3a782b379c$var$AiGenerativeRemixIcon = (props)=>/*#__PURE__*/ $e73feb3a782b379c$var$_react.default.createElement($e73feb3a782b379c$var$_baseNew.default, Object.assign({
        name: "AiGenerativeRemixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="M15.78 3.72a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM6 4.25a.75.75 0 0 1-.49.71l-1.1.4a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.41 0l-.4-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.48-.59L0 4.25l.01-.12a.75.75 0 0 1 .48-.59l1.1-.4a.5.5 0 0 0 .3-.3l.4-1.1.05-.11A.75.75 0 0 1 3 1.24l.12.01a.75.75 0 0 1 .54.38l.05.11.4 1.1c.05.14.16.25.3.3l1.1.4a.75.75 0 0 1 .49.71"/>`
    }, props));
$e73feb3a782b379c$var$AiGenerativeRemixIcon.displayName = 'AiGenerativeRemixIcon';
var $e73feb3a782b379c$var$_default = module.exports.default = $e73feb3a782b379c$var$AiGenerativeRemixIcon;

});

parcelRegister("dnbZ2", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $2a69d40b2e0abea7$export$4739f60b2e0ffe71 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoLLMEnabled && (0, $6mKj3.isExperimentEnabled)('cc-maui-experiment');
};
module.exports["useIsRemixAvailable"] = $2a69d40b2e0abea7$export$4739f60b2e0ffe71;

});

parcelRegister("6W81y", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $dAYOx = parcelRequire("dAYOx");


var $g5gZt = parcelRequire("g5gZt");


var $2qVkt = parcelRequire("2qVkt");


var $7ZcJJ = parcelRequire("7ZcJJ");


var $inPa6 = parcelRequire("inPa6");


var $1pSma = parcelRequire("1pSma");


var $iu6m9 = parcelRequire("iu6m9");


var $2GVu1 = parcelRequire("2GVu1");






var $fYQcF = parcelRequire("fYQcF");


var $jln20 = parcelRequire("jln20");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $frJep = parcelRequire("frJep");


var $cSSgB = parcelRequire("cSSgB");


var $ai7NK = parcelRequire("ai7NK");


var $9wGTI = parcelRequire("9wGTI");


var $cAdj8 = parcelRequire("cAdj8");


var $4VJDS = parcelRequire("4VJDS");


var $6mKj3 = parcelRequire("6mKj3");


var $2W2Mk = parcelRequire("2W2Mk");


var $joYQz = parcelRequire("joYQz");

const $ae4b6329110effd0$export$67bda1dbd5f0074c = {
    SINGLE_ISSUE: 'SINGLE_ISSUE',
    MULTIPLE_ISSUE: 'MULTIPLE_ISSUE',
    AI_ISSUE: 'AI_ISSUE'
};
// Helper function to find the parent <table> element of a given node
const $ae4b6329110effd0$var$findParentTable = (node)=>{
    let currentNode = node;
    while(currentNode){
        if (currentNode.nodeType === Node.ELEMENT_NODE && currentNode.tagName === 'TABLE') return currentNode;
        currentNode = currentNode.parentNode;
    }
    return null;
};
// Use this helper function when we have the modernized bulk create ready.
const $ae4b6329110effd0$var$isMultiRowTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Helper function to find the parent <tr> element of a given node
    const findParentTableRow = (node)=>{
        while(node){
            if (node.tagName === 'TR') return node;
            node = node.parentNode;
        }
        return null;
    };
    // Find the closest <tr> ancestor for both start and end of the selection
    const startRow = findParentTableRow(startContainer);
    const endRow = findParentTableRow(endContainer);
    if (!startRow || !endRow) return false;
    // If the start and end are not in the same row, it's a multi-row selection
    return startRow !== endRow;
};
/**
 * isTableSelection: returns true if the user highlights over only
 * table content.
 * @param selection
 * @returns {boolean}
 */ const $ae4b6329110effd0$var$isTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Check if both the start and end container are within a table
    const startInTable = $ae4b6329110effd0$var$findParentTable(startContainer) !== null;
    const endInTable = $ae4b6329110effd0$var$findParentTable(endContainer) !== null;
    return startInTable && endInTable;
};
const $ae4b6329110effd0$export$50d84a2be082120 = (selection)=>{
    if (!selection || selection.rangeCount === 0) return 0;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return 0;
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    const startInActionContainer = (0, $cSSgB.findActionItemElement)(startContainer);
    const endInActionContainer = (0, $cSSgB.findActionItemElement)(endContainer);
    let commonAncestor;
    if (startInActionContainer || endInActionContainer) {
        const actionItemRange = range.cloneRange();
        actionItemRange.setStart(startInActionContainer || startContainer, 0);
        actionItemRange.setEnd(endInActionContainer || endContainer, 0);
        commonAncestor = actionItemRange.commonAncestorContainer;
    } else // the selection might span across different containers
    // or be in between the start and end highlight
    commonAncestor = range.commonAncestorContainer;
    const walker = document.createTreeWalker(commonAncestor, NodeFilter.SHOW_ELEMENT, null);
    let node = walker.currentNode;
    let actionItemsInSelection = 0;
    while(node){
        if (range.intersectsNode(node)) {
            const element = node;
            if (element.dataset?.taskLocalId !== undefined) actionItemsInSelection++;
        }
        node = walker.nextNode();
    }
    return actionItemsInSelection;
};
const $ae4b6329110effd0$var$getIssueCreationType = ({ isAIIssueCreationEnabled: isAIIssueCreationEnabled })=>{
    if (isAIIssueCreationEnabled) return $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE;
    else return $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE;
};
const $ae4b6329110effd0$var$userHasEditPermission = (pageInfo)=>{
    if (!pageInfo) return false;
    const contentType = pageInfo.type;
    return pageInfo.operations?.some((op)=>op?.operation === 'update' && op?.targetType === contentType) || false;
};
const $ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows } = t0;
    let t1;
    let t2;
    if ($[0] !== completeKey || $[1] !== handleCreateIssueItemClicked || $[2] !== isAIIssueCreationEnabled || $[3] !== isSelectionMultipleRows) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
                isAIIssueCreationEnabled: isAIIssueCreationEnabled
            });
            const getIcon = (iconProps)=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
                    ...iconProps,
                    label: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
                    ...iconProps,
                    label: ""
                });
            };
            const getIconAIFC = (iconProps_0)=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
                    ...iconProps_0,
                    size: "small",
                    label: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
                    ...iconProps_0,
                    size: "small",
                    label: ""
                });
            };
            const getButtonText = ()=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    id: "highlight-actions.create-multiple-jira-work-items",
                    defaultMessage: "Create Jira work items"
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    id: "highlight-actions.create-jira-work-item",
                    defaultMessage: "Create Jira work item"
                });
            };
            if ((0, $9wGTI.fg)("aifc_create_enabled") || (0, $6mKj3.expValEquals)("platform_editor_toolbar_aifc_confluence", "isEnabled", true)) {
                let t3;
                if ($[6] !== getIconAIFC) {
                    t3 = getIconAIFC({});
                    $[6] = getIconAIFC;
                    $[7] = t3;
                } else t3 = $[7];
                const t4 = handleCreateIssueItemClicked(issueCreationType);
                let t5;
                if ($[8] !== getButtonText) {
                    t5 = getButtonText();
                    $[8] = getButtonText;
                    $[9] = t5;
                } else t5 = $[9];
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
                    testId: "consolidated-create-jira-issue-button",
                    "data-key": completeKey,
                    shouldTitleWrap: false,
                    elemBefore: t3,
                    onClick: t4
                }, t5);
                break bb0;
            }
            t1 = (0, $iu6m9.editorExperiment)("platform_editor_controls", "variant1") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                testId: "consolidated-create-jira-issue-button",
                "data-key": completeKey,
                shouldTitleWrap: false,
                elemBefore: getIcon({}),
                onClick: handleCreateIssueItemClicked(issueCreationType)
            }, getButtonText()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                id: "create-jira-issue-button",
                appearance: "subtle",
                iconBefore: $ae4b6329110effd0$var$_temp,
                "data-key": completeKey,
                testId: "consolidated-create-jira-issue-button",
                onClick: handleCreateIssueItemClicked(isSelectionMultipleRows ? "MULTIPLE_ISSUE" : $ae4b6329110effd0$var$getIssueCreationType({
                    isAIIssueCreationEnabled: isAIIssueCreationEnabled
                })),
                spacing: "compact"
            }, (0, $9wGTI.fg)("confluence-issue-terminology-refresh") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.create-jira-issue-issue-term-refresh",
                defaultMessage: "Jira work item"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "highlight-actions.create-jira-issue",
                defaultMessage: "Jira issue"
            }));
        }
        $[0] = completeKey;
        $[1] = handleCreateIssueItemClicked;
        $[2] = isAIIssueCreationEnabled;
        $[3] = isSelectionMultipleRows;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    return t1;
} : ({ completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows })=>{
    const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
        isAIIssueCreationEnabled: isAIIssueCreationEnabled
    });
    const getIcon = (iconProps)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
            ...iconProps,
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
            ...iconProps,
            label: ""
        });
    };
    const getIconAIFC = (iconProps_0)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
            ...iconProps_0,
            size: "small",
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
            ...iconProps_0,
            size: "small",
            label: ""
        });
    };
    const getButtonText = ()=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.create-multiple-jira-work-items",
            defaultMessage: "Create Jira work items"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "highlight-actions.create-jira-work-item",
            defaultMessage: "Create Jira work item"
        });
    };
    if ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: getIconAIFC({}),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText());
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: getIcon({}),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        id: "create-jira-issue-button",
        appearance: "subtle",
        iconBefore: (iconProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                ...iconProps_1,
                label: ""
            }),
        "data-key": completeKey,
        testId: "consolidated-create-jira-issue-button",
        onClick: handleCreateIssueItemClicked(isSelectionMultipleRows ? 'MULTIPLE_ISSUE' : $ae4b6329110effd0$var$getIssueCreationType({
            isAIIssueCreationEnabled: isAIIssueCreationEnabled
        })),
        spacing: "compact"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.create-jira-issue-issue-term-refresh",
        defaultMessage: "Jira work item"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.create-jira-issue",
        defaultMessage: "Jira issue"
    }));
};
const $ae4b6329110effd0$export$f91cf3aef874f6f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(42);
    const { activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen } = t0;
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1pSma.default)("highlight-actions.ai-issue-create.dropdown-item-click");
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $frJep.useIsAIIssueCreationEnabled)();
    let t1;
    if ($[0] !== activeSelection) {
        t1 = $ae4b6329110effd0$var$isTableSelection(activeSelection);
        $[0] = activeSelection;
        $[1] = t1;
    } else t1 = $[1];
    const isSelectionInTable = t1;
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    let t2;
    if ($[2] !== actionItemsInSelection || $[3] !== isSelectionInTable) {
        t2 = actionItemsInSelection > 0 && !isSelectionInTable && (0, $9wGTI.fg)("confluence-create-work-items-from-action-items");
        $[2] = actionItemsInSelection;
        $[3] = isSelectionInTable;
        $[4] = t2;
    } else t2 = $[4];
    const isActionItemInSelection = t2;
    let t3;
    if ($[5] !== actionItemsInSelection || $[6] !== isSelectionInTable) {
        t3 = actionItemsInSelection > 1 && !isSelectionInTable && (0, $9wGTI.fg)("confluence-create-work-items-from-action-items");
        $[5] = actionItemsInSelection;
        $[6] = isSelectionInTable;
        $[7] = t3;
    } else t3 = $[7];
    const isMultiActionItemsInSelection = t3;
    let t4;
    if ($[8] !== activeSelection || $[9] !== isMultiActionItemsInSelection) {
        t4 = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
        $[8] = activeSelection;
        $[9] = isMultiActionItemsInSelection;
        $[10] = t4;
    } else t4 = $[10];
    const isSelectionMultipleRows = t4;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            fetchPolicy: "cache-first"
        };
        $[11] = t5;
    } else t5 = $[11];
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)(t5);
    let t6;
    if ($[12] !== pageInfo) {
        t6 = $ae4b6329110effd0$var$userHasEditPermission(pageInfo);
        $[12] = pageInfo;
        $[13] = t6;
    } else t6 = $[13];
    const hasEditPermission = t6;
    let t7;
    if ($[14] !== createAnalyticsEvent || $[15] !== hasEditPermission) {
        t7 = (issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "confluenceHighlightActionsMenu",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "jiraIssueLink",
                    type: "ui",
                    attributes: {
                        issueCreationType: issueCreationType,
                        isDropdownItem: false,
                        isCreatedFromTable: isCreatedFromTable,
                        isCreatedFromActionItems: isCreatedFromActionItems,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }
                }
            }).fire();
        };
        $[14] = createAnalyticsEvent;
        $[15] = hasEditPermission;
        $[16] = t7;
    } else t7 = $[16];
    const fireCreateIssueButtonClickedAnalytics = t7;
    let t8;
    if ($[17] !== actions || $[18] !== activeSelection || $[19] !== container || $[20] !== contentId || $[21] !== contentType || $[22] !== fireCreateIssueButtonClickedAnalytics || $[23] !== hasEditPermission || $[24] !== isActionItemInSelection || $[25] !== isSelectionInTable || $[26] !== isSidePanelOpen || $[27] !== lastModified || $[28] !== pressTracing || $[29] !== rightSidebarContext || $[30] !== setIsCreatedFromActionItems || $[31] !== setIsCreatedFromTable || $[32] !== setIsCreatedWithAi || $[33] !== setIsWarningDialogOpen || $[34] !== setRecordedClick || $[35] !== trackAIInteractionInit) {
        t8 = (issueCreationType_0)=>()=>{
                if (!isSidePanelOpen) bb29: switch(issueCreationType_0){
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                        (0, $joYQz.createSingleJiraIssueHandle)({
                            rightSidebarContext: rightSidebarContext,
                            actions: actions,
                            activeSelection: activeSelection,
                            contentId: contentId,
                            contentType: contentType,
                            container: container,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            isActionItemInSelection: isActionItemInSelection,
                            pageMode: (0, $1mDVg.PageMode).VIEW
                        });
                        break bb29;
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                        !(0, $4VJDS.default).getBoolean("confluence_legacy_bulk_jira_work_create", false) ? (0, $joYQz.createMultipleJiraIssuesHandleModernized)({
                            rightSidebarContext: rightSidebarContext,
                            pressTracing: pressTracing,
                            activeSelection: activeSelection,
                            actions: actions,
                            setIsCreatedWithAi: setIsCreatedWithAi,
                            setIsCreatedFromTable: setIsCreatedFromTable,
                            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                            contentId: contentId,
                            container: container,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            pageMode: (0, $1mDVg.PageMode).VIEW
                        }) : (0, $2W2Mk.createMultipleJiraIssuesHandle)(container, contentId, lastModified);
                        break bb29;
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                        (0, $joYQz.createSingleAiJiraIssueHandle)({
                            rightSidebarContext: rightSidebarContext,
                            actions: actions,
                            activeSelection: activeSelection,
                            contentId: contentId,
                            contentType: contentType,
                            container: container,
                            fireAiAnalytics: trackAIInteractionInit,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            pageMode: (0, $1mDVg.PageMode).VIEW,
                            isActionItemInSelection: isActionItemInSelection
                        });
                        pressTracing();
                }
                else {
                    const aiData = {
                        contentType: contentType,
                        fireAiAnalytics: trackAIInteractionInit
                    };
                    const tempData = {
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        ...issueCreationType_0 === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                    };
                    setRecordedClick(tempData);
                    setIsWarningDialogOpen(true);
                }
            };
        $[17] = actions;
        $[18] = activeSelection;
        $[19] = container;
        $[20] = contentId;
        $[21] = contentType;
        $[22] = fireCreateIssueButtonClickedAnalytics;
        $[23] = hasEditPermission;
        $[24] = isActionItemInSelection;
        $[25] = isSelectionInTable;
        $[26] = isSidePanelOpen;
        $[27] = lastModified;
        $[28] = pressTracing;
        $[29] = rightSidebarContext;
        $[30] = setIsCreatedFromActionItems;
        $[31] = setIsCreatedFromTable;
        $[32] = setIsCreatedWithAi;
        $[33] = setIsWarningDialogOpen;
        $[34] = setRecordedClick;
        $[35] = trackAIInteractionInit;
        $[36] = t8;
    } else t8 = $[36];
    const handleCreateIssueItemClicked = t8;
    let t9;
    if ($[37] !== completeKey || $[38] !== handleCreateIssueItemClicked || $[39] !== isAIIssueCreationEnabled || $[40] !== isSelectionMultipleRows) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
            completeKey: completeKey,
            handleCreateIssueItemClicked: handleCreateIssueItemClicked,
            isAIIssueCreationEnabled: isAIIssueCreationEnabled,
            isSelectionMultipleRows: isSelectionMultipleRows
        });
        $[37] = completeKey;
        $[38] = handleCreateIssueItemClicked;
        $[39] = isAIIssueCreationEnabled;
        $[40] = isSelectionMultipleRows;
        $[41] = t9;
    } else t9 = $[41];
    return t9;
} : ({ activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen })=>{
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1pSma.default)('highlight-actions.ai-issue-create.dropdown-item-click');
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $frJep.useIsAIIssueCreationEnabled)();
    const isSelectionInTable = $ae4b6329110effd0$var$isTableSelection(activeSelection);
    // table creation has higher priority than action item creation
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    const isActionItemInSelection = actionItemsInSelection > 0 && !isSelectionInTable && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const isMultiActionItemsInSelection = actionItemsInSelection > 1 && !isSelectionInTable && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const isSelectionMultipleRows = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $42omo.useMemo)(()=>$ae4b6329110effd0$var$userHasEditPermission(pageInfo), [
        pageInfo
    ]);
    const fireCreateIssueButtonClickedAnalytics = (0, $42omo.useCallback)((issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: issueCreationType,
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    hasEditPermission: hasEditPermission,
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        hasEditPermission
    ]);
    const handleCreateIssueItemClicked = (0, $42omo.useCallback)((issueCreationType_0)=>()=>{
            if (!isSidePanelOpen) switch(issueCreationType_0){
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $joYQz.createSingleJiraIssueHandle)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        isActionItemInSelection: isActionItemInSelection,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    });
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    !(0, $4VJDS.default).getBoolean('confluence_legacy_bulk_jira_work_create', false) ? (0, $joYQz.createMultipleJiraIssuesHandleModernized)({
                        rightSidebarContext: rightSidebarContext,
                        pressTracing: pressTracing,
                        activeSelection: activeSelection,
                        actions: actions,
                        setIsCreatedWithAi: setIsCreatedWithAi,
                        setIsCreatedFromTable: setIsCreatedFromTable,
                        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }) : (0, $2W2Mk.createMultipleJiraIssuesHandle)(container, contentId, lastModified);
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $joYQz.createSingleAiJiraIssueHandle)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        fireAiAnalytics: trackAIInteractionInit,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW,
                        isActionItemInSelection: isActionItemInSelection
                    });
                    pressTracing();
                    break;
            }
            else {
                // ai specific data
                const aiData = {
                    contentType: contentType,
                    fireAiAnalytics: trackAIInteractionInit
                };
                // record temp data
                const tempData = {
                    rightSidebarContext: rightSidebarContext,
                    actions: actions,
                    activeSelection: activeSelection,
                    contentId: contentId,
                    container: container,
                    lastModified: lastModified,
                    hasEditPermission: hasEditPermission,
                    ...issueCreationType_0 === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                };
                setRecordedClick(tempData);
                setIsWarningDialogOpen(true);
            }
        }, [
        isSidePanelOpen,
        fireCreateIssueButtonClickedAnalytics,
        isSelectionInTable,
        rightSidebarContext,
        actions,
        activeSelection,
        contentId,
        contentType,
        container,
        lastModified,
        pressTracing,
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsCreatedFromActionItems,
        trackAIInteractionInit,
        setRecordedClick,
        setIsWarningDialogOpen,
        hasEditPermission,
        isActionItemInSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
        completeKey: completeKey,
        handleCreateIssueItemClicked: handleCreateIssueItemClicked,
        isAIIssueCreationEnabled: isAIIssueCreationEnabled,
        isSelectionMultipleRows: isSelectionMultipleRows
    });
};
function $ae4b6329110effd0$var$_temp(iconProps_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        ...iconProps_1,
        label: ""
    });
}
module.exports["CreateJiraIssueActions"] = $ae4b6329110effd0$export$f91cf3aef874f6f;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("dhBFe", function(module, exports) {
// eslint-disable-next-line sort-imports

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $6wMCT = parcelRequire("6wMCT");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $6wMCT.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("6wMCT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $ad89860a791bab0b$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
module.exports["FocusManagerContext"] = $ad89860a791bab0b$export$f18c1d4fc7326096;

});

parcelRegister("frJep", function(module, exports) {

var $1mDVg = parcelRequire("1mDVg");


var $dAg4H = parcelRequire("dAg4H");


var $2ay9q = parcelRequire("2ay9q");

const $ae678835b2293c93$export$58de3335a79e10d3 = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId
    });
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
    const isCreateIssueWithAiEnabledByUser = (0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)();
    return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};
module.exports["useIsAIIssueCreationEnabled"] = $ae678835b2293c93$export$58de3335a79e10d3;

});

parcelRegister("2W2Mk", function(module, exports) {

var $04e9M = parcelRequire("04e9M");


var $aUTn5 = parcelRequire("aUTn5");

const $fc9c79783a6d919a$export$b5c53601259f278e = (container, contentId, lastModified)=>()=>{
        const selection = window.getSelection();
        if (selection) {
            // Send an event to track the user clicking the JIRA Link
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendUIEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'jiraIssueLink',
                    source: 'HighlightContextMenu'
                });
            });
            window.dispatchEvent(new CustomEvent('create-jira-issue-summary', // Convert window.getSelection() to legacy format used in jira issue summary.
            // Once we Reactified it this should be deleted.
            {
                detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
            }));
        }
    };
const $fc9c79783a6d919a$export$92ec81e7ac5e7973 = (container, contentId, lastModified)=>{
    const selection = window.getSelection();
    if (selection) {
        window.dispatchEvent(new CustomEvent('create-jira-issue-summary', {
            detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
        }));
        const observer = new MutationObserver((_mutations, observer)=>{
            const createMultipleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-multiple-issues');
            if (createMultipleButton) {
                createMultipleButton.click();
                observer.disconnect();
            }
            const createSingleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-single-issue');
            if (createSingleButton) createSingleButton.style.display = 'none';
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};
module.exports["createJiraIssueSummaryHandle"] = $fc9c79783a6d919a$export$b5c53601259f278e;
module.exports["createMultipleJiraIssuesHandle"] = $fc9c79783a6d919a$export$92ec81e7ac5e7973;

});

parcelRegister("joYQz", function(module, exports) {

var $eqKgz = parcelRequire("eqKgz");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3TWPv = parcelRequire("3TWPv");


var $cSSgB = parcelRequire("cSSgB");


var $euVTc = parcelRequire("euVTc");


var $1Q0l6 = parcelRequire("1Q0l6");


var $2ViZo = parcelRequire("2ViZo");


var $UNr39 = parcelRequire("UNr39");


var $aUTn5 = parcelRequire("aUTn5");

const $4d90dab75b68bf7b$export$a25c0fd63a5cc834 = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $4d90dab75b68bf7b$export$233a92718b28d19e = 254;
const $4d90dab75b68bf7b$export$2878cc467c8be8fe = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    // Calculate the length of the first part without including the ellipsis
    const firstPartLength = maxLength - horizontalEllipsis.length;
    // Split the text into two parts
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $4d90dab75b68bf7b$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $4d90dab75b68bf7b$export$a25c0fd63a5cc834(activeSelection);
    const [summary] = $4d90dab75b68bf7b$export$2878cc467c8be8fe(selectionString, $4d90dab75b68bf7b$export$233a92718b28d19e);
    /*
   The regex matches one or more occurrences of any line break (\r, \n) or tab (\t)
   and replaces them all with a single space. (We only consider whitespace characters because
   these are the only ones that ultimately stick when parsing the summary.)
   */ const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    // Convert the full HTML content to ADF for the description
    const descriptionAdf = (0, $eqKgz.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $4d90dab75b68bf7b$export$358d16442308a1f3 = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    actions.setIsCreatedWithAi(false);
    actions.setHasEditPermission(hasEditPermission);
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
};
const $4d90dab75b68bf7b$export$5378c6b60bde04bf = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, fireAiAnalytics: fireAiAnalytics, lastModified: lastModified, pressTracing: pressTracing, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    fireAiAnalytics();
    actions.setIsCreatedWithAi(true);
    actions.setHasEditPermission(hasEditPermission);
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
    pressTracing?.();
};
const $4d90dab75b68bf7b$export$83a48a684a9c82ca = ({ actions: actions, setIsCreatedWithAi: setIsCreatedWithAi, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, rightSidebarContext: rightSidebarContext, pressTracing: pressTracing, activeSelection: activeSelection, contentId: contentId, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode })=>{
    if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) {
        const result = (0, $2ViZo.prepareBulkCreateFromSelection)({
            actions: actions,
            activeSelection: activeSelection,
            contentId: contentId,
            pageMode: pageMode,
            hasEditPermission: hasEditPermission,
            container: container,
            lastModified: lastModified,
            setIsCreatedFromTable: setIsCreatedFromTable,
            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
        });
        if (result === (0, $2ViZo.BulkSelectionResult).None) return;
    } else {
        const selectedActionList = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection, pageMode);
        const selectedTable = (0, $euVTc.getClosestTableFromSelection)(activeSelection);
        if (!selectedTable && !selectedActionList && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) // We have checks to ensure that the activeSelection is in a table or contains action items, so this should never happen.
        return;
        if (selectedTable) {
            actions.setSelectedTable(selectedTable);
            const insertStorageColumnTableRequestPayload = (0, $1Q0l6.constructInsertStorageColumnTableRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0)), container, lastModified);
            actions.setInsertStorageColumnTableRequestPayload(insertStorageColumnTableRequestPayload);
            setIsCreatedFromTable(true);
            $4d90dab75b68bf7b$var$resetActionItemsState(setIsCreatedFromActionItems, actions);
        } else if (selectedActionList && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
            actions.setSelectedActionItems(selectedActionList);
            const actionItems = selectedActionList.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""])');
            const ranges = [];
            actionItems.forEach((actionItem)=>{
                const range = new Range();
                range.selectNodeContents(actionItem);
                const validRange = (0, $1Q0l6.getValidRangeForActionItem)(range);
                if (validRange) ranges.push(validRange);
            });
            const insertMultipleStorageFragmentsRequestPayload = (0, $1Q0l6.constructInsertMultipleStorageFragmentsRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), ranges, container, lastModified);
            actions.setInsertMultipleStorageFragmentsRequestPayload(insertMultipleStorageFragmentsRequestPayload);
            setIsCreatedFromActionItems(true);
            $4d90dab75b68bf7b$var$resetTableState(setIsCreatedFromTable, actions);
        }
        actions.setContentId(contentId);
        actions.setPageMode(pageMode);
        actions.setHasEditPermission(hasEditPermission);
        setIsCreatedWithAi(false);
    }
    rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    pressTracing?.();
};
const $4d90dab75b68bf7b$var$resetTableState = (setIsCreatedFromTable, actions)=>{
    setIsCreatedFromTable(false);
    actions.setSelectedTable(undefined);
    actions.setInsertStorageColumnTableRequestPayload(undefined);
};
const $4d90dab75b68bf7b$var$resetActionItemsState = (setIsCreatedFromActionItems, actions)=>{
    setIsCreatedFromActionItems(false);
    actions.setSelectedActionItems(undefined);
    actions.setInsertMultipleStorageFragmentsRequestPayload(undefined);
};
module.exports["getHTMLString"] = $4d90dab75b68bf7b$export$a25c0fd63a5cc834;
module.exports["createSingleJiraIssueHandle"] = $4d90dab75b68bf7b$export$358d16442308a1f3;
module.exports["createSingleAiJiraIssueHandle"] = $4d90dab75b68bf7b$export$5378c6b60bde04bf;
module.exports["createMultipleJiraIssuesHandleModernized"] = $4d90dab75b68bf7b$export$83a48a684a9c82ca;

});

parcelRegister("3TWPv", function(module, exports) {

var $eqKgz = parcelRequire("eqKgz");


var $9wGTI = parcelRequire("9wGTI");


var $1Q0l6 = parcelRequire("1Q0l6");


var $1mDVg = parcelRequire("1mDVg");


var $1L1jV = parcelRequire("1L1jV");


var $cSSgB = parcelRequire("cSSgB");


var $9uzSK = parcelRequire("9uzSK");

const $918fba8df3fbcc13$export$233a92718b28d19e = 254;
const $918fba8df3fbcc13$var$getHTMLString = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $918fba8df3fbcc13$export$db5a8500f6b6286e = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    const firstPartLength = maxLength - horizontalEllipsis.length;
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipsis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipsis,
        text
    ];
};
const $918fba8df3fbcc13$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $918fba8df3fbcc13$var$getHTMLString(activeSelection);
    const [summary] = $918fba8df3fbcc13$export$db5a8500f6b6286e(selectionString, $918fba8df3fbcc13$export$233a92718b28d19e);
    const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    const descriptionAdf = (0, $eqKgz.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $918fba8df3fbcc13$export$41bb5569f66eae2a = ({ actions: actions, rightSidebarContext: rightSidebarContext, activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    const { updatedSelection: updatedSelection, activeSelectionRange: activeSelectionRange } = $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected({
        activeSelection: activeSelection,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection
    });
    const shouldUseSelectionAdf = pageMode !== (0, $1mDVg.PageMode).VIEW && !!selectionAdfResult?.selectedNodeAdf;
    const selectionAdf = shouldUseSelectionAdf ? (0, $9uzSK.extractSelectedAdfSlice)(selectionAdfResult) : undefined;
    const highlightedText = shouldUseSelectionAdf ? (0, $9uzSK.normalizeToDocNode)(selectionAdf) : (0, $eqKgz.htmlToADF)($918fba8df3fbcc13$var$getHTMLString(updatedSelection));
    const insertStorageFragmentRequestPayload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, convertSelectionToLegacyFormat, activeSelectionRange, container, lastModified);
    const [summaryWithoutFormatting, descriptionAdf] = shouldUseSelectionAdf ? (0, $9uzSK.getSummaryAndDescriptionFromSelectionAdfResult)(selectionAdfResult, $918fba8df3fbcc13$export$233a92718b28d19e) : $918fba8df3fbcc13$export$5645fd1d37220db2(updatedSelection);
    actions.setSummary(summaryWithoutFormatting);
    actions.setDescriptionAdf(descriptionAdf);
    actions.setContentId(contentId);
    contentType && actions.setContentType(contentType);
    actions.setHighlightedText(highlightedText);
    actions.setInsertStorageFragmentRequestPayload(insertStorageFragmentRequestPayload);
    actions.setIsCreatedFromActionItem(!!isActionItemInSelection);
    actions.setPageMode(pageMode);
    rightSidebarContext.open((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID), (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_WIDTH));
};
const $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected = ({ activeSelection: activeSelection, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    let updatedSelection = activeSelection;
    let activeSelectionRange = (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0));
    if (isActionItemInSelection && (pageMode === (0, $1mDVg.PageMode).VIEW || (0, $9wGTI.fg)('confluence-editor-jira-work-create-block-menu')) && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
        const updatedActiveSelection = (0, $cSSgB.includeEntireActionItemInSelection)(activeSelection, pageMode);
        if (updatedActiveSelection instanceof Range) {
            updatedSelection = updatedActiveSelection;
            activeSelectionRange = (0, $1Q0l6.getValidRangeForActionItem)(updatedActiveSelection);
        } else activeSelectionRange = activeSelection && 'getRangeAt' in activeSelection ? (0, $1Q0l6.getValidRange)(activeSelection.getRangeAt(0)) : undefined;
    }
    return {
        updatedSelection: updatedSelection,
        activeSelectionRange: activeSelectionRange
    };
};
module.exports["openSingleIssueSidePanelWithSelection"] = $918fba8df3fbcc13$export$41bb5569f66eae2a;

});

parcelRegister("4oXkq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $dAYOx = parcelRequire("dAYOx");


var $inPa6 = parcelRequire("inPa6");


var $iu6m9 = parcelRequire("iu6m9");


var $2GVu1 = parcelRequire("2GVu1");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $lpGuF = parcelRequire("lpGuF");


var $dMbwP = parcelRequire("dMbwP");


var $9ujb2 = parcelRequire("9ujb2");

const $ed7cf63fc877d47c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $ed7cf63fc877d47c$var$getHighlightedText = (selection)=>{
    if (!selection || selection.rangeCount === 0) return '';
    return selection.toString().trim();
};
const $ed7cf63fc877d47c$var$i18n = (0, $aXWIB.defineMessages)({
    trelloLabel: {
        id: "highlight-actions.create-trello-card",
        defaultMessage: "Send to your Trello Inbox"
    },
    errorTitle: {
        id: "highlight-actions.trello.create.error",
        defaultMessage: "Couldn't create Trello card. Try again later."
    },
    successTitle: {
        id: "highlight-actions.trello.create.success",
        defaultMessage: "Trello card created"
    },
    openCard: {
        id: "highlight-actions.trello.openCard",
        defaultMessage: "Open card"
    }
});
const $ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent = ({ activeSelection: activeSelection, completeKey: completeKey, contentId: contentId, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const { hasTrelloAccess: hasTrelloAccess, loading: trelloAccessLoading } = (0, $9ujb2.useTrelloAccess)();
    const fireTrelloCardCreatedAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'trelloInboxCard',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    hasSelection: Boolean(activeSelection && activeSelection.toString().trim())
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        activeSelection
    ]);
    const showCreateErrorFlag = (0, $42omo.useCallback)(()=>{
        flags.showFlag({
            id: 'trello-inbox-create-error',
            type: 'error',
            title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.errorTitle),
            close: 'auto'
        });
    }, [
        flags,
        intl
    ]);
    const makeHandleCreateTrelloCardClick = (0, $42omo.useCallback)(async ()=>{
        const highlightedText = $ed7cf63fc877d47c$var$getHighlightedText(activeSelection);
        if (!highlightedText) return;
        try {
            fireTrelloCardCreatedAnalytics();
            const result = await (0, $lpGuF.createTrelloCardHandle)({
                text: highlightedText,
                contentId: contentId
            });
            if (result && result.success) {
                const actions = result.cardUrl ? [
                    {
                        content: intl.formatMessage($ed7cf63fc877d47c$var$i18n.openCard),
                        href: result.cardUrl,
                        target: '_blank'
                    }
                ] : undefined;
                flags.showFlag({
                    id: 'trello-inbox-create-success',
                    type: 'success-circle',
                    title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.successTitle),
                    actions: actions,
                    close: 'auto'
                });
            } else showCreateErrorFlag();
        } catch  {
            $ed7cf63fc877d47c$var$logger.error`Error creating Trello card for contentId=${contentId}`;
            showCreateErrorFlag();
        }
    }, [
        activeSelection,
        contentId,
        fireTrelloCardCreatedAnalytics,
        flags,
        showCreateErrorFlag,
        intl
    ]);
    if (!(0, $9wGTI.fg)('quick_capture_trello_inbox')) return null;
    if (trelloAccessLoading) return null;
    if (!hasTrelloAccess) return null;
    if ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        testId: "create-trello-card-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMbwP.TrelloInboxIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
            size: "small"
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "create-trello-card-button",
        "aria-label": intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
        "data-key": completeKey,
        shouldTitleWrap: false,
        title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMbwP.TrelloInboxIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        id: "create-trello-card-button",
        appearance: "subtle",
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMbwP.TrelloInboxIcon), {
                label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)
            }),
        "data-key": completeKey,
        testId: "create-trello-card-button",
        onClick: makeHandleCreateTrelloCardClick,
        spacing: "compact"
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
};
const $ed7cf63fc877d47c$export$12f6e4d1b0812953 = (0, $7aRa9.withFlags)($ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent);
module.exports["AddToTrelloInboxActions"] = $ed7cf63fc877d47c$export$12f6e4d1b0812953;

});

parcelRegister("lpGuF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $988c838c2543c991$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT = '/wiki/api/v2/trello/inbox/card';
const $988c838c2543c991$var$CARD_NAME_MAX_LENGTH = 254;
const $988c838c2543c991$var$HORIZONTAL_ELLIPSIS = "\u2026";
const $988c838c2543c991$var$toPayloadSafeName = (raw, maxLength = $988c838c2543c991$var$CARD_NAME_MAX_LENGTH)=>{
    const normalized = String(raw).replace(/[\r\n\t]+/g, ' ').trim();
    if (normalized.length <= maxLength) return normalized;
    const firstPartLength = Math.max(0, maxLength - $988c838c2543c991$var$HORIZONTAL_ELLIPSIS.length);
    return normalized.substring(0, firstPartLength) + $988c838c2543c991$var$HORIZONTAL_ELLIPSIS;
};
const $988c838c2543c991$export$750e0c983aee1f51 = async ({ text: text, contentId: contentId })=>{
    const payload = {
        name: $988c838c2543c991$var$toPayloadSafeName(text, $988c838c2543c991$var$CARD_NAME_MAX_LENGTH),
        description: text || 'Created via Confluence',
        sourceContentId: contentId,
        sourceUrl: typeof location !== 'undefined' ? location.href : undefined
    };
    try {
        const resp = await fetch($988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!resp.ok) {
            $988c838c2543c991$var$logger.error`Failed to create Trello card for contentId=${contentId} status=${resp.status}`;
            return null;
        }
        const data = await resp.json();
        const idCandidate = data.cardId;
        const urlCandidate = data.cardUrl;
        if (!idCandidate || !urlCandidate) {
            $988c838c2543c991$var$logger.error`Invalid Trello response for contentId=${contentId}`;
            return null;
        }
        const response = {
            cardId: idCandidate || '',
            cardUrl: urlCandidate || '',
            success: true
        };
        return response;
    } catch  {
        $988c838c2543c991$var$logger.error`Error creating Trello card for contentId=${contentId}`;
        return null;
    }
};
module.exports["createTrelloCardHandle"] = $988c838c2543c991$export$750e0c983aee1f51;

});

parcelRegister("dMbwP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $flZlQ = parcelRequire("flZlQ");

const $aa74cc1d9c17d5e2$export$65b41c6aab3a46a7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $flZlQ.default), {
            name: "TrelloInboxIcon",
            dangerouslySetGlyph: "<path fill=\"currentcolor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.3356 1H2.66436C1.74525 1 1 1.74525 1 2.66436V13.3356C1 14.2548 1.74525 15 2.66436 15H13.3356C14.2548 15 15 14.2548 15 13.3356V2.66436C15 1.74525 14.2548 1 13.3356 1ZM7.0307 11.0836C7.0307 11.3892 6.783 11.6365 6.4777 11.6365H4.13768C3.83203 11.6365 3.58475 11.3888 3.58475 11.0836V4.13768C3.58475 3.83203 3.83245 3.58475 4.13768 3.58475H6.4777C6.7834 3.58475 7.0307 3.83245 7.0307 4.13768V11.0836ZM12.4152 7.8948C12.4152 8.2005 12.1675 8.4477 11.8623 8.4477H9.5223C9.2166 8.4477 8.9693 8.2 8.9693 7.8948V4.13768C8.9693 3.83203 9.217 3.58475 9.5223 3.58475H11.8623C12.168 3.58475 12.4152 3.83245 12.4152 4.13768V7.8948Z\"/>",
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $flZlQ.default), {
        name: "TrelloInboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" clip-rule="evenodd" d="M13.3356 1H2.66436C1.74525 1 1 1.74525 1 2.66436V13.3356C1 14.2548 1.74525 15 2.66436 15H13.3356C14.2548 15 15 14.2548 15 13.3356V2.66436C15 1.74525 14.2548 1 13.3356 1ZM7.0307 11.0836C7.0307 11.3892 6.783 11.6365 6.4777 11.6365H4.13768C3.83203 11.6365 3.58475 11.3888 3.58475 11.0836V4.13768C3.58475 3.83203 3.83245 3.58475 4.13768 3.58475H6.4777C6.7834 3.58475 7.0307 3.83245 7.0307 4.13768V11.0836ZM12.4152 7.8948C12.4152 8.2005 12.1675 8.4477 11.8623 8.4477H9.5223C9.2166 8.4477 8.9693 8.2 8.9693 7.8948V4.13768C8.9693 3.83203 9.217 3.58475 9.5223 3.58475H11.8623C12.168 3.58475 12.4152 3.83245 12.4152 4.13768V7.8948Z"/>`,
        ...props
    });
module.exports["TrelloInboxIcon"] = $aa74cc1d9c17d5e2$export$65b41c6aab3a46a7;

});

parcelRegister("9ujb2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7W8i8 = parcelRequire("7W8i8");

const $26b2f47c8bb8be0c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $26b2f47c8bb8be0c$var$TRELLO_HAS_ACCESS_ENDPOINT = '/wiki/api/v2/trello/inbox/has-access';
let $26b2f47c8bb8be0c$var$cachedResult = null;
let $26b2f47c8bb8be0c$var$fetchPromise = null;
function $26b2f47c8bb8be0c$export$66160e11912cf1e6() {
    $26b2f47c8bb8be0c$var$cachedResult = null;
    $26b2f47c8bb8be0c$var$fetchPromise = null;
}
function $26b2f47c8bb8be0c$var$cacheErrorResult() {
    const result = {
        hasTrelloAccess: false,
        loading: false,
        error: true
    };
    $26b2f47c8bb8be0c$var$cachedResult = result;
    return result;
}
function $26b2f47c8bb8be0c$export$52c51aee2d49bb7f() {
    if (!$26b2f47c8bb8be0c$var$fetchPromise) $26b2f47c8bb8be0c$var$fetchPromise = Promise.resolve().then(()=>fetch($26b2f47c8bb8be0c$var$TRELLO_HAS_ACCESS_ENDPOINT, {
            method: 'GET',
            credentials: 'include',
            headers: {
                Accept: 'application/json'
            }
        })).then(async (response)=>{
        if (!response.ok) {
            $26b2f47c8bb8be0c$var$logger.warn`Failed to check Trello access: status=${response.status}`;
            return $26b2f47c8bb8be0c$var$cacheErrorResult();
        }
        const data = await response.json();
        const result = {
            hasTrelloAccess: Boolean(data.hasTrelloAccess),
            loading: false,
            error: false
        };
        $26b2f47c8bb8be0c$var$cachedResult = result;
        return result;
    }).catch((error)=>{
        $26b2f47c8bb8be0c$var$logger.error`Error checking Trello access: ${error}`;
        return $26b2f47c8bb8be0c$var$cacheErrorResult();
    });
    return $26b2f47c8bb8be0c$var$fetchPromise;
}
const $26b2f47c8bb8be0c$export$955874e1badc4683 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const [state, setState] = (0, $42omo.useState)($26b2f47c8bb8be0c$var$_temp);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if ($26b2f47c8bb8be0c$var$cachedResult) {
                setState($26b2f47c8bb8be0c$var$cachedResult);
                return;
            }
            let cancelled = false;
            $26b2f47c8bb8be0c$export$52c51aee2d49bb7f().then((result)=>{
                if (!cancelled) setState(result);
            });
            return ()=>{
                cancelled = true;
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useEffect)(t0, t1);
    return state;
} : ()=>{
    const [state, setState] = (0, $42omo.useState)(()=>$26b2f47c8bb8be0c$var$cachedResult ?? {
            hasTrelloAccess: false,
            loading: true,
            error: false
        });
    (0, $42omo.useEffect)(()=>{
        if ($26b2f47c8bb8be0c$var$cachedResult) {
            setState($26b2f47c8bb8be0c$var$cachedResult);
            return;
        }
        let cancelled = false;
        $26b2f47c8bb8be0c$export$52c51aee2d49bb7f().then((result)=>{
            if (!cancelled) setState(result);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    return state;
};
function $26b2f47c8bb8be0c$var$_temp() {
    return $26b2f47c8bb8be0c$var$cachedResult ?? {
        hasTrelloAccess: false,
        loading: true,
        error: false
    };
}
module.exports["prefetchTrelloAccess"] = $26b2f47c8bb8be0c$export$52c51aee2d49bb7f;
module.exports["useTrelloAccess"] = $26b2f47c8bb8be0c$export$955874e1badc4683;

});

parcelRegister("lEDve", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $jTxSS = parcelRequire("jTxSS");


var $6F6hl = parcelRequire("6F6hl");


var $l7fKC = parcelRequire("l7fKC");


var $6mKj3 = parcelRequire("6mKj3");


var $id4ij = parcelRequire("id4ij");


var $9wGTI = parcelRequire("9wGTI");


var $bEdUx = parcelRequire("bEdUx");

const $709c5a5818d3675c$var$popupAnimation = null;
const $709c5a5818d3675c$var$popupPanelStyles = null;
const $709c5a5818d3675c$var$popupTransition = null;
const $709c5a5818d3675c$var$buttonContainerStyle = null;
const $709c5a5818d3675c$var$buttonContainerBorderUpdated = null;
const $709c5a5818d3675c$var$toolbarContainerStyle = null;
const $709c5a5818d3675c$var$i18n = (0, $aXWIB.defineMessages)({
    toolbarAlert: {
        id: "highlight-actions.toolbar.alert",
        defaultMessage: "Floating toolbar is available. Press tab to access it"
    }
});
const $709c5a5818d3675c$export$129a32eedafa97c5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children, top: top, left: left, needTransition: t1, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition } = t0;
    const needTransition = t1 === undefined ? true : t1;
    const popupContainerRef = (0, $42omo.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("aifc_create_enabled") || (0, $6mKj3.expValEquals)("platform_editor_toolbar_aifc_confluence", "isEnabled", true);
        $[0] = t2;
    } else t2 = $[0];
    const isNewToolbarEnabled = t2;
    const popupRef = (0, $42omo.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[1] = t3;
    } else t3 = $[1];
    (0, $42omo.useEffect)($709c5a5818d3675c$var$_temp2, t3);
    let t4;
    if ($[2] !== children || $[3] !== formatMessage || $[4] !== needTransition || $[5] !== onMouseEnter || $[6] !== onMouseLeave || $[7] !== popupLeft || $[8] !== top) {
        const portalContainer_0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
        let t5;
        if ($[10] !== onMouseEnter || $[11] !== onMouseLeave) {
            t5 = onMouseEnter && onMouseLeave && {
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            };
            $[10] = onMouseEnter;
            $[11] = onMouseLeave;
            $[12] = t5;
        } else t5 = $[12];
        const mouseMoveHandlers = t5;
        t4 = portalContainer_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ $42omo.createElement("div", {
            ref: popupContainerRef,
            style: {
                top: top
            },
            ...mouseMoveHandlers,
            className: (0, $gMc0m.default)([
                "_y44vlq9g _kqswstnw",
                needTransition && "_v564zagr"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), {
            id: "toolbar-alert"
        }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), isNewToolbarEnabled ? /*#__PURE__*/ $42omo.createElement("div", {
            ref: popupRef,
            style: {
                left: `${popupLeft || 0}px`
            },
            "data-testid": "highlightActionsPopup",
            id: "highlightActionsPopup",
            className: (0, $gMc0m.default)([
                "_t9ecm79d _kqswstnw _154iidpf"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $l7fKC.Toolbar), {
            label: "Renderer toolbar"
        }, children)) : /*#__PURE__*/ $42omo.createElement("div", {
            ref: popupRef,
            style: {
                left: `${popupLeft || 0}px`
            },
            "data-testid": "highlightActionsPopup",
            id: "highlightActionsPopup",
            className: (0, $gMc0m.default)([
                "_2rkofajl _t9ecm79d _16qs130s _kqswstnw _154iidpf _bfhk1bhr _1e0c1txw",
                (0, $9wGTI.fg)("confluence_comment_border_migration") && "_2rko12b0"
            ])
        }, children)), portalContainer_0) : null;
        $[2] = children;
        $[3] = formatMessage;
        $[4] = needTransition;
        $[5] = onMouseEnter;
        $[6] = onMouseLeave;
        $[7] = popupLeft;
        $[8] = top;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, top: top, left: left, needTransition: needTransition = true, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition })=>{
    const popupContainerRef = (0, $42omo.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const popupRef = (0, $42omo.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
        if (!portalContainer) return;
        const screenreaderCb = (_mutationsList, observer)=>{
            //These accessibility attributes are added dynamically here rather than directly on the VisuallyHidden element because it did not get read by the NVDA screenreader properly on Firefox. This is due to the screenreader sometimes only reading content when there has been a dynamic change to an element
            const accessibleDiv = document.getElementById('toolbar-alert');
            if (accessibleDiv instanceof HTMLElement) {
                accessibleDiv?.setAttribute('role', 'alert');
                accessibleDiv?.setAttribute('aria-live', 'polite');
                observer.disconnect();
            }
        };
        const observer_0 = new MutationObserver(screenreaderCb);
        observer_0.observe(portalContainer, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer_0.disconnect();
        };
    }, []);
    const portalContainer_0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
    const mouseMoveHandlers = onMouseEnter && onMouseLeave && {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
    return portalContainer_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ $42omo.createElement("div", {
        ref: popupContainerRef,
        style: {
            top: top
        },
        ...mouseMoveHandlers,
        className: (0, $gMc0m.default)([
            "_y44vlq9g _kqswstnw",
            needTransition && "_v564zagr"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), {
        id: "toolbar-alert"
    }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), isNewToolbarEnabled ? /*#__PURE__*/ $42omo.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $gMc0m.default)([
            "_t9ecm79d _kqswstnw _154iidpf"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $l7fKC.Toolbar), {
        label: "Renderer toolbar"
    }, children)) : /*#__PURE__*/ $42omo.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $gMc0m.default)([
            "_2rkofajl _t9ecm79d _16qs130s _kqswstnw _154iidpf _bfhk1bhr _1e0c1txw",
            (0, $9wGTI.fg)('confluence_comment_border_migration') && "_2rko12b0"
        ])
    }, children)), portalContainer_0) : null;
};
const $709c5a5818d3675c$var$useAdjustedLeft = (0, $3u0dr.isReactCompilerActiveV2)() ? function useAdjustedLeft(left, popupRef) {
    const $ = (0, $frIzR.c)(4);
    const [adjustedLeft, setAdjustedLeft] = (0, $42omo.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $42omo.useState)(left);
    let t0;
    let t1;
    if ($[0] !== left || $[1] !== popupRef) {
        t0 = ()=>{
            if (!popupRef.current) return;
            const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
            const windowWidth = window.innerWidth;
            let containerBounds = {
                left: 0,
                right: windowWidth
            };
            const nav4ContentContainer = document.getElementById("AkMainContent");
            if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
            if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + 20);
            else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - 20);
            else setAdjustedLeft(left);
            setAdjustedLeftOrigin(left);
        };
        t1 = [
            left,
            popupRef
        ];
        $[0] = left;
        $[1] = popupRef;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useLayoutEffect)(t0, t1);
    return adjustedLeftOrigin === left ? adjustedLeft : left;
} : function useAdjustedLeft(left, popupRef) {
    const WINDOW_PADDING = 20;
    const [adjustedLeft, setAdjustedLeft] = (0, $42omo.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $42omo.useState)(left);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!popupRef.current) return;
        const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
        const windowWidth = window.innerWidth;
        let containerBounds = {
            left: 0,
            right: windowWidth
        }; // When nav4 container doesn't exist, the window is the container
        const nav4ContentContainer = document.getElementById('AkMainContent');
        if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
         // WS-1703 - If the popup menu is off either side of the screen or outside of the scrollable content area
        // set it so it's inside the WINDOW_PADDING
        if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + WINDOW_PADDING);
        else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - WINDOW_PADDING);
        else setAdjustedLeft(left);
        setAdjustedLeftOrigin(left);
    }, [
        left,
        popupRef
    ]); // Only use the adjustedLeft if it was calculated relative to the current left prop
    return adjustedLeftOrigin === left ? adjustedLeft : left;
};
/**
 * `popupPortalContainerId` is after the ADF renderer in the HTML DOM.
 * Consequently, when there is vertical layout shift before `popupPortalContainerId` such as in the ADF renderer, the `Popup` will automatically shift away from the selected range.
 * This automatic shift is undesirable and `useAdjustedTop` is attempting to undo it in a way as imperceptible to the user as possible.
 *
 * Inspired by {@link https://floating-ui.com/} which is "The Future of Popper". Both Popper and Floating UI are used by Design System to deal with popups including to reposition them.
 */ const $709c5a5818d3675c$var$useAdjustedTop = (0, $3u0dr.isReactCompilerActiveV2)() ? function useAdjustedTop(updatePosition, popupContainerRef) {
    const $ = (0, $frIzR.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
        $[0] = t0;
    } else t0 = $[0];
    const portalContainer = t0;
    let t1;
    let t2;
    if ($[1] !== popupContainerRef || $[2] !== updatePosition) {
        t1 = ()=>{
            if (!portalContainer || !updatePosition || !("ResizeObserver" in window)) return;
            const { parentElement: parentElement } = portalContainer;
            if (!parentElement) return;
            const observer = new ResizeObserver(()=>{
                if (!popupContainerRef.current) return;
                const newPosition = updatePosition();
                if (!newPosition) return;
                const { style: style } = popupContainerRef.current;
                const newTop = `${newPosition.top}px`;
                if (style.top !== newTop) {
                    style.transition = "none";
                    style.top = newTop;
                }
            });
            observer.observe(parentElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupContainerRef,
            portalContainer,
            updatePosition
        ];
        $[1] = popupContainerRef;
        $[2] = updatePosition;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
} : function useAdjustedTop(updatePosition, popupContainerRef) {
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    (0, $42omo.useEffect)(()=>{
        if (!portalContainer || !updatePosition || !('ResizeObserver' in window)) return; // The position of `popupPortalContainerId` relative to the selected range will change when the parent element of `popupPortalContainerId` is resized.
        const { parentElement: parentElement } = portalContainer;
        if (!parentElement) return;
        const observer = new ResizeObserver(()=>{
            if (!popupContainerRef.current) return;
            const newPosition = updatePosition();
            if (!newPosition) return;
            const { style: style } = popupContainerRef.current;
            const newTop = `${newPosition.top}px`;
            if (style.top !== newTop) {
                // `popupPortalContainerId` moved and automatically shifted `popupContainerRef` away from the selected range.
                // This automatic shift is undesirable and here we're attempting to undo it in a way as imperceptible to the user as possible.
                // Imperceptible here means that a transition animation cannot be used.
                style.transition = 'none';
                style.top = newTop;
            }
        });
        observer.observe(parentElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupContainerRef,
        portalContainer,
        updatePosition
    ]);
};
function $709c5a5818d3675c$var$_temp(_mutationsList, observer) {
    const accessibleDiv = document.getElementById("toolbar-alert");
    if (accessibleDiv instanceof HTMLElement) {
        accessibleDiv?.setAttribute("role", "alert");
        accessibleDiv?.setAttribute("aria-live", "polite");
        observer.disconnect();
    }
}
function $709c5a5818d3675c$var$_temp2() {
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    if (!portalContainer) return;
    const screenreaderCb = $709c5a5818d3675c$var$_temp;
    const observer_0 = new MutationObserver(screenreaderCb);
    observer_0.observe(portalContainer, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer_0.disconnect();
    };
}
module.exports["Popup"] = $709c5a5818d3675c$export$129a32eedafa97c5;

});

parcelRegister("l7fKC", function(module, exports) {
/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $8hoW2 = parcelRequire("8hoW2");


var $9jB2n = parcelRequire("9jB2n");


var $12Oyv = parcelRequire("12Oyv");


var $j0UQK = parcelRequire("j0UQK");

const $a3c14e992c9fdb13$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $a3c14e992c9fdb13$export$4c260019440d418f = ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, $a3c14e992c9fdb13$var$styles.toolbarResponsive, $a3c14e992c9fdb13$var$styles.hiddenSelectors, $a3c14e992c9fdb13$var$styles.toolbarSeparator, $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j0UQK.ViewEventEmitter), {
                actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $l998X.jsx)((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveWrapper), {
        children: wrappedToolbar
    });
};
const $a3c14e992c9fdb13$export$7469f9986edfc2 = ({ children: children, label: label, breakpointPreset: breakpointPreset })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors),
            "aria-label": label,
            "data-toolbar-type": "primary",
            children: children
        })
    });
};
module.exports["Toolbar"] = $a3c14e992c9fdb13$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $a3c14e992c9fdb13$export$7469f9986edfc2;

});

parcelRegister("9jB2n", function(module, exports) {
/* ResponsiveContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-container-queries */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");

const $bc8e1bf6110fb52a$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssueUpdated: "_152xglyw _1cn41ule _1j4d1ule _1n52glyw _1nd71ule _lf431ule _103bglyw _1p0z1ule _g5yu1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmCommentUpdated: "_s2iiglyw _o4331ule _1u301ule _u7j1glyw _c7al1ule _14ob1ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $bc8e1bf6110fb52a$var$presetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpage,
    reduced: $bc8e1bf6110fb52a$var$styles.reduced,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssue,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmComment,
    'confluence-comment': $bc8e1bf6110fb52a$var$styles.confluenceComment
};
const $bc8e1bf6110fb52a$var$updatedPresetStyleMap = {
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssueUpdated,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmCommentUpdated
};
const $bc8e1bf6110fb52a$export$e60a4704009a0009 = ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (0, $1oCLl.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $bc8e1bf6110fb52a$var$updatedPresetStyleMap;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, isUpdatedConfig ? $bc8e1bf6110fb52a$var$updatedPresetStyleMap[breakpointPreset] : $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset]),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $bc8e1bf6110fb52a$export$fa6e408d6a7d6214 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $bc8e1bf6110fb52a$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $bc8e1bf6110fb52a$export$fa6e408d6a7d6214;

});

parcelRegister("12Oyv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");

const $b79e6ddf5e0c34a1$export$881345eb2554ea9e = ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            const currentIndex = focusableElements.findIndex((el)=>el === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            let index = doc?.activeElement ? focusableElements.findIndex((el)=>el === doc?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
            focusableElements[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) handleFocus(event);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
module.exports["ToolbarKeyboardNavigationProvider"] = $b79e6ddf5e0c34a1$export$881345eb2554ea9e;

});

parcelRegister("j0UQK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $e7817ef9ea32a2ec$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $e7817ef9ea32a2ec$export$58d0f383acf77599 = ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    (0, $42omo.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $e7817ef9ea32a2ec$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $e7817ef9ea32a2ec$export$58d0f383acf77599;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("bEdUx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4JDbp = parcelRequire("4JDbp");


var $9wGTI = parcelRequire("9wGTI");


var $e4o8D = parcelRequire("e4o8D");

const $cef29f59925fac19$var$baseStyles = null; // This z-index value is higher than the sticky table header
const $cef29f59925fac19$var$zIndex11Styles = null; // This z-index value is higher than the content header
const $cef29f59925fac19$var$zIndex13Styles = null;
const $cef29f59925fac19$export$873f34bfb1875202 = 'highlight-actions-portal-container';
let $cef29f59925fac19$var$popupPortalContainerWidth;
function $cef29f59925fac19$var$onResize(width) {
    // Hide popup when the container is resized.
    if (width !== $cef29f59925fac19$var$popupPortalContainerWidth) {
        $cef29f59925fac19$var$popupPortalContainerWidth = width;
        window.dispatchEvent(new CustomEvent('highlight-actions.container.resized'));
    }
}
const $cef29f59925fac19$export$8b383aca014c1850 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("div", {
            id: $cef29f59925fac19$export$873f34bfb1875202,
            className: (0, $gMc0m.default)([
                "_1reoewfl _18m9ewfl _kqswh2mm",
                (0, $9wGTI.fg)("confluence_highlight_actions_zindex_fix") ? "_1pbyibnn" : "_1pbyilow"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $4JDbp.WidthObserver), {
            setWidth: $cef29f59925fac19$var$onResize
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: $cef29f59925fac19$export$873f34bfb1875202,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm",
            (0, $9wGTI.fg)('confluence_highlight_actions_zindex_fix') ? "_1pbyibnn" : "_1pbyilow"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $4JDbp.WidthObserver), {
        setWidth: $cef29f59925fac19$var$onResize
    }));
}; // Only renders the Highlight Actions Provider if we're using Nav4
const $cef29f59925fac19$export$68a992a5cacaa78b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    if (renderServerPlaceholder) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return /*#__PURE__*/ $42omo.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
};
module.exports["popupPortalContainerId"] = $cef29f59925fac19$export$873f34bfb1875202;
module.exports["HighlightActionsProviderForNav4"] = $cef29f59925fac19$export$68a992a5cacaa78b;

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("l4eiF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $79f107ddc4d1b489$var$defaultState = {
    firstHighlightShown: false
};
const $79f107ddc4d1b489$export$ca9047e33beaf8b2 = (0, $42omo.createContext)($79f107ddc4d1b489$var$defaultState);
$79f107ddc4d1b489$export$ca9047e33beaf8b2.displayName = 'HighlightActionsContext';
module.exports["HighlightActionsContext"] = $79f107ddc4d1b489$export$ca9047e33beaf8b2;

});

parcelRegister("b1ynj", function(module, exports) {
/* OtherActions.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $4KS7f = parcelRequire("4KS7f");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $1s5hv = parcelRequire("1s5hv");


var $9VJDA = parcelRequire("9VJDA");


var $jdPfT = parcelRequire("jdPfT");


var $tvI67 = parcelRequire("tvI67");


var $lGgRw = parcelRequire("lGgRw");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $gj7hi = parcelRequire("gj7hi");


var $inPa6 = parcelRequire("inPa6");




var $2GVu1 = parcelRequire("2GVu1");

var $6UWPx = parcelRequire("6UWPx");

var $bTiiT = parcelRequire("bTiiT");

var $iIVVb = parcelRequire("iIVVb");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4vC63 = parcelRequire("4vC63");


var $9fBoq = parcelRequire("9fBoq");


var $4GDP8 = parcelRequire("4GDP8");


var $1mDVg = parcelRequire("1mDVg");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $f5df649ae1312176$var$i18n = (0, $aXWIB.defineMessages)({
    selectApp: {
        id: "highlight-actions.select.app",
        defaultMessage: "Select app"
    },
    apps: {
        id: "highlight-actions.dropdown-group.apps",
        defaultMessage: "Apps"
    }
});
const $f5df649ae1312176$var$oldDropdownTriggerWrapperStyle = null;
const $f5df649ae1312176$var$dropdownTriggerWrapperStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5df649ae1312176$var$PopupPaddingContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt44ar7",
            __cmplp.className
        ])
    });
});
const $f5df649ae1312176$var$dropdownComponentListStyle = null;
const $f5df649ae1312176$var$iconImageStyle = null;
const $f5df649ae1312176$var$noIconWrapperStyle = null;
const $f5df649ae1312176$export$c01fdef1354c759b = ({ builtInActions: builtInActions = [], connectItems: connectItems, forgeItems: forgeItems = [], selectForgeExtension: selectForgeExtension = ()=>{} })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const fireOverflowMenuAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                name: 'button clicked - highlightActionsMenuOverflow',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuOverflow',
                source: 'highlightActionsMenu',
                type: 'ui',
                attributes: {
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const connectComponents = (0, $42omo.useMemo)(()=>connectItems.map((item)=>{
            if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $42omo.createElement((0, $2GVu1.ToolbarDropdownItem), {
                key: item.completeKey,
                "data-vc": "link-item",
                "data-key": item.completeKey,
                href: item.url,
                title: item.label,
                shouldTitleWrap: false,
                elemBefore: item?.icon?.path ? /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
                    src: item.icon.path,
                    alt: item.label,
                    className: (0, $gMc0m.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    size: "small",
                    label: ""
                })
            }, item.label);
            return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ $42omo.createElement("div", {
                className: item.styleClass
            }, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
                key: item.completeKey,
                "data-key": item.completeKey,
                href: item.url,
                title: item.label,
                shouldTitleWrap: false,
                elemBefore: item?.icon?.path ? /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
                    src: item.icon.path,
                    className: (0, $gMc0m.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: ""
                })
            }, item.label)) : /*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                iconBefore: item?.icon?.path ? /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
                    src: item.icon.path,
                    className: (0, $gMc0m.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $42omo.createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_2rko1rr0 _1bsb1tcg _4t3i1tcg _bfhkby5v _1e0c1txw _4cvr1h6o _1bah1b1v"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: "No icon",
                    color: "var(--ds-icon-disabled, #080F214A)"
                })),
                key: item.completeKey,
                appearance: "subtle",
                "data-key": item.completeKey,
                className: item.styleClass,
                href: item.url,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    textAlign: 'left',
                    // we can't wrap Button with `styled` as inner styles override this
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderRadius: 0
                },
                shouldFitContainer: true,
                title: item.label
            }, item.label);
        }), [
        connectItems
    ]);
    const forgeComponents = (0, $42omo.useMemo)(()=>forgeItems.map((item)=>{
            const appTitle = (0, $9fBoq.extensionTitle)(item);
            if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $42omo.createElement((0, $2GVu1.ToolbarDropdownItem), {
                key: item.id,
                title: appTitle,
                shouldTitleWrap: false,
                elemBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    size: "small",
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                }
            }, appTitle));
            return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $42omo.createElement((0, $dAYOx.default), {
                key: item.id,
                title: appTitle,
                shouldTitleWrap: false,
                elemBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                }
            }, appTitle)) : /*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                key: item.id,
                id: item.id,
                appearance: "subtle",
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    textAlign: 'left',
                    // we can't wrap Button with `styled` as inner styles override this
                    paddingLeft: connectItems.length ? '40px' : '8px',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderRadius: 0
                },
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                },
                shouldFitContainer: true,
                title: appTitle
            }, appTitle));
        }), [
        connectItems,
        forgeItems,
        selectForgeExtension,
        experienceTracker
    ]);
    const forgeKeyboardShortcuts = (0, $42omo.useMemo)(()=>forgeItems.map((module)=>/*#__PURE__*/ $42omo.createElement((0, $4vC63.ForgeKeyboardShortcut), {
                key: module.id,
                module: module,
                action: ()=>{
                    (0, $4GDP8.openContextMenuClick)();
                    (0, $4GDP8.simulateItemClick)(module.id);
                    (0, $4GDP8.simulateItemMouseOver)(module.id);
                }
            })), [
        forgeItems
    ]);
    const dropDownComponents = (0, $42omo.useMemo)(()=>{
        const oldToolbarComponents = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $42omo.createElement((0, $ahaN7.default), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)) : /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_18s8ax2b _1e0c1txw _2lx21bp4 _ca0qu2gc _n3tdu2gc _18m91wug _c71l1mjv _p12f1mjv"
            ])
        }, connectComponents, forgeComponents);
        return isNewToolbarEnabled ? /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $6UWPx.ToolbarDropdownItemSection), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $42omo.createElement((0, $6UWPx.ToolbarDropdownItemSection), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)) : oldToolbarComponents;
    }, [
        isNewToolbarEnabled,
        builtInActions,
        connectItems.length,
        forgeItems.length,
        intl,
        connectComponents,
        forgeComponents
    ]);
    if (isNewToolbarEnabled) {
        if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
        if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $42omo.createElement((0, $bTiiT.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                size: "small"
            }),
            id: "context-menu-other-apps",
            testId: "context-menu-other-apps",
            onClick: fireOverflowMenuAnalytics,
            tooltipComponent: /*#__PURE__*/ $42omo.createElement((0, $iIVVb.ToolbarTooltip), {
                content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
            })
        }, dropDownComponents, forgeKeyboardShortcuts);
        return /*#__PURE__*/ $42omo.createElement((0, $iIVVb.ToolbarTooltip), {
            content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
        }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            isOpen: isOpen,
            onOpenChange: (attrs)=>{
                setIsOpen(attrs.isOpen);
            },
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ $42omo.createElement("div", {
                    ...triggerProps,
                    ref: triggerRef,
                    id: "context-menu-other-apps",
                    "data-testid": "context-menu-other-apps",
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _u5f31b66"
                    ])
                }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                    appearance: "subtle",
                    isSelected: isOpen,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false,
                    label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                    testId: "highlight-actions-show-more",
                    onClick: fireOverflowMenuAnalytics
                }), forgeKeyboardShortcuts)
        }, dropDownComponents));
    }
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
    } else {
        if (!connectItems.length && !forgeItems.length) return null;
    }
    return (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isOpen,
        onOpenChange: (attrs)=>{
            setIsOpen(attrs.isOpen);
        },
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement("div", {
                ...triggerProps,
                ref: triggerProps.triggerRef,
                id: "context-menu-other-apps",
                "data-testid": "context-menu-other-apps",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _u5f31b66"
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                appearance: "subtle",
                isSelected: isOpen,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                isTooltipDisabled: false,
                label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                testId: "highlight-actions-show-more",
                onClick: fireOverflowMenuAnalytics
            }), forgeKeyboardShortcuts)
    }, dropDownComponents) : /*#__PURE__*/ $42omo.createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ $42omo.createElement($f5df649ae1312176$var$PopupPaddingContainer, null, dropDownComponents),
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement("div", {
                ...triggerProps,
                className: (0, $gMc0m.default)([
                    (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && "_1yt4v77o _1e0c1txw _4cvr1h6o _f7xt1osq _16711osq _5jgi1h6o _1d841h6o"
                ])
            }, /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
                content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
            }, (tooltipProps)=>/*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
                    ...tooltipProps,
                    id: "context-menu-other-apps",
                    "aria-expanded": isOpen,
                    appearance: "subtle",
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    iconBefore: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "",
                        spacing: "spacious",
                        testId: "highlight-actions-show-more"
                    }) : /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
                        alignItems: "center",
                        gap: "space.050"
                    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                        label: ""
                    }), /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "Drop down",
                        testId: "highlight-actions-show-more",
                        size: "small"
                    })),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        margin: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? undefined : "var(--ds-space-025, 2px)",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        marginLeft: "var(--ds-space-negative-025, -2px)"
                    },
                    testId: "context-menu-other-apps"
                })), forgeKeyboardShortcuts),
        shouldRenderToParent: true
    });
};
module.exports["OtherActions"] = $f5df649ae1312176$export$c01fdef1354c759b;

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $16xFS = parcelRequire("16xFS");


var $lGgRw = parcelRequire("lGgRw");


var $g5lKx = parcelRequire("g5lKx");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $g5lKx.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $16xFS = parcelRequire("16xFS");


var $ijhQY = parcelRequire("ijhQY");


var $6wMCT = parcelRequire("6wMCT");

/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6wMCT.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $6wMCT = parcelRequire("6wMCT");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $6wMCT.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $dh538.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5g4rt = parcelRequire("5g4rt");

/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5g4rt.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("5g4rt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $19b5453b5db39d0b$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
module.exports["SelectionStoreContext"] = $19b5453b5db39d0b$export$756f795847463ebd;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("bflGB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lisKW = parcelRequire("lisKW");

parcelRequire("4ARHe");


var $l65Bo = parcelRequire("l65Bo");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback = function(...[e, element, combo]) {
        const isAllowed = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS).map((className)=>element.classList.contains(className)).some((truthful)=>truthful);
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            if ((0, $9wGTI.fg)("confluence_frontend_shortcut_deprecation_flag")) (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("lisKW", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("4ARHe", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    'ProseMirror-focused',
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $aXWIB.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_zulpv77o _1e0c1txw _4cvr1h6o"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 604800000);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("dj3mI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $54a4a16d7bb73c56$export$52cdeba2896092f6 = (isContentArchived, userCanAddComments, needsUpdateToComment, contentType)=>{
    if (isContentArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unsupported.archive",
        defaultMessage: "Comments can\u2019t be added to archived items"
    });
    else if (!userCanAddComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.no.permission",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}",
        values: {
            contentType: contentType
        }
    });
    else if (needsUpdateToComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.needs.update",
        defaultMessage: "Page is outdated, refresh to comment"
    });
    else if ((0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unable.to.create",
        defaultMessage: "Unable to comment on this element"
    });
    else return (0, $9wGTI.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.create.disabled",
        defaultMessage: "You can only comment on text, headings, emojis, dates, mentions, links, and statuses."
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unsupported",
        defaultMessage: "Comments can only be added to text that doesn\u2019t contain an emoji, a macro, or an @mention"
    });
};
module.exports["getCreateButtonDisabledMessage"] = $54a4a16d7bb73c56$export$52cdeba2896092f6;

});

parcelRegister("6zmDz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $164fd7006e7d8160$export$c5fb2fd13b5122a = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$export$8729c6345a54240d = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _wzf91osq _9uby1osq _1dbr1txw _14ts1txw _1mu51h6o _wfjv1h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _wzf91osq _9uby1osq _1dbr1txw _14ts1txw _1mu51h6o _wfjv1h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ])
    });
}); // remove this when cleanup platform_editor_controls
const $164fd7006e7d8160$export$d7f009f4a3abb74 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41b66 _1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$var$disabledButtonWrapperStyle = null;
const $164fd7006e7d8160$export$b065c4c0e869841d = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_kqswh2mm"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $42omo.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    });
const $164fd7006e7d8160$var$disabledButtonOverlayStyle = null;
const $164fd7006e7d8160$export$dea79eb12e1f6e1f = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1pby15gg _bfhk1j28 _80om13gf"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $42omo.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1pby15gg _bfhk1j28 _80om13gf"
        ])
    });
const $164fd7006e7d8160$var$dividerStyleOld = null;
const $164fd7006e7d8160$export$fb1f035d38cc4d20 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_18s81o9c _1bsbt94y _bfhk1l7x"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $42omo.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_18s81o9c _1bsbt94y _bfhk1l7x"
        ])
    });
const $164fd7006e7d8160$var$dividerStyle = null;
const $164fd7006e7d8160$export$2e0a83ec2e27ecbb = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_1bsbt94y _bfhk1l7x _18u01b66 _2hwx1b66 _19pkr5cr _otyrr5cr"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $42omo.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $42omo.createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsbt94y _bfhk1l7x _18u01b66 _2hwx1b66 _19pkr5cr _otyrr5cr"
        ])
    });
module.exports["BuiltInActionsOld"] = $164fd7006e7d8160$export$c5fb2fd13b5122a;
module.exports["BuiltInActionsPatch"] = $164fd7006e7d8160$export$8729c6345a54240d;
module.exports["BuiltInActionsSimple"] = $164fd7006e7d8160$export$d7f009f4a3abb74;
module.exports["DisabledButtonWrapper"] = $164fd7006e7d8160$export$b065c4c0e869841d;
module.exports["DisabledButtonOverlay"] = $164fd7006e7d8160$export$dea79eb12e1f6e1f;
module.exports["DividerOld"] = $164fd7006e7d8160$export$fb1f035d38cc4d20;
module.exports["Divider"] = $164fd7006e7d8160$export$2e0a83ec2e27ecbb;

});

parcelRegister("97kfW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $12914a8fd53705f4$var$lightBlueColor = '#2684FF';
const $12914a8fd53705f4$var$blueColor = '#0052CC';
const $12914a8fd53705f4$var$greyColor = "var(--ds-icon-disabled, #080F214A)";
const $12914a8fd53705f4$export$eaf821108be3620b = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(53);
    const { greyed: t1, size: t2 } = t0;
    const greyed = t1 === undefined ? false : t1;
    const size = t2 === undefined ? "small" : t2;
    const t3 = size === "smaller" ? "16" : size === "small" ? "18" : "24";
    const t4 = size === "smaller" ? "16" : size === "small" ? "18" : "24";
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.1699 12C17.1699 11.4477 17.6176 11 18.1699 11H19.9999C20.5522 11 20.9999 11.4477 20.9999 12C20.9999 12.5523 20.5522 13 19.9999 13H18.1699C17.6176 13 17.1699 12.5523 17.1699 12Z",
            fill: "url(#paint0_linear_1733_293438)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
            fill: "url(#paint1_linear_1733_293438)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
            fill: "url(#paint2_linear_1733_293438)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 17.1699C12.5523 17.1699 13 17.6176 13 18.1699V19.9999C13 20.5522 12.5523 20.9999 12 20.9999C11.4477 20.9999 11 20.5522 11 19.9999V18.1699C11 17.6176 11.4477 17.1699 12 17.1699Z",
            fill: "url(#paint3_linear_1733_293438)"
        });
        $[0] = t5;
        $[1] = t6;
        $[2] = t7;
        $[3] = t8;
    } else {
        t5 = $[0];
        t6 = $[1];
        t7 = $[2];
        t8 = $[3];
    }
    const t9 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t10;
    if ($[4] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
            fill: t9
        });
        $[4] = t9;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t12;
    if ($[6] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z",
            fill: t11
        });
        $[6] = t11;
        $[7] = t12;
    } else t12 = $[7];
    const t13 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t14;
    if ($[8] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: t13
        });
        $[8] = t13;
        $[9] = t14;
    } else t14 = $[9];
    const t15 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t16;
    if ($[10] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
            fill: t15
        });
        $[10] = t15;
        $[11] = t16;
    } else t16 = $[11];
    const t17 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t18;
    if ($[12] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.270833",
            stopColor: t17
        });
        $[12] = t17;
        $[13] = t18;
    } else t18 = $[13];
    const t19 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t20;
    if ($[14] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "1",
            stopColor: t19
        });
        $[14] = t19;
        $[15] = t20;
    } else t20 = $[15];
    let t21;
    if ($[16] !== t18 || $[17] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint0_linear_1733_293438",
            x1: "20.9999",
            y1: "12",
            x2: "17.4999",
            y2: "12",
            gradientUnits: "userSpaceOnUse"
        }, t18, t20);
        $[16] = t18;
        $[17] = t20;
        $[18] = t21;
    } else t21 = $[18];
    const t22 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t23;
    if ($[19] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.1875",
            stopColor: t22
        });
        $[19] = t22;
        $[20] = t23;
    } else t23 = $[20];
    const t24 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t25;
    if ($[21] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "1",
            stopColor: t24
        });
        $[21] = t24;
        $[22] = t25;
    } else t25 = $[22];
    let t26;
    if ($[23] !== t23 || $[24] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint1_linear_1733_293438",
            x1: "12.5",
            y1: "3",
            x2: "12.5",
            y2: "6.5",
            gradientUnits: "userSpaceOnUse"
        }, t23, t25);
        $[23] = t23;
        $[24] = t25;
        $[25] = t26;
    } else t26 = $[25];
    const t27 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t28;
    if ($[26] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            stopColor: t27
        });
        $[26] = t27;
        $[27] = t28;
    } else t28 = $[27];
    const t29 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t30;
    if ($[28] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.791667",
            stopColor: t29
        });
        $[28] = t29;
        $[29] = t30;
    } else t30 = $[29];
    let t31;
    if ($[30] !== t28 || $[31] !== t30) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint2_linear_1733_293438",
            x1: "6.82996",
            y1: "12",
            x2: "3.32996",
            y2: "12",
            gradientUnits: "userSpaceOnUse"
        }, t28, t30);
        $[30] = t28;
        $[31] = t30;
        $[32] = t31;
    } else t31 = $[32];
    const t32 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t33;
    if ($[33] !== t32) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            stopColor: t32
        });
        $[33] = t32;
        $[34] = t33;
    } else t33 = $[34];
    const t34 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t35;
    if ($[35] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.802083",
            stopColor: t34
        });
        $[35] = t34;
        $[36] = t35;
    } else t35 = $[36];
    let t36;
    if ($[37] !== t33 || $[38] !== t35) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint3_linear_1733_293438",
            x1: "12.5",
            y1: "16.9999",
            x2: "12.5",
            y2: "20.9999",
            gradientUnits: "userSpaceOnUse"
        }, t33, t35);
        $[37] = t33;
        $[38] = t35;
        $[39] = t36;
    } else t36 = $[39];
    let t37;
    if ($[40] !== t21 || $[41] !== t26 || $[42] !== t31 || $[43] !== t36) {
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t21, t26, t31, t36);
        $[40] = t21;
        $[41] = t26;
        $[42] = t31;
        $[43] = t36;
        $[44] = t37;
    } else t37 = $[44];
    let t38;
    if ($[45] !== t10 || $[46] !== t12 || $[47] !== t14 || $[48] !== t16 || $[49] !== t3 || $[50] !== t37 || $[51] !== t4) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: t3,
            height: t4,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t5, t6, t7, t8, t10, t12, t14, t16, t37);
        $[45] = t10;
        $[46] = t12;
        $[47] = t14;
        $[48] = t16;
        $[49] = t3;
        $[50] = t37;
        $[51] = t4;
        $[52] = t38;
    } else t38 = $[52];
    return t38;
} : ({ greyed: greyed = false, size: size = 'small' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : '24',
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.1699 12C17.1699 11.4477 17.6176 11 18.1699 11H19.9999C20.5522 11 20.9999 11.4477 20.9999 12C20.9999 12.5523 20.5522 13 19.9999 13H18.1699C17.6176 13 17.1699 12.5523 17.1699 12Z",
        fill: "url(#paint0_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "url(#paint1_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "url(#paint2_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.1699C12.5523 17.1699 13 17.6176 13 18.1699V19.9999C13 20.5522 12.5523 20.9999 12 20.9999C11.4477 20.9999 11 20.5522 11 19.9999V18.1699C11 17.6176 11.4477 17.1699 12 17.1699Z",
        fill: "url(#paint3_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_1733_293438",
        x1: "20.9999",
        y1: "12",
        x2: "17.4999",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.270833",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint1_linear_1733_293438",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.1875",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint2_linear_1733_293438",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.791667",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint3_linear_1733_293438",
        x1: "12.5",
        y1: "16.9999",
        x2: "12.5",
        y2: "20.9999",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.802083",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }))));
module.exports["AtlassianIntelligenceIcon"] = $12914a8fd53705f4$export$eaf821108be3620b;

});

parcelRegister("5iBet", function(module, exports) {

let $3dbb83cc91d556d0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3dbb83cc91d556d0$var$load("hpN5y").then(()=>parcelRequire('jhEjP'));

});

parcelRegister("eJvrZ", function(module, exports) {

let $ab9daa12e78f0869$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab9daa12e78f0869$var$load("6wr18"),
    $ab9daa12e78f0869$var$load("ffEVr"),
    $ab9daa12e78f0869$var$load("dP7ao"),
    $ab9daa12e78f0869$var$load("aSmvL")
]).then(()=>parcelRequire('1TWCG'));

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("lXnaE"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("4EDQB"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("63Sa6"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("KFpBB"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("4e9mM"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("gcnRn"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("i52gf"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("4doEc"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("kFJwL"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("5shOo"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("3Hycf"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("5S3Gg"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("lXnaE", function(module, exports) {

let $ffc114e09dca3abb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffc114e09dca3abb$var$load("2YffH"),
    $ffc114e09dca3abb$var$load("1o23t"),
    $ffc114e09dca3abb$var$load("b7OPx"),
    $ffc114e09dca3abb$var$load("lqFMg"),
    $ffc114e09dca3abb$var$load("gELW6"),
    $ffc114e09dca3abb$var$load("4hDGB"),
    $ffc114e09dca3abb$var$load("7o5Pu"),
    $ffc114e09dca3abb$var$load("1H5IN"),
    $ffc114e09dca3abb$var$load("eBRUf"),
    $ffc114e09dca3abb$var$load("hwT9D"),
    $ffc114e09dca3abb$var$load("j4Bpe"),
    $ffc114e09dca3abb$var$load("h4Nf7"),
    $ffc114e09dca3abb$var$load("7f9Fz"),
    $ffc114e09dca3abb$var$load("8YSo7"),
    $ffc114e09dca3abb$var$load("7do1E"),
    $ffc114e09dca3abb$var$load("77dkW"),
    $ffc114e09dca3abb$var$load("g9CVe"),
    $ffc114e09dca3abb$var$load("9hYRW"),
    $ffc114e09dca3abb$var$load("kpm7S"),
    $ffc114e09dca3abb$var$load("6wr18"),
    $ffc114e09dca3abb$var$load("kjZZD"),
    $ffc114e09dca3abb$var$load("3JSgG"),
    $ffc114e09dca3abb$var$load("9AXkC"),
    $ffc114e09dca3abb$var$load("ffEVr"),
    $ffc114e09dca3abb$var$load("28arV"),
    $ffc114e09dca3abb$var$load("l1BQC"),
    $ffc114e09dca3abb$var$load("jlSF3"),
    $ffc114e09dca3abb$var$load("2vAWg"),
    $ffc114e09dca3abb$var$load("7cABH"),
    $ffc114e09dca3abb$var$load("31vk5"),
    $ffc114e09dca3abb$var$load("4pqtR"),
    $ffc114e09dca3abb$var$load("5XqRg"),
    $ffc114e09dca3abb$var$load("2uVTT"),
    $ffc114e09dca3abb$var$load("hhss7"),
    $ffc114e09dca3abb$var$load("Wowvf"),
    $ffc114e09dca3abb$var$load("5RR9C"),
    $ffc114e09dca3abb$var$load("2PePB"),
    $ffc114e09dca3abb$var$load("bIPPg"),
    $ffc114e09dca3abb$var$load("lnKog"),
    $ffc114e09dca3abb$var$load("h3ABO"),
    $ffc114e09dca3abb$var$load("kC80R"),
    $ffc114e09dca3abb$var$load("7EorR"),
    $ffc114e09dca3abb$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("4EDQB", function(module, exports) {

let $3639ceb76464ee37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3639ceb76464ee37$var$load("2YffH"),
    $3639ceb76464ee37$var$load("1o23t"),
    $3639ceb76464ee37$var$load("b7OPx"),
    $3639ceb76464ee37$var$load("lqFMg"),
    $3639ceb76464ee37$var$load("gELW6"),
    $3639ceb76464ee37$var$load("4hDGB"),
    $3639ceb76464ee37$var$load("7o5Pu"),
    $3639ceb76464ee37$var$load("1H5IN"),
    $3639ceb76464ee37$var$load("eBRUf"),
    $3639ceb76464ee37$var$load("hwT9D"),
    $3639ceb76464ee37$var$load("j4Bpe"),
    $3639ceb76464ee37$var$load("h4Nf7"),
    $3639ceb76464ee37$var$load("7f9Fz"),
    $3639ceb76464ee37$var$load("8YSo7"),
    $3639ceb76464ee37$var$load("7do1E"),
    $3639ceb76464ee37$var$load("77dkW"),
    $3639ceb76464ee37$var$load("g9CVe"),
    $3639ceb76464ee37$var$load("9hYRW"),
    $3639ceb76464ee37$var$load("kpm7S"),
    $3639ceb76464ee37$var$load("6wr18"),
    $3639ceb76464ee37$var$load("kjZZD"),
    $3639ceb76464ee37$var$load("3JSgG"),
    $3639ceb76464ee37$var$load("9AXkC"),
    $3639ceb76464ee37$var$load("ffEVr"),
    $3639ceb76464ee37$var$load("28arV"),
    $3639ceb76464ee37$var$load("l1BQC"),
    $3639ceb76464ee37$var$load("jlSF3"),
    $3639ceb76464ee37$var$load("2vAWg"),
    $3639ceb76464ee37$var$load("7cABH"),
    $3639ceb76464ee37$var$load("31vk5"),
    $3639ceb76464ee37$var$load("4pqtR"),
    $3639ceb76464ee37$var$load("5XqRg"),
    $3639ceb76464ee37$var$load("2uVTT"),
    $3639ceb76464ee37$var$load("hhss7"),
    $3639ceb76464ee37$var$load("Wowvf"),
    $3639ceb76464ee37$var$load("5RR9C"),
    $3639ceb76464ee37$var$load("2PePB"),
    $3639ceb76464ee37$var$load("bIPPg"),
    $3639ceb76464ee37$var$load("lnKog"),
    $3639ceb76464ee37$var$load("h3ABO"),
    $3639ceb76464ee37$var$load("kC80R"),
    $3639ceb76464ee37$var$load("7EorR"),
    $3639ceb76464ee37$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("63Sa6", function(module, exports) {

let $469d0953f050b025$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $469d0953f050b025$var$load("2YffH"),
    $469d0953f050b025$var$load("1o23t"),
    $469d0953f050b025$var$load("b7OPx"),
    $469d0953f050b025$var$load("lqFMg"),
    $469d0953f050b025$var$load("gELW6"),
    $469d0953f050b025$var$load("4hDGB"),
    $469d0953f050b025$var$load("7o5Pu"),
    $469d0953f050b025$var$load("1H5IN"),
    $469d0953f050b025$var$load("eBRUf"),
    $469d0953f050b025$var$load("hwT9D"),
    $469d0953f050b025$var$load("j4Bpe"),
    $469d0953f050b025$var$load("h4Nf7"),
    $469d0953f050b025$var$load("7f9Fz"),
    $469d0953f050b025$var$load("8YSo7"),
    $469d0953f050b025$var$load("7do1E"),
    $469d0953f050b025$var$load("77dkW"),
    $469d0953f050b025$var$load("g9CVe"),
    $469d0953f050b025$var$load("9hYRW"),
    $469d0953f050b025$var$load("kpm7S"),
    $469d0953f050b025$var$load("6wr18"),
    $469d0953f050b025$var$load("kjZZD"),
    $469d0953f050b025$var$load("3JSgG"),
    $469d0953f050b025$var$load("9AXkC"),
    $469d0953f050b025$var$load("ffEVr"),
    $469d0953f050b025$var$load("28arV"),
    $469d0953f050b025$var$load("l1BQC"),
    $469d0953f050b025$var$load("jlSF3"),
    $469d0953f050b025$var$load("2vAWg"),
    $469d0953f050b025$var$load("7cABH"),
    $469d0953f050b025$var$load("31vk5"),
    $469d0953f050b025$var$load("4pqtR"),
    $469d0953f050b025$var$load("5XqRg"),
    $469d0953f050b025$var$load("2uVTT"),
    $469d0953f050b025$var$load("hhss7"),
    $469d0953f050b025$var$load("Wowvf"),
    $469d0953f050b025$var$load("5RR9C"),
    $469d0953f050b025$var$load("2PePB"),
    $469d0953f050b025$var$load("bIPPg"),
    $469d0953f050b025$var$load("lnKog"),
    $469d0953f050b025$var$load("h3ABO"),
    $469d0953f050b025$var$load("kC80R"),
    $469d0953f050b025$var$load("7EorR"),
    $469d0953f050b025$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("KFpBB", function(module, exports) {

let $08c46b8d298251cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08c46b8d298251cc$var$load("7do1E"),
    $08c46b8d298251cc$var$load("77dkW"),
    $08c46b8d298251cc$var$load("2YffH"),
    $08c46b8d298251cc$var$load("b7OPx"),
    $08c46b8d298251cc$var$load("lqFMg"),
    $08c46b8d298251cc$var$load("gELW6"),
    $08c46b8d298251cc$var$load("4hDGB"),
    $08c46b8d298251cc$var$load("2PePB"),
    $08c46b8d298251cc$var$load("eBRUf"),
    $08c46b8d298251cc$var$load("hwT9D"),
    $08c46b8d298251cc$var$load("j4Bpe"),
    $08c46b8d298251cc$var$load("h4Nf7"),
    $08c46b8d298251cc$var$load("7f9Fz"),
    $08c46b8d298251cc$var$load("8YSo7"),
    $08c46b8d298251cc$var$load("g9CVe"),
    $08c46b8d298251cc$var$load("9hYRW"),
    $08c46b8d298251cc$var$load("kpm7S"),
    $08c46b8d298251cc$var$load("6wr18"),
    $08c46b8d298251cc$var$load("kjZZD"),
    $08c46b8d298251cc$var$load("3JSgG"),
    $08c46b8d298251cc$var$load("9AXkC"),
    $08c46b8d298251cc$var$load("ffEVr"),
    $08c46b8d298251cc$var$load("28arV"),
    $08c46b8d298251cc$var$load("l1BQC"),
    $08c46b8d298251cc$var$load("jlSF3"),
    $08c46b8d298251cc$var$load("2vAWg"),
    $08c46b8d298251cc$var$load("7cABH"),
    $08c46b8d298251cc$var$load("31vk5"),
    $08c46b8d298251cc$var$load("4pqtR"),
    $08c46b8d298251cc$var$load("5XqRg"),
    $08c46b8d298251cc$var$load("bIPPg"),
    $08c46b8d298251cc$var$load("2uVTT"),
    $08c46b8d298251cc$var$load("hhss7"),
    $08c46b8d298251cc$var$load("Wowvf"),
    $08c46b8d298251cc$var$load("5RR9C"),
    $08c46b8d298251cc$var$load("h3ABO"),
    $08c46b8d298251cc$var$load("kC80R"),
    $08c46b8d298251cc$var$load("7EorR"),
    $08c46b8d298251cc$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("4e9mM", function(module, exports) {

let $313fbc2f3844e0dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $313fbc2f3844e0dc$var$load("7do1E"),
    $313fbc2f3844e0dc$var$load("77dkW"),
    $313fbc2f3844e0dc$var$load("2YffH"),
    $313fbc2f3844e0dc$var$load("b7OPx"),
    $313fbc2f3844e0dc$var$load("lqFMg"),
    $313fbc2f3844e0dc$var$load("gELW6"),
    $313fbc2f3844e0dc$var$load("4hDGB"),
    $313fbc2f3844e0dc$var$load("2PePB"),
    $313fbc2f3844e0dc$var$load("eBRUf"),
    $313fbc2f3844e0dc$var$load("hwT9D"),
    $313fbc2f3844e0dc$var$load("j4Bpe"),
    $313fbc2f3844e0dc$var$load("h4Nf7"),
    $313fbc2f3844e0dc$var$load("7f9Fz"),
    $313fbc2f3844e0dc$var$load("8YSo7"),
    $313fbc2f3844e0dc$var$load("g9CVe"),
    $313fbc2f3844e0dc$var$load("9hYRW"),
    $313fbc2f3844e0dc$var$load("kpm7S"),
    $313fbc2f3844e0dc$var$load("6wr18"),
    $313fbc2f3844e0dc$var$load("kjZZD"),
    $313fbc2f3844e0dc$var$load("3JSgG"),
    $313fbc2f3844e0dc$var$load("9AXkC"),
    $313fbc2f3844e0dc$var$load("ffEVr"),
    $313fbc2f3844e0dc$var$load("28arV"),
    $313fbc2f3844e0dc$var$load("l1BQC"),
    $313fbc2f3844e0dc$var$load("jlSF3"),
    $313fbc2f3844e0dc$var$load("2vAWg"),
    $313fbc2f3844e0dc$var$load("7cABH"),
    $313fbc2f3844e0dc$var$load("31vk5"),
    $313fbc2f3844e0dc$var$load("4pqtR"),
    $313fbc2f3844e0dc$var$load("5XqRg"),
    $313fbc2f3844e0dc$var$load("bIPPg"),
    $313fbc2f3844e0dc$var$load("2uVTT"),
    $313fbc2f3844e0dc$var$load("hhss7"),
    $313fbc2f3844e0dc$var$load("Wowvf"),
    $313fbc2f3844e0dc$var$load("5RR9C"),
    $313fbc2f3844e0dc$var$load("h3ABO"),
    $313fbc2f3844e0dc$var$load("kC80R"),
    $313fbc2f3844e0dc$var$load("7EorR"),
    $313fbc2f3844e0dc$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("gcnRn", function(module, exports) {

let $bcb04664b0e7f05a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bcb04664b0e7f05a$var$load("7do1E"),
    $bcb04664b0e7f05a$var$load("77dkW"),
    $bcb04664b0e7f05a$var$load("2YffH"),
    $bcb04664b0e7f05a$var$load("b7OPx"),
    $bcb04664b0e7f05a$var$load("lqFMg"),
    $bcb04664b0e7f05a$var$load("gELW6"),
    $bcb04664b0e7f05a$var$load("4hDGB"),
    $bcb04664b0e7f05a$var$load("2PePB"),
    $bcb04664b0e7f05a$var$load("eBRUf"),
    $bcb04664b0e7f05a$var$load("hwT9D"),
    $bcb04664b0e7f05a$var$load("j4Bpe"),
    $bcb04664b0e7f05a$var$load("h4Nf7"),
    $bcb04664b0e7f05a$var$load("7f9Fz"),
    $bcb04664b0e7f05a$var$load("8YSo7"),
    $bcb04664b0e7f05a$var$load("g9CVe"),
    $bcb04664b0e7f05a$var$load("9hYRW"),
    $bcb04664b0e7f05a$var$load("kpm7S"),
    $bcb04664b0e7f05a$var$load("6wr18"),
    $bcb04664b0e7f05a$var$load("kjZZD"),
    $bcb04664b0e7f05a$var$load("3JSgG"),
    $bcb04664b0e7f05a$var$load("9AXkC"),
    $bcb04664b0e7f05a$var$load("ffEVr"),
    $bcb04664b0e7f05a$var$load("28arV"),
    $bcb04664b0e7f05a$var$load("l1BQC"),
    $bcb04664b0e7f05a$var$load("jlSF3"),
    $bcb04664b0e7f05a$var$load("2vAWg"),
    $bcb04664b0e7f05a$var$load("7cABH"),
    $bcb04664b0e7f05a$var$load("31vk5"),
    $bcb04664b0e7f05a$var$load("4pqtR"),
    $bcb04664b0e7f05a$var$load("5XqRg"),
    $bcb04664b0e7f05a$var$load("bIPPg"),
    $bcb04664b0e7f05a$var$load("2uVTT"),
    $bcb04664b0e7f05a$var$load("hhss7"),
    $bcb04664b0e7f05a$var$load("Wowvf"),
    $bcb04664b0e7f05a$var$load("5RR9C"),
    $bcb04664b0e7f05a$var$load("h3ABO"),
    $bcb04664b0e7f05a$var$load("kC80R"),
    $bcb04664b0e7f05a$var$load("7EorR"),
    $bcb04664b0e7f05a$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("i52gf", function(module, exports) {

let $d29a729a0db7efa2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d29a729a0db7efa2$var$load("7do1E"),
    $d29a729a0db7efa2$var$load("77dkW"),
    $d29a729a0db7efa2$var$load("2YffH"),
    $d29a729a0db7efa2$var$load("b7OPx"),
    $d29a729a0db7efa2$var$load("lqFMg"),
    $d29a729a0db7efa2$var$load("gELW6"),
    $d29a729a0db7efa2$var$load("4hDGB"),
    $d29a729a0db7efa2$var$load("eBRUf"),
    $d29a729a0db7efa2$var$load("hwT9D"),
    $d29a729a0db7efa2$var$load("j4Bpe"),
    $d29a729a0db7efa2$var$load("h4Nf7"),
    $d29a729a0db7efa2$var$load("7f9Fz"),
    $d29a729a0db7efa2$var$load("8YSo7"),
    $d29a729a0db7efa2$var$load("g9CVe"),
    $d29a729a0db7efa2$var$load("9hYRW"),
    $d29a729a0db7efa2$var$load("kpm7S"),
    $d29a729a0db7efa2$var$load("6wr18"),
    $d29a729a0db7efa2$var$load("kjZZD"),
    $d29a729a0db7efa2$var$load("3JSgG"),
    $d29a729a0db7efa2$var$load("9AXkC"),
    $d29a729a0db7efa2$var$load("ffEVr"),
    $d29a729a0db7efa2$var$load("28arV"),
    $d29a729a0db7efa2$var$load("l1BQC"),
    $d29a729a0db7efa2$var$load("jlSF3"),
    $d29a729a0db7efa2$var$load("2vAWg"),
    $d29a729a0db7efa2$var$load("7cABH"),
    $d29a729a0db7efa2$var$load("31vk5"),
    $d29a729a0db7efa2$var$load("4pqtR"),
    $d29a729a0db7efa2$var$load("5XqRg"),
    $d29a729a0db7efa2$var$load("2uVTT"),
    $d29a729a0db7efa2$var$load("hhss7"),
    $d29a729a0db7efa2$var$load("Wowvf"),
    $d29a729a0db7efa2$var$load("5RR9C"),
    $d29a729a0db7efa2$var$load("2PePB"),
    $d29a729a0db7efa2$var$load("bIPPg"),
    $d29a729a0db7efa2$var$load("lnKog"),
    $d29a729a0db7efa2$var$load("h3ABO"),
    $d29a729a0db7efa2$var$load("kC80R"),
    $d29a729a0db7efa2$var$load("7EorR"),
    $d29a729a0db7efa2$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("4doEc", function(module, exports) {

let $311b7ec1ee83a155$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $311b7ec1ee83a155$var$load("2YffH"),
    $311b7ec1ee83a155$var$load("b7OPx"),
    $311b7ec1ee83a155$var$load("lqFMg"),
    $311b7ec1ee83a155$var$load("gELW6"),
    $311b7ec1ee83a155$var$load("4hDGB"),
    $311b7ec1ee83a155$var$load("1H5IN"),
    $311b7ec1ee83a155$var$load("eBRUf"),
    $311b7ec1ee83a155$var$load("hwT9D"),
    $311b7ec1ee83a155$var$load("j4Bpe"),
    $311b7ec1ee83a155$var$load("h4Nf7"),
    $311b7ec1ee83a155$var$load("7f9Fz"),
    $311b7ec1ee83a155$var$load("8YSo7"),
    $311b7ec1ee83a155$var$load("7do1E"),
    $311b7ec1ee83a155$var$load("77dkW"),
    $311b7ec1ee83a155$var$load("g9CVe"),
    $311b7ec1ee83a155$var$load("9hYRW"),
    $311b7ec1ee83a155$var$load("kpm7S"),
    $311b7ec1ee83a155$var$load("6wr18"),
    $311b7ec1ee83a155$var$load("kjZZD"),
    $311b7ec1ee83a155$var$load("3JSgG"),
    $311b7ec1ee83a155$var$load("9AXkC"),
    $311b7ec1ee83a155$var$load("ffEVr"),
    $311b7ec1ee83a155$var$load("28arV"),
    $311b7ec1ee83a155$var$load("l1BQC"),
    $311b7ec1ee83a155$var$load("jlSF3"),
    $311b7ec1ee83a155$var$load("2vAWg"),
    $311b7ec1ee83a155$var$load("7cABH"),
    $311b7ec1ee83a155$var$load("31vk5"),
    $311b7ec1ee83a155$var$load("4pqtR"),
    $311b7ec1ee83a155$var$load("5XqRg"),
    $311b7ec1ee83a155$var$load("2uVTT"),
    $311b7ec1ee83a155$var$load("hhss7"),
    $311b7ec1ee83a155$var$load("Wowvf"),
    $311b7ec1ee83a155$var$load("5RR9C"),
    $311b7ec1ee83a155$var$load("2PePB"),
    $311b7ec1ee83a155$var$load("bIPPg"),
    $311b7ec1ee83a155$var$load("lnKog"),
    $311b7ec1ee83a155$var$load("h3ABO"),
    $311b7ec1ee83a155$var$load("kC80R"),
    $311b7ec1ee83a155$var$load("7EorR"),
    $311b7ec1ee83a155$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("kFJwL", function(module, exports) {

let $f0caf3c7b012306d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0caf3c7b012306d$var$load("2YffH"),
    $f0caf3c7b012306d$var$load("b7OPx"),
    $f0caf3c7b012306d$var$load("lqFMg"),
    $f0caf3c7b012306d$var$load("gELW6"),
    $f0caf3c7b012306d$var$load("4hDGB"),
    $f0caf3c7b012306d$var$load("1H5IN"),
    $f0caf3c7b012306d$var$load("eBRUf"),
    $f0caf3c7b012306d$var$load("hwT9D"),
    $f0caf3c7b012306d$var$load("j4Bpe"),
    $f0caf3c7b012306d$var$load("h4Nf7"),
    $f0caf3c7b012306d$var$load("7f9Fz"),
    $f0caf3c7b012306d$var$load("8YSo7"),
    $f0caf3c7b012306d$var$load("7do1E"),
    $f0caf3c7b012306d$var$load("77dkW"),
    $f0caf3c7b012306d$var$load("g9CVe"),
    $f0caf3c7b012306d$var$load("9hYRW"),
    $f0caf3c7b012306d$var$load("kpm7S"),
    $f0caf3c7b012306d$var$load("6wr18"),
    $f0caf3c7b012306d$var$load("kjZZD"),
    $f0caf3c7b012306d$var$load("3JSgG"),
    $f0caf3c7b012306d$var$load("9AXkC"),
    $f0caf3c7b012306d$var$load("ffEVr"),
    $f0caf3c7b012306d$var$load("28arV"),
    $f0caf3c7b012306d$var$load("l1BQC"),
    $f0caf3c7b012306d$var$load("jlSF3"),
    $f0caf3c7b012306d$var$load("2vAWg"),
    $f0caf3c7b012306d$var$load("7cABH"),
    $f0caf3c7b012306d$var$load("31vk5"),
    $f0caf3c7b012306d$var$load("4pqtR"),
    $f0caf3c7b012306d$var$load("5XqRg"),
    $f0caf3c7b012306d$var$load("2uVTT"),
    $f0caf3c7b012306d$var$load("hhss7"),
    $f0caf3c7b012306d$var$load("Wowvf"),
    $f0caf3c7b012306d$var$load("5RR9C"),
    $f0caf3c7b012306d$var$load("2PePB"),
    $f0caf3c7b012306d$var$load("bIPPg"),
    $f0caf3c7b012306d$var$load("lnKog"),
    $f0caf3c7b012306d$var$load("h3ABO"),
    $f0caf3c7b012306d$var$load("kC80R"),
    $f0caf3c7b012306d$var$load("7EorR"),
    $f0caf3c7b012306d$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("5shOo", function(module, exports) {

let $3f8d62588ff52c9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f8d62588ff52c9b$var$load("7do1E"),
    $3f8d62588ff52c9b$var$load("77dkW"),
    $3f8d62588ff52c9b$var$load("2YffH"),
    $3f8d62588ff52c9b$var$load("b7OPx"),
    $3f8d62588ff52c9b$var$load("lqFMg"),
    $3f8d62588ff52c9b$var$load("gELW6"),
    $3f8d62588ff52c9b$var$load("4hDGB"),
    $3f8d62588ff52c9b$var$load("2PePB"),
    $3f8d62588ff52c9b$var$load("eBRUf"),
    $3f8d62588ff52c9b$var$load("hwT9D"),
    $3f8d62588ff52c9b$var$load("j4Bpe"),
    $3f8d62588ff52c9b$var$load("h4Nf7"),
    $3f8d62588ff52c9b$var$load("7f9Fz"),
    $3f8d62588ff52c9b$var$load("8YSo7"),
    $3f8d62588ff52c9b$var$load("g9CVe"),
    $3f8d62588ff52c9b$var$load("9hYRW"),
    $3f8d62588ff52c9b$var$load("kpm7S"),
    $3f8d62588ff52c9b$var$load("6wr18"),
    $3f8d62588ff52c9b$var$load("kjZZD"),
    $3f8d62588ff52c9b$var$load("3JSgG"),
    $3f8d62588ff52c9b$var$load("9AXkC"),
    $3f8d62588ff52c9b$var$load("ffEVr"),
    $3f8d62588ff52c9b$var$load("28arV"),
    $3f8d62588ff52c9b$var$load("l1BQC"),
    $3f8d62588ff52c9b$var$load("jlSF3"),
    $3f8d62588ff52c9b$var$load("2vAWg"),
    $3f8d62588ff52c9b$var$load("7cABH"),
    $3f8d62588ff52c9b$var$load("31vk5"),
    $3f8d62588ff52c9b$var$load("4pqtR"),
    $3f8d62588ff52c9b$var$load("5XqRg"),
    $3f8d62588ff52c9b$var$load("bIPPg"),
    $3f8d62588ff52c9b$var$load("2uVTT"),
    $3f8d62588ff52c9b$var$load("hhss7"),
    $3f8d62588ff52c9b$var$load("Wowvf"),
    $3f8d62588ff52c9b$var$load("5RR9C"),
    $3f8d62588ff52c9b$var$load("h3ABO"),
    $3f8d62588ff52c9b$var$load("kC80R"),
    $3f8d62588ff52c9b$var$load("7EorR"),
    $3f8d62588ff52c9b$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("3Hycf", function(module, exports) {

let $2b1fe9f7f738c36c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2b1fe9f7f738c36c$var$load("7do1E"),
    $2b1fe9f7f738c36c$var$load("77dkW"),
    $2b1fe9f7f738c36c$var$load("2YffH"),
    $2b1fe9f7f738c36c$var$load("b7OPx"),
    $2b1fe9f7f738c36c$var$load("lqFMg"),
    $2b1fe9f7f738c36c$var$load("gELW6"),
    $2b1fe9f7f738c36c$var$load("4hDGB"),
    $2b1fe9f7f738c36c$var$load("eBRUf"),
    $2b1fe9f7f738c36c$var$load("hwT9D"),
    $2b1fe9f7f738c36c$var$load("j4Bpe"),
    $2b1fe9f7f738c36c$var$load("h4Nf7"),
    $2b1fe9f7f738c36c$var$load("7f9Fz"),
    $2b1fe9f7f738c36c$var$load("8YSo7"),
    $2b1fe9f7f738c36c$var$load("g9CVe"),
    $2b1fe9f7f738c36c$var$load("9hYRW"),
    $2b1fe9f7f738c36c$var$load("kpm7S"),
    $2b1fe9f7f738c36c$var$load("6wr18"),
    $2b1fe9f7f738c36c$var$load("kjZZD"),
    $2b1fe9f7f738c36c$var$load("3JSgG"),
    $2b1fe9f7f738c36c$var$load("9AXkC"),
    $2b1fe9f7f738c36c$var$load("ffEVr"),
    $2b1fe9f7f738c36c$var$load("28arV"),
    $2b1fe9f7f738c36c$var$load("l1BQC"),
    $2b1fe9f7f738c36c$var$load("jlSF3"),
    $2b1fe9f7f738c36c$var$load("2vAWg"),
    $2b1fe9f7f738c36c$var$load("7cABH"),
    $2b1fe9f7f738c36c$var$load("31vk5"),
    $2b1fe9f7f738c36c$var$load("4pqtR"),
    $2b1fe9f7f738c36c$var$load("5XqRg"),
    $2b1fe9f7f738c36c$var$load("2uVTT"),
    $2b1fe9f7f738c36c$var$load("hhss7"),
    $2b1fe9f7f738c36c$var$load("Wowvf"),
    $2b1fe9f7f738c36c$var$load("5RR9C"),
    $2b1fe9f7f738c36c$var$load("2PePB"),
    $2b1fe9f7f738c36c$var$load("bIPPg"),
    $2b1fe9f7f738c36c$var$load("lnKog"),
    $2b1fe9f7f738c36c$var$load("h3ABO"),
    $2b1fe9f7f738c36c$var$load("kC80R"),
    $2b1fe9f7f738c36c$var$load("7EorR"),
    $2b1fe9f7f738c36c$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("5S3Gg", function(module, exports) {

let $4464d9cf9d8cfe99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4464d9cf9d8cfe99$var$load("7do1E"),
    $4464d9cf9d8cfe99$var$load("77dkW"),
    $4464d9cf9d8cfe99$var$load("2YffH"),
    $4464d9cf9d8cfe99$var$load("b7OPx"),
    $4464d9cf9d8cfe99$var$load("lqFMg"),
    $4464d9cf9d8cfe99$var$load("gELW6"),
    $4464d9cf9d8cfe99$var$load("4hDGB"),
    $4464d9cf9d8cfe99$var$load("eBRUf"),
    $4464d9cf9d8cfe99$var$load("hwT9D"),
    $4464d9cf9d8cfe99$var$load("j4Bpe"),
    $4464d9cf9d8cfe99$var$load("h4Nf7"),
    $4464d9cf9d8cfe99$var$load("7f9Fz"),
    $4464d9cf9d8cfe99$var$load("8YSo7"),
    $4464d9cf9d8cfe99$var$load("g9CVe"),
    $4464d9cf9d8cfe99$var$load("9hYRW"),
    $4464d9cf9d8cfe99$var$load("kpm7S"),
    $4464d9cf9d8cfe99$var$load("6wr18"),
    $4464d9cf9d8cfe99$var$load("kjZZD"),
    $4464d9cf9d8cfe99$var$load("3JSgG"),
    $4464d9cf9d8cfe99$var$load("9AXkC"),
    $4464d9cf9d8cfe99$var$load("ffEVr"),
    $4464d9cf9d8cfe99$var$load("28arV"),
    $4464d9cf9d8cfe99$var$load("l1BQC"),
    $4464d9cf9d8cfe99$var$load("jlSF3"),
    $4464d9cf9d8cfe99$var$load("2vAWg"),
    $4464d9cf9d8cfe99$var$load("7cABH"),
    $4464d9cf9d8cfe99$var$load("31vk5"),
    $4464d9cf9d8cfe99$var$load("4pqtR"),
    $4464d9cf9d8cfe99$var$load("5XqRg"),
    $4464d9cf9d8cfe99$var$load("2uVTT"),
    $4464d9cf9d8cfe99$var$load("hhss7"),
    $4464d9cf9d8cfe99$var$load("Wowvf"),
    $4464d9cf9d8cfe99$var$load("5RR9C"),
    $4464d9cf9d8cfe99$var$load("2PePB"),
    $4464d9cf9d8cfe99$var$load("bIPPg"),
    $4464d9cf9d8cfe99$var$load("lnKog"),
    $4464d9cf9d8cfe99$var$load("h3ABO"),
    $4464d9cf9d8cfe99$var$load("kC80R"),
    $4464d9cf9d8cfe99$var$load("7EorR"),
    $4464d9cf9d8cfe99$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("jO6sX", function(module, exports) {

var $ip8Mg = parcelRequire("ip8Mg");


var $bPFvq = parcelRequire("bPFvq");


var $cbHql = parcelRequire("cbHql");


var $42omo = parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");


var $fFmJj = parcelRequire("fFmJj");


var $9wGTI = parcelRequire("9wGTI");


var $hp2SH = parcelRequire("hp2SH");


var $bQm3c = parcelRequire("bQm3c");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $44LO1 = parcelRequire("44LO1");


var $iGI5F = parcelRequire("iGI5F");

const $0d17c8f0adf5cf3d$var$EditorPreferencesQuery = (0, $cbHql.default);
const $0d17c8f0adf5cf3d$var$EditorPreferencesMutation = (0, $bPFvq.default);
const $0d17c8f0adf5cf3d$export$3ece90ca9e31f585 = (confluenceEditorSettings)=>{
    if (confluenceEditorSettings && confluenceEditorSettings) return confluenceEditorSettings;
    return {};
};
class $0d17c8f0adf5cf3d$export$accffe59bc474b30 {
    init() {
        if (!this.initialized) this.fetchPreferences().catch(()=>{
        // Do nothing
        });
    }
    // add this to implment the UserPreferensProvider interface.
    loadPreferences() {
        return Promise.reject();
    }
    async fetchPreferences() {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        try {
            if (!this.initialized) {
                const { data: data } = await (0, $c0rhi.queryInterop)({
                    query: $0d17c8f0adf5cf3d$var$EditorPreferencesQuery
                });
                this.userPreferences = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585(data?.userPreferences?.confluenceEditorSettings);
                this.initialized = true;
            }
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async updatePreference(key, value) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        this.userPreferences[key] = value;
        const variables = {
            [key]: value
        };
        try {
            const response = await (0, $6s78L.mutateInterop)({
                mutation: $0d17c8f0adf5cf3d$var$EditorPreferencesMutation,
                variables: variables,
                update: ()=>{
                    // this is required to indicate toolbar changes to progressive object header
                    (0, $fEmGS.writeQueryInterop)({
                        query: $0d17c8f0adf5cf3d$var$EditorPreferencesQuery,
                        data: {
                            userPreferences: {
                                __typename: 'UserPreferences',
                                confluenceEditorSettings: {
                                    __typename: 'ConfluenceEditorSettings',
                                    toolbarDockingInitialPosition: value === 'top' ? value : null // Null is required since apollo cache uses shallow reference equality
                                }
                            }
                        }
                    });
                }
            });
            const confluenceEditorSettings = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585(response.data?.updateUserPreferences?.confluenceEditorSettings);
            this.userPreferences[key] = confluenceEditorSettings[key];
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
    getPreference(key) {
        return this.userPreferences[key];
    }
    constructor(){
        this.userPreferences = {};
        // We use getApolloClient to get the apollo client instance
        // This is to avoid adding required apollo context
        this.apolloClient = (0, $hp2SH.getApolloClient)();
        this.initialized = false;
        this.init();
    }
}
const $0d17c8f0adf5cf3d$var$createUserPreferencesProvider = (options)=>{
    if ((0, $9wGTI.fg)('platform_editor_user_preferences_provider_update')) {
        const getFallbackUserPreferences = ()=>({
                toolbarDockingInitialPosition: options?.getCurrentIsLivePage?.() ? 'none' : 'top'
            });
        return new (0, $44LO1.EditorUserPreferencesProvider)({
            getFallbackUserPreferences: getFallbackUserPreferences
        });
    }
    return new $0d17c8f0adf5cf3d$export$accffe59bc474b30();
};
const $0d17c8f0adf5cf3d$export$c88c6b9f15f77aea = (options)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const confluenceEditorPreferencesProvider = (0, $42omo.useRef)();
    const editorPreferencesProvider = (0, $42omo.useRef)();
    const persistenceAPI = (0, $42omo.useRef)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ip8Mg.default)
    });
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        if ((0, $9wGTI.fg)('platform_editor_use_preferences_plugin')) {
            if (!editorPreferencesProvider.current) {
                const isLivePage = options?.getCurrentIsLivePage?.() ?? false;
                persistenceAPI.current = new (0, $iGI5F.UserPreferencesPersistenceAPI)(isLoggedIn, readFragmentInterop);
                editorPreferencesProvider.current = (0, $iGI5F.getUserPreferencesProvider)({
                    isLivePage: isLivePage,
                    persistenceAPI: persistenceAPI.current,
                    readFragmentInterop: readFragmentInterop
                });
            }
        } else if (!confluenceEditorPreferencesProvider.current) confluenceEditorPreferencesProvider.current = isLoggedIn ? $0d17c8f0adf5cf3d$var$createUserPreferencesProvider(options) : undefined;
    }
    (0, $42omo.useEffect)(()=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
            if (persistenceAPI.current && (0, $9wGTI.fg)('platform_editor_use_preferences_plugin')) persistenceAPI.current.setIsLoggedIn(isLoggedIn);
        }
    }, [
        isLoggedIn
    ]);
    return {
        confluenceEditorPreferencesProvider: confluenceEditorPreferencesProvider.current,
        editorPreferencesProvider: editorPreferencesProvider.current ?? undefined
    };
};
module.exports["parseConfluenceEditorSettings"] = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585;
module.exports["useEditorPreferencesProvider"] = $0d17c8f0adf5cf3d$export$c88c6b9f15f77aea;

});

parcelRegister("ip8Mg", function(module, exports) {
/**
 * @generated SignedSource<<9ad8e6f16baa7c87db8fb00958304324>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dcb986cc56874e48$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EditorPreferencesQueryFragment",
    "selections": [
        {
            "concreteType": "ConfluenceEditorSettings",
            "kind": "LinkedField",
            "name": "confluenceEditorSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "toolbarDockingInitialPosition"
                }
            ]
        }
    ],
    "type": "UserPreferences"
};
$dcb986cc56874e48$var$node.hash = "c14a58c792cd6196c5f117a58ba70054";
var $dcb986cc56874e48$export$2e2bcd8739ae039 = $dcb986cc56874e48$var$node;
module.exports["default"] = $dcb986cc56874e48$export$2e2bcd8739ae039;

});

parcelRegister("bPFvq", function(module, exports) {
/**
 * @generated SignedSource<<57af5be957251f949c7d18d74c9e575d>>
 * @relayHash 1b2bc31ac42719bf8add4db3a6390b58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb
const $185ebb8cafff52fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toolbarDockingInitialPosition"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "toolbarDockingInitialPosition",
                                    "variableName": "toolbarDockingInitialPosition"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "confluenceEditorSettingsInput"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b2bc31ac42719bf8add4db3a6390b58",
            "id": "127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb",
            "metadata": {},
            "name": "EditorPreferencesMutation",
            "operationKind": "mutation",
            "text": "mutation EditorPreferencesMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$185ebb8cafff52fb$var$node.hash = "37475c1d65dabe41f55ac97eba30ddfa";
var $185ebb8cafff52fb$export$2e2bcd8739ae039 = $185ebb8cafff52fb$var$node;
module.exports["default"] = $185ebb8cafff52fb$export$2e2bcd8739ae039;

});

parcelRegister("cbHql", function(module, exports) {
/**
 * @generated SignedSource<<7e6955d1a7c4801d30e917cc16a83306>>
 * @relayHash c67b40e0841cbe3641e147b8f635e291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5
const $40163854596f3729$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c67b40e0841cbe3641e147b8f635e291",
            "id": "8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5",
            "metadata": {},
            "name": "EditorPreferencesQuery",
            "operationKind": "query",
            "text": "query EditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$40163854596f3729$var$node.hash = "49dd5f6cf6c26477ad455a4c7f501e60";
var $40163854596f3729$export$2e2bcd8739ae039 = $40163854596f3729$var$node;
module.exports["default"] = $40163854596f3729$export$2e2bcd8739ae039;

});

parcelRegister("44LO1", function(module, exports) {

var $6ryhQ = parcelRequire("6ryhQ");


var $18dXR = parcelRequire("18dXR");


var $hp2SH = parcelRequire("hp2SH");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $lmtWR = parcelRequire("lmtWR");


var $l1uFv = parcelRequire("l1uFv");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $jO6sX = parcelRequire("jO6sX");

const $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery = (0, $18dXR.default);
const $fa29ff75a45929c5$var$EditorUserPreferencesProviderMutation = (0, $6ryhQ.default);
var $fa29ff75a45929c5$var$Status = /*#__PURE__*/ function(Status) {
    Status["Complete"] = "complete";
    Status["Error"] = "error";
    Status["Pending"] = "pending";
    return Status;
}($fa29ff75a45929c5$var$Status || {});
const $fa29ff75a45929c5$export$48d7c418edadb60c = ()=>Boolean(undefined);
class $fa29ff75a45929c5$export$7f7007b732b93d85 {
    // synchronously load preferences from cache
    loadPreferencesFromCache() {
        if (!$fa29ff75a45929c5$export$48d7c418edadb60c()) {
            const userPreferenceStorage = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES);
            if (userPreferenceStorage) this.userPreferences = JSON.parse(userPreferenceStorage);
        }
        if (!this.apolloClient) return undefined;
        try {
            const result = (0, $l1uFv.readQueryInterop)({
                query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery
            });
            if (result?.userPreferences) {
                this.userPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(result.userPreferences?.confluenceEditorSettings);
                // if we have a cached value, we can set the status to complete
                // since we are not going to make a network request
                // to fetch the preferences with loadPreferencesInternal and not skipCache
                if (this.providerStatus !== "complete") this.providerStatus = "complete";
            }
            return this.userPreferences;
        } catch  {
            return this.userPreferences;
        }
    }
    async loadPreferencesInternal(options) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
            fetchPolicy: options?.skipCache ? 'no-cache' : 'cache-first'
        });
        this.userPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(data?.userPreferences?.confluenceEditorSettings);
        this.updateLocalStorage();
        return this.userPreferences;
    }
    async loadPreferences() {
        try {
            const userPreferences = await this.loadPreferencesInternal({
                skipCache: true
            });
            // can recover from the status previous error
            if (this.providerStatus !== "complete") this.providerStatus = "complete";
            return userPreferences;
        } catch (error) {
            // We will ignore subssequent errors if thte status was complete
            // And will use the data from previous request
            if (this.providerStatus !== "complete") this.providerStatus = "error";
            return Promise.reject(error);
        }
    }
    updateLocalStorage() {
        if (!$fa29ff75a45929c5$export$48d7c418edadb60c()) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES, JSON.stringify(this.userPreferences));
    }
    async updatePreference(key, value) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        const variables = {
            [key]: value
        };
        this.userPreferences[key] = value;
        const { data: data } = await (0, $6s78L.mutateInterop)({
            mutation: $fa29ff75a45929c5$var$EditorUserPreferencesProviderMutation,
            variables: variables,
            update: ()=>{
                // this is required to indicate toolbar changes to any useQuery for EditorPreferencesQuery, particularly progressive object header
                const getValue = ()=>value ?? null;
                (0, $fEmGS.writeQueryInterop)({
                    query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
                    data: {
                        userPreferences: {
                            __typename: 'UserPreferences',
                            confluenceEditorSettings: {
                                __typename: 'ConfluenceEditorSettings',
                                toolbarDockingInitialPosition: getValue()
                            }
                        }
                    }
                });
            }
        });
        const updatedUserPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(data?.updateUserPreferences?.confluenceEditorSettings);
        this.userPreferences = {
            ...this.userPreferences,
            ...updatedUserPreferences
        };
        if (value === 'top') (0, $lmtWR.persistBannerDismissalNewPinning)('toolbar-inline');
        else if (value === 'none') (0, $lmtWR.persistBannerDismissalNewPinning)('toolbar-top');
        this.updateLocalStorage();
    }
    getPreference(key) {
        const fallbackUserPreferences = this.getFallbackUserPreferences?.() || {};
        return this.userPreferences[key] || fallbackUserPreferences[key];
    }
    constructor(options = {}){
        this.userPreferences = {};
        this.getFallbackUserPreferences = void 0;
        // We use getApolloClient to get the apollo client instance
        // This is to avoid adding required apollo context
        this.apolloClient = (0, $hp2SH.getApolloClient)();
        this.providerStatus = "pending";
        this.getFallbackUserPreferences = options.getFallbackUserPreferences;
        this.loadPreferencesFromCache();
        this.loadPreferencesInternal().then(()=>{
            this.providerStatus = "complete";
        }).catch(()=>{
            this.providerStatus = "error";
        });
    }
}
module.exports["isSSR"] = $fa29ff75a45929c5$export$48d7c418edadb60c;
module.exports["EditorUserPreferencesProvider"] = $fa29ff75a45929c5$export$7f7007b732b93d85;

});

parcelRegister("6ryhQ", function(module, exports) {
/**
 * @generated SignedSource<<de45818214e4def3f5796cf626e62283>>
 * @relayHash abbe28b997f121d37d2a6bcf9de50587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec
const $90a65d92fac4dfbd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toolbarDockingInitialPosition"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "toolbarDockingInitialPosition",
                                    "variableName": "toolbarDockingInitialPosition"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "confluenceEditorSettingsInput"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorUserPreferencesProviderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorUserPreferencesProviderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "abbe28b997f121d37d2a6bcf9de50587",
            "id": "f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec",
            "metadata": {},
            "name": "EditorUserPreferencesProviderMutation",
            "operationKind": "mutation",
            "text": "mutation EditorUserPreferencesProviderMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$90a65d92fac4dfbd$var$node.hash = "58cff6da35ff84f165c997ef5ed48166";
var $90a65d92fac4dfbd$export$2e2bcd8739ae039 = $90a65d92fac4dfbd$var$node;
module.exports["default"] = $90a65d92fac4dfbd$export$2e2bcd8739ae039;

});

parcelRegister("18dXR", function(module, exports) {
/**
 * @generated SignedSource<<1bd43e437b489cf3c7c124ff4a966a9f>>
 * @relayHash 63854a4c84372d699a45f9c1a07dc352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e
const $e4a48aa60613f0b2$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorUserPreferencesProviderQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorUserPreferencesProviderQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "63854a4c84372d699a45f9c1a07dc352",
            "id": "3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e",
            "metadata": {},
            "name": "EditorUserPreferencesProviderQuery",
            "operationKind": "query",
            "text": "query EditorUserPreferencesProviderQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$e4a48aa60613f0b2$var$node.hash = "22c44eb8a7e5e6240c1d402a68a09da0";
var $e4a48aa60613f0b2$export$2e2bcd8739ae039 = $e4a48aa60613f0b2$var$node;
module.exports["default"] = $e4a48aa60613f0b2$export$2e2bcd8739ae039;

});

parcelRegister("lmtWR", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $087f019a02b7077e$var$logger = (0, $7W8i8.getLogger)('EditorControlsBannerDismissal');
const $087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED;
const $087f019a02b7077e$var$AUTO_DISMISSAL_THRESHOLD = 604800000; // 7 days in milliseconds
const $087f019a02b7077e$export$b16c0225931fdfcf = (isTopBanner)=>{
    return isTopBanner ? 'toolbar-top' : 'toolbar-inline';
};
const $087f019a02b7077e$var$getLocalStorageItem = (storageKey)=>{
    try {
        const itemString = (0, $17wUi.confluenceLocalStorageInstance).getItem(storageKey);
        if (!itemString) return undefined;
        const item = JSON.parse(itemString);
        if (typeof item === 'object' && item !== null && !Array.isArray(item) && Object.keys(item).every((key)=>[
                'toolbar-top',
                'toolbar-inline'
            ].includes(key))) return item;
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error parsing local storage key(${storageKey}): ${error}`;
    }
    return undefined;
};
const $087f019a02b7077e$var$recordFirstViewTime = (bannerType, item)=>{
    const firstViewed = {
        firstViewed: Date.now()
    };
    try {
        if (!item) (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify({
            [bannerType]: firstViewed
        }));
        else {
            item[bannerType] = {
                ...item[bannerType],
                ...firstViewed
            };
            (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
        }
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error setting local storage key(${$087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY}): ${error}`;
    }
};
const $087f019a02b7077e$export$7b46a18b5966c9f8 = (bannerType)=>{
    const localStorageItem = $087f019a02b7077e$var$getLocalStorageItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY);
    const { firstViewed: firstViewed, count: dismissalCount } = localStorageItem?.[bannerType] || {};
    // Record first view time if it does not exist. Do this before returning to
    // ensure we record a time even if there are no prior records
    if (firstViewed === undefined) $087f019a02b7077e$var$recordFirstViewTime(bannerType, localStorageItem);
    // No local storage = no banner dismissal
    if (!localStorageItem) return false;
    // If banner was first viewed more than a week ago, hide it even if it had not been dismissed
    const shouldAutoDismiss = firstViewed && Date.now() - firstViewed > $087f019a02b7077e$var$AUTO_DISMISSAL_THRESHOLD;
    if (shouldAutoDismiss) return true;
    // If count is anything other than undefined, it means the banner has been dismissed (including if count is 0!)
    return dismissalCount !== undefined;
};
const $087f019a02b7077e$export$1f63bcf565c85af4 = (bannerType)=>{
    let item = $087f019a02b7077e$var$getLocalStorageItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY);
    if (!item) item = {
        [bannerType]: {
            count: 0
        }
    };
    else {
        const existingDismissal = item[bannerType];
        item[bannerType] = {
            ...existingDismissal,
            count: 0
        };
    }
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error setting local storage key(${$087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY}): ${error}`;
    }
};
module.exports["getBannerType"] = $087f019a02b7077e$export$b16c0225931fdfcf;
module.exports["isBannerDismissedInLocalStorage"] = $087f019a02b7077e$export$7b46a18b5966c9f8;
module.exports["persistBannerDismissalNewPinning"] = $087f019a02b7077e$export$1f63bcf565c85af4;

});

parcelRegister("iGI5F", function(module, exports) {

var $iraTI = parcelRequire("iraTI");

var $kwopk = parcelRequire("kwopk");


var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $1UApO = parcelRequire("1UApO");


var $cbHql = parcelRequire("cbHql");


var $bPFvq = parcelRequire("bPFvq");


var $44LO1 = parcelRequire("44LO1");

const $5fb34be1fffb3f33$var$parseConfluenceEditorSettings = (confluenceEditorSettings)=>{
    if (confluenceEditorSettings) {
        const result = {};
        const entries = Object.entries(confluenceEditorSettings);
        for (const [key, value] of entries){
            if (key === 'toolbarDockingInitialPosition' && value && (0, $iraTI.TOOLBAR_DOCKING_POSITIONS).includes(value)) result.toolbarDockingPosition = value;
            else if (value !== null && value !== undefined) // Pass through other settings as-is
            result[key] = value;
        }
        return result;
    }
    return {};
};
const $5fb34be1fffb3f33$var$updateLocalStorage = (userPreferences)=>{
    // confluenceLocalStorageInstance is only available in the browser environment
    if (!(0, $44LO1.isSSR)() && (0, $17wUi.confluenceLocalStorageInstance)) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES, JSON.stringify(userPreferences));
};
class $5fb34be1fffb3f33$export$acb1a00758cac9cd {
    setIsLoggedIn(isLoggedin) {
        this.isLoggedin = isLoggedin;
    }
    getInitialUserPreferences() {
        let initialUserPreferences;
        try {
            if (this.readFragmentInterop) {
                const result = this.readFragmentInterop({
                    id: `$ROOT_QUERY.userPreferences`
                });
                if (result) initialUserPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(result.confluenceEditorSettings);
            }
        } catch  {
            initialUserPreferences = undefined;
        }
        // If we don't have values from the Apollo cache, we try to fetch from local storage
        if (!initialUserPreferences && !(0, $44LO1.isSSR)()) try {
            const userPreferenceStorage = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES);
            if (userPreferenceStorage) initialUserPreferences = JSON.parse(userPreferenceStorage);
        } catch  {
            // If the local storage is corrupted or not available, we ignore the error and return undefined
            initialUserPreferences = undefined;
        }
        return initialUserPreferences;
    }
    async updateUserPreference(key, value) {
        if (!this.isLoggedin) // If the user is not logged in, we return the key with updated value
        // This is to ensure that the editor can still function without flaws
        // but the value will not be persisted to the server
        return Promise.resolve({
            [key]: value
        });
        // we only support updating the toolbarDockingInitialPosition preference ATM,
        // need to update this if we add more preferences
        const variables = {
            toolbarDockingInitialPosition: value
        };
        try {
            const { data: data } = await (0, $6s78L.mutateInterop)({
                mutation: (0, $bPFvq.default),
                variables: variables
            });
            // this is required to indicate toolbar changes to any useQuery for EditorPreferencesQuery, particularly progressive object header
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $cbHql.default),
                data: {
                    userPreferences: {
                        __typename: 'UserPreferences',
                        confluenceEditorSettings: {
                            toolbarDockingInitialPosition: value ?? null
                        }
                    }
                }
            });
            const userPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(data?.updateUserPreferences?.confluenceEditorSettings);
            $5fb34be1fffb3f33$var$updateLocalStorage(userPreferences);
            return {
                [key]: userPreferences[key]
            };
        } catch  {
            // In case of an error, we return the key with updated value
            // This is to ensure that the editor can still function without flaws
            // but the value might not be persisted to the server
            return {
                [key]: value
            };
        }
    }
    async loadUserPreferences() {
        let userPreferences = {};
        if (!this.isLoggedin) // If the user is not logged in, we return an empty object
        return Promise.resolve(userPreferences);
        try {
            // first time we load we use cache-first policy to avoid unnecessary network requests
            // after the first load we always use no-cache to ensure we have the latest preferences
            // this is particularly important when user has multiple tabs open and changes preferences in one tab
            // we want to ensure other tabs have the latest preferences
            const fetchPolicy = !this.isInitialLoad && (0, $6mKj3.expVal)('cc_editor_preferences_query_optimisation', 'isEnabled', false) ? 'cache-first' : 'no-cache';
            this.isInitialLoad = true;
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: (0, $cbHql.default),
                fetchPolicy: fetchPolicy
            });
            userPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(data?.userPreferences?.confluenceEditorSettings);
            $5fb34be1fffb3f33$var$updateLocalStorage(userPreferences);
            return userPreferences;
        } catch  {
            // if upload local storage fails, we will still return the user preferences
            return userPreferences;
        }
    }
    constructor(isLoggedin = true, readFragmentInterop){
        this.readFragmentInterop = void 0;
        this.isLoggedin = true;
        this.isInitialLoad = false;
        this.setIsLoggedIn(isLoggedin);
        this.readFragmentInterop = readFragmentInterop;
    }
}
const $5fb34be1fffb3f33$export$c53529b5ad54089d = (options)=>{
    const persistenceAPI = options.persistenceAPI || new $5fb34be1fffb3f33$export$acb1a00758cac9cd(undefined, options.readFragmentInterop);
    return new (0, $kwopk.UserPreferencesProvider)(persistenceAPI, {
        toolbarDockingPosition: options.isLivePage ? 'none' : 'top'
    });
};
module.exports["UserPreferencesPersistenceAPI"] = $5fb34be1fffb3f33$export$acb1a00758cac9cd;
module.exports["getUserPreferencesProvider"] = $5fb34be1fffb3f33$export$c53529b5ad54089d;

});

parcelRegister("iraTI", function(module, exports) {
const $eb340c49362f17be$export$e2238e88752bfc4a = [
    'top',
    'none'
];
module.exports["TOOLBAR_DOCKING_POSITIONS"] = $eb340c49362f17be$export$e2238e88752bfc4a;

});

parcelRegister("kwopk", function(module, exports) {

var $6Npva = parcelRequire("6Npva");

class $94172f9fef348b93$export$42096c77943a6f6f {
    /**
   * This method returns the initialized state of the user preferences provider
   * @returns true if the user preferences provider is initialized, false otherwise
   * @example userPreferencesProvider.isInitialized
   */ get isInitialized() {
        return this.initialized;
    }
    /**
   * This method fetches the latest user preferences
   * @returns a promise that resolves with the user preferences, or rejects if error occurs
   * @throws Error if there is an error loading user preferences
   * @example userPreferencesProvider.loadPreferences()
   */ async loadPreferences() {
        const userPreferences = await this.persistenceAPI.loadUserPreferences();
        this.setUserPreferences(userPreferences);
    }
    /**
   * This method updates a user preference
   * @param key
   * @param value
   * @returns a promise that resolves when the user preference is updated
   * @throws Error if there is an error updating user preferences
   * @example userPreferencesProvider.updatePreference('toolbarDockingPosition', 'top')
   */ async updatePreference(key, value) {
        const userPreferences = await this.persistenceAPI.updateUserPreference(key, value);
        this.setUserPreferences(userPreferences);
    }
    /**
   * get a user preference, Note that this function is a not async function,
   * meaning that consumers should prefetch the user preference and make it available initially
   * @param key
   * @returns the user preference
   * @example userPreferencesProvider.getPreference('toolbarDockingPosition')
   */ getPreference(key) {
        return this.resolvedUserPreferences[key];
    }
    /**
   * get all user preferences
   * @returns the user preferences
   * @example userPreferencesProvider.getPreferences()
   */ getPreferences() {
        return this.resolvedUserPreferences;
    }
    /**
   * This method fetches the latest user preferences
   * @param onUpdate
   * @returns a function to unsubscribe from the updates
   * @example
   */ onUpdate(onUpdate) {
        this.updateCallbacks.push(onUpdate);
        // Return the cleanup function to unsubscribe from the updates
        return ()=>{
            this.updateCallbacks = this.updateCallbacks.filter((callback)=>callback !== onUpdate);
        };
    }
    /**
   * This method is used to set the default user preferences,
   * setting the default user preferences will also trigger an update
   * This is useful when the default user preferences dynamically based on the context
   * @param preferences
   * @example
   */ setDefaultPreferences(preferences) {
        this.defaultPreferences = preferences;
        const hasUpdated = this.resolveUserPreferences();
        if (hasUpdated) this.notifyUserPreferencesUpdated();
    }
    setUserPreferences(userPreferences) {
        this.userPreferences = userPreferences;
        const hasUpdated = this.resolveUserPreferences();
        if (hasUpdated || !this.initialized) {
            if (!this.initialized) this.initialized = true;
            this.notifyUserPreferencesUpdated();
        }
    }
    /**
   * This method is used to notify the user preferences updated
   * @example userPreferencesProvider.notifyUserPreferencesUpdated()
   */ notifyUserPreferencesUpdated() {
        this.updateCallbacks.forEach((callback)=>{
            callback(this.resolvedUserPreferences);
        });
    }
    /**
   * This method resolves the user preferences by merging the default preferences
   * with the user preferences and filtering out any undefined or null values
   * to avoid overwriting default preferences with null values
   * @returns true if the user preferences were updated, false otherwise
   * @example userPreferencesProvider.resolveUserPreferences()
   */ resolveUserPreferences() {
        // Merge default preferences with user preferences
        // and filter out any undefined or null values
        // to avoid overwriting default preferences with null values
        const newResolvedUserPreferences = (0, $6Npva.mergeUserPreferences)(this.userPreferences, this.defaultPreferences);
        // if the user preferences is NOT initialized, we need to update and notify
        // the user preferences
        // if the user preferences is initialized, we need to check if the new user preferences
        // is different from the old user preferences
        const isSame = (0, $6Npva.areUserPreferencesEqual)(newResolvedUserPreferences, this.resolvedUserPreferences);
        const needUpdate = !isSame;
        if (needUpdate) this.resolvedUserPreferences = newResolvedUserPreferences;
        return needUpdate;
    }
    /**
   * This is the constructor for the UserPreferencesProvider class.
   * @param persistenceAPI - The persistence API to use for loading and updating user preferences
   * @param defaultPreferences - The default user preferences to use
   * @param initialUserPreferences - The initial user preferences to use (optional)
   * @example const userPreferencesProvider = new UserPreferencesProvider(persistenceAPI, defaultPreferences);
   */ constructor(persistenceAPI, defaultPreferences){
        this.updateCallbacks = [];
        this.userPreferences = {};
        this.defaultPreferences = void 0;
        this.resolvedUserPreferences = void 0;
        this.initialized = false;
        this.persistenceAPI = void 0;
        this.persistenceAPI = persistenceAPI;
        this.defaultPreferences = defaultPreferences;
        this.resolvedUserPreferences = defaultPreferences;
        const initialUserPreferences = this.persistenceAPI.getInitialUserPreferences?.();
        if (initialUserPreferences) this.setUserPreferences(initialUserPreferences);
        // the initial user preferences might come from the local cache,
        // so we need to always load the preferences
        this.loadPreferences();
    }
}
module.exports["UserPreferencesProvider"] = $94172f9fef348b93$export$42096c77943a6f6f;

});

parcelRegister("6Npva", function(module, exports) {

var $iraTI = parcelRequire("iraTI");

const $4717a3a92f858726$export$c583bb83c793248b = (userPreferences, defaultPreferences)=>{
    const newResolvedUserPreferences = {
        ...defaultPreferences,
        ...Object.fromEntries(Object.entries(userPreferences).filter(([key, value])=>{
            if (key === 'toolbarDockingPosition') return (0, $iraTI.TOOLBAR_DOCKING_POSITIONS).includes(value);
            return value !== undefined && value !== null;
        }))
    };
    return newResolvedUserPreferences;
};
const $4717a3a92f858726$export$6d64c804b8f53798 = (left, right)=>{
    return Object.entries(left).every(([key, value])=>{
        return value === right[key];
    });
};
module.exports["mergeUserPreferences"] = $4717a3a92f858726$export$c583bb83c793248b;
module.exports["areUserPreferencesEqual"] = $4717a3a92f858726$export$6d64c804b8f53798;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $e5ba90f4b97bd7c1$var$i18n = (0, $aXWIB.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $aXWIB.useIntl)();
    return (0, $42omo.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("hMfsx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $ej7WH = parcelRequire("ej7WH");


var $k0DFC = parcelRequire("k0DFC");


var $f5Ulo = parcelRequire("f5Ulo");

const $985cb37370034aac$var$crossFlowAdType = 'crossFlow';
const $985cb37370034aac$var$crossJoinAdType = 'crossJoin';
const $985cb37370034aac$export$26447b7789af7a96 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent, sourceContext: sourceContext } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== sourceComponent || $[1] !== sourceContext) {
        t1 = {
            sourceComponent: sourceComponent,
            sourceContext: sourceContext
        };
        $[0] = sourceComponent;
        $[1] = sourceContext;
        $[2] = t1;
    } else t1 = $[2];
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)(t1);
    let t2;
    if ($[3] !== entryPointId) {
        t2 = {
            touchpoint: entryPointId
        };
        $[3] = entryPointId;
        $[4] = t2;
    } else t2 = $[4];
    const { isInterestedInLoom: isInterestedInLoom } = (0, $k0DFC.useLoomAdControlState)(t2);
    let t3;
    if ($[5] !== createAnalyticsEvent || $[6] !== entryPointId || $[7] !== sourceActionSubjectId || $[8] !== triggerCrossFlow) {
        t3 = async (triggerName)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: triggerName,
                    source: triggerName === "tryNow" ? "loomCrossFlowPopupCard" : sourceActionSubjectId,
                    attributes: {
                        adType: $985cb37370034aac$var$crossFlowAdType,
                        entrypoint: entryPointId
                    }
                }
            }).fire();
            await triggerCrossFlow();
        };
        $[5] = createAnalyticsEvent;
        $[6] = entryPointId;
        $[7] = sourceActionSubjectId;
        $[8] = triggerCrossFlow;
        $[9] = t3;
    } else t3 = $[9];
    const onCrossFlowTriggerClick = t3;
    if (!isInterestedInLoom) return null;
    let t4;
    if ($[10] !== onCrossFlowTriggerClick || $[11] !== sourceActionSubjectId) {
        t4 = ()=>onCrossFlowTriggerClick(sourceActionSubjectId);
        $[10] = onCrossFlowTriggerClick;
        $[11] = sourceActionSubjectId;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== ButtonComponent || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
            onClickBeforeInit: t4
        });
        $[13] = ButtonComponent;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : ({ buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)({
        sourceComponent: sourceComponent,
        sourceContext: sourceContext
    });
    const { isInterestedInLoom: isInterestedInLoom } = (0, $k0DFC.useLoomAdControlState)({
        touchpoint: entryPointId
    });
    const onCrossFlowTriggerClick = (0, $42omo.useCallback)(async (triggerName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: triggerName,
                source: triggerName === 'tryNow' ? 'loomCrossFlowPopupCard' : sourceActionSubjectId,
                attributes: {
                    adType: $985cb37370034aac$var$crossFlowAdType,
                    entrypoint: entryPointId
                }
            }
        }).fire();
        await triggerCrossFlow();
    }, [
        createAnalyticsEvent,
        entryPointId,
        triggerCrossFlow,
        sourceActionSubjectId
    ]);
    if (!isInterestedInLoom) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
        onClickBeforeInit: ()=>onCrossFlowTriggerClick(sourceActionSubjectId)
    });
};
const $985cb37370034aac$export$53b6c16ae8132c96 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    let t1;
    if ($[0] !== entryPointId || $[1] !== experienceTracker) {
        t1 = ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $985cb37370034aac$var$crossJoinAdType
                }
            });
        };
        $[0] = entryPointId;
        $[1] = experienceTracker;
        $[2] = t1;
    } else t1 = $[2];
    const onCrossJoinSuccess = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== entryPointId || $[5] !== onCrossJoinSuccess || $[6] !== sourceActionSubjectId || $[7] !== sourceComponent) {
        t2 = async ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: sourceActionSubjectId,
                    source: sourceActionSubjectId,
                    attributes: {
                        adType: $985cb37370034aac$var$crossJoinAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[3] = createAnalyticsEvent;
        $[4] = entryPointId;
        $[5] = onCrossJoinSuccess;
        $[6] = sourceActionSubjectId;
        $[7] = sourceComponent;
        $[8] = t2;
    } else t2 = $[8];
    const onCrossJoinTriggerClick = t2;
    let t3;
    if ($[9] !== ButtonComponent || $[10] !== crossJoinHref || $[11] !== onCrossJoinTriggerClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
            onClickBeforeInit: onCrossJoinTriggerClick,
            href: crossJoinHref,
            target: "_blank",
            rel: "noreferrer"
        });
        $[9] = ButtonComponent;
        $[10] = crossJoinHref;
        $[11] = onCrossJoinTriggerClick;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const onCrossJoinSuccess = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $985cb37370034aac$var$crossJoinAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker
    ]);
    const onCrossJoinTriggerClick = (0, $42omo.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $985cb37370034aac$var$crossJoinAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, {
        onClickBeforeInit: onCrossJoinTriggerClick,
        href: crossJoinHref,
        target: "_blank",
        rel: "noreferrer"
    });
};
module.exports["CrossFlowMenuItem"] = $985cb37370034aac$export$26447b7789af7a96;
module.exports["CrossJoinMenuItem"] = $985cb37370034aac$export$53b6c16ae8132c96;

});

parcelRegister("ej7WH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

parcelRequire("2YerA");
var $fqrVl = parcelRequire("fqrVl");
var $jCM2u = parcelRequire("jCM2u");
parcelRequire("49sr4");
var $82BVR = parcelRequire("82BVR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $a763567c6da5be00$export$fa70eeb8352dd55e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { sourceComponent: sourceComponent, sourceContext: sourceContext } = t0;
    const crossFlow = (0, $jCM2u.useCrossFlow)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== crossFlow.apiV1 || $[1] !== crossFlow.isEnabled || $[2] !== experienceTracker || $[3] !== sourceComponent || $[4] !== sourceContext) {
        t1 = async ()=>{
            if (!crossFlow.isEnabled) {
                experienceTracker.fail({
                    name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                    error: new Error("Loom crossflow is not enabled"),
                    attributes: {
                        sourceComponent: sourceComponent,
                        adType: "crossFlow"
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: sourceComponent,
                    adType: "crossFlow"
                }
            });
            try {
                await crossFlow.apiV1.open({
                    journey: (0, $fqrVl.Journeys).GET_STARTED,
                    sourceComponent: sourceComponent,
                    sourceContext: sourceContext,
                    targetProduct: (0, $82BVR.Targets).LOOM,
                    v1: true
                });
            } catch (t2) {
                const error = t2;
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
                });
            }
        };
        $[0] = crossFlow.apiV1;
        $[1] = crossFlow.isEnabled;
        $[2] = experienceTracker;
        $[3] = sourceComponent;
        $[4] = sourceContext;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const crossFlow = (0, $jCM2u.useCrossFlow)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    return (0, $42omo.useCallback)(async ()=>{
        if (!crossFlow.isEnabled) {
            experienceTracker.fail({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                error: new Error('Loom crossflow is not enabled'),
                attributes: {
                    sourceComponent: sourceComponent,
                    adType: 'crossFlow'
                }
            });
            return;
        }
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: sourceComponent,
                adType: 'crossFlow'
            }
        });
        try {
            /**
       * Additionally, if the user *does* go through cross-flow, they'll be navigated to Loom.com and
       * not return to this code path.
       */ await crossFlow.apiV1.open({
                journey: (0, $fqrVl.Journeys).GET_STARTED,
                sourceComponent: sourceComponent,
                sourceContext: sourceContext,
                targetProduct: (0, $82BVR.Targets).LOOM,
                v1: true
            });
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
            });
        }
    }, [
        crossFlow,
        sourceComponent,
        experienceTracker,
        sourceContext
    ]);
};
module.exports["useLoomCrossFlowRequestAccessCallback"] = $a763567c6da5be00$export$fa70eeb8352dd55e;

});

parcelRegister("2YerA", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("jCM2u")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("fqrVl")).Reasons);

var $jCM2u = parcelRequire("jCM2u");


var $fqrVl = parcelRequire("fqrVl");


});

parcelRegister("jCM2u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5xIym = parcelRequire("5xIym");


var $5B9n6 = parcelRequire("5B9n6");


var $fqrVl = parcelRequire("fqrVl");

const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $42omo.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $42omo.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $32c19fce160b377b$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $32c19fce160b377b$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $32c19fce160b377b$export$655b6c19a0daddb8;

});

parcelRegister("5xIym", function(module, exports) {
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $1eb0c594c750199f$export$9ff7368ac93fcf2d;

});

parcelRegister("5B9n6", function(module, exports) {
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $12de2f6721823415$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $12de2f6721823415$export$8fd5792fc468459f;

});

parcelRegister("fqrVl", function(module, exports) {
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $4db9b154d66dd01a$export$3411873bfd520bb6;
module.exports["Reasons"] = $4db9b154d66dd01a$export$da2d4f2f250d6f84;

});

parcelRegister("49sr4", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("ctMWd")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("82BVR")).Targets);

var $ctMWd = parcelRequire("ctMWd");


var $82BVR = parcelRequire("82BVR");


});

parcelRegister("ctMWd", function(module, exports) {
class $0081b4f618dff6fe$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $0081b4f618dff6fe$export$a5e53d1dcbd6eb61;

});

parcelRegister("82BVR", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $49d7ae8ec7eae7d8$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $49d7ae8ec7eae7d8$export$59a8eb9cff113544;

});

parcelRegister("k0DFC", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $66b8bcdb334754ff$var$getCachedValuesArray = ()=>{
    try {
        const cachedValues = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED);
        if (cachedValues !== null && cachedValues !== 'undefined') return String(cachedValues).split(',');
    } catch (e) {} // Swallow any errors and return empty array
    return [];
};
const $66b8bcdb334754ff$export$83d1e1540840fcd3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { touchpoint: touchpoint } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const valueToBeCached = `${touchpoint}.${userId}.${cloudId}`;
    let t1;
    let t2;
    if ($[0] !== valueToBeCached) {
        const cachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
        t1 = (0, $42omo.useState);
        t2 = !cachedValuesArray || !cachedValuesArray.includes(valueToBeCached);
        $[0] = valueToBeCached;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    const [isInterestedInLoom, setIsInterestedInLoom] = t1(t2);
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== isInterestedInLoom || $[5] !== touchpoint || $[6] !== valueToBeCached) {
        t3 = async ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "notInterested",
                    source: "loomAdControlDropdown",
                    attributes: {
                        adType: "crossFlow",
                        entrypoint: touchpoint
                    }
                }
            }).fire();
            if (!isInterestedInLoom) return;
            const freshCachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
            freshCachedValuesArray.push(valueToBeCached);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED, freshCachedValuesArray);
            setIsInterestedInLoom(false);
        };
        $[3] = createAnalyticsEvent;
        $[4] = isInterestedInLoom;
        $[5] = touchpoint;
        $[6] = valueToBeCached;
        $[7] = t3;
    } else t3 = $[7];
    const notInterestedInLoomCallback = t3;
    let t4;
    if ($[8] !== isInterestedInLoom || $[9] !== notInterestedInLoomCallback) {
        t4 = {
            isInterestedInLoom: isInterestedInLoom,
            notInterestedInLoomCallback: notInterestedInLoomCallback
        };
        $[8] = isInterestedInLoom;
        $[9] = notInterestedInLoomCallback;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ touchpoint: touchpoint })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const valueToBeCached = `${touchpoint}.${userId}.${cloudId}`;
    const cachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
    const [isInterestedInLoom, setIsInterestedInLoom] = (0, $42omo.useState)(!cachedValuesArray || !cachedValuesArray.includes(valueToBeCached));
    const notInterestedInLoomCallback = (0, $42omo.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'notInterested',
                source: 'loomAdControlDropdown',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: touchpoint
                }
            }
        }).fire();
        // Avoid duplicate values being added to cache
        if (!isInterestedInLoom) return;
        // Ensure fresh cache values array by reading from storage
        const freshCachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
        freshCachedValuesArray.push(valueToBeCached);
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED, freshCachedValuesArray);
        setIsInterestedInLoom(false);
    }, [
        isInterestedInLoom,
        valueToBeCached,
        createAnalyticsEvent,
        touchpoint
    ]);
    return {
        isInterestedInLoom: isInterestedInLoom,
        notInterestedInLoomCallback: notInterestedInLoomCallback
    };
};
module.exports["useLoomAdControlState"] = $66b8bcdb334754ff$export$83d1e1540840fcd3;

});

parcelRegister("f5Ulo", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dedJV = parcelRequire("dedJV");


var $bQm3c = parcelRequire("bQm3c");

const $3326fe0c1f9a5868$var$environmentMap = {
    DEVELOPMENT: 'dev',
    STAGING: 'stg',
    PRODUCTION: 'prod'
};
const $3326fe0c1f9a5868$export$80677895f41c9591 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const t0 = $3326fe0c1f9a5868$var$environmentMap[environment];
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $dedJV.getATLContextDomain)("id", [
            t0,
            "commercial"
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const identityDomain = t1;
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === "PRODUCTION" ? "https://loom.com/api/auth/atlassian" : "https://stage.loom.com/api/auth/atlassian";
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
} : ()=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    // Using `environment` from session data (rather than letting `getATLContextDomain` determine it
    // internally) in order to better support local development that can be targeted at different
    // Confluence BE environments
    const identityDomain = (0, $dedJV.getATLContextDomain)('id', [
        $3326fe0c1f9a5868$var$environmentMap[environment],
        'commercial'
    ]);
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === 'PRODUCTION' ? 'https://loom.com/api/auth/atlassian' : 'https://stage.loom.com/api/auth/atlassian';
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
};
module.exports["useLoomCrossJoinUrl"] = $3326fe0c1f9a5868$export$80677895f41c9591;

});

parcelRegister("8Q0mA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $gd8AW = parcelRequire("gd8AW");


var $erVVf = parcelRequire("erVVf");


var $f5Ulo = parcelRequire("f5Ulo");


var $cnQgR = parcelRequire("cnQgR");

const $012e0fafda229e4e$var$sourceAdType = 'crossJoin';
const $012e0fafda229e4e$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    crossJoinCTA: {
        id: "loom-utils.loom-cross-sell-popup-card.crossJoinCTA",
        defaultMessage: "Try now"
    },
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    }
});
const $012e0fafda229e4e$export$9937e9f99bf53911 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(40);
    const { description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t1;
    if ($[0] !== entryPointId || $[1] !== flags || $[2] !== sourceComponent) {
        t1 = {
            entryPointId: entryPointId,
            flags: flags,
            source: "loomCrossJoinPopupCard",
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        };
        $[0] = entryPointId;
        $[1] = flags;
        $[2] = sourceComponent;
        $[3] = t1;
    } else t1 = $[3];
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)(t1);
    let t2;
    if ($[4] !== stopPulse) {
        t2 = ()=>{
            stopPulse();
        };
        $[4] = stopPulse;
        $[5] = t2;
    } else t2 = $[5];
    const stopDiscoverabilityPulse = t2;
    let t3;
    if ($[6] !== entryPointId || $[7] !== experienceTracker || $[8] !== stopDiscoverabilityPulse) {
        t3 = ()=>{
            stopDiscoverabilityPulse();
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $012e0fafda229e4e$var$sourceAdType
                }
            });
        };
        $[6] = entryPointId;
        $[7] = experienceTracker;
        $[8] = stopDiscoverabilityPulse;
        $[9] = t3;
    } else t3 = $[9];
    const onCrossJoinSuccess = t3;
    let t4;
    if ($[10] !== createAnalyticsEvent || $[11] !== entryPointId || $[12] !== onCrossJoinSuccess || $[13] !== sourceComponent || $[14] !== streamliningCrossJoinOnButtonClicked) {
        t4 = async ()=>{
            if ((0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate")) await streamliningCrossJoinOnButtonClicked(false);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "tryNow",
                    source: "loomCrossJoinPopupCard",
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[10] = createAnalyticsEvent;
        $[11] = entryPointId;
        $[12] = onCrossJoinSuccess;
        $[13] = sourceComponent;
        $[14] = streamliningCrossJoinOnButtonClicked;
        $[15] = t4;
    } else t4 = $[15];
    const onTryNowButtonClick = t4;
    let t5;
    if ($[16] !== createAnalyticsEvent || $[17] !== entryPointId || $[18] !== onCrossJoinSuccess || $[19] !== sourceActionSubjectId || $[20] !== sourceComponent || $[21] !== streamliningCrossJoinOnButtonClicked) {
        t5 = async ()=>{
            if ((0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate")) await streamliningCrossJoinOnButtonClicked(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: sourceActionSubjectId,
                    source: sourceActionSubjectId,
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[16] = createAnalyticsEvent;
        $[17] = entryPointId;
        $[18] = onCrossJoinSuccess;
        $[19] = sourceActionSubjectId;
        $[20] = sourceComponent;
        $[21] = streamliningCrossJoinOnButtonClicked;
        $[22] = t5;
    } else t5 = $[22];
    const onCrossJoinTriggerClick = t5;
    let t6;
    if ($[23] !== crossJoinHref || $[24] !== intl || $[25] !== onTryNowButtonClick) {
        t6 = (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA));
        $[23] = crossJoinHref;
        $[24] = intl;
        $[25] = onTryNowButtonClick;
        $[26] = t6;
    } else t6 = $[26];
    let t7;
    if ($[27] !== crossJoinHref || $[28] !== onCrossJoinTriggerClick || $[29] !== triggerLink) {
        t7 = (popupTriggerProps)=>triggerLink(!(0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? crossJoinHref : "", {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            });
        $[27] = crossJoinHref;
        $[28] = onCrossJoinTriggerClick;
        $[29] = triggerLink;
        $[30] = t7;
    } else t7 = $[30];
    let t8;
    if ($[31] !== description || $[32] !== entryPointId || $[33] !== placement || $[34] !== shouldRenderToParent || $[35] !== sourceComponent || $[36] !== t6 || $[37] !== t7 || $[38] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
            actions: t6,
            description: description,
            entryPointId: entryPointId,
            placement: placement,
            shouldRenderToParent: shouldRenderToParent,
            title: title,
            trigger: t7,
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        });
        $[31] = description;
        $[32] = entryPointId;
        $[33] = placement;
        $[34] = shouldRenderToParent;
        $[35] = sourceComponent;
        $[36] = t6;
        $[37] = t7;
        $[38] = title;
        $[39] = t8;
    } else t8 = $[39];
    return t8;
} : ({ description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)({
        entryPointId: entryPointId,
        flags: flags,
        source: 'loomCrossJoinPopupCard',
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
    const stopDiscoverabilityPulse = (0, $42omo.useCallback)(()=>{
        stopPulse();
    }, [
        stopPulse
    ]);
    const onCrossJoinSuccess = (0, $42omo.useCallback)(()=>{
        stopDiscoverabilityPulse();
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $012e0fafda229e4e$var$sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        stopDiscoverabilityPulse
    ]);
    const onTryNowButtonClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryNow',
                source: 'loomCrossJoinPopupCard',
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    const onCrossJoinTriggerClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>// the link button behaviour is handled in streamliningCrossJoinOnButtonClicked
            // when feature gate is on for Loom crossjoin experiment
            triggerLink(!(0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? crossJoinHref : '', {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            }),
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
};
module.exports["LoomCrossJoinPopupCard"] = $012e0fafda229e4e$export$9937e9f99bf53911;

});

parcelRegister("gd8AW", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $1P1Tu.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $9zUhf.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $9zUhf.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("erVVf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $7p4As = parcelRequire("7p4As");


var $6mKj3 = parcelRequire("6mKj3");


var $f5Ulo = parcelRequire("f5Ulo");


var $64hvi = parcelRequire("64hvi");

const $7197be9efeb6a957$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    },
    requestAccessNote: {
        id: "loom-utils.use-streamlining-cross-join.request-access-note.content",
        defaultMessage: "Hi, admin \uD83D\uDC4B I'd like to use Loom to collaborate with my team."
    }
});
const $7197be9efeb6a957$export$76d3f97e5e2f022d = ({ entryPointId: entryPointId, flags: flags, source: source, sourceAdType: sourceAdType, sourceComponent: sourceComponent })=>{
    const intl = (0, $aXWIB.useIntl)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const requestAccess = (0, $64hvi.useRequestAccessService)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType,
        note: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessNote)
    });
    const fetchRequestAccessCapability = (0, $64hvi.useFetchRequestAccessCapability)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType
    });
    return (0, $42omo.useCallback)(async (fromTrigger = false)=>{
        const capability = await fetchRequestAccessCapability();
        if (capability === 'REQUEST_ACCESS') {
            if ([
                'control',
                'variation'
            ].includes((0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'))) {
                if (fromTrigger) {
                    // Open new tab for control and do nothing for variation
                    if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'control')) window && window.open(crossJoinHref, '_blank');
                    return;
                }
                // fire manual feature exposed event for control and variation cohorts only
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'exposed',
                        actionSubject: 'feature',
                        source: source,
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            flagKey: 'twcg-1241_streamlining_loom_cross_join',
                            cohort: (0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'),
                            fromTrigger: fromTrigger // we should always receive false here
                        }
                    }
                }).fire();
                // streamlining access request flow for variation cohort
                if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'variation')) try {
                    const requestedAccess = await requestAccess();
                    if (requestedAccess) {
                        flags && flags.showSuccessFlag({
                            title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagTitle),
                            description: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagDescription)
                        });
                        // after successful access request, we do not proceed to open the cross join link
                        return;
                    }
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'requestAccess',
                            source: source,
                            attributes: {
                                adType: sourceAdType,
                                entrypoint: entryPointId,
                                sourceComponent: sourceComponent,
                                error: error instanceof Error ? error.message : 'unknown'
                            }
                        }
                    }).fire();
                    flags && flags.showErrorFlag({
                        title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
                            href: "https://support.atlassian.com/contact",
                            target: "_blank",
                            rel: "noreferrer"
                        }, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagActionTitle)))
                    });
                }
            }
        }
        // for other capability, we bring back the default link behaviour here
        // as we have disabled the default link behaviour for the trigger button
        window && window.open(crossJoinHref, '_blank');
    }, [
        createAnalyticsEvent,
        crossJoinHref,
        entryPointId,
        fetchRequestAccessCapability,
        flags,
        intl,
        requestAccess,
        source,
        sourceAdType,
        sourceComponent
    ]);
};
module.exports["useStreamliningCrossJoin"] = $7197be9efeb6a957$export$76d3f97e5e2f022d;

});

parcelRegister("64hvi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hCOLa = parcelRequire("hCOLa");


var $fNwcJ = parcelRequire("fNwcJ");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $92f7d7126b973070$var$fetchJson = async (input)=>{
    const { url: url, ...options } = input;
    const response = await (0, $f7B1p.cfetch)(url, options);
    return response.json();
};
const $92f7d7126b973070$export$1c1d3bfbd79d853f = ({ entryPointId: entryPointId, note: note, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const deps = (0, $42omo.useMemo)(()=>({
            createAnalyticsEvent: ({ type: type, data: data })=>createAnalyticsEvent({
                    type: type,
                    data: {
                        source: source,
                        ...data
                    }
                }),
            fetchJSON: $92f7d7126b973070$var$fetchJson,
            getCurrentCloudId: ()=>cloudId,
            getCurrentUserId: ()=>userId ?? '',
            getCurrentProduct: ()=>'confluence'
        }), [
        createAnalyticsEvent,
        cloudId,
        source,
        userId
    ]);
    const requestAccess = (0, $hCOLa.useService)((0, $fNwcJ.requestAccess), deps);
    return (0, $42omo.useCallback)(async ()=>{
        try {
            const { result: result = '' } = await requestAccess({
                product: 'loom',
                integration: entryPointId,
                note: note
            });
            const success = result === 'PENDING_REQUEST_CREATED';
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        result: result,
                        success: success
                    }
                }
            }).fire();
            return success;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        result: undefined,
                        success: false
                    }
                }
            }).fire();
            throw error;
        }
    }, [
        entryPointId,
        note,
        requestAccess,
        source,
        sourceAdType,
        createAnalyticsEvent
    ]);
};
const $92f7d7126b973070$export$a74078d93650d63f = ({ entryPointId: entryPointId, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useCallback)(async ()=>{
        const resource = `ari:cloud:loom::site/${cloudId}`;
        try {
            const params = new URLSearchParams({
                resource: resource
            });
            const url = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
            const response = await $92f7d7126b973070$var$fetchJson({
                url: url
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        resource: resource
                    }
                }
            }).fire();
            return response.results[resource] || undefined;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        resource: resource
                    }
                }
            }).fire();
        }
        return undefined;
    }, [
        cloudId,
        createAnalyticsEvent,
        entryPointId,
        source,
        sourceAdType
    ]);
};
module.exports["useRequestAccessService"] = $92f7d7126b973070$export$1c1d3bfbd79d853f;
module.exports["useFetchRequestAccessCapability"] = $92f7d7126b973070$export$a74078d93650d63f;

});

parcelRegister("hCOLa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jdJm1 = parcelRequire("jdJm1");

const $5c38ed4eae58ec94$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $42omo.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$5c38ed4eae58ec94$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $jdJm1.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $5c38ed4eae58ec94$var$DIFFERENT = false;
const $5c38ed4eae58ec94$var$EQUAL = true;
const $5c38ed4eae58ec94$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $5c38ed4eae58ec94$var$EQUAL;
    if (!prevObject || !nextObject) return $5c38ed4eae58ec94$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $5c38ed4eae58ec94$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $5c38ed4eae58ec94$var$DIFFERENT;
        }
        return $5c38ed4eae58ec94$var$EQUAL;
    }
};
module.exports["useService"] = $5c38ed4eae58ec94$export$6de4685a6c88b4e9;

});

parcelRegister("jdJm1", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

function $e28c424ef32ed9ff$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $7DBey.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $e28c424ef32ed9ff$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }
module.exports["resolveService"] = $e28c424ef32ed9ff$export$388f24d19a29b0a2;

});

parcelRegister("7DBey", function(module, exports) {
const $91acf6157f8b5c3c$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $91acf6157f8b5c3c$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $91acf6157f8b5c3c$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};
module.exports["isServiceWithDeps"] = $91acf6157f8b5c3c$export$4094c5185600bd73;
module.exports["unimplementedAbstractService"] = $91acf6157f8b5c3c$export$6e9f7b680f09bab1;
module.exports["toError"] = $91acf6157f8b5c3c$export$cc3b967c039ed3e7;

});

parcelRegister("fNwcJ", function(module, exports) {
/**
 * This file defines the requestAccess() service.
 */ 
var $dh538 = parcelRequire("dh538");


var $k4HRJ = parcelRequire("k4HRJ");


var $7DBey = parcelRequire("7DBey");


var $2Q94g = parcelRequire("2Q94g");


var $bmTr3 = parcelRequire("bmTr3");

/**
 * Valid values are defined in IIS:
 * https://bitbucket.org/atlassian/id-invitations-service/src/master/src/main/java/com/atlassian/identity/invitations/model/EnablementTouchpoint.java
 */ const $bf9bb0e4c78e4bdb$var$EnablementTouchpoint = {
    CROSSJOIN_NUDGE: 'Crossjoin Nudge'
};
// Dependencies - generally common to all RA's/joins:
const $bf9bb0e4c78e4bdb$var$dependencies = {
    fetchJSON: $bmTr3.fetchJSON,
    createAnalyticsEvent: $2Q94g.createAnalyticsEvent,
    getStargateURL: $2Q94g.getStargateURL,
    getCurrentUserId: $2Q94g.getCurrentUserId,
    getCurrentCloudId: $2Q94g.getCurrentCloudId,
    getCurrentProduct: $2Q94g.getCurrentProduct
};
const $bf9bb0e4c78e4bdb$export$cd9e5995821603e1 = Object.assign($bf9bb0e4c78e4bdb$var$requestAccessImpl, {
    dependencies: $bf9bb0e4c78e4bdb$var$dependencies
});
async function $bf9bb0e4c78e4bdb$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = (0, $k4HRJ.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString();
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const response = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...input.note && (0, $dh538.fg)('puma-1287-add-note-payload') ? {
                    note: input.note
                } : {},
                metadata: {
                    sourceProduct: deps.getCurrentProduct(),
                    ...input.touchpoint ? {
                        touchpoint: input.touchpoint
                    } : {}
                }
            })
        });
        result = $bf9bb0e4c78e4bdb$var$mapRequestAccessResponse(response, {
            resource: resource,
            userId: userId,
            ...input
        });
    } catch (error) {
        result = {
            error: (0, $7DBey.toError)(error),
            ...input,
            result: null,
            resource: resource,
            userId: userId
        };
    }
    $bf9bb0e4c78e4bdb$var$fireRequestAccessAnalytics({
        ...input,
        ...result
    }, context);
    return result;
}
function $bf9bb0e4c78e4bdb$var$mapRequestAccessResponse(response, input) {
    return {
        error: null,
        result: response.results[input.resource],
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $bf9bb0e4c78e4bdb$var$fireRequestAccessAnalytics({ error: error, product: product, result: result }, context) {
    if (!error) {
        const currentUserId = context.dependencies().getCurrentUserId();
        const attributes = {
            userAaid: currentUserId,
            actorAaid: currentUserId,
            roleName: 'product/member',
            inviteStatus: result,
            sourceProduct: context.dependencies().getCurrentProduct(),
            sourceTenantId: context.dependencies().getCurrentCloudId(),
            ...(0, $dh538.fg)('puma-1344-request-access-attributes') ? {
                PUMA_1344_REQUEST_ACCESS_ATTRIBUTES: true,
                targetProduct: product
            } : {
                PUMA_1344_REQUEST_ACCESS_ATTRIBUTES: false,
                product: product
            }
        };
        if (result === 'ACCESS_GRANTED') $bf9bb0e4c78e4bdb$var$fireProductJoined(attributes, context);
        else $bf9bb0e4c78e4bdb$var$fireProductAccessRequested(attributes, context);
    }
}
function $bf9bb0e4c78e4bdb$var$fireProductAccessRequested(input, context) {
    const { PUMA_1344_REQUEST_ACCESS_ATTRIBUTES: PUMA_1344_REQUEST_ACCESS_ATTRIBUTES, ...attributes } = input;
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: PUMA_1344_REQUEST_ACCESS_ATTRIBUTES ? input.targetProduct : input.product,
            attributes: attributes
        }
    }).fire();
}
function $bf9bb0e4c78e4bdb$var$fireProductJoined(input, context) {
    const { userUuid: userUuid, userAaid: userAaid, roleName: roleName, sourceTenantId: sourceTenantId, sourceProduct: sourceProduct, recommendationSources: recommendationSources, PUMA_1344_REQUEST_ACCESS_ATTRIBUTES: PUMA_1344_REQUEST_ACCESS_ATTRIBUTES } = input;
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSubjectId: PUMA_1344_REQUEST_ACCESS_ATTRIBUTES ? input.targetProduct : input.product,
            attributes: {
                userUuid: userUuid,
                userAaid: userAaid,
                roleName: roleName,
                sourceTenantId: sourceTenantId,
                sourceProduct: sourceProduct,
                recommendationSources: recommendationSources,
                ...PUMA_1344_REQUEST_ACCESS_ATTRIBUTES ? {
                    targetProduct: input.targetProduct
                } : {
                    product: input.product
                }
            }
        }
    }).fire();
}
module.exports["requestAccess"] = $bf9bb0e4c78e4bdb$export$cd9e5995821603e1;

});

parcelRegister("2Q94g", function(module, exports) {
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $dh538 = parcelRequire("dh538");


var $7DBey = parcelRequire("7DBey");

const $26f4407bbf6764a3$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $26f4407bbf6764a3$export$ddb1688281a3443e = (0, $7DBey.unimplementedAbstractService)('getCurrentCloudId');
const $26f4407bbf6764a3$export$5ebc6cb2748e1881 = (0, $7DBey.unimplementedAbstractService)('getCurrentUserId');
const $26f4407bbf6764a3$export$d01408ed6f850a64 = (0, $7DBey.unimplementedAbstractService)('getCurrentProduct');
const $26f4407bbf6764a3$export$a48841c0475a8073 = (0, $7DBey.unimplementedAbstractService)('createAnalyticsEvent');
const $26f4407bbf6764a3$export$a27c21aa3ed8f0f1 = (0, $7DBey.unimplementedAbstractService)('fireErrorAnalytics');
class $26f4407bbf6764a3$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $26f4407bbf6764a3$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: (0, $dh538.fg)('puma-1321-expansion-services-event-error-status') ? $26f4407bbf6764a3$var$getErrorStatus(err) : err instanceof $26f4407bbf6764a3$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });
const $26f4407bbf6764a3$var$getErrorStatus = (error)=>{
    if (!error) return undefined;
    const e = error;
    return e.statusCode ?? e.status ?? e.responseCode ?? e.response?.status;
};
const $26f4407bbf6764a3$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $26f4407bbf6764a3$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $26f4407bbf6764a3$export$1f2663aaa83f036d = 'Failed to fetch';
const $26f4407bbf6764a3$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $26f4407bbf6764a3$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $26f4407bbf6764a3$export$6827a0909c1bf12f = [
    $26f4407bbf6764a3$export$1f2663aaa83f036d,
    $26f4407bbf6764a3$export$65e55894e6e38a89,
    $26f4407bbf6764a3$export$f25400ad927aa79c
];
const $26f4407bbf6764a3$export$e1b6bb1617649e83 = (errorMessage)=>$26f4407bbf6764a3$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $26f4407bbf6764a3$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $26f4407bbf6764a3$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $26f4407bbf6764a3$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $26f4407bbf6764a3$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $26f4407bbf6764a3$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $26f4407bbf6764a3$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $26f4407bbf6764a3$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $26f4407bbf6764a3$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $26f4407bbf6764a3$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (_ignoredError) {
        return false;
    }
};
const $26f4407bbf6764a3$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $26f4407bbf6764a3$export$80a3c1a1eb6f063 || errorMessage === $26f4407bbf6764a3$export$e089e1d2018847da;
const $26f4407bbf6764a3$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $26f4407bbf6764a3$export$678d91a98f79a24d(message, status) || status === 400 && ($26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$c53f16dd5442ef61) || $26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$e27975535396141b)) || status === 412 && $26f4407bbf6764a3$export$395f41a02d6a8be0(key, message);
};
const $26f4407bbf6764a3$export$9de493bcd9b1d977 = 'bad-request';
const $26f4407bbf6764a3$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $26f4407bbf6764a3$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $26f4407bbf6764a3$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $26f4407bbf6764a3$export$e5254cb9f7678ab9) return false;
    return true;
};
module.exports["getStargateURL"] = $26f4407bbf6764a3$export$c7904a8284e43beb;
module.exports["getCurrentCloudId"] = $26f4407bbf6764a3$export$ddb1688281a3443e;
module.exports["getCurrentUserId"] = $26f4407bbf6764a3$export$5ebc6cb2748e1881;
module.exports["getCurrentProduct"] = $26f4407bbf6764a3$export$d01408ed6f850a64;
module.exports["createAnalyticsEvent"] = $26f4407bbf6764a3$export$a48841c0475a8073;
module.exports["getErrorDetails"] = $26f4407bbf6764a3$export$33e83b6fee5d732d;
module.exports["isAcceptableFailure"] = $26f4407bbf6764a3$export$678d91a98f79a24d;
module.exports["isAcceptableFailureForUserInvite"] = $26f4407bbf6764a3$export$1c4c1f7e2d529330;
module.exports["shouldReportFailedInvite"] = $26f4407bbf6764a3$export$90cda429f609d666;

});

parcelRegister("bmTr3", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

const $c1aca408fa9ca14a$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $7DBey.unimplementedAbstractService)('fetchJSON');
module.exports["fetchJSON"] = $c1aca408fa9ca14a$export$81bec6e38e8b706b;

});

parcelRegister("cnQgR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4rwCt = parcelRequire("4rwCt");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $cOrQJ = parcelRequire("cOrQJ");


var $lAFHW = parcelRequire("lAFHW");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $6mKj3 = parcelRequire("6mKj3");


var $2fvAC = parcelRequire("2fvAC");


var $5M6IM = parcelRequire("5M6IM");


var $kqrkb = parcelRequire("kqrkb");

const $282df3a04f7add9c$export$e4ecefef0a48fd72 = 400;
const $282df3a04f7add9c$var$i18n = (0, $aXWIB.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $282df3a04f7add9c$var$cardStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    overflow: 'auto',
    width: '352px'
});
const $282df3a04f7add9c$var$cardContentStyles = (0, $ecnYn.xcss)({
    padding: 'space.300'
});
const $282df3a04f7add9c$var$imageContainerStyles = (0, $ecnYn.xcss)({
    height: '201px'
});
const $282df3a04f7add9c$var$spotlightContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'fixed'
});
const $282df3a04f7add9c$export$48e89f1cdc429537 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(87);
    const { actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: t1, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl } = t0;
    const shouldRenderToParent = t1 === undefined ? true : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === "dark";
    const intl = (0, $aXWIB.useIntl)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const hasStartedPreloadingImage = (0, $42omo.useRef)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const openPopupTimerRef = (0, $42omo.useRef)(null);
    const contentWrapperElementRef = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const isOpenOnFocusDisabled = (0, $42omo.useRef)(false);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (closePopupTimerRef.current) {
                clearTimeout(closePopupTimerRef.current);
                closePopupTimerRef.current = null;
            }
        };
        $[0] = t2;
    } else t2 = $[0];
    const clearClosePopupTimer = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (openPopupTimerRef.current) {
                clearTimeout(openPopupTimerRef.current);
                openPopupTimerRef.current = null;
            }
        };
        $[1] = t3;
    } else t3 = $[1];
    const clearOpenPopupTimer = t3;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t4;
    let t5;
    if ($[2] !== entryPointId || $[3] !== experienceTracker || $[4] !== isOpen || $[5] !== sourceAdType) {
        t4 = ()=>{
            if (isOpen) experienceTracker.start({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
        };
        t5 = [
            entryPointId,
            experienceTracker,
            isOpen,
            sourceAdType
        ];
        $[2] = entryPointId;
        $[3] = experienceTracker;
        $[4] = isOpen;
        $[5] = sourceAdType;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[8] !== entryPointId || $[9] !== experienceTracker || $[10] !== sourceAdType) {
        t6 = ()=>{
            setIsOpen(false);
            experienceTracker.abort({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                reason: "Loom pop up closed",
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
            isOpenOnFocusDisabled.current = true;
            setTimeout(()=>{
                isOpenOnFocusDisabled.current = false;
            }, 0);
        };
        $[8] = entryPointId;
        $[9] = experienceTracker;
        $[10] = sourceAdType;
        $[11] = t6;
    } else t6 = $[11];
    const safeClosePopup = t6;
    let t7;
    if ($[12] !== safeClosePopup) {
        t7 = ()=>{
            clearOpenPopupTimer();
            if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
                safeClosePopup();
                closePopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[12] = safeClosePopup;
        $[13] = t7;
    } else t7 = $[13];
    const startClosePopupTimer = t7;
    let t8;
    if ($[14] !== createAnalyticsEvent || $[15] !== entryPointId || $[16] !== sourceAdType || $[17] !== sourceComponent) {
        t8 = ()=>{
            clearClosePopupTimer();
            if (!hasStartedPreloadingImage.current) {
                hasStartedPreloadingImage.current = true;
                const img = new Image();
                img.src = (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)));
            }
            if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
                if (sourceAdType === "crossFlow") (0, $6mKj3.expVal)("migrate_confluence_loom_xflow_popup_to_spotlight", "exposure", false);
                createAnalyticsEvent({
                    type: "sendScreenEvent",
                    data: {
                        name: "loomAdPopupCard",
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            sourceComponent: sourceComponent,
                            isMigrateToSpotlightEnabled: sourceAdType === "crossFlow" && (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false)
                        }
                    }
                }).fire();
                setIsOpen(true);
                openPopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[14] = createAnalyticsEvent;
        $[15] = entryPointId;
        $[16] = sourceAdType;
        $[17] = sourceComponent;
        $[18] = t8;
    } else t8 = $[18];
    const startOpenPopupTimer = t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            clearOpenPopupTimer();
        };
        $[19] = t9;
    } else t9 = $[19];
    const handleTriggerBlur = t9;
    let t10;
    if ($[20] !== startOpenPopupTimer) {
        t10 = ()=>{
            if ((0, $6mKj3.expValEquals)("cc_comments_a11y_tuneup", "isEnabled", true)) return;
            if (!isOpenOnFocusDisabled.current) startOpenPopupTimer();
        };
        $[20] = startOpenPopupTimer;
        $[21] = t10;
    } else t10 = $[21];
    const handleTriggerFocus = t10;
    let t11;
    if ($[22] !== startOpenPopupTimer) {
        t11 = ()=>{
            startOpenPopupTimer();
        };
        $[22] = startOpenPopupTimer;
        $[23] = t11;
    } else t11 = $[23];
    const handleTriggerMouseEnter = t11;
    let t12;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            clearClosePopupTimer();
        };
        $[24] = t12;
    } else t12 = $[24];
    const handleCardMouseEnter = t12;
    let t13;
    if ($[25] !== startClosePopupTimer) {
        t13 = ()=>{
            if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
        };
        $[25] = startClosePopupTimer;
        $[26] = t13;
    } else t13 = $[26];
    const handleMouseLeave = t13;
    let t14;
    if ($[27] !== actions || $[28] !== description || $[29] !== handleMouseLeave || $[30] !== title) {
        t14 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: contentWrapperElementRef,
                xcss: $282df3a04f7add9c$var$cardStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $282df3a04f7add9c$var$imageContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                alt: "",
                height: "201px",
                width: "352px",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)))
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.300",
                xcss: $282df3a04f7add9c$var$cardContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                as: "h2",
                size: "small"
            }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                as: "p",
                color: "color.text.subtle"
            }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomAttributionLogo), {
                appearance: "brand",
                size: "medium"
            }), actions)));
        $[27] = actions;
        $[28] = description;
        $[29] = handleMouseLeave;
        $[30] = title;
        $[31] = t14;
    } else t14 = $[31];
    const content = t14;
    if (sourceAdType === "crossFlow" && (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false)) {
        let t15;
        if ($[32] !== handleMouseLeave || $[33] !== handleTriggerFocus || $[34] !== handleTriggerMouseEnter || $[35] !== isOpen || $[36] !== trigger) {
            t15 = trigger({
                ref: triggerElementRef,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                "aria-expanded": isOpen,
                "aria-haspopup": true
            });
            $[32] = handleMouseLeave;
            $[33] = handleTriggerFocus;
            $[34] = handleTriggerMouseEnter;
            $[35] = isOpen;
            $[36] = trigger;
            $[37] = t15;
        } else t15 = $[37];
        let t16;
        if ($[38] !== t15) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, t15);
            $[38] = t15;
            $[39] = t16;
        } else t16 = $[39];
        const t17 = spotlightPlacement || "left-start";
        let t18;
        if ($[40] !== title) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                as: "span",
                size: "xsmall"
            }, title);
            $[40] = title;
            $[41] = t18;
        } else t18 = $[41];
        let t19;
        if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null);
            $[42] = t19;
        } else t19 = $[42];
        let t20;
        if ($[43] !== adControl) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, t19, adControl);
            $[43] = adControl;
            $[44] = t20;
        } else t20 = $[44];
        let t21;
        if ($[45] !== t18 || $[46] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, t18, t20);
            $[45] = t18;
            $[46] = t20;
            $[47] = t21;
        } else t21 = $[47];
        const t22 = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($kqrkb))) : (0, (/*@__PURE__*/$parcel$interopDefault($5M6IM)));
        let t23;
        if ($[48] !== t22) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                alt: "",
                src: t22
            }));
            $[48] = t22;
            $[49] = t23;
        } else t23 = $[49];
        let t24;
        if ($[50] !== description) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                as: "p"
            }, description));
            $[50] = description;
            $[51] = t24;
        } else t24 = $[51];
        let t25;
        if ($[52] !== intl) {
            t25 = intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow);
            $[52] = intl;
            $[53] = t25;
        } else t25 = $[53];
        let t26;
        if ($[54] !== primaryOnClick || $[55] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
                onClick: primaryOnClick
            }, t25)));
            $[54] = primaryOnClick;
            $[55] = t25;
            $[56] = t26;
        } else t26 = $[56];
        let t27;
        if ($[57] !== t21 || $[58] !== t23 || $[59] !== t24 || $[60] !== t26) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
                testId: "loom-cross-sell-spotlight-content-card"
            }, t21, t23, t24, t26);
            $[57] = t21;
            $[58] = t23;
            $[59] = t24;
            $[60] = t26;
            $[61] = t27;
        } else t27 = $[61];
        let t28;
        if ($[62] !== isOpen || $[63] !== safeClosePopup || $[64] !== t17 || $[65] !== t27) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
                isVisible: isOpen,
                placement: t17,
                dismiss: safeClosePopup,
                testId: "loom-cross-sell-spotlight-content",
                strategy: "absolute",
                shouldDismissOnClickOutside: false
            }, t27);
            $[62] = isOpen;
            $[63] = safeClosePopup;
            $[64] = t17;
            $[65] = t27;
            $[66] = t28;
        } else t28 = $[66];
        let t29;
        if ($[67] !== handleMouseLeave || $[68] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                ref: triggerElementRef,
                testId: "loom-cross-sell-spotlight-content-container",
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
            }, t28);
            $[67] = handleMouseLeave;
            $[68] = t28;
            $[69] = t29;
        } else t29 = $[69];
        let t30;
        if ($[70] !== t16 || $[71] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, t16, t29);
            $[70] = t16;
            $[71] = t29;
            $[72] = t30;
        } else t30 = $[72];
        return t30;
    }
    const t15 = placement || "auto";
    let t16;
    if ($[73] !== handleMouseLeave || $[74] !== handleTriggerFocus || $[75] !== handleTriggerMouseEnter || $[76] !== isOpen || $[77] !== trigger) {
        t16 = (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4rwCt.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            });
        $[73] = handleMouseLeave;
        $[74] = handleTriggerFocus;
        $[75] = handleTriggerMouseEnter;
        $[76] = isOpen;
        $[77] = trigger;
        $[78] = t16;
    } else t16 = $[78];
    let t17;
    if ($[79] !== content || $[80] !== isOpen || $[81] !== safeClosePopup || $[82] !== shouldRenderToParent || $[83] !== t15 || $[84] !== t16 || $[85] !== title) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            autoFocus: false,
            content: content,
            isOpen: isOpen,
            label: title,
            onClose: safeClosePopup,
            placement: t15,
            role: "dialog",
            shouldRenderToParent: shouldRenderToParent,
            trigger: t16
        });
        $[79] = content;
        $[80] = isOpen;
        $[81] = safeClosePopup;
        $[82] = shouldRenderToParent;
        $[83] = t15;
        $[84] = t16;
        $[85] = title;
        $[86] = t17;
    } else t17 = $[86];
    return t17;
} : ({ actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: shouldRenderToParent = true, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    const intl = (0, $aXWIB.useIntl)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const hasStartedPreloadingImage = (0, $42omo.useRef)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const openPopupTimerRef = (0, $42omo.useRef)(null);
    const contentWrapperElementRef = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const isOpenOnFocusDisabled = (0, $42omo.useRef)(false);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const clearOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openPopupTimerRef.current) {
            clearTimeout(openPopupTimerRef.current);
            openPopupTimerRef.current = null;
        }
    }, []);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (isOpen) experienceTracker.start({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        isOpen,
        sourceAdType
    ]);
    /**
   * Temporarily disable the popup from re-opening (for a tick) on focus
   * because in many cases, closing the popup returns focus back to the
   * trigger, which would normally open the popup again.
   */ const safeClosePopup = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'Loom pop up closed',
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
        isOpenOnFocusDisabled.current = true;
        setTimeout(()=>{
            isOpenOnFocusDisabled.current = false;
        }, 0);
    }, [
        entryPointId,
        experienceTracker,
        sourceAdType
    ]);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
        if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
            safeClosePopup();
            closePopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearOpenPopupTimer,
        safeClosePopup
    ]);
    /**
   * Don't open the popup card immediately on hover or focus
   *
   * 1) Focus: We want KB users to be able to quickly navigate through areas with entrypoints that
   * are alongside many other UI controls (e.g., Page Header, Page Editor Toolbar) without triggering
   * the popup card and getting "stuck" (needing to hit "esc" to continue).
   *
   * 2) Hover: We don't want users to feel like the popup card gets in their way of clicking other
   * things in the UI just because their mouse briefly brushed over the entrypoint button.
   *
   * This was heavily inspired by the hover cards used in the Page Tree (`useHoverPageCard`)
   */ const startOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        if (!hasStartedPreloadingImage.current) {
            hasStartedPreloadingImage.current = true;
            const img = new Image();
            img.src = (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)));
        }
        if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
            if (sourceAdType === 'crossFlow') // We are only migrating the cross-flow popup to spotlight for now https://atlassian.slack.com/archives/C0A7J84AS68/p1768356523913099)
            (0, $6mKj3.expVal)('migrate_confluence_loom_xflow_popup_to_spotlight', 'exposure', false); // fire exposure event when the popup is actually opened
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'loomAdPopupCard',
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent,
                        isMigrateToSpotlightEnabled: sourceAdType === 'crossFlow' && (0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false)
                    }
                }
            }).fire();
            setIsOpen(true);
            openPopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearClosePopupTimer,
        createAnalyticsEvent,
        entryPointId,
        sourceAdType,
        sourceComponent
    ]);
    const handleTriggerBlur = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
    }, [
        clearOpenPopupTimer
    ]);
    const handleTriggerFocus = (0, $42omo.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_comments_a11y_tuneup', 'isEnabled', true)) // Keyboard focus should NOT open the popup — only hover should.
        // Opening on focus violates WCAG 3.2.1 (On Focus) as it triggers a
        // change of context without user activation. (A11Y-30783, A11Y-30827)
        return;
        if (!isOpenOnFocusDisabled.current) startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleTriggerMouseEnter = (0, $42omo.useCallback)(()=>{
        startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleCardMouseEnter = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
    }, [
        clearClosePopupTimer
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        /**
     * Don't close the popup card when moving the mouse outside of it (or the trigger) if something
     * inside it (or the trigger itself) is focused
     */ if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
    }, [
        startClosePopupTimer
    ]);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            onMouseEnter: handleCardMouseEnter,
            onMouseLeave: handleMouseLeave,
            ref: contentWrapperElementRef,
            xcss: $282df3a04f7add9c$var$cardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $282df3a04f7add9c$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            alt: "",
            height: "201px",
            width: "352px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.300",
            xcss: $282df3a04f7add9c$var$cardContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "h2",
            size: "small"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            as: "p",
            color: "color.text.subtle"
        }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomAttributionLogo), {
            appearance: "brand",
            size: "medium"
        }), actions)));
    if (sourceAdType === 'crossFlow' && // We are only migrating the cross-flow popup to spotlight for now https://atlassian.slack.com/archives/C0A7J84AS68/p1768356523913099
    (0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false)) /**
     * We are migrating the crossflow popup to use the new ADS spotlight design.
     * We will be conducting this as a no-harm experiment.
     * Poster: https://hello.atlassian.net/wiki/spaces/Growth/pages/6294901981/Migrate+Confluence+Loom+Crossflow+Popup+to+Spotlight+Eng+led+TWCG-1446+Project+Poster+FY26
     */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, trigger({
        ref: triggerElementRef,
        isSelected: isOpen,
        onBlur: handleTriggerBlur,
        onFocus: handleTriggerFocus,
        onMouseEnter: handleTriggerMouseEnter,
        onMouseLeave: handleMouseLeave,
        'aria-expanded': isOpen,
        'aria-haspopup': true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: triggerElementRef,
        testId: "loom-cross-sell-spotlight-content-container",
        onMouseEnter: handleCardMouseEnter,
        onMouseLeave: handleMouseLeave,
        xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: isOpen,
        placement: spotlightPlacement || 'left-start',
        dismiss: safeClosePopup,
        testId: "loom-cross-sell-spotlight-content",
        strategy: "absolute",
        shouldDismissOnClickOutside: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "loom-cross-sell-spotlight-content-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "span",
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null), adControl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($kqrkb))) : (0, (/*@__PURE__*/$parcel$interopDefault($5M6IM)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: primaryOnClick
    }, intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        autoFocus: false,
        content: content,
        isOpen: isOpen,
        /**
   * Using `titleId` and adding the same value as an `id` to the Heading in the popup content
   * does not announce properly in macOS VoiceOver
   */ label: title,
        onClose: safeClosePopup,
        placement: placement || 'auto',
        role: "dialog",
        shouldRenderToParent: shouldRenderToParent,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4rwCt.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            })
    });
};
module.exports["BaseLoomPopupCard"] = $282df3a04f7add9c$export$48e89f1cdc429537;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("2fvAC", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImage.6e60c328.png", import.meta.url).toString();

});

parcelRegister("5M6IM", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png", import.meta.url).toString();

});

parcelRegister("kqrkb", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png", import.meta.url).toString();

});

parcelRegister("6T0Pj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $u9agA = parcelRequire("u9agA");


var $6NnCm = parcelRequire("6NnCm");


var $1cfhF = parcelRequire("1cfhF");

var $lfQiY = parcelRequire("lfQiY");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $gd8AW = parcelRequire("gd8AW");


var $ej7WH = parcelRequire("ej7WH");


var $jkI1v = parcelRequire("jkI1v");


var $k0DFC = parcelRequire("k0DFC");


var $6mKj3 = parcelRequire("6mKj3");


var $cnQgR = parcelRequire("cnQgR");

const $9bb41a4fe26f7df4$var$sourceAdType = 'crossFlow';
const $9bb41a4fe26f7df4$var$i18n = (0, $aXWIB.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $9bb41a4fe26f7df4$var$env = 'prod';
const $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID = (0, $1cfhF.FIRST_PARTY_CCP_PRODUCT_IDS)[$9bb41a4fe26f7df4$var$env].loom;
const $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource = (entrypointId)=>{
    switch(entrypointId){
        case 'loom-confluence-inline-comment':
            return 'loomConfluenceInlineCommentButton';
        case 'loom-confluence-page-editor-toolbar':
            return 'loomConfluencePageEditorToolbarButton';
        case 'loom-confluence-page-header':
            return 'loomConfluencePageHeaderButton';
        default:
            return null;
    }
};
const $9bb41a4fe26f7df4$export$7232e4c8af3c9680 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(58);
    const { description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, title: title, trigger: trigger, sourceComponent: sourceComponent, sourceContext: sourceContext } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $lfQiY.useFireCrossFlowAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const ctaRef = (0, $42omo.useRef)(null);
    let t1;
    if ($[0] !== sourceComponent || $[1] !== sourceContext) {
        t1 = {
            sourceComponent: sourceComponent,
            sourceContext: sourceContext
        };
        $[0] = sourceComponent;
        $[1] = sourceContext;
        $[2] = t1;
    } else t1 = $[2];
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)(t1);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t2;
    if ($[3] !== entryPointId) {
        t2 = {
            touchpoint: entryPointId
        };
        $[3] = entryPointId;
        $[4] = t2;
    } else t2 = $[4];
    const { isInterestedInLoom: isInterestedInLoom, notInterestedInLoomCallback: notInterestedInLoomCallback } = (0, $k0DFC.useLoomAdControlState)(t2);
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t3;
    if ($[5] !== stopPulse) {
        t3 = ()=>{
            stopPulse();
        };
        $[5] = stopPulse;
        $[6] = t3;
    } else t3 = $[6];
    const stopDiscoverabilityPulse = t3;
    let t4;
    let t5;
    if ($[7] !== entryPointId || $[8] !== fireViewedUIEvent || $[9] !== sourceComponent) {
        t4 = ()=>{
            fireViewedUIEvent({
                action: "viewed",
                actionSubject: "button",
                actionSubjectId: sourceComponent
            }, {
                source: entryPointId,
                recommendedProductIds: [
                    $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
                ]
            });
        };
        t5 = [
            fireViewedUIEvent,
            sourceComponent,
            entryPointId
        ];
        $[7] = entryPointId;
        $[8] = fireViewedUIEvent;
        $[9] = sourceComponent;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[12] !== createAnalyticsEvent || $[13] !== entryPointId || $[14] !== fireInteractedUIEvent || $[15] !== sourceActionSubjectId || $[16] !== sourceContext || $[17] !== stopDiscoverabilityPulse || $[18] !== triggerCrossFlow) {
        t6 = async (triggerName)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: triggerName,
                    source: triggerName === "tryNow" ? "loomCrossFlowPopupCard" : sourceActionSubjectId,
                    attributes: {
                        adType: $9bb41a4fe26f7df4$var$sourceAdType,
                        entrypoint: entryPointId,
                        isMigrateToSpotlightEnabled: (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false)
                    }
                }
            }).fire();
            const crossFlowInteractionSource = $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource(entryPointId);
            crossFlowInteractionSource && fireInteractedUIEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: sourceContext
            }, {
                source: crossFlowInteractionSource,
                recommendedProductIds: [
                    $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
                ],
                targetProductId: $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            });
            stopDiscoverabilityPulse();
            await triggerCrossFlow();
        };
        $[12] = createAnalyticsEvent;
        $[13] = entryPointId;
        $[14] = fireInteractedUIEvent;
        $[15] = sourceActionSubjectId;
        $[16] = sourceContext;
        $[17] = stopDiscoverabilityPulse;
        $[18] = triggerCrossFlow;
        $[19] = t6;
    } else t6 = $[19];
    const onCrossFlowTriggerClick = t6;
    let t7;
    if ($[20] !== entryPointId || $[21] !== experienceTracker || $[22] !== notInterestedInLoomCallback || $[23] !== stopDiscoverabilityPulse) {
        t7 = async ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                reason: "User not interested in Loom",
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $9bb41a4fe26f7df4$var$sourceAdType
                }
            });
            stopDiscoverabilityPulse();
            await notInterestedInLoomCallback();
        };
        $[20] = entryPointId;
        $[21] = experienceTracker;
        $[22] = notInterestedInLoomCallback;
        $[23] = stopDiscoverabilityPulse;
        $[24] = t7;
    } else t7 = $[24];
    const handleNotInterested = t7;
    if (!isInterestedInLoom) return null;
    let t8;
    if ($[25] !== entryPointId || $[26] !== handleNotInterested) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId
        });
        $[25] = entryPointId;
        $[26] = handleNotInterested;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== onCrossFlowTriggerClick) {
        t9 = ()=>onCrossFlowTriggerClick("tryNow");
        $[28] = onCrossFlowTriggerClick;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== intl) {
        t10 = intl.formatMessage($9bb41a4fe26f7df4$var$i18n.tryNow);
        $[30] = intl;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== t10 || $[33] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: t9,
            ref: ctaRef
        }, t10);
        $[32] = t10;
        $[33] = t9;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== t11 || $[36] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100"
        }, t8, t11);
        $[35] = t11;
        $[36] = t8;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== onCrossFlowTriggerClick || $[39] !== sourceActionSubjectId || $[40] !== trigger) {
        t13 = (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                onClick: ()=>onCrossFlowTriggerClick(sourceActionSubjectId),
                onKeyDown: (e)=>{
                    if (e.key === "Tab") ctaRef.current?.focus();
                }
            });
        $[38] = onCrossFlowTriggerClick;
        $[39] = sourceActionSubjectId;
        $[40] = trigger;
        $[41] = t13;
    } else t13 = $[41];
    let t14;
    if ($[42] !== onCrossFlowTriggerClick) {
        t14 = ()=>onCrossFlowTriggerClick("tryNow");
        $[42] = onCrossFlowTriggerClick;
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== entryPointId || $[45] !== handleNotInterested) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId,
            customTrigger: $9bb41a4fe26f7df4$var$_temp
        });
        $[44] = entryPointId;
        $[45] = handleNotInterested;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== description || $[48] !== entryPointId || $[49] !== placement || $[50] !== shouldRenderToParent || $[51] !== spotlightPlacement || $[52] !== t12 || $[53] !== t13 || $[54] !== t14 || $[55] !== t15 || $[56] !== title) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
            actions: t12,
            description: description,
            entryPointId: entryPointId,
            placement: placement,
            shouldRenderToParent: shouldRenderToParent,
            title: title,
            trigger: t13,
            sourceAdType: $9bb41a4fe26f7df4$var$sourceAdType,
            spotlightPlacement: spotlightPlacement,
            primaryOnClick: t14,
            adControl: t15
        });
        $[47] = description;
        $[48] = entryPointId;
        $[49] = placement;
        $[50] = shouldRenderToParent;
        $[51] = spotlightPlacement;
        $[52] = t12;
        $[53] = t13;
        $[54] = t14;
        $[55] = t15;
        $[56] = title;
        $[57] = t16;
    } else t16 = $[57];
    return t16;
} : ({ description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, title: title, trigger: trigger, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $lfQiY.useFireCrossFlowAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const ctaRef = (0, $42omo.useRef)(null);
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)({
        sourceComponent: sourceComponent,
        sourceContext: sourceContext
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isInterestedInLoom: isInterestedInLoom, notInterestedInLoomCallback: notInterestedInLoomCallback } = (0, $k0DFC.useLoomAdControlState)({
        touchpoint: entryPointId
    });
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const stopDiscoverabilityPulse = (0, $42omo.useCallback)(()=>{
        stopPulse();
    }, [
        stopPulse
    ]);
    // View event for go/BMD crossflow funnel
    (0, $42omo.useEffect)(()=>{
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'button',
            actionSubjectId: sourceComponent
        }, {
            source: entryPointId,
            recommendedProductIds: [
                $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            ]
        });
    }, [
        fireViewedUIEvent,
        sourceComponent,
        entryPointId
    ]);
    const onCrossFlowTriggerClick = (0, $42omo.useCallback)(async (triggerName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: triggerName,
                source: triggerName === 'tryNow' ? 'loomCrossFlowPopupCard' : sourceActionSubjectId,
                attributes: {
                    adType: $9bb41a4fe26f7df4$var$sourceAdType,
                    entrypoint: entryPointId,
                    isMigrateToSpotlightEnabled: (0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false)
                }
            }
        }).fire();
        // Interaction event for go/BMD crossflow funnel. Only fire if entryPointId is registered in @atlassian/surface-analytics-specs package
        const crossFlowInteractionSource = $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource(entryPointId);
        crossFlowInteractionSource && fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: sourceContext
        }, {
            source: crossFlowInteractionSource,
            recommendedProductIds: [
                $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            ],
            targetProductId: $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
        });
        stopDiscoverabilityPulse();
        await triggerCrossFlow();
    }, [
        createAnalyticsEvent,
        entryPointId,
        triggerCrossFlow,
        sourceActionSubjectId,
        sourceContext,
        fireInteractedUIEvent,
        stopDiscoverabilityPulse
    ]);
    const handleNotInterested = (0, $42omo.useCallback)(async ()=>{
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'User not interested in Loom',
            attributes: {
                sourceComponent: entryPointId,
                adType: $9bb41a4fe26f7df4$var$sourceAdType
            }
        });
        stopDiscoverabilityPulse();
        await notInterestedInLoomCallback();
    }, [
        entryPointId,
        experienceTracker,
        notInterestedInLoomCallback,
        stopDiscoverabilityPulse
    ]);
    if (!isInterestedInLoom) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: ()=>onCrossFlowTriggerClick('tryNow'),
            ref: ctaRef
        }, intl.formatMessage($9bb41a4fe26f7df4$var$i18n.tryNow))),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                onClick: ()=>onCrossFlowTriggerClick(sourceActionSubjectId),
                onKeyDown: (e)=>{
                    if (e.key === 'Tab') ctaRef.current?.focus();
                }
            }),
        sourceAdType: $9bb41a4fe26f7df4$var$sourceAdType,
        spotlightPlacement: spotlightPlacement,
        primaryOnClick: ()=>onCrossFlowTriggerClick('tryNow'),
        adControl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId,
            customTrigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6NnCm.SpotlightShowMoreControl), {
                    testId: triggerProps.testId,
                    ref: triggerProps.triggerRef,
                    onClick: triggerProps.onClick
                })
        })
    });
};
function $9bb41a4fe26f7df4$var$_temp(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6NnCm.SpotlightShowMoreControl), {
        testId: triggerProps.testId,
        ref: triggerProps.triggerRef,
        onClick: triggerProps.onClick
    });
}
module.exports["LoomCrossFlowPopupCard"] = $9bb41a4fe26f7df4$export$7232e4c8af3c9680;

});

parcelRegister("6NnCm", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9VJDA = parcelRequire("9VJDA");


var $fVUfS = parcelRequire("fVUfS");

const $ad0bfce27db989ea$var$styles = {
    root: "_2rko12b0 _1rjc12x7 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $ad0bfce27db989ea$export$b97a88aea1fe9a05 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: $ad0bfce27db989ea$var$styles.root,
        onClick: onClick,
        ref: ref,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: "Show more"
        })
    });
});
module.exports["SpotlightShowMoreControl"] = $ad0bfce27db989ea$export$b97a88aea1fe9a05;

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("jkI1v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $1qfLF = parcelRequire("1qfLF");


var $9VJDA = parcelRequire("9VJDA");


var $irxfF = parcelRequire("irxfF");

var $2zUpm = parcelRequire("2zUpm");

var $3ylo6 = parcelRequire("3ylo6");

var $hEz36 = parcelRequire("hEz36");


var $6mKj3 = parcelRequire("6mKj3");

const $8b615b773eb5cff4$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $8b615b773eb5cff4$export$81624a1cb6914931 = (0, $aXWIB.defineMessages)({
    dismissFlagTitle: {
        id: "loom-utils.loom-ad-control.dismiss-flag-title",
        defaultMessage: "Got it, thanks for letting us know"
    },
    dismissFlagDescription: {
        id: "loom-utils.loom-ad-control.dismiss-flag-description",
        defaultMessage: "You won\u2019t see this here as often."
    },
    reasonsModalTitle: {
        id: "loom-utils.loom-ad-control.reasons-modal-title",
        defaultMessage: "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        id: "loom-utils.loom-ad-control.reasons-modal-explanation",
        defaultMessage: "We think that <strong>Loom</strong> will improve your team\u2019s productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        id: "loom-utils.loom-ad-control.reasons-modal-bullet-one",
        defaultMessage: "the size of your team"
    },
    reasonsModalBulletTwo: {
        id: "loom-utils.loom-ad-control.reasons-modal-bullet-two",
        defaultMessage: "your existing Atlassian products"
    },
    privacyPolicy: {
        id: "loom-utils.loom-ad-control.privacy-policy",
        defaultMessage: "Learn more about your data privacy with Atlassian"
    }
});
const $8b615b773eb5cff4$var$linkStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $8b615b773eb5cff4$var$moreIconStyles = (0, $ecnYn.xcss)({
    alignSelf: 'center'
});
const $8b615b773eb5cff4$var$LoomAdControlReasonModalBody = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { entryPointId: entryPointId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== entryPointId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "loomAdControlReasonsModal",
                    attributes: {
                        adType: "crossFlow",
                        entrypoint: entryPointId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            entryPointId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = entryPointId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalExplanation, {
            strong: $8b615b773eb5cff4$var$_temp
        });
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletOne);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, t5);
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== formatMessage) {
        t7 = formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletTwo);
        $[12] = formatMessage;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, t7);
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t6 || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", null, t6, t8);
        $[16] = t6;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== formatMessage) {
        t10 = formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.privacyPolicy);
        $[19] = formatMessage;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $8b615b773eb5cff4$var$linkStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
            href: $8b615b773eb5cff4$export$aefe1c8741b24a28,
            target: "_blank"
        }, t10));
        $[21] = t10;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== t4 || $[25] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t4, t9, t11);
        $[23] = t11;
        $[24] = t4;
        $[25] = t9;
        $[26] = t12;
    } else t12 = $[26];
    return t12;
} : ({ entryPointId: entryPointId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'loomAdControlReasonsModal',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: entryPointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text"
    }, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalExplanation, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold",
                color: "color.text"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8b615b773eb5cff4$var$linkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        href: $8b615b773eb5cff4$export$aefe1c8741b24a28,
        target: "_blank"
    }, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.privacyPolicy))));
};
const $8b615b773eb5cff4$export$5922fd76035890d5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { onDismiss: onDismiss, entryPointId: entryPointId, spacing: t1, customTrigger: customTrigger } = t0;
    const spacing = t1 === undefined ? "compact" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== entryPointId) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "toggleLoomAdControlDropdown",
                    source: "loomCrossFlowPopupCard",
                    attributes: {
                        adType: "crossFlow",
                        entrypoint: entryPointId
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = entryPointId;
        $[2] = t2;
    } else t2 = $[2];
    const fireTriggerClickAnalyticsEvent = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false) ? {
            placement: "top-end"
        } : {};
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== customTrigger || $[5] !== fireTriggerClickAnalyticsEvent || $[6] !== spacing) {
        t4 = (t5)=>{
            const { triggerRef: triggerRef, ...props } = t5;
            return customTrigger ? customTrigger({
                testId: "loom-utils.loom-ad-control.custom-button",
                triggerRef: triggerRef,
                onClick: (e)=>{
                    fireTriggerClickAnalyticsEvent();
                    props.onClick?.(e);
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8b615b773eb5cff4$var$moreIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                onClick: (e_0)=>{
                    fireTriggerClickAnalyticsEvent();
                    props.onClick?.(e_0);
                },
                appearance: "subtle",
                spacing: spacing,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                label: "LoomAdControl",
                testId: "loom-utils.loom-ad-control.button"
            }));
        };
        $[4] = customTrigger;
        $[5] = fireTriggerClickAnalyticsEvent;
        $[6] = spacing;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false) ? {
            strategy: "absolute"
        } : {};
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== createAnalyticsEvent || $[10] !== entryPointId || $[11] !== formatMessage || $[12] !== onDismiss) {
        t6 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ylo6.default), {
                ...props_0,
                flagProps: {
                    title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagTitle),
                    description: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagDescription)
                },
                onClick: onDismiss
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEz36.default), {
                ...props_0,
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "toggleLoomAdControlReasonsModal",
                            source: "loomAdControlDropdown",
                            attributes: {
                                adType: "crossFlow",
                                entrypoint: entryPointId
                            }
                        }
                    }).fire();
                },
                modalProps: {
                    title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalTitle),
                    body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8b615b773eb5cff4$var$LoomAdControlReasonModalBody, {
                        entryPointId: entryPointId
                    })
                }
            }));
        $[9] = createAnalyticsEvent;
        $[10] = entryPointId;
        $[11] = formatMessage;
        $[12] = onDismiss;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t4 || $[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2zUpm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irxfF.default), {
            itemId: "loom-ad-controls",
            ...t3,
            trigger: t4,
            ...t5
        }, t6));
        $[14] = t4;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ onDismiss: onDismiss, entryPointId: entryPointId, spacing: spacing = 'compact', customTrigger: customTrigger })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const fireTriggerClickAnalyticsEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'toggleLoomAdControlDropdown',
                source: 'loomCrossFlowPopupCard',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: entryPointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2zUpm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irxfF.default), {
        itemId: "loom-ad-controls",
        ...(0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false) ? {
            placement: 'top-end'
        } // align the menu to be on top so it doesn't cover the spotlight
         : {},
        trigger: ({ triggerRef: triggerRef, ...props })=>customTrigger ? customTrigger({
                testId: 'loom-utils.loom-ad-control.custom-button',
                triggerRef: triggerRef,
                onClick: (e)=>{
                    fireTriggerClickAnalyticsEvent();
                    props.onClick?.(e);
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8b615b773eb5cff4$var$moreIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                onClick: (e_0)=>{
                    fireTriggerClickAnalyticsEvent();
                    props.onClick?.(e_0);
                },
                appearance: "subtle",
                spacing: spacing,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                label: "LoomAdControl",
                testId: "loom-utils.loom-ad-control.button"
            })),
        ...(0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false) ? {
            strategy: 'absolute'
        } : {}
    }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ylo6.default), {
            ...props_0,
            flagProps: {
                title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagTitle),
                description: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagDescription)
            },
            onClick: onDismiss
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEz36.default), {
            ...props_0,
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'toggleLoomAdControlReasonsModal',
                        source: 'loomAdControlDropdown',
                        attributes: {
                            adType: 'crossFlow',
                            entrypoint: entryPointId
                        }
                    }
                }).fire();
            },
            modalProps: {
                title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8b615b773eb5cff4$var$LoomAdControlReasonModalBody, {
                    entryPointId: entryPointId
                })
            }
        }))));
};
function $8b615b773eb5cff4$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "bold",
        color: "color.text"
    }, chunks);
}
module.exports["LoomAdControl"] = $8b615b773eb5cff4$export$5922fd76035890d5;

});

parcelRegister("irxfF", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $52EPl = parcelRequire("52EPl");

var $ahaN7 = parcelRequire("ahaN7");


var $dh538 = parcelRequire("dh538");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");

const $bdcc218e6a1dcb18$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $bdcc218e6a1dcb18$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $fRta5.AD_CONTROL_DROP_DOWN_MENU_OPENED) : (0, $fRta5.AD_CONTROL_DROP_DOWN_MENU_CLOSED), createInteractedUIEvent($bdcc218e6a1dcb18$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-growth-trai'),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
var $bdcc218e6a1dcb18$export$2e2bcd8739ae039 = $bdcc218e6a1dcb18$var$AdControlDropdownMenu;
module.exports["default"] = $bdcc218e6a1dcb18$export$2e2bcd8739ae039;

});

parcelRegister("fRta5", function(module, exports) {
// ACT Event types
// AdControlDropdownMenu
const $6a9218f106f63d94$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $6a9218f106f63d94$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $6a9218f106f63d94$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $6a9218f106f63d94$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $6a9218f106f63d94$export$6d3088110036f124 = 'DISMISS_FAILED';
const $6a9218f106f63d94$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $6a9218f106f63d94$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $6a9218f106f63d94$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $6a9218f106f63d94$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';
module.exports["AD_CONTROL_DROP_DOWN_MENU_OPENED"] = $6a9218f106f63d94$export$17ff257e1f6e39f5;
module.exports["AD_CONTROL_DROP_DOWN_MENU_CLOSED"] = $6a9218f106f63d94$export$7fc09cf740f33ed4;
module.exports["DISMISS_STARTED"] = $6a9218f106f63d94$export$e33200507ac1d20a;
module.exports["DISMISS_SUCCEEDED"] = $6a9218f106f63d94$export$103f41d1f3bf374e;
module.exports["DISMISS_FAILED"] = $6a9218f106f63d94$export$6d3088110036f124;
module.exports["REASONS_BUTTON_CLICKED"] = $6a9218f106f63d94$export$5595c6967e83d351;
module.exports["REASONS_MODAL_SHOWN"] = $6a9218f106f63d94$export$ff50ad60f08a4bc0;
module.exports["REASONS_MODAL_DISMISSED"] = $6a9218f106f63d94$export$6bd2d8eacca15ce1;
module.exports["FLAG_DISMISSED"] = $6a9218f106f63d94$export$5c5fc6956b7600ea;

});

parcelRegister("kSW34", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e3ec5bbd654613$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");

function $07e3ec5bbd654613$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $7TH2w.SCREEN_EVENT_TYPE),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});

parcelRegister("h9hzU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fRta5 = parcelRequire("fRta5");


var $9c9yH = parcelRequire("9c9yH");


var $8L1Fu = parcelRequire("8L1Fu");

function $80d3df06c6f273d3$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $8L1Fu.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $fRta5.FLAG_DISMISSED:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((itemId)=>{
        return new (0, $9c9yH.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}
module.exports["useAdControlProvider"] = $80d3df06c6f273d3$export$450072b04d50916;

});

parcelRegister("9c9yH", function(module, exports) {
class $99f724af69d7c626$export$2e2bcd8739ae039 {
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
}
module.exports["default"] = $99f724af69d7c626$export$2e2bcd8739ae039;

});

parcelRegister("8L1Fu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $35IL4 = parcelRequire("35IL4");

function $d1d018053c996795$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $35IL4.AdControlContext));
}
module.exports["useAdControlContext"] = $d1d018053c996795$export$4e82dc865a56141b;

});

parcelRegister("35IL4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1dZ5H = parcelRequire("1dZ5H");

const $8a2d05ab8b5622c4$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    state: {
        ...(0, $1dZ5H.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});
module.exports["AdControlContext"] = $8a2d05ab8b5622c4$export$554b2f9bd0a293df;

});

parcelRegister("1dZ5H", function(module, exports) {
const $abc4c02fc3dda9d3$export$22776e7a42f7089d = {
    flags: new Map()
};
const $abc4c02fc3dda9d3$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};
module.exports["initialAdControlProviderState"] = $abc4c02fc3dda9d3$export$22776e7a42f7089d;
module.exports["adControlProviderReducer"] = $abc4c02fc3dda9d3$export$5f3557676ca801eb;

});

parcelRegister("2zUpm", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $35IL4 = parcelRequire("35IL4");


var $1dZ5H = parcelRequire("1dZ5H");


var $kL1O8 = parcelRequire("kL1O8");


var $85Wse = parcelRequire("85Wse");


var $jC7C7 = parcelRequire("jC7C7");

const $f0fb9a90e64cd61d$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useReducer((0, $1dZ5H.adControlProviderReducer), (0, $1dZ5H.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: '',
        hasCloseButton: true
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kL1O8.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $35IL4.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $jC7C7.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $85Wse.default), {})
            ]
        })
    });
};
var $f0fb9a90e64cd61d$export$2e2bcd8739ae039 = $f0fb9a90e64cd61d$var$AdControlProvider;
module.exports["default"] = $f0fb9a90e64cd61d$export$2e2bcd8739ae039;

});

parcelRegister("kL1O8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $dqUnB = parcelRequire("dqUnB");


var $i9bNu = parcelRequire("i9bNu");

const $b308713f20b40665$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $i9bNu.default),
        loaderFn: (0, $dqUnB.fetchMessagesForLocale),
        children: children
    });
};
var $b308713f20b40665$export$2e2bcd8739ae039 = $b308713f20b40665$var$ActIntlProvider;
module.exports["default"] = $b308713f20b40665$export$2e2bcd8739ae039;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $49YLc = parcelRequire("49YLc");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (0, $49YLc.functionWithFG)('navx-4615-fix-async-intl-for-gsn', $e1a1ee666860bb23$var$useMessagesNEW, $e1a1ee666860bb23$var$useMessagesOLD);
function $e1a1ee666860bb23$var$useMessagesNEW(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.NEW_DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}
function $e1a1ee666860bb23$var$useMessagesOLD(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("49YLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $1I43V = parcelRequire("1I43V");

const $45703bb7386f8863$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $1I43V.functionWithCondition)(()=>(0, $dh538.fg)(featureFlagName), functionTrue, functionFalse);
module.exports["functionWithFG"] = $45703bb7386f8863$export$53903226fff06fbb;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
const $b9a0da62d538b640$export$c568080b217d81ad = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;
module.exports["NEW_DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$c568080b217d81ad;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) {
        const defaultState = (0, $dh538.fg)('navx-4615-fix-async-intl-for-gsn') ? (0, $hxPth.NEW_DEFAULT_LOCALE_STATE) : (0, $hxPth.DEFAULT_LOCALE_STATE);
        return (0, $aXWIB.createIntl)(defaultState, $1961b540cbe6be26$var$cache);
    }
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("dqUnB", function(module, exports) {

var $k1MFX = parcelRequire("k1MFX");


var $i9bNu = parcelRequire("i9bNu");

const $06c066c00d1ae0fc$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $06c066c00d1ae0fc$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($06c066c00d1ae0fc$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $k1MFX.locales)) {
            const messages = await (0, $k1MFX.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $k1MFX.locales)) {
            const messages = await (0, $k1MFX.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $i9bNu.default;
};
module.exports["fetchMessagesForLocale"] = $06c066c00d1ae0fc$export$2b153a2030b0feb2;

});

parcelRegister("k1MFX", function(module, exports) {


























const $21a44ec23de25ffe$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("4eMQd")),
    da: ()=>(parcelRequire("6xcXa")),
    de: ()=>(parcelRequire("ge2eI")),
    en_GB: ()=>(parcelRequire("kFjnq")),
    en_ZZ: ()=>(parcelRequire("bxcHY")),
    en: ()=>Promise.resolve((parcelRequire("i9bNu"))),
    es: ()=>(parcelRequire("lRPwm")),
    fi: ()=>(parcelRequire("ebB32")),
    fr: ()=>(parcelRequire("5uZHO")),
    hu: ()=>(parcelRequire("1JxHc")),
    it: ()=>(parcelRequire("7IBBJ")),
    ja: ()=>(parcelRequire("jrej6")),
    ko: ()=>(parcelRequire("1JX7s")),
    nb: ()=>(parcelRequire("jMOHK")),
    nl: ()=>(parcelRequire("9nNiG")),
    pl: ()=>(parcelRequire("5BSNH")),
    pt_BR: ()=>(parcelRequire("jm3ex")),
    ru: ()=>(parcelRequire("eZ80I")),
    sv: ()=>(parcelRequire("3ZEFq")),
    th: ()=>(parcelRequire("kEPri")),
    tr: ()=>(parcelRequire("h4TBY")),
    uk: ()=>(parcelRequire("9eHWu")),
    vi: ()=>(parcelRequire("a2Nsn")),
    zh_TW: ()=>(parcelRequire("9Ihm1")),
    zh: ()=>(parcelRequire("S8Ege"))
};
module.exports["locales"] = $21a44ec23de25ffe$export$df1c34db1371eeed;

});

parcelRegister("i9bNu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3654660649c0d4bb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fRUtn = parcelRequire("fRUtn");

var $3654660649c0d4bb$export$2e2bcd8739ae039 = (0, $fRUtn.default);

});

parcelRegister("fRUtn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a08ce06ba468bdfe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a08ce06ba468bdfe$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});

parcelRegister("4eMQd", function(module, exports) {

let $315e5b0eff786d5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $315e5b0eff786d5a$var$load("3FT39").then(()=>parcelRequire('4Yleb'));

});

parcelRegister("6xcXa", function(module, exports) {

let $4c1fdf6b12b37a17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c1fdf6b12b37a17$var$load("7QoTg").then(()=>parcelRequire('jDakE'));

});

parcelRegister("ge2eI", function(module, exports) {

let $bcffb037722ea990$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcffb037722ea990$var$load("d1Lrf").then(()=>parcelRequire('6RK0u'));

});

parcelRegister("kFjnq", function(module, exports) {

let $f0b6aacbdb40b5ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0b6aacbdb40b5ad$var$load("kM5GB").then(()=>parcelRequire('kzcZp'));

});

parcelRegister("bxcHY", function(module, exports) {

let $865ca262a9055aad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $865ca262a9055aad$var$load("5506N").then(()=>parcelRequire('33OOq'));

});

parcelRegister("lRPwm", function(module, exports) {

let $feb683360f3c545f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $feb683360f3c545f$var$load("7ioy0").then(()=>parcelRequire('gMkb6'));

});

parcelRegister("ebB32", function(module, exports) {

let $a53ed4b86a0b887f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a53ed4b86a0b887f$var$load("kZ6zs").then(()=>parcelRequire('1OjJD'));

});

parcelRegister("5uZHO", function(module, exports) {

let $400f9e8fda48b9de$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $400f9e8fda48b9de$var$load("phbpE").then(()=>parcelRequire('jvMdy'));

});

parcelRegister("1JxHc", function(module, exports) {

let $143421b071e9854c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $143421b071e9854c$var$load("6pKhl").then(()=>parcelRequire('gVnbl'));

});

parcelRegister("7IBBJ", function(module, exports) {

let $59e9d08f20e946d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $59e9d08f20e946d5$var$load("hzLOt").then(()=>parcelRequire('d0lkZ'));

});

parcelRegister("jrej6", function(module, exports) {

let $e26ba30433a0b5bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e26ba30433a0b5bf$var$load("1M8mW").then(()=>parcelRequire('4TGbq'));

});

parcelRegister("1JX7s", function(module, exports) {

let $1447da49ec6cfdc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1447da49ec6cfdc7$var$load("eHQAY").then(()=>parcelRequire('hGfMv'));

});

parcelRegister("jMOHK", function(module, exports) {

let $e679d4de95e3657e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e679d4de95e3657e$var$load("8exPB").then(()=>parcelRequire('aYgYT'));

});

parcelRegister("9nNiG", function(module, exports) {

let $6d4c8109597ab866$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d4c8109597ab866$var$load("knfAP").then(()=>parcelRequire('2GadI'));

});

parcelRegister("5BSNH", function(module, exports) {

let $415aeabc10236ce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $415aeabc10236ce4$var$load("ljRXP").then(()=>parcelRequire('eoRvM'));

});

parcelRegister("jm3ex", function(module, exports) {

let $e172947b685f7336$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e172947b685f7336$var$load("bEb8c").then(()=>parcelRequire('5mSqI'));

});

parcelRegister("eZ80I", function(module, exports) {

let $ae8cf9e6f09d976b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae8cf9e6f09d976b$var$load("c7JYF").then(()=>parcelRequire('5zX31'));

});

parcelRegister("3ZEFq", function(module, exports) {

let $2e869d3f88a75530$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2e869d3f88a75530$var$load("ari8V").then(()=>parcelRequire('j4Pzu'));

});

parcelRegister("kEPri", function(module, exports) {

let $f09f71dda87efcbd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f09f71dda87efcbd$var$load("kfrHX").then(()=>parcelRequire('bdGVV'));

});

parcelRegister("h4TBY", function(module, exports) {

let $c6edf2b09dd62781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c6edf2b09dd62781$var$load("aWToy").then(()=>parcelRequire('bg9up'));

});

parcelRegister("9eHWu", function(module, exports) {

let $6b9781e1cddd22ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b9781e1cddd22ce$var$load("4ns5x").then(()=>parcelRequire('jG5jM'));

});

parcelRegister("a2Nsn", function(module, exports) {

let $7500745ca11310a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7500745ca11310a3$var$load("7bfAn").then(()=>parcelRequire('jgloM'));

});

parcelRegister("9Ihm1", function(module, exports) {

let $7125af4652facd67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7125af4652facd67$var$load("gftgT").then(()=>parcelRequire('i0bIF'));

});

parcelRegister("S8Ege", function(module, exports) {

let $0a2bc0a564e10417$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0a2bc0a564e10417$var$load("6YVlG").then(()=>parcelRequire('4a8Ly'));

});

parcelRegister("85Wse", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $aD1SW = parcelRequire("aD1SW");

var $6uGcC = parcelRequire("6uGcC");


var $imt6g = parcelRequire("imt6g");


var $gdv5Z = parcelRequire("gdv5Z");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");


var $2bASh = parcelRequire("2bASh");

const $0f8daac9763b8054$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $0f8daac9763b8054$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $0f8daac9763b8054$var$DismissalFlagGroup = ()=>{
    (0, $2bASh.overridePortalIndex)($0f8daac9763b8054$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $fRta5.FLAG_DISMISSED), createInteractedUIEvent($0f8daac9763b8054$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                id: $0f8daac9763b8054$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                        label: "Success",
                        spacing: "spacious",
                        color: "var(--ds-icon-success, #6A9A23)"
                    }),
                    title: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $7R3FL.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $7R3FL.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
var $0f8daac9763b8054$export$2e2bcd8739ae039 = $0f8daac9763b8054$var$DismissalFlagGroup;
module.exports["default"] = $0f8daac9763b8054$export$2e2bcd8739ae039;

});

parcelRegister("7R3FL", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c156cf06b085a120$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    notInterested: {
        id: "act.action.notInterested.button.text",
        defaultMessage: "Not interested"
    },
    notInterestedFlag: {
        id: "act.action.notInterestedFlag.flag.text",
        defaultMessage: "Got it, thanks for letting us know"
    },
    showReasons: {
        id: "act.action.showReasons.common.text",
        defaultMessage: "Why am I seeing this?"
    },
    dismissalMessage: {
        id: "act.action.dismissalMessage.common.text",
        defaultMessage: "You won\u2019t see this here as often."
    },
    reasonsModalOkButton: {
        id: "act.action.reasonsModalOkButton.common.text",
        defaultMessage: "OK"
    }
});
module.exports["messages"] = $c156cf06b085a120$export$defe85febe8b728c;

});

parcelRegister("2bASh", function(module, exports) {
const $5cf66c7a3cd119b9$export$335243096683aa37 = 900;
function $5cf66c7a3cd119b9$export$61df98316049b30(elementId, index = $5cf66c7a3cd119b9$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $5cf66c7a3cd119b9$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $5cf66c7a3cd119b9$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $5cf66c7a3cd119b9$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$5cf66c7a3cd119b9$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}
module.exports["DEFAULT_PORTAL_OVERRIDE_INDEX"] = $5cf66c7a3cd119b9$export$335243096683aa37;
module.exports["overridePortalIndex"] = $5cf66c7a3cd119b9$export$61df98316049b30;

});

parcelRegister("jC7C7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");


var $2bASh = parcelRequire("2bASh");

const $139ac0b427a5c906$var$adControlScreenName = 'adControlsReasonsModal';
const $139ac0b427a5c906$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $139ac0b427a5c906$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $2bASh.DEFAULT_PORTAL_OVERRIDE_INDEX), hasCloseButton: hasCloseButton = true, ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $h9hzU.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $kSW34.default)();
    const isMounted = (0, $42omo.useRef)(false);
    const eventDispatcherRef = (0, $42omo.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $42omo.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $fRta5.REASONS_MODAL_SHOWN), createScreenUIEvent($139ac0b427a5c906$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $fRta5.REASONS_MODAL_DISMISSED), createScreenUIEvent($139ac0b427a5c906$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $2bASh.overridePortalIndex)($139ac0b427a5c906$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                id: $139ac0b427a5c906$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        hasCloseButton: hasCloseButton,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $7R3FL.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $7R3FL.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $139ac0b427a5c906$export$2e2bcd8739ae039 = $139ac0b427a5c906$var$ReasonsModal;
module.exports["default"] = $139ac0b427a5c906$export$2e2bcd8739ae039;

});

parcelRegister("3ylo6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dAYOx = parcelRequire("dAYOx");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");

const $08a2895c8eb1cea2$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $08a2895c8eb1cea2$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $fRta5.DISMISS_STARTED), createInteractedUIEvent($08a2895c8eb1cea2$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $fRta5.DISMISS_SUCCEEDED));
        } catch (e) {
            eventDispatcher.dispatchError((0, $fRta5.DISMISS_FAILED), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $7R3FL.messages).notInterested
        })
    });
};
var $08a2895c8eb1cea2$export$2e2bcd8739ae039 = $08a2895c8eb1cea2$var$DismissalButton;
module.exports["default"] = $08a2895c8eb1cea2$export$2e2bcd8739ae039;

});

parcelRegister("hEz36", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dAYOx = parcelRequire("dAYOx");


var $fRta5 = parcelRequire("fRta5");


var $kSW34 = parcelRequire("kSW34");


var $h9hzU = parcelRequire("h9hzU");


var $7R3FL = parcelRequire("7R3FL");

const $3b87ab993ce1d1b1$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $3b87ab993ce1d1b1$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $h9hzU.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $kSW34.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $fRta5.REASONS_BUTTON_CLICKED), createInteractedUIEvent($3b87ab993ce1d1b1$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $7R3FL.messages).showReasons
        })
    });
};
var $3b87ab993ce1d1b1$export$2e2bcd8739ae039 = $3b87ab993ce1d1b1$var$ReasonsButton;
module.exports["default"] = $3b87ab993ce1d1b1$export$2e2bcd8739ae039;

});

parcelRegister("5i3ci", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1lhEF = parcelRequire("1lhEF");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $9wGTI = parcelRequire("9wGTI");


var $aFmsO = parcelRequire("aFmsO");

const $9fbe62170cacfcf3$export$d6e697640576fe29 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, entryPointId: entryPointId, isCircle: isCircle } = t0;
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    if ((0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children));
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    const t1 = isCircle ? 24 : 3;
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
            radius: t1,
            testId: "loom-cross-sell-discoverability-pulse"
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, entryPointId: entryPointId, isCircle: isCircle })=>{
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    // Feature-gated migration from @atlaskit/onboarding to @atlaskit/spotlight
    if ((0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
        radius: isCircle ? 24 : 3,
        testId: "loom-cross-sell-discoverability-pulse"
    }, children);
};
module.exports["DiscoverabilityPulse"] = $9fbe62170cacfcf3$export$d6e697640576fe29;

});

parcelRegister("aFmsO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXjWU = parcelRequire("aXjWU");


var $gd8AW = parcelRequire("gd8AW");

const $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS = [
    'cc-loom-x-sell-discoverability-pulse-1',
    'cc-loom-x-sell-discoverability-pulse-2',
    'cc-loom-x-sell-discoverability-pulse-3',
    'cc-loom-x-sell-discoverability-pulse-4',
    'cc-loom-x-sell-discoverability-pulse-5'
];
const $9c43e73b872d5b9c$var$TIMEOUT_MS = 300;
const $9c43e73b872d5b9c$var$LAST_PULSE_INDEX = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS.length - 1;
const $9c43e73b872d5b9c$var$requestNextPulse = (nextIndex, pulseHooks, hasRequestedRef, lastRequestedRef)=>{
    if (nextIndex < pulseHooks.length && !hasRequestedRef.current.has(nextIndex)) {
        hasRequestedRef.current.add(nextIndex);
        lastRequestedRef.current = {
            index: nextIndex,
            timestamp: Date.now()
        };
        pulseHooks[nextIndex].requestMessageStart();
    }
};
const $9c43e73b872d5b9c$export$2002ab0670152c89 = (0, $3u0dr.isReactCompilerActiveV2)() ? (entryPointId)=>{
    const $ = (0, $frIzR.c)(74);
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t0;
    if ($[0] !== isPulseActive) {
        t0 = isPulseActive && (0, $gd8AW.havePulsesEnded)();
        $[0] = isPulseActive;
        $[1] = t0;
    } else t0 = $[1];
    const skipRefreshPulseStatus = t0;
    const pulse1 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    let t1;
    if ($[2] !== pulse1 || $[3] !== pulse2 || $[4] !== pulse3 || $[5] !== pulse4 || $[6] !== pulse5) {
        t1 = [
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ];
        $[2] = pulse1;
        $[3] = pulse2;
        $[4] = pulse3;
        $[5] = pulse4;
        $[6] = pulse5;
        $[7] = t1;
    } else t1 = $[7];
    const pulseHooks = t1;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[8] = t2;
    } else t2 = $[8];
    const hasRequestedRef = (0, $42omo.useRef)(t2);
    const lastRequestedRef = (0, $42omo.useRef)(null);
    const lastStartedIndexRef = (0, $42omo.useRef)(null);
    const [timeoutTrigger, setTimeoutTrigger] = (0, $42omo.useState)(0);
    let t3;
    if ($[9] !== pulseHooks || $[10] !== skipRefreshPulseStatus) {
        t3 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i = 0; i < pulseHooks.length; i++){
                const pulseHook = pulseHooks[i];
                if (pulseHook.hasMessageStarted) {
                    lastRequestedRef.current = null;
                    lastStartedIndexRef.current = i;
                    break;
                }
                if (!hasRequestedRef.current.has(i)) {
                    hasRequestedRef.current.add(i);
                    lastRequestedRef.current = {
                        index: i,
                        timestamp: Date.now()
                    };
                    pulseHook.requestMessageStart();
                    break;
                }
            }
        };
        $[9] = pulseHooks;
        $[10] = skipRefreshPulseStatus;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== pulse1.handleClickTracking || $[13] !== pulse1.hasMessageStarted || $[14] !== pulse1.requestMessageStart || $[15] !== pulse2.handleClickTracking || $[16] !== pulse2.hasMessageStarted || $[17] !== pulse2.requestMessageStart || $[18] !== pulse3.handleClickTracking || $[19] !== pulse3.hasMessageStarted || $[20] !== pulse3.requestMessageStart || $[21] !== pulse4.handleClickTracking || $[22] !== pulse4.hasMessageStarted || $[23] !== pulse4.requestMessageStart || $[24] !== pulse5.handleClickTracking || $[25] !== pulse5.hasMessageStarted || $[26] !== pulse5.requestMessageStart || $[27] !== pulseHooks || $[28] !== skipRefreshPulseStatus) {
        t4 = [
            skipRefreshPulseStatus,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted,
            pulse1.requestMessageStart,
            pulse2.requestMessageStart,
            pulse3.requestMessageStart,
            pulse4.requestMessageStart,
            pulse5.requestMessageStart,
            pulse1.handleClickTracking,
            pulse2.handleClickTracking,
            pulse3.handleClickTracking,
            pulse4.handleClickTracking,
            pulse5.handleClickTracking
        ];
        $[12] = pulse1.handleClickTracking;
        $[13] = pulse1.hasMessageStarted;
        $[14] = pulse1.requestMessageStart;
        $[15] = pulse2.handleClickTracking;
        $[16] = pulse2.hasMessageStarted;
        $[17] = pulse2.requestMessageStart;
        $[18] = pulse3.handleClickTracking;
        $[19] = pulse3.hasMessageStarted;
        $[20] = pulse3.requestMessageStart;
        $[21] = pulse4.handleClickTracking;
        $[22] = pulse4.hasMessageStarted;
        $[23] = pulse4.requestMessageStart;
        $[24] = pulse5.handleClickTracking;
        $[25] = pulse5.hasMessageStarted;
        $[26] = pulse5.requestMessageStart;
        $[27] = pulseHooks;
        $[28] = skipRefreshPulseStatus;
        $[29] = t4;
    } else t4 = $[29];
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[30] !== isPulseActive || $[31] !== pulseHooks || $[32] !== skipRefreshPulseStatus) {
        t5 = ()=>{
            if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
            const { index: index, timestamp: timestamp } = lastRequestedRef.current;
            const pulseHook_0 = pulseHooks[index];
            if (pulseHook_0.hasMessageStarted) {
                lastRequestedRef.current = null;
                return;
            }
            const elapsed = Date.now() - timestamp;
            if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
                lastRequestedRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            } else {
                const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
                const timeoutId = setTimeout(()=>{
                    setTimeoutTrigger($9c43e73b872d5b9c$var$_temp);
                }, remainingTime);
                return ()=>clearTimeout(timeoutId);
            }
        };
        $[30] = isPulseActive;
        $[31] = pulseHooks;
        $[32] = skipRefreshPulseStatus;
        $[33] = t5;
    } else t5 = $[33];
    let t6;
    if ($[34] !== isPulseActive || $[35] !== pulse1.hasMessageStarted || $[36] !== pulse2.hasMessageStarted || $[37] !== pulse3.hasMessageStarted || $[38] !== pulse4.hasMessageStarted || $[39] !== pulse5.hasMessageStarted || $[40] !== pulseHooks || $[41] !== skipRefreshPulseStatus || $[42] !== timeoutTrigger) {
        t6 = [
            skipRefreshPulseStatus,
            isPulseActive,
            timeoutTrigger,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[34] = isPulseActive;
        $[35] = pulse1.hasMessageStarted;
        $[36] = pulse2.hasMessageStarted;
        $[37] = pulse3.hasMessageStarted;
        $[38] = pulse4.hasMessageStarted;
        $[39] = pulse5.hasMessageStarted;
        $[40] = pulseHooks;
        $[41] = skipRefreshPulseStatus;
        $[42] = timeoutTrigger;
        $[43] = t6;
    } else t6 = $[43];
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[44] !== entryPointId || $[45] !== pulseHooks || $[46] !== skipRefreshPulseStatus || $[47] !== startPulse) {
        t7 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
                const pulseHook_1 = pulseHooks[i_0];
                const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
                if (pulseHook_1.hasMessageStarted) {
                    lastStartedIndexRef.current = i_0;
                    startPulse(entryPointId, messageId, {
                        onDismiss: ()=>pulseHook_1.dismissMessage(),
                        onClick: ()=>pulseHook_1.handleClickTracking?.()
                    });
                    if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) (0, $gd8AW.endPulses)();
                    break;
                }
            }
        };
        $[44] = entryPointId;
        $[45] = pulseHooks;
        $[46] = skipRefreshPulseStatus;
        $[47] = startPulse;
        $[48] = t7;
    } else t7 = $[48];
    let t8;
    if ($[49] !== entryPointId || $[50] !== pulse1.hasMessageStarted || $[51] !== pulse2.hasMessageStarted || $[52] !== pulse3.hasMessageStarted || $[53] !== pulse4.hasMessageStarted || $[54] !== pulse5.hasMessageStarted || $[55] !== pulseHooks || $[56] !== skipRefreshPulseStatus || $[57] !== startPulse) {
        t8 = [
            skipRefreshPulseStatus,
            entryPointId,
            startPulse,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[49] = entryPointId;
        $[50] = pulse1.hasMessageStarted;
        $[51] = pulse2.hasMessageStarted;
        $[52] = pulse3.hasMessageStarted;
        $[53] = pulse4.hasMessageStarted;
        $[54] = pulse5.hasMessageStarted;
        $[55] = pulseHooks;
        $[56] = skipRefreshPulseStatus;
        $[57] = startPulse;
        $[58] = t8;
    } else t8 = $[58];
    (0, $42omo.useEffect)(t7, t8);
    let t9;
    if ($[59] !== isPulseActive || $[60] !== pulseHooks || $[61] !== skipRefreshPulseStatus) {
        t9 = ()=>{
            if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
            const startedIndex = lastStartedIndexRef.current;
            const startedPulseHook = pulseHooks[startedIndex];
            if (!startedPulseHook.hasMessageStarted) {
                hasRequestedRef.current.delete(startedIndex);
                lastStartedIndexRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            }
        };
        $[59] = isPulseActive;
        $[60] = pulseHooks;
        $[61] = skipRefreshPulseStatus;
        $[62] = t9;
    } else t9 = $[62];
    let t10;
    if ($[63] !== isPulseActive || $[64] !== pulse1.hasMessageStarted || $[65] !== pulse2.hasMessageStarted || $[66] !== pulse3.hasMessageStarted || $[67] !== pulse4.hasMessageStarted || $[68] !== pulse5.hasMessageStarted || $[69] !== pulseHooks || $[70] !== skipRefreshPulseStatus) {
        t10 = [
            skipRefreshPulseStatus,
            isPulseActive,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[63] = isPulseActive;
        $[64] = pulse1.hasMessageStarted;
        $[65] = pulse2.hasMessageStarted;
        $[66] = pulse3.hasMessageStarted;
        $[67] = pulse4.hasMessageStarted;
        $[68] = pulse5.hasMessageStarted;
        $[69] = pulseHooks;
        $[70] = skipRefreshPulseStatus;
        $[71] = t10;
    } else t10 = $[71];
    (0, $42omo.useEffect)(t9, t10);
    let t11;
    if ($[72] !== isPulseActive) {
        t11 = {
            isPulseActive: isPulseActive
        };
        $[72] = isPulseActive;
        $[73] = t11;
    } else t11 = $[73];
    return t11;
} : (entryPointId)=>{
    // All hooks must be called unconditionally (Rules of Hooks)
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const skipRefreshPulseStatus = isPulseActive && (0, $gd8AW.havePulsesEnded)();
    // Call hooks at the top level for all message IDs
    const pulse1 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $aXjWU.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    const pulseHooks = (0, $42omo.useMemo)(()=>[
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ], [
        pulse1,
        pulse2,
        pulse3,
        pulse4,
        pulse5
    ]);
    // Track which messages we've requested to avoid duplicate requests
    const hasRequestedRef = (0, $42omo.useRef)(new Set());
    // Track the last requested message index and when it was requested (for timeout)
    const lastRequestedRef = (0, $42omo.useRef)(null);
    // Track which message index was last started (to detect dismissal)
    const lastStartedIndexRef = (0, $42omo.useRef)(null);
    // State trigger to force re-evaluation when timeout expires
    const [timeoutTrigger, setTimeoutTrigger] = (0, $42omo.useState)(0);
    // Request messages sequentially - only request the next one if previous ones haven't started
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Find the first message that hasn't started and request it
        // If a previous message has started, we stop (handled by the other effect)
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            // If this message has started, we're done - don't request any more
            if (pulseHook.hasMessageStarted) {
                // Clear the timeout tracking since we found an active message
                lastRequestedRef.current = null;
                // Track which message is started (will be set by the activation effect, but set here too for consistency)
                lastStartedIndexRef.current = i;
                break;
            }
            // If we haven't requested this one yet, request it and stop
            // The effect will re-run when hasMessageStarted changes, allowing us to move to the next one
            if (!hasRequestedRef.current.has(i)) {
                hasRequestedRef.current.add(i);
                lastRequestedRef.current = {
                    index: i,
                    timestamp: Date.now()
                };
                pulseHook.requestMessageStart();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted,
        pulse1.requestMessageStart,
        pulse2.requestMessageStart,
        pulse3.requestMessageStart,
        pulse4.requestMessageStart,
        pulse5.requestMessageStart,
        pulse1.handleClickTracking,
        pulse2.handleClickTracking,
        pulse3.handleClickTracking,
        pulse4.handleClickTracking,
        pulse5.handleClickTracking
    ]);
    // Timeout handler: if a requested message hasn't started after a delay, try the next one
    // Note: If a message was already dismissed, Post Office filters it before page load
    // so we only need time for the initial load and state updates (~200-300ms)
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
        const { index: index, timestamp: timestamp } = lastRequestedRef.current;
        const pulseHook_0 = pulseHooks[index];
        // If the message has started, clear the timeout tracking
        if (pulseHook_0.hasMessageStarted) {
            lastRequestedRef.current = null;
            return;
        }
        // If enough time has passed and the message still hasn't started, move to the next one
        const elapsed = Date.now() - timestamp;
        if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
            // Clear the current request tracking
            lastRequestedRef.current = null;
            // Try the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        } else {
            // Set a timeout to trigger re-evaluation when the timeout period elapses
            const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
            const timeoutId = setTimeout(()=>{
                setTimeoutTrigger((prev)=>prev + 1);
            }, remainingTime);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        timeoutTrigger,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Reactively respond when a message starts - activate the pulse
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Check each pulse in sequence - activate the first one that has started
        for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
            const pulseHook_1 = pulseHooks[i_0];
            const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
            if (pulseHook_1.hasMessageStarted) {
                lastStartedIndexRef.current = i_0;
                startPulse(entryPointId, messageId, {
                    onDismiss: ()=>pulseHook_1.dismissMessage(),
                    onClick: ()=>pulseHook_1.handleClickTracking?.()
                });
                // If this is the last pulse, mark pulses as ended
                if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) /**
           * Mark the EP message as "complete" and disable Loom discoverability in localStorage
           * immediately after showing the final pulse. Otherwise, if a user ignores the entrypoints
           * entirely and never clicks on one while it's pulsing, they'll:
           *
           * - Remain in the TAP audience forever
           * - Continue to check the EP messages every time an entrypoint renders
           *
           * This will technically unlock EP to show other messages, but the pulse is subtle enough that
           * this shouldn't result in poor UX
           */ (0, $gd8AW.endPulses)();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        entryPointId,
        startPulse,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Handle message dismissal: if a started message becomes not started, request the next one
    (0, $42omo.useEffect)(()=>{
        if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
        const startedIndex = lastStartedIndexRef.current;
        const startedPulseHook = pulseHooks[startedIndex];
        // If the message that was started is no longer started, it was dismissed
        if (!startedPulseHook.hasMessageStarted) {
            // Clear the tracking for this message so we can move forward
            hasRequestedRef.current.delete(startedIndex);
            lastStartedIndexRef.current = null;
            // Request the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    return {
        isPulseActive: isPulseActive
    };
};
function $9c43e73b872d5b9c$var$_temp(prev) {
    return prev + 1;
}
module.exports["useDiscoverabilityPulse"] = $9c43e73b872d5b9c$export$2002ab0670152c89;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $42omo.useState)($6d6c82fa2f331bd2$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    const enableEpExternalMessageCleanup = (0, $dh538.fg)('post-office_enable-ep-external-message-cleanup');
    const { activeTriggerState: { activeTriggerId: activeTriggerId } } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    const hasMessageAlreadyStarted = enableEpExternalMessageCleanup && activeTriggerId?.endsWith('-started');
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        if (hasMessageAlreadyStarted) return;
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger,
        hasMessageAlreadyStarted
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("Yuf8j", function(module, exports) {
/**
 * Duplicates a MAUI app by calling the Remix duplicate API endpoint.
 *
 * @param appId - The ID of the MAUI app to duplicate
 * @param containerContentId - The Confluence page ID that will contain the duplicated app
 * @param cloudId - Optional cloud ID used to construct the container ARI
 * @returns The ID of the newly duplicated app
 */ async function $6ffbee19a8d8957f$export$2cee355049cb72e4(appId, containerContentId, cloudId) {
    const containerAri = cloudId ? `ari:cloud:confluence:${cloudId}:page/${containerContentId}` : undefined;
    const response = await fetch(`/gateway/api/remix/api/v1/ui/${encodeURIComponent(appId)}/duplicate`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            containerAri: containerAri ?? containerContentId
        })
    });
    if (!response.ok) throw new Error("We couldn't duplicate this component. Please try again.");
    const data = await response.json();
    if (!data?.id) throw new Error("We couldn't duplicate this component. The server did not return a new component ID.");
    return {
        id: data.id
    };
}
module.exports["duplicateMauiApp"] = $6ffbee19a8d8957f$export$2cee355049cb72e4;

});

parcelRegister("cauOq", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $9JpPs = parcelRequire("9JpPs");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


const $5d7856924c94f859$var$EditorHelpCenterBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "hR0dw",
    name: "EditorHelpCenterBackground",
    loader: async ()=>(await (parcelRequire("gIPeG"))).EditorHelpCenter
});

const $5d7856924c94f859$var$EditorHelpCenterOnPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "V131B",
    name: "EditorHelpCenterOnPaint",
    loader: async ()=>(await (parcelRequire("gIPeG"))).EditorHelpCenter
});
const $5d7856924c94f859$export$8ffe1e824479312f = (0, $9JpPs.componentWithCondition)(()=>(0, $6mKj3.expValEquals)('platform_editor_help_center_background_load', 'variant', 'test'), $5d7856924c94f859$var$EditorHelpCenterBackground, $5d7856924c94f859$var$EditorHelpCenterOnPaint);
module.exports["EditorHelpCenter"] = $5d7856924c94f859$export$8ffe1e824479312f;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("gIPeG", function(module, exports) {

let $c2c87fc2ea7ede7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2c87fc2ea7ede7d$var$load("9anPW"),
    $c2c87fc2ea7ede7d$var$load("50ame"),
    $c2c87fc2ea7ede7d$var$load("2nk6f")
]).then(()=>parcelRequire('cix6s'));

});

parcelRegister("7WFax", function(module, exports) {
/* HelpWidget.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $ci7Ox = parcelRequire("ci7Ox");


var $3gadb = parcelRequire("3gadb");


var $6xdDU = parcelRequire("6xdDU");


var $6wrL8 = parcelRequire("6wrL8");


var $dcvq8 = parcelRequire("dcvq8");


var $lx6jn = parcelRequire("lx6jn");


var $8ViO5 = parcelRequire("8ViO5");

const $42fef2b06f093364$var$styles = {
    root: "_kqswstnw _94n51ejb _1ltvv47k _1pby1nn1"
};
const $42fef2b06f093364$var$i18n = (0, $aXWIB.defineMessages)({
    helpName: {
        id: "editor-help.help.name",
        defaultMessage: "Help"
    }
});
const $42fef2b06f093364$export$c7125cce544d6ba9 = /*#__PURE__*/ (0, $42omo.memo)(({ openHelpDialog: openHelpDialog, contentId: contentId, isNCSEditor: isNCSEditor, isTemplateEditor: isTemplateEditor, isCompanyHub: isCompanyHub, setIsOpen: setIsOpen, isOpen: isOpen })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [shouldShowDevTools, setShouldShowDevTools] = (0, $42omo.useState)(false);
    const [shouldShowGlobalFeedbackCollector, setShouldShowGlobalFeedbackCollector] = (0, $42omo.useState)(false);
    const triggerRef = (0, $42omo.useRef)(null);
    const handleButtonClick = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        setIsOpen?.(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "help-widget",
        className: (0, $gMc0m.default)([
            $42fef2b06f093364$var$styles.root
        ])
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8ViO5.HelpMenu), {
        openHelpDialog: openHelpDialog,
        contentId: contentId,
        isNCSEditor: isNCSEditor,
        isTemplateEditor: isTemplateEditor,
        isCompanyHub: isCompanyHub,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        setShouldShowDevTools: setShouldShowDevTools,
        setShouldShowGlobalFeedbackCollector: setShouldShowGlobalFeedbackCollector,
        triggerRef: triggerRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($42fef2b06f093364$var$i18n.helpName),
        position: "right",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        ref: triggerRef,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        shape: "circle",
        appearance: "subtle",
        label: formatMessage($42fef2b06f093364$var$i18n.helpName),
        testId: "help-menu-icon-button",
        onClick: handleButtonClick,
        isSelected: isOpen,
        "aria-expanded": isOpen,
        "aria-haspopup": "menu",
        color: "color.icon.subtlest"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, shouldShowDevTools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wrL8.LazyDevToolsDialog), {
        onClose: ()=>setShouldShowDevTools(false)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, shouldShowGlobalFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcvq8.LazyGlobalFeedbackCollector), {
        feedbackSource: (0, $lx6jn.FeedbackSource).EDITOR,
        onClose: ()=>setShouldShowGlobalFeedbackCollector(false),
        onCloseComplete: ()=>{},
        contentType: "page"
    })));
});
module.exports["HelpWidget"] = $42fef2b06f093364$export$c7125cce544d6ba9;

});

parcelRegister("6wrL8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c2828397bc04eb44$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ltMJ3",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("8GUrV"))).DevToolsDialog
});

const $c2828397bc04eb44$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "f62AJ",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("8GUrV"))).DevToolsDialog
});

const $c2828397bc04eb44$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xzcSO",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("ddmQY"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $c2828397bc04eb44$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $c2828397bc04eb44$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $c2828397bc04eb44$export$a08fb8aab8d5eb82;

});

parcelRegister("8GUrV", function(module, exports) {

let $653e08a7123e3a98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $653e08a7123e3a98$var$load("lkOIY"),
    $653e08a7123e3a98$var$load("6wr18"),
    $653e08a7123e3a98$var$load("gdPWB"),
    $653e08a7123e3a98$var$load("ffEVr"),
    $653e08a7123e3a98$var$load("kHOMt"),
    $653e08a7123e3a98$var$load("hhss7"),
    $653e08a7123e3a98$var$load("7EorR"),
    $653e08a7123e3a98$var$load("Wowvf"),
    $653e08a7123e3a98$var$load("5RR9C"),
    $653e08a7123e3a98$var$load("fYNhh")
]).then(()=>parcelRequire('bFmys'));

});

parcelRegister("ddmQY", function(module, exports) {

let $99ee3773125bddc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99ee3773125bddc9$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("dcvq8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $28c0ce898ab65517$export$7bd982897ab56fe5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1kdap",
    name: "GlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("h03Gt"))).GlobalFeedbackCollector
});

const $28c0ce898ab65517$export$76de8e4d628aac4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7vDuP",
    name: "LazyGlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("h03Gt"))).GlobalFeedbackCollector
});
module.exports["GlobalFeedbackCollector"] = $28c0ce898ab65517$export$7bd982897ab56fe5;
module.exports["LazyGlobalFeedbackCollector"] = $28c0ce898ab65517$export$76de8e4d628aac4a;

});

parcelRegister("h03Gt", function(module, exports) {

let $c6054b58d4c9db37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c6054b58d4c9db37$var$load("cyGuT"),
    $c6054b58d4c9db37$var$load("hhss7"),
    $c6054b58d4c9db37$var$load("dGk3x")
]).then(()=>parcelRequire('liJpy'));

});

parcelRegister("8ViO5", function(module, exports) {
/* HelpMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $8tdj3 = parcelRequire("8tdj3");


var $56M4r = parcelRequire("56M4r");

var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $bavCP = parcelRequire("bavCP");


var $4tOXV = parcelRequire("4tOXV");


var $bw3p5 = parcelRequire("bw3p5");


var $gHANe = parcelRequire("gHANe");


var $jmjWc = parcelRequire("jmjWc");


var $lREFo = parcelRequire("lREFo");


var $6mKj3 = parcelRequire("6mKj3");


var $79V5c = parcelRequire("79V5c");


var $gi8bo = parcelRequire("gi8bo");


var $ep7kE = parcelRequire("ep7kE");

const $9fef5514b8b73423$var$styles = {
    base: "_2rko12b0 _1rjc12x7 _1mouu2gc _195g1wug _bfhk1bhr _16qs130s _p12fnklw",
    shortcut: "_syaz1rpy"
};
const $9fef5514b8b73423$export$d3e032c62ea2d293 = ({ openHelpDialog: openHelpDialog, contentId: contentId, isNCSEditor: isNCSEditor, isTemplateEditor: isTemplateEditor, isCompanyHub: isCompanyHub, isOpen: isOpen, setIsOpen: setIsOpen, setShouldShowDevTools: setShouldShowDevTools, setShouldShowGlobalFeedbackCollector: setShouldShowGlobalFeedbackCollector, triggerRef: triggerRef })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const blueprintType = (0, $lREFo.useBlueprintType)(contentId, isTemplateEditor);
    const handleCloseHelpMenu = (0, $42omo.useCallback)(()=>{
        setIsOpen?.(false);
    }, [
        setIsOpen
    ]); // Callback ref to focus the menu container when it mounts for a11y
    const setContainerRef = (0, $42omo.useCallback)((node)=>{
        containerRef.current = node;
        if (node) // Focus the menu container directly - it has tabIndex={-1} to receive programmatic focus
        node.focus();
    }, []); // Arrow key navigation for keyboard a11y
    // Implemented manually here because this is not yet supported by the AK Menu component
    // and the DropdownMenu is avoided for performance reasons
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (!containerRef.current) return;
        const items = containerRef.current.querySelectorAll('button, a, [role="menuitem"]');
        if (!items.length) return;
         // Check if focus is on the container itself (not on a menu item)
        const focusOnContainer = document.activeElement === containerRef.current;
        const currentIndex = focusOnContainer ? -1 : Array.from(items).findIndex((item)=>item === document.activeElement);
        switch(event.key){
            case 'ArrowDown':
                event.preventDefault();
                if (focusOnContainer || currentIndex === -1) // Focus first item when pressing down from container
                items[0].focus();
                else {
                    const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                    items[nextIndex].focus();
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (focusOnContainer || currentIndex === -1) // Focus last item when pressing up from container
                items[items.length - 1].focus();
                else {
                    const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                    items[prevIndex].focus();
                }
                break;
            case 'Tab':
                event.preventDefault();
                if (event.shiftKey) {
                    // Shift+Tab - move backwards
                    if (focusOnContainer || currentIndex === -1) items[items.length - 1].focus();
                    else {
                        const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                        items[prevIndex].focus();
                    }
                } else // Tab - move forwards
                if (focusOnContainer || currentIndex === -1) items[0].focus();
                else {
                    const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                    items[nextIndex].focus();
                }
                break;
            case 'Escape':
                event.preventDefault();
                handleCloseHelpMenu(); // Return focus to trigger button
                triggerRef?.current?.focus();
                break;
        }
    }, [
        containerRef,
        handleCloseHelpMenu,
        triggerRef
    ]);
    const handleClickOutside = (0, $42omo.useCallback)((event)=>{
        const target = event.target;
        const targetIsNotUnmountedByReact = target.offsetParent;
        if (isOpen && targetIsNotUnmountedByReact && !(0, $79V5c.isDescendant)(containerRef.current, target)) handleCloseHelpMenu();
    }, [
        isOpen,
        handleCloseHelpMenu
    ]);
    (0, $42omo.useEffect)(()=>{
        window.document.addEventListener('click', handleClickOutside);
        return ()=>{
            window.document.removeEventListener('click', handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    const onItemClick = (0, $42omo.useCallback)((_event, callback)=>{
        if (callback) return ()=>{
            handleCloseHelpMenu();
            triggerRef?.current?.focus(); // Wrap callback in requestAnimationFrame to ensure it is triggered async after focus is moved
            // This allows focus to return to the help icon after the opened modal is closed for a11y
            requestAnimationFrame(()=>{
                callback();
            });
        };
        handleCloseHelpMenu();
    }, [
        handleCloseHelpMenu,
        triggerRef
    ]);
    const renderHelpShortcutDropDownItem = (0, $42omo.useMemo)(()=>/*#__PURE__*/ $42omo.createElement((0, $56M4r.default), {
            onClick: onItemClick(null, openHelpDialog),
            iconAfter: /*#__PURE__*/ $42omo.createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: "mod+/"
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
            id: "editor.shortcuts"
        })), [
        onItemClick,
        openHelpDialog
    ]);
    const renderHelpCenter = (0, $42omo.useMemo)(()=>{
        return !(0, $6mKj3.expVal)('cc_fd_help_center_no_changeboarding', 'isEnabled', false) && /*#__PURE__*/ $42omo.createElement((0, $ep7kE.HelpMenuHelpCenterItem), {
            closeHelpMenu: handleCloseHelpMenu
        });
    }, [
        handleCloseHelpMenu
    ]);
    const renderBlueprintTypeBasedDropdownItems = (0, $42omo.useMemo)(()=>{
        if ((0, $gi8bo.CONTEXTUAL_EDITOR_HELP_LINKS).hasOwnProperty(blueprintType)) {
            const i18nMessage = {
                id: (0, $gi8bo.PREDEFINED_BLUEPRINT_TYPES_TITLES)[blueprintType]
            };
            const blueprintTitle = formatMessage(i18nMessage);
            return (0, $gi8bo.CONTEXTUAL_EDITOR_HELP_LINKS)[blueprintType].map((item, index)=>/*#__PURE__*/ $42omo.createElement((0, $cGtPE.default), {
                    key: index,
                    onClick: (e)=>onItemClick(e, null),
                    href: item.href,
                    target: "_blank"
                }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
                    id: "editor.help.how.to.use.blueprint",
                    values: {
                        blueprintType: blueprintTitle
                    }
                })));
        }
        return null;
    }, [
        blueprintType,
        formatMessage,
        onItemClick
    ]);
    const renderDevTools = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $bavCP.QueryInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $gHANe.UserContextQuery)
        }, ({ data: data })=>{
            const atlassianStaff = (0, $bw3p5.isAtlassianStaff)(data);
            const showDevTools = ()=>setShouldShowDevTools?.(true);
            return atlassianStaff ? /*#__PURE__*/ $42omo.createElement((0, $56M4r.default), {
                onClick: onItemClick(null, showDevTools)
            }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
                id: "editor.help.dev-tools",
                defaultMessage: "Dev Tools"
            })) : null;
        });
    }, [
        setShouldShowDevTools,
        onItemClick
    ]);
    const renderExternalLinkItems = (0, $42omo.useMemo)(()=>{
        if (isTemplateEditor) return null;
        return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement((0, $cGtPE.default), {
            href: (0, $gi8bo.EDITOR_IMPROVEMENTS_URL),
            target: "_blank",
            iconAfter: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                color: "currentColor",
                label: formatMessage({
                    id: "help.name"
                })
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
            id: "editor.help.updates"
        })), !isCompanyHub ? /*#__PURE__*/ $42omo.createElement((0, $cGtPE.default), {
            href: (0, $gi8bo.EDITOR_TEMPLATES_URL),
            target: "_blank",
            iconAfter: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                color: "currentColor",
                label: formatMessage({
                    id: "help.name"
                })
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
            id: "editor.help.templates",
            defaultMessage: "Use page templates"
        })) : null);
    }, [
        isTemplateEditor,
        isCompanyHub,
        formatMessage
    ]);
    const renderNCSSynchronyIndicator = (0, $42omo.useMemo)(()=>/*#__PURE__*/ $42omo.createElement((0, $bavCP.QueryInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $gHANe.UserContextQuery)
        }, ({ data: data })=>{
            const atlassianStaff = (0, $bw3p5.isAtlassianStaff)(data);
            if (!atlassianStaff) return null;
            if (isTemplateEditor) return null;
            const indicator = isNCSEditor ? /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
                id: "editor.help.dev-only-ncs-editor",
                defaultMessage: "DEV ONLY: NCS editor"
            }) : /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
                id: "editor.help.dev-only-synchrony-editor",
                defaultMessage: "DEV ONLY: Synchrony editor"
            });
            return /*#__PURE__*/ $42omo.createElement((0, $56M4r.default), null, indicator);
        }), [
        isNCSEditor,
        isTemplateEditor
    ]);
    const renderFeedbackItem = (0, $42omo.useMemo)(()=>{
        const openGlobalFeedbackCollector = ()=>{
            setShouldShowGlobalFeedbackCollector?.(true);
        };
        return /*#__PURE__*/ $42omo.createElement((0, $56M4r.default), {
            onClick: onItemClick(null, openGlobalFeedbackCollector)
        }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
            id: "editor-help.fabric.help.center.feedback.item",
            defaultMessage: "Feedback"
        }));
    }, [
        onItemClick,
        setShouldShowGlobalFeedbackCollector
    ]);
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": "help-menu-component",
        ref: setContainerRef,
        role: "menu",
        "aria-label": formatMessage({
            id: "editor-help.help.name",
            defaultMessage: "Help menu"
        }),
        onKeyDown: handleKeyDown,
        tabIndex: -1,
        className: (0, $gMc0m.default)([
            $9fef5514b8b73423$var$styles.base
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2SlZp.default), {
        role: "none"
    }, /*#__PURE__*/ $42omo.createElement((0, $7rvPL.default), null, renderNCSSynchronyIndicator, renderDevTools, renderHelpShortcutDropDownItem, renderExternalLinkItems, renderHelpCenter, renderBlueprintTypeBasedDropdownItems, renderFeedbackItem)));
};

const $9fef5514b8b73423$export$c95a604f5f13c815 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "P9Lue",
    name: "HelpMenu",
    loader: async ()=>(await Promise.resolve(module.exports)).HelpMenuComponent
});
module.exports["HelpMenuComponent"] = $9fef5514b8b73423$export$d3e032c62ea2d293;
module.exports["HelpMenu"] = $9fef5514b8b73423$export$c95a604f5f13c815;

});

parcelRegister("bw3p5", function(module, exports) {
const $94cc6fb69dc46872$export$c447f2d04f7089f6 = (data)=>{
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com'))) || false;
};
module.exports["isAtlassianStaff"] = $94cc6fb69dc46872$export$c447f2d04f7089f6;

});

parcelRegister("gHANe", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $d5213b14145490b2$export$4dfd297558414f12 = (0, $eSUdr.default)`query UserContextQuery{user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}}}`;
module.exports["UserContextQuery"] = $d5213b14145490b2$export$4dfd297558414f12;

});

parcelRegister("79V5c", function(module, exports) {
const $61ebe33edfdd9c82$export$8503f9d2928f9a64 = (parent, child)=>{
    let node = child.parentNode;
    while(node !== null){
        if (node === parent) return true;
        node = node.parentNode;
    }
    return false;
};
module.exports["isDescendant"] = $61ebe33edfdd9c82$export$8503f9d2928f9a64;

});

parcelRegister("gi8bo", function(module, exports) {
const $b321bf2443957350$export$94242db98fef807c = 'fabric-editor-onboarding-spotlight';
const $b321bf2443957350$export$29775c4096cc1552 = 'editor.help.center.spotlight.on.help.menu';
const $b321bf2443957350$export$d9e6ed86eee859f9 = 'https://confluence.atlassian.com/confcloud/confluence-editing-improvements-945107733.html';
const $b321bf2443957350$export$27957730b2c962c0 = 'https://confluence.atlassian.com/display/ConfCloud/Create+a+page+from+a+template';
const $b321bf2443957350$export$4b54359533b49a0a = {
    EDITING_IMPROVEMENTS: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements',
    MEETING_NOTES: 'https://www.atlassian.com/software/confluence/templates/meeting-notes',
    BLOGS_UPDATE: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements#ConfluenceEditingImprovements-blogposts',
    MEETING_NOTES_UPDATE: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements#ConfluenceEditingImprovements-meetingnotes'
};
const $b321bf2443957350$export$8ef3900260e04cce = {
    'meeting-notes': [
        {
            href: $b321bf2443957350$export$4b54359533b49a0a.MEETING_NOTES,
            title: 'editor.help.how.to.use.blueprint'
        }
    ]
};
const $b321bf2443957350$export$3e2a3fad4e0315ba = {
    'meeting-notes': 'content.kind.meeting-notes',
    decisions: 'content.kind.decisions',
    'kb-how-to-article': 'content.kind.kb-how-to-article',
    'file-list': 'content.kind.file-list',
    retrospective: 'content.kind.retrospective',
    requirements: 'content.kind.product-requirements',
    'shared-links': 'content.kind.shared-links',
    'kb-troubleshooting-article': 'content.kind.kb-troubleshooting-article',
    'task-report': 'content.kind.task-report',
    jirareport: 'content.kind.jirareport'
};
module.exports["HELP_MENU_SPOTLIGHT"] = $b321bf2443957350$export$29775c4096cc1552;
module.exports["EDITOR_IMPROVEMENTS_URL"] = $b321bf2443957350$export$d9e6ed86eee859f9;
module.exports["EDITOR_TEMPLATES_URL"] = $b321bf2443957350$export$27957730b2c962c0;
module.exports["CONTEXTUAL_EDITOR_HELP_LINKS"] = $b321bf2443957350$export$8ef3900260e04cce;
module.exports["PREDEFINED_BLUEPRINT_TYPES_TITLES"] = $b321bf2443957350$export$3e2a3fad4e0315ba;

});

parcelRegister("ep7kE", function(module, exports) {
/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ /*
This component represents the help center list item in the editor help menu
(currently in the bottom left of the editor view).

It is broken out as a component because of the need to add/remove a listener in
componentDidUpdate.
 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dAYOx = parcelRequire("dAYOx");


var $1DWH0 = parcelRequire("1DWH0");


var $giS6h = parcelRequire("giS6h");


var $3RNrC = parcelRequire("3RNrC");


var $gi8bo = parcelRequire("gi8bo");


var $29Qpd = parcelRequire("29Qpd");

const $763e12daea84475e$var$HelpMenuHelpCenterItemWithContext = (props)=>{
    const classicEditorContext = (0, $42omo.useContext)((0, $giS6h.ClassicEditorContext));
    const helpMenuClassicContext = (0, $42omo.useContext)((0, $3RNrC.HelpMenuClassicContext));
    // The next editor uses the ClassicEditorContext, while classic uses the HelpMenuClassicContext
    const { Changeboarding: Changeboarding } = classicEditorContext.Changeboarding ? classicEditorContext : helpMenuClassicContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($763e12daea84475e$var$HelpMenuHelpCenterItemClass, {
        ...props,
        Changeboarding: Changeboarding
    });
};
const $763e12daea84475e$var$HelpMenuHelpCenterItemClass = ({ closeHelpMenu: closeHelpMenu, createAnalyticsEvent: createAnalyticsEvent, Changeboarding: Changeboarding })=>{
    const [helpCenterSweetState, { openHelpCenter: openHelpCenter, hideHelpMenuSpotlight: hideHelpMenuSpotlight }] = (0, $29Qpd.useHelpMenuState)();
    const onOpenHelpCenter = ()=>{
        openHelpCenter();
        closeHelpMenu();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'helpMenuItemForEditorHelpCenter',
                source: 'editorHelpMenu'
            }
        }).fire();
    };
    /**
   * When the last changeboard in the current sequence is closed, call this
   * callback to set the state of the spotlight in helpCenterState.
   * @param helpCenterState
   */ const changeboardingFinished = ()=>{
        hideHelpMenuSpotlight();
        closeHelpMenu();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spotlightForEditorHelpCenter',
                source: 'editor help menu spotlight'
            }
        }).fire();
    };
    const isHelpCenterOpen = helpCenterSweetState.isHelpCenterOpen;
    return helpCenterSweetState.shouldShowHelpMenuSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Changeboarding, {
        spotlightId: (0, $gi8bo.HELP_MENU_SPOTLIGHT),
        delaySpotlight: 200,
        changeboardFlowFinished: changeboardingFinished
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        isDisabled: isHelpCenterOpen,
        onClick: onOpenHelpCenter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "fabric.help.center.menuitem.title"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        testId: "help-center-menuitem-title",
        isDisabled: isHelpCenterOpen,
        onClick: onOpenHelpCenter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "fabric.help.center.menuitem.title"
    }));
};
const $763e12daea84475e$export$9fbf8d846e1f1108 = (0, $1DWH0.default)()($763e12daea84475e$var$HelpMenuHelpCenterItemWithContext);
module.exports["HelpMenuHelpCenterItem"] = $763e12daea84475e$export$9fbf8d846e1f1108;

});

parcelRegister("3RNrC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d5243bcfa2782ca1$export$c6b672e180f71a34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
module.exports["HelpMenuClassicContext"] = $d5243bcfa2782ca1$export$c6b672e180f71a34;

});

parcelRegister("29Qpd", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $cdc66bc83bc87cd7$var$initialState = {
    isHelpCenterOpen: false,
    isHelpCenterManuallyOpened: false,
    shouldShowHelpMenuSpotlight: null,
    isFeatureDiscovered: false
};
const $cdc66bc83bc87cd7$export$e324594224ef24da = {
    openHelpCenter: (isHelpCenterManuallyOpened = false)=>({ setState: setState })=>{
            setState({
                isHelpCenterOpen: true,
                isHelpCenterManuallyOpened: isHelpCenterManuallyOpened
            });
        },
    closeHelpCenter: ()=>({ setState: setState })=>{
            setState({
                isHelpCenterOpen: false,
                isHelpCenterManuallyOpened: false
            });
        },
    showHelpMenuSpotlight: ()=>({ setState: setState })=>{
            setState({
                shouldShowHelpMenuSpotlight: true
            });
        },
    hideHelpMenuSpotlight: ()=>({ setState: setState })=>{
            setState({
                shouldShowHelpMenuSpotlight: false
            });
        },
    setFeatureDiscovered: (discoveryState)=>({ setState: setState })=>{
            setState({
                isFeatureDiscovered: discoveryState
            });
        }
};
const $cdc66bc83bc87cd7$var$store = (0, $1P1Tu.createStore)({
    initialState: $cdc66bc83bc87cd7$var$initialState,
    actions: $cdc66bc83bc87cd7$export$e324594224ef24da
});
const $cdc66bc83bc87cd7$export$cfc41c159d64eee0 = (0, $9zUhf.createHook)($cdc66bc83bc87cd7$var$store);
const $cdc66bc83bc87cd7$export$e72a86a116ee4bad = (0, $9zUhf.createActionsHook)($cdc66bc83bc87cd7$var$store);
module.exports["useHelpMenuState"] = $cdc66bc83bc87cd7$export$cfc41c159d64eee0;
module.exports["useHelpMenuActions"] = $cdc66bc83bc87cd7$export$e72a86a116ee4bad;

});

parcelRegister("hQDqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $2iJbI = parcelRequire("2iJbI");


var $Uf8ZT = parcelRequire("Uf8ZT");


var $6ZneI = parcelRequire("6ZneI");


var $1wNUR = parcelRequire("1wNUR");

const $ebcc6a166a2bc753$export$fb51ab5e8dce5cd = (props)=>{
    const { contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner, spaceKey: spaceKey, editorActions: editorActions, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded, handleTitleChange: handleTitleChange, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel } = props;
    const { isVisible: isVisible, setIsVisible: setIsVisible, isLandInEditorBannerShown: isLandInEditorBannerShown, showingOfflineBanner: showingOfflineBanner, onboardingStateData: onboardingStateData, onboardingStateError: onboardingStateError, deserializedData: deserializedData, editorOnboardingEligiblity: editorOnboardingEligiblity, wasDraftBannerSeen: wasDraftBannerSeen, labelsError: labelsError, hasQueryErrors: hasQueryErrors } = (0, $1wNUR.useOnboardingBannerLogic)({
        contentId: contentId,
        version: version,
        isShowingOfflineBanner: isShowingOfflineBanner,
        spaceKey: spaceKey,
        setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded
    });
    (0, $42omo.useEffect)(()=>{
        if (!isVisible) {
            // TODO: Manage logic in a separate component https://hello.atlassian.net/browse/CONFONBO-1674
            // These are all conditions where we should not block the Editor Help Center from rendering
            const finishedLoading = // there are any errors in the queries
            onboardingStateError || labelsError || hasQueryErrors || // the user is not eligible for the experiment
            onboardingStateData && !editorOnboardingEligiblity || wasDraftBannerSeen;
            if (finishedLoading) setIsOnboardingBannerDataLoaded(true);
        }
    }, [
        isVisible,
        onboardingStateError,
        labelsError,
        hasQueryErrors,
        onboardingStateData,
        editorOnboardingEligiblity,
        wasDraftBannerSeen,
        setIsOnboardingBannerDataLoaded
    ]);
    const { shouldHideFeatureForWacTemplateUsers: shouldHideFeatureForWacTemplateUsers, isLoading: isLoadingShouldHideFeatureForWacTemplateUsers } = (0, $2iJbI.useShouldHideFeatureForWacTemplateUsers)();
    // note: unauthorized errors are handled in the queries themselves
    if (onboardingStateError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: onboardingStateError
    });
    else if (labelsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: labelsError
    });
    if (isLoadingShouldHideFeatureForWacTemplateUsers || shouldHideFeatureForWacTemplateUsers) return null;
    if (!isVisible) return null;
    const [BannerComponent, experienceName] = isLandInEditorBannerShown ? [
        (0, $6ZneI.LandInEditorBanner),
        (0, $irVI7.ONBOARDING_LAND_IN_EDITOR_BANNER_EXPERIENCE)
    ] : [
        (0, $Uf8ZT.EditorDraftBanner),
        (0, $irVI7.ONBOARDING_EDITOR_DRAFT_BANNER_EXPERIENCE)
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isLandInEditorBannerShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: experienceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BannerComponent, {
        ...props,
        showingOfflineBanner: showingOfflineBanner,
        setIsVisible: setIsVisible,
        deserializedData: onboardingStateData && deserializedData,
        editorActions: editorActions,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        handleTitleChange: handleTitleChange
    }));
};
const $ebcc6a166a2bc753$export$d450ceafc6a31d4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ebcc6a166a2bc753$export$fb51ab5e8dce5cd, props));
};
module.exports["OnboardingEditorBanner"] = $ebcc6a166a2bc753$export$d450ceafc6a31d4;

});

parcelRegister("2iJbI", function(module, exports) {

var $9kdHI = parcelRequire("9kdHI");

const $f4a73ae29c7bb36d$export$75ba00a1e24e646 = ()=>{
    const { templateOnboardingViewedTime: templateOnboardingViewedTime, isLoading: isLoading } = (0, $9kdHI.useGetTemplateOnboardingViewedTime)();
    if (isLoading) return {
        isLoading: true,
        shouldHideFeatureForWacTemplateUsers: undefined
    };
    const msSinceOnboardingViewed = Date.now() - templateOnboardingViewedTime;
    const daysSinceOnboardingViewed = Math.floor(msSinceOnboardingViewed / 86400000);
    return {
        isLoading: isLoading,
        shouldHideFeatureForWacTemplateUsers: daysSinceOnboardingViewed === 0
    };
};
module.exports["useShouldHideFeatureForWacTemplateUsers"] = $f4a73ae29c7bb36d$export$75ba00a1e24e646;

});

parcelRegister("9kdHI", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $d1bc8a4175482375$export$51c1a6087b7be3d9 = ()=>{
    const { data: onboardingStateData, loading: isLoading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).TEMPLATE_ONBOARDING_VIEWED_TIME
    ]);
    if (error) return {
        isLoading: false,
        templateOnboardingViewedTime: 0
    };
    if (isLoading) return {
        isLoading: isLoading,
        templateOnboardingViewedTime: 0
    };
    const { templateOnboardingViewedTime: templateOnboardingViewedTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const templateOnboardingViewedTimeNumber = +templateOnboardingViewedTime;
    return {
        isLoading: false,
        templateOnboardingViewedTime: Number.isNaN(templateOnboardingViewedTimeNumber) ? 0 : templateOnboardingViewedTimeNumber
    };
};
const $d1bc8a4175482375$export$ab4c942452c94059 = ()=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    return {
        setTemplateOnboardingViewedNow: ()=>{
            const now = Date.now().toString();
            setOnboardingState({
                key: (0, $dBcar.ONBOARDING_EXPERIENCES).TEMPLATE_ONBOARDING_VIEWED_TIME,
                value: now
            });
        }
    };
};
module.exports["useGetTemplateOnboardingViewedTime"] = $d1bc8a4175482375$export$51c1a6087b7be3d9;
module.exports["useSetTemplateOnboardingViewedTime"] = $d1bc8a4175482375$export$ab4c942452c94059;

});

parcelRegister("Uf8ZT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $hmuev = parcelRequire("hmuev");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $ivb8S = parcelRequire("ivb8S");


var $5cryL = parcelRequire("5cryL");


var $2Csej = parcelRequire("2Csej");


var $lf5Wg = parcelRequire("lf5Wg");

const $3f811c71e472125a$var$i18n = (0, $aXWIB.defineMessages)({
    bannerMessage: {
        id: "onboarding-editor.draft.banner",
        defaultMessage: "{boldedUnpublishedDraftText} Only you can see it until you publish it or give someone the link. {learnMoreLink}"
    },
    unpublishedDraftText: {
        id: "onboarding-editor.unpublished.draft",
        defaultMessage: "<b>This is an unpublished draft.</b>"
    },
    learnMore: {
        id: "onboarding-editor.learn.more",
        defaultMessage: "Learn more"
    }
});
const $3f811c71e472125a$export$b786d9c272de6a0b = (props)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, showingOfflineBanner: showingOfflineBanner, setIsVisible: setIsVisible, deserializedData: { wasDraftBannerSeen: wasDraftBannerSeen } = {}, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_editor_ttvc_release_bundle_one', 'onboardingUseEffectFix', true)) {
            if (!wasDraftBannerSeen) {
                const editorNode = document.querySelector('.ak-editor-content-area');
                if (editorNode) editorNode.style.marginTop = '52px';
                return ()=>{
                    if (editorNode) editorNode.style.marginTop = '0';
                };
            }
        }
    }, [
        wasDraftBannerSeen
    ]);
    // Adjusting the margins after mount in this useEffect is causing a TTVC regression. Remove this useEffect after removing cc_editor_ttvc_release_bundle_one.
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc_editor_ttvc_release_bundle_one', 'onboardingUseEffectFix', true)) {
            if (!wasDraftBannerSeen) {
                const editorNode = document.querySelector('.ak-editor-content-area');
                if (editorNode) editorNode.style.marginTop = '52px';
                return ()=>{
                    if (editorNode) editorNode.style.marginTop = '0';
                };
            }
        }
    }, [
        wasDraftBannerSeen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!wasDraftBannerSeen) {
            setOnboardingState([
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).WAS_DRAFT_BANNER_SEEN,
                    value: 'true'
                },
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).IS_DRAFT_BANNER_VISIBLE,
                    value: 'true'
                }
            ]);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'onboardingEditorDraft'
                }
            }).fire();
            // TODO: Refactor https://hello.atlassian.net/browse/CONFONBO-1674
            setTimeout(()=>{
                setIsOnboardingBannerDataLoaded(true);
            }, 0);
        }
    }, [
        createAnalyticsEvent,
        setIsOnboardingBannerDataLoaded,
        setOnboardingState,
        wasDraftBannerSeen
    ]);
    const _onDismiss = ()=>{
        setIsVisible(false);
        // Move all the content back up 52px to adjust for the banner disappearing
        const editorNode = document.querySelector('.ak-editor-content-area');
        if (editorNode) editorNode.style.marginTop = '0px';
    };
    // compiled shouldn't handle a complicated runtime CSS, hence the inlined style
    const calculatedTop = (0, $42omo.useMemo)(()=>(0, $2Csej.getAdjustedTopPropertyValue)(showingOfflineBanner), [
        showingOfflineBanner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lf5Wg.BannerContainer), {
        style: {
            top: calculatedTop
        },
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        "data-testid": "onboarding-editor-draft-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lf5Wg.Banner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$3f811c71e472125a$var$i18n.bannerMessage,
        values: {
            boldedUnpublishedDraftText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$3f811c71e472125a$var$i18n.unpublishedDraftText,
                values: {
                    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                }
            }),
            learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: "https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/",
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3f811c71e472125a$var$i18n.learnMore))
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lf5Wg.IconContainer), {
        "data-testid": "onboarding-editor-close-banner",
        onClick: _onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "dismiss"
    }))));
};
module.exports["EditorDraftBanner"] = $3f811c71e472125a$export$b786d9c272de6a0b;

});

parcelRegister("2Csej", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");

const $962512f38cbacac9$export$4b0deb0da32f3c86 = (userOffline)=>{
    const offlineBannerHeight = 32;
    let toolbarHeight = (0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    if (userOffline) toolbarHeight = `calc(${toolbarHeight} + ${offlineBannerHeight}px)`;
    return toolbarHeight;
};
module.exports["getAdjustedTopPropertyValue"] = $962512f38cbacac9$export$4b0deb0da32f3c86;

});

parcelRegister("lf5Wg", function(module, exports) {
/* EditorDraftBannerStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to dynamic nature
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $50c9ab69d3957b00$export$f316edcbf748c37b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71nm4 _v564rftg _4t3i1ex1 _kqswstnw _1ltvidpf _1pbyb4wl",
            __cmplp.isContentCreationPanelOpen ? "_1xi2nklw" : "_1xi2idpf",
            __cmplp.className
        ])
    });
});
const $50c9ab69d3957b00$export$3b4e64e77073e307 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41gu9 _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq _y3gn1h6o _vchhusvi",
            __cmplp.className
        ])
    });
});
const $50c9ab69d3957b00$export$8f314e512d92575f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1xi2v47k _154ipxbi _80omtlke _1pbyb4wl",
            __cmplp.className
        ])
    });
});
module.exports["BannerContainer"] = $50c9ab69d3957b00$export$f316edcbf748c37b;
module.exports["Banner"] = $50c9ab69d3957b00$export$3b4e64e77073e307;
module.exports["IconContainer"] = $50c9ab69d3957b00$export$8f314e512d92575f;

});

parcelRegister("6ZneI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hmuev = parcelRequire("hmuev");


var $cOrQJ = parcelRequire("cOrQJ");


var $inPa6 = parcelRequire("inPa6");


var $u9agA = parcelRequire("u9agA");


var $eEA8O = parcelRequire("eEA8O");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $ivb8S = parcelRequire("ivb8S");


var $5cryL = parcelRequire("5cryL");


var $hl0fg = parcelRequire("hl0fg");


var $6mKj3 = parcelRequire("6mKj3");


var $2Csej = parcelRequire("2Csej");


var $2vb0O = parcelRequire("2vb0O");


var $2FB93 = parcelRequire("2FB93");

var $lf5Wg = parcelRequire("lf5Wg");


var $dz5dy = parcelRequire("dz5dy");


var $iiztD = parcelRequire("iiztD");


var $1e4h8 = parcelRequire("1e4h8");

const $f8787e8012c53a80$var$i18n = (0, $aXWIB.defineMessages)({
    bannerTitle: {
        id: "onboarding-editor.land-in-editor.banner.title",
        defaultMessage: "There\u2019s a template for that"
    },
    bannerDescription: {
        id: "onboarding-editor.land-in-editor.banner.description",
        defaultMessage: "Based on your responses, here\u2019s a template best suited to help you get started."
    },
    exploreCTA: {
        id: "onboarding-editor.land-in-editor.explore-templates",
        defaultMessage: "Explore all templates"
    },
    blankPageCTA: {
        id: "onboarding-editor.land-in-editor.blank-page",
        defaultMessage: "Start with a blank page"
    }
});
const $f8787e8012c53a80$export$8cf2982a68e0098c = (props)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, showingOfflineBanner: showingOfflineBanner, setIsVisible: setIsVisible, deserializedData: { isLandInEditorBannerVisible: isLandInEditorBannerVisible } = {}, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded, editorActions: editorActions, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, handleTitleChange: handleTitleChange } = props;
    const { setHasLandInEditorBannerVisible: setHasLandInEditorBannerVisible } = (0, $dz5dy.useOnboardingEditorActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $42omo.useEffect)(()=>{
        if (isLandInEditorBannerVisible) {
            setOnboardingState([
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).IS_LAND_IN_EDITOR_BANNER_VISIBLE,
                    value: 'false'
                }
            ]);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'landInEditorBanner'
                }
            }).fire();
            setHasLandInEditorBannerVisible(true);
        }
        // TODO: Refactor https://hello.atlassian.net/browse/CONFONBO-1674
        setTimeout(()=>{
            setIsOnboardingBannerDataLoaded(true);
        }, 0);
    }, [
        setOnboardingState,
        isLandInEditorBannerVisible,
        createAnalyticsEvent,
        setIsOnboardingBannerDataLoaded,
        setHasLandInEditorBannerVisible
    ]);
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    // Apply margin-top with useLayoutEffect (before paint). This prevents TTVC mutations.
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_editor_ttvc_release_bundle_one', 'onboardingUseEffectFix', true)) {
            const editorNode = document.querySelector('.ak-editor-content-area');
            // shift the editor content down for different banner breakpoints
            if (editorNode) {
                if (windowWidth <= 375) editorNode.style.marginTop = '300px';
                else if (windowWidth <= 1024 || isContentCreationPanelOpen && windowWidth <= 1024 + (0, $2FB93.templateSidebarWidth)) editorNode.style.marginTop = '291px';
                else editorNode.style.marginTop = '174px';
            }
            return ()=>{
                if (editorNode) editorNode.style.marginTop = '0';
            };
        }
    }, [
        windowWidth,
        isContentCreationPanelOpen
    ]);
    // Adjusting the margins after mount in this useEffect is causing a TTVC regression. Remove this useEffect after removing cc_editor_ttvc_release_bundle_one.
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc_editor_ttvc_release_bundle_one', 'onboardingUseEffectFix', true)) {
            const editorNode = document.querySelector('.ak-editor-content-area');
            // shift the editor content down for different banner breakpoints
            if (editorNode) {
                if (windowWidth <= 375) editorNode.style.marginTop = '300px';
                else if (windowWidth <= 1024 || isContentCreationPanelOpen && windowWidth <= 1024 + (0, $2FB93.templateSidebarWidth)) editorNode.style.marginTop = '291px';
                else editorNode.style.marginTop = '174px';
            }
            return ()=>{
                if (editorNode) editorNode.style.marginTop = '0';
            };
        }
    }, [
        windowWidth,
        isContentCreationPanelOpen
    ]);
    const handleExploreCTA = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerExploreTemplates',
                source: 'landInEditorBanner'
            }
        }).fire();
        onClickOpenContentCreationPanel();
        setIsVisible(false);
    };
    const handleBlankPageCTA = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerBlankPage',
                source: 'landInEditorBanner'
            }
        }).fire();
        onClickOpenContentCreationPanel();
        editorActions.clear();
        setIsVisible(false);
        handleTitleChange('');
    };
    const _onDismiss = ()=>{
        // this will start the animation, and onAnimationEnd we should hide the component
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerDismiss',
                source: 'landInEditorBanner'
            }
        }).fire();
        setIsVisible(false);
    };
    // compiled shouldn't handle a complicated runtime CSS, hence the inlined style
    const calculatedTop = (0, $42omo.useMemo)(()=>(0, $2Csej.getAdjustedTopPropertyValue)(showingOfflineBanner), [
        showingOfflineBanner
    ]);
    const theme = (0, $cOrQJ.default)();
    const backgroundImageUrl = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($1e4h8))) : (0, (/*@__PURE__*/$parcel$interopDefault($iiztD)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.TemplateBannerContainer), {
        style: {
            top: calculatedTop,
            backgroundImage: `url(${backgroundImageUrl})`
        },
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        "data-testid": "onboarding-land-in-editor-banner",
        fade: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.LeftWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2vb0O.TemplateBannerIllustration), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.RightWrapper), {
        isContentCreationPanelOpen: isContentCreationPanelOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.TitleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f8787e8012c53a80$var$i18n.bannerTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.BodyWrapper), {
        isContentCreationPanelOpen: isContentCreationPanelOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f8787e8012c53a80$var$i18n.bannerDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2FB93.StyledButton), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 'fit-content'
        },
        onClick: handleExploreCTA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f8787e8012c53a80$var$i18n.exploreCTA)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: handleBlankPageCTA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f8787e8012c53a80$var$i18n.blankPageCTA)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lf5Wg.IconContainer), {
        "data-testid": "onboarding-land-in-editor-banner-close",
        onClick: _onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "dismiss"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_LAND_IN_EDITOR_BANNER_EXPERIENCE)
    }));
};
module.exports["LandInEditorBanner"] = $f8787e8012c53a80$export$8cf2982a68e0098c;

});

parcelRegister("2vb0O", function(module, exports) {
/* TemplateBannerIllustration.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to custom illustration
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gj7hi = parcelRequire("gj7hi");


var $k29GF = parcelRequire("k29GF");


var $9YG2V = parcelRequire("9YG2V");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $936e99c91b0f8b74$var$IllustrationContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko14xi _n7zljaz9 _1bsbp2n4 _4t3i1w81 _19pk1ejb _bfhkvuon _3okf1ejb _534poahv",
            __cmplp.className
        ])
    });
});
const $936e99c91b0f8b74$export$f60cdccc39dd0674 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($936e99c91b0f8b74$var$IllustrationContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9YG2V))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($k29GF))),
        alt: "",
        testId: "template-banner-illustration"
    }));
};
module.exports["TemplateBannerIllustration"] = $936e99c91b0f8b74$export$f60cdccc39dd0674;

});

parcelRegister("k29GF", function(module, exports) {
module.exports = new URL("LandInEditorIllustrationDark.2f9f7913.svg", import.meta.url).toString();

});

parcelRegister("9YG2V", function(module, exports) {
module.exports = new URL("LandInEditorIllustrationLight.28460c36.svg", import.meta.url).toString();

});

parcelRegister("2FB93", function(module, exports) {
/* EditorTemplateBannerStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to dynamic nature
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $4923552e618c34e5$export$edc250a38d698468 = 320;
const $4923552e618c34e5$var$shrinkUp = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$37a12d5fd88d0bab = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, fade: fade, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3ic4ae _1lrw1dfr _12vemgnk _kqswstnw _1ltvidpf _1pbyb4wl _l60l1sxn _1gwz14u9 _n7es1mjv",
            __cmplp.isContentCreationPanelOpen ? "_1xi2nklw" : "_1xi2idpf",
            __cmplp.isContentCreationPanelOpen && "_16q81sxn",
            __cmplp.isContentCreationPanelOpen && "_1dwk14u9",
            __cmplp.fade && "",
            __cmplp.fade && "_y44v1m2i",
            __cmplp.className
        ])
    });
});
const $4923552e618c34e5$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_nup9u5tj _1w901gfe _w1ap146b _ge1rfqeg _1fh11gfe _r7sm1f1m _1l5a1gfe",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$c3d2343a748f64d3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _kqswh2mm _4t3i1osq _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$8e62e599821d99ec = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1y6m _ca0q1ejb _1nzlidpf _1w22idpf _n71r1wug _1lzu1ejb _1ehg1ejb",
            __cmplp.isContentCreationPanelOpen && "_c5lf1tcg",
            __cmplp.isContentCreationPanelOpen && "_yy4t1tcg",
            __cmplp.isContentCreationPanelOpen && "_1oz9idpf _sxtsidpf _33eu1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$585a3b23e887288b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81af2 _syazi7uo _otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$14966827497f4695 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo _otyrpxbi _1bsb1osq _1i4q1hna _slp31hna _p12f13jv _1428glyw",
            __cmplp.isContentCreationPanelOpen && "_5aflglyw",
            __cmplp.className
        ])
    });
});
module.exports["templateSidebarWidth"] = $4923552e618c34e5$export$edc250a38d698468;
module.exports["TemplateBannerContainer"] = $4923552e618c34e5$export$37a12d5fd88d0bab;
module.exports["StyledButton"] = $4923552e618c34e5$export$2d5d2ba3c7c8c40b;
module.exports["LeftWrapper"] = $4923552e618c34e5$export$c3d2343a748f64d3;
module.exports["RightWrapper"] = $4923552e618c34e5$export$8e62e599821d99ec;
module.exports["TitleWrapper"] = $4923552e618c34e5$export$585a3b23e887288b;
module.exports["BodyWrapper"] = $4923552e618c34e5$export$14966827497f4695;

});

parcelRegister("dz5dy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $f3a77a444e363c9b$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        /**
		 * The user has published their first page ever in the current session
		 * If they publish more than one page, this condition is invalidated
		 */ hasMetPublishNudgeConditions: false,
        hasLandInEditorBannerVisible: false
    },
    actions: {
        setHasMetPublishNudgeConditions: (hasMetPublishNudgeConditions)=>({ setState: setState })=>{
                setState({
                    hasMetPublishNudgeConditions: hasMetPublishNudgeConditions
                });
            },
        setHasLandInEditorBannerVisible: (hasLandInEditorBannerVisible)=>({ setState: setState })=>{
                setState({
                    hasLandInEditorBannerVisible: hasLandInEditorBannerVisible
                });
            }
    },
    name: 'useOnboardingEditorState'
});
const $f3a77a444e363c9b$export$b4e2284668311d45 = (0, $9zUhf.createStateHook)($f3a77a444e363c9b$var$Store, {
    selector: (state)=>({
            hasMetPublishNudgeConditions: state.hasMetPublishNudgeConditions,
            hasLandInEditorBannerVisible: state.hasLandInEditorBannerVisible
        })
});
const $f3a77a444e363c9b$export$e1d5565bc8c0d054 = (0, $9zUhf.createActionsHook)($f3a77a444e363c9b$var$Store);
module.exports["useOnboardingEditorState"] = $f3a77a444e363c9b$export$b4e2284668311d45;
module.exports["useOnboardingEditorActions"] = $f3a77a444e363c9b$export$e1d5565bc8c0d054;

});

parcelRegister("iiztD", function(module, exports) {
module.exports = new URL("LandInEditorBannerBackgroundLight.5f156b32.svg", import.meta.url).toString();

});

parcelRegister("1e4h8", function(module, exports) {
module.exports = new URL("LandInEditorBannerBackgroundDark.f8ccb0f3.svg", import.meta.url).toString();

});

parcelRegister("1wNUR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gci8t = parcelRequire("gci8t");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $66Dsm = parcelRequire("66Dsm");


var $bQm3c = parcelRequire("bQm3c");

const $550262a7e0b7f3e1$var$DELAY_TIMEOUT = 3000;
const $550262a7e0b7f3e1$export$d80357b11b6fd623 = ({ contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner, spaceKey: spaceKey, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded })=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [isLandInEditorBannerShown, setIsLandInEditorBannerShown] = (0, $42omo.useState)(false);
    const [showingOfflineBanner, setShowingOfflineBanner] = (0, $42omo.useState)(false);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)), version !== 1 && version?.number !== 1);
    const deserializedData = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, wasDraftBannerSeen: wasDraftBannerSeen, isLandInEditorBannerVisible: isLandInEditorBannerVisible } = deserializedData;
    // Only check the labels, if they are eligible for the tutorial experiment to begin with.
    const skip = !onboardingStateData || onboardingStateLoading || Boolean(onboardingStateError) || /* Check to see if they are a new user */ !editorOnboardingEligiblity || isLandInEditorBannerVisible; //Skip if user is eligible for Land In Editor Banner
    const { isTemplate: isTemplate, isOnboardingTemplate: isOnboardingTemplate, labelsData: labelsData, labelsLoading: labelsLoading, labelsError: labelsError } = (0, $gci8t.useCheckIfOnboardingEditorTemplate)({
        contentId: contentId,
        skip: skip
    });
    const { shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate, hasQueryErrors: hasQueryErrors } = (0, $66Dsm.useIncludeEditorTutorialTemplate)();
    // Connection banner height has a delay to appear, adjust the draft banner height to reflect this delay
    (0, $42omo.useEffect)(()=>{
        const delayTimeout = setTimeout(()=>setShowingOfflineBanner(isShowingOfflineBanner), $550262a7e0b7f3e1$var$DELAY_TIMEOUT);
        return ()=>clearTimeout(delayTimeout);
    }, [
        isShowingOfflineBanner
    ]);
    (0, $42omo.useEffect)(()=>{
        if (labelsData && !labelsLoading) {
            // the original onboarding template should not have the draft banner
            if (isOnboardingTemplate || !shouldIncludeEditorTutorialTemplate) {
                setIsOnboardingBannerDataLoaded(true);
                return;
            }
            if (!wasDraftBannerSeen) setIsVisible(true);
        // land in editor banner has no labelsData
        } else if (isLandInEditorBannerVisible) {
            setIsVisible(true);
            setIsLandInEditorBannerShown(true);
        }
    }, [
        isOnboardingTemplate,
        isTemplate,
        labelsData,
        labelsLoading,
        locale,
        shouldIncludeEditorTutorialTemplate,
        setIsOnboardingBannerDataLoaded,
        spaceKey,
        wasDraftBannerSeen,
        isLandInEditorBannerVisible
    ]);
    return {
        isVisible: isVisible,
        setIsVisible: setIsVisible,
        isLandInEditorBannerShown: isLandInEditorBannerShown,
        showingOfflineBanner: showingOfflineBanner,
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        deserializedData: deserializedData,
        editorOnboardingEligiblity: editorOnboardingEligiblity,
        wasDraftBannerSeen: wasDraftBannerSeen,
        isLandInEditorBannerVisible: isLandInEditorBannerVisible,
        isTemplate: isTemplate,
        isOnboardingTemplate: isOnboardingTemplate,
        labelsData: labelsData,
        labelsLoading: labelsLoading,
        labelsError: labelsError,
        shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate,
        hasQueryErrors: hasQueryErrors
    };
};
module.exports["useOnboardingBannerLogic"] = $550262a7e0b7f3e1$export$d80357b11b6fd623;

});

parcelRegister("gci8t", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5cryL = parcelRequire("5cryL");


var $cQ5By = parcelRequire("cQ5By");

const $36eef014bcae96ba$export$9870b3b3798cc923 = ({ contentId: contentId, skip: skip })=>{
    const { data: labelsData, loading: labelsLoading, error: labelsError } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $cQ5By.LabelsQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        skip: skip
    });
    const labels = labelsData?.content?.nodes?.[0]?.labels?.nodes || [];
    const sourceTemplateEntityId = labelsData?.content?.nodes?.[0]?.metadata?.sourceTemplateEntityId || undefined;
    // If the current editor is NOT the onboarding editor tutorial, show the draft banner.
    const isOnboardingTemplate = Boolean(labels.find((label)=>label?.label === (0, $5cryL.ONBOARDING_TUTORIAL_LABEL)));
    if (labelsError && (0, $1uFM6.isUnauthorizedError)(labelsError)) (0, $7Sm4c.markErrorAsHandled)(labelsError);
    return {
        isTemplate: !!sourceTemplateEntityId,
        isOnboardingTemplate: isOnboardingTemplate,
        labelsData: labelsData,
        labelsLoading: labelsLoading,
        labelsError: labelsError
    };
};
module.exports["useCheckIfOnboardingEditorTemplate"] = $36eef014bcae96ba$export$9870b3b3798cc923;

});

parcelRegister("cQ5By", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f25f5641eac8f6ae$export$8f13056fc1e2a814 = (0, $eSUdr.default)`query OnboardingLabelsQuery($contentId:ID!$status:[String]){content(id:$contentId status:$status){nodes{id labels{nodes{id label}}metadata{sourceTemplateEntityId}}}}`;
module.exports["LabelsQuery"] = $f25f5641eac8f6ae$export$8f13056fc1e2a814;

});

parcelRegister("66Dsm", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $bQm3c = parcelRequire("bQm3c");


var $1JEqL = parcelRequire("1JEqL");

const $13240525381ea71e$export$10e7c37d48e20bae = 11;
const $13240525381ea71e$export$d227e9a2756e8472 = 7;
const $13240525381ea71e$export$d18f171722e15763 = ()=>{
    const { isLicensed: isLicensed, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { data: editorOnboardingData, loading: editorOnboardingLoading, error: editorOnboardingError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)));
    const { data: userContentData, loading: userContentLoading, error: userContentError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIncludeEditorTutorialTemplateGetUserContentQuery($cql:String!){search:confluence_search(cql:$cql first:12){count}isSiteAdmin}`, {
        variables: {
            cql: `type = 'page' AND creator = '${userId}'`
        },
        skip: !isLicensed || !isLoggedIn
    });
    const { data: privilegeData, loading: privilegeLoading, error: privilegeError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIncludeEditorTutorialTemplateGetUserPrivilegesQuery{user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole}`);
    // Onboarding related variables
    const deserializedEditorOnboardingState = (0, $ivb8S.deserializeState)(editorOnboardingData);
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = deserializedEditorOnboardingState;
    const queriesLoadingOrErrored = editorOnboardingLoading || Boolean(editorOnboardingError) || userContentLoading || Boolean(userContentError) || privilegeLoading || Boolean(privilegeError);
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(privilegeData);
    const hasQueryErrors = Boolean(editorOnboardingError) || Boolean(userContentError) || Boolean(privilegeError);
    // Admins get automatically created 9 pages, while Nth users only get created 5.
    const publishedPagesThreshold = isProductOrSiteAdmin ? $13240525381ea71e$export$10e7c37d48e20bae : $13240525381ea71e$export$d227e9a2756e8472;
    // If there is no data on how many pages they published, then assume that the template shouldn't be visible.
    const numberOfPagesPublished = userContentData?.search?.count ?? publishedPagesThreshold;
    const shouldIncludeEditorTutorialTemplate = !queriesLoadingOrErrored && // Show the template if onboarding state is not loading / has an error
    Boolean(editorOnboardingEligiblity) && // Has to be onboarding eligible (new user)
    numberOfPagesPublished < publishedPagesThreshold; // Don't show if they have published 2 pages (excluding the auto-generated pages)
    return {
        shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate,
        userContentError: userContentError,
        editorOnboardingError: editorOnboardingError,
        privilegeError: privilegeError,
        isProductOrSiteAdmin: isProductOrSiteAdmin,
        queriesLoadingOrErrored: queriesLoadingOrErrored,
        hasQueryErrors: hasQueryErrors
    };
};
module.exports["useIncludeEditorTutorialTemplate"] = $13240525381ea71e$export$d18f171722e15763;

});

parcelRegister("1JEqL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $eJhXX = parcelRequire("eJhXX");


var $icMDs = parcelRequire("icMDs");

function $e18808c613ab8370$export$138f02318593ab4(queryData) {
    const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(queryData);
    return userPrivilege === (0, $icMDs.UserPrivilege).PRODUCT_ADMIN || userPrivilege === (0, $icMDs.UserPrivilege).SITE_ADMIN;
}
module.exports["getIsProductOrSiteAdminFromQuery"] = $e18808c613ab8370$export$138f02318593ab4;

});

parcelRegister("eJhXX", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $fWkVZ = parcelRequire("fWkVZ");


var $w033M = parcelRequire("w033M");


var $icMDs = parcelRequire("icMDs");

function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}
module.exports["getUserPrivilegeFromQuery"] = $a7000458c02582d2$export$d036114e4ad5c4c3;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("icMDs", function(module, exports) {
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});
module.exports["UserPrivilege"] = $296e2d91f769f195$export$fa8745fb6d256802;

});

parcelRegister("i4dNk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

const $0451aea256d3610a$export$5ff0b879ab65d0b0 = 'd1';
const $0451aea256d3610a$export$46c1c92549715335 = 'loading';
const $0451aea256d3610a$export$61c0af74ec47d243 = 'd0';
const $0451aea256d3610a$export$f883a24d5edde77c = 'none';
const $0451aea256d3610a$export$a226a5c24cc00b77 = (updateState = false)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { cohort: cohort, delayInMinutes: delayInMinutes } = $0451aea256d3610a$var$getExperimentData();
    const hasUpdatedState = (0, $42omo.useRef)(false);
    const isInExperimentControl = cohort !== 'treatment';
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled') ? [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ] : [
        (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
        (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME)
    ], isInExperimentControl);
    const spotlightShown = ()=>{
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'false'
        });
    };
    if (isInExperimentControl) return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    if (onboardingStateLoading) // Simplify nav and hide banners while loading, to minimize flashing
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$46c1c92549715335
    };
    if (onboardingStateError) // Control behavior if there are any errors
    return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    const { shouldShowSpotlight: shouldShowSpotlight, startTime: startTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if ($0451aea256d3610a$var$isSiteOlderThanDelay(delayInMinutes, startTime)) {
        if (shouldShowSpotlight) // Spotlight ready to show --> Show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: true,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0,
            onSpotlightShown: spotlightShown
        };
        else if (shouldShowSpotlight === false) // Spotlight has already shown --> Don't show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: false,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0
        };
        // This account was created before the experiment started, so we won't change anything even though statsig returned "treatment"
        return {
            isSpotlightVisible: false,
            areBannersHidden: false,
            navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
        };
    } else if (shouldShowSpotlight === undefined && updateState && !hasUpdatedState.current) {
        hasUpdatedState.current = true;
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'true'
        });
    }
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$61c0af74ec47d243
    };
};
const $0451aea256d3610a$var$getExperimentData = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind-4473-creation-focused-nav'); // Experiment exposure is fired in the backend
    const cohort = expConfig.get('cohort', 'control');
    const minutesPerHour = 60;
    const hoursPerDay = 24;
    const defaultDelayInMinutes = minutesPerHour * hoursPerDay;
    const delayInMinutes = expConfig.get('delayInMinutes', defaultDelayInMinutes.toString());
    return {
        cohort: cohort,
        delayInMinutes: parseInt(delayInMinutes)
    };
};
const $0451aea256d3610a$var$isSiteOlderThanDelay = (delayInMinutes, siteActivationDateString)=>{
    if (!siteActivationDateString) return true; // If site has no activation date, assume it is old
    const siteActivationDateNumber = Number(siteActivationDateString);
    const siteActivationDate = new Date(siteActivationDateNumber ?? '');
    if (isNaN(siteActivationDate.getTime())) return true; // If site has no activation date, assume it is old
    const createdAtTimestamp = siteActivationDate.getTime();
    const millisecondsSinceCreation = Date.now() - createdAtTimestamp;
    const secondsPerMinute = 60;
    const millisecondsPerSecond = 1000;
    const millisecondsInDelayTime = delayInMinutes * secondsPerMinute * millisecondsPerSecond;
    return millisecondsSinceCreation > millisecondsInDelayTime;
};
module.exports["d1"] = $0451aea256d3610a$export$5ff0b879ab65d0b0;
module.exports["loading"] = $0451aea256d3610a$export$46c1c92549715335;
module.exports["d0"] = $0451aea256d3610a$export$61c0af74ec47d243;
module.exports["useCfind4473CreationFocusedNav"] = $0451aea256d3610a$export$a226a5c24cc00b77;

});

parcelRegister("eLnQS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $5e22f724447894e7$export$367f35882b7b4a5b = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $42omo.useMemo)(()=>({
            'table-drag-and-drop': (0, $6mKj3.expVal)('platform_editor_tables_drag_and_drop', 'isEnabled', false),
            'table-selector': (0, $6mKj3.expVal)('platform_editor_tables_table_selector', 'isEnabled', false),
            'macro-interaction-updates': true,
            'table-with-fixed-column-widths-option': true,
            'more-elements-in-quick-insert-view': true
        }), []);
};
module.exports["useEditorFullPageExperiments"] = $5e22f724447894e7$export$367f35882b7b4a5b;

});

parcelRegister("7vJCW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3bfd7e130592105d$export$18f927573c4993d5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-VTjB",
    name: "EditorBreadcrumbs",
    loader: async ()=>{
        const { EditorBreadcrumbsComponent: EditorBreadcrumbsComponent } = await (parcelRequire("aLSQw"));
        return EditorBreadcrumbsComponent;
    }
});
module.exports["EditorBreadcrumbs"] = $3bfd7e130592105d$export$18f927573c4993d5;

});

parcelRegister("aLSQw", function(module, exports) {

let $7d78d67c35577c88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7d78d67c35577c88$var$load("lUs3J"),
    $7d78d67c35577c88$var$load("6wr18"),
    $7d78d67c35577c88$var$load("lPQcc"),
    $7d78d67c35577c88$var$load("ffEVr"),
    $7d78d67c35577c88$var$load("jXx9i"),
    $7d78d67c35577c88$var$load("9qfB8"),
    $7d78d67c35577c88$var$load("hhss7"),
    $7d78d67c35577c88$var$load("aIkc8")
]).then(()=>parcelRequire('aNZDi'));

});

parcelRegister("5RPbY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1hM5R",
    name: "EditorAppearanceButtonNext",
    loader: async ()=>{
        const { EditorAppearanceButtonNext: EditorAppearanceButtonNext } = await (parcelRequire("hbcfL"));
        return EditorAppearanceButtonNext;
    }
});
module.exports["EditorAppearanceButtonNext"] = $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a;

});

parcelRegister("hbcfL", function(module, exports) {

let $c81cf802c96f79e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c81cf802c96f79e1$var$load("6wr18"),
    $c81cf802c96f79e1$var$load("dlm6q"),
    $c81cf802c96f79e1$var$load("ffEVr"),
    $c81cf802c96f79e1$var$load("7GtpA")
]).then(()=>parcelRequire('Vjn6T'));

});

parcelRegister("9iTNj", function(module, exports) {
/* TitleAreaContentComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $554a9c527b7ebc79$var$EmptyTitleArea = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTemplateEditor: isTemplateEditor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.isTemplateEditor ? "_4t3ibi2l" : "_4t3i1nlq",
            __cmplp.className
        ])
    });
});

const $554a9c527b7ebc79$export$24c87f0cb1dfb811 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-4zEr",
    name: "TitleAreaContentComponents",
    loader: async ()=>(await (parcelRequire("7UbTq"))).TitleAreaContentComponents,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($554a9c527b7ebc79$var$EmptyTitleArea, {
            isTemplateEditor: props.isTemplateEditor
        })
});

const $554a9c527b7ebc79$export$94a078f0640d9238 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JPi6Y",
    name: "SmartCreateTitleAreaContentComponents",
    loader: async ()=>(await (parcelRequire("75Qa0"))).SmartCreateTitleAreaContentComponents,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($554a9c527b7ebc79$var$EmptyTitleArea, null)
});
module.exports["TitleAreaContentComponents"] = $554a9c527b7ebc79$export$24c87f0cb1dfb811;

});

parcelRegister("7UbTq", function(module, exports) {

let $5c16fd0967e8a72d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5c16fd0967e8a72d$var$load("2vQEy"),
    $5c16fd0967e8a72d$var$load("5wC2D"),
    $5c16fd0967e8a72d$var$load("6wr18"),
    $5c16fd0967e8a72d$var$load("fkqEO"),
    $5c16fd0967e8a72d$var$load("dlm6q"),
    $5c16fd0967e8a72d$var$load("dtpmo"),
    $5c16fd0967e8a72d$var$load("6m3ID"),
    $5c16fd0967e8a72d$var$load("jbxHq"),
    $5c16fd0967e8a72d$var$load("6jGZ7"),
    $5c16fd0967e8a72d$var$load("5zDuS"),
    $5c16fd0967e8a72d$var$load("ffEVr"),
    $5c16fd0967e8a72d$var$load("kHOMt"),
    $5c16fd0967e8a72d$var$load("7EorR"),
    $5c16fd0967e8a72d$var$load("9AXkC"),
    $5c16fd0967e8a72d$var$load("fZt2F"),
    $5c16fd0967e8a72d$var$load("2vAWg"),
    $5c16fd0967e8a72d$var$load("7cABH"),
    $5c16fd0967e8a72d$var$load("31vk5"),
    $5c16fd0967e8a72d$var$load("4izLy"),
    $5c16fd0967e8a72d$var$load("3DgZV"),
    $5c16fd0967e8a72d$var$load("hhss7"),
    $5c16fd0967e8a72d$var$load("hbc6v")
]).then(()=>parcelRequire('bbYj5'));

});

parcelRegister("75Qa0", function(module, exports) {

let $52a175f95455ba2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $52a175f95455ba2d$var$load("2vQEy"),
    $52a175f95455ba2d$var$load("5wC2D"),
    $52a175f95455ba2d$var$load("6wr18"),
    $52a175f95455ba2d$var$load("fkqEO"),
    $52a175f95455ba2d$var$load("dlm6q"),
    $52a175f95455ba2d$var$load("6m3ID"),
    $52a175f95455ba2d$var$load("jbxHq"),
    $52a175f95455ba2d$var$load("6jGZ7"),
    $52a175f95455ba2d$var$load("5zDuS"),
    $52a175f95455ba2d$var$load("ffEVr"),
    $52a175f95455ba2d$var$load("7EorR"),
    $52a175f95455ba2d$var$load("9AXkC"),
    $52a175f95455ba2d$var$load("fZt2F"),
    $52a175f95455ba2d$var$load("2vAWg"),
    $52a175f95455ba2d$var$load("7cABH"),
    $52a175f95455ba2d$var$load("31vk5"),
    $52a175f95455ba2d$var$load("4izLy"),
    $52a175f95455ba2d$var$load("3DgZV"),
    $52a175f95455ba2d$var$load("hhss7"),
    $52a175f95455ba2d$var$load("dUTj8")
]).then(()=>parcelRequire('fKhxN'));

});

parcelRegister("gjEAi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $44846349058524ee$export$9e2285f96d44792b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "kBUyq",
    name: "ApprovalBanner",
    loader: async ()=>(await (parcelRequire("eLreB"))).ApprovalBanner
});
module.exports["ApprovalBanner"] = $44846349058524ee$export$9e2285f96d44792b;

});

parcelRegister("eLreB", function(module, exports) {

let $abfa94ae6e6a789f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abfa94ae6e6a789f$var$load("6m3ID"),
    $abfa94ae6e6a789f$var$load("8gmaR")
]).then(()=>parcelRequire('hbQeG'));

});

parcelRegister("38qvz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $kqIWy = parcelRequire("kqIWy");

const $f0e4954369e4b2a4$export$6c92cd4e39d5997c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { spaceKey: spaceKey } = t0;
    const { data: spaceData } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const t1 = spaceData?.type;
    const t2 = spaceData?.type === "knowledge_base";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            spaceType: t1,
            isKnowledgeBaseSpace: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
} : ({ spaceKey: spaceKey })=>{
    const { data: spaceData } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    return {
        spaceType: spaceData?.type,
        isKnowledgeBaseSpace: spaceData?.type === 'knowledge_base'
    };
};
module.exports["useSpaceType"] = $f0e4954369e4b2a4$export$6c92cd4e39d5997c;

});

parcelRegister("j5cB3", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cOrQJ = parcelRequire("cOrQJ");


const $43c705326a57355f$export$c720381daa58fcbb = ()=>{
    const $ = (0, $frIzR.c)(2);
    const adsTheme = (0, $cOrQJ.default)();
    let t0;
    if ($[0] !== adsTheme) {
        t0 = adsTheme;
        $[0] = adsTheme;
        $[1] = t0;
    } else t0 = $[1];
    const effectiveTheme = t0;
    return effectiveTheme?.colorMode === "dark";
};
module.exports["useIsDarkMode"] = $43c705326a57355f$export$c720381daa58fcbb;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("lrMxq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $io723 = parcelRequire("io723");


var $jmjWc = parcelRequire("jmjWc");


var $fgdVB = parcelRequire("fgdVB");


const $172892494f392667$var$ObjectSidebarControlLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "liSnz",
    name: "ObjectSidebarControlLoader",
    loader: async ()=>(await (parcelRequire("6A44E"))).ObjectSidebarControl
});
const $172892494f392667$export$3fab07431350539e = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
module.exports["ObjectSidebarControl"] = $172892494f392667$export$3fab07431350539e;

});

parcelRegister("6A44E", function(module, exports) {

let $4ca943e7a19b3715$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ca943e7a19b3715$var$load("fPSgL"),
    $4ca943e7a19b3715$var$load("70IPm"),
    $4ca943e7a19b3715$var$load("6wr18"),
    $4ca943e7a19b3715$var$load("hVgF8"),
    $4ca943e7a19b3715$var$load("8Wi1Y"),
    $4ca943e7a19b3715$var$load("1tMby"),
    $4ca943e7a19b3715$var$load("kTdzk"),
    $4ca943e7a19b3715$var$load("9qKOt"),
    $4ca943e7a19b3715$var$load("hSkfH"),
    $4ca943e7a19b3715$var$load("8Sbjy"),
    $4ca943e7a19b3715$var$load("2O2Xv"),
    $4ca943e7a19b3715$var$load("adH3p"),
    $4ca943e7a19b3715$var$load("hHrTM"),
    $4ca943e7a19b3715$var$load("1jbvx"),
    $4ca943e7a19b3715$var$load("fiOV9"),
    $4ca943e7a19b3715$var$load("4dNRa"),
    $4ca943e7a19b3715$var$load("jdmfD"),
    $4ca943e7a19b3715$var$load("i3R6S"),
    $4ca943e7a19b3715$var$load("1ZFzv"),
    $4ca943e7a19b3715$var$load("hOaAV"),
    $4ca943e7a19b3715$var$load("iK6Gk"),
    $4ca943e7a19b3715$var$load("8VT23"),
    $4ca943e7a19b3715$var$load("1okAQ"),
    $4ca943e7a19b3715$var$load("4rKYa"),
    $4ca943e7a19b3715$var$load("lBu3j"),
    $4ca943e7a19b3715$var$load("tKhaz"),
    $4ca943e7a19b3715$var$load("eD79G"),
    $4ca943e7a19b3715$var$load("cEqm7"),
    $4ca943e7a19b3715$var$load("6XCf4"),
    $4ca943e7a19b3715$var$load("5pvpJ"),
    $4ca943e7a19b3715$var$load("ffEVr"),
    $4ca943e7a19b3715$var$load("1qlDN"),
    $4ca943e7a19b3715$var$load("1yVM6"),
    $4ca943e7a19b3715$var$load("hHIPg")
]).then(()=>parcelRequire('lVF98'));

});

parcelRegister("8Psje", function(module, exports) {
const $5c0c9a15440579bc$export$fb74cd09fc20f0c3 = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
module.exports["isRovoSystemSpaceKey"] = $5c0c9a15440579bc$export$fb74cd09fc20f0c3;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("Ovp0E"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("Ovp0E", function(module, exports) {

let $097d077c1d0e1bc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $097d077c1d0e1bc5$var$load("iMSgb"),
    $097d077c1d0e1bc5$var$load("9a2oY"),
    $097d077c1d0e1bc5$var$load("7EorR"),
    $097d077c1d0e1bc5$var$load("hhss7"),
    $097d077c1d0e1bc5$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("jARmo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $15h8H = parcelRequire("15h8H");


var $2a7wR = parcelRequire("2a7wR");

var $d2rit = parcelRequire("d2rit");

var $hirMS = parcelRequire("hirMS");


var $6mKj3 = parcelRequire("6mKj3");

const $7a91ce8e942450a2$export$ee581ede78ce7214 = ()=>{
    const clientRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expVal)('cc-maui-experiment', 'isEnabled', false)) return;
        const params = (0, $d2rit.maybeParseNativeEmbedParams)(new URLSearchParams(window.location.search));
        if (!params) return;
        const bridge = (0, $15h8H.getBrowserBridgeAPI)();
        const { childClientId: childClientId, parentClientId: parentClientId } = params;
        const supportedFeatures = new Set([
            (0, $hirMS.NativeEmbedCoreFeature).NotifyHostClick
        ]);
        const client = (0, $2a7wR.createNativeEmbedChildClient)(bridge, childClientId, parentClientId, supportedFeatures);
        clientRef.current = client;
        return ()=>{
            client.destroy();
            clientRef.current = null;
        };
    }, []);
    const sendChildCommand = (0, $42omo.useCallback)((command)=>{
        clientRef.current?.sendChildCommand(command);
    }, []);
    return {
        sendChildCommand: sendChildCommand
    };
};
module.exports["usePageNativeEmbedClient"] = $7a91ce8e942450a2$export$ee581ede78ce7214;

});

parcelRegister("2a7wR", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $hTKp4 = parcelRequire("hTKp4");


var $b9NdB = parcelRequire("b9NdB");


var $hirMS = parcelRequire("hirMS");


var $kZzRg = parcelRequire("kZzRg");


var $jVaR2 = parcelRequire("jVaR2");




function $eb0cf3dfaa02e3e6$export$a0386ba7bfa2e425() {
    return {
        bind (handler) {
            const doc = (0, $hTKp4.getDocument)();
            if (!doc) return ()=>{};
            const listener = ()=>{
                handler();
            };
            return (0, $fFa3V.bind)(doc, {
                type: 'click',
                listener: listener,
                options: {
                    capture: true
                }
            });
        }
    };
}
function $eb0cf3dfaa02e3e6$export$3e97a25517c2bf33(bridge, childClientId, parentClientId, supportedFeatures) {
    return new $eb0cf3dfaa02e3e6$export$fcfa04793dda7c9d(bridge, childClientId, parentClientId, new (0, $kZzRg.SupportedFeatures)(supportedFeatures), $eb0cf3dfaa02e3e6$export$a0386ba7bfa2e425());
}
class $eb0cf3dfaa02e3e6$export$fcfa04793dda7c9d {
    /**
   * Single handler for selected-change: runs any user callback from onSelectedChange.
   * We register once so that calling onSelectedChange does not overwrite the
   * internal handler (bridges typically allow one handler per command).
   */ setupSelectedChangeListener() {
        this.bridge.on(this.childClientId, (0, $jVaR2.NativeEmbedSelectedChangeCommand), (params)=>{
            this.onSelectedChangeCallback?.({
                selected: params.selected
            });
        });
    }
    /**
   * Single handler for always-show-title-change: runs any user callback from
   * onAlwaysShowTitleChange. Registered in the constructor so the bridge handler
   * is in place before the handshake completes, preventing dropped messages.
   */ setupAlwaysShowTitleChangeListener() {
        this.bridge.on(this.childClientId, (0, $jVaR2.NativeEmbedAlwaysShowTitleChangeCommand), (params)=>{
            this.onAlwaysShowTitleChangeCallback?.({
                alwaysShowTitle: params.alwaysShowTitle
            });
        });
    }
    setupFeatureHandshakeListener() {
        this.bridge.on(this.childClientId, (0, $jVaR2.NativeEmbedFeatureHandshakeCommand), (params)=>{
            this.supportedFeatures.completeWithAgreedFeatures(new Set(params.features));
        });
    }
    sendFeatureHandshake() {
        this.bridge.send((0, $jVaR2.NativeEmbedFeatureHandshakeCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId,
            features: Array.from(this.supportedFeatures.getLocalSupportedFeatures())
        });
    }
    /**
   * When agreed features include notify-host-click, capture click events
   * and send them to the parent so the host can select this embed.
   */ setupClickCaptureWhenEnabled() {
        this.supportedFeatures.getFeaturesPromise().then((features)=>{
            if (!features.has((0, $hirMS.NativeEmbedCoreFeature).NotifyHostClick)) return;
            const handler = ()=>{
                this.bridge.send((0, $jVaR2.NativeEmbedClickEventCommand), {
                    senderId: this.childClientId,
                    receiverId: this.parentClientId
                });
            };
            const unbind = this.clickCaptureBinder.bind(handler);
            this.clickCaptureCleanup = ()=>{
                unbind();
                this.clickCaptureCleanup = null;
            };
        });
    }
    onNativeEmbedCommand(handler) {
        this.bridge.on(this.childClientId, (0, $jVaR2.NativeEmbedBridgeCommand), handler);
    }
    /**
   * Subscribe to selected-change events from the parent.
   * Only emitted when the SelectedChange feature is agreed in the handshake.
   */ onSelectedChange(handler) {
        this.onSelectedChangeCallback = handler;
    }
    /**
   * Subscribe to view-mode-change events from the parent.
   * Only emitted when the ViewModeChange feature is agreed in the handshake.
   */ onViewModeChange(handler) {
        this.bridge.on(this.childClientId, (0, $jVaR2.NativeEmbedViewModeChangeCommand), (params)=>handler({
                viewMode: params.viewMode
            }));
    }
    /**
   * Subscribe to always-show-title-change events from the parent.
   * Emitted when the user toggles the always-show-title option.
   */ onAlwaysShowTitleChange(handler) {
        this.onAlwaysShowTitleChangeCallback = handler;
    }
    sendChildCommand(command) {
        this.bridge.send((0, $jVaR2.NativeEmbedChildBridgeCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId,
            ...command
        });
    }
    /**
   * Request the host to toggle the full-screen dialog.
   * Only effective when the ToggleFullScreen feature is agreed in the handshake.
   */ sendToggleFullScreen() {
        this.bridge.send((0, $jVaR2.NativeEmbedToggleFullScreenCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId
        });
    }
    /**
   * Request the host to resize the embed container to the given pixel dimensions.
   * Only effective when the RequestResize feature is agreed in the handshake.
   */ sendRequestResize(width, height) {
        this.bridge.send((0, $jVaR2.NativeEmbedRequestResizeCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId,
            width: width,
            height: height
        });
    }
    nativeEmbedFeatures() {
        return this.supportedFeatures.getFeaturesPromise();
    }
    /**
   * Removes click capture listeners.
   * Call when the child client is no longer needed.
   */ destroy() {
        this.clickCaptureCleanup?.();
        this.bridge.teardown((0, $b9NdB.client)(this.childClientId));
    }
    constructor(bridge, childClientId, parentClientId, supportedFeatures, clickCaptureBinder){
        this.bridge = void 0;
        this.childClientId = void 0;
        this.parentClientId = void 0;
        this.supportedFeatures = void 0;
        this.clickCaptureBinder = void 0;
        this.clickCaptureCleanup = null;
        this.onSelectedChangeCallback = null;
        this.onAlwaysShowTitleChangeCallback = null;
        this.bridge = bridge;
        this.childClientId = childClientId;
        this.parentClientId = parentClientId;
        this.supportedFeatures = supportedFeatures;
        this.clickCaptureBinder = clickCaptureBinder;
        this.setupFeatureHandshakeListener();
        this.setupClickCaptureWhenEnabled();
        this.setupSelectedChangeListener();
        this.setupAlwaysShowTitleChangeListener();
        // Register as ready before sending the handshake so the bridge can deliver the message.
        this.bridge.ready((0, $b9NdB.client)(this.childClientId));
        this.sendFeatureHandshake();
    }
}
module.exports["createNativeEmbedChildClient"] = $eb0cf3dfaa02e3e6$export$3e97a25517c2bf33;

});

parcelRegister("kZzRg", function(module, exports) {
class $532205f918115a7e$export$1d19c2585ceee427 {
    setLocalSupportedFeatures(features) {
        this.localSupportedFeatures = features;
    }
    getLocalSupportedFeatures() {
        return this.localSupportedFeatures;
    }
    getFeaturesPromise() {
        return this.deferred.promise;
    }
    /**
   * Completes the handshake with the agreed feature set (call from host after computing intersection, or from child when host responds).
   */ completeWithAgreedFeatures(agreed) {
        this.deferred.resolve(agreed);
    }
    constructor(localSupportedFeatures = new Set()){
        this.localSupportedFeatures = void 0;
        this.deferred = void 0;
        this.localSupportedFeatures = localSupportedFeatures;
        this.deferred = {};
        this.deferred.promise = new Promise((resolve)=>{
            this.deferred.resolve = resolve;
        });
    }
}
module.exports["SupportedFeatures"] = $532205f918115a7e$export$1d19c2585ceee427;

});

parcelRegister("jVaR2", function(module, exports) {

var $3OwWt = parcelRequire("3OwWt");

const $d94c6c66f6c5f5dc$export$6fa96f9e61f5bb99 = (0, $3OwWt.createCommand)('native-embed-command');
const $d94c6c66f6c5f5dc$export$1ee701ffff9b762 = (0, $3OwWt.createCommand)('native-embed-child-command');
const $d94c6c66f6c5f5dc$export$2eb498d58c22456f = (0, $3OwWt.createCommand)('native-embed-feature-handshake-command');
const $d94c6c66f6c5f5dc$export$91600996d49f0b0a = (0, $3OwWt.createCommand)('native-embed-selected-change-command');
const $d94c6c66f6c5f5dc$export$57a04bf1e92410f2 = (0, $3OwWt.createCommand)('native-embed-view-mode-change-command');
const $d94c6c66f6c5f5dc$export$478f68dcfd854b21 = (0, $3OwWt.createCommand)('native-embed-click-event-command');
const $d94c6c66f6c5f5dc$export$e1f68fdfa2b498fc = (0, $3OwWt.createCommand)('native-embed-always-show-title-change-command');
const $d94c6c66f6c5f5dc$export$66deedc198182b99 = (0, $3OwWt.createCommand)('native-embed-toggle-full-screen-command');
const $d94c6c66f6c5f5dc$export$604bbec515403568 = (0, $3OwWt.createCommand)('native-embed-request-resize-command');
module.exports["NativeEmbedBridgeCommand"] = $d94c6c66f6c5f5dc$export$6fa96f9e61f5bb99;
module.exports["NativeEmbedChildBridgeCommand"] = $d94c6c66f6c5f5dc$export$1ee701ffff9b762;
module.exports["NativeEmbedFeatureHandshakeCommand"] = $d94c6c66f6c5f5dc$export$2eb498d58c22456f;
module.exports["NativeEmbedSelectedChangeCommand"] = $d94c6c66f6c5f5dc$export$91600996d49f0b0a;
module.exports["NativeEmbedViewModeChangeCommand"] = $d94c6c66f6c5f5dc$export$57a04bf1e92410f2;
module.exports["NativeEmbedClickEventCommand"] = $d94c6c66f6c5f5dc$export$478f68dcfd854b21;
module.exports["NativeEmbedAlwaysShowTitleChangeCommand"] = $d94c6c66f6c5f5dc$export$e1f68fdfa2b498fc;
module.exports["NativeEmbedToggleFullScreenCommand"] = $d94c6c66f6c5f5dc$export$66deedc198182b99;
module.exports["NativeEmbedRequestResizeCommand"] = $d94c6c66f6c5f5dc$export$604bbec515403568;

});

parcelRegister("d2rit", function(module, exports) {
const $de7cd7c124168308$var$ROVO_RECEIVER_ID_DATA_ATTR = 'data-rovo-receiver-id';
const $de7cd7c124168308$var$ROVO_CHILD_ID_QUERY_PARAM_KEY = 'nativeEmbedChildId';
const $de7cd7c124168308$var$ROVO_PARENT_ID_QUERY_PARAM_KEY = 'nativeEmbedParentId';
function $de7cd7c124168308$export$d5ca420e0d8fc785(bridgeParams) {
    const { embedClientId: embedClientId, hostClientId: hostClientId } = bridgeParams;
    return {
        clientId: embedClientId,
        getQueryParams: ()=>({
                [$de7cd7c124168308$var$ROVO_CHILD_ID_QUERY_PARAM_KEY]: embedClientId,
                [$de7cd7c124168308$var$ROVO_PARENT_ID_QUERY_PARAM_KEY]: hostClientId
            }),
        getIframeDataAttributes: ()=>({
                [$de7cd7c124168308$var$ROVO_RECEIVER_ID_DATA_ATTR]: embedClientId
            })
    };
}
function $de7cd7c124168308$export$a5e60906cc8da6df(params) {
    const id = params.get($de7cd7c124168308$var$ROVO_CHILD_ID_QUERY_PARAM_KEY);
    const parentId = params.get($de7cd7c124168308$var$ROVO_PARENT_ID_QUERY_PARAM_KEY);
    if (!id || id.length === 0 || !parentId || parentId.length === 0) return undefined;
    return {
        childClientId: id,
        parentClientId: parentId
    };
}
module.exports["createNativeEmbedClientIframeIntegrator"] = $de7cd7c124168308$export$d5ca420e0d8fc785;
module.exports["maybeParseNativeEmbedParams"] = $de7cd7c124168308$export$a5e60906cc8da6df;

});

parcelRegister("essql", function(module, exports) {

var $hG1iq = parcelRequire("hG1iq");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $4L9ve = parcelRequire("4L9ve");


var $8i27m = parcelRequire("8i27m");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $8WQTF = parcelRequire("8WQTF");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $9nXVV = parcelRequire("9nXVV");


var $3bH25 = parcelRequire("3bH25");


var $9SEzS = parcelRequire("9SEzS");


var $e4kZB = parcelRequire("e4kZB");

const $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED = 1000;
const $2524304961e9b056$var$unreadCommentsQuery = (0, $hG1iq.default);
const $2524304961e9b056$export$3c5a4187b7dbe412 = ({ pageId: pageId, pageContentTypeProps: pageContentTypeProps, onCommentRead: onCommentRead })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { setIsUpdatingUnreadComments: setIsUpdatingUnreadComments, setIsUnreadQueryLoading: setIsUnreadQueryLoading, updateUnreadCommentIDSet: updateUnreadCommentIDSet, setShouldClearVisibleThreads: setShouldClearVisibleThreads }] = (0, $fHAwL.useUnreadComments)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // Setup observer for unread comments
    (0, $9nXVV.useUnreadCommentsObserverSetup)({
        pageId: pageId,
        onCommentRead: onCommentRead
    });
    // Destructure pageContentTypeProps with defaults
    const { pageMode: pageMode } = pageContentTypeProps || {};
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Get comments data directly from comments-data package (for pages only)
    // This fixes the circular dependency issue
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList = [], commentsDataMap: legacyCommentsDataMap = {
        inline: {},
        general: {}
    } }, { addNewCommentThreads: addNewCommentThreads }] = (0, $8i27m.useCommentsData)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const { isDanglingCallback: isDanglingCallback } = (0, $3bH25.useIsDanglingCallback)({
        pageMode: pageMode
    });
    // We still need these for the logic in handleUpdateUnreadComments
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations, pageId: editorPageId } = editorAnnotationsState;
    const isRenderer = pageMode === 'view';
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions, pageId: rendererPageId } = rendererActionsResult || {};
    const { getViewedCommentsFresh: getViewedCommentsFresh } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const legacyQueryResult = (0, $jMyy4.useQueryInterop)($2524304961e9b056$var$unreadCommentsQuery, {
        variables: {
            pageId: pageId || '',
            contentStatus: !isRenderer ? [
                (0, $9SEzS.GraphQLContentStatus).CURRENT,
                (0, $9SEzS.GraphQLContentStatus).DRAFT
            ] : [
                (0, $9SEzS.GraphQLContentStatus).CURRENT
            ]
        },
        skip: !pageId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    const loading = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? !processedCommentsData.isDataProcessed : legacyQueryResult.loading;
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.error : legacyQueryResult.error;
    (0, $42omo.useEffect)(()=>{
        // isUnreadQueryLoading is used in other areas of the code to make sure unread logic is processed before further logic
        setIsUnreadQueryLoading(loading);
    }, [
        loading,
        setIsUnreadQueryLoading
    ]);
    // Handle GraphQL query errors with proper error handling
    (0, $42omo.useEffect)(()=>{
        if (!error || !pageId) return;
        // Handle expected errors (403/unauthorized, network errors) - just mark as handled
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return;
        }
        // Handle unexpected errors (including 500) - track them with context
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: pageId,
            objectType: 'page'
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error,
        pageId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (pageId) {
            updateUnreadCommentIDSet(new Set(), 'removeAll');
            setShouldClearVisibleThreads(false);
            // reset so we can recreate the set for the page that the user is changing to
            setIsUpdatingUnreadComments(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const resetStates = (0, $42omo.useCallback)(()=>{
        setIsUpdatingUnreadComments(false);
    }, [
        setIsUpdatingUnreadComments
    ]);
    const handleUpdateUnreadComments = (0, $42omo.useCallback)(async ()=>{
        if (userId && isUpdatingUnreadComments) {
            if (loading) return [];
            if (!pageId) return;
            const currentAllCommentsFromQuery = (()=>{
                // When feature flag is enabled, use data from ProcessedCommentsDataStore
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return processedCommentsData.openComments || [];
                // Legacy path: use data from unreadCommentsQuery
                // Validate that the query was executed for the current page
                if (legacyQueryResult.variables?.pageId !== pageId) return [];
                const filteredNodes = legacyQueryResult.data?.comments?.nodes?.filter((node)=>node !== null) || [];
                if (filteredNodes.length === 0) return [];
                return filteredNodes;
            })();
            if (currentAllCommentsFromQuery.length === 0) {
                resetStates(); // we no longer need to create the set if there are no comments on the page
                return;
            }
            // Skip if renderer actions or editor annotations are for different page
            if (pageMode && (isRenderer && rendererActions && rendererPageId !== pageId || !isRenderer && annotations && editorPageId !== pageId)) return; // Wait for next rerender when rendererActions / annotations are updated for the current page
            const rendererAnnotations = rendererActions?.getAnnotationMarks() || [];
            const annotationsInEditorDoc = new Set(annotations || []);
            if (currentAllCommentsFromQuery.length < $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED) {
                const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
                const hasPageComments = currentAllCommentsFromQuery.some((comment)=>comment?.location?.type === 'FOOTER');
                // skip creating unread comments set if the page is archived
                // or if there are no page comments and inline comments
                if (isArchived || pageMode && !hasPageComments && (isRenderer && rendererAnnotations?.length === 0 || !isRenderer && annotationsInEditorDoc?.size === 0)) return;
                // continuing here means one of these 3 scenarios are true so we do want to check for unread comments
                // 1. no inline comments, yes page comments
                // 2. yes inline comments, no page comments
                // 3. yes inline comments, yes page comments
                const viewedComments = await getViewedCommentsFresh();
                if (viewedComments.success && viewedComments.data) (0, $e4kZB.createUnreadCommentsSet)({
                    allComments: currentAllCommentsFromQuery,
                    currentUserId: userId,
                    pageId: pageId,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    resetStates: resetStates,
                    viewedComments: viewedComments.data,
                    isDanglingCallback: isDanglingCallback,
                    addNewCommentThreads: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? undefined : addNewCommentThreads
                });
            }
        }
    }, [
        userId,
        isUpdatingUnreadComments,
        loading,
        pageId,
        pageMode,
        isRenderer,
        rendererActions,
        rendererPageId,
        annotations,
        editorPageId,
        legacyQueryResult.variables?.pageId,
        legacyQueryResult.data?.comments?.nodes,
        processedCommentsData.openComments,
        resetStates,
        contentStatus,
        getViewedCommentsFresh,
        updateUnreadCommentIDSet,
        isDanglingCallback,
        addNewCommentThreads
    ]);
    (0, $3bH25.useDanglingAndResolvedHandler)({
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
        commentsDataMap: commentsDataMap,
        userId: userId || '',
        pageId: pageId || '',
        isDanglingCallback: pageMode ? isDanglingCallback : undefined // use dangling callback if content type is a page
    });
    (0, $42omo.useEffect)(()=>{
        const isNotPageContentType = !pageContentTypeProps;
        if (isNotPageContentType && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) return;
        handleUpdateUnreadComments();
    }, [
        handleUpdateUnreadComments,
        rendererActions,
        annotations,
        pageContentTypeProps
    ]);
};
module.exports["useUnreadCommentsSetup"] = $2524304961e9b056$export$3c5a4187b7dbe412;

});

parcelRegister("hG1iq", function(module, exports) {
/**
 * @generated SignedSource<<348b49694886010e7026fa7c29d7df8c>>
 * @relayHash d39dbd59eb9fb721eb22ceae8c220866
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f388e03eec4876c6337191ddf420d23450f78db7d52b381220875c59f39116d
const $66270afabeec0762$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "inlineMarkerRef"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v7 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    }
                ],
                "type": "KnownUser"
            }
        ]
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v9 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "UNRESOLVED"
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "InlineCommentResolveProperties",
                                            "kind": "LinkedField",
                                            "name": "inlineResolveProperties",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDangling"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "InlineComment"
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "InlineCommentResolveProperties",
                                                    "kind": "LinkedField",
                                                    "name": "inlineResolveProperties",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "InlineComment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUnreadCommentsSetupQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUnreadCommentsSetupQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "d39dbd59eb9fb721eb22ceae8c220866",
            "id": "2f388e03eec4876c6337191ddf420d23450f78db7d52b381220875c59f39116d",
            "metadata": {},
            "name": "useUnreadCommentsSetupQuery",
            "operationKind": "query",
            "text": "query useUnreadCommentsSetupQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,type:UNRESOLVED,depth:ROOT){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved,isDangling}}},author{__typename,permissionType,...on KnownUser{accountId}},createdAt{value},replies{id,author{__typename,permissionType,...on KnownUser{accountId}},createdAt{value},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}}},totalCount}}"
        }
    };
}();
$66270afabeec0762$var$node.hash = "7519f4245d619aa0e9791a4d4979af13";
var $66270afabeec0762$export$2e2bcd8739ae039 = $66270afabeec0762$var$node;
module.exports["default"] = $66270afabeec0762$export$2e2bcd8739ae039;

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $eLFD2 = parcelRequire("eLFD2");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");





var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eLFD2.default);
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, whiteboard, and slide support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType)) return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $aXiya.default),
        fragmentSpec: (0, $aXiya.default)
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default)
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)($18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        }
    });
    // Helper function to process the query result
    const processQueryResult = (0, $42omo.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null && id !== undefined));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $42omo.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $42omo.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $42omo.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $42omo.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $42omo.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<1e46ee12c5990a431d6a0246c6d7de03>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<d9eb40e323bcab3039625e27c490b47c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("eLFD2", function(module, exports) {
/**
 * @generated SignedSource<<8ac926c77bbabbc7d4186c9c9df16f19>>
 * @relayHash 62839dc9a36eb801c9e817f5ebefa91f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65
const $61b7521c17137f8d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "ViewedComments",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewedComments",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "commentIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useViewedCommentsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useViewedCommentsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "62839dc9a36eb801c9e817f5ebefa91f",
            "id": "525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65",
            "metadata": {},
            "name": "useViewedCommentsQuery",
            "operationKind": "query",
            "text": "query useViewedCommentsQuery($contentId:ID!,$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId,contentType:$contentType){commentIds}}"
        }
    };
}();
$61b7521c17137f8d$var$node.hash = "3584bbc92d39d1aa58e2ff1c3396ad40";
var $61b7521c17137f8d$export$2e2bcd8739ae039 = $61b7521c17137f8d$var$node;
module.exports["default"] = $61b7521c17137f8d$export$2e2bcd8739ae039;

});

parcelRegister("9nXVV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $c1UWH = parcelRequire("c1UWH");


var $fHAwL = parcelRequire("fHAwL");


var $1czFr = parcelRequire("1czFr");


var $d3bcC = parcelRequire("d3bcC");

const $b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS = 1000;
const $b14365a28be63efb$export$d5d84acfffa9b3ca = ({ pageId: pageId, onCommentRead: onCommentRead })=>{
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead, flushPendingComments: flushPendingComments } = (0, $1czFr.useDebouncedMarkCommentsAsRead)($b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS);
    const { updateViewedCommentsCache: updateViewedCommentsCache } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const intersectionCallback = (0, $42omo.useCallback)((commentId)=>{
        if (commentId) {
            updateUnreadCommentIDSet(new Set([
                commentId
            ]), 'remove');
            debouncedMarkCommentsAsRead(commentId);
            updateViewedCommentsCache([
                commentId
            ]);
            if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) // Notify external systems about the comment being read (e.g. content types, whiteboards, databases)
            onCommentRead?.([
                commentId
            ]);
        }
    }, [
        updateUnreadCommentIDSet,
        debouncedMarkCommentsAsRead,
        updateViewedCommentsCache,
        onCommentRead
    ]);
    // Create refs to avoid stale closures in useEffect
    const intersectionCallbackRef = (0, $42omo.useRef)(intersectionCallback);
    intersectionCallbackRef.current = intersectionCallback;
    const flushPendingCommentsRef = (0, $42omo.useRef)(flushPendingComments);
    flushPendingCommentsRef.current = flushPendingComments;
    (0, $42omo.useEffect)(()=>{
        if (!pageId) return;
        const observer = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
        observer.registerIntersectionCallback((commentId)=>{
            intersectionCallbackRef.current(commentId);
        });
        return ()=>{
            observer.disconnect();
            flushPendingCommentsRef.current();
        };
    }, [
        pageId
    ]);
};
module.exports["useUnreadCommentsObserverSetup"] = $b14365a28be63efb$export$d5d84acfffa9b3ca;

});

parcelRegister("c1UWH", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

class $992a1265dc051ead$var$UnreadCommentsIntersectionObserver {
    createObserver() {
        try {
            if (typeof IntersectionObserver === 'undefined') return;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const commentId = entry.target.getAttribute('data-comment-id');
                    if (!commentId) return;
                    if (entry.isIntersecting) {
                        // Comment became visible - set new timer for this specific comment
                        const timer = setTimeout(()=>{
                            this.intersectionCallbacks.forEach((callback)=>{
                                callback(commentId);
                            });
                            // Clear the timer for this comment
                            this.commentTimersMap.delete(commentId);
                            // Unobserve this element since it's been processed
                            if (this.observer && typeof this.observer.unobserve === 'function') {
                                this.observer.unobserve(entry.target);
                                this.observedElementsSet.delete(entry.target);
                            }
                        }, 2000); // 2 seconds default
                        this.commentTimersMap.set(commentId, timer);
                    } else // Comment became invisible - clear timer for this comment
                    if (this.commentTimersMap.has(commentId)) {
                        clearTimeout(this.commentTimersMap.get(commentId));
                        this.commentTimersMap.delete(commentId);
                    }
                });
            }, {
                threshold: [
                    0.25
                ],
                // add a bottom root margin to account for sticky elements at the bottom of the observable viewport such as the sticky footer
                // this is because the intersection observer doesn't know about elements that are above the observed comments, and so we can avoid
                // marking comments as read when they're not actually visible to the user. this is a best effort approach
                rootMargin: '0px 0px -65px 0px',
                // Add a custom name to identify this as the unread comments observer
                // This helps in tests to distinguish it from other intersection observers
                name: 'unreadCommentsObserver'
            });
            // Only set observer if it has the required methods
            if (observer && typeof observer.disconnect === 'function' && typeof observer.observe === 'function' && typeof observer.unobserve === 'function') this.observer = observer;
            else this.observer = null;
        } catch  {
            this.observer = null;
        }
    }
    observeComment(targetElement) {
        // don't observe if the observer is not initialized
        if (!this.observer) return;
        // don't observe if the targetElement is not a valid element
        if (!targetElement) return;
        // don't observe the same element twice
        if (this.observedElementsSet.has(targetElement)) return;
        this.observer.observe(targetElement);
        this.observedElementsSet.add(targetElement);
    }
    unobserveComment(targetElement) {
        // don't unobserve if the observer is not initialized
        if (!this.observer) return;
        // don't unobserve if the targetElement is not a valid element
        if (!targetElement) return;
        // only unobserve if we're actually observing this element
        if (!this.observedElementsSet.has(targetElement)) return;
        // Clear any running timer for this comment
        const commentId = targetElement.getAttribute('data-comment-id');
        if (commentId && this.commentTimersMap.has(commentId)) {
            clearTimeout(this.commentTimersMap.get(commentId));
            this.commentTimersMap.delete(commentId);
        }
        this.observer.unobserve(targetElement);
        this.observedElementsSet.delete(targetElement);
    }
    // By exposing this function, we allow consumers to register callbacks
    registerIntersectionCallback(callback) {
        this.intersectionCallbacks.push(callback);
    }
    // Reconnect the observer if it was disconnected
    reconnect() {
        if (!this.observer) this.createObserver();
    }
    // Clean up method
    disconnect() {
        if (this.observer && typeof this.observer.disconnect === 'function') {
            this.observer.disconnect();
            this.observer = null;
        }
        // Clear all timers
        this.commentTimersMap.forEach((timer)=>clearTimeout(timer));
        this.commentTimersMap.clear();
        // Clear observed elements
        this.observedElementsSet.clear();
        // Clear callbacks
        this.intersectionCallbacks = [];
    }
    constructor(){
        this.observer = null;
        this.commentTimersMap = new Map();
        this.observedElementsSet = new Set();
        this.intersectionCallbacks = [];
        this.createObserver();
    }
}
// memoize ensures an IntersectionObserver is instantiated only once
const $992a1265dc051ead$var$getStableIntersectionObserver = (0, $2XqLN.default)(()=>{
    return new $992a1265dc051ead$var$UnreadCommentsIntersectionObserver();
});
const $992a1265dc051ead$export$ad65f5516d9692ed = ()=>{
    const intersectionObserver = $992a1265dc051ead$var$getStableIntersectionObserver();
    intersectionObserver.reconnect();
    return intersectionObserver;
};
module.exports["getUnreadCommentsIntersectionObserver"] = $992a1265dc051ead$export$ad65f5516d9692ed;

});

parcelRegister("1czFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gi0WF = parcelRequire("gi0WF");

const $e63c8ea486e09ced$export$faaf0da9552bb131 = (debounceMs = 1000)=>{
    const markCommentsAsRead = (0, $gi0WF.useMarkCommentsAsRead)();
    const pendingCommentIds = (0, $42omo.useRef)(new Set());
    const timeoutRef = (0, $42omo.useRef)(null);
    const beforeUnloadHandlerRef = (0, $42omo.useRef)(null);
    const debouncedMarkCommentsAsRead = (0, $42omo.useCallback)((commentId)=>{
        // Add the comment ID to the pending set
        pendingCommentIds.current.add(commentId);
        // Clear any existing timeout
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        // Set a new timeout to batch and send the request
        timeoutRef.current = setTimeout(()=>{
            const commentIdsToMark = Array.from(pendingCommentIds.current);
            // Clear the pending set
            pendingCommentIds.current.clear();
            // Reset the timeout ref
            timeoutRef.current = null;
            // Only call the mutation if there are comments to mark
            if (commentIdsToMark.length > 0) markCommentsAsRead(commentIdsToMark);
        }, debounceMs);
    }, [
        markCommentsAsRead,
        debounceMs
    ]);
    // Function to send pending comment IDs
    const sendPendingComments = (0, $42omo.useCallback)(()=>{
        const commentIdsToMark = Array.from(pendingCommentIds.current);
        if (commentIdsToMark.length === 0) return;
        // Clear the pending set
        pendingCommentIds.current.clear();
        // Just call the existing mutation function
        markCommentsAsRead(commentIdsToMark);
    }, [
        markCommentsAsRead
    ]);
    // Beforeunload event handler (e.g. when the user closes the tab or window)
    const handleBeforeUnload = (0, $42omo.useCallback)((_event)=>{
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    // Set up beforeunload event listener
    (0, $42omo.useEffect)(()=>{
        beforeUnloadHandlerRef.current = handleBeforeUnload;
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        handleBeforeUnload
    ]);
    // Flush pending comments and clear timeout
    const flushPendingComments = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // Send any pending comments
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    return {
        debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead,
        flushPendingComments: flushPendingComments
    };
};
module.exports["useDebouncedMarkCommentsAsRead"] = $e63c8ea486e09ced$export$faaf0da9552bb131;

});

parcelRegister("gi0WF", function(module, exports) {

var $8rdFk = parcelRequire("8rdFk");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bMmYR = parcelRequire("bMmYR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

const $170c9bba7ed44542$var$markCommentsAsReadMutation = (0, $8rdFk.default);
const $170c9bba7ed44542$export$db614d7d47784b95 = ()=>{
    const [markCommentsAsRead] = (0, $308Wd.useMutationInterop)($170c9bba7ed44542$var$markCommentsAsReadMutation);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const markCommentsAsReadFn = (0, $42omo.useCallback)(async (commentIds)=>{
        if (commentIds.length === 0) return;
        // Start experience tracking for marking comments as read
        experienceTracker.start({
            name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
            attributes: {
                commentIds: commentIds,
                commentCount: commentIds.length
            }
        });
        let attemptNumber = 1;
        try {
            const result = await (0, $bMmYR.retry)(async (attempt)=>{
                attemptNumber = attempt + 1;
                return await markCommentsAsRead({
                    variables: {
                        commentIds: commentIds
                    }
                });
            }, {}, async (error)=>{
                // Don't retry for expected errors (403/unauthorized, network errors)
                return !(0, $1uFM6.isUnauthorizedError)(error) && !(0, $6fil2.containsNetworkError)(error);
            });
            // Check if the mutation succeeded
            if (result?.data?.markCommentsAsRead?.success) // Mark experience as successful
            experienceTracker.succeed({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                attributes: {
                    commentIds: commentIds,
                    commentCount: commentIds.length,
                    attemptNumber: attemptNumber
                }
            });
            else // Backend returned success: false
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: new Error('Backend returned success: false'),
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
        } catch (err) {
            // Handle expected errors (403/unauthorized, network errors) - abort experience tracking
            if ((0, $1uFM6.isUnauthorizedError)(err) || (0, $6fil2.containsNetworkError)(err)) {
                experienceTracker.abort({
                    name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                    reason: 'Expected error (unauthorized or network error)'
                });
                (0, $7Sm4c.markErrorAsHandled)(err);
                return;
            }
            // Mark experience as failed for unexpected errors
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: err,
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
            // Handle unexpected errors (including 500) - track them with context
            (0, $fJlJm.setContentErrorAttributes)(err, {
                objectType: 'comment'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(err);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- experienceTracker from context doesn't need to be in deps
    [
        markCommentsAsRead
    ]);
    return markCommentsAsReadFn;
};
module.exports["useMarkCommentsAsRead"] = $170c9bba7ed44542$export$db614d7d47784b95;

});

parcelRegister("8rdFk", function(module, exports) {
/**
 * @generated SignedSource<<9a8e6f055ec02e2d99edf35fde311932>>
 * @relayHash 446a6fa3fbbe8bbb4444e858a1c7626c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14
const $4a78b10481ac8443$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "commentIds",
                            "variableName": "commentIds"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MarkCommentsAsReadPayload",
            "kind": "LinkedField",
            "name": "markCommentsAsRead",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "kind": "ScalarField",
                    "name": "errors"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMarkCommentsAsReadMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMarkCommentsAsReadMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "446a6fa3fbbe8bbb4444e858a1c7626c",
            "id": "2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14",
            "metadata": {},
            "name": "useMarkCommentsAsReadMutation",
            "operationKind": "mutation",
            "text": "mutation useMarkCommentsAsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success,errors}}"
        }
    };
}();
$4a78b10481ac8443$var$node.hash = "d155280f920b93703b5ae452997bdcaf";
var $4a78b10481ac8443$export$2e2bcd8739ae039 = $4a78b10481ac8443$var$node;
module.exports["default"] = $4a78b10481ac8443$export$2e2bcd8739ae039;

});

parcelRegister("3bH25", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $42omo = parcelRequire("42omo");


var $aUU0C = parcelRequire("aUU0C");


var $8WQTF = parcelRequire("8WQTF");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $e4kZB = parcelRequire("e4kZB");

const $280745ffe1b8b376$export$30b625574e8a38c7 = ({ pageMode: pageMode })=>{
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations } = editorAnnotationsState;
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions } = rendererActionsResult || {};
    const isDanglingCallback = (0, $42omo.useCallback)((markerRef)=>{
        if (!pageMode) return false;
        return (0, $e4kZB.commentIsDangling)({
            pageMode: pageMode,
            annotationsInEditorDoc: new Set(annotations),
            rendererAnnotations: new Set(rendererActions?.getAnnotationMarks()?.map((ann)=>ann.attrs.id).filter(Boolean) || [])
        })(markerRef);
    }, [
        annotations,
        rendererActions,
        pageMode
    ]);
    return {
        isDanglingCallback: isDanglingCallback
    };
};
// Helper function to process added annotations (reopened / undangled)
const $280745ffe1b8b376$var$processAddedAnnotations = ({ currentList: currentList, previousThreadKeys: previousThreadKeys, commentsDataMap: commentsDataMap, viewedComments: viewedComments, userId: userId, isDanglingCallback: isDanglingCallback })=>{
    const addedCommentIds = new Set();
    for (const annotation of currentList)if (!previousThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Early return if comment is already viewed
            if (viewedComments.has(commentData.id)) return addedCommentIds;
            // Add the main comment ID if it's a valid unread comment
            if ((0, $e4kZB.isValidUnreadComment)({
                comment: commentData,
                currentUserId: userId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) addedCommentIds.add(commentData.id);
            // Add all reply IDs if they're valid unread comments
            commentData.replies?.forEach((reply)=>{
                if (reply) {
                    // Skip if reply is already viewed
                    if (viewedComments.has(reply.id)) return;
                    if ((0, $e4kZB.isValidUnreadComment)({
                        comment: reply,
                        currentUserId: userId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) addedCommentIds.add(reply.id);
                }
            });
        }
    }
    return addedCommentIds;
};
// Helper function to process removed annotations (resolved / dangled)
const $280745ffe1b8b376$var$processRemovedAnnotations = ({ previousList: previousList, currentThreadKeys: currentThreadKeys, commentsDataMap: commentsDataMap })=>{
    const removedCommentIds = new Set();
    for (const annotation of previousList)if (!currentThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Add the main comment ID
            removedCommentIds.add(commentData.id);
            // Add all reply IDs
            commentData.replies?.forEach((reply)=>{
                if (reply) removedCommentIds.add(reply.id);
            });
        }
    }
    return removedCommentIds;
};
const $280745ffe1b8b376$export$ce2ddc24e5a132d = ({ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, userId: userId, pageId: pageId, isDanglingCallback: isDanglingCallback })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { updateUnreadCommentIDSet: updateUnreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: pageId
    });
    // Keep track of the previous orderedActiveAnnotationIdList
    const previousOrderedActiveAnnotationIdListRef = (0, $42omo.useRef)(orderedActiveAnnotationIdList);
    // Handle the async getViewedComments call
    const processAnnotations = (0, $42omo.useCallback)(async ()=>{
        const previousList = previousOrderedActiveAnnotationIdListRef.current;
        const currentList = orderedActiveAnnotationIdList;
        // Early exit if lists are identical (same length)
        if (previousList.length === currentList.length) return;
        // Build thread key sets for processing
        const previousThreadKeys = new Set(previousList.map((annotation)=>annotation.threadKey));
        const currentThreadKeys = new Set(currentList.map((annotation)=>annotation.threadKey));
        const viewedCommentsResult = getViewedCommentsCacheOnly();
        if (!viewedCommentsResult.success || !viewedCommentsResult.data) return;
        const viewedComments = viewedCommentsResult.data;
        // Process added annotations (reopened / undangled)
        const addedCommentIds = $280745ffe1b8b376$var$processAddedAnnotations({
            currentList: currentList,
            previousThreadKeys: previousThreadKeys,
            commentsDataMap: commentsDataMap,
            viewedComments: viewedComments,
            userId: userId,
            isDanglingCallback: isDanglingCallback
        });
        // Process removed annotations (resolved / dangled)
        const removedCommentIds = $280745ffe1b8b376$var$processRemovedAnnotations({
            previousList: previousList,
            currentThreadKeys: currentThreadKeys,
            commentsDataMap: commentsDataMap
        });
        // Update unread comment ID set for added annotations
        if (addedCommentIds.size > 0) updateUnreadCommentIDSet(addedCommentIds, 'add');
        // Update unread comment ID set for removed annotations
        if (removedCommentIds.size > 0) updateUnreadCommentIDSet(removedCommentIds, 'remove');
        // Update the previous list ref to current list for next comparison
        previousOrderedActiveAnnotationIdListRef.current = currentList;
    }, [
        orderedActiveAnnotationIdList,
        commentsDataMap,
        userId,
        isDanglingCallback,
        getViewedCommentsCacheOnly,
        updateUnreadCommentIDSet
    ]);
    (0, $42omo.useEffect)(()=>{
        // skip entirely if:
        // - feature flag is disabled
        // - isDanglingCallback check is not enabled
        // - isUpdatingUnreadComments being true means the unread query and viewed comments query are not complete yet, which means we shouldn't process the annotations yet
        if (!isDanglingCallback || isUpdatingUnreadComments) return;
        processAnnotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude commentsDataMap because we don't need to rerun this hook when it changes
    }, [
        processAnnotations,
        isUpdatingUnreadComments
    ]);
};
module.exports["useIsDanglingCallback"] = $280745ffe1b8b376$export$30b625574e8a38c7;
module.exports["useDanglingAndResolvedHandler"] = $280745ffe1b8b376$export$ce2ddc24e5a132d;

});

parcelRegister("e4kZB", function(module, exports) {
const $5243889752facbc2$export$446c7c25f5f55821 = (comment)=>{
    return {
        id: comment.id,
        author: {
            accountId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined
        },
        createdAt: {
            value: comment.createdAt?.value || ''
        },
        location: {
            type: comment.location.type,
            inlineMarkerRef: comment.location?.inlineMarkerRef,
            inlineResolveProperties: comment.location?.inlineResolveProperties,
            commentResolveProperties: comment.location?.commentResolveProperties
        }
    };
};
const $5243889752facbc2$export$77349abd6de54bd8 = ({ commentId: commentId, userId: userId, createdAt: createdAt, commentType: commentType, resolveProperties: resolveProperties })=>{
    return {
        id: commentId,
        author: {
            accountId: userId || undefined
        },
        createdAt: {
            value: createdAt || ''
        },
        location: {
            type: commentType,
            ...commentType === 'INLINE' ? {
                inlineResolveProperties: resolveProperties || {
                    resolved: false
                }
            } : {
                commentResolveProperties: resolveProperties || {
                    resolved: false
                }
            }
        }
    };
};
const $5243889752facbc2$export$8df0b6c8bcdda615 = ({ pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc, rendererAnnotations: rendererAnnotations })=>(markerRef)=>{
        if (!markerRef) return false; // default to false if no marker ref
        // Treat 'live' mode as 'edit' mode
        const effectivePageMode = pageMode === 'live' ? 'edit' : pageMode;
        return effectivePageMode === 'view' ? !rendererAnnotations.has(markerRef) : !annotationsInEditorDoc.has(markerRef);
    };
const $5243889752facbc2$export$22ce26f7ba09f326 = ({ comment: comment, currentUserId: currentUserId, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    // Early return if comment is already viewed
    if (viewedComments.has(comment.id)) return false;
    const isNotOwnComment = comment.author?.accountId && comment.author.accountId !== currentUserId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const commentLocation = comment?.location;
    const markerRef = commentLocation?.inlineMarkerRef;
    const isDanglingInlineComment = isDanglingCallback ? isDanglingCallback(markerRef) : false;
    const isPageComment = comment?.location.type === 'FOOTER';
    const isResolved = comment?.location?.inlineResolveProperties?.resolved || comment?.location?.commentResolveProperties?.resolved;
    return !isResolved && isNotOwnComment && createdLast30Days && (!isDanglingInlineComment || isPageComment);
};
const $5243889752facbc2$export$92c1e243fe45a57f = async ({ allComments: allComments, currentUserId: currentUserId, pageId: pageId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, resetStates: resetStates, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback, addNewCommentThreads: addNewCommentThreads })=>{
    if (!allComments || !pageId) return;
    const unreadCommentIds = new Set();
    // keep track inline comment threads so we can prepopulate comments data map in order to keep track of dangling and resolved comments for unread
    const inlineCommentThreadsToAdd = {};
    allComments.forEach((comment)=>{
        if (!comment) return;
        if (comment.location.type === 'INLINE') {
            const commentLocation = comment.location;
            const threadKey = commentLocation?.inlineMarkerRef;
            if (threadKey) // Our query only returns open comments, so we need to set the isOpen status to true
            inlineCommentThreadsToAdd[threadKey] = {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false
            };
        }
        if (currentUserId) {
            const parentCommentForValidation = $5243889752facbc2$export$446c7c25f5f55821(comment);
            if ($5243889752facbc2$export$22ce26f7ba09f326({
                comment: parentCommentForValidation,
                currentUserId: currentUserId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) unreadCommentIds.add(comment.id);
            if (comment.replies) comment.replies.forEach((reply)=>{
                if (reply) {
                    const replyForValidation = $5243889752facbc2$export$446c7c25f5f55821(reply);
                    if ($5243889752facbc2$export$22ce26f7ba09f326({
                        comment: replyForValidation,
                        currentUserId: currentUserId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) unreadCommentIds.add(reply.id);
                }
            });
        }
    });
    updateUnreadCommentIDSet(unreadCommentIds, 'initialize');
    // Add the comment threads for inline comments at the end
    addNewCommentThreads && addNewCommentThreads({
        inline: inlineCommentThreadsToAdd,
        general: {}
    });
    // Once we are done updating the unread list, need to reset the states.
    resetStates();
};
module.exports["buildValidationObjectFromProps"] = $5243889752facbc2$export$77349abd6de54bd8;
module.exports["commentIsDangling"] = $5243889752facbc2$export$8df0b6c8bcdda615;
module.exports["isValidUnreadComment"] = $5243889752facbc2$export$22ce26f7ba09f326;
module.exports["createUnreadCommentsSet"] = $5243889752facbc2$export$92c1e243fe45a57f;

});

parcelRegister("9SEzS", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $6771fdd733157350$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
var $6771fdd733157350$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["GraphQLContentStatus"] = $6771fdd733157350$export$b634e5de755b7d35;

});

parcelRegister("cHANb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cWr0H = parcelRequire("cWr0H");


var $dh538 = parcelRequire("dh538");


var $jOIil = parcelRequire("jOIil");

const $9ab2866fb2a1e6e3$var$ACTIONED_EVENT_DELAY = 10000;
const $9ab2866fb2a1e6e3$var$AI_GENERATED_TITLE_CHANGE_PERCENTAGE_THRESHOLD = 50;
const $9ab2866fb2a1e6e3$export$ff041132f32feaf3 = ({ enabled: enabled, title: title, handleNewTitle: handleNewTitle, canFireUnifiedAIAnalyticsEvent: canFireUnifiedAIAnalyticsEvent })=>{
    const canFireActionedEvent = canFireUnifiedAIAnalyticsEvent && (0, $dh538.fg)('platform_editor_ai_suggest_title_actioned_event');
    const currentTitleRef = (0, $42omo.useRef)(title);
    (0, $42omo.useEffect)(()=>{
        currentTitleRef.current = title;
    }, [
        title
    ]);
    const currentAnalyticsEventDataRef = (0, $42omo.useRef)(null);
    const fireAnalyticEvent = (0, $42omo.useCallback)((currentTitle)=>{
        if (!canFireActionedEvent) return;
        if (currentAnalyticsEventDataRef.current && currentAnalyticsEventDataRef.current.isFinal) {
            const titleChangePercentage = $9ab2866fb2a1e6e3$export$1c6b9baa0047190(currentAnalyticsEventDataRef.current.aiGeneratingTitle, currentTitle);
            if (titleChangePercentage < $9ab2866fb2a1e6e3$var$AI_GENERATED_TITLE_CHANGE_PERCENTAGE_THRESHOLD) currentAnalyticsEventDataRef.current.fireUnifiedAnalyticsEvent('actioned');
            else currentAnalyticsEventDataRef.current.fireUnifiedAnalyticsEvent('discarded');
            // currentAnalyticsEventDataRef.current to null to avoid duplicate events.
            currentAnalyticsEventDataRef.current = null;
        }
    }, [
        canFireActionedEvent
    ]);
    const currentTimerIdRef = (0, $42omo.useRef)(undefined);
    const createTimerToFireActionedEvent = (0, $42omo.useCallback)(()=>{
        if (currentTimerIdRef.current) window.clearTimeout(currentTimerIdRef.current);
        currentTimerIdRef.current = window.setTimeout(()=>{
            fireAnalyticEvent(currentTitleRef.current);
        }, $9ab2866fb2a1e6e3$var$ACTIONED_EVENT_DELAY);
    }, [
        fireAnalyticEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!enabled) return;
        const { unsubscribe: unsubscribe } = (0, $jOIil.eventHub).subscribe({
            event: 'replace title in confluence',
            callback: (data)=>{
                const aiGeneratingTitle = data.title;
                if (canFireActionedEvent && data.isFinal !== undefined && data.fireUnifiedAnalyticsEvent) {
                    /**
					 * This callback is called multiple times, for single replace title event
					 * 	because of streaming api.
					 *
					 * So if only currentTimerIdRef.current is not undefined,
					 * 	that means user has clicked on suggest title button again
					 * 	within ACTIONED_EVENT_DELAY.
					 *
					 * That means user didn't like previously generated title,
					 * 	so we will pass empty string, so that dismissed event is fired.
					 */ if (currentTimerIdRef.current) {
                        fireAnalyticEvent('');
                        window.clearTimeout(currentTimerIdRef.current);
                        currentTimerIdRef.current = undefined;
                    }
                    currentAnalyticsEventDataRef.current = {
                        aiGeneratingTitle: aiGeneratingTitle,
                        isFinal: data.isFinal,
                        fireUnifiedAnalyticsEvent: data.fireUnifiedAnalyticsEvent
                    };
                    // When final stream arrives, we will set timer to fire actioned/dismissed event.
                    if (data.isFinal) createTimerToFireActionedEvent();
                }
                handleNewTitle(aiGeneratingTitle);
            }
        });
        return ()=>{
            unsubscribe();
            window.clearTimeout(currentTimerIdRef.current);
        };
    }, [
        createTimerToFireActionedEvent,
        enabled,
        fireAnalyticEvent,
        handleNewTitle,
        canFireActionedEvent
    ]);
};
const $9ab2866fb2a1e6e3$export$1c6b9baa0047190 = (aiGeneratedTitle, currentTitle)=>{
    if (aiGeneratedTitle.length === 0) return 0;
    const distance = (0, $cWr0H.distance)(aiGeneratedTitle, currentTitle);
    return distance / aiGeneratedTitle.length * 100;
};
module.exports["useEditorAIReplacingTitle"] = $9ab2866fb2a1e6e3$export$ff041132f32feaf3;

});

parcelRegister("cWr0H", function(module, exports) {
const $96bfda78fc7e8630$var$peq = new Uint32Array(0x10000);
const $96bfda78fc7e8630$var$myers_32 = (a, b)=>{
    const n = a.length;
    const m = b.length;
    const lst = 1 << n - 1;
    let pv = -1;
    let mv = 0;
    let sc = n;
    let i = n;
    while(i--)$96bfda78fc7e8630$var$peq[a.charCodeAt(i)] |= 1 << i;
    for(i = 0; i < m; i++){
        let eq = $96bfda78fc7e8630$var$peq[b.charCodeAt(i)];
        const xv = eq | mv;
        eq |= (eq & pv) + pv ^ pv;
        mv |= ~(eq | pv);
        pv &= eq;
        if (mv & lst) sc++;
        if (pv & lst) sc--;
        mv = mv << 1 | 1;
        pv = pv << 1 | ~(xv | mv);
        mv &= xv;
    }
    i = n;
    while(i--)$96bfda78fc7e8630$var$peq[a.charCodeAt(i)] = 0;
    return sc;
};
const $96bfda78fc7e8630$var$myers_x = (b, a)=>{
    const n = a.length;
    const m = b.length;
    const mhc = [];
    const phc = [];
    const hsize = Math.ceil(n / 32);
    const vsize = Math.ceil(m / 32);
    for(let i = 0; i < hsize; i++){
        phc[i] = -1;
        mhc[i] = 0;
    }
    let j = 0;
    for(; j < vsize - 1; j++){
        let mv = 0;
        let pv = -1;
        const start = j * 32;
        const vlen = Math.min(32, m) + start;
        for(let k = start; k < vlen; k++)$96bfda78fc7e8630$var$peq[b.charCodeAt(k)] |= 1 << k;
        for(let i = 0; i < n; i++){
            const eq = $96bfda78fc7e8630$var$peq[a.charCodeAt(i)];
            const pb = phc[i / 32 | 0] >>> i & 1;
            const mb = mhc[i / 32 | 0] >>> i & 1;
            const xv = eq | mv;
            const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
            let ph = mv | ~(xh | pv);
            let mh = pv & xh;
            if (ph >>> 31 ^ pb) phc[i / 32 | 0] ^= 1 << i;
            if (mh >>> 31 ^ mb) mhc[i / 32 | 0] ^= 1 << i;
            ph = ph << 1 | pb;
            mh = mh << 1 | mb;
            pv = mh | ~(xv | ph);
            mv = ph & xv;
        }
        for(let k = start; k < vlen; k++)$96bfda78fc7e8630$var$peq[b.charCodeAt(k)] = 0;
    }
    let mv = 0;
    let pv = -1;
    const start = j * 32;
    const vlen = Math.min(32, m - start) + start;
    for(let k = start; k < vlen; k++)$96bfda78fc7e8630$var$peq[b.charCodeAt(k)] |= 1 << k;
    let score = m;
    for(let i = 0; i < n; i++){
        const eq = $96bfda78fc7e8630$var$peq[a.charCodeAt(i)];
        const pb = phc[i / 32 | 0] >>> i & 1;
        const mb = mhc[i / 32 | 0] >>> i & 1;
        const xv = eq | mv;
        const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
        let ph = mv | ~(xh | pv);
        let mh = pv & xh;
        score += ph >>> m - 1 & 1;
        score -= mh >>> m - 1 & 1;
        if (ph >>> 31 ^ pb) phc[i / 32 | 0] ^= 1 << i;
        if (mh >>> 31 ^ mb) mhc[i / 32 | 0] ^= 1 << i;
        ph = ph << 1 | pb;
        mh = mh << 1 | mb;
        pv = mh | ~(xv | ph);
        mv = ph & xv;
    }
    for(let k = start; k < vlen; k++)$96bfda78fc7e8630$var$peq[b.charCodeAt(k)] = 0;
    return score;
};
const $96bfda78fc7e8630$export$9f17032d917177de = (a, b)=>{
    if (a.length < b.length) {
        const tmp = b;
        b = a;
        a = tmp;
    }
    if (b.length === 0) return a.length;
    if (a.length <= 32) return $96bfda78fc7e8630$var$myers_32(a, b);
    return $96bfda78fc7e8630$var$myers_x(a, b);
};
const $96bfda78fc7e8630$export$ff7f7c97cdce86e = (str, arr)=>{
    let min_distance = Infinity;
    let min_index = 0;
    for(let i = 0; i < arr.length; i++){
        const dist = $96bfda78fc7e8630$export$9f17032d917177de(str, arr[i]);
        if (dist < min_distance) {
            min_distance = dist;
            min_index = i;
        }
    }
    return arr[min_index];
};
module.exports["distance"] = $96bfda78fc7e8630$export$9f17032d917177de;
module.exports["closest"] = $96bfda78fc7e8630$export$ff7f7c97cdce86e;

});

parcelRegister("jOIil", function(module, exports) {
class $3057f4cb0fd3db76$var$EventHub {
    /**
   * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
   *
   * @param {object} params - The subscription parameters.
   * @param {T} params.event - The name of the event to subscribe to.
   * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
   * It receives the event data as its parameter.
   * @returns {object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
   *
   * @example
   * // Subscribing to an event
   * const subscription = eventHub.subscribe({
   *   event: 'start prompt',
   *   callback: (data) => {
   *     console.log('Received start prompt event:', data);
   *   },
   * });
   *
   * // Later, to unsubscribe
   * subscription.unsubscribe();
   */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
   * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event to the editor
   * eventHub.publishToEditor({
   *   event: 'start prompt',
   *   data: {
   *     prompt: 'issue reformatter',
   *     targetEditorId,
   *     analyticSourceId: 'jiraIssueReformatterExternalButton',
   *   },
   * });
   */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
   * Publishes an event originating from the editor, invoking all registered subscribers for that event.
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event from the editor
   * eventHub.publishFromEditor({
   *   event: 'replace title in confluence',
   *   data: {
   *     analyticSourceId: 'confluenceTitleToolbar',
   *     sourceEditorId,
   *     title: textContent,
   *   },
   * });
   */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
}
const $3057f4cb0fd3db76$export$e17a52e5da72c4cb = new $3057f4cb0fd3db76$var$EventHub();
module.exports["eventHub"] = $3057f4cb0fd3db76$export$e17a52e5da72c4cb;

});

parcelRegister("202oG", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $h9yJL.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("iwNka", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7zgzO = parcelRequire("7zgzO");


var $fFk4O = parcelRequire("fFk4O");

const $54ae78ae571a596a$export$1a20dd7f74852e6b = ()=>{
    // Linter is forcing us to use getHref instead of window.location.href to retrieve href and it isn't the full href - it doesn't include origin
    const { getHref: getHref } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    (0, $42omo.useEffect)(()=>{
        // https://atlassian.slack.com/archives/C0131PNA4GL/p1723738281832269
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ('setCaptureHandleConfig' in (navigator?.mediaDevices ?? {})) {
            const href = getHref();
            (0, $fFk4O.appendGoogleMeetScreenSharingScript)(href);
        }
    // Only execute on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
module.exports["useExposeGoogleMeetScreenShare"] = $54ae78ae571a596a$export$1a20dd7f74852e6b;

});

parcelRegister("fFk4O", function(module, exports) {

var $9ICY6 = parcelRequire("9ICY6");

const $1cd0e9177e768135$export$449f0d0bb2c2424b = 'https://www.gstatic.com/meetjs/addons/1.1.0/meet.addons.js';
const $1cd0e9177e768135$export$8ea5dba186347383 = (href)=>{
    // Create script
    const script = document.createElement('script');
    script.src = $1cd0e9177e768135$export$449f0d0bb2c2424b;
    script.async = true;
    // When script is done loading, run the Google Meet screenshare method
    script.onload = ()=>{
        (0, $9ICY6.exposeToMeetWhenScreensharing)(href);
    };
    // Add script to DOM
    document.head.appendChild(script);
};
module.exports["appendGoogleMeetScreenSharingScript"] = $1cd0e9177e768135$export$8ea5dba186347383;

});

parcelRegister("9ICY6", function(module, exports) {

var $hwNSM = parcelRequire("hwNSM");

var $f29836a0ec4c93d3$export$eab8e91f09e6d84a = /*#__PURE__*/ function(ProjectNumber) {
    ProjectNumber["staging"] = "1017113233545";
    ProjectNumber["production"] = "118174936708";
    return ProjectNumber;
}({});
var $f29836a0ec4c93d3$export$73691bb86ec75a9 = /*#__PURE__*/ function(Hostname) {
    Hostname["staging"] = "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    Hostname["production"] = "cc-embedded-pages-integ.atlassian.com";
    return Hostname;
}({});
const $f29836a0ec4c93d3$export$8446085e93adc95b = (hostname, queryParams)=>`https://${hostname}/google-meet/page?${queryParams}`;
const $f29836a0ec4c93d3$export$7973aed45b22124c = (href)=>{
    const buildUrl = `${window.location.origin}${href}`;
    const parsedURL = (0, $hwNSM.parseUrl)(buildUrl) ?? {};
    return new URLSearchParams(parsedURL).toString();
};
const $f29836a0ec4c93d3$export$88041f03017aa037 = (href)=>{
    const currentEnv = "production";
    // Create the correct query params for the main stage url - based on confluence embedded page
    const queryParams = $f29836a0ec4c93d3$export$7973aed45b22124c(href);
    // Grab hardcoded hostname and project number based on current env
    const hostname = $f29836a0ec4c93d3$export$73691bb86ec75a9[currentEnv] ?? "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    const cloudProjectNumber = $f29836a0ec4c93d3$export$eab8e91f09e6d84a[currentEnv] ?? "1017113233545";
    // Fire the Google add-on method to allow promotion and add-on use when screensharing
    // startActivityOnOpen needs to be set to true as long as we use mainstageUrl
    // See docs for additional info: https://developers.google.com/meet/add-ons/reference/websdk/screenshare_api.addonscreenshareinfo.startactivityonopen
    window?.meet?.addon?.screensharing?.exposeToMeetWhenScreensharing({
        cloudProjectNumber: cloudProjectNumber,
        startActivityOnOpen: true,
        mainStageUrl: $f29836a0ec4c93d3$export$8446085e93adc95b(hostname, queryParams)
    });
};
module.exports["exposeToMeetWhenScreensharing"] = $f29836a0ec4c93d3$export$88041f03017aa037;

});

parcelRegister("7oCdN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2FNjD = parcelRequire("2FNjD");


var $aXWIB = parcelRequire("aXWIB");


var $1xywh = parcelRequire("1xywh");


var $iEYBu = parcelRequire("iEYBu");


var $bHWAG = parcelRequire("bHWAG");

const $3b7fa3742d344605$var$TARGET_SELECTOR = '#AkMainContent';
const $3b7fa3742d344605$var$COVER_ID = 'print-cover-page';
const $3b7fa3742d344605$var$STYLE_DATA_ATTR = 'data-print-cover-style';
function $3b7fa3742d344605$var$ensurePrintStyles() {
    if (typeof document === 'undefined') return;
    if (document.head.querySelector(`style[${$3b7fa3742d344605$var$STYLE_DATA_ATTR}="true"]`)) return;
    const style = document.createElement('style');
    style.setAttribute($3b7fa3742d344605$var$STYLE_DATA_ATTR, 'true');
    style.textContent = `
				/* Hidden on screen; visible when printing */
				#${$3b7fa3742d344605$var$COVER_ID} { display: none; }

				@media print {
				#${$3b7fa3742d344605$var$COVER_ID} {
					display: block !important;
					break-after: page;        /* modern */
					page-break-after: always; /* legacy */
				}
					
				/* Hide only the layout header when printing */
					header[data-layout-slot="true"] {
						display: none !important;
						visibility: hidden !important;
				}
			}`;
    document.head.appendChild(style);
}
function $3b7fa3742d344605$export$4b3266eb0ec6c746(enabled, intl) {
    const rootRef = (0, $42omo.useRef)(null);
    const hostRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!enabled || typeof window === 'undefined' || typeof document === 'undefined') return;
        $3b7fa3742d344605$var$ensurePrintStyles();
        (0, $bHWAG.preloadImage)((0, (/*@__PURE__*/$parcel$interopDefault($1xywh))));
        const before = ()=>{
            if (!(0, $bHWAG.isPageViewRoute)(window.location.pathname)) return;
            // find the main content container where we'll inject the cover page
            const target = document.querySelector($3b7fa3742d344605$var$TARGET_SELECTOR);
            // exit early if target element doesn't exist
            if (!target) return;
            // check if the cover page host container already exists in the DOM
            let host = document.getElementById($3b7fa3742d344605$var$COVER_ID);
            if (!host) {
                // Create a new host container if it doesn't exist
                host = document.createElement('div');
                host.id = $3b7fa3742d344605$var$COVER_ID;
            }
            /* insert the host as the first child of target so the cover page prints before content
      only insert if it's not already the first child (prevents duplicate insertions) */ if (target.firstChild !== host) target.insertBefore(host, target.firstChild);
            /* create a React root for the host container if it doesn't exist yet
      This allows us to render React components into this DOM node */ if (!rootRef.current) rootRef.current = (0, $2FNjD.createRoot)(host);
            // render the cover page component with internationalization support
            // wrap it in IntlProvider to provide translations from the parent app
            rootRef.current.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
                locale: intl.locale,
                messages: intl.messages,
                defaultLocale: "en"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iEYBu.CoverPageComponent), null)));
            // store reference to the host element for cleanup later
            hostRef.current = host;
        };
        const after = ()=>{
            // clean up the React root to prevent memory leaks
            if (rootRef.current) {
                // unmount the React component tree from the DOM
                rootRef.current.unmount();
                rootRef.current = null;
            }
            // remove the host container from the DOM if it exists and has a parent
            if (hostRef.current?.parentNode) // remove the cover page element from its parent node
            hostRef.current.parentNode.removeChild(hostRef.current);
            // clear the host element reference
            hostRef.current = null;
        };
        window.addEventListener('beforeprint', before);
        window.addEventListener('afterprint', after);
        // safety: some browsers may skip afterprint on cancel
        const onVisibility = ()=>{
            if (document.visibilityState === 'visible') after();
        };
        document.addEventListener('visibilitychange', onVisibility);
        return ()=>{
            window.removeEventListener('beforeprint', before);
            window.removeEventListener('afterprint', after);
            document.removeEventListener('visibilitychange', onVisibility);
            after();
        };
    }, [
        enabled,
        intl
    ]);
}
module.exports["usePrintCoverInjector"] = $3b7fa3742d344605$export$4b3266eb0ec6c746;

});

parcelRegister("1xywh", function(module, exports) {
module.exports = new URL("PDFexport.298a755d.png", import.meta.url).toString();

});

parcelRegister("iEYBu", function(module, exports) {
/* PrintCoverComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1xywh = parcelRequire("1xywh");

const $182813799a742845$export$d7f7fd46ad566704 = (0, $aXWIB.defineMessages)({
    printCoverHeader: {
        id: "pdf-print-utils.print-cover.header",
        defaultMessage: "Your page may not be formatted properly if you print now."
    },
    printCoverSubheader: {
        id: "pdf-print-utils.print-cover.subheader",
        defaultMessage: "To maintain your page's format, export it as a PDF before printing - either with \u2318P/Ctrl+P or by following these steps:"
    },
    printStep1: {
        id: "pdf-print-utils.print-cover.step1",
        defaultMessage: "Close this window"
    },
    printStep2: {
        id: "pdf-print-utils.print-cover.step2",
        defaultMessage: "Select More actions (\u2022\u2022\u2022) in the upper right."
    },
    printStep3: {
        id: "pdf-print-utils.print-cover.step3",
        defaultMessage: "Select Export > Export as PDF."
    },
    printStep4: {
        id: "pdf-print-utils.print-cover.step4",
        defaultMessage: "Download and open the PDF to print."
    },
    imageAlt: {
        id: "pdf-print-utils.print-cover.image-alt",
        defaultMessage: "PDF export instructions diagram"
    }
});
const $182813799a742845$var$coverWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    padding: 'space.500',
    boxSizing: 'border-box',
    marginTop: 'space.100'
});
const $182813799a742845$var$headingStyles = null;
const $182813799a742845$var$subHeadingStyles = null;
const $182813799a742845$var$imgContStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.100',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay'
});
const $182813799a742845$var$imageStyles = null;
const $182813799a742845$var$listStyles = null;
const $182813799a742845$var$listItemStyles = null;
const $182813799a742845$export$a01b7b078c69ca5a = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $182813799a742845$var$coverWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_1wybldb6 _k48p1wq8 _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printCoverHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_1wyb1ou6 _19pk1ejb _k48p1wq8 _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printCoverSubheader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $182813799a742845$var$imgContStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        alt: intl.formatMessage($182813799a742845$export$d7f7fd46ad566704.imageAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1xywh))),
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1ule"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ol", {
        className: (0, $gMc0m.default)([
            "_19pku2gc _bozgxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printStep1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printStep2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printStep3)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        className: (0, $gMc0m.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printStep4))));
};
module.exports["CoverPageComponent"] = $182813799a742845$export$a01b7b078c69ca5a;

});

parcelRegister("ikPi2", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2748374594b3931f$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        fullPageEditorLoomUrl: undefined,
        pageCommentEditorLoomUrl: undefined,
        inlineCommentEditorLoomUrl: undefined
    },
    actions: {
        updateFullPageEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    fullPageEditorLoomUrl: video
                });
            },
        updatePageCommentEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    pageCommentEditorLoomUrl: video
                });
            }
    },
    name: 'loomUrlToInsert'
});
const $2748374594b3931f$export$f76207310d699374 = (0, $9zUhf.createHook)($2748374594b3931f$var$Store);
const $2748374594b3931f$export$b51bf851d750866c = ()=>$2748374594b3931f$export$f76207310d699374()[1];
module.exports["useLoomInsertUrlState"] = $2748374594b3931f$export$f76207310d699374;

});

parcelRegister("dRPxE", function(module, exports) {

let $a18834b2be09b5a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a18834b2be09b5a6$var$load("7YkzC"),
    $a18834b2be09b5a6$var$load("5uHxI"),
    $a18834b2be09b5a6$var$load("3XJd1"),
    $a18834b2be09b5a6$var$load("iSp49"),
    $a18834b2be09b5a6$var$load("cXen0"),
    $a18834b2be09b5a6$var$load("kWL2K"),
    $a18834b2be09b5a6$var$load("8Ww5y"),
    $a18834b2be09b5a6$var$load("6aFLR"),
    $a18834b2be09b5a6$var$load("j4lHi"),
    $a18834b2be09b5a6$var$load("8LtYa"),
    $a18834b2be09b5a6$var$load("hOaAV"),
    $a18834b2be09b5a6$var$load("iK6Gk"),
    $a18834b2be09b5a6$var$load("72YPP"),
    $a18834b2be09b5a6$var$load("47RmW"),
    $a18834b2be09b5a6$var$load("g5HUX"),
    $a18834b2be09b5a6$var$load("i1up4"),
    $a18834b2be09b5a6$var$load("1GvGi"),
    $a18834b2be09b5a6$var$load("d4u0p"),
    $a18834b2be09b5a6$var$load("cD6Zr"),
    $a18834b2be09b5a6$var$load("901NJ"),
    $a18834b2be09b5a6$var$load("gUo8V"),
    $a18834b2be09b5a6$var$load("kEwWf"),
    $a18834b2be09b5a6$var$load("4t77a"),
    $a18834b2be09b5a6$var$load("cEqm7"),
    $a18834b2be09b5a6$var$load("6XCf4"),
    $a18834b2be09b5a6$var$load("7EorR"),
    $a18834b2be09b5a6$var$load("klllM"),
    $a18834b2be09b5a6$var$load("gOOwE"),
    $a18834b2be09b5a6$var$load("5pvpJ"),
    $a18834b2be09b5a6$var$load("iNa18"),
    $a18834b2be09b5a6$var$load("hshEG"),
    $a18834b2be09b5a6$var$load("5CdWD"),
    $a18834b2be09b5a6$var$load("6iz6l"),
    $a18834b2be09b5a6$var$load("4SCW2"),
    $a18834b2be09b5a6$var$load("aXHNO"),
    $a18834b2be09b5a6$var$load("kmvek"),
    $a18834b2be09b5a6$var$load("Wowvf"),
    $a18834b2be09b5a6$var$load("dek7I"),
    $a18834b2be09b5a6$var$load("9aQIt"),
    $a18834b2be09b5a6$var$load("XZauT"),
    $a18834b2be09b5a6$var$load("4S1SF"),
    $a18834b2be09b5a6$var$load("lm9Lt"),
    $a18834b2be09b5a6$var$load("9wPDc"),
    $a18834b2be09b5a6$var$load("1MWOL"),
    $a18834b2be09b5a6$var$load("6fQco"),
    $a18834b2be09b5a6$var$load("dYtBN"),
    $a18834b2be09b5a6$var$load("kNV5Y"),
    $a18834b2be09b5a6$var$load("6wr18"),
    $a18834b2be09b5a6$var$load("kjZZD"),
    $a18834b2be09b5a6$var$load("7cDV0"),
    $a18834b2be09b5a6$var$load("ijD5W"),
    $a18834b2be09b5a6$var$load("ffEVr"),
    $a18834b2be09b5a6$var$load("1qlDN"),
    $a18834b2be09b5a6$var$load("1yVM6"),
    $a18834b2be09b5a6$var$load("hhss7"),
    $a18834b2be09b5a6$var$load("iq6Zv")
]).then(()=>parcelRequire('8pP5E'));

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
const $4cdfc0aeee394c11$export$a682f4bbb3650e11 = 200;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;
module.exports["SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH"] = $4cdfc0aeee394c11$export$a682f4bbb3650e11;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("lyWac", function(module, exports) {

var $3mugH = parcelRequire("3mugH");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') {
                const fulfilledValue = result.value;
                if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                else if (Array.isArray(fulfilledValue)) {
                    const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                    errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                }
            }
        }
        if (errors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return errors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("85RNG", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7hpmn = parcelRequire("7hpmn");


var $jtTDB = parcelRequire("jtTDB");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $6084008f41008b40$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
const $6084008f41008b40$export$84c726b6114f53f8 = ({ duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination width first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.width === prevDimensions.current.width) {
            onFinishMotion?.();
            return;
        }
        const newStyles = {
            width: `${prevDimensions.current.width}px`,
            willChange: 'width',
            transitionProperty: 'width',
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        Object.assign(element.style, newStyles);
        const resolvedDuration = $6084008f41008b40$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.width = `${nextDimensions.width}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $6084008f41008b40$export$5146a620d339842f = ({ children: children, ...props })=>{
    const resizing = $6084008f41008b40$export$84c726b6114f53f8(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children(resizing)
    });
};
module.exports["useResizingWidth"] = $6084008f41008b40$export$84c726b6114f53f8;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("gHaxX", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $c278d7dccfa97a86$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $c278d7dccfa97a86$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $c278d7dccfa97a86$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $iEfsZ = parcelRequire("iEfsZ");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        }
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            }
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    return (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables
    });
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<2835de3dfc12defdb25dd8893b73b398>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("wPrRK", function(module, exports) {

var $3mugH = parcelRequire("3mugH");


var $9WAeG = parcelRequire("9WAeG");


var $4VJDS = parcelRequire("4VJDS");

const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            // eslint-disable-next-line no-console
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`SlowQueryGuard "${name}" timed out after ${finalTimeout}ms`));
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
        if (timer) clearTimeout(timer);
        return true;
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<356b7b18b17a7ca52b06497ba0dbca19>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("kwDQA", function(module, exports) {
/**
 * @generated SignedSource<<193afe3edebf9b23d8d9084f6c5830f3>>
 * @relayHash dc72ca00e2d1457e65f0598584181ac4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c301260df5a4466153ed3f56d8be0b24166ae188507e59c4709e8a0159d8500
const $377c093245c44338$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fromDate"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "fromDate",
                    "variableName": "fromDate"
                }
            ],
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "dc72ca00e2d1457e65f0598584181ac4",
            "id": "4c301260df5a4466153ed3f56d8be0b24166ae188507e59c4709e8a0159d8500",
            "metadata": {},
            "name": "useAnalyticsByLineQuery",
            "operationKind": "query",
            "text": "query useAnalyticsByLineQuery($contentId:ID!,$fromDate:String){contentAnalyticsViewers(contentId:$contentId,fromDate:$fromDate){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$377c093245c44338$var$node.hash = "bc547488b58318aeb15d566ad5044ad7";
var $377c093245c44338$export$2e2bcd8739ae039 = $377c093245c44338$var$node;
module.exports["default"] = $377c093245c44338$export$2e2bcd8739ae039;

});

parcelRegister("e3X7L", function(module, exports) {
/**
 * @generated SignedSource<<a6653f94e2eb58f1cf8a0c35ea98db0d>>
 * @relayHash 6ea58338105a015fd443972b8fa8bd85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64
const $05607cbb6652fe1b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6ea58338105a015fd443972b8fa8bd85",
            "id": "c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64",
            "metadata": {},
            "name": "GrantAccessDialogLoaderQuery",
            "operationKind": "query",
            "text": "query GrantAccessDialogLoaderQuery($contentId:ID!,$accountId:ID!){singleContent(id:$contentId){id,title},user:confluence_atlassianUser(id:$accountId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$05607cbb6652fe1b$var$node.hash = "65e9fca072feda54403e4da52299bc66";
var $05607cbb6652fe1b$export$2e2bcd8739ae039 = $05607cbb6652fe1b$var$node;
module.exports["default"] = $05607cbb6652fe1b$export$2e2bcd8739ae039;

});

parcelRegister("3cpum", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $3lWl0 = parcelRequire("3lWl0");

function $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0({ contentId: contentId, useCache: useCache, shouldGetDraftVersion: shouldGetDraftVersion }) {
    return (0, $dYU3e.query)({
        query: (0, $3lWl0.default),
        variables: {
            contentId: contentId,
            isDraft: shouldGetDraftVersion,
            shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : shouldGetDraftVersion,
            isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY'
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadEditorContentState"] = $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<a1717ed97f0439e908018ebd5158b9e3>>
 * @relayHash b4c5e8d8fe0e4cf7e15ddede8b214601
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50c0ce974af8bdc413c3f60e4d9e3ba911ae7557d0935f2f44379c4bc9411469
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "color"
    }, v9 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v10 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                {
                    "args": [
                        v6 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v6 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v5 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "b4c5e8d8fe0e4cf7e15ddede8b214601",
            "id": "50c0ce974af8bdc413c3f60e4d9e3ba911ae7557d0935f2f44379c4bc9411469",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted,lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "2ad6563c393bf2c4924f755b12809ec0";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<d6eefc5a03716abdbaca8e40915faea8>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("fxLAA", function(module, exports) {
/**
 * @generated SignedSource<<2bbcb82f8eaaf125b7fec3c8bfb95497>>
 * @relayHash 70098693ba1c82f5876b86639e5e7339
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1fdd1301213b13c7a53671f5d4a6c200423ef906910b7b5e784abbee4092451b
const $d3bfdb752c338d80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v7 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "title"
    }, v13 = {
        "kind": "ScalarField",
        "name": "status"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = {
        "kind": "ScalarField",
        "name": "number"
    }, v17 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ 
                    ]
                }
            ]
        }
    ], v18 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v17 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v19 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v22 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v23 = [
        v10 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ 
    ], v24 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v17 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v25 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v17 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v26 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"editor\")"
    }, v27 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "message"
    }, v29 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v30 = {
        "kind": "ScalarField",
        "name": "when"
    }, v31 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v32 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v33 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "count"
    }, v36 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v37 = {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
    }, v38 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": [
                            v14 /*: any*/ ,
                            v15 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "background"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundAttachment"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundBlendMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundClip"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundColor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundImage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundOrigin"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundPosition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundRepeat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundSize"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v39 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v10 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v23 /*: any*/ 
                                        },
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ]
                                },
                                v32 /*: any*/ ,
                                v33 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v34 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v23 /*: any*/ 
                        }
                    ]
                },
                v38 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v39 /*: any*/ 
                                        },
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ]
                                },
                                v32 /*: any*/ ,
                                v33 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v34 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v39 /*: any*/ 
                        }
                    ]
                },
                v38 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "70098693ba1c82f5876b86639e5e7339",
            "id": "1fdd1301213b13c7a53671f5d4a6c200423ef906910b7b5e784abbee4092451b",
            "metadata": {},
            "name": "ContentHeaderUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,type,subType,title,status,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}"
        }
    };
}();
$d3bfdb752c338d80$var$node.hash = "d58bd52d67b335df9d3d40434d235698";
var $d3bfdb752c338d80$export$2e2bcd8739ae039 = $d3bfdb752c338d80$var$node;
module.exports["default"] = $d3bfdb752c338d80$export$2e2bcd8739ae039;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("6LsQQ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $g2gGv = parcelRequire("g2gGv");

const $f8780459a3f4abf6$export$7da3cd10eb68919e = (0, $eSUdr.default)`query ContentTypesHeaderQuery($contentId:ID$useObjectHeader:Boolean!){content(id:$contentId status:["archived" "current" "draft"]){nodes{id title operations{operation targetType}space{id name key alias}type subType status version@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedVersionFragment}draftVersion@include(if:$useObjectHeader){contentTypeModified number friendlyWhen ...LastEditedDraftVersionFragment}}}}${(0, $g2gGv.LastEditedVersionFragment)}${(0, $g2gGv.LastEditedDraftVersionFragment)}`;
module.exports["ContentTypesHeaderQuery"] = $f8780459a3f4abf6$export$7da3cd10eb68919e;

});

parcelRegister("g2gGv", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $82f60ea6bd1b627b$export$deecf62d8ca1b922 = (0, $eSUdr.default)`fragment LastEditedVersionFragment on Version{by{displayName}when}`;
const $82f60ea6bd1b627b$export$36bc043d85f07c8 = (0, $eSUdr.default)`fragment LastEditedDraftVersionFragment on Version{by{displayName}when}`;
module.exports["LastEditedVersionFragment"] = $82f60ea6bd1b627b$export$deecf62d8ca1b922;
module.exports["LastEditedDraftVersionFragment"] = $82f60ea6bd1b627b$export$36bc043d85f07c8;

});

parcelRegister("lPNkm", function(module, exports) {
/**
 * @generated SignedSource<<c2c7b89990f66597ab5459eb501da180>>
 * @relayHash 19081691cac2c634716f82092efd5e14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3
const $98f50c7d6961f0d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SpaceSettingsMetadata",
                            "kind": "LinkedField",
                            "name": "customHeaderAndFooter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "footer",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "19081691cac2c634716f82092efd5e14",
            "id": "3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3",
            "metadata": {},
            "name": "CustomHeaderFooterQuery",
            "operationKind": "query",
            "text": "query CustomHeaderFooterQuery($spaceKey:String){space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}}}"
        }
    };
}();
$98f50c7d6961f0d8$var$node.hash = "deed3f087b4973bd7d276b1389cfb125";
var $98f50c7d6961f0d8$export$2e2bcd8739ae039 = $98f50c7d6961f0d8$var$node;
module.exports["default"] = $98f50c7d6961f0d8$export$2e2bcd8739ae039;

});

parcelRegister("fyUox", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (0, $dYU3e.query)({
        query: (0, $zalpJ.PreloadHomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<7c4fad734c378beb08364142bb7cfc48>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $1Y111 = parcelRequire("1Y111");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const unwatchedResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true)
    });
    const interopResult = (0, $jMyy4.useQueryInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        ...options,
        skip: !contentId || (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true)
    });
    const { data: data, error: error, loading: loading } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? unwatchedResult : interopResult;
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<7a25f638a0360fe7e4a7975f76de16eb>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("1i2qc", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $dYU3e = parcelRequire("dYU3e");


var $iTcHJ = parcelRequire("iTcHJ");

const $ab4965c7462ff107$export$2d12daceb0197048 = async (contentId)=>{
    const response = await (0, $dYU3e.query)({
        query: (0, $iTcHJ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        }
    });
    return response;
};
module.exports["preloadMediaToken"] = $ab4965c7462ff107$export$2d12daceb0197048;

});

parcelRegister("k5dl6", function(module, exports) {
/**
 * @generated SignedSource<<c2aa8cb4e44c9a69d3085b995905a773>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06
const $bff977656480fdfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    v2 /*: any*/ 
                ]
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v11 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "when"
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v20 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v24 /*: any*/ ,
                                v16 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
            "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
            "metadata": {},
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$bff977656480fdfe$var$node.hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";
var $bff977656480fdfe$export$2e2bcd8739ae039 = $bff977656480fdfe$var$node;
module.exports["default"] = $bff977656480fdfe$export$2e2bcd8739ae039;

});

parcelRegister("cvj7x", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $65pdw = parcelRequire("65pdw");


var $1TElT = parcelRequire("1TElT");


var $3cpum = parcelRequire("3cpum");


var $7PLO8 = parcelRequire("7PLO8");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $4trRg = parcelRequire("4trRg");

parcelRequire("kGDoD");
var $9nGwZ = parcelRequire("9nGwZ");


var $1c0dB = parcelRequire("1c0dB");


var $kDt9L = parcelRequire("kDt9L");


var $4vyfK = parcelRequire("4vyfK");


var $cRQNp = parcelRequire("cRQNp");


var $eSLr0 = parcelRequire("eSLr0");


var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $lyWac = parcelRequire("lyWac");


var $9wGTI = parcelRequire("9wGTI");


var $fqIt3 = parcelRequire("fqIt3");


var $9OYfw = parcelRequire("9OYfw");


var $hr9NW = parcelRequire("hr9NW");

const $c13994d6914d469f$var$logger = (0, $7W8i8.getLogger)('load-edit-page');
async function $c13994d6914d469f$export$1149cf9041c3e7b8({ spaceKey: spaceKey, contentId: contentId, shouldPreloadMentionsProvider: shouldPreloadMentionsProvider = false, useCache: useCache = false, catchFn: // use cache for native editor data
catchFn, isBlog: isBlog, cloudId: cloudId, isLivePage: isLivePage = false }) {
    // note: explicitly casting to Promise<any> to avoid typescript incorrectly inferring tuple types; although we don't use the return value of this function regardless
    $c13994d6914d469f$var$logger.debug`Calling preloadEditorData ${performance.now() / 1000}`;
    const draftShareId = (0, $7PLO8.getDraftShareIdFromQueryParam)();
    // preload queries shared by Synchrony and Native Collab editors
    const immediateResultsPromises = [
        (0, $irrTO.preloadDraftContentAppearance)(contentId, useCache)
    ];
    // specific native collab editor queries
    if (!!contentId) {
        immediateResultsPromises.push((0, $9OYfw.preloadCollabDraftContent)(contentId, draftShareId, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? useCache || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) : useCache));
        immediateResultsPromises.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId, cloudId, isBlog));
        if ((0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) {
            const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
            immediateResultsPromises.push((0, $4trRg.preloadContentMode)({
                contentId: contentId,
                isDraft: !isLivePage,
                useCache: useCache,
                isArchived: isArchived
            }));
        }
        immediateResultsPromises.push((0, $1TElT.preloadEmojiTitle)(contentId, draftShareId, useCache), (0, $9OYfw.preloadNativeCollab)(contentId, draftShareId, useCache));
    }
    immediateResultsPromises.push((0, $65pdw.preloadEditorPageCoverPicture)(contentId, draftShareId, useCache), (0, $3cpum.preloadEditorContentState)({
        contentId: contentId,
        useCache: useCache,
        shouldGetDraftVersion: !isLivePage
    }));
    if (isLivePage) {
        // Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
        immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        }), // For some reason the addition of the filter (uses new Forge query) is causing SSR to timeout - workaround by skipping the filter
        (0, $8CHHT.preloadUseExtensionList)({
            spaceKey: spaceKey || '',
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
        }));
        immediateResultsPromises.push((0, $9nGwZ.preloadLastUpdated)(contentId, useCache));
        immediateResultsPromises.push((0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            useCache: useCache
        }));
    }
    if (shouldPreloadMentionsProvider) immediateResultsPromises.push((0, $kDt9L.preloadMentionsProvider)());
    immediateResultsPromises.push((0, $1c0dB.preloadEditorPageTitleContentProperties)({
        contentId: contentId,
        draftShareId: draftShareId,
        useCache: useCache
    }));
    await (0, $lyWac.waitForAllReturnWhenError)(immediateResultsPromises.map((p)=>!!catchFn ? p?.catch(catchFn) : p));
    $c13994d6914d469f$var$logger.debug`preloadEditorData complete ${performance.now() / 1000}`;
}
module.exports["preloadEditorData"] = $c13994d6914d469f$export$1149cf9041c3e7b8;

});

parcelRegister("65pdw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lC6Qd = parcelRequire("lC6Qd");

function $4e9d3c2f55d09139$export$cca2a63dd6cc6345(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $lC6Qd.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: draftShareId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadEditorPageCoverPicture"] = $4e9d3c2f55d09139$export$cca2a63dd6cc6345;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<222524e9edc9d9e64505b61c38fde3e9>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("1TElT", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $5DJsZ = parcelRequire("5DJsZ");

const $0272cf4ae0232c26$export$a9fe7043b42a1476 = (contentId, draftShareId, useCache)=>{
    return (0, $dYU3e.query)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadEmojiTitle"] = $0272cf4ae0232c26$export$a9fe7043b42a1476;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<26dbb45846c41499d3735f0e079c26cb>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("4trRg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $flWvL = parcelRequire("flWvL");


var $joyRP = parcelRequire("joyRP");

const $b51af1b6a5dfb3b5$export$79f4fda3b987b044 = ({ contentId: contentId, isDraft: isDraft, useCache: useCache = false, isArchived: isArchived })=>{
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    return (0, $dYU3e.query)({
        query: (0, $joyRP.default),
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadContentMode"] = $b51af1b6a5dfb3b5$export$79f4fda3b987b044;

});

parcelRegister("kGDoD", function(module, exports) {
$parcel$export(module.exports, "preloadLastUpdated", () => (parcelRequire("9nGwZ")).preloadLastUpdated);

var $9nGwZ = parcelRequire("9nGwZ");


var $9BupY = parcelRequire("9BupY");


});

parcelRegister("9nGwZ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9BupY = parcelRequire("9BupY");

function $693a95aca15bff58$export$e7a15421d1327843(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $9BupY.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadLastUpdated"] = $693a95aca15bff58$export$e7a15421d1327843;

});

parcelRegister("9BupY", function(module, exports) {
/**
 * @generated SignedSource<<6cd69bb600740f6a687eaabe82eab755>>
 * @relayHash 596c33f2627461693b923b812b6e225f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235
const $173882722a7c2e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "596c33f2627461693b923b812b6e225f",
            "id": "a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235",
            "metadata": {},
            "name": "LivePagesByLineLastUpdatedQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineLastUpdatedQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,version{friendlyWhen,when}}}}"
        }
    };
}();
$173882722a7c2e36$var$node.hash = "4e6df5756d13dcdcef29e05d538280a7";
var $173882722a7c2e36$export$2e2bcd8739ae039 = $173882722a7c2e36$var$node;
module.exports["default"] = $173882722a7c2e36$export$2e2bcd8739ae039;

});

parcelRegister("1c0dB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $kae7O = parcelRequire("kae7O");

const $cb49cba09ddc32ea$export$2ea86854c75d3ec8 = async ({ contentId: contentId, draftShareId: draftShareId, useCache: useCache })=>{
    const variables = {
        contentId: contentId,
        status: [
            'current',
            'draft',
            'archived'
        ],
        draftShareId: draftShareId,
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    };
    return (0, $dYU3e.query)({
        query: (0, $kae7O.default),
        variables: variables
    });
};
module.exports["preloadEditorPageTitleContentProperties"] = $cb49cba09ddc32ea$export$2ea86854c75d3ec8;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<32e624cd68d3727bb5bc93ef7fb77fe7>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("kDt9L", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $dYU3e = parcelRequire("dYU3e");


var $89CKS = parcelRequire("89CKS");

const $6bd71bdc26599ad9$export$45c648ba9bf4e12f = async ()=>(0, $dYU3e.query)({
        query: (0, $89CKS.default)
    });
module.exports["preloadMentionsProvider"] = $6bd71bdc26599ad9$export$45c648ba9bf4e12f;

});

parcelRegister("cRQNp", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $j25oo = parcelRequire("j25oo");

function $345f814d0887da7c$export$8301c585ee328ce0({ contentId: contentId, includeContentBody: includeContentBody = true, status: status, useCache: useCache }) {
    return (0, $dYU3e.query)({
        query: (0, $j25oo.default),
        variables: {
            contentId: contentId,
            includeContentBody: includeContentBody,
            status: status
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
module.exports["preloadReadTime"] = $345f814d0887da7c$export$8301c585ee328ce0;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<08aaea74493da34011b5c879855eeef9>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("8CHHT", function(module, exports) {

var $9WAeG = parcelRequire("9WAeG");


var $xwvlW = parcelRequire("xwvlW");


var $3mugH = parcelRequire("3mugH");


var $7Sm4c = parcelRequire("7Sm4c");


var $6fil2 = parcelRequire("6fil2");


var $8n0y0 = parcelRequire("8n0y0");

const $23196774779b9db8$var$setWindowExtensions = (moduleType, extensions, error)=>{
    window.__SSR_FORGE_EXTENSIONS__ = window.__SSR_FORGE_EXTENSIONS__ || {};
    window.__SSR_FORGE_EXTENSIONS__[moduleType] = {
        extensions: extensions,
        error: error
    };
};
async function $23196774779b9db8$export$afb6180712276ba1({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType, includeHidden: includeHidden = false }) {
    const { cloudId: cloudId, locale: locale } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:ForgeExtensionList', async ()=>{
        try {
            const extensions = await (0, $8n0y0.preloadForgeApps)({
                cloudId: cloudId,
                locale: locale,
                types: [
                    moduleType
                ],
                context: {
                    spaceKey: spaceKey,
                    contentId: contentId
                },
                includeHidden: includeHidden
            });
            if (extensions) $23196774779b9db8$var$setWindowExtensions(moduleType, extensions, undefined);
        } catch (e) {
            // Want to handle network errors to not affect experience SLA
            if ((0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
            else (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Filed to get forge extension list: ${e.message}`));
        }
    });
}
module.exports["preloadUseExtensionList"] = $23196774779b9db8$export$afb6180712276ba1;

});

parcelRegister("8n0y0", function(module, exports) {
/** @graphql cc **/ 
var $aIwYp = parcelRequire("aIwYp");


var $dYU3e = parcelRequire("dYU3e");

const $0469ff9a24207ab9$export$e95a50d7f0e263b5 = async ({ cloudId: cloudId, locale: locale, types: types, context: context, includeHidden: includeHidden })=>{
    return (0, $aIwYp.preloadPrefilteredExtensionList)(// This is s a special case that the query is from platform in DocumentNode not Relay TaggedNode
    // query can handle both Relay TaggedNode and DocumentNode but type is only declared as Relay TaggedNode
    (0, $dYU3e.queryAgg), {
        cloudId: cloudId,
        locale: locale,
        types: types,
        context: context,
        includeHidden: includeHidden
    });
};
module.exports["preloadForgeApps"] = $0469ff9a24207ab9$export$e95a50d7f0e263b5;

});

parcelRegister("aIwYp", function(module, exports) {

var $8VYSW = parcelRequire("8VYSW");


var $7zIsq = parcelRequire("7zIsq");


var $39Ajm = parcelRequire("39Ajm");

const $1539bb55e97e95bf$export$689e6fec3c3a045c = async (query, { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, queryOptions: queryOptions })=>{
    const requestOptions = (0, $7zIsq.createUsePrefilteredExtensionListQueryOptions)(cloudId, context, undefined, types, locale, includeHidden, queryOptions);
    const { data: data } = await query({
        query: (0, $39Ajm.FetchPreFilteredForgeAppsQuery),
        ...requestOptions
    });
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (extensions.length > 0) return (0, $8VYSW.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["preloadPrefilteredExtensionList"] = $1539bb55e97e95bf$export$689e6fec3c3a045c;

});

parcelRegister("9OYfw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $l1kdf = parcelRequire("l1kdf");


var $nIvaQ = parcelRequire("nIvaQ");


var $8R0gj = parcelRequire("8R0gj");


var $hNtOj = parcelRequire("hNtOj");


var $27Dus = parcelRequire("27Dus");

function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    }).then(async (result)=>{
        // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
        // that doesn't preserve the result in caches if there is an error in SSR
        // So we need to preserve the error, to be able to verify it later during render phase in SSR
        if (result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
        // There are two reasons to store smart card URLs on the window object:
        // 1. The OTP uses a document snapshot from Confluence that may be outdated and miss recently added or removed smart cards,
        //    so we must reconcile the list of smart cards with the draft content.
        // 2. The draft content stores links with slugs, but the Confluence snapshot does not,
        //    so we need to add slugs sourced from the draft content.
        // Therefore, we extract smart cards from the draft content here, save them on the window object,
        // and later use them to align the Confluence snapshot with the draft content.
        window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodes)(result?.data?.collabDraft?.document || '');
        return result;
    });
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        query: (0, $l1kdf.NativeCollabQuery),
        variables: {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        }
    });
}
module.exports["preloadCollabDraftContent"] = $cb117090d47a4a62$export$952cf09a216eb6d;
module.exports["preloadNativeCollab"] = $cb117090d47a4a62$export$7c1f00ae06ab82b8;

});

parcelRegister("l1kdf", function(module, exports) {

var $hrBIS = parcelRequire("hrBIS");

const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $hrBIS.default);
module.exports["NativeCollabQuery"] = $c2e596865d8e6fea$export$79b924d780de6f0d;

});

parcelRegister("hrBIS", function(module, exports) {
/**
 * @generated SignedSource<<06da63ac15a0b7042e767601c7978c5d>>
 * @relayHash 4e152ff0861f20bc69927f68972ccc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc
const $83575f8369490c15$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "draftShareId",
            "variableName": "draftShareId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v12 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4e152ff0861f20bc69927f68972ccc1e",
            "id": "24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc",
            "metadata": {},
            "name": "NativeCollabQuery",
            "operationKind": "query",
            "text": "query NativeCollabQuery($contentId:ID,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,type,status,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},history{createdBy{__typename,displayName},createdDate},space{id,name,homepageId},labels{nodes{id,name}},subType}}}"
        }
    };
}();
$83575f8369490c15$var$node.hash = "182a5142c1846497c5e27245efe74033";
var $83575f8369490c15$export$2e2bcd8739ae039 = $83575f8369490c15$var$node;
module.exports["default"] = $83575f8369490c15$export$2e2bcd8739ae039;

});

parcelRegister("8R0gj", function(module, exports) {

var $747ya = parcelRequire("747ya");

async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        startTime: window?.performance?.now?.()
    };
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
module.exports["preloadDraft"] = $65899b702fdd32b1$export$dfd3c4c0aa957792;
module.exports["isDraftSSRPreloadPermissionError"] = $65899b702fdd32b1$export$9d45b1b64b2cb8e1;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("27Dus", function(module, exports) {

var $et4nk = parcelRequire("et4nk");


var $6GQtz = parcelRequire("6GQtz");


var $aN0qB = parcelRequire("aN0qB");

function $010c1dfc98319256$export$1970baffe86d32af(docJsonString) {
    if (!docJsonString) return [];
    const doc = JSON.parse(docJsonString);
    const cardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)('custom');
    return (0, $et4nk.findNodesToPrefetch)(doc, [
        {
            provider: cardProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        }
    ], (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT))[0].nodes;
}
module.exports["findSmartCardNodes"] = $010c1dfc98319256$export$1970baffe86d32af;

});

parcelRegister("et4nk", function(module, exports) {
function $7f5b74af20e3e05b$export$41263783ff0932a8(doc, providers, maxNodesToVisit) {
    // Counter for the total number of visited nodes to limit the traversal.
    let totalVisitedNodesCount = 0;
    // A map to store the results, with the provider name as the key.
    const resultMap = providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            provider: provider,
            nodes: []
        };
        return acc;
    }, {});
    // It doesn't use `filter` function from `@atlaskit/adf-utils/traverse` because it does not support early stopping.
    // We need to stop traversing when we reach the maximum number of nodes to visit to support large documents.
    // Create a list of providers for which we still need to find nodes.
    const providersToLookup = providers.filter(({ maxNodesToPrefetch: maxNodesToPrefetch })=>maxNodesToPrefetch > 0).map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            foundNodes: 0
        }));
    // Stack for the depth-first search (DFS), starting with the root document node.
    const nodesToVisit = [
        doc
    ];
    // The loop continues as long as there are nodes to visit, providers to look for,
    // and the visited nodes limit has not been reached.
    while(nodesToVisit.length > 0 && providersToLookup.length > 0 && totalVisitedNodesCount < maxNodesToVisit){
        totalVisitedNodesCount += 1;
        // Pop from the end to maintain DFS order (LIFO - Last In, First Out)
        const currentNode = nodesToVisit.pop();
        if (!currentNode) continue;
        // Using a reverse loop to avoid issues with array mutation (when removing elements).
        for(let i = providersToLookup.length - 1; i >= 0; i--){
            const providerToFind = providersToLookup[i];
            // Check if the current provider supports this node.
            if (providerToFind.provider.isNodeSupported(currentNode)) {
                // If provider supports the node, add it to the result map.
                resultMap[providerToFind.provider.name].nodes.push(currentNode);
                // Increment the count of found nodes for this provider.
                providerToFind.foundNodes += 1;
                // If the provider has found enough nodes, remove it from the lookup list.
                if (providerToFind.foundNodes >= providerToFind.maxNodesToPrefetch) providersToLookup.splice(i, 1);
            }
        }
        // If the current node has children, add them to the stack in reverse order
        // to maintain left-to-right traversal when popping from the stack,
        // because it's LIFO.
        if (currentNode.content) // Push children in reverse order to maintain correct DFS traversal order
        for(let i = currentNode.content.length - 1; i >= 0; i--){
            const node = currentNode.content[i];
            if (node) nodesToVisit.push(node);
        }
    }
    // Return an array of the found nodes, grouped by provider.
    return Object.values(resultMap);
}
module.exports["findNodesToPrefetch"] = $7f5b74af20e3e05b$export$41263783ff0932a8;

});

parcelRegister("aN0qB", function(module, exports) {
// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
const $e5ce665804adc727$export$d723a039341399fc = 10000;
const $e5ce665804adc727$export$109b6787e4cb0d4c = {
    smartCard: 10,
    emoji: 500
};
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT"] = $e5ce665804adc727$export$d723a039341399fc;
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH"] = $e5ce665804adc727$export$109b6787e4cb0d4c;

});

parcelRegister("hr9NW", function(module, exports) {

var $jC7Je = parcelRequire("jC7Je");


var $eTj7Y = parcelRequire("eTj7Y");


var $ibzAc = parcelRequire("ibzAc");


var $loQgl = parcelRequire("loQgl");


var $k00oi = parcelRequire("k00oi");


var $h9yJL = parcelRequire("h9yJL");


var $477dG = parcelRequire("477dG");


var $ge2sX = parcelRequire("ge2sX");


var $yuV6Z = parcelRequire("yuV6Z");


var $32x2E = parcelRequire("32x2E");


var $9WAeG = parcelRequire("9WAeG");


var $jQQYu = parcelRequire("jQQYu");


var $6GQtz = parcelRequire("6GQtz");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $60cDW = parcelRequire("60cDW");


var $aN0qB = parcelRequire("aN0qB");


var $kY8KV = parcelRequire("kY8KV");


var $6GukH = parcelRequire("6GukH");


var $985xA = parcelRequire("985xA");

const $8323d63e0ec880b7$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData';
const $8323d63e0ec880b7$var$DEFAULT_TIMEOUT = 300;
const $8323d63e0ec880b7$var$EDITOR_CARD_PROVIDER_NAME = 'editorCardProvider';
const $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME = 'externalEditorCardProvider';
const $8323d63e0ec880b7$var$preloadEditorNodeDataProvidersDataQuery = (0, $jC7Je.default);
async function $8323d63e0ec880b7$export$82c96ba69b54d1e5(contentId, cloudId, isBlog) {
    if (!contentId) return;
    if (!(0, $eTj7Y.isSSR)()) // If we are not in SSR, we don't need to preload node data providers data.
    return;
    await (0, $9WAeG.SSRMeasures).run($8323d63e0ec880b7$var$MEASURE_SEGMENT, async ()=>{
        const fetchAdfStart = performance.now();
        const docJsonString = await $8323d63e0ec880b7$var$fetchAdf(contentId);
        const fetchAdfDuration = performance.now() - fetchAdfStart;
        if (!docJsonString) return;
        const doc = JSON.parse(docJsonString);
        // Validate that the parsed document is a valid JSONDocNode
        if (!(0, $985xA.isValidJSONDocNode)(doc)) return;
        const providers = [];
        let syncedBlocksPromise;
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
            if ((0, $h9yJL.isJSONDocNode)(doc)) syncedBlocksPromise = (0, $6GukH.preloadEditorSyncedBlocksData)(contentId, cloudId, isBlog, doc);
        }
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isSplittingEnabled', true)) {
            providers.push({
                provider: $8323d63e0ec880b7$export$ebf5846faf5beb2(),
                maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
            });
            providers.push({
                provider: $8323d63e0ec880b7$export$21425f1d7e912e7a(),
                maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
            });
        } else providers.push({
            provider: $8323d63e0ec880b7$var$ssrEditorCardProvider(),
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        });
        const sessionData = await $8323d63e0ec880b7$var$getSessionData();
        const emojiNodeDataProvider = $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider(sessionData);
        if (emojiNodeDataProvider) providers.push({
            provider: emojiNodeDataProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).emoji
        });
        providers.forEach(({ provider: provider })=>{
            (0, $9WAeG.SSRMeasures).markMeasureStart($8323d63e0ec880b7$var$measureProviderSegment(provider.name));
        });
        let editorNodeDataProvidersData = await (0, $loQgl.prefetchNodeDataProvidersData)({
            doc: doc,
            providers: providers,
            timeout: ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) ? // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
            (0, $6mKj3.expVal)('cc_editor_node_data_providers_preload_config', 'defaultTimeout', $8323d63e0ec880b7$var$DEFAULT_TIMEOUT) || $8323d63e0ec880b7$var$DEFAULT_TIMEOUT : $8323d63e0ec880b7$var$DEFAULT_TIMEOUT) - fetchAdfDuration,
            maxNodesToVisit: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT)
        });
        Object.entries(editorNodeDataProvidersData).forEach(([providerName, { duration: duration }])=>{
            (0, $9WAeG.SSRMeasures).setMeasureDuration($8323d63e0ec880b7$var$measureProviderSegment(providerName), duration);
        });
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isSplittingEnabled', true)) editorNodeDataProvidersData = $8323d63e0ec880b7$export$45312dbe9e8537fb(editorNodeDataProvidersData);
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
            const nodeDataToStore = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                    providerName,
                    data
                ]));
            (0, $kY8KV.addToSSREditorNodeDataProvidersStore)(nodeDataToStore);
        } else window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                providerName,
                data
            ]));
        // Ensure synced blocks data is fully resolved before returning
        if (syncedBlocksPromise) await syncedBlocksPromise;
    });
}
function $8323d63e0ec880b7$export$45312dbe9e8537fb(nodeDataProvidersSsrData, // will merge to the first provider in the list, which is `editorCardProvider` in our case, so it should be listed first in the array
keysOfProviderDataToMerge = [
    $8323d63e0ec880b7$var$EDITOR_CARD_PROVIDER_NAME,
    $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME
]) {
    if (keysOfProviderDataToMerge.length < 2) return nodeDataProvidersSsrData;
    const [mainProviderName, ...sourceKeys] = keysOfProviderDataToMerge;
    const result = {
        ...nodeDataProvidersSsrData
    };
    const processedSourceKeys = new Set();
    for (const sourceKey of sourceKeys){
        if (sourceKey === mainProviderName || processedSourceKeys.has(sourceKey)) continue;
        processedSourceKeys.add(sourceKey);
        const sourceData = result[sourceKey];
        if (sourceData) {
            result[mainProviderName] = result[mainProviderName] || {
                data: {},
                duration: 0,
                success: false
            };
            result[mainProviderName] = {
                data: {
                    ...result[mainProviderName].data,
                    ...sourceData.data
                },
                duration: Math.max(result[mainProviderName].duration, sourceData.duration),
                success: result[mainProviderName].success || sourceData.success
            };
            delete result[sourceKey];
        }
    }
    return result;
}
function $8323d63e0ec880b7$var$fetchAdf(contentId) {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/fetch:AdfDocQuery`, async ()=>{
        try {
            const result = await (0, $dYU3e.query)({
                query: $8323d63e0ec880b7$var$preloadEditorNodeDataProvidersDataQuery,
                variables: {
                    contentId: contentId,
                    status: [
                        'draft'
                    ]
                },
                fetchPolicy: 'network-only'
            });
            if (result.hasErrors) return undefined;
            return result.data?.singleContent?.body?.atlas_doc_format?.value || undefined;
        } catch  {
            return undefined;
        }
    });
}
function $8323d63e0ec880b7$var$getSessionData() {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/getSessionData`, async ()=>{
        return (0, $ge2sX.getSessionData)();
    });
}
function $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider(sessionData) {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = sessionData;
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $yuV6Z.createEmojiProviderParameters)({
        cloudId: cloudId,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn
    });
    return (0, $32x2E.getEmojiNodeDataProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
}
function $8323d63e0ec880b7$var$ssrEditorCardProvider() {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    const ssrCardClient = new (0, $k00oi.default)('custom', objectResolverURL);
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    // No URL filter: accepts both internal and external URLs
    return new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient);
}
function $8323d63e0ec880b7$var$createSSREditorCardProvider(urlFilter, nameOverride) {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    // This URL will be something like `https://object-resolver.staging.atl-paas.net/resolve/batch`.
    // We need only protocol and host to pass it to the EditorCardProvider,
    // because path will be added by `CardClient`.
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    // We need to define a custom CardClient for SSR, because the default one works through public API gateway.
    const ssrCardClient = new (0, $k00oi.default)('custom', objectResolverURL);
    // Headers from `fetchORSForSSR` from confluence/next/packages/content-smartlinks/src/index.ts
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    return new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient, urlFilter, nameOverride);
}
function $8323d63e0ec880b7$export$ebf5846faf5beb2() {
    return $8323d63e0ec880b7$var$createSSREditorCardProvider((0, $477dG.isInternalUrl));
}
function $8323d63e0ec880b7$export$21425f1d7e912e7a() {
    return $8323d63e0ec880b7$var$createSSREditorCardProvider((0, $477dG.isExternalUrl), $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME);
}
function $8323d63e0ec880b7$var$measureProviderSegment(providerName) {
    return `${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/${providerName}`;
}
module.exports["preloadEditorNodeDataProvidersData"] = $8323d63e0ec880b7$export$82c96ba69b54d1e5;

});

parcelRegister("jC7Je", function(module, exports) {
/**
 * @generated SignedSource<<2653764bd6519c7ce6cca690d06b72b6>>
 * @relayHash 72f0e11f3a3324a5c8d9d9a03df96df2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985
const $f23059387da63ee7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "72f0e11f3a3324a5c8d9d9a03df96df2",
            "id": "c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985",
            "metadata": {},
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "operationKind": "query",
            "text": "query preloadEditorNodeDataProvidersDataQuery($contentId:ID,$status:[String]){singleContent(id:$contentId,status:$status){id,body{atlas_doc_format{value}}}}"
        }
    };
}();
$f23059387da63ee7$var$node.hash = "b082e4555a8e2adb34e1cfb641ee98a0";
var $f23059387da63ee7$export$2e2bcd8739ae039 = $f23059387da63ee7$var$node;
module.exports["default"] = $f23059387da63ee7$export$2e2bcd8739ae039;

});

parcelRegister("loQgl", function(module, exports) {

var $et4nk = parcelRequire("et4nk");

async function $33eee30649b8eece$export$65217f7ac34c2278({ providers: providers, doc: doc, timeout: timeout, maxNodesToVisit: maxNodesToVisit = Infinity }) {
    if (timeout <= 0) // If the global timeout is 0 or negative, skip fetching entirely.
    return providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            data: {},
            success: false,
            duration: 0
        };
        return acc;
    }, {});
    const providersWithDefaults = providers.map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch = Infinity, timeout: providerTimeout = Infinity })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            // Use the minimum of the global timeout and the provider-specific timeout
            timeout: Math.min(providerTimeout, timeout)
        }));
    const providerTimeouts = providersWithDefaults.reduce((acc, { provider: provider, timeout: timeout })=>{
        acc[provider.name] = timeout;
        return acc;
    }, {});
    const nodesWithProviders = (0, $et4nk.findNodesToPrefetch)(doc, providersWithDefaults, maxNodesToVisit).map(({ provider: provider, nodes: nodes })=>({
            provider: provider,
            nodes: nodes,
            timeout: providerTimeouts[provider.name]
        }));
    const promises = nodesWithProviders.map(async ({ nodes: nodes, provider: provider, timeout: timeout })=>{
        if (timeout <= 0) return {
            provider: provider,
            success: false,
            duration: 0,
            nodes: nodes,
            data: []
        };
        const start = performance.now();
        function getDurationFromStart() {
            return Math.min(performance.now() - start, timeout);
        }
        try {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject();
                }, timeout);
            });
            const data = await Promise.race([
                provider.fetchNodesData(nodes),
                timeoutPromise
            ]);
            return {
                provider: provider,
                success: true,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: data
            };
        } catch  {
            return {
                provider: provider,
                success: false,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: []
            };
        }
    });
    const results = await Promise.all(promises);
    return results.reduce((acc, { provider: provider, success: success, duration: duration, nodes: nodes, data: data })=>{
        const ssrData = data.reduce((providerSsrData, nodeData, nodeIndex)=>{
            const node = nodes[nodeIndex];
            const nodeDataKey = provider.nodeDataKey(node);
            providerSsrData[nodeDataKey] = nodeData;
            return providerSsrData;
        }, {});
        acc[provider.name] = {
            data: ssrData,
            success: success,
            duration: duration
        };
        return acc;
    }, {});
}
module.exports["prefetchNodeDataProvidersData"] = $33eee30649b8eece$export$65217f7ac34c2278;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("kY8KV", function(module, exports) {
/**
 * Adds data to the SSR editor node data providers store on the window object.
 * This allows multiple loaders to safely add data to the same object without
 * overwriting each other's data.
 *
 * @param data - The data to merge into the existing store
 */ function $5ae7655949a69969$export$a2bf498e230933ac(data) {
    const existingData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
    window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = {
        ...existingData,
        ...data
    };
}
module.exports["addToSSREditorNodeDataProvidersStore"] = $5ae7655949a69969$export$a2bf498e230933ac;

});

parcelRegister("6GukH", function(module, exports) {

var $45MGZ = parcelRequire("45MGZ");

const $86855d2f29349b22$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/syncedBlocksData';
async function $86855d2f29349b22$export$bd3ad760f826791(contentId, cloudId, isBlog, doc) {
    if (!contentId || !cloudId || typeof isBlog === 'undefined') return;
    return (0, $45MGZ.preloadSyncedBlocksData)({
        contentId: contentId,
        cloudId: cloudId,
        isBlog: isBlog,
        doc: doc,
        measureSegment: $86855d2f29349b22$var$MEASURE_SEGMENT
    });
}
module.exports["preloadEditorSyncedBlocksData"] = $86855d2f29349b22$export$bd3ad760f826791;

});

parcelRegister("45MGZ", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $l1vR8 = parcelRequire("l1vR8");

var $f8eu7 = parcelRequire("f8eu7");

var $47N43 = parcelRequire("47N43");

var $awHlv = parcelRequire("awHlv");


var $hceZu = parcelRequire("hceZu");


var $lBSlf = parcelRequire("lBSlf");


var $9WAeG = parcelRequire("9WAeG");


var $1i2qc = parcelRequire("1i2qc");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $3mugH = parcelRequire("3mugH");


var $kY8KV = parcelRequire("kY8KV");


var $8AcAF = parcelRequire("8AcAF");


var $l9Wsf = parcelRequire("l9Wsf");

const $8435e015d85a0f69$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/syncedBlocksData';
// Timeout for fetching synced block references in milliseconds
// This is currently set to higher value to account for potential network latencys
// We will monitor performance and adjust this value as needed
const $8435e015d85a0f69$var$DEFAULT_TIMEOUT = 1500;
// New default timeout for batch fetch implementation, which includes more relistics value
const $8435e015d85a0f69$var$DEFAULT_TIMEOUT_NEXT = 500;
async function $8435e015d85a0f69$export$1de9b28b2fdef558(options) {
    const { contentId: contentId, cloudId: cloudId, isBlog: isBlog, doc: doc, measureSegment: measureSegment, timeout: timeout } = options;
    // Check feature flags before attempting to fetch synced block data
    if (!contentId || !cloudId || !doc || !(0, $eTj7Y.isSSR)() || typeof isBlog === 'undefined' || !(0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false) && (0, $9wGTI.fg)('platform_synced_block_patch_8')) (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Skipped synced blocks preload: guard condition failed'), {
            isSsr: (0, $eTj7Y.isSSR)(),
            contentId: contentId,
            cloudId: cloudId,
            isBlog: isBlog
        });
        return;
    }
    const segmentName = measureSegment || $8435e015d85a0f69$var$MEASURE_SEGMENT;
    let blockNodeIdentifiers = [];
    // When FG is enabled, check for empty synced blocks BEFORE entering the measured run
    // so pages with no synced blocks don't record a metric for this segment
    if ((0, $9wGTI.fg)('platform_synced_block_patch_ssr')) {
        blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        if (blockNodeIdentifiers.length === 0) return;
    }
    if (doc && (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) {
        blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        // If no synced blocks found, return early
        if (blockNodeIdentifiers.length === 0) return;
    }
    await (0, $9WAeG.SSRMeasures).run(segmentName, async ()=>{
        // Use bulk load (batchFetchData) when doc is available
        if (doc) // Extract block identifiers from the ADF document
        {
            if (!(0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        }
        if (!(0, $9wGTI.fg)('platform_synced_block_patch_ssr')) {
            blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
            if (blockNodeIdentifiers.length === 0) return;
        }
        const syncBlockReferences = await $8435e015d85a0f69$export$9523b76ee01ef6d(contentId, cloudId, isBlog, blockNodeIdentifiers, segmentName, timeout);
        if (!syncBlockReferences) {
            if (blockNodeIdentifiers.length > 0 && (0, $9wGTI.fg)('platform_synced_block_patch_8')) (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Synced block fetch returned incomplete results: ${blockNodeIdentifiers.length} blocks missing`), {
                code: (0, $lBSlf.SyncedBlocksSSRErrorCodeMap).FETCH_INCOMPLETE,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                missingIdentifiers: blockNodeIdentifiers
            });
            return;
        }
        // check if results match the requested block identifiers, if not,
        // it means the fetch was likely incomplete/failed,
        if (syncBlockReferences.length !== blockNodeIdentifiers.length) {
            // Find which block identifiers are missing from the results
            const returnedIdentifiers = new Set(syncBlockReferences.map((ref)=>`${ref.resourceId}:${ref.data?.blockInstanceId ?? 'unknown'}`));
            const missingIdentifiers = blockNodeIdentifiers.filter((identifier)=>!returnedIdentifiers.has(`${identifier.resourceId}:${identifier.blockInstanceId}`));
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Synced block fetch returned incomplete results: ${missingIdentifiers.length} blocks missing`), {
                code: (0, $lBSlf.SyncedBlocksSSRErrorCodeMap).FETCH_INCOMPLETE,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                missingIdentifiers: missingIdentifiers
            });
        }
        (0, $kY8KV.addToSSREditorNodeDataProvidersStore)({
            syncBlocks: syncBlockReferences
        });
        const syncedBlocksWithMedia = syncBlockReferences.filter((syncBlock)=>{
            // Preload media data providers for synced blocks that contain media nodes
            const containedNodeTypes = (0, $8AcAF.syncBlockContainsNodes)(syncBlock, [
                'media'
            ]);
            return containedNodeTypes.length > 0 && containedNodeTypes.includes('media');
        });
        const tasks = [];
        syncedBlocksWithMedia.forEach((syncBlockInstance)=>{
            tasks.push($8435e015d85a0f69$export$6df3cdf918cdf771(syncBlockInstance));
        });
        await Promise.allSettled(tasks);
    });
}
async function $8435e015d85a0f69$export$6df3cdf918cdf771(syncBlock) {
    if (!syncBlock) return null;
    const { product: product, contentId: contentId } = (0, $47N43.parseResourceId)(syncBlock.resourceId) || {};
    if (!product || !contentId) return {
        resourceId: syncBlock.resourceId,
        result: undefined
    };
    if (product === 'confluence-page') {
        const result = await (0, $1i2qc.preloadMediaToken)(contentId);
        return {
            resourceId: syncBlock.resourceId,
            result: result
        };
    }
    if (product === 'jira-work-item') {
        const jiraIssueAri = syncBlock.data?.sourceAri;
        const result = jiraIssueAri ? await (0, $hceZu.fetchJiraMediaToken)(jiraIssueAri) : undefined;
        return {
            resourceId: syncBlock.resourceId,
            result: result
        };
    }
    return null;
}
function $8435e015d85a0f69$export$9523b76ee01ef6d(contentId, cloudId, isBlog, blockNodeIdentifiers, measureSegment = $8435e015d85a0f69$var$MEASURE_SEGMENT, timeout = (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false) ? $8435e015d85a0f69$var$DEFAULT_TIMEOUT_NEXT : $8435e015d85a0f69$var$DEFAULT_TIMEOUT) {
    return (0, $9WAeG.SSRMeasures).run(`${measureSegment}/fetch:SyncBlockReferences`, async ()=>{
        const pageAri = (0, $f8eu7.getConfluencePageAri)({
            cloudId: cloudId,
            pageId: contentId,
            pageType: isBlog ? 'blogpost' : 'page'
        });
        const timeoutError = new Error('timeout');
        let batchFetchDataConfig = undefined;
        if ((0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) batchFetchDataConfig = {
            timeoutMs: (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'timeout', null) ?? timeout,
            isSSR: (0, $eTj7Y.isSSR)(),
            maxBatchSize: (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'maxBatchSize', null) ?? undefined
        };
        try {
            let results;
            if ((0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) // We only passing the batchFetchDataConfig when the experiment is enabled,
            // however, batchFetchData is NOT gateed.
            results = await (0, $l1vR8.batchFetchData)(cloudId, pageAri, blockNodeIdentifiers, batchFetchDataConfig);
            else results = await Promise.race([
                (0, $l1vR8.batchFetchData)(cloudId, pageAri, blockNodeIdentifiers),
                new Promise((_resolve, reject)=>setTimeout(()=>{
                        reject(timeoutError);
                    }, timeout))
            ]);
            if (!results) {
                // No results returned - this could indicate a failure in the batch fetch operation
                // this would not be timeout, as it will throw a timeout error instead,
                // so we can attribute this to a fetch failure and log accordingly
                (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Synced blocks fetch returned no results'), {
                    code: (0, $lBSlf.SyncedBlocksSSRErrorCodeMap).BATCH_FETCH_FAILED,
                    contentId: contentId,
                    cloudId: cloudId,
                    isBlog: isBlog,
                    identifiers: blockNodeIdentifiers
                });
                return undefined;
            }
            // check if result is timeout error
            if (Array.isArray(results) && results.length > 0 && (0, $eTj7Y.isSSR)() && // we only want to apply this logic for SSR, as in client side we can allow for retries and better error handling.
            (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) {
                const isTimeout = results.some((result)=>(0, $awHlv.SyncBlockError).Aborted === result.error?.type);
                if (isTimeout) {
                    // This means the batch fetch operation timed out
                    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Synced blocks fetch operation timed out'), {
                        code: (0, $lBSlf.SyncedBlocksSSRErrorCodeMap).FETCH_TIMEOUT,
                        contentId: contentId,
                        cloudId: cloudId,
                        isBlog: isBlog,
                        identifiers: blockNodeIdentifiers
                    });
                    // we don't want to return timeout results,
                    // as it might cause error on the initial page load.
                    return undefined;
                }
            }
            return results;
        } catch (error) {
            // Network or API error
            const errorMessage = error instanceof Error ? error.message : String(error);
            const errorName = error instanceof Error ? error.name : undefined;
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Batch fetch for synced blocks failed: unable to fetch ${blockNodeIdentifiers.length} blocks`), {
                code: (0, $lBSlf.SyncedBlocksSSRErrorCodeMap).BATCH_FETCH_FAILED,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                errorMessage: errorMessage,
                errorName: errorName
            });
            return undefined;
        }
    });
}
module.exports["preloadSyncedBlocksData"] = $8435e015d85a0f69$export$1de9b28b2fdef558;

});

parcelRegister("l1vR8", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $ejAeh = parcelRequire("ejAeh");


var $7SvKC = parcelRequire("7SvKC");


var $bXEbs = parcelRequire("bXEbs");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $47N43 = parcelRequire("47N43");


var $gtauf = parcelRequire("gtauf");

const $b01c0675c087bdaf$var$mapBlockError = (error)=>{
    switch(error.status){
        case 400:
        case 401:
            return (0, $awHlv.SyncBlockError).InvalidRequest;
        case 403:
            return (0, $awHlv.SyncBlockError).Forbidden;
        case 404:
            return (0, $awHlv.SyncBlockError).NotFound;
        case 409:
            return (0, $awHlv.SyncBlockError).Conflict;
        case 429:
            return (0, $awHlv.SyncBlockError).RateLimited;
        case 500:
        case 503:
        case 504:
            return (0, $awHlv.SyncBlockError).ServerError;
    }
    return (0, $awHlv.SyncBlockError).Errored;
};
const $b01c0675c087bdaf$var$mapErrorResponseCode = (errorCode)=>{
    switch(errorCode){
        case 'FORBIDDEN':
            return (0, $awHlv.SyncBlockError).Forbidden;
        case 'RESOURCE_NOT_FOUND':
        case 'NOT_FOUND':
            return (0, $awHlv.SyncBlockError).NotFound;
        case 'EntityNotFound':
            return (0, $dh538.fg)('platform_synced_block_patch_9') ? (0, $awHlv.SyncBlockError).EntityNotFound : (0, $awHlv.SyncBlockError).Errored;
        case 'INVALID_REQUEST':
            return (0, $awHlv.SyncBlockError).InvalidRequest;
        case 'CONFLICT':
            return (0, $awHlv.SyncBlockError).Conflict;
        case 'RATE_LIMITED':
            return (0, $awHlv.SyncBlockError).RateLimited;
        case 'SERVER_ERROR':
            return (0, $awHlv.SyncBlockError).ServerError;
        case 'INVALID_CONTENT':
            return (0, $awHlv.SyncBlockError).InvalidContent;
        default:
            return (0, $awHlv.SyncBlockError).Errored;
    }
};
const $b01c0675c087bdaf$export$7a367d6c9621d11 = (blockAri)=>{
    // Validate ARI format and extract resourceId using regex
    // Format: ari:cloud:blocks:{uuid}:synced-block/{product}/{parentId}/{resourceId}
    // The regex captures the full path after synced-block/
    // e.g. ari:cloud:blocks:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:synced-block/confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    // should return confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    const match = blockAri.match(/^ari:cloud:blocks:.*:synced-block\/(.+)$/);
    return match?.[1] || null;
};
const $b01c0675c087bdaf$export$bba762cb095b2f42 = (data, resourceId)=>{
    let createdAt;
    if (data.createdAt !== undefined && data.createdAt !== null) try {
        createdAt = new Date(data.createdAt).toISOString();
    } catch  {
        // fallback to undefined
        // as we don't want to block the whole process due to invalid date
        createdAt = undefined;
    }
    return {
        blockInstanceId: data.blockInstanceId,
        content: JSON.parse(data.content),
        contentUpdatedAt: (0, $gtauf.convertContentUpdatedAt)(data.contentUpdatedAt),
        createdAt: createdAt,
        createdBy: data.createdBy,
        product: data.product,
        resourceId: resourceId,
        sourceAri: data.sourceAri,
        status: data.status
    };
};
const $b01c0675c087bdaf$export$17132bdfdc28611c = async (documentAri)=>{
    let response;
    try {
        response = await (0, $7SvKC.getReferenceSyncedBlocks)(documentAri);
    } catch (error) {
        if (error instanceof (0, $7SvKC.BlockError)) return $b01c0675c087bdaf$var$mapBlockError(error);
        return (0, $awHlv.SyncBlockError).Errored;
    }
    const { blocks: blocks, errors: errors } = response || {};
    const blocksInstances = (blocks || []).map((blockContentResponse)=>{
        try {
            const resourceId = $b01c0675c087bdaf$export$7a367d6c9621d11(blockContentResponse.blockAri);
            if (!resourceId) // could not extract resourceId from blockAri, return InvalidContent error
            return {
                error: {
                    type: (0, $awHlv.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
            return {
                data: $b01c0675c087bdaf$export$bba762cb095b2f42(blockContentResponse, resourceId),
                resourceId: resourceId
            };
        } catch  {
            // JSON parsing error, return InvalidContent error
            return {
                error: {
                    type: (0, $awHlv.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
        }
    });
    const errorInstances = (errors || []).map((errorBlock)=>({
            error: {
                type: (0, $awHlv.SyncBlockError).Errored
            },
            resourceId: errorBlock.blockAri
        }));
    return [
        ...blocksInstances,
        ...errorInstances
    ];
};
const $b01c0675c087bdaf$export$2837853885c81488 = (blockAri)=>{
    const match = blockAri.match(/ari:cloud:blocks:[^:]+:synced-block\/(.+)$/);
    return match?.[1];
};
const $b01c0675c087bdaf$export$abdcb5d4d6767e73 = async (cloudId, parentAri, blockNodeIdentifiers, config)=>{
    const blockIdentifiers = blockNodeIdentifiers.map((blockIdentifier)=>({
            blockAri: (0, $ejAeh.generateBlockAriFromReference)({
                cloudId: cloudId,
                resourceId: blockIdentifier.resourceId
            }),
            blockInstanceId: blockIdentifier.blockInstanceId
        }));
    // Create a set of valid resourceIds for validation
    const validResourceIds = new Set(blockNodeIdentifiers.map((blockNodeIdentifier)=>blockNodeIdentifier.resourceId));
    // Track which resourceIds have been processed
    const processedResourceIds = new Set();
    if (!parentAri) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
            error: {
                type: (0, $awHlv.SyncBlockError).Errored
            },
            resourceId: blockNodeIdentifier.resourceId
        }));
    try {
        const response = await (0, $7SvKC.batchRetrieveSyncedBlocks)({
            blockIdentifiers: blockIdentifiers,
            config: config
        });
        const results = [];
        // Process successful blocks
        if (response.success) for (const blockContentResponse of response.success){
            // Extract resourceId from the returned blockAri
            const resourceId = $b01c0675c087bdaf$export$2837853885c81488(blockContentResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            const { content: content, deletionReason: deletionReason, sourceAri: sourceAri, blockAri: blockAri, contentUpdatedAt: contentUpdatedAt, blockInstanceId: blockInstanceId, product: product, status: status } = blockContentResponse;
            if (!content) {
                results.push({
                    error: {
                        type: (0, $awHlv.SyncBlockError).NotFound,
                        reason: deletionReason,
                        sourceAri: sourceAri
                    },
                    resourceId: resourceId
                });
                continue;
            }
            try {
                const syncedBlockData = JSON.parse(content);
                results.push({
                    data: {
                        content: syncedBlockData,
                        resourceId: blockAri,
                        contentUpdatedAt: (0, $gtauf.convertContentUpdatedAt)(contentUpdatedAt),
                        blockInstanceId: blockInstanceId,
                        sourceAri: sourceAri,
                        product: product,
                        status: status,
                        deletionReason: deletionReason
                    },
                    resourceId: resourceId
                });
            } catch  {
                results.push({
                    error: {
                        type: (0, $awHlv.SyncBlockError).Errored,
                        reason: `parsing JSON content response failed for resourceId: ${resourceId} localId: ${blockAri}`
                    },
                    resourceId: resourceId
                });
            }
        }
        // Process errors
        if (response.error) for (const errorResponse of response.error){
            // Extract resourceId from the returned blockAri
            const resourceId = $b01c0675c087bdaf$export$2837853885c81488(errorResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            results.push({
                error: {
                    type: $b01c0675c087bdaf$var$mapErrorResponseCode(errorResponse.code),
                    reason: errorResponse.reason
                },
                resourceId: resourceId
            });
        }
        // Ensure all resourceIds have a result - return NotFound for any missing ones
        for (const blockNodeIdentifier of blockNodeIdentifiers)if (!processedResourceIds.has(blockNodeIdentifier.resourceId)) results.push({
            error: {
                type: (0, $awHlv.SyncBlockError).NotFound
            },
            resourceId: blockNodeIdentifier.resourceId
        });
        return results;
    } catch (error) {
        if (error instanceof (0, $7SvKC.BlockTimeoutError) && (0, $1oCLl.expValEquals)('platform_editor_sync_block_ssr_config', 'isEnabled', true)) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: (0, $awHlv.SyncBlockError).Aborted,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
        // If batch request fails, return error for all resourceIds
        return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: error instanceof (0, $7SvKC.BlockError) ? $b01c0675c087bdaf$var$mapBlockError(error) : (0, $awHlv.SyncBlockError).Errored,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
    }
};
const $b01c0675c087bdaf$export$13b682467148f88a = async (cloudId, parentAri, parentId, product, data, stepVersion)=>{
    if (!parentAri || !parentId) return data.map((block)=>({
            error: (0, $awHlv.SyncBlockError).Errored,
            resourceId: block.resourceId
        }));
    try {
        // Create a map from blockAri to original resourceId for matching responses
        const blockAriToResourceIdMap = new Map();
        const blocks = data.map((block)=>{
            const blockAri = (0, $ejAeh.generateBlockAri)({
                cloudId: cloudId,
                parentId: parentId,
                product: product,
                resourceId: block.resourceId
            });
            blockAriToResourceIdMap.set(blockAri, block.resourceId);
            return {
                blockAri: blockAri,
                content: JSON.stringify(block.content),
                status: block.status,
                stepVersion: stepVersion
            };
        });
        const response = await (0, $7SvKC.updateSyncedBlocks)({
            blocks: blocks
        });
        const results = [];
        // Process successful updates
        if (response.success) {
            const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
            for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                resourceId: block.resourceId
            });
        }
        if (response.error) {
            const errorResourceIds = new Map(response.error.map((err)=>[
                    // Use the map to get the original resourceId
                    blockAriToResourceIdMap.get(err.blockAri) || '',
                    $b01c0675c087bdaf$var$mapErrorResponseCode(err.code)
                ]));
            for (const block of data){
                const error = errorResourceIds.get(block.resourceId);
                if (error) results.push({
                    error: error,
                    resourceId: block.resourceId
                });
                else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                results.push({
                    error: (0, $awHlv.SyncBlockError).Errored,
                    resourceId: block.resourceId
                });
            }
        }
        return results;
    } catch (error) {
        if (error instanceof (0, $7SvKC.BlockError)) return data.map((block)=>({
                error: $b01c0675c087bdaf$var$mapBlockError(error),
                resourceId: block.resourceId
            }));
        return data.map((block)=>({
                error: (0, $cFpEg.stringifyError)(error),
                resourceId: block.resourceId
            }));
    }
};
/**
 * ADFFetchProvider implementation that fetches synced block data from Block Service API
 */ class $b01c0675c087bdaf$var$BlockServiceADFFetchProvider {
    // resourceId of the reference synced block.
    // the ARI must be constructed to call the block service API
    async fetchData(resourceId) {
        const blockAri = (0, $ejAeh.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        try {
            const blockContentResponse = await (0, $7SvKC.getSyncedBlockContent)({
                blockAri: blockAri
            });
            const { content: content, sourceAri: sourceAri, deletionReason: deletionReason, blockInstanceId: blockInstanceId, contentUpdatedAt: contentUpdatedAt, product: product, status: status } = blockContentResponse;
            if (!content) return {
                error: {
                    type: (0, $awHlv.SyncBlockError).NotFound,
                    reason: deletionReason,
                    sourceAri: sourceAri
                },
                resourceId: resourceId
            };
            // Parse the synced block content from the response's content
            const syncedBlockData = JSON.parse(content);
            return {
                data: {
                    content: syncedBlockData,
                    resourceId: blockAri,
                    blockInstanceId: blockInstanceId,
                    // this was the node's localId, but has become the resourceId.
                    contentUpdatedAt: (0, $gtauf.convertContentUpdatedAt)(contentUpdatedAt),
                    sourceAri: sourceAri,
                    product: product,
                    status: status,
                    deletionReason: deletionReason
                },
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                error: {
                    type: $b01c0675c087bdaf$var$mapBlockError(error),
                    reason: error.message
                },
                resourceId: resourceId
            };
            return {
                error: {
                    type: (0, $awHlv.SyncBlockError).Errored,
                    reason: error.message
                },
                resourceId: resourceId
            };
        }
    }
    async fetchReferences(referenceResourceId) {
        try {
            const blockAri = (0, $ejAeh.generateBlockAriFromReference)({
                cloudId: this.cloudId,
                resourceId: referenceResourceId
            });
            const response = await (0, $7SvKC.getReferenceSyncedBlocksByBlockAri)({
                blockAri: blockAri
            });
            const references = [];
            response.references.forEach((reference)=>{
                references.push({
                    ...reference,
                    hasAccess: true,
                    onSameDocument: this.parentAri === reference.documentAri
                });
            });
            response.errors.forEach((reference)=>{
                if (reference.code === 'FORBIDDEN') references.push({
                    blockAri: reference.blockAri,
                    documentAri: reference.documentAri,
                    hasAccess: false,
                    onSameDocument: false
                });
            });
            return {
                references: references
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                error: $b01c0675c087bdaf$var$mapBlockError(error)
            };
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
    }
    /**
   * Batch fetches multiple synced blocks by their resource IDs.
   * @param blockNodeIdentifiers - Array of block node identifiers to fetch
   * @param config - Optional batch fetch configuration
   * @returns Array of SyncBlockInstance results
   */ async batchFetchData(blockNodeIdentifiers, config) {
        return await $b01c0675c087bdaf$export$abdcb5d4d6767e73(this.cloudId, this.parentAri, blockNodeIdentifiers, config);
    }
    /**
   * Subscribes to real-time updates for a specific block using GraphQL WebSocket subscriptions.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError) {
        const blockAri = (0, $ejAeh.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        return (0, $bXEbs.subscribeToBlockUpdates)(blockAri, (parsedData)=>{
            // Convert ParsedBlockSubscriptionData to SyncBlockInstance
            const syncBlockInstance = {
                data: {
                    content: parsedData.content,
                    resourceId: parsedData.blockAri,
                    blockInstanceId: parsedData.blockInstanceId,
                    sourceAri: parsedData.sourceAri,
                    product: parsedData.product,
                    createdAt: parsedData.createdAt,
                    contentUpdatedAt: parsedData.contentUpdatedAt,
                    createdBy: parsedData.createdBy,
                    status: parsedData.status
                },
                resourceId: parsedData.resourceId
            };
            onUpdate(syncBlockInstance);
        }, onError);
    }
    constructor({ cloudId: cloudId, parentAri: parentAri }){
        this.cloudId = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Block Service API
 */ class $b01c0675c087bdaf$var$BlockServiceADFWriteProvider {
    async writeData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $awHlv.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $ejAeh.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            const status = data.status;
            await (0, $7SvKC.updateSyncedBlock)({
                blockAri: blockAri,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                error: $b01c0675c087bdaf$var$mapBlockError(error),
                resourceId: resourceId
            };
            return {
                error: (0, $cFpEg.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    async createData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $awHlv.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $ejAeh.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        const status = 'unpublished';
        try {
            await (0, $7SvKC.createSyncedBlock)({
                blockAri: blockAri,
                blockInstanceId: data.blockInstanceId,
                sourceAri: this.parentAri,
                product: this.product,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                error: $b01c0675c087bdaf$var$mapBlockError(error),
                resourceId: resourceId
            };
            return {
                error: (0, $cFpEg.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    // soft deletes the source synced block
    async deleteData(resourceId, deleteReason) {
        if (!this.parentId) return {
            resourceId: resourceId,
            success: false,
            error: (0, $awHlv.SyncBlockError).Errored
        };
        const blockAri = (0, $ejAeh.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        try {
            await (0, $7SvKC.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockNotFoundError) && this.parentAri && (0, $dh538.fg)('platform_synced_block_patch_8')) return this.deleteOrphanBlock({
                blockAri: blockAri,
                resourceId: resourceId,
                parentAri: this.parentAri,
                deleteReason: deleteReason
            });
            if (error instanceof (0, $7SvKC.BlockError)) {
                if (error.status === 404) // User should not be blocked by not_found error when deleting,
                // hence returns successful result for 404 error
                return {
                    resourceId: resourceId,
                    success: true
                };
                return {
                    resourceId: resourceId,
                    success: false,
                    error: $b01c0675c087bdaf$var$mapBlockError(error)
                };
            }
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $cFpEg.stringifyError)(error)
            };
        }
    }
    // The block is an orphan (e.g. from a copied page) — it doesn't exist in Block Service.
    // Block Service uses soft-deletes, so we must first create the block then delete it,
    // ensuring a deletion-reason record is stored (used to display errors in reference blocks).
    async deleteOrphanBlock({ blockAri: blockAri, resourceId: resourceId, parentAri: parentAri, deleteReason: deleteReason }) {
        try {
            const stepVersion = this.getVersion ? await this.getVersion() : undefined;
            try {
                await (0, $7SvKC.createSyncedBlock)({
                    blockAri: blockAri,
                    blockInstanceId: resourceId,
                    sourceAri: parentAri,
                    product: this.product,
                    content: '[]',
                    stepVersion: stepVersion
                });
            } catch (createError) {
                // "Conditional check failed" means the block already exists in Block Service.
                // This can happen when an orphan block is copied and pasted — a reference block repair
                // in the backend may have already created it. We can proceed directly to delete it.
                if (createError instanceof Error && createError.message.includes('Conditional check failed')) ;
                else if (createError instanceof (0, $7SvKC.BlockError)) return {
                    resourceId: resourceId,
                    success: false,
                    error: $b01c0675c087bdaf$var$mapBlockError(createError)
                };
                else return {
                    resourceId: resourceId,
                    success: false,
                    error: (0, $cFpEg.stringifyError)(createError)
                };
            }
            await (0, $7SvKC.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                resourceId: resourceId,
                success: false,
                error: $b01c0675c087bdaf$var$mapBlockError(error)
            };
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $cFpEg.stringifyError)(error)
            };
        }
    }
    // the sourceId is the resourceId of the source synced block.
    generateResourceIdForReference(sourceId) {
        return (0, $47N43.createResourceIdForReference)(this.product, this.parentId || '', sourceId);
    }
    generateResourceId() {
        return crypto.randomUUID();
    }
    generateBlockAri(resourceId) {
        return (0, $ejAeh.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId || '',
            product: this.product,
            resourceId: resourceId
        });
    }
    async updateReferenceData(blocks, noContent) {
        if (!this.parentAri) return {
            success: false,
            error: (0, $awHlv.SyncBlockError).Errored
        };
        try {
            await (0, $7SvKC.updateReferenceSyncedBlockOnDocument)({
                documentAri: this.parentAri,
                blocks: blocks.map((block)=>({
                        blockAri: (0, $ejAeh.generateBlockAriFromReference)({
                            cloudId: this.cloudId,
                            resourceId: block.resourceId
                        }),
                        blockInstanceId: block.localId
                    })),
                noContent: noContent
            });
            return {
                success: true
            };
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return {
                success: false,
                error: $b01c0675c087bdaf$var$mapBlockError(error)
            };
            return {
                success: false,
                error: (0, $cFpEg.stringifyError)(error)
            };
        }
    }
    async writeDataBatch(data) {
        if (!this.parentAri || !this.parentId) return data.map((block)=>({
                error: (0, $awHlv.SyncBlockError).Errored,
                resourceId: block.resourceId
            }));
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            // Create a map from blockAri to original resourceId for matching responses
            const blockAriToResourceIdMap = new Map();
            const blocks = data.map((block)=>{
                const blockAri = this.generateBlockAri(block.resourceId);
                blockAriToResourceIdMap.set(blockAri, block.resourceId);
                return {
                    blockAri: blockAri,
                    content: JSON.stringify(block.content),
                    status: block.status,
                    stepVersion: stepVersion
                };
            });
            const response = await (0, $7SvKC.updateSyncedBlocks)({
                blocks: blocks
            });
            const results = [];
            // Process successful updates
            if (response.success) {
                const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
                for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                    resourceId: block.resourceId
                });
            }
            if (response.error) {
                const errorResourceIds = new Map(response.error.map((err)=>[
                        // Use the map to get the original resourceId
                        blockAriToResourceIdMap.get(err.blockAri) || '',
                        $b01c0675c087bdaf$var$mapErrorResponseCode(err.code)
                    ]));
                for (const block of data){
                    const error = errorResourceIds.get(block.resourceId);
                    if (error) {
                        if (error !== (0, $awHlv.SyncBlockError).NotFound) results.push({
                            error: error,
                            resourceId: block.resourceId
                        });
                    } else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                    results.push({
                        error: (0, $awHlv.SyncBlockError).Errored,
                        resourceId: block.resourceId
                    });
                }
            }
            return results;
        } catch (error) {
            if (error instanceof (0, $7SvKC.BlockError)) return data.map((block)=>({
                    error: $b01c0675c087bdaf$var$mapBlockError(error),
                    resourceId: block.resourceId
                }));
            return data.map((block)=>({
                    error: (0, $cFpEg.stringifyError)(error),
                    resourceId: block.resourceId
                }));
        }
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion }){
        this.cloudId = void 0;
        this.parentId = void 0;
        this.getVersion = void 0;
        this.product = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
        this.getVersion = getVersion;
    }
}
const $b01c0675c087bdaf$var$createBlockServiceAPIProviders = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return {
        fetchProvider: new $b01c0675c087bdaf$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: new $b01c0675c087bdaf$var$BlockServiceADFWriteProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        })
    };
};
const $b01c0675c087bdaf$export$ec654f5ac7e6d976 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return (0, $42omo.useMemo)(()=>{
        return $b01c0675c087bdaf$var$createBlockServiceAPIProviders({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        });
    }, [
        cloudId,
        parentAri,
        parentId,
        product,
        getVersion
    ]);
};
const $b01c0675c087bdaf$var$createBlockServiceFetchOnlyAPIProvider = ({ cloudId: cloudId, parentAri: parentAri })=>{
    return {
        fetchProvider: new $b01c0675c087bdaf$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: undefined
    };
};
const $b01c0675c087bdaf$export$1e67317f82b65067 = ({ cloudId: cloudId, parentAri: parentAri })=>(0, $42omo.useMemo)(()=>$b01c0675c087bdaf$var$createBlockServiceFetchOnlyAPIProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }), [
        cloudId,
        parentAri
    ]);
module.exports["batchFetchData"] = $b01c0675c087bdaf$export$abdcb5d4d6767e73;
module.exports["useMemoizedBlockServiceAPIProviders"] = $b01c0675c087bdaf$export$ec654f5ac7e6d976;

});

parcelRegister("ejAeh", function(module, exports) {
/* eslint-disable require-unicode-regexp */ const $111bb5a84f82538f$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $111bb5a84f82538f$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $111bb5a84f82538f$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match(/ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $111bb5a84f82538f$export$c10656f449ea0fb5 = (ari)=>{
    const jiraMatch = ari?.search(/ari:cloud:jira:.*/);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search(/ari:cloud:confluence:.*/);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $111bb5a84f82538f$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $111bb5a84f82538f$export$92a2331f8a9ed841;
module.exports["getProductFromSourceAri"] = $111bb5a84f82538f$export$c10656f449ea0fb5;

});

parcelRegister("7SvKC", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $k2in1 = parcelRequire("k2in1");

const $619122aa51211846$export$f426a9918d7f49b3 = (response)=>{
    const content = response.content;
    return typeof content === 'string';
};
const $619122aa51211846$export$571f6abc3f4e5951 = async (documentAri)=>{
    const bodyData = {
        query: $619122aa51211846$var$buildGetDocumentReferenceBlocksQuery(documentAri),
        operationName: $619122aa51211846$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetDocumentReferenceBlocks`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getDocumentReferenceBlocks;
};
const $619122aa51211846$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $619122aa51211846$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $619122aa51211846$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_DOCUMENT_REFERENCE_BLOCKS';
const $619122aa51211846$var$UPDATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_BLOCK';
const $619122aa51211846$var$DELETE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE_BLOCK';
const $619122aa51211846$var$CREATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE_BLOCK';
const $619122aa51211846$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_DOCUMENT_REFERENCES';
const $619122aa51211846$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_RETRIEVE_BLOCKS';
const $619122aa51211846$var$GET_BLOCK_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_REFERENCES';
const $619122aa51211846$var$GET_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_BLOCK';
const $619122aa51211846$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_UPDATE_BLOCKS';
const $619122aa51211846$var$buildGetDocumentReferenceBlocksQuery = (documentAri)=>`query ${$619122aa51211846$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME} {
	blockService_getDocumentReferenceBlocks(documentAri: ${JSON.stringify(documentAri)}) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
const $619122aa51211846$var$buildGetBlockQuery = (blockAri)=>`query ${$619122aa51211846$var$GET_BLOCK_OPERATION_NAME} {
	blockService_getBlock(blockAri: ${JSON.stringify(blockAri)}) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
const $619122aa51211846$var$buildUpdateBlockMutation = (blockAri, content, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `content: ${JSON.stringify(content)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$619122aa51211846$var$UPDATE_BLOCK_OPERATION_NAME} {
	blockService_updateBlock(input: { ${inputArgs} }) {
		__typename
	}
}`;
};
const $619122aa51211846$var$buildDeleteBlockMutation = (blockAri, deletionReason)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`
    ];
    if (deletionReason !== undefined) inputParts.push(`deletionReason: ${JSON.stringify(deletionReason)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$619122aa51211846$var$DELETE_BLOCK_OPERATION_NAME} {
	blockService_deleteBlock(input: { ${inputArgs} }) {
		deleted
	}
}`;
};
/**
 * Converts product string to GraphQL enum format
 * 'confluence-page' -> 'CONFLUENCE_PAGE'
 * 'jira-work-item' -> 'JIRA_WORK_ITEM'
 */ const $619122aa51211846$var$convertProductToGraphQLEnum = (product)=>{
    switch(product){
        case 'confluence-page':
            return 'CONFLUENCE_PAGE';
        case 'jira-work-item':
            return 'JIRA_WORK_ITEM';
        default:
            {
                const exhaustiveCheck = product;
                throw new Error(`Unsupported product: ${exhaustiveCheck}`);
            }
    }
};
const $619122aa51211846$var$buildCreateBlockMutation = (blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `blockInstanceId: ${JSON.stringify(blockInstanceId)}`,
        `content: ${JSON.stringify(content)}`,
        `product: ${$619122aa51211846$var$convertProductToGraphQLEnum(product)}`,
        `sourceAri: ${JSON.stringify(sourceAri)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$619122aa51211846$var$CREATE_BLOCK_OPERATION_NAME} {
	blockService_createBlock(input: { ${inputArgs} }) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
};
const $619122aa51211846$var$buildUpdateDocumentReferencesMutation = (documentAri, blocks, noContent)=>{
    const blocksArray = blocks.map((block)=>`{ blockAri: ${JSON.stringify(block.blockAri)}, blockInstanceId: ${JSON.stringify(block.blockInstanceId)} }`).join(', ');
    const inputArgs = `documentAri: ${JSON.stringify(documentAri)}, blocks: [${blocksArray}], noContent: ${noContent}`;
    return `mutation ${$619122aa51211846$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME} {
	blockService_updateDocumentReferences(input: { ${inputArgs} }) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $619122aa51211846$var$buildBatchRetrieveBlocksQuery = (blockAris)=>{
    const blockArisArray = blockAris.map((ari)=>JSON.stringify(ari)).join(', ');
    const inputArgs = `blockAris: [${blockArisArray}]`;
    return `query ${$619122aa51211846$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME} {
	blockService_batchRetrieveBlocks(input: { ${inputArgs} }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
const $619122aa51211846$var$buildGetBlockReferencesQuery = (blockAri)=>{
    return `query ${$619122aa51211846$var$GET_BLOCK_REFERENCES_OPERATION_NAME} {
	blockService_getReferences(blockAri: ${JSON.stringify(blockAri)}) {
		references {
			blockAri
			blockInstanceId
			createdAt
			createdBy
			documentAri
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $619122aa51211846$var$buildBatchUpdateBlocksMutation = (blocks)=>{
    const blocksArray = blocks.map((block)=>{
        const inputParts = [
            `blockAri: ${JSON.stringify(block.blockAri)}`,
            `content: ${JSON.stringify(block.content)}`
        ];
        if (block.stepVersion !== undefined) inputParts.push(`stepVersion: ${block.stepVersion}`);
        if (block.status !== undefined) inputParts.push(`status: ${JSON.stringify(block.status)}`);
        return `{ ${inputParts.join(', ')} }`;
    }).join(', ');
    return `mutation ${$619122aa51211846$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME} {
	blockService_batchUpdateBlocks(input: { blocks: [${blocksArray}] }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
class $619122aa51211846$export$e47a0a94b0998697 extends Error {
    constructor(status){
        super(`Block error`), this.status = status;
    }
}
class $619122aa51211846$export$f5a00468af285e38 extends Error {
    constructor(){
        super('Block not found in Block Service');
        this.name = 'BlockNotFoundError';
    }
}
class $619122aa51211846$export$b5687000eb0902be extends Error {
    constructor(){
        super('Block request timed out');
        this.name = 'BlockTimeoutError';
    }
}
const $619122aa51211846$export$fab66d51cc0c1a7 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildGetBlockQuery(blockAri),
        operationName: $619122aa51211846$var$GET_BLOCK_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetBlock`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getBlock) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getBlock;
};
const $619122aa51211846$export$48a4f565308f4741 = async ({ blockIdentifiers: blockIdentifiers, config: config })=>{
    const blockAris = blockIdentifiers.map((blockIdentifier)=>blockIdentifier.blockAri);
    const bodyData = {
        query: $619122aa51211846$var$buildBatchRetrieveBlocksQuery(blockAris),
        operationName: $619122aa51211846$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchRetrieveBlocks`;
    // undefined or 0 or negative means no timeout,
    // We don't enforce a minimum timeout for simplicity
    const fetchPromise = (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    const timeoutMs = config?.timeoutMs ?? 0;
    const response = await (timeoutMs > 0 ? Promise.race([
        fetchPromise,
        new Promise((_, reject)=>setTimeout(()=>reject(new $619122aa51211846$export$b5687000eb0902be()), timeoutMs))
    ]) : fetchPromise);
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchRetrieveBlocks) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_batchRetrieveBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
const $619122aa51211846$export$cbbc86409cac3ee5 = async ({ blockAri: blockAri, deleteReason: deleteReason })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildDeleteBlockMutation(blockAri, deleteReason),
        operationName: $619122aa51211846$var$DELETE_BLOCK_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockDeleteBlock`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) {
        if ((0, $dh538.fg)('platform_synced_block_patch_8')) {
            const allNotFound = result.errors.every((e)=>e.extensions?.errorType === 'RESOURCE_NOT_FOUND');
            if (allNotFound) // Throw BlockNotFoundError so the caller can create the block first then retry the delete.
            // Block Service uses soft-deletes: the entry must exist before deletion so a deletion-reason
            // is stored (used to display errors in reference blocks).
            throw new $619122aa51211846$export$f5a00468af285e38();
        }
        throw new Error(result.errors.map((e)=>e.message).join(', '));
    }
    const isDeleted = result.data?.blockService_deleteBlock?.deleted;
    if (!isDeleted) throw new Error('Block deletion failed; deleted flag is false');
};
const $619122aa51211846$export$d5bf0c5618431e5e = async ({ blockAri: blockAri, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildUpdateBlockMutation(blockAri, content, stepVersion, status),
        operationName: $619122aa51211846$var$UPDATE_BLOCK_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateBlock`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
};
const $619122aa51211846$export$fbc30658d812c800 = async ({ blockAri: blockAri, blockInstanceId: blockInstanceId, sourceAri: sourceAri, product: product, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildCreateBlockMutation(blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status),
        operationName: $619122aa51211846$var$CREATE_BLOCK_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockCreateBlock`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_createBlock) throw new Error('No data returned from GraphQL mutation');
    return result.data.blockService_createBlock;
};
const $619122aa51211846$export$59c7369fa04bcba1 = async ({ documentAri: documentAri, blocks: blocks, noContent: noContent = true })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildUpdateDocumentReferencesMutation(documentAri, blocks, noContent),
        operationName: $619122aa51211846$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateDocumentReferences`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData),
        keepalive: true
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!noContent) {
        if (!result.data?.blockService_updateDocumentReferences) throw new Error('No data returned from GraphQL mutation');
        return result.data.blockService_updateDocumentReferences;
    }
};
const $619122aa51211846$export$75f5aeff9ce22a33 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildGetBlockReferencesQuery(blockAri),
        operationName: $619122aa51211846$var$GET_BLOCK_REFERENCES_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetReferences`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getReferences) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_getReferences;
    return {
        blockAri: blockAri,
        references: graphqlResponse.references || [],
        errors: graphqlResponse.errors || []
    };
};
const $619122aa51211846$export$a9e53fa4329b5ed2 = async ({ blocks: blocks })=>{
    const bodyData = {
        query: $619122aa51211846$var$buildBatchUpdateBlocksMutation(blocks),
        operationName: $619122aa51211846$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME
    };
    const url = `${$619122aa51211846$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchUpdateBlocks`;
    const response = await (0, $k2in1.fetchWithRetry)(url, {
        method: 'POST',
        headers: $619122aa51211846$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $619122aa51211846$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchUpdateBlocks) throw new Error('No data returned from GraphQL mutation');
    const graphqlResponse = result.data.blockService_batchUpdateBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
module.exports["getReferenceSyncedBlocks"] = $619122aa51211846$export$571f6abc3f4e5951;
module.exports["BlockError"] = $619122aa51211846$export$e47a0a94b0998697;
module.exports["BlockNotFoundError"] = $619122aa51211846$export$f5a00468af285e38;
module.exports["BlockTimeoutError"] = $619122aa51211846$export$b5687000eb0902be;
module.exports["getSyncedBlockContent"] = $619122aa51211846$export$fab66d51cc0c1a7;
module.exports["batchRetrieveSyncedBlocks"] = $619122aa51211846$export$48a4f565308f4741;
module.exports["deleteSyncedBlock"] = $619122aa51211846$export$cbbc86409cac3ee5;
module.exports["updateSyncedBlock"] = $619122aa51211846$export$d5bf0c5618431e5e;
module.exports["createSyncedBlock"] = $619122aa51211846$export$fbc30658d812c800;
module.exports["updateReferenceSyncedBlockOnDocument"] = $619122aa51211846$export$59c7369fa04bcba1;
module.exports["getReferenceSyncedBlocksByBlockAri"] = $619122aa51211846$export$75f5aeff9ce22a33;
module.exports["updateSyncedBlocks"] = $619122aa51211846$export$a9e53fa4329b5ed2;

});

parcelRegister("bXEbs", function(module, exports) {

var $lrJXD = parcelRequire("lrJXD");


var $eTj7Y = parcelRequire("eTj7Y");


var $dh538 = parcelRequire("dh538");


var $gtauf = parcelRequire("gtauf");

const $cadfedcfbb7922e8$var$GRAPHQL_WS_ENDPOINT = '/gateway/api/graphql/subscriptions';
let $cadfedcfbb7922e8$var$blockServiceClient = null;
/**
 * Tracks the last known WebSocket connection context for diagnostics.
 * Since browser WebSocket errors are intentionally opaque ({isTrusted: true}),
 * we capture lifecycle events to provide meaningful context when errors occur.
 */ const $cadfedcfbb7922e8$var$connectionDiagnostics = {
    /** Whether the last connection attempt was a retry */ wasRetry: false,
    /** Timestamp of the last successful connection */ lastConnectedAt: 0,
    /** The close code from the most recent WebSocket CloseEvent, see (https://websocket.org/reference/close-codes/)*/ lastCloseCode: 0,
    /** The close reason from the most recent WebSocket CloseEvent */ lastCloseReason: '',
    /** Whether the last close was clean */ lastCloseWasClean: true,
    /** Current connection state */ state: 'idle',
    /** Number of consecutive connection failures */ consecutiveFailures: 0
};
const $cadfedcfbb7922e8$export$a3e5e470773b1f2b = ()=>{
    const parts = [];
    if ($cadfedcfbb7922e8$var$connectionDiagnostics.lastCloseCode !== 0) {
        parts.push(`lastCloseCode=${$cadfedcfbb7922e8$var$connectionDiagnostics.lastCloseCode}`);
        parts.push(`lastCloseReason="${$cadfedcfbb7922e8$var$connectionDiagnostics.lastCloseReason || 'none'}"`);
        parts.push(`wasClean=${$cadfedcfbb7922e8$var$connectionDiagnostics.lastCloseWasClean}`);
    }
    parts.push(`state=${$cadfedcfbb7922e8$var$connectionDiagnostics.state}`);
    parts.push(`wasRetry=${$cadfedcfbb7922e8$var$connectionDiagnostics.wasRetry}`);
    parts.push(`consecutiveFailures=${$cadfedcfbb7922e8$var$connectionDiagnostics.consecutiveFailures}`);
    if ($cadfedcfbb7922e8$var$connectionDiagnostics.lastConnectedAt > 0) {
        const elapsed = Date.now() - $cadfedcfbb7922e8$var$connectionDiagnostics.lastConnectedAt;
        parts.push(`timeSinceLastConnection=${elapsed}ms`);
    }
    return parts.join(', ');
};
const $cadfedcfbb7922e8$var$getBlockServiceClient = ()=>{
    // Don't create client during SSR
    if ((0, $eTj7Y.isSSR)()) return null;
    if (!$cadfedcfbb7922e8$var$blockServiceClient) {
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        const wsUrl = `${protocol}//${window.location.host}${$cadfedcfbb7922e8$var$GRAPHQL_WS_ENDPOINT}`;
        $cadfedcfbb7922e8$var$blockServiceClient = (0, $lrJXD.createClient)({
            url: wsUrl,
            lazy: true,
            retryAttempts: 3,
            on: (0, $dh538.fg)('platform_synced_block_add_info_web_socket_error') ? {
                connecting: (isRetry)=>{
                    $cadfedcfbb7922e8$var$connectionDiagnostics.wasRetry = isRetry;
                    $cadfedcfbb7922e8$var$connectionDiagnostics.state = 'connecting';
                },
                connected: (_socket, _payload, wasRetry)=>{
                    $cadfedcfbb7922e8$var$connectionDiagnostics.state = 'connected';
                    $cadfedcfbb7922e8$var$connectionDiagnostics.lastConnectedAt = Date.now();
                    $cadfedcfbb7922e8$var$connectionDiagnostics.wasRetry = wasRetry;
                    $cadfedcfbb7922e8$var$connectionDiagnostics.consecutiveFailures = 0;
                },
                closed: (event)=>{
                    $cadfedcfbb7922e8$var$connectionDiagnostics.state = 'closed';
                    const closeEvent = event;
                    $cadfedcfbb7922e8$var$connectionDiagnostics.lastCloseCode = closeEvent.code ?? 0;
                    $cadfedcfbb7922e8$var$connectionDiagnostics.lastCloseReason = closeEvent.reason ?? '';
                    $cadfedcfbb7922e8$var$connectionDiagnostics.lastCloseWasClean = closeEvent.wasClean ?? false;
                },
                error: ()=>{
                    $cadfedcfbb7922e8$var$connectionDiagnostics.state = 'error';
                    $cadfedcfbb7922e8$var$connectionDiagnostics.consecutiveFailures += 1;
                }
            } : undefined
        });
    }
    return $cadfedcfbb7922e8$var$blockServiceClient;
};
const $cadfedcfbb7922e8$var$SUBSCRIPTION_QUERY = `
subscription EDITOR_SYNCED_BLOCK_ON_BLOCK_UPDATED($resourceId: ID!) {
	blockService_onBlockUpdated(resourceId: $resourceId) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
	}
}
`;
const $cadfedcfbb7922e8$export$307d3f85d27f6d40 = (error)=>{
    const diagnostics = $cadfedcfbb7922e8$export$a3e5e470773b1f2b();
    // Raw Event from WebSocket.onerror — browsers don't expose error details
    // for security reasons, so {isTrusted: true} is all we get.
    if (typeof error === 'object' && error !== null && 'isTrusted' in error) return `GraphQL WebSocket connection error (browser restricted error details). Diagnostics: ${diagnostics}`;
    if (error instanceof Error) return error.message;
    // Fallback: try to stringify whatever we got
    try {
        const serialized = JSON.stringify(error);
        return `GraphQL subscription error: ${serialized}`;
    } catch  {
        return 'GraphQL subscription error: unknown error';
    }
};
/**
 * Extracts the resourceId from a block ARI.
 * Block ARI format: ari:cloud:blocks:<cloudId>:synced-block/<resourceId>
 * @param blockAri - The block ARI string
 * @returns The resourceId portion of the ARI
 */ const $cadfedcfbb7922e8$var$extractResourceIdFromBlockAri = (blockAri)=>{
    // eslint-disable-next-line require-unicode-regexp
    const match = blockAri.match(/ari:cloud:blocks:[^:]+:synced-block\/(.+)$/);
    return match?.[1] || null;
};
/**
 * Parses the subscription payload into a standardized format.
 * @param payload - The raw subscription payload
 * @returns Parsed block data or null if parsing fails
 */ const $cadfedcfbb7922e8$var$parseSubscriptionPayload = (payload)=>{
    try {
        const resourceId = $cadfedcfbb7922e8$var$extractResourceIdFromBlockAri(payload.blockAri);
        if (!resourceId) return null;
        let createdAt;
        if (payload.createdAt !== undefined && payload.createdAt !== null) createdAt = new Date(payload.createdAt).toISOString();
        return {
            blockAri: payload.blockAri,
            blockInstanceId: payload.blockInstanceId,
            content: JSON.parse(payload.content),
            contentUpdatedAt: (0, $gtauf.convertContentUpdatedAt)(payload.contentUpdatedAt),
            createdAt: createdAt,
            createdBy: payload.createdBy,
            product: payload.product,
            resourceId: resourceId,
            sourceAri: payload.sourceAri,
            status: payload.status
        };
    } catch  {
        return null;
    }
};
const $cadfedcfbb7922e8$export$1358b82fada7c923 = (blockAri, onData, onError)=>{
    const client = $cadfedcfbb7922e8$var$getBlockServiceClient();
    if (!client) // Return a no-op unsubscribe if client is not available (e.g., SSR)
    return ()=>{};
    const unsubscribe = client.subscribe({
        query: $cadfedcfbb7922e8$var$SUBSCRIPTION_QUERY,
        variables: {
            resourceId: blockAri
        },
        operationName: 'EDITOR_SYNCED_BLOCK_ON_BLOCK_UPDATED'
    }, {
        next: (value)=>{
            if (value.data?.blockService_onBlockUpdated) {
                const parsed = $cadfedcfbb7922e8$var$parseSubscriptionPayload(value.data.blockService_onBlockUpdated);
                if (parsed !== null) onData(parsed);
                else onError?.(new Error('Failed to parse block subscription payload'));
            }
        },
        error: (error)=>{
            if ((0, $dh538.fg)('platform_synced_block_add_info_web_socket_error')) onError?.(new Error($cadfedcfbb7922e8$export$307d3f85d27f6d40(error)));
            else {
                const errorMessage = error instanceof Error ? error.message : 'GraphQL subscription error';
                onError?.(new Error(errorMessage));
            }
        },
        complete: ()=>{
        // Subscription completed
        }
    });
    return unsubscribe;
};
module.exports["subscribeToBlockUpdates"] = $cadfedcfbb7922e8$export$1358b82fada7c923;

});

parcelRegister("gtauf", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $5a9379de970b4a33$export$aafb32b192c8228c = (node)=>{
    return {
        blockInstanceId: node.attrs.localId,
        content: node.content.toJSON(),
        resourceId: node.attrs.resourceId
    };
};
const $5a9379de970b4a33$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $5a9379de970b4a33$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$5a9379de970b4a33$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $5a9379de970b4a33$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match(/^(confluence-page|jira-work-item)\/([^/]+)/);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $5a9379de970b4a33$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $5a9379de970b4a33$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $5a9379de970b4a33$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $5a9379de970b4a33$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $5a9379de970b4a33$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $5a9379de970b4a33$export$2cf4a74c3e18f31a;
module.exports["convertContentUpdatedAt"] = $5a9379de970b4a33$export$4c6687d128f55da5;

});

parcelRegister("awHlv", function(module, exports) {
var $14957aea32c8ee8e$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
module.exports["SyncBlockError"] = $14957aea32c8ee8e$export$686dd843fdf311d4;

});

parcelRegister("cFpEg", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $22be2fac1f3375a4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $22be2fac1f3375a4$export$999ed1af1b20ac2d = (actionSubjectId, error, resourceId)=>({
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            }
        }
    });
const $22be2fac1f3375a4$export$94dcd08406353dba = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId);
const $22be2fac1f3375a4$export$c5131f589148b9d3 = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId);
const $22be2fac1f3375a4$export$adc2363832f8735d = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId);
const $22be2fac1f3375a4$export$154595d209a77913 = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId);
const $22be2fac1f3375a4$export$5d2f0c264cf49280 = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId);
const $22be2fac1f3375a4$export$cd0aaab38ff32ec2 = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId);
const $22be2fac1f3375a4$export$e40ed1768baf5d1e = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId);
const $22be2fac1f3375a4$export$ebf3ba305f3f0e1a = (error, resourceId)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId);
const $22be2fac1f3375a4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $d925B.ACTION).FETCHED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $22be2fac1f3375a4$export$5b8e0915870366d0 = (resourceId)=>{
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId
        }
    };
};
const $22be2fac1f3375a4$export$dd6ad6471c8fade8 = (resourceId)=>({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId
        }
    });
const $22be2fac1f3375a4$export$f2b4214fae56af83 = (resourceId, hasReference)=>({
        action: (0, $d925B.ACTION).UPDATED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            }
        }
    });
const $22be2fac1f3375a4$export$2283f5d682476cde = (resourceId)=>({
        action: (0, $d925B.ACTION).DELETED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId
        }
    });
module.exports["stringifyError"] = $22be2fac1f3375a4$export$7fc2c997455452c8;
module.exports["fetchErrorPayload"] = $22be2fac1f3375a4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $22be2fac1f3375a4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $22be2fac1f3375a4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $22be2fac1f3375a4$export$154595d209a77913;
module.exports["createErrorPayload"] = $22be2fac1f3375a4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $22be2fac1f3375a4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $22be2fac1f3375a4$export$e40ed1768baf5d1e;
module.exports["fetchReferencesErrorPayload"] = $22be2fac1f3375a4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $22be2fac1f3375a4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $22be2fac1f3375a4$export$5b8e0915870366d0;
module.exports["updateSuccessPayload"] = $22be2fac1f3375a4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $22be2fac1f3375a4$export$2283f5d682476cde;

});

parcelRegister("47N43", function(module, exports) {

var $6RJVA = parcelRequire("6RJVA");

const $f989ba18ccabbf74$var$isSyncBlockProduct = (product)=>{
    return (0, $6RJVA.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $f989ba18ccabbf74$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$f989ba18ccabbf74$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $f989ba18ccabbf74$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $f989ba18ccabbf74$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $f989ba18ccabbf74$export$cf5895b3b46faf63;

});

parcelRegister("6RJVA", function(module, exports) {
const $ccfe16213375d02d$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $ccfe16213375d02d$export$c05408ef703373ad;

});

parcelRegister("f8eu7", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ /**
 * The type of the Confluence page
 */ const $ff6ec2d844d0271f$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $ff6ec2d844d0271f$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match(/ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $ff6ec2d844d0271f$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $ff6ec2d844d0271f$export$2ee4e689bde04de2;

});

parcelRegister("lBSlf", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");

const $a0f9e31b9493339e$export$f10410d219e3ec29 = {
    /**
	 * Occurs when the fetch operation returns fewer results than requested.
	 * This indicates incomplete data retrieval or potential data loss.
	 * Included in error: list of missing block identifiers
	 */ FETCH_INCOMPLETE: 'SYNCED_BLOCKS_FETCH_INCOMPLETE',
    /**
	 * Occurs when the batch fetch operation throws an error during execution.
	 * This indicates a network error, timeout, or API failure.
	 * Included in error: resource IDs that failed to fetch
	 */ BATCH_FETCH_FAILED: 'SYNCED_BLOCKS_BATCH_FETCH_FAILED',
    /**
	 * Occurs when the fetch operation times out without returning results.
	 * This is specific to the bulk fetch operation with a configurable timeout.
	 */ FETCH_TIMEOUT: 'SYNCED_BLOCKS_FETCH_TIMEOUT'
};
const $a0f9e31b9493339e$var$isSyncedBlocksSSRErrorObj = (maybeSSRErrorObj)=>{
    if (!maybeSSRErrorObj || typeof maybeSSRErrorObj !== 'object') return false;
    const errorWrapper = maybeSSRErrorObj;
    // Check for meta object with valid code
    const hasValidMeta = errorWrapper.meta && typeof errorWrapper.meta === 'object' && Object.values($a0f9e31b9493339e$export$f10410d219e3ec29).includes(errorWrapper.meta.code);
    return Boolean(hasValidMeta);
};
/**
 * Get the first SSR error for synced blocks from the window.__SSR_ERROR__ array.
 *
 * Expected structure of error objects stored in confluence window.__SSR_ERROR__ for synced blocks SSR errors:
 *
 * @example
 * {
 *   error: {
 *     message: "Synced blocks fetch operation timed out",
 *     stack: "Error: Synced blocks fetch operation timed out\n    at /tmp/script.js:xxx:xxx"
 *   },
 *   meta: {
 *     code: "SYNCED_BLOCKS_FETCH_TIMEOUT",
 *     contentId: "XXXXXX",
 *     cloudId: "XXXX-XXXX-XXXX-XXXX-XXXX",
 *     isBlog: false,
 *     identifiers: [
 *       {
 *         resourceId: "confluence-page/XXXXXX/XXXX-XXXX-XXXX-XXXX-XXXX",
 *         blockInstanceId: "XXXX-XXXX-XXXX-XXXX-XXXX"
 *       }
 *     ]
 *   }
 * }
 *
 * @returns The first SSR error metadata, or undefined if no error found
 */ const $a0f9e31b9493339e$var$getSyncedBlocksSSRError = ()=>{
    if ((0, $eTj7Y.isSSR)()) return undefined;
    const ssrErrors = window.__SSR_ERROR__;
    if (Array.isArray(ssrErrors)) {
        const syncedBlockErrors = ssrErrors.filter($a0f9e31b9493339e$var$isSyncedBlocksSSRErrorObj).map((errorWrapper)=>errorWrapper.meta);
        return syncedBlockErrors.length > 0 ? syncedBlockErrors[0] : undefined;
    }
    return undefined;
};
const $a0f9e31b9493339e$export$8be916857642095b = (()=>{
    let called = false;
    // I want this fireAnalyticsEvent only takes in SyncedBlockSSRErrorAEP
    return (fireAnalyticsEvent)=>{
        if (called) return;
        called = true;
        if (!fireAnalyticsEvent) return;
        const error = $a0f9e31b9493339e$var$getSyncedBlocksSSRError();
        if (error) fireAnalyticsEvent({
            action: (0, $d925B.ACTION).ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_SSR_ERROR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                code: error.code,
                isBlog: error.isBlog,
                syncedBlocksCount: error.identifiers?.length || 0,
                missingSyncedBlocksCount: error.missingIdentifiers?.length || 0,
                errorMessage: error.errorMessage,
                errorName: error.errorName
            }
        });
    };
})();
module.exports["SyncedBlocksSSRErrorCodeMap"] = $a0f9e31b9493339e$export$f10410d219e3ec29;
module.exports["handleSSRErrorsAnalytics"] = $a0f9e31b9493339e$export$8be916857642095b;

});

parcelRegister("8AcAF", function(module, exports) {
function $239408713401734d$export$25570414f819b6df(syncBlock, nodeTypes) {
    if (!syncBlock?.data?.content) return [];
    if (nodeTypes.length === 0) return [];
    const nodeTypesSet = new Set(nodeTypes);
    const foundTypes = new Set();
    const content = syncBlock.data.content;
    const checkNode = (node)=>{
        if (!node || typeof node !== 'object') return false;
        // Check if this node matches one of the requested types
        if (typeof node.type === 'string' && nodeTypesSet.has(node.type) && !foundTypes.has(node.type)) {
            // node type found, add to found set and remove from search set
            foundTypes.add(node.type);
            nodeTypesSet.delete(node.type);
            // If all types have been found, we can stop searching
            if (nodeTypesSet.size === 0) return true;
        }
        // Recursively check all child content
        if (Array.isArray(node.content)) // Return true to stop searching if all types have been found in children
        return node.content.some(checkNode);
        return false;
    };
    content.some(checkNode);
    return Array.from(foundTypes);
}
module.exports["syncBlockContainsNodes"] = $239408713401734d$export$25570414f819b6df;

});

parcelRegister("l9Wsf", function(module, exports) {
const $7267ec4c0ff40ba5$var$isSyncBlockNode = (node)=>{
    return node.type === 'syncBlock' && typeof node.attrs === 'object' && node.attrs !== null && 'resourceId' in node.attrs && 'localId' in node.attrs && typeof node.attrs.resourceId === 'string' && typeof node.attrs.localId === 'string';
};
function $7267ec4c0ff40ba5$export$7895de99cf1d8719(doc) {
    const content = doc.content || [];
    return content.reduce((acc, node)=>{
        if ($7267ec4c0ff40ba5$var$isSyncBlockNode(node)) acc.push({
            resourceId: node.attrs.resourceId,
            blockInstanceId: node.attrs.localId
        });
        return acc;
    }, []);
}
module.exports["extractSyncBlockIdentifiers"] = $7267ec4c0ff40ba5$export$7895de99cf1d8719;

});

parcelRegister("985xA", function(module, exports) {
function $4a85fd13a342ae42$export$e3ccb083fef98320(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}
module.exports["isValidJSONDocNode"] = $4a85fd13a342ae42$export$e3ccb083fef98320;

});

parcelRegister("7azCD", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");



/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.10.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2023
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $kyRHQ === 'object' && $kyRHQ.versions && $kyRHQ.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("h1hUh"));
        var Buffer = (parcelRequire("h1hUh")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");

const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<ef39d1947f2c75643bf07b6020916552>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "0b21ca1826000dc79e07e5aee0fcca18";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<4e7ae046f42e24faa52469f0916f89dd>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "b632c435e4326f4f3245476cffd31162";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<af053c380526e6af1db453d5af6c8ddd>>
 * @relayHash 84e141f4639993fa671b560586b064ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "84e141f4639993fa671b560586b064ac",
            "id": "8efac480ec4a436c1a451826fa401d62a5e1cb57c29989be5ed579813655fbf2",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String){content(id:$contentId){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "0027e387b6111f3e5ddcfb9450c87857";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<f427d60135d525baae96e1ed2aa37840>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("98Fgg", function(module, exports) {
/**
 * @generated SignedSource<<9c518495d9d600b8eb70e175a5313de5>>
 * @relayHash 1eef94f086d4818dc81396289138687a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09
const $314d226daa5f5ce2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isBlog"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "condition": "isBlog",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "CURRENT"
                            ]
                        }
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                }
                            ],
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "PTPage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "nearestAncestors(first:1)"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1eef94f086d4818dc81396289138687a",
            "id": "57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09",
            "metadata": {},
            "name": "preloadLegacyBridgeQuery",
            "operationKind": "query",
            "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
        }
    };
}();
$314d226daa5f5ce2$var$node.hash = "6d396d281028b16cc64fd39e7d8cd3db";
var $314d226daa5f5ce2$export$2e2bcd8739ae039 = $314d226daa5f5ce2$var$node;
module.exports["default"] = $314d226daa5f5ce2$export$2e2bcd8739ae039;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<472361c14129814960a603dd2d887711>>
 * @relayHash feae64578b0a3fba44f22230201969bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "concreteType": "RecommendedPagesStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "userCanToggle"
            },
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            }
        ]
    }, v19 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "feae64578b0a3fba44f22230201969bb",
            "id": "5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy},status{userCanToggle,isEnabled}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "89dc64ac31ebaadc798791741477c5f3";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<4efd7d9e8d315675bb805e09816dec16>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "4580906c8b823122d6a7f5ad8c2e2c6c";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<a2f1fb017cf204bc3e2e85149c2195e0>>
 * @relayHash 43e22200d20c9054da6f6b002b467f53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e62a6711347ebe24e07ec7b2626132ba0b382ac1b84769556e96431c837da97
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "43e22200d20c9054da6f6b002b467f53",
            "id": "3e62a6711347ebe24e07ec7b2626132ba0b382ac1b84769556e96431c837da97",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "3f2ed67e9608ba74e2a432234c7f66f7";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<786f1007a6af1730b92980dd25753886>>
 * @relayHash 917128614372b454a0c92f921e265a3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v11 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v13 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v14 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v11 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v21 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v23 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "number"
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "FOOTER"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "FOOTER"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v27 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v27 /*: any*/ 
        },
        "params": {
            "cacheID": "917128614372b454a0c92f921e265a3f",
            "id": "d247e68f7dc475170950704c1ecdbb1f5c61bcfd1fd837a33a67fbd4b418b0bb",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "0538003061ae5e768497e01082e44e58";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$c6ff0a0df62acf44 = 3;
const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: null,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$fa19d42490144c8 = (contentId)=>({
        pageId: contentId,
        // Query for all comments regardless of status (although skip deleted since we have no way to show it), we'll filter on the FE
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $eeebfa790a4a25a5$export$c6ff0a0df62acf44
    });
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["buildPreloadObjectCommentsQueryVariables"] = $eeebfa790a4a25a5$export$fa19d42490144c8;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("lj2R9", function(module, exports) {
/**
 * @generated SignedSource<<6e1fdafbe71fead92d067d722f5f76db>>
 * @relayHash 667db9b1207176451cb2198029bc1794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c
const $0d0305ae4f6822bb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalCollaboratorCount"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "667db9b1207176451cb2198029bc1794",
            "id": "263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c",
            "metadata": {},
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "operationKind": "query",
            "text": "query ViewSpaceExternalCollaboratorsDialogQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
        }
    };
}();
$0d0305ae4f6822bb$var$node.hash = "722ca76340bcbe86e394e6f8663add12";
var $0d0305ae4f6822bb$export$2e2bcd8739ae039 = $0d0305ae4f6822bb$var$node;
module.exports["default"] = $0d0305ae4f6822bb$export$2e2bcd8739ae039;

});

parcelRegister("g2a13", function(module, exports) {
/**
 * @generated SignedSource<<c26593af271aeb10b6aad9455b37e877>>
 * @relayHash fe506bd9046797cde11ab0f7fcc9d885
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be
const $53f7ad90e8632c3f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "SpaceSidebarLinks",
            "kind": "LinkedField",
            "name": "spaceSidebarLinks",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "quick",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "position"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe506bd9046797cde11ab0f7fcc9d885",
            "id": "854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be",
            "metadata": {},
            "name": "useShortcutsSpaceNavigationQuery",
            "operationKind": "query",
            "text": "query useShortcutsSpaceNavigationQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){__typename,quick{id,url,position,title,styleClass}}}"
        }
    };
}();
$53f7ad90e8632c3f$var$node.hash = "52dba71769af710a3e1e472bed635436";
var $53f7ad90e8632c3f$export$2e2bcd8739ae039 = $53f7ad90e8632c3f$var$node;
module.exports["default"] = $53f7ad90e8632c3f$export$2e2bcd8739ae039;

});

parcelRegister("MyxIQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bnKhH = parcelRequire("bnKhH");


var $5dPMD = parcelRequire("5dPMD");


var $301rJ = parcelRequire("301rJ");



var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $4VJDS = parcelRequire("4VJDS");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");




var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $5dPMD.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'post-office',
                // Tells Tesseract to S2S with `post-office`
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $bnKhH.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $5dPMD.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $42omo.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $42omo.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $42omo.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return (0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
            postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext),
            environment: {
                currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
            }
        }, extraFetchOptions), postOfficeTimeout);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("bnKhH", function(module, exports) {

var $7kqqb = parcelRequire("7kqqb");


var $c3xd8 = parcelRequire("c3xd8");

const $121828a65173ad3f$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $c3xd8.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $7kqqb.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $121828a65173ad3f$export$e8b30f9c4a80230f;

});

parcelRegister("7kqqb", function(module, exports) {
const $5d54839cd273dd72$export$5ca004be156a127a = 'http://localhost:4224';
const $5d54839cd273dd72$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $5d54839cd273dd72$export$1e9fed4c0197724c = 'http://localhost:8081';
const $5d54839cd273dd72$export$919a9569bce66f17 = '/api/v1/placements/';
const $5d54839cd273dd72$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $5d54839cd273dd72$export$67be2569ef5d7666 = 'http://localhost:9009';
const $5d54839cd273dd72$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $5d54839cd273dd72$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
const $5d54839cd273dd72$export$a2ac4fea250cfcb6 = 'https://post-office-rml-frontend.stg.frontend.cdn.atlassian-us-gov-mod.com';
const $5d54839cd273dd72$export$4db578e7ea13bd1b = 'https://post-office-rml-frontend.prod.frontend.cdn.atlassian-us-gov-mod.com';
module.exports["API_ORIGIN_TEST_SERVER"] = $5d54839cd273dd72$export$5ca004be156a127a;
module.exports["API_PATHNAME_TEST_SERVER"] = $5d54839cd273dd72$export$a5c5394c951a9848;
module.exports["API_ORIGIN_LOCAL"] = $5d54839cd273dd72$export$1e9fed4c0197724c;
module.exports["API_PATHNAME_LOCAL"] = $5d54839cd273dd72$export$919a9569bce66f17;
module.exports["API_PATHNAME_STG_PROD"] = $5d54839cd273dd72$export$d4fe3482c88e73a8;
module.exports["REMOTE_MODULE_URI_LOCAL"] = $5d54839cd273dd72$export$67be2569ef5d7666;
module.exports["REMOTE_MODULE_URI_STG"] = $5d54839cd273dd72$export$b49738b89db261cd;
module.exports["REMOTE_MODULE_URI_PROD"] = $5d54839cd273dd72$export$bbd96cd490b0df63;
module.exports["REMOTE_MODULE_URI_STG_FEDM"] = $5d54839cd273dd72$export$a2ac4fea250cfcb6;
module.exports["REMOTE_MODULE_URI_PROD_FEDM"] = $5d54839cd273dd72$export$4db578e7ea13bd1b;

});

parcelRegister("c3xd8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7kqqb = parcelRequire("7kqqb");

const $de5791e01a0486f7$export$5dba87a2097d7fb2 = (isFedRampCompliantUrlsEnabled = false)=>{
    return {
        currentEnv: 'local',
        envConfigs: {
            'test-server': {
                remoteModule: {
                    origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $7kqqb.API_ORIGIN_TEST_SERVER),
                    pathname: (0, $7kqqb.API_ORIGIN_TEST_SERVER),
                    searchParams: undefined
                }
            },
            test: {
                remoteModule: {
                    origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                    pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                    pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                    pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $7kqqb.REMOTE_MODULE_URI_STG),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $7kqqb.REMOTE_MODULE_URI_STG_FEDM) : (0, $7kqqb.REMOTE_MODULE_URI_STG),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $7kqqb.REMOTE_MODULE_URI_PROD),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $7kqqb.REMOTE_MODULE_URI_PROD_FEDM) : (0, $7kqqb.REMOTE_MODULE_URI_PROD),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            }
        }
    };
};
const $de5791e01a0486f7$export$b4ede87479bfcf09 = $de5791e01a0486f7$export$5dba87a2097d7fb2();
const $de5791e01a0486f7$export$fceca2c399b32565 = (0, $42omo.createContext)($de5791e01a0486f7$export$b4ede87479bfcf09);
const $de5791e01a0486f7$export$604607f913ef367c = $de5791e01a0486f7$export$fceca2c399b32565.Provider;
const $de5791e01a0486f7$export$877b97169cc75e8b = ()=>(0, $42omo.useContext)($de5791e01a0486f7$export$fceca2c399b32565);
module.exports["buildDefaultEnvironmentValues"] = $de5791e01a0486f7$export$5dba87a2097d7fb2;
module.exports["defaultEnvironmentValues"] = $de5791e01a0486f7$export$b4ede87479bfcf09;
module.exports["PostOfficeEnvironmentProvider"] = $de5791e01a0486f7$export$604607f913ef367c;
module.exports["usePostOfficeEnvironment"] = $de5791e01a0486f7$export$877b97169cc75e8b;

});

parcelRegister("5dPMD", function(module, exports) {
const $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-\/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("dGmBZ", function(module, exports) {
/**
 * @generated SignedSource<<ac8e488f089fdc7810ba99e6c3a93093>>
 * @relayHash 3a2b6de25396328a7215eef4ddb9d1c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da824bb32521ddcdda62ebc8dbb8760dafd02a73da759678ecb4d940100cf6a0
const $819504ce5ddad46c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "position"
    }, v6 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v7 = {
        "kind": "ScalarField",
        "name": "path"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "SpaceSidebarLinks",
            "kind": "LinkedField",
            "name": "spaceSidebarLinks",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "includeHidden",
                            "value": true
                        }
                    ],
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "main",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "webItemKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webItemCompleteKey"
                        },
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconClass"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hidden"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canHide"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "linkIdentifier"
                        },
                        v8 /*: any*/ 
                    ],
                    "storageKey": "main(includeHidden:true)"
                },
                {
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "quick",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v3 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "condition": "isLicensed",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAdmin"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourited"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "containsExternalCollaborators"
                },
                {
                    "concreteType": "SpaceHistory",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceNavigationQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceNavigationQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "3a2b6de25396328a7215eef4ddb9d1c0",
            "id": "da824bb32521ddcdda62ebc8dbb8760dafd02a73da759678ecb4d940100cf6a0",
            "metadata": {},
            "name": "SpaceNavigationQuery",
            "operationKind": "query",
            "text": "query SpaceNavigationQuery($spaceKey:String,$isLicensed:Boolean!){user:confluence_atlassianUser(current:true){id,confluence{permissionType}},spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators,history{createdDate},didContainUserContent}}"
        }
    };
}();
$819504ce5ddad46c$var$node.hash = "bca4942401246f836068201b36fd61d7";
var $819504ce5ddad46c$export$2e2bcd8739ae039 = $819504ce5ddad46c$var$node;
module.exports["default"] = $819504ce5ddad46c$export$2e2bcd8739ae039;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<30b71203151c57c81eb934d688fd9be6>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "cc599626e8f53c4256f22a11dfce92c8";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("e5i8U", function(module, exports) {
/**
 * @generated SignedSource<<fd21dfbb1d7f06ab912dc89f38c8ce4d>>
 * @relayHash e2df23bdc78f713de65477722c69e437
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54
const $352d8776ce9e612e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "e2df23bdc78f713de65477722c69e437",
            "id": "a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54",
            "metadata": {},
            "name": "useSpaceViewsDataSpaceRootQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsDataSpaceRootQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$352d8776ce9e612e$var$node.hash = "0fe50aba41f4ffff776e7aeae840f990";
var $352d8776ce9e612e$export$2e2bcd8739ae039 = $352d8776ce9e612e$var$node;
module.exports["default"] = $352d8776ce9e612e$export$2e2bcd8739ae039;

});

parcelRegister("2fQCH", function(module, exports) {
/**
 * @generated SignedSource<<99d72e06067bd7dd05c5c13f8e6db9fc>>
 * @relayHash 5841807a4e3bf2a59de617588db23f8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8
const $3b3e50e8050cb646$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5841807a4e3bf2a59de617588db23f8f",
            "id": "1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8",
            "metadata": {},
            "name": "FooterCreateButtonsQuery",
            "operationKind": "query",
            "text": "query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}}"
        }
    };
}();
$3b3e50e8050cb646$var$node.hash = "8f908e5cb8da1d069802e69ea3d7f563";
var $3b3e50e8050cb646$export$2e2bcd8739ae039 = $3b3e50e8050cb646$var$node;
module.exports["default"] = $3b3e50e8050cb646$export$2e2bcd8739ae039;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("9eCf8", function(module, exports) {
/**
 * @generated SignedSource<<6ad365f1ccfb596256d27d51fa6c0d6c>>
 * @relayHash 40e147f795d6ae695dc2af4dc7df056c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 689b777212e11a0053f5570d2350dc0482010aee341093c6a0ec7019bd59dc72
const $b0adf32477ccbbfa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v6 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v7 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v8 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v15 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v16 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v12 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v22 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v25 = [
        {
            "alias": "currentPage",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ 
        },
        "params": {
            "cacheID": "40e147f795d6ae695dc2af4dc7df056c",
            "id": "689b777212e11a0053f5570d2350dc0482010aee341093c6a0ec7019bd59dc72",
            "metadata": {},
            "name": "PageTreeQuery",
            "operationKind": "query",
            "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$b0adf32477ccbbfa$var$node.hash = "9ca5cb64b6d53c6754a4b7af001ba098";
var $b0adf32477ccbbfa$export$2e2bcd8739ae039 = $b0adf32477ccbbfa$var$node;
module.exports["default"] = $b0adf32477ccbbfa$export$2e2bcd8739ae039;

});

parcelRegister("fL5TY", function(module, exports) {
/**
 * @generated SignedSource<<fd6a29a5439888c539f0d50e28c86e14>>
 * @relayHash 32d094adde43b53166e21c73e0e18466
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db
const $b517e71d543026da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endCursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "endCursor"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orderby",
                    "variableName": "orderBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "blogpost"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blank"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft",
                                        "editor"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "32d094adde43b53166e21c73e0e18466",
            "id": "8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db",
            "metadata": {},
            "name": "BlogTreeRootComponentQuery",
            "operationKind": "query",
            "text": "query BlogTreeRootComponentQuery($spaceKey:String!,$first:Int,$endCursor:String,$statuses:[String],$orderBy:String){content(spaceKey:$spaceKey,type:\"blogpost\",first:$first,orderby:$orderBy,after:$endCursor,status:$statuses){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}"
        }
    };
}();
$b517e71d543026da$var$node.hash = "dcdc7591048a9e478035919db8a4bcd0";
var $b517e71d543026da$export$2e2bcd8739ae039 = $b517e71d543026da$var$node;
module.exports["default"] = $b517e71d543026da$export$2e2bcd8739ae039;

});

parcelRegister("6DMfJ", function(module, exports) {
const $4d5bd09a97238678$export$e3c11860ad35ba05 = [
    'current',
    'draft'
];
const $4d5bd09a97238678$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $4d5bd09a97238678$export$8ec3d08588d2eeda = 40;
const $4d5bd09a97238678$export$130b26c73bb9d040 = 16;
module.exports["BLOG_STATUSES"] = $4d5bd09a97238678$export$e3c11860ad35ba05;
module.exports["VIRTUAL_ROOT_ID"] = $4d5bd09a97238678$export$70918a400db2b6af;
module.exports["PAGE_SIZE"] = $4d5bd09a97238678$export$8ec3d08588d2eeda;
module.exports["INDENT_PER_LEVEL"] = $4d5bd09a97238678$export$130b26c73bb9d040;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
const $4eb170397cdf11a9$export$5522fe3493552101 = [
    'current',
    'draft'
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<ccf01a471b3f103a7f9b7d03914777ce>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "7c791401f0e963cfa78bdcff70a3c87c";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("gRzR4", function(module, exports) {
/**
 * @generated SignedSource<<aa4f0ae977b2c9361756ffbf741314bd>>
 * @relayHash a2b7f78fbc7a4e9ecead01083cfe8f24
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266
const $7836e6257492ac35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorId"
                },
                {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DraftContentProperties",
                            "kind": "LinkedField",
                            "name": "draft",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "PublishedContentProperties",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "a2b7f78fbc7a4e9ecead01083cfe8f24",
            "id": "e2f8168270ed250fa33f38610fa3b20029664886f16e5db1184bbca7a9821266",
            "metadata": {},
            "name": "SmartCreateFeedbackBannerQuery",
            "operationKind": "query",
            "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,contentProperties{draft{generatedBy},latest{generatedBy}}}}"
        }
    };
}();
$7836e6257492ac35$var$node.hash = "4f4f276100c2961c7227836999fc58e5";
var $7836e6257492ac35$export$2e2bcd8739ae039 = $7836e6257492ac35$var$node;
module.exports["default"] = $7836e6257492ac35$export$2e2bcd8739ae039;

});

parcelRegister("1k2r8", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9xoMO = parcelRequire("9xoMO");


var $8Z78B = parcelRequire("8Z78B");

const $2daa64592339f2ce$export$ce5c629ae8376218 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: (0, $9xoMO.OnboardingKeysCombined)
        }
    });
};
module.exports["preloadAllOnboardingState"] = $2daa64592339f2ce$export$ce5c629ae8376218;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<9e679e18b3c55847da4cfc18581316bd>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "031eb89bf77537fd501cf18345136db8";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("lpxTx", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $4ac0bfd36ecfdf97$export$7e83667ababb3077 = (0, $eSUdr.default)`query ContentBlogUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false){content(id:$contentId version:$versionOverride){nodes{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value content{version{number}}webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;
module.exports["ContentBlogUnifiedQuery"] = $4ac0bfd36ecfdf97$export$7e83667ababb3077;

});

parcelRegister("61vTv", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7b6381fcd1b9e458$export$16dddce791a11901 = (0, $eSUdr.default)`query ContentUnifiedQuery($contentId:ID!$spaceKey:String=null$versionOverride:Int$isSSR:Boolean=false$useNewContentTopper:Boolean=false$preloadLabels:Boolean=false)@allowHigherTimeout{content(id:$contentId version:$versionOverride){nodes{id status type subType title space{id key alias}version{confRev number}properties(keys:["cover-picture-id-published" "emoji-title-published" "editor" "import-source" "imported-page-modified-date"]){nodes{id key value version{number}}}pageTitlePublished:properties(key:"page-title-property-published")@include(if:$useNewContentTopper){nodes{id key value version{number}}}metadata{lastModifiedDate frontend{fabricEditorSupported coverPictureWidth@include(if:$useNewContentTopper)}}macroRenderedOutput@include(if:$isSSR){key value{value representation webresource{tags{js css}}}}body{dynamic{representation value content{version{number}}webresource{superbatch{tags{js css}}tags{js css}}}}appearancePublished:properties(key:"content-appearance-published"){nodes{id key value version{number}}}labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING})@include(if:$preloadLabels){count nodes{id label name prefix}}operations@include(if:$preloadLabels){operation targetType}}}space(key:$spaceKey){id theme{name themeKey}lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}settings{routeOverrideEnabled}currentUser{isAnonymouslyAuthorized}}}`;
module.exports["ContentUnifiedQuery"] = $7b6381fcd1b9e458$export$16dddce791a11901;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<79b04f42581891e3c00d88fc569d2a2d>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<e4079842eb47115adf7e93781ad329f1>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "d0f958354cdf65029012c243a64d4874";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("ixL26", function(module, exports) {
/**
 * @generated SignedSource<<58a4f7aebb98a4cf9cb16412bf63adf9>>
 * @relayHash d6be154debcc9cc4834278390fc53126
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b
const $0d2a1fbf3179ce94$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeOperations"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "condition": "excludeOperations",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d6be154debcc9cc4834278390fc53126",
            "id": "2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b",
            "metadata": {},
            "name": "SpaceOverviewQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewQuery($spaceKey:String!,$excludeOperations:Boolean!){space(key:$spaceKey){id,currentUser{isAdmin},name,type,theme{themeKey},icon{path},homepage{id,operations@skip(if:$excludeOperations){operation},properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}"
        }
    };
}();
$0d2a1fbf3179ce94$var$node.hash = "800c4a5e07b722b2b0e454947ac55f3c";
var $0d2a1fbf3179ce94$export$2e2bcd8739ae039 = $0d2a1fbf3179ce94$var$node;
module.exports["default"] = $0d2a1fbf3179ce94$export$2e2bcd8739ae039;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnabled = (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType]);
            if (isEnabled && (0, $lzcvT.isFedRamp)()) return (0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp');
            if (isEnabled && (0, $T9xHm.isIsolatedCloud)()) return (0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic');
            return isEnabled;
        }
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<ce267d56c5b6d7a41b23a639614e5b9e>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("PAiZW", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6cd46b79c049adec$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $6cd46b79c049adec$export$a228be81fcb77b42 = (0, $42omo.createContext)($6cd46b79c049adec$export$da5dc9062cba6715);
const $6cd46b79c049adec$export$3a10495c2cd2db0c = $6cd46b79c049adec$export$a228be81fcb77b42.Provider;
const $6cd46b79c049adec$export$b77983be89bb0a4e = $6cd46b79c049adec$export$3a10495c2cd2db0c;
const $6cd46b79c049adec$export$5bd9099e0ae94a43 = ()=>(0, $42omo.useContext)($6cd46b79c049adec$export$a228be81fcb77b42);
module.exports["defaultPostOfficeContextValue"] = $6cd46b79c049adec$export$da5dc9062cba6715;
module.exports["PostOfficeContext"] = $6cd46b79c049adec$export$a228be81fcb77b42;
module.exports["InternalPostOfficeContextProvider"] = $6cd46b79c049adec$export$3a10495c2cd2db0c;
module.exports["PostOfficeContextProvider"] = $6cd46b79c049adec$export$b77983be89bb0a4e;
module.exports["usePostOfficeContext"] = $6cd46b79c049adec$export$5bd9099e0ae94a43;

});

parcelRegister("6yHRM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $4H1Ql = parcelRequire("4H1Ql");

const $d8346e8a2779e8cd$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $d8346e8a2779e8cd$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $d8346e8a2779e8cd$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $hxT4C.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $4H1Ql.useStableObject)(route);
};
const $d8346e8a2779e8cd$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $d8346e8a2779e8cd$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$d8346e8a2779e8cd$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $d8346e8a2779e8cd$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $42omo.createContext)($d8346e8a2779e8cd$var$initialState);
const $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $42omo.useRef)();
    if (!ref.current) ref.current = $d8346e8a2779e8cd$export$98c77e1bd702ed15(props);
    const route = $d8346e8a2779e8cd$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8346e8a2779e8cd$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $d8346e8a2779e8cd$export$79301b66f7808cd8 = ()=>(0, $42omo.useContext)($d8346e8a2779e8cd$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $d8346e8a2779e8cd$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $d8346e8a2779e8cd$export$79301b66f7808cd8;

});

parcelRegister("4H1Ql", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $6932c2b531d219ac$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $6932c2b531d219ac$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>obj, $6932c2b531d219ac$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $6932c2b531d219ac$export$ed02d4adf2068b08;

});

parcelRegister("2mPpz", function(module, exports) {

var $byfJM = parcelRequire("byfJM");

const $479bf4f98cf9c8c7$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $byfJM.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $479bf4f98cf9c8c7$export$8a57effc6307f916;

});

parcelRegister("byfJM", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $T9xHm = parcelRequire("T9xHm");


var $1eSke = parcelRequire("1eSke");

var $4H1Ql = parcelRequire("4H1Ql");


var $kO3gu = parcelRequire("kO3gu");


var $a8wvv = parcelRequire("a8wvv");


var $9dOtv = parcelRequire("9dOtv");


var $eXPKf = parcelRequire("eXPKf");

var $MnX4h = parcelRequire("MnX4h");


var $2HRxT = parcelRequire("2HRxT");

const $573f4005c25c6dbc$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2HRxT.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $T9xHm.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kO3gu.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $MnX4h.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $573f4005c25c6dbc$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $573f4005c25c6dbc$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9dOtv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $a8wvv.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $573f4005c25c6dbc$export$8a57effc6307f916;

});

parcelRegister("1eSke", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $3a5f78a0c0b53634$export$be54ac815726b4bd = (context)=>{
    const isGlobalDisablePlacementCheckEnabled = (0, $dh538.fg)('post-office-enable-disable-placement-check');
    if (isGlobalDisablePlacementCheckEnabled) return context.disableAllPlacements === true;
    return false;
};
module.exports["isPostOfficePlacementsGloballyDisabled"] = $3a5f78a0c0b53634$export$be54ac815726b4bd;

});

parcelRegister("kO3gu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1235947cddcdc3a4$export$afec669dc416ee7e = /*#__PURE__*/ (0, $42omo.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $1235947cddcdc3a4$export$e1e2cdb0425a9fa8 = ()=>(0, $42omo.useContext)($1235947cddcdc3a4$export$afec669dc416ee7e);
const $1235947cddcdc3a4$export$e6d4e8801dff09b9 = ()=>{
    try {
        return (0, $42omo.useContext)($1235947cddcdc3a4$export$afec669dc416ee7e);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error) {
        return undefined;
    }
};
const $1235947cddcdc3a4$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $42omo.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1235947cddcdc3a4$export$afec669dc416ee7e.Provider, {
        value: value
    }, children);
};
const $1235947cddcdc3a4$export$a088c81282679a25 = ({ fetch: fetch, children: children })=>{
    if (!fetch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1235947cddcdc3a4$export$5f25a6ddf0324fa8, {
        fetch: fetch
    }, children);
};
module.exports["usePlacementFetchingContext"] = $1235947cddcdc3a4$export$e1e2cdb0425a9fa8;
module.exports["useOptionalPlacementFetchingContext"] = $1235947cddcdc3a4$export$e6d4e8801dff09b9;
module.exports["PlacementFetchingProvider"] = $1235947cddcdc3a4$export$5f25a6ddf0324fa8;
module.exports["MaybePlacementFetchingProvider"] = $1235947cddcdc3a4$export$a088c81282679a25;

});

parcelRegister("a8wvv", function(module, exports) {
const $f5ba185a6bfa7119$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $f5ba185a6bfa7119$export$71ff7382870ef1b0 = 'create-placement-component';
module.exports["DEFAULT_CONTEXT"] = $f5ba185a6bfa7119$export$9c542858adf7dcd0;
module.exports["ERROR_BOUNDARY_LOCATION"] = $f5ba185a6bfa7119$export$71ff7382870ef1b0;

});

parcelRegister("9dOtv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $94fea169e2cb8de7$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $42omo.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $94fea169e2cb8de7$export$3d127465d22fe4e5;

});

parcelRegister("eXPKf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $h6POP = parcelRequire("h6POP");


var $42omo = parcelRequire("42omo");


var $fUB5z = parcelRequire("fUB5z");


var $a39tv = parcelRequire("a39tv");

const $3a8bbfb177ab8743$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $a39tv.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                name: (0, $h6POP.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $3a8bbfb177ab8743$export$b35129264a401b3c = /*#__PURE__*/ (0, $42omo.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $c6GJD.default).checkGate('post_office_update_ufov2_placements');
    /**
		 * If feature gate is not enabled, then we just return the children without the
		 * UFO segments attached.
		 */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
module.exports["PerformanceTracking"] = $3a8bbfb177ab8743$export$9a335a42ce02bdb8;
module.exports["PerformanceTrackingSegment"] = $3a8bbfb177ab8743$export$b35129264a401b3c;

});

parcelRegister("h6POP", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $hnvzE = parcelRequire("hnvzE");

const $7e9b04f8bb48d01d$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $fwDOR.default,
    UFOSegment: $hnvzE.default
};
module.exports["UFOv2"] = $7e9b04f8bb48d01d$export$c91b09caa8ecbab1;

});

parcelRegister("fUB5z", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $28f53716d0e10e9b$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["TrackMount"] = $28f53716d0e10e9b$export$21b400a8c8ebc91a;

});

parcelRegister("a39tv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d839c5f036ae335$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    // Initialise to true only if there's a Promise to await, avoiding an unnecessary UFO hold on mount.
    const [isLoading, setIsLoading] = (0, $42omo.useState)(initialData !== undefined);
    const onMount = (0, $42omo.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $42omo.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};
module.exports["usePerformanceTracking"] = $6d839c5f036ae335$export$317d52099614f316;

});

parcelRegister("MnX4h", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $jfBff = parcelRequire("jfBff");


var $1Ah4R = parcelRequire("1Ah4R");


var $3zCGc = parcelRequire("3zCGc");


var $kzyrP = parcelRequire("kzyrP");


var $goPQE = parcelRequire("goPQE");


var $kODQd = parcelRequire("kODQd");


var $coAgb = parcelRequire("coAgb");


var $eXPKf = parcelRequire("eXPKf");

/**
 * Feature gate name for GraphQL subscriptions in Post Office placements.
 * When disabled, subscriptions will not be enabled even if configured.
 */ // https://switcheroo.atlassian.com/ui/gates/8299833f-7cf4-453b-bd5b-16f3bcf81ddb/key/post-office_graphql_subscriptions_enabled
const $e96f8aedef8f7ae2$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE = 'post-office_graphql_subscriptions_enabled';
/**
 * Optional provider that wraps subscription providers only if feature gate is enabled.
 */ const $e96f8aedef8f7ae2$var$OptionalPostOfficeSubscriptionsProvider = ({ children: children, subscription: subscription })=>{
    const isPostOfficeSubscriptionsFeatureGateEnabled = (0, $c6GJD.default).checkGate($e96f8aedef8f7ae2$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE);
    if (isPostOfficeSubscriptionsFeatureGateEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kODQd.StableSubscriptionConfigProvider), {
        subscription: subscription,
        children: children
    });
    return children;
};
const $e96f8aedef8f7ae2$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kzyrP.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $goPQE.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $coAgb.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1Ah4R.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)($e96f8aedef8f7ae2$var$OptionalPostOfficeSubscriptionsProvider, {
                        subscription: subscription,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3zCGc.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jfBff.RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
module.exports["StableProviders"] = $e96f8aedef8f7ae2$export$2b6596bcb1383a71;

});

parcelRegister("jfBff", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");


var $kODQd = parcelRequire("kODQd");

/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $5ba220ca4e76952d$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const subscriptionConfig = (0, $kODQd.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    (0, $42omo.useEffect)(()=>{
        if ($5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement',
            attributes: {
                subscriptionEnabled: subscriptionEnabled
            }
        });
    }, [
        fireAnalyticsEvent,
        placementId,
        subscriptionEnabled
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["RenderTrackerProvider"] = $5ba220ca4e76952d$export$2d84fd9af6c9e378;

});

parcelRegister("7XIdu", function(module, exports) {

var $inPa6 = parcelRequire("inPa6");


var $42omo = parcelRequire("42omo");

const $ddf71c7c19f3c4df$export$85183a312807388d = 'postOffice';
const $ddf71c7c19f3c4df$export$33911828b25deac7 = 'engagementPlatform';
const $ddf71c7c19f3c4df$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $ddf71c7c19f3c4df$export$f7fadc54a04f9307 = {
    eventType: 'track',
    action: 'exposed',
    actionSubject: 'feature',
    source: 'engagement-platform',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ]
};
const $ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992 = {
    eventType: 'operational',
    action: 'stopped',
    actionSubject: 'message',
    source: 'epTargeting',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ],
    product: 'engagementPlatform'
};
const $ddf71c7c19f3c4df$export$f14470c9a12428fc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((eventPayload, attributes)=>{
        if (eventPayload.messageType === 'inapp') {
            const epMessageId = `engagement.inproduct.${eventPayload.messageId}`;
            createAnalyticsEvent({
                ...$ddf71c7c19f3c4df$export$f7fadc54a04f9307,
                ...eventPayload,
                actionSubjectId: epMessageId,
                attributes: {
                    ...$ddf71c7c19f3c4df$export$f7fadc54a04f9307.attributes,
                    ...eventPayload.locale && {
                        locale: eventPayload.locale
                    },
                    ...attributes,
                    flagKey: epMessageId
                }
            }).fire($ddf71c7c19f3c4df$export$33911828b25deac7);
        } else createAnalyticsEvent({
            ...$ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992,
            ...eventPayload,
            actionSubjectId: eventPayload.messageId,
            attributes: {
                ...$ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992.attributes,
                ...eventPayload.locale && {
                    locale: eventPayload.locale
                },
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$33911828b25deac7);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
module.exports["useFirePostOfficeAnalyticsEvents"] = $ddf71c7c19f3c4df$export$57d19d18d6e255a5;
module.exports["useFireEngagementPlatformAnalyticsEvents"] = $ddf71c7c19f3c4df$export$f14470c9a12428fc;

});

parcelRegister("kODQd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $4fa55b3f6245b5e9$var$SubscriptionConfigContext = /*#__PURE__*/ (0, $42omo.createContext)({
    subscription: undefined
});
const $4fa55b3f6245b5e9$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($4fa55b3f6245b5e9$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
const $4fa55b3f6245b5e9$export$1129f1fe63b2d7ab = ()=>{
    return (0, $42omo.useContext)($4fa55b3f6245b5e9$var$SubscriptionConfigContext);
};
module.exports["StableSubscriptionConfigProvider"] = $4fa55b3f6245b5e9$export$d870bd1cf2974c88;
module.exports["useSubscriptionConfig"] = $4fa55b3f6245b5e9$export$1129f1fe63b2d7ab;

});

parcelRegister("1Ah4R", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $ffCOo = parcelRequire("ffCOo");

const $6622e517a1cb034d$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "6ddfbde9306dfd982164ed7de16a09a624cbfaa6",
            b: "13597007",
            t: undefined
        }
    }
};
const $6622e517a1cb034d$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: $6622e517a1cb034d$var$postOfficeAnalyticsContextData,
        children: children
    });
};
module.exports["StableAnaltyicsProvider"] = $6622e517a1cb034d$export$5a66cdc9893b43e;

});

parcelRegister("3zCGc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $PAiZW = parcelRequire("PAiZW");

var $c3xd8 = parcelRequire("c3xd8");


var $6zKHU = parcelRequire("6zKHU");


var $42omo = parcelRequire("42omo");

/**
 * Choreographer-specific debug logger instance
 */ const $a6536447802fda47$var$choreographerLogger = (0, $6zKHU.createInBrowserDebugLogger)('choreographer');
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $a6536447802fda47$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        // CommonJS module
        $a6536447802fda47$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        // ESM module in browser
        $a6536447802fda47$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof mod?.default === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        // ESM module in Node.js
        $a6536447802fda47$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $a6536447802fda47$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ // @twood: NEVER CHANGE THIS DEFAULT VALUE
const $a6536447802fda47$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $a6536447802fda47$var$defaultContext = {
    choreographerEnabled: $a6536447802fda47$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $a6536447802fda47$var$ChoreographerContext = /*#__PURE__*/ (0, $42omo.createContext)($a6536447802fda47$var$defaultContext);

const $a6536447802fda47$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $42omo.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $42omo.useState)(choreographer?.isDefaultEnabled ?? $a6536447802fda47$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $c3xd8.usePostOfficeEnvironment)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    (0, $42omo.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("bh3sZ")).then((m)=>{
            // Autoresolve the ChoreographerRegistry class depending on whether the module is an ESM or CommonJS module
            const ChoreographerRegistryClass = $a6536447802fda47$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $a6536447802fda47$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $a6536447802fda47$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $a6536447802fda47$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $a6536447802fda47$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $42omo.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    // Log context changes outside of useMemo to avoid performance impact
    (0, $42omo.useEffect)(()=>{
        $a6536447802fda47$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        stableChoreographerContext,
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a6536447802fda47$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $a6536447802fda47$export$cab5a8adbabcee23 = ()=>(0, $42omo.useContext)($a6536447802fda47$var$ChoreographerContext);
module.exports["StableChoreographerProvider"] = $a6536447802fda47$export$e68b2c75bfb5682a;
module.exports["useChoreographerContext"] = $a6536447802fda47$export$cab5a8adbabcee23;

});

parcelRegister("6zKHU", function(module, exports) {
/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components
 *
 * Usage:
 * - Enable: window.postOfficeChoreographerDebug = true
 * - Disable: window.postOfficeChoreographerDebug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $101ad7de46cb7b68$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};
module.exports["createInBrowserDebugLogger"] = $101ad7de46cb7b68$export$806eda59584e395d;

});

parcelRegister("bh3sZ", function(module, exports) {

let $8353f8a5b3bf3a40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8353f8a5b3bf3a40$var$load("69dSh").then(()=>parcelRequire('fuev4'));

});

parcelRegister("kzyrP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $PAiZW = parcelRequire("PAiZW");

var $4H1Ql = parcelRequire("4H1Ql");


var $a8wvv = parcelRequire("a8wvv");

const $d8708472710e950a$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $4H1Ql.useStableObject)({
        ...(0, $a8wvv.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $PAiZW.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};
module.exports["StableContextProvider"] = $d8708472710e950a$export$d4982c0a28b18f63;

});

parcelRegister("goPQE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $8Bzrf = parcelRequire("8Bzrf");

const $2119b7887220da1c$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $4H1Ql.useStableObject)(placement);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8Bzrf.PlacementProvider), {
        value: stableValue,
        children: children
    });
};
module.exports["StablePlacementProvider"] = $2119b7887220da1c$export$e9fd288527498af6;

});

parcelRegister("8Bzrf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $ffCOo = parcelRequire("ffCOo");


var $3Bn1T = parcelRequire("3Bn1T");


var $42omo = parcelRequire("42omo");

const $d26f31a8de6bf192$export$6394bf86db095a8 = /*#__PURE__*/ (0, $42omo.createContext)({
    placementId: undefined
});
const $d26f31a8de6bf192$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $3Bn1T.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $l998X.jsx)($d26f31a8de6bf192$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $d26f31a8de6bf192$export$4fc0446ee742ad80 = ()=>(0, $42omo.useContext)($d26f31a8de6bf192$export$6394bf86db095a8);
module.exports["PlacementProvider"] = $d26f31a8de6bf192$export$6272e220478c7f1d;
module.exports["usePlacementContext"] = $d26f31a8de6bf192$export$4fc0446ee742ad80;

});

parcelRegister("3Bn1T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6sni0 = parcelRequire("6sni0");

const $37d7f318e8260291$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $37d7f318e8260291$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $42omo.createContext)({
    placements: $37d7f318e8260291$var$initialPlacementState
});
const $37d7f318e8260291$export$70e19226ddeaf957 = ()=>(0, $42omo.useContext)($37d7f318e8260291$var$PostOfficeScreenContext);
const $37d7f318e8260291$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $42omo.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $37d7f318e8260291$export$5d27c0ee02be2a23 = ()=>(0, $42omo.useContext)($37d7f318e8260291$var$PostOfficeScreenUpdateContext);
const $37d7f318e8260291$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $42omo.useState)($37d7f318e8260291$var$initialPlacementState);
    const placementMount = (0, $42omo.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $6sni0.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $6sni0.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $42omo.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $42omo.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $42omo.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($37d7f318e8260291$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($37d7f318e8260291$var$PostOfficeScreenContext.Provider, {
        value: postOfficeScreenContext
    }, children));
};
const $37d7f318e8260291$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $37d7f318e8260291$export$5d27c0ee02be2a23();
    (0, $42omo.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};
module.exports["usePostOfficeScreen"] = $37d7f318e8260291$export$70e19226ddeaf957;
module.exports["PostOfficeScreenContextProvider"] = $37d7f318e8260291$export$ca77a8cbe94108fe;
module.exports["usePostOfficeScreenPlacement"] = $37d7f318e8260291$export$f51d04a086368016;

});

parcelRegister("6sni0", function(module, exports) {
const $df02b7ceef3465b9$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
module.exports["uniqueArray"] = $df02b7ceef3465b9$export$bbd17ecb0679edd7;

});

parcelRegister("coAgb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $kbN4i = parcelRequire("kbN4i");

const $ee97961d0a968e6e$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $kbN4i.useLocationHref)();
    const stableRoute = (0, $4H1Ql.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6yHRM.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};
module.exports["StableRouteProvider"] = $ee97961d0a968e6e$export$ce13d00e696dfc96;

});

parcelRegister("kbN4i", function(module, exports) {
const $b036fb6e61b1c432$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $b036fb6e61b1c432$export$49fc3f3d8c7f99 = ()=>{
    return $b036fb6e61b1c432$var$isLocationAvailable() ? globalThis.location.href : undefined;
};
module.exports["useLocationHref"] = $b036fb6e61b1c432$export$49fc3f3d8c7f99;

});

parcelRegister("2HRxT", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7TH2w = parcelRequire("7TH2w");


var $7XIdu = parcelRequire("7XIdu");


var $lAJUP = parcelRequire("lAJUP");

const $efad4e1316fb199e$export$f0c7a449e0cfaec7 = (Component)=>(props)=>{
        const { errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, messageTemplateId: messageTemplateId, fallbackRender: fallbackRender, onError: onError } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId,
                    messageTemplateId: additionalAnalytics.messageTemplateId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $l998X.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId,
                messageTemplateId: messageTemplateId
            }, onError),
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withErrorBoundary"] = $efad4e1316fb199e$export$f0c7a449e0cfaec7;

});

parcelRegister("cpPWT", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $375253a0664acfd5$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $375253a0664acfd5$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $375253a0664acfd5$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $375253a0664acfd5$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $375253a0664acfd5$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $42omo.createContext)($375253a0664acfd5$export$a28a0c048b24fc5a());
const $375253a0664acfd5$export$c7535f8ebc5b75a9 = $375253a0664acfd5$export$ea58328f3ceee4d4.Provider;
const $375253a0664acfd5$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($375253a0664acfd5$export$c7535f8ebc5b75a9, {
            value: $375253a0664acfd5$export$a28a0c048b24fc5a()
        }, children);
const $375253a0664acfd5$export$89f8e1f623d8f5ac = ()=>(0, $42omo.useContext)($375253a0664acfd5$export$ea58328f3ceee4d4);
module.exports["createMessagePlacementValues"] = $375253a0664acfd5$export$a28a0c048b24fc5a;
module.exports["MessagePlacementProvider"] = $375253a0664acfd5$export$c7535f8ebc5b75a9;
module.exports["useMessagePlacementHooks"] = $375253a0664acfd5$export$89f8e1f623d8f5ac;

});

parcelRegister("cyz5M", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $3NyPa = parcelRequire("3NyPa");

var $h6POP = parcelRequire("h6POP");


var $hOVIX = parcelRequire("hOVIX");


var $3Shv6 = parcelRequire("3Shv6");


var $eNels = parcelRequire("eNels");


var $aEUWC = parcelRequire("aEUWC");


var $2amyA = parcelRequire("2amyA");


var $Sjnjb = parcelRequire("Sjnjb");


var $cqOSB = parcelRequire("cqOSB");


var $4S89c = parcelRequire("4S89c");


var $9iUWG = parcelRequire("9iUWG");


var $fUB5z = parcelRequire("fUB5z");


var $2HRxT = parcelRequire("2HRxT");


var $hyvHs = parcelRequire("hyvHs");


var $42omo = parcelRequire("42omo");


var $lVEBn = parcelRequire("lVEBn");

const $765afc5340447923$var$STABLE_EMPTY_OBJECT = {};
const $765afc5340447923$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        ...props,
        children: children
    });
};
const $765afc5340447923$export$7b7e5a348ef9a7c1 = (messageComponents, placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $42omo.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, SuspenseBoundary: SuspenseBoundary = (0, $42omo.Suspense), ...data })=>{
            const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
            const isTriggerChoreographingEnabled = (0, $c6GJD.default).checkGate('post-office_enable_trigger-choreographing');
            /// https://switcheroo.atlassian.com/ui/gates/e8049c84-32d5-4452-a52f-5b92940a1b55/key/post-office_enable-i18n-migration-pull
            const isI18nMigrationInAppEnabled = (0, $c6GJD.default).checkGate('post-office_enable-i18n-migration-pull');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $42omo.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $3NyPa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $hOVIX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $hOVIX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $42omo.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                        name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = isTriggerChoreographingEnabled && (0, $9iUWG.isClientTriggeredMessage)(triggerType);
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $cqOSB.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $42omo.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    messageInstanceId,
                    messageTemplateId,
                    triggerId,
                    componentProps.transactionAccountId,
                    postOffice?.analyticsDetails,
                    journeyTriggerId
                ]);
                const messageContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                    messageTemplateId: messageTemplateId,
                    isEnabled: isUFOEnabled,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3Shv6.MessageContextProvider), {
                        value: messageContextValue,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hyvHs.RecommendationProvider), {
                            value: recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT,
                            children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                                fallback: loadingComponent,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eNels.MaybeI18nProvider), {
                                        messageTemplateId: messageTemplateId,
                                        placementId: placementId,
                                        isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled,
                                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4S89c.MaybeManualMessageViewedEvent), {
                                            isManual: !!waitForTrigger,
                                            children: [
                                                !waitForTrigger && messageSuccessComponent,
                                                /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                                    onError: onError,
                                                    messageInstanceId: messageInstanceId,
                                                    ...componentProps,
                                                    waitForTrigger: waitForTrigger
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
                // Triggered messages handle choreography with TriggeredMessageValidator
                if (waitForTrigger) return /*#__PURE__*/ (0, $l998X.jsx)((0, $Sjnjb.TriggeredMessageValidator), {
                    waitForTrigger: waitForTrigger,
                    children: messageContent
                });
                // Regular messages use automatic choreography
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $lVEBn.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: messageContent
                });
            };
            return (0, $2HRxT.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $765afc5340447923$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $765afc5340447923$export$7b7e5a348ef9a7c1;

});

parcelRegister("3NyPa", function(module, exports) {

var $jTlSd = parcelRequire("jTlSd");


var $koKWt = parcelRequire("koKWt");

const $959aa8656bf0972c$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jTlSd.MessagePerformanceTracker,
    PlacementPerformanceTracker: $koKWt.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $959aa8656bf0972c$export$96236906ebaa7f87;

});

parcelRegister("jTlSd", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

class $71d7f78b2ff13923$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $71d7f78b2ff13923$export$ae5c73c7c4f454e6;

});

parcelRegister("haNjI", function(module, exports) {
const $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $ac68ec5e99dfa5a8$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $ac68ec5e99dfa5a8$export$6d482cfa20c9d220;

});

parcelRegister("koKWt", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

const $f3e04d171a04c0ba$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $9NDUe.ExperienceTypes).Load,
    platform: {
        component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $f3e04d171a04c0ba$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).PLACEMENT, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).PLACEMENT}.${placementId}`, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $f3e04d171a04c0ba$export$8b48c2105ba0b35a;

});

parcelRegister("hOVIX", function(module, exports) {
var $0a8f0e83dcf5160a$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 extends Error {
}
class $0a8f0e83dcf5160a$export$627bc00a5ef5f6ae extends Error {
}
class $0a8f0e83dcf5160a$export$66e065cfeb491a4d extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    static is(value) {
        return value instanceof $0a8f0e83dcf5160a$export$66e065cfeb491a4d;
    }
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $0a8f0e83dcf5160a$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $0a8f0e83dcf5160a$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(args){
        /**
     * It is expected that this error message can be not deterministic.
     * This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
     * Showing the error cause helps them understand what was the problem with their payload.
     *
     * On Post Office (platform) side, we use "instanceof MessageTemplateError" check
     * to distinguish between message makers code errors and platform errors,
     * but we don't rely on the error message itself.
     */ const errMessage = args.cause instanceof Error ? args.cause.message : 'Error in message template code';
        super(errMessage, "MessageTemplateError", args.cause);
        this.function = void 0;
        this.messageTemplateId = void 0;
        this.triggerId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2833d4759f81601b extends $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = 'Invalid CSS property could not be processed by Juice';
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8d39b103586e9fd4 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$f649da38897d27f7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c2852c1c4d9aba3e extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4b7b4e09547e4bb3 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$360a094a97597d87 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4d068b43eb55165b extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ac007ee150add337 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$19cb89dd679394cb extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$78651662ad470cc5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8a5041670cdd8db2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(journeyId){
        super('Journey not found', "JourneyNotFoundError"), this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1240ddc25cf964e6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3c4884b7ae7fe517 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$913b8e68dc7ae8fe extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e5ccdf8bbfead7a2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$823733742d803ae6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1caa32527f23acd2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.errorCause = void 0;
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$a6f2aad8fa094b39 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2296e5dc6a1bf3d2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Gateway timeout occurred', "GatewayTimeoutError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2f1e27130c2bf271 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.payloadSize = void 0;
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$d0dc094613469f2b extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.workspaceId = void 0;
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5603eab37ce562f5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.fileType = void 0;
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e0e9aa0e9c6b37ff extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.error = void 0;
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3ad818f64601e141 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$25470bb6cba4fba0 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.messageTemplateId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ce14d445679448b6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.messageTemplateId = void 0;
        this.messageInstanceId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $0a8f0e83dcf5160a$export$c9a26a17db1045c8 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8ab4fb362168b928 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2afd69f57fe5285f extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$7635d2b1a281d626 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = void 0;
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$9e1c6d00e675bc86 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.recipient = void 0;
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$6d1a4929f6ff1a32 extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
const $0a8f0e83dcf5160a$export$5c9840cf9181ada = 'post-office_enable_ca-ignore-upstream-errors';
const $0a8f0e83dcf5160a$export$a1f2446abf1cd73 = '1';
class $0a8f0e83dcf5160a$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = void 0;
        this.messageInstanceId = void 0;
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$c504492f06c975b5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.ipmNumber = void 0;
        this.variantFromStatsig = void 0;
        this.contentfulLocale = void 0;
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1c932b9d1680ee0b extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5d5d1885c87ef4bc extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
module.exports["PostOfficeErrorCodes"] = $0a8f0e83dcf5160a$export$b9722560029694e7;
module.exports["PostOfficeError"] = $0a8f0e83dcf5160a$export$d145ea5319863172;
module.exports["InvalidMessageTemplateIdError"] = $0a8f0e83dcf5160a$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d;

});

parcelRegister("3Shv6", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f1cd061039c521e8$var$initialValue = {};
const $f1cd061039c521e8$export$b060d577040138d8 = (0, $42omo.createContext)($f1cd061039c521e8$var$initialValue);
const $f1cd061039c521e8$export$42de33f7652dc3de = $f1cd061039c521e8$export$b060d577040138d8.Provider;
const $f1cd061039c521e8$export$a5b6d14a2e25725a = ()=>(0, $42omo.useContext)($f1cd061039c521e8$export$b060d577040138d8);
module.exports["MessageContextProvider"] = $f1cd061039c521e8$export$42de33f7652dc3de;
module.exports["useMessageContext"] = $f1cd061039c521e8$export$a5b6d14a2e25725a;

});

parcelRegister("eNels", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $45587d2f47667e39$export$d5a462ce7bd04520 = async (messageTemplateId, placementId, _locale)=>{
    const candidate = `@post-office/i18n-translation/${messageTemplateId}-in-app/${placementId}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return await import(candidate);
};
function $45587d2f47667e39$export$c003690f5ce066ed(messageTemplateId, placementId, messageLoader = $45587d2f47667e39$export$d5a462ce7bd04520) {
    const [messages, setMessages] = (0, $42omo.useState)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    let locale = 'en';
    try {
        locale = (0, $aXWIB.useIntl)().locale;
    } catch  {
    // fallback to en
    }
    (0, $42omo.useEffect)(()=>{
        messageLoader(messageTemplateId, placementId, locale).then((loadedMessages)=>{
            setMessages(loadedMessages.default);
        }).catch(()=>{
            setMessages({});
            fireAnalyticsEvent({
                action: 'error',
                actionSubject: 'i18nMessageLoader',
                eventType: 'operational'
            });
        });
    }, [
        fireAnalyticsEvent,
        locale,
        messageLoader,
        messageTemplateId,
        placementId
    ]);
    return {
        locale: locale,
        messages: messages
    };
}
const $45587d2f47667e39$var$I18nProvider = ({ children: children, messageTemplateId: messageTemplateId, placementId: placementId, messageLoader: messageLoader })=>{
    const { locale: locale, messages: messages } = $45587d2f47667e39$export$c003690f5ce066ed(messageTemplateId, placementId, messageLoader);
    if (!messages || Object.keys(messages).length === 0) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        children: children
    });
};
const $45587d2f47667e39$export$d55fcc9e7bd9ff3e = ({ isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled, messageTemplateId: messageTemplateId, placementId: placementId, children: children, messageLoader: messageLoader = $45587d2f47667e39$export$d5a462ce7bd04520 })=>{
    if (!isI18nMigrationInAppEnabled || !placementId) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($45587d2f47667e39$var$I18nProvider, {
        messageTemplateId: messageTemplateId,
        placementId: placementId,
        messageLoader: messageLoader,
        children: children
    });
};
module.exports["MaybeI18nProvider"] = $45587d2f47667e39$export$d55fcc9e7bd9ff3e;

});

parcelRegister("aEUWC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $03b25510c5956e6e$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $03b25510c5956e6e$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $42omo.createContext)($03b25510c5956e6e$var$defaultMessageAnalyticsContextValue);
const $03b25510c5956e6e$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $42omo.useRef)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($03b25510c5956e6e$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $03b25510c5956e6e$export$bb426ba114b64992 = ()=>(0, $42omo.useContext)($03b25510c5956e6e$export$c81717973c6c4a90);
module.exports["MessageAnalyticsContextProvider"] = $03b25510c5956e6e$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $03b25510c5956e6e$export$bb426ba114b64992;

});

parcelRegister("2amyA", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $h6POP = parcelRequire("h6POP");

const $5a78db0628042bee$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["FeatureFlaggedUfoWrapper"] = $5a78db0628042bee$export$8e6fb7035018b3e4;

});

parcelRegister("Sjnjb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $crDNP = parcelRequire("crDNP");

/** Hide content until validated; avoids flash without off-screen positioning or scrollbar issues. */ const $54a73c30ae097a04$var$HIDDEN_CONTAINER_STYLE = {
    display: 'none'
};
const $54a73c30ae097a04$export$c8b5f992b8a1b38b = ({ children: children, waitForTrigger: waitForTrigger })=>{
    const [validated, setValidated] = (0, $42omo.useState)('pending');
    const isFirstEffectRun = (0, $42omo.useRef)(true);
    (0, $42omo.useLayoutEffect)(()=>{
        const calledRef = waitForTrigger?.__calledRef;
        if (calledRef?.current) {
            isFirstEffectRun.current = false;
            setValidated('allowed');
            return;
        }
        // First run: template may not have run yet (e.g. lazy component suspended). Stay pending
        // so we re-check when children update (after Suspense resolves and template runs).
        if (isFirstEffectRun.current) {
            isFirstEffectRun.current = false;
            return;
        }
        // Ref not set after template had a chance to run (e.g. second commit or template didn't call)
        if (calledRef) setValidated('blocked');
    }, [
        waitForTrigger,
        children
    ]);
    if (validated === 'blocked') return null;
    const isHidden = validated === 'pending';
    if ((0, $c6GJD.default).checkGate('post-office_enable_fixed-viewed-handling')) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: isHidden ? $54a73c30ae097a04$var$HIDDEN_CONTAINER_STYLE : undefined,
        "aria-hidden": isHidden,
        "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $crDNP.ManualMessageViewedEvent), {
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            style: isHidden ? $54a73c30ae097a04$var$HIDDEN_CONTAINER_STYLE : undefined,
            "aria-hidden": isHidden,
            "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
            children: children
        })
    });
};
module.exports["TriggeredMessageValidator"] = $54a73c30ae097a04$export$c8b5f992b8a1b38b;

});

parcelRegister("crDNP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $gVWoV = parcelRequire("gVWoV");


var $jVJ5P = parcelRequire("jVJ5P");


var $42omo = parcelRequire("42omo");


var $e7mZc = parcelRequire("e7mZc");


var $aEUWC = parcelRequire("aEUWC");


var $fUB5z = parcelRequire("fUB5z");

const $b9b497d1215dcd3f$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $aEUWC.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
const $b9b497d1215dcd3f$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $aEUWC.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $gVWoV.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $42omo.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $42omo.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $42omo.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $b9b497d1215dcd3f$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $42omo.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $gVWoV.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $e7mZc.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $42omo.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $42omo.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $l998X.jsx)($b9b497d1215dcd3f$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};
module.exports["ManualMessageViewedEvent"] = $b9b497d1215dcd3f$export$de534803cb07dfcc;
module.exports["MessageViewed"] = $b9b497d1215dcd3f$export$14fe1fc3395b6e3f;

});

parcelRegister("gVWoV", function(module, exports) {

var $PAiZW = parcelRequire("PAiZW");


var $3Shv6 = parcelRequire("3Shv6");


var $8Bzrf = parcelRequire("8Bzrf");


var $hyvHs = parcelRequire("hyvHs");


var $42omo = parcelRequire("42omo");


var $76QLI = parcelRequire("76QLI");


var $gXdxk = parcelRequire("gXdxk");

const $736ffbfc26ebdab1$export$39b0f5626e96f41e = ()=>{
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $gXdxk.MessageInstanceEventClient)();
    const client = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId = null, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, analyticsDetails: analyticsDetails = null, configSetId: configSetId } = (0, $3Shv6.useMessageContext)();
    const { placementId: placementId } = (0, $8Bzrf.usePlacementContext)();
    const browserContext = (0, $PAiZW.usePostOfficeContext)();
    const recommendationContext = (0, $hyvHs.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $42omo.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $76QLI.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceViewed = (0, $42omo.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $76QLI.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceClicked = (0, $42omo.useCallback)(async (params)=>{
        if (!messageInstanceId && !params.messageInstanceId || !messageTemplateId && !params.messageTemplateId || !placementId || !messageCreationType && !params.messageCreationType || !messageTriggerId && !params.messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $76QLI.MessageInstanceEventContextError)());
            return;
        }
        const clickEventPayload = {
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: params.messageTriggerId ?? messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            ...params,
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...params.additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(clickEventPayload);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};
module.exports["useMessageInstanceEvent"] = $736ffbfc26ebdab1$export$39b0f5626e96f41e;

});

parcelRegister("hyvHs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $bYRk6 = parcelRequire("bYRk6");


var $42omo = parcelRequire("42omo");

const $68ebcc2083a05cc4$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $42omo.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $68ebcc2083a05cc4$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($68ebcc2083a05cc4$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: value,
            children: children
        })
    });
};
const $68ebcc2083a05cc4$export$3321c0b02f750bcc = ()=>(0, $42omo.useContext)($68ebcc2083a05cc4$export$ba2f44035effd9c1);
module.exports["RecommendationProvider"] = $68ebcc2083a05cc4$export$f60e87d7b5f59562;
module.exports["useRecommendationContext"] = $68ebcc2083a05cc4$export$3321c0b02f750bcc;

});

parcelRegister("76QLI", function(module, exports) {
class $cf44d591220b1074$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $cf44d591220b1074$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}
module.exports["MessageInstanceEventContextError"] = $cf44d591220b1074$export$9ffc53d3edc152da;

});

parcelRegister("gXdxk", function(module, exports) {
const $49d0938c9296dd55$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("1IQCv"));
class $49d0938c9296dd55$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $49d0938c9296dd55$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}
module.exports["MessageInstanceEventClient"] = $49d0938c9296dd55$export$4564cfc2de39be55;

});

parcelRegister("1IQCv", function(module, exports) {
$parcel$export(module.exports, "DOMException", () => $1412b7bab5fe955c$export$fe58bcf938607f6a);
/* eslint-disable no-prototype-builtins */ var $1412b7bab5fe955c$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $1412b7bab5fe955c$var$support = {
    searchParams: 'URLSearchParams' in $1412b7bab5fe955c$var$g,
    iterable: 'Symbol' in $1412b7bab5fe955c$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $1412b7bab5fe955c$var$g && 'Blob' in $1412b7bab5fe955c$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $1412b7bab5fe955c$var$g,
    arrayBuffer: 'ArrayBuffer' in $1412b7bab5fe955c$var$g
};
function $1412b7bab5fe955c$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($1412b7bab5fe955c$var$support.arrayBuffer) {
    var $1412b7bab5fe955c$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $1412b7bab5fe955c$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $1412b7bab5fe955c$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $1412b7bab5fe955c$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $1412b7bab5fe955c$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $1412b7bab5fe955c$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($1412b7bab5fe955c$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $1412b7bab5fe955c$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $1412b7bab5fe955c$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $1412b7bab5fe955c$var$normalizeName(name);
    value = $1412b7bab5fe955c$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$1412b7bab5fe955c$var$normalizeName(name)];
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $1412b7bab5fe955c$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($1412b7bab5fe955c$var$normalizeName(name));
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$1412b7bab5fe955c$var$normalizeName(name)] = $1412b7bab5fe955c$var$normalizeValue(value);
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $1412b7bab5fe955c$var$iteratorFor(items);
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $1412b7bab5fe955c$var$iteratorFor(items);
};
$1412b7bab5fe955c$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $1412b7bab5fe955c$var$iteratorFor(items);
};
if ($1412b7bab5fe955c$var$support.iterable) $1412b7bab5fe955c$export$79b704688b15c0f4.prototype[Symbol.iterator] = $1412b7bab5fe955c$export$79b704688b15c0f4.prototype.entries;
function $1412b7bab5fe955c$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $1412b7bab5fe955c$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $1412b7bab5fe955c$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $1412b7bab5fe955c$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $1412b7bab5fe955c$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $1412b7bab5fe955c$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $1412b7bab5fe955c$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $1412b7bab5fe955c$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $1412b7bab5fe955c$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($1412b7bab5fe955c$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($1412b7bab5fe955c$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($1412b7bab5fe955c$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($1412b7bab5fe955c$var$support.arrayBuffer && $1412b7bab5fe955c$var$support.blob && $1412b7bab5fe955c$var$isDataView(body)) {
            this._bodyArrayBuffer = $1412b7bab5fe955c$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($1412b7bab5fe955c$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $1412b7bab5fe955c$var$isArrayBufferView(body))) this._bodyArrayBuffer = $1412b7bab5fe955c$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($1412b7bab5fe955c$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($1412b7bab5fe955c$var$support.blob) this.blob = function() {
        var rejected = $1412b7bab5fe955c$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $1412b7bab5fe955c$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($1412b7bab5fe955c$var$support.blob) return this.blob().then($1412b7bab5fe955c$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $1412b7bab5fe955c$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $1412b7bab5fe955c$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($1412b7bab5fe955c$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($1412b7bab5fe955c$var$support.formData) this.formData = function() {
        return this.text().then($1412b7bab5fe955c$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $1412b7bab5fe955c$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $1412b7bab5fe955c$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $1412b7bab5fe955c$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $1412b7bab5fe955c$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $1412b7bab5fe955c$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $1412b7bab5fe955c$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $1412b7bab5fe955c$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $1412b7bab5fe955c$export$79b704688b15c0f4(options.headers);
    this.method = $1412b7bab5fe955c$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $1412b7bab5fe955c$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$1412b7bab5fe955c$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $1412b7bab5fe955c$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $1412b7bab5fe955c$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $1412b7bab5fe955c$var$parseHeaders(rawHeaders) {
    var headers = new $1412b7bab5fe955c$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$1412b7bab5fe955c$var$Body.call($1412b7bab5fe955c$export$7fa6c5b6f8193917.prototype);
function $1412b7bab5fe955c$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $1412b7bab5fe955c$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $1412b7bab5fe955c$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$1412b7bab5fe955c$var$Body.call($1412b7bab5fe955c$export$9f633d56d7ec90d3.prototype);
$1412b7bab5fe955c$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $1412b7bab5fe955c$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $1412b7bab5fe955c$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$1412b7bab5fe955c$export$9f633d56d7ec90d3.error = function() {
    var response = new $1412b7bab5fe955c$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $1412b7bab5fe955c$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$1412b7bab5fe955c$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($1412b7bab5fe955c$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $1412b7bab5fe955c$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $1412b7bab5fe955c$export$fe58bcf938607f6a = $1412b7bab5fe955c$var$g.DOMException;
try {
    new $1412b7bab5fe955c$export$fe58bcf938607f6a();
} catch (err) {
    $1412b7bab5fe955c$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $1412b7bab5fe955c$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $1412b7bab5fe955c$export$fe58bcf938607f6a.prototype.constructor = $1412b7bab5fe955c$export$fe58bcf938607f6a;
}
function $1412b7bab5fe955c$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $1412b7bab5fe955c$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $1412b7bab5fe955c$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $1412b7bab5fe955c$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $1412b7bab5fe955c$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $1412b7bab5fe955c$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $1412b7bab5fe955c$var$g.location.href ? $1412b7bab5fe955c$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($1412b7bab5fe955c$var$support.blob) xhr.responseType = 'blob';
            else if ($1412b7bab5fe955c$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $1412b7bab5fe955c$export$79b704688b15c0f4 || $1412b7bab5fe955c$var$g.Headers && init.headers instanceof $1412b7bab5fe955c$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($1412b7bab5fe955c$var$normalizeName(name));
                xhr.setRequestHeader(name, $1412b7bab5fe955c$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$1412b7bab5fe955c$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$1412b7bab5fe955c$var$g.fetch) {
    $1412b7bab5fe955c$var$g.fetch = $1412b7bab5fe955c$export$e7aa7bc5c1b3cfb3;
    $1412b7bab5fe955c$var$g.Headers = $1412b7bab5fe955c$export$79b704688b15c0f4;
    $1412b7bab5fe955c$var$g.Request = $1412b7bab5fe955c$export$7fa6c5b6f8193917;
    $1412b7bab5fe955c$var$g.Response = $1412b7bab5fe955c$export$9f633d56d7ec90d3;
}
module.exports["Headers"] = $1412b7bab5fe955c$export$79b704688b15c0f4;
module.exports["Request"] = $1412b7bab5fe955c$export$7fa6c5b6f8193917;
module.exports["Response"] = $1412b7bab5fe955c$export$9f633d56d7ec90d3;
module.exports["fetch"] = $1412b7bab5fe955c$export$e7aa7bc5c1b3cfb3;

});

parcelRegister("jVJ5P", function(module, exports) {

var $cpPWT = parcelRequire("cpPWT");

var $PAiZW = parcelRequire("PAiZW");


var $3Shv6 = parcelRequire("3Shv6");


var $8Bzrf = parcelRequire("8Bzrf");


var $hyvHs = parcelRequire("hyvHs");


var $42omo = parcelRequire("42omo");


var $60ZhZ = parcelRequire("60ZhZ");


var $adG9I = parcelRequire("adG9I");


var $hwwQB = parcelRequire("hwwQB");

const $30a6ba7a29ef3ba2$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $adG9I.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $cpPWT.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $3Shv6.useMessageContext)();
    const { placementId: placementId } = (0, $8Bzrf.usePlacementContext)();
    const browserContext = (0, $PAiZW.usePostOfficeContext)();
    const recommendationContext = (0, $hyvHs.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $42omo.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $hwwQB.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $60ZhZ.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $hwwQB.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $60ZhZ.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $hwwQB.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $60ZhZ.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageClicked = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageDismissed = (0, $42omo.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $42omo.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};
module.exports["useMessageEvent"] = $30a6ba7a29ef3ba2$export$3cbbf1e81e2ecb39;

});

parcelRegister("60ZhZ", function(module, exports) {
class $60ff315a8e8596ab$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $60ff315a8e8596ab$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}
module.exports["MessageLifecycleContextError"] = $60ff315a8e8596ab$export$12bb62b204112f55;
module.exports["MessageLifecycleClientError"] = $60ff315a8e8596ab$export$44f397e2afeb89e0;

});

parcelRegister("adG9I", function(module, exports) {
const $598d6f0ae3cb5f70$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $598d6f0ae3cb5f70$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $598d6f0ae3cb5f70$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("1IQCv"));
class $598d6f0ae3cb5f70$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $598d6f0ae3cb5f70$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $598d6f0ae3cb5f70$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $598d6f0ae3cb5f70$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($598d6f0ae3cb5f70$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $598d6f0ae3cb5f70$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $598d6f0ae3cb5f70$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}
module.exports["MessageEventClient"] = $598d6f0ae3cb5f70$export$ae86a6dabe385178;

});

parcelRegister("hwwQB", function(module, exports) {
var $bdfc318f2434f78e$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
module.exports["InAppMessageEventType"] = $bdfc318f2434f78e$export$b31ffc6f7c85f1b;

});

parcelRegister("e7mZc", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $a4738caf79f2dd10$export$6215040b989f9b0f, (v) => $a4738caf79f2dd10$export$6215040b989f9b0f = v);
var $a4738caf79f2dd10$export$1e511d4a378977f5;
var $a4738caf79f2dd10$export$6215040b989f9b0f;
var $a4738caf79f2dd10$export$436b63fa4855237f;
var $a4738caf79f2dd10$export$2e2bcd8739ae039;
var $a4738caf79f2dd10$export$95cef81be5ddcfd4;
"use strict";
$a4738caf79f2dd10$export$1e511d4a378977f5 = true;
$a4738caf79f2dd10$export$6215040b989f9b0f = $a4738caf79f2dd10$export$436b63fa4855237f = $a4738caf79f2dd10$export$2e2bcd8739ae039 = $a4738caf79f2dd10$export$95cef81be5ddcfd4 = void 0;

var $a4738caf79f2dd10$var$_handleViewport = $a4738caf79f2dd10$var$_interopRequireDefault((parcelRequire("cQglR")));
$a4738caf79f2dd10$export$436b63fa4855237f = $a4738caf79f2dd10$var$_handleViewport.default;

var $a4738caf79f2dd10$var$_useInViewport = $a4738caf79f2dd10$var$_interopRequireDefault((parcelRequire("fvKTt")));
$a4738caf79f2dd10$export$6215040b989f9b0f = $a4738caf79f2dd10$var$_useInViewport.default;
function $a4738caf79f2dd10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $a4738caf79f2dd10$var$customProps = $a4738caf79f2dd10$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $a4738caf79f2dd10$var$_default = $a4738caf79f2dd10$export$2e2bcd8739ae039 = $a4738caf79f2dd10$var$_handleViewport.default;

});

parcelRegister("cQglR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $959706786c414c90$export$1e511d4a378977f5, (v) => $959706786c414c90$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $959706786c414c90$export$2e2bcd8739ae039, (v) => $959706786c414c90$export$2e2bcd8739ae039 = v);
var $959706786c414c90$export$1e511d4a378977f5;
var $959706786c414c90$export$2e2bcd8739ae039;
"use strict";
$959706786c414c90$export$1e511d4a378977f5 = true;
$959706786c414c90$export$2e2bcd8739ae039 = void 0;

var $42omo = parcelRequire("42omo");


var $959706786c414c90$var$_hoistNonReactStatics = $959706786c414c90$var$_interopRequireDefault((parcelRequire("56GFp")));

var $959706786c414c90$var$_useInViewport = $959706786c414c90$var$_interopRequireDefault((parcelRequire("fvKTt")));

var $jC1t2 = parcelRequire("jC1t2");


var $l998X = parcelRequire("l998X");

var $959706786c414c90$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $959706786c414c90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $959706786c414c90$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $959706786c414c90$var$_extends() {
    return $959706786c414c90$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $959706786c414c90$var$_extends.apply(null, arguments);
}
function $959706786c414c90$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $jC1t2.defaultOptions;
    if (config === void 0) config = $jC1t2.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $l998X.jsx)(TargetComponent, $959706786c414c90$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $jC1t2.noop, onLeaveViewport: onLeaveViewport = $jC1t2.noop } = _ref, restProps = $959706786c414c90$var$_objectWithoutPropertiesLoose(_ref, $959706786c414c90$var$_excluded);
        var node = (0, $42omo.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $959706786c414c90$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $959706786c414c90$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $l998X.jsx)(ForwardedRefComponent, $959706786c414c90$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $959706786c414c90$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $959706786c414c90$var$_default = $959706786c414c90$export$2e2bcd8739ae039 = $959706786c414c90$var$handleViewport;

});

parcelRegister("fvKTt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $02ea08c7e210a161$export$1e511d4a378977f5, (v) => $02ea08c7e210a161$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $02ea08c7e210a161$export$2e2bcd8739ae039, (v) => $02ea08c7e210a161$export$2e2bcd8739ae039 = v);
var $02ea08c7e210a161$export$1e511d4a378977f5;
var $02ea08c7e210a161$export$2e2bcd8739ae039;
"use strict";
$02ea08c7e210a161$export$1e511d4a378977f5 = true;
$02ea08c7e210a161$export$2e2bcd8739ae039 = void 0;

var $42omo = parcelRequire("42omo");


var $jC1t2 = parcelRequire("jC1t2");

var $02ea08c7e210a161$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $02ea08c7e210a161$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $jC1t2.defaultOptions;
    if (config === void 0) config = $jC1t2.defaultConfig;
    if (props === void 0) props = $jC1t2.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $42omo.useState)();
    var observer = (0, $42omo.useRef)();
    var inViewportRef = (0, $42omo.useRef)(false);
    var intersected = (0, $42omo.useRef)(false);
    var enterCountRef = (0, $42omo.useRef)(0);
    var leaveCountRef = (0, $42omo.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $42omo.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $42omo.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $42omo.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $02ea08c7e210a161$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $02ea08c7e210a161$var$_default = $02ea08c7e210a161$export$2e2bcd8739ae039 = $02ea08c7e210a161$var$useInViewport;

});

parcelRegister("jC1t2", function(module, exports) {
$parcel$export(module.exports, "noop", () => $e472b457761b7785$export$8793edee2d425525, (v) => $e472b457761b7785$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $e472b457761b7785$export$9c21a3269931e1e6, (v) => $e472b457761b7785$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $e472b457761b7785$export$ba43bf67f3d48107, (v) => $e472b457761b7785$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $e472b457761b7785$export$f84bd70098573c5c, (v) => $e472b457761b7785$export$f84bd70098573c5c = v);
var $e472b457761b7785$export$1e511d4a378977f5;
var $e472b457761b7785$export$8793edee2d425525;
var $e472b457761b7785$export$9c21a3269931e1e6;
var $e472b457761b7785$export$ba43bf67f3d48107;
var $e472b457761b7785$export$f84bd70098573c5c;
"use strict";
$e472b457761b7785$export$1e511d4a378977f5 = true;
$e472b457761b7785$export$8793edee2d425525 = $e472b457761b7785$export$9c21a3269931e1e6 = $e472b457761b7785$export$ba43bf67f3d48107 = $e472b457761b7785$export$f84bd70098573c5c = void 0;
var $e472b457761b7785$var$defaultOptions = $e472b457761b7785$export$ba43bf67f3d48107 = {};
var $e472b457761b7785$var$defaultConfig = $e472b457761b7785$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $e472b457761b7785$var$noop = ()=>{};
$e472b457761b7785$export$8793edee2d425525 = $e472b457761b7785$var$noop;
var $e472b457761b7785$var$defaultProps = $e472b457761b7785$export$9c21a3269931e1e6 = {
    onEnterViewport: $e472b457761b7785$var$noop,
    onLeaveViewport: $e472b457761b7785$var$noop
};

});

parcelRegister("cqOSB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5RZ3F = parcelRequire("5RZ3F");


var $gVWoV = parcelRequire("gVWoV");

/**
 * Component that calls messageInstanceViewed, renders messageSuccessComponent, and calls onShow callback once when mounted
 */ const $3151eb9717652767$var$OnChoreographerApproved = ({ children: children, onShow: onShow, messageSuccessComponent: messageSuccessComponent, additionalMetadataFromFrontend: additionalMetadataFromFrontend = {} })=>{
    const hasShownRef = (0, $42omo.useRef)(false);
    const { messageInstanceViewed: messageInstanceViewed } = (0, $gVWoV.useMessageInstanceEvent)();
    (0, $42omo.useEffect)(()=>{
        if (!hasShownRef.current) {
            hasShownRef.current = true;
            messageInstanceViewed({
                ...additionalMetadataFromFrontend
            });
            onShow?.();
        }
    }, [
        onShow,
        messageInstanceViewed,
        additionalMetadataFromFrontend
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            messageSuccessComponent,
            children
        ]
    });
};
const $3151eb9717652767$export$b5884e72fa051e28 = ({ hasTrigger: hasTrigger, messageSuccessComponent: messageSuccessComponent, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const waitForTriggerCalledRef = (0, $42omo.useRef)(false);
    // Create waitForTrigger function that wraps content with choreography
    const waitForTriggerCallback = (0, $42omo.useCallback)((isTriggerActive, messageContent, onShow, additionalMetadataFromFrontend)=>{
        // Mark that this function was called
        waitForTriggerCalledRef.current = true;
        // If isTriggerActive is false, don't claim choreographer slot yet
        if (!isTriggerActive) return null;
        // When triggered, wrap content with choreography and analytics
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5RZ3F.ChoreographerWrapper), {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            children: /*#__PURE__*/ (0, $l998X.jsx)($3151eb9717652767$var$OnChoreographerApproved, {
                onShow: onShow,
                additionalMetadataFromFrontend: additionalMetadataFromFrontend,
                messageSuccessComponent: messageSuccessComponent,
                children: messageContent
            })
        });
    }, [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        messageSuccessComponent
    ]);
    const waitForTrigger = hasTrigger ? waitForTriggerCallback : undefined; // Non-triggered messages don't get this prop
    // Attach the ref to the function as a property
    if (waitForTrigger) waitForTrigger.__calledRef = waitForTriggerCalledRef;
    return {
        waitForTrigger: waitForTrigger
    };
};
module.exports["useWaitForTrigger"] = $3151eb9717652767$export$b5884e72fa051e28;

});

parcelRegister("5RZ3F", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");


var $3zCGc = parcelRequire("3zCGc");

const $92519f251282f573$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $92519f251282f573$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $l998X.jsx)($92519f251282f573$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $92519f251282f573$export$8db7ba034addcd65;

});

parcelRegister("4S89c", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $crDNP = parcelRequire("crDNP");

const $b30ccc91f26ed8ac$export$9915b88f81e90e6e = ({ isManual: isManual, children: children })=>{
    if ((0, $c6GJD.default).checkGate('post-office_enable_fixed-viewed-handling')) return isManual ? /*#__PURE__*/ (0, $l998X.jsx)((0, $crDNP.ManualMessageViewedEvent), {
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["MaybeManualMessageViewedEvent"] = $b30ccc91f26ed8ac$export$9915b88f81e90e6e;

});

parcelRegister("9iUWG", function(module, exports) {
const $eceb70624fd909b9$export$21c420c0c257c346 = (triggerType)=>{
    if (!triggerType) return false;
    return triggerType === 'gasV3' || triggerType === 'poTrigger';
};
module.exports["isClientTriggeredMessage"] = $eceb70624fd909b9$export$21c420c0c257c346;

});

parcelRegister("lVEBn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $3zCGc = parcelRequire("3zCGc");


var $42omo = parcelRequire("42omo");

const $5d2b57d7f45b3b6a$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $5d2b57d7f45b3b6a$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $l998X.jsx)($5d2b57d7f45b3b6a$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $5d2b57d7f45b3b6a$export$8db7ba034addcd65;

});

parcelRegister("6Ht9d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $876859b1b10b173e$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $42omo.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gAOec.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $876859b1b10b173e$export$5523c5f3222291d0;

});

parcelRegister("gAOec", function(module, exports) {

var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");


var $42omo = parcelRequire("42omo");


var $6IMPA = parcelRequire("6IMPA");

class $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $42omo.useState)((0, $6IMPA.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $42omo.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $6IMPA.assertResponseIsOk)(res)) {
                const data = await res.json();
                setState((0, $6IMPA.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $6IMPA.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};
module.exports["AlreadyRunningError"] = $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b;
module.exports["useData"] = $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937;

});

parcelRegister("6IMPA", function(module, exports) {
const $7d79f12ff0021e5f$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $7d79f12ff0021e5f$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($7d79f12ff0021e5f$export$18a0019e5439b209(res));
};
const $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $7d79f12ff0021e5f$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $7d79f12ff0021e5f$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });
module.exports["assertResponseIsOk"] = $7d79f12ff0021e5f$export$b3732c8ff6f9c463;
module.exports["toLoading"] = $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc;
module.exports["toError"] = $7d79f12ff0021e5f$export$cc3b967c039ed3e7;
module.exports["toData"] = $7d79f12ff0021e5f$export$24a6b176bdc41ce5;

});

parcelRegister("j0Fou", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $PAiZW = parcelRequire("PAiZW");


var $kO3gu = parcelRequire("kO3gu");


var $8Bzrf = parcelRequire("8Bzrf");


var $eHv8q = parcelRequire("eHv8q");


var $9OLUt = parcelRequire("9OLUt");


var $kODQd = parcelRequire("kODQd");


var $42omo = parcelRequire("42omo");

// https://switcheroo.atlassian.com/ui/gates/746a161c-d307-4db3-a966-8fe63c551fea/key/post-office_skip_rest_for_graphql_subscription
const $68a42afbf7553230$var$SKIP_REST_FETCH_GATE = 'post-office_skip_rest_for_graphql_subscription';
const $68a42afbf7553230$export$201bbce8187a6e3c = (path, config)=>{
    const { placementId: placementId } = (0, $8Bzrf.usePlacementContext)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    const { subscription: subscription } = (0, $kODQd.useSubscriptionConfig)();
    const placementApi = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!placementId) return ()=>({
                isLoading: false,
                data: undefined,
                error: new Error('No placementId found. Ensure this hook is used as a child of PlacementProvider.')
            });
        // Prefer the explicit prop when provided; fall back to the Switcheroo gate
        // so existing callers that have not yet migrated continue to work unchanged.
        const isClientFetch = config?.useClientFetch !== undefined ? config.useClientFetch : (0, $c6GJD.default).checkGate('post-office-use-placement-with-client');
        if (isClientFetch) return (0, $9OLUt.createUsePlacementWithClient)(placementId, fetcher);
        return (0, $eHv8q.createUsePlacement)(placementId, fetcher);
    }, [
        placementId,
        fetcher,
        config?.useClientFetch
    ]);
    const { queryParams: queryParams = {} } = config ?? {};
    const placementParams = {
        ...context,
        ...queryParams
    };
    const apiDependencies = (0, $42omo.useMemo)(()=>{
        return [
            config?.autoRefetch?.updateKey
        ];
    }, [
        config?.autoRefetch?.updateKey
    ]);
    // disable REST fetch for initialMessages for subscription based placements if the gate is enabled
    const isSubscriptionBasedFetchDisabled = subscription?.enabled === true && (0, $c6GJD.default).checkGate($68a42afbf7553230$var$SKIP_REST_FETCH_GATE);
    return placementApi(path, placementParams, config?.requestOptions, {
        throttleTime: config?.throttleTime,
        isEnabled: isSubscriptionBasedFetchDisabled ? false : config?.autoRefetch?.isEnabled,
        deps: apiDependencies
    });
};
module.exports["usePlacementApi"] = $68a42afbf7553230$export$201bbce8187a6e3c;

});

parcelRegister("eHv8q", function(module, exports) {

var $2OGMq = parcelRequire("2OGMq");


var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $872a969cc90d2799$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $42omo.useRef)();
        const isRunningPromise = (0, $42omo.useRef)(false);
        (0, $42omo.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $42omo.useMemo)(()=>{
            if (config?.isEnabled === false) return undefined;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new (0, $gAOec.AlreadyRunningError)());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $2OGMq.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            config?.deps,
            path
        ]);
        return (0, $gAOec.useData)(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};
module.exports["createUsePlacement"] = $872a969cc90d2799$export$ee1d67e435d25cb5;

});

parcelRegister("2OGMq", function(module, exports) {
const $c9d2f99792ae105c$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $c9d2f99792ae105c$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $c9d2f99792ae105c$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$c9d2f99792ae105c$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $c9d2f99792ae105c$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($c9d2f99792ae105c$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$c9d2f99792ae105c$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};
module.exports["fetchPlacementData"] = $c9d2f99792ae105c$export$ce743d02f83ee521;

});

parcelRegister("9OLUt", function(module, exports) {

var $hy3a0 = parcelRequire("hy3a0");


var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");

const $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
    return (path, context, requestOptions, config)=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const analyticsSubjectId = placementId;
        const analyticsAttributes = {
            path: path
        };
        const { data: data, error: error } = (0, $hy3a0.useFetchPlacementData)(config?.isEnabled === false ? null : placementId, path, context, fetcher, requestOptions, {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            onSuccess: ()=>{
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            },
            onError: (error)=>{
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: error?.name ?? 'unknown',
                        errorMessage: error?.message ?? 'unknown'
                    }
                });
            }
        });
        if (data) return {
            isLoading: false,
            error: undefined,
            data: data
        };
        if (error) return {
            isLoading: false,
            error: error,
            data: undefined
        };
        return {
            isLoading: true,
            error: undefined,
            data: undefined
        };
    };
};
module.exports["createUsePlacementWithClient"] = $c40dbd4b4a40e84f$export$7a2a7b6f48ac7d1;

});

parcelRegister("hy3a0", function(module, exports) {

var $fCcUZ = parcelRequire("fCcUZ");

const $785c8761b65409e5$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $785c8761b65409e5$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $785c8761b65409e5$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$785c8761b65409e5$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $785c8761b65409e5$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $785c8761b65409e5$export$ef70136078f15deb = (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($785c8761b65409e5$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$785c8761b65409e5$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $fCcUZ.default)(placementId ? url : null, (url)=>fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...$785c8761b65409e5$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};
module.exports["useFetchPlacementData"] = $785c8761b65409e5$export$ef70136078f15deb;

});

parcelRegister("fCcUZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $kdJ9r = parcelRequire("kdJ9r");
parcelRequire("ltrno");
var $ltrno = parcelRequire("ltrno");

var $hKRm8 = parcelRequire("hKRm8");

// Shared state between server components and client components
const $b5e46ce872016a0c$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $b5e46ce872016a0c$var$UNDEFINED = /*#__NOINLINE__*/ $b5e46ce872016a0c$var$noop();
const $b5e46ce872016a0c$var$OBJECT = Object;
const $b5e46ce872016a0c$var$isUndefined = (v)=>v === $b5e46ce872016a0c$var$UNDEFINED;
const $b5e46ce872016a0c$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $b5e46ce872016a0c$var$table = new WeakMap();
const $b5e46ce872016a0c$var$getTypeName = (value)=>$b5e46ce872016a0c$var$OBJECT.prototype.toString.call(value);
const $b5e46ce872016a0c$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $b5e46ce872016a0c$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $b5e46ce872016a0c$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $b5e46ce872016a0c$var$getTypeName(arg);
    const isDate = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $b5e46ce872016a0c$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($b5e46ce872016a0c$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $b5e46ce872016a0c$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$b5e46ce872016a0c$var$counter + '~';
        $b5e46ce872016a0c$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $b5e46ce872016a0c$var$stableHash(arg[index]) + ',';
            $b5e46ce872016a0c$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $b5e46ce872016a0c$var$OBJECT.keys(arg).sort();
            while(!$b5e46ce872016a0c$var$isUndefined(index = keys.pop()))if (!$b5e46ce872016a0c$var$isUndefined(arg[index])) result += index + ':' + $b5e46ce872016a0c$var$stableHash(arg[index]) + ',';
            $b5e46ce872016a0c$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $b5e46ce872016a0c$var$serialize = (key)=>{
    if ($b5e46ce872016a0c$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $b5e46ce872016a0c$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $b5e46ce872016a0c$export$dbab534a48e651ef = (key)=>$b5e46ce872016a0c$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $b5e46ce872016a0c$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $b5e46ce872016a0c$var$WITH_DEDUPE = {
    dedupe: true
};
const $b5e46ce872016a0c$var$resolvedUndef = Promise.resolve((0, $kdJ9r.U));
/**
 * The core implementation of the useSWR hook.
 *
 * This is the main handler function that implements all SWR functionality including
 * data fetching, caching, revalidation, error handling, and state management.
 * It manages the complete lifecycle of SWR requests from initialization through
 * cleanup.
 *
 * Key responsibilities:
 * - Key serialization and normalization
 * - Cache state management and synchronization
 * - Automatic and manual revalidation
 * - Error handling and retry logic
 * - Suspense integration
 * - Loading state management
 * - Effect cleanup and memory management
 *
 * @template Data - The type of data returned by the fetcher
 * @template Error - The type of error that can be thrown
 *
 * @param _key - The SWR key (string, array, object, function, or falsy)
 * @param fetcher - The fetcher function to retrieve data, or null to disable fetching
 * @param config - Complete SWR configuration object with both public and internal options
 *
 * @returns SWRResponse object containing data, error, mutate function, and loading states
 *
 * @internal This is the internal implementation. Use `useSWR` instead.
 */ const $b5e46ce872016a0c$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData, strictServerPrefetchWarning: strictServerPrefetchWarning } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $kdJ9r.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $kdJ9r.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $42omo.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $42omo.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $42omo.useRef)(key);
    const fetcherRef = (0, $42omo.useRef)(fetcher);
    const configRef = (0, $42omo.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $kdJ9r.z)(cache, key);
    const stateDependencies = (0, $42omo.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $kdJ9r.e)(fallbackData) ? (0, $kdJ9r.e)(config.fallback) ? (0, $kdJ9r.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $kdJ9r.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $42omo.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $kdJ9r.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $kdJ9r.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $hxT4C.useSyncExternalStore)((0, $42omo.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $kdJ9r.e)(cachedData) ? fallback && (0, $kdJ9r.B)(fallback) ? $b5e46ce872016a0c$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $42omo.useRef)(data);
    const returnedData = keepPreviousData ? (0, $kdJ9r.e)(cachedData) ? (0, $kdJ9r.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    const hasKeyButNoData = key && (0, $kdJ9r.e)(data);
    // Note: the conditionally hook call is fine because the environment
    // `IS_SERVER` never changes.
    const isHydration = !(0, $kdJ9r.r) && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hxT4C.useSyncExternalStore)(()=>(0, $kdJ9r.A), ()=>false, ()=>true);
    // During the initial SSR render, warn if the key has no data pre-fetched via:
    // - fallback data
    // - preload calls
    // - initial data from the cache provider
    // We only warn once for each key during SSR.
    if (strictServerPrefetchWarning && isHydration && !suspense && hasKeyButNoData) console.warn(`Missing pre-initiated data for serialized key "${key}" during server-side rendering. Data fethcing should be initiated on the server and provided to SWR via fallback data. You can set "strictServerPrefetchWarning: false" to disable this warning.`);
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $kdJ9r.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $kdJ9r.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $kdJ9r.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $kdJ9r.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $kdJ9r.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $kdJ9r.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $42omo.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $kdJ9r.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $kdJ9r.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $kdJ9r.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $kdJ9r.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $kdJ9r.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $kdJ9r.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $kdJ9r.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $hKRm8).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $42omo.useCallback)((...args)=>{
        return (0, $kdJ9r.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $kdJ9r.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $kdJ9r.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $kdJ9r.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $kdJ9r.U), $b5e46ce872016a0c$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $hKRm8).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $hKRm8).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $hKRm8).MUTATE_EVENT) return revalidate();
            else if (type == (0, $hKRm8).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $ltrno.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $kdJ9r.e)(data) || (0, $kdJ9r.r)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $kdJ9r.t)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $kdJ9r.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $kdJ9r.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($b5e46ce872016a0c$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $42omo.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $kdJ9r.I) && (0, $kdJ9r.r) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $kdJ9r.e)(req) && hasKeyButNoData ? boundMutate(req) : $b5e46ce872016a0c$var$resolvedUndef;
        $b5e46ce872016a0c$var$use(mutateReq);
        if (!(0, $kdJ9r.e)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($b5e46ce872016a0c$var$WITH_DEDUPE) : $b5e46ce872016a0c$var$resolvedUndef;
        if (!(0, $kdJ9r.e)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $b5e46ce872016a0c$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $b5e46ce872016a0c$export$4c7bbecdacc3ca2c = (0, $kdJ9r.O).defineProperty((0, $kdJ9r.g), 'defaultValue', {
    value: (0, $kdJ9r.d)
});
/**
 * A hook to fetch data.
 *
 * @see {@link https://swr.vercel.app}
 *
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $b5e46ce872016a0c$export$2e2bcd8739ae039 = (0, $ltrno.withArgs)($b5e46ce872016a0c$var$useSWRHandler);
module.exports["SWRConfig"] = $b5e46ce872016a0c$export$4c7bbecdacc3ca2c;
module.exports["default"] = $b5e46ce872016a0c$export$2e2bcd8739ae039;

});

parcelRegister("kdJ9r", function(module, exports) {
$parcel$export(module.exports, "c", () => $eb880baa88ae83f7$export$db3b6bfb95261072);

var $42omo = parcelRequire("42omo");


var $hKRm8 = parcelRequire("hKRm8");


var $hrSFW = parcelRequire("hrSFW");

'use client';
// Global state used to deduplicate requests and store listeners
const $eb880baa88ae83f7$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $eb880baa88ae83f7$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $eb880baa88ae83f7$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $eb880baa88ae83f7$export$ebd11618f299a286();
const $eb880baa88ae83f7$export$c4ce752e73470fba = Object;
const $eb880baa88ae83f7$export$f1e1789686576879 = (v)=>v === $eb880baa88ae83f7$export$3a6d5c9ae78a2c08;
const $eb880baa88ae83f7$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $eb880baa88ae83f7$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $eb880baa88ae83f7$export$ef35774e6d314e91 = (x)=>$eb880baa88ae83f7$export$407448d2b89b1813(x.then);
const $eb880baa88ae83f7$var$EMPTY_CACHE = {};
const $eb880baa88ae83f7$var$INITIAL_CACHE = {};
const $eb880baa88ae83f7$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $eb880baa88ae83f7$export$23f2a1d2818174ef = typeof window != $eb880baa88ae83f7$var$STR_UNDEFINED;
const $eb880baa88ae83f7$export$efccba1c4a2ef57b = typeof document != $eb880baa88ae83f7$var$STR_UNDEFINED;
const $eb880baa88ae83f7$export$d141bba7fdc215a3 = $eb880baa88ae83f7$export$23f2a1d2818174ef && 'Deno' in window;
const $eb880baa88ae83f7$export$4a5767248b18ef41 = ()=>$eb880baa88ae83f7$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $eb880baa88ae83f7$var$STR_UNDEFINED;
const $eb880baa88ae83f7$export$df995fae86a55f06 = (cache, key)=>{
    const state = $eb880baa88ae83f7$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$eb880baa88ae83f7$export$f1e1789686576879(key) && cache.get(key) || $eb880baa88ae83f7$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$eb880baa88ae83f7$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $eb880baa88ae83f7$var$INITIAL_CACHE)) $eb880baa88ae83f7$var$INITIAL_CACHE[key] = prev;
                state[5](key, $eb880baa88ae83f7$export$953cecd6e717a553(prev, info), prev || $eb880baa88ae83f7$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$eb880baa88ae83f7$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $eb880baa88ae83f7$var$INITIAL_CACHE) return $eb880baa88ae83f7$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$eb880baa88ae83f7$export$f1e1789686576879(key) && cache.get(key) || $eb880baa88ae83f7$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $eb880baa88ae83f7$var$online = true;
const $eb880baa88ae83f7$var$isOnline = ()=>$eb880baa88ae83f7$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$eb880baa88ae83f7$var$onWindowEvent, $eb880baa88ae83f7$var$offWindowEvent] = $eb880baa88ae83f7$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $eb880baa88ae83f7$export$ebd11618f299a286,
    $eb880baa88ae83f7$export$ebd11618f299a286
];
const $eb880baa88ae83f7$var$isVisible = ()=>{
    const visibilityState = $eb880baa88ae83f7$export$efccba1c4a2ef57b && document.visibilityState;
    return $eb880baa88ae83f7$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $eb880baa88ae83f7$var$initFocus = (callback)=>{
    // focus revalidate
    if ($eb880baa88ae83f7$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $eb880baa88ae83f7$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($eb880baa88ae83f7$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $eb880baa88ae83f7$var$offWindowEvent('focus', callback);
    };
};
const $eb880baa88ae83f7$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $eb880baa88ae83f7$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $eb880baa88ae83f7$var$online = false;
    };
    $eb880baa88ae83f7$var$onWindowEvent('online', onOnline);
    $eb880baa88ae83f7$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $eb880baa88ae83f7$var$offWindowEvent('online', onOnline);
        $eb880baa88ae83f7$var$offWindowEvent('offline', onOffline);
    };
};
const $eb880baa88ae83f7$export$ffb5f4729a158638 = {
    isOnline: $eb880baa88ae83f7$var$isOnline,
    isVisible: $eb880baa88ae83f7$var$isVisible
};
const $eb880baa88ae83f7$export$9e5f44173e64f162 = {
    initFocus: $eb880baa88ae83f7$var$initFocus,
    initReconnect: $eb880baa88ae83f7$var$initReconnect
};
const $eb880baa88ae83f7$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useId;
const $eb880baa88ae83f7$export$43caf9889c228507 = !$eb880baa88ae83f7$export$23f2a1d2818174ef || $eb880baa88ae83f7$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $eb880baa88ae83f7$export$625550452a3fa3ec = (f)=>$eb880baa88ae83f7$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $eb880baa88ae83f7$export$3b14a55fb2447963 = $eb880baa88ae83f7$export$43caf9889c228507 ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $eb880baa88ae83f7$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $eb880baa88ae83f7$export$90a7f3efeed30595 = !$eb880baa88ae83f7$export$43caf9889c228507 && $eb880baa88ae83f7$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($eb880baa88ae83f7$var$navigatorConnection.effectiveType) || $eb880baa88ae83f7$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $eb880baa88ae83f7$var$table = new WeakMap();
const $eb880baa88ae83f7$var$getTypeName = (value)=>$eb880baa88ae83f7$export$c4ce752e73470fba.prototype.toString.call(value);
const $eb880baa88ae83f7$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $eb880baa88ae83f7$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $eb880baa88ae83f7$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $eb880baa88ae83f7$var$getTypeName(arg);
    const isDate = $eb880baa88ae83f7$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $eb880baa88ae83f7$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $eb880baa88ae83f7$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($eb880baa88ae83f7$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $eb880baa88ae83f7$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$eb880baa88ae83f7$var$counter + '~';
        $eb880baa88ae83f7$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $eb880baa88ae83f7$export$882b5998b3b9117c(arg[index]) + ',';
            $eb880baa88ae83f7$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $eb880baa88ae83f7$export$c4ce752e73470fba.keys(arg).sort();
            while(!$eb880baa88ae83f7$export$f1e1789686576879(index = keys.pop()))if (!$eb880baa88ae83f7$export$f1e1789686576879(arg[index])) result += index + ':' + $eb880baa88ae83f7$export$882b5998b3b9117c(arg[index]) + ',';
            $eb880baa88ae83f7$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $eb880baa88ae83f7$export$2408f22a0fab9ae5 = (key)=>{
    if ($eb880baa88ae83f7$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $eb880baa88ae83f7$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $eb880baa88ae83f7$var$__timestamp = 0;
const $eb880baa88ae83f7$export$ae1af26003f05816 = ()=>++$eb880baa88ae83f7$var$__timestamp;
async function $eb880baa88ae83f7$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $eb880baa88ae83f7$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($eb880baa88ae83f7$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $eb880baa88ae83f7$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $eb880baa88ae83f7$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $eb880baa88ae83f7$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $eb880baa88ae83f7$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($hKRm8.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $eb880baa88ae83f7$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$eb880baa88ae83f7$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $eb880baa88ae83f7$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $eb880baa88ae83f7$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($eb880baa88ae83f7$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $eb880baa88ae83f7$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $eb880baa88ae83f7$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($eb880baa88ae83f7$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $eb880baa88ae83f7$export$3a6d5c9ae78a2c08,
                        _c: $eb880baa88ae83f7$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $eb880baa88ae83f7$export$3a6d5c9ae78a2c08,
                    _c: $eb880baa88ae83f7$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $eb880baa88ae83f7$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $eb880baa88ae83f7$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $eb880baa88ae83f7$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $eb880baa88ae83f7$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$eb880baa88ae83f7$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $eb880baa88ae83f7$export$953cecd6e717a553($eb880baa88ae83f7$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $eb880baa88ae83f7$export$7ccc53e8f1e7dfc5.bind($eb880baa88ae83f7$export$3a6d5c9ae78a2c08, provider);
        let unmount = $eb880baa88ae83f7$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$eb880baa88ae83f7$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $eb880baa88ae83f7$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$eb880baa88ae83f7$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($eb880baa88ae83f7$export$3a6d5c9ae78a2c08, $eb880baa88ae83f7$var$revalidateAllKeys.bind($eb880baa88ae83f7$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $hKRm8.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($eb880baa88ae83f7$export$3a6d5c9ae78a2c08, $eb880baa88ae83f7$var$revalidateAllKeys.bind($eb880baa88ae83f7$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $hKRm8.RECONNECT_EVENT)));
                    unmount = ()=>{
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseFocus && releaseFocus();
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $eb880baa88ae83f7$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $eb880baa88ae83f7$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $eb880baa88ae83f7$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$eb880baa88ae83f7$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $eb880baa88ae83f7$export$342063e11d6c3cad = (0, $hrSFW.dequal);
// Default cache provider
const [$eb880baa88ae83f7$export$db3b6bfb95261072, $eb880baa88ae83f7$export$35e795649ee09318] = $eb880baa88ae83f7$export$dda1d9f60106f0e9(new Map());
// Default config
const $eb880baa88ae83f7$export$4368d992c4eafac0 = $eb880baa88ae83f7$export$953cecd6e717a553({
    // events
    onLoadingSlow: $eb880baa88ae83f7$export$ebd11618f299a286,
    onSuccess: $eb880baa88ae83f7$export$ebd11618f299a286,
    onError: $eb880baa88ae83f7$export$ebd11618f299a286,
    onErrorRetry: $eb880baa88ae83f7$var$onErrorRetry,
    onDiscarded: $eb880baa88ae83f7$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $eb880baa88ae83f7$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $eb880baa88ae83f7$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $eb880baa88ae83f7$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $eb880baa88ae83f7$export$db3b6bfb95261072,
    mutate: $eb880baa88ae83f7$export$35e795649ee09318,
    fallback: {}
}, $eb880baa88ae83f7$export$ffb5f4729a158638);
const $eb880baa88ae83f7$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $eb880baa88ae83f7$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $eb880baa88ae83f7$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $eb880baa88ae83f7$export$25ce5a424b770e84 = (0, $42omo.createContext)({});
const $eb880baa88ae83f7$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $42omo.useContext)($eb880baa88ae83f7$export$25ce5a424b770e84);
    const isFunctionalConfig = $eb880baa88ae83f7$export$407448d2b89b1813(value);
    const config = (0, $42omo.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $42omo.useMemo)(()=>isFunctionalConfig ? config : $eb880baa88ae83f7$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $42omo.useRef)($eb880baa88ae83f7$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $eb880baa88ae83f7$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $eb880baa88ae83f7$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $eb880baa88ae83f7$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $42omo.createElement)($eb880baa88ae83f7$export$25ce5a424b770e84.Provider, $eb880baa88ae83f7$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};
module.exports["b"] = $eb880baa88ae83f7$export$8b22cf2602fb60ce;
module.exports["A"] = $eb880baa88ae83f7$export$ebd11618f299a286;
module.exports["U"] = $eb880baa88ae83f7$export$3a6d5c9ae78a2c08;
module.exports["O"] = $eb880baa88ae83f7$export$c4ce752e73470fba;
module.exports["e"] = $eb880baa88ae83f7$export$f1e1789686576879;
module.exports["a"] = $eb880baa88ae83f7$export$407448d2b89b1813;
module.exports["m"] = $eb880baa88ae83f7$export$953cecd6e717a553;
module.exports["B"] = $eb880baa88ae83f7$export$ef35774e6d314e91;
module.exports["i"] = $eb880baa88ae83f7$export$23f2a1d2818174ef;
module.exports["z"] = $eb880baa88ae83f7$export$df995fae86a55f06;
module.exports["I"] = $eb880baa88ae83f7$export$9bb611d729802a56;
module.exports["r"] = $eb880baa88ae83f7$export$43caf9889c228507;
module.exports["t"] = $eb880baa88ae83f7$export$625550452a3fa3ec;
module.exports["u"] = $eb880baa88ae83f7$export$3b14a55fb2447963;
module.exports["s"] = $eb880baa88ae83f7$export$2408f22a0fab9ae5;
module.exports["o"] = $eb880baa88ae83f7$export$ae1af26003f05816;
module.exports["n"] = $eb880baa88ae83f7$export$7ccc53e8f1e7dfc5;
module.exports["d"] = $eb880baa88ae83f7$export$4368d992c4eafac0;
module.exports["f"] = $eb880baa88ae83f7$export$2d1720544b23b823;
module.exports["S"] = $eb880baa88ae83f7$export$25ce5a424b770e84;
module.exports["g"] = $eb880baa88ae83f7$export$39b482c5e57630a8;

});

parcelRegister("hKRm8", function(module, exports) {
const $0355effb9da30fde$export$831c820ad60f9d12 = 0;
const $0355effb9da30fde$export$24e9454cb99a11dc = 1;
const $0355effb9da30fde$export$75ea288459391154 = 2;
const $0355effb9da30fde$export$b019c3839228f243 = 3;
module.exports["FOCUS_EVENT"] = $0355effb9da30fde$export$831c820ad60f9d12;
module.exports["RECONNECT_EVENT"] = $0355effb9da30fde$export$24e9454cb99a11dc;
module.exports["MUTATE_EVENT"] = $0355effb9da30fde$export$75ea288459391154;
module.exports["ERROR_REVALIDATE_EVENT"] = $0355effb9da30fde$export$b019c3839228f243;

});

parcelRegister("hrSFW", function(module, exports) {
var $cb3f5eae1efed147$var$has = Object.prototype.hasOwnProperty;
function $cb3f5eae1efed147$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $cb3f5eae1efed147$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($cb3f5eae1efed147$var$has.call(foo, ctor) && ++len && !$cb3f5eae1efed147$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$cb3f5eae1efed147$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $cb3f5eae1efed147$export$de8294bb3be0322f;

});

parcelRegister("ltrno", function(module, exports) {
$parcel$export(module.exports, "useSWRConfig", () => $fa218ac480f8609c$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "withArgs", () => $fa218ac480f8609c$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $fa218ac480f8609c$export$e005210ed621746);
$parcel$export(module.exports, "SWRGlobalState", () => (parcelRequire("kdJ9r")).b);
$parcel$export(module.exports, "defaultConfig", () => (parcelRequire("kdJ9r")).d);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("kdJ9r")).a);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("kdJ9r")).e);
$parcel$export(module.exports, "mergeObjects", () => (parcelRequire("kdJ9r")).m);
$parcel$export(module.exports, "serialize", () => (parcelRequire("kdJ9r")).s);

var $kdJ9r = parcelRequire("kdJ9r");


var $hKRm8 = parcelRequire("hKRm8");


var $aQZOK = parcelRequire("aQZOK");


var $42omo = parcelRequire("42omo");


// @ts-expect-error
const $fa218ac480f8609c$var$enableDevtools = (0, $kdJ9r.i) && window.__SWR_DEVTOOLS_USE__;
const $fa218ac480f8609c$var$use = $fa218ac480f8609c$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $fa218ac480f8609c$var$setupDevTools = ()=>{
    if ($fa218ac480f8609c$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
};
const $fa218ac480f8609c$export$a3295358bff77e = (args)=>{
    return (0, $kdJ9r.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $fa218ac480f8609c$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $42omo.useContext)((0, $kdJ9r.S));
    const mergedConfig = (0, $42omo.useMemo)(()=>(0, $kdJ9r.m)((0, $kdJ9r.d), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $fa218ac480f8609c$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $kdJ9r.s)(key_);
    const [, , , PRELOAD] = (0, $kdJ9r.b).get((0, $kdJ9r.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $fa218ac480f8609c$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $kdJ9r.s)(key_);
            const [, , , PRELOAD] = (0, $kdJ9r.b).get((0, $kdJ9r.c));
            if (key.startsWith((0, $aQZOK.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $kdJ9r.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $fa218ac480f8609c$var$BUILT_IN_MIDDLEWARE = $fa218ac480f8609c$var$use.concat($fa218ac480f8609c$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $fa218ac480f8609c$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $fa218ac480f8609c$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $fa218ac480f8609c$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $kdJ9r.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($fa218ac480f8609c$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $fa218ac480f8609c$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $fa218ac480f8609c$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $fa218ac480f8609c$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$fa218ac480f8609c$var$setupDevTools();

});

parcelRegister("aQZOK", function(module, exports) {
const $7e6eb65cf45696a8$export$8667f065faedc62c = '$inf$';
module.exports["INFINITE_PREFIX"] = $7e6eb65cf45696a8$export$8667f065faedc62c;

});

parcelRegister("8tIbq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $2MPqq = parcelRequire("2MPqq");

const $50e1434d8c6bc030$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $50e1434d8c6bc030$export$6a6a5d23d75b0f62 = ({ selectors: selectors = [
    'body'
], options: options = $50e1434d8c6bc030$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $42omo.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer)=>observer.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
module.exports["UNSAFE_UpdateOnChange"] = $50e1434d8c6bc030$export$6a6a5d23d75b0f62;

});

parcelRegister("2Pg7f", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $esRft = parcelRequire("esRft");


var $4JWgN = parcelRequire("4JWgN");


var $ee7An = parcelRequire("ee7An");


var $loiTn = parcelRequire("loiTn");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $htJyp = parcelRequire("htJyp");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $fj4Q9 = parcelRequire("fj4Q9");


var $crJ46 = parcelRequire("crJ46");


var $6MWy1 = parcelRequire("6MWy1");


var $2cWqt = parcelRequire("2cWqt");


var $2LGbr = parcelRequire("2LGbr");


var $6Ac15 = parcelRequire("6Ac15");


var $1DG7o = parcelRequire("1DG7o");

const $49cfd043cf935c3d$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $49cfd043cf935c3d$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $49cfd043cf935c3d$var$AvatarGroup = ({ appearance: appearance = 'stack', moreIndicatorAppearance: moreIndicatorAppearance, avatar: avatar = (0, $esRft.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $ee7An.default;
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $4JWgN.KEY_DOWN)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$49cfd043cf935c3d$var$getOverrides(overrides).MoreIndicator.render((0, $2LGbr.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props,
                ...(0, $dh538.fg)('jira-ai-agent-stack') && {
                    appearance: moreIndicatorAppearance
                }
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6MWy1.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2cWqt.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatar, index)=>$49cfd043cf935c3d$var$getOverrides(overrides).AvatarGroupItem.render((0, $fj4Q9.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>(0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $htJyp.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: renderMoreButton({
                        ...triggerProps,
                        ...bindFocus,
                        onClick: handleTriggerClicked
                    })
                }) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $49cfd043cf935c3d$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const groupId = (0, $c0qxy.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6Ac15.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                if ((0, $dh538.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $htJyp.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: avatarData.name,
                        testId: testId && `${testId}--tooltip-${idx}`,
                        position: tooltipPosition,
                        children: finalAvatar
                    }) : finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx));
                else return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $crJ46.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                if ((0, $dh538.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $htJyp.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: avatarData.name,
                        testId: testId && `${testId}--tooltip-${idx}`,
                        position: tooltipPosition,
                        children: finalAvatar
                    }) : finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx));
                else return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    });
};
var $49cfd043cf935c3d$export$2e2bcd8739ae039 = $49cfd043cf935c3d$var$AvatarGroup;
module.exports["default"] = $49cfd043cf935c3d$export$2e2bcd8739ae039;

});

parcelRegister("fj4Q9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");

var $d77M1 = parcelRequire("d77M1");

var $cGtPE = parcelRequire("cGtPE");


var $atkCk = parcelRequire("atkCk");

const $b02c3981c986946c$var$AvatarGroupItem = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $atkCk.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b02c3981c986946c$export$2e2bcd8739ae039 = $b02c3981c986946c$var$AvatarGroupItem;
module.exports["default"] = $b02c3981c986946c$export$2e2bcd8739ae039;

});

parcelRegister("atkCk", function(module, exports) {
// eslint-disable-next-line sort-imports

var $42omo = parcelRequire("42omo");


var $2gBGR = parcelRequire("2gBGR");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $f69e73e233725633$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $2gBGR.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $f69e73e233725633$export$2e2bcd8739ae039 = $f69e73e233725633$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f69e73e233725633$export$2e2bcd8739ae039;

});

parcelRegister("2gBGR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $9cda518d56d21a57$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
module.exports["FocusManagerContext"] = $9cda518d56d21a57$export$f18c1d4fc7326096;

});

parcelRegister("crJ46", function(module, exports) {
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g9Srd = parcelRequire("g9Srd");


var $dh538 = parcelRequire("dh538");

const $97f44b6287529f93$var$gutter = "var(--ds-space-negative-050, -4px)";
const $97f44b6287529f93$var$listStyles = null;
const $97f44b6287529f93$var$listStylesFlagged = null;
const $97f44b6287529f93$var$listItemStyles = null;
const $97f44b6287529f93$var$Grid = ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]),
        children: (0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
            exitThenEnter: true,
            children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                    className: (0, $gMc0m.default)([
                        "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                    ]),
                    children: child
                }))
        }) : (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $97f44b6287529f93$export$2e2bcd8739ae039 = $97f44b6287529f93$var$Grid;
module.exports["default"] = $97f44b6287529f93$export$2e2bcd8739ae039;

});

parcelRegister("6MWy1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $1ztii = parcelRequire("1ztii");


var $2gBGR = parcelRequire("2gBGR");

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Focus manager__
 *
 * A focus manager {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $5d9c84f5f87b7a1d$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $42omo.useEffect)(()=>{
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $1ztii.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: (0, $1ztii.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2gBGR.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $5d9c84f5f87b7a1d$export$2e2bcd8739ae039 = $5d9c84f5f87b7a1d$var$FocusManager;
module.exports["default"] = $5d9c84f5f87b7a1d$export$2e2bcd8739ae039;

});

parcelRegister("1ztii", function(module, exports) {
$parcel$export(module.exports, "default", () => $15cbf707a7ad85d1$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");

const $15cbf707a7ad85d1$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $15cbf707a7ad85d1$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $15cbf707a7ad85d1$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("2cWqt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $2gBGR = parcelRequire("2gBGR");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $fd056483eb698f52$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $2gBGR.FocusManagerContext));
    (0, $42omo.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $fd056483eb698f52$export$2e2bcd8739ae039 = $fd056483eb698f52$var$PopupAvatarGroup;
module.exports["default"] = $fd056483eb698f52$export$2e2bcd8739ae039;

});

parcelRegister("2LGbr", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $965bb25f1302cdca$var$boxShadowCssVar = '--avatar-box-shadow';
const $965bb25f1302cdca$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _jlxit94y",
    circle: "_2rko1qll",
    activeScale: "_1q8w1np6",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    activeStateScale: "_t9ec1np6",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon",
    hexagon: "_mkrz1k6g"
};
const $965bb25f1302cdca$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $965bb25f1302cdca$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $965bb25f1302cdca$var$fontMap = {
    small: "_11c8wadc",
    medium: "_11c8wadc",
    large: "_11c8wadc",
    xlarge: "_11c81d4k",
    xxlarge: "_11c81d4k"
};
const $965bb25f1302cdca$var$MAX_DISPLAY_COUNT = 99;
const $965bb25f1302cdca$var$MoreIndicator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $965bb25f1302cdca$var$MAX_DISPLAY_COUNT ? $965bb25f1302cdca$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$965bb25f1302cdca$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $gMc0m.default)([
            $965bb25f1302cdca$var$styles.root,
            !(0, $dh538.fg)('remove_scaling_from_avatar_stack') && $965bb25f1302cdca$var$styles.activeScale,
            $965bb25f1302cdca$var$borderRadiusMap[size],
            appearance === 'circle' && $965bb25f1302cdca$var$styles.circle,
            appearance === 'hexagon' && (0, $dh538.fg)('jira-ai-agent-stack') && $965bb25f1302cdca$var$styles.hexagon,
            $965bb25f1302cdca$var$widthHeightMap[size],
            $965bb25f1302cdca$var$fontMap[size],
            isActive && $965bb25f1302cdca$var$styles.active,
            isActive && !(0, $dh538.fg)('remove_scaling_from_avatar_stack') && $965bb25f1302cdca$var$styles.activeStateScale
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$965bb25f1302cdca$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $965bb25f1302cdca$export$2e2bcd8739ae039 = $965bb25f1302cdca$var$MoreIndicator;
module.exports["default"] = $965bb25f1302cdca$export$2e2bcd8739ae039;

});

parcelRegister("6Ac15", function(module, exports) {
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g9Srd = parcelRequire("g9Srd");


var $dh538 = parcelRequire("dh538");

const $7b5befcdc2ab883e$var$listStyles = null;
const $7b5befcdc2ab883e$var$listSmallStyles = null;
const $7b5befcdc2ab883e$var$listItemStyles = null;
const $7b5befcdc2ab883e$var$listItemSmallStyles = null;
const $7b5befcdc2ab883e$var$Stack = ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ]),
        children: (0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
            exitThenEnter: true,
            children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                    className: (0, $gMc0m.default)([
                        "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                        size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                    ]),
                    children: child
                }))
        }) : (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7b5befcdc2ab883e$export$2e2bcd8739ae039 = $7b5befcdc2ab883e$var$Stack;
module.exports["default"] = $7b5befcdc2ab883e$export$2e2bcd8739ae039;

});

parcelRegister("1DG7o", function(module, exports) {
const $e8b8a534df2444a6$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $e8b8a534df2444a6$export$b067756944994c79;

});

parcelRegister("4TIFs", function(module, exports) {
$parcel$export(module.exports, "default", () => $390ef28ea0b1f2a7$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $390ef28ea0b1f2a7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("k9Smn", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");

//      
var $eaced0a9c3d84a94$var$charCodeOfDot = ".".charCodeAt(0);
var $eaced0a9c3d84a94$var$reEscapeChar = /\\(\\)?/g;
var $eaced0a9c3d84a94$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $eaced0a9c3d84a94$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $eaced0a9c3d84a94$var$charCodeOfDot) result.push("");
    string.replace($eaced0a9c3d84a94$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($eaced0a9c3d84a94$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $eaced0a9c3d84a94$var$keysCache = {};
var $eaced0a9c3d84a94$var$keysRegex = /[.[\]]+/;
var $eaced0a9c3d84a94$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($eaced0a9c3d84a94$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $eaced0a9c3d84a94$var$keysCache[key] = key.split($eaced0a9c3d84a94$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $eaced0a9c3d84a94$var$keysCache[key] = $eaced0a9c3d84a94$var$stringToPath(key);
    }
    return $eaced0a9c3d84a94$var$keysCache[key];
};
//      
var $eaced0a9c3d84a94$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $eaced0a9c3d84a94$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $eaced0a9c3d84a94$var$_toPropertyKey(arg) {
    var key = $eaced0a9c3d84a94$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $eaced0a9c3d84a94$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $eaced0a9c3d84a94$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $bDniu.default)(current, [
                key
            ].map($eaced0a9c3d84a94$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $7Q5yr.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $eaced0a9c3d84a94$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $eaced0a9c3d84a94$var$setInRecursor(state, 0, $eaced0a9c3d84a94$var$toPath(key), value1, destroyArrays);
};
var $eaced0a9c3d84a94$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $eaced0a9c3d84a94$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $eaced0a9c3d84a94$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(values, name);
    var error = $eaced0a9c3d84a94$export$c52e5867d5879e24(errors, name);
    if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) error = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
    var submitError = submitErrors && $eaced0a9c3d84a94$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $eaced0a9c3d84a94$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $eaced0a9c3d84a94$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $eaced0a9c3d84a94$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $eaced0a9c3d84a94$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$eaced0a9c3d84a94$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $eaced0a9c3d84a94$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$41e855cb628c1b55, $eaced0a9c3d84a94$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $eaced0a9c3d84a94$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3, $eaced0a9c3d84a94$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $eaced0a9c3d84a94$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$eaced0a9c3d84a94$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $eaced0a9c3d84a94$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $eaced0a9c3d84a94$export$83d89fbfd8236492 = "4.20.10";
var $eaced0a9c3d84a94$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $eaced0a9c3d84a94$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $eaced0a9c3d84a94$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $eaced0a9c3d84a94$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $eaced0a9c3d84a94$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $eaced0a9c3d84a94$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $eaced0a9c3d84a94$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $eaced0a9c3d84a94$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $7Q5yr.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $7Q5yr.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $7Q5yr.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $7Q5yr.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $7Q5yr.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $eaced0a9c3d84a94$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $eaced0a9c3d84a94$export$e6bdf135a54e021b,
                    shallowEqual: $eaced0a9c3d84a94$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $7Q5yr.default)({}, state.formState.values)); // clone to avoid writing
            if ($eaced0a9c3d84a94$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $eaced0a9c3d84a94$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $eaced0a9c3d84a94$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $7Q5yr.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $eaced0a9c3d84a94$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) {
                    var existing = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$eaced0a9c3d84a94$export$735bebc8ffabf28a] = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
                    merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$eaced0a9c3d84a94$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $eaced0a9c3d84a94$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $eaced0a9c3d84a94$var$notify(fieldSubscriber, fieldState, lastFieldState, $eaced0a9c3d84a94$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $eaced0a9c3d84a94$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$eaced0a9c3d84a94$var$hasAnyError(formState.errors) && !(formState.submitErrors && $eaced0a9c3d84a94$var$hasAnyError(formState.submitErrors));
        var nextFormState = $eaced0a9c3d84a94$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $eaced0a9c3d84a94$var$notify(state.subscribers, nextFormState, lastFormState, $eaced0a9c3d84a94$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $7Q5yr.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $eaced0a9c3d84a94$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $eaced0a9c3d84a94$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $eaced0a9c3d84a94$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $eaced0a9c3d84a94$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $eaced0a9c3d84a94$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $eaced0a9c3d84a94$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $eaced0a9c3d84a94$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $eaced0a9c3d84a94$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $eaced0a9c3d84a94$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $eaced0a9c3d84a94$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $eaced0a9c3d84a94$export$83d89fbfd8236492;
module.exports["createForm"] = $eaced0a9c3d84a94$export$f681a8129d2e9d28;

});

parcelRegister("jTvbt", function(module, exports) {

var $k9Smn = parcelRequire("k9Smn");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $e7bb57e5fe20696d$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $e7bb57e5fe20696d$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $e7bb57e5fe20696d$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $k9Smn.getIn)(errors, input.name);
    });
};
//      
var $e7bb57e5fe20696d$var$noop = function noop() {};
var $e7bb57e5fe20696d$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $e7bb57e5fe20696d$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $e7bb57e5fe20696d$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $e7bb57e5fe20696d$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $e7bb57e5fe20696d$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$e7bb57e5fe20696d$export$2e2bcd8739ae039 = $e7bb57e5fe20696d$var$createDecorator;
module.exports["default"] = $e7bb57e5fe20696d$export$2e2bcd8739ae039;

});

parcelRegister("abN8T", function(module, exports) {

var $92z90 = parcelRequire("92z90");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $76b10d1eacd527b2$var$set(object, path, value) {
    return object == null ? object : $92z90(object, path, value);
}
module.exports = $76b10d1eacd527b2$var$set;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("aLypr", function(module, exports) {
const $e5e607f963e2ce3b$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $e5e607f963e2ce3b$export$7452d7062a4d0634;

});

parcelRegister("cQMhV", function(module, exports) {
$parcel$export(module.exports, "PanelInfoIcon", () => (parcelRequire("9h6tL")).PanelInfoIcon);
$parcel$export(module.exports, "PanelWarningIcon", () => (parcelRequire("7aW37")).PanelWarningIcon);
$parcel$export(module.exports, "PanelErrorIcon", () => (parcelRequire("9f7tI")).PanelErrorIcon);
$parcel$export(module.exports, "PanelSuccessIcon", () => (parcelRequire("5Eiz2")).PanelSuccessIcon);
$parcel$export(module.exports, "PanelNoteIcon", () => (parcelRequire("9jJiA")).PanelNoteIcon);
$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => (parcelRequire("c0czl")).DynamicStrokeIconDecoration);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4wH3g = parcelRequire("4wH3g");


var $9h6tL = parcelRequire("9h6tL");


var $7aW37 = parcelRequire("7aW37");


var $9f7tI = parcelRequire("9f7tI");


var $5Eiz2 = parcelRequire("5Eiz2");


var $9jJiA = parcelRequire("9jJiA");




var $c0czl = parcelRequire("c0czl");


const $37f04d4596614e71$export$84f497075f5b07be = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7Wa7q",
    name: "IconTable",
    loader: ()=>(parcelRequire("8v9hm")).then((module)=>module.default),
    loading: ()=>null
});
module.exports["IconTable"] = $37f04d4596614e71$export$84f497075f5b07be;

});

parcelRegister("9h6tL", function(module, exports) {
/* PanelInfoIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $4e1d4745b1e8289e$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $4e1d4745b1e8289e$var$PanelInfoGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
        fill: "currentColor"
    }));
};
const $4e1d4745b1e8289e$export$2187dc2d495c3efc = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($4e1d4745b1e8289e$var$PanelInfoGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelInfoIcon"] = $4e1d4745b1e8289e$export$2187dc2d495c3efc;

});

parcelRegister("7aW37", function(module, exports) {
/* PanelWarningIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c82a733b017451e7$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $c82a733b017451e7$var$PanelWarningGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
        fill: "currentColor"
    }));
};
const $c82a733b017451e7$export$246c5468186717b7 = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($c82a733b017451e7$var$PanelWarningGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelWarningIcon"] = $c82a733b017451e7$export$246c5468186717b7;

});

parcelRegister("9f7tI", function(module, exports) {
/* PanelErrorIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2c603864430226d2$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $2c603864430226d2$var$PanelErrorGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
        fill: "currentColor"
    }));
};
const $2c603864430226d2$export$76fa6c311f4e2871 = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($2c603864430226d2$var$PanelErrorGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelErrorIcon"] = $2c603864430226d2$export$76fa6c311f4e2871;

});

parcelRegister("5Eiz2", function(module, exports) {
/* PanelSuccessIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $12304797f5f70131$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $12304797f5f70131$var$PanelSuccessGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
        fill: "currentColor"
    }));
};
const $12304797f5f70131$export$a5a5162e21242c3c = ({ label: label })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($12304797f5f70131$var$PanelSuccessGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelSuccessIcon"] = $12304797f5f70131$export$a5a5162e21242c3c;

});

parcelRegister("9jJiA", function(module, exports) {
/* PanelNoteIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0eeb07e0bc008878$var$iconStyles = null;
const $0eeb07e0bc008878$var$PanelNoteGlyph = ({ role: role })=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
        fill: "currentColor"
    }));
};
const $0eeb07e0bc008878$export$d4f894f0c3f0db6 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _re2rglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement($0eeb07e0bc008878$var$PanelNoteGlyph, {
        role: "presentation"
    }));
};
module.exports["PanelNoteIcon"] = $0eeb07e0bc008878$export$d4f894f0c3f0db6;

});

parcelRegister("c0czl", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $9K4OG = parcelRequire("9K4OG");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

function $3ae2a3e708a69581$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ae2a3e708a69581$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $3ae2a3e708a69581$var$textColorIconWrapper = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $3ae2a3e708a69581$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)";
};
const $3ae2a3e708a69581$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $3ae2a3e708a69581$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $3ae2a3e708a69581$var$getBackground(selectedColor, disabled)
        },
        css: $3ae2a3e708a69581$var$barStyles
    }));
};
module.exports["DynamicStrokeIconDecoration"] = $3ae2a3e708a69581$export$76b0278e018f8601;

});

parcelRegister("8v9hm", function(module, exports) {

let $63086a963e499817$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63086a963e499817$var$load("4pqtR"),
    $63086a963e499817$var$load("5XqRg"),
    $63086a963e499817$var$load("7Vmxp")
]).then(()=>parcelRequire('aJWwp'));

});

parcelRegister("7642E", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $XOZYy = parcelRequire("XOZYy");


const $52ac3a8ba658d4f5$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */ const React = (parcelRequire("42omo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $XOZYy, {
    default: $52ac3a8ba658d4f5$var$_inlined0
});
if ($XOZYy.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("9JsQ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $chO1Z = parcelRequire("chO1Z");


var $7CgcZ = parcelRequire("7CgcZ");

const $b894277b0121d160$var$FileIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold');
$b894277b0121d160$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $b894277b0121d160$export$2e2bcd8739ae039 = $b894277b0121d160$var$FileIconWithColor;
module.exports["default"] = $b894277b0121d160$export$2e2bcd8739ae039;

});

parcelRegister("1w5AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $1zLiv = parcelRequire("1zLiv");


var $7CgcZ = parcelRequire("7CgcZ");

const $236bd638115a684a$var$ChartBarIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold');
$236bd638115a684a$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $236bd638115a684a$export$2e2bcd8739ae039 = $236bd638115a684a$var$ChartBarIconWithColor;
module.exports["default"] = $236bd638115a684a$export$2e2bcd8739ae039;

});

parcelRegister("h45kr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $cUQMr = parcelRequire("cUQMr");


var $7CgcZ = parcelRequire("7CgcZ");

const $55cc43e42726cbf8$var$ListBulletedIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold');
$55cc43e42726cbf8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $55cc43e42726cbf8$export$2e2bcd8739ae039 = $55cc43e42726cbf8$var$ListBulletedIconWithColor;
module.exports["default"] = $55cc43e42726cbf8$export$2e2bcd8739ae039;

});

parcelRegister("euACo", function(module, exports) {
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $035a46a85e451274$var$iconStyles = null;
const $035a46a85e451274$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $035a46a85e451274$var$baseHcmStyles = null;
const $035a46a85e451274$var$primaryEqualsSecondaryHcmStyles = null;
const $035a46a85e451274$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $035a46a85e451274$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $l998X.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $035a46a85e451274$var$sizeStyles[size]
        ])
    });
});
var $035a46a85e451274$export$2e2bcd8739ae039 = $035a46a85e451274$export$f04a61298a47a40f;
module.exports["Icon"] = $035a46a85e451274$export$f04a61298a47a40f;

});

parcelRegister("8PFSM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $009878891f6679eb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $kXb3C = parcelRequire("kXb3C");

function $009878891f6679eb$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("iZCav", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0686486f925c9ddd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $kXb3C = parcelRequire("kXb3C");

function $0686486f925c9ddd$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("5NrIb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $692c05f58e5d3ef7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $kXb3C = parcelRequire("kXb3C");

function $692c05f58e5d3ef7$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("gV3jM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2708dfe0209c3c78$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $kXb3C = parcelRequire("kXb3C");

function $2708dfe0209c3c78$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("1WiZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c77f4c6a2336f8ae$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $kXb3C = parcelRequire("kXb3C");

function $c77f4c6a2336f8ae$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4ce94c9023f0019e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

function $4ce94c9023f0019e$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("cKqka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4b99d5ed076c1160$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $kXb3C = parcelRequire("kXb3C");

function $4b99d5ed076c1160$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("7Jxvl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ef63a9b3b9aed96b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $kXb3C = parcelRequire("kXb3C");

function $ef63a9b3b9aed96b$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("4KIbP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $627ab7f82241d2c9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $kXb3C = parcelRequire("kXb3C");

function $627ab7f82241d2c9$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && window.__SSR_RENDERED__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $gMc0m.default)([
                        $71feb0a29953fded$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("h982G", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $i25hX = parcelRequire("i25hX");

const $a5e138d08f3fc65b$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $a5e138d08f3fc65b$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $a5e138d08f3fc65b$var$allowedSubdomains = [
    '.jira-dev.com',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $a5e138d08f3fc65b$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $a5e138d08f3fc65b$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($a5e138d08f3fc65b$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $a5e138d08f3fc65b$var$allowedOrigins.includes(hostname));
};
const $a5e138d08f3fc65b$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $a5e138d08f3fc65b$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $a5e138d08f3fc65b$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, (0, $dh538.fg)('ai-mate-pub-sub-post-message-origin-fix') ? {
                        targetOrigin: '*'
                    } : undefined);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $a5e138d08f3fc65b$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $42omo.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $a5e138d08f3fc65b$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $42omo.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $a5e138d08f3fc65b$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};
module.exports["RovoPostMessagePubsubListener"] = $a5e138d08f3fc65b$export$e5e1a9c59c299631;
module.exports["useRovoPostMessageToPubsub"] = $a5e138d08f3fc65b$export$5340cc94dd0ecbea;

});

parcelRegister("gKlAz", function(module, exports) {

var $eG1Z0 = parcelRequire("eG1Z0");


var $aoDcQ = parcelRequire("aoDcQ");

function $ac303ab343815a94$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $aoDcQ.text)(maybeNode) : maybeNode;
    if ((0, $eG1Z0.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $eG1Z0.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}
module.exports["applyMark"] = $ac303ab343815a94$export$50d34f59d07755a2;

});

parcelRegister("eG1Z0", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9abe739d14fcbdba$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}
function $9abe739d14fcbdba$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}
module.exports["isDuplicateMark"] = $9abe739d14fcbdba$export$5ec47a80d7cc0dfa;
module.exports["duplicateMarkError"] = $9abe739d14fcbdba$export$db1000b9ac08ce57;

});

parcelRegister("iJQnc", function(module, exports) {

var $gKlAz = parcelRequire("gKlAz");

const $0c4bf63002e7b177$export$6565f9f03506010b = (maybeNode)=>(0, $gKlAz.applyMark)({
        type: 'code'
    }, maybeNode);
module.exports["code"] = $0c4bf63002e7b177$export$6565f9f03506010b;

});

parcelRegister("e6pbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4452a63831cbd09$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $a4452a63831cbd09$var$t() {
    return $a4452a63831cbd09$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $a4452a63831cbd09$var$t.apply(this, arguments);
}
const $a4452a63831cbd09$var$n = [
    "children",
    "options"
], $a4452a63831cbd09$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $a4452a63831cbd09$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($a4452a63831cbd09$var$i || ($a4452a63831cbd09$var$i = {}));
const $a4452a63831cbd09$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    for: "htmlFor"
}), $a4452a63831cbd09$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $a4452a63831cbd09$var$o = [
    "style",
    "script"
], $a4452a63831cbd09$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $a4452a63831cbd09$var$s = /mailto:/i, $a4452a63831cbd09$var$d = /\n{2,}$/, $a4452a63831cbd09$var$u = /^(\s*>[\s\S]*?)(?=\n{2,})/, $a4452a63831cbd09$var$p = /^ *> ?/gm, $a4452a63831cbd09$var$f = /^ {2,}\n/, $a4452a63831cbd09$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $a4452a63831cbd09$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $a4452a63831cbd09$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $a4452a63831cbd09$var$k = /^(?:\n *)*\n/, $a4452a63831cbd09$var$x = /\r\n?/g, $a4452a63831cbd09$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $a4452a63831cbd09$var$v = /^\[\^([^\]]+)]/, $a4452a63831cbd09$var$S = /\f/g, $a4452a63831cbd09$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $a4452a63831cbd09$var$$ = /^\s*?\[(x|\s)\]/, $a4452a63831cbd09$var$w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $a4452a63831cbd09$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $a4452a63831cbd09$var$T = /^<!--[\s\S]*?(?:-->)/, $a4452a63831cbd09$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $a4452a63831cbd09$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $a4452a63831cbd09$var$M = /^\{.*\}$/, $a4452a63831cbd09$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $a4452a63831cbd09$var$I = /^<([^ >]+@[^ >]+)>/, $a4452a63831cbd09$var$U = /^<([^ >]+:\/[^ >]+)>/, $a4452a63831cbd09$var$D = /-([a-z])?/gi, $a4452a63831cbd09$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $a4452a63831cbd09$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $a4452a63831cbd09$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$P = /(\[|\])/g, $a4452a63831cbd09$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $a4452a63831cbd09$var$W = /\t/g, $a4452a63831cbd09$var$G = /(^ *\||\| *$)/g, $a4452a63831cbd09$var$Z = /^ *:-+: *$/, $a4452a63831cbd09$var$q = /^ *:-+ *$/, $a4452a63831cbd09$var$Q = /^ *-+: *$/, $a4452a63831cbd09$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $a4452a63831cbd09$var$X = new RegExp(`^([*_])\\1${$a4452a63831cbd09$var$V}\\1\\1(?!\\1)`), $a4452a63831cbd09$var$J = new RegExp(`^([*_])${$a4452a63831cbd09$var$V}\\1(?!\\1|\\w)`), $a4452a63831cbd09$var$K = new RegExp(`^==${$a4452a63831cbd09$var$V}==`), $a4452a63831cbd09$var$Y = new RegExp(`^~~${$a4452a63831cbd09$var$V}~~`), $a4452a63831cbd09$var$ee = /^\\([^0-9A-Za-z\s])/, $a4452a63831cbd09$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $a4452a63831cbd09$var$ne = /^\n+/, $a4452a63831cbd09$var$re = /^([ \t]*)/, $a4452a63831cbd09$var$ie = /\\([^\\])/g, $a4452a63831cbd09$var$le = / *\n+$/, $a4452a63831cbd09$var$ae = /(?:^|\n)( *)$/, $a4452a63831cbd09$var$oe = "(?:\\d+\\.)", $a4452a63831cbd09$var$ce = "(?:[*+-])";
function $a4452a63831cbd09$var$se(e) {
    return "( *)(" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + ") +";
}
const $a4452a63831cbd09$var$de = $a4452a63831cbd09$var$se(1), $a4452a63831cbd09$var$ue = $a4452a63831cbd09$var$se(2);
function $a4452a63831cbd09$var$pe(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue));
}
const $a4452a63831cbd09$var$fe = $a4452a63831cbd09$var$pe(1), $a4452a63831cbd09$var$he = $a4452a63831cbd09$var$pe(2);
function $a4452a63831cbd09$var$me(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $a4452a63831cbd09$var$ge = $a4452a63831cbd09$var$me(1), $a4452a63831cbd09$var$ye = $a4452a63831cbd09$var$me(2);
function $a4452a63831cbd09$var$ke(e) {
    const t = 1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $a4452a63831cbd09$var$xe = $a4452a63831cbd09$var$ke(1), $a4452a63831cbd09$var$be = $a4452a63831cbd09$var$ke(2);
function $a4452a63831cbd09$var$ve(e, t) {
    const n = 1 === t, i = n ? $a4452a63831cbd09$var$xe : $a4452a63831cbd09$var$be, l = n ? $a4452a63831cbd09$var$ge : $a4452a63831cbd09$var$ye, a = n ? $a4452a63831cbd09$var$fe : $a4452a63831cbd09$var$he;
    return {
        match (e, t, n) {
            const r = $a4452a63831cbd09$var$ae.exec(n);
            return r && (t.list || !t.inline && !t.simple) ? i.exec(e = r[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($a4452a63831cbd09$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, u = -1 !== s.indexOf("\n\n") || d && c;
                    c = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($a4452a63831cbd09$var$le, "\n\n")) : (r.inline = !0, h = s.replace($a4452a63831cbd09$var$le, ""));
                    const m = t(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $a4452a63831cbd09$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $a4452a63831cbd09$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $a4452a63831cbd09$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $a4452a63831cbd09$var$$e = [
    $a4452a63831cbd09$var$u,
    $a4452a63831cbd09$var$m,
    $a4452a63831cbd09$var$g,
    $a4452a63831cbd09$var$w,
    $a4452a63831cbd09$var$z,
    $a4452a63831cbd09$var$C,
    $a4452a63831cbd09$var$T,
    $a4452a63831cbd09$var$j,
    $a4452a63831cbd09$var$ge,
    $a4452a63831cbd09$var$xe,
    $a4452a63831cbd09$var$ye,
    $a4452a63831cbd09$var$be
], $a4452a63831cbd09$var$we = [
    ...$a4452a63831cbd09$var$$e,
    /^[^\n]+(?:  \n|\n{2,})/,
    $a4452a63831cbd09$var$L,
    $a4452a63831cbd09$var$B
];
function $a4452a63831cbd09$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $a4452a63831cbd09$var$ze(e) {
    return $a4452a63831cbd09$var$Q.test(e) ? "right" : $a4452a63831cbd09$var$Z.test(e) ? "center" : $a4452a63831cbd09$var$q.test(e) ? "left" : null;
}
function $a4452a63831cbd09$var$Le(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $a4452a63831cbd09$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $a4452a63831cbd09$var$Ae(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($a4452a63831cbd09$var$G, "").split("|").map($a4452a63831cbd09$var$ze) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $a4452a63831cbd09$var$Le(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $a4452a63831cbd09$var$Le(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.paragraph
    };
}
function $a4452a63831cbd09$var$Te(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $a4452a63831cbd09$var$Oe(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Me(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $a4452a63831cbd09$var$Re(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $a4452a63831cbd09$var$Ie(e, t, n) {
    if (t.inline || t.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$a4452a63831cbd09$var$$e.some((t)=>t.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $a4452a63831cbd09$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $a4452a63831cbd09$var$De(e) {
    return e.replace($a4452a63831cbd09$var$ie, "$1");
}
function $a4452a63831cbd09$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$Ne(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$He(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $a4452a63831cbd09$var$Fe = (e, t, n)=>({
        children: $a4452a63831cbd09$var$je(t, e[1], n)
    });
function $a4452a63831cbd09$var$Pe() {
    return {};
}
function $a4452a63831cbd09$var$_e() {
    return null;
}
function $a4452a63831cbd09$var$We(...e) {
    return e.filter(Boolean).join(" ");
}
function $a4452a63831cbd09$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $a4452a63831cbd09$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $a4452a63831cbd09$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $a4452a63831cbd09$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $a4452a63831cbd09$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $a4452a63831cbd09$var$t({}, n, l, {
            className: $a4452a63831cbd09$var$We(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($a4452a63831cbd09$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $a4452a63831cbd09$var$_.test(t));
        const r = le(ie(n ? t : `${t.trimEnd().replace($a4452a63831cbd09$var$ne, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $42omo.createElement(l, {
            key: "outer"
        }, a);
    }
    function Z(t, n) {
        const r = n.match($a4452a63831cbd09$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($a4452a63831cbd09$var$O) && (e = e.replace($a4452a63831cbd09$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $a4452a63831cbd09$var$l[c] || c, u = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($a4452a63831cbd09$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof u && ($a4452a63831cbd09$var$L.test(u) || $a4452a63831cbd09$var$B.test(u)) && (n[d] = $42omo.cloneElement(G(u.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$a4452a63831cbd09$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $a4452a63831cbd09$export$3e2338ea76b578c9, i.slugify = i.slugify || $a4452a63831cbd09$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $a4452a63831cbd09$var$t({}, $a4452a63831cbd09$var$a, i.namedCodesToUnicode) : $a4452a63831cbd09$var$a, i.createElement = i.createElement || $42omo.createElement;
    const q = [], Q = {}, V = {
        [$a4452a63831cbd09$export$e0aa44767d8750d5.blockQuote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$u),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($a4452a63831cbd09$var$p, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakLine]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$f),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakThematic]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$h),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $a4452a63831cbd09$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeFenced]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: Z("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeInline]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$b),
            order: 0,
            parse: (e)=>(q.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnoteReference]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $a4452a63831cbd09$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.gfmTask]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$$),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.heading]: {
            match: $a4452a63831cbd09$var$Me(i.enforceAtxHeadings ? $a4452a63831cbd09$var$C : $a4452a63831cbd09$var$w),
            order: 1,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[2], n),
                    id: i.slugify(e[2], $a4452a63831cbd09$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.headingSetext]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.heading
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($a4452a63831cbd09$var$re), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $a4452a63831cbd09$var$we.some((e)=>e.test(c)) ? $a4452a63831cbd09$var$He : $a4452a63831cbd09$var$je);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $a4452a63831cbd09$var$o.indexOf(s), u = (d ? s : e[1]).trim(), p = {
                    attrs: Z(u, e[2]),
                    noInnerParse: d,
                    tag: u
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? p.text = e[3] : p.children = a(t, l, n), n.inAnchor = !1, p;
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({
                    key: r.key
                }, e.attrs), e.text || n(e.children, r))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: Z(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlComment]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$T),
            order: 1,
            parse: ()=>({}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.image]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Ee),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.link]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$Se),
            order: 3,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$Ne(t, e[1], n),
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor ? null : $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $a4452a63831cbd09$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                };
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.orderedList]: $a4452a63831cbd09$var$ve(d, 1),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.unorderedList]: $a4452a63831cbd09$var$ve(d, 2),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$k),
            order: 3,
            parse: $a4452a63831cbd09$var$Pe,
            render: ()=>"\n"
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.paragraph]: {
            match: $a4452a63831cbd09$var$Ie,
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.ref]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$N),
            order: 0,
            parse: (e)=>(Q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refImage]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(Q[e.ref].target, "img", "src"),
                    title: Q[e.ref].title
                }) : null
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refLink]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: t(e[0].replace($a4452a63831cbd09$var$P, "\\$1"), n),
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(Q[e.ref].target, "a", "href"),
                    title: Q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, t(e.fallbackChildren, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.table]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$j),
            order: 1,
            parse: $a4452a63831cbd09$var$Ae,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $a4452a63831cbd09$var$Te(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $a4452a63831cbd09$var$Te(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.text]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($a4452a63831cbd09$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textBolded]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$X),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEmphasized]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$J),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEscaped]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$ee),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textMarked]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$K),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Y),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock], delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]);
    const ie = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [], a = "";
            for(; r;){
                let o = 0;
                for(; o < t.length;){
                    const c = t[o], s = e[c], d = s.match(r, i, a);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const t = s.parse(d, n, i);
                        null == t.type && (t.type = c), l.push(t), a = e;
                        break;
                    }
                    o++;
                }
            }
            return l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($a4452a63831cbd09$var$x, "\n").replace($a4452a63831cbd09$var$S, "").replace($a4452a63831cbd09$var$W, "    ");
            }(e), t);
        };
    }(V), le = (ae = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(V, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return ae(t, e, n);
    });
    var ae;
    const oe = G(n);
    return q.length ? d("div", null, oe, d("footer", {
        key: "footer"
    }, q.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $a4452a63831cbd09$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(ie(e.footnote, {
            inline: !0
        })));
    }))) : oe;
}
var $a4452a63831cbd09$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $a4452a63831cbd09$var$n);
    return $42omo.cloneElement($a4452a63831cbd09$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $aXWIB = parcelRequire("aXWIB");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $d21a741e0de1277a$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $d21a741e0de1277a$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$d21a741e0de1277a$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $d21a741e0de1277a$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("9ISlX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kVnOi = parcelRequire("kVnOi");

class $d6477c19fa37ad04$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + (0, $kVnOi.embedHeaderHeight);
            onHeightUpdate(height);
        };
    }
}
module.exports["EmbedResizeMessageListener"] = $d6477c19fa37ad04$export$3482036c37e627f4;

});

parcelRegister("6CRn4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5311f5d282e4b997$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $gxsT9 = parcelRequire("gxsT9");


var $gAARK = parcelRequire("gAARK");


var $kfJSC = parcelRequire("kfJSC");


var $lqWNh = parcelRequire("lqWNh");


var $1OLls = parcelRequire("1OLls");

function $5311f5d282e4b997$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $lqWNh.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $kfJSC.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $aFUXX.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) - (0, $aFUXX.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $1OLls.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $dh538.fg)('media-perf-uplift-mutation-fix')
        }),
        ...!(0, $dh538.fg)('platform_editor_fix_media_in_renderer') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $gxsT9.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1OLls.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("2daQU", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("kfJSC", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $lqWNh = parcelRequire("lqWNh");


var $gAARK = parcelRequire("gAARK");

function $7eac1e1fe0a5dbb7$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $7eac1e1fe0a5dbb7$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $7eac1e1fe0a5dbb7$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $gAARK.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $7eac1e1fe0a5dbb7$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $7eac1e1fe0a5dbb7$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $aFUXX.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $aFUXX.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $aFUXX.akEditorFullWidthLayoutWidth));
};
const $7eac1e1fe0a5dbb7$export$4ab195f543459515 = (origWidth = (0, $gAARK.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $aFUXX.akEditorDefaultLayoutWidth), minWidth = (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $7eac1e1fe0a5dbb7$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $7eac1e1fe0a5dbb7$export$f72673597dacfcfa = (value, interval = (0, $gAARK.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $7eac1e1fe0a5dbb7$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $gAARK.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $gAARK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $7eac1e1fe0a5dbb7$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $lqWNh.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $lqWNh.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $7eac1e1fe0a5dbb7$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $7eac1e1fe0a5dbb7$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $7eac1e1fe0a5dbb7$export$7cc71489edfd26f8($pos, view) : $7eac1e1fe0a5dbb7$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $7eac1e1fe0a5dbb7$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $lqWNh.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $7eac1e1fe0a5dbb7$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $7eac1e1fe0a5dbb7$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $7eac1e1fe0a5dbb7$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $7eac1e1fe0a5dbb7$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $ks2lK.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};
module.exports["getMediaSinglePixelWidth"] = $7eac1e1fe0a5dbb7$export$a6f4ec2edd25b07e;
module.exports["calcMediaSinglePixelWidth"] = $7eac1e1fe0a5dbb7$export$5091b2c0d1cd2361;
module.exports["calcMediaSingleMaxWidth"] = $7eac1e1fe0a5dbb7$export$a2e7f6320d796a21;
module.exports["getMediaSingleInitialWidth"] = $7eac1e1fe0a5dbb7$export$4ab195f543459515;
module.exports["calculateOffsetLeft"] = $7eac1e1fe0a5dbb7$export$ab1f1890e4428242;
module.exports["roundToNearest"] = $7eac1e1fe0a5dbb7$export$f72673597dacfcfa;
module.exports["calcMinWidth"] = $7eac1e1fe0a5dbb7$export$c7eaa4d46a45395;
module.exports["getMaxWidthForNestedNode"] = $7eac1e1fe0a5dbb7$export$4147ff5cc31ec064;
module.exports["getMaxWidthForNestedNodeNext"] = $7eac1e1fe0a5dbb7$export$bcefe8f1d5d7bbf3;
module.exports["currentMediaNodeWithPos"] = $7eac1e1fe0a5dbb7$export$22e4c8c04f58169d;

});

parcelRegister("1OLls", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $lqWNh = parcelRequire("lqWNh");


var $fJNzZ = parcelRequire("fJNzZ");

function $0ef555bed3f3ee7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $0ef555bed3f3ee7f$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $aFUXX.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $aFUXX.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $aFUXX.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $aFUXX.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $0ef555bed3f3ee7f$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $fJNzZ.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $0ef555bed3f3ee7f$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $0ef555bed3f3ee7f$var$getWidthIfFullWidthMode(width, containerWidth) : $0ef555bed3f3ee7f$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $0ef555bed3f3ee7f$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $0ef555bed3f3ee7f$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $fJNzZ.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $fJNzZ.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $0ef555bed3f3ee7f$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $0ef555bed3f3ee7f$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $0ef555bed3f3ee7f$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $0ef555bed3f3ee7f$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ var $0ef555bed3f3ee7f$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $0ef555bed3f3ee7f$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $0ef555bed3f3ee7f$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = $0ef555bed3f3ee7f$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $0ef555bed3f3ee7f$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $0ef555bed3f3ee7f$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $0ef555bed3f3ee7f$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $0ef555bed3f3ee7f$var$calcMaxWidth(layout, containerWidth));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $0ef555bed3f3ee7f$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $0ef555bed3f3ee7f$var$_ref2, " ", isInRenderer ? $0ef555bed3f3ee7f$var$_ref : (0, $1oCLl.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) ? `max-width: ${cssMaxWidth};` : `max-width: ${calculatedMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $lqWNh.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $0ef555bed3f3ee7f$var$float(layout), ";margin:", $0ef555bed3f3ee7f$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $lqWNh.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $0ef555bed3f3ee7f$var$isImageAligned(layout), ";");
};
const $0ef555bed3f3ee7f$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $9K4OG.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $0ef555bed3f3ee7f$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $9K4OG.css)("position:relative;", $0ef555bed3f3ee7f$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;", (0, $dh538.fg)('platform_forge_ui_support_images_in_adfrenderer') ? 'height: auto !important;' : '', ">div{position:absolute;height:100%;}}");
const $0ef555bed3f3ee7f$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $0ef555bed3f3ee7f$export$9e3fd9f6215dd7b6(rest)
    }, children);
$0ef555bed3f3ee7f$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $0ef555bed3f3ee7f$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    // [FEATURE FLAG: platform_editor_media_border_radius_fix]
    // Fixes border radius to properly match image with 8px radius
    // To clean up: remove conditional, keep only flag-on behavior ('8px')
    const borderRadius = (0, $dh538.fg)('platform_editor_media_border_radius_fix') ? "var(--ds-radius-large, 8px)" : '1px'; // OLD BEHAVIOR (to be removed when flag is cleaned up)
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $0ef555bed3f3ee7f$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $0ef555bed3f3ee7f$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $0ef555bed3f3ee7f$export$e18e95249d813157;

});

parcelRegister("fBAKC", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("69fUv")));
const $7850275dc402dd65$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7850275dc402dd65$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $7850275dc402dd65$export$f386473e8f104bcb;

});

parcelRegister("69fUv", function(module, exports) {

let $479fecd0aea59d37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $479fecd0aea59d37$var$load("koKgZ").then(()=>parcelRequire('7Fmwh'));

});

parcelRegister("f9yl5", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $79vw2 = parcelRequire("79vw2");


var $eIleF = parcelRequire("eIleF");


var $l3dur = parcelRequire("l3dur");


var $dh538 = parcelRequire("dh538");


var $4T4vf = parcelRequire("4T4vf");

parcelRequire("882hS");
var $85Mv7 = parcelRequire("85Mv7");

parcelRequire("afUmf");
var $3ts5j = parcelRequire("3ts5j");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $226XV = parcelRequire("226XV");

var $ba441b9d4456e512$export$89741becde3d0e54 = /*#__PURE__*/ function(SMART_LINK_DRAG_TYPES) {
    SMART_LINK_DRAG_TYPES["EDITOR"] = "smart-link-from-editor";
    SMART_LINK_DRAG_TYPES["RENDERER"] = "smart-link-from-renderer";
    return SMART_LINK_DRAG_TYPES;
}({});
var $ba441b9d4456e512$export$a4a3cf1d43312764 = /*#__PURE__*/ function(SMART_LINK_APPEARANCE) {
    SMART_LINK_APPEARANCE["INLINE"] = "inline";
    SMART_LINK_APPEARANCE["BLOCK"] = "block";
    SMART_LINK_APPEARANCE["EMBED"] = "embed";
    return SMART_LINK_APPEARANCE;
}({});
function $ba441b9d4456e512$export$ac5f6dc1cb5b8db6(type) {
    return type === "smart-link-from-editor" || type === "smart-link-from-renderer";
} /**
   * Checks if a ProseMirror node type is a smart link card.
   */ 
function $ba441b9d4456e512$export$250eee508686c799(nodeType) {
    return nodeType === 'inlineCard' || nodeType === 'blockCard' || nodeType === 'embedCard';
}
const $ba441b9d4456e512$var$idleState = {
    type: 'idle'
};
const $ba441b9d4456e512$var$draggingState = {
    type: 'dragging'
};
const $ba441b9d4456e512$var$styles = {
    preview: "_1reo15vq _18m915vq _2rko12b0 _1rjc1b66 _18zru2gc _1dqonqa1 _1h6d1l7x _bfhkvuon _p12fgx0z _16qs130s",
    previewText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    draggableBlock: "_80om1qgj"
};
const $ba441b9d4456e512$var$previewIconStyles = null;
const $ba441b9d4456e512$var$draggableInlineStyles = null;
function $ba441b9d4456e512$var$SmartLinkDragPreview({ title: title, url: url, iconUrl: iconUrl }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $ba441b9d4456e512$var$styles.preview,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.075",
            children: [
                iconUrl && /*#__PURE__*/ (0, $l998X.jsx)("img", {
                    src: iconUrl,
                    alt: "",
                    className: (0, $gMc0m.default)([
                        "_1bsbpxbi _4t3ipxbi _1o9zidpf"
                    ])
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    xcss: $ba441b9d4456e512$var$styles.previewText,
                    children: title || url
                })
            ]
        })
    });
}
function $ba441b9d4456e512$var$getIconUrl(details) {
    if (details?.data && 'icon' in details.data && typeof details?.data?.icon === 'string') return details.data.icon;
    const objectIconUrl = (0, $226XV.getObjectIconUrl)(details);
    if (objectIconUrl) return objectIconUrl;
     // Confluence/Jira content-type specific icons (page, blog, whiteboard, issue, etc.)
    if (details?.entityData && 'iconUrl' in details.entityData && typeof details.entityData.iconUrl === 'string') return details.entityData.iconUrl;
     // Fallback to provider/generator icon (product logo)
    if (typeof details?.meta?.generator?.icon?.url === 'string') return details.meta.generator.icon.url;
    return undefined;
} /**
   * Inner component that handles the actual drag behavior.
   * Must be rendered within a SmartCardProvider context.
   */ 
function $ba441b9d4456e512$var$SmartLinkDraggableInner({ url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget = false, children: children }) {
    const ref = (0, $42omo.useRef)(null);
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const [state, setState] = (0, $42omo.useState)($ba441b9d4456e512$var$idleState); // Store the draggable config so we can re-register on different elements
    // when the browser picks a child as the drag target.
    const getDragConfig = (0, $42omo.useCallback)((targetEl)=>({
            element: targetEl,
            getInitialData: ()=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $79vw2.extractSmartLinkTitle)(details);
                const iconUrl = $ba441b9d4456e512$var$getIconUrl(details);
                return {
                    type: source,
                    url: url,
                    title: title,
                    iconUrl: iconUrl,
                    appearance: appearance
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $79vw2.extractSmartLinkTitle)(details);
                const iconUrl = $ba441b9d4456e512$var$getIconUrl(details);
                (0, $3ts5j.setCustomNativeDragPreview)({
                    getOffset: (0, $85Mv7.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setState({
                            type: 'preview',
                            container: container,
                            title: title,
                            iconUrl: iconUrl
                        });
                        return ()=>setState($ba441b9d4456e512$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>setState($ba441b9d4456e512$var$draggingState),
            onDrop: ()=>setState($ba441b9d4456e512$var$idleState)
        }), [
        url,
        propTitle,
        appearance,
        source,
        store
    ]);
    // On pointerdown, determine the drag element and register it with Pragmatic DnD.
    // Uses pointerdown because the drag source may not exist at mount time as smart cards resolve.
    // For inline cards inside ProseMirror, prefer the inner anchor because the browser fires
    // dragstart from that element rather than from the inline card wrapper.
    (0, $42omo.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const inlineCardRootSelector = '[data-prosemirror-node-name="inlineCard"][draggable="true"]'; // In contentEditable editors (ProseMirror), the browser may pick a child
        // element (e.g., an <a> tag) as the drag target instead of our element.
        // On pointerdown, we find the likely drag target and register draggable()
        // on it so pragmatic-drag-and-drop recognizes the drag.
        let cleanupDraggable = null; // In contentEditable="true" contexts (block/embed cards), the browser treats
        // the smart-element-link as editable text rather than a draggable element.
        // Not needed for inline cards since the wrapper is already not editable
        let observer = null;
        if (appearance !== "inline") {
            const setupSmartElementLink = ()=>{
                el.querySelectorAll('[data-smart-element-link]').forEach((link)=>{
                    link.contentEditable = 'false';
                    link.setAttribute('draggable', 'true');
                });
            };
            setupSmartElementLink();
            observer = new MutationObserver(setupSmartElementLink);
            observer.observe(el, {
                childList: true,
                subtree: true
            });
        }
        const unbindPointerDown = (0, $fFa3V.bind)(el, {
            type: 'pointerdown',
            listener: (event)=>{
                const selectionAtPointerDown = window.getSelection();
                if (appearance === "inline" && selectionAtPointerDown?.type === 'Range' && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                cleanupDraggable?.();
                const target = event.target; // Find the nearest draggable ancestor within the card to match
                // the element the browser will use as the dragstart target.
                let dragTarget = el;
                if (appearance === "inline") {
                    const targetElement = target instanceof Element ? target : null;
                    const hostInlineCardRoot = el.closest(inlineCardRootSelector);
                    const inlineCardRoot = targetElement?.closest(inlineCardRootSelector) ?? null;
                    const closestInlineAnchor = targetElement?.closest('a[href], [data-smart-element-link]') ?? null;
                    if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                    else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                cleanupDraggable = (0, $4T4vf.draggable)(getDragConfig(dragTarget));
            }
        });
        return ()=>{
            cleanupDraggable?.();
            unbindPointerDown();
            observer?.disconnect();
        };
    }, [
        url,
        propTitle,
        appearance,
        source,
        store,
        getDragConfig
    ]);
    const preview = state.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, $l998X.jsx)($ba441b9d4456e512$var$SmartLinkDragPreview, {
        title: state.title,
        url: url,
        iconUrl: state.iconUrl
    }), state.container) : null; // Use span with inline display for inline cards to preserve text flow.
    if (appearance === "inline") return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": isChangeboardTarget ? 'smart-link-draggable-changeboard' : undefined,
                className: (0, $gMc0m.default)([
                    "_80om1qgj _1e0c1nu9"
                ]),
                children: children
            }),
            preview
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: ref,
                xcss: $ba441b9d4456e512$var$styles.draggableBlock,
                testId: "smart-link-draggable-block",
                children: children
            }),
            preview
        ]
    });
}
function $ba441b9d4456e512$export$c67c8f76ce4436c({ url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children }) {
    if (!url || !(0, $l3dur.isSafeUrl)(url) || !(0, $dh538.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($ba441b9d4456e512$var$SmartLinkDraggableInner, {
        url: url,
        title: title,
        appearance: appearance,
        source: source,
        isChangeboardTarget: isChangeboardTarget,
        children: children
    });
}
module.exports["SMART_LINK_DRAG_TYPES"] = $ba441b9d4456e512$export$89741becde3d0e54;
module.exports["SMART_LINK_APPEARANCE"] = $ba441b9d4456e512$export$a4a3cf1d43312764;
module.exports["isSmartLinkDrag"] = $ba441b9d4456e512$export$ac5f6dc1cb5b8db6;
module.exports["SmartLinkDraggable"] = $ba441b9d4456e512$export$c67c8f76ce4436c;

});

parcelRegister("882hS", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");


});

parcelRegister("85Mv7", function(module, exports) {

var $ic3Jg = parcelRequire("ic3Jg");


var $iFRCn = parcelRequire("iFRCn");


var $76xc7 = parcelRequire("76xc7");

function $30069a8958953d8b$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $iFRCn.isSafariOnIOS)() || (0, $ic3Jg.isAndroid)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $30069a8958953d8b$export$427e20518819fabc;

});

parcelRegister("iFRCn", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");


var $e880Z = parcelRequire("e880Z");

const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $3720fb1a551ae595$export$52fc40c68fea4952;

});

parcelRegister("76xc7", function(module, exports) {
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $54acc06d1c628398$export$81d8e72a15eef435;

});

parcelRegister("afUmf", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("3ts5j")).setCustomNativeDragPreview);

var $3ts5j = parcelRequire("3ts5j");


});

parcelRegister("3ts5j", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $e880Z = parcelRequire("e880Z");


var $f7qXf = parcelRequire("f7qXf");


var $hSdmP = parcelRequire("hSdmP");


var $j4IDJ = parcelRequire("j4IDJ");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $90430ceac724b72d$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $90430ceac724b72d$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $90430ceac724b72d$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $j4IDJ.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $j4IDJ.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $hSdmP.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f7qXf.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $j4IDJ.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $e880Z.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $90430ceac724b72d$export$52d889c66db0f96e;

});

parcelRegister("h8cpw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $eIleF = parcelRequire("eIleF");


var $1oCLl = parcelRequire("1oCLl");


var $kKODE = parcelRequire("kKODE");


var $eB2Ls = parcelRequire("eB2Ls");


var $4gOU2 = parcelRequire("4gOU2");


var $dOvUN = parcelRequire("dOvUN");


var $afp1H = parcelRequire("afp1H");


var $bz6dj = parcelRequire("bz6dj");


var $9oOnT = parcelRequire("9oOnT");


var $7DSoa = parcelRequire("7DSoa");


var $lz9QA = parcelRequire("lz9QA");

function $4a6a130a5859a503$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))(), []);
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const invokeClientAction = (0, $9oOnT.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $7DSoa.default)();
    if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve(url);
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $eB2Ls.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $bz6dj.toAction)(downloadActionProps, invokeClientAction, (0, $afp1H.messages).download, 'download-content'));
        const viewActionProps = (0, $dOvUN.extractInvokeViewAction)(invokeParam);
        if (viewActionProps) actions.push((0, $bz6dj.toAction)(viewActionProps, invokeClientAction, (0, $afp1H.messages).view, 'view-content'));
        const previewActionProps = (0, $4gOU2.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        });
        if (previewActionProps) actions.push((0, $bz6dj.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $afp1H.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $4a6a130a5859a503$export$a95296ded9241771;

});

parcelRegister("bz6dj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $2752aec5c6b5a722$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $2752aec5c6b5a722$export$9d52be0dab870c7;

});

parcelRegister("7FiWH", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $lOzEN = parcelRequire("lOzEN");


var $8tdj3 = parcelRequire("8tdj3");


var $jypE9 = parcelRequire("jypE9");


var $dh538 = parcelRequire("dh538");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $iGbqR = parcelRequire("iGbqR");

var $d925B = parcelRequire("d925B");


var $3RxtY = parcelRequire("3RxtY");

function $f7a722354e8e82d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $aFUXX.akEditorFullPageDefaultFontSize)}px) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $f7a722354e8e82d7$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f7a722354e8e82d7$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $f7a722354e8e82d7$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $f7a722354e8e82d7$var$linkStylesCommon = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    top: '0px',
    height: '1.2em',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $f7a722354e8e82d7$var$ICON_WIDTH = 16;
const $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $f7a722354e8e82d7$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $f7a722354e8e82d7$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const containerRef = (0, $42omo.useRef)(null);
    const hoverLinkButtonRef = (0, $42omo.useRef)(null);
    const hiddenTextRef = (0, $42omo.useRef)(null);
    const [showLabel, setShowLabel] = (0, $42omo.useState)(true);
    const [isHovered, setHovered] = (0, $42omo.useState)(false);
    const openTextWidthRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $f7a722354e8e82d7$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $f7a722354e8e82d7$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $f7a722354e8e82d7$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if ((0, $iu6m9.editorExperiment)('cc_editor_hover_link_overlay_css_fix', true)) {
            if (containerRef.current && hoverLinkButtonRef.current) {
                const containerRight = containerRef.current.getBoundingClientRect().right;
                const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
                if (buttonRight > containerRight) canShowLabel = false;
            }
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if ((0, $iu6m9.editorExperiment)('cc_editor_hover_link_overlay_css_fix', true)) {
            if (isHovered) setShowLabel(true);
        }
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $f7a722354e8e82d7$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $d925B.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $3RxtY.messages).previewButtonTitle) : formatMessage((0, $3RxtY.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: containerRef,
        css: $f7a722354e8e82d7$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        // No-op focus/blur handlers to satisfy a11y/mouse-events-have-key-events rule.
        // The hover overlay is a mouse convenience — keyboard users can access link actions
        // (open, preview) via the floating toolbar that appears on selection.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, children, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $f7a722354e8e82d7$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fpGTa.default), {
        ref: hoverLinkButtonRef,
        xcss: $f7a722354e8e82d7$var$linkStylesCommon,
        href: url,
        target: "_blank",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        style: {
            paddingBlock: compactPadding ? '1px' : (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? $f7a722354e8e82d7$var$DYNAMIC_PADDING_BLOCK : "var(--ds-space-025, 2px)"
        },
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $f7a722354e8e82d7$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
var $f7a722354e8e82d7$export$2e2bcd8739ae039 = $f7a722354e8e82d7$var$HoverLinkOverlay;
module.exports["default"] = $f7a722354e8e82d7$export$2e2bcd8739ae039;

});

parcelRegister("eLQM6", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b100a9eece33ac5b$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aCItv")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b100a9eece33ac5b$var$LazyDatasourceTableView, props));
};
var $b100a9eece33ac5b$export$2e2bcd8739ae039 = $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $b100a9eece33ac5b$export$2e2bcd8739ae039;

});

parcelRegister("aCItv", function(module, exports) {

let $7bbff3cdab8c5841$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7bbff3cdab8c5841$var$load("4pqtR"),
    $7bbff3cdab8c5841$var$load("5XqRg"),
    $7bbff3cdab8c5841$var$load("6wr18"),
    $7bbff3cdab8c5841$var$load("5pvpJ"),
    $7bbff3cdab8c5841$var$load("iNa18"),
    $7bbff3cdab8c5841$var$load("8makw"),
    $7bbff3cdab8c5841$var$load("9hYRW"),
    $7bbff3cdab8c5841$var$load("kpm7S"),
    $7bbff3cdab8c5841$var$load("ffEVr"),
    $7bbff3cdab8c5841$var$load("eO0qk"),
    $7bbff3cdab8c5841$var$load("kHOMt"),
    $7bbff3cdab8c5841$var$load("hhss7"),
    $7bbff3cdab8c5841$var$load("7EorR"),
    $7bbff3cdab8c5841$var$load("Wowvf"),
    $7bbff3cdab8c5841$var$load("5RR9C"),
    $7bbff3cdab8c5841$var$load("7ixUU")
]).then(()=>parcelRequire('jfuml'));

});

parcelRegister("655oj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9trs7 = parcelRequire("9trs7");


var $eIleF = parcelRequire("eIleF");


var $gmi3X = parcelRequire("gmi3X");


var $1Okf1 = parcelRequire("1Okf1");

const $b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE = 50;
const $b1fdc4e801245f01$export$f82fcd766a8daa7f = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$40b1dd31340bd5c2 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$15cd58682efec5a5 = new (0, $9trs7.LRUMap)($b1fdc4e801245f01$var$URL_RESPONSE_CACHE_SIZE);
const $b1fdc4e801245f01$export$5e074c0b68e2ce03 = 20;
const $b1fdc4e801245f01$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    const resolverUrl = (0, $1Okf1.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
			 * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
			 * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $gmi3X.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $gmi3X.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $42omo.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $b1fdc4e801245f01$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $42omo.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $b1fdc4e801245f01$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $42omo.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $b1fdc4e801245f01$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $42omo.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $42omo.useCallback)((ari)=>{
        $b1fdc4e801245f01$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $b1fdc4e801245f01$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $42omo.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $b1fdc4e801245f01$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $b1fdc4e801245f01$export$7d812bb756889442;

});

parcelRegister("4Z0ju", function(module, exports) {
const $706ca8480df97452$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};
module.exports["buildDatasourceAdf"] = $706ca8480df97452$export$1de3504963fc32f2;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("2WHHL", function(module, exports) {
const $4de09c96514ff692$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $4de09c96514ff692$var$uniqueKey = Symbol('closestEdge');
function $4de09c96514ff692$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $4de09c96514ff692$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$4de09c96514ff692$var$uniqueKey]: addClosestEdge
    };
}
function $4de09c96514ff692$export$945a571f3b658bf(userData) {
    return userData[$4de09c96514ff692$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $4de09c96514ff692$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $4de09c96514ff692$export$945a571f3b658bf;

});

parcelRegister("5jQxm", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("66utD")).getElementFromPointWithoutHoneypot);

var $66utD = parcelRequire("66utD");


});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("4Ldep", function(module, exports) {
$parcel$export(module.exports, "default", () => $3775d0b53e1446a0$export$2e2bcd8739ae039);

var $dhNqt = parcelRequire("dhNqt");


var $b5utg = parcelRequire("b5utg");

function $3775d0b53e1446a0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeftStartOfDay = (0, $dhNqt.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $dhNqt.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("5TGLQ", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $aw01o = parcelRequire("aw01o");


var $a6FC8 = parcelRequire("a6FC8");

const $0aa0cd7558ee373c$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $aw01o.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $0aa0cd7558ee373c$export$ea56ca58f08ffa52;

});

parcelRegister("gL6du", function(module, exports) {
const $21e9301be8cff986$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $21e9301be8cff986$export$dca0327c9b9c6498;

});

parcelRegister("aw01o", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $3nGJd = parcelRequire("3nGJd");


var $4eigd = parcelRequire("4eigd");


var $2iEso = parcelRequire("2iEso");

const $734802129a3b7f4d$var$INVALID_DATE = new Date(NaN);
const $734802129a3b7f4d$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $734802129a3b7f4d$var$INVARIANT_DATE = (0, $2iEso.toDate)($734802129a3b7f4d$var$INVARIANT);
const $734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $734802129a3b7f4d$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $734802129a3b7f4d$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $734802129a3b7f4d$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $734802129a3b7f4d$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($734802129a3b7f4d$var$INVARIANT_DATE);
    const shortDate = $734802129a3b7f4d$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $734802129a3b7f4d$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $734802129a3b7f4d$var$stripExtras(date).match($734802129a3b7f4d$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $734802129a3b7f4d$var$INVALID_DATE;
        const dateParts = $734802129a3b7f4d$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $4eigd.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3nGJd.isValid)(normalizedDate)) return $734802129a3b7f4d$var$INVALID_DATE;
        return (0, $2iEso.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $734802129a3b7f4d$export$cfa2ef2687faeda2;

});

parcelRegister("3nGJd", function(module, exports) {

var $7sNuF = parcelRequire("7sNuF");

const $7f0fa5875d6e9a42$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $7sNuF.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $7f0fa5875d6e9a42$export$1ea939691cdc45b8;

});

parcelRegister("7sNuF", function(module, exports) {

var $1RvqY = parcelRequire("1RvqY");

const $320ec45740b0ee24$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $1RvqY.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $320ec45740b0ee24$export$f645ddd439eb259d;

});

parcelRegister("1RvqY", function(module, exports) {
const $323f2e4da88832b7$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $323f2e4da88832b7$export$553d7fa8e3805fc0;

});

parcelRegister("4eigd", function(module, exports) {

var $aKKC5 = parcelRequire("aKKC5");

const $927e6bf7203913f7$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $aKKC5.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $927e6bf7203913f7$export$fcc71269590ba0a8;

});

parcelRegister("aKKC5", function(module, exports) {
const $00e4455f9b4cd7ae$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $00e4455f9b4cd7ae$export$abe96da78d4f59dd;

});

parcelRegister("2iEso", function(module, exports) {
const $f36e5bfee980e3d5$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $f36e5bfee980e3d5$export$e67a095c620b86fe;

});

parcelRegister("a6FC8", function(module, exports) {
const $5e4f9944cbc7c90e$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $5e4f9944cbc7c90e$export$9b7ca29af37c192;

});

parcelRegister("9ir1r", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
function $6c4ac1879293f4a7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6c4ac1879293f4a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6c4ac1879293f4a7$var$_typeof(o);
}
function $6c4ac1879293f4a7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6c4ac1879293f4a7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6c4ac1879293f4a7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6c4ac1879293f4a7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6c4ac1879293f4a7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6c4ac1879293f4a7$var$_toPropertyKey(arg) {
    var key = $6c4ac1879293f4a7$var$_toPrimitive(arg, "string");
    return $6c4ac1879293f4a7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6c4ac1879293f4a7$var$_toPrimitive(input, hint) {
    if ($6c4ac1879293f4a7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6c4ac1879293f4a7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6c4ac1879293f4a7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $f5M9x = parcelRequire("f5M9x");

var $6c4ac1879293f4a7$var$_require$codes = $f5M9x.codes, $6c4ac1879293f4a7$var$ERR_AMBIGUOUS_ARGUMENT = $6c4ac1879293f4a7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE = $6c4ac1879293f4a7$var$_require$codes.ERR_INVALID_ARG_TYPE, $6c4ac1879293f4a7$var$ERR_INVALID_ARG_VALUE = $6c4ac1879293f4a7$var$_require$codes.ERR_INVALID_ARG_VALUE, $6c4ac1879293f4a7$var$ERR_INVALID_RETURN_VALUE = $6c4ac1879293f4a7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $6c4ac1879293f4a7$var$ERR_MISSING_ARGS = $6c4ac1879293f4a7$var$_require$codes.ERR_MISSING_ARGS;

var $1siW5 = parcelRequire("1siW5");


var $b0OmS = parcelRequire("b0OmS");

var $6c4ac1879293f4a7$var$inspect = $b0OmS.inspect;



var $6c4ac1879293f4a7$require$_require$types = $b0OmS.types;
var $6c4ac1879293f4a7$var$isPromise = $6c4ac1879293f4a7$require$_require$types.isPromise, $6c4ac1879293f4a7$var$isRegExp = $6c4ac1879293f4a7$require$_require$types.isRegExp;

var $6c4ac1879293f4a7$var$objectAssign = (parcelRequire("h1v6R"))();

var $6c4ac1879293f4a7$var$objectIs = (parcelRequire("d9tvR"))();

var $6c4ac1879293f4a7$var$RegExpPrototypeTest = (parcelRequire("bbt7I"))('RegExp.prototype.test');
var $6c4ac1879293f4a7$var$errorCache = new Map();
var $6c4ac1879293f4a7$var$isDeepEqual;
var $6c4ac1879293f4a7$var$isDeepStrictEqual;
var $6c4ac1879293f4a7$var$parseExpressionAt;
var $6c4ac1879293f4a7$var$findNodeAround;
var $6c4ac1879293f4a7$var$decoder;

function $6c4ac1879293f4a7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("2BOM9"));
    $6c4ac1879293f4a7$var$isDeepEqual = comparison.isDeepEqual;
    $6c4ac1879293f4a7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $6c4ac1879293f4a7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $6c4ac1879293f4a7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $6c4ac1879293f4a7$var$escapeFn = function escapeFn(str) {
    return $6c4ac1879293f4a7$var$meta[str.charCodeAt(0)];
};
var $6c4ac1879293f4a7$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $6c4ac1879293f4a7$var$assert = module.exports = $6c4ac1879293f4a7$var$ok;
var $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $6c4ac1879293f4a7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $1siW5(obj);
}
function $6c4ac1879293f4a7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($6c4ac1879293f4a7$var$warned === false) {
            $6c4ac1879293f4a7$var$warned = true;
            var warn = $kyRHQ.emitWarning ? $kyRHQ.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $6c4ac1879293f4a7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $1siW5(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$6c4ac1879293f4a7$var$assert.fail = $6c4ac1879293f4a7$var$fail;
// The AssertionError is defined in internal/error.
$6c4ac1879293f4a7$var$assert.AssertionError = $1siW5;
function $6c4ac1879293f4a7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $1siW5({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $6c4ac1879293f4a7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $6c4ac1879293f4a7$var$innerOk.apply(void 0, [
        $6c4ac1879293f4a7$var$ok,
        args.length
    ].concat(args));
}
$6c4ac1879293f4a7$var$assert.ok = $6c4ac1879293f4a7$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $6c4ac1879293f4a7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$6c4ac1879293f4a7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$6c4ac1879293f4a7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
    if (!$6c4ac1879293f4a7$var$isDeepEqual(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$6c4ac1879293f4a7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
    if ($6c4ac1879293f4a7$var$isDeepEqual(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $6c4ac1879293f4a7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
    if (!$6c4ac1879293f4a7$var$isDeepStrictEqual(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$6c4ac1879293f4a7$var$assert.notDeepStrictEqual = $6c4ac1879293f4a7$var$notDeepStrictEqual;
function $6c4ac1879293f4a7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
    if ($6c4ac1879293f4a7$var$isDeepStrictEqual(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $6c4ac1879293f4a7$var$notDeepStrictEqual
    });
}
$6c4ac1879293f4a7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$6c4ac1879293f4a7$var$objectIs(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$6c4ac1879293f4a7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $6c4ac1879293f4a7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($6c4ac1879293f4a7$var$objectIs(actual, expected)) $6c4ac1879293f4a7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $6c4ac1879293f4a7$var$Comparison = /*#__PURE__*/ $6c4ac1879293f4a7$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $6c4ac1879293f4a7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $6c4ac1879293f4a7$var$isRegExp(obj[key]) && $6c4ac1879293f4a7$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $6c4ac1879293f4a7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$6c4ac1879293f4a7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $6c4ac1879293f4a7$var$Comparison(actual, keys);
            var b = new $6c4ac1879293f4a7$var$Comparison(expected, keys, actual);
            var err = new $1siW5({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $6c4ac1879293f4a7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $6c4ac1879293f4a7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($6c4ac1879293f4a7$var$isRegExp(expected)) return $6c4ac1879293f4a7$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($6c4ac1879293f4a7$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $1siW5({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($6c4ac1879293f4a7$var$isDeepEqual === undefined) $6c4ac1879293f4a7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $6c4ac1879293f4a7$var$isRegExp(expected[key]) && $6c4ac1879293f4a7$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $6c4ac1879293f4a7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $6c4ac1879293f4a7$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL;
}
function $6c4ac1879293f4a7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $6c4ac1879293f4a7$var$isPromise(obj) || obj !== null && $6c4ac1879293f4a7$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $6c4ac1879293f4a7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$6c4ac1879293f4a7$var$checkIsPromise(resultPromise)) throw new $6c4ac1879293f4a7$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($6c4ac1879293f4a7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $6c4ac1879293f4a7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($6c4ac1879293f4a7$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $6c4ac1879293f4a7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $6c4ac1879293f4a7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $6c4ac1879293f4a7$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $6c4ac1879293f4a7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$6c4ac1879293f4a7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $6c4ac1879293f4a7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $6c4ac1879293f4a7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $6c4ac1879293f4a7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $6c4ac1879293f4a7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$6c4ac1879293f4a7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $6c4ac1879293f4a7$var$expectsError.apply(void 0, [
        throws,
        $6c4ac1879293f4a7$var$getActual(promiseFn)
    ].concat(args));
};
$6c4ac1879293f4a7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $6c4ac1879293f4a7$var$waitForActual(promiseFn).then(function(result) {
        return $6c4ac1879293f4a7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$6c4ac1879293f4a7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $6c4ac1879293f4a7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $6c4ac1879293f4a7$var$getActual(fn)
    ].concat(args));
};
$6c4ac1879293f4a7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $6c4ac1879293f4a7$var$waitForActual(fn).then(function(result) {
        return $6c4ac1879293f4a7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$6c4ac1879293f4a7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($6c4ac1879293f4a7$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $6c4ac1879293f4a7$var$inspect(err);
        var newErr = new $1siW5({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $6c4ac1879293f4a7$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$6c4ac1879293f4a7$var$isRegExp(regexp)) throw new $6c4ac1879293f4a7$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $6c4ac1879293f4a7$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($6c4ac1879293f4a7$var$_typeof(string), " (").concat($6c4ac1879293f4a7$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($6c4ac1879293f4a7$var$inspect(regexp), ". Input:\n\n").concat($6c4ac1879293f4a7$var$inspect(string), "\n"));
        var err = new $1siW5({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$6c4ac1879293f4a7$var$assert.match = function match(string, regexp, message) {
    $6c4ac1879293f4a7$var$internalMatch(string, regexp, message, match, 'match');
};
$6c4ac1879293f4a7$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $6c4ac1879293f4a7$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $6c4ac1879293f4a7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $6c4ac1879293f4a7$var$innerOk.apply(void 0, [
        $6c4ac1879293f4a7$var$strict,
        args.length
    ].concat(args));
}
$6c4ac1879293f4a7$var$assert.strict = $6c4ac1879293f4a7$var$objectAssign($6c4ac1879293f4a7$var$strict, $6c4ac1879293f4a7$var$assert, {
    equal: $6c4ac1879293f4a7$var$assert.strictEqual,
    deepEqual: $6c4ac1879293f4a7$var$assert.deepStrictEqual,
    notEqual: $6c4ac1879293f4a7$var$assert.notStrictEqual,
    notDeepEqual: $6c4ac1879293f4a7$var$assert.notDeepStrictEqual
});
$6c4ac1879293f4a7$var$assert.strict.strict = $6c4ac1879293f4a7$var$assert.strict;

});

parcelRegister("f5M9x", function(module, exports) {
$parcel$export(module.exports, "codes", () => $afccaccef25c16b2$export$e45cb6485273080e, (v) => $afccaccef25c16b2$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $afccaccef25c16b2$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $afccaccef25c16b2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afccaccef25c16b2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afccaccef25c16b2$var$_typeof(o);
}
function $afccaccef25c16b2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $afccaccef25c16b2$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $afccaccef25c16b2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $afccaccef25c16b2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $afccaccef25c16b2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $afccaccef25c16b2$var$_toPropertyKey(arg) {
    var key = $afccaccef25c16b2$var$_toPrimitive(arg, "string");
    return $afccaccef25c16b2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $afccaccef25c16b2$var$_toPrimitive(input, hint) {
    if ($afccaccef25c16b2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($afccaccef25c16b2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $afccaccef25c16b2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $afccaccef25c16b2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $afccaccef25c16b2$var$_setPrototypeOf(subClass, superClass);
}
function $afccaccef25c16b2$var$_setPrototypeOf(o, p) {
    $afccaccef25c16b2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $afccaccef25c16b2$var$_setPrototypeOf(o, p);
}
function $afccaccef25c16b2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $afccaccef25c16b2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $afccaccef25c16b2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $afccaccef25c16b2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $afccaccef25c16b2$var$_possibleConstructorReturn(this, result);
    };
}
function $afccaccef25c16b2$var$_possibleConstructorReturn(self, call) {
    if (call && ($afccaccef25c16b2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $afccaccef25c16b2$var$_assertThisInitialized(self);
}
function $afccaccef25c16b2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $afccaccef25c16b2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $afccaccef25c16b2$var$_getPrototypeOf(o) {
    $afccaccef25c16b2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $afccaccef25c16b2$var$_getPrototypeOf(o);
}
var $afccaccef25c16b2$var$codes = {};
// Lazy loaded
var $afccaccef25c16b2$var$assert;
var $afccaccef25c16b2$var$util;
function $afccaccef25c16b2$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $afccaccef25c16b2$var$_inherits(NodeError, _Base);
        var _super = $afccaccef25c16b2$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $afccaccef25c16b2$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $afccaccef25c16b2$var$_createClass(NodeError);
    }(Base);
    $afccaccef25c16b2$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $afccaccef25c16b2$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $afccaccef25c16b2$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $afccaccef25c16b2$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $afccaccef25c16b2$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$afccaccef25c16b2$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$afccaccef25c16b2$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($afccaccef25c16b2$var$assert === undefined) $afccaccef25c16b2$var$assert = (parcelRequire("9ir1r"));
    $afccaccef25c16b2$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $afccaccef25c16b2$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($afccaccef25c16b2$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($afccaccef25c16b2$var$oneOf(expected, 'type'));
    else {
        var type = $afccaccef25c16b2$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($afccaccef25c16b2$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($afccaccef25c16b2$var$_typeof(actual));
    return msg;
}, TypeError);

$afccaccef25c16b2$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($afccaccef25c16b2$var$util === undefined) $afccaccef25c16b2$var$util = (parcelRequire("b0OmS"));
    var inspected = $afccaccef25c16b2$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$afccaccef25c16b2$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($afccaccef25c16b2$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$afccaccef25c16b2$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($afccaccef25c16b2$var$assert === undefined) $afccaccef25c16b2$var$assert = (parcelRequire("9ir1r"));
    $afccaccef25c16b2$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$afccaccef25c16b2$export$e45cb6485273080e = $afccaccef25c16b2$var$codes;

});

parcelRegister("b0OmS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $kyRHQ = parcelRequire("kyRHQ");

var $8046c3ce1b0e4212$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $8046c3ce1b0e4212$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$8046c3ce1b0e4212$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($8046c3ce1b0e4212$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($8046c3ce1b0e4212$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($8046c3ce1b0e4212$var$isNull(x) || !$8046c3ce1b0e4212$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $8046c3ce1b0e4212$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $kyRHQ !== 'undefined' && $kyRHQ.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $kyRHQ === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($kyRHQ.throwDeprecation) throw new Error(msg);
            else if ($kyRHQ.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $8046c3ce1b0e4212$var$debugs = {};
var $8046c3ce1b0e4212$var$debugEnvRegex = /^$/;
var $8046c3ce1b0e4212$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$8046c3ce1b0e4212$var$debugs[set]) {
        if ($8046c3ce1b0e4212$var$debugEnvRegex.test(set)) {
            var pid = $kyRHQ.pid;
            $8046c3ce1b0e4212$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $8046c3ce1b0e4212$var$debugs[set] = function() {};
    }
    return $8046c3ce1b0e4212$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $8046c3ce1b0e4212$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $8046c3ce1b0e4212$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($8046c3ce1b0e4212$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($8046c3ce1b0e4212$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($8046c3ce1b0e4212$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($8046c3ce1b0e4212$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($8046c3ce1b0e4212$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $8046c3ce1b0e4212$var$stylizeWithColor;
    return $8046c3ce1b0e4212$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $8046c3ce1b0e4212$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$8046c3ce1b0e4212$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$8046c3ce1b0e4212$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $8046c3ce1b0e4212$var$stylizeWithColor(str, styleType) {
    var style = $8046c3ce1b0e4212$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $8046c3ce1b0e4212$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $8046c3ce1b0e4212$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $8046c3ce1b0e4212$var$stylizeNoColor(str, styleType) {
    return str;
}
function $8046c3ce1b0e4212$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $8046c3ce1b0e4212$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $8046c3ce1b0e4212$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$8046c3ce1b0e4212$var$isString(ret)) ret = $8046c3ce1b0e4212$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $8046c3ce1b0e4212$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $8046c3ce1b0e4212$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($8046c3ce1b0e4212$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $8046c3ce1b0e4212$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($8046c3ce1b0e4212$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($8046c3ce1b0e4212$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($8046c3ce1b0e4212$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($8046c3ce1b0e4212$var$isError(value)) return $8046c3ce1b0e4212$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($8046c3ce1b0e4212$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($8046c3ce1b0e4212$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($8046c3ce1b0e4212$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($8046c3ce1b0e4212$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($8046c3ce1b0e4212$var$isError(value)) base = ' ' + $8046c3ce1b0e4212$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($8046c3ce1b0e4212$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $8046c3ce1b0e4212$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $8046c3ce1b0e4212$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $8046c3ce1b0e4212$var$reduceToSingleString(output, base, braces);
}
function $8046c3ce1b0e4212$var$formatPrimitive(ctx, value) {
    if ($8046c3ce1b0e4212$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($8046c3ce1b0e4212$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($8046c3ce1b0e4212$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($8046c3ce1b0e4212$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($8046c3ce1b0e4212$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $8046c3ce1b0e4212$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $8046c3ce1b0e4212$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($8046c3ce1b0e4212$var$hasOwnProperty(value, String(i))) output.push($8046c3ce1b0e4212$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($8046c3ce1b0e4212$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $8046c3ce1b0e4212$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$8046c3ce1b0e4212$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($8046c3ce1b0e4212$var$isNull(recurseTimes)) str = $8046c3ce1b0e4212$var$formatValue(ctx, desc.value, null);
            else str = $8046c3ce1b0e4212$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($8046c3ce1b0e4212$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $8046c3ce1b0e4212$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("6o2Ml"));
function $8046c3ce1b0e4212$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $8046c3ce1b0e4212$var$isArray;
function $8046c3ce1b0e4212$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $8046c3ce1b0e4212$var$isBoolean;
function $8046c3ce1b0e4212$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $8046c3ce1b0e4212$var$isNull;
function $8046c3ce1b0e4212$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $8046c3ce1b0e4212$var$isNullOrUndefined;
function $8046c3ce1b0e4212$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $8046c3ce1b0e4212$var$isNumber;
function $8046c3ce1b0e4212$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $8046c3ce1b0e4212$var$isString;
function $8046c3ce1b0e4212$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $8046c3ce1b0e4212$var$isSymbol;
function $8046c3ce1b0e4212$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $8046c3ce1b0e4212$var$isUndefined;
function $8046c3ce1b0e4212$var$isRegExp(re) {
    return $8046c3ce1b0e4212$var$isObject(re) && $8046c3ce1b0e4212$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $8046c3ce1b0e4212$var$isRegExp;
module.exports.types.isRegExp = $8046c3ce1b0e4212$var$isRegExp;
function $8046c3ce1b0e4212$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $8046c3ce1b0e4212$var$isObject;
function $8046c3ce1b0e4212$var$isDate(d) {
    return $8046c3ce1b0e4212$var$isObject(d) && $8046c3ce1b0e4212$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $8046c3ce1b0e4212$var$isDate;
module.exports.types.isDate = $8046c3ce1b0e4212$var$isDate;
function $8046c3ce1b0e4212$var$isError(e) {
    return $8046c3ce1b0e4212$var$isObject(e) && ($8046c3ce1b0e4212$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $8046c3ce1b0e4212$var$isError;
module.exports.types.isNativeError = $8046c3ce1b0e4212$var$isError;
function $8046c3ce1b0e4212$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $8046c3ce1b0e4212$var$isFunction;
function $8046c3ce1b0e4212$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $8046c3ce1b0e4212$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("ciKgI"));
function $8046c3ce1b0e4212$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $8046c3ce1b0e4212$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $8046c3ce1b0e4212$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $8046c3ce1b0e4212$var$timestamp() {
    var d = new Date();
    var time = [
        $8046c3ce1b0e4212$var$pad(d.getHours()),
        $8046c3ce1b0e4212$var$pad(d.getMinutes()),
        $8046c3ce1b0e4212$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $8046c3ce1b0e4212$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $8046c3ce1b0e4212$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dMzRp"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$8046c3ce1b0e4212$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $8046c3ce1b0e4212$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $8046c3ce1b0e4212$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($8046c3ce1b0e4212$var$kCustomPromisifiedSymbol && original[$8046c3ce1b0e4212$var$kCustomPromisifiedSymbol]) {
        var fn = original[$8046c3ce1b0e4212$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $8046c3ce1b0e4212$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($8046c3ce1b0e4212$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $8046c3ce1b0e4212$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $8046c3ce1b0e4212$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $8046c3ce1b0e4212$var$kCustomPromisifiedSymbol;
function $8046c3ce1b0e4212$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $8046c3ce1b0e4212$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $kyRHQ.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $kyRHQ.nextTick($8046c3ce1b0e4212$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $8046c3ce1b0e4212$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $8046c3ce1b0e4212$var$callbackify;

});

parcelRegister("6o2Ml", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $bz2Iq = parcelRequire("bz2Iq");


var $3cWlp = parcelRequire("3cWlp");


var $khd9U = parcelRequire("khd9U");


var $7vkYj = parcelRequire("7vkYj");

function $4a6723c0633fbcbf$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $4a6723c0633fbcbf$var$BigIntSupported = typeof BigInt !== 'undefined';
var $4a6723c0633fbcbf$var$SymbolSupported = typeof Symbol !== 'undefined';
var $4a6723c0633fbcbf$var$ObjectToString = $4a6723c0633fbcbf$var$uncurryThis(Object.prototype.toString);
var $4a6723c0633fbcbf$var$numberValue = $4a6723c0633fbcbf$var$uncurryThis(Number.prototype.valueOf);
var $4a6723c0633fbcbf$var$stringValue = $4a6723c0633fbcbf$var$uncurryThis(String.prototype.valueOf);
var $4a6723c0633fbcbf$var$booleanValue = $4a6723c0633fbcbf$var$uncurryThis(Boolean.prototype.valueOf);
if ($4a6723c0633fbcbf$var$BigIntSupported) var $4a6723c0633fbcbf$var$bigIntValue = $4a6723c0633fbcbf$var$uncurryThis(BigInt.prototype.valueOf);
if ($4a6723c0633fbcbf$var$SymbolSupported) var $4a6723c0633fbcbf$var$symbolValue = $4a6723c0633fbcbf$var$uncurryThis(Symbol.prototype.valueOf);
function $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $bz2Iq;
module.exports.isGeneratorFunction = $3cWlp;
module.exports.isTypedArray = $7vkYj;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $4a6723c0633fbcbf$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $4a6723c0633fbcbf$var$isPromise;
function $4a6723c0633fbcbf$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $7vkYj(value) || $4a6723c0633fbcbf$var$isDataView(value);
}
module.exports.isArrayBufferView = $4a6723c0633fbcbf$var$isArrayBufferView;
function $4a6723c0633fbcbf$var$isUint8Array(value) {
    return $khd9U(value) === 'Uint8Array';
}
module.exports.isUint8Array = $4a6723c0633fbcbf$var$isUint8Array;
function $4a6723c0633fbcbf$var$isUint8ClampedArray(value) {
    return $khd9U(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $4a6723c0633fbcbf$var$isUint8ClampedArray;
function $4a6723c0633fbcbf$var$isUint16Array(value) {
    return $khd9U(value) === 'Uint16Array';
}
module.exports.isUint16Array = $4a6723c0633fbcbf$var$isUint16Array;
function $4a6723c0633fbcbf$var$isUint32Array(value) {
    return $khd9U(value) === 'Uint32Array';
}
module.exports.isUint32Array = $4a6723c0633fbcbf$var$isUint32Array;
function $4a6723c0633fbcbf$var$isInt8Array(value) {
    return $khd9U(value) === 'Int8Array';
}
module.exports.isInt8Array = $4a6723c0633fbcbf$var$isInt8Array;
function $4a6723c0633fbcbf$var$isInt16Array(value) {
    return $khd9U(value) === 'Int16Array';
}
module.exports.isInt16Array = $4a6723c0633fbcbf$var$isInt16Array;
function $4a6723c0633fbcbf$var$isInt32Array(value) {
    return $khd9U(value) === 'Int32Array';
}
module.exports.isInt32Array = $4a6723c0633fbcbf$var$isInt32Array;
function $4a6723c0633fbcbf$var$isFloat32Array(value) {
    return $khd9U(value) === 'Float32Array';
}
module.exports.isFloat32Array = $4a6723c0633fbcbf$var$isFloat32Array;
function $4a6723c0633fbcbf$var$isFloat64Array(value) {
    return $khd9U(value) === 'Float64Array';
}
module.exports.isFloat64Array = $4a6723c0633fbcbf$var$isFloat64Array;
function $4a6723c0633fbcbf$var$isBigInt64Array(value) {
    return $khd9U(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $4a6723c0633fbcbf$var$isBigInt64Array;
function $4a6723c0633fbcbf$var$isBigUint64Array(value) {
    return $khd9U(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $4a6723c0633fbcbf$var$isBigUint64Array;
function $4a6723c0633fbcbf$var$isMapToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Map]';
}
$4a6723c0633fbcbf$var$isMapToString.working = typeof Map !== 'undefined' && $4a6723c0633fbcbf$var$isMapToString(new Map());
function $4a6723c0633fbcbf$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isMapToString.working ? $4a6723c0633fbcbf$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $4a6723c0633fbcbf$var$isMap;
function $4a6723c0633fbcbf$var$isSetToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Set]';
}
$4a6723c0633fbcbf$var$isSetToString.working = typeof Set !== 'undefined' && $4a6723c0633fbcbf$var$isSetToString(new Set());
function $4a6723c0633fbcbf$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isSetToString.working ? $4a6723c0633fbcbf$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $4a6723c0633fbcbf$var$isSet;
function $4a6723c0633fbcbf$var$isWeakMapToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object WeakMap]';
}
$4a6723c0633fbcbf$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $4a6723c0633fbcbf$var$isWeakMapToString(new WeakMap());
function $4a6723c0633fbcbf$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isWeakMapToString.working ? $4a6723c0633fbcbf$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $4a6723c0633fbcbf$var$isWeakMap;
function $4a6723c0633fbcbf$var$isWeakSetToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object WeakSet]';
}
$4a6723c0633fbcbf$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $4a6723c0633fbcbf$var$isWeakSetToString(new WeakSet());
function $4a6723c0633fbcbf$var$isWeakSet(value) {
    return $4a6723c0633fbcbf$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $4a6723c0633fbcbf$var$isWeakSet;
function $4a6723c0633fbcbf$var$isArrayBufferToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$4a6723c0633fbcbf$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $4a6723c0633fbcbf$var$isArrayBufferToString(new ArrayBuffer());
function $4a6723c0633fbcbf$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isArrayBufferToString.working ? $4a6723c0633fbcbf$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $4a6723c0633fbcbf$var$isArrayBuffer;
function $4a6723c0633fbcbf$var$isDataViewToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object DataView]';
}
$4a6723c0633fbcbf$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $4a6723c0633fbcbf$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $4a6723c0633fbcbf$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $4a6723c0633fbcbf$var$isDataViewToString.working ? $4a6723c0633fbcbf$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $4a6723c0633fbcbf$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $4a6723c0633fbcbf$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $4a6723c0633fbcbf$var$isSharedArrayBufferToString(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $4a6723c0633fbcbf$var$isSharedArrayBuffer(value) {
    if (typeof $4a6723c0633fbcbf$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $4a6723c0633fbcbf$var$isSharedArrayBufferToString.working === 'undefined') $4a6723c0633fbcbf$var$isSharedArrayBufferToString.working = $4a6723c0633fbcbf$var$isSharedArrayBufferToString(new $4a6723c0633fbcbf$var$SharedArrayBufferCopy());
    return $4a6723c0633fbcbf$var$isSharedArrayBufferToString.working ? $4a6723c0633fbcbf$var$isSharedArrayBufferToString(value) : value instanceof $4a6723c0633fbcbf$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $4a6723c0633fbcbf$var$isSharedArrayBuffer;
function $4a6723c0633fbcbf$var$isAsyncFunction(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $4a6723c0633fbcbf$var$isAsyncFunction;
function $4a6723c0633fbcbf$var$isMapIterator(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $4a6723c0633fbcbf$var$isMapIterator;
function $4a6723c0633fbcbf$var$isSetIterator(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $4a6723c0633fbcbf$var$isSetIterator;
function $4a6723c0633fbcbf$var$isGeneratorObject(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $4a6723c0633fbcbf$var$isGeneratorObject;
function $4a6723c0633fbcbf$var$isWebAssemblyCompiledModule(value) {
    return $4a6723c0633fbcbf$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $4a6723c0633fbcbf$var$isWebAssemblyCompiledModule;
function $4a6723c0633fbcbf$var$isNumberObject(value) {
    return $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$numberValue);
}
module.exports.isNumberObject = $4a6723c0633fbcbf$var$isNumberObject;
function $4a6723c0633fbcbf$var$isStringObject(value) {
    return $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$stringValue);
}
module.exports.isStringObject = $4a6723c0633fbcbf$var$isStringObject;
function $4a6723c0633fbcbf$var$isBooleanObject(value) {
    return $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$booleanValue);
}
module.exports.isBooleanObject = $4a6723c0633fbcbf$var$isBooleanObject;
function $4a6723c0633fbcbf$var$isBigIntObject(value) {
    return $4a6723c0633fbcbf$var$BigIntSupported && $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$bigIntValue);
}
module.exports.isBigIntObject = $4a6723c0633fbcbf$var$isBigIntObject;
function $4a6723c0633fbcbf$var$isSymbolObject(value) {
    return $4a6723c0633fbcbf$var$SymbolSupported && $4a6723c0633fbcbf$var$checkBoxedPrimitive(value, $4a6723c0633fbcbf$var$symbolValue);
}
module.exports.isSymbolObject = $4a6723c0633fbcbf$var$isSymbolObject;
function $4a6723c0633fbcbf$var$isBoxedPrimitive(value) {
    return $4a6723c0633fbcbf$var$isNumberObject(value) || $4a6723c0633fbcbf$var$isStringObject(value) || $4a6723c0633fbcbf$var$isBooleanObject(value) || $4a6723c0633fbcbf$var$isBigIntObject(value) || $4a6723c0633fbcbf$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $4a6723c0633fbcbf$var$isBoxedPrimitive;
function $4a6723c0633fbcbf$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($4a6723c0633fbcbf$var$isArrayBuffer(value) || $4a6723c0633fbcbf$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $4a6723c0633fbcbf$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});

parcelRegister("bz2Iq", function(module, exports) {
'use strict';

var $86b511da6386f62f$var$hasToStringTag = (parcelRequire("8an01"))();

var $bbt7I = parcelRequire("bbt7I");

var $86b511da6386f62f$var$$toString = $bbt7I('Object.prototype.toString');
var $86b511da6386f62f$var$isStandardArguments = function isArguments(value) {
    if ($86b511da6386f62f$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $86b511da6386f62f$var$$toString(value) === '[object Arguments]';
};
var $86b511da6386f62f$var$isLegacyArguments = function isArguments(value) {
    if ($86b511da6386f62f$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $86b511da6386f62f$var$$toString(value) !== '[object Array]' && $86b511da6386f62f$var$$toString(value.callee) === '[object Function]';
};
var $86b511da6386f62f$var$supportsStandardArguments = function() {
    return $86b511da6386f62f$var$isStandardArguments(arguments);
}();
$86b511da6386f62f$var$isStandardArguments.isLegacyArguments = $86b511da6386f62f$var$isLegacyArguments; // for tests
module.exports = $86b511da6386f62f$var$supportsStandardArguments ? $86b511da6386f62f$var$isStandardArguments : $86b511da6386f62f$var$isLegacyArguments;

});

parcelRegister("bbt7I", function(module, exports) {
'use strict';

var $92atP = parcelRequire("92atP");


var $i3fmO = parcelRequire("i3fmO");

var $8247501a17a70da7$var$$indexOf = $i3fmO($92atP('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $92atP(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $8247501a17a70da7$var$$indexOf(name, '.prototype.') > -1) return $i3fmO(intrinsic);
    return intrinsic;
};

});

parcelRegister("3cWlp", function(module, exports) {
'use strict';
var $255fc00e314822ed$var$toStr = Object.prototype.toString;
var $255fc00e314822ed$var$fnToStr = Function.prototype.toString;
var $255fc00e314822ed$var$isFnRegex = /^\s*(?:function)?\*/;

var $255fc00e314822ed$var$hasToStringTag = (parcelRequire("8an01"))();
var $255fc00e314822ed$var$getProto = Object.getPrototypeOf;
var $255fc00e314822ed$var$getGeneratorFunc = function() {
    if (!$255fc00e314822ed$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $255fc00e314822ed$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($255fc00e314822ed$var$isFnRegex.test($255fc00e314822ed$var$fnToStr.call(fn))) return true;
    if (!$255fc00e314822ed$var$hasToStringTag) {
        var str = $255fc00e314822ed$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$255fc00e314822ed$var$getProto) return false;
    if (typeof $255fc00e314822ed$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $255fc00e314822ed$var$getGeneratorFunc();
        $255fc00e314822ed$var$GeneratorFunction = generatorFunc ? $255fc00e314822ed$var$getProto(generatorFunc) : false;
    }
    return $255fc00e314822ed$var$getProto(fn) === $255fc00e314822ed$var$GeneratorFunction;
};

});

parcelRegister("ciKgI", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("1siW5", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $kyRHQ = parcelRequire("kyRHQ");

'use strict';
function $10f718393718d8b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10f718393718d8b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10f718393718d8b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $10f718393718d8b8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10f718393718d8b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $10f718393718d8b8$var$_defineProperty(obj, key, value) {
    key = $10f718393718d8b8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $10f718393718d8b8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $10f718393718d8b8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $10f718393718d8b8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $10f718393718d8b8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $10f718393718d8b8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $10f718393718d8b8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $10f718393718d8b8$var$_toPropertyKey(arg) {
    var key = $10f718393718d8b8$var$_toPrimitive(arg, "string");
    return $10f718393718d8b8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $10f718393718d8b8$var$_toPrimitive(input, hint) {
    if ($10f718393718d8b8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($10f718393718d8b8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $10f718393718d8b8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $10f718393718d8b8$var$_setPrototypeOf(subClass, superClass);
}
function $10f718393718d8b8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $10f718393718d8b8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $10f718393718d8b8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $10f718393718d8b8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $10f718393718d8b8$var$_possibleConstructorReturn(this, result);
    };
}
function $10f718393718d8b8$var$_possibleConstructorReturn(self, call) {
    if (call && ($10f718393718d8b8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $10f718393718d8b8$var$_assertThisInitialized(self);
}
function $10f718393718d8b8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $10f718393718d8b8$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $10f718393718d8b8$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$10f718393718d8b8$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $10f718393718d8b8$var$_construct(Class, arguments, $10f718393718d8b8$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $10f718393718d8b8$var$_setPrototypeOf(Wrapper, Class);
    };
    return $10f718393718d8b8$var$_wrapNativeSuper(Class);
}
function $10f718393718d8b8$var$_construct(Parent, args, Class) {
    if ($10f718393718d8b8$var$_isNativeReflectConstruct()) $10f718393718d8b8$var$_construct = Reflect.construct.bind();
    else $10f718393718d8b8$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $10f718393718d8b8$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $10f718393718d8b8$var$_construct.apply(null, arguments);
}
function $10f718393718d8b8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $10f718393718d8b8$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $10f718393718d8b8$var$_setPrototypeOf(o, p) {
    $10f718393718d8b8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $10f718393718d8b8$var$_setPrototypeOf(o, p);
}
function $10f718393718d8b8$var$_getPrototypeOf(o) {
    $10f718393718d8b8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $10f718393718d8b8$var$_getPrototypeOf(o);
}
function $10f718393718d8b8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $10f718393718d8b8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $10f718393718d8b8$var$_typeof(o);
}

var $b0OmS = parcelRequire("b0OmS");

var $10f718393718d8b8$var$inspect = $b0OmS.inspect;

var $f5M9x = parcelRequire("f5M9x");

var $10f718393718d8b8$var$ERR_INVALID_ARG_TYPE = $f5M9x.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $10f718393718d8b8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $10f718393718d8b8$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $10f718393718d8b8$var$blue = '';
var $10f718393718d8b8$var$green = '';
var $10f718393718d8b8$var$red = '';
var $10f718393718d8b8$var$white = '';
var $10f718393718d8b8$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $10f718393718d8b8$var$kMaxShortLength = 10;
function $10f718393718d8b8$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $10f718393718d8b8$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $10f718393718d8b8$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $10f718393718d8b8$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $10f718393718d8b8$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $10f718393718d8b8$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $10f718393718d8b8$var$_typeof(actual) === 'object' && $10f718393718d8b8$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $10f718393718d8b8$var$kMaxShortLength) {
            if (($10f718393718d8b8$var$_typeof(actual) !== 'object' || actual === null) && ($10f718393718d8b8$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($10f718393718d8b8$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $kyRHQ.stderr && $kyRHQ.stderr.isTTY ? $kyRHQ.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($10f718393718d8b8$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($10f718393718d8b8$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $10f718393718d8b8$var$kReadableOperator[operator] + "\n".concat($10f718393718d8b8$var$green, "+ actual").concat($10f718393718d8b8$var$white, " ").concat($10f718393718d8b8$var$red, "- expected").concat($10f718393718d8b8$var$white);
    var skippedMsg = " ".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($10f718393718d8b8$var$red, "-").concat($10f718393718d8b8$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($10f718393718d8b8$var$green, "+").concat($10f718393718d8b8$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$10f718393718d8b8$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $10f718393718d8b8$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($10f718393718d8b8$var$green, "+").concat($10f718393718d8b8$var$white, " ").concat(actualLine);
                other += "\n".concat($10f718393718d8b8$var$red, "-").concat($10f718393718d8b8$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white).concat(other, "\n") + "".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $10f718393718d8b8$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $10f718393718d8b8$var$_inherits(AssertionError, _Error);
    var _super = $10f718393718d8b8$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $10f718393718d8b8$var$_classCallCheck(this, AssertionError);
        if ($10f718393718d8b8$var$_typeof(options) !== 'object' || options === null) throw new $10f718393718d8b8$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($kyRHQ.stderr && $kyRHQ.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($kyRHQ.stderr && $kyRHQ.stderr.getColorDepth && $kyRHQ.stderr.getColorDepth() !== 1) {
                    $10f718393718d8b8$var$blue = "\x1B[34m";
                    $10f718393718d8b8$var$green = "\x1B[32m";
                    $10f718393718d8b8$var$white = "\x1B[39m";
                    $10f718393718d8b8$var$red = "\x1B[31m";
                } else {
                    $10f718393718d8b8$var$blue = '';
                    $10f718393718d8b8$var$green = '';
                    $10f718393718d8b8$var$white = '';
                    $10f718393718d8b8$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($10f718393718d8b8$var$_typeof(actual) === 'object' && actual !== null && $10f718393718d8b8$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $10f718393718d8b8$var$copyError(actual);
                expected = $10f718393718d8b8$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $10f718393718d8b8$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $10f718393718d8b8$var$kReadableOperator[operator];
                var res = $10f718393718d8b8$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $10f718393718d8b8$var$_typeof(actual) === 'object' && actual !== null) base = $10f718393718d8b8$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($10f718393718d8b8$var$blue, "...").concat($10f718393718d8b8$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $10f718393718d8b8$var$inspectValue(actual);
                var other = '';
                var knownOperators = $10f718393718d8b8$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($10f718393718d8b8$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($10f718393718d8b8$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($10f718393718d8b8$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($10f718393718d8b8$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $10f718393718d8b8$var$_possibleConstructorReturn(_this);
    }
    $10f718393718d8b8$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $10f718393718d8b8$var$inspect(this, $10f718393718d8b8$var$_objectSpread($10f718393718d8b8$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $10f718393718d8b8$var$_wrapNativeSuper(Error), $10f718393718d8b8$var$inspect.custom);
module.exports = $10f718393718d8b8$var$AssertionError;

});

parcelRegister("h1v6R", function(module, exports) {
'use strict';

var $8Fult = parcelRequire("8Fult");

var $c64aa95e9c42a904$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $c64aa95e9c42a904$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $8Fult;
    if ($c64aa95e9c42a904$var$lacksProperEnumerationOrder()) return $8Fult;
    if ($c64aa95e9c42a904$var$assignHasPendingExceptions()) return $8Fult;
    return Object.assign;
};

});

parcelRegister("8Fult", function(module, exports) {
'use strict';

var $70R9c = parcelRequire("70R9c");


var $64f9b1077ce826d5$var$hasSymbols = (parcelRequire("23Da1"))();

var $aahHV = parcelRequire("aahHV");


var $j4PUi = parcelRequire("j4PUi");

var $64f9b1077ce826d5$var$$push = $aahHV('Array.prototype.push');
var $64f9b1077ce826d5$var$$propIsEnumerable = $aahHV('Object.prototype.propertyIsEnumerable');
var $64f9b1077ce826d5$var$originalGetSymbols = $64f9b1077ce826d5$var$hasSymbols ? $j4PUi.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $j4PUi(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $j4PUi(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $70R9c(from);
        var getSymbols = $64f9b1077ce826d5$var$hasSymbols && ($j4PUi.getOwnPropertySymbols || $64f9b1077ce826d5$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($64f9b1077ce826d5$var$$propIsEnumerable(from, key)) $64f9b1077ce826d5$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($64f9b1077ce826d5$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});

parcelRegister("70R9c", function(module, exports) {
'use strict';
var $51b1c276532d198e$var$slice = Array.prototype.slice;

var $75XcH = parcelRequire("75XcH");

var $51b1c276532d198e$var$origKeys = Object.keys;

var $51b1c276532d198e$var$keysShim = $51b1c276532d198e$var$origKeys ? function keys(o) {
    return $51b1c276532d198e$var$origKeys(o);
} : (parcelRequire("8vcFU"));
var $51b1c276532d198e$var$originalKeys = Object.keys;
$51b1c276532d198e$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($75XcH(object)) return $51b1c276532d198e$var$originalKeys($51b1c276532d198e$var$slice.call(object));
            return $51b1c276532d198e$var$originalKeys(object);
        };
    } else Object.keys = $51b1c276532d198e$var$keysShim;
    return Object.keys || $51b1c276532d198e$var$keysShim;
};
module.exports = $51b1c276532d198e$var$keysShim;

});

parcelRegister("75XcH", function(module, exports) {
'use strict';
var $52a6ecac25e6c24e$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $52a6ecac25e6c24e$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $52a6ecac25e6c24e$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("8vcFU", function(module, exports) {
'use strict';
var $630b0cf713a4b00d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $630b0cf713a4b00d$var$has = Object.prototype.hasOwnProperty;
    var $630b0cf713a4b00d$var$toStr = Object.prototype.toString;
    var $630b0cf713a4b00d$var$isArgs = (parcelRequire("75XcH")); // eslint-disable-line global-require
    var $630b0cf713a4b00d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $630b0cf713a4b00d$var$hasDontEnumBug = !$630b0cf713a4b00d$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $630b0cf713a4b00d$var$hasProtoEnumBug = $630b0cf713a4b00d$var$isEnumerable.call(function() {}, 'prototype');
    var $630b0cf713a4b00d$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $630b0cf713a4b00d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $630b0cf713a4b00d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $630b0cf713a4b00d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$630b0cf713a4b00d$var$excludedKeys['$' + k] && $630b0cf713a4b00d$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $630b0cf713a4b00d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $630b0cf713a4b00d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$630b0cf713a4b00d$var$hasAutomationEqualityBug) return $630b0cf713a4b00d$var$equalsConstructorPrototype(o);
        try {
            return $630b0cf713a4b00d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $630b0cf713a4b00d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $630b0cf713a4b00d$var$toStr.call(object) === '[object Function]';
        var isArguments = $630b0cf713a4b00d$var$isArgs(object);
        var isString = isObject && $630b0cf713a4b00d$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $630b0cf713a4b00d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$630b0cf713a4b00d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $630b0cf713a4b00d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($630b0cf713a4b00d$var$hasDontEnumBug) {
            var skipConstructor = $630b0cf713a4b00d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $630b0cf713a4b00d$var$dontEnums.length; ++k)if (!(skipConstructor && $630b0cf713a4b00d$var$dontEnums[k] === 'constructor') && $630b0cf713a4b00d$var$has.call(object, $630b0cf713a4b00d$var$dontEnums[k])) theKeys.push($630b0cf713a4b00d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $630b0cf713a4b00d$var$keysShim;

});

parcelRegister("d9tvR", function(module, exports) {
'use strict';

var $3oQFO = parcelRequire("3oQFO");

module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $3oQFO;
};

});

parcelRegister("3oQFO", function(module, exports) {
'use strict';
var $279c78d5a2041951$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($279c78d5a2041951$var$numberIsNaN(a) && $279c78d5a2041951$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("2BOM9", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $1e666c76a5838678$var$_slicedToArray(arr, i) {
    return $1e666c76a5838678$var$_arrayWithHoles(arr) || $1e666c76a5838678$var$_iterableToArrayLimit(arr, i) || $1e666c76a5838678$var$_unsupportedIterableToArray(arr, i) || $1e666c76a5838678$var$_nonIterableRest();
}
function $1e666c76a5838678$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1e666c76a5838678$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e666c76a5838678$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e666c76a5838678$var$_arrayLikeToArray(o, minLen);
}
function $1e666c76a5838678$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1e666c76a5838678$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1e666c76a5838678$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1e666c76a5838678$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1e666c76a5838678$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1e666c76a5838678$var$_typeof(o);
}
var $1e666c76a5838678$var$regexFlagsSupported = /a/g.flags !== undefined;
var $1e666c76a5838678$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $1e666c76a5838678$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $1e666c76a5838678$var$objectIs = Object.is ? Object.is : (parcelRequire("1lWVG"));
var $1e666c76a5838678$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $1e666c76a5838678$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("3LzxK"));
function $1e666c76a5838678$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $1e666c76a5838678$var$hasOwnProperty = $1e666c76a5838678$var$uncurryThis(Object.prototype.hasOwnProperty);
var $1e666c76a5838678$var$propertyIsEnumerable = $1e666c76a5838678$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $1e666c76a5838678$var$objectToString = $1e666c76a5838678$var$uncurryThis(Object.prototype.toString);

var $b0OmS = parcelRequire("b0OmS");

var $1e666c76a5838678$require$_require$types = $b0OmS.types;
var $1e666c76a5838678$var$isAnyArrayBuffer = $1e666c76a5838678$require$_require$types.isAnyArrayBuffer, $1e666c76a5838678$var$isArrayBufferView = $1e666c76a5838678$require$_require$types.isArrayBufferView, $1e666c76a5838678$var$isDate = $1e666c76a5838678$require$_require$types.isDate, $1e666c76a5838678$var$isMap = $1e666c76a5838678$require$_require$types.isMap, $1e666c76a5838678$var$isRegExp = $1e666c76a5838678$require$_require$types.isRegExp, $1e666c76a5838678$var$isSet = $1e666c76a5838678$require$_require$types.isSet, $1e666c76a5838678$var$isNativeError = $1e666c76a5838678$require$_require$types.isNativeError, $1e666c76a5838678$var$isBoxedPrimitive = $1e666c76a5838678$require$_require$types.isBoxedPrimitive, $1e666c76a5838678$var$isNumberObject = $1e666c76a5838678$require$_require$types.isNumberObject, $1e666c76a5838678$var$isStringObject = $1e666c76a5838678$require$_require$types.isStringObject, $1e666c76a5838678$var$isBooleanObject = $1e666c76a5838678$require$_require$types.isBooleanObject, $1e666c76a5838678$var$isBigIntObject = $1e666c76a5838678$require$_require$types.isBigIntObject, $1e666c76a5838678$var$isSymbolObject = $1e666c76a5838678$require$_require$types.isSymbolObject, $1e666c76a5838678$var$isFloat32Array = $1e666c76a5838678$require$_require$types.isFloat32Array, $1e666c76a5838678$var$isFloat64Array = $1e666c76a5838678$require$_require$types.isFloat64Array;
function $1e666c76a5838678$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $1e666c76a5838678$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($1e666c76a5838678$var$isNonIndex).concat($1e666c76a5838678$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $1e666c76a5838678$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $1e666c76a5838678$var$ONLY_ENUMERABLE = undefined;
var $1e666c76a5838678$var$kStrict = true;
var $1e666c76a5838678$var$kLoose = false;
var $1e666c76a5838678$var$kNoIterator = 0;
var $1e666c76a5838678$var$kIsArray = 1;
var $1e666c76a5838678$var$kIsSet = 2;
var $1e666c76a5838678$var$kIsMap = 3;
// Check if they have the same source and flags
function $1e666c76a5838678$var$areSimilarRegExps(a, b) {
    return $1e666c76a5838678$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $1e666c76a5838678$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $1e666c76a5838678$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $1e666c76a5838678$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $1e666c76a5838678$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $1e666c76a5838678$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $1e666c76a5838678$var$isEqualBoxedPrimitive(val1, val2) {
    if ($1e666c76a5838678$var$isNumberObject(val1)) return $1e666c76a5838678$var$isNumberObject(val2) && $1e666c76a5838678$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($1e666c76a5838678$var$isStringObject(val1)) return $1e666c76a5838678$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($1e666c76a5838678$var$isBooleanObject(val1)) return $1e666c76a5838678$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($1e666c76a5838678$var$isBigIntObject(val1)) return $1e666c76a5838678$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $1e666c76a5838678$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $1e666c76a5838678$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $1e666c76a5838678$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($1e666c76a5838678$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $1e666c76a5838678$var$numberIsNaN(val1) && $1e666c76a5838678$var$numberIsNaN(val2);
        if ($1e666c76a5838678$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $1e666c76a5838678$var$_typeof(val1) !== 'object') {
            if (val2 === null || $1e666c76a5838678$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $1e666c76a5838678$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $1e666c76a5838678$var$objectToString(val1);
    var val2Tag = $1e666c76a5838678$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $1e666c76a5838678$var$getOwnNonIndexProperties(val1, $1e666c76a5838678$var$ONLY_ENUMERABLE);
        var keys2 = $1e666c76a5838678$var$getOwnNonIndexProperties(val2, $1e666c76a5838678$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$1e666c76a5838678$var$isMap(val1) && $1e666c76a5838678$var$isMap(val2) || !$1e666c76a5838678$var$isSet(val1) && $1e666c76a5838678$var$isSet(val2)) return false;
    }
    if ($1e666c76a5838678$var$isDate(val1)) {
        if (!$1e666c76a5838678$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($1e666c76a5838678$var$isRegExp(val1)) {
        if (!$1e666c76a5838678$var$isRegExp(val2) || !$1e666c76a5838678$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($1e666c76a5838678$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($1e666c76a5838678$var$isArrayBufferView(val1)) {
        if (!strict && ($1e666c76a5838678$var$isFloat32Array(val1) || $1e666c76a5838678$var$isFloat64Array(val1))) {
            if (!$1e666c76a5838678$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$1e666c76a5838678$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $1e666c76a5838678$var$getOwnNonIndexProperties(val1, $1e666c76a5838678$var$ONLY_ENUMERABLE);
        var _keys2 = $1e666c76a5838678$var$getOwnNonIndexProperties(val2, $1e666c76a5838678$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kNoIterator, _keys);
    } else if ($1e666c76a5838678$var$isSet(val1)) {
        if (!$1e666c76a5838678$var$isSet(val2) || val1.size !== val2.size) return false;
        return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kIsSet);
    } else if ($1e666c76a5838678$var$isMap(val1)) {
        if (!$1e666c76a5838678$var$isMap(val2) || val1.size !== val2.size) return false;
        return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kIsMap);
    } else if ($1e666c76a5838678$var$isAnyArrayBuffer(val1)) {
        if (!$1e666c76a5838678$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($1e666c76a5838678$var$isBoxedPrimitive(val1) && !$1e666c76a5838678$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, $1e666c76a5838678$var$kNoIterator);
}
function $1e666c76a5838678$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $1e666c76a5838678$var$propertyIsEnumerable(val, k);
    });
}
function $1e666c76a5838678$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$1e666c76a5838678$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $1e666c76a5838678$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($1e666c76a5838678$var$propertyIsEnumerable(val1, key)) {
                    if (!$1e666c76a5838678$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($1e666c76a5838678$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $1e666c76a5838678$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $1e666c76a5838678$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $1e666c76a5838678$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $1e666c76a5838678$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $1e666c76a5838678$var$kNoIterator || iterationType === $1e666c76a5838678$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $1e666c76a5838678$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $1e666c76a5838678$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $1e666c76a5838678$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($1e666c76a5838678$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $1e666c76a5838678$var$findLooseMatchingPrimitives(prim) {
    switch($1e666c76a5838678$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($1e666c76a5838678$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $1e666c76a5838678$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $1e666c76a5838678$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $1e666c76a5838678$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $1e666c76a5838678$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$1e666c76a5838678$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $1e666c76a5838678$var$innerDeepEqual(item, curB, false, memo);
}
function $1e666c76a5838678$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $1e666c76a5838678$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($1e666c76a5838678$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$1e666c76a5838678$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $1e666c76a5838678$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($1e666c76a5838678$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$1e666c76a5838678$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$1e666c76a5838678$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $1e666c76a5838678$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $1e666c76a5838678$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($1e666c76a5838678$var$innerDeepEqual(key1, key2, strict, memo) && $1e666c76a5838678$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $1e666c76a5838678$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $1e666c76a5838678$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $1e666c76a5838678$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($1e666c76a5838678$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$1e666c76a5838678$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$1e666c76a5838678$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $1e666c76a5838678$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $1e666c76a5838678$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($1e666c76a5838678$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$1e666c76a5838678$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$1e666c76a5838678$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$1e666c76a5838678$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $1e666c76a5838678$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $1e666c76a5838678$var$kIsSet) {
        if (!$1e666c76a5838678$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $1e666c76a5838678$var$kIsMap) {
        if (!$1e666c76a5838678$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $1e666c76a5838678$var$kIsArray) for(; i < a.length; i++){
        if ($1e666c76a5838678$var$hasOwnProperty(a, i)) {
            if (!$1e666c76a5838678$var$hasOwnProperty(b, i) || !$1e666c76a5838678$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($1e666c76a5838678$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$1e666c76a5838678$var$hasOwnProperty(b, key) || !$1e666c76a5838678$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$1e666c76a5838678$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $1e666c76a5838678$var$isDeepEqual(val1, val2) {
    return $1e666c76a5838678$var$innerDeepEqual(val1, val2, $1e666c76a5838678$var$kLoose);
}
function $1e666c76a5838678$var$isDeepStrictEqual(val1, val2) {
    return $1e666c76a5838678$var$innerDeepEqual(val1, val2, $1e666c76a5838678$var$kStrict);
}
module.exports = {
    isDeepEqual: $1e666c76a5838678$var$isDeepEqual,
    isDeepStrictEqual: $1e666c76a5838678$var$isDeepStrictEqual
};

});

parcelRegister("1lWVG", function(module, exports) {
'use strict';

var $eeQAO = parcelRequire("eeQAO");


var $i3fmO = parcelRequire("i3fmO");


var $3oQFO = parcelRequire("3oQFO");


var $d9tvR = parcelRequire("d9tvR");


var $enjtz = parcelRequire("enjtz");

var $0fc576c14e1f3493$var$polyfill = $i3fmO($d9tvR(), Object);
$eeQAO($0fc576c14e1f3493$var$polyfill, {
    getPolyfill: $d9tvR,
    implementation: $3oQFO,
    shim: $enjtz
});
module.exports = $0fc576c14e1f3493$var$polyfill;

});

parcelRegister("eeQAO", function(module, exports) {
'use strict';

var $70R9c = parcelRequire("70R9c");

var $a5db2b50bead88e3$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $a5db2b50bead88e3$var$toStr = Object.prototype.toString;
var $a5db2b50bead88e3$var$concat = Array.prototype.concat;

var $gglQq = parcelRequire("gglQq");

var $a5db2b50bead88e3$var$isFunction = function(fn) {
    return typeof fn === 'function' && $a5db2b50bead88e3$var$toStr.call(fn) === '[object Function]';
};

var $a5db2b50bead88e3$var$supportsDescriptors = (parcelRequire("lUjLg"))();
var $a5db2b50bead88e3$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$a5db2b50bead88e3$var$isFunction(predicate) || !predicate()) return;
    }
    if ($a5db2b50bead88e3$var$supportsDescriptors) $gglQq(object, name, value, true);
    else $gglQq(object, name, value);
};
var $a5db2b50bead88e3$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $70R9c(map);
    if ($a5db2b50bead88e3$var$hasSymbols) props = $a5db2b50bead88e3$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$a5db2b50bead88e3$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$a5db2b50bead88e3$var$defineProperties.supportsDescriptors = !!$a5db2b50bead88e3$var$supportsDescriptors;
module.exports = $a5db2b50bead88e3$var$defineProperties;

});

parcelRegister("enjtz", function(module, exports) {
'use strict';

var $d9tvR = parcelRequire("d9tvR");


var $eeQAO = parcelRequire("eeQAO");

module.exports = function shimObjectIs() {
    var polyfill = $d9tvR();
    $eeQAO(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("3LzxK", function(module, exports) {
'use strict';

var $i3fmO = parcelRequire("i3fmO");


var $eeQAO = parcelRequire("eeQAO");


var $fWwv5 = parcelRequire("fWwv5");


var $bMM0q = parcelRequire("bMM0q");


var $5OG3Y = parcelRequire("5OG3Y");

var $2be1550e2ae24faf$var$polyfill = $i3fmO($bMM0q(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $eeQAO($2be1550e2ae24faf$var$polyfill, {
    getPolyfill: $bMM0q,
    implementation: $fWwv5,
    shim: $5OG3Y
});
module.exports = $2be1550e2ae24faf$var$polyfill;

});

parcelRegister("fWwv5", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("bMM0q", function(module, exports) {
'use strict';

var $fWwv5 = parcelRequire("fWwv5");

module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $fWwv5;
};

});

parcelRegister("5OG3Y", function(module, exports) {
'use strict';

var $eeQAO = parcelRequire("eeQAO");


var $bMM0q = parcelRequire("bMM0q");

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $bMM0q();
    $eeQAO(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("7HI7Y", function(module, exports) {
$parcel$export(module.exports, "merge", () => $59bec75d4837f566$export$4950aa0f605343fb, (v) => $59bec75d4837f566$export$4950aa0f605343fb = v);
var $59bec75d4837f566$export$4950aa0f605343fb;
"use strict";

var $YgydF = parcelRequire("YgydF");


var $HHFyQ = parcelRequire("HHFyQ");


var $5Dgek = parcelRequire("5Dgek");


var $kQ0lo = parcelRequire("kQ0lo");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $59bec75d4837f566$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($5Dgek.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $YgydF.Observable) return observables[0];
    return $kQ0lo.mergeAll(concurrent)(new $HHFyQ.ArrayObservable(observables, scheduler));
}
$59bec75d4837f566$export$4950aa0f605343fb = $59bec75d4837f566$var$merge;

});

parcelRegister("kQ0lo", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $f2b8ee495d9150ab$export$18aef43295bbe906, (v) => $f2b8ee495d9150ab$export$18aef43295bbe906 = v);
var $f2b8ee495d9150ab$export$18aef43295bbe906;
"use strict";

var $XrDsM = parcelRequire("XrDsM");


var $hsCka = parcelRequire("hsCka");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $f2b8ee495d9150ab$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $XrDsM.mergeMap($hsCka.identity, null, concurrent);
}
$f2b8ee495d9150ab$export$18aef43295bbe906 = $f2b8ee495d9150ab$var$mergeAll;

});

parcelRegister("hsCka", function(module, exports) {
$parcel$export(module.exports, "identity", () => $cb62c79807c8a85d$export$f0954fd7d5368655, (v) => $cb62c79807c8a85d$export$f0954fd7d5368655 = v);
var $cb62c79807c8a85d$export$f0954fd7d5368655;
"use strict";
function $cb62c79807c8a85d$var$identity(x) {
    return x;
}
$cb62c79807c8a85d$export$f0954fd7d5368655 = $cb62c79807c8a85d$var$identity;

});

parcelRegister("eVpDl", function(module, exports) {
"use strict";
var $adda45daebf3b6ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $adda45daebf3b6ff$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $adda45daebf3b6ff$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $adda45daebf3b6ff$var$filter;
var $adda45daebf3b6ff$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $adda45daebf3b6ff$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $adda45daebf3b6ff$var$FilterSubscriber = function(_super) {
    $adda45daebf3b6ff$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($axeml.Subscriber);

});

parcelRegister("kXEyd", function(module, exports) {
"use strict";
var $f428c5e2ee2b390f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $f428c5e2ee2b390f$var$take(count) {
    return function(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $f428c5e2ee2b390f$var$TakeOperator(count));
    };
}
module.exports.take = $f428c5e2ee2b390f$var$take;
var $f428c5e2ee2b390f$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f428c5e2ee2b390f$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f428c5e2ee2b390f$var$TakeSubscriber = function(_super) {
    $f428c5e2ee2b390f$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($axeml.Subscriber);

});

parcelRegister("2g0GA", function(module, exports) {
"use strict";
var $1a4d9b96869ee1a1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError = function(_super) {
    $1a4d9b96869ee1a1$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $1a4d9b96869ee1a1$var$ArgumentOutOfRangeError;

});

parcelRegister("1Ria2", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $15a8d410ba774044$export$45b10814cc054894, (v) => $15a8d410ba774044$export$45b10814cc054894 = v);
var $15a8d410ba774044$export$45b10814cc054894;
"use strict";

var $244gB = parcelRequire("244gB");

function $15a8d410ba774044$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $15a8d410ba774044$var$toArray() {
    return $244gB.reduce($15a8d410ba774044$var$toArrayReducer, []);
}
$15a8d410ba774044$export$45b10814cc054894 = $15a8d410ba774044$var$toArray;

});

parcelRegister("244gB", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $180f43c63924c6e6$export$533b26079ad0b4b, (v) => $180f43c63924c6e6$export$533b26079ad0b4b = v);
var $180f43c63924c6e6$export$533b26079ad0b4b;
"use strict";

var $kiSup = parcelRequire("kiSup");


var $ib5HR = parcelRequire("ib5HR");


var $avZwt = parcelRequire("avZwt");


var $5wWzN = parcelRequire("5wWzN");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $180f43c63924c6e6$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $5wWzN.pipe($kiSup.scan(accumulator, seed), $ib5HR.takeLast(1), $avZwt.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $5wWzN.pipe($kiSup.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $ib5HR.takeLast(1))(source);
    };
}
$180f43c63924c6e6$export$533b26079ad0b4b = $180f43c63924c6e6$var$reduce;

});

parcelRegister("kiSup", function(module, exports) {
"use strict";
var $ec7fc18d41270381$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $ec7fc18d41270381$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $ec7fc18d41270381$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $ec7fc18d41270381$var$scan;
var $ec7fc18d41270381$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ec7fc18d41270381$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ec7fc18d41270381$var$ScanSubscriber = function(_super) {
    $ec7fc18d41270381$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ib5HR", function(module, exports) {
"use strict";
var $d3bdae4589ae3cf1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $2g0GA = parcelRequire("2g0GA");


var $b5CQv = parcelRequire("b5CQv");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $d3bdae4589ae3cf1$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $b5CQv.EmptyObservable();
        else return source.lift(new $d3bdae4589ae3cf1$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $d3bdae4589ae3cf1$var$takeLast;
var $d3bdae4589ae3cf1$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $2g0GA.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d3bdae4589ae3cf1$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d3bdae4589ae3cf1$var$TakeLastSubscriber = function(_super) {
    $d3bdae4589ae3cf1$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($axeml.Subscriber);

});

parcelRegister("avZwt", function(module, exports) {
"use strict";
var $7a7c85c9732247d4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $7a7c85c9732247d4$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $7a7c85c9732247d4$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $7a7c85c9732247d4$var$defaultIfEmpty;
var $7a7c85c9732247d4$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7a7c85c9732247d4$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7a7c85c9732247d4$var$DefaultIfEmptySubscriber = function(_super) {
    $7a7c85c9732247d4$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($axeml.Subscriber);

});

parcelRegister("hu8We", function(module, exports) {
$parcel$export(module.exports, "of", () => $cbac2bf0af029aab$export$ba255e9e49e00608, (v) => $cbac2bf0af029aab$export$ba255e9e49e00608 = v);
var $cbac2bf0af029aab$export$ba255e9e49e00608;
"use strict";

var $HHFyQ = parcelRequire("HHFyQ");

$cbac2bf0af029aab$export$ba255e9e49e00608 = $HHFyQ.ArrayObservable.of;

});

parcelRegister("fulrs", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteDelay = $kVeeY.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($6j5QO.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($6j5QO.Notification.createComplete());
    };
    return DelaySubscriber;
}($axeml.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRegister("3u6GG", function(module, exports) {
$parcel$export(module.exports, "async", () => $28995c6d2039be6b$export$12af436354f1a4f7, (v) => $28995c6d2039be6b$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $28995c6d2039be6b$export$12af436354f1a4f7;
"use strict";

var $k8JsH = parcelRequire("k8JsH");


var $iOeLv = parcelRequire("iOeLv");

$28995c6d2039be6b$export$12af436354f1a4f7 = new $iOeLv.AsyncScheduler($k8JsH.AsyncAction);

});

parcelRegister("kVeeY", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $f3b42d67f4ad5339$export$871608497c498473, (v) => $f3b42d67f4ad5339$export$871608497c498473 = v);
var $f3b42d67f4ad5339$export$871608497c498473;
"use strict";
function $f3b42d67f4ad5339$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$f3b42d67f4ad5339$export$871608497c498473 = $f3b42d67f4ad5339$var$isDate;

});

parcelRegister("1BiXn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $dh538 = parcelRequire("dh538");


var $9s7Po = parcelRequire("9s7Po");


var $hnvzE = parcelRequire("hnvzE");

const $2f66d7816a46cebf$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $2f66d7816a46cebf$var$CardLoadingWithContext = ()=>{
    const props = (0, $42omo.useContext)($2f66d7816a46cebf$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9s7Po.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $2f66d7816a46cebf$var$loadCardWithMediaClient() {
    return (parcelRequire("hUWTk"));
}
const $2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "a0IPb",
    name: "MediaCardWithMediaClientLoadable",
    loader: ()=>$2f66d7816a46cebf$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$CardLoadingWithContext, null)
});
const $2f66d7816a46cebf$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>$2f66d7816a46cebf$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $2f66d7816a46cebf$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardContext.Provider, {
        value: props
    }, (0, $dh538.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable, props)));
};
$2f66d7816a46cebf$var$CardLoader.preload = ()=>{
    if ((0, $dh538.fg)('platform_media_react19_support')) $2f66d7816a46cebf$var$loadCardWithMediaClient().then(()=>{});
    else $2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable.preload?.();
};
var $2f66d7816a46cebf$export$2e2bcd8739ae039 = $2f66d7816a46cebf$var$CardLoader;
module.exports["default"] = $2f66d7816a46cebf$export$2e2bcd8739ae039;

});

parcelRegister("9s7Po", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDGbV = parcelRequire("fDGbV");


var $64ehG = parcelRequire("64ehG");


var $9hlns = parcelRequire("9hlns");

class $bf3fa0f5391f39b8$export$5d25853fd6bdf402 extends (0, $42omo.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $fDGbV.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64ehG.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            interactionName: interactionName || 'media-card-loading'
        }));
    }
}
module.exports["CardLoading"] = $bf3fa0f5391f39b8$export$5d25853fd6bdf402;

});

parcelRegister("64ehG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $1CyYH = parcelRequire("1CyYH");

const $fd9c20c94dd40490$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $1CyYH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $fd9c20c94dd40490$export$e6dfd72ab29f8598;

});

parcelRegister("1CyYH", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $fN2NR = parcelRequire("fN2NR");

const $aedc46c8c12477c6$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.center), "background:var(--ds-background-neutral, #0515240F);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });
module.exports["wrapperStyles"] = $aedc46c8c12477c6$export$491e6397d7c1480b;

});

parcelRegister("fN2NR", function(module, exports) {
const $adbace133e9e6202$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $adbace133e9e6202$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $adbace133e9e6202$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $adbace133e9e6202$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $adbace133e9e6202$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $adbace133e9e6202$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $adbace133e9e6202$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["size"] = $adbace133e9e6202$export$346677f925de839c;
module.exports["center"] = $adbace133e9e6202$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $adbace133e9e6202$export$7a57f79000377ca2;

});

parcelRegister("hUWTk", function(module, exports) {

let $d0b5593c80ce3046$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0b5593c80ce3046$var$load("4pqtR"),
    $d0b5593c80ce3046$var$load("5XqRg"),
    $d0b5593c80ce3046$var$load("f35QR"),
    $d0b5593c80ce3046$var$load("eVYW1"),
    $d0b5593c80ce3046$var$load("ls0Um"),
    $d0b5593c80ce3046$var$load("020xd"),
    $d0b5593c80ce3046$var$load("eTBsW"),
    $d0b5593c80ce3046$var$load("bYxCZ"),
    $d0b5593c80ce3046$var$load("6HBYC"),
    $d0b5593c80ce3046$var$load("eDqo1"),
    $d0b5593c80ce3046$var$load("lxiFd"),
    $d0b5593c80ce3046$var$load("1oiJ6"),
    $d0b5593c80ce3046$var$load("huUvS"),
    $d0b5593c80ce3046$var$load("6wr18"),
    $d0b5593c80ce3046$var$load("fisfU"),
    $d0b5593c80ce3046$var$load("fsikk"),
    $d0b5593c80ce3046$var$load("gOOwE"),
    $d0b5593c80ce3046$var$load("8j9XC"),
    $d0b5593c80ce3046$var$load("6vhrJ"),
    $d0b5593c80ce3046$var$load("fxC6e"),
    $d0b5593c80ce3046$var$load("kknf5"),
    $d0b5593c80ce3046$var$load("ajMch"),
    $d0b5593c80ce3046$var$load("hPalR"),
    $d0b5593c80ce3046$var$load("jDjSj"),
    $d0b5593c80ce3046$var$load("8059b"),
    $d0b5593c80ce3046$var$load("3QZdB"),
    $d0b5593c80ce3046$var$load("3M4Om"),
    $d0b5593c80ce3046$var$load("4jPsO"),
    $d0b5593c80ce3046$var$load("72780"),
    $d0b5593c80ce3046$var$load("hszIA"),
    $d0b5593c80ce3046$var$load("2fk6g"),
    $d0b5593c80ce3046$var$load("ffEVr"),
    $d0b5593c80ce3046$var$load("7EorR"),
    $d0b5593c80ce3046$var$load("fwuXj")
]).then(()=>parcelRequire('r0CCR'));

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("3BZZG", function(module, exports) {
const $b77837f445efd10f$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $b77837f445efd10f$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $b77837f445efd10f$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $b77837f445efd10f$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $b77837f445efd10f$export$d87a47989c00f322;
    if (appearance === 'square') return $b77837f445efd10f$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $b77837f445efd10f$export$aeb48196afcd236a;
    return $b77837f445efd10f$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $b77837f445efd10f$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $b77837f445efd10f$export$ed7b8a4728e9c63;

});

parcelRegister("e63NX", function(module, exports) {

var $hL7bb = parcelRequire("hL7bb");

const $aeded572d33c89ca$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $aeded572d33c89ca$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $aeded572d33c89ca$export$5883721593c4e4b1 = (a, b)=>{
    if ($aeded572d33c89ca$export$7695387cd66cf5b5(a) && $aeded572d33c89ca$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(a, b);
};
module.exports["isFileIdentifier"] = $aeded572d33c89ca$export$7695387cd66cf5b5;
module.exports["isExternalImageIdentifier"] = $aeded572d33c89ca$export$2782f2fbff82f0c9;

});

parcelRegister("hL7bb", function(module, exports) {
var $cedc651d64f014e0$var$pSlice = Array.prototype.slice;

var $gFqzn = parcelRequire("gFqzn");


var $2EuUq = parcelRequire("2EuUq");

var $cedc651d64f014e0$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $cedc651d64f014e0$var$objEquiv(actual, expected, opts);
};
function $cedc651d64f014e0$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $cedc651d64f014e0$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $cedc651d64f014e0$var$objEquiv(a, b, opts) {
    var i, key;
    if ($cedc651d64f014e0$var$isUndefinedOrNull(a) || $cedc651d64f014e0$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($2EuUq(a)) {
        if (!$2EuUq(b)) return false;
        a = $cedc651d64f014e0$var$pSlice.call(a);
        b = $cedc651d64f014e0$var$pSlice.call(b);
        return $cedc651d64f014e0$var$deepEqual(a, b, opts);
    }
    if ($cedc651d64f014e0$var$isBuffer(a)) {
        if (!$cedc651d64f014e0$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $gFqzn(a), kb = $gFqzn(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$cedc651d64f014e0$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("gFqzn", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("2EuUq", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("7NoXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a320422a745418e6$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fs5Wi = parcelRequire("fs5Wi");


var $1GQGM = parcelRequire("1GQGM");


const $a320422a745418e6$var$MediaViewer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7SQ5H")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a320422a745418e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fs5Wi.default), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GQGM.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($a320422a745418e6$var$MediaViewer, {
                ...props
            })
        })
    });
}

});

parcelRegister("fs5Wi", function(module, exports) {
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $70BxX = parcelRequire("70BxX");


var $cOrQJ = parcelRequire("cOrQJ");

const $379228055afe24f5$export$442b7be89436c101 = '#101214';
const $379228055afe24f5$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $70BxX.default), {
        blankedColor: $379228055afe24f5$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $379228055afe24f5$export$2e2bcd8739ae039 = $379228055afe24f5$var$ModalSpinner;
module.exports["default"] = $379228055afe24f5$export$2e2bcd8739ae039;

});

parcelRegister("70BxX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9DX83 = parcelRequire("9DX83");

const $9f2ec0906c10b2d9$var$ModalSpinner = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9DX83.default), props);
var $9f2ec0906c10b2d9$export$2e2bcd8739ae039 = $9f2ec0906c10b2d9$var$ModalSpinner;
module.exports["default"] = $9f2ec0906c10b2d9$export$2e2bcd8739ae039;

});

parcelRegister("9DX83", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed42ad447c5e042f$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $ed42ad447c5e042f$var$blanketStyles = null;
const $ed42ad447c5e042f$var$spinnerStyles = null;
const $ed42ad447c5e042f$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $ed42ad447c5e042f$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $42omo.createElement("div", {
        style: {
            backgroundColor: blankedColor || $ed42ad447c5e042f$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "large",
        appearance: invertSpinnerColor || $ed42ad447c5e042f$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("1GQGM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");

const $86b842c4b2e17806$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
        zIndex: 510,
        children: children
    });
module.exports["MediaViewerPortal"] = $86b842c4b2e17806$export$51aee4c01b17acde;

});

parcelRegister("7SQ5H", function(module, exports) {

let $5bd5fbb7a5fbd824$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5bd5fbb7a5fbd824$var$load("gOOwE"),
    $5bd5fbb7a5fbd824$var$load("4pqtR"),
    $5bd5fbb7a5fbd824$var$load("5XqRg"),
    $5bd5fbb7a5fbd824$var$load("f35QR"),
    $5bd5fbb7a5fbd824$var$load("eVYW1"),
    $5bd5fbb7a5fbd824$var$load("ls0Um"),
    $5bd5fbb7a5fbd824$var$load("020xd"),
    $5bd5fbb7a5fbd824$var$load("eTBsW"),
    $5bd5fbb7a5fbd824$var$load("bYxCZ"),
    $5bd5fbb7a5fbd824$var$load("6HBYC"),
    $5bd5fbb7a5fbd824$var$load("eDqo1"),
    $5bd5fbb7a5fbd824$var$load("lxiFd"),
    $5bd5fbb7a5fbd824$var$load("1oiJ6"),
    $5bd5fbb7a5fbd824$var$load("huUvS"),
    $5bd5fbb7a5fbd824$var$load("6wr18"),
    $5bd5fbb7a5fbd824$var$load("llcfA"),
    $5bd5fbb7a5fbd824$var$load("azCDs"),
    $5bd5fbb7a5fbd824$var$load("dT77m"),
    $5bd5fbb7a5fbd824$var$load("8j9XC"),
    $5bd5fbb7a5fbd824$var$load("ffEVr"),
    $5bd5fbb7a5fbd824$var$load("6vhrJ"),
    $5bd5fbb7a5fbd824$var$load("fxC6e"),
    $5bd5fbb7a5fbd824$var$load("kknf5"),
    $5bd5fbb7a5fbd824$var$load("ajMch"),
    $5bd5fbb7a5fbd824$var$load("hPalR"),
    $5bd5fbb7a5fbd824$var$load("jDjSj"),
    $5bd5fbb7a5fbd824$var$load("8059b"),
    $5bd5fbb7a5fbd824$var$load("3QZdB"),
    $5bd5fbb7a5fbd824$var$load("3M4Om"),
    $5bd5fbb7a5fbd824$var$load("4jPsO"),
    $5bd5fbb7a5fbd824$var$load("72780"),
    $5bd5fbb7a5fbd824$var$load("hszIA"),
    $5bd5fbb7a5fbd824$var$load("2fk6g"),
    $5bd5fbb7a5fbd824$var$load("hhss7"),
    $5bd5fbb7a5fbd824$var$load("cKkZK")
]).then(()=>parcelRequire('gamJO'));

});

parcelRegister("31QJ7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $51c490bf07ac8c08$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    svg_image_preview_label_assistive_text: {
        id: "media.media-viewer.svg-wrapper.label_assistive_text",
        defaultMessage: "Close Image Preview"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    },
    media_card_wrapper_label_assistive_text: {
        id: "media.media-card.wrapper.label_assistive_text",
        defaultMessage: "Media file card"
    }
});
module.exports["messages"] = $51c490bf07ac8c08$export$defe85febe8b728c;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("i2CQL", function(module, exports) {

var $g99e4 = parcelRequire("g99e4");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $g99e4.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("g99e4", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $bc14a4aa688fca7b$export$6ccbb43953eebf8);

var $9mu1x = parcelRequire("9mu1x");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $bc14a4aa688fca7b$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $bc14a4aa688fca7b$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = false;
const $bc14a4aa688fca7b$var$identity = (arg)=>arg;
function $bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector = $bc14a4aa688fca7b$var$identity, equalityFn) {
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$bc14a4aa688fca7b$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = true;
    }
    const slice = $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $bc14a4aa688fca7b$var$useDebugValue(slice);
    return slice;
}
const $bc14a4aa688fca7b$var$createImpl = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $9mu1x.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $bc14a4aa688fca7b$export$185802fd694ee1f5 = (createState)=>createState ? $bc14a4aa688fca7b$var$createImpl(createState) : $bc14a4aa688fca7b$var$createImpl;
var $bc14a4aa688fca7b$export$2e2bcd8739ae039 = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $bc14a4aa688fca7b$export$185802fd694ee1f5(createState);
};

});

parcelRegister("8QL6C", function(module, exports) {

var $6mxnm = parcelRequire("6mxnm");


var $hMBjV = parcelRequire("hMBjV");


var $78fzv = parcelRequire("78fzv");

const $586e61da7604bdbd$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $586e61da7604bdbd$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hMBjV.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $6mxnm.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $586e61da7604bdbd$export$836625761e76d373 = {
    mediaInline: false
};
function $586e61da7604bdbd$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $78fzv.getGenericFeatureFlag)(flagName, $586e61da7604bdbd$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $586e61da7604bdbd$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $586e61da7604bdbd$export$383e8f51978266d;

});

parcelRegister("6mxnm", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $6b97f3fad80b5910$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $6b97f3fad80b5910$export$2db74afa1ef496f1;

});

parcelRegister("hMBjV", function(module, exports) {
const $d17c6572fbd16cff$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $d17c6572fbd16cff$export$189fe120be7e73fc = ()=>$d17c6572fbd16cff$var$productKeys;
module.exports["getProductKeys"] = $d17c6572fbd16cff$export$189fe120be7e73fc;

});

parcelRegister("78fzv", function(module, exports) {

var $bcpPc = parcelRequire("bcpPc");

function $18475707c4faede4$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $bcpPc.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $18475707c4faede4$export$f2687d0de19e4973;

});

parcelRegister("bcpPc", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $6c56cea62b261d1c$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $6c56cea62b261d1c$export$d125817a2695dbc9;

});

parcelRegister("41GKb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2ee869754fb919da$var$_react = $2ee869754fb919da$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $2ee869754fb919da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ee869754fb919da$var$Image16Icon = (props)=>/*#__PURE__*/ $2ee869754fb919da$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$2ee869754fb919da$var$Image16Icon.displayName = 'Image16Icon';
var $2ee869754fb919da$var$_default = module.exports.default = $2ee869754fb919da$var$Image16Icon;

});

parcelRegister("46EIy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cewj5 = parcelRequire("cewj5");


var $6ZDLj = parcelRequire("6ZDLj");

const $340ce807e864e408$var$DURATION_MIN = 0.5;
const $340ce807e864e408$var$DURATION_MAX = 1.0;
const $340ce807e864e408$var$EXTRA_PADDING = 4;
const $340ce807e864e408$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $340ce807e864e408$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $340ce807e864e408$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $340ce807e864e408$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $340ce807e864e408$var$DURATION_MAX - $340ce807e864e408$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $340ce807e864e408$var$DURATION_MAX), $340ce807e864e408$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $340ce807e864e408$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $340ce807e864e408$var$EXTRA_PADDING) return newOffset - $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $340ce807e864e408$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, $340ce807e864e408$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($cewj5)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$340ce807e864e408$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $340ce807e864e408$var$mapReactChildToReactNode(child, index) {
    const key = $340ce807e864e408$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $340ce807e864e408$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $340ce807e864e408$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $340ce807e864e408$export$817db220b90d8024;

});

parcelRegister("cewj5", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $8e7fda51b7396b67$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$8e7fda51b7396b67$var$debounce.debounce = $8e7fda51b7396b67$var$debounce;
module.exports = $8e7fda51b7396b67$var$debounce;

});

parcelRegister("6ZDLj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bwcZT = parcelRequire("bwcZT");

const $15c7f4a4aa94e52b$export$924abd21043fc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowLeftWrapper), props);
const $15c7f4a4aa94e52b$export$a5ffe38c17bbc0a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ShadowRight), props);
const $15c7f4a4aa94e52b$export$abf07652016c7e56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowRightWrapper), props);
const $15c7f4a4aa94e52b$export$b39b1b86b48b621f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.LeftArrow), props);
const $15c7f4a4aa94e52b$export$6208675820d4cc50 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.RightArrow), props);
const $15c7f4a4aa94e52b$export$d37eb83491863cbb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripViewWrapper), props);
const $15c7f4a4aa94e52b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripList), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$54cfc70c184c0713 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListItem), props);
module.exports["LeftArrow"] = $15c7f4a4aa94e52b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $15c7f4a4aa94e52b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $15c7f4a4aa94e52b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $15c7f4a4aa94e52b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $15c7f4a4aa94e52b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $15c7f4a4aa94e52b$export$54cfc70c184c0713;

});

parcelRegister("bwcZT", function(module, exports) {
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $bPdpL = parcelRequire("bPdpL");


var $5tOl1 = parcelRequire("5tOl1");


var $46EIy = parcelRequire("46EIy");


var $dh538 = parcelRequire("dh538");

const $1156f5d5007639c5$var$filmStripViewStyles = null;
const $1156f5d5007639c5$var$filmStripListWrapperStyles = null;
const $1156f5d5007639c5$var$filmStripListStyles = null;
const $1156f5d5007639c5$var$filmStripListItemStyles = null;
const $1156f5d5007639c5$var$arrowWrapperStyles = null;
const $1156f5d5007639c5$var$arrowLeftWrapperStyles = null;
const $1156f5d5007639c5$var$arrowRightWrapperStyles = null;
const $1156f5d5007639c5$var$shadowStyles = null;
const $1156f5d5007639c5$var$resetButtonStyle = null;
const $1156f5d5007639c5$var$shadowLeftStyles = null;
const $1156f5d5007639c5$var$shadowRightStyles = null;
const $1156f5d5007639c5$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ])
    }, children);
const $1156f5d5007639c5$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>{
    return (0, $dh538.fg)('platform_media_a11y_suppression_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_kkk2n7od _1e0c1ule",
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
};
const $1156f5d5007639c5$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ])
    }, children);
const $1156f5d5007639c5$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>{
    return (0, $dh538.fg)('platform_media_a11y_suppression_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_kkk2n7od _1e0c1ule",
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
};
const $1156f5d5007639c5$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $1156f5d5007639c5$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $1156f5d5007639c5$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ])
    }, children);
const $1156f5d5007639c5$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ])
    }, children));
const $1156f5d5007639c5$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ])
    }, children));
const $1156f5d5007639c5$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $46EIy.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $1156f5d5007639c5$export$924abd21043fc000;
module.exports["ShadowRight"] = $1156f5d5007639c5$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $1156f5d5007639c5$export$abf07652016c7e56;
module.exports["LeftArrow"] = $1156f5d5007639c5$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $1156f5d5007639c5$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $1156f5d5007639c5$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $1156f5d5007639c5$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $1156f5d5007639c5$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $1156f5d5007639c5$export$54cfc70c184c0713;

});

parcelRegister("aL0VQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");


var $jQCJ9 = parcelRequire("jQCJ9");

const $4cae511015088d55$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
function $4cae511015088d55$export$f91c9e51e5ab027d(ids) {
    const nonErrorFiles = (0, $i2CQL.useMediaStore)((state)=>Object.values(state.files).filter((0, $hZ6O7.isNonErrorFinalFileState)));
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const collections = (0, $42omo.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $42omo.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id })=>file.id === id)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $jQCJ9.usePrevious)(files);
    (0, $42omo.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file)=>file && prev.every((prevFile)=>prevFile.id !== file.id || prevFile.status !== file.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file)=>addedOrChangedFiles.some((addedFile)=>$4cae511015088d55$var$areFilesPotentiallyDuplicated(file, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file)=>{
            const collectionName = collections[file.id];
            mediaClient.file.getFileState(file.id, {
                collectionName: collectionName,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $42omo.useMemo)(()=>Object.fromEntries(files.map((file)=>[
                file.id,
                file.hash
            ])), [
        files
    ]);
    return hashMap;
}
module.exports["useFileHashes"] = $4cae511015088d55$export$f91c9e51e5ab027d;

});

parcelRegister("jQCJ9", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $8227eceacc56cecd$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $8227eceacc56cecd$export$5cae361ad82dce8b;

});

parcelRegister("9EfFC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dOMrE = parcelRequire("dOMrE");


var $i0btU = parcelRequire("i0btU");


var $4qXXo = parcelRequire("4qXXo");


var $l2474 = parcelRequire("l2474");


var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");


var $1DWH0 = parcelRequire("1DWH0");


var $28cxD = parcelRequire("28cxD");


var $bwC67 = parcelRequire("bwC67");


var $g6YCz = parcelRequire("g6YCz");

const $893da78086ca16ac$export$7452d7062a4d0634 = 1000;
const $893da78086ca16ac$export$af8124aa496797f2 = '_|unknown|_';
class $893da78086ca16ac$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $28cxD.UFOExperienceState)['STARTED'],
            (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC67.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$893da78086ca16ac$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $6mYMS.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dOMrE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4qXXo.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showTooltip
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g6YCz.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i0btU.default), null, showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: mentionComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l2474.default), {
            name: text
        }, mentionComponent)) : mentionComponent)));
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $893da78086ca16ac$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $6mYMS.MentionType).SELF;
            if ((0, $6mYMS.isRestricted)(accessLevel)) return (0, $6mYMS.MentionType).RESTRICTED;
            return (0, $6mYMS.MentionType).DEFAULT;
        };
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
const $893da78086ca16ac$var$MentionWithAnalytics = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($893da78086ca16ac$export$92ab8442e7a15cef);
const $893da78086ca16ac$var$Mention = $893da78086ca16ac$var$MentionWithAnalytics;
var $893da78086ca16ac$export$2e2bcd8739ae039 = $893da78086ca16ac$var$Mention;
module.exports["UNKNOWN_USER_ID"] = $893da78086ca16ac$export$af8124aa496797f2;
module.exports["default"] = $893da78086ca16ac$export$2e2bcd8739ae039;

});

parcelRegister("i0btU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bwC67 = parcelRequire("bwC67");

const $806263e9564ebacc$var$EMPTY = {};
const $806263e9564ebacc$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($806263e9564ebacc$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($806263e9564ebacc$var$EMPTY);
        (0, $bwC67.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $806263e9564ebacc$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $aXWIB.useIntl)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $806263e9564ebacc$export$2e2bcd8739ae039 = $806263e9564ebacc$var$MessagesIntlProvider;
module.exports["default"] = $806263e9564ebacc$export$2e2bcd8739ae039;

});

parcelRegister("bwC67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gjAAG = parcelRequire("gjAAG");

const $1cb8431546098045$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
const $1cb8431546098045$export$98e06fe7a6174253 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).unknownUserError);
const $1cb8431546098045$export$58bd5a2057b6b855 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessWarning);
const $1cb8431546098045$export$da9f8ce14593162f = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessLabel);
const $1cb8431546098045$export$4a258ffee7316766 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultHeadline);
const $1cb8431546098045$export$702321a50d74536e = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultAdvisedAction);
const $1cb8431546098045$export$ed7f16088a93ae9d = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).loginAgain);
const $1cb8431546098045$export$3ab158df56460d1c = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).differentText);































const $1cb8431546098045$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("iWyg2")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("1YvbX")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("czJia")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5twea")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("8wGCq")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("8ffMA")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("4ebsh")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("h0Nae")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("2rjCd")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("7wVzx")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("eYAzd")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dJ6Pi")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aMTu8")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("fB9vD")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("ctuC7")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("kAYXB")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("kszoB")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("diIb4")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("jOZnx")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("eD8co")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("dUGvg")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("e8vnv")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("dVKWy")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("4Jwts")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("dct7i")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("jEHCa")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("9677e")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lksJj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("1bipl")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("5FKXT")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $1cb8431546098045$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5twea")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $1cb8431546098045$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $1cb8431546098045$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $1cb8431546098045$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $1cb8431546098045$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $1cb8431546098045$export$702321a50d74536e;
module.exports["LoginAgain"] = $1cb8431546098045$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $1cb8431546098045$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $1cb8431546098045$export$d0a3169680473b6c;

});

parcelRegister("gjAAG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $898c0db98da1400a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $898c0db98da1400a$export$defe85febe8b728c;

});

parcelRegister("iWyg2", function(module, exports) {

let $dca837a70e1ba127$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dca837a70e1ba127$var$load("4Mixi"),
    $dca837a70e1ba127$var$load("1jsQH"),
    $dca837a70e1ba127$var$load("bv8GZ"),
    $dca837a70e1ba127$var$load("i9sd0"),
    $dca837a70e1ba127$var$load("i5eMd"),
    $dca837a70e1ba127$var$load("4DYJ5"),
    $dca837a70e1ba127$var$load("gyXEE"),
    $dca837a70e1ba127$var$load("hoPZ9")
]).then(()=>parcelRequire('6Yuab'));

});

parcelRegister("1YvbX", function(module, exports) {

let $17039717377e3cdf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17039717377e3cdf$var$load("cjveN"),
    $17039717377e3cdf$var$load("deyvi"),
    $17039717377e3cdf$var$load("cdeuH"),
    $17039717377e3cdf$var$load("aNg21"),
    $17039717377e3cdf$var$load("4UPfH"),
    $17039717377e3cdf$var$load("hfFxJ"),
    $17039717377e3cdf$var$load("1Mp9N"),
    $17039717377e3cdf$var$load("2Fu3d")
]).then(()=>parcelRequire('biDFC'));

});

parcelRegister("czJia", function(module, exports) {

let $927be2f6ddcd7086$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $927be2f6ddcd7086$var$load("8XGJb"),
    $927be2f6ddcd7086$var$load("6dERU"),
    $927be2f6ddcd7086$var$load("7gF8f"),
    $927be2f6ddcd7086$var$load("YEGhv"),
    $927be2f6ddcd7086$var$load("gd4qs"),
    $927be2f6ddcd7086$var$load("gofGr"),
    $927be2f6ddcd7086$var$load("dBb6q"),
    $927be2f6ddcd7086$var$load("eJgH8")
]).then(()=>parcelRequire('e7zr1'));

});

parcelRegister("5twea", function(module, exports) {

let $3fc8a8e755b35ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fc8a8e755b35ba7$var$load("2YffH").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("8wGCq", function(module, exports) {

let $63525f118eb34896$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63525f118eb34896$var$load("hdvZr"),
    $63525f118eb34896$var$load("kTurq"),
    $63525f118eb34896$var$load("djb49"),
    $63525f118eb34896$var$load("d8WL7"),
    $63525f118eb34896$var$load("fviv5"),
    $63525f118eb34896$var$load("2RQvP"),
    $63525f118eb34896$var$load("7Lkvk")
]).then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("8ffMA", function(module, exports) {

let $600bf78d50760720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $600bf78d50760720$var$load("4ViGN"),
    $600bf78d50760720$var$load("j0PWv"),
    $600bf78d50760720$var$load("ksTQ6"),
    $600bf78d50760720$var$load("j5F5K"),
    $600bf78d50760720$var$load("eBoC7"),
    $600bf78d50760720$var$load("7NpX8"),
    $600bf78d50760720$var$load("cukQS"),
    $600bf78d50760720$var$load("5FaEJ")
]).then(()=>parcelRequire('4FRcU'));

});

parcelRegister("4ebsh", function(module, exports) {

let $31415afcef6a6469$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $31415afcef6a6469$var$load("32vlK"),
    $31415afcef6a6469$var$load("dlmud"),
    $31415afcef6a6469$var$load("5CGnz"),
    $31415afcef6a6469$var$load("dXu4x"),
    $31415afcef6a6469$var$load("bNv64"),
    $31415afcef6a6469$var$load("bFU3Y"),
    $31415afcef6a6469$var$load("3CucM"),
    $31415afcef6a6469$var$load("9yemY")
]).then(()=>parcelRequire('bG4aH'));

});

parcelRegister("h0Nae", function(module, exports) {

let $c62892b55bb0439e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c62892b55bb0439e$var$load("7snhF"),
    $c62892b55bb0439e$var$load("X0Jic"),
    $c62892b55bb0439e$var$load("34YSq"),
    $c62892b55bb0439e$var$load("bAoKR"),
    $c62892b55bb0439e$var$load("5IaSN")
]).then(()=>parcelRequire('kVRsY'));

});

parcelRegister("2rjCd", function(module, exports) {

let $1c6d51973e42ac94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c6d51973e42ac94$var$load("bjoGV"),
    $1c6d51973e42ac94$var$load("cbkj0"),
    $1c6d51973e42ac94$var$load("9Oxgj"),
    $1c6d51973e42ac94$var$load("18TX5"),
    $1c6d51973e42ac94$var$load("4Afgd"),
    $1c6d51973e42ac94$var$load("exaJ2"),
    $1c6d51973e42ac94$var$load("lp8Wm"),
    $1c6d51973e42ac94$var$load("l2LZP")
]).then(()=>parcelRequire('FrZOj'));

});

parcelRegister("7wVzx", function(module, exports) {

let $57b82e2efe873583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57b82e2efe873583$var$load("8oiz7"),
    $57b82e2efe873583$var$load("17m16"),
    $57b82e2efe873583$var$load("kAg8V"),
    $57b82e2efe873583$var$load("9Cdzw"),
    $57b82e2efe873583$var$load("cMubu"),
    $57b82e2efe873583$var$load("hcCcg"),
    $57b82e2efe873583$var$load("cHWSM"),
    $57b82e2efe873583$var$load("35Ssm")
]).then(()=>parcelRequire('225Fx'));

});

parcelRegister("eYAzd", function(module, exports) {

let $ae7308bb98355904$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae7308bb98355904$var$load("hFxmj"),
    $ae7308bb98355904$var$load("b4NO6"),
    $ae7308bb98355904$var$load("fM2oh"),
    $ae7308bb98355904$var$load("guNAg"),
    $ae7308bb98355904$var$load("3fLE9"),
    $ae7308bb98355904$var$load("j9KTb"),
    $ae7308bb98355904$var$load("b37xN"),
    $ae7308bb98355904$var$load("ik6u5")
]).then(()=>parcelRequire('alG1N'));

});

parcelRegister("dJ6Pi", function(module, exports) {

let $9fe4c5e3bbeeb3c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fe4c5e3bbeeb3c3$var$load("fModo").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("aMTu8", function(module, exports) {

let $7da96d436e1303bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7da96d436e1303bd$var$load("BXOZB"),
    $7da96d436e1303bd$var$load("1K1Fj"),
    $7da96d436e1303bd$var$load("xnqy2"),
    $7da96d436e1303bd$var$load("cM3gY"),
    $7da96d436e1303bd$var$load("8hOn0"),
    $7da96d436e1303bd$var$load("3hjAq"),
    $7da96d436e1303bd$var$load("7PjNK"),
    $7da96d436e1303bd$var$load("Vt6S9")
]).then(()=>parcelRequire('gSUUF'));

});

parcelRegister("fB9vD", function(module, exports) {

let $b5b1b010e0d3f8ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b5b1b010e0d3f8ab$var$load("9Xiuh"),
    $b5b1b010e0d3f8ab$var$load("38sfA"),
    $b5b1b010e0d3f8ab$var$load("awkVi"),
    $b5b1b010e0d3f8ab$var$load("6yRq3"),
    $b5b1b010e0d3f8ab$var$load("h4OCL"),
    $b5b1b010e0d3f8ab$var$load("2bCHJ"),
    $b5b1b010e0d3f8ab$var$load("ktSfi"),
    $b5b1b010e0d3f8ab$var$load("9GZ76")
]).then(()=>parcelRequire('cF55v'));

});

parcelRegister("ctuC7", function(module, exports) {

let $914ff0bb8aa2c368$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $914ff0bb8aa2c368$var$load("7Odo3"),
    $914ff0bb8aa2c368$var$load("bjmre"),
    $914ff0bb8aa2c368$var$load("11DLa"),
    $914ff0bb8aa2c368$var$load("cft22"),
    $914ff0bb8aa2c368$var$load("bcQs2"),
    $914ff0bb8aa2c368$var$load("fdXnq"),
    $914ff0bb8aa2c368$var$load("iouLY"),
    $914ff0bb8aa2c368$var$load("4sOIV")
]).then(()=>parcelRequire('4IbNl'));

});

parcelRegister("kAYXB", function(module, exports) {

let $efe674e091118520$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $efe674e091118520$var$load("4VkvT"),
    $efe674e091118520$var$load("asvK9"),
    $efe674e091118520$var$load("barSq"),
    $efe674e091118520$var$load("gctEz"),
    $efe674e091118520$var$load("aBa7j"),
    $efe674e091118520$var$load("cItJR"),
    $efe674e091118520$var$load("hPZE5"),
    $efe674e091118520$var$load("QTjdE")
]).then(()=>parcelRequire('jKge3'));

});

parcelRegister("kszoB", function(module, exports) {

let $ee51e109396074e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee51e109396074e0$var$load("g5qJV"),
    $ee51e109396074e0$var$load("7v6wU"),
    $ee51e109396074e0$var$load("a8heY"),
    $ee51e109396074e0$var$load("9PPH7"),
    $ee51e109396074e0$var$load("b544F"),
    $ee51e109396074e0$var$load("SctKm"),
    $ee51e109396074e0$var$load("dzIm8"),
    $ee51e109396074e0$var$load("hrf1M")
]).then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("diIb4", function(module, exports) {

let $9aef399064f89ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9aef399064f89ced$var$load("dPa6p"),
    $9aef399064f89ced$var$load("aEpRh"),
    $9aef399064f89ced$var$load("6hlNE"),
    $9aef399064f89ced$var$load("1y1eN"),
    $9aef399064f89ced$var$load("K6fhx"),
    $9aef399064f89ced$var$load("1fJz1"),
    $9aef399064f89ced$var$load("jqwnR"),
    $9aef399064f89ced$var$load("lsloj")
]).then(()=>parcelRequire('d7PIu'));

});

parcelRegister("jOZnx", function(module, exports) {

let $e6e24c5da898ba6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e6e24c5da898ba6d$var$load("iG4uh"),
    $e6e24c5da898ba6d$var$load("3fuR9"),
    $e6e24c5da898ba6d$var$load("2bqSD"),
    $e6e24c5da898ba6d$var$load("e8jpx"),
    $e6e24c5da898ba6d$var$load("gZU54"),
    $e6e24c5da898ba6d$var$load("9yA8o"),
    $e6e24c5da898ba6d$var$load("bGhLc"),
    $e6e24c5da898ba6d$var$load("iRKhU")
]).then(()=>parcelRequire('jwd3r'));

});

parcelRegister("eD8co", function(module, exports) {

let $aa6b115a311b9fd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa6b115a311b9fd0$var$load("aGECO").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("dUGvg", function(module, exports) {

let $a21179997b16d6f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a21179997b16d6f7$var$load("bSjyK"),
    $a21179997b16d6f7$var$load("j6IGj"),
    $a21179997b16d6f7$var$load("6tWAg"),
    $a21179997b16d6f7$var$load("hlJc4"),
    $a21179997b16d6f7$var$load("aOdaf")
]).then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("e8vnv", function(module, exports) {

let $a4aa27148dad9d3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a4aa27148dad9d3a$var$load("9tVE8"),
    $a4aa27148dad9d3a$var$load("fMrUo"),
    $a4aa27148dad9d3a$var$load("bJykp"),
    $a4aa27148dad9d3a$var$load("fjbzp"),
    $a4aa27148dad9d3a$var$load("4Wdqb"),
    $a4aa27148dad9d3a$var$load("448N7"),
    $a4aa27148dad9d3a$var$load("9v6ER"),
    $a4aa27148dad9d3a$var$load("aEAsN")
]).then(()=>parcelRequire('fkCIe'));

});

parcelRegister("dVKWy", function(module, exports) {

let $a245033a20d44784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a245033a20d44784$var$load("5WkxF").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("4Jwts", function(module, exports) {

let $37248e16b030f0da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $37248e16b030f0da$var$load("6UAlo"),
    $37248e16b030f0da$var$load("9eNkX"),
    $37248e16b030f0da$var$load("dh2Er"),
    $37248e16b030f0da$var$load("1pFHs"),
    $37248e16b030f0da$var$load("k10Cs"),
    $37248e16b030f0da$var$load("gBDdh"),
    $37248e16b030f0da$var$load("8Mz40"),
    $37248e16b030f0da$var$load("l6YHr")
]).then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("dct7i", function(module, exports) {

let $99c2fb5138729985$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c2fb5138729985$var$load("l7PQP").then(()=>parcelRequire('bRxNE'));

});

parcelRegister("jEHCa", function(module, exports) {

let $e4f395b7fd009e5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4f395b7fd009e5c$var$load("9Yw4z"),
    $e4f395b7fd009e5c$var$load("h0uBE"),
    $e4f395b7fd009e5c$var$load("eBLgB"),
    $e4f395b7fd009e5c$var$load("d0Fxy"),
    $e4f395b7fd009e5c$var$load("1n8w9"),
    $e4f395b7fd009e5c$var$load("6NHX3"),
    $e4f395b7fd009e5c$var$load("77dzh")
]).then(()=>parcelRequire('4dnaM'));

});

parcelRegister("9677e", function(module, exports) {

let $69fa319b49dca515$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69fa319b49dca515$var$load("fLjHM").then(()=>parcelRequire('2qq54'));

});

parcelRegister("lksJj", function(module, exports) {

let $f871c05e7ad2e071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f871c05e7ad2e071$var$load("3YGga").then(()=>parcelRequire('7iyzo'));

});

parcelRegister("1bipl", function(module, exports) {

let $0dc518e78099ecb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0dc518e78099ecb1$var$load("ia9y3"),
    $0dc518e78099ecb1$var$load("j9OUx"),
    $0dc518e78099ecb1$var$load("bV8sS"),
    $0dc518e78099ecb1$var$load("kKXTS"),
    $0dc518e78099ecb1$var$load("l079e"),
    $0dc518e78099ecb1$var$load("ebljE"),
    $0dc518e78099ecb1$var$load("hF4v3"),
    $0dc518e78099ecb1$var$load("afU9w")
]).then(()=>parcelRequire('lRTsu'));

});

parcelRegister("5FKXT", function(module, exports) {

let $4215365dbe7d42c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4215365dbe7d42c4$var$load("15ncj"),
    $4215365dbe7d42c4$var$load("gDiIK"),
    $4215365dbe7d42c4$var$load("eLlpV"),
    $4215365dbe7d42c4$var$load("7sItg"),
    $4215365dbe7d42c4$var$load("f1B4n"),
    $4215365dbe7d42c4$var$load("j4dSZ"),
    $4215365dbe7d42c4$var$load("1Tuyb"),
    $4215365dbe7d42c4$var$load("7iCpI")
]).then(()=>parcelRequire('jKBtA'));

});

parcelRegister("4qXXo", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6mYMS = parcelRequire("6mYMS");


var $42omo = parcelRequire("42omo");

const $1278ab3a4b348f22$var$mentionStyle = {
    [(0, $6mYMS.MentionType).SELF]: {
        background: "var(--ds-background-brand-bold, #1868DB)",
        borderColor: 'transparent',
        text: "var(--ds-text-inverse, #FFFFFF)",
        hoveredBackground: "var(--ds-background-brand-bold-hovered, #1558BC)",
        pressedBackground: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    [(0, $6mYMS.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: "var(--ds-border-bold, #7D818A)",
        text: "var(--ds-text, #292A2E)",
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $6mYMS.MentionType).DEFAULT]: {
        background: "var(--ds-background-neutral, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-subtle, #505258)",
        hoveredBackground: "var(--ds-background-neutral-hovered, #0B120E24)",
        pressedBackground: "var(--ds-background-neutral-pressed, #080F214A)"
    }
};
const $1278ab3a4b348f22$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $1278ab3a4b348f22$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $1278ab3a4b348f22$var$PrimitiveMention = /*#__PURE__*/ (0, $42omo.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $1278ab3a4b348f22$export$2e2bcd8739ae039 = $1278ab3a4b348f22$var$PrimitiveMention;
module.exports["default"] = $1278ab3a4b348f22$export$2e2bcd8739ae039;

});

parcelRegister("l2474", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $d23df821b2d2d994$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gURmQ")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $d23df821b2d2d994$export$2e2bcd8739ae039 = $d23df821b2d2d994$var$AsyncNoAccessTooltip;
module.exports["default"] = $d23df821b2d2d994$export$2e2bcd8739ae039;

});

parcelRegister("gURmQ", function(module, exports) {

let $c50b45f90fc6d653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c50b45f90fc6d653$var$load("2lsX7").then(()=>parcelRequire('5zTqW'));

});

parcelRegister("g6YCz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $af19f55bb4052571$export$1d011e4240507c78 = new (0, $9801n.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
class $af19f55bb4052571$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        $af19f55bb4052571$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["mentionRenderedUfoExperience"] = $af19f55bb4052571$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $af19f55bb4052571$export$5ef1c2550074a375;

});

parcelRegister("9yt4X", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $huXH9 = parcelRequire("huXH9");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $087487947faf3e7f$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr"
};
const $087487947faf3e7f$var$Observer = ({ onLoad: onLoad })=>{
    (0, $42omo.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};

const $087487947faf3e7f$var$AutoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Jp34")));

const $087487947faf3e7f$var$AutoFixAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iXcnT")));

const $087487947faf3e7f$var$AutoReviewAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aUp1o")));

const $087487947faf3e7f$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3KJ0b")));

const $087487947faf3e7f$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eKuAc")));

const $087487947faf3e7f$var$CultureAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6kpkG")));

const $087487947faf3e7f$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Q4wY")));

const $087487947faf3e7f$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dRCU8")));

const $087487947faf3e7f$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kQTXK")));

const $087487947faf3e7f$var$GenericAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kFBSF")));

const $087487947faf3e7f$var$HireWriterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("44XTS")));

const $087487947faf3e7f$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2SnMt")));

const $087487947faf3e7f$var$MyUserManualAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cXu7g")));

const $087487947faf3e7f$var$OkrOracleAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3EvKg")));

const $087487947faf3e7f$var$OpsAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htmh0")));

const $087487947faf3e7f$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kTVse")));

const $087487947faf3e7f$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("emHN5")));

const $087487947faf3e7f$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9Oxg9")));

const $087487947faf3e7f$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("doqXm")));

const $087487947faf3e7f$var$RovoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k0SSx")));

const $087487947faf3e7f$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kVvzt")));

const $087487947faf3e7f$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Hx38")));

const $087487947faf3e7f$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3v9w9")));

const $087487947faf3e7f$var$TrialGuideAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("58iCo")));

const $087487947faf3e7f$var$JsmRovoServiceAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("df4F9"))); /**
                                      * OOTB Agents avatars - start
                                      */ 

const $087487947faf3e7f$var$AmplitudeAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cbUPK")));

const $087487947faf3e7f$var$BoxAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gGDJa")));

const $087487947faf3e7f$var$CanvaAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jmaDr")));

const $087487947faf3e7f$var$FigmaAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ajnZr")));

const $087487947faf3e7f$var$HubSpotAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iLrU0")));

const $087487947faf3e7f$var$IntercomAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("FA5RY")));

const $087487947faf3e7f$var$GammaAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jm9GH")));

const $087487947faf3e7f$var$LovableAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Hqsv")));

const $087487947faf3e7f$var$ReplitAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fKjEJ")));

const $087487947faf3e7f$var$RovoAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bHCOw"))); /**
                          * OOTB Agents avatars - end
                          */ 
const $087487947faf3e7f$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $087487947faf3e7f$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $087487947faf3e7f$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $087487947faf3e7f$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $087487947faf3e7f$var$colorList = [
    $087487947faf3e7f$export$cf7c9ad03f4a70b2,
    $087487947faf3e7f$export$3e344798f7855e62,
    $087487947faf3e7f$export$a3d0897f023251ae,
    $087487947faf3e7f$export$d933daaf7b69e6ee
]; /**
                                                                               * NOTE: DO NOT ADD OOTB AGENTAVATARS TO THIS LIST
                                                                               */ 
const $087487947faf3e7f$var$avatarList = [
    $087487947faf3e7f$var$CustomerInsightAvatar,
    $087487947faf3e7f$var$BacklogBuddyAvatar,
    $087487947faf3e7f$var$DecisionDirectorAvatar,
    $087487947faf3e7f$var$CommsCrafterAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$OkrOracleAvatar,
    $087487947faf3e7f$var$CultureAvatar,
    $087487947faf3e7f$var$SocialMediaScribeAvatar,
    $087487947faf3e7f$var$TeamConnectionAvatar,
    $087487947faf3e7f$var$HireWriterAvatar,
    $087487947faf3e7f$var$OpsAgentAvatar,
    $087487947faf3e7f$var$ResearchScoutAvatar,
    $087487947faf3e7f$var$ReleaseNotesAvatar,
    $087487947faf3e7f$var$MyUserManualAvatar,
    $087487947faf3e7f$var$PitchPerfectorAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$AutoFixAvatar,
    $087487947faf3e7f$var$AutoReviewAvatar,
    $087487947faf3e7f$var$MarketingMessageMaestroAvatar,
    $087487947faf3e7f$var$FeatureFlagAvatar,
    $087487947faf3e7f$var$ProductRequirementAvatar
];
const $087487947faf3e7f$export$a834793a4d0d739e = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
const $087487947faf3e7f$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoFixAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MarketingMessageMaestroAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ResearchScoutAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$HireWriterAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$SocialMediaScribeAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$FeatureFlagAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$DecisionDirectorAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ProductRequirementAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$BacklogBuddyAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_workflow_builder_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$WorkflowBuilderAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoReviewAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_trial_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$TrialGuideAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    jsm_rovo_service_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$JsmRovoServiceAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    mcp_amplitude_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AmplitudeAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_box_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$BoxAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_canva_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$CanvaAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_figma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$FigmaAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_hubspot_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$HubSpotAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_intercom_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$IntercomAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_gamma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$GammaAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_lovable_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$LovableAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_replit_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ReplitAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    rovo_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    }
}; /**
    * agentIdentityAccountId examples:
    * 5b985e7c96cb052b5f65c830
    * 712020:19e57f67-c132-462b-8503-0c19953122cd
    *
    * agentId examples:
    * cd002f25-46e4-4023-80ff-32e4d90849b4
    */ 
const $087487947faf3e7f$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $087487947faf3e7f$var$ROVO_DEV_AGENT_ID = '027f0676-e8e9-4939-8962-3850987d78bb';
const $087487947faf3e7f$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, size: size })=>{
    if (isRovoDev && (0, $dh538.fg)('rovo_dev_themed_identity_card')) return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoDevAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    };
     //@TODO CRCS-3129: Remove Rovo Dev hardcoded icon after TeamEU demos
    // Handle Rovo Dev agent avatar for TeamEU Demo
    if (agentId === $087487947faf3e7f$var$ROVO_DEV_AGENT_ID && (0, $dh538.fg)('jira_ai_force_rovo_dev_avatar')) return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoDevAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    };
    if (typeof agentNamedId === 'string' && $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $087487947faf3e7f$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $087487947faf3e7f$var$colorList.length);
        const colorIndex = combinationIndex % $087487947faf3e7f$var$colorList.length;
        const Avatar = $087487947faf3e7f$var$avatarList[avatarIndex];
        const color = $087487947faf3e7f$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, $l998X.jsx)(Avatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$GenericAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
            secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
        }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    };
};
const $087487947faf3e7f$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $087487947faf3e7f$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($087487947faf3e7f$var$styles.banner, fillSpace ? $087487947faf3e7f$var$styles.bannerFillSpace : undefined),
        style: {
            backgroundColor: color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $087487947faf3e7f$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $087487947faf3e7f$var$getAvatarRender(props);
    const { onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $087487947faf3e7f$var$styles.image,
        style: {
            backgroundColor: color.primary
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Suspense), {
            fallback: null,
            children: [
                onLoad && /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$Observer, {
                    onLoad: onLoad
                }),
                render
            ]
        })
    });
};
module.exports["AgentBanner"] = $087487947faf3e7f$export$6efaefb8ad2fba40;
module.exports["GeneratedAvatar"] = $087487947faf3e7f$export$96bb253b7de22616;

});

parcelRegister("1Jp34", function(module, exports) {

let $142d6c869fc93f1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $142d6c869fc93f1c$var$load("c9Qqc").then(()=>parcelRequire('f0XYo'));

});

parcelRegister("iXcnT", function(module, exports) {

let $dcc757fb35de9e43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcc757fb35de9e43$var$load("1TK6P").then(()=>parcelRequire('kdo1N'));

});

parcelRegister("aUp1o", function(module, exports) {

let $7f128b1159aaf0b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f128b1159aaf0b3$var$load("grvAy").then(()=>parcelRequire('1xsEe'));

});

parcelRegister("3KJ0b", function(module, exports) {

let $2bb8937090f7886d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bb8937090f7886d$var$load("23K0q").then(()=>parcelRequire('iOx72'));

});

parcelRegister("eKuAc", function(module, exports) {

let $abcd15b4f7a895b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abcd15b4f7a895b0$var$load("3kQkj").then(()=>parcelRequire('5yA7f'));

});

parcelRegister("6kpkG", function(module, exports) {

let $49b842e0f53b0840$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49b842e0f53b0840$var$load("6OXgE").then(()=>parcelRequire('40gXx'));

});

parcelRegister("1Q4wY", function(module, exports) {

let $156e297d03d850f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $156e297d03d850f4$var$load("cbucA").then(()=>parcelRequire('e6WCz'));

});

parcelRegister("dRCU8", function(module, exports) {

let $a17e67305e32e080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a17e67305e32e080$var$load("bVhr1").then(()=>parcelRequire('b4yf3'));

});

parcelRegister("kQTXK", function(module, exports) {

let $f2e41300efb7f39f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2e41300efb7f39f$var$load("kE0QC").then(()=>parcelRequire('lRRwN'));

});

parcelRegister("kFBSF", function(module, exports) {

let $f0c5054f72bf4788$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0c5054f72bf4788$var$load("eVFXf").then(()=>parcelRequire('xXksI'));

});

parcelRegister("44XTS", function(module, exports) {

let $2f86000f50552006$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f86000f50552006$var$load("9FhBz").then(()=>parcelRequire('gHjiO'));

});

parcelRegister("2SnMt", function(module, exports) {

let $21831245fa81e40e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21831245fa81e40e$var$load("6zB8z").then(()=>parcelRequire('9sJzD'));

});

parcelRegister("cXu7g", function(module, exports) {

let $96f25b251372ce30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96f25b251372ce30$var$load("eENGY").then(()=>parcelRequire('cxxnV'));

});

parcelRegister("3EvKg", function(module, exports) {

let $2a8dbb6f12744413$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a8dbb6f12744413$var$load("hmlb0").then(()=>parcelRequire('8nSrm'));

});

parcelRegister("htmh0", function(module, exports) {

let $cb866c206a5b0b04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb866c206a5b0b04$var$load("2NGxc").then(()=>parcelRequire('hGaQU'));

});

parcelRegister("kTVse", function(module, exports) {

let $f37582f3db40c2c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f37582f3db40c2c1$var$load("bPgcq").then(()=>parcelRequire('4zXPl'));

});

parcelRegister("emHN5", function(module, exports) {

let $a75516b19f472f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a75516b19f472f5d$var$load("31b1q").then(()=>parcelRequire('1xC4V'));

});

parcelRegister("9Oxg9", function(module, exports) {

let $725295393c538ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $725295393c538ed1$var$load("8Lh9U").then(()=>parcelRequire('kqZOw'));

});

parcelRegister("doqXm", function(module, exports) {

let $9c026d43c7a38bfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c026d43c7a38bfd$var$load("6ZzYJ").then(()=>parcelRequire('bZPun'));

});

parcelRegister("k0SSx", function(module, exports) {

let $e91e6080a2f1e543$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e91e6080a2f1e543$var$load("2zIbn").then(()=>parcelRequire('bXyC6'));

});

parcelRegister("kVvzt", function(module, exports) {

let $f3c19ee75daa2848$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3c19ee75daa2848$var$load("410SS").then(()=>parcelRequire('aY5Ef'));

});

parcelRegister("2Hx38", function(module, exports) {

let $1f793be472254651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f793be472254651$var$load("z3s9q").then(()=>parcelRequire('9mYoH'));

});

parcelRegister("3v9w9", function(module, exports) {

let $28cba65833e09a5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28cba65833e09a5e$var$load("9gqcE").then(()=>parcelRequire('3hbTz'));

});

parcelRegister("58iCo", function(module, exports) {

let $3bcc244b8daf70af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3bcc244b8daf70af$var$load("eipnW").then(()=>parcelRequire('3AA8L'));

});

parcelRegister("df4F9", function(module, exports) {

let $9a404af99aaca7d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a404af99aaca7d7$var$load("jdAk9").then(()=>parcelRequire('bqzK1'));

});

parcelRegister("cbUPK", function(module, exports) {

let $8e029916cb1e3744$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e029916cb1e3744$var$load("fbike").then(()=>parcelRequire('GyvF7'));

});

parcelRegister("gGDJa", function(module, exports) {

let $c25f62a14bcce2dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c25f62a14bcce2dc$var$load("4n4TY").then(()=>parcelRequire('UImUr'));

});

parcelRegister("jmaDr", function(module, exports) {

let $e178525485a33ea1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e178525485a33ea1$var$load("2aX2w").then(()=>parcelRequire('6EXWp'));

});

parcelRegister("ajnZr", function(module, exports) {

let $781e49aade0ad5b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $781e49aade0ad5b2$var$load("dWdGk").then(()=>parcelRequire('bE44a'));

});

parcelRegister("iLrU0", function(module, exports) {

let $da92429d11cff6c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da92429d11cff6c5$var$load("hQhwm").then(()=>parcelRequire('3wBah'));

});

parcelRegister("FA5RY", function(module, exports) {

let $07cfd3e6c0d3435a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07cfd3e6c0d3435a$var$load("7VfH7").then(()=>parcelRequire('5WMJM'));

});

parcelRegister("jm9GH", function(module, exports) {

let $e1779632453b15d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e1779632453b15d8$var$load("aJ4jy").then(()=>parcelRequire('bPhHP'));

});

parcelRegister("2Hqsv", function(module, exports) {

let $1f741f18d9a21a24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f741f18d9a21a24$var$load("4AOh0").then(()=>parcelRequire('6z9xT'));

});

parcelRegister("fKjEJ", function(module, exports) {

let $b76a6629f8d79b96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b76a6629f8d79b96$var$load("i87P0").then(()=>parcelRequire('cP8YK'));

});

parcelRegister("bHCOw", function(module, exports) {

let $8851d178ad87e908$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8851d178ad87e908$var$load("aLqH7").then(()=>parcelRequire('iA7sC'));

});

parcelRegister("hezkK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $huXH9 = parcelRequire("huXH9");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9yt4X = parcelRequire("9yt4X");


var $4Ve7Q = parcelRequire("4Ve7Q");

const $4efd70df50f13ebd$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $4efd70df50f13ebd$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $4efd70df50f13ebd$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $4efd70df50f13ebd$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "aria-label": label,
        xcss: $4efd70df50f13ebd$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $dh538.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $huXH9.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $huXH9.AVATAR_SIZES)[size]
            } : {}
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $4efd70df50f13ebd$var$stylesCompiled.innerShape
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $4efd70df50f13ebd$var$styles.avatarContentContainer,
                children: imgUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "img",
                    xcss: $4efd70df50f13ebd$var$styles.image,
                    src: imgUrl,
                    alt: name || label || formatMessage((0, $4Ve7Q.messages).agentAvatarLabel)
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9yt4X.GeneratedAvatar), {
                    agentId: agentId,
                    agentNamedId: agentNamedId,
                    agentIdentityAccountId: agentIdentityAccountId,
                    isRovoDev: isRovoDev,
                    size: size
                })
            })
        })
    });
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $4efd70df50f13ebd$export$2f5dfaa7873e8973;
module.exports["AgentAvatar"] = $4efd70df50f13ebd$export$38b71b080e1832c8;

});

parcelRegister("4Ve7Q", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c1395595ab243cbd$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    agentAvatarLabel: {
        id: "ai-mate.agent-avatar-label",
        defaultMessage: "Agent avatar"
    }
});
module.exports["messages"] = $c1395595ab243cbd$export$defe85febe8b728c;

});

parcelRegister("jMZdB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $d8ohW = parcelRequire("d8ohW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");


var $3h2i4 = parcelRequire("3h2i4");


var $lBFuf = parcelRequire("lBFuf");


var $gMCDH = parcelRequire("gMCDH");

const $1694d7942d86318a$var$styles = {
    conversationStartersList: "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
    conversationStarterIcon: "_1o9zidpf",
    conversationStarterText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1o9zkb7n _1ul9idpf",
    button: "_11c8fhey _2rko12b0 _syazazsu _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _1bsb1osq _bfhksm61 _irr31dpa _1di6fcek"
};
const $1694d7942d86318a$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const type = 'static';
    const customAgentConversationStarters = [
        {
            message: (0, $gMCDH.messages).agentEmptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $gMCDH.messages).agentEmptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $gMCDH.messages).agentEmptyStateSuggestion3,
            type: type
        }
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        {
            message: (0, $gMCDH.messages).emptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $gMCDH.messages).emptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $gMCDH.messages).emptyStateSuggestion3,
            type: type
        }
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return user defined suggestions + static fallback suggestions with a max of 3 suggestions (user defined taking precendence over fallback)
        return [
            ...userDefinedConversationStarters,
            ...customAgentConversationStarters
        ].slice(0, 3);
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $1694d7942d86318a$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $42omo.useMemo)(()=>$1694d7942d86318a$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $42omo.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                message: starter.message,
                type: starter.type
            } : {
                message: formatMessage(starter.message),
                type: starter.type
            }), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1694d7942d86318a$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $1694d7942d86318a$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        as: "ul",
        space: "space.050",
        xcss: $1694d7942d86318a$var$styles.conversationStartersList,
        children: [
            starters.map((starter, index)=>{
                const isLastStarter = index === starters.length - 1;
                const chatPill = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "li",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        xcss: $1694d7942d86318a$var$styles.button,
                        onClick: ()=>onConversationStarterClick(starter),
                        testId: "conversation-starter",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.150",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $1694d7942d86318a$var$styles.conversationStarterIcon,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3h2i4.AgentChatIcon), {})
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $1694d7942d86318a$var$styles.conversationStarterText,
                                    children: starter.message
                                })
                            ]
                        })
                    })
                }, starter.message);
                return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.050",
                    grow: "fill",
                    alignInline: "end",
                    children: [
                        chatPill,
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
                            onClick: onReloadButtonClick,
                            appearance: "subtle",
                            label: ""
                        })
                    ]
                }, starter.message) : chatPill;
            }),
            !!onBrowseAgentsClick && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "li",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.BrowseAgentsPill), {
                    onClick: onBrowseAgentsClick
                })
            })
        ]
    });
};
module.exports["getConversationStarters"] = $1694d7942d86318a$export$c2d882153e0984c5;
module.exports["AgentConversationStarters"] = $1694d7942d86318a$export$171adfc74aa509c3;

});

parcelRegister("3h2i4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cOQz3 = parcelRequire("cOQz3");


var $1s5hv = parcelRequire("1s5hv");

const $ea5bd56cfe7af0a8$var$styles = {
    agentChatIcon: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsbzwfg _4t3izwfg"
};
const $ea5bd56cfe7af0a8$export$f33bbc5f5534c8a4 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $ea5bd56cfe7af0a8$var$styles.agentChatIcon,
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
            label: "",
            color: "var(--ds-icon-subtlest, #6B6E76)"
        })
    });
};
module.exports["AgentChatIcon"] = $ea5bd56cfe7af0a8$export$f33bbc5f5534c8a4;

});

parcelRegister("gMCDH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $e1133cfae3bfd440$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emptyStateSuggestion1: {
        id: "ai-mate.chat-history.empty-state.suggestion1",
        defaultMessage: "Are any of my tickets overdue?"
    },
    emptyStateSuggestion2: {
        id: "ai-mate.chat-history.empty-state.suggestion2",
        defaultMessage: "What should I work on next?"
    },
    emptyStateSuggestion3: {
        id: "ai-mate.chat-history.empty-state.suggestion3",
        defaultMessage: "Write an update about my week"
    },
    agentEmptyStateSuggestion1: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion1",
        defaultMessage: "Tell me about yourself"
    },
    agentEmptyStateSuggestion2: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion2",
        defaultMessage: "What can you help me with?"
    },
    agentEmptyStateSuggestion3: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion3",
        defaultMessage: "Summarize what I'm looking at"
    }
});
module.exports["messages"] = $e1133cfae3bfd440$export$defe85febe8b728c;

});

parcelRegister("kSoKM", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $aFUXX = parcelRequire("aFUXX");

function $095aa81eb4c35edf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $095aa81eb4c35edf$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    }
});
const $095aa81eb4c35edf$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: ()=>expanded ? [
                $095aa81eb4c35edf$var$expandIconWrapperStyle(),
                $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle
            ] : $095aa81eb4c35edf$var$expandIconWrapperStyle()
    }, children);
};
const $095aa81eb4c35edf$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`
        }
    });
const $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $095aa81eb4c35edf$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $095aa81eb4c35edf$export$c67faf67c1185cba = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $095aa81eb4c35edf$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $095aa81eb4c35edf$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $095aa81eb4c35edf$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $095aa81eb4c35edf$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $095aa81eb4c35edf$export$c67faf67c1185cba;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("7bZ3i", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $99uSl = parcelRequire("99uSl");


var $lgmus = parcelRequire("lgmus");


var $6q0AE = parcelRequire("6q0AE");


var $79vw2 = parcelRequire("79vw2");


var $dE3t3 = parcelRequire("dE3t3");


var $eIleF = parcelRequire("eIleF");


var $k00oi = parcelRequire("k00oi");

function $4cf4ff4aa0c52ddf$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions }) {
    const parentContext = (0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    const defaultInitialState = (0, $42omo.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $42omo.useMemo)(()=>{
        return (0, $99uSl.createStore)((0, $dE3t3.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>{
        const client = customClient || new (0, $k00oi.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, // @deprecated The support for platform will be removed and default to `web`
        _platform)=>{
            const cardState = (0, $6q0AE.getUrl)(store, url);
            return cardState.details ? (0, $79vw2.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        store
    ]);
    const value = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $4cf4ff4aa0c52ddf$export$2e2bcd8739ae039 = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;
module.exports["SmartCardProvider"] = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;

});

parcelRegister("dE3t3", function(module, exports) {

var $9gPkz = parcelRequire("9gPkz");

var $btw9C = parcelRequire("btw9C");

const $93945b5bac9d9f43$var$isCardAction = (action)=>{
    return [
        (0, $9gPkz.ACTION_PENDING),
        (0, $9gPkz.ACTION_RESOLVING),
        (0, $9gPkz.ACTION_RESOLVED),
        (0, $9gPkz.ACTION_RELOADING),
        (0, $9gPkz.ACTION_ERROR),
        (0, $9gPkz.ACTION_ERROR_FALLBACK),
        (0, $9gPkz.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $93945b5bac9d9f43$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $btw9C.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $93945b5bac9d9f43$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $9gPkz.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVED:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $9gPkz.ACTION_RELOADING:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $9gPkz.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $9gPkz.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $9gPkz.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $93945b5bac9d9f43$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$93945b5bac9d9f43$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $93945b5bac9d9f43$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};
module.exports["cardReducer"] = $93945b5bac9d9f43$export$3c7c3113a97b6492;

});

parcelRegister("jQRRW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $5pS3b = parcelRequire("5pS3b");

const $221a2b03be5b44a4$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5pS3b.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withIntlProvider"] = $221a2b03be5b44a4$export$a5d940130f33be3f;

});

parcelRegister("5pS3b", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $aXWIB = parcelRequire("aXWIB");


var $ewi8o = parcelRequire("ewi8o");

function $b2d267b4c02f41c6$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $aXWIB.useIntl)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $b2d267b4c02f41c6$export$480518999dfc4151(props) {
    const { locale: locale } = $b2d267b4c02f41c6$var$useFetchLocale();
    const messages = (0, $ewi8o.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}
module.exports["IntlProvider"] = $b2d267b4c02f41c6$export$480518999dfc4151;

});

parcelRegister("ewi8o", function(module, exports) {

var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");

const $9f428f426036dbfa$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $42omo.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};
module.exports["useIntlMessages"] = $9f428f426036dbfa$export$2641ec9a2025a81f;

});

parcelRegister("9QvUi", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $NT2w1 = parcelRequire("NT2w1");


var $2mPpz = parcelRequire("2mPpz");


var $eXPKf = parcelRequire("eXPKf");


var $42omo = parcelRequire("42omo");


var $2xYsH = parcelRequire("2xYsH");


var $hnA4H = parcelRequire("hnA4H");

const $13bb23ac78effffb$var$STABLE_OBJECT = {};
const $13bb23ac78effffb$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $42omo.useMemo)(()=>(0, $2mPpz.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $4H1Ql.useStableObject)(placementProps ?? $13bb23ac78effffb$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $NT2w1.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2xYsH.default), {
                    analyticsChannel: (0, $hnA4H.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $13bb23ac78effffb$var$PlacementMemoized = /*#__PURE__*/ (0, $42omo.memo)($13bb23ac78effffb$var$Placement);
var $13bb23ac78effffb$export$2e2bcd8739ae039 = $13bb23ac78effffb$var$PlacementMemoized;
module.exports["default"] = $13bb23ac78effffb$export$2e2bcd8739ae039;

});

parcelRegister("NT2w1", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $PAiZW = parcelRequire("PAiZW");

var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $3NyPa = parcelRequire("3NyPa");


var $kO3gu = parcelRequire("kO3gu");


var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $dE7qQ = parcelRequire("dE7qQ");


var $5dPMD = parcelRequire("5dPMD");


var $dug7n = parcelRequire("dug7n");


var $feexy = parcelRequire("feexy");


var $9x4nt = parcelRequire("9x4nt");


var $dh538 = parcelRequire("dh538");

const $80ab3a0c2f45d583$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    return (0, $42omo.useMemo)(()=>disableInitialData ? undefined : (0, $5dPMD.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $80ab3a0c2f45d583$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $80ab3a0c2f45d583$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $80ab3a0c2f45d583$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $4u5NT.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $4u5NT.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $80ab3a0c2f45d583$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dug7n.useBuildBasePath)();
    const stableContextWithRoute = (0, $4H1Ql.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $42omo.useMemo)(()=>isUFOEnabled ? new (0, $3NyPa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $42omo.useContext)((0, $feexy.default));
    const ufoV2InteractionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const stableUfoV2Interaction = (0, $4H1Ql.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $42omo.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    if ((0, $dh538.fg)('post-office_enable_ufo-v2-add-error')) $80ab3a0c2f45d583$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $80ab3a0c2f45d583$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $42omo.useMemo)(()=>({
            source: (0, $dE7qQ.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $80ab3a0c2f45d583$export$2e2bcd8739ae039 = $80ab3a0c2f45d583$var$Placement;
module.exports["default"] = $80ab3a0c2f45d583$export$2e2bcd8739ae039;

});

parcelRegister("dE7qQ", function(module, exports) {
const $2d2adb07a8ea6d4a$export$85183a312807388d = 'postOffice';
const $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6;

});

parcelRegister("dug7n", function(module, exports) {

var $bnKhH = parcelRequire("bnKhH");

var $c3xd8 = parcelRequire("c3xd8");


var $42omo = parcelRequire("42omo");

const $f2f503b4228c54ff$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $c3xd8.usePostOfficeEnvironment)();
    return (0, $42omo.useMemo)(()=>(0, $bnKhH.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $f2f503b4228c54ff$export$83d6c58b7ab7ae67;

});

parcelRegister("2xYsH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $42omo = parcelRequire("42omo");

class $1916333c8b5a116e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $1916333c8b5a116e$var$ErrorBoundaryWithAnalytics = (0, $1DWH0.default)()($1916333c8b5a116e$var$ErrorBoundary);
var $1916333c8b5a116e$export$2e2bcd8739ae039 = $1916333c8b5a116e$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $1916333c8b5a116e$export$2e2bcd8739ae039;

});

parcelRegister("hnA4H", function(module, exports) {
const $f3b0e253e752d4df$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $f3b0e253e752d4df$export$85183a312807388d;

});

parcelRegister("9oJIg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kO3gu = parcelRequire("kO3gu");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO3gu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card?.id === rec?.content?.id);
        pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $dh538.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage
        }
    });
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            }
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            }
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        }
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $dM0Qh = parcelRequire("dM0Qh");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $1LZHF = parcelRequire("1LZHF");

var $a5Dk4 = parcelRequire("a5Dk4");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $a2xFu.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $eB56w.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $a5Dk4.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iH7AG.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $dM0Qh.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lb1Mg.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1LZHF.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("1LZHF", function(module, exports) {

var $gFQkO = parcelRequire("gFQkO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/slide/manifest.ts
var $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $gFQkO.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $gFQkO.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $14aa0b35cfffabf8$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $14aa0b35cfffabf8$export$86048ac46024146a;

});

parcelRegister("gFQkO", function(module, exports) {
// src/confluence/slide/types.ts
var $c23912470bd9b644$export$204fa7edd529d4b3 = "confluence", $c23912470bd9b644$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $c23912470bd9b644$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $c23912470bd9b644$export$3de52c55a164daa4;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $T1bCI.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("hjygH", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("dYcT6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $601vk = parcelRequire("601vk");

const $2e3f617799d734b5$var$EditorFlagsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    showEditorFlag: ()=>{}
});
const $2e3f617799d734b5$export$ad7226c60a7baa4f = ({ contentId: contentId, children: children })=>{
    const [flag, setFlag] = (0, $42omo.useState)(undefined);
    const showEditorFlag = (0, $42omo.useCallback)((flagData)=>{
        setFlag(flagData);
    }, [
        setFlag
    ]);
    // memoize to return the same reference to object and prevent render of multiple error flag with the same message
    const errorData = (0, $42omo.useMemo)(()=>flag?.errorName ? {
            [flag.errorName]: true
        } : undefined, [
        flag
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>{
        return {
            showEditorFlag: showEditorFlag
        };
    }, [
        showEditorFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e3f617799d734b5$var$EditorFlagsContext.Provider, {
        value: contextValue
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $601vk.EditorErrorFlags), {
        contentId: contentId,
        statusCode: flag?.statusCode,
        errorData: errorData,
        lastPublisher: flag?.lastPublisher,
        collabService: flag?.collabService,
        isUnpublishedDraft: flag?.isUnpublishedDraft
    }));
};
function $2e3f617799d734b5$export$5368f855bc23a165(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e3f617799d734b5$export$ad7226c60a7baa4f, {
            contentId: props.contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
}
const $2e3f617799d734b5$export$32aceb9a79692418 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($2e3f617799d734b5$var$EditorFlagsContext);
};
module.exports["withEditorFlagsContext"] = $2e3f617799d734b5$export$5368f855bc23a165;
module.exports["useEditorFlagsContext"] = $2e3f617799d734b5$export$32aceb9a79692418;

});

parcelRegister("601vk", function(module, exports) {

var $f2yKj = parcelRequire("f2yKj");


var $kw3pa = parcelRequire("kw3pa");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $kyKWe = parcelRequire("kyKWe");


var $inPa6 = parcelRequire("inPa6");


var $ep3mz = parcelRequire("ep3mz");


var $7aRa9 = parcelRequire("7aRa9");


var $b3j2Y = parcelRequire("b3j2Y");


var $3jwuS = parcelRequire("3jwuS");


var $03Xmw = parcelRequire("03Xmw");


var $fb79u = parcelRequire("fb79u");


var $6jB9o = parcelRequire("6jB9o");


var $1mHQU = parcelRequire("1mHQU");


var $cHfGW = parcelRequire("cHfGW");


var $gQojb = parcelRequire("gQojb");


var $jMyy4 = parcelRequire("jMyy4");

const $5f7518f04afd0b6f$export$8f60114e4ef36b27 = (0, $aXWIB.injectIntl)(({ flags: flags, nextTryIn: nextTryIn, statusCode: statusCode, flagData: flagData, errorData: errorData, intl: { formatMessage: formatMessage }, lastPublisher: lastPublisher, parentPageId: parentPageId, collabService: collabService, isUnpublishedDraft: isUnpublishedDraft })=>{
    const [{ contentSlug: contentSlug, contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { triggerPageConflictAnalytics: triggerPageConflictAnalytics } = (0, $gQojb.usePageConflictAnalytics)({
        contentId: contentId,
        contentType: contentType,
        collabService: collabService,
        source: 'EditorFlags',
        actionSubjectId: 'editor.flag'
    });
    const userInfoQueryResult = (0, $jMyy4.useQueryInterop)((0, $kw3pa.default), {
        variables: {
            accountId: lastPublisher || ''
        },
        // only make this query if the lastPublisher is defined and it is a publish/restore flag
        skip: !lastPublisher || !errorData || !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] && !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE]
    });
    // only make this query if the parentPageId is NOT defined and we have an error where we want link to the parent page
    const ancestorQuerySkipped = Boolean(parentPageId) || !contentId || !errorData || !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED];
    const ancestorQueryResult = (0, $jMyy4.useQueryInterop)((0, $f2yKj.default), {
        variables: {
            contentId: contentId
        },
        skip: ancestorQuerySkipped
    });
    const [actualParentPageId, setActualParentPageId] = (0, $42omo.useState)(parentPageId);
    (0, $42omo.useEffect)(()=>{
        // when done loading, set to the parentId that was found, or "" if not found
        if (!ancestorQuerySkipped && !ancestorQueryResult.loading) setActualParentPageId(ancestorQueryResult.data?.content?.nodes?.[0]?.ancestors?.slice(-1)[0]?.id || parentPageId || '');
    }, [
        parentPageId,
        ancestorQueryResult,
        ancestorQuerySkipped
    ]);
    // Cleanup on component unmount
    (0, $42omo.useEffect)(()=>()=>void flags.hideAllFlags(), [
        flags
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] || errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE] || errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED] && actualParentPageId === undefined) && !flagData) {
            const flagContent = (0, $cHfGW.buildEditorFlagMessage)({
                errorData: errorData,
                spaceKey: spaceKey,
                statusCode: statusCode,
                formatMessage: formatMessage,
                nextTryIn: nextTryIn,
                parentPageId: actualParentPageId,
                isUnpublishedDraft: isUnpublishedDraft,
                isLivePage: isLivePage
            });
            if (flagContent) {
                const flagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                flags.showErrorFlag({
                    id: flagId,
                    title: flagContent.title,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $03Xmw.FlagDescription), {
                        flags: flags,
                        flagContent: flagContent,
                        flagId: flagId,
                        nextTryIn: nextTryIn
                    })
                });
                if (statusCode === 409) triggerPageConflictAnalytics(Object.keys(errorData ?? {}).filter((k)=>k.startsWith('com.atlassian.confluence.api.service.exceptions.ecosystem.ConflictException')), {});
            } else // If there is no errorData the value of flagProps is null
            // Clear the existing flags
            flags.hideAllFlags();
        }
    }, [
        isUnpublishedDraft,
        flags,
        flagData,
        nextTryIn,
        spaceKey,
        statusCode,
        errorData,
        lastPublisher,
        actualParentPageId,
        contentId,
        formatMessage,
        triggerPageConflictAnalytics,
        isLivePage
    ]);
    const showInfoFlag = (0, $42omo.useCallback)(()=>{
        const attributes = {
            contentType: contentType,
            spaceKey: spaceKey,
            contentId: contentId,
            contentSlug: contentSlug
        };
        return (0, $fb79u.initializeInfoFlag)(flags, formatMessage, attributes, isLivePage);
    }, // Subscribe returns a new flag object each rerender causing infinite rerendering when displaying a publish flag,
    // so we are excluding it from the dep array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (errorData && (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] || errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE])) showInfoFlag()(userInfoQueryResult, {
            ...errorData
        });
    }, [
        userInfoQueryResult,
        errorData,
        showInfoFlag
    ]);
    const showSuccessFlag = (0, $42omo.useCallback)(()=>{
        const attributes = {
            contentType: contentType,
            spaceKey: spaceKey,
            contentId: contentId,
            contentSlug: contentSlug
        };
        (0, $6jB9o.initializeSuccessFlag)(flags, formatMessage, {
            attributes: attributes,
            flagData: flagData
        }, createAnalyticsEvent);
    // Subscribe returns a new flag object each rerender causing infinite re-rendering,
    // so we are excluding it from the dep array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formatMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (flagData) showSuccessFlag();
    }, [
        flagData,
        showSuccessFlag
    ]);
    return ancestorQueryResult?.error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: ancestorQueryResult.error
    }) : null;
});
const $5f7518f04afd0b6f$export$7220a8ff64533d72 = (0, $7aRa9.withFlags)($5f7518f04afd0b6f$export$8f60114e4ef36b27);
module.exports["EditorFlags"] = $5f7518f04afd0b6f$export$8f60114e4ef36b27;
module.exports["EditorErrorFlags"] = $5f7518f04afd0b6f$export$7220a8ff64533d72;

});

parcelRegister("f2yKj", function(module, exports) {
/**
 * @generated SignedSource<<aa1bfe3c9da32749e128f79f1585582c>>
 * @relayHash 143c98ff018aa1ff4230e9a1e86632ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c3139736436d5ee28a33804f3e80416357bad9c4b98c269648f2b81dd964f39a
const $2292f9aa8bd88324$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorFlagsContentAncestorsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorFlagsContentAncestorsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "143c98ff018aa1ff4230e9a1e86632ca",
            "id": "c3139736436d5ee28a33804f3e80416357bad9c4b98c269648f2b81dd964f39a",
            "metadata": {},
            "name": "EditorFlagsContentAncestorsQuery",
            "operationKind": "query",
            "text": "query EditorFlagsContentAncestorsQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,ancestors{id}}}}"
        }
    };
}();
$2292f9aa8bd88324$var$node.hash = "dae699d39d7456c23f9c77a8e35347ba";
var $2292f9aa8bd88324$export$2e2bcd8739ae039 = $2292f9aa8bd88324$var$node;
module.exports["default"] = $2292f9aa8bd88324$export$2e2bcd8739ae039;

});

parcelRegister("kw3pa", function(module, exports) {
/**
 * @generated SignedSource<<b8f4fb84cc06908e7a03c5ff3a1b33b7>>
 * @relayHash 633f8580ff29ac0eef5aabbd01aa2025
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04b103c3fd8e6dd3187db1fe66459b8fdab4878d85ace24413ec2d1f946efb9f
const $4b4bf52c95a16bda$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorFlagsUserPersonalInformationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorFlagsUserPersonalInformationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "633f8580ff29ac0eef5aabbd01aa2025",
            "id": "04b103c3fd8e6dd3187db1fe66459b8fdab4878d85ace24413ec2d1f946efb9f",
            "metadata": {},
            "name": "EditorFlagsUserPersonalInformationQuery",
            "operationKind": "query",
            "text": "query EditorFlagsUserPersonalInformationQuery($accountId:ID!){user:confluence_atlassianUser(id:$accountId){id,displayName}}"
        }
    };
}();
$4b4bf52c95a16bda$var$node.hash = "f3c3315775439f1cc7912f906f070deb";
var $4b4bf52c95a16bda$export$2e2bcd8739ae039 = $4b4bf52c95a16bda$var$node;
module.exports["default"] = $4b4bf52c95a16bda$export$2e2bcd8739ae039;

});

parcelRegister("03Xmw", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $7dc210c4acbee9cf$export$bc4f7e1226380dba = ({ flagContent: flagContent, nextTryIn: nextTryIn, flagId: flagId, flags: flags })=>{
    const [secondsLeft, setSecondsLeft] = (0, $42omo.useState)(nextTryIn ? Math.max(Math.round(nextTryIn / 1000), 0) : 0);
    const description = typeof flagContent.description === 'function' ? flagContent.description(secondsLeft) : flagContent.description;
    (0, $42omo.useEffect)(()=>{
        if (nextTryIn) {
            const flagInterval = setInterval(()=>setSecondsLeft((secondsLeft)=>secondsLeft - 1), 1000);
            return ()=>clearInterval(flagInterval);
        }
    }, [
        nextTryIn
    ]);
    // Clean the flag up if the flag is a count down flag
    // and the countdown reached its end
    if (nextTryIn && secondsLeft < 0) flags.hideFlag(flagId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "flag-description"
    }, description, flagContent.details && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "flag-details"
    }, flagContent.details));
};
module.exports["FlagDescription"] = $7dc210c4acbee9cf$export$bc4f7e1226380dba;

});

parcelRegister("fb79u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1mHQU = parcelRequire("1mHQU");


var $4iY7F = parcelRequire("4iY7F");

const $e03997dfc3ec06ab$var$i18n = {
    publishTitle: {
        id: 'editor-flags.publish-page.title',
        defaultMessage: 'New version published',
        description: 'Title for flag that appears when a new version of the page is published'
    },
    publishMessage: {
        id: 'editor-flags.publish-page.known.user.message',
        defaultMessage: "{user} just published a new version of this page, which includes the changes you\u2019ve made so far",
        description: 'Message for flag that appears when a new version of the page is published'
    },
    restoreTitle: {
        id: 'editor-flags.restore-page.title',
        defaultMessage: 'Previous version restored',
        description: 'Title for flag that appears when another user restores a previous version of the page'
    },
    restoreOtherMessage: {
        id: 'editor-flags.restore-page.known.user.message',
        defaultMessage: '{user} just restored a prior version of this {contentType}. Recent changes may have been lost. Check the <alink>page history</alink> for details.',
        description: 'Message for flag that apprears when another user restores a previous version of the page'
    },
    unknownUser: {
        id: 'editor-flags.publish-page.known.user.name',
        defaultMessage: 'Another user',
        description: 'Alternate name when the user responsible for publish is not known'
    },
    anonymousUser: {
        id: 'editor-flags.publish-page.anonymous.user.name',
        defaultMessage: 'An anonymous user',
        description: 'Alternate name when anonymous user is responsible for publish'
    },
    reloadButton: {
        id: 'editor-flags.publish-page.actions.reload',
        description: 'Button label for button that causes a page reload',
        defaultMessage: 'Reload'
    }
};
const $e03997dfc3ec06ab$var$reloadPage = ()=>window.location.reload();
const $e03997dfc3ec06ab$var$displayLivePagePublishedFlag = (flags, formatMessage, user)=>{
    flags.showCustomFlag({
        title: formatMessage($e03997dfc3ec06ab$var$i18n.publishTitle),
        description: formatMessage($e03997dfc3ec06ab$var$i18n.publishMessage, {
            user: user
        }),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-testid": "quick-reload-reload-button"
                }, formatMessage($e03997dfc3ec06ab$var$i18n.reloadButton)),
                onClick: $e03997dfc3ec06ab$var$reloadPage
            }
        ]
    });
};
const $e03997dfc3ec06ab$var$getUserMessage = (formatMessage, queryResult)=>{
    let user;
    const displayName = queryResult?.data?.user?.displayName;
    /* There are 3 cases:
      1. error when making query : the other publisher is unknown and therefore default to "Another user"
      2. queryResult?.data?.user?.displayName is falsy but there is no error, the other publisher is anonymous user
      3. The other publisher is authenticated and there's no error in making query
     */ if (queryResult.error) // error when making query, publisher is unknown and therefore
    user = formatMessage($e03997dfc3ec06ab$var$i18n.unknownUser);
    else if (!displayName) // queryResult data is null, publisher is anonymous user
    user = formatMessage($e03997dfc3ec06ab$var$i18n.anonymousUser);
    else user = displayName;
    return user;
};
const $e03997dfc3ec06ab$var$handlePublishFlag = (flags, formatMessage, isLivePage, user)=>{
    if (isLivePage) $e03997dfc3ec06ab$var$displayLivePagePublishedFlag(flags, formatMessage, user);
    else flags.showInfoFlag({
        title: formatMessage($e03997dfc3ec06ab$var$i18n.publishTitle),
        description: formatMessage($e03997dfc3ec06ab$var$i18n.publishMessage, {
            user: user
        })
    });
};
const $e03997dfc3ec06ab$export$147dab68cb862647 = (flags, formatMessage, attributes, isLivePage = false)=>(queryResult, flagData)=>{
        if (!queryResult.loading) {
            const user = $e03997dfc3ec06ab$var$getUserMessage(formatMessage, queryResult);
            if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH]) {
                $e03997dfc3ec06ab$var$handlePublishFlag(flags, formatMessage, isLivePage, user);
                return;
            } else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE]) flags.showInfoFlag({
                title: formatMessage($e03997dfc3ec06ab$var$i18n.restoreTitle),
                description: formatMessage($e03997dfc3ec06ab$var$i18n.restoreOtherMessage, {
                    user: user,
                    alink: (0, $4iY7F.getPageHistoryLink)(attributes),
                    contentType: attributes.contentType ?? 'page'
                })
            });
        }
        return null;
    };
module.exports["initializeInfoFlag"] = $e03997dfc3ec06ab$export$147dab68cb862647;

});

parcelRegister("4iY7F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $1NBp8 = parcelRequire("1NBp8");

const $35f324be8ccb2751$export$be60689b3b3efd2c = (attributes)=>{
    const { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } = attributes;
    return (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            target: "_blank",
            href: (0, $1NBp8.CONTENT_HISTORY).toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            })
        }, chunks);
};
module.exports["getPageHistoryLink"] = $35f324be8ccb2751$export$be60689b3b3efd2c;

});

parcelRegister("6jB9o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $1NBp8 = parcelRequire("1NBp8");


var $7PLO8 = parcelRequire("7PLO8");


var $1mHQU = parcelRequire("1mHQU");


var $4iY7F = parcelRequire("4iY7F");

const $c31ff9c3561eb614$var$i18n = {
    blogifySuccessTitle: {
        id: 'editor-flags.blogify.blogpost.success.title',
        defaultMessage: 'Page converted to a blog post',
        description: 'The title of the flag shown in the editor when someone convert a page to blogpost'
    },
    blogifySuccessMessage: {
        id: 'editor-flags.blogify.blogpost.success.message',
        defaultMessage: "{displayName} just converted this page to a <alink>blog post</alink>, which includes the changes you\u2019ve made so far.",
        description: 'The body of the flag shown in the editor when someone convert a page to blogpost'
    },
    restoreTitle: {
        id: 'editor-flags.restore-page.title',
        defaultMessage: 'Previous version restored',
        description: 'Title for flag that appears when another user restores a previous version of the page'
    },
    restoreMessage: {
        id: 'editor-flags.restore.page.success.message',
        defaultMessage: 'Recent changes may have been overwritten. Check the <alink>page history</alink> for details.',
        description: 'The body of the flag shown in the editor when someone revert the page/blogpost to previous version in page history'
    },
    extensionCreateTitle: {
        id: 'editor-flags.extension-create.title',
        defaultMessage: 'New draft created',
        description: 'Title for flag that appears when a draft is created by the /create Confluence page extension from another page'
    },
    extensionCreateMessage: {
        id: 'editor-flags.extension-create.message',
        defaultMessage: "There\u2019s now a link to this draft on <alink>{parentPage}</alink>. All of your changes have been saved.",
        description: 'The body of the flag shown in the editor when a draft is created by the /create Confluence page extension from another page'
    },
    extensionCreateParentPage: {
        id: 'editor-flags.extension-create.parent-page',
        defaultMessage: 'the previous page',
        description: 'Placeholder text for {parentPage} in `editor-flags.extension-create.message` when the parent page does not have a title'
    }
};
const $c31ff9c3561eb614$export$63605c1c0febbffe = (flags, formatMessage, { attributes: attributes, flagData: flagData }, createAnalyticsEvent)=>{
    const { contentType: contentType, spaceKey: spaceKey, contentId: contentId } = attributes;
    if (flagData) {
        if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).RESTORE_CONTENT_SUCCESS]) flags.showFlag({
            type: 'success-circle',
            title: formatMessage($c31ff9c3561eb614$var$i18n.restoreTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$c31ff9c3561eb614$var$i18n.restoreMessage,
                values: {
                    contentType: contentType,
                    alink: (0, $4iY7F.getPageHistoryLink)(attributes)
                }
            }),
            messageType: 'transactional',
            messageId: 'editor-flags-version-restore-success'
        });
        else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).BLOGIFY_BLOGPOST_SUCCESS]) {
            const displayName = flagData?.converterDisplayName;
            flags.showFlag({
                type: 'success-circle',
                title: formatMessage($c31ff9c3561eb614$var$i18n.blogifySuccessTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$c31ff9c3561eb614$var$i18n.blogifySuccessMessage,
                    values: {
                        displayName: displayName || formatMessage({
                            id: "editor.page.moved.message.unknown.mover"
                        }),
                        alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                                target: "_blank",
                                href: (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                                    spaceKey: spaceKey,
                                    contentId: contentId,
                                    contentType: 'blog'
                                }, {
                                    query: {
                                        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                    }
                                })
                            }, chunks)
                    }
                }),
                messageType: 'transactional',
                messageId: 'editor-flags-blogify-success'
            });
        } else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CREATED_FROM_EXTENSION]) {
            const { parentContentId: parentContentId, parentTitle: parentTitle } = flagData;
            const parentUrl = (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: parentContentId
            });
            const handleClick = (event)=>{
                event.preventDefault();
                // Open the parent page in the existing tab if it hasn't been closed
                const parentWin = window.open('', parentContentId);
                parentWin?.focus();
                // If tab was closed, navigate new tab to the parent page URL
                if (parentWin && !parentWin.location.host) // eslint-disable-next-line no-restricted-syntax
                parentWin.location.assign(parentUrl);
                if (createAnalyticsEvent) createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'parentPageLink',
                        actionSubjectId: 'inlineCreateOneStepExperiment',
                        source: 'SuccessFlag',
                        attributes: {
                            contentId: contentId,
                            contentType: contentType,
                            parentContentId: parentContentId
                        }
                    }
                }).fire();
            };
            flags.showFlag({
                type: 'success-circle',
                title: formatMessage($c31ff9c3561eb614$var$i18n.extensionCreateTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...$c31ff9c3561eb614$var$i18n.extensionCreateMessage,
                    values: {
                        parentPage: !!parentTitle ? parentTitle : formatMessage($c31ff9c3561eb614$var$i18n.extensionCreateParentPage),
                        alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                                href: parentUrl,
                                target: parentContentId,
                                onClick: handleClick
                            }, chunks)
                    }
                }),
                messageType: 'transactional',
                messageId: 'editor-flags-create-from-extension-success'
            });
        }
    }
};
const $c31ff9c3561eb614$export$4db4941fd1416d17 = ()=>{
    // createdFrom parameter means draft was created by the create page extension from another page
    const urlParams = new URLSearchParams(window.location.search);
    const parentContentId = urlParams.get('createdFrom');
    if (parentContentId) {
        // Remove createdFrom param from url without reloading
        urlParams.delete('createdFrom');
        const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
        window.history.pushState({}, '', `${window.location.pathname}${newParams}`);
        // Show flag if the parentContentId is a number
        // and this was an auto redirect from parent page, i.e. not copy/pasted url
        if (/^\d+$/.test(parentContentId) && !!document.referrer) return parentContentId;
    }
    return null;
};
module.exports["initializeSuccessFlag"] = $c31ff9c3561eb614$export$63605c1c0febbffe;
module.exports["getParentContentId"] = $c31ff9c3561eb614$export$4db4941fd1416d17;

});

parcelRegister("gQojb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3dcbd344a2ba2fc1$export$593ae3df1272c4d1 = ({ source: source, actionSubjectId: actionSubjectId, contentId: contentId, contentType: contentType, collabService: collabService, version: version })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const triggerPageConflictAnalytics = (0, $42omo.useCallback)((errorMessage, extraData = {})=>{
        $3dcbd344a2ba2fc1$export$80e39f0a257b3d6c(source, actionSubjectId, {
            contentId: contentId,
            contentType: contentType,
            collabService: collabService,
            version: version,
            errorMessage: errorMessage,
            ...extraData
        }, createAnalyticsEvent);
    }, [
        createAnalyticsEvent,
        source,
        actionSubjectId,
        contentId,
        contentType,
        collabService,
        version
    ]);
    return {
        triggerPageConflictAnalytics: triggerPageConflictAnalytics
    };
};
const $3dcbd344a2ba2fc1$export$80e39f0a257b3d6c = (source, actionSubjectId, attributes, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: source,
            action: 'error',
            actionSubject: 'pageConflict',
            actionSubjectId: actionSubjectId,
            attributes: attributes
        }
    }).fire();
};
module.exports["usePageConflictAnalytics"] = $3dcbd344a2ba2fc1$export$593ae3df1272c4d1;

});

parcelRegister("jv3O2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");

const $a23dc1f066cda204$var$i18nBase = (0, $aXWIB.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle",
        defaultMessage: "This page was switched to a live page"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle",
        defaultMessage: "You\u2019ve switched to a live page"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody",
        defaultMessage: "Updates to this page will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore",
        defaultMessage: "Find out more"
    },
    reloadButton: {
        id: "editor-flags.convert-to-live-page-flag.reloadButton",
        defaultMessage: "Reload"
    }
});
const $a23dc1f066cda204$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle.livedocs",
        defaultMessage: "This page was converted to a live doc"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle.livedocs",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody.livedocs",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore.livedocs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a23dc1f066cda204$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($a23dc1f066cda204$var$i18nBase, $a23dc1f066cda204$var$i18nLiveDocs);
const $a23dc1f066cda204$var$LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME = 11000;
const $a23dc1f066cda204$export$cb5a789d90de377 = ({ flags: flags })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const intl = (0, $aXWIB.useIntl)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        const livePageLink = (0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        });
        return isOnEditRoute ? replace(livePageLink) : window.location.reload();
    }, [
        isOnEditRoute,
        replace,
        spaceKey,
        contentId
    ]);
    return (0, $42omo.useCallback)(async ({ converterWasCurrentUser: converterWasCurrentUser })=>{
        const successFlag = await flags.showFlag({
            title: converterWasCurrentUser ? intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.switcherFlagTitle) : intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagTitle),
            description: intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagBody),
            type: 'success',
            id: 'convert-to-live-page-flag',
            close: 'never',
            // Needed to bypass the flags.hideAllFlags() call in EditorFlags.tsx on editor unmount.
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        "data-testid": "reload-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.reloadButton)),
                    onClick: handleOnClick
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                        "data-testid": "find-out-more-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.findOutMore)),
                    onClick: ()=>window.open($a23dc1f066cda204$var$LEARN_MORE_URL, '_blank')
                }
            ]
        });
        // We don't want to auto-close the flag when a different user converts the page,
        // because there's no auto-redirect, so the user must click "Reload" in the flag to continue.
        if (converterWasCurrentUser) // Manually set a timeout so the flag auto-closes after the page transition completes.
        setTimeout(()=>flags.hideFlag(successFlag.id), $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME);
    }, [
        intl,
        flags,
        handleOnClick
    ]);
};
module.exports["useShowConvertToLivePageFlag"] = $a23dc1f066cda204$export$cb5a789d90de377;

});

parcelRegister("9o40q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("5MyXJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $3jwuS = parcelRequire("3jwuS");


var $4VJDS = parcelRequire("4VJDS");


var $9wGTI = parcelRequire("9wGTI");


var $8MyKT = parcelRequire("8MyKT");


var $jKP0k = parcelRequire("jKP0k");


var $loOZe = parcelRequire("loOZe");


var $9y3bP = parcelRequire("9y3bP");

/* Editor heartbeat set to tick every 60 seconds */ const $2350038afb2a4a3e$var$HEARTBEAT_TIMER_INTERVAL = 60000;
const $2350038afb2a4a3e$var$EDITOR_NCS_MAX_PARTICIPANTS = 'confluence_frontend_collab_ncs_max_participants';
const $2350038afb2a4a3e$var$LIVE_PAGES_LIMITS = 'confluence_frontend_collab_live_pages_limits';
const $2350038afb2a4a3e$var$COLLAB_SERVICE = 'ncs'; // this hook is only used for NCS editor
const $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS = 12;
class $2350038afb2a4a3e$export$17a91496024ff2c1 extends Error {
    constructor(message, reason){
        super(message), this.message = message, this.reason = reason;
        this.reason = reason;
    }
}
const $2350038afb2a4a3e$export$e11674744930cd15 = (heartbeatError)=>{
    return heartbeatError?.reason === 'unauthorised' || heartbeatError?.reason === 'UNAUTHORIZED';
};
const $2350038afb2a4a3e$export$af429709ba6838d6 = ({ contentId: contentId, contentType: contentType, collabEditInitialized: collabEditInitialized, viewMode: viewMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const heartbeatTimerId = (0, $42omo.useRef)(null);
    const editorSessionIdRef = (0, $42omo.useRef)(null);
    const [subtypeMismatch, setSubtypeMismatch] = (0, $42omo.useState)(false);
    const [heartbeatSubtype, setHeartbeatSubtype] = (0, $42omo.useState)(undefined);
    // If view mode changes, trigger new heartbeat request with new "user type", before enforcing any limits or returning errors
    const prevViewModeRef = (0, $42omo.useRef)(viewMode !== undefined ? viewMode : null);
    const isResettingHeartbeat = (0, $42omo.useRef)(false);
    // keep track of list of users from heartbeat response, which are ordered by time that they joined the collaborative session
    const [orderedActiveUsers, setOrderedActiveUsers] = (0, $42omo.useState)(null);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // used for regular pages
    const [collabLimitReached, setCollabLimitReached] = (0, $42omo.useState)(false);
    // used for live pages
    const [liveEditLimitReached, setLiveEditLimitReached] = (0, $42omo.useState)(false);
    const [liveViewLimitReached, setLiveViewLimitReached] = (0, $42omo.useState)(false);
    const [heartbeatError, setHeartbeatError] = (0, $42omo.useState)();
    let maxEditParticipants = (0, $4VJDS.default).getNumber($2350038afb2a4a3e$var$EDITOR_NCS_MAX_PARTICIPANTS, $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS);
    const livePagesLimitConfig = (0, $4VJDS.default).getString($2350038afb2a4a3e$var$LIVE_PAGES_LIMITS, '');
    const { viewLimit: livePageViewLimit, editLimit: livePageEditLimit } = (0, $42omo.useMemo)(()=>{
        const defaultLimits = {
            editLimit: $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS,
            viewLimit: 100
        };
        if (typeof livePagesLimitConfig === 'string') try {
            const limitObject = JSON.parse(livePagesLimitConfig);
            if (!('viewLimit' in limitObject) || !('editLimit' in limitObject)) return defaultLimits;
            return limitObject;
        } catch  {
        // ignore and fallback to default
        }
        return defaultLimits;
    }, [
        livePagesLimitConfig
    ]);
    if (isLivePage) maxEditParticipants = livePageEditLimit;
    const [startHeartbeat] = (0, $loOZe.useExperimentalEditorStartHeartbeatMutation)({
        variables: {
            contentId: contentId,
            contentType: contentType,
            collabService: $2350038afb2a4a3e$var$COLLAB_SERVICE,
            heartbeatUserType: viewMode ? (0, $8MyKT.ExperimentalHeartbeatUserType).VIEW : (0, $8MyKT.ExperimentalHeartbeatUserType).EDIT
        }
    });
    const [stopHeartbeat] = (0, $9y3bP.useExperimentalEditorStopHeartbeatMutation)({
        variables: {
            contentId: contentId,
            contentType: contentType,
            heartbeatUserType: viewMode ? (0, $jKP0k.ExperimentalHeartbeatUserType).VIEW : (0, $jKP0k.ExperimentalHeartbeatUserType).EDIT
        }
    });
    const handleError = (0, $42omo.useCallback)((error, data)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: 'heartbeat',
                source: 'useEditorHeartbeat',
                objectId: contentId,
                objectType: contentType,
                attributes: {
                    error: {
                        reason: error instanceof $2350038afb2a4a3e$export$17a91496024ff2c1 ? error.reason : 'Error',
                        message: error.message
                    },
                    activeUsersSize: data?.experimentalEditorStartHeartbeat?.orderedUsers?.length
                }
            }
        }).fire();
        setHeartbeatError(error);
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const stopHeartbeatCallback = (0, $42omo.useCallback)(()=>{
        if (heartbeatTimerId?.current) clearInterval(heartbeatTimerId.current);
        stopHeartbeat().catch((error)=>{
            handleError(error);
        });
    }, [
        stopHeartbeat,
        handleError
    ]);
    const handleHeartbeatSubtypeMismatch = (0, $42omo.useCallback)((subtype)=>{
        setHeartbeatSubtype(subtype);
        // Detect if page type (live/classic page) differs between frontend and backend
        // This can happen when a page is converted but the user hasn't received the event
        // We disable the editor in NCS to prevent potential data loss in this state
        const hasSubtypeMismatch = isLivePage && subtype !== 'live' || // Live doc with a different subtype
        !isLivePage && subtype !== null; // Non-live doc with any subtype
        setSubtypeMismatch(hasSubtypeMismatch);
    }, [
        isLivePage,
        setHeartbeatSubtype,
        setSubtypeMismatch
    ]);
    const startHeartbeatCallback = (0, $42omo.useCallback)(()=>{
        startHeartbeat().then((result)=>{
            const { data: data } = result;
            if (isResettingHeartbeat.current) isResettingHeartbeat.current = false;
            if (!data || !data.experimentalEditorStartHeartbeat) {
                handleError(new $2350038afb2a4a3e$export$17a91496024ff2c1('Missing response data', !data ? 'No data' : 'No heartbeat data'));
                return;
            }
            const { error: error, message: message, orderedUsers: orderedUsers, editorSessionId: editorSessionId, subtype: subtype } = data.experimentalEditorStartHeartbeat;
            editorSessionIdRef.current = editorSessionId;
            if ((0, $9wGTI.fg)('confluence_ncs_disconnect_idle_tabs_pubsub')) handleHeartbeatSubtypeMismatch(subtype);
            if (error) {
                const heartbeatError = new $2350038afb2a4a3e$export$17a91496024ff2c1(message ?? 'Heartbeat failed', error);
                if (isLivePage && $2350038afb2a4a3e$export$e11674744930cd15(heartbeatError)) // heartbeat permission check is a redundant extra check on top of NCS permission enforcement
                // for live pages:
                //    there is a race condition where heartbeat is sent with outdated user type
                //    we ignore the permission error and re-send the heartbeat with the correct user type
                return;
                handleError(heartbeatError, data);
            }
            if (!!orderedUsers) setOrderedActiveUsers(orderedUsers);
        }).catch((error)=>{
            handleError(error);
        });
    }, [
        startHeartbeat,
        handleError,
        isLivePage,
        handleHeartbeatSubtypeMismatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!orderedActiveUsers || isResettingHeartbeat.current) return;
        const isCurrentUserOverLimit = ({ activeUsers: activeUsers, limit: limit })=>{
            // If there are less active users than the limit, the user is not over the limit
            if (activeUsers.length < limit) return false;
            const isUserAnActiveUser = userId ? activeUsers.slice(0, limit).includes(userId) : false;
            return(// heartbeat backend doesn't handle anonymous users, they will be locked out regardless of order that they joined (i.e. we just use activeUsers size number comparison for anonymous users)
            // otherwise, only the first N users should be able to continue editing
            !userId && activeUsers.length > limit || !!userId && !isUserAnActiveUser);
        };
        const editUsers = orderedActiveUsers.filter((user)=>user.heartbeatUserType === (0, $8MyKT.ExperimentalHeartbeatUserType).EDIT).map((user)=>user.accountId) ?? [];
        const isEditLimitExceeded = isCurrentUserOverLimit({
            activeUsers: editUsers,
            limit: maxEditParticipants
        });
        if (!isLivePage) {
            setCollabLimitReached(isEditLimitExceeded);
            return;
        }
        // include edit->view fallback users, based on queue order
        const allowedEditUsers = editUsers.slice(0, maxEditParticipants);
        const viewUsers = orderedActiveUsers.filter((user)=>!allowedEditUsers.includes(user.accountId)).map((user)=>user.accountId) ?? [];
        const isViewLimitExceeded = isCurrentUserOverLimit({
            activeUsers: viewUsers,
            limit: livePageViewLimit
        });
        if (isEditLimitExceeded && !(prevViewModeRef.current || isViewLimitExceeded)) setLiveEditLimitReached(true);
        else setLiveEditLimitReached(false);
        if (isViewLimitExceeded && (prevViewModeRef.current || isEditLimitExceeded)) setLiveViewLimitReached(true);
        else setLiveViewLimitReached(false);
    }, [
        orderedActiveUsers,
        maxEditParticipants,
        userId,
        isLivePage,
        livePageViewLimit
    ]);
    (0, $42omo.useEffect)(()=>{
        if (viewMode !== undefined && viewMode !== prevViewModeRef.current) {
            // view mode has changed, refetch heartbeat with new user type
            isResettingHeartbeat.current = true;
            startHeartbeatCallback();
            prevViewModeRef.current = viewMode;
        }
    }, [
        viewMode,
        startHeartbeatCallback
    ]);
    (0, $42omo.useEffect)(()=>{
        if (collabEditInitialized) {
            startHeartbeatCallback();
            heartbeatTimerId.current = setInterval(startHeartbeatCallback, $2350038afb2a4a3e$var$HEARTBEAT_TIMER_INTERVAL);
            return ()=>stopHeartbeatCallback();
        }
    // prevent re-triggering start/stop when heartbeat type changes (i.e. when mutation callback changes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInitialized,
        contentId,
        // only re-trigger heartbeat on specific mutation variables, not viewMode
        contentType
    ]);
    return {
        collabLimitReached: // regular edit pages
        collabLimitReached,
        liveEditLimitReached: // live pages specific
        liveEditLimitReached,
        liveViewLimitReached: liveViewLimitReached,
        heartbeatError: // shared data
        heartbeatError,
        stopHeartbeatCallback: stopHeartbeatCallback,
        editorSessionId: editorSessionIdRef.current,
        subtypeMismatch: subtypeMismatch,
        heartbeatSubtype: heartbeatSubtype
    };
};
module.exports["isPermissionError"] = $2350038afb2a4a3e$export$e11674744930cd15;
module.exports["useEditorHeartbeat"] = $2350038afb2a4a3e$export$af429709ba6838d6;

});

parcelRegister("8MyKT", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d61f6181e4c7da5b$export$5d0e43ccb00ec46a = /*#__PURE__*/ function(ExperimentalHeartbeatUserType) {
    ExperimentalHeartbeatUserType["EDIT"] = "EDIT";
    ExperimentalHeartbeatUserType["VIEW"] = "VIEW";
    return ExperimentalHeartbeatUserType;
}({});
module.exports["ExperimentalHeartbeatUserType"] = $d61f6181e4c7da5b$export$5d0e43ccb00ec46a;

});

parcelRegister("jKP0k", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $89185ab988181834$export$5d0e43ccb00ec46a = /*#__PURE__*/ function(ExperimentalHeartbeatUserType) {
    ExperimentalHeartbeatUserType["EDIT"] = "EDIT";
    ExperimentalHeartbeatUserType["VIEW"] = "VIEW";
    return ExperimentalHeartbeatUserType;
}({});
module.exports["ExperimentalHeartbeatUserType"] = $89185ab988181834$export$5d0e43ccb00ec46a;

});

parcelRegister("loOZe", function(module, exports) {

var $9o40q = parcelRequire("9o40q");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $d7e083384eee425a$var$TENANT_SUSPENDED_RESPONSE = 'Site temporarily unavailable';
const $d7e083384eee425a$export$458b4e9b72fe370e = ({ variables: variables })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: '/wiki/api/v2/editor/heartbeat/start',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON,
            Accept: (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        body: ({ contentId: contentId, contentType: contentType, collabService: collabService, heartbeatUserType: heartbeatUserType })=>JSON.stringify({
                dataType: 'json',
                contentId: contentId,
                draftType: contentType ?? '',
                collabService: collabService,
                // confluence-frontend only sends heartbeat for Fabric editor, legacy editor heartbeat code is in confluence web resource.
                // heartbeat response is different for each editor version; only fabric heartbeat response in handled in this experimental mutation
                editorVersion: 'v2',
                heartbeatUserType: heartbeatUserType
            }),
        parseResponseOnError: async (fetchError)=>{
            // this catches unhandled server errors (e.g. internal server error)
            let error;
            let message;
            if (fetchError instanceof (0, $hBkCm.BadStatusError)) try {
                // try to parse original error message
                const errorMessageJson = await fetchError.response.json();
                if (errorMessageJson?.errorMessage === $d7e083384eee425a$var$TENANT_SUSPENDED_RESPONSE) {
                    // error from atlassian-proxy during region migration
                    error = 'tenant-unavailable';
                    message = 'Site temporarily unavailable';
                } else {
                    // Parse heartbeat REST error response
                    error = errorMessageJson?.errors[0].code;
                    message = errorMessageJson?.errors[0].title;
                }
            } catch  {
                error = fetchError.response.statusText;
                message = fetchError.message;
            }
            else {
                error = fetchError.name;
                message = fetchError.message;
            }
            return {
                orderedUsers: null,
                editorSessionId: null,
                error: error,
                message: message,
                subtype: null
            };
        },
        parseResult: ({ orderedUsers: orderedUsers, editorSessionId: editorSessionId, subtype: subtype, error: error, message: message })=>{
            return {
                experimentalEditorStartHeartbeat: {
                    orderedUsers: orderedUsers,
                    editorSessionId: editorSessionId,
                    error: error,
                    message: message,
                    subtype: subtype
                }
            };
        }
    });
};
module.exports["useExperimentalEditorStartHeartbeatMutation"] = $d7e083384eee425a$export$458b4e9b72fe370e;

});

parcelRegister("9y3bP", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");

const $bd279094f7d7a508$export$d3610256bfeae95f = ({ variables: variables })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: '/wiki/api/v2/editor/heartbeat/stop',
        method: 'POST',
        variables: variables,
        headers: {
            Accept: (0, $aBfpe.MediaType).JSON,
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ contentId: contentId, contentType: contentType, heartbeatUserType: heartbeatUserType })=>JSON.stringify({
                dataType: 'json',
                contentId: contentId,
                draftType: contentType ?? '',
                heartbeatUserType: heartbeatUserType
            }),
        parseResponseOnError: ()=>{
            return false;
        },
        parseResult: (response)=>{
            return {
                experimentalEditorStopHeartbeat: Boolean(response)
            };
        }
    });
};
module.exports["useExperimentalEditorStopHeartbeatMutation"] = $bd279094f7d7a508$export$d3610256bfeae95f;

});

parcelRegister("5M5fB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3jwuS = parcelRequire("3jwuS");

/**
 * To avoid multiple people saving the draft simultaneously, which causes a lock exception,
 * we only want the first active user to be in charge of saving.
 * See issue CFE-1369 for details.
 */ const $ecd355b99e8f624d$var$checkIsFirstParticipant = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Check if the first participant is the current user
    return participants[0].sessionId === currentUserSessionId;
};
/**
 * Verifies if the current user is the primary participant and has edit permissions.
 * @returns {boolean} True if the user is the first participant with edit permissions,
 *                    false if the user has view only or is not the first participant.
 */ const $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Find the first participant in the sorted list with edit permissions
    const primaryParticipant = participants.find((activeUser)=>activeUser.permit?.isPermittedToEdit);
    return !!primaryParticipant && primaryParticipant.sessionId === currentUserSessionId;
};
const $ecd355b99e8f624d$var$updatePresence = (presenceData, currentParticipants)=>{
    const { joined: joined = [], left: left = [] } = presenceData;
    let updatedParticipants = [];
    if (currentParticipants === null) updatedParticipants = joined;
    else {
        // Add new participants to the list
        updatedParticipants = [
            ...currentParticipants,
            ...joined
        ];
        // Remove participants who have left
        updatedParticipants = updatedParticipants.filter((participant)=>!left.some((leftUser)=>leftUser.sessionId === participant.sessionId));
    }
    // Sort the session IDs to ensure the comparison for choosing the
    // draft sync leader is deterministic.
    updatedParticipants.sort((a, b)=>a.sessionId.localeCompare(b.sessionId));
    return updatedParticipants;
};
const $ecd355b99e8f624d$export$2a8c16d82a0a0e26 = (collabEditProvider)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentUserSessionId = (0, $42omo.useRef)(null);
    const currentParticipants = (0, $42omo.useRef)(null);
    const [isFirstParticipant, setIsFirstParticipant] = (0, $42omo.useState)(true);
    const [isSingleUserSession, setIsSingleUserSession] = (0, $42omo.useState)(true);
    // Listen to the connected event to grab the current user's sessionId
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = (event)=>{
            currentUserSessionId.current = event?.sid;
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider
    ]);
    const handleUpdatePresence = (0, $42omo.useCallback)((presenceData)=>{
        const updatedParticipants = $ecd355b99e8f624d$var$updatePresence(presenceData, currentParticipants.current);
        currentParticipants.current = updatedParticipants;
        const isFirst = isLivePage ? $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions(updatedParticipants, currentUserSessionId.current) : $ecd355b99e8f624d$var$checkIsFirstParticipant(updatedParticipants, currentUserSessionId.current);
        setIsFirstParticipant(isFirst);
        setIsSingleUserSession(currentParticipants.current.length <= 1);
    }, [
        isLivePage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('presence', handleUpdatePresence);
        return ()=>{
            collabEditProvider.off('presence', handleUpdatePresence);
        };
    }, [
        collabEditProvider,
        handleUpdatePresence
    ]);
    return {
        isFirstParticipant: isFirstParticipant,
        isSingleUserSession: isSingleUserSession
    };
};
module.exports["usePresence"] = $ecd355b99e8f624d$export$2a8c16d82a0a0e26;

});

parcelRegister("2VQ4B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $bhXnY = parcelRequire("bhXnY");


var $5EhNr = parcelRequire("5EhNr");

const $010b88689ec70f7f$export$a267cdf45880b07b = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5EhNr.UFOSegmentLoadEnd), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhXnY.Bm3PageSegmentLoadEnd), props);
};
module.exports["PageSegmentLoadEnd"] = $010b88689ec70f7f$export$a267cdf45880b07b;

});

parcelRegister("bhXnY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $9bfe2b6f868e7303$var$noop = ()=>{};
const $9bfe2b6f868e7303$var$Bm3PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $9bfe2b6f868e7303$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $9bfe2b6f868e7303$export$b20cfab4e3fe23b6 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($9bfe2b6f868e7303$var$Bm3PageSegmentLoadEndComponent);
module.exports["Bm3PageSegmentLoadEnd"] = $9bfe2b6f868e7303$export$b20cfab4e3fe23b6;

});

parcelRegister("5EhNr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $e32532ca00da3b97$var$noop = ()=>{};
const $e32532ca00da3b97$var$EMBEDDED_PREFIX = 'embedded-';
const $e32532ca00da3b97$var$UFOSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $e32532ca00da3b97$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    const prefixedKey = isEmbedded ? `${$e32532ca00da3b97$var$EMBEDDED_PREFIX}${metric.key}` : metric.key;
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
            (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
            (0, $cbc8g.addUFOCustomData)({
                ...finalCustomData,
                ...typeof stopTimeRef.current === 'number' ? {
                    stopTime: stopTimeRef.current
                } : {},
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            });
        }
    }, [
        metric,
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $e32532ca00da3b97$export$9859c9d857077c0b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e32532ca00da3b97$var$UFOSegmentLoadEndComponent);
module.exports["UFOSegmentLoadEnd"] = $e32532ca00da3b97$export$9859c9d857077c0b;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $T1bCI.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("cl74W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $3sFtD = parcelRequire("3sFtD");


var $hmuev = parcelRequire("hmuev");


var $eEA8O = parcelRequire("eEA8O");


var $cO1el = parcelRequire("cO1el");


var $inPa6 = parcelRequire("inPa6");


var $fxBfz = parcelRequire("fxBfz");


var $lsxnT = parcelRequire("lsxnT");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $hTxAd = parcelRequire("hTxAd");


var $fiFCv = parcelRequire("fiFCv");


var $5v7QA = parcelRequire("5v7QA");

const $6518ada37406f39b$var$insightMessageStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.300'
});
const $6518ada37406f39b$var$i18n = (0, $aXWIB.defineMessages)({
    successIconLabel: {
        id: "automation-discovery.global-public-link.success.icon.label",
        defaultMessage: "Success check icon"
    },
    modalCloseIconLabel: {
        id: "automation-discovery.global-public-link.modal.close.icon.label",
        defaultMessage: "Close icon for modal"
    }
});
const $6518ada37406f39b$var$BaseAutomationDiscoveryDialogComponent = ({ onClose: onClose, templateUrl: templateUrl, templateName: templateName, spaceKey: spaceKey, header: header, cta: cta, eventSourceName: eventSourceName, localStorageKey: localStorageKey, discoveryExperience: discoveryExperience, customBody: customBody, children: children, templateId: templateId = '', onDismiss: onDismiss = ()=>{}, onRedirectToRuleBuilder: onRedirectToRuleBuilder = ()=>{}, onCreateRuleSuccess: onCreateRuleSuccess = ()=>{}, onRuleCreateStart: onRuleCreateStart, onCreateRuleFail: onCreateRuleFail, disableCreateRule: disableCreateRule, testId: testId, insightMessage: insightMessage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: discoveryExperience,
                source: eventSourceName
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        eventSourceName,
        discoveryExperience
    ]);
    const handleDismiss = ()=>{
        (0, $hTxAd.markDiscoveryExperienceAsSeen)(localStorageKey);
        onClose();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${discoveryExperience}Dismiss`,
                source: eventSourceName,
                attributes: {
                    spaceKey: spaceKey
                }
            }
        }).fire();
    };
    const handleProceed = ()=>{
        window.open(templateUrl, '_blank');
        (0, $hTxAd.markDiscoveryExperienceAsSeen)(localStorageKey);
        onClose();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${discoveryExperience}Proceed`,
                source: eventSourceName,
                attributes: {
                    spaceKey: spaceKey,
                    template: templateName
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: "small",
        onClose: onClose,
        testId: testId,
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "end",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            padding: 'space.100',
            paddingRight: 'space.200'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        "aria-label": formatMessage((0, $5v7QA.meetingNotesI18n).modalCloseIconLabel),
        appearance: "link",
        onClick: onClose,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: "",
            color: "var(--ds-text-subtle, #505258)"
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: formatMessage($6518ada37406f39b$var$i18n.successIconLabel),
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small"
    }, header)), customBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fiFCv.InContextAutomationPrompt), {
        ruleComponentAlignment: "stack",
        templateId: templateId,
        templateDescription: templateName,
        spaceKey: spaceKey,
        message: cta,
        insightMessage: insightMessage,
        handleRedirectToRuleBuilder: onRedirectToRuleBuilder,
        handleDismiss: onDismiss,
        handleRuleCreationSuccess: onCreateRuleSuccess,
        handleRuleCreationStart: onRuleCreateStart,
        handleRuleCreationFail: onCreateRuleFail,
        checkIsInContextRuleBuilderStateValid: ()=>true,
        automationDiscoveryParent: eventSourceName,
        displayMode: "modal",
        disableCreateRule: disableCreateRule
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill",
        space: "space.150",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            padding: 'space.150',
            backgroundColor: 'color.background.accent.gray.subtlest'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, cta)), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6518ada37406f39b$var$insightMessageStyles
    }, insightMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.200",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: handleDismiss,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: handleProceed,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5v7QA.commonI18n).showMeHow))))));
};
const $6518ada37406f39b$export$50558003331d128c = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($6518ada37406f39b$var$BaseAutomationDiscoveryDialogComponent);
module.exports["BaseAutomationDiscoveryDialog"] = $6518ada37406f39b$export$50558003331d128c;

});

parcelRegister("hTxAd", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $tgs13 = parcelRequire("tgs13");

const $a5f7b05a2384a497$export$9f585226e9430b76 = (experienceKey)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem(experienceKey, true, (0, $tgs13.TWENTY_EIGHT_DAYS_IN_SECONDS));
};
module.exports["markDiscoveryExperienceAsSeen"] = $a5f7b05a2384a497$export$9f585226e9430b76;

});

parcelRegister("tgs13", function(module, exports) {
const $2e9fe66aaea8de6a$export$f09b8e10e3913161 = 2419200;
const $2e9fe66aaea8de6a$export$885b9d72bc39ecdb = 2592000000;
const $2e9fe66aaea8de6a$export$6ec716a28918c083 = 31536000;
module.exports["TWENTY_EIGHT_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$f09b8e10e3913161;
module.exports["THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$6ec716a28918c083;

});

parcelRegister("fiFCv", function(module, exports) {
/* InContextAutomationPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $cvXh8 = parcelRequire("cvXh8");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");

var $9YwaJ = parcelRequire("9YwaJ");


var $cO1el = parcelRequire("cO1el");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $fxBfz = parcelRequire("fxBfz");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $9KNO1 = parcelRequire("9KNO1");


var $d0Ide = parcelRequire("d0Ide");


var $2HPSp = parcelRequire("2HPSp");


var $5v7QA = parcelRequire("5v7QA");


var $5scZK = parcelRequire("5scZK");

const $3dbeeac5567d9c48$var$insightMessageStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.300'
});
const $3dbeeac5567d9c48$var$insightMessageInContextStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.300',
    marginTop: 'space.050'
});
const $3dbeeac5567d9c48$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    buildingRule: {
        id: "automation-discovery.common.building-rule",
        defaultMessage: "Building rule"
    },
    createRule: {
        id: "automation-discovery.common.create-rule",
        defaultMessage: "Turn on rule"
    },
    createRuleSuccess: {
        id: "automation-discovery.common.create-rule-success",
        defaultMessage: "Rule has been turned on"
    },
    viewRule: {
        id: "automation-discovery.common.view-rule",
        defaultMessage: "View rule"
    },
    editInRuleBuilder: {
        id: "automation-discovery.common.edit-in-rule-builder",
        defaultMessage: "Edit in rule builder"
    },
    errorFlagTitle: {
        id: "automation-discovery.common.error-flag.title",
        defaultMessage: "Failed to create rule"
    },
    errorFlagDescription: {
        id: "automation-discovery.common.error-flag.description",
        defaultMessage: "An unexpected error occurred while creating the rule."
    }
});
const $3dbeeac5567d9c48$var$ConditionalWrapper = ({ condition: condition, WrapperIfTrue: WrapperIfTrue, WrapperIfFalse: WrapperIfFalse, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperIfTrue, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrapperIfFalse, null, children);
const $3dbeeac5567d9c48$var$StackWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, children);
const $3dbeeac5567d9c48$var$InlineWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
const $3dbeeac5567d9c48$var$defaultInContextPromptContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.150',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    marginBottom: 'space.200',
    marginRight: 'space.0',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3dbeeac5567d9c48$var$BouncingDot = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _j7hqu8hp _5sag3sne _tip812c5 _1pgl6ui8 _xg4k6ebc _1lac188d",
            __cmplp.className
        ])
    });
});
const $3dbeeac5567d9c48$var$InContextRuleBuilder = ({ templateId: templateId, spaceKey: spaceKey, templateDescription: templateDescription, handleRedirectToRuleBuilder: handleRedirectToRuleBuilder, handleRuleCreationStart: handleRuleCreationStart, handleRuleCreationSuccess: handleRuleCreationSuccess, flags: flags, children: children, automationDiscoveryParent: automationDiscoveryParent, customContainerStyles: customContainerStyles, checkIsInContextRuleBuilderStateValid: checkIsInContextRuleBuilderStateValid, ruleComponentAlignment: ruleComponentAlignment = 'stack', displayMode: displayMode = 'in-context', handleRuleCreationFail: handleRuleCreationFail, disableCreateRule: disableCreateRule, handleDismiss: handleDismiss, message: message, insightMessage: insightMessage })=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { templateApiParameters: templateApiParameters } = (0, $42omo.useContext)((0, $2HPSp.InContextRuleBuilderContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey || undefined);
    const [createdRuleId, setCreatedRuleId] = (0, $42omo.useState)(null);
    const [displayPrompt, setShouldDisplayPrompt] = (0, $42omo.useState)(true);
    const [animationState, setAnimationState] = (0, $42omo.useState)(-1);
    const timeoutID = (0, $42omo.useRef)(null);
    const isAnimationFinished = animationState >= (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) + 1;
    const onCompleted = (result)=>{
        if (result?.experimentalCreateAutomationRuleFromTemplate?.ruleId) {
            handleRuleCreationSuccess();
            setCreatedRuleId(result.experimentalCreateAutomationRuleFromTemplate.ruleId);
        }
    };
    const onError = (err)=>{
        handleRuleCreationFail?.(err);
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.errorFlagDescription),
            isAutoDismiss: true
        });
    };
    const [createAutomationRuleFromTemplate, { data: data, loading: loading, error: mutationError }] = (0, $5scZK.useExperimentalCreateAutomationRuleFromTemplateMutation)({
        onCompleted: onCompleted,
        onError: onError
    });
    (0, $42omo.useEffect)(()=>{
        if (isAnimationFinished) {
            clearTimeout(timeoutID.current);
            timeoutID.current = null;
            return;
        } // Count up to the # of components in the rule we want to render
        if (!displayPrompt) timeoutID.current = setTimeout(()=>{
            setAnimationState((value)=>value + 1);
        }, 1000);
        return ()=>clearTimeout(timeoutID.current);
    }, [
        animationState,
        isAnimationFinished,
        displayPrompt
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                source: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                attributes: {
                    automationDiscoveryParent: automationDiscoveryParent
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        automationDiscoveryParent
    ]);
    const handleOnClickCreateRule = async ()=>{
        if (checkIsInContextRuleBuilderStateValid()) {
            handleRuleCreationStart?.(); // This is really fast in prod (no remote call)
            const automationStack = await (0, $9KNO1.getAutomationStack)(environment);
            const formattedParameters = Object.entries(templateApiParameters).map(([parameterName, parameterValue])=>({
                    name: parameterName,
                    type: parameterValue.type,
                    value: String(parameterValue.value)
                }));
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'automationDiscoveryInContextRuleBuilderTurnOn',
                    source: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                    attributes: {
                        spaceKey: spaceKey,
                        automationDiscoveryParent: automationDiscoveryParent
                    }
                }
            }).fire();
            await createAutomationRuleFromTemplate({
                variables: {
                    templateId: templateId,
                    cloudId: cloudId,
                    automationStack: automationStack,
                    spaceId: spaceId,
                    parameters: formattedParameters
                }
            });
        }
    };
    const renderInContextActionButtons = ()=>{
        if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            href: `/wiki/spaces/${spaceKey}/settings/automation#/rule/${createdRuleId}`,
            target: "_blank",
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.viewRule)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            xcss: (0, $ecnYn.xcss)({
                color: 'color.text.success'
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            label: "",
            color: "var(--ds-icon-accent-green, #22A06B)",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.createRuleSuccess)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: disableCreateRule ? 'primary' : 'link',
            onClick: ()=>{
                handleRedirectToRuleBuilder();
            },
            spacing: disableCreateRule ? 'compact' : 'none'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.editInRuleBuilder)), !disableCreateRule ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
            appearance: "primary",
            spacing: "compact",
            isLoading: loading,
            onClick: handleOnClickCreateRule
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.createRule)) : null);
    };
    if (displayPrompt) return displayMode === 'modal' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill",
        space: "space.150",
        xcss: (0, $ecnYn.xcss)({
            padding: 'space.150',
            backgroundColor: 'color.background.accent.gray.subtlest'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, message)), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3dbeeac5567d9c48$var$insightMessageStyles
    }, insightMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.200",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: handleDismiss,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: ()=>setShouldDisplayPrompt(false),
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5v7QA.commonI18n).showMeHow)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ), {
        xcss: (0, $ecnYn.xcss)({
            borderColor: 'color.border',
            borderStyle: 'solid',
            borderRadius: 'radius.large',
            borderWidth: 'border.width',
            backgroundColor: 'color.background.neutral',
            padding: 'space.200'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle-link",
        onClick: handleDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: ()=>setShouldDisplayPrompt(false),
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5v7QA.commonI18n).showMeHow)))), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $3dbeeac5567d9c48$var$insightMessageInContextStyles
    }, insightMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        grow: "fill",
        space: "space.150",
        xcss: [
            $3dbeeac5567d9c48$var$defaultInContextPromptContainerStyles,
            customContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.200",
        xcss: (0, $ecnYn.xcss)({
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        space: "space.200",
        alignBlock: "center"
    }, isAnimationFinished ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, templateDescription), displayMode === 'in-context' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.200"
    }, renderInContextActionButtons())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.buildingRule), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, ".")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dbeeac5567d9c48$var$ConditionalWrapper, {
        condition: ruleComponentAlignment === 'stack',
        WrapperIfTrue: $3dbeeac5567d9c48$var$StackWrapper,
        WrapperIfFalse: $3dbeeac5567d9c48$var$InlineWrapper
    }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child, componentNumber)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            isSkeleton: componentNumber === animationState,
            isHidden: componentNumber > animationState
        });
        return child;
    })), !!insightMessage && isAnimationFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, insightMessage), isAnimationFinished && displayMode === 'modal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "end",
        space: "space.200"
    }, renderInContextActionButtons())), mutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }));
};
const $3dbeeac5567d9c48$export$bff0256bf4beef8c = (0, $7aRa9.withFlags)((0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($3dbeeac5567d9c48$var$InContextRuleBuilder));
module.exports["InContextAutomationPrompt"] = $3dbeeac5567d9c48$export$bff0256bf4beef8c;

});

parcelRegister("9KNO1", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $1UApO = parcelRequire("1UApO");

/**
 * Here we will check if devWatch is running and if so, we will use the associated dev stack.
 */ const $0691681f8bad8323$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await (0, $f7B1p.cfetch)('https://localhost:8082/devStack.json', {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'omit'
        });
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from https://localhost:8082/devStack.json with error: ${e}`);
        return null;
    }
};
const $0691681f8bad8323$export$6123178d3f5fb24d = async (environment)=>{
    switch(environment){
        case 'DEVELOPMENT':
        case 'STAGING':
            return await $0691681f8bad8323$var$getAutomationDevStackFromLocalServer() || window.localStorage.getItem((0, $1UApO.keys).AUTOMATION_PLATFORM_STACK) || 'staging';
        default:
            return 'pro';
    }
};
module.exports["getAutomationStack"] = $0691681f8bad8323$export$6123178d3f5fb24d;

});

parcelRegister("d0Ide", function(module, exports) {
var $fe73de88bf54921d$export$288b04954abdcf5 = /*#__PURE__*/ function(EventSourceName) {
    EventSourceName["ADD_LABEL_TO_PAGE"] = "automationDiscoveryWhenLabelAddedToPage";
    EventSourceName["MEETING_NOTES"] = "automationDiscoveryWhenPublishingMeetingNotes";
    EventSourceName["ARCHIVE_PAGE"] = "automationDiscoveryWhenArchivingPage";
    EventSourceName["HOVER_OVER_PAGE_TITLE"] = "automationDiscoveryFromHoverOverPageTitle";
    EventSourceName["JIRA_LINK"] = "automationDiscoveryJiraLink";
    EventSourceName["MANUAL_TRIGGER"] = "automationDiscoveryManualTrigger";
    EventSourceName["MANUAL_TRIGGER_SMART_BUTTON"] = "automationDiscoveryManualTriggerSmartButton";
    EventSourceName["IN_CONTEXT_RULE_BUILDER"] = "automationDiscoveryInContextRuleBuilder";
    EventSourceName["VERIFED_CONTENT"] = "automationDiscoveryVerifiedContent";
    EventSourceName["BULK_ARCHIVE"] = "automationDiscoveryBulkArchive";
    EventSourceName["GLOBAL_PUBLIC_LINKS"] = "automationDiscoveryGlobalPermissions";
    EventSourceName["PAGE_PUBLIC_LINKS"] = "automationDiscoverPageShare";
    EventSourceName["BULK_ASSIGN"] = "automationDiscoverySpaceAssignedBulk";
    EventSourceName["SINGLE_ASSIGN"] = "automationDiscoverySpaceAssignedSingle";
    EventSourceName["DEFAULT_SPACE_ASSIGN"] = "automationDiscoveryDefaultSpaceAssigned";
    EventSourceName["WHITE_BOARDS"] = "automationDiscoveryPublishWhiteBoards";
    EventSourceName["SHARE_SLACK"] = "automationDiscoveryShareSlack";
    EventSourceName["BULK_CHANGE_OWNER"] = "automationDiscoveryBulkChangePageOwner";
    EventSourceName["PRODUCT_REQUIREMENTS"] = "automationDiscoveryProductRequirements";
    EventSourceName["FEEDBACK_ANALYSIS"] = "automationDiscoveryFeedbackAnalysis";
    EventSourceName["RELEASE_NOTES"] = "automationDiscoveryReleaseNotes";
    return EventSourceName;
}({});
module.exports["EventSourceName"] = $fe73de88bf54921d$export$288b04954abdcf5;

});

parcelRegister("2HPSp", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $02196f736713ab99$export$869e231d926edfce = /*#__PURE__*/ function(TemplateParameterTypeEnum) {
    TemplateParameterTypeEnum["TEXT"] = "TEXT";
    TemplateParameterTypeEnum["NUMBER"] = "NUMBER";
    TemplateParameterTypeEnum["BOOLEAN"] = "BOOLEAN";
    return TemplateParameterTypeEnum;
}({});
const $02196f736713ab99$var$defaultContext = {
    templateApiParameters: {},
    setParameterByKey: ()=>{},
    removeParameterByKey: ()=>{}
};
const $02196f736713ab99$export$b1e136c3301c05ad = /*#__PURE__*/ (0, $42omo.createContext)($02196f736713ab99$var$defaultContext);
const $02196f736713ab99$export$6cdc09e06812d6d1 = ({ children: children })=>{
    const [parameters, setParameters] = (0, $42omo.useState)({});
    const setParameterByKey = (0, $42omo.useCallback)((key, value)=>{
        setParameters((prev)=>({
                ...prev,
                [key]: value
            }));
    }, [
        setParameters
    ]);
    const removeParameterByKey = (0, $42omo.useCallback)((key)=>{
        setParameters((prev)=>{
            const newParameters = {
                ...prev
            };
            delete newParameters[key];
            return newParameters;
        });
    }, [
        setParameters
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            templateApiParameters: parameters,
            setParameterByKey: setParameterByKey,
            removeParameterByKey: removeParameterByKey
        }), [
        parameters,
        setParameterByKey,
        removeParameterByKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($02196f736713ab99$export$b1e136c3301c05ad.Provider, {
        value: contextValue
    }, children);
};
module.exports["TemplateParameterTypeEnum"] = $02196f736713ab99$export$869e231d926edfce;
module.exports["InContextRuleBuilderContext"] = $02196f736713ab99$export$b1e136c3301c05ad;
module.exports["InContextRuleBuilderProvider"] = $02196f736713ab99$export$6cdc09e06812d6d1;

});

parcelRegister("5v7QA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $aXWIB = parcelRequire("aXWIB");

const $9b11c5b093926f82$export$242890b69747c0cf = (0, $aXWIB.defineMessages)({
    dismiss: {
        id: "automation-discovery.common.dismiss",
        defaultMessage: "Not now"
    },
    showMeHow: {
        id: "automation-discovery.common.show-me-how",
        defaultMessage: "Show me how"
    },
    spotlightCta: {
        id: "automation-discovery.manual-trigger.cta.text",
        defaultMessage: "Build rule"
    },
    spotlightDismiss: {
        id: "automation-discovery.manual-trigger.dismiss",
        defaultMessage: "Done"
    }
});
const $9b11c5b093926f82$export$eaeae0ae54954c9a = (0, $aXWIB.defineMessages)({
    header: {
        id: "automation-discovery.hover-page-title.header",
        defaultMessage: "Auto-archive old pages?"
    },
    message: {
        id: "automation-discovery.hover-page-title.message",
        defaultMessage: "This page hasn\u2019t been updated lately. An Automation rule could archive old pages once a month."
    }
});
const $9b11c5b093926f82$export$6216ba99d37b53d2 = (0, $aXWIB.defineMessages)({
    header: {
        id: "automation-discovery.archive.from-archive-modal",
        defaultMessage: "Confluence can auto-archive old pages"
    },
    message: {
        id: "automation-discovery.archive.message",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "Try building this Automation rule: Archive pages in this space that haven't been updated in at least 3 months."
    },
    success: {
        id: "automation-discovery.archive.success",
        defaultMessage: "Your page was archived"
    },
    successHeader: {
        id: "automation-discovery.archive.success-header",
        defaultMessage: "Archived successfully"
    },
    viewInArchive: {
        id: "automation-discovery.archive.view-in-archive",
        defaultMessage: "View in archive"
    }
});
const $9b11c5b093926f82$export$e252be6159b8f418 = (0, $aXWIB.defineMessages)({
    title: {
        id: "automation-discovery.add-label.title",
        defaultMessage: "Confluence can auto-add labels"
    },
    message: {
        id: "automation-discovery.add-label.message",
        defaultMessage: "Try building this Automation rule: When the user you choose publishes a new page, label it with their name."
    }
});
const $9b11c5b093926f82$export$defcdcbe29897057 = (0, $aXWIB.defineMessages)({
    success: {
        id: "automation-discovery.meeting-notes.success",
        defaultMessage: "Your page was published"
    },
    title: {
        id: "automation-discovery.meeting-notes.title",
        defaultMessage: "Confluence can auto-publish pages"
    },
    message: {
        id: "automation-discovery.meeting-notes.message",
        defaultMessage: "Try building this Automation rule: Publish a new Meeting notes page according to your meeting schedule."
    },
    ctaText: {
        id: "automation-discovery.meeting-notes.cta.text",
        defaultMessage: "Auto-summarize pages?"
    },
    modalBody: {
        id: "automation-discovery.meeting-notes.modal.body",
        defaultMessage: "{publishedPageTitle} was successfully published in the {spaceName} space"
    },
    successIconLabel: {
        id: "automation-discovery.meeting-notes.success.icon.label",
        defaultMessage: "Success check icon"
    },
    modalCloseIconLabel: {
        id: "automation-discovery.meeting-notes.modal.close.icon.label",
        defaultMessage: "Close icon for modal"
    }
});
const $9b11c5b093926f82$export$ce468634859ccf2b = (0, $aXWIB.defineMessages)({
    ctaText: {
        id: "automation-discovery.jira-link.cta.text",
        defaultMessage: "Auto-link Jira issues?"
    }
});
const $9b11c5b093926f82$export$51183073ec843a06 = (0, $aXWIB.defineMessages)({
    title: {
        id: "automation-discovery.manual-trigger.title",
        defaultMessage: "Page automation menu"
    },
    body: {
        id: "automation-discovery.manual-trigger.body",
        defaultMessage: "Teammates can apply rules from this menu to a single page."
    }
});
const $9b11c5b093926f82$export$4cf5be76251112af = (0, $aXWIB.defineMessages)({
    title: {
        id: "automation-discovery.verified-content.title",
        defaultMessage: "Want to manage your verified pages?"
    },
    body: {
        id: "automation-discovery.verified-content.body",
        defaultMessage: "Use Confluence automation to schedule reviews for verified content."
    }
});
const $9b11c5b093926f82$export$6b1f7d6fd8c7714c = (0, $aXWIB.defineMessages)({
    productivityTimeSavedMessage: {
        id: "automation-discovery.productivity-insights.time-saved.message",
        defaultMessage: "Save your team <b>{timeSaved, plural, one {{timeSaved} minute} other {{timeSaved} minutes}}</b> per quarter by setting up this automation rule!"
    }
});
module.exports["commonI18n"] = $9b11c5b093926f82$export$242890b69747c0cf;
module.exports["hoverPageTitleI18n"] = $9b11c5b093926f82$export$eaeae0ae54954c9a;
module.exports["archiveMessagesI18n"] = $9b11c5b093926f82$export$6216ba99d37b53d2;
module.exports["labelMessagesI18n"] = $9b11c5b093926f82$export$e252be6159b8f418;
module.exports["meetingNotesI18n"] = $9b11c5b093926f82$export$defcdcbe29897057;
module.exports["jiraLinkI18n"] = $9b11c5b093926f82$export$ce468634859ccf2b;
module.exports["productivityInsightsI18n"] = $9b11c5b093926f82$export$6b1f7d6fd8c7714c;

});

parcelRegister("5scZK", function(module, exports) {

var $9o40q = parcelRequire("9o40q");

const $d71603234ecc6b8d$export$b60b821c3d861f36 = ({ onCompleted: onCompleted, onError: onError })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ cloudId: cloudId, automationStack: automationStack })=>`/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/public/rest/v1/template/create`,
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: ({ templateId: templateId, cloudId: cloudId, spaceId: spaceId, parameters: parameters })=>{
            const ruleHome = spaceId ? `ari:cloud:confluence:${cloudId}:space/${spaceId}` : `ari:cloud:confluence::site/${cloudId}`;
            let formattedParameters = null;
            if (parameters) {
                formattedParameters = {};
                for (const parameter of parameters)formattedParameters[parameter.name] = {
                    value: parameter.value,
                    type: parameter.type
                };
            }
            return JSON.stringify({
                templateId: templateId,
                ruleHome: ruleHome,
                parameters: formattedParameters
            });
        },
        parseResult: ({ ruleId: ruleId, ruleUuid: ruleUuid })=>({
                experimentalCreateAutomationRuleFromTemplate: {
                    ruleId: ruleId,
                    ruleUuid: ruleUuid
                }
            }),
        onCompleted: onCompleted,
        onError: onError
    });
};
var $d71603234ecc6b8d$var$TemplateParameterTypeEnum = /*#__PURE__*/ function(TemplateParameterTypeEnum) {
    TemplateParameterTypeEnum["BOOLEAN"] = "BOOLEAN";
    TemplateParameterTypeEnum["NUMBER"] = "NUMBER";
    TemplateParameterTypeEnum["TEXT"] = "TEXT";
    return TemplateParameterTypeEnum;
}($d71603234ecc6b8d$var$TemplateParameterTypeEnum || {});
module.exports["useExperimentalCreateAutomationRuleFromTemplateMutation"] = $d71603234ecc6b8d$export$b60b821c3d861f36;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("3JQXa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e2866f1e30f0246d$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = (0, $42omo.useCallback)(async (value)=>{
        // check if the browser supports the clipboard API
        if (value && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') await navigator.clipboard.writeText(value);
    }, []);
    return (0, $42omo.useMemo)(()=>({
            copyToClipboard: copyToClipboard
        }), [
        copyToClipboard
    ]);
};
module.exports["useCopyToClipboard"] = $e2866f1e30f0246d$export$b2199c37e85de4a7;

});

parcelRegister("2wSyg", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext = /*#__PURE__*/ (0, $42omo.createContext)({
    getIsPublishing: ()=>false,
    setIsPublishing: (_)=>{
    // Intentional no-op
    },
    isPublishing: false
});
const $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8 = ({ children: children })=>{
    // These should remain in sync. The ref is used while a draft sync occurs, while
    // the state variable is used for re-rendering.
    const isPublishingRef = (0, $42omo.useRef)(false);
    const [isPublishing, setIsPublishing] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const getIsPublishing = (0, $42omo.useCallback)(()=>isPublishingRef.current, []);
    const setPublishing = (0, $42omo.useCallback)((value)=>{
        isPublishingRef.current = value;
        setIsPublishing(value);
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>({
            getIsPublishing: getIsPublishing,
            setIsPublishing: setPublishing,
            isPublishing: isPublishing
        }), [
        getIsPublishing,
        setPublishing,
        isPublishing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext.Provider, {
        value: contextValue
    }, children);
};
const $87bc0f5ac3c4b9fb$export$bceb447197cf2e23 = ({ children: children })=>{
    const context = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4();
    return children(context);
};
const $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4 = ()=>{
    return (0, $42omo.useContext)($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext);
};
module.exports["DraftSyncAndPublishContextProvider"] = $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8;
module.exports["DraftSyncAndPublishContextConsumer"] = $87bc0f5ac3c4b9fb$export$bceb447197cf2e23;
module.exports["useDraftSyncAndPublishContext"] = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4;

});

parcelRegister("d9uxk", function(module, exports) {
/**
 * @generated SignedSource<<10f69d30b5361424ab8d9103cfee3b47>>
 * @relayHash 3e8398ac4cc35cda2ed93f4628fc8a69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd
const $39137d315768d978$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceDataLifecycleManagementPolicy",
            "kind": "LinkedField",
            "name": "confluence_dataLifecycleManagementPolicy",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDataRetentionPolicyStatus",
                    "kind": "LinkedField",
                    "name": "dataRetentionPolicyDetailsForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "policyEnabledStatus"
                        },
                        {
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "disabledOnDate",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e8398ac4cc35cda2ed93f4628fc8a69",
            "id": "011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd",
            "metadata": {},
            "name": "useDataRetentionDetailsQuery",
            "operationKind": "query",
            "text": "query useDataRetentionDetailsQuery($cloudId:ID!){confluence_dataLifecycleManagementPolicy(cloudId:$cloudId){dataRetentionPolicyDetailsForWorkspace{policyEnabledStatus,disabledOnDate{value}}}}"
        }
    };
}();
$39137d315768d978$var$node.hash = "0241f940fae6659cf9e57c7aaae37fa7";
var $39137d315768d978$export$2e2bcd8739ae039 = $39137d315768d978$var$node;
module.exports["default"] = $39137d315768d978$export$2e2bcd8739ae039;

});

parcelRegister("3pU8m", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $3scmi = parcelRequire("3scmi");


var $56M4r = parcelRequire("56M4r");


var $iTh4n = parcelRequire("iTh4n");


var $jwNgW = parcelRequire("jwNgW");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $a61a6d10c0a933b0$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $jwNgW.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3scmi.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $iTh4n.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $a61a6d10c0a933b0$export$2e2bcd8739ae039 = $a61a6d10c0a933b0$var$DropdownItemCheckbox;
module.exports["default"] = $a61a6d10c0a933b0$export$2e2bcd8739ae039;

});

parcelRegister("iTh4n", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $ade312c7505f4d8d$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $ade312c7505f4d8d$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $ade312c7505f4d8d$export$2e2bcd8739ae039 = $ade312c7505f4d8d$var$CheckboxIcon;
module.exports["default"] = $ade312c7505f4d8d$export$2e2bcd8739ae039;

});

parcelRegister("jwNgW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1FJYC = parcelRequire("1FJYC");


var $5g4rt = parcelRequire("5g4rt");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $05848c92b720c3b2$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $42omo.useContext)((0, $5g4rt.SelectionStoreContext));
    const groupId = (0, $42omo.useContext)((0, $1FJYC.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $05848c92b720c3b2$export$2e2bcd8739ae039 = $05848c92b720c3b2$var$useCheckboxState;
module.exports["default"] = $05848c92b720c3b2$export$2e2bcd8739ae039;

});

parcelRegister("1FJYC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5d17552b6cb2fab4$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $42omo.createContext)('');
module.exports["CheckboxGroupContext"] = $5d17552b6cb2fab4$export$baf37c4be89255b8;

});

parcelRegister("fKL7x", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");


var $1FJYC = parcelRequire("1FJYC");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1FJYC.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $b6be4855f2bf1ca8$export$2e2bcd8739ae039 = $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup;
module.exports["default"] = $b6be4855f2bf1ca8$export$2e2bcd8739ae039;

});

parcelRegister("7B9wr", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");

const $e0dcf0245d0f4db8$export$8ee67841592dfd9f = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    return contentType !== (0, $1ggpj.ContentType).DATABASE && !(0, $1ggpj.isCanvasContentType)(contentType) && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux');
};
module.exports["useIsNewDanglingCommentExperienceEnabled"] = $e0dcf0245d0f4db8$export$8ee67841592dfd9f;

});

parcelRegister("6hmtW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $42omo.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $42omo.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $42omo.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $42omo.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $42omo.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $42omo.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("fy5yb", function(module, exports) {

var $cUycv = parcelRequire("cUycv");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");

const $747cae967af72a91$export$765c3cc11af57952 = (unresolvedInlineComments)=>Object.fromEntries(unresolvedInlineComments.map((annotationId)=>[
            annotationId,
            {
                id: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                state: (0, $cUycv.AnnotationMarkStates).RESOLVED
            }
        ]));
const $747cae967af72a91$var$extractAllComments = (commentsDataMap)=>Object.values(commentsDataMap).flatMap((dataMap)=>Object.values(dataMap));
const $747cae967af72a91$var$excludeDraftComments = (comments)=>comments.filter((comment)=>comment.contentStatus !== 'draft');
const $747cae967af72a91$var$extractUnresolvedCommentIds = (comments)=>comments.filter((comment)=>comment.isOpen).map((comment)=>comment.id);
const $747cae967af72a91$export$8407ff9f3ad87778 = (commentsDataMap, includeDrafts)=>{
    const allParentComments = includeDrafts ? $747cae967af72a91$var$extractAllComments(commentsDataMap) : $747cae967af72a91$var$excludeDraftComments($747cae967af72a91$var$extractAllComments(commentsDataMap));
    return $747cae967af72a91$var$extractUnresolvedCommentIds(allParentComments);
};
const $747cae967af72a91$var$COMMENTS_LOCATIONS = {
    INLINE: 'INLINE',
    FOOTER: 'FOOTER'
};
const $747cae967af72a91$export$e25befbc00a116b = (resolvedComments, commentData)=>{
    if (!resolvedComments?.comments?.nodes) return commentData;
    const resolvedCommentNodes = resolvedComments.comments.nodes.filter((node)=>node !== null);
    const updateComments = (comments, locationType, commentType)=>Object.keys(comments).reduce((acc, key)=>{
            const comment = comments[key];
            const resolvedComment = resolvedCommentNodes.find((resolved)=>locationType === $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE ? resolved.location.inlineMarkerRef === key && resolved.location.type === locationType : resolved.id === key && resolved.location.type === locationType);
            if (resolvedComment && comment.isOpen) return {
                ...acc,
                [key]: {
                    ...resolvedComment,
                    isOpen: false,
                    type: commentType
                }
            };
            else return {
                ...acc,
                [key]: comment
            };
        }, {});
    const updatedInlineComments = updateComments(commentData.inline, $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE, (0, $8i27m.CommentType).INLINE);
    const updatedGeneralComments = updateComments(commentData.general, $747cae967af72a91$var$COMMENTS_LOCATIONS.FOOTER, (0, $8i27m.CommentType).GENERAL);
    return {
        inline: updatedInlineComments,
        general: updatedGeneralComments
    };
};
const $747cae967af72a91$export$4e544898773875e3 = ({ isReply: isReply, threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    if (isReply || !(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: {
            [threadKey]: commentsDataMap.inline[threadKey]
        },
        [(0, $8i27m.CommentType).GENERAL]: {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
const $747cae967af72a91$export$36d96c1319999e05 = ({ threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    const parentComment = commentsDataMap[commentType][threadKey];
    if (!parentComment) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: commentType === (0, $8i27m.CommentType).INLINE ? {
            [threadKey]: parentComment
        } : {},
        [(0, $8i27m.CommentType).GENERAL]: commentType === (0, $8i27m.CommentType).GENERAL ? {
            [threadKey]: parentComment
        } : {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
const $747cae967af72a91$export$485aa15bd11fefca = ({ threadKey: threadKey, commentId: commentId, commentType: commentType, commentsDataMap: commentsDataMap, handleRemovingComments: handleRemovingComments })=>{
    const parentComment = commentsDataMap[commentType][threadKey];
    if (!parentComment) return null;
    const replies = parentComment.replies;
    const deletedReplyComment = replies.find((reply)=>reply.id === commentId);
    if (!deletedReplyComment) return null;
    handleRemovingComments({
        threadKey: threadKey,
        commentId: commentId,
        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
        commentType: commentType
    });
    return deletedReplyComment;
};
module.exports["getResolvedAnnotationState"] = $747cae967af72a91$export$765c3cc11af57952;
module.exports["computeResolvedCommentIds"] = $747cae967af72a91$export$8407ff9f3ad87778;
module.exports["updateResolvedComments"] = $747cae967af72a91$export$e25befbc00a116b;
module.exports["deleteInlineParentComment"] = $747cae967af72a91$export$4e544898773875e3;
module.exports["deleteParentCommentOptimistically"] = $747cae967af72a91$export$36d96c1319999e05;
module.exports["deleteReplyCommentOptimistically"] = $747cae967af72a91$export$485aa15bd11fefca;

});

parcelRegister("b4BfG", function(module, exports) {

var $hMac6 = parcelRequire("hMac6");


var $42omo = parcelRequire("42omo");


var $lesF8 = parcelRequire("lesF8");


var $7EEGh = parcelRequire("7EEGh");


var $jMyy4 = parcelRequire("jMyy4");


var $hXzKU = parcelRequire("hXzKU");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $7QM6o = parcelRequire("7QM6o");

const $a75b2138c8eb75e6$export$b9905c4f8315d0a1 = ({ mode: mode, saveHandler: saveHandler, cancelHandler: cancelHandler, onEditorLoaded: onEditorLoaded, onEditorReady: onEditorReady, onEditorContentChanged: onEditorContentChanged, onEditorContentChangedWithData: onEditorContentChangedWithData, afterActivate: afterActivate, content: content, useNewExperienceAbort: useNewExperienceAbort, expandEditor: expandEditor, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment = false, isOffline: isOffline = false })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $hMac6.default), {
        variables: {
            contentId: contentId ?? ''
        },
        skip: !contentId
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const operations = (0, $42omo.useMemo)(()=>data?.content?.nodes?.[0]?.operations ?? [], [
        data
    ]);
    // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $42omo.useMemo)(()=>(0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? data?.content?.nodes?.[0]?.space?.operations || [] : [], [
        data
    ]);
    const canEditPage = (0, $42omo.useMemo)(()=>operations.filter((op)=>op?.operation === 'update' && op?.targetType === contentType).length > 0, [
        operations,
        contentType
    ]);
    const canAddComment = (0, $42omo.useMemo)(()=>operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment'), [
        operations
    ]);
    const canAddAttachment = (0, $42omo.useMemo)(()=>operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'), [
        operations,
        spaceOperations
    ]);
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : canEditPage;
    // Simulate the unmount function for the other editor
    (0, $42omo.useEffect)(()=>()=>{
            cancelHandler({
                isEditorAborted: false
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $42omo.useEffect)(()=>{
        const handleExperienceAbort = ()=>{
            const reason = 'Navigated away from page';
            if (mode === 'edit') experienceTracker.abort({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else if (mode === 'reply') experienceTracker.abort({
                name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else experienceTracker.abort({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
        };
        if (useNewExperienceAbort) window.addEventListener('beforeunload', handleExperienceAbort);
        return ()=>{
            if (useNewExperienceAbort) window.removeEventListener('beforeunload', handleExperienceAbort);
        };
    }, [
        experienceTracker,
        mode,
        useNewExperienceAbort
    ]);
    const handleSave = (0, $42omo.useCallback)((adf, onSuccess)=>saveHandler({
            adf: adf
        }, onSuccess).catch((err)=>{
            // There is another handler higher up to re-enable the buttons, throw the error to allow for that
            throw err;
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        saveHandler
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        cancelHandler({
            isEditorAborted: true
        });
    }, [
        cancelHandler
    ]);
    const handleEditorReady = (0, $42omo.useCallback)((editorActions)=>{
        onEditorLoaded();
        onEditorReady?.(editorActions);
    }, [
        onEditorLoaded,
        onEditorReady
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditorWithoutSpinner), {
        pageId: contentId,
        pageType: contentType,
        appearance: isCommentsPanel ? 'chromeless' : 'comment',
        EditorComponent: isCommentsPanel ? (0, $7EEGh.ChromelessEditor) : (0, $lesF8.CommentEditor),
        commentMode: mode,
        commentType: "page",
        spaceId: spaceId,
        onSaveComment: handleSave,
        content: content,
        onCancelComment: handleCancel,
        onEditorReady: handleEditorReady,
        onContentChange: onEditorContentChanged,
        onContentChangeWithData: onEditorContentChangedWithData,
        afterActivation: afterActivate,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        shouldWarnOnInternalNavigation: true,
        expandEditor: expandEditor,
        showCancelButton: isCommentsPanel || isFooterComment,
        useNewWarningModal: isCommentsPanel || isFooterComment,
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isOffline: isOffline
    });
};
module.exports["PageCommentEditor"] = $a75b2138c8eb75e6$export$b9905c4f8315d0a1;

});

parcelRegister("hMac6", function(module, exports) {
/**
 * @generated SignedSource<<15c613af7160fefd3f38ff1aff4cb0be>>
 * @relayHash 84a9c75863296610fb60639c2398b5f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608
const $e6c37684dc7bdb3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageCommentEditorContentOperationsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageCommentEditorContentOperationsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "84a9c75863296610fb60639c2398b5f3",
            "id": "f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608",
            "metadata": {},
            "name": "PageCommentEditorContentOperationsQuery",
            "operationKind": "query",
            "text": "query PageCommentEditorContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}}}"
        }
    };
}();
$e6c37684dc7bdb3d$var$node.hash = "84986896d9e1b1e2bb0707f822adf359";
var $e6c37684dc7bdb3d$export$2e2bcd8739ae039 = $e6c37684dc7bdb3d$var$node;
module.exports["default"] = $e6c37684dc7bdb3d$export$2e2bcd8739ae039;

});

parcelRegister("lesF8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $6cQbn = parcelRequire("6cQbn");

function $0eec8481dd12dbe1$export$4153d6fbc2386422(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $6cQbn.CommentEditorWithIntl)
    });
}
module.exports["CommentEditor"] = $0eec8481dd12dbe1$export$4153d6fbc2386422;

});

parcelRegister("7EEGh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $1PKpt = parcelRequire("1PKpt");

function $c97a308eea576e63$export$5252bd745392dcde(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $1PKpt.default)
    });
}
module.exports["ChromelessEditor"] = $c97a308eea576e63$export$5252bd745392dcde;

});

parcelRegister("cOau5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kycWk = parcelRequire("kycWk");


var $F4YLX = parcelRequire("F4YLX");


const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    return {
        title: 'Redaction',
        type: (0, $kycWk.REDACTION_EXTENSION_TYPE),
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("fSxYU"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("fSxYU", function(module, exports) {

let $b8f6422d7c09d941$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8f6422d7c09d941$var$load("3XbzG").then(()=>parcelRequire('4s2T0'));

});

parcelRegister("i5WUp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2Rith = parcelRequire("2Rith");

var $fYQcF = parcelRequire("fYQcF");


var $9Rf00 = parcelRequire("9Rf00");

var $au4KV = parcelRequire("au4KV");


var $gWF6I = parcelRequire("gWF6I");


var $9NDUe = parcelRequire("9NDUe");

var $2Gu9D = parcelRequire("2Gu9D");


var $in8wv = parcelRequire("in8wv");


var $kt1Xc = parcelRequire("kt1Xc");


var $2UyBL = parcelRequire("2UyBL");

const $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $990b0c00f1a7800f$var$DEFAULT_MAX_LINES = 4;
const $990b0c00f1a7800f$var$styles = {
    container: "_11c8wadc"
};
const $990b0c00f1a7800f$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $990b0c00f1a7800f$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $990b0c00f1a7800f$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    });
const $990b0c00f1a7800f$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: $990b0c00f1a7800f$var$getAnalyticsConfig(props),
        children: /*#__PURE__*/ (0, $l998X.jsx)($990b0c00f1a7800f$export$ac90160f7ae1e32f, {
            ...props
        })
    });
};
const $990b0c00f1a7800f$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $990b0c00f1a7800f$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $irOoi.useQueryLoader)((0, $2UyBL.default));
    const isLoadingRef = (0, $42omo.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $2Gu9D.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $990b0c00f1a7800f$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $dh538.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $42omo.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        };
    // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $in8wv.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($990b0c00f1a7800f$var$styles.container),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {}),
                children: queryRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kt1Xc.AISnippetLoader), {
                    queryRef: queryRef,
                    fallbackText: fallbackText,
                    contentId: contentId,
                    source: source,
                    isHidden: isHidden,
                    maxLines: maxLines,
                    showFooter: showFooter,
                    showAwareness: showAwareness
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $au4KV.AIStreamLoading), {})
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: isEnabledForJira ? content : /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
            entrypointId: $990b0c00f1a7800f$var$SNIPPET_ENTRYPOINT_ID,
            userId: userId,
            displayName: displayName,
            children: content
        })
    });
};
const $990b0c00f1a7800f$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($990b0c00f1a7800f$export$1b2af18ca4bb327b, {
            ...props
        })
    });
};
module.exports["AISnippetWithRelayEnvironment"] = $990b0c00f1a7800f$export$c9a07cebec67e951;

});

parcelRegister("9Rf00", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $a07f007de41f1483$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a07f007de41f1483$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $a07f007de41f1483$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $aXWIB.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a07f007de41f1483$export$f906c21bacdb2d8e.Provider, {
        value: contextValue,
        children: children
    });
};
const $a07f007de41f1483$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $42omo.useContext)($a07f007de41f1483$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $a07f007de41f1483$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $a07f007de41f1483$export$ff3deb4415ee32e3;

});

parcelRegister("au4KV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $igbBp = parcelRequire("igbBp");

const $fe7ceaa3509ef4fa$var$styles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $fe7ceaa3509ef4fa$var$i18n = (0, $aXWIB.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: padding,
        xcss: $fe7ceaa3509ef4fa$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($fe7ceaa3509ef4fa$var$i18n.generatingSummaryAnimationAlt)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...$fe7ceaa3509ef4fa$var$i18n.generatingSummaryText
                })
            ]
        })
    });
};
module.exports["AIStreamLoading"] = $fe7ceaa3509ef4fa$export$47a62cbf3ee79fef;

});

parcelRegister("igbBp", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $dd45fdb3e38904f6$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "#0C66E4",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "#1D7AFC",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "#388BFF",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
module.exports["GeneratingStreamAnimation"] = $dd45fdb3e38904f6$export$3709887a1be0e305;

});

parcelRegister("2Gu9D", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

const $b5fd5f50ef335781$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $42omo.useRef)(new (0, $5aVN7.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $42omo.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $42omo.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $42omo.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $42omo.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $42omo.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $b5fd5f50ef335781$export$fade2d05a6320d49;

});

parcelRegister("in8wv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");


var $c6GJD = parcelRequire("c6GJD");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $fYQcF = parcelRequire("fYQcF");


var $aFC6o = parcelRequire("aFC6o");

var $iuafG = parcelRequire("iuafG");

var $aXh2V = parcelRequire("aXh2V");


var $fXbFR = parcelRequire("fXbFR");

const $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $b015c3cc5e677900$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $b015c3cc5e677900$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $42omo.useRef)(text);
    const isExperimentEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $c6GJD.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $42omo.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $42omo.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $b015c3cc5e677900$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.100",
        ref: ref,
        children: [
            showAwareness && /*#__PURE__*/ (0, $l998X.jsx)((0, $aFC6o.AIAwareness), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                maxLines: maxLines,
                children: renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    options: {
                        disableParsingRawHTML: true
                    },
                    children: $b015c3cc5e677900$var$sanitizeMarkdown(text || '')
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    children: text || ''
                }) : text || ''
            }),
            showFooter && text && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iuafG.AIDisclaimer), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aXh2V.AIFeedbackComponent), {
                        contentId: contentId,
                        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
                        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
                    })
                ]
            })
        ]
    });
};
module.exports["AISnippetContent"] = $b015c3cc5e677900$export$3cf37822a11d3ff3;

});

parcelRegister("aFC6o", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $lAFHW = parcelRequire("lAFHW");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $eLAh6 = parcelRequire("eLAh6");

const $902b2990c09c9892$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $902b2990c09c9892$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $eLAh6.i18n).rovoAwarenessMessage,
        define: (0, $eLAh6.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($902b2990c09c9892$var$styles.text),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                    size: "xxsmall",
                    appearance: "brand",
                    shouldUseNewLogoDesign: true
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: formatMessage(message)
                })
            ]
        })
    });
};
module.exports["AIAwareness"] = $902b2990c09c9892$export$fde99ed387d90f1;

});

parcelRegister("eLAh6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8e99185ad20025a1$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $8e99185ad20025a1$export$a7357cdd1f0b0168;

});

parcelRegister("iuafG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $2Nwuj = parcelRequire("2Nwuj");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $fSglY = parcelRequire("fSglY");

const $8fdbd961e8c69c33$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $8fdbd961e8c69c33$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $8fdbd961e8c69c33$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const disclaimerContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest",
        children: formatMessage((0, $fSglY.i18n).disclaimerMessage)
    });
    if (withLink) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        appearance: "subtle",
        href: $8fdbd961e8c69c33$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick,
        children: disclaimerContent
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8fdbd961e8c69c33$var$styles.text),
        children: disclaimerContent
    });
};
module.exports["AIDisclaimer"] = $8fdbd961e8c69c33$export$e0542ba0c737fe5c;

});

parcelRegister("fSglY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $fe37a92cb7b3dd3c$export$a7357cdd1f0b0168;

});

parcelRegister("aXh2V", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $biiXa = parcelRequire("biiXa");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $9Rf00 = parcelRequire("9Rf00");


var $aFwxm = parcelRequire("aFwxm");

const $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $00b0d3bf57a2c2c6$var$i18n = (0, $aXWIB.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $00b0d3bf57a2c2c6$var$PrivacyPolicyLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...$00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink
        })
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...$00b0d3bf57a2c2c6$var$i18n.privacyPolicyLink
        })
    });
const $00b0d3bf57a2c2c6$var$ResearchGroupLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...$00b0d3bf57a2c2c6$var$i18n.researchGroupLink
        })
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $l998X.jsx)("a", {
        target: "_blank",
        href: link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...$00b0d3bf57a2c2c6$var$i18n.researchGroupLink
        })
    });
const $00b0d3bf57a2c2c6$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...$00b0d3bf57a2c2c6$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$PrivacyPolicyLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...(0, $dh538.fg)('product-terminology-refresh') ? $00b0d3bf57a2c2c6$var$i18n.improveAtlassianTextAppify : $00b0d3bf57a2c2c6$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$ResearchGroupLink, {
                link: $00b0d3bf57a2c2c6$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $00b0d3bf57a2c2c6$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const feedbackCollectorProperties = (0, $9Rf00.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagTitle),
            description: formatMessage($00b0d3bf57a2c2c6$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation(),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.likeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $aFwxm.ThumbIcon), {
                                isSelected: hasGoodFeedbackBeenSubmitted
                            }),
                            onClick: handleLikeClicked,
                            testId: "feedback-like-button",
                            isDisabled: hasGoodFeedbackBeenSubmitted
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    hideTooltipOnMouseDown: true,
                    content: formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
                    position: "top",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $00b0d3bf57a2c2c6$var$ButtonWrapperXCSS,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            "aria-label": formatMessage($00b0d3bf57a2c2c6$var$i18n.dislikeTooltip),
                            spacing: "none",
                            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $00b0d3bf57a2c2c6$var$DislikeIconWrapperXCSS,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aFwxm.ThumbIcon), {
                                    isSelected: hasBadFeedbackBeenSubmitted
                                })
                            }),
                            onClick: handleDislikeClicked,
                            testId: "feedback-dislike-button",
                            isDisabled: hasBadFeedbackBeenSubmitted
                        })
                    })
                }),
                isFeedbackOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $biiXa.default), {
                    locale: feedbackCollectorProperties.locale,
                    onSubmit: onFeedbackSubmit,
                    onClose: ()=>setIsFeedbackOpen(false),
                    atlassianAccountId: feedbackCollectorProperties.userId,
                    name: feedbackCollectorProperties.displayName,
                    entrypointId: feedbackCollectorProperties.entrypointId,
                    summaryPlaceholder: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryPlaceholder),
                    additionalFields: [
                        {
                            id: feedbackCollectorProperties.feedbackContextId,
                            value: feedbackContextString
                        }
                    ],
                    feedbackTitle: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackTitle),
                    showTypeField: false,
                    customTextAreaLabel: formatMessage($00b0d3bf57a2c2c6$var$i18n.feedbackSummaryTitle),
                    canBeContactedLabel: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$CanContactLabel, {}),
                    enrolInResearchLabel: /*#__PURE__*/ (0, $l998X.jsx)($00b0d3bf57a2c2c6$var$EnrolLabel, {})
                })
            ]
        })
    });
};
module.exports["AIFeedbackComponent"] = $00b0d3bf57a2c2c6$export$f9f34317e5bc3551;

});

parcelRegister("biiXa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c4c27c8e6323826$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("29DUH")).default);


var $hrGQb = parcelRequire("hrGQb");


var $29DUH = parcelRequire("29DUH");


var $3c4c27c8e6323826$export$2e2bcd8739ae039 = (0, $hrGQb.default);

});

parcelRegister("hrGQb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $iA9co = parcelRequire("iA9co");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $2KPHZ = parcelRequire("2KPHZ");


var $gpfq4 = parcelRequire("gpfq4");


var $8zkrp = parcelRequire("8zkrp");

const $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $6b78f3070669f383$var$singleLineTruncatedText = (text, length = $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $gpfq4.default)(singleLineText, length);
};
class $6b78f3070669f383$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $6b78f3070669f383$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8zkrp.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            locale: this.props.locale,
            anonymousFeedback: (0, $dh538.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $2KPHZ.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $iA9co.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$6b78f3070669f383$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $6b78f3070669f383$export$2e2bcd8739ae039;

});

parcelRegister("2KPHZ", function(module, exports) {
const $defa15de0313af4d$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $defa15de0313af4d$export$f0f6fc934288a17c;

});

parcelRegister("gpfq4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bab40c5fbb12059f$export$2e2bcd8739ae039);
function $bab40c5fbb12059f$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("8zkrp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $7gpC4 = parcelRequire("7gpC4");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $kuB2l = parcelRequire("kuB2l");

var $jVhgp = parcelRequire("jVhgp");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");


var $aoVih = parcelRequire("aoVih");


var $6T8v4 = parcelRequire("6T8v4");


var $9EtP6 = parcelRequire("9EtP6");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $27c5bd5943874410$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        children: children
    });
};
const $27c5bd5943874410$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $42omo.useState)(false);
    const [description, setDescription] = (0, $42omo.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $42omo.useState)(false);
    const [type, setType] = (0, $42omo.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const [validationErrors, setValidationErrors] = (0, $42omo.useState)({});
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const canShowTextField = isTypeSelected() || !showTypeField;
    const hasDescription = description || hasDescriptionDefaultValue;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getValidationErrors = ()=>{
        const errors = {};
        // Validate type selection if showTypeField is true
        if (showTypeField && !isTypeSelected()) errors.type = formatMessage((0, $fSdY7.messages).validationErrorTypeRequired);
        // Validate description if showDefaultTextFields is true
        if (showDefaultTextFields && !hasDescription) errors.description = formatMessage((0, $fSdY7.messages).validationErrorDescriptionRequired);
        return errors;
    };
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $fSdY7.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $fSdY7.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $fSdY7.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $fSdY7.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $fSdY7.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $fSdY7.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $fSdY7.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $fSdY7.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $42omo.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabelAppify;
    };
    const renderContactLabel = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabel;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $l998X.jsxs)("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        },
        children: [
            formatMessage((0, $fSdY7.messages).requiredFieldsSummary),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
        ]
    });
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $l998X.jsx)("p", {
        children: formatMessage((0, $fSdY7.messages).feedbackIsAnonymous)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true,
        children: (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
            onSubmit: async ()=>{
                const errors = getValidationErrors();
                if (Object.keys(errors).length > 0) {
                    setValidationErrors(errors);
                    return;
                }
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: feedbackTitle || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $fSdY7.messages).feedbackTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                    children: [
                        (0, $dh538.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                        feedbackTitleDetails,
                        customContent,
                        showTypeField ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                            name: "topic",
                            label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
                            isRequired: true,
                            children: ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                            ...restProps,
                                            onChange: (option)=>{
                                                if (!option || option instanceof Array) return;
                                                setType(option.value);
                                                if (validationErrors.type) setValidationErrors((prev)=>({
                                                        ...prev,
                                                        type: undefined
                                                    }));
                                            },
                                            menuPortalTarget: document.body,
                                            styles: {
                                                menuPortal: (base)=>({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                            },
                                            options: selectOptions,
                                            // @ts-ignore
                                            ref: focusRef,
                                            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                            inputId: id
                                        }),
                                        validationErrors.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                            children: validationErrors.type
                                        })
                                    ]
                                })
                        }) : null,
                        showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
                                    isRequired: true,
                                    name: "description",
                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                    ...fieldProps,
                                                    name: "foo",
                                                    minimumRows: 6,
                                                    placeholder: summaryPlaceholder || undefined,
                                                    onChange: (e)=>{
                                                        setDescription(e.target.value);
                                                        if (validationErrors.description) setValidationErrors((prev)=>({
                                                                ...prev,
                                                                description: undefined
                                                            }));
                                                    },
                                                    value: description
                                                }),
                                                validationErrors.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                    children: validationErrors.description
                                                })
                                            ]
                                        })
                                }),
                                !anonymousFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $kuB2l.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("legend", {
                                            "aria-hidden": false,
                                            hidden: true,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                ...(0, $fSdY7.messages).optInOptionsLegend
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            name: "can-be-contacted",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: canBeContactedLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                                ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                    values: {
                                                                        a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                target: "_blank",
                                                                                children: chunks
                                                                            })
                                                                    }
                                                                }
                                                            }),
                                                            onChange: (event)=>setCanBeContacted(event.target.checked)
                                                        }),
                                                        canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: canBeContactedLink
                                                        }),
                                                        !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                target: "_blank",
                                                                children: formatMessage((0, $fSdY7.messages).privacyPolicy)
                                                            })
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            name: "enroll-in-research-group",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                                                            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                        }),
                                                        enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: enrolInResearchLink
                                                        })
                                                    ]
                                                })
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                        name: 'anonymousFeedback',
                                        children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                                title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                                                appearance: 'information',
                                                children: feedbackIsAnonymous
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: cancelButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $fSdY7.messages).cancelButtonLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            type: "submit",
                            isDisabled: isSubmitting || isDisabled,
                            testId: "feedbackCollectorSubmitBtn",
                            children: submitButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $fSdY7.messages).submitButtonLabel
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
            onSubmit: async ()=>{
                const errors = getValidationErrors();
                if (Object.keys(errors).length > 0) {
                    setValidationErrors(errors);
                    return;
                }
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                children: feedbackTitle || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $fSdY7.messages).feedbackTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                            children: [
                                (0, $dh538.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                                feedbackTitleDetails,
                                customContent,
                                showTypeField ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    name: "topic",
                                    label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
                                    isRequired: true,
                                    children: ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                                    ...restProps,
                                                    onChange: (option)=>{
                                                        if (!option || option instanceof Array) return;
                                                        setType(option.value);
                                                        if (validationErrors.type) setValidationErrors((prev)=>({
                                                                ...prev,
                                                                type: undefined
                                                            }));
                                                    },
                                                    menuPortalTarget: document.body,
                                                    styles: {
                                                        menuPortal: (base)=>({
                                                                ...base,
                                                                zIndex: 9999
                                                            })
                                                    },
                                                    options: selectOptions,
                                                    // @ts-ignore
                                                    ref: focusRef,
                                                    placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                                    inputId: id
                                                }),
                                                validationErrors.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                    children: validationErrors.type
                                                })
                                            ]
                                        })
                                }) : null,
                                showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
                                            isRequired: true,
                                            name: "description",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                            ...fieldProps,
                                                            name: "foo",
                                                            minimumRows: 6,
                                                            placeholder: summaryPlaceholder || undefined,
                                                            onChange: (e)=>{
                                                                setDescription(e.target.value);
                                                                if (validationErrors.description) setValidationErrors((prev)=>({
                                                                        ...prev,
                                                                        description: undefined
                                                                    }));
                                                            },
                                                            value: description
                                                        }),
                                                        validationErrors.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                            children: validationErrors.description
                                                        })
                                                    ]
                                                })
                                        }),
                                        !anonymousFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $kuB2l.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)("legend", {
                                                    "aria-hidden": false,
                                                    hidden: true,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                        ...(0, $fSdY7.messages).optInOptionsLegend
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                    name: "can-be-contacted",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: canBeContactedLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                                        ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                        ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                            values: {
                                                                                a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                        target: "_blank",
                                                                                        children: chunks
                                                                                    })
                                                                            }
                                                                        }
                                                                    }),
                                                                    onChange: (event)=>setCanBeContacted(event.target.checked)
                                                                }),
                                                                canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: canBeContactedLink
                                                                }),
                                                                !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                        target: "_blank",
                                                                        children: formatMessage((0, $fSdY7.messages).privacyPolicy)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                    name: "enroll-in-research-group",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                                                                    onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                                }),
                                                                enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: enrolInResearchLink
                                                                })
                                                            ]
                                                        })
                                                })
                                            ]
                                        }) || /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                name: 'anonymousFeedback',
                                                children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                                        title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                                                        appearance: 'information',
                                                        children: feedbackIsAnonymous
                                                    })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                    appearance: "subtle",
                                    onClick: onClose,
                                    children: cancelButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $fSdY7.messages).cancelButtonLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isDisabled: isSubmitting || isDisabled,
                                    testId: "feedbackCollectorSubmitBtn",
                                    children: submitButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $fSdY7.messages).submitButtonLabel
                                    })
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
const $27c5bd5943874410$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: locale,
        children: /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$FeedbackForm, {
            ...props
        })
    });
};
var $27c5bd5943874410$export$2e2bcd8739ae039 = $27c5bd5943874410$var$FeedbackFormWithIntl;
module.exports["default"] = $27c5bd5943874410$export$2e2bcd8739ae039;

});

parcelRegister("fSdY7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a10dc5cbcf39e7b4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabel: {
        id: "feedback-collector.can-be-contacted.label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppify: {
        id: "feedback-collector.can-be-contacted.label-appify",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $a10dc5cbcf39e7b4$export$defe85febe8b728c;

});

parcelRegister("giCws", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1tbUg = parcelRequire("1tbUg");

const $9a574d55f4cfa28d$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $1tbUg.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale,
        children: children
    });
};
module.exports["IntlProviderWithResolvedMessages"] = $9a574d55f4cfa28d$export$f793de1293176fe6;

});

parcelRegister("1tbUg", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ const $c02f8c9a6f146725$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};
module.exports["getMessagesForLocale"] = $c02f8c9a6f146725$export$d0a3169680473b6c;

});

parcelRegister("29DUH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $aD1SW = parcelRequire("aD1SW");


var $3sFtD = parcelRequire("3sFtD");


var $dh538 = parcelRequire("dh538");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $36b921ab0de27528$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $fSdY7.messages).feedbackSuccessFlagDescriptionAppify : (0, $fSdY7.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $fSdY7.messages).feedbackSuccessFlagTitle)
    });
};
const $36b921ab0de27528$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: props.locale,
        children: /*#__PURE__*/ (0, $l998X.jsx)($36b921ab0de27528$var$FeedbackFlag, {
            ...props
        })
    });
var $36b921ab0de27528$export$2e2bcd8739ae039 = $36b921ab0de27528$var$FeedbackFlagWithIntl;
module.exports["default"] = $36b921ab0de27528$export$2e2bcd8739ae039;

});

parcelRegister("aFwxm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $321f16821ba8d88a$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $321f16821ba8d88a$export$ec2ba0e929740f73;

});

parcelRegister("fXbFR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PxT5 = parcelRequire("4PxT5");

const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $d2d9cd8fe7c899bb$export$15dda63faa44a0df;

});

parcelRegister("4PxT5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $944e21aa736984a5$export$edb9b52ab3f1abbb;

});

parcelRegister("kt1Xc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $2UyBL = parcelRequire("2UyBL");

parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $9Rf00 = parcelRequire("9Rf00");


var $in8wv = parcelRequire("in8wv");

const $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $45557925e309956a$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $irOoi.usePreloadedQuery)((0, $2UyBL.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $in8wv.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $dh538.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Rf00.AIFeedbackPropertiesProvider), {
        entrypointId: $45557925e309956a$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name,
        children: content
    });
    return content;
};
module.exports["AISnippetLoader"] = $45557925e309956a$export$f50b64530422ea99;

});

parcelRegister("2UyBL", function(module, exports) {
/**
 * @generated SignedSource<<4c96b43036647f13e18ed303fd4483be>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $06d2529594a8e25b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$06d2529594a8e25b$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $06d2529594a8e25b$export$2e2bcd8739ae039 = $06d2529594a8e25b$var$node;
module.exports["default"] = $06d2529594a8e25b$export$2e2bcd8739ae039;

});

parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick, includeAgents);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("e4JJO", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");


var $ij2FZ = parcelRequire("ij2FZ");

const $8d8bfd1ce8e7d438$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $8d8bfd1ce8e7d438$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            const linkCount = node.marks?.some((mark)=>mark.type === 'link') ? currentValue.linkCount + 1 : currentValue.linkCount;
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $8d8bfd1ce8e7d438$var$wordCount(node.text),
                linkCount: linkCount
            };
        case 'mention':
            return {
                ...currentValue,
                mentionCount: currentValue.mentionCount + 1
            };
        case 'inlineCard':
        case 'embedCard':
            return {
                ...currentValue,
                linkCount: currentValue.linkCount + 1
            };
        case 'inlineExtension':
            if (node.attrs?.extensionKey === (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY) && node.attrs?.parameters?.slug) return {
                ...currentValue,
                explicitSkills: [
                    ...currentValue.explicitSkills,
                    node.attrs.parameters.slug
                ]
            };
            return currentValue;
    }
    return currentValue;
};
const $8d8bfd1ce8e7d438$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        adfLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        linkCount: 0,
        mentionCount: 0,
        explicitSkills: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$8d8bfd1ce8e7d438$var$processADFNode(currentValue, node), initialFeatures);
};
const $8d8bfd1ce8e7d438$export$c5df045f791f45da = (adf)=>(0, $1A9t2.reduce)(adf, (currentValue, node)=>node.type === 'text' && node.text ? currentValue + node.text : currentValue, '');
/**
 * Backtick-wrapped placeholders in prompt cards (e.g. `document`, `person`) are meant to be replaced by the user.
 * When comparing sent text to the card prompt, we treat these as variable and only require fixed segments to match.
 */ const $8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX = /`[^`]*`/g;
const $8d8bfd1ce8e7d438$export$2def72d3ef808307 = (normalizedSentText, normalizedOriginalPrompt)=>{
    if (normalizedSentText === normalizedOriginalPrompt) return 'asIs';
    if (normalizedOriginalPrompt.length === 0) return null;
    const fixedSegments = normalizedOriginalPrompt.split($8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX);
    const hasPlaceholders = fixedSegments.length > 1;
    if (hasPlaceholders) {
        let searchFrom = 0;
        let firstSegmentMatchedAtStart = true;
        for (const segment of fixedSegments){
            const trimmed = segment.trim();
            if (trimmed.length === 0) continue;
            const idx = normalizedSentText.indexOf(trimmed, searchFrom);
            if (idx === -1) {
                // User truncated or edited after matching some of the card — if we matched at least one
                // fixed segment, they started from the card so treat as tweaked
                if (searchFrom > 0) return 'tweaked';
                // No segment matched yet; check containment (strip placeholders so "on `x`" vs "on x" match)
                const originalWithoutPlaceholders = normalizedOriginalPrompt.replace($8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX, ' ').replace(/\s+/g, ' ').trim();
                if (normalizedOriginalPrompt.includes(normalizedSentText) || normalizedSentText.includes(normalizedOriginalPrompt) || originalWithoutPlaceholders.includes(normalizedSentText) || normalizedSentText.includes(originalWithoutPlaceholders) || originalWithoutPlaceholders.startsWith(normalizedSentText) || normalizedSentText.startsWith(originalWithoutPlaceholders)) return 'tweaked';
                return null;
            }
            if (searchFrom === 0 && idx !== 0) firstSegmentMatchedAtStart = false;
            searchFrom = idx + trimmed.length;
        }
        // Trailing content after the last fixed segment
        if (normalizedSentText.length > searchFrom) return 'tweaked';
        return firstSegmentMatchedAtStart ? 'placeholdersFilled' : 'tweaked';
    }
    if (normalizedSentText.includes(normalizedOriginalPrompt) || normalizedOriginalPrompt.includes(normalizedSentText)) return 'tweaked';
    return null;
};
const $8d8bfd1ce8e7d438$export$89d0962bb7c449e3 = (normalizedSentText, normalizedOriginalPrompt)=>$8d8bfd1ce8e7d438$export$2def72d3ef808307(normalizedSentText, normalizedOriginalPrompt) !== null;
module.exports["extractContentFeatures"] = $8d8bfd1ce8e7d438$export$a148305df2eb5487;
module.exports["extractPlainTextFromAdf"] = $8d8bfd1ce8e7d438$export$c5df045f791f45da;
module.exports["getPromptCardSendType"] = $8d8bfd1ce8e7d438$export$2def72d3ef808307;

});

parcelRegister("ij2FZ", function(module, exports) {
const $d70a1b66183cdb12$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $d70a1b66183cdb12$export$d4f002c79ea2ad20 = 'skill';
const $d70a1b66183cdb12$export$e4d0b30afd49f7df = 'skillTag';
const $d70a1b66183cdb12$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $d70a1b66183cdb12$export$aae1b80712c1b67b = `${$d70a1b66183cdb12$export$d4f002c79ea2ad20}:${$d70a1b66183cdb12$export$e4d0b30afd49f7df}`;
const $d70a1b66183cdb12$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $d70a1b66183cdb12$export$d0e832101df0ac96 && extensionKey === $d70a1b66183cdb12$export$aae1b80712c1b67b;
};
const $d70a1b66183cdb12$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $d70a1b66183cdb12$export$aae1b80712c1b67b,
                extensionType: $d70a1b66183cdb12$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $d70a1b66183cdb12$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $d70a1b66183cdb12$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $d70a1b66183cdb12$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $d70a1b66183cdb12$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $d70a1b66183cdb12$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $d70a1b66183cdb12$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $d70a1b66183cdb12$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $d70a1b66183cdb12$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $d70a1b66183cdb12$export$a425ebfe740d9932;

});

parcelRegister("j1TMt", function(module, exports) {
const $b517352a9421396a$var$MAUI_PERSONAL_READ_TOKEN_PATH = '/gateway/api/assist/rovo/v1/maui/media/personal-read-token';
async function $b517352a9421396a$export$c64afe9f7c18b7d9(productHeader) {
    const response = await fetch($b517352a9421396a$var$MAUI_PERSONAL_READ_TOKEN_PATH, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'X-Product': productHeader
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch MAUI personal read token: ${response.status} ${response.statusText}`);
    const data = await response.json();
    return {
        token: data.token,
        collection: data.collection
    };
}
module.exports["fetchMauiPersonalReadToken"] = $b517352a9421396a$export$c64afe9f7c18b7d9;

});

parcelRegister("4B9iQ", function(module, exports) {

var $hHa70 = parcelRequire("hHa70");


var $aesXQ = parcelRequire("aesXQ");


var $eeVx7 = parcelRequire("eeVx7");


var $15h8H = parcelRequire("15h8H");

const $bc86aa71442de6a5$export$a6cddc722e179ebe = (props)=>{
    const api = (0, $15h8H.getBrowserBridgeAPI)();
    const senderId = (0, $aesXQ.ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID);
    const receiverId = (0, $hHa70.ROVO_CHAT_CLIENT_ID);
    let payload;
    switch(props.status){
        case 'fail':
            payload = {
                ...props,
                error: typeof props.error === 'string' ? props.error : 'Unknown error',
                reason: undefined,
                senderId: senderId,
                receiverId: receiverId
            };
            break;
        case 'abort':
            payload = {
                ...props,
                reason: typeof props.reason === 'string' ? props.reason : 'Aborted',
                error: undefined,
                senderId: senderId,
                receiverId: receiverId
            };
            break;
        case 'success':
        default:
            payload = {
                ...props,
                error: undefined,
                reason: undefined,
                senderId: senderId,
                receiverId: receiverId
            };
            break;
    }
    api?.send((0, $eeVx7.AifcExperienceTrackingCommand), payload);
};
module.exports["sendAIFCExperienceTrackingToParent"] = $bc86aa71442de6a5$export$a6cddc722e179ebe;

});

parcelRegister("6n5hj", function(module, exports) {

var $3OwWt = parcelRequire("3OwWt");

const $8794d2454b15e69c$export$2d48a0bb3ca90998 = (0, $3OwWt.createCommand)('action-classification-command');
module.exports["ActionClassificationCommand"] = $8794d2454b15e69c$export$2d48a0bb3ca90998;

});

parcelRegister("3BJ0q", function(module, exports) {

var $3OwWt = parcelRequire("3OwWt");

const $c713d2442761476f$export$ae5d3e7a3e1f01ca = (0, $3OwWt.createCommand)('editor-insert-content-command');
module.exports["EditorInsertContentCommand"] = $c713d2442761476f$export$ae5d3e7a3e1f01ca;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("iRHUq"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("iRHUq", function(module, exports) {

let $dbbf3caca417d651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dbbf3caca417d651$var$load("fPSgL"),
    $dbbf3caca417d651$var$load("6GYDO"),
    $dbbf3caca417d651$var$load("hhss7"),
    $dbbf3caca417d651$var$load("cyGuT"),
    $dbbf3caca417d651$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("cJeDc", function(module, exports) {
var $c39b3ef3793f3f0e$export$3f98ccc336fde004 = /*#__PURE__*/ function(FeedbackVariant) {
    FeedbackVariant["AFTER_AIFC_MODAL_CLOSE"] = "after-aifc-modal-close";
    FeedbackVariant["AFTER_UPDATE_STREAM_COMPLETE"] = "after-update-stream-complete";
    FeedbackVariant["AFTER_REMIX_MODAL_CLOSE"] = "after-remix-modal-close";
    FeedbackVariant["AFTER_REMIX_INSERT"] = "after-remix-insert";
    return FeedbackVariant;
}({});
module.exports["FeedbackVariant"] = $c39b3ef3793f3f0e$export$3f98ccc336fde004;

});

parcelRegister("lpRYt", function(module, exports) {

var $2Yzoe = parcelRequire("2Yzoe");


var $csam1 = parcelRequire("csam1");


var $aRZzN = parcelRequire("aRZzN");


var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $aFrN0 = parcelRequire("aFrN0");


var $kVuPa = parcelRequire("kVuPa");


var $kbmYM = parcelRequire("kbmYM");


var $ijO3G = parcelRequire("ijO3G");


var $eqo2H = parcelRequire("eqo2H");


var $6RXI6 = parcelRequire("6RXI6");


var $b2Usv = parcelRequire("b2Usv");


var $3Jbpl = parcelRequire("3Jbpl");


var $j0P3F = parcelRequire("j0P3F");


var $dSj2z = parcelRequire("dSj2z");


var $1Ce64 = parcelRequire("1Ce64");


var $5XYXq = parcelRequire("5XYXq");


var $7ai6d = parcelRequire("7ai6d");


var $EZ3q4 = parcelRequire("EZ3q4");


var $bCKHR = parcelRequire("bCKHR");

class $2d26328991932579$export$614853bf2169db97 extends (0, $aRZzN.MarkdownTransformer) {
    parse(content) {
        // Sanitize the raw markdown string before it reaches the markdown-it block
        // tokenizer (ParserBlock.tokenize). Indented tables and 4+ space-indented
        // fences can cause catastrophic backtracking / OOM; `sanitizeMarkdown`
        // outdents fences with 4+ spaces of indentation so the parser recognises
        // them as fenced code blocks rather than entering an infinite tokenization
        // loop.
        //
        // Note: md.core.ruler cannot be used here — core rules run AFTER block
        // tokenization, which is too late to prevent the crash. The sanitization
        // must happen on the raw string before parse() is called.
        const node = this.parser.parse((0, $dh538.fg)('rovo_chat_sanitize_markdown_oom_fix') ? (0, $EZ3q4.sanitizeMarkdown)(content) : content);
        if (!node) return new (0, $5SAOw.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage, useGroupedCitations){
        super();
        this.parser = void 0;
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $bCKHR.enableSchemaPlugins)(md, schema);
        // Handle blockquotes inside list items - ADF doesn't support this nesting,
        // so we transform them into emphasized paragraphs
        md.use((0, $b2Usv.default));
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $6RXI6.createLinkifyPlugin)(pluginConfig.linkify));
        if (useGroupedCitations) md.use((0, $ijO3G.default));
        else md.use((0, $aFrN0.default));
        if ((0, $dh538.fg)('rovo_enable_data_sculptor')) md.use((0, $kVuPa.default));
        md.use((0, $kbmYM.default));
        md.use((0, $5XYXq.default));
        if ((0, $dh538.fg)('rovo_chat_enable_inline_lumina')) md.use((0, $eqo2H.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) // this is where we should separate it into its own plugin called createSmartLinksPluginRefresh
        md.use((0, $dSj2z.createSmartLinksPlugin)(pluginConfig.smartLinks, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $j0P3F.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $csam1.markdownItTable));
            if ((0, $dh538.fg)('rovo_chat_enable_markdown_table_break_tags')) md.use((0, $1Ce64.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $3Jbpl.default));
        const filter = (0, $bCKHR.filterSchemaMapping)(schema, (0, $7ai6d.mdToPmSchema));
        this.parser = new (0, $42JDa.MarkdownParser)(schema, md, filter);
    }
}
module.exports["AiMateMarkdownTransformer"] = $2d26328991932579$export$614853bf2169db97;

});

parcelRegister("aFrN0", function(module, exports) {
$parcel$export(module.exports, "default", () => $eedc127a683be258$export$2e2bcd8739ae039);
const $eedc127a683be258$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $eedc127a683be258$var$citation = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $eedc127a683be258$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($eedc127a683be258$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $eedc127a683be258$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $eedc127a683be258$var$citation);

});

parcelRegister("kVuPa", function(module, exports) {
$parcel$export(module.exports, "default", () => $85f34bd2edc9da4d$export$2e2bcd8739ae039);
const $85f34bd2edc9da4d$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $85f34bd2edc9da4d$var$dataSculptor = (state)=>{
    const tokens = [];
    let sculptorCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $85f34bd2edc9da4d$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                const parts = childToken.content.split($85f34bd2edc9da4d$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        citationToken.attrs = [
                            [
                                'localId',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'text',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(citationToken);
                        sculptorCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $85f34bd2edc9da4d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $85f34bd2edc9da4d$var$dataSculptor);

});

parcelRegister("kbmYM", function(module, exports) {
const $8d6eacbf9e066d7e$var$EXPAND_REGEX = /\[\^(expand)\^\]/;
const $8d6eacbf9e066d7e$var$expandable = (state)=>{
    const tokens = [];
    let expandCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children?.length === 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $8d6eacbf9e066d7e$var$EXPAND_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($8d6eacbf9e066d7e$var$EXPAND_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const expandToken = new state.Token('status', '', 0);
                        expandToken.content = '';
                        expandToken.block = false;
                        expandToken.level = childToken.level;
                        expandToken.attrs = [
                            [
                                'localId',
                                'expandable-' + expandCounter
                            ],
                            [
                                'text',
                                'expandable-' + expandCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(expandToken);
                        expandCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
const $8d6eacbf9e066d7e$var$mdPluginExpandable = (md)=>{
    md.core.ruler.push('expandable', $8d6eacbf9e066d7e$var$expandable);
};
var $8d6eacbf9e066d7e$export$2e2bcd8739ae039 = $8d6eacbf9e066d7e$var$mdPluginExpandable;
module.exports["default"] = $8d6eacbf9e066d7e$export$2e2bcd8739ae039;

});

parcelRegister("ijO3G", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc4534e96af60336$export$2e2bcd8739ae039);
const $cc4534e96af60336$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $cc4534e96af60336$var$groupedCitations = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $cc4534e96af60336$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($cc4534e96af60336$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                let citationIndices = [];
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if ((isLastCitationDuplicate || citationIndices.length > 0) && part.trim() === '') return;
                        if (part.trim() !== '') {
                            /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                            /**
								 * once we reach a text part, we need to capture the indices of the citations that have occurred up to this point
								 *
								 * Example
								 * `Hello [^1^][^2^] The example continues` -> parts = ['Hello ', '1', '', '2', 'The example continues']
								 * When 'The example continues' is reached, we need to create a status token for the citations prior
								 */ if (citationIndices.length > 0) {
                                const citationToken = new state.Token('status', '', 0);
                                citationToken.content = '';
                                citationToken.block = false;
                                citationToken.level = childToken.level;
                                // localId is used to identify the citation indices in the DOM
                                // this overrides the uuid that is normally used
                                // NOTE: ReactRenderer expects specific props for status nodes and
                                // therefore we cannot pass in custom attributes
                                citationToken.attrs = [
                                    [
                                        'color',
                                        'blue'
                                    ],
                                    [
                                        'text',
                                        'citation'
                                    ],
                                    // citationIndices is used to identify the citation token in the DOM
                                    // this overrides the uuid that is normally used
                                    [
                                        'localId',
                                        JSON.stringify(citationIndices)
                                    ]
                                ];
                                newChildren.push(citationToken);
                                citationIndices = [];
                            }
                        }
                        const textToken = new state.Token('text', '', 0);
                        // don't add trailing space if part already ends with one
                        textToken.content = index === parts.length - 1 ? part : part.endsWith(' ') ? part : part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        if (part !== '') newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        citationIndices.push(parseInt(part));
                    }
                });
                /**
					 * Once we've reached the end of parts, we need to create a status token for any citations at the very end
					 *
					 * Example: `Hello [^1^][^2^]` -> parts = ['Hello ', '1', '', '2', '']
					 * When we've iterated through all of parts, 1 and 2 indices exist in citationIndices, and a status token needs to be created
					 */ if (citationIndices.length > 0) {
                    const citationToken = new state.Token('status', '', 0);
                    citationToken.content = '';
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            'color',
                            'blue'
                        ],
                        [
                            'text',
                            'citation'
                        ],
                        [
                            'localId',
                            JSON.stringify(citationIndices)
                        ]
                    ];
                    newChildren.push(citationToken);
                    citationIndices = [];
                }
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $cc4534e96af60336$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $cc4534e96af60336$var$groupedCitations);

});

parcelRegister("eqo2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e69c75627933db8$export$2e2bcd8739ae039);

var $l8G7y = parcelRequire("l8G7y");

const $2e69c75627933db8$var$LUMINA_REGEX = /\[\^(lumina)\^\]/;
const $2e69c75627933db8$var$inlineLumina = (state)=>{
    const tokens = [];
    let luminaCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $2e69c75627933db8$var$LUMINA_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($2e69c75627933db8$var$LUMINA_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const luminaToken = new state.Token('status', '', 0);
                        luminaToken.content = '';
                        luminaToken.block = false;
                        luminaToken.level = childToken.level;
                        luminaToken.attrs = [
                            [
                                'localId',
                                (0, $l8G7y.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'text',
                                (0, $l8G7y.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(luminaToken);
                        luminaCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $2e69c75627933db8$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-lumina', $2e69c75627933db8$var$inlineLumina);
}

});

parcelRegister("l8G7y", function(module, exports) {
const $b441813f442be22d$export$8288860537fb7872 = 'inline-lumina-';
const $b441813f442be22d$export$5d9d37bd58628e00 = (localId)=>{
    return localId != null && localId.startsWith($b441813f442be22d$export$8288860537fb7872);
};
module.exports["INLINE_LUMINA_STATUS_PREFIX"] = $b441813f442be22d$export$8288860537fb7872;
module.exports["isInlineLuminaStatus"] = $b441813f442be22d$export$5d9d37bd58628e00;

});

parcelRegister("6RXI6", function(module, exports) {

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $146b6bae45423f24$var$arrayReplaceAt = (src, pos, newElements)=>{
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $146b6bae45423f24$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $146b6bae45423f24$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $146b6bae45423f24$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children;
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($146b6bae45423f24$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($146b6bae45423f24$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $81OAa.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $146b6bae45423f24$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
const $146b6bae45423f24$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', $146b6bae45423f24$export$8cd7d1ec2e6808da(params));
module.exports["createLinkifyPlugin"] = $146b6bae45423f24$export$763ac077c9998026;

});

parcelRegister("b2Usv", function(module, exports) {
/**
 * This plugin handles blockquotes nested inside list items.
 * Since ADF doesn't support blockquotes as children of listItems,
 * we transform blockquote content into emphasized (italic) paragraphs.
 *
 * Before: 1. Item\n   > "Quote"
 * After:  1. Item\n   _"Quote"_
 *
 * This allows quotes within lists to render gracefully as italicized text
 * rather than failing due to ADF schema constraints.
 */ const $eebefa0fafefd79c$var$listBlockquoteFallback = (state)=>{
    const tokens = state.tokens;
    let listDepth = 0;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Track list nesting depth
        if (token.type === 'ordered_list_open' || token.type === 'bullet_list_open') listDepth++;
        else if (token.type === 'ordered_list_close' || token.type === 'bullet_list_close') listDepth--;
        // If we're inside a list and encounter a blockquote, transform it
        if (listDepth > 0 && token.type === 'blockquote_open') {
            // Find the matching blockquote_close
            let closeIndex = -1;
            let depth = 1;
            for(let j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'blockquote_open') depth++;
                else if (tokens[j].type === 'blockquote_close') {
                    depth--;
                    if (depth === 0) {
                        closeIndex = j;
                        break;
                    }
                }
            }
            if (closeIndex !== -1) {
                // Mark the blockquote tokens for removal
                token.type = 'blockquote_fallback_open';
                token.hidden = true;
                tokens[closeIndex].type = 'blockquote_fallback_close';
                tokens[closeIndex].hidden = true;
                // Process the content inside the blockquote
                // We need to wrap the inline content with emphasis marks
                for(let j = i + 1; j < closeIndex; j++){
                    const innerToken = tokens[j];
                    if (innerToken.type === 'inline' && innerToken.children) {
                        // Wrap all children with em marks
                        const emOpen = new state.Token('em_open', 'em', 1);
                        emOpen.block = false;
                        const emClose = new state.Token('em_close', 'em', -1);
                        emClose.block = false;
                        innerToken.children = [
                            emOpen,
                            ...innerToken.children,
                            emClose
                        ];
                    }
                }
            }
        }
    }
    // Filter out the hidden blockquote fallback tokens
    state.tokens = tokens.filter((t)=>t.type !== 'blockquote_fallback_open' && t.type !== 'blockquote_fallback_close');
};
const $eebefa0fafefd79c$var$mdPluginListBlockquoteFallback = (md)=>{
    md.core.ruler.push('list_blockquote_fallback', $eebefa0fafefd79c$var$listBlockquoteFallback);
};
var $eebefa0fafefd79c$export$2e2bcd8739ae039 = $eebefa0fafefd79c$var$mdPluginListBlockquoteFallback;
module.exports["default"] = $eebefa0fafefd79c$export$2e2bcd8739ae039;

});

parcelRegister("3Jbpl", function(module, exports) {
$parcel$export(module.exports, "default", () => $536a5df99342df46$export$2e2bcd8739ae039);
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $536a5df99342df46$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        // Track the difference between original array indices and accumulated tokens indices
        // This is needed because when we skip processed tokens, the indices diverge
        let indexOffset = 0;
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                // Adjust cursor to account for previously skipped/modified tokens
                const adjustedCursor = cursor - indexOffset;
                tokens = [
                    ...tokens.slice(0, adjustedCursor),
                    ...subTree
                ];
                // Update offset: we consumed (i - cursor + 1) original tokens and added subTree.length
                indexOffset += i + 1 - cursor - subTree.length;
            } else if (processedTokens.indexOf(token.type) !== -1) {
                // Ignore token if it's already processed
                processedTokens.splice(processedTokens.indexOf(token.type), 1);
                // We skipped a token, so the offset increases
                indexOffset++;
            } else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $536a5df99342df46$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $536a5df99342df46$var$createRule());
};

});

parcelRegister("j0P3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab169cc784e6afd4$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $ab169cc784e6afd4$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $ab169cc784e6afd4$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $ab169cc784e6afd4$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $ab169cc784e6afd4$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$ab169cc784e6afd4$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $ab169cc784e6afd4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $ab169cc784e6afd4$var$mentionLinks);

});

parcelRegister("dSj2z", function(module, exports) {

var $gEMk1 = parcelRequire("gEMk1");

const $d5cccf701aceb868$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $d5cccf701aceb868$var$linkPatternEnd = '[^\\s\\]\\)]*';
const $d5cccf701aceb868$var$linkRegex = {
    youtube: `${$d5cccf701aceb868$var$linkPatternStart}youtube\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    youtubeShortUrl: `${$d5cccf701aceb868$var$linkPatternStart}youtu\\.be${$d5cccf701aceb868$var$linkPatternEnd}`,
    loomVideo: `${$d5cccf701aceb868$var$linkPatternStart}loom\\.com\\/share\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    figmaFile: `${$d5cccf701aceb868$var$linkPatternStart}figma\\.com\\/(file|design)\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$d5cccf701aceb868$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleDoc: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleForm: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    microsoftForm: `${$d5cccf701aceb868$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$d5cccf701aceb868$var$linkPatternEnd}`,
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$d5cccf701aceb868$var$linkPatternEnd}`
};
const $d5cccf701aceb868$var$newThirdPartyLinkRegex = {
    github: `${$d5cccf701aceb868$var$linkPatternStart}github\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    canvaDesign: `${$d5cccf701aceb868$var$linkPatternStart}canva\\.com\\/design\\/[a-zA-Z0-9_\\-.]{1,255}\\/[a-zA-Z0-9_\\-.]{1,255}(?:\\/[^\\s\\]\\)]*)?`,
    canvaShortLink: `${$d5cccf701aceb868$var$linkPatternStart}canva\\.link\\/[a-zA-Z0-9]+(?:\\?${$d5cccf701aceb868$var$linkPatternEnd})?`,
    rovo: `${$d5cccf701aceb868$var$linkPatternStart}[^\\s\\]\\)]*\\.atlassian\\.net\\/rovo${$d5cccf701aceb868$var$linkPatternEnd}`,
    amplitude: `${$d5cccf701aceb868$var$linkPatternStart}app\\.amplitude\\.com${$d5cccf701aceb868$var$linkPatternEnd}`
};
const $d5cccf701aceb868$var$buildEmbedRegex = (includeNewThirdParties)=>{
    const patterns = [
        ...Object.values($d5cccf701aceb868$var$linkRegex),
        ...includeNewThirdParties ? Object.values($d5cccf701aceb868$var$newThirdPartyLinkRegex) : []
    ];
    return new RegExp(patterns.join('|'), 'g');
};
const $d5cccf701aceb868$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$d5cccf701aceb868$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$d5cccf701aceb868$var$linkPatternEnd}`
];
const $d5cccf701aceb868$var$avpChartsRegex = `${$d5cccf701aceb868$var$linkPatternStart}.*?\\/avpviz\\/c\\/[^\\/]+.*${$d5cccf701aceb868$var$linkPatternEnd}`;
/**
 * Checks if there is more than one link in the token stream.
 * Used to determine if all links should be rendered inline instead of as embeds.
 */ const $d5cccf701aceb868$var$hasMultipleLinks = (tokens)=>{
    let linkCount = 0;
    for (const token of tokens){
        if (token.type !== 'inline' || !token.children) continue;
        for (const childToken of token.children)if (childToken?.type === 'link_open') {
            linkCount++;
            if (linkCount > 1) return true; // Early exit once we find more than one
        }
    }
    return false;
};
const $d5cccf701aceb868$var$createSmartLinks = ({ regexStorage: regexStorage, isNonAgentMessage: isNonAgentMessage, isExperimentEnabled: isExperimentEnabled })=>(state)=>{
        const embedRegex = $d5cccf701aceb868$var$buildEmbedRegex(isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false) ?? false);
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match(embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $gEMk1.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match(embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $d5cccf701aceb868$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($d5cccf701aceb868$var$avpChartsRegex);
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        if (shouldRenderAvpEmbedInline) {
                            outputToken.children = processedTokenChildren;
                            tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                            processedTokenChildren = [];
                            let embedToken = new state.Token('embedCard', '', 0);
                            embedToken.content = '';
                            embedToken.block = true;
                            embedToken.attrSet('url', url);
                            embedToken.attrSet('layout', 'center');
                            tokensToAppend.push(embedToken);
                            tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                            outputToken = new state.Token('inline', '', 0);
                            tokensToAppend.push(outputToken);
                            return;
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', url);
                        processedTokenChildren.push(cardToken);
                        return;
                    }
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        // Render all embeds at the end of the results if it is an agent message
        if (embedMatches?.length && !isNonAgentMessage && !isExperimentEnabled?.('rovo_chat_smartlink_embedcard_improvements', true)) // Default behavior: render all embeds at the end
        [
            ...new Set(embedMatches)
        ].forEach((match)=>{
            let embedToken = new state.Token('embedCard', '', 0);
            embedToken.content = '';
            embedToken.block = true;
            embedToken.attrSet('url', match);
            embedToken.attrSet('layout', 'center');
            embedTokens.push(embedToken);
        });
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $d5cccf701aceb868$var$createSmartLinksRefresh = ({ regexStorage: regexStorage, isExperimentEnabled: isExperimentEnabled, shouldShowAsInline: shouldShowAsInline })=>(state)=>{
        const embedRegex = $d5cccf701aceb868$var$buildEmbedRegex(isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false) ?? false);
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        const renderedInlineEmbeds = new Set();
        // If there are more than one link or the user opened the chat in mini modal, all links display inline
        const forceAllToInline = $d5cccf701aceb868$var$hasMultipleLinks(state.tokens) || shouldShowAsInline;
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match(embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $gEMk1.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match(embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        // handle condition for when link in the token content matches the linkRegex
                        const shouldRenderLinksAsEmbed = matchesEmbedRegex;
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $d5cccf701aceb868$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($d5cccf701aceb868$var$avpChartsRegex);
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        // Render inline embed if either regex matches and token content is not part of a list
                        const shouldRenderEmbedInline = shouldRenderLinksAsEmbed && token.level <= 1;
                        if (shouldRenderAvpEmbedInline || shouldRenderLinksAsEmbed && isExperimentEnabled?.('rovo_chat_smartlink_embedcard_improvements', true)) {
                            // handle case if it is an analytic chart link or microsoft form link
                            // these should be rendered as inline cards, not embed cards
                            const isMicrosoftFormLink = new RegExp($d5cccf701aceb868$var$linkRegex.microsoftForm).test(url);
                            const isAnalyticsChartLink = new RegExp($d5cccf701aceb868$var$linkRegex.analyticsChart).test(url);
                            if (!forceAllToInline && shouldRenderEmbedInline && !isMicrosoftFormLink && !isAnalyticsChartLink || shouldRenderAvpEmbedInline) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                processedTokenChildren = [];
                                let embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', url);
                                embedToken.attrSet('layout', 'center');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                // Track that we've rendered this URL as an inline embed
                                renderedInlineEmbeds.add(url);
                                return;
                            }
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', url);
                        processedTokenChildren.push(cardToken);
                        return;
                    }
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $d5cccf701aceb868$export$9625a798761643ac = (params, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage)=>(md)=>md.core.ruler.push('inlineCard', isExperimentEnabled?.('rovo_chat_smartlink_embedcard_improvements', false) ? $d5cccf701aceb868$var$createSmartLinksRefresh({
            ...params,
            isExperimentEnabled: isExperimentEnabled,
            shouldShowAsInline: shouldShowAsInline
        }) : $d5cccf701aceb868$var$createSmartLinks({
            ...params,
            isNonAgentMessage: isNonAgentMessage,
            isExperimentEnabled: isExperimentEnabled
        }));
module.exports["createSmartLinksPlugin"] = $d5cccf701aceb868$export$9625a798761643ac;

});

parcelRegister("gEMk1", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $lBWya = parcelRequire("lBWya");

const $bf5d74ffdabdc3d2$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $bf5d74ffdabdc3d2$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    const regexPattern = new RegExp(cachedProviderRegex, 'g');
    return regexPattern.test(url);
};
const $bf5d74ffdabdc3d2$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))) return JSON.parse(`${regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))}`);
    return '';
};
const $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
const $bf5d74ffdabdc3d2$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerData = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    if (providerData) {
        const providerRegex = $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(providerData);
        $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83(regexStorage, providerRegex);
        const providerMapping = $bf5d74ffdabdc3d2$export$8eafd18d19de7df5(providerData);
        $bf5d74ffdabdc3d2$export$b22dfe84603542b1(regexStorage, providerMapping);
    }
};
const $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return '';
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns?.map((pattern)=>pattern.source) || [];
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $bf5d74ffdabdc3d2$export$8eafd18d19de7df5 = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return {
        combinedRegex: '',
        patterns: []
    };
    const patterns = data.providers.flatMap((provider)=>(provider.patterns || []).map((pattern)=>({
                key: provider.key,
                regex: pattern.source
            })));
    const combinedRegex = patterns.map((p)=>p.regex).join('|');
    return {
        combinedRegex: combinedRegex,
        patterns: patterns
    };
};
const $bf5d74ffdabdc3d2$export$25b8a9cebf834f6e = (regexStorage)=>{
    const stored = regexStorage.getItem((0, $lBWya.LS_PROVIDER_MAPPING_KEY));
    if (stored) try {
        return JSON.parse(stored);
    } catch  {
        return null;
    }
    return null;
};
const $bf5d74ffdabdc3d2$export$b22dfe84603542b1 = (regexStorage, providerMapping)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_MAPPING_KEY), JSON.stringify(providerMapping));
};
const $bf5d74ffdabdc3d2$export$dfebbb511ada4128 = (0, $2XqLN.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $lBWya.PROVIDERS_API), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return data || null;
    } catch  {
        return null;
    }
});
const $bf5d74ffdabdc3d2$export$ab8eaff0f2d596bd = (0, $2XqLN.default)(async (baseUrl = '')=>{
    const data = await $bf5d74ffdabdc3d2$export$dfebbb511ada4128(baseUrl);
    return data ? $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(data) : '';
});
module.exports["isSupportedByLinkingPlatform"] = $bf5d74ffdabdc3d2$export$4b1056d02426889c;
module.exports["hydrateLinkingPlatformCache"] = $bf5d74ffdabdc3d2$export$d08c351b3b4e4934;

});

parcelRegister("lBWya", function(module, exports) {
const $9088146284880a5b$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $9088146284880a5b$export$1a30f994aeced995 = `/gateway/api/object-resolver/resolve/batch`;
const $9088146284880a5b$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $9088146284880a5b$export$b9858121ed269ff3 = 'aiMateSmartLinkProviderMapping';
module.exports["PROVIDERS_API"] = $9088146284880a5b$export$57ad190cdc563df3;
module.exports["LS_PROVIDER_KEY"] = $9088146284880a5b$export$56bec2f197c16818;
module.exports["LS_PROVIDER_MAPPING_KEY"] = $9088146284880a5b$export$b9858121ed269ff3;

});

parcelRegister("1Ce64", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ff6b0f828ae5055$export$2e2bcd8739ae039);
const $9ff6b0f828ae5055$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $9ff6b0f828ae5055$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $9ff6b0f828ae5055$var$tableBreakTags);

});

parcelRegister("5XYXq", function(module, exports) {
$parcel$export(module.exports, "default", () => $28815f35966a9eaf$export$2e2bcd8739ae039);
const $28815f35966a9eaf$var$CHART_REGEX = /\[\^(chart)\^\]/;
const $28815f35966a9eaf$var$visualizationChart = (state)=>{
    const tokens = [];
    let chartCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $28815f35966a9eaf$var$CHART_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($28815f35966a9eaf$var$CHART_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        // Create a new token for each chart match
                        const chartToken = new state.Token('status', '', 0);
                        chartToken.content = '';
                        chartToken.block = false;
                        chartToken.level = childToken.level;
                        chartToken.attrs = [
                            [
                                'localId',
                                'chart-' + chartCounter
                            ],
                            [
                                'text',
                                'loading chart-' + chartCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(chartToken);
                        chartCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $28815f35966a9eaf$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('chart', $28815f35966a9eaf$var$visualizationChart);
}

});

parcelRegister("7ai6d", function(module, exports) {
const $a1a032ec05100051$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $a1a032ec05100051$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('order') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};
module.exports["pmToMd"] = $a1a032ec05100051$export$cd54a56af01ba875;
module.exports["mdToPmSchema"] = $a1a032ec05100051$export$eb83d753215c78a2;

});

parcelRegister("EZ3q4", function(module, exports) {
/**
 * Sanitizes raw markdown content before it reaches the markdown-it block tokenizer.
 *
 * Two constructs cause `ParserBlock.prototype.tokenize` to enter catastrophic
 * backtracking / exponential rule-matching, causing OOM browser crashes:
 *
 * ## 1. Tables indented 2+ spaces (inside a list item)
 *
 * The `markdown-it-table` plugin requires the table header row to start at
 * column 0 (or ≤1 space of indentation). When an AI response places a table
 * inside a list item — a common pattern — the table rows are indented with
 * 2+ spaces and are never recognized as a table block.
 *
 * Instead, each `|---` separator row triggers markdown-it's `lheading`
 * (setext heading) rule which checks whether the preceding paragraph can be
 * promoted to a heading. This check is O(n) against all prior paragraphs,
 * repeated for every `|` row in the table → O(n²) overall. For documents
 * with 200+ lines and multiple tables, this crashes the browser.
 *
 * ## 2. Code fences indented 4+ spaces (inside nested list items)
 *
 * markdown-it's `fence` block rule only recognizes fences with 0–3 spaces of
 * leading indentation. Fences indented with 4+ spaces (common inside nested
 * list items like "     ```jql") are treated as indented code continuation,
 * meaning the opening fence is never paired with its closing fence. The block
 * parser then tries every rule against the remaining content until EOF →
 * effectively infinite loop → OOM.
 *
 * ## Fix
 *
 * Strip excess leading whitespace from table rows and fence delimiters so
 * they are recognized by the parser as valid block-level constructs. A
 * fence-tracking state machine ensures that table rows and fence delimiters
 * *inside* a code fence are never modified.
 */ // Fast pre-check: matches a line starting with 2+ spaces followed by `|` or ` ``` `.
// Uses (^|\n) so it also catches indented constructs on the very first line.
// If the content has neither, skip the full line-by-line pass entirely.
const $603f9fbe0d7d63e0$var$NEEDS_SANITIZE_RE = /(?:^|\n) {2,}[|`]/;
function $603f9fbe0d7d63e0$export$20209a1e2cc01cc1(content) {
    if (!$603f9fbe0d7d63e0$var$NEEDS_SANITIZE_RE.test(content)) return content;
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    let fenceIndent = 0;
    for (const line of lines){
        const stripped = line.replace(/^\s+/, '');
        const indent = line.length - stripped.length;
        if (!inFence && stripped.startsWith('```')) {
            if (indent >= 4) {
                // Outdent deeply-indented opening fence to column 0 so the parser
                // recognizes it as a fenced code block
                result.push(stripped);
                inFence = true;
                fenceIndent = indent;
            } else {
                result.push(line);
                inFence = true;
                fenceIndent = indent;
            }
        } else if (inFence && stripped.startsWith('```')) {
            if (indent >= 4 && fenceIndent >= 4) // Outdent matching closing fence
            result.push(stripped);
            else result.push(line);
            inFence = false;
            fenceIndent = 0;
        } else if (!inFence && indent >= 2 && stripped.startsWith('|')) // Outdent table rows that are indented inside list items so
        // markdown-it-table recognizes them as a proper table block
        result.push(stripped);
        else result.push(line);
    }
    return result.join('\n');
}
module.exports["sanitizeMarkdown"] = $603f9fbe0d7d63e0$export$20209a1e2cc01cc1;

});

parcelRegister("bCKHR", function(module, exports) {

var $7ai6d = parcelRequire("7ai6d");

const $8bba972fb5d34921$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $8bba972fb5d34921$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $7ai6d.pmToMd){
        const key = k;
        for(const i in (0, $7ai6d.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $7ai6d.pmToMd)[key][idx]);
        }
    }
};
module.exports["filterSchemaMapping"] = $8bba972fb5d34921$export$155749302793c60c;
module.exports["enableSchemaPlugins"] = $8bba972fb5d34921$export$a1cf9d9b96e16789;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $8zKDl = parcelRequire("8zKDl");


var $cemw8 = parcelRequire("cemw8");


var $6mKj3 = parcelRequire("6mKj3");

// Enhanced context to track the full boundary chain from root to current
const $5cfe2edd168ef31e$var$SuspenseBoundaryNameContext = /*#__PURE__*/ (0, $42omo.createContext)([]);
const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
} : ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
};
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $frIzR.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $42omo.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = [
        ...parentBoundaryChain,
        dataFetcherName
    ];
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        // If confluence_frontend_use_hydration_safe_suspense is on,
        // use a suspense boundary that will block updates (via memo) until hydration has completed
        const SuspenseComponent = (0, $6mKj3.expVal)('confluence_frontend_use_hydration_safe_suspense', 'isEnabled', false) ? (0, $cemw8.HydrationSafeSuspense) : (0, $42omo.Suspense);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext.Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SuspenseComponent, {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("cemw8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e4o8D = parcelRequire("e4o8D");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $42omo.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("eMqrF", function(module, exports) {

var $02AY0 = parcelRequire("02AY0");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team/manifest.ts
var $ac2a0fd84662e75e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $02AY0.IdentityTeamAriResourceOwner),
    resourceType: (0, $02AY0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $ac2a0fd84662e75e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NXcb.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $ac2a0fd84662e75e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ac2a0fd84662e75e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $ac2a0fd84662e75e$export$33bbb2d79e520118;

});

parcelRegister("02AY0", function(module, exports) {
// src/identity/team/types.ts
var $007cdcdc857abd84$export$49beddf48ffb3f35 = "identity", $007cdcdc857abd84$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $007cdcdc857abd84$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $007cdcdc857abd84$export$b2079a2a841afe32;

});

parcelRegister("b8JCF", function(module, exports) {

var $1VjMI = parcelRequire("1VjMI");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/issue/manifest.ts
var $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1VjMI.JiraIssueAriResourceOwner),
    resourceType: (0, $1VjMI.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $81c3d4c7dce903d7$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $81c3d4c7dce903d7$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $81c3d4c7dce903d7$export$1da6808e89ee03e;

});

parcelRegister("1VjMI", function(module, exports) {
// src/jira/issue/types.ts
var $166a76280cbc11fa$export$665a39f1b4e29e0a = "jira", $166a76280cbc11fa$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $166a76280cbc11fa$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $166a76280cbc11fa$export$76beb4d0da177ad4;

});

parcelRegister("5JRMI", function(module, exports) {

var $ehowZ = parcelRequire("ehowZ");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/project/manifest.ts
var $01140be010796b0a$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ehowZ.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ehowZ.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $01140be010796b0a$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $01140be010796b0a$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $01140be010796b0a$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $01140be010796b0a$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $01140be010796b0a$export$41215e8d01921e7d;

});

parcelRegister("ehowZ", function(module, exports) {
// src/townsquare/project/types.ts
var $a655ae9218632ad3$export$a258bc824c789b17 = "townsquare", $a655ae9218632ad3$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $a655ae9218632ad3$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $a655ae9218632ad3$export$aa8900dadffaa32a;

});

parcelRegister("ibFXh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");

const $0f4f34a4aa7da555$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $0f4f34a4aa7da555$export$9520f072db304aa0 = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $0f4f34a4aa7da555$var$styles.wrapper,
        testId: testId,
        children: children
    });
};
module.exports["PreviewPanel"] = $0f4f34a4aa7da555$export$9520f072db304aa0;

});

parcelRegister("aSy6D", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $4m76H = parcelRequire("4m76H");

const $dd1efdb181d94706$export$cda5e69749e7aeee = ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: styles })=>{
    const bodyRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!!styles && styles),
        ref: bodyRef,
        children: children
    });
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ if ((0, $dh538.fg)('platform_preview_panels_sniffer')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4m76H.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes,
        children: panelBodyContent
    });
    return panelBodyContent;
};
module.exports["PreviewPanelBody"] = $dd1efdb181d94706$export$cda5e69749e7aeee;

});

parcelRegister("4m76H", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");

const $b7ecffdf81d3e124$export$93a96f69a5c679de = ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $42omo.useRef)(false);
    const isValidContentSizeMessage = (0, $42omo.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $42omo.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth = bodyElement.clientWidth;
            const scrollWidth = bodyElement.scrollWidth;
            if (scrollWidth > clientWidth) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth,
                scrollWidth: scrollWidth
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            const contentSizePayload = event.data;
            if (!isValidContentSizeMessage(event, contentSizePayload)) return;
            const panelIframe = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe?.clientWidth ?? 0;
            const clientWidth = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth !== 'number' || contentSizePayload.width <= clientWidth) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth,
                scrollWidth: contentSizePayload.width
            });
        };
        return (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["PreviewPanelSniffer"] = $b7ecffdf81d3e124$export$93a96f69a5c679de;

});

parcelRegister("fZVub", function(module, exports) {
$parcel$export(module.exports, "default", () => $920790d5dac34360$export$2e2bcd8739ae039);

var $aXWIB = parcelRequire("aXWIB");

var $920790d5dac34360$export$2e2bcd8739ae039 = (0, $aXWIB.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    }
});

});

parcelRegister("2os6v", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $dE1p6 = parcelRequire("dE1p6");

const $ed5d65f9b39936d9$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    return href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $ed5d65f9b39936d9$export$a37cb5f447b2cf16;

});

parcelRegister("3ZVni", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $39XmP = parcelRequire("39XmP");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $fZVub = parcelRequire("fZVub");


var $6CSXv = parcelRequire("6CSXv");

const $ce13ec86664e204c$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $ce13ec86664e204c$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n"
};
const $ce13ec86664e204c$export$426d4171de44bac0 = ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const enableCrossMAUUsage = (0, $dh538.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $ce13ec86664e204c$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: $ce13ec86664e204c$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $ce13ec86664e204c$var$styles.childWrapper,
                spread: "space-between",
                alignBlock: "center",
                space: "space.100",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.100",
                children: [
                    url && /*#__PURE__*/ (0, $l998X.jsx)((0, $6CSXv.PreviewPanelNewTabLink), {
                        label: formatMessage((0, $fZVub.default).previewPanelOpenInNewWindowLabel),
                        onClick: onOpenInNewWindow,
                        testId: testId && `${testId}.open-in-new-window-button`
                    }),
                    moreActions,
                    onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small"
                            }),
                        label: formatMessage((0, $fZVub.default).previewPanelCloseButtonLabel),
                        onClick: onPanelClose,
                        testId: testId && `${testId}.close-button`,
                        role: "button"
                    })
                ]
            })
        ]
    });
};
module.exports["PreviewPanelHeader"] = $ce13ec86664e204c$export$426d4171de44bac0;

});

parcelRegister("39XmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f84bdce2dbfd750d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $fFa3V = parcelRequire("fFa3V");


var $T9xHm = parcelRequire("T9xHm");


var $dh538 = parcelRequire("dh538");


var $a4UIB = parcelRequire("a4UIB");


var $26AWB = parcelRequire("26AWB");


var $5O1V9 = parcelRequire("5O1V9");

function $f84bdce2dbfd750d$export$2e2bcd8739ae039(options) {
    const [interactionSessionId, setInteractionSessionId] = (0, $42omo.useState)('');
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const shouldDisable = (0, $dh538.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $5spQU.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $T9xHm.isFedrampModerate)();
    const isEnabled = !shouldDisable;
    // Client does not change on re-render - cache with useMemo
    const interactionSessionClient = (0, $42omo.useMemo)(()=>{
        if (isEnabled) return new (0, $a4UIB.default)();
        else return null;
    }, [
        isEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // Fetch any initial interaction session ID
            const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
            currentSessionId && setInteractionSessionId(currentSessionId);
            // Add event listener that subscribes to any future interaction session ID updates
            const unbind = (0, $fFa3V.bind)(document, {
                type: (0, $5O1V9.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    if (!isEnabled) return (url)=>url;
    return (url)=>(0, $26AWB.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
}

});

parcelRegister("6CSXv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $8tdj3 = parcelRequire("8tdj3");


var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $4d61e3d7ff65f94b$export$d05dda6f1d91eaad = ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2os6v.PreviewPanelAction), {
        label: label || formatMessage((0, $fZVub.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $4d61e3d7ff65f94b$export$d05dda6f1d91eaad;

});

parcelRegister("3R2u2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $237c600fec460668$export$92a58681483f4529 = ({ title: title, icon: icon, color: color })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                weight: "bold",
                maxLines: 1,
                color: color,
                children: title
            })
        ]
    });
};
module.exports["PreviewPanelTitle"] = $237c600fec460668$export$92a58681483f4529;

});

parcelRegister("fwXBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4e8151e15b50def$var$_react = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("42omo")));

var $b4e8151e15b50def$var$_baseNew = $b4e8151e15b50def$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b4e8151e15b50def$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4e8151e15b50def$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $b4e8151e15b50def$var$_react.default.createElement($b4e8151e15b50def$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$b4e8151e15b50def$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $b4e8151e15b50def$var$_default = module.exports.default = $b4e8151e15b50def$var$AssetsObjectIcon;

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $da1a55ed1292d791$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $da1a55ed1292d791$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$da1a55ed1292d791$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("9Omoq", function(module, exports) {

var $bMsrH = parcelRequire("bMsrH");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/site/manifest.ts
var $724a275577bd8bbe$var$townsquareSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $bMsrH.TownsquareSiteAriResourceOwner),
    resourceType: (0, $bMsrH.TownsquareSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/townsquare/site/index.ts
var $724a275577bd8bbe$export$87ae3de5f1f7725a = class _TownsquareSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $724a275577bd8bbe$var$townsquareSiteAriStaticOpts.qualifier,
            platformQualifier: $724a275577bd8bbe$var$townsquareSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $724a275577bd8bbe$var$townsquareSiteAriStaticOpts.resourceOwner,
            resourceType: $724a275577bd8bbe$var$townsquareSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $724a275577bd8bbe$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $724a275577bd8bbe$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["TownsquareSiteAri"] = $724a275577bd8bbe$export$87ae3de5f1f7725a;

});

parcelRegister("bMsrH", function(module, exports) {
// src/townsquare/site/types.ts
var $893a3e20dd932982$export$9ee8c46ef1f3e6a8 = "townsquare", $893a3e20dd932982$export$44737bde24f3bac1 = "site";
module.exports["TownsquareSiteAriResourceOwner"] = $893a3e20dd932982$export$9ee8c46ef1f3e6a8;
module.exports["TownsquareSiteAriResourceType"] = $893a3e20dd932982$export$44737bde24f3bac1;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("744ND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $524ca136d29d3c89$var$_react = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("42omo")));

var $524ca136d29d3c89$var$_baseNew = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $524ca136d29d3c89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $524ca136d29d3c89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $524ca136d29d3c89$var$_react.default.createElement($524ca136d29d3c89$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$524ca136d29d3c89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $524ca136d29d3c89$var$_default = module.exports.default = $524ca136d29d3c89$var$WarningOutlineIcon;

});

parcelRegister("1eBTN", function(module, exports) {

var $9Omoq = parcelRequire("9Omoq");

const $851240d1cd0bd23c$export$792aeacb7990bc6 = (containerId)=>{
    // we wrap in a try/catch incase there are any issues with creating the site ari
    try {
        return (0, $9Omoq.TownsquareSiteAri).create({
            siteId: containerId
        }).toString();
    } catch  {
        return '';
    }
};
module.exports["getSiteAri"] = $851240d1cd0bd23c$export$792aeacb7990bc6;

});

parcelRegister("ksiqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee44b6768ad41edb$export$2e2bcd8739ae039);

var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $ee44b6768ad41edb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $922yL.default)(dirtyDate, -amount);
}

});

parcelRegister("bJbIe", function(module, exports) {
$parcel$export(module.exports, "default", () => $889cfb8399c60f9e$export$2e2bcd8739ae039);

var $da6O1 = parcelRequire("da6O1");


var $R3ff4 = parcelRequire("R3ff4");


var $g3Gzi = parcelRequire("g3Gzi");


var $f5SRR = parcelRequire("f5SRR");


var $egXhZ = parcelRequire("egXhZ");


var $9hDHZ = parcelRequire("9hDHZ");


var $1tT8e = parcelRequire("1tT8e");


var $qc9ak = parcelRequire("qc9ak");


var $671gj = parcelRequire("671gj");


var $jZ39j = parcelRequire("jZ39j");


var $b5utg = parcelRequire("b5utg");


var $l9XGS = parcelRequire("l9XGS");


var $3Ujd4 = parcelRequire("3Ujd4");


var $2h3f7 = parcelRequire("2h3f7");

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $889cfb8399c60f9e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $889cfb8399c60f9e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $889cfb8399c60f9e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $889cfb8399c60f9e$var$doubleQuoteRegExp = /''/g;
var $889cfb8399c60f9e$var$notWhitespaceRegExp = /\S/;
var $889cfb8399c60f9e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $889cfb8399c60f9e$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $b5utg.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $g3Gzi.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $jZ39j.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $jZ39j.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $egXhZ.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $l9XGS.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($889cfb8399c60f9e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $1tT8e.default)) {
            var longFormatter = (0, $1tT8e.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($889cfb8399c60f9e$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $R3ff4.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $671gj.isProtectedWeekYearToken)(token)) (0, $671gj.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $671gj.isProtectedDayOfYearToken)(token)) (0, $671gj.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $3Ujd4.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($889cfb8399c60f9e$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $889cfb8399c60f9e$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $da6O1.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $889cfb8399c60f9e$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $egXhZ.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $f5SRR.default)(date, (0, $qc9ak.default)(date));
    var flags = {};
    var _iterator2 = (0, $R3ff4.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $9hDHZ.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $889cfb8399c60f9e$var$cleanEscapedString(input) {
    return input.match($889cfb8399c60f9e$var$escapedStringRegExp)[1].replace($889cfb8399c60f9e$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("R3ff4", function(module, exports) {

var $TsV82 = parcelRequire("TsV82");

function $09f777b5b2878172$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $TsV82.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports["default"] = $09f777b5b2878172$export$2e2bcd8739ae039;

});

parcelRegister("TsV82", function(module, exports) {

var $9jNLK = parcelRequire("9jNLK");

function $0a6b9229e3e26525$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9jNLK.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9jNLK.default)(r, a) : void 0;
    }
}
module.exports["default"] = $0a6b9229e3e26525$export$2e2bcd8739ae039;

});

parcelRegister("9jNLK", function(module, exports) {
function $6c8c7e8119113394$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports["default"] = $6c8c7e8119113394$export$2e2bcd8739ae039;

});

parcelRegister("l9XGS", function(module, exports) {

var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $iLaQ6 = parcelRequire("iLaQ6");

var $f678bd8d7ac0b60d$var$TIMEZONE_UNIT_PRIORITY = 10;
var $f678bd8d7ac0b60d$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $kWj1y.default)(this, Setter);
        (0, $iLaQ6.default)(this, "priority", void 0);
        (0, $iLaQ6.default)(this, "subPriority", 0);
    }
    (0, $9xXPc.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $f678bd8d7ac0b60d$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $gfm86.default)(ValueSetter, _Setter);
    var _super = (0, $3wwsR.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $kWj1y.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $9xXPc.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($f678bd8d7ac0b60d$export$81d53e3678089a6);
var $f678bd8d7ac0b60d$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $gfm86.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $3wwsR.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $kWj1y.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this2), "priority", $f678bd8d7ac0b60d$var$TIMEZONE_UNIT_PRIORITY);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $9xXPc.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($f678bd8d7ac0b60d$export$81d53e3678089a6);
module.exports["ValueSetter"] = $f678bd8d7ac0b60d$export$9a09e32dd4990fd5;
module.exports["DateToSystemTimezoneSetter"] = $f678bd8d7ac0b60d$export$5aaf7ff7f09ea4ee;

});

parcelRegister("5KkDP", function(module, exports) {
function $42f1429094bd004c$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports["default"] = $42f1429094bd004c$export$2e2bcd8739ae039;

});

parcelRegister("gfm86", function(module, exports) {

var $9JDHm = parcelRequire("9JDHm");

function $bd3f3687ad31e822$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $9JDHm.default)(t, e);
}
module.exports["default"] = $bd3f3687ad31e822$export$2e2bcd8739ae039;

});

parcelRegister("3wwsR", function(module, exports) {

var $23OHc = parcelRequire("23OHc");


var $1dBP2 = parcelRequire("1dBP2");


var $82Dwy = parcelRequire("82Dwy");

function $290d8b0c402264de$export$2e2bcd8739ae039(t) {
    var r = (0, $1dBP2.default)();
    return function() {
        var e, o = (0, $23OHc.default)(t);
        if (r) {
            var s = (0, $23OHc.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $82Dwy.default)(this, e);
    };
}
module.exports["default"] = $290d8b0c402264de$export$2e2bcd8739ae039;

});

parcelRegister("23OHc", function(module, exports) {
$parcel$export(module.exports, "default", () => $18032fb0cc96bfcf$export$2e2bcd8739ae039);
function $18032fb0cc96bfcf$export$2e2bcd8739ae039(t) {
    return $18032fb0cc96bfcf$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $18032fb0cc96bfcf$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1dBP2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e34580674e4df99$export$2e2bcd8739ae039);
function $0e34580674e4df99$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0e34580674e4df99$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("82Dwy", function(module, exports) {

var $da6O1 = parcelRequire("da6O1");


var $5KkDP = parcelRequire("5KkDP");

function $5dad2b4c21ff4d60$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $da6O1.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $5KkDP.default)(t);
}
module.exports["default"] = $5dad2b4c21ff4d60$export$2e2bcd8739ae039;

});

parcelRegister("kWj1y", function(module, exports) {
function $f3e7fb3aad6b0ea3$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports["default"] = $f3e7fb3aad6b0ea3$export$2e2bcd8739ae039;

});

parcelRegister("9xXPc", function(module, exports) {

var $gCRro = parcelRequire("gCRro");

function $6f359a1653c3da39$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $gCRro.default)(o.key), o);
    }
}
function $6f359a1653c3da39$export$2e2bcd8739ae039(e, r, t) {
    return r && $6f359a1653c3da39$var$_defineProperties(e.prototype, r), t && $6f359a1653c3da39$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports["default"] = $6f359a1653c3da39$export$2e2bcd8739ae039;

});

parcelRegister("3Ujd4", function(module, exports) {

var $hzQbH = parcelRequire("hzQbH");


var $ME38g = parcelRequire("ME38g");


var $ODxM2 = parcelRequire("ODxM2");


var $afFXj = parcelRequire("afFXj");


var $7Wbag = parcelRequire("7Wbag");


var $du6zo = parcelRequire("du6zo");


var $2hTtW = parcelRequire("2hTtW");


var $lof2I = parcelRequire("lof2I");


var $1wUSc = parcelRequire("1wUSc");


var $dJ7Bc = parcelRequire("dJ7Bc");


var $56Qdz = parcelRequire("56Qdz");


var $f5ZuE = parcelRequire("f5ZuE");


var $hahvS = parcelRequire("hahvS");


var $4hkrg = parcelRequire("4hkrg");


var $8W49h = parcelRequire("8W49h");


var $dGU37 = parcelRequire("dGU37");


var $5jyPW = parcelRequire("5jyPW");


var $9v13k = parcelRequire("9v13k");


var $5IZ8l = parcelRequire("5IZ8l");


var $5GZ8B = parcelRequire("5GZ8B");


var $jvsga = parcelRequire("jvsga");


var $159WX = parcelRequire("159WX");


var $kEUZw = parcelRequire("kEUZw");


var $8dVaB = parcelRequire("8dVaB");


var $iPEk0 = parcelRequire("iPEk0");


var $8UQlb = parcelRequire("8UQlb");


var $c1MLX = parcelRequire("c1MLX");


var $jtzx8 = parcelRequire("jtzx8");


var $8szAD = parcelRequire("8szAD");


var $7XQKb = parcelRequire("7XQKb");


var $kNeQk = parcelRequire("kNeQk");

var $2d8580c1357539e5$export$19131010e7fd8373 = {
    G: new (0, $hzQbH.EraParser)(),
    y: new (0, $ME38g.YearParser)(),
    Y: new (0, $ODxM2.LocalWeekYearParser)(),
    R: new (0, $afFXj.ISOWeekYearParser)(),
    u: new (0, $7Wbag.ExtendedYearParser)(),
    Q: new (0, $du6zo.QuarterParser)(),
    q: new (0, $2hTtW.StandAloneQuarterParser)(),
    M: new (0, $lof2I.MonthParser)(),
    L: new (0, $1wUSc.StandAloneMonthParser)(),
    w: new (0, $dJ7Bc.LocalWeekParser)(),
    I: new (0, $56Qdz.ISOWeekParser)(),
    d: new (0, $f5ZuE.DateParser)(),
    D: new (0, $hahvS.DayOfYearParser)(),
    E: new (0, $4hkrg.DayParser)(),
    e: new (0, $8W49h.LocalDayParser)(),
    c: new (0, $dGU37.StandAloneLocalDayParser)(),
    i: new (0, $5jyPW.ISODayParser)(),
    a: new (0, $9v13k.AMPMParser)(),
    b: new (0, $5IZ8l.AMPMMidnightParser)(),
    B: new (0, $5GZ8B.DayPeriodParser)(),
    h: new (0, $jvsga.Hour1to12Parser)(),
    H: new (0, $159WX.Hour0to23Parser)(),
    K: new (0, $kEUZw.Hour0To11Parser)(),
    k: new (0, $8dVaB.Hour1To24Parser)(),
    m: new (0, $iPEk0.MinuteParser)(),
    s: new (0, $8UQlb.SecondParser)(),
    S: new (0, $c1MLX.FractionOfSecondParser)(),
    X: new (0, $jtzx8.ISOTimezoneWithZParser)(),
    x: new (0, $8szAD.ISOTimezoneParser)(),
    t: new (0, $7XQKb.TimestampSecondsParser)(),
    T: new (0, $kNeQk.TimestampMillisecondsParser)()
};
module.exports["parsers"] = $2d8580c1357539e5$export$19131010e7fd8373;

});

parcelRegister("hzQbH", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");

var $ccbe2ff6d3113980$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(EraParser, _Parser);
    var _super = (0, $3wwsR.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $kWj1y.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 140);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $kOj7r.Parser));
module.exports["EraParser"] = $ccbe2ff6d3113980$export$8e5a1d3f85a9688;

});

parcelRegister("kOj7r", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $iLaQ6 = parcelRequire("iLaQ6");


var $l9XGS = parcelRequire("l9XGS");

var $f2674ecae7b9448f$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $kWj1y.default)(this, Parser);
        (0, $iLaQ6.default)(this, "incompatibleTokens", void 0);
        (0, $iLaQ6.default)(this, "priority", void 0);
        (0, $iLaQ6.default)(this, "subPriority", void 0);
    }
    (0, $9xXPc.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $l9XGS.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();
module.exports["Parser"] = $f2674ecae7b9448f$export$7acfa6ed01010e37;

});

parcelRegister("ME38g", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $09238ccf5261b9b2$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(YearParser, _Parser);
    var _super = (0, $3wwsR.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $kWj1y.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 130);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $9lhtP.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $kOj7r.Parser));
module.exports["YearParser"] = $09238ccf5261b9b2$export$48d352de7cd4a988;

});

parcelRegister("9lhtP", function(module, exports) {

var $jx0NF = parcelRequire("jx0NF");


var $aSp9j = parcelRequire("aSp9j");

function $6cd3a26cb85520f8$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $6cd3a26cb85520f8$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * (0, $jx0NF.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $6cd3a26cb85520f8$export$d931c43c4608a164(dateString) {
    return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).anyDigitsSigned, dateString);
}
function $6cd3a26cb85520f8$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).singleDigit, dateString);
        case 2:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).twoDigits, dateString);
        case 3:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).threeDigits, dateString);
        case 4:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).fourDigits, dateString);
        default:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $6cd3a26cb85520f8$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388((0, $aSp9j.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $6cd3a26cb85520f8$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $6cd3a26cb85520f8$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $6cd3a26cb85520f8$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
module.exports["mapValue"] = $6cd3a26cb85520f8$export$4f84e3a82c7b538;
module.exports["parseNumericPattern"] = $6cd3a26cb85520f8$export$cc7cc9e2a3ff9388;
module.exports["parseTimezonePattern"] = $6cd3a26cb85520f8$export$6497f4c0ecdfba8e;
module.exports["parseAnyDigitsSigned"] = $6cd3a26cb85520f8$export$d931c43c4608a164;
module.exports["parseNDigits"] = $6cd3a26cb85520f8$export$513bb01536146ab6;
module.exports["parseNDigitsSigned"] = $6cd3a26cb85520f8$export$2c9307b2e29c533c;
module.exports["dayPeriodEnumToHours"] = $6cd3a26cb85520f8$export$fb506d2676e7f207;
module.exports["normalizeTwoDigitYear"] = $6cd3a26cb85520f8$export$29126f735cbf69f7;
module.exports["isLeapYearIndex"] = $6cd3a26cb85520f8$export$3d50627710b84d75;

});

parcelRegister("aSp9j", function(module, exports) {
var $7eb2749d6724eb00$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $7eb2749d6724eb00$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
module.exports["numericPatterns"] = $7eb2749d6724eb00$export$c123ee06d9da8480;
module.exports["timezonePatterns"] = $7eb2749d6724eb00$export$a7ee192b982af9c1;

});

parcelRegister("ODxM2", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $40Dd9 = parcelRequire("40Dd9");


var $d1KG5 = parcelRequire("d1KG5");

var $0983583080df7973$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $3wwsR.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $kWj1y.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 130);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $40Dd9.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $9lhtP.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $d1KG5.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $d1KG5.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $kOj7r.Parser));
module.exports["LocalWeekYearParser"] = $0983583080df7973$export$b8ef38dfcf05d5db;

});

parcelRegister("afFXj", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $3QScg = parcelRequire("3QScg");

var $776bd9985b6b00f7$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $3wwsR.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $kWj1y.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 130);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $9lhtP.parseNDigitsSigned)(4, dateString);
                return (0, $9lhtP.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $3QScg.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $kOj7r.Parser));
module.exports["ISOWeekYearParser"] = $776bd9985b6b00f7$export$951d1df011fde06f;

});

parcelRegister("7Wbag", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $5c769c3685de8d82$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ExtendedYearParser, _Parser);
    var _super = (0, $3wwsR.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $kWj1y.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 130);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $9lhtP.parseNDigitsSigned)(4, dateString);
                return (0, $9lhtP.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $kOj7r.Parser));
module.exports["ExtendedYearParser"] = $5c769c3685de8d82$export$bad9d2ea38e8f1a;

});

parcelRegister("du6zo", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $9d132c56bb070087$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(QuarterParser, _Parser);
    var _super = (0, $3wwsR.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $kWj1y.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 120);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $kOj7r.Parser));
module.exports["QuarterParser"] = $9d132c56bb070087$export$5cb0f701186dde1d;

});

parcelRegister("2hTtW", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $1aa834dc0b623229$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $3wwsR.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $kWj1y.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 120);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $kOj7r.Parser));
module.exports["StandAloneQuarterParser"] = $1aa834dc0b623229$export$300c0c2990e20e6d;

});

parcelRegister("lof2I", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $9lhtP = parcelRequire("9lhtP");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");

var $f927820bdb3df3ab$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(MonthParser, _Parser);
    var _super = (0, $3wwsR.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $kWj1y.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 110);
        return _this;
    }
    (0, $9xXPc.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $kOj7r.Parser));
module.exports["MonthParser"] = $f927820bdb3df3ab$export$400dd8b40ef138a3;

});

parcelRegister("1wUSc", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $11d4e570e96dee1e$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $3wwsR.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $kWj1y.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 110);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $kOj7r.Parser));
module.exports["StandAloneMonthParser"] = $11d4e570e96dee1e$export$1d7eaa53eaa5deba;

});

parcelRegister("dJ7Bc", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");


var $inO80 = parcelRequire("inO80");


var $d1KG5 = parcelRequire("d1KG5");

var $9fe55f4f8f362fac$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(LocalWeekParser, _Parser);
    var _super = (0, $3wwsR.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $kWj1y.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 100);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $d1KG5.default)((0, $inO80.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $kOj7r.Parser));
module.exports["LocalWeekParser"] = $9fe55f4f8f362fac$export$c4005ffc174e07c0;

});

parcelRegister("inO80", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6214262b8dafb1c$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $ld8ZT = parcelRequire("ld8ZT");


var $b5utg = parcelRequire("b5utg");

function $d6214262b8dafb1c$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var week = (0, $jZ39j.default)(dirtyWeek);
    var diff = (0, $ld8ZT.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("56Qdz", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");


var $aXMUM = parcelRequire("aXMUM");


var $3QScg = parcelRequire("3QScg");

var $3b8604a6bc017761$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISOWeekParser, _Parser);
    var _super = (0, $3wwsR.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $kWj1y.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 100);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $3QScg.default)((0, $aXMUM.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $kOj7r.Parser));
module.exports["ISOWeekParser"] = $3b8604a6bc017761$export$6fc8dbedd560a6af;

});

parcelRegister("aXMUM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fb55b89aceb3469$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $8mXz6 = parcelRequire("8mXz6");


var $b5utg = parcelRequire("b5utg");

function $7fb55b89aceb3469$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var isoWeek = (0, $jZ39j.default)(dirtyISOWeek);
    var diff = (0, $8mXz6.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("f5ZuE", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $9lhtP = parcelRequire("9lhtP");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");

var $afd705f45f0b715c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $afd705f45f0b715c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $afd705f45f0b715c$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(DateParser, _Parser);
    var _super = (0, $3wwsR.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $kWj1y.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "subPriority", 1);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $9lhtP.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $afd705f45f0b715c$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $afd705f45f0b715c$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $kOj7r.Parser));
module.exports["DateParser"] = $afd705f45f0b715c$export$e8d4b28a20981dd2;

});

parcelRegister("hahvS", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $c7f0f49202d1fedf$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(DayOfYearParser, _Parser);
    var _super = (0, $3wwsR.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $kWj1y.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "subpriority", 1);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $9lhtP.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $kOj7r.Parser));
module.exports["DayOfYearParser"] = $c7f0f49202d1fedf$export$6cfe0d613455f615;

});

parcelRegister("4hkrg", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $g6CRr = parcelRequire("g6CRr");

var $31d89aa5cc04b396$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(DayParser, _Parser);
    var _super = (0, $3wwsR.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $kWj1y.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $g6CRr.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $kOj7r.Parser));
module.exports["DayParser"] = $31d89aa5cc04b396$export$1b03c8b76262f7bd;

});

parcelRegister("g6CRr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0306a27b35342568$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");


var $2h3f7 = parcelRequire("2h3f7");

function $0306a27b35342568$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(2, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = (0, $jZ39j.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("8W49h", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $g6CRr = parcelRequire("g6CRr");

var $6816f55b5a2b6010$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(LocalDayParser, _Parser);
    var _super = (0, $3wwsR.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $kWj1y.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $g6CRr.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $kOj7r.Parser));
module.exports["LocalDayParser"] = $6816f55b5a2b6010$export$44d1c127ab42c480;

});

parcelRegister("dGU37", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $g6CRr = parcelRequire("g6CRr");

var $9f7aacdaf3090d72$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $3wwsR.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $kWj1y.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $9lhtP.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $g6CRr.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $kOj7r.Parser));
module.exports["StandAloneLocalDayParser"] = $9f7aacdaf3090d72$export$e447a647caaaec1d;

});

parcelRegister("5jyPW", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");


var $b3fnO = parcelRequire("b3fnO");

var $3de9bff04ea0a6c5$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISODayParser, _Parser);
    var _super = (0, $3wwsR.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $kWj1y.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 90);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $9lhtP.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $9lhtP.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $9lhtP.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $9lhtP.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $b3fnO.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $kOj7r.Parser));
module.exports["ISODayParser"] = $3de9bff04ea0a6c5$export$693fb1e525095b2a;

});

parcelRegister("b3fnO", function(module, exports) {
$parcel$export(module.exports, "default", () => $80bbe8412f227e83$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $80bbe8412f227e83$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $b5utg.default)(2, arguments);
    var day = (0, $jZ39j.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $egXhZ.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("9v13k", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $6ea7d35c0c9fd41f$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(AMPMParser, _Parser);
    var _super = (0, $3wwsR.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $kWj1y.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 80);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $9lhtP.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $kOj7r.Parser));
module.exports["AMPMParser"] = $6ea7d35c0c9fd41f$export$8d1e08492351df91;

});

parcelRegister("5IZ8l", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $42b07bae4fbc7607$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $3wwsR.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $kWj1y.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 80);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $9lhtP.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $kOj7r.Parser));
module.exports["AMPMMidnightParser"] = $42b07bae4fbc7607$export$73ca2bd0a17d273;

});

parcelRegister("5GZ8B", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $42504cb0c2d84ce0$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(DayPeriodParser, _Parser);
    var _super = (0, $3wwsR.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $kWj1y.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 80);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $9lhtP.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $kOj7r.Parser));
module.exports["DayPeriodParser"] = $42504cb0c2d84ce0$export$bb9212adf05373db;

});

parcelRegister("jvsga", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $e336d561ce89ecd5$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(Hour1to12Parser, _Parser);
    var _super = (0, $3wwsR.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $kWj1y.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 70);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $kOj7r.Parser));
module.exports["Hour1to12Parser"] = $e336d561ce89ecd5$export$8a04050a727a1756;

});

parcelRegister("159WX", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $0c9df9ea87066242$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(Hour0to23Parser, _Parser);
    var _super = (0, $3wwsR.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $kWj1y.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 70);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $kOj7r.Parser));
module.exports["Hour0to23Parser"] = $0c9df9ea87066242$export$e56f4dea2c3e56dd;

});

parcelRegister("kEUZw", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $f0a3c057ace59c5d$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(Hour0To11Parser, _Parser);
    var _super = (0, $3wwsR.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $kWj1y.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 70);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $kOj7r.Parser));
module.exports["Hour0To11Parser"] = $f0a3c057ace59c5d$export$cbbe855312f87d77;

});

parcelRegister("8dVaB", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $5fcbe266be913f82$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(Hour1To24Parser, _Parser);
    var _super = (0, $3wwsR.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $kWj1y.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 70);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $kOj7r.Parser));
module.exports["Hour1To24Parser"] = $5fcbe266be913f82$export$6008046d2b34b6a5;

});

parcelRegister("iPEk0", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $db5c447921e67e0d$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(MinuteParser, _Parser);
    var _super = (0, $3wwsR.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $kWj1y.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 60);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $kOj7r.Parser));
module.exports["MinuteParser"] = $db5c447921e67e0d$export$2b52670d9e2be53;

});

parcelRegister("8UQlb", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $67dc2776c62adca4$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(SecondParser, _Parser);
    var _super = (0, $3wwsR.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $kWj1y.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 50);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $9lhtP.parseNumericPattern)((0, $aSp9j.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $9lhtP.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $kOj7r.Parser));
module.exports["SecondParser"] = $67dc2776c62adca4$export$94d46d540cf1366a;

});

parcelRegister("c1MLX", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $8c1b693bbf932733$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $3wwsR.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $kWj1y.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 30);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $9lhtP.mapValue)((0, $9lhtP.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $kOj7r.Parser));
module.exports["FractionOfSecondParser"] = $8c1b693bbf932733$export$b8e6f8b2d70893b1;

});

parcelRegister("jtzx8", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $e2dc49ee04af4fe5$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $3wwsR.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $kWj1y.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 10);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $kOj7r.Parser));
module.exports["ISOTimezoneWithZParser"] = $e2dc49ee04af4fe5$export$104d901d49fea29b;

});

parcelRegister("8szAD", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $aSp9j = parcelRequire("aSp9j");


var $9lhtP = parcelRequire("9lhtP");

var $628c8bac8c7dfaae$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $3wwsR.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $kWj1y.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 10);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $9xXPc.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $9lhtP.parseTimezonePattern)((0, $aSp9j.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $kOj7r.Parser));
module.exports["ISOTimezoneParser"] = $628c8bac8c7dfaae$export$12910e5204b52b9;

});

parcelRegister("7XQKb", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $5cc6f4e956e5cc96$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $3wwsR.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $kWj1y.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 40);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $9xXPc.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $9lhtP.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $kOj7r.Parser));
module.exports["TimestampSecondsParser"] = $5cc6f4e956e5cc96$export$2cd8bf877a05e96;

});

parcelRegister("kNeQk", function(module, exports) {

var $kWj1y = parcelRequire("kWj1y");


var $9xXPc = parcelRequire("9xXPc");


var $5KkDP = parcelRequire("5KkDP");


var $gfm86 = parcelRequire("gfm86");


var $3wwsR = parcelRequire("3wwsR");


var $iLaQ6 = parcelRequire("iLaQ6");


var $kOj7r = parcelRequire("kOj7r");


var $9lhtP = parcelRequire("9lhtP");

var $f233e5c71665e058$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $gfm86.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $3wwsR.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $kWj1y.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "priority", 20);
        (0, $iLaQ6.default)((0, $5KkDP.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $9xXPc.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $9lhtP.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $kOj7r.Parser));
module.exports["TimestampMillisecondsParser"] = $f233e5c71665e058$export$6d8f69c6906d6368;

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("aY6zh", function(module, exports) {

var $bqMS3 = parcelRequire("bqMS3");

var $6mYMS = parcelRequire("6mYMS");


var $grTgx = parcelRequire("grTgx");


var $9w35C = parcelRequire("9w35C");


var $f8oLo = parcelRequire("f8oLo");


var $eHWNJ = parcelRequire("eHWNJ");

const $9ff3e07c34644328$var$CONTEXT_TYPE = 'Mentions';
const $9ff3e07c34644328$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */ class $9ff3e07c34644328$var$SmartMentionResource extends (0, $bqMS3.AbstractMentionResource) {
    shouldHighlightMention(mention) {
        if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, _query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
    }
    async filter(query, contextIdentifier) {
        this.contextIdentifier = contextIdentifier;
        const searchTime = Date.now();
        try {
            let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    async getRecommendedMentions(query, contextIdentifier) {
        const startTime = window.performance.now();
        const conf = this.smartMentionConfig;
        const maxNumberOfResults = conf.maxNumberOfResults || 100;
        const request = {
            baseUrl: conf.baseUrl,
            context: {
                productKey: conf.productKey,
                contextType: $9ff3e07c34644328$var$CONTEXT_TYPE,
                principalId: conf.principalId || 'context',
                containerId: contextIdentifier && contextIdentifier.containerId,
                siteId: conf.siteId,
                organizationId: conf.orgId,
                objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined'
            },
            includeGroups: conf.includeGroups,
            includeTeams: conf.includeTeams,
            includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
            maxNumberOfResults: maxNumberOfResults,
            searchQueryFilter: conf.searchQueryFilter,
            query: query
        };
        try {
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'users', (0, $9w35C.Actions).REQUESTED, (0, $9w35C.defaultAttributes)(contextIdentifier));
            const users = await (0, $eHWNJ.default)(request);
            const elapsedTimeMilli = window.performance.now() - startTime;
            const usersForAnalytics = (0, $9w35C.getUsersForAnalytics)(users);
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).SUCCESSFUL, {
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics,
                ...(0, $9w35C.defaultAttributes)(contextIdentifier)
            });
            const mentions = this.transformUsersToMentions(users);
            return {
                mentions: mentions,
                query: query
            };
        } catch (e) {
            const elapsedTimeMilli = window.performance.now() - startTime;
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).FAILED, {
                elapsedTimeMilli: elapsedTimeMilli,
                ...(0, $9w35C.defaultAttributes)(contextIdentifier)
            });
            throw e instanceof Error ? e : new Error(String(e));
        }
    }
    transformTeamMember(member) {
        return {
            id: member.id,
            name: member.name
        };
    }
    transformUserToMention(item) {
        const type = item.entityType;
        let defaultVals = {
            source: 'smarts'
        };
        if (type === (0, $grTgx.EntityType).USER) {
            const user = item;
            return {
                ...defaultVals,
                id: user.id,
                accessLevel: user.accessLevel,
                avatarUrl: user.avatarUrl,
                mentionName: user.nickname || '',
                name: user.name,
                userType: user.userType
            };
        }
        if (type === (0, $grTgx.EntityType).TEAM) {
            const team = item;
            let teamLink = '';
            const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
            if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
            return {
                ...defaultVals,
                id: team.id,
                name: team.displayName || '',
                mentionName: team.displayName,
                avatarUrl: team.smallAvatarImageUrl,
                accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
                userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
                lozenge: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
                context: {
                    members: team.members ? team.members.map(this.transformTeamMember) : [],
                    includesYou: team.includesYou || false,
                    memberCount: team.memberCount || 0,
                    teamLink: teamLink || defaultTeamLink //OOH HERE Do we pass in resolver or add in provider?
                },
                source: 'smarts'
            };
        }
        if (type === (0, $grTgx.EntityType).GROUP) {
            const group = item;
            return {
                ...defaultVals,
                id: group.id,
                userType: type.toLowerCase(),
                name: group.name || '',
                lozenge: type.toLowerCase()
            };
        }
        return {
            id: item.id,
            userType: (0, $grTgx.EntityType).USER.toLowerCase(),
            avatarUrl: item.avatarUrl,
            name: item.name,
            lozenge: (0, $grTgx.EntityType).USER.toLowerCase()
        };
    }
    transformUsersToMentions(recommendationItems) {
        return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
    }
    cacheMentionName(id, mentionName) {
        this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
    resolveMentionName(id) {
        return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return true;
    }
    recordMentionSelection(_mention) {
        this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).SELECTED, {
            selectedOption: _mention.id,
            ...(0, $9w35C.defaultAttributes)(this.contextIdentifier)
        });
    }
    constructor(smartMentionConfig){
        super();
        // If the product doesn't provide a mention name resolve, use the default resolver so that
        // mention names can be looked up from PRS without configuration.
        this.smartMentionConfig = void 0;
        this.lastReturnedSearch = void 0;
        this.contextIdentifier = void 0;
        this.smartMentionConfig = $9ff3e07c34644328$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
            ...smartMentionConfig,
            mentionNameResolver: new (0, $f8oLo.DefaultMentionNameResolver)(smartMentionConfig.baseUrl, smartMentionConfig.siteId, smartMentionConfig.productKey)
        };
        this.lastReturnedSearch = 0;
    }
}
var $9ff3e07c34644328$export$2e2bcd8739ae039 = $9ff3e07c34644328$var$SmartMentionResource;
module.exports["default"] = $9ff3e07c34644328$export$2e2bcd8739ae039;

});

parcelRegister("grTgx", function(module, exports) {
var $066beef4d1f2f02a$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
module.exports["EntityType"] = $066beef4d1f2f02a$export$8eda7e02f8f033b2;

});

parcelRegister("9w35C", function(module, exports) {
const $4f1d2b2c69412aab$export$c724588856bbfbcf = 'smart';
var $4f1d2b2c69412aab$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["REQUESTED"] = "requested";
    Actions["SUCCESSFUL"] = "successful";
    Actions["SEARCHED"] = "searched";
    Actions["FAILED"] = "failed";
    Actions["SELECTED"] = "selected";
    return Actions;
}({});
const $4f1d2b2c69412aab$export$38cd8db2db178f58 = (context)=>{
    return {
        context: context?.objectId || '',
        sessionId: context?.sessionId || '',
        pickerType: 'mentions',
        source: 'smarts'
    };
};
const $4f1d2b2c69412aab$export$e8be30a842a4b49d = (users)=>{
    return users ? users.map(({ id: id, entityType: entityType })=>({
            id: id,
            type: entityType.toLowerCase()
        })) : [];
};
module.exports["SMART_EVENT_TYPE"] = $4f1d2b2c69412aab$export$c724588856bbfbcf;
module.exports["Actions"] = $4f1d2b2c69412aab$export$b52183d5cfb26dc9;
module.exports["defaultAttributes"] = $4f1d2b2c69412aab$export$38cd8db2db178f58;
module.exports["getUsersForAnalytics"] = $4f1d2b2c69412aab$export$e8be30a842a4b49d;

});

parcelRegister("f8oLo", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $1NrSh = parcelRequire("1NrSh");


var $9KHZR = parcelRequire("9KHZR");

const $760648ceb1fc9809$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $760648ceb1fc9809$var$makeRequest = async (url, accountIds, cloudId, product)=>{
    const query = $760648ceb1fc9809$var$buildUsersQuery(accountIds);
    return (0, $9KHZR.graphqlQuery)(url, query, cloudId, product);
};
class $760648ceb1fc9809$export$2ae0434dccdcb77e {
    async lookupName(id) {
        try {
            if (this.cache.has(id)) return {
                id: id,
                name: this.cache.get(id),
                status: (0, $6mYMS.MentionNameStatus).OK
            };
            const url = (0, $1NrSh.PRD_CONFIG).getGraphQLUrl(this.baseUrl);
            const data = await $760648ceb1fc9809$var$makeRequest(url, [
                id
            ], this.cloudId, this.product);
            const userInfo = data.users?.find((user)=>user.accountId === id);
            return userInfo ? {
                id: id,
                name: userInfo.name,
                status: (0, $6mYMS.MentionNameStatus).OK
            } : {
                id: id,
                status: (0, $6mYMS.MentionNameStatus).UNKNOWN
            };
        } catch  {
            // on network error, return original list with label 'Unknown'
            return {
                id: id,
                status: (0, $6mYMS.MentionNameStatus).UNKNOWN
            };
        }
    }
    cacheName(id, name) {
        this.cache.set(id, name);
    }
    constructor(baseUrl, cloudId, product){
        this.baseUrl = void 0;
        this.cloudId = void 0;
        this.product = void 0;
        this.cache = void 0;
        this.baseUrl = baseUrl;
        this.cloudId = cloudId;
        this.product = product;
        this.cache = new Map();
    }
}
module.exports["DefaultMentionNameResolver"] = $760648ceb1fc9809$export$2ae0434dccdcb77e;

});

parcelRegister("1NrSh", function(module, exports) {
const $49895188b0a86f3f$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $49895188b0a86f3f$export$d4fff2dfff3e2bc1;

});

parcelRegister("9KHZR", function(module, exports) {
const $6d4812bfe02f5ea6$var$buildHeaders = (cloudId, product = 'platform')=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    if (cloudId && product) {
        const atlAttributionHeader = {
            tenantId: cloudId,
            product: product
        };
        headers.append('atl-attribution', JSON.stringify(atlAttributionHeader));
    }
    return headers;
};
function $6d4812bfe02f5ea6$export$74eb8d79ae3e02b5(serviceUrl, query, cloudId, product) {
    const headers = $6d4812bfe02f5ea6$var$buildHeaders(cloudId, product);
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $6d4812bfe02f5ea6$export$74eb8d79ae3e02b5;

});

parcelRegister("eHWNJ", function(module, exports) {

var $1NrSh = parcelRequire("1NrSh");

const $721aad13b249dafb$var$getUserRecommendations = (request)=>{
    const url = (0, $1NrSh.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>response.recommendedUsers);
};
var $721aad13b249dafb$export$2e2bcd8739ae039 = $721aad13b249dafb$var$getUserRecommendations;
module.exports["default"] = $721aad13b249dafb$export$2e2bcd8739ae039;

});

parcelRegister("7uLCZ", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $2HVlJ = parcelRequire("2HVlJ");



var $lPGZG = parcelRequire("lPGZG");


var $dlky5 = parcelRequire("dlky5");

var $575047a4d1f8def0$export$bb38bb9a1161268 = 'unmounted';
var $575047a4d1f8def0$export$84cbff306f539230 = 'exited';
var $575047a4d1f8def0$export$df38205c966be359 = 'entering';
var $575047a4d1f8def0$export$78e9e6e3e014d60a = 'entered';
var $575047a4d1f8def0$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $575047a4d1f8def0$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
                _this.appearStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else initialStatus = $575047a4d1f8def0$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $575047a4d1f8def0$export$bb38bb9a1161268;
        else initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $575047a4d1f8def0$export$bb38bb9a1161268) return {
            status: $575047a4d1f8def0$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $575047a4d1f8def0$export$df38205c966be359 && status !== $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else if (status === $575047a4d1f8def0$export$df38205c966be359 || status === $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $575047a4d1f8def0$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $dlky5.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $575047a4d1f8def0$export$84cbff306f539230) this.setState({
            status: $575047a4d1f8def0$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $575047a4d1f8def0$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $575047a4d1f8def0$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $575047a4d1f8def0$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $575047a4d1f8def0$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $575047a4d1f8def0$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bDniu.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lPGZG.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$575047a4d1f8def0$var$Transition.contextType = (0, $lPGZG.default);
$575047a4d1f8def0$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $575047a4d1f8def0$var$noop() {}
$575047a4d1f8def0$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $575047a4d1f8def0$var$noop,
    onEntering: $575047a4d1f8def0$var$noop,
    onEntered: $575047a4d1f8def0$var$noop,
    onExit: $575047a4d1f8def0$var$noop,
    onExiting: $575047a4d1f8def0$var$noop,
    onExited: $575047a4d1f8def0$var$noop
};
$575047a4d1f8def0$var$Transition.UNMOUNTED = $575047a4d1f8def0$export$bb38bb9a1161268;
$575047a4d1f8def0$var$Transition.EXITED = $575047a4d1f8def0$export$84cbff306f539230;
$575047a4d1f8def0$var$Transition.ENTERING = $575047a4d1f8def0$export$df38205c966be359;
$575047a4d1f8def0$var$Transition.ENTERED = $575047a4d1f8def0$export$78e9e6e3e014d60a;
$575047a4d1f8def0$var$Transition.EXITING = $575047a4d1f8def0$export$4aacc83d4d59139f;
var $575047a4d1f8def0$export$2e2bcd8739ae039 = $575047a4d1f8def0$var$Transition;
module.exports["default"] = $575047a4d1f8def0$export$2e2bcd8739ae039;

});

parcelRegister("2HVlJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8c1559a495fd3f$export$2e2bcd8739ae039);
var $1f8c1559a495fd3f$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("lPGZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4fb61bd619d593$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var $fe4fb61bd619d593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);

});

parcelRegister("dlky5", function(module, exports) {
var $9b6d2d196fd1178d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $9b6d2d196fd1178d$export$7d26bbb1236dafd6;

});

parcelRegister("6eZqW", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8m4tT = parcelRequire("8m4tT");


var $8nxxM = parcelRequire("8nxxM");


var $2htg1 = parcelRequire("2htg1");

/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $8m4tT.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $8m4tT.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $fb0b992a34319cb0$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $fb0b992a34319cb0$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $fb0b992a34319cb0$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $fb0b992a34319cb0$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $fb0b992a34319cb0$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $fb0b992a34319cb0$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $fb0b992a34319cb0$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $fb0b992a34319cb0$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $fb0b992a34319cb0$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const markdownSerializerState = new (0, $2htg1.MarkdownSerializerState)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $8nxxM.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}
module.exports["convertProsemirrorToMarkdown"] = $fb0b992a34319cb0$export$cc6cac500a4da966;
module.exports["convertProsemirrorNodeToMarkdown"] = $fb0b992a34319cb0$export$3d24004275aefeab;

});

parcelRegister("8nxxM", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

class $13b081699855d8a3$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $5SAOw.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}
module.exports["ProseMirrorContentStatistics"] = $13b081699855d8a3$export$acf14785d7d5b1be;

});

parcelRegister("2htg1", function(module, exports) {

var $42JDa = parcelRequire("42JDa");


var $5SAOw = parcelRequire("5SAOw");


var $2xv4m = parcelRequire("2xv4m");


var $bd943 = parcelRequire("bd943");


var $50zV1 = parcelRequire("50zV1");


var $8q1Q5 = parcelRequire("8q1Q5");

const $e985dce6263f3bba$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $8q1Q5.stringRepeat)('`', length);
    };
})();
class $e985dce6263f3bba$export$61055fa707e69319 extends (0, $42JDa.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return /(^|\n)$/.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp, @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/^`/)) text = ' ' + text;
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    if (text.match(/`$/)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore -next-line
        super($e985dce6263f3bba$export$695720b7e7a61533, $e985dce6263f3bba$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $e985dce6263f3bba$export$695720b7e7a61533;
        this.marks = $e985dce6263f3bba$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $e985dce6263f3bba$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $e985dce6263f3bba$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $50zV1.getOrderFromMaybeOrderedListNode)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $5SAOw.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = `blob:${(0, $bd943.MEDIA_BASE_URL_STAGING)}/?`;
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $8q1Q5.escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $8q1Q5.escapeMarkdown)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $8q1Q5.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$e985dce6263f3bba$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                // Ensure localId is explicitly set to null if not present
                const attributes = {
                    ...node.attrs,
                    localId: node.attrs.localId ?? null
                };
                state.idMap[id] = {
                    type: 'date',
                    attributes: attributes
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $e985dce6263f3bba$export$695720b7e7a61533 = {
    ...$e985dce6263f3bba$var$editorNodes,
    ...(0, $2xv4m.default)
};
const $e985dce6263f3bba$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};
module.exports["MarkdownSerializerState"] = $e985dce6263f3bba$export$61055fa707e69319;

});

parcelRegister("2xv4m", function(module, exports) {

var $2VvL9 = parcelRequire("2VvL9");

const $deb7030063275628$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $deb7030063275628$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $deb7030063275628$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($deb7030063275628$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $deb7030063275628$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $deb7030063275628$var$renderNode(state, child, i);
    });
};
const $deb7030063275628$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $deb7030063275628$var$renderNode(state, node, 0);
    state.write(' ');
};
const $deb7030063275628$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $deb7030063275628$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($deb7030063275628$var$isHeaderRow(node) || $deb7030063275628$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $2VvL9.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $deb7030063275628$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $deb7030063275628$export$2e2bcd8739ae039 = $deb7030063275628$var$tableNodes;
module.exports["default"] = $deb7030063275628$export$2e2bcd8739ae039;

});

parcelRegister("2VvL9", function(module, exports) {
const $92afea9a8f6a2cee$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};
module.exports["attributesMatchDefault"] = $92afea9a8f6a2cee$export$5be26e657c035da4;

});

parcelRegister("50zV1", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

const $6ff1f24202635c31$export$8ef94ae42a3729bd = 1;
const $6ff1f24202635c31$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $6ff1f24202635c31$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $5SAOw.Node))) return $6ff1f24202635c31$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $6ff1f24202635c31$export$d445360e2a3c026b(order) ?? $6ff1f24202635c31$export$8ef94ae42a3729bd;
};
module.exports["getOrderFromMaybeOrderedListNode"] = $6ff1f24202635c31$export$4ea3c6bbdf8f7944;

});

parcelRegister("8q1Q5", function(module, exports) {
/**
 * A replacement for `String.repeat` until it becomes widely available.
 */ function $74c7a8487430b8e3$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $74c7a8487430b8e3$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\+[ ]|[\-*>])/, '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/^(\s*\d+)\.\s/, '$1\\. ');
    if (insideTable) // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $74c7a8487430b8e3$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
function $74c7a8487430b8e3$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($74c7a8487430b8e3$var$SPECIAL_CHARACTERS, '');
    Array.from(node.childNodes).forEach((child)=>$74c7a8487430b8e3$var$removeSpecialCharacters(child));
}
function $74c7a8487430b8e3$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $74c7a8487430b8e3$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const usernameMatch = title.match(/^@(.*?)$/);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            const idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}
module.exports["stringRepeat"] = $74c7a8487430b8e3$export$345d822805ab3239;
module.exports["escapeMarkdown"] = $74c7a8487430b8e3$export$560888d6fe0cfe97;

});

parcelRegister("7ShCl", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3d55d2ba43147efd$export$480e55f805d7990f = (0, $aXWIB.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    },
    // On-paste menu messages
    pasteMenuActionsTitle: {
        id: "fabric.editor.ai.paste-menu.section-title",
        defaultMessage: "Actions"
    },
    // Block menu messages
    blockMenuNestedMenuTitle: {
        id: "fabric.editor.ai.config.item.blockMenuNestedMenu.title",
        defaultMessage: "View more actions"
    },
    // Smartlink action messages
    smartlinkListKeyTopics: {
        id: "fabric.editor.ai.smartlink.action.listKeyTopics",
        defaultMessage: "List key topics"
    },
    smartlinkListKeyThemes: {
        id: "fabric.editor.ai.smartlink.action.listKeyThemes",
        defaultMessage: "List key themes"
    },
    smartlinkExtractInsights: {
        id: "fabric.editor.ai.smartlink.action.extractInsights",
        defaultMessage: "Extract insights"
    },
    smartlinkExtractUserQuotes: {
        id: "fabric.editor.ai.smartlink.action.extractUserQuotes",
        defaultMessage: "Extract user quotes"
    },
    smartlinkAddDecisions: {
        id: "fabric.editor.ai.smartlink.action.addDecisions",
        defaultMessage: "Add decisions"
    },
    smartlinkDefineActionItems: {
        id: "fabric.editor.ai.smartlink.action.defineActionItems",
        defaultMessage: "Define action items"
    },
    smartlinkSummarizeChanges: {
        id: "fabric.editor.ai.smartlink.action.summarizeChanges",
        defaultMessage: "Summarize changes"
    },
    smartlinkAddRelatedWorkItems: {
        id: "fabric.editor.ai.smartlink.action.addRelatedWorkItems",
        defaultMessage: "Add related work items"
    },
    smartlinkListTodos: {
        id: "fabric.editor.ai.smartlink.action.listTodos",
        defaultMessage: "List to-dos"
    }
});
module.exports["aiMessages"] = $3d55d2ba43147efd$export$480e55f805d7990f;

});

parcelRegister("6Htct", function(module, exports) {
var $4c47f75c6ef52bb8$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $4c47f75c6ef52bb8$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_PULL_REQUEST_WITHOUT_PIPELINES_STARTERS"] = "bitbucket-pull-request-without-pipelines-starters";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["STORE_HOME"] = "store-home";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $4c47f75c6ef52bb8$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $4c47f75c6ef52bb8$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $4c47f75c6ef52bb8$export$c91e07269f22915a;
module.exports["PageContextType"] = $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $4c47f75c6ef52bb8$export$4f757e7d9540e8f9;

});

parcelRegister("2wblJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d575faf3ca782e2$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $4TIFs = parcelRequire("4TIFs");


var $b5utg = parcelRequire("b5utg");

function $1d575faf3ca782e2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $4TIFs.default)(dirtyDate, amount * 12);
}

});

parcelRegister("cbtR4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e145ebbd6eaf2e0b8e4930467ce4a33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dedabaf09e709a0$var$_react = $8dedabaf09e709a0$var$_interopRequireDefault((parcelRequire("42omo")));

var $8dedabaf09e709a0$var$_baseNew = $8dedabaf09e709a0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8dedabaf09e709a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeCleanup".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for automated cleanup and tidy functionality
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8dedabaf09e709a0$var$AiGenerativeCleanupIcon = (props)=>/*#__PURE__*/ $8dedabaf09e709a0$var$_react.default.createElement($8dedabaf09e709a0$var$_baseNew.default, Object.assign({
        name: "AiGenerativeCleanupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.23.44 12.22 8h1.58a2 2 0 0 1 1.91 2.59l-1.23 4a2 2 0 0 1-1.9 1.41H4.75a.75.75 0 0 1-.28-1.45h-.01l.02-.01q.03-.01.1-.06c.09-.06.23-.16.39-.32.31-.32.71-.88.93-1.84l.03-.09L7 9.3A2 2 0 0 1 8.87 8h1.8L12.78.06zM8.87 9.5a.5.5 0 0 0-.47.33l-1.06 2.89a5.7 5.7 0 0 1-.73 1.78h5.97a.5.5 0 0 0 .48-.35l1.23-4a.5.5 0 0 0-.48-.65zM4.62 1.01a.75.75 0 0 1 .54.38l.05.11.54 1.47.05.1a.5.5 0 0 0 .25.2l1.47.54.11.05a.75.75 0 0 1 0 1.31l-.11.05-1.47.54a.5.5 0 0 0-.3.3l-.54 1.47a.75.75 0 0 1-1.36.11l-.05-.1-.54-1.47a.5.5 0 0 0-.2-.25l-.1-.05-1.47-.53a.75.75 0 0 1-.48-.59L1 4.5l.01-.12a.75.75 0 0 1 .48-.59l1.47-.54.1-.05a.5.5 0 0 0 .2-.25l.54-1.47.05-.11A.75.75 0 0 1 4.5 1z"/>`
    }, props));
$8dedabaf09e709a0$var$AiGenerativeCleanupIcon.displayName = 'AiGenerativeCleanupIcon';
var $8dedabaf09e709a0$var$_default = module.exports.default = $8dedabaf09e709a0$var$AiGenerativeCleanupIcon;

});

parcelRegister("6Vqkv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $irOoi = parcelRequire("irOoi");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $dh538 = parcelRequire("dh538");


var $aMqwg = parcelRequire("aMqwg");


var $16lEl = parcelRequire("16lEl");


var $ljUdP = parcelRequire("ljUdP");


var $flpNp = parcelRequire("flpNp");


var $9eLw5 = parcelRequire("9eLw5");


var $h26dv = parcelRequire("h26dv");


var $f2OFx = parcelRequire("f2OFx");


var $2Cfy4 = parcelRequire("2Cfy4");


var $ffpG2 = parcelRequire("ffpG2");


var $iswAx = parcelRequire("iswAx");


var $1uFMJ = parcelRequire("1uFMJ");


var $4ul15 = parcelRequire("4ul15");


var $hT0Hx = parcelRequire("hT0Hx");


var $37oID = parcelRequire("37oID");


var $cqFPV = parcelRequire("cqFPV");


var $ka7s2 = parcelRequire("ka7s2");

const $c0881cdb28f9c5e5$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
        if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
        else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
        else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
        else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
        return categorisedAgents;
    }, {
        public: [],
        private: [],
        system: []
    });
/**
 * @deprecated Please use `useAgentsPaginated...` hooks instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $c0881cdb28f9c5e5$var$agentsStore = (0, $1P1Tu.createStore)({
    initialState: {
        availableAgents: [],
        categorisedAgents: {
            private: [],
            public: [],
            system: []
        },
        agentsInitialized: false,
        agentsError: undefined
    },
    name: 'AgentsStore',
    actions: {
        setAgents: (availableAgents)=>({ setState: setState })=>{
                setState({
                    availableAgents: availableAgents,
                    categorisedAgents: $c0881cdb28f9c5e5$var$categoriseAgents(availableAgents)
                });
            },
        setAgentsInitialized: ()=>({ setState: setState })=>{
                setState({
                    agentsInitialized: true
                });
            },
        setAgentsError: (agentsError)=>({ setState: setState })=>{
                setState({
                    agentsError: agentsError
                });
            }
    }
});
/**
 * @deprecated Please use `useAgentsPaginated...` instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $c0881cdb28f9c5e5$var$useAgentsStore = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsStore);
const $c0881cdb28f9c5e5$export$f5b1109ecd7858c1 = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, experienceId: experienceId, product: product, siteId: siteId, touchpointSource: touchpointSource } })=>{
    // TODO remove `isRovoEnabled`
    const { isRovoEnabled: isRovoEnabled } = (0, $aMqwg.useRovoEntitlement)();
    const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, $hT0Hx.useAgentOverrider)();
    const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized, agentsError: agentsError }, { setAgents: setAgents, setAgentsInitialized: setAgentsInitialized, setAgentsError: setAgentsError }] = $c0881cdb28f9c5e5$var$useAgentsStore();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $4ul15.useAgentFavourites)({
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        }
    });
    const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
    const defaultAgent = (0, $42omo.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
        availableAgents
    ]);
    const nonDefaultAgents = (0, $42omo.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
        availableAgents
    ]);
    const nonDefaultFavouriteAgents = (0, $42omo.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
        nonDefaultAgents
    ]);
    const fetchAndStoreAvailableAgents = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchAgents'
        ],
        queryFn: async ()=>{
            try {
                experienceTracker.start({
                    id: (0, $16lEl.ExperienceName).FETCH_AGENTS,
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                });
                const agents = await assistanceService.getAgents();
                const transformedAgents = agents.map((agent)=>{
                    // Rename default agent to Chat, which is displayed in the UI
                    if (agent.is_default) {
                        agent.name = formatMessage((0, $ka7s2.default).defaultAgentName);
                        agent.description = formatMessage((0, $ka7s2.default).defaultAgentDescription);
                    }
                    return agent;
                });
                const overriddenAgents = (0, $37oID.getOverridenAgents)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                setAgents(overriddenAgents);
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                });
                setAgentsInitialized();
            } catch (error) {
                //Filter out HIPAA errors from experience tracker https://product-fabric.atlassian.net/browse/ROVOFE-543
                if ((0, $cqFPV.isHipaaError)(error)) {
                    experienceTracker.succeed({
                        name: (0, $16lEl.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                if ((0, $ljUdP.isRateLimitedError)(error)) setAgentsError(error);
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS,
                    error: error
                });
                throw error;
            }
        },
        onError: onError,
        enabled: isRovoEnabled,
        refetchOnWindowFocus: false
    });
    const { deleteAgent: deleteAgent } = (0, $1uFMJ.useDeleteAgent)({
        onSuccess: ()=>{
            fetchAndStoreAvailableAgents.refetch();
        },
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        },
        onInit: (id)=>{
            setAgents(availableAgents.filter((agent)=>agent.id !== id));
        },
        onError: ()=>{
            setAgents(availableAgents);
        }
    });
    const setFavouriteAgent = (0, $42omo.useCallback)(async (id, isFavourite)=>{
        const updatedAgent = availableAgents.find((a)=>a.id === id);
        const setUpdatedAgent = (shouldBeFavourite)=>{
            if (updatedAgent) {
                updatedAgent.favourite = shouldBeFavourite;
                setAgents(availableAgents.map((a)=>{
                    // If the current agent's id matches the new agent's id, return the new agent.
                    // Otherwise, return the current agent.
                    return a.id === updatedAgent.id ? updatedAgent : a;
                }));
            }
        };
        //Optimistically update favourite value before we mutate
        setUpdatedAgent(isFavourite);
        //Pass callback to roll back optimistic update if mutation fails
        const errorCallback = {
            onError: ()=>{
                setUpdatedAgent(!isFavourite);
            }
        };
        if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        availableAgents,
        setAgents,
        favouriteAgent,
        unfavouriteAgent
    ]);
    /** This updates the agent on the client side only
   * Useful for updating the agent after a successful mutation
   */ const updateAgentLocally = (0, $42omo.useCallback)((agentId, updatedAgent)=>{
        const updatedAgents = availableAgents.map((agent)=>{
            if (agent.id === agentId) return {
                ...agent,
                ...updatedAgent
            };
            return agent;
        });
        setAgents(updatedAgents);
    }, [
        availableAgents,
        setAgents
    ]);
    return {
        availableAgents: availableAgents,
        favouritedAgents: favouritedAgents,
        categorisedAgents: categorisedAgents,
        fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        defaultAgent: defaultAgent,
        agentsInitialized: agentsInitialized,
        nonDefaultAgents: nonDefaultAgents,
        nonDefaultFavouriteAgents: nonDefaultFavouriteAgents,
        updateAgentLocally: updateAgentLocally,
        agentsError: agentsError
    };
});
const $c0881cdb28f9c5e5$var$agentsPaginatedStore = (0, $1P1Tu.createStore)({
    initialState: {
        /*
    Hash map which is the source of truth for agent data
    agent categories simply hold the agent ids to perform a lookup
    */ agentsMap: {},
        loadingCategories: new Set(),
        agentCategories: {
            ['all-agents']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['starred-agents']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['my-agents']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['templates']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['verified-agents']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['available-for-jira']: {
                agentIds: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            }
        }
    },
    name: 'AgentsPaginatedStore',
    actions: {
        /**
     * This action populates a specific category with backend data
     * it will store the ids in `agentCategories` and the agents in `agentsMap`
     */ populateAgentCategories: ({ agentsList: agentsList, pageInfo: pageInfo, category: category = 'all-agents' })=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                updatedAgentCategories[category].pageInfo = pageInfo;
                if (!agentsList.length) updatedAgentCategories[category].agentIds = [];
                else agentsList.forEach((agent)=>{
                    // Ensure isPlaceholder is cleared when hydrating with real BE data
                    const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                    updatedAgentsMap[agent.id] = {
                        ...existingData,
                        ...agent
                    };
                    updatedAgentCategories[category].agentIds.push(agent.id);
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        setAgentCategoriesByCategory: ({ categoryName: categoryName, agentCategoryData: agentCategoryData })=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: agentCategoryData
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        setCategoryError: (categoryName, agentsError)=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: {
                        ...agentCategories[categoryName],
                        agentsError: agentsError
                    }
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        getAgentCategoriesByCategory: (category)=>({ getState: getState })=>{
                const state = getState();
                const { agentCategories: agentCategories } = state;
                return agentCategories[category];
            },
        removeAgent: (id)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const catsImpacted = new Set();
                let agentToReturn;
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                if (agentsMap[id]) {
                    agentToReturn = agentsMap[id];
                    delete updatedAgentsMap[id];
                }
                Object.keys(agentCategories).forEach((category)=>{
                    if (updatedAgentCategories[category]?.agentIds.includes(id)) {
                        updatedAgentCategories[category].agentIds = updatedAgentCategories[category].agentIds.filter((agentId)=>agentId !== id);
                        catsImpacted.add(category);
                    }
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
                return {
                    agent: agentToReturn,
                    categories: Array.from(catsImpacted)
                };
            },
        addAgent: (agent, categories = [
            'all-agents'
        ])=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                categories.forEach((category)=>{
                    updatedAgentCategories?.[category]?.agentIds.push(agent.id);
                });
                // Ensure isPlaceholder is cleared when adding full agent data
                const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                updatedAgentsMap[agent.id] = {
                    ...existingData,
                    ...agent
                };
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        updateAgent: (id, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const prevData = agentsMap[id] ?? {};
                const updatedData = {
                    ...prevData,
                    ...data
                };
                // Clean up placeholder flag when real agent data arrives
                // Keep placeholderAvatarUrl to avoid avatar flicker (same image, stable source)
                if (prevData.isPlaceholder) delete updatedData.isPlaceholder;
                updatedAgentsMap[id] = updatedData;
                setState({
                    agentsMap: updatedAgentsMap
                });
                return updatedData;
            },
        setCategoryLoading: (category, loading)=>({ setState: setState, getState: getState })=>{
                const { loadingCategories: loadingCategories } = getState();
                const updatedLoadingCategories = new Set(loadingCategories);
                if (loading) updatedLoadingCategories.add(category);
                else updatedLoadingCategories.delete(category);
                setState({
                    loadingCategories: updatedLoadingCategories
                });
            },
        abortCategoryFetch: (category)=>({ getState: getState })=>{
                const { agentCategories: agentCategories } = getState();
                agentCategories[category].abortController.abort();
                agentCategories[category].abortController = new AbortController();
            },
        /**
     * Sets a placeholder agent in the agentsMap with partial data for immediate rendering.
     * The agent is marked with `isPlaceholder: true` so that `useAgentsPaginatedByAgentId`
     * still fetches full details from the network to replace it.
     * Used for optimistic rendering of agent name/avatar from pubsub payloads.
     */ setPlaceholderAgent: (agentId, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                // Only set placeholder if agent doesn't already exist with full data
                if (!agentsMap[agentId]) {
                    const updatedAgentsMap = {
                        ...agentsMap
                    };
                    updatedAgentsMap[agentId] = {
                        ...data,
                        id: agentId,
                        isPlaceholder: true
                    };
                    setState({
                        agentsMap: updatedAgentsMap
                    });
                }
            },
        getCachedAgentByExternalConfigReference: (externalConfigReference)=>({ getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                return Object.values(agentsMap).find((agent)=>agent.external_config_reference === externalConfigReference);
            }
    }
});
const $c0881cdb28f9c5e5$export$1553678862324ff0 = (0, $9zUhf.createActionsHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore);
const $c0881cdb28f9c5e5$export$cea603150faaa56f = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    // TODO https://product-fabric.atlassian.net/browse/RAGE-618
    // change `{ agentId }` to `agentId`
    selector: (state, agentId)=>({
            agent: state.agentsMap[agentId],
            doesAgentExist: Boolean(state.agentsMap[agentId]),
            isPlaceholder: Boolean(state.agentsMap[agentId]?.isPlaceholder)
        })
});
const $c0881cdb28f9c5e5$export$44c2e95a7a8b47c9 = (0, $h26dv.createHookWithAssistanceService)(({ agentId: agentId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$44c2e95a7a8b47c9, $c0881cdb28f9c5e5$export$cea603150faaa56f, $c0881cdb28f9c5e5$export$1553678862324ff0);
    const [{ agent: agent, doesAgentExist: doesAgentExist, isPlaceholder: isPlaceholder }] = $c0881cdb28f9c5e5$export$cea603150faaa56f(agentId ?? '');
    const { updateAgent: updateAgent } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const { error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'agentHydration',
            agentId ?? ''
        ],
        queryFn: async ()=>{
            if (!agentId) // this throw won't happen because the `enabled` field below
            throw new Error('Agent ID is required');
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA,
                id: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA
            });
            const response = await assistanceService.getAgentDetails(agentId);
            return response;
        },
        enabled: Boolean(agentId) && (!doesAgentExist || isPlaceholder),
        onSuccess: (data)=>{
            if (!agentId) return;
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA
            });
            updateAgent(agentId ?? '', data);
        },
        onError: (error)=>{
            if (!agentId) return;
            const is404Error = error.errorAttributes.statusCode === 404;
            const is403Error = error.errorAttributes.statusCode === 403 && (0, $dh538.fg)('convo-ai-enable-agents-use-permission');
            if (!(is404Error || is403Error)) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).HYDRATE_AGENT_DATA,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    if (!agentId) return {
        agent: undefined,
        error: undefined
    };
    return {
        agent: agent,
        error: error ?? undefined
    };
});
const $c0881cdb28f9c5e5$export$eae59c91509947e4 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    const environment = (0, $irOoi.useRelayEnvironment)();
    const removedAgentCache = (0, $42omo.useRef)({
        categories: [],
        agent: undefined
    });
    const { removeAgent: removeAgent, addAgent: addAgent, updateAgent: updateAgent } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $4ul15.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    // Note: Experience Tracker events implemented in useDeleteAgent
    const { deleteAgent: deleteAgent } = (0, $1uFMJ.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceInjectedParams,
        onInit: (id)=>{
            const { categories: categories, agent: agent } = removeAgent(id);
            removedAgentCache.current = {
                categories: categories,
                agent: agent
            };
        },
        onError: ()=>{
            if (removedAgentCache.current.agent) addAgent(removedAgentCache.current.agent, removedAgentCache.current.categories);
        }
    });
    // Note: Experience Tracker events implemented in useAgentFavourites
    const setFavouriteAgent = (0, $42omo.useCallback)(async (id, favourite, agentAri)=>{
        // Optimistic update
        updateAgent(id, {
            favourite: favourite
        });
        const localRelayUpdate = async (isFavourite)=>{
            if (agentAri) (0, $irOoi.commitLocalUpdate)(environment, (store)=>{
                const id = (0, $f2OFx.default)({
                    id: agentAri
                }, 'AgentStudioAssistant');
                if (!id) return;
                const agentRecord = store.get(id);
                if (agentRecord) agentRecord.setValue(isFavourite, 'isFavourite');
                const root = store.getRoot();
                const connection = (0, $irOoi.ConnectionHandler).getConnection(root, 'paginatedAgentsList_agentStudio_getAgents', {
                    cloudId: assistanceServiceInjectedParams.siteId,
                    input: {
                        onlyFavouriteAgents: true
                    },
                    product: assistanceServiceInjectedParams.product
                });
                const agentDataID = agentRecord?.getDataID();
                if (!connection || !agentDataID || !agentRecord) return;
                if (isFavourite) {
                    const edge = (0, $irOoi.ConnectionHandler).createEdge(store, connection, agentRecord, 'AgentStudioAgentEdge');
                    (0, $irOoi.ConnectionHandler).insertEdgeAfter(connection, edge);
                } else (0, $irOoi.ConnectionHandler).deleteNode(connection, agentDataID);
            });
        };
        localRelayUpdate(favourite);
        const errorCallback = {
            onError: ()=>{
                // Reverse optimistic update
                updateAgent(id, {
                    favourite: !favourite
                });
                localRelayUpdate(!favourite);
            }
        };
        if (favourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        assistanceServiceInjectedParams.product,
        assistanceServiceInjectedParams.siteId,
        environment,
        favouriteAgent,
        unfavouriteAgent,
        updateAgent
    ]);
    /**
   * Function that updates the verified status of an agent.
   * This can be removed once the dropdown has converted over to relay.
   */ const setVerifiedAgent = (0, $42omo.useCallback)((id, isVerified)=>{
        updateAgent(id, {
            is_verified: isVerified
        });
    }, [
        updateAgent
    ]);
    // Local cache update function for optimistic delete
    // This only handles cache updates, not API calls or analytics
    const deleteAgentLocally = (0, $42omo.useCallback)((id)=>{
        // Optimistically remove from cache
        const { categories: categories, agent: agent } = removeAgent(id);
        // Return restore function for error handling
        return {
            restore: ()=>{
                if (agent) addAgent(agent, categories);
            }
        };
    }, [
        removeAgent,
        addAgent
    ]);
    return {
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        setVerifiedAgent: setVerifiedAgent,
        deleteAgentLocally: deleteAgentLocally
    };
});
const $c0881cdb28f9c5e5$export$cc3deb815b1c179b = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    selector: (state, category)=>({
            agentsByCategory: state.agentCategories[category].agentIds.map((agentId)=>state.agentsMap[agentId]),
            isCategoryInitialized: state.agentCategories[category].pageInfo.startCursor !== undefined && state.agentCategories[category].pageInfo.endCursor !== undefined,
            isCategoryLoading: state.loadingCategories.has(category),
            isCategoryEmpty: state.agentCategories[category].agentIds.length === 0,
            hasNextPage: state.agentCategories[category].pageInfo.hasNextPage,
            nextPageCursor: state.agentCategories[category].pageInfo.endCursor,
            agentsError: state.agentCategories[category].agentsError
        })
});
const $c0881cdb28f9c5e5$export$e6997ec35c535c54 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $fBMbo.di)((0, $hT0Hx.useAgentOverrider), $c0881cdb28f9c5e5$export$1553678862324ff0);
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $hT0Hx.useAgentOverrider)();
    const { addAgent: addAgent, populateAgentCategories: populateAgentCategories } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const fetchOverriddenAgentsAndPopulateStoreQuery = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? ''
        ],
        queryFn: async ()=>{
            const agentIdsToFetchSet = new Set();
            if (agentDefaultIdOverride) agentIdsToFetchSet.add(agentDefaultIdOverride);
            if (agentIdFiltersOverride?.length) agentIdFiltersOverride.forEach((agentId)=>{
                agentIdsToFetchSet.add(agentId);
            });
            if (agentIdsToFetchSet.size === 0) return;
            const agentIdsToFetch = Array.from(agentIdsToFetchSet);
            populateAgentCategories({
                category: 'all-agents',
                agentsList: [],
                pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO)
            });
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES,
                id: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
            const agents = await Promise.all(agentIdsToFetch.map(async (agentId)=>{
                return await assistanceService.getAgentDetails(agentId);
            }));
            // then add the agents into "All agents" category
            agents.forEach((agent)=>{
                addAgent(agent, [
                    'all-agents'
                ]);
            });
            return agentIdsToFetch;
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_OVERRIDES,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: false
    });
    return {
        fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStoreQuery.refetch
    };
});
const $c0881cdb28f9c5e5$export$94c2040c41639ede = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$1553678862324ff0, (0, $hT0Hx.useAgentOverrider), $c0881cdb28f9c5e5$export$e6997ec35c535c54);
    const { experienceTracker: experienceTracker, siteId: siteId, product: product, headers: assistanceServiceHeaders } = assistanceServiceInjectedParams;
    const actions = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const { setCategoryLoading: setCategoryLoading, setCategoryError: setCategoryError, populateAgentCategories: populateAgentCategories, getAgentCategoriesByCategory: getAgentCategoriesByCategory, setAgentCategoriesByCategory: setAgentCategoriesByCategory } = actions;
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $hT0Hx.useAgentOverrider)();
    const { fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStore } = $c0881cdb28f9c5e5$export$e6997ec35c535c54({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const fetchAgentsByCategory = (0, $42omo.useCallback)(async ({ category: category = 'all-agents', after: after, query: query })=>{
        // if there are any overrides, cancel the normal fetchByCategory and instead fetch the overridden agents
        if (agentDefaultIdOverride || agentIdFiltersOverride?.length) return await fetchOverriddenAgentsAndPopulateStore() ?? [];
        const dataBeforeFetch = getAgentCategoriesByCategory(category);
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED,
            id: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
        });
        let queryInput = {};
        switch(category){
            case 'starred-agents':
                queryInput.onlyFavouriteAgents = true;
                break;
            case 'my-agents':
                queryInput.onlyMyAgents = true;
                break;
            case 'templates':
                queryInput.onlyTemplateAgents = true;
                break;
            case 'verified-agents':
                queryInput.onlyVerifiedAgents = true;
                break;
        }
        if (query) queryInput.name = query;
        // for rolling back data in case of abort/failure
        const resetData = ()=>{
            setAgentCategoriesByCategory({
                categoryName: category,
                agentCategoryData: dataBeforeFetch
            });
            return dataBeforeFetch.agentIds;
        };
        // No after means we're requesting the first page so the category data is reset
        if (!after) populateAgentCategories({
            category: category,
            agentsList: [],
            pageInfo: (0, $ffpG2.DEFAULT_PAGE_INFO)
        });
        setCategoryLoading(category, true);
        setCategoryError(category, undefined);
        const headers = new Headers(assistanceServiceHeaders);
        const maybeWorkspaceId = headers.get('x-workspace-id');
        try {
            const response = await (0, $ffpG2.fetchPaginatedAgents)({
                after: after ?? undefined,
                cloudId: siteId,
                count: 10,
                input: Object.keys(queryInput).length > 0 ? queryInput : undefined,
                product: product,
                abortController: getAgentCategoriesByCategory(category).abortController,
                workspaceId: maybeWorkspaceId
            });
            setCategoryLoading(category, false);
            if (getAgentCategoriesByCategory(category).abortController.signal?.aborted) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return resetData();
            }
            if (response) {
                populateAgentCategories({
                    category: category,
                    agentsList: response.agents,
                    pageInfo: response.pageInfo
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED
                });
            }
            return response?.agents.map((agent)=>agent.id);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENTS_PAGINATED,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            const prevAgentIds = resetData();
            setCategoryError(category, error);
            setCategoryLoading(category, false);
            if (error instanceof (0, $flpNp.ApiError)) onError?.(error);
            return prevAgentIds;
        }
    }, [
        agentDefaultIdOverride,
        agentIdFiltersOverride?.length,
        getAgentCategoriesByCategory,
        experienceTracker,
        setCategoryLoading,
        setCategoryError,
        assistanceServiceHeaders,
        fetchOverriddenAgentsAndPopulateStore,
        setAgentCategoriesByCategory,
        populateAgentCategories,
        siteId,
        product,
        onError
    ]);
    return {
        ...actions,
        fetchAgentsByCategory: fetchAgentsByCategory
    };
});
const $c0881cdb28f9c5e5$export$65c6565d33cf8f4f = (0, $9zUhf.createHook)($c0881cdb28f9c5e5$var$agentsPaginatedStore, {
    selector: (state)=>state.agentsMap
});
const $c0881cdb28f9c5e5$export$631401679afcb10f = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, limit: limit = 3, pageUrl: pageUrl })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$65c6565d33cf8f4f);
    const { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } = assistanceServiceInjectedParams;
    const [agentsMap, { updateAgent: updateAgent }] = $c0881cdb28f9c5e5$export$65c6565d33cf8f4f();
    const { isFetching: isFetching, data: data } = (0, $9eLw5.useQuery)({
        queryKey: [
            'recommendedAgents',
            limit,
            pageUrl ?? ''
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS,
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
            });
            const response = await assistanceService.getRecommendedAgents({
                limit: limit,
                pageUrl: pageUrl
            });
            // store the agents in the paginated store for optimistic updates etc
            // not adding them to specific category in local cache on purpose
            response.agents.forEach((agent)=>{
                updateAgent(agent.id, agent);
            });
            return response;
        },
        enabled: Boolean(siteId),
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
            });
        },
        onError: (error)=>{
            if ((0, $cqFPV.isHipaaError)(error)) {
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).GET_RECOMMENDED_AGENTS,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    return {
        isFetching: isFetching,
        recommendedAgents: data?.agents.map((agent)=>agentsMap[agent.id]).filter(Boolean) ?? [],
        recommendationKey: data?.metadata?.recommendationKey
    };
});
const $c0881cdb28f9c5e5$export$71d3696dcc60eb2d = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $fBMbo.di)($c0881cdb28f9c5e5$export$1553678862324ff0, (0, $ffpG2.fetchAgentByExternalConfigReference));
    const { updateAgent: updateAgent, getCachedAgentByExternalConfigReference: getCachedAgentByExternalConfigReference } = $c0881cdb28f9c5e5$export$1553678862324ff0();
    const getAndStoreAgentByExternalConfigReference = (0, $42omo.useCallback)(async ({ externalConfigReference: externalConfigReference })=>{
        const cachedAgent = getCachedAgentByExternalConfigReference(externalConfigReference);
        if (cachedAgent) return cachedAgent;
        try {
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            const agentData = await (0, $ffpG2.fetchAgentByExternalConfigReference)({
                cloudId: siteId,
                externalConfigReference: externalConfigReference
            });
            // cache the data
            updateAgent(agentData.id, agentData);
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            return agentData;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            return undefined;
        }
    }, [
        getCachedAgentByExternalConfigReference,
        experienceTracker,
        siteId,
        updateAgent
    ]);
    return {
        getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference
    };
});
const $c0881cdb28f9c5e5$export$eee66751ca85dbf7 = (param)=>{
    return $c0881cdb28f9c5e5$export$f5b1109ecd7858c1(param);
};
const $c0881cdb28f9c5e5$export$6553fa633373a34 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { product: product, experienceId: experienceId, headers: headers, touchpointSource: touchpointSource, siteId: siteId }, filter: filter })=>{
    const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $c0881cdb28f9c5e5$export$eee66751ca85dbf7({
        assistanceServiceParams: {
            product: product,
            experienceId: experienceId,
            headers: headers,
            touchpointSource: touchpointSource,
            siteId: siteId
        }
    });
    const defaultAgents = (0, $iswAx.getSuggestedOotbAgents)({
        availableAgents: availableAgents,
        product: product
    });
    const defaultAgentsOutsideUserFavourites = defaultAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.id === defaultAgent.id));
    const favouritedAgentsWithDefault = [
        ...favouritedAgents,
        ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
    ];
    return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
});
module.exports["useAgentsPaginatedStoreActions"] = $c0881cdb28f9c5e5$export$1553678862324ff0;
module.exports["useAgentsPaginatedByAgentId"] = $c0881cdb28f9c5e5$export$44c2e95a7a8b47c9;
module.exports["useAgentsPaginatedActionsWithOptimistic"] = $c0881cdb28f9c5e5$export$eae59c91509947e4;
module.exports["usePaginatedAgentsByCategory"] = $c0881cdb28f9c5e5$export$cc3deb815b1c179b;
module.exports["usePaginatedAgentsActions"] = $c0881cdb28f9c5e5$export$94c2040c41639ede;
module.exports["useRecommendedAgents"] = $c0881cdb28f9c5e5$export$631401679afcb10f;
module.exports["usePaginatedAgentByConfigReference"] = $c0881cdb28f9c5e5$export$71d3696dcc60eb2d;
module.exports["useAgentsList"] = $c0881cdb28f9c5e5$export$6553fa633373a34;

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("ljUdP", function(module, exports) {

var $5MO1q = parcelRequire("5MO1q");


var $flpNp = parcelRequire("flpNp");

const $35329f6c3dcf5d43$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $35329f6c3dcf5d43$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $35329f6c3dcf5d43$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
var $35329f6c3dcf5d43$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $35329f6c3dcf5d43$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $35329f6c3dcf5d43$export$77c9504201bdfdea = 'PROMPT_TILE';
const $35329f6c3dcf5d43$export$fb661125ffb29bd6 = (message)=>{
    return $35329f6c3dcf5d43$export$a69fab2afb88c2eb(message) || $35329f6c3dcf5d43$export$6f965deda7f0960c(message) || $35329f6c3dcf5d43$export$b4631726cbc1440a(message);
};
const $35329f6c3dcf5d43$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $35329f6c3dcf5d43$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $35329f6c3dcf5d43$export$a6e5100ca2770191 = (message)=>message instanceof Object && $35329f6c3dcf5d43$export$6f965deda7f0960c(message.message);
const $35329f6c3dcf5d43$export$5c1c15675df13ae5 = (message)=>$35329f6c3dcf5d43$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $35329f6c3dcf5d43$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $35329f6c3dcf5d43$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $35329f6c3dcf5d43$export$1e1cf807ece63df4 = (message)=>$35329f6c3dcf5d43$export$d422a2733a3b5def(message) && message.message?.message_template === $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
const $35329f6c3dcf5d43$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $35329f6c3dcf5d43$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $35329f6c3dcf5d43$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $35329f6c3dcf5d43$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $35329f6c3dcf5d43$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $35329f6c3dcf5d43$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $35329f6c3dcf5d43$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $35329f6c3dcf5d43$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $35329f6c3dcf5d43$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $35329f6c3dcf5d43$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $35329f6c3dcf5d43$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $35329f6c3dcf5d43$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $35329f6c3dcf5d43$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $35329f6c3dcf5d43$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $35329f6c3dcf5d43$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $35329f6c3dcf5d43$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $35329f6c3dcf5d43$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $35329f6c3dcf5d43$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $35329f6c3dcf5d43$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $35329f6c3dcf5d43$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $35329f6c3dcf5d43$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $35329f6c3dcf5d43$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $35329f6c3dcf5d43$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $35329f6c3dcf5d43$export$b00dd9d0560e29d2 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $35329f6c3dcf5d43$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $35329f6c3dcf5d43$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $35329f6c3dcf5d43$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($35329f6c3dcf5d43$export$7898cc38956b9052(message) || $35329f6c3dcf5d43$export$bb608d13a1268633(message));
const $35329f6c3dcf5d43$export$d95e474df0d530df = (message)=>message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'MEMORY_UPDATE';
const $35329f6c3dcf5d43$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($35329f6c3dcf5d43$export$46e0fb5e4b019a49(message)) return false;
    if ($35329f6c3dcf5d43$export$cde91b49af35d559(message)) return false;
    if ($35329f6c3dcf5d43$export$6f74311d40862a9f(message)) return false;
    if ($35329f6c3dcf5d43$export$b65c73c7e2d8d96f(message)) return false;
    if ($35329f6c3dcf5d43$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $35329f6c3dcf5d43$export$682514f3a8131b98 = (message)=>{
    return message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'THINK_DEEPER_TRIGGERED';
};
const $35329f6c3dcf5d43$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $35329f6c3dcf5d43$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $35329f6c3dcf5d43$export$b8391261162989d9 = (message)=>$35329f6c3dcf5d43$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $35329f6c3dcf5d43$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $35329f6c3dcf5d43$export$6ce1ccc24e75456f = (error)=>(0, $flpNp.isApiError)(error) && error.errorAttributes?.errorCode === $35329f6c3dcf5d43$export$5945515082cc2cbf;
const $35329f6c3dcf5d43$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $35329f6c3dcf5d43$export$bc96a6a479480590 = (error)=>(0, $flpNp.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $35329f6c3dcf5d43$export$f8b1b75846492611 = (error)=>(0, $flpNp.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $35329f6c3dcf5d43$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
const $35329f6c3dcf5d43$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
function $35329f6c3dcf5d43$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["isSSEMessage"] = $35329f6c3dcf5d43$export$f78edfe5a93b58af;
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $35329f6c3dcf5d43$export$c424fe9570a5f2d9;
module.exports["SUGGESTED_PROMPT_TILE_STREAM_MESSAGE_TYPE"] = $35329f6c3dcf5d43$export$77c9504201bdfdea;
module.exports["isHumanMessage"] = $35329f6c3dcf5d43$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $35329f6c3dcf5d43$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $35329f6c3dcf5d43$export$b4631726cbc1440a;
module.exports["isAgentResponse"] = $35329f6c3dcf5d43$export$a6e5100ca2770191;
module.exports["isInProgressStreamResponse"] = $35329f6c3dcf5d43$export$5c1c15675df13ae5;
module.exports["isStreamError"] = $35329f6c3dcf5d43$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $35329f6c3dcf5d43$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $35329f6c3dcf5d43$export$e45102edbc73b240;
module.exports["isStreamReasoningPart"] = $35329f6c3dcf5d43$export$51a109436d382715;
module.exports["isStreamActionPart"] = $35329f6c3dcf5d43$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $35329f6c3dcf5d43$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $35329f6c3dcf5d43$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $35329f6c3dcf5d43$export$7d94ce53d589f586;
module.exports["isStreamResearchStart"] = $35329f6c3dcf5d43$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $35329f6c3dcf5d43$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $35329f6c3dcf5d43$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $35329f6c3dcf5d43$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $35329f6c3dcf5d43$export$cde91b49af35d559;
module.exports["isStreamTodoSnapshot"] = $35329f6c3dcf5d43$export$4a6a601f69cf3c74;
module.exports["isStreamResearchStepTitleShort"] = $35329f6c3dcf5d43$export$ac74da022f74040a;
module.exports["isStreamSkillStart"] = $35329f6c3dcf5d43$export$7898cc38956b9052;
module.exports["isStreamSkillEnd"] = $35329f6c3dcf5d43$export$bb608d13a1268633;
module.exports["isStreamFastModeResponseAvailable"] = $35329f6c3dcf5d43$export$b65c73c7e2d8d96f;
module.exports["isStreamFastModeEnabled"] = $35329f6c3dcf5d43$export$40cf419186312161;
module.exports["isStreamRemoveAnswerNow"] = $35329f6c3dcf5d43$export$a83708fc4401682d;
module.exports["isStreamResearchStepSource"] = $35329f6c3dcf5d43$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $35329f6c3dcf5d43$export$cfccfd17b68ccb0;
module.exports["isStreamResearchStepIcons"] = $35329f6c3dcf5d43$export$1fd230d6956c2575;
module.exports["isStreamResearchStepDocument"] = $35329f6c3dcf5d43$export$3bc697eeff31bdf6;
module.exports["isStreamReconnectSupportPart"] = $35329f6c3dcf5d43$export$c679ee34f7312895;
module.exports["isStreamAnswerGenerationType"] = $35329f6c3dcf5d43$export$b00dd9d0560e29d2;
module.exports["isStreamDynamicLayoutSubAgent"] = $35329f6c3dcf5d43$export$5fa02529cd2ab34c;
module.exports["isStreamResearchPayload"] = $35329f6c3dcf5d43$export$46e0fb5e4b019a49;
module.exports["isStreamSkill"] = $35329f6c3dcf5d43$export$6f74311d40862a9f;
module.exports["isStreamMemoryUpdate"] = $35329f6c3dcf5d43$export$d95e474df0d530df;
module.exports["isStreamTrace"] = $35329f6c3dcf5d43$export$fd5a05be03f147a0;
module.exports["isStreamThinkDeeperTriggered"] = $35329f6c3dcf5d43$export$682514f3a8131b98;
module.exports["isFollowUpMessage"] = $35329f6c3dcf5d43$export$aeae5b4fda357302;
module.exports["isStreamHeartbeat"] = $35329f6c3dcf5d43$export$b46beea5c82aa1b9;
module.exports["isActionExecutedSuccessfully"] = $35329f6c3dcf5d43$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $35329f6c3dcf5d43$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $35329f6c3dcf5d43$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $35329f6c3dcf5d43$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $35329f6c3dcf5d43$export$bc96a6a479480590;
module.exports["isHipaaError"] = $35329f6c3dcf5d43$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $35329f6c3dcf5d43$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $35329f6c3dcf5d43$export$b454081350f4a578;
module.exports["isConfirmAction"] = $35329f6c3dcf5d43$export$4af48296a8d61cec;

});

parcelRegister("5MO1q", function(module, exports) {
const $bc280b458a56ce28$export$e8114853eca81277 = 'ai-mate';
const $bc280b458a56ce28$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $bc280b458a56ce28$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $bc280b458a56ce28$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $bc280b458a56ce28$export$333e4f57333eadfa;

});

parcelRegister("flpNp", function(module, exports) {
class $1d075fa469bb0891$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $1d075fa469bb0891$export$89d83cc97c52a37 = (error)=>error instanceof $1d075fa469bb0891$export$f2e832acab1bdd79;
const $1d075fa469bb0891$export$3c02d1a328d4d808 = (error)=>{
    if ($1d075fa469bb0891$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $1d075fa469bb0891$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $1d075fa469bb0891$export$f2e832acab1bdd79;
module.exports["isApiError"] = $1d075fa469bb0891$export$89d83cc97c52a37;
module.exports["mapErrorToApiError"] = $1d075fa469bb0891$export$3c02d1a328d4d808;

});

parcelRegister("9eLw5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $flpNp = parcelRequire("flpNp");

const $2c362c1c58e43242$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $2c362c1c58e43242$var$selector = (0, $cclHy.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $2c362c1c58e43242$var$useCacheEntry = (0, $9zUhf.createHook)($2c362c1c58e43242$var$store, {
    selector: $2c362c1c58e43242$var$selector
});
const $2c362c1c58e43242$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $42omo.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $2c362c1c58e43242$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $42omo.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $fFa3V.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["useQuery"] = $2c362c1c58e43242$export$dd0a697e1782aedd;

});

parcelRegister("h26dv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $4u5NT = parcelRequire("4u5NT");


var $hUyPY = parcelRequire("hUyPY");


var $ljUdP = parcelRequire("ljUdP");


var $8Igpw = parcelRequire("8Igpw");


var $33mIS = parcelRequire("33mIS");


var $4Z0i5 = parcelRequire("4Z0i5");


var $e4Fay = parcelRequire("e4Fay");


var $4E0A1 = parcelRequire("4E0A1");


var $99vXA = parcelRequire("99vXA");


var $aclUh = parcelRequire("aclUh");

const $7b2e91008351c623$var$PRODUCT_HEADER = 'x-product';
const $7b2e91008351c623$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $7b2e91008351c623$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
class $7b2e91008351c623$export$40a7802808e2fbe3 {
    createHeaders(init) {
        return new Headers({
            [$7b2e91008351c623$var$PRODUCT_HEADER]: this.config.product,
            [$7b2e91008351c623$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.headers || {},
            ...init || {}
        });
    }
    async fetch({ path: path, options: options, holdName: holdName }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = configBaseUrl;
        const requestUrl = (0, $4E0A1.addPath)(baseUrl, path);
        const startTime = performance.now();
        const response = await window.fetch(requestUrl, {
            credentials: configCredentials,
            ...options
        });
        if (this.config.labelStack) {
            // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
            // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
            // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
            const endTime = performance.now();
            (0, $4u5NT.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
        }
        return (0, $4E0A1.processResponse)({
            response: response
        });
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async fetchStream(options, config) {
        const response = await this.fetch(options);
        const contentType = response.headers.get('content-type') ?? '';
        const headerSuggestsSSE = config?.useSSE && contentType.includes('text/event-stream');
        return {
            responseData: {
                traceId: (0, $8Igpw.getTraceIdFromResponse)(response)
            },
            generator: headerSuggestsSSE ? (0, $e4Fay.readSSEStream)(response) : (0, $4Z0i5.readJsonStream)(response)
        };
    }
    constructor(props){
        this.config = void 0;
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
}
const $7b2e91008351c623$var$getHref = (product)=>{
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window?.location?.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
class $7b2e91008351c623$export$a522c5f4ccda1c94 extends $7b2e91008351c623$export$40a7802808e2fbe3 {
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, appFilters: appFilters, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, browserContextSanitizer: browserContextSanitizer, optInSSEStream: optInSSEStream = false, agentVersion: agentVersion }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$7b2e91008351c623$var$CHANNEL_ID_HEADER]: 'rovo-chat',
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        // Check if the URL is blocklisted
        const browserUrl = browserContext?.context?.browserUrl;
        const isBlocklisted = browserUrl && browserContextSanitizer ? browserContextSanitizer.isBlocklisted(browserUrl) : false;
        // Determine the URL to send to the backend
        // If blocklisted, send empty URL to ensure the site is not sent to the backend
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        let url;
        if (isBlocklisted || browserContext?.context?.browserUrl === 'NO-URL' && (0, $c6GJD.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) url = '';
        else if (browserContext?.context?.browserUrl) url = browserContext.context.browserUrl;
        else url = $7b2e91008351c623$var$getHref(this.getConfig().product) ?? '';
        const body = {
            content: message,
            context: {
                // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
                // instead it depends on prompt intent to use it,
                // with useCurrentBrowsingContext we can ensure it is always used
                browser_url: url,
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
                ...browserContext && !isBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext,
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                ...knowledgeOverride
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            // don't allow store message if feature flag is off
            store_message: (0, $dh538.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {})
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async reconnectToMessageStream({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, controller: controller }) {
        const headers = this.createHeaders();
        // Add Last-Event-ID header if available
        if (lastEventId) headers.set('Last-Event-ID', lastEventId);
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/stream/sse`,
            options: options
        }, {
            useSSE: true
        });
    }
    // Only takes effect if the stream is a Deep Research stream
    async cancelMessageStream({ conversationId: conversationId, messageId: messageId }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/cancel`,
            options: options
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools, optInSSEStream: optInSSEStream = false, storeMessage: storeMessage = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, aiFeatureContext: aiFeatureContext, agentVersion: agentVersion, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            }
        });
        const url = window?.location?.href;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            confirmed_tools: confirmed_tools,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            context: {
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                ...deepResearchEnabled ? {
                    deepResearchEnabled: deepResearchEnabled
                } : {},
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...aiFeatureContext ? {
                    aiFeatureContext: aiFeatureContext
                } : {}
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            // don't allow store message if feature flag is off
            store_message: (0, $dh538.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const rawChat = await this.fetchJson({
            path: `/rovo/v1/chat/conversation/${conversationId}/messages`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]-messages'
        });
        const chatArray = rawChat.items;
        return chatArray.map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (message)=>// Must be converted into StreamResponse
            (0, $ljUdP.isHumanMessage)(message) ? message : (0, $aclUh.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options,
            holdName: 'rovo-v1-agents-accountid-[identityAccountId]'
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async createConversationChannel(options) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    name: options?.name ?? (0, $99vXA.generateConversationName)(),
                    dialogues: options?.dialogues ?? undefined,
                    tags: options?.tags
                })
            },
            holdName: 'rovo-v1-chat-conversation'
        });
    }
    async getConversationChannels() {
        // Clean up `ConversationChannel[] | { items: ConversationChannel[] }` when fg('rovo_convo_ai_migration') is removed
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'rovo-v1-chat-conversations'
        });
        // Transform snake_case fields to camelCase
        return result.items.map((item)=>this.transformSnakeCaseToCamelCase(item));
    }
    updateConversationChannel(id, payload) {
        // Transform camelCase field names to snake_case for the REST API
        const apiPayload = this.transformCamelCaseToSnakeCase(payload);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(apiPayload)
            },
            holdName: 'rovo-v1-chat-conversation-[id]'
        }).then((response)=>this.transformSnakeCaseToCamelCase(response));
    }
    transformCamelCaseToSnakeCase(payload) {
        const result = {};
        for (const [key, value] of Object.entries(payload))if (key === 'readStatus') result['read_status'] = value;
        else result[key] = value;
        return result;
    }
    transformSnakeCaseToCamelCase(item) {
        if (!item) return item;
        const result = {
            ...item
        };
        if ('read_status' in item) {
            result.readStatus = item.read_status;
            delete result.read_status;
        }
        return result;
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            holdName: 'rovo-v1-chat-conversation-[id]-action'
        });
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options,
            holdName: 'rovo-v1-conversation-starters-agent-starter-suggestion'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options,
            holdName: 'rovo-v1-conversation-starters-page-contextual'
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options,
            holdName: 'api-ai-v2-ai-feature-convo-starters'
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options,
            holdName: 'api-v2-configuration-web-search-ai'
        });
        return result;
    }
    async getPrompts() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
        return result;
    }
    async getPrompt(promptId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-[promptId]'
        });
    }
    async bulkGetPrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-get',
            options: options,
            holdName: 'api-v2-prompts-bulk-get'
        });
    }
    async createPrompt(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
    }
    async updatePrompt(promptId, payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-update'
        });
    }
    async addPromptsToLibrary(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: '/api/v2/prompts/add-to-library',
            options: options,
            holdName: 'api-v2-prompts-add-to-library'
        });
    }
    async deletePrompt(shareId) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers
        };
        await this.fetch({
            path: `/api/v2/prompts/${shareId}`,
            options: options,
            holdName: 'api-v2-prompts-delete'
        });
    }
    async favoritePrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: `/api/v2/prompts/favorite`,
            options: options,
            holdName: 'api-v2-prompts-favorite'
        });
    }
    async bulkUpdatePrivacy(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-update-privacy',
            options: options,
            holdName: 'api-v2-prompts-bulk-update-privacy'
        });
    }
    constructor(props){
        super(props);
        this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-actions'
            });
            return response.actions;
        };
        this.getAgentKnowledgeConfiguration = (agentCreatorType)=>{
            const queryParams = agentCreatorType && (0, $dh538.fg)('rovo_agent_knowledge_source_allow_list') ? `?agentCreatorType=${agentCreatorType}` : '';
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge${queryParams}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-knowledge'
            });
        };
        this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v2-permissions-agents-[agentId]'
            });
        };
        this.getRecommendedAgents = ({ limit: limit, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString()
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-recommend-v2'
            });
        };
        this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]-debug-logs'
            });
            return response.items;
        };
        this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: `/rovo/v1/chat/message/file/validate`,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-message-file-validate'
            });
        };
        this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/message/file`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                },
                holdName: 'rovo-v1-chat-message-file'
            });
            return response;
        };
        this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-agent-playground-chat-stream'
            });
        };
        this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-chat-conversations'
            });
        };
        this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-tools'
            });
        };
        this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-language-models'
            });
        };
        this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-prompts'
            });
        };
        this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-generated-content'
            });
        };
        this.getInsightsStatus = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/insights/status',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json;charset=UTF-8',
                        [$7b2e91008351c623$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                        [$7b2e91008351c623$var$PRODUCT_HEADER]: 'rovo',
                        [$7b2e91008351c623$var$EXPERIENCE_ID_HEADER]: 'ai-mate'
                    }),
                    body: JSON.stringify({})
                },
                holdName: 'rovo-v1-insights-status'
            });
        };
        this.getInsightsFeed = async ()=>{
            const overrides = {};
            if (typeof localStorage !== 'undefined') {
                const promptVariation = localStorage.getItem('DEBUG_rovo_insights_prompt_variation');
                if (promptVariation) overrides.prompt_variation = promptVariation;
                const generate = localStorage.getItem('DEBUG_rovo_insights_generate');
                if (generate) overrides.generate = generate === 'true';
            }
            return this.fetchJson({
                path: '/rovo/v1/insights/fetch',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json;charset=UTF-8',
                        [$7b2e91008351c623$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                        [$7b2e91008351c623$var$PRODUCT_HEADER]: 'rovo',
                        [$7b2e91008351c623$var$EXPERIENCE_ID_HEADER]: 'ai-mate'
                    }),
                    body: JSON.stringify(overrides)
                },
                holdName: 'rovo-v1-insights-fetch'
            });
        };
        this.getRovoUserSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.updateRovoUserSettings = async (settings)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(settings)
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.getRovoMemories = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories'
            });
        };
        this.answerNow = async (conversationId, messageId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/answer-now`,
                options: options,
                holdName: 'rovo-v1-chat-conversation-message-answer-now'
            });
        };
        this.deleteRovoMemory = async (memoryId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/${memoryId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-[memoryId]'
            });
        };
        this.fetchConversationMetadata = async (conversationId)=>{
            const result = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]'
            });
            return this.transformSnakeCaseToCamelCase(result);
        };
        this.fetchPersonalizedPromptSuggestions = async (config)=>{
            const { offset: offset = 0, limit: limit = 9 } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit
                    }
                })
            };
            const result = await this.fetchJson({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles'
            });
            return result?.ai_feature_output?.prompt_tiles ?? [];
        };
        this.getTasks = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/tasks',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-tasks'
            });
        };
        this.fetchPersonalizedPromptSuggestionsStream = async (config)=>{
            const { offset: offset = 0, limit: limit = 9 } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit
                    }
                })
            };
            return this.fetchStream({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles/stream',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles-stream'
            });
        };
    }
}
const $7b2e91008351c623$var$AssistanceServiceContext = /*#__PURE__*/ (0, $42omo.createContext)(new $7b2e91008351c623$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $7b2e91008351c623$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)($7b2e91008351c623$var$AssistanceServiceContext.Provider, {
        value: value,
        children: children
    });
const $7b2e91008351c623$export$7e31a1844ebbaf85 = (props)=>{
    (0, $fBMbo.di)((0, $42omo.useContext), $7b2e91008351c623$export$a522c5f4ccda1c94);
    const service = (0, $42omo.useContext)($7b2e91008351c623$var$AssistanceServiceContext);
    (0, $33mIS.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    return new $7b2e91008351c623$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers
    });
};
const $7b2e91008351c623$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $fBMbo.di)($7b2e91008351c623$export$a522c5f4ccda1c94, (0, $hUyPY.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $42omo.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $42omo.useMemo)(()=>{
            return new $7b2e91008351c623$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            headers,
            assistanceServiceParams.minionAlias
        ]);
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};
module.exports["AssistanceServiceImpl"] = $7b2e91008351c623$export$a522c5f4ccda1c94;
module.exports["AssistanceServiceProvider"] = $7b2e91008351c623$export$8fe647eb935c33db;
module.exports["useAssistanceService"] = $7b2e91008351c623$export$7e31a1844ebbaf85;
module.exports["createHookWithAssistanceService"] = $7b2e91008351c623$export$5a9ea20fc196ec62;

});

parcelRegister("33mIS", function(module, exports) {
// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
const $8485b8d4788fac0e$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};
module.exports["setRovoChatProduct"] = $8485b8d4788fac0e$export$caa27b16709bc2df;

});

parcelRegister("4Z0i5", function(module, exports) {

var $wzD3I = parcelRequire("wzD3I");

async function* $daf6340d0b79c55b$export$1f24b2b263bcfa75(response) {
    const reader = (0, $wzD3I.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                yield JSON.parse(chunk);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readJsonStream"] = $daf6340d0b79c55b$export$1f24b2b263bcfa75;

});

parcelRegister("wzD3I", function(module, exports) {
const $e391ccd494b2887b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
module.exports["getBufferReader"] = $e391ccd494b2887b$export$f6383c3ea1307da9;

});

parcelRegister("e4Fay", function(module, exports) {

var $wzD3I = parcelRequire("wzD3I");

const $647a1bfa8247ed45$var$parseSSEMessage = (message)=>{
    const parsed = {};
    const dataLines = [];
    for (const line of message.split('\n')){
        const trimmedLine = line.trim();
        const colonIndex = trimmedLine.indexOf(':');
        if (trimmedLine && colonIndex !== -1) {
            const field = trimmedLine.substring(0, colonIndex);
            const value = trimmedLine.substring(colonIndex + 1).trimStart();
            switch(field){
                case 'event':
                    parsed.eventType = value;
                    break;
                case 'data':
                    dataLines.push(value);
                    break;
                case 'id':
                    parsed.id = value;
                    break;
                default:
                    break;
            }
        }
    }
    if (dataLines.length) parsed.data = dataLines.join('\n');
    return parsed;
};
async function* $647a1bfa8247ed45$export$6dab2f647580dc69(response) {
    const reader = (0, $wzD3I.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const combined = `${remainder}${value}`;
            const parts = combined.split('\n\n'); // SSE messages are separated by double newlines
            // the last part may be incomplete — keep it for the next read
            remainder = parts.pop() ?? '';
            for (const chunk of parts)try {
                const parsed = $647a1bfa8247ed45$var$parseSSEMessage(chunk);
                if (parsed.data) {
                    const parsedData = JSON.parse(parsed.data);
                    yield {
                        __isSSEWrapper: true,
                        data: parsedData,
                        id: parsed.id,
                        eventType: parsed.eventType
                    };
                }
            } catch  {
            // ignore malformed JSON; keep streaming future valid messages
            }
        }
        // If the stream just ended and we still have a remainder, try to parse it once.
        if (doneStreaming && remainder) try {
            const parsed = $647a1bfa8247ed45$var$parseSSEMessage(remainder);
            if (parsed.data) {
                const parsedData = JSON.parse(parsed.data);
                yield {
                    __isSSEWrapper: true,
                    data: parsedData,
                    id: parsed.id,
                    eventType: parsed.eventType
                };
            }
        } catch  {
        // ignore malformed tail
        } finally{
            remainder = '';
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readSSEStream"] = $647a1bfa8247ed45$export$6dab2f647580dc69;

});

parcelRegister("4E0A1", function(module, exports) {

var $flpNp = parcelRequire("flpNp");


var $8Igpw = parcelRequire("8Igpw");

const $839038eaaf7c5a3d$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $839038eaaf7c5a3d$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $839038eaaf7c5a3d$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $839038eaaf7c5a3d$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    throw new (0, $flpNp.ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $8Igpw.getTraceIdFromResponse)(response)
    });
};
const $839038eaaf7c5a3d$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $839038eaaf7c5a3d$var$processErrorResponse({
        response: response
    });
    return response;
};
module.exports["addPath"] = $839038eaaf7c5a3d$export$4c25481b843feb0b;
module.exports["processResponse"] = $839038eaaf7c5a3d$export$21fcb6cfd5628534;

});

parcelRegister("99vXA", function(module, exports) {
const $54861eb441be5d90$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $54861eb441be5d90$export$11cc4786742ed7c2;

});

parcelRegister("aclUh", function(module, exports) {

var $ljUdP = parcelRequire("ljUdP");

const $68019d45b4210062$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $68019d45b4210062$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $68019d45b4210062$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $68019d45b4210062$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $68019d45b4210062$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $68019d45b4210062$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (cur == null || typeof cur !== 'object') return undefined;
        cur = cur[key];
    }
    return cur;
};
const $68019d45b4210062$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = obj && typeof obj === 'object' ? obj : {};
    return {
        ...base,
        [head]: $68019d45b4210062$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $68019d45b4210062$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $68019d45b4210062$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $68019d45b4210062$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $68019d45b4210062$var$toPathArr(p);
            const prevVal = $68019d45b4210062$var$getAtPath(prevData, pathArr);
            const nextVal = $68019d45b4210062$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            base = $68019d45b4210062$var$setAtPath(base, pathArr, accumulated);
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $68019d45b4210062$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key } = actionPart.message;
    const existingActionIndex = actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $68019d45b4210062$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $68019d45b4210062$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $68019d45b4210062$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $68019d45b4210062$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $68019d45b4210062$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $68019d45b4210062$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $68019d45b4210062$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $68019d45b4210062$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $68019d45b4210062$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $68019d45b4210062$var$removeSensitiveDataAgentResponse(message.message)
    });
const $68019d45b4210062$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads
    };
};
const $68019d45b4210062$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $ljUdP.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $68019d45b4210062$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $68019d45b4210062$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $68019d45b4210062$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $68019d45b4210062$export$efd4f6b5d168b654;
module.exports["createHumanMessage"] = $68019d45b4210062$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $68019d45b4210062$export$3220a4ff7b3a96df;

});

parcelRegister("2Cfy4", function(module, exports) {
const $0009c874b00d4f72$export$73b400613798970e = 'rovo-agents-fe';
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $0009c874b00d4f72$export$73b400613798970e;

});

parcelRegister("ffpG2", function(module, exports) {

var $fBMbo = parcelRequire("fBMbo");


var $8CAML = parcelRequire("8CAML");


var $9eSnh = parcelRequire("9eSnh");

const $824f750b126db2e8$export$cf57de7718965ae3 = {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: undefined,
    endCursor: undefined
};
const $824f750b126db2e8$var$transformAgentListToGqlResponse = (response)=>{
    try {
        // data can be null if the `abortController` is aborted
        const { edges: edges, pageInfo: pageInfo } = response?.data?.agentStudio_getAgents ?? {
            pageInfo: $824f750b126db2e8$export$cf57de7718965ae3
        };
        const agents = edges?.map((edge)=>(0, $9eSnh.transformAgentGqlResponse)(edge.node)).filter((agent)=>!!agent.id) ?? [];
        return {
            agents: agents,
            pageInfo: pageInfo
        };
    } catch  {
        return {
            agents: [],
            pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: undefined,
                endCursor: undefined
            }
        };
    }
};
const $824f750b126db2e8$var$agentStudioAssistantFragment = `
fragment conversationAssistantAgent_agentStudioAssistant on AgentStudioAssistant {
  id
  name
  description
  conversationStarters
  isFavourite
  creatorType
  identityAccountId
  externalConfigReference
  creator {
    id
  }
  icon
  authoringTeam {
    id
    profileUrl
    displayName
		smallAvatarImageUrl
  }
  isVerified
}
`;
const $824f750b126db2e8$export$44f796a68d9bc9f1 = async ({ cloudId: cloudId, count: count = 10, after: after, product: product, input: input, abortController: abortController, workspaceId: workspaceId })=>{
    (0, $fBMbo.di)((0, $8CAML.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput, $after: String, $product: String, $workspaceId: String) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
			after: $after
			product: $product
			workspaceId: $workspaceId
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...conversationAssistantAgent_agentStudioAssistant
				}
			}
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
		}
	}

	${$824f750b126db2e8$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        first: count,
        after: after,
        product: product,
        input: input,
        workspaceId: workspaceId
    };
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables,
        abortController: abortController
    });
    return $824f750b126db2e8$var$transformAgentListToGqlResponse(response);
};
const $824f750b126db2e8$export$fce04ce5e2fe57d3 = async ({ cloudId: cloudId, externalConfigReference: externalConfigReference })=>{
    (0, $fBMbo.di)((0, $8CAML.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgentByExternalConfigReference($cloudId: String!, $externalConfigReference: String!) {
		agentStudio_getByExternalReference(cloudId: $cloudId, externalReference: $externalConfigReference) @optIn(to: "AgentStudio") {
			...conversationAssistantAgent_agentStudioAssistant
		}
	}

	${$824f750b126db2e8$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        externalConfigReference: externalConfigReference
    };
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables
    });
    return (0, $9eSnh.transformAgentGqlResponse)(response.data.agentStudio_getByExternalReference);
};
module.exports["DEFAULT_PAGE_INFO"] = $824f750b126db2e8$export$cf57de7718965ae3;
module.exports["fetchPaginatedAgents"] = $824f750b126db2e8$export$44f796a68d9bc9f1;
module.exports["fetchAgentByExternalConfigReference"] = $824f750b126db2e8$export$fce04ce5e2fe57d3;

});

parcelRegister("8CAML", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $ece6631c27d5e331$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $ece6631c27d5e331$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $ece6631c27d5e331$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $ece6631c27d5e331$export$ba203f24e0131ba7) throw err;
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') return {
            data: null,
            errors: undefined
        };
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $8Igpw.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $ece6631c27d5e331$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $ece6631c27d5e331$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $ece6631c27d5e331$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $ece6631c27d5e331$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $ece6631c27d5e331$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $ece6631c27d5e331$export$ba203f24e0131ba7;

});

parcelRegister("9eSnh", function(module, exports) {
const $ddc6cc090d64d6da$export$92f11cf4e802b166 = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $ddc6cc090d64d6da$export$91e35509133d1cc1 = (agentNode)=>({
        creator_type: agentNode.creatorType,
        creator: agentNode.creator?.id,
        description: agentNode.description,
        external_config_reference: agentNode.externalConfigReference,
        favourite: agentNode.isFavourite,
        id: $ddc6cc090d64d6da$export$92f11cf4e802b166(agentNode.id) ?? '',
        agentAri: agentNode.id,
        identity_account_id: agentNode.identityAccountId,
        name: agentNode.name,
        user_defined_conversation_starters: agentNode.conversationStarters,
        icon: agentNode.icon,
        // We need named_id here as the FE requires it for certain features
        named_id: $ddc6cc090d64d6da$export$92f11cf4e802b166(agentNode.id) ?? '',
        authoring_team: agentNode?.authoringTeam ? {
            id: agentNode.authoringTeam.id,
            profile_url: agentNode.authoringTeam.profileUrl,
            display_name: agentNode.authoringTeam.displayName,
            avatar_url: agentNode.authoringTeam.smallAvatarImageUrl
        } : null,
        is_verified: agentNode.isVerified
    });
module.exports["transformAgentGqlResponse"] = $ddc6cc090d64d6da$export$91e35509133d1cc1;

});

parcelRegister("iswAx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");


var $9EfFC = parcelRequire("9EfFC");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $9uTsJ = parcelRequire("9uTsJ");


var $bOrYy = parcelRequire("bOrYy");


var $kpYGL = parcelRequire("kpYGL");


var $1yaYZ = parcelRequire("1yaYZ");


var $9eLw5 = parcelRequire("9eLw5");


var $26nu6 = parcelRequire("26nu6");


var $cqFPV = parcelRequire("cqFPV");


var $fQF1W = parcelRequire("fQF1W");


var $eOn3v = parcelRequire("eOn3v");


var $5kyLi = parcelRequire("5kyLi");

const $baa53903be441878$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $baa53903be441878$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $baa53903be441878$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $26nu6.isSystemAgent)(agent) || (0, $26nu6.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        testId: "atlassian-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: "Atlassian"
            })
        ]
    });
    if ((0, $26nu6.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            testId: "atlassian-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: authoringTeam.profile_url,
                target: "_blank",
                onClick: onClick,
                children: authoringTeam.display_name
            })
        });
        const aaid = agent.creator ? $baa53903be441878$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)($baa53903be441878$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $dh538.fg)('rovo_agent_support_a2a_avatar') ? (0, $bOrYy.isForgeAgentByCreatorType)(agent.creator_type) : (0, $26nu6.isForgeAgent)(agent)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: agent.creator
    });
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $baa53903be441878$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $fBMbo.di)($baa53903be441878$export$5d980898591175e);
    const { profile: profile, client: client } = $baa53903be441878$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { atlasURL: atlasURL } = (0, $fQF1W.useAtlasURL)(siteId);
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $5kyLi.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: (0, $dh538.fg)('csmai_skeleton_border_refactor') ? "var(--ds-radius-small, 4px)" : 3
    });
    if (simplified) {
        const profileUrl = atlasURL(`/people/${userId}`);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick,
            children: fullName
        });
    }
    return profileCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9uTsJ.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
function $baa53903be441878$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $eOn3v.useProfileClient)();
    const profile = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $1yaYZ.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $baa53903be441878$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $baa53903be441878$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources?.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $baa53903be441878$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $cqFPV.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $baa53903be441878$export$3761e66a04602cbd;
module.exports["AgentCreatedBy"] = $baa53903be441878$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $baa53903be441878$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $baa53903be441878$export$a6e36c224ec3c0cb;
module.exports["getSuggestedOotbAgents"] = $baa53903be441878$export$6d876204c5d593ac;

});

parcelRegister("26nu6", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $04c28723649a2305$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $04c28723649a2305$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $04c28723649a2305$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $dh538.fg)('rovo_agent_support_a2a_avatar');
const $04c28723649a2305$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $04c28723649a2305$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $04c28723649a2305$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents',
    /** Jira browse tab: agents available for Jira (UI label localized in product). */ AVAILABLE_FOR_JIRA: 'available-for-jira'
};
module.exports["isSystemAgent"] = $04c28723649a2305$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $04c28723649a2305$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $04c28723649a2305$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $04c28723649a2305$export$7091e3bee2adaacb;

});

parcelRegister("cqFPV", function(module, exports) {
const $570a782ebb8f75e0$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $570a782ebb8f75e0$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $570a782ebb8f75e0$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $570a782ebb8f75e0$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $570a782ebb8f75e0$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE;
const $570a782ebb8f75e0$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$HIPAA_ERROR_CODE;
const $570a782ebb8f75e0$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $570a782ebb8f75e0$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $570a782ebb8f75e0$export$804d9ee5f4cc40a8;
module.exports["isHipaaError"] = $570a782ebb8f75e0$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $570a782ebb8f75e0$export$429080cfef3412f2;

});

parcelRegister("fQF1W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $827Ne = parcelRequire("827Ne");


var $dYtRL = parcelRequire("dYtRL");

const $2a6bb271c0fd2ecb$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $dYtRL.useTenantDataController)(siteId);
    const atlasURL = (0, $42omo.useCallback)((path)=>(0, $827Ne.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $2a6bb271c0fd2ecb$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202;

});

parcelRegister("827Ne", function(module, exports) {

var $6FQwA = parcelRequire("6FQwA");


var $bhcGS = parcelRequire("bhcGS");

const $5ae4133df3384b49$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $5ae4133df3384b49$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $5ae4133df3384b49$export$5105758c0e772381 = ()=>{
    return (0, $bhcGS.isStaging)() ? $5ae4133df3384b49$var$ATLAS_STAGING_URL : $5ae4133df3384b49$var$ATLAS_PROD_URL;
};
const $5ae4133df3384b49$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$5ae4133df3384b49$export$5105758c0e772381()}/o/${orgId}` : $5ae4133df3384b49$export$5105758c0e772381();
    return (0, $6FQwA.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $5ae4133df3384b49$export$5105758c0e772381;
module.exports["getAtlasURL"] = $5ae4133df3384b49$export$bfee0f88bf621ad3;

});

parcelRegister("6FQwA", function(module, exports) {

var $kGZ7I = parcelRequire("kGZ7I");

const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $kGZ7I.ROVO_PARAM_PREFIX}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $kGZ7I.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $kGZ7I.ROVO_PARAM_PREFIX))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $kGZ7I.ROVO_VALID_PARAMS).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $fba4647064c9da0b$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $fba4647064c9da0b$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $fba4647064c9da0b$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $fba4647064c9da0b$export$eddc20a009406015;

});

parcelRegister("kGZ7I", function(module, exports) {
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen'
];
module.exports["ROVO_PARAM_PREFIX"] = $0075612de7c1f282$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $0075612de7c1f282$export$3cd6b610e7ede579;

});

parcelRegister("bhcGS", function(module, exports) {
const $f2c917fe02396491$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $f2c917fe02396491$export$23da1d24a38b0bde;

});

parcelRegister("dYtRL", function(module, exports) {

var $fBMbo = parcelRequire("fBMbo");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $9eLw5 = parcelRequire("9eLw5");


var $hGGLc = parcelRequire("hGGLc");

const $63d59501eb65c4db$export$b863fec6791eae25 = (siteId)=>{
    (0, $fBMbo.di)((0, $9eLw5.useQuery));
    const experience = (0, $hUyPY.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hGGLc.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};
module.exports["useTenantDataController"] = $63d59501eb65c4db$export$b863fec6791eae25;

});

parcelRegister("hGGLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8CAML = parcelRequire("8CAML");

const $0fc4c72c92b990ea$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $0fc4c72c92b990ea$var$cache = new Map();
const $0fc4c72c92b990ea$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    // If AIFC is enabled, use the new caching
    if ((0, $dh538.fg)('aifc_create_enabled')) {
        // Check if we already have a pending promise or cached result
        if ($0fc4c72c92b990ea$var$cache.has(cloudId)) return $0fc4c72c92b990ea$var$cache.get(cloudId);
        const response = await (0, $8CAML.performGqlFetch)({
            gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
            variables: {
                cloudIds: [
                    cloudId
                ]
            }
        });
        const result = response.data?.tenantContexts?.[0];
        if (result) // Store the promise in the cache
        $0fc4c72c92b990ea$var$cache.set(cloudId, result);
        return result;
    }
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
module.exports["getCloudUrlFromId"] = $0fc4c72c92b990ea$export$d4ace54df9bd6bb1;

});

parcelRegister("eOn3v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $fHxn4 = parcelRequire("fHxn4");

const $1bde4828e2efe4cf$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $1bde4828e2efe4cf$var$client;
const $1bde4828e2efe4cf$export$d43dc22a8337ee9f = ()=>{
    (0, $fBMbo.di)((0, $fHxn4.default));
    const profileClient = (0, $42omo.useMemo)(()=>{
        if (!$1bde4828e2efe4cf$var$client) // To support di
        $1bde4828e2efe4cf$var$client = new (0, $fHxn4.default)({
            url: $1bde4828e2efe4cf$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $1bde4828e2efe4cf$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $1bde4828e2efe4cf$export$d43dc22a8337ee9f;

});

parcelRegister("5kyLi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b55ef878efda143d$var$_default_1 = (0, $aXWIB.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $b55ef878efda143d$export$2e2bcd8739ae039 = $b55ef878efda143d$var$_default_1;
module.exports["default"] = $b55ef878efda143d$export$2e2bcd8739ae039;

});

parcelRegister("1uFMJ", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $29BPs = parcelRequire("29BPs");


var $h26dv = parcelRequire("h26dv");


var $2Cfy4 = parcelRequire("2Cfy4");

const $4188851fb0c3debc$export$89877d4f8d8790ca = (0, $h26dv.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).DELETE_AGENT,
                name: (0, $16lEl.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).DELETE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});
module.exports["useDeleteAgent"] = $4188851fb0c3debc$export$89877d4f8d8790ca;

});

parcelRegister("29BPs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $flpNp = parcelRequire("flpNp");

const $e1cff82b24aa7fdd$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $42omo.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $42omo.useState)(null);
    const [error, setError] = (0, $42omo.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const mutate = (0, $42omo.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            setError(apiError);
            onErrorRef.current?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};
module.exports["useMutation"] = $e1cff82b24aa7fdd$export$609860bf8b0084c;

});

parcelRegister("4ul15", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $29BPs = parcelRequire("29BPs");


var $h26dv = parcelRequire("h26dv");


var $2Cfy4 = parcelRequire("2Cfy4");

const $d9bcfe62b373548d$export$5c4c46b1f93a6e69 = (0, $h26dv.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).FAVOURITE_AGENT,
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FAVOURITE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $29BPs.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).UNFAVOURITE_AGENT,
                error: error,
                teamName: (0, $2Cfy4.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});
module.exports["useAgentFavourites"] = $d9bcfe62b373548d$export$5c4c46b1f93a6e69;

});

parcelRegister("hT0Hx", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6570846fafa2bfa7$export$ccc6603eb027f48b = /*#__PURE__*/ (0, $42omo.createContext)({});
const $6570846fafa2bfa7$export$7b61e11d4e81ba17 = ()=>(0, $42omo.useContext)($6570846fafa2bfa7$export$ccc6603eb027f48b);
const $6570846fafa2bfa7$export$aa582af5b4b72bb2 = $6570846fafa2bfa7$export$ccc6603eb027f48b.Provider;
const $6570846fafa2bfa7$export$6aab84dc399ad753 = (config)=>({
        agentDefaultIdOverride: config?.defaultAgentId,
        agentIdFiltersOverride: config?.filter
    });
module.exports["useAgentOverrider"] = $6570846fafa2bfa7$export$7b61e11d4e81ba17;
module.exports["AgentOverriderProvider"] = $6570846fafa2bfa7$export$aa582af5b4b72bb2;
module.exports["createAgentsConfig"] = $6570846fafa2bfa7$export$6aab84dc399ad753;

});

parcelRegister("37oID", function(module, exports) {
const $12593467a1d8dec1$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
    const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
    let overridenAgents = [];
    if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
            ...agent,
            is_default: index === defaultOverrideAgentsIndex
        }));
    else overridenAgents = agents;
    if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
    return overridenAgents;
};
module.exports["getOverridenAgents"] = $12593467a1d8dec1$export$b873e2166b2a4c4f;

});

parcelRegister("ka7s2", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $e2b97d183040b705$var$_default_1 = (0, $aXWIB.defineMessages)({
    defaultAgentName: {
        id: "ai-mate.agent-selector.default-agent-name",
        defaultMessage: "Chat"
    },
    defaultAgentDescription: {
        id: "ai-mate.agent-selector.default-agent-description",
        defaultMessage: "Get answers, generate new ideas, and accelerate everyday work."
    }
});
var $e2b97d183040b705$export$2e2bcd8739ae039 = $e2b97d183040b705$var$_default_1;
module.exports["default"] = $e2b97d183040b705$export$2e2bcd8739ae039;

});

parcelRegister("b4zhJ", function(module, exports) {

var $dM1Gg = parcelRequire("dM1Gg");


var $42omo = parcelRequire("42omo");


var $dWCFT = parcelRequire("dWCFT");

const $4b5152b7d142b759$var$isClickable = (props)=>!!props.onClick;
class $4b5152b7d142b759$export$6341f9a885713487 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dM1Gg.DateLozenge), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            onClick: $4b5152b7d142b759$var$isClickable(this.props) ? this.handleOnClick : undefined,
            color: this.props.color
        }, this.renderContent());
    }
    constructor(...args){
        super(...args);
        this.handleOnClick = (event)=>{
            if ($4b5152b7d142b759$var$isClickable(this.props)) this.props.onClick(this.props.value, event);
        };
        this.renderContent = ()=>{
            if (this.props.children) {
                if (typeof this.props.children === 'function') return(// prettier-ignore
                // eslint-disable-next-line @typescript-eslint/ban-types
                this.props.children(this.props));
                return this.props.children;
            }
            return (0, $dWCFT.default)(this.props.value, this.props.format || '');
        };
    }
}
$4b5152b7d142b759$export$6341f9a885713487.displayName = 'Date';
$4b5152b7d142b759$export$6341f9a885713487.defaultProps = {
    format: 'dd/MM/yyyy',
    color: 'grey'
};
module.exports["Date"] = $4b5152b7d142b759$export$6341f9a885713487;

});

parcelRegister("dM1Gg", function(module, exports) {
/* DateLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $6603fd6b25dc5551$var$baseStyles = null;
const $6603fd6b25dc5551$var$onClickStyles = null;
const $6603fd6b25dc5551$var$colorStyles = {
    red: "_bfhk1vk5 _syaz9lu1 _irr31rtt",
    yellow: "_bfhkibhp _syazfb2s _irr31773",
    blue: "_bfhk1s93 _syaz16jw _irr31dy8",
    green: "_bfhkn729 _syazh55r _irr31wnw",
    purple: "_bfhkp2ly _syazqmo9 _irr31nm4",
    grey: "_bfhki8nm _syazi7uo _irr3plhp"
};
const $6603fd6b25dc5551$export$a9273d5fc6f7142c = (props)=>{
    const { className: className, color: color = 'grey', children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...rest,
        className: (0, $gMc0m.default)([
            "_2rkofajl _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od",
            props.onClick && "_80omtlke",
            $6603fd6b25dc5551$var$colorStyles[color],
            className
        ]),
        role: "button"
    }, children);
};
module.exports["DateLozenge"] = $6603fd6b25dc5551$export$a9273d5fc6f7142c;

});

parcelRegister("ls2Fy", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $aXWIB = parcelRequire("aXWIB");

const $19b135ef0d7ad272$export$21be832820f3e6e6 = (0, $aXWIB.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $19b135ef0d7ad272$export$21be832820f3e6e6;

});

parcelRegister("fi2El", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::619fb4ad6cec2107e8d1f4fc5bb05b5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b21a97a402c82df9$var$_react = $b21a97a402c82df9$var$_interopRequireDefault((parcelRequire("42omo")));

var $b21a97a402c82df9$var$_baseNew = $b21a97a402c82df9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b21a97a402c82df9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b21a97a402c82df9$var$HistoryIcon = (props)=>/*#__PURE__*/ $b21a97a402c82df9$var$_react.default.createElement($b21a97a402c82df9$var$_baseNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$b21a97a402c82df9$var$HistoryIcon.displayName = 'HistoryIcon';
var $b21a97a402c82df9$var$_default = module.exports.default = $b21a97a402c82df9$var$HistoryIcon;

});

parcelRegister("9XexZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $15h8H = parcelRequire("15h8H");

const $26e790de36bba91a$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $15h8H.getBrowserBridgeAPI)())=>{
    const refApi = (0, $42omo.useRef)(apiInstance);
    const refReady = (0, $42omo.useRef)(false);
    const refMount = (0, $42omo.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $42omo.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $42omo.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $42omo.useCallback)((command, params)=>{
        // devx: provide current `clientId`
        return api.send(command, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $42omo.useCallback)((command, params, options)=>{
        api.broadcast(command, params, options);
    }, [
        api
    ]);
    const teardown = (0, $42omo.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
	 * If we have already mounted our handlers once and marked ourselves as ready, then this
	 * bridge API client is already capable of receiving & handling commands. On subsequent renders
	 * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
	 *
	 * This will ensure the newest state of every handler is being used, with no stale references
	 * in closures, as can often occur with initialise-only-once code in React.
	 */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $26e790de36bba91a$export$a74fbbd6fb01001c;

});

parcelRegister("5gEqE", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $815712ef274e8115$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchId: 0
};
const $815712ef274e8115$var$store = (0, $1P1Tu.createStore)({
    name: 'uiStore',
    initialState: $815712ef274e8115$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$815712ef274e8115$var$initialState,
                    conversationHeader: null
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchReplaceProviderActions: false
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchReplaceProviderActions: false
                });
            }
    }
});
const $815712ef274e8115$var$useStore = (0, $9zUhf.createHook)($815712ef274e8115$var$store);
const $815712ef274e8115$export$13a6c73a57f1d6a6 = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            launchId: state.emptyChatLaunchId
        })
});
const $815712ef274e8115$export$5b2ba9b8ea3b0771 = ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader }] = $815712ef274e8115$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader
    };
};
const $815712ef274e8115$export$cd2fc25ddd3752d4 = (0, $9zUhf.createActionsHook)($815712ef274e8115$var$store);
module.exports["useEmptyChatLaunchSelector"] = $815712ef274e8115$export$13a6c73a57f1d6a6;
module.exports["useUIStore"] = $815712ef274e8115$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $815712ef274e8115$export$cd2fc25ddd3752d4;

});

parcelRegister("jO3S6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("d7r2R", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $376a36c4bbddbe1c$var$Loading = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("title", {
                children: props.alt
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
var $376a36c4bbddbe1c$export$2e2bcd8739ae039 = $376a36c4bbddbe1c$var$Loading;
module.exports["default"] = $376a36c4bbddbe1c$export$2e2bcd8739ae039;

});

parcelRegister("kPjga", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $hezkK = parcelRequire("hezkK");

const $d0b7a75160e05812$export$c913fcdcf440a92c = ({ agent: agent })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hezkK.AgentAvatar), {
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "small",
        showBorder: false,
        isForgeAgent: agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE',
        forgeAgentIconUrl: agent.icon
    });
};
module.exports["PromptAgentAvatar"] = $d0b7a75160e05812$export$c913fcdcf440a92c;

});

parcelRegister("c03HB", function(module, exports) {
function $e4b1db74fc0aac08$export$1ae670edab4485a3(customWebsocketUrl) {
    let WEBSOCKET_URI;
    if (customWebsocketUrl) return customWebsocketUrl;
    WEBSOCKET_URI = `wss://${window.location.host}`;
    return WEBSOCKET_URI;
}
module.exports["getWebsocketURI"] = $e4b1db74fc0aac08$export$1ae670edab4485a3;

});

parcelRegister("kfm76", function(module, exports) {

var $5gid3 = parcelRequire("5gid3");


var $4EkjI = parcelRequire("4EkjI");


var $apXGz = parcelRequire("apXGz");


var $jt2Le = parcelRequire("jt2Le");


var $dxYGu = parcelRequire("dxYGu");


var $3D4Mf = parcelRequire("3D4Mf");


var $bTlBy = parcelRequire("bTlBy");

const $73101da86f523d32$export$e8bef16f28ed7bfe = async (audioChunks, lastProcessedPosition, sampleRate, audioGain = {
    enableGain: false,
    gainFactor: 3.0,
    autoNormalize: false,
    targetRMS: 0.2,
    preventClipping: true
})=>{
    const completeAudio = new Blob(audioChunks);
    const { audioBuffer: audioBuffer, newAudioEndPosition: newAudioEndPosition } = await (0, $bTlBy.getLastRecorderAudioChunk)(completeAudio, lastProcessedPosition, sampleRate);
    if (!audioBuffer) return {
        audioString: null,
        newAudioEndPosition: newAudioEndPosition
    };
    // Apply audio gain if enabled
    let processedAudioBuffer = audioBuffer;
    if (audioGain.enableGain) {
        const { gainFactor: gainFactor = 1.0, autoNormalize: autoNormalize = false, targetRMS: targetRMS = 0.2, preventClipping: preventClipping = true } = audioGain;
        const finalGainFactor = autoNormalize ? (0, $apXGz.calculateNormalizationGain)(audioBuffer, targetRMS) : gainFactor;
        processedAudioBuffer = (0, $apXGz.applyAudioGain)(audioBuffer, finalGainFactor, preventClipping);
    }
    const wavBuffer = (0, $3D4Mf.createWAVFromAudioBuffer)(processedAudioBuffer);
    const wavBlob = new Blob([
        wavBuffer
    ], {
        type: 'audio/wav'
    });
    const audioString = await (0, $4EkjI.createBase64FromBlob)(wavBlob);
    const transcription = await (0, $5gid3.getTranscriptions)({
        audioString: audioString
    });
    return {
        transcription: transcription[0],
        newAudioEndPosition: newAudioEndPosition
    };
};
const $73101da86f523d32$export$456b9750d8dac572 = async (audioChunks, lastProcessedPosition, sampleRate, soundDetection = {
    enableSoundDetection: false,
    useComprehensiveDetection: false,
    soundThreshold: 0.005
}, audioGain = {
    enableGain: false,
    gainFactor: 3.0,
    autoNormalize: false,
    targetRMS: 0.2,
    preventClipping: true
})=>{
    const { enableSoundDetection: enableSoundDetection, useComprehensiveDetection: useComprehensiveDetection, soundThreshold: soundThreshold } = soundDetection;
    const completeAudio = new Blob(audioChunks);
    const { audioBuffer: audioBuffer, newAudioEndPosition: newAudioEndPosition } = await (0, $bTlBy.getLastRecorderAudioChunk)(completeAudio, lastProcessedPosition, sampleRate);
    if (!audioBuffer) return {
        audioString: null,
        newAudioEndPosition: newAudioEndPosition
    };
    if (enableSoundDetection) {
        const hasSound = useComprehensiveDetection ? (0, $jt2Le.hasAudioContentComprehensive)(audioBuffer, {
            rmsThreshold: soundThreshold
        }) : (0, $jt2Le.hasAudioContent)(audioBuffer, soundThreshold);
        if (!hasSound) return {
            audioString: null,
            newAudioEndPosition: newAudioEndPosition
        };
    }
    let processedAudioBuffer = audioBuffer;
    if (audioGain.enableGain) {
        const { gainFactor: gainFactor = 1.0, autoNormalize: autoNormalize = false, targetRMS: targetRMS = 0.2, preventClipping: preventClipping = true } = audioGain;
        const finalGainFactor = autoNormalize ? (0, $apXGz.calculateNormalizationGain)(audioBuffer, targetRMS) : gainFactor;
        processedAudioBuffer = (0, $apXGz.applyAudioGain)(audioBuffer, finalGainFactor, preventClipping);
    }
    const pcm16Buffer = (0, $dxYGu.createPCM16FromAudioBuffer)(processedAudioBuffer);
    const pcm16Blob = new Blob([
        pcm16Buffer
    ], {
        type: 'audio/pcm'
    });
    const audioString = await (0, $4EkjI.createBase64FromBlob)(pcm16Blob);
    return {
        audioString: audioString,
        newAudioEndPosition: newAudioEndPosition
    };
};
module.exports["processAudioToTextWithPCM16"] = $73101da86f523d32$export$456b9750d8dac572;

});

parcelRegister("5gid3", function(module, exports) {
const $d4d8bb8b0048aed9$export$e70ce39e35650c8d = async ({ audioString: audioString })=>{
    const response = await fetch('/gateway/api/v1/audio/transcriptions', {
        method: 'POST',
        body: JSON.stringify({
            data: [
                {
                    audio: audioString
                }
            ],
            model: 'whisper-1',
            audio_format: 'wav'
        }),
        headers: {
            'Content-Type': 'application/json',
            'Request-ID': crypto.randomUUID()
        }
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    if (!response.body) throw new Error('Response body is null');
    return response.json();
};
module.exports["getTranscriptions"] = $d4d8bb8b0048aed9$export$e70ce39e35650c8d;

});

parcelRegister("4EkjI", function(module, exports) {
const $85e69f175dc787f8$export$c5d4e064eaa9ff1f = async (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            const result = reader.result;
            const base64 = result.split(',')[1];
            resolve(base64);
        };
        reader.onerror = ()=>reject(new Error('Failed to convert to base64'));
        reader.readAsDataURL(blob);
    });
module.exports["createBase64FromBlob"] = $85e69f175dc787f8$export$c5d4e064eaa9ff1f;

});

parcelRegister("apXGz", function(module, exports) {
/**
 * Applies audio gain (amplification) to an AudioBuffer
 *
 * This function multiplies all audio samples by a gain factor to increase or decrease
 * the audio volume. The gain is applied uniformly across all channels.
 *
 * @param audioBuffer - The AudioBuffer to apply gain to
 * @param gainFactor - The gain multiplier (1.0 = no change, 2.0 = double volume, 0.5 = half volume)
 *                     Values > 1.0 amplify the audio, values < 1.0 attenuate it
 * @param preventClipping - Whether to prevent clipping by normalizing if gain would cause overflow
 *
 * @returns A new AudioBuffer with gain applied
 *
 * @example
 * ```typescript
 * // Double the audio volume
 * const amplifiedBuffer = applyAudioGain(originalBuffer, 2.0);
 *
 * // Reduce volume by half
 * const quieterBuffer = applyAudioGain(originalBuffer, 0.5);
 *
 * // Amplify with clipping prevention
 * const safeBuffer = applyAudioGain(originalBuffer, 3.0, true);
 * ```
 */ const $740746d2cbc3cc73$export$fdc1ec94e71033b9 = (audioBuffer, gainFactor, preventClipping = true)=>{
    // Create a new AudioBuffer with the same properties
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const newBuffer = audioContext.createBuffer(audioBuffer.numberOfChannels, audioBuffer.length, audioBuffer.sampleRate);
    // Apply gain to each channel
    for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
        const originalData = audioBuffer.getChannelData(channel);
        const newData = newBuffer.getChannelData(channel);
        // First pass: apply gain and find peak if clipping prevention is enabled
        let peak = 0;
        for(let i = 0; i < originalData.length; i++){
            const amplifiedSample = originalData[i] * gainFactor;
            newData[i] = amplifiedSample;
            if (preventClipping) peak = Math.max(peak, Math.abs(amplifiedSample));
        }
        // Second pass: normalize if clipping would occur
        if (preventClipping && peak > 1.0) {
            const normalizationFactor = 1.0 / peak;
            for(let i = 0; i < newData.length; i++)newData[i] *= normalizationFactor;
        } else if (!preventClipping) // Clamp values to prevent distortion if clipping prevention is disabled
        for(let i = 0; i < newData.length; i++)newData[i] = Math.max(-1, Math.min(1.0, newData[i]));
    }
    return newBuffer;
};
const $740746d2cbc3cc73$export$dae3aad198bcc4dd = (audioBuffer)=>{
    let sumSquares = 0;
    let sampleCount = 0;
    for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let i = 0; i < channelData.length; i++){
            sumSquares += channelData[i] * channelData[i];
            sampleCount++;
        }
    }
    return Math.sqrt(sumSquares / sampleCount);
};
const $740746d2cbc3cc73$export$a4f04dc9b8c85a93 = (audioBuffer, targetRMS = 0.2, maxGain = 10.0)=>{
    const currentRMS = $740746d2cbc3cc73$export$dae3aad198bcc4dd(audioBuffer);
    if (currentRMS === 0) return 1.0; // Avoid division by zero for silent audio
    const calculatedGain = targetRMS / currentRMS;
    return Math.min(calculatedGain, maxGain);
};
module.exports["applyAudioGain"] = $740746d2cbc3cc73$export$fdc1ec94e71033b9;
module.exports["calculateNormalizationGain"] = $740746d2cbc3cc73$export$a4f04dc9b8c85a93;

});

parcelRegister("jt2Le", function(module, exports) {
/**
 * Audio analysis utilities for detecting sound content and audio quality
 */ /**
 * Detects if audio buffer contains sound above a threshold using RMS analysis
 * @param audioBuffer - The AudioBuffer to analyze
 * @param threshold - RMS threshold for sound detection (default: 0.01)
 * @returns true if audio contains sound, false if silent
 */ const $6c5f2eec39a185b4$export$fb7d0dbec0b9c428 = (audioBuffer, threshold = 0.01)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    // Calculate RMS (Root Mean Square) for each channel
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        let sumSquares = 0;
        // Calculate sum of squares for RMS
        for(let sample = 0; sample < length; sample++)sumSquares += channelData[sample] * channelData[sample];
        // Calculate RMS for this channel
        const rms = Math.sqrt(sumSquares / length);
        // If any channel has audio above threshold, return true
        if (rms > threshold) return true;
    }
    return false;
};
const $6c5f2eec39a185b4$export$41efb760936b1083 = (audioBuffer, threshold = 0.005)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    // Check peak amplitude for each channel
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let sample = 0; sample < length; sample++){
            const amplitude = Math.abs(channelData[sample]);
            if (amplitude > threshold) return true;
        }
    }
    return false;
};
const $6c5f2eec39a185b4$export$ac8474076d842596 = (audioBuffer, threshold = 0.1)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        let zeroCrossings = 0;
        // Count zero crossings
        for(let sample = 1; sample < length; sample++)if (channelData[sample] >= 0 && channelData[sample - 1] < 0 || channelData[sample] < 0 && channelData[sample - 1] >= 0) zeroCrossings++;
        // Calculate zero-crossing rate
        const zeroCrossingRate = zeroCrossings / length;
        if (zeroCrossingRate > threshold) return true;
    }
    return false;
};
const $6c5f2eec39a185b4$export$7c7be76b9ed1e76f = (audioBuffer, options = {})=>{
    const { rmsThreshold: rmsThreshold = 0.01, peakThreshold: peakThreshold = 0.005, zeroCrossingThreshold: zeroCrossingThreshold = 0.1, requireAll: requireAll = false } = options;
    const rmsResult = $6c5f2eec39a185b4$export$fb7d0dbec0b9c428(audioBuffer, rmsThreshold);
    const peakResult = $6c5f2eec39a185b4$export$41efb760936b1083(audioBuffer, peakThreshold);
    const zeroCrossingResult = $6c5f2eec39a185b4$export$ac8474076d842596(audioBuffer, zeroCrossingThreshold);
    if (requireAll) return rmsResult && peakResult && zeroCrossingResult;
    // Return true if any method detects sound (more sensitive)
    return rmsResult || peakResult || zeroCrossingResult;
};
module.exports["hasAudioContent"] = $6c5f2eec39a185b4$export$fb7d0dbec0b9c428;
module.exports["hasAudioContentComprehensive"] = $6c5f2eec39a185b4$export$7c7be76b9ed1e76f;

});

parcelRegister("dxYGu", function(module, exports) {
/**
 * Creates PCM16 data from an AudioBuffer
 *
 * This function converts Web Audio API AudioBuffer data into raw PCM16 format
 * (16-bit signed integer samples) without any file headers. This is more efficient
 * than WAV format for audio processing since it eliminates header overhead.
 *
 * @param audioBuffer - The AudioBuffer to convert to PCM16 format. This should contain
 *                      audio data from the Web Audio API (e.g., from MediaRecorder, AudioContext, etc.)
 *
 * @returns An ArrayBuffer containing the raw PCM16 audio data.
 *          The audio is encoded as 16-bit signed integers at the original sample rate and channel count.
 *
 * @example
 * ```typescript
 * // Convert an AudioBuffer to PCM16 format
 * const audioBuffer = audioContext.createBuffer(2, 44100, 44100); // 2 channels, 44.1kHz, 1 second
 * const pcm16Buffer = createPCM16FromAudioBuffer(audioBuffer);
 *
 * // Create a Blob for file download or processing
 * const blob = new Blob([pcm16Buffer], { type: 'audio/pcm' });
 *
 * // Or use directly with other APIs
 * const audioData = new Int16Array(pcm16Buffer);
 * ```
 *
 * @remarks
 * - The function generates raw PCM16 data without any file headers
 * - Supports any number of channels (mono, stereo, surround, etc.)
 * - Preserves the original sample rate from the AudioBuffer
 * - Output is little-endian 16-bit signed integers
 * - No header overhead, making it more efficient for processing
 * - Each sample is 2 bytes (16-bit)
 */ const $0d8536a4cd8d0d17$export$1c5b7794d3e4d402 = (audioBuffer)=>{
    // Extract audio properties from the buffer
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length; // Total number of samples
    // Validate that we're working with mono audio as expected
    // Note: This function is designed to work with mono audio (1 channel) as configured in getUserMedia
    // Calculate buffer size: audio data only (no headers)
    // Each sample is 16-bit (2 bytes), multiplied by number of channels
    const buffer = new ArrayBuffer(length * numChannels * 2);
    const view = new DataView(buffer);
    // Write audio data starting at byte 0
    let offset = 0;
    // Convert each channel's float32 data to int16
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let sample = 0; sample < length; sample++){
            // Convert float32 (-1.0 to 1.0) to int16 (-32768 to 32767)
            // Clamp to prevent overflow
            const floatSample = Math.max(-1, Math.min(1.0, channelData[sample]));
            const int16Sample = Math.round(floatSample * 32767);
            // Write as little-endian 16-bit signed integer
            view.setInt16(offset, int16Sample, true); // true = little-endian
            offset += 2;
        }
    }
    return buffer;
};
module.exports["createPCM16FromAudioBuffer"] = $0d8536a4cd8d0d17$export$1c5b7794d3e4d402;

});

parcelRegister("3D4Mf", function(module, exports) {
/**
 * Creates a WAV file from an AudioBuffer
 *
 * This function converts Web Audio API AudioBuffer data into a standard WAV format
 * that can be saved as a file or transmitted over the network. The function generates
 * a complete WAV file with proper headers including RIFF chunk, format chunk, and data chunk.
 *
 * @param audioBuffer - The AudioBuffer to convert to WAV format. This should contain
 *                      audio data from the Web Audio API (e.g., from MediaRecorder, AudioContext, etc.)
 *
 * @returns An ArrayBuffer containing the complete WAV file data with headers and audio samples.
 *          The audio is encoded as 16-bit PCM at the original sample rate and channel count.
 *
 * @example
 * ```typescript
 * // Convert an AudioBuffer to WAV format
 * const audioBuffer = audioContext.createBuffer(2, 44100, 44100); // 2 channels, 44.1kHz, 1 second
 * const wavBuffer = createWAVFromAudioBuffer(audioBuffer);
 *
 * // Create a Blob for file download
 * const blob = new Blob([wavBuffer], { type: 'audio/wav' });
 * const url = URL.createObjectURL(blob);
 *
 * // Or use directly with other APIs
 * const audioData = new Uint8Array(wavBuffer);
 * ```
 *
 * @remarks
 * - The function generates standard WAV format with 16-bit PCM encoding
 * - Supports any number of channels (mono, stereo, surround, etc.)
 * - Preserves the original sample rate from the AudioBuffer
 * - Output is little-endian as per WAV specification
 * - Header size is always 44 bytes + audio data
 *
 * @see {@link https://en.wikipedia.org/wiki/WAV|WAV file format specification}
 */ const $f5b30fae2e708424$export$279cd95a97baa2e3 = (audioBuffer)=>{
    // Extract audio properties from the buffer
    const numChannels = audioBuffer.numberOfChannels; // Mono = 1, Stereo = 2, etc.
    const sampleRate = audioBuffer.sampleRate; // Samples per second (e.g., 44100 Hz)
    const length = audioBuffer.length; // Total number of samples
    // Calculate buffer size: 44 bytes for WAV header + audio data
    // Each sample is 16-bit (2 bytes), multiplied by number of channels
    const buffer = new ArrayBuffer(44 + length * numChannels * 2);
    const view = new DataView(buffer);
    /**
	 * Helper function to write ASCII strings to the buffer
	 * WAV files use ASCII strings for chunk identifiers
	 */ const writeString = (offset, string)=>{
        for(let i = 0; i < string.length; i++)view.setUint8(offset + i, string.charCodeAt(i));
    };
    // Write WAV file header (44 bytes total)
    // RIFF chunk identifier - indicates this is a RIFF-formatted file
    writeString(0, 'RIFF');
    // File size minus 8 bytes (RIFF identifier + size field)
    // 36 bytes for remaining header + audio data size
    view.setUint32(4, 36 + length * numChannels * 2, true); // true = little-endian
    // WAVE format identifier
    writeString(8, 'WAVE');
    // Format chunk identifier
    writeString(12, 'fmt ');
    // Format chunk size (16 bytes for PCM format)
    view.setUint32(16, 16, true);
    // Audio format (1 = PCM/uncompressed)
    view.setUint16(20, 1, true);
    // Number of channels (1 = mono, 2 = stereo, etc.)
    view.setUint16(22, numChannels, true);
    // Sample rate in Hz (e.g., 44100, 48000)
    view.setUint32(24, sampleRate, true);
    // Byte rate: sample rate * number of channels * bytes per sample
    view.setUint32(28, sampleRate * numChannels * 2, true);
    // Block align: number of channels * bytes per sample
    view.setUint16(32, numChannels * 2, true);
    // Bits per sample (16-bit audio)
    view.setUint16(34, 16, true);
    // Data chunk identifier
    writeString(36, 'data');
    // Data chunk size: total audio data size in bytes
    view.setUint32(40, length * numChannels * 2, true);
    // Write audio data starting at byte 44 (after header)
    let offset = 44;
    // Iterate through each sample in the audio buffer
    for(let i = 0; i < length; i++)// For each sample, write data from all channels
    for(let channel = 0; channel < numChannels; channel++){
        // Get the sample value for this channel and sample index
        // Clamp the value between -1 and 1 (Web Audio API range)
        const sample = Math.max(-1, Math.min(1, audioBuffer.getChannelData(channel)[i]));
        // Convert float sample (-1 to 1) to 16-bit integer
        // For negative values: multiply by 0x8000 (32768)
        // For positive values: multiply by 0x7fff (32767)
        // This ensures proper 16-bit signed integer representation
        view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true);
        // Move to next sample position (2 bytes per sample)
        offset += 2;
    }
    return buffer;
};
module.exports["createWAVFromAudioBuffer"] = $f5b30fae2e708424$export$279cd95a97baa2e3;

});

parcelRegister("bTlBy", function(module, exports) {
const $31b1773bb64d7438$export$947890ff7373a8ab = async (audioBlob, lastProcessedPosition, sampleRate = 24000)=>{
    const arrayBuffer = await audioBlob.arrayBuffer();
    const audioContext = new AudioContext({
        sampleRate: sampleRate
    });
    try {
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const totalSamples = audioBuffer.length;
        const newSamples = totalSamples - lastProcessedPosition;
        if (newSamples <= 0) {
            await audioContext.close();
            return {
                audioBuffer: null,
                newAudioEndPosition: 0
            };
        }
        const newAudioStart = lastProcessedPosition;
        const newAudioEndPosition = totalSamples;
        const newAudioLength = newAudioEndPosition - newAudioStart;
        const newAudioBuffer = audioContext.createBuffer(audioBuffer.numberOfChannels, newAudioLength, audioBuffer.sampleRate);
        // Copy audio data from the specified range for each channel
        for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
            const channelData = audioBuffer.getChannelData(channel);
            const newChannelData = newAudioBuffer.getChannelData(channel);
            newChannelData.set(channelData.slice(newAudioStart, newAudioEndPosition));
        }
        await audioContext.close();
        return {
            audioBuffer: newAudioBuffer,
            newAudioEndPosition: newAudioEndPosition
        };
    } catch (error) {
        await audioContext.close();
        throw error;
    }
};
module.exports["getLastRecorderAudioChunk"] = $31b1773bb64d7438$export$947890ff7373a8ab;

});

parcelRegister("gVoWJ", function(module, exports) {
// #region Imports

var $bupcf = parcelRequire("bupcf");


var $hEicH = parcelRequire("hEicH");


var $jmHSv = parcelRequire("jmHSv");


var $fi7Vj = parcelRequire("fi7Vj");


var $55skd = parcelRequire("55skd");


var $khxQ7 = parcelRequire("khxQ7");


var $kXH7i = parcelRequire("kXH7i");


var $acwPl = parcelRequire("acwPl");


var $7rj2U = parcelRequire("7rj2U");


var $gyXPd = parcelRequire("gyXPd");


var $kbe7k = parcelRequire("kbe7k");


var $kIhx9 = parcelRequire("kIhx9");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $l7rln = parcelRequire("l7rln");


var $7sK9h = parcelRequire("7sK9h");


var $jS0a0 = parcelRequire("jS0a0");


var $HYzBP = parcelRequire("HYzBP");


var $gATpw = parcelRequire("gATpw");


var $6AqNX = parcelRequire("6AqNX");


var $36iDo = parcelRequire("36iDo");


var $kYgUn = parcelRequire("kYgUn");


var $itirX = parcelRequire("itirX");


var $e6sdP = parcelRequire("e6sdP");


var $bULcr = parcelRequire("bULcr");


var $7nKrc = parcelRequire("7nKrc");


var $6borH = parcelRequire("6borH");


var $5mDFx = parcelRequire("5mDFx");


var $3JBsx = parcelRequire("3JBsx");


var $fMaLE = parcelRequire("fMaLE");


var $kw2eg = parcelRequire("kw2eg");


var $vxKdN = parcelRequire("vxKdN");


var $3O0YV = parcelRequire("3O0YV");


var $fI6T7 = parcelRequire("fI6T7");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $geLSP = parcelRequire("geLSP");

function $836251edf00fa846$export$4efc99f259929bff(options) {
    const isFullPage = (0, $geLSP.isFullPage)(options.appearance);
    const preset = new (0, $bupcf.EditorPresetBuilder)().add([
        (0, $l7rln.featureFlagsPlugin),
        options.featureFlags || {}
    ]).maybeAdd([
        (0, $jmHSv.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent,
            performanceTracking: options.performanceTracking
        }
    ], Boolean(options.allowAnalyticsGASV3)).add((0, $55skd.betterTypeHistoryPlugin)).add([
        (0, $36iDo.pastePlugin),
        {
            ...options?.paste,
            isFullPage: isFullPage
        }
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        {
            initialUserPreferences: {
                toolbarDockingPosition: isFullPage ? 'none' : 'top'
            }
        }
    ], ()=>(0, $dh538.fg)('platform_editor_use_preferences_plugin')).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(options?.__livePage) || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)).add((0, $gyXPd.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        {
            contextIdentifierProvider: options.contextIdentifierProvider
        }
    ]).add([
        (0, $fi7Vj.default),
        options.base
    ]).add((0, $4KTOl.decorationsPlugin)).add([
        (0, $fMaLE.typeAheadPlugin),
        options.typeAhead
    ]).maybeAdd((0, $HYzBP.default), Boolean(options.allowUndoRedoButtons)).add((0, $3O0YV.userIntentPlugin)).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        options.toolbar || {}
    ], Boolean(options.toolbar?.enableNewToolbarExperience)).add([
        (0, $itirX.primaryToolbarPlugin),
        {
            contextualFormattingEnabled: isFullPage
        }
    ]).maybeAdd((0, $kw2eg.undoRedoPlugin), Boolean(options.featureFlags?.undoRedoButtons ?? options.allowUndoRedoButtons)).add([
        (0, $khxQ7.blockTypePlugin),
        {
            ...options.blockType,
            includeBlockQuoteAsTextstyleOption: isFullPage
        }
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        {
            preferenceToolbarAboveSelection: !!options.preferenceToolbarAboveSelection,
            contextualFormattingEnabled: isFullPage
        }
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        {
            ...options.hyperlinkOptions,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: options.__livePage
        }
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        options.textFormatting
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $e6sdP.quickInsertPlugin),
        options.quickInsert
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        options.placeholder
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $lgjGE.editorDisabledPlugin),
        {
            initialDisabledState: options.disabled
        }
    ]).add([
        (0, $6borH.submitEditorPlugin),
        options.submitEditor
    ]).add((0, $kIhx9.copyButtonPlugin)).add((0, $7sK9h.floatingToolbarPlugin)).add([
        (0, $bULcr.selectionPlugin),
        {
            ...options.selection,
            __livePage: options.__livePage
        }
    ]).add([
        (0, $7rj2U.default),
        options.codeBlock
    ]);
    return preset;
}
function $836251edf00fa846$export$a3add99b7c13b8f7(props) {
    const preset = $836251edf00fa846$export$4efc99f259929bff(props);
    return [
        preset
    ];
}
module.exports["createDefaultPreset"] = $836251edf00fa846$export$4efc99f259929bff;

});

parcelRegister("4iPjq", function(module, exports) {
parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $96msn.lazyForPaint)(()=>(parcelRequire("3106w")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $74848600c16eb369$var$_default_1 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);
var $74848600c16eb369$export$2e2bcd8739ae039 = $74848600c16eb369$var$_default_1;
module.exports["default"] = $74848600c16eb369$export$2e2bcd8739ae039;

});

parcelRegister("5wEPK", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

parcelRequire("aqrhZ");
var $jyd5r = parcelRequire("jyd5r");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $knjgj.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lQSkW.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)($99bf16152ad1d840$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $918lS.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $jrfDA.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $56c0565d5892d700$var$useConstructor(()=>(0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $l998X.jsx)($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $56c0565d5892d700$export$36ecc935abdc3636 = ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

function $4548d496336bec74$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback),
        children: children
    });
}
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::cd5b926575a5c379425d0d72e5339f12>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $l998X.jsx)(ErrorComponent, {});
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $atwsN.EmptyState), {
            header: header,
            renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c2ARh.GenericErrorSVG), {}),
            description: description
        })
    });
};
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $e8c7333955d8c82e$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ab7LA.LazyMessagesProvider), {
        children: children
    });
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale),
        children: children
    });
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("7QabG")),
    da: ()=>(parcelRequire("fZ5cF")),
    de: ()=>(parcelRequire("et5rH")),
    en_GB: ()=>(parcelRequire("9iJaf")),
    en_ZZ: ()=>(parcelRequire("4Cnvr")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("98LT8")),
    fi: ()=>(parcelRequire("g7yUI")),
    fr: ()=>(parcelRequire("54msv")),
    hu: ()=>(parcelRequire("gwZUB")),
    it: ()=>(parcelRequire("xztHG")),
    ja: ()=>(parcelRequire("2KyfN")),
    ko: ()=>(parcelRequire("9Acpd")),
    nb: ()=>(parcelRequire("16lF4")),
    nl: ()=>(parcelRequire("2kH7F")),
    pl: ()=>(parcelRequire("aXcVD")),
    pt_BR: ()=>(parcelRequire("5zlIO")),
    ru: ()=>(parcelRequire("k2mlL")),
    sv: ()=>(parcelRequire("fHEUp")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("fbVgU")),
    zh: ()=>(parcelRequire("hDdXe"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("7QabG", function(module, exports) {

let $5b554ac0a4775ef8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b554ac0a4775ef8$var$load("4Mixi"),
    $5b554ac0a4775ef8$var$load("1jsQH"),
    $5b554ac0a4775ef8$var$load("bv8GZ"),
    $5b554ac0a4775ef8$var$load("i9sd0"),
    $5b554ac0a4775ef8$var$load("i5eMd"),
    $5b554ac0a4775ef8$var$load("4DYJ5"),
    $5b554ac0a4775ef8$var$load("gyXEE"),
    $5b554ac0a4775ef8$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("fZ5cF", function(module, exports) {

let $ba3096ce98de807c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba3096ce98de807c$var$load("cjveN"),
    $ba3096ce98de807c$var$load("deyvi"),
    $ba3096ce98de807c$var$load("cdeuH"),
    $ba3096ce98de807c$var$load("aNg21"),
    $ba3096ce98de807c$var$load("4UPfH"),
    $ba3096ce98de807c$var$load("hfFxJ"),
    $ba3096ce98de807c$var$load("1Mp9N"),
    $ba3096ce98de807c$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("et5rH", function(module, exports) {

let $a887ff903b710b1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a887ff903b710b1b$var$load("8XGJb"),
    $a887ff903b710b1b$var$load("6dERU"),
    $a887ff903b710b1b$var$load("7gF8f"),
    $a887ff903b710b1b$var$load("YEGhv"),
    $a887ff903b710b1b$var$load("gd4qs"),
    $a887ff903b710b1b$var$load("gofGr"),
    $a887ff903b710b1b$var$load("dBb6q"),
    $a887ff903b710b1b$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("9iJaf", function(module, exports) {

let $6c58d42f4a0edd59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c58d42f4a0edd59$var$load("hdvZr"),
    $6c58d42f4a0edd59$var$load("kTurq"),
    $6c58d42f4a0edd59$var$load("djb49"),
    $6c58d42f4a0edd59$var$load("d8WL7"),
    $6c58d42f4a0edd59$var$load("fviv5"),
    $6c58d42f4a0edd59$var$load("2RQvP"),
    $6c58d42f4a0edd59$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("4Cnvr", function(module, exports) {

let $35ccf1dd50685b5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35ccf1dd50685b5f$var$load("4ViGN"),
    $35ccf1dd50685b5f$var$load("j0PWv"),
    $35ccf1dd50685b5f$var$load("ksTQ6"),
    $35ccf1dd50685b5f$var$load("j5F5K"),
    $35ccf1dd50685b5f$var$load("eBoC7"),
    $35ccf1dd50685b5f$var$load("7NpX8"),
    $35ccf1dd50685b5f$var$load("cukQS"),
    $35ccf1dd50685b5f$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("98LT8", function(module, exports) {

let $6a7a020a351d74e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a7a020a351d74e8$var$load("32vlK"),
    $6a7a020a351d74e8$var$load("dlmud"),
    $6a7a020a351d74e8$var$load("5CGnz"),
    $6a7a020a351d74e8$var$load("dXu4x"),
    $6a7a020a351d74e8$var$load("bNv64"),
    $6a7a020a351d74e8$var$load("bFU3Y"),
    $6a7a020a351d74e8$var$load("3CucM"),
    $6a7a020a351d74e8$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("g7yUI", function(module, exports) {

let $bbc861f37c3af690$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bbc861f37c3af690$var$load("bjoGV"),
    $bbc861f37c3af690$var$load("cbkj0"),
    $bbc861f37c3af690$var$load("9Oxgj"),
    $bbc861f37c3af690$var$load("18TX5"),
    $bbc861f37c3af690$var$load("4Afgd"),
    $bbc861f37c3af690$var$load("exaJ2"),
    $bbc861f37c3af690$var$load("lp8Wm"),
    $bbc861f37c3af690$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("54msv", function(module, exports) {

let $3b0ebf4c93ba50be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3b0ebf4c93ba50be$var$load("8oiz7"),
    $3b0ebf4c93ba50be$var$load("17m16"),
    $3b0ebf4c93ba50be$var$load("kAg8V"),
    $3b0ebf4c93ba50be$var$load("9Cdzw"),
    $3b0ebf4c93ba50be$var$load("cMubu"),
    $3b0ebf4c93ba50be$var$load("hcCcg"),
    $3b0ebf4c93ba50be$var$load("cHWSM"),
    $3b0ebf4c93ba50be$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("gwZUB", function(module, exports) {

let $c08fa8ef165abe34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c08fa8ef165abe34$var$load("hFxmj"),
    $c08fa8ef165abe34$var$load("b4NO6"),
    $c08fa8ef165abe34$var$load("fM2oh"),
    $c08fa8ef165abe34$var$load("guNAg"),
    $c08fa8ef165abe34$var$load("3fLE9"),
    $c08fa8ef165abe34$var$load("j9KTb"),
    $c08fa8ef165abe34$var$load("b37xN"),
    $c08fa8ef165abe34$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("xztHG", function(module, exports) {

let $064e9a642f5294af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $064e9a642f5294af$var$load("BXOZB"),
    $064e9a642f5294af$var$load("1K1Fj"),
    $064e9a642f5294af$var$load("xnqy2"),
    $064e9a642f5294af$var$load("cM3gY"),
    $064e9a642f5294af$var$load("8hOn0"),
    $064e9a642f5294af$var$load("3hjAq"),
    $064e9a642f5294af$var$load("7PjNK"),
    $064e9a642f5294af$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("2KyfN", function(module, exports) {

let $200a72bdd603d235$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $200a72bdd603d235$var$load("9Xiuh"),
    $200a72bdd603d235$var$load("38sfA"),
    $200a72bdd603d235$var$load("awkVi"),
    $200a72bdd603d235$var$load("6yRq3"),
    $200a72bdd603d235$var$load("h4OCL"),
    $200a72bdd603d235$var$load("2bCHJ"),
    $200a72bdd603d235$var$load("ktSfi"),
    $200a72bdd603d235$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("9Acpd", function(module, exports) {

let $6fa1195a67639e91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6fa1195a67639e91$var$load("7Odo3"),
    $6fa1195a67639e91$var$load("bjmre"),
    $6fa1195a67639e91$var$load("11DLa"),
    $6fa1195a67639e91$var$load("cft22"),
    $6fa1195a67639e91$var$load("bcQs2"),
    $6fa1195a67639e91$var$load("fdXnq"),
    $6fa1195a67639e91$var$load("iouLY"),
    $6fa1195a67639e91$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("16lF4", function(module, exports) {

let $0cd7277e754619f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0cd7277e754619f9$var$load("4VkvT"),
    $0cd7277e754619f9$var$load("asvK9"),
    $0cd7277e754619f9$var$load("barSq"),
    $0cd7277e754619f9$var$load("gctEz"),
    $0cd7277e754619f9$var$load("aBa7j"),
    $0cd7277e754619f9$var$load("cItJR"),
    $0cd7277e754619f9$var$load("hPZE5"),
    $0cd7277e754619f9$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("2kH7F", function(module, exports) {

let $1b2ee6483a0770cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b2ee6483a0770cc$var$load("g5qJV"),
    $1b2ee6483a0770cc$var$load("7v6wU"),
    $1b2ee6483a0770cc$var$load("a8heY"),
    $1b2ee6483a0770cc$var$load("9PPH7"),
    $1b2ee6483a0770cc$var$load("b544F"),
    $1b2ee6483a0770cc$var$load("SctKm"),
    $1b2ee6483a0770cc$var$load("dzIm8"),
    $1b2ee6483a0770cc$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("aXcVD", function(module, exports) {

let $7f997165c7ba8892$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f997165c7ba8892$var$load("dPa6p"),
    $7f997165c7ba8892$var$load("aEpRh"),
    $7f997165c7ba8892$var$load("6hlNE"),
    $7f997165c7ba8892$var$load("1y1eN"),
    $7f997165c7ba8892$var$load("K6fhx"),
    $7f997165c7ba8892$var$load("1fJz1"),
    $7f997165c7ba8892$var$load("jqwnR"),
    $7f997165c7ba8892$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("5zlIO", function(module, exports) {

let $40e1121b9ee6c93d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40e1121b9ee6c93d$var$load("iG4uh"),
    $40e1121b9ee6c93d$var$load("3fuR9"),
    $40e1121b9ee6c93d$var$load("2bqSD"),
    $40e1121b9ee6c93d$var$load("e8jpx"),
    $40e1121b9ee6c93d$var$load("gZU54"),
    $40e1121b9ee6c93d$var$load("9yA8o"),
    $40e1121b9ee6c93d$var$load("bGhLc"),
    $40e1121b9ee6c93d$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("k2mlL", function(module, exports) {

let $e96554c98c9bc495$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e96554c98c9bc495$var$load("9tVE8"),
    $e96554c98c9bc495$var$load("fMrUo"),
    $e96554c98c9bc495$var$load("bJykp"),
    $e96554c98c9bc495$var$load("fjbzp"),
    $e96554c98c9bc495$var$load("4Wdqb"),
    $e96554c98c9bc495$var$load("448N7"),
    $e96554c98c9bc495$var$load("9v6ER"),
    $e96554c98c9bc495$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("fHEUp", function(module, exports) {

let $b6ea9acd9e8be017$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b6ea9acd9e8be017$var$load("6UAlo"),
    $b6ea9acd9e8be017$var$load("9eNkX"),
    $b6ea9acd9e8be017$var$load("dh2Er"),
    $b6ea9acd9e8be017$var$load("1pFHs"),
    $b6ea9acd9e8be017$var$load("k10Cs"),
    $b6ea9acd9e8be017$var$load("gBDdh"),
    $b6ea9acd9e8be017$var$load("8Mz40"),
    $b6ea9acd9e8be017$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("fbVgU", function(module, exports) {

let $b0f44f1323f5f3cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0f44f1323f5f3cb$var$load("ia9y3"),
    $b0f44f1323f5f3cb$var$load("j9OUx"),
    $b0f44f1323f5f3cb$var$load("bV8sS"),
    $b0f44f1323f5f3cb$var$load("kKXTS"),
    $b0f44f1323f5f3cb$var$load("l079e"),
    $b0f44f1323f5f3cb$var$load("ebljE"),
    $b0f44f1323f5f3cb$var$load("hF4v3"),
    $b0f44f1323f5f3cb$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("hDdXe", function(module, exports) {

let $cd60e73a24cb5f53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd60e73a24cb5f53$var$load("15ncj"),
    $cd60e73a24cb5f53$var$load("gDiIK"),
    $cd60e73a24cb5f53$var$load("eLlpV"),
    $cd60e73a24cb5f53$var$load("7sItg"),
    $cd60e73a24cb5f53$var$load("f1B4n"),
    $cd60e73a24cb5f53$var$load("j4dSZ"),
    $cd60e73a24cb5f53$var$load("1Tuyb"),
    $cd60e73a24cb5f53$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("3106w", function(module, exports) {

let $23218bc4e793493f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $23218bc4e793493f$var$load("6wr18"),
    $23218bc4e793493f$var$load("7EorR"),
    $23218bc4e793493f$var$load("ffEVr"),
    $23218bc4e793493f$var$load("Wowvf"),
    $23218bc4e793493f$var$load("hhss7"),
    $23218bc4e793493f$var$load("4pqtR"),
    $23218bc4e793493f$var$load("5XqRg"),
    $23218bc4e793493f$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("io1wY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62ba7e132800466$export$2e2bcd8739ae039);

var $4Ldep = parcelRequire("4Ldep");


var $ksiqf = parcelRequire("ksiqf");


var $b5utg = parcelRequire("b5utg");

function $d62ba7e132800466$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $4Ldep.default)(dirtyDate, (0, $ksiqf.default)(Date.now(), 1));
}

});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init(shouldSkipInitRender = false) {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        if (!shouldSkipInitRender) this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $led7c = parcelRequire("led7c");


var $d7ZU3 = parcelRequire("d7ZU3");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$var$isSSR = Boolean(undefined);
const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.getBrowserInfo)().android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $8cc71206023006a6$var$isSSR) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("7pxpu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eWRwJ = parcelRequire("eWRwJ");

var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");


var $sXTCx = parcelRequire("sXTCx");


var $aFv56 = parcelRequire("aFv56");


var $l4JAB = parcelRequire("l4JAB");


var $655oj = parcelRequire("655oj");


const $669d74d97f0070d8$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("epCG3"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

const $669d74d97f0070d8$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $655oj.useDatasourceClientExtension)();
    return (0, $42omo.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $l4JAB.runWhenIdle)(()=>{
                        (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $l4JAB.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("epCG3"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $eWRwJ.default)((0, $sXTCx.EVENT_CHANNEL))((0, $aFv56.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $669d74d97f0070d8$export$612752b1e088a45e;
module.exports["useDatasourceLifecycleAnalytics"] = $669d74d97f0070d8$export$c82e48d9fd97c55b;

});

parcelRegister("sXTCx", function(module, exports) {
const $8b92489052cdb314$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $8b92489052cdb314$export$3f072f06b90c3985;

});

parcelRegister("aFv56", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $260a3ee885876edc$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $260a3ee885876edc$export$2e2bcd8739ae039 = $260a3ee885876edc$var$createEventPayload;
module.exports["default"] = $260a3ee885876edc$export$2e2bcd8739ae039;

});

parcelRegister("l4JAB", function(module, exports) {
/* eslint-disable compat/compat */ const $1f035c9bfd2157e4$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $1f035c9bfd2157e4$export$51d09170c61ebe04;

});

parcelRegister("epCG3", function(module, exports) {

let $a7e166fbd6941fc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a7e166fbd6941fc7$var$load("4pqtR"),
    $a7e166fbd6941fc7$var$load("5XqRg"),
    $a7e166fbd6941fc7$var$load("6cVEd")
]).then(()=>parcelRequire('bSBwg'));

});

parcelRegister("eyggb", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $2xxP6 = parcelRequire("2xxP6");

var $aotp7 = parcelRequire("aotp7");

var $u6ZFj = parcelRequire("u6ZFj");


var $1S4f7 = parcelRequire("1S4f7");


var $dh538 = parcelRequire("dh538");


var $cXuuT = parcelRequire("cXuuT");


var $iQfKE = parcelRequire("iQfKE");


var $gQfsl = parcelRequire("gQfsl");


var $53iyh = parcelRequire("53iyh");


var $9Ll4Q = parcelRequire("9Ll4Q");


var $7r0tI = parcelRequire("7r0tI");


var $68566 = parcelRequire("68566");


var $8RsWX = parcelRequire("8RsWX");


var $gbdVR = parcelRequire("gbdVR");


var $dXuw2 = parcelRequire("dXuw2");


var $h1iwq = parcelRequire("h1iwq");


var $7NMV8 = parcelRequire("7NMV8");


var $83ZkX = parcelRequire("83ZkX");


var $i1yGN = parcelRequire("i1yGN");

const $19fd44dc1dd6e218$export$feb99ebbc74a9193 = ({ config: options = {}, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const configPanelId = `${(0, $7NMV8.CONFIG_PANEL_ID)}-${(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()}`;
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    //Note: This is a hack to get the editor view reference in the plugin. Copied from table plugin.
    //This is needed to get the current selection in the editor
    const editorViewRef = {
        current: null
    };
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    return {
        name: 'extension',
        nodes () {
            const extensionNodes = [
                {
                    name: 'extension',
                    node: (0, $2xxP6.extension)
                },
                {
                    name: 'bodiedExtension',
                    node: (0, $gbdVR.bodiedExtensionSpecWithFixedToDOM)()
                },
                {
                    name: 'inlineExtension',
                    node: (0, $u6ZFj.inlineExtension)
                },
                {
                    name: 'extensionFrame',
                    node: (0, $aotp7.extensionFrame)
                },
                {
                    name: 'multiBodiedExtension',
                    node: (0, $aotp7.multiBodiedExtension)
                }
            ];
            return extensionNodes;
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $8RsWX.pluginKey).getState(state);
            return {
                showContextPanel: pluginState?.showContextPanel,
                extensionProvider: pluginState?.extensionProvider,
                processParametersAfter: pluginState?.processParametersAfter
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'extension',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher })=>{
                        const extensionHandlers = options.extensionHandlers || {};
                        return (0, $68566.createPlugin)(dispatch, providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, api, options.useLongPressSelection, {
                            appearance: options.appearance,
                            getExtensionHeight: options.getExtensionHeight
                        }, featureFlags, options?.__rendererExtensionOptions);
                    }
                },
                {
                    name: 'extensionKeymap',
                    plugin: ()=>(0, $53iyh.default)(api?.contextPanel?.actions.applyChange)
                },
                {
                    name: 'extensionUniqueId',
                    plugin: ()=>(0, $h1iwq.createPlugin)()
                },
                {
                    name: 'extensionEditorViewRef',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                },
                {
                    name: 'macro',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>(0, $7r0tI.createPlugin)(dispatch, providerFactory)
                }
            ];
        },
        actions: {
            api: ()=>{
                return (0, $gQfsl.createExtensionAPI)({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorView: editorViewRef.current,
                    applyChange: api?.contextPanel?.actions.applyChange,
                    editorAnalyticsAPI: api?.analytics?.actions
                });
            },
            insertMacroFromMacroBrowser: (0, $9Ll4Q.insertMacroFromMacroBrowser)(api?.analytics?.actions),
            insertOrReplaceExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $cXuuT.insertOrReplaceExtension)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            insertOrReplaceBodiedExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $cXuuT.insertOrReplaceBodiedExtension)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            editSelectedExtension: (0, $cXuuT.createEditSelectedExtensionAction)({
                editorViewRef: editorViewRef,
                editorAnalyticsAPI: api?.analytics?.actions,
                applyChangeToContextPanel: api?.contextPanel?.actions.applyChange
            }),
            runMacroAutoConvert: $9Ll4Q.runMacroAutoConvert,
            forceAutoSave: $iQfKE.forceAutoSave
        },
        pluginsOptions: {
            floatingToolbar: (0, $dXuw2.getToolbarConfig)({
                breakoutEnabled: options.breakoutEnabled,
                extensionApi: api,
                getUnsupportedContent: options.getUnsupportedContent
            }),
            contextPanel: // if showContextPanel action is not available, or platform_editor_ai_object_sidebar_injection feature flag is off
            // 	then keep using old context panel.
            !showContextPanel || !(0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? (0, $83ZkX.getContextPanel)(()=>editorViewRef.current ?? undefined)(api, featureFlags) : undefined
        },
        usePluginHook: showContextPanel && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? ({ editorView: editorView })=>{
            (0, $i1yGN.useConfigPanelPluginHook)({
                api: api,
                configPanelId: configPanelId,
                editorView: editorView
            });
        } : undefined
    };
};
module.exports["extensionPlugin"] = $19fd44dc1dd6e218$export$feb99ebbc74a9193;

});

parcelRegister("cXuuT", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aBkg6 = parcelRequire("aBkg6");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $gQfsl = parcelRequire("gQfsl");


var $liMF6 = parcelRequire("liMF6");


var $j6kTj = parcelRequire("j6kTj");

const $5d025507818a1091$export$5e06148a47ef53c2 = (type, schema, attrs, content, marks)=>{
    switch(type){
        case 'extension':
            return schema.nodes.extension.createChecked(attrs, content, marks);
        case 'inlineExtension':
            return schema.nodes.inlineExtension.createChecked(attrs, content, marks);
        case 'bodiedExtension':
            return schema.nodes.bodiedExtension.create(attrs, content, marks);
        case 'multiBodiedExtension':
            return schema.nodes.multiBodiedExtension.create(attrs, content, marks);
    }
};
const $5d025507818a1091$export$60b0a40d996019c8 = (editorAnalyticsAPI)=>(type, newAttrs, content, marks, shouldScrollIntoView)=>(_state, _dispatch, view)=>{
            if (!view) throw Error('EditorView is required to perform node update!');
            // NOTE: `state` and `dispatch` are stale at this point so we need to grab
            // the latest one from `view` @see HOT-93986
            const { state: state, dispatch: dispatch } = view;
            const newNode = $5d025507818a1091$export$5e06148a47ef53c2(type, state.schema, newAttrs, content, marks);
            if (!newNode) return false;
            const { selection: selection, schema: schema } = state;
            const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
            const isBodiedExtensionSelected = !!(0, $8m4tT.findSelectedNodeOfType)([
                bodiedExtension
            ])(selection);
            const isMultiBodiedExtensionSelected = !!(0, $8m4tT.findSelectedNodeOfType)([
                multiBodiedExtension
            ])(selection);
            const extensionState = (0, $liMF6.getPluginState)(state);
            const updateSelectionsByNodeType = (nodeType)=>{
                // Bodied/MultiBodied extensions can trigger an update when the cursor is inside which means that there is no node selected.
                // To work around that we replace the parent and create a text selection instead of new node selection
                tr = (0, $8m4tT.replaceParentNodeOfType)(nodeType, newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, state.selection.anchor));
            };
            let targetSelectionSource = (0, $aBkg6.TARGET_SELECTION_SOURCE).CURRENT_SELECTION;
            let action = (0, $d925B.ACTION).UPDATED;
            let { tr: tr } = state;
            // When it's a bodiedExtension but not selected
            if (newNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
            else if (newNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
            else if ((0, $8m4tT.findSelectedNodeOfType)([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ])(selection)) {
                tr = (0, $8m4tT.replaceSelectedNode)(newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
            } else if (extensionState.element) {
                const pos = view.posAtDOM(extensionState.element, -1);
                if (pos > -1) {
                    tr = tr.replaceWith(pos, pos + (content.size || 0) + 1, newNode);
                    tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos)));
                    targetSelectionSource = (0, $aBkg6.TARGET_SELECTION_SOURCE).HTML_ELEMENT;
                } else action = (0, $d925B.ACTION).ERRORED;
            }
            // Only scroll if we have anything to update, best to avoid surprise scroll
            if (dispatch && tr.docChanged) {
                const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = newNode.attrs;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: action,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
                    actionSubjectId: newNode.type.name,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                        // This error was introduced after upgrading to TypeScript 5
                        inputMethod: (0, $d925B.INPUT_METHOD).CONFIG_PANEL,
                        extensionType: extensionType,
                        extensionKey: extensionKey,
                        layout: layout,
                        localId: localId,
                        selection: tr.selection.toJSON(),
                        targetSelectionSource: targetSelectionSource
                    }
                })(tr);
                dispatch(shouldScrollIntoView ? tr.scrollIntoView() : tr);
            }
            return true;
        };
const $5d025507818a1091$var$updateExtensionParams = (editorAnalyticsAPI)=>(updateExtension, node, actions)=>async (state, dispatch, view)=>{
            const { attrs: attrs, type: type, content: content, marks: marks } = node.node;
            if (!state.schema.nodes[type.name]) return false;
            const { parameters: parameters } = attrs;
            try {
                const newParameters = await updateExtension(parameters, actions);
                if (newParameters) {
                    const newAttrs = {
                        ...attrs,
                        parameters: {
                            ...parameters,
                            ...newParameters
                        }
                    };
                    if (type.name === 'multiBodiedExtension') newAttrs.parameters.macroParams = {
                        ...parameters.macroParams,
                        ...newParameters?.macroParams
                    };
                    return $5d025507818a1091$export$60b0a40d996019c8(editorAnalyticsAPI)(type.name, newAttrs, content, marks, true)(state, dispatch, view);
                }
            } catch  {}
            return true;
        };
const $5d025507818a1091$export$f45ebaf24963f4bb = (macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)=>(state, dispatch, view)=>{
        if (!view) return false;
        const { localId: localId } = (0, $liMF6.getPluginState)(state);
        const nodeWithPos = (0, $j6kTj.findExtensionWithLocalId)(state, localId);
        if (!nodeWithPos) return false;
        const editInLegacyMacroBrowser = (0, $gQfsl.getEditInLegacyMacroBrowser)({
            view: view,
            macroProvider: macroProvider || undefined,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
        if (updateExtension) updateExtension.then((updateMethod)=>{
            if (updateMethod && view) {
                const actions = (0, $gQfsl.createExtensionAPI)({
                    editorView: view,
                    editInLegacyMacroBrowser: editInLegacyMacroBrowser,
                    applyChange: applyChangeToContextPanel,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
                $5d025507818a1091$var$updateExtensionParams(editorAnalyticsAPI)(updateMethod, nodeWithPos, actions)(state, dispatch, view);
                return;
            }
            if (!updateMethod && macroProvider) {
                editInLegacyMacroBrowser();
                return;
            }
        });
        else {
            if (!macroProvider) return false;
            editInLegacyMacroBrowser();
        }
        return true;
    };
const $5d025507818a1091$export$1efb7858e16078f5 = ({ editorViewRef: editorViewRef, editorAnalyticsAPI: editorAnalyticsAPI, applyChangeToContextPanel: applyChangeToContextPanel })=>()=>{
        const { current: view } = editorViewRef;
        if (!view) return false;
        const { updateExtension: updateExtension } = (0, $liMF6.getPluginState)(view.state);
        return $5d025507818a1091$export$f45ebaf24963f4bb(null, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(view.state, view.dispatch, view);
    };
const $5d025507818a1091$export$f151d046c10e64b5 = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('extension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};
const $5d025507818a1091$export$8ee156b55126996c = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('bodiedExtension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};
module.exports["buildExtensionNode"] = $5d025507818a1091$export$5e06148a47ef53c2;
module.exports["editExtension"] = $5d025507818a1091$export$f45ebaf24963f4bb;
module.exports["createEditSelectedExtensionAction"] = $5d025507818a1091$export$1efb7858e16078f5;
module.exports["insertOrReplaceExtension"] = $5d025507818a1091$export$f151d046c10e64b5;
module.exports["insertOrReplaceBodiedExtension"] = $5d025507818a1091$export$8ee156b55126996c;

});

parcelRegister("aBkg6", function(module, exports) {
var $e458bc4b0a17a20d$export$bbbdd76b3dbe0ab9 = /*#__PURE__*/ function(GAP_CURSOR_POSITION) {
    GAP_CURSOR_POSITION["LEFT"] = "left";
    GAP_CURSOR_POSITION["RIGHT"] = "right";
    return GAP_CURSOR_POSITION;
}({});
var $e458bc4b0a17a20d$export$b9401faa25e39d87 = /*#__PURE__*/ function(TARGET_SELECTION_SOURCE) {
    TARGET_SELECTION_SOURCE["CURRENT_SELECTION"] = "currentSelection";
    TARGET_SELECTION_SOURCE["HTML_ELEMENT"] = "htmlElement";
    return TARGET_SELECTION_SOURCE;
}({});
module.exports["TARGET_SELECTION_SOURCE"] = $e458bc4b0a17a20d$export$b9401faa25e39d87;

});

parcelRegister("gQfsl", function(module, exports) {

var $jqXx5 = parcelRequire("jqXx5");


var $d925B = parcelRequire("d925B");


var $7iE7T = parcelRequire("7iE7T");


var $h9yJL = parcelRequire("h9yJL");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $1oCLl = parcelRequire("1oCLl");


var $iQfKE = parcelRequire("iQfKE");


var $9Ll4Q = parcelRequire("9Ll4Q");


var $gdgqN = parcelRequire("gdgqN");


var $j6kTj = parcelRequire("j6kTj");

const $96bd81a1f1e3494f$export$5c24840493a9fa44 = ({ view: view, macroProvider: macroProvider, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return ()=>{
        if (!view) throw new Error(`Missing view. Can't update without EditorView`);
        if (!macroProvider) throw new Error(`Missing macroProvider. Can't use the macro browser for updates`);
        const nodeWithPos = (0, $j6kTj.getSelectedExtension)(view.state, true);
        if (!nodeWithPos) throw new Error(`Missing nodeWithPos. Can't determine position of node`);
        (0, $9Ll4Q.insertMacroFromMacroBrowser)(editorAnalyticsAPI)(macroProvider, nodeWithPos.node, true)(view);
    };
};
const $96bd81a1f1e3494f$var$extensionAPICallPayload = (functionName)=>({
        action: (0, $d925B.ACTION).INVOKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION_API,
        attributes: {
            functionName: functionName
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    });
const $96bd81a1f1e3494f$export$5c70dcf0377b6800 = (options)=>{
    const { editorView: { state: { schema: schema } }, editorAnalyticsAPI: editorAnalyticsAPI } = options;
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $jqXx5.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    /**
	 * Finds the node and its position by `localId`. Throws if the node could not be found.
	 *
	 * @returns {NodeWithPos}
	 */ const ensureNodePosByLocalId = (localId, { opName: opName })=>{
        // Be extra cautious since 3rd party devs can use regular JS without type safety
        if (typeof localId !== 'string' || localId === '') throw new Error(`${opName}(): Invalid localId '${localId}'.`);
        // Find the node + position matching the given ID
        const { editorView: { state: state } } = options;
        const nodePos = (0, $j6kTj.findNodePosWithLocalId)(state, localId);
        if (!nodePos) throw new Error(`${opName}(): Could not find node with ID '${localId}'.`);
        return nodePos;
    };
    const doc = {
        insertAfter: (localId, adf, opt)=>{
            try {
                validate(adf);
            } catch (e) {
                throw new Error(`insertAfter(): Invalid ADF given.`);
            }
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'insertAfter'
            });
            const { editorView: editorView } = options;
            const { dispatch: dispatch, state: state } = editorView;
            // Validate the given ADF
            const { tr: tr, schema: schema } = state;
            const nodeType = schema.nodes[adf.type];
            if (!nodeType) throw new Error(`insertAfter(): Invalid ADF type '${adf.type}'.`);
            const fragment = (0, $5SAOw.Fragment).fromJSON(schema, adf.content);
            const marks = (adf.marks || []).map((markEntity)=>(0, $5SAOw.Mark).fromJSON(schema, markEntity));
            const newNode = nodeType?.createChecked(adf.attrs, fragment, marks);
            if (!newNode) throw new Error('insertAfter(): Could not create a node for given ADFEntity.');
            const insertPosition = nodePos.pos + nodePos.node.nodeSize;
            tr.insert(insertPosition, newNode);
            // Validate if the document is valid at this point
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAfter(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $96bd81a1f1e3494f$var$extensionAPICallPayload('insertAfter');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            // Analytics - tracking node types added
            const nodesAdded = [
                newNode
            ];
            newNode.descendants((node)=>{
                nodesAdded.push(node);
                return true;
            });
            nodesAdded.forEach((node)=>{
                const { extensionKey: extensionKey, extensionType: extensionType } = node.attrs;
                const dataConsumerMark = (0, $j6kTj.getDataConsumerMark)(node);
                const stringIds = dataConsumerMark?.attrs.sources.map((sourceId)=>sourceId) || [];
                const hasReferentiality = !!dataConsumerMark;
                const nodeTypesReferenced = hasReferentiality ? (0, $j6kTj.getNodeTypesReferenced)(stringIds, state) : undefined;
                // fire off analytics for this ADF
                const payload = {
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    attributes: {
                        nodeType: node.type.name,
                        inputMethod: (0, $d925B.INPUT_METHOD).EXTENSION_API,
                        hasReferentiality: hasReferentiality,
                        nodeTypesReferenced: nodeTypesReferenced,
                        layout: node.attrs.layout,
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            });
            if (opt) {
                if (opt.allowSelectionToNewNode) tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(insertPosition)));
                else if (opt.allowSelectionNearNewNode) tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(insertPosition)));
            }
            dispatch(tr);
        },
        scrollTo: (localId)=>{
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'scrollTo'
            });
            // Analytics - tracking the api call
            const apiCallPayload = $96bd81a1f1e3494f$var$extensionAPICallPayload('scrollTo');
            const { editorView: { dispatch: dispatch, state: state } } = options;
            let { tr: tr } = state;
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            tr = (0, $8m4tT.setTextSelection)(nodePos.pos)(tr);
            let useScrollIntoView = true;
            if (nodePos.node.type.name === 'table' && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                const tableDOM = options.editorView.nodeDOM(nodePos.pos);
                if (tableDOM instanceof HTMLElement) {
                    tableDOM.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                    useScrollIntoView = false;
                }
            }
            if (useScrollIntoView) tr.scrollIntoView();
            dispatch(tr);
        },
        update: (localId, mutationCallback, opts)=>{
            const { node: node, pos: pos } = ensureNodePosByLocalId(localId, {
                opName: 'update'
            });
            const { editorView: { dispatch: dispatch, state: state } } = options;
            const { tr: tr, schema: schema } = state;
            const changedValues = mutationCallback({
                content: (0, $7iE7T.nodeToJSON)(node).content,
                attrs: node.attrs,
                marks: node.marks.map((pmMark)=>({
                        type: pmMark.type.name,
                        attrs: pmMark.attrs
                    }))
            });
            const ensureValidMark = (mark)=>{
                if (typeof mark !== 'object' || Array.isArray(mark)) throw new Error(`update(): Invalid mark given.`);
                const { parent: parent } = state.doc.resolve(pos);
                // Ensure that the given mark is present in the schema
                const markType = schema.marks[mark.type];
                if (!markType) throw new Error(`update(): Invalid ADF mark type '${mark.type}'.`);
                if (!parent.type.allowsMarkType(markType)) throw new Error(`update(): Parent of type '${parent.type.name}' does not allow marks of type '${mark.type}'.`);
                return {
                    mark: markType,
                    attrs: mark.attrs
                };
            };
            const newMarks = changedValues.hasOwnProperty('marks') ? changedValues.marks?.map(ensureValidMark).map(({ mark: mark, attrs: attrs })=>mark.create(attrs)) : node.marks;
            const newContent = changedValues.hasOwnProperty('content') ? (0, $5SAOw.Fragment).fromJSON(schema, changedValues.content) : node.content;
            let newAttrs = changedValues.hasOwnProperty('attrs') ? changedValues.attrs : node.attrs;
            if (node.type.name === 'multiBodiedExtension') newAttrs = {
                ...node.attrs,
                ...changedValues.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    ...changedValues.attrs?.parameters,
                    macroParams: {
                        ...node.attrs.parameters?.macroParams,
                        ...changedValues.attrs?.parameters?.macroParams
                    }
                }
            };
            // Validate if the new attributes, content and marks result in a valid node and adf.
            try {
                const newNode = node.type.createChecked(newAttrs, newContent, newMarks);
                const newNodeAdf = new (0, $h9yJL.JSONTransformer)().encodeNode(newNode);
                validate(newNodeAdf);
                tr.replaceWith(pos, pos + node.nodeSize, newNode);
                // Keep selection if content does not change
                if (newContent === node.content) tr.setSelection((0, $ks2lK.Selection).fromJSON(tr.doc, state.selection.toJSON()));
            } catch (err) {
                throw new Error(`update(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $96bd81a1f1e3494f$var$extensionAPICallPayload('update');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            if (typeof opts?.addToHistory === 'boolean') tr.setMeta('addToHistory', opts.addToHistory);
            if (typeof opts?.scrollIntoView === 'boolean') tr.setMeta('scrollIntoView', opts.scrollIntoView);
            dispatch(tr);
        }
    };
    return {
        editInContextPanel: (transformBefore, transformAfter)=>{
            const { editorView: editorView } = options;
            (0, $iQfKE.setEditingContextToContextPanel)(transformBefore, transformAfter, options.applyChange)(editorView.state, editorView.dispatch, editorView);
        },
        _editInLegacyMacroBrowser: ()=>{
            const { editorView: editorView } = options;
            let editInLegacy = options.editInLegacyMacroBrowser;
            if (!editInLegacy) {
                const macroState = (0, $gdgqN.pluginKey).getState(editorView.state);
                editInLegacy = $96bd81a1f1e3494f$export$5c24840493a9fa44({
                    view: options.editorView,
                    macroProvider: macroState?.macroProvider || undefined,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
            }
            editInLegacy();
        },
        getNodeWithPosByLocalId: (localId)=>{
            return ensureNodePosByLocalId(localId, {
                opName: 'getNodeWithPosByLocalId'
            });
        },
        doc: doc
    };
};
module.exports["getEditInLegacyMacroBrowser"] = $96bd81a1f1e3494f$export$5c24840493a9fa44;
module.exports["createExtensionAPI"] = $96bd81a1f1e3494f$export$5c70dcf0377b6800;

});

parcelRegister("iQfKE", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aBkg6 = parcelRequire("aBkg6");


var $5GR8v = parcelRequire("5GR8v");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $liMF6 = parcelRequire("liMF6");


var $j6kTj = parcelRequire("j6kTj");

function $d61ca718ec6d02a8$export$4971331372cec95a(state) {
    return (0, $liMF6.createCommand)({
        type: 'UPDATE_STATE',
        data: state
    });
}
function $d61ca718ec6d02a8$export$845f8c516a847983(processParametersBefore, processParametersAfter, applyChangeToContextPanel) {
    return (0, $liMF6.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: true,
            processParametersBefore: processParametersBefore,
            processParametersAfter: processParametersAfter
        }
    }, applyChangeToContextPanel);
}
const $d61ca718ec6d02a8$export$81748740fe20ba64 = (applyChangeToContextPanel)=>(0, $liMF6.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: false,
            processParametersBefore: undefined,
            processParametersAfter: undefined
        }
    }, applyChangeToContextPanel);
const $d61ca718ec6d02a8$export$265d048971b3d878 = (applyChangeToContextPanel)=>(resolve, reject)=>(0, $liMF6.createCommand)({
            type: 'UPDATE_STATE',
            data: {
                autoSaveResolve: resolve,
                autoSaveReject: reject
            }
        }, applyChangeToContextPanel);
const $d61ca718ec6d02a8$export$612be0ec35a64e3b = (layout, analyticsApi)=>(0, $liMF6.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            layout: layout
        }
    }, (tr, state)=>{
        const selectedExtension = (0, $j6kTj.getSelectedExtension)(state, true);
        if (selectedExtension) {
            const trWithNewNodeMarkup = tr.setNodeMarkup(selectedExtension.pos, undefined, {
                ...selectedExtension.node.attrs,
                layout: layout
            });
            trWithNewNodeMarkup.setMeta('scrollIntoView', false);
            if (analyticsApi) analyticsApi.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).UPDATED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    extensionType: selectedExtension.node.attrs.extensionType,
                    extensionKey: selectedExtension.node.attrs.extensionKey,
                    localId: selectedExtension.node.attrs.localId,
                    layout: layout,
                    selection: tr.selection.toJSON(),
                    targetSelectionSource: (0, $aBkg6.TARGET_SELECTION_SOURCE).CURRENT_SELECTION
                }
            })(tr);
            return trWithNewNodeMarkup;
        }
        return tr;
    });
const $d61ca718ec6d02a8$export$366c74c25333cf63 = (editorAnalyticsAPI, inputMethod)=>(0, $liMF6.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        if ((0, $j6kTj.getSelectedExtension)(state)) return $d61ca718ec6d02a8$export$8bdb85550181fac8(state, tr, editorAnalyticsAPI, inputMethod);
        else return $d61ca718ec6d02a8$export$a5879ac679bfa06d(state, tr, editorAnalyticsAPI, inputMethod);
    });
const $d61ca718ec6d02a8$export$fa79c3ccfdddfece = (sourceNode)=>(0, $liMF6.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $5GR8v.removeConnectedNodes)(state, sourceNode) : tr;
    });
const $d61ca718ec6d02a8$export$8bdb85550181fac8 = (state, tr, analyticsApi, inputMethod)=>{
    if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
        const node = state.selection.node;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $8m4tT.removeSelectedNode)(tr);
};
const $d61ca718ec6d02a8$export$a5879ac679bfa06d = (state, tr, analyticsApi, inputMethod)=>{
    let nodeType = state.schema.nodes.bodiedExtension;
    const maybeMBENode = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.multiBodiedExtension)(state.selection);
    if (maybeMBENode) {
        nodeType = state.schema.nodes.multiBodiedExtension;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: maybeMBENode.node.attrs.extensionType,
                extensionKey: maybeMBENode.node.attrs.extensionKey,
                localId: maybeMBENode.node.attrs.localId,
                currentFramesCount: maybeMBENode.node.content.childCount,
                inputMethod: inputMethod
            }
        })(tr);
    }
    const bodiedExtensionNode = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
    if (bodiedExtensionNode) {
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: bodiedExtensionNode.node.attrs.extensionType,
                extensionKey: bodiedExtensionNode.node.attrs.extensionKey,
                localId: bodiedExtensionNode.node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $8m4tT.removeParentNodeOfType)(nodeType)(tr);
};
module.exports["updateState"] = $d61ca718ec6d02a8$export$4971331372cec95a;
module.exports["setEditingContextToContextPanel"] = $d61ca718ec6d02a8$export$845f8c516a847983;
module.exports["clearEditingContext"] = $d61ca718ec6d02a8$export$81748740fe20ba64;
module.exports["forceAutoSave"] = $d61ca718ec6d02a8$export$265d048971b3d878;
module.exports["updateExtensionLayout"] = $d61ca718ec6d02a8$export$612be0ec35a64e3b;
module.exports["removeExtension"] = $d61ca718ec6d02a8$export$366c74c25333cf63;
module.exports["removeDescendantNodes"] = $d61ca718ec6d02a8$export$fa79c3ccfdddfece;

});

parcelRegister("liMF6", function(module, exports) {

var $lkJUe = parcelRequire("lkJUe");


var $8RsWX = parcelRequire("8RsWX");


var $eO9Ig = parcelRequire("eO9Ig");

const $7c3916ff30296215$var$factory = (0, $lkJUe.pluginFactory)((0, $8RsWX.pluginKey), (0, $eO9Ig.default), {
    mapping (tr, state) {
        const { positions: previousPositions } = state;
        if (!previousPositions) return state;
        const positions = {
            ...previousPositions
        };
        // eslint-disable-next-line guard-for-in
        for(const key in positions)positions[key] = tr.mapping.map(positions[key]);
        return {
            ...state,
            positions: positions
        };
    }
});
const $7c3916ff30296215$export$656c7661095efe2e = $7c3916ff30296215$var$factory.createPluginState;
const $7c3916ff30296215$export$8d4021544bdece00 = $7c3916ff30296215$var$factory.createCommand;
const $7c3916ff30296215$export$f05434c51e3762e = $7c3916ff30296215$var$factory.getPluginState;
module.exports["createPluginState"] = $7c3916ff30296215$export$656c7661095efe2e;
module.exports["createCommand"] = $7c3916ff30296215$export$8d4021544bdece00;
module.exports["getPluginState"] = $7c3916ff30296215$export$f05434c51e3762e;

});

parcelRegister("8RsWX", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $c9b341a736aaedb1$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('extensionPlugin');
module.exports["pluginKey"] = $c9b341a736aaedb1$export$18d4026d1ea86bb1;

});

parcelRegister("eO9Ig", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6b622e1ab00ec41$export$2e2bcd8739ae039);
function $c6b622e1ab00ec41$export$2e2bcd8739ae039(pluginState, action) {
    switch(action.type){
        case 'UPDATE_STATE':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
}

});

parcelRegister("j6kTj", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $cMZNY = parcelRequire("cMZNY");


var $4vlwG = parcelRequire("4vlwG");

var $2bi6l = parcelRequire("2bi6l");


var $h9yJL = parcelRequire("h9yJL");


var $8m4tT = parcelRequire("8m4tT");


var $bqMS3 = parcelRequire("bqMS3");

const $1aea8836743878dc$export$cdb701fa2b3c99df = (state, searchParent = false)=>{
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    return (0, $8m4tT.findSelectedNodeOfType)(nodeTypes)(state.selection) || searchParent && (0, $8m4tT.findParentNodeOfType)(nodeTypes)(state.selection) || undefined;
};
const $1aea8836743878dc$export$b003700b6d25caa7 = (state, localId)=>{
    const selectedExtension = $1aea8836743878dc$export$cdb701fa2b3c99df(state, true);
    if (!localId) return selectedExtension;
    if (selectedExtension && selectedExtension.node.attrs.localId === localId) return selectedExtension;
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    let matched;
    state.doc.descendants((node, pos)=>{
        if (nodeTypes.includes(node.type) && node.attrs.localId === localId) matched = {
            node: node,
            pos: pos
        };
    });
    return matched;
};
const $1aea8836743878dc$export$f1c79f28529bfc9a = (schema, domAtPos, selectedExtensionNode)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const selectedExtensionDomNode = (0, $8m4tT.findDomRefAtPos)(selectedExtensionNode.pos, domAtPos);
    const isContentExtension = selectedExtensionNode.node.type !== schema.nodes.bodiedExtension;
    return(// Content extension can be nested in bodied-extension, the following check is necessary for that case
    (isContentExtension // Search down
     ? selectedExtensionDomNode.querySelector('.extension-container') // Try searching up and then down
     : (0, $4vlwG.closestElement)(selectedExtensionDomNode, '.extension-container') || selectedExtensionDomNode.querySelector('.extension-container')) || selectedExtensionDomNode);
};
const $1aea8836743878dc$export$cd9967958db163fc = (newNode)=>newNode.marks?.find((mark)=>mark.type.name === 'dataConsumer');
const $1aea8836743878dc$export$1004a88e790d2d21 = (ids, state)=>{
    return (0, $2bi6l.findNodePosByLocalIds)(state, ids, {
        includeDocNode: true
    }).map(({ node: node })=>node.type.name);
};
const $1aea8836743878dc$export$bb057d1dfc5c8b1b = (state, localId)=>{
    const nodes = (0, $2bi6l.findNodePosByLocalIds)(state, [
        localId
    ]);
    return nodes.length >= 1 ? nodes[0] : undefined;
};
/**
 * Converts a ProseMirror node to its text representation.
 * Handles text nodes with marks (links) and inline nodes (status, mention, emoji).
 * Returns the content for this node, with a trailing separator for text blocks.
 */ const $1aea8836743878dc$var$convertNodeToText = (node, mentionSet, parent, locale)=>{
    if (node.isInline) {
        const schema = node.type.schema;
        let finalText = '';
        if (node.isText) {
            finalText = node.text || '';
            if (node.marks.length > 0) {
                for (const mark of node.marks)// if it's link, include the href in the text
                if (mark.type === schema.marks.link) {
                    const href = mark.attrs.href;
                    const text = node.text || '';
                    // If the text differs from the href, include both
                    if (text && text !== href) finalText = `${text} ${href}`;
                    else finalText = href;
                }
            }
        } else switch(node.type){
            case schema.nodes.status:
                finalText = node.attrs.text || '';
                break;
            case schema.nodes.mention:
                mentionSet.add(node.attrs.id);
                finalText = `@${node.attrs.id}`;
                break;
            case schema.nodes.emoji:
                finalText = node.attrs.shortName || '';
                break;
            case schema.nodes.date:
                const timestamp = new Date(Number(node.attrs.timestamp));
                finalText = !isNaN(timestamp.getTime()) ? timestamp.toLocaleDateString(locale ?? 'en-US') : String(node.attrs.timestamp);
                break;
            default:
                finalText = node.textContent;
                break;
        }
        if (parent && parent.isTextblock && node === parent.lastChild && parent.childCount > 0) finalText += '\n\n';
        return finalText;
    }
    return '';
};
/**
 * Resolves mention IDs to their display names and replaces them in the text.
 * Returns the text with resolved mentions, or the original text if the provider is unavailable.
 */ const $1aea8836743878dc$var$resolveMentionsInText = async (text, mentionSet, api)=>{
    const mentionProvider = api?.mention?.sharedState?.currentState()?.mentionProvider;
    if (!mentionProvider || !(0, $bqMS3.isResolvingMentionProvider)(mentionProvider)) return text;
    let resolvedText = text;
    for (const id of mentionSet){
        const mention = await mentionProvider.resolveMentionName(id);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        resolvedText = resolvedText.replace(`@${id}`, `@${mention.name}` || "@\u2026");
    }
    return resolvedText;
};
const $1aea8836743878dc$export$9defe25170de6263 = async ({ locale: locale, schema: schema, unsupportedContent: unsupportedContent, api: api })=>{
    try {
        if (!unsupportedContent) throw new Error('No nested content found');
        if (unsupportedContent.type !== 'doc') unsupportedContent = {
            version: 1,
            type: 'doc',
            content: [
                unsupportedContent
            ]
        };
        const transformer = new (0, $h9yJL.JSONTransformer)(schema);
        const pmNode = transformer.parse(unsupportedContent);
        let text = '';
        const mentionSet = new Set();
        pmNode.nodesBetween(0, pmNode.content.size, (node, _pos, parent)=>{
            text += $1aea8836743878dc$var$convertNodeToText(node, mentionSet, parent, locale);
        });
        // Trim leading/trailing whitespace from the collected text
        text = text.trim();
        text = await $1aea8836743878dc$var$resolveMentionsInText(text, mentionSet, api);
        (0, $cMZNY.copyToClipboard)(text);
    } catch (error) {
        throw error instanceof Error ? error : new Error('Failed to copy content');
    }
};
const $1aea8836743878dc$export$67e8f2a5d4f25de0 = ({ error: error, extensionApi: extensionApi, state: state })=>{
    const nodeWithPos = $1aea8836743878dc$export$cdb701fa2b3c99df(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    extensionApi?.analytics?.actions.fireAnalyticsEvent({
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        action: (0, $d925B.ACTION).COPY_FAILED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: node.type.name,
        attributes: {
            extensionKey: extensionKey,
            extensionType: extensionType,
            errorMessage: error.message,
            errorStack: error.stack
        }
    });
};
module.exports["getSelectedExtension"] = $1aea8836743878dc$export$cdb701fa2b3c99df;
module.exports["findExtensionWithLocalId"] = $1aea8836743878dc$export$b003700b6d25caa7;
module.exports["getSelectedDomElement"] = $1aea8836743878dc$export$f1c79f28529bfc9a;
module.exports["getDataConsumerMark"] = $1aea8836743878dc$export$cd9967958db163fc;
module.exports["getNodeTypesReferenced"] = $1aea8836743878dc$export$1004a88e790d2d21;
module.exports["findNodePosWithLocalId"] = $1aea8836743878dc$export$bb057d1dfc5c8b1b;
module.exports["copyUnsupportedContentToClipboard"] = $1aea8836743878dc$export$9defe25170de6263;
module.exports["onCopyFailed"] = $1aea8836743878dc$export$67e8f2a5d4f25de0;

});

parcelRegister("9Ll4Q", function(module, exports) {

var $9ir1r = parcelRequire("9ir1r");


var $d925B = parcelRequire("d925B");

var $aBkg6 = parcelRequire("aBkg6");


var $zT4ZO = parcelRequire("zT4ZO");


var $bSXAs = parcelRequire("bSXAs");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $liMF6 = parcelRequire("liMF6");


var $gdgqN = parcelRequire("gdgqN");

const $b35d6c52d15b10f4$export$4ec44b2939e261e2 = (editorAnalyticsAPI)=>(macroProvider, macroNode, isEditing)=>async (view)=>{
            if (!macroProvider) return false;
            // opens MacroBrowser for editing "macroNode" if passed in
            const newMacro = await macroProvider.openMacroBrowser(macroNode);
            if (newMacro && macroNode) {
                const { state: state, dispatch: dispatch } = view;
                const currentLayout = macroNode && macroNode.attrs.layout || 'default';
                const node = $b35d6c52d15b10f4$export$87074dfcaea41da3(newMacro, state, {
                    layout: currentLayout
                });
                if (!node) return false;
                const { selection: selection, schema: schema } = state;
                const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const updateSelectionsByNodeType = (nodeType)=>{
                    // `isEditing` is `false` when we are inserting from insert-block toolbar
                    tr = isEditing ? (0, $8m4tT.replaceParentNodeOfType)(nodeType, node)(tr) : (0, $8m4tT.safeInsert)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, state.selection.anchor));
                };
                const extensionState = (0, $liMF6.getPluginState)(state);
                let targetSelectionSource = (0, $aBkg6.TARGET_SELECTION_SOURCE).CURRENT_SELECTION;
                let { tr: tr } = state;
                const isBodiedExtensionSelected = !!(0, $8m4tT.findSelectedNodeOfType)([
                    bodiedExtension
                ])(selection);
                const isMultiBodiedExtensionSelected = !!(0, $8m4tT.findSelectedNodeOfType)([
                    multiBodiedExtension
                ])(selection);
                // When it's a bodiedExtension but not selected
                if (macroNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
                else if (macroNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
                else if ((0, $8m4tT.findSelectedNodeOfType)([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ])(selection)) {
                    tr = (0, $8m4tT.replaceSelectedNode)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
                } else if (extensionState.element) {
                    const pos = view.posAtDOM(extensionState.element, -1);
                    if (pos > -1) {
                        tr = tr.replaceWith(pos, pos + macroNode.nodeSize, node);
                        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos)));
                        targetSelectionSource = (0, $aBkg6.TARGET_SELECTION_SOURCE).HTML_ELEMENT;
                    }
                }
                // Only scroll if we have anything to update, best to avoid surprise scroll
                if (dispatch && tr.docChanged) {
                    const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = macroNode.attrs;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $d925B.ACTION).UPDATED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
                        actionSubjectId: macroNode.type.name,
                        eventType: (0, $d925B.EVENT_TYPE).TRACK,
                        attributes: {
                            // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                            // This error was introduced after upgrading to TypeScript 5
                            inputMethod: isEditing ? (0, $d925B.INPUT_METHOD).MACRO_BROWSER : (0, $d925B.INPUT_METHOD).TOOLBAR,
                            extensionType: extensionType,
                            extensionKey: extensionKey,
                            layout: layout,
                            localId: localId,
                            selection: tr.selection.toJSON(),
                            targetSelectionSource: targetSelectionSource
                        }
                    })(tr);
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            return false;
        };
const $b35d6c52d15b10f4$export$87074dfcaea41da3 = (macro, state, optionalAttrs)=>{
    if (!macro || !state) return null;
    const { schema: schema } = state;
    const { type: type, attrs: attrs } = (0, $bSXAs.getValidNode)(macro, schema);
    let node = null;
    if (type === 'extension') node = schema.nodes.extension.create({
        ...attrs,
        ...optionalAttrs
    });
    else if (type === 'bodiedExtension') node = schema.nodes.bodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    else if (type === 'inlineExtension') node = schema.nodes.inlineExtension.create(attrs);
    else if (type === 'multiBodiedExtension') node = schema.nodes.multiBodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    return node && (0, $zT4ZO.normaliseNestedLayout)(state, node);
};
const $b35d6c52d15b10f4$export$774dc72aee79b8eb = (state, text)=>{
    const macroPluginState = (0, $gdgqN.pluginKey).getState(state);
    const macroProvider = macroPluginState && macroPluginState.macroProvider;
    if (!macroProvider || !macroProvider.autoConvert) return null;
    const macroAttributes = macroProvider.autoConvert(text);
    if (!macroAttributes) return null;
    // decides which kind of macro to render (inline|bodied|bodyless)
    return $b35d6c52d15b10f4$export$87074dfcaea41da3(macroAttributes, state);
};
const $b35d6c52d15b10f4$export$e45aff648def0591 = (provider)=>async (view)=>{
        let resolvedProvider;
        try {
            resolvedProvider = await provider;
            (0, (/*@__PURE__*/$parcel$interopDefault($9ir1r)))(resolvedProvider && resolvedProvider.openMacroBrowser, `MacroProvider promise did not resolve to a valid instance of MacroProvider - ${resolvedProvider}`);
        } catch (err) {
            resolvedProvider = null;
        }
        view.dispatch(view.state.tr.setMeta((0, $gdgqN.pluginKey), {
            macroProvider: resolvedProvider
        }));
        return true;
    };
module.exports["insertMacroFromMacroBrowser"] = $b35d6c52d15b10f4$export$4ec44b2939e261e2;
module.exports["runMacroAutoConvert"] = $b35d6c52d15b10f4$export$774dc72aee79b8eb;
module.exports["setMacroProvider"] = $b35d6c52d15b10f4$export$e45aff648def0591;

});

parcelRegister("gdgqN", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $2ffaec345eb6ed9f$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('macroPlugin');
module.exports["pluginKey"] = $2ffaec345eb6ed9f$export$18d4026d1ea86bb1;

});

parcelRegister("53iyh", function(module, exports) {
$parcel$export(module.exports, "default", () => $391952836eb8b15d$export$2e2bcd8739ae039);

var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


var $iQfKE = parcelRequire("iQfKE");


var $liMF6 = parcelRequire("liMF6");

function $391952836eb8b15d$export$2e2bcd8739ae039(applyChange) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.escape).common, (state, dispatch)=>{
        const extensionState = (0, $liMF6.getPluginState)(state);
        if (!extensionState.showContextPanel) return false;
        return (0, $iQfKE.clearEditingContext)(applyChange)(state, dispatch);
    }, list);
    return (0, $dus6D.keymap)(list);
}

});

parcelRegister("7r0tI", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $9Ll4Q = parcelRequire("9Ll4Q");


var $gdgqN = parcelRequire("gdgqN");

const $e83e7d9c02de9f75$export$ae829ec7b2625219 = (dispatch, providerFactory)=>new (0, $1S4f7.SafePlugin)({
        state: {
            init: ()=>({
                    macroProvider: null
                }),
            apply (tr, state) {
                const meta = tr.getMeta((0, $gdgqN.pluginKey));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    dispatch((0, $gdgqN.pluginKey), newState);
                    return newState;
                }
                return state;
            }
        },
        key: (0, $gdgqN.pluginKey),
        view: (view)=>{
            const handleProvider = (_name, provider)=>provider && (0, $9Ll4Q.setMacroProvider)(provider)(view);
            // make sure editable DOM node is mounted
            if (view.dom.parentNode) providerFactory.subscribe('macroProvider', handleProvider);
            return {
                destroy () {
                    providerFactory.unsubscribe('macroProvider', handleProvider);
                }
            };
        }
    });
module.exports["createPlugin"] = $e83e7d9c02de9f75$export$ae829ec7b2625219;

});

parcelRegister("68566", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");

var $adhil = parcelRequire("adhil");

var $l6okE = parcelRequire("l6okE");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $iQfKE = parcelRequire("iQfKE");


var $acUEK = parcelRequire("acUEK");


var $liMF6 = parcelRequire("liMF6");


var $8RsWX = parcelRequire("8RsWX");


var $4eFRN = parcelRequire("4eFRN");


var $j6kTj = parcelRequire("j6kTj");

const $9c14eded2e96d0e7$var$shouldShowEditButton = (extensionHandler, extensionProvider)=>{
    const usesLegacyMacroBrowser = !extensionHandler && !extensionProvider || typeof extensionHandler === 'function';
    const usesModernUpdateMethod = typeof extensionHandler === 'object' && typeof extensionHandler.update === 'function';
    if (usesLegacyMacroBrowser || usesModernUpdateMethod) return true;
    return false;
};
const $9c14eded2e96d0e7$var$getUpdateExtensionPromise = async (view, extensionHandler, extensionProvider)=>{
    if (extensionHandler && typeof extensionHandler === 'object') // Old API with the `update` function
    return extensionHandler.update;
    else if (extensionProvider) {
        // New API with or without the `update` function, we don't know at this point
        const updateMethod = await (0, $4eFRN.updateEditButton)(view, extensionProvider);
        if (updateMethod) return updateMethod;
    }
    throw new Error('No update method available');
};
const $9c14eded2e96d0e7$export$21b8c38408ff6d69 = (view)=>async (name, provider)=>{
        if (name === 'extensionProvider' && provider) try {
            const extensionProvider = await provider;
            (0, $iQfKE.updateState)({
                extensionProvider: extensionProvider
            })(view.state, view.dispatch);
            await (0, $4eFRN.updateEditButton)(view, extensionProvider);
        } catch  {
            (0, $iQfKE.updateState)({
                extensionProvider: undefined
            })(view.state, view.dispatch);
        }
    };
const $9c14eded2e96d0e7$export$3c1d0d79a942e731 = ({ view: view, prevState: prevState, domAtPos: domAtPos, extensionHandlers: extensionHandlers, applyChange: applyChange })=>{
    const { state: state, dispatch: dispatch } = view;
    const { element: element, localId: localId, extensionProvider: extensionProvider, showContextPanel: showContextPanel, showEditButton: showEditButton } = (0, $liMF6.getPluginState)(state);
    // This fetches the selected extension node, either by keyboard selection or click for all types of extensions
    const selectedExtension = (0, $j6kTj.getSelectedExtension)(state, true);
    if (!selectedExtension) {
        if (showContextPanel) (0, $iQfKE.clearEditingContext)(applyChange)(state, dispatch);
        return;
    }
    const { node: node } = selectedExtension;
    const newElement = (0, $j6kTj.getSelectedDomElement)(state.schema, domAtPos, selectedExtension);
    // In some cases, showEditButton can be stale and the edit button doesn't show - @see ED-15285
    // To be safe, we update the showEditButton state here
    const shouldUpdateEditButton = !showEditButton && extensionProvider && element === newElement && !(0, $j6kTj.getSelectedExtension)(prevState, true);
    const isNewNodeSelected = node.attrs.localId ? localId !== node.attrs.localId : // as fallback in case we need to turn off `allowLocalIdGeneration`
    element !== newElement;
    if (isNewNodeSelected || shouldUpdateEditButton) {
        if (showContextPanel) {
            (0, $iQfKE.clearEditingContext)(applyChange)(state, dispatch);
            return;
        }
        const { extensionType: extensionType } = node.attrs;
        const extensionHandler = extensionHandlers[extensionType];
        // showEditButton might change async based on results from extension providers
        const showEditButton = $9c14eded2e96d0e7$var$shouldShowEditButton(extensionHandler, extensionProvider);
        const updateExtension = $9c14eded2e96d0e7$var$getUpdateExtensionPromise(view, extensionHandler, extensionProvider).catch(()=>{
        // do nothing;
        });
        (0, $iQfKE.updateState)({
            localId: node.attrs.localId,
            showContextPanel: false,
            element: newElement,
            showEditButton: showEditButton,
            updateExtension: updateExtension
        })(state, dispatch);
    } else if (element !== newElement) (0, $iQfKE.updateState)({
        element: newElement
    })(state, dispatch);
    return true;
};
const $9c14eded2e96d0e7$export$ae829ec7b2625219 = (dispatch, providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, pluginInjectionApi, useLongPressSelection = false, options = {}, featureFlags, __rendererExtensionOptions)=>{
    const state = (0, $liMF6.createPluginState)(dispatch, {
        showEditButton: false,
        showContextPanel: false
    });
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight
    };
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: featureFlags?.macroInteractionUpdates ?? false
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    return new (0, $1S4f7.SafePlugin)({
        state: state,
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const extensionProviderHandler = $9c14eded2e96d0e7$export$21b8c38408ff6d69(editorView);
            providerFactory.subscribe('extensionProvider', extensionProviderHandler);
            return {
                update: (view, prevState)=>{
                    $9c14eded2e96d0e7$export$3c1d0d79a942e731({
                        view: view,
                        prevState: prevState,
                        domAtPos: domAtPos,
                        extensionHandlers: extensionHandlers,
                        applyChange: pluginInjectionApi?.contextPanel?.actions.applyChange
                    });
                },
                destroy: ()=>{
                    providerFactory.unsubscribe('extensionProvider', extensionProviderHandler);
                }
            };
        },
        key: (0, $8RsWX.pluginKey),
        props: {
            handleDOMEvents: {
                /**
				 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty.
				 * This code is to handle the case where the selection starts inside or on the node and the user is trying to shift + arrow.
				 * For other part of the solution see code in: packages/editor/editor-core/src/plugins/selection/pm-plugins/events/keydown.ts
				 */ keydown: (view, event)=>{
                    if (event instanceof KeyboardEvent && event.shiftKey && [
                        'ArrowUp',
                        'ArrowDown',
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { bodiedExtension: bodiedExtension } = schema.nodes;
                        if (selection instanceof (0, $ks2lK.TextSelection) || selection instanceof (0, $ks2lK.NodeSelection)) {
                            const maybeBodiedExtension = selection instanceof (0, $ks2lK.TextSelection) ? (0, $8m4tT.findParentNodeOfTypeClosestToPos)($head, bodiedExtension) : (0, $8m4tT.findSelectedNodeOfType)(bodiedExtension)(selection);
                            if (maybeBodiedExtension) {
                                const end = maybeBodiedExtension.pos + maybeBodiedExtension.node.nodeSize;
                                if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' && (0, $l6okE.isSelectionAtStartOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = end + 1;
                                    // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
                                    const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
                                    const head = maybeBodiedExtension.pos + headOffset;
                                    const newSelection = (0, $ks2lK.TextSelection).create(doc, Math.max(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                                if (event.key === 'ArrowDown' || event.key === 'ArrowRight' && (0, $l6okE.isSelectionAtEndOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = maybeBodiedExtension.pos - 1;
                                    const head = end + 1;
                                    const newSelection = (0, $ks2lK.TextSelection).create(doc, Math.min(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                            }
                        }
                    }
                    // Handle non shift key case for MBE
                    if (event instanceof KeyboardEvent && !event.shiftKey && event.key === 'ArrowLeft') {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame, paragraph: paragraph } = schema.nodes;
                        if (selection instanceof (0, $adhil.GapCursorSelection) || selection instanceof (0, $ks2lK.TextSelection) && $head.parent.type === paragraph) {
                            const maybeMultiBodiedExtension = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($head, multiBodiedExtension);
                            if (maybeMultiBodiedExtension) {
                                /* In case of gap cursor, we need to decrement the position by 1 as we need to check the node at previous position
								 * In case of text selection, we need to decrement the position by 2 as we need to jump back twice, once from text node and then its parent paragraph node
								 */ const previousPositionDecrement = selection instanceof (0, $adhil.GapCursorSelection) ? 1 : 2;
                                if (tr.doc.nodeAt($head.pos - previousPositionDecrement)?.type === extensionFrame) {
                                    const newSelection = (0, $ks2lK.TextSelection).create(doc, tr.doc.resolve($head.pos - previousPositionDecrement).start($head.depth - previousPositionDecrement));
                                    view.dispatch(tr.setSelection(newSelection));
                                }
                            }
                        }
                    }
                    return false;
                }
            },
            nodeViews: {
                // WARNING: referentiality-plugin also creates these nodeviews
                extension: (0, $acUEK.lazyExtensionNodeView)('extension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                // WARNING: referentiality-plugin also creates these nodeviews
                bodiedExtension: (0, $acUEK.lazyExtensionNodeView)('bodiedExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers),
                // WARNING: referentiality-plugin also creates these nodeviews
                inlineExtension: (0, $acUEK.lazyExtensionNodeView)('inlineExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                multiBodiedExtension: (0, $acUEK.lazyExtensionNodeView)('multiBodiedExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags)
            },
            createSelectionBetween: function(view, anchor, head) {
                const { schema: schema, doc: doc } = view.state;
                const { multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const isAnchorInMBE = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(anchor, multiBodiedExtension);
                const isHeadInMBE = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(head, multiBodiedExtension);
                if (isAnchorInMBE !== undefined && isHeadInMBE === undefined) {
                    // Anchor is in MBE, where user started selecting within MBE and then moved outside
                    const newSelection = (0, $ks2lK.TextSelection).create(doc, isAnchorInMBE.pos < head.pos ? isAnchorInMBE.pos : isAnchorInMBE.pos + isAnchorInMBE.node.nodeSize, head.pos);
                    return newSelection;
                }
                if (isAnchorInMBE === undefined && isHeadInMBE !== undefined) {
                    // Head is in MBE, where user started selecting outside MBE and then moved inside
                    const newSelection = (0, $ks2lK.TextSelection).create(doc, anchor.pos, isHeadInMBE.pos < anchor.pos ? isHeadInMBE.pos : isHeadInMBE.pos + isHeadInMBE.node.nodeSize);
                    return newSelection;
                }
                return null;
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ], (target)=>!target.closest('.extension-non-editable-area') && (!target.closest('.extension-content') || !!target.closest('.extension-container')), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};
module.exports["createPlugin"] = $9c14eded2e96d0e7$export$ae829ec7b2625219;

});

parcelRegister("acUEK", function(module, exports) {

var $gjBRE = parcelRequire("gjBRE");


var $ftpVl = parcelRequire("ftpVl");


var $iu6m9 = parcelRequire("iu6m9");


function $aa818765dc2dc945$export$18f6e24b34cb523d(nodeName, ...params) {
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $gjBRE.default)(...params);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: nodeName,
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("8y1DS")).then(({ ExtensionNodeView: ExtensionNodeView })=>{
                return ExtensionNodeView(...params);
            });
            return result;
        }
    });
}
module.exports["lazyExtensionNodeView"] = $aa818765dc2dc945$export$18f6e24b34cb523d;

});

parcelRegister("gjBRE", function(module, exports) {
$parcel$export(module.exports, "default", () => $1db25360181e8d88$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eTj7Y = parcelRequire("eTj7Y");


var $2gkmX = parcelRequire("2gkmX");


var $fPlBD = parcelRequire("fPlBD");


var $3oRlx = parcelRequire("3oRlx");

class $1db25360181e8d88$export$456a23774b90f061 extends (0, $2gkmX.default) {
    ignoreMutation(mutation) {
        // Extensions can perform async operations that will change the DOM.
        // To avoid having their tree rebuilt, we need to ignore the mutation
        // for atom based extensions if its not a layout, we need to give
        // children a chance to recalc
        return this.node.type.isAtom || mutation.type !== 'selection' && mutation.attributeName !== 'data-layout';
    }
    // Reserve height by setting a minimum height for the extension node view element
    createDomRef() {
        if (!(0, $dh538.fg)('confluence_connect_macro_preset_height')) {
            // Try to reuse SSR'd DOM node on first init only
            // This preserves SSR content and avoids TTVC mutations during hydration
            if (!(0, $eTj7Y.isSSR)() && this.isFirstInit && this.node.type.name === 'extension' && this.node.attrs.extensionKey === 'toc' && (0, $1oCLl.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) {
                const ssrElement = this.findSSRElement();
                if (ssrElement) {
                    this.didReuseSsrDom = true;
                    return ssrElement;
                }
            }
            return super.createDomRef();
        }
        if (!this.node.isInline) {
            const htmlElement = document.createElement('div');
            const extensionHeight = this.reactComponentProps?.extensionNodeViewOptions?.getExtensionHeight?.(this.node);
            if (extensionHeight) htmlElement.style.setProperty('min-height', `${extensionHeight}px`);
            return htmlElement;
        }
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    /**
   * Attempts to find an existing SSR'd DOM element for this extension node by extensionKey and localId
   * which should uniquely identify the
   * extension node within the editor content.
   *
   * @returns The SSR'd element if found, otherwise null
   */ findSSRElement() {
        if (this.cachedSsrElement !== undefined) return this.cachedSsrElement || null;
        const extensionKey = this.node.attrs.extensionKey;
        const localId = this.node.attrs.localId;
        const editorDom = this.view.dom;
        if (extensionKey && localId) {
            const selector = `[extensionkey="${extensionKey}"][localid="${localId}"]`;
            const element = editorDom.querySelector(selector);
            if (element && element instanceof HTMLElement) {
                this.cachedSsrElement = element;
                return element;
            }
        }
        this.cachedSsrElement = null;
        return null;
    }
    /**
   * Override init() to skip React Portal rendering on first init if we're reusing SSR'd DOM.
   * This preserves the SSR content without React unnecessarily re-rendering it.
   */ init() {
        if (!(0, $1oCLl.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) super.init();
        else if (!(0, $eTj7Y.isSSR)() && this.node.type.name === 'extension' && this.node.attrs.extensionKey === 'toc') {
            const ssrElement = this.findSSRElement();
            const shouldSkipInitRender = ssrElement !== null;
            super.init(shouldSkipInitRender);
            if (shouldSkipInitRender) this.isFirstInit = false;
        } else super.init();
        return this;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // Remove extensionNodeWrapper aka span.relative if we previously reused SSR DOM
        // control is back to React afterwards
        if (this.didReuseSsrDom && (0, $1oCLl.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) {
            const ssrElement = this.findSSRElement();
            if (ssrElement) {
                const extensionNodeWrapper = ssrElement.querySelector('[data-testId="extension-node-wrapper"]');
                if (extensionNodeWrapper) extensionNodeWrapper.remove();
                this.didReuseSsrDom = false;
            }
        }
        return super.update(node, decorations, _innerDecorations, validUpdate);
    }
    /**
   * When interacting with input elements inside an extension's body, the events
   * bubble up to the editor and get handled by it. This almost always gets in the way
   * of being able to actually interact with said input in the extension, i.e.
   * typing inside a text field (in an extension body) will print the text in the editor
   * content area instead. This change prevents the editor view from trying to handle these events,
   * when the target of the event is an input element, so the extension can.
   */ stopEvent(event) {
        if ((0, $dh538.fg)('forge-ui-extensionnodeview-stop-event-for-textarea')) return event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement;
        return event.target instanceof HTMLInputElement;
    }
    getContentDOM() {
        if (this.node.isInline) return;
        if (this.didReuseSsrDom) return;
        const contentDomWrapper = document.createElement('div');
        contentDomWrapper.className = `${this.node.type.name}-content-dom-wrapper`;
        const isBodiedExtension = this.node.type.name === 'bodiedExtension';
        const showMacroInteractionDesignUpdates = this.reactComponentProps?.macroInteractionDesignFeatureFlags?.showMacroInteractionDesignUpdates;
        if (isBodiedExtension && showMacroInteractionDesignUpdates && (0, $1oCLl.expValEquals)('platform_editor_bodiedextension_layoutshift_fix', 'isEnabled', true)) {
            // Create outer wrapper to hold space for the lozenge
            const outerWrapper = document.createElement('div');
            outerWrapper.className = `${this.node.type.name}-content-outer-wrapper`;
            // Create inner wrapper to position inner content
            const innerWrapper = document.createElement('div');
            innerWrapper.className = `${this.node.type.name}-content-inner-wrapper`;
            innerWrapper.appendChild(contentDomWrapper);
            outerWrapper.appendChild(innerWrapper);
            return {
                dom: outerWrapper,
                contentDOM: contentDomWrapper
            };
        }
        return {
            dom: contentDomWrapper
        };
    }
    render(props, forwardRef) {
        // If we reused SSR'd DOM on first init, don't render React Portal
        // The SSR content is already perfect and doesn't need re-rendering
        if (this.didReuseSsrDom && this.isFirstInit) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3oRlx.ExtensionNodeWrapper), {
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fPlBD.Extension), {
            editorView: this.view,
            node: this.node,
            eventDispatcher: this.eventDispatcher,
            // The getPos arg is always a function when used with nodes
            // the version of the types we use has a union with the type
            // for marks.
            // This has been fixed in later versions of the definitly typed
            // types (and also in prosmirror-views inbuilt types).
            // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
            getPos: this.getPos,
            providerFactory: props.providerFactory,
            handleContentDOMRef: forwardRef,
            extensionHandlers: props.extensionHandlers,
            editorAppearance: props.extensionNodeViewOptions?.appearance,
            pluginInjectionApi: props.pluginInjectionApi,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: props.rendererExtensionHandlers
        }));
    }
    constructor(...args){
        super(...args);
        /**
     * Track whether we found and are reusing SSR'd DOM.
     * When true, we skip React Portal rendering on first init to preserve SSR content.
     */ this.didReuseSsrDom = false;
        /**
     * Track whether this is the first init call.
     * SSR content preservation only happens on the very first init.
     */ this.isFirstInit = true;
        /**
     * Cache for SSR element lookup to avoid repeated DOM queries.
     * undefined = not yet searched, null = searched but not found, HTMLElement = found
     */ this.cachedSsrElement = void 0;
    }
}
function $1db25360181e8d88$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers) {
    return (node, view, getPos)=>{
        return new $1db25360181e8d88$export$456a23774b90f061(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers
        }).init();
    };
}
module.exports["ExtensionNode"] = $1db25360181e8d88$export$456a23774b90f061;

});

parcelRegister("fPlBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4FxUL = parcelRequire("4FxUL");

var $dYBVS = parcelRequire("dYBVS");


var $dhO1r = parcelRequire("dhO1r");

class $394b11282ac27980$export$eeddbf09bb970356 extends (0, $42omo.Component) {
    componentWillUnmount() {
        if (!this.props.providerFactory) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYBVS.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'extensionProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = ({ extensionProvider: extensionProvider })=>{
            const { node: node, getPos: getPos, editorView: editorView, handleContentDOMRef: handleContentDOMRef, extensionHandlers: extensionHandlers, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            // Extensions are not yet using the new plugin architecture, and the use of the pluginInjectionApi
            // is not type safe in editor-common.
            // @ts-ignore
            const currentState = pluginInjectionApi?.editorViewMode?.sharedState?.currentState();
            const { contentMode: contentMode, mode: mode } = currentState || {};
            const isLivePageViewMode = contentMode === 'live-view' || mode === 'view';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dhO1r.ExtensionComponent), {
                editorView: editorView,
                node: node,
                getPos: getPos,
                references: references,
                extensionProvider: extensionProvider,
                handleContentDOMRef: handleContentDOMRef,
                extensionHandlers: extensionHandlers,
                editorAppearance: editorAppearance,
                pluginInjectionApi: pluginInjectionApi,
                eventDispatcher: eventDispatcher,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: rendererExtensionHandlers,
                isLivePageViewMode: isLivePageViewMode
            });
        };
        this.providerFactory = props.providerFactory || new (0, $4FxUL.default)();
    }
}
$394b11282ac27980$export$eeddbf09bb970356.displayName = 'Extension';
module.exports["Extension"] = $394b11282ac27980$export$eeddbf09bb970356;

});

parcelRegister("dhO1r", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $heH5c = parcelRequire("heH5c");


var $2diEG = parcelRequire("2diEG");

var $7iE7T = parcelRequire("7iE7T");


var $8Ze8r = parcelRequire("8Ze8r");


var $5wrbt = parcelRequire("5wrbt");


var $aAiMR = parcelRequire("aAiMR");


var $akFmj = parcelRequire("akFmj");

const $cad668a69e29b538$var$getBodiedExtensionContent = (node)=>{
    const bodiedExtensionContent = [];
    node.content.forEach((childNode)=>{
        bodiedExtensionContent.push((0, $7iE7T.nodeToJSON)(childNode));
    });
    return !!bodiedExtensionContent.length ? bodiedExtensionContent : node.attrs.text;
};
const $cad668a69e29b538$export$908ff786c04d5297 = (props)=>{
    const { extensionProvider: extensionProviderResolver, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, node: node, ...restProps } = props;
    const [extensionProvider, setExtensionProvider] = (0, $42omo.useState)(undefined);
    const [showBodiedExtensionRendererView, setShowBodiedExtensionRendererView] = (0, $42omo.useState)(!!showLivePagesBodiedMacrosRendererView?.((0, $7iE7T.nodeToJSON)(node)) && !(0, $5wrbt.isEmptyBodiedMacro)(node));
    const mountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        extensionProviderResolver?.then((provider)=>{
            if (mountedRef.current) setExtensionProvider(provider);
        });
    }, [
        extensionProviderResolver
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cad668a69e29b538$var$ExtensionComponentInner, {
        ...restProps,
        extensionProvider: extensionProvider,
        node: node,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    });
};
class $cad668a69e29b538$var$ExtensionComponentInner extends (0, $42omo.Component) {
    componentDidUpdate() {
        this.parsePrivateNodePropsIfNeeded();
    }
    render() {
        const { node: node, handleContentDOMRef: handleContentDOMRef, editorView: editorView, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, getPos: getPos, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, extensionProvider: extensionProvider, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, isLivePageViewMode: isLivePageViewMode } = this.props;
        const { selection: selection } = editorView.state;
        const selectedNode = selection instanceof (0, $ks2lK.NodeSelection) && selection.node;
        const position = typeof getPos === 'function' && getPos();
        const resolvedPosition = position && editorView.state.doc.resolve(position);
        const isNodeNested = !!(resolvedPosition && resolvedPosition.depth > 0);
        if (node.type.name === 'multiBodiedExtension') {
            const allowBodiedOverride = this.state._privateProps?.__allowBodiedOverride;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $akFmj.default), {
                node: node,
                editorView: editorView,
                getPos: getPos,
                handleContentDOMRef: handleContentDOMRef,
                tryExtensionHandler: this.tryExtensionHandler.bind(this),
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi,
                editorAppearance: editorAppearance,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                isNodeSelected: selectedNode === node,
                isNodeNested: isNodeNested,
                isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                isLivePageViewMode: isLivePageViewMode,
                allowBodiedOverride: allowBodiedOverride
            });
        }
        const extensionHandlerResult = this.tryExtensionHandler(undefined);
        switch(node.type.name){
            case 'extension':
            case 'bodiedExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Ze8r.default), {
                    node: node,
                    getPos: this.props.getPos,
                    references: references,
                    extensionProvider: extensionProvider,
                    handleContentDOMRef: handleContentDOMRef,
                    view: editorView,
                    editorAppearance: editorAppearance,
                    hideFrame: this.state._privateProps?.__hideFrame,
                    pluginInjectionApi: pluginInjectionApi,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                    isNodeNested: isNodeNested,
                    setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                    showLivePagesBodiedMacrosRendererView: !!showLivePagesBodiedMacrosRendererView?.((0, $7iE7T.nodeToJSON)(node)),
                    showUpdatedLivePages1PBodiedExtensionUI: !!showUpdatedLivePages1PBodiedExtensionUI?.((0, $7iE7T.nodeToJSON)(node)),
                    showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                    setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                    isLivePageViewMode: isLivePageViewMode
                }, extensionHandlerResult);
            case 'inlineExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aAiMR.default), {
                    node: node,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.state.isNodeHovered,
                    setIsNodeHovered: (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? undefined : this.setIsNodeHovered,
                    isLivePageViewMode: isLivePageViewMode
                }, extensionHandlerResult);
            default:
                return null;
        }
    }
    tryExtensionHandler(actions) {
        const { node: node } = this.props;
        try {
            const extensionContent = this.handleExtension(node, actions);
            if (extensionContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(extensionContent)) return extensionContent;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Provided extension handler has thrown an error\n', e);
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return null;
    }
    constructor(...args){
        super(...args);
        this.privatePropsParsed = false;
        this.state = {};
        // memoized to avoid rerender on extension state changes
        this.getNodeRenderer = (0, $2XqLN.default)((0, $heH5c.getNodeRenderer));
        this.getExtensionModuleNodePrivateProps = (0, $2XqLN.default)((0, $heH5c.getExtensionModuleNodePrivateProps));
        this.setIsNodeHovered = (isHovered)=>{
            // Don't want to show hover interactions for live page view mode
            if (!this.props.isLivePageViewMode) this.setState({
                isNodeHovered: isHovered
            });
        };
        /**
     * Parses any private nodes once an extension provider is available.
     *
     * We do this separately from resolving a node renderer component since the
     * private props come from extension provider, rather than an extension
     * handler which only handles `render`/component concerns.
     */ this.parsePrivateNodePropsIfNeeded = async ()=>{
            if (this.privatePropsParsed || !this.props.extensionProvider) return;
            this.privatePropsParsed = true;
            const { extensionType: extensionType, extensionKey: extensionKey } = this.props.node.attrs;
            /**
       * getExtensionModuleNodePrivateProps can throw if there are issues in the
       * manifest
       */ try {
                const privateProps = await this.getExtensionModuleNodePrivateProps(this.props.extensionProvider, extensionType, extensionKey);
                this.setState({
                    _privateProps: privateProps
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Provided extension handler has thrown an error\n', e);
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        };
        this.handleExtension = (pmNode, actions)=>{
            const { extensionHandlers: extensionHandlers, editorView: editorView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, text: text } = pmNode.attrs;
            const isBodiedExtension = pmNode.type.name === 'bodiedExtension';
            if (isBodiedExtension && !showBodiedExtensionRendererView) return;
            const fragmentLocalId = pmNode?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const content = isBodiedExtension ? $cad668a69e29b538$var$getBodiedExtensionContent(pmNode) : text;
            const node = {
                type: pmNode.type.name,
                extensionType: extensionType,
                extensionKey: extensionKey,
                parameters: parameters,
                content: content,
                localId: pmNode.attrs.localId,
                fragmentLocalId: fragmentLocalId
            };
            if (isBodiedExtension) {
                const rendererExtensionHandler = rendererExtensionHandlers?.[extensionType];
                // Forge bodied extensions don't get rendererExtensionHandlers passed in and use extensionHandlerFromProvider from the below logic instead
                if (rendererExtensionHandler) return (0, $2diEG.getExtensionRenderer)(rendererExtensionHandler)(node, (0, $7iE7T.toJSON)(editorView.state.doc));
            }
            let result;
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2diEG.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, editorView.state.doc, actions);
            }
            if (!result) {
                const extensionHandlerFromProvider = this.props.extensionProvider && this.getNodeRenderer(this.props.extensionProvider, extensionType, extensionKey);
                if (extensionHandlerFromProvider) {
                    const NodeRenderer = extensionHandlerFromProvider;
                    if (node.type === 'multiBodiedExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        actions: actions
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        showUnknownMacroPlaceholder: (0, $dh538.fg)('tinymce_display_unknown_macro_body_content')
                    });
                }
            }
            return result;
        };
    }
}
module.exports["ExtensionComponent"] = $cad668a69e29b538$export$908ff786c04d5297;

});

parcelRegister("8Ze8r", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $eiA8Z = parcelRequire("eiA8Z");


var $frt7o = parcelRequire("frt7o");


var $fJNzZ = parcelRequire("fJNzZ");


var $3Zyfb = parcelRequire("3Zyfb");


var $klDBQ = parcelRequire("klDBQ");


var $mBi3D = parcelRequire("mBi3D");


var $5wrbt = parcelRequire("5wrbt");


var $jY6Lt = parcelRequire("jY6Lt");

function $8b68c835fd1c0f68$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b68c835fd1c0f68$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $8b68c835fd1c0f68$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
function $8b68c835fd1c0f68$var$ExtensionWithPluginState(props) {
    const { node: node, handleContentDOMRef: handleContentDOMRef, children: children, widthState: widthState, handleRef: handleRef, shadowClassNames: shadowClassNames, hideFrame: hideFrame, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const isLegacyContentMacroExtension = (extensionNode)=>extensionNode.type.name === 'extension' && extensionNode.attrs?.extensionType === 'com.atlassian.confluence.migration' && extensionNode.attrs?.extensionKey === 'legacy-content';
    const showLegacyContentHeader = (0, $dh538.fg)('platform_editor_legacy_content_macro_visual_update') && isLegacyContentMacroExtension(node);
    const hasBody = [
        'bodiedExtension',
        'multiBodiedExtension'
    ].includes(node.type.name);
    const hasChildren = !!children;
    const removeBorder = showMacroInteractionDesignUpdates || !!(hideFrame && !hasBody);
    // Some native bodied macros (e.g Content properties) have this param to hide in view mode
    // which we want to also hide in live page view mode too
    const macroParamHiddenValue = node?.attrs?.parameters?.macroParams?.hidden?.value;
    const shouldHideInLivePageViewMode = isLivePageViewMode && macroParamHiddenValue === 'true'; // it is stored as a string
    const { getPos: getPos, view: view } = props;
    const isTopLevelNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const pos = typeof getPos === 'function' ? getPos() : undefined;
        return typeof pos !== 'undefined' && !isNaN(pos) && view.state.doc.resolve(pos).depth === 0;
    }, [
        view,
        getPos
    ]);
    const layout = node.attrs.layout;
    const legacyShouldBreakout = [
        'full-width',
        'wide'
    ].includes(layout) && isTopLevelNode && editorAppearance !== 'full-width';
    const tinymceFullWidthModeEnabled = (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true);
    const breakoutExtensionFixEnabled = (0, $1oCLl.expValEquals)('confluence_max_width_breakout_extension_fix', 'isEnabled', true);
    const shouldUseBreakoutFix = tinymceFullWidthModeEnabled && breakoutExtensionFixEnabled;
    const shouldBreakout = shouldUseBreakoutFix ? (0, $3Zyfb.shouldExtensionBreakout)({
        layout: layout,
        isTopLevelNode: isTopLevelNode,
        editorAppearance: editorAppearance
    }) : legacyShouldBreakout;
    // We don't want to show border for non-empty 1p bodied extensions in live pages
    const show1PBodiedExtensionBorder = showUpdatedLivePages1PBodiedExtensionUI ? (0, $5wrbt.isEmptyBodiedMacro)(node) : true;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-container', 'block', shadowClassNames, {
        'with-overlay': !hasBody && !showMacroInteractionDesignUpdates,
        'with-bodied-border': showMacroInteractionDesignUpdates && (hasBody || isLegacyContentMacroExtension(node)) && !showBodiedExtensionRendererView && show1PBodiedExtensionBorder,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'without-frame': removeBorder,
        [(0, $jY6Lt.widerLayoutClassName)]: shouldBreakout
    });
    const overflowClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-overflow-wrapper', {
        'with-body': hasBody,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        // Adding extra padding for renderer view so users can have a touch target to click on the extension
        'with-padding-styles': showMacroInteractionDesignUpdates && showBodiedExtensionRendererView
    });
    const headerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'with-children': hasChildren,
        'without-frame': removeBorder
    });
    const newContentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'with-padding-styles': showMacroInteractionDesignUpdates,
        'with-bodied-padding-styles': hasBody && showMacroInteractionDesignUpdates
    });
    const contentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-content', 'block', {
        'remove-border': showMacroInteractionDesignUpdates,
        'hide-content': showBodiedExtensionRendererView
    });
    let customContainerStyles = {
        width: '100%'
    };
    let newContentStyles = {};
    if (shouldBreakout) {
        // type is destructured so that breakout styles does not include it
        const { type: _type, ...breakoutStyles } = (0, $fJNzZ.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateWidth: widthState.width,
            widthStateLineLength: widthState.lineLength
        });
        newContentStyles = {
            ...breakoutStyles
        };
        customContainerStyles = breakoutStyles;
    }
    newContentStyles = {
        ...newContentStyles,
        ...(0, $jY6Lt.contentWrapper)
    };
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, !showLegacyContentHeader && showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: hasBody || isLegacyContentMacroExtension(node),
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-container",
        ref: handleRef,
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $jY6Lt.wrapperStyleInheritedCursor),
            showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $8b68c835fd1c0f68$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-overflow-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: overflowClassNames,
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jY6Lt.overflowWrapperStyles),
            (0, $dh538.fg)('platform_fix_macro_renders_in_layouts') && $8b68c835fd1c0f68$var$containerStyle
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: 'extension-overlay',
        css: (0, $mBi3D.overlay)
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jY6Lt.header),
        contentEditable: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: headerClassNames
    }, !removeBorder && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    }), children), hasBody && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: newContentStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: newContentClassNames,
        "data-testid": "extension-new-content"
    }, !shouldHideInLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-content",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jY6Lt.extensionContent),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: contentClassNames
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: handleContentDOMRef
    }))))));
}
const $8b68c835fd1c0f68$var$Extension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { lineLength: lineLength, width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width ?? 0,
            lineLength: states.widthState?.lineLength
        }));
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $9K4OG.jsx)($8b68c835fd1c0f68$var$ExtensionWithPluginState, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        widthState: {
            width: width ?? 0,
            lineLength: lineLength
        },
        ...props
    });
};
const $8b68c835fd1c0f68$var$_default_1 = (0, $frt7o.default)($8b68c835fd1c0f68$var$Extension, {
    overflowSelector: '.extension-overflow-wrapper'
});
var $8b68c835fd1c0f68$export$2e2bcd8739ae039 = $8b68c835fd1c0f68$var$_default_1;
module.exports["default"] = $8b68c835fd1c0f68$export$2e2bcd8739ae039;

});

parcelRegister("3Zyfb", function(module, exports) {
const $447f0fbfb2a8ec9b$var$breakoutLayouts = new Set([
    'full-width',
    'wide'
]);
const $447f0fbfb2a8ec9b$var$shouldRespectBreakoutForAppearance = (appearance)=>{
    if (!appearance) return true;
    if (appearance === 'full-width') return false;
    if (appearance === 'max') return false;
    return true;
};
const $447f0fbfb2a8ec9b$export$85b54d274949f309 = ({ layout: layout, isTopLevelNode: isTopLevelNode = true, editorAppearance: editorAppearance })=>{
    if (!layout || !$447f0fbfb2a8ec9b$var$breakoutLayouts.has(layout)) return false;
    if (!isTopLevelNode) return false;
    return $447f0fbfb2a8ec9b$var$shouldRespectBreakoutForAppearance(editorAppearance);
};
module.exports["shouldExtensionBreakout"] = $447f0fbfb2a8ec9b$export$85b54d274949f309;

});

parcelRegister("klDBQ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $21PP6 = parcelRequire("21PP6");


var $mBi3D = parcelRequire("mBi3D");


var $gSgoy = parcelRequire("gSgoy");

class $74e650406d32bf0b$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { node: node, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = this.props;
        const imageData = (0, $21PP6.getExtensionLozengeData)({
            node: node,
            type: 'image'
        });
        if (!showMacroInteractionDesignUpdates && imageData && node.type.name !== 'extension') return this.renderImage(imageData);
        const iconData = (0, $21PP6.getExtensionLozengeData)({
            node: node,
            type: 'icon'
        });
        return this.renderFallback(iconData);
    }
    constructor(...args){
        super(...args);
        this.renderImage = (lozengeData)=>{
            const { extensionKey: extensionKey } = this.props.node.attrs;
            const { url: url, ...rest } = lozengeData;
            // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
                css: (0, $mBi3D.styledImage),
                src: url,
                ...rest,
                alt: extensionKey
            });
        };
        this.renderFallback = (lozengeData)=>{
            const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi } = this.props;
            const { parameters: parameters, extensionKey: extensionKey } = this.props.node.attrs;
            const { name: name } = this.props.node.type;
            const params = parameters && parameters.macroParams;
            const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gSgoy.LozengeComponent), {
                isNodeHovered: isNodeHovered,
                isNodeSelected: isNodeSelected,
                isNodeNested: isNodeNested,
                showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
                extensionName: name,
                lozengeData: lozengeData,
                params: params,
                title: title,
                renderImage: this.renderImage,
                customContainerStyles: customContainerStyles,
                setIsNodeHovered: setIsNodeHovered,
                isBodiedMacro: isBodiedMacro,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                pluginInjectionApi: pluginInjectionApi
            });
        };
    }
}
module.exports["default"] = $74e650406d32bf0b$export$2e2bcd8739ae039;

});

parcelRegister("mBi3D", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $b9c5aa0c0db479ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b9c5aa0c0db479ff$export$2c23939c304dcbb6 = {
    name: "1st3gh2",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-small, 3px);position:relative;vertical-align:middle;&.with-overlay{.extension-overlay{background:var(--ds-background-neutral-hovered, #0B120E24);color:transparent;}&:hover .extension-overlay{opacity:1;}}"
};
const $b9c5aa0c0db479ff$export$29dd17c7f3c81c36 = {
    name: "7geot",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;top:0;left:0"
};
const $b9c5aa0c0db479ff$export$f61e107d01719381 = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`
    },
    /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */ /* stylelint-disable-next-line */ label: 'placeholder-fallback'
});
const $b9c5aa0c0db479ff$export$baa8de7b590bf812 = {
    name: "147iacu",
    styles: "display:inline-block;max-width:200px;margin-left:var(--ds-space-050, 4px);color:var(--ds-text-subtlest, #6B6E76);text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
const $b9c5aa0c0db479ff$export$83cb1da155637959 = {
    name: "1ib9bih-lozenge-image",
    styles: "max-height:16px;max-width:16px;label:lozenge-image"
};
module.exports["wrapperDefault"] = $b9c5aa0c0db479ff$export$2c23939c304dcbb6;
module.exports["overlay"] = $b9c5aa0c0db479ff$export$29dd17c7f3c81c36;
module.exports["placeholderFallback"] = $b9c5aa0c0db479ff$export$f61e107d01719381;
module.exports["placeholderFallbackParams"] = $b9c5aa0c0db479ff$export$baa8de7b590bf812;
module.exports["styledImage"] = $b9c5aa0c0db479ff$export$83cb1da155637959;

});

parcelRegister("gSgoy", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $chO1Z = parcelRequire("chO1Z");


var $mBi3D = parcelRequire("mBi3D");


var $lFpYn = parcelRequire("lFpYn");


var $3owB7 = parcelRequire("3owB7");

const $f12893e761db125d$export$91a15f1424900d33 = 24;
const $f12893e761db125d$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $f12893e761db125d$export$14bad8182dc08b5a = ({ lozengeData: lozengeData, extensionName: extensionName, title: title, params: params, renderImage: renderImage, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, customContainerStyles: customContainerStyles, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi })=>{
    const capitalizedTitle = $f12893e761db125d$var$capitalizeFirstLetter(title);
    if (showMacroInteractionDesignUpdates) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3owB7.ExtensionLabel), {
        text: capitalizedTitle,
        extensionName: extensionName,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: isBodiedMacro,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), showLivePagesBodiedMacrosRendererView && isBodiedMacro && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lFpYn.EditToggle), {
        isNodeHovered: isNodeHovered,
        setIsNodeHovered: setIsNodeHovered,
        customContainerStyles: customContainerStyles,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    }));
    const isBlockExtension = extensionName === 'extension';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "lozenge-fallback",
        css: (0, $mBi3D.placeholderFallback)
    }, lozengeData && !isBlockExtension ? renderImage({
        height: $f12893e761db125d$export$91a15f1424900d33,
        width: $f12893e761db125d$export$91a15f1424900d33,
        ...lozengeData
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: title
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        className: "extension-title"
    }, capitalizedTitle), params && !isBlockExtension && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $mBi3D.placeholderFallbackParams)
    }, Object.keys(params).map((key)=>key && ` | ${key} = ${params[key].value}`))));
};
module.exports["LozengeComponent"] = $f12893e761db125d$export$14bad8182dc08b5a;

});

parcelRegister("lFpYn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $cvXh8 = parcelRequire("cvXh8");


var $1Zr9M = parcelRequire("1Zr9M");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");

function $6d2e29ce63723d2b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d2e29ce63723d2b$var$buttonContainerStyles = {
    name: "cy6p8l",
    styles: "opacity:0;line-height:1;position:absolute;width:max-content;top:-28px;display:inline-flex;justify-content:flex-end;color:var(--ds-text-subtle, #505258)"
};
const $6d2e29ce63723d2b$var$buttonStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
    minHeight: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingLeft: "var(--ds-space-150, 12px)",
    paddingRight: "var(--ds-space-150, 12px)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    '&:hover': {
        backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
    },
    outlineColor: "var(--ds-border-focused, #4688EC)",
    border: 'none',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    color: "var(--ds-text-subtle, #505258)"
});
const $6d2e29ce63723d2b$var$showButtonContainerStyle = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $6d2e29ce63723d2b$var$iconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $6d2e29ce63723d2b$var$i18n = (0, $aXWIB.defineMessages)({
    doneEditing: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.done.editing",
        defaultMessage: "Done editing"
    },
    makeEdits: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.make.edits",
        defaultMessage: "Make edits"
    }
});
const $6d2e29ce63723d2b$export$2ada5dce8cd41705 = ({ isNodeHovered: isNodeHovered, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView })=>{
    const intl = (0, $aXWIB.useIntl)();
    const text = showBodiedExtensionRendererView ? intl.formatMessage($6d2e29ce63723d2b$var$i18n.makeEdits) : intl.formatMessage($6d2e29ce63723d2b$var$i18n.doneEditing);
    const icon = showBodiedExtensionRendererView ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        testId: "edit-icon",
        label: ""
    }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        testId: "check-mark-icon",
        label: ""
    });
    const handleClick = (0, $42omo.useCallback)(()=>{
        setShowBodiedExtensionRendererView?.(!showBodiedExtensionRendererView);
    }, [
        showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') handleClick();
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "extension-edit-toggle-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: [
            $6d2e29ce63723d2b$var$buttonContainerStyles,
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? null : isNodeHovered && $6d2e29ce63723d2b$var$showButtonContainerStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle-container",
        onMouseOver: ()=>setIsNodeHovered?.(true),
        // @atlassian/a11y/mouse-events-have-key-events: keyboard focus is already handled by the
        // inner <button>'s onFocus/onBlur. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>setIsNodeHovered?.(false),
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        type: "button",
        "data-testid": "edit-toggle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $6d2e29ce63723d2b$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle",
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        onFocus: ()=>setIsNodeHovered?.(true),
        onBlur: ()=>setIsNodeHovered?.(false)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bUlM5.default), {
        as: "span",
        xcss: $6d2e29ce63723d2b$var$iconStyles
    }, icon), text));
};
module.exports["EditToggle"] = $6d2e29ce63723d2b$export$2ada5dce8cd41705;

});

parcelRegister("3owB7", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aXWIB = parcelRequire("aXWIB");


var $isYda = parcelRequire("isYda");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $3gadb = parcelRequire("3gadb");

function $55e0171fddd47a60$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $55e0171fddd47a60$var$containerStyles = {
    name: "1xnw70r",
    styles: "text-align:left;z-index:1;position:relative;&.bodied{margin-top:var(--ds-space-300, 24px);}"
};
const $55e0171fddd47a60$var$showLabelStyles = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $55e0171fddd47a60$var$hideLabelStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $55e0171fddd47a60$var$labelStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    display: 'inline-flex',
    justifyContent: 'left',
    position: 'absolute',
    width: 'max-content',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '-28px',
    // When updating this value, make sure to also update the value in EditToggle.tsx, buttonContainerStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.show-label': {
        cursor: 'pointer',
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.nested': {
        // Need to add indent if the node is nested since we removed previous indentation styles to make it fit properly
        // in the nested component
        marginLeft: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.inline': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '-27px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-background': {
        background: "var(--ds-surface, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    minHeight: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    borderRadius: "var(--ds-radius-small, 3px)",
    paddingLeft: "var(--ds-space-100, 8px)",
    paddingRight: "var(--ds-space-100, 8px)",
    color: "var(--ds-text-subtle, #505258)",
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-left-margin': {
        marginLeft: "var(--ds-space-negative-150, -12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-nested-left-margin': {
        marginLeft: 0
    },
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-macro-live-page-styles': {
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $55e0171fddd47a60$var$spacerStyles = (0, $ecnYn.xcss)({
    height: 'space.200',
    position: 'absolute',
    width: '100%'
});
const $55e0171fddd47a60$var$iconStyles = {
    name: "1s9vzwe",
    styles: "margin-left:var(--ds-space-075, 6px);&.hide-icon{display:none;}"
};
const $55e0171fddd47a60$var$bodiedMacroIconStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $55e0171fddd47a60$var$i18n = (0, $aXWIB.defineMessages)({
    configure: {
        id: "editor-common-extensibility.macro.button.configure",
        defaultMessage: "Configure {macroName}"
    }
});
const $55e0171fddd47a60$export$b91fdbabc60200d0 = (isBodiedMacro, isNodeHovered, showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView, showUpdatedLivePages1PBodiedExtensionUI)=>{
    // Bodied macros show the label by default except for the new live pages 1P bodied macro experience where we only show it on hover
    if (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI) return isNodeHovered;
    if (!showLivePagesBodiedMacrosRendererView) return true;
     // Keep showing labels as usual for default experience for bodied macros
    return !!(isNodeHovered && !showBodiedExtensionRendererView); // For the new live pages bodied macro experience, we only show the label on hover in the "edit" view
};
const $55e0171fddd47a60$export$addedb5f7f03bdb1 = ({ text: text, extensionName: extensionName, isNodeHovered: isNodeHovered, customContainerStyles: customContainerStyles, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, pluginInjectionApi: _pluginInjectionApi })=>{
    const isInlineExtension = extensionName === 'inlineExtension';
    const showDefaultBodiedStyles = (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'isEnabled', true) ? isBodiedMacro : isBodiedMacro && !isNodeHovered;
    const shouldShowBodiedMacroLabel = $55e0171fddd47a60$export$b91fdbabc60200d0(isBodiedMacro, isNodeHovered, showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView, showUpdatedLivePages1PBodiedExtensionUI);
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        bodied: isBodiedMacro
    });
    const labelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-label', {
        nested: isNodeNested,
        inline: isInlineExtension,
        bodied: isBodiedMacro,
        'bodied-border': showDefaultBodiedStyles,
        'bodied-background': showDefaultBodiedStyles,
        'show-label': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : shouldShowBodiedMacroLabel,
        'with-bodied-macro-live-page-styles': isBodiedMacro && showLivePagesBodiedMacrosRendererView,
        'always-hide-label': isBodiedMacro && showBodiedExtensionRendererView,
        // Need this separate class since we don't ever want to show the label during view mode
        'remove-left-margin': !isBodiedMacro && !isInlineExtension && !isNodeNested,
        'remove-nested-left-margin': isNodeNested && !isBodiedMacro && !isInlineExtension
    });
    const iconClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'hide-icon': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : isBodiedMacro && !isNodeHovered,
        'extension-icon': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true)
    });
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $55e0171fddd47a60$var$containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseOver: ()=>{
            setIsNodeHovered?.(true);
        },
        // @atlassian/a11y/mouse-events-have-key-events: label visibility on keyboard focus is already
        // handled via the .ak-editor-selected-node CSS class applied by ProseMirror on node selection.
        // No-ops here satisfy the rule.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>{
            setIsNodeHovered?.(false);
        },
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        "data-testid": "new-lozenge-container",
        contentEditable: false
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aXWIB.FormattedMessage), {
            ...$55e0171fddd47a60$var$i18n.configure,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            values: {
                macroName: text
            }
        }),
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            "data-testid": "new-lozenge-button",
            ...tooltipProps,
            css: [
                $55e0171fddd47a60$var$labelStyles,
                ...(0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? [
                    !showLivePagesBodiedMacrosRendererView && $55e0171fddd47a60$var$showLabelStyles,
                    (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI) && $55e0171fddd47a60$var$hideLabelStyles
                ] : []
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: labelClassNames
        }, text, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: [
                $55e0171fddd47a60$var$iconStyles,
                isBodiedMacro && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $55e0171fddd47a60$var$bodiedMacroIconStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: iconClassNames,
            "data-testid": "config-icon"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
            label: ""
        })))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $55e0171fddd47a60$var$spacerStyles
    })));
};
module.exports["ExtensionLabel"] = $55e0171fddd47a60$export$addedb5f7f03bdb1;

});

parcelRegister("5wrbt", function(module, exports) {
const $fafa73a8db5dffb3$export$d01da3229dfc693b = (node)=>{
    if (node.type.name !== 'bodiedExtension') return false;
    const firstChildNode = node?.content?.firstChild;
    const firstGrandChildNode = firstChildNode?.firstChild;
    // If firstChildNode?.childCount > 1 means there is content along with the placeholder.
    const isEmptyWithPlacholder = firstGrandChildNode?.type?.name === 'placeholder' && firstChildNode?.childCount === 1;
    const isEmptyWithNoContent = !firstGrandChildNode && node.childCount === 1;
    return isEmptyWithPlacholder || isEmptyWithNoContent;
};
module.exports["isEmptyBodiedMacro"] = $fafa73a8db5dffb3$export$d01da3229dfc693b;

});

parcelRegister("jY6Lt", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

const $9c8e1848f6b0636a$export$c51f29288b3ec9db = 'wider-layout';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $9c8e1848f6b0636a$var$wrapperStyleWithoutCursor = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        background: 'transparent'
    },
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.extension-overflow-wrapper:not(.with-body)': {
        overflowX: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`,
        padding: `0 ${"var(--ds-space-250, 20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.legacy-content': {
        borderRadius: `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}`
    }
});
const $9c8e1848f6b0636a$export$ebf956b2dea5bd2e = /*#__PURE__*/ (0, $9K4OG.css)($9c8e1848f6b0636a$var$wrapperStyleWithoutCursor, ".extension-overflow-wrapper:has(.extension-editable-area){cursor:inherit;}.extension-overflow-wrapper:not(:has(.extension-editable-area)){cursor:pointer;}");
const $9c8e1848f6b0636a$export$38e42c68cf43b5d4 = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&.with-children:not(.without-frame)': {
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        padding: 0
    }
});
const $9c8e1848f6b0636a$export$a7db06668cad9adb = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $9c8e1848f6b0636a$export$16dcf8c62f81d973 = /*#__PURE__*/ (0, $9K4OG.css)({
    boxSizing: 'border-box',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $9c8e1848f6b0636a$export$2a82ddc22e8c7fbb = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-padding-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` // account for upcoming editor elements drag & drop feature
    }
});
const $9c8e1848f6b0636a$export$2ab74686abf0084 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    }
});
module.exports["widerLayoutClassName"] = $9c8e1848f6b0636a$export$c51f29288b3ec9db;
module.exports["wrapperStyleInheritedCursor"] = $9c8e1848f6b0636a$export$ebf956b2dea5bd2e;
module.exports["header"] = $9c8e1848f6b0636a$export$38e42c68cf43b5d4;
module.exports["extensionContent"] = $9c8e1848f6b0636a$export$16dcf8c62f81d973;
module.exports["contentWrapper"] = $9c8e1848f6b0636a$export$2a82ddc22e8c7fbb;
module.exports["overflowWrapperStyles"] = $9c8e1848f6b0636a$export$2ab74686abf0084;

});

parcelRegister("aAiMR", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $eiA8Z = parcelRequire("eiA8Z");


var $bWRlG = parcelRequire("bWRlG");


var $klDBQ = parcelRequire("klDBQ");


var $mBi3D = parcelRequire("mBi3D");


var $jZde6 = parcelRequire("jZde6");

function $b04b056b17bd0ca9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b04b056b17bd0ca9$var$inlineWrapperStyles = {
    name: "m3p6m2",
    styles: "max-width:100%;tr &{max-width:inherit;}.rich-media-item{max-width:100%;}"
};
const $b04b056b17bd0ca9$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $b04b056b17bd0ca9$var$InlineExtension = (props)=>{
    const { node: node, pluginInjectionApi: pluginInjectionApi, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, children: children, isNodeHovered: isNodeHovered, setIsNodeHovered: setIsNodeHovered, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>{
        return {
            width: states.widthState?.width
        };
    });
    const hasChildren = !!children;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('extension-container', 'inline', {
        'with-overlay': !showMacroInteractionDesignUpdates,
        'with-children': hasChildren,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered
    });
    let rendererContainerWidth = 0;
    if ((0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    })) {
        if (width) {
            const padding = width > (0, $aFUXX.akEditorFullPageNarrowBreakout) ? (0, $aFUXX.akEditorGutterPaddingDynamic)() : (0, $aFUXX.akEditorGutterPaddingReduced);
            rendererContainerWidth = width - padding * 2;
        }
    } else rendererContainerWidth = width ? width - (0, $aFUXX.akEditorGutterPaddingDynamic)() * 2 : 0;
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const inlineExtensionInternal = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        setIsNodeHovered: setIsNodeHovered,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "inline-extension-wrapper",
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $jZde6.wrapperStyle),
            $b04b056b17bd0ca9$var$inlineWrapperStyles,
            showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $b04b056b17bd0ca9$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also accessible via keyboard selection.
        // No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $mBi3D.overlay),
        className: "extension-overlay"
    }), children ? children : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    })));
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthContext).Provider, {
        value: (0, $bWRlG.createWidthContext)(rendererContainerWidth)
    }, inlineExtensionInternal);
};
var $b04b056b17bd0ca9$export$2e2bcd8739ae039 = $b04b056b17bd0ca9$var$InlineExtension;
module.exports["default"] = $b04b056b17bd0ca9$export$2e2bcd8739ae039;

});

parcelRegister("jZde6", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

const $d1d88cc5ea760762$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    cursor: 'pointer',
    display: 'inline-flex',
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> img': {
        borderRadius: "var(--ds-radius-small, 3px)"
    },
    '&::after, &::before': {
        verticalAlign: 'text-top',
        display: 'inline-block',
        content: "''"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-children': {
        padding: 0,
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
module.exports["wrapperStyle"] = $d1d88cc5ea760762$export$c4d4f06a25de97f;

});

parcelRegister("akFmj", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $chO1Z = parcelRequire("chO1Z");


var $1oCLl = parcelRequire("1oCLl");


var $eiA8Z = parcelRequire("eiA8Z");


var $dsfZn = parcelRequire("dsfZn");


var $fJNzZ = parcelRequire("fJNzZ");

var $21PP6 = parcelRequire("21PP6");


var $klDBQ = parcelRequire("klDBQ");


var $3Zyfb = parcelRequire("3Zyfb");


var $gC39r = parcelRequire("gC39r");


var $7OgWk = parcelRequire("7OgWk");

function $d51e9fd51004e891$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d51e9fd51004e891$var$getContainerCssExtendedStyles = (activeChildIndex, showMacroInteractionDesignUpdates)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9K4OG.css)((0, $dsfZn.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1})`]: /*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $dsfZn.sharedMultiBodiedExtensionStyles).extensionFrameContent, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        showMacroInteractionDesignUpdates && (0, $dsfZn.removeMarginsAndBorder))
    });
const $d51e9fd51004e891$var$imageStyles = {
    name: "yadgg9",
    styles: "max-height:24px;max-width:24px"
};
const $d51e9fd51004e891$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $d51e9fd51004e891$var$MultiBodiedExtensionFrames = ({ articleRef: articleRef })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("article", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--frames",
        "data-testid": "multiBodiedExtension--frames",
        ref: articleRef
    });
};
// Similar to the one in platform/packages/editor/editor-common/src/extensibility/Extension/Lozenge.tsx
const $d51e9fd51004e891$var$getWrapperTitleContent = (imageData, title, showMacroInteractionDesignUpdates)=>{
    if (showMacroInteractionDesignUpdates) return null;
    if (imageData) {
        const { url: url, ...rest } = imageData;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            className: "extension-title"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
            css: $d51e9fd51004e891$var$imageStyles,
            src: url,
            ...rest,
            alt: title
        }), title));
    }
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-title",
        "data-testid": 'multiBodiedExtension-default-lozenge'
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: title
    }), title);
};
const $d51e9fd51004e891$var$MultiBodiedExtensionWithWidth = ({ node: node, handleContentDOMRef: handleContentDOMRef, getPos: getPos, tryExtensionHandler: tryExtensionHandler, editorView: editorView, eventDispatcher: eventDispatcher, widthState: widthState, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode, allowBodiedOverride: allowBodiedOverride = false })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { parameters: parameters, extensionKey: extensionKey } = node.attrs;
    const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey || node.type.name;
    const imageData = (0, $21PP6.getExtensionLozengeData)({
        node: node,
        type: 'image'
    });
    const [activeChildIndex, setActiveChildIndex] = (0, $42omo.useState)(0);
    // Adding to avoid aliasing `this` for the callbacks
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((index)=>{
        if (typeof index !== 'number') {
            setActiveChildIndex(0);
            throw new Error('Index is not valid');
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const articleRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        return handleContentDOMRef(node);
    }, [
        handleContentDOMRef
    ]);
    const childrenContainer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return /*#__PURE__*/ (0, $9K4OG.jsx)($d51e9fd51004e891$var$MultiBodiedExtensionFrames, {
            articleRef: articleRef
        });
    }, [
        articleRef
    ]);
    const actions = (0, $gC39r.useMultiBodiedExtensionActions)({
        updateActiveChild: updateActiveChild,
        editorView: editorView,
        getPos: getPos,
        node: node,
        eventDispatcher: eventDispatcher,
        allowBodiedOverride: allowBodiedOverride,
        childrenContainer: childrenContainer
    });
    const extensionHandlerResult = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return tryExtensionHandler(actions);
    }, [
        tryExtensionHandler,
        actions
    ]);
    const layout = node.attrs.layout;
    const legacyShouldBreakout = [
        'full-width',
        'wide'
    ].includes(layout) && editorAppearance !== 'full-width';
    const tinymceFullWidthModeEnabled = (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true);
    const breakoutExtensionFixEnabled = (0, $1oCLl.expValEquals)('confluence_max_width_breakout_extension_fix', 'isEnabled', true);
    const shouldUseBreakoutFix = tinymceFullWidthModeEnabled && breakoutExtensionFixEnabled;
    const shouldBreakout = shouldUseBreakoutFix ? (0, $3Zyfb.shouldExtensionBreakout)({
        layout: layout,
        editorAppearance: editorAppearance,
        isTopLevelNode: true
    }) : legacyShouldBreakout;
    let mbeWrapperStyles = {};
    if (shouldBreakout) {
        const { ...breakoutStyles } = (0, $fJNzZ.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateLineLength: widthState?.lineLength,
            widthStateWidth: widthState?.width
        });
        mbeWrapperStyles = breakoutStyles;
    }
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--wrapper', 'extension-container', 'block', {
        'with-border': showMacroInteractionDesignUpdates,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-padding-background-styles': showMacroInteractionDesignUpdates,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested,
        'with-hover-border': (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) ? false : showMacroInteractionDesignUpdates && isNodeHovered
    });
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--container', {
        'remove-padding': showMacroInteractionDesignUpdates
    });
    const bodyContainerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--body-container');
    const navigationClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--navigation', {
        'remove-margins': showMacroInteractionDesignUpdates,
        'remove-border': showMacroInteractionDesignUpdates
    });
    const overlayClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('multiBodiedExtension--overlay', {
        'with-margin': showMacroInteractionDesignUpdates
    });
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $klDBQ.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: true,
        customContainerStyles: mbeWrapperStyles,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: true,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassNames,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $7OgWk.mbeExtensionWrapperCSSStyles),
            showMacroInteractionDesignUpdates && !isLivePageViewMode && (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $d51e9fd51004e891$var$hoverStyles
        ],
        "data-testid": "multiBodiedExtension--wrapper-editor",
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mbeWrapperStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $7OgWk.overlayStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: overlayClassNames,
        "data-testid": "multiBodiedExtension--overlay"
    }), $d51e9fd51004e891$var$getWrapperTitleContent(imageData, title, showMacroInteractionDesignUpdates), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $d51e9fd51004e891$var$getContainerCssExtendedStyles(activeChildIndex, showMacroInteractionDesignUpdates),
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex
    }, allowBodiedOverride ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: bodyContainerClassNames,
        "data-testid": "multiBodiedExtension--body-container"
    }, extensionHandlerResult) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)("nav", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: navigationClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $dsfZn.sharedMultiBodiedExtensionStyles).mbeNavigation,
        "data-testid": "multiBodiedExtension-navigation"
    }, extensionHandlerResult), childrenContainer))));
};
const $d51e9fd51004e891$var$MultiBodiedExtension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { width: width, lineLength: lineLength } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width,
            lineLength: states.widthState?.lineLength
        }));
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $9K4OG.jsx)($d51e9fd51004e891$var$MultiBodiedExtensionWithWidth, {
        widthState: width === undefined ? undefined : {
            width: width,
            lineLength: lineLength
        },
        ...props
    });
};
var $d51e9fd51004e891$export$2e2bcd8739ae039 = $d51e9fd51004e891$var$MultiBodiedExtension;
module.exports["default"] = $d51e9fd51004e891$export$2e2bcd8739ae039;

});

parcelRegister("dsfZn", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $a6eef6e1b2d41e58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a6eef6e1b2d41e58$var$mbeExtensionContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a6eef6e1b2d41e58$var$mbeNavigation = {
    name: "1a47qx2",
    styles: "border-top-left-radius:var(--ds-radius-small, 3px);border-top-right-radius:var(--ds-radius-small, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, #FFFFFF);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a6eef6e1b2d41e58$var$extensionFrameContent = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a6eef6e1b2d41e58$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a6eef6e1b2d41e58$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a6eef6e1b2d41e58$var$mbeExtensionContainer,
    mbeNavigation: $a6eef6e1b2d41e58$var$mbeNavigation,
    extensionFrameContent: $a6eef6e1b2d41e58$var$extensionFrameContent
};
module.exports["removeMarginsAndBorder"] = $a6eef6e1b2d41e58$export$8df0393dc2d5d656;
module.exports["sharedMultiBodiedExtensionStyles"] = $a6eef6e1b2d41e58$export$9c7196ca47f67390;

});

parcelRegister("gC39r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ks2lK = parcelRequire("ks2lK");


var $d925B = parcelRequire("d925B");


var $lWHWf = parcelRequire("lWHWf");

const $9ffc27468419e619$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            changeActive (index) {
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                // On selection of a childFrame, we need to change the focus/selection to the end of the target child Frame
                const pos = getPos();
                if (typeof pos !== 'number') return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                let desiredPos = pos;
                if (possiblyMbeNode && possiblyMbeNode?.type?.name === 'multiBodiedExtension' && possiblyMbeNode?.content) {
                    if (index < 0 || index >= possiblyMbeNode?.content?.childCount) throw new Error(`Index out of bounds: valid range is 0-${possiblyMbeNode?.content?.childCount - 1} inclusive`);
                    for(let i = 0; i <= index && i < possiblyMbeNode?.content?.childCount; i++)desiredPos += possiblyMbeNode?.content?.child(i)?.nodeSize || 0;
                    /* desiredPos gives the cursor at the end of last child of the current frame, in case of paragraph nodes, this will be the end of the paragraph
					 * Performing -1 brings the cursor inside the paragraph, similar to a user click, so any pasted text will be inside the last paragraph rather than a new line
					 */ dispatch(state.tr.setSelection(new (0, $ks2lK.TextSelection)(state.doc.resolve(desiredPos - 1))));
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state, dispatch: dispatch } = editorView;
                const p = state.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error('Could not create paragraph');
                const frame = state.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos = getPos();
                if (typeof pos !== 'number' || !frame) throw new Error('Could not create frame or position not valid');
                const insertAt = Math.min((pos || 1) + node.content.size, state.doc.content.size);
                const tr = state.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index) {
                const pos = getPos();
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Add child index validation here, don't trust this data
                if (typeof pos !== 'number' || typeof index !== 'number') throw new Error('Position or index not valid');
                const { state: state, dispatch: dispatch } = editorView;
                if (node.content.childCount === 1) {
                    const tr = state.tr;
                    tr.deleteRange(pos, pos + node.content.size);
                    dispatch(tr);
                    return true;
                }
                const $pos = state.doc.resolve(pos);
                const $startNodePos = state.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index);
                const maybeFrameNode = state.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error('Could not find frame node');
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr = state.tr;
                tr.deleteRange(startFramePosition, endFramePosition);
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            updateParameters (parameters) {
                const { state: state, dispatch: dispatch } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') throw new Error('Position not valid');
                // We are retaining node.attrs to keep the node type and extension key
                // and only updating the parameters coming in from the user
                // parameters will contain only macroParams information
                const updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        macroParams: parameters
                    }
                };
                const tr = state.tr.setNodeMarkup(pos, null, updatedParameters);
                dispatch(tr);
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).UPDATE_PARAMETERS, node, eventDispatcher);
                return true;
            },
            getChildren () {
                const { state: state } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') return [];
                const children = state.doc.nodeAt(pos)?.content;
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).GET_CHILDREN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            },
            getChildrenContainer () {
                if (!allowBodiedOverride) throw new Error('Could not provide children container');
                if (eventDispatcher) (0, $lWHWf.sendMBEAnalyticsEvent)((0, $d925B.ACTION).GET_CHILDREN_CONTAINER, node, eventDispatcher);
                return childrenContainer;
            }
        };
    }, [
        node,
        editorView,
        getPos,
        updateActiveChild,
        eventDispatcher,
        allowBodiedOverride,
        childrenContainer
    ]);
    return actions;
};
module.exports["useMultiBodiedExtensionActions"] = $9ffc27468419e619$export$3c7139d93ecb4f1f;

});

parcelRegister("lWHWf", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $lWghV = parcelRequire("lWghV");

const $71ab275aa2a7d41a$export$c39676f5ca8bcb0e = (action, node, eventDispatcher)=>{
    const analyticsDispatch = (0, $5vVM5.createDispatch)(eventDispatcher);
    analyticsDispatch((0, $lWghV.analyticsEventKey), {
        payload: {
            action: action,
            actionSubject: (0, $d925B.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                currentFramesCount: node.content.childCount
            }
        }
    });
};
module.exports["sendMBEAnalyticsEvent"] = $71ab275aa2a7d41a$export$c39676f5ca8bcb0e;

});

parcelRegister("7OgWk", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $mBi3D = parcelRequire("mBi3D");

function $3f1e3a768037ae22$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3f1e3a768037ae22$export$4226a1fc882c4ef9 = /*#__PURE__*/ (0, $9K4OG.css)((0, $mBi3D.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: 0,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $3f1e3a768037ae22$export$9b0df2896b2eff02 = {
    name: "1jgeuox",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin:var(--ds-space-negative-100, -8px);}"
};
module.exports["mbeExtensionWrapperCSSStyles"] = $3f1e3a768037ae22$export$4226a1fc882c4ef9;
module.exports["overlayStyles"] = $3f1e3a768037ae22$export$9b0df2896b2eff02;

});

parcelRegister("3oRlx", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2daQU = parcelRequire("2daQU");


var $1oCLl = parcelRequire("1oCLl");


var $TfRUG = parcelRequire("TfRUG");

function $a1dfc4182694ae4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a1dfc4182694ae4d$var$styles = {
    name: "4s3kp2",
    styles: "&.inline-extension{display:inline-block;}&.relative{position:relative;}"
};
const $a1dfc4182694ae4d$var$hoverStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-container, :has(.extension-edit-toggle-container:hover) .extension-container': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-container:hover) .extension-label, :has(.extension-edit-toggle-container:hover) .extension-label, .extension-label:hover': {
        opacity: 1,
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        boxShadow: 'none',
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.always-hide-label': {
            opacity: 0,
            cursor: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.with-bodied-macro-live-page-styles': {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-icon, :has(.extension-container:hover) .extension-icon, :has(.extension-edit-toggle-container:hover) .extension-icon': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-edit-toggle-container, :has(.extension-container:hover) .extension-edit-toggle-container, .extension-edit-toggle-container:hover': {
        opacity: 1
    }
});
const $a1dfc4182694ae4d$export$f97fc055ac075140 = ({ children: children, nodeType: nodeType, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
        'inline-extension': nodeType === 'inlineExtension' && showMacroInteractionDesignUpdates,
        relative: showMacroInteractionDesignUpdates
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "data-testId": "extension-node-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: wrapperClassNames,
        css: [
            $a1dfc4182694ae4d$var$styles,
            (0, $1oCLl.expValEquals)('cc_editor_ttvc_release_bundle_one', 'extensionHoverRefactor', true) && $a1dfc4182694ae4d$var$hoverStyles
        ]
    }, children, nodeType === 'inlineExtension' && (0, $TfRUG.ZERO_WIDTH_SPACE));
};
module.exports["ExtensionNodeWrapper"] = $a1dfc4182694ae4d$export$f97fc055ac075140;

});

parcelRegister("8y1DS", function(module, exports) {

let $6392c5cf93d8a552$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6392c5cf93d8a552$var$load("eFHVS").then(()=>parcelRequire('hx1ag'));

});

parcelRegister("4eFRN", function(module, exports) {

var $heH5c = parcelRequire("heH5c");


var $iQfKE = parcelRequire("iQfKE");


var $j6kTj = parcelRequire("j6kTj");

const $2e6603bf3390fe53$var$maybeGetUpdateMethodFromExtensionProvider = async (view, extensionProvider)=>{
    const nodeWithPos = (0, $j6kTj.getSelectedExtension)(view.state, true);
    if (!nodeWithPos) throw new Error('There is no selection');
    const { extensionType: extensionType, extensionKey: extensionKey } = nodeWithPos.node.attrs;
    const extensionModuleNode = await (0, $heH5c.getExtensionModuleNode)(extensionProvider, extensionType, extensionKey);
    const newNodeWithPos = (0, $j6kTj.getSelectedExtension)(view.state, true);
    if (newNodeWithPos && newNodeWithPos.node.attrs.extensionType === extensionType && newNodeWithPos.node.attrs.extensionKey === extensionKey && newNodeWithPos.pos === nodeWithPos.pos && extensionModuleNode) return extensionModuleNode.update;
};
const $2e6603bf3390fe53$export$1e25f457f2ade11e = async (view, extensionProvider)=>{
    try {
        const updateMethod = await $2e6603bf3390fe53$var$maybeGetUpdateMethodFromExtensionProvider(view, extensionProvider);
        (0, $iQfKE.updateState)({
            showEditButton: !!updateMethod,
            updateExtension: updateMethod && Promise.resolve(updateMethod) || undefined
        })(view.state, view.dispatch);
        return updateMethod;
    } catch  {
    // this exception is not important for this case, fail silently
    }
};
module.exports["updateEditButton"] = $2e6603bf3390fe53$export$1e25f457f2ade11e;

});

parcelRegister("gbdVR", function(module, exports) {

var $4sfnB = parcelRequire("4sfnB");


var $24P9d = parcelRequire("24P9d");

const $dba54e90a92c69fe$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $dba54e90a92c69fe$export$1a85854d3d541a64 = ()=>{
    return {
        ...(0, $4sfnB.bodiedExtension),
        toDOM: (node)=>{
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId,
                style: (0, $24P9d.convertToInlineCss)({
                    position: 'relative',
                    marginTop: "var(--ds-space-300, 24px)"
                })
            };
            const title = node.attrs && node.attrs.extensionTitle || node.attrs && node.attrs.macroMetadata && node.attrs.macroMetadata.title || node.attrs.extensionKey;
            return [
                'div',
                attrs,
                [
                    'span',
                    {
                        // Styles based on `packages/editor/editor-common/src/extensibility/Extension/Lozenge/ExtensionLabel.tsx`
                        style: (0, $24P9d.convertToInlineCss)({
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            fontSize: '14px',
                            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                            color: "var(--ds-text-subtle, #505258)",
                            borderTopLeftRadius: "var(--ds-radius-small, 4px)",
                            borderTopRightRadius: "var(--ds-radius-small, 4px)",
                            lineHeight: 1,
                            position: 'absolute',
                            top: '-19px'
                        }),
                        // If we put this below inside the span then we serialise the label (which causes the label to be
                        // be copied to the clipboard causing copy-paste issues).
                        // So instead we use a pseudo-element to add the title to this class
                        'data-bodied-extension-label': $dba54e90a92c69fe$var$capitalizeFirstLetter(title),
                        class: 'bodied-extension-to-dom-label'
                    }
                ],
                [
                    'div',
                    {
                        style: (0, $24P9d.convertToInlineCss)({
                            padding: "var(--ds-space-200, 16px)",
                            marginLeft: "var(--ds-space-negative-150, -12px)",
                            marginRight: "var(--ds-space-negative-150, -12px)",
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            borderRadius: "var(--ds-radius-small, 4px)"
                        })
                    },
                    0
                ]
            ];
        }
    };
};
module.exports["bodiedExtensionSpecWithFixedToDOM"] = $dba54e90a92c69fe$export$1a85854d3d541a64;

});

parcelRegister("dXuw2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5pF33 = parcelRequire("5pF33");

var $3jQ9y = parcelRequire("3jQ9y");


var $61p3e = parcelRequire("61p3e");


var $5Ev1b = parcelRequire("5Ev1b");


var $iHzeA = parcelRequire("iHzeA");


var $5GR8v = parcelRequire("5GR8v");


var $91bcx = parcelRequire("91bcx");


var $8m4tT = parcelRequire("8m4tT");


var $3uQ0E = parcelRequire("3uQ0E");


var $kDG8M = parcelRequire("kDG8M");


var $gKvd9 = parcelRequire("gKvd9");


var $1Zr9M = parcelRequire("1Zr9M");


var $gzsfl = parcelRequire("gzsfl");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $cXuuT = parcelRequire("cXuuT");


var $iQfKE = parcelRequire("iQfKE");


var $gdgqN = parcelRequire("gdgqN");


var $liMF6 = parcelRequire("liMF6");


var $j6kTj = parcelRequire("j6kTj");

// non-bodied extensions nested inside panels, blockquotes and lists do not support layouts
const $cbbd6680b3b391a3$var$isNestedNBM = (state, selectedExtNode)=>{
    const { schema: { nodes: { extension: extension, panel: panel, blockquote: blockquote, listItem: listItem } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    return selectedExtNode.node.type === extension && (0, $8m4tT.hasParentNodeOfType)([
        panel,
        blockquote,
        listItem
    ].filter(Boolean))(selection);
};
const $cbbd6680b3b391a3$var$isLayoutSupported = (state, selectedExtNode)=>{
    const { schema: { nodes: { bodiedExtension: bodiedExtension, extension: extension, layoutSection: layoutSection, table: table, expand: expand, multiBodiedExtension: multiBodiedExtension } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    const isMultiBodiedExtension = selectedExtNode.node.type === multiBodiedExtension;
    const isNonEmbeddedBodiedExtension = selectedExtNode.node.type === bodiedExtension && !(0, $8m4tT.hasParentNodeOfType)([
        multiBodiedExtension
    ].filter(Boolean))(selection);
    const isNonEmbeddedExtension = selectedExtNode.node.type === extension && !(0, $8m4tT.hasParentNodeOfType)([
        bodiedExtension,
        table,
        expand,
        multiBodiedExtension
    ].filter(Boolean))(selection);
    // if selection belongs to layout supported extension category
    // and not inside a layoutSection
    return !!((isMultiBodiedExtension || isNonEmbeddedBodiedExtension || isNonEmbeddedExtension) && !(0, $8m4tT.hasParentNodeOfType)([
        layoutSection
    ])(selection));
};
const $cbbd6680b3b391a3$var$breakoutButtonListOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $j6kTj.getSelectedExtension)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (nodeWithPos && breakoutEnabled && $cbbd6680b3b391a3$var$isLayoutSupported(state, nodeWithPos) && !$cbbd6680b3b391a3$var$isNestedNBM(state, nodeWithPos)) {
        const { layout: layout } = nodeWithPos.node.attrs;
        return [
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uQ0E))), {
                        label: formatMessage((0, $61p3e.default).layoutFixedWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($3uQ0E))),
                onClick: (0, $iQfKE.updateExtensionLayout)('default', editorAnalyticsAPI),
                selected: layout === 'default',
                title: formatMessage((0, $61p3e.default).layoutFixedWidth),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kDG8M))), {
                        label: formatMessage((0, $61p3e.default).layoutWide),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($kDG8M))),
                onClick: (0, $iQfKE.updateExtensionLayout)('wide', editorAnalyticsAPI),
                selected: layout === 'wide',
                title: formatMessage((0, $61p3e.default).layoutWide),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gzsfl))), {
                        label: formatMessage((0, $61p3e.default).layoutFullWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gzsfl))),
                onClick: (0, $iQfKE.updateExtensionLayout)('full-width', editorAnalyticsAPI),
                selected: layout === 'full-width',
                title: formatMessage((0, $61p3e.default).layoutFullWidth),
                tabIndex: null
            }
        ];
    }
    return [];
};
const $cbbd6680b3b391a3$var$breakoutDropdownOptions = (state, formatMessage, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $j6kTj.getSelectedExtension)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (!nodeWithPos || !breakoutEnabled || !$cbbd6680b3b391a3$var$isLayoutSupported(state, nodeWithPos) || $cbbd6680b3b391a3$var$isNestedNBM(state, nodeWithPos)) return [];
    const { layout: layout } = nodeWithPos.node.attrs;
    let title = '';
    let IconComponent;
    switch(layout){
        case 'wide':
            title = formatMessage((0, $61p3e.default).layoutStateWide);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($kDG8M)));
            break;
        case 'full-width':
            title = formatMessage((0, $61p3e.default).layoutStateFullWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($gzsfl)));
            break;
        case 'default':
        default:
            title = formatMessage((0, $61p3e.default).layoutStateFixedWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($3uQ0E)));
            break;
    }
    const options = [
        {
            id: 'editor.extensions.width.default',
            title: formatMessage((0, $61p3e.default).layoutFixedWidth),
            onClick: (0, $iQfKE.updateExtensionLayout)('default', editorAnalyticsAPI),
            selected: layout === 'default',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uQ0E))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $61p3e.default).layoutFixedWidth)
            })
        },
        {
            id: 'editor.extensions.width.wide',
            title: formatMessage((0, $61p3e.default).layoutWide),
            onClick: (0, $iQfKE.updateExtensionLayout)('wide', editorAnalyticsAPI),
            selected: layout === 'wide',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kDG8M))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $61p3e.default).layoutWide)
            })
        },
        {
            id: 'editor.extensions.width.full-width',
            title: formatMessage((0, $61p3e.default).layoutFullWidth),
            onClick: (0, $iQfKE.updateExtensionLayout)('full-width', editorAnalyticsAPI),
            selected: layout === 'full-width',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gzsfl))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $61p3e.default).layoutFullWidth)
            })
        }
    ];
    return [
        {
            id: 'extensions-width-options-toolbar-item',
            testId: 'extensions-width-options-toolbar-dropdown',
            type: 'dropdown',
            options: options,
            title: title,
            iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                    color: "currentColor",
                    spacing: "spacious",
                    label: title
                })
        }
    ];
};
const $cbbd6680b3b391a3$var$breakoutOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, api)=>{
    return (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? $cbbd6680b3b391a3$var$breakoutDropdownOptions(state, formatMessage, breakoutEnabled, editorAnalyticsAPI) : $cbbd6680b3b391a3$var$breakoutButtonListOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI);
};
const $cbbd6680b3b391a3$var$editButton = (formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, isDisabled = false, api)=>{
    if (!extensionState.showEditButton) return [];
    const toolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const editButtonItems = [
        {
            id: 'editor.extension.edit',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
            testId: 'extension-toolbar-edit-button',
            // Taking the latest `updateExtension` from plugin state to avoid race condition @see ED-8501
            onClick: (state, dispatch, view)=>{
                const macroState = (0, $gdgqN.pluginKey).getState(state);
                const { updateExtension: updateExtension } = (0, $liMF6.getPluginState)(state);
                (0, $cXuuT.editExtension)(macroState && macroState.macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(state, dispatch, view);
                return true;
            },
            title: formatMessage((0, $5pF33.messages).edit),
            tabIndex: null,
            focusEditoronEnter: true,
            disabled: isDisabled,
            isRadioButton: (0, $1oCLl.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? false : undefined
        }
    ];
    if (toolbarFlagsEnabled) editButtonItems.push({
        type: 'separator',
        fullHeight: true
    });
    return editButtonItems;
};
/**
 * Calculates the position for the toolbar when dealing with nested extensions
 * @param editorView
 * @param nextPos
 * @param state
 * @param extensionNode
 * @example
 */ const $cbbd6680b3b391a3$var$calculateToolbarPosition = (editorView, nextPos, state, extensionNode)=>{
    const { state: { schema: schema, selection: selection } } = editorView;
    const possibleMbeParent = (0, $8m4tT.findParentNodeOfType)(schema.nodes.extensionFrame)(selection);
    // We only want to use calculated position in case of a bodiedExtension present inside an MBE node
    const isBodiedExtensionInsideMBE = possibleMbeParent && extensionNode?.node.type.name === 'bodiedExtension';
    let scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
    if (!extensionNode) return nextPos;
    const isInsideEditableExtensionArea = !!editorView.dom.closest('.extension-editable-area');
    if (!isBodiedExtensionInsideMBE && !isInsideEditableExtensionArea) return nextPos;
    if (isInsideEditableExtensionArea && scrollWrapper.parentElement) // The editable extension area may have its own scroll wrapper, so we want to keep searching up the tree for the page level scroll wrapper.
    scrollWrapper = scrollWrapper.parentElement.closest('.fabric-editor-popup-scroll-parent') || scrollWrapper;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const nestedBodiedExtensionDomElement = editorView.nodeDOM(extensionNode.pos);
    const nestedBodiedExtensionRect = nestedBodiedExtensionDomElement?.getBoundingClientRect();
    const wrapperBounds = scrollWrapper.getBoundingClientRect();
    const toolbarTopPos = nestedBodiedExtensionRect.bottom - wrapperBounds.top + scrollWrapper.scrollTop + (0, $5Ev1b.BODIED_EXT_MBE_MARGIN_TOP);
    return {
        top: toolbarTopPos,
        left: nextPos.left
    };
};
const $cbbd6680b3b391a3$export$7652656d91146fb9 = ({ formatMessage: formatMessage, extensionApi: extensionApi, extensionProvider: extensionProvider, getUnsupportedContent: getUnsupportedContent, state: state, locale: locale })=>{
    if (!extensionProvider) return;
    const nodeWithPos = (0, $j6kTj.getSelectedExtension)(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    const extensionParams = {
        type: node.type.name,
        extensionKey: extensionKey,
        extensionType: extensionType,
        parameters: node.attrs.parameters,
        content: node.content,
        localId: node.attrs.localId
    };
    const adf = getUnsupportedContent?.(extensionParams);
    if (!adf) return;
    // this command copies the text content of the unsupported content extension to the clipboard
    return (editorState)=>{
        extensionApi?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).COPY_BUTTON,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
            attributes: {
                extensionDynamicType: node.type.name,
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey
            }
        });
        (0, $j6kTj.copyUnsupportedContentToClipboard)({
            locale: locale,
            unsupportedContent: adf,
            schema: state.schema,
            api: extensionApi
        }).then(()=>{
            extensionApi?.copyButton?.actions.afterCopy(formatMessage((0, $61p3e.default).copiedToClipboard));
        }).catch((error)=>{
            (0, $j6kTj.onCopyFailed)({
                error: error,
                extensionApi: extensionApi,
                state: editorState
            });
        });
        return true;
    };
};
const $cbbd6680b3b391a3$export$86ce8f8241c20a3 = ({ breakoutEnabled: breakoutEnabled = true, extensionApi: extensionApi, getUnsupportedContent: getUnsupportedContent })=>(state, intl)=>{
        const { formatMessage: formatMessage, locale: locale } = intl;
        const extensionState = (0, $liMF6.getPluginState)(state);
        const { extensionProvider: extensionProvider } = extensionState;
        const hoverDecoration = extensionApi?.decorations?.actions.hoverDecoration;
        const applyChangeToContextPanel = extensionApi?.contextPanel?.actions.applyChange;
        const editorAnalyticsAPI = extensionApi?.analytics?.actions;
        if (!extensionState || extensionState.showContextPanel || !extensionState.element) return;
        const nodeType = [
            state.schema.nodes.extension,
            state.schema.nodes.inlineExtension,
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.multiBodiedExtension
        ];
        const editButtonItems = $cbbd6680b3b391a3$var$editButton(formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) && (0, $91bcx.isOfflineMode)(extensionApi?.connectivity?.sharedState?.currentState()?.mode), extensionApi);
        const breakoutItems = $cbbd6680b3b391a3$var$breakoutOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, extensionApi);
        const extensionObj = (0, $j6kTj.getSelectedExtension)(state, true);
        // If this is a native-embed extension, skip providing a toolbar config to allow
        // the native-embed plugin to provide a custom toolbar config.
        if (extensionObj?.node.attrs.extensionType === (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE) && extensionObj?.node.attrs.extensionKey.includes((0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY))) return;
        // Check if we need to show confirm dialog for delete button
        let confirmDialog;
        if ((0, $5GR8v.isReferencedSource)(state, extensionObj?.node)) confirmDialog = ()=>{
            const localSourceName = formatMessage((0, $5pF33.messages).unnamedSource);
            return {
                title: formatMessage((0, $5pF33.messages).deleteElementTitle),
                okButtonLabel: formatMessage((0, $5pF33.messages).confirmDeleteLinkedModalOKButton),
                message: formatMessage((0, $5pF33.messages).confirmDeleteLinkedModalMessage, {
                    nodeName: (0, $5GR8v.getNodeName)(state, extensionObj?.node) || localSourceName
                }),
                isReferentialityDialog: true,
                getChildrenInfo: ()=>(0, $5GR8v.getChildrenInfo)(state, extensionObj?.node),
                checkboxLabel: formatMessage((0, $5pF33.messages).confirmModalCheckboxLabel),
                onConfirm: (isChecked = false)=>$cbbd6680b3b391a3$var$clickWithCheckboxHandler(isChecked, extensionObj?.node)
            };
        };
        // disable copy button for legacy content macro
        const isLegacyContentMacro = extensionObj?.node.attrs.extensionType === 'com.atlassian.confluence.migration' && extensionObj?.node.attrs.extensionKey === 'legacy-content';
        const shouldHideCopyButton = isLegacyContentMacro && (0, $1oCLl.expValEquals)('platform_editor_disable_lcm_copy_button', 'isEnabled', true);
        return {
            title: 'Extension floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getDomRef: ()=>extensionState.element.parentElement || undefined,
            nodeType: nodeType,
            onPositionCalculated: (editorView, nextPos)=>$cbbd6680b3b391a3$var$calculateToolbarPosition(editorView, nextPos, state, extensionObj),
            items: [
                ...editButtonItems,
                ...breakoutItems,
                {
                    type: 'separator',
                    hidden: editButtonItems.length === 0 && breakoutItems.length === 0
                },
                {
                    type: 'extensions-placeholder',
                    separator: 'end'
                },
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onClick: (0, $1oCLl.expValEquals)('platform_editor_ai_edit_unsupported_content', 'isEnabled', true) ? $cbbd6680b3b391a3$export$7652656d91146fb9({
                                formatMessage: formatMessage,
                                extensionApi: extensionApi,
                                extensionProvider: extensionProvider,
                                getUnsupportedContent: getUnsupportedContent,
                                state: state,
                                locale: locale
                            }) : undefined
                        }
                    ],
                    ...shouldHideCopyButton && {
                        hidden: shouldHideCopyButton
                    }
                },
                {
                    type: 'separator'
                },
                {
                    id: 'editor.extension.delete',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    appearance: 'danger',
                    onClick: (0, $iQfKE.removeExtension)(editorAnalyticsAPI, (0, $d925B.INPUT_METHOD).FLOATING_TB),
                    onMouseEnter: hoverDecoration?.(nodeType, true),
                    onMouseLeave: hoverDecoration?.(nodeType, false),
                    onFocus: hoverDecoration?.(nodeType, true),
                    onBlur: hoverDecoration?.(nodeType, false),
                    focusEditoronEnter: true,
                    title: formatMessage((0, $61p3e.default).remove),
                    tabIndex: null,
                    confirmDialog: confirmDialog
                }
            ],
            scrollable: true
        };
    };
const $cbbd6680b3b391a3$var$clickWithCheckboxHandler = (isChecked, node)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) (0, $iQfKE.removeExtension)()(state, dispatch);
        else (0, $iQfKE.removeDescendantNodes)(node)(state, dispatch);
        return true;
    };
module.exports["getToolbarConfig"] = $cbbd6680b3b391a3$export$86ce8f8241c20a3;

});

parcelRegister("h1iwq", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $9YoeD = parcelRequire("9YoeD");


var $1S4f7 = parcelRequire("1S4f7");


var $kTbzR = parcelRequire("kTbzR");


var $ks2lK = parcelRequire("ks2lK");

const $901577c8e6386978$var$pluginKey = new (0, $ks2lK.PluginKey)('extensionUniqueIdPlugin');
const $901577c8e6386978$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            const selectionBookmark = tr.selection.getBookmark();
            let modified = false;
            const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = newState.schema.nodes;
            const extensionTypes = new Set([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ]);
            const idsObserved = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                const isAddingExtension = transaction.steps.some((step)=>(0, $kTbzR.stepAddsOneOf)(step, extensionTypes) || // There are instances where the localId will be reset to null on publish due to extension
                    // not existing in the Storage format (eg. Legacy Content Extensions) or not having a localId
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    step instanceof (0, $9YoeD.SetAttrsStep) && // @ts-expect-error Bad ProseMirror step types
                    step.attrs?.localId === null);
                if (isAddingExtension) // Can't simply look at changed nodes, as we could be adding an extension
                newState.doc.descendants((node, pos)=>{
                    const localId = node.attrs.localId;
                    // Dealing with an extension - make sure it's a unique ID
                    if (!!node.type && extensionTypes.has(node.type)) {
                        if (localId && !idsObserved.has(localId)) idsObserved.add(localId);
                        else if (!localId || idsObserved.has(localId)) {
                            modified = true;
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                localId: (0, $fO7hX.uuid).generate()
                            });
                        }
                        /**
							 * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
							 * since we can have more extension nodes within the contents of that
							 */ if ([
                            multiBodiedExtension,
                            bodiedExtension
                        ].includes(node.type)) return true;
                        return false;
                    }
                    /**
						 * Otherwise continue traversing, we can encounter extensions nested in
						 * expands/bodiedExtensions
						 */ return true;
                });
            });
            if (modified) // We want to restore to the original selection but w/o applying the mapping
            // @see https://github.com/ProseMirror/prosemirror/issues/645
            return tr.setSelection(selectionBookmark.resolve(tr.doc));
            return;
        },
        key: $901577c8e6386978$var$pluginKey
    });
module.exports["createPlugin"] = $901577c8e6386978$export$ae829ec7b2625219;

});

parcelRegister("7NMV8", function(module, exports) {
// Allowlist of { macroKey: parameterName[] } for analytics logging
const $dbe157a86c6b2ed1$export$2a99ab8c82908148 = {
    children: [
        'all',
        'first',
        'depth',
        'style',
        'excerptType',
        'sort',
        'reverse'
    ],
    'recently-updated': [
        'width',
        'types',
        'max',
        'theme',
        'showProfilePic',
        'hideHeading'
    ],
    excerpt: [
        'hidden'
    ]
};
const $dbe157a86c6b2ed1$export$d17c9f402b8c93c8 = [
    'enum',
    'number',
    'boolean'
];
const $dbe157a86c6b2ed1$export$57e7dbe0bbfe09b5 = 320;
const $dbe157a86c6b2ed1$export$cb69418acbe13bc2 = 'extensions-panel';
module.exports["ALLOWED_LOGGED_MACRO_PARAMS"] = $dbe157a86c6b2ed1$export$2a99ab8c82908148;
module.exports["ALLOWED_PARAM_TYPES"] = $dbe157a86c6b2ed1$export$d17c9f402b8c93c8;
module.exports["CONFIG_PANEL_WIDTH"] = $dbe157a86c6b2ed1$export$57e7dbe0bbfe09b5;
module.exports["CONFIG_PANEL_ID"] = $dbe157a86c6b2ed1$export$cb69418acbe13bc2;

});

parcelRegister("83ZkX", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3jQ9y = parcelRequire("3jQ9y");


var $adhil = parcelRequire("adhil");


var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $cXuuT = parcelRequire("cXuuT");


var $iQfKE = parcelRequire("iQfKE");


var $liMF6 = parcelRequire("liMF6");


var $j6kTj = parcelRequire("j6kTj");


var $bRruX = parcelRequire("bRruX");


var $fpcUk = parcelRequire("fpcUk");

const $ab33982f3ff76825$var$areParametersEqual = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
firstParameters, // eslint-disable-next-line @typescript-eslint/no-explicit-any
secondParameters)=>{
    if (typeof firstParameters === 'object' && typeof secondParameters === 'object' && firstParameters !== null && secondParameters !== null) {
        const firstKeys = Object.keys(firstParameters);
        const secondKeys = Object.keys(secondParameters);
        return firstKeys.length === secondKeys.length && firstKeys.every((key)=>firstParameters[key] === secondParameters[key]);
    }
    return firstParameters === secondParameters;
};
const $ab33982f3ff76825$export$3c0bb68e76442a1e = (selectionToDuplicate, doc)=>{
    if (selectionToDuplicate instanceof (0, $ks2lK.NodeSelection)) return (0, $ks2lK.NodeSelection).create(doc, selectionToDuplicate.from);
    else if (selectionToDuplicate instanceof (0, $ks2lK.TextSelection)) return (0, $ks2lK.TextSelection).create(doc, selectionToDuplicate.from, selectionToDuplicate.to);
    else if (selectionToDuplicate instanceof (0, $adhil.GapCursorSelection)) return new (0, $adhil.GapCursorSelection)(doc.resolve(selectionToDuplicate.from), selectionToDuplicate.side);
    else if (selectionToDuplicate instanceof (0, $7XFGZ.CellSelection)) return new (0, $7XFGZ.CellSelection)(doc.resolve(selectionToDuplicate.$anchorCell.pos), doc.resolve(selectionToDuplicate.$headCell.pos));
};
const $ab33982f3ff76825$export$7c8c60c0acb92731 = (getEditorView)=>(api, featureFlags)=>(state)=>{
            const nodeWithPos = (0, $j6kTj.getSelectedExtension)(state, true);
            const applyChange = api?.contextPanel?.actions.applyChange;
            // Adding checks to bail out early
            if (!nodeWithPos) return;
            const extensionState = (0, $liMF6.getPluginState)(state);
            const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersBefore: processParametersBefore, processParametersAfter: processParametersAfter } = extensionState;
            if (extensionState && showContextPanel && extensionProvider && processParametersAfter) {
                const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
                const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
                const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $fpcUk.SaveIndicator), {
                    duration: 5000,
                    visible: true,
                    children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                        const editorView = getEditorView?.();
                        if (!editorView) return null;
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bRruX.default), {
                            api: api,
                            showHeader: true,
                            closeOnEsc: true,
                            extensionType: extensionType,
                            extensionKey: extKey,
                            nodeKey: nodeKey,
                            extensionParameters: parameters,
                            parameters: configParams,
                            extensionProvider: extensionProvider,
                            autoSaveTrigger: autoSaveResolve,
                            autoSaveReject: autoSaveReject,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onChange: async (updatedParameters)=>{
                                await $ab33982f3ff76825$export$2f221d4ebb46923c(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                                onSaveEnded();
                                if (autoSaveResolve) autoSaveResolve();
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onCancel: async ()=>{
                                try {
                                    await new Promise((resolve, reject)=>{
                                        (0, $iQfKE.forceAutoSave)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
                                    });
                                } catch (e) {
                                    // Even if the save failed, we should proceed with closing the panel
                                    // eslint-disable-next-line no-console
                                    console.error(`Autosave failed with error`, e);
                                }
                                (0, $iQfKE.clearEditingContext)(applyChange)(editorView.state, editorView.dispatch);
                            },
                            featureFlags: featureFlags
                        });
                    }
                });
            }
        };
async function $ab33982f3ff76825$export$2f221d4ebb46923c(editorView, updatedParameters = {}, oldParameters = {}, nodeWithPos, onSaving) {
    // WARNING: editorView.state stales quickly, do not unpack
    const { processParametersAfter: processParametersAfter, processParametersBefore: processParametersBefore } = (0, $liMF6.getPluginState)(editorView.state);
    if (!processParametersAfter) return;
    const unwrappedOldParameters = processParametersBefore ? processParametersBefore(oldParameters) : oldParameters;
    if ($ab33982f3ff76825$var$areParametersEqual(unwrappedOldParameters, updatedParameters)) return;
    if (onSaving) onSaving();
    const key = Date.now();
    const { positions: previousPositions } = (0, $liMF6.getPluginState)(editorView.state);
    await (0, $iQfKE.updateState)({
        positions: {
            ...previousPositions,
            [key]: nodeWithPos.pos
        }
    })(editorView.state, editorView.dispatch);
    // WARNING: after this, editorView.state may have changed
    const newParameters = await processParametersAfter(updatedParameters);
    const { positions: positions } = (0, $liMF6.getPluginState)(editorView.state);
    if (!positions) return;
    if (!(key in positions)) return;
    const { node: node } = nodeWithPos;
    const newNode = (0, $cXuuT.buildExtensionNode)(nodeWithPos.node.toJSON().type, editorView.state.schema, {
        ...node.attrs,
        parameters: {
            ...oldParameters,
            ...newParameters
        }
    }, node.content, node.marks);
    if (!newNode) return;
    const positionUpdated = positions[key];
    const transaction = editorView.state.tr.replaceWith(positionUpdated, positionUpdated + newNode.nodeSize, newNode);
    // Ensure we preserve the selection, tr.replaceWith causes it to be lost in some cases
    // when replacing the node
    const { selection: prevSelection } = editorView.state;
    if (!prevSelection.eq(transaction.selection)) {
        const selection = $ab33982f3ff76825$export$3c0bb68e76442a1e(prevSelection, transaction.doc);
        if (selection) transaction.setSelection(selection);
    }
    const positionsLess = {
        ...(0, $liMF6.getPluginState)(editorView.state).positions
    };
    delete positionsLess[key];
    await (0, $iQfKE.updateState)({
        positions: positionsLess
    })(editorView.state, editorView.dispatch);
    editorView.dispatch(transaction);
}
module.exports["getContextPanel"] = $ab33982f3ff76825$export$7c8c60c0acb92731;
module.exports["onChangeAction"] = $ab33982f3ff76825$export$2f221d4ebb46923c;

});

parcelRegister("bRruX", function(module, exports) {

var $4wH3g = parcelRequire("4wH3g");


var $1ux1Z = parcelRequire("1ux1Z");


const $94f53d3f64228b83$var$_default_1 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "qCkVP",
    name: "_default_1",
    loader: ()=>(parcelRequire("7jNQ0")).then((module)=>module.default),
    loading: (0, $1ux1Z.default)
});
var $94f53d3f64228b83$export$2e2bcd8739ae039 = $94f53d3f64228b83$var$_default_1;
module.exports["default"] = $94f53d3f64228b83$export$2e2bcd8739ae039;

});

parcelRegister("1ux1Z", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $5pF33 = parcelRequire("5pF33");


var $aoVih = parcelRequire("aoVih");


var $9hlns = parcelRequire("9hlns");


var $iu6m9 = parcelRequire("iu6m9");

function $2519f064eb7ebc07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2519f064eb7ebc07$var$spinnerWrapperStyles = {
    name: "kcqyy5",
    styles: "display:flex;justify-content:center;margin-top:var(--ds-space-800, 64px)"
};
const $2519f064eb7ebc07$var$errorWrapperStyles = {
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
};
const $2519f064eb7ebc07$var$LoadingStateWithErrorHandling = (0, $aXWIB.injectIntl)((props)=>{
    if (props.error) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $2519f064eb7ebc07$var$errorWrapperStyles,
        "data-testid": "ConfigPanelLoadingError"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aoVih.default), {
        appearance: "error"
    }, props.intl.formatMessage((0, $5pF33.messages).panelLoadingError)));
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $2519f064eb7ebc07$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hlns.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
});
const $2519f064eb7ebc07$var$LoadingStateWithoutErrorHandling = ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $2519f064eb7ebc07$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hlns.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
const $2519f064eb7ebc07$var$LoadingState = (props)=>(0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? $2519f064eb7ebc07$var$LoadingStateWithErrorHandling(props) : $2519f064eb7ebc07$var$LoadingStateWithoutErrorHandling();
var $2519f064eb7ebc07$export$2e2bcd8739ae039 = $2519f064eb7ebc07$var$LoadingState;
module.exports["default"] = $2519f064eb7ebc07$export$2e2bcd8739ae039;

});

parcelRegister("7jNQ0", function(module, exports) {

let $5540f77fd2cd3874$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5540f77fd2cd3874$var$load("6wr18"),
    $5540f77fd2cd3874$var$load("Wowvf"),
    $5540f77fd2cd3874$var$load("byA95"),
    $5540f77fd2cd3874$var$load("9hYRW"),
    $5540f77fd2cd3874$var$load("kpm7S"),
    $5540f77fd2cd3874$var$load("7EorR"),
    $5540f77fd2cd3874$var$load("ffEVr"),
    $5540f77fd2cd3874$var$load("hhss7"),
    $5540f77fd2cd3874$var$load("djfev")
]).then(()=>parcelRequire('7oBuJ'));

});

parcelRegister("fpcUk", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $5pF33 = parcelRequire("5pF33");


var $3sFtD = parcelRequire("3sFtD");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");

function $edcdc351883ee8ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $edcdc351883ee8ae$var$noop = ()=>{};
const $edcdc351883ee8ae$var$saveIndicatorWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $edcdc351883ee8ae$var$saveIndicatorContentStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'fixed',
    width: '256px',
    bottom: "var(--ds-space-250, 20px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    /* E300 */ boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    borderRadius: "var(--ds-radius-xxlarge, 16px)"
});
const $edcdc351883ee8ae$var$saveIndicatorTextStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.075'
});
const $edcdc351883ee8ae$export$7ceebdb305e167df = ({ children: children, duration: duration, visible: visible = true })=>{
    const [saving, setSaving] = (0, $42omo.useState)(false);
    const shown = (0, $42omo.useRef)(false);
    const onSaveStarted = (0, $42omo.useCallback)(()=>{
        if (!shown.current) {
            setSaving(true);
            shown.current = true;
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (saving) {
            const handleId = setTimeout(()=>{
                setSaving(false);
            }, duration);
            return ()=>clearTimeout(handleId);
        }
    }, [
        saving,
        duration
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, children({
        onSaveStarted: onSaveStarted,
        onSaveEnded: $edcdc351883ee8ae$var$noop
    })), visible && saving && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $edcdc351883ee8ae$var$saveIndicatorWrapperStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $edcdc351883ee8ae$var$saveIndicatorContentStyles,
        "data-testid": "save-indicator-content"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: "Saving",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $edcdc351883ee8ae$var$saveIndicatorTextStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aXWIB.FormattedMessage), (0, $5pF33.messages).saveIndicator))))));
};
module.exports["SaveIndicator"] = $edcdc351883ee8ae$export$7ceebdb305e167df;

});

parcelRegister("i1yGN", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3jQ9y = parcelRequire("3jQ9y");


var $eiA8Z = parcelRequire("eiA8Z");


var $gdv5Z = parcelRequire("gdv5Z");


var $iQfKE = parcelRequire("iQfKE");


var $liMF6 = parcelRequire("liMF6");


var $j6kTj = parcelRequire("j6kTj");


var $bRruX = parcelRequire("bRruX");


var $7NMV8 = parcelRequire("7NMV8");


var $gbONg = parcelRequire("gbONg");


var $a8brD = parcelRequire("a8brD");


var $83ZkX = parcelRequire("83ZkX");


var $fpcUk = parcelRequire("fpcUk");

const $b6b68ed5d492495b$var$selector = (states)=>{
    return {
        showContextPanel: states.extensionState?.showContextPanel,
        extensionProvider: states.extensionState?.extensionProvider,
        processParametersAfter: states.extensionState?.processParametersAfter
    };
};
function $b6b68ed5d492495b$export$781dfcd068e3a2e0({ editorView: editorView, configPanelId: configPanelId, api: api }) {
    const editorState = editorView.state;
    const { showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersAfter: processParametersAfter } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'extension'
    ], $b6b68ed5d492495b$var$selector);
    (0, $42omo.useEffect)(()=>{
        const nodeWithPos = (0, $j6kTj.getSelectedExtension)(editorState, true);
        // Adding checks to bail out early
        if (!nodeWithPos) {
            $b6b68ed5d492495b$export$2a2eb89a1c258b39(configPanelId, api);
            return;
        }
        if (showContextPanel && extensionProvider && processParametersAfter) $b6b68ed5d492495b$export$e4eb3d5da2de4919({
            api: api,
            configPanelId: configPanelId,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        else $b6b68ed5d492495b$export$2a2eb89a1c258b39(configPanelId, api);
    }, [
        api,
        configPanelId,
        editorState,
        editorView,
        showContextPanel,
        extensionProvider,
        processParametersAfter
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            $b6b68ed5d492495b$export$2a2eb89a1c258b39(configPanelId, api);
        };
    }, [
        api,
        configPanelId
    ]);
}
function $b6b68ed5d492495b$export$2a2eb89a1c258b39(configPanelId, api) {
    const closePanelById = api?.contextPanel?.actions?.closePanelById;
    if (closePanelById) closePanelById(configPanelId);
}
function $b6b68ed5d492495b$export$e4eb3d5da2de4919({ api: api, configPanelId: configPanelId, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos }) {
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    if (showContextPanel) {
        const nodeAttrs = nodeWithPos?.node.attrs;
        const extensionType = nodeAttrs?.extensionType;
        const extensionKey = nodeAttrs?.extensionKey;
        /**
		 * Loading extension manifest fails when using
		 * 	extensionKey directly from nodeAttrs.
		 * Always get extensionKey from getExtensionKeyAndNodeKey to load
		 * 	extension manifest successfully.
		 */ const [extKey, _] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const HeadeIconWrapper = ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $a8brD.default), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const HeaderAfterIconElementWrapper = ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gbONg.default), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const BodyComponent = $b6b68ed5d492495b$export$768c11fa806367e7({
            api: api,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        showContextPanel({
            id: configPanelId,
            headerComponentElements: {
                HeaderIcon: HeadeIconWrapper,
                HeaderAfterIconElement: HeaderAfterIconElementWrapper
            },
            BodyComponent: BodyComponent,
            closeOptions: {
                canClosePanel: async ()=>{
                    // When navigating away from the editor, the editorView is destroyed.
                    if (editorView.isDestroyed) return true;
                    const extensionState = (0, $liMF6.getPluginState)(editorView.state);
                    /**
						 * 	If context panel is open, then first update extension plugin state.
						 * 	Updating extension plugin state will trigger useEffect in useConfigPanelPluginHook,
						 * 		which will call hideConfigPanel.
						 */ if (extensionState?.showContextPanel) {
                        await $b6b68ed5d492495b$export$237eef05f48e1226({
                            api: api,
                            editorView: editorView
                        });
                        return false;
                    }
                    // Return true if extension plugin state has been updated and hideConfigPanel has been called.
                    return true;
                }
            }
        }, 'push', (0, $7NMV8.CONFIG_PANEL_WIDTH));
    }
}
async function $b6b68ed5d492495b$export$237eef05f48e1226({ api: api, editorView: editorView }) {
    const applyChange = api?.contextPanel?.actions.applyChange;
    // Even if the save failed, we should proceed with closing the panel
    (0, $iQfKE.clearEditingContext)(applyChange)(editorView.state, editorView.dispatch);
    try {
        await new Promise((resolve, reject)=>{
            (0, $iQfKE.forceAutoSave)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
        });
    } catch (e) {
        // Even if the save failed, we should proceed with closing the panel
        // eslint-disable-next-line no-console
        console.error(`Autosave failed with error`, e);
    }
}
const $b6b68ed5d492495b$export$768c11fa806367e7 = ({ api: api, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorState = editorView.state;
    const extensionState = (0, $liMF6.getPluginState)(editorState);
    const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, processParametersBefore: processParametersBefore } = extensionState;
    const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
    const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            padding: "space.200",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpcUk.SaveIndicator), {
                duration: 5000,
                visible: true,
                children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bRruX.default), {
                        api: api,
                        showHeader: true,
                        closeOnEsc: true,
                        extensionType: extensionType,
                        extensionKey: extKey,
                        nodeKey: nodeKey,
                        extensionParameters: parameters,
                        parameters: configParams,
                        extensionProvider: extensionProvider,
                        autoSaveTrigger: autoSaveResolve,
                        autoSaveReject: autoSaveReject,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onChange: async (updatedParameters)=>{
                            await (0, $83ZkX.onChangeAction)(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                            onSaveEnded();
                            if (autoSaveResolve) autoSaveResolve();
                        },
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onCancel: ()=>$b6b68ed5d492495b$export$237eef05f48e1226({
                                api: api,
                                editorView: editorView
                            }),
                        featureFlags: featureFlags,
                        // Remove below prop when cleaning platform_editor_ai_object_sidebar_injection FG
                        // Becuase it will always be true
                        usingObjectSidebarPanel: true
                    });
                }
            })
        });
};
module.exports["useConfigPanelPluginHook"] = $b6b68ed5d492495b$export$781dfcd068e3a2e0;

});

parcelRegister("gbONg", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $110Zy = parcelRequire("110Zy");

const $a037f4da29032475$var$itemBodyStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    margin: 'space.200',
    flexGrow: 3
});
const $a037f4da29032475$var$itemTextStyles = (0, $ecnYn.xcss)({
    maxWidth: '100%',
    whiteSpace: 'initial'
});
const $a037f4da29032475$var$summaryStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
function $a037f4da29032475$var$HeaderAfterIconElement({ extensionManifest: extensionManifest }) {
    const title = extensionManifest.title;
    const summary = extensionManifest.summary;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $a037f4da29032475$var$itemBodyStyles,
        children: summary ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $a037f4da29032475$var$itemTextStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    id: "context-panel-title",
                    "data-testid": "context-panel-title",
                    children: title
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $a037f4da29032475$var$summaryStyles,
                    children: summary
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
            direction: "column",
            alignItems: "center",
            testId: "context-panel-title",
            children: title
        })
    });
}
const $a037f4da29032475$var$_default_1 = (0, $110Zy.withExtensionManifest)($a037f4da29032475$var$HeaderAfterIconElement);
var $a037f4da29032475$export$2e2bcd8739ae039 = $a037f4da29032475$var$_default_1;
module.exports["default"] = $a037f4da29032475$export$2e2bcd8739ae039;

});

parcelRegister("110Zy", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1eYoq = parcelRequire("1eYoq");

function $db52d1799ba5ba81$export$7dd73e517d9d8a3(WrappedComponent) {
    return function WithExtensionManifest(props) {
        const { extensionKey: extensionKey, extensionProvider: extensionProvider, extensionType: extensionType, ...restProps } = props;
        const [extensionManifest] = (0, $1eYoq.useStateFromPromise)(()=>extensionProvider.getExtension(extensionType, extensionKey), [
            extensionProvider,
            extensionType,
            extensionKey
        ]);
        return extensionManifest ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            extensionManifest: extensionManifest,
            ...restProps
        }) : null;
    };
}
module.exports["withExtensionManifest"] = $db52d1799ba5ba81$export$7dd73e517d9d8a3;

});

parcelRegister("1eYoq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3wuBU = parcelRequire("3wuBU");

function $ab362e0d4d3dfbd5$export$4960a9d54b2095bb(callback, deps, initialValue) {
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $42omo.useCallback)(callback, deps);
    const [value, setValue] = (0, $42omo.useState)(initialValue);
    (0, $3wuBU.useAbortableEffect)((signal)=>{
        Promise.resolve(fn()).then((result)=>{
            if (signal.aborted) return;
            setValue(result);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        ...deps
    ]);
    return [
        value,
        setValue
    ];
}
module.exports["useStateFromPromise"] = $ab362e0d4d3dfbd5$export$4960a9d54b2095bb;

});

parcelRegister("3wuBU", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c316ee5083a2c330$var$safeError = (message)=>{
    // eslint-disable-next-line no-console
    console.error(message);
};
const $c316ee5083a2c330$var$createAbortController = ()=>{
    if (typeof AbortController === 'undefined') $c316ee5083a2c330$var$safeError('Missing AbortController');
    return new AbortController();
};
function $c316ee5083a2c330$export$daf4e774a28efe06(callback, deps) {
    const abortController = (0, $42omo.useMemo)(()=>$c316ee5083a2c330$var$createAbortController(), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const abort = (0, $42omo.useCallback)(()=>abortController.abort(), [
        abortController
    ]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $42omo.useCallback)(callback, deps);
    (0, $42omo.useEffect)(()=>{
        const teardown = fn(abortController.signal);
        return ()=>{
            if (typeof teardown === 'function') teardown();
            abort();
        };
    }, [
        abortController,
        abort,
        fn,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...deps
    ]);
}
module.exports["useAbortableEffect"] = $c316ee5083a2c330$export$daf4e774a28efe06;

});

parcelRegister("a8brD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $110Zy = parcelRequire("110Zy");

const $af2fc30072ef2472$var$iconWidth = '40px';
const $af2fc30072ef2472$var$itemIconStyles = (0, $ecnYn.xcss)({
    width: $af2fc30072ef2472$var$iconWidth,
    height: $af2fc30072ef2472$var$iconWidth,
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
function $af2fc30072ef2472$var$HeaderIcon({ extensionManifest: extensionManifest }) {
    const icon = extensionManifest.icons['48'];
    const title = extensionManifest.title;
    const ResolvedIcon = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $42omo.lazy)(()=>icon().then((Cmp)=>{
                if ('default' in Cmp) return Cmp;
                return {
                    default: Cmp
                };
            }));
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $af2fc30072ef2472$var$itemIconStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $l998X.jsx)(ResolvedIcon, {
                label: title
            })
        })
    });
}
const $af2fc30072ef2472$var$_default_1 = (0, $110Zy.withExtensionManifest)($af2fc30072ef2472$var$HeaderIcon);
var $af2fc30072ef2472$export$2e2bcd8739ae039 = $af2fc30072ef2472$var$_default_1;
module.exports["default"] = $af2fc30072ef2472$export$2e2bcd8739ae039;

});

parcelRegister("5u7tz", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dQl1W = parcelRequire("dQl1W");


var $d925B = parcelRequire("d925B");


var $ePpFN = parcelRequire("ePpFN");

var $4HWgE = parcelRequire("4HWgE");


var $dYBVS = parcelRequire("dYBVS");


var $3pLGZ = parcelRequire("3pLGZ");


var $bqMS3 = parcelRequire("bqMS3");


var $6mYMS = parcelRequire("6mYMS");


var $dh538 = parcelRequire("dh538");


var $3ZAfE = parcelRequire("3ZAfE");


var $8Shge = parcelRequire("8Shge");


var $9gkNA = parcelRequire("9gkNA");


var $8PUqB = parcelRequire("8PUqB");


var $cKd84 = parcelRequire("cKd84");


var $9kFq1 = parcelRequire("9kFq1");


var $jziTd = parcelRequire("jziTd");


var $jDVxk = parcelRequire("jDVxk");

const $99922ebfc07182a8$var$processName = (name, intl)=>{
    const unknownLabel = intl.formatMessage((0, $ePpFN.mentionMessages).unknownLabel);
    if (name.status === (0, $6mYMS.MentionNameStatus).OK) return `@${name.name || unknownLabel}`;
    else return `@${unknownLabel}`;
};
/**
 * We will need to clean this up once mentionProvider is
 * put inside mention plugin.
 * See: https://product-fabric.atlassian.net/browse/ED-26011
 */ function $99922ebfc07182a8$var$Component({ mentionProvider: mentionProvider, api: api }) {
    const mentionProviderMemo = (0, $42omo.useMemo)(()=>{
        return mentionProvider;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        mentionProviderMemo?.then((mentionProviderSync)=>{
            api?.base?.actions?.registerMarks(({ tr: tr, node: node, pos: pos })=>{
                const { doc: doc } = tr;
                const { schema: schema } = doc.type;
                const { mention: mentionNodeType } = schema.nodes;
                const { id: id } = node.attrs;
                if (node.type === mentionNodeType) {
                    if ((0, $bqMS3.isResolvingMentionProvider)(mentionProviderSync)) {
                        const nameDetail = mentionProviderSync?.resolveMentionName(id);
                        let newText;
                        if ((0, $6mYMS.isPromise)(nameDetail)) newText = `@${intl.formatMessage((0, $ePpFN.mentionMessages).unknownLabel)}`;
                        else newText = $99922ebfc07182a8$var$processName(nameDetail, intl);
                        const currentPos = tr.mapping.map(pos);
                        tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
                    }
                }
            });
        });
    }, [
        mentionProviderMemo,
        api,
        intl
    ]);
    return null;
}
const $99922ebfc07182a8$export$280dfabe1535ae84 = ({ config: options, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
    let previousMediaProvider;
    const fireEvent = (payload, channel)=>{
        const fireAnalyticsEvent = api?.analytics?.actions?.fireAnalyticsEvent;
        if (!fireAnalyticsEvent) return;
        if (payload.attributes && !payload.attributes.sessionId) payload.attributes.sessionId = sessionId;
        fireAnalyticsEvent(payload, channel);
    };
    const typeAhead = (0, $jDVxk.createTypeAheadConfig)({
        sanitizePrivateContent: options?.sanitizePrivateContent,
        mentionInsertDisplayName: options?.insertDisplayName,
        HighlightComponent: options?.HighlightComponent,
        handleMentionsChanged: options?.handleMentionsChanged,
        fireEvent: fireEvent,
        api: api
    });
    return {
        name: 'mention',
        nodes () {
            return [
                {
                    name: 'mention',
                    node: (0, $8Shge.mentionNodeSpec)()
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'mention',
                    plugin: (pmPluginFactoryParams)=>(0, $8PUqB.createMentionPlugin)({
                            pmPluginFactoryParams: pmPluginFactoryParams,
                            fireEvent: fireEvent,
                            options: options,
                            api: api
                        })
                }
            ];
            if ((0, $dh538.fg)('jira_invites_auto_tag_new_user_in_mentions_fg')) plugins.push({
                name: 'mentionPlaceholder',
                plugin: ()=>(0, $cKd84.createMentionPlaceholderPlugin)()
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, providerFactory: providerFactory }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $dYBVS.WithProviders), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                providers: [
                    'mentionProvider'
                ],
                providerFactory: providerFactory,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                renderNode: ({ mentionProvider: mentionProvider })=>{
                    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)($99922ebfc07182a8$var$Component, {
                                mentionProvider: mentionProvider,
                                api: api
                            }),
                            (0, $dh538.fg)('jira_invites_auto_tag_new_user_in_mentions_fg') && /*#__PURE__*/ (0, $l998X.jsx)((0, $9kFq1.InlineInviteRecaptchaContainer), {
                                mentionProvider: mentionProvider,
                                api: api
                            })
                        ]
                    });
                }
            });
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $jziTd.SecondaryToolbarComponent), {
                editorView: editorView,
                api: api,
                disabled: disabled,
                typeAhead: typeAhead
            });
        },
        commands: {
            insertMention: (0, $3ZAfE.insertMention)({
                sanitizePrivateContent: options?.sanitizePrivateContent ?? false,
                mentionInsertDisplayName: options?.insertDisplayName ?? false,
                api: api
            })
        },
        actions: {
            openTypeAhead (inputMethod) {
                return Boolean(api?.typeAhead?.actions?.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod
                }));
            },
            announceMentionsInsertion: (mentionChanges)=>{
                if (options?.handleMentionsChanged) options.handleMentionsChanged(mentionChanges);
            },
            setProvider: async (providerPromise)=>{
                if (!(0, $dh538.fg)('platform_editor_mention_provider_via_plugin_config')) return false;
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $9gkNA.mentionPluginKey), {
                        action: (0, $8PUqB.ACTIONS).SET_PROVIDER,
                        params: {
                            provider: provider
                        }
                    })) ?? false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const mentionPluginState = (0, $9gkNA.mentionPluginKey).getState(editorState);
            return {
                ...mentionPluginState,
                typeAheadHandler: typeAhead
            };
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'mention',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mention),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).mentionDescription),
                        keywords: [
                            'team',
                            'user'
                        ],
                        priority: 400,
                        keyshortcut: '@',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconMention), {}),
                        action (insert, state) {
                            const tr = insert(undefined);
                            const pluginState = (0, $9gkNA.mentionPluginKey).getState(state);
                            if (pluginState && pluginState.canInsertMention === false) return false;
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead
        }
    };
};
module.exports["mentionsPlugin"] = $99922ebfc07182a8$export$280dfabe1535ae84;

});

parcelRegister("3ZAfE", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $bYZ53 = parcelRequire("bYZ53");


var $5SAOw = parcelRequire("5SAOw");


var $bqMS3 = parcelRequire("bqMS3");

const $71881ae30930a463$export$c39c34a625f03dcd = ({ mentionInsertDisplayName: mentionInsertDisplayName, mentionProvider: mentionProvider, tr: tr, sanitizePrivateContent: sanitizePrivateContent })=>({ name: name, id: id, userType: userType, nickname: nickname, localId: localId, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        const schema = tr.doc.type.schema;
        const trimmedNickname = nickname && nickname.startsWith('@') ? nickname.slice(1) : nickname;
        const renderName = mentionInsertDisplayName || !trimmedNickname ? name : trimmedNickname;
        if (isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
        // Don't insert into document if document data is sanitized.
        const text = sanitizePrivateContent ? '' : `@${renderName}`;
        if (sanitizePrivateContent && (0, $bqMS3.isResolvingMentionProvider)(mentionProvider)) // Cache (locally) for later rendering
        mentionProvider.cacheMentionName(id, renderName);
        const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(tr.selection.$head);
        const mentionNode = schema.nodes.mention.createChecked({
            text: text,
            id: id,
            accessLevel: accessLevel,
            userType: userType === 'DEFAULT' ? null : userType,
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: localId ?? (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()
        }, null, annotationMarksForPos);
        const space = schema.text(' ', annotationMarksForPos);
        return (0, $5SAOw.Fragment).from([
            mentionNode,
            space
        ]);
    };
const $71881ae30930a463$export$8c4314a90d4c5fc1 = ({ sanitizePrivateContent: sanitizePrivateContent, api: api, mentionInsertDisplayName: mentionInsertDisplayName })=>({ name: name, id: id, userType: userType, localId: localId, nickname: nickname, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        return ({ tr: tr })=>{
            const mentionProvider = api?.mention.sharedState.currentState()?.mentionProvider;
            const mentionFragment = $71881ae30930a463$export$c39c34a625f03dcd({
                sanitizePrivateContent: sanitizePrivateContent,
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: tr
            })({
                name: name,
                id: id,
                userType: userType,
                nickname: nickname,
                localId: localId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            });
            return tr.insert(tr.selection.from, mentionFragment);
        };
    };
module.exports["createSingleMentionFragment"] = $71881ae30930a463$export$c39c34a625f03dcd;
module.exports["insertMention"] = $71881ae30930a463$export$8c4314a90d4c5fc1;

});

parcelRegister("8Shge", function(module, exports) {

var $CmplZ = parcelRequire("CmplZ");


var $24P9d = parcelRequire("24P9d");

const $7f5ae13a5d726242$var$isSSR = Boolean(undefined);
const $7f5ae13a5d726242$export$a9cde69b487c37ac = ()=>{
    if ($7f5ae13a5d726242$var$isSSR) return 0, $CmplZ.mention;
    return {
        ...(0, $CmplZ.mention),
        toDOM: (node)=>{
            // packages/elements/mention/src/components/Mention/index.tsx
            const mentionAttrs = {
                'aria-busy': 'true',
                contenteditable: 'false',
                'data-access-level': '',
                'data-mention-id': node.attrs.id,
                'data-prosemirror-content-type': 'node',
                'data-prosemirror-node-inline': 'true',
                'data-prosemirror-node-name': 'mention',
                style: (0, $24P9d.convertToInlineCss)({
                    display: 'inline',
                    border: `1px solid transparent`,
                    background: "var(--ds-background-neutral, #0515240F)",
                    color: "var(--ds-text-subtle, #505258)",
                    borderRadius: '20px',
                    cursor: 'pointer',
                    padding: '0 0.3em 2px 0.23em',
                    wordBreak: 'break-word'
                })
            };
            return [
                'span',
                mentionAttrs,
                node.attrs.text
            ];
        }
    };
};
module.exports["mentionNodeSpec"] = $7f5ae13a5d726242$export$a9cde69b487c37ac;

});

parcelRegister("9gkNA", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $c056e65a68cf462f$export$617302757e30e37c = new (0, $ks2lK.PluginKey)('mentionPlugin');
module.exports["mentionPluginKey"] = $c056e65a68cf462f$export$617302757e30e37c;

});

parcelRegister("8PUqB", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $2v1PW = parcelRequire("2v1PW");


var $3jsXx = parcelRequire("3jsXx");


var $6mYMS = parcelRequire("6mYMS");


var $dh538 = parcelRequire("dh538");


var $3v1AL = parcelRequire("3v1AL");


var $a5yde = parcelRequire("a5yde");


var $9gkNA = parcelRequire("9gkNA");


var $12WWZ = parcelRequire("12WWZ");

const $2f5e4de94cd8d98b$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER'
};
const $2f5e4de94cd8d98b$var$PACKAGE_NAME = "platform-pkg";
const $2f5e4de94cd8d98b$var$PACKAGE_VERSION = "0.0.0-use.local";
const $2f5e4de94cd8d98b$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $9gkNA.mentionPluginKey), {
            action: $2f5e4de94cd8d98b$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        }));
        return true;
    };
function $2f5e4de94cd8d98b$export$36c073f17660f60f({ pmPluginFactoryParams: pmPluginFactoryParams, fireEvent: fireEvent, options: options, api: api }) {
    let mentionProvider;
    const sendAnalytics = (event, actionSubject, action, attributes)=>{
        if (event === (0, $3jsXx.SLI_EVENT_TYPE) || event === (0, $3jsXx.SMART_EVENT_TYPE)) fireEvent({
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                packageName: $2f5e4de94cd8d98b$var$PACKAGE_NAME,
                packageVersion: $2f5e4de94cd8d98b$var$PACKAGE_VERSION,
                componentName: (0, $6mYMS.ComponentNames).MENTION,
                ...attributes
            }
        }, 'fabricElements');
    };
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $9gkNA.mentionPluginKey),
        state: {
            init (_, state) {
                const canInsertMention = (0, $12WWZ.canMentionBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    canInsertMention: canInsertMention
                };
            },
            apply (tr, pluginState, oldState, newState) {
                const { action: action, params: params } = tr.getMeta((0, $9gkNA.mentionPluginKey)) || {
                    action: null,
                    params: null
                };
                let hasNewPluginState = false;
                let newPluginState = pluginState;
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.docChanged || tr.selectionSet && hasPositionChanged) {
                    newPluginState = {
                        ...pluginState,
                        canInsertMention: (0, $12WWZ.canMentionBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState)
                    };
                    hasNewPluginState = true;
                }
                switch(action){
                    case $2f5e4de94cd8d98b$export$92a1a3b7554e9387.SET_PROVIDER:
                        newPluginState = {
                            ...newPluginState,
                            mentionProvider: params.provider
                        };
                        hasNewPluginState = true;
                        break;
                }
                if (hasNewPluginState) pmPluginFactoryParams.dispatch((0, $9gkNA.mentionPluginKey), newPluginState);
                if (options?.handleMentionsChanged && tr.docChanged) {
                    (0, $2v1PW.insm).session?.startFeature('mentionDeletionDetection');
                    const mentionSchema = newState.schema.nodes.mention;
                    const mentionsRemoved = new Map();
                    tr.steps.forEach((step, index)=>{
                        step.getMap().forEach((from, to)=>{
                            const newStart = tr.mapping.slice(index).map(from, -1);
                            const newEnd = tr.mapping.slice(index).map(to);
                            const oldStart = tr.mapping.invert().map(newStart, -1);
                            const oldEnd = tr.mapping.invert().map(newEnd);
                            const oldSlice = oldState.doc.slice(oldStart, oldEnd);
                            const newSlice = newState.doc.slice(newStart, newEnd);
                            const mentionsBefore = new Map();
                            const mentionsAfter = new Map();
                            oldSlice.content.descendants((node)=>{
                                if (node.type.name === mentionSchema.name && node.attrs.localId) mentionsBefore.set(node.attrs.localId, {
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                });
                            });
                            newSlice.content.descendants((node)=>{
                                if (node.type.name === mentionSchema.name && node.attrs.localId) mentionsAfter.set(node.attrs.localId, {
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                });
                            });
                            // Determine which mentions were removed in this step
                            mentionsBefore.forEach((mention, localId)=>{
                                if (!mentionsAfter.has(localId)) mentionsRemoved.set(localId, mention);
                            });
                            // Adjust mentionsRemoved by removing any that reappear
                            mentionsAfter.forEach((_, localId)=>{
                                if (mentionsRemoved.has(localId)) mentionsRemoved.delete(localId);
                            });
                        });
                    });
                    if (mentionsRemoved.size > 0) {
                        const changes = Array.from(mentionsRemoved.values()).map((mention)=>({
                                id: mention.id,
                                localId: mention.localId,
                                type: 'deleted'
                            }));
                        options.handleMentionsChanged(changes);
                    }
                    (0, $2v1PW.insm).session?.endFeature('mentionDeletionDetection');
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                mention: (node)=>{
                    return new (0, $3v1AL.MentionNodeView)(node, {
                        options: options,
                        api: api,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'mentionProvider':
                        if (!providerPromise) {
                            fireEvent({
                                action: (0, $d925B.ACTION).ERRORED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $a5yde.MENTION_PROVIDER_UNDEFINED)
                                }
                            });
                            return $2f5e4de94cd8d98b$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        }
                        providerPromise.then((provider)=>{
                            if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                            mentionProvider = provider;
                            $2f5e4de94cd8d98b$var$setProvider(provider)(editorView.state, editorView.dispatch);
                            provider.subscribe('mentionPlugin', undefined, undefined, undefined, undefined, sendAnalytics);
                        }).catch(()=>{
                            fireEvent({
                                action: (0, $d925B.ACTION).ERRORED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $a5yde.MENTION_PROVIDER_REJECTED)
                                }
                            });
                            return $2f5e4de94cd8d98b$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        });
                        break;
                }
                return;
            };
            const providerViaConfig = (0, $dh538.fg)('platform_editor_mention_provider_via_plugin_config');
            if (providerViaConfig && options?.mentionProvider) providerHandler('mentionProvider', options?.mentionProvider);
            else pmPluginFactoryParams.providerFactory.subscribe('mentionProvider', providerHandler);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('mentionProvider', providerHandler);
                    if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                }
            };
        }
    });
}
module.exports["ACTIONS"] = $2f5e4de94cd8d98b$export$92a1a3b7554e9387;
module.exports["createMentionPlugin"] = $2f5e4de94cd8d98b$export$36c073f17660f60f;

});

parcelRegister("3v1AL", function(module, exports) {

var $d7ZU3 = parcelRequire("d7ZU3");


var $TfRUG = parcelRequire("TfRUG");


var $5SAOw = parcelRequire("5SAOw");


var $bqMS3 = parcelRequire("bqMS3");

var $6mYMS = parcelRequire("6mYMS");





var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $2K8Se = parcelRequire("2K8Se");

const $562b7f45d4fe9a0b$var$primitiveClassName = 'editor-mention-primitive';
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $562b7f45d4fe9a0b$var$getAccessibilityLabelFromName = (name)=>name.replace(/^@/u, '');
const $562b7f45d4fe9a0b$var$toDOM = (node)=>{
    // packages/elements/mention/src/components/Mention/index.tsx
    let mentionAttrs = {
        contenteditable: 'false',
        'data-access-level': node.attrs.accessLevel,
        'data-mention-id': node.attrs.id,
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-inline': 'true',
        'data-prosemirror-node-name': 'mention',
        'data-prosemirror-node-view-type': 'vanilla',
        class: 'mentionView-content-wrap inlineNodeView'
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) mentionAttrs = {
        ...mentionAttrs,
        'data-local-id': node.attrs.localId
    };
    const browser = (0, $d7ZU3.getBrowserInfo)();
    return [
        'span',
        mentionAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $TfRUG.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            {
                spellcheck: 'false',
                class: $562b7f45d4fe9a0b$var$primitiveClassName
            },
            node.attrs.text || "@\u2026"
        ],
        browser.android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contenteditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $TfRUG.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            (0, $TfRUG.ZERO_WIDTH_SPACE)
        ]
    ];
};
const $562b7f45d4fe9a0b$var$processName = (name)=>{
    return name.status === (0, $6mYMS.MentionNameStatus).OK ? `@${name.name || ''}` : `@_|unknown|_`;
};
const $562b7f45d4fe9a0b$var$handleProviderName = async (mentionProvider, node)=>{
    if ((0, $bqMS3.isResolvingMentionProvider)(mentionProvider) && node.attrs.id && !node.attrs.text) {
        const nameDetail = mentionProvider?.resolveMentionName(node.attrs.id);
        const resolvedNameDetail = await nameDetail;
        return $562b7f45d4fe9a0b$var$processName(resolvedNameDetail);
    }
};
const $562b7f45d4fe9a0b$var$getNewState = (isHighlighted, isRestricted)=>{
    if (isHighlighted) return 'self';
    if (isRestricted) return 'restricted';
    return 'default';
};
class $562b7f45d4fe9a0b$export$ed501823ec7e75de {
    setClassList(state) {
        this.mentionPrimitiveElement?.classList.toggle('mention-self', state === 'self');
        this.mentionPrimitiveElement?.classList.toggle('mention-restricted', state === 'restricted');
    }
    setTextContent(name) {
        if (name && !this.node.attrs.text && this.mentionPrimitiveElement) this.mentionPrimitiveElement.textContent = name;
    }
    shouldHighlightMention(mentionProvider) {
        const { currentUserId: currentUserId } = this.config.options ?? {};
        // Check options first (immediate), then provider (async), then default to false
        if (currentUserId && this.node.attrs.id === currentUserId) return true;
        else return mentionProvider?.shouldHighlightMention({
            id: this.node.attrs.id
        }) ?? false;
    }
    async updateState(mentionProvider) {
        const isHighlighted = (0, $1oCLl.expValEquals)('platform_editor_vc90_transition_mentions', 'isEnabled', true) ? this.shouldHighlightMention(mentionProvider) : mentionProvider?.shouldHighlightMention({
            id: this.node.attrs.id
        }) ?? false;
        const newState = $562b7f45d4fe9a0b$var$getNewState(isHighlighted, (0, $6mYMS.isRestricted)(this.node.attrs.accessLevel));
        if (newState !== this.state) {
            this.setClassList(newState);
            this.state = newState;
        }
        const name = await $562b7f45d4fe9a0b$var$handleProviderName(mentionProvider, this.node);
        this.setTextContent(name);
        if (name && this.domElement && this.config.options?.profilecardProvider) this.domElement.setAttribute('aria-label', $562b7f45d4fe9a0b$var$getAccessibilityLabelFromName(name));
    }
    nodeIsEqual(nextNode) {
        if (this.config.options?.sanitizePrivateContent) {
            // Compare nodes but ignore the text parameter as it may be sanitized
            const nextNodeAttrs = {
                ...nextNode.attrs,
                text: this.node.attrs.text
            };
            return this.node.hasMarkup(nextNode.type, nextNodeAttrs, nextNode.marks);
        }
        return this.node.sameMarkup(nextNode);
    }
    update(node) {
        if (!this.nodeIsEqual(node)) return false;
        this.node = node;
        return true;
    }
    destroy() {
        this.cleanup?.();
        this.destroyProfileCard?.();
    }
    deselectNode() {
        this.removeProfileCard?.();
    }
    constructor(node, config){
        this.state = 'default';
        this.dom = void 0;
        this.domElement = void 0;
        this.contentDOM = void 0;
        this.config = void 0;
        this.node = void 0;
        this.cleanup = void 0;
        this.destroyProfileCard = void 0;
        this.removeProfileCard = void 0;
        this.mentionPrimitiveElement = void 0;
        const { options: options, api: api, portalProviderAPI: portalProviderAPI } = config;
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, $562b7f45d4fe9a0b$var$toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.config = config;
        this.node = node;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        this.mentionPrimitiveElement = this.domElement ? this.domElement.querySelector(`.${$562b7f45d4fe9a0b$var$primitiveClassName}`) ?? undefined : undefined;
        const { mentionProvider: mentionProvider } = api?.mention.sharedState.currentState() ?? {};
        this.updateState(mentionProvider);
        this.cleanup = api?.mention.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateState(nextSharedState?.mentionProvider);
        });
        const { destroyProfileCard: destroyProfileCard, removeProfileCard: removeProfileCard } = (0, $2K8Se.profileCardRenderer)({
            dom: dom,
            options: options,
            portalProviderAPI: portalProviderAPI,
            node: node,
            api: api
        });
        // Accessibility attributes - based on `packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx`
        if (this.domElement && options?.profilecardProvider) {
            if (node.attrs.text) this.domElement.setAttribute('aria-label', $562b7f45d4fe9a0b$var$getAccessibilityLabelFromName(node.attrs.text));
            this.domElement.setAttribute('aria-expanded', 'false');
            this.domElement.setAttribute('role', 'button');
            this.domElement.setAttribute('tabindex', '0');
            this.domElement.setAttribute('aria-haspopup', 'dialog');
        }
        this.destroyProfileCard = destroyProfileCard;
        this.removeProfileCard = removeProfileCard;
    }
}
module.exports["MentionNodeView"] = $562b7f45d4fe9a0b$export$ed501823ec7e75de;

});

parcelRegister("2K8Se", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $cUcZ5 = parcelRequire("cUcZ5");


var $ks2lK = parcelRequire("ks2lK");


var $lBy1w = parcelRequire("lBy1w");

const $cd857555fbf3a9f6$export$6adf928fbc333163 = ({ dom: dom, options: options, portalProviderAPI: portalProviderAPI, node: node, api: api })=>{
    let renderingProfileCard = false;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
    let cleanupSelection;
    const removeProfileCard = ()=>{
        if (dom instanceof HTMLElement) dom.setAttribute('aria-expanded', 'false');
        portalProviderAPI.remove(key);
        renderingProfileCard = false;
        cleanupSelection?.();
    };
    const listenerCleanup = (0, $fFa3V.bind)(dom, {
        type: 'click',
        listener: ()=>{
            if (dom instanceof HTMLElement && options?.profilecardProvider && !renderingProfileCard) {
                dom.setAttribute('aria-expanded', 'true');
                renderingProfileCard = true;
                portalProviderAPI.render(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lBy1w.ProfileCardComponent), {
                        activeMention: node,
                        profilecardProvider: options?.profilecardProvider,
                        dom: dom,
                        closeComponent: removeProfileCard
                    }), dom, key);
                // If we change the selection we should also remove the profile card. The "deselectNode"
                // should usually catch this, but it's possible (ie. on triple click) for this not to be called
                // which means the profile card gets stuck open until you click + change selection
                cleanupSelection = api?.selection?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                    const selection = nextSharedState?.selection;
                    if (selection instanceof (0, $ks2lK.NodeSelection) ? selection.node === node : false) return;
                    removeProfileCard?.();
                });
            }
        }
    });
    return {
        destroyProfileCard: ()=>{
            listenerCleanup();
            removeProfileCard?.();
        },
        removeProfileCard: removeProfileCard
    };
};
module.exports["profileCardRenderer"] = $cd857555fbf3a9f6$export$6adf928fbc333163;

});

parcelRegister("lBy1w", function(module, exports) {
/* ProfileCardComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $hF7dB = parcelRequire("hF7dB");


var $1oCLl = parcelRequire("1oCLl");


var $7uX2s = parcelRequire("7uX2s");

const $e4866ae3b60254eb$var$styles = {
    loadingStyles: "_2rko12b0 _16qs130s"
};
const $e4866ae3b60254eb$var$LoadingWrapper = ({ children: children, isLoading: isLoading })=>isLoading ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $e4866ae3b60254eb$var$styles.loadingStyles
        ]),
        children: children
    }) : children;
const $e4866ae3b60254eb$export$2776629671584a76 = ({ id: id, provider: provider })=>{
    const [data, setData] = (0, $42omo.useState)();
    const [reportingLinesData, setReportingLinesData] = (0, $42omo.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $42omo.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $42omo.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [hasError, setHasError] = (0, $42omo.useState)(false); // From: packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!id || !provider) return;
            setIsLoading(true);
            try {
                const [data, reportingLines, shouldGiveKudos, teamCentralBaseUrl] = await Promise.all([
                    provider?.resourceClient.getProfile(provider?.cloudId || '', id, ()=>{}),
                    provider?.resourceClient.getReportingLines(id),
                    provider?.resourceClient.shouldShowGiveKudos(),
                    provider?.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                setData(data);
                setReportingLinesData(reportingLines);
                setShouldShowGiveKudos(shouldGiveKudos ?? false);
                setTeamCentralBaseUrl(teamCentralBaseUrl);
                setHasError(false);
            } catch  {
                setHasError(true);
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        id,
        provider
    ]);
    return {
        data: data,
        reportingLinesData: reportingLinesData,
        shouldShowGiveKudos: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        isLoading: isLoading,
        hasError: hasError
    };
};
function $e4866ae3b60254eb$export$cbc1b955d6cce80d({ profilecardProvider: profilecardProvider, activeMention: activeMention, dom: dom, closeComponent: closeComponent }) {
    const [provider, setProvider] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        profilecardProvider?.then((p)=>{
            setProvider(p);
        });
    }, [
        profilecardProvider
    ]);
    const { id: id, text: text, accessLevel: accessLevel } = activeMention.attrs ?? {};
    const actions = (0, $42omo.useMemo)(()=>provider?.getActions(id, text ?? '', accessLevel), [
        accessLevel,
        id,
        provider,
        text
    ]);
    const { data: data, reportingLinesData: reportingLinesData, shouldShowGiveKudos: shouldShowGiveKudos, teamCentralBaseUrl: teamCentralBaseUrl, isLoading: isLoading, hasError: hasError } = $e4866ae3b60254eb$export$2776629671584a76({
        id: id,
        provider: provider
    });
    (0, $42omo.useEffect)(()=>{
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') closeComponent();
            }
        });
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7uX2s.Popup), {
        referenceElement: dom,
        children: /*#__PURE__*/ (0, $l998X.jsx)($e4866ae3b60254eb$var$LoadingWrapper, {
            isLoading: isLoading,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hF7dB.ProfileCardLazy), {
                avatarUrl: data?.avatarUrl,
                accountType: data?.accountType,
                status: data?.status,
                statusModifiedDate: data?.statusModifiedDate,
                timestring: data?.timestring,
                isCurrentUser: data?.isCurrentUser,
                isBot: data?.isBot,
                fullName: data?.fullName,
                userId: id,
                cloudId: provider?.cloudId,
                actions: actions,
                isLoading: isLoading,
                location: data?.location,
                companyName: data?.companyName,
                customLozenges: data?.customLozenges,
                nickname: data?.nickname,
                email: data?.email,
                hasError: hasError,
                reportingLines: reportingLinesData,
                isKudosEnabled: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl,
                isRenderedInPortal: (0, $1oCLl.expValEquals)('editor_a11y_7152_profile_card_tab_order', 'isEnabled', true)
            })
        })
    });
}
module.exports["ProfileCardComponent"] = $e4866ae3b60254eb$export$cbc1b955d6cce80d;

});

parcelRegister("7uX2s", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lqsSp = parcelRequire("lqsSp");


var $caX7N = parcelRequire("caX7N");


var $g5lKx = parcelRequire("g5lKx");


var $26KdU = parcelRequire("26KdU");

const $2f02737abfc96a63$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        children
    ]);
    return children;
};
function $2f02737abfc96a63$export$129a32eedafa97c5({ referenceElement: referenceElement, children: children }) {
    const [targetRef, setPopupRef] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    (0, $26KdU.useFocusTrap)({
        targetRef: targetRef
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
            zIndex: (0, $g5lKx.layers).modal(),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
                referenceElement: referenceElement,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    0,
                    8
                ],
                placement: "bottom-end",
                strategy: "fixed",
                children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ref: (node)=>{
                            if (node) {
                                if (typeof ref === 'function') ref(node);
                                else ref.current = node;
                                setPopupRef(node);
                            }
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                        style: style,
                        children: /*#__PURE__*/ (0, $l998X.jsx)($2f02737abfc96a63$export$51eddd7655ca235a, {
                            update: update,
                            children: children
                        })
                    })
            })
        })
    });
}
module.exports["Popup"] = $2f02737abfc96a63$export$129a32eedafa97c5;

});

parcelRegister("26KdU", function(module, exports) {
/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */ 
var $42omo = parcelRequire("42omo");


var $iqsGx = parcelRequire("iqsGx");

const $17acc0524b257831$export$5562a1f223a0d314 = ({ targetRef: targetRef })=>{
    (0, $42omo.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: true
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($iqsGx)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef
    ]);
};
module.exports["useFocusTrap"] = $17acc0524b257831$export$5562a1f223a0d314;

});

parcelRegister("a5yde", function(module, exports) {
const $07adcb0974ca6bda$export$7d0bcf8324b20190 = 'REJECTED';
const $07adcb0974ca6bda$export$eceeecffdf63fc89 = 'UNDEFINED';
module.exports["MENTION_PROVIDER_REJECTED"] = $07adcb0974ca6bda$export$7d0bcf8324b20190;
module.exports["MENTION_PROVIDER_UNDEFINED"] = $07adcb0974ca6bda$export$eceeecffdf63fc89;

});

parcelRegister("12WWZ", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $9gkNA = parcelRequire("9gkNA");

function $ed26758b0d30a729$export$1e2b0e72eff65e51(state) {
    return (0, $9gkNA.mentionPluginKey).getState(state);
}
const $ed26758b0d30a729$export$bdc4118452fb5868 = (from, to)=>(state)=>{
        const $from = state.doc.resolve(from);
        const $to = state.doc.resolve(to);
        const mention = state.schema.nodes.mention.createChecked();
        if ($from.parent === $to.parent && (0, $8m4tT.canInsert)($from, mention)) return true;
        return false;
    };
module.exports["getMentionPluginState"] = $ed26758b0d30a729$export$1e2b0e72eff65e51;
module.exports["canMentionBeCreatedInRange"] = $ed26758b0d30a729$export$bdc4118452fb5868;

});

parcelRegister("cKd84", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");

const $523a0cfe30e27936$export$42622392b518cf42 = new (0, $ks2lK.PluginKey)('mentionPlaceholderPlugin');
const $523a0cfe30e27936$export$9db21fd659b6b6c3 = {
    SHOW_PLACEHOLDER: 'SHOW_PLACEHOLDER',
    HIDE_PLACEHOLDER: 'HIDE_PLACEHOLDER'
};
function $523a0cfe30e27936$export$a6f49f496e9473d7() {
    return new (0, $1S4f7.SafePlugin)({
        key: $523a0cfe30e27936$export$42622392b518cf42,
        state: {
            init: ()=>({}),
            apply (tr, pluginState) {
                const meta = tr.getMeta($523a0cfe30e27936$export$42622392b518cf42);
                if (meta?.action === $523a0cfe30e27936$export$9db21fd659b6b6c3.SHOW_PLACEHOLDER) return {
                    placeholder: meta.placeholder
                };
                if (meta?.action === $523a0cfe30e27936$export$9db21fd659b6b6c3.HIDE_PLACEHOLDER) return {};
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                const pluginState = $523a0cfe30e27936$export$42622392b518cf42.getState(state);
                if (pluginState?.placeholder) {
                    const { selection: selection } = state;
                    const span = document.createElement('span');
                    span.textContent = pluginState.placeholder;
                    span.style.setProperty('color', "var(--ds-text-accent-blue, #1558BC)");
                    return (0, $ftzrq.DecorationSet).create(state.doc, [
                        (0, $ftzrq.Decoration).widget(selection.from, span)
                    ]);
                }
                return null;
            }
        }
    });
}
module.exports["mentionPlaceholderPluginKey"] = $523a0cfe30e27936$export$42622392b518cf42;
module.exports["MENTION_PLACEHOLDER_ACTIONS"] = $523a0cfe30e27936$export$9db21fd659b6b6c3;
module.exports["createMentionPlaceholderPlugin"] = $523a0cfe30e27936$export$a6f49f496e9473d7;

});

parcelRegister("9kFq1", function(module, exports) {
/* InlineInviteRecaptchaContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cKd84 = parcelRequire("cKd84");


var $17rN2 = parcelRequire("17rN2");

const $be70682421d667bb$export$468624c2fd30bc43 = ({ mentionProvider: mentionProvider, api: api })=>{
    const [provider, setProvider] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!mentionProvider) return;
        let isMounted = true;
        mentionProvider.then((resolvedProvider)=>{
            if (!isMounted) return;
            setProvider(resolvedProvider);
        }).catch(()=>{
        // Silently handle promise rejection
        });
        return ()=>{
            isMounted = false;
            setProvider(null);
        };
    }, [
        mentionProvider
    ]);
    const handleSuccess = (0, $42omo.useCallback)((userId, email)=>{
        if (!api?.mention?.commands?.insertMention || !api?.core?.actions?.execute) return;
        const name = email.split('@')[0] || email;
        api.core.actions.execute(api.mention.commands.insertMention({
            id: userId,
            name: name,
            userType: 'DEFAULT',
            accessLevel: 'CONTAINER'
        }));
        api.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $cKd84.mentionPlaceholderPluginKey), {
                action: (0, $cKd84.MENTION_PLACEHOLDER_ACTIONS).HIDE_PLACEHOLDER
            });
            return tr;
        });
    }, [
        api
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        if (!api?.core?.actions?.execute) return;
        api.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $cKd84.mentionPlaceholderPluginKey), {
                action: (0, $cKd84.MENTION_PLACEHOLDER_ACTIONS).HIDE_PLACEHOLDER
            });
            return tr;
        });
    }, [
        api
    ]);
    const handleReady = (0, $42omo.useCallback)((showRecaptcha)=>{
        if (provider) {
            if (showRecaptcha) provider.showInlineInviteRecaptcha = showRecaptcha;
            else delete provider.showInlineInviteRecaptcha;
        }
    }, [
        provider
    ]);
    if (!provider?.InlineInviteRecaptcha || !api?.mention?.commands?.insertMention || !api?.core?.actions?.execute) return null;
    const RecaptchaComponent = provider.InlineInviteRecaptcha;
    return /*#__PURE__*/ (0, $l998X.jsx)(RecaptchaComponent, {
        analyticsSource: (0, $17rN2.MENTION_SOURCE),
        onSuccess: handleSuccess,
        onClose: handleClose,
        onReady: handleReady
    });
};
module.exports["InlineInviteRecaptchaContainer"] = $be70682421d667bb$export$468624c2fd30bc43;

});

parcelRegister("17rN2", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $6mYMS = parcelRequire("6mYMS");


var $gmydP = parcelRequire("gmydP");

const $a0ac5818e0563ad4$var$componentName = 'mention';
const $a0ac5818e0563ad4$export$867a43da6e470584 = 'mentionInEditor';
const $a0ac5818e0563ad4$var$emptyQueryResponse = {
    queryLength: 0,
    spaceInQuery: false
};
const $a0ac5818e0563ad4$var$extractAttributesFromQuery = (query)=>{
    if (query) return {
        queryLength: query.length,
        spaceInQuery: query.indexOf(' ') !== -1
    };
    return $a0ac5818e0563ad4$var$emptyQueryResponse;
};
const $a0ac5818e0563ad4$export$e1d5d51810b7e165 = (duration, upKeyCount, downKeyCount, sessionId, query)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $a0ac5818e0563ad4$var$extractAttributesFromQuery(query);
    return {
        action: (0, $d925B.ACTION).CANCELLED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            componentName: $a0ac5818e0563ad4$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            sessionId: sessionId
        }
    };
};
const $a0ac5818e0563ad4$var$getPosition = (mentionList, selectedMention)=>{
    if (mentionList) {
        const index = mentionList.findIndex((mention)=>mention.id === selectedMention.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $a0ac5818e0563ad4$var$isClicked = (insertType)=>insertType === 'selected';
const $a0ac5818e0563ad4$export$c102b710f5c857c4 = (sessionId, contextIdentifierProvider, userRole, additionalAttributes)=>{
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: (0, $d925B.ACTION).RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            componentName: $a0ac5818e0563ad4$var$componentName,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            source: $a0ac5818e0563ad4$export$867a43da6e470584,
            ...additionalAttributes
        }
    };
};
const $a0ac5818e0563ad4$export$e4c4d872dcfe2b15 = (duration, upKeyCount, downKeyCount, sessionId, insertType, query, contextIdentifierProvider, userRole, additionalAttributes)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $a0ac5818e0563ad4$var$extractAttributesFromQuery(query);
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: $a0ac5818e0563ad4$var$isClicked(insertType) ? (0, $d925B.ACTION).CLICKED : (0, $d925B.ACTION).PRESSED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            componentName: $a0ac5818e0563ad4$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            keyboardKey: $a0ac5818e0563ad4$var$isClicked(insertType) ? undefined : insertType,
            ...additionalAttributes
        }
    };
};
const $a0ac5818e0563ad4$export$84030a552533cdf8 = (duration, upKeyCount, downKeyCount, sessionId, insertType, mention, mentionLocalId, mentionList, query, contextIdentifierProvider, taskListId, taskItemId)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $a0ac5818e0563ad4$var$extractAttributesFromQuery(query);
    let containerId;
    let objectId;
    let childObjectId;
    if (contextIdentifierProvider) {
        containerId = contextIdentifierProvider.containerId || undefined;
        objectId = contextIdentifierProvider.objectId || undefined;
        childObjectId = contextIdentifierProvider.childObjectId || undefined;
    }
    return {
        action: $a0ac5818e0563ad4$var$isClicked(insertType) ? (0, $d925B.ACTION).CLICKED : (0, $d925B.ACTION).PRESSED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        containerId: containerId,
        objectId: objectId,
        childObjectId: childObjectId,
        attributes: {
            sessionId: sessionId,
            duration: duration,
            position: $a0ac5818e0563ad4$var$getPosition(mentionList, mention),
            keyboardKey: $a0ac5818e0563ad4$var$isClicked(insertType) ? undefined : insertType,
            source: mention.source,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            isSpecial: (0, $6mYMS.isSpecialMention)(mention),
            accessLevel: mention.accessLevel || '',
            userType: mention.userType,
            userId: mention.id,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            memberCount: (0, $gmydP.isTeamType)(mention.userType) && mention.context ? mention.context.memberCount : null,
            includesYou: (0, $gmydP.isTeamType)(mention.userType) && mention.context ? mention.context.includesYou : null,
            taskListId: taskListId,
            taskItemId: taskItemId,
            localId: mentionLocalId,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId
        }
    };
};
const $a0ac5818e0563ad4$export$901fb6651fc13b0e = (duration, userIds, query, teams, xProductMentionsLength)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $a0ac5818e0563ad4$var$extractAttributesFromQuery(query);
    const actionSubject = userIds ? (0, $d925B.ACTION_SUBJECT).MENTION_TYPEAHEAD : (0, $d925B.ACTION_SUBJECT).TEAM_MENTION_TYPEAHEAD;
    return {
        action: (0, $d925B.ACTION).RENDERED,
        actionSubject: actionSubject,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            componentName: $a0ac5818e0563ad4$var$componentName,
            duration: duration,
            userIds: userIds,
            teams: teams,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            xProductMentionsLength: xProductMentionsLength
        }
    };
};
module.exports["MENTION_SOURCE"] = $a0ac5818e0563ad4$export$867a43da6e470584;
module.exports["buildTypeAheadCancelPayload"] = $a0ac5818e0563ad4$export$e1d5d51810b7e165;
module.exports["buildTypeAheadInviteItemViewedPayload"] = $a0ac5818e0563ad4$export$c102b710f5c857c4;
module.exports["buildTypeAheadInviteItemClickedPayload"] = $a0ac5818e0563ad4$export$e4c4d872dcfe2b15;
module.exports["buildTypeAheadInsertedPayload"] = $a0ac5818e0563ad4$export$84030a552533cdf8;
module.exports["buildTypeAheadRenderedPayload"] = $a0ac5818e0563ad4$export$901fb6651fc13b0e;

});

parcelRegister("gmydP", function(module, exports) {

var $e1wFI = parcelRequire("e1wFI");

const $fcd57767319030fa$export$6ddb6ef001273170 = (userType)=>userType === 'TEAM';
const $fcd57767319030fa$export$c427182c53a1ba5 = (stat)=>stat && !isNaN(stat.teamMentionDuration);
const $fcd57767319030fa$export$f5a334b5a28d1e01 = (mention)=>mention && mention.id === (0, $e1wFI.INVITE_ITEM_DESCRIPTION).id;
const $fcd57767319030fa$export$16a134d4e1b461dc = (query, firstQueryWithoutResults)=>{
    if (!firstQueryWithoutResults) return true;
    const lastIndexWithResults = firstQueryWithoutResults.length - 1;
    let suffix = query.slice(lastIndexWithResults);
    if (query[lastIndexWithResults - 1] === ' ') suffix = ' ' + suffix;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const depletedExtraWords = /\s[^\s]+\s/.test(suffix);
    return !depletedExtraWords;
};
module.exports["isTeamType"] = $fcd57767319030fa$export$6ddb6ef001273170;
module.exports["isTeamStats"] = $fcd57767319030fa$export$c427182c53a1ba5;
module.exports["isInviteItem"] = $fcd57767319030fa$export$f5a334b5a28d1e01;
module.exports["shouldKeepInviteItem"] = $fcd57767319030fa$export$16a134d4e1b461dc;

});

parcelRegister("e1wFI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ePpFN = parcelRequire("ePpFN");


var $g5gZt = parcelRequire("g5gZt");

const $dca1e095f42e8aa9$var$mentionItemStyle = null;
const $dca1e095f42e8aa9$var$mentionItemSelectedStyle = null;
const $dca1e095f42e8aa9$var$rowStyle = null;
const $dca1e095f42e8aa9$var$avatarStyle = null;
const $dca1e095f42e8aa9$var$nameSectionStyle = null;
const $dca1e095f42e8aa9$var$capitalizedStyle = null;
const $dca1e095f42e8aa9$export$75621ed4176efc9e = {
    id: 'invite-teammate'
}; // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dca1e095f42e8aa9$var$leftClick = (event)=>{
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
};
const $dca1e095f42e8aa9$var$InviteItem = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, intl: intl })=>{
    const onSelected = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onSelection) {
            // For mouse events, only handle left click
            if ('button' in event && !$dca1e095f42e8aa9$var$leftClick(event)) return;
             // For keyboard events, only handle Enter and Space
            if ('key' in event && event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            onSelection($dca1e095f42e8aa9$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($dca1e095f42e8aa9$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    const onItemFocus = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($dca1e095f42e8aa9$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "button",
        tabIndex: 0,
        onMouseDown: onSelected,
        onKeyDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        onFocus: onItemFocus,
        "data-id": $dca1e095f42e8aa9$export$75621ed4176efc9e.id,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _bfhk1j28 _1e0c1ule _2mzuglyw _80omtlke",
            selected && "_bfhk1dpa"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvdlk8 _u5f3dlk8 _1bto1l2s _s7n4nkob"
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                        label: intl.formatMessage((0, $ePpFN.mentionMessages).mentionsAddLabel),
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-testid": "name-section",
                    className: (0, $gMc0m.default)([
                        "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0dlk8 _syazazsu"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage // Ignored via go/ees005
                    ), {
                        ...(0, $ePpFN.mentionMessages).inviteItemTitle,
                        values: {
                            userRole: userRole || 'basic',
                            productName: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                                "data-testid": "capitalized-message",
                                className: (0, $gMc0m.default)([
                                    "_1p1d1dk0"
                                ]),
                                children: productName
                            })
                        }
                    })
                })
            ]
        })
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $dca1e095f42e8aa9$var$_default_1 = (0, $aXWIB.injectIntl)($dca1e095f42e8aa9$var$InviteItem);
var $dca1e095f42e8aa9$export$2e2bcd8739ae039 = $dca1e095f42e8aa9$var$_default_1;
module.exports["INVITE_ITEM_DESCRIPTION"] = $dca1e095f42e8aa9$export$75621ed4176efc9e;
module.exports["default"] = $dca1e095f42e8aa9$export$2e2bcd8739ae039;

});

parcelRegister("jziTd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");


var $1NfJ1 = parcelRequire("1NfJ1");

const $84f7a9985f2b0dd5$var$selector = (states)=>{
    return {
        mentionProvider: states.mentionState?.mentionProvider
    };
};
function $84f7a9985f2b0dd5$export$124ea4367cf7d1fc({ editorView: editorView, api: api, typeAhead: typeAhead, disabled: disabled }) {
    const { mentionProvider: mentionProvider } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'mention'
    ], $84f7a9985f2b0dd5$var$selector);
    const openMentionTypeAhead = (0, $42omo.useCallback)(()=>{
        api?.typeAhead?.actions?.open({
            triggerHandler: typeAhead,
            inputMethod: (0, $d925B.INPUT_METHOD).INSERT_MENU
        });
    }, [
        api,
        typeAhead
    ]);
    return !mentionProvider ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $1NfJ1.default), {
        editorView: editorView,
        onInsertMention: openMentionTypeAhead,
        isDisabled: disabled || api?.typeAhead?.actions.isAllowed(editorView.state)
    });
}
module.exports["SecondaryToolbarComponent"] = $84f7a9985f2b0dd5$export$124ea4367cf7d1fc;

});

parcelRegister("1NfJ1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ePpFN = parcelRequire("ePpFN");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $b4wUN = parcelRequire("b4wUN");

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $263cf3fdef9fdf3d$var$ToolbarMention extends (0, $42omo.PureComponent) {
    render() {
        const mentionStringTranslated = this.props.intl.formatMessage((0, $ePpFN.mentionMessages).mentionsIconLabel);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
            testId: this.props.testId,
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).MENTION,
            spacing: "none",
            onClick: this.handleInsertMention,
            disabled: this.props.isDisabled,
            title: mentionStringTranslated + '@',
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                label: mentionStringTranslated
            })
        });
    }
    constructor(...args){
        super(...args);
        this.handleInsertMention = ()=>{
            if (!this.props.editorView) return false;
            this.props.onInsertMention();
            return true;
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $263cf3fdef9fdf3d$var$_default_1 = (0, $aXWIB.injectIntl)($263cf3fdef9fdf3d$var$ToolbarMention);
var $263cf3fdef9fdf3d$export$2e2bcd8739ae039 = $263cf3fdef9fdf3d$var$_default_1;
module.exports["default"] = $263cf3fdef9fdf3d$export$2e2bcd8739ae039;

});

parcelRegister("jDVxk", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $lOELb = parcelRequire("lOELb");


var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $dVkxw = parcelRequire("dVkxw");

var $dGsOm = parcelRequire("dGsOm");


var $bqMS3 = parcelRequire("bqMS3");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $3ZAfE = parcelRequire("3ZAfE");


var $cKd84 = parcelRequire("cKd84");


var $12WWZ = parcelRequire("12WWZ");


var $e1wFI = parcelRequire("e1wFI");


var $ekqC5 = parcelRequire("ekqC5");


var $17rN2 = parcelRequire("17rN2");


var $gmydP = parcelRequire("gmydP");

const $24a7b456f3432eef$var$createInviteItem = ({ mentionProvider: mentionProvider, onInviteItemMount: onInviteItemMount, query: query, emailDomain: emailDomain })=>({
        title: (0, $e1wFI.INVITE_ITEM_DESCRIPTION).id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>emailDomain && mentionProvider.getShouldEnableInlineInvite?.() && (0, $dh538.fg)('jira_invites_auto_tag_new_user_in_mentions_fg') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ekqC5.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole,
                query: query,
                emailDomain: emailDomain
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $e1wFI.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole
            }),
        mention: (0, $e1wFI.INVITE_ITEM_DESCRIPTION)
    });
const $24a7b456f3432eef$var$withInviteItem = ({ mentionProvider: mentionProvider, firstQueryWithoutResults: firstQueryWithoutResults, currentQuery: currentQuery, onInviteItemMount: onInviteItemMount, emailDomain: emailDomain })=>(mentionItems)=>{
        const inviteItem = $24a7b456f3432eef$var$createInviteItem({
            mentionProvider: mentionProvider,
            onInviteItemMount: onInviteItemMount,
            query: currentQuery,
            emailDomain: emailDomain
        });
        const keepInviteItem = (0, $gmydP.shouldKeepInviteItem)(currentQuery, firstQueryWithoutResults);
        if (mentionItems.length === 0) return keepInviteItem ? [
            inviteItem
        ] : [];
        return [
            ...mentionItems,
            // invite item should be shown at the bottom
            inviteItem
        ];
    };
const $24a7b456f3432eef$export$f476360102d72b2 = (mention)=>{
    return {
        title: mention.id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dGsOm.default), {
                mention: mention,
                selected: isSelected,
                onMouseEnter: onHover,
                onSelection: onClick
            }),
        getCustomComponentHeight: ()=>{
            return 0, $dVkxw.MENTION_ITEM_HEIGHT;
        },
        mention: mention
    };
};
function $24a7b456f3432eef$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(mention) {
        // Check cache for hits
        const hit = seen.get(mention.id);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(mention);
        seen.set(mention.id, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $24a7b456f3432eef$var$memoizedToItem = $24a7b456f3432eef$export$fc10aeed3a532e2a($24a7b456f3432eef$export$f476360102d72b2);
const $24a7b456f3432eef$var$buildAndSendElementsTypeAheadAnalytics = (fireEvent)=>({ query: query, mentions: mentions, stats: stats })=>{
        let duration = 0;
        let userOrTeamIds = null;
        let teams = null;
        let xProductMentionsLength = 0;
        if (!(0, $gmydP.isTeamStats)(stats)) {
            // is from primary mention endpoint which could be just user mentions or user/team mentions
            duration = stats && stats.duration;
            teams = null;
            userOrTeamIds = mentions.map((mention)=>mention.id);
            xProductMentionsLength = mentions.filter((mention)=>mention.isXProductUser).length;
        } else {
            // is from dedicated team-only mention endpoint
            duration = stats && stats.teamMentionDuration;
            userOrTeamIds = null;
            teams = mentions.map((mention)=>(0, $gmydP.isTeamType)(mention.userType) ? {
                    teamId: mention.id,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    includesYou: mention.context.includesYou,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    memberCount: mention.context.memberCount
                } : null).filter((m)=>!!m);
        }
        const payload = (0, $17rN2.buildTypeAheadRenderedPayload)(duration, userOrTeamIds, query, teams, xProductMentionsLength);
        fireEvent(payload, 'fabric-elements');
    };
/**
 * When a team mention is selected, we render a team link and list of member/user mentions
 * in editor content
 */ const $24a7b456f3432eef$var$buildNodesForTeamMention = (schema, selectedMention, mentionProvider, sanitizePrivateContent)=>{
    const { nodes: nodes, marks: marks } = schema;
    const { name: name, id: teamId, accessLevel: accessLevel, context: context } = selectedMention;
    // build team link
    const defaultTeamLink = `${window.location.origin}/people/team/${teamId}`;
    const teamLink = context && context.teamLink ? context.teamLink : defaultTeamLink;
    const teamLinkNode = (0, $dh538.fg)('team-mention-inline-smartlink') ? schema.nodes.inlineCard.create({
        url: teamLink
    }) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    schema.text(name, [
        marks.link.create({
            href: teamLink
        })
    ]);
    const openBracketText = schema.text('(');
    const closeBracketText = schema.text(')');
    const emptySpaceText = schema.text(' ');
    const inlineNodes = [
        teamLinkNode,
        emptySpaceText,
        openBracketText
    ];
    const members = context && context.members ? context.members : [];
    members.forEach((member, index)=>{
        const { name: name, id: id } = member;
        const mentionName = `@${name}`;
        const text = sanitizePrivateContent ? '' : mentionName;
        if (sanitizePrivateContent && (0, $bqMS3.isResolvingMentionProvider)(mentionProvider)) mentionProvider.cacheMentionName(id, name);
        const userMentionNode = nodes.mention.createChecked({
            text: text,
            id: member.id,
            accessLevel: accessLevel,
            userType: 'DEFAULT',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()
        });
        inlineNodes.push(userMentionNode);
        // should not add empty space after the last user mention.
        if (index !== members.length - 1) inlineNodes.push(emptySpaceText);
    });
    inlineNodes.push(closeBracketText);
    return (0, $5SAOw.Fragment).fromArray(inlineNodes);
};
const $24a7b456f3432eef$export$90e81ee10e57772b = ({ sanitizePrivateContent: sanitizePrivateContent, mentionInsertDisplayName: mentionInsertDisplayName, fireEvent: fireEvent, HighlightComponent: HighlightComponent, api: api, handleMentionsChanged: handleMentionsChanged })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    let sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
    let firstQueryWithoutResults = null;
    const subscriptionKeys = new Set();
    const typeAhead = {
        id: (0, $lOELb.TypeAheadAvailableNodes).MENTION,
        trigger: '@',
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(@)',
        getHighlight: (_state)=>{
            const CustomHighlightComponent = HighlightComponent;
            if (CustomHighlightComponent) return /*#__PURE__*/ (0, $l998X.jsx)(CustomHighlightComponent, {});
            return null;
        },
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = (0, $12WWZ.getMentionPluginState)(editorState);
            if (!pluginState?.mentionProvider) return Promise.resolve([]);
            const { mentionProvider: mentionProvider } = pluginState;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            return new Promise((resolve, reject)=>{
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const key = `loadingMentionsForTypeAhead_${(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()}`;
                const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
                    if (query !== resultQuery) return;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    const mentionItems = mentions.map((mention)=>$24a7b456f3432eef$var$memoizedToItem.call(mention));
                    $24a7b456f3432eef$var$buildAndSendElementsTypeAheadAnalytics(fireEvent)({
                        query: query,
                        mentions: mentions,
                        stats: stats
                    });
                    if (mentions.length === 0 && firstQueryWithoutResults === null) firstQueryWithoutResults = query;
                    if (!mentionProvider.shouldEnableInvite || mentionItems.length > 2) resolve(mentionItems);
                    else {
                        const emailDomain = mentionProvider.userEmailDomain;
                        const items = $24a7b456f3432eef$var$withInviteItem({
                            mentionProvider: mentionProvider,
                            firstQueryWithoutResults: firstQueryWithoutResults || '',
                            currentQuery: query,
                            onInviteItemMount: ()=>{
                                fireEvent((0, $17rN2.buildTypeAheadInviteItemViewedPayload)(sessionId, contextIdentifierProvider, mentionProvider.userRole, (0, $dh538.fg)('jira_invites_auto_tag_new_user_in_mentions_fg') ? {
                                    isInlineInviteMentionsEnabled: mentionProvider.getShouldEnableInlineInvite?.()
                                } : {}));
                            },
                            emailDomain: emailDomain
                        })(mentionItems);
                        resolve(items);
                    }
                };
                subscriptionKeys.add(key);
                mentionProvider.subscribe(key, mentionsSubscribeCallback, ()=>{
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
                        mentionProvider.unsubscribe(key);
                        subscriptionKeys.delete(key);
                        reject('FETCH_ERROR');
                    }
                });
                mentionProvider.filter(query || '', {
                    ...contextIdentifierProvider,
                    sessionId: sessionId
                });
            });
        },
        onOpen: ()=>{
            firstQueryWithoutResults = null;
        },
        selectItem (state, item, insert, { mode: mode, stats: stats, query: query, sourceListItem: sourceListItem }) {
            const { schema: schema } = state;
            const pluginState = (0, $12WWZ.getMentionPluginState)(state);
            const { mentionProvider: mentionProvider } = pluginState;
            const { id: id, name: name, nickname: nickname, accessLevel: accessLevel, userType: userType, isXProductUser: isXProductUser } = item.mention;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            const mentionContext = {
                ...contextIdentifierProvider,
                sessionId: sessionId
            };
            if (mentionProvider && !(0, $gmydP.isInviteItem)(item.mention)) mentionProvider.recordMentionSelection(item.mention, mentionContext);
            // use same timer as StatsModifier
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (mentionProvider && mentionProvider.shouldEnableInvite && (0, $gmydP.isInviteItem)(item.mention)) {
                // Don't fire event and the callback with selection by space press
                if (mode !== 'space') {
                    fireEvent((0, $17rN2.buildTypeAheadInviteItemClickedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, query, contextIdentifierProvider, mentionProvider.userRole, (0, $dh538.fg)('jira_invites_auto_tag_new_user_in_mentions_fg') ? {
                        isInlineInviteMentionsEnabled: mentionProvider.getShouldEnableInlineInvite?.()
                    } : {}));
                    if (mentionProvider.getShouldEnableInlineInvite?.() && (0, $dh538.fg)('jira_invites_auto_tag_new_user_in_mentions_fg')) {
                        // Get the email from query, using the same logic as InviteItemWithEmailDomain
                        const emailDomain = mentionProvider.userEmailDomain;
                        let email = query || '';
                        // If query doesn't include @ and we have an email domain, append it
                        if (email && !email.includes('@') && emailDomain) email = `${email.toLowerCase()}@${emailDomain}`;
                        // If query already includes @, use it as is
                        if (email && mentionProvider.showInlineInviteRecaptcha) {
                            mentionProvider.showInlineInviteRecaptcha(email);
                            const { tr: tr } = state;
                            tr.setMeta((0, $cKd84.mentionPlaceholderPluginKey), {
                                action: (0, $cKd84.MENTION_PLACEHOLDER_ACTIONS).SHOW_PLACEHOLDER,
                                placeholder: `@${query}`
                            });
                            return tr;
                        }
                    } else if (mentionProvider.onInviteItemClick) // Fallback to old behavior for backward compatibility
                    mentionProvider.onInviteItemClick('mention');
                }
                return state.tr;
            }
            let taskListId, taskItemId;
            const taskList = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.taskList)(state.selection);
            if (taskList) {
                taskListId = taskList.node.attrs.localId;
                const taskItem = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.taskItem)(state.selection);
                if (taskItem) taskItemId = taskItem.node.attrs.localId;
            }
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const mentionLocalId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
            if (handleMentionsChanged) {
                if (taskItemId) handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id,
                        taskLocalId: taskItemId,
                        method: 'typed'
                    }
                ]);
                else handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id,
                        method: 'typed'
                    }
                ]);
            }
            fireEvent((0, $17rN2.buildTypeAheadInsertedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, item.mention, mentionLocalId, sourceListItem.map((x)=>x.mention), query, contextIdentifierProvider, taskListId, taskItemId));
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
            if (mentionProvider && (0, $gmydP.isTeamType)(userType)) return insert($24a7b456f3432eef$var$buildNodesForTeamMention(schema, item.mention, mentionProvider, sanitizePrivateContent));
            if (isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
            return insert((0, $3ZAfE.createSingleMentionFragment)({
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: state.tr,
                sanitizePrivateContent: sanitizePrivateContent
            })({
                name: name,
                id: id,
                userType: userType,
                nickname: nickname,
                localId: mentionLocalId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            }));
        },
        dismiss ({ editorState: editorState, query: query, stats: stats, wasItemInserted: wasItemInserted }) {
            firstQueryWithoutResults = null;
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (!wasItemInserted) fireEvent((0, $17rN2.buildTypeAheadCancelPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, query || ''), 'fabric-elements');
            const pluginState = (0, $12WWZ.getMentionPluginState)(editorState);
            if (pluginState?.mentionProvider) {
                const mentionProvider = pluginState.mentionProvider;
                for (const key of subscriptionKeys)mentionProvider.unsubscribe(key);
            }
            subscriptionKeys.clear();
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        }
    };
    return typeAhead;
};
module.exports["createTypeAheadConfig"] = $24a7b456f3432eef$export$90e81ee10e57772b;

});

parcelRegister("dVkxw", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dh538 = parcelRequire("dh538");


var $cStGJ = parcelRequire("cStGJ");

function $69c88bcb95aa7e29$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $69c88bcb95aa7e29$export$be24b091af3609e7 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs7"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $69c88bcb95aa7e29$export$141d6bfd196b561 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1b3haxs6"
})((props)=>({
        position: 'relative',
        flex: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $69c88bcb95aa7e29$export$159b59de9966d2d3 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs5"
})((props)=>({
        flex: 1,
        minWidth: 0,
        marginLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $69c88bcb95aa7e29$export$d1c198a7fd873fad = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1b3haxs4"
})({
    name: "a6q67k",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--ds-text, #292A2E)"
});
const $69c88bcb95aa7e29$export$50ad5d386685fccb = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs3"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '& > span': (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
                marginRight: "var(--ds-space-negative-025, -2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                marginTop: "var(--ds-space-025, 2px)"
            } : {
                marginBottom: "var(--ds-space-025, 2px)"
            }
        }
    }));
const $69c88bcb95aa7e29$export$cf4c6e54e715dfd9 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs2"
})({
    name: "1w8issl",
    styles: "margin-left:var(--ds-space-250, 20px);flex:none;color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $69c88bcb95aa7e29$export$934cc98367d9ca68 = 48;
const $69c88bcb95aa7e29$export$cf80dda9d7a88a01 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? "var(--ds-background-selected, #E9F2FE)" : 'transparent',
        display: 'block',
        overflow: 'hidden',
        listStyleType: 'none',
        height: `${$69c88bcb95aa7e29$export$934cc98367d9ca68}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        cursor: 'pointer'
    }));
const $69c88bcb95aa7e29$export$7bf9a8fa7c04527a = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1b3haxs0"
})({
    name: "8l7ck6",
    styles: "padding-left:var(--ds-space-050, 4px);color:var(--ds-text-subtle, #505258)"
});
module.exports["RowStyle"] = $69c88bcb95aa7e29$export$be24b091af3609e7;
module.exports["AvatarStyle"] = $69c88bcb95aa7e29$export$141d6bfd196b561;
module.exports["NameSectionStyle"] = $69c88bcb95aa7e29$export$159b59de9966d2d3;
module.exports["FullNameStyle"] = $69c88bcb95aa7e29$export$d1c198a7fd873fad;
module.exports["InfoSectionStyle"] = $69c88bcb95aa7e29$export$50ad5d386685fccb;
module.exports["TimeStyle"] = $69c88bcb95aa7e29$export$cf4c6e54e715dfd9;
module.exports["MENTION_ITEM_HEIGHT"] = $69c88bcb95aa7e29$export$934cc98367d9ca68;
module.exports["MentionItemStyle"] = $69c88bcb95aa7e29$export$cf80dda9d7a88a01;
module.exports["AccessSectionStyle"] = $69c88bcb95aa7e29$export$7bf9a8fa7c04527a;

});

parcelRegister("dGsOm", function(module, exports) {

var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $3WVxj = parcelRequire("3WVxj");


var $42omo = parcelRequire("42omo");


var $eXmBZ = parcelRequire("eXmBZ");


var $6mYMS = parcelRequire("6mYMS");


var $bwC67 = parcelRequire("bwC67");


var $hldTh = parcelRequire("hldTh");


var $l2474 = parcelRequire("l2474");


var $27fVz = parcelRequire("27fVz");


var $dVkxw = parcelRequire("dVkxw");


var $77Xrn = parcelRequire("77Xrn");


var $6RIul = parcelRequire("6RIul");


var $i0btU = parcelRequire("i0btU");


var $laU6g = parcelRequire("laU6g");

const $0204c6fcc7b5f8a9$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
function $0204c6fcc7b5f8a9$var$renderTag(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3WVxj.default), {
        text: lozenge,
        color: "standard",
        isRemovable: false,
        migration_fallback: "lozenge"
    });
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        const color = appearance ? $0204c6fcc7b5f8a9$var$lozengeAppearanceToTagColor[appearance] : 'standard';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3WVxj.default), {
            text: text,
            color: color,
            isRemovable: false,
            migration_fallback: "lozenge"
        });
    }
    return null;
}
function $0204c6fcc7b5f8a9$var$renderLozenge(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), null, lozenge);
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: appearance
        }, text);
    }
    return null;
}
function $0204c6fcc7b5f8a9$var$renderTime(time) {
    if (time) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.TimeStyle), null, time);
    return null;
}
class $0204c6fcc7b5f8a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { mention: mention, selected: selected, forwardedRef: forwardedRef } = this.props;
        const { id: id, highlight: highlight, presence: presence, name: name, mentionName: mentionName, lozenge: lozenge, accessLevel: accessLevel, isXProductUser: isXProductUser } = mention;
        const { time: time } = presence || {};
        const restricted = (0, $6mYMS.isRestricted)(accessLevel);
        const nameHighlights = highlight && highlight.name;
        const xProductUserInfoIconColor = selected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i0btU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.MentionItemStyle), {
            selected: selected,
            onMouseDown: this.onMentionSelected,
            onMouseMove: this.onMentionMenuItemMouseMove,
            onMouseEnter: this.onMentionMenuItemMouseEnter,
            "data-mention-item": true,
            "data-testid": `mention-item-${id}`,
            "data-mention-id": id,
            "data-mention-name": mentionName,
            "data-selected": selected,
            ref: forwardedRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.RowStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.AvatarStyle), {
            restricted: restricted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $laU6g.MentionAvatar), {
            selected: selected,
            mention: mention
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.NameSectionStyle), {
            restricted: restricted
        }, (0, $77Xrn.renderHighlight)((0, $dVkxw.FullNameStyle), name, nameHighlights), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6RIul.default), {
            mention: mention
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.InfoSectionStyle), {
            restricted: restricted
        }, (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $0204c6fcc7b5f8a9$var$renderTag(lozenge) : $0204c6fcc7b5f8a9$var$renderLozenge(lozenge), $0204c6fcc7b5f8a9$var$renderTime(time)), restricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l2474.default), {
            name: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dVkxw.AccessSectionStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC67.NoAccessLabel), null, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $27fVz.default), {
                label: text
            }))))) : null, isXProductUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            color: xProductUserInfoIconColor,
            label: ''
        }))));
    }
    constructor(...args){
        super(...args);
        // internal, used for callbacks
        this.onMentionSelected = (event)=>{
            if ((0, $hldTh.leftClick)(event) && this.props.onSelection) {
                event.preventDefault();
                this.props.onSelection(this.props.mention, event);
            }
        };
        this.onMentionMenuItemMouseMove = (event)=>{
            if (this.props.onMouseMove) this.props.onMouseMove(this.props.mention, event);
        };
        this.onMentionMenuItemMouseEnter = (event)=>{
            if (this.props.onMouseEnter) this.props.onMouseEnter(this.props.mention, event);
        };
    }
}
const $0204c6fcc7b5f8a9$export$604dabd552e94336 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0204c6fcc7b5f8a9$export$2e2bcd8739ae039, {
        ...props,
        forwardedRef: ref
    });
});
module.exports["default"] = $0204c6fcc7b5f8a9$export$2e2bcd8739ae039;
module.exports["MentionItemWithRef"] = $0204c6fcc7b5f8a9$export$604dabd552e94336;

});

parcelRegister("hldTh", function(module, exports) {
function $aa59fadcb630050c$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $aa59fadcb630050c$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $aa59fadcb630050c$export$34ebdaf2c517ae75(event) {
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}
module.exports["mouseLocation"] = $aa59fadcb630050c$export$fd3cd03f8ac42187;
module.exports["actualMouseMove"] = $aa59fadcb630050c$export$de744e30016241b0;
module.exports["leftClick"] = $aa59fadcb630050c$export$34ebdaf2c517ae75;

});

parcelRegister("27fVz", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $80397ffe2f8dbca3$var$AsyncLockCircleIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9Q2dU"))).then((module)=>({
            default: module.default
        })));
var $80397ffe2f8dbca3$export$2e2bcd8739ae039 = $80397ffe2f8dbca3$var$AsyncLockCircleIcon;
module.exports["default"] = $80397ffe2f8dbca3$export$2e2bcd8739ae039;

});

parcelRegister("77Xrn", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $3b40cc09386e38bc$export$2bcf43b01d5314f5(ReactComponent, value, highlights, prefix) {
    if (!value) return null;
    const parts = [];
    const prefixText = prefix || '';
    let lastIndex = 0;
    if (highlights) {
        for(let i = 0; i < highlights.length; i++){
            const h = highlights[i];
            const start = h.start;
            const end = h.end;
            if (start > lastIndex) parts.push({
                value: value.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: value.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) parts.push({
            value: value.substring(lastIndex, value.length),
            matches: false
        });
    } else parts.push({
        value: value,
        matches: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ReactComponent, null, prefixText, parts.map((part, index)=>{
        if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", {
            key: index
        }, part.value);
        return part.value;
    }));
}
module.exports["renderHighlight"] = $3b40cc09386e38bc$export$2bcf43b01d5314f5;

});

parcelRegister("6RIul", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6mYMS = parcelRequire("6mYMS");


var $bTdBi = parcelRequire("bTdBi");


var $lGxNJ = parcelRequire("lGxNJ");


var $dHZFZ = parcelRequire("dHZFZ");


var $gjAAG = parcelRequire("gjAAG");

class $2168da1a134a3aab$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { userType: userType, isXProductUser: isXProductUser } = this.props.mention;
        if (isXProductUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dHZFZ.DescriptionBylineStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $gjAAG.messages).xProductMentionDescription));
        switch(userType){
            case (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM]:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGxNJ.default), {
                    mention: this.props.mention
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bTdBi.default), {
                    mention: this.props.mention
                });
        }
    }
}
module.exports["default"] = $2168da1a134a3aab$export$2e2bcd8739ae039;

});

parcelRegister("bTdBi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $77Xrn = parcelRequire("77Xrn");


var $dHZFZ = parcelRequire("dHZFZ");

class $cbd22085b8f91971$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { highlight: highlight, name: name, nickname: nickname } = this.props.mention;
        const nicknameHighlights = highlight && highlight.nickname;
        if (name === nickname) return null;
        return (0, $77Xrn.renderHighlight)((0, $dHZFZ.DescriptionBylineStyle), nickname, nicknameHighlights, '@');
    }
}
module.exports["default"] = $cbd22085b8f91971$export$2e2bcd8739ae039;

});

parcelRegister("dHZFZ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $cStGJ = parcelRequire("cStGJ");

function $8131603721b4dfdc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8131603721b4dfdc$export$607100a5f9cc9977 = /*#__PURE__*/ (0, $cStGJ.default)("span", {
    target: "e1bkpfff0"
})({
    name: "mffxab",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:var(--ds-space-025, 2px);display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
});
module.exports["DescriptionBylineStyle"] = $8131603721b4dfdc$export$607100a5f9cc9977;

});

parcelRegister("lGxNJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dHZFZ = parcelRequire("dHZFZ");


var $gjAAG = parcelRequire("gjAAG");

class $8badfae915fa3b7b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { context: context } = this.props.mention;
        if (!context) return null;
        const includesYou = context.includesYou;
        const memberCount = context.memberCount;
        return this.renderByline(memberCount, includesYou);
    }
    constructor(...args){
        super(...args);
        this.renderByline = (memberCount, includesYou)=>{
            if (includesYou) {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $gjAAG.messages).plus50MembersWithYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...(0, $gjAAG.messages).memberCountWithYou,
                    values: {
                        0: memberCount
                    }
                }));
            } else {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $gjAAG.messages).plus50MembersWithoutYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...(0, $gjAAG.messages).memberCountWithoutYou,
                    values: {
                        0: memberCount
                    }
                }));
            }
        };
        this.getBylineComponent = (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dHZFZ.DescriptionBylineStyle), null, message);
    }
}
module.exports["default"] = $8badfae915fa3b7b$export$2e2bcd8739ae039;

});

parcelRegister("laU6g", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");

var $1wHV6 = parcelRequire("1wHV6");


var $alaek = parcelRequire("alaek");


var $dh538 = parcelRequire("dh538");


var $6mYMS = parcelRequire("6mYMS");

const $1ce2ae5bf64180d0$export$35f495c0dc0a1015 = ({ mention: mention, selected: selected })=>{
    const { appType: appType, avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #0B120E24)" : undefined;
    const { status: status } = presence || {};
    if ((0, $6mYMS.isTeamMention)(mention)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $alaek.default), {
        src: avatarUrl,
        size: "medium",
        borderColor: borderColor
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl,
        size: "medium",
        presence: status,
        borderColor: borderColor,
        appearance: (0, $dh538.fg)('jira_ai_agent_avatar_issue_view_comment_mentions') ? (0, $1wHV6.default)(appType) : undefined
    });
};
module.exports["MentionAvatar"] = $1ce2ae5bf64180d0$export$35f495c0dc0a1015;

});

parcelRegister("ekqC5", function(module, exports) {
/* InviteItemWithEmailDomain.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ePpFN = parcelRequire("ePpFN");


var $ldfch = parcelRequire("ldfch");


var $a3fRD = parcelRequire("a3fRD");


var $9xsgQ = parcelRequire("9xsgQ");

const $9db57f61bf631cc4$var$mentionItemStyle = null;
const $9db57f61bf631cc4$var$mentionItemSelectedStyle = null;
const $9db57f61bf631cc4$var$style = {
    byline: "_19pkv77o",
    rowStyle: "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvutpp _u5f3utpp _1bto1l2s _s7n4nkob",
    avatar: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no",
    nameSection: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0utpp _syazazsu",
    capitalize: "_1p1d1dk0"
};
const $9db57f61bf631cc4$var$VALID_OPTION = 'VALID';
const $9db57f61bf631cc4$var$POTENTIAL_OPTION = 'POTENTIAL'; // eslint-disable-next-line require-unicode-regexp
const $9db57f61bf631cc4$var$COMPLETE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $9db57f61bf631cc4$var$ERROR_DELAY_MS = 750;
const $9db57f61bf631cc4$var$getInviteOption = (inputValue, suggestedEmailDomain)=>{
    if (inputValue.includes(' ') && inputValue.includes('@')) return inputValue;
    const isEmail = inputValue && [
        $9db57f61bf631cc4$var$VALID_OPTION,
        $9db57f61bf631cc4$var$POTENTIAL_OPTION
    ].includes((0, $9xsgQ.isValidEmail)(inputValue));
    if (isEmail || !suggestedEmailDomain) return inputValue;
    return `${inputValue.toLocaleLowerCase()}@${suggestedEmailDomain}`;
};
const $9db57f61bf631cc4$var$getIsEmailValid = (inputValue)=>{
    if (!inputValue || inputValue.length === 0) return false;
    if (inputValue.includes(' ')) return false;
    if (inputValue.includes('@') && !$9db57f61bf631cc4$var$COMPLETE_EMAIL_REGEX.test(inputValue)) return false;
    return true;
};
const $9db57f61bf631cc4$export$75621ed4176efc9e = {
    id: 'invite-teammate'
};
const $9db57f61bf631cc4$var$InviteItemWithEmailDomain = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, query: query = '', emailDomain: emailDomain, intl: intl })=>{
    const [showErrorIcon, setShowErrorIcon] = (0, $42omo.useState)(false);
    const timeoutRef = (0, $42omo.useRef)();
    const possibleEmail = $9db57f61bf631cc4$var$getInviteOption(query, emailDomain);
    const isEmailValid = $9db57f61bf631cc4$var$getIsEmailValid(query); // Use debounced error state for icon and byline display
    const shouldShowError = !isEmailValid && showErrorIcon; // Use debounced error state for byline: show invalid message only after delay
    const isValidForByline = isEmailValid || !shouldShowError;
    const getByline = ()=>{
        if (!isValidForByline) return intl.formatMessage((0, $ePpFN.mentionMessages).inviteTeammateInvalidEmail);
        if (userRole === 'admin') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage // Ignored via go/ees005
        ), {
            ...(0, $ePpFN.mentionMessages).inviteItemTitle,
            values: {
                userRole: userRole || 'basic',
                productName: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "data-testid": "capitalized-message",
                    className: (0, $gMc0m.default)([
                        $9db57f61bf631cc4$var$style.capitalize
                    ]),
                    children: productName
                })
            }
        });
        return intl.formatMessage((0, $ePpFN.mentionMessages).sendInvite);
    };
    const onSelected = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onSelection) {
            // For mouse events, only handle left click
            if ('button' in event && event.button !== 0) return;
             // For keyboard events, only handle Enter and Space
            if ('key' in event && event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            onSelection($9db57f61bf631cc4$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($9db57f61bf631cc4$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    const onItemFocus = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($9db57f61bf631cc4$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]); // Debounce error icon display: only show error after user stops typing invalid input
    (0, $42omo.useEffect)(()=>{
        // Clear existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        } // Reset error icon immediately if input becomes valid or empty
        if (isEmailValid || query.length === 0) setShowErrorIcon(false);
        else // Debounce: only show error icon after delay if input remains invalid
        timeoutRef.current = setTimeout(()=>{
            setShowErrorIcon(true);
        }, $9db57f61bf631cc4$var$ERROR_DELAY_MS);
         // Cleanup timeout on unmount or when query changes
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [
        query,
        isEmailValid
    ]);
    const displayName = query && emailDomain ? possibleEmail : undefined;
    return displayName && /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "button",
        tabIndex: 0,
        onMouseDown: onSelected,
        onKeyDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        onFocus: onItemFocus,
        "data-id": $9db57f61bf631cc4$export$75621ed4176efc9e.id,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _bfhk1j28 _1e0c1ule _2mzuglyw _80omtlke",
            selected && "_bfhk1dpa"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            className: (0, $gMc0m.default)([
                $9db57f61bf631cc4$var$style.rowStyle
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        $9db57f61bf631cc4$var$style.avatar
                    ]),
                    children: shouldShowError ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        label: "Error",
                        color: "var(--ds-icon-danger, #C9372C)"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldfch))), {
                        label: "Email",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "data-testid": "name-section",
                    className: (0, $gMc0m.default)([
                        $9db57f61bf631cc4$var$style.nameSection
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                children: displayName
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    $9db57f61bf631cc4$var$style.byline
                                ]),
                                children: getByline()
                            })
                        ]
                    })
                })
            ]
        })
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $9db57f61bf631cc4$var$_default_1 = (0, $aXWIB.injectIntl)($9db57f61bf631cc4$var$InviteItemWithEmailDomain);
var $9db57f61bf631cc4$export$2e2bcd8739ae039 = $9db57f61bf631cc4$var$_default_1;
module.exports["default"] = $9db57f61bf631cc4$export$2e2bcd8739ae039;

});

parcelRegister("gCiM9", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $lWghV = parcelRequire("lWghV");


var $dus6D = parcelRequire("dus6D");

const $efde80a57d73d90b$export$ae829ec7b2625219 = (eventDispatch, onSave)=>{
    if (!onSave) return;
    return (0, $dus6D.keymap)({
        Enter (state, _dispatch, editorView) {
            if (editorView && $efde80a57d73d90b$var$canSaveOnEnter(editorView)) {
                eventDispatch((0, $lWghV.analyticsEventKey), $efde80a57d73d90b$var$analyticsPayload(state));
                onSave(editorView);
                return true;
            }
            return false;
        }
    });
};
function $efde80a57d73d90b$var$canSaveOnEnter(editorView) {
    const { $cursor: $cursor } = editorView.state.selection;
    const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
    return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$efde80a57d73d90b$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$efde80a57d73d90b$var$isEmptyAtCursor($cursor);
}
function $efde80a57d73d90b$var$isEmptyAtCursor($cursor) {
    const { content: content } = $cursor.parent;
    return !(content && content.size);
}
const $efde80a57d73d90b$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $d925B.ACTION).STOPPED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        }
    });
const $efde80a57d73d90b$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
        name: 'saveOnEnter',
        pmPlugins () {
            return [
                {
                    name: 'saveOnEnter',
                    plugin: ({ dispatch: dispatch })=>$efde80a57d73d90b$export$ae829ec7b2625219(dispatch, onSave)
                }
            ];
        }
    });
module.exports["saveOnEnterPlugin"] = $efde80a57d73d90b$export$8ba1e5775ae443a6;

});

parcelRegister("4pEXC", function(module, exports) {

var $b0F8r = parcelRequire("b0F8r");


var $b7FrM = parcelRequire("b7FrM");


var $lpRYt = parcelRequire("lpRYt");


var $ij2FZ = parcelRequire("ij2FZ");

const $cdcb92bd6c40797f$export$d801201dc544181 = (content)=>{
    /*
	This try-catch is a necessary guard rail against broken content to prevent higher level
	error boundaries from displaying the error and breaking the experience.
	*/ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $cdcb92bd6c40797f$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $cdcb92bd6c40797f$var$pluginConfig = {
    linkify: {
        findFilepaths: $b0F8r.findFilepaths,
        isLinkInMatches: $b0F8r.isLinkInMatches
    },
    smartLinks: {
        regexStorage: globalThis.localStorage
    }
};
const $cdcb92bd6c40797f$export$3374c63d7715b4ce = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, false));
const $cdcb92bd6c40797f$var$streamingAdfEncoder = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, true));
const $cdcb92bd6c40797f$export$53ded0b846f45216 = (content, streaming = false, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage, useGroupedCitations)=>{
    if ($cdcb92bd6c40797f$export$d801201dc544181(content)) return content;
    if (isExperimentEnabled || isNonAgentMessage) return new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage)).encode(content);
    else if (useGroupedCitations) return streaming ? new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, true, undefined, undefined, undefined, true)).encode(content) : new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $cdcb92bd6c40797f$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, isNonAgentMessage, useGroupedCitations)).encode(content);
    else return streaming ? $cdcb92bd6c40797f$var$streamingAdfEncoder.encode(content) : $cdcb92bd6c40797f$export$3374c63d7715b4ce.encode(content);
};
const $cdcb92bd6c40797f$export$cc924f6f2bb49b7c = (content)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let match;
    let promptLength = 0;
    // Find all skill tag matches
    const matches = [];
    while((match = (0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).exec(content)) !== null)matches.push({
        index: match.index,
        skillSlug: match[1],
        length: match[0].length
    });
    // Process the string segment by segment
    for(let i = 0; i < matches.length; i++){
        const currentMatch = matches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textBefore = content.substring(lastIndex, matchStart);
            if (textBefore) {
                contentNodes.push({
                    type: 'text',
                    text: textBefore
                });
                promptLength += textBefore.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.skillSlug
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text after the last match (if any)
    if (lastIndex < content.length) {
        const textAfter = content.substring(lastIndex);
        if (textAfter) {
            contentNodes.push({
                type: 'text',
                text: textAfter
            });
            promptLength += textAfter.length;
        }
    }
    // If no matches were found, return the entire string as text
    if (contentNodes.length === 0) {
        contentNodes.push({
            type: 'text',
            text: content
        });
        promptLength += content.length;
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength
    };
};
const $cdcb92bd6c40797f$export$b663bc0d84e6eaa6 = '`';
// encodeAdf removes leading spaces, so prepend a text node with the segment's leading spaces to preserve them.
const $cdcb92bd6c40797f$var$preserveLeadingSpaces = (textSegment, nodes)=>{
    const leading = textSegment.match(/^\s*/)?.[0] ?? '';
    if (leading.length === 0) return nodes;
    return [
        {
            type: 'text',
            text: leading
        },
        ...nodes
    ];
};
// Collect all content nodes from all top-level blocks, since encodeAdf can return multiple paragraphs for e.g. "line1\n\nline2".
const $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf = (segmentAdf, fallbackSegment)=>{
    const blocks = segmentAdf.content ?? [];
    if (blocks.length === 0) return [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
    const nodes = blocks.flatMap((block)=>block.content ?? []);
    return nodes.length > 0 ? nodes : [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
};
const $cdcb92bd6c40797f$var$detectSkills = (content, skillMetadata)=>{
    if (!skillMetadata) return [];
    const regex = new RegExp((0, $ij2FZ.ROVO_SKILL_TAG_PATTERN).source, 'g');
    const matches = [
        ...content.matchAll(regex)
    ];
    if (matches.length === 0) return [];
    return matches.filter((m)=>m[1] in skillMetadata).map((m)=>({
            index: m.index ?? 0,
            slug: m[1],
            length: m[0].length
        }));
};
const $cdcb92bd6c40797f$export$20cf1197bba4fe47 = (content, skillMetadata)=>{
    const skillMatches = $cdcb92bd6c40797f$var$detectSkills(content, skillMetadata);
    if (skillMatches.length === 0) {
        const { placeholderRange: placeholderRange } = $cdcb92bd6c40797f$var$getPlaceholderRange(content, 0);
        return {
            adf: $cdcb92bd6c40797f$export$53ded0b846f45216(content),
            promptLength: content.length,
            ...placeholderRange && {
                placeholderRange: placeholderRange
            }
        };
    }
    return $cdcb92bd6c40797f$var$encodePromptWithSkills(content, skillMatches, skillMetadata);
};
const $cdcb92bd6c40797f$var$encodePromptWithSkills = (content, skillMatches, skillMetadata)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let promptLength = 0;
    let placeholderRange;
    for(let i = 0; i < skillMatches.length; i++){
        const currentMatch = skillMatches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text and placeholder range before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textSegment = content.substring(lastIndex, matchStart);
            if (textSegment) {
                const { placeholderRange: range } = $cdcb92bd6c40797f$var$getPlaceholderRange(textSegment, promptLength);
                if (range) placeholderRange = range;
                const segmentAdf = $cdcb92bd6c40797f$export$53ded0b846f45216(textSegment);
                const nodes = $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
                contentNodes.push(...$cdcb92bd6c40797f$var$preserveLeadingSpaces(textSegment, nodes));
                promptLength += textSegment.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.slug,
                    ...skillMetadata?.[currentMatch.slug]
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text and placeholder range after the last match (if any)
    if (lastIndex < content.length) {
        const textSegment = content.substring(lastIndex);
        if (textSegment) {
            const { placeholderRange: range } = $cdcb92bd6c40797f$var$getPlaceholderRange(textSegment, promptLength);
            if (range) placeholderRange = range;
            const segmentAdf = $cdcb92bd6c40797f$export$53ded0b846f45216(textSegment);
            const nodes = $cdcb92bd6c40797f$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
            contentNodes.push(...$cdcb92bd6c40797f$var$preserveLeadingSpaces(textSegment, nodes));
            promptLength += textSegment.length;
        }
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength,
        ...placeholderRange && {
            placeholderRange: placeholderRange
        }
    };
};
// Returns the placeholder range for link typeahead when content has `label` backticks.
const $cdcb92bd6c40797f$var$getPlaceholderRange = (segment, currentContentIndex)=>{
    const firstBacktick = segment.indexOf($cdcb92bd6c40797f$export$b663bc0d84e6eaa6);
    const lastBacktick = segment.lastIndexOf($cdcb92bd6c40797f$export$b663bc0d84e6eaa6);
    if (firstBacktick !== -1 && lastBacktick !== -1 && firstBacktick !== lastBacktick) {
        const label = segment.slice(firstBacktick + 1, lastBacktick);
        const start = currentContentIndex + firstBacktick + 1;
        return {
            placeholderRange: {
                start: start,
                end: start + label.length,
                label: label
            }
        };
    }
    return {};
};
module.exports["isAdfContent"] = $cdcb92bd6c40797f$export$d801201dc544181;
module.exports["appendContent"] = $cdcb92bd6c40797f$export$a236f395afded7e0;
module.exports["encodeAdf"] = $cdcb92bd6c40797f$export$53ded0b846f45216;
module.exports["encodeSkillPromptToAdf"] = $cdcb92bd6c40797f$export$cc924f6f2bb49b7c;
module.exports["PROMPT_PLACEHOLDER_CHAR"] = $cdcb92bd6c40797f$export$b663bc0d84e6eaa6;
module.exports["encodePromptToAdf"] = $cdcb92bd6c40797f$export$20cf1197bba4fe47;

});

parcelRegister("805F8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $hUyPY = parcelRequire("hUyPY");

const $9feb5506bcd0ebb4$export$4962f3898bd5c829 = ({ name: name, trigger: trigger = 'mount' })=>{
    (0, $fBMbo.di)((0, $hUyPY.useAIMateExperienceTracker));
    const successTriggerRef = (0, $42omo.useRef)(trigger);
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    (0, $42omo.useEffect)(()=>{
        if (successTriggerRef.current === 'mount') experienceTracker.succeed({
            name: name
        });
        if (successTriggerRef.current === 'unmount') return ()=>{
            experienceTracker.succeed({
                name: name
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $9feb5506bcd0ebb4$export$eed1d73ebdd8c7ab = ({ error: error, name: name })=>{
    (0, $fBMbo.di)((0, $hUyPY.useAIMateExperienceTracker));
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    (0, $42omo.useEffect)(()=>{
        experienceTracker.fail({
            name: name,
            error: error
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $9feb5506bcd0ebb4$export$f20b867e738a222c = ({ name: name })=>{
    (0, $fBMbo.di)((0, $hUyPY.useAIMateExperienceTracker));
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    (0, $42omo.useMemo)(()=>{
        experienceTracker.start({
            id: name,
            name: name
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["ExperienceSuccess"] = $9feb5506bcd0ebb4$export$4962f3898bd5c829;
module.exports["ExperienceFailure"] = $9feb5506bcd0ebb4$export$eed1d73ebdd8c7ab;
module.exports["ExperienceStart"] = $9feb5506bcd0ebb4$export$f20b867e738a222c;

});

parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("42omo")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});

parcelRegister("i1Nyn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $3527ba50fc1c4fde$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const currentAIFeatureContextState = getState().aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                // targets is always an array
                const targetList = targets;
                // If activeTargetId provided, find it; otherwise return first target
                if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                return targetList[0];
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = targets;
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const entries = getState().contentTargets;
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                if (entries['staging-area']) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                // Store as array, append if not already present
                const existing = currentTargets[toAdd];
                const targetList = existing ?? [];
                // Avoid duplicates by checking if target with same id exists
                // & filter out any targets with empty IDs to avoid stale targets
                const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                filtered.push(target);
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: filtered
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId) {
                        // If a specific targetId is provided, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId
    }
});
const $3527ba50fc1c4fde$export$53bf948a400e8426 = (0, $9zUhf.createActionsHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9);
const $3527ba50fc1c4fde$export$9465f65715425f1b = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $3527ba50fc1c4fde$export$eea520981851a092 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $3527ba50fc1c4fde$export$c517e9a5e436c401 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $3527ba50fc1c4fde$export$debe3dc2612d2a8e = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $3527ba50fc1c4fde$export$376b2a7bf70dad8 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $3527ba50fc1c4fde$export$6280f21050465fe4 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $3527ba50fc1c4fde$export$3794ec8d9f571031 = (0, $9zUhf.createHook)($3527ba50fc1c4fde$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $3527ba50fc1c4fde$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext })=>{
    const actions = $3527ba50fc1c4fde$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $42omo.useCallback)(async (type, contentContext, activeTargetId)=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext, activeTargetId);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody(type, selectedTargetId);
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    contentMauiId: contentBody.contentMauiId,
                    dynamicUiSource: contentBody.dynamicUiSource,
                    dynamicUiType: contentBody.dynamicUiType,
                    mediaFileId: contentBody.mediaFileId,
                    isViewMode: contentBody.isViewMode,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getEditorContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('page', contentContext, activeTargetId) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
	 * Fetches the context of a currently live page with Rovo chat open.
	 *
	 * @description see full list of cases to consider in {@link getContextRequirements}
	 */ const getWhiteboardContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('whiteboard', contentContext, activeTargetId) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSlidesContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $c6GJD.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('slide', contentContext, activeTargetId) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $42omo.useCallback)(async ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId })=>{
        const isAifcEnabled = (0, $dh538.fg)('aifc_create_enabled');
        const shouldProvideContext = $3527ba50fc1c4fde$export$86d7678a1db25436({
            contentContext: contentContext,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('database', contentContext, activeTargetId) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $42omo.useCallback)(async ({ contentContext: contentContext, activeTargetId: activeTargetId })=>{
        if (!(0, $dh538.fg)('platform_avp_aifc_enabled')) return undefined;
        return await fetchContent('dashboard', contentContext, activeTargetId);
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $42omo.useCallback)(({ contentContext: contentContext, isFirstPrompt: isFirstPrompt })=>{
        if (contentContext === 'staging-area' && !isFirstPrompt && (0, $dh538.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $42omo.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $42omo.useCallback)((addCurrentPageAsContextUserPreference)=>{
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea
    ]);
    const getBrowserContext = (0, $42omo.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $c6GJD.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $42omo.useCallback)(async ()=>{
        if ((0, $dh538.fg)('jira-aifc-enable-preview-card-in-chat-v2')) {
            const isStagingArea = getIsStagingArea();
            if (!isStagingArea) {
                const jiraCreateContext = actions.getJiraCreateContext();
                if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
            }
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $3527ba50fc1c4fde$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
	 * If AIFC is not enabled, we default to the user's preference.
	 */ if (!isAifcEnabled) return userPreference;
    /**
	 * In the staging area, we always want to provide context if the source is the
	 * inline editor, or if the prompt is not the first in a new conversation.
	 */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
		 * On real content when AIFC is enabled, we only want to default to true
		 * if the source of the content is the inline editing experience. Otherwise,
		 * we want to respect the preference chosen by the user.
		 */ return sourceEligible || userPreference;
}
module.exports["useChatContextStoreActions"] = $3527ba50fc1c4fde$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $3527ba50fc1c4fde$export$9465f65715425f1b;
module.exports["useChatContextDatabaseContext"] = $3527ba50fc1c4fde$export$debe3dc2612d2a8e;
module.exports["useChatContextBrowserContext"] = $3527ba50fc1c4fde$export$376b2a7bf70dad8;
module.exports["useChatContextPageSmartLinks"] = $3527ba50fc1c4fde$export$6280f21050465fe4;
module.exports["useChatContextAIFeatureContext"] = $3527ba50fc1c4fde$export$3794ec8d9f571031;
module.exports["useChatContextProvider"] = $3527ba50fc1c4fde$export$904052abb7b98535;

});

parcelRegister("lGVHb", function(module, exports) {
function $b4b40a49047a27cf$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: node.description ?? '',
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $b4b40a49047a27cf$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$b4b40a49047a27cf$export$74ea09dd5afceb60(edge?.node)).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $b4b40a49047a27cf$export$74ea09dd5afceb60;
module.exports["parseSkillEdges"] = $b4b40a49047a27cf$export$2cffb029ea623d71;

});

parcelRegister("iulqN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8eced7d4004a78c9a645ef3d6727f49b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d75ba71d2f7e4979$var$_react = $d75ba71d2f7e4979$var$_interopRequireDefault((parcelRequire("42omo")));

var $d75ba71d2f7e4979$var$_baseNew = $d75ba71d2f7e4979$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d75ba71d2f7e4979$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeChapters".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto chapters functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d75ba71d2f7e4979$var$AiGenerativeChaptersIcon = (props)=>/*#__PURE__*/ $d75ba71d2f7e4979$var$_react.default.createElement($d75ba71d2f7e4979$var$_baseNew.default, Object.assign({
        name: "AiGenerativeChaptersIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 2.5v10h5.75V14H1.375C.615 14 0 13.384 0 12.625V2.375C0 1.617.613 1 1.374 1h3.5A3.87 3.87 0 0 1 8 2.583 3.87 3.87 0 0 1 11.125 1h3.5C15.387 1 16 1.62 16 2.376V8.25h-1.5V2.5h-3.375A2.375 2.375 0 0 0 8.75 4.875V10h-1.5V4.875A2.375 2.375 0 0 0 4.875 2.5zM13.25 6H10.5V4.5h2.75zM2.75 4.5H5.5V6H2.75zm0 2.5H5.5v1.5H2.75zm9.045 2.494a.75.75 0 0 1 1.41 0l.614 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.686-.615a.75.75 0 0 1 0-1.41l1.686-.615z" clip-rule="evenodd"/>`
    }, props));
$d75ba71d2f7e4979$var$AiGenerativeChaptersIcon.displayName = 'AiGenerativeChaptersIcon';
var $d75ba71d2f7e4979$var$_default = module.exports.default = $d75ba71d2f7e4979$var$AiGenerativeChaptersIcon;

});

parcelRegister("eugUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14d3508a57d0950b33e5e611a6d67b81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8c0fbec8ff90f28$var$_react = $a8c0fbec8ff90f28$var$_interopRequireDefault((parcelRequire("42omo")));

var $a8c0fbec8ff90f28$var$_baseNew = $a8c0fbec8ff90f28$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a8c0fbec8ff90f28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLengthen".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Lengthening text content with Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8c0fbec8ff90f28$var$TextLengthenIcon = (props)=>/*#__PURE__*/ $a8c0fbec8ff90f28$var$_react.default.createElement($a8c0fbec8ff90f28$var$_baseNew.default, Object.assign({
        name: "TextLengthenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm0 4.167H1v-1.5h14zm0 4.166H1v-1.5h14zM8 15H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$a8c0fbec8ff90f28$var$TextLengthenIcon.displayName = 'TextLengthenIcon';
var $a8c0fbec8ff90f28$var$_default = module.exports.default = $a8c0fbec8ff90f28$var$TextLengthenIcon;

});

parcelRegister("cdw4J", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e1accb675e158e1c$var$animation = null;
const $e1accb675e158e1c$var$animation1 = null;
const $e1accb675e158e1c$var$animation2 = null;
const $e1accb675e158e1c$var$dot1 = null;
const $e1accb675e158e1c$var$dot2 = null;
const $e1accb675e158e1c$var$dot3 = null;
const $e1accb675e158e1c$var$animatedOpacity = null; /**
                               * @deprecated please use EllipsesAnimation from @atlassian/rovo-platform-ui-components/primitives/ellipses-animation/EllipsesAnimation instead
                               */ 
const $e1accb675e158e1c$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v1gpk",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v18gg",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44voqx9",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
                fill: "#FCA700"
            })
        ]
    });
};
module.exports["EllipsesAnimation"] = $e1accb675e158e1c$export$c0e6915bcce7d1d0;

});

parcelRegister("i08Mr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $e459ef83dafb04f4$var$initialState = {
    fullScreen: false,
    externalEmbed: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true
    }
};
const $e459ef83dafb04f4$export$ab340e857ee89c62 = $e459ef83dafb04f4$var$initialState;
const $e459ef83dafb04f4$var$uiConfig = /*#__PURE__*/ (0, $42omo.createContext)($e459ef83dafb04f4$var$initialState);
const $e459ef83dafb04f4$export$3063519296e335bf = $e459ef83dafb04f4$var$uiConfig.Provider;
const $e459ef83dafb04f4$export$e83755c3ab7a4493 = ()=>(0, $42omo.useContext)($e459ef83dafb04f4$var$uiConfig);
const $e459ef83dafb04f4$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $dh538.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    return {
        ...{
            ...$e459ef83dafb04f4$var$initialState,
            ...processedConfig,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? $e459ef83dafb04f4$var$initialState.enableBrowserContextBanner,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...$e459ef83dafb04f4$var$initialState.elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        }
    };
};
module.exports["UIConfigProvider"] = $e459ef83dafb04f4$export$3063519296e335bf;
module.exports["useUIConfig"] = $e459ef83dafb04f4$export$e83755c3ab7a4493;
module.exports["createUIConfig"] = $e459ef83dafb04f4$export$3e623b13d2da727a;

});

parcelRegister("fDnfG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

const $d1554a578f10d6c8$export$46133998910543ac = (0, $42omo.createContext)(null);
const $d1554a578f10d6c8$export$6fa751d66e55d2e1 = ()=>{
    const isSsr = typeof window === 'undefined';
    const [location, setLocation] = (0, $42omo.useState)(window.location.href);
    // For easier mocking
    const contextValue = (0, $42omo.useContext)($d1554a578f10d6c8$export$46133998910543ac);
    const handleLocationChange = (0, $42omo.useCallback)(()=>{
        if (!isSsr && window.location.href !== location) setLocation(window.location.href);
    }, [
        location,
        setLocation,
        isSsr
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isSsr) {
            const originalPushState = window.history.pushState;
            const originalReplaceState = window.history.replaceState;
            window.history.pushState = function(...args) {
                originalPushState.apply(this, args);
                handleLocationChange();
            };
            window.history.replaceState = function(...args) {
                originalReplaceState.apply(this, args);
                handleLocationChange();
            };
            const unbind = (0, $fFa3V.bindAll)(window, [
                {
                    type: 'popstate',
                    listener: handleLocationChange
                }
            ]);
            return ()=>{
                unbind();
                window.history.pushState = originalPushState;
                window.history.replaceState = originalReplaceState;
            };
        }
    }, [
        handleLocationChange,
        isSsr
    ]);
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $d1554a578f10d6c8$export$6fa751d66e55d2e1;

});

parcelRegister("hcboS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $ahUGI = parcelRequire("ahUGI");

var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $1S4f7 = parcelRequire("1S4f7");


var $lOELb = parcelRequire("lOELb");


var $lNDSG = parcelRequire("lNDSG");


var $ks2lK = parcelRequire("ks2lK");


var $kVNt7 = parcelRequire("kVNt7");

var $lGf1F = parcelRequire("lGf1F");

var $injKz = parcelRequire("injKz");

var $aGYoD = parcelRequire("aGYoD");


var $1yB28 = parcelRequire("1yB28");


var $iu6m9 = parcelRequire("iu6m9");


var $kQc80 = parcelRequire("kQc80");


var $j0XxS = parcelRequire("j0XxS");


var $lhIns = parcelRequire("lhIns");


var $cKEEj = parcelRequire("cKEEj");


var $cTFYB = parcelRequire("cTFYB");


var $aFWfo = parcelRequire("aFWfo");

const $8d1c5078b4947753$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $kVNt7.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $8d1c5078b4947753$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $8d1c5078b4947753$var$memoizedToItem = $8d1c5078b4947753$export$fc10aeed3a532e2a($8d1c5078b4947753$export$144d1b98bacb98cc);
const $8d1c5078b4947753$var$defaultListLimit = 50;
const $8d1c5078b4947753$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $8d1c5078b4947753$var$TRIGGER = ':';
function $8d1c5078b4947753$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $8d1c5078b4947753$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $lOELb.TypeAheadAvailableNodes).EMOJI,
        trigger: $8d1c5078b4947753$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $8d1c5078b4947753$var$getEmojiPluginState(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$8d1c5078b4947753$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($8d1c5078b4947753$var$TRIGGER.concat(query), {
                    limit: $8d1c5078b4947753$var$defaultListLimit,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $aGYoD.SearchSort).UsageFrequency : (0, $aGYoD.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $8d1c5078b4947753$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (!options?.disableAutoformat && asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $8d1c5078b4947753$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $injKz.recordSelectionSucceededSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $injKz.recordSelectionFailedSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            const fragment = (0, $kQc80.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $j0XxS.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $42omo.useEffect)(()=>{
                $8d1c5078b4947753$var$delayUntilIdle(()=>{
                    (0, $lGf1F.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $8d1c5078b4947753$var$createEmojiPlugin(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $cTFYB.inputRulePlugin)(schema, api?.analytics?.actions, api, options?.disableAutoformat)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $cKEEj.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$8d1c5078b4947753$var$setProviderTr(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $kQc80.insertEmoji)(api?.analytics?.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') || !editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aFWfo.InlineEmojiPopup), {
                api: api,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'emoji',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emoji),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).emojiDescription),
                        priority: 500,
                        keyshortcut: ':',
                        isDisabledOffline: false,
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconEmoji), {}),
                        action (insert) {
                            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                                exposure: true
                            })) {
                                // Clear slash
                                let tr = insert('');
                                tr = (0, $cKEEj.setInlineEmojiPopupOpen)(true)(tr);
                                return tr;
                            }
                            const tr = insert(undefined);
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).CLICKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $d925B.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'emoji'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $lNDSG.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                                title: intl.formatMessage((0, $ahUGI.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                                    description: intl.formatMessage((0, $ahUGI.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $8d1c5078b4947753$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $cKEEj.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $8d1c5078b4947753$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $8d1c5078b4947753$var$logRateWarning = ()=>{};
const $8d1c5078b4947753$var$setProviderTr = $8d1c5078b4947753$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $cKEEj.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $8d1c5078b4947753$var$logRateWarning);
const $8d1c5078b4947753$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $8d1c5078b4947753$var$setProviderTr(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $8d1c5078b4947753$export$e3ef5170578bd8ba = new (0, $ks2lK.PluginKey)('emojiPlugin');
function $8d1c5078b4947753$var$getEmojiPluginState(state) {
    return $8d1c5078b4947753$export$e3ef5170578bd8ba.getState(state) || {};
}
function $8d1c5078b4947753$var$createEmojiPlugin(pmPluginFactoryParams, options, api) {
    return new (0, $1S4f7.SafePlugin)({
        key: $8d1c5078b4947753$export$e3ef5170578bd8ba,
        state: {
            init () {
                if (options?.emojiProvider && (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($8d1c5078b4947753$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $cKEEj.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: (0, $iu6m9.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true) ? Promise.resolve(params.provider) : undefined
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $cKEEj.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($8d1c5078b4947753$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (node)=>{
                    return new (0, $lhIns.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api,
                        emojiNodeDataProvider: options?.emojiNodeDataProvider
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $8d1c5078b4947753$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $8d1c5078b4947753$var$setProvider?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $8d1c5078b4947753$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$8d1c5078b4947753$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["emojiPlugin"] = $8d1c5078b4947753$export$d1221bd3f80501e0;
module.exports["emojiPluginKey"] = $8d1c5078b4947753$export$e3ef5170578bd8ba;

});

parcelRegister("kQc80", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $bYZ53 = parcelRequire("bYZ53");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");

const $86388d1937acfc41$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $5SAOw.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $86388d1937acfc41$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                const fragment = $86388d1937acfc41$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                const newTr = (0, $8m4tT.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $ks2lK.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };
module.exports["createEmojiFragment"] = $86388d1937acfc41$export$c62c7770bca4be17;
module.exports["insertEmoji"] = $86388d1937acfc41$export$8d5c072327044b6f;

});

parcelRegister("j0XxS", function(module, exports) {

var $bIZRt = parcelRequire("bIZRt");


var $24P9d = parcelRequire("24P9d");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

const $ef49a6b5d9cf65a1$var$isSSR = Boolean(undefined);
const $ef49a6b5d9cf65a1$export$d122e24cc43292f6 = ()=>{
    const emojiNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $bIZRt.emojiWithLocalId) : (0, $bIZRt.emoji);
    if ($ef49a6b5d9cf65a1$var$isSSR) return emojiNode;
    return {
        ...emojiNode,
        toDOM: (node)=>$ef49a6b5d9cf65a1$export$9edeb07c311f4561(node)
    };
};
function $ef49a6b5d9cf65a1$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const isEmojiScalingEnabled = (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true);
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $24P9d.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #0515240F)",
            ...isEmojiScalingEnabled ? {
                minWidth: '16.25px',
                minHeight: '16.25px'
            } : {
                minWidth: `20px`,
                width: `20px`,
                height: `20px`
            },
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #0515240F)",
            borderRadius: "var(--ds-radius-small, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    if ((0, $dh538.fg)('platform_editor_adf_with_localid')) attrs['data-local-id'] = node.attrs.localId;
    return [
        'span',
        attrs
    ];
}
module.exports["emojiNodeSpec"] = $ef49a6b5d9cf65a1$export$d122e24cc43292f6;
module.exports["emojiToDom"] = $ef49a6b5d9cf65a1$export$9edeb07c311f4561;

});

parcelRegister("lhIns", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");

var $ig7BH = parcelRequire("ig7BH");


var $hWRJP = parcelRequire("hWRJP");


var $91bcx = parcelRequire("91bcx");


var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $j0XxS = parcelRequire("j0XxS");

function $14dc3fa642295a9f$export$1d677781db73ff20(fallbackText) {
    // Regular expression to match a single emoji character
    const emojiRegex = // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    RegExp("^(\\p{Emoji_Presentation}|\\p{Extended_Pictographic}\\u{FE0F}?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
    return emojiRegex.test(fallbackText);
}
class $14dc3fa642295a9f$export$cadc6675ce598ba8 {
    static logError(error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    /** Type guard to check if a Node is an HTMLElement in a safe way. */ isHTMLElement(element) {
        if (element === null) return false;
        // In SSR `HTMLElement` is not defined, so we need to use duck typing here
        return 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await emojiProvider?.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true);
            if (!emojiDescription) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const emojiRepresentation = emojiDescription?.representation;
            if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation);
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
        }
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        const fallbackElement = document.createElement('span');
        fallbackElement.innerText = this.node.attrs.text || this.node.attrs.shortName;
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${this.node.attrs.shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'sprite' in representation ? 'sprite' : 'image';
        // Add wrapper for the emoji
        const containerElement = document.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.setAttribute('title', description.shortName);
        containerElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $ig7BH.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
    }
    createSpriteEmojiElement(representation) {
        const spriteElement = document.createElement('span');
        spriteElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $fhsiz.defaultEmojiHeight}px`;
        if (!(0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
            spriteElement.style.width = `${0, $fhsiz.defaultEmojiHeight}px`;
            spriteElement.style.height = `${0, $fhsiz.defaultEmojiHeight}px`;
        }
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        const imageElement = document.createElement('img');
        imageElement.classList.add((0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        imageElement.style.minWidth = `${0, $fhsiz.defaultEmojiHeight}px`;
        imageElement.style.objectFit = 'contain';
        imageElement.height = (0, $fhsiz.defaultEmojiHeight);
        imageElement.onerror = ()=>{
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
                // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
                // mark the node to refresh when returning online.
                // Create a check that confirms if this.node.attrs.text if an ascii emoji
                if ($14dc3fa642295a9f$export$1d677781db73ff20(this.node.attrs.text)) this.renderFallback();
                else this.renderingFallback = true;
            } else this.renderFallback();
        };
        return imageElement;
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   * @param extraProps.emojiNodeDataProvider - (Optional) A provider for fetching emoji data.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api, emojiNodeDataProvider });
   */ constructor(node, { intl: intl, api: api, emojiNodeDataProvider: emojiNodeDataProvider }){
        this.dom = void 0;
        this.domElement = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.renderingFallback = false;
        this.destroy = ()=>{};
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $5SAOw.DOMSerializer).renderSpec(document, (0, $j0XxS.emojiToDom)(this.node));
        this.dom = dom;
        this.domElement = this.isHTMLElement(dom) ? dom : undefined;
        if (emojiNodeDataProvider) {
            let previousEmojiDescription;
            emojiNodeDataProvider.getData(node, (payload)=>{
                if (payload.error) {
                    $14dc3fa642295a9f$export$cadc6675ce598ba8.logError(payload.error);
                    this.renderFallback();
                    return;
                }
                const optionalEmojiDescription = payload.data;
                if (!optionalEmojiDescription) {
                    this.renderFallback();
                    return;
                }
                const emojiRepresentation = optionalEmojiDescription?.representation;
                if (!$14dc3fa642295a9f$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                    this.renderFallback();
                    return;
                }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(previousEmojiDescription, optionalEmojiDescription)) // Do not re-render if the emoji description is the same as before
                return;
                previousEmojiDescription = optionalEmojiDescription;
                this.renderEmoji(optionalEmojiDescription, emojiRepresentation);
            });
        } else {
            if ((0, $eTj7Y.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
            // that's why we don't need to continue node rendering.
            // In SSR we want to show a placeholder, that `emojiToDom()` returns.
            return;
            // We use the `emojiProvider` from the shared state
            // because it supports the `emojiProvider` prop in the `ComposableEditor` options
            // as well as the `emojiProvider` in the `EmojiPlugin` options.
            const sharedState = api?.emoji?.sharedState;
            if (!sharedState) return;
            let emojiProvider = sharedState.currentState()?.emojiProvider;
            if (emojiProvider) this.updateDom(emojiProvider);
            const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (emojiProvider === nextSharedState?.emojiProvider) // Do not update if the provider is the same
                return;
                emojiProvider = nextSharedState?.emojiProvider;
                this.updateDom(emojiProvider);
            });
            // Refresh emojis if we go back online
            const subscribeToConnection = api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
                if ((0, $91bcx.isOfflineMode)(prevSharedState?.mode) && nextSharedState?.mode === 'online' && this.renderingFallback && (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) this.updateDom(sharedState.currentState()?.emojiProvider);
            });
            this.destroy = ()=>{
                unsubscribe();
                subscribeToConnection?.();
            };
        }
    }
}
module.exports["EmojiNodeView"] = $14dc3fa642295a9f$export$cadc6675ce598ba8;

});

parcelRegister("ig7BH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $2faac4f2f00836b4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $2faac4f2f00836b4$export$defe85febe8b728c;

});

parcelRegister("cKEEj", function(module, exports) {

var $hcboS = parcelRequire("hcboS");

const $38eca9ebbfac95ba$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $38eca9ebbfac95ba$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $38eca9ebbfac95ba$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $38eca9ebbfac95ba$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $38eca9ebbfac95ba$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $hcboS.emojiPluginKey), {
            action: $38eca9ebbfac95ba$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });
module.exports["ACTIONS"] = $38eca9ebbfac95ba$export$92a1a3b7554e9387;
module.exports["setAsciiMap"] = $38eca9ebbfac95ba$export$5e8f481ab8296997;
module.exports["openTypeAhead"] = $38eca9ebbfac95ba$export$adbec20dbbf15a6b;
module.exports["setProvider"] = $38eca9ebbfac95ba$export$1572b3eade6662f9;
module.exports["setInlineEmojiPopupOpen"] = $38eca9ebbfac95ba$export$f53f9c9a74ec859b;

});

parcelRegister("cTFYB", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");


var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");

let $4f54215972d22941$var$matcher;
function $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi, disableAutoformat) {
    if (disableAutoformat) return;
    if (schema.nodes.emoji) {
        $4f54215972d22941$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $l03WE.createRule)($4f54215972d22941$var$AsciiEmojiMatcher.REGEX, $4f54215972d22941$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $4f54215972d22941$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $4f54215972d22941$var$matcher = new $4f54215972d22941$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $4f54215972d22941$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$4f54215972d22941$var$matcher) return null;
        const match = $4f54215972d22941$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $4f54215972d22941$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $4f54215972d22941$var$getLeadingString = (match, withParenthesis = true)=>match[$4f54215972d22941$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $4f54215972d22941$var$getLeadingStringWithoutParentheses = (match)=>$4f54215972d22941$var$getLeadingString(match, false);
const $4f54215972d22941$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$4f54215972d22941$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$4f54215972d22941$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $4f54215972d22941$var$getAsciiWithParentheses = (matchParts)=>$4f54215972d22941$var$getAscii(matchParts, true);
const $4f54215972d22941$var$getTrailingString = (match)=>match[$4f54215972d22941$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        return this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingStringWithoutParentheses(matchParts), $4f54215972d22941$var$getAsciiWithParentheses(matchParts), $4f54215972d22941$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($4f54215972d22941$var$getLeadingString(matchParts), $4f54215972d22941$var$getAscii(matchParts), $4f54215972d22941$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = void 0;
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ /**
 * This regex matches 2 scenarios:
 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
 *
 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
 *
 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
 *    Non-capturing group (?:^|[\s\ufffc])
 *      1st Alternative ^
 *        ^ asserts position at start of the string
 *      2nd Alternative [\s\ufffc]
 *        matches a single character present in [\s\ufffc]
 *    Non-capturing group (?:\(*?)
 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
 *  2nd Capturing Group (\(?)
 *    matches a single ( if present
 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *    2nd Alternative :\S{1,3}( )
 *      : matches the character : literally
 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *  4th Capturing Group ( )
 *
 * See https://regex101.com/r/HRS9O2/4
 */ // New behavior: All emoticons require whitespace after them
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4f54215972d22941$var$AsciiEmojiMatcher.REGEX = new RegExp(`((?:^|[\\s${(0, $14sLv.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $14sLv.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3})([\\s\\t\\n])$`);
class $4f54215972d22941$var$RecordingAsciiEmojiMatcher extends $4f54215972d22941$var$AsciiEmojiMatcher {
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = void 0;
        this.emojiProvider = emojiProvider;
    }
}
class $4f54215972d22941$var$AsciiEmojiTransactionCreator {
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).ASCII
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = void 0;
        this.match = void 0;
        this.start = void 0;
        this.end = void 0;
        this.editorAnalyticsAPI = void 0;
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
}
const $4f54215972d22941$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $4f54215972d22941$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $4f54215972d22941$export$2e2bcd8739ae039 = $4f54215972d22941$var$plugins;
module.exports["inputRulePlugin"] = $4f54215972d22941$export$568a7ed6897c4817;

});

parcelRegister("aFWfo", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $d925B = parcelRequire("d925B");


var $kuh1P = parcelRequire("kuh1P");


var $1Oo9w = parcelRequire("1Oo9w");


var $jwWgu = parcelRequire("jwWgu");


var $efG2U = parcelRequire("efG2U");


var $b3YrF = parcelRequire("b3YrF");


var $aFUXX = parcelRequire("aFUXX");


var $fnia6 = parcelRequire("fnia6");


var $dh538 = parcelRequire("dh538");


var $cKEEj = parcelRequire("cKEEj");

const $5da86e14354f1f0f$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $5da86e14354f1f0f$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $5da86e14354f1f0f$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, onClose: onClose })=>{
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = (0, $1Oo9w.useSharedPluginState)(api, [
        'emoji'
    ])?.emojiState ?? {};
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        if (isOpen && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        onClose?.();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $42omo.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions);
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fnia6.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $5da86e14354f1f0f$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const emojiProvider = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        api?.core.actions,
        api?.metrics?.commands
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        editorView.dispatch((0, $cKEEj.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
    }, [
        editorView,
        api.core.actions,
        api.metrics?.commands
    ]);
    const focusEditor = (0, $42omo.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $42omo.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $d925B.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $42omo.useMemo)(()=>(0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions), [
        editorView,
        api?.analytics?.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($5da86e14354f1f0f$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fnia6.EmojiPicker), {
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $5da86e14354f1f0f$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const isOpen = (0, $b3YrF.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($5da86e14354f1f0f$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement
    });
});
module.exports["InlineEmojiPopup"] = $5da86e14354f1f0f$export$295b54f3ba0abfa5;

});

parcelRegister("kuh1P", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $d925B = parcelRequire("d925B");

const $7e8a46109aa777b7$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $8m4tT.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};
module.exports["getDomRefFromSelection"] = $7e8a46109aa777b7$export$49d74ed2464a12b9;

});

parcelRegister("10CSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");



class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("aXBXO")),
            (parcelRequire("eqCNj"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $330e3eb3197f64f9$export$3ce634ac4a869e2c;

});

parcelRegister("aXBXO", function(module, exports) {

let $7facdce16fc449d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7facdce16fc449d7$var$load("gOOwE"),
    $7facdce16fc449d7$var$load("4pqtR"),
    $7facdce16fc449d7$var$load("5XqRg"),
    $7facdce16fc449d7$var$load("8j9XC"),
    $7facdce16fc449d7$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("eqCNj", function(module, exports) {

let $a81196217acfe6a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a81196217acfe6a7$var$load("8j9XC"),
    $a81196217acfe6a7$var$load("gOOwE"),
    $a81196217acfe6a7$var$load("f35QR"),
    $a81196217acfe6a7$var$load("eVYW1"),
    $a81196217acfe6a7$var$load("ls0Um"),
    $a81196217acfe6a7$var$load("020xd"),
    $a81196217acfe6a7$var$load("eTBsW"),
    $a81196217acfe6a7$var$load("bYxCZ"),
    $a81196217acfe6a7$var$load("6HBYC"),
    $a81196217acfe6a7$var$load("eDqo1"),
    $a81196217acfe6a7$var$load("lxiFd"),
    $a81196217acfe6a7$var$load("1oiJ6"),
    $a81196217acfe6a7$var$load("huUvS"),
    $a81196217acfe6a7$var$load("dT77m"),
    $a81196217acfe6a7$var$load("6vhrJ"),
    $a81196217acfe6a7$var$load("fxC6e"),
    $a81196217acfe6a7$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});

parcelRegister("lhT9r", function(module, exports) {

var $42omo = parcelRequire("42omo");




class $d6fdc1f3aa5fd3b7$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) Promise.all([
            (parcelRequire("aXBXO")),
            (parcelRequire("99cD7")),
            (parcelRequire("gfJu4"))
        ]).then(([mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        }).catch(()=>{
        // TODO [MS-2272]: Add operational error to catch import error
        });
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.displayName = 'AsyncDropzone';
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone = void 0;
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary = void 0;
module.exports["DropzoneLoader"] = $d6fdc1f3aa5fd3b7$export$66201d263cd6342;

});

parcelRegister("99cD7", function(module, exports) {

let $6a8ec06134ba00b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a8ec06134ba00b4$var$load("8j9XC"),
    $6a8ec06134ba00b4$var$load("gOOwE"),
    $6a8ec06134ba00b4$var$load("f35QR"),
    $6a8ec06134ba00b4$var$load("eVYW1"),
    $6a8ec06134ba00b4$var$load("ls0Um"),
    $6a8ec06134ba00b4$var$load("020xd"),
    $6a8ec06134ba00b4$var$load("eTBsW"),
    $6a8ec06134ba00b4$var$load("bYxCZ"),
    $6a8ec06134ba00b4$var$load("6HBYC"),
    $6a8ec06134ba00b4$var$load("eDqo1"),
    $6a8ec06134ba00b4$var$load("lxiFd"),
    $6a8ec06134ba00b4$var$load("1oiJ6"),
    $6a8ec06134ba00b4$var$load("huUvS"),
    $6a8ec06134ba00b4$var$load("dT77m"),
    $6a8ec06134ba00b4$var$load("6vhrJ"),
    $6a8ec06134ba00b4$var$load("fxC6e"),
    $6a8ec06134ba00b4$var$load("cCWZm")
]).then(()=>parcelRequire('xvLlm'));

});

parcelRegister("gfJu4", function(module, exports) {

let $bd515437e3b43a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd515437e3b43a65$var$load("lE3cg").then(()=>parcelRequire('dp2qz'));

});

parcelRegister("kw19Z", function(module, exports) {

var $iyDxB = parcelRequire("iyDxB");


var $hZW9z = parcelRequire("hZW9z");

class $0be842260db55ec0$export$2e2bcd8739ae039 {
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $hZW9z.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $iyDxB.defaultSchema)) {
        return new $0be842260db55ec0$export$2e2bcd8739ae039(schema);
    }
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
}
module.exports["default"] = $0be842260db55ec0$export$2e2bcd8739ae039;

});

parcelRegister("hZW9z", function(module, exports) {

var $dpr67 = parcelRequire("dpr67");


var $4lxYo = parcelRequire("4lxYo");


var $lnC5W = parcelRequire("lnC5W");


var $luMIx = parcelRequire("luMIx");


var $j4yOf = parcelRequire("j4yOf");


var $80lKV = parcelRequire("80lKV");


var $4pSzj = parcelRequire("4pSzj");


var $7oJlc = parcelRequire("7oJlc");


var $6BJLi = parcelRequire("6BJLi");


var $9553M = parcelRequire("9553M");


var $1XLKe = parcelRequire("1XLKe");


var $8SD1i = parcelRequire("8SD1i");


var $ntsJf = parcelRequire("ntsJf");


var $hhMD5 = parcelRequire("hhMD5");


var $7O1my = parcelRequire("7O1my");


var $14o7M = parcelRequire("14o7M");


var $fNci1 = parcelRequire("fNci1");


var $bvn5Z = parcelRequire("bvn5Z");

const $06474df1136b3dc1$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $06474df1136b3dc1$var$nodeToReducerMapping[node.type.name] || $06474df1136b3dc1$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $06474df1136b3dc1$var$nodeToReducerMapping = {
    blockquote: $dpr67.default,
    bulletList: $4lxYo.default,
    date: $lnC5W.default,
    decisionItem: $luMIx.default,
    hardBreak: $j4yOf.default,
    heading: $80lKV.default,
    inlineCard: $4pSzj.default,
    listItem: $7oJlc.default,
    mediaGroup: $6BJLi.default,
    mention: $9553M.default,
    orderedList: $1XLKe.default,
    panel: $8SD1i.default,
    paragraph: $ntsJf.default,
    rule: $hhMD5.default,
    status: $7O1my.default,
    table: $14o7M.default,
    taskItem: $fNci1.default,
    unknown: $bvn5Z.default
};
module.exports["reduce"] = $06474df1136b3dc1$export$533b26079ad0b4b;

});

parcelRegister("dpr67", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $aa8f1012bb552b9a$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $aa8f1012bb552b9a$export$2e2bcd8739ae039 = $aa8f1012bb552b9a$var$blockquote;
module.exports["default"] = $aa8f1012bb552b9a$export$2e2bcd8739ae039;

});

parcelRegister("4lxYo", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $6f70b3fb9c9a420a$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $hZW9z.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $6f70b3fb9c9a420a$export$2e2bcd8739ae039 = $6f70b3fb9c9a420a$var$bulletList;
module.exports["default"] = $6f70b3fb9c9a420a$export$2e2bcd8739ae039;

});

parcelRegister("lnC5W", function(module, exports) {

var $dIxHZ = parcelRequire("dIxHZ");


var $b7FrM = parcelRequire("b7FrM");

const $45097794511600bc$var$date = (node, _schema)=>{
    return node.attrs.timestamp ? (0, $dIxHZ.timestampToIsoFormat)(node.attrs.timestamp) : (0, $b7FrM.getText)(node);
};
var $45097794511600bc$export$2e2bcd8739ae039 = $45097794511600bc$var$date;
module.exports["default"] = $45097794511600bc$export$2e2bcd8739ae039;

});

parcelRegister("luMIx", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $a2f744f6dce90c93$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $a2f744f6dce90c93$export$2e2bcd8739ae039 = $a2f744f6dce90c93$var$decisionItem;
module.exports["default"] = $a2f744f6dce90c93$export$2e2bcd8739ae039;

});

parcelRegister("j4yOf", function(module, exports) {
const $28af56f2b8986b57$var$hardBreak = ()=>{
    return '\n';
};
var $28af56f2b8986b57$export$2e2bcd8739ae039 = $28af56f2b8986b57$var$hardBreak;
module.exports["default"] = $28af56f2b8986b57$export$2e2bcd8739ae039;

});

parcelRegister("80lKV", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $951f7824bed45cdb$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('');
};
var $951f7824bed45cdb$export$2e2bcd8739ae039 = $951f7824bed45cdb$var$heading;
module.exports["default"] = $951f7824bed45cdb$export$2e2bcd8739ae039;

});

parcelRegister("4pSzj", function(module, exports) {

var $b7FrM = parcelRequire("b7FrM");

const $defd2b7923d300de$var$inlineCard = (node, _schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $b7FrM.getText)(node);
};
var $defd2b7923d300de$export$2e2bcd8739ae039 = $defd2b7923d300de$var$inlineCard;
module.exports["default"] = $defd2b7923d300de$export$2e2bcd8739ae039;

});

parcelRegister("7oJlc", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $134205d8b087ad65$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $134205d8b087ad65$export$2e2bcd8739ae039 = $134205d8b087ad65$var$listItem;
module.exports["default"] = $134205d8b087ad65$export$2e2bcd8739ae039;

});

parcelRegister("6BJLi", function(module, exports) {
const $d832b43c98f4140b$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $d832b43c98f4140b$export$2e2bcd8739ae039 = $d832b43c98f4140b$var$mediaGroup;
module.exports["default"] = $d832b43c98f4140b$export$2e2bcd8739ae039;

});

parcelRegister("9553M", function(module, exports) {
const $788567eaebbf2e2c$var$mention = (node, _schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $788567eaebbf2e2c$export$2e2bcd8739ae039 = $788567eaebbf2e2c$var$mention;
module.exports["default"] = $788567eaebbf2e2c$export$2e2bcd8739ae039;

});

parcelRegister("1XLKe", function(module, exports) {

var $irKZA = parcelRequire("irKZA");


var $hZW9z = parcelRequire("hZW9z");

const $d8d47451ce06aad1$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $irKZA.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $hZW9z.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $d8d47451ce06aad1$export$2e2bcd8739ae039 = $d8d47451ce06aad1$var$orderedList;
module.exports["default"] = $d8d47451ce06aad1$export$2e2bcd8739ae039;

});

parcelRegister("8SD1i", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $49e4a61201921798$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $49e4a61201921798$export$2e2bcd8739ae039 = $49e4a61201921798$var$panel;
module.exports["default"] = $49e4a61201921798$export$2e2bcd8739ae039;

});

parcelRegister("ntsJf", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $c17bffe0d8dcd208$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $c17bffe0d8dcd208$export$2e2bcd8739ae039 = $c17bffe0d8dcd208$var$paragraph;
module.exports["default"] = $c17bffe0d8dcd208$export$2e2bcd8739ae039;

});

parcelRegister("hhMD5", function(module, exports) {
const $d065cc1601112956$var$rule = ()=>{
    return '';
};
var $d065cc1601112956$export$2e2bcd8739ae039 = $d065cc1601112956$var$rule;
module.exports["default"] = $d065cc1601112956$export$2e2bcd8739ae039;

});

parcelRegister("7O1my", function(module, exports) {

var $b7FrM = parcelRequire("b7FrM");


var $dh538 = parcelRequire("dh538");

const $5da49fbb8ebaf963$var$status = (node, _schema)=>{
    return node.attrs.text ? node.attrs.style === 'mixedCase' && (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? `[ ${node.attrs.text} ]` : `[ ${node.attrs.text.toUpperCase()} ]` : (0, $b7FrM.getText)(node);
};
var $5da49fbb8ebaf963$export$2e2bcd8739ae039 = $5da49fbb8ebaf963$var$status;
module.exports["default"] = $5da49fbb8ebaf963$export$2e2bcd8739ae039;

});

parcelRegister("14o7M", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $429219c4864a9efd$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($429219c4864a9efd$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $429219c4864a9efd$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($429219c4864a9efd$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $429219c4864a9efd$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    return result.join('\n');
};
var $429219c4864a9efd$export$2e2bcd8739ae039 = $429219c4864a9efd$var$table;
module.exports["default"] = $429219c4864a9efd$export$2e2bcd8739ae039;

});

parcelRegister("fNci1", function(module, exports) {

var $hZW9z = parcelRequire("hZW9z");

const $96fce170cf034ba3$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $hZW9z.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $96fce170cf034ba3$export$2e2bcd8739ae039 = $96fce170cf034ba3$var$taskItem;
module.exports["default"] = $96fce170cf034ba3$export$2e2bcd8739ae039;

});

parcelRegister("bvn5Z", function(module, exports) {

var $b7FrM = parcelRequire("b7FrM");


var $hZW9z = parcelRequire("hZW9z");

const $14e7757f2318836a$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $hZW9z.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $b7FrM.getText)(node);
};
var $14e7757f2318836a$export$2e2bcd8739ae039 = $14e7757f2318836a$var$unknown;
module.exports["default"] = $14e7757f2318836a$export$2e2bcd8739ae039;

});

parcelRegister("delmI", function(module, exports) {

var $9p8fB = parcelRequire("9p8fB");

const $6f1c9f8313f13d49$export$2cf68c3f3d00fa30 = (html)=>{
    return (0, $9p8fB.parseHTMLTextContent)(html);
};
module.exports["createADFFromHTML"] = $6f1c9f8313f13d49$export$2cf68c3f3d00fa30;

});

parcelRegister("9p8fB", function(module, exports) {

var $iyDxB = parcelRequire("iyDxB");


var $5SAOw = parcelRequire("5SAOw");

const $b3d6bafd8af48f38$var$domParser = (0, $5SAOw.DOMParser).fromSchema((0, $iyDxB.defaultSchema));
const $b3d6bafd8af48f38$export$61f8df97ec7cf3 = ()=>{
    const KEYWORDS = [
        'inline',
        'block',
        'text',
        'leaf',
        'group',
        'unsupportedBlock',
        'unsupportedInline'
    ];
    const rules = {};
    for (const nodeType of Object.keys((0, $iyDxB.defaultSchema).nodes)){
        const contentStr = (0, $iyDxB.defaultSchema).nodes[nodeType]?.spec.content;
        if (!contentStr) continue;
        const allowedChildren = (String(contentStr).match(/\b([a-zA-Z_][a-zA-Z0-9_]*)\b/g) || []).filter((match, index, arr)=>!KEYWORDS.includes(match) && (0, $iyDxB.defaultSchema).nodes[match] && arr.indexOf(match) === index);
        if (allowedChildren.length > 0) rules[nodeType] = allowedChildren;
    }
    return rules;
};
const $b3d6bafd8af48f38$var$NESTING_RULES = $b3d6bafd8af48f38$export$61f8df97ec7cf3();
const $b3d6bafd8af48f38$var$canContainChildren = (nodeType)=>!!$b3d6bafd8af48f38$var$NESTING_RULES[nodeType]?.length;
const $b3d6bafd8af48f38$var$isAllowedChild = (parent, child)=>$b3d6bafd8af48f38$var$NESTING_RULES[parent]?.includes(child) ?? false;
const $b3d6bafd8af48f38$var$shouldApplyMark = (tag)=>$b3d6bafd8af48f38$var$domParser.rules.some((rule)=>'mark' in rule && rule.tag === tag);
const $b3d6bafd8af48f38$var$isBlockElement = (tag)=>$b3d6bafd8af48f38$var$domParser.rules.some((rule)=>rule.tag === tag && rule.node);
const $b3d6bafd8af48f38$var$getMarkTypes = (tags)=>{
    const seen = new Set();
    const marks = [];
    for (const tag of tags){
        const markType = $b3d6bafd8af48f38$var$domParser.rules.find((rule)=>rule.tag === tag)?.mark;
        if (markType && !seen.has(markType)) {
            marks.push({
                type: markType
            });
            seen.add(markType);
        }
    }
    return marks;
};
const $b3d6bafd8af48f38$var$createParagraph = (content = [])=>({
        type: 'paragraph',
        content: content
    });
const $b3d6bafd8af48f38$var$getBlockType = (tag)=>{
    const rule = $b3d6bafd8af48f38$var$domParser.rules.find((r)=>r.tag === tag);
    return rule && 'node' in rule && rule.node ? rule.node : 'paragraph';
};
const $b3d6bafd8af48f38$var$createTextNode = (text, marks)=>{
    const markTypes = $b3d6bafd8af48f38$var$getMarkTypes(marks);
    return {
        type: 'text',
        text: text,
        ...markTypes.length > 0 && {
            marks: markTypes
        }
    };
};
const $b3d6bafd8af48f38$var$addText = (text, marks, content)=>{
    if (text) content.push($b3d6bafd8af48f38$var$createTextNode(text, marks));
};
const $b3d6bafd8af48f38$var$handleBlockElement = (tag, innerContent, marks, blocks, currentParagraphContent, parseNode, nestedContainer)=>{
    // Push any accumulated content as paragraph before block element
    if (currentParagraphContent.length > 0) {
        blocks.push($b3d6bafd8af48f38$var$createParagraph([
            ...currentParagraphContent
        ]));
        currentParagraphContent.length = 0;
    }
    const blockType = $b3d6bafd8af48f38$var$getBlockType(tag);
    const newMarks = $b3d6bafd8af48f38$var$shouldApplyMark(tag) ? [
        ...marks,
        tag
    ] : marks;
    const parentNodeType = nestedContainer?.parentType;
    if (nestedContainer && parentNodeType && $b3d6bafd8af48f38$var$isAllowedChild(parentNodeType, blockType)) {
        const elementContent = [];
        const childNestedContainer = $b3d6bafd8af48f38$var$canContainChildren(blockType) ? {
            parentType: blockType,
            children: elementContent
        } : nestedContainer;
        parseNode(innerContent, newMarks, childNestedContainer);
        if (currentParagraphContent.length > 0) {
            elementContent.push($b3d6bafd8af48f38$var$createParagraph([
                ...currentParagraphContent
            ]));
            currentParagraphContent.length = 0;
        }
        nestedContainer.children.push({
            type: blockType,
            content: elementContent.length > 0 ? elementContent : [
                $b3d6bafd8af48f38$var$createParagraph()
            ]
        });
    } else if ($b3d6bafd8af48f38$var$canContainChildren(blockType)) {
        const children = [];
        parseNode(innerContent, newMarks, {
            parentType: blockType,
            children: children
        });
        blocks.push({
            type: blockType,
            content: children.length > 0 ? children : [
                $b3d6bafd8af48f38$var$createParagraph()
            ]
        });
    } else {
        // Regular block elements
        parseNode(innerContent, newMarks, nestedContainer);
        // Push content generated from block parsing
        if (currentParagraphContent.length > 0) {
            if (blockType === 'paragraph' || blockType === 'codeBlock') blocks.push({
                type: blockType,
                content: [
                    ...currentParagraphContent
                ]
            });
            currentParagraphContent.length = 0;
        }
    }
};
const $b3d6bafd8af48f38$var$handleInlineElement = (tag, innerContent, marks, parseNode, nestedContainer)=>{
    const newMarks = $b3d6bafd8af48f38$var$shouldApplyMark(tag) ? [
        ...marks,
        tag
    ] : marks;
    parseNode(innerContent, newMarks, nestedContainer);
};
const $b3d6bafd8af48f38$export$803b79985c54270a = (html)=>{
    const blocks = [];
    const currentParagraphContent = [];
    // Simple regex-based parser that works in both SSR and browser
    const parseNode = (content, marks = [], nestedContainer)=>{
        // Match HTML tags and text content
        // eslint-disable-next-line require-unicode-regexp
        const tagRegex = /<\s*(\w+)([^>]*)>([\s\S]*?)<\s*\/\s*\1\s*>|([^<]+)/g;
        let match = tagRegex.exec(content);
        while(match !== null){
            if (match[4]) $b3d6bafd8af48f38$var$addText(match[4], marks, currentParagraphContent);
            else {
                // HTML element
                const tag = match[1].toLowerCase();
                const innerContent = match[3];
                if ($b3d6bafd8af48f38$var$isBlockElement(tag)) $b3d6bafd8af48f38$var$handleBlockElement(tag, innerContent, marks, blocks, currentParagraphContent, parseNode, nestedContainer);
                else $b3d6bafd8af48f38$var$handleInlineElement(tag, innerContent, marks, parseNode, nestedContainer);
            }
            match = tagRegex.exec(content);
        }
    };
    parseNode(html);
    // Push any remaining content
    if (currentParagraphContent.length > 0) blocks.push($b3d6bafd8af48f38$var$createParagraph(currentParagraphContent));
    return {
        type: 'doc',
        version: 1,
        content: blocks.length > 0 ? blocks : [
            $b3d6bafd8af48f38$var$createParagraph()
        ]
    };
};
module.exports["parseHTMLTextContent"] = $b3d6bafd8af48f38$export$803b79985c54270a;

});

parcelRegister("1MUpo", function(module, exports) {
const $72d61fc920bbc248$export$27903d543b563e39 = (attrs)=>(...content)=>({
            type: 'bodiedExtension',
            attrs: attrs,
            content: content
        });
module.exports["bodiedExtension"] = $72d61fc920bbc248$export$27903d543b563e39;

});

parcelRegister("bAT9l", function(module, exports) {
const $6b7e17532fed1b16$export$db83999c14438df4 = (attrs)=>({
        type: 'mention',
        attrs: {
            accessLevel: '',
            ...attrs
        }
    });
module.exports["mention"] = $6b7e17532fed1b16$export$db83999c14438df4;

});

parcelRegister("cc99d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0cd8dd83f623ffc8a93c918c96c1a11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e0db38dacc0710f$var$_react = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("42omo")));

var $8e0db38dacc0710f$var$_baseNew = $8e0db38dacc0710f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8e0db38dacc0710f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e0db38dacc0710f$var$FieldTextIcon = (props)=>/*#__PURE__*/ $8e0db38dacc0710f$var$_react.default.createElement($8e0db38dacc0710f$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$8e0db38dacc0710f$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $8e0db38dacc0710f$var$_default = module.exports.default = $8e0db38dacc0710f$var$FieldTextIcon;

});

parcelRegister("51lK8", function(module, exports) {

var $4T4vf = parcelRequire("4T4vf");


var $f1MqO = parcelRequire("f1MqO");

const $883f68a01157ae2e$var$api = (0, $f1MqO.makeApi)({
    monitor: (0, $4T4vf.monitorForElements)
});
const $883f68a01157ae2e$export$4b66ee8317094cdb = $883f68a01157ae2e$var$api.autoScroll;
const $883f68a01157ae2e$export$c9168f41de61f525 = $883f68a01157ae2e$var$api.autoScrollWindow;
module.exports["autoScrollForElements"] = $883f68a01157ae2e$export$4b66ee8317094cdb;

});

parcelRegister("f1MqO", function(module, exports) {

var $bSjaC = parcelRequire("bSjaC");

parcelRequire("eItNK");
var $aYpzB = parcelRequire("aYpzB");


var $jtbk8 = parcelRequire("jtbk8");


var $ejbcR = parcelRequire("ejbcR");


var $h66Yh = parcelRequire("h66Yh");

function $d8d8df98db63a460$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $bSjaC.combine)((0, $ejbcR.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $aYpzB.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $aYpzB.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $h66Yh.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $jtbk8.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}
module.exports["makeApi"] = $d8d8df98db63a460$export$b8fa21320a811083;

});

parcelRegister("eItNK", function(module, exports) {
$parcel$export(module.exports, "once", () => (parcelRequire("aYpzB")).once);

var $aYpzB = parcelRequire("aYpzB");


});

parcelRegister("jtbk8", function(module, exports) {
parcelRequire("5jQxm");
var $66utD = parcelRequire("66utD");


var $1PEak = parcelRequire("1PEak");

// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $ae06eb7a26d5c40d$var$schedulers = new Map();
function $ae06eb7a26d5c40d$export$5cff7ac265db316a(monitor) {
    const scheduler = $ae06eb7a26d5c40d$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $ae06eb7a26d5c40d$var$makeScheduler(monitor);
    $ae06eb7a26d5c40d$var$schedulers.set(monitor, created);
    return created;
}
function $ae06eb7a26d5c40d$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $66utD.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $1PEak.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $1PEak.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}
module.exports["getScheduler"] = $ae06eb7a26d5c40d$export$5cff7ac265db316a;

});

parcelRegister("1PEak", function(module, exports) {
const $b8aa3381b771fe03$var$ledger = new Map();
const $b8aa3381b771fe03$var$requested = new Set();
function $b8aa3381b771fe03$export$8c764c3f2fc3d2d2(element) {
    $b8aa3381b771fe03$export$1cb7cbb266b6f6fa(element);
    const entry = $b8aa3381b771fe03$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b8aa3381b771fe03$var$ledger.set(element, fresh);
    return fresh;
}
function $b8aa3381b771fe03$export$1cb7cbb266b6f6fa(element) {
    $b8aa3381b771fe03$var$requested.add(element);
}
function $b8aa3381b771fe03$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b8aa3381b771fe03$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b8aa3381b771fe03$var$ledger.forEach((_, element)=>{
        if (!$b8aa3381b771fe03$var$requested.has(element)) $b8aa3381b771fe03$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b8aa3381b771fe03$var$requested.clear();
}
function $b8aa3381b771fe03$export$13ae770ed39b71ea() {
    $b8aa3381b771fe03$var$ledger.clear();
}
module.exports["markAndGetEngagement"] = $b8aa3381b771fe03$export$8c764c3f2fc3d2d2;
module.exports["clearUnusedEngagements"] = $b8aa3381b771fe03$export$991e77dd347f3df1;
module.exports["clearEngagementHistory"] = $b8aa3381b771fe03$export$13ae770ed39b71ea;

});

parcelRegister("ejbcR", function(module, exports) {
const $ba3cc2be2c89e337$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $ba3cc2be2c89e337$export$aea217a45095ce11 = `[${$ba3cc2be2c89e337$export$4b152ab55cad4fd6}="true"]`;
function $ba3cc2be2c89e337$export$4ec12fb57dfebd53(element) {
    element.setAttribute($ba3cc2be2c89e337$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($ba3cc2be2c89e337$export$4b152ab55cad4fd6);
}
module.exports["selector"] = $ba3cc2be2c89e337$export$aea217a45095ce11;
module.exports["addScrollableAttribute"] = $ba3cc2be2c89e337$export$4ec12fb57dfebd53;

});

parcelRegister("h66Yh", function(module, exports) {

var $h9dtK = parcelRequire("h9dtK");


var $1PEak = parcelRequire("1PEak");


var $ejbcR = parcelRequire("ejbcR");


var $6DDhO = parcelRequire("6DDhO");

function $568f43811c88fe4c$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $568f43811c88fe4c$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$568f43811c88fe4c$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $ejbcR.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $568f43811c88fe4c$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $1PEak.markAndGetEngagement)(element);
    const config = (0, $h9dtK.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $6DDhO.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $568f43811c88fe4c$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $1PEak.markAndGetEngagement)(element);
        const config = (0, $h9dtK.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $6DDhO.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $568f43811c88fe4c$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $568f43811c88fe4c$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$568f43811c88fe4c$var$isScrollingAvailable(remainder)) return;
    $568f43811c88fe4c$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}
module.exports["tryScroll"] = $568f43811c88fe4c$export$233199807749476d;

});

parcelRegister("h9dtK", function(module, exports) {
const $35bbc9592dd770aa$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $35bbc9592dd770aa$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $35bbc9592dd770aa$export$e96028ec7ff9d079(provided) {
    return {
        ...$35bbc9592dd770aa$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $35bbc9592dd770aa$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}
module.exports["getInternalConfig"] = $35bbc9592dd770aa$export$e96028ec7ff9d079;

});

parcelRegister("6DDhO", function(module, exports) {

var $hhm38 = parcelRequire("hhm38");


var $ajYex = parcelRequire("ajYex");


var $lFBSq = parcelRequire("lFBSq");


var $wfJXn = parcelRequire("wfJXn");


var $eIOs5 = parcelRequire("eIOs5");


var $6UNNA = parcelRequire("6UNNA");

function $d6a7fe667f94accc$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $d6a7fe667f94accc$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $d6a7fe667f94accc$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $ajYex.edges).reduce((map, edge)=>{
        const hitbox = (0, $lFBSq.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $ajYex.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $eIOs5.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $6UNNA.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $hhm38.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}
module.exports["getScrollBy"] = $d6a7fe667f94accc$export$6cfa6dfe6898b98f;

});

parcelRegister("hhm38", function(module, exports) {
const $7d638df63a9348c1$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};
module.exports["canScrollOnEdge"] = $7d638df63a9348c1$export$ccd6d9407403fcad;

});

parcelRegister("ajYex", function(module, exports) {
const $e2d5736e549d9f1a$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $e2d5736e549d9f1a$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};
module.exports["edges"] = $e2d5736e549d9f1a$export$4544a00f8eb65eb2;
module.exports["edgeAxisLookup"] = $e2d5736e549d9f1a$export$7fc144124ccf8292;

});

parcelRegister("lFBSq", function(module, exports) {

var $8e8VQ = parcelRequire("8e8VQ");


var $84ZAS = parcelRequire("84ZAS");

function $c2a3ef074bb4151d$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $8e8VQ.axisLookup)[axis];
        const side = (0, $84ZAS.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $c2a3ef074bb4151d$export$b9a449c20abb0e9 = {
    top: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $c2a3ef074bb4151d$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};
module.exports["getOverElementHitbox"] = $c2a3ef074bb4151d$export$b9a449c20abb0e9;

});

parcelRegister("8e8VQ", function(module, exports) {
const $88deb29ded672487$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $88deb29ded672487$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $88deb29ded672487$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $88deb29ded672487$var$vertical,
        crossAxis: $88deb29ded672487$var$horizontal
    },
    horizontal: {
        mainAxis: $88deb29ded672487$var$horizontal,
        crossAxis: $88deb29ded672487$var$vertical
    }
};
module.exports["axisLookup"] = $88deb29ded672487$export$42e42cdab35a2b96;

});

parcelRegister("84ZAS", function(module, exports) {
const $5948654a23ca7c24$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};
module.exports["mainAxisSideLookup"] = $5948654a23ca7c24$export$a45c0cd714a4dbaa;

});

parcelRegister("wfJXn", function(module, exports) {

var $8e8VQ = parcelRequire("8e8VQ");


var $htU2u = parcelRequire("htU2u");


var $84ZAS = parcelRequire("84ZAS");

// We want a consistent scroll speed across devices, regardless of framerate
function $3f544cf5427e20fd$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $3f544cf5427e20fd$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $8e8VQ.axisLookup)[axis];
    const side = (0, $84ZAS.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $htU2u.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $htU2u.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $3f544cf5427e20fd$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $3f544cf5427e20fd$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $3f544cf5427e20fd$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $htU2u.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $84ZAS.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}
module.exports["getScrollChange"] = $3f544cf5427e20fd$export$470a2ff46db8cee8;

});

parcelRegister("htU2u", function(module, exports) {
function $1fec9052eae48826$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}
module.exports["getPercentageInRange"] = $1fec9052eae48826$export$1a29de000a332d74;

});

parcelRegister("eIOs5", function(module, exports) {
function $602bab09026eed2a$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}
module.exports["isAxisAllowed"] = $602bab09026eed2a$export$7120fdbd90bd1292;

});

parcelRegister("6UNNA", function(module, exports) {
function $92037081dc0ecd04$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
module.exports["isWithin"] = $92037081dc0ecd04$export$cda7a9d4399bf2e3;

});

parcelRegister("jY68A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03c064ac252dc790$var$_react = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("42omo")));

var $03c064ac252dc790$var$_baseNew = $03c064ac252dc790$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $03c064ac252dc790$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03c064ac252dc790$var$SyncIcon = (props)=>/*#__PURE__*/ $03c064ac252dc790$var$_react.default.createElement($03c064ac252dc790$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$03c064ac252dc790$var$SyncIcon.displayName = 'SyncIcon';
var $03c064ac252dc790$var$_default = module.exports.default = $03c064ac252dc790$var$SyncIcon;

});

parcelRegister("1BTvF", function(module, exports) {
/**
 * This file defines the invite() service.
 */ 
var $6Co6F = parcelRequire("6Co6F");


var $k4HRJ = parcelRequire("k4HRJ");


var $7DBey = parcelRequire("7DBey");


var $2Q94g = parcelRequire("2Q94g");


var $bmTr3 = parcelRequire("bmTr3");


var $acJmZ = parcelRequire("acJmZ");

const $135e52b0113e9793$export$ff8f647a32d0f23c = [
    'INVITED',
    'USER_EXISTS',
    'INVITED_PENDING_APPROVAL',
    'PENDING_INVITE_EXISTS',
    'NOT_INVITED',
    'ERROR'
];
// Dependencies - generally common to all invites:
const $135e52b0113e9793$var$dependencies = {
    fetchJSON: $bmTr3.fetchJSON,
    createAnalyticsEvent: $2Q94g.createAnalyticsEvent,
    getStargateURL: $2Q94g.getStargateURL,
    getCurrentUserId: $2Q94g.getCurrentUserId,
    getCurrentCloudId: $2Q94g.getCurrentCloudId,
    getCurrentProduct: $2Q94g.getCurrentProduct
};
const $135e52b0113e9793$export$dd37b42f82fee9c3 = Object.assign($135e52b0113e9793$var$inviteImpl, {
    dependencies: $135e52b0113e9793$var$dependencies
});
async function $135e52b0113e9793$var$inviteImpl(input, context) {
    const deps = context.dependencies();
    let results;
    const touchpoint = input.touchpoint === $135e52b0113e9793$export$ba588e0ff1c8ed38.UNKNOWN ? input.integration : input.touchpoint;
    const usersWithOrigin = input.users.map((user)=>{
        const origin = new (0, $6Co6F.default)({
            product: deps.getCurrentProduct()
        });
        const continueUrl = (0, $acJmZ.getContinueUrlWithOrigin)(input.continueUrl, input.resources, origin, touchpoint.replace(/ /g, '_'));
        return {
            user: {
                ...user,
                continueUrl: continueUrl
            },
            origin: origin
        };
    });
    const users = usersWithOrigin.map(({ user: user })=>user);
    try {
        const response = await deps.fetchJSON({
            url: deps.getStargateURL('/v3/invitations/invite'),
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...input.recaptchaOptions?.recaptchaToken ? {
                    'G-Recaptcha-Token': input.recaptchaOptions.recaptchaToken
                } : {},
                ...input.recaptchaOptions?.recaptchaAction ? {
                    'Recaptcha-Action': input.recaptchaOptions.recaptchaAction
                } : {}
            },
            body: JSON.stringify({
                users: users,
                resources: input.resources.map((resource)=>resource.toString()),
                metadata: {
                    ...input.touchpoint === $135e52b0113e9793$export$ba588e0ff1c8ed38.UNKNOWN ? {} : {
                        touchpoint: input.touchpoint
                    },
                    sourceProduct: deps.getCurrentProduct(),
                    ...input.notes && {
                        notes: input.notes
                    }
                }
            })
        });
        results = $135e52b0113e9793$export$aa38717ddd608a8e(response, usersWithOrigin, input.touchpoint, input.integration);
    } catch (error) {
        const errorReason = (0, $2Q94g.getErrorDetails)(error);
        const { code: code, message: message, status: status } = errorReason;
        const attributes = {
            code: code,
            message: message,
            status: status
        };
        if (!(0, $2Q94g.isAcceptableFailure)(message, status)) $135e52b0113e9793$var$inviteFailedSLO(input.touchpoint, attributes, context);
        results = [
            {
                inviteStatus: null,
                error: (0, $7DBey.toError)(error),
                errorReason: errorReason
            }
        ];
    }
    results.forEach((result)=>$135e52b0113e9793$var$fireInviteAnalytics(result, context, input.getAdditionalAttributes));
    return results;
}
const $135e52b0113e9793$export$aa38717ddd608a8e = (response, usersWithOrigin, touchpoint, integration)=>response.flatMap((user)=>{
        const origin = usersWithOrigin.find((userWithOrigin)=>userWithOrigin.user.id === user.id || userWithOrigin.user.email === user.email)?.origin;
        return Object.keys(user.results).map((resource)=>{
            const inviteStatus = user.results[resource];
            const resourceAri = (0, $k4HRJ.AnyAri).parse(resource);
            const common = {
                id: user.id,
                email: user.email,
                origin: origin,
                integration: integration,
                touchpoint: touchpoint,
                resource: resourceAri
            };
            if (inviteStatus === 'ERROR') return {
                ...common,
                inviteStatus: inviteStatus,
                // errorReasons should always be present for error responses
                error: user.errorReasons?.[resource] ?? {
                    code: 'UNKNOWN_ERROR',
                    message: 'Unknown error'
                }
            };
            return {
                ...common,
                inviteStatus: inviteStatus,
                error: null
            };
        });
    });
const $135e52b0113e9793$var$isInvited = (res)=>{
    return res.inviteStatus === 'INVITED' || res.inviteStatus === 'USER_EXISTS';
};
const $135e52b0113e9793$var$isRequested = (res)=>{
    return res.inviteStatus === 'INVITED_PENDING_APPROVAL' || res.inviteStatus === 'PENDING_INVITE_EXISTS';
};
const $135e52b0113e9793$var$isError = (res)=>{
    return res.inviteStatus === 'NOT_INVITED' || res.inviteStatus === 'ERROR';
};
const $135e52b0113e9793$export$e0d12419555d8733 = (result)=>result.reduce((accumulator, res)=>{
        switch(res.inviteStatus){
            case 'INVITED':
            case 'USER_EXISTS':
                $135e52b0113e9793$var$isInvited(res) && accumulator.invited.push(res);
                break;
            case 'INVITED_PENDING_APPROVAL':
            case 'PENDING_INVITE_EXISTS':
                $135e52b0113e9793$var$isRequested(res) && accumulator.requested.push(res);
                break;
            case 'NOT_INVITED':
            case 'ERROR':
                $135e52b0113e9793$var$isError(res) && accumulator.error.push(res);
                break;
            default:
                accumulator.failure = res;
        }
        return accumulator;
    }, {
        invited: [],
        requested: [],
        error: [],
        failure: undefined
    });
// Analytics functions for these common events might later become
// exported for standalone use
function $135e52b0113e9793$var$fireInviteAnalytics(result, context, getAdditionalAttributes) {
    if (!result.error) {
        const originAttributes = result.origin?.toAnalyticsAttributes({
            hasGeneratedId: true
        }) ?? {};
        const attributes = {
            ...getAdditionalAttributes?.(result) ?? {},
            ...originAttributes,
            // The id is always present for success responses
            userAaid: result.id,
            actorAaid: context.dependencies().getCurrentUserId(),
            inviteStatus: result.inviteStatus,
            targetProduct: result.resource.resourceOwner,
            targetTenantId: result.resource.resourceId,
            sourceProduct: context.dependencies().getCurrentProduct(),
            sourceTenantId: context.dependencies().getCurrentCloudId(),
            integration: result.integration,
            touchpoint: result.touchpoint
        };
        $135e52b0113e9793$var$inviteSucceededSLO(result.touchpoint, context);
        if (result.inviteStatus === 'INVITED') $135e52b0113e9793$var$fireUserInvited(attributes, context);
        if (result.inviteStatus === 'INVITED_PENDING_APPROVAL') $135e52b0113e9793$var$fireProductAccessRequested(attributes, context);
    } else if (result.inviteStatus === 'ERROR') {
        const failure = result.error;
        // There should not be a failure SLO event if the error is a user network failure error
        if (!(0, $2Q94g.isAcceptableFailureForUserInvite)(failure)) {
            if ((0, $2Q94g.shouldReportFailedInvite)(failure)) $135e52b0113e9793$var$inviteFailedSLO(result.touchpoint, failure, context);
            else $135e52b0113e9793$var$inviteSucceededSLO(result.touchpoint, context);
        }
    }
}
const $135e52b0113e9793$export$ba588e0ff1c8ed38 = {
    CORE_INVITES: 'Core Invites',
    SHARE_DIALOG: 'Share Dialog',
    TEAMS_MENU: 'Teams Menu',
    MENTIONS: 'Mentions',
    JIRA_ASSIGNS: 'Jira Assigns',
    PROMPT_INVITE_ON_LINK_INSERT: 'Prompt invite on link insert',
    CROSSJOIN_NUDGE: 'Crossjoin Nudge',
    UNKNOWN: 'unknown'
};
function $135e52b0113e9793$var$fireProductAccessRequested(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: attributes.targetProduct,
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $135e52b0113e9793$var$fireUserInvited(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'user',
            action: 'invited',
            actionSubjectId: attributes.userAaid,
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
const $135e52b0113e9793$var$inviteFailedSLO = (touchpoint, attributes, context)=>{
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'sloInviteRequest',
            action: 'failed',
            source: touchpoint,
            attributes: {
                ...attributes,
                touchpoint: touchpoint
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
};
const $135e52b0113e9793$var$inviteSucceededSLO = (touchpoint, context)=>{
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'sloInviteRequest',
            action: 'succeeded',
            source: touchpoint,
            attributes: {
                touchpoint: touchpoint
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
};
module.exports["invite"] = $135e52b0113e9793$export$dd37b42f82fee9c3;
module.exports["mapInviteResult"] = $135e52b0113e9793$export$e0d12419555d8733;

});

parcelRegister("acJmZ", function(module, exports) {
const $1c3a325003f470c5$var$getInstanceUrl = ()=>{
    return window.location.origin;
};
const $1c3a325003f470c5$var$landingPathMap = {
    confluence: '/wiki',
    compass: '/compass',
    avp: '/analytics',
    mercury: '/focus'
};
const $1c3a325003f470c5$var$getLandingPathByProduct = (product)=>$1c3a325003f470c5$var$landingPathMap[product] ?? '';
const $1c3a325003f470c5$export$ab36e4577f8d8354 = (continueUrl, resources, origin, source)=>{
    const instanceUrl = $1c3a325003f470c5$var$getInstanceUrl();
    let productContinueUrl = continueUrl;
    const targetProducts = resources.map((resource)=>resource.resourceOwner);
    if (continueUrl && origin.containsOrigin(continueUrl)) throw new Error('continueUrl contains Origin Tracing query parameter');
    if (!productContinueUrl) productContinueUrl = resources.length === 1 ? `${instanceUrl}${$1c3a325003f470c5$var$getLandingPathByProduct(targetProducts[0])}` : instanceUrl;
    // Also try to find urls that forward newly invited users to jira setting pages and redirect them to a product landing page instead.
    // We should do this so newly invited users are not seeing a permission denied screen when accessing restricted pages.
    if (productContinueUrl.match(/.*\/jira.*\/settings/gim)) productContinueUrl = targetProducts.length === 1 ? `${instanceUrl}${$1c3a325003f470c5$var$getLandingPathByProduct(targetProducts[0])}` : instanceUrl;
    const productContinueUrlWithOrigin = origin.addToUrl(productContinueUrl);
    return `${productContinueUrlWithOrigin}&source=${source}`;
};
module.exports["getContinueUrlWithOrigin"] = $1c3a325003f470c5$export$ab36e4577f8d8354;

});

parcelRegister("gYmGc", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3wBuN = parcelRequire("3wBuN");


var $2Pg7f = parcelRequire("2Pg7f");

const $1e910fe72e775768$export$29beada2d5f93289 = ({ data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $42omo.useMemo)(()=>$1e910fe72e775768$export$bc55c1ff86d63c4d({
            data: data
        }), [
        data
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Pg7f.default), {
        maxCount: 999,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: "top",
        size: "small",
        onMoreClick: ()=>{},
        ...props
    });
};
const $1e910fe72e775768$var$MAX_AVATARS_FEATURED = 2;
const $1e910fe72e775768$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $1e910fe72e775768$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $1e910fe72e775768$export$bc55c1ff86d63c4d = ({ data: users })=>{
    const overflows = users.length > $1e910fe72e775768$var$MAX_AVATARS_FEATURED;
    const lastFeaturedUser = $1e910fe72e775768$var$MAX_AVATARS_FEATURED - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $1e910fe72e775768$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $1e910fe72e775768$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, $l998X.jsx)(AvatarComponent, {
                    ...avatarProps
                });
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $1e910fe72e775768$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $1e910fe72e775768$var$OVERFLOW_USER_MARKER
    });
const $1e910fe72e775768$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, $l998X.jsx)(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3wBuN.AvatarContent), {
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_4cvr1h6o _6a6z1h6o _11c8wadc _1bsb1osq _4t3i1osq _1e0c11p5 _bfhki8nm _syazi7uo _y3gn1h6o _k48p1wq8"
                ]),
                children: `+${Math.min(overflowCount, $1e910fe72e775768$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`
            })
        })
    });
const $1e910fe72e775768$var$avatarOverflowCountContainer = null;
module.exports["FlagCompatibleAvatarGroup"] = $1e910fe72e775768$export$29beada2d5f93289;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("4acD6", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $48675c89bdefef9d$export$d4c72bab9d6cc13a = {
    nudges: []
};
const $48675c89bdefef9d$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        }
};
const $48675c89bdefef9d$export$72552b26ebb37b2 = (0, $1P1Tu.createStore)({
    initialState: $48675c89bdefef9d$export$d4c72bab9d6cc13a,
    actions: $48675c89bdefef9d$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $48675c89bdefef9d$export$af36d029992e7a8c = (0, $9zUhf.createActionsHook)($48675c89bdefef9d$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $48675c89bdefef9d$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $48675c89bdefef9d$export$af36d029992e7a8c;

});

parcelRegister("02cx8", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4c5988c837301b49$export$d4c72bab9d6cc13a = {
    actions: []
};
const $4c5988c837301b49$export$e324594224ef24da = {
    setActions: (actions)=>({ setState: setState })=>{
            setState({
                actions: actions
            });
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                context: context
            });
        },
    removeContext: ()=>({ setState: setState })=>{
            setState({
                context: undefined
            });
        },
    removeActions: ()=>({ setState: setState })=>{
            setState({
                actions: []
            });
        }
};
const $4c5988c837301b49$export$e72cf4a64160987e = (0, $1P1Tu.createStore)({
    initialState: $4c5988c837301b49$export$d4c72bab9d6cc13a,
    actions: $4c5988c837301b49$export$e324594224ef24da,
    name: 'EditorRovoButtonActionsStore'
});
const $4c5988c837301b49$export$b95031893a3d9d63 = (0, $9zUhf.createActionsHook)($4c5988c837301b49$export$e72cf4a64160987e);
const $4c5988c837301b49$export$c693678b9cc11679 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.actions
});
const $4c5988c837301b49$export$59213a5c9f9d59b8 = (0, $9zUhf.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.context
});
module.exports["useEditorRovoButtonActions"] = $4c5988c837301b49$export$b95031893a3d9d63;
module.exports["useEditorRovoButtonActionsActions"] = $4c5988c837301b49$export$c693678b9cc11679;
module.exports["useEditorRovoButtonActionsContext"] = $4c5988c837301b49$export$59213a5c9f9d59b8;

});

parcelRegister("80JwR", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $bdlPz = parcelRequire("bdlPz");


var $1Tagp = parcelRequire("1Tagp");


var $1Elsv = parcelRequire("1Elsv");


var $hB6ux = parcelRequire("hB6ux");


var $8PlH8 = parcelRequire("8PlH8");

const $574aa43e6bff8140$export$c1375d8d7bd75982 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isNewToolbarEnabled = Boolean(api?.toolbar);
    // Workaround since we want to insert a loom via the `hyperlink` plugin for now.
    // The hyperlink plugin (and the card plugin) are deeply tied into using the Prosemirror Command
    // Ideally one day we refactor those and we can remove this.
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = (0, $1Elsv.loomPrimaryToolbarComponent)(config, api);
    if (isNewToolbarEnabled) api?.toolbar?.actions.registerComponents((0, $8PlH8.getToolbarComponents)(config, api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'loom',
        component: primaryToolbarComponent
    });
    return {
        name: 'loom',
        actions: {
            recordVideo: $bdlPz.recordVideo,
            insertLoom: (video, positionType)=>(0, $bdlPz.insertLoom)(editorViewRef.current, api, video, positionType),
            initLoom: ({ loomProvider: loomProvider })=>{
                return (0, $bdlPz.setupLoom)(loomProvider, api, editorViewRef.current, true);
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'loom',
                    plugin: ()=>(0, $1Tagp.createPlugin)({
                            config: config,
                            api: api
                        })
                },
                {
                    name: 'loomViewRefWorkaround',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $1Tagp.loomPluginKey).getState(editorState);
        },
        pluginsOptions: {
            // Enable inserting Loom recordings through the slash command
            quickInsert: (intl)=>{
                if (config.loomProvider) return (0, $hB6ux.getQuickInsertItem)(editorAnalyticsAPI)(intl);
                return [];
            }
        },
        // Enable inserting Loom recordings through main toolbar
        primaryToolbarComponent: !api?.primaryToolbar && !isNewToolbarEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["loomPlugin"] = $574aa43e6bff8140$export$c1375d8d7bd75982;

});

parcelRegister("bdlPz", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");


var $hB6ux = parcelRequire("hB6ux");


var $1Tagp = parcelRequire("1Tagp");

const $a212a932479b4271$export$b5c7c74886310ae0 = ({ loomButton: loomButton })=>({ tr: tr })=>{
        tr.setMeta((0, $1Tagp.loomPluginKey), {
            type: (0, $1Tagp.LoomPluginAction).ENABLE,
            loomButton: loomButton
        });
        return tr;
    };
const $a212a932479b4271$export$6f61f49dd8b64c45 = ({ error: error })=>({ tr: tr })=>{
        tr.setMeta((0, $1Tagp.loomPluginKey), {
            type: (0, $1Tagp.LoomPluginAction).DISABLE,
            error: error
        });
        return tr;
    };
const $a212a932479b4271$export$2d56b03ca3f4ead9 = ({ inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        tr.setMeta((0, $1Tagp.loomPluginKey), {
            type: (0, $1Tagp.LoomPluginAction).RECORD_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).RECORD_VIDEO,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $a212a932479b4271$export$3b5a9e613ed2ae87 = ({ inputMethod: inputMethod, error: error, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).RECORD_VIDEO_FAILED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod,
                error: error
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $a212a932479b4271$export$73a289ac38fc1ec = ({ editorAnalyticsAPI: editorAnalyticsAPI, video: video })=>({ tr: tr })=>{
        tr.setMeta((0, $1Tagp.loomPluginKey), {
            type: (0, $1Tagp.LoomPluginAction).INSERT_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERT_VIDEO,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                duration: video.duration
            }
        })(tr);
        return tr;
    };
const $a212a932479b4271$var$getPositions = (tr, posType)=>{
    const selection = tr.selection;
    switch(posType){
        case 'current':
            return {
                from: selection.from,
                to: selection.from
            };
        case 'start':
            return {
                from: 0,
                to: 0
            };
        case 'end':
            return {
                from: tr.doc.content.size,
                to: tr.doc.content.size
            };
    }
};
const $a212a932479b4271$export$e61f2d2bdaa7ecf4 = (editorView, api, video, positionType)=>{
    if (!editorView) return false;
    const { state: state, dispatch: dispatch } = editorView;
    const { from: from, to: to } = $a212a932479b4271$var$getPositions(state.tr, positionType);
    return api?.hyperlink?.actions.insertLink((0, $d925B.INPUT_METHOD).TYPEAHEAD, from, to, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch) ?? false;
};
const $a212a932479b4271$export$92a5ff9a4d5c2287 = (api)=>{
    api?.core?.actions.execute($a212a932479b4271$export$2d56b03ca3f4ead9({
        inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
        editorAnalyticsAPI: api?.analytics?.actions
    }));
};
const $a212a932479b4271$export$a39487b0b81d2404 = async (loomProvider, api, editorView, /**
	 * Whether loom initialisation is evoked via `initLoom` command.
	 */ initViaCommand)=>{
    const clientResult = await loomProvider.getClient();
    if (clientResult.status === 'error') {
        api?.core?.actions.execute($a212a932479b4271$export$6f61f49dd8b64c45({
            error: clientResult.message
        }));
        (0, $hWRJP.logException)(new Error(clientResult.message), {
            location: 'editor-plugin-loom/sdk-initialisation'
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: clientResult.message
            }
        });
        return {
            error: clientResult.message
        };
    }
    const { attachToButton: attachToButton } = clientResult.client;
    // Hidden element to work around the SDK API
    const loomButton = document.createElement('button');
    attachToButton({
        button: loomButton,
        onInsert: (video)=>{
            if (!editorView) return;
            const { state: state, dispatch: dispatch } = editorView;
            const pos = state.selection.from;
            api?.hyperlink?.actions.insertLink((0, $d925B.INPUT_METHOD).TYPEAHEAD, pos, pos, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch);
            api?.core?.actions.execute($a212a932479b4271$export$73a289ac38fc1ec({
                editorAnalyticsAPI: api?.analytics?.actions,
                video: video
            }));
        }
    });
    api?.core?.actions.execute(({ tr: tr })=>{
        $a212a932479b4271$export$b5c7c74886310ae0({
            loomButton: loomButton
        })({
            tr: tr
        });
        if (initViaCommand) api?.quickInsert?.commands.addQuickInsertItem((0, $hB6ux.getQuickInsertItem)(api?.analytics?.actions))({
            tr: tr
        });
        return tr;
    });
    // We're not combining the analytics steps into the enable / disable commands because the collab-edit plugin
    // filters out any transactions with steps (even analytics) when it's initialising.
    // Even if `initViaCommand` is true, collab-edit might not be ready depending on when `initLoom` is called,
    // hence the analytics step is added separately in both cases
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).INITIALISED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    });
    return {};
};
module.exports["recordVideo"] = $a212a932479b4271$export$2d56b03ca3f4ead9;
module.exports["recordVideoFailed"] = $a212a932479b4271$export$3b5a9e613ed2ae87;
module.exports["insertLoom"] = $a212a932479b4271$export$e61f2d2bdaa7ecf4;
module.exports["executeRecordVideo"] = $a212a932479b4271$export$92a5ff9a4d5c2287;
module.exports["setupLoom"] = $a212a932479b4271$export$a39487b0b81d2404;

});

parcelRegister("hB6ux", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $4HWgE = parcelRequire("4HWgE");


var $hWRJP = parcelRequire("hWRJP");


var $2Yaht = parcelRequire("2Yaht");


var $bdlPz = parcelRequire("bdlPz");


var $1Tagp = parcelRequire("1Tagp");

const $ad333a3a37885863$export$3432d7b65cad662d = (editorAnalyticsAPI)=>({ formatMessage: formatMessage })=>[
            {
                id: 'loom',
                title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordVideo),
                description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordVideoDescription),
                keywords: [
                    'loom',
                    'record',
                    'video'
                ],
                priority: 800,
                isDisabledOffline: true,
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        spacing: "spacious"
                    }),
                action (insert, editorState) {
                    const tr = insert(undefined);
                    const loomState = (0, $1Tagp.loomPluginKey).getState(editorState);
                    if (!loomState?.isEnabled) {
                        const errorMessage = loomState?.error;
                        (0, $hWRJP.logException)(new Error(errorMessage), {
                            location: 'editor-plugin-loom/quick-insert-record-video'
                        });
                        return (0, $bdlPz.recordVideoFailed)({
                            inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                            error: errorMessage,
                            editorAnalyticsAPI: editorAnalyticsAPI
                        })({
                            tr: tr
                        }) ?? false;
                    }
                    return (0, $bdlPz.recordVideo)({
                        inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                        editorAnalyticsAPI: editorAnalyticsAPI
                    })({
                        tr: tr
                    }) ?? false;
                }
            }
        ];
module.exports["getQuickInsertItem"] = $ad333a3a37885863$export$3432d7b65cad662d;

});

parcelRegister("1Tagp", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $bdlPz = parcelRequire("bdlPz");

var $ae8edf494757bf0e$export$5f9dbfce88541fe5 = /*#__PURE__*/ function(LoomPluginAction) {
    LoomPluginAction[LoomPluginAction["ENABLE"] = 0] = "ENABLE";
    LoomPluginAction[LoomPluginAction["DISABLE"] = 1] = "DISABLE";
    LoomPluginAction[LoomPluginAction["RECORD_VIDEO"] = 2] = "RECORD_VIDEO";
    LoomPluginAction[LoomPluginAction["INSERT_VIDEO"] = 3] = "INSERT_VIDEO";
    return LoomPluginAction;
}({});
const $ae8edf494757bf0e$export$db6b5ebe5a8c279 = new (0, $ks2lK.PluginKey)('loom');
const $ae8edf494757bf0e$export$ae829ec7b2625219 = ({ config: config, api: api })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $ae8edf494757bf0e$export$db6b5ebe5a8c279,
        state: {
            init: ()=>({
                    isEnabled: false,
                    loomButton: null,
                    isRecordingVideo: false,
                    error: undefined
                }),
            apply: (tr, pluginState)=>{
                const action = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279)?.type;
                switch(action){
                    case 0:
                        const { loomButton: loomButton } = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: true,
                            loomButton: loomButton
                        };
                    case 1:
                        const { error: error } = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: false,
                            loomButton: null,
                            error: error
                        };
                    case 2:
                        // Click the unmounted button in state that has the Loom SDK attached
                        pluginState?.loomButton?.click();
                        return {
                            ...pluginState,
                            isRecordingVideo: true
                        };
                    case 3:
                        return {
                            ...pluginState,
                            isRecordingVideo: false
                        };
                    default:
                        return pluginState;
                }
            }
        },
        view (editorView) {
            if (config.loomProvider) (0, $bdlPz.setupLoom)(config.loomProvider, api, editorView);
            return {};
        }
    });
};
module.exports["LoomPluginAction"] = $ae8edf494757bf0e$export$5f9dbfce88541fe5;
module.exports["loomPluginKey"] = $ae8edf494757bf0e$export$db6b5ebe5a8c279;
module.exports["createPlugin"] = $ae8edf494757bf0e$export$ae829ec7b2625219;

});

parcelRegister("1Elsv", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eiA8Z = parcelRequire("eiA8Z");


var $91bcx = parcelRequire("91bcx");


var $bdlPz = parcelRequire("bdlPz");


var $aOf65 = parcelRequire("aOf65");

const $e04bd784ac086222$var$selector = (states)=>{
    return {
        loomEnabled: states.loomState?.isEnabled,
        connectivityMode: states.connectivityState?.mode
    };
};
const $e04bd784ac086222$var$CustomisableLoomToolbarButton = (disabled, appearance, api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
        const { onClickBeforeInit: onClickBeforeInit, isDisabled: isDisabled = false, href: href, ...restProps } = props;
        const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
            'loom',
            'connectivity'
        ], $e04bd784ac086222$var$selector);
        const isLoomEnabled = !!loomEnabled;
        const handleOnClick = (0, $42omo.useCallback)((e)=>{
            if (isLoomEnabled) (0, $bdlPz.executeRecordVideo)(api);
            else onClickBeforeInit && onClickBeforeInit(e);
        }, [
            isLoomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aOf65.default), {
            ref: ref,
            hideTooltip: !!(restProps.onMouseEnter || restProps.onMouseLeave),
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: isLoomEnabled ? undefined : href,
            disabled: disabled || isDisabled || (0, $91bcx.isOfflineMode)(connectivityMode),
            api: api,
            appearance: appearance,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (e)=>handleOnClick(e),
            ...restProps
        });
    });
const $e04bd784ac086222$var$LoomToolbarButtonWrapper = ({ disabled: disabled, api: api, appearance: appearance })=>{
    const handleOnClick = (0, $42omo.useCallback)(()=>(0, $bdlPz.executeRecordVideo)(api), [
        api
    ]);
    const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'loom',
        'connectivity'
    ], $e04bd784ac086222$var$selector);
    if (loomEnabled === undefined) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aOf65.default), {
        // Disable the icon while the SDK isn't initialised
        disabled: disabled || !loomEnabled || (0, $91bcx.isOfflineMode)(connectivityMode),
        api: api,
        appearance: appearance,
        onClick: handleOnClick
    });
};
const $e04bd784ac086222$export$b7aa095334bc8677 = (config, api)=>({ disabled: disabled, appearance: appearance })=>{
        if (config.shouldShowToolbarButton === false) return null;
        if (config.renderButton) return config.renderButton($e04bd784ac086222$var$CustomisableLoomToolbarButton(disabled, appearance, api));
        if (config.shouldShowToolbarButton) return /*#__PURE__*/ (0, $9K4OG.jsx)($e04bd784ac086222$var$LoomToolbarButtonWrapper, {
            // Disable the icon while the SDK isn't initialised
            disabled: disabled,
            api: api,
            appearance: appearance
        });
        return null;
    };
module.exports["loomPrimaryToolbarComponent"] = $e04bd784ac086222$export$b7aa095334bc8677;

});

parcelRegister("aOf65", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $4HWgE = parcelRequire("4HWgE");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $2Yaht = parcelRequire("2Yaht");

function $e0f54c4226daf504$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
const $e0f54c4226daf504$var$LOOM_BUTTON_WIDTH_BREAKPOINT = 1076;
const $e0f54c4226daf504$var$iconMinWidthStyle = {
    name: "9bmev",
    styles: "min-width:24px"
};
const $e0f54c4226daf504$var$selector = (states)=>{
    return {
        width: states.widthState?.width
    };
};
const $e0f54c4226daf504$var$LoomToolbarButtonInternal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ disabled: disabled, api: api, appearance: appearance, intl: { formatMessage: formatMessage }, selected: selected, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'data-ds--level': dataDsLevel, onClick: onClick, href: href, target: target, hideTooltip: hideTooltip, rel: rel }, ref)=>{
    const { width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'width'
    ], $e0f54c4226daf504$var$selector);
    const label = formatMessage(appearance === 'comment' ? (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideoComment : (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideo);
    const shouldShowRecordText = (width || 0) > $e0f54c4226daf504$var$LOOM_BUTTON_WIDTH_BREAKPOINT;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        hideTooltip: hideTooltip,
        ref: ref,
        href: href,
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
        disabled: disabled,
        title: label,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: $e0f54c4226daf504$var$iconMinWidthStyle
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
            label: label,
            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
            spacing: "spacious"
        })),
        selected: selected,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        target: target,
        rel: rel
    }, shouldShowRecordText && formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordLoomShortTitle));
});
const $e0f54c4226daf504$var$_default_1 = (0, $aXWIB.injectIntl)($e0f54c4226daf504$var$LoomToolbarButtonInternal, {
    forwardRef: true
});
var $e0f54c4226daf504$export$2e2bcd8739ae039 = $e0f54c4226daf504$var$_default_1;
module.exports["default"] = $e0f54c4226daf504$export$2e2bcd8739ae039;

});

parcelRegister("8PlH8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $7gIIX = parcelRequire("7gIIX");


var $3Y62F = parcelRequire("3Y62F");

const $cc270d98483e6586$export$a758406ca53b86a5 = (config, api)=>{
    return [
        {
            type: (0, $cPCP8.LOOM_MENU_SECTION).type,
            key: (0, $cPCP8.LOOM_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.LOOM_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $3Y62F.MenuSection), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $cPCP8.LOOM_MENU_ITEM).type,
            key: (0, $cPCP8.LOOM_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.LOOM_MENU_SECTION).type,
                    key: (0, $cPCP8.LOOM_MENU_SECTION).key,
                    rank: (0, $4Chin.LOOM_MENU_SECTION_RANK)[(0, $cPCP8.LOOM_MENU_ITEM).key]
                },
                {
                    type: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                    key: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                    rank: (0, $4Chin.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $cPCP8.LOOM_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $7gIIX.LoomMenuItem), {
                    api: api,
                    renderButton: config.renderButton
                });
            },
            isHidden: ()=>{
                const loomState = api?.loom?.sharedState.currentState();
                const editorViewMode = api?.editorViewMode?.sharedState.currentState() ?? 'edit';
                // if shouldRenderButton is not provided, default to true
                const shouldRenderButton = config?.shouldRenderButton?.() ?? true;
                return 'renderButton' in config && shouldRenderButton === false || loomState?.isEnabled === undefined || editorViewMode !== 'edit';
            }
        }
    ];
};
module.exports["getToolbarComponents"] = $cc270d98483e6586$export$a758406ca53b86a5;

});

parcelRegister("7gIIX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $4HWgE = parcelRequire("4HWgE");


var $gzUv9 = parcelRequire("gzUv9");


var $2Yaht = parcelRequire("2Yaht");

var $2GVu1 = parcelRequire("2GVu1");


var $bdlPz = parcelRequire("bdlPz");

const $6934ba2fbea4b39b$var$useLoomEnabled = (api)=>{
    const { loomEnabled: loomEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'loom'
    ], (states)=>{
        return {
            loomEnabled: states.loomState?.isEnabled
        };
    });
    return loomEnabled;
};
const $6934ba2fbea4b39b$export$cfd738d449e0a4ef = ({ api: api, renderButton: renderButton })=>{
    const loomEnabled = $6934ba2fbea4b39b$var$useLoomEnabled(api);
    const { editorViewMode: editorViewMode } = (0, $gzUv9.useEditorToolbar)();
    if (editorViewMode !== 'edit') return null;
    if (renderButton) return renderButton($6934ba2fbea4b39b$export$a209d77fd6c75051(api));
    else if (loomEnabled !== undefined) return /*#__PURE__*/ (0, $l998X.jsx)($6934ba2fbea4b39b$var$DefaultLoomMenuItem, {
        api: api
    });
};
const $6934ba2fbea4b39b$export$a209d77fd6c75051 = (api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ isDisabled: isDisabled = false, onClickBeforeInit: onClickBeforeInit, href: href, target: target, rel: rel }, ref)=>{
        const loomEnabled = !!$6934ba2fbea4b39b$var$useLoomEnabled(api);
        const handleOnClick = (0, $42omo.useCallback)((e)=>{
            if (loomEnabled) (0, $bdlPz.executeRecordVideo)(api);
            else if (onClickBeforeInit && e.type === 'click' && e.target instanceof HTMLElement) onClickBeforeInit(e);
        }, [
            loomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)($6934ba2fbea4b39b$var$MenuItemComponent, {
            ref: ref,
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: loomEnabled ? undefined : href,
            disabled: isDisabled,
            onClick: handleOnClick,
            target: target,
            rel: rel
        });
    });
const $6934ba2fbea4b39b$var$DefaultLoomMenuItem = ({ api: api })=>{
    const loomEnabled = $6934ba2fbea4b39b$var$useLoomEnabled(api);
    const handleOnClick = (0, $42omo.useCallback)(()=>(0, $bdlPz.executeRecordVideo)(api), [
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($6934ba2fbea4b39b$var$MenuItemComponent, {
        disabled: !loomEnabled,
        onClick: handleOnClick
    });
};
const $6934ba2fbea4b39b$var$MenuItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(// eslint-disable-next-line no-unused-vars
({ disabled: disabled, onClick: onClick, href: href, target: target, rel: rel }, ref)=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
            size: "small",
            label: ""
        }),
        isDisabled: disabled,
        href: href,
        target: target,
        rel: rel,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>onClick(e),
        children: formatMessage(editorAppearance === 'comment' ? (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideoComment : (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideo)
    });
});
module.exports["LoomMenuItem"] = $6934ba2fbea4b39b$export$cfd738d449e0a4ef;

});

parcelRegister("3Y62F", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gzUv9 = parcelRequire("gzUv9");


var $6UWPx = parcelRequire("6UWPx");

const $0e0411cca8afc5ea$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $0e0411cca8afc5ea$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $0e0411cca8afc5ea$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};
module.exports["MenuSection"] = $0e0411cca8afc5ea$export$4b1545b4f2016d26;

});

parcelRegister("lQotL", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gSn22 = parcelRequire("gSn22");


var $lClEe = parcelRequire("lClEe");


var $dBGeU = parcelRequire("dBGeU");

const $976b4431197bda7a$export$a305f4d2cc38e07 = ({ api: api })=>({
        name: 'localId',
        actions: {
            replaceNode: (0, $gSn22.replaceNode)(api),
            getNode: (0, $gSn22.getNode)(api)
        },
        pmPlugins () {
            return [
                {
                    name: 'localIdPlugin',
                    plugin: ()=>(0, $lClEe.createPlugin)(api)
                },
                {
                    name: 'localId-watchmen',
                    plugin: ()=>(0, $dh538.fg)('platform_editor_ai_aifc_localid_error_reporting') ? (0, $dBGeU.createWatchmenPlugin)(api) : undefined
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const watchmentPluginState = (0, $dBGeU.localIdWatchmenPluginKey).getState(editorState);
            return {
                localIdWatchmenEnabled: !!watchmentPluginState?.enabled,
                localIdStatus: new Map(watchmentPluginState?.localIdStatus)
            };
        }
    });
module.exports["localIdPlugin"] = $976b4431197bda7a$export$a305f4d2cc38e07;

});

parcelRegister("gSn22", function(module, exports) {
function $1c3c5e644df8ef9c$export$aadcc3ba2430b(tr, localId) {
    let result;
    tr.doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.attrs.localId === localId) result = {
            node: node,
            pos: pos
        };
        return result === undefined;
    });
    return result;
}
const $1c3c5e644df8ef9c$export$5542201de9311ab2 = (api)=>({ localId: localId, value: value })=>{
        const nodeWithPos = $1c3c5e644df8ef9c$export$3f778c4e796a1f9c(api)({
            localId: localId
        });
        if (!nodeWithPos) return false;
        const { pos: pos, node: node } = nodeWithPos;
        return api?.core.actions.execute(({ tr: tr })=>tr.replaceWith(pos, pos + node.nodeSize, value).scrollIntoView()) ?? false;
    };
const $1c3c5e644df8ef9c$export$3f778c4e796a1f9c = (api)=>({ localId: localId })=>{
        let result;
        api?.core.actions.execute(({ tr: tr })=>{
            result = $1c3c5e644df8ef9c$export$aadcc3ba2430b(tr, localId);
            return null;
        });
        return result;
    };
module.exports["replaceNode"] = $1c3c5e644df8ef9c$export$5542201de9311ab2;
module.exports["getNode"] = $1c3c5e644df8ef9c$export$3f778c4e796a1f9c;

});

parcelRegister("lClEe", function(module, exports) {

var $7Mtx3 = parcelRequire("7Mtx3");


var $h3X17 = parcelRequire("h3X17");


var $1S4f7 = parcelRequire("1S4f7");


var $kTbzR = parcelRequire("kTbzR");


var $ks2lK = parcelRequire("ks2lK");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $f1E8N = parcelRequire("f1E8N");

const $afcb24c50c80cbe1$export$588b8cd7ca34b82 = new (0, $ks2lK.PluginKey)('localIdPlugin');
const $afcb24c50c80cbe1$var$generateUUID = ()=>{
    return (0, $f1E8N.generateShortUUID)();
};
// Fallback for Safari which doesn't support requestIdleCallback
const $afcb24c50c80cbe1$var$requestIdleCallbackWithFallback = (callback)=>{
    if (typeof requestIdleCallback !== 'undefined') requestIdleCallback(callback);
    else // Fallback to requestAnimationFrame for Safari
    requestAnimationFrame(callback);
};
const $afcb24c50c80cbe1$export$ae829ec7b2625219 = (api)=>{
    // Track if we've initialized existing UUIDs for this plugin instance
    let hasInitializedExistingUUIDs = false;
    return new (0, $1S4f7.SafePlugin)({
        key: $afcb24c50c80cbe1$export$588b8cd7ca34b82,
        view: (editorView)=>{
            /**
			 * This performs a one-time scan of the document to add local IDs
			 * to nodes that don't have them. It's designed to run only once per
			 * editor instance to avoid performance issues.
			 */ if (api?.collabEdit) return {
                update: ()=>{}
            };
            $afcb24c50c80cbe1$var$requestIdleCallbackWithFallback(()=>{
                const tr = editorView.state.tr;
                let localIdWasAdded = false;
                const nodesToUpdate = new Map(); // position -> localId
                const { text: text, hardBreak: hardBreak, mediaGroup: mediaGroup } = editorView.state.schema.nodes;
                // Media group is ignored for now
                // https://bitbucket.org/atlassian/adf-schema/src/fb2236147a0c2bc9c8efbdb75fd8f8c411df44ba/packages/adf-schema/src/next-schema/nodes/mediaGroup.ts#lines-12
                const ignoredNodeTypes = mediaGroup ? [
                    text.name,
                    hardBreak.name,
                    mediaGroup.name
                ] : [
                    text.name,
                    hardBreak.name
                ];
                editorView.state.doc.descendants((node, pos)=>{
                    if (!ignoredNodeTypes.includes(node.type.name) && !node.attrs.localId && !!node.type.spec.attrs?.localId) {
                        if ((0, $dh538.fg)('platform_editor_localid_improvements')) nodesToUpdate.set(pos, $afcb24c50c80cbe1$var$generateUUID());
                        else {
                            localIdWasAdded = true;
                            $afcb24c50c80cbe1$export$9c1f7572297aed68(pos, tr);
                        }
                    }
                    return true; // Continue traversing
                });
                if ((0, $dh538.fg)('platform_editor_localid_improvements')) {
                    if (nodesToUpdate.size > 0) {
                        $afcb24c50c80cbe1$export$6722232dcd7a6b1b(nodesToUpdate, tr);
                        (0, $h3X17.tintDirtyTransaction)(tr);
                        editorView.dispatch(tr);
                    }
                } else if (localIdWasAdded) {
                    tr.setMeta('addToHistory', false);
                    (0, $h3X17.tintDirtyTransaction)(tr);
                    editorView.dispatch(tr);
                }
            });
            return {
                update: ()=>{}
            };
        },
        /**
		 * Handles adding local IDs to new nodes that are created and have the localId attribute
		 * This ensures uniqueness of localIds on nodes being created or edited
		 */ appendTransaction: (transactions, _oldState, newState)=>{
            if (api?.composition.sharedState.currentState()?.isComposing && (0, $1oCLl.expValEquals)('platform_editor_localid_ime_composition_fix', 'isEnabled', true)) return undefined;
            let modified = false;
            const tr = newState.tr;
            const { text: text, hardBreak: hardBreak, mediaGroup: mediaGroup } = newState.schema.nodes;
            // Media group is ignored for now
            // https://bitbucket.org/atlassian/adf-schema/src/fb2236147a0c2bc9c8efbdb75fd8f8c411df44ba/packages/adf-schema/src/next-schema/nodes/mediaGroup.ts#lines-12
            const ignoredNodeTypes = [
                text?.name,
                hardBreak?.name,
                mediaGroup?.name
            ];
            const addedNodes = new Set();
            const addedNodePos = new Map();
            const localIds = new Set();
            const nodesToUpdate = new Map(); // position -> localId
            // Process only the nodes added in the transactions
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                if (transaction.getMeta('uiEvent') === 'cut' || // We skip remote transactions as we don't want to affect transactions created
                // by other users
                Boolean(transaction.getMeta('isRemote'))) return;
                // Ignore local ID updates for certain transactions
                // this is purposely not a public API as we should not use
                // this except in some circumstances (ie. streaming)
                if (transaction.getMeta('ignoreLocalIdUpdate')) return;
                transaction.steps.forEach((step)=>{
                    if (!(0, $kTbzR.stepHasSlice)(step)) return;
                    step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                        // Scan the changed range to find all nodes
                        tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                            if (ignoredNodeTypes.includes(node.type.name) || !node.type.spec.attrs?.localId) return true;
                            modified = true;
                            if ((0, $dh538.fg)('platform_editor_use_localid_dedupe')) {
                                // Always add to addedNodes for duplicate prevention
                                addedNodes.add(node);
                                addedNodePos.set(node, pos);
                            } else if (!node?.attrs.localId) {
                                if ((0, $dh538.fg)('platform_editor_localid_improvements')) nodesToUpdate.set(pos, $afcb24c50c80cbe1$var$generateUUID());
                                else // Legacy behavior - individual steps
                                $afcb24c50c80cbe1$export$9c1f7572297aed68(pos, tr);
                            }
                            return true;
                        });
                    });
                });
            });
            if (addedNodes.size > 0 && (0, $dh538.fg)('platform_editor_use_localid_dedupe')) {
                newState.doc.descendants((node)=>{
                    // Also track existing UUIDs in the global Set for short UUID collision detection
                    if (node.attrs?.localId && !hasInitializedExistingUUIDs) (0, $f1E8N.generatedShortUUIDs).add(node.attrs.localId);
                    if (addedNodes.has(node)) return true;
                    localIds.add(node.attrs.localId);
                    return true;
                });
                hasInitializedExistingUUIDs = true;
                // Also ensure the added have no duplicates
                const seenIds = new Set();
                for (const node of addedNodes){
                    if (!node.attrs.localId || localIds.has(node.attrs.localId) || seenIds.has(node.attrs.localId)) {
                        const pos = addedNodePos.get(node);
                        if (pos !== undefined) {
                            if ((0, $dh538.fg)('platform_editor_localid_improvements')) {
                                const newId = $afcb24c50c80cbe1$var$generateUUID();
                                nodesToUpdate.set(pos, newId);
                                seenIds.add(newId);
                            } else $afcb24c50c80cbe1$export$9c1f7572297aed68(pos, tr);
                            modified = true;
                        }
                    }
                    if (node.attrs.localId) seenIds.add(node.attrs.localId);
                }
            }
            // Apply local ID updates based on the improvements feature flag:
            // - When enabled: Batch all updates into a single BatchAttrsStep
            // - When disabled: Individual steps were already applied above during node processing
            if (modified && nodesToUpdate.size > 0 && (0, $dh538.fg)('platform_editor_localid_improvements')) $afcb24c50c80cbe1$export$6722232dcd7a6b1b(nodesToUpdate, tr);
            return modified ? tr : undefined;
        }
    });
};
const $afcb24c50c80cbe1$export$9c1f7572297aed68 = (pos, tr)=>{
    tr.setNodeAttribute(pos, 'localId', $afcb24c50c80cbe1$var$generateUUID());
    tr.setMeta('addToHistory', false);
};
const $afcb24c50c80cbe1$export$6722232dcd7a6b1b = (nodesToUpdate, tr)=>{
    const batchData = Array.from(nodesToUpdate.entries()).map(([pos, localId])=>{
        const node = tr.doc.nodeAt(pos);
        if (!node) throw new Error(`Node does not exist at position ${pos}`);
        return {
            position: pos,
            attrs: {
                localId: localId
            },
            nodeType: node.type.name
        };
    });
    tr.step(new (0, $7Mtx3.BatchAttrsStep)(batchData));
    tr.setMeta('addToHistory', false);
};
module.exports["createPlugin"] = $afcb24c50c80cbe1$export$ae829ec7b2625219;

});

parcelRegister("f1E8N", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");

const $78bd306b21f957cf$export$f710f46299736b99 = new Set();
const $78bd306b21f957cf$export$cafea8c01b062dd4 = ()=>{
    const maxRetries = 10;
    for(let attempt = 0; attempt < maxRetries; attempt++)try {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        const shortUUID = crypto.randomUUID().split('-')[4];
        if (!$78bd306b21f957cf$export$f710f46299736b99.has(shortUUID)) {
            $78bd306b21f957cf$export$f710f46299736b99.add(shortUUID);
            return shortUUID;
        }
    } catch  {
        break;
    }
    // Fallback to full UUID if short UUID generation fails or max retries exceeded
    return (0, $fO7hX.uuid).generate();
};
module.exports["generatedShortUUIDs"] = $78bd306b21f957cf$export$f710f46299736b99;
module.exports["generateShortUUID"] = $78bd306b21f957cf$export$cafea8c01b062dd4;

});

parcelRegister("dBGeU", function(module, exports) {

var $7Mtx3 = parcelRequire("7Mtx3");

var $9YoeD = parcelRequire("9YoeD");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");

/**
 * This is a safeguard limit to avoid tracking localIds in extremely large documents with too many localIds.
 * If the number of unique localIds exceeds this limit, the watchmen plugin will disable itself to avoid performance issues.
 * Reminder: The Map has a hard limit of 2^24 (16 million) entries in V8, please keep this value well below that
 * to avoid any potential memory issues.
 */ const $0beb72140a08d668$var$MAX_LOCAL_ID_MAP_SIZE = 2097152; // 2^21
const $0beb72140a08d668$export$a45751f625b5b80e = new (0, $ks2lK.PluginKey)('localIdWatchmenPlugin');
/**
 * Scans the entire document to find all active localIds
 */ const $0beb72140a08d668$var$scanDocumentForLocalIds = (doc)=>{
    const localIds = new Set();
    doc.descendants((node)=>{
        if (node.attrs?.localId) localIds.add(node.attrs.localId);
        // Check marks for localIds
        if (node.marks) node.marks.forEach((mark)=>{
            if (mark.attrs?.localId) localIds.add(mark.attrs.localId);
        });
        return localIds.size < $0beb72140a08d668$var$MAX_LOCAL_ID_MAP_SIZE; // Continue traversing
    });
    return localIds;
};
const $0beb72140a08d668$var$getReplacementStatusCode = (tr, step)=>{
    let method;
    if (step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $aXG5V.DocAttrStep)) method = 'ByAttr';
    else if (step instanceof (0, $9YoeD.SetAttrsStep)) method = 'BySetAttrs';
    else if (step instanceof (0, $7Mtx3.BatchAttrsStep)) method = 'ByBatchAttrs';
    else if (step instanceof (0, $aXG5V.ReplaceStep)) {
        const isDeleting = step.from < step.to; // range has content to remove
        const isInserting = step.slice.content.size > 0; // slice has content to insert
        if (isDeleting && !isInserting) method = 'ByDelete'; // removing content, inserting nothing
        else // isDeleting && isInserting
        method = 'ByReplace';
    } else if (step instanceof (0, $aXG5V.ReplaceAroundStep)) method = 'ByReplaceAround';
    else method = 'ByUnknown';
    if (tr.getMeta('isAIStreamingTransformation')) return `AIChange${method}`;
    if (tr.getMeta('replaceDocument')) return `docChange${method}`;
    if (tr.getMeta('isRemote')) return `remoteChange${method}`;
    return `localChange${method}`;
};
/**
 * Handles AttrStep and DocAttrStep which modify a single attribute
 */ const $0beb72140a08d668$var$handleAttrStep = (tr, step, localIdStatus, preDoc)=>{
    if (step.attr !== 'localId') return {
        localIdStatus: localIdStatus,
        modified: false
    };
    let modified = false;
    const newlocalIdStatus = new Map(localIdStatus);
    // Get the old value if it exists
    let oldLocalId;
    if (step instanceof (0, $aXG5V.AttrStep)) try {
        const node = preDoc.nodeAt(step.pos);
        oldLocalId = node?.attrs?.localId;
    } catch  {
    // Position might be invalid
    }
    // Handle the new value
    const newLocalId = step.value;
    if (oldLocalId && oldLocalId !== newLocalId) {
        // Old localId is being replaced or removed
        newlocalIdStatus.set(oldLocalId, $0beb72140a08d668$var$getReplacementStatusCode(tr, step));
        modified = true;
    }
    if (newLocalId) {
        newlocalIdStatus.set(newLocalId, 'current');
        modified = true;
    }
    return {
        localIdStatus: newlocalIdStatus,
        modified: modified
    };
};
/**
 * Handles SetAttrsStep which sets multiple attributes at once
 */ const $0beb72140a08d668$var$handleSetAttrsStep = (tr, step, localIdStatus, preDoc)=>{
    const attrs = step.attrs;
    if (!attrs || !attrs.hasOwnProperty('localId')) return {
        localIdStatus: localIdStatus,
        modified: false
    };
    let modified = false;
    const newlocalIdStatus = new Map(localIdStatus);
    // Get old localId from the node being modified
    try {
        const node = preDoc.nodeAt(step.pos);
        const oldLocalId = node?.attrs?.localId;
        if (oldLocalId && oldLocalId !== attrs.localId) {
            newlocalIdStatus.set(oldLocalId, $0beb72140a08d668$var$getReplacementStatusCode(tr, step));
            modified = true;
        }
    } catch  {
    // Position might be invalid
    }
    const newLocalId = attrs.localId;
    if (newLocalId) {
        newlocalIdStatus.set(newLocalId, 'current');
        modified = true;
    }
    return {
        localIdStatus: newlocalIdStatus,
        modified: modified
    };
};
/**
 * Handles BatchAttrsStep which applies multiple attribute changes
 */ const $0beb72140a08d668$var$handleBatchAttrsStep = (tr, step, localIdStatus, preDoc)=>{
    let modified = false;
    const newlocalIdStatus = new Map(localIdStatus);
    step.data.forEach((change)=>{
        if (!change.attrs?.hasOwnProperty('localId')) return;
        // Get old localId from the node being modified
        try {
            const node = preDoc.nodeAt(change.position);
            const oldLocalId = node?.attrs?.localId;
            const newLocalId = change.attrs.localId;
            if (oldLocalId && oldLocalId !== newLocalId) {
                newlocalIdStatus.set(oldLocalId, $0beb72140a08d668$var$getReplacementStatusCode(tr, step));
                modified = true;
            }
            if (newLocalId) {
                newlocalIdStatus.set(newLocalId, 'current');
                modified = true;
            }
        } catch  {
        // Position might be invalid
        }
    });
    return {
        localIdStatus: newlocalIdStatus,
        modified: modified
    };
};
/**
 * Handles ReplaceStep which inserts or deletes content
 */ const $0beb72140a08d668$var$handleReplaceStep = (tr, step, localIdStatus, preDoc, postDoc)=>{
    let modified = false;
    try {
        // Create a temporary set to collect new localIds
        const changedLocaleIds = new Map();
        const replaceCode = $0beb72140a08d668$var$getReplacementStatusCode(tr, step);
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            // For each step map item we can just look at the nodes in the old doc and mark them as "inactive" and then
            // look at the nodes in the doc after the step has been applied and mark them as "active"
            // then lastly we can compare these to the current states and only update what's different.
            preDoc.nodesBetween(oldStart, oldEnd, (node)=>{
                if (node.attrs?.localId) changedLocaleIds.set(node.attrs.localId, replaceCode);
                if (node.marks) node.marks.forEach((mark)=>{
                    if (mark.attrs?.localId) changedLocaleIds.set(node.attrs.localId, replaceCode);
                });
            });
            postDoc.nodesBetween(newStart, newEnd, (node)=>{
                if (node.attrs?.localId) changedLocaleIds.set(node.attrs.localId, 'current');
                if (node.marks) node.marks.forEach((mark)=>{
                    if (mark.attrs?.localId) changedLocaleIds.set(node.attrs.localId, 'current');
                });
            });
        });
        if (!!changedLocaleIds.size) {
            const newlocalIdStatus = new Map(localIdStatus);
            for (const [key, value] of changedLocaleIds)if (!localIdStatus.has(key) || localIdStatus.get(key) !== value) {
                modified = true;
                newlocalIdStatus.set(key, value);
            }
            return {
                localIdStatus: newlocalIdStatus,
                modified: modified
            };
        }
    } catch  {
    // If position calculation fails, do a full document rescan as fallback
    // This shouldn't happen often but provides safety
    }
    return {
        localIdStatus: localIdStatus,
        modified: modified
    };
};
/**
 * Handles ReplaceAroundStep which wraps or unwraps content
 */ const $0beb72140a08d668$var$handleReplaceAroundStep = (tr, step, localIdStatus, preDoc, postDoc)=>{
    let modified = false;
    const newlocalIdStatus = new Map(localIdStatus);
    // Scan the affected region before and after the step
    const from = step.from;
    const to = step.to;
    try {
        // Collect localIds from the old region
        const oldLocalIds = new Set();
        if (from < to && from >= 0 && to <= preDoc.content.size) preDoc.nodesBetween(from, to, (node)=>{
            if (node.attrs?.localId) oldLocalIds.add(node.attrs.localId);
            if (node.marks) node.marks.forEach((mark)=>{
                if (mark.attrs?.localId) oldLocalIds.add(mark.attrs.localId);
            });
        });
        // Collect localIds from the new region
        const map = step.getMap();
        const newFrom = map.map(from, -1);
        const newTo = map.map(to, 1);
        const newLocalIds = new Set();
        if (newFrom < newTo && newFrom >= 0 && newTo <= postDoc.content.size) postDoc.nodesBetween(newFrom, newTo, (node)=>{
            if (node.attrs?.localId) newLocalIds.add(node.attrs.localId);
            if (node.marks) node.marks.forEach((mark)=>{
                if (mark.attrs?.localId) newLocalIds.add(mark.attrs.localId);
            });
        });
        // Find localIds that were removed
        oldLocalIds.forEach((localId)=>{
            if (!newLocalIds.has(localId) && newlocalIdStatus.get(localId) === 'current') {
                newlocalIdStatus.set(localId, $0beb72140a08d668$var$getReplacementStatusCode(tr, step));
                modified = true;
            }
        });
        // Find localIds that were added
        newLocalIds.forEach((localId)=>{
            if (!oldLocalIds.has(localId)) {
                newlocalIdStatus.set(localId, 'current');
                modified = true;
            }
        });
    } catch  {
    // Position might be invalid, skip this step
    }
    return {
        localIdStatus: newlocalIdStatus,
        modified: modified
    };
};
/**
 * Processes a transaction to update localId tracking state
 */ const $0beb72140a08d668$var$processTransaction = (tr, currentState)=>{
    let localIdStatus = currentState.localIdStatus;
    let modified = false;
    // Process each step in the transaction
    try {
        tr.steps.forEach((step, index)=>{
            let result;
            // steps are relative to their docs, so we ensure we reference the doc before/after the step was applied.
            const preDoc = tr.docs?.[index] ?? tr.doc;
            const postDoc = tr.docs?.[index + 1] ?? tr.doc;
            if (step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $aXG5V.DocAttrStep)) result = $0beb72140a08d668$var$handleAttrStep(tr, step, localIdStatus, preDoc);
            else if (step instanceof (0, $9YoeD.SetAttrsStep)) result = $0beb72140a08d668$var$handleSetAttrsStep(tr, step, localIdStatus, preDoc);
            else if (step instanceof (0, $7Mtx3.BatchAttrsStep)) result = $0beb72140a08d668$var$handleBatchAttrsStep(tr, step, localIdStatus, preDoc);
            else if (step instanceof (0, $aXG5V.ReplaceStep)) result = $0beb72140a08d668$var$handleReplaceStep(tr, step, localIdStatus, preDoc, postDoc);
            else if (step instanceof (0, $aXG5V.ReplaceAroundStep)) result = $0beb72140a08d668$var$handleReplaceAroundStep(tr, step, localIdStatus, preDoc, postDoc);
            else // Unknown step type, no changes
            result = {
                localIdStatus: localIdStatus,
                modified: false
            };
            localIdStatus = result.localIdStatus;
            modified = modified || result.modified;
        });
    } catch  {
        // If any error occurs during step processing, we fallback to disabling the plugin
        return {
            enabled: false,
            initLocalIdSize: currentState.initLocalIdSize,
            localIdStatus: new Map(),
            lastUpdated: Date.now()
        };
    }
    // If nothing changed, return the same state object
    if (!modified) return currentState;
    // If we exceeded the max size while processing the steps, we need to disable the watchmen from further processing.
    // If a Map size limit of 2^24 is exceeded then it's more than likely an error would have been thrown during processing
    // which would also disable this plugin.
    if (localIdStatus.size >= $0beb72140a08d668$var$MAX_LOCAL_ID_MAP_SIZE) return {
        enabled: false,
        initLocalIdSize: currentState.initLocalIdSize,
        localIdStatus: new Map(),
        lastUpdated: Date.now()
    };
    // Return new state with updated sets
    return {
        enabled: true,
        initLocalIdSize: currentState.initLocalIdSize,
        localIdStatus: localIdStatus,
        lastUpdated: Date.now()
    };
};
const $0beb72140a08d668$export$69a1d29561fe4403 = (api)=>{
    // Ensure limited mode is initialized
    return new (0, $1S4f7.SafePlugin)({
        key: $0beb72140a08d668$export$a45751f625b5b80e,
        state: {
            init (_config, state) {
                const isLimitedModeEnabled = api?.limitedMode?.sharedState.currentState()?.enabled ?? false;
                if (isLimitedModeEnabled) return {
                    enabled: false,
                    initLocalIdSize: -1,
                    localIdStatus: new Map(),
                    lastUpdated: Date.now()
                };
                // Initialize by scanning the entire document
                const activeLocalIds = $0beb72140a08d668$var$scanDocumentForLocalIds(state.doc);
                if (activeLocalIds.size >= $0beb72140a08d668$var$MAX_LOCAL_ID_MAP_SIZE) return {
                    enabled: false,
                    initLocalIdSize: activeLocalIds.size,
                    localIdStatus: new Map(),
                    lastUpdated: Date.now()
                };
                return {
                    enabled: true,
                    initLocalIdSize: activeLocalIds.size,
                    localIdStatus: new Map(Array.from(activeLocalIds).map((key)=>[
                            key,
                            'current'
                        ])),
                    lastUpdated: Date.now()
                };
            },
            apply (tr, currentPluginState) {
                const { enabled: enabled } = tr.getMeta($0beb72140a08d668$export$a45751f625b5b80e) || {
                    enabled: currentPluginState.enabled
                };
                const newPluginState = currentPluginState;
                if (enabled !== currentPluginState.enabled) {
                    // If this plugin enabled state is changing and it's being disabled at runtime then we will kill this plugin
                    // to avoid tracking localIds when in limited mode or there after.
                    // Once disabled it cannot be re-enabled without a full editor reload.
                    if (!enabled) return {
                        enabled: false,
                        initLocalIdSize: currentPluginState.initLocalIdSize,
                        localIdStatus: currentPluginState.localIdStatus,
                        lastUpdated: Date.now()
                    };
                }
                if (!newPluginState.enabled) // If this plugin has been disabled, do not track localIds.
                return newPluginState;
                // If no steps, nothing changed
                if (tr.steps.length === 0 || !tr.docChanged) return newPluginState;
                // Process the transaction to update state
                return $0beb72140a08d668$var$processTransaction(tr, newPluginState);
            }
        },
        view (editorView) {
            // If limited mode changes, for example if we start not limited but then all of a sudden become limited, we kill
            // the watchment plugin to avoid tracking localIds when in limited mode. We also don't want/need to re-enable it once it's disabled.
            const unsub = api?.limitedMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                const watchmentPluginState = $0beb72140a08d668$export$a45751f625b5b80e.getState(editorView.state);
                if (nextSharedState.enabled && watchmentPluginState?.enabled === true) // if nextSharedState.enabled === true, then we need to disable the watchmen plugin, if not already disabled
                editorView.dispatch(editorView.state.tr.setMeta($0beb72140a08d668$export$a45751f625b5b80e, {
                    enabled: false
                }));
            });
            return {
                destroy: unsub
            };
        }
    });
};
module.exports["localIdWatchmenPluginKey"] = $0beb72140a08d668$export$a45751f625b5b80e;
module.exports["createWatchmenPlugin"] = $0beb72140a08d668$export$69a1d29561fe4403;

});

parcelRegister("cu2RD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jvymJ = parcelRequire("jvymJ");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $lYyGb = parcelRequire("lYyGb");


var $dzypS = parcelRequire("dzypS");


var $31vtz = parcelRequire("31vtz");


var $dLPJI = parcelRequire("dLPJI");


var $hpaOT = parcelRequire("hpaOT");


var $cdbrp = parcelRequire("cdbrp");


var $hCfMV = parcelRequire("hCfMV");

const $7ff11d0606ef5fb6$export$8751de4ba1d9a8f9 = ({ api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $cdbrp.PrimaryToolbarHighlightColorWithIntl), {
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            pluginInjectionApi: api,
            editorView: editorView
        });
    };
    if (!isToolbarAIFCEnabled) api?.primaryToolbar?.actions.registerComponent({
        name: 'highlight',
        component: primaryToolbarComponent
    });
    else api?.toolbar?.actions.registerComponents((0, $hCfMV.getToolbarComponent)(api));
    return {
        name: 'highlight',
        marks () {
            return [
                {
                    name: 'backgroundColor',
                    mark: (0, $jvymJ.backgroundColor)
                }
            ];
        },
        commands: {
            changeColor: (0, $lYyGb.changeColor)(editorAnalyticsAPI)
        },
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'highlight',
                    plugin: ()=>(0, $dLPJI.createPlugin)({
                            api: api
                        })
                },
                {
                    name: 'highlightKeymap',
                    plugin: ()=>(0, $31vtz.keymapPlugin)({
                            api: api
                        })
                },
                {
                    name: 'highlightPadding',
                    plugin: ()=>(0, $dzypS.createHighlightPaddingPlugin)()
                }
            ];
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $dLPJI.highlightPluginKey).getState(editorState);
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar () {
                const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hpaOT.FloatingToolbarHighlightColorWithIntl), {
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                pluginInjectionApi: api,
                                editorView: view
                            }),
                        fallback: []
                    };
                    const rank = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 5 : -9;
                    return {
                        rank: rank,
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        pluginName: 'highlight'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["highlightPlugin"] = $7ff11d0606ef5fb6$export$8751de4ba1d9a8f9;

});

parcelRegister("lYyGb", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $b167b = parcelRequire("b167b");


var $5qdhe = parcelRequire("5qdhe");


var $dLPJI = parcelRequire("dLPJI");


var $kRdr9 = parcelRequire("kRdr9");

const $443070aebdee33c1$export$917538e4f4eb20f9 = (editorAnalyticsAPI)=>({ color: color, inputMethod: inputMethod })=>({ tr: tr })=>{
            const { backgroundColor: backgroundColor } = tr.doc.type.schema.marks;
            if (!backgroundColor) return null;
            editorAnalyticsAPI?.attachAnalyticsEvent($443070aebdee33c1$var$createAnalyticsEvent(color, inputMethod, tr))(tr);
            tr.scrollIntoView();
            if (color === (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR)) (0, $b167b.removeMark)(backgroundColor)({
                tr: tr
            });
            else {
                tr.setMeta((0, $dLPJI.highlightPluginKey), {
                    type: (0, $dLPJI.HighlightPluginAction).CHANGE_COLOR,
                    color: color
                });
                (0, $b167b.toggleMark)(backgroundColor, {
                    color: color
                })({
                    tr: tr
                });
            }
            return tr;
        };
const $443070aebdee33c1$var$createAnalyticsEvent = (color, inputMethod, tr)=>{
    const previousColor = (0, $kRdr9.getActiveColor)(tr) ?? (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR);
    // get color names from palette
    const newColorFromPalette = (0, $5qdhe.highlightColorPalette).find(({ value: value })=>value === color);
    const previousColorFromPalette = (0, $5qdhe.highlightColorPalette).find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : color;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor;
    return {
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel ? previousColorLabel.toLowerCase() : '',
            inputMethod: inputMethod
        }
    };
};
module.exports["changeColor"] = $443070aebdee33c1$export$917538e4f4eb20f9;

});

parcelRegister("dLPJI", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $kRdr9 = parcelRequire("kRdr9");


var $2gsYp = parcelRequire("2gsYp");

const $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0 = new (0, $ks2lK.PluginKey)('highlight');
var $4d4a1e94f0e796d8$export$2dfab9d4f3f51423 = /*#__PURE__*/ function(HighlightPluginAction) {
    HighlightPluginAction[HighlightPluginAction["CHANGE_COLOR"] = 0] = "CHANGE_COLOR";
    HighlightPluginAction[HighlightPluginAction["SET_PALETTE"] = 1] = "SET_PALETTE";
    return HighlightPluginAction;
}({});
const $4d4a1e94f0e796d8$export$ae829ec7b2625219 = ({ api: api })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0,
        state: {
            init: (_, editorState)=>({
                    activeColor: null,
                    disabled: (0, $2gsYp.getDisabledState)(editorState),
                    isPaletteOpen: false
                }),
            apply: (tr, pluginState, _oldState, newState)=>{
                const action = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0)?.type;
                switch(action){
                    case 0:
                        const { color: color } = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            activeColor: color
                        };
                    case 1:
                        const { isPaletteOpen: isPaletteOpen } = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            isPaletteOpen: isPaletteOpen
                        };
                    default:
                        return {
                            ...pluginState,
                            activeColor: (0, $kRdr9.getActiveColor)(tr),
                            disabled: (0, $2gsYp.getDisabledState)(newState)
                        };
                }
            }
        }
    });
};
module.exports["highlightPluginKey"] = $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0;
module.exports["HighlightPluginAction"] = $4d4a1e94f0e796d8$export$2dfab9d4f3f51423;
module.exports["createPlugin"] = $4d4a1e94f0e796d8$export$ae829ec7b2625219;

});

parcelRegister("kRdr9", function(module, exports) {

var $b167b = parcelRequire("b167b");


var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");

const $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange = (from, to, tr)=>{
    const { doc: doc } = tr;
    const { backgroundColor: backgroundColor } = doc.type.schema.marks;
    const colorMarks = [];
    const colorSet = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (node.isLeaf) {
            const mark = backgroundColor.isInSet(node.marks);
            if (mark && !colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        }
    });
    return colorMarks;
};
const $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInCellSelection = (selection, tr)=>{
    const colorMarks = [];
    const colorSet = new Set();
    selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
        marks.forEach((mark)=>{
            if (!colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        });
    });
    return colorMarks;
};
// For Cell Selections - find first instance of a backgroundColor mark
// if all cells entirely contain this mark, set the color.
// If the selection contains multiple colors, return null
const $3d2494da195881ae$var$getColorFromCellSelection = (selection, tr)=>{
    const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInCellSelection(selection, tr);
    if (marks.length > 1) return 'multiple';
    const firstColorMark = marks.at(0);
    if (!firstColorMark) return null;
    let foundUncolouredNode = false;
    selection.forEachCell((cell, cellPos)=>{
        if (foundUncolouredNode) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!(0, $b167b.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) foundUncolouredNode = true;
    });
    return foundUncolouredNode ? null : firstColorMark.attrs.color;
};
// All other selections - find the first instance of a backgroundColor mark
// if selection entirely contains this mark, set the color.
// If the selection contains multiple colors, return null
const $3d2494da195881ae$var$getColorFromRange = (from, to, tr)=>{
    const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
    if (marks.length > 1) return 'multiple';
    const firstColorMark = marks.at(0);
    if (firstColorMark && (0, $b167b.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) return firstColorMark.attrs.color;
    return null;
};
// For Cursor selections - set color if it is found in the storedMarks or $cursor.marks
const $3d2494da195881ae$var$getColorFromCursor = (selection, tr)=>{
    if (!selection.$cursor) return null;
    const mark = tr.doc.type.schema.marks.backgroundColor.isInSet([
        ...tr.storedMarks ? tr.storedMarks : [],
        ...selection.$cursor.marks()
    ]);
    return mark?.attrs.color ?? null;
};
const $3d2494da195881ae$export$1c6fa8f53a5fb47f = (tr)=>{
    const { selection: selection } = tr;
    let color = null;
    if (selection instanceof (0, $7XFGZ.CellSelection)) color = $3d2494da195881ae$var$getColorFromCellSelection(selection, tr);
    else if (selection instanceof (0, $ks2lK.TextSelection) && selection.$cursor) color = $3d2494da195881ae$var$getColorFromCursor(selection, tr);
    else color = $3d2494da195881ae$var$getColorFromRange(selection.from, selection.to, tr);
    return color;
};
module.exports["getActiveColor"] = $3d2494da195881ae$export$1c6fa8f53a5fb47f;

});

parcelRegister("2gsYp", function(module, exports) {

var $l6xRR = parcelRequire("l6xRR");


var $adhil = parcelRequire("adhil");


var $ks2lK = parcelRequire("ks2lK");

const $7d78cd00df36c4c6$export$4af1020a67b5ec91 = (state)=>{
    const { backgroundColor: backgroundColor } = state.schema.marks;
    const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
    if (!backgroundColor) return true;
    if (state.selection instanceof (0, $ks2lK.NodeSelection) || state.selection instanceof (0, $adhil.GapCursorSelection)) return true;
    if (empty && !$cursor || (0, $l6xRR.isMarkAllowedInRange)(state.doc, ranges, backgroundColor) === false) return true;
    if ((0, $l6xRR.isMarkExcluded)(backgroundColor, state.storedMarks || $cursor && $cursor.marks())) return true;
    return false;
};
module.exports["getDisabledState"] = $7d78cd00df36c4c6$export$4af1020a67b5ec91;

});

parcelRegister("dzypS", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $lHd5I = parcelRequire("lHd5I");


var $g9iqE = parcelRequire("g9iqE");

const $9cdc59158e6be17c$export$64079c8b271eeba4 = new (0, $ks2lK.PluginKey)('highlightPaddingPluginKey');
const $9cdc59158e6be17c$export$8d5a971433249768 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $9cdc59158e6be17c$export$64079c8b271eeba4,
        state: {
            init: (_, state)=>{
                // Initially scan the entire doc to create all highlight padding decorations
                // after which updates will only apply to changed ranges
                const initialDecorationSet = (0, $ftzrq.DecorationSet).empty;
                const decorationSet = (0, $lHd5I.addPaddingDecorations)({
                    decorationSet: initialDecorationSet,
                    state: state,
                    from: 0,
                    to: state.doc.content.size
                });
                return {
                    decorationSet: decorationSet
                };
            },
            apply: (tr, pluginState, _oldState, state)=>{
                if (!tr.docChanged) return pluginState;
                let decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
                tr.mapping.maps.forEach((stepMap)=>{
                    stepMap.forEach((_oldStart, _oldEnd, start, end)=>{
                        decorationSet = (0, $g9iqE.updatePaddingDecorations)({
                            decorationSet: decorationSet,
                            state: state,
                            start: start,
                            end: end
                        });
                    });
                });
                return {
                    decorationSet: decorationSet
                };
            }
        },
        props: {
            decorations: (state)=>{
                return $9cdc59158e6be17c$export$64079c8b271eeba4.getState(state).decorationSet;
            }
        }
    });
};
module.exports["createHighlightPaddingPlugin"] = $9cdc59158e6be17c$export$8d5a971433249768;

});

parcelRegister("lHd5I", function(module, exports) {

var $ftzrq = parcelRequire("ftzrq");


var $27aZU = parcelRequire("27aZU");

const $75d65e7fd63930f1$var$createPaddingDecoration = ({ pos: pos, node: node, padLeft: padLeft, padRight: padRight })=>{
    const classes = [];
    const baseClass = 'background-color';
    const padLeftClass = `${baseClass}-padding-left`;
    const padRightClass = `${baseClass}-padding-right`;
    if (padLeft) classes.push(padLeftClass);
    if (padRight) classes.push(padRightClass);
    return (0, $ftzrq.Decoration).inline(pos, pos + node.nodeSize, {
        class: classes.join(' ')
    });
};
const $75d65e7fd63930f1$export$e955b6e659e59713 = ({ decorationSet: decorationSet, state: state, from: from, to: to })=>{
    let newDecorationSet = decorationSet;
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!(0, $27aZU.isHighlightedTextNode)(node)) return;
        const nodeStart = pos;
        const nodeEnd = pos + node.nodeSize;
        const padLeft = (0, $27aZU.shouldPadLeft)({
            state: state,
            nodeStart: nodeStart
        });
        const padRight = (0, $27aZU.shouldPadRight)({
            state: state,
            nodeEnd: nodeEnd
        });
        if (padLeft && padRight) {
            const newDecoration = $75d65e7fd63930f1$var$createPaddingDecoration({
                pos: nodeStart,
                node: node,
                padLeft: padLeft,
                padRight: padRight
            });
            newDecorationSet = newDecorationSet.add(state.doc, [
                newDecoration
            ]);
        }
    });
    return newDecorationSet;
};
module.exports["addPaddingDecorations"] = $75d65e7fd63930f1$export$e955b6e659e59713;

});

parcelRegister("27aZU", function(module, exports) {
const $8bd38b773d7252d2$export$d6f914f85b7b868b = (node)=>{
    return node.isText && node.marks.some((mark)=>mark.type.name === 'backgroundColor');
};
const $8bd38b773d7252d2$export$48e6e6ce50a6fb39 = ({ state: state, nodeStart: nodeStart })=>{
    const $pos = state.doc.resolve(nodeStart);
    const isAtBlockStart = $pos.parentOffset === 0;
    if (isAtBlockStart) return true;
    const isAtDocStart = nodeStart === 0;
    if (isAtDocStart) return true;
    const isPrevCharSpace = state.doc.textBetween(nodeStart - 1, nodeStart) === ' ';
    if (isPrevCharSpace) return true;
    return false;
};
const $8bd38b773d7252d2$export$b44b3045e621df46 = ({ state: state, nodeEnd: nodeEnd })=>{
    const $pos = state.doc.resolve(nodeEnd);
    const isAtBlockEnd = $pos.parentOffset === $pos.parent.content.size;
    if (isAtBlockEnd) return true;
    const isAtDocEnd = nodeEnd === state.doc.content.size;
    if (isAtDocEnd) return true;
    const isNextCharSpace = state.doc.textBetween(nodeEnd, nodeEnd + 1) === ' ';
    if (isNextCharSpace) return true;
    return false;
};
module.exports["isHighlightedTextNode"] = $8bd38b773d7252d2$export$d6f914f85b7b868b;
module.exports["shouldPadLeft"] = $8bd38b773d7252d2$export$48e6e6ce50a6fb39;
module.exports["shouldPadRight"] = $8bd38b773d7252d2$export$b44b3045e621df46;

});

parcelRegister("g9iqE", function(module, exports) {

var $lHd5I = parcelRequire("lHd5I");

const $8934f79a1793d309$export$d9003f1f8089aa99 = ({ decorationSet: prevDecorationSet, state: state, start: start, end: end })=>{
    // First remove any decorations within the range
    // Note that it finds all decorations in the set which touch the given range (including decorations that start or end directly at the boundaries)
    const toRemove = prevDecorationSet.find(start, end);
    const decorationSet = prevDecorationSet.remove(toRemove);
    // Expand the range by 1 on each side to catch adjacent text nodes
    // that may need padding decorations added/removed
    const from = Math.max(0, start - 1);
    const to = Math.min(state.doc.content.size, end + 1);
    return (0, $lHd5I.addPaddingDecorations)({
        decorationSet: decorationSet,
        state: state,
        from: from,
        to: to
    });
};
module.exports["updatePaddingDecorations"] = $8934f79a1793d309$export$d9003f1f8089aa99;

});

parcelRegister("31vtz", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");

var $60bKU = parcelRequire("60bKU");


var $gmyMu = parcelRequire("gmyMu");


var $5qdhe = parcelRequire("5qdhe");


var $lYyGb = parcelRequire("lYyGb");


var $3VmVg = parcelRequire("3VmVg");

function $37cb423ae71dbe77$export$e832373cff8dec22({ api: api }) {
    const list = {};
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (!isToolbarAIFCEnabled) (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleHighlightPalette).common, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $3VmVg.togglePalette)(api)({
        inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
    }), list);
    const analyticsApi = api?.analytics?.actions;
    const color = (0, $5qdhe.highlightColorPalette).find(({ label: label })=>label === 'Yellow');
    if (color) (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.applyYellowHighlight).common, (0, $gmyMu.editorCommandToPMCommand)((0, $lYyGb.changeColor)(analyticsApi)({
        color: color.value,
        inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
    })), list);
    return (0, $60bKU.keymap)(list);
}
module.exports["keymapPlugin"] = $37cb423ae71dbe77$export$e832373cff8dec22;

});

parcelRegister("3VmVg", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $dLPJI = parcelRequire("dLPJI");

const $0fd746eb53b3bb5e$export$7c9cf3bdfeac3246 = (api)=>({ inputMethod: inputMethod })=>(state, dispatch)=>{
            const isPaletteOpen = (0, $dLPJI.highlightPluginKey).getState(state)?.isPaletteOpen;
            return $0fd746eb53b3bb5e$export$9567774ece486a9(api)({
                isPaletteOpen: !isPaletteOpen,
                inputMethod: inputMethod
            })(state, dispatch);
        };
const $0fd746eb53b3bb5e$export$9567774ece486a9 = (api)=>({ isPaletteOpen: isPaletteOpen, inputMethod: inputMethod })=>(state, dispatch)=>{
            const isDisabled = (0, $dLPJI.highlightPluginKey).getState(state)?.disabled;
            if (!isDisabled) {
                const tr = state.tr;
                tr.setMeta((0, $dLPJI.highlightPluginKey), {
                    type: (0, $dLPJI.HighlightPluginAction).SET_PALETTE,
                    isPaletteOpen: isPaletteOpen
                });
                api.analytics?.actions.attachAnalyticsEvent($0fd746eb53b3bb5e$var$createAnalyticsEvent(isPaletteOpen, inputMethod))(tr);
                tr.setMeta('addToHistory', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
const $0fd746eb53b3bb5e$var$createAnalyticsEvent = (isPaletteOpen, inputMethod)=>{
    return {
        action: isPaletteOpen ? (0, $d925B.ACTION).OPENED : (0, $d925B.ACTION).CLOSED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod
        }
    };
};
module.exports["togglePalette"] = $0fd746eb53b3bb5e$export$7c9cf3bdfeac3246;
module.exports["setPalette"] = $0fd746eb53b3bb5e$export$9567774ece486a9;

});

parcelRegister("hpaOT", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");

parcelRequire("cQMhV");
var $c0czl = parcelRequire("c0czl");


var $hgeg8 = parcelRequire("hgeg8");


var $e0nFU = parcelRequire("e0nFU");


var $cORDs = parcelRequire("cORDs");

var $iMS6j = parcelRequire("iMS6j");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $bWiTS = parcelRequire("bWiTS");


var $ghftu = parcelRequire("ghftu");


var $74Ajl = parcelRequire("74Ajl");


var $iu6m9 = parcelRequire("iu6m9");


var $3VmVg = parcelRequire("3VmVg");


var $3hEpM = parcelRequire("3hEpM");


var $4je8H = parcelRequire("4je8H");

const $5945e95d36a07c01$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        activeColor: states.highlightState?.activeColor,
        disabled: states.highlightState?.disabled
    };
};
const $5945e95d36a07c01$var$FloatingToolbarHighlightColor = ({ pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $42omo.useRef)(null);
    const { activeColor: activeColor, disabled: disabled, isPaletteOpen: isPaletteOpen } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $5945e95d36a07c01$var$selector);
    const setDropdownOpen = (isOpen)=>{
        if (!disabled && editorView && pluginInjectionApi) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $3VmVg.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            })(state, dispatch);
        }
        pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
            action: isOpen ? (0, $d925B.ACTION).OPENED : (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            }
        });
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $4je8H.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || disabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $e0nFU.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(activeColor);
    const title = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel) : toolbarButtonLabel;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hEpM.PaletteDropdown), {
        isOpen: isDropdownOpen && !disabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $cORDs.disableBlueBorderStyles),
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
            disabled: disabled,
            selected: isDropdownOpen,
            "aria-label": title,
            "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: title,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $cORDs.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c0czl.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: disabled,
                icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($74Ajl))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: (0, $iMS6j.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }, (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') && formatMessage((0, $e0nFU.highlightMessages).highlightFloatingToolbar)),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    });
};
const $5945e95d36a07c01$export$5d201a8e1b725031 = (0, $aXWIB.injectIntl)($5945e95d36a07c01$var$FloatingToolbarHighlightColor);
module.exports["FloatingToolbarHighlightColorWithIntl"] = $5945e95d36a07c01$export$5d201a8e1b725031;

});

parcelRegister("3hEpM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $hxEux = parcelRequire("hxEux");

var $ahQKW = parcelRequire("ahQKW");

var $5qdhe = parcelRequire("5qdhe");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $bWiTS = parcelRequire("bWiTS");


var $aFUXX = parcelRequire("aFUXX");

const $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 8;
const $c17a292014f8c899$export$780f86860853be18 = (props)=>{
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isOpen: isOpen, activeColor: activeColor, trigger: trigger, onColorChange: onColorChange, isOpenedByKeyboard: isOpenedByKeyboard, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown } = props;
    // pixels, used to determine where to horizontally position the dropdown when space is limited
    // this should reflect the width of the dropdown when fully populated with colors, including translations due to layering
    const fitWidth = 274;
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $ahQKW.getSelectedRowAndColumnFromPalette)((0, $5qdhe.highlightColorPalette), activeColor, $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2dkHo.DropdownContainer), {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        isOpen: isOpen,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        zIndex: (0, $aFUXX.akEditorMenuZIndex),
        fitWidth: fitWidth,
        closeOnTab: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: true
        },
        trigger: trigger,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "highlight-color-palette",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hxEux.default), {
                cols: $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS,
                onClick: onColorChange,
                selectedColor: activeColor,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                paletteOptions: {
                    palette: (0, $5qdhe.highlightColorPalette),
                    hexToPaletteColor: (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)
                }
            })
        })
    });
};
module.exports["PaletteDropdown"] = $c17a292014f8c899$export$780f86860853be18;

});

parcelRegister("4je8H", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lYyGb = parcelRequire("lYyGb");

const $86014c52cbaafb4d$export$98f4eb06acf89919 = (args)=>{
    const { toolbarItemRef: toolbarItemRef, setIsDropdownOpen: setIsDropdownOpen, isDropdownOpen: isDropdownOpen, pluginInjectionApi: pluginInjectionApi } = args;
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $42omo.useState)(false);
    return {
        handleClick: ()=>{
            setIsOpenedByKeyboard(false);
            setIsDropdownOpen(!isDropdownOpen);
        },
        handleKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setIsOpenedByKeyboard(true);
                setIsDropdownOpen(!isDropdownOpen);
            }
        },
        handleClickOutside: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
            }
        },
        handleEscapeKeydown: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
                toolbarItemRef?.current?.focus();
            }
        },
        handleColorChange: ({ color: color, inputMethod: inputMethod })=>{
            pluginInjectionApi?.core?.actions.execute((0, $lYyGb.changeColor)(pluginInjectionApi?.analytics?.actions)({
                color: color,
                inputMethod: inputMethod
            }));
            setIsDropdownOpen(false);
        },
        isOpenedByKeyboard: isOpenedByKeyboard
    };
};
module.exports["useDropdownEvents"] = $86014c52cbaafb4d$export$98f4eb06acf89919;

});

parcelRegister("cdbrp", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");

parcelRequire("cQMhV");
var $c0czl = parcelRequire("c0czl");


var $hgeg8 = parcelRequire("hgeg8");


var $e0nFU = parcelRequire("e0nFU");


var $cORDs = parcelRequire("cORDs");

var $iMS6j = parcelRequire("iMS6j");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $bWiTS = parcelRequire("bWiTS");


var $ghftu = parcelRequire("ghftu");


var $74Ajl = parcelRequire("74Ajl");


var $1s5hv = parcelRequire("1s5hv");


var $3VmVg = parcelRequire("3VmVg");


var $3hEpM = parcelRequire("3hEpM");


var $4je8H = parcelRequire("4je8H");

const $9f842e0a01a1e3bc$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        highlightDisabled: states.highlightState?.disabled,
        activeColor: states.highlightState?.activeColor
    };
};
const $9f842e0a01a1e3bc$var$PrimaryToolbarHighlightColor = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $42omo.useRef)(null);
    const { isPaletteOpen: isPaletteOpen, highlightDisabled: highlightDisabled, activeColor: activeColor } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $9f842e0a01a1e3bc$var$selector);
    const setIsDropdownOpen = (isOpen)=>{
        if (!highlightDisabled) {
            const { state: state, dispatch: dispatch } = editorView;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $3VmVg.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
            })(state, dispatch);
        }
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $4je8H.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setIsDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || highlightDisabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $e0nFU.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(activeColor);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hEpM.PaletteDropdown), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isOpen: isDropdownOpen && !highlightDisabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $cORDs.disableBlueBorderStyles),
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: isToolbarReducedSpacing ? 'none' : 'default',
            disabled: disabled || highlightDisabled,
            selected: isDropdownOpen,
            "aria-label": (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel),
            "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel),
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $cORDs.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c0czl.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: highlightDisabled,
                icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($74Ajl))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: (0, $iMS6j.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    }));
};
const $9f842e0a01a1e3bc$export$124ac7b23aa1ea6a = (0, $aXWIB.injectIntl)($9f842e0a01a1e3bc$var$PrimaryToolbarHighlightColor);
module.exports["PrimaryToolbarHighlightColorWithIntl"] = $9f842e0a01a1e3bc$export$124ac7b23aa1ea6a;

});

parcelRegister("hCfMV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $kRJ3B = parcelRequire("kRJ3B");

const $a5b7313ece327a81$export$6cd8b101843de8d2 = (api)=>{
    return [
        {
            ...(0, $cPCP8.HIGHLIGHT_MENU_ITEM),
            parents: [
                {
                    ...(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $4Chin.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $cPCP8.HIGHLIGHT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kRJ3B.HighlightColorMenuItem), {
                    api: api,
                    parents: parents
                })
        }
    ];
};
module.exports["getToolbarComponent"] = $a5b7313ece327a81$export$6cd8b101843de8d2;

});

parcelRegister("kRJ3B", function(module, exports) {
/* HighlightColorMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e0nFU = parcelRequire("e0nFU");


var $4Dsx2 = parcelRequire("4Dsx2");


var $5qdhe = parcelRequire("5qdhe");


var $b3YrF = parcelRequire("b3YrF");


var $bWiTS = parcelRequire("bWiTS");


var $g66hv = parcelRequire("g66hv");

var $5v3PK = parcelRequire("5v3PK");


var $cO1el = parcelRequire("cO1el");


var $cvXh8 = parcelRequire("cvXh8");


var $5gydP = parcelRequire("5gydP");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

const $c3912d4eed8d6b1c$var$styles = {
    container: "_zulp12x7 _19pkpxbi",
    removeHighlightButton: "_2rko12b0 _195gv77o _189ee4h9 _1dqonqa1 _1h6d1l7x",
    icon: "_1e0c1o8l _18u01n1a"
};
const $c3912d4eed8d6b1c$var$TextColorIconDecorator = ({ label: label, isSelected: isSelected })=>{
    const iconColor = "var(--ds-icon, #292A2E)";
    return isSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        color: iconColor,
        label: label
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: $c3912d4eed8d6b1c$var$styles.icon,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gydP))), {
            label: label,
            color: iconColor,
            shouldRecommendSmallIcon: true,
            spacing: "spacious",
            size: "small"
        })
    });
};
function $c3912d4eed8d6b1c$export$5b2f3a4c271f0961({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const activeColor = (0, $b3YrF.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    const context = (0, $5v3PK.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const handleHighlightColorChange = (0, $42omo.useCallback)((color, event)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $4Dsx2.getInputMethodFromParentKeys)(parents)
            }));
            closeMenu?.(event);
        }
    }, [
        api,
        closeMenu,
        parents
    ]);
    const colorPalette = (0, $42omo.useMemo)(()=>{
        const isSelected = (color)=>color.value === activeColor;
        return (0, $5qdhe.highlightColorPalette).filter((color)=>color.value !== (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR)).map((color)=>({
                ...color,
                decorator: /*#__PURE__*/ (0, $l998X.jsx)($c3912d4eed8d6b1c$var$TextColorIconDecorator, {
                    label: color.label,
                    isSelected: isSelected(color)
                })
            }));
    }, [
        activeColor
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $c3912d4eed8d6b1c$var$styles.container,
        testId: "highlight-color-menu-item",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "xxsmall",
                children: formatMessage((0, $e0nFU.highlightMessages).highlight)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $g66hv.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ), {
                onClick: (color, _, event)=>{
                    handleHighlightColorChange(color, event);
                },
                selectedColor: activeColor || null,
                paletteOptions: {
                    palette: colorPalette || [],
                    hexToPaletteColor: (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)
                }
            })
        ]
    });
}
module.exports["HighlightColorMenuItem"] = $c3912d4eed8d6b1c$export$5b2f3a4c271f0961;

});

parcelRegister("jgFdO", function(module, exports) {

var $aMfes = parcelRequire("aMfes");


var $aBpO5 = parcelRequire("aBpO5");

const $ee26c792ae0f4629$export$a69eee655819c5bd = ({ api: api, config: config })=>{
    return {
        name: 'codeBlockAdvanced',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $aMfes.codeBlockNodeWithFixedToDOM)({
                        allowCodeFolding: config?.allowCodeFolding ?? false
                    })
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlockAdvancedPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $aBpO5.createPlugin)({
                            api: api,
                            extensions: config?.extensions ?? [],
                            allowCodeFolding: config?.allowCodeFolding ?? false,
                            getIntl: getIntl
                        })
                }
            ];
        }
    };
};
module.exports["codeBlockAdvancedPlugin"] = $ee26c792ae0f4629$export$a69eee655819c5bd;

});

parcelRegister("aMfes", function(module, exports) {

var $4HD7y = parcelRequire("4HD7y");


var $24P9d = parcelRequire("24P9d");


var $5MaNT = parcelRequire("5MaNT");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

const $0b09362160fbf83a$var$codeBlockClassNames = {
    container: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    content: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
};
const $0b09362160fbf83a$var$MATCH_NEWLINES = new RegExp('\n', 'gu');
const $0b09362160fbf83a$var$getFontSize = ()=>(0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? '0.875em' : '0.875rem';
// Based on: `packages/editor/editor-plugin-code-block/src/nodeviews/code-block.ts`
const $0b09362160fbf83a$var$toDOM = (node, formattedAriaLabel, config)=>{
    let totalLineCount = 1;
    node.forEach((node)=>{
        const text = node.text;
        if (text) totalLineCount += (node.text.match($0b09362160fbf83a$var$MATCH_NEWLINES) || []).length;
    });
    const maxDigits = totalLineCount.toString().length;
    const content = node.textContent.split('\n').map((_, i)=>i + 1).join('\n');
    return [
        'pre',
        {
            class: $0b09362160fbf83a$var$codeBlockClassNames.container,
            style: `--lineNumberGutterWidth:${maxDigits}ch;`,
            'data-language': node.attrs.language || ''
        },
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.contentWrapper
            },
            [
                'div',
                {
                    // Based on packages/editor/editor-common/src/styles/shared/code-block.ts
                    // But we can't reuse that class as it adds a ::before that intefers with this approach
                    style: (0, $24P9d.convertToInlineCss)({
                        backgroundColor: "var(--ds-background-neutral, #0515240F)",
                        position: 'relative',
                        width: 'var(--lineNumberGutterWidth, 2rem)',
                        /* top and bottom | left and right */ padding: config.allowCodeFolding ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-100, 8px)",
                        flexShrink: 0,
                        fontSize: $0b09362160fbf83a$var$getFontSize(),
                        boxSizing: 'content-box'
                    }),
                    contenteditable: 'false'
                },
                [
                    'div',
                    {
                        class: 'code-block-gutter-pseudo-element',
                        style: (0, $24P9d.convertToInlineCss)({
                            textAlign: 'right',
                            color: "var(--ds-text-subtlest, #6B6E76)",
                            fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
                            whiteSpace: 'pre-wrap'
                        }),
                        'data-label': content
                    }
                ]
            ],
            [
                'div',
                {
                    class: $0b09362160fbf83a$var$codeBlockClassNames.content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.end,
                contenteditable: 'false'
            }
        ]
    ];
};
const $0b09362160fbf83a$export$3cf83e71c577e77b = (config)=>{
    return {
        ...(0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $4HD7y.codeBlockWithLocalId) : (0, $4HD7y.codeBlock),
        toDOM: (node)=>$0b09362160fbf83a$var$toDOM(node, '', config)
    };
};
module.exports["codeBlockNodeWithFixedToDOM"] = $0b09362160fbf83a$export$3cf83e71c577e77b;

});

parcelRegister("aBpO5", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $76ISC = parcelRequire("76ISC");


var $iNmBw = parcelRequire("iNmBw");

const $c622eb7762717460$export$ae829ec7b2625219 = (props)=>{
    return new (0, $1S4f7.SafePlugin)({
        props: {
            nodeViews: {
                codeBlock: (0, $76ISC.lazyCodeBlockView)(props)
            },
            // Custom selection behaviour to fix issues with codeblocks with Shift + Arrow{Up || Down}
            // These issues are also present in the prosemirror codemirror example and @marijnh suggests to
            // use custom event handlers: https://github.com/ProseMirror/website/issues/83
            handleKeyDown (view, event) {
                if (!(event instanceof KeyboardEvent)) return false;
                if (event.key === 'ArrowUp' && event.shiftKey) return (0, $iNmBw.shiftArrowUpWorkaround)(view, event);
                else if (event.key === 'ArrowDown' && event.shiftKey) return (0, $iNmBw.shiftArrowDownWorkaround)(view, event);
            }
        }
    });
};
module.exports["createPlugin"] = $c622eb7762717460$export$ae829ec7b2625219;

});

parcelRegister("76ISC", function(module, exports) {

var $ftpVl = parcelRequire("ftpVl");


const $ac8e0ae822b535d4$export$28da8fbeb01202c6 = (props)=>{
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'codeBlock',
        getNodeViewOptions: ()=>{},
        loader: async ()=>{
            const { getCodeBlockAdvancedNodeView: getCodeBlockAdvancedNodeView } = await (parcelRequire("9OMY8"));
            return (node, view, getPos, _decs, _nodeViewOptions, innerDecorations)=>getCodeBlockAdvancedNodeView(props)(node, view, getPos, innerDecorations);
        }
    });
};
module.exports["lazyCodeBlockView"] = $ac8e0ae822b535d4$export$28da8fbeb01202c6;

});

parcelRegister("9OMY8", function(module, exports) {

let $725ec4c8487de059$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $725ec4c8487de059$var$load("g9tji"),
    $725ec4c8487de059$var$load("FOgP0"),
    $725ec4c8487de059$var$load("gTkiI"),
    $725ec4c8487de059$var$load("d3gsT"),
    $725ec4c8487de059$var$load("6XNSn")
]).then(()=>parcelRequire('2SLpl'));

});

parcelRegister("iNmBw", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $1f2f0f9c198ac88d$export$d4559115ffe0b372 = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = Math.max($head.pos - 1, 1);
    const isNodeBefore = doc.resolve(pos).nodeBefore?.type === codeBlock;
    const maybeProblematicNode = isNodeBefore ? doc.resolve(pos).nodeBefore : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeBefore ? pos : $head.pos;
        tr.setSelection((0, $ks2lK.TextSelection).create(doc, $anchor.pos, Math.max(startPos - nodeSize, 0)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
const $1f2f0f9c198ac88d$export$ba335e235e59f4ed = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = $head.pos + 1;
    const isNodeAfter = doc.resolve(pos).nodeAfter?.type === codeBlock;
    const maybeProblematicNode = isNodeAfter ? doc.resolve(pos).nodeAfter : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeAfter ? pos : $head.pos;
        tr.setSelection((0, $ks2lK.TextSelection).create(doc, $anchor.pos, Math.min(startPos + nodeSize, doc.content.size)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
module.exports["shiftArrowUpWorkaround"] = $1f2f0f9c198ac88d$export$d4559115ffe0b372;
module.exports["shiftArrowDownWorkaround"] = $1f2f0f9c198ac88d$export$ba335e235e59f4ed;

});

parcelRegister("1Rod9", function(module, exports) {

var $9ciHB = parcelRequire("9ciHB");

function $33d6ff45ac878a78$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["createFeatureFlagsFromProps"] = $33d6ff45ac878a78$export$63102b0cbe181144;

});

parcelRegister("aGjYc", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $9a76668fa978df44$export$6af3d18059afaa9e = 'outOfDate';
const $9a76668fa978df44$var$logger = (0, $7W8i8.getLogger)('comment-draft-utils');
const $9a76668fa978df44$var$getKey = (type, mode)=>{
    switch(type){
        case 'edit-inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_REPLY;
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
};
const $9a76668fa978df44$export$a4f0a5ceed96eae8 = (adf, pageId, type, mode)=>{
    let b64EncodedDraftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const draftObj = JSON.stringify({
        pageId: pageId,
        adf: adf
    });
    try {
        b64EncodedDraftObj = btoa(draftObj);
    } catch (e) {
        $9a76668fa978df44$var$logger.error`Unable to save draft object for ${pageId}; ${e}`;
    }
    if (b64EncodedDraftObj === null) return false;
    // Store the draft with a 72 hour expiration
    (0, $17wUi.confluenceLocalStorageInstance).setItem(key, b64EncodedDraftObj, 259200);
    return true;
};
const $9a76668fa978df44$export$e7cfba777a0d590e = (type, mode)=>{
    const key = $9a76668fa978df44$var$getKey(type, mode);
    (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
};
const $9a76668fa978df44$export$5fff31d3d3e1ad8b = (pageId, type, mode)=>Boolean($9a76668fa978df44$export$7c0604f3bd51258a(pageId, type, mode));
const $9a76668fa978df44$export$7c0604f3bd51258a = (pageId, type, mode)=>{
    let draftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const b64EncodedDraftObj = (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
    if (b64EncodedDraftObj !== null) {
        try {
            draftObj = JSON.parse(atob(b64EncodedDraftObj));
        } catch (e) {
            $9a76668fa978df44$var$logger.error`Unable to get draft object for ${pageId}; ${e}`;
        }
        if (draftObj) {
            const { pageId: draftPageId, adf: adf } = draftObj;
            // If the pageId matches, return the ADF, otherwise return null
            if (draftPageId === pageId) return adf;
        }
    }
    return null;
};
module.exports["OUT_OF_DATE_KEY"] = $9a76668fa978df44$export$6af3d18059afaa9e;
module.exports["saveCommentDraft"] = $9a76668fa978df44$export$a4f0a5ceed96eae8;
module.exports["clearCommentDraft"] = $9a76668fa978df44$export$e7cfba777a0d590e;
module.exports["hasCommentDraft"] = $9a76668fa978df44$export$5fff31d3d3e1ad8b;
module.exports["getCommentDraft"] = $9a76668fa978df44$export$7c0604f3bd51258a;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $42omo.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("ag51I", function(module, exports) {

var $49xGN = parcelRequire("49xGN");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");

// This hook returns a mutation function to create a new comment on an object. Because the new
// Comments Data Manager caches all the data for comments in Relay, we need to define the mutation
// here so that the cache can be updated fully when a new comment is created - and that means the
// mutation needs to return the full comment data structure that we are using in the returned query
// part of the mutation.  Since that returned query is quite large, we define it here in its own
// hook to avoid having it in many places in the codebase - which makes the code harder to read and
// could lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
const $8cba0eaacdb447e5$var$CreateObjectCommentMutation = (0, $49xGN.default);
const $8cba0eaacdb447e5$export$14bad9f468eeedfb = ()=>{
    const [createObjectCommentFn] = (0, $308Wd.useMutationInterop)($8cba0eaacdb447e5$var$CreateObjectCommentMutation);
    return createObjectCommentFn;
};
const $8cba0eaacdb447e5$export$be067408524a8736 = (commentData)=>{
    return commentData ? {
        ...commentData,
        replies: [],
        reactionsSummary: (0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true) ? null : commentData.reactionsSummary ?? null
    } : undefined;
};
module.exports["useCreateObjectCommentMutation"] = $8cba0eaacdb447e5$export$14bad9f468eeedfb;
module.exports["addEmptyObjectRepliesAndReactions"] = $8cba0eaacdb447e5$export$be067408524a8736;

});

parcelRegister("49xGN", function(module, exports) {
/**
 * @generated SignedSource<<0c001ca977c14ebc611ed135e5bb7f2e>>
 * @relayHash e4c493ec197fdfb6eb597c1e5cc6c430
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec5d148a6bf1b0bbf739ad3280e032c82fd08256cc50a97dc2063f7726739d5e
const $2b92f41c42f85596$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsSummary"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v14 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createFooterComment",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v9 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                },
                {
                    "condition": "includeReactionsSummary",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "pageId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateObjectCommentMutation",
            "selections": v14 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateObjectCommentMutation",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "e4c493ec197fdfb6eb597c1e5cc6c430",
            "id": "ec5d148a6bf1b0bbf739ad3280e032c82fd08256cc50a97dc2063f7726739d5e",
            "metadata": {},
            "name": "useCreateObjectCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateObjectCommentMutation($pageId:ID!,$cloudId:ID!,$input:CreateCommentInput!,$includeReactionsSummary:Boolean!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$2b92f41c42f85596$var$node.hash = "c1ecd7a7f6b08a2552cfea3da74fecee";
var $2b92f41c42f85596$export$2e2bcd8739ae039 = $2b92f41c42f85596$var$node;
module.exports["default"] = $2b92f41c42f85596$export$2e2bcd8739ae039;

});

parcelRegister("famWw", function(module, exports) {
/* AddCommentPromptButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $c6fYi = parcelRequire("c6fYi");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $9wGTI = parcelRequire("9wGTI");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");

const $6aab88ace7ca0350$var$styles = {
    addCommentButtonStyle: "_1yt4ze3t _2rko12b0 _11c8fhey _1e0c1txw _1tkezwfg _19bvutpp _u5f3utpp _1bah1h6o _4cvr1h6o _syazazsu",
    enabledStyle: "_bfhksm61 _d0altlke _irr31dpa",
    disabledStyle: "_bfhkby5v _80om13gf _syaz1gmx",
    fullWidthStyle: "_1bsb1osq"
};
const $6aab88ace7ca0350$var$i18n = (0, $aXWIB.defineMessages)({
    addCommentPromptText: {
        id: "comments-common.add-comment-prompt.text",
        defaultMessage: "Add a comment"
    },
    addCommentPromptAriaLabel: {
        id: "comments-common.add-comment-prompt.aria-label",
        defaultMessage: "Add a general comment"
    }
});
const $6aab88ace7ca0350$export$caf1bbdc1c7b1a40 = ({ onClick: onClick, autofocusRef: autofocusRef, shouldFitContainer: shouldFitContainer, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId || '');
    const buttonRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (autofocusRef.current) {
            buttonRef.current?.focus({
                preventScroll: true
            });
            autofocusRef.current = false;
        }
    }, [
        autofocusRef
    ]);
    const allowAddComment = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? canAddComments : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($6aab88ace7ca0350$var$styles.addCommentButtonStyle, !allowAddComment ? $6aab88ace7ca0350$var$styles.disabledStyle : $6aab88ace7ca0350$var$styles.enabledStyle, shouldFitContainer && $6aab88ace7ca0350$var$styles.fullWidthStyle),
        isDisabled: !allowAddComment,
        onClick: onClick,
        testId: testId,
        ref: buttonRef,
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            'aria-label': formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptAriaLabel)
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6fYi))), {
        label: formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), null, formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText))));
};
module.exports["AddCommentPromptButton"] = $6aab88ace7ca0350$export$caf1bbdc1c7b1a40;

});

parcelRegister("kKAQX", function(module, exports) {
/**
 * @generated SignedSource<<c5008fda444ba5427db7f5c49b38d99b>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $485d7166d746f7d6$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $485d7166d746f7d6$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $485d7166d746f7d6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ContentRepresentation"] = $485d7166d746f7d6$export$f4016897b165b6d5;
module.exports["Platform"] = $485d7166d746f7d6$export$2dffd0b5373a4389;

});

parcelRegister("87CZC", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $abN8T = parcelRequire("abN8T");


var $7W8i8 = parcelRequire("7W8i8");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $cD1qu = parcelRequire("cD1qu");


var $irVI7 = parcelRequire("irVI7");


var $56QzY = parcelRequire("56QzY");


var $en1dX = parcelRequire("en1dX");


var $gtj7V = parcelRequire("gtj7V");


var $2i3To = parcelRequire("2i3To");


var $ftXPY = parcelRequire("ftXPY");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");

const $80b47fa0b569ef69$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $80b47fa0b569ef69$export$a02bedef5e94d20c = (actionType, queryVariables, isReactionsEnabled, commentId)=>(_cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, type: type } = queryVariables;
        try {
            const singleType = type && type.length >= 1 ? type[0] : undefined;
            const consistentQueryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: pageId,
                type: singleType
            });
            // Update the comments panel data
            const commentsPanelCacheResponse = (0, $l1uFv.readQueryInterop)({
                query: (0, $b1hSc.default),
                variables: consistentQueryVariables
            });
            if (commentsPanelCacheResponse) {
                const panelNodes = commentsPanelCacheResponse?.comments?.nodes || [];
                if (actionType === 'delete') {
                    // Remove the returned commentId from the cache and reset it
                    const idxToRemove = panelNodes.findIndex((comment)=>comment?.id === commentId);
                    if (idxToRemove !== -1) panelNodes.splice(idxToRemove, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment,
                        replies: []
                    };
                    // Add the new reply entry to the cache and reset it
                    panelNodes.push(mutationResult);
                }
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $b1hSc.default),
                    variables: consistentQueryVariables,
                    data: commentsPanelCacheResponse
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = (0, $l1uFv.readQueryInterop)({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                }
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentSectionCacheDataClone = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = [
                    ...commentSectionCacheDataClone?.comments?.edges || []
                ];
                if (actionType === 'delete') {
                    // Find the last index of the top level comment to delete
                    const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                    if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment
                    };
                    // As far as I can tell, this is always called w/o reactions enabled
                    // This maps the mutation result we get to the cache object that's expected by the comments section query
                    const cacheCommentObject = {
                        id: mutationResult.id,
                        ancestors: [],
                        author: {
                            ...mutationResult.author,
                            type: 'known'
                        },
                        body: mutationResult.body,
                        contentStatus: mutationResult.contentStatus,
                        links: {
                            webui: mutationResult.links.webui,
                            // @ts-ignore
                            __typename: mutationResult.links.__typename
                        },
                        location: mutationResult.location,
                        parentId: mutationResult.parentId,
                        permissions: mutationResult.permissions,
                        version: {
                            ...mutationResult.version,
                            friendlyWhen: 'Just now',
                            // TODO: Maybe replace this with the actual date
                            by: {
                                type: 'user',
                                displayName: '',
                                accountId: '',
                                __typename: 'User'
                            },
                            __typename: 'Version'
                        },
                        __typename: 'Comment'
                    };
                    // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                    const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                    const newEdge = {
                        cursor: (commentEdges.length - 1).toString(),
                        node: cacheContentDeepCopy,
                        __typename: 'CommentEdge'
                    };
                    const insertAfterIndex = commentEdges.length - 1;
                    // Put the new reply in the array
                    commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                }
                (0, $fEmGS.writeQueryInterop)({
                    query: commentsSectionQuery,
                    variables: {
                        contentId: pageId,
                        offset: '',
                        first: (0, $2i3To.DEFAULT_LIMIT)
                    },
                    data: {
                        ...commentSectionCacheDataClone,
                        comments: {
                            ...commentSectionCacheDataClone.comments,
                            totalCount: commentEdges.length,
                            pageInfo: {
                                ...commentSectionCacheDataClone.comments?.pageInfo,
                                endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                hasNextPage: false
                            },
                            edges: commentEdges
                        }
                    }
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments section cache for ${actionType} - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$bab18f310e4f95e8 = (actionType, queryVariables, parentCommentId, isReactionsEnabled, commentId)=>(_cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, type: type } = queryVariables;
        try {
            const singleType = type && type.length >= 1 ? type[0] : undefined;
            const consistentQueryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: pageId,
                type: singleType
            });
            // Update the comments panel data
            const commentsPanelCacheResponse = (0, $l1uFv.readQueryInterop)({
                query: (0, $b1hSc.default),
                variables: consistentQueryVariables
            });
            if (commentsPanelCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsPanelParentComment = commentsPanelCacheResponse?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (commentsPanelParentComment) {
                    if (actionType === 'delete') {
                        // Remove the returned commentId from the cache and reset it
                        const idxToRemove = commentsPanelParentComment.replies.findIndex((reply)=>reply?.id === commentId);
                        if (idxToRemove !== -1) commentsPanelParentComment.replies.splice(idxToRemove, 1);
                    } else {
                        const mutationResult = result.data.createFooterComment;
                        // Add the new reply entry to the cache and reset it
                        commentsPanelParentComment.replies.push(mutationResult);
                    }
                    (0, $fEmGS.writeQueryInterop)({
                        query: (0, $b1hSc.default),
                        variables: consistentQueryVariables,
                        data: commentsPanelCacheResponse
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = (0, $l1uFv.readQueryInterop)({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                }
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsSectionCacheData = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = [
                    ...commentsSectionCacheData?.comments?.edges || []
                ];
                const parentCommentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === parentCommentId);
                if (parentCommentIdx !== -1) {
                    if (actionType === 'delete') {
                        // Find the last index of the comment to delete
                        const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                        if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                    } else {
                        const mutationResult = {
                            ...result.data.createFooterComment
                        };
                        // As far as I can tell, this is always called w/o reactions enabled
                        // This maps the mutation result we get to the cache object that's expected by the comments section query
                        const cacheCommentObject = {
                            id: mutationResult.id,
                            ancestors: [
                                {
                                    id: mutationResult.parentId,
                                    __typename: 'Comment'
                                }
                            ],
                            author: {
                                ...mutationResult.author,
                                type: 'known'
                            },
                            body: mutationResult.body,
                            contentStatus: mutationResult.contentStatus,
                            links: {
                                webui: mutationResult.links.webui,
                                // @ts-ignore
                                __typename: mutationResult.links.__typename
                            },
                            location: mutationResult.location,
                            parentId: mutationResult.parentId,
                            permissions: mutationResult.permissions,
                            version: {
                                ...mutationResult.version,
                                friendlyWhen: 'Just now',
                                // TODO: Maybe replace this with the actual date
                                by: {
                                    type: 'user',
                                    displayName: '',
                                    accountId: '',
                                    __typename: 'User'
                                },
                                __typename: 'Version'
                            },
                            __typename: 'Comment'
                        };
                        // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                        const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                        const newEdge = {
                            cursor: (commentEdges.length - 1).toString(),
                            node: cacheContentDeepCopy,
                            __typename: 'CommentEdge'
                        };
                        // Find the last index of the thread to insert the reply
                        const threadLastCommentIdx = commentEdges?.findLastIndex((edge)=>edge?.node?.parentId === parentCommentId);
                        // If we can't find it, the parent has no replies
                        const insertAfterIndex = threadLastCommentIdx !== -1 ? threadLastCommentIdx : parentCommentIdx;
                        // Put the new reply in the array
                        commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                    }
                    (0, $fEmGS.writeQueryInterop)({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: pageId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...commentsSectionCacheData,
                            comments: {
                                ...commentsSectionCacheData.comments,
                                totalCount: commentEdges.length,
                                pageInfo: {
                                    ...commentsSectionCacheData.comments?.pageInfo,
                                    endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                    hasNextPage: false
                                },
                                edges: commentEdges
                            }
                        }
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating general comments cache for ${actionType} reply - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$aee61debd6ae89df = (commentId, newBody, pageId, isReactionsEnabled, _cache, sessionDisplayName)=>{
    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
    try {
        // Update the comments section data
        const commentsSectionCacheData = (0, $l1uFv.readQueryInterop)({
            query: commentsSectionQuery,
            variables: {
                contentId: pageId,
                offset: '',
                first: (0, $2i3To.DEFAULT_LIMIT)
            }
        });
        if (commentsSectionCacheData) {
            // grab the parent comment for the comments panel
            const commentEdges = [
                ...commentsSectionCacheData?.comments?.edges || []
            ];
            const commentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === commentId);
            if (commentIdx !== undefined && commentIdx !== null && commentIdx !== -1 && commentEdges[commentIdx]?.node?.body && commentEdges[commentIdx]?.node?.version?.number) {
                // Find the index to update. TS will throw an error even though we've already checked the index is valid
                // @ts-ignore
                commentEdges[commentIdx].node.body.value = newBody; // Update the body we keep in the footer cache
                // @ts-ignore
                commentEdges[commentIdx].node.version.number += 1; // This is required for the propagated footer version to also be editable
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(commentEdges[commentIdx].node, 'version.by.displayName', sessionDisplayName); // Update the display name to the user who edited the comment
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(commentEdges[commentIdx].node, 'version.when', new Date().toISOString()); // Update the version date to the date of the edit
            }
            (0, $fEmGS.writeQueryInterop)({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                },
                data: {
                    ...commentsSectionCacheData,
                    comments: {
                        ...commentsSectionCacheData.comments,
                        totalCount: commentEdges.length,
                        pageInfo: {
                            ...commentsSectionCacheData.comments?.pageInfo,
                            endCursor: Math.random().toString(),
                            // The cache won't update without this. Should be harmless, given hasNextPage is false, so we won't be loading more
                            hasNextPage: false
                        },
                        edges: commentEdges
                    }
                }
            });
        }
    } catch (err) {
        $80b47fa0b569ef69$var$logger.error`An Error occurred when updating cache for edit footer reply - ${err}`;
    }
};
const $80b47fa0b569ef69$export$c94bffbead878776 = ({ onSuccess: onSuccess, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, data: data, createAnalyticsEvent: createAnalyticsEvent, pageId: pageId, pageType: pageType, analyticsSource: analyticsSource, commentId: commentId, pageMode: pageMode, experienceTracker: experienceTracker, searchSessionId: searchSessionId, isFooterComment: isFooterComment })=>{
    onSuccess();
    if (editCommentQueryId) setCommentForEdit && setCommentForEdit('');
    const replyCommentInfo = data?.createFooterComment;
    // Find the reply button container and scroll to it if needed
    if (replyCommentInfo?.id && commentId && isFooterComment) {
        // First find the container
        const container = document.getElementById(`footer-comment-thread-${commentId}-container`);
        if (container) {
            // Set up observer to watch for the reply button in the container
            const observer = new MutationObserver((_mutations, obs)=>{
                const replyButtonContainer = container.querySelector('[data-testid="comments-panel-reply-comment-action"]');
                if (replyButtonContainer) {
                    obs.disconnect();
                    // Check if the element is not in viewport, accounting for 75px add comment prompt at bottom
                    const rect = replyButtonContainer.getBoundingClientRect();
                    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                    const isInViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= viewportHeight - 75 && // Account for add comment prompt
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                    if (!isInViewport) replyButtonContainer.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            });
            observer.observe(container, {
                childList: true,
                subtree: true
            });
            // Cleanup observer after 2 seconds to prevent memory leaks
            setTimeout(()=>{
                observer.disconnect();
            }, 2000);
        }
    }
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'created',
            actionSubject: 'comment',
            actionSubjectId: replyCommentInfo?.id,
            // The newly created comment ID
            objectType: pageType,
            objectId: pageId,
            source: analyticsSource,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                commentType: (0, $en1dX.CommentType).GENERAL,
                source: analyticsSource,
                pageType: pageType,
                isReply: true,
                pageMode: pageMode,
                isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                editor: 'v2',
                searchSessionId: searchSessionId,
                navdexPointType: (0, $56QzY.END),
                parentCommentId: commentId ?? null // analytics event schema type expects string or null
            }
        }
    }).fire();
    experienceTracker.succeed({
        name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE)
    });
};
module.exports["updateApolloCacheParentCallback"] = $80b47fa0b569ef69$export$a02bedef5e94d20c;
module.exports["updateApolloCacheReplyCallback"] = $80b47fa0b569ef69$export$bab18f310e4f95e8;
module.exports["updateFooterApolloCacheOnEdit"] = $80b47fa0b569ef69$export$aee61debd6ae89df;
module.exports["handleCreateReplySuccess"] = $80b47fa0b569ef69$export$c94bffbead878776;

});

parcelRegister("lFkRf", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $CP0sd = parcelRequire("CP0sd");


var $FBfum = parcelRequire("FBfum");

const $ad3c53086a228972$var$parseError = (error)=>{
    const { message: message } = error;
    let errorMessage;
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from queries/mutations always have the same format:
   * GraphQL error: <GUID>:[ <EXCEPTION>:] <REASON>
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
    } else errorMessage = message;
    const parsedError = {
        message: errorMessage
    };
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
    return parsedError;
};
const $ad3c53086a228972$export$a67f8c1198066537 = (error)=>{
    if ((0, $6fil2.containsNetworkError)(error)) return (0, $FBfum.i18n).networkError;
    const parsedError = $ad3c53086a228972$var$parseError(error);
    switch(parsedError.message){
        case (0, $CP0sd.ObjectCommentsError).VIEW_NOT_PERMITTED:
            return (0, $FBfum.i18n).viewNotPermitted;
        case (0, $CP0sd.ObjectCommentsError).NO_CREATE_PERMS:
            return (0, $FBfum.i18n).createNotPermitted;
        default:
            return (0, $FBfum.i18n).unexpectedError;
    }
};
const $ad3c53086a228972$export$c4a6c57f5b95da54 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).viewNotPermitted.id;
const $ad3c53086a228972$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).networkError.id;
const $ad3c53086a228972$export$aa951ce6b8761d86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).createNotPermitted.id;
module.exports["getTranslatedError"] = $ad3c53086a228972$export$a67f8c1198066537;
module.exports["isViewNotPermittedError"] = $ad3c53086a228972$export$c4a6c57f5b95da54;
module.exports["isNetworkError"] = $ad3c53086a228972$export$476aa014e2fd89d5;
module.exports["isCreateNotPermittedError"] = $ad3c53086a228972$export$aa951ce6b8761d86;

});

parcelRegister("CP0sd", function(module, exports) {
var $a1a7014f0329fe2c$export$37d35ac9f5bc0a58 = /*#__PURE__*/ function(ObjectCommentsError) {
    // view
    ObjectCommentsError["VIEW_NOT_PERMITTED"] = "403 Forbidden, current user not permitted to use Confluence.";
    // Create
    ObjectCommentsError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    return ObjectCommentsError;
}({});
module.exports["ObjectCommentsError"] = $a1a7014f0329fe2c$export$37d35ac9f5bc0a58;

});

parcelRegister("FBfum", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $93264f9de833f05e$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    unableToLoadCommentsTitle: {
        id: "comments-util.error.unable.to.load.comments",
        defaultMessage: "Unable to load comments"
    },
    networkError: {
        id: "comments-util.error.network",
        defaultMessage: "A network error was encountered when loading comments. Please try refreshing the page."
    },
    viewNotPermitted: {
        id: "comments-util.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view comments on this page. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "comments-util.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unexpectedError: {
        id: "comments-util.error.unexpected",
        defaultMessage: "Something went wrong when loading comments on this page."
    }
});
module.exports["i18n"] = $93264f9de833f05e$export$a7357cdd1f0b0168;

});

parcelRegister("3cu4A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $8i27m = parcelRequire("8i27m");


var $6eYRP = parcelRequire("6eYRP");

const $ba24a8cc7b954968$export$3577ba943a5537ec = 8;
// Binary search to find the transition point between inline/general comments
const $ba24a8cc7b954968$var$findTransitionIndex = (commentsList)=>{
    if (!commentsList.length) return 0;
    let low = 0;
    let high = commentsList.length - 1;
    // If all comments are of the same type, return 0
    const firstType = commentsList[0].type;
    const lastType = commentsList[high].type;
    if (firstType === lastType) return 0;
    while(low < high){
        const mid = Math.floor((low + high) / 2);
        if (commentsList[mid].type === (0, $8i27m.CommentType).INLINE) low = mid + 1;
        else high = mid;
    }
    return low;
};
const $ba24a8cc7b954968$export$69f1296a446ecce6 = /*#__PURE__*/ (0, $42omo.memo)(({ commentsList: commentsList, passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const batchCount = Math.ceil(commentsList.length / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const batches = (0, $42omo.useMemo)(()=>new Array(batchCount).fill(0), [
        batchCount
    ]);
    const [batch, setBatch] = (0, $42omo.useState)(0);
    const onBatchRendered = (0, $42omo.useCallback)((batchIndex)=>{
        if (passThroughProps) {
            passThroughProps.onCommentBatchRendered && passThroughProps.onCommentBatchRendered();
            if (batches.length && batchIndex === batches.length - 1) passThroughProps.onLastThreadRendered && passThroughProps.onLastThreadRendered();
        }
        setBatch(batchIndex + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const globalTransitionIndex = (0, $42omo.useMemo)(()=>$ba24a8cc7b954968$var$findTransitionIndex(commentsList), [
        commentsList
    ]);
    const transitionBatchIndex = Math.floor(globalTransitionIndex / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const transitionIndexWithinBatch = globalTransitionIndex % $ba24a8cc7b954968$export$3577ba943a5537ec;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, batches.map((_, index)=>{
        const isTransitionBatch = index === transitionBatchIndex && globalTransitionIndex !== 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6eYRP.CommentBatch), {
            key: `${contentId}-batch-${index}`,
            commentsList: commentsList,
            canRenderBatch: index <= batch,
            batchIndex: index,
            passThroughProps: passThroughProps,
            Component: Component,
            getElementsToBatch: getElementsToBatch,
            onBatchRendered: onBatchRendered,
            transitionIndexWithinBatch: isTransitionBatch ? transitionIndexWithinBatch : undefined
        });
    }));
});
module.exports["BATCH_SIZE"] = $ba24a8cc7b954968$export$3577ba943a5537ec;
module.exports["CommentBatchList"] = $ba24a8cc7b954968$export$69f1296a446ecce6;

});

parcelRegister("6eYRP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $9hlns = parcelRequire("9hlns");


var $3cu4A = parcelRequire("3cu4A");

const $4d6840eb7d00cd1a$var$spinnerContainerStyles = (0, $ecnYn.xcss)({
    margin: 'auto',
    position: 'sticky',
    bottom: '1px'
});
const $4d6840eb7d00cd1a$export$f7f1256703956fe = 100;
const $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe = /*#__PURE__*/ (0, $42omo.memo)(({ passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch, commentsList: commentsList, canRenderBatch: canRenderBatch, batchIndex: batchIndex, onBatchRendered: onBatchRendered, transitionIndexWithinBatch: transitionIndexWithinBatch })=>{
    const [showSpinner, setShowSpinner] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (canRenderBatch) {
            setShowSpinner(true);
            setTimeout(()=>{
                onBatchRendered(batchIndex);
                setShowSpinner(false);
            }, $4d6840eb7d00cd1a$export$f7f1256703956fe);
        }
    }, [
        canRenderBatch,
        batchIndex,
        onBatchRendered
    ]);
    if (!canRenderBatch) return null;
    const batchOffset = batchIndex * (0, $3cu4A.BATCH_SIZE);
    const batchedList = commentsList.slice(batchOffset, batchOffset + (0, $3cu4A.BATCH_SIZE));
    const elements = getElementsToBatch(batchedList, passThroughProps, Component, transitionIndexWithinBatch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, elements, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4d6840eb7d00cd1a$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: "comment-batch",
        size: "medium"
    })) : null);
});
module.exports["CommentBatch"] = $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe;

});

parcelRegister("a6t12", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $8j9VY = parcelRequire("8j9VY");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("5XsiK");
var $lfSOe = parcelRequire("lfSOe");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $9wGTI = parcelRequire("9wGTI");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $aXWIB.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { position: t1, userId: userId, isAnonymous: t2, canViewProfile: t3, children: children, trigger: t4, fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel } = t0;
    const position = t1 === undefined ? "bottom-start" : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const canViewProfile = t3 === undefined ? true : t3;
    const trigger = t4 === undefined ? "hover" : t4;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            type: "LANDING"
        };
        $[0] = t5;
    } else t5 = $[0];
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)(t5);
    let t6;
    if ($[1] !== orgId) {
        t6 = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || "", {
                type: "USER",
                payload: {
                    userId: clickedUserId
                }
            });
        $[1] = orgId;
        $[2] = t6;
    } else t6 = $[2];
    const getReportingLinesUserProfile = t6;
    const t7 = userId || "";
    let t8;
    if ($[3] !== t7) {
        t8 = {
            type: "USER",
            payload: {
                userId: t7
            }
        };
        $[3] = t7;
        $[4] = t8;
    } else t8 = $[4];
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)(t8);
    let t9;
    if ($[5] !== reportingLines) {
        t9 = (0, $lfSOe.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
        $[5] = reportingLines;
        $[6] = t9;
    } else t9 = $[6];
    const reportingLinesProfileUrl = t9;
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    let t10;
    if ($[7] !== push || $[8] !== userId || $[9] !== userProfile) {
        t10 = (0, $lfSOe.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        });
        $[7] = push;
        $[8] = userId;
        $[9] = userProfile;
        $[10] = t10;
    } else t10 = $[10];
    const viewProfileAction = t10;
    let t11;
    if ($[11] !== followedUsers || $[12] !== getToggleFollowUser || $[13] !== loggedInUserId || $[14] !== renderFeedFollow || $[15] !== userId) {
        t11 = $3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        });
        $[11] = followedUsers;
        $[12] = getToggleFollowUser;
        $[13] = loggedInUserId;
        $[14] = renderFeedFollow;
        $[15] = userId;
        $[16] = t11;
    } else t11 = $[16];
    const followUserAction = t11;
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) {
        let t12;
        if ($[17] !== children) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[17] = children;
            $[18] = t12;
        } else t12 = $[18];
        return t12;
    }
    let t12;
    if ($[19] !== createAnalyticsEvent || $[20] !== getReportingLinesUserProfile || $[21] !== push) {
        t12 = (clickedUserId_0)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "profileCardWrapper",
                    action: "clicked",
                    actionSubject: "viewProfile",
                    actionSubjectId: "userProfileCard",
                    attributes: {
                        clickTarget: "userReportingLine"
                    }
                }
            }).fire();
            if ((0, $lfSOe.isTeamsAppEnabled)()) {
                getReportingLinesUserProfile(clickedUserId_0).onNavigate();
                return false;
            }
            if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, "", (0, $jlIaF.CONTEXT_PATH)), "_blank", "noreferrer");
            else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, $3d0f3ea3171aff68$var$_temp);
        };
        $[19] = createAnalyticsEvent;
        $[20] = getReportingLinesUserProfile;
        $[21] = push;
        $[22] = t12;
    } else t12 = $[22];
    const reportingLinesClickCallback = t12;
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== ariaLabel || $[25] !== children || $[26] !== cloudId || $[27] !== disabledAriaAttributes || $[28] !== featureFlags || $[29] !== feedConfigError || $[30] !== followUserAction || $[31] !== fullName || $[32] !== isVisible || $[33] !== loggedInUserId || $[34] !== mutationError || $[35] !== offset || $[36] !== onVisibilityChange || $[37] !== position || $[38] !== reportingLinesClickCallback || $[39] !== reportingLinesProfileUrl || $[40] !== trigger || $[41] !== userId || $[42] !== viewProfileAction) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t13
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
                feedConfigError: feedConfigError,
                mutationError: mutationError,
                showErrorFlag: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
                cloudId: cloudId,
                userId: userId,
                resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
                position: position,
                trigger: trigger,
                actions: [
                    viewProfileAction,
                    followUserAction
                ],
                reportingLinesProfileUrl: reportingLinesProfileUrl,
                onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
                addFlag: (flag)=>flags.showFlag(flag),
                prepopulatedData: {
                    fullName: fullName
                },
                disabledAriaAttributes: disabledAriaAttributes,
                isVisible: (0, $9wGTI.fg)("fix_profilecard_trigger_isvisible") ? undefined : isVisible,
                onVisibilityChange: onVisibilityChange || ((changedIsVisible)=>{
                    setIsVisible(changedIsVisible);
                }),
                offset: offset,
                testId: "profileCardTrigger",
                viewingUserId: loggedInUserId,
                ...disabledAriaAttributes ? {} : {
                    ariaLabel: ariaLabel
                }
            }, children)));
        $[24] = ariaLabel;
        $[25] = children;
        $[26] = cloudId;
        $[27] = disabledAriaAttributes;
        $[28] = featureFlags;
        $[29] = feedConfigError;
        $[30] = followUserAction;
        $[31] = fullName;
        $[32] = isVisible;
        $[33] = loggedInUserId;
        $[34] = mutationError;
        $[35] = offset;
        $[36] = onVisibilityChange;
        $[37] = position;
        $[38] = reportingLinesClickCallback;
        $[39] = reportingLinesProfileUrl;
        $[40] = trigger;
        $[41] = userId;
        $[42] = viewProfileAction;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
};
function $3d0f3ea3171aff68$var$_temp() {}
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("5XsiK", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => (parcelRequire("lfSOe")).isTeamsAppEnabled);

var $lfSOe = parcelRequire("lfSOe");


});

parcelRegister("lfSOe", function(module, exports) {

var $hbEOA = parcelRequire("hbEOA");


var $bYUc2 = parcelRequire("bYUc2");

const $6739d59719e0930b$export$5921b2a93a401547 = ()=>{
    return (0, $hbEOA.isTeamsAppEnabled)({
        userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
        hostProduct: 'confluence'
    });
};
module.exports["isTeamsAppEnabled"] = $6739d59719e0930b$export$5921b2a93a401547;

});

parcelRegister("bYUc2", function(module, exports) {

var $1dnxO = parcelRequire("1dnxO");

const $e2bf374f654691d1$export$bd6b49f42ca8817b = ()=>{
    try {
        return (0, $1dnxO.getIsNav4Enabled)();
    } catch  {
        return false;
    }
};
module.exports["getIsNav4EnabledSafe"] = $e2bf374f654691d1$export$bd6b49f42ca8817b;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bYUc2 = parcelRequire("bYUc2");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $bYUc2 = parcelRequire("bYUc2");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("bedVD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");

const $e4e11ee9fe4a88c9$var$i18n = (0, $aXWIB.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error)
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ]
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = followedUsersRaw ? followedUsersRaw.map((id)=>id ?? null) : undefined;
    const getToggleFollowUser = (0, $42omo.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    const feedFollowData = {
        renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
        loading: queryLoading,
        getToggleFollowUser: getToggleFollowUser,
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        followedUsers: followedUsers
    };
    const feedFollowDataMemoized = (0, $42omo.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? feedFollowDataMemoized : feedFollowData;
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<6cb612d4cea5ce160c6eb286adf1c433>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<beab7c81a1cfd7a9e019c32e0155ce41>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("bumSD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $7c52C = parcelRequire("7c52C");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $2XqLN.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $7c52C.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $8zKPT = parcelRequire("8zKPT");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $8zKPT.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            }
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<a1c4b5acd8781bbc1c31568d38ca0327>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gj42z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $aXWIB = parcelRequire("aXWIB");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("3B9cR", function(module, exports) {

var $6kgLu = parcelRequire("6kgLu");

const $7d2c123586cab1f2$export$5fa1043645dd2c26 = (0, $6kgLu.default);
module.exports["InlineCommentQuery"] = $7d2c123586cab1f2$export$5fa1043645dd2c26;

});

parcelRegister("6kgLu", function(module, exports) {
/**
 * @generated SignedSource<<26efd07c7b5420616063943f4d8cbff7>>
 * @relayHash 1565f9a21fb928625638bc549e846634
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 66870dba275f9b13105b9633c348af8de6c6550db6806aaa7794cf5e03af8e86
const $91432cb47dad508a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "annotationId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRef",
            "variableName": "annotationId"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "when"
    }, v18 = {
        "kind": "ScalarField",
        "name": "number"
    }, v19 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    },
                    v5 /*: any*/ 
                ]
            }
        ]
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InlineCommentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InlineCommentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v24 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1565f9a21fb928625638bc549e846634",
            "id": "66870dba275f9b13105b9633c348af8de6c6550db6806aaa7794cf5e03af8e86",
            "metadata": {},
            "name": "InlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentQuery($annotationId:String,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRef:$annotationId,pageId:$pageId,contentStatus:$contentStatus){nodes{replies{id,parentId,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,links{webui,editui},author{__typename,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},location{__typename,type},version{by{__typename,displayName},when,number},permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}},version{by{__typename,displayName},when,number},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,resolvedTime,resolvedUser}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$91432cb47dad508a$var$node.hash = "97a27177dfbb0afcc0c9bf12ba1b9268";
var $91432cb47dad508a$export$2e2bcd8739ae039 = $91432cb47dad508a$var$node;
module.exports["default"] = $91432cb47dad508a$export$2e2bcd8739ae039;

});

parcelRegister("1C8XP", function(module, exports) {

var $3cQo5 = parcelRequire("3cQo5");

const $087454af48047e63$export$c9407390b0cf740d = (0, $3cQo5.default);
module.exports["ActiveInlineCommentsQuery"] = $087454af48047e63$export$c9407390b0cf740d;

});

parcelRegister("3cQo5", function(module, exports) {
/**
 * @generated SignedSource<<aef8a0e9b6871e678deac4abd2786471>>
 * @relayHash 0c90169da883bac60f8fe8cfefab06a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4
const $487b4c2a573008bb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0c90169da883bac60f8fe8cfefab06a0",
            "id": "552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4",
            "metadata": {},
            "name": "ActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$487b4c2a573008bb$var$node.hash = "93367b15ee96494c20452626f5b23b5d";
var $487b4c2a573008bb$export$2e2bcd8739ae039 = $487b4c2a573008bb$var$node;
module.exports["default"] = $487b4c2a573008bb$export$2e2bcd8739ae039;

});

parcelRegister("isdzP", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fJlJm = parcelRequire("fJlJm");


var $hL41C = parcelRequire("hL41C");


var $9CnRS = parcelRequire("9CnRS");

const $e5083fb3da68bf8e$export$e80a9284539c1797 = (error)=>{
    const { message: message } = error;
    let errorMessage = '';
    const parsedError = {
        message: errorMessage,
        isAuthorized: false
    };
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from mutations always have the same format:
   * GraphQL error: <GUID>: <EXCEPTION>: <REASON>
   * The GUID correlates to the microsId so it unfortunately doesn't do much for us
   * With this in mind, we want to extract the REASON as the message for translation
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
        // Extract the traceId for highlight errors
        parsedError.errorId = (0, $fJlJm.getLogSafeErrorAttributes)(error).traceId;
    } else errorMessage = message;
    parsedError.message = errorMessage;
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) {
        parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
        parsedError.isAuthorized = graphQLErrors?.[0]?.extensions?.data?.authorized || false;
    }
    return parsedError;
};
const $e5083fb3da68bf8e$export$a67f8c1198066537 = (message, id = '')=>{
    let i18nError;
    // COMMENTS-4199 - This is our own handling of the error thrown by the editor/renderer that we wrap
    //				   in our own message, so to preserve the original error we just check for our message
    if (message.includes('Unable to apply annotation to document')) {
        if (message.includes('Failed to create annotation')) i18nError = (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation;
        else i18nError = (0, $9CnRS.i18n).unableToApplyAnnotation;
    } else if (message.startsWith('Network error: ')) i18nError = (0, $9CnRS.i18n).networkError;
    else switch(message){
        case (0, $hL41C.InlineCommentError).INVALID_SELECTION:
        case (0, $hL41C.InlineCommentError).FAILED_TO_INSERT_MARK:
            i18nError = (0, $9CnRS.i18n).invalidHighlight;
            break;
        case (0, $hL41C.InlineCommentError).STALE_SELECTION:
            i18nError = (0, $9CnRS.i18n).staleContent;
            break;
        case (0, $hL41C.InlineCommentError).NO_ANONYMOUS_ACCESS:
            i18nError = (0, $9CnRS.i18n).actionNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF:
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST:
            i18nError = (0, $9CnRS.i18n).noCommentsFoundForGivenMarkerRef;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_PERMS:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED_COMMENTS:
            i18nError = (0, $9CnRS.i18n).viewNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_UPDATE_PERMS.replace('%d', id ? id : ''):
            i18nError = (0, $9CnRS.i18n).editNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_OR_MODIFY_PERMS:
        case (0, $hL41C.InlineCommentError).NO_SPACE_PERMS:
            i18nError = (0, $9CnRS.i18n).viewOrModifyNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_DELETE_WITH_CHILDREN:
            i18nError = (0, $9CnRS.i18n).deleteWithRepliesNotAllowed;
            break;
        case (0, $hL41C.InlineCommentError).NO_CREATE_PERMS:
            i18nError = (0, $9CnRS.i18n).createNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).UPDATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).COMMENT_ALREADY_DELETED.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).CANNOT_RESOLVE_DELETED_COMMENT.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).ERROR_404:
            i18nError = (0, $9CnRS.i18n).commentAlreadyDeleted;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_DELETED_PARENT:
            i18nError = (0, $9CnRS.i18n).replyNotAllowedParentDeleted;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_MATCHES:
            i18nError = (0, $6mKj3.expValEquals)('confluence_fe_create_inline_use_curr_doc_version', 'isEnabled', true) ? (0, $9CnRS.i18n).cannotHighlightContent : (0, $9CnRS.i18n).contentHasBeenRemoved;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotReplyToResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_UPDATE_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotUpdateResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CONTENT_OUT_OF_DATE:
            i18nError = (0, $9CnRS.i18n).contentOutOfDate;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_CREATED_FROM:
        case (0, $hL41C.InlineCommentError).CREATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).PARENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).INCOMPATIBLE_PARENT_TYPE:
        case (0, $hL41C.InlineCommentError).DELETE_ERROR:
        default:
            i18nError = (0, $9CnRS.i18n).unexpectedError;
            break;
    }
    return i18nError;
};
const $e5083fb3da68bf8e$export$336db91bab9fb3ba = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).invalidHighlight.id;
const $e5083fb3da68bf8e$export$68de2e41a5e9d0c3 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unexpectedError.id;
const $e5083fb3da68bf8e$export$fb2e61e668e6b1d2 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unableToApplyAnnotation.id || translatedMessage.id === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation.id;
const $e5083fb3da68bf8e$export$81795bac145b8560 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).contentOutOfDate.id || translatedMessage.id === (0, $9CnRS.i18n).staleContent.id;
const $e5083fb3da68bf8e$export$b2e3f629cad072ef = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).commentAlreadyDeleted.id;
const $e5083fb3da68bf8e$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).networkError.id;
module.exports["parseError"] = $e5083fb3da68bf8e$export$e80a9284539c1797;
module.exports["getTranslatedError"] = $e5083fb3da68bf8e$export$a67f8c1198066537;
module.exports["isHighlightError"] = $e5083fb3da68bf8e$export$336db91bab9fb3ba;
module.exports["isUnexpectedError"] = $e5083fb3da68bf8e$export$68de2e41a5e9d0c3;
module.exports["isAnnotationError"] = $e5083fb3da68bf8e$export$fb2e61e668e6b1d2;
module.exports["isOutOfDateError"] = $e5083fb3da68bf8e$export$81795bac145b8560;
module.exports["isAlreadyDeletedError"] = $e5083fb3da68bf8e$export$b2e3f629cad072ef;
module.exports["isNetworkError"] = $e5083fb3da68bf8e$export$476aa014e2fd89d5;

});

parcelRegister("hL41C", function(module, exports) {
var $4bdefc881ecc3bb8$export$317614131ad59950 = /*#__PURE__*/ function(InlineCommentError) {
    InlineCommentError["INVALID_SELECTION"] = "Invalid text selection. Cannot create inline comments on macros (mentions, images, emojis, etc.)";
    InlineCommentError["FAILED_TO_INSERT_MARK"] = "Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex";
    InlineCommentError["INVALID_ARGUMENT_CREATED_FROM"] = "Invalid createdFrom, please specify if created from editor or renderer";
    InlineCommentError["STALE_SELECTION"] = "Selection was made against a stale version of the content";
    InlineCommentError["NO_ANONYMOUS_ACCESS"] = "Anonymous access is not permitted";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF"] = "No comments found for the given markerRef";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST"] = "No comments found for the given markerRefList";
    InlineCommentError["NO_VIEW_PERMS"] = "User doesn't have VIEW permission for this comment";
    InlineCommentError["NOT_AUTHORIZED"] = "403 Forbidden, current user not permitted to use Confluence.";
    InlineCommentError["NOT_AUTHORIZED_COMMENTS"] = "User does not have permission to access the comment(s)";
    // Create Reply
    InlineCommentError["CREATE_COMMENT_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    InlineCommentError["PARENT_NOT_FOUND"] = "Parent comment with id %d is not found. Please provide correct parent comment id.";
    InlineCommentError["INCOMPATIBLE_PARENT_TYPE"] = "Incompatible parent type. Please provide comment id.";
    InlineCommentError["CANNOT_REPLY_TO_DELETED_PARENT"] = "Cannot add reply to a deleted comment";
    InlineCommentError["CANNOT_REPLY_TO_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be replied";
    // Delete
    // This is the error message for a NotFoundException only
    InlineCommentError["DELETE_ERROR"] = "Exception occurred while deleting comment with id";
    InlineCommentError["NO_VIEW_OR_MODIFY_PERMS"] = "Parent page view is restricted";
    InlineCommentError["NO_SPACE_PERMS"] = "Space is restricted";
    InlineCommentError["NO_DELETE_WITH_CHILDREN"] = "Inline comment with child cannot be deleted.";
    InlineCommentError["COMMENT_ALREADY_DELETED"] = "Exception occurred while deleting comment with id %d";
    InlineCommentError["ERROR_404"] = "Received status 404";
    // Edit
    InlineCommentError["NO_UPDATE_PERMS"] = "Could not update Content of type  = class com.atlassian.confluence.pages.Comment with id %d";
    InlineCommentError["UPDATE_COMMENT_NOT_FOUND"] = "Could not find Comment for update with id CommentId{id=%d}";
    InlineCommentError["CANNOT_UPDATE_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be updated";
    // Create
    InlineCommentError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    InlineCommentError["INVALID_ARGUMENT_MATCHES"] = "Invalid arguments provided for matchIndex and/or numMatches";
    InlineCommentError["CONTENT_OUT_OF_DATE"] = "Published Version out of date. Please provide correct published version.";
    InlineCommentError["UNABLE_TO_APPLY_ANNOTATION"] = "Unable to apply annotation to document";
    // Resolve
    InlineCommentError["CANNOT_RESOLVE_DELETED_COMMENT"] = "%d must be existing and be an inline comment";
    return InlineCommentError;
}({});
module.exports["InlineCommentError"] = $4bdefc881ecc3bb8$export$317614131ad59950;

});

parcelRegister("9CnRS", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    cannotHighlightContent: {
        id: "inline-comments-common.error.cannot.highlight.content",
        defaultMessage: "An error occurred when commenting on the highlighted content. The page may be outdated. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    commentAlreadyDeletedTitle: {
        id: "inline-comments-common.error.comment.already.deleted.title",
        defaultMessage: "Unable to delete comment"
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    resolveError: {
        id: "inline-comments-common.error.resolve.error",
        defaultMessage: "We failed to resolve your comment due to an error. Try resolving the comment again."
    },
    resolveErrorTitle: {
        id: "inline-comments-common.error.resolve.error.title",
        defaultMessage: "Failed to resolve comment"
    },
    deleteError: {
        id: "inline-comments-common.error.delete.error",
        defaultMessage: "We failed to delete your comment due to an error. Try deleting the comment again."
    },
    deleteErrorTitle: {
        id: "inline-comments-common.error.delete.error.title",
        defaultMessage: "Failed to delete comment"
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    deletedCommentActionLabel: {
        id: "inline-comments-common.deleted.comment.action.label",
        defaultMessage: "This comment has been deleted"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("8QQGs", function(module, exports) {
"use strict";
var $671c0bfbaf864118$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $671c0bfbaf864118$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $671c0bfbaf864118$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $671c0bfbaf864118$var$catchError;
var $671c0bfbaf864118$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $671c0bfbaf864118$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $671c0bfbaf864118$var$CatchSubscriber = function(_super) {
    $671c0bfbaf864118$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($dZ9AU.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("2mnXV", function(module, exports) {
"use strict";
var $1b8039eb254298fd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $1b8039eb254298fd$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $1b8039eb254298fd$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $1b8039eb254298fd$var$distinctUntilChanged;
var $1b8039eb254298fd$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1b8039eb254298fd$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1b8039eb254298fd$var$DistinctUntilChangedSubscriber = function(_super) {
    $1b8039eb254298fd$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3FcLR.tryCatch(this.keySelector)(value);
            if (key === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3FcLR.tryCatch(this.compare)(this.key, key);
            if (result === $6LPWz.errorObject) return this.destination.error($6LPWz.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($axeml.Subscriber);

});

parcelRegister("3VDUL", function(module, exports) {
"use strict";
var $2dc5a83127dcb05a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $2dc5a83127dcb05a$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $2dc5a83127dcb05a$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $2dc5a83127dcb05a$var$skipWhile;
var $2dc5a83127dcb05a$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2dc5a83127dcb05a$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2dc5a83127dcb05a$var$SkipWhileSubscriber = function(_super) {
    $2dc5a83127dcb05a$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($axeml.Subscriber);

});

parcelRegister("j8M4E", function(module, exports) {
"use strict";
var $def40e2be1e8c847$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iwB6M = parcelRequire("iwB6M");


var $dZ9AU = parcelRequire("dZ9AU");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $def40e2be1e8c847$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $def40e2be1e8c847$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $def40e2be1e8c847$var$switchMap;
var $def40e2be1e8c847$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $def40e2be1e8c847$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $def40e2be1e8c847$var$SwitchMapSubscriber = function(_super) {
    $def40e2be1e8c847$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $dZ9AU.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($iwB6M.OuterSubscriber);

});

parcelRegister("i3vZV", function(module, exports) {
"use strict";
var $d25153e5d88b6a52$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

function $d25153e5d88b6a52$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $d25153e5d88b6a52$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $d25153e5d88b6a52$var$timeInterval;
var $d25153e5d88b6a52$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $d25153e5d88b6a52$var$TimeInterval;
var $d25153e5d88b6a52$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d25153e5d88b6a52$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d25153e5d88b6a52$var$TimeIntervalSubscriber = function(_super) {
    $d25153e5d88b6a52$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $d25153e5d88b6a52$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($axeml.Subscriber);

});

parcelRegister("ePuNq", function(module, exports) {
"use strict";
var $acbdb7992e24bbb8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3u6GG = parcelRequire("3u6GG");


var $kVeeY = parcelRequire("kVeeY");


var $axeml = parcelRequire("axeml");


var $6GdLZ = parcelRequire("6GdLZ");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $acbdb7992e24bbb8$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    var absoluteTimeout = $kVeeY.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $acbdb7992e24bbb8$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $6GdLZ.TimeoutError()));
    };
}
module.exports.timeout = $acbdb7992e24bbb8$var$timeout;
var $acbdb7992e24bbb8$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $acbdb7992e24bbb8$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $acbdb7992e24bbb8$var$TimeoutSubscriber = function(_super) {
    $acbdb7992e24bbb8$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($axeml.Subscriber);

});

parcelRegister("6GdLZ", function(module, exports) {
"use strict";
var $4dd15960f755eae6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $4dd15960f755eae6$var$TimeoutError = function(_super) {
    $4dd15960f755eae6$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $4dd15960f755eae6$var$TimeoutError;

});

parcelRegister("5h38X", function(module, exports) {
"use strict";
var $3d70fa8830a46307$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");


var $bGuMq = parcelRequire("bGuMq");

/**
 * @class BehaviorSubject<T>
 */ var $3d70fa8830a46307$var$BehaviorSubject = function(_super) {
    $3d70fa8830a46307$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($augeV.Subject);
module.exports.BehaviorSubject = $3d70fa8830a46307$var$BehaviorSubject;

});

parcelRegister("cZRYC", function(module, exports) {

var $21K7m = parcelRequire("21K7m");


var $cD1qu = parcelRequire("cD1qu");

const $360cac0569dadbce$export$24cbf19a725de615 = ({ id: id, threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(true);
        id && setHoveredCommentId(id);
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('sethoveredannotation', threadKey);
        else eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, {
            annotationId: threadKey
        });
    }
};
const $360cac0569dadbce$export$8ce16d4c9a8b2b8a = ({ threadKey: threadKey, setIsThreadHovered: setIsThreadHovered, setHoveredCommentId: setHoveredCommentId, pageMode: pageMode, eventEmitter: eventEmitter })=>{
    if (threadKey) {
        setIsThreadHovered(false);
        setHoveredCommentId(undefined);
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) eventEmitter?.emit('removehoveredannotation', threadKey);
        else eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, {
            annotationId: threadKey
        });
    }
};
module.exports["handleCommentThreadMouseEnter"] = $360cac0569dadbce$export$24cbf19a725de615;
module.exports["handleCommentThreadMouseLeave"] = $360cac0569dadbce$export$8ce16d4c9a8b2b8a;

});

parcelRegister("i8TeS", function(module, exports) {
/* BaseCommentThread.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $8jHAi = parcelRequire("8jHAi");


var $8i27m = parcelRequire("8i27m");


var $cAdj8 = parcelRequire("cAdj8");


var $3ejfs = parcelRequire("3ejfs");


var $6faGq = parcelRequire("6faGq");


var $3iaSn = parcelRequire("3iaSn");


var $3mVfX = parcelRequire("3mVfX");


var $fHAwL = parcelRequire("fHAwL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $cZRYC = parcelRequire("cZRYC");


var $ibqdE = parcelRequire("ibqdE");

const $74b51dc92462c104$var$styles = {
    threadBoxStyles: "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _kqswh2mm _19bvpxbi _u5f3pxbi _ca0qpxbi _n3tdpxbi _1e0c1txw _2lx21bp4",
    selectedThreadStyles: "_bfhkl4ek",
    commentTypeSeperatorStyle: "_zulp1b66 _x3doia51 _ca0q1ejb _u5f31ejb _n3tdutpp _19bvpxbi",
    commentBodyBoxStyles: "_qtt8glyw _kqswh2mm"
};
const $74b51dc92462c104$var$i18n = (0, $aXWIB.defineMessages)({
    commentTypeSeperatorText: {
        id: "comments-common.comment.thread.type-seperator",
        defaultMessage: "General comments"
    },
    threadContentAriaLabelWithName: {
        // COMMENTS-5979: ObjectCommentThread doesn't have timestamp, but it probably should
        id: "comments-common.thread.content.aria-label.with-name",
        defaultMessage: "{name}\u2019s comment thread, {timestamp}"
    }
});
const $74b51dc92462c104$var$noop = ()=>{}; // This component renders the parent comment and its replies.
const $74b51dc92462c104$export$a9ce751de1bf208f = ({ commentThreadRef: commentThreadRef, commentComponent: commentComponent, commentRepliesComponent: commentRepliesComponent, parentComment: parentComment, eventEmitter: eventEmitter, pageMode: pageMode, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator, canAddComments: canAddComments, handleCommentThreadClick: handleCommentThreadClick, handleCommentThreadMouseDown: onCommentThreadMouseDown, testIdPrefix: testIdPrefix, isEditorExpanded: isEditorExpanded, forceShowRepliesSection: forceShowRepliesSection = false })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { currentlySelectedThreadKey: currentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelState)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const threadKey = parentComment.type === (0, $8i27m.CommentType).INLINE ? parentComment.location.inlineMarkerRef ?? '' : parentComment.id;
    const [isThreadHovered, setIsThreadHovered] = (0, $42omo.useState)(false);
    const [isThreadPressed, setIsThreadPressed] = (0, $42omo.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $42omo.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(false);
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey;
    (0, $42omo.useEffect)(()=>{
        const parentIdOfSelectedReply = parentComment?.replies?.find((reply)=>reply.id === currentlySelectedThreadKey);
        if (isCurrentSelectedComment || parentIdOfSelectedReply) setIsThreadPressed(true);
        else setIsThreadPressed(false);
    }, [
        currentlySelectedThreadKey,
        isCurrentSelectedComment,
        parentComment?.replies
    ]);
    const handleCommentThreadMouseDown = (0, $42omo.useCallback)(()=>{
        onCommentThreadMouseDown?.(); /**
                                   * Limiting executions of this function because updating isThreadPressed
                                   * rerenders every component in this tree. Most notably, a user clicking into
                                   * the reply comment editor will call this function every time (and really any sibling component).
                                   * 1. isThreadPressed is only used as a style variable alongside isCurrentSelectedComment
                                   * 2. if clicking doesn't change threadKey then currentlySelectedThreadKey never changes either
                                   * which are the two variables isCurrentSelectedComment compares. We should only call this function
                                   * if threadKey has changed.
                                   */ 
        if (!isCurrentSelectedComment) setIsThreadPressed(true);
    }, [
        onCommentThreadMouseDown,
        isCurrentSelectedComment
    ]);
    const handleCommentThreadHoverProps = (0, $42omo.useMemo)(()=>({
            threadKey: threadKey,
            setIsThreadHovered: setIsThreadHovered,
            setHoveredCommentId: setHoveredCommentId,
            pageMode: pageMode,
            eventEmitter: eventEmitter
        }), [
        threadKey,
        setIsThreadHovered,
        setHoveredCommentId,
        pageMode,
        eventEmitter
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((id)=>{
        (0, $cZRYC.handleCommentThreadMouseEnter)({
            ...handleCommentThreadHoverProps,
            id: id
        });
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        (0, $cZRYC.handleCommentThreadMouseLeave)(handleCommentThreadHoverProps);
    }, [
        handleCommentThreadHoverProps
    ]);
    const handleFocus = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        setCommentIsFocused(true);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        // Only clear focus if we're not focusing a child element
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(false);
    }, [
        setCommentIsFocused
    ]);
    const resolveProperties = parentComment.location?.inlineResolveProperties || parentComment.location?.commentResolveProperties || undefined;
    const commentStatus = (0, $3iaSn.useGetCommentStatus)({
        resolveProperties: resolveProperties
    });
    const timestamp = (0, $6faGq.formatTimestampForAriaLabel)({
        intl: intl,
        dateString: parentComment.createdAtNonLocalized,
        commentStatus: commentStatus,
        resolveProperties: resolveProperties
    });
    const testIdPrefixWithDelimiter = testIdPrefix ? `${testIdPrefix}-` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderCommentTypeSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $74b51dc92462c104$var$styles.commentTypeSeperatorStyle,
        as: "li",
        testId: "comment-section-separator",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        testId: "general-comment-page-icon",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: commentThreadRef,
        id: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        testId: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        xcss: (0, $1Whri.cx)($74b51dc92462c104$var$styles.threadBoxStyles, (isCurrentSelectedComment || isThreadPressed) && $74b51dc92462c104$var$styles.selectedThreadStyles),
        "data-selected-comment-thread": isCurrentSelectedComment && parentComment.location?.inlineMarkerRef ? parentComment.location.inlineMarkerRef : undefined,
        onClick: handleCommentThreadClick,
        onMouseDown: handleCommentThreadMouseDown,
        onMouseUp: ()=>setIsThreadPressed(false),
        onFocus: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleFocus,
        onBlur: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleBlur,
        onKeyDown: ()=>{},
        tabIndex: 0,
        "aria-label": formatMessage($74b51dc92462c104$var$i18n.threadContentAriaLabelWithName, {
            name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
            timestamp: timestamp
        }),
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            role: 'button'
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `${testIdPrefixWithDelimiter}comment-thread-${parentComment.id}-parent`,
        xcss: $74b51dc92462c104$var$styles.commentBodyBoxStyles,
        onMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : ()=>handleMouseEnter(parentComment.id),
        onMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleMouseLeave
    }, commentComponent({
        comment: parentComment,
        pageInfo: pageInfo,
        pageMode: pageMode,
        isUnread: unreadCommentIDSet.has(parentComment.id),
        isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === parentComment.id || commentIsFocused && (0, $9wGTI.fg)('confluence_comments_hover_state_on_focused_comment'),
        threadKey: threadKey,
        hideBranchingStyle: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? parentComment.replies.length === 0 && !isEditorExpanded : (!parentComment.isOpen || !canAddComments) && parentComment.replies.length === 0,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered
    })), ((0, $ibqdE.getShouldShowRepliesSection)({
        replies: parentComment.replies,
        isEditorExpanded: isEditorExpanded
    }) || forceShowRepliesSection) && commentRepliesComponent({
        parentComment: parentComment,
        pageInfo: pageInfo,
        hoveredCommentId: hoveredCommentId ?? '',
        pageMode: pageMode,
        parentCommentId: parentComment.id,
        handleMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $74b51dc92462c104$var$noop : handleMouseEnter,
        handleMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $74b51dc92462c104$var$noop : handleMouseLeave,
        canAddComments: canAddComments,
        isEditorExpanded: isEditorExpanded
    })));
};
module.exports["BaseCommentThread"] = $74b51dc92462c104$export$a9ce751de1bf208f;

});

parcelRegister("7wP5b", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8i27m = parcelRequire("8i27m");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $189731c52bd04a36$var$createInlineMarkerMatcher = (parentLocation)=>(reply)=>{
        if (!reply) return false;
        const replyLocation = reply.location;
        return parentLocation.inlineMarkerRef === replyLocation.inlineMarkerRef;
    };
const $189731c52bd04a36$export$ea659f9ae26b6c6b = (parentComment, location)=>{
    const { hasNestedComments: legacyHasNestedComments } = (0, $8i27m.useCommentsDataState)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const hasNestedComments = (0, $6mKj3.expValEquals)('cc_comments_new_comments_data_manager', 'isEnabled', true) ? processedCommentsData.hasNestedComments : legacyHasNestedComments;
    const { replyToCommentId: replyToCommentId, location: commentLocation } = (0, $3mVfX.useCommentsPanelState)();
    return (0, $42omo.useMemo)(()=>{
        if (location === (0, $i6UMJ.LocationValue).FOOTER) {
            if (commentLocation === (0, $i6UMJ.LocationValue).FOOTER) return parentComment.id === replyToCommentId || // Editor management depends on reply nesting configuration:
            // - With nested replies: ObjectCommentNestableReplies handles the Editor
            // - Without nested replies: Open Editor when replyToComment query parameter
            //   matches a reply's ID
            !hasNestedComments && parentComment.replies.some(({ id: id })=>id === replyToCommentId);
            return false;
        }
        const inlineMarkerMatcher = $189731c52bd04a36$var$createInlineMarkerMatcher(parentComment.location);
        const parentReplies = parentComment.replies || [];
        const matchedReplies = parentReplies.filter(inlineMarkerMatcher);
        if (commentLocation === (0, $i6UMJ.LocationValue).PANEL) {
            const isReplyingToParent = replyToCommentId === parentComment.id;
            const isReplyingToChild = matchedReplies.some((reply)=>reply.id === replyToCommentId);
            const canExpandForChildReply = isReplyingToChild && (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true);
            return isReplyingToParent || canExpandForChildReply;
        }
        return false;
    }, [
        commentLocation,
        hasNestedComments,
        location,
        parentComment.id,
        parentComment.location,
        parentComment.replies,
        replyToCommentId
    ]);
};
module.exports["useIsEditorExpanded"] = $189731c52bd04a36$export$ea659f9ae26b6c6b;

});

parcelRegister("4Svbr", function(module, exports) {

var $1rgDT = parcelRequire("1rgDT");


var $8DH6r = parcelRequire("8DH6r");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7EEGh = parcelRequire("7EEGh");


var $inPa6 = parcelRequire("inPa6");


var $21K7m = parcelRequire("21K7m");


var $ccHMk = parcelRequire("ccHMk");


var $3ejfs = parcelRequire("3ejfs");


var $fHAwL = parcelRequire("fHAwL");


var $hXzKU = parcelRequire("hXzKU");


var $666Tc = parcelRequire("666Tc");


var $8i27m = parcelRequire("8i27m");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $NYiei = parcelRequire("NYiei");


var $ag51I = parcelRequire("ag51I");


var $cQCqE = parcelRequire("cQCqE");


var $cD1qu = parcelRequire("cD1qu");


var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6faGq = parcelRequire("6faGq");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $1Sjzs = parcelRequire("1Sjzs");


var $bQm3c = parcelRequire("bQm3c");


var $hl1Kw = parcelRequire("hl1Kw");


var $58Zuw = parcelRequire("58Zuw");


var $lLpk8 = parcelRequire("lLpk8");


var $ibqdE = parcelRequire("ibqdE");


var $8gR6k = parcelRequire("8gR6k");


var $1JuAZ = parcelRequire("1JuAZ");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $en1dX = parcelRequire("en1dX");


var $cZa7r = parcelRequire("cZa7r");


var $6hmtW = parcelRequire("6hmtW");


var $7qvmT = parcelRequire("7qvmT");


var $9tfnI = parcelRequire("9tfnI");


var $308Wd = parcelRequire("308Wd");

const $ff4f83a3b963012b$var$CommentRepliesCreateInlineReplyMutation = (0, $8DH6r.default);
const $ff4f83a3b963012b$var$CommentRepliesCreateGeneralReplyMutation = (0, $1rgDT.default);
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStyles = null;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStylesV2 = null;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStandaloneStyleOverrides = null;
const $ff4f83a3b963012b$var$commentThreadRepliesBoxStandaloneStyleOverridesV2 = null;
const $ff4f83a3b963012b$var$commentHandlesPaddingReplyBoxOverrides = null;
const $ff4f83a3b963012b$var$replyBoxStyles = null;
const $ff4f83a3b963012b$var$translucentStyle = null;
const $ff4f83a3b963012b$var$replyActionButtonStyles = {
    marginLeft: "var(--ds-space-150, 12px)",
    width: '62px',
    height: '24px',
    left: '-12px',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)"
};
const $ff4f83a3b963012b$var$customizedReplyButtonStyles = null; // This would cause the branching style to jump when clicking reply
const $ff4f83a3b963012b$var$commentEditorLegacyCustomStyles = {
    marginLeft: "var(--ds-space-300, 24px)",
    height: '16px',
    marginRight: "var(--ds-space-050, 4px)"
};
const $ff4f83a3b963012b$var$commentEditorCustomStyles = {
    marginLeft: "var(--ds-space-300, 24px)",
    height: '24px',
    // 24px = 16px offset + 8px of padding
    marginRight: "var(--ds-space-050, 4px)",
    paddingTop: "var(--ds-space-100, 8px)"
};
const $ff4f83a3b963012b$var$i18n = (0, $aXWIB.defineMessages)({
    replyAction: {
        id: "comments-panel.reply.action",
        defaultMessage: "Reply"
    },
    threadReplyButtonAriaLabelWithName: {
        id: "comments-panel.reply.button.aria-label.with-name",
        defaultMessage: "Reply to {name}\u2019s thread"
    },
    replyAriaLabel: {
        id: "comments-panel.reply.aria-label",
        defaultMessage: "Reply by {authorName}, {timestamp}"
    }
});
const $ff4f83a3b963012b$export$c38311e545a763a = ({ parentComment: parentComment, pageInfo: pageInfo, hoveredCommentId: hoveredCommentId, pageMode: pageMode, editCommentQueryId: editCommentQueryId, selectedAnnotation: selectedAnnotation, parentCommentId: parentCommentId, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, canAddComments: canAddComments, isStandaloneComment: isStandaloneComment, deleteStandaloneComment: deleteStandaloneComment, replyToComment: replyToComment, updateReactionsCacheFn: updateReactionsCacheFn, onRendered: onRendered, eventEmitter: eventEmitter, isEditorExpanded: isEditorExpanded = false, hasParentMaxHeight: hasParentMaxHeight = false, flags: flags, hideReactions: hideReactions = false, isCommentSummaryPopup: isCommentSummaryPopup = false })=>{
    const [createInlineReplyFn] = (0, $308Wd.useMutationInterop)($ff4f83a3b963012b$var$CommentRepliesCreateInlineReplyMutation);
    const [createGeneralReplyFn] = (0, $308Wd.useMutationInterop)($ff4f83a3b963012b$var$CommentRepliesCreateGeneralReplyMutation);
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const pageId = pageInfo?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    const { createInlineReplyInterop: createInlineReplyInterop } = (0, $cQCqE.useCreateInlineReplyMutation)({
        contentId: pageId
    });
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: pageId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addReplyToCommentThread: addReplyToCommentThread } = (0, $8i27m.useCommentsDataActions)();
    const [{ replyToCommentId: replyToCommentId, location: location, replyToCommentUser: replyToCommentUser }, { setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const isOffline = (0, $cZa7r.useAnnotationsIsOffline)();
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const allReplies = (0, $42omo.useMemo)(()=>parentComment.replies.filter((r)=>r !== null && parentComment.location.inlineMarkerRef === r.location.inlineMarkerRef), [
        parentComment.replies,
        parentComment.location
    ]);
    const numOfReplies = allReplies.length;
    const unreadReplyIds = (0, $42omo.useMemo)(()=>{
        return allReplies.filter((r)=>unreadCommentIDSet.has(r.id)).map((r)=>r.id);
    }, [
        allReplies,
        unreadCommentIDSet
    ]);
    const [visibleReplies, setVisibleReplies] = (0, $42omo.useState)(undefined);
    const [, setCommentForEdit] = (0, $42omo.useState)('');
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(null);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const commentType = parentComment.type;
    const inlineCommentLocation = parentComment?.location;
    const isDanglingComment = commentType === (0, $8i27m.CommentType).INLINE && inlineCommentLocation?.inlineResolveProperties?.isDangling && !isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux');
    const isParentCommentOpen = parentComment.isOpen;
    const isParentCommentResolvedOrDangling = !isParentCommentOpen || Boolean(isDanglingComment);
    const [currentReplyView, setReplyView] = (0, $42omo.useState)(// Determine the reply view by counting the total number of top-level replies to the parent comment.
    // This excludes any nested replies.
    (0, $7qvmT.getDefaultReplyView)((0, $ibqdE.getCommentReplies)(allReplies, parentCommentId).length, isParentCommentResolvedOrDangling, isStandaloneComment)); // User page permissions
    const operations = pageInfo?.operations || []; // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    const threadKey = commentType === (0, $8i27m.CommentType).INLINE ? (parentComment?.location).inlineMarkerRef || '' : parentCommentId; // When in summarizer popup, force empty actions on replies.
    // reopen won't be rendered for reply, but we are using it to render disabled reaction summary for replies
    let supportedTopLevelActions;
    if (isCommentSummaryPopup) supportedTopLevelActions = [];
    else if (isParentCommentOpen) supportedTopLevelActions = [
        'edit',
        'resolve',
        'delete'
    ];
    else supportedTopLevelActions = [
        'reopen'
    ];
     // When inside the summarizer popup, never expand the reply editor inline.
    let expandReplyEditor = false;
    if (isCommentSummaryPopup) expandReplyEditor = false;
    else if ((0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)) expandReplyEditor = isEditorExpanded;
    else expandReplyEditor = location === (0, $i6UMJ.LocationValue).PANEL && (replyToCommentId === parentCommentId || allReplies.some((reply)=>reply.id === replyToCommentId) && (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true));
     // Track if we've already fired the analytics event for current visibleReplies state
    const hasFiredForVisibleRepliesRef = (0, $42omo.useRef)('');
    const topLevelReplyToNestedChildrenMap = (0, $42omo.useMemo)(()=>{
        const topLevelReplyIds = new Set(allReplies.filter((reply)=>reply.parentId === parentCommentId).map((reply)=>reply.id)); // We need to get all replies that are nested to any depth under a top level reply.
        // This will help us render the GeneralReplyScroller component for each reply (mainly, we need to show user icons and the blue dot indicator)
        const topLevelReplyToNestedChildrenMapInternal = Array.from(topLevelReplyIds).reduce((acc, replyId)=>{
            acc[replyId] = [];
            return acc;
        }, {});
        const replyIdToReplyMap = allReplies.reduce((acc, reply)=>{
            acc[reply.id] = reply;
            return acc;
        }, {}); // Map all replies to their top level parent. Replies can be nested to any depth, so we need to traverse the tree.
        const filteredReplies = allReplies.filter((reply)=>!topLevelReplyIds.has(reply.id));
        for (const filteredReply of filteredReplies){
            let replyParentId = filteredReply.parentId; // Add a circuit breaker to prevent infinite loops if we get really wonky data
            let circuitBreaker = 0;
            while(replyParentId && circuitBreaker < 100 && !topLevelReplyIds.has(replyParentId)){
                replyParentId = replyIdToReplyMap[replyParentId]?.parentId;
                circuitBreaker++;
            }
            if (replyParentId && replyParentId in topLevelReplyToNestedChildrenMapInternal) // Second condition will always be true, unless we somehow hit circuit breaker above
            topLevelReplyToNestedChildrenMapInternal[replyParentId].push(filteredReply);
        }
        return topLevelReplyToNestedChildrenMapInternal;
    }, [
        allReplies,
        parentCommentId
    ]); // Determine the latest top level replies to show on the thread's initial load
    const latestReplies = (0, $42omo.useMemo)(()=>{
        const replies = [];
        const topLevelReplies = allReplies.filter((reply)=>reply.id in topLevelReplyToNestedChildrenMap); // Sort by createdAtNonLocalized value
        topLevelReplies.sort((a, b)=>{
            // Safely handle missing or invalid dates
            const dateA = (0, $6faGq.getValidDate)(a?.createdAtNonLocalized);
            const dateB = (0, $6faGq.getValidDate)(b?.createdAtNonLocalized);
            return dateA.getTime() - dateB.getTime();
        }); // Add the latest replies to the replies array
        for(let i = 0; i < (0, $7qvmT.getDefaultNumVisibleReplies)(numOfReplies, isStandaloneComment, isParentCommentResolvedOrDangling); i++)if (topLevelReplies.length > 0) {
            const reply = topLevelReplies.pop();
            if (reply) // Unshift to maintain reply chronological order
            replies.unshift(reply);
        }
        return replies;
    }, [
        allReplies,
        isStandaloneComment,
        numOfReplies,
        topLevelReplyToNestedChildrenMap,
        isParentCommentResolvedOrDangling
    ]); /*
                                                                                                                             * Determine the latest top level reply IDs and their nested reply IDs.
                                                                                                                             * This is passed to RepliesToggler to determine the hidden replies.
                                                                                                                             */ 
    const latestReplyIds = (0, $42omo.useMemo)(()=>{
        const latestAndNestedReplyIds = new Set();
        for (const reply of latestReplies){
            latestAndNestedReplyIds.add(reply.id);
            for (const nestedReply of topLevelReplyToNestedChildrenMap[reply.id])latestAndNestedReplyIds.add(nestedReply.id);
        }
        return latestAndNestedReplyIds;
    }, [
        latestReplies,
        topLevelReplyToNestedChildrenMap
    ]); // Wrapper for setVisibleReplies to match the expected type signature
    const setVisibleRepliesWrapper = (0, $42omo.useCallback)((value)=>{
        if (typeof value === 'function') setVisibleReplies((prev)=>{
            const prevArray = prev === undefined ? [] : prev;
            return value(prevArray);
        });
        else setVisibleReplies(value);
    }, []);
    (0, $8gR6k.useUpdateVisibleReplies)({
        allReplies: allReplies,
        isParentCommentOpen: isParentCommentOpen,
        currentReplyView: currentReplyView,
        latestReplies: latestReplies,
        parentCommentId: parentCommentId,
        setVisibleReplies: setVisibleRepliesWrapper
    }); // Track replies rendered state in experience tracker
    // Extract visibleReplies length to avoid complex expression in dependency array
    const visibleRepliesLength = visibleReplies?.length ?? -1;
    (0, $42omo.useEffect)(()=>{
        if (visibleReplies === undefined) return;
        const repliesRendered = currentReplyView === (0, $ibqdE.ViewReplyOptions).ALL && visibleReplies.length > 0; // Fire GASV3 event only when in ALL view with replies and we haven't fired for this state yet
        if (currentReplyView === (0, $ibqdE.ViewReplyOptions).ALL && visibleReplies.length > 0) {
            const stateKey = `${currentReplyView}-${visibleReplies.length}`; // Only fire if we haven't already fired for this exact state
            if (hasFiredForVisibleRepliesRef.current !== stateKey && numOfReplies !== 0) {
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'repliesRenderedStateChanged',
                        actionSubject: 'comment',
                        actionSubjectId: parentCommentId,
                        objectType: pageType,
                        objectId: pageId,
                        source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                        attributes: {
                            commentType: commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : 'inline',
                            repliesRendered: repliesRendered,
                            currentReplyView: currentReplyView,
                            numOfReplies: numOfReplies,
                            visibleRepliesCount: visibleReplies.length
                        }
                    }
                }).fire(); // Mark this state as fired
                hasFiredForVisibleRepliesRef.current = stateKey;
            }
        }
    }, [
        currentReplyView,
        visibleReplies,
        visibleRepliesLength,
        numOfReplies,
        commentType,
        experienceTracker,
        createAnalyticsEvent,
        parentCommentId,
        pageType,
        pageId,
        isStandaloneComment
    ]);
    const removeAnnotationHighlight = (0, $42omo.useCallback)(()=>{
        if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
        else eventEmitter?.emit('setselectedannotation', null);
    }, [
        pageMode,
        eventEmitter
    ]); // Track whether this CommentReplies is inside the comment summary popup.
    const isInsidePopupRef = (0, $42omo.useRef)(isCommentSummaryPopup);
    isInsidePopupRef.current = isCommentSummaryPopup; // Reset ref on component unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            hasFiredForVisibleRepliesRef.current = ''; // When inside the popup, skip resetting the panel's reply state on unmount.
            if (isInsidePopupRef.current) return;
             //TODO: Remove once https://product-fabric.atlassian.net/browse/COMMENTS-5857 is resolved
            const isDatabaseOrWhiteboard = contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType);
            if (!isDatabaseOrWhiteboard && (0, $6mKj3.expValEquals)('confluence_comment_reset_reply_options', 'isEnabled', true)) {
                setReplyToCommentId();
                removeAnnotationHighlight();
            }
        };
    }, [
        removeAnnotationHighlight,
        setReplyToCommentId,
        contentType
    ]);
    const handleReplyButtonClick = ()=>{
        // When inside the summarizer popup, delegate to the popup's reply handler
        // so it can explicitly close the popup and then open the reply editor in the panel.
        // Check for unsaved draft first so the user can choose to keep it.
        if (isCommentSummaryPopup && replyToComment) {
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    replyToComment(parentCommentId, parentComment);
                }
            });
            else replyToComment(parentCommentId, parentComment);
            return;
        } // Skip if there is no active inline comment annotation and currentlySelectedComment is not general
        const shouldRemoveAnnotationHighlight = commentType === (0, $8i27m.CommentType).GENERAL && selectedAnnotation.id;
        if (hasContentChanged) // if the content has changed and the user has clicked reply button to another comment thread, warn the user
        showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                setReplyToCommentId({
                    parentCommentId: parentCommentId,
                    location: (0, $i6UMJ.LocationValue).PANEL
                });
                shouldRemoveAnnotationHighlight && eventEmitter && removeAnnotationHighlight();
            }
        });
        else {
            setReplyToCommentId({
                parentCommentId: parentCommentId,
                location: (0, $i6UMJ.LocationValue).PANEL
            });
            shouldRemoveAnnotationHighlight && eventEmitter && removeAnnotationHighlight();
        }
    };
    const handleFocus = (0, $42omo.useCallback)((event, replyId)=>{
        event.stopPropagation();
        setCommentIsFocused(replyId);
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(null);
    }, [
        setCommentIsFocused
    ]);
    const renderReplyButton = ()=>{
        return isParentCommentOpen && canAddComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: $ff4f83a3b963012b$var$replyActionButtonStyles,
            testId: "comments-panel-reply-comment-action",
            onClick: handleReplyButtonClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            "data-cy": "comments-panel-reply-comment-action",
            appearance: "subtle",
            isDisabled: !isParentCommentOpen,
            analyticsContext: {
                attributes: {
                    name: 'replyToCommentButton',
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL
                }
            },
            interactionName: "start-reply-comment-action",
            ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
                'aria-label': formatMessage($ff4f83a3b963012b$var$i18n.threadReplyButtonAriaLabelWithName, {
                    name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
                })
            } : {},
            className: (0, $gMc0m.default)([
                "_1tv3glyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ff4f83a3b963012b$var$i18n.replyAction)));
    }; // Helper function to check if the reply editor is visible in the comments panel
    const isReplyEditorVisible = ()=>{
        // Use combined selector to find the specific reply editor for this comment thread
        const replyEditorContainer = document.querySelector(`[data-testid="comment-thread-${parentCommentId}-replies"] [data-testid="comments-panel-new-reply-container"]`);
        const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
        if (!replyEditorContainer || !panelContainer) return false;
        const replyEditorRect = replyEditorContainer.getBoundingClientRect();
        const panelRect = panelContainer.getBoundingClientRect(); // Check if the bottom of the reply editor container is visible within the panel
        return replyEditorRect.bottom <= panelRect.bottom;
    };
    const editorChangeHandler = ()=>{
        let experienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE);
        if (commentType === (0, $8i27m.CommentType).GENERAL) experienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE);
        experienceTracker.succeed({
            name: experienceName
        }); // Check if we need to scroll to show the reply editor
        // Only scroll if the reply editor is for this specific comment thread
        if (replyToCommentId === parentCommentId && !isReplyEditorVisible() && (0, $6mKj3.expValEquals)('confluence_comment_bring_replyeditor_intoview', 'isEnabled', true)) {
            // Use combined selector to find the specific reply editor for this comment thread
            const replyEditorContainer = document.querySelector(`[data-testid="comment-thread-${parentCommentId}-replies"] [data-testid="comments-panel-new-reply-container"]`);
            if (replyEditorContainer) replyEditorContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
        }
    }; // Wrap the createInlineReplyFn mutation with the interop logic that handles both the direct
    // Apollo mutation path and the new hook-based path for the Comments Data Manager
    const replyCreationInteropWrapper = (0, $42omo.useCallback)((options, onCacheUpdateError)=>createInlineReplyInterop({
            originalMutationFn: createInlineReplyFn,
            options: options,
            onCacheUpdateError: onCacheUpdateError
        }), [
        createInlineReplyInterop,
        createInlineReplyFn
    ]);
    const renderCommentEditor = ()=>{
        let customBranchingStyles = $ff4f83a3b963012b$var$commentEditorLegacyCustomStyles;
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // Accounts for extra padding in the author (was previously handled in a higher parent component)
        customBranchingStyles = $ff4f83a3b963012b$var$commentEditorCustomStyles;
        const editor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor), {
            pageId: pageId,
            pageType: pageType,
            content: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $7qvmT.getAdfForQuickReplyMention)(replyToCommentUser) : undefined,
            appearance: "chromeless",
            EditorComponent: (0, $7EEGh.ChromelessEditor),
            onSaveComment: (adf, onSuccess)=>{
                return (0, $7qvmT.onSaveReply)({
                    pageId: pageId,
                    parentCommentId: parentCommentId,
                    cloudId: cloudId,
                    adf: adf,
                    onSuccess: onSuccess,
                    pageMode: pageMode,
                    editCommentQueryId: editCommentQueryId,
                    setCommentForEdit: setCommentForEdit,
                    createAnalyticsEvent: createAnalyticsEvent,
                    pageType: pageType,
                    experienceTracker: experienceTracker,
                    createInlineReplyFn: replyCreationInteropWrapper,
                    createGeneralReplyFn: createGeneralReplyFn,
                    createObjectReplyFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? createObjectCommentMutationFn : undefined,
                    addCommentInCommentsDataManagerCacheFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? addCommentInCache : undefined,
                    setReplyToCommentId: setReplyToCommentId,
                    resetContentChanged: resetContentChanged,
                    setReplyView: setReplyView,
                    selectedAnnotation: selectedAnnotation,
                    addReplyToCommentThread: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addReplyToCommentThread,
                    threadKey: threadKey,
                    commentType: commentType,
                    searchSessionId: searchSessionId,
                    isReactionsEnabled: isReactionsEnabled,
                    analyticsSource: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    contentTypesCommentService: commentService
                });
            },
            onContentChange: onChange,
            onEditorReady: editorChangeHandler,
            commentMode: "reply",
            commentType: commentType === (0, $8i27m.CommentType).GENERAL ? 'page' : 'inline',
            spaceId: "",
            showCancelButton: true,
            useNewWarningModal: true,
            hideWatchCheckbox: true,
            expandEditor: expandReplyEditor,
            pageMode: "view",
            hasMediaUploadPermissions: hasMediaUploadPermissions,
            topLevelCommentId: parentComment.id,
            shouldWarnOnInternalNavigation: true,
            onCancelComment: ({ destroy: destroy = false } = {})=>{
                // when the transition happens the
                // other reply list item is clicked
                // and we need to reset ssetReplyToCommentId
                if (!destroy || replyToCommentId !== parentCommentId) setReplyToCommentId();
            },
            isCommentsPanel: true,
            wasRemovedByAnotherUser: parentComment.wasRemovedByAnotherUser,
            isOffline: isOffline
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
            mode: "view",
            isCommentsPanel: true,
            isFabricPage: true,
            "data-testid": "comments-panel-new-reply-container"
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? editor : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
            showDefaultStyles: true,
            customStyles: customBranchingStyles
        }, editor));
    };
    const renderUpdatedLowerAction = ()=>{
        if (expandReplyEditor) return renderCommentEditor();
        else if (!isStandaloneComment) return renderReplyButton();
        else return null;
    }; // Make reply containers tabbable for accessibility
    (0, $42omo.useEffect)(()=>{
        if (visibleReplies && visibleReplies.length > 0 && (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false)) // Find all reply containers and make them tabbable
        visibleReplies.forEach((reply)=>{
            const replyContainer = document.querySelector(`[data-testid="comment-thread-${parentComment.id}-replies-${reply.id}"]`);
            if (replyContainer instanceof HTMLElement) replyContainer.setAttribute('tabIndex', '0');
        });
    }, [
        visibleReplies,
        parentComment.id
    ]);
    const renderRepliesToggler = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58Zuw.RepliesToggler), {
            replies: allReplies,
            unreadReplyIds: unreadReplyIds,
            setReplyView: setReplyView,
            currentReplyView: currentReplyView,
            commentType: commentType,
            parentCommentId: parentCommentId,
            isParentOpen: isParentCommentOpen,
            canAddComments: canAddComments,
            latestReplyIds: latestReplyIds,
            isStandaloneComment: isStandaloneComment,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            analyticsSource: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
            expandReplyEditor: expandReplyEditor
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, numOfReplies > 0 && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && renderRepliesToggler(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `comment-thread-${parentComment.id}-replies`,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _19bvpxbi _u5f3u2gc",
            (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvutpp",
            parentComment.wasRemovedByAnotherUser && "_tzy41ssb",
            isStandaloneComment && "_u5f3pxbi",
            isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_u5f3utpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, numOfReplies > 0 && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && renderRepliesToggler(), visibleReplies && visibleReplies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `comment-thread-${parentComment.id}-reply-list`
    }, visibleReplies.map((reply, idx)=>{
        const isLastUnnestableReply = idx === visibleReplies.length - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: reply.id,
            "data-testid": `comment-thread-${parentComment.id}-replies-${reply.id}`,
            onMouseEnter: ()=>handleMouseEnter(reply.id),
            onMouseLeave: handleMouseLeave,
            onFocus: (event)=>handleFocus(event, reply.id),
            onBlur: handleBlur,
            "aria-label": formatMessage($ff4f83a3b963012b$var$i18n.replyAriaLabel, {
                authorName: reply.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
                timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                    intl: intl,
                    dateString: reply.createdAtNonLocalized,
                    isReply: true
                })
            }),
            className: (0, $gMc0m.default)([
                "_qtt8glyw _kqswh2mm _ca0qu2gc _n3tdu2gc _19bv1ejb",
                (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_ca0qze3t _19bvze3t _n3tdze3t"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9tfnI.Comment), {
            flags: flags,
            comment: reply,
            supportedTopLevelActions: supportedTopLevelActions,
            hideReactions: hideReactions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: unreadCommentIDSet.has(reply.id),
            isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === reply.id || commentIsFocused === reply.id && (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false),
            threadKey: threadKey,
            hideBranchingStyle: !canAddComments && isLastUnnestableReply || isStandaloneComment && isLastUnnestableReply || isLastUnnestableReply && !expandReplyEditor && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
            adjustForNestedReplies: commentType === (0, $8i27m.CommentType).GENERAL && reply.id in topLevelReplyToNestedChildrenMap && topLevelReplyToNestedChildrenMap[reply.id]?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            canAddComments: canAddComments,
            isParentCommentOpen: isParentCommentOpen,
            deleteStandaloneComment: deleteStandaloneComment,
            isStandaloneComment: isStandaloneComment,
            replyToComment: replyToComment,
            updateReactionsCacheFn: updateReactionsCacheFn,
            onRendered: onRendered,
            isLastUnnestableReply: isLastUnnestableReply,
            commentHandlesPadding: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            hasParentMaxHeight: hasParentMaxHeight
        }), commentType === (0, $8i27m.CommentType).GENERAL && reply.id in topLevelReplyToNestedChildrenMap && topLevelReplyToNestedChildrenMap[reply.id]?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1JuAZ.GeneralReplyScroller), {
            nestedReplies: topLevelReplyToNestedChildrenMap[reply.id],
            unreadReplyIds: unreadReplyIds,
            targetCommentIdForScroll: reply.id,
            isLastUnnestableReply: isLastUnnestableReply
        }));
    }))), (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLpk8.RepliesFooter), {
        replyView: currentReplyView,
        setReplyView: setReplyView,
        isEditorExpanded: !isCommentSummaryPopup && isEditorExpanded,
        isParentCommentOpen: isParentCommentOpen,
        isStandaloneComment: isStandaloneComment,
        handleReplyButtonClick: handleReplyButtonClick,
        numOfVisibleReplies: visibleReplies ? visibleReplies.length : 0,
        isOffline: isOffline,
        scrollToId: threadKey,
        location: (0, $i6UMJ.LocationValue).PANEL
    }, renderCommentEditor()) : renderUpdatedLowerAction()));
};
module.exports["CommentReplies"] = $ff4f83a3b963012b$export$c38311e545a763a;

});

parcelRegister("1rgDT", function(module, exports) {
/**
 * @generated SignedSource<<d553f972a98ad7b3065614acaf998bda>>
 * @relayHash dbfe00fb39056eb3a0f24ae626006e70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 37e0b01331c6dcada462d07f7764d7a34a182c06b9c730308a9449086d63c78c
const $a077863dd44c9913$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v13 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v10 /*: any*/ 
    }, v14 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v15 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "condition": "includeReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v5 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "when"
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentRepliesCreateGeneralReplyMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "createFooterComment",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ 
                                    ]
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentRepliesCreateGeneralReplyMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "createFooterComment",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v28 /*: any*/ ,
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dbfe00fb39056eb3a0f24ae626006e70",
            "id": "37e0b01331c6dcada462d07f7764d7a34a182c06b9c730308a9449086d63c78c",
            "metadata": {},
            "name": "CommentRepliesCreateGeneralReplyMutation",
            "operationKind": "mutation",
            "text": "mutation CommentRepliesCreateGeneralReplyMutation($pageId:ID!,$cloudId:ID!,$input:CreateCommentInput!,$includeReactions:Boolean!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},version{by{__typename,displayName},when,number}}}"
        }
    };
}();
$a077863dd44c9913$var$node.hash = "42751e8cecbdf3c515d561bda37d1e47";
var $a077863dd44c9913$export$2e2bcd8739ae039 = $a077863dd44c9913$var$node;
module.exports["default"] = $a077863dd44c9913$export$2e2bcd8739ae039;

});

parcelRegister("8DH6r", function(module, exports) {
/**
 * @generated SignedSource<<6aad3880ad3f6d9258df40d24c42acc7>>
 * @relayHash 0da891ebc91832bab75be58319e47f10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dcb0effecbd4ee333f8bbc40dbf593d0618ba3236edd5007050f7f719441833d
const $bd04856e92610f9a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "when"
    }, v22 = {
        "kind": "ScalarField",
        "name": "number"
    }, v23 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v26 = {
        "condition": "includeReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentRepliesCreateInlineReplyMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "replyInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v26 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentRepliesCreateInlineReplyMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "replyInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v11 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v26 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0da891ebc91832bab75be58319e47f10",
            "id": "dcb0effecbd4ee333f8bbc40dbf593d0618ba3236edd5007050f7f719441833d",
            "metadata": {},
            "name": "CommentRepliesCreateInlineReplyMutation",
            "operationKind": "mutation",
            "text": "mutation CommentRepliesCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!,$includeReactions:Boolean!){replyInlineComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}"
        }
    };
}();
$bd04856e92610f9a$var$node.hash = "3ec5c8e50962a5f1e44c0682ca61f71f";
var $bd04856e92610f9a$export$2e2bcd8739ae039 = $bd04856e92610f9a$var$node;
module.exports["default"] = $bd04856e92610f9a$export$2e2bcd8739ae039;

});

parcelRegister("666Tc", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $4KS7f = parcelRequire("4KS7f");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1yt4v0yc _1e0c1txw _1n261g80 _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1as91r31 _j4qy8stv _1wwgnqa1 _v0fytlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $7sObp.default)(`${rightOffset}px`),
                "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19itia51 _2rko1l7b _16qs1nax _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4 _1bsb1178 _c71lglyw",
                __cmplp.mode === "view" ? "_1pbyibnn" : "_1pby1ap8",
                __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$18986330a3dbad03 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _521wia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, isStandaloneComment: isStandaloneComment, ...__cmpldp } = __cmplp;
        let result;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result = "var(--ds-space-150, 12px)";
        else {
            const basePadding = __cmplp.mode === "view" ? "var(--ds-space-150, 12px) var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px) var(--ds-space-150, 12px)";
            result = __cmplp.isCommentsPanel ? "0" : basePadding;
        }
        const t3 = result;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let result_0;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result_0 = "var(--ds-space-150, 12px)";
        else if (!__cmplp.isCommentsPanel && (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) result_0 = "var(--ds-space-200, 16px)";
        else result_0 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-space-150, 12px)" : "var(--ds-space-100, 8px)";
        const t5 = result_0;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $7sObp.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-space-075, 6px) var(--ds-space-100, 8px)" : "var(--ds-space-050, 4px)");
            $[7] = t7;
        } else t7 = $[7];
        let t8;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-disabled, #080F214A)");
            $[8] = t8;
        } else t8 = $[8];
        let t9;
        if ($[9] !== __cmpls || $[10] !== t4 || $[11] !== t6) {
            t9 = {
                ...__cmpls,
                "--_35y4il": t4,
                "--_1je193e": t6,
                "--_567avp": t7,
                "--_1n1whry": t8
            };
            $[9] = __cmpls;
            $[10] = t4;
            $[11] = t6;
            $[12] = t9;
        } else t9 = $[12];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t9,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1yt4pe71 _n3td1fzo _1k0c1qnt _159vzwfg _1wv15a2x",
                __cmplp.isCommentsPanel || __cmplp.isFabricPage && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "_x3doglyw" : "_x3doj0fz",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41jx0 _1e0c1txw _4cvr1h6o _2lx21bp4 _1i7vwadc _9a6v14no _kckd15o9 _125xi7uo _31ku1h6o _ekv6wadc _dkzuutpp _5lhmtlke _1pzm1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isReply: isReply, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            !__cmplp.isReply && "_1yt4utpp _n7zlia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldHaveButtonGap: shouldHaveButtonGap, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1usn19bv _1achz0dk _1scmazsu",
            __cmplp.shouldHaveButtonGap && "_zulpv77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: "var(--ds-radius-small, 4px)",
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F0F1F2)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #6B6E76)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let isSSRFocusedComment;
    let props;
    if ($[0] !== t0) {
        ({ isSSRFocusedComment: isSSRFocusedComment, ...props } = t0);
        $[0] = t0;
        $[1] = isSSRFocusedComment;
        $[2] = props;
    } else {
        isSSRFocusedComment = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== isSSRFocusedComment) {
        t1 = $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(isSSRFocusedComment);
        $[3] = isSSRFocusedComment;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t1,
            ...props
        });
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1txw _19bvutpp _u5f3utpp",
            __cmplp.shouldShowNavigation ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.shouldShowNavigation && "_4t3i10yn _ca0qutpp",
            __cmplp.isReattachHeader && "_4t3i10yn _ca0qpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $003eb47e4cfe7fce$export$f39f3f768bc98e3d : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1178 _4t3irvwn",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.showNavigation ? "_19pkxy5q" : "_19pkze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _1xi2utpp _1pbykb7n _154iutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp12x7 _kqswstnw _154ipxbi _1ltvpxbi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let isUpdatedStandaloneComment;
    let props;
    if ($[0] !== t0) {
        ({ isUpdatedStandaloneComment: isUpdatedStandaloneComment, ...props } = t0);
        $[0] = t0;
        $[1] = isUpdatedStandaloneComment;
        $[2] = props;
    } else {
        isUpdatedStandaloneComment = $[1];
        props = $[2];
    }
    const t1 = isUpdatedStandaloneComment ?? false;
    let t2;
    if ($[3] !== t1) {
        t2 = $003eb47e4cfe7fce$var$closeButtonTheme(t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t2,
            ...props
        });
        $[5] = props;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ActionsContainer"] = $003eb47e4cfe7fce$export$48377ae1c677702b;
module.exports["SidebarContainer"] = $003eb47e4cfe7fce$export$f39f3f768bc98e3d;
module.exports["ReplyListContainer"] = $003eb47e4cfe7fce$export$18986330a3dbad03;
module.exports["NewReplyContainer"] = $003eb47e4cfe7fce$export$86b1f0d05f7b12cd;
module.exports["ResolvedNotificationContainer"] = $003eb47e4cfe7fce$export$5aae1a36fc838370;
module.exports["EditorContainer"] = $003eb47e4cfe7fce$export$b38a2fd24b22fb35;
module.exports["NavigationContainer"] = $003eb47e4cfe7fce$export$d1b98bde82a43bb3;
module.exports["InlineHeaderButton"] = $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5;
module.exports["SidebarHeader"] = $003eb47e4cfe7fce$export$e575a964a1fe8b0;
module.exports["LoadingSkeletonContainer"] = $003eb47e4cfe7fce$export$b3b0191112eea395;
module.exports["TopContainer"] = $003eb47e4cfe7fce$export$f895097fe90363d1;
module.exports["CloseButtonContainer"] = $003eb47e4cfe7fce$export$32dd8f1956fe77b1;
module.exports["CloseButton"] = $003eb47e4cfe7fce$export$de65de8213222d10;

});

parcelRegister("cQCqE", function(module, exports) {

var $310ZR = parcelRequire("310ZR");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment reply. Because the new
// Comments Data Manager caches all the data for comments in Relay, we need to define the mutation
// here so that the cache can be updated fully when a new reply is created - and that means the
// mutation needs to return the full comment data structure that we are using in the returned query
// part of the mutation.  Since that returned query is quite large, we define it here in its own
// hook to avoid having it in many places in the codebase - which makes the code harder to read and
// could lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
const $f9d242b7b867bd0c$var$CreateInlineReplyMutation = (0, $310ZR.default);
const $f9d242b7b867bd0c$export$9cc5e5ba32b058b7 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineReplyFn] = (0, $308Wd.useMutationInterop)($f9d242b7b867bd0c$var$CreateInlineReplyMutation);
    const addEmptyInlineRepliesAndReactions = (0, $42omo.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            replies: [],
            reactionsSummary: (0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true) ? null : commentData.reactionsSummary ?? null
        } : undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comment replies. It will either call the new Comments Data Manager path or the old
    // Apollo mutation path depending on whether the relevant experiment is enabled.
    const createInlineReplyInterop = (0, $42omo.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        const updateNewCommentReplyInCache = (_dataProxy, mutationResult)=>{
            addCommentInCache({
                newComment: addEmptyInlineRepliesAndReactions(mutationResult.data.replyInlineComment),
                onError: onCacheUpdateError
            });
        };
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // strip old update function and other options and adjust variables as needed
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables;
            return createInlineReplyFn({
                variables: {
                    ...newVariables,
                    includeReactionsSummary: !(0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true)
                },
                update: updateNewCommentReplyInCache
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesAndReactions,
        createInlineReplyFn
    ]);
    return {
        createInlineReplyInterop: createInlineReplyInterop
    };
};
module.exports["useCreateInlineReplyMutation"] = $f9d242b7b867bd0c$export$9cc5e5ba32b058b7;

});

parcelRegister("310ZR", function(module, exports) {
/**
 * @generated SignedSource<<35487fa1edf598dafba4be4adb52239e>>
 * @relayHash 251686a61db1160888478730ff3239b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6faea90f9b58d45b5664d99ac3cdecf7908886ec22a01b3b93a5a295ab4fec9
const $fb6961718abb1299$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsSummary"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v13 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "replyInlineComment",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v8 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                },
                {
                    "condition": "includeReactionsSummary",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "pageId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateInlineReplyMutation",
            "selections": v13 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateInlineReplyMutation",
            "selections": v13 /*: any*/ 
        },
        "params": {
            "cacheID": "251686a61db1160888478730ff3239b3",
            "id": "a6faea90f9b58d45b5664d99ac3cdecf7908886ec22a01b3b93a5a295ab4fec9",
            "metadata": {},
            "name": "useCreateInlineReplyMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!,$includeReactionsSummary:Boolean!){replyInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$fb6961718abb1299$var$node.hash = "2b7f67eb2971040c4fc787ed5990c49d";
var $fb6961718abb1299$export$2e2bcd8739ae039 = $fb6961718abb1299$var$node;
module.exports["default"] = $fb6961718abb1299$export$2e2bcd8739ae039;

});

parcelRegister("1JuAZ", function(module, exports) {
/* GeneralReplyScroller.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bUlM5 = parcelRequire("bUlM5");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $2Pg7f = parcelRequire("2Pg7f");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1Sjzs = parcelRequire("1Sjzs");


var $fURMF = parcelRequire("fURMF");

const $2e558da207609fcd$var$replyScrollerStyles = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    marginTop: "var(--ds-space-150, 12px)",
    left: 0
};
const $2e558da207609fcd$var$replyScrollerStylesV2 = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    left: 0
};
const $2e558da207609fcd$var$replyScrollerBranchingStyle = null;
const $2e558da207609fcd$var$replyWrapperWithSpacingStyles = {
    paddingTop: "var(--ds-space-100, 8px)"
};
const $2e558da207609fcd$var$leftMargin = null;
const $2e558da207609fcd$var$unreadIndicatorStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
}); // This snippet is being used in CommentBody.tsx
const $2e558da207609fcd$var$dotStyles = null;
const $2e558da207609fcd$var$pressableStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    backgroundColor: 'color.background.neutral.subtle',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    borderRadius: 'radius.small',
    userSelect: 'none',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $2e558da207609fcd$var$styles = {
    generalReplyScrollerWrapperStyles: "_1kl71h4i _ca0qutpp"
};
const $2e558da207609fcd$var$i18n = (0, $aXWIB.defineMessages)({
    commentsPanelShowGeneralNestedReplies: {
        id: "comments-common.comment-thread.go.to.nested.general.reply",
        defaultMessage: "Go to more replies"
    },
    commentsPanelGeneralNestedRepliesHasUnread: {
        id: "comments-common.comment-thread.general.nested.replies.has.unread",
        defaultMessage: "There are unread replies"
    }
});
const $2e558da207609fcd$export$a0769df2292690a8 = ({ nestedReplies: nestedReplies, unreadReplyIds: unreadReplyIds, targetCommentIdForScroll: targetCommentIdForScroll, isLastUnnestableReply: isLastUnnestableReply })=>(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e558da207609fcd$var$GeneralReplyScrollerWrapperComponent, {
        nestedReplies: nestedReplies,
        unreadReplyIds: unreadReplyIds,
        targetCommentIdForScroll: targetCommentIdForScroll,
        isLastUnnestableReply: isLastUnnestableReply
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e558da207609fcd$var$GeneralReplyScrollerComponent, {
        nestedReplies: nestedReplies,
        unreadReplyIds: unreadReplyIds,
        targetCommentIdForScroll: targetCommentIdForScroll
    });
const $2e558da207609fcd$var$GeneralReplyScrollerComponent = ({ nestedReplies: nestedReplies, unreadReplyIds: unreadReplyIds, targetCommentIdForScroll: targetCommentIdForScroll })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const maxProfilePicturesToShow = 3; // If any of the nestedReplies match an ID in unreadReplyIds, render the blue dot indicator
    const unreadReplyIdsSet = new Set(unreadReplyIds);
    const shouldRenderBlueDotIndicator = nestedReplies.some((reply)=>unreadReplyIdsSet.has(reply.id));
    const avatarsToShow = (0, $42omo.useMemo)(()=>{
        const uniqueAccountsMap = new Map(); // Start from the end of the list and move backwards
        for(let i = nestedReplies.length - 1; i >= 0; i--){
            const reply = nestedReplies[i];
            const { displayName: displayName, profilePicture: profilePicture } = reply.author; // Determine if the author has an accountId, anonymous users don't have accountId
            let uniqueKey;
            if ('accountId' in reply.author && reply.author.accountId) uniqueKey = reply.author.accountId;
            else // Fallback for anonymous users or if accountId is not present
            uniqueKey = `anonymous-${i}`;
            if (!uniqueAccountsMap.has(uniqueKey)) uniqueAccountsMap.set(uniqueKey, {
                displayName: displayName ?? '',
                profilePicturePath: profilePicture?.path
            });
        }
        const avatars = Array.from(uniqueAccountsMap.values());
        const mappedAvatars = avatars.map((profilePicturesInfo)=>({
                name: profilePicturesInfo.displayName,
                src: profilePicturesInfo.profilePicturePath
            }));
        return mappedAvatars;
    }, [
        nestedReplies
    ]); // NOTE: This component replicates a lot of the code in RepliesToggler.tsx
    // However, GeneralReplyScroller is only used for multi nested general comment replies for pages created before the single threading general comments feature was introduced
    // All new pages created after this time will use RepliesScroller instead of GeneralReplyScroller
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _18u01jfw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        testId: "comments-panel-reply-scroller-container",
        showDefaultStyles: true,
        customStyles: {
            ...(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? $2e558da207609fcd$var$replyScrollerStylesV2 : $2e558da207609fcd$var$replyScrollerStyles,
            ...$2e558da207609fcd$var$replyWrapperWithSpacingStyles
        },
        disableLeftProp: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18u0utpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: ()=>{
            const targetElementId = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? `footer-comment-thread-${targetCommentIdForScroll}-replies` : `comment-${targetCommentIdForScroll}-footer`;
            const commentElement = document.getElementById(targetElementId); // NOTE - redesigned footer comments don't yet all load when the panel is opened, so may not be in the DOM
            // In cases where this is not yet in the DOM, we treat it like clicking the comment body in commentThreadHelper#shouldTriggerCommentScroll
            if (commentElement) {
                const offset = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? -60 : -75; // Redesigned footer comments have a slightly different height
                (0, $fURMF.scrollToElement)(commentElement, offset, 'smooth');
            }
        },
        testId: "comments-panel-thread-show-nested-general-replies",
        xcss: $2e558da207609fcd$var$pressableStyles,
        interactionName: "comments-panel-thread-show-nested-general-replies"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, avatarsToShow.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: avatarsToShow,
        maxCount: maxProfilePicturesToShow,
        appearance: "stack",
        size: "small",
        shouldPopupRenderToParent: true,
        testId: "comments-panel-replies-scroller-profile-pictures"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $2e558da207609fcd$var$unreadIndicatorStyle
    }, formatMessage($2e558da207609fcd$var$i18n.commentsPanelShowGeneralNestedReplies), shouldRenderBlueDotIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "comments-panel-unread-nested-general-replies-indicator",
        "aria-label": formatMessage($2e558da207609fcd$var$i18n.commentsPanelGeneralNestedRepliesHasUnread),
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _18s81b66 _4t3iu2gc _1bsbu2gc _bfhk1856"
        ])
    }))))))));
};
const $2e558da207609fcd$var$GeneralReplyScrollerWrapperComponent = ({ nestedReplies: nestedReplies, unreadReplyIds: unreadReplyIds, targetCommentIdForScroll: targetCommentIdForScroll, isLastUnnestableReply: isLastUnnestableReply })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: `general-reply-scroller-wrapper-${isLastUnnestableReply ? 'without-border' : 'with-border'}`,
        xcss: !isLastUnnestableReply && $2e558da207609fcd$var$styles.generalReplyScrollerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2e558da207609fcd$var$GeneralReplyScrollerComponent, {
        nestedReplies: nestedReplies,
        unreadReplyIds: unreadReplyIds,
        targetCommentIdForScroll: targetCommentIdForScroll
    }));
module.exports["GeneralReplyScroller"] = $2e558da207609fcd$export$a0769df2292690a8;

});

parcelRegister("fURMF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $1dnxO = parcelRequire("1dnxO");


var $9wGTI = parcelRequire("9wGTI");

const $e9d2c346c5e28ee8$var$logger = (0, $7W8i8.getLogger)('scroll-to-element');
const $e9d2c346c5e28ee8$export$aa10bd88079cd4f3 = 60;
/**
 * Returns the HTMLElement that should be used as the scroll root. By default, this is the window.
 * For Nav 4, this is the div with id=AkMainContent, if the id exists in the DOM
 *
 * @param isNav4Enabled - boolean
 */ function $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled = false) {
    //if we are in mobile size for nav4, we should still scroll window.
    // the magic number below maps to media.above.md @media (min-width: 64rem)	1024px which sadly appears to have no means of access in pure JS
    if (isNav4Enabled && window.innerWidth > 1023 && document.getElementById('AkMainContent')) return document.getElementById('AkMainContent');
    return window;
}
const $e9d2c346c5e28ee8$var$explicitScrollListeners = new Set();
function $e9d2c346c5e28ee8$export$73ac910751bb2a9b(listener) {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.add(listener);
    return ()=>$e9d2c346c5e28ee8$var$explicitScrollListeners.delete(listener);
}


function $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners() {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.forEach((listener)=>{
        try {
            listener();
        } catch (error) {
            Promise.all([
                (parcelRequire("kI6Jo")),
                (parcelRequire("YiYda"))
            ]).then(([{ getMonitoringClient: getMonitoringClient }, { Attribution: Attribution }])=>{
                getMonitoringClient().submitError(error, {
                    attribution: Attribution.PAGE_EXTENSIONS
                });
            }).catch(()=>{
            // ignore errors, we can't do anything at this point
            });
        }
    });
}
function $e9d2c346c5e28ee8$var$isSmoothScrollSupported() {
    return 'scrollBehavior' in document.documentElement.style;
}
function $e9d2c346c5e28ee8$export$9b071b9c6dd786a2(isSmooth = false) {
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const scrollRootElement = $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled);
    if (scrollRootElement) {
        //typecheck is convinced this can be null
        if (isSmooth && $e9d2c346c5e28ee8$var$isSmoothScrollSupported()) scrollRootElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        else scrollRootElement.scrollTo(0, 0);
    }
}
function $e9d2c346c5e28ee8$export$2353115f31f4d15(element, scrollCorrectionPixels, scrollBehavior = 'auto', isLivePage) {
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const scrollRootElement = isLivePage ? document.querySelector('.fabric-editor-popup-scroll-parent') : $e9d2c346c5e28ee8$var$getScrollRootElement(isNav4Enabled);
    let parentsOffset = 0;
    let currentOffsetParent = element.offsetParent;
    while(currentOffsetParent instanceof HTMLElement && currentOffsetParent != scrollRootElement){
        parentsOffset += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    const pageHeaderHeightAdjustment = isNav4Enabled ? (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? 56 : 0 : $e9d2c346c5e28ee8$export$aa10bd88079cd4f3;
    let top = element.offsetTop + (scrollCorrectionPixels || 0) + parentsOffset - pageHeaderHeightAdjustment;
    // check if element is nested inside table, if so we need to account for
    // sticky table header overlapping the element
    const hasTableParent = element?.closest('.pm-table-container td');
    if (hasTableParent && scrollCorrectionPixels) top = top + scrollCorrectionPixels * 1.25;
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    let behavior = scrollBehavior;
    if (behavior === 'smooth' && !$e9d2c346c5e28ee8$var$isSmoothScrollSupported()) behavior = 'auto';
    try {
        scrollRootElement?.scroll({
            top: top,
            behavior: behavior
        });
    } catch  {
        isNav4Enabled ? $e9d2c346c5e28ee8$var$logger.error`scroll() is not supported on #AkMainContent` : $e9d2c346c5e28ee8$var$logger.error`window.scroll() is not supported`;
    }
}
function $e9d2c346c5e28ee8$export$8611df79cae6484f(element) {
    const scrollContainer = document.getElementById('AkMainContent');
    const breadcrumbHeaderHeight = 56; // FixedSpaceHeaderContainer (top nav) of the classic full page
    if (scrollContainer && scrollContainer.contains(element)) {
        // Let the browser calculate the exact scroll position
        const savedScroll = scrollContainer.scrollTop;
        element.scrollIntoView({
            behavior: 'instant',
            block: 'start'
        });
        const targetScroll = scrollContainer.scrollTop;
        scrollContainer.scrollTop = savedScroll;
        scrollContainer.scrollTo({
            left: 0,
            top: targetScroll - breadcrumbHeaderHeight,
            behavior: 'smooth'
        });
    } else element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}
module.exports["scrollToPageStart"] = $e9d2c346c5e28ee8$export$9b071b9c6dd786a2;
module.exports["scrollToElement"] = $e9d2c346c5e28ee8$export$2353115f31f4d15;
module.exports["scrollToBlockForViewPage"] = $e9d2c346c5e28ee8$export$8611df79cae6484f;

});

parcelRegister("kI6Jo", function(module, exports) {

let $f13d236567563fe5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f13d236567563fe5$var$load("9fiFD").then(()=>parcelRequire('6SqQk'));

});

parcelRegister("YiYda", function(module, exports) {

let $0b5451c9b84ee3f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0b5451c9b84ee3f1$var$load("fH5Zm").then(()=>parcelRequire('bZmZf'));

});

parcelRegister("9tfnI", function(module, exports) {

var $6hV0F = parcelRequire("6hV0F");


var $iRmLY = parcelRequire("iRmLY");


var $5858y = parcelRequire("5858y");


var $4cf5h = parcelRequire("4cf5h");


var $hznSr = parcelRequire("hznSr");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $9wGTI = parcelRequire("9wGTI");


var $1ggpj = parcelRequire("1ggpj");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $3ZsvI = parcelRequire("3ZsvI");


var $8i27m = parcelRequire("8i27m");


var $NYiei = parcelRequire("NYiei");


var $jbF1h = parcelRequire("jbF1h");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $bSvtO = parcelRequire("bSvtO");


var $1YPul = parcelRequire("1YPul");


var $8SCD6 = parcelRequire("8SCD6");


var $kmHPt = parcelRequire("kmHPt");


var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $g0DaR = parcelRequire("g0DaR");

var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");


var $ep3mz = parcelRequire("ep3mz");


var $8z9UY = parcelRequire("8z9UY");


var $3s9yq = parcelRequire("3s9yq");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $liGyh = parcelRequire("liGyh");


var $aUU0C = parcelRequire("aUU0C");


var $k8e76 = parcelRequire("k8e76");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cD1qu = parcelRequire("cD1qu");


var $8WQTF = parcelRequire("8WQTF");


var $cZa7r = parcelRequire("cZa7r");


var $3ejfs = parcelRequire("3ejfs");


var $2i3To = parcelRequire("2i3To");


var $9CnRS = parcelRequire("9CnRS");


var $ftXPY = parcelRequire("ftXPY");


var $87CZC = parcelRequire("87CZC");


var $bQm3c = parcelRequire("bQm3c");


var $7W8i8 = parcelRequire("7W8i8");


var $7B9wr = parcelRequire("7B9wr");


var $i6UMJ = parcelRequire("i6UMJ");


var $9FoVw = parcelRequire("9FoVw");


var $aMfLn = parcelRequire("aMfLn");


var $3mVfX = parcelRequire("3mVfX");


var $en1dX = parcelRequire("en1dX");


var $6hmtW = parcelRequire("6hmtW");


var $5fMeR = parcelRequire("5fMeR");


var $fy5yb = parcelRequire("fy5yb");


var $308Wd = parcelRequire("308Wd");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");

const $dbdd2e782e37c476$var$CommentResolveCommentMutation = (0, $hznSr.default);
const $dbdd2e782e37c476$var$CommentReopenCommentMutation = (0, $4cf5h.default);
const $dbdd2e782e37c476$var$CommentDeleteInlineCommentMutationWithStepMutation = (0, $5858y.default);
const $dbdd2e782e37c476$var$CommentDeleteInlineCommentMutation = (0, $iRmLY.default);
const $dbdd2e782e37c476$var$CommentDeleteGeneralCommentMutation = (0, $6hV0F.default);
const $dbdd2e782e37c476$var$i18n = (0, $aXWIB.defineMessages)({
    commentReopenedFlagTitle: {
        id: "comments-panel.comment.reopened.flag.title",
        defaultMessage: "Comment reopened"
    },
    commentReopenFailedFlagTitle: {
        id: "comments-panel.comment.reopen.failed.flag.title",
        defaultMessage: "Failed to reopen comment"
    },
    commentReopenCacheUpdateFailedFlagTitle: {
        id: "comments-panel.comment.reopen.cache-update.failed.flag.title",
        defaultMessage: "Failed to update reopened comment. Please refresh the page."
    },
    retryCTA: {
        id: "comments-panel.comment.reopen.failed.flag.cta.retry",
        defaultMessage: "Retry now"
    }
});
const $dbdd2e782e37c476$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $dbdd2e782e37c476$var$commentWrapperReplyPaddingOverrides = null;
const $dbdd2e782e37c476$var$commentWrapperReplyPaddingOverridesV2 = null;
const $dbdd2e782e37c476$var$standaloneCommentWrapperReplyPaddingOverrides = null;
const $dbdd2e782e37c476$var$leftBorderStyle = null;
const $dbdd2e782e37c476$var$leftBorderStyleUpdated = null; // this component can be used for parent comment and a reply
const $dbdd2e782e37c476$export$4d299b491347818a = ({ comment: comment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, pageInfo: pageInfo, isUnread: isUnread = false, isHovered: isHovered, threadKey: threadKey, flags: flags, isAnnotatedTextPressed: isAnnotatedTextPressed, setAnnotatedTextPressed: setAnnotatedTextPressed, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, hideReactions: hideReactions = false, canAddComments: canAddComments = true, isThreadHovered: isThreadHovered, isParentCommentOpen: isParentCommentOpen, isStandaloneComment: isStandaloneComment, showRepliesWithCurvedBorders: showRepliesWithCurvedBorders, deleteStandaloneComment: deleteStandaloneComment, replyToComment: replyToComment, updateReactionsCacheFn: updateReactionsCacheFn, onRendered: onRendered, isLastUnnestableReply: isLastUnnestableReply = false, commentHandlesPadding: commentHandlesPadding = false, hasParentMaxHeight: hasParentMaxHeight = false })=>{
    // Store stable references to break circular dependency in useCallback
    const handleResolveCommentRef = (0, $42omo.useRef)(null);
    const handleReopenCommentRef = (0, $42omo.useRef)(null);
    const [editCommentId, setCommentForEdit] = (0, $42omo.useState)('');
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const isNewDanglingCommentExperienceEnable = (0, $7B9wr.useIsNewDanglingCommentExperienceEnabled)();
    const isOffline = (0, $cZa7r.useAnnotationsIsOffline)();
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { removeUnresolvedInlineComment: removeUnresolvedInlineComment, addUnresolvedInlineComment: addUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const [{ commentsDataMap: legacyCommentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, deleteParentComment: deleteParentComment, handleRemovingComments: handleRemovingComments, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList }] = (0, $8i27m.useCommentsData)();
    const { setCacheUpdateFailed: setCacheUpdateFailed } = (0, $8i27m.useCommentsDataActions)(); // Get cache operations for new comments data manager
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId || '',
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    }); // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)(); // Use new or legacy data based on experiment
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const [{ annotations: annotations }] = (0, $aUU0C.useEditorAnnotations)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const [{ updateDocumentFn: updateDocumentFn }] = (0, $1YPul.useUpdateDocument)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey, currentView: currentView }, { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { focusedCommentId: focusedCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [contentType] = (0, $ep3mz.useContentType)(); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [resolveCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentResolveCommentMutation); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [reopenCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentReopenCommentMutation, {
        refetchQueries: // Copied from the existing dialog flow to support standalone experience
        pageMode === (0, $cD1qu.PageMode).VIEW && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? [
            {
                query: (0, $3s9yq.InlineCommentsQuery),
                variables: {
                    pageId: contentId
                }
            }
        ] : []
    });
    const [deleteTopLevelRendererInlineCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentDeleteInlineCommentMutationWithStepMutation);
    const [deleteInlineCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentDeleteInlineCommentMutation);
    const [deleteGeneralCommentFn] = (0, $308Wd.useMutationInterop)($dbdd2e782e37c476$var$CommentDeleteGeneralCommentMutation); // Get the update functions for the comments data manager - aliased to support the different
    // mutation's different result types
    const { updateCommentInCache: updateResolveCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { updateCommentInCache: updateReopenCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)(); // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
    const pageId = contentId;
    const userId = comment?.author?.accountId;
    const topCommentUserAvatar = comment?.author?.profilePicture?.path;
    const topCommentDisplayName = comment?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = comment?.id;
    const date = comment?.version?.when;
    const createdAt = comment?.createdAt?.value;
    const createdAtNonLocalized = comment?.createdAtNonLocalized;
    const versionByDisplayName = comment?.version?.by?.displayName;
    const versionDate = comment?.version?.when;
    const permissions = comment?.permissions;
    const content = comment?.body?.value;
    const permissionType = comment?.author?.permissionType ?? undefined;
    const parentCommentId = comment?.parentId;
    const isReply = !!parentCommentId;
    const isEdited = (comment?.version?.number || 0) > 1;
    const numReplies = comment?.replies?.length || 0;
    const commentUrl = pageMode === (0, $cD1qu.PageMode).EDIT ? comment?.links?.editui : comment?.links?.webui; // view page and live docs uses the webui field
    const isDatabaseOrWhiteboard = contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType); // When hideReactions (e.g. comment preview popup), pass empty summary so reactions query is skipped and none render
    const inheritedReactionsData = hideReactions ? (0, $g0DaR.defaultReactionsSummary) : comment?.reactionsSummary ?? null;
    const inlineCommentlocation = comment?.location;
    const footerCommentLocation = comment?.location;
    const commentType = inlineCommentlocation?.type === 'INLINE' ? (0, $8i27m.CommentType).INLINE : (0, $8i27m.CommentType).GENERAL;
    const getResolvedProperties = (0, $42omo.useCallback)((type)=>{
        const properties = type === (0, $8i27m.CommentType).INLINE ? inlineCommentlocation?.inlineResolveProperties : footerCommentLocation?.commentResolveProperties;
        if (!isReply) return properties || undefined;
        return undefined;
    }, [
        inlineCommentlocation,
        footerCommentLocation,
        isReply
    ]);
    const resolveProperties = getResolvedProperties(commentType);
    const annotatedText = inlineCommentlocation?.inlineText || undefined;
    const isCommentRemovedByAnotherUser = comment?.wasRemovedByAnotherUser;
    const isResolvedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD;
    const isDeletedByAnotherUser = isCommentRemovedByAnotherUser && isCommentRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
    const deleteCommentInCacheOnUpdate = (0, $42omo.useCallback)((removalCommentId, experienceName)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: experienceName,
                    error: err,
                    commentId: removalCommentId
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker
    ]);
    const isOptimisticDeleteEnabled = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false);
    const handleDeleteInlineComment = ()=>{
        // NOTE: The DELETE experience is started in CommentActions.tsx
        const isDangling = resolveProperties?.isDangling;
        const isTopLevelRendererComment = !isDatabaseOrWhiteboard && pageMode === (0, $cD1qu.PageMode).VIEW && !isReply;
        const canDeleteAnnotation = !isDangling && isTopLevelRendererComment;
        let step;
        if (canDeleteAnnotation) try {
            const deleteResult = rendererActions?.deleteAnnotation(threadKey, 'inlineComment');
            if (deleteResult) step = deleteResult.step;
            else {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: new Error(`Unable to remove annotation ${threadKey} from document`)
                });
                return;
            }
        } catch (e) {
            experienceTracker.stopOnError({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                error: e
            });
            return;
        }
        if (isStandaloneComment) {
            deleteStandaloneComment && parentCommentId && deleteStandaloneComment(parentCommentId, commentId);
            return;
        }
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) resetContentChanged();
         // Optimistically mark the annotation as resolved.
        // If deletion is successful, the annotation will be deleted later;
        // if deletion fails, the annotation will be unresolved.
        if (!isReply && isOptimisticDeleteEnabled) (0, $g0DaR.resolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
         // Optimistically delete the comment thread, if it is not a reply.
        let deletedParentComment = null;
        if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            if (!isReply && isOptimisticDeleteEnabled) deletedParentComment = (0, $fy5yb.deleteParentCommentOptimistically)({
                threadKey: threadKey,
                commentType: commentType,
                commentsDataMap: commentsDataMap,
                deleteParentComment: deleteParentComment
            });
            else deletedParentComment = (0, $fy5yb.deleteInlineParentComment)({
                isReply: isReply,
                threadKey: threadKey,
                commentType: commentType,
                commentsDataMap: commentsDataMap,
                deleteParentComment: deleteParentComment
            });
        } // Optimistically delete the reply, if it is a reply.
        const deletedReplyComment = !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && isReply && isOptimisticDeleteEnabled ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: threadKey,
            commentId: commentId,
            commentType: commentType,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        const deleteMutation = canDeleteAnnotation ? deleteTopLevelRendererInlineCommentFn : deleteInlineCommentFn;
        const optimisticDeleteResponse = canDeleteAnnotation ? {
            deleteInlineComment: true
        } : {
            deleteComment: true
        };
        const deleteVariables = {
            variables: canDeleteAnnotation ? {
                input: {
                    commentId: commentId,
                    step: step ? (0, $aMfLn.constructStepForGql)(step) : {}
                }
            } : {
                commentIdToDelete: commentId,
                // There is no VIEW option
                deleteFrom: pageMode === (0, $cD1qu.PageMode).EDIT ? (0, $8z9UY.CommentDeletionLocation).EDITOR : (0, $8z9UY.CommentDeletionLocation).LIVE
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(commentId, (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)), ()=>isReply ? (0, $g0DaR.updateApolloCacheCallback)('delete', {
                    pageId: pageId,
                    contentStatus: [
                        'CURRENT',
                        'DRAFT'
                    ]
                }, parentCommentId, commentId) : undefined),
            optimisticResponse: isOptimisticDeleteEnabled ? optimisticDeleteResponse : undefined
        };
        deleteMutation({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || canDeleteAnnotation && !data.deleteInlineComment || !canDeleteAnnotation && !data.deleteComment) throw new Error('No data returned from mutation');
            const cleanUpReply = ()=>{
                if (!isOptimisticDeleteEnabled) {
                    if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) handleRemovingComments({
                        threadKey: threadKey,
                        commentId: commentId,
                        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: commentType
                    });
                }
            };
            const deleteAnnotationAndCleanUpParent = (annotationId)=>{
                // For a top level comment in renderer, we need to send out the events to tell the
                // renderer to deselect the annotation and remove it from the document
                if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                    const deleteResult = rendererActions?.deleteAnnotation(annotationId, 'inlineComment');
                    if (deleteResult && deleteResult.doc) {
                        // Inform the Renderer to de-select the annotation
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                        updateDocumentFn && updateDocumentFn(deleteResult.doc);
                    } // For editor/live pages we need to send the event to delete the mark
                } else eventEmitter.emit('delete', annotationId);
                if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    resetContentChanged();
                    if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) deleteParentComment({
                        threadKey: threadKey,
                        commentType: commentType
                    });
                    if (commentType === (0, $8i27m.CommentType).INLINE) setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== threadKey));
                }
            }; // send bridge api signal to content types.
            commentService.onDeleteComment?.(threadKey);
            const onSuccess = (annotationId)=>{
                if (isReply) cleanUpReply();
                else deleteAnnotationAndCleanUpParent(annotationId);
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            (0, $8dA1U.handleDeleteSuccess)({
                commentId: commentId,
                annotationId: threadKey,
                pageId: pageId,
                pageMode: pageMode,
                isReply: isReply,
                source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                inlineNodeTypes: undefined,
                createAnalyticsEvent: // We need to figure out how to get this data
                createAnalyticsEvent,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                onSuccess: onSuccess
            });
        }).catch((err)=>{
            handleDeleteCommentError({
                err: err,
                deletedParentComment: deletedParentComment,
                deletedReplyComment: deletedReplyComment
            });
        });
    };
    const handleDeleteGeneralComment = ()=>{
        // Optimistically delete the comment thread, if it is not a reply.
        const deletedParentComment = !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && !isReply && isOptimisticDeleteEnabled ? (0, $fy5yb.deleteParentCommentOptimistically)({
            threadKey: threadKey,
            commentType: commentType,
            commentsDataMap: commentsDataMap,
            deleteParentComment: deleteParentComment
        }) : null; // Optimistically delete the reply, if it is a reply.
        const deletedReplyComment = !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && isReply && isOptimisticDeleteEnabled ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: threadKey,
            commentId: commentId,
            commentType: commentType,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        let deleteLocation; // There is no deleteLocation for View Page
        if (pageMode !== (0, $cD1qu.PageMode).VIEW) deleteLocation = pageMode === (0, $cD1qu.PageMode).EDIT ? (0, $8z9UY.CommentDeletionLocation).EDITOR : (0, $8z9UY.CommentDeletionLocation).LIVE;
        const queryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
            pageId: pageId,
            type: 'FOOTER' // If we have footer, always write to footer. Panel works either way
        });
        const deleteVariables = {
            variables: {
                commentIdToDelete: commentId,
                deleteFrom: deleteLocation
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(commentId, (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)), ()=>isReply ? (0, $87CZC.updateApolloCacheReplyCallback)('delete', queryVariables, parentCommentId, isReactionsEnabled, commentId) : (0, $87CZC.updateApolloCacheParentCallback)('delete', queryVariables, isReactionsEnabled, commentId)),
            optimisticResponse: isOptimisticDeleteEnabled ? {
                deleteComment: true
            } : undefined
        };
        deleteGeneralCommentFn({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || !data.deleteComment) throw new Error('No data returned from mutation');
            resetContentChanged();
            if (!isOptimisticDeleteEnabled) {
                if (isReply) {
                    if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) handleRemovingComments({
                        threadKey: threadKey,
                        commentId: commentId,
                        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: commentType
                    });
                } else if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) deleteParentComment({
                    threadKey: threadKey,
                    commentType: commentType
                });
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        isReply: isReply,
                        commentType: (0, $8i27m.CommentType).GENERAL,
                        source: isStandaloneComment ? (0, $en1dX.AnalyticsSource).STANDALONE : (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                        pageMode: pageMode
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err)=>{
            handleDeleteCommentError({
                err: err,
                deletedParentComment: deletedParentComment,
                deletedReplyComment: deletedReplyComment
            });
        });
    };
    const handleDeleteCommentError = ({ err: err, deletedParentComment: deletedParentComment, deletedReplyComment: deletedReplyComment })=>{
        const isInlineComment = commentType === (0, $8i27m.CommentType).INLINE;
        const parsedError = (0, $isdzP.parseError)(err);
        const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, commentId);
        if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
            flags?.showWarningFlag({
                id: commentId,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).commentAlreadyDeletedTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), translatedError)
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'alreadyDeleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        commentType: commentType,
                        mode: pageMode,
                        framework: isInlineComment ? (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER : undefined,
                        isReply: isReply
                    }
                }
            }).fire();
        } else if (isOptimisticDeleteEnabled) // show an error flag to the user when optimistic deletion fails
        flags?.showErrorFlag({
            id: commentId,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).deleteErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).deleteError)
        });
        if (deletedParentComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addNewCommentThreads(deletedParentComment);
            if (isInlineComment && (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false)) (0, $g0DaR.unresolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
        }
        if (deletedReplyComment && isOptimisticDeleteEnabled) {
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(threadKey, deletedReplyComment, commentType, true);
        }
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: isInlineComment ? (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
            error: err,
            commentId: commentId
        });
    };
    const handleEditComment = ()=>{
        setCommentForEdit(commentId);
    };
    const exitCommentEditor = ()=>{
        setCommentForEdit('');
    };
    const handleReplyToComment = (id)=>{
        setReplyToCommentId({
            parentCommentId: id,
            location: (0, $i6UMJ.LocationValue).PANEL,
            user: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? {
                displayName: comment?.author?.displayName,
                accountId: comment?.author?.accountId
            } : undefined
        });
    };
    const handleReopenMutationFailure = (0, $42omo.useCallback)(({ isCacheUpdateFailed: isCacheUpdateFailed })=>{
        // TODO: Add experience tracking for reopening, which will allow us to differentiate and
        // detect cache errors vs mutation errors by the error value in the stopOnError() experience
        // call.  When that is added, we can go back to having a single flag message.
        flags?.showErrorFlag({
            id: commentId,
            title: formatMessage(isCacheUpdateFailed ? $dbdd2e782e37c476$var$i18n.commentReopenCacheUpdateFailedFlagTitle : $dbdd2e782e37c476$var$i18n.commentReopenFailedFlagTitle),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage($dbdd2e782e37c476$var$i18n.retryCTA),
                    onClick: ()=>{
                        flags.hideFlag(flags.state.flags[0]?.id);
                        handleReopenCommentRef.current?.();
                    }
                }
            ]
        });
    }, [
        commentId,
        flags,
        formatMessage
    ]);
    const reopenCommentUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateReopenCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.reopenCommentInCacheCallback),
            onError: ()=>handleReopenMutationFailure({
                    isCacheUpdateFailed: true
                })
        }), [
        commentId,
        handleReopenMutationFailure,
        updateReopenCommentInCache
    ]);
    const handleReopenComment = ()=>{
        // NOTE: The reopen experience is started in CommentActions.tsx
        reopenCommentFn({
            variables: {
                commentId: commentId,
                cloudId: cloudId
            },
            update: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? reopenCommentUpdateFn : undefined
        }).then(()=>{
            // Update the list of active annotationIds
            addUnresolvedInlineComment(threadKey, pageMode); // Emit the event to editor/renderer to reactivate the annotationId
            if (!isDatabaseOrWhiteboard && commentType === (0, $8i27m.CommentType).INLINE) {
                if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $g0DaR.unresolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
                else if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                        [threadKey]: {
                            id: threadKey,
                            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                            state: (0, $cUycv.AnnotationMarkStates).ACTIVE
                        }
                    });
                } else {
                    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                    emitter.emit('unresolve', threadKey);
                }
            } // Update the state for panel experience (legacy only)
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $3ZsvI.reopenCommentInDataMap)(commentsDataMap, commentType, threadKey, addNewCommentThreads);
                else {
                    const commentsDataMapClone = {
                        ...commentsDataMap
                    };
                    const commentInMap = commentsDataMapClone[commentType][threadKey];
                    if (commentInMap) {
                        commentInMap.isOpen = true;
                        commentInMap.wasRemovedByAnotherUser = false;
                        const commentLocation = commentInMap.location;
                        if (commentLocation && 'commentResolveProperties' in commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = false;
                        if (commentLocation && 'inlineResolveProperties' in commentLocation && commentLocation.inlineResolveProperties && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) commentLocation.inlineResolveProperties.resolved = false;
                        addNewCommentThreads(commentsDataMapClone);
                    }
                }
            } // Show the reopen flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage($dbdd2e782e37c476$var$i18n.commentReopenedFlagTitle),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            const isDangling = inlineCommentlocation?.inlineResolveProperties?.isDangling;
                            let currentViewValue = undefined; // just in case the user closed the panel after flag is displayed but before the action is taken, we'll want to reopen the panel again
                            // TOFIX: isCommentsPanelShown is still true after the panel is closed so we'll omit this check for now
                            if (isDangling && isNewDanglingCommentExperienceEnable) {
                                setCurrentView((0, $3mVfX.ViewValues).DELETED_CONTENT);
                                currentViewValue = (0, $3mVfX.ViewValues).DELETED_CONTENT;
                            } else if (isCommentsPanelShown) {
                                setCurrentView((0, $3mVfX.ViewValues).OPEN);
                                currentViewValue = (0, $3mVfX.ViewValues).OPEN;
                            } // Call navigation with view change waiting for reopen flow
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: commentType === (0, $8i27m.CommentType).INLINE ? 'INLINE' : 'FOOTER',
                                annotationClicked: true,
                                expectedView: currentViewValue,
                                commentId: commentId
                            });
                            if (commentType === (0, $8i27m.CommentType).INLINE || commentType === (0, $8i27m.CommentType).GENERAL) setCurrentlySelectedThreadKey(threadKey);
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleResolveCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            if (commentType === (0, $8i27m.CommentType).INLINE) {
                if (isDatabaseOrWhiteboard && (0, $9wGTI.fg)('cc-whiteboards-consolidating-comments')) {
                    // add unresolved comment to whiteboard and database
                    const commentInMap = commentsDataMap[commentType][threadKey];
                    const commentLocation = commentInMap.location;
                    commentService.onReopenResolvedComment?.({
                        contentId: pageId,
                        referenceId: commentLocation.inlineMarkerRef
                    });
                }
                const orderedActiveAnnotationIds = orderedActiveAnnotationIdList.map((annotation)=>annotation.threadKey); // only insert reopened comment annotation if the comment highlight exists
                if (!resolveProperties?.isDangling) {
                    let annotationsList = annotations;
                    if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                        const annotationMarks = rendererActions?.getAnnotationMarks();
                        annotationsList = annotationMarks?.map((mark)=>mark.attrs.id) ?? [];
                    }
                    if (annotationsList.length > 0) (0, $g0DaR.insertReopenedCommentAnnotation)(annotationsList, threadKey, orderedActiveAnnotationIds, setOrderedActiveAnnotationIdList);
                }
            }
        }).catch(()=>{
            handleReopenMutationFailure({
                isCacheUpdateFailed: false
            });
        });
    };
    const resolveExperienceName = commentType === (0, $8i27m.CommentType).INLINE ? (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE);
    const handleResolveMutationFailure = (0, $42omo.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: resolveExperienceName,
            error: resolveError
        });
    }, [
        experienceTracker,
        resolveExperienceName
    ]);
    const resolveCommentsUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateResolveCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateResolveCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    let commentsDataManagerResolveUpdateFn = undefined;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) commentsDataManagerResolveUpdateFn = resolveCommentsUpdateFn; // FG enables new BE resolve comments endpoint
    const handleResolveComment = ()=>{
        if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
            // Optimistically mark the comment as resolved in the data map & update UI early (legacy only)
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) (0, $3ZsvI.resolveCommentInDataMap)(commentsDataMap, commentType, threadKey, addNewCommentThreads);
             // Optimistically mark the inline comment annotation as resolved
            if (!isDatabaseOrWhiteboard && commentType === (0, $8i27m.CommentType).INLINE) (0, $g0DaR.resolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
        } // NOTE: The RESOLVED experience is started in CommentActions.tsx
        resolveCommentFn({
            variables: {
                commentIds: [
                    commentId
                ],
                cloudId: cloudId
            },
            update: commentsDataManagerResolveUpdateFn || ((cache, { data: data })=>{
                (0, $3ZsvI.updateCommentsQueryCacheForResolve)({
                    cache: cache,
                    commentId: commentId,
                    query: (0, $b1hSc.default),
                    queryVariables: (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                        pageId: pageId,
                        type: commentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : undefined // If we have footer, always write to footer. Panel works either way
                    }),
                    cacheUpdateFailed: cacheUpdateFailed,
                    setCacheUpdateFailed: setCacheUpdateFailed,
                    source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                    logger: $dbdd2e782e37c476$var$logger
                });
                if (!isReply && comment.type === (0, $8i27m.CommentType).GENERAL) try {
                    const { confluence_resolveComments: confluence_resolveComments } = data;
                    if (!confluence_resolveComments) return;
                    const { commentResolutionStates: commentResolutionStates, success: success } = confluence_resolveComments;
                    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
                    if (!success || commentResolutionStates === null || commentResolutionStates.length === 0) return;
                    const firstState = commentResolutionStates[0];
                    if (!firstState) return;
                    const { commentId: commentId } = firstState;
                    const prevData = (0, $l1uFv.readQueryInterop)({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: contentId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        }
                    });
                    const edges = prevData?.comments?.edges; // Filter out all comments related to the parent and it's children as they will all be resolved
                    const newEdges = edges?.filter((edge)=>edge?.node?.id !== commentId && !edge?.node?.ancestors.map((a)=>a?.id).includes(commentId)) || [];
                    const newData = {
                        comments: {
                            ...prevData?.comments,
                            totalCount: newEdges.length,
                            pageInfo: {
                                ...prevData?.comments?.pageInfo,
                                endCursor: '',
                                hasNextPage: false //set hasNextPage to always false to avoid performing incremental fetching again which will result in duplicate data
                            },
                            edges: newEdges
                        },
                        content: {
                            ...prevData?.content,
                            nodes: [
                                ...prevData?.content?.nodes || []
                            ]
                        },
                        user: {
                            ...prevData?.user
                        }
                    };
                    (0, $fEmGS.writeQueryInterop)({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: contentId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...newData
                        }
                    });
                } catch (err) {
                    $dbdd2e782e37c476$var$logger.error`An error occurred when updating cache for general comments resolve - ${err}`;
                    if (!(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // CommentsSectionQuery is being deprecated. `readQuery` will throw error
                    // if a matching cache entry is not present. This won't break any user experience.
                    // However, setCacheUpdateFailed(true) will trigger a refetch of ActiveCommentsQuery,
                    // whose result, with optimistic resolve, will include the newly resolved comment.
                    // This causes comments panel to show the resolved comment. So skipping it here.
                    setCacheUpdateFailed(true);
                }
            }),
            // When a `optimisticResponse` is set, useMutation invokes the update function twice:
            // first immediately, and after mutation succeeds, a second time. If mutation fails,
            // the cache updated by the update function is rolled back. Thus, this optimistic
            // resolve works both when cc_comments_new_comments_data_manager is ON and OFF.
            optimisticResponse: (0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false) ? {
                confluence_resolveComments: {
                    commentResolutionStates: [
                        {
                            commentId: commentId,
                            status: true,
                            resolveProperties: {
                                // These 2 values will be updated to the correct value after mutation succeeds.
                                // - `resolvedUser` is only displayed in comments panel Resolved view,
                                //   inside a tooltip when hovered.
                                // - `resolvedFriendlyDate` is only used when confluence_frontend_content_wrapper
                                //   is off; otherwise `resolvedTime` is used.
                                // So setting them as empty optimistically won't affect the static UI.
                                resolvedUser: null,
                                resolvedFriendlyDate: '',
                                resolvedTime: Date.now(),
                                __typename: 'InlineCommentResolveProperties'
                            },
                            __typename: 'ConfluenceCommentResolutionState'
                        }
                    ],
                    success: true,
                    errors: [],
                    __typename: 'ConfluenceResolveCommentsPayload'
                } // typed as any because optimisticResponse is provided only for the resolve comment mutation
            } : undefined
        }).then(()=>{
            if (!(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // Update the state for panel experience when optimistic resolve is disabled
            // If enabled, this has been done before the mutation succeeds.
            {
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $3ZsvI.resolveCommentInDataMap)(commentsDataMap, commentType, threadKey, addNewCommentThreads);
                    else {
                        const commentsDataMapClone = {
                            ...commentsDataMap
                        };
                        const commentInMap = commentsDataMapClone[commentType][threadKey];
                        if (commentInMap) {
                            commentsDataMapClone[commentType][threadKey].isOpen = false;
                            const commentLocation = commentsDataMapClone[commentType][threadKey].location;
                            if (commentLocation && commentLocation.inlineResolveProperties) commentLocation.inlineResolveProperties.resolved = true;
                            if (commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = true;
                            addNewCommentThreads(commentsDataMapClone);
                        }
                    }
                }
            } // Update content types comment service if we are resolving a comment
            commentService.onResolveComment?.(threadKey);
            if (commentType === (0, $8i27m.CommentType).INLINE || !(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // (Putting this behind the experiment just in case.)
            // This handles INLINE comment annotation. No need to invoke it for GENERAL comment.
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: threadKey,
                pageId: pageId,
                pageMode: pageMode,
                commentType: commentType,
                eventEmitter: eventEmitter,
                source: (0, $en1dX.AnalyticsSource).COMMENTS_PANEL,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                createAnalyticsEvent: createAnalyticsEvent,
                setEditorViewProps: setEditorViewProps //getInlineNodeTypes  // TODO: Figure out how to get this info
            });
            setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== threadKey)); // Show the resolved flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).RESOLVED
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: commentType === (0, $8i27m.CommentType).INLINE ? 'INLINE' : 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).RESOLVED,
                                commentId: commentId
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            handleReopenComment();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            experienceTracker.succeed({
                name: resolveExperienceName
            });
        }).catch((err)=>{
            if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                // Undo resolving the comment when optimistic resolve is enabled (legacy only)
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) (0, $3ZsvI.reopenCommentInDataMap)(commentsDataMap, commentType, threadKey, addNewCommentThreads);
                 // Undo resolving the inline comment annotation
                if (!isDatabaseOrWhiteboard && commentType === (0, $8i27m.CommentType).INLINE) (0, $g0DaR.unresolveInlineCommentAnnotation)(threadKey, pageMode, eventEmitter);
                 // Show an error flag to user when resolve fails
                flags?.showErrorFlag({
                    id: commentId,
                    title: formatMessage((0, $9CnRS.i18n).resolveErrorTitle),
                    description: formatMessage((0, $9CnRS.i18n).resolveError)
                });
            }
            handleResolveMutationFailure(err);
        });
    }; // Update refs to break circular dependency
    handleResolveCommentRef.current = handleResolveComment;
    handleReopenCommentRef.current = handleReopenComment;
    const pageType = pageInfo?.type ?? ''; // Editor setup
    const spaceId = pageInfo?.space?.id ?? ''; // User page permissions
    const operations = pageInfo?.operations || []; // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType); // We only want to focus resolved comments because the 'active' comments have
    // their own treatment for when one is hovered/selected and could cause weird behavior
    const isCommentFocused = resolveProperties?.resolved && commentId === focusedCommentId;
    const supportedActions = !isReply && isCommentRemovedByAnotherUser ? [
        'reopen'
    ] : supportedTopLevelActions;
    const shouldShowLeftBorder = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? commentHandlesPadding && commentId === editCommentId && isReply && !isLastUnnestableReply : commentHandlesPadding && !isStandaloneComment && commentId === editCommentId && isReply;
    const handleStandaloneReply = (id)=>{
        replyToComment && replyToComment(id, comment);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            commentHandlesPadding && "_19bv1ejb _n3tdu2gc",
            commentHandlesPadding && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19bvpxbi",
            commentHandlesPadding && isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_18u0utpp",
            shouldShowLeftBorder && "_1kl711qs",
            shouldShowLeftBorder && (0, $9wGTI.fg)('confluence_comment_border_migration') && "_1kl71h4i"
        ])
    }, commentId === editCommentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auGhu.EditComment), {
        pageId: pageId,
        pageType: pageType,
        annotationId: threadKey,
        commentId: commentId,
        spaceId: spaceId,
        content: content ?? '',
        isReply: isReply,
        displayCommentInViewMode: exitCommentEditor,
        avatarUrl: topCommentUserAvatar ?? '',
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate ?? '',
        resolveProperties: resolveProperties,
        mode: pageMode === (0, $cD1qu.PageMode).VIEW ? 'view' : 'edit',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        isCommentsPanel: isCommentsPanelShown,
        commentType: commentType,
        isStandaloneComment: isStandaloneComment,
        isOffline: isOffline,
        isLastUnnestableReply: isLastUnnestableReply,
        hasParentMaxHeight: hasParentMaxHeight,
        numReplies: numReplies
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEmgx.CommentBody), {
        mode: "view",
        userId: userId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAt: createdAt ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName,
        versionDate: versionDate ?? '',
        pageId: pageId,
        pageType: pageType,
        commentId: commentId ?? '',
        isReply: isReply,
        isEdited: isEdited,
        parentCommentId: parentCommentId,
        permissions: permissions,
        content: content ?? '',
        permissionType: permissionType ?? undefined,
        supportedActions: supportedActions,
        deleteComment: commentType === (0, $8i27m.CommentType).INLINE ? handleDeleteInlineComment : handleDeleteGeneralComment,
        editComment: handleEditComment,
        resolveComment: handleResolveComment,
        numReplies: numReplies,
        isUnread: isUnread,
        isCommentActive: true,
        hideAiSuggestEdit: currentView === (0, $3mVfX.ViewValues).RESOLVED || currentView === (0, $3mVfX.ViewValues).DELETED_CONTENT,
        isCommentsPanel: true,
        isHovered: isHovered,
        isResolvedByAnotherUser: isResolvedByAnotherUser,
        isFocused: isCommentFocused,
        isOffline: isOffline,
        resolveProperties: resolveProperties,
        annotationId: threadKey,
        annotatedText: annotatedText,
        reopenComment: handleReopenComment,
        replyToComment: isStandaloneComment ? handleStandaloneReply : handleReplyToComment,
        inheritedReactionsData: inheritedReactionsData,
        isDeletedByAnotherUser: isDeletedByAnotherUser,
        currentlySelectedThreadKey: currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        isAnnotatedTextPressed: isAnnotatedTextPressed,
        setAnnotatedTextPressed: setAnnotatedTextPressed,
        commentType: commentType,
        adjustForNestedReplies: adjustForNestedReplies,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isThreadHovered: isThreadHovered,
        isParentCommentOpen: isParentCommentOpen,
        reactionsCacheUpdateFn: updateReactionsCacheFn,
        isStandaloneComment: isStandaloneComment,
        showRepliesWithCurvedBorders: showRepliesWithCurvedBorders,
        onRendered: onRendered
    }));
};
module.exports["Comment"] = $dbdd2e782e37c476$export$4d299b491347818a;

});

parcelRegister("6hV0F", function(module, exports) {
/**
 * @generated SignedSource<<5b7dc925798f0e1a955da69f0b805b7a>>
 * @relayHash 7aa392ac24b60ca30af878bca1c734bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7732d40cfe8a07c6480c6fa88698f2b50d6f208bd2caeb687fa3bafbe1f452fd
const $eaa0b5bea1a46072$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7aa392ac24b60ca30af878bca1c734bb",
            "id": "7732d40cfe8a07c6480c6fa88698f2b50d6f208bd2caeb687fa3bafbe1f452fd",
            "metadata": {},
            "name": "CommentDeleteGeneralCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CommentDeleteGeneralCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$eaa0b5bea1a46072$var$node.hash = "21ca12d96d4a730277a95bbc05c15c9c";
var $eaa0b5bea1a46072$export$2e2bcd8739ae039 = $eaa0b5bea1a46072$var$node;
module.exports["default"] = $eaa0b5bea1a46072$export$2e2bcd8739ae039;

});

parcelRegister("iRmLY", function(module, exports) {
/**
 * @generated SignedSource<<5aad8dc5c2ad1f82d82fcffabd7eebfd>>
 * @relayHash 89c9c6606c3cc7f9e98c234f63e138f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 53dad722b9392cc0d8fb000b7813f8dc5b4c5bbea45d2a785e57afe7c6db80c4
const $2ae18362ec7f1758$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentDeleteInlineCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentDeleteInlineCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "89c9c6606c3cc7f9e98c234f63e138f9",
            "id": "53dad722b9392cc0d8fb000b7813f8dc5b4c5bbea45d2a785e57afe7c6db80c4",
            "metadata": {},
            "name": "CommentDeleteInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CommentDeleteInlineCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$2ae18362ec7f1758$var$node.hash = "985100db430c5b7c44c5f1e2701cbfdc";
var $2ae18362ec7f1758$export$2e2bcd8739ae039 = $2ae18362ec7f1758$var$node;
module.exports["default"] = $2ae18362ec7f1758$export$2e2bcd8739ae039;

});

parcelRegister("5858y", function(module, exports) {
/**
 * @generated SignedSource<<b1218db97686153aa85d8f50bca2b52d>>
 * @relayHash 8e5e866c8ce8d1cb963ef62edd739b94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 18a27afe1a8aa48e2b295eb57b00b2804ec99dd028f5aa61b14ebdb521b94793
const $cd762cea5f448981$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteInlineComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentDeleteInlineCommentMutationWithStepMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentDeleteInlineCommentMutationWithStepMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8e5e866c8ce8d1cb963ef62edd739b94",
            "id": "18a27afe1a8aa48e2b295eb57b00b2804ec99dd028f5aa61b14ebdb521b94793",
            "metadata": {},
            "name": "CommentDeleteInlineCommentMutationWithStepMutation",
            "operationKind": "mutation",
            "text": "mutation CommentDeleteInlineCommentMutationWithStepMutation($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}"
        }
    };
}();
$cd762cea5f448981$var$node.hash = "8bc2a29aa8ca1e95a28cad450493e297";
var $cd762cea5f448981$export$2e2bcd8739ae039 = $cd762cea5f448981$var$node;
module.exports["default"] = $cd762cea5f448981$export$2e2bcd8739ae039;

});

parcelRegister("4cf5h", function(module, exports) {
/**
 * @generated SignedSource<<5df2d3f9147e3b8ffed415db5bea1cb5>>
 * @relayHash b166cb02008e1ced909e66efb1618724
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f20db408527e12b3b82266fb8dbd13b035a569d68a64e5fcf9e00d7df264ab4
const $6afe964f7c8584f2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ReopenCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b166cb02008e1ced909e66efb1618724",
            "id": "7f20db408527e12b3b82266fb8dbd13b035a569d68a64e5fcf9e00d7df264ab4",
            "metadata": {},
            "name": "CommentReopenCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CommentReopenCommentMutation($commentId:ID!,$cloudId:ID!){confluence_reopenComment(commentId:$commentId,cloudId:$cloudId){success,commentResolutionStates{commentId,status},errors{message,extensions{...on ReopenCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$6afe964f7c8584f2$var$node.hash = "119c695b9232d3c254c219ff60606f0d";
var $6afe964f7c8584f2$export$2e2bcd8739ae039 = $6afe964f7c8584f2$var$node;
module.exports["default"] = $6afe964f7c8584f2$export$2e2bcd8739ae039;

});

parcelRegister("hznSr", function(module, exports) {
/**
 * @generated SignedSource<<ced4a23cf94847bcf809500c687ee9bd>>
 * @relayHash fcfc2d9b0f804b2483ddcf7145a681dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 724c9c43713dcdc68803fcd115dbe1babe7be82cef5185aa9a634678ac1544a4
const $0748a08963961eeb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentIds"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentIds",
            "variableName": "commentIds"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "resolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedFriendlyDate"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ResolveCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fcfc2d9b0f804b2483ddcf7145a681dc",
            "id": "724c9c43713dcdc68803fcd115dbe1babe7be82cef5185aa9a634678ac1544a4",
            "metadata": {},
            "name": "CommentResolveCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CommentResolveCommentMutation($commentIds:[ID]!,$cloudId:ID!){confluence_resolveComments(commentIds:$commentIds,cloudId:$cloudId){success,commentResolutionStates{commentId,resolveProperties{resolvedTime,resolvedUser,resolvedFriendlyDate},status},errors{message,extensions{...on ResolveCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$0748a08963961eeb$var$node.hash = "a1e79d6cdf36db4379af2bb6df78c060";
var $0748a08963961eeb$export$2e2bcd8739ae039 = $0748a08963961eeb$var$node;
module.exports["default"] = $0748a08963961eeb$export$2e2bcd8739ae039;

});

parcelRegister("1YPul", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $77145f754114b981$export$d4c72bab9d6cc13a = {
    updateDocumentFn: ()=>{}
};
const $77145f754114b981$export$e324594224ef24da = {
    setUpdateDocumentFn: (newUpdateDocumentFn)=>({ setState: setState })=>{
            setState({
                updateDocumentFn: newUpdateDocumentFn
            });
        }
};
const $77145f754114b981$export$bca0c556b0ff9d9c = (0, $1P1Tu.createStore)({
    initialState: $77145f754114b981$export$d4c72bab9d6cc13a,
    actions: $77145f754114b981$export$e324594224ef24da,
    name: 'UpdateDocumentStore'
});
const $77145f754114b981$export$5e7505d6571fe99d = (0, $9zUhf.createHook)($77145f754114b981$export$bca0c556b0ff9d9c);
const $77145f754114b981$export$25ca074c0dbf9075 = (0, $9zUhf.createActionsHook)($77145f754114b981$export$bca0c556b0ff9d9c);
module.exports["useUpdateDocument"] = $77145f754114b981$export$5e7505d6571fe99d;
module.exports["useUpdateDocumentActions"] = $77145f754114b981$export$25ca074c0dbf9075;

});

parcelRegister("8z9UY", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $651b67533e11f043$export$26bc7a3bb70e176c = /*#__PURE__*/ function(CommentDeletionLocation) {
    CommentDeletionLocation["EDITOR"] = "EDITOR";
    CommentDeletionLocation["LIVE"] = "LIVE";
    return CommentDeletionLocation;
}({});
module.exports["CommentDeletionLocation"] = $651b67533e11f043$export$26bc7a3bb70e176c;

});

parcelRegister("3s9yq", function(module, exports) {

var $4gWyR = parcelRequire("4gWyR");

const $dc6096cce6b3b96b$export$8c4bf31cea6aa53c = (0, $4gWyR.default);
module.exports["InlineCommentsQuery"] = $dc6096cce6b3b96b$export$8c4bf31cea6aa53c;

});

parcelRegister("4gWyR", function(module, exports) {
/**
 * @generated SignedSource<<364e9e6e981281c5a3861630529ba27d>>
 * @relayHash b1e02ca7b094a1ff9aaf5a6b5ddc5a29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506
const $ed32661450888f95$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "pageId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    },
                    v3 /*: any*/ 
                ]
            }
        ]
    }, v5 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    }, v23 = {
        "kind": "ScalarField",
        "name": "number"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v25 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v28 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v30 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v2 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v29 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v32 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsQuery",
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v24 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsQuery",
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v30 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b1e02ca7b094a1ff9aaf5a6b5ddc5a29",
            "id": "9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506",
            "metadata": {},
            "name": "InlineCommentsQuery",
            "operationKind": "query",
            "text": "query InlineCommentsQuery($pageId:ID!)@allowHigherTimeout{content(id:$pageId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$ed32661450888f95$var$node.hash = "82d41657ba53df28146f886f7478ca62";
var $ed32661450888f95$export$2e2bcd8739ae039 = $ed32661450888f95$var$node;
module.exports["default"] = $ed32661450888f95$export$2e2bcd8739ae039;

});

parcelRegister("aMfLn", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $kDIns = parcelRequire("kDIns");

const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};
module.exports["updateRendererAnnotations"] = $194c389c7ab5ab2c$export$bbbd7ccaedea9691;
module.exports["constructStepForGql"] = $194c389c7ab5ab2c$export$2600439b3e609c06;

});

parcelRegister("daq5m", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $77XlC = parcelRequire("77XlC");


var $aFLCH = parcelRequire("aFLCH");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cUiCf = parcelRequire("cUiCf");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $8jHAi = parcelRequire("8jHAi");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $1YXTQ = parcelRequire("1YXTQ");


var $gvWVt = parcelRequire("gvWVt");


var $6faGq = parcelRequire("6faGq");


var $7tI6B = parcelRequire("7tI6B");


var $9wGTI = parcelRequire("9wGTI");


var $3ejfs = parcelRequire("3ejfs");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $6b5EI = parcelRequire("6b5EI");


var $cWhxr = parcelRequire("cWhxr");


var $lRNq8 = parcelRequire("lRNq8");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery = (0, $aFLCH.default);
const $005e7fbdd3b99ea0$var$CommentAuthorUserQuery = (0, $77XlC.default);
const $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply, isStandaloneComment: isStandaloneComment, isFooterComment: isFooterComment })=>{
    if (isFixedEditStyles) {
        const negativeMarginForEditMode = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? '-16px' : '-24px';
        return commentMode === 'edit' ? isReply || isStandaloneComment || isFooterComment ? '0' : negativeMarginForEditMode : undefined;
    }
    return commentMode === 'reply' ? '-2px' : 'inherit';
};
const $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply })=>{
    if (isFixedEditStyles) return commentMode === 'edit' ? isReply ? '8px' : '12px' : undefined;
    return commentMode === 'view' ? undefined : '8px';
};
const $005e7fbdd3b99ea0$var$authorContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$AuthorContainer = (props)=>{
    const { commentMode: _commentMode, isReply: _isReply, isStandaloneComment: _isStandaloneComment, isFooterComment: _isFooterComment, isFixedEditStyles: _isFixedEditStyles, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            marginLeft: $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft(props),
            paddingBottom: $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom(props)
        },
        ...rest,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1ul9idpf _jva41snc _uvzw1snc _wkreagmp _12rjagmp _gcmzvv82 _1vjrvv82 _5xy14viv _1dtc4viv _1msj4viv"
        ])
    });
};
const $005e7fbdd3b99ea0$var$avatarWrapperBaseStyles = null;
const $005e7fbdd3b99ea0$var$avatarSmallPaddingStyles = null;
const $005e7fbdd3b99ea0$var$avatarLargePaddingStyles = null;
const $005e7fbdd3b99ea0$var$AvatarWrapper = ({ isCommentsTuneupActive: isCommentsTuneupActive, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            !isCommentsTuneupActive && (isCommentsPanel || isFooterComment || isFixedEditStyles) ? "_u5f312x7" : "_u5f3u2gc"
        ])
    });
};
const $005e7fbdd3b99ea0$var$containerStyles = null;
const $005e7fbdd3b99ea0$var$Container = ({ useProfileLinkStyle: useProfileLinkStyle, useColumnStyle: useColumnStyle, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9idpf _14yyfhey _hwn17g83 _1msj4viv _5xy14viv _1dtc4viv _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5azsu _1ptk1j28 _19gdazsu _1gidazsu _1e6pazsu",
            useProfileLinkStyle && "_zulpu2gc _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _4cvr1q9y _1ul9idpf",
            useColumnStyle && "_zulpidpf _2lx21bp4 _4cvr1y6m"
        ])
    });
};
const $005e7fbdd3b99ea0$var$newPageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative'
}); // TODO: remove the following 3 styles when cleaning up `confluence_frontend_content_wrapper` flag
const $005e7fbdd3b99ea0$var$resolvedPropertiesStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $005e7fbdd3b99ea0$var$pageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025'
});
const $005e7fbdd3b99ea0$var$generalCommentFooterStyle = (0, $ecnYn.xcss)({
    top: 'space.negative.050'
});
const $005e7fbdd3b99ea0$var$profileLinkContainerStyle = null;
const $005e7fbdd3b99ea0$var$profileLinkContainerColumnStyle = null;
const $005e7fbdd3b99ea0$var$truncateTextStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: '1 1 0%',
    wordBreak: 'unset'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $005e7fbdd3b99ea0$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$var$dateContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerStandaloneStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerSubtlestStyles = null;
const $005e7fbdd3b99ea0$var$DateContainer = ({ isStandaloneComment: isStandaloneComment, isCommentsPanel: isCommentsPanel, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _2lx2n7od _4cvrn7od _102ewadc _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _7wy0glyw _1plv1j28 _zmp8azsu _1blwazsu _9b8iazsu _1kcs1y54",
            isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_2lx21bp4 _4cvr1y6m",
            (isStandaloneComment || isCommentsPanel && isFixedEditStyles) && "_syaz1rpy"
        ])
    });
}; // confluence_comments_cohiti_date_tooltips exp evaluations will use this component-level i18n object instead of commentsI18n
const $005e7fbdd3b99ea0$var$i18n = (0, $aXWIB.defineMessages)({
    defaultTooltip: {
        id: "inline-comments-common.date-tooltip.default",
        defaultMessage: "Added on {date} at {timestamp}"
    },
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    },
    resolvedTooltip: {
        id: "inline-comments-common.date-tooltip.resolved",
        defaultMessage: "Resolved by {username} on {date} at {timeStamp}"
    },
    reopenedTooltip: {
        id: "inline-comments-common.date-tooltip.reopened",
        defaultMessage: "Reopened by {username} on {date} at {timeStamp}"
    },
    reopenedDateInfoText: {
        id: "inline-comments-common.reopened.date.info.text",
        defaultMessage: "Reopened {timeAgo}{timeStamp, select,\n\t\t\tundefined {}\n\t\t\tother { at {timeStamp}}\n\t\t}"
    },
    resolvedDateInfoText: {
        id: "inline-comments-common.resolved.date.info.text",
        defaultMessage: "Resolved {timeAgo}"
    }
});
const $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, createdAtNonLocalized: createdAtNonLocalized, size: size, displayName: displayName, avatarUrl: avatarUrl, commentDateUrl: commentDateUrl, commentId: commentId, permissionType: permissionType, isInactiveComment: isInactiveComment, showCopyLink: showCopyLink = false, resolveProperties: resolveProperties, isCommentsPanel: isCommentsPanel = false, isGeneralComments: isGeneralComments = false, isReply: isReply = false, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false })=>{
    const skipUserIdPath = Boolean(avatarUrl && displayName || !userId || commentId);
    const { data: authorData } = (0, $jMyy4.useQueryInterop)($005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery, {
        variables: {
            commentId: commentId
        },
        fetchPolicy: 'cache-and-network',
        skip: Boolean(userId || !commentId)
    });
    const { data: userDataFromOld } = (0, $jMyy4.useQueryInterop)($005e7fbdd3b99ea0$var$CommentAuthorUserQuery, {
        variables: {
            id: userId
        },
        fetchPolicy: 'cache-and-network',
        skip: skipUserIdPath || (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true)
    });
    const { data: userDataFromNew } = (0, $cUiCf.useCommentAuthorQuery)(userId ?? undefined, {
        skip: skipUserIdPath || !(0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true),
        fetchPolicy: 'cache-and-network'
    });
    const userData = (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true) ? userDataFromNew : userDataFromOld;
    const author = (authorData?.content?.nodes || [])[0]?.history?.createdBy;
    const userAvatar = author ? author.profilePicture?.path : (userData?.user?.photos || [])[0]?.value;
    const userDisplayName = author ? author.displayName : userData?.user?.displayName;
    const userAccountId = author?.accountId;
    const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const getTooltipContent = ()=>{
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            // resolveProperties.resolved = true -> comment is in resolved state
            // resolveProperties.resolved = false -> comment is in re-opened state
            const i18nMessage = resolveProperties?.resolved ? $005e7fbdd3b99ea0$var$i18n.resolvedTooltip : $005e7fbdd3b99ea0$var$i18n.reopenedTooltip;
            const resolvedTimeBase = new Date(resolveProperties.resolvedTime);
            return formatMessage(i18nMessage, {
                username: resolveProperties?.resolvedUser,
                date: intl.formatDate(resolvedTimeBase, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime(resolvedTimeBase, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            });
        }
        if (resolveProperties?.resolved) return formatMessage((0, $3ejfs.commentsi18n).resolvedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser
        });
        return formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser,
            createdAtNonLocalized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(createdAtNonLocalized),
                usePrepositions: true
            })
        });
    };
    const oldStandloneExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: resolveProperties?.resolvedFriendlyDate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                username: resolveProperties?.resolvedUser,
                friendlyDate: resolveProperties?.resolvedFriendlyDate
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
            username: resolveProperties?.resolvedUser,
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        }))));
    };
    const getResolvedDateInfoText = ()=>{
        // resolveProperties.resolved = true -> comment is in resolved state
        // resolveProperties.resolved = false -> comment is in re-opened state
        const i18nKey = resolveProperties?.resolved ? 'resolvedDateInfoText' : 'reopenedDateInfoText';
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            const resolvedTimeBase_0 = new Date(resolveProperties.resolvedTime);
            const twentyFourHourThreshold = 86400; // in seconds
            const secondsSinceReopen = (Date.now() - resolvedTimeBase_0.getTime()) / 1000; // Don't include a timestamp if the comment was re-opened less than 24 hours ago
            const shouldIncludeTimeStamp = secondsSinceReopen >= twentyFourHourThreshold;
            return formatMessage($005e7fbdd3b99ea0$var$i18n[i18nKey], {
                // use formatTimeAgo directly so that this string can be injected into aria-label,
                timeAgo: (0, $1YXTQ.formatTimeAgo)(intl, resolvedTimeBase_0, true, {}, userTimeZone, tenantTimeZone),
                timeStamp: shouldIncludeTimeStamp && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? intl.formatTime(resolvedTimeBase_0, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                }) : undefined
            });
        } else return formatMessage((0, $3ejfs.commentsi18n)[i18nKey], {
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        });
    };
    const newExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: getTooltipContent()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": getResolvedDateInfoText()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, getResolvedDateInfoText())));
    };
    const renderResolveInfo = ()=>{
        const standAloneExperience = !isFooterComment && !isCommentsPanel;
        if (standAloneExperience && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isFooterComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isCommentsPanel) return newExperienceResolveInfo();
        return oldStandloneExperienceResolveInfo();
    };
    const hasPageCommentIconEnabled = (0, $42omo.useCallback)(()=>{
        if (!isGeneralComments) return false;
        return !isFooterComment;
    }, [
        isGeneralComments,
        isFooterComment
    ]); // TODO: remove renderDateInfoOldExperience() when cleaning up `confluence_frontend_content_wrapper` flag
    const renderDateInfoOldExperience = (resolvedInfo)=>{
        return resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, resolvedInfo, hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $005e7fbdd3b99ea0$var$pageIconStyle,
                $005e7fbdd3b99ea0$var$resolvedPropertiesStyle,
                isFooterComment && $005e7fbdd3b99ea0$var$generalCommentFooterStyle
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date)
        }), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$pageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))));
    };
    const renderCopyButton = ()=>{
        const resolvedInfo_0 = renderResolveInfo();
        const renderCopyLinkButton = commentDateUrl && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && !isCommentsPanel;
        const timeAgoDate = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$DateContainer, {
            isStandaloneComment: isStandaloneComment,
            isCommentsPanel: isCommentsPanel,
            isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? resolvedInfo_0 : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true) ? formatMessage($005e7fbdd3b99ea0$var$i18n.defaultTooltip, {
                date: intl.formatDate((0, $6faGq.getValidDate)(timeAgoDate), {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timestamp: intl.formatTime((0, $6faGq.getValidDate)(timeAgoDate), {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            }) : undefined
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cWhxr.RelativeTimestamp), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        })), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$newPageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }))))) : renderDateInfoOldExperience(resolvedInfo_0), renderCopyLinkButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b5EI.CopyLinkButton), {
            visible: showCopyLink,
            textToCopy: linkToComment
        }));
    };
    const isDateShown = (commentMode === 'view' || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && date;
    const name = displayName || userDisplayName || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AuthorContainer, {
        commentMode: commentMode,
        isReply: isReply,
        isStandaloneComment: isStandaloneComment,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        "data-testid": "comment-author"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AvatarWrapper, {
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        isCommentsTuneupActive: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        isBlockLevel: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        userId: userId,
        src: avatarUrl || userAvatar,
        trigger: "click",
        size: size,
        name: name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lRNq8.MaybeTooltip), {
        date: date,
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$Container, {
        useProfileLinkStyle: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        useColumnStyle: !!(resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate) && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$ProfileLinkContainer, null, isInactiveComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "dummy-profile-link"
    }, displayName || userDisplayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
        fullName: displayName || userDisplayName,
        userId: userId || userAccountId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            wordBreak: 'break-word',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #292A2E)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $005e7fbdd3b99ea0$var$truncateTextStyle
        },
        isUnderlinedByDefault: false
    }), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && renderCopyButton())));
};
module.exports["CommentAuthor"] = $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7;

});

parcelRegister("77XlC", function(module, exports) {
/**
 * @generated SignedSource<<7f656897fe2d7584b434fb2f6d2810d8>>
 * @relayHash 7603ffb5cdb0040c872fb1a866b28175
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0
const $a4999a70afb18ca0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAuthorUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAuthorUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7603ffb5cdb0040c872fb1a866b28175",
            "id": "0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0",
            "metadata": {},
            "name": "CommentAuthorUserQuery",
            "operationKind": "query",
            "text": "query CommentAuthorUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4999a70afb18ca0$var$node.hash = "b941cc393296a840051106bc2b577a66";
var $a4999a70afb18ca0$export$2e2bcd8739ae039 = $a4999a70afb18ca0$var$node;
module.exports["default"] = $a4999a70afb18ca0$export$2e2bcd8739ae039;

});

parcelRegister("aFLCH", function(module, exports) {
/**
 * @generated SignedSource<<733f338222518407bee3f003b89a22ea>>
 * @relayHash 3fce16c4b50c6a412fa8487092b88148
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e22018d4069a45e8f6db8aee4f779ec3d1167f9f1b3abb3096b28120a93d6641
const $05493535de3a048c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3fce16c4b50c6a412fa8487092b88148",
            "id": "e22018d4069a45e8f6db8aee4f779ec3d1167f9f1b3abb3096b28120a93d6641",
            "metadata": {},
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "operationKind": "query",
            "text": "query CommentAuthorInlineCommentAuthorQuery($commentId:ID!){content(id:$commentId){nodes{id,history{createdBy{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}"
        }
    };
}();
$05493535de3a048c$var$node.hash = "7be748651ddc7f6e555a6f8193a7649c";
var $05493535de3a048c$export$2e2bcd8739ae039 = $05493535de3a048c$var$node;
module.exports["default"] = $05493535de3a048c$export$2e2bcd8739ae039;

});

parcelRegister("cUiCf", function(module, exports) {

var $kVisP = parcelRequire("kVisP");


var $jMyy4 = parcelRequire("jMyy4");

const $e7d88eb3577c40b3$export$81e6931b5465b2c6 = (0, $kVisP.default);
const $e7d88eb3577c40b3$export$15a9d6bfd715c3fb = (userId, options = {})=>{
    const { skip: skip = !userId, fetchPolicy: fetchPolicy = 'cache-and-network' } = options;
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($e7d88eb3577c40b3$export$81e6931b5465b2c6, {
        variables: {
            id: userId
        },
        fetchPolicy: fetchPolicy,
        skip: skip || !userId
    });
    const isReady = skip || !!data || !loading;
    return {
        data: data,
        loading: loading,
        isReady: isReady
    };
};
module.exports["useCommentAuthorQuery"] = $e7d88eb3577c40b3$export$15a9d6bfd715c3fb;

});

parcelRegister("kVisP", function(module, exports) {
/**
 * @generated SignedSource<<0723787bceb10bb2029b850fd50fd235>>
 * @relayHash d7dd18272a64084411071f3794bede2a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 034bbfdcc82ad8b892c7f2334d1da72b0bff1c2b16820174371933b530761c1d
const $a036ea87d0b71d0a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentAuthorQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentAuthorQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d7dd18272a64084411071f3794bede2a",
            "id": "034bbfdcc82ad8b892c7f2334d1da72b0bff1c2b16820174371933b530761c1d",
            "metadata": {},
            "name": "useCommentAuthorQuery",
            "operationKind": "query",
            "text": "query useCommentAuthorQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a036ea87d0b71d0a$var$node.hash = "5a28bff8b85798e31c8498c8ffd13edb";
var $a036ea87d0b71d0a$export$2e2bcd8739ae039 = $a036ea87d0b71d0a$var$node;
module.exports["default"] = $a036ea87d0b71d0a$export$2e2bcd8739ae039;

});

parcelRegister("jJK3p", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");

parcelRequire("5XsiK");
var $lfSOe = parcelRequire("lfSOe");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $aXWIB.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $aXWIB.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $4N3op.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $lfSOe.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");

parcelRequire("5XsiK");
var $lfSOe = parcelRequire("lfSOe");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $lfSOe.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== t0 || $[8] !== to) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            href: t0,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = t0;
        $[8] = to;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("8lYIw", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7fpiF = parcelRequire("7fpiF");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const $ = (0, $frIzR.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fpiF.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("7fpiF", function(module, exports) {

var $QU6QS = parcelRequire("QU6QS");


var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $22s37 = parcelRequire("22s37");




var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $dRnqM = parcelRequire("dRnqM");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $546d8f2c65102c44$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $546d8f2c65102c44$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
var $546d8f2c65102c44$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $546d8f2c65102c44$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $22s37.createLocation)(to, null, null, currentLocation) : to;
};
var $546d8f2c65102c44$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef === "undefined") $546d8f2c65102c44$var$forwardRef = $546d8f2c65102c44$var$forwardRefShim;
function $546d8f2c65102c44$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $546d8f2c65102c44$var$LinkAnchor = $546d8f2c65102c44$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $bDniu.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $7Q5yr.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$546d8f2c65102c44$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $546d8f2c65102c44$export$a6c7ac8248d6e38a = $546d8f2c65102c44$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $546d8f2c65102c44$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $bDniu.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var history = context.history;
        var location = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $7Q5yr.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $546d8f2c65102c44$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $22s37.createPath)(context.location) === (0, $22s37.createPath)($546d8f2c65102c44$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(component, props);
    });
});
var $546d8f2c65102c44$var$toType, $546d8f2c65102c44$var$refType;
var $546d8f2c65102c44$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef$1 === "undefined") $546d8f2c65102c44$var$forwardRef$1 = $546d8f2c65102c44$var$forwardRefShim$1;
function $546d8f2c65102c44$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $546d8f2c65102c44$export$b0d92dbee9b5b60d = $546d8f2c65102c44$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $bDniu.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $QU6QS.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $546d8f2c65102c44$var$joinClassnames(className, activeClassName);
            style = (0, $7Q5yr.default)({}, style, activeStyle);
        }
        var props = (0, $7Q5yr.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim$1 !== $546d8f2c65102c44$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($546d8f2c65102c44$export$a6c7ac8248d6e38a, props);
    });
});
var $546d8f2c65102c44$var$ariaCurrentType;
module.exports["Link"] = $546d8f2c65102c44$export$a6c7ac8248d6e38a;

});

parcelRegister("22s37", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $4B6DI = parcelRequire("4B6DI");


var $bjNrH = parcelRequire("bjNrH");



var $dRnqM = parcelRequire("dRnqM");

function $17c186b078d80207$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $17c186b078d80207$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $17c186b078d80207$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $17c186b078d80207$var$stripBasename(path, prefix) {
    return $17c186b078d80207$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $17c186b078d80207$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $17c186b078d80207$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $17c186b078d80207$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $17c186b078d80207$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $17c186b078d80207$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $7Q5yr.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $4B6DI.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $17c186b078d80207$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $bjNrH.default)(a.state, b.state);
}
function $17c186b078d80207$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $17c186b078d80207$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $17c186b078d80207$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $17c186b078d80207$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $17c186b078d80207$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $17c186b078d80207$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $17c186b078d80207$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $17c186b078d80207$var$PopStateEvent = 'popstate';
var $17c186b078d80207$var$HashChangeEvent = 'hashchange';
function $17c186b078d80207$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $17c186b078d80207$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $dRnqM.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $17c186b078d80207$var$supportsHistory();
    var needsHashChangeListener = !$17c186b078d80207$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($17c186b078d80207$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($17c186b078d80207$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($17c186b078d80207$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $17c186b078d80207$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $17c186b078d80207$var$HashChangeEvent$1 = 'hashchange';
var $17c186b078d80207$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $17c186b078d80207$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $17c186b078d80207$var$stripLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    },
    slash: {
        encodePath: $17c186b078d80207$var$addLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    }
};
function $17c186b078d80207$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $17c186b078d80207$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $17c186b078d80207$var$pushHashPath(path) {
    window.location.hash = path;
}
function $17c186b078d80207$var$replaceHashPath(path) {
    window.location.replace($17c186b078d80207$var$stripHash(window.location.href) + '#' + path);
}
function $17c186b078d80207$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $dRnqM.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $17c186b078d80207$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $17c186b078d80207$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($17c186b078d80207$var$getHashPath());
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $17c186b078d80207$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $17c186b078d80207$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $17c186b078d80207$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $17c186b078d80207$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $17c186b078d80207$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $17c186b078d80207$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $17c186b078d80207$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $17c186b078d80207$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $17c186b078d80207$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $17c186b078d80207$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $7Q5yr.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $17c186b078d80207$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, createKey()) : $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $17c186b078d80207$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $17c186b078d80207$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}
module.exports["createPath"] = $17c186b078d80207$export$fe53371bee54353d;
module.exports["createLocation"] = $17c186b078d80207$export$90c043f1c57770b8;
module.exports["createBrowserHistory"] = $17c186b078d80207$export$719fc203c4e16dee;
module.exports["createHashHistory"] = $17c186b078d80207$export$b71fdd3798280242;

});

parcelRegister("fs6LW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $ecnYn.xcss)({
        display: 'flex'
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $aXWIB.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $aXWIB.useIntl)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("7tI6B", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $89d6a09a4f827a20$export$8995abb8169b2cb8;

});

parcelRegister("6b5EI", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");


var $6F6hl = parcelRequire("6F6hl");


var $aHcFH = parcelRequire("aHcFH");


var $afGoD = parcelRequire("afGoD");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9CnRS = parcelRequire("9CnRS");

const $0220545780b126ac$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { visible: visible, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_v5641n2p _1e0c116y _4cvr1h6o _1bah1h6o _18u014y2 _tzy4idpf _t9ec1jvs _1mygkb7n _66dk1xty",
            __cmplp.visible && "_tzy4kb7n _t9ec1ygq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0220545780b126ac$var$CustomTooltipWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0220545780b126ac$var$CustomizedTooltipTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((t0, ref)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    const t1 = ref;
    let t2;
    if ($[3] !== children || $[4] !== rest || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$CustomTooltipWrapper, {
            ...rest,
            ref: t1
        }, children);
        $[3] = children;
        $[4] = rest;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
});
const $0220545780b126ac$export$da91d1846689786c = 'link-icon';
const $0220545780b126ac$export$9c785f85e6437122 = 'check-icon';
const $0220545780b126ac$export$266980ac2cfa7919 = 'legacy-clipboard-support';
const $0220545780b126ac$var$RESET_TIMEOUT = 5000;
const $0220545780b126ac$export$534d10f1c5b9c7b3 = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { visible: visible, textToCopy: textToCopy, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isCopied, setCopied] = (0, $42omo.useState)(false);
    const copyWrapperRef = (0, $42omo.useRef)(null);
    const cleanupTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditor = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = !(0, $aHcFH.isClipboardApiSupported)() && !(0, $aHcFH.isIEClipboardApiSupported)();
        $[0] = t1;
    } else t1 = $[0];
    const needRenderCopyArea = t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (needRenderCopyArea) copyWrapperRef.current = document.getElementById("copyWrapperRef");
        };
        t3 = [
            needRenderCopyArea
        ];
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[3] !== isCopied) {
        t4 = ()=>{
            if (isCopied) cleanupTimer.current = setTimeout(()=>setCopied(false), $0220545780b126ac$var$RESET_TIMEOUT);
            return ()=>clearTimeout(cleanupTimer.current);
        };
        t5 = [
            isCopied
        ];
        $[3] = isCopied;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== createAnalyticsEvent || $[7] !== isCopied || $[8] !== isEditor || $[9] !== isLivePage || $[10] !== textToCopy) {
        t6 = async (event)=>{
            event.stopPropagation();
            if (isCopied) return;
            if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(textToCopy);
            else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(textToCopy);
            else await (0, $aHcFH.legacyCopyToClipboard)(textToCopy, copyWrapperRef.current);
            const pageMode = (isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER).toLowerCase();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: isEditor ? "editPageScreen" : "viewPageScreen",
                    action: "clicked",
                    actionSubject: "copyCommentLink",
                    attributes: {
                        pageMode: pageMode
                    }
                }
            }).fire();
            setCopied(true);
        };
        $[6] = createAnalyticsEvent;
        $[7] = isCopied;
        $[8] = isEditor;
        $[9] = isLivePage;
        $[10] = textToCopy;
        $[11] = t6;
    } else t6 = $[11];
    const handleButtonClick = t6;
    let t7;
    if ($[12] !== formatMessage || $[13] !== isCopied) {
        t7 = isCopied ? formatMessage((0, $9CnRS.i18n).linkCopiedTooltip) : formatMessage((0, $9CnRS.i18n).copyLinkTooltip);
        $[12] = formatMessage;
        $[13] = isCopied;
        $[14] = t7;
    } else t7 = $[14];
    const tooltipContent = t7;
    let t8;
    if ($[15] !== formatMessage || $[16] !== isCopied) {
        t8 = !isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $9CnRS.i18n).copyLinkTooltip),
            testId: $0220545780b126ac$export$da91d1846689786c,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            label: formatMessage((0, $9CnRS.i18n).linkCopiedTooltip),
            color: "var(--ds-icon-success, #6A9A23)",
            testId: $0220545780b126ac$export$9c785f85e6437122,
            spacing: "spacious"
        });
        $[15] = formatMessage;
        $[16] = isCopied;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== handleButtonClick || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            "data-cy": "inline-comment-time-link",
            iconBefore: t8,
            onClick: handleButtonClick,
            spacing: "none"
        });
        $[18] = handleButtonClick;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t9 || $[22] !== tooltipContent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            position: "top",
            tag: $0220545780b126ac$var$CustomizedTooltipTag,
            hideTooltipOnClick: true
        }, t9);
        $[21] = t9;
        $[22] = tooltipContent;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== children) {
        t11 = needRenderCopyArea && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            testId: $0220545780b126ac$export$266980ac2cfa7919,
            id: "copyWrapperRef"
        }, children);
        $[24] = children;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t10 || $[27] !== t11 || $[28] !== visible) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$Wrapper, {
            visible: visible
        }, t10, t11);
        $[26] = t10;
        $[27] = t11;
        $[28] = visible;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
};
module.exports["CopyLinkButton"] = $0220545780b126ac$export$534d10f1c5b9c7b3;

});

parcelRegister("cWhxr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $917iu = parcelRequire("917iu");

var $8uR5k = parcelRequire("8uR5k");

var $d6omw = parcelRequire("d6omw");

var $lvvx5 = parcelRequire("lvvx5");

const $677d422179b5c9e8$var$messages = (0, $aXWIB.defineMessages)({
    now: {
        id: "inline-comments-common.relative-timestamp.now",
        defaultMessage: "Now"
    }
});
const $677d422179b5c9e8$export$705da3a6fb3571ab = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { date: date } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const now = new Date();
    const diffInMinutes = (0, $d6omw.default)(now, date);
    const diffInHours = (0, $8uR5k.default)(now, date);
    const diffInDays = (0, $917iu.default)(now, date);
    const diffInWeeks = (0, $lvvx5.default)(now, date);
    if (diffInMinutes < 2) {
        let t1;
        if ($[0] !== intl) {
            t1 = intl.formatMessage($677d422179b5c9e8$var$messages.now);
            $[0] = intl;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (diffInMinutes < 60) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedNumber), {
        value: diffInMinutes,
        style: "unit",
        unit: "minute",
        unitDisplay: "narrow"
    });
    if (diffInHours < 24) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedNumber), {
        value: diffInHours,
        style: "unit",
        unit: "hour",
        unitDisplay: "narrow"
    });
    if (diffInWeeks < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedNumber), {
        value: diffInDays,
        style: "unit",
        unit: "day",
        unitDisplay: "narrow"
    });
    const currentYear = now.getFullYear();
    const dateYear = date.getFullYear();
    if (currentYear === dateYear) {
        let t1;
        if ($[4] !== date || $[5] !== intl) {
            t1 = intl.formatDate(date, {
                month: "short",
                day: "numeric"
            });
            $[4] = date;
            $[5] = intl;
            $[6] = t1;
        } else t1 = $[6];
        let t2;
        if ($[7] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
            $[7] = t1;
            $[8] = t2;
        } else t2 = $[8];
        return t2;
    }
    let t1;
    if ($[9] !== date || $[10] !== intl) {
        t1 = intl.formatDate(date, {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
        $[9] = date;
        $[10] = intl;
        $[11] = t1;
    } else t1 = $[11];
    let t2;
    if ($[12] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};
module.exports["RelativeTimestamp"] = $677d422179b5c9e8$export$705da3a6fb3571ab;

});

parcelRegister("lvvx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa84f3f15ff2b5dc$export$2e2bcd8739ae039);

var $917iu = parcelRequire("917iu");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $fa84f3f15ff2b5dc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $917iu.default)(dateLeft, dateRight) / 7;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("lRNq8", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");


var $gdv5Z = parcelRequire("gdv5Z");


var $6faGq = parcelRequire("6faGq");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $82d0090970c55653$var$styles = {
    tooltipWrapper: "_1ul9idpf"
};
const $82d0090970c55653$var$i18n = (0, $aXWIB.defineMessages)({
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    }
});
const $82d0090970c55653$export$8d25ba73a810c5c5 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, date: date, name: name } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    let t1;
    if ($[0] !== children || $[1] !== date || $[2] !== formatMessage || $[3] !== intl || $[4] !== name || $[5] !== timeZone) {
        t1 = date && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $82d0090970c55653$var$styles.tooltipWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($82d0090970c55653$var$i18n.addedTooltip, {
                username: name,
                date: intl.formatDate((0, $6faGq.getValidDate)(date), {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime((0, $6faGq.getValidDate)(date), {
                    hour: "numeric",
                    minute: "numeric",
                    timeZone: timeZone
                })
            })
        }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = date;
        $[2] = formatMessage;
        $[3] = intl;
        $[4] = name;
        $[5] = timeZone;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["MaybeTooltip"] = $82d0090970c55653$export$8d25ba73a810c5c5;

});

parcelRegister("c6FO3", function(module, exports) {

var $51jGp = parcelRequire("51jGp");


var $dEABD = parcelRequire("dEABD");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");


var $9Z0wk = parcelRequire("9Z0wk");


var $lspPP = parcelRequire("lspPP");


var $3gadb = parcelRequire("3gadb");


var $kYvrE = parcelRequire("kYvrE");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $f7lNm = parcelRequire("f7lNm");

var $le4yZ = parcelRequire("le4yZ");

var $14FKK = parcelRequire("14FKK");

var $eVM9z = parcelRequire("eVM9z");


var $kNfRw = parcelRequire("kNfRw");


var $9wGTI = parcelRequire("9wGTI");


var $bzqa9 = parcelRequire("bzqa9");


var $h0UOA = parcelRequire("h0UOA");


var $lmNXu = parcelRequire("lmNXu");


var $hEeUR = parcelRequire("hEeUR");


var $7mpOv = parcelRequire("7mpOv");


var $chaNr = parcelRequire("chaNr");


var $1C1zB = parcelRequire("1C1zB");


var $gw4Eo = parcelRequire("gw4Eo");


var $eV0v4 = parcelRequire("eV0v4");


var $dPJCf = parcelRequire("dPJCf");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");


var $1YXTQ = parcelRequire("1YXTQ");


var $3ejfs = parcelRequire("3ejfs");


var $6faGq = parcelRequire("6faGq");


var $en1dX = parcelRequire("en1dX");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $iKSlH = parcelRequire("iKSlH");


var $97Szk = parcelRequire("97Szk");


var $fFmJj = parcelRequire("fFmJj");


var $g7Tm3 = parcelRequire("g7Tm3");


var $1TLVx = parcelRequire("1TLVx");

const $dc146e3974e81fa1$var$i18n = (0, $aXWIB.defineMessages)({
    editedInParentheses: {
        id: "comment.renderer.edited.in.parentheses",
        defaultMessage: "(edited)"
    },
    editedBy: {
        id: "comment.renderer.edited.by",
        defaultMessage: "Edited by {username} {at}"
    }
}); // Approx Scroll Height for Comment Container with 2 Lines
const $dc146e3974e81fa1$var$MIN_SCROLL_HEIGHT = 50;
const $dc146e3974e81fa1$var$legacyStandaloneStyle = null;
const $dc146e3974e81fa1$var$standaloneStyle = null;
const $dc146e3974e81fa1$var$standaloneStyleV2 = null;
const $dc146e3974e81fa1$var$commentsPanelV2Style = null;
const $dc146e3974e81fa1$var$commentEditedLabelStyle = null;
const $dc146e3974e81fa1$export$fb8f382757c44d14 = (entry, hasBeenViewed, commentId, setHasBeenViewed, markCommentsRead)=>{
    if (entry.isIntersecting) // Comment entered the viewport
    setHasBeenViewed(true);
    else if (hasBeenViewed) // Comment left the viewport after it was viewed
    markCommentsRead({
        variables: {
            commentIds: [
                commentId
            ]
        }
    });
};
const $dc146e3974e81fa1$export$ce6d3ea87eba7794 = /*#__PURE__*/ (0, $42omo.memo)(({ commentId: commentId, adf: adf, onContentFallback: onContentFallback, isTruncatedContent: isTruncatedContent, onRendered: onRendered, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, onComplete: onComplete, isInlineComment: isInlineComment, isCommentsPanel: isCommentsPanel = false, isEdited: isEdited, versionByDisplayName: versionByDisplayName, versionDate: versionDate, commentType: commentType, annotationId: annotationId, annotatedText: annotatedText, hideAiSuggestEdit: hideAiSuggestEdit = false, isReply: isReply = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const [rootEl, setRootEl] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId, cloudId: cloudId, locale: locale, userId: userId, featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $6mKj3.expValEquals)('confluence_fetch_appkey_field', 'isEnabled', true) ? (0, $dEABD.default) : (0, $51jGp.default)
    });
    let analyticsContextSource = (0, $en1dX.AnalyticsSource).COMMENTS_PANEL;
    let definitionExperienceName = 'commentPanelAutohighlight';
    if (!isCommentsPanel) {
        if (commentType === (0, $8i27m.CommentType).GENERAL) {
            analyticsContextSource = (0, $en1dX.AnalyticsSource).PAGE_FOOTER;
            definitionExperienceName = 'commentFooterAutohighlight';
        } else {
            analyticsContextSource = (0, $en1dX.AnalyticsSource).STANDALONE;
            definitionExperienceName = 'commentInlineAutohighlight';
        }
    }
    const { isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDefinitionsEnabled = (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en') && !JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT) || '""') && (0, $9wGTI.fg)('kd_definitions_enable_confluence_comments');
    const cloudIdARI = (0, $kYvrE.ConfluenceSiteAri).create({
        siteId: cloudId
    }).toString();
    const contentARI = contentType ? (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        resourceId: contentId || '',
        activationId: ''
    }) : '';
    const spaceARI = spaceId ? (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'space',
        resourceId: spaceId,
        activationId: ''
    }) : '';
    const workspaceId = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'workspace',
        resourceId: activationId,
        activationId: ''
    }); // entityAri is empty string to fetch acronyms used in comment text (see loadAutohighlights)
    // rather than acronyms used in associated page to prevent them being highlighted again
    const { keyPhrases: keyPhrases, autoHighlightRegex: autoHighlightRegex, loadAutohighlights: loadAutohighlights } = (0, $le4yZ.useAutohighlightSupplier)({
        entityAri: '',
        workspaceId: workspaceId,
        product: 'confluence',
        cloudId: cloudId
    });
    const { fetchDefinition: fetchDefinition } = (0, $eVM9z.useDefinitionSupplier)({
        workspaceId: workspaceId,
        cloudIdARI: cloudIdARI,
        product: 'confluence',
        fetchConfig: {
            entity_ari: contentARI
        },
        productConfig: {
            contentId: contentARI,
            spaceId: spaceARI
        },
        isDefinitionCurationEnabled: true
    });
    const onDisableDefinitions = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT, true);
    }, []);
    const onEnableDefinitions = (0, $42omo.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT, false);
    }, []);
    const getDefinitionsDisabled = (0, $42omo.useCallback)(()=>{
        return (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT);
    }, []);
    const definitionRestrictionOptions = (0, $97Szk.useDefinitionRestrictionOptions)(contentType);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('kd_definitions_enable_confluence_comments')) {
            const text = adf ? (0, $14FKK.parseContent)(adf) : '';
            loadAutohighlights({
                inputText: {
                    text: text,
                    format: (0, $le4yZ.KnowledgeDiscoveryKeyPhraseInputTextFormat).PLAIN
                }
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const memoTextPlatformHighlighter = (0, $42omo.useMemo)(()=>{
        const sourceConfig = {
            brand: isRovoEnabled ? (0, $f7lNm.AiBrand).ROVO : (0, $f7lNm.AiBrand).AI,
            cloudId: cloudId,
            contentARI: contentARI,
            contentId: contentId,
            experience: definitionExperienceName,
            source: 'readingAids',
            sourceProduct: 'confluence',
            userId: userId,
            workspaceId: workspaceId
        };
        const curatedDefinitionScopeConfig = {
            workspaceId: workspaceId,
            definitionRestrictionOptions: definitionRestrictionOptions,
            productScopes: {
                contentARI: contentARI,
                spaceARI: spaceARI
            },
            cloudId: cloudId,
            product: 'confluence'
        };
        const definitionConfig = {
            fetchDefinition: fetchDefinition,
            isAutohighlighted: true,
            definitionCurationOptions: {
                curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
            },
            disableDefinitionsCallbacks: {
                onDisableDefinitions: onDisableDefinitions,
                onEnableDefinitions: onEnableDefinitions,
                getDefinitionsDisabled: getDefinitionsDisabled
            },
            showChatFollowUps: isRovoLLMEnabled
        };
        return {
            pattern: autoHighlightRegex,
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kNfRw.RendererDefinitionTextHighlighter), {
                    ...props,
                    definitionConfig: definitionConfig,
                    keyPhrases: keyPhrases,
                    sourceConfig: sourceConfig
                })
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoHighlightRegex,
        keyPhrases
    ]);
    const handleContentFallback = (extensionKey)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'fellback',
                actionSubject: 'comment',
                actionSubjectId: commentId,
                source: 'comment',
                attributes: {
                    editor: 'v2',
                    commentType: 'page',
                    reason: extensionKey ? `${(0, $chaNr.FALLBACK_REASONS).UNSUPPORTED_EXTENSION} - ${extensionKey}` : (0, $chaNr.FALLBACK_REASONS).INVALID_ADF
                }
            }
        }).fire();
        onContentFallback && onContentFallback(extensionKey);
    };
    const extensionHandlers = (0, $1C1zB.getExtensionHandlers)(handleContentFallback, commentId);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const embeddedConfluenceEventHandlers = (0, $bzqa9.useEventHandlers)();
    const eventHandlers = (0, $42omo.useMemo)(()=>({
            ...(0, $lmNXu.createSmartCardEventHandler)({
                matchRoute: matchRoute,
                push: push
            }),
            ...(0, $h0UOA.createLinkEventHandler)({
                matchRoute: matchRoute,
                push: push
            }),
            ...embeddedConfluenceEventHandlers
        }), [
        matchRoute,
        push,
        embeddedConfluenceEventHandlers
    ]); /* Logic to not show Fade when we have 2 lines in Inactive state. When we have more than 2 lines the scrollHeight is
                                                            greater than 50, if its less than 50 send fadeOutHeight as 0*/ 
    const getFadeHeight = ()=>{
        if (isTruncatedContent && (rootEl?.firstElementChild?.scrollHeight ?? 0) > $dc146e3974e81fa1$var$MIN_SCROLL_HEIGHT) return fadeOutHeight;
        else return 0;
    };
    const injectObjectIdIntoRendererAnalytics = (objectId)=>(event)=>{
            // WS-3190 If a renderer event is fired, inject the commentId as objectId
            if (event.payload.actionSubject === 'renderer') event.update((payload)=>({
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        appearance: 'comment',
                        objectId: objectId
                    }
                }));
        };
    const getRendererLocation = (0, $42omo.useCallback)(()=>{
        let rendererLocation = isInlineComment ? (0, $g7Tm3.CommentRendererLocation).STANDALONE_INLINE : (0, $g7Tm3.CommentRendererLocation).STANDALONE_OBJECT;
        if (isCommentsPanel) {
            if (isInlineComment) rendererLocation = (0, $g7Tm3.CommentRendererLocation).COMMENTS_PANEL_INLINE;
            else rendererLocation = (0, $g7Tm3.CommentRendererLocation).COMMENTS_PANEL_OBJECT;
        }
        return rendererLocation;
    }, [
        isInlineComment,
        isCommentsPanel
    ]);
    const handleEmojiLoadFail = (0, $42omo.useCallback)((emojiId, reason)=>{
        const rendererLocation = getRendererLocation();
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                objectType: 'page',
                objectId: contentId,
                action: 'failed',
                actionSubject: 'emojiLoad',
                actionSubjectId: 'commentRenderer',
                attributes: {
                    commentId: commentId,
                    location: rendererLocation,
                    isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                    emojiId: emojiId,
                    tenantId: cloudId,
                    userId: userId,
                    reason: reason,
                    pageId: contentId
                }
            }
        }).fire();
    }, [
        pageMode,
        contentId,
        commentId,
        cloudId,
        userId,
        getRendererLocation,
        createAnalyticsEvent
    ]);
    const handleEmojiLoadSuccess = (0, $42omo.useCallback)((emojiId)=>{
        const rendererLocation = getRendererLocation();
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                objectType: 'page',
                objectId: contentId,
                action: 'success',
                actionSubject: 'emojiLoad',
                actionSubjectId: 'commentRenderer',
                attributes: {
                    commentId: commentId,
                    location: rendererLocation,
                    isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                    emojiId: emojiId,
                    tenantId: cloudId,
                    userId: userId,
                    pageId: contentId
                }
            }
        }).fire();
    }, [
        pageMode,
        contentId,
        commentId,
        cloudId,
        userId,
        getRendererLocation,
        createAnalyticsEvent
    ]);
    if (!adf) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: injectObjectIdIntoRendererAnalytics(commentId),
        channel: "editor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eV0v4.DynamicAnalyticsListener), {
        channelParam: (0, $eV0v4.editorChannel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: setRootEl,
        className: (0, $gMc0m.default)([
            !isCommentsPanel && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_ca0qu2gc _n3tdu2gc",
            !isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_19pkutpp _n3tdu2gc",
            !isCommentsPanel && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19pku2gc",
            isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_n3tdn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKSlH.MultiMacroQueryContainer), {
        contentId: contentId ?? '',
        featureFlags: featureFlags,
        contentRendererMode: "renderer",
        readFragmentInterop: readFragmentInterop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        contentId: commentId,
        document: adf,
        extensionHandlers: extensionHandlers,
        portal: rootEl ?? undefined,
        allowStickyHeaders: false,
        isTruncatedContent: isTruncatedContent,
        onRendered: onRendered,
        onComplete: onComplete,
        allowSelectAllTrap: true,
        maxHeight: maxHeight,
        fadeOutHeight: getFadeHeight(),
        appearance: "comment",
        eventHandlers: eventHandlers,
        UNSTABLE_allowTableAlignment: !isInlineComment,
        UNSTABLE_allowTableResizing: !isInlineComment,
        shouldRemoveEmptySpaceAroundContent: true,
        onEmojiLoadFail: handleEmojiLoadFail,
        onEmojiLoadSuccess: handleEmojiLoadSuccess,
        textHighlighter: isDefinitionsEnabled ? memoTextPlatformHighlighter : undefined
    }), isEdited && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _syaz1rpy _ca0q12x7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($dc146e3974e81fa1$var$i18n.editedBy, {
            username: versionByDisplayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
            at: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(versionDate),
                usePrepositions: true
            })
        }),
        analyticsContext: {
            attributes: {
                source: analyticsContextSource,
                commentType: commentType,
                name: 'commentEditedBadgeTooltip'
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "comment-edited-label",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z0wk.default), null, formatMessage($dc146e3974e81fa1$var$i18n.editedInParentheses))))), annotationId && !hideAiSuggestEdit && !isReply && (0, $6mKj3.expValEquals)('ai-suggested-edits', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1TLVx.AiSuggestEdit), {
        commentId: commentId,
        annotationId: annotationId,
        annotatedText: annotatedText,
        commentAdf: adf ? JSON.stringify(adf) : undefined,
        contentId: contentId
    }))))))));
});
$dc146e3974e81fa1$export$ce6d3ea87eba7794.displayName = 'CommentRenderer';
module.exports["CommentRenderer"] = $dc146e3974e81fa1$export$ce6d3ea87eba7794;

});

parcelRegister("51jGp", function(module, exports) {
/**
 * @generated SignedSource<<c77e7e3126bc5a97a2d2f0792b3df4d9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20cea39b88d5a5ee$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "CommentRendererReadFragment",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "RENDERER"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"RENDERER\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$20cea39b88d5a5ee$var$node.hash = "2939a86cf744f10a55b9d35c52e07226";
var $20cea39b88d5a5ee$export$2e2bcd8739ae039 = $20cea39b88d5a5ee$var$node;
module.exports["default"] = $20cea39b88d5a5ee$export$2e2bcd8739ae039;

});

parcelRegister("dEABD", function(module, exports) {
/**
 * @generated SignedSource<<cb51699659a0fa451b13f98a28147a27>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $00ef5e4e26dd3cfe$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "CommentRendererReadFragmentWithAppKey",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "RENDERER"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appKey"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"RENDERER\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$00ef5e4e26dd3cfe$var$node.hash = "baa5be0493f483d10c38df29c48e3340";
var $00ef5e4e26dd3cfe$export$2e2bcd8739ae039 = $00ef5e4e26dd3cfe$var$node;
module.exports["default"] = $00ef5e4e26dd3cfe$export$2e2bcd8739ae039;

});

parcelRegister("9Z0wk", function(module, exports) {
/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $5e18336ff60a0b69$var$editedContentStyles = {
    root: "_syaz1rpy"
};
const $5e18336ff60a0b69$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $gMc0m.default)([
            $5e18336ff60a0b69$var$editedContentStyles.root
        ]),
        children: children
    });
$5e18336ff60a0b69$var$Edited.displayName = 'Edited'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $5e18336ff60a0b69$export$2e2bcd8739ae039 = $5e18336ff60a0b69$var$Edited;
module.exports["default"] = $5e18336ff60a0b69$export$2e2bcd8739ae039;

});

parcelRegister("kYvrE", function(module, exports) {

var $3lhEv = parcelRequire("3lhEv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/site/manifest.ts
var $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $3lhEv.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $3lhEv.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $f451cd8c9de7a9df$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f451cd8c9de7a9df$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $f451cd8c9de7a9df$export$82e6693d75ffdd8;

});

parcelRegister("3lhEv", function(module, exports) {
// src/confluence/site/types.ts
var $26f1069ffd8f654d$export$9e07499cd8b0bde5 = "confluence", $26f1069ffd8f654d$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $26f1069ffd8f654d$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $26f1069ffd8f654d$export$57b7cabbf31f1f68;

});

parcelRegister("f7lNm", function(module, exports) {
const $ea70aa10be5defa1$export$82b05c69aac5d0c6 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ea70aa10be5defa1$export$e7d7da8c94dcb6fc = 'https://support.atlassian.com/confluence-cloud/docs/use-atlassian-intelligence-to-search-for-answers/';
const $ea70aa10be5defa1$export$506bad4598ef877f = 'https://www.atlassian.com/software/artificial-intelligence';
const $ea70aa10be5defa1$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ea70aa10be5defa1$export$b4efff19add55eb6 = 'https://confluence.atlassian.com/support/atlassian-support-ai-chat-1455423797.html';
const $ea70aa10be5defa1$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $ea70aa10be5defa1$export$d3a50b0660f215e0 = 'https://support.atlassian.com/organization-administration/docs/usage-limits-in-atlassian-intelligence/';
const $ea70aa10be5defa1$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $ea70aa10be5defa1$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $ea70aa10be5defa1$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $ea70aa10be5defa1$export$c4fda24479ad6357 = '82633dea-7fbf-4faa-9a51-a83a3fd181d9';
const $ea70aa10be5defa1$export$91d63889268b5e23 = "365\xa05ce1d-16b8-4630-9e93-6c39069625fa";
const $ea70aa10be5defa1$export$c0ced37cfe138d3e = '10f4daa4-bcfc-4d42-ae33-92888648d9db';
const $ea70aa10be5defa1$export$d04cd98bb7625919 = 'customfield_10047';
const $ea70aa10be5defa1$export$ed78826c06dd24e3 = 'fabric-elements';
var $ea70aa10be5defa1$export$83c8d7110915321e = /*#__PURE__*/ function(SOURCE) {
    SOURCE["SEARCH_DIALOG"] = "searchDialog";
    SOURCE["ADVANCED_SEARCH"] = "advancedSearch";
    SOURCE["READING_AIDS"] = "readingAids";
    return SOURCE;
}({});
const $ea70aa10be5defa1$export$e7862e8dbda0aa3 = '500px';
const $ea70aa10be5defa1$export$169d09d6d83f61d6 = '/gateway/api/smartAnswers/stream';
const $ea70aa10be5defa1$export$a00f71e6c6b44441 = '/gateway/api/assist';
const $ea70aa10be5defa1$export$cc4a4ed360fef1ba = '/gateway/api/graphql';
var $ea70aa10be5defa1$export$83d4ba88ba80625b = /*#__PURE__*/ function(QueryIntent) {
    QueryIntent["DEFAULT"] = "DEFAULT";
    QueryIntent["NATURAL_LANGUAGE_QUERY"] = "NATURAL_LANGUAGE_QUERY";
    QueryIntent["KEYWORD_OR_ACRONYM"] = "KEYWORD_OR_ACRONYM";
    QueryIntent["PERSON"] = "PERSON";
    QueryIntent["TEAM"] = "TEAM";
    QueryIntent["NAVIGATIONAL"] = "NAVIGATIONAL";
    QueryIntent["NONE"] = "NONE";
    QueryIntent["LOCATION"] = "LOCATION";
    QueryIntent["DATE"] = "DATE";
    QueryIntent["JIRA_ISSUE"] = "JIRA_ISSUE";
    QueryIntent["TOPIC"] = "TOPIC";
    QueryIntent["JIRA_NATURAL_LANGUAGE_QUERY"] = "JIRA_NATURAL_LANGUAGE_QUERY";
    QueryIntent["AGENT"] = "AGENT";
    QueryIntent["ORG_CHART"] = "ORG_CHART";
    QueryIntent["NAV_CONTENT"] = "NAV_CONTENT";
    QueryIntent["BOOKMARK"] = "BOOKMARK";
    QueryIntent["VISUAL"] = "VISUAL";
    return QueryIntent;
}({});
var $ea70aa10be5defa1$export$a08a848abe54c31f = /*#__PURE__*/ function(AnswerCardType) {
    AnswerCardType["PERSON"] = "people";
    AnswerCardType["TEAM"] = "team";
    AnswerCardType["AGENT"] = "agent";
    AnswerCardType["DATE"] = "date";
    AnswerCardType["LOCATION"] = "location";
    AnswerCardType["TOPIC"] = "topic";
    AnswerCardType["JIRA_NATURAL_LANGUAGE_QUERY"] = "jira_nl_to_jql";
    AnswerCardType["JIRA_ISSUE"] = "jira_issue";
    AnswerCardType["NAVIGATIONAL"] = "navigational";
    AnswerCardType["NAV_CONTENT"] = "nav_content";
    AnswerCardType["NONE"] = "none";
    AnswerCardType["DEFAULT"] = "default";
    AnswerCardType["SAIN"] = "SAIN";
    AnswerCardType["DEFINITION"] = "definition";
    AnswerCardType["ORG_CHART"] = "org_chart";
    AnswerCardType["BOOKMARK_KNOWLEDGE_CARD"] = "bookmarkKnowledgeCard";
    AnswerCardType["VISUAL"] = "visual";
    return AnswerCardType;
}({});
var $ea70aa10be5defa1$export$c243a7d908564b9b = /*#__PURE__*/ function(AiExperienceName) {
    AiExperienceName["PERSON_CARD"] = "Person Card";
    AiExperienceName["TEAM_CARD"] = "Team Card";
    AiExperienceName["LOCATION_CARD"] = "Location Card";
    AiExperienceName["DATE_CARD"] = "Date Card";
    AiExperienceName["TOPIC_CARD"] = "Topic Card";
    AiExperienceName["JIRA_NATURAL_LANGUAGE_QUERY_CARD"] = "Jira Card";
    AiExperienceName["AGENT_CARD"] = "Agent Card";
    AiExperienceName["JIRA_ISSUE_CARD"] = "Jira Issue Card";
    AiExperienceName["NAVIGATIONAL"] = "Navigational";
    AiExperienceName["NONE"] = "None";
    AiExperienceName["DEFAULT"] = "Default";
    AiExperienceName["PLAIN_TEXT"] = "Plain Text";
    AiExperienceName["POPULAR_SEARCH_QUERY_CARD"] = "Popular Search Query Card";
    AiExperienceName["NAVIGATIONAL_SEARCH_RESULT_CARD"] = "Navigational Search Result Card";
    return AiExperienceName;
}({});
var $ea70aa10be5defa1$export$30e36b9f4147b88f = /*#__PURE__*/ function(CardTemplate) {
    CardTemplate["DEFAULT"] = "DEFAULT";
    CardTemplate["SMART_ANSWER"] = "SMART_ANSWER";
    CardTemplate["RIGHT_PANEL"] = "RIGHT_PANEL";
    return CardTemplate;
}({});
var $ea70aa10be5defa1$export$49069087564847a7 = /*#__PURE__*/ function(AiBrand) {
    AiBrand["ROVO"] = "ROVO";
    AiBrand["AI"] = "ATLASSIAN INTELLIGENCE";
    return AiBrand;
}({});
var $ea70aa10be5defa1$export$8375a80c95e07251 = /*#__PURE__*/ function(AIAnswerTab) {
    AIAnswerTab["AI_ANSWER"] = "AI_ANSWER";
    AIAnswerTab["SOURCES"] = "SOURCES";
    return AIAnswerTab;
}({});
const $ea70aa10be5defa1$export$98d221c2fcca6d6b = [
    "AI_ANSWER",
    "SOURCES"
];
const $ea70aa10be5defa1$export$7ecd7f1b620801eb = 'convo_ai_sain_prompt_override_hello';
const $ea70aa10be5defa1$export$fe340b7aba57733d = 'atlassian.search-dialog.ai-answer-component';
module.exports["ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK"] = $ea70aa10be5defa1$export$e7d7da8c94dcb6fc;
module.exports["ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $ea70aa10be5defa1$export$59da2b3b71a076c7;
module.exports["SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $ea70aa10be5defa1$export$b4efff19add55eb6;
module.exports["ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK"] = $ea70aa10be5defa1$export$96cc4126cdc27248;
module.exports["ATLASSIAN_AI_USAGE_LIMITS_LINK"] = $ea70aa10be5defa1$export$d3a50b0660f215e0;
module.exports["ATLASSIAN_AI_TROUBLESHOOT_LINK"] = $ea70aa10be5defa1$export$50e6b843de210064;
module.exports["ATLASSIAN_HIPAA_COMPLICANCE_LINK"] = $ea70aa10be5defa1$export$dd87179defae3659;
module.exports["ATLASSIAN_ROVO_LINK"] = $ea70aa10be5defa1$export$2c1028e1e7bf5557;
module.exports["FEEDBACK_ENTRYPOINT_ID_SAIN"] = $ea70aa10be5defa1$export$c4fda24479ad6357;
module.exports["FEEDBACK_ENTRYPOINT_ID_TOPICS"] = $ea70aa10be5defa1$export$c0ced37cfe138d3e;
module.exports["FEEDBACK_CONTEXT_CF"] = $ea70aa10be5defa1$export$d04cd98bb7625919;
module.exports["DEFAULT_GAS_CHANNEL"] = $ea70aa10be5defa1$export$ed78826c06dd24e3;
module.exports["READING_AIDS_DIALOG_WIDTH"] = $ea70aa10be5defa1$export$e7862e8dbda0aa3;
module.exports["SAIN_STREAMING_API"] = $ea70aa10be5defa1$export$169d09d6d83f61d6;
module.exports["ASSISTANCE_SERVICE_API_BASE_URL"] = $ea70aa10be5defa1$export$a00f71e6c6b44441;
module.exports["DEFAULT_GRAPHQL_ENDPOINT"] = $ea70aa10be5defa1$export$cc4a4ed360fef1ba;
module.exports["QueryIntent"] = $ea70aa10be5defa1$export$83d4ba88ba80625b;
module.exports["AnswerCardType"] = $ea70aa10be5defa1$export$a08a848abe54c31f;
module.exports["AiExperienceName"] = $ea70aa10be5defa1$export$c243a7d908564b9b;
module.exports["CardTemplate"] = $ea70aa10be5defa1$export$30e36b9f4147b88f;
module.exports["AiBrand"] = $ea70aa10be5defa1$export$49069087564847a7;
module.exports["AIAnswerTab"] = $ea70aa10be5defa1$export$8375a80c95e07251;
module.exports["aiAnswerTabsOrder"] = $ea70aa10be5defa1$export$98d221c2fcca6d6b;
module.exports["PROMPT_OVERRIDE_SESSION_KEY"] = $ea70aa10be5defa1$export$7ecd7f1b620801eb;
module.exports["SEARCH_AI_ANSWER_CACHE_KEY"] = $ea70aa10be5defa1$export$fe340b7aba57733d;

});

parcelRegister("le4yZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $f7lNm = parcelRequire("f7lNm");


var $9pwVP = parcelRequire("9pwVP");


var $bbPOv = parcelRequire("bbPOv");

var $850e39d8df191904$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["PLAIN"] = "PLAIN";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["ADF"] = "ADF";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
var $850e39d8df191904$export$17a511c5c23509af = /*#__PURE__*/ function(KeyPhraseCategory) {
    KeyPhraseCategory["PROJECT"] = "PROJECT";
    KeyPhraseCategory["TEAM"] = "TEAM";
    KeyPhraseCategory["ACRONYM"] = "ACRONYM";
    KeyPhraseCategory["AUTO"] = "AUTO";
    KeyPhraseCategory["OTHER"] = "OTHER";
    return KeyPhraseCategory;
}({});
const $850e39d8df191904$export$276f56b9dab90860 = 'atlassian.knowledge-discovery.autohighlights';
const $850e39d8df191904$var$escapeRegExp = (regex)=>{
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const $850e39d8df191904$export$4a1c1074ca627 = (keyPhrases)=>{
    try {
        if (!keyPhrases.length) return new RegExp('(?!)');
        else return new RegExp(keyPhrases.map((node)=>`\\b${$850e39d8df191904$var$escapeRegExp(node.keyPhrase)}\\b`).join('|'), 'gi');
    } catch  {
        return new RegExp('(?!)');
    }
};
const $850e39d8df191904$var$getKeyphraseCategory = (keyPhrases)=>{
    return keyPhrases.length ? keyPhrases[0].category : "AUTO";
};
const $850e39d8df191904$var$initialState = {
    keyPhrases: [],
    keyPhraseCategory: "AUTO",
    autoHighlightRegex: new RegExp('(?!)'),
    loadAutohighlights: ()=>Promise.resolve([]),
    resetAutohighlights: ()=>{},
    autohighlightsLoading: false,
    error: undefined
};
const $850e39d8df191904$export$52e9ff9bfbb65046 = ({ entityAri: entityAri, workspaceId: workspaceId, product: product, productConfig: productConfig, fieldType: fieldType, cloudId: cloudId })=>{
    const [state, setState] = (0, $42omo.useState)($850e39d8df191904$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const { jiraReporterAccountId: jiraReporterAccountId, jiraAssigneeAccountId: jiraAssigneeAccountId } = productConfig || {};
    const loadAutohighlights = (0, $42omo.useCallback)(async ({ inputText: inputText })=>{
        try {
            setState({
                ...$850e39d8df191904$var$initialState,
                autohighlightsLoading: true
            });
            const keyPhrasesResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $bbPOv.KeyPhrasesQuery),
                variables: {
                    workspaceId: workspaceId,
                    entityAri: entityAri,
                    ...!!jiraReporterAccountId && {
                        jiraReporterAccountId: jiraReporterAccountId
                    },
                    ...!!jiraAssigneeAccountId && {
                        jiraAssigneeAccountId: jiraAssigneeAccountId
                    },
                    ...!!inputText && {
                        inputText: inputText
                    }
                },
                operationName: (0, $bbPOv.KEY_PHRASES_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            });
            const keyPhrases = keyPhrasesResult?.data?.knowledgeDiscovery?.keyPhrases?.nodes ? keyPhrasesResult.data.knowledgeDiscovery.keyPhrases.nodes : [];
            if (keyPhrases.length > 0 && (0, $dh538.fg)('kd_definitions_click_and_show_event_product_parity')) fireAnalyticsEvent((0, $9pwVP.onShownAutoDefinitionHighlights)({
                product: product,
                contentId: entityAri,
                keyPhrases: keyPhrases,
                fieldType: fieldType
            }));
            const autoHighlightRegex = $850e39d8df191904$export$4a1c1074ca627(keyPhrases);
            setState({
                ...$850e39d8df191904$var$initialState,
                keyPhraseCategory: $850e39d8df191904$var$getKeyphraseCategory(keyPhrases),
                autoHighlightRegex: autoHighlightRegex,
                keyPhrases: keyPhrases
            });
            return keyPhrases;
        } catch (error) {
            setState({
                ...$850e39d8df191904$var$initialState,
                error: error.message
            });
            return [];
        }
    }, [
        entityAri,
        workspaceId,
        fireAnalyticsEvent,
        product,
        jiraReporterAccountId,
        jiraAssigneeAccountId,
        fieldType,
        cloudId
    ]);
    const resetAutohighlights = (0, $42omo.useCallback)(()=>{
        setState($850e39d8df191904$var$initialState);
    }, []);
    const autoHighlightRegex = (0, $42omo.useMemo)(()=>state.autoHighlightRegex, [
        state.autoHighlightRegex
    ]);
    const autohighlightsLoading = (0, $42omo.useMemo)(()=>state.autohighlightsLoading, [
        state.autohighlightsLoading
    ]);
    const keyPhrases = (0, $42omo.useMemo)(()=>state.keyPhrases, [
        state.keyPhrases
    ]);
    const error = (0, $42omo.useMemo)(()=>state.error, [
        state.error
    ]);
    return {
        keyPhrases: keyPhrases,
        keyPhraseCategory: state.keyPhraseCategory,
        autoHighlightRegex: autoHighlightRegex,
        loadAutohighlights: loadAutohighlights,
        resetAutohighlights: resetAutohighlights,
        autohighlightsLoading: autohighlightsLoading,
        error: error
    };
};
module.exports["KnowledgeDiscoveryKeyPhraseInputTextFormat"] = $850e39d8df191904$export$5fc610914b028d97;
module.exports["KeyPhraseCategory"] = $850e39d8df191904$export$17a511c5c23509af;
module.exports["getHighlightRegex"] = $850e39d8df191904$export$4a1c1074ca627;
module.exports["useAutohighlightSupplier"] = $850e39d8df191904$export$52e9ff9bfbb65046;

});

parcelRegister("6yuru", function(module, exports) {
function $9b992db01b095d2f$export$14ef296862e3705e({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
}
module.exports["createAtlAttributionHeader"] = $9b992db01b095d2f$export$14ef296862e3705e;

});

parcelRegister("9EFEY", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dwp40 = parcelRequire("dwp40");


var $5M6sZ = parcelRequire("5M6sZ");


var $i1ClO = parcelRequire("i1ClO");

const $f389ba2de7a9be34$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $f389ba2de7a9be34$export$1642248503fca29({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f389ba2de7a9be34$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    // Populated from HTTP response via requestService (not present on JSON body).
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        },
        reportTracingHeaders: (tracing)=>{
            Object.assign(capturedTracingHeaders, tracing);
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $dh538.fg)('kd_fe_enable_api_cache')) return (0, $i1ClO.fetchAggResponseWithCache)({
        graphQuery: graphQuery,
        variables: variables,
        operationName: operationName,
        cache: cache,
        headers: headers
    });
    const response = await (0, $dwp40.utils).requestService({
        url: url
    }, options);
    // Attach gateway trace / request IDs for downstream tracing and analytics.
    return (0, $5M6sZ.enrichAggResponseWithGatewayTracingHeaders)(response, capturedTracingHeaders);
}
module.exports["fetchAggResponse"] = $f389ba2de7a9be34$export$1642248503fca29;

});

parcelRegister("5M6sZ", function(module, exports) {
function $d0dd88187373cc96$export$547fb2fa14d5b927(response, tracingHeaders) {
    if (!tracingHeaders || Object.keys(tracingHeaders).length === 0) return response;
    return {
        ...response,
        gatewayTracingHeaders: {
            ...response.gatewayTracingHeaders,
            ...tracingHeaders
        }
    };
}
module.exports["enrichAggResponseWithGatewayTracingHeaders"] = $d0dd88187373cc96$export$547fb2fa14d5b927;

});

parcelRegister("i1ClO", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $5M6sZ = parcelRequire("5M6sZ");


var $iip0W = parcelRequire("iip0W");

const $d8368aeaca537ae2$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $d8368aeaca537ae2$export$6fe550b7d5be614c({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $d8368aeaca537ae2$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    // From HTTP response headers; merged onto the payload before cache / return.
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        },
        reportTracingHeaders: (tracing)=>{
            Object.assign(capturedTracingHeaders, tracing);
        }
    };
    let cachedResponse = (0, $iip0W.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $iip0W.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $iip0W.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $dwp40.utils).requestService({
                url: url
            }, options);
            // Attach `x-trace-id` / `atl-request-id` from the HTTP layer for tracing.
            const enriched = (0, $5M6sZ.enrichAggResponseWithGatewayTracingHeaders)(response, capturedTracingHeaders);
            (0, $iip0W.InMemCache).setData({
                key: cache.key,
                response: enriched,
                ttl: cache.ttl
            });
            resolve(enriched);
        } catch (error) {
            reject(error);
        } finally{
            (0, $iip0W.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $iip0W.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}
module.exports["fetchAggResponseWithCache"] = $d8368aeaca537ae2$export$6fe550b7d5be614c;

});

parcelRegister("iip0W", function(module, exports) {
const $72ec73b0e41d4c0a$var$DEFAULT_TTL = 300000;
class $72ec73b0e41d4c0a$export$916bab80494ce385 {
    static setData({ key: key, response: response, ttl: ttl }) {
        this.cache.set(key, {
            ttl: Date.now() + (ttl || $72ec73b0e41d4c0a$var$DEFAULT_TTL),
            response: response
        });
    }
    static getData(key) {
        return this.cache.get(key)?.response;
    }
    static isValid(key) {
        const item = this.cache.get(key);
        return Boolean(item) && Date.now() < (item?.ttl || 0);
    }
    static getInflightRequest(key) {
        return this.inFlightRequests.get(key);
    }
    static setInflightRequest({ key: key, request: request }) {
        this.inFlightRequests.set(key, request);
    }
    static removeInflightRequest(key) {
        return this.inFlightRequests.delete(key);
    }
    // only for tests
    static clearCache() {
        this.cache.clear();
        this.inFlightRequests.clear();
    }
}
$72ec73b0e41d4c0a$export$916bab80494ce385.cache = new Map();
$72ec73b0e41d4c0a$export$916bab80494ce385.inFlightRequests = new Map();
module.exports["InMemCache"] = $72ec73b0e41d4c0a$export$916bab80494ce385;

});

parcelRegister("9pwVP", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");


var $le4yZ = parcelRequire("le4yZ");


var $fjzE4 = parcelRequire("fjzE4");

const $135aee7ed4d7fef7$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};
const $135aee7ed4d7fef7$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$42897f8f02baa658 = ({ product: product, contentId: contentId, keyPhrases: keyPhrases, fieldType: fieldType })=>({
        action: 'shown',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'track',
        attributes: {
            product: product,
            contentId: contentId,
            numHighlights: keyPhrases.length,
            categories: (0, $fjzE4.getHighlightCategories)(keyPhrases),
            beAcronymsEnabled: true,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$9e6261f08debf93b = ({ contentId: contentId, sessionId: sessionId, keyPhraseCategory: keyPhraseCategory, fieldType: fieldType })=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: sessionId,
            keyPhraseCategory: keyPhraseCategory || (0, $le4yZ.KeyPhraseCategory).AUTO,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$bfe6deae035e3ea7 = (props)=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsDisableDefinition',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    });
module.exports["onCuratedDefinitionUpdateButtonClicked"] = $135aee7ed4d7fef7$export$ae4ae603f16dcf42;
module.exports["onCuratedDefinitionSeeEditHistoryButtonClicked"] = $135aee7ed4d7fef7$export$d80f83cdfda72179;
module.exports["onLikeButtonClick"] = $135aee7ed4d7fef7$export$5b155f527aff26b9;
module.exports["onDislikeButtonClick"] = $135aee7ed4d7fef7$export$c4c8b81ee90e6af2;
module.exports["onShownAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$42897f8f02baa658;
module.exports["onClickAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$9e6261f08debf93b;
module.exports["onClickDisableDefinition"] = $135aee7ed4d7fef7$export$bfe6deae035e3ea7;

});

parcelRegister("cqFuK", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $01aV7 = parcelRequire("01aV7");

// list from https://atlassian.slack.com/archives/C08VA0N40A2/p1749172242825969?thread_ts=1749088363.059769&cid=C08VA0N40A2
const $f6cafe5dbc3bbc93$var$products1PList = [
    'Assets',
    'Atlas',
    'Confluence',
    'Atlassian Analytics',
    'Atlassian Cloud',
    'Automation for Jira',
    'Bamboo',
    'Bitbucket',
    'Compass',
    'Jira',
    'Jira Product Discovery',
    'Jira Service Management',
    'Jira Software',
    'Jira Work Management',
    'Jira Align',
    'Migration',
    'Loom',
    'Opsgenie',
    'Platform Experiences',
    'Rovo',
    'Statuspage',
    'Trello',
    'webSearch',
    'web-page',
    'Fisheye and Crucible',
    'Crowd',
    'Sourcetree',
    'Unknown',
    'Focus',
    'file-upload',
    'Advanced Roadmaps For Jira',
    'Questions for Confluence',
    'csm',
    'Dewey Support',
    'Dewey JAC Support',
    'Help Aggregator'
];
const $f6cafe5dbc3bbc93$var$noAnswerPhrases = [
    "i'm sorry",
    'i apologize',
    "couldn't find ",
    "couldn't generate",
    'provide more context',
    "don't have enough information"
];
const $f6cafe5dbc3bbc93$export$e9cf531f9f13a177 = (text)=>{
    const lowerCaseText = text.toLowerCase();
    return $f6cafe5dbc3bbc93$var$noAnswerPhrases.some((phrase)=>lowerCaseText.includes(phrase));
};
const $f6cafe5dbc3bbc93$var$getSourceProducts = (sources)=>{
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};
const $f6cafe5dbc3bbc93$var$sanitizeSources = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $f6cafe5dbc3bbc93$export$fae1292002da0b83 = (sources)=>sources.filter((source)=>source.product ? !$f6cafe5dbc3bbc93$var$products1PList.includes(source.product) && !source.product.includes('Plugin') : false);
const $f6cafe5dbc3bbc93$export$dff579a44dd3965d = new Set([
    'contentId',
    'readingAidsSessionId',
    'fieldType',
    'multipleUserResultsShown',
    'numAddtlWhoMatches',
    'isCuratedDefinition',
    'isPrecomputedDefinition',
    'editDistance',
    'bookmarkId',
    'bookmarkState',
    'dwellTime',
    'availableProducts',
    'isDescriptionEmpty',
    // from extraAPIAnalyticsAttributes
    'message_id',
    'conversational_channel_id',
    'experience_id',
    'user_id',
    // Deduplicated list of plugin names and minion IDs invoked during the AI answer generation
    'pluginsInvoked',
    // from extraAnalyticsAttributes
    'experiments',
    'featureGates',
    'isFullPageSearch',
    'has3pProducts',
    'is3pSearch',
    'mode',
    'triggeredBy',
    'referrer',
    'requestId'
]);
const $f6cafe5dbc3bbc93$export$988d4f126deef74 = (extraAttributes)=>{
    if (!(0, $dh538.fg)('kd_fe_sanitize_analytics')) return extraAttributes;
    const sanitizedAttributes = {};
    // Sanitize everything except COMMON_ALLOWED_KEYS
    for(const key in extraAttributes)if ($f6cafe5dbc3bbc93$export$dff579a44dd3965d.has(key)) sanitizedAttributes[key] = extraAttributes[key];
    else // replacing with text because the value has type `any`
    sanitizedAttributes[key] = '[sanitized]';
    return sanitizedAttributes;
};
/**
 * Keys produced by `filterCommonAttributes` (including optional and feature-gated fields). Keep in
 * sync when adding new attributes there — `SEARCH_AI_ANALYTICS_CONTEXT_ATTRIBUTE_ALLOWLIST` is
 * derived from this list plus `ALLOWED_EXTRA_ATTRIBUTES_KEYS`, `location`, and `source`.
 */ const $f6cafe5dbc3bbc93$var$FILTER_COMMON_ATTRIBUTES_OUTPUT_KEYS = [
    'searchSessionId',
    'queryHash',
    'baseQueryHash',
    'wordCount',
    'queryLength',
    'answerHash',
    'appliedFilters',
    'answerFormat',
    'answerLength',
    'answerWordCount',
    'answerCardType',
    'followUpsCount',
    'followUpsLength',
    'has3PSources',
    'sources',
    'sourceProducts',
    'apiSource',
    'brand',
    'sessionId',
    'isHello',
    'sourceProduct',
    'isReadingAids',
    'queryIntent',
    'sourcesCount',
    'sources3P',
    'sources3PCount',
    'hasSources',
    'has1PSources',
    'containsNoAnswerPhrase'
];
const $f6cafe5dbc3bbc93$export$26c187b85342c353 = new Set([
    'location',
    'source',
    ...$f6cafe5dbc3bbc93$var$FILTER_COMMON_ATTRIBUTES_OUTPUT_KEYS,
    ...$f6cafe5dbc3bbc93$export$dff579a44dd3965d
]);
const $f6cafe5dbc3bbc93$export$5e5d3678c52c4007 = (data)=>{
    const location = data.location;
    const raw = {
        ...data.attributes ?? {}
    };
    if (raw.location === undefined) raw.location = location;
    const attributes = {};
    for (const key of Object.keys(raw))if ($f6cafe5dbc3bbc93$export$26c187b85342c353.has(key)) attributes[key] = raw[key];
    return {
        attributes: attributes,
        location: location
    };
};
const $f6cafe5dbc3bbc93$export$14f72eaec5bfc1a8 = (props)=>{
    const { appliedFilters: appliedFilters, answerFormat: answerFormat, answerLength: answerLength, answerWordCount: answerWordCount, answerCardType: answerCardType, followUps: followUps, sources: sources, extraAttributes: extraAttributes, searchSessionId: searchSessionId, queryHash: queryHash, baseQueryHash: baseQueryHash, query: query, answerString: answerString, apiSource: apiSource, brand: brand, sourceProduct: sourceProduct, isReadingAids: isReadingAids, queryIntent: queryIntent, sessionId: sessionId, isHello: isHello } = props;
    const filtered3P = $f6cafe5dbc3bbc93$export$fae1292002da0b83(sources);
    return {
        searchSessionId: searchSessionId,
        queryHash: queryHash,
        baseQueryHash: baseQueryHash,
        wordCount: (query.match(/\w+/g) || []).length,
        queryLength: query.length,
        answerHash: (0, $01aV7.sha256Hash)(answerString),
        appliedFilters: appliedFilters,
        answerFormat: answerFormat,
        answerLength: answerLength,
        answerWordCount: answerWordCount,
        answerCardType: answerCardType,
        followUpsCount: followUps.length,
        followUpsLength: followUps.map((followUp)=>followUp.length),
        has3PSources: filtered3P.length > 0,
        sources: $f6cafe5dbc3bbc93$var$sanitizeSources(sources),
        sourceProducts: $f6cafe5dbc3bbc93$var$getSourceProducts(sources),
        apiSource: apiSource,
        brand: brand,
        ...sourceProduct !== undefined && {
            sourceProduct: sourceProduct
        },
        ...isReadingAids !== undefined && {
            isReadingAids: isReadingAids
        },
        ...queryIntent !== undefined && {
            queryIntent: queryIntent
        },
        ...(0, $dh538.fg)('kd_consolidate_sources_analytics') && {
            sourcesCount: sources.length,
            sources3P: $f6cafe5dbc3bbc93$var$sanitizeSources(filtered3P),
            sources3PCount: filtered3P.length
        },
        ...(0, $dh538.fg)('kd_send_no_answer_attributes') && {
            hasSources: sources.length > 0,
            has1PSources: sources.length > filtered3P.length,
            containsNoAnswerPhrase: $f6cafe5dbc3bbc93$export$e9cf531f9f13a177(answerString)
        },
        sessionId: sessionId,
        isHello: isHello,
        ...$f6cafe5dbc3bbc93$export$988d4f126deef74(extraAttributes)
    };
};
module.exports["sanitizeExtraAttributes"] = $f6cafe5dbc3bbc93$export$988d4f126deef74;
module.exports["sanitizeSearchAIAnalyticsContextData"] = $f6cafe5dbc3bbc93$export$5e5d3678c52c4007;
module.exports["filterCommonAttributes"] = $f6cafe5dbc3bbc93$export$14f72eaec5bfc1a8;

});

parcelRegister("01aV7", function(module, exports) {

var $7azCD = parcelRequire("7azCD");


var $f7lNm = parcelRequire("f7lNm");

const $2d6714779ba6d3a2$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $2d6714779ba6d3a2$export$a3b7216c107a7a1 = (sourceUrl)=>{
    let url;
    try {
        url = new URL(sourceUrl);
    } catch  {
        return undefined;
    }
    return url.hostname;
};
const $2d6714779ba6d3a2$export$8e3fc93123f96c19 = (cloudId)=>{
    return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};
const $2d6714779ba6d3a2$export$694ee0cc469a8709 = (isReadingAids, smartAnswersRoute)=>{
    if (isReadingAids) return (0, $f7lNm.AnswerCardType).DEFINITION;
    switch(smartAnswersRoute){
        case (0, $f7lNm.QueryIntent).PERSON:
            return (0, $f7lNm.AnswerCardType).PERSON;
        case (0, $f7lNm.QueryIntent).TEAM:
            return (0, $f7lNm.AnswerCardType).TEAM;
        case (0, $f7lNm.QueryIntent).AGENT:
            return (0, $f7lNm.AnswerCardType).AGENT;
        case (0, $f7lNm.QueryIntent).DATE:
            return (0, $f7lNm.AnswerCardType).DATE;
        case (0, $f7lNm.QueryIntent).LOCATION:
            return (0, $f7lNm.AnswerCardType).LOCATION;
        case (0, $f7lNm.QueryIntent).TOPIC:
            return (0, $f7lNm.AnswerCardType).TOPIC;
        case (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            return (0, $f7lNm.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY;
        case (0, $f7lNm.QueryIntent).JIRA_ISSUE:
            return (0, $f7lNm.AnswerCardType).JIRA_ISSUE;
        case (0, $f7lNm.QueryIntent).NAV_CONTENT:
            return (0, $f7lNm.AnswerCardType).NAV_CONTENT;
        case (0, $f7lNm.QueryIntent).BOOKMARK:
            return (0, $f7lNm.AnswerCardType).BOOKMARK_KNOWLEDGE_CARD;
        case (0, $f7lNm.QueryIntent).VISUAL:
            return (0, $f7lNm.AnswerCardType).VISUAL;
        case (0, $f7lNm.QueryIntent).ORG_CHART:
            return (0, $f7lNm.AnswerCardType).ORG_CHART;
        case (0, $f7lNm.QueryIntent).NAVIGATIONAL:
            return (0, $f7lNm.AnswerCardType).NAVIGATIONAL;
        case (0, $f7lNm.QueryIntent).NONE:
            return (0, $f7lNm.AnswerCardType).NONE;
        case (0, $f7lNm.QueryIntent).DEFAULT:
            return (0, $f7lNm.AnswerCardType).DEFAULT;
        case (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY:
        case (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM:
        default:
            return (0, $f7lNm.AnswerCardType).SAIN;
    }
};
module.exports["sha256Hash"] = $2d6714779ba6d3a2$export$e9131c78c1110376;
module.exports["extractUrlHostname"] = $2d6714779ba6d3a2$export$a3b7216c107a7a1;
module.exports["isHello"] = $2d6714779ba6d3a2$export$8e3fc93123f96c19;
module.exports["getAnswerCardType"] = $2d6714779ba6d3a2$export$694ee0cc469a8709;

});

parcelRegister("fjzE4", function(module, exports) {

var $7azCD = parcelRequire("7azCD");

const $f09d80c8646d0453$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $f09d80c8646d0453$export$72ebbc2f4d73897b = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $f09d80c8646d0453$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["getHighlightCategories"] = $f09d80c8646d0453$export$f600f3124ea5916b;

});

parcelRegister("bbPOv", function(module, exports) {
const $b754f76c2ea6a90a$export$b260340f6ff10d53 = 'PlatformHighlightKeywordsQuery';
const $b754f76c2ea6a90a$export$39b2bc657daf065 = `
	query ${$b754f76c2ea6a90a$export$b260340f6ff10d53}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["KEY_PHRASES_OPERATION_NAME"] = $b754f76c2ea6a90a$export$b260340f6ff10d53;
module.exports["KeyPhrasesQuery"] = $b754f76c2ea6a90a$export$39b2bc657daf065;

});

parcelRegister("14FKK", function(module, exports) {
// create separate utils folder if need to export more utils
const $e67d683b71b74003$var$validMarks = (data)=>{
    const invalidMarks = [
        'annotation',
        'link'
    ];
    return !data.marks || !data.marks.some((mark)=>invalidMarks.includes(mark.type));
};
const $e67d683b71b74003$var$validType = (data)=>{
    const invalidTypes = [
        'codeBlock'
    ];
    return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e67d683b71b74003$var$extractContent = (data, flatMap)=>{
    if ($e67d683b71b74003$var$validType(data)) {
        if (data.content && data.content.length > 0) for (const node of data.content)$e67d683b71b74003$var$extractContent(node, flatMap);
    }
    // leaf node
    if (data.type === 'text' && $e67d683b71b74003$var$validMarks(data)) flatMap.push(data);
};
const $e67d683b71b74003$export$4cf5403beffb0fc1 = (adfValue)=>{
    const flatMap = [];
    $e67d683b71b74003$var$extractContent(adfValue, flatMap);
    return flatMap.map((node)=>node.text).join(',');
};
module.exports["parseContent"] = $e67d683b71b74003$export$4cf5403beffb0fc1;

});

parcelRegister("eVM9z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eRXI0 = parcelRequire("eRXI0");


var $7Zbm6 = parcelRequire("7Zbm6");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $5Ymlp = parcelRequire("5Ymlp");


var $xhg8G = parcelRequire("xhg8G");


var $9nZle = parcelRequire("9nZle");


var $4WiNS = parcelRequire("4WiNS");


var $3qbRZ = parcelRequire("3qbRZ");

const $e71f869528412a13$var$i18n = (0, $aXWIB.defineMessages)({
    searchAiDialogQueryPretext: {
        id: "contextual-reading-aids.search-ai-dialog.query-pretext",
        defaultMessage: "what is {queryText}?"
    }
});
const $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE = 'No matching scope for Definition';
const $e71f869528412a13$export$7111b45b195dd101 = ({ workspaceId: workspaceId, cloudIdARI: cloudIdARI, fetchConfig: fetchConfig, isDefinitionCurationEnabled: isDefinitionCurationEnabled, productConfig: productConfig, product: product })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { contentId: contentId } = productConfig;
    const fetchAIGeneratedDefinition = (0, $42omo.useCallback)(async ({ variables: variables })=>{
        const { query: query, locale: locale, additional_context: additional_context, experience: experience, followUpsEnabled: followUpsEnabled } = variables;
        if (contentId !== '') try {
            const precomputedResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $4WiNS.PrecomputedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    contentId: contentId
                },
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (precomputedResult.data && !precomputedResult.data.knowledgeDiscovery.autoDefinition.message) {
                const data = {
                    nlpSearch: {
                        ...(0, $3qbRZ.mapCustomDefinitionToNLPSearchType)(precomputedResult.data.knowledgeDiscovery.autoDefinition),
                        extraAPIAnalyticsAttributes: {
                            requestId: precomputedResult.extensions?.gateway?.trace_id ?? null
                        }
                    }
                };
                setLoading(false);
                return data;
            } else if (precomputedResult.data && precomputedResult.data.knowledgeDiscovery.autoDefinition.message) throw new Error(precomputedResult.data.knowledgeDiscovery.autoDefinition.message);
            else throw new Error('Something went wrong with fetching precomputed definition');
        } catch (error) {
            if (error instanceof Object && 'message' in error && error.message !== $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $xhg8G.fetchPrecomputedDefinitionErrorPayload)(error, commonAttributes));
        }
        const streamFetchArgs = {
            variables: {
                query: intl.formatMessage($e71f869528412a13$var$i18n.searchAiDialogQueryPretext, {
                    queryText: query
                }),
                locale: locale,
                cloudIdARI: cloudIdARI,
                additional_context: additional_context,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            },
            isReadingAids: true,
            fetchConfig: fetchConfig,
            generatorConfig: {
                yieldAnswerPart: true,
                yieldFinalResponse: true
            },
            onStreamFinalResponse: ()=>{
                setLoading(false);
            }
        };
        return {
            type: (0, $7Zbm6.AIAnswerAPIType).STREAM,
            stream: (0, $5Ymlp.aiDefinitionsStreamFetchConvoAIService)(streamFetchArgs)
        };
    }, [
        cloudIdARI,
        fetchConfig,
        intl,
        commonAttributes,
        fireAnalyticsEvent,
        workspaceId,
        contentId,
        product
    ]);
    const fetchDefinition = (0, $42omo.useCallback)(async ({ variables: variables })=>{
        if (isDefinitionCurationEnabled) try {
            let confluenceScopeId, jiraScopeId;
            if ('spaceId' in productConfig) confluenceScopeId = productConfig;
            else if ('projectId' in productConfig) jiraScopeId = {
                projectId: productConfig.projectId
            };
            const result = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $9nZle.CuratedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    confluenceScopeId: confluenceScopeId,
                    jiraScopeId: jiraScopeId
                },
                operationName: (0, $9nZle.CURATED_DEFINITION_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (result.data && !result.data.knowledgeDiscovery.definition.message) {
                const data = {
                    nlpSearch: {
                        ...(0, $3qbRZ.mapCustomDefinitionToNLPSearchType)(result.data.knowledgeDiscovery.definition),
                        extraAPIAnalyticsAttributes: {
                            requestId: result.extensions?.gateway?.trace_id ?? null
                        }
                    }
                };
                setLoading(false);
                return data;
            } else if (result.data && result.data.knowledgeDiscovery.definition.message) throw new Error(result.data.knowledgeDiscovery.definition.message);
            else throw new Error('Something went wrong with fetching curated definition');
        } catch (error) {
            // want to fire event when error.message does not equal the no curated definition message
            // returned by the query in data.knowledgeDiscovery.definition.message
            if (error instanceof Object && 'message' in error && error.message !== $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $xhg8G.fetchCuratedDefinitionErrorPayload)(error, commonAttributes));
            return fetchAIGeneratedDefinition({
                variables: variables
            });
        }
        return fetchAIGeneratedDefinition({
            variables: variables
        });
    }, [
        productConfig,
        fetchAIGeneratedDefinition,
        isDefinitionCurationEnabled,
        workspaceId,
        commonAttributes,
        fireAnalyticsEvent,
        cloudIdARI,
        product
    ]);
    return {
        fetchDefinition: fetchDefinition,
        loading: loading
    };
};
module.exports["useDefinitionSupplier"] = $e71f869528412a13$export$7111b45b195dd101;

});

parcelRegister("eRXI0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $f7lNm = parcelRequire("f7lNm");

const $c9273af68a747a43$var$UNINITIALIZED_COMMON_ATTRIBUTES = {
    cloudId: '',
    query: '',
    queryHash: '',
    baseQueryHash: '',
    source: '',
    searchSessionId: '',
    answerString: '',
    answerLength: 0,
    answerWordCount: 0,
    answerFormat: null,
    answerCardType: (0, $f7lNm.AnswerCardType).SAIN,
    sources: [],
    followUps: [],
    errorStateSuggestedQueries: [],
    errorState: null,
    extraAttributes: {},
    apiSource: 'cc-search-nlp',
    workspaceId: '',
    sessionId: '',
    brand: (0, $f7lNm.AiBrand).AI,
    orgId: '',
    isHello: false
};
const $c9273af68a747a43$export$19a05d5f6391d0e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    loading: undefined,
    isAnswered: false,
    hasError: false,
    advancedSearchUrl: undefined,
    onNavigate: ()=>{},
    updateContextCache: ()=>{},
    fireAnalyticsEvent: ()=>{},
    setQuery: ()=>{},
    setData: ()=>{},
    userDetails: {},
    disclaimer: null,
    commonAttributes: $c9273af68a747a43$var$UNINITIALIZED_COMMON_ATTRIBUTES,
    initialCollapsed: undefined,
    liked: undefined,
    setLiked: ()=>{},
    likesDisabled: false,
    setLikesDisabled: ()=>{},
    initialReported: undefined,
    isReadingAids: false,
    dynamicLayoutSubAgentMessages: [],
    setDynamicLayoutSubAgentMessages: ()=>{},
    cardProviderProps: undefined,
    baseQuery: undefined,
    smartAnswersRoute: (0, $f7lNm.QueryIntent).DEFAULT,
    cardTemplate: (0, $f7lNm.CardTemplate).DEFAULT,
    brand: (0, $f7lNm.AiBrand).AI,
    answerEditor: undefined,
    closeParentDialog: ()=>{},
    showGenericFooter: false,
    initiallyExpanded: false,
    queryIntentClassificationData: undefined,
    traceHeaders: undefined
});
const $c9273af68a747a43$export$1485bfa2a4aa8c9b = ()=>{
    return (0, $42omo.useContext)($c9273af68a747a43$export$19a05d5f6391d0e1);
};
module.exports["AIAnswerContext"] = $c9273af68a747a43$export$19a05d5f6391d0e1;
module.exports["useAIAnswerContext"] = $c9273af68a747a43$export$1485bfa2a4aa8c9b;

});

parcelRegister("5Ymlp", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $epS7s = parcelRequire("epS7s");


var $iA4lt = parcelRequire("iA4lt");


var $7Zbm6 = parcelRequire("7Zbm6");


var $4Zqgi = parcelRequire("4Zqgi");


var $f7lNm = parcelRequire("f7lNm");


var $5Wlau = parcelRequire("5Wlau");

const $6ff046935ab0156c$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
function $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids) {
    return isReadingAids ? {
        named_id: 'reading_aids_agent',
        experience: 'reading-aids'
    } : {
        named_id: 'sain_agent',
        experience: 'sain'
    };
}
function $6ff046935ab0156c$var$mapMimeTypeToFormat(mimeType) {
    switch(mimeType){
        case 'text/markdown':
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $7Zbm6.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $7Zbm6.NLPSearchResultFormat).JSON;
        default:
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
    }
}
function $6ff046935ab0156c$var$mapErrorToSain(error, traceId) {
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswer
            };
        case 'NO_ANSWER_PEOPLE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion
            };
        case 'NO_ANSWER_KEYWORDS':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords
            };
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults
            };
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation
            };
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse
            };
        case 'FEATURE_DISABLED_ON_SITE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).AIDisabled
            };
        default:
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                networkErrorReason: 'unmapped_backend_error',
                networkErrorDetails: errorMessage,
                backendFailureType: 'unmapped_template'
            };
    }
}
function $6ff046935ab0156c$var$mapMessageToNLPSearchType(message, requestId) {
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message || message;
    return {
        nlpResult: messageContent.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $6ff046935ab0156c$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($6ff046935ab0156c$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : message.message?.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $dh538.fg)('kd_consolidate_sources_analytics') && {
                sources: message.sources
            },
            cacheInfo: message.message?.message_metadata?.global_cache_info ?? null,
            pluginInvocations: message.message?.plugin_invocations,
            rawJson: message,
            ...(0, $dh538.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            }
        }
    };
}
async function* $6ff046935ab0156c$export$87d234127b4babfd({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig }) {
    try {
        const { query: query, locale: locale, experience: experience, filters: filters, cloudIdARI: cloudIdARI, followUpsEnabled: followUpsEnabled } = variables || {};
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.SAIN_STREAMING_API)}`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                filters: filters,
                locations: [
                    cloudIdARI
                ],
                locale: locale,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            }),
            credentials: fetchConfig?.credentials || 'same-origin'
        }));
        if (!response.ok) // For non 200 status codes
        return {
            state: 'failed',
            reason: 'backend',
            details: 'Unhandled error response received',
            errorCode: response.status
        };
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = JSON.parse(line);
                    if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) yield parsedData;
                    else {
                        finalResponse = parsedData;
                        done = true;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
const $6ff046935ab0156c$var$getAgentInput = ({ variables: variables, fetchConfig: fetchConfig })=>{
    const { query: query, locale: locale, additional_context: additional_context, experimentContext: experimentContext, isQuerySuggestion: isQuerySuggestion } = variables || {};
    return {
        content: query,
        locale: locale,
        additional_context: additional_context,
        entity_ari: fetchConfig?.entity_ari,
        ...experimentContext && (0, $dh538.fg)('kd_sain_backend_exp_context') && {
            experimentContext: experimentContext
        },
        ...typeof isQuerySuggestion === 'boolean' ? {
            isQuerySuggestion: isQuerySuggestion
        } : {}
    };
};
const $6ff046935ab0156c$var$getPromptOverrideContext = ()=>{
    if (!(0, $dh538.fg)('convo_ai_sain_enable_prompt_override_hello_only')) return {};
    const promptOverride = (0, $epS7s.getSessionItem)((0, $f7lNm.PROMPT_OVERRIDE_SESSION_KEY));
    if (!promptOverride) return {};
    return {
        aiFeatureContext: {
            systemPromptOverride: promptOverride
        }
    };
};
async function* $6ff046935ab0156c$export$3e1bd964ad0ba888({ fetchReturn: fetchReturn, variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, storeMessage: storeMessage, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const { filters: filters, selectedProduct: selectedProduct } = variables || {};
        const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/sain/stream`;
        const streamFilters = filters && !Array.isArray(filters) && (0, $dh538.fg)('kd_add_common_filters_support_to_sain') ? [
            {
                commonFilters: filters.commonFilters
            },
            {
                confluenceFilters: filters.confluenceFilters
            }
        ] : [
            {
                confluenceFilters: filters
            }
        ];
        if (selectedProduct) streamFilters.push({
            knowledgeSources: [
                selectedProduct
            ]
        });
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience,
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: {
                    ...$6ff046935ab0156c$var$getAgentInput({
                        variables: variables,
                        fetchConfig: fetchConfig
                    }),
                    filters: filters ? streamFilters : undefined,
                    ...$6ff046935ab0156c$var$getPromptOverrideContext()
                },
                ...storeMessage
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            backendFailureType: 'empty_body'
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            const pluginsInvoked = [];
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status,
                        backendFailureType: 'hipaa'
                    };
                    // For non 200 status codes
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status,
                        backendFailureType: 'http_error'
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $5Wlau.mapStreamSAINResponse)(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === 'plugin-invocation') {
                        pluginsInvoked.push(parsedData.pluginName);
                        continue;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop) return {
                        state: 'complete',
                        value: parsedData
                    };
                    else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            if ((0, $dh538.fg)('kd_add_plugins_invoked')) {
                const filteredPluginsInvoked = pluginsInvoked.filter(Boolean);
                if (filteredPluginsInvoked.length > 0 && finalResponse.message) {
                    const existing = finalResponse.message.extraAPIAnalyticsAttributes?.pluginsInvoked ?? [];
                    finalResponse.message.extraAPIAnalyticsAttributes = {
                        ...finalResponse.message.extraAPIAnalyticsAttributes,
                        pluginsInvoked: [
                            ...new Set([
                                ...existing,
                                ...filteredPluginsInvoked
                            ])
                        ]
                    };
                }
            }
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
async function $6ff046935ab0156c$export$c8ae4e2310d6c222({ variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig }) {
    const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
    const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/chat/v1/invoke_agent`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': 'confluence',
            'X-Experience-Id': experience,
            ...fetchConfig?.headers
        },
        body: JSON.stringify({
            recipient_agent_named_id: named_id,
            agent_input: $6ff046935ab0156c$var$getAgentInput({
                variables: variables,
                fetchConfig: fetchConfig
            })
        }),
        credentials: fetchConfig?.credentials || 'same-origin',
        signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
    });
    const traceId = response.headers.get('x-trace-id') || null;
    const data = await response.json();
    if ('message_template' in data) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $6ff046935ab0156c$var$mapErrorToSain(data, traceId);
        return {
            nlpSearch: {
                errorState: errorState,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    return {
        nlpSearch: $6ff046935ab0156c$var$mapMessageToNLPSearchType(data, traceId)
    };
}
async function* $6ff046935ab0156c$export$824b789d24de77d3({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/ai-definition`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': 'reading-aids',
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                ...$6ff046935ab0156c$var$getAgentInput({
                    variables: variables,
                    fetchConfig: fetchConfig
                })
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            backendFailureType: 'empty_body'
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status,
                        backendFailureType: 'hipaa'
                    };
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status,
                        backendFailureType: 'http_error'
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $5Wlau.mapStreamDefinitionResponse)(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
module.exports["sainStreamFetchConvoAIService"] = $6ff046935ab0156c$export$3e1bd964ad0ba888;
module.exports["aiDefinitionsStreamFetchConvoAIService"] = $6ff046935ab0156c$export$824b789d24de77d3;

});

parcelRegister("epS7s", function(module, exports) {

var $c4TO3 = parcelRequire("c4TO3");


var $dh538 = parcelRequire("dh538");

const $760a00543381114b$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $760a00543381114b$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $760a00543381114b$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $760a00543381114b$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $760a00543381114b$var$getWindow = ()=>typeof window !== 'undefined' ? window : null;
const $760a00543381114b$export$fdf7104ff19cc288 = (key)=>{
    const windowReady = $760a00543381114b$var$getWindow();
    if (!windowReady) return null;
    return (0, $dh538.fg)('search_page_use_bsc_session_storage') ? (0, $c4TO3.AtlBrowserStorageSession).getItem(key) : $760a00543381114b$var$getWindow()?.sessionStorage.getItem(key);
};
const $760a00543381114b$export$a5376dd4adeb0fbf = (key, value)=>{
    const windowReady = $760a00543381114b$var$getWindow();
    if (!windowReady) return;
    try {
        if ((0, $dh538.fg)('search_page_use_bsc_session_storage')) (0, $c4TO3.AtlBrowserStorageSession).setItem(key, value);
        else $760a00543381114b$var$getWindow()?.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $760a00543381114b$export$5896963da935fdc4 = (key)=>{
    const windowReady = $760a00543381114b$var$getWindow();
    if (!windowReady) return;
    if ((0, $dh538.fg)('search_page_use_bsc_session_storage')) (0, $c4TO3.AtlBrowserStorageSession).removeItem(key);
    else $760a00543381114b$var$getWindow()?.sessionStorage.removeItem(key);
};
module.exports["SEARCH_QUERY_KEY"] = $760a00543381114b$export$240cb7dc75f6cac2;
module.exports["SEARCH_FILTERS_KEY"] = $760a00543381114b$export$978fb20afa14aaa7;
module.exports["SEARCH_SHOW_AI_DIALOG_KEY"] = $760a00543381114b$export$f4dca218ecb5824a;
module.exports["getSessionItem"] = $760a00543381114b$export$fdf7104ff19cc288;
module.exports["setSessionItem"] = $760a00543381114b$export$a5376dd4adeb0fbf;
module.exports["deleteSessionItem"] = $760a00543381114b$export$5896963da935fdc4;

});

parcelRegister("iA4lt", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $4vEoF = parcelRequire("4vEoF");

const $3a954310db248169$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError })=>{
    try {
        const cohort = (0, $c6GJD.default).getExperiment(abTestId).get('cohort', (0, $4vEoF.Cohort).Default);
        const serveExperiment = cohort === (0, $4vEoF.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $4vEoF.Cohort).Default
    };
};
const $3a954310db248169$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).checkGate('search-experiment-overrides-killswitch')) return $3a954310db248169$var$defaultCheckGate;
    if (!overrides) return $3a954310db248169$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $3a954310db248169$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $3a954310db248169$var$defaultCheckGate;
    }
};
const $3a954310db248169$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).checkGate('search-experiment-overrides-killswitch')) return $3a954310db248169$export$a68238496eb1c8ce;
    if (!overrides) return $3a954310db248169$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $3a954310db248169$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $4vEoF.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $3a954310db248169$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $3a954310db248169$var$defaultCheckGate = (name)=>(0, $c6GJD.default).checkGate(name);
const $3a954310db248169$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $c6GJD.default).getLayer(layerName, options);
    return undefined;
};
module.exports["getFrontendExperiment"] = $3a954310db248169$export$a68238496eb1c8ce;
module.exports["createFeatureGateHandler"] = $3a954310db248169$export$8774a01dc80b4a26;
module.exports["createFrontendExperimentHandler"] = $3a954310db248169$export$841981a8a1feee8d;
module.exports["getMutuallyExclusiveUIExperiment"] = $3a954310db248169$export$b8cc3cdd046fba93;

});

parcelRegister("4vEoF", function(module, exports) {
var $f534e05ac776c43b$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});
module.exports["Cohort"] = $f534e05ac776c43b$export$b76685d1b5a37732;

});

parcelRegister("4Zqgi", function(module, exports) {

var $97HEP = parcelRequire("97HEP");

const $2afb97bb773ddd18$var$error = async ({ error: error, functionName: functionName, traceId: traceId })=>{
    try {
        const SentryClient = await (0, $97HEP.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('packageName', '@atlassian/search-ai');
            scope.setFingerprint([
                `functionName: ${functionName}`
            ]);
            if (traceId) scope.setTag('traceId', traceId);
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
const $2afb97bb773ddd18$export$af88d00dbe7f521 = {
    error: $2afb97bb773ddd18$var$error
};
module.exports["logger"] = $2afb97bb773ddd18$export$af88d00dbe7f521;

});

parcelRegister("97HEP", function(module, exports) {

var $3nPYZ = parcelRequire("3nPYZ");


var $1JvBr = parcelRequire("1JvBr");


var $g8CIJ = parcelRequire("g8CIJ");

let $effdb799a148a720$var$Sentry;
const $effdb799a148a720$var$beforeSend = (event)=>{
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    if (event.environment === 'development') return null;
    return event;
};

const $effdb799a148a720$export$f553e8b08ef59d31 = async ()=>{
    if (!$effdb799a148a720$var$Sentry) $effdb799a148a720$var$Sentry = Promise.resolve((parcelRequire("7hGsm"))).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $g8CIJ.SENTRY_DSN),
            attachStacktrace: true,
            release: (0, $3nPYZ.PRODUCT_BUILD) || (0, $g8CIJ.UNKNOWN_TAG),
            environment: (0, $1JvBr.getEnvironment)(),
            beforeSend: $effdb799a148a720$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $effdb799a148a720$var$Sentry;
};
module.exports["getSentryClient"] = $effdb799a148a720$export$f553e8b08ef59d31;

});

parcelRegister("3nPYZ", function(module, exports) {
// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 *  - For the service workers where window is not available, we return 'unknown'.
 */ const $caff51da97cfcbcc$export$668f31ea3127f48f = (typeof window !== 'undefined' && (window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION)) ?? 'unknown';
module.exports["PRODUCT_BUILD"] = $caff51da97cfcbcc$export$668f31ea3127f48f;

});

parcelRegister("1JvBr", function(module, exports) {
const $bfee5be0414bd1fa$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $bfee5be0414bd1fa$export$57570b1603cf6adb;

});

parcelRegister("g8CIJ", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/afm-search-ai/getting-started/
const $6ddb4d99fe6d7477$export$6faa4a850bc4d0ce = 'https://467ed23c400f1de490da05364bed5930@o55978.ingest.us.sentry.io/4507432686125056';
const $6ddb4d99fe6d7477$export$ea77880e3935182d = 'unknown';
module.exports["SENTRY_DSN"] = $6ddb4d99fe6d7477$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $6ddb4d99fe6d7477$export$ea77880e3935182d;

});

parcelRegister("5Wlau", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7Zbm6 = parcelRequire("7Zbm6");


var $4Zqgi = parcelRequire("4Zqgi");


var $59vy4 = parcelRequire("59vy4");


var $2NVuz = parcelRequire("2NVuz");

const $087142bc218bc052$var$mapMimeTypeToFormat = (mimeType)=>{
    switch(mimeType){
        case 'text/markdown':
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $7Zbm6.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $7Zbm6.NLPSearchResultFormat).JSON;
        default:
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
    }
};
const $087142bc218bc052$var$mapErrorTo = (error, traceId)=>{
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswer
            };
        case 'NO_ANSWER_PEOPLE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion
            };
        case 'NO_ANSWER_KEYWORDS':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords
            };
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults
            };
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation
            };
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse
            };
        case 'FEATURE_DISABLED_ON_SITE':
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).AIDisabled
            };
        default:
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                networkErrorReason: 'unmapped_backend_error',
                networkErrorDetails: errorMessage,
                backendFailureType: 'unmapped_template'
            };
    }
};
const $087142bc218bc052$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
const $087142bc218bc052$export$b4465cb8e5734ca9 = (message, requestId)=>{
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message;
    // The CSM streaming endpoint puts sources inside SAINMessage (message.message.sources)
    // rather than at the SAINAgentResponse level (message.sources). Fall back to the
    // nested location so citations and the Sources section render correctly for both the APIs.
    const sources = message.sources ?? message.message?.sources;
    return {
        nlpResult: (0, $dh538.fg)('kd_sain_extract_footnote') ? $087142bc218bc052$export$231abbb3de9b00b5(messageContent.content) : messageContent.content,
        uniqueSources: sources ? sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $087142bc218bc052$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($087142bc218bc052$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : messageContent.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $dh538.fg)('kd_consolidate_sources_analytics') && {
                sources: sources
            },
            cacheInfo: messageContent.message_metadata?.global_cache_info ?? null,
            pluginInvocations: messageContent.plugin_invocations,
            rawJson: message,
            ...(0, $dh538.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            },
            ...(0, $dh538.fg)('kd_add_plugins_invoked') && (()=>{
                const pluginNames = (messageContent.plugin_invocations ?? []).map((p)=>p.plugin_name).filter(Boolean);
                const minionOutputs = messageContent.minion_outputs ?? [];
                const minionIds = minionOutputs.flat().map((m)=>m.minion_id).filter(Boolean);
                const pluginsInvoked = [
                    ...pluginNames,
                    ...minionIds
                ];
                return pluginsInvoked.length > 0 ? {
                    pluginsInvoked: pluginsInvoked
                } : {};
            })()
        }
    };
};
const $087142bc218bc052$export$ed070f749797478 = (response, traceId)=>{
    if ((0, $2NVuz.isStreamError)(response)) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $087142bc218bc052$var$mapErrorTo(response, traceId);
        return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
            message: {
                errorState: errorState,
                errorCode: response.message.status_code,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    if ((0, $2NVuz.isStreamGenerationType)(response) && (0, $59vy4.SAINFeatureControl).canRenderLumina()) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType,
        message: {
            answer_generation_type: response.message.answer_generation_type
        }
    };
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamSAINResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $087142bc218bc052$export$b4465cb8e5734ca9(response.message, traceId)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    if ((0, $2NVuz.isStreamErrorStateQuerySuggestions)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions,
        suggested_queries: response.message.suggested_queries ?? []
    };
    if ((0, $59vy4.SAINFeatureControl).canRenderLumina()) {
        if ((0, $2NVuz.isStreamDynamicLayoutSubAgent)(response)) return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage,
            message: response.message
        };
    }
    if ((0, $dh538.fg)('kd_sain_early_stop_hello_exp_fg') || (0, $dh538.fg)('kd_sain_early_stop_customer_exp_fg')) {
        if ((0, $2NVuz.isStreamEarlyStop)(response)) {
            const earlyStopSearchResult = {
                nlpResult: response.message?.reason ?? '',
                format: null,
                uniqueSources: [],
                errorState: (0, $7Zbm6.NLPSearchErrorState).EarlyStop,
                disclaimer: null
            };
            return {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop,
                message: earlyStopSearchResult
            };
        }
    }
    if (response.type === 'PLUGIN_INVOCATION' && response.message?.plugin_name) return {
        type: 'plugin-invocation',
        pluginName: response.message.plugin_name
    };
    return {
        type: 'other'
    };
};
const $087142bc218bc052$export$b4d3daa122c7e257 = (message, traceId)=>{
    return {
        nlpResult: message.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
        extraAPIAnalyticsAttributes: {
            requestId: traceId ?? null,
            userQuery: message.human_message?.content ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $dh538.fg)('kd_consolidate_sources_analytics') && {
                sources: message.sources
            },
            rawJson: message
        }
    };
};
const $087142bc218bc052$export$fb9e9bea38ae660f = (response, traceId)=>{
    if ((0, $2NVuz.isStreamError)(response)) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $087142bc218bc052$var$mapErrorTo(response, traceId);
        return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
            message: {
                errorState: errorState,
                errorCode: response.message.status_code,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamDefinitionResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $087142bc218bc052$export$b4d3daa122c7e257(response.message, traceId)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
};
const $087142bc218bc052$export$231abbb3de9b00b5 = (result)=>{
    const removeFootnoteRegex = /\[\^(\d{1,2})\^\]:\s*https?:\/\/.*$/gm;
    const removeNonDigitCitationsRegex = /\[\^([a-zA-Z\-]+)\^\]/g;
    let cleanedAnswer = result.replace(removeFootnoteRegex, '').trim();
    cleanedAnswer = cleanedAnswer.replace(removeNonDigitCitationsRegex, '').trim();
    return cleanedAnswer;
};
module.exports["mapStreamSAINResponse"] = $087142bc218bc052$export$ed070f749797478;
module.exports["mapStreamDefinitionResponse"] = $087142bc218bc052$export$fb9e9bea38ae660f;

});

parcelRegister("59vy4", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $4OGlb = parcelRequire("4OGlb");


var $eUEtI = parcelRequire("eUEtI");

const $38536d7307700a9c$var$canRenderLuminaUnmemoized = ()=>{
    if ((0, $dh538.fg)('kd_dynamic_layout_in_sain')) return true;
    return false;
};
const $38536d7307700a9c$var$isBorderlessUXEnabledUnmemoized = ()=>{
    if ((0, $eUEtI.hasSAINHelloLayerParamValue)('LuminaInSAIN', 'test')) return true;
    if ((0, $eUEtI.hasSAINLayerParamValue)('LuminaInSAIN', 'test')) return true;
    return false;
};
const $38536d7307700a9c$var$isSAINUXUpliftEnabledUnmemoized = ()=>{
    const helloLayer = (0, $c6GJD.default).getLayer((0, $eUEtI.SAIN_HELLO_LAYER_NAME));
    const helloCustomersEnabled = helloLayer.get('isSainUXUpliftEnabled', false);
    const customerLayer = (0, $c6GJD.default).getLayer((0, $eUEtI.SAIN_LAYER_NAME));
    const customersEnabled = customerLayer.get('isSainUXUpliftEnabled', false);
    if (helloCustomersEnabled || customersEnabled) return true;
    return false;
};
const $38536d7307700a9c$var$isSourcesInShortSAINAnswersEnabledUnmemoized = ()=>{
    if ((0, $dh538.fg)('kd_sain_show_sources_in_short_answers')) return true;
    return (0, $eUEtI.hasSAINLayerParamValue)('sourcesInShortSAINAnswers', 'test');
};
const $38536d7307700a9c$var$isZeroQuerySuggestionsV1EnabledUnmemoized = (isHello)=>{
    if (isHello) return true;
    const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_ROVO_SEARCH_QF_EXPERIENCE_LAYER));
    const customersEnabled = layer.get('isZeroQuerySuggestionsV1Enabled', false);
    return customersEnabled;
};
const $38536d7307700a9c$var$isSourcesSidePanelEnabledUnmemoized = ()=>{
    if ((0, $eUEtI.hasSAINHelloLayerParamValue)('SAINSourcesUplift', 'SourcesInSidePanel')) return true;
    if ((0, $eUEtI.hasSAINLayerParamValue)('SAINSourcesUplift', 'SourcesInSidePanel')) return true;
    return false;
};
const $38536d7307700a9c$var$isSourcesFullWidthEnabledUnmemoized = ()=>{
    if ((0, $eUEtI.hasSAINHelloLayerParamValue)('SAINSourcesUplift', 'FullWidthSAIN')) return true;
    if ((0, $eUEtI.hasSAINLayerParamValue)('SAINSourcesUplift', 'FullWidthSAIN')) return true;
    return false;
};
const $38536d7307700a9c$var$isFullHeightLuminaEnabledUnmemoized = ()=>{
    if ((0, $dh538.fg)('kd_enable_full_height_lumina')) return true;
    return false;
};
const $38536d7307700a9c$var$isNonPrimaryClickTrackingEnabledUnmemoized = ()=>{
    if ((0, $dh538.fg)('kd_track_non_primary_clicks_gate')) return true;
    if ((0, $c6GJD.default).getExperimentValue('kd_track_non_primary_clicks', 'shouldTrackNonPrimaryClicks', 'control', {
        fireExperimentExposure: false
    }) === 'test') return true;
    return false;
};
const $38536d7307700a9c$var$triggerNonPrimaryClickTrackingExposure = ()=>{
    try {
        if (!(0, $dh538.fg)('kd_track_non_primary_clicks_gate')) (0, $c6GJD.default).manuallyLogExperimentExposure('kd_track_non_primary_clicks');
    } catch  {
    // Silently fail if FeatureGates is not available (e.g., in test environments)
    }
};
const $38536d7307700a9c$var$isJiraSAINCardSmartLinkEnabledUnmemoized = ({ sourceProduct: sourceProduct })=>{
    const { serveExperiment: serveJiraFPSNLQNavigationExperiment } = (0, $eUEtI.getJiraUIExperienceLayerFrontendExperiment)({
        abTestId: 'rovo_jira_nin_fps_nlq_navigation_exp'
    });
    const { serveExperiment: serveJiraFPSNLQNavigationTenantsExperiment } = (0, $eUEtI.getJiraUIExperienceTenantsLayerFrontendExperiment)({
        abTestId: 'rovo_jira_nin_fps_nlq_navigation_tenants_exp'
    });
    return sourceProduct === 'jira' && ((0, $dh538.fg)('kd_jira_sain_card_smartlink_fg') || serveJiraFPSNLQNavigationExperiment || serveJiraFPSNLQNavigationTenantsExperiment);
};
const $38536d7307700a9c$export$1f65635c37e1bde3 = {
    /** Controls whether frontend can parse and render lumina-formatted answers */ canRenderLumina: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$canRenderLuminaUnmemoized),
    /** Controls the borderless UX experiment (visual design refresh) */ isBorderlessUXEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isBorderlessUXEnabledUnmemoized),
    isSAINUXUpliftEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isSAINUXUpliftEnabledUnmemoized),
    isSourcesSidePanelEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isSourcesSidePanelEnabledUnmemoized),
    isSourcesFullWidthEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isSourcesFullWidthEnabledUnmemoized),
    isFullHeightLuminaEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isFullHeightLuminaEnabledUnmemoized),
    isSourcesInShortSAINAnswersEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isSourcesInShortSAINAnswersEnabledUnmemoized),
    isZeroQuerySuggestionsV1Enabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isZeroQuerySuggestionsV1EnabledUnmemoized),
    isNonPrimaryClickTrackingEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isNonPrimaryClickTrackingEnabledUnmemoized),
    triggerNonPrimaryClickTrackingExposure: $38536d7307700a9c$var$triggerNonPrimaryClickTrackingExposure,
    isJiraSAINCardSmartLinkEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))($38536d7307700a9c$var$isJiraSAINCardSmartLinkEnabledUnmemoized)
};
module.exports["SAINFeatureControl"] = $38536d7307700a9c$export$1f65635c37e1bde3;

});

parcelRegister("4OGlb", function(module, exports) {
const $8c848bb8ca35d190$export$71a8b319599e57dc = 'l1_premium_vs_standard';
const $8c848bb8ca35d190$export$c076c4dd9e9d1e6e = 'search_platform_layer_l1_standard';
const $8c848bb8ca35d190$export$23877616cb34cf0c = 'search_platform_layer_l1_premium';
const $8c848bb8ca35d190$export$68be56e20dba0ed5 = 'l2_premium_vs_standard';
const $8c848bb8ca35d190$export$f39fa5cd744578ae = 'search_platform_layer_l2_standard';
const $8c848bb8ca35d190$export$a36d8c2d9981ec2b = 'search_platform_layer_l2_premium';
const $8c848bb8ca35d190$export$fe025e19388affcf = 'search_platform_layer_l2_blending';
const $8c848bb8ca35d190$export$11e2cd4e8edc5e82 = 'search_platform_layer_l3';
const $8c848bb8ca35d190$export$9b30fb0a29b39382 = 'search_platform_layer_query_expansion';
const $8c848bb8ca35d190$export$a62089c95934ccf8 = 'enable_l3';
const $8c848bb8ca35d190$export$4e36729d15b3db9e = 'enable_query_rewrite';
const $8c848bb8ca35d190$export$87f92c12fc8bb620 = 'search_platform_non_overlapping_domain';
const $8c848bb8ca35d190$export$86bb6d2503529310 = 'search_platform_layer_l1';
const $8c848bb8ca35d190$export$722a4624bef605fa = 'search_platform_layer_l2';
const $8c848bb8ca35d190$export$1963cf4be1b2cd5e = 'search_platform_layer_l3';
const $8c848bb8ca35d190$export$a18b3b3caa760214 = 'search_platform_layer_query_expansion';
const $8c848bb8ca35d190$export$39bbb550e0341d58 = 'full_page_search_layer';
const $8c848bb8ca35d190$export$b669e8e4ed2b4c67 = 'quick_find_layer';
const $8c848bb8ca35d190$export$ee35a7247cdafe84 = 'search_platform_jira_layer';
const $8c848bb8ca35d190$export$2d33b7f91c9f9071 = 'search_platform_jira_layer_tenants_based';
const $8c848bb8ca35d190$export$dd8503a49fbff14d = 'rovo_search_qf_experience_layer';
const $8c848bb8ca35d190$export$afc3cbf9db978004 = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    controlId: 'default',
    abTestId: 'default'
};
const $8c848bb8ca35d190$export$fca208e1e43c6fac = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    experimentLayers: []
};
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM"] = $8c848bb8ca35d190$export$71a8b319599e57dc;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD"] = $8c848bb8ca35d190$export$c076c4dd9e9d1e6e;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM"] = $8c848bb8ca35d190$export$23877616cb34cf0c;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM"] = $8c848bb8ca35d190$export$68be56e20dba0ed5;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD"] = $8c848bb8ca35d190$export$f39fa5cd744578ae;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM"] = $8c848bb8ca35d190$export$a36d8c2d9981ec2b;
module.exports["STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER"] = $8c848bb8ca35d190$export$fe025e19388affcf;
module.exports["STATSIG_SEARCH_BACKEND_L3_LAYER"] = $8c848bb8ca35d190$export$11e2cd4e8edc5e82;
module.exports["STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER"] = $8c848bb8ca35d190$export$9b30fb0a29b39382;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED"] = $8c848bb8ca35d190$export$a62089c95934ccf8;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED"] = $8c848bb8ca35d190$export$4e36729d15b3db9e;
module.exports["STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN"] = $8c848bb8ca35d190$export$87f92c12fc8bb620;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_NAME"] = $8c848bb8ca35d190$export$86bb6d2503529310;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_NAME"] = $8c848bb8ca35d190$export$722a4624bef605fa;
module.exports["STATSIG_SEARCH_BACKEND_L3_LAYER_NAME"] = $8c848bb8ca35d190$export$1963cf4be1b2cd5e;
module.exports["STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME"] = $8c848bb8ca35d190$export$a18b3b3caa760214;
module.exports["STATSIG_FULL_PAGE_SEARCH_LAYER"] = $8c848bb8ca35d190$export$39bbb550e0341d58;
module.exports["STATSIG_QUICK_FIND_LAYER"] = $8c848bb8ca35d190$export$b669e8e4ed2b4c67;
module.exports["STATSIG_SEARCH_PLATFORM_JIRA_LAYER"] = $8c848bb8ca35d190$export$ee35a7247cdafe84;
module.exports["STATSIG_SEARCH_PLATFORM_JIRA_LAYER_TENANTS_BASED"] = $8c848bb8ca35d190$export$2d33b7f91c9f9071;
module.exports["STATSIG_ROVO_SEARCH_QF_EXPERIENCE_LAYER"] = $8c848bb8ca35d190$export$dd8503a49fbff14d;
module.exports["DEFAULT_STATSIG_EXPERIMENT_CONFIG"] = $8c848bb8ca35d190$export$afc3cbf9db978004;
module.exports["DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG"] = $8c848bb8ca35d190$export$fca208e1e43c6fac;

});

parcelRegister("eUEtI", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $c6GJD = parcelRequire("c6GJD");


var $4OGlb = parcelRequire("4OGlb");


var $iA4lt = parcelRequire("iA4lt");


var $4Zqgi = parcelRequire("4Zqgi");

const $ff35af2675612b0e$export$5091efb9b1abe9af = 'kd_sain_layer';
const $ff35af2675612b0e$export$61cd502eadfc7f4a = 'kd_sain_hello_layer';
const $ff35af2675612b0e$export$fb4dba971e54444f = 'rovo_jira_ui_experience_layer';
const $ff35af2675612b0e$export$50eae6f311ab1b36 = 'rovo_jira_ui_tenants_experience_layer';
function $ff35af2675612b0e$export$c5e2c0a7fe245f7d() {
    const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), {
        fireLayerExposure: false
    });
    const abTestId = layer.get('abTestId', 'no_ab_test_id');
    if (abTestId === 'kd_disable_sain_experiment') {
        const backendExperimentData = layer.get('backendChanges', {
            sain: true
        });
        if (!backendExperimentData?.sain) return true;
    }
    return false;
}
function $ff35af2675612b0e$var$doesLayerFrontendExperimentExist(layerName, abTestId) {
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const layerFrontendExperimentName = layer.get('frontendExperimentName', null);
    return layerFrontendExperimentName !== null && layerFrontendExperimentName === abTestId;
}
function $ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({ layerName: layerName, abTestId: abTestId, onError: onError }) {
    const falseEvaluationResult = {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: 'not-enrolled'
    };
    const handleError = (error)=>{
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: `getLayerFrontendExperimentUnmemoized(${layerName})`
        });
        onError?.(error);
    };
    try {
        // we skip experiment evaluation if the user is part of the SAIN holdback experiment test cohort,
        // because SAIN is disabled in this case
        if ($ff35af2675612b0e$export$c5e2c0a7fe245f7d()) return falseEvaluationResult;
        if ($ff35af2675612b0e$var$doesLayerFrontendExperimentExist(layerName, abTestId)) return (0, $iA4lt.getFrontendExperiment)({
            abTestId: abTestId,
            onError: handleError
        });
    } catch (error) {
        handleError(error);
    }
    return falseEvaluationResult;
}
const $ff35af2675612b0e$export$3de2a2aa2c11f251 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$5091efb9b1abe9af
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$5c2fc79d2a515e54 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$61cd502eadfc7f4a
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$2ae87375886cb5b0 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$fb4dba971e54444f
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$399aed7d323465a6 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$50eae6f311ab1b36
    }), ({ abTestId: abTestId })=>abTestId);
function $ff35af2675612b0e$var$getLayerFrontendMultiArmExperimentUnmemoized({ layerName: layerName, abTestId: abTestId, onError: onError }) {
    const handleError = (error)=>{
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: `getLayerFrontendExperimentUnmemoized(${layerName})`
        });
        onError?.(error);
    };
    try {
        // we skip experiment evaluation if the user is part of the SAIN holdback experiment test cohort,
        // because SAIN is disabled in this case
        if (!$ff35af2675612b0e$export$c5e2c0a7fe245f7d() && $ff35af2675612b0e$var$doesLayerFrontendExperimentExist(layerName, abTestId)) {
            const experiment = (0, $c6GJD.default).getExperiment(abTestId);
            const cohort = experiment.get('cohort', 'not-enrolled');
            return {
                abTestId: abTestId,
                cohort: cohort
            };
        }
    } catch (error) {
        handleError(error);
    }
    return {
        abTestId: abTestId,
        cohort: 'not-enrolled'
    };
}
const $ff35af2675612b0e$export$3e4672526d3420fc = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$5091efb9b1abe9af
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$7ea065ff36b2919b = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((params)=>$ff35af2675612b0e$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $ff35af2675612b0e$export$61cd502eadfc7f4a
    }), ({ abTestId: abTestId })=>abTestId);
const $ff35af2675612b0e$export$ef7d89c571d837a1 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((paramName)=>{
    const layer = (0, $c6GJD.default).getLayer($ff35af2675612b0e$export$5091efb9b1abe9af);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $ff35af2675612b0e$export$98e9af5151f46651 = (paramName, paramValue)=>{
    return $ff35af2675612b0e$export$ef7d89c571d837a1(paramName) === paramValue;
};
const $ff35af2675612b0e$export$2a3e1ea63f6e0a96 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((paramName)=>{
    const layer = (0, $c6GJD.default).getLayer($ff35af2675612b0e$export$61cd502eadfc7f4a);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $ff35af2675612b0e$export$acf5b4af6876c34 = (paramName, paramValue)=>{
    return $ff35af2675612b0e$export$2a3e1ea63f6e0a96(paramName) === paramValue;
};
module.exports["SAIN_LAYER_NAME"] = $ff35af2675612b0e$export$5091efb9b1abe9af;
module.exports["SAIN_HELLO_LAYER_NAME"] = $ff35af2675612b0e$export$61cd502eadfc7f4a;
module.exports["getSAINLayerFrontendExperiment"] = $ff35af2675612b0e$export$3de2a2aa2c11f251;
module.exports["getJiraUIExperienceLayerFrontendExperiment"] = $ff35af2675612b0e$export$2ae87375886cb5b0;
module.exports["getJiraUIExperienceTenantsLayerFrontendExperiment"] = $ff35af2675612b0e$export$399aed7d323465a6;
module.exports["hasSAINLayerParamValue"] = $ff35af2675612b0e$export$98e9af5151f46651;
module.exports["hasSAINHelloLayerParamValue"] = $ff35af2675612b0e$export$acf5b4af6876c34;

});

parcelRegister("2NVuz", function(module, exports) {
/** Types copied from platform/packages/ai-mate/conversation-assistant/src/services/assistance-service/types.ts for now */ var $605e1a783968ada3$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $605e1a783968ada3$export$255ec938a30a2b3 = /*#__PURE__*/ function(StreamAnswerGenerationTypes) {
    StreamAnswerGenerationTypes["LUMINA"] = "LUMINA";
    StreamAnswerGenerationTypes["STANDARD"] = "STANDARD";
    return StreamAnswerGenerationTypes;
}({});
const $605e1a783968ada3$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $605e1a783968ada3$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $605e1a783968ada3$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $605e1a783968ada3$export$c563bc6129a38894 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $605e1a783968ada3$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
const $605e1a783968ada3$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $605e1a783968ada3$export$cfb6b6bb809f778e = (message)=>message instanceof Object && message.type === 'FOLLOW_UP_QUERIES';
const $605e1a783968ada3$export$de29cc71fd2aafc1 = (message)=>message instanceof Object && message.type === 'ERROR_STATE_QUERY_SUGGESTIONS';
const $605e1a783968ada3$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $605e1a783968ada3$export$b6b59db8d0b45219 = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $605e1a783968ada3$export$1598409b78d1d369 = (message)=>message instanceof Object && message.type === 'EARLY_STOP';
const $605e1a783968ada3$export$53e95dec5f877b4e = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
module.exports["StreamAnswerGenerationTypes"] = $605e1a783968ada3$export$255ec938a30a2b3;
module.exports["isStreamError"] = $605e1a783968ada3$export$d422a2733a3b5def;
module.exports["isStreamAnswerPart"] = $605e1a783968ada3$export$e45102edbc73b240;
module.exports["isStreamGenerationType"] = $605e1a783968ada3$export$c563bc6129a38894;
module.exports["isStreamTrace"] = $605e1a783968ada3$export$fd5a05be03f147a0;
module.exports["isStreamFollowUp"] = $605e1a783968ada3$export$cfb6b6bb809f778e;
module.exports["isStreamErrorStateQuerySuggestions"] = $605e1a783968ada3$export$de29cc71fd2aafc1;
module.exports["isStreamDynamicLayoutSubAgent"] = $605e1a783968ada3$export$5fa02529cd2ab34c;
module.exports["isStreamSAINResponse"] = $605e1a783968ada3$export$b6b59db8d0b45219;
module.exports["isStreamEarlyStop"] = $605e1a783968ada3$export$1598409b78d1d369;
module.exports["isStreamDefinitionResponse"] = $605e1a783968ada3$export$53e95dec5f877b4e;

});

parcelRegister("xhg8G", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");

const $d691b863678f8843$export$1b6ec2a437dbf65e = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$b3c6d7a1ecb4efe1 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiPrecomputedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$ef8b7cdd9a33efb4 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionUpdate',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$48200d71a3e25afe = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiDefinitionToggle',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
module.exports["fetchCuratedDefinitionErrorPayload"] = $d691b863678f8843$export$1b6ec2a437dbf65e;
module.exports["fetchPrecomputedDefinitionErrorPayload"] = $d691b863678f8843$export$b3c6d7a1ecb4efe1;
module.exports["updateDefinitionErrorPayload"] = $d691b863678f8843$export$ef8b7cdd9a33efb4;
module.exports["toggleDefinitionErrorPayload"] = $d691b863678f8843$export$48200d71a3e25afe;

});

parcelRegister("9nZle", function(module, exports) {
// query to check whether curated definition exists
const $797cf255205c2458$export$9051e5c888508a3d = 'CuratedDefinitionQuery';
const $797cf255205c2458$export$1886f34f107a0451 = `
query ${$797cf255205c2458$export$9051e5c888508a3d}(
		$workspaceId: String!
		$keyPhrase: String!
		$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
		$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
	) {
		knowledgeDiscovery {
			definition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				confluenceScopeId: $confluenceScopeId
				jiraScopeId: $jiraScopeId
			) @optIn(to: "KnowledgeDiscovery Get definition") {
				__typename
				... on KnowledgeDiscoveryDefinition {
					definition
					accountId
					createdAt
					editor {
						... on User {
							name
							accountId
						}
					}
					referenceUrl
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["CURATED_DEFINITION_OPERATION_NAME"] = $797cf255205c2458$export$9051e5c888508a3d;
module.exports["CuratedDefinitionQuery"] = $797cf255205c2458$export$1886f34f107a0451;

});

parcelRegister("4WiNS", function(module, exports) {
const $205ce4d60dc88166$export$73cd67d787c37f2e = `
query PrecomputedDefinitionQuery(
		$workspaceId: String!
		$keyPhrase: String!
        $contentId: String!
	) {
		knowledgeDiscovery {
			autoDefinition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				contentId: $contentId
			) @optIn(to: "KnowledgeDiscovery Get auto definition") {
				__typename
				... on KnowledgeDiscoveryAutoDefinition {
					definition
                    createdAt
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
					}
				}
				... on QueryError {
					message
                    extensions {
                        statusCode
                        errorType
                    }
				}
			}
		}
	}
`;
module.exports["PrecomputedDefinitionQuery"] = $205ce4d60dc88166$export$73cd67d787c37f2e;

});

parcelRegister("3qbRZ", function(module, exports) {

var $7Zbm6 = parcelRequire("7Zbm6");

const $9a638390fddaeddf$export$faaccabd846a199 = (definition)=>{
    const definitionReference = definition.confluenceEntity;
    return {
        nlpResult: definition.definition,
        uniqueSources: definitionReference ? [
            {
                id: definitionReference?.id || '',
                title: definitionReference?.title || '',
                url: 'referenceUrl' in definition ? definition.referenceUrl || '' : 'links' in definitionReference && definitionReference.links.base && definitionReference.links.webUi ? `${definitionReference.links.base}${definitionReference.links.webUi}` : '',
                type: definitionReference?.type || '',
                // Currently curated and precomputed definitions sources can only be Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: 'editor' in definition ? {
            name: definition.editor?.name || '',
            id: definition.editor?.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
        customDefinitionType: 'editor' in definition ? (0, $7Zbm6.NLPSearchCustomDefinitionType).CURATED : (0, $7Zbm6.NLPSearchCustomDefinitionType).PRECOMPUTED
    };
};
module.exports["mapCustomDefinitionToNLPSearchType"] = $9a638390fddaeddf$export$faaccabd846a199;

});

parcelRegister("kNfRw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aFuYc = parcelRequire("aFuYc");

const $88a1eed9115fe27e$var$existingHighlightedTextMap = new Map();
const $88a1eed9115fe27e$export$f9a15102b225398f = ({ children: children, match: match, marks: marks, startPos: startPos, definitionConfig: definitionConfig, sourceConfig: sourceConfig, keyPhrases: keyPhrases })=>{
    const contentARI = sourceConfig.contentARI;
    if (!$88a1eed9115fe27e$var$existingHighlightedTextMap.has(`${contentARI}-${match}`)) $88a1eed9115fe27e$var$existingHighlightedTextMap.set(`${contentARI}-${match}`, startPos);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            $88a1eed9115fe27e$var$existingHighlightedTextMap.delete(`${contentARI}-${match}`);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // no comments or links should be highlighted
    if (!(marks.has('annotation') || marks.has('link'))) {
        const nodeMatch = keyPhrases.find((node)=>node.keyPhrase === match);
        // only highlight first occurrence of the word
        if (!!nodeMatch && $88a1eed9115fe27e$var$existingHighlightedTextMap.get(`${contentARI}-${match}`) === startPos) return /*#__PURE__*/ (0, $l998X.jsx)((0, $aFuYc.DefinitionTextHighlighter), {
            keyPhraseCategory: nodeMatch.category,
            definitionConfig: definitionConfig,
            sourceConfig: sourceConfig,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["RendererDefinitionTextHighlighter"] = $88a1eed9115fe27e$export$f9a15102b225398f;

});

parcelRegister("aFuYc", function(module, exports) {
/* definition-text-highlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $dQl1W = parcelRequire("dQl1W");


var $cVtio = parcelRequire("cVtio");


var $7DCm4 = parcelRequire("7DCm4");


var $jWDKZ = parcelRequire("jWDKZ");


var $9pwVP = parcelRequire("9pwVP");


var $7wVkn = parcelRequire("7wVkn");

const $adc6ea8a600cb787$var$definitionWrapperStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $adc6ea8a600cb787$var$DefinitionHighlighter = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showHighlight: showHighlight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_11qfq0e": (0, $7sObp.default)(__cmplp.showHighlight ? 'solid' : 'none')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_5pioz8co _189e1dm9 _1il9buyh _19lc184f _d0altlke",
            __cmplp.className
        ])
    });
});
const $adc6ea8a600cb787$export$5f4d22ccfacd381d = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, definitionConfig: definitionConfig, keyPhraseCategory: keyPhraseCategory, sourceConfig: sourceConfig })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const definitionSessionId = (0, $42omo.useRef)((0, $dQl1W.v4)()).current; // controls whether to show underline highlight
    const [showHighlight, setShowHighlight] = (0, $42omo.useState)(true);
    const [definitionQuery, setDefinitionQuery] = (0, $42omo.useState)('');
    const [triggerPosition, setTriggerPosition] = (0, $42omo.useState)(undefined); // const [additionalContext, setAdditionalContext] = useState('');
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const onDefinitionSingleClick = (0, $42omo.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const eventTarget = e.target;
        if (!eventTarget || !(eventTarget instanceof Element)) return;
        await (0, $7DCm4.aiDefinitionsLoadUFOExperience).start();
        setShowHighlight(false);
        fireAnalyticsEvent((0, $9pwVP.onClickAutoDefinitionHighlights)({
            contentId: sourceConfig.contentId,
            sessionId: definitionSessionId,
            keyPhraseCategory: keyPhraseCategory
        })); // const selectedContext = eventTarget.parentElement;
        // const additionalContext = selectedContext
        // 	? selectedContext.textContent || selectedContext.innerText
        // 	: '';
        const rect = eventTarget.getBoundingClientRect(); // we only need to pass in height to popup; others are needed for manual define
        const acronymRect = {
            top: 0,
            left: 0,
            width: rect.width,
            height: rect.height
        };
        setDefinitionQuery(eventTarget.textContent || '');
        setTriggerPosition(acronymRect); // setAdditionalContext(additionalContext);
    }, [
        definitionSessionId,
        fireAnalyticsEvent,
        keyPhraseCategory,
        sourceConfig.contentId
    ]);
    const onDefinitionClick = (0, $jWDKZ.useTextHighlighterClickNative)({
        singleClickCallback: onDefinitionSingleClick,
        doubleClickCallback: ()=>{} // do nothing, actions menu takes over
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($adc6ea8a600cb787$var$DefinitionHighlighter, {
                showHighlight: showHighlight,
                onClick: onDefinitionClick,
                "data-testid": "definition-highlighter",
                children: children
            }),
            triggerPosition ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7wVkn.DefinitionPopup), {
                onClose: ()=>{
                    setTriggerPosition(undefined);
                    setShowHighlight(true);
                },
                triggerPosition: triggerPosition,
                queryConfig: {
                    query: definitionQuery,
                    additionalQueryContext: ''
                },
                sessionConfig: {
                    sessionId: definitionSessionId
                },
                sourceConfig: sourceConfig,
                definitionConfig: definitionConfig,
                definitionLoadingConfig: {
                    width: triggerPosition.width
                },
                onLoad: ()=>setShowHighlight(true)
            }) : null
        ]
    });
});
module.exports["DefinitionTextHighlighter"] = $adc6ea8a600cb787$export$5f4d22ccfacd381d;

});

parcelRegister("cVtio", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $f7lNm = parcelRequire("f7lNm");

const $ca77e5059fb214ed$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $ca77e5059fb214ed$export$e955abb82869dc84;

});

parcelRegister("7DCm4", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $399439794f928dc1$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $399439794f928dc1$export$5b2a28beea8d66c3 = new (0, $5aVN7.UFOExperience)(`${$399439794f928dc1$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $399439794f928dc1$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $399439794f928dc1$export$5b2a28beea8d66c3;

});

parcelRegister("jWDKZ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4dd7b9fe81a55e61$export$ab78b8e7dad428f8 = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $42omo.useState)({
        e: null
    });
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // single click
            if (state.e?.detail === 1) singleClickCallback(state.e);
            else if (state.e?.detail && state.e.detail > 1) doubleClickCallback(state.e);
            setState({
                e: null
            });
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            e: e
        });
    };
};
const $4dd7b9fe81a55e61$export$f93f1774a43b3eae = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $42omo.useState)({
        click: 0,
        e: null
    });
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // simple click
            if (state.click === 1) singleClickCallback(state.e);
            setState({
                e: null,
                click: 0
            });
        }, delay);
        // the duration between this click and the previous one
        // is less than the value of delay = double-click
        if (state.click === 2) doubleClickCallback(state.e);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            click: state.click + 1,
            e: e
        });
    };
};
module.exports["useTextHighlighterClickNative"] = $4dd7b9fe81a55e61$export$ab78b8e7dad428f8;
module.exports["useTextHighlighterClick"] = $4dd7b9fe81a55e61$export$f93f1774a43b3eae;

});

parcelRegister("7wVkn", function(module, exports) {
/* definition-popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lGgRw = parcelRequire("lGgRw");

const $7a4b02046260f338$var$popupContainerStyles = null;
const $7a4b02046260f338$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1pbyowjs"
        ]),
        children: children
    });
});
const $7a4b02046260f338$var$definitionPopupTriggerStylesStatic = null;

const $7a4b02046260f338$var$LazyDefinitionPopupContent = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eDJ4j")).then((module)=>({
            default: module.DefinitionPopupContent
        })));
function $7a4b02046260f338$export$576a6d4c65a0c923({ onClose: onClose, triggerPosition: triggerPosition, onLoad: onLoad, ...definitionPopupContentProps }) {
    const definitionPopupTriggerStylesDynamic = {
        height: `${triggerPosition.height}px`,
        left: `${triggerPosition.left}px`,
        top: `${triggerPosition.top}px`,
        width: `${triggerPosition.width}px`
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        content: ({ update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)($7a4b02046260f338$var$LazyDefinitionPopupContent, {
                    ...definitionPopupContentProps,
                    onClose: onClose,
                    onLoad: ()=>{
                        onLoad?.();
                        update();
                    }
                })
            }),
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: $7a4b02046260f338$var$CustomPopupContainer,
        testId: "definition-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                ...triggerProps,
                style: definitionPopupTriggerStylesDynamic,
                "data-testid": "definition-popup-trigger",
                className: (0, $gMc0m.default)([
                    "_tzy4idpf _kqswstnw _lcxvglyw _bfhk1j28 _1ltvidpf _94n5idpf"
                ])
            }),
        isOpen: true
    });
}
module.exports["DefinitionPopup"] = $7a4b02046260f338$export$576a6d4c65a0c923;

});

parcelRegister("eDJ4j", function(module, exports) {

let $aa87aae78c4e7113$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa87aae78c4e7113$var$load("h3ABO"),
    $aa87aae78c4e7113$var$load("9hYRW"),
    $aa87aae78c4e7113$var$load("kpm7S"),
    $aa87aae78c4e7113$var$load("5wC2D"),
    $aa87aae78c4e7113$var$load("2YffH"),
    $aa87aae78c4e7113$var$load("g7ggm"),
    $aa87aae78c4e7113$var$load("6mHrv"),
    $aa87aae78c4e7113$var$load("awWN9"),
    $aa87aae78c4e7113$var$load("9CYct"),
    $aa87aae78c4e7113$var$load("lHaTX"),
    $aa87aae78c4e7113$var$load("fP9Su"),
    $aa87aae78c4e7113$var$load("3KcX6"),
    $aa87aae78c4e7113$var$load("hZtKG"),
    $aa87aae78c4e7113$var$load("dkqvW"),
    $aa87aae78c4e7113$var$load("lVO3w"),
    $aa87aae78c4e7113$var$load("hyzoX"),
    $aa87aae78c4e7113$var$load("h9Ed7"),
    $aa87aae78c4e7113$var$load("eBRUf"),
    $aa87aae78c4e7113$var$load("kbRvk"),
    $aa87aae78c4e7113$var$load("tKhaz"),
    $aa87aae78c4e7113$var$load("hwT9D"),
    $aa87aae78c4e7113$var$load("j4Bpe"),
    $aa87aae78c4e7113$var$load("cD6Zr"),
    $aa87aae78c4e7113$var$load("fPSgL"),
    $aa87aae78c4e7113$var$load("8nbmv"),
    $aa87aae78c4e7113$var$load("k3jER"),
    $aa87aae78c4e7113$var$load("9wzNh"),
    $aa87aae78c4e7113$var$load("8YSo7"),
    $aa87aae78c4e7113$var$load("9ldRJ"),
    $aa87aae78c4e7113$var$load("9anPW"),
    $aa87aae78c4e7113$var$load("50ame"),
    $aa87aae78c4e7113$var$load("7do1E"),
    $aa87aae78c4e7113$var$load("77dkW"),
    $aa87aae78c4e7113$var$load("1MlIV"),
    $aa87aae78c4e7113$var$load("6iz6l"),
    $aa87aae78c4e7113$var$load("4SCW2"),
    $aa87aae78c4e7113$var$load("aXHNO"),
    $aa87aae78c4e7113$var$load("kmvek"),
    $aa87aae78c4e7113$var$load("Wowvf"),
    $aa87aae78c4e7113$var$load("421lv"),
    $aa87aae78c4e7113$var$load("dek7I"),
    $aa87aae78c4e7113$var$load("dYtBN"),
    $aa87aae78c4e7113$var$load("6wr18"),
    $aa87aae78c4e7113$var$load("kjZZD"),
    $aa87aae78c4e7113$var$load("7cDV0"),
    $aa87aae78c4e7113$var$load("ijD5W"),
    $aa87aae78c4e7113$var$load("3JSgG"),
    $aa87aae78c4e7113$var$load("37ldp"),
    $aa87aae78c4e7113$var$load("ffEVr"),
    $aa87aae78c4e7113$var$load("9AXkC"),
    $aa87aae78c4e7113$var$load("28arV"),
    $aa87aae78c4e7113$var$load("hhss7"),
    $aa87aae78c4e7113$var$load("l1BQC"),
    $aa87aae78c4e7113$var$load("jlSF3"),
    $aa87aae78c4e7113$var$load("hogcU"),
    $aa87aae78c4e7113$var$load("4pqtR"),
    $aa87aae78c4e7113$var$load("5XqRg"),
    $aa87aae78c4e7113$var$load("7EorR"),
    $aa87aae78c4e7113$var$load("77ceh")
]).then(()=>parcelRequire('bA47i'));

});

parcelRegister("bzqa9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $1iSzD = parcelRequire("1iSzD");


var $dPJCf = parcelRequire("dPJCf");


var $4qzKl = parcelRequire("4qzKl");


var $icKZN = parcelRequire("icKZN");

const $abb6860b27595ef6$export$8ce912bc34d0dbea = ()=>{
    const $ = (0, $frIzR.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== push) {
        t0 = (event, url)=>{
            if (!event?.isDefaultPrevented()) event?.preventDefault();
            if ((0, $icKZN.isClickEventToOpenNewTab)(event)) window.open(url, "_blank");
            else push(url);
        };
        $[0] = push;
        $[1] = t0;
    } else t0 = $[1];
    const handleClick = t0;
    let t1;
    if ($[2] !== handleClick) {
        t1 = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() ? {
            mention: {
                onClick: async (userId, _, event_0)=>{
                    event_0?.preventDefault();
                    event_0?.stopPropagation();
                    const url_0 = await (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId);
                    handleClick(event_0, url_0);
                }
            },
            link: {
                onClick (e, url_1) {
                    handleClick(e, url_1);
                }
            },
            smartCard: {
                onClick (e_0, url_2) {
                    handleClick(e_0, url_2);
                }
            }
        } : undefined;
        $[2] = handleClick;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useEventHandlers"] = $abb6860b27595ef6$export$8ce912bc34d0dbea;

});

parcelRegister("h0UOA", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $jibmA = parcelRequire("jibmA");

const $f3a2ccfb73948f5b$export$68bee16d64211457 = (0, $2XqLN.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        link: {
            onClick (e, url) {
                const isInlineComment = e.target instanceof Element && e.target.matches('[data-mark-annotation-type="inlineComment"]');
                if (isInlineComment) return;
                const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
                if ((0, $jibmA.isExternalLink)(url)) {
                    e.preventDefault();
                    window.open(url, '_blank', 'noopener, noreferrer');
                } else if (details?.href && details.href === url) {
                    e.preventDefault();
                    routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
                }
            }
        }
    } : undefined);
module.exports["createLinkEventHandler"] = $f3a2ccfb73948f5b$export$68bee16d64211457;

});

parcelRegister("chaNr", function(module, exports) {
const $edb96fd8df3233f3$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $edb96fd8df3233f3$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $edb96fd8df3233f3$export$718381a72a965ef3 = [
    'jira',
    'attachments',
    'bgcolor',
    'blog-posts',
    'center',
    'chart',
    'column',
    'contentbylabel',
    'content-by-user',
    'rw-ui-layout-macro',
    'content-report-table',
    'profile-picture',
    'contributors-summary',
    'copyright',
    'excerpt',
    'excerpt-include',
    'fancy-bullets',
    'favpages',
    'gallery',
    'global-reports',
    'map',
    'highlight',
    'listlabels',
    'mathblock',
    'mathinline',
    'loremipsum',
    'navmap',
    'network',
    'index',
    'details',
    'detailssummary',
    'panel',
    'popular-labels',
    'privacy-mark',
    'privacy-policy',
    'recently-updated',
    'recently-used-labels',
    'reg-tm',
    'section',
    'sm',
    'space-details',
    'strike',
    'tasks-report-macro',
    'tm',
    'rw-ui-textbox-macro',
    'userlister',
    'profile',
    'jirachart',
    'jiraroadmap',
    'gadget',
    'contributors',
    'widget'
];
module.exports["FALLBACK_REASONS"] = $edb96fd8df3233f3$export$a4903313a3329d59;
module.exports["supportedMacroExtensions"] = $edb96fd8df3233f3$export$718381a72a965ef3;

});

parcelRegister("1C1zB", function(module, exports) {
/* eslint-disable react/jsx-boolean-value */ 
var $42omo = parcelRequire("42omo");


var $5kjCz = parcelRequire("5kjCz");


var $8pcS0 = parcelRequire("8pcS0");


var $fuLIO = parcelRequire("fuLIO");


var $9wGTI = parcelRequire("9wGTI");


var $kycWk = parcelRequire("kycWk");

var $F4YLX = parcelRequire("F4YLX");


var $chaNr = parcelRequire("chaNr");


var $lXP6p = parcelRequire("lXP6p");


var $ajkp0 = parcelRequire("ajkp0");

const $4ff570b9d2ed6508$var$getRedactionExtensionHandler = (contentId)=>(extension)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
            contentId: contentId,
            extensionNode: extension,
            isCommentContext: true
        });
    };
const $4ff570b9d2ed6508$export$fe33197d44e10fcf = (setLegacyRendererFlag, contentId, spaceKey, mode)=>{
    const macroHandler = {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $4ff570b9d2ed6508$var$getMacroExtensionHandler({
            setLegacyRendererFlag: setLegacyRendererFlag,
            contentId: contentId,
            spaceKey: spaceKey,
            mode: mode
        })
    };
    const migrationHandler = {
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: $4ff570b9d2ed6508$var$getMigrationExtensionHandler(setLegacyRendererFlag, contentId)
    };
    const redactionHandler = (0, $9wGTI.fg)('confluence_dlp_comment_redaction') ? {
        [(0, $kycWk.REDACTION_EXTENSION_TYPE)]: $4ff570b9d2ed6508$var$getRedactionExtensionHandler(contentId)
    } : {};
    return {
        ...macroHandler,
        ...migrationHandler,
        ...redactionHandler
    };
};
const $4ff570b9d2ed6508$var$getMacroExtensionHandler = ({ setLegacyRendererFlag: setLegacyRendererFlag, contentId: contentId, spaceKey: spaceKey, mode: mode })=>(extension)=>{
        const { extensionKey: extensionKey } = extension;
        if (setLegacyRendererFlag) setLegacyRendererFlag(extensionKey);
        if ((0, $chaNr.supportedMacroExtensions).includes(extensionKey)) {
            const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
            const macroDefaultProps = {
                node: extension,
                contentId: contentId || '',
                mode: mode || (0, $5kjCz.RENDERER),
                spaceKey: spaceKey || '',
                extensionKey: extensionKey,
                attributes: attributes
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ajkp0.UnsupportedFallbackComponent), null);
    };
const $4ff570b9d2ed6508$var$getMigrationExtensionHandler = (setLegacyRendererFlag, contentId)=>(extension)=>{
        const { extensionKey: extensionKey } = extension;
        if (extensionKey === (0, $8pcS0.MIGRATION_EXTENSION_KEYS).INVALID) {
            if (setLegacyRendererFlag) setLegacyRendererFlag();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ajkp0.UnsupportedFallbackComponent), null);
        }
        if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE || extensionKey === (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE) {
            if (setLegacyRendererFlag) setLegacyRendererFlag(extensionKey);
            return contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lXP6p.FallbackComponent), {
                contentId: contentId
            }) : null;
        }
        return null;
    };
module.exports["getExtensionHandlers"] = $4ff570b9d2ed6508$export$fe33197d44e10fcf;

});

parcelRegister("lXP6p", function(module, exports) {

var $eJfvT = parcelRequire("eJfvT");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $8tdj3 = parcelRequire("8tdj3");


var $6xdDU = parcelRequire("6xdDU");


var $jMyy4 = parcelRequire("jMyy4");


var $cutWg = parcelRequire("cutWg");

const $0d195c36a2d7770a$var$StyledContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt45uws _1e0c1txw _10rcu2gc",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$CommentSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41g6e _1e0c1txw _99ztu2gc",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$CommentSkeletonLine = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "%")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _bfhkizff _4t3i1crf _otyru2gc _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$export$23216ae99c93d0b = ({ contentId: contentId })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $eJfvT.default), {
        variables: {
            contentId: contentId ?? ''
        }
    });
    const buildUserObject = (data)=>{
        const userId = data?.content?.nodes?.[0]?.history?.createdBy?.accountId;
        const avatarUrl = data?.content?.nodes?.[0]?.history?.createdBy?.profilePicture?.path;
        const displayName = data?.content?.nodes?.[0]?.history?.createdBy?.displayName;
        return {
            userId: userId,
            avatarUrl: avatarUrl,
            displayName: displayName
        };
    };
    const handleCloseModal = (0, $42omo.useCallback)(()=>{
        setIsOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const user = buildUserObject(data);
    const legacyContent = data?.content?.nodes?.[0]?.body?.view?.value ?? '';
    const webResourceKeys = data?.content?.nodes?.[0]?.body?.view?.webresource?.keys ?? [];
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        spacing: "spacious",
        label: "legacy-modal-shortcut"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$CommentSkeleton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 100
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 100
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 75
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0d195c36a2d7770a$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        spacing: "spacious",
        label: "legacy-modal-shortcut"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "#",
        onClick: handleCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "comment-extension-handlers.fallback.action",
        defaultMessage: "Click to view content"
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "comment-extension-handlers.fallback.reason",
        defaultMessage: "that can\u2019t display inline as it was created in a legacy version of Confluence."
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cutWg.LegacyContentModal), {
        onClose: setIsOpen,
        content: legacyContent,
        webResources: webResourceKeys,
        user: user
    })));
};
module.exports["FallbackComponent"] = $0d195c36a2d7770a$export$23216ae99c93d0b;

});

parcelRegister("eJfvT", function(module, exports) {
/**
 * @generated SignedSource<<edfaf8793adb766f814acf307138a873>>
 * @relayHash 2b11554f4389f71764621368308cd942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a38265f9e9abdb4a3757d0be1c234f0641d5bb317dd568c63a5496eb5b0dbaa
const $f10d0aba441df4ce$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "WebResourceDependencies",
                                            "kind": "LinkedField",
                                            "name": "webresource",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "keys"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "accountId"
                                                }
                                            ],
                                            "type": "KnownUser"
                                        },
                                        {
                                            "concreteType": "Icon",
                                            "kind": "LinkedField",
                                            "name": "profilePicture",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "path"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FallbackComponentLegacyContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FallbackComponentLegacyContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2b11554f4389f71764621368308cd942",
            "id": "2a38265f9e9abdb4a3757d0be1c234f0641d5bb317dd568c63a5496eb5b0dbaa",
            "metadata": {},
            "name": "FallbackComponentLegacyContentQuery",
            "operationKind": "query",
            "text": "query FallbackComponentLegacyContentQuery($contentId:ID!){content(id:$contentId){nodes{id,body{view{value,webresource{keys}}},history{createdBy{__typename,...on KnownUser{accountId},profilePicture{path},displayName}},type}}}"
        }
    };
}();
$f10d0aba441df4ce$var$node.hash = "115b91c2474796b4abfdcb0076932148";
var $f10d0aba441df4ce$export$2e2bcd8739ae039 = $f10d0aba441df4ce$var$node;
module.exports["default"] = $f10d0aba441df4ce$export$2e2bcd8739ae039;

});

parcelRegister("cutWg", function(module, exports) {
/* LegacyContentModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");


var $brpfO = parcelRequire("brpfO");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $cpjd2 = parcelRequire("cpjd2");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $920076e2f988014c$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _ca0qpxbi",
            __cmplp.className
        ])
    });
});
const $920076e2f988014c$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _19bvu2gc _16tx1b66",
            __cmplp.className
        ])
    });
});
const $920076e2f988014c$var$closeButton = (0, $aXWIB.defineMessage)({
    id: "comment-extension-handlers.legacy-content-modal.close-button.non-final-ai",
    defaultMessage: "Close"
});
const $920076e2f988014c$export$8d93ebb7c75cb5b4 = ({ onClose: onClose, content: content, user: user, webResources: webResources })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [containerRef, setContainerRef] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(webResources, ()=>{}, ()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (containerRef) (0, $brpfO.evalLegacyConnectInlineScripts)(containerRef);
    }, [
        containerRef
    ]);
    const onRefSet = (ref)=>{
        setContainerRef(ref);
    };
    const handleClose = ()=>{
        onClose(false);
    };
    const handleImageClick = (event)=>{
        // clicking on an image shows a full screen modal
        // of the image in the background
        if (event.target instanceof HTMLImageElement) onClose(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: handleClose,
        width: "large",
        testId: "modal-dialog-legacy-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($920076e2f988014c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: user.userId,
        src: user.avatarUrl,
        name: user.displayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($920076e2f988014c$var$ContentContainer, {
        onClick: handleImageClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
        userId: user.userId,
        fullName: user.displayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: onRefSet,
        dangerouslySetInnerHTML: {
            __html: content
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        autoFocus: true,
        appearance: "primary",
        onClick: handleClose
    }, formatMessage($920076e2f988014c$var$closeButton))));
};
module.exports["LegacyContentModal"] = $920076e2f988014c$export$8d93ebb7c75cb5b4;

});

parcelRegister("ajkp0", function(module, exports) {
/* UnsupportedFallbackComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $a3fRD = parcelRequire("a3fRD");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff2521e469949e41$var$StyledContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt45uws _1e0c1txw _10rcu2gc",
            __cmplp.className
        ])
    });
});
const $ff2521e469949e41$export$563f56722e191781 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ff2521e469949e41$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        spacing: "spacious",
        label: "unsupported-legacy-error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "comment-extension-handlers.unsupported.fallback",
        defaultMessage: "This content cannot be displayed as it was created in a legacy version of Confluence and is unsupported."
    }));
module.exports["UnsupportedFallbackComponent"] = $ff2521e469949e41$export$563f56722e191781;

});

parcelRegister("eV0v4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $78QFu = parcelRequire("78QFu");

const $2f8044ddd141ffa3$export$8f5016028a31aee0 = {
    channel: 'media',
    actionSubjects: [
        'mediaCardRender',
        'mediaUpload',
        'smartLink'
    ]
};
const $2f8044ddd141ffa3$export$def227c48fe2bf2c = {
    channel: 'editor',
    actionSubjects: [
        'renderer'
    ]
};
const $2f8044ddd141ffa3$export$e3ba538a10828e25 = ({ channelParam: channelParam, children: children })=>{
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        function updateEvent() {
            event.update((payload)=>{
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                };
            });
        }
        if (channelParam.actionSubjects.includes(event.payload.actionSubject)) updateEvent();
    }, [
        channelParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        channel: channelParam.channel,
        onEvent: handleEvent
    }, children);
};
module.exports["mediaChannel"] = $2f8044ddd141ffa3$export$8f5016028a31aee0;
module.exports["editorChannel"] = $2f8044ddd141ffa3$export$def227c48fe2bf2c;
module.exports["DynamicAnalyticsListener"] = $2f8044ddd141ffa3$export$e3ba538a10828e25;

});

parcelRegister("97Szk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $chO1Z = parcelRequire("chO1Z");


var $gXn1S = parcelRequire("gXn1S");


var $ctmPb = parcelRequire("ctmPb");


var $9RVmI = parcelRequire("9RVmI");


var $9KkVf = parcelRequire("9KkVf");

const $3fda69966c9a64cd$var$i18n = (0, $aXWIB.defineMessages)({
    editDefinitionRestrictedToSpaceOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.space.option",
        defaultMessage: "In this space"
    },
    editDefinitionRestrictedToPageOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.page.option",
        defaultMessage: "On this page"
    },
    editDefinitionRestrictedToBlogpostOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.blogpost.option",
        defaultMessage: "On this blogpost"
    },
    editDefinitionRestrictedToSiteOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.site.option",
        defaultMessage: "On this site"
    }
});
function $3fda69966c9a64cd$export$ad09b24d617a41f5(contentType) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return (0, $42omo.useMemo)(()=>[
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSpaceOption),
                value: (0, $9KkVf.EditedDefinitionScope).SPACE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                    label: ""
                })
            },
            contentType === 'blogpost' ? {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToBlogpostOption),
                value: (0, $9KkVf.EditedDefinitionScope).BLOGPOST,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                    label: ""
                })
            } : {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToPageOption),
                value: (0, $9KkVf.EditedDefinitionScope).PAGE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
                    label: ""
                })
            },
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSiteOption),
                value: (0, $9KkVf.EditedDefinitionScope).ORGANIZATION,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ctmPb))), {
                    label: ""
                })
            }
        ], [
        contentType,
        formatMessage
    ]);
}
module.exports["useDefinitionRestrictionOptions"] = $3fda69966c9a64cd$export$ad09b24d617a41f5;

});

parcelRegister("9KkVf", function(module, exports) {
var $3b7655b6bdb7bdb0$export$a53c998f5fa685e1 = /*#__PURE__*/ function(EditedDefinitionScope) {
    EditedDefinitionScope["SPACE"] = "SPACE";
    EditedDefinitionScope["PAGE"] = "PAGE";
    EditedDefinitionScope["BLOGPOST"] = "BLOGPOST";
    EditedDefinitionScope["ORGANIZATION"] = "ORGANIZATION";
    EditedDefinitionScope["PROJECT"] = "PROJECT";
    return EditedDefinitionScope;
}({});
module.exports["EditedDefinitionScope"] = $3b7655b6bdb7bdb0$export$a53c998f5fa685e1;

});

parcelRegister("g7Tm3", function(module, exports) {
var $f98b9dde8f8a6e61$export$f30b281f34822b59 = /*#__PURE__*/ function(CommentRendererLocation) {
    CommentRendererLocation["COMMENTS_PANEL_INLINE"] = "comments-panel-inline";
    CommentRendererLocation["COMMENTS_PANEL_OBJECT"] = "comments-panel-object";
    CommentRendererLocation["STANDALONE_INLINE"] = "standalone-inline";
    CommentRendererLocation["STANDALONE_OBJECT"] = "standalone-object";
    return CommentRendererLocation;
}({});
module.exports["CommentRendererLocation"] = $f98b9dde8f8a6e61$export$f30b281f34822b59;

});

parcelRegister("1TLVx", function(module, exports) {
/* AiSuggestEdit.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $iXCQx = parcelRequire("iXCQx");


var $gNXND = parcelRequire("gNXND");


var $7yDmn = parcelRequire("7yDmn");


var $jO3S6 = parcelRequire("jO3S6");


var $ep3mz = parcelRequire("ep3mz");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $gczDe = parcelRequire("gczDe");


var $cUycv = parcelRequire("cUycv");


var $21K7m = parcelRequire("21K7m");


var $tch6L = parcelRequire("tch6L");

const $1b60cc241c9d075b$var$i18n = (0, $aXWIB.defineMessages)({
    suggestEdit: {
        id: "ai-suggest-edit.button.label",
        defaultMessage: "Suggest Edit"
    },
    loading: {
        id: "ai-suggest-edit.button.loading",
        defaultMessage: "Suggesting edit..."
    },
    error: {
        id: "ai-suggest-edit.button.error",
        defaultMessage: "Retry suggest edit"
    },
    rovoLoadingAlt: {
        id: "ai-suggest-edit.rovo-loading.alt",
        defaultMessage: "Rovo is processing"
    }
});
// Rainbow border animation keyframes
const $1b60cc241c9d075b$var$animateBorder = null;
const $1b60cc241c9d075b$var$buttonContainerStyle = null; // Rainbow gradient border styles for loading state
const $1b60cc241c9d075b$var$rainbowBorderStyle = null; // CSS property declaration for --angle (needed for the animation)
const $1b60cc241c9d075b$var$anglePropertyStyle = null;
const $1b60cc241c9d075b$var$loadingIconStyle = null; // Style to make the wrapper only as wide as its content
const $1b60cc241c9d075b$var$fitContentStyle = null;
const $1b60cc241c9d075b$var$SuggestEditIcon = ({ isLoading: isLoading, error: error, loadingAlt: loadingAlt })=>{
    if (isLoading) return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $jO3S6.LazyAnimatedRovoIcon), {
        alt: loadingAlt,
        width: "16px",
        height: "16px"
    }));
    if (error) // Icon is decorative - button text provides accessible name
    return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    });
     // Icon is decorative - button text provides accessible name
    return /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gNXND))), {
        label: ""
    });
};
const $1b60cc241c9d075b$export$14092fd39e8d9e65 = ({ annotationId: annotationId, annotatedText: annotatedText, commentAdf: commentAdf, commentId: _commentId, contentId: contentIdProp })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = pageContentId || contentIdProp; // IMPORTANT: keep feature gate / experiment usage inline so it remains statically analyzable.
    const { suggestEdit: suggestEdit, isLoading: isLoading, error: error, isSuccess: isSuccess, reset: reset } = (0, $tch6L.useSuggestEdit)({
        contentId: contentId,
        enabled: isRovoEnabled && (0, $9wGTI.fg)('aifc_create_enabled')
    }); // Handle successful edit: resolve the inline comment
    (0, $42omo.useEffect)(()=>{
        if (isSuccess) {
            if (annotationId) {
                const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [annotationId]: {
                        id: annotationId,
                        annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $cUycv.AnnotationMarkStates).RESOLVED
                    }
                });
                else eventEmitter.emit('resolve', annotationId);
            }
        }
    }, [
        isSuccess,
        annotationId,
        pageMode
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('aifc_create_enabled')) return;
        if (isLoading) {
            reset();
            return;
        }
        const commentText = (0, $tch6L.getCommentTextFromAdf)(commentAdf);
        suggestEdit({
            annotatedText: annotatedText,
            commentText: commentText,
            contentId: contentId
        });
    }, [
        annotatedText,
        commentAdf,
        contentId,
        isLoading,
        reset,
        suggestEdit
    ]);
    const loadingAlt = formatMessage($1b60cc241c9d075b$var$i18n.rovoLoadingAlt);
    const renderIcon = (0, $42omo.useCallback)(()=>/*#__PURE__*/ $42omo.createElement($1b60cc241c9d075b$var$SuggestEditIcon, {
            isLoading: isLoading,
            error: error,
            loadingAlt: loadingAlt
        }), [
        isLoading,
        error,
        loadingAlt
    ]);
    const isAllowedPageMode = pageMode === (0, $cD1qu.PageMode).LIVE || pageMode === (0, $cD1qu.PageMode).EDIT;
    if (!annotationId || !isAllowedPageMode || !isRovoEnabled || !(0, $9wGTI.fg)('aifc_create_enabled') || !(0, $6mKj3.expValEquals)('ai-suggested-edits', 'isEnabled', true)) return null;
    return /*#__PURE__*/ $42omo.createElement("div", {
        "aria-live": "polite",
        className: (0, $gMc0m.default)([
            "_ca0qu2gc _n3td1b66"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            isLoading && "",
            isLoading && "_2rko12b0 _1rrh1i1e _kqswh2mm _1tes12gs _rfx312b0 _1414yh40 _p7f0yh40 _7gpxyh40 _syayyh40 _1s6kbt9t _16qq1kun _1kt9b3bt _1cs8stnw _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw",
            isLoading && "",
            isLoading && "_1bsb1ns9"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: renderIcon,
        onClick: handleClick,
        testId: "ai-suggest-edit-button"
    }, error && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "span",
        color: "color.text.danger"
    }, formatMessage($1b60cc241c9d075b$var$i18n.error)), !error && (isLoading ? formatMessage($1b60cc241c9d075b$var$i18n.loading) : formatMessage($1b60cc241c9d075b$var$i18n.suggestEdit)))));
};
module.exports["AiSuggestEdit"] = $1b60cc241c9d075b$export$14092fd39e8d9e65;

});

parcelRegister("tch6L", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6jPem = parcelRequire("6jPem");


var $fD5Hh = parcelRequire("fD5Hh");


var $9XexZ = parcelRequire("9XexZ");


var $6VfGD = parcelRequire("6VfGD");

const $c831c12a1b3671b1$export$99257a64eb64548c = (commentAdf)=>{
    if (!commentAdf) return '';
    try {
        const doc = JSON.parse(commentAdf);
        const result = [];
        (0, $6jPem.traverse)(doc, {
            text: (node)=>{
                result.push(node.text || '');
            },
            mention: (node)=>{
                result.push(node.attrs?.text || '');
            },
            emoji: (node)=>{
                result.push(node.attrs?.text || node.attrs?.shortName || '');
            },
            hardBreak: ()=>{
                result.push(' ');
            }
        });
        return result.join('').trim();
    } catch  {
        return '';
    }
};
const $c831c12a1b3671b1$var$initialState = {
    isLoading: false,
    error: null,
    isSuccess: false
};
const $c831c12a1b3671b1$export$d2b578541bb14155 = ({ contentId: contentId, enabled: enabled = true } = {})=>{
    const [state, setState] = (0, $42omo.useState)($c831c12a1b3671b1$var$initialState);
    const isActiveRef = (0, $42omo.useRef)(false);
    const contentIdRef = (0, $42omo.useRef)(contentId);
    // Keep contentIdRef in sync
    (0, $42omo.useEffect)(()=>{
        contentIdRef.current = contentId;
    }, [
        contentId
    ]);
    const reset = (0, $42omo.useCallback)(()=>{
        setState($c831c12a1b3671b1$var$initialState);
        isActiveRef.current = false;
    }, []);
    // Use a separate client ID for suggest-edit to avoid conflicting with the editor's bridge registration.
    // The editor registers with getConfluenceEditorClientId(contentId) and handles ContentReadyCommand
    // and ReadContentCommand. We just need to send messages and listen for stream events.
    const suggestEditClientId = (0, $fD5Hh.client)(`confluence-suggest-edit-${contentId || 'fallback'}`);
    // Set up bridge API with handlers for streaming lifecycle events
    const { send: send, ready: ready } = (0, $9XexZ.useRovoContentBridgeAPI)(suggestEditClientId, (on)=>{
        // Handle stream completed - edit was successfully applied
        on((0, $6VfGD.RovoStreamCompletedCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: null,
                    isSuccess: true
                });
                isActiveRef.current = false;
            }
        });
        // Handle stream error - edit failed
        on((0, $6VfGD.RovoStreamErroredCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: 'Failed to apply edit',
                    isSuccess: false
                });
                isActiveRef.current = false;
            }
        });
        // Handle stream aborted - user cancelled
        on((0, $6VfGD.RovoStreamAbortedCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: null,
                    isSuccess: false
                });
                isActiveRef.current = false;
            }
        });
    });
    // Mark the client as ready to receive messages just-in-time.
    // This avoids chaining state updates via an effect.
    const hasCalledReadyRef = (0, $42omo.useRef)(false);
    const suggestEdit = (0, $42omo.useCallback)(({ annotatedText: annotatedText, commentText: commentText, contentId: paramContentId })=>{
        if (enabled && !hasCalledReadyRef.current) {
            ready();
            hasCalledReadyRef.current = true;
        }
        const effectiveContentId = paramContentId || contentId;
        contentIdRef.current = effectiveContentId;
        // Validate required context - contentId is essential for page context
        if (!effectiveContentId) {
            setState({
                isLoading: false,
                error: 'Missing page context. Unable to suggest edit.',
                isSuccess: false
            });
            return;
        }
        if (!annotatedText) {
            setState({
                isLoading: false,
                error: 'No annotated text found. Unable to suggest edit.',
                isSuccess: false
            });
            return;
        }
        // Set loading state
        setState({
            isLoading: true,
            error: null,
            isSuccess: false
        });
        // Track this request
        isActiveRef.current = true;
        // Build the initial prompt with context about the comment
        const prompt = `Update the document using the ConfluenceCreationTool and fix the content "${annotatedText}"` + `based on the comment: "${commentText}".` + `Only fix the content. ` + `Do not provide your own comment.` + `Do not open up the Rovo chat window. openChat=false.`;
        try {
            send((0, $6VfGD.InlineInputBoxSendMessageCommand), {
                receiverId: (0, $6VfGD.ROVO_CHAT_CLIENT_ID),
                prompt: prompt,
                source: 'CONFLUENCE_COMMENT_FIX',
                productKey: 'confluence',
                deepResearchEnabled: false,
                webSearchEnabled: false,
                contentId: effectiveContentId,
                openChat: false,
                addCurrentPageAsContextUserPreference: true
            });
        } catch (error) {
            setState({
                isLoading: false,
                error: error instanceof Error ? error.message : 'Failed to send message to Rovo',
                isSuccess: false
            });
            isActiveRef.current = false;
        }
    }, [
        send,
        contentId,
        enabled,
        ready
    ]);
    return {
        ...state,
        suggestEdit: suggestEdit,
        reset: reset
    };
};
module.exports["getCommentTextFromAdf"] = $c831c12a1b3671b1$export$99257a64eb64548c;
module.exports["useSuggestEdit"] = $c831c12a1b3671b1$export$d2b578541bb14155;

});

parcelRegister("aUwPP", function(module, exports) {

var $9LRzA = parcelRequire("9LRzA");


var $5abq6 = parcelRequire("5abq6");


var $b9lC3 = parcelRequire("b9lC3");


var $87fJd = parcelRequire("87fJd");

const $8f944f557ac62b40$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $9LRzA.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $b9lC3.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $b9lC3.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $b9lC3.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $87fJd.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $8f944f557ac62b40$export$171e576bb7c729fa;

});

parcelRegister("b9lC3", function(module, exports) {

var $aU3dp = parcelRequire("aU3dp");

var $d925B = parcelRequire("d925B");


var $dhoHU = parcelRequire("dhoHU");


var $5abq6 = parcelRequire("5abq6");


var $kecXX = parcelRequire("kecXX");


var $by9bj = parcelRequire("by9bj");

const $a4290f7701cf1730$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $a4290f7701cf1730$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $dhoHU.toggleBlockMark)(indentation, getNewIndentationAttrs, $a4290f7701cf1730$export$54db194d337db321)(state, dispatch);
    };
}
function $a4290f7701cf1730$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $kecXX.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $a4290f7701cf1730$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $by9bj.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $a4290f7701cf1730$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getIndentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $a4290f7701cf1730$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getOutdentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $a4290f7701cf1730$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $dhoHU.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $a4290f7701cf1730$export$54db194d337db321;
module.exports["getIndentCommand"] = $a4290f7701cf1730$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $a4290f7701cf1730$export$620b2a1f10eb3a5f;

});

parcelRegister("kecXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d4de3432317ffe3$export$2e2bcd8739ae039);
function $2d4de3432317ffe3$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("by9bj", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aU3dp = parcelRequire("aU3dp");

const $a44445544afb543f$var$indentTypes = {
    paragraph: (0, $aU3dp.INDENT_TYPE).PARAGRAPH,
    heading: (0, $aU3dp.INDENT_TYPE).HEADING
};
function $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $a44445544afb543f$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $a44445544afb543f$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $a44445544afb543f$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $a44445544afb543f$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $a44445544afb543f$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $a44445544afb543f$export$4f15b45384b61427;

});

parcelRegister("87fJd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $kTbzR = parcelRequire("kTbzR");


var $dus6D = parcelRequire("dus6D");


var $8m4tT = parcelRequire("8m4tT");


var $b9lC3 = parcelRequire("b9lC3");

function $e60d68c782a1a955$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $b9lC3.getIndentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.outdent)), (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $kTbzR.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $8m4tT.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
var $e60d68c782a1a955$export$2e2bcd8739ae039 = $e60d68c782a1a955$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $e60d68c782a1a955$export$e832373cff8dec22;

});

parcelRegister("iPfZG", function(module, exports) {
$parcel$export(module.exports, "EngagementSpotlight", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2Fndw = parcelRequire("2Fndw");


var $iiBJH = parcelRequire("iiBJH");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $8cBM8 = parcelRequire("8cBM8");

const $d1e26a6c07491d4a$var$SpotlightWithVariables = (0, $iiBJH.default)((0, $8cBM8.default));
const $d1e26a6c07491d4a$export$f57123e11f24bec9 = (0, $3Npfo.default)($d1e26a6c07491d4a$var$SpotlightWithVariables);
const $d1e26a6c07491d4a$var$SpotlightWithMessage = (0, $k5HOq.default)($d1e26a6c07491d4a$export$f57123e11f24bec9, 'spotlight');
function $d1e26a6c07491d4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1e26a6c07491d4a$var$SpotlightWithMessage, props));
}

});

parcelRegister("iiBJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cfa45347111319c$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $3Sftg = parcelRequire("3Sftg");

function $3cfa45347111319c$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $42omo.Component) {
        render() {
            const props = $3cfa45347111319c$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TargetComponent, props);
        }
    }
    WithVariables.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $3cfa45347111319c$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3Sftg.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});

parcelRegister("3Sftg", function(module, exports) {

var $g47C5 = parcelRequire("g47C5");

var $4xewT = parcelRequire("4xewT");

function $e4ebe363c373022b$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $e4ebe363c373022b$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $4xewT.runTemplateForUrl)(input, variables) : (0, $4xewT.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $g47C5.REPLACEMENT_ERROR)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}
module.exports["rebuildButtonAction"] = $e4ebe363c373022b$export$5d0ec4f796aceeb1;
module.exports["runTemplateOnInputs"] = $e4ebe363c373022b$export$d808999430a3f186;

});

parcelRegister("g47C5", function(module, exports) {
const $e428a4697dceb24e$export$e26f00bd90899835 = 'success';
const $e428a4697dceb24e$export$edb46161045fece7 = 'error';
module.exports["REPLACEMENT_ERROR"] = $e428a4697dceb24e$export$edb46161045fece7;

});

parcelRegister("4xewT", function(module, exports) {

var $i0lyP = parcelRequire("i0lyP");


var $cpDxi = parcelRequire("cpDxi");


var $g47C5 = parcelRequire("g47C5");


var $cuEWu = parcelRequire("cuEWu");

function $ace38877ac0d85ab$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $i0lyP.default)(template);
    return (0, $cuEWu.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $ace38877ac0d85ab$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForUrl)(epTemplate, variables);
}
function $ace38877ac0d85ab$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForHtml)(epTemplate, variables);
}
module.exports["runTemplateForUrl"] = $ace38877ac0d85ab$export$416b2ef51d91ea20;
module.exports["runTemplateForHtml"] = $ace38877ac0d85ab$export$5681b97796b74884;

});

parcelRegister("i0lyP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2be59bfe0ce0113$export$2e2bcd8739ae039);

var $bz2UO = parcelRequire("bz2UO");

/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $e2be59bfe0ce0113$var$UNESCAPED_MATCH = 1;
const $e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS = 2;
const $e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS = 5;
function $e2be59bfe0ce0113$export$2e2bcd8739ae039(template) {
    const parts = (0, $bz2UO.regexpParts)(template, $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});

parcelRegister("bz2UO", function(module, exports) {
function $78901a26ed98192e$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}
module.exports["regexpParts"] = $78901a26ed98192e$export$b16d411b3b6d6dff;

});

parcelRegister("cpDxi", function(module, exports) {

var $cuEWu = parcelRequire("cuEWu");


var $48gB0 = parcelRequire("48gB0");

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $9d422126fe4600e0$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $cuEWu.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $9d422126fe4600e0$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForUrl(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForHtml(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, (0, $48gB0.default));
}
function $9d422126fe4600e0$export$d10ae881b12b8ef2(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForUrl);
}
function $9d422126fe4600e0$export$ca536300dbd6350(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForHtml);
}
module.exports["replaceForUrl"] = $9d422126fe4600e0$export$d10ae881b12b8ef2;
module.exports["replaceForHtml"] = $9d422126fe4600e0$export$ca536300dbd6350;

});

parcelRegister("cuEWu", function(module, exports) {

var $1rjmQ = parcelRequire("1rjmQ");

function $5e0333abe2221126$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $5e0333abe2221126$export$4a33186abb06007b(template) {
    const variableParts = $5e0333abe2221126$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $1rjmQ.uniqStrings)(variableNames);
}
module.exports["getRequiredVariablesFromTemplate"] = $5e0333abe2221126$export$4a33186abb06007b;

});

parcelRegister("1rjmQ", function(module, exports) {
/**
 * Removes duplicate strings from an array.
 */ function $56c35590cbe5b17a$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}
module.exports["uniqStrings"] = $56c35590cbe5b17a$export$c150c7c1a29f33d8;

});

parcelRegister("48gB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d527f6527719db2$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $8d527f6527719db2$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});

parcelRegister("3Npfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $924fbb9a636b21af$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

var $924fbb9a636b21af$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $42omo.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $1DWH0.default)()(EngagementEventsWrapper);
};

});

parcelRegister("k5HOq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e47b6edde9367a4f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

var $e47b6edde9367a4f$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
    }
    StoreWrapper.contextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    };
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $42omo.useState)(null);
        const unsubscribeRef = (0, $42omo.useRef)(null);
        const removeConfigRef = (0, $42omo.useRef)(null);
        const canSubscribe = (0, $42omo.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $42omo.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $42omo.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $42omo.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $42omo.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $42omo.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $42omo.useRef)(engagementId);
        const previousMessageType = (0, $42omo.useRef)(messageType);
        const previousOnMessageDisposition = (0, $42omo.useRef)(onMessageDisposition);
        (0, $42omo.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("8cBM8", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $hQNhB = parcelRequire("hQNhB");


var $gj7hi = parcelRequire("gj7hi");


var $5RBJ9 = parcelRequire("5RBJ9");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $hzth4 = parcelRequire("hzth4");

var $19Jj3 = parcelRequire("19Jj3");

var $eSpLK = parcelRequire("eSpLK");


var $7cTWR = parcelRequire("7cTWR");


var $8953F = parcelRequire("8953F");


var $9A5yV = parcelRequire("9A5yV");

function $86110ead6fe3e8af$var$_defineProperty(e, r, t) {
    return (r = $86110ead6fe3e8af$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $86110ead6fe3e8af$var$_toPropertyKey(t) {
    var i = $86110ead6fe3e8af$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $86110ead6fe3e8af$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $86110ead6fe3e8af$var$styles = {
    image: "_1bsb1osq"
};
const $86110ead6fe3e8af$export$f14689466e4eca7a = ({ isMigrated: isMigrated = false, ...rest })=>{
    if (isMigrated && (0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($86110ead6fe3e8af$var$MigratedAkSpotlight, rest);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($86110ead6fe3e8af$var$DeprecatedAkSpotlight, rest);
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $86110ead6fe3e8af$var$DeprecatedAkSpotlight extends (0, $42omo.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
    }
}
$86110ead6fe3e8af$var$_defineProperty($86110ead6fe3e8af$var$DeprecatedAkSpotlight, "defaultProps", {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
});
const $86110ead6fe3e8af$var$MigratedAkSpotlight = (props)=>{
    const placement = (0, $8953F.translations).dialogPlacement(props.dialogPlacement);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const dismiss = (0, $42omo.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        offset: props.offset,
        dismiss: dismiss,
        placement: placement,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), props.image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: props.image,
        alt: "",
        className: (0, $gMc0m.default)([
            $86110ead6fe3e8af$var$styles.image
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, props.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, props.secondaryAction && (props.secondaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSpLK.SpotlightSecondaryLink), {
        onClick: dismiss,
        ...props.secondaryAction.data,
        href: props.secondaryAction.data?.url || '',
        target: props.secondaryAction.data?.target
    }, props.secondaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: dismiss,
        ...props.secondaryAction.data
    }, props.secondaryText)), props.primaryAction && (props.primaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hzth4.SpotlightPrimaryLink), {
        onClick: dismiss,
        ...props.primaryAction.data,
        href: props.primaryAction.data?.url || '',
        target: props.primaryAction.data?.target
    }, props.primaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: dismiss,
        ...props.primaryAction.data
    }, props.primaryText))))));
};
var $86110ead6fe3e8af$export$2e2bcd8739ae039 = $86110ead6fe3e8af$export$f14689466e4eca7a;
module.exports["default"] = $86110ead6fe3e8af$export$2e2bcd8739ae039;

});

parcelRegister("hzth4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $auNCB = parcelRequire("auNCB");

var $iXCQx = parcelRequire("iXCQx");

const $ccaffbcaf2b62b3e$var$styles = {
    root: "_2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6d8yml _18zr12x7 _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27"
};
const $ccaffbcaf2b62b3e$export$82ba9bc832fb64 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $ccaffbcaf2b62b3e$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightPrimaryLink",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    }));
module.exports["SpotlightPrimaryLink"] = $ccaffbcaf2b62b3e$export$82ba9bc832fb64;

});

parcelRegister("eSpLK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $auNCB = parcelRequire("auNCB");

var $iXCQx = parcelRequire("iXCQx");

const $8b5e95512cfdb346$var$styles = {
    root: "_2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zr12x7 _1rjcv77o _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27"
};
const $8b5e95512cfdb346$export$797d360648cfd970 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $8b5e95512cfdb346$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightSecondaryLink",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    }));
module.exports["SpotlightSecondaryLink"] = $8b5e95512cfdb346$export$797d360648cfd970;

});

parcelRegister("7cTWR", function(module, exports) {
const $31e3ef3c9b5f37b6$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};
module.exports["buttonActionTypes"] = $31e3ef3c9b5f37b6$export$e7d79186651244da;

});

parcelRegister("8953F", function(module, exports) {
const $59e8e8c8e0635f86$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
   * All of the following are actually invalid in CSS selectors.
   * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
   * If it turns out other characters are used, add them as needed.
   *
   * (space) — descendant combinator
   * > — child combinator
   * + — adjacent sibling combinator
   * ~ — general sibling combinator
   * . — class selector
   * # — ID selector
   * : — pseudo-class/element
   * [ ] — attribute selectors
   * ( ) — functional notation
   * , — selector list separator
   * * — universal selector
   * | — namespace separator
   * " ' — string delimiters
   * \ — escape character
   * Characters not allowed in unescaped identifiers:
   * Digits 0-9 cannot be the first character
   * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
   */ return value.replaceAll(' ', '-').replaceAll('/', '-');
};
const $59e8e8c8e0635f86$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $59e8e8c8e0635f86$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $59e8e8c8e0635f86$var$placementMap[value || 'bottom left'];
};
const $59e8e8c8e0635f86$export$150b732325d14d04 = {
    target: $59e8e8c8e0635f86$export$44271b4f0c6a3563,
    dialogPlacement: $59e8e8c8e0635f86$export$608d2c28a2f3926e
};
module.exports["translations"] = $59e8e8c8e0635f86$export$150b732325d14d04;

});

parcelRegister("9A5yV", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $8cb2cd879eafccd1$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
module.exports["default"] = $8cb2cd879eafccd1$export$2e2bcd8739ae039;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $42omo.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $42omo.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const baseOptions = {
        variables: variables,
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY) && // Keep watching query for home route to avoid VC90 regression
    (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy
    });
    const panels = (data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: loading,
        error: error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $b847dc1d37d68706$export$dcf9d4e77de27956 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInterop(query, options) {
    const $ = (0, $frIzR.c)(11);
    const resolversRef = (0, $42omo.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options || $[3] !== t0) {
        t1 = [
            t0,
            options
        ];
        $[2] = options;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const [doQuery, t2] = (0, $jxs8y.useLazyQuery)(...t1);
    const { data: data, error: error } = t2;
    let t3;
    let t4;
    if ($[5] !== data || $[6] !== error) {
        t3 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t4 = [
            data,
            error
        ];
        $[5] = data;
        $[6] = error;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== doQuery) {
        t5 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[9] = doQuery;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function useLazyQueryPromiseInterop(query, options) {
    const resolversRef = (0, $42omo.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("fOKpq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $7c1587c4cdf698a9$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $42omo.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $7c1587c4cdf698a9$export$774887fcc3922763 = ({ children: children, ...props })=>{
    const defaultValue = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($7c1587c4cdf698a9$export$49e1053dfc41d188.Provider, {
        value: value,
        children: children
    });
};
function $7c1587c4cdf698a9$export$8dcbb40932065737() {
    const ctx = (0, $42omo.useContext)($7c1587c4cdf698a9$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
}
module.exports["ProductDependenciesContext"] = $7c1587c4cdf698a9$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $7c1587c4cdf698a9$export$8dcbb40932065737;

});

parcelRegister("lOeVN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $42omo.useRef)();
    propsRef.current = props;
    return (0, $42omo.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("1421M"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("1421M", function(module, exports) {

let $0c67bcd931c05ad3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c67bcd931c05ad3$var$load("6wr18"),
    $0c67bcd931c05ad3$var$load("ffEVr"),
    $0c67bcd931c05ad3$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("dOOm2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7hpmn = parcelRequire("7hpmn");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64c374ed616824e$var$GradientPropertyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _kqswh2mm _c71l1kw7",
            __cmplp.className
        ])
    });
});
const $f64c374ed616824e$var$outerContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $7hpmn.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f64c374ed616824e$var$animationStyles = (0, $ecnYn.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f64c374ed616824e$var$baseGlowStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f64c374ed616824e$var$defaultBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.large'
});
const $f64c374ed616824e$var$modalBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small'
});
const $f64c374ed616824e$var$innerContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f64c374ed616824e$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f64c374ed616824e$var$outerContainerStyles,
        $f64c374ed616824e$var$animationStyles
    ] : [
        $f64c374ed616824e$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f64c374ed616824e$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f64c374ed616824e$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f64c374ed616824e$var$modalBorderRadiusStyles : $f64c374ed616824e$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, $l998X.jsxs)($f64c374ed616824e$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props,
        children: [
            shouldRotate && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles,
                    ...hideGlow ? [] : glowStyles
                ],
                testId: "loading-glow"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles
                ],
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    padding: "space.025",
                    xcss: [
                        $f64c374ed616824e$var$innerContainerStyles,
                        borderRadiusStyles,
                        customInnerContainerStyles
                    ],
                    children: children
                })
            })
        ]
    });
};
module.exports["AIBorder"] = $f64c374ed616824e$export$6ed1e39f4dbe0bbf;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("4o1RV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iV5Ic = parcelRequire("iV5Ic");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $frIzR.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $iV5Ic.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $42omo.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $42omo.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2XqLN = parcelRequire("2XqLN");


var $7CLBv = parcelRequire("7CLBv");


var $dDZcC = parcelRequire("dDZcC");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $frIzR.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $2XqLN.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $2XqLN.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $dDZcC.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("7EIq6", function(module, exports) {

var $dd33Q = parcelRequire("dd33Q");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, spaceEnabledContentTypesQueryOptions);
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("9eOvr", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b2dbadf512f98f64$var$SyncBlockActionsContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $b2dbadf512f98f64$export$1536d3aa2f6b9cd9 = ()=>{
    return (0, $42omo.useContext)($b2dbadf512f98f64$var$SyncBlockActionsContext);
};
const $b2dbadf512f98f64$export$5f0b55764d1d819f = ({ children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo })=>{
    const value = (0, $42omo.useMemo)(()=>({
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        }), [
        removeSyncBlock,
        fetchSyncBlockSourceInfo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b2dbadf512f98f64$var$SyncBlockActionsContext.Provider, {
        value: value
    }, children);
};
module.exports["useSyncBlockActions"] = $b2dbadf512f98f64$export$1536d3aa2f6b9cd9;
module.exports["SyncBlockActionsProvider"] = $b2dbadf512f98f64$export$5f0b55764d1d819f;

});

parcelRegister("lEQpi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $ejAeh = parcelRequire("ejAeh");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $3RNNl = parcelRequire("3RNNl");


var $dBGrG = parcelRequire("dBGrG");

class $f2fbfd8272c84174$export$d353efb45bc662f4 {
    isSyncBlock(node) {
        return this.sourceSyncBlockStoreManager.isSourceBlock(node) || this.referenceSyncBlockStoreManager.isReferenceBlock(node);
    }
    async fetchReferencesSourceInfo(resourceId, blockInstanceId, isSourceSyncBlock) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchReferencesExperience?.start();
            const response = await this.dataProvider.fetchReferences(resourceId, isSourceSyncBlock);
            if (response.error) {
                this.fetchReferencesExperience?.failure({
                    reason: response.error
                });
                return {
                    error: response.error
                };
            }
            if (!response.references || response.references?.length === 0) {
                if ((0, $dh538.fg)('platform_synced_block_patch_8')) return this.getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock);
                else {
                    // No reference found
                    if (isSourceSyncBlock) this.fetchReferencesExperience?.success();
                    else this.fetchReferencesExperience?.failure({
                        reason: 'No references found for reference synced block'
                    });
                    return isSourceSyncBlock ? {
                        references: []
                    } : {
                        error: (0, $awHlv.SyncBlockError).Errored
                    };
                }
            }
            this.fetchReferencesExperience?.success();
            const sourceInfoPromises = (response.references ?? []).map(async (reference)=>{
                this.fetchSourceInfoExperience?.start();
                const sourceInfo = await this.dataProvider?.fetchSyncBlockSourceInfo(reference.blockInstanceId || '', reference.documentAri, (0, $ejAeh.getProductFromSourceAri)(reference.documentAri), reference.hasAccess);
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: `no source info returned for ari: ${reference.documentAri}`
                    });
                    return undefined;
                }
                this.fetchSourceInfoExperience?.success();
                return {
                    ...sourceInfo,
                    onSameDocument: reference.onSameDocument,
                    hasAccess: reference.hasAccess,
                    productType: sourceInfo.productType
                };
            });
            const sourceInfos = await Promise.all(sourceInfoPromises);
            const sourceSyncBlockData = await (isSourceSyncBlock ? this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId) : this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId));
            if (sourceSyncBlockData) sourceInfos.push({
                ...sourceSyncBlockData,
                onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                hasAccess: true,
                isSource: true,
                productType: sourceSyncBlockData?.productType
            });
            return {
                references: sourceInfos
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message));
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.fetchReferencesExperience = (0, $QkKjT.getFetchReferencesExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
        this.fetchReferencesExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
    }
    async getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock) {
        // No reference found
        if (isSourceSyncBlock) {
            // Verify that a reference sync block for this specific source actually
            // exists on the current page by checking if the reference manager has
            // an active subscription for the derived reference resourceId.
            const referenceResourceId = this.referenceSyncBlockStoreManager.generateResourceIdForReference(resourceId);
            const hasUnregisteredReferenceOnPage = this.referenceSyncBlockStoreManager.getSubscribedResourceIds().includes(referenceResourceId);
            if (hasUnregisteredReferenceOnPage) {
                // This is current page data. It is the same for data for source and reference
                const sourceSyncBlockData = await this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId);
                const references = [];
                if (sourceSyncBlockData) {
                    const sourceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: true
                    };
                    const referenceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: false
                    };
                    references.push(sourceSyncBlockReference, referenceSyncBlockReference);
                }
                this.fetchReferencesExperience?.success();
                return {
                    references: references
                };
            }
            // No remote or local reference exists — show info text with link to doco on how to use Synced Blocks
            this.fetchReferencesExperience?.success();
            return {
                references: []
            };
        }
        // Though no references registered yet for this reference sync block,
        // still show the source and the current page itself since they are known
        // but not saved yet.
        const references = [];
        const sourceSyncBlockData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId);
        if (sourceSyncBlockData) references.push({
            ...sourceSyncBlockData,
            onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
            hasAccess: true,
            isSource: true
        });
        const currentPageData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfoByLocalId(blockInstanceId);
        if (currentPageData) references.push({
            ...currentPageData,
            onSameDocument: true,
            hasAccess: true,
            isSource: false
        });
        if (references.length === 0) {
            this.fetchReferencesExperience?.failure({
                reason: 'No references found for reference synced block'
            });
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
        this.fetchReferencesExperience?.success();
        return {
            references: references
        };
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.fetchReferencesExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        // In future, if reference manager needs to reach to source manager and read its current in memory cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $dBGrG.SourceSyncBlockStoreManager)(dataProvider, viewMode, isLivePage);
        this.referenceSyncBlockStoreManager = new (0, $3RNNl.ReferenceSyncBlockStoreManager)(dataProvider, viewMode);
        this.dataProvider = dataProvider;
        this.referenceSyncBlockStoreManager.setRealTimeSubscriptionsEnabled(true);
    }
}
const $f2fbfd8272c84174$var$createSyncBlockStoreManager = (dataProvider)=>{
    return new $f2fbfd8272c84174$export$d353efb45bc662f4(dataProvider);
};
const $f2fbfd8272c84174$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent)=>{
    const syncBlockStoreManager = (0, $42omo.useMemo)(()=>{
        return $f2fbfd8272c84174$var$createSyncBlockStoreManager(dataProvider);
    }, [
        dataProvider
    ]);
    const prevFireAnalyticsEventRef = (0, $42omo.useRef)(undefined);
    if (fireAnalyticsEvent !== prevFireAnalyticsEventRef.current) {
        prevFireAnalyticsEventRef.current = fireAnalyticsEvent;
        syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    }
    return syncBlockStoreManager;
};
module.exports["SyncBlockStoreManager"] = $f2fbfd8272c84174$export$d353efb45bc662f4;
module.exports["useMemoizedSyncBlockStoreManager"] = $f2fbfd8272c84174$export$d95b04bc16414394;

});

parcelRegister("QkKjT", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $grmt9 = parcelRequire("grmt9");

var $8kPu1 = parcelRequire("8kPu1");

var $fo9p3 = parcelRequire("fo9p3");

const $48856e1ef5d8a6d7$var$TIMEOUT_DURATION = 30000;
const $48856e1ef5d8a6d7$export$b335cfa3334e49e6 = (fireAnalyticsEvent)=>{
    return (payload)=>{
        // Runtime type guard - only forward experience events
        if (payload.action === (0, $d925B.ACTION).EXPERIENCE_MEASURED || payload.action === (0, $d925B.ACTION).EXPERIENCE_SAMPLED) fireAnalyticsEvent?.(payload);
    };
};
const $48856e1ef5d8a6d7$export$553df56755696c09 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$188e7890e84f55e4 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).REFERENCE_SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$cf32ad2bf7484097 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_GET_SOURCE_INFO,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$666920a07aaa7d43 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_DELETE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bf943e4a2bda18f6 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_CREATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$3ba8782eb93c9adf = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH_REFERENCES,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
module.exports["getSaveSourceExperience"] = $48856e1ef5d8a6d7$export$553df56755696c09;
module.exports["getSaveReferenceExperience"] = $48856e1ef5d8a6d7$export$188e7890e84f55e4;
module.exports["getFetchExperience"] = $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0;
module.exports["getFetchSourceInfoExperience"] = $48856e1ef5d8a6d7$export$cf32ad2bf7484097;
module.exports["getDeleteSourceExperience"] = $48856e1ef5d8a6d7$export$666920a07aaa7d43;
module.exports["getCreateSourceExperience"] = $48856e1ef5d8a6d7$export$bf943e4a2bda18f6;
module.exports["getFetchReferencesExperience"] = $48856e1ef5d8a6d7$export$3ba8782eb93c9adf;

});

parcelRegister("3RNNl", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");


var $dyHCj = parcelRequire("dyHCj");


var $bBz3A = parcelRequire("bBz3A");


var $cTANx = parcelRequire("cTANx");


var $axlAB = parcelRequire("axlAB");

const $bf9ff2ea047058dc$var$CACHE_KEY_PREFIX = 'sync-block-data-';
class $bf9ff2ea047058dc$export$fb04276dca31302e {
    isReferenceBlock(node) {
        return node.type.name === 'syncBlock';
    }
    /**
   * Enables or disables real-time GraphQL subscriptions for block updates.
   * When enabled, the store manager will subscribe to real-time updates
   * instead of relying on polling.
   * @param enabled - Whether to enable real-time subscriptions
   */ setRealTimeSubscriptionsEnabled(enabled) {
        this._subscriptionManager.setRealTimeSubscriptionsEnabled(enabled);
    }
    /**
   * Checks if real-time subscriptions are currently enabled.
   */ isRealTimeSubscriptionsEnabled() {
        return this._subscriptionManager.isRealTimeSubscriptionsEnabled();
    }
    /**
   * Returns all resource IDs that are currently subscribed to.
   * Used by React components to render subscription components.
   */ getSubscribedResourceIds() {
        return this._subscriptionManager.getSubscribedResourceIds();
    }
    /**
   * Registers a listener that will be called when subscriptions change.
   * @param listener - Callback function to invoke when subscriptions change
   * @returns Unsubscribe function to remove the listener
   */ onSubscriptionsChanged(listener) {
        return this._subscriptionManager.onSubscriptionsChanged(listener);
    }
    /**
   * Handles incoming data from a GraphQL subscription.
   * Called by React subscription components when they receive updates.
   * @param syncBlockInstance - The updated sync block instance
   */ handleSubscriptionUpdate(syncBlockInstance) {
        this._subscriptionManager.handleSubscriptionUpdate(syncBlockInstance);
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.fetchExperience = (0, $QkKjT.getFetchExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveReferenceExperience)(fireAnalyticsEvent);
    }
    setOnUnpublishedSyncBlockDetected(callback) {
        this.onUnpublishedSyncBlockDetected = callback;
    }
    /**
   * Mark a sync block as newly added to the document.
   * This should be called when a sync block node is added via a transaction.
   * @param resourceId - The resource ID of the newly added sync block
   */ markAsNewlyAdded(resourceId) {
        this.newlyAddedSyncBlocks.add(resourceId);
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        const providerData = this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (providerData) return providerData;
        return this.getFromSessionCache(resourceId);
    }
    updateSessionCache(resourceId) {
        const latestData = this.getFromCache(resourceId);
        if (latestData) (0, $bBz3A.syncBlockInMemorySessionCache).setItem(`${$bf9ff2ea047058dc$var$CACHE_KEY_PREFIX}${resourceId}`, JSON.stringify(latestData));
    }
    getFromSessionCache(resourceId) {
        try {
            const raw = (0, $bBz3A.syncBlockInMemorySessionCache).getItem(`${$bf9ff2ea047058dc$var$CACHE_KEY_PREFIX}${resourceId}`);
            if (!raw) return undefined;
            return JSON.parse(raw);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/getFromSessionCache'
            });
            return undefined;
        }
    }
    fetchSyncBlockSourceInfoBySourceAri(sourceAri, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const sourceInfo = this.dataProvider.fetchSyncBlockSourceInfo(undefined, sourceAri, undefined, hasAccess);
            return sourceInfo;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoBySourceAri'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfoByLocalId(localId, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined, hasAccess);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoByLocalId'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            const existingRequest = this.syncBlockSourceInfoRequests.get(resourceId);
            if (existingRequest) return existingRequest;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId, sourceURL: sourceURL, sourceTitle: sourceTitle, onSameDocument: onSameDocument, sourceSubType: sourceSubType } = existingSyncBlock.data || {};
            // skip if source URL and title are already present
            if (sourceURL && sourceTitle) return Promise.resolve({
                title: sourceTitle,
                url: sourceURL,
                subType: sourceSubType,
                sourceAri: sourceAri || '',
                onSameDocument: onSameDocument,
                productType: product
            });
            if (!sourceAri || !product || !blockInstanceId) {
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing', resourceId));
                return Promise.resolve(undefined);
            }
            this.fetchSourceInfoExperience?.start({});
            const sourceInfoPromise = this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, true // hasAccess
            ).then((sourceInfo)=>{
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'No source info returned'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('No source info returned', resourceId));
                    return undefined;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this._subscriptionManager.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if (sourceInfo.title && sourceInfo.url) this.fetchSourceInfoExperience?.success();
                else {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'Missing title or url'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('Missing title or url', resourceId));
                }
                return sourceInfo;
            }).catch((error)=>{
                this.fetchSourceInfoExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId));
                return undefined;
            }).finally(()=>{
                this.syncBlockSourceInfoRequests.delete(resourceId);
            });
            this.syncBlockSourceInfoRequests.set(resourceId, sourceInfoPromise);
            return sourceInfoPromise;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId));
        }
        return Promise.resolve(undefined);
    }
    /**
   * Processes prefetched data and updates the cache.
   * @param prefetchedData - The prefetched data to process
   * @returns {Promise<void>}
   */ async processPrefetchedData(prefetchedData) {
        if (!prefetchedData) return;
        // start the fetch experience (this should be started much earlier to properly track performance, but better late than never)
        this.fetchExperience?.start({});
        // mark the sync block requests as in fly
        prefetchedData.resourceIds.forEach((resourceId)=>{
            this.syncBlockFetchDataRequests.set(resourceId, true);
        });
        try {
            const prefetchedResolvedData = await prefetchedData.prefetchPromise;
            const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(prefetchedResolvedData);
            if (hasUnexpectedError) this.fetchExperience?.failure({
                reason: 'Unexpected error during prefetch'
            });
            else if (hasExpectedError) this.fetchExperience?.abort({
                reason: 'Expected error: NotFound or PermissionDenied during prefetch'
            });
            else this.fetchExperience?.success();
        } catch (error) {
            this.fetchExperience?.failure({
                reason: `Prefetch promise rejected: ${error.message}`
            });
        } finally{
            // Clean up in-flight markers so subsequent fetches are not blocked
            prefetchedData.resourceIds.forEach((resourceId)=>{
                this.syncBlockFetchDataRequests.delete(resourceId);
            });
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error?.type === (0, $awHlv.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        if (!this.dataProvider) throw new Error('Data provider not set');
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        this.fetchExperience?.start({});
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(data);
        if (hasUnexpectedError) this.fetchExperience?.failure({
            reason: 'Unexpected error during fetch'
        });
        else if (hasExpectedError) this.fetchExperience?.abort({
            reason: 'Expected error: NotFound or PermissionDenied'
        });
        else this.fetchExperience?.success();
    }
    processFetchedData(data) {
        if (!data) return {
            hasUnexpectedError: false,
            hasExpectedError: false
        };
        let hasUnexpectedError = false;
        let hasExpectedError = false;
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                const payload = syncBlockInstance.error?.reason || syncBlockInstance.error?.type || 'Returned sync block instance does not have resource id';
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(payload));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            // Check if this is a newly added unpublished sync block and notify
            // Only trigger for sync blocks that were just added (not refreshed or loaded on page init)
            if (!syncBlockInstance.error && resolvedSyncBlockInstance.data?.status === 'unpublished' && this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId) && this.onUnpublishedSyncBlockDetected) {
                // Remove from newly added set after checking to prevent duplicate flags
                this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
                this.onUnpublishedSyncBlockDetected(resolvedSyncBlockInstance.resourceId);
            } else if (this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId)) // Remove from newly added set even if not unpublished (to clean up)
            this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
            if (syncBlockInstance.error) {
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error.reason || syncBlockInstance.error.type, syncBlockInstance.resourceId));
                if (syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).NotFound || syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).Forbidden) hasExpectedError = true;
                else if (syncBlockInstance.error) hasUnexpectedError = true;
                return;
            }
            const callbacks = this._subscriptionManager.getSubscriptions().get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product));
            });
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return {
            hasUnexpectedError: hasUnexpectedError,
            hasExpectedError: hasExpectedError
        };
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title,
                onSameDocument: sourceInfo?.onSameDocument,
                sourceSubType: sourceInfo?.subType
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const { resourceId: resourceId } = syncBlock;
        if (resourceId) {
            this.dataProvider?.updateCache({
                [resourceId]: syncBlock
            }, {
                strategy: 'merge',
                source: 'network'
            });
            this._subscriptionManager.notifySubscriptionCallbacks(resourceId, syncBlock);
            this.updateSessionCache(resourceId);
        }
    }
    getFromCache(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        return this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    deleteFromCache(resourceId) {
        this.dataProvider?.removeFromCache([
            resourceId
        ]);
        this._providerFactoryManager.deleteFactory(resourceId);
    }
    debouncedBatchedFetchSyncBlocks(resourceId) {
        this._batchFetcher.queueFetch(resourceId);
    }
    setSSRDataInSessionCache(resourceIds) {
        if (!resourceIds || resourceIds.length === 0) return;
        resourceIds.forEach((resourceId)=>{
            this.updateSessionCache(resourceId);
        });
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
    }
    subscribeToSourceTitle(node, callback) {
        return this._subscriptionManager.subscribeToSourceTitle(node, callback);
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock) return undefined;
        return syncBlock.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        return this._providerFactoryManager.getProviderFactory(resourceId);
    }
    getSSRProviders(resourceId) {
        return this._providerFactoryManager.getSSRProviders(resourceId);
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return false;
        if (!this.isCacheDirty) // we use the isCacheDirty flag as a quick check.
        return true;
        // Prevent concurrent flushes to avoid race conditions with lastFlushedSyncedBlocks
        if (this.isFlushInProgress) {
            // Mark that another flush is needed after the current one completes
            this.flushNeededAfterCurrent = true;
            // We return true here because we know the pending flush will handle the dirty cache
            return true;
        } else this.isFlushInProgress = true;
        let success = true;
        // a copy of the subscriptions STRUCTURE (without the callbacks)
        // To be saved as the last flushed structure if the flush is successful
        const syncedBlocksToFlush = {};
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const blocks = [];
            // First, build the complete subscription structure
            for (const [resourceId, callbacks] of this._subscriptionManager.getSubscriptions().entries()){
                syncedBlocksToFlush[resourceId] = {};
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                    syncedBlocksToFlush[resourceId][localId] = true;
                });
            }
            // Then, compare with the last flushed structure to detect changes
            // We check against the last flushed structure to prevent unnecessary flushes
            // Note that we will always flush at least once when editor starts
            // This is useful for eventual consistency between the editor and the BE.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(syncedBlocksToFlush, this.lastFlushedSyncedBlocks)) {
                this.isCacheDirty = false; // Reset since we're considering this a successful no-op flush
                return true;
            }
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            this.saveExperience?.start();
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                this.saveExperience?.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document'));
            }
        } catch (error) {
            success = false;
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.saveExperience?.failure({
                reason: error.message
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(error.message));
        } finally{
            if (!success) // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
            this.isCacheDirty = true;
            else {
                this.lastFlushedSyncedBlocks = syncedBlocksToFlush;
                this.saveExperience?.success();
            }
            // Always reset isFlushInProgress
            this.isFlushInProgress = false;
            // If another flush was requested while this one was in progress, execute it now
            if (this.flushNeededAfterCurrent) {
                this.flushNeededAfterCurrent = false;
                // Use setTimeout to avoid deep recursion and run queued flush asynchronously
                // Note: flush() handles all exceptions internally and never rejects
                this.queuedFlushTimeout = setTimeout(()=>{
                    this.queuedFlushTimeout = undefined;
                    this.flush();
                }, 0);
            }
        }
        return success;
    }
    destroy() {
        // Cancel any queued flush to prevent it from running after destroy
        if (this.queuedFlushTimeout) {
            clearTimeout(this.queuedFlushTimeout);
            this.queuedFlushTimeout = undefined;
        }
        this._subscriptionManager.destroy();
        this._providerFactoryManager.destroy();
        this._batchFetcher.destroy();
        this.dataProvider?.resetCache();
        this.dataProvider = undefined;
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequests.clear();
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fireAnalyticsEvent = undefined;
        (0, $bBz3A.syncBlockInMemorySessionCache).clear();
    }
    constructor(dataProvider, viewMode){
        this.viewMode = void 0;
        this.dataProvider = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor session is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockFetchDataRequests = void 0;
        this.syncBlockSourceInfoRequests = void 0;
        // Track newly added sync blocks (resourceIds that were just subscribed to without cached data)
        this.newlyAddedSyncBlocks = void 0;
        // Keep track of the last flushed subscriptions to optimize cache flushing on document save
        this.lastFlushedSyncedBlocks = {};
        // Callback to notify when an unpublished sync block is detected
        this.onUnpublishedSyncBlockDetected = void 0;
        // Track if a flush operation is currently in progress
        this.isFlushInProgress = false;
        // Track if another flush is needed after the current one completes
        this.flushNeededAfterCurrent = false;
        // Track the setTimeout handle for queued flush so we can cancel it on destroy
        this.queuedFlushTimeout = void 0;
        this.fetchExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.saveExperience = void 0;
        this._subscriptionManager = void 0;
        this._providerFactoryManager = void 0;
        this._batchFetcher = void 0;
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.newlyAddedSyncBlocks = new Set();
        this._subscriptionManager = new (0, $axlAB.SyncBlockSubscriptionManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            updateCache: (inst)=>this.updateCache(inst),
            deleteFromCache: (rid)=>this.deleteFromCache(rid),
            debouncedBatchedFetchSyncBlocks: (rid)=>this.debouncedBatchedFetchSyncBlocks(rid),
            fetchSyncBlockSourceInfo: (rid)=>this.fetchSyncBlockSourceInfo(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            markCacheDirty: ()=>{
                this.isCacheDirty = true;
            }
        });
        this._providerFactoryManager = new (0, $cTANx.SyncBlockProviderFactoryManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        this._batchFetcher = new (0, $dyHCj.SyncBlockBatchFetcher)({
            getSubscriptions: ()=>this._subscriptionManager.getSubscriptions(),
            fetchSyncBlocksData: (nodes)=>this.fetchSyncBlocksData(nodes),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        // The provider might have SSR data cache already set, so we need to update the cache in session memory storage
        this.setSSRDataInSessionCache(this.dataProvider?.getNodeDataCacheKeys());
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $bf9ff2ea047058dc$export$fb04276dca31302e;

});

parcelRegister("4wATI", function(module, exports) {

var $f8eu7 = parcelRequire("f8eu7");


var $awHlv = parcelRequire("awHlv");

const $165aef3c3dcb8be4$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error?.type === (0, $awHlv.SyncBlockError).NotFound || newResult.error?.type === (0, $awHlv.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined,
            sourceSubType: $165aef3c3dcb8be4$var$mergeSubType(oldResult, newResult),
            onSameDocument: newResult.data?.onSameDocument || oldResult.data?.onSameDocument || undefined
        }
    };
};
const $165aef3c3dcb8be4$var$mergeSubType = (oldResult, newResult)=>{
    // for classic pages, subType is 'null'
    if (newResult.data?.sourceSubType !== undefined) return newResult.data.sourceSubType;
    if (newResult.data?.sourceAri) // for blogposts, subType is always undefined
    try {
        const { type: pageType } = (0, $f8eu7.getPageIdAndTypeFromConfluencePageAri)({
            ari: newResult.data?.sourceAri
        });
        if (pageType === 'blogpost') return newResult.data?.sourceSubType;
    } catch  {}
    return oldResult.data?.sourceSubType;
};
module.exports["resolveSyncBlockInstance"] = $165aef3c3dcb8be4$export$dcc459f28c1cd2fd;

});

parcelRegister("dyHCj", function(module, exports) {

var $2P8Ax = parcelRequire("2P8Ax");


var $hWRJP = parcelRequire("hWRJP");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

class $f5bf878eca9bbfe8$export$7d827e0357659116 {
    queueFetch(resourceId) {
        const subscriptions = this.deps.getSubscriptions();
        if (subscriptions.has(resourceId) && Object.keys(subscriptions.get(resourceId) || {}).length > 0) {
            this.pendingFetchRequests.add(resourceId);
            this.scheduledBatchFetch();
        } else this.pendingFetchRequests.delete(resourceId);
    }
    cancel() {
        this.scheduledBatchFetch.cancel();
    }
    clearPending() {
        this.pendingFetchRequests.clear();
    }
    destroy() {
        this.cancel();
        this.clearPending();
    }
    constructor(deps){
        this.deps = deps;
        this.pendingFetchRequests = new Set();
        this.scheduledBatchFetch = void 0;
        this.scheduledBatchFetch = (0, $2P8Ax.default)(()=>{
            if (this.pendingFetchRequests.size === 0) return;
            const resourceIds = Array.from(this.pendingFetchRequests);
            const syncBlockNodes = resourceIds.map((resId)=>{
                const subscriptions = this.deps.getSubscriptions().get(resId) || {};
                const firstLocalId = Object.keys(subscriptions)[0] || '';
                return (0, $gtauf.createSyncBlockNode)(firstLocalId, resId);
            });
            this.pendingFetchRequests.clear();
            this.deps.fetchSyncBlocksData(syncBlockNodes).catch((error)=>{
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockBatchFetcher/batchedFetchSyncBlocks'
                });
                resourceIds.forEach((resId)=>{
                    this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resId));
                });
            });
        });
    }
}
module.exports["SyncBlockBatchFetcher"] = $f5bf878eca9bbfe8$export$7d827e0357659116;

});

parcelRegister("bBz3A", function(module, exports) {
/**
 * In-memory session cache for sync block data with size-based LRU eviction.
 *
 * Backed by a plain Map so that potentially private ADF content is never
 * written to any browser-persistent storage (sessionStorage, localStorage,
 * IndexedDB). The module-level singleton survives SPA transitions (no full
 * page reload) and is naturally cleared on hard navigation or tab close.
 *
 * Uses JavaScript Map's insertion-order guarantee to implement LRU:
 * on every read or write the accessed entry is moved to the end of the
 * iteration order; when total cached size exceeds `maxSize`, the oldest
 * (least-recently-used) entries are evicted first.
 */ class $657a090a5274b259$export$75f7f86498dcaabe {
    /**
   * Retrieves a cached value by key.
   *
   * **Side-effect:** promotes the entry to the most-recently-used
   * position by re-inserting it at the end of the underlying Map's
   * iteration order.
   */ getItem(key) {
        const value = this.store.get(key);
        if (value === undefined) return null;
        this.store.delete(key);
        this.store.set(key, value);
        return value;
    }
    setItem(key, value) {
        const existing = this.store.get(key);
        if (existing !== undefined) {
            this.currentSize -= existing.length;
            this.store.delete(key);
        }
        this.store.set(key, value);
        this.currentSize += value.length;
        while(this.currentSize > this.maxSize && this.store.size > 1){
            const oldestKey = this.store.keys().next().value;
            if (oldestKey !== undefined) {
                const oldestValue = this.store.get(oldestKey);
                if (oldestValue !== undefined) this.currentSize -= oldestValue.length;
                this.store.delete(oldestKey);
            }
        }
    }
    removeItem(key) {
        const value = this.store.get(key);
        if (value !== undefined) {
            this.currentSize -= value.length;
            this.store.delete(key);
        }
    }
    /**
   * Removes all entries from the cache and resets the tracked size to zero.
   * Useful for cleaning up the singleton on SPA navigation boundaries.
   */ clear() {
        this.store.clear();
        this.currentSize = 0;
    }
    constructor(maxSize = 5242880){
        this.store = new Map();
        this.currentSize = 0;
        /**
     * Maximum total size of all cached values, measured in **UTF-16 code
     * units** (i.e. `String.prototype.length`), not bytes.  For ASCII-only
     * content the two are equivalent; for content with characters outside
     * the BMP each surrogate pair counts as 2.
     */ this.maxSize = void 0;
        this.maxSize = maxSize;
    }
}
const $657a090a5274b259$export$b811313deafee9ed = new $657a090a5274b259$export$75f7f86498dcaabe();
module.exports["syncBlockInMemorySessionCache"] = $657a090a5274b259$export$b811313deafee9ed;

});

parcelRegister("cTANx", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $4FxUL = parcelRequire("4FxUL");


var $cFpEg = parcelRequire("cFpEg");


var $47N43 = parcelRequire("47N43");

class $acb948bac57fc60c$export$3bfff6c128de82c9 {
    getProviderFactory(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) {
            const error = new Error('Data provider not set');
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return undefined;
        }
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $4FxUL.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        } else {
            if (parentDataProviders?.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders?.mentionProvider);
            if (parentDataProviders?.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders?.profilecardProvider);
            if (parentDataProviders?.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders?.taskDecisionProvider);
        }
        if (providerCreator) try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId));
        }
        return providerFactory;
    }
    getSSRProviders(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return null;
        const { providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (!providerCreator?.createSSRMediaProvider) return null;
        const parsedResourceId = (0, $47N43.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        let { contentId: contentId, product: contentProduct } = parsedResourceId;
        const syncBlock = this.deps.getFromCache(resourceId);
        let contentAri = syncBlock?.data?.sourceAri || '';
        if (syncBlock?.data?.sourceAri && syncBlock.data.product) {
            const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
            if (parentInfo) {
                contentId = parentInfo.contentId;
                contentProduct = parentInfo.contentProduct;
                contentAri = parentInfo.contentAri;
            }
        }
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
        }
        return null;
    }
    deleteFactory(resourceId) {
        this.providerFactories.delete(resourceId);
    }
    destroy() {
        this.providerFactories.forEach((pf)=>pf.destroy());
        this.providerFactories.clear();
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        const hasCardProvider = providerFactory.hasProvider('cardProvider');
        if (hasMediaProvider && hasEmojiProvider && hasCardProvider) return;
        const syncBlock = this.deps.getFromCache(resourceId);
        if (!syncBlock?.data) return;
        if (!syncBlock.data.sourceAri || !syncBlock.data.product) {
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)('Sync block source ari or product not found'));
            return;
        }
        const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
        if (!parentInfo) throw new Error('Unable to retrieve sync block parent info');
        const { contentAri: contentAri, contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider && providerCreator.createMediaProvider && contentId && contentProduct) {
            const mediaProvider = providerCreator.createMediaProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
        }
        if (!hasEmojiProvider && providerCreator.createEmojiProvider && contentId && contentProduct) {
            const emojiProvider = providerCreator.createEmojiProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
        }
        if (!hasCardProvider && providerCreator.createSmartLinkProvider) {
            const smartLinkProvider = providerCreator.createSmartLinkProvider();
            if (smartLinkProvider) providerFactory.setProvider('cardProvider', smartLinkProvider);
        }
    }
    constructor(deps){
        this.deps = deps;
        this.providerFactories = new Map();
    }
}
module.exports["SyncBlockProviderFactoryManager"] = $acb948bac57fc60c$export$3bfff6c128de82c9;

});

parcelRegister("axlAB", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $cFpEg = parcelRequire("cFpEg");


var $4wATI = parcelRequire("4wATI");

class $e3afe1feb1dd429f$export$200c87d47b3d6e17 {
    /**
   * Returns the subscriptions map. Used by external consumers (e.g. batch fetcher, flush)
   * that need to read the current subscription state.
   */ getSubscriptions() {
        return this.subscriptions;
    }
    setRealTimeSubscriptionsEnabled(enabled) {
        if (this.useRealTimeSubscriptions === enabled) return;
        this.useRealTimeSubscriptions = enabled;
        if (enabled) this.setupSubscriptionsForAllBlocks();
        else this.cleanupAll();
    }
    isRealTimeSubscriptionsEnabled() {
        return this.useRealTimeSubscriptions;
    }
    getSubscribedResourceIds() {
        return Array.from(this.subscriptions.keys());
    }
    onSubscriptionsChanged(listener) {
        this.subscriptionChangeListeners.add(listener);
        return ()=>{
            this.subscriptionChangeListeners.delete(listener);
        };
    }
    notifySubscriptionChangeListeners() {
        this.subscriptionChangeListeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockSubscriptionManager/notifySubscriptionChangeListeners'
                });
                this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message));
            }
        });
    }
    handleSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $4wATI.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        const pendingDeletion = this.pendingCacheDeletions.get(resourceId);
        if (pendingDeletion) {
            clearTimeout(pendingDeletion);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        const isNewResourceSubscription = Object.keys(resourceSubscriptions).length === 0;
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.deps.markCacheDirty();
        // Notify listeners if this is a new resource subscription
        if (isNewResourceSubscription) this.notifySubscriptionChangeListeners();
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData) callback(cachedData);
        else this.deps.debouncedBatchedFetchSyncBlocks(resourceId);
        // Set up GraphQL subscription if real-time subscriptions are enabled
        if (this.shouldUseRealTime()) this.setupSubscription(resourceId);
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.deps.markCacheDirty();
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Clean up GraphQL subscription when no more local subscribers
                    this.cleanupSubscription(resourceId);
                    // Notify listeners that subscription was removed
                    this.notifySubscriptionChangeListeners();
                    // Delay cache deletion to handle block moves (unmount/remount).
                    // When a block is moved, the old component unmounts before the new one mounts.
                    // By delaying deletion, we give the new component time to subscribe and
                    // cancel this pending deletion, preserving the cached data.
                    // TODO: EDITOR-4152 - Rework this logic
                    const deletionTimeout = setTimeout(()=>{
                        // Only delete if still no subscribers (wasn't re-subscribed)
                        if (!this.subscriptions.has(resourceId)) this.deps.deleteFromCache(resourceId);
                        this.pendingCacheDeletions.delete(resourceId);
                    }, 1000);
                    this.pendingCacheDeletions.set(resourceId, deletionTimeout);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    /**
   * Notifies all subscription callbacks for a given resource ID with the provided sync block instance.
   */ notifySubscriptionCallbacks(resourceId, syncBlock) {
        const callbacks = this.subscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(syncBlock);
        });
    }
    setupSubscription(resourceId) {
        if (this.graphqlSubscriptions.has(resourceId)) return;
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider?.subscribeToBlockUpdates) return;
        const unsubscribe = dataProvider.subscribeToBlockUpdates(resourceId, (syncBlockInstance)=>{
            this.handleGraphQLUpdate(syncBlockInstance);
        }, (error)=>{
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/graphql-subscription'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message));
        });
        if (unsubscribe) this.graphqlSubscriptions.set(resourceId, unsubscribe);
    }
    cleanupSubscription(resourceId) {
        const unsubscribe = this.graphqlSubscriptions.get(resourceId);
        if (unsubscribe) {
            unsubscribe();
            this.graphqlSubscriptions.delete(resourceId);
        }
    }
    setupSubscriptionsForAllBlocks() {
        for (const resourceId of this.subscriptions.keys())this.setupSubscription(resourceId);
    }
    cleanupAll() {
        for (const unsubscribe of this.graphqlSubscriptions.values())unsubscribe();
        this.graphqlSubscriptions.clear();
    }
    destroy() {
        this.cleanupAll();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.subscriptionChangeListeners.clear();
        this.useRealTimeSubscriptions = false;
        // Clear any pending cache deletions
        for (const timeout of this.pendingCacheDeletions.values())clearTimeout(timeout);
        this.pendingCacheDeletions.clear();
    }
    shouldUseRealTime() {
        return this.useRealTimeSubscriptions;
    }
    handleGraphQLUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $4wATI.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) {
            const callbacks = this.subscriptions.get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product));
            });
            this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
        } else {
            const errorMessage = syncBlockInstance.error?.reason || syncBlockInstance.error?.type;
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(errorMessage, syncBlockInstance.resourceId));
        }
    }
    constructor(deps){
        this.deps = deps;
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.graphqlSubscriptions = new Map();
        this.subscriptionChangeListeners = new Set();
        this.useRealTimeSubscriptions = false;
        // Track pending cache deletions to handle block moves (unmount/remount)
        // When a block is moved, the old component unmounts before the new one mounts,
        // causing the cache to be deleted prematurely. We delay deletion to allow
        // the new component to subscribe and cancel the pending deletion.
        this.pendingCacheDeletions = new Map();
    }
}
module.exports["SyncBlockSubscriptionManager"] = $e3afe1feb1dd429f$export$200c87d47b3d6e17;

});

parcelRegister("dBGrG", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $gtauf = parcelRequire("gtauf");

class $297b92badcfd6d6a$export$9c6faa8962092f36 {
    /**
   * Register a callback to be invoked after flush() completes.
   * Used by the pm-plugin to dispatch a transaction so that
   * hasUnsavedBodiedSyncBlockChanges is recalculated in plugin state.
   */ registerFlushCompletionCallback(callback) {
        this.flushCompletionCallback = callback;
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.createExperience = (0, $QkKjT.getCreateSourceExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveSourceExperience)(fireAnalyticsEvent);
        this.deleteExperience = (0, $QkKjT.getDeleteSourceExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode, isRemote) {
        try {
            if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return false;
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) throw new Error('Local ID or resource ID is not set');
            const cachedBlock = this.syncBlockCache.get(resourceId);
            if ((0, $dh538.fg)('platform_synced_block_update_refactor')) {
                // Fast path: if the PM content fragment hasn't changed, skip serialization entirely
                // Fragment.eq() leverages ProseMirror's structural sharing for O(1) comparison
                if (cachedBlock?.contentFragment?.eq(syncBlockNode.content)) return true;
                const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
                if (cachedBlock && !isRemote) this.hasReceivedContentChange = true;
                const isDirty = !isRemote || !cachedBlock; // if the change is not remote, or the block is not in the cache yet, it's dirty
                this.syncBlockCache.set(resourceId, {
                    ...syncBlockData,
                    isDirty: isDirty,
                    // if the change is from remote, it's not dirty
                    contentFragment: syncBlockNode.content
                });
            } else {
                const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
                if (cachedBlock && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(syncBlockData.content, cachedBlock.content)) this.hasReceivedContentChange = true;
                this.syncBlockCache.set(resourceId, {
                    ...syncBlockData,
                    isDirty: true
                });
            }
            return true;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateCacheErrorPayload)(error.message));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return true;
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that
                // - are waiting to be deleted to avoid nodes being re-created
                // - haven't been updated since we last flushed
                // - are still pending BE creation
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty && !this.isPendingCreation(syncBlockData.resourceId)) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                    // When flushing, set status to 'active' so the block is published
                    const dataToFlush = {
                        ...syncBlockData,
                        status: 'active'
                    };
                    bodiedSyncBlockData.push(dataToFlush);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.saveExperience?.start({});
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $awHlv.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = true;
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                this.saveExperience?.success();
                writeResults.forEach((result)=>{
                    if (result.resourceId && !result.error) this.fireAnalyticsEvent?.((0, $cFpEg.updateSuccessPayload)(result.resourceId, false));
                });
                return true;
            } else {
                this.saveExperience?.failure();
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(result.error || 'Failed to write data', result.resourceId));
                });
                return false;
            }
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(error.message));
            return false;
        } finally{
            this.flushCompletionCallback?.();
        }
    }
    hasUnsavedChanges() {
        if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return false;
        // Only track unsaved changes in source synced block for live pages
        // classic pages's draft don't publish synced block content to block service and the content itself is saved as part of the draft
        // classic page's publish flow will trigger a flush which only uses the isDirty flag to determine if there are unsaved changes
        if (!this.isLivePage) return false;
        return this.hasReceivedContentChange && Array.from(this.syncBlockCache.values()).some((syncBlockData)=>syncBlockData.isDirty);
    }
    isPendingCreation(resourceId) {
        return this.creationCompletionCallbacks.has(resourceId);
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success, resourceId) {
        if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return;
        const onCompletion = this.creationCompletionCallbacks.get(resourceId);
        if (onCompletion) {
            this.creationCompletionCallbacks.delete(resourceId);
            onCompletion(success);
            if (success && (0, $iu6m9.editorExperiment)('platform_synced_block_patch_6', true, {
                exposure: true
            })) // If creation is successful, set hasReceivedContentChange to true
            // to indicate that there are unsaved changes in the cache
            this.hasReceivedContentChange = true;
        } else this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('creation complete callback missing', resourceId));
        if (success) this.fireAnalyticsEvent?.((0, $cFpEg.createSuccessPayload)(resourceId || ''));
        else {
            // Delete the node from cache if fail to create so it's not flushed to BE
            this.syncBlockCache.delete(resourceId || '');
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('Fail to create bodied sync block', resourceId));
        }
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   * @param node the ProseMirror node to cache
   * @param onCompletion callback invoked when creation completes
   */ createBodiedSyncBlockNode(attrs, node, onCompletion) {
        if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return;
        const { resourceId: resourceId, localId: blockInstanceId } = attrs;
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            if ((0, $dh538.fg)('platform_synced_block_update_refactor')) // add the node to the cache
            this.updateSyncBlockData(node, false);
            this.creationCompletionCallbacks.set(resourceId, onCompletion);
            this.createExperience?.start({});
            this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId || '';
                if (resourceId && !result.error) {
                    this.commitPendingCreation(true, resourceId);
                    this.createExperience?.success();
                } else {
                    this.commitPendingCreation(false, resourceId);
                    this.createExperience?.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(result.error || 'Failed to create bodied sync block', resourceId));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false, resourceId);
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                this.createExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message, resourceId));
            });
        } catch (error) {
            if (this.isPendingCreation(resourceId)) this.commitPendingCreation(false, resourceId);
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message));
        }
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted, reason) {
        try {
            if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return false;
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            this.deleteExperience?.start({});
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId), reason);
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
                this.deleteExperience?.success();
                results.forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(result.resourceId));
                });
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                this.deleteExperience?.failure();
                results.forEach((result)=>{
                    if (result.success) this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(result.resourceId));
                    else this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(result.error || 'Failed to delete synced block', result.resourceId));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
                this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(error.message, Ids.resourceId));
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return Promise.resolve();
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted, deletionReason: deletionReason } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, deletionReason, onDelete, onDeleteCompleted, destroyCallback) {
        if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return Promise.resolve();
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds, deletionReason);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback,
                    deletionReason: deletionReason
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    getSyncBlockSourceInfo(localId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchSourceInfoExperience?.start();
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined).then((sourceInfo)=>{
                if (!sourceInfo) this.fetchSourceInfoExperience?.failure({
                    reason: 'No source info returned'
                });
                else this.fetchSourceInfoExperience?.success();
                return sourceInfo;
            });
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchReferences(resourceId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchReferences(resourceId, true);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message));
            return Promise.resolve({
                error: (0, $awHlv.SyncBlockError).Errored
            });
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.creationCompletionCallbacks.clear();
        this.flushCompletionCallback = undefined;
        this.dataProvider = undefined;
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.createExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.deleteExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.clearPendingDeletion();
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.viewMode = void 0;
        this.isLivePage = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.hasReceivedContentChange = false;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.creationCompletionCallbacks = void 0;
        this.flushCompletionCallback = void 0;
        this.createExperience = void 0;
        this.saveExperience = void 0;
        this.deleteExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.setPendingDeletion = (Ids, value)=>{
            if (this.viewMode === 'view' && (0, $dh538.fg)('platform_synced_block_patch_8')) return;
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.isLivePage = isLivePage;
        this.syncBlockCache = new Map();
        this.creationCompletionCallbacks = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $297b92badcfd6d6a$export$9c6faa8962092f36;

});

parcelRegister("a7tZV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $hWRJP = parcelRequire("hWRJP");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

const $fb1e42d9cacf5d6e$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $42omo.useState)(()=>{
        if (resourceId) {
            const initialData = manager?.referenceManager?.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    const reloadData = (0, $42omo.useCallback)(async ()=>{
        if (isLoading) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $gtauf.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            // Set error state if fetching fails
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: {
                        type: (0, $awHlv.SyncBlockError).Errored
                    }
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // in SSR, we don't need to subscribe to updates,
        // instead we rely on pre-fetched data ONLY, see initialization of syncBlockInstance above
        return;
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        localId,
        manager.referenceManager,
        resourceId
    ]);
    const ssrProviders = (0, $42omo.useMemo)(()=>{
        return resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null;
    }, [
        resourceId,
        manager.referenceManager
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: ssrProviders,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $fb1e42d9cacf5d6e$export$2b02427d5640395b;

});

parcelRegister("cQHTi", function(module, exports) {
/**
 * URL to the Atlassian support documentation for synced blocks in Confluence Cloud.
 */ const $7481da872fe5ea98$export$81b3a92cdfa3191b = 'https://support.atlassian.com/confluence-cloud/docs/reuse-content-with-synced-blocks';
module.exports["SYNCED_BLOCKS_DOCUMENTATION_URL"] = $7481da872fe5ea98$export$81b3a92cdfa3191b;

});

parcelRegister("8z3oB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $aD1SW = parcelRequire("aD1SW");


var $gqqjz = parcelRequire("gqqjz");

const $0ffa514f9611729c$export$723a1497b2536563 = ({ showFlag: showFlag, hideFlag: hideFlag })=>{
    const createFlag = (flagOptions)=>{
        const { isAutoDismiss: isAutoDismiss, ...restOptions } = flagOptions;
        const { type: type, appearance: appearance, actions: actions } = flagOptions;
        const shouldAutoDismiss = isAutoDismiss ?? (appearance === 'info' || appearance === 'success');
        showFlag({
            ...restOptions,
            type: appearance ?? type,
            actions: actions?.map(({ text: content, onClick: onClick })=>({
                    onClick: ()=>onClick(),
                    content: content
                })),
            customComponent: shouldAutoDismiss ? (0, $aD1SW.default) : undefined
        });
        return true;
    };
    const closeFlag = ({ id: id })=>{
        hideFlag(id);
        return true;
    };
    return {
        showFlag: createFlag,
        closeFlag: closeFlag
    };
};
const $0ffa514f9611729c$export$b0063bae72b769ca = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, children);
module.exports["getFlagProvider"] = $0ffa514f9611729c$export$723a1497b2536563;
module.exports["FlagProvider"] = $0ffa514f9611729c$export$b0063bae72b769ca;

});

parcelRegister("eLUTa", function(module, exports) {
"use strict";
var $ac11956e102a58e7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ac11956e102a58e7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ac11956e102a58e7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ac11956e102a58e7$var$__exportStar((parcelRequire("fYnqe")), module.exports);

});

parcelRegister("fYnqe", function(module, exports) {
"use strict";
var $ba0ea0bb4cfa0c5b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba0ea0bb4cfa0c5b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ba0ea0bb4cfa0c5b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ba0ea0bb4cfa0c5b$var$__exportStar((parcelRequire("3b0vC")), module.exports);

});

parcelRegister("3b0vC", function(module, exports) {
"use strict";
var $2502cb3fa9925066$var$__assign = module.exports && module.exports.__assign || function() {
    $2502cb3fa9925066$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2502cb3fa9925066$var$__assign.apply(this, arguments);
};
var $2502cb3fa9925066$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2502cb3fa9925066$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2502cb3fa9925066$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.postRobotOn = module.exports.postRobotSend = module.exports.createIframeBridge = void 0;

var $eMRIC = parcelRequire("eMRIC");

Object.defineProperty(module.exports, "postRobotOn", {
    enumerable: true,
    get: function() {
        return $eMRIC.on;
    }
});
Object.defineProperty(module.exports, "postRobotSend", {
    enumerable: true,
    get: function() {
        return $eMRIC.send;
    }
});

var $8tWYx = parcelRequire("8tWYx");

var $2502cb3fa9925066$var$setupMessageListeners = function(window1, domain, listeners) {
    return Object.entries(listeners).map(function(_a) {
        var eventKey = _a[0], eventHandler = _a[1];
        return (0, $eMRIC.on)(eventKey, {
            window: window1,
            domain: domain
        }, function(event) {
            if (eventHandler && event.origin === domain) return eventHandler(event);
            return Promise.resolve();
        });
    });
};
var $2502cb3fa9925066$var$createIframeBridge = function(options) {
    if (!options.withWindow) throw new Error('Target window to setup the bridge with is not defined');
    var bridge = {
        open: function() {
            var withWindow = options.withWindow, withDomain = options.withDomain, features = options.features, theme = options.theme, surfaceColor = options.surfaceColor, sendHandshakeMetric = options.sendHandshakeMetric, metadata = options.metadata, shouldReceiveEmbeddedMacroMessages = options.shouldReceiveEmbeddedMacroMessages;
            var listeners = $2502cb3fa9925066$var$setupMessageListeners(withWindow, withDomain, features);
            var cancelEmbeddedMacroHandler;
            var localId = metadata === null || metadata === void 0 ? void 0 : metadata.localId;
            if (shouldReceiveEmbeddedMacroMessages && localId) try {
                var productHostname_1 = window.location.hostname;
                var handler = (0, $eMRIC.on)("messageFromEmbeddedFAUS_".concat(localId), {}, function(event) {
                    var originUrl = new URL(event.origin);
                    if (originUrl.hostname !== productHostname_1) return Promise.resolve();
                    var _a = event.data || {}, eventKey = _a.eventKey, payload = $2502cb3fa9925066$var$__rest(_a, [
                        "eventKey"
                    ]);
                    var handler = features[eventKey];
                    if (handler) return handler($2502cb3fa9925066$var$__assign($2502cb3fa9925066$var$__assign({}, event), {
                        data: payload
                    }));
                    return Promise.resolve();
                });
                cancelEmbeddedMacroHandler = handler.cancel;
            } catch (error) {
                console.error("Failed to set up messageFromEmbeddedFAUS listener for localId ".concat(localId, ":"), error);
            }
            var cancelReadyHandler = (0, $eMRIC.on)($8tWYx.READY_EVENT, {
                window: withWindow,
                domain: withDomain
            }, function() {
                return $2502cb3fa9925066$var$__awaiter(void 0, void 0, void 0, function() {
                    return $2502cb3fa9925066$var$__generator(this, function(_a) {
                        return [
                            2,
                            true
                        ];
                    });
                });
            }).cancel;
            (0, $eMRIC.send)(withWindow, $8tWYx.READY_EVENT, $2502cb3fa9925066$var$__assign({
                theme: theme,
                surfaceColor: surfaceColor
            }, options.metadata || {}), {
                timeout: $8tWYx.BRIDGE_HANDSHAKE_TIMEOUT_MS
            }).then(function() {
                sendHandshakeMetric(true);
            }).catch(function(error) {
                sendHandshakeMetric(false, error);
                return (0, $8tWYx.handleMissingHandlerError)(error);
            });
            return {
                enableTheming: function() {
                    (0, $eMRIC.send)(withWindow, $8tWYx.THEME_ENABLE_EVENT).catch($8tWYx.handleMissingHandlerError);
                },
                setTheme: function(theme, surfaceColor, env) {
                    (0, $eMRIC.send)(withWindow, $8tWYx.THEME_CHANGE_EVENT, {
                        theme: theme,
                        surfaceColor: surfaceColor,
                        env: env,
                        isFedRamp: metadata === null || metadata === void 0 ? void 0 : metadata.isFedRamp
                    }).catch($8tWYx.handleMissingHandlerError);
                },
                close: function() {
                    cancelReadyHandler();
                    cancelEmbeddedMacroHandler === null || cancelEmbeddedMacroHandler === void 0 || cancelEmbeddedMacroHandler();
                    listeners.forEach(function(_a) {
                        var cancel = _a.cancel;
                        return cancel();
                    });
                }
            };
        }
    };
    return bridge;
};
module.exports.createIframeBridge = $2502cb3fa9925066$var$createIframeBridge;

});

parcelRegister("eMRIC", function(module, exports) {
/* @flow */ // $FlowFixMe

module.exports = (parcelRequire("p8f0R")); // eslint-disable-line import/no-commonjs
// $FlowFixMe
module.exports.default = module.exports; // eslint-disable-line import/no-commonjs

});

parcelRegister("p8f0R", function(module, exports) {

var $iA9co = parcelRequire("iA9co");

var $04b8ba6eff8b7085$require$Buffer = $iA9co.Buffer;
!function(root, factory) {
    module.exports = factory();
}("undefined" != typeof self ? self : module.exports, function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module1 = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            module1.l = !0;
            return module1.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.r = function(exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        };
        __webpack_require__.t = function(value, mode) {
            1 & mode && (value = __webpack_require__(value));
            if (8 & mode) return value;
            if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            });
            if (2 & mode && "string" != typeof value) for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module1) {
            var getter = module1 && module1.__esModule ? function() {
                return module1.default;
            } : function() {
                return module1;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return ({}).hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 0);
    }([
        function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "Promise", function() {
                return promise_ZalgoPromise;
            });
            __webpack_require__.d(__webpack_exports__, "TYPES", function() {
                return src_types_TYPES_0;
            });
            __webpack_require__.d(__webpack_exports__, "ProxyWindow", function() {
                return window_ProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "setup", function() {
                return setup;
            });
            __webpack_require__.d(__webpack_exports__, "destroy", function() {
                return destroy;
            });
            __webpack_require__.d(__webpack_exports__, "serializeMessage", function() {
                return setup_serializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "deserializeMessage", function() {
                return setup_deserializeMessage;
            });
            __webpack_require__.d(__webpack_exports__, "createProxyWindow", function() {
                return createProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "toProxyWindow", function() {
                return setup_toProxyWindow;
            });
            __webpack_require__.d(__webpack_exports__, "on", function() {
                return on_on;
            });
            __webpack_require__.d(__webpack_exports__, "once", function() {
                return on_once;
            });
            __webpack_require__.d(__webpack_exports__, "send", function() {
                return send_send;
            });
            __webpack_require__.d(__webpack_exports__, "markWindowKnown", function() {
                return markWindowKnown;
            });
            __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() {
                return cleanUpWindow;
            });
            __webpack_require__.d(__webpack_exports__, "bridge", function() {});
            function isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            var IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
            function isAboutProtocol(win) {
                void 0 === win && (win = window);
                return "about:" === win.location.protocol;
            }
            function getParent(win) {
                void 0 === win && (win = window);
                if (win) try {
                    if (win.parent && win.parent !== win) return win.parent;
                } catch (err) {}
            }
            function getOpener(win) {
                void 0 === win && (win = window);
                if (win && !getParent(win)) try {
                    return win.opener;
                } catch (err) {}
            }
            function canReadFromWindow(win) {
                try {
                    return !0;
                } catch (err) {}
                return !1;
            }
            function getActualDomain(win) {
                void 0 === win && (win = window);
                var location = win.location;
                if (!location) throw new Error("Can not read window location");
                var protocol = location.protocol;
                if (!protocol) throw new Error("Can not read window protocol");
                if ("file:" === protocol) return "file://";
                if ("about:" === protocol) {
                    var parent = getParent(win);
                    return parent && canReadFromWindow() ? getActualDomain(parent) : "about://";
                }
                var host = location.host;
                if (!host) throw new Error("Can not read window host");
                return protocol + "//" + host;
            }
            function getDomain(win) {
                void 0 === win && (win = window);
                var domain = getActualDomain(win);
                return domain && win.mockDomain && 0 === win.mockDomain.indexOf("mock:") ? win.mockDomain : domain;
            }
            function isSameDomain(win) {
                if (!function(win) {
                    try {
                        if (win === window) return !0;
                    } catch (err) {}
                    try {
                        var desc = Object.getOwnPropertyDescriptor(win, "location");
                        if (desc && !1 === desc.enumerable) return !1;
                    } catch (err) {}
                    try {
                        if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    } catch (err) {}
                    try {
                        if (getActualDomain(win) === getActualDomain(window)) return !0;
                    } catch (err) {}
                    return !1;
                }(win)) return !1;
                try {
                    if (win === window) return !0;
                    if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                    if (getDomain(window) === getDomain(win)) return !0;
                } catch (err) {}
                return !1;
            }
            function assertSameDomain(win) {
                if (!isSameDomain(win)) throw new Error("Expected window to be same domain");
                return win;
            }
            function isAncestorParent(parent, child) {
                if (!parent || !child) return !1;
                var childParent = getParent(child);
                return childParent ? childParent === parent : -1 !== (function(win) {
                    var result = [];
                    try {
                        for(; win.parent !== win;){
                            result.push(win.parent);
                            win = win.parent;
                        }
                    } catch (err) {}
                    return result;
                })(child).indexOf(parent);
            }
            function getFrames(win) {
                var result = [];
                var frames;
                try {
                    frames = win.frames;
                } catch (err) {
                    frames = win;
                }
                var len;
                try {
                    len = frames.length;
                } catch (err) {}
                if (0 === len) return result;
                if (len) {
                    for(var i = 0; i < len; i++){
                        var frame = void 0;
                        try {
                            frame = frames[i];
                        } catch (err) {
                            continue;
                        }
                        result.push(frame);
                    }
                    return result;
                }
                for(var _i = 0; _i < 100; _i++){
                    var _frame = void 0;
                    try {
                        _frame = frames[_i];
                    } catch (err) {
                        return result;
                    }
                    if (!_frame) return result;
                    result.push(_frame);
                }
                return result;
            }
            var iframeWindows = [];
            var iframeFrames = [];
            function isWindowClosed(win, allowMock) {
                void 0 === allowMock && (allowMock = !0);
                try {
                    if (win === window) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if (!win) return !0;
                } catch (err) {
                    return !0;
                }
                try {
                    if (win.closed) return !0;
                } catch (err) {
                    return !err || err.message !== IE_WIN_ACCESS_ERROR;
                }
                if (allowMock && isSameDomain(win)) try {
                    if (win.mockclosed) return !0;
                } catch (err) {}
                try {
                    if (!win.parent || !win.top) return !0;
                } catch (err) {}
                var iframeIndex = function(collection, item) {
                    for(var i = 0; i < collection.length; i++)try {
                        if (collection[i] === item) return i;
                    } catch (err) {}
                    return -1;
                }(iframeWindows, win);
                if (-1 !== iframeIndex) {
                    var frame = iframeFrames[iframeIndex];
                    if (frame && function(frame) {
                        if (!frame.contentWindow) return !0;
                        if (!frame.parentNode) return !0;
                        var doc = frame.ownerDocument;
                        if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
                            var parent = frame;
                            for(; parent.parentNode && parent.parentNode !== parent;)parent = parent.parentNode;
                            if (!parent.host || !doc.documentElement.contains(parent.host)) return !0;
                        }
                        return !1;
                    }(frame)) return !0;
                }
                return !1;
            }
            function getAncestor(win) {
                void 0 === win && (win = window);
                return getOpener(win = win || window) || getParent(win) || void 0;
            }
            function matchDomain(pattern, origin) {
                if ("string" == typeof pattern) {
                    if ("string" == typeof origin) return "*" === pattern || origin === pattern;
                    if (isRegex(origin)) return !1;
                    if (Array.isArray(origin)) return !1;
                }
                return isRegex(pattern) ? isRegex(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !isRegex(origin) && pattern.some(function(subpattern) {
                    return matchDomain(subpattern, origin);
                }));
            }
            function isWindow(obj) {
                try {
                    if (obj === window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if ("[object Window]" === ({}).toString.call(obj)) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (window.Window && obj instanceof window.Window) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.self === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.parent === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && obj.top === obj) return !0;
                } catch (err) {
                    if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
                }
                try {
                    if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
                } catch (err) {
                    return !0;
                }
                try {
                    if ("postMessage" in obj && "self" in obj && "location" in obj) return !0;
                } catch (err) {}
                return !1;
            }
            function closeWindow(win) {
                try {
                    win.close();
                } catch (err) {}
            }
            function utils_isPromise(item) {
                try {
                    if (!item) return !1;
                    if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                    if ("undefined" != typeof window && "function" == typeof window.Window && item instanceof window.Window) return !1;
                    if ("undefined" != typeof window && "function" == typeof window.constructor && item instanceof window.constructor) return !1;
                    var _toString = {}.toString;
                    if (_toString) {
                        var name = _toString.call(item);
                        if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                    }
                    if ("function" == typeof item.then) return !0;
                } catch (err) {
                    return !1;
                }
                return !1;
            }
            var dispatchedErrors = [];
            var possiblyUnhandledPromiseHandlers = [];
            var activeCount = 0;
            var flushPromise;
            function flushActive() {
                if (!activeCount && flushPromise) {
                    var promise = flushPromise;
                    flushPromise = null;
                    promise.resolve();
                }
            }
            function startActive() {
                activeCount += 1;
            }
            function endActive() {
                activeCount -= 1;
                flushActive();
            }
            var promise_ZalgoPromise = function() {
                function ZalgoPromise(handler) {
                    var _this = this;
                    this.resolved = void 0;
                    this.rejected = void 0;
                    this.errorHandled = void 0;
                    this.value = void 0;
                    this.error = void 0;
                    this.handlers = void 0;
                    this.dispatching = void 0;
                    this.stack = void 0;
                    this.resolved = !1;
                    this.rejected = !1;
                    this.errorHandled = !1;
                    this.handlers = [];
                    if (handler) {
                        var _result;
                        var _error;
                        var resolved = !1;
                        var rejected = !1;
                        var isAsync = !1;
                        startActive();
                        try {
                            handler(function(res) {
                                if (isAsync) _this.resolve(res);
                                else {
                                    resolved = !0;
                                    _result = res;
                                }
                            }, function(err) {
                                if (isAsync) _this.reject(err);
                                else {
                                    rejected = !0;
                                    _error = err;
                                }
                            });
                        } catch (err) {
                            endActive();
                            this.reject(err);
                            return;
                        }
                        endActive();
                        isAsync = !0;
                        resolved ? this.resolve(_result) : rejected && this.reject(_error);
                    }
                }
                var _proto = ZalgoPromise.prototype;
                _proto.resolve = function(result) {
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                    this.resolved = !0;
                    this.value = result;
                    this.dispatch();
                    return this;
                };
                _proto.reject = function(error) {
                    var _this2 = this;
                    if (this.resolved || this.rejected) return this;
                    if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                    if (!error) {
                        var _err = error && "function" == typeof error.toString ? error.toString() : ({}).toString.call(error);
                        error = new Error("Expected reject to be called with Error, got " + _err);
                    }
                    this.rejected = !0;
                    this.error = error;
                    this.errorHandled || setTimeout(function() {
                        _this2.errorHandled || function(err, promise) {
                            if (-1 === dispatchedErrors.indexOf(err)) {
                                dispatchedErrors.push(err);
                                setTimeout(function() {
                                    throw err;
                                }, 1);
                                for(var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++)possiblyUnhandledPromiseHandlers[j](err, promise);
                            }
                        }(error, _this2);
                    }, 1);
                    this.dispatch();
                    return this;
                };
                _proto.asyncReject = function(error) {
                    this.errorHandled = !0;
                    this.reject(error);
                    return this;
                };
                _proto.dispatch = function() {
                    var resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                    if (!this.dispatching && (resolved || rejected)) {
                        this.dispatching = !0;
                        startActive();
                        var chain = function(firstPromise, secondPromise) {
                            return firstPromise.then(function(res) {
                                secondPromise.resolve(res);
                            }, function(err) {
                                secondPromise.reject(err);
                            });
                        };
                        for(var i = 0; i < handlers.length; i++){
                            var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise;
                            var _result2 = void 0;
                            if (resolved) try {
                                _result2 = onSuccess ? onSuccess(this.value) : this.value;
                            } catch (err) {
                                promise.reject(err);
                                continue;
                            }
                            else if (rejected) {
                                if (!onError) {
                                    promise.reject(this.error);
                                    continue;
                                }
                                try {
                                    _result2 = onError(this.error);
                                } catch (err) {
                                    promise.reject(err);
                                    continue;
                                }
                            }
                            if (_result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected)) {
                                _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error);
                                _result2.errorHandled = !0;
                            } else utils_isPromise(_result2) ? _result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected) ? _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error) : chain(_result2, promise) : promise.resolve(_result2);
                        }
                        handlers.length = 0;
                        this.dispatching = !1;
                        endActive();
                    }
                };
                _proto.then = function(onSuccess, onError) {
                    if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                    if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                    var promise = new ZalgoPromise;
                    this.handlers.push({
                        promise: promise,
                        onSuccess: onSuccess,
                        onError: onError
                    });
                    this.errorHandled = !0;
                    this.dispatch();
                    return promise;
                };
                _proto.catch = function(onError) {
                    return this.then(void 0, onError);
                };
                _proto.finally = function(onFinally) {
                    if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                    return this.then(function(result) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            return result;
                        });
                    }, function(err) {
                        return ZalgoPromise.try(onFinally).then(function() {
                            throw err;
                        });
                    });
                };
                _proto.timeout = function(time, err) {
                    var _this3 = this;
                    if (this.resolved || this.rejected) return this;
                    var timeout = setTimeout(function() {
                        _this3.resolved || _this3.rejected || _this3.reject(err || new Error("Promise timed out after " + time + "ms"));
                    }, time);
                    return this.then(function(result) {
                        clearTimeout(timeout);
                        return result;
                    });
                };
                _proto.toPromise = function() {
                    if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                    return Promise.resolve(this);
                };
                ZalgoPromise.resolve = function(value) {
                    return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise(function(resolve, reject) {
                        return value.then(resolve, reject);
                    }) : (new ZalgoPromise).resolve(value);
                };
                ZalgoPromise.reject = function(error) {
                    return (new ZalgoPromise).reject(error);
                };
                ZalgoPromise.asyncReject = function(error) {
                    return (new ZalgoPromise).asyncReject(error);
                };
                ZalgoPromise.all = function(promises) {
                    var promise = new ZalgoPromise;
                    var count = promises.length;
                    var results = [];
                    if (!count) {
                        promise.resolve(results);
                        return promise;
                    }
                    var chain = function(i, firstPromise, secondPromise) {
                        return firstPromise.then(function(res) {
                            results[i] = res;
                            0 == (count -= 1) && promise.resolve(results);
                        }, function(err) {
                            secondPromise.reject(err);
                        });
                    };
                    for(var i = 0; i < promises.length; i++){
                        var prom = promises[i];
                        if (prom instanceof ZalgoPromise) {
                            if (prom.resolved) {
                                results[i] = prom.value;
                                count -= 1;
                                continue;
                            }
                        } else if (!utils_isPromise(prom)) {
                            results[i] = prom;
                            count -= 1;
                            continue;
                        }
                        chain(i, ZalgoPromise.resolve(prom), promise);
                    }
                    0 === count && promise.resolve(results);
                    return promise;
                };
                ZalgoPromise.hash = function(promises) {
                    var result = {};
                    var awaitPromises = [];
                    var _loop = function(key) {
                        if (promises.hasOwnProperty(key)) {
                            var value = promises[key];
                            utils_isPromise(value) ? awaitPromises.push(value.then(function(res) {
                                result[key] = res;
                            })) : result[key] = value;
                        }
                    };
                    for(var key in promises)_loop(key);
                    return ZalgoPromise.all(awaitPromises).then(function() {
                        return result;
                    });
                };
                ZalgoPromise.map = function(items, method) {
                    return ZalgoPromise.all(items.map(method));
                };
                ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                    return function(handler) {
                        possiblyUnhandledPromiseHandlers.push(handler);
                        return {
                            cancel: function() {
                                possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                            }
                        };
                    }(handler);
                };
                ZalgoPromise.try = function(method, context, args) {
                    if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                    var result;
                    startActive();
                    try {
                        result = method.apply(context, args || []);
                    } catch (err) {
                        endActive();
                        return ZalgoPromise.reject(err);
                    }
                    endActive();
                    return ZalgoPromise.resolve(result);
                };
                ZalgoPromise.delay = function(_delay) {
                    return new ZalgoPromise(function(resolve) {
                        setTimeout(resolve, _delay);
                    });
                };
                ZalgoPromise.isPromise = function(value) {
                    return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
                };
                ZalgoPromise.flush = function() {
                    return function(Zalgo) {
                        var promise = flushPromise = flushPromise || new Zalgo;
                        flushActive();
                        return promise;
                    }(ZalgoPromise);
                };
                return ZalgoPromise;
            }();
            function util_safeIndexOf(collection, item) {
                for(var i = 0; i < collection.length; i++)try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }
            var weakmap_CrossDomainSafeWeakMap = function() {
                function CrossDomainSafeWeakMap() {
                    this.name = void 0;
                    this.weakmap = void 0;
                    this.keys = void 0;
                    this.values = void 0;
                    this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__";
                    if (function() {
                        if ("undefined" == typeof WeakMap) return !1;
                        if (void 0 === Object.freeze) return !1;
                        try {
                            var testWeakMap = new WeakMap;
                            var testKey = {};
                            Object.freeze(testKey);
                            testWeakMap.set(testKey, "__testvalue__");
                            return "__testvalue__" === testWeakMap.get(testKey);
                        } catch (err) {
                            return !1;
                        }
                    }()) try {
                        this.weakmap = new WeakMap;
                    } catch (err) {}
                    this.keys = [];
                    this.values = [];
                }
                var _proto = CrossDomainSafeWeakMap.prototype;
                _proto._cleanupClosedWindows = function() {
                    var weakmap = this.weakmap;
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++){
                        var value = keys[i];
                        if (isWindow(value) && isWindowClosed(value)) {
                            if (weakmap) try {
                                weakmap.delete(value);
                            } catch (err) {}
                            keys.splice(i, 1);
                            this.values.splice(i, 1);
                            i -= 1;
                        }
                    }
                };
                _proto.isSafeToReadWrite = function(key) {
                    return !isWindow(key);
                };
                _proto.set = function(key, value) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.set(key, value);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var name = this.name;
                        var entry = key[name];
                        entry && entry[0] === key ? entry[1] = value : Object.defineProperty(key, name, {
                            value: [
                                key,
                                value
                            ],
                            writable: !0
                        });
                        return;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var values = this.values;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 === index) {
                        keys.push(key);
                        values.push(value);
                    } else values[index] = value;
                };
                _proto.get = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return weakmap.get(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return entry && entry[0] === key ? entry[1] : void 0;
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var index = util_safeIndexOf(this.keys, key);
                    if (-1 !== index) return this.values[index];
                };
                _proto.delete = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        weakmap.delete(key);
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    var keys = this.keys;
                    var index = util_safeIndexOf(keys, key);
                    if (-1 !== index) {
                        keys.splice(index, 1);
                        this.values.splice(index, 1);
                    }
                };
                _proto.has = function(key) {
                    if (!key) throw new Error("WeakMap expected key");
                    var weakmap = this.weakmap;
                    if (weakmap) try {
                        if (weakmap.has(key)) return !0;
                    } catch (err) {
                        delete this.weakmap;
                    }
                    if (this.isSafeToReadWrite(key)) try {
                        var entry = key[this.name];
                        return !(!entry || entry[0] !== key);
                    } catch (err) {}
                    this._cleanupClosedWindows();
                    return -1 !== util_safeIndexOf(this.keys, key);
                };
                _proto.getOrSet = function(key, getter) {
                    if (this.has(key)) return this.get(key);
                    var value = getter();
                    this.set(key, value);
                    return value;
                };
                return CrossDomainSafeWeakMap;
            }();
            function getFunctionName(fn) {
                return fn.name || fn.__name__ || fn.displayName || "anonymous";
            }
            function setFunctionName(fn, name) {
                try {
                    delete fn.name;
                    fn.name = name;
                } catch (err) {}
                fn.__name__ = fn.displayName = name;
                return fn;
            }
            function uniqueID() {
                var chars = "0123456789abcdef";
                return "xxxxxxxxxx".replace(/./g, function() {
                    return chars.charAt(Math.floor(Math.random() * chars.length));
                }) + "_" + (function(str) {
                    if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(m, p1) {
                        return String.fromCharCode(parseInt(p1, 16));
                    }));
                    if ("undefined" != typeof $04b8ba6eff8b7085$require$Buffer) return $04b8ba6eff8b7085$require$Buffer.from(str, "utf8").toString("base64");
                    throw new Error("Can not find window.btoa or Buffer");
                })((new Date).toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            }
            var objectIDs;
            function serializeArgs(args) {
                try {
                    return JSON.stringify([].slice.call(args), function(subkey, val) {
                        return "function" == typeof val ? "memoize[" + function(obj) {
                            objectIDs = objectIDs || new weakmap_CrossDomainSafeWeakMap;
                            if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
                            var uid = objectIDs.get(obj);
                            if (!uid) {
                                uid = typeof obj + ":" + uniqueID();
                                objectIDs.set(obj, uid);
                            }
                            return uid;
                        }(val) + "]" : val;
                    });
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
            }
            var memoizedFunctions = [];
            function memoize(method, options) {
                var _this = this;
                void 0 === options && (options = {});
                var cacheMap = new weakmap_CrossDomainSafeWeakMap;
                var memoizedFunction = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var cache = cacheMap.getOrSet(options.thisNamespace ? this : method, function() {
                        return {};
                    });
                    var key = serializeArgs(args);
                    var cacheTime = options.time;
                    cache[key] && cacheTime && Date.now() - cache[key].time < cacheTime && delete cache[key];
                    if (cache[key]) return cache[key].value;
                    var time = Date.now();
                    var value = method.apply(this, arguments);
                    cache[key] = {
                        time: time,
                        value: value
                    };
                    return cache[key].value;
                };
                memoizedFunction.reset = function() {
                    cacheMap.delete(options.thisNamespace ? _this : method);
                };
                memoizedFunctions.push(memoizedFunction);
                return setFunctionName(memoizedFunction, (options.name || getFunctionName(method)) + "::memoized");
            }
            memoize.clear = function() {
                for(var _i2 = 0; _i2 < memoizedFunctions.length; _i2++)memoizedFunctions[_i2].reset();
            };
            function memoizePromise(method) {
                var cache = {};
                function memoizedPromiseFunction() {
                    var _arguments = arguments, _this2 = this;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    var key = serializeArgs(args);
                    if (cache.hasOwnProperty(key)) return cache[key];
                    cache[key] = promise_ZalgoPromise.try(function() {
                        return method.apply(_this2, _arguments);
                    }).finally(function() {
                        delete cache[key];
                    });
                    return cache[key];
                }
                memoizedPromiseFunction.reset = function() {
                    cache = {};
                };
                return setFunctionName(memoizedPromiseFunction, getFunctionName(method) + "::promiseMemoized");
            }
            function src_util_noop() {}
            function stringifyError(err, level) {
                void 0 === level && (level = 1);
                if (level >= 3) return "stringifyError stack overflow";
                try {
                    if (!err) return "<unknown error: " + ({}).toString.call(err) + ">";
                    if ("string" == typeof err) return err;
                    if (err instanceof Error) {
                        var stack = err && err.stack;
                        var message = err && err.message;
                        if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                        if (stack) return stack;
                        if (message) return message;
                    }
                    return err && err.toString && "function" == typeof err.toString ? err.toString() : ({}).toString.call(err);
                } catch (newErr) {
                    return "Error while stringifying error: " + stringifyError(newErr, level + 1);
                }
            }
            function stringify(item) {
                return "string" == typeof item ? item : item && item.toString && "function" == typeof item.toString ? item.toString() : ({}).toString.call(item);
            }
            memoize(function(obj) {
                if (Object.values) return Object.values(obj);
                var result = [];
                for(var key in obj)obj.hasOwnProperty(key) && result.push(obj[key]);
                return result;
            });
            function util_isRegex(item) {
                return "[object RegExp]" === ({}).toString.call(item);
            }
            function util_getOrSet(obj, key, getter) {
                if (obj.hasOwnProperty(key)) return obj[key];
                var val = getter();
                obj[key] = val;
                return val;
            }
            Error;
            function isDocumentReady() {
                return Boolean(document.body) && "complete" === document.readyState;
            }
            function isDocumentInteractive() {
                return Boolean(document.body) && "interactive" === document.readyState;
            }
            memoize(function() {
                return new promise_ZalgoPromise(function(resolve) {
                    if (isDocumentReady() || isDocumentInteractive()) return resolve();
                    var interval = setInterval(function() {
                        if (isDocumentReady() || isDocumentInteractive()) {
                            clearInterval(interval);
                            return resolve();
                        }
                    }, 10);
                });
            });
            var currentScript = "undefined" != typeof document ? document.currentScript : null;
            var getCurrentScript = memoize(function() {
                if (currentScript) return currentScript;
                if (currentScript = function() {
                    try {
                        var stack = function() {
                            try {
                                throw new Error("_");
                            } catch (err) {
                                return err.stack || "";
                            }
                        }();
                        var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(stack);
                        var scriptLocation = stackDetails && stackDetails[1];
                        if (!scriptLocation) return;
                        for(var _i20 = 0, _Array$prototype$slic2 = [].slice.call(document.getElementsByTagName("script")).reverse(); _i20 < _Array$prototype$slic2.length; _i20++){
                            var script = _Array$prototype$slic2[_i20];
                            if (script.src && script.src === scriptLocation) return script;
                        }
                    } catch (err) {}
                }()) return currentScript;
                throw new Error("Can not determine current script");
            });
            var currentUID = uniqueID();
            memoize(function() {
                var script;
                try {
                    script = getCurrentScript();
                } catch (err) {
                    return currentUID;
                }
                var uid = script.getAttribute("data-uid");
                if (uid && "string" == typeof uid) return uid;
                uid = uniqueID();
                script.setAttribute("data-uid", uid);
                return uid;
            });
            function global_getGlobal(win) {
                void 0 === win && (win = window);
                var globalKey = "__post_robot_10_0_41__";
                return win !== window ? win[globalKey] : win[globalKey] = win[globalKey] || {};
            }
            var getObj = function() {
                return {};
            };
            function globalStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return util_getOrSet(global_getGlobal(), key, function() {
                    var store = defStore();
                    return {
                        has: function(storeKey) {
                            return store.hasOwnProperty(storeKey);
                        },
                        get: function(storeKey, defVal) {
                            return store.hasOwnProperty(storeKey) ? store[storeKey] : defVal;
                        },
                        set: function(storeKey, val) {
                            store[storeKey] = val;
                            return val;
                        },
                        del: function(storeKey) {
                            delete store[storeKey];
                        },
                        getOrSet: function(storeKey, getter) {
                            return util_getOrSet(store, storeKey, getter);
                        },
                        reset: function() {
                            store = defStore();
                        },
                        keys: function() {
                            return Object.keys(store);
                        }
                    };
                });
            }
            var WildCard = function() {};
            function getWildcard() {
                var global = global_getGlobal();
                global.WINDOW_WILDCARD = global.WINDOW_WILDCARD || new WildCard;
                return global.WINDOW_WILDCARD;
            }
            function windowStore(key, defStore) {
                void 0 === key && (key = "store");
                void 0 === defStore && (defStore = getObj);
                return globalStore("windowStore").getOrSet(key, function() {
                    var winStore = new weakmap_CrossDomainSafeWeakMap;
                    var getStore = function(win) {
                        return winStore.getOrSet(win, defStore);
                    };
                    return {
                        has: function(win) {
                            return getStore(win).hasOwnProperty(key);
                        },
                        get: function(win, defVal) {
                            var store = getStore(win);
                            return store.hasOwnProperty(key) ? store[key] : defVal;
                        },
                        set: function(win, val) {
                            getStore(win)[key] = val;
                            return val;
                        },
                        del: function(win) {
                            delete getStore(win)[key];
                        },
                        getOrSet: function(win, getter) {
                            return util_getOrSet(getStore(win), key, getter);
                        }
                    };
                });
            }
            function getInstanceID() {
                return globalStore("instance").getOrSet("instanceID", uniqueID);
            }
            function resolveHelloPromise(win, _ref) {
                var domain = _ref.domain;
                var helloPromises = windowStore("helloPromises");
                var existingPromise = helloPromises.get(win);
                existingPromise && existingPromise.resolve({
                    domain: domain
                });
                var newPromise = promise_ZalgoPromise.resolve({
                    domain: domain
                });
                helloPromises.set(win, newPromise);
                return newPromise;
            }
            function sayHello(win, _ref4) {
                return (0, _ref4.send)(win, "postrobot_hello", {
                    instanceID: getInstanceID()
                }, {
                    domain: "*",
                    timeout: -1
                }).then(function(_ref5) {
                    var origin = _ref5.origin, instanceID = _ref5.data.instanceID;
                    resolveHelloPromise(win, {
                        domain: origin
                    });
                    return {
                        win: win,
                        domain: origin,
                        instanceID: instanceID
                    };
                });
            }
            function getWindowInstanceID(win, _ref6) {
                var send = _ref6.send;
                return windowStore("windowInstanceIDPromises").getOrSet(win, function() {
                    return sayHello(win, {
                        send: send
                    }).then(function(_ref7) {
                        return _ref7.instanceID;
                    });
                });
            }
            function markWindowKnown(win) {
                windowStore("knownWindows").set(win, !0);
            }
            function isSerializedType(item) {
                return "object" == typeof item && null !== item && "string" == typeof item.__type__;
            }
            function determineType(val) {
                return void 0 === val ? "undefined" : null === val ? "null" : Array.isArray(val) ? "array" : "function" == typeof val ? "function" : "object" == typeof val ? val instanceof Error ? "error" : "function" == typeof val.then ? "promise" : "[object RegExp]" === ({}).toString.call(val) ? "regex" : "[object Date]" === ({}).toString.call(val) ? "date" : "object" : "string" == typeof val ? "string" : "number" == typeof val ? "number" : "boolean" == typeof val ? "boolean" : void 0;
            }
            function serializeType(type, val) {
                return {
                    __type__: type,
                    __val__: val
                };
            }
            var _SERIALIZER;
            var SERIALIZER = ((_SERIALIZER = {}).function = function() {}, _SERIALIZER.error = function(_ref) {
                return serializeType("error", {
                    message: _ref.message,
                    stack: _ref.stack,
                    code: _ref.code,
                    data: _ref.data
                });
            }, _SERIALIZER.promise = function() {}, _SERIALIZER.regex = function(val) {
                return serializeType("regex", val.source);
            }, _SERIALIZER.date = function(val) {
                return serializeType("date", val.toJSON());
            }, _SERIALIZER.array = function(val) {
                return val;
            }, _SERIALIZER.object = function(val) {
                return val;
            }, _SERIALIZER.string = function(val) {
                return val;
            }, _SERIALIZER.number = function(val) {
                return val;
            }, _SERIALIZER.boolean = function(val) {
                return val;
            }, _SERIALIZER.null = function(val) {
                return val;
            }, _SERIALIZER);
            var defaultSerializers = {};
            var _DESERIALIZER;
            var DESERIALIZER = ((_DESERIALIZER = {}).function = function() {
                throw new Error("Function serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.error = function(_ref2) {
                var stack = _ref2.stack, code = _ref2.code, data = _ref2.data;
                var error = new Error(_ref2.message);
                error.code = code;
                data && (error.data = data);
                error.stack = stack + "\n\n" + error.stack;
                return error;
            }, _DESERIALIZER.promise = function() {
                throw new Error("Promise serialization is not implemented; nothing to deserialize");
            }, _DESERIALIZER.regex = function(val) {
                return new RegExp(val);
            }, _DESERIALIZER.date = function(val) {
                return new Date(val);
            }, _DESERIALIZER.array = function(val) {
                return val;
            }, _DESERIALIZER.object = function(val) {
                return val;
            }, _DESERIALIZER.string = function(val) {
                return val;
            }, _DESERIALIZER.number = function(val) {
                return val;
            }, _DESERIALIZER.boolean = function(val) {
                return val;
            }, _DESERIALIZER.null = function(val) {
                return val;
            }, _DESERIALIZER);
            var defaultDeserializers = {};
            new promise_ZalgoPromise(function(resolve) {
                if (window.document && window.document.body) return resolve(window.document.body);
                var interval = setInterval(function() {
                    if (window.document && window.document.body) {
                        clearInterval(interval);
                        return resolve(window.document.body);
                    }
                }, 10);
            });
            function cleanupProxyWindows() {
                var idToProxyWindow = globalStore("idToProxyWindow");
                for(var _i2 = 0, _idToProxyWindow$keys2 = idToProxyWindow.keys(); _i2 < _idToProxyWindow$keys2.length; _i2++){
                    var id = _idToProxyWindow$keys2[_i2];
                    idToProxyWindow.get(id).shouldClean() && idToProxyWindow.del(id);
                }
            }
            function getSerializedWindow(winPromise, _ref) {
                var send = _ref.send, _ref$id = _ref.id, id = void 0 === _ref$id ? uniqueID() : _ref$id;
                var windowNamePromise = winPromise.then(function(win) {
                    if (isSameDomain(win)) return assertSameDomain(win).name;
                });
                var windowTypePromise = winPromise.then(function(window1) {
                    if (isWindowClosed(window1)) throw new Error("Window is closed, can not determine type");
                    return getOpener(window1) ? "popup" : "iframe";
                });
                windowNamePromise.catch(src_util_noop);
                windowTypePromise.catch(src_util_noop);
                return {
                    id: id,
                    getType: function() {
                        return windowTypePromise;
                    },
                    getInstanceID: memoizePromise(function() {
                        return winPromise.then(function(win) {
                            return getWindowInstanceID(win, {
                                send: send
                            });
                        });
                    }),
                    close: function() {
                        return winPromise.then(closeWindow);
                    },
                    getName: function() {
                        return winPromise.then(function(win) {
                            if (!isWindowClosed(win)) return isSameDomain(win) ? assertSameDomain(win).name : windowNamePromise;
                        });
                    },
                    focus: function() {
                        return winPromise.then(function(win) {
                            win.focus();
                        });
                    },
                    isClosed: function() {
                        return winPromise.then(function(win) {
                            return isWindowClosed(win);
                        });
                    },
                    setLocation: function(href) {
                        return winPromise.then(function(win) {
                            var domain = window.location.protocol + "//" + window.location.host;
                            if (0 === href.indexOf("/")) href = "" + domain + href;
                            else if (!href.match(/^https?:\/\//) && 0 !== href.indexOf(domain)) throw new Error("Expected url to be http or https url, or absolute path, got " + JSON.stringify(href));
                            if (isSameDomain(win)) try {
                                if (win.location && "function" == typeof win.location.replace) {
                                    win.location.replace(href);
                                    return;
                                }
                            } catch (err) {}
                            win.location = href;
                        });
                    },
                    setName: function(name) {
                        return winPromise.then(function(win) {
                            var sameDomain = isSameDomain(win);
                            var frame = function(win) {
                                if (isSameDomain(win)) return assertSameDomain(win).frameElement;
                                for(var _i21 = 0, _document$querySelect2 = document.querySelectorAll("iframe"); _i21 < _document$querySelect2.length; _i21++){
                                    var frame = _document$querySelect2[_i21];
                                    if (frame && frame.contentWindow && frame.contentWindow === win) return frame;
                                }
                            }(win);
                            if (!sameDomain) throw new Error("Can not set name for cross-domain window: " + name);
                            assertSameDomain(win).name = name;
                            frame && frame.setAttribute("name", name);
                            windowNamePromise = promise_ZalgoPromise.resolve(name);
                        });
                    }
                };
            }
            var window_ProxyWindow = function() {
                function ProxyWindow(_ref2) {
                    var send = _ref2.send, win = _ref2.win, serializedWindow = _ref2.serializedWindow;
                    this.id = void 0;
                    this.isProxyWindow = !0;
                    this.serializedWindow = void 0;
                    this.actualWindow = void 0;
                    this.actualWindowPromise = void 0;
                    this.send = void 0;
                    this.name = void 0;
                    this.actualWindowPromise = new promise_ZalgoPromise;
                    this.serializedWindow = serializedWindow || getSerializedWindow(this.actualWindowPromise, {
                        send: send
                    });
                    globalStore("idToProxyWindow").set(this.getID(), this);
                    win && this.setWindow(win, {
                        send: send
                    });
                }
                var _proto = ProxyWindow.prototype;
                _proto.getID = function() {
                    return this.serializedWindow.id;
                };
                _proto.getType = function() {
                    return this.serializedWindow.getType();
                };
                _proto.isPopup = function() {
                    return this.getType().then(function(type) {
                        return "popup" === type;
                    });
                };
                _proto.setLocation = function(href) {
                    var _this = this;
                    return this.serializedWindow.setLocation(href).then(function() {
                        return _this;
                    });
                };
                _proto.getName = function() {
                    return this.serializedWindow.getName();
                };
                _proto.setName = function(name) {
                    var _this2 = this;
                    return this.serializedWindow.setName(name).then(function() {
                        return _this2;
                    });
                };
                _proto.close = function() {
                    var _this3 = this;
                    return this.serializedWindow.close().then(function() {
                        return _this3;
                    });
                };
                _proto.focus = function() {
                    var _this4 = this;
                    var isPopupPromise = this.isPopup();
                    var getNamePromise = this.getName();
                    var reopenPromise = promise_ZalgoPromise.hash({
                        isPopup: isPopupPromise,
                        name: getNamePromise
                    }).then(function(_ref3) {
                        var name = _ref3.name;
                        _ref3.isPopup && name && window.open("", name);
                    });
                    var focusPromise = this.serializedWindow.focus();
                    return promise_ZalgoPromise.all([
                        reopenPromise,
                        focusPromise
                    ]).then(function() {
                        return _this4;
                    });
                };
                _proto.isClosed = function() {
                    return this.serializedWindow.isClosed();
                };
                _proto.getWindow = function() {
                    return this.actualWindow;
                };
                _proto.setWindow = function(win, _ref4) {
                    var send = _ref4.send;
                    this.actualWindow = win;
                    this.actualWindowPromise.resolve(this.actualWindow);
                    this.serializedWindow = getSerializedWindow(this.actualWindowPromise, {
                        send: send,
                        id: this.getID()
                    });
                    windowStore("winToProxyWindow").set(win, this);
                };
                _proto.awaitWindow = function() {
                    return this.actualWindowPromise;
                };
                _proto.matchWindow = function(win, _ref5) {
                    var _this5 = this;
                    var send = _ref5.send;
                    return promise_ZalgoPromise.try(function() {
                        return _this5.actualWindow ? win === _this5.actualWindow : promise_ZalgoPromise.hash({
                            proxyInstanceID: _this5.getInstanceID(),
                            knownWindowInstanceID: getWindowInstanceID(win, {
                                send: send
                            })
                        }).then(function(_ref6) {
                            var match = _ref6.proxyInstanceID === _ref6.knownWindowInstanceID;
                            match && _this5.setWindow(win, {
                                send: send
                            });
                            return match;
                        });
                    });
                };
                _proto.unwrap = function() {
                    return this.actualWindow || this;
                };
                _proto.getInstanceID = function() {
                    return this.serializedWindow.getInstanceID();
                };
                _proto.shouldClean = function() {
                    return Boolean(this.actualWindow && isWindowClosed(this.actualWindow));
                };
                _proto.serialize = function() {
                    return this.serializedWindow;
                };
                ProxyWindow.unwrap = function(win) {
                    return ProxyWindow.isProxyWindow(win) ? win.unwrap() : win;
                };
                ProxyWindow.serialize = function(win, _ref7) {
                    var send = _ref7.send;
                    cleanupProxyWindows();
                    return ProxyWindow.toProxyWindow(win, {
                        send: send
                    }).serialize();
                };
                ProxyWindow.deserialize = function(serializedWindow, _ref8) {
                    var send = _ref8.send;
                    cleanupProxyWindows();
                    return globalStore("idToProxyWindow").get(serializedWindow.id) || new ProxyWindow({
                        serializedWindow: serializedWindow,
                        send: send
                    });
                };
                ProxyWindow.isProxyWindow = function(obj) {
                    return Boolean(obj && !isWindow(obj) && obj.isProxyWindow);
                };
                ProxyWindow.toProxyWindow = function(win, _ref9) {
                    var send = _ref9.send;
                    cleanupProxyWindows();
                    if (ProxyWindow.isProxyWindow(win)) return win;
                    var actualWindow = win;
                    return windowStore("winToProxyWindow").get(actualWindow) || new ProxyWindow({
                        win: actualWindow,
                        send: send
                    });
                };
                return ProxyWindow;
            }();
            function addMethod(id, val, name, source, domain) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                if (window_ProxyWindow.isProxyWindow(source)) proxyWindowMethods.set(id, {
                    val: val,
                    name: name,
                    domain: domain,
                    source: source
                });
                else {
                    proxyWindowMethods.del(id);
                    methodStore.getOrSet(source, function() {
                        return {};
                    })[id] = {
                        domain: domain,
                        name: name,
                        val: val,
                        source: source
                    };
                }
            }
            function lookupMethod(source, id) {
                var methodStore = windowStore("methodStore");
                var proxyWindowMethods = globalStore("proxyWindowMethods");
                return methodStore.getOrSet(source, function() {
                    return {};
                })[id] || proxyWindowMethods.get(id);
            }
            function function_serializeFunction(destination, domain, val, key, _ref3) {
                on = (_ref = {
                    on: _ref3.on,
                    send: _ref3.send
                }).on, send = _ref.send, globalStore("builtinListeners").getOrSet("functionCalls", function() {
                    return on("postrobot_method", {
                        domain: "*"
                    }, function(_ref2) {
                        var source = _ref2.source, origin = _ref2.origin, data = _ref2.data;
                        var id = data.id, name = data.name;
                        var meth = lookupMethod(source, id);
                        if (!meth) throw new Error("Could not find method '" + name + "' with id: " + data.id + " in " + getDomain(window));
                        var methodSource = meth.source, domain = meth.domain, val = meth.val;
                        return promise_ZalgoPromise.try(function() {
                            if (!matchDomain(domain, origin)) throw new Error("Method '" + data.name + "' domain " + JSON.stringify(util_isRegex(meth.domain) ? meth.domain.source : meth.domain) + " does not match origin " + origin + " in " + getDomain(window));
                            if (window_ProxyWindow.isProxyWindow(methodSource)) return methodSource.matchWindow(source, {
                                send: send
                            }).then(function(match) {
                                if (!match) throw new Error("Method call '" + data.name + "' failed - proxy window does not match source in " + getDomain(window));
                            });
                        }).then(function() {
                            return val.apply({
                                source: source,
                                origin: origin
                            }, data.args);
                        }, function(err) {
                            return promise_ZalgoPromise.try(function() {
                                if (val.onError) return val.onError(err);
                            }).then(function() {
                                err.stack && (err.stack = "Remote call to " + name + "(" + function(args) {
                                    void 0 === args && (args = []);
                                    var item;
                                    return (item = args, [].slice.call(item)).map(function(arg) {
                                        return "string" == typeof arg ? "'" + arg + "'" : void 0 === arg ? "undefined" : null === arg ? "null" : "boolean" == typeof arg ? arg.toString() : Array.isArray(arg) ? "[ ... ]" : "object" == typeof arg ? "{ ... }" : "function" == typeof arg ? "() => { ... }" : "<" + typeof arg + ">";
                                    }).join(", ");
                                }(data.args) + ") failed\n\n" + err.stack);
                                throw err;
                            });
                        }).then(function(result) {
                            return {
                                result: result,
                                id: id,
                                name: name
                            };
                        });
                    });
                });
                var _ref, on, send;
                var id = val.__id__ || uniqueID();
                destination = window_ProxyWindow.unwrap(destination);
                var name = val.__name__ || val.name || key;
                "string" == typeof name && "function" == typeof name.indexOf && 0 === name.indexOf("anonymous::") && (name = name.replace("anonymous::", key + "::"));
                if (window_ProxyWindow.isProxyWindow(destination)) {
                    addMethod(id, val, name, destination, domain);
                    destination.awaitWindow().then(function(win) {
                        addMethod(id, val, name, win, domain);
                    });
                } else addMethod(id, val, name, destination, domain);
                return serializeType("cross_domain_function", {
                    id: id,
                    name: name
                });
            }
            function serializeMessage(destination, domain, obj, _ref) {
                var _serialize;
                var on = _ref.on, send = _ref.send;
                return function(obj, serializers) {
                    void 0 === serializers && (serializers = defaultSerializers);
                    var result = JSON.stringify(obj, function(key) {
                        var val = this[key];
                        if (isSerializedType(this)) return val;
                        var type = determineType(val);
                        if (!type) return val;
                        var serializer = serializers[type] || SERIALIZER[type];
                        return serializer ? serializer(val, key) : val;
                    });
                    return void 0 === result ? "undefined" : result;
                }(obj, ((_serialize = {}).promise = function(val, key) {
                    return function(destination, domain, val, key, _ref) {
                        return serializeType("cross_domain_zalgo_promise", {
                            then: function_serializeFunction(destination, domain, function(resolve, reject) {
                                return val.then(resolve, reject);
                            }, key, {
                                on: _ref.on,
                                send: _ref.send
                            })
                        });
                    }(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.function = function(val, key) {
                    return function_serializeFunction(destination, domain, val, key, {
                        on: on,
                        send: send
                    });
                }, _serialize.object = function(val) {
                    return isWindow(val) || window_ProxyWindow.isProxyWindow(val) ? serializeType("cross_domain_window", window_ProxyWindow.serialize(val, {
                        send: send
                    })) : val;
                }, _serialize));
            }
            function deserializeMessage(source, origin, message, _ref2) {
                var _deserialize;
                var send = _ref2.send;
                return function(str, deserializers) {
                    void 0 === deserializers && (deserializers = defaultDeserializers);
                    if ("undefined" !== str) return JSON.parse(str, function(key, val) {
                        if (isSerializedType(this)) return val;
                        var type;
                        var value;
                        if (isSerializedType(val)) {
                            type = val.__type__;
                            value = val.__val__;
                        } else {
                            type = determineType(val);
                            value = val;
                        }
                        if (!type) return value;
                        var deserializer = deserializers[type] || DESERIALIZER[type];
                        return deserializer ? deserializer(value, key) : value;
                    });
                }(message, ((_deserialize = {}).cross_domain_zalgo_promise = function(serializedPromise) {
                    return function(source, origin, _ref2) {
                        return new promise_ZalgoPromise(_ref2.then);
                    }(0, 0, serializedPromise);
                }, _deserialize.cross_domain_function = function(serializedFunction) {
                    return function(source, origin, _ref4, _ref5) {
                        var id = _ref4.id, name = _ref4.name;
                        var send = _ref5.send;
                        var getDeserializedFunction = function(opts) {
                            void 0 === opts && (opts = {});
                            function crossDomainFunctionWrapper() {
                                var _arguments = arguments;
                                return window_ProxyWindow.toProxyWindow(source, {
                                    send: send
                                }).awaitWindow().then(function(win) {
                                    var meth = lookupMethod(win, id);
                                    if (meth && meth.val !== crossDomainFunctionWrapper) return meth.val.apply({
                                        source: window,
                                        origin: getDomain()
                                    }, _arguments);
                                    var _args = [].slice.call(_arguments);
                                    return opts.fireAndForget ? send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !0
                                    }) : send(win, "postrobot_method", {
                                        id: id,
                                        name: name,
                                        args: _args
                                    }, {
                                        domain: origin,
                                        fireAndForget: !1
                                    }).then(function(res) {
                                        return res.data.result;
                                    });
                                }).catch(function(err) {
                                    throw err;
                                });
                            }
                            crossDomainFunctionWrapper.__name__ = name;
                            crossDomainFunctionWrapper.__origin__ = origin;
                            crossDomainFunctionWrapper.__source__ = source;
                            crossDomainFunctionWrapper.__id__ = id;
                            crossDomainFunctionWrapper.origin = origin;
                            return crossDomainFunctionWrapper;
                        };
                        var crossDomainFunctionWrapper = getDeserializedFunction();
                        crossDomainFunctionWrapper.fireAndForget = getDeserializedFunction({
                            fireAndForget: !0
                        });
                        return crossDomainFunctionWrapper;
                    }(source, origin, serializedFunction, {
                        send: send
                    });
                }, _deserialize.cross_domain_window = function(serializedWindow) {
                    return window_ProxyWindow.deserialize(serializedWindow, {
                        send: send
                    });
                }, _deserialize));
            }
            var SEND_MESSAGE_STRATEGIES = {};
            SEND_MESSAGE_STRATEGIES.postrobot_post_message = function(win, serializedMessage, domain) {
                0 === domain.indexOf("file:") && (domain = "*");
                win.postMessage(serializedMessage, domain);
            };
            function send_sendMessage(win, domain, message, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                return promise_ZalgoPromise.try(function() {
                    var domainBuffer = windowStore().getOrSet(win, function() {
                        return {};
                    });
                    domainBuffer.buffer = domainBuffer.buffer || [];
                    domainBuffer.buffer.push(message);
                    domainBuffer.flush = domainBuffer.flush || promise_ZalgoPromise.flush().then(function() {
                        if (isWindowClosed(win)) throw new Error("Window is closed");
                        var serializedMessage = serializeMessage(win, domain, ((_ref = {}).__post_robot_10_0_41__ = domainBuffer.buffer || [], _ref), {
                            on: on,
                            send: send
                        });
                        var _ref;
                        delete domainBuffer.buffer;
                        var strategies = Object.keys(SEND_MESSAGE_STRATEGIES);
                        var errors = [];
                        for(var _i2 = 0; _i2 < strategies.length; _i2++){
                            var strategyName = strategies[_i2];
                            try {
                                SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                            } catch (err) {
                                errors.push(err);
                            }
                        }
                        if (errors.length === strategies.length) throw new Error("All post-robot messaging strategies failed:\n\n" + errors.map(function(err, i) {
                            return i + ". " + stringifyError(err);
                        }).join("\n\n"));
                    });
                    return domainBuffer.flush.then(function() {
                        delete domainBuffer.flush;
                    });
                }).then(src_util_noop);
            }
            function getResponseListener(hash) {
                return globalStore("responseListeners").get(hash);
            }
            function deleteResponseListener(hash) {
                globalStore("responseListeners").del(hash);
            }
            function isResponseListenerErrored(hash) {
                return globalStore("erroredResponseListeners").has(hash);
            }
            function getRequestListener(_ref) {
                var name = _ref.name, win = _ref.win, domain = _ref.domain;
                var requestListeners = windowStore("requestListeners");
                "*" === win && (win = null);
                "*" === domain && (domain = null);
                if (!name) throw new Error("Name required to get request listener");
                for(var _i4 = 0, _ref3 = [
                    win,
                    getWildcard()
                ]; _i4 < _ref3.length; _i4++){
                    var winQualifier = _ref3[_i4];
                    if (winQualifier) {
                        var nameListeners = requestListeners.get(winQualifier);
                        if (nameListeners) {
                            var domainListeners = nameListeners[name];
                            if (domainListeners) {
                                if (domain && "string" == typeof domain) {
                                    if (domainListeners[domain]) return domainListeners[domain];
                                    if (domainListeners.__domain_regex__) for(var _i6 = 0, _domainListeners$__DO2 = domainListeners.__domain_regex__; _i6 < _domainListeners$__DO2.length; _i6++){
                                        var _domainListeners$__DO3 = _domainListeners$__DO2[_i6], listener = _domainListeners$__DO3.listener;
                                        if (matchDomain(_domainListeners$__DO3.regex, domain)) return listener;
                                    }
                                }
                                if (domainListeners["*"]) return domainListeners["*"];
                            }
                        }
                    }
                }
            }
            function handleRequest(source, origin, message, _ref) {
                var on = _ref.on, send = _ref.send;
                var options = getRequestListener({
                    name: message.name,
                    win: source,
                    domain: origin
                });
                var logName = "postrobot_method" === message.name && message.data && "string" == typeof message.data.name ? message.data.name + "()" : message.name;
                function sendResponse(ack, data, error) {
                    return promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_response",
                                hash: message.hash,
                                name: message.name,
                                ack: ack,
                                data: data,
                                error: error
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send response message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    });
                }
                return promise_ZalgoPromise.all([
                    promise_ZalgoPromise.flush().then(function() {
                        if (!message.fireAndForget && !isWindowClosed(source)) try {
                            return send_sendMessage(source, origin, {
                                id: uniqueID(),
                                origin: getDomain(window),
                                type: "postrobot_message_ack",
                                hash: message.hash,
                                name: message.name
                            }, {
                                on: on,
                                send: send
                            });
                        } catch (err) {
                            throw new Error("Send ack message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                        }
                    }),
                    promise_ZalgoPromise.try(function() {
                        if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                        if (!matchDomain(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                        return options.handler({
                            source: source,
                            origin: origin,
                            data: message.data
                        });
                    }).then(function(data) {
                        return sendResponse("success", data);
                    }, function(error) {
                        return sendResponse("error", null, error);
                    })
                ]).then(src_util_noop).catch(function(err) {
                    if (options && options.handleError) return options.handleError(err);
                    throw err;
                });
            }
            function handleAck(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    try {
                        if (!matchDomain(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                        if (source !== options.win) throw new Error("Ack source does not match registered window");
                    } catch (err) {
                        options.promise.reject(err);
                    }
                    options.ack = !0;
                }
            }
            function handleResponse(source, origin, message) {
                if (!isResponseListenerErrored(message.hash)) {
                    var options = getResponseListener(message.hash);
                    if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                    if (!matchDomain(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + (pattern = options.domain, Array.isArray(pattern) ? "(" + pattern.join(" | ") + ")" : isRegex(pattern) ? "RegExp(" + pattern.toString() : pattern.toString()));
                    var pattern;
                    if (source !== options.win) throw new Error("Response source does not match registered window");
                    deleteResponseListener(message.hash);
                    "error" === message.ack ? options.promise.reject(message.error) : "success" === message.ack && options.promise.resolve({
                        source: source,
                        origin: origin,
                        data: message.data
                    });
                }
            }
            function receive_receiveMessage(event, _ref2) {
                var on = _ref2.on, send = _ref2.send;
                var receivedMessages = globalStore("receivedMessages");
                try {
                    if (!window || window.closed || !event.source) return;
                } catch (err) {
                    return;
                }
                var source = event.source, origin = event.origin;
                var messages = function(message, source, origin, _ref) {
                    var on = _ref.on, send = _ref.send;
                    var parsedMessage;
                    try {
                        parsedMessage = deserializeMessage(source, origin, message, {
                            on: on,
                            send: send
                        });
                    } catch (err) {
                        return;
                    }
                    if (parsedMessage && "object" == typeof parsedMessage && null !== parsedMessage) {
                        var parseMessages = parsedMessage.__post_robot_10_0_41__;
                        if (Array.isArray(parseMessages)) return parseMessages;
                    }
                }(event.data, source, origin, {
                    on: on,
                    send: send
                });
                if (messages) {
                    markWindowKnown(source);
                    for(var _i2 = 0; _i2 < messages.length; _i2++){
                        var message = messages[_i2];
                        if (receivedMessages.has(message.id)) return;
                        receivedMessages.set(message.id, !0);
                        if (isWindowClosed(source) && !message.fireAndForget) return;
                        0 === message.origin.indexOf("file:") && (origin = "file://");
                        try {
                            "postrobot_message_request" === message.type ? handleRequest(source, origin, message, {
                                on: on,
                                send: send
                            }) : "postrobot_message_response" === message.type ? handleResponse(source, origin, message) : "postrobot_message_ack" === message.type && handleAck(source, origin, message);
                        } catch (err) {
                            setTimeout(function() {
                                throw err;
                            }, 0);
                        }
                    }
                }
            }
            function on_on(name, options, handler) {
                if (!name) throw new Error("Expected name");
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                if (!handler) throw new Error("Expected handler");
                (options = options || {}).name = name;
                options.handler = handler || options.handler;
                var win = options.window;
                var domain = options.domain;
                var requestListener = function addRequestListener(_ref4, listener) {
                    var name = _ref4.name, win = _ref4.win, domain = _ref4.domain;
                    var requestListeners = windowStore("requestListeners");
                    if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                    if (Array.isArray(win)) {
                        var listenersCollection = [];
                        for(var _i8 = 0, _win2 = win; _i8 < _win2.length; _i8++)listenersCollection.push(addRequestListener({
                            name: name,
                            domain: domain,
                            win: _win2[_i8]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i10 = 0; _i10 < listenersCollection.length; _i10++)listenersCollection[_i10].cancel();
                            }
                        };
                    }
                    if (Array.isArray(domain)) {
                        var _listenersCollection = [];
                        for(var _i12 = 0, _domain2 = domain; _i12 < _domain2.length; _i12++)_listenersCollection.push(addRequestListener({
                            name: name,
                            win: win,
                            domain: _domain2[_i12]
                        }, listener));
                        return {
                            cancel: function() {
                                for(var _i14 = 0; _i14 < _listenersCollection.length; _i14++)_listenersCollection[_i14].cancel();
                            }
                        };
                    }
                    var existingListener = getRequestListener({
                        name: name,
                        win: win,
                        domain: domain
                    });
                    win && "*" !== win || (win = getWildcard());
                    domain = domain || "*";
                    if (existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === getWildcard() ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                    var nameListeners = requestListeners.getOrSet(win, function() {
                        return {};
                    });
                    var domainListeners = util_getOrSet(nameListeners, name, function() {
                        return {};
                    });
                    var strDomain = domain.toString();
                    var regexListeners;
                    var regexListener;
                    util_isRegex(domain) ? (regexListeners = util_getOrSet(domainListeners, "__domain_regex__", function() {
                        return [];
                    })).push(regexListener = {
                        regex: domain,
                        listener: listener
                    }) : domainListeners[strDomain] = listener;
                    return {
                        cancel: function() {
                            delete domainListeners[strDomain];
                            if (regexListener) {
                                regexListeners.splice(regexListeners.indexOf(regexListener, 1));
                                regexListeners.length || delete domainListeners.__domain_regex__;
                            }
                            Object.keys(domainListeners).length || delete nameListeners[name];
                            win && !Object.keys(nameListeners).length && requestListeners.del(win);
                        }
                    };
                }({
                    name: name,
                    win: win,
                    domain: domain
                }, {
                    handler: options.handler,
                    handleError: options.errorHandler || function(err) {
                        throw err;
                    },
                    window: win,
                    domain: domain || "*",
                    name: name
                });
                return {
                    cancel: function() {
                        requestListener.cancel();
                    }
                };
            }
            function on_once(name, options, handler) {
                if ("function" == typeof (options = options || {})) {
                    handler = options;
                    options = {};
                }
                var promise = new promise_ZalgoPromise;
                var listener;
                options.errorHandler = function(err) {
                    listener.cancel();
                    promise.reject(err);
                };
                listener = on_on(name, options, function(event) {
                    listener.cancel();
                    promise.resolve(event);
                    if (handler) return handler(event);
                });
                promise.cancel = listener.cancel;
                return promise;
            }
            var send_send = function send(win, name, data, options) {
                var domainMatcher = (options = options || {}).domain || "*";
                var responseTimeout = options.timeout || -1;
                var childTimeout = options.timeout || 5e3;
                var fireAndForget = options.fireAndForget || !1;
                return promise_ZalgoPromise.try(function() {
                    !function(name, win, domain) {
                        if (!name) throw new Error("Expected name");
                        if (domain && "string" != typeof domain && !Array.isArray(domain) && !util_isRegex(domain)) throw new TypeError("Can not send " + name + ". Expected domain " + JSON.stringify(domain) + " to be a string, array, or regex");
                        if (isWindowClosed(win)) throw new Error("Can not send " + name + ". Target window is closed");
                    }(name, win, domainMatcher);
                    if (function(parent, child) {
                        var actualParent = getAncestor(child);
                        if (actualParent) return actualParent === parent;
                        if (child === parent) return !1;
                        if (function(win) {
                            void 0 === win && (win = window);
                            try {
                                if (win.top) return win.top;
                            } catch (err) {}
                            if (getParent(win) === win) return win;
                            try {
                                if (isAncestorParent(window, win) && window.top) return window.top;
                            } catch (err) {}
                            try {
                                if (isAncestorParent(win, window) && window.top) return window.top;
                            } catch (err) {}
                            for(var _i7 = 0, _getAllChildFrames4 = function getAllChildFrames(win) {
                                var result = [];
                                for(var _i3 = 0, _getFrames2 = getFrames(win); _i3 < _getFrames2.length; _i3++){
                                    var frame = _getFrames2[_i3];
                                    result.push(frame);
                                    for(var _i5 = 0, _getAllChildFrames2 = getAllChildFrames(frame); _i5 < _getAllChildFrames2.length; _i5++)result.push(_getAllChildFrames2[_i5]);
                                }
                                return result;
                            }(win); _i7 < _getAllChildFrames4.length; _i7++){
                                var frame = _getAllChildFrames4[_i7];
                                try {
                                    if (frame.top) return frame.top;
                                } catch (err) {}
                                if (getParent(frame) === frame) return frame;
                            }
                        }(child) === child) return !1;
                        for(var _i15 = 0, _getFrames8 = getFrames(parent); _i15 < _getFrames8.length; _i15++)if (_getFrames8[_i15] === child) return !0;
                        return !1;
                    }(window, win)) return function(win, timeout, name) {
                        void 0 === timeout && (timeout = 5e3);
                        void 0 === name && (name = "Window");
                        var promise = function(win) {
                            return windowStore("helloPromises").getOrSet(win, function() {
                                return new promise_ZalgoPromise;
                            });
                        }(win);
                        -1 !== timeout && (promise = promise.timeout(timeout, new Error(name + " did not load after " + timeout + "ms")));
                        return promise;
                    }(win, childTimeout);
                }).then(function(_temp) {
                    return function(win, targetDomain, actualDomain, _ref) {
                        var send = _ref.send;
                        return promise_ZalgoPromise.try(function() {
                            return "string" == typeof targetDomain ? targetDomain : promise_ZalgoPromise.try(function() {
                                return actualDomain || sayHello(win, {
                                    send: send
                                }).then(function(_ref2) {
                                    return _ref2.domain;
                                });
                            }).then(function(normalizedDomain) {
                                if (!matchDomain(targetDomain, targetDomain)) throw new Error("Domain " + stringify(targetDomain) + " does not match " + stringify(targetDomain));
                                return normalizedDomain;
                            });
                        });
                    }(win, domainMatcher, (void 0 === _temp ? {} : _temp).domain, {
                        send: send
                    });
                }).then(function(targetDomain) {
                    var domain = targetDomain;
                    var logName = "postrobot_method" === name && data && "string" == typeof data.name ? data.name + "()" : name;
                    var promise = new promise_ZalgoPromise;
                    var hash = name + "_" + uniqueID();
                    if (!fireAndForget) {
                        var responseListener = {
                            name: name,
                            win: win,
                            domain: domain,
                            promise: promise
                        };
                        !function(hash, listener) {
                            globalStore("responseListeners").set(hash, listener);
                        }(hash, responseListener);
                        var reqPromises = windowStore("requestPromises").getOrSet(win, function() {
                            return [];
                        });
                        reqPromises.push(promise);
                        promise.catch(function() {
                            !function(hash) {
                                globalStore("erroredResponseListeners").set(hash, !0);
                            }(hash);
                            deleteResponseListener(hash);
                        });
                        var totalAckTimeout = function(win) {
                            return windowStore("knownWindows").get(win, !1);
                        }(win) ? 1e4 : 2e3;
                        var totalResTimeout = responseTimeout;
                        var ackTimeout = totalAckTimeout;
                        var resTimeout = totalResTimeout;
                        var interval = function(method, time) {
                            var timeout;
                            !function loop() {
                                timeout = setTimeout(function() {
                                    !function() {
                                        if (isWindowClosed(win)) return promise.reject(new Error("Window closed for " + name + " before " + (responseListener.ack ? "response" : "ack")));
                                        if (responseListener.cancelled) return promise.reject(new Error("Response listener was cancelled for " + name));
                                        ackTimeout = Math.max(ackTimeout - 500, 0);
                                        -1 !== resTimeout && (resTimeout = Math.max(resTimeout - 500, 0));
                                        responseListener.ack || 0 !== ackTimeout ? 0 === resTimeout && promise.reject(new Error("No response for postMessage " + logName + " in " + getDomain() + " in " + totalResTimeout + "ms")) : promise.reject(new Error("No ack for postMessage " + logName + " in " + getDomain() + " in " + totalAckTimeout + "ms"));
                                    }();
                                    loop();
                                }, 500);
                            }();
                            return {
                                cancel: function() {
                                    clearTimeout(timeout);
                                }
                            };
                        }();
                        promise.finally(function() {
                            interval.cancel();
                            reqPromises.splice(reqPromises.indexOf(promise, 1));
                        }).catch(src_util_noop);
                    }
                    return send_sendMessage(win, domain, {
                        id: uniqueID(),
                        origin: getDomain(window),
                        type: "postrobot_message_request",
                        hash: hash,
                        name: name,
                        data: data,
                        fireAndForget: fireAndForget
                    }, {
                        on: on_on,
                        send: send
                    }).then(function() {
                        return fireAndForget ? promise.resolve() : promise;
                    }, function(err) {
                        throw new Error("Send request message failed for " + logName + " in " + getDomain() + "\n\n" + stringifyError(err));
                    });
                });
            };
            function setup_serializeMessage(destination, domain, obj) {
                return serializeMessage(destination, domain, obj, {
                    on: on_on,
                    send: send_send
                });
            }
            function setup_deserializeMessage(source, origin, message) {
                return deserializeMessage(source, origin, message, {
                    on: on_on,
                    send: send_send
                });
            }
            function createProxyWindow(win) {
                return new window_ProxyWindow({
                    send: send_send,
                    win: win
                });
            }
            function setup_toProxyWindow(win) {
                return window_ProxyWindow.toProxyWindow(win, {
                    send: send_send
                });
            }
            function setup() {
                if (!global_getGlobal().initialized) {
                    global_getGlobal().initialized = !0;
                    on = (_ref3 = {
                        on: on_on,
                        send: send_send
                    }).on, send = _ref3.send, (global = global_getGlobal()).receiveMessage = global.receiveMessage || function(message) {
                        return receive_receiveMessage(message, {
                            on: on,
                            send: send
                        });
                    };
                    !function(_ref5) {
                        var on = _ref5.on, send = _ref5.send;
                        globalStore().getOrSet("postMessageListener", function() {
                            return function(obj, event, handler) {
                                obj.addEventListener("message", handler);
                                return {
                                    cancel: function() {
                                        obj.removeEventListener("message", handler);
                                    }
                                };
                            }(window, 0, function(event) {
                                !function(event, _ref4) {
                                    var on = _ref4.on, send = _ref4.send;
                                    promise_ZalgoPromise.try(function() {
                                        var source = event.source || event.sourceElement;
                                        var origin = event.origin || event.originalEvent && event.originalEvent.origin;
                                        var data = event.data;
                                        "null" === origin && (origin = "file://");
                                        if (source) {
                                            if (!origin) throw new Error("Post message did not have origin domain");
                                            receive_receiveMessage({
                                                source: source,
                                                origin: origin,
                                                data: data
                                            }, {
                                                on: on,
                                                send: send
                                            });
                                        }
                                    });
                                }(event, {
                                    on: on,
                                    send: send
                                });
                            });
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                    !function(_ref8) {
                        var on = _ref8.on, send = _ref8.send;
                        globalStore("builtinListeners").getOrSet("helloListener", function() {
                            var listener = on("postrobot_hello", {
                                domain: "*"
                            }, function(_ref3) {
                                resolveHelloPromise(_ref3.source, {
                                    domain: _ref3.origin
                                });
                                return {
                                    instanceID: getInstanceID()
                                };
                            });
                            var parent = getAncestor();
                            parent && sayHello(parent, {
                                send: send
                            }).catch(function(err) {});
                            return listener;
                        });
                    }({
                        on: on_on,
                        send: send_send
                    });
                }
                var _ref3, on, send, global;
            }
            function destroy() {
                !function() {
                    var responseListeners = globalStore("responseListeners");
                    for(var _i2 = 0, _responseListeners$ke2 = responseListeners.keys(); _i2 < _responseListeners$ke2.length; _i2++){
                        var hash = _responseListeners$ke2[_i2];
                        var listener = responseListeners.get(hash);
                        listener && (listener.cancelled = !0);
                        responseListeners.del(hash);
                    }
                }();
                (listener = globalStore().get("postMessageListener")) && listener.cancel();
                var listener;
                delete window.__post_robot_10_0_41__;
            }
            var src_types_TYPES_0 = !0;
            function cleanUpWindow(win) {
                for(var _i2 = 0, _requestPromises$get2 = windowStore("requestPromises").get(win, []); _i2 < _requestPromises$get2.length; _i2++)_requestPromises$get2[_i2].reject(new Error("Window " + (isWindowClosed(win) ? "closed" : "cleaned up") + " before response")).catch(src_util_noop);
            }
            setup();
        }
    ]);
});

});

parcelRegister("8tWYx", function(module, exports) {
"use strict";
var $62cec777db13e7d3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $62cec777db13e7d3$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SANDBOX_CONNECTION_TIMEOUT_MS = module.exports.SANDBOX_CONTROLLER_REQUEST_EVENT = module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = module.exports.THEME_CHANGE_EVENT = module.exports.THEME_ENABLE_EVENT = module.exports.READY_EVENT = module.exports.handleMissingHandlerError = module.exports.firstToResolve = void 0;
var $62cec777db13e7d3$var$invertPromise = function(p) {
    return new Promise(function(resolve, reject) {
        return p.then(reject, resolve);
    });
};
var $62cec777db13e7d3$var$firstToResolve = function(promises) {
    return $62cec777db13e7d3$var$__awaiter(void 0, void 0, void 0, function() {
        var err_1;
        return $62cec777db13e7d3$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $62cec777db13e7d3$var$invertPromise(Promise.all(promises.map($62cec777db13e7d3$var$invertPromise)))
                    ];
                case 1:
                    return [
                        2,
                        _a.sent()
                    ];
                case 2:
                    err_1 = _a.sent();
                    throw err_1[0];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
};
module.exports.firstToResolve = $62cec777db13e7d3$var$firstToResolve;
var $62cec777db13e7d3$var$handleMissingHandlerError = function(error) {
    if (error === null || error === void 0 ? void 0 : error.message.startsWith('No handler found for post message:')) return Promise.resolve();
    else return Promise.reject("Error while sending bridge message: ".concat(error === null || error === void 0 ? void 0 : error.message));
};
module.exports.handleMissingHandlerError = $62cec777db13e7d3$var$handleMissingHandlerError;
module.exports.READY_EVENT = '__ready';
module.exports.THEME_ENABLE_EVENT = '__theme_enable';
module.exports.THEME_CHANGE_EVENT = '__theme_change';
module.exports.BRIDGE_HANDSHAKE_TIMEOUT_MS = 20000;
module.exports.SANDBOX_CONTROLLER_REQUEST_EVENT = '__sandbox_controller_request';
module.exports.SANDBOX_CONNECTION_TIMEOUT_MS = 5000;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3wBuN = parcelRequire("3wBuN");


var $esRft = parcelRequire("esRft");


var $gj7hi = parcelRequire("gj7hi");


var $chO1Z = parcelRequire("chO1Z");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $gMc0m.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $42omo.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $42omo.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $7sObp.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $7sObp.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $7sObp.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $gMc0m.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $7sObp.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $7sObp.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $7sObp.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $2XqLN = parcelRequire("2XqLN");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $aXWIB.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
// Templates that should not show the Create with Rovo button:
// legacy editor (tiny editor), blog post, and team calendar blueprints
const $f4c21c880d0229da$var$CWR_EXCLUDED_BLUEPRINT_KEYS = [
    'com.atlassian.confluence.plugins.confluence-business-blueprints:tinyeditor-blueprint',
    'com.atlassian.confluence.extra.team-calendars:tc-on-space-blueprint'
];
const $f4c21c880d0229da$export$d2b7a52bdf90089f = (template)=>{
    const { blueprintModuleCompleteKey: blueprintModuleCompleteKey, contentBlueprintId: contentBlueprintId, name: name } = template;
    return !$f4c21c880d0229da$var$CWR_EXCLUDED_BLUEPRINT_KEYS.includes(blueprintModuleCompleteKey ?? '') && contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b && !name?.toLowerCase().includes('blog');
};
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $2XqLN.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $2XqLN.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $2XqLN.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $2XqLN.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["shouldShowCWRButton"] = $f4c21c880d0229da$export$d2b7a52bdf90089f;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $2XqLN.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("5ozYM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5hAil = parcelRequire("5hAil");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $cEgMD = parcelRequire("cEgMD");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $3zetf = parcelRequire("3zetf");

const $080ccb5c9f312cd0$var$i18n = (0, $aXWIB.defineMessages)({
    companyHubDefaultTitle: {
        id: "document-title.document-space-title.company-hub.title",
        defaultMessage: "Company hub"
    }
});
function $080ccb5c9f312cd0$export$7ce5f0b10eeaaf17({ spaceKey: spaceKey, titlePrefix: titlePrefix }) {
    const { siteTitle: siteTitle, companyHubName: companyHubName } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    //In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__']) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INHERIT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5hAil.QueryGroup), {
        queryProps: (0, $3zetf.getSpaceNameQueryProps)(spaceKey)
    }, ({ results: results, loading: loading })=>{
        if (loading) return null;
        const companyHubSpaceName = companyHubName || formatMessage($080ccb5c9f312cd0$var$i18n.companyHubDefaultTitle);
        const spaceName = isCompanyHub ? companyHubSpaceName : (0, $3zetf.getSpaceNameFromResults)(results);
        const title = [
            titlePrefix,
            spaceName,
            siteTitle
        ].filter((part)=>part).join(' - ');
        // set for SSR document title
        window.__DOCUMENT_TITLE_TAG__ = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
            title: title
        });
    }));
}
module.exports["DocumentSpaceTitle"] = $080ccb5c9f312cd0$export$7ce5f0b10eeaaf17;

});

parcelRegister("5hAil", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $bavCP = parcelRequire("bavCP");

class $3d8ab1ac7a88b72c$export$9fae4d77e240e114 extends (0, $42omo.Component) {
    render() {
        const { queryProps: queryProps, children: children } = this.props;
        return this._renderQueryComponent(queryProps, children, 0);
    }
    constructor(..._args){
        super(..._args);
        this._queryResults = [];
        this._queryProperties = [];
        this._anyLoading = ()=>this._queryResults.some((data)=>data.loading === true);
        this._renderQueryComponent = (configArray, children, index)=>{
            if (!configArray.length) return children({
                results: [],
                loading: false
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
                errorPolicy: "all",
                ...configArray[index]
            }, ({ data: data, loading: loading, error: error, ...args })=>{
                this._queryResults[index] = {
                    data: data,
                    loading: loading,
                    error: error
                };
                this._queryProperties[index] = args;
                const nextIndex = index + 1;
                if (configArray.length > nextIndex) return this._renderQueryComponent(configArray, children, nextIndex);
                return children({
                    results: this._queryResults,
                    loading: this._anyLoading(),
                    properties: this._queryProperties
                });
            });
        };
    }
}
$3d8ab1ac7a88b72c$export$9fae4d77e240e114.propTypes = {
    queryProps: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).array.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["QueryGroup"] = $3d8ab1ac7a88b72c$export$9fae4d77e240e114;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("3zetf", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7ftOo = parcelRequire("7ftOo");

const $578f455bd7f79c76$export$64984dda48ed9108 = (results)=>{
    const errors = results.filter((result)=>result.error).map((result)=>result.error);
    if (errors.length) throw new Error(errors.join('\n\n'));
    return results[0]?.data?.space?.name || '';
};
const $578f455bd7f79c76$export$5e300c68d69bb755 = (spaceKey)=>{
    return [
        {
            query: (0, $7ftOo.SpaceNameQuery),
            variables: {
                spaceKey: spaceKey
            },
            skip: !spaceKey
        }
    ];
};
module.exports["getSpaceNameFromResults"] = $578f455bd7f79c76$export$64984dda48ed9108;
module.exports["getSpaceNameQueryProps"] = $578f455bd7f79c76$export$5e300c68d69bb755;

});

parcelRegister("7ftOo", function(module, exports) {

var $1QQ3D = parcelRequire("1QQ3D");

const $6a955c062718cf11$export$572a16972f8daeee = (0, $1QQ3D.default);
module.exports["SpaceNameQuery"] = $6a955c062718cf11$export$572a16972f8daeee;

});

parcelRegister("1QQ3D", function(module, exports) {
/**
 * @generated SignedSource<<e0c7950acffff709510129897556ec1c>>
 * @relayHash b9a37f70969ec1ccfea09d42d23ee047
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f211597d24101c497aaa6a30088a1b2c297fbb6197c83adc7a00aafa186acb5f
const $117903155ebb89ee$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceNameQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceNameQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b9a37f70969ec1ccfea09d42d23ee047",
            "id": "f211597d24101c497aaa6a30088a1b2c297fbb6197c83adc7a00aafa186acb5f",
            "metadata": {},
            "name": "SpaceNameQuery",
            "operationKind": "query",
            "text": "query SpaceNameQuery($spaceKey:String!){space(key:$spaceKey){id,name,key}}"
        }
    };
}();
$117903155ebb89ee$var$node.hash = "0ef458e46db525bf3a5156fbd23b8cfc";
var $117903155ebb89ee$export$2e2bcd8739ae039 = $117903155ebb89ee$var$node;
module.exports["default"] = $117903155ebb89ee$export$2e2bcd8739ae039;

});

parcelRegister("cTt7H", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $lEN6w = parcelRequire("lEN6w");


var $c1GUA = parcelRequire("c1GUA");

const $3ab45e305da1892a$export$570dec5b65c6715b = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c1GUA.UFOLoadEnd), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEN6w.Bm3PageLoadEnd), props);
};
module.exports["PageLoadEnd"] = $3ab45e305da1892a$export$570dec5b65c6715b;

});

parcelRegister("lEN6w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $4XtQK = parcelRequire("4XtQK");

const $fd3232056a8feb49$var$Bm3PageLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const stopArguments = {
            stopTime: typeof stopTime === 'number' ? stopTime : undefined,
            customData: {
                ...customData,
                previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            }
        };
        metric.stop(stopArguments);
        (0, $7fw2E.markBrowserMetricEnd)(metric);
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData` or `stopTime`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $fd3232056a8feb49$export$ad1c47bc07e7de3b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($fd3232056a8feb49$var$Bm3PageLoadEndComponent);
module.exports["Bm3PageLoadEnd"] = $fd3232056a8feb49$export$ad1c47bc07e7de3b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = Boolean(window.__SSR_REACT_STREAMING__) ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("c1GUA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cbc8g = parcelRequire("cbc8g");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $af29827660b87816$var$UFOLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $cbc8g.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $af29827660b87816$export$6f85d00e0066bc7 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($af29827660b87816$var$UFOLoadEndComponent);
module.exports["UFOLoadEnd"] = $af29827660b87816$export$6f85d00e0066bc7;

});

parcelRegister("8jTDW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17e542faf6fbe5ebc711b672478100d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60eb42a7b08ac844$var$_react = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("42omo")));

var $60eb42a7b08ac844$var$_baseNew = $60eb42a7b08ac844$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $60eb42a7b08ac844$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudOffline".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for showing when a connection can't be established to the cloud.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60eb42a7b08ac844$var$CloudOfflineIcon = (props)=>/*#__PURE__*/ $60eb42a7b08ac844$var$_react.default.createElement($60eb42a7b08ac844$var$_baseNew.default, Object.assign({
        name: "CloudOfflineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM8.82 12l1.5 1.5H3.75a3.75 3.75 0 0 1-1.42-7.22q.06-.32.14-.62l1.29 1.28a.75.75 0 0 1-.56.63A2.25 2.25 0 0 0 3.75 12zM8 1.5c-.96 0-1.87.24-2.66.65l1.13 1.13a4.25 4.25 0 0 1 5.72 3.23.75.75 0 0 0 .53.59 2.5 2.5 0 0 1 1.36 3.79l1.07 1.07a4 4 0 0 0-1.58-6.15A5.75 5.75 0 0 0 8 1.5"/>`
    }, props));
$60eb42a7b08ac844$var$CloudOfflineIcon.displayName = 'CloudOfflineIcon';
var $60eb42a7b08ac844$var$_default = module.exports.default = $60eb42a7b08ac844$var$CloudOfflineIcon;

});

parcelRegister("hpRYU", function(module, exports) {

var $1dUJk = parcelRequire("1dUJk");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $bQm3c = parcelRequire("bQm3c");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $jjoF2 = parcelRequire("jjoF2");


var $VQdE0 = parcelRequire("VQdE0");


var $g3p2i = parcelRequire("g3p2i");


var $jMyy4 = parcelRequire("jMyy4");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, verifiedTeams: verifiedTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components, isHeaderFocused: isHeaderFocused, setIsHeaderFocused: setIsHeaderFocused })=>{
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $VQdE0.default));
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $jMyy4.useQueryInterop)((0, $1dUJk.default));
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: components,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId,
        'aria-label': ariaLabel,
        isHeaderFocused: isHeaderFocused,
        setIsHeaderFocused: setIsHeaderFocused
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context",
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        verifiedTeams: verifiedTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: true,
        enableEmailSearch: true,
        allowEmailSelectionWhenEmailMatched: false,
        isTeamSyncedToGroupDirectoryFilter: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("1dUJk", function(module, exports) {
/**
 * @generated SignedSource<<ffde12fa34b24494a7218dc7e97e102e>>
 * @relayHash 55f887ce338962f3d231967eb05baaf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a
const $a7eff2b640cdd5ac$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "55f887ce338962f3d231967eb05baaf5",
            "id": "f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a",
            "metadata": {},
            "name": "UserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$a7eff2b640cdd5ac$var$node.hash = "6fe67cddff8056d8e38840c5214712ee";
var $a7eff2b640cdd5ac$export$2e2bcd8739ae039 = $a7eff2b640cdd5ac$var$node;
module.exports["default"] = $a7eff2b640cdd5ac$export$2e2bcd8739ae039;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $f9006b515271a00f$var$i18n = (0, $aXWIB.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("VQdE0", function(module, exports) {
/**
 * @generated SignedSource<<98d3dac5a252904c893f2857f7288344>>
 * @relayHash 8824351f0529abac5573900b2bee2db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751
const $3fbecf5b2b9bf0ac$var$node = function() {
    var v0 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchTerm"
    }, v2 = {
        "defaultValue": "NONE",
        "kind": "LocalArgument",
        "name": "sitePermissionTypeFilter"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withGroups"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withUsers"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "maxResults",
            "variableName": "maxResults"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchTerm"
        },
        {
            "kind": "Variable",
            "name": "sitePermissionTypeFilter",
            "variableName": "sitePermissionTypeFilter"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "condition": "withGroups",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v8 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8824351f0529abac5573900b2bee2db5",
            "id": "2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751",
            "metadata": {},
            "name": "UserAndGroupSearchQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchQuery($searchTerm:String!,$maxResults:Int=50,$withGroups:Boolean=true,$withUsers:Boolean=true,$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm,maxResults:$maxResults,sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){__typename,type,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},groups@include(if:$withGroups){id,name,permissionType}}}"
        }
    };
}();
$3fbecf5b2b9bf0ac$var$node.hash = "52200fecbeb2441b36c8ceb106bad130";
var $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039 = $3fbecf5b2b9bf0ac$var$node;
module.exports["default"] = $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039;

});

parcelRegister("hkzol", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1bY7o = parcelRequire("1bY7o");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $aXWIB.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $aXWIB.useIntl)();
    const cleanupCopiedTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $42omo.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $42omo.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {

var $2i78V = parcelRequire("2i78V");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $9wGTI = parcelRequire("9wGTI");


var $hkzol = parcelRequire("hkzol");


var $kfIha = parcelRequire("kfIha");

const $68bb0af1984f782c$var$useCopyContentLinkQuery = (0, $2i78V.default);
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($68bb0af1984f782c$var$useCopyContentLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip
    });
    const makeContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case 'slide':
                routeName = (0, $1NBp8.SLIDES_VIEW).name;
                break;
            // omit databases and other unsupported content types
            default:
                if (!contentType && (0, $9wGTI.fg)('confluence_ufo_trace_ct_err')) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("2i78V", function(module, exports) {
/**
 * @generated SignedSource<<76594ff6dea3ddce980da6a08753a006>>
 * @relayHash 29cac5aad51907935410d62eca7f1996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34
const $77e7fa3fd8a73973$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "29cac5aad51907935410d62eca7f1996",
            "id": "9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34",
            "metadata": {},
            "name": "useCopyContentLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$77e7fa3fd8a73973$var$node.hash = "37d735340f7b52ac7552b4a67a3fb5da";
var $77e7fa3fd8a73973$export$2e2bcd8739ae039 = $77e7fa3fd8a73973$var$node;
module.exports["default"] = $77e7fa3fd8a73973$export$2e2bcd8739ae039;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("jooGc", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $1P1Tu.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $9zUhf.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $9zUhf.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("i2BsV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c26d5c1d83386c25$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $dokWT = parcelRequire("dokWT");


var $5HQ8i = parcelRequire("5HQ8i");


var $gWldI = parcelRequire("gWldI");


var $1HYxw = parcelRequire("1HYxw");

const $c26d5c1d83386c25$var$styles = {
    base: "_zulp1b66 _2rko12b0 _1e0c116y _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _4cvr1h6o _1bah1h6o _o5724jg8 _1bto1l2s _80om73ad",
    compact: "_4t3igktf",
    expanded: "_4t3i1tcg",
    disabled: "_syaz1gmx _bfhkby5v _80om73ad",
    clickable: "_80omtlke",
    red: "_syazi7uo _bfhk1rtt",
    redClickable: "_13ix1rtt _irr3affd _1di61j5a",
    redBold: "_syaz15cr _bfhkuibq",
    redBoldClickable: "_13ixuibq _irr3100f _1di61cl6",
    orange: "_syazi7uo _bfhk1kkj",
    orangeClickable: "_13ix1kkj _irr39mfs _1di6axpp",
    yellow: "_syazi7uo _bfhkibhp",
    yellowClickable: "_13ixibhp _irr3aetg _1di61o1l",
    green: "_syazi7uo _bfhkn729",
    greenClickable: "_13ixn729 _irr33utz _1di6yfny",
    blue: "_syazi7uo _bfhk1dy8",
    blueClickable: "_13ix1dy8 _irr3815t _1di6rwxf",
    teal: "_syazi7uo _bfhk1a17",
    tealClickable: "_13ix1a17 _irr3kwwr _1di61jb0",
    lime: "_syazi7uo _bfhkz2ec",
    limeClickable: "_13ixz2ec _irr31gf0 _1di62kxc",
    purple: "_syazi7uo _bfhkp2ly",
    purpleClickable: "_13ixp2ly _irr3kca2 _1di61jbm",
    grey: "_syazi7uo _bfhkysee",
    greyClickable: "_13ixysee _irr3wejn _1di618ut",
    popup: "_1bsbp2n4"
};
function $c26d5c1d83386c25$export$2e2bcd8739ae039({ testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: color = 'GREY', iconSize: iconSize = 'small', guideline: guideline, guidelineADF: guidelineADF, isDisabled: isDisabled = false, isPopupDisabled: isPopupDisabled = false, isPopupOpenByDefault: isPopupOpenByDefault = false, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, popupPlacement: popupPlacement = 'bottom-start', shouldRenderToParent: shouldRenderToParent, isIconOnly: isIconOnlyProp = false, associatedPoliciesCount: associatedPoliciesCount, spacing: spacing = 'default' }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isMissingName = !name || name.length === 0;
    const isIconOnly = isMissingName || isIconOnlyProp;
    const nameWithRules = isMissingName ? '' : associatedPoliciesCount ? name + ' ' + formatMessage((0, $1HYxw.messages).rules, {
        associatedPoliciesCount: associatedPoliciesCount
    }) : name;
    const nameTruncated = (nameWithRules ?? '').substring(0, (0, $5HQ8i.nameMaxLength));
    const iconPx = iconSize === 'small' ? 12 : iconSize === 'medium' ? 18 : iconSize === 'large' ? 24 : iconSize === 'xlarge' ? 32 : iconSize === 'xxlarge' ? 40 : 12;
    const handleContainerClicked = ()=>{
        if (isPopupDisabled || isDisabled || isMissingName) return;
        if (onPopupShown) onPopupShown();
        setIsPopupOpen(!isPopupOpen);
    };
    const closePopup = ()=>{
        setIsPopupOpen(false);
    };
    const isClickable = !isPopupDisabled && !isDisabled && !isMissingName;
    const getContainer = (triggerProps = {})=>{
        // @ts-ignore
        const { 'aria-expanded': ariaExpanded, ...restProps } = triggerProps;
        const Container = isClickable ? (0, $fVUfS.default) : (0, $gdv5Z.default);
        return /*#__PURE__*/ (0, $l998X.jsxs)(Container, {
            role: isClickable ? 'button' : 'presentation',
            "aria-disabled": isDisabled,
            ...isClickable ? {
                'aria-label': `${formatMessage((0, $1HYxw.messages).dataClassificationLevel)} - ${name}`
            } : {},
            xcss: (0, $1Whri.cx)(...[
                $c26d5c1d83386c25$var$styles.base,
                // Add size styles if not icon only
                ...!isIconOnly ? [
                    spacing === 'expanded' ? $c26d5c1d83386c25$var$styles.expanded : $c26d5c1d83386c25$var$styles.compact
                ] : [],
                // Add disabled styles if disabled
                ...isDisabled ? [
                    $c26d5c1d83386c25$var$styles.disabled
                ] : [],
                // Add color styles
                ...!isDisabled ? [
                    {
                        RED: $c26d5c1d83386c25$var$styles.red,
                        RED_BOLD: $c26d5c1d83386c25$var$styles.redBold,
                        ORANGE: $c26d5c1d83386c25$var$styles.orange,
                        YELLOW: $c26d5c1d83386c25$var$styles.yellow,
                        GREEN: $c26d5c1d83386c25$var$styles.green,
                        BLUE: $c26d5c1d83386c25$var$styles.blue,
                        TEAL: $c26d5c1d83386c25$var$styles.teal,
                        LIME: $c26d5c1d83386c25$var$styles.lime,
                        PURPLE: $c26d5c1d83386c25$var$styles.purple,
                        GREY: $c26d5c1d83386c25$var$styles.grey
                    }[color]
                ] : [],
                // Add clickable styles if clickable
                ...!isDisabled && isClickable ? [
                    $c26d5c1d83386c25$var$styles.clickable,
                    {
                        RED: $c26d5c1d83386c25$var$styles.redClickable,
                        RED_BOLD: $c26d5c1d83386c25$var$styles.redBoldClickable,
                        ORANGE: $c26d5c1d83386c25$var$styles.orangeClickable,
                        YELLOW: $c26d5c1d83386c25$var$styles.yellowClickable,
                        GREEN: $c26d5c1d83386c25$var$styles.greenClickable,
                        BLUE: $c26d5c1d83386c25$var$styles.blueClickable,
                        TEAL: $c26d5c1d83386c25$var$styles.tealClickable,
                        LIME: $c26d5c1d83386c25$var$styles.limeClickable,
                        PURPLE: $c26d5c1d83386c25$var$styles.purpleClickable,
                        GREY: $c26d5c1d83386c25$var$styles.greyClickable
                    }[color]
                ] : []
            ]),
            testId: testId,
            padding: "space.050",
            onClick: ()=>{
                if (onClick) onClick();
                handleContainerClicked();
            },
            ...isClickable ? triggerProps : restProps,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWldI.ClassificationIcon), {
                        width: iconPx,
                        height: iconPx,
                        color: isDisabled ? (0, $5HQ8i.disabledColorConfig).iconColor : (0, $5HQ8i.colorsConfig)[color].iconColor
                    })
                }),
                !isIconOnly && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    maxLines: 1,
                    color: color === 'RED_BOLD' ? 'color.text.inverse' : 'color.text',
                    testId: "data-classification-level-name",
                    children: nameTruncated
                })
            ]
        });
    };
    return isPopupDisabled ? getContainer() : // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        label: popupLabel,
        titleId: popupTitleId,
        role: popupRole,
        shouldRenderToParent: shouldRenderToParent,
        placement: popupPlacement,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: isPopupOpen ? null : tooltip,
                hideTooltipOnClick: true,
                position: tooltipPosition,
                children: getContainer(triggerProps)
            }),
        content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                padding: "space.250",
                xcss: $c26d5c1d83386c25$var$styles.popup,
                role: "dialog",
                "aria-labelledby": "data-classification-read-content-name",
                "aria-describedby": "data-classification-read-content-guideline",
                "aria-modal": "true",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dokWT.ClassificationView), {
                    name: name,
                    guideline: guideline,
                    guidelineADF: guidelineADF,
                    guidelineRepresentation: guidelineRepresentation
                })
            }),
        isOpen: isPopupOpen,
        onClose: ()=>{
            if (onPopupClose) onPopupClose();
            closePopup();
        },
        zIndex: popupZIndex
    });
}

});

parcelRegister("dokWT", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7bZ3i = parcelRequire("7bZ3i");


var $gdv5Z = parcelRequire("gdv5Z");


var $67O0h = parcelRequire("67O0h");


var $5HQ8i = parcelRequire("5HQ8i");


var $blUZ2 = parcelRequire("blUZ2");


var $kGNkZ = parcelRequire("kGNkZ");

// Maximum height for guideline content to enable scrolling for long text
const $6522a38deabe02d9$var$GUIDELINE_MAX_HEIGHT = '300px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6522a38deabe02d9$var$Name = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81af2 _syazi7uo",
            __cmplp.className
        ])
    });
});
const $6522a38deabe02d9$var$Guideline = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo _o5721jtm _1i4q1hna _c71l1mjv _18m91wug",
            __cmplp.className
        ])
    });
});
const $6522a38deabe02d9$var$GuidelineADFContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_c71l1mjv _18m91wug",
            __cmplp.className
        ])
    });
});
const $6522a38deabe02d9$export$d413367b4cbb5577 = ({ name: name, guideline: guideline, guidelineADF: guidelineADF, guidelineRepresentation: guidelineRepresentation = 'PLAIN' })=>{
    const nameTruncated = (name ?? '').substring(0, (0, $5HQ8i.nameMaxLength));
    // Select the appropriate guideline based on guidelineRepresentation
    // Prefers guidelineADF when in EDITOR mode, falls back to guideline
    const selectedGuideline = (0, $kGNkZ.selectGuideline)({
        guidelineADF: guidelineADF,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation
    });
    // Parse ADF if in EDITOR mode - parse before truncation to avoid breaking JSON
    const parsedADF = guidelineRepresentation === 'EDITOR' ? (0, $blUZ2.safeParseGuidelineADF)(selectedGuideline) : undefined;
    // Only truncate for plain text mode - ADF content shows full text with scrolling
    const guidelineTruncated = (selectedGuideline ?? '').substring(0, (0, $5HQ8i.guidelineMaxLength));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            nameTruncated && /*#__PURE__*/ (0, $l998X.jsx)($6522a38deabe02d9$var$Name, {
                id: "data-classification-read-content-name",
                children: nameTruncated
            }),
            selectedGuideline && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                paddingBlockStart: "space.200",
                children: guidelineRepresentation === 'PLAIN' || !parsedADF ? /*#__PURE__*/ (0, $l998X.jsx)($6522a38deabe02d9$var$Guideline, {
                    id: "data-classification-read-content-guideline",
                    children: guidelineTruncated
                }) : /*#__PURE__*/ (0, $l998X.jsx)($6522a38deabe02d9$var$GuidelineADFContainer, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
                            document: parsedADF
                        })
                    })
                })
            })
        ]
    });
};
module.exports["ClassificationView"] = $6522a38deabe02d9$export$d413367b4cbb5577;

});

parcelRegister("5HQ8i", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $1HYxw = parcelRequire("1HYxw");

const { formatMessage: $e53ad3413efcb6ae$var$formatMessage } = (0, $aXWIB.createIntl)({
    locale: 'en'
});
const $e53ad3413efcb6ae$export$89b67151eed9295a = {
    definition: $e53ad3413efcb6ae$var$formatMessage((0, $1HYxw.messages).noClassification),
    includeIcon: false
};
const $e53ad3413efcb6ae$export$5f11f8883714351 = {
    id: 'no-selection',
    name: 'No selection'
};
const $e53ad3413efcb6ae$export$253bdad208569777 = 50;
const $e53ad3413efcb6ae$export$cbc3cef853d1014b = 1000;
const $e53ad3413efcb6ae$export$e1444e5b0a63d793 = 1000;
const $e53ad3413efcb6ae$export$fb2992e82b83582a = {
    YELLOW: {
        iconColor: "var(--ds-icon-accent-yellow, #B38600)",
        bgColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    ORANGE: {
        iconColor: "var(--ds-icon-accent-orange, #E06C00)",
        bgColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED: {
        iconColor: "var(--ds-icon-accent-red, #C9372C)",
        bgColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED_BOLD: {
        iconColor: "var(--ds-icon-inverse, #FFFFFF)",
        bgColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        fontColor: "var(--ds-text-inverse, #FFFFFF)"
    },
    PURPLE: {
        iconColor: "var(--ds-icon-accent-purple, #AF59E1)",
        bgColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    BLUE: {
        iconColor: "var(--ds-icon-accent-blue, #357DE8)",
        bgColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    TEAL: {
        iconColor: "var(--ds-icon-accent-teal, #2898BD)",
        bgColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREEN: {
        iconColor: "var(--ds-icon-accent-green, #22A06B)",
        bgColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREY: {
        iconColor: "var(--ds-icon-accent-gray, #7D818A)",
        bgColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    LIME: {
        iconColor: "var(--ds-icon-accent-lime, #6A9A23)",
        bgColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        fontColor: "var(--ds-text, #292A2E)"
    }
};
const $e53ad3413efcb6ae$export$9cdea53b8993b139 = {
    iconColor: "var(--ds-icon-disabled, #080F214A)",
    bgColor: "var(--ds-background-disabled, #17171708)",
    fontColor: "var(--ds-text-disabled, #080F214A)"
};
module.exports["NO_SELECTION_OPTION"] = $e53ad3413efcb6ae$export$5f11f8883714351;
module.exports["nameMaxLength"] = $e53ad3413efcb6ae$export$253bdad208569777;
module.exports["guidelineMaxLength"] = $e53ad3413efcb6ae$export$e1444e5b0a63d793;
module.exports["colorsConfig"] = $e53ad3413efcb6ae$export$fb2992e82b83582a;
module.exports["disabledColorConfig"] = $e53ad3413efcb6ae$export$9cdea53b8993b139;

});

parcelRegister("1HYxw", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $eac3d8fc17e23def$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noClassification: {
        id: "data-classification-level.no-classification",
        defaultMessage: "No classification"
    },
    classifyContent: {
        id: "data-classification-level.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    selectClassification: {
        id: "data-classification-level.edit-popup.select-classification",
        defaultMessage: "Select classification"
    },
    updateButton: {
        id: "data-classification-level.edit-popup.update-button",
        defaultMessage: "Update"
    },
    cancelButton: {
        id: "data-classification-level.edit-popup.cancel-button",
        defaultMessage: "Cancel"
    },
    changeLevel: {
        id: "data-classification-level.read-popup.change-level",
        defaultMessage: "Change level"
    },
    rules: {
        id: "data-classification-level.rules",
        defaultMessage: "({associatedPoliciesCount, plural, one {# rule} other {# rules}})"
    },
    dataClassificationLevel: {
        id: "data-classification-level.data-classification-level",
        defaultMessage: "Data classification level"
    },
    dataClassificationLevelDialog: {
        id: "data-classification-level.read-popup.data-classification-level",
        defaultMessage: "Data classification level Dialog"
    },
    classificationLevelGuidelines: {
        id: "data-classification-level.read-popup.heading",
        defaultMessage: "Classification level guidelines"
    },
    sourceAutoClassification: {
        id: "data-classification-level.read-popup.source-auto-classification",
        defaultMessage: "The current classification level is based on information detected in the content. <a>Update classification level</a>"
    },
    sourceUserClassification: {
        id: "data-classification-level.read-popup.source-user-classification",
        defaultMessage: "A user assigned the current classification level. <a>Update classification level</a>"
    },
    sourceSpaceDefaultClassification: {
        id: "data-classification-level.read-popup.source-space-default-classification",
        defaultMessage: "The current classification level is the default for this space. <a>Update classification level</a>"
    },
    sourceOrgDefaultClassification: {
        id: "data-classification-level.read-popup.source-org-default-classification",
        defaultMessage: "The current classification level is the default for your organization. <a>Update classification level</a>"
    },
    sourceNoneClassification: {
        id: "data-classification-level.read-popup.source-none-classification",
        defaultMessage: "<a>Update classification level</a>"
    },
    sourceAutoClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-auto-classification-user-override-disallow",
        defaultMessage: "The current classification level is based on information detected in the content. Updates to classification levels aren't permitted."
    },
    sourceUserClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-user-classification-user-override-disallow",
        defaultMessage: "A user assigned the current classification level. Updates to classification levels aren't permitted."
    },
    sourceSpaceDefaultClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-space-default-classification-user-override-disallow",
        defaultMessage: "The current classification level is the default for this space. Updates to classification levels aren't permitted."
    },
    sourceOrgDefaultClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-org-default-classification-user-override-disallow",
        defaultMessage: "The current classification level is the default for your organization. Updates to classification levels aren't permitted."
    },
    sourceNoneClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-none-classification-user-override-disallow",
        defaultMessage: "Updates to classification levels aren't permitted."
    },
    sourceAutoClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-auto-classification-not-container-admin",
        defaultMessage: "The current classification level is based on information detected in the content. Only users who can manage space settings can update the current classification level."
    },
    sourceUserClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-user-classification-not-container-admin",
        defaultMessage: "A user assigned the current classification level. Only users who can manage space settings can update the current classification level."
    },
    sourceSpaceDefaultClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-space-default-classification-not-container-admin",
        defaultMessage: "The current classification level is the default for this space. Only users who can manage space settings can update the current classification level."
    },
    sourceOrgDefaultClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-org-default-classification-not-container-admin",
        defaultMessage: "The current classification level is the default for your organization. Only users who can manage space settings can update the current classification level."
    },
    sourceNoneClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-none-classification-not-container-admin",
        defaultMessage: "Only users who can manage space settings can update the current classification level."
    },
    assignClassificationLevel: {
        id: "data-classification-level.edit-popup.assign-classification-level",
        defaultMessage: "Assign classification level"
    },
    lowestPermittedLevelOrgDefault: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-org-default",
        defaultMessage: "Classification levels less sensitive than the organization default aren't available."
    },
    lowestPermittedLevelSpaceDefault: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-space-default",
        defaultMessage: "Classification levels less sensitive than the space default aren't available."
    },
    lowestPermittedLevelAutoClassification: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-auto-classification",
        defaultMessage: "Classification levels less sensitive than the level automatically applied aren't available."
    },
    noSelection: {
        id: "data-classification-level.edit-popup.no-selection",
        defaultMessage: "No selection"
    },
    noSelectionDescription: {
        id: "data-classification-level.edit-popup.no-selection-description",
        defaultMessage: "The classification level will be updated based on the default or detected content."
    },
    assignButton: {
        id: "data-classification-level.edit-popup.assign-button",
        defaultMessage: "Assign"
    }
});
module.exports["messages"] = $eac3d8fc17e23def$export$defe85febe8b728c;

});

parcelRegister("blUZ2", function(module, exports) {
/**
 * @fileoverview ADF parsing utilities for handling guideline content
 *
 * TODO: Consider extracting these utilities to a shared ADF library once the API is stable.
 * This would benefit other teams dealing with similar ReactRenderer empty content issues.
 */ /**
 * Valid empty ADF document that ComposableEditor can work with
 */ const $d467d863edde4456$var$EMPTY_ADF_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
/**
 * Type guard to check if a parsed object is a valid ADF DocNode
 *
 * Performs basic structural validation of ADF documents. This intentionally does not validate
 * the entire ADF content tree, as ReactRenderer will handle that validation during rendering.
 * This approach allows for graceful degradation - if the ADF is invalid at a deeper level,
 * the component will fallback to plain text rendering.
 *
 * @param {unknown} obj - Object to validate
 * @returns {boolean} True if the object has the basic structure of an ADF DocNode
 */ const $d467d863edde4456$var$isValidADFDocument = (obj)=>{
    if (!obj || typeof obj !== 'object') return false;
    const doc = obj;
    // ADF documents must have type 'doc', version 1, and content array
    // Note: We don't validate the content array items themselves, as ReactRenderer
    // will handle that and provide appropriate error handling
    return doc.type === 'doc' && doc.version === 1 && Array.isArray(doc.content);
};
/**
 * Checks if a text node is empty (no text or only whitespace)
 */ const $d467d863edde4456$var$isEmptyText = (node)=>{
    if (!node || typeof node !== 'object') return true;
    const textNode = node;
    if (textNode.type !== 'text') return false;
    const text = textNode.text;
    return !text || text.trim().length === 0;
};
/**
 * Checks if a paragraph node is empty (no content or only empty text nodes)
 */ const $d467d863edde4456$var$isEmptyParagraph = (node)=>{
    if (!node || typeof node !== 'object') return true;
    const paragraph = node;
    if (paragraph.type !== 'paragraph') return false;
    // Paragraph with no content property or empty array
    if (!('content' in paragraph) || !paragraph.content || paragraph.content.length === 0) return true;
    // Paragraph with only empty text nodes
    return paragraph.content.every($d467d863edde4456$var$isEmptyText);
};
/**
 * Returns true if the given ADF doc is "visually empty".
 *
 * The ReactRenderer shows "Unsupported text" errors when it encounters certain
 * empty content structures that the backend may return (e.g., paragraphs with
 * empty text nodes). This function detects those cases so we can normalize them
 * to a proper empty ADF document, allowing components to gracefully fallback
 * to plain text rendering.
 *
 * Handles canonical empty forms like:
 * - {"version":1,"type":"doc","content":[]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph"}]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph","content":[]}]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":""}]}]}
 * - And variations where text is only whitespace
 *
 * Note: Only handles single-paragraph empty documents to avoid false positives.
 * More complex documents are passed through for ReactRenderer to handle.
 *
 * @param {DocNode} doc - ADF document to check
 * @returns {boolean} True if the document is visually empty
 */ const $d467d863edde4456$var$isVisuallyEmptyAdf = (doc)=>{
    // Type guard - should always be valid at this point
    if (!doc || doc.type !== 'doc') return true;
    const content = doc.content ?? [];
    // Empty content array
    if (content.length === 0) return true;
    // Only handle simple single-paragraph case to avoid false positives
    // More complex documents should be handled by ReactRenderer
    if (content.length === 1) return $d467d863edde4456$var$isEmptyParagraph(content[0]);
    return false;
};
const $d467d863edde4456$export$caab9411b15d6295 = (guideline)=>{
    if (!guideline) return $d467d863edde4456$var$EMPTY_ADF_DOCUMENT;
    try {
        const parsed = JSON.parse(guideline);
        if (!$d467d863edde4456$var$isValidADFDocument(parsed)) return $d467d863edde4456$var$EMPTY_ADF_DOCUMENT;
        // Check if the ADF is visually empty (would cause renderer errors)
        if ($d467d863edde4456$var$isVisuallyEmptyAdf(parsed)) return $d467d863edde4456$var$EMPTY_ADF_DOCUMENT;
        return parsed;
    } catch  {
        return $d467d863edde4456$var$EMPTY_ADF_DOCUMENT;
    }
};
module.exports["safeParseGuidelineADF"] = $d467d863edde4456$export$caab9411b15d6295;

});

parcelRegister("kGNkZ", function(module, exports) {
const $eac995fb73d1f5cf$export$1da3a1abbabd0674 = ({ guidelineADF: guidelineADF, guideline: guideline, guidelineRepresentation: guidelineRepresentation })=>{
    if (guidelineRepresentation === 'EDITOR') // Prefer ADF format when in EDITOR mode, fallback to plain text
    // Use nullish coalescing to treat empty strings as valid values
    return guidelineADF ?? guideline;
    // Use plain text guideline for PLAIN mode
    return guideline;
};
module.exports["selectGuideline"] = $eac995fb73d1f5cf$export$1da3a1abbabd0674;

});

parcelRegister("gWldI", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $cf27063ba0229f9a$export$d2e14829910b9b7d = ({ color: color, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 22",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
            fill: color
        })
    });
};
module.exports["ClassificationIcon"] = $cf27063ba0229f9a$export$d2e14829910b9b7d;

});

parcelRegister("jJli4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $f9KPY = parcelRequire("f9KPY");


const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("8FKW5"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});
module.exports["ExcerptIncludeLoader"] = $7549d063fe593b21$export$2800e3d415e59020;

});

parcelRegister("f9KPY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lOkIA = parcelRequire("lOkIA");


var $dhEYL = parcelRequire("dhEYL");

class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $42omo.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}
module.exports["ExcerptIncludeComponentShadow"] = $747c563e4499b240$export$8f88facf076a2d46;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $42omo.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $gMc0m.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("dhEYL", function(module, exports) {
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: `${"var(--ds-border-width, 1px)"} 0px 0px 0px`,
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #6B6E76)",
    paddingLeft: "var(--ds-space-050, 4px)"
};
module.exports["panel"] = $9b021e0aba5455d5$export$21f42ab9b6679f44;
module.exports["panelHeader"] = $9b021e0aba5455d5$export$92937d9937dc7ce9;
module.exports["panelBody"] = $9b021e0aba5455d5$export$d763905bda51ef54;
module.exports["panelHeaderExcerpt"] = $9b021e0aba5455d5$export$99e3f651fb62ec86;

});

parcelRegister("8FKW5", function(module, exports) {

let $65068f8728e59ef2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65068f8728e59ef2$var$load("6wr18"),
    $65068f8728e59ef2$var$load("ffEVr"),
    $65068f8728e59ef2$var$load("9tNcH")
]).then(()=>parcelRequire('c6u22'));

});

parcelRegister("5LTS4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");


var $4VJDS = parcelRequire("4VJDS");


var $bF1aY = parcelRequire("bF1aY");


var $h8C1D = parcelRequire("h8C1D");


var $kksmx = parcelRequire("kksmx");

const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $4VJDS.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $42omo.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $42omo.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0,
            hydratable: window?.__HYDRATABLE__ || false,
            hydrationFailed: window?.__HYDRATION_FAILED__ || false
        };
        const metric = (0, $bF1aY.LEGACY_EXTENSION_LOADING_METRIC)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: markerRef
    });
};
module.exports["ExtensionLoadingComplete"] = $ebb4d303074e1a0c$export$64e91845ba744516;

});

parcelRegister("bF1aY", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});
module.exports["LEGACY_EXTENSION_LOADING_METRIC"] = $63112e910a0def69$export$841f5507db609445;

});

parcelRegister("jxpvN", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $42omo.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("2tHI8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $ba840c49dd70d4e9$export$322c13354cdebc20 = ()=>{
    const [panelHeight, setPanelHeight] = (0, $42omo.useState)(()=>{
        if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true)) {
            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'];
            return initialHeight ?? 0;
        }
        return 0;
    });
    (0, $42omo.useEffect)(()=>{
        const updateHeight = (e)=>{
            if ((0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true)) // Use event detail height if available, otherwise fallback to 0
            setPanelHeight(e?.detail?.height ?? 0);
            else // Legacy behavior: read from CSS variable
            try {
                const heightValue = getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height');
                const numericValue = parseInt(heightValue, 10);
                setPanelHeight(!isNaN(numericValue) && numericValue >= 0 ? numericValue : 0);
            } catch (e) {
                setPanelHeight(0);
            }
        };
        !(0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true) && updateHeight();
        // Listen for height changes
        document.addEventListener('atlGeneralWebPanelHeightUpdated', updateHeight);
        return ()=>{
            document.removeEventListener('atlGeneralWebPanelHeightUpdated', updateHeight);
        };
    }, []);
    return panelHeight;
};
module.exports["useGeneralWebPanelHeight"] = $ba840c49dd70d4e9$export$322c13354cdebc20;

});

parcelRegister("cqCFf", function(module, exports) {
/* LiveSearchTemplate.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ /* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $aXWIB = parcelRequire("aXWIB");


var $kyKWe = parcelRequire("kyKWe");


var $jluld = parcelRequire("jluld");


var $3hOY6 = parcelRequire("3hOY6");

var $6T8v4 = parcelRequire("6T8v4");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6F6hl = parcelRequire("6F6hl");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $1AV5C = parcelRequire("1AV5C");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $b3dss = parcelRequire("b3dss");


var $3uWLy = parcelRequire("3uWLy");


var $afqWO = parcelRequire("afqWO");


var $lHQkL = parcelRequire("lHQkL");


var $3EYav = parcelRequire("3EYav");


var $047Sb = parcelRequire("047Sb");

const $ea51fe5225a56158$var$CONFLUENCE_ARI = 'ari:cloud:confluence::site/'; // Value of these constants is important for proper handling of input events for live search
const $ea51fe5225a56158$export$f96974a826589f12 = 'live-search-macro';
const $ea51fe5225a56158$export$914adcd8d06245e4 = 'search-macro-button';
const $ea51fe5225a56158$var$controlStyles = {
    root: "_bfw71uh4 _8vu41qi0 _irr3l4ek",
    focused: "_bfw7z0c1 _irr31j9a"
};
const $ea51fe5225a56158$var$MediumControl = ({ children: children, ...props })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).Control, {
        ...props,
        xcss: (0, $1bHXt.cx)($ea51fe5225a56158$var$controlStyles.root, props.isFocused && $ea51fe5225a56158$var$controlStyles.focused)
    }, children);
};
const $ea51fe5225a56158$var$LargeControl = ({ children: children, ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $3hOY6.components).Control, {
        ...props,
        xcss: (0, $1bHXt.cx)($ea51fe5225a56158$var$controlStyles.root, props.isFocused && $ea51fe5225a56158$var$controlStyles.focused)
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: intl.formatMessage((0, $lHQkL.i18n).searchIconLabel),
        spacing: "spacious"
    }), children);
};
const $ea51fe5225a56158$var$mediumSizeWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $ea51fe5225a56158$var$largeSizeWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    display: 'block'
});
const $ea51fe5225a56158$export$f43084e69a1ba6f6 = ({ config: config })=>{
    const scriptRef = (0, $42omo.useRef)(null);
    const selectRef = (0, $42omo.useRef)(null);
    const { size: size, placeholder: placeholder } = config;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const confluenceInstance = $ea51fe5225a56158$var$CONFLUENCE_ARI.concat(cloudId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [searchResults, setSearchResults] = (0, $42omo.useState)([]);
    const [loadState, setLoadState] = (0, $42omo.useState)(true);
    const [searchInput, setSearchInput] = (0, $42omo.useState)('');
    const [menuIsOpen, setMenuOpen] = (0, $42omo.useState)(false);
    const [queryVersion, setQueryVersion] = (0, $42omo.useState)(0);
    const [searchSessionId, setSearchSessionId] = (0, $42omo.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const intl = (0, $aXWIB.useIntl)();
    const handleClickNavigate = (0, $3EYav.handleNavigate)();
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isInEditMode = pageMode === (0, $cD1qu.PageMode).EDIT;
    (0, $42omo.useEffect)(()=>{
        const closeResultsOnResize = ()=>{
            setMenuOpen(false);
        };
        window.addEventListener('resize', closeResultsOnResize);
        return ()=>window.removeEventListener('resize', closeResultsOnResize);
    }, []);
    const updateResults = (0, $42omo.useCallback)((results)=>{
        setSearchResults(results);
        setQueryVersion(queryVersion + 1);
    }, [
        queryVersion
    ]);
    const handleMenuClose = (0, $42omo.useCallback)(()=>{
        setSearchInput(searchInput);
        setSearchResults(searchResults);
        setQueryVersion(0);
        setMenuOpen(false);
        setSearchSessionId((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    }, [
        searchInput,
        searchResults
    ]);
    const onChange = async (str)=>{
        const input = str;
        setSearchInput(input);
        if (input.length > 2) {
            setLoadState(true);
            const { results: results, size: size } = await (0, $b3dss.handleAGGSearch)({
                searchInput: input,
                config: config,
                currentSpaceKey: currentSpaceKey,
                confluenceInstance: confluenceInstance
            });
            updateResults(results);
            setLoadState(false);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'liveSearchResults',
                    actionSubjectId: 'liveSearchQueryResults',
                    source: 'liveSearch',
                    attributes: {
                        source: 'liveSearch',
                        searchSessionId: searchSessionId,
                        queryHash: (0, $1AV5C.hashDataWithSha1_DO_NOT_USE)(input),
                        queryVersion: queryVersion,
                        queryLength: input.length,
                        wordCount: input.split(/\s+/).length,
                        resultCount: size
                    }
                }
            }).fire();
        } else if (searchResults.length) setSearchResults([]);
    };
    const navigateHandler = (0, $42omo.useCallback)((obj)=>{
        const trigger = obj?.searchMore ? 'menuClick' : obj?.nativeEvent?.type === 'submit' ? 'shortcut' : 'click'; // will need to apply the same filter setting when navigate to advance page
        handleClickNavigate({
            searchMore: searchInput,
            searchResult: obj.searchResult,
            currentSpaceKey: currentSpaceKey,
            config: config,
            eventParams: {
                wordCount: searchInput.split(/\s+/).length,
                queryLength: searchInput.length,
                queryHash: (0, $1AV5C.hashDataWithSha1_DO_NOT_USE)(searchInput),
                trigger: trigger,
                queryVersion: queryVersion,
                searchSessionId: searchSessionId,
                pageId: contentId
            }
        });
    }, // Only searchInput and config may change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        searchInput,
        config
    ]);
    const handleActivateButtonOnKeydown = (event)=>{
        // Keyboard support for button: https://www.w3.org/TR/wai-aria-practices/examples/button/button.html
        // event.key spec: https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        const ACTIVATE_BUTTON_KEYS = [
            'Enter',
            'Spacebar',
            ' '
        ]; // Stop the propagation of these keyboard events so users can activate the button using the keyboard without the editor handling it
        if (ACTIVATE_BUTTON_KEYS.includes(event?.key)) {
            event?.stopPropagation();
            event?.preventDefault();
            navigateHandler(event);
        }
    };
    const handleKeyDownOverride = (0, $42omo.useCallback)((e)=>{
        if ((e?.metaKey || e?.ctrlKey) && e?.key === 'a') e.stopPropagation();
    }, []);
    const MenuList = (props)=>{
        // corresponds to Search result format LSM setting
        const { additional: additional } = config;
        const extraInfo = additional === 'page excerpt' ? 'excerpt' : additional === 'none' ? 'none' : 'space';
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ $42omo.createElement("div", {
            style: props
        }, /*#__PURE__*/ $42omo.createElement((0, $afqWO.SearchResultsList), {
            searchResults: searchResults,
            searchInput: searchInput,
            onClick: navigateHandler,
            extraInfo: extraInfo,
            loading: loadState
        })));
    };
    const focusSelect = ()=>{
        selectRef.current?.focus();
    };
    return /*#__PURE__*/ $42omo.createElement((0, $3uWLy.LiveSearchWrapper), {
        title: intl.formatMessage((0, $lHQkL.i18n).liveSearchTooltip),
        "data-fabric-macro": config?.macroId,
        "data-macro-body": true,
        "data-macro-parameters": JSON.stringify({
            currentSpaceKey: currentSpaceKey,
            ...config
        })
    }, /*#__PURE__*/ $42omo.createElement((0, $3uWLy.SearchMacro), {
        isLarge: size === 'large'
    }, /*#__PURE__*/ $42omo.createElement("form", {
        onSubmit: navigateHandler
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: size === 'large' ? $ea51fe5225a56158$var$largeSizeWrapperStyles : $ea51fe5225a56158$var$mediumSizeWrapperStyles
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: "search-macro-query",
        onClick: focusSelect
    }, /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), null, /*#__PURE__*/ $42omo.createElement("label", {
        htmlFor: "live-search-select"
    }, intl.formatMessage((0, $lHQkL.i18n).liveSearchLabel))), /*#__PURE__*/ $42omo.createElement((0, $6T8v4.default), {
        isDisabled: isInEditMode,
        inputId: "live-search-select",
        classNamePrefix: $ea51fe5225a56158$export$f96974a826589f12,
        ref: selectRef,
        placeholder: placeholder || intl.formatMessage((0, $lHQkL.i18n).liveSearchLabel),
        inputValue: searchInput,
        onInputChange: (input)=>{
            onChange(input);
        },
        onKeyDown: handleKeyDownOverride,
        menuIsOpen: searchInput.length > 2 ? menuIsOpen : false,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 2
                }),
            menu: (base)=>({
                    ...base,
                    overflowY: 'auto',
                    minWidth: '283px'
                }),
            placeholder: (base)=>({
                    ...base,
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                }),
            control: (base, state)=>({
                    ...base,
                    paddingLeft: size === 'large' ? "var(--ds-space-050, 4px)" : '0px',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)",
                    border: state.isFocused ? `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-selected, #1868DB)"}` : `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                    borderRadius: "var(--ds-radius-medium, 6px)",
                    ':hover': {
                        backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input-hovered, #F8F8F8)",
                        border: state.isFocused ? `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-selected, #1868DB)"}` : `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                        borderRadius: "var(--ds-radius-medium, 6px)"
                    }
                }),
            valueContainer: (base)=>({
                    ...base,
                    paddingLeft: size === 'large' ? "var(--ds-space-025, 2px)" : "var(--ds-space-100, 8px)"
                })
        },
        maxMenuHeight: 400,
        components: {
            MenuList: MenuList,
            DropdownIndicator: ()=>null,
            Control: size === 'large' ? $ea51fe5225a56158$var$LargeControl : $ea51fe5225a56158$var$MediumControl
        },
        menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
        onMenuOpen: ()=>setMenuOpen(true),
        onMenuClose: ()=>handleMenuClose()
    })), size !== 'large' && /*#__PURE__*/ $42omo.createElement((0, $3uWLy.StyledButton // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: $ea51fe5225a56158$export$914adcd8d06245e4,
        iconBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            color: "var(--ds-icon-subtle, #505258)",
            label: intl.formatMessage((0, $lHQkL.i18n).searchIconLabel),
            spacing: "spacious"
        }),
        onClick: navigateHandler,
        onKeyDown: handleActivateButtonOnKeydown,
        appearance: "subtle",
        isDisabled: isInEditMode
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $lHQkL.i18n).liveSearchLabel))), /*#__PURE__*/ $42omo.createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        "data-test-id": "ssr-scripts-init",
        ref: scriptRef,
        dangerouslySetInnerHTML: {
            __html: (0, $047Sb.script)
        }
    }))));
};
module.exports["LIVE_SEARCH_SELECT_CLASSNAME_PREFIX"] = $ea51fe5225a56158$export$f96974a826589f12;
module.exports["LIVE_SEARCH_BUTTON_CLASSNAME"] = $ea51fe5225a56158$export$914adcd8d06245e4;
module.exports["LiveSearchTemplate"] = $ea51fe5225a56158$export$f43084e69a1ba6f6;

});

parcelRegister("b3dss", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $coZY6 = parcelRequire("coZY6");


var $8scIT = parcelRequire("8scIT");


var $b6QdV = parcelRequire("b6QdV");

const $5ecb5a6b19c7b99a$export$f3881448ce6d41ab = async ({ searchInput: searchInput, config: config, currentSpaceKey: currentSpaceKey, confluenceInstance: confluenceInstance })=>{
    const results = await (0, $c0rhi.queryInterop)({
        query: (0, $b6QdV.default),
        interopApolloAggClient: true,
        ...(0, $coZY6.getQueryVariablesForAGGSearch)({
            searchInput: searchInput,
            config: config,
            currentSpaceKey: currentSpaceKey,
            confluenceInstance: confluenceInstance
        })
    }).then((response)=>response.data.search?.search?.edges.map((0, $8scIT.aggResultMapper)));
    return {
        results: results,
        size: results.length
    };
};
module.exports["handleAGGSearch"] = $5ecb5a6b19c7b99a$export$f3881448ce6d41ab;

});

parcelRegister("coZY6", function(module, exports) {

var $6Jc3U = parcelRequire("6Jc3U");

const $adcbb7eb47b613db$export$151b4a7c4fb38187 = 'confluence.liveSearchMacro';
const $adcbb7eb47b613db$export$8c6bf2df244e6a99 = '/wiki';
const $adcbb7eb47b613db$export$185e0f2aa1d225bd = 5;
const $adcbb7eb47b613db$export$5685b08df1669f19 = ',';
const $adcbb7eb47b613db$export$c94fdbf59dff15c8 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:slide'
];
var $adcbb7eb47b613db$export$9da7f865fb841394 = /*#__PURE__*/ function(ConfluenceATIs) {
    ConfluenceATIs["PAGE"] = "ati:cloud:confluence:page";
    ConfluenceATIs["BLOG"] = "ati:cloud:confluence:blogpost";
    ConfluenceATIs["SPACE"] = "ati:cloud:confluence:space";
    ConfluenceATIs["COMMENT"] = "ati:cloud:confluence:comment";
    ConfluenceATIs["WHITEBOARD"] = "ati:cloud:confluence:whiteboard";
    ConfluenceATIs["DATABASE"] = "ati:cloud:confluence:database";
    ConfluenceATIs["EMBED"] = "ati:cloud:confluence:embed";
    ConfluenceATIs["SLIDE"] = "ati:cloud:confluence:slide";
    return ConfluenceATIs;
}({});
const $adcbb7eb47b613db$export$36f2f1b03ac5f864 = ({ searchInput: searchInput, config: config, currentSpaceKey: currentSpaceKey, confluenceInstance: confluenceInstance })=>{
    const { type: type, spaceKey: spaceKey, labels: labels } = config;
    return {
        variables: {
            experience: $adcbb7eb47b613db$export$151b4a7c4fb38187,
            query: searchInput,
            first: $adcbb7eb47b613db$export$185e0f2aa1d225bd,
            filters: {
                entities: $adcbb7eb47b613db$export$e2e3f9f64b249105(type),
                locations: [
                    confluenceInstance
                ],
                confluenceFilters: (0, $6Jc3U.createAggFilters)(spaceKey, currentSpaceKey, labels)
            }
        }
    };
};
const $adcbb7eb47b613db$export$e2e3f9f64b249105 = (type)=>{
    let entities;
    switch(type){
        case 'page':
            entities = [
                "ati:cloud:confluence:page"
            ];
            break;
        case 'blogpost':
            entities = [
                "ati:cloud:confluence:blogpost"
            ];
            break;
        case 'spacedesc':
            entities = [
                "ati:cloud:confluence:space"
            ];
            break;
        case 'comment':
            entities = [
                "ati:cloud:confluence:comment"
            ];
            break;
        case 'whiteboard':
            entities = [
                "ati:cloud:confluence:whiteboard"
            ];
            break;
        case 'database':
            entities = [
                "ati:cloud:confluence:database"
            ];
            break;
        case 'embed':
            entities = [
                "ati:cloud:confluence:embed"
            ];
            break;
        case 'slide':
            entities = [
                "ati:cloud:confluence:slide"
            ];
            break;
        default:
            entities = $adcbb7eb47b613db$export$c94fdbf59dff15c8;
    }
    return entities;
};
module.exports["CONTEXT_PATH"] = $adcbb7eb47b613db$export$8c6bf2df244e6a99;
module.exports["LABEL_FILTER_SEPARATOR"] = $adcbb7eb47b613db$export$5685b08df1669f19;
module.exports["getQueryVariablesForAGGSearch"] = $adcbb7eb47b613db$export$36f2f1b03ac5f864;

});

parcelRegister("6Jc3U", function(module, exports) {

var $coZY6 = parcelRequire("coZY6");

const $aa37c24e8c8ac542$export$416386056bdfd75 = (spaceKey, currentSpaceKey, labels)=>{
    const aggConfluenceFilters = {};
    const spaceFilterKey = !spaceKey ? undefined : spaceKey === 'currentSpace()' || spaceKey === '@self' ? currentSpaceKey : spaceKey;
    if (spaceFilterKey) aggConfluenceFilters.spacesFilter = [
        spaceFilterKey
    ];
    if (labels) {
        const labelFilters = labels.split((0, $coZY6.LABEL_FILTER_SEPARATOR));
        aggConfluenceFilters.labelsFilter = labelFilters;
    }
    return aggConfluenceFilters;
};
module.exports["createAggFilters"] = $aa37c24e8c8ac542$export$416386056bdfd75;

});

parcelRegister("8scIT", function(module, exports) {

var $coZY6 = parcelRequire("coZY6");

const $8125818ec3b81d48$export$a9c9cad42c57a90d = ({ node: result })=>({
        id: result.id,
        title: result.title,
        excerpt: result.excerpt || '',
        spaceName: result.space?.name || '',
        type: result.type,
        url: $8125818ec3b81d48$export$d449648a99616a75(result.url)
    });
const $8125818ec3b81d48$export$d449648a99616a75 = (url)=>{
    const splitUrl = url.split((0, $coZY6.CONTEXT_PATH));
    return splitUrl[splitUrl.length - 1];
};
module.exports["aggResultMapper"] = $8125818ec3b81d48$export$a9c9cad42c57a90d;

});

parcelRegister("b6QdV", function(module, exports) {
/**
 * @generated SignedSource<<b0b836378514628bf36243f452fbc1ea>>
 * @relayHash b471b1154ab30ebc4408fb7bac5cce34
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2020dc14c8c38653e1c2a2c56c15153664f6729d547645fb246000cdc144fa0
const $b84b615bca25d155$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "url"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "concreteType": "SearchConfluenceResultSpace",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    }
                ]
            }
        ],
        "type": "SearchConfluencePageBlogAttachment"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "LiveSearchAGGQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "LiveSearchAGGQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b471b1154ab30ebc4408fb7bac5cce34",
            "id": "a2020dc14c8c38653e1c2a2c56c15153664f6729d547645fb246000cdc144fa0",
            "metadata": {},
            "name": "LiveSearchAGGQuery",
            "operationKind": "query",
            "text": "query LiveSearchAGGQuery($experience:String!,$query:String!,$first:Int,$filters:SearchFilterInput!){search{search(experience:$experience,query:$query,first:$first,filters:$filters){edges{node{__typename,id,title,type,url,...on SearchConfluencePageBlogAttachment{excerpt,space{id,name}}}}}}}"
        }
    };
}();
$b84b615bca25d155$var$node.hash = "e68094c3a55432af69fb46f8bfefc4c4";
var $b84b615bca25d155$export$2e2bcd8739ae039 = $b84b615bca25d155$var$node;
module.exports["default"] = $b84b615bca25d155$export$2e2bcd8739ae039;

});

parcelRegister("3uWLy", function(module, exports) {
/* LiveSearchElementStructure.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $bd32abb04a95f4ca$export$a1c423cec4871ad1 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v77o _1bsb1osq _p12f1osq _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1w90i7uo _qop31e5h _149mu2gc _16hgi8nm _btpd1ylp _if291txw _1kba1h6o",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$export$6d263636989f6ae8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLarge: isLarge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1o8l _p12f1osq",
            __cmplp.isLarge ? "_1bsb1ogm _8e9gh2mm _11lwglyw _vj0by152 _1y9uglyw _1phytdg6 _w4u1stnw _mbkzu2gc _kjd0rdoj _tj1p1ihb" : "_1bsb1m8p _11lw1e5h _zi7q1ujv _tr7mglyw",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$var$SearchMacroMedium = null;
const $bd32abb04a95f4ca$var$SearchMacroLarge = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$fb9f58ebe9de6283 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$1917b7d8b72b7e9c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1l7b _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$41596f83281a8833 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41pyq _1tke1gkc _kqswh2mm _y3gn1e5h _1e0c1txw _2lx2vrvc _19ysutpp _7mmmutpp _irr319i6 _d0altlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$31f0069b8e88f592 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _19pkv77o _c71l1f4h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$fcde7feadcb5c60d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu _19pkv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$904a9954c9f03ce2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1tke163w _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _7axpzws8 _mezj1st9 _bna712cx",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$7c3018f441722857 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$ec0f4e517a3a36ce = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i163w _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$7d1f3ef9e605f458 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41w7u _x3doia51 _bfhk1bhr _c71lgktf _y3gn1e5h _kqsw1if8 _94n5idpf _irr36o2t _d0altlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$2d2e4766151d9035 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazi7uo _1r5pwu06",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$1b51c6466e79404f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazi7uo _1kibidpf _1laeidpf _1f5yidpf _kq8jidpf _1695idpf _1pnsidpf _vktqidpf _1byqidpf _1ilx1ule",
            __cmplp.className
        ])
    });
});
module.exports["LiveSearchWrapper"] = $bd32abb04a95f4ca$export$a1c423cec4871ad1;
module.exports["StyledButton"] = $bd32abb04a95f4ca$export$2d5d2ba3c7c8c40b;
module.exports["SearchMacro"] = $bd32abb04a95f4ca$export$6d263636989f6ae8;
module.exports["SearchResultIconWrapper"] = $bd32abb04a95f4ca$export$1917b7d8b72b7e9c;
module.exports["SearchResultNormalWrapper"] = $bd32abb04a95f4ca$export$41596f83281a8833;
module.exports["SearchResultExcerpt"] = $bd32abb04a95f4ca$export$31f0069b8e88f592;
module.exports["SearchResultSpace"] = $bd32abb04a95f4ca$export$fcde7feadcb5c60d;
module.exports["SearchNoResultWrapper"] = $bd32abb04a95f4ca$export$904a9954c9f03ce2;
module.exports["TextWrapper"] = $bd32abb04a95f4ca$export$7c3018f441722857;
module.exports["SearchLoadWrapper"] = $bd32abb04a95f4ca$export$ec0f4e517a3a36ce;
module.exports["SearchResultMoreWrapper"] = $bd32abb04a95f4ca$export$7d1f3ef9e605f458;
module.exports["TextContentBold"] = $bd32abb04a95f4ca$export$2d2e4766151d9035;
module.exports["TextContent"] = $bd32abb04a95f4ca$export$1b51c6466e79404f;

});

parcelRegister("afqWO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7gG00 = parcelRequire("7gG00");


var $cElcb = parcelRequire("cElcb");


var $8z70D = parcelRequire("8z70D");


var $dkccs = parcelRequire("dkccs");

const $6cd4a3afa36bda77$export$92697b2a267ec7ef = ({ searchResults: searchResults, searchInput: searchInput, onClick: onClick, loading: loading, extraInfo: extraInfo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gG00.SearchLoading), null) : searchResults.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, searchResults.map((result)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cElcb.SearchResult), {
            searchResult: result,
            onClick: onClick,
            extraInfo: extraInfo,
            key: result.id
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dkccs.SearchResultMore), {
        onClick: onClick,
        searchInput: searchInput
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8z70D.SearchNoResults), null));
module.exports["SearchResultsList"] = $6cd4a3afa36bda77$export$92697b2a267ec7ef;

});

parcelRegister("7gG00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $3uWLy = parcelRequire("3uWLy");

const $8f0e2446176068a1$export$8934683688a2f019 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchLoadWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small"
    }));
module.exports["SearchLoading"] = $8f0e2446176068a1$export$8934683688a2f019;

});

parcelRegister("cElcb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6p02T = parcelRequire("6p02T");


var $3uWLy = parcelRequire("3uWLy");


var $7pRSN = parcelRequire("7pRSN");

const $c20f7d4a6116fd22$export$a2def421b23768aa = ({ searchResult: searchResult, onClick: onClick, extraInfo: extraInfo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultNormalWrapper), {
        onClick: ()=>onClick({
                searchResult: searchResult.url
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultIconWrapper), {
        contentType: searchResult.type
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7pRSN.SearchResultTypeIcon), {
        contentType: searchResult.type
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, (0, $6p02T.enrichExcerpt)(searchResult.title)), extraInfo === 'excerpt' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultExcerpt), null, (0, $6p02T.processExcerpt)(searchResult.excerpt)), extraInfo === 'space' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultSpace), null, (0, $6p02T.enrichExcerpt)(searchResult.type !== 'space' ? searchResult.spaceName : searchResult.title))));
module.exports["SearchResult"] = $c20f7d4a6116fd22$export$a2def421b23768aa;

});

parcelRegister("6p02T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("7pRSN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxQwS = parcelRequire("hxQwS");


var $41GKb = parcelRequire("41GKb");


var $9lz2c = parcelRequire("9lz2c");


var $13WX1 = parcelRequire("13WX1");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $duwSm = parcelRequire("duwSm");

const $d0c35681f27804ef$export$73b9ddc99f37f785 = ({ contentType: contentType })=>{
    switch(contentType){
        case 'blogpost':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hxQwS.default), {
                label: "page icon"
            });
        case 'image':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41GKb))), {
                label: "page icon"
            });
        case 'attachment':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
                label: "page icon",
                spacing: "spacious"
            });
        case 'whiteboard':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                label: "whiteboard icon"
            });
        case 'database':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
                label: "database icon"
            });
        case 'slide':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))), {
                label: "slide icon"
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($duwSm))), {
                label: "embed icon"
            });
        case 'page':
        case 'comment':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13WX1.default), {
                label: "page icon"
            });
    }
};
module.exports["SearchResultTypeIcon"] = $d0c35681f27804ef$export$73b9ddc99f37f785;

});

parcelRegister("8z70D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3uWLy = parcelRequire("3uWLy");


var $b4T2n = parcelRequire("b4T2n");


var $lHQkL = parcelRequire("lHQkL");

const $d23f3d633ea38e93$export$8e56e0a68b41e69c = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchNoResultWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b4T2n))),
        alt: intl.formatMessage((0, $lHQkL.i18n).searchIconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.TextWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.TextContentBold), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $lHQkL.i18n).liveSearchSelectNoResult1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.TextContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $lHQkL.i18n).liveSearchSelectNoResult2))));
};
module.exports["SearchNoResults"] = $d23f3d633ea38e93$export$8e56e0a68b41e69c;

});

parcelRegister("b4T2n", function(module, exports) {
module.exports = new URL("searchError.f24f82b3.svg", import.meta.url).toString();

});

parcelRegister("lHQkL", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3004d3bb8ead7d7b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    liveSearchLabel: {
        id: "live-search.label",
        defaultMessage: "Search"
    },
    liveSearchTooltip: {
        id: "live-search.tooltip",
        defaultMessage: "Live Search Macro"
    },
    liveSearchSelectSearchMore: {
        id: "live-search.search-more",
        defaultMessage: "See more search results"
    },
    liveSearchSelectNoResult1: {
        id: "live-search.no-result-1",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn't find anything matching your search"
    },
    liveSearchSelectNoResult2: {
        id: "live-search.no-result-2",
        defaultMessage: "Try again with a different term"
    },
    searchIconLabel: {
        id: "live-search.search-icon-label",
        defaultMessage: "Magnifying glass"
    }
});
module.exports["i18n"] = $3004d3bb8ead7d7b$export$a7357cdd1f0b0168;

});

parcelRegister("dkccs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3uWLy = parcelRequire("3uWLy");


var $lHQkL = parcelRequire("lHQkL");

const $b4fc439cf581a678$export$37d81fcf1a4df7fc = ({ onClick: onClick, searchInput: searchInput })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3uWLy.SearchResultMoreWrapper), {
        onClick: ()=>onClick({
                searchMore: searchInput
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $lHQkL.i18n).liveSearchSelectSearchMore));
module.exports["SearchResultMore"] = $b4fc439cf581a678$export$37d81fcf1a4df7fc;

});

parcelRegister("3EYav", function(module, exports) {
// handleNavigate does called in react component
/* eslint-disable react-hooks/rules-of-hooks */ 
var $inPa6 = parcelRequire("inPa6");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $1b86c7896a2c63d8$export$efe49016b6e93b85 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return ({ searchMore: searchMore, searchResult: searchResult, currentSpaceKey: currentSpaceKey, config: config, eventParams: eventParams })=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'liveSearch',
                source: 'liveSearch',
                actionSubjectId: 'liveSearchButtonClicked',
                objectId: eventParams?.pageId,
                attributes: {
                    destination: !searchResult ? 'advanced_search' : 'user_defined',
                    trigger: eventParams?.trigger || 'click',
                    source: 'liveSearch',
                    searchSessionId: eventParams?.searchSessionId || undefined,
                    navigation: searchMore ? 'postQuery' : 'preQuery'
                }
            }
        }).fire();
        if (searchMore !== undefined && !searchResult) {
            const { spaceKey: spaceKey, type: type, labels: labels } = config;
            let typeQuery;
            let spaces;
            if (spaceKey === 'currentSpace()' || spaceKey === '@self') spaces = `&spaces=${currentSpaceKey}`;
            else if (spaceKey) spaces = `&spaces=${spaceKey}`;
            if (type === 'spacedesc') typeQuery = '&type=space';
            else if (type) typeQuery = `&type=${type}`;
            const appliedLabels = labels ? `&labels=${labels}` : '';
            push(`${(0, $1NBp8.ADVANCED_SEARCH).toUrl()}?text=${searchMore}${spaces || ''}${typeQuery || ''}${appliedLabels}`);
        } else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'liveSearchResult',
                    actionSubjectId: 'liveSearchQueryResult',
                    source: 'liveSearch',
                    attributes: {
                        source: 'liveSearch',
                        searchSessionId: eventParams?.searchSessionId,
                        queryHash: eventParams?.queryHash,
                        queryVersion: eventParams?.queryVersion,
                        queryLength: eventParams?.queryLength,
                        wordCount: eventParams?.wordCount
                    }
                }
            }).fire();
            push(`${(0, $1NBp8.WIKI).toUrl()}${searchResult}`);
        }
    };
};
module.exports["handleNavigate"] = $1b86c7896a2c63d8$export$efe49016b6e93b85;

});

parcelRegister("047Sb", function(module, exports) {
/* eslint-disable */ // @ts-ignore
const $4e16e09ee5d4c2a8$export$bc237d627614fc48 = `!function(e,a){a.liveSearchInput={};var t,c=e.querySelectorAll("div[title='Live Search Macro']"),r=c[c.length-1],n=r.getElementsByTagName("form")[0],i=r.getElementsByTagName("button")[0],l=r.getElementsByTagName("input")[0],s=r.attributes,p="";Array.prototype.slice.call(s).forEach(function(e){"data-macro-parameters"===e.name&&(t=JSON.parse(e.value))});var e=t||{},c=e.spaceKey,r=e.type,s=e.currentSpaceKey,u=e.macroId,o="",m="";function v(e){var t="/wiki/search?text="+p+m+o;a.location.href=t,e.preventDefault()}function y(e,t,a){e&&e.addEventListener(t,a)}"currentSpace()"===c||"@self"===c?m="&spaces="+s:c&&(m="&spaces="+c),"spacedesc"===r?o="&type=space":r&&(o="&type="+r),y(n,"submit",v),y(i,"click",v),y(l,"input",function(e){p=e.target.value,u&&(a.liveSearchInput[u]=p)})}(document,window);`;
module.exports["script"] = $4e16e09ee5d4c2a8$export$bc237d627614fc48;

});

parcelRegister("31HPn", function(module, exports) {
const $23fc703b824b091d$export$38c6526d67de94bb = 'xen:macro';
const $23fc703b824b091d$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $23fc703b824b091d$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $23fc703b824b091d$export$46fc26821adc3495 = 'connectAddon';
const $23fc703b824b091d$export$95077f102dafd025 = 'migratedServerP2Addon';
const $23fc703b824b091d$export$981e47da3e2dfc13 = 'bodiedExtension';
const $23fc703b824b091d$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $23fc703b824b091d$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $23fc703b824b091d$export$bf4c163a4c708db1 = 'forgeDocUpdated';
module.exports["MODULE_NAME"] = $23fc703b824b091d$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $23fc703b824b091d$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $23fc703b824b091d$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $23fc703b824b091d$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $23fc703b824b091d$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $23fc703b824b091d$export$bf4c163a4c708db1;

});

parcelRegister("cBi7Q", function(module, exports) {
const $a428bcb8f1a15d17$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $a428bcb8f1a15d17$export$c87b1e2e3344192f = 1000;
const $a428bcb8f1a15d17$export$c4e7b6208a0b853e = 60;
const $a428bcb8f1a15d17$export$cd6b7e688e614eeb = $a428bcb8f1a15d17$export$c4e7b6208a0b853e * 60;
const $a428bcb8f1a15d17$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $a428bcb8f1a15d17$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $a428bcb8f1a15d17$export$e5a3af287978673c = (siteId)=>siteId ? `${$a428bcb8f1a15d17$export$a0d33d6e93abfb90}_${siteId}` : $a428bcb8f1a15d17$export$a0d33d6e93abfb90;
const $a428bcb8f1a15d17$export$e8114853eca81277 = 'ai-mate';
const $a428bcb8f1a15d17$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $a428bcb8f1a15d17$export$1ea9613e3e37d315 = 30 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$501af059da333e01 = 5 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $a428bcb8f1a15d17$export$85d90d98449e85fd = 140;
const $a428bcb8f1a15d17$export$cad0f6e78cd99203 = '600px';
const $a428bcb8f1a15d17$export$900371d5fadf47e7 = {
    NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
    THUMBS_UP_BUTTON: 'rovo-chat-thumbs-up-button'
};
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $a428bcb8f1a15d17$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $a428bcb8f1a15d17$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $a428bcb8f1a15d17$export$cd6b7e688e614eeb;
module.exports["getChatLoadPreferenceKey"] = $a428bcb8f1a15d17$export$e5a3af287978673c;
module.exports["AI_MATE_EXPERIENCE_ID"] = $a428bcb8f1a15d17$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $a428bcb8f1a15d17$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $a428bcb8f1a15d17$export$f8d883b8f9181b19;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $a428bcb8f1a15d17$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $a428bcb8f1a15d17$export$cad0f6e78cd99203;
module.exports["POLLINATOR_TEST_IDS"] = $a428bcb8f1a15d17$export$900371d5fadf47e7;

});

parcelRegister("hHZWk", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $42omo.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $frIzR.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("8cOoD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("3FlVr", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ var $3196fb7749a17aaf$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $3196fb7749a17aaf$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $3196fb7749a17aaf$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $3196fb7749a17aaf$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("cLFvw"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("cLFvw"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $b3Wpp = parcelRequire("b3Wpp");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $4FHTF = parcelRequire("4FHTF");


var $1s5hv = parcelRequire("1s5hv");


var $1qfLF = parcelRequire("1qfLF");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $b3Wpp.default);
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3ae84312c23de134$var$ReactionsPlaceholderQuery, t3);
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $gMc0m.default)([
                    "_11q7vkf5 _2rko1rr0 _1bsb1crf _4t3i1crf _18u012x7"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $gMc0m.default)([
            "_11q7vkf5 _2rko1rr0 _1bsbor1b _4t3i1tcg _2hwx1b66"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("b3Wpp", function(module, exports) {
/**
 * @generated SignedSource<<e034cf0adfd46c9f4d0f6acd07f7d817>>
 * @relayHash 82e58e09cb6c0ae8731a0483a5357faf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6
const $41658e2724bc842d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "82e58e09cb6c0ae8731a0483a5357faf",
            "id": "d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6",
            "metadata": {},
            "name": "ReactionsPlaceholderQuery",
            "operationKind": "query",
            "text": "query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}"
        }
    };
}();
$41658e2724bc842d$var$node.hash = "22ecbec40a97883abeadc26399cf4367";
var $41658e2724bc842d$export$2e2bcd8739ae039 = $41658e2724bc842d$var$node;
module.exports["default"] = $41658e2724bc842d$export$2e2bcd8739ae039;

});

parcelRegister("5Kc7f", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $eTjjM = parcelRequire("eTjjM");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_bfhkizff",
    wrapperStyles: "_19bvu2gc _u5f3utpp _19pk1i6y",
    countSkeletonStyles: "_2rko1rr0 _1bsb19bv _4t3i19bv _bfhkizff"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eTjjM.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ])
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("cLFvw", function(module, exports) {

let $94ba124f403f1157$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $94ba124f403f1157$var$load("4pqtR"),
    $94ba124f403f1157$var$load("5XqRg"),
    $94ba124f403f1157$var$load("6wr18"),
    $94ba124f403f1157$var$load("Wowvf"),
    $94ba124f403f1157$var$load("7EorR"),
    $94ba124f403f1157$var$load("3EXzu"),
    $94ba124f403f1157$var$load("ffEVr"),
    $94ba124f403f1157$var$load("5qNrc"),
    $94ba124f403f1157$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("isEtk", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0cd4a5fc89cb5961$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        isContentReady: false,
        contentLoading: {}
    },
    actions: {
        onContentRendered: ()=>({ setState: setState })=>{
                setState({
                    isContentReady: true
                });
            },
        addContentToBeLoaded: (content, value)=>({ setState: setState, getState: getState })=>{
                const newContentLoading = getState().contentLoading;
                newContentLoading[content] = value;
                setState({
                    contentLoading: newContentLoading
                });
            },
        removeContentFromLoading: (content)=>({ setState: setState, getState: getState })=>{
                const existingContentLoading = getState().contentLoading;
                existingContentLoading[content] && delete existingContentLoading[content];
                setState({
                    contentLoading: existingContentLoading
                });
            }
    },
    name: 'isContentReady'
});
const $0cd4a5fc89cb5961$export$fce89f7e653f0af5 = (0, $FOT9i.createContainer)($0cd4a5fc89cb5961$var$Store);
const $0cd4a5fc89cb5961$export$b49d63386d42e7ce = (0, $9zUhf.createHook)($0cd4a5fc89cb5961$var$Store);
module.exports["ContentStateContainer"] = $0cd4a5fc89cb5961$export$fce89f7e653f0af5;
module.exports["useContentState"] = $0cd4a5fc89cb5961$export$b49d63386d42e7ce;

});

parcelRegister("ad6ZE", function(module, exports) {
var $bcdbc544cc3a5c22$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $bcdbc544cc3a5c22$export$2df6d049e5bad28e;

});

parcelRegister("6bd6t", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $biiXa = parcelRequire("biiXa");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $fYQcF = parcelRequire("fYQcF");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $7OLeD = parcelRequire("7OLeD");


var $PjC9c = parcelRequire("PjC9c");


var $dchHi = parcelRequire("dchHi");

const $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $6d65bb3bd17dd577$var$i18n = (0, $aXWIB.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Good response"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Bad response"
    },
    likeSuggestionTooltip: {
        id: "quick-summary.like-suggestion.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeSuggestionTooltip: {
        id: "quick-summary.dislike-suggestion.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $6d65bb3bd17dd577$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6d65bb3bd17dd577$var$i18n.privacyPolicyLink));
const $6d65bb3bd17dd577$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6d65bb3bd17dd577$var$i18n.researchGroupLink));
const $6d65bb3bd17dd577$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$6d65bb3bd17dd577$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$PrivacyPolicyLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $6d65bb3bd17dd577$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$6d65bb3bd17dd577$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$ResearchGroupLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $6d65bb3bd17dd577$var$TooltipWrapperXCSS = (0, $ecnYn.xcss)({
    listStyle: 'none',
    marginTop: 'space.0'
});
const $6d65bb3bd17dd577$var$FeedbackIconXCSS = (0, $ecnYn.xcss)({
    marginRight: 'space.050'
});
const $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS = (0, $ecnYn.xcss)({
    transform: 'rotate(180deg)'
});
const $6d65bb3bd17dd577$var$ButtonWrapperXCSS = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $6d65bb3bd17dd577$var$InlineULXCSS = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0',
    display: 'flex'
});
const $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3 = ({ analyticsProperties: analyticsProperties, contentId: contentId, spaceKey: spaceKey, summaryId: summaryId, summaryLocale: summaryLocale, feedbackTitle: feedbackTitle, feedbackSummaryPlaceholder: feedbackSummaryPlaceholder, aiContentType: aiContentType })=>{
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const feedbackCollectorProperties = (0, $dchHi.useFeedbackCollectorProperties)();
    const [sentiment, setSentiment] = (0, $42omo.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $42omo.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // Only fetch contributor info when contentId is provided (not for space-level feedback)
    const shouldFetchContributors = !!contentId;
    const contributorResult = (0, $PjC9c.useCurrentUserContributor)(contentId || '');
    const { isCurrentUserContributor: isCurrentUserContributor, contentContributorsError: contentContributorsError } = shouldFetchContributors ? contributorResult : {
        isCurrentUserContributor: undefined,
        contentContributorsError: undefined
    };
    const feedbackContextParts = [
        contentId && `contentId: ${contentId}`,
        spaceKey && `spaceKey: ${spaceKey}`,
        `sentiment: ${sentiment}`,
        `cloudId: ${cloudId}`,
        `isCurrentUserContributor: ${isCurrentUserContributor}`,
        feedbackCollectorProperties.feedbackContext.length > 0 && feedbackCollectorProperties.feedbackContext
    ].filter(Boolean);
    const feedbackContextString = feedbackContextParts.join(' ');
    (0, $42omo.useEffect)(()=>{
        if (isFeedbackOpen) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: `${analyticsProperties.source}FeedbackCollectorDialog`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isFeedbackOpen,
        contentId,
        spaceKey,
        summaryId,
        summaryLocale,
        sentiment,
        analyticsProperties
    ]);
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($6d65bb3bd17dd577$var$i18n.flagTitle),
            description: formatMessage($6d65bb3bd17dd577$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const onLikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('good');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}LikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('up');
    };
    const onDislikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('bad');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}DislikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('down');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}SubmitFeedbackButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    };
    const likeTooltip = aiContentType && aiContentType === 'suggestion' ? $6d65bb3bd17dd577$var$i18n.likeSuggestionTooltip : $6d65bb3bd17dd577$var$i18n.likeTooltip;
    const dislikeTooltip = aiContentType && aiContentType === 'suggestion' ? $6d65bb3bd17dd577$var$i18n.dislikeSuggestionTooltip : $6d65bb3bd17dd577$var$i18n.dislikeTooltip;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "ul",
        xcss: $6d65bb3bd17dd577$var$InlineULXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage(likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage(likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: onLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage(dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        "aria-label": formatMessage(dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: onDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage(feedbackSummaryPlaceholder ?? $6d65bb3bd17dd577$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage(feedbackTitle ?? $6d65bb3bd17dd577$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($6d65bb3bd17dd577$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d65bb3bd17dd577$var$EnrolLabel, null)
    })), contentContributorsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentContributorsError
    })));
};
module.exports["SmartsFeedbackComponent"] = $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3;

});

parcelRegister("7OLeD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9FnLD = parcelRequire("9FnLD");

const $e94a9fb89963bcaa$export$1337fc502d44e2c0 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        spacing: "spacious",
        label: ""
    });
module.exports["ThumbsIcon"] = $e94a9fb89963bcaa$export$1337fc502d44e2c0;

});

parcelRegister("PjC9c", function(module, exports) {

var $3XvFR = parcelRequire("3XvFR");


var $jMyy4 = parcelRequire("jMyy4");

const $03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery = (0, $3XvFR.default);
const $03062ed3aa730446$export$b7b7e80a2f61884d = (contentId)=>{
    const { data: data, loading: contentContributorsLoading, error: contentContributorsError } = (0, $jMyy4.useQueryInterop)($03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery, {
        variables: {
            contentId: contentId
        }
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? undefined;
    return {
        isCurrentUserContributor: isCurrentUserContributor,
        contentContributorsLoading: contentContributorsLoading,
        contentContributorsError: contentContributorsError
    };
};
module.exports["useCurrentUserContributor"] = $03062ed3aa730446$export$b7b7e80a2f61884d;

});

parcelRegister("3XvFR", function(module, exports) {
/**
 * @generated SignedSource<<fb725f8f2469f59a812a30ad037a1207>>
 * @relayHash 8d03040d688843528ead855771e8246c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e77762aba0ebc1a12b0097564e9f8fce072dd0e08c861f47b22ab9799b0f4a00
const $019e619a88781c82$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCurrentUserContributorContentContributorsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCurrentUserContributorContentContributorsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8d03040d688843528ead855771e8246c",
            "id": "e77762aba0ebc1a12b0097564e9f8fce072dd0e08c861f47b22ab9799b0f4a00",
            "metadata": {},
            "name": "useCurrentUserContributorContentContributorsQuery",
            "operationKind": "query",
            "text": "query useCurrentUserContributorContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$019e619a88781c82$var$node.hash = "3529cb3bd09c95342e2b9b31b917a3c4";
var $019e619a88781c82$export$2e2bcd8739ae039 = $019e619a88781c82$var$node;
module.exports["default"] = $019e619a88781c82$export$2e2bcd8739ae039;

});

parcelRegister("dchHi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $aXWIB.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $42omo.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("dkDqz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $2c3fc5ab77b32b66$export$3238f1bda20b469c = (0, $2XqLN.default)(()=>({
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true
    }));
module.exports["getLayoutOptions"] = $2c3fc5ab77b32b66$export$3238f1bda20b469c;

});

parcelRegister("bY24B", function(module, exports) {
const $0e0fdc78f7a1bae2$var$DEFAULT_EXPAND_OPTIONS = {
    allowInsertion: true,
    allowInteractiveExpand: true
};
const $0e0fdc78f7a1bae2$export$98ec01862577ac69 = ()=>{
    return $0e0fdc78f7a1bae2$var$DEFAULT_EXPAND_OPTIONS;
};
module.exports["useExpandOptions"] = $0e0fdc78f7a1bae2$export$98ec01862577ac69;

});

parcelRegister("jvzGU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hUz7g = parcelRequire("hUz7g");

const $83b906b815f15665$export$fddc468cd8cb4db9 = ()=>{
    return (0, $42omo.useMemo)(()=>(0, $hUz7g.getTableOptions)(), []);
};
module.exports["useTableOptions"] = $83b906b815f15665$export$fddc468cd8cb4db9;

});

parcelRegister("hUz7g", function(module, exports) {
const $68268dc60793ca56$export$4fc4c895dbb98f6b = ()=>{
    return {
        allowTableResizing: true,
        allowTableAlignment: true,
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowColumnSorting: true,
        allowDistributeColumns: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        allowNestedTables: true,
        allowControls: true,
        stickyHeaders: true,
        allowAddColumnWithCustomStep: false
    };
};
module.exports["getTableOptions"] = $68268dc60793ca56$export$4fc4c895dbb98f6b;

});

parcelRegister("ihn35", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qoahv _n3tdv47k _p12fukw8 _1bsb1osq _4t3i68cl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$efb20161e583b9b8 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81qyo _1e0c1txw _1bah1yb4 _4cvr1h6o _n3tdu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$80837d77c7223a53 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _u5f3u2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _bfhki8nm _4t3it94y _1bsbidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$48423cf6a25b5248 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulputpp _11c8fhey _1yt44ar7 _1e0c1txw _2lx21bp4 _p12fsb0t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$49166591ec160d97 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _19bvu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$ee3e739bedcb3f4c = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx2vrvc _1n261g80 _zulppxbi _1e0c1txw _4t3i1obz _1bah1yb4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$227f3f793075b973 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp1ejb _11c8fhey _1e0c1txw _2lx21bp4 _u5f3xncg _p12f10k3",
            !__cmplp.isNav4Enabled && "_19bvv47k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$545440ab15c19255 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulputpp _11c8i4vh _syazazsu _1e0c1txw _4cvr1h6o _19bv1ejb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a436177ded449686 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulppxbi _1e0c1txw _4cvr1h6o _19bvutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$faaa5da096482ae9 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8i4vh _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a1abff0c22b50819 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u01b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$23b4998b204f6604 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8i4vh _syazazsu _n3tdu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["EndOfPageRecPlaceholderContainer"] = $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d;
module.exports["EndOfPageRecHeader"] = $e8a7d12ee4dfec6a$export$efb20161e583b9b8;
module.exports["HeaderFrontContainer"] = $e8a7d12ee4dfec6a$export$80837d77c7223a53;
module.exports["HeaderLineContainer"] = $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a;
module.exports["InfoContainer"] = $e8a7d12ee4dfec6a$export$48423cf6a25b5248;
module.exports["FeedbackContainer"] = $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1;
module.exports["EndOfPageRecAdminConfigContainer"] = $e8a7d12ee4dfec6a$export$227f3f793075b973;
module.exports["EndOfPageRecHideControlContainer"] = $e8a7d12ee4dfec6a$export$545440ab15c19255;
module.exports["EndOfPageRecHideToggleContainer"] = $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab;
module.exports["SpaceFeedbackButtonWrapper"] = $e8a7d12ee4dfec6a$export$a1abff0c22b50819;
module.exports["FeedbackFormQuestion"] = $e8a7d12ee4dfec6a$export$23b4998b204f6604;

});

parcelRegister("4r9Ir", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7IghX = parcelRequire("7IghX");

const $4ae3b5b25efc2fdf$export$c465d99c658013a3 = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentPositions: [],
    addNewComment: ()=>{},
    removeComment: ()=>{},
    acknowledgeComment: ()=>{},
    acknowledgeComments: ()=>{},
    clearNewComments: ()=>{}
});
const $4ae3b5b25efc2fdf$var$getCommentScreenPosition = (commentId)=>{
    const commentElem = document.querySelector(`#comment-${commentId}`);
    if (commentElem) return {
        top: commentElem.offsetTop,
        bottom: commentElem.offsetTop + commentElem.offsetHeight
    };
    return {
        top: Number.NEGATIVE_INFINITY,
        bottom: Number.POSITIVE_INFINITY
    };
};
const $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [newCommentPositions, setNewCommentPositions] = (0, $42omo.useState)(t1);
    const { count: count, setCount: setCount } = (0, $42omo.useContext)((0, $7IghX.PageCommentsCountContext));
    let t2;
    if ($[1] !== count || $[2] !== setCount) {
        t2 = (t3)=>{
            const { currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId } = t3;
            if (newCommentId) {
                const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                setNewCommentPositions((existingPositions)=>{
                    const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                    return !commentExists ? [
                        ...existingPositions,
                        {
                            id: newCommentId,
                            pos: pos,
                            seen: false,
                            currentUserMadeComment: currentUserMadeComment
                        }
                    ] : existingPositions;
                });
                setCount(count + 1);
            }
        };
        $[1] = count;
        $[2] = setCount;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== count || $[5] !== newCommentPositions || $[6] !== setCount) {
        t3 = (commentId)=>{
            if (commentId) {
                const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                if (idx !== -1) {
                    const positionCopy = [
                        ...newCommentPositions
                    ];
                    positionCopy.splice(idx, 1);
                    setNewCommentPositions(positionCopy);
                }
                const newCount = count - 1;
                setCount(newCount < 0 ? 0 : newCount);
            }
        };
        $[4] = count;
        $[5] = newCommentPositions;
        $[6] = setCount;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    let t5;
    if ($[8] !== newCommentPositions) {
        t4 = (commentId_0)=>{
            if (commentId_0) {
                const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                if (comment_0) comment_0.seen = true;
            }
        };
        t5 = (commentIds)=>{
            if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                if (comment_1) comment_1.seen = true;
            });
        };
        $[8] = newCommentPositions;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setNewCommentPositions([]);
        };
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== newCommentPositions || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t7 = {
            newCommentPositions: newCommentPositions,
            addNewComment: t2,
            removeComment: t3,
            acknowledgeComment: t4,
            acknowledgeComments: t5,
            clearNewComments: t6
        };
        $[12] = newCommentPositions;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t7;
    } else t7 = $[17];
    const newCommentsContextValue = t7;
    let t8;
    if ($[18] !== children || $[19] !== newCommentsContextValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
            value: newCommentsContextValue
        }, children);
        $[18] = children;
        $[19] = newCommentsContextValue;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ children: children })=>{
    const [newCommentPositions, setNewCommentPositions] = (0, $42omo.useState)([]);
    const { count: count, setCount: setCount } = (0, $42omo.useContext)((0, $7IghX.PageCommentsCountContext));
    const newCommentsContextValue = (0, $42omo.useMemo)(()=>({
            newCommentPositions: newCommentPositions,
            addNewComment: ({ currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId })=>{
                if (newCommentId) {
                    const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                    setNewCommentPositions((existingPositions)=>{
                        const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                        return !commentExists ? [
                            ...existingPositions,
                            {
                                id: newCommentId,
                                pos: pos,
                                seen: false,
                                currentUserMadeComment: currentUserMadeComment
                            }
                        ] : existingPositions;
                    });
                    // Update the comment count
                    setCount(count + 1);
                }
            },
            removeComment: (commentId)=>{
                if (commentId) {
                    const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                    if (idx !== -1) {
                        const positionCopy = [
                            ...newCommentPositions
                        ];
                        positionCopy.splice(idx, 1);
                        setNewCommentPositions(positionCopy);
                    }
                    // Update the comment count
                    const newCount = count - 1;
                    setCount(newCount < 0 ? 0 : newCount);
                }
            },
            acknowledgeComment: (commentId_0)=>{
                if (commentId_0) {
                    const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                    if (comment_0) comment_0.seen = true;
                }
            },
            acknowledgeComments: (commentIds)=>{
                if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                    const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                    if (comment_1) comment_1.seen = true;
                });
            },
            clearNewComments: ()=>{
                setNewCommentPositions([]);
            }
        }), [
        count,
        newCommentPositions,
        setCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
        value: newCommentsContextValue
    }, children);
};
module.exports["NewCommentsContext"] = $4ae3b5b25efc2fdf$export$c465d99c658013a3;
module.exports["NewCommentsProvider"] = $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f;

});

parcelRegister("7IghX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $230ca5ca2ceedabc$export$560530991a10c1f8 = /*#__PURE__*/ (0, $42omo.createContext)({
    count: 0,
    setCount: ()=>{}
});
const $230ca5ca2ceedabc$export$d3be1c3b23ba5810 = ({ children: children, contentId: contentId })=>{
    const [count, setCount] = (0, $42omo.useState)(0);
    const pageCommentsCountContextValue = (0, $42omo.useMemo)(()=>({
            count: count,
            setCount: setCount
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        count,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($230ca5ca2ceedabc$export$560530991a10c1f8.Provider, {
        value: pageCommentsCountContextValue
    }, children);
};
module.exports["PageCommentsCountContext"] = $230ca5ca2ceedabc$export$560530991a10c1f8;
module.exports["PageCommentsCountProvider"] = $230ca5ca2ceedabc$export$d3be1c3b23ba5810;

});

parcelRegister("804Ue", function(module, exports) {

var $lFugL = parcelRequire("lFugL");


var $42omo = parcelRequire("42omo");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $42omo.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $42omo.useRef)(null);
    const missedEventQueryTimeout = (0, $42omo.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $42omo.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $42omo.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        // this is required for page navigation using the page tree
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $42omo.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        if (latestVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            if ((0, $6mKj3.expValEquals)('confluence_fe_correct_document_needs_update', 'isEnabled', true)) // Set documentNeedsUpdate to true only if all of the following are true:
            // 1. pageMode is VIEW
            // 2. currentDocumentVersion is set to a valid version number
            // 3. latestVersion is different from currentDocumentVersion
            // Otherwise, set documentNeedsUpdate to false.
            setDocumentNeedsUpdate(pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion > 0 && latestVersion !== currentDocumentVersion);
            else setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate,
        pageMode
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $lFugL.default),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all'
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = comment.comment?.author?.accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $42omo.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $42omo.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("lFugL", function(module, exports) {
/**
 * @generated SignedSource<<aa10696ec6a2d7e4cb588f189ac2382f>>
 * @relayHash 7477557bbdcb7cd2b6d07a81a3bcb66a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559
const $f560d9e78fe64cde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "since"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "since",
            "variableName": "since"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "time"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "KnownUser"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "UnknownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7477557bbdcb7cd2b6d07a81a3bcb66a",
            "id": "b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559",
            "metadata": {},
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "operationKind": "query",
            "text": "query MissedPubSubCommentEventsHandlerQuery($contentId:Long!,$since:Long!){quickReload(pageId:$contentId,since:$since){time,comments{comment{id,location{__typename,type},author{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}"
        }
    };
}();
$f560d9e78fe64cde$var$node.hash = "7c3b6fa82a316ebe81a0bcd5cab2114e";
var $f560d9e78fe64cde$export$2e2bcd8739ae039 = $f560d9e78fe64cde$var$node;
module.exports["default"] = $f560d9e78fe64cde$export$2e2bcd8739ae039;

});

parcelRegister("kQekh", function(module, exports) {

var $k5aG8 = parcelRequire("k5aG8");


var $f9FCO = parcelRequire("f9FCO");

const $90ffe60e2eae60ca$export$bf87400a8da436f8 = (0, $f9FCO.default);
const $90ffe60e2eae60ca$export$caecd77287327384 = (0, $k5aG8.default);
module.exports["CommentsSectionGetSingleCommentQuery"] = $90ffe60e2eae60ca$export$bf87400a8da436f8;
module.exports["CommentsSectionGetSingleCommentWithoutReactionsQuery"] = $90ffe60e2eae60ca$export$caecd77287327384;

});

parcelRegister("k5aG8", function(module, exports) {
/**
 * @generated SignedSource<<0d8825875af9c0853fe1e8d18bf78b15>>
 * @relayHash d3bcc60b520b9e62b29ac8be494a67be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c
const $2711060718729916$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d3bcc60b520b9e62b29ac8be494a67be",
            "id": "7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQueryWithoutReactionsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$2711060718729916$var$node.hash = "2d393682eae4feef3986d5e4ea1bd5a6";
var $2711060718729916$export$2e2bcd8739ae039 = $2711060718729916$var$node;
module.exports["default"] = $2711060718729916$export$2e2bcd8739ae039;

});

parcelRegister("f9FCO", function(module, exports) {
/**
 * @generated SignedSource<<ddb9266936acdb7c6803058e0215a77c>>
 * @relayHash 1a3bffe088c5850ddf1b9c1ca4f044de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a
const $c1f0ddf438970e3e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1a3bffe088c5850ddf1b9c1ca4f044de",
            "id": "99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQuery($commentId:ID!,$contentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$c1f0ddf438970e3e$var$node.hash = "326ee68c128aba1a564502e019c38ae6";
var $c1f0ddf438970e3e$export$2e2bcd8739ae039 = $c1f0ddf438970e3e$var$node;
module.exports["default"] = $c1f0ddf438970e3e$export$2e2bcd8739ae039;

});

parcelRegister("lTuad", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4oS56 = parcelRequire("4oS56");

const $cd929b75fafb645b$export$cea8cae1a6ef81f0 = /*#__PURE__*/ (0, $42omo.memo)(({ itemName: itemName, children: component, closeSelf: closeSelf, hasPadding: hasPadding = true, customWidth: customWidth })=>{
    const { setItem: setItem, removeItem: removeItem } = (0, $42omo.useContext)((0, $4oS56.EditorContextPanelContext));
    // remove the item on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            removeItem(itemName);
        };
    }, [
        itemName,
        removeItem
    ]);
    (0, $42omo.useEffect)(()=>{
        if (component) setItem({
            itemName: itemName,
            component: component,
            close: closeSelf,
            hasPadding: hasPadding,
            customWidth: customWidth
        });
        else removeItem(itemName);
    }, [
        component,
        itemName,
        setItem,
        removeItem,
        closeSelf,
        hasPadding,
        customWidth
    ]);
    return null;
});
module.exports["EditorContextPanelItem"] = $cd929b75fafb645b$export$cea8cae1a6ef81f0;

});

parcelRegister("c5gk7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $3gadb = parcelRequire("3gadb");

const $3611e64236f83f1d$var$i18n = (0, $aXWIB.defineMessages)({
    close: {
        id: "editor-context-panel.panel-close-button.close-label",
        defaultMessage: "Close configuration panel"
    }
});
const $3611e64236f83f1d$export$de65de8213222d10 = /*#__PURE__*/ (0, $42omo.memo)(({ appearance: appearance = 'subtle', onClose: onClose, label: label, isTooltipDisabled: isTooltipDisabled = true, testId: testId = 'panel-close-button', analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        hideTooltipOnClick: true,
        content: label || formatMessage($3611e64236f83f1d$var$i18n.close)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: onClose,
        appearance: appearance,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: label || formatMessage($3611e64236f83f1d$var$i18n.close),
        testId: testId,
        isTooltipDisabled: isTooltipDisabled,
        analyticsContext: analyticsContext
    }));
});
module.exports["CloseButton"] = $3611e64236f83f1d$export$de65de8213222d10;

});

parcelRegister("eTcMK", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ const $cae726f3aa41e4da$export$497a036b5874e4b0 = (parentCommentId, location, author, shouldIncludeUser)=>{
    return {
        parentCommentId: parentCommentId,
        location: location,
        user: author && shouldIncludeUser ? {
            displayName: author.displayName,
            accountId: author.accountId
        } : undefined
    };
};
module.exports["createReplyToCommentParams"] = $cae726f3aa41e4da$export$497a036b5874e4b0;

});

parcelRegister("ifBRq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $wwjAh = parcelRequire("wwjAh");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $4u5NT = parcelRequire("4u5NT");


var $gczDe = parcelRequire("gczDe");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $lb2Lp = parcelRequire("lb2Lp");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $7aRa9 = parcelRequire("7aRa9");


var $7W8i8 = parcelRequire("7W8i8");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $8WQTF = parcelRequire("8WQTF");


var $aSsfA = parcelRequire("aSsfA");


var $dPJCf = parcelRequire("dPJCf");


var $jMyy4 = parcelRequire("jMyy4");


var $eTcMK = parcelRequire("eTcMK");


var $1ZGYV = parcelRequire("1ZGYV");

// ---------------------------------------------------------------------------
// Unified GraphQL query (superset of both individual queries)
// Fetches inline fields + footer fields in a single request.
// ---------------------------------------------------------------------------
const $4d5518b698c93929$var$CommentQueryParamsListenerQuery = (0, $wwjAh.default);
// ---------------------------------------------------------------------------
// Constants (from ObjectCommentQueryParamsListener)
// ---------------------------------------------------------------------------
const $4d5518b698c93929$var$SCROLL_TIMEOUT_MS = 4000;
const $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS = 500;
const $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS = 150;
const $4d5518b698c93929$var$expectedErrorCodes = [
    404
];
const $4d5518b698c93929$export$5e7d3f36c6d6619d = (error)=>{
    const list = error.graphQLErrors;
    if (!Array.isArray(list) || list.length === 0) return false;
    return list.some((e)=>{
        const code = e?.extensions?.code;
        if (code === 'NOT_FOUND') return true;
        const statusCode = e?.extensions?.statusCode;
        if (statusCode == null) return false;
        const n = Number(statusCode);
        return Number.isFinite(n) && $4d5518b698c93929$var$expectedErrorCodes.includes(n);
    });
};
function $4d5518b698c93929$var$resolveLegacyCommentQueryInteropErrorMode(isNewFlow, foundComment, legacyData, legacyError) {
    if (isNewFlow) {
        const t = foundComment?.location?.type;
        return t && t !== 'INLINE' ? 'object' : 'inline';
    }
    const node = legacyData?.comments?.nodes?.[0];
    const t = node?.location?.type;
    if (t && t !== 'INLINE') return 'object';
    // Error with no comment node: location unknown — use object semantics for expected 404s only
    if (legacyError && !node) return $4d5518b698c93929$export$5e7d3f36c6d6619d(legacyError) ? 'object' : 'inline';
    return 'inline';
}
function $4d5518b698c93929$var$handleLegacyCommentQueryInteropError(legacyError, mode) {
    if (!legacyError) return;
    if (mode === 'inline') {
        // Missing/deleted comment (404 / NOT_FOUND) is expected — do not mark as handled (matches object-listener).
        if (!$4d5518b698c93929$export$5e7d3f36c6d6619d(legacyError)) {
            $4d5518b698c93929$var$logger.error`An error occurred when querying the focused comment status; ${legacyError}`;
            (0, $7Sm4c.markErrorAsHandled)(legacyError);
        }
        return;
    }
    // ObjectCommentQueryParamsListener: log unexpected only; never markErrorAsHandled
    if (!$4d5518b698c93929$export$5e7d3f36c6d6619d(legacyError)) $4d5518b698c93929$var$logger.error`An error occurred when querying the focused object comment status; ${legacyError}`;
}
const $4d5518b698c93929$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentLinkNotFoundFlagTitle: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    }
});
// ---------------------------------------------------------------------------
// Query param hooks
// ---------------------------------------------------------------------------
const $4d5518b698c93929$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $4d5518b698c93929$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $4d5518b698c93929$var$logger = (0, $7W8i8.getLogger)('inline-comments:query-param-listener');
const $4d5518b698c93929$var$useCommentQueryParamsData = (0, $3u0dr.isReactCompilerActiveV2)() ? function useCommentQueryParamsData(t0) {
    const $ = (0, $frIzR.c)(43);
    const { commentId: commentId, contentId: contentId } = t0;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let t1;
    if ($[0] !== pageMode) {
        t1 = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
        $[0] = pageMode;
        $[1] = t1;
    } else t1 = $[1];
    const contentStatusFilters = t1;
    const t2 = commentId || "";
    const t3 = contentId || "";
    let t4;
    if ($[2] !== commentId) {
        t4 = !commentId || !(0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false);
        $[2] = commentId;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t4) {
        t5 = {
            skip: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== contentStatusFilters || $[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
        t6 = {
            commentId: t2,
            contentId: t3,
            contentStatus: contentStatusFilters,
            options: t5
        };
        $[6] = contentStatusFilters;
        $[7] = t2;
        $[8] = t3;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)(t6);
    const t7 = foundComment?.parentId || "";
    const t8 = contentId || "";
    let t9;
    if ($[11] !== foundComment?.parentId) {
        t9 = !(0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) || !foundComment?.parentId;
        $[11] = foundComment?.parentId;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== t9) {
        t10 = {
            skip: t9
        };
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== contentStatusFilters || $[16] !== t10 || $[17] !== t7 || $[18] !== t8) {
        t11 = {
            commentId: t7,
            contentId: t8,
            contentStatus: contentStatusFilters,
            options: t10
        };
        $[15] = contentStatusFilters;
        $[16] = t10;
        $[17] = t7;
        $[18] = t8;
        $[19] = t11;
    } else t11 = $[19];
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)(t11);
    let t12;
    let t13;
    if ($[20] !== commentId) {
        t12 = {
            commentId: commentId
        };
        t13 = !commentId || (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false);
        $[20] = commentId;
        $[21] = t12;
        $[22] = t13;
    } else {
        t12 = $[21];
        t13 = $[22];
    }
    let t14;
    if ($[23] !== t12 || $[24] !== t13) {
        t14 = {
            variables: t12,
            skip: t13
        };
        $[23] = t12;
        $[24] = t13;
        $[25] = t14;
    } else t14 = $[25];
    const { data: legacyData, loading: legacyLoading, error: legacyError } = (0, $jMyy4.useQueryInterop)($4d5518b698c93929$var$CommentQueryParamsListenerQuery, t14);
    const legacyInteropErrorMode = $4d5518b698c93929$var$resolveLegacyCommentQueryInteropErrorMode((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false), foundComment, legacyData, legacyError);
    $4d5518b698c93929$var$handleLegacyCommentQueryInteropError(legacyError, legacyInteropErrorMode);
    let isResolved = undefined;
    let parentId = undefined;
    if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
        if (foundComment && !commentError) {
            const loc = foundComment.location;
            if (loc?.type === "INLINE") isResolved = Boolean(loc?.inlineResolveProperties?.resolved);
            else isResolved = Boolean(loc?.commentResolveProperties?.resolved);
            parentId = foundComment.parentId;
        }
    } else if (legacyData && !legacyError) {
        const node = legacyData?.comments?.nodes?.[0];
        const loc_0 = node?.location;
        if (loc_0?.type === "INLINE") isResolved = Boolean(loc_0?.inlineResolveProperties?.resolved);
        else isResolved = Boolean(loc_0?.commentResolveProperties?.resolved);
        parentId = node?.parentId;
    }
    let t15;
    if ($[26] !== foundComment || $[27] !== legacyData?.comments?.nodes?.[0]) {
        t15 = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? foundComment : legacyData?.comments?.nodes?.[0] ?? null;
        $[26] = foundComment;
        $[27] = legacyData?.comments?.nodes?.[0];
        $[28] = t15;
    } else t15 = $[28];
    const rawCommentForReply = t15;
    const t16 = Boolean(commentError);
    const t17 = Boolean(parentError);
    let t18;
    if ($[29] !== commentId || $[30] !== commentLoading || $[31] !== foundComment || $[32] !== isResolved || $[33] !== legacyData || $[34] !== legacyError || $[35] !== legacyLoading || $[36] !== parentComment || $[37] !== parentId || $[38] !== parentLoading || $[39] !== rawCommentForReply || $[40] !== t16 || $[41] !== t17) {
        t18 = {
            commentId: commentId,
            foundComment: foundComment,
            parentComment: parentComment,
            commentLoading: commentLoading,
            commentError: t16,
            parentLoading: parentLoading,
            parentError: t17,
            legacyData: legacyData,
            legacyError: legacyError,
            legacyLoading: legacyLoading,
            isResolved: isResolved,
            parentId: parentId,
            rawCommentForReply: rawCommentForReply
        };
        $[29] = commentId;
        $[30] = commentLoading;
        $[31] = foundComment;
        $[32] = isResolved;
        $[33] = legacyData;
        $[34] = legacyError;
        $[35] = legacyLoading;
        $[36] = parentComment;
        $[37] = parentId;
        $[38] = parentLoading;
        $[39] = rawCommentForReply;
        $[40] = t16;
        $[41] = t17;
        $[42] = t18;
    } else t18 = $[42];
    return t18;
} : function useCommentQueryParamsData({ commentId: commentId, contentId: contentId }) {
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    // NEW FLOW
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: !commentId || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)({
        commentId: foundComment?.parentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) || !foundComment?.parentId
        }
    });
    // OLD FLOW — unified query fetches superset of both inline + footer fields
    const { data: legacyData, loading: legacyLoading, error: legacyError } = (0, $jMyy4.useQueryInterop)($4d5518b698c93929$var$CommentQueryParamsListenerQuery, {
        variables: {
            commentId: commentId
        },
        skip: !commentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    const legacyInteropErrorMode = $4d5518b698c93929$var$resolveLegacyCommentQueryInteropErrorMode((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), foundComment, legacyData, legacyError);
    $4d5518b698c93929$var$handleLegacyCommentQueryInteropError(legacyError, legacyInteropErrorMode);
    // Derive isResolved + parentId from whichever flow is active
    let isResolved = undefined;
    let parentId = undefined;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (foundComment && !commentError) {
            const loc = foundComment.location;
            if (loc?.type === 'INLINE') isResolved = Boolean(loc?.inlineResolveProperties?.resolved);
            else isResolved = Boolean(loc?.commentResolveProperties?.resolved);
            parentId = foundComment.parentId;
        }
    } else if (legacyData && !legacyError) {
        const node = legacyData?.comments?.nodes?.[0];
        const loc_0 = node?.location;
        if (loc_0?.type === 'INLINE') isResolved = Boolean(loc_0?.inlineResolveProperties?.resolved);
        else isResolved = Boolean(loc_0?.commentResolveProperties?.resolved);
        parentId = node?.parentId;
    }
    const rawCommentForReply = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment : legacyData?.comments?.nodes?.[0] ?? null;
    return {
        commentId: commentId,
        foundComment: foundComment,
        parentComment: parentComment,
        commentLoading: commentLoading,
        commentError: Boolean(commentError),
        parentLoading: parentLoading,
        parentError: Boolean(parentError),
        legacyData: legacyData,
        legacyError: legacyError,
        legacyLoading: legacyLoading,
        isResolved: isResolved,
        parentId: parentId,
        rawCommentForReply: rawCommentForReply
    };
}; // ---------------------------------------------------------------------------
const $4d5518b698c93929$var$InlineCommentHandler = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(57);
    const { commentId: commentId, isArchived: isArchived, rendererRef: rendererRef, flags: flags, data: data } = t0;
    const hasHandledCommentLink = (0, $42omo.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    let t1;
    if ($[0] !== isArchived) {
        t1 = {
            queryArchivedContent: isArchived
        };
        $[0] = isArchived;
        $[1] = t1;
    } else t1 = $[1];
    const { replyToCommentId: replyToCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)(t1);
    const { foundComment: foundComment, parentComment: parentComment } = data;
    let t2;
    bb0: if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
        if (!data.commentError && !data.commentLoading && foundComment) {
            const location = foundComment.location ?? undefined;
            const pid = foundComment.parentId;
            const parentLocation = pid && !data.parentError && !data.parentLoading && parentComment ? parentComment.location ?? undefined : undefined;
            if (!pid || parentComment) {
                let t3;
                if ($[2] !== location || $[3] !== parentLocation || $[4] !== pid) {
                    t3 = {
                        location: location,
                        parentId: pid,
                        parentLocation: parentLocation
                    };
                    $[2] = location;
                    $[3] = parentLocation;
                    $[4] = pid;
                    $[5] = t3;
                } else t3 = $[5];
                t2 = t3;
                break bb0;
            }
        }
        t2 = undefined;
    } else {
        if (!data.legacyError && !data.legacyLoading && data.legacyData) {
            const node = data.legacyData?.comments?.nodes?.[0];
            const location_0 = node?.location ?? undefined;
            const pid_0 = node?.parentId;
            const parentLocation_0 = node?.ancestors?.[0]?.location ?? undefined;
            let t3;
            if ($[6] !== location_0 || $[7] !== parentLocation_0 || $[8] !== pid_0) {
                t3 = {
                    location: location_0,
                    parentId: pid_0,
                    parentLocation: parentLocation_0
                };
                $[6] = location_0;
                $[7] = parentLocation_0;
                $[8] = pid_0;
                $[9] = t3;
            } else t3 = $[9];
            t2 = t3;
            break bb0;
        }
        t2 = undefined;
    }
    const queryParamData = t2;
    let t3;
    if ($[10] !== queryParamData) {
        t3 = queryParamData || {};
        $[10] = queryParamData;
        $[11] = t3;
    } else t3 = $[11];
    const { location: loc, parentLocation: pLoc } = t3;
    let t4;
    if ($[12] !== loc || $[13] !== pLoc?.inlineMarkerRef || $[14] !== pLoc?.inlineResolveProperties?.resolved) {
        t4 = loc?.inlineMarkerRef ? {
            annotationId: loc.inlineMarkerRef,
            isResolved: Boolean(loc.inlineResolveProperties?.resolved)
        } : {
            annotationId: pLoc?.inlineMarkerRef,
            isResolved: Boolean(pLoc?.inlineResolveProperties?.resolved)
        };
        $[12] = loc;
        $[13] = pLoc?.inlineMarkerRef;
        $[14] = pLoc?.inlineResolveProperties?.resolved;
        $[15] = t4;
    } else t4 = $[15];
    const queryParamDataExt = t4;
    let t5;
    if ($[16] !== data.legacyData?.comments?.nodes?.[0] || $[17] !== foundComment || $[18] !== queryParamDataExt?.annotationId || $[19] !== replyToCommentId || $[20] !== setCurrentlySelectedThreadKey || $[21] !== setReplyToCommentId) {
        t5 = ()=>{
            if (!replyToCommentId) return;
            const rawComment = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? foundComment : data.legacyData?.comments?.nodes?.[0];
            if (rawComment) {
                const annotationId = queryParamDataExt?.annotationId;
                if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
                const author = rawComment?.author;
                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, (0, $9wGTI.fg)("confluence_frontend_content_wrapper")));
            }
        };
        $[16] = data.legacyData?.comments?.nodes?.[0];
        $[17] = foundComment;
        $[18] = queryParamDataExt?.annotationId;
        $[19] = replyToCommentId;
        $[20] = setCurrentlySelectedThreadKey;
        $[21] = setReplyToCommentId;
        $[22] = t5;
    } else t5 = $[22];
    const onReplyToCommentReady = t5;
    let t6;
    if ($[23] !== commentId || $[24] !== queryParamData?.parentId || $[25] !== queryParamDataExt?.annotationId) {
        t6 = ()=>$4d5518b698c93929$var$tryToFocusAndScrollActiveComment({
                parentId: queryParamData?.parentId,
                annotationId: queryParamDataExt?.annotationId || null,
                commentId: commentId || null
            });
        $[23] = commentId;
        $[24] = queryParamData?.parentId;
        $[25] = queryParamDataExt?.annotationId;
        $[26] = t6;
    } else t6 = $[26];
    const tryToFocusAndScrollActiveCommentCallback = t6;
    const t7 = !commentId || !queryParamData || queryParamDataExt.isResolved;
    let t8;
    if ($[27] !== rendererRef || $[28] !== t7 || $[29] !== tryToFocusAndScrollActiveCommentCallback) {
        t8 = {
            callback: tryToFocusAndScrollActiveCommentCallback,
            elementRef: rendererRef,
            skip: t7
        };
        $[27] = rendererRef;
        $[28] = t7;
        $[29] = tryToFocusAndScrollActiveCommentCallback;
        $[30] = t8;
    } else t8 = $[30];
    (0, $1ZGYV.useRetryOnMutation)(t8);
    let t9;
    if ($[31] !== commentId || $[32] !== isCommentNotFound || $[33] !== onReplyToCommentReady || $[34] !== queryParamData || $[35] !== queryParamDataExt || $[36] !== rendererActions || $[37] !== setCommentContainerToFocus || $[38] !== setCurrentlySelectedThreadKey || $[39] !== showCommentsPanel) {
        t9 = ()=>{
            if (!queryParamData || hasHandledCommentLink.current) return;
            const { location: location_1 } = queryParamData;
            const { annotationId: annotationId_0 } = queryParamDataExt;
            if (location_1) {
                if (queryParamDataExt.isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    if (annotationId_0) {
                        setCurrentlySelectedThreadKey(annotationId_0, (0, $8i27m.CommentType).INLINE);
                        setCommentContainerToFocus(commentId ?? undefined);
                    }
                }
            } else {
                if ((0, $6mKj3.expValEquals)("confluence_comment_improve_comment_deeplink", "isEnabled", true)) {
                    if (!rendererActions || annotationId_0 && isCommentNotFound === undefined) return;
                }
                if (!rendererActions && (0, $6mKj3.expValEquals)("confluence_comment_improve_comment_deeplink", "isEnabled", true)) return;
                const annotationExists = rendererActions?.getAnnotationMarks()?.some((mark)=>mark.attrs?.id === annotationId_0);
                if (annotationId_0 && !annotationExists && (0, $9wGTI.fg)("confluence_frontend_new_dangling_comments_ux")) {
                    setCurrentlySelectedThreadKey(annotationId_0, (0, $8i27m.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true) && onReplyToCommentReady();
                }
                hasHandledCommentLink.current = true;
            }
        };
        $[31] = commentId;
        $[32] = isCommentNotFound;
        $[33] = onReplyToCommentReady;
        $[34] = queryParamData;
        $[35] = queryParamDataExt;
        $[36] = rendererActions;
        $[37] = setCommentContainerToFocus;
        $[38] = setCurrentlySelectedThreadKey;
        $[39] = showCommentsPanel;
        $[40] = t9;
    } else t9 = $[40];
    let t10;
    if ($[41] !== commentId || $[42] !== isCommentNotFound || $[43] !== onReplyToCommentReady || $[44] !== orderedActiveAnnotationIdList || $[45] !== queryParamData || $[46] !== queryParamDataExt || $[47] !== rendererActions || $[48] !== setCommentContainerToFocus || $[49] !== setCurrentlySelectedThreadKey || $[50] !== showCommentsPanel) {
        t10 = [
            queryParamData,
            rendererActions,
            orderedActiveAnnotationIdList,
            queryParamDataExt,
            showCommentsPanel,
            setCurrentlySelectedThreadKey,
            setCommentContainerToFocus,
            commentId,
            isCommentNotFound,
            onReplyToCommentReady
        ];
        $[41] = commentId;
        $[42] = isCommentNotFound;
        $[43] = onReplyToCommentReady;
        $[44] = orderedActiveAnnotationIdList;
        $[45] = queryParamData;
        $[46] = queryParamDataExt;
        $[47] = rendererActions;
        $[48] = setCommentContainerToFocus;
        $[49] = setCurrentlySelectedThreadKey;
        $[50] = showCommentsPanel;
        $[51] = t10;
    } else t10 = $[51];
    (0, $42omo.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[52] !== commentId || $[53] !== flags || $[54] !== isCommentNotFound) {
        t11 = ()=>{
            if (isCommentNotFound) flags.showWarningFlag({
                id: `viewpage-comment-link-not-found-${commentId}`,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
            });
        };
        t12 = [
            commentId,
            flags,
            isCommentNotFound
        ];
        $[52] = commentId;
        $[53] = flags;
        $[54] = isCommentNotFound;
        $[55] = t11;
        $[56] = t12;
    } else {
        t11 = $[55];
        t12 = $[56];
    }
    (0, $42omo.useEffect)(t11, t12);
    return null;
} : ({ commentId: commentId, isArchived: isArchived, rendererRef: rendererRef, flags: flags, data: data })=>{
    const hasHandledCommentLink = (0, $42omo.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const { replyToCommentId: replyToCommentId, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)({
        queryArchivedContent: isArchived
    });
    const { foundComment: foundComment, isResolved: _ignored, parentComment: parentComment } = data;
    const queryParamData = (0, $42omo.useMemo)(()=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            if (!data.commentError && !data.commentLoading && foundComment) {
                const location = foundComment.location ?? undefined;
                const pid = foundComment.parentId;
                const parentLocation = pid && !data.parentError && !data.parentLoading && parentComment ? parentComment.location ?? undefined : undefined;
                if (!pid || parentComment) return {
                    location: location,
                    parentId: pid,
                    parentLocation: parentLocation
                };
            }
            return undefined;
        } else {
            if (!data.legacyError && !data.legacyLoading && data.legacyData) {
                const node = data.legacyData?.comments?.nodes?.[0];
                const location_0 = node?.location ?? undefined;
                const pid_0 = node?.parentId;
                const parentLocation_0 = node?.ancestors?.[0]?.location ?? undefined;
                return {
                    location: location_0,
                    parentId: pid_0,
                    parentLocation: parentLocation_0
                };
            }
            return undefined;
        }
    }, [
        data.commentError,
        data.commentLoading,
        foundComment,
        data.parentError,
        data.parentLoading,
        parentComment,
        data.legacyData,
        data.legacyError,
        data.legacyLoading
    ]);
    const queryParamDataExt = (0, $42omo.useMemo)(()=>{
        const { location: loc, parentLocation: pLoc } = queryParamData || {};
        return loc?.inlineMarkerRef ? {
            annotationId: loc.inlineMarkerRef,
            isResolved: Boolean(loc.inlineResolveProperties?.resolved)
        } : {
            annotationId: pLoc?.inlineMarkerRef,
            isResolved: Boolean(pLoc?.inlineResolveProperties?.resolved)
        };
    }, [
        queryParamData
    ]);
    const onReplyToCommentReady = (0, $42omo.useCallback)(()=>{
        if (!replyToCommentId) return;
        const rawComment = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment : data.legacyData?.comments?.nodes?.[0];
        if (rawComment) {
            const annotationId = queryParamDataExt?.annotationId;
            if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
            const author = rawComment?.author;
            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        }
    }, [
        replyToCommentId,
        foundComment,
        data.legacyData,
        queryParamDataExt,
        setReplyToCommentId,
        setCurrentlySelectedThreadKey
    ]);
    const tryToFocusAndScrollActiveCommentCallback = (0, $42omo.useCallback)(()=>{
        return $4d5518b698c93929$var$tryToFocusAndScrollActiveComment({
            parentId: queryParamData?.parentId,
            annotationId: queryParamDataExt?.annotationId || null,
            commentId: commentId || null
        });
    }, [
        queryParamData,
        queryParamDataExt,
        commentId
    ]);
    (0, $1ZGYV.useRetryOnMutation)({
        callback: tryToFocusAndScrollActiveCommentCallback,
        elementRef: rendererRef,
        skip: !commentId || !queryParamData || queryParamDataExt.isResolved
    });
    (0, $42omo.useEffect)(()=>{
        if (!queryParamData || hasHandledCommentLink.current) return;
        const { location: location_1 } = queryParamData;
        const { annotationId: annotationId_0 } = queryParamDataExt;
        if (location_1) {
            if (queryParamDataExt.isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (annotationId_0) {
                    setCurrentlySelectedThreadKey(annotationId_0, (0, $8i27m.CommentType).INLINE);
                    setCommentContainerToFocus(commentId ?? undefined);
                }
            }
        } else {
            if ((0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) {
                if (!rendererActions || annotationId_0 && isCommentNotFound === undefined) return;
            }
            if (!rendererActions && (0, $6mKj3.expValEquals)('confluence_comment_improve_comment_deeplink', 'isEnabled', true)) return;
            const annotationExists = rendererActions?.getAnnotationMarks()?.some((mark)=>mark.attrs?.id === annotationId_0);
            if (annotationId_0 && !annotationExists && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                setCurrentlySelectedThreadKey(annotationId_0, (0, $8i27m.CommentType).INLINE);
                setCommentContainerToFocus(commentId ?? undefined);
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
            }
            hasHandledCommentLink.current = true;
        }
    }, [
        queryParamData,
        rendererActions,
        orderedActiveAnnotationIdList,
        queryParamDataExt,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        setCommentContainerToFocus,
        commentId,
        isCommentNotFound,
        onReplyToCommentReady
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isCommentNotFound) flags.showWarningFlag({
            id: `viewpage-comment-link-not-found-${commentId}`,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4d5518b698c93929$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
        });
    }, [
        commentId,
        flags,
        isCommentNotFound
    ]);
    return null;
};
// Helper (kept private — only used by InlineCommentHandler)
const $4d5518b698c93929$var$tryToFocusAndScrollActiveComment = ({ parentId: parentId, annotationId: annotationId, commentId: commentId })=>{
    const mark = document.querySelector(`[data-id="${annotationId}"]`);
    if (mark) {
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        if (focusedMarkerRef?.id !== annotationId) {
            const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
            (0, $aHcFH.checkElementExpand)(mark, true);
            emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId
                ],
                eventTarget: mark
            });
        }
        if (commentId) {
            const success = (0, $9FoVw.handleDeepLinkNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                block: 'center',
                markElement: mark,
                commentId: commentId
            });
            if (!success) {
                (0, $4u5NT.abortAll)('new_interaction', 'focused-comment-scroll');
                (0, $aHcFH.scrollToElementWithViewingRoom)({
                    element: mark,
                    useInstantScroll: true
                });
            }
        } else if (!parentId) {
            (0, $4u5NT.abortAll)('new_interaction', 'focused-comment-scroll');
            (0, $aHcFH.scrollToElementWithViewingRoom)({
                element: mark,
                useInstantScroll: true
            });
        }
    }
    return !!mark;
};
const $4d5518b698c93929$var$ObjectCommentHandler = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(57);
    const { commentId: commentId, focusedCommentId: focusedCommentId, replyToComment: replyToComment, hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments, data: data } = t0;
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $42omo.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $42omo.useState)(false);
    const mutationObserverRef = (0, $42omo.useRef)(null);
    const scrollTimeoutRef = (0, $42omo.useRef)(null);
    const lastMutationTimeRef = (0, $42omo.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (scrollTimeoutRef.current !== null) {
                if (typeof scrollTimeoutRef.current === "number") {
                    if (typeof window !== "undefined" && "cancelIdleCallback" in window) window.cancelIdleCallback(scrollTimeoutRef.current);
                } else clearTimeout(scrollTimeoutRef.current);
                scrollTimeoutRef.current = null;
            }
        };
        $[0] = t1;
    } else t1 = $[0];
    const clearScrollTimeout = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (mutationObserverRef.current) {
                mutationObserverRef.current.disconnect();
                mutationObserverRef.current = null;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const cleanupMutationObserver = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (mutationObserverRef.current) cleanupMutationObserver();
            if (scrollTimeoutRef.current !== null) clearScrollTimeout();
        };
        $[2] = t3;
    } else t3 = $[2];
    const cleanupScrollResources = t3;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const { commentsDataMap: commentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { isResolved: isResolved, parentId: parentId, rawCommentForReply: rawCommentForReply, foundComment: foundComment, legacyData: legacyData, commentError: commentError } = data;
    let t4;
    if ($[3] !== allObjectCommentsRendered || $[4] !== commentError || $[5] !== commentId || $[6] !== commentsDataMap || $[7] !== data.legacyError || $[8] !== focusedCommentId || $[9] !== foundComment || $[10] !== hasLoadedObjectComments || $[11] !== hasScrolledToFocusedComment || $[12] !== hasScrolledToReplyComment || $[13] !== isResolved || $[14] !== legacyData || $[15] !== parentId || $[16] !== processedCommentsData || $[17] !== rawCommentForReply || $[18] !== replyToComment || $[19] !== setCurrentlySelectedThreadKey || $[20] !== setReplyToCommentId || $[21] !== showCommentsPanel) {
        t4 = ()=>{
            const hasData = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? foundComment && !commentError : legacyData && !data.legacyError;
            if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                let rootCommentId;
                if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                    if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId)?.id;
                } else {
                    const legacyFooterComments = Object.values(commentsDataMap.general);
                    if (legacyFooterComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments, parentId)?.id;
                }
                if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
            }
            if (hasData && commentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_queryparam_selection", "isEnabled", true)) {
                const loc = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? foundComment?.location : legacyData?.comments?.nodes?.[0]?.location;
                if (loc && "type" in loc && loc.type === "INLINE") return;
            }
            if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
                if (isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    setCurrentlySelectedThreadKey(commentId, (0, $8i27m.CommentType).GENERAL);
                    if (focusedCommentId) setHasScrolledToFocusedComment(true);
                    else setHasScrolledToReplyComment(true);
                } else {
                    const commentElementId = `footer-comment-thread-${commentId}-container`;
                    const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                    let threadToBeSelected = commentId;
                    if (parentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                        let rootCommentId_0;
                        if ((0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false)) {
                            if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId)?.id;
                        } else {
                            const legacyFooterComments_0 = Object.values(commentsDataMap.general);
                            if (legacyFooterComments_0.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments_0, parentId)?.id;
                        }
                        threadToBeSelected = rootCommentId_0 ?? parentId;
                    }
                    if (commentId) {
                        if ((0, $6mKj3.expValEquals)("confluence_comment_deeplink_delay_scroll", "isEnabled", true)) {
                            if (replyToComment) {
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                const author = rawCommentForReply?.author;
                                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true)));
                                setHasScrolledToReplyComment(true);
                                return;
                            }
                            cleanupMutationObserver();
                            const getDocumentScrollHeight = $4d5518b698c93929$var$_temp;
                            const scrollToComment = ()=>{
                                const el = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (el && (0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) getDocumentScrollHeight();
                                (0, $9FoVw.handleFooterCommentsNavigation)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                cleanupMutationObserver();
                            };
                            const performScrollAndCleanup = ()=>{
                                clearScrollTimeout();
                                if ((0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) requestAnimationFrame(()=>requestAnimationFrame(scrollToComment));
                                else scrollToComment();
                            };
                            const checkHeightStabilityThenScroll = ()=>{
                                if (!(0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) {
                                    performScrollAndCleanup();
                                    return;
                                }
                                const h1 = getDocumentScrollHeight();
                                scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    const h2 = getDocumentScrollHeight();
                                    if (h1 === h2) performScrollAndCleanup();
                                    else scheduleScroll();
                                }, $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS);
                            };
                            const scheduleScroll = ()=>{
                                clearScrollTimeout();
                                lastMutationTimeRef.current = Date.now();
                                if (typeof window !== "undefined" && "requestIdleCallback" in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                    const checkStabilityAndScroll = ()=>{
                                        const timeSince = Date.now() - lastMutationTimeRef.current;
                                        if (timeSince >= $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                        else scrollTimeoutRef.current = setTimeout(()=>{
                                            scrollTimeoutRef.current = null;
                                            checkStabilityAndScroll();
                                        }, $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS - timeSince);
                                    };
                                    checkStabilityAndScroll();
                                });
                                else scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    checkHeightStabilityThenScroll();
                                }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                            };
                            const getElementAndCheckReady = ()=>{
                                const el_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (!el_0) return {
                                    element: null,
                                    isReady: false
                                };
                                const rect = el_0.getBoundingClientRect();
                                return {
                                    element: el_0,
                                    isReady: el_0.offsetHeight > 0 && el_0.offsetWidth > 0 && rect.height > 0 && rect.width > 0
                                };
                            };
                            const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                            if (currentElement && isReady) scheduleScroll();
                            else {
                                mutationObserverRef.current = new MutationObserver(()=>{
                                    lastMutationTimeRef.current = Date.now();
                                    const { element: el_1, isReady: elReady } = getElementAndCheckReady();
                                    if (el_1 && elReady) scheduleScroll();
                                });
                                if (currentElement) {
                                    mutationObserverRef.current.observe(currentElement, {
                                        childList: true,
                                        subtree: true,
                                        attributes: true,
                                        attributeFilter: [
                                            "style",
                                            "class"
                                        ]
                                    });
                                    const parent = currentElement.parentElement;
                                    if (parent) mutationObserverRef.current.observe(parent, {
                                        childList: true,
                                        subtree: true
                                    });
                                } else mutationObserverRef.current.observe(document.body, {
                                    childList: true,
                                    subtree: true
                                });
                                setTimeout(()=>{
                                    if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                                }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                            }
                        } else {
                            const el_2 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (el_2) {
                                (0, $9FoVw.handleFooterCommentsNavigation)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                            }
                        }
                    }
                }
            }
        };
        $[3] = allObjectCommentsRendered;
        $[4] = commentError;
        $[5] = commentId;
        $[6] = commentsDataMap;
        $[7] = data.legacyError;
        $[8] = focusedCommentId;
        $[9] = foundComment;
        $[10] = hasLoadedObjectComments;
        $[11] = hasScrolledToFocusedComment;
        $[12] = hasScrolledToReplyComment;
        $[13] = isResolved;
        $[14] = legacyData;
        $[15] = parentId;
        $[16] = processedCommentsData;
        $[17] = rawCommentForReply;
        $[18] = replyToComment;
        $[19] = setCurrentlySelectedThreadKey;
        $[20] = setReplyToCommentId;
        $[21] = showCommentsPanel;
        $[22] = t4;
    } else t4 = $[22];
    let t5;
    if ($[23] !== allObjectCommentsRendered || $[24] !== commentBatchCount || $[25] !== commentBatchRendered || $[26] !== commentError || $[27] !== commentId || $[28] !== commentsDataMap || $[29] !== data.legacyError || $[30] !== focusedCommentId || $[31] !== foundComment || $[32] !== hasLoadedObjectComments || $[33] !== hasScrolledToFocusedComment || $[34] !== hasScrolledToReplyComment || $[35] !== isResolved || $[36] !== legacyData || $[37] !== parentId || $[38] !== processedCommentsData || $[39] !== rawCommentForReply || $[40] !== replyToComment || $[41] !== setCurrentlySelectedThreadKey || $[42] !== setReplyToCommentId || $[43] !== showCommentsPanel) {
        t5 = [
            legacyData,
            data.legacyError,
            foundComment,
            commentError,
            hasLoadedObjectComments,
            commentId,
            focusedCommentId,
            replyToComment,
            allObjectCommentsRendered,
            commentBatchRendered,
            commentBatchCount,
            setCurrentlySelectedThreadKey,
            setReplyToCommentId,
            isResolved,
            showCommentsPanel,
            hasScrolledToFocusedComment,
            hasScrolledToReplyComment,
            rawCommentForReply,
            parentId,
            processedCommentsData,
            commentsDataMap,
            cleanupScrollResources,
            cleanupMutationObserver,
            clearScrollTimeout
        ];
        $[23] = allObjectCommentsRendered;
        $[24] = commentBatchCount;
        $[25] = commentBatchRendered;
        $[26] = commentError;
        $[27] = commentId;
        $[28] = commentsDataMap;
        $[29] = data.legacyError;
        $[30] = focusedCommentId;
        $[31] = foundComment;
        $[32] = hasLoadedObjectComments;
        $[33] = hasScrolledToFocusedComment;
        $[34] = hasScrolledToReplyComment;
        $[35] = isResolved;
        $[36] = legacyData;
        $[37] = parentId;
        $[38] = processedCommentsData;
        $[39] = rawCommentForReply;
        $[40] = replyToComment;
        $[41] = setCurrentlySelectedThreadKey;
        $[42] = setReplyToCommentId;
        $[43] = showCommentsPanel;
        $[44] = t5;
    } else t5 = $[44];
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setHasScrolledToFocusedComment(false);
            setHasScrolledToReplyComment(false);
            cleanupScrollResources();
        };
        $[45] = t6;
    } else t6 = $[45];
    let t7;
    if ($[46] !== focusedCommentId || $[47] !== replyToComment) {
        t7 = [
            focusedCommentId,
            replyToComment,
            cleanupScrollResources
        ];
        $[46] = focusedCommentId;
        $[47] = replyToComment;
        $[48] = t7;
    } else t7 = $[48];
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>()=>cleanupScrollResources();
        t9 = [
            cleanupScrollResources
        ];
        $[49] = t8;
        $[50] = t9;
    } else {
        t8 = $[49];
        t9 = $[50];
    }
    (0, $42omo.useEffect)(t8, t9);
    let t10;
    let t11;
    if ($[51] !== focusedCommentId || $[52] !== hasLoadedObjectComments || $[53] !== replyToComment || $[54] !== setForceLoadComments) {
        t10 = ()=>{
            if ((focusedCommentId || replyToComment) && !hasLoadedObjectComments) setForceLoadComments(true);
        };
        t11 = [
            focusedCommentId,
            replyToComment,
            hasLoadedObjectComments,
            setForceLoadComments
        ];
        $[51] = focusedCommentId;
        $[52] = hasLoadedObjectComments;
        $[53] = replyToComment;
        $[54] = setForceLoadComments;
        $[55] = t10;
        $[56] = t11;
    } else {
        t10 = $[55];
        t11 = $[56];
    }
    (0, $42omo.useEffect)(t10, t11);
    return null;
} : ({ commentId: commentId, focusedCommentId: focusedCommentId, replyToComment: replyToComment, hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments, data: data })=>{
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $42omo.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $42omo.useState)(false);
    const mutationObserverRef = (0, $42omo.useRef)(null);
    const scrollTimeoutRef = (0, $42omo.useRef)(null);
    const lastMutationTimeRef = (0, $42omo.useRef)(0);
    const clearScrollTimeout = (0, $42omo.useCallback)(()=>{
        if (scrollTimeoutRef.current !== null) {
            if (typeof scrollTimeoutRef.current === 'number') {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window) window.cancelIdleCallback(scrollTimeoutRef.current);
            } else clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
        }
    }, []);
    const cleanupMutationObserver = (0, $42omo.useCallback)(()=>{
        if (mutationObserverRef.current) {
            mutationObserverRef.current.disconnect();
            mutationObserverRef.current = null;
        }
    }, []);
    const cleanupScrollResources = (0, $42omo.useCallback)(()=>{
        if (mutationObserverRef.current) cleanupMutationObserver();
        if (scrollTimeoutRef.current !== null) clearScrollTimeout();
    }, [
        cleanupMutationObserver,
        clearScrollTimeout
    ]);
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const { commentsDataMap: commentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { isResolved: isResolved, parentId: parentId, rawCommentForReply: rawCommentForReply, foundComment: foundComment, legacyData: legacyData, commentError: commentError } = data;
    // Update currentlySelectedThreadKey to root comment for replies (after scroll)
    (0, $42omo.useEffect)(()=>{
        const hasData = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment && !commentError : legacyData && !data.legacyError;
        if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
            let rootCommentId;
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId)?.id;
            } else {
                const legacyFooterComments = Object.values(commentsDataMap.general);
                if (legacyFooterComments.length > 0) rootCommentId = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments, parentId)?.id;
            }
            if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
        }
        // Early return if this is actually an INLINE comment — handled by InlineCommentHandler
        if (hasData && commentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_queryparam_selection', 'isEnabled', true)) {
            const loc = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment?.location : legacyData?.comments?.nodes?.[0]?.location;
            if (loc && 'type' in loc && loc.type === 'INLINE') return;
        }
        if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                setCurrentlySelectedThreadKey(commentId, (0, $8i27m.CommentType).GENERAL);
                if (focusedCommentId) setHasScrolledToFocusedComment(true);
                else setHasScrolledToReplyComment(true);
            } else {
                const commentElementId = `footer-comment-thread-${commentId}-container`;
                const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                let threadToBeSelected = commentId;
                if (parentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
                    let rootCommentId_0;
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (processedCommentsData.isDataProcessed && processedCommentsData.allComments.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(processedCommentsData.allComments, parentId)?.id;
                    } else {
                        const legacyFooterComments_0 = Object.values(commentsDataMap.general);
                        if (legacyFooterComments_0.length > 0) rootCommentId_0 = (0, $kgNLQ.findRootCommentForReply)(legacyFooterComments_0, parentId)?.id;
                    }
                    threadToBeSelected = rootCommentId_0 ?? parentId;
                }
                if (commentId) {
                    if ((0, $6mKj3.expValEquals)('confluence_comment_deeplink_delay_scroll', 'isEnabled', true)) {
                        if (replyToComment) {
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            const author = rawCommentForReply?.author;
                            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true)));
                            setHasScrolledToReplyComment(true);
                            return;
                        }
                        cleanupMutationObserver();
                        const getDocumentScrollHeight = ()=>Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
                        const scrollToComment = ()=>{
                            const el = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (el && (0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                el.offsetTop;
                                getDocumentScrollHeight();
                            }
                            (0, $9FoVw.handleFooterCommentsNavigation)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            cleanupMutationObserver();
                        };
                        const performScrollAndCleanup = ()=>{
                            clearScrollTimeout();
                            if ((0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) requestAnimationFrame(()=>requestAnimationFrame(scrollToComment));
                            else scrollToComment();
                        };
                        const checkHeightStabilityThenScroll = ()=>{
                            if (!(0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                performScrollAndCleanup();
                                return;
                            }
                            const h1 = getDocumentScrollHeight();
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                const h2 = getDocumentScrollHeight();
                                if (h1 === h2) performScrollAndCleanup();
                                else scheduleScroll();
                            }, $4d5518b698c93929$var$HEIGHT_STABILITY_CHECK_MS);
                        };
                        const scheduleScroll = ()=>{
                            clearScrollTimeout();
                            lastMutationTimeRef.current = Date.now();
                            if (typeof window !== 'undefined' && 'requestIdleCallback' in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                const checkStabilityAndScroll = ()=>{
                                    const timeSince = Date.now() - lastMutationTimeRef.current;
                                    if (timeSince >= $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                    else scrollTimeoutRef.current = setTimeout(()=>{
                                        scrollTimeoutRef.current = null;
                                        checkStabilityAndScroll();
                                    }, $4d5518b698c93929$var$PAGE_STABILITY_DELAY_MS - timeSince);
                                };
                                checkStabilityAndScroll();
                            });
                            else scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                checkHeightStabilityThenScroll();
                            }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                        };
                        const getElementAndCheckReady = ()=>{
                            const el_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (!el_0) return {
                                element: null,
                                isReady: false
                            };
                            const rect = el_0.getBoundingClientRect();
                            return {
                                element: el_0,
                                isReady: el_0.offsetHeight > 0 && el_0.offsetWidth > 0 && rect.height > 0 && rect.width > 0
                            };
                        };
                        const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                        if (currentElement && isReady) scheduleScroll();
                        else {
                            mutationObserverRef.current = new MutationObserver(()=>{
                                lastMutationTimeRef.current = Date.now();
                                const { element: el_1, isReady: elReady } = getElementAndCheckReady();
                                if (el_1 && elReady) scheduleScroll();
                            });
                            if (currentElement) {
                                mutationObserverRef.current.observe(currentElement, {
                                    childList: true,
                                    subtree: true,
                                    attributes: true,
                                    attributeFilter: [
                                        'style',
                                        'class'
                                    ]
                                });
                                const parent = currentElement.parentElement;
                                if (parent) mutationObserverRef.current.observe(parent, {
                                    childList: true,
                                    subtree: true
                                });
                            } else mutationObserverRef.current.observe(document.body, {
                                childList: true,
                                subtree: true
                            });
                            setTimeout(()=>{
                                if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                            }, $4d5518b698c93929$var$SCROLL_TIMEOUT_MS);
                        }
                    } else {
                        const el_2 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                        if (el_2) {
                            (0, $9FoVw.handleFooterCommentsNavigation)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                        }
                    }
                }
            }
        }
    }, [
        legacyData,
        data.legacyError,
        foundComment,
        commentError,
        hasLoadedObjectComments,
        commentId,
        focusedCommentId,
        replyToComment,
        allObjectCommentsRendered,
        commentBatchRendered,
        commentBatchCount,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        isResolved,
        showCommentsPanel,
        hasScrolledToFocusedComment,
        hasScrolledToReplyComment,
        rawCommentForReply,
        parentId,
        processedCommentsData,
        commentsDataMap,
        cleanupScrollResources,
        cleanupMutationObserver,
        clearScrollTimeout
    ]);
    (0, $42omo.useEffect)(()=>{
        setHasScrolledToFocusedComment(false);
        setHasScrolledToReplyComment(false);
        cleanupScrollResources();
    }, [
        focusedCommentId,
        replyToComment,
        cleanupScrollResources
    ]);
    (0, $42omo.useEffect)(()=>()=>cleanupScrollResources(), [
        cleanupScrollResources
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((focusedCommentId || replyToComment) && !hasLoadedObjectComments) setForceLoadComments(true);
    }, [
        focusedCommentId,
        replyToComment,
        hasLoadedObjectComments,
        setForceLoadComments
    ]);
    return null;
};
const $4d5518b698c93929$export$c21fa150171418d7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { isArchived: t1, rendererRef: rendererRef, hasLoadedObjectComments: t2, allObjectCommentsRendered: t3, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments, flags: flags } = t0;
    const isArchived = t1 === undefined ? false : t1;
    const hasLoadedObjectComments = t2 === undefined ? false : t2;
    const allObjectCommentsRendered = t3 === undefined ? false : t3;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t4;
    if ($[0] !== isArchived) {
        t4 = {
            queryArchivedContent: isArchived
        };
        $[0] = isArchived;
        $[1] = t4;
    } else t4 = $[1];
    const { focusedCommentId: inlineFocusedId, replyToCommentId: replyToCommentId, editCommentId: editCommentId } = (0, $liGyh.useInlineCommentQueryParams)(t4);
    const focusedCommentIdQP = $4d5518b698c93929$var$useFocusedCommentIdQueryParam();
    const replyToCommentQP = $4d5518b698c93929$var$useReplyToCommentQueryParam();
    const commentId = inlineFocusedId || replyToCommentId || editCommentId || focusedCommentIdQP || replyToCommentQP;
    let t5;
    if ($[2] !== commentId || $[3] !== contentId) {
        t5 = {
            commentId: commentId,
            contentId: contentId
        };
        $[2] = commentId;
        $[3] = contentId;
        $[4] = t5;
    } else t5 = $[4];
    const sharedData = $4d5518b698c93929$var$useCommentQueryParamsData(t5);
    const commentLocationType = (0, $6mKj3.expVal)("cc_comments_new_comments_data_manager", "isEnabled", false) ? sharedData.foundComment?.location?.type : sharedData.legacyData?.comments?.nodes?.[0]?.location?.type;
    const isInlineComment = !commentLocationType || commentLocationType === "INLINE";
    if (isInlineComment && rendererRef) {
        let t6;
        if ($[5] !== commentId || $[6] !== flags || $[7] !== isArchived || $[8] !== rendererRef || $[9] !== sharedData) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d5518b698c93929$var$InlineCommentHandler, {
                commentId: commentId,
                isArchived: isArchived,
                rendererRef: rendererRef,
                flags: flags,
                data: sharedData
            });
            $[5] = commentId;
            $[6] = flags;
            $[7] = isArchived;
            $[8] = rendererRef;
            $[9] = sharedData;
            $[10] = t6;
        } else t6 = $[10];
        return t6;
    }
    if (!isInlineComment && setForceLoadComments) {
        const t6 = focusedCommentIdQP || inlineFocusedId;
        const t7 = replyToCommentQP || replyToCommentId;
        let t8;
        if ($[11] !== allObjectCommentsRendered || $[12] !== commentBatchCount || $[13] !== commentBatchRendered || $[14] !== commentId || $[15] !== hasLoadedObjectComments || $[16] !== setForceLoadComments || $[17] !== sharedData || $[18] !== t6 || $[19] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d5518b698c93929$var$ObjectCommentHandler, {
                commentId: commentId,
                focusedCommentId: t6,
                replyToComment: t7,
                hasLoadedObjectComments: hasLoadedObjectComments,
                allObjectCommentsRendered: allObjectCommentsRendered,
                commentBatchRendered: commentBatchRendered,
                commentBatchCount: commentBatchCount,
                setForceLoadComments: setForceLoadComments,
                data: sharedData
            });
            $[11] = allObjectCommentsRendered;
            $[12] = commentBatchCount;
            $[13] = commentBatchRendered;
            $[14] = commentId;
            $[15] = hasLoadedObjectComments;
            $[16] = setForceLoadComments;
            $[17] = sharedData;
            $[18] = t6;
            $[19] = t7;
            $[20] = t8;
        } else t8 = $[20];
        return t8;
    }
    return null;
} : ({ isArchived: isArchived = false, rendererRef: rendererRef, hasLoadedObjectComments: hasLoadedObjectComments = false, allObjectCommentsRendered: allObjectCommentsRendered = false, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount, setForceLoadComments: setForceLoadComments, flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // Inline query params (used for InlineCommentHandler + shared commentId)
    const { focusedCommentId: inlineFocusedId, replyToCommentId: replyToCommentId, editCommentId: editCommentId } = (0, $liGyh.useInlineCommentQueryParams)({
        queryArchivedContent: isArchived
    });
    // Object query params
    const focusedCommentIdQP = $4d5518b698c93929$var$useFocusedCommentIdQueryParam();
    const replyToCommentQP = $4d5518b698c93929$var$useReplyToCommentQueryParam();
    // Unified commentId: prefer inline params, fall back to object params
    const commentId = inlineFocusedId || replyToCommentId || editCommentId || focusedCommentIdQP || replyToCommentQP;
    // Single shared data fetch — one query for all comment types
    const sharedData = $4d5518b698c93929$var$useCommentQueryParamsData({
        commentId: commentId,
        contentId: contentId
    });
    // Determine comment type from data (new or old flow)
    const commentLocationType = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? sharedData.foundComment?.location?.type : sharedData.legacyData?.comments?.nodes?.[0]?.location?.type;
    // Treat undefined (not yet loaded) as INLINE to satisfy InlineCommentHandler
    // which handles the "not found" case. Once loaded, route based on actual type.
    const isInlineComment = !commentLocationType || commentLocationType === 'INLINE';
    if (isInlineComment && rendererRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d5518b698c93929$var$InlineCommentHandler, {
        commentId: commentId,
        isArchived: isArchived,
        rendererRef: rendererRef,
        flags: flags,
        data: sharedData
    });
    if (!isInlineComment && setForceLoadComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d5518b698c93929$var$ObjectCommentHandler, {
        commentId: commentId,
        focusedCommentId: focusedCommentIdQP || inlineFocusedId,
        replyToComment: replyToCommentQP || replyToCommentId,
        hasLoadedObjectComments: hasLoadedObjectComments,
        allObjectCommentsRendered: allObjectCommentsRendered,
        commentBatchRendered: commentBatchRendered,
        commentBatchCount: commentBatchCount,
        setForceLoadComments: setForceLoadComments,
        data: sharedData
    });
    return null;
};
const $4d5518b698c93929$export$d7e13e4fc19ecc08 = (0, $7aRa9.withFlags)($4d5518b698c93929$export$c21fa150171418d7);
function $4d5518b698c93929$var$_temp() {
    return Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
}
module.exports["CommentQueryParamsListener"] = $4d5518b698c93929$export$d7e13e4fc19ecc08;

});

parcelRegister("wwjAh", function(module, exports) {
/**
 * @generated SignedSource<<007593166bedea6758f6841be57669be>>
 * @relayHash 5b529092e8e7cf6e323eeab66137e3bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c229ae6e5818fbecf2bb0804d73eba2602d664fa5e34d0c1a4ba786d8eaa39f8
const $8a780169bce82353$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "resolved"
        }
    ], v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": v10 /*: any*/ 
            }
        ],
        "type": "InlineComment"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": v10 /*: any*/ 
            }
        ],
        "type": "FooterComment"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentQueryParamsListenerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentQueryParamsListenerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5b529092e8e7cf6e323eeab66137e3bd",
            "id": "c229ae6e5818fbecf2bb0804d73eba2602d664fa5e34d0c1a4ba786d8eaa39f8",
            "metadata": {},
            "name": "CommentQueryParamsListenerQuery",
            "operationKind": "query",
            "text": "query CommentQueryParamsListenerQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,parentId,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}},...on FooterComment{commentResolveProperties{resolved}}},ancestors{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}}}}}"
        }
    };
}();
$8a780169bce82353$var$node.hash = "d0febae7f259d56d6f03c22fbaa80801";
var $8a780169bce82353$export$2e2bcd8739ae039 = $8a780169bce82353$var$node;
module.exports["default"] = $8a780169bce82353$export$2e2bcd8739ae039;

});

parcelRegister("1ZGYV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION = 20000;
const $b6108840e0d320f3$var$USER_INTERACTION_EVENTS = [
    'mousedown',
    'keydown',
    'wheel',
    'touchstart'
];
const $b6108840e0d320f3$export$544875121493f258 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { callback: callback, elementRef: elementRef, skip: skip } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const stopObserverCallbacks = (0, $42omo.useRef)(t1);
    const mutationEndTimer = (0, $42omo.useRef)(0);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (_reason)=>{
            stopObserverCallbacks.current.forEach($b6108840e0d320f3$var$_temp);
            stopObserverCallbacks.current = [];
            if (mutationEndTimer.current !== 0) {
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = 0;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const stopMonitoring = t2;
    let t3;
    if ($[2] !== callback || $[3] !== elementRef) {
        t3 = ()=>{
            if (!stopObserverCallbacks.current.length && elementRef?.current) {
                const mutationObserver = new MutationObserver(()=>{
                    window.clearTimeout(mutationEndTimer.current);
                    mutationEndTimer.current = window.setTimeout(()=>{
                        stopMonitoring("Deep link target never found");
                    }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                    if (callback()) stopMonitoring("Callback succeeded");
                });
                mutationObserver.observe(elementRef.current, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true
                });
                stopObserverCallbacks.current.push(()=>{
                    mutationObserver.disconnect();
                });
                $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                    const userInteractionHandler = ()=>stopMonitoring("User interaction");
                    window.addEventListener(name, userInteractionHandler, true);
                    stopObserverCallbacks.current.push(()=>{
                        window.removeEventListener(name, userInteractionHandler, true);
                    });
                });
            }
        };
        $[2] = callback;
        $[3] = elementRef;
        $[4] = t3;
    } else t3 = $[4];
    const startMonitoring = t3;
    let t4;
    let t5;
    if ($[5] !== callback || $[6] !== elementRef || $[7] !== skip || $[8] !== startMonitoring) {
        t4 = ()=>{
            if (skip || !elementRef?.current) return;
            if (callback()) return;
            startMonitoring();
            return ()=>{
                stopMonitoring("Canceled by unmount");
            };
        };
        t5 = [
            elementRef,
            callback,
            skip,
            startMonitoring,
            stopMonitoring
        ];
        $[5] = callback;
        $[6] = elementRef;
        $[7] = skip;
        $[8] = startMonitoring;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $42omo.useEffect)(t4, t5);
} : ({ callback: callback, elementRef: elementRef, skip: skip })=>{
    const stopObserverCallbacks = (0, $42omo.useRef)([]);
    const mutationEndTimer = (0, $42omo.useRef)(0);
    const stopMonitoring = (0, $42omo.useCallback)((_reason)=>{
        stopObserverCallbacks.current.forEach((stop)=>{
            stop();
        });
        stopObserverCallbacks.current = [];
        if (mutationEndTimer.current !== 0) {
            window.clearTimeout(mutationEndTimer.current);
            mutationEndTimer.current = 0;
        }
    }, []);
    const startMonitoring = (0, $42omo.useCallback)(()=>{
        if (!stopObserverCallbacks.current.length && elementRef?.current) {
            const mutationObserver = new MutationObserver(()=>{
                // Every time there's a change, restart the timer that ends watching for mutations
                // (keep the observer going until changes stop for a while).
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = window.setTimeout(()=>{
                    // De-bouncing ended. Timeout finally running, time to stop observing and trying to follow the anchor
                    stopMonitoring('Deep link target never found');
                }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                if (callback()) // If the callback succeeded, stop monitoring
                stopMonitoring('Callback succeeded');
            });
            mutationObserver.observe(elementRef.current, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true
            });
            stopObserverCallbacks.current.push(()=>{
                mutationObserver.disconnect();
            });
            // Listen for user interaction to end checking for changes
            $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                const userInteractionHandler = ()=>stopMonitoring('User interaction');
                window.addEventListener(name, userInteractionHandler, true);
                stopObserverCallbacks.current.push(()=>{
                    window.removeEventListener(name, userInteractionHandler, true);
                });
            });
        }
    }, [
        elementRef,
        callback,
        stopMonitoring
    ]);
    (0, $42omo.useEffect)(()=>{
        // Do nothing if skip is true or the elementRef is not set.
        if (skip || !elementRef?.current) return;
        // Try right away in case the page has already settled and there are no mutations to observe.
        if (callback()) return;
        // Watch for changes to the page and call the callback whenever one occurs.
        startMonitoring();
        return ()=>{
            stopMonitoring('Canceled by unmount');
        };
    }, [
        elementRef,
        callback,
        skip,
        startMonitoring,
        stopMonitoring
    ]);
};
function $b6108840e0d320f3$var$_temp(stop) {
    stop();
}
module.exports["useRetryOnMutation"] = $b6108840e0d320f3$export$544875121493f258;

});

parcelRegister("jFm04", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $drEG9 = parcelRequire("drEG9");

const $30c826ecad02059a$var$ContentOwnershipContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isModalOpen: false,
    openModal: ()=>{
    /* no-op */ },
    closeModal: ()=>{
    /* no-op */ }
});
const $30c826ecad02059a$export$22f379f031a59eaa = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [returnFocusRef, setReturnFocusRef] = (0, $42omo.useState)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (args)=>{
            setIsModalOpen(true);
            if (args?.returnFocusRef) setReturnFocusRef(args.returnFocusRef);
        };
        $[0] = t1;
    } else t1 = $[0];
    const openModal = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsModalOpen(false);
        $[1] = t2;
    } else t2 = $[1];
    const closeModal = t2;
    let t3;
    if ($[2] !== isModalOpen) {
        t3 = {
            isModalOpen: isModalOpen,
            openModal: openModal,
            closeModal: closeModal
        };
        $[2] = isModalOpen;
        $[3] = t3;
    } else t3 = $[3];
    const contentOwnershipContextValue = t3;
    let t4;
    if ($[4] !== returnFocusRef) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $drEG9.ContentOwnershipDialog), {
            shouldReturnFocusRef: returnFocusRef
        });
        $[4] = returnFocusRef;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== children || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, t4);
        $[6] = children;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== contentOwnershipContextValue || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($30c826ecad02059a$var$ContentOwnershipContext.Provider, {
            value: contentOwnershipContextValue
        }, t5);
        $[9] = contentOwnershipContextValue;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ children: children })=>{
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [returnFocusRef, setReturnFocusRef] = (0, $42omo.useState)();
    const openModal = (0, $42omo.useCallback)((args)=>{
        setIsModalOpen(true);
        if (args?.returnFocusRef) setReturnFocusRef(args.returnFocusRef);
    }, []);
    const closeModal = (0, $42omo.useCallback)(()=>setIsModalOpen(false), []);
    const contentOwnershipContextValue = (0, $42omo.useMemo)(()=>({
            isModalOpen: isModalOpen,
            openModal: openModal,
            closeModal: closeModal
        }), [
        isModalOpen,
        openModal,
        closeModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($30c826ecad02059a$var$ContentOwnershipContext.Provider, {
        value: contentOwnershipContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $drEG9.ContentOwnershipDialog), {
        shouldReturnFocusRef: returnFocusRef
    })));
};
const $30c826ecad02059a$export$e047c3e72baa9533 = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($30c826ecad02059a$export$22f379f031a59eaa, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
const $30c826ecad02059a$export$1e71db018b220386 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($30c826ecad02059a$var$ContentOwnershipContext);
} : ()=>{
    return (0, $42omo.useContext)($30c826ecad02059a$var$ContentOwnershipContext);
};
const $30c826ecad02059a$export$d8bfa07cf352465c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    const context = $30c826ecad02059a$export$1e71db018b220386();
    let t1;
    if ($[0] !== children || $[1] !== context) {
        t1 = children(context);
        $[0] = children;
        $[1] = context;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const context = $30c826ecad02059a$export$1e71db018b220386();
    return children(context);
};
module.exports["ContentOwnershipContextProvider"] = $30c826ecad02059a$export$22f379f031a59eaa;
module.exports["withContentOwnershipContextProvider"] = $30c826ecad02059a$export$e047c3e72baa9533;
module.exports["useContentOwnershipContext"] = $30c826ecad02059a$export$1e71db018b220386;
module.exports["ContentOwnershipContextConsumer"] = $30c826ecad02059a$export$d8bfa07cf352465c;

});

parcelRegister("drEG9", function(module, exports) {

var $g4Nt4 = parcelRequire("g4Nt4");


var $22ahU = parcelRequire("22ahU");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $esRft = parcelRequire("esRft");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $eEA8O = parcelRequire("eEA8O");


var $inPa6 = parcelRequire("inPa6");


var $3jwuS = parcelRequire("3jwuS");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $ep3mz = parcelRequire("ep3mz");


var $7aRa9 = parcelRequire("7aRa9");


var $lsxnT = parcelRequire("lsxnT");


var $iquRY = parcelRequire("iquRY");


var $i28ZW = parcelRequire("i28ZW");


var $kuujH = parcelRequire("kuujH");


var $aNtZv = parcelRequire("aNtZv");


var $2E1L5 = parcelRequire("2E1L5");


var $7Ss3J = parcelRequire("7Ss3J");


var $jFm04 = parcelRequire("jFm04");


var $gbOP8 = parcelRequire("gbOP8");


var $aUYRy = parcelRequire("aUYRy");


var $68BwE = parcelRequire("68BwE");


var $c9As2 = parcelRequire("c9As2");


var $5k5SG = parcelRequire("5k5SG");


var $jMyy4 = parcelRequire("jMyy4");


var $86okN = parcelRequire("86okN");


var $6s78L = parcelRequire("6s78L");

const $d47aff8da3f39616$var$ContentOwnershipDialogRefetchOnMutationQuery = (0, $22ahU.default);
const $d47aff8da3f39616$var$ContentOwnershipDialogContentOwnerHistoryQuery = (0, $g4Nt4.default);
const $d47aff8da3f39616$var$currentOwnerContainer = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $d47aff8da3f39616$var$photoAndNameContainer = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 'space.200'
});
const $d47aff8da3f39616$var$nameContainer = (0, $ecnYn.xcss)({
    marginLeft: 'space.075'
});
const $d47aff8da3f39616$var$ContentOwnershipDialogComponent = ({ flags: flags, shouldReturnFocusRef: shouldReturnFocusRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const intl = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [selectedUser, setSelectedUser] = (0, $42omo.useState)(undefined);
    const [currentOwner, setCurrentOwner] = (0, $42omo.useState)(undefined);
    const [isRequestInFlight, setIsRequestInFlight] = (0, $42omo.useState)(false);
    const [showConfirmModal, setShowConfirmModal] = (0, $42omo.useState)(false);
    const [restrictions, setRestrictions] = (0, $42omo.useState)({
        isUserRestricted: false,
        isSpaceRestricted: false,
        isParentPageRestricted: false,
        isEditPageRestricted: false
    });
    const { closeModal: closeModal } = (0, $jFm04.useContentOwnershipContext)();
    const isAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const { canManageContent: canManageContent, loading: isLoadingSpaceManagementOperations } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey
    });
    const canBypassConfirmModal = isRbacEnabled ? canManageContent : isAdmin;
    const { data: data } = (0, $jMyy4.useQueryInterop)($d47aff8da3f39616$var$ContentOwnershipDialogContentOwnerHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    (0, $42omo.useEffect)(()=>{
        if (!data) return;
        let ownerId;
        const ownerData = data?.singleContent?.history?.ownedBy;
        if (ownerData && 'accountId' in ownerData) ownerId = ownerData.accountId ?? undefined;
        const owner = {
            fullName: ownerData?.displayName ?? undefined,
            avatarUrl: ownerData?.profilePicture?.path ?? undefined,
            id: ownerId
        };
        setCurrentOwner(owner);
    }, [
        data
    ]);
    (0, $42omo.useEffect)(()=>{
        const { isUserRestricted: isUserRestricted, isSpaceRestricted: isSpaceRestricted, isParentPageRestricted: isParentPageRestricted } = restrictions;
        if (isUserRestricted || isSpaceRestricted || isParentPageRestricted) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'changeErrorPermissionWarning',
                actionSubject: 'content.owner',
                source: 'changeOwnerModal',
                attributes: {
                    ...restrictions,
                    contentId: contentId,
                    isAdmin: isAdmin,
                    contentType: contentType
                }
            }
        }).fire();
    }, [
        restrictions,
        createAnalyticsEvent,
        contentId,
        isAdmin,
        contentType
    ]);
    const resetRestrictions = ()=>{
        setRestrictions({
            isUserRestricted: false,
            isSpaceRestricted: false,
            isParentPageRestricted: false,
            isEditPageRestricted: false
        });
    };
    const handleShowConfirmModal = (0, $42omo.useCallback)(()=>{
        setShowConfirmModal(true);
    }, []);
    const handleHideConfirmModal = (0, $42omo.useCallback)(()=>{
        setShowConfirmModal(false);
    }, []);
    // TODO: The user picker itself doesn't seem to get cleared
    const handleClearSelectedUser = (0, $42omo.useCallback)(()=>{
        setSelectedUser(undefined);
        resetRestrictions();
    }, []);
    const handleSelectUser = (0, $42omo.useCallback)(async (user)=>{
        setIsRequestInFlight(true);
        setSelectedUser(user);
        const newRestrictions = await (0, $68BwE.checkIsUserRestricted)(contentId, user.id);
        if (newRestrictions) setRestrictions(newRestrictions);
        else resetRestrictions();
        setIsRequestInFlight(false);
    }, [
        contentId
    ]);
    const tryUpdateOwner = (0, $42omo.useCallback)(async ()=>{
        try {
            experienceTracker.start({
                name: (0, $irVI7.CHANGE_PAGE_OWNER_EXPERIENCE)
            });
            setIsRequestInFlight(true);
            const newOwnerId = selectedUser.id;
            try {
                const mutationResult = await (0, $6s78L.mutateInterop)({
                    mutation: (0, $7Ss3J.UpdateOwnerMutation),
                    variables: {
                        contentId: contentId,
                        ownerId: newOwnerId
                    },
                    refetchQueries: [
                        {
                            query: (0, $86okN.toDocumentNode)($d47aff8da3f39616$var$ContentOwnershipDialogRefetchOnMutationQuery),
                            variables: {
                                contentId: contentId
                            }
                        },
                        {
                            query: (0, $86okN.toDocumentNode)($d47aff8da3f39616$var$ContentOwnershipDialogContentOwnerHistoryQuery),
                            variables: {
                                contentId: contentId
                            }
                        }
                    ]
                });
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'changeSuccess',
                        actionSubject: 'content.owner',
                        source: 'changeOwnerModal',
                        attributes: {
                            contentId: contentId,
                            isAdmin: isAdmin,
                            isLivePage: isLivePage,
                            contentType: contentType
                        }
                    }
                }).fire();
                experienceTracker.succeed({
                    name: (0, $irVI7.CHANGE_PAGE_OWNER_EXPERIENCE)
                });
                closeModal();
                flags.showSuccessFlag({
                    id: 'content-ownership-dialog-update-owner-success',
                    title: intl.formatMessage((0, $kuujH.i18n).successFlagMessage, {
                        user: mutationResult?.data?.updateOwner?.content?.history?.ownedBy?.displayName
                    }),
                    isAutoDismiss: true
                });
            } catch (error) {
                // if the attempt to update owner fails due to
                // new owner lacking page view / edit permissions
                if (error.message.includes((0, $2E1L5.EXPECTED_ERROR_MESSAGES).USER_MISSING_PAGE_PERMISSION)) {
                    experienceTracker.abort({
                        name: (0, $irVI7.CHANGE_PAGE_OWNER_EXPERIENCE),
                        reason: 'New owner does not have view/edit permission on the page'
                    });
                    setRestrictions({
                        ...restrictions,
                        isUserRestricted: true
                    });
                } else experienceTracker.fail({
                    name: (0, $irVI7.CHANGE_PAGE_OWNER_EXPERIENCE),
                    error: error
                });
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'changeError',
                        actionSubject: 'content.owner',
                        source: 'changeOwnerModal',
                        attributes: {
                            ...error,
                            contentId: contentId,
                            isAdmin: isAdmin,
                            isLivePage: isLivePage,
                            contentType: contentType
                        }
                    }
                }).fire();
                flags.showErrorFlag({
                    id: 'content-ownership-dialog-update-owner-failed',
                    title: intl.formatMessage((0, $kuujH.i18n).errorFlagMessage),
                    isAutoDismiss: true
                });
            }
        } finally{
            setIsRequestInFlight(false);
        }
    }, [
        selectedUser,
        contentId,
        closeModal,
        restrictions,
        createAnalyticsEvent,
        isAdmin,
        experienceTracker,
        isLivePage,
        flags,
        intl,
        contentType
    ]);
    const handleConfirmChange = (0, $42omo.useCallback)(async ()=>{
        setShowConfirmModal(false);
        await tryUpdateOwner();
    }, [
        tryUpdateOwner
    ]);
    const onChangeButtonHandler = (0, $42omo.useMemo)(()=>{
        return canBypassConfirmModal ? tryUpdateOwner : handleShowConfirmModal;
    }, [
        canBypassConfirmModal,
        tryUpdateOwner,
        handleShowConfirmModal
    ]);
    if (!spaceKey || !contentId) return null;
    if (!currentOwner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        testId: "content-owner-modal",
        onClose: closeModal,
        messageType: "transactional",
        messageId: "content-ownership-modal",
        shouldReturnFocus: shouldReturnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, intl.formatMessage((0, $kuujH.i18n).modalTitleEnabledForAllContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModal,
        label: intl.formatMessage((0, $kuujH.i18n).closeModal)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d47aff8da3f39616$var$currentOwnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.ModalLabel), null, intl.formatMessage((0, $kuujH.i18n).modalCurrentOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d47aff8da3f39616$var$photoAndNameContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: currentOwner?.avatarUrl,
        name: currentOwner?.fullName,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d47aff8da3f39616$var$nameContainer,
        as: "span"
    }, currentOwner?.fullName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.ModalLabel), null, intl.formatMessage((0, $kuujH.i18n).modalBodyEnabledForAllContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gbOP8.ContentOwnershipDialogUserPicker), {
        selectedUser: selectedUser,
        onSelectUser: handleSelectUser,
        onClearSelectedUser: handleClearSelectedUser,
        spaceKey: spaceKey,
        contentId: contentId,
        currentOwner: currentOwner
    }), restrictions.isUserRestricted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aUYRy.ContentOwnershipPermissionWarning), {
        isParentPageRestriction: restrictions.isParentPageRestricted,
        isEditPageRestricted: restrictions.isEditPageRestricted,
        contentId: contentId,
        isSpaceRestricted: restrictions.isSpaceRestricted,
        selectedUser: selectedUser,
        resetRestrictions: resetRestrictions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.FlexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: closeModal
    }, intl.formatMessage((0, $kuujH.i18n).modalCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "content-owner-modal-update-owner-button",
        appearance: "primary",
        onClick: onChangeButtonHandler,
        isDisabled: !selectedUser || restrictions.isUserRestricted || isRequestInFlight || isLoadingSpaceRoleMode || isLoadingSpaceManagementOperations
    }, intl.formatMessage((0, $kuujH.i18n).modalChangeOwner))))), showConfirmModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9As2.ChangeOwnerConfirmationModal), {
        onCancel: handleHideConfirmModal,
        onConfirm: handleConfirmChange,
        currentOwner: currentOwner,
        newOwner: {
            fullName: selectedUser.name,
            avatarUrl: selectedUser.avatarUrl,
            id: selectedUser.id
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE),
        attributes: {
            contentType: contentType,
            isLivePage: isLivePage
        }
    }));
};
const $d47aff8da3f39616$export$c4b58737fceb9315 = (0, $7aRa9.withFlags)(({ flags: flags, shouldReturnFocusRef: shouldReturnFocusRef })=>{
    const { isModalOpen: isModalOpen } = (0, $jFm04.useContentOwnershipContext)();
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d47aff8da3f39616$var$ContentOwnershipDialogComponent, {
        flags: flags,
        shouldReturnFocusRef: shouldReturnFocusRef
    });
});
module.exports["ContentOwnershipDialog"] = $d47aff8da3f39616$export$c4b58737fceb9315;

});

parcelRegister("g4Nt4", function(module, exports) {
/**
 * @generated SignedSource<<8a609b80d6b85f37325b4b4f6de00a68>>
 * @relayHash d8d0a0c3773fb5614142ae8976c19503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2970b60e100eb92685e942d12759081a5851051628a93c78cf86833ab7f7f73
const $b42be9987d281f35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnershipDialogContentOwnerHistoryQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v8 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v8 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnershipDialogContentOwnerHistoryQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d8d0a0c3773fb5614142ae8976c19503",
            "id": "b2970b60e100eb92685e942d12759081a5851051628a93c78cf86833ab7f7f73",
            "metadata": {},
            "name": "ContentOwnershipDialogContentOwnerHistoryQuery",
            "operationKind": "query",
            "text": "query ContentOwnershipDialogContentOwnerHistoryQuery($contentId:ID!){singleContent(id:$contentId){id,history{createdDate,createdBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}}"
        }
    };
}();
$b42be9987d281f35$var$node.hash = "e2c8f3dd7349e4f2eeb6723084505460";
var $b42be9987d281f35$export$2e2bcd8739ae039 = $b42be9987d281f35$var$node;
module.exports["default"] = $b42be9987d281f35$export$2e2bcd8739ae039;

});

parcelRegister("22ahU", function(module, exports) {
/**
 * @generated SignedSource<<ac84d180d5b594c7163918f01f9799d7>>
 * @relayHash 15c4d5cd83724d2c377e03e67f0401a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04f1e2e12365470f1a82e7ad525acea578598fdcf526eb7c64d848b023824aba
const $79e030b4bb95f75a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isOwnerContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnershipDialogRefetchOnMutationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnershipDialogRefetchOnMutationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "15c4d5cd83724d2c377e03e67f0401a0",
            "id": "04f1e2e12365470f1a82e7ad525acea578598fdcf526eb7c64d848b023824aba",
            "metadata": {},
            "name": "ContentOwnershipDialogRefetchOnMutationQuery",
            "operationKind": "query",
            "text": "query ContentOwnershipDialogRefetchOnMutationQuery($contentId:ID!){contentContributors(id:$contentId){isOwnerContributor}}"
        }
    };
}();
$79e030b4bb95f75a$var$node.hash = "3c1d5e334c9e0f12e92785d43b19032c";
var $79e030b4bb95f75a$export$2e2bcd8739ae039 = $79e030b4bb95f75a$var$node;
module.exports["default"] = $79e030b4bb95f75a$export$2e2bcd8739ae039;

});

parcelRegister("iquRY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), t0);
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<312885e46175f1caad2e8c88a205c3bc>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("i28ZW", function(module, exports) {

var $i0mmi = parcelRequire("i0mmi");


var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");


var $jMyy4 = parcelRequire("jMyy4");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $i0mmi.default);
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled;
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    });
    const hasSpaceOperation = (0, $42omo.useCallback)((spaceOperation)=>{
        return data?.space?.operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
    }, [
        data
    ]);
    return {
        canManageSomeUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4) || hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149) || hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: hasSpaceOperation($981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: hasSpaceOperation($981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: hasSpaceOperation($981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: hasSpaceOperation($981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: hasSpaceOperation($981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: hasSpaceOperation($981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: hasSpaceOperation($981a614bc39b93a3$export$92f9e1ed9114d3a6),
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("i0mmi", function(module, exports) {
/**
 * @generated SignedSource<<538ddf86109b083feb03880ace3dfe2d>>
 * @relayHash 0a3dc9cecca8233daf01e0443fdaa5e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471
const $7dc84e66153faa36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0a3dc9cecca8233daf01e0443fdaa5e6",
            "id": "1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471",
            "metadata": {},
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "operationKind": "query",
            "text": "query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin},operations{operation,targetType}}}"
        }
    };
}();
$7dc84e66153faa36$var$node.hash = "4d967e32f567d3367490b1d8fb6f1ecf";
var $7dc84e66153faa36$export$2e2bcd8739ae039 = $7dc84e66153faa36$var$node;
module.exports["default"] = $7dc84e66153faa36$export$2e2bcd8739ae039;

});

parcelRegister("kuujH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");

const $5f4da457b317160c$var$i18nBase = (0, $aXWIB.defineMessages)({
    modalTitleEnabledForAllContent: {
        id: "content-ownership.content-header.owner-modal.title-enabled-for-all-content",
        defaultMessage: "Change owner"
    },
    modalBodyEnabledForAllContent: {
        id: "content-ownership.content-header.owner-modal.body-enabled-for-all-content",
        defaultMessage: "Choose a new owner"
    },
    modalCurrentOwner: {
        id: "content-ownership.content-header.owner-modal.current-owner",
        defaultMessage: "Current owner"
    },
    modalCancel: {
        id: "content-ownership.content-header.owner-modal.cancel-button",
        defaultMessage: "Cancel"
    },
    modalChangeOwner: {
        id: "content-ownership.content-header.owner-modal.change-owner-button",
        defaultMessage: "Change owner"
    },
    confirmModalTitle: {
        id: "content-ownership.content-header.confirm-owner-modal.title",
        defaultMessage: "Confirm this ownership transfer?"
    },
    confirmModalBody: {
        id: "content-ownership.content-header.confirm-owner-modal.body",
        defaultMessage: "Once you transfer ownership of this content, only an admin or the new owner can reverse it. <button>Learn more</button>"
    },
    confirmModalCancel: {
        id: "content-ownership.content-header.confirm-owner-modal.cancel-button",
        defaultMessage: "Cancel"
    },
    confirmModalConfirmChangeOwner: {
        id: "content-ownership.content-header.confirm-owner-modal.confirm-change-owner-button",
        defaultMessage: "Continue"
    },
    confirmModalCurrentOwner: {
        id: "content-ownership.content-header.confirm-owner-modal.current-owner",
        defaultMessage: "Current owner"
    },
    confirmModalNewOwner: {
        id: "content-ownership.content-header.confirm-owner-modal.new-owner",
        defaultMessage: "New owner"
    },
    bylineButtonTooltip: {
        id: "content-ownership.byline-button.tooltip",
        defaultMessage: "Manage ownership"
    },
    bylineButtonTooltipReadOnly: {
        id: "content-ownership.byline-button.tooltip.read.only",
        defaultMessage: "More details"
    },
    popupTriggerLabel: {
        id: "content-ownership.byline-popup.trigger-label",
        defaultMessage: "Manage ownership"
    },
    popupChangeOwnerButton: {
        id: "content-ownership.byline-popup.change-owner-button",
        defaultMessage: "Change owner"
    },
    popupCreatedBy: {
        id: "content-ownership.byline-popup.created-by",
        defaultMessage: "Created by <b>{user}</b> on {date}"
    },
    popupCreatedByUnknownDate: {
        id: "content-ownership.byline-popup.created-by.unknown-date",
        defaultMessage: "Created by <b>{user}</b> on unknown date"
    },
    popupLastOwnedBy: {
        id: "content-ownership.byline-popup.last-owned-by",
        defaultMessage: "Last owned by <b>{user}</b>"
    },
    changeWarningTitle: {
        id: "content-ownership.change-warning-dialog.title",
        defaultMessage: "This change can\u2019t be reversed"
    },
    changeWarningBody: {
        id: "content-ownership.change-warning-dialog.body",
        defaultMessage: "Once you transfer ownership to someone else, you won\u2019t be able to reverse it."
    },
    changeWarningCancel: {
        id: "content-ownership.change-warning-dialog.cancel-button",
        defaultMessage: "Cancel"
    },
    changeWarningContinue: {
        id: "content-ownership.change-warning-dialog.continue-button",
        defaultMessage: "Continue"
    },
    bylineMainText: {
        id: "content-ownership.byline.main-text",
        defaultMessage: "Owned by {user}"
    },
    abbreviatedBylineMainText: {
        id: "content-ownership.byline.abbreviated-main-text",
        defaultMessage: "By {user}"
    },
    bylineMainTextCreatedByConfluence: {
        id: "content-ownership.byline.main-text.created-by-confluence",
        defaultMessage: "Owned by {user}, created by Confluence"
    },
    abbreviatedBylineOwnerMessage: {
        id: "content-ownership.byline.abbreviated-owner-message",
        defaultMessage: "Owner"
    },
    bylineMainTextWithTemplate: {
        id: "content-ownership.byline.main-text.with-template",
        defaultMessage: "Owned by {user}, created {withTemplate}"
    },
    ownerWithContributorsDropdownTooltip: {
        id: "content-ownership.byline.owner-with-contributors-dropdown.tooltip",
        defaultMessage: "View owner and contributors"
    },
    ownerRestrictionTitle: {
        id: "content-ownership.owner.restriction.title",
        defaultMessage: "This person doesn\u2019t have edit access"
    },
    ownerRestrictionMessage: {
        id: "content-ownership.owner.restriction.message",
        defaultMessage: "To grant them ownership, you must first give them edit access to this content."
    },
    manageRestrictionButton: {
        id: "content-ownership.manage.restriction.button",
        defaultMessage: "Manage access"
    },
    ownerParentPageRestrictionTitle: {
        id: "content-ownership.owner.parent.page.restriction.title",
        defaultMessage: "This person doesn\u2019t have edit access to this content and/or its parent."
    },
    ownerParentPageRestrictionMessage: {
        id: "content-ownership.owner.parent.page.restriction.message",
        defaultMessage: "To grant them ownership, you must provide them edit access to this and any necessary parent items."
    },
    manageParentPageRestrictionButton: {
        id: "content-ownership.manage.parent.page.restriction.button",
        defaultMessage: "Learn more"
    },
    ownerPremiumRestrictionTitle: {
        id: "content-ownership.owner.premium.restriction.title",
        defaultMessage: "This person doesn\u2019t have access to this content and/or parent content."
    },
    ownerPremiumRestrictionMessage: {
        id: "content-ownership.owner.premium.restriction.message",
        defaultMessage: "To grant them ownership, you must provide them edit access to this and any other necessary parent items."
    },
    managePremiumRestrictionButton: {
        id: "content-ownership.manage.premium.restriction.button",
        defaultMessage: "Inspect permissions"
    },
    ownerSpaceRestrictionTitle: {
        id: "content-ownership.owner.space.restriction.title",
        defaultMessage: "This person doesn\u2019t have access to this space"
    },
    ownerSpaceRestrictionMessage: {
        id: "content-ownership.owner.space.restriction.message",
        defaultMessage: "In order to grant them ownership, they must have access to this space."
    },
    manageSpaceRestrictionButton: {
        id: "content-ownership.manage.space.restriction.button",
        defaultMessage: "Contact space admins"
    },
    manageSpaceRestrictionButtonAdmin: {
        id: "content-ownership.manage.space.restriction.button.admin",
        defaultMessage: "Manage space permissions"
    },
    changeOwnerSpotlightTitle: {
        id: "content-ownership.change-owner.spotlight.title",
        defaultMessage: "Change who owns a page"
    },
    changeOwnerSpotlightBody: {
        id: "content-ownership.change-owner.spotlight.body",
        defaultMessage: "You (or your admin) can now transfer ownership of content to someone else."
    },
    changeOwnerSpotlightLearnMoreButton: {
        id: "content-ownership.change-owner.spotlight.learn-more-button",
        defaultMessage: "Learn more"
    },
    changeOwnerSpotlightOkButton: {
        id: "content-ownership.change-owner.spotlight.ok-button",
        defaultMessage: "OK"
    },
    requestSpacePermissionAdminEmailSubject: {
        id: "content-ownership.mailto.subject.space",
        defaultMessage: "[Confluence] A Confluence user needs space access"
    },
    requestSpacePermissionAdminEmailBody: {
        id: "content-ownership.mailto.body.space",
        defaultMessage: "Hi,%0D%0A%0D%0AI have someone who needs access to a space, but neither of us can change their access level. Can you take a look?%0D%0A%0D%0AThanks!%0D%0A{currentUser}%0D%0A%0D%0AUser who needs access:%0D%0A{requestedUser}%0D%0A%0D%0ALink to permissions for space \u201C{spaceName}\u201D:%0D%0A{spacePermissionsUrl}%0D%0A%0D%0ALink to content \u201C{pageTitle}\u201D:%0D%0A{pageUrl}"
    },
    successFlagMessage: {
        id: "content-ownership.change-owner.success-flag-message",
        defaultMessage: "Ownership transferred to {user}"
    },
    errorFlagMessage: {
        id: "content-ownership.change-owner.error-flag-message",
        defaultMessage: "Failed to transfer ownership"
    },
    closeModal: {
        id: "content-ownership.change-owner.close-modal-label",
        defaultMessage: "Close modal"
    },
    ownershipTransfer: {
        id: "content-ownership.ownership-transfer.arrow-right-icon",
        defaultMessage: "Ownership Transfer"
    },
    poweredByTemplates: {
        id: "content-ownership.powered-by-templates.byline.text",
        defaultMessage: "with a template"
    }
});
const $5f4da457b317160c$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    changeOwnerSpotlightTitle: {
        id: "content-ownership.change-owner.spotlight.title.livedocs",
        defaultMessage: "Change who owns a page or live doc"
    }
});
const $5f4da457b317160c$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($5f4da457b317160c$var$i18nBase, $5f4da457b317160c$var$i18nLiveDocs);
module.exports["i18n"] = $5f4da457b317160c$export$a7357cdd1f0b0168;

});

parcelRegister("aNtZv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $b6c0eda6d78c2bc7$export$824219d997137766 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q71917 _2rkofajl _1yt4pxbi _1e0c1txw _19pkpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71917 _2rkofajl _1yt4pxbi _1e0c1txw _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8vqg6",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8vqg6",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$ecf8022a0b2d321f = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0pxbi _k48pwu06",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0pxbi _k48pwu06",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$b1a401d0eced3e7 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2lx21bp4 _11lvze3t _fl8bpxbi _1br9ze3t _pm7ize3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx21bp4 _11lvze3t _fl8bpxbi _1br9ze3t _pm7ize3t",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$7196851310a3d0bf = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "input" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19itglyw _4t3iidpf _1bsbidpf _nt751r31 _49pcglyw _1hvw1o36 _1ohhglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _4t3iidpf _1bsbidpf _nt751r31 _49pcglyw _1hvw1o36 _1ohhglyw",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$124d4c7bf7db9715 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1bsb1osq _oteh12x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1bsb1osq _oteh12x7",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$d25f95f50a0dfdf9 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_80omtlke _1bsbf6fq _1e0c1txw _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80omtlke _1bsbf6fq _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$69d5845bfe8a4fe9 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$3901cdc3044f6691 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2hwxv77o _15tynkob",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwxv77o _15tynkob",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$7b991bc77107aa2a = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4v47k _bfhkvuon _19pkv47k _1e0c1txw _4cvr1h6o _1bahitcz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4v47k _bfhkvuon _19pkv47k _1e0c1txw _4cvr1h6o _1bahitcz",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$b02238f37d00229c = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlbs82 _1o9zkb7n _i0dlf1ug _1e0c1txw _p12f1jje _1bah1h6o _1wpz1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlbs82 _1o9zkb7n _i0dlf1ug _1e0c1txw _p12f1jje _1bah1h6o _1wpz1y6m",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$351d4cd765ab9ea2 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u012x7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$7fa76b0a88544135 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$36dbc8eb54fc2b77 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _k48p1wq8 _syazi7uo _p12f5rga",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _k48p1wq8 _syazi7uo _p12f5rga",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4pxbi _y3gnv2br _1bsb1gwv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _y3gnv2br _1bsb1gwv",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$f006f5b646fd98c5 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4ze3t _syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4ze3t _syazi7uo",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$ad4d708bacf4d87d = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pk1ejb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$6a67697a421197fe = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41lhn _4t3i1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41lhn _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$6748052329e9b21a = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$8434332cb9a91069 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _kqswstnw _1pbyxnxo _1ltvmofv _154i1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _kqswstnw _1pbyxnxo _1ltvmofv _154i1ul9",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$ba1d1c438cc57586 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syaz15cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syaz15cr",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$54e8379445658073 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3ildb6 _1e0c1txw _4cvr1h6o _1wpz1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3ildb6 _1e0c1txw _4cvr1h6o _1wpz1y6m",
            __cmplp.className
        ])
    });
});
const $b6c0eda6d78c2bc7$export$6316ca01164c199e = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _syazazsu _k48p1pd9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu _k48p1pd9",
            __cmplp.className
        ])
    });
});
module.exports["PermissionWarningContainer"] = $b6c0eda6d78c2bc7$export$824219d997137766;
module.exports["Text"] = $b6c0eda6d78c2bc7$export$5f1af8db9871e1d6;
module.exports["TextStrong"] = $b6c0eda6d78c2bc7$export$ecf8022a0b2d321f;
module.exports["FlexColumn"] = $b6c0eda6d78c2bc7$export$b1a401d0eced3e7;
module.exports["Wrapper"] = $b6c0eda6d78c2bc7$export$e6dfd72ab29f8598;
module.exports["FlexContainer"] = $b6c0eda6d78c2bc7$export$124d4c7bf7db9715;
module.exports["BylineContainer"] = $b6c0eda6d78c2bc7$export$69d5845bfe8a4fe9;
module.exports["BylineMessageContainer"] = $b6c0eda6d78c2bc7$export$3901cdc3044f6691;
module.exports["OwnerSwapBackground"] = $b6c0eda6d78c2bc7$export$7b991bc77107aa2a;
module.exports["OwnerSwapIndividualContainer"] = $b6c0eda6d78c2bc7$export$b02238f37d00229c;
module.exports["OwnerSwapIndividualTextContainer"] = $b6c0eda6d78c2bc7$export$351d4cd765ab9ea2;
module.exports["OwnerSwapIndividualTitle"] = $b6c0eda6d78c2bc7$export$7fa76b0a88544135;
module.exports["OwnerSwapIndividualName"] = $b6c0eda6d78c2bc7$export$36dbc8eb54fc2b77;
module.exports["PopupContainer"] = $b6c0eda6d78c2bc7$export$cca08eed9de89ba9;
module.exports["PopupUserDetailsContainer"] = $b6c0eda6d78c2bc7$export$f006f5b646fd98c5;
module.exports["PopupButtonContainer"] = $b6c0eda6d78c2bc7$export$ad4d708bacf4d87d;
module.exports["OwnerSwapArrow"] = $b6c0eda6d78c2bc7$export$6a67697a421197fe;
module.exports["OwnerSwapArrowContainer"] = $b6c0eda6d78c2bc7$export$54e8379445658073;
module.exports["ModalLabel"] = $b6c0eda6d78c2bc7$export$6316ca01164c199e;

});

parcelRegister("2E1L5", function(module, exports) {
const $f1205e6da653ae62$export$16708f74bd486c8 = 'confluence_page_ownership_changeboarding';
const $f1205e6da653ae62$export$9ed1986df73b834a = 'change-page-ownership-link';
const $f1205e6da653ae62$export$21191b0c00ca25f4 = 10;
const $f1205e6da653ae62$export$83728ea2bd792f67 = {
    USER_IS_NULL: 'You cannot set an owner as an anonymous user.',
    USER_NOT_FOUND: 'Owner id is an invalid account id.',
    USER_MISSING_PAGE_PERMISSION: 'New owner must have view and edit permission on the content.',
    CONTENT_ID_INVALID: 'Content id is invalid.',
    INSUFFICIENT_PERMISSIONS: 'You must be the content creator, owner, or a space admin to set the owner.'
};
const $f1205e6da653ae62$export$f0b683cb64dc68b0 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $f1205e6da653ae62$export$b344b39e3835f655 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
const $f1205e6da653ae62$export$7ab4b084abc24ac8 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
module.exports["CONTENT_OWNERSHIP_WEB_ITEM_ID"] = $f1205e6da653ae62$export$9ed1986df73b834a;
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $f1205e6da653ae62$export$21191b0c00ca25f4;
module.exports["EXPECTED_ERROR_MESSAGES"] = $f1205e6da653ae62$export$83728ea2bd792f67;
module.exports["PARENT_PAGE_LEARN_MORE_URL"] = $f1205e6da653ae62$export$f0b683cb64dc68b0;
module.exports["CONFIRM_MODAL_LEARN_MORE_LINK"] = $f1205e6da653ae62$export$7ab4b084abc24ac8;

});

parcelRegister("7Ss3J", function(module, exports) {

var $2bo06 = parcelRequire("2bo06");

const $93d3b821210dc608$export$86698751cb06e71c = (0, $2bo06.default);
module.exports["UpdateOwnerMutation"] = $93d3b821210dc608$export$86698751cb06e71c;

});

parcelRegister("2bo06", function(module, exports) {
/**
 * @generated SignedSource<<9c3f1bd8692b534bcdf596568e1dab4c>>
 * @relayHash cae771a5bdfb0acf2046a85914568a96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8a6a4cb4ee8fb082c4dabb9673b3f9b93f5c5c7d7b80b372753bc4806a167a9
const $119bf30f119f2d5f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "ownerId",
                    "variableName": "ownerId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UpdateOwnerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "UpdateOwnerPayload",
                    "kind": "LinkedField",
                    "name": "updateOwner",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UpdateOwnerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "UpdateOwnerPayload",
                    "kind": "LinkedField",
                    "name": "updateOwner",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "cae771a5bdfb0acf2046a85914568a96",
            "id": "d8a6a4cb4ee8fb082c4dabb9673b3f9b93f5c5c7d7b80b372753bc4806a167a9",
            "metadata": {},
            "name": "UpdateOwnerMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateOwnerMutation($contentId:ID!,$ownerId:String!){updateOwner(input:{contentId:$contentId,ownerId:$ownerId}){content{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}}}"
        }
    };
}();
$119bf30f119f2d5f$var$node.hash = "cdc1ca6586048959e4b974720b0962e3";
var $119bf30f119f2d5f$export$2e2bcd8739ae039 = $119bf30f119f2d5f$var$node;
module.exports["default"] = $119bf30f119f2d5f$export$2e2bcd8739ae039;

});

parcelRegister("gbOP8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $hpRYU = parcelRequire("hpRYU");


var $74Ff0 = parcelRequire("74Ff0");

const $8d0ff9fdc708c8d2$var$userPickerContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.050',
    marginBottom: 'space.250'
});
/**
 * Required to generate the ref used to attach UserPicker's menu onto
 * Copied from next/packages/restrictions/src/RestrictionsDialog/RestrictionsDialogComponent.tsx
 */ const $8d0ff9fdc708c8d2$var$UserPickerRefContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children } = t0;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [refSt, setRefSt] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (current)=>{
            ref.current = current;
            setRefSt(ref.current);
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== refSt) {
        t2 = children(refSt);
        $[1] = children;
        $[2] = refSt;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: t1
        }, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children })=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [refSt, setRefSt] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: (current)=>{
            ref.current = current;
            setRefSt(ref.current);
        }
    }, children(refSt));
};
const $8d0ff9fdc708c8d2$export$c8d398915dca2120 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { selectedUser: selectedUser, onSelectUser: onSelectUser, onClearSelectedUser: onClearSelectedUser, spaceKey: spaceKey, contentId: contentId, currentOwner: currentOwner } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== spaceKey) {
        t1 = {
            contentId: contentId,
            spaceKey: spaceKey
        };
        $[0] = contentId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const bootstrapOptions = (0, $74Ff0.useContentOwnershipContributors)(t1);
    let t2;
    if ($[3] !== currentOwner?.id) {
        t2 = (values)=>{
            const currentOwnerId = currentOwner?.id;
            return currentOwnerId ? values.filter((value)=>value.id !== currentOwnerId) : values;
        };
        $[3] = currentOwner?.id;
        $[4] = t2;
    } else t2 = $[4];
    const userResultsFilter = t2;
    let t3;
    if ($[5] !== bootstrapOptions || $[6] !== onClearSelectedUser || $[7] !== onSelectUser || $[8] !== selectedUser || $[9] !== userResultsFilter) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $8d0ff9fdc708c8d2$var$userPickerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8d0ff9fdc708c8d2$var$UserPickerRefContainer, null, (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
                fieldId: "content.owner",
                value: selectedUser,
                onSelect: onSelectUser,
                onClear: onClearSelectedUser,
                width: "100%",
                isMulti: false,
                includeGroup: false,
                smart: true,
                isClearable: true,
                menuPortalTarget: ref || undefined,
                bootstrapOptions: bootstrapOptions,
                smartFilterOptions: userResultsFilter,
                styles: {
                    menuPortal: $8d0ff9fdc708c8d2$var$_temp
                },
                noOptionsMessage: null
            })));
        $[5] = bootstrapOptions;
        $[6] = onClearSelectedUser;
        $[7] = onSelectUser;
        $[8] = selectedUser;
        $[9] = userResultsFilter;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ selectedUser: selectedUser, onSelectUser: onSelectUser, onClearSelectedUser: onClearSelectedUser, spaceKey: spaceKey, contentId: contentId, currentOwner: currentOwner })=>{
    const bootstrapOptions = (0, $74Ff0.useContentOwnershipContributors)({
        contentId: contentId,
        spaceKey: spaceKey
    });
    // filter user dropdown results to exclude the current page owner
    const userResultsFilter = (values)=>{
        const currentOwnerId = currentOwner?.id;
        return currentOwnerId ? values.filter((value)=>value.id !== currentOwnerId) : values;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8d0ff9fdc708c8d2$var$userPickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8d0ff9fdc708c8d2$var$UserPickerRefContainer, null, (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
            fieldId: "content.owner",
            value: selectedUser,
            onSelect: onSelectUser,
            onClear: onClearSelectedUser,
            width: "100%",
            isMulti: false,
            includeGroup: false,
            smart: true,
            isClearable: true,
            menuPortalTarget: ref || undefined,
            bootstrapOptions: bootstrapOptions,
            smartFilterOptions: userResultsFilter,
            styles: {
                menuPortal: (css)=>({
                        ...css,
                        position: 'absolute',
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        left: 'inherit',
                        // override positional attrs
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: 'inherit'
                    })
            },
            noOptionsMessage: null
        }))));
};
function $8d0ff9fdc708c8d2$var$_temp(css) {
    return {
        ...css,
        position: "absolute",
        left: "inherit",
        top: "inherit"
    };
}
module.exports["ContentOwnershipDialogUserPicker"] = $8d0ff9fdc708c8d2$export$c8d398915dca2120;

});

parcelRegister("74Ff0", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gGK1T = parcelRequire("gGK1T");


var $42omo = parcelRequire("42omo");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $2E1L5 = parcelRequire("2E1L5");


var $68BwE = parcelRequire("68BwE");


var $jMyy4 = parcelRequire("jMyy4");

const $4e0f38e9e07b2bb1$export$d061690dfa4a74b7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [arrangedContributors, setArrangedContributors] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] !== contentId) {
        t2 = {
            variables: {
                contentId: contentId,
                limit: (0, $2E1L5.DEFAULT_CONTRIBUTORS_FETCH_LIMIT)
            }
        };
        $[1] = contentId;
        $[2] = t2;
    } else t2 = $[2];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $gGK1T.default), t2);
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }
    let t3;
    let t4;
    if ($[3] !== data) {
        t3 = ()=>{
            if (data) {
                const contributors = (0, $68BwE.parseContributors)(data);
                setArrangedContributors(contributors);
            }
        };
        t4 = [
            data
        ];
        $[3] = data;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    return arrangedContributors;
} : ({ contentId: contentId })=>{
    const [arrangedContributors, setArrangedContributors] = (0, $42omo.useState)([]);
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $gGK1T.default), {
        variables: {
            contentId: contentId,
            limit: (0, $2E1L5.DEFAULT_CONTRIBUTORS_FETCH_LIMIT)
        }
    });
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    // TODO: add analytics or experience tracking for errors
    }
    (0, $42omo.useEffect)(()=>{
        if (data) {
            const contributors = (0, $68BwE.parseContributors)(data);
            setArrangedContributors(contributors);
        }
    }, [
        data
    ]);
    return arrangedContributors;
};
module.exports["useContentOwnershipContributors"] = $4e0f38e9e07b2bb1$export$d061690dfa4a74b7;

});

parcelRegister("gGK1T", function(module, exports) {
/**
 * @generated SignedSource<<268c7c2d18674f28f9305cae54f3b33e>>
 * @relayHash b8208417e6c09fc98b947c6af794b0f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327
const $edbbfe37cbd0175f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 4,
            "kind": "LocalArgument",
            "name": "limit"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8208417e6c09fc98b947c6af794b0f3",
            "id": "c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327",
            "metadata": {},
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipContributorsContentOwnershipContributorsQuery($contentId:ID!,$limit:Int=4){content(id:$contentId){nodes{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}},contentContributors(id:$contentId,limit:$limit){nodes{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}"
        }
    };
}();
$edbbfe37cbd0175f$var$node.hash = "e8dd42a19657acc23120ab54c46606ff";
var $edbbfe37cbd0175f$export$2e2bcd8739ae039 = $edbbfe37cbd0175f$var$node;
module.exports["default"] = $edbbfe37cbd0175f$export$2e2bcd8739ae039;

});

parcelRegister("68BwE", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");


var $1kHsc = parcelRequire("1kHsc");


var $kuujH = parcelRequire("kuujH");


var $c0rhi = parcelRequire("c0rhi");


var $jA5Yp = parcelRequire("jA5Yp");

const $dd78442dc578dfc5$export$23cea6cd9905a69d = async (contentId, newOwnerId)=>{
    const result = {
        isUserRestricted: false,
        isSpaceRestricted: false,
        isParentPageRestricted: false,
        isEditPageRestricted: false
    };
    if (!contentId) return result;
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $jA5Yp.default),
        variables: {
            contentId: contentId,
            accountId: newOwnerId
        }
    });
    const restrictions = response?.data?.userWithContentRestrictions;
    if (!restrictions) // TODO: Could this happen? What should we do?
    return result;
    const operations = restrictions?.operations ?? [];
    const canEdit = operations.some((operationCheckResult)=>operationCheckResult?.operation === 'update');
    if (!canEdit) {
        // user is restricted on some level
        result.isUserRestricted = true;
        result.isEditPageRestricted = true;
    }
    // if there are space or parent page restrictions,
    // handle updating the warning state correctly
    if (!restrictions.hasSpaceEditPermission || restrictions.restrictingContent?.id) {
        // user is restricted on some level
        result.isUserRestricted = true;
        // check if user can edit in the space
        if (!restrictions.hasSpaceEditPermission) result.isSpaceRestricted = true;
        // check if the user is restricted on any parent content
        if (restrictions.restrictingContent?.id) result.isParentPageRestricted = true;
    }
    return result;
};
const $dd78442dc578dfc5$var$toUserProps = (graphqlUser)=>({
        id: graphqlUser?.accountId,
        name: graphqlUser?.displayName,
        avatarUrl: graphqlUser?.profilePicture?.path
    });
const $dd78442dc578dfc5$export$cb17140916749f02 = (data)=>{
    const content = data?.content?.nodes?.[0];
    const contributors = data?.contentContributors?.nodes?.map($dd78442dc578dfc5$var$toUserProps) || [];
    const lastModifier = $dd78442dc578dfc5$var$toUserProps(content?.version?.by);
    const owner = $dd78442dc578dfc5$var$toUserProps(content?.history?.ownedBy);
    return [
        // Owner is always shown first
        owner,
        // Then the last person to have edited, unless they're also the author
        ...lastModifier.id === owner.id ? [] : [
            lastModifier
        ],
        // Then all the other contributors
        ...contributors.filter(({ id: id })=>id !== owner.id && id !== lastModifier.id)
    ];
};
const $dd78442dc578dfc5$export$7c3fc15730a64f5a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
} : ()=>{
    return (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
};
const $dd78442dc578dfc5$export$36b45599d1b6a619 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
} : ()=>{
    return (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
};
const $dd78442dc578dfc5$export$c14d487d74629ccd = ({ intl: intl, spaceAdmins: spaceAdmins, spacePermissionsUrl: spacePermissionsUrl, spaceKey: spaceKey, contentId: contentId, requestedUser: requestedUser, currentUser: currentUser, pageTitle: pageTitle })=>{
    const spaceAdminsEmailList = spaceAdmins?.filter((admin)=>admin.email)?.map((admin)=>admin.email)?.join(',');
    const subject = intl.formatMessage((0, $kuujH.i18n).requestSpacePermissionAdminEmailSubject);
    const emailBodyProps = {
        spacePermissionsUrl: `${window.location.origin}${spacePermissionsUrl}`,
        requestedUser: requestedUser,
        currentUser: currentUser,
        pageTitle: pageTitle,
        pageUrl: `${window.location.origin}/spaces/${spaceKey}/pages/${contentId}`,
        spaceName: spaceKey
    };
    const body = intl.formatMessage((0, $kuujH.i18n).requestSpacePermissionAdminEmailBody, emailBodyProps);
    return `mailto:${spaceAdminsEmailList}?subject=${subject}&body=${body}`;
};
module.exports["checkIsUserRestricted"] = $dd78442dc578dfc5$export$23cea6cd9905a69d;
module.exports["parseContributors"] = $dd78442dc578dfc5$export$cb17140916749f02;
module.exports["useSPAViewContext"] = $dd78442dc578dfc5$export$7c3fc15730a64f5a;
module.exports["useExperienceTrackerContext"] = $dd78442dc578dfc5$export$36b45599d1b6a619;
module.exports["generateMailtoLink"] = $dd78442dc578dfc5$export$c14d487d74629ccd;

});

parcelRegister("jA5Yp", function(module, exports) {
/**
 * @generated SignedSource<<1a79278214e19f9428173afc13186584>>
 * @relayHash a36706bcb128501a5933a98fbda08020
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 87254643fc40b244325fdfa97a4b56bc6ccf22622fadff5eb337608fbb01d85b
const $d76d7f75124a4530$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "UserWithRestrictions",
            "kind": "LinkedField",
            "name": "userWithContentRestrictions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasSpaceEditPermission"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasSpaceViewPermission"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "restrictingContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "base"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnershipCheckRestrictionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnershipCheckRestrictionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a36706bcb128501a5933a98fbda08020",
            "id": "87254643fc40b244325fdfa97a4b56bc6ccf22622fadff5eb337608fbb01d85b",
            "metadata": {},
            "name": "ContentOwnershipCheckRestrictionsQuery",
            "operationKind": "query",
            "text": "query ContentOwnershipCheckRestrictionsQuery($accountId:String!,$contentId:ID!){userWithContentRestrictions(accountId:$accountId,contentId:$contentId){accountId,hasSpaceEditPermission,hasSpaceViewPermission,restrictingContent{id,links{webui,base}},operations{operation}}}"
        }
    };
}();
$d76d7f75124a4530$var$node.hash = "ee48824a057953005fb24fb90907119a";
var $d76d7f75124a4530$export$2e2bcd8739ae039 = $d76d7f75124a4530$var$node;
module.exports["default"] = $d76d7f75124a4530$export$2e2bcd8739ae039;

});

parcelRegister("aUYRy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $ebrpi = parcelRequire("ebrpi");


var $eEA8O = parcelRequire("eEA8O");


var $erzVD = parcelRequire("erzVD");


var $bVAxT = parcelRequire("bVAxT");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $3P1RK = parcelRequire("3P1RK");


var $ep3mz = parcelRequire("ep3mz");


var $kuujH = parcelRequire("kuujH");


var $aNtZv = parcelRequire("aNtZv");


var $2E1L5 = parcelRequire("2E1L5");


var $5k5SG = parcelRequire("5k5SG");


var $68BwE = parcelRequire("68BwE");


var $gG6gW = parcelRequire("gG6gW");


var $jgcNz = parcelRequire("jgcNz");

const $eed1915733801f58$var$SpaceRestrictionButton = ({ intl: intl, displayName: displayName, contentId: contentId, selectedUser: selectedUser })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    const spacePermissionsUrl = `${(0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
        spaceKey: spaceKey,
        tab: (0, $3P1RK.SpacePermissionsTabKey).Users
    })}`;
    const SpaceAdminRestrictionButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            href: spacePermissionsUrl,
            target: "_blank"
        }, intl.formatMessage((0, $kuujH.i18n).manageSpaceRestrictionButtonAdmin));
    };
    const SpaceUserRestrictionButton = ()=>{
        const spaceAdmins = (0, $gG6gW.useContentOwnershipSpaceAdmins)();
        const { contentTitle: contentTitle } = (0, $jgcNz.useContentInfo)({
            contentId: contentId
        });
        const mailtoLink = (0, $68BwE.generateMailtoLink)({
            intl: intl,
            spaceAdmins: spaceAdmins,
            spacePermissionsUrl: spacePermissionsUrl,
            spaceKey: spaceKey,
            contentId: contentId,
            requestedUser: selectedUser?.name,
            currentUser: displayName,
            pageTitle: contentTitle
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            href: mailtoLink
        }, intl.formatMessage((0, $kuujH.i18n).manageSpaceRestrictionButton));
    };
    return isSpaceOrSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpaceAdminRestrictionButton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpaceUserRestrictionButton, null);
};
const $eed1915733801f58$var$ParentPageRestrictionButton = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { intl: intl, contentId: contentId, isPremium: isPremium } = t0;
    const [showInspectPermissions, setShowInspectPermissions] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== intl || $[1] !== isPremium) {
        t1 = isPremium ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            onClick: ()=>setShowInspectPermissions(true)
        }, intl.formatMessage((0, $kuujH.i18n).managePremiumRestrictionButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            target: "_blank",
            href: (0, $2E1L5.PARENT_PAGE_LEARN_MORE_URL)
        }, intl.formatMessage((0, $kuujH.i18n).manageParentPageRestrictionButton));
        $[0] = intl;
        $[1] = isPremium;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== contentId || $[4] !== showInspectPermissions) {
        t2 = showInspectPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $erzVD.InspectPermissionsDialog), {
            contentId: contentId,
            onClose: ()=>setShowInspectPermissions(false)
        });
        $[3] = contentId;
        $[4] = showInspectPermissions;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ intl: intl, contentId: contentId, isPremium: isPremium })=>{
    const [showInspectPermissions, setShowInspectPermissions] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isPremium ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: ()=>setShowInspectPermissions(true)
    }, intl.formatMessage((0, $kuujH.i18n).managePremiumRestrictionButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        target: "_blank",
        href: (0, $2E1L5.PARENT_PAGE_LEARN_MORE_URL)
    }, intl.formatMessage((0, $kuujH.i18n).manageParentPageRestrictionButton)), showInspectPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $erzVD.InspectPermissionsDialog), {
        contentId: contentId,
        onClose: ()=>setShowInspectPermissions(false)
    }));
};
const $eed1915733801f58$var$RestrictionButton = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { intl: intl, resetRestrictions: resetRestrictions } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== intl || $[2] !== resetRestrictions) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t1
        }, (dialogState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                onClick: ()=>{
                    dialogState.setIsOpen(true);
                    resetRestrictions();
                }
            }, intl.formatMessage((0, $kuujH.i18n).manageRestrictionButton)));
        $[1] = intl;
        $[2] = resetRestrictions;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ intl: intl, resetRestrictions: resetRestrictions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            onClick: ()=>{
                dialogState.setIsOpen(true);
                resetRestrictions();
            }
        }, intl.formatMessage((0, $kuujH.i18n).manageRestrictionButton)));
};
const $eed1915733801f58$export$ea9ef81cc32c3347 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { isParentPageRestriction: t1, isSpaceRestricted: t2, isEditPageRestricted: t3, contentId: t4, selectedUser: selectedUser, resetRestrictions: resetRestrictions } = t0;
    const isParentPageRestriction = t1 === undefined ? false : t1;
    const isSpaceRestricted = t2 === undefined ? false : t2;
    const isEditPageRestricted = t3 === undefined ? false : t3;
    const contentId = t4 === undefined ? "" : t4;
    const intl = (0, $aXWIB.useIntl)();
    const { edition: edition, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let restrictionTitle;
    let restrictionMessage;
    if (isSpaceRestricted) {
        restrictionTitle = (0, $kuujH.i18n).ownerSpaceRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerSpaceRestrictionMessage;
    } else if (isPremium && isParentPageRestriction) {
        restrictionTitle = (0, $kuujH.i18n).ownerPremiumRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerPremiumRestrictionMessage;
    } else {
        if (isParentPageRestriction) {
            restrictionTitle = (0, $kuujH.i18n).ownerParentPageRestrictionTitle;
            restrictionMessage = (0, $kuujH.i18n).ownerParentPageRestrictionMessage;
        } else if (isEditPageRestricted) {
            restrictionTitle = (0, $kuujH.i18n).ownerRestrictionTitle;
            restrictionMessage = (0, $kuujH.i18n).ownerRestrictionMessage;
        } else {
            restrictionTitle = (0, $kuujH.i18n).ownerRestrictionTitle;
            restrictionMessage = (0, $kuujH.i18n).ownerRestrictionMessage;
        }
    }
    let restrictionButton;
    if (isSpaceRestricted) {
        let t5;
        if ($[0] !== contentId || $[1] !== displayName || $[2] !== intl || $[3] !== selectedUser) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed1915733801f58$var$SpaceRestrictionButton, {
                intl: intl,
                displayName: displayName,
                selectedUser: selectedUser,
                contentId: contentId
            });
            $[0] = contentId;
            $[1] = displayName;
            $[2] = intl;
            $[3] = selectedUser;
            $[4] = t5;
        } else t5 = $[4];
        restrictionButton = t5;
    } else if (isParentPageRestriction) {
        let t5;
        if ($[5] !== contentId || $[6] !== intl || $[7] !== isPremium) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed1915733801f58$var$ParentPageRestrictionButton, {
                intl: intl,
                contentId: contentId,
                isPremium: isPremium
            });
            $[5] = contentId;
            $[6] = intl;
            $[7] = isPremium;
            $[8] = t5;
        } else t5 = $[8];
        restrictionButton = t5;
    } else {
        let t5;
        if ($[9] !== intl || $[10] !== resetRestrictions) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed1915733801f58$var$RestrictionButton, {
                intl: intl,
                resetRestrictions: resetRestrictions
            });
            $[9] = intl;
            $[10] = resetRestrictions;
            $[11] = t5;
        } else t5 = $[11];
        restrictionButton = t5;
    }
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-text-warning, #9E4C00)"
        });
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== intl || $[14] !== restrictionTitle) {
        t6 = intl.formatMessage(restrictionTitle);
        $[13] = intl;
        $[14] = restrictionTitle;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.TextStrong), null, t6);
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== intl || $[19] !== restrictionMessage) {
        t8 = intl.formatMessage(restrictionMessage);
        $[18] = intl;
        $[19] = restrictionMessage;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.Text), null, t8);
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== restrictionButton || $[24] !== t7 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PermissionWarningContainer), {
            "data-testid": "content-ownership-permissions-warning-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.Wrapper), null, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.FlexColumn), null, t7, t9, restrictionButton)));
        $[23] = restrictionButton;
        $[24] = t7;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    return t10;
} : ({ isParentPageRestriction: isParentPageRestriction = false, isSpaceRestricted: isSpaceRestricted = false, isEditPageRestricted: isEditPageRestricted = false, contentId: contentId = '', selectedUser: selectedUser, resetRestrictions: resetRestrictions })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { edition: edition, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    // Set i18n title and message based on restrictionType
    let restrictionTitle = {};
    let restrictionMessage = {};
    if (isSpaceRestricted) {
        restrictionTitle = (0, $kuujH.i18n).ownerSpaceRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerSpaceRestrictionMessage;
    } else if (isPremium && isParentPageRestriction) {
        restrictionTitle = (0, $kuujH.i18n).ownerPremiumRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerPremiumRestrictionMessage;
    } else if (isParentPageRestriction) {
        restrictionTitle = (0, $kuujH.i18n).ownerParentPageRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerParentPageRestrictionMessage;
    } else if (isEditPageRestricted) {
        restrictionTitle = (0, $kuujH.i18n).ownerRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerRestrictionMessage;
    } else {
        restrictionTitle = (0, $kuujH.i18n).ownerRestrictionTitle;
        restrictionMessage = (0, $kuujH.i18n).ownerRestrictionMessage;
    }
    let restrictionButton = null;
    if (isSpaceRestricted) restrictionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed1915733801f58$var$SpaceRestrictionButton, {
        intl: intl,
        displayName: displayName,
        selectedUser: selectedUser,
        contentId: contentId
    });
    else if (isParentPageRestriction) // Premium link renders inspect permissions dialog
    restrictionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed1915733801f58$var$ParentPageRestrictionButton, {
        intl: intl,
        contentId: contentId,
        isPremium: isPremium
    });
    else // Default opens permissions dialog
    restrictionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eed1915733801f58$var$RestrictionButton, {
        intl: intl,
        resetRestrictions: resetRestrictions
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.PermissionWarningContainer), {
        "data-testid": "content-ownership-permissions-warning-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-text-warning, #9E4C00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.FlexColumn), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.TextStrong), null, intl.formatMessage(restrictionTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.Text), null, intl.formatMessage(restrictionMessage)), restrictionButton)));
};
module.exports["ContentOwnershipPermissionWarning"] = $eed1915733801f58$export$ea9ef81cc32c3347;

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("h71c3"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("h71c3", function(module, exports) {

let $c7540414e914bd3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c7540414e914bd3d$var$load("9hYRW"),
    $c7540414e914bd3d$var$load("kpm7S"),
    $c7540414e914bd3d$var$load("jDjSj"),
    $c7540414e914bd3d$var$load("6wr18"),
    $c7540414e914bd3d$var$load("dMOc8"),
    $c7540414e914bd3d$var$load("eYCHi"),
    $c7540414e914bd3d$var$load("7o5Pu"),
    $c7540414e914bd3d$var$load("c831e"),
    $c7540414e914bd3d$var$load("1H5IN"),
    $c7540414e914bd3d$var$load("jbmut"),
    $c7540414e914bd3d$var$load("h4Nf7"),
    $c7540414e914bd3d$var$load("7do1E"),
    $c7540414e914bd3d$var$load("77dkW"),
    $c7540414e914bd3d$var$load("Wowvf"),
    $c7540414e914bd3d$var$load("kHOMt"),
    $c7540414e914bd3d$var$load("9AXkC"),
    $c7540414e914bd3d$var$load("ffEVr"),
    $c7540414e914bd3d$var$load("7EorR"),
    $c7540414e914bd3d$var$load("28arV"),
    $c7540414e914bd3d$var$load("hhss7"),
    $c7540414e914bd3d$var$load("31vk5"),
    $c7540414e914bd3d$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("5k5SG", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $fIsVa = parcelRequire("fIsVa");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $68BwE = parcelRequire("68BwE");


var $jMyy4 = parcelRequire("jMyy4");

const $b47c68511ddb148c$export$5197e7012247b053 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(9);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSiteAdmin: isSiteAdmin } = (0, $68BwE.useSPAViewContext)();
    const [isSpaceAdmin, setIsSpaceAdmin] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $fIsVa.default), t2);
    let t3;
    if ($[5] !== data?.space?.currentUser?.isAdmin) {
        t3 = ()=>{
            const isAdmin = data?.space?.currentUser?.isAdmin ?? false;
            setIsSpaceAdmin(isAdmin);
        };
        $[5] = data?.space?.currentUser?.isAdmin;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== data) {
        t4 = [
            data
        ];
        $[7] = data;
        $[8] = t4;
    } else t4 = $[8];
    (0, $42omo.useEffect)(t3, t4);
    return isSiteAdmin || isSpaceAdmin;
} : ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSiteAdmin: isSiteAdmin } = (0, $68BwE.useSPAViewContext)();
    const [isSpaceAdmin, setIsSpaceAdmin] = (0, $42omo.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $fIsVa.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    (0, $42omo.useEffect)(()=>{
        const isAdmin = data?.space?.currentUser?.isAdmin ?? false;
        setIsSpaceAdmin(isAdmin);
    }, [
        data
    ]);
    return isSiteAdmin || isSpaceAdmin;
};
module.exports["useIsSpaceOrSiteAdmin"] = $b47c68511ddb148c$export$5197e7012247b053;

});

parcelRegister("fIsVa", function(module, exports) {
/**
 * @generated SignedSource<<921a0d73b07f77732d72fba8a69f9fdc>>
 * @relayHash fe7b6aeef2ff7293e4725ed5dae04ccf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58f5ebede16870335101f943d6d18dd3a91ef303ea41352c3fe3a851b3dafa33
const $dcb25824db19c666$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe7b6aeef2ff7293e4725ed5dae04ccf",
            "id": "58f5ebede16870335101f943d6d18dd3a91ef303ea41352c3fe3a851b3dafa33",
            "metadata": {},
            "name": "useIsSpaceOrSiteAdminSpaceAdminQuery",
            "operationKind": "query",
            "text": "query useIsSpaceOrSiteAdminSpaceAdminQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$dcb25824db19c666$var$node.hash = "f2eac010f611ed87c98059843b20682c";
var $dcb25824db19c666$export$2e2bcd8739ae039 = $dcb25824db19c666$var$node;
module.exports["default"] = $dcb25824db19c666$export$2e2bcd8739ae039;

});

parcelRegister("gG6gW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $ji0Nd = parcelRequire("ji0Nd");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $c83c690498928ef1$export$d51985cea2551a1b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [spaceAdminsList, setSpaceAdminsList] = (0, $42omo.useState)(t0);
    let t1;
    if ($[1] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !spaceKey;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $ji0Nd.default), t3);
    let t4;
    if ($[6] !== data?.space?.admins) {
        t4 = ()=>{
            const spaceAdmins = data?.space?.admins || [];
            setSpaceAdminsList([
                ...spaceAdmins
            ].filter($c83c690498928ef1$var$_temp));
        };
        $[6] = data?.space?.admins;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== data) {
        t5 = [
            data
        ];
        $[8] = data;
        $[9] = t5;
    } else t5 = $[9];
    (0, $42omo.useEffect)(t4, t5);
    return spaceAdminsList;
} : ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [spaceAdminsList, setSpaceAdminsList] = (0, $42omo.useState)([]);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $ji0Nd.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    (0, $42omo.useEffect)(()=>{
        const spaceAdmins = data?.space?.admins || [];
        setSpaceAdminsList([
            ...spaceAdmins
        ].filter((admin)=>admin !== undefined));
    }, [
        data
    ]);
    return spaceAdminsList;
};
function $c83c690498928ef1$var$_temp(admin) {
    return admin !== undefined;
}
module.exports["useContentOwnershipSpaceAdmins"] = $c83c690498928ef1$export$d51985cea2551a1b;

});

parcelRegister("ji0Nd", function(module, exports) {
/**
 * @generated SignedSource<<2ef9ab0c88328e666c88fabaa79c700e>>
 * @relayHash 462f52dcf04a704f3f189d003436f376
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce1b1ed0f6465ba08dafe0385b3804ddd4a83c3bcd0758bd9f55716b7e5f5b0
const $c2bfffab535ce88f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "accountType",
            "value": "ATLASSIAN"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "email"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "admins",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ],
                            "storageKey": "admins(accountType:\"ATLASSIAN\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "admins",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ],
                            "storageKey": "admins(accountType:\"ATLASSIAN\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "462f52dcf04a704f3f189d003436f376",
            "id": "7ce1b1ed0f6465ba08dafe0385b3804ddd4a83c3bcd0758bd9f55716b7e5f5b0",
            "metadata": {},
            "name": "useContentOwnershipSpaceAdminsSpaceAdminsListQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipSpaceAdminsSpaceAdminsListQuery($spaceKey:String!){space(key:$spaceKey){id,admins(accountType:ATLASSIAN){__typename,type,...on KnownUser{email}}}}"
        }
    };
}();
$c2bfffab535ce88f$var$node.hash = "e7540581691bddbb5911e7d86948b5a5";
var $c2bfffab535ce88f$export$2e2bcd8739ae039 = $c2bfffab535ce88f$var$node;
module.exports["default"] = $c2bfffab535ce88f$export$2e2bcd8739ae039;

});

parcelRegister("jgcNz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $3ldtA = parcelRequire("3ldtA");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");

const $a79cf8ba6a83274a$export$5aaaa082bc10c9cc = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { contentId: contentId } = t0;
    const [contentTitle, setContentTitle] = (0, $42omo.useState)("");
    const [isArchived, setIsArchived] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $3ldtA.default), t1);
    let t2;
    if ($[2] !== data?.singleContent?.status || $[3] !== data?.singleContent?.title) {
        t2 = ()=>{
            const title = data?.singleContent?.title ?? "";
            const archived = data?.singleContent?.status === "archived";
            setContentTitle(title);
            setIsArchived(archived);
        };
        $[2] = data?.singleContent?.status;
        $[3] = data?.singleContent?.title;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== data) {
        t3 = [
            data
        ];
        $[5] = data;
        $[6] = t3;
    } else t3 = $[6];
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[7] !== contentTitle || $[8] !== isArchived) {
        t4 = {
            contentTitle: contentTitle,
            isArchived: isArchived
        };
        $[7] = contentTitle;
        $[8] = isArchived;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ contentId: contentId })=>{
    const [contentTitle, setContentTitle] = (0, $42omo.useState)('');
    const [isArchived, setIsArchived] = (0, $42omo.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $3ldtA.default), {
        variables: {
            contentId: contentId
        }
    });
    (0, $42omo.useEffect)(()=>{
        const title = data?.singleContent?.title ?? '';
        const archived = data?.singleContent?.status === 'archived';
        setContentTitle(title);
        setIsArchived(archived);
    }, [
        data
    ]);
    return {
        contentTitle: contentTitle,
        isArchived: isArchived
    };
};
module.exports["useContentInfo"] = $a79cf8ba6a83274a$export$5aaaa082bc10c9cc;

});

parcelRegister("3ldtA", function(module, exports) {
/**
 * @generated SignedSource<<a472a2302cfdd92ee07b3cc9c4cc67ea>>
 * @relayHash 02e5694eae05d544c06e2fa66565189c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14f9f5f6d6e0c64e5e92a784821105c630f04dd5684cd3348558eb13e8e4ebac
const $9d23db36bd693d24$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentInfoContentOwnershipContentInfoQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentInfoContentOwnershipContentInfoQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "02e5694eae05d544c06e2fa66565189c",
            "id": "14f9f5f6d6e0c64e5e92a784821105c630f04dd5684cd3348558eb13e8e4ebac",
            "metadata": {},
            "name": "useContentInfoContentOwnershipContentInfoQuery",
            "operationKind": "query",
            "text": "query useContentInfoContentOwnershipContentInfoQuery($contentId:ID!){singleContent(id:$contentId){id,title,status}}"
        }
    };
}();
$9d23db36bd693d24$var$node.hash = "bbc83213ee3157004ed18cf9c0a1713f";
var $9d23db36bd693d24$export$2e2bcd8739ae039 = $9d23db36bd693d24$var$node;
module.exports["default"] = $9d23db36bd693d24$export$2e2bcd8739ae039;

});

parcelRegister("c9As2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $iXCQx = parcelRequire("iXCQx");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $eEA8O = parcelRequire("eEA8O");


var $5tOl1 = parcelRequire("5tOl1");


var $esRft = parcelRequire("esRft");


var $lsxnT = parcelRequire("lsxnT");


var $kuujH = parcelRequire("kuujH");


var $aNtZv = parcelRequire("aNtZv");


var $2E1L5 = parcelRequire("2E1L5");

const $16a863bb4ebc026d$export$e07e2fe8dd18723a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(50);
    const { onCancel: onCancel, onConfirm: onConfirm, currentOwner: currentOwner, newOwner: newOwner } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $kuujH.i18n).confirmModalTitle);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
            appearance: "warning"
        }, t1));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== intl) {
        t3 = intl.formatMessage((0, $kuujH.i18n).confirmModalBody, {
            button: $16a863bb4ebc026d$var$_temp
        });
        $[4] = intl;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "p"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = currentOwner?.avatarUrl;
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            size: "medium",
            src: t5
        });
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kuujH.i18n).confirmModalCurrentOwner));
        $[10] = t7;
    } else t7 = $[10];
    const t8 = currentOwner?.fullName;
    let t9;
    if ($[11] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualTextContainer), null, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualName), null, t8));
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== t6 || $[14] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualContainer), {
            "data-testid": "content-owner-confirm-modal-current-user"
        }, t6, t9);
        $[13] = t6;
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapArrowContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapArrow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Ownership Transfer"
        })));
        $[16] = t11;
    } else t11 = $[16];
    const t12 = newOwner?.avatarUrl;
    let t13;
    if ($[17] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            size: "medium",
            src: t12
        });
        $[17] = t12;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kuujH.i18n).confirmModalNewOwner));
        $[19] = t14;
    } else t14 = $[19];
    const t15 = newOwner?.fullName;
    let t16;
    if ($[20] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualTextContainer), null, t14, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualName), null, t15));
        $[20] = t15;
        $[21] = t16;
    } else t16 = $[21];
    let t17;
    if ($[22] !== t13 || $[23] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualContainer), {
            "data-testid": "content-owner-confirm-modal-new-user"
        }, t13, t16);
        $[22] = t13;
        $[23] = t16;
        $[24] = t17;
    } else t17 = $[24];
    let t18;
    if ($[25] !== t10 || $[26] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapBackground), null, t10, t11, t17);
        $[25] = t10;
        $[26] = t17;
        $[27] = t18;
    } else t18 = $[27];
    let t19;
    if ($[28] !== t18 || $[29] !== t4) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, t4, t18);
        $[28] = t18;
        $[29] = t4;
        $[30] = t19;
    } else t19 = $[30];
    let t20;
    if ($[31] !== intl) {
        t20 = intl.formatMessage((0, $kuujH.i18n).confirmModalCancel);
        $[31] = intl;
        $[32] = t20;
    } else t20 = $[32];
    let t21;
    if ($[33] !== onCancel || $[34] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "content-owner-modal-cancel-update-owner-button",
            appearance: "subtle",
            onClick: onCancel
        }, t20);
        $[33] = onCancel;
        $[34] = t20;
        $[35] = t21;
    } else t21 = $[35];
    let t22;
    if ($[36] !== intl) {
        t22 = intl.formatMessage((0, $kuujH.i18n).confirmModalConfirmChangeOwner);
        $[36] = intl;
        $[37] = t22;
    } else t22 = $[37];
    let t23;
    if ($[38] !== onConfirm || $[39] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "content-owner-modal-confirm-update-owner-button",
            appearance: "warning",
            onClick: onConfirm
        }, t22);
        $[38] = onConfirm;
        $[39] = t22;
        $[40] = t23;
    } else t23 = $[40];
    let t24;
    if ($[41] !== t21 || $[42] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.FlexContainer), null, t21, t23));
        $[41] = t21;
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== Modal || $[45] !== onCancel || $[46] !== t19 || $[47] !== t2 || $[48] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            testId: "content-owner-confirm-modal",
            onClose: onCancel,
            width: "small",
            messageType: "transactional",
            messageId: "content-ownership-confirm-modal"
        }, t2, t19, t24);
        $[44] = Modal;
        $[45] = onCancel;
        $[46] = t19;
        $[47] = t2;
        $[48] = t24;
        $[49] = t25;
    } else t25 = $[49];
    return t25;
} : ({ onCancel: onCancel, onConfirm: onConfirm, currentOwner: currentOwner, newOwner: newOwner })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        testId: "content-owner-confirm-modal",
        onClose: onCancel,
        width: "small",
        messageType: "transactional",
        messageId: "content-ownership-confirm-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, intl.formatMessage((0, $kuujH.i18n).confirmModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, intl.formatMessage((0, $kuujH.i18n).confirmModalBody, {
        button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                spacing: "none",
                target: "_blank",
                href: (0, $2E1L5.CONFIRM_MODAL_LEARN_MORE_LINK)
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapBackground), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualContainer), {
        "data-testid": "content-owner-confirm-modal-current-user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        size: "medium",
        src: currentOwner?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kuujH.i18n).confirmModalCurrentOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualName), null, currentOwner?.fullName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapArrowContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapArrow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
        color: "currentColor",
        spacing: "spacious",
        label: "Ownership Transfer"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualContainer), {
        "data-testid": "content-owner-confirm-modal-new-user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        size: "medium",
        src: newOwner?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kuujH.i18n).confirmModalNewOwner)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.OwnerSwapIndividualName), null, newOwner?.fullName))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aNtZv.FlexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "content-owner-modal-cancel-update-owner-button",
        appearance: "subtle",
        onClick: onCancel
    }, intl.formatMessage((0, $kuujH.i18n).confirmModalCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "content-owner-modal-confirm-update-owner-button",
        appearance: "warning",
        onClick: onConfirm
    }, intl.formatMessage((0, $kuujH.i18n).confirmModalConfirmChangeOwner)))));
};
function $16a863bb4ebc026d$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        appearance: "link",
        spacing: "none",
        target: "_blank",
        href: (0, $2E1L5.CONFIRM_MODAL_LEARN_MORE_LINK)
    }, chunks);
}
module.exports["ChangeOwnerConfirmationModal"] = $16a863bb4ebc026d$export$e07e2fe8dd18723a;

});

parcelRegister("iiPY2", function(module, exports) {
$parcel$export(module.exports, "ContentTypeClassification", () => (parcelRequire("2JKSZ")).ContentTypeClassification);

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");


var $2JKSZ = parcelRequire("2JKSZ");


const $200528ba24c995ad$export$b3d0b57fae17761b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fcpuS",
    name: "ContentTypeClassificationLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("2JKSZ")))).ContentTypeClassification,
    loading: (props)=>{
        const { contentClassificationMetadata: contentClassificationMetadata } = props;
        const { hasNoClassification: hasNoClassification } = contentClassificationMetadata;
        const shouldNotRenderLoader = hasNoClassification;
        if (shouldNotRenderLoader) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
            const $ = (0, $frIzR.c)(13);
            let T0;
            let t1;
            let t2;
            let t3;
            let t4;
            if ($[0] !== __cmplr || $[1] !== t0) {
                const { as: t5, style: __cmpls, ...__cmplp } = t0;
                const C = t5 === undefined ? "div" : t5;
                T0 = C;
                t1 = __cmplp;
                t2 = __cmpls;
                t3 = __cmplr;
                t4 = (0, $gMc0m.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ]);
                $[0] = __cmplr;
                $[1] = t0;
                $[2] = T0;
                $[3] = t1;
                $[4] = t2;
                $[5] = t3;
                $[6] = t4;
            } else {
                T0 = $[2];
                t1 = $[3];
                t2 = $[4];
                t3 = $[5];
                t4 = $[6];
            }
            let t5;
            if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
                    ...t1,
                    style: t2,
                    ref: t3,
                    className: t4
                });
                $[7] = T0;
                $[8] = t1;
                $[9] = t2;
                $[10] = t3;
                $[11] = t4;
                $[12] = t5;
            } else t5 = $[12];
            return t5;
        } : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $gMc0m.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});
module.exports["ContentTypeClassificationLoader"] = $200528ba24c995ad$export$b3d0b57fae17761b;

});

parcelRegister("2JKSZ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $arfOv = parcelRequire("arfOv");


var $9yVdT = parcelRequire("9yVdT");


var $fGQzQ = parcelRequire("fGQzQ");


var $1u6lx = parcelRequire("1u6lx");


var $in5LX = parcelRequire("in5LX");


var $79yie = parcelRequire("79yie");


const $d07cae14ea38bbbf$var$ClassificationTagButtonError = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8ozBk",
    name: "ClassificationTagButtonError",
    loader: async ()=>(await (parcelRequire("1gG4q"))).ClassificationTagButtonError
});
const $d07cae14ea38bbbf$var$ContentTypeClassificationComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: t1, variant: t2, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId } = t0;
    const readOnly = t1 === undefined ? true : t1;
    const variant = t2 === undefined ? (0, $1u6lx.TagButtonUIVariant).default : t2;
    let t3;
    if ($[0] !== contentClassificationMetadata || $[1] !== contentId) {
        t3 = {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata
        };
        $[0] = contentClassificationMetadata;
        $[1] = contentId;
        $[2] = t3;
    } else t3 = $[2];
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)(t3);
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification;
    if (isAddNewClassificationMode) return null;
    if (!currentClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) {
        let t4;
        if ($[3] !== contentLevelError) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
                contentLevelError: contentLevelError
            });
            $[3] = contentLevelError;
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    const t4 = readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit;
    let t5;
    if ($[5] !== buttonTestId || $[6] !== canManageSpaceSettings || $[7] !== classificationControlSetting || $[8] !== contentId || $[9] !== contentType || $[10] !== currentClassification || $[11] !== handleSubmit || $[12] !== isLoading || $[13] !== onRestoreFocus || $[14] !== popupPlacementOverride || $[15] !== source || $[16] !== spaceDefaultIsOverridden || $[17] !== spaceKey || $[18] !== spacing || $[19] !== t4 || $[20] !== userOverrideSetting || $[21] !== variant) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arfOv.GenericClassificationTagButton), {
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: contentType,
            currentClassification: currentClassification,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            onEditSubmit: handleSubmit,
            menuBehavior: t4,
            loading: isLoading,
            variant: variant,
            popupPlacementOverride: popupPlacementOverride,
            spacing: spacing,
            onRestoreFocus: onRestoreFocus,
            buttonTestId: buttonTestId,
            source: source,
            canManageSpaceSettings: canManageSpaceSettings,
            classificationControlSetting: classificationControlSetting,
            userOverrideSetting: userOverrideSetting
        });
        $[5] = buttonTestId;
        $[6] = canManageSpaceSettings;
        $[7] = classificationControlSetting;
        $[8] = contentId;
        $[9] = contentType;
        $[10] = currentClassification;
        $[11] = handleSubmit;
        $[12] = isLoading;
        $[13] = onRestoreFocus;
        $[14] = popupPlacementOverride;
        $[15] = source;
        $[16] = spaceDefaultIsOverridden;
        $[17] = spaceKey;
        $[18] = spacing;
        $[19] = t4;
        $[20] = userOverrideSetting;
        $[21] = variant;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== flagStatus || $[24] !== isLoading || $[25] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
            isLoading: isLoading,
            flagStatus: flagStatus
        }, t5);
        $[23] = flagStatus;
        $[24] = isLoading;
        $[25] = t5;
        $[26] = t6;
    } else t6 = $[26];
    return t6;
} : ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: readOnly = true, variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId })=>{
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification;
    if (isAddNewClassificationMode) return null;
    if (!currentClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
        contentLevelError: contentLevelError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
        isLoading: isLoading,
        flagStatus: flagStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arfOv.GenericClassificationTagButton), {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        currentClassification: currentClassification,
        spaceDefaultIsOverridden: spaceDefaultIsOverridden,
        onEditSubmit: handleSubmit,
        menuBehavior: readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit,
        loading: isLoading,
        variant: variant,
        popupPlacementOverride: popupPlacementOverride,
        spacing: spacing,
        onRestoreFocus: onRestoreFocus,
        buttonTestId: buttonTestId,
        source: source,
        canManageSpaceSettings: canManageSpaceSettings,
        classificationControlSetting: classificationControlSetting,
        userOverrideSetting: userOverrideSetting
    }));
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationGetter = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($d07cae14ea38bbbf$var$ContentTypeClassificationGetter);
const $d07cae14ea38bbbf$export$e97138dbbe0f9a02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
module.exports["ContentTypeClassification"] = $d07cae14ea38bbbf$export$e97138dbbe0f9a02;

});

parcelRegister("arfOv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $i2BsV = parcelRequire("i2BsV");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $earLp = parcelRequire("earLp");


var $1u6lx = parcelRequire("1u6lx");


var $6Ry4r = parcelRequire("6Ry4r");


const $e299f5faef060d8a$var$ClassificationReadViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "zUIer",
    name: "ClassificationReadViewPopup",
    loader: async ()=>(await (parcelRequire("ddDB2"))).ClassificationReadViewPopup
});

const $e299f5faef060d8a$var$ClassificationEditViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mT5oW",
    name: "ClassificationEditViewPopup",
    loader: async ()=>(await (parcelRequire("kGmHz"))).ClassificationEditViewPopup
});
var $e299f5faef060d8a$export$db79e28c55608769 = /*#__PURE__*/ function(TagButtonMenuBehavior) {
    TagButtonMenuBehavior["readOnly"] = "readOnly";
    TagButtonMenuBehavior["editOnly"] = "editOnly";
    TagButtonMenuBehavior["readAndEdit"] = "readAndEdit";
    return TagButtonMenuBehavior;
}({});
const $e299f5faef060d8a$var$DataClassificationLevelMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $i2BsV.default));
const $e299f5faef060d8a$var$messages = (0, $aXWIB.defineMessages)({
    tooltipMessage: {
        id: "data-classification.content-classification.tag-button.tooltip",
        defaultMessage: "This {contentType} is classified as {classification}"
    }
});
const $e299f5faef060d8a$export$e396cc9924b8f3a0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(56);
    const { spaceKey: spaceKey, contentId: contentId, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: t1, isPopupDisabled: t2, menuBehavior: t3, variant: t4, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: t5, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = t0;
    const loading = t1 === undefined ? false : t1;
    const isPopupDisabled = t2 === undefined ? false : t2;
    const menuBehavior = t3 === undefined ? "readOnly" : t3;
    const variant = t4 === undefined ? (0, $1u6lx.TagButtonUIVariant).default : t4;
    const buttonTestId = t5 === undefined ? "data-classification-level" : t5;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isReadView, setIsReadView] = (0, $42omo.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || "auto";
    let t6;
    let t7;
    if ($[0] !== menuBehavior) {
        t6 = ()=>{
            if (menuBehavior === "editOnly") setIsReadView(false);
        };
        t7 = [
            menuBehavior
        ];
        $[0] = menuBehavior;
        $[1] = t6;
        $[2] = t7;
    } else {
        t6 = $[1];
        t7 = $[2];
    }
    (0, $42omo.useEffect)(t6, t7);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    let getOnChangeLevelClick;
    let handlePopupShown;
    let onEditCancel;
    let onEditSubmit;
    if ($[3] !== isReadView || $[4] !== menuBehavior || $[5] !== onEditCancelProp || $[6] !== onEditSubmitProp || $[7] !== onRestoreFocus || $[8] !== trackEditPopupViewed) {
        getOnChangeLevelClick = ()=>{
            if (menuBehavior === "readOnly") return;
            return ()=>{
                setIsReadView(false);
                handlePopupShown({
                    isOpen: true,
                    shouldForce: true
                });
            };
        };
        let t8;
        if ($[13] !== menuBehavior || $[14] !== onEditCancelProp) {
            t8 = (closePopup)=>{
                onEditCancelProp && onEditCancelProp();
                closePopup();
                if (menuBehavior !== "editOnly") setIsReadView(true);
            };
            $[13] = menuBehavior;
            $[14] = onEditCancelProp;
            $[15] = t8;
        } else t8 = $[15];
        onEditCancel = t8;
        let t9;
        if ($[16] !== menuBehavior || $[17] !== onEditSubmitProp || $[18] !== onRestoreFocus) {
            t9 = (classification, closePopup_0)=>{
                onEditSubmitProp && onEditSubmitProp(classification);
                onRestoreFocus && onRestoreFocus();
                closePopup_0();
                if (menuBehavior !== "editOnly") setIsReadView(true);
            };
            $[16] = menuBehavior;
            $[17] = onEditSubmitProp;
            $[18] = onRestoreFocus;
            $[19] = t9;
        } else t9 = $[19];
        onEditSubmit = t9;
        handlePopupShown = (t10)=>{
            const { isOpen: isOpen, shouldForce: t11 } = t10;
            const shouldForce = t11 === undefined ? false : t11;
            if (isOpen) {
                const shouldTrackEvent = !isReadView || shouldForce;
                if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
            }
        };
        $[3] = isReadView;
        $[4] = menuBehavior;
        $[5] = onEditCancelProp;
        $[6] = onEditSubmitProp;
        $[7] = onRestoreFocus;
        $[8] = trackEditPopupViewed;
        $[9] = getOnChangeLevelClick;
        $[10] = handlePopupShown;
        $[11] = onEditCancel;
        $[12] = onEditSubmit;
    } else {
        getOnChangeLevelClick = $[9];
        handlePopupShown = $[10];
        onEditCancel = $[11];
        onEditSubmit = $[12];
    }
    let t8;
    if ($[20] !== canManageSpaceSettings || $[21] !== classificationControlSetting || $[22] !== cloudId || $[23] !== contentId || $[24] !== currentClassification || $[25] !== defaultSelectedEditOption || $[26] !== getOnChangeLevelClick || $[27] !== isReadView || $[28] !== loading || $[29] !== onEditCancel || $[30] !== onEditSubmit || $[31] !== source || $[32] !== spaceKey || $[33] !== userOverrideSetting) {
        t8 = (closePopup_1)=>isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
                name: currentClassification.name,
                classification: currentClassification,
                onChangeLevelClick: getOnChangeLevelClick(),
                source: source ?? undefined,
                isCurrentUserSpaceAdmin: canManageSpaceSettings,
                classificationControl: classificationControlSetting ?? "ANY",
                userOverride: userOverrideSetting ?? "ANY"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
                spaceKey: spaceKey,
                selectedOption: defaultSelectedEditOption,
                onEditCancel: ()=>onEditCancel(closePopup_1),
                onEditSubmit: (classification_0)=>onEditSubmit(classification_0, closePopup_1),
                loading: loading,
                cloudId: cloudId,
                contentId: contentId,
                userOverride: userOverrideSetting ?? "ANY"
            });
        $[20] = canManageSpaceSettings;
        $[21] = classificationControlSetting;
        $[22] = cloudId;
        $[23] = contentId;
        $[24] = currentClassification;
        $[25] = defaultSelectedEditOption;
        $[26] = getOnChangeLevelClick;
        $[27] = isReadView;
        $[28] = loading;
        $[29] = onEditCancel;
        $[30] = onEditSubmit;
        $[31] = source;
        $[32] = spaceKey;
        $[33] = userOverrideSetting;
        $[34] = t8;
    } else t8 = $[34];
    const renderPopupComponent = t8;
    let t9;
    if ($[35] !== currentClassification) {
        t9 = (0, $6Ry4r.getGuidelineProps)(currentClassification, (0, $9wGTI.fg)("confluence_dlp_guideline_rich_text_support"));
        $[35] = currentClassification;
        $[36] = t9;
    } else t9 = $[36];
    const { guideline: guideline, guidelineRepresentation: guidelineRepresentation } = t9;
    const t10 = currentClassification.name;
    let t11;
    if ($[37] !== contentType || $[38] !== currentClassification.name || $[39] !== formatMessage) {
        t11 = formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        });
        $[37] = contentType;
        $[38] = currentClassification.name;
        $[39] = formatMessage;
        $[40] = t11;
    } else t11 = $[40];
    const t12 = renderPopupComponent;
    let t13;
    if ($[41] !== handlePopupShown) {
        t13 = ()=>handlePopupShown({
                isOpen: true
            });
        $[41] = handlePopupShown;
        $[42] = t13;
    } else t13 = $[42];
    const t14 = variant === (0, $1u6lx.TagButtonUIVariant).iconOnly;
    let t15;
    if ($[43] !== buttonTestId || $[44] !== currentClassification.color || $[45] !== currentClassification.name || $[46] !== guideline || $[47] !== guidelineRepresentation || $[48] !== isPopupDisabled || $[49] !== popupPlacement || $[50] !== spacing || $[51] !== t11 || $[52] !== t12 || $[53] !== t13 || $[54] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
            testId: buttonTestId,
            name: t10,
            guideline: guideline,
            guidelineRepresentation: guidelineRepresentation,
            tooltip: t11,
            color: currentClassification.color,
            isPopupDisabled: isPopupDisabled,
            renderPopupComponent: t12,
            onPopupShown: t13,
            isIconOnly: t14,
            popupPlacement: popupPlacement,
            spacing: spacing
        }));
        $[43] = buttonTestId;
        $[44] = currentClassification.color;
        $[45] = currentClassification.name;
        $[46] = guideline;
        $[47] = guidelineRepresentation;
        $[48] = isPopupDisabled;
        $[49] = popupPlacement;
        $[50] = spacing;
        $[51] = t11;
        $[52] = t12;
        $[53] = t13;
        $[54] = t14;
        $[55] = t15;
    } else t15 = $[55];
    return t15;
} : ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: loading = false, isPopupDisabled: isPopupDisabled = false, menuBehavior: menuBehavior = "readOnly", variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId = 'data-classification-level', source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isReadView, setIsReadView] = (0, $42omo.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || 'auto';
    (0, $42omo.useEffect)(()=>{
        if (menuBehavior === "editOnly") setIsReadView(false);
    }, [
        menuBehavior
    ]);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    const getOnChangeLevelClick = ()=>{
        if (menuBehavior === "readOnly") return undefined;
        return ()=>{
            setIsReadView(false);
            handlePopupShown({
                isOpen: true,
                shouldForce: true
            });
        };
    };
    const onEditCancel = (closePopup)=>{
        onEditCancelProp && onEditCancelProp();
        closePopup();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const onEditSubmit = (classification, closePopup_0)=>{
        onEditSubmitProp && onEditSubmitProp(classification);
        onRestoreFocus && onRestoreFocus();
        closePopup_0();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const handlePopupShown = ({ isOpen: isOpen, shouldForce: shouldForce = false })=>{
        if (isOpen) {
            const shouldTrackEvent = !isReadView || shouldForce;
            if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
        }
    };
    const renderPopupComponent = (closePopup_1)=>{
        return isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
            name: currentClassification.name,
            classification: currentClassification,
            onChangeLevelClick: getOnChangeLevelClick(),
            source: source ?? undefined,
            isCurrentUserSpaceAdmin: canManageSpaceSettings,
            classificationControl: classificationControlSetting ?? 'ANY',
            userOverride: userOverrideSetting ?? 'ANY'
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
            spaceKey: spaceKey,
            selectedOption: defaultSelectedEditOption,
            onEditCancel: ()=>onEditCancel(closePopup_1),
            onEditSubmit: (classification_0)=>onEditSubmit(classification_0, closePopup_1),
            loading: loading,
            cloudId: cloudId,
            contentId: contentId,
            userOverride: userOverrideSetting ?? 'ANY'
        });
    };
    const { guideline: guideline, guidelineRepresentation: guidelineRepresentation } = (0, $6Ry4r.getGuidelineProps)(currentClassification, (0, $9wGTI.fg)('confluence_dlp_guideline_rich_text_support'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
        testId: buttonTestId,
        name: currentClassification.name,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation,
        tooltip: formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        }),
        color: currentClassification.color,
        isPopupDisabled: isPopupDisabled,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        renderPopupComponent: renderPopupComponent,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        onPopupShown: ()=>handlePopupShown({
                isOpen: true
            }),
        isIconOnly: variant === (0, $1u6lx.TagButtonUIVariant).iconOnly,
        popupPlacement: popupPlacement,
        spacing: spacing
    }));
};
module.exports["TagButtonMenuBehavior"] = $e299f5faef060d8a$export$db79e28c55608769;
module.exports["GenericClassificationTagButton"] = $e299f5faef060d8a$export$e396cc9924b8f3a0;

});

parcelRegister("1u6lx", function(module, exports) {
var $a200b44450c31008$export$f72f271864b318ce = /*#__PURE__*/ function(TagButtonUIVariant) {
    TagButtonUIVariant["iconOnly"] = "iconOnly";
    TagButtonUIVariant["default"] = "default";
    return TagButtonUIVariant;
}({});
module.exports["TagButtonUIVariant"] = $a200b44450c31008$export$f72f271864b318ce;

});

parcelRegister("6Ry4r", function(module, exports) {
const $588818833e6e4a91$export$44b43449ad5e39e3 = (classification, isADFEnabled)=>{
    // When feature flag is enabled, prefer ADF guideline over plain text
    if (isADFEnabled && classification?.guidelineADF) return {
        guideline: classification.guidelineADF,
        guidelineRepresentation: 'EDITOR'
    };
    // Fall back to plain text guideline
    return {
        guideline: classification?.guideline,
        guidelineRepresentation: 'PLAIN'
    };
};
module.exports["getGuidelineProps"] = $588818833e6e4a91$export$44b43449ad5e39e3;

});

parcelRegister("ddDB2", function(module, exports) {

let $027bcb2a62b71cce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $027bcb2a62b71cce$var$load("iJsKa").then(()=>parcelRequire('ePhVt'));

});

parcelRegister("kGmHz", function(module, exports) {

let $f0e956f9b8b5df56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f0e956f9b8b5df56$var$load("cZdQT"),
    $f0e956f9b8b5df56$var$load("58UdM")
]).then(()=>parcelRequire('8KSlr'));

});

parcelRegister("9yVdT", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $9hlns = parcelRequire("9hlns");


var $u9agA = parcelRequire("u9agA");


var $gqqjz = parcelRequire("gqqjz");


var $in5LX = parcelRequire("in5LX");


var $gfkT8 = parcelRequire("gfkT8");


var $93WhG = parcelRequire("93WhG");

const $b9673e4989b5dd09$export$10b01f6c9dc571ea = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children, flagStatus: flagStatus, isLoading: t1 } = t0;
    const isLoading = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isLoading) {
        t2 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small",
            interactionName: "data-classification-tag-loading"
        });
        $[0] = isLoading;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== flagStatus) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t3
        }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfkT8.SaveFlag), {
                flags: flags,
                title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
                description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
                type: "warning",
                showRefresh: false
            }));
        $[3] = flagStatus;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== children || $[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050"
        }, children, t2, t4);
        $[5] = children;
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ children: children, flagStatus: flagStatus, isLoading: isLoading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small",
        interactionName: "data-classification-tag-loading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfkT8.SaveFlag), {
            flags: flags,
            title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
            description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
            type: "warning",
            showRefresh: false
        })));
};
module.exports["TagLoadingAndFlagWrapper"] = $b9673e4989b5dd09$export$10b01f6c9dc571ea;

});

parcelRegister("gfkT8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1cYlh = parcelRequire("1cYlh");

const $4ebf6b4d55a3b532$var$actionMessage = (0, $aXWIB.defineMessage)({
    id: "data-classification.settings-panel.error-flag-action",
    defaultMessage: "Refresh page"
});
const $4ebf6b4d55a3b532$export$fedbe2c138bb22c4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh } = t0;
    let t1;
    let t2;
    if ($[0] !== classification || $[1] !== description || $[2] !== flags || $[3] !== showRefresh || $[4] !== spaceName || $[5] !== title || $[6] !== type) {
        t1 = ()=>{
            const actions = !!showRefresh ? [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4ebf6b4d55a3b532$var$actionMessage),
                    onClick: $4ebf6b4d55a3b532$var$_temp
                }
            ] : [];
            const showFlag = async ()=>{
                const successFlag = await flags.showFlag({
                    type: type,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                        ...description,
                        values: {
                            spaceName: spaceName,
                            classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? "unclassified" : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, classification)
                        }
                    }),
                    actions: actions
                });
                setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
            };
            showFlag().catch(console.error);
        };
        t2 = [
            flags,
            type,
            title,
            description,
            spaceName,
            showRefresh,
            classification
        ];
        $[0] = classification;
        $[1] = description;
        $[2] = flags;
        $[3] = showRefresh;
        $[4] = spaceName;
        $[5] = title;
        $[6] = type;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : ({ flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh })=>{
    (0, $42omo.useEffect)(()=>{
        const actions = !!showRefresh ? [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4ebf6b4d55a3b532$var$actionMessage),
                onClick: ()=>window.location.reload()
            }
        ] : [];
        const showFlag = async ()=>{
            const successFlag = await flags.showFlag({
                type: type,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), title),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...description,
                    values: {
                        spaceName: spaceName,
                        classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? 'unclassified' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, classification)
                    }
                }),
                actions: actions
            });
            setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
        };
        // eslint-disable-next-line no-console
        showFlag().catch(console.error);
    }, [
        flags,
        type,
        title,
        description,
        spaceName,
        showRefresh,
        classification
    ]);
    return null;
};
const $4ebf6b4d55a3b532$var$SaveFlagGetter = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
};
const $4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($4ebf6b4d55a3b532$var$SaveFlagGetter);
const $4ebf6b4d55a3b532$export$ac7557ff3627d244 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
function $4ebf6b4d55a3b532$var$_temp() {
    return window.location.reload();
}
module.exports["SaveFlag"] = $4ebf6b4d55a3b532$export$ac7557ff3627d244;

});

parcelRegister("93WhG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $81f08aaba4f97dd2$export$39a13631616da233 = (0, $aXWIB.defineMessages)({
    classifyContent: {
        id: "data-classification.shared-messages.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    fetchErrorTextPrimary: {
        id: "data-classification.shared-messages.fetch-error.primary",
        defaultMessage: "Unable to load classification. Try again."
    },
    fetchErrorTextSecondary: {
        id: "data-classification.shared-messages.fetch-error.secondary",
        defaultMessage: "Try reloading now."
    },
    saveErrorTextPrimary: {
        id: "data-classification.shared-messages.save-error.primary",
        defaultMessage: "Update to classification failed to save"
    },
    saveErrorTextSecondary: {
        id: "data-classification.shared-messages.save-error.secondary",
        defaultMessage: "Please try again."
    }
});
module.exports["sharedMessages"] = $81f08aaba4f97dd2$export$39a13631616da233;

});

parcelRegister("1gG4q", function(module, exports) {

let $0ec7eb59ea45e0fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ec7eb59ea45e0fc$var$load("5odbj").then(()=>parcelRequire('2O7oS'));

});

parcelRegister("dLX9a", function(module, exports) {

var $cb6fO = parcelRequire("cb6fO");


var $cEgMD = parcelRequire("cEgMD");


var $1NBp8 = parcelRequire("1NBp8");


var $dqLea = parcelRequire("dqLea");

const $89342ddee4389e57$export$9d5b76aa7bb3f492 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return (0, $1NBp8.COMPANY_HUB).toUrl();
    const path = `${(0, $cb6fO.getSpaceLink)(spaceKey, contentType === 'page' ? 'pages' : 'blog')}/${contentId}`;
    return path;
};
const $89342ddee4389e57$export$5906c3344719ad0e = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, breadcrumbs: breadcrumbs, isUnpublishedDraft: isUnpublishedDraft })=>{
    let url = (0, $1NBp8.HOME).toUrl();
    if (isUnpublishedDraft) {
        if (contentType === 'page') // Draft page -> redirect to closest published parent view page
        {
            if (breadcrumbs) {
                url = (0, $dqLea.getNearestVisibleAncestor)({
                    breadcrumbs: breadcrumbs,
                    fallbackUrl: url
                });
                // if the parent is a folder, redirect to the space overview
                if (Boolean((0, $1NBp8.FOLDER_VIEW).match(url))) url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                    spaceKey: spaceKey
                });
            }
        } else // Draft blog -> redirect to space index page
        url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
    } else // this part executes when closing the edit section for a previously/already published page
    // we can do a lil hack here to avoid making a query.
    // the router will prettify our route with slug (& posting date for blogs) for us
    url = $89342ddee4389e57$export$9d5b76aa7bb3f492({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    return url;
};
module.exports["getPublishPreloadUrl"] = $89342ddee4389e57$export$9d5b76aa7bb3f492;
module.exports["getClosePreloadUrl"] = $89342ddee4389e57$export$5906c3344719ad0e;

});

parcelRegister("dqLea", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab = ({ breadcrumbs: breadcrumbs, fallbackUrl: fallbackUrl })=>{
    let url = fallbackUrl;
    // Loop through all breadcrumbs from bottom up and find the first view page url
    if (breadcrumbs) for(let index = breadcrumbs.length - 1; index >= 0; index--){
        const crumb = breadcrumbs[index];
        const ancestorUrl = crumb?.url;
        if (ancestorUrl && !(0, $1NBp8.RESUME_DRAFT_LEGACY).match(ancestorUrl)) {
            url = ancestorUrl;
            break;
        }
    }
    return url;
};
module.exports["getNearestVisibleAncestor"] = $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab;

});

parcelRegister("lABjq", function(module, exports) {
const $8cb98e143c540908$export$79ede1af301c436c = {
    pageJustPublished: false
};
module.exports["pagePublishedState"] = $8cb98e143c540908$export$79ede1af301c436c;

});

parcelRegister("8G1o2", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $8WndG = parcelRequire("8WndG");


var $eitcW = parcelRequire("eitcW");

function $4afe25e74c0897d4$export$af6ae8f81a672789(contentId) {
    const { data: data, error: error } = (0, $eitcW.useExperimentalEditorBreadcrumbsQuery)({
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    const breadcrumbs = (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    const memoizedBreadcrumbs = (0, $42omo.useMemo)(()=>{
        return (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    }, [
        data,
        error
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? memoizedBreadcrumbs : breadcrumbs;
}
module.exports["useEditorBreadcrumbs"] = $4afe25e74c0897d4$export$af6ae8f81a672789;

});

parcelRegister("8WndG", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");

function $808c5ea5e28dcdc3$export$ba755fc0ebb98c2(data, error) {
    if (error) {
        if ((0, $6fil2.containsNetworkError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }
    return data?.experimentalEditorBreadcrumbs?.breadcrumbs || [];
}
module.exports["handleEditorBreadcrumbsQueryResult"] = $808c5ea5e28dcdc3$export$ba755fc0ebb98c2;

});

parcelRegister("eitcW", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d = ({ variables: variables, skip: skip, onError: onError })=>{
    const { contentId: contentId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/pages/breadcrumb.action?pageId=${contentId}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (json, _variables)=>{
            if (!contentId) throw new Error('contentId is missing.');
            return {
                experimentalEditorBreadcrumbs: {
                    breadcrumbs: json?.breadcrumbs || null
                }
            };
        },
        skip: skip,
        variables: variables,
        onError: onError
    });
};
module.exports["useExperimentalEditorBreadcrumbsQuery"] = $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d;

});

parcelRegister("lEnke", function(module, exports) {

var $9o40q = parcelRequire("9o40q");


var $aBfpe = parcelRequire("aBfpe");

const $6bba1273a65c92dc$export$97c5b582958cdf97 = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ contentId: contentId })=>`/wiki/rest/api/content/${contentId}/?status=draft&action=sync`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ contentId: contentId, contentType: contentType, title: title, content: content, ncsStepVersion: ncsStepVersion })=>{
            const history = contentType === 'blogpost' ? {
                createdDate: new Date().toISOString()
            } : undefined;
            const extensions = {
                'update-trigger': 'DRAFT_SYNC'
            };
            const body = {
                id: contentId,
                type: contentType,
                title: title,
                body: {
                    atlas_doc_format: {
                        value: content,
                        representation: 'atlas_doc_format',
                        content: {
                            id: contentId
                        }
                    }
                },
                status: 'draft',
                version: {
                    number: 1,
                    message: '',
                    ...ncsStepVersion ? {
                        ncsStepVersion: ncsStepVersion
                    } : {}
                },
                extensions: extensions,
                history: history
            };
            return JSON.stringify(body);
        },
        parseResult: (response)=>{
            // The response should match the GraphQL mutation structure
            // experimentalDraftSync: { id: string | null }
            return {
                experimentalDraftSync: {
                    id: response?.id || null
                }
            };
        },
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useExperimentalDraftSyncMutation"] = $6bba1273a65c92dc$export$97c5b582958cdf97;

});

parcelRegister("3WXN2", function(module, exports) {

var $jANWd = parcelRequire("jANWd");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $9wGTI = parcelRequire("9wGTI");


var $jMyy4 = parcelRequire("jMyy4");


var $3JQXa = parcelRequire("3JQXa");


var $fuYhW = parcelRequire("fuYhW");

const $1e41cfcb0548d2ef$var$useCopyContentLinkCopyLinkQuery = (0, $jANWd.default);
var $1e41cfcb0548d2ef$export$61634440d18842d5 = /*#__PURE__*/ function(SUPPORTED_CONTENT_TYPES) {
    SUPPORTED_CONTENT_TYPES["PAGE"] = "page";
    SUPPORTED_CONTENT_TYPES["BLOGPOST"] = "blogpost";
    SUPPORTED_CONTENT_TYPES["OVERVIEW"] = "overview";
    SUPPORTED_CONTENT_TYPES["WHITEBOARD"] = "whiteboard";
    SUPPORTED_CONTENT_TYPES["EMBED"] = "embed";
    SUPPORTED_CONTENT_TYPES["DATABASE"] = "database";
    return SUPPORTED_CONTENT_TYPES;
}({});
const $1e41cfcb0548d2ef$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $3JQXa.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($1e41cfcb0548d2ef$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId
        }
    });
    const getCopyContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === (0, $fuYhW.PAGE_MODE).EDIT) copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) return `${links.base}${copyLink}`;
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === (0, $fuYhW.PAGE_MODE).EDIT) {
            routeName = contentType === "blogpost" ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === "blogpost" ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case "overview":
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case "blogpost":
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case "page":
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case "whiteboard":
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case "embed":
                routeName = (0, $1NBp8.EMBED_VIEW).name;
                break;
            case "database":
                routeName = (0, $1NBp8.DATABASE_VIEW).name;
                if ((0, $9wGTI.fg)('confluence_ufo_trace_ct_err')) break;
            // omit unsupported content types
            // eslint-disable-next-line no-fallthrough
            default:
                if (!contentType && (0, $9wGTI.fg)('confluence_ufo_trace_ct_err')) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $fuYhW.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'copied',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $fuYhW.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            return `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(getCopyContentLink());
    }, [
        getCopyContentLink,
        copyToClipboard
    ]);
    return (0, $42omo.useMemo)(()=>({
            queryError: queryError,
            unsupportedLinkError: unsupportedLinkError,
            getCopyContentLink: getCopyContentLink,
            copyContentLink: copyContentLink
        }), [
        queryError,
        unsupportedLinkError,
        getCopyContentLink,
        copyContentLink
    ]);
};
module.exports["SUPPORTED_CONTENT_TYPES"] = $1e41cfcb0548d2ef$export$61634440d18842d5;
module.exports["useCopyContentLink"] = $1e41cfcb0548d2ef$export$a049904f049cf16d;

});

parcelRegister("jANWd", function(module, exports) {
/**
 * @generated SignedSource<<5034c6b2348a63bdb21d20a24df5b3e7>>
 * @relayHash 18ff4f8d8b4085f53eca6f5430f839ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59
const $0719a5957e91a133$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkCopyLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkCopyLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "18ff4f8d8b4085f53eca6f5430f839ae",
            "id": "696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59",
            "metadata": {},
            "name": "useCopyContentLinkCopyLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$0719a5957e91a133$var$node.hash = "d21c9891b99750e37c7d31e767baec64";
var $0719a5957e91a133$export$2e2bcd8739ae039 = $0719a5957e91a133$var$node;
module.exports["default"] = $0719a5957e91a133$export$2e2bcd8739ae039;

});

parcelRegister("fuYhW", function(module, exports) {
const $77f648e008248362$export$9957974f8b4d8f74 = 'copyShareLink';
var $77f648e008248362$export$e82cf716cce37b4e = /*#__PURE__*/ function(PAGE_MODE) {
    PAGE_MODE["VIEW"] = "view";
    PAGE_MODE["EDIT"] = "edit";
    return PAGE_MODE;
}({});
module.exports["ACTION_SUBJECT_ID"] = $77f648e008248362$export$9957974f8b4d8f74;
module.exports["PAGE_MODE"] = $77f648e008248362$export$e82cf716cce37b4e;

});

parcelRegister("cVfpT", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("fuYhW")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $h5hpR = parcelRequire("h5hpR");


var $fuYhW = parcelRequire("fuYhW");


const $77a17cdb2708e975$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qHKXp",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await (parcelRequire("Ss9SD"))).CopyLink;
    },
    loading: (0, $h5hpR.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $77a17cdb2708e975$export$9d30156e45c09e81;

});

parcelRegister("h5hpR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");

const $585272eb5e339a55$var$i18n = (0, $aXWIB.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $585272eb5e339a55$export$1f3200a5b8d4d8e1 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button-placeholder",
        "data-test-id": "copy-link-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: intl.formatMessage($585272eb5e339a55$var$i18n.copyLinkLabel),
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["CopyLinkButtonPlaceholder"] = $585272eb5e339a55$export$1f3200a5b8d4d8e1;

});

parcelRegister("Ss9SD", function(module, exports) {

let $0a3ae2ec859d1164$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0a3ae2ec859d1164$var$load("lUs3J"),
    $0a3ae2ec859d1164$var$load("nrKDI")
]).then(()=>parcelRequire('9WYR7'));

});

parcelRegister("lRCxi", function(module, exports) {
const $6d3a2f07b0875b27$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await $6d3a2f07b0875b27$var$fetchSitePersonalization(cloudId);
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
const $6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $6d3a2f07b0875b27$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSiteOptedOut"] = $6d3a2f07b0875b27$export$3475487c10c1ac17;

});

parcelRegister("jroIa", function(module, exports) {
/**
 * @generated SignedSource<<61375d69ccecd72ef5e67137896b8abb>>
 * @relayHash 985f6ee79c133e444ec409d517228f1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871
const $fe9e027b65465b8b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatching"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatchingChildren"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserHasAncestorWatchingChildren"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatchingBlogs"
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "985f6ee79c133e444ec409d517228f1d",
            "id": "6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871",
            "metadata": {},
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "operationKind": "query",
            "text": "query WatchDialogComponentWithWatchChildrenQuery($contentId:ID!){singleContent(id:$contentId){__typename,id,currentUserIsWatching,currentUserIsWatchingChildren,currentUserHasAncestorWatchingChildren,type,space{id,key,currentUser{isWatched,isWatchingBlogs},operations{operation,targetType}}}}"
        }
    };
}();
$fe9e027b65465b8b$var$node.hash = "b5ae30f67304ac91f4e47cad0c3cbfda";
var $fe9e027b65465b8b$export$2e2bcd8739ae039 = $fe9e027b65465b8b$var$node;
module.exports["default"] = $fe9e027b65465b8b$export$2e2bcd8739ae039;

});

parcelRegister("kdpMy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9ec3d7afd2a780b8$export$d4c72bab9d6cc13a = {
    generatedTitle: '',
    trackAIResultViewStored: ()=>{},
    generatedTitleFromPaste: '',
    fireResultAnalyticsFromPaste: ()=>{}
};
const $9ec3d7afd2a780b8$var$NAME = 'GENERATED_TITLE_STORE';
const $9ec3d7afd2a780b8$export$e324594224ef24da = {
    setGeneratedTitle: (newTitle)=>({ setState: setState })=>{
            setState({
                generatedTitle: newTitle
            });
        },
    setTrackAIResultViewStored: (trackAIResultViewHook)=>({ setState: setState })=>{
            setState({
                trackAIResultViewStored: trackAIResultViewHook
            });
        },
    setGeneratedTitleFromPaste: (newTitle)=>({ setState: setState })=>{
            setState({
                generatedTitleFromPaste: newTitle
            });
        },
    setFireResultAnalyticsFromPaste: (fireResultAnalytics)=>({ setState: setState })=>{
            setState({
                fireResultAnalyticsFromPaste: fireResultAnalytics
            });
        },
    clearGeneratedTitleFromPaste: ()=>({ setState: setState })=>{
            setState({
                generatedTitleFromPaste: '',
                fireResultAnalyticsFromPaste: ()=>{}
            });
        }
};
const $9ec3d7afd2a780b8$var$GeneratedTitleStore = (0, $1P1Tu.createStore)({
    name: $9ec3d7afd2a780b8$var$NAME,
    initialState: $9ec3d7afd2a780b8$export$d4c72bab9d6cc13a,
    actions: $9ec3d7afd2a780b8$export$e324594224ef24da
});
const $9ec3d7afd2a780b8$export$b824f038e1bda391 = (0, $9zUhf.createHook)($9ec3d7afd2a780b8$var$GeneratedTitleStore);
const $9ec3d7afd2a780b8$export$5d1d441e079eaec3 = (0, $9zUhf.createActionsHook)($9ec3d7afd2a780b8$var$GeneratedTitleStore);
module.exports["useGeneratedTitle"] = $9ec3d7afd2a780b8$export$b824f038e1bda391;
module.exports["useGeneratedTitleActions"] = $9ec3d7afd2a780b8$export$5d1d441e079eaec3;

});

parcelRegister("59MXn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $inPa6 = parcelRequire("inPa6");


var $6fil2 = parcelRequire("6fil2");

var $f7B1p = parcelRequire("f7B1p");

var $flE5X = parcelRequire("flE5X");


var $bQm3c = parcelRequire("bQm3c");


var $gFlI1 = parcelRequire("gFlI1");


var $fdPUP = parcelRequire("fdPUP");


var $lf3m6 = parcelRequire("lf3m6");

class $ca931691e16eb076$var$UserSuggestionsCache {
    setContext(siteId, orgId, userId, contextType, containerId, objectId, mentionsSessionId) {
        this._siteId = siteId;
        this._orgId = orgId;
        this._userId = userId;
        this._contextType = contextType;
        this._containerId = containerId;
        this._objectId = objectId;
        this._mentionsSessionId = mentionsSessionId;
    }
    setSiteId(siteId) {
        this._siteId = siteId;
    }
    setOrgId(orgId) {
        this._orgId = orgId;
    }
    fullCacheAndStateReset() {
        this._abortAndResetAbortController();
        this._resetUserSuggestionsPromiseState();
        this._resetUserSuggestionsCacheState();
    }
    async hydrateUserSuggestionsCache(isEntitledExternalCollaboration) {
        /** Any errors here will get caught in the usePreloadUserSuggestions hook */ await this._fetchAndCacheUserSuggestions(isEntitledExternalCollaboration);
        return this._userSuggestions;
    }
    async getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults = this._maxNumberOfDisplayResults, shouldFetchMoreResults = true, contextType, siteId, orgId, containerId, objectId, mentionsSessionId) {
        /** Any errors here will get caught in the useUserSuggestions hook */ if (this._userSuggestionsPromiseState === 'empty' || this._shouldFetchAdditionalSuggestions) {
            if (!this._siteId && siteId) this.setSiteId(siteId);
            if (!this._orgId && orgId) this.setOrgId(orgId);
            if (!this._contextType && contextType) this._contextType = contextType;
            if (!this._containerId && containerId) this._containerId = containerId;
            if (!this._objectId && objectId) this._objectId = objectId;
            if (!this._mentionsSessionId && mentionsSessionId) this._mentionsSessionId = mentionsSessionId;
            await this._fetchAndCacheUserSuggestions(isEntitledExternalCollaboration, contextType, containerId, objectId, mentionsSessionId);
        }
        const usersIdsExcludedFromShownSuggestions = [
            ...currentPickedPrincipalIds,
            this._userId
        ];
        const unfilteredServerResults = await this._userSuggestions;
        // Although we allow for maxDisplayResults to be any number, we only fetch 10 at a time so realistically we only display 10 max
        const userFacingDisplayResults = unfilteredServerResults.filter(({ id: id })=>!usersIdsExcludedFromShownSuggestions.includes(id)).slice(0, maxDisplayResults);
        this._shouldFetchAdditionalSuggestions = userFacingDisplayResults.length < this._criticallyLowDisplayResults && this._currentRequestedServerResults <= this._requestedServerResultsHardCap && this._userSuggestionsPromiseState === 'resolved' && this._noMoreServerResults === false && shouldFetchMoreResults;
        if (this._shouldFetchAdditionalSuggestions) {
            this._currentRequestedServerResults += this._serverResultsIncreaseDelta;
            return this.getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults, shouldFetchMoreResults, contextType, siteId, orgId, containerId, objectId, mentionsSessionId);
        }
        return userFacingDisplayResults;
    }
    _abortAndResetAbortController() {
        this._abortController?.abort();
        this._abortController = new AbortController();
    }
    _resetUserSuggestionsPromiseState() {
        this._userSuggestions = new Promise((resolve, reject)=>{
            this._resolveUserSuggestions = resolve;
            this._rejectUserSuggestions = reject;
        });
        this._userSuggestionsPromiseState = 'empty';
    }
    _resetUserSuggestionsCacheState() {
        this._shouldFetchAdditionalSuggestions = false;
        this._currentRequestedServerResults = 10;
        this._noMoreServerResults = false;
    }
    createContextPayload(contextType, containerId, objectId, mentionsSessionId) {
        return (0, $dWJ5i.match)({
            contextType: contextType || this._contextType,
            containerId: containerId || this._containerId,
            objectId: objectId || this._objectId,
            mentionsSessionId: mentionsSessionId || this._mentionsSessionId,
            siteId: this._siteId,
            orgId: this._orgId
        }).with({
            contextType: (0, $dWJ5i.P).string,
            containerId: (0, $dWJ5i.P).string,
            objectId: (0, $dWJ5i.P).string,
            mentionsSessionId: (0, $dWJ5i.P).string
        }, (res)=>({
                contextType: res.contextType,
                containerId: res.containerId,
                objectId: res.objectId,
                mentionsSessionId: res.mentionsSessionId,
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            })).with({
            contextType: (0, $dWJ5i.P).string
        }, (res)=>({
                contextType: res.contextType,
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            })).otherwise((res)=>({
                contextType: 'share-and-restrict-dialog:user-and-group-search:suggested-share-users',
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            }));
    }
    async _fetchAndCacheUserSuggestions(isEntitledExternalCollaboration, contextType, containerId, objectId, mentionsSessionId) {
        try {
            /** No more fetching in the same dialog session if we got an error */ if (this._userSuggestionsPromiseState === 'rejected') return this._userSuggestions;
            this._abortAndResetAbortController();
            this._resetUserSuggestionsPromiseState();
            this._userSuggestionsPromiseState = 'pending';
            const contextPayload = this.createContextPayload(contextType, containerId, objectId, mentionsSessionId);
            const response = await (0, $f7B1p.cfetch)(this._recommendationsApi, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    context: contextPayload,
                    searchQuery: {
                        cpusQueryHighlights: {
                            query: '',
                            field: ''
                        },
                        customQuery: '',
                        customerDirectoryId: '',
                        minimumAccessLevel: 'APPLICATION',
                        productAccessPermissionIds: isEntitledExternalCollaboration ? [
                            'write',
                            'external-collaborator-write'
                        ] : [
                            'write'
                        ],
                        queryString: '',
                        restrictTo: {
                            userIds: [],
                            groupIds: []
                        },
                        searchUserbase: false
                    },
                    includeNonLicensedUsers: false,
                    includeTeams: false,
                    includeGroups: false,
                    includeUsers: true,
                    performSearchQueryOnly: false,
                    maxNumberOfResults: this._currentRequestedServerResults
                }),
                signal: this._abortController?.signal
            });
            const { recommendedUsers: recommendedUsers } = await response.json();
            const formattedUsers = recommendedUsers.map(({ id: id, name: name, email: email, avatarUrl: avatarUrl, userType: userType })=>({
                    type: 'user',
                    id: id,
                    name: name,
                    email: email,
                    avatarUrl: avatarUrl,
                    ...userType !== undefined ? {
                        userType: userType
                    } : {}
                }));
            this._resolveUserSuggestions(formattedUsers);
            this._noMoreServerResults = formattedUsers.length < this._currentRequestedServerResults;
            this._userSuggestionsPromiseState = 'resolved';
        } catch (e) {
            if (e instanceof (0, $flE5X.NoNetworkError) && (0, $6fil2.causedByAbortError)(e)) ;
            else {
                /** Any errors here will get caught in the consuming methods or hooks */ this._rejectUserSuggestions(e);
                this._userSuggestionsPromiseState = 'rejected';
            }
        } finally{
            this._shouldFetchAdditionalSuggestions = false;
        }
    }
    constructor(){
        this._userSuggestions = void 0;
        this._resolveUserSuggestions = void 0;
        this._rejectUserSuggestions = void 0;
        this._userSuggestionsPromiseState = void 0;
        /** URS API Route */ this._recommendationsApi = '/gateway/api/v1/recommendations';
        /** The number of displayed suggestions below which we trigger a fetch */ this._criticallyLowDisplayResults = 3;
        /** Max number of user suggestions shown at any one time */ this._maxNumberOfDisplayResults = 3;
        /** Self-imposed limit, which if reached turns off additional fetching */ this._requestedServerResultsHardCap = 60;
        /** The amount by which we increase the requested results every time we fetch.
     * Since the API is not paginated, we have to increase the amount of suggestions
     * we request from the API for the user to see additional suggestions. Each additional
     * round we increase the requested results by 10 until we reach the self-imposed hard-cap.
     */ this._serverResultsIncreaseDelta = 10;
        /** After initial hydration we look at this variable to know whether to trigger another fetch */ this._shouldFetchAdditionalSuggestions = false;
        /** The current amount of suggestions we request from the API. Gets increased by _serverResultsIncreaseDelta
     * with every following fetch until the hard cap of _requestedServerResultsHardCap is reached
     * At that point we stop allowing fetching of additional results to avoid abusing the API
     */ this._currentRequestedServerResults = 10;
        /** If _currentRequestedServerResults is 10, but the API only returns 5 back, then we assume
     * that there are _noMoreServerResults, a.k.a it becomes true
     */ this._noMoreServerResults = false;
        /** Cancel in-flight requests when needed */ this._abortController = void 0;
        this._siteId = '';
        this._orgId = '';
        this._userId = '';
        this._contextType = undefined;
        this._containerId = undefined;
        this._objectId = undefined;
        this._mentionsSessionId = undefined;
        this.fullCacheAndStateReset();
    }
}
const $ca931691e16eb076$export$434f68299dc91067 = new $ca931691e16eb076$var$UserSuggestionsCache();
const $ca931691e16eb076$export$8ac1bc9725285cbb = ({ currentPickedPrincipalIds: currentPickedPrincipalIds, maxDisplayResults: maxDisplayResults, shouldFetchMoreResults: shouldFetchMoreResults, contextType: contextType, siteId: siteId, orgId: orgId, source: source, skip: skip = false, containerId: containerId, objectId: objectId, mentionsSessionId: mentionsSessionId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isEntitledExternalCollaboration: isEntitledExternalCollaboration, loading: isEntitledExternalCollaborationLoading } = (0, $gFlI1.useIsEntitledExternalCollaborator)();
    const [suggestedUsers, setSuggestedUsers] = (0, $42omo.useState)(null);
    const [error, setError] = (0, $42omo.useState)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const _fetchUserSuggestions = async ()=>{
            if (skip) return;
            setLoading(true);
            if (!isEntitledExternalCollaborationLoading) try {
                setSuggestedUsers(await $ca931691e16eb076$export$434f68299dc91067.getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults, shouldFetchMoreResults, contextType, siteId, orgId, containerId, objectId, mentionsSessionId));
                /** Reset error state after successful fetch */ setError(undefined);
            } catch (e) {
                setError(e);
            } finally{
                setLoading(false);
            }
        };
        _fetchUserSuggestions();
    }, [
        currentPickedPrincipalIds,
        isEntitledExternalCollaboration,
        isEntitledExternalCollaborationLoading,
        maxDisplayResults,
        shouldFetchMoreResults,
        contextType,
        siteId,
        orgId,
        skip,
        containerId,
        objectId,
        mentionsSessionId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: source || (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'useUserSuggestions',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    cause: error?.cause
                }
            }
        }).fire();
    }, [
        error,
        source,
        createAnalyticsEvent
    ]);
    return {
        suggestedUsers: suggestedUsers,
        loading: loading,
        error: error
    };
};
const $ca931691e16eb076$export$a7906c54c2a4948b = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, orgId: unsafeOrgId, userId: unsafeUserId } = (0, $bQm3c.useSessionData)();
    const { isEntitledExternalCollaboration: isEntitledExternalCollaboration, loading: isEntitledExternalCollaborationLoading } = (0, $gFlI1.useIsEntitledExternalCollaborator)();
    const { contentId: contentId, spaceId: spaceId, contextType: contextType, mentionsSessionId: mentionsSessionId } = (0, $lf3m6.useUserSuggestionsMentionsExperiment)();
    const [error, setError] = (0, $42omo.useState)();
    const orgId = unsafeOrgId ?? "";
    const userId = unsafeUserId ?? "";
    let t3;
    let t4;
    if ($[2] !== cloudId || $[3] !== contentId || $[4] !== contextType || $[5] !== isEntitledExternalCollaboration || $[6] !== isEntitledExternalCollaborationLoading || $[7] !== mentionsSessionId || $[8] !== orgId || $[9] !== skip || $[10] !== spaceId || $[11] !== userId) {
        t3 = ()=>{
            const hydrate = async ()=>{
                try {
                    $ca931691e16eb076$export$434f68299dc91067.setContext(cloudId, orgId, userId, contextType, spaceId, contentId, mentionsSessionId);
                    await $ca931691e16eb076$export$434f68299dc91067.hydrateUserSuggestionsCache(isEntitledExternalCollaboration);
                } catch (t5) {
                    const e = t5;
                    setError(e);
                }
            };
            if (!isEntitledExternalCollaborationLoading && !skip) hydrate();
            return $ca931691e16eb076$var$_temp;
        };
        t4 = [
            cloudId,
            orgId,
            userId,
            isEntitledExternalCollaboration,
            isEntitledExternalCollaborationLoading,
            contextType,
            spaceId,
            skip,
            contentId,
            mentionsSessionId
        ];
        $[2] = cloudId;
        $[3] = contentId;
        $[4] = contextType;
        $[5] = isEntitledExternalCollaboration;
        $[6] = isEntitledExternalCollaborationLoading;
        $[7] = mentionsSessionId;
        $[8] = orgId;
        $[9] = skip;
        $[10] = spaceId;
        $[11] = userId;
        $[12] = t3;
        $[13] = t4;
    } else {
        t3 = $[12];
        t4 = $[13];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[14] !== createAnalyticsEvent || $[15] !== error) {
        t5 = ()=>{
            if (error) createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "errored",
                    actionSubject: "usePreloadUserSuggestions",
                    attributes: {
                        message: error?.message,
                        name: error?.name,
                        stack: error?.stack,
                        cause: error?.cause
                    }
                }
            }).fire();
        };
        t6 = [
            error,
            createAnalyticsEvent
        ];
        $[14] = createAnalyticsEvent;
        $[15] = error;
        $[16] = t5;
        $[17] = t6;
    } else {
        t5 = $[16];
        t6 = $[17];
    }
    (0, $42omo.useEffect)(t5, t6);
};
function $ca931691e16eb076$var$_temp() {
    $ca931691e16eb076$export$434f68299dc91067.fullCacheAndStateReset();
}
module.exports["useUserSuggestions"] = $ca931691e16eb076$export$8ac1bc9725285cbb;
module.exports["usePreloadUserSuggestions"] = $ca931691e16eb076$export$a7906c54c2a4948b;

});

parcelRegister("gFlI1", function(module, exports) {

var $1Z6ME = parcelRequire("1Z6ME");


var $7lu50 = parcelRequire("7lu50");


var $jMyy4 = parcelRequire("jMyy4");

const $5cc409285e24cb50$export$7a601c0e3c28bd14 = ({ skip: skip = false } = {})=>{
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $1Z6ME.default), {
        skip: skip
    });
    return {
        isEntitledExternalCollaboration: (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) ?? false,
        loading: loading
    };
};
module.exports["useIsEntitledExternalCollaborator"] = $5cc409285e24cb50$export$7a601c0e3c28bd14;

});

parcelRegister("1Z6ME", function(module, exports) {
/**
 * @generated SignedSource<<379245558009663d8a21fc9124296289>>
 * @relayHash 624bb7f2e1333a1dc93bb4e3e1ab1a47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50cdeb2f8746825d9a317b38ba0c85a01e96c5247af9f0eb632d2a708fb4be48
const $08d563e748b13a46$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "624bb7f2e1333a1dc93bb4e3e1ab1a47",
            "id": "50cdeb2f8746825d9a317b38ba0c85a01e96c5247af9f0eb632d2a708fb4be48",
            "metadata": {},
            "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$08d563e748b13a46$var$node.hash = "15c75f072c1c9beaecdb4e535cfc9037";
var $08d563e748b13a46$export$2e2bcd8739ae039 = $08d563e748b13a46$var$node;
module.exports["default"] = $08d563e748b13a46$export$2e2bcd8739ae039;

});

parcelRegister("fdPUP", function(module, exports) {
const $73fa77a308d85fef$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $73fa77a308d85fef$export$da7d900b1da56fbf = 'share-and-restrict-dialog-user-picker-input';
const $73fa77a308d85fef$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $73fa77a308d85fef$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $73fa77a308d85fef$export$219d516b185caa05;
module.exports["USER_PICKER_INPUT_ID"] = $73fa77a308d85fef$export$da7d900b1da56fbf;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $73fa77a308d85fef$export$ce504fce6cf8855f;

});

parcelRegister("lf3m6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");

const $1fe9d405ea0b7d31$export$c8803e7fcf129fb7 = ()=>{
    const $ = (0, $frIzR.c)(5);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceId] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = crypto.randomUUID();
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== contentId || $[2] !== spaceId) {
        t1 = {
            contentId: contentId,
            spaceId: spaceId,
            mentionsSessionId: t0,
            contextType: "Mentions"
        };
        $[1] = contentId;
        $[2] = spaceId;
        $[3] = t1;
    } else t1 = $[3];
    const mentionRequestModel = t1;
    if ((0, $6mKj3.expValEquals)("cc_suggested_users_next", "cohort", "variation")) return mentionRequestModel;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            contentId: undefined,
            spaceId: undefined,
            contextType: undefined,
            mentionsSessionId: undefined
        };
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["useUserSuggestionsMentionsExperiment"] = $1fe9d405ea0b7d31$export$c8803e7fcf129fb7;

});

parcelRegister("ePExc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ec704748a0115052$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "327gI",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("bHDn4"))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $ec704748a0115052$export$9542b2119eeb5eb4;

});

parcelRegister("bHDn4", function(module, exports) {

let $885240264fd1472e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $885240264fd1472e$var$load("jbxHq"),
    $885240264fd1472e$var$load("jXx9i"),
    $885240264fd1472e$var$load("6wr18"),
    $885240264fd1472e$var$load("k55bj"),
    $885240264fd1472e$var$load("3nozt"),
    $885240264fd1472e$var$load("jrCdz"),
    $885240264fd1472e$var$load("dedpp"),
    $885240264fd1472e$var$load("9hYRW"),
    $885240264fd1472e$var$load("kpm7S"),
    $885240264fd1472e$var$load("ffEVr"),
    $885240264fd1472e$var$load("7EorR"),
    $885240264fd1472e$var$load("Wowvf"),
    $885240264fd1472e$var$load("5RR9C"),
    $885240264fd1472e$var$load("3DgZV"),
    $885240264fd1472e$var$load("hhss7"),
    $885240264fd1472e$var$load("bunf9")
]).then(()=>parcelRequire('4adOe'));

});

parcelRegister("eZLpN", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $2589de0f689b9a54$export$fc06099c27831dd7({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy = 'cache-first', variables: variables, pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $2589de0f689b9a54$export$846a05bdbd4f6c21({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $2589de0f689b9a54$export$846a05bdbd4f6c21(params) {
    const { queryState: queryState, execute: baseExecute, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        ...params,
        isLazyQuery: true
    });
    const execute = (0, $26Yfd.useStableCallback)(async (options)=>{
        await baseExecute(options?.variables);
    });
    return [
        execute,
        {
            ...queryState ?? (0, $7ji4X.INITIAL_IDLE_STATE),
            stopPolling: stopPolling
        }
    ];
}
module.exports["useExperimentalLazyQuery"] = $2589de0f689b9a54$export$fc06099c27831dd7;

});

parcelRegister("d35qt", function(module, exports) {
/* NewAccessRequestIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Yes, this file is one giant exception to the rules, it is intentional.
 * If we were to do this with Javascript it would be way less performant
 * And more error prone
 */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $eRpR8 = parcelRequire("eRpR8");

const $ad45489d485fda80$var$styles = {
    accessRequestsStatusContainer: "_kqswh2mm",
    accessRequestsStatusContainerInline: "_1e0c1o8l",
    accessRequestsStatusIndicatorOutline: "_2rko1qi0 _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb19bv _4t3i19bv _kqswstnw _1pbykb7n",
    surfaceBackground: "_1ukrtuvp _ru4f1h6o _1ngpvuon _g87g116u _uohs13ro",
    overlayBackground: "_1ngp1bhr _g87g6o2t _uohsm8nx",
    accessRequestsStatusIndicator: "_2rko1qi0 _bfhkyhbg _1bsbi2wt _4t3ii2wt"
};
const $ad45489d485fda80$export$b86a366ed549a737 = ({ children: children, top: top, right: right, source: source, isInsideOverlay: isInsideOverlay = false, as: Container = 'div' })=>{
    const [showIndicator, setShowIndicator] = (0, $42omo.useState)(false);
    const transform = `scale(${showIndicator ? 1 : 0})`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        return (0, $eRpR8.NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE).subscribe(setShowIndicator);
    }, []);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: showIndicator ? 'shown' : 'hidden',
                actionSubject: 'pendingRequestIndicator',
                attributes: {
                    isInsideOverlay: isInsideOverlay
                },
                source: source
            }
        }).fire();
    }, [
        showIndicator,
        createAnalyticsEvent,
        isInsideOverlay,
        source
    ]);
    return /*#__PURE__*/ $42omo.createElement(Container, {
        className: (0, $gMc0m.default)([
            $ad45489d485fda80$var$styles.accessRequestsStatusContainer,
            Container === 'span' && $ad45489d485fda80$var$styles.accessRequestsStatusContainerInline,
            isInsideOverlay ? $ad45489d485fda80$var$styles.overlayBackground : $ad45489d485fda80$var$styles.surfaceBackground
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        id: "unseen-request-indicator",
        "data-testid": "unseen-request-indicator",
        style: {
            top: top,
            right: right,
            transform: transform
        },
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            $ad45489d485fda80$var$styles.accessRequestsStatusIndicatorOutline,
            showIndicator && $ad45489d485fda80$var$styles.surfaceBackgroundVisible
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $ad45489d485fda80$var$styles.accessRequestsStatusIndicator
        ])
    })), children);
};
const $ad45489d485fda80$export$91c5e709f5f88246 = (props)=>// eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_fe_realtime_access_requests', 'isEnabled', true) ? /*#__PURE__*/ $42omo.createElement($ad45489d485fda80$export$b86a366ed549a737, props) : props.children;
module.exports["NewAccessRequestIndicator"] = $ad45489d485fda80$export$91c5e709f5f88246;

});

parcelRegister("eRpR8", function(module, exports) {

var $1UApO = parcelRequire("1UApO");


var $2Oud5 = parcelRequire("2Oud5");

const $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED = (0, $1UApO.keys).LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED;
class $fcbf902ccbdfa629$export$78cb9c0f9b082b54 {
    _toggleIndicator(newState) {
        this._indicatorShown = newState;
        this._subscribers.forEach((sub)=>sub(newState));
    }
    _clearCache(contentId) {
        (0, $2Oud5.removeCachedTuple)(contentId, $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
    }
    subscribe(callback) {
        this._subscribers.add(callback);
        callback(this._indicatorShown);
        return ()=>{
            this._subscribers.delete(callback);
        };
    }
    updateIndicatorVisibility(contentId, mostRecentPendingRequestCreatedAt, lookback, remainingRequests) {
        if (lookback === 'full') {
            // No pending request remain whatsoever.
            // No need for 🔵. No need for cache.
            if (remainingRequests === 0) {
                this._clearCache(contentId);
                this._toggleIndicator(false);
                return;
            }
            // At least one pending request left
            // Check if it was created after last time Requests dialog was seen
            // If after -> show 🔵, If before -> hide 🔵
            const shouldShowIndicator = mostRecentPendingRequestCreatedAt > (0, $2Oud5.getCachedTimestamp)(contentId, $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
            this._toggleIndicator(shouldShowIndicator);
        } else {
            // At this point we know we're ONLY seeing requests X minutes back (likely 5)
            // I.e. "partial" lookback.
            const shouldShowIndicator = mostRecentPendingRequestCreatedAt > (0, $2Oud5.getCachedTimestamp)(contentId, $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
            // Since this is a partial lookback we can ONLY reliably show the 🔵
            // We cannot reliably hide the 🔵, because there might be older requests
            // that still happened AFTER last time Access Requests dialog was seen
            if (shouldShowIndicator) this._toggleIndicator(true);
        }
    }
    markAllRequestsAsSeen(contentId) {
        this._toggleIndicator(false);
        (0, $2Oud5.setCachedTuple)(contentId, Date.now(), $fcbf902ccbdfa629$var$LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
    }
    resetSubscribers() {
        this._indicatorShown = false;
        this._subscribers.clear();
    }
    constructor(){
        this._indicatorShown = false;
        this._subscribers = new Set();
    }
}
const $fcbf902ccbdfa629$export$8ccd90350e41eeed = new $fcbf902ccbdfa629$export$78cb9c0f9b082b54();
module.exports["NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE"] = $fcbf902ccbdfa629$export$8ccd90350e41eeed;

});

parcelRegister("2Oud5", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $e2788db33f615ba0$export$29633e5fddc10d17 = (key)=>{
    try {
        const cachedContentTimestampPairs = (0, $17wUi.confluenceLocalStorageInstance).getItem(key) ?? '';
        return cachedContentTimestampPairs?.split(',').reduce((acc, entry)=>{
            if (!entry) return acc;
            const [contentId, timestamp] = entry.split(':');
            if (contentId && timestamp) acc.push([
                contentId,
                Number(timestamp)
            ]);
            return acc;
        }, []);
    } catch  {
        // ToDo: Emit operational error analytic
        return [];
    }
};
const $e2788db33f615ba0$export$ccb7f4e8765d6456 = (entries, key)=>{
    try {
        const filteredEntries = entries.flatMap((entry)=>entry[0] && entry[1] && typeof entry[0] === 'string' && typeof entry[1] === 'number' ? [
                entry.join(':')
            ] : []);
        if (filteredEntries.length) (0, $17wUi.confluenceLocalStorageInstance).setItem(key, filteredEntries.join(','));
        else (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
    } catch  {
    // ToDo: Emit operational analytic event
    }
};
const $e2788db33f615ba0$export$3b0244bd9f8f568e = (contentId, key)=>{
    const cache = $e2788db33f615ba0$export$29633e5fddc10d17(key);
    const cachedEntry = cache.find(([cachedId])=>cachedId === contentId);
    const timestamp = cachedEntry?.[1] ?? 0;
    return timestamp;
};
const $e2788db33f615ba0$export$f57463674d9b9177 = (contentId, key, /** If no condition is provided, then we remove without asking questions */ condition)=>{
    const cache = $e2788db33f615ba0$export$29633e5fddc10d17(key);
    const cachedTupleIndex = cache.findIndex((entry)=>entry[0] === contentId);
    const cachedTuple = cachedTupleIndex > -1 ? cache[cachedTupleIndex] : null;
    const cachedTimestamp = cachedTuple?.[1] ?? 0;
    const shouldRemove = condition ? condition(cachedTimestamp) : true;
    if (shouldRemove) {
        const cleanedCache = cache.filter(([cachedId])=>cachedId !== contentId);
        $e2788db33f615ba0$export$ccb7f4e8765d6456(cleanedCache, key);
    }
};
const $e2788db33f615ba0$export$6f3d0a17746d454e = (contentId, timestamp, key, /** If no condition is provided, then we set without asking questions */ condition)=>{
    const shouldSet = condition ? condition(timestamp) : true;
    if (shouldSet) {
        const cache = $e2788db33f615ba0$export$29633e5fddc10d17(key);
        const cachedTupleIndex = cache.findIndex((entry)=>entry[0] === contentId);
        const updatedEntry = [
            contentId,
            timestamp
        ];
        if (cachedTupleIndex === -1) cache.push(updatedEntry);
        else cache[cachedTupleIndex] = updatedEntry;
        $e2788db33f615ba0$export$ccb7f4e8765d6456(cache, key);
    }
};
module.exports["getCachedTimestamp"] = $e2788db33f615ba0$export$3b0244bd9f8f568e;
module.exports["removeCachedTuple"] = $e2788db33f615ba0$export$f57463674d9b9177;
module.exports["setCachedTuple"] = $e2788db33f615ba0$export$6f3d0a17746d454e;

});

parcelRegister("4Ewfm", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $fg72c = parcelRequire("fg72c");


var $8oEoE = parcelRequire("8oEoE");

const $b2ff9ab7087360b2$export$3b523c26f78a7afe = (principal)=>{
    if (principal.type === 'user') {
        const warning = principal.knownErrors?.accessWarning;
        return warning === 'pending-site-access-warning' || warning === 'pending-userbase-propagation-warning';
    }
    return false;
};
function $b2ff9ab7087360b2$export$9871f41355e50e43({ principals: principals, removals: removals, principalsPendingAccess: principalsPendingAccess, removeAll: removeAll }) {
    if (!(0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate')) return false;
    if (!(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('twcg-444-invite-usd-improvements-m2', 'cohort', 'variation')) return false;
    if (Array.from(principals.values()).some(({ principal: principal })=>$b2ff9ab7087360b2$export$3b523c26f78a7afe(principal))) return true;
    if (principalsPendingAccess.some(({ principal: { id: id } })=>removals.has(id))) return true;
    if (removeAll && principalsPendingAccess.length > 0) return true;
    return false;
}
function $b2ff9ab7087360b2$export$e84d96463240149a({ generalAccess: generalAccess, principals: principals }) {
    return $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
}
function $b2ff9ab7087360b2$export$50e102a305a0ed72({ generalAccess: generalAccess, principals: principals }) {
    const currentRestrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'publish-modal-restrictions'
    });
    const read = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const update = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const { publishModalReadRestrictions: publishModalReadRestrictions, publishModalUpdateRestrictions: publishModalUpdateRestrictions } = $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions);
    return [
        publishModalReadRestrictions,
        publishModalUpdateRestrictions
    ];
}
function $b2ff9ab7087360b2$export$49bcbf98a41d5666({ generalAccess: generalAccess, principals: principals }) {
    const restrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
    const gqlInput = {
        read: restrictions.read,
        update: restrictions.update
    };
    // Only include new fields for explicit permissions paradigm when experiment is enabled
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('persistence_specific_access_gate', 'cohort', 'experiment')) {
        gqlInput.restrictionState = (0, $fg72c.generalAccessLevelToMode)(generalAccess);
        gqlInput.permissions = $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, generalAccess);
    }
    return gqlInput;
}
/**
 * Builds the flat permissions array format (view/edit) from the principals map.
 * This is the new format used by the permissions + restrictionState fields on ConfluenceContentInput.
 *
 * Unlike the old restrictions format (read/update with separate user/group arrays),
 * this produces flat arrays of { id, type } objects for view and edit.
 */ function $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, _generalAccess) {
    const viewList = [];
    const editList = [];
    // For persistence_specific_access_gate: always include principals to show redundant restrictions
    // regardless of general access mode. Add principals based solely on their role.
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const principalType = principal.type === 'user' ? 'USER' : 'GROUP';
        // Add can-view principals to view list
        if (role === 'can-view') viewList.push({
            id: principal.id,
            type: principalType
        });
        // Add can-edit principals to edit list only
        if (role === 'can-edit') editList.push({
            id: principal.id,
            type: principalType
        });
    }
    return {
        view: viewList,
        edit: editList
    };
}
/**
 * Generates restrictions based on the general access level, the provided principals map and restrictionType.
 */ function $b2ff9ab7087360b2$var$getRestrictions({ generalAccess: generalAccess, principals: principals, restrictionType: restrictionType }) {
    switch(generalAccess){
        case 'restricted':
            return {
                read: $b2ff9ab7087360b2$var$getReadList(principals, restrictionType),
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        case 'open-can-view':
            return {
                read: {
                    group: [],
                    user: []
                },
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        default:
            return {
                read: {
                    group: [],
                    user: []
                },
                update: {
                    group: [],
                    user: []
                }
            };
    }
}
/**
 * Converts the current state to publish modal restrictions by transforming user and group lists.
 *
 * @param {ContentRestriction} read - The read restrictions content.
 * @param {ContentRestriction} update - The update restrictions content.
 * @param {PageRestrictionsInput} currentRestrictions - The current restrictions input.
 * @returns {{ publishModalReadRestrictions: ContentRestriction, publishModalUpdateRestrictions: ContentRestriction }} The transformed publish modal restrictions.
 */ function $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions) {
    const { restrictions: { user: { results: readUserList }, group: { results: readGroupList } } } = read;
    const { restrictions: { user: { results: updateUserList }, group: { results: updateGroupList } } } = update;
    const { read: currentReadList, update: currentUpdateList } = currentRestrictions;
    $b2ff9ab7087360b2$var$pushTransformedUser(readUserList, currentReadList.user);
    $b2ff9ab7087360b2$var$pushTransformedUser(updateUserList, currentUpdateList.user);
    $b2ff9ab7087360b2$var$pushTransformedGroup(readGroupList, currentReadList.group);
    $b2ff9ab7087360b2$var$pushTransformedGroup(updateGroupList, currentUpdateList.group);
    return {
        publishModalReadRestrictions: read,
        publishModalUpdateRestrictions: update
    };
}
/**
 * Transforms and adds user restrictions to the publish modal user list.
 */ function $b2ff9ab7087360b2$var$pushTransformedUser(list, users) {
    for (const user of users){
        if (!user) continue;
        list.push({
            ...user,
            type: 'known',
            // instead of type: 'user'
            publicName: user.displayName,
            isExternalCollaborator: false
        });
    }
}
/**
 * Transforms and adds group restrictions to the publish modal group list.
 */ function $b2ff9ab7087360b2$var$pushTransformedGroup(list, groups) {
    for (const group of groups){
        if (!group) continue;
        list.push(group);
    }
}
const $b2ff9ab7087360b2$var$getUsageType = (principal)=>{
    if ((principal.type === 'group' || principal.type === 'team') && 'usageType' in principal && principal.usageType) return principal.usageType;
    if (principal.type === 'group') return (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP;
    if (principal.type === 'team') return (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION;
};
/**
 * Generates a list of principals with 'can-edit' access for the update list.
 */ function $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && role === 'can-edit') groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && role === 'can-edit') userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
/**
 * Generates a list of principals with 'can-view' access for the read list.
 */ function $b2ff9ab7087360b2$var$getReadList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && (role === 'can-view' || role === 'can-edit')) groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && (role === 'can-view' || role === 'can-edit')) userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
module.exports["isUserPendingAccess"] = $b2ff9ab7087360b2$export$3b523c26f78a7afe;
module.exports["shouldMutationIncludeInvites"] = $b2ff9ab7087360b2$export$9871f41355e50e43;
module.exports["getRestrictionsForMutation"] = $b2ff9ab7087360b2$export$e84d96463240149a;
module.exports["getRestrictionsForPublishModal"] = $b2ff9ab7087360b2$export$50e102a305a0ed72;
module.exports["getGqlRestrictionsInputForPublishModal"] = $b2ff9ab7087360b2$export$49bcbf98a41d5666;

});

parcelRegister("fg72c", function(module, exports) {
const $06bae8500a7e571b$export$406c89e51172952a = {
    restricted: 'VIEW_RESTRICTED',
    'open-can-view': 'EDIT_RESTRICTED',
    'open-can-edit': 'OPEN'
};
const $06bae8500a7e571b$export$3e8e3eee6dfccab0 = (level)=>$06bae8500a7e571b$export$406c89e51172952a[level];
module.exports["generalAccessLevelToMode"] = $06bae8500a7e571b$export$3e8e3eee6dfccab0;

});

parcelRegister("8oEoE", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0f8a7127f2228c42$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $0f8a7127f2228c42$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ConfluenceGroupUsageType"] = $0f8a7127f2228c42$export$e7c9280c9da1cc0a;

});

parcelRegister("86H8K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $fdPUP = parcelRequire("fdPUP");

const $09f2383e12028cd7$var$SAC_LEARN_MORE_DOCUMENTATION = 'https://support.atlassian.com/confluence-cloud/docs/troubleshoot-access-problems-to-content/';
const $09f2383e12028cd7$export$40b60b643290317e = (chunks)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'blockedAccessLearnMore'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: $09f2383e12028cd7$var$SAC_LEARN_MORE_DOCUMENTATION,
        onClick: handleClick
    }, chunks);
};
module.exports["LearnMoreChunk"] = $09f2383e12028cd7$export$40b60b643290317e;

});

parcelRegister("dwkNQ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $lE63B = parcelRequire("lE63B");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $2Nwuj = parcelRequire("2Nwuj");


var $2Pg7f = parcelRequire("2Pg7f");


var $3hOY6 = parcelRequire("3hOY6");

var $6T8v4 = parcelRequire("6T8v4");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $iquRY = parcelRequire("iquRY");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");


var $1688F = parcelRequire("1688F");


var $1chEN = parcelRequire("1chEN");


var $3c7da = parcelRequire("3c7da");


var $86H8K = parcelRequire("86H8K");


var $308Wd = parcelRequire("308Wd");

const $a159289724029162$var$ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation = (0, $lE63B.default);
const $a159289724029162$var$i18n = (0, $aXWIB.defineMessages)({
    headingSingleUser: {
        id: "share-and-restrict-dialog.resolve-restricted-access.heading.single-user",
        defaultMessage: "Someone needs additional access"
    },
    headingMultiUser: {
        id: "share-and-restrict-dialog.resolve-restricted-access.heading.multi-user",
        defaultMessage: "Some people need additional access"
    },
    parentAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.body",
        defaultMessage: "They need access to a parent <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    parentAccessRolesRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.roles-update.body",
        defaultMessage: "They need access to a parent <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access."
    },
    spaceAccessViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.body",
        defaultMessage: "They need access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view and edit permissions only. <learnMoreLink>Learn more</learnMoreLink>"
    },
    spaceAccessViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.roles-update.body",
        defaultMessage: "They need edit access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully edit <bold>{pageTitle}</bold>."
    },
    spaceAccessViewBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view.body",
        defaultMessage: "They need access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully view <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    spaceAccessViewRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view.roles-update.body",
        defaultMessage: "They need view access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully view <bold>{pageTitle}</bold>."
    },
    spaceAccessRoleSelectionForViewAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.role-selection-for-view-access.body",
        defaultMessage: "<bold>Role</bold>"
    },
    spaceAccessRoleSelectionForEditAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.role-selection-for-edit-access.body",
        defaultMessage: "<bold>Roles that allow editing</bold>"
    },
    skipButton: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.skip-button",
        defaultMessage: "Skip for now"
    },
    addToParentButton: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.add-to-parent-button",
        defaultMessage: "Add to parent"
    },
    addToSpaceButton: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.add-to-space-button",
        defaultMessage: "Add to space"
    },
    addToAllButton: {
        id: "share-and-restrict-dialog.resolve-restriction.add-to-all-button",
        defaultMessage: "Add to all"
    },
    multiUserSpaceViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with edit access at the space level only. They\u2019ll be added to the parent items with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserSpaceViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully edit <bold>{pageTitle}</bold>. Choose a role they should have in the space. They\u2019ll be added to any parent content with view-only access."
    },
    multiUserParentViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added to the parent items with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserParentViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully edit <bold>{pageTitle}</bold>. They\u2019ll be added to any parent items with view-only access."
    },
    multiUserViewBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs to be granted view access in other places first before they can successfully view <bold>{pageTitle}</bold>. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserViewRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs view access in other places first before they can successfully view <bold>{pageTitle}</bold>. They\u2019ll be added to any parent content with view-only access."
    },
    multiUserViewSpaceIncludedRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.space-included.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs view access in other places first before they can successfully view <bold>{pageTitle}</bold>. Choose a role they should have in the space. They\u2019ll be added to any parent content with view-only access."
    },
    usersNameList: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.single-restriction.body",
        defaultMessage: "{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}"
    },
    errorFlagTitle: {
        id: "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.title",
        defaultMessage: "Can\u2019t add guests"
    },
    errorFlagBodyDescription: {
        id: "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.body",
        defaultMessage: "One or more guests can\u2019t be added to the space because they have access to another space already. Guests can only access one space at a time."
    }
});
const $a159289724029162$var$collaboratorSystemRoleId = '0c103ff5-44d0-4b2a-b80d-8690442c95f0';
const $a159289724029162$var$selectStyle = (0, $ecnYn.xcss)({
    width: '150px'
});
const $a159289724029162$var$menuItemStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $a159289724029162$export$51715d98ed95f9db = (restrictedPrincipals = [])=>{
    const hasSpaceRestriction = restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE));
    const hasParentRestriction = restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType !== (0, $1chEN.ResourceType).SPACE));
    if (hasSpaceRestriction && hasParentRestriction) return 'space-and-parent';
    else if (hasSpaceRestriction) return 'space';
    else return 'parent';
};
const $a159289724029162$var$hasSpaceRestriction = (restrictedPrincipals = [])=>{
    return restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE));
};
const $a159289724029162$var$mapSpaceRoleToOption = (role)=>({
        id: role?.roleId || '',
        label: role?.roleName || '',
        value: role?.roleId || '',
        description: role?.roleDescription || ''
    });
const $a159289724029162$export$b8299340c4128c03 = (t0)=>{
    const $ = (0, $frIzR.c)(199);
    const { restrictedUserPrincipals: restrictedUserPrincipals, assignableSpaceRolesIntersection: assignableSpaceRolesIntersection, pageTitle: pageTitle, contentId: contentId, addMode: addMode, onComplete: onComplete, onClose: onClose, onCloseComplete: onCloseComplete, onSkip: onSkip, showErrorFlag: showErrorFlag, triggeredBy: triggeredBy } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const focusRef = (0, $42omo.useRef)(null);
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== assignableSpaceRolesIntersection) {
        t1 = assignableSpaceRolesIntersection?.map($a159289724029162$var$mapSpaceRoleToOption) || [];
        $[0] = assignableSpaceRolesIntersection;
        $[1] = t1;
    } else t1 = $[1];
    const roleOptions = t1;
    let t2;
    if ($[2] !== roleOptions) {
        t2 = ()=>{
            const collaboratorRole = roleOptions.find($a159289724029162$var$_temp);
            if (collaboratorRole) return collaboratorRole;
            return roleOptions[0] || null;
        };
        $[2] = roleOptions;
        $[3] = t2;
    } else t2 = $[3];
    const [selectedRole, setSelectedRole] = (0, $42omo.useState)(t2);
    let t3;
    if ($[4] !== onClose || $[5] !== onSkip) {
        t3 = ()=>{
            onSkip();
            onClose?.();
        };
        $[4] = onClose;
        $[5] = onSkip;
        $[6] = t3;
    } else t3 = $[6];
    const onCloseButtonClick = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const usersCount = restrictedUserPrincipals ? restrictedUserPrincipals.length : 0;
    let t4;
    let t5;
    if ($[7] !== createAnalyticsEvent || $[8] !== triggeredBy) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "ResolveRestrictionsDialog",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
        };
        t5 = [
            createAnalyticsEvent,
            triggeredBy
        ];
        $[7] = createAnalyticsEvent;
        $[8] = triggeredBy;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[11] !== restrictedUserPrincipals) {
        t6 = restrictedUserPrincipals?.map($a159289724029162$var$_temp2);
        $[11] = restrictedUserPrincipals;
        $[12] = t6;
    } else t6 = $[12];
    const blockedAccessSubjects = t6;
    let t7;
    if ($[13] !== contentType || $[14] !== createAnalyticsEvent || $[15] !== intl || $[16] !== onClose || $[17] !== onComplete || $[18] !== onSkip || $[19] !== restrictedUserPrincipals || $[20] !== showErrorFlag || $[21] !== triggeredBy || $[22] !== usersCount) {
        t7 = (data)=>{
            if (data?.resolveRestrictionsForSubjects?.success) {
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: "success",
                        actionSubject: "resolveRestrictionsForSubjects",
                        attributes: {
                            blockedUsersCount: usersCount,
                            blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                            contentType: contentType,
                            triggeredBy: triggeredBy
                        }
                    }
                }).fire();
                setIsLoading(false);
                onComplete();
                onClose?.();
            } else {
                const errors = data?.resolveRestrictionsForSubjects?.errors;
                const isGuestError = errors?.some($a159289724029162$var$_temp3);
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: "failure",
                        actionSubject: "resolveRestrictionsForSubjects",
                        attributes: {
                            blockedUsersCount: usersCount,
                            blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                            contentType: contentType,
                            errors: errors,
                            triggeredBy: triggeredBy
                        }
                    }
                }).fire();
                setIsLoading(false);
                if (isGuestError) {
                    showErrorFlag({
                        title: intl.formatMessage($a159289724029162$var$i18n.errorFlagTitle),
                        description: intl.formatMessage($a159289724029162$var$i18n.errorFlagBodyDescription),
                        isAutoDismiss: true
                    });
                    onSkip(isGuestError);
                    onClose?.();
                }
            }
        };
        $[13] = contentType;
        $[14] = createAnalyticsEvent;
        $[15] = intl;
        $[16] = onClose;
        $[17] = onComplete;
        $[18] = onSkip;
        $[19] = restrictedUserPrincipals;
        $[20] = showErrorFlag;
        $[21] = triggeredBy;
        $[22] = usersCount;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== createAnalyticsEvent || $[25] !== triggeredBy) {
        t8 = (error_0)=>{
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "errored",
                    actionSubject: "resolveRestrictionsForSubjects",
                    attributes: {
                        message: error_0?.message,
                        name: error_0?.name,
                        stack: error_0?.stack,
                        cause: error_0?.cause,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            setIsLoading(false);
        };
        $[24] = createAnalyticsEvent;
        $[25] = triggeredBy;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== t7 || $[28] !== t8) {
        t9 = {
            onCompleted: t7,
            onError: t8
        };
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    const [resolveRestrictionsForSubjectsMutation] = (0, $308Wd.useMutationInterop)($a159289724029162$var$ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation, t9);
    let t10;
    if ($[30] !== addMode || $[31] !== blockedAccessSubjects || $[32] !== contentId || $[33] !== contentType || $[34] !== createAnalyticsEvent || $[35] !== resolveRestrictionsForSubjectsMutation || $[36] !== restrictedUserPrincipals || $[37] !== selectedRole?.value || $[38] !== triggeredBy || $[39] !== usersCount) {
        t10 = ()=>{
            setIsLoading(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "AddResolveRestrictions",
                    attributes: {
                        blockedUsersCount: usersCount,
                        blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                        contentType: contentType,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            resolveRestrictionsForSubjectsMutation({
                variables: {
                    contentId: contentId,
                    accessType: addMode == "as-editor" ? (0, $1688F.ResourceAccessType).EDIT : (0, $1688F.ResourceAccessType).VIEW,
                    subjects: blockedAccessSubjects || [],
                    spaceRoleId: selectedRole?.value || null
                }
            });
        };
        $[30] = addMode;
        $[31] = blockedAccessSubjects;
        $[32] = contentId;
        $[33] = contentType;
        $[34] = createAnalyticsEvent;
        $[35] = resolveRestrictionsForSubjectsMutation;
        $[36] = restrictedUserPrincipals;
        $[37] = selectedRole?.value;
        $[38] = triggeredBy;
        $[39] = usersCount;
        $[40] = t10;
    } else t10 = $[40];
    const handleAdd = t10;
    let t11;
    if ($[41] !== contentType || $[42] !== createAnalyticsEvent || $[43] !== onClose || $[44] !== onSkip || $[45] !== restrictedUserPrincipals || $[46] !== triggeredBy || $[47] !== usersCount) {
        t11 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "SkipResolveRestrictions",
                    attributes: {
                        blockedUsersCount: usersCount,
                        blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                        contentType: contentType,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            onSkip();
            onClose?.();
        };
        $[41] = contentType;
        $[42] = createAnalyticsEvent;
        $[43] = onClose;
        $[44] = onSkip;
        $[45] = restrictedUserPrincipals;
        $[46] = triggeredBy;
        $[47] = usersCount;
        $[48] = t11;
    } else t11 = $[48];
    const handleSkip = t11;
    if (usersCount < 1) return null;
    const isSingleUserAndSingleRestriction = restrictedUserPrincipals?.length == 1 && restrictedUserPrincipals[0].restrictedResources?.length == 1;
    const firstRestriction = restrictedUserPrincipals && restrictedUserPrincipals?.length > 1 && restrictedUserPrincipals[0].restrictedResources?.length == 1 && restrictedUserPrincipals[0].restrictedResources[0];
    const isMultiUserSingleRestriction = !isSingleUserAndSingleRestriction && restrictedUserPrincipals?.every((obj)=>{
        if (obj?.restrictedResources?.length == 1) {
            if (firstRestriction && obj?.restrictedResources[0]?.resourceId == firstRestriction?.resourceId) return true;
        }
        return false;
    });
    let t12;
    if ($[49] !== addMode || $[50] !== isRbacEnabled || $[51] !== restrictedUserPrincipals || $[52] !== roleOptions || $[53] !== selectedRole) {
        t12 = ()=>{
            if (!isRbacEnabled || !$a159289724029162$var$hasSpaceRestriction(restrictedUserPrincipals)) return null;
            const roleSelectionBody = addMode === "as-viewer" ? $a159289724029162$var$i18n.spaceAccessRoleSelectionForViewAccessBody : $a159289724029162$var$i18n.spaceAccessRoleSelectionForEditAccessBody;
            const SELECT_STYLE_PROPS = {
                isSearchable: false,
                menuPortalTarget: document.body,
                styles: {
                    menu: $a159289724029162$var$_temp4,
                    menuPortal: $a159289724029162$var$_temp5
                }
            };
            const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($a159289724029162$var$_temp6);
            const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($a159289724029162$var$_temp7);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text",
                testId: "selectRoleText"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                values: {
                    bold: $a159289724029162$var$_temp8
                },
                ...roleSelectionBody
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $a159289724029162$var$selectStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
                options: roleOptions,
                value: selectedRole,
                onChange: (option)=>setSelectedRole(option),
                components: {
                    SingleValue: CustomSingleValue,
                    Option: CustomOption
                },
                ...SELECT_STYLE_PROPS
            })));
        };
        $[49] = addMode;
        $[50] = isRbacEnabled;
        $[51] = restrictedUserPrincipals;
        $[52] = roleOptions;
        $[53] = selectedRole;
        $[54] = t12;
    } else t12 = $[54];
    const renderSpaceRoleSelector = t12;
    if (isSingleUserAndSingleRestriction) {
        const singleUserPrincipal = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal;
        const singleRestrictedResource = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].restrictedResources && restrictedUserPrincipals[0].restrictedResources[0];
        const t13 = singleRestrictedResource && singleRestrictedResource.resourceLink.base || "";
        const t14 = singleRestrictedResource && singleRestrictedResource.resourceLink.webUi || "";
        let resourceUrl;
        if ($[55] !== t13 || $[56] !== t14) {
            resourceUrl = t13 + t14;
            if ((0, $1NBp8.FOLDER_VIEW).match(resourceUrl)) {
                resourceUrl = resourceUrl + "?referrer=share-and-restrict-dialog";
                resourceUrl;
            }
            $[55] = t13;
            $[56] = t14;
            $[57] = resourceUrl;
        } else resourceUrl = $[57];
        const resourceTitle = singleRestrictedResource && singleRestrictedResource.resourceTitle;
        const spaceAccessViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewAndEditBody;
        const spaceAccessView = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewBody;
        const parentAccessBody = isRbacEnabled ? $a159289724029162$var$i18n.parentAccessRolesRolesUpdateBody : $a159289724029162$var$i18n.parentAccessBody;
        const editorMessage = addMode === "as-editor" ? spaceAccessViewAndEdit : spaceAccessView;
        const singleUserBodyMessageId = singleRestrictedResource && singleRestrictedResource.resourceType == (0, $1chEN.ResourceType).SPACE ? editorMessage : parentAccessBody;
        let t15;
        if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a159289724029162$var$i18n.headingSingleUser));
            $[58] = t15;
        } else t15 = $[58];
        let t16;
        if ($[59] !== onCloseButtonClick) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, t15, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[59] = onCloseButtonClick;
            $[60] = t16;
        } else t16 = $[60];
        const t17 = singleUserPrincipal && singleUserPrincipal.avatarUrl;
        let t18;
        if ($[61] !== t17) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: t17
            });
            $[61] = t17;
            $[62] = t18;
        } else t18 = $[62];
        const t19 = singleUserPrincipal && singleUserPrincipal.name;
        let t20;
        if ($[63] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text"
            }, t19);
            $[63] = t19;
            $[64] = t20;
        } else t20 = $[64];
        let t21;
        if ($[65] !== t18 || $[66] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.150",
                alignBlock: "center"
            }, t18, t20);
            $[65] = t18;
            $[66] = t20;
            $[67] = t21;
        } else t21 = $[67];
        let t22;
        if ($[68] !== resourceUrl) {
            t22 = (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: resourceUrl
                }, chunks_0);
            $[68] = resourceUrl;
            $[69] = t22;
        } else t22 = $[69];
        let t23;
        if ($[70] !== pageTitle || $[71] !== resourceTitle || $[72] !== t22) {
            t23 = {
                pageTitle: pageTitle,
                resourceTitle: resourceTitle,
                resourceLink: t22,
                bold: $a159289724029162$var$_temp9,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[70] = pageTitle;
            $[71] = resourceTitle;
            $[72] = t22;
            $[73] = t23;
        } else t23 = $[73];
        let t24;
        if ($[74] !== singleUserBodyMessageId || $[75] !== t23) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                values: t23,
                ...singleUserBodyMessageId
            });
            $[74] = singleUserBodyMessageId;
            $[75] = t23;
            $[76] = t24;
        } else t24 = $[76];
        let t25;
        if ($[77] !== renderSpaceRoleSelector) {
            t25 = renderSpaceRoleSelector();
            $[77] = renderSpaceRoleSelector;
            $[78] = t25;
        } else t25 = $[78];
        let t26;
        if ($[79] !== t21 || $[80] !== t24 || $[81] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.200"
            }, t21, t24, t25));
            $[79] = t21;
            $[80] = t24;
            $[81] = t25;
            $[82] = t26;
        } else t26 = $[82];
        let t27;
        if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a159289724029162$var$i18n.skipButton);
            $[83] = t27;
        } else t27 = $[83];
        let t28;
        if ($[84] !== handleSkip || $[85] !== isLoading) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t27);
            $[84] = handleSkip;
            $[85] = isLoading;
            $[86] = t28;
        } else t28 = $[86];
        const t29 = singleRestrictedResource && singleRestrictedResource.resourceType == (0, $1chEN.ResourceType).SPACE ? $a159289724029162$var$i18n.addToSpaceButton : $a159289724029162$var$i18n.addToParentButton;
        let t30;
        if ($[87] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), t29);
            $[87] = t29;
            $[88] = t30;
        } else t30 = $[88];
        let t31;
        if ($[89] !== handleAdd || $[90] !== isLoading || $[91] !== t30) {
            t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t30);
            $[89] = handleAdd;
            $[90] = isLoading;
            $[91] = t30;
            $[92] = t31;
        } else t31 = $[92];
        let t32;
        if ($[93] !== t28 || $[94] !== t31) {
            t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, t28, t31);
            $[93] = t28;
            $[94] = t31;
            $[95] = t32;
        } else t32 = $[95];
        let t33;
        if ($[96] !== Modal || $[97] !== onClose || $[98] !== onCloseComplete || $[99] !== t16 || $[100] !== t26 || $[101] !== t32) {
            t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
                width: "500px",
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete,
                testId: "modal-dialog-resolve-restrictions"
            }, t16, t26, t32);
            $[96] = Modal;
            $[97] = onClose;
            $[98] = onCloseComplete;
            $[99] = t16;
            $[100] = t26;
            $[101] = t32;
            $[102] = t33;
        } else t33 = $[102];
        return t33;
    } else if (isMultiUserSingleRestriction) {
        let t13;
        if ($[103] !== restrictedUserPrincipals) {
            t13 = restrictedUserPrincipals ? restrictedUserPrincipals.map($a159289724029162$var$_temp0) : [];
            $[103] = restrictedUserPrincipals;
            $[104] = t13;
        } else t13 = $[104];
        const avatarGroupData = t13;
        const t14 = firstRestriction && firstRestriction.resourceLink.base || "";
        const t15 = firstRestriction && firstRestriction.resourceLink.webUi || "";
        let resourceUrl_0;
        if ($[105] !== t14 || $[106] !== t15) {
            resourceUrl_0 = t14 + t15;
            if ((0, $1NBp8.FOLDER_VIEW).match(resourceUrl_0)) {
                resourceUrl_0 = resourceUrl_0 + "?referrer=share-and-restrict-dialog";
                resourceUrl_0;
            }
            $[105] = t14;
            $[106] = t15;
            $[107] = resourceUrl_0;
        } else resourceUrl_0 = $[107];
        const spaceAccessViewAndEdit_0 = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewAndEditBody;
        const spaceAccessView_0 = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewBody;
        const i18nSpaceAccess = addMode === "as-editor" ? spaceAccessViewAndEdit_0 : spaceAccessView_0;
        const parentAccessBody_0 = isRbacEnabled ? $a159289724029162$var$i18n.parentAccessRolesRolesUpdateBody : $a159289724029162$var$i18n.parentAccessBody;
        const multiUserSingleRestrictionBodyMessageId = firstRestriction && firstRestriction.resourceType == (0, $1chEN.ResourceType).SPACE ? i18nSpaceAccess : parentAccessBody_0;
        let t16;
        if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a159289724029162$var$i18n.headingMultiUser));
            $[108] = t16;
        } else t16 = $[108];
        let t17;
        if ($[109] !== onCloseButtonClick) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, t16, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[109] = onCloseButtonClick;
            $[110] = t17;
        } else t17 = $[110];
        let t18;
        if ($[111] !== avatarGroupData) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
                appearance: "stack",
                data: avatarGroupData,
                maxCount: 4
            });
            $[111] = avatarGroupData;
            $[112] = t18;
        } else t18 = $[112];
        const t19 = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal ? restrictedUserPrincipals[0].userPrincipal.name : null;
        const t20 = restrictedUserPrincipals && restrictedUserPrincipals[1] && restrictedUserPrincipals[1].userPrincipal ? restrictedUserPrincipals[1].userPrincipal.name : null;
        const t21 = restrictedUserPrincipals && restrictedUserPrincipals[2] && restrictedUserPrincipals[2].userPrincipal ? restrictedUserPrincipals[2].userPrincipal.name : null;
        const t22 = restrictedUserPrincipals && restrictedUserPrincipals[3] && restrictedUserPrincipals[3].userPrincipal ? restrictedUserPrincipals[3].userPrincipal.name : null;
        const t23 = usersCount - 3;
        let t24;
        if ($[113] !== t19 || $[114] !== t20 || $[115] !== t21 || $[116] !== t22 || $[117] !== t23 || $[118] !== usersCount) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$a159289724029162$var$i18n.usersNameList,
                values: {
                    usersCount: usersCount,
                    firstUser: t19,
                    secondUser: t20,
                    thirdUser: t21,
                    fourthUser: t22,
                    remainingUserCount: t23
                }
            }));
            $[113] = t19;
            $[114] = t20;
            $[115] = t21;
            $[116] = t22;
            $[117] = t23;
            $[118] = usersCount;
            $[119] = t24;
        } else t24 = $[119];
        let t25;
        if ($[120] !== t18 || $[121] !== t24) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.100",
                alignBlock: "center"
            }, t18, t24);
            $[120] = t18;
            $[121] = t24;
            $[122] = t25;
        } else t25 = $[122];
        const t26 = firstRestriction && firstRestriction.resourceTitle;
        let t27;
        if ($[123] !== resourceUrl_0) {
            t27 = (chunks_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: resourceUrl_0
                }, chunks_2);
            $[123] = resourceUrl_0;
            $[124] = t27;
        } else t27 = $[124];
        let t28;
        if ($[125] !== pageTitle || $[126] !== t26 || $[127] !== t27) {
            t28 = {
                pageTitle: pageTitle,
                resourceTitle: t26,
                resourceLink: t27,
                bold: $a159289724029162$var$_temp1,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[125] = pageTitle;
            $[126] = t26;
            $[127] = t27;
            $[128] = t28;
        } else t28 = $[128];
        let t29;
        if ($[129] !== multiUserSingleRestrictionBodyMessageId || $[130] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                values: t28,
                ...multiUserSingleRestrictionBodyMessageId
            });
            $[129] = multiUserSingleRestrictionBodyMessageId;
            $[130] = t28;
            $[131] = t29;
        } else t29 = $[131];
        let t30;
        if ($[132] !== renderSpaceRoleSelector) {
            t30 = renderSpaceRoleSelector();
            $[132] = renderSpaceRoleSelector;
            $[133] = t30;
        } else t30 = $[133];
        let t31;
        if ($[134] !== t25 || $[135] !== t29 || $[136] !== t30) {
            t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.200"
            }, t25, t29, t30));
            $[134] = t25;
            $[135] = t29;
            $[136] = t30;
            $[137] = t31;
        } else t31 = $[137];
        let t32;
        if ($[138] === Symbol.for("react.memo_cache_sentinel")) {
            t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a159289724029162$var$i18n.skipButton);
            $[138] = t32;
        } else t32 = $[138];
        let t33;
        if ($[139] !== handleSkip || $[140] !== isLoading) {
            t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t32);
            $[139] = handleSkip;
            $[140] = isLoading;
            $[141] = t33;
        } else t33 = $[141];
        const t34 = firstRestriction && firstRestriction.resourceType == (0, $1chEN.ResourceType).SPACE ? $a159289724029162$var$i18n.addToSpaceButton : $a159289724029162$var$i18n.addToParentButton;
        let t35;
        if ($[142] !== t34) {
            t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), t34);
            $[142] = t34;
            $[143] = t35;
        } else t35 = $[143];
        let t36;
        if ($[144] !== handleAdd || $[145] !== isLoading || $[146] !== t35) {
            t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t35);
            $[144] = handleAdd;
            $[145] = isLoading;
            $[146] = t35;
            $[147] = t36;
        } else t36 = $[147];
        let t37;
        if ($[148] !== t33 || $[149] !== t36) {
            t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, t33, t36);
            $[148] = t33;
            $[149] = t36;
            $[150] = t37;
        } else t37 = $[150];
        let t38;
        if ($[151] !== Modal || $[152] !== onClose || $[153] !== onCloseComplete || $[154] !== t17 || $[155] !== t31 || $[156] !== t37) {
            t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
                width: "500px",
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, t17, t31, t37);
            $[151] = Modal;
            $[152] = onClose;
            $[153] = onCloseComplete;
            $[154] = t17;
            $[155] = t31;
            $[156] = t37;
            $[157] = t38;
        } else t38 = $[157];
        return t38;
    } else {
        const hasSpaceRestricted = $a159289724029162$var$hasSpaceRestriction(restrictedUserPrincipals);
        const multiUserSpaceViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.multiUserSpaceViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.multiUserSpaceViewAndEditBody;
        const multiUserParentViewAndEditBody = isRbacEnabled ? $a159289724029162$var$i18n.multiUserParentViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.multiUserParentViewAndEditBody;
        const multiUserViewAndEditI18n = hasSpaceRestricted ? multiUserSpaceViewAndEdit : multiUserParentViewAndEditBody;
        const multiUserViewRolesUpdateBody = hasSpaceRestricted ? $a159289724029162$var$i18n.multiUserViewSpaceIncludedRolesUpdateBody : $a159289724029162$var$i18n.multiUserViewRolesUpdateBody;
        const multiUserViewBody = isRbacEnabled ? multiUserViewRolesUpdateBody : $a159289724029162$var$i18n.multiUserViewBody;
        const multiUsersBodyMessageId = addMode === "as-editor" ? multiUserViewAndEditI18n : multiUserViewBody;
        const isSingleUser = restrictedUserPrincipals?.length === 1;
        const modalHeight = isSingleUser ? "inherit" : "600px";
        let t13;
        if ($[158] === Symbol.for("react.memo_cache_sentinel")) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a159289724029162$var$i18n.headingSingleUser));
            $[158] = t13;
        } else t13 = $[158];
        let t14;
        if ($[159] !== onCloseButtonClick) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[159] = onCloseButtonClick;
            $[160] = t14;
        } else t14 = $[160];
        const t15 = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal ? restrictedUserPrincipals[0].userPrincipal.name : null;
        const t16 = restrictedUserPrincipals && restrictedUserPrincipals[1] && restrictedUserPrincipals[1].userPrincipal ? restrictedUserPrincipals[1].userPrincipal.name : null;
        const t17 = restrictedUserPrincipals && restrictedUserPrincipals[2] && restrictedUserPrincipals[2].userPrincipal ? restrictedUserPrincipals[2].userPrincipal.name : null;
        const t18 = restrictedUserPrincipals && restrictedUserPrincipals[3] && restrictedUserPrincipals[3].userPrincipal ? restrictedUserPrincipals[3].userPrincipal.name : null;
        const t19 = usersCount - 3;
        let t20;
        if ($[161] !== pageTitle || $[162] !== t15 || $[163] !== t16 || $[164] !== t17 || $[165] !== t18 || $[166] !== t19 || $[167] !== usersCount) {
            t20 = {
                usersCount: usersCount,
                firstUser: t15,
                secondUser: t16,
                thirdUser: t17,
                fourthUser: t18,
                remainingUserCount: t19,
                pageTitle: pageTitle,
                bold: $a159289724029162$var$_temp10,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[161] = pageTitle;
            $[162] = t15;
            $[163] = t16;
            $[164] = t17;
            $[165] = t18;
            $[166] = t19;
            $[167] = usersCount;
            $[168] = t20;
        } else t20 = $[168];
        let t21;
        if ($[169] !== multiUsersBodyMessageId || $[170] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.100",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...multiUsersBodyMessageId,
                values: t20
            })));
            $[169] = multiUsersBodyMessageId;
            $[170] = t20;
            $[171] = t21;
        } else t21 = $[171];
        let t22;
        if ($[172] !== renderSpaceRoleSelector) {
            t22 = renderSpaceRoleSelector();
            $[172] = renderSpaceRoleSelector;
            $[173] = t22;
        } else t22 = $[173];
        let t23;
        if ($[174] !== restrictedUserPrincipals) {
            t23 = restrictedUserPrincipals && restrictedUserPrincipals.map($a159289724029162$var$_temp11);
            $[174] = restrictedUserPrincipals;
            $[175] = t23;
        } else t23 = $[175];
        let t24;
        if ($[176] !== t21 || $[177] !== t22 || $[178] !== t23) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.200"
            }, t21, t22, t23));
            $[176] = t21;
            $[177] = t22;
            $[178] = t23;
            $[179] = t24;
        } else t24 = $[179];
        let t25;
        if ($[180] === Symbol.for("react.memo_cache_sentinel")) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a159289724029162$var$i18n.skipButton);
            $[180] = t25;
        } else t25 = $[180];
        let t26;
        if ($[181] !== handleSkip || $[182] !== isLoading) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t25);
            $[181] = handleSkip;
            $[182] = isLoading;
            $[183] = t26;
        } else t26 = $[183];
        let t27;
        if ($[184] === Symbol.for("react.memo_cache_sentinel")) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a159289724029162$var$i18n.addToAllButton);
            $[184] = t27;
        } else t27 = $[184];
        let t28;
        if ($[185] !== handleAdd || $[186] !== isLoading) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t27);
            $[185] = handleAdd;
            $[186] = isLoading;
            $[187] = t28;
        } else t28 = $[187];
        let t29;
        if ($[188] !== t26 || $[189] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, t26, t28);
            $[188] = t26;
            $[189] = t28;
            $[190] = t29;
        } else t29 = $[190];
        let t30;
        if ($[191] !== Modal || $[192] !== modalHeight || $[193] !== onClose || $[194] !== onCloseComplete || $[195] !== t14 || $[196] !== t24 || $[197] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
                width: "500px",
                height: modalHeight,
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, t14, t24, t29);
            $[191] = Modal;
            $[192] = modalHeight;
            $[193] = onClose;
            $[194] = onCloseComplete;
            $[195] = t14;
            $[196] = t24;
            $[197] = t29;
            $[198] = t30;
        } else t30 = $[198];
        return t30;
    }
};
function $a159289724029162$var$_temp(role) {
    return role.id === $a159289724029162$var$collaboratorSystemRoleId;
}
function $a159289724029162$var$_temp2(user) {
    const blockedAccessSubject = {
        subjectId: user?.userPrincipal?.id || "",
        subjectType: (0, $1688F.BlockedAccessSubjectType).USER
    };
    return blockedAccessSubject;
}
function $a159289724029162$var$_temp3(error) {
    return error.message === "ExcoSingleSpaceException: Failed to save permission for guest: guest already has access to another space";
}
function $a159289724029162$var$_temp4(base) {
    return {
        ...base,
        width: "320px"
    };
}
function $a159289724029162$var$_temp5(base_0) {
    return {
        ...base_0,
        zIndex: 600
    };
}
function $a159289724029162$var$_temp6(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, props, props.data.label);
}
function $a159289724029162$var$_temp7(props_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props_0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a159289724029162$var$menuItemStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, props_0.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, props_0.data.description)));
}
function $a159289724029162$var$_temp8(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks);
}
function $a159289724029162$var$_temp9(chunks_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_1);
}
function $a159289724029162$var$_temp0(user_0) {
    return {
        key: user_0?.userPrincipal?.email || "",
        name: user_0?.userPrincipal?.name || "",
        href: "#",
        src: user_0?.userPrincipal?.avatarUrl || ""
    };
}
function $a159289724029162$var$_temp1(chunks_3) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_3);
}
function $a159289724029162$var$_temp10(chunk) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "bold"
    }, chunk);
}
function $a159289724029162$var$_temp11(user_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.050",
        key: user_1.userPrincipal?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
        role: "presentation",
        style: {
            width: "100%"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        key: user_1.userPrincipal?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3c7da.RestrictedUserResourcesDetails), {
        user: user_1.userPrincipal,
        restrictedResources: user_1.restrictedResources
    })));
}
module.exports["getBlockedResourceTypes"] = $a159289724029162$export$51715d98ed95f9db;
module.exports["ResolveRestrictionsDialog"] = $a159289724029162$export$b8299340c4128c03;

});

parcelRegister("lE63B", function(module, exports) {
/**
 * @generated SignedSource<<d7152b43db468a41d5711cbca042ce18>>
 * @relayHash 4a516532f481795a6fb98a0e01c981b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3fb282db83bed282d73474fa53054acdf7c575da6ffa5d4a3dec565ba86c9898
const $94aa94c1917f6c40$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accessType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceRoleId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subjects"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "accessType",
                            "variableName": "accessType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceRoleId",
                            "variableName": "spaceRoleId"
                        },
                        {
                            "kind": "Variable",
                            "name": "subjects",
                            "variableName": "subjects"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ResolveRestrictionsPayload",
            "kind": "LinkedField",
            "name": "resolveRestrictionsForSubjects",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "4a516532f481795a6fb98a0e01c981b9",
            "id": "3fb282db83bed282d73474fa53054acdf7c575da6ffa5d4a3dec565ba86c9898",
            "metadata": {},
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "operationKind": "mutation",
            "text": "mutation ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!,$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType,contentId:$contentId,subjects:$subjects,spaceRoleId:$spaceRoleId}){success,errors{message}}}"
        }
    };
}();
$94aa94c1917f6c40$var$node.hash = "ff5bb2cdac9b46578fa9fdfee10454ed";
var $94aa94c1917f6c40$export$2e2bcd8739ae039 = $94aa94c1917f6c40$var$node;
module.exports["default"] = $94aa94c1917f6c40$export$2e2bcd8739ae039;

});

parcelRegister("1688F", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $1565541f45629689$export$43eb1e191ddb78c0 = /*#__PURE__*/ function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["GROUP"] = "GROUP";
    BlockedAccessSubjectType["USER"] = "USER";
    return BlockedAccessSubjectType;
}({});
var $1565541f45629689$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});
module.exports["BlockedAccessSubjectType"] = $1565541f45629689$export$43eb1e191ddb78c0;
module.exports["ResourceAccessType"] = $1565541f45629689$export$8e7b7bb509dc942b;

});

parcelRegister("1chEN", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $597ccb3a2cb4013d$export$43eb1e191ddb78c0 = /*#__PURE__*/ function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["GROUP"] = "GROUP";
    BlockedAccessSubjectType["USER"] = "USER";
    return BlockedAccessSubjectType;
}({});
var $597ccb3a2cb4013d$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});
var $597ccb3a2cb4013d$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["DATABASE"] = "DATABASE";
    ResourceType["FOLDER"] = "FOLDER";
    ResourceType["PAGE"] = "PAGE";
    ResourceType["SPACE"] = "SPACE";
    ResourceType["WHITEBOARD"] = "WHITEBOARD";
    return ResourceType;
}({});
var $597ccb3a2cb4013d$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({});
module.exports["ResourceType"] = $597ccb3a2cb4013d$export$c6f9da6f70cfc2eb;

});

parcelRegister("3c7da", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $esRft = parcelRequire("esRft");


var $9Q2dU = parcelRequire("9Q2dU");


var $5tmwS = parcelRequire("5tmwS");


var $6B0jU = parcelRequire("6B0jU");


var $ZDq1z = parcelRequire("ZDq1z");


var $8jHAi = parcelRequire("8jHAi");


var $cO1el = parcelRequire("cO1el");


var $iKskQ = parcelRequire("iKskQ");

const $c3b447d238ca71b0$var$i18n = (0, $aXWIB.defineMessages)({
    needsAccess: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.needs-access",
        defaultMessage: "needs access in {resourcesCount} {resourcesCount, plural, one {place} other {places}}:"
    },
    space: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.space",
        defaultMessage: "Space"
    },
    parentItems: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.parent-items",
        defaultMessage: "Parent items"
    }
});
const $c3b447d238ca71b0$var$getContenTypeIcon = (type)=>{
    switch(type){
        case 'DATABASE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
                label: "Databse"
            });
        case 'WHITEBOARD':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                label: "Whiteboard"
            });
        case 'PAGE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                label: "Page"
            });
        case 'FOLDER':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
                label: "Page"
            });
        case 'SPACE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
                size: "xsmall",
                src: "/images/logo/default-space-logo-256.png"
            });
    }
};
const $c3b447d238ca71b0$var$SingleResourcesDetails = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { restrictedResource: restrictedResource, showLock: showLock } = t0;
    let t1;
    if ($[0] !== showLock) {
        t1 = showLock ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        }) : null;
        $[0] = showLock;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== restrictedResource) {
        t2 = restrictedResource && $c3b447d238ca71b0$var$getContenTypeIcon(restrictedResource.resourceType);
        $[2] = restrictedResource;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = restrictedResource ? restrictedResource.resourceTitle : "";
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.150",
            alignBlock: "center"
        }, t1, t2, t4);
        $[6] = t1;
        $[7] = t2;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $c3b447d238ca71b0$export$c6de5a3e56b68494 = (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { user: user, restrictedResources: restrictedResources } = t0;
    let t1;
    if ($[0] !== restrictedResources) {
        t1 = restrictedResources && restrictedResources.filter($c3b447d238ca71b0$var$_temp);
        $[0] = restrictedResources;
        $[1] = t1;
    } else t1 = $[1];
    const resourcesWithoutSpace = t1;
    let t2;
    if ($[2] !== restrictedResources) {
        t2 = restrictedResources && restrictedResources.filter($c3b447d238ca71b0$var$_temp2);
        $[2] = restrictedResources;
        $[3] = t2;
    } else t2 = $[3];
    const restrictedSpaces = t2;
    const resourcesWithoutSpaceCount = resourcesWithoutSpace ? resourcesWithoutSpace.length : 0;
    const restrictedSpacesCount = restrictedSpaces ? restrictedSpaces.length : 0;
    const resourcesCount = resourcesWithoutSpaceCount + restrictedSpacesCount;
    const t3 = user && user.avatarUrl;
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: t3
        });
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const t5 = user && user.name;
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text",
            weight: "bold"
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== resourcesCount) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            values: {
                resourcesCount: resourcesCount
            },
            ...$c3b447d238ca71b0$var$i18n.needsAccess
        });
        $[8] = resourcesCount;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center"
        }, t4, t6, t7);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== restrictedSpaces) {
        t9 = restrictedSpaces && restrictedSpaces.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xxsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c3b447d238ca71b0$var$i18n.space)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.150"
        }, restrictedSpaces.map($c3b447d238ca71b0$var$_temp3))) : null;
        $[14] = restrictedSpaces;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== resourcesWithoutSpace) {
        t10 = resourcesWithoutSpace && resourcesWithoutSpace.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xxsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c3b447d238ca71b0$var$i18n.parentItems)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            alignBlock: "center"
        }, resourcesWithoutSpace.map($c3b447d238ca71b0$var$_temp4)))) : null;
        $[16] = resourcesWithoutSpace;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== t10 || $[19] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.500"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            alignBlock: "center"
        }, t9, t10));
        $[18] = t10;
        $[19] = t9;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== t11 || $[22] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, t8, t11);
        $[21] = t11;
        $[22] = t8;
        $[23] = t12;
    } else t12 = $[23];
    return t12;
};
function $c3b447d238ca71b0$var$_temp(resource) {
    if (resource?.resourceType === "SPACE") return false;
    return true;
}
function $c3b447d238ca71b0$var$_temp2(resource_0) {
    if (resource_0?.resourceType === "SPACE") return true;
    return false;
}
function $c3b447d238ca71b0$var$_temp3(resource_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b447d238ca71b0$var$SingleResourcesDetails, {
        restrictedResource: resource_1,
        showLock: false,
        key: resource_1?.resourceId
    });
}
function $c3b447d238ca71b0$var$_temp4(resource_2) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b447d238ca71b0$var$SingleResourcesDetails, {
        restrictedResource: resource_2,
        showLock: true,
        key: resource_2?.resourceId
    });
}
module.exports["RestrictedUserResourcesDetails"] = $c3b447d238ca71b0$export$c6de5a3e56b68494;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $4wwVl = parcelRequire("4wwVl");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $gMc0m.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    const setLoaded = (0, $42omo.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("7QoAs", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $d9tcB = parcelRequire("d9tcB");


var $fdPUP = parcelRequire("fdPUP");


var $4Ewfm = parcelRequire("4Ewfm");


var $22cFL = parcelRequire("22cFL");


var $jI7Td = parcelRequire("jI7Td");

const $164b2844d962585d$var$blockedAccessUsersLimit = 10;
const $164b2844d962585d$var$blockedAccessLevelsLimit = 10;
const $164b2844d962585d$export$4da22e4767045266 = async ({ contentId: contentId, cloudId: cloudId, edition: edition, numberOfAncestors: numberOfAncestors, addMode: addMode, stagedUserPrincipals: stagedUserPrincipals, setMasterState: setMasterState, fireAnalyticEvent: fireAnalyticEvent })=>{
    //The validation  is skipped if free edition
    if (edition == (0, $d9tcB.ConfluenceEdition).FREE) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    const activeStagedUserPrincipals = stagedUserPrincipals.filter((user)=>!(0, $4Ewfm.isUserPendingAccess)({
            type: 'user',
            ...user
        }));
    //The validation  is skipped if staged user count is 0
    if (activeStagedUserPrincipals.length == 0) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    // if staged user count is greater than 10,
    // or content is more than 10 levels deep
    if (activeStagedUserPrincipals.length > $164b2844d962585d$var$blockedAccessUsersLimit || numberOfAncestors > $164b2844d962585d$var$blockedAccessLevelsLimit) {
        fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'BlockedAccessCheckLimitExceeded',
            actionSubject: 'BlockedAccessCheck',
            source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
            attributes: {
                NewUsersCount: activeStagedUserPrincipals.length,
                numberOfAncestors: numberOfAncestors
            }
        });
        const accountIds = activeStagedUserPrincipals.map((user)=>{
            return user.id;
        });
        const { data: usersContentAccessData, errors: usersContentAccessErrors } = await (0, $c0rhi.queryInterop)({
            query: (0, $jI7Td.default),
            variables: {
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                accountIds: accountIds,
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'network-only'
        });
        if (usersContentAccessErrors) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'UsersContentAccessQuery',
                actionSubjectId: 'validateRestrictedPrincipals',
                attributes: {
                    message: usersContentAccessErrors[0]?.message
                }
            });
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: false
            };
        }
        const canNotAccessList = usersContentAccessData?.confluence_userContentAccess?.cannotAccessList;
        if (canNotAccessList != null && canNotAccessList.length > 0) {
            const restrictedUserPrincipalsList = canNotAccessList.map((userId)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === userId),
                    restrictedResources: null
                };
                return restrictedPrincipal;
            });
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList
                }));
            return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
        }
    } else {
        const blockedAccessSubjects = activeStagedUserPrincipals.map((user)=>{
            const blockedAccessSubject = {
                subjectId: user.id,
                subjectType: 'USER'
            };
            return blockedAccessSubject;
        });
        const { data: data, errors: errors } = await (0, $c0rhi.queryInterop)({
            query: (0, $22cFL.default),
            variables: {
                // The GraphQL query expects a number, but contentId is a string. For the relay migration we will type it as any to not break existing functionality,
                // but this should be fixed in the future and keep the types consistent.
                contentId: contentId,
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                subjects: blockedAccessSubjects
            },
            fetchPolicy: 'network-only'
        });
        if (errors) fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'errored',
            actionSubject: 'BlockedAccessRestrictionsQuery',
            actionSubjectId: 'validateRestrictedPrincipals',
            attributes: {
                message: errors[0]?.message
            }
        });
        const blockedAccessRestrictions = data?.blockedAccessRestrictions;
        const blockedAccessRestrictionSummary = blockedAccessRestrictions?.blockedAccessRestrictionSummary;
        if (blockedAccessRestrictions && blockedAccessRestrictionSummary && blockedAccessRestrictionSummary.length > 0) {
            const restrictedUserPrincipalsList = blockedAccessRestrictionSummary.map((restrictedUser)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === restrictedUser?.subject?.subjectId),
                    restrictedResources: restrictedUser?.restrictedResources
                };
                return restrictedPrincipal;
            });
            const assignableSpaceRolesIntersection = blockedAccessRestrictions.blockedAccessAssignableSpaceRolesIntersection;
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
                }));
            //current user is not empowered to fix at least one of the selected user's restrictions
            if (!blockedAccessRestrictions.canFixRestrictionsForAllSubjects) return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: true,
                // Expose this extra info for Realtime requests to consume
                // In USD these get set directly on the masterState
                // But realtime requests don't have access to masterState
                restrictedUserPrincipals: restrictedUserPrincipalsList,
                assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
            };
        }
    }
    // all added principles can access or blocked access was skipped
    return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
};
module.exports["validateRestrictedPrincipals"] = $164b2844d962585d$export$4da22e4767045266;

});

parcelRegister("22cFL", function(module, exports) {
/**
 * @generated SignedSource<<d23d3ae2363469dfab348520f136999d>>
 * @relayHash 0823488049ea540f2c3f5c4cb3a9f517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed
const $855873b1252722a0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjects"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "subjectId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "subjects",
                    "variableName": "subjects"
                }
            ],
            "concreteType": "BlockedAccessRestrictions",
            "kind": "LinkedField",
            "name": "blockedAccessRestrictions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SubjectRestrictionHierarchySummary",
                    "kind": "LinkedField",
                    "name": "blockedAccessRestrictionSummary",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "BlockedAccessSubject",
                            "kind": "LinkedField",
                            "name": "subject",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "subjectType"
                                }
                            ]
                        },
                        {
                            "concreteType": "RestrictedResource",
                            "kind": "LinkedField",
                            "name": "restrictedResources",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceTitle"
                                },
                                {
                                    "concreteType": "RestrictedResourceLinks",
                                    "kind": "LinkedField",
                                    "name": "resourceLink",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "base"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUi"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredAccessType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceType"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "BlockedAccessEmpowerment",
                    "kind": "LinkedField",
                    "name": "blockedAccessEmpowerment",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCurrentUserEmpowered"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceBlockedAccessAssignableSpaceRole",
                    "kind": "LinkedField",
                    "name": "blockedAccessAssignableSpaceRolesIntersection",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "canFixRestrictionsForAllSubjects"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0823488049ea540f2c3f5c4cb3a9f517",
            "id": "e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed",
            "metadata": {},
            "name": "BlockedAccessRestrictionsQuery",
            "operationKind": "query",
            "text": "query BlockedAccessRestrictionsQuery($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!){blockedAccessRestrictions(accessType:$accessType,contentId:$contentId,subjects:$subjects){blockedAccessRestrictionSummary{subject{subjectId,subjectType},restrictedResources{resourceId,resourceTitle,resourceLink{base,webUi},requiredAccessType,resourceType}},blockedAccessEmpowerment{subjectId,isCurrentUserEmpowered},blockedAccessAssignableSpaceRolesIntersection{roleId,roleDescription,roleName,roleType},canFixRestrictionsForAllSubjects}}"
        }
    };
}();
$855873b1252722a0$var$node.hash = "cc9731fa07afd21d30e45e70eeb338f4";
var $855873b1252722a0$export$2e2bcd8739ae039 = $855873b1252722a0$var$node;
module.exports["default"] = $855873b1252722a0$export$2e2bcd8739ae039;

});

parcelRegister("jI7Td", function(module, exports) {
/**
 * @generated SignedSource<<a8e02494c003ce9642cd610a5717fc5f>>
 * @relayHash 727771f625528321882e822398d219fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9
const $b86f4f4db61ac40f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceUserContentAccessResult",
            "kind": "LinkedField",
            "name": "confluence_userContentAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAccessList"
                },
                {
                    "kind": "ScalarField",
                    "name": "cannotAccessList"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "727771f625528321882e822398d219fd",
            "id": "e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9",
            "metadata": {},
            "name": "UsersContentAccessQuery",
            "operationKind": "query",
            "text": "query UsersContentAccessQuery($accessType:ResourceAccessType!,$accountIds:[String]!,$cloudId:ID!,$contentId:ID!){confluence_userContentAccess(accessType:$accessType,accountIds:$accountIds,cloudId:$cloudId,contentId:$contentId){canAccessList,cannotAccessList}}"
        }
    };
}();
$b86f4f4db61ac40f$var$node.hash = "3af84917efe0ce91f68b18f96d2f126c";
var $b86f4f4db61ac40f$export$2e2bcd8739ae039 = $b86f4f4db61ac40f$var$node;
module.exports["default"] = $b86f4f4db61ac40f$export$2e2bcd8739ae039;

});

parcelRegister("f2UnK", function(module, exports) {

var $8NGcs = parcelRequire("8NGcs");


var $dYU3e = parcelRequire("dYU3e");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery = (0, $8NGcs.default);
const $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d = (cloudId)=>{
    return (0, $dYU3e.query)({
        query: $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery,
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: 'cache-first'
    }).then(({ data: data, hasErrors: hasErrors })=>{
        if (hasErrors) // Handle errors silently for preloading
        return null;
        return data?.confluence_spaceRoleMode || null;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    });
};
const $0ac8a6fa9069d7d8$export$c715e7f8018f9029 = async (cloudId)=>{
    await $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d(cloudId);
};
module.exports["preloadSpaceRoleMode"] = $0ac8a6fa9069d7d8$export$c715e7f8018f9029;

});

parcelRegister("8NGcs", function(module, exports) {
/**
 * @generated SignedSource<<84fb53b6d98189b320531115364d143c>>
 * @relayHash 4c198432b204cbcb18fb5160733adf98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4
const $556eda7e15abe5d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4c198432b204cbcb18fb5160733adf98",
            "id": "cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4",
            "metadata": {},
            "name": "preloadSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query preloadSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$556eda7e15abe5d2$var$node.hash = "1b6118c2bdcdd04e86f799370c9c7bca";
var $556eda7e15abe5d2$export$2e2bcd8739ae039 = $556eda7e15abe5d2$var$node;
module.exports["default"] = $556eda7e15abe5d2$export$2e2bcd8739ae039;

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("ajdQJ", function(module, exports) {
class $78166bfa877f38c2$var$SafeString {
    constructor(value){
        this.value = value;
        this.valueOf = this.toString = this.toJSON = ()=>this.value;
    }
}
const $78166bfa877f38c2$export$b91bb42a4e3ff500 = (value)=>new $78166bfa877f38c2$var$SafeString(value);
const $78166bfa877f38c2$export$7d336779073e9481 = (value)=>value instanceof $78166bfa877f38c2$var$SafeString;
const $78166bfa877f38c2$export$2a4aba80518f1883 = (...allowedStrings)=>(value)=>allowedStrings.includes(value) ? Object.freeze(new $78166bfa877f38c2$var$SafeString(value)) : value;
module.exports["dangerouslyCreateSafeString"] = $78166bfa877f38c2$export$b91bb42a4e3ff500;
module.exports["markAsSafe"] = $78166bfa877f38c2$export$2a4aba80518f1883;

});

parcelRegister("1BYn9", function(module, exports) {

var $3TDto = parcelRequire("3TDto");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $fWkVZ = parcelRequire("fWkVZ");


var $jMyy4 = parcelRequire("jMyy4");

const $141bd073c52fec74$export$44f5b9746e66da9 = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $jMyy4.useQueryInterop)((0, $3TDto.default));
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(data);
    return {
        isProductAdmin: isProductAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsProductAdmin"] = $141bd073c52fec74$export$44f5b9746e66da9;

});

parcelRegister("3TDto", function(module, exports) {
/**
 * @generated SignedSource<<38ac79bd1ceae98336c6c12cf485904b>>
 * @relayHash d40e79986defbb74ee71a42460f4e593
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622
const $7c2c3a08c3ad61f2$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d40e79986defbb74ee71a42460f4e593",
            "id": "fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622",
            "metadata": {},
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "operationKind": "query",
            "text": "query useIsProductAdminUseIsProductAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
        }
    };
}();
$7c2c3a08c3ad61f2$var$node.hash = "179058bf05f0f539ac360b7a899d6923";
var $7c2c3a08c3ad61f2$export$2e2bcd8739ae039 = $7c2c3a08c3ad61f2$var$node;
module.exports["default"] = $7c2c3a08c3ad61f2$export$2e2bcd8739ae039;

});

parcelRegister("letmB", function(module, exports) {

var $a2xFu = parcelRequire("a2xFu");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8HDoM = parcelRequire("8HDoM");


var $vOJcF = parcelRequire("vOJcF");


var $c0rhi = parcelRequire("c0rhi");

const $a2d59a8e8d049c83$export$c3db30b0866daf5a = 'companyHubAnnouncementBannerId';
const $a2d59a8e8d049c83$export$324fa2b24bd3bd0 = async (contentId, tenantId)=>{
    try {
        // Fetch the announcement banner id from the page properties
        const { data: dataAnnouncementBanner } = await (0, $c0rhi.queryInterop)({
            query: (0, $8HDoM.CompanyHubAnnouncementBannerQuery),
            variables: {
                pageId: (0, $a2xFu.ConfluencePageAri).create({
                    siteId: tenantId,
                    pageId: contentId
                }).toString(),
                keys: [
                    $a2d59a8e8d049c83$export$c3db30b0866daf5a
                ]
            }
        });
        const bannerId = dataAnnouncementBanner?.confluence?.page?.properties?.[0]?.value;
        if (!bannerId) return {
            bannerId: null
        };
        // If the announcement banner exists check banner status
        const { data: dataAnnouncementBannerStatus } = await (0, $c0rhi.queryInterop)({
            query: (0, $vOJcF.CompanyHubAnnouncementBannerStatusQuery),
            variables: {
                bannerId: bannerId
            }
        });
        return {
            bannerId: bannerId,
            bannerStatus: dataAnnouncementBannerStatus?.adminAnnouncementBannerSetting?.status
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            bannerId: null
        };
    }
};
module.exports["COMPANY_HUB_ANNOUNCEMENT_BANNER_CONTENT_PROPERTY_KEY"] = $a2d59a8e8d049c83$export$c3db30b0866daf5a;
module.exports["getCompanyHubAnnouncementBanner"] = $a2d59a8e8d049c83$export$324fa2b24bd3bd0;

});

parcelRegister("8HDoM", function(module, exports) {

var $1zTRY = parcelRequire("1zTRY");

const $b548b68664ebb0d0$export$89196b32c22f357e = (0, $1zTRY.default);
module.exports["CompanyHubAnnouncementBannerQuery"] = $b548b68664ebb0d0$export$89196b32c22f357e;

});

parcelRegister("1zTRY", function(module, exports) {
/**
 * @generated SignedSource<<66789805880df0a0bcdc594422521efc>>
 * @relayHash d5bf5df01eff840f9b29492824ebb770
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f2dbcd4c020f3063655a22a146ec1e45596f5206fe356d3370930377f841e1ab
const $6e08b27e27741697$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keys"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "concreteType": "ConfluenceQueryApi",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "pageId"
                        }
                    ],
                    "concreteType": "ConfluencePage",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "keys",
                                    "variableName": "keys"
                                }
                            ],
                            "concreteType": "ConfluencePageProperty",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CompanyHubAnnouncementBannerQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CompanyHubAnnouncementBannerQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d5bf5df01eff840f9b29492824ebb770",
            "id": "f2dbcd4c020f3063655a22a146ec1e45596f5206fe356d3370930377f841e1ab",
            "metadata": {},
            "name": "CompanyHubAnnouncementBannerQuery",
            "operationKind": "query",
            "text": "query CompanyHubAnnouncementBannerQuery($pageId:ID!,$keys:[String]!){confluence{page(id:$pageId){id,properties(keys:$keys){key,value,id}}}}"
        }
    };
}();
$6e08b27e27741697$var$node.hash = "fbfc6dce8692747276f81029c894fe08";
var $6e08b27e27741697$export$2e2bcd8739ae039 = $6e08b27e27741697$var$node;
module.exports["default"] = $6e08b27e27741697$export$2e2bcd8739ae039;

});

parcelRegister("vOJcF", function(module, exports) {

var $dXZhO = parcelRequire("dXZhO");

const $bee353d845b65bc1$export$b7c5a946c2c575d = (0, $dXZhO.default);
module.exports["CompanyHubAnnouncementBannerStatusQuery"] = $bee353d845b65bc1$export$b7c5a946c2c575d;

});

parcelRegister("dXZhO", function(module, exports) {
/**
 * @generated SignedSource<<c24980dadf415e9c7c6f46cda359cf62>>
 * @relayHash 63ebc26c4e8f00afe8b0ef90b6f20478
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 517e7bc0b657d6a5cbc2554de9f2e62ee6b8f153890e617c5b562206f56ba7c1
const $a96221200ab74212$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "bannerId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "bannerId"
                }
            ],
            "concreteType": "ConfluenceAdminAnnouncementBannerSetting",
            "kind": "LinkedField",
            "name": "adminAnnouncementBannerSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CompanyHubAnnouncementBannerStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CompanyHubAnnouncementBannerStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "63ebc26c4e8f00afe8b0ef90b6f20478",
            "id": "517e7bc0b657d6a5cbc2554de9f2e62ee6b8f153890e617c5b562206f56ba7c1",
            "metadata": {},
            "name": "CompanyHubAnnouncementBannerStatusQuery",
            "operationKind": "query",
            "text": "query CompanyHubAnnouncementBannerStatusQuery($bannerId:String!){adminAnnouncementBannerSetting(id:$bannerId){id,status}}"
        }
    };
}();
$a96221200ab74212$var$node.hash = "0729b964654c5bed0f702b89156648b8";
var $a96221200ab74212$export$2e2bcd8739ae039 = $a96221200ab74212$var$node;
module.exports["default"] = $a96221200ab74212$export$2e2bcd8739ae039;

});

parcelRegister("k7Jwr", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $0714d46e5830d709$export$99fe151f78e1a08f = /*#__PURE__*/ function(GraphQLFrontCoverState) {
    GraphQLFrontCoverState["HIDDEN"] = "HIDDEN";
    GraphQLFrontCoverState["SHOWN"] = "SHOWN";
    GraphQLFrontCoverState["UNSET"] = "UNSET";
    return GraphQLFrontCoverState;
}({});
module.exports["GraphQLFrontCoverState"] = $0714d46e5830d709$export$99fe151f78e1a08f;

});

parcelRegister("5wLVq", function(module, exports) {

var $dYrYQ = parcelRequire("dYrYQ");


var $k7Jwr = parcelRequire("k7Jwr");


var $8DBCv = parcelRequire("8DBCv");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");

const $14b7107f244f2fb8$export$eb7670413c83c3d4 = ()=>{
    const [updateSiteLookAndFeel, { data: data, loading: loading, error: error }] = (0, $308Wd.useMutationInterop)((0, $dYrYQ.default), {
        update: (_cache, { data: data })=>{
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $8DBCv.default),
                data: {
                    siteSettings: {
                        // Codegen is specifically configured to not add __typename when generating the types file,
                        // so unfortunately ts-ignore is required here.
                        // @ts-ignore
                        __typename: 'SiteSettings',
                        frontCover: {
                            // Codegen is specifically configured to not add __typename when generating the types file,
                            // so unfortunately ts-ignore is required here.
                            // @ts-ignore
                            __typename: 'FrontCover',
                            frontCoverState: data?.updateSiteLookAndFeel?.siteLookAndFeel?.frontCoverState
                        }
                    }
                }
            });
        }
    });
    const changeHubPublishState = (frontCoverState)=>updateSiteLookAndFeel({
            variables: {
                input: {
                    faviconFiles: [],
                    frontCoverState: frontCoverState,
                    showFrontCover: frontCoverState === (0, $k7Jwr.GraphQLFrontCoverState).SHOWN
                }
            }
        });
    return {
        data: data,
        loading: loading,
        error: error,
        changeHubPublishState: changeHubPublishState
    };
};
module.exports["useChangeCompanyHubPublishState"] = $14b7107f244f2fb8$export$eb7670413c83c3d4;

});

parcelRegister("dYrYQ", function(module, exports) {
/**
 * @generated SignedSource<<e44b7bf63d841e43ab0c99ce632182bf>>
 * @relayHash a2b4f79ba8694b8a2d5afbaf9da0fcb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f0dfbbfc5c4fa6e0daaf56d8218ccb97b40043f636316a0df8b893f60d7ec2a
const $60288b3398c0f5d0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "concreteType": "SiteLookAndFeel",
        "kind": "LinkedField",
        "name": "siteLookAndFeel",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "frontCoverState"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "UpdateSiteLookAndFeelPayload",
                    "kind": "LinkedField",
                    "name": "updateSiteLookAndFeel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "UpdateSiteLookAndFeelPayload",
                    "kind": "LinkedField",
                    "name": "updateSiteLookAndFeel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a2b4f79ba8694b8a2d5afbaf9da0fcb0",
            "id": "4f0dfbbfc5c4fa6e0daaf56d8218ccb97b40043f636316a0df8b893f60d7ec2a",
            "metadata": {},
            "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
            "operationKind": "mutation",
            "text": "mutation useChangeCompanyHubPublishStateChangeHubPublishStateMutation($input:UpdateSiteLookAndFeelInput!){updateSiteLookAndFeel(input:$input){siteLookAndFeel{frontCoverState},success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$60288b3398c0f5d0$var$node.hash = "5001b4614b3c544c07ab66e207d7fc69";
var $60288b3398c0f5d0$export$2e2bcd8739ae039 = $60288b3398c0f5d0$var$node;
module.exports["default"] = $60288b3398c0f5d0$export$2e2bcd8739ae039;

});

parcelRegister("8DBCv", function(module, exports) {
/**
 * @generated SignedSource<<786c2a248e6cb5c6bcc28a3653f8307e>>
 * @relayHash cf3a11251bae2782447696e602cbd833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c8c8215334c6aaae5ba752034e6f1f94c2510353995460bd924dc0af55a18cb5
const $01986b5e53f5d2cf$var$node = function() {
    var v0 = [
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "FrontCover",
                    "kind": "LinkedField",
                    "name": "frontCover",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "frontCoverState"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ChangeHubPublishStateWriteQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ChangeHubPublishStateWriteQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "cf3a11251bae2782447696e602cbd833",
            "id": "c8c8215334c6aaae5ba752034e6f1f94c2510353995460bd924dc0af55a18cb5",
            "metadata": {},
            "name": "ChangeHubPublishStateWriteQuery",
            "operationKind": "query",
            "text": "query ChangeHubPublishStateWriteQuery{siteSettings{frontCover{frontCoverState}}}"
        }
    };
}();
$01986b5e53f5d2cf$var$node.hash = "c5edd80e44855ef2031199e9bcac6386";
var $01986b5e53f5d2cf$export$2e2bcd8739ae039 = $01986b5e53f5d2cf$var$node;
module.exports["default"] = $01986b5e53f5d2cf$export$2e2bcd8739ae039;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("a9mGH"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("a9mGH", function(module, exports) {

let $763c57f46bb5d4e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $763c57f46bb5d4e7$var$load("6wr18"),
    $763c57f46bb5d4e7$var$load("ffEVr"),
    $763c57f46bb5d4e7$var$load("3DgZV"),
    $763c57f46bb5d4e7$var$load("7EorR"),
    $763c57f46bb5d4e7$var$load("hhss7"),
    $763c57f46bb5d4e7$var$load("2OcM6"),
    $763c57f46bb5d4e7$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $42omo.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        }
    });
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<c2dfd6c4d3d5c9094f289e2a6367c967>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});

parcelRegister("iVU5h", function(module, exports) {
const $6269d9b82324487a$export$42ca032027818031 = ()=>{
    return new URLSearchParams(window.location.search).get('amn-referral-source') || '';
};
module.exports["getAMNReferralSourceFromQueryParam"] = $6269d9b82324487a$export$42ca032027818031;

});

parcelRegister("iSXh4", function(module, exports) {

var $9VdrT = parcelRequire("9VdrT");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $9VdrT.default);
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("9VdrT", function(module, exports) {
/**
 * @generated SignedSource<<11b231cd6c02553d35cade7f32b48a2a>>
 * @relayHash 2d27dcc1d1eac2731f01ec3e79c7f7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd
const $2aa10c7c748cb29a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2d27dcc1d1eac2731f01ec3e79c7f7d9",
            "id": "bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd",
            "metadata": {},
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$2aa10c7c748cb29a$var$node.hash = "a7e1d622b5e3dfb0202b4f6045de22bd";
var $2aa10c7c748cb29a$export$2e2bcd8739ae039 = $2aa10c7c748cb29a$var$node;
module.exports["default"] = $2aa10c7c748cb29a$export$2e2bcd8739ae039;

});

parcelRegister("70LTe", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $da99c994e33d3600$export$6654a9a4dc3a2802 = ()=>{
    return (0, $42omo.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
module.exports["useEmbeddedConfluenceEventMarkers"] = $da99c994e33d3600$export$6654a9a4dc3a2802;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("3StSI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $5Z8MD = parcelRequire("5Z8MD");


var $4lI3M = parcelRequire("4lI3M");

const $e450de9019b1af6a$export$107265ce1e467930 = (props)=>{
    if ((0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4lI3M.UFOLoadMarkFMP), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Z8MD.Bm3PageLoadMarkFMP), props);
};
module.exports["PageLoadMarkFMP"] = $e450de9019b1af6a$export$107265ce1e467930;

});

parcelRegister("5Z8MD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");

/**
 * This component allows to mark customized FMP metric on page-load event.
 */ const $4cdad5edb4cc053e$var$Bm3PageLoadMarkFMPComponent = ({ timestamp: timestamp })=>{
    const pageLoadMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    (0, $42omo.useEffect)(()=>{
        if (typeof timestamp === 'number') pageLoadMetric.markFMP(timestamp);
        else {
            pageLoadMetric.markFMP();
            try {
                performance.mark('browser-metric.fmp');
                performance.measure('browser-metric:fmp', (0, $6VdZc.isInitial)() ? undefined : 'browser-metric.start', 'browser-metric.fmp');
            // eslint-disable-next-line no-unused-vars
            } catch (e) {
            // Suppress error when performance API failed.
            // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
            // That's why wrap with try catch statement.
            }
        }
    }, [
        timestamp,
        pageLoadMetric
    ]);
    return null;
};
const $4cdad5edb4cc053e$export$b93f9592e94ecbd1 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4cdad5edb4cc053e$var$Bm3PageLoadMarkFMPComponent);
module.exports["Bm3PageLoadMarkFMP"] = $4cdad5edb4cc053e$export$b93f9592e94ecbd1;

});

parcelRegister("4lI3M", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");

const $5f4e81a704597936$var$UFOLoadMarkFMPComponent = ({ timestamp: timestamp })=>{
    (0, $42omo.useEffect)(()=>(0, $kGwvc.addUFOCustomMark)('fmp', timestamp), [
        timestamp
    ]);
    return null;
};
const $5f4e81a704597936$export$fb963c3b1ed54502 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($5f4e81a704597936$var$UFOLoadMarkFMPComponent);
module.exports["UFOLoadMarkFMP"] = $5f4e81a704597936$export$fb963c3b1ed54502;

});

parcelRegister("ZugQS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");


var $4u5NT = parcelRequire("4u5NT");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");

/**
 * Marks FMP (First Meaningful Paint) on UFO transition interactions.
 *
 * When the `confluence_fe_deprecate_bm3` feature gate is **disabled** (legacy BM3 mode),
 * this component does nothing — FMP for transitions is handled through the BM3 pipeline
 * (although unreliably, see investigation in CCP-7117).
 *
 * When the feature gate is **enabled** (UFO mode) and we are in a transition, this
 * component places an `addUFOCustomMark('fmp', timestamp)` call. Unlike `PageLoadMarkFMP`
 * which is meant for initial page loads, this component is specifically designed for SPA
 * transitions where the platform UFO library does not natively track FMP.
 *
 * The corresponding `metric:fmp` value is computed in `additionalPayloadData.ts` by
 * reading this mark from the interaction and calculating the offset from interaction start.
 */ const $70ecb93741312159$var$UFOTransitionMarkFMPComponent = ({ timestamp: timestamp })=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    (0, $42omo.useEffect)(()=>{
        if (isTransition && (0, $9wGTI.fg)('confluence_fe_deprecate_bm3')) {
            (0, $kGwvc.addUFOCustomMark)('fmp', timestamp);
            // The code below unfortunately relies on internals of the UFO library and on some
            // knowledge of how the UFO event data (especially FMP) are processed by the analytics
            // pipeline. This is relatively stable "private API", but it has to be sorted out with
            // the UFO team, as a follow up to https://product-fabric.atlassian.net/browse/CCP-7117.
            const interaction = (0, $4u5NT.getActiveInteraction)();
            if (!interaction) return;
            // In UFO realm, there's no concept of FMP, and by design it is defaulted to TTAI. While
            // in Confluence we rely on FMP for transitions, so emulating the legacy behavior here.
            interaction.legacyMetrics = interaction.legacyMetrics || [];
            interaction.legacyMetrics.push({
                key: 'fmp',
                config: {
                    type: 'PAGE_LOAD'
                },
                start: 0,
                stop: timestamp ?? null,
                type: 'PAGE_LOAD',
                custom: {}
            });
        }
    }, [
        isTransition,
        timestamp
    ]);
    return null;
};
const $70ecb93741312159$export$f881402a7a312ba4 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($70ecb93741312159$var$UFOTransitionMarkFMPComponent);
module.exports["UFOTransitionMarkFMP"] = $70ecb93741312159$export$f881402a7a312ba4;

});

parcelRegister("7r2px", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $0bdd6e0a6db7c960$var$logger = (0, $7W8i8.getLogger)('retrieveContentExtensionMetrics');
const $0bdd6e0a6db7c960$export$1fa8ce0cc2ea267e = 10;
const $0bdd6e0a6db7c960$export$5da22daff5be7fe6 = (contentBody)=>{
    try {
        const contentExtensionMetrics = {
            contentExtensionCount: {
                connect: {},
                forge: {}
            },
            contentExtensionKeys: {
                connect: [],
                forge: []
            },
            hasExtensions: false
        };
        const document = JSON.parse(contentBody);
        const visit = (node)=>{
            $0bdd6e0a6db7c960$export$bd4248834ea73a5(node, contentExtensionMetrics);
        };
        document?.content?.forEach(visit);
        return contentExtensionMetrics;
    } catch  {
        $0bdd6e0a6db7c960$var$logger.error`Unable to parse ADF`;
        return {};
    }
};
const $0bdd6e0a6db7c960$export$bd4248834ea73a5 = (node, contentExtensionMetrics)=>{
    $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode(node, contentExtensionMetrics.contentExtensionCount);
    $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode(node, contentExtensionMetrics.contentExtensionKeys);
    contentExtensionMetrics.hasExtensions = contentExtensionMetrics.contentExtensionKeys?.connect.length > 0 || contentExtensionMetrics.contentExtensionKeys?.forge.length > 0;
    return contentExtensionMetrics;
};
function $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode({ attrs: attrs, type: type }, contentExtensionKeys) {
    if (attrs && type) {
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs;
        if (extensionType === 'com.atlassian.ecosystem' && extensionKey) contentExtensionKeys.forge.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.macro.core' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.migration' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else return;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode({ attrs: attrs, type: type }, contentExtensionCount) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        let extensionsObj;
        if (extensionType === 'com.atlassian.ecosystem') extensionsObj = contentExtensionCount.forge;
        else if (extensionType === 'com.atlassian.confluence.macro.core') extensionsObj = contentExtensionCount.connect;
        else if (extensionType === 'com.atlassian.confluence.migration') extensionsObj = contentExtensionCount.connect;
        else return;
        if (extensionsObj) extensionsObj[type] = (extensionsObj[type] || 0) + 1;
    }
}
module.exports["retrieveContentExtensionMetrics"] = $0bdd6e0a6db7c960$export$5da22daff5be7fe6;
module.exports["retrieveContentExtensionMetricsFromNode"] = $0bdd6e0a6db7c960$export$bd4248834ea73a5;

});

parcelRegister("juCeZ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $9Z1sw = parcelRequire("9Z1sw");

const $816e839f3c4509f6$export$b3d89882591ee965 = ({ contentId: contentId, location: location })=>{
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: location
        }
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    const panels = data?.webPanels || [];
    return panels.map((panel)=>panel?.moduleKey).join(',');
};
module.exports["useConnectAppsData"] = $816e839f3c4509f6$export$b3d89882591ee965;

});

parcelRegister("koYWo", function(module, exports) {

var $iFjdQ = parcelRequire("iFjdQ");


var $5q601 = parcelRequire("5q601");

const $b52d61085419c758$var$EDITOR_STARTED_MAX_MS = 15000;
const $b52d61085419c758$export$a8df9cafe21ac55e = (createAnalyticsEvent, analytics)=>{
    const { isCreate: isCreate } = analytics;
    const measures = (0, $iFjdQ.ExperienceActionMeasures).getMeasures();
    if (!measures.hasOwnProperty((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION))) return;
    const timeToInitializeEditor = measures[0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION].duration;
    // Don't send event if editor took longer than 15 seconds to intialize or if page is being created
    if (timeToInitializeEditor > $b52d61085419c758$var$EDITOR_STARTED_MAX_MS || isCreate) return;
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'editorStarted',
            actionSubject: 'performanceTrigger',
            source: 'editPageScreen',
            attributes: {
                timeToInitializeEditor: timeToInitializeEditor
            }
        }
    }).fire();
};
module.exports["sendEditorStartedPageEvent"] = $b52d61085419c758$export$a8df9cafe21ac55e;

});

parcelRegister("2sWSU", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $jOBr7 = parcelRequire("jOBr7");


const $2259a099417bd041$export$9f5f445f63346dec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "koi_U",
    name: "CategorySelector",
    loader: async ()=>(await (parcelRequire("5oN4g"))).CategorySelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jOBr7.LoadingCategories), null)
});

const $2259a099417bd041$export$fd98f335d958fe2c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Mzucr",
    name: "InlineCategorySelector",
    loader: async ()=>(await (parcelRequire("5lTgA"))).InlineCategorySelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jOBr7.LoadingInlineCategories), null)
});
module.exports["CategorySelector"] = $2259a099417bd041$export$9f5f445f63346dec;
module.exports["InlineCategorySelector"] = $2259a099417bd041$export$fd98f335d958fe2c;

});

parcelRegister("jOBr7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hicHn = parcelRequire("hicHn");

const $c94e5250e436cf81$export$d00b36cac03d226 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.CategoryList), {
        "data-testid": "loading-categories"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 156,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 32,
        isDisabled: true
    }, "\xa0"));
const $c94e5250e436cf81$export$59cb8d91bea3cd98 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.InlineCategorySelectorWrapper), {
        "data-testid": "inline-loading-categories",
        isCollapsed: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.InlineCategoryList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderPill), {
        width: 156,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.PlaceholderExpandPill), {
        width: 24,
        isDisabled: true
    }, "\xa0")));
module.exports["LoadingCategories"] = $c94e5250e436cf81$export$d00b36cac03d226;
module.exports["LoadingInlineCategories"] = $c94e5250e436cf81$export$59cb8d91bea3cd98;

});

parcelRegister("hicHn", function(module, exports) {
/* CategorySelectorStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $29c38e9d5023fba6$export$fef438fc53d8c7b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1yt4xwjf _v564klxk _2rko1rr0 _11c8fhey _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _vchhusvi _1e0c116y _4t3i1ou6 _19pkidpf _otyru2gc _2hwx1b66 _uiztglyw _p12f1osq _1bto1l2s _o5721q9c _s7n4jp4b _7ehiw5lj _irr3i8nm",
            __cmplp.isDisabled || !__cmplp.isSelected ? "_bfhki8nm" : "_bfhk15s3",
            __cmplp.isDisabled || !__cmplp.isSelected ? "_1h6d1j28" : "_1h6d6x5g",
            __cmplp.isDisabled || !__cmplp.isSelected ? "_syazi7uo" : "_syaz6x5g",
            __cmplp.isDisabled ? "_80om1kw7" : "_80omtlke",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$36ed96fc7440ff81 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $29c38e9d5023fba6$export$fef438fc53d8c7b3, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bv1y44 _u5f31y44 _s7n4jp4b _2hwxidpf _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$97fb31c46eea67f0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $29c38e9d5023fba6$export$fef438fc53d8c7b3, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1rkg _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$7c3018f441722857 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bto1l2s _1o9zkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$ea56f7cea075a7df = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$ae846b5f9b917b03 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s818xp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$4d0d284a7daa943b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81opn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$324eb091ed8d0181 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8huju",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$be58b4326e23250f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$95aa4184327d6b72 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_k48p1pd9 _1o9zidpf _18u012x7",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$fc1c3c7100f32c93 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$a05835e82fd98f96 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _p12fgx0z _vchhusvi",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$79717968ed9ae6cd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yxxidpf",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$94db4e2a8a326082 = 26;
const $29c38e9d5023fba6$export$1fa4c0e9ca4cb169 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41qq9 _1reo15vq _18m915vq _kqswh2mm _1e0c1txw _4cvr1y6m",
            __cmplp.isCollapsed ? "_4t3i1ou6" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$a37b48cfe5037c84 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $29c38e9d5023fba6$export$fef438fc53d8c7b3, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c116y _4cvr1h6o _4t3i1tcg _19pkt94y _otyrt94y _18u0idpf _2hwxidpf",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$5b35db8b663b38dd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $29c38e9d5023fba6$export$97fb31c46eea67f0, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _19pkt94y _otyrt94y _18u0idpf _2hwxidpf",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$5dff2750eb30565b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $29c38e9d5023fba6$export$79717968ed9ae6cd, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_p12f1osq _1ofnglyw",
            __cmplp.className
        ])
    });
});
module.exports["CategoryPill"] = $29c38e9d5023fba6$export$fef438fc53d8c7b3;
module.exports["EllipsisPill"] = $29c38e9d5023fba6$export$36ed96fc7440ff81;
module.exports["PlaceholderPill"] = $29c38e9d5023fba6$export$97fb31c46eea67f0;
module.exports["TextWrapper"] = $29c38e9d5023fba6$export$7c3018f441722857;
module.exports["CategoryNameWrapper"] = $29c38e9d5023fba6$export$ea56f7cea075a7df;
module.exports["TrophyIconWrapper"] = $29c38e9d5023fba6$export$ae846b5f9b917b03;
module.exports["FireIconWrapper"] = $29c38e9d5023fba6$export$4d0d284a7daa943b;
module.exports["StarIconWrapper"] = $29c38e9d5023fba6$export$324eb091ed8d0181;
module.exports["IconWrapper"] = $29c38e9d5023fba6$export$be58b4326e23250f;
module.exports["Bold"] = $29c38e9d5023fba6$export$95aa4184327d6b72;
module.exports["NoCountSpace"] = $29c38e9d5023fba6$export$fc1c3c7100f32c93;
module.exports["InlineDialogContentWrapper"] = $29c38e9d5023fba6$export$a05835e82fd98f96;
module.exports["CategoryList"] = $29c38e9d5023fba6$export$79717968ed9ae6cd;
module.exports["COLLAPSED_INLINE_WRAPPER_HEIGHT"] = $29c38e9d5023fba6$export$94db4e2a8a326082;
module.exports["InlineCategorySelectorWrapper"] = $29c38e9d5023fba6$export$1fa4c0e9ca4cb169;
module.exports["InlineExpandCollapsePill"] = $29c38e9d5023fba6$export$a37b48cfe5037c84;
module.exports["PlaceholderExpandPill"] = $29c38e9d5023fba6$export$5b35db8b663b38dd;
module.exports["InlineCategoryList"] = $29c38e9d5023fba6$export$5dff2750eb30565b;

});

parcelRegister("5oN4g", function(module, exports) {

let $3ee54174437a0697$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ee54174437a0697$var$load("g6t0n").then(()=>parcelRequire('Go6xd'));

});

parcelRegister("5lTgA", function(module, exports) {

let $3e59c8b2f52a2b87$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e59c8b2f52a2b87$var$load("1NmUq").then(()=>parcelRequire('7vrqx'));

});

parcelRegister("6sN9o", function(module, exports) {
/* DebouncedSearchBar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $jSnXV = parcelRequire("jSnXV");


var $4noo5 = parcelRequire("4noo5");


var $jluld = parcelRequire("jluld");


var $7yDmn = parcelRequire("7yDmn");


var $6F6hl = parcelRequire("6F6hl");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");

function $82b202e8c8a4137c$var$_defineProperty(e, r, t) {
    return (r = $82b202e8c8a4137c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $82b202e8c8a4137c$var$_toPropertyKey(t) {
    var i = $82b202e8c8a4137c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $82b202e8c8a4137c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $82b202e8c8a4137c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    searchBarLabel: {
        id: "debounced-search-bar.label",
        defaultMessage: "Search"
    },
    searchPlaceholderText: {
        id: "debounced-search-bar.hintText",
        defaultMessage: "Search"
    },
    searchIconLabel: {
        id: "debounced-search-bar.search.icon.label",
        defaultMessage: "Search icon"
    },
    crossIconLabel: {
        id: "debounced-search-bar.cross.icon.label",
        defaultMessage: "Clear search bar"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82b202e8c8a4137c$var$SearchIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81gdr",
            __cmplp.className
        ])
    });
});
const $82b202e8c8a4137c$var$pressableStyles = (0, $ecnYn.xcss)({
    marginTop: '0',
    marginBottom: '0',
    marginLeft: 'space.075',
    marginRight: 'space.075',
    padding: '0',
    background: 'none',
    border: 'none'
});
const $82b202e8c8a4137c$var$pressableDisabledStyle = (0, $ecnYn.xcss)({
    cursor: 'inherit'
});
const $82b202e8c8a4137c$var$pressableEnabledStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
class $82b202e8c8a4137c$var$InjectedDebouncedSearchBar extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { intl: intl, onFocus: onFocus, label: label = intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.searchBarLabel), placeholder: placeholder = intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.searchPlaceholderText), testId: testId, isDisabled: isDisabled, isCompact: isCompact, autoFocus: autoFocus, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ref: this.searchBarRef,
            label: label,
            testId: testId,
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82b202e8c8a4137c$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                label: intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.searchIconLabel),
                color: "var(--ds-icon-subtle)"
            })),
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                xcss: [
                    $82b202e8c8a4137c$var$pressableStyles,
                    isDisabled ? $82b202e8c8a4137c$var$pressableDisabledStyle : $82b202e8c8a4137c$var$pressableEnabledStyle
                ],
                testId: "clear-button",
                onClick: this.handleClearClick,
                isDisabled: isDisabled
            }, !!value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.crossIconLabel),
                color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.crossIconLabel),
                color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
            }))),
            isDisabled: isDisabled,
            onFocus: onFocus,
            isCompact: isCompact,
            autoFocus: autoFocus,
            "aria-labelledby": ariaLabelledBy,
            "aria-live": ariaLive
        });
    }
    constructor(...args){
        super(...args);
        $82b202e8c8a4137c$var$_defineProperty(this, "state", {
            value: this.props.initialValue || ''
        });
        $82b202e8c8a4137c$var$_defineProperty(this, "searchBarRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef());
        $82b202e8c8a4137c$var$_defineProperty(this, "_debouncedUpdateSearch", (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((newSearchQuery)=>{
            this.props.onChange(newSearchQuery);
        }, this.props.debouncedTime));
        $82b202e8c8a4137c$var$_defineProperty(this, "handleChange", (e)=>{
            this.setState({
                value: e.target.value
            });
            this._debouncedUpdateSearch(e.target.value);
        });
        $82b202e8c8a4137c$var$_defineProperty(this, "handleBlur", ()=>{
            const { onBlur: onBlur } = this.props;
            this._debouncedUpdateSearch.flush();
            onBlur?.();
        });
        $82b202e8c8a4137c$var$_defineProperty(this, "handleClearClick", (e)=>{
            e.preventDefault();
            if (this.props.isDisabled) return;
            this.setState({
                value: ''
            });
            this._debouncedUpdateSearch('');
            this._debouncedUpdateSearch.flush();
            this.searchBarRef.current?.focus();
        });
    }
}
$82b202e8c8a4137c$var$_defineProperty($82b202e8c8a4137c$var$InjectedDebouncedSearchBar, "defaultProps", {
    isCompact: true,
    debouncedTime: 250
});
const $82b202e8c8a4137c$export$6dbfe8c3c1fa25b2 = (0, $aXWIB.injectIntl)($82b202e8c8a4137c$var$InjectedDebouncedSearchBar);
module.exports["DebouncedSearchBar"] = $82b202e8c8a4137c$export$6dbfe8c3c1fa25b2;

});

parcelRegister("7Voxz", function(module, exports) {

var $kBRLU = parcelRequire("kBRLU");

var $3353d8f494041692$export$ec254908aabec82d = /*#__PURE__*/ function(EMPTY_STATE_VARIANT) {
    EMPTY_STATE_VARIANT["SEARCH"] = "search";
    EMPTY_STATE_VARIANT["MY_TEMPLATES"] = "my-templates";
    EMPTY_STATE_VARIANT["FAVORITES"] = "favorites";
    return EMPTY_STATE_VARIANT;
}({});
function $3353d8f494041692$export$89548721a3a7aa8c(isCategoryEmpty, selectedCategoryId) {
    if (!isCategoryEmpty) return "search";
    if (selectedCategoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).MY_TEMPLATES) return "my-templates";
    if (selectedCategoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).FAVORITES) return "favorites";
    return "search";
}
module.exports["EMPTY_STATE_VARIANT"] = $3353d8f494041692$export$ec254908aabec82d;
module.exports["getEmptyStateVariant"] = $3353d8f494041692$export$89548721a3a7aa8c;

});

parcelRegister("5Vsx9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $kBRLU = parcelRequire("kBRLU");

const $76d8847bf8b5dfb8$var$snippetCategoryI18n = (0, $aXWIB.defineMessages)({
    allCategory: {
        id: "snippets.snippet-tab.category.all",
        defaultMessage: "All"
    },
    myTemplatesCategory: {
        id: "snippets.snippet-tab.category.my-templates",
        defaultMessage: "My Templates"
    },
    favoritesCategory: {
        id: "snippets.snippet-tab.category.favorites",
        defaultMessage: "Favorites"
    }
});
const $76d8847bf8b5dfb8$export$9f6577ab4f3698eb = ()=>{
    const $ = (0, $frIzR.c)(16);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($76d8847bf8b5dfb8$var$snippetCategoryI18n.allCategory);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            id: (0, $kBRLU.SNIPPET_CATEGORY_IDS).ALL,
            name: t0
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== intl) {
        t2 = intl.formatMessage($76d8847bf8b5dfb8$var$snippetCategoryI18n.myTemplatesCategory);
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            id: (0, $kBRLU.SNIPPET_CATEGORY_IDS).MY_TEMPLATES,
            name: t2
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== intl) {
        t4 = intl.formatMessage($76d8847bf8b5dfb8$var$snippetCategoryI18n.favoritesCategory);
        $[8] = intl;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t4) {
        t5 = {
            id: (0, $kBRLU.SNIPPET_CATEGORY_IDS).FAVORITES,
            name: t4
        };
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
        t6 = [
            t1,
            t3,
            t5
        ];
        $[12] = t1;
        $[13] = t3;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useSnippetFilterCategories"] = $76d8847bf8b5dfb8$export$9f6577ab4f3698eb;

});

parcelRegister("2mmJ0", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $abC4X = parcelRequire("abC4X");


var $gj7hi = parcelRequire("gj7hi");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $hPTbh = parcelRequire("hPTbh");


var $7Voxz = parcelRequire("7Voxz");


var $jxXkP = parcelRequire("jxXkP");


var $c5QpP = parcelRequire("c5QpP");


var $1ezzW = parcelRequire("1ezzW");


var $iqyWt = parcelRequire("iqyWt");


var $5iZ08 = parcelRequire("5iZ08");


var $kzKk3 = parcelRequire("kzKk3");

const $d7e889767909fab4$var$wrapperStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.800',
    marginBottom: 'space.100'
});
const $d7e889767909fab4$export$6ec02dae7201276c = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { origin: origin, variant: variant, primaryAction: primaryAction } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic } = (0, $jxXkP.useSnippetAnalytics)(origin);
    let header;
    let description;
    let imageUrl;
    let imageHeight;
    let renderImage;
    let primaryActionLabel = null;
    if (variant === (0, $7Voxz.EMPTY_STATE_VARIANT).MY_TEMPLATES) {
        let t1;
        if ($[0] !== intl) {
            t1 = intl.formatMessage((0, $kzKk3.i18n).myTemplatesEmptyHeader);
            $[0] = intl;
            $[1] = t1;
        } else t1 = $[1];
        header = t1;
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...(0, $kzKk3.i18n).myTemplatesEmptyDescription,
                values: {
                    categoryName: $d7e889767909fab4$var$_temp,
                    br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
                }
            });
            $[2] = t2;
        } else t2 = $[2];
        description = t2;
        imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($1ezzW)));
        imageHeight = 165;
        if (primaryAction) {
            let t3;
            if ($[3] !== intl) {
                t3 = intl.formatMessage((0, $kzKk3.i18n).myTemplatesEmptyPrimaryAction);
                $[3] = intl;
                $[4] = t3;
            } else t3 = $[4];
            primaryActionLabel = t3;
        }
    } else if (variant === (0, $7Voxz.EMPTY_STATE_VARIANT).FAVORITES) {
        let t1;
        if ($[5] !== intl) {
            t1 = intl.formatMessage((0, $kzKk3.i18n).favoritesEmptyHeader);
            $[5] = intl;
            $[6] = t1;
        } else t1 = $[6];
        header = t1;
        let t2;
        if ($[7] !== intl) {
            t2 = intl.formatMessage((0, $kzKk3.i18n).favoritesEmptyDescription);
            $[7] = intl;
            $[8] = t2;
        } else t2 = $[8];
        description = t2;
        imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($c5QpP)));
        imageHeight = 165;
        if (primaryAction) {
            let t3;
            if ($[9] !== intl) {
                t3 = intl.formatMessage((0, $kzKk3.i18n).favoritesEmptyPrimaryAction);
                $[9] = intl;
                $[10] = t3;
            } else t3 = $[10];
            primaryActionLabel = t3;
        }
    } else {
        let t1;
        if ($[11] !== intl) {
            t1 = intl.formatMessage((0, $kzKk3.i18n).emptyHeader);
            $[11] = intl;
            $[12] = t1;
        } else t1 = $[12];
        header = t1;
        let t2;
        if ($[13] !== intl) {
            t2 = intl.formatMessage((0, $kzKk3.i18n).emptyDescription);
            $[13] = intl;
            $[14] = t2;
        } else t2 = $[14];
        description = t2;
        imageHeight = 160;
        renderImage = $d7e889767909fab4$var$_temp2;
    }
    let t1;
    if ($[15] !== fireButtonClickedAnalytic || $[16] !== primaryAction || $[17] !== variant) {
        t1 = ()=>{
            if (variant === (0, $7Voxz.EMPTY_STATE_VARIANT).MY_TEMPLATES) fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).EMPTY_MY_TEMPLATES_CALL_TO_ACTION);
            else if (variant === (0, $7Voxz.EMPTY_STATE_VARIANT).FAVORITES) fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).EMPTY_FAVORITES_CALL_TO_ACTION);
            primaryAction?.();
        };
        $[15] = fireButtonClickedAnalytic;
        $[16] = primaryAction;
        $[17] = variant;
        $[18] = t1;
    } else t1 = $[18];
    const handlePrimaryAction = t1;
    let t2;
    if ($[19] !== handlePrimaryAction || $[20] !== primaryAction || $[21] !== primaryActionLabel) {
        t2 = primaryAction && primaryActionLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handlePrimaryAction
        }, primaryActionLabel) : null;
        $[19] = handlePrimaryAction;
        $[20] = primaryAction;
        $[21] = primaryActionLabel;
        $[22] = t2;
    } else t2 = $[22];
    const primaryActionButton = t2;
    const t3 = primaryActionButton ?? undefined;
    let t4;
    if ($[23] !== description || $[24] !== header || $[25] !== imageHeight || $[26] !== imageUrl || $[27] !== renderImage || $[28] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $d7e889767909fab4$var$wrapperStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), {
            header: header,
            description: description,
            imageUrl: imageUrl,
            imageHeight: imageHeight,
            renderImage: renderImage,
            primaryAction: t3
        }));
        $[23] = description;
        $[24] = header;
        $[25] = imageHeight;
        $[26] = imageUrl;
        $[27] = renderImage;
        $[28] = t3;
        $[29] = t4;
    } else t4 = $[29];
    return t4;
};
function $d7e889767909fab4$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "strong"
    }, chunks);
}
function $d7e889767909fab4$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5iZ08))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($iqyWt))),
        alt: ""
    });
}
module.exports["EmptySnippets"] = $d7e889767909fab4$export$6ec02dae7201276c;

});

parcelRegister("c5QpP", function(module, exports) {
module.exports = new URL("EmptyFavoritesImg.bbb61fc3.svg", import.meta.url).toString();

});

parcelRegister("1ezzW", function(module, exports) {
module.exports = new URL("EmptyMyTemplatesImg.66c713bd.svg", import.meta.url).toString();

});

parcelRegister("iqyWt", function(module, exports) {
module.exports = new URL("EmptySearchDark.eb3b9001.svg", import.meta.url).toString();

});

parcelRegister("5iZ08", function(module, exports) {
module.exports = new URL("EmptySearchLight.8191120f.svg", import.meta.url).toString();

});

parcelRegister("kzKk3", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a335104451b5aa13$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    emptyHeader: {
        id: "snippets.snippet-tab.empty.header",
        defaultMessage: "No templates found"
    },
    emptyDescription: {
        id: "snippets.snippet-tab.empty.description",
        defaultMessage: "Try selecting a different category to see more templates."
    },
    myTemplatesEmptyHeader: {
        id: "snippets.snippet-tab.empty.my-templates.header",
        defaultMessage: "Make almost anything a block template"
    },
    myTemplatesEmptyDescription: {
        id: "snippets.snippet-tab.empty.my-templates.description",
        defaultMessage: "See something you like on a page? Highlight it and save it as a template. It'll be here in <categoryName>My Templates</categoryName>.{br}Reuse it. Edit it. Share it.{br}Type \"/templatename\" to insert into a page."
    },
    myTemplatesEmptyPrimaryAction: {
        id: "snippets.snippet-tab.empty.my-templates.primary-action",
        defaultMessage: "Create template"
    },
    favoritesEmptyHeader: {
        id: "snippets.snippet-tab.empty.favorites.header",
        defaultMessage: "You haven't starred a template yet"
    },
    favoritesEmptyDescription: {
        id: "snippets.snippet-tab.empty.favorites.description",
        defaultMessage: "If you've got a favorite template or one that you use often, star it (\u2B50) for easy access."
    },
    favoritesEmptyPrimaryAction: {
        id: "snippets.snippet-tab.empty.favorites.primary-action",
        defaultMessage: "Explore templates"
    }
});
module.exports["i18n"] = $a335104451b5aa13$export$a7357cdd1f0b0168;

});

parcelRegister("5B99W", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $cga1x = parcelRequire("cga1x");


var $kBRLU = parcelRequire("kBRLU");


var $gPFNt = parcelRequire("gPFNt");

const $354bd492cd3c3cd4$export$8c1f8aab30e0c253 = (snippets, categoryId, searchQuery, userId)=>{
    let categoryFiltered = snippets;
    // Apply category filter
    if (categoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).MY_TEMPLATES) categoryFiltered = snippets.filter((snippet)=>snippet.scope === (0, $cga1x.SnippetScope).USER && snippet.createdBy.accountId === userId);
    else if (categoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).FAVORITES) categoryFiltered = snippets.filter((snippet)=>snippet?.isFavorite);
    // Apply search filter
    const trimmedSearchQuery = searchQuery.trim().toLowerCase();
    if (!trimmedSearchQuery) return categoryFiltered;
    return categoryFiltered.filter((snippet)=>{
        const nameMatch = snippet.name.toLowerCase().includes(trimmedSearchQuery);
        const ownerMatch = snippet.createdBy.displayName.toLowerCase().includes(trimmedSearchQuery);
        const descriptionMatch = snippet.description?.toLowerCase().includes(trimmedSearchQuery);
        return nameMatch || ownerMatch || descriptionMatch;
    });
};
const $354bd492cd3c3cd4$export$961a77b8589838c3 = (snippets, sortOrder)=>{
    const sorted = [
        ...snippets
    ];
    switch(sortOrder){
        case (0, $gPFNt.SnippetSortOrder).CREATED_AT:
            return sorted.sort((a, b)=>new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        case (0, $gPFNt.SnippetSortOrder).LAST_UPDATED:
            return sorted.sort((a, b)=>new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
        case (0, $gPFNt.SnippetSortOrder).POPULARITY:
            return sorted.sort((a, b)=>{
                // Site and global snippets should be sorted by insert count, but not user snippets
                const sortableInsertCount = (s)=>s.scope === (0, $cga1x.SnippetScope).USER ? 0 : s.insertCount ?? 0;
                return sortableInsertCount(b) - sortableInsertCount(a);
            });
        case (0, $gPFNt.SnippetSortOrder).ALPHABETICAL:
            return sorted.sort((a, b)=>a.name.localeCompare(b.name));
        default:
            return sorted;
    }
};
const $354bd492cd3c3cd4$export$f1d3128352bb5216 = (snippets)=>{
    const $ = (0, $frIzR.c)(12);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [selectedCategoryId, setSelectedCategoryId] = (0, $42omo.useState)((0, $kBRLU.DEFAULT_CATEGORY_ID));
    const [searchQuery, setSearchQuery] = (0, $42omo.useState)("");
    const [sortOrder, setSortOrder] = (0, $42omo.useState)((0, $gPFNt.DEFAULT_SNIPPET_SORT_ORDER));
    let t0;
    if ($[0] !== searchQuery || $[1] !== selectedCategoryId || $[2] !== snippets || $[3] !== sortOrder || $[4] !== userId) {
        t0 = $354bd492cd3c3cd4$export$961a77b8589838c3($354bd492cd3c3cd4$export$8c1f8aab30e0c253(snippets, selectedCategoryId, searchQuery, userId), sortOrder);
        $[0] = searchQuery;
        $[1] = selectedCategoryId;
        $[2] = snippets;
        $[3] = sortOrder;
        $[4] = userId;
        $[5] = t0;
    } else t0 = $[5];
    const filteredSnippets = t0;
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setSelectedCategoryId((0, $kBRLU.DEFAULT_CATEGORY_ID));
            setSearchQuery("");
            setSortOrder((0, $gPFNt.DEFAULT_SNIPPET_SORT_ORDER));
        };
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== filteredSnippets || $[8] !== searchQuery || $[9] !== selectedCategoryId || $[10] !== sortOrder) {
        t2 = {
            selectedCategoryId: selectedCategoryId,
            searchQuery: searchQuery,
            sortOrder: sortOrder,
            filteredSnippets: filteredSnippets,
            setCategoryFilter: setSelectedCategoryId,
            setSearchQuery: setSearchQuery,
            setSortOrder: setSortOrder,
            resetFilters: t1
        };
        $[7] = filteredSnippets;
        $[8] = searchQuery;
        $[9] = selectedCategoryId;
        $[10] = sortOrder;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
module.exports["filterSnippets"] = $354bd492cd3c3cd4$export$8c1f8aab30e0c253;
module.exports["sortSnippets"] = $354bd492cd3c3cd4$export$961a77b8589838c3;
module.exports["useSnippetFilterAndSort"] = $354bd492cd3c3cd4$export$f1d3128352bb5216;

});

parcelRegister("67NtX", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $67O0h = parcelRequire("67O0h");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $kBU5m = parcelRequire("kBU5m");


var $bQm3c = parcelRequire("bQm3c");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $ies1q = parcelRequire("ies1q");


var $5DXNy = parcelRequire("5DXNy");

const $e12252c7883ca5e3$var$styles = {
    scaledContainer: "_1reo15vq _18m915vq _uiztglyw _lcxvglyw",
    scaledContent: "_4t3i1wug _8hrz5d63",
    loadingWrapper: "_1bsb1osq _4t3i1osq"
}; /** Desired output dimensions (container size) */ 
const $e12252c7883ca5e3$export$a13d19bdacf806db = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { snippet: snippet, dimensions: dimensions, renderWidth: renderWidth, loadingComponent: loadingComponent } = t0;
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const showFallback = !!loadingComponent && isLoading;
    let t1;
    if ($[0] !== loadingComponent || $[1] !== showFallback) {
        t1 = showFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $e12252c7883ca5e3$var$styles.loadingWrapper,
            alignItems: "center",
            justifyContent: "center"
        }, loadingComponent);
        $[0] = loadingComponent;
        $[1] = showFallback;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsLoading(false);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== snippet.body || $[5] !== snippet.scope || $[6] !== snippet.snippetId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12252c7883ca5e3$var$Renderer, {
            adf: snippet.body,
            snippetId: snippet.snippetId,
            scope: snippet.scope,
            onRendered: t2
        });
        $[4] = snippet.body;
        $[5] = snippet.scope;
        $[6] = snippet.snippetId;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== dimensions || $[9] !== renderWidth || $[10] !== showFallback || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12252c7883ca5e3$var$ScaledContainer, {
            dimensions: dimensions,
            renderWidth: renderWidth,
            shouldHide: showFallback
        }, t3);
        $[8] = dimensions;
        $[9] = renderWidth;
        $[10] = showFallback;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t1 || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t4);
        $[13] = t1;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $e12252c7883ca5e3$var$Renderer = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { adf: adf, snippetId: snippetId, scope: scope, onRendered: onRendered } = t0;
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    const { fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_PANEL);
    let t1;
    if ($[0] !== fireFailedAnalytic) {
        t1 = (error)=>{
            const reasonString = error instanceof Error ? error.message : JSON.stringify(error);
            const errorToLog = new Error(`Error when rendering snippet preview: ${reasonString}`);
            (0, $5ZqQS.getMonitoringClient)().submitError(errorToLog, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_PREVIEW_RENDER, {});
        };
        $[0] = fireFailedAnalytic;
        $[1] = t1;
    } else t1 = $[1];
    const handleRenderError = t1;
    let t2;
    if ($[2] !== cloudId || $[3] !== scope || $[4] !== snippetId || $[5] !== userId) {
        t2 = (0, $5DXNy.getProviders)(cloudId, userId, snippetId, scope);
        $[2] = cloudId;
        $[3] = scope;
        $[4] = snippetId;
        $[5] = userId;
        $[6] = t2;
    } else t2 = $[6];
    const providers = t2;
    let t3;
    if ($[7] !== adf) {
        t3 = (0, $ies1q.wrapAdfWithDocNode)(adf);
        $[7] = adf;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== featureFlags) {
        t4 = (0, $kBU5m.getMediaFeatureFlags)(featureFlags);
        $[9] = featureFlags;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t4) {
        t5 = {
            featureFlags: t4
        };
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== handleRenderError || $[14] !== onRendered || $[15] !== providers || $[16] !== t3 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
            adfStage: "stage0",
            document: t3,
            appearance: "full-page",
            allowColumnSorting: false,
            enableSsrInlineScripts: false,
            allowHeadingAnchorLinks: false,
            stickyHeaders: undefined,
            dataProviders: providers,
            onComplete: onRendered,
            onError: handleRenderError,
            allowPlaceholderText: true,
            media: t5
        });
        $[13] = handleRenderError;
        $[14] = onRendered;
        $[15] = providers;
        $[16] = t3;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
};
const $e12252c7883ca5e3$var$useContainerWidth = (containerRef)=>{
    const $ = (0, $frIzR.c)(3);
    const [containerWidth, setContainerWidth] = (0, $42omo.useState)(null);
    let t0;
    let t1;
    if ($[0] !== containerRef) {
        t0 = ()=>{
            const node = containerRef.current;
            if (!node || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver((t2)=>{
                const [entry] = t2;
                const width = entry.contentRect.width;
                if (width > 0) setContainerWidth(width);
            });
            observer.observe(node);
            return ()=>observer.disconnect();
        };
        t1 = [
            containerRef
        ];
        $[0] = containerRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    return containerWidth;
};
const $e12252c7883ca5e3$var$ScaledContainer = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { children: children, dimensions: dimensions, renderWidth: renderWidth, shouldHide: t1 } = t0;
    const shouldHide = t1 === undefined ? false : t1;
    const containerRef = (0, $42omo.useRef)(null);
    const containerWidth = $e12252c7883ca5e3$var$useContainerWidth(containerRef);
    const scaleFactor = containerWidth !== null ? containerWidth / renderWidth : 0;
    const isMeasured = containerWidth !== null;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (node)=>{
            containerRef.current = node;
            node?.setAttribute("inert", "");
        };
        $[0] = t2;
    } else t2 = $[0];
    const t3 = shouldHide ? "none" : "block";
    let t4;
    if ($[1] !== dimensions.maxHeight || $[2] !== dimensions.width || $[3] !== t3) {
        t4 = {
            width: dimensions.width,
            maxHeight: dimensions.maxHeight,
            display: t3
        };
        $[1] = dimensions.maxHeight;
        $[2] = dimensions.width;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = `scale(${scaleFactor})`;
    const t6 = isMeasured ? "visible" : "hidden";
    let t7;
    if ($[5] !== renderWidth || $[6] !== t5 || $[7] !== t6) {
        t7 = {
            transform: t5,
            width: renderWidth,
            visibility: t6
        };
        $[5] = renderWidth;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== children || $[10] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e12252c7883ca5e3$var$styles.scaledContent,
            style: t7
        }, children);
        $[9] = children;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t4 || $[13] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: t2,
            xcss: $e12252c7883ca5e3$var$styles.scaledContainer,
            testId: "snippet-preview-container",
            style: t4
        }, t8);
        $[12] = t4;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    return t9;
};
module.exports["SnippetPreview"] = $e12252c7883ca5e3$export$a13d19bdacf806db;

});

parcelRegister("5DXNy", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $4FxUL = parcelRequire("4FxUL");


var $32x2E = parcelRequire("32x2E");


var $bKBay = parcelRequire("bKBay");

const $1b808083bd8e59eb$export$4e044719025cb45d = (cloudId, userId, snippetId, scope)=>{
    const providers = (0, $4FxUL.default).create({});
    providers.setProvider('emojiProvider', (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    }));
    providers.setProvider('mediaProvider', (0, $bKBay.createSnippetsRendererMediaProvider)({
        snippetId: snippetId,
        scope: scope
    }));
    return providers;
};
module.exports["getProviders"] = $1b808083bd8e59eb$export$4e044719025cb45d;

});

parcelRegister("2esFu", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

const $def96d89fa00bdae$var$styles = {
    skeletonLongLine: "_2rko1mok _4t3i1crf _1bsb1w8u _bfhkizff",
    skeletonShortLine: "_2rko1mok _4t3i1crf _1bsbhwvj _bfhkizff",
    skeletonLine: "_2rko1mok _4t3i1crf _1bsb1nrf _bfhkizff"
};
const $def96d89fa00bdae$export$b8636d59d0a13d7d = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $def96d89fa00bdae$var$styles.skeletonLongLine
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $def96d89fa00bdae$var$styles.skeletonLine
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $def96d89fa00bdae$var$styles.skeletonLongLine
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $def96d89fa00bdae$var$styles.skeletonShortLine
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["SnippetPreviewSkeleton"] = $def96d89fa00bdae$export$b8636d59d0a13d7d;

});

parcelRegister("bL1ca", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $9VJDA = parcelRequire("9VJDA");


var $1Zr9M = parcelRequire("1Zr9M");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $1bY7o = parcelRequire("1bY7o");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $5vi32 = parcelRequire("5vi32");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $i1se2 = parcelRequire("i1se2");


var $cga1x = parcelRequire("cga1x");


var $eDBud = parcelRequire("eDBud");

const $d0a603587c38db5a$var$styles = {
    actionsContainer: "_v564wz4i _1o9zidpf _tzy4idpf _1mygkb7n",
    actionsContainerVisible: "_tzy4kb7n"
};
const $d0a603587c38db5a$var$messages = (0, $aXWIB.defineMessages)({
    moreActions: {
        id: "snippets.snippetMoreActions.moreActions",
        defaultMessage: "Block Templates actions"
    },
    edit: {
        id: "snippets.snippetMoreActions.edit",
        defaultMessage: "Edit"
    },
    duplicate: {
        id: "snippets.snippetMoreActions.duplicate",
        defaultMessage: "Duplicate"
    },
    delete: {
        id: "snippets.snippetMoreActions.delete",
        defaultMessage: "Delete"
    },
    share: {
        id: "snippets.snippetMoreActions.share",
        defaultMessage: "Copy share link"
    },
    shareSuccessFlagTitle: {
        id: "snippets.snippetMoreActions.shareSuccessFlagTitle",
        defaultMessage: "Link copied"
    },
    shareSuccessFlagDescription: {
        id: "snippets.snippetMoreActions.shareSuccessFlagDescription",
        defaultMessage: "Template share link copied to clipboard"
    }
});
const $d0a603587c38db5a$var$SnippetMoreActionsInner = (t0)=>{
    const $ = (0, $frIzR.c)(59);
    const { analyticsOrigin: analyticsOrigin, snippet: snippet, isHovered: isHovered, onMenuOpenChange: onMenuOpenChange, contentId: t1, spaceId: t2, spaceKey: t3, flags: flags } = t0;
    const contentId = t1 === undefined ? "" : t1;
    const spaceId = t2 === undefined ? "" : t2;
    const spaceKey = t3 === undefined ? "" : t3;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const intl = (0, $aXWIB.useIntl)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    let t4;
    if ($[0] !== analyticsOrigin || $[1] !== contentId || $[2] !== spaceId || $[3] !== spaceKey) {
        t4 = {
            analyticsOrigin: analyticsOrigin,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey
        };
        $[0] = analyticsOrigin;
        $[1] = contentId;
        $[2] = spaceId;
        $[3] = spaceKey;
        $[4] = t4;
    } else t4 = $[4];
    const { handleEdit: handleEdit, handleDuplicate: handleDuplicate, handleDelete: handleDelete, handleShare: handleShare } = (0, $i1se2.useSnippetActionHandlers)(t4);
    const isOwnedByCurrentUser = snippet.scope === (0, $cga1x.SnippetScope).USER && userId === snippet.createdBy.accountId;
    let t5;
    if ($[5] !== isEmbeddedConfluence) {
        t5 = !isEmbeddedConfluence && (0, $6mKj3.expVal)("cc_snippets_dogfooding_beta", "isEnabled", false);
        $[5] = isEmbeddedConfluence;
        $[6] = t5;
    } else t5 = $[6];
    const showShare = t5;
    let t6;
    if ($[7] !== onMenuOpenChange) {
        t6 = (t7)=>{
            const { isOpen: isOpen } = t7;
            setIsMenuOpen(isOpen);
            onMenuOpenChange?.(isOpen);
        };
        $[7] = onMenuOpenChange;
        $[8] = t6;
    } else t6 = $[8];
    const handleMenuOpenChange = t6;
    let t7;
    if ($[9] !== flags || $[10] !== handleShare || $[11] !== intl || $[12] !== snippet) {
        t7 = ()=>{
            handleShare(snippet).then((success)=>{
                if (success && flags) (0, $eDBud.showSnippetSuccessFlag)(flags, intl.formatMessage($d0a603587c38db5a$var$messages.shareSuccessFlagTitle), intl.formatMessage($d0a603587c38db5a$var$messages.shareSuccessFlagDescription));
            }).catch($d0a603587c38db5a$var$_temp);
        };
        $[9] = flags;
        $[10] = handleShare;
        $[11] = intl;
        $[12] = snippet;
        $[13] = t7;
    } else t7 = $[13];
    const onShareClick = t7;
    const t8 = `snippet-panel-actions-${snippet.snippetId}`;
    const t9 = (isHovered || isMenuOpen) && $d0a603587c38db5a$var$styles.actionsContainerVisible;
    let t10;
    if ($[14] !== t9) {
        t10 = (0, $1Whri.cx)($d0a603587c38db5a$var$styles.actionsContainer, t9);
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    const t11 = `snippet-ellipsis-menu-${snippet.snippetId}`;
    let t12;
    if ($[16] !== intl || $[17] !== isMenuOpen) {
        t12 = (t13)=>{
            const { triggerRef: triggerRef, ...props } = t13;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                label: intl.formatMessage($d0a603587c38db5a$var$messages.moreActions),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                "aria-expanded": isMenuOpen ? "true" : "false"
            });
        };
        $[16] = intl;
        $[17] = isMenuOpen;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== handleEdit || $[20] !== intl || $[21] !== isOwnedByCurrentUser || $[22] !== snippet) {
        t13 = isOwnedByCurrentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: ()=>handleEdit(snippet),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                label: intl.formatMessage($d0a603587c38db5a$var$messages.edit)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d0a603587c38db5a$var$messages.edit));
        $[19] = handleEdit;
        $[20] = intl;
        $[21] = isOwnedByCurrentUser;
        $[22] = snippet;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== intl || $[25] !== onShareClick || $[26] !== showShare) {
        t14 = showShare && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: onShareClick,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: intl.formatMessage($d0a603587c38db5a$var$messages.share)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d0a603587c38db5a$var$messages.share));
        $[24] = intl;
        $[25] = onShareClick;
        $[26] = showShare;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== handleDuplicate || $[29] !== snippet) {
        t15 = ()=>handleDuplicate(snippet);
        $[28] = handleDuplicate;
        $[29] = snippet;
        $[30] = t15;
    } else t15 = $[30];
    let t16;
    if ($[31] !== intl) {
        t16 = intl.formatMessage($d0a603587c38db5a$var$messages.duplicate);
        $[31] = intl;
        $[32] = t16;
    } else t16 = $[32];
    let t17;
    if ($[33] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
            label: t16
        });
        $[33] = t16;
        $[34] = t17;
    } else t17 = $[34];
    let t18;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d0a603587c38db5a$var$messages.duplicate);
        $[35] = t18;
    } else t18 = $[35];
    let t19;
    if ($[36] !== t15 || $[37] !== t17) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: t15,
            elemBefore: t17
        }, t18);
        $[36] = t15;
        $[37] = t17;
        $[38] = t19;
    } else t19 = $[38];
    let t20;
    if ($[39] !== handleDelete || $[40] !== intl || $[41] !== isOwnedByCurrentUser || $[42] !== snippet) {
        t20 = isOwnedByCurrentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: ()=>handleDelete(snippet),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                label: intl.formatMessage($d0a603587c38db5a$var$messages.delete)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $d0a603587c38db5a$var$messages.delete));
        $[39] = handleDelete;
        $[40] = intl;
        $[41] = isOwnedByCurrentUser;
        $[42] = snippet;
        $[43] = t20;
    } else t20 = $[43];
    let t21;
    if ($[44] !== t13 || $[45] !== t14 || $[46] !== t19 || $[47] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, t13, t14, t19, t20);
        $[44] = t13;
        $[45] = t14;
        $[46] = t19;
        $[47] = t20;
        $[48] = t21;
    } else t21 = $[48];
    let t22;
    if ($[49] !== handleMenuOpenChange || $[50] !== isMenuOpen || $[51] !== t11 || $[52] !== t12 || $[53] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            placement: "bottom-end",
            testId: t11,
            trigger: t12,
            appearance: "tall",
            isOpen: isMenuOpen,
            onOpenChange: handleMenuOpenChange
        }, t21);
        $[49] = handleMenuOpenChange;
        $[50] = isMenuOpen;
        $[51] = t11;
        $[52] = t12;
        $[53] = t21;
        $[54] = t22;
    } else t22 = $[54];
    let t23;
    if ($[55] !== t10 || $[56] !== t22 || $[57] !== t8) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: t8,
            xcss: t10
        }, t22);
        $[55] = t10;
        $[56] = t22;
        $[57] = t8;
        $[58] = t23;
    } else t23 = $[58];
    return t23;
};
const $d0a603587c38db5a$export$ffd81b4fbf24c6dc = (0, $7aRa9.withFlags)($d0a603587c38db5a$var$SnippetMoreActionsInner);
function $d0a603587c38db5a$var$_temp() {}
module.exports["SnippetMoreActions"] = $d0a603587c38db5a$export$ffd81b4fbf24c6dc;

});

parcelRegister("i1se2", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4oS56 = parcelRequire("4oS56");


var $kfIha = parcelRequire("kfIha");


var $8aF6s = parcelRequire("8aF6s");


var $hPTbh = parcelRequire("hPTbh");


var $cQa7q = parcelRequire("cQa7q");


var $2q5ry = parcelRequire("2q5ry");


var $4lamI = parcelRequire("4lamI");


var $aUBmi = parcelRequire("aUBmi");


var $jxXkP = parcelRequire("jxXkP");

const $93b1aebccdc051cd$export$fffb2c8c8b22d965 = (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { analyticsOrigin: analyticsOrigin, contentId: t1, spaceId: t2, spaceKey: t3 } = t0;
    const contentId = t1 === undefined ? "" : t1;
    const spaceId = t2 === undefined ? "" : t2;
    const spaceKey = t3 === undefined ? "" : t3;
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic } = (0, $jxXkP.useSnippetAnalytics)(analyticsOrigin);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { editorAPI: editorAPI } = (0, $42omo.useContext)((0, $4oS56.EditorContextPanelContext));
    let t4;
    if ($[0] !== contentId || $[1] !== editorAPI || $[2] !== fireButtonClickedAnalytic || $[3] !== showModal || $[4] !== spaceId || $[5] !== spaceKey) {
        t4 = (snippet)=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).EDIT_SNIPPET, {
                snippetId: snippet.snippetId,
                scope: snippet.scope
            });
            showModal((0, $4lamI.EditSnippetModal), {
                snippet: snippet,
                editorAPI: editorAPI,
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey
            });
        };
        $[0] = contentId;
        $[1] = editorAPI;
        $[2] = fireButtonClickedAnalytic;
        $[3] = showModal;
        $[4] = spaceId;
        $[5] = spaceKey;
        $[6] = t4;
    } else t4 = $[6];
    const handleEdit = t4;
    let t5;
    if ($[7] !== analyticsOrigin || $[8] !== contentId || $[9] !== editorAPI || $[10] !== fireButtonClickedAnalytic || $[11] !== showModal || $[12] !== spaceId || $[13] !== spaceKey) {
        t5 = (snippet_0)=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DUPLICATE_SNIPPET, {
                snippetId: snippet_0.snippetId,
                scope: snippet_0.scope
            });
            showModal((0, $2q5ry.DuplicateSnippetModal), {
                snippet: snippet_0,
                editorAPI: editorAPI,
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                analyticsOrigin: analyticsOrigin
            });
        };
        $[7] = analyticsOrigin;
        $[8] = contentId;
        $[9] = editorAPI;
        $[10] = fireButtonClickedAnalytic;
        $[11] = showModal;
        $[12] = spaceId;
        $[13] = spaceKey;
        $[14] = t5;
    } else t5 = $[14];
    const handleDuplicate = t5;
    let t6;
    if ($[15] !== editorAPI || $[16] !== fireButtonClickedAnalytic || $[17] !== showModal) {
        t6 = (snippet_1)=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DELETE_SNIPPET, {
                snippetId: snippet_1.snippetId,
                scope: snippet_1.scope
            });
            showModal((0, $cQa7q.DeleteSnippetModal), {
                snippet: snippet_1,
                editorAPI: editorAPI
            });
        };
        $[15] = editorAPI;
        $[16] = fireButtonClickedAnalytic;
        $[17] = showModal;
        $[18] = t6;
    } else t6 = $[18];
    const handleDelete = t6;
    let t7;
    if ($[19] !== copyToClipboard || $[20] !== fireButtonClickedAnalytic) {
        t7 = async (snippet_2)=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).COPY_SNIPPET_LINK, {
                snippetId: snippet_2.snippetId,
                scope: snippet_2.scope,
                isShared: snippet_2.isShared
            });
            if (!snippet_2.shareUrl) {
                (0, $aUBmi.reportError)(new Error(`handleShare called without shareUrl for snippet ${snippet_2.snippetId}`));
                return false;
            }
            const fullUrl = typeof window !== "undefined" ? `${window.location.origin}${snippet_2.shareUrl}` : snippet_2.shareUrl;
            try {
                await copyToClipboard(fullUrl);
                return true;
            } catch  {
                return false;
            }
        };
        $[19] = copyToClipboard;
        $[20] = fireButtonClickedAnalytic;
        $[21] = t7;
    } else t7 = $[21];
    const handleShare = t7;
    let t8;
    if ($[22] !== handleDelete || $[23] !== handleDuplicate || $[24] !== handleEdit || $[25] !== handleShare) {
        t8 = {
            handleEdit: handleEdit,
            handleDuplicate: handleDuplicate,
            handleDelete: handleDelete,
            handleShare: handleShare
        };
        $[22] = handleDelete;
        $[23] = handleDuplicate;
        $[24] = handleEdit;
        $[25] = handleShare;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
};
module.exports["useSnippetActionHandlers"] = $93b1aebccdc051cd$export$fffb2c8c8b22d965;

});

parcelRegister("cQa7q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hArLp = parcelRequire("hArLp");


var $ccHMk = parcelRequire("ccHMk");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");


var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $lsxnT = parcelRequire("lsxnT");


var $7aRa9 = parcelRequire("7aRa9");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $dZUkS = parcelRequire("dZUkS");


var $64ncc = parcelRequire("64ncc");

const $629f1f7885b694b1$var$DeleteSnippetModalWithFlags = ({ snippet: snippet, onClose: onClose, onCloseComplete: onCloseComplete, flags: flags, editorAPI: editorAPI })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const titleId = (0, $42omo.useId)();
    const intl = (0, $aXWIB.useIntl)();
    const { fireModalClosedAnalytic: fireModalClosedAnalytic, fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).DELETE_SNIPPET_MODAL);
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const [isDeleting, setIsDeleting] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const handleCancel = ()=>{
        fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DELETE_SNIPPET, {
            snippetId: snippet.snippetId,
            outcome: (0, $hPTbh.MODAL_OUTCOME).CANCELLED
        });
        onClose();
    };
    const handleConfirm = async ()=>{
        setIsDeleting(true);
        setError(null);
        try {
            await snippetsActions.deleteSnippet(snippet.snippetId, {
                flags: flags,
                intl: intl,
                editorAPI: editorAPI ?? null
            });
            fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DELETE_SNIPPET, {
                snippetId: snippet.snippetId,
                outcome: (0, $hPTbh.MODAL_OUTCOME).DELETED
            });
            onClose();
        } catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
            fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_DELETE, {
                snippetId: snippet.snippetId
            });
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: handleCancel,
        onCloseComplete: onCloseComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        id: titleId,
        weight: "semibold",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $64ncc.messages).deleteTemplateModalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: handleCancel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $64ncc.messages).deleteTemplateModalBody)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.danger",
        size: "small"
    }, error.message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: isDeleting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $64ncc.messages).deleteTemplateModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "danger",
        onClick: handleConfirm,
        isLoading: isDeleting,
        isDisabled: isDeleting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $64ncc.messages).deleteTemplateModalConfirmButton)))));
};
const $629f1f7885b694b1$export$424b6d728b5615c6 = (0, $7aRa9.withFlags)($629f1f7885b694b1$var$DeleteSnippetModalWithFlags);
module.exports["DeleteSnippetModal"] = $629f1f7885b694b1$export$424b6d728b5615c6;

});

parcelRegister("2q5ry", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7aRa9 = parcelRequire("7aRa9");


var $ies1q = parcelRequire("ies1q");


var $gUhOL = parcelRequire("gUhOL");


var $dZUkS = parcelRequire("dZUkS");


var $hPTbh = parcelRequire("hPTbh");


var $8yRiX = parcelRequire("8yRiX");


var $jxXkP = parcelRequire("jxXkP");


var $2u5FB = parcelRequire("2u5FB");


var $6K2yS = parcelRequire("6K2yS");


var $eWCeD = parcelRequire("eWCeD");


var $aNHzZ = parcelRequire("aNHzZ");


var $8JRDD = parcelRequire("8JRDD");


var $2hX8e = parcelRequire("2hX8e");

const $9b2db0b31b451eb0$var$DuplicateSnippetModalWithFlags = (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { snippet: snippet, onClose: onClose, onCloseComplete: onCloseComplete, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, flags: flags, editorAPI: editorAPI, analyticsOrigin: analyticsOrigin } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const openSnippetPanel = (0, $8yRiX.useOpenSnippetPanel)();
    const { isSnippetSharingForSiteEnabled: t1 } = (0, $dZUkS.useSnippetsState)();
    const isSnippetSharingForSiteEnabled = t1 === undefined ? false : t1;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).DUPLICATE_SNIPPET_MODAL);
    const handleClose = (0, $8JRDD.useSnippetModalClose)(onClose, (0, $hPTbh.ANALYTICS_ORIGIN).DUPLICATE_SNIPPET_MODAL, (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DUPLICATE_SNIPPET);
    let T0;
    let t2;
    if ($[0] !== analyticsOrigin || $[1] !== contentId || $[2] !== editorAPI || $[3] !== fireFailedAnalytic || $[4] !== fireSuccessAnalytic || $[5] !== flags || $[6] !== handleClose || $[7] !== intl || $[8] !== isSnippetSharingForSiteEnabled || $[9] !== onCloseComplete || $[10] !== openSnippetPanel || $[11] !== snippet.body || $[12] !== snippet.description || $[13] !== snippet.name || $[14] !== snippet.scope || $[15] !== snippet.snippetId || $[16] !== snippetsActions || $[17] !== spaceId || $[18] !== spaceKey) {
        const baseValues = (0, $aNHzZ.getDefaultFormValues)(isSnippetSharingForSiteEnabled);
        const suggestedName = (0, $gUhOL.getSuggestedDuplicateName)(snippet.name ?? "");
        const defaultValues = {
            ...baseValues,
            snippetName: suggestedName,
            snippetDescription: snippet.description ?? ""
        };
        const initialAdf = (0, $ies1q.wrapAdfWithDocNode)(snippet?.body);
        const formKey = `duplicate-${snippet.snippetId}`;
        const title = intl.formatMessage((0, $2hX8e.duplicateSnippetModalMessages).titleDuplicate, {
            snippetName: snippet.name ?? ""
        });
        const submitLabel = intl.formatMessage((0, $2hX8e.duplicateSnippetModalMessages).duplicateButton);
        const successFlagActions = analyticsOrigin === (0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_GALLERY ? undefined : [
            {
                content: intl.formatMessage((0, $6K2yS.messages).successFlagViewTemplateAction),
                onClick: openSnippetPanel
            }
        ];
        const onSubmit = async (values, currentAdf)=>{
            const bodySize = JSON.stringify(currentAdf).length;
            const duplicatedSnippet = await snippetsActions.createSnippet(values.snippetName, currentAdf, values.snippetDescription, {
                flags: flags,
                intl: intl,
                editorAPI: editorAPI ?? undefined,
                isShared: values.isShared,
                successFlagActions: successFlagActions,
                onShareFailure: (snippetId)=>fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SHARE, {
                        snippetId: snippetId
                    }),
                onSaveFailure: (error)=>{
                    const isBodyTooLarge = (0, $eWCeD.isBodyTooLargeError)(error);
                    fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_DUPLICATE, {
                        snippetId: snippet.snippetId,
                        ...isBodyTooLarge && {
                            isBodyTooLarge: true,
                            bodySize: bodySize
                        }
                    });
                },
                messages: {
                    successFlagTitle: (0, $2hX8e.duplicateSnippetModalMessages).duplicateSuccessFlagTitle,
                    errorFlagTitle: (0, $2hX8e.duplicateSnippetModalMessages).duplicateErrorFlagTitle,
                    errorFlagDescription: (0, $2hX8e.duplicateSnippetModalMessages).duplicateErrorFlagDescription
                }
            });
            if (duplicatedSnippet) {
                fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SAVE_SUCCESS, {
                    snippetId: duplicatedSnippet.snippetId,
                    bodySize: bodySize,
                    modalType: (0, $hPTbh.MODAL_TYPE).DUPLICATE
                });
                handleClose({
                    outcome: (0, $hPTbh.MODAL_OUTCOME).DUPLICATED,
                    snippetId: duplicatedSnippet.snippetId
                });
            }
        };
        T0 = (0, $2u5FB.SnippetBaseModal);
        t2 = (0, $2u5FB.getSnippetBaseModalProps)({
            title: title,
            submitLabel: submitLabel,
            formKey: formKey,
            defaultValues: defaultValues,
            initialAdf: initialAdf,
            onSubmit: onSubmit,
            handleClose: handleClose,
            fireFailedAnalytic: fireFailedAnalytic,
            onCloseComplete: onCloseComplete,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey,
            snippetId: snippet.snippetId,
            snippetScope: snippet.scope,
            isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled
        });
        $[0] = analyticsOrigin;
        $[1] = contentId;
        $[2] = editorAPI;
        $[3] = fireFailedAnalytic;
        $[4] = fireSuccessAnalytic;
        $[5] = flags;
        $[6] = handleClose;
        $[7] = intl;
        $[8] = isSnippetSharingForSiteEnabled;
        $[9] = onCloseComplete;
        $[10] = openSnippetPanel;
        $[11] = snippet.body;
        $[12] = snippet.description;
        $[13] = snippet.name;
        $[14] = snippet.scope;
        $[15] = snippet.snippetId;
        $[16] = snippetsActions;
        $[17] = spaceId;
        $[18] = spaceKey;
        $[19] = T0;
        $[20] = t2;
    } else {
        T0 = $[19];
        t2 = $[20];
    }
    let t3;
    if ($[21] !== T0 || $[22] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, t2);
        $[21] = T0;
        $[22] = t2;
        $[23] = t3;
    } else t3 = $[23];
    return t3;
};
const $9b2db0b31b451eb0$export$e422d2665be90f85 = (0, $7aRa9.withFlags)($9b2db0b31b451eb0$var$DuplicateSnippetModalWithFlags);
module.exports["DuplicateSnippetModal"] = $9b2db0b31b451eb0$export$e422d2665be90f85;

});

parcelRegister("gUhOL", function(module, exports) {
/**
 * Returns a suggested name for a duplicated snippet.
 * - If currentName ends with optional space(s) + number (e.g. "Snippet 2", "Snippet 10"), increment the number (e.g. "Snippet 3").
 * - Otherwise append " 2" so the next duplicate will fall under the first case.
 */ const $15e4b6093fd907e1$export$77a98a67f1bd093c = (currentName)=>{
    const trimmed = currentName.trim();
    if (!trimmed) // If the name is empty, leave as is
    return currentName;
    // Match "prefix" + space(s) + trailing number (e.g. "Snippet 2")
    const match = trimmed.match(/^(.+?)\s+(\d+)$/);
    if (match) {
        const prefix = match[1];
        const num = match[2];
        return `${prefix} ${parseInt(num, 10) + 1}`;
    }
    return `${trimmed} 2`;
};
module.exports["getSuggestedDuplicateName"] = $15e4b6093fd907e1$export$77a98a67f1bd093c;

});

parcelRegister("2hX8e", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $917224bcae6dc304$export$cf4d37474cc90563 = (0, $aXWIB.defineMessages)({
    titleDuplicate: {
        id: "snippets.snippetEditorModal.titleDuplicate",
        defaultMessage: "Create duplicate of {snippetName}"
    },
    duplicateButton: {
        id: "snippets.snippetEditorModal.duplicateButton",
        defaultMessage: "Duplicate"
    },
    duplicateSuccessFlagTitle: {
        id: "snippets.snippetEditorModal.duplicateSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" duplicated"
    },
    duplicateErrorFlagTitle: {
        id: "snippets.snippetEditorModal.duplicateErrorFlagTitle",
        defaultMessage: "Could not duplicate the template"
    },
    duplicateErrorFlagDescription: {
        id: "snippets.snippetEditorModal.duplicateErrorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["duplicateSnippetModalMessages"] = $917224bcae6dc304$export$cf4d37474cc90563;

});

parcelRegister("4lamI", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dcJ7R = parcelRequire("dcJ7R");


var $7aRa9 = parcelRequire("7aRa9");


var $ies1q = parcelRequire("ies1q");


var $dZUkS = parcelRequire("dZUkS");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $eWCeD = parcelRequire("eWCeD");


var $8JRDD = parcelRequire("8JRDD");


var $2u5FB = parcelRequire("2u5FB");


var $giat8 = parcelRequire("giat8");


var $aNHzZ = parcelRequire("aNHzZ");


var $8pLNp = parcelRequire("8pLNp");

const $b954cfb60a1110d7$var$EditSnippetModalWithFlags = (t0)=>{
    const $ = (0, $frIzR.c)(36);
    const { snippet: snippet, onClose: onClose, onCloseComplete: onCloseComplete, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, flags: flags, editorAPI: editorAPI } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { isSnippetSharingForSiteEnabled: t1 } = (0, $dZUkS.useSnippetsState)();
    const isSnippetSharingForSiteEnabled = t1 === undefined ? false : t1;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).EDIT_SNIPPET_MODAL);
    const handleClose = (0, $8JRDD.useSnippetModalClose)(onClose, (0, $hPTbh.ANALYTICS_ORIGIN).EDIT_SNIPPET_MODAL, (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).EDIT_SNIPPET);
    let T0;
    let t2;
    if ($[0] !== contentId || $[1] !== editorAPI || $[2] !== fireFailedAnalytic || $[3] !== fireSuccessAnalytic || $[4] !== flags || $[5] !== handleClose || $[6] !== intl || $[7] !== isSnippetSharingForSiteEnabled || $[8] !== onCloseComplete || $[9] !== snippet.body || $[10] !== snippet.description || $[11] !== snippet.isShared || $[12] !== snippet.name || $[13] !== snippet.scope || $[14] !== snippet.shareUrl || $[15] !== snippet.snippetId || $[16] !== snippetsActions || $[17] !== spaceId || $[18] !== spaceKey) {
        const baseValues = (0, $aNHzZ.getDefaultFormValues)(isSnippetSharingForSiteEnabled);
        const defaultValues = {
            ...baseValues,
            snippetName: snippet.name ?? "",
            snippetDescription: snippet.description ?? "",
            ...isSnippetSharingForSiteEnabled && {
                isShared: snippet.isShared ?? false
            }
        };
        const initialAdf = (0, $ies1q.wrapAdfWithDocNode)(snippet?.body);
        const formKey = `edit-${snippet.snippetId}`;
        const title = intl.formatMessage((0, $8pLNp.editSnippetModalMessages).titleEdit);
        const submitLabel = intl.formatMessage((0, $8pLNp.editSnippetModalMessages).saveButton);
        let t3;
        if ($[21] !== editorAPI || $[22] !== fireFailedAnalytic || $[23] !== fireSuccessAnalytic || $[24] !== flags || $[25] !== handleClose || $[26] !== intl || $[27] !== snippet.isShared || $[28] !== snippet.snippetId || $[29] !== snippetsActions) {
            t3 = async (values, currentAdf)=>{
                const bodySize = JSON.stringify(currentAdf).length;
                const updatedSnippet = await snippetsActions.updateSnippet(snippet.snippetId, values.snippetName, currentAdf, values.snippetDescription, {
                    flags: flags,
                    intl: intl,
                    editorAPI: editorAPI ?? undefined,
                    isShared: values.isShared ?? false,
                    previousIsShared: snippet.isShared ?? false,
                    onShareFailure: (snippetId)=>fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SHARE, {
                            snippetId: snippetId
                        }),
                    onUnshareFailure: (snippetId_0)=>fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_UNSHARE, {
                            snippetId: snippetId_0
                        }),
                    onSaveFailure: (error)=>{
                        const isBodyTooLarge = (0, $eWCeD.isBodyTooLargeError)(error);
                        fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_UPDATE, {
                            snippetId: snippet.snippetId,
                            ...isBodyTooLarge && {
                                isBodyTooLarge: true,
                                bodySize: bodySize
                            }
                        });
                    }
                });
                if (updatedSnippet) {
                    fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SAVE_SUCCESS, {
                        snippetId: updatedSnippet.snippetId,
                        bodySize: bodySize,
                        modalType: (0, $hPTbh.MODAL_TYPE).EDIT
                    });
                    handleClose({
                        outcome: (0, $hPTbh.MODAL_OUTCOME).EDITED,
                        snippetId: updatedSnippet.snippetId
                    });
                }
            };
            $[21] = editorAPI;
            $[22] = fireFailedAnalytic;
            $[23] = fireSuccessAnalytic;
            $[24] = flags;
            $[25] = handleClose;
            $[26] = intl;
            $[27] = snippet.isShared;
            $[28] = snippet.snippetId;
            $[29] = snippetsActions;
            $[30] = t3;
        } else t3 = $[30];
        const onSubmit = t3;
        T0 = (0, $2u5FB.SnippetBaseModal);
        let t4;
        if ($[31] !== snippet.shareUrl) {
            t4 = snippet.shareUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignInline: "end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $giat8.SnippetShareButton), {
                shareUrl: snippet.shareUrl
            })) : undefined;
            $[31] = snippet.shareUrl;
            $[32] = t4;
        } else t4 = $[32];
        t2 = (0, $2u5FB.getSnippetBaseModalProps)({
            title: title,
            submitLabel: submitLabel,
            formKey: formKey,
            defaultValues: defaultValues,
            initialAdf: initialAdf,
            onSubmit: onSubmit,
            handleClose: handleClose,
            fireFailedAnalytic: fireFailedAnalytic,
            onCloseComplete: onCloseComplete,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey,
            snippetId: snippet.snippetId,
            snippetScope: snippet.scope,
            isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled,
            extraActions: t4
        });
        $[0] = contentId;
        $[1] = editorAPI;
        $[2] = fireFailedAnalytic;
        $[3] = fireSuccessAnalytic;
        $[4] = flags;
        $[5] = handleClose;
        $[6] = intl;
        $[7] = isSnippetSharingForSiteEnabled;
        $[8] = onCloseComplete;
        $[9] = snippet.body;
        $[10] = snippet.description;
        $[11] = snippet.isShared;
        $[12] = snippet.name;
        $[13] = snippet.scope;
        $[14] = snippet.shareUrl;
        $[15] = snippet.snippetId;
        $[16] = snippetsActions;
        $[17] = spaceId;
        $[18] = spaceKey;
        $[19] = T0;
        $[20] = t2;
    } else {
        T0 = $[19];
        t2 = $[20];
    }
    let t3;
    if ($[33] !== T0 || $[34] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, t2);
        $[33] = T0;
        $[34] = t2;
        $[35] = t3;
    } else t3 = $[35];
    return t3;
};
const $b954cfb60a1110d7$export$41655ea7501ab119 = (0, $7aRa9.withFlags)($b954cfb60a1110d7$var$EditSnippetModalWithFlags);
module.exports["EditSnippetModal"] = $b954cfb60a1110d7$export$41655ea7501ab119;

});

parcelRegister("giat8", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $1bY7o = parcelRequire("1bY7o");


var $7aRa9 = parcelRequire("7aRa9");


var $kfIha = parcelRequire("kfIha");


var $eDBud = parcelRequire("eDBud");

const $b7f5fd7e4ee08804$var$messages = (0, $aXWIB.defineMessages)({
    label: {
        id: "snippets.snippetShareButton.label",
        defaultMessage: "Copy share link"
    },
    successTitle: {
        id: "snippets.snippetShareButton.successTitle",
        defaultMessage: "Link copied"
    },
    successDescription: {
        id: "snippets.snippetShareButton.successDescription",
        defaultMessage: "Template share link copied to clipboard"
    },
    errorTitle: {
        id: "snippets.snippetShareButton.errorTitle",
        defaultMessage: "Failed to copy link"
    }
});
const $b7f5fd7e4ee08804$var$SnippetShareButtonInner = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { shareUrl: shareUrl, flags: flags } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    let t1;
    if ($[0] !== copyToClipboard || $[1] !== flags || $[2] !== intl || $[3] !== shareUrl) {
        t1 = async ()=>{
            const origin = window?.location?.origin ?? "";
            const fullUrl = `${origin}${shareUrl}`;
            try {
                await copyToClipboard(fullUrl);
                (0, $eDBud.showSnippetSuccessFlag)(flags, intl.formatMessage($b7f5fd7e4ee08804$var$messages.successTitle), intl.formatMessage($b7f5fd7e4ee08804$var$messages.successDescription));
            } catch  {
                (0, $eDBud.showSnippetErrorFlag)(flags, intl.formatMessage($b7f5fd7e4ee08804$var$messages.errorTitle));
            }
        };
        $[0] = copyToClipboard;
        $[1] = flags;
        $[2] = intl;
        $[3] = shareUrl;
        $[4] = t1;
    } else t1 = $[4];
    const handleClick = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b7f5fd7e4ee08804$var$messages.label);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: handleClick
        }, t2);
        $[6] = handleClick;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $b7f5fd7e4ee08804$export$ebcbef2342efbe50 = (0, $7aRa9.withFlags)($b7f5fd7e4ee08804$var$SnippetShareButtonInner);
module.exports["SnippetShareButton"] = $b7f5fd7e4ee08804$export$ebcbef2342efbe50;

});

parcelRegister("6ATU7", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $4Nwes = parcelRequire("4Nwes");


var $buwvF = parcelRequire("buwvF");

const $45571a049f068e4f$export$f810e9b80d91f804 = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { snippetOwner: snippetOwner } = t0;
    const shouldUseAtlassianIcon = snippetOwner.accountId.toLowerCase() === (0, $buwvF.ATLASSIAN_ACCOUNT_ID).toLowerCase();
    if (shouldUseAtlassianIcon) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
                appearance: "brand",
                size: "xsmall"
            });
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    const t1 = snippetOwner;
    let t2;
    if ($[1] !== snippetOwner.displayName || $[2] !== t1.avatarUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            appearance: "circle",
            size: "xsmall",
            src: t1.avatarUrl,
            name: snippetOwner.displayName
        });
        $[1] = snippetOwner.displayName;
        $[2] = t1.avatarUrl;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
module.exports["SnippetCreatedByAvatar"] = $45571a049f068e4f$export$f810e9b80d91f804;

});

parcelRegister("f3452", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $kfYj7 = parcelRequire("kfYj7");


var $gI8uy = parcelRequire("gI8uy");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1qfLF = parcelRequire("1qfLF");


var $7aRa9 = parcelRequire("7aRa9");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $dZUkS = parcelRequire("dZUkS");

const $3ef50e7a99bc3ef5$var$styles = {
    container: "_v564wz4i _1o9zidpf _tzy4idpf _1mygkb7n",
    containerVisible: "_tzy4kb7n"
};
const $3ef50e7a99bc3ef5$var$messages = (0, $aXWIB.defineMessages)({
    favoritedLabel: {
        id: "snippets.snippetFavoriteButton.favoritedLabel",
        defaultMessage: "Unfavorite Snippet"
    },
    unfavoritedLabel: {
        id: "snippets.snippetFavoriteButton.unfavoritedLabel",
        defaultMessage: "Favorite Snippet"
    }
});
const $3ef50e7a99bc3ef5$var$SnippetFavoriteButtonInner = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { analyticsOrigin: analyticsOrigin, snippet: snippet, isHovered: isHovered, flags: flags } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic, fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)(analyticsOrigin);
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const shouldShowIcon = snippet.isFavorite || isHovered;
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = {
            intl: intl,
            flags: flags
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    const options = t1;
    let t2;
    if ($[3] !== fireButtonClickedAnalytic || $[4] !== fireFailedAnalytic || $[5] !== options || $[6] !== snippet.scope || $[7] !== snippet.snippetId || $[8] !== snippetsActions) {
        t2 = async (isFavoriteAfterToggle)=>{
            const action = isFavoriteAfterToggle ? snippetsActions.favoriteSnippet(snippet.snippetId, options) : snippetsActions.unfavoriteSnippet(snippet.snippetId, options);
            const success = await action;
            if (success) fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).SNIPPET_FAVORITE_TOGGLED, {
                snippetId: snippet.snippetId,
                scope: snippet.scope,
                isFavoriteAfterToggle: isFavoriteAfterToggle
            });
            else fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_FAVORITE_TOGGLED, {
                snippetId: snippet.snippetId,
                scope: snippet.scope,
                isFavoriteAfterToggle: isFavoriteAfterToggle
            });
        };
        $[3] = fireButtonClickedAnalytic;
        $[4] = fireFailedAnalytic;
        $[5] = options;
        $[6] = snippet.scope;
        $[7] = snippet.snippetId;
        $[8] = snippetsActions;
        $[9] = t2;
    } else t2 = $[9];
    const handleFavoriteToggle = t2;
    const t3 = shouldShowIcon && $3ef50e7a99bc3ef5$var$styles.containerVisible;
    let t4;
    if ($[10] !== t3) {
        t4 = (0, $1Whri.cx)($3ef50e7a99bc3ef5$var$styles.container, t3);
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== handleFavoriteToggle || $[13] !== intl || $[14] !== snippet.isFavorite) {
        t5 = snippet.isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            label: intl.formatMessage($3ef50e7a99bc3ef5$var$messages.favoritedLabel),
            icon: $3ef50e7a99bc3ef5$var$_temp,
            appearance: "subtle",
            onClick: ()=>handleFavoriteToggle(false)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            label: intl.formatMessage($3ef50e7a99bc3ef5$var$messages.unfavoritedLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))),
            appearance: "subtle",
            onClick: ()=>handleFavoriteToggle(true)
        });
        $[12] = handleFavoriteToggle;
        $[13] = intl;
        $[14] = snippet.isFavorite;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t4 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t4
        }, t5);
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
};
const $3ef50e7a99bc3ef5$export$d2c6bb946e52cf45 = (0, $7aRa9.withFlags)($3ef50e7a99bc3ef5$var$SnippetFavoriteButtonInner);
function $3ef50e7a99bc3ef5$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
        ...iconProps,
        color: "var(--ds-icon-accent-orange, #E06C00)",
        label: ""
    });
}
module.exports["SnippetFavoriteButton"] = $3ef50e7a99bc3ef5$export$d2c6bb946e52cf45;

});

parcelRegister("dh4hm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $iXCQx = parcelRequire("iXCQx");


var $jffWD = parcelRequire("jffWD");


var $2KKxv = parcelRequire("2KKxv");

const $2f79b005d1f01fd2$export$383d22f5717d5eaf = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { snippet: snippet } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== snippet) {
        t1 = (0, $jffWD.shouldShowInsertCount)(snippet);
        $[0] = snippet;
        $[1] = t1;
    } else t1 = $[1];
    const showUsage = t1;
    let t2;
    if ($[2] !== snippet) {
        t2 = (0, $jffWD.shouldShowPrivateLabel)(snippet);
        $[2] = snippet;
        $[3] = t2;
    } else t2 = $[3];
    const showPrivate = t2;
    if (!showUsage && !showPrivate) return null;
    let t3;
    if ($[4] !== intl || $[5] !== showUsage || $[6] !== snippet) {
        t3 = showUsage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, intl.formatMessage((0, $2KKxv.snippetUsageMessages).snippetUses, {
            formattedCount: (0, $jffWD.formatInsertCount)(snippet.insertCount),
            count: snippet.insertCount
        }));
        $[4] = intl;
        $[5] = showUsage;
        $[6] = snippet;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== showPrivate) {
        t4 = showPrivate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2KKxv.snippetUsageMessages).privateLabel));
        $[8] = showPrivate;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
module.exports["SnippetUsageAndPrivateLabels"] = $2f79b005d1f01fd2$export$383d22f5717d5eaf;

});

parcelRegister("jffWD", function(module, exports) {

var $cga1x = parcelRequire("cga1x");

const $4cb26235b23f04cc$export$b0602077fff33843 = (count)=>{
    if (count >= 1000000) {
        const millions = count / 1000000;
        const isWholeNumber = millions % 1 === 0;
        const usageValue = isWholeNumber ? millions.toFixed(0) : millions.toFixed(1);
        return `${usageValue}M`;
    }
    if (count >= 1000) {
        const thousands = count / 1000;
        const isWholeNumber = thousands % 1 === 0;
        const usageValue = isWholeNumber ? thousands.toFixed(0) : thousands.toFixed(1);
        return `${usageValue}K`;
    }
    return String(count);
};
const $4cb26235b23f04cc$export$8d9d303a9f76663f = (snippet)=>(snippet.scope === (0, $cga1x.SnippetScope).SITE || snippet.scope === (0, $cga1x.SnippetScope).GLOBAL) && snippet.insertCount !== undefined;
const $4cb26235b23f04cc$export$4b83df82273b7011 = (snippet)=>snippet.scope === (0, $cga1x.SnippetScope).USER && !snippet.isShared;
module.exports["formatInsertCount"] = $4cb26235b23f04cc$export$b0602077fff33843;
module.exports["shouldShowInsertCount"] = $4cb26235b23f04cc$export$8d9d303a9f76663f;
module.exports["shouldShowPrivateLabel"] = $4cb26235b23f04cc$export$4b83df82273b7011;

});

parcelRegister("2KKxv", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $5cdcffa8a3d87054$export$1bcb279c0c86be26 = (0, $aXWIB.defineMessages)({
    snippetUses: {
        id: "snippets.common.usage.uses",
        defaultMessage: "{formattedCount} {count, plural, one {Use} other {Uses}}"
    },
    privateLabel: {
        id: "snippets.common.usage.private",
        defaultMessage: "Private"
    }
});
module.exports["snippetUsageMessages"] = $5cdcffa8a3d87054$export$1bcb279c0c86be26;

});

parcelRegister("4tTm9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $kbVzJ = parcelRequire("kbVzJ");


var $aUTn5 = parcelRequire("aUTn5");


var $cZa7r = parcelRequire("cZa7r");


var $24amZ = parcelRequire("24amZ");

var $l2hqi = parcelRequire("l2hqi");


var $3jwuS = parcelRequire("3jwuS");


var $afGoD = parcelRequire("afGoD");


var $bQm3c = parcelRequire("bQm3c");


var $8Mzkb = parcelRequire("8Mzkb");

const $1d207411f43b18d4$export$a9a76753cd947d5c = ({ pageId: pageId, onCreate: onCreate, onClose: onClose, dom: selectionElement, textSelection: textSelection, inlineNodeTypes: inlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar = false, closeObjectSidebar: closeObjectSidebar, isOffline: isOffline })=>{
    const { editorCreateProps: editorCreateProps } = (0, $cZa7r.useAnnotations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const editorNode = (0, $42omo.useRef)(null);
    const indexFound = (0, $42omo.useRef)(0);
    const textMatches = (0, $42omo.useRef)(0);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Required to close the sidebar once we create a new standalone comment
    (0, $42omo.useEffect)(()=>{
        closeObjectSidebar && editorCreateProps && closeObjectSidebar();
    }, [
        closeObjectSidebar,
        editorCreateProps
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $8Ss4E.startEditorExperiences)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                mode: isLivePage ? (0, $l2hqi.InlineCommentMode).LIVE : (0, $l2hqi.InlineCommentMode).EDIT,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                edition: edition
            }
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        // both editor and inline comment sidebar share the same class, target the element that isn't the sidebar
        const editorNodes = Array.from(document.querySelectorAll('.ak-editor-content-area > .ProseMirror'));
        if (editorNodes.length) {
            const foundEditorNode = editorNodes.find((element)=>!element.closest('#editor-create-sidebar'));
            if (foundEditorNode) editorNode.current = foundEditorNode;
        }
        if (selectionElement && editorNode.current && textSelection) {
            const ignoredNodes = Array.from(editorNode.current.querySelectorAll((0, $aUTn5.IGNORE_SELECTORS)));
            const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(editorNode.current, ignoredNodes);
            const { index: index, numMatches: numMatches } = (0, $kbVzJ.findMatches)(text, textSelection, // we prefer the TextNode rather than <p> or headings
            selectionElement.parentNode ? selectionElement.parentNode : selectionElement, // default to 0 since the Editor wraps the selection in a <span> now
            0, nodesStartPos, nodes);
            indexFound.current = index;
            textMatches.current = numMatches;
        }
    }, [
        edition,
        selectionElement,
        textSelection,
        isLivePage,
        pageId,
        closeObjectSidebar,
        createAnalyticsEvent,
        editorCreateProps
    ]);
    const selectionOptions = (0, $42omo.useMemo)(()=>({
            originalSelection: textSelection,
            numMatches: textMatches.current,
            matchIndex: indexFound.current,
            inlineNodeTypes: inlineNodeTypes,
            createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : (0, $afGoD.CommentCreationLocation).EDITOR
        }), [
        textSelection,
        textMatches,
        indexFound,
        isLivePage,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Mzkb.CreateComment), {
        pageId: pageId,
        annotationElement: selectionElement,
        selectionOptions: selectionOptions,
        onClose: onClose,
        onCreate: onCreate,
        isEditor: true,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        isOffline: isOffline
    });
};
module.exports["CreateComponent"] = $1d207411f43b18d4$export$a9a76753cd947d5c;

});

parcelRegister("8Mzkb", function(module, exports) {

var $9dDPb = parcelRequire("9dDPb");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $inPa6 = parcelRequire("inPa6");


var $7EEGh = parcelRequire("7EEGh");


var $308Wd = parcelRequire("308Wd");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $aGjYc = parcelRequire("aGjYc");


var $hXzKU = parcelRequire("hXzKU");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $bSvtO = parcelRequire("bSvtO");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $cAdj8 = parcelRequire("cAdj8");


var $kmHPt = parcelRequire("kmHPt");


var $daq5m = parcelRequire("daq5m");


var $dLr6w = parcelRequire("dLr6w");


var $isdzP = parcelRequire("isdzP");


var $6cWI7 = parcelRequire("6cWI7");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $9CnRS = parcelRequire("9CnRS");


var $aMfLn = parcelRequire("aMfLn");


var $9QIM2 = parcelRequire("9QIM2");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $k8e76 = parcelRequire("k8e76");


var $56QzY = parcelRequire("56QzY");


var $fqIt3 = parcelRequire("fqIt3");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $hl0fg = parcelRequire("hl0fg");


var $7aRa9 = parcelRequire("7aRa9");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $en1dX = parcelRequire("en1dX");


var $9FoVw = parcelRequire("9FoVw");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $6mKj3 = parcelRequire("6mKj3");


var $b0EGa = parcelRequire("b0EGa");


var $a3q17 = parcelRequire("a3q17");


var $B3Avz = parcelRequire("B3Avz");

const $f4c77c6e390a7914$export$d26c1daa0321174b = (0, $aJPUt.ExperienceTimeout).CREATE_COMMENT_PUBLISH;
const $f4c77c6e390a7914$var$relativeFilePath = 'annotation-provider-inline-comments/CreateComment';
const $f4c77c6e390a7914$var$i18n = (0, $aXWIB.defineMessages)({
    unableToApplyTitle: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.title",
        defaultMessage: "Something went wrong"
    },
    unableToApplyDescription: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.description",
        defaultMessage: "We failed to display your comment. To view it, refresh now."
    },
    refreshContentLink: {
        id: "annotation-provider-inline-comments.refresh.content.link",
        defaultMessage: "Refresh content"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4c77c6e390a7914$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b",
            __cmplp.className
        ])
    });
});
const $f4c77c6e390a7914$var$styles = {
    commentEditorContainer: "_ca0qutpp"
};
const $f4c77c6e390a7914$var$getNodeType = (element, annotationId)=>{
    const nodeWithAnnotationWrapper = element.querySelector(`[id="${annotationId}"]`);
    if (nodeWithAnnotationWrapper) {
        const firsChildren = nodeWithAnnotationWrapper.firstChild;
        if (firsChildren?.nodeType === Node.TEXT_NODE) return 'text';
        const targetNode = nodeWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
    }
    return 'unknown';
}; // Exporting for testing cases
const $f4c77c6e390a7914$export$d4044f5b8f4bc73a = (setWasDraftAnnotationRemoved)=>(mutationList, observer)=>{
        for (const mutation of mutationList){
            if (mutation.type === 'childList') {
                if (mutation.removedNodes.length > 0) mutation.removedNodes.forEach((node)=>{
                    const nodeClassList = Array.from(node.classList ?? []); // COMMENTS-4308 - If any part of the draft annotation was removed, check if the entirity of the draft
                    // 				   was removed, if so, we need to disable the editor buttons as the comment will fail
                    if (nodeClassList.includes('ak-editor-annotation-draft')) {
                        if (document.querySelector('.ak-editor-annotation-draft') === null) {
                            // Tell the editor that the draft annotation was removed
                            setWasDraftAnnotationRemoved(true);
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog - draft annotation removed`); // Disconnect the observer since we no longer need it
                            observer.disconnect();
                        }
                    }
                });
            }
        }
    };
const $f4c77c6e390a7914$var$CommentEditorContainer = ({ children: children })=>(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $f4c77c6e390a7914$var$styles.commentEditorContainer
    }, children) : children;
const $f4c77c6e390a7914$var$CreateCommentComponent = ({ pageId: pageId, annotationElement: annotationElement, selectionOptions: selectionOptions, onClose: onClose, onCreate: onCreate, isEditor: isEditor, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, flags: flags, isOffline: isOffline })=>{
    const started = (0, $42omo.useRef)(false);
    const pageClass = (0, $9QIM2.usePageClass)();
    const { edition: edition, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    if (started.current === false) {
        // Just in case `edition` is not set on `createInlineCommentCompoundExperience.start()`,
        // which can occur if the experience was started from within the editor platform code.
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            edition: edition ?? ''
        });
        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.start();
        started.current = true;
    }
    const initialisedSelection = (0, $42omo.useRef)(false);
    if (selectionOptions && selectionOptions?.createdFrom === 'EDITOR' && initialisedSelection.current === false) {
        initialisedSelection.current = true;
        if (selectionOptions.inlineNodeTypes) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: selectionOptions.inlineNodeTypes
        });
    }
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const lastContentFetchTime = (0, $42omo.useRef)(1);
    const requestTimeoutHandle = (0, $42omo.useRef)();
    const sidebarEl = (0, $42omo.useRef)(null);
    const draftAnnotationMutationObserverRef = (0, $42omo.useRef)();
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const { documentUpdated: documentUpdated, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const createdAnnotationId = (0, $42omo.useRef)(null);
    const createdCommentId = (0, $42omo.useRef)(null);
    const [shouldRefetch, setShouldRefetch] = (0, $42omo.useState)(false);
    const [wasDraftAnnotationRemoved, setWasDraftAnnotationRemoved] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addUnresolvedInlineComment: addUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)(); // Check if avatar data is ready - this hook runs independently and checks cache/loading state
    const isAuthorReady = (0, $dLr6w.useCurrentUserAvatarReady)();
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElement,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: Boolean(isEditor),
        annotationElement: annotationElement,
        windowWidth: windowWidth,
        isSticky: isSticky
    }); // Hide OmniBar while this component is mounted (viewing inline comment)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $9wGTI.fg)('cc-engagement-omnibar-hide-inline-comments')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    const [createCommentFn] = (0, $308Wd.useMutationInterop)((0, $9dDPb.default));
    const { createInlineCommentInterop: createInlineCommentInterop } = (0, $6cWI7.useCreateInlineCommentMutation)({
        contentId: pageId
    });
    const { pageInfo: pageInfo, loading: loading, error: error, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        onError: (err)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                error: err
            });
        }
    });
    (0, $42omo.useEffect)(()=>{
        // should only refresh on the Content Out of date `Refresh` CTA is clicked
        if (documentUpdated && shouldRefetch && refetch) {
            refetch();
            setShouldRefetch(false);
            onClose && onClose();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentUpdated,
        shouldRefetch
    ]);
    (0, $42omo.useEffect)(()=>{
        const metadata = document.querySelector('meta[name=confluence-request-time]');
        if (metadata) {
            const fetchTime = Number(metadata.getAttribute('content'));
            lastContentFetchTime.current = isNaN(fetchTime) ? 1 : fetchTime;
        }
        if (pageMode !== (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            const editorTextArea = document.getElementById('ak-editor-textarea');
            draftAnnotationMutationObserverRef.current = new MutationObserver($f4c77c6e390a7914$export$d4044f5b8f4bc73a(setWasDraftAnnotationRemoved)); // We need to watch the whole editorTextArea because highlights could
            if (editorTextArea) draftAnnotationMutationObserverRef.current.observe(editorTextArea, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            if (pageMode !== (0, $cD1qu.PageMode).VIEW && draftAnnotationMutationObserverRef.current && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) draftAnnotationMutationObserverRef.current.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Check for highlight element on mount - fail experience if createComment renders without a highlight
    // This tracks the scenario where createComment re-renders on close of the comment box without a highlight
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_enable_exp_create_rerenderer', 'isEnabled', true)) return;
         // Use a small delay to allow the DOM to settle after any state changes
        const timeoutId = setTimeout(()=>{
            const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191(); // Fail experience if createComment renders without a highlight
            if (!draftAnnotationElement && !wasDraftAnnotationRemoved) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('CreateComment renders without highlight'));
        }, 100);
        return ()=>clearTimeout(timeoutId); // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const saveAttemptedTracker = (0, $42omo.useRef)({
        lastMutationSucceeded: false,
        totalSaves: 0,
        failedSaves: 0
    });
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const savesWithoutError = // hit, the experience will already have completed in the `handleSaveComment`.
            saveAttemptedTracker.current.totalSaves - saveAttemptedTracker.current.failedSaves;
            if (saveAttemptedTracker.current.failedSaves > 0) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                // eslint-disable-next-line react-hooks/exhaustive-deps
                failedSaves: saveAttemptedTracker.current.failedSaves
            });
            if (savesWithoutError > 1) {
                // At the point this is dismounting -- we don't know for certain if the user intended for this to be discarded or not
                // so we hard fail the full experience (it's possible the dismount is because the second save has worked and
                // the UI is about to load the new comment)
                (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                    savesWithoutError: savesWithoutError
                });
                const msg = 'User clicked save, but UI did not update following successful save'; // we log a debug point and continue with the flow, since creation is not necessarily failing
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debugPoint(msg);
            }
            if (saveAttemptedTracker.current.lastPublishFailure) {
                if (saveAttemptedTracker.current.lastMutationSucceeded) {
                    // in the case there was a publish failure, but the last mutation succeeded -- we assume the dismount is
                    // because the ui is about to load the new comment - in this case we only mark the experience as a soft
                    // failure (we'll capture more details and fail in the final experience step)
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.softFail(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                } else {
                    // In this scenario -- the user attempted to save at least once, got a network error, and gave up on
                    // trying to create the comment
                    // For a subset of errors -- the user is presented with a human readable error message describing that
                    // the comment creation failure is due to the content changing (e.g. the user has edited the page) and
                    // that they need to refresh the page to apply the comment.  In this scenario we don't treat the comment
                    // creation as a failure, but rather we want to mark the experience as aborted.
                    const contentChangedErrorSubstrings = [
                        'Invalid arguments provided for matchIndex and/or numMatches',
                        'Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex',
                        'Selection was made against a stale version of the content',
                        'Published Version out of date. Please provide correct published version.'
                    ];
                    const isContentChangedError = contentChangedErrorSubstrings.some((substring)=>// eslint-disable-next-line react-hooks/exhaustive-deps
                        saveAttemptedTracker.current.lastPublishFailure?.message.includes(substring));
                    if (isContentChangedError) {
                        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                            abortReason: 'Unable to apply annotation to document'
                        });
                        return;
                    } // This is handled in the UI appropriately, and we should abort not fail
                    const permissionErrorSubstring = 'Could not create content with type comment';
                    const isPermissionError = saveAttemptedTracker.current.lastPublishFailure?.message.includes(permissionErrorSubstring);
                    if (isPermissionError) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                        abortReason: 'User does not have space permission to create comments'
                    });
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.stopOnError(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                }
            }
            if (saveAttemptedTracker.current.lastMutationSucceeded) {
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.complete();
                return;
            } // In this case the user did not attempt to save the comment, and so we assume this was
            // an intentional discard of the comment.
            // So we abort the draftToPublishExperience here, along with any unfinished initExperience.
            const abortReason = 'Create Comment UI dismissed';
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                abortReason: abortReason
            });
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                abortReason: abortReason
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
        };
    }, []);
    const saveAttemptedCounts = (0, $42omo.useRef)({
        total: 0,
        failedSaves: 0
    });
    const failPublishExperience = (0, $42omo.useCallback)((commentPublishError, translatedErrorMsg)=>{
        // COMMENTS-1879 - Only log unexpected errors or annotation application error as failures
        if ((0, $isdzP.isUnexpectedError)(translatedErrorMsg)) experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: commentPublishError
        });
        else (0, $7Sm4c.markErrorAsHandled)(commentPublishError);
    }, [
        experienceTracker
    ]);
    const onCacheUpdateError = (0, $42omo.useCallback)((cacheError)=>{
        const { message: message } = (0, $isdzP.parseError)(cacheError);
        failPublishExperience(cacheError, (0, $isdzP.getTranslatedError)(message));
    }, [
        failPublishExperience
    ]);
    const handleSaveCommentWithTimeout = (timeoutInMs, saveMutation)=>{
        const timeout = new Promise((_resolve, reject)=>{
            requestTimeoutHandle.current = setTimeout(()=>{
                experienceTracker.stopOnError({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                    error: new Error(`Request took longer than ${timeoutInMs}ms`)
                });
                return reject({
                    error: (0, $9CnRS.i18n).createTimeout
                });
            }, timeoutInMs);
        });
        return Promise.race([
            timeout,
            saveMutation
        ]).finally(()=>{
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
        });
    };
    const handleSaveComment = (adf, onSuccess)=>{
        saveAttemptedTracker.current.totalSaves = saveAttemptedTracker.current.totalSaves + 1;
        saveAttemptedTracker.current.lastMutationSucceeded = false;
        saveAttemptedCounts.current.total = saveAttemptedCounts.current.total + 1;
        createdAnnotationId.current = null;
        createdCommentId.current = null;
        if (!selectionOptions) // We likely will never get here, but just in case
        return Promise.reject({
            error: (0, $9CnRS.i18n).unableToGenerateStep
        });
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
            attributes: {
                pageId: pageId,
                pageMode: pageMode,
                isEditor: isEditor
            }
        });
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).start();
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationStart');
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                timeout: $f4c77c6e390a7914$export$d26c1daa0321174b
            }
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_debug_v2')) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            currentDocumentVersion: currentDocumentVersion,
            publishedDocumentVersion: publishedDocumentVersion,
            isPageOutdated: currentDocumentVersion !== publishedDocumentVersion
        });
        const { numMatches: numMatches, matchIndex: matchIndex, originalSelection: originalSelection, createdFrom: createdFrom, step: step, targetNodeType: targetNodeType } = selectionOptions; // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: pageId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                numMatches: numMatches,
                matchIndex: matchIndex,
                originalSelection: originalSelection,
                createdFrom: createdFrom,
                lastFetchTimeMillis: lastContentFetchTime.current,
                // In VIEW mode, we send the currentDocumentVersion so that the backend can
                // correctly identify where the inline annotation should be applied on the Page.
                // p.s. currentDocumentVersion is not set in EDIT/LIVE mode.
                publishedVersion: pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_create_inline_use_curr_doc_version', 'isEnabled', true) ? currentDocumentVersion : publishedDocumentVersion,
                ...!!step && {
                    step: (0, $aMfLn.constructStepForGql)(step)
                }
            },
            pageId: pageId,
            includeReactionsAndReplies: false
        }; // Note -- this mixes data saving logic and UI application logic.
        // And when the UI logic fails, the result is that the user is left with
        // the ui looking like the comment failed to save.
        // This should be refactored to separate the two concerns, and on a UI application
        // failure, we should encourage users to refresh (and mark the experience as failed).
        let succeededPublish = false;
        const onCreateSuccess = (retVal)=>{
            saveAttemptedTracker.current.lastMutationSucceeded = true;
            const { data: data } = retVal;
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
            succeededPublish = true;
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.publishSucceeded(); // Invalidate the collab draft cache since adding a comment modifies the ADF content
            // (adds annotation marks). This ensures the editor will fetch fresh content with
            // comment annotations if the user clicks Edit after adding a comment.
            if ((0, $9wGTI.fg)('confluence_fe_invalidate_collab_draft_cache')) (0, $fqIt3.clearCollabDraftTimestamp)(pageId);
             // Mark comment creation end for both cohorts
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationEnd');
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentDataLoadStart');
            const annotationId = data?.createInlineComment?.location?.inlineMarkerRef;
            const commentId = data?.createInlineComment?.id;
            if (!annotationId || !commentId) throw new Error(`Comment was not saved correctly - either annotationId '${annotationId}' or commentId '${commentId}' were undefined`);
            createdAnnotationId.current = annotationId;
            createdCommentId.current = commentId; // Reset the content changing flag
            resetContentChanged(); // Grab the marker ref id returned and update the editor/renderer
            try {
                onCreate(annotationId, data?.createInlineComment);
            } catch (e) {
                // We generate errors in renderer, but this will also handle the editor case
                throw new Error(`Unable to apply annotation to document - ${e.message}`);
            } // Update the unresolved inline comments count
            addUnresolvedInlineComment(annotationId, pageMode); // For experiment cohort, we pass the mutation data to onCreate
            // The experiment success and data load completion will be handled in AnnotationsContext
            // after the view component renders the new data
            const newComment = {
                // (Need to coerce the data from the new Comments Data Manager's mutation because it is
                // defined using the new Relay-generated types that define option fields as "| null | undefined"
                // but the original Apollo-generated types define them as just "| null".  These aren't compatible
                // without the coercion even though the "if (value)" or "value?." expressions would work the same.)
                ...data?.createInlineComment,
                isOpen: true,
                type: (0, $8i27m.CommentType).INLINE,
                wasRemovedByAnotherUser: false,
                replies: [],
                reactionsSummary: null
            };
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addNewCommentThreads({
                general: {},
                inline: {
                    [annotationId]: newComment
                }
            });
             // Create inline comment track event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        parentCommentId: null,
                        isReply: false,
                        pageMode: pageMode,
                        isLivePage: createdFrom === 'LIVE',
                        navdexPointType: (0, $56QzY.END),
                        inlineNodeTypes: selectionOptions.inlineNodeTypes,
                        ...annotationElement && !isEditor && {
                            nodeType: $f4c77c6e390a7914$var$getNodeType(annotationElement, annotationId)
                        },
                        ...!isEditor && {
                            targetNodeType: targetNodeType
                        }
                    }
                }
            }).fire(); // Reset the editor
            onSuccess();
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                commentType: 'inline',
                entryPoint: 'create-comment',
                annotationId: annotationId
            }); /*
           * On editor pages, the view-inline-comment experience is started by the editor when the
           * created annotation is automatically selected after successful comment creation. For
           * editor pages, we update the attributes here to ensure that the experience is tracked
           * with the correct entry point.
           */ 
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_create')) {
                const attributes = {
                    annotationId: annotationId,
                    entryPoint: $f4c77c6e390a7914$var$relativeFilePath,
                    pageClass: pageClass
                };
                if (pageClass === 'renderer') experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        ...attributes
                    }
                });
                else if (pageClass === 'editor') experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    attributes: attributes
                });
                if (isCommentsPanelShown) experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Comments panel is visible when it should not be'),
                    attributes: {
                        stopPoint: $f4c77c6e390a7914$var$relativeFilePath
                    }
                });
            }
        };
        const onCreateFailure = (err)=>{
            saveAttemptedTracker.current.failedSaves = saveAttemptedTracker.current.failedSaves + 1;
            saveAttemptedCounts.current.failedSaves = saveAttemptedCounts.current.failedSaves + 1;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                error: err,
                attributes: {
                    pageId: pageId,
                    pageMode: pageMode,
                    isEditor: isEditor,
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debug({
                error: err,
                createAnalyticsEvent: createAnalyticsEvent,
                extraAttributes: {
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            if (!succeededPublish) saveAttemptedTracker.current.lastPublishFailure = err;
            let contentOutOfDate = false; // Get a truncated graphql error message
            const { errorId: errorId, message: message } = (0, $isdzP.parseError)(err);
            const translatedError = (0, $isdzP.getTranslatedError)(message); // COMMENTS-1879 - The backend will fall back to the old method of trying to make string matches if the content
            // is out of date. If the BE fails to apply a comment when using the old fallback method we should log it
            if ((0, $isdzP.isHighlightError)(translatedError)) {
                // Send the analytics event
                const analyticsObject = {
                    source: 'viewPage',
                    objectType: 'page',
                    objectId: pageId,
                    action: 'invalid',
                    actionSubject: 'highlight',
                    actionSubjectId: 'inlineComment',
                    attributes: {
                        errorMessage: message,
                        editor: 'FABRIC',
                        framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                        errorId: errorId,
                        highlightOrigin: 'userHighlight' // TODO: Do we need to programmatically track this?
                    }
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: analyticsObject
                }).fire();
                contentOutOfDate = true;
            }
            failPublishExperience(err, translatedError); // Use the existing value if it's already set or is an out of date error
            contentOutOfDate = contentOutOfDate || (0, $isdzP.isOutOfDateError)(translatedError); // In the case of an annotation error, we should show a flag to the user to let them know
            // their comment has been saved and they need to refresh the content (view mode only)
            if ((0, $isdzP.isAnnotationError)(translatedError)) {
                const CREATE_ERROR_FLAG_ID = `create-error-${Date.now()}`;
                const getAnnotationErrorFlagActions = ()=>{
                    if (pageMode === (0, $cD1qu.PageMode).VIEW) // Only show the refetch content action on view mode as it's not applicable in editor/live
                    return [
                        {
                            content: formatMessage($f4c77c6e390a7914$var$i18n.refreshContentLink),
                            onClick: ()=>{
                                setRefetchContent(true);
                                handleOnClose();
                                flags.hideFlag(CREATE_ERROR_FLAG_ID);
                            }
                        }
                    ];
                    else {
                        // pageMode === PageMode.EDITOR || PageMode.LIVE
                        if (createdAnnotationId.current && createdCommentId.current && translatedError === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation && (0, $6mKj3.expValEquals)('confluence_fe_show_created_dangling_comment_flag', 'isEnabled', true)) return [
                            {
                                content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                                onClick: ()=>{
                                    if (!isCommentsPanelShown) showCommentsPanel({
                                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    else setCurrentView((0, $3mVfX.ViewValues).DELETED_CONTENT);
                                    setCurrentlySelectedThreadKey(createdAnnotationId.current);
                                    (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                        context: (0, $9FoVw.NavigationContext).PANEL,
                                        block: 'center',
                                        annotationId: createdAnnotationId.current,
                                        commentId: createdCommentId.current,
                                        commentType: 'INLINE',
                                        annotationClicked: true,
                                        expectedView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    flags.hideFlag(CREATE_ERROR_FLAG_ID);
                                }
                            }
                        ];
                         // TODO: Add more actions for editor/live if needed
                    }
                    return [];
                };
                flags.showWarningFlag({
                    id: CREATE_ERROR_FLAG_ID,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f4c77c6e390a7914$var$i18n.unableToApplyTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), translatedError === (0, $9CnRS.i18n).unableToApplyAnnotation ? $f4c77c6e390a7914$var$i18n.unableToApplyDescription : translatedError),
                    actions: getAnnotationErrorFlagActions()
                }); // Log the occurance through analytics so we can still track it
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                        objectType: 'page',
                        objectId: pageId,
                        action: 'failed',
                        actionSubject: 'applyAnnotation',
                        actionSubjectId: 'inlineComment',
                        attributes: {
                            errorMessage: message,
                            editor: 'FABRIC',
                            framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                            isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                            tenantId: cloudId,
                            userId: userId,
                            pageId: pageId
                        }
                    }
                }).fire(); // Some code duplication.
                // Not extracting common code since `else` will be deleted after experiment is shipped.
                if ((0, $6mKj3.expValEquals)('confluence_fe_show_created_dangling_comment_flag', 'isEnabled', true)) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Unable to apply annotation to document',
                    attributes: {
                        detailedMessage: message,
                        ...errorId ? {
                            errorId: errorId
                        } : {},
                        pageMode: pageMode,
                        context: isEditor ? 'editor' : 'renderer',
                        pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                        pageId: pageId
                    }
                });
                else (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.fail(new Error('Unable to apply annotation to document'), {
                    detailedMessage: message,
                    ...errorId ? {
                        errorId: errorId
                    } : {},
                    pageMode: pageMode,
                    context: isEditor ? 'editor' : 'renderer',
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                    pageId: pageId
                });
                onClose && onClose();
                return;
            }
            // CommentEditor expects a translated error message otherwise it fails
            // TODO: CommentEditor should likely just receive the translated message
            // rather than expect the object needed for FormattedMessage
            return Promise.reject({
                error: contentOutOfDate ? (0, $9CnRS.i18n).contentOutOfDate : translatedError,
                contentOutOfDate: contentOutOfDate
            });
        };
        // Wrap the createCommentFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const commentCreationInteropWrapper = (options)=>createInlineCommentInterop({
                originalMutationFn: createCommentFn,
                options: options,
                onCacheUpdateError: onCacheUpdateError
            });
        if ((0, $9wGTI.fg)('confluence_frontend_add_inline_comment_timeout')) return handleSaveCommentWithTimeout($f4c77c6e390a7914$export$d26c1daa0321174b, commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure));
        else return commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure);
    };
    const handleOnClose = (0, $42omo.useCallback)((hasContentChanged)=>{
        const reason = hasContentChanged ? 'comment discarded by user' : 'empty comment discarded by user';
        experienceTracker.abort({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            reason: reason
        }); // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', 'create');
        onClose && onClose();
    }, [
        experienceTracker,
        isEditor,
        onClose
    ]);
    const [currentContentId] = (0, $ep3mz.usePageContentId)();
    const initialContentIdRef = (0, $42omo.useRef)(currentContentId);
    (0, $42omo.useEffect)(()=>{
        if (initialContentIdRef.current && currentContentId && initialContentIdRef.current !== currentContentId && (0, $9wGTI.fg)('confluence_fe_discard_inline_comment_on_navigation')) handleOnClose();
    }, [
        currentContentId,
        handleOnClose
    ]);
    const onEditorLoad = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        });
        const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191();
        if (!draftAnnotationElement && !wasDraftAnnotationRemoved) {
            // We have handling to show a message when we detect the draft annotation was removed, indicated by
            // `wasDraftAnnotationRemoved=true`. So we only need to fail the experience if we unexpectedly cannot find
            // the draftAnnotationElement, indicated by `wasDraftAnnotationRemoved=false`
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('No annotation element'));
            return;
        }
        setTimeout(()=>{
            // There are multiple useEffects involved in positioning the comment UI.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            requestAnimationFrame(()=>{
                // In the Editor and Renderer, the comment UI is positioned relative to slightly different
                // elements.
                if (!draftAnnotationElement) {
                    (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                        abortReason: 'Draft annotation removed from document'
                    });
                    return;
                } else if (!sidebarEl.current) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Missing create comment ui'));
                else {
                    const commentUIVerticalDistanceFromAnnotation = Math.abs(draftAnnotationElement.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top); // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                    if (commentUIVerticalDistanceFromAnnotation > 40) {
                        const isVisible = sidebarEl.current.checkVisibility();
                        if (isVisible) {
                            // if it's fully visible, but misaligned, we don't treat this as a failure
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debug({
                                error: new Error('View Created Comment UI too far from annotation'),
                                createAnalyticsEvent: createAnalyticsEvent,
                                extraAttributes: {
                                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                                }
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                        } else {
                            (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                                misalignedBy: commentUIVerticalDistanceFromAnnotation
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Draft Comment UI is setup too far from annotation'));
                        }
                    } else (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                }
            });
        }, 1000);
    };
    if (loading || error) {
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog ${loading ? 'loading' : 'error'}`, {
            error: error?.message ?? '',
            loading: loading
        });
        return null;
    }
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? ''; // User page permissions
    const operations = pageInfo?.operations || [];
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType); // Don't render CreateComment at all until author data is ready (only when experiment is enabled)
    // This ensures both CommentAuthor and CommentEditor render together with data ready
    if (!isAuthorReady && (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $B3Avz.CommentSidebar), {
        pageId: pageId,
        onClose: handleOnClose,
        isEditor: isEditor,
        annotationElement: annotationElement,
        sidebarOffset: sidebarOffset,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        isSticky: isSticky,
        isFabricPage: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4c77c6e390a7914$var$Container, {
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        size: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? 'small' : 'medium',
        commentMode: "create",
        userId: userId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4c77c6e390a7914$var$CommentEditorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor // @ts-ignore FIXME: `pageId` can be `undefined` here, and needs proper handling
    ), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: "chromeless",
        EditorComponent: (0, $7EEGh.ChromelessEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        commentMode: "create",
        commentType: isEditor ? 'edit-inline' : 'inline',
        onEditorReady: onEditorLoad,
        hideWatchCheckbox: true,
        pageMode: isEditor ? 'edit' : 'view',
        shouldWarnOnInternalNavigation: true,
        useNewWarningModal: true,
        setShouldRefetch: ()=>setShouldRefetch(true),
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        wasDraftAnnotationRemoved: wasDraftAnnotationRemoved,
        isStandaloneComment: true,
        isOffline: isOffline
    }))));
};
const $f4c77c6e390a7914$export$b217475cf0d7b767 = (0, $7aRa9.withFlags)($f4c77c6e390a7914$var$CreateCommentComponent); /**
                                                                 *
                                                                 * Exported for testing purposes only
                                                                 *
                                                                 * This function is used to find the draft annotation element in the DOM.
                                                                 * It checks both the renderer and editor for the draft annotation element.
                                                                 *
                                                                 * In some scenarios, there are duplicate draft annotations in the DOM such
                                                                 * as in the renderer where the dom for table headers is repeated.
                                                                 *
                                                                 * To mitigate this, we get all possible draft annotation elements and
                                                                 * and return the first one that has a height greater than 0.
                                                                 *
                                                                 * If no draft annotation element is found, it returns null.
                                                                 */ 
function $f4c77c6e390a7914$export$292a5d148db8f191() {
    const possibleAnnotations = document.querySelectorAll((0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage_2') ? '[data-annotation-draft-mark="true"], .ak-editor-annotation-draft, .ak-editor-block-annotation-draft' : '[data-annotation-draft-mark="true"], .ak-editor-annotation-draft');
    if (possibleAnnotations.length === 1) // In cases where there is only one draft annotation, we can return it directly
    // and avoid the performance hit where reflow is triggered by checking if the
    // annotation has a height greater than 0.
    return possibleAnnotations[0];
    for(let i = 0; i < possibleAnnotations.length; i++){
        if (possibleAnnotations[i].getBoundingClientRect().height > 0) return possibleAnnotations[i];
    }
    return null;
}
module.exports["CreateComment"] = $f4c77c6e390a7914$export$b217475cf0d7b767;

});

parcelRegister("9dDPb", function(module, exports) {
/**
 * @generated SignedSource<<40388ecd47484ed71ca6b291e9af3d83>>
 * @relayHash 53d10a195ebf90f6f61c9c986fa7c9e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d5eae455a43e1b40c154fe51c43e195ecb9291e9b50f3ec9fa5dcc7d168f047
const $122b34084b15b4af$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsAndReplies"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    }, v23 = {
        "kind": "ScalarField",
        "name": "number"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v25 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v28 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v29 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v31 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v11 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v32 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v33 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateCommentInlineCommentMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "createInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v24 /*: any*/ ,
                        v28 /*: any*/ ,
                        {
                            "condition": "includeReactionsAndReplies",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateCommentInlineCommentMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "createInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v31 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ ,
                        {
                            "condition": "includeReactionsAndReplies",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "53d10a195ebf90f6f61c9c986fa7c9e9",
            "id": "0d5eae455a43e1b40c154fe51c43e195ecb9291e9b50f3ec9fa5dcc7d168f047",
            "metadata": {},
            "name": "CreateCommentInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CreateCommentInlineCommentMutation($input:CreateInlineCommentInput!,$pageId:ID!,$includeReactionsAndReplies:Boolean!){createInlineComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsAndReplies){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}\n    replies@include(if:$includeReactionsAndReplies){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$122b34084b15b4af$var$node.hash = "a3c6b6f761ae740a51004ae0c2e8fb68";
var $122b34084b15b4af$export$2e2bcd8739ae039 = $122b34084b15b4af$var$node;
module.exports["default"] = $122b34084b15b4af$export$2e2bcd8739ae039;

});

parcelRegister("dLr6w", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $cUiCf = parcelRequire("cUiCf");

const $4baccafa846af1c4$export$fba4d5c7ef076998 = ()=>{
    const $ = (0, $frIzR.c)(4);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== userId) {
        t0 = !userId || !(0, $6mKj3.expValEquals)("confluence_comment_improve_author_paint", "isEnabled", true);
        $[0] = userId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            skip: t0,
            fetchPolicy: "cache-first"
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const { isReady: isReady } = (0, $cUiCf.useCommentAuthorQuery)(userId ?? undefined, t1);
    if (!(0, $6mKj3.expValEquals)("confluence_comment_improve_author_paint", "isEnabled", true)) return true;
    if (!userId) return true;
    return isReady;
};
module.exports["useCurrentUserAvatarReady"] = $4baccafa846af1c4$export$fba4d5c7ef076998;

});

parcelRegister("6cWI7", function(module, exports) {

var $l4jQJ = parcelRequire("l4jQJ");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment. Because the new Comments
// Data Manager caches all the data for comments in Relay, we need to define the mutation here so
// that the cache can be updated fully when a new comment is created - and that means the mutation
// needs to return the full comment data structure that we are using in the returned query part of
// the mutation.  Since that returned query is quite large, we define it here in its own hook to
// avoid having it in many places in the codebase - which makes the code harder to read and could
// lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// (Note that there is another exported GraphQL mutation variable named "CreateInlineCommentMutation"
// that is exported from @confluence/inline-comments-queries. It's okay that these are the same
// variable name because the other one does not seem to be imported anywhere in the codebase at
// present, this variable is only used internally in this file, and the actual muation's name -
// useCreateInlineCommentMutation - is unique so GQL won't complain.)
const $03f1ee89907a0c1d$var$CreateInlineCommentMutation = (0, $l4jQJ.default);
const $03f1ee89907a0c1d$export$10606ca3587bb707 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineCommentFn] = (0, $308Wd.useMutationInterop)($03f1ee89907a0c1d$var$CreateInlineCommentMutation);
    const addEmptyInlineRepliesAndReactions = (0, $42omo.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            replies: [],
            reactionsSummary: (0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true) ? null : commentData.reactionsSummary ?? null
        } : undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comments. It will either call the new Comments Data Manager path or the old Apollo
    // mutation path depending on whether the relevant experiment is enabled.
    const createInlineCommentInterop = (0, $42omo.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // Strip out the old update function and other options, and adjust variables as needed
            // The includeReactionsAndReplies variable is needed by some of the legacy mutations but is
            // not needed by the new Comments Data Manager. So remove it if we're using the new path -
            // otherwise Typescript will complain and GQL may error as well.
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables ?? {
                includeReactionsAndReplies: undefined
            };
            const updateNewCommentInCache = (_dataProxy, mutationResult)=>{
                addCommentInCache({
                    newComment: addEmptyInlineRepliesAndReactions(mutationResult.data.createInlineComment),
                    onError: onCacheUpdateError
                });
            };
            return createInlineCommentFn({
                variables: {
                    ...newVariables,
                    includeReactionsSummary: !(0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true)
                },
                update: updateNewCommentInCache
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesAndReactions,
        createInlineCommentFn
    ]);
    return {
        createInlineCommentInterop: createInlineCommentInterop
    };
};
module.exports["useCreateInlineCommentMutation"] = $03f1ee89907a0c1d$export$10606ca3587bb707;

});

parcelRegister("l4jQJ", function(module, exports) {
/**
 * @generated SignedSource<<01b0defc3b9ea25e87aebb656d2e24b0>>
 * @relayHash 44102a25791a45664a7cee556a06b417
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c986ca4c90a941ccb373a83d557efa12425e0ed56bc3f91ac8ce141534051446
const $3dcbd79e6f23278f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsSummary"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v13 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createInlineComment",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v8 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                },
                {
                    "condition": "includeReactionsSummary",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "pageId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateInlineCommentMutation",
            "selections": v13 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateInlineCommentMutation",
            "selections": v13 /*: any*/ 
        },
        "params": {
            "cacheID": "44102a25791a45664a7cee556a06b417",
            "id": "c986ca4c90a941ccb373a83d557efa12425e0ed56bc3f91ac8ce141534051446",
            "metadata": {},
            "name": "useCreateInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineCommentMutation($pageId:ID!,$input:CreateInlineCommentInput!,$includeReactionsSummary:Boolean!){createInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$3dcbd79e6f23278f$var$node.hash = "1024b1212d3a391069987015908aee0c";
var $3dcbd79e6f23278f$export$2e2bcd8739ae039 = $3dcbd79e6f23278f$var$node;
module.exports["default"] = $3dcbd79e6f23278f$export$2e2bcd8739ae039;

});

parcelRegister("3Xfi8", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7nPJ6 = parcelRequire("7nPJ6");


var $6HwWx = parcelRequire("6HwWx");

const $6a7e747c5d5174c7$export$9be7dcbe458ba189 = ({ annotationElement: annotationElement, isEditor: isEditor })=>{
    const classToCheck = '.pm-table-container';
    let elementToObserve = undefined;
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // elements to observe, these are different than elements that determine if the table is sticky
    if (isEditor) elementToObserve = isStickyHeaderExperimentEnabled ? annotationElement?.closest(classToCheck)?.querySelector('.pm-table-wrapper > table > tbody > tr') : annotationElement?.closest(classToCheck)?.parentElement?.querySelector('.pm-table-sticky-sentinel-top');
    else elementToObserve = annotationElement?.closest(classToCheck);
    const [isSticky, setIsSticky] = (0, $7nPJ6.useIsSticky)({
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    (0, $6HwWx.useStickyTableHeaderObserver)({
        setIsSticky: setIsSticky,
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    // Check if annotationElement is a child of tr (th element) and th's immediate parent is tbody
    const thElement = annotationElement?.closest('th');
    if (thElement) {
        const trElement = thElement.parentElement;
        const tbodyElement = trElement?.parentElement;
        // If tr is the first child of tbody, return false
        if (tbodyElement?.firstElementChild !== trElement) return {
            isSticky: false
        };
    }
    // if annotation element is inside a nested table, then return false
    if (annotationElement?.closest('.pm-table-nested-table-with-controls')) return {
        isSticky: false
    };
    // if annotation element is not inside a table header, then return false
    if (!annotationElement?.closest('th')) return {
        isSticky: false
    };
    // Remove debug console logs
    return {
        isSticky: isSticky
    };
};
module.exports["useShouldCommentSidebarBeSticky"] = $6a7e747c5d5174c7$export$9be7dcbe458ba189;

});

parcelRegister("7nPJ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jW2Ig = parcelRequire("jW2Ig");

const $b1509838bb0fcfff$export$2cf94d5875603a88 = ({ isEditor: isEditor, elementToObserve: elementToObserve })=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // check if table is already sticky
    const initialStickyState = elementToObserve ? (0, $jW2Ig.getIsSticky)(isEditor && isStickyHeaderExperimentEnabled ? elementToObserve : elementToObserve.parentElement, isEditor) : false;
    const [isSticky, setIsSticky] = (0, $42omo.useState)((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') && initialStickyState);
    // Sticky state effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    // Sticky state effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    return [
        isSticky,
        setIsSticky
    ];
};
module.exports["useIsSticky"] = $b1509838bb0fcfff$export$2cf94d5875603a88;

});

parcelRegister("jW2Ig", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $28177804efc2055d$export$17682ee29db08043 = (tableElement)=>{
    return Boolean(tableElement?.getAttribute('mode') === 'stick');
};
const $28177804efc2055d$export$4676b00e54210cb0 = (tableElement)=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    if (isStickyHeaderExperimentEnabled) return Boolean(tableElement?.classList.contains('pm-table-row-native-sticky-active'));
    return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};
const $28177804efc2055d$export$f3993a99776f75ca = (tableElement, isEditor)=>isEditor ? $28177804efc2055d$export$4676b00e54210cb0(tableElement) : $28177804efc2055d$export$17682ee29db08043(tableElement);
module.exports["isStickyInViewMode"] = $28177804efc2055d$export$17682ee29db08043;
module.exports["isStickyInEditMode"] = $28177804efc2055d$export$4676b00e54210cb0;
module.exports["getIsSticky"] = $28177804efc2055d$export$f3993a99776f75ca;

});

parcelRegister("6HwWx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jW2Ig = parcelRequire("jW2Ig");

const $cf08b287de1b8d82$export$204fd756b18b92ff = ({ setIsSticky: setIsSticky, isEditor: isEditor, elementToObserve: elementToObserve })=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // if the experiment is enabled and this is the editor, we need to observe the table element
    // else, we observe the parent element
    const stickyElementToObserve = isEditor && isStickyHeaderExperimentEnabled ? elementToObserve : elementToObserve?.parentElement;
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        // Create mutation observer to track class changes
        const stickyTableHeaderObserver = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (isEditor && (0, $jW2Ig.isStickyInEditMode)(target) || (0, $jW2Ig.isStickyInViewMode)(target)) setIsSticky(true);
                    else setIsSticky(false);
                }
            });
        });
        // Start observing class changes
        if (stickyElementToObserve) stickyTableHeaderObserver.observe(stickyElementToObserve, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
        // Clean up all observers
        return ()=>{
            stickyTableHeaderObserver.disconnect();
        };
    }, [
        stickyElementToObserve,
        isEditor,
        setIsSticky
    ]);
};
module.exports["useStickyTableHeaderObserver"] = $cf08b287de1b8d82$export$204fd756b18b92ff;

});

parcelRegister("eA7s6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aHcFH = parcelRequire("aHcFH");

const $168172ede45a02b4$export$aca484f2c8185777 = ({ annotationElement: annotationElement, isEditor: isEditor, isViewCommentMode: isViewCommentMode, windowWidth: windowWidth, isSticky: isSticky })=>{
    return (0, $42omo.useMemo)(()=>{
        if (!annotationElement) return 0;
        if (isEditor) return (0, $aHcFH.calculateEditorOffsetFromParent)(annotationElement, '.fabric-editor-popup-scroll-parent');
        return (0, $aHcFH.calculateRendererOffsetFromParent)(annotationElement, `[data-annotation-draft-mark="true"]`, Boolean(isViewCommentMode));
    // We want to re-calculate when the window width changes or the comment sidebar becomes sticky / unsticky
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditor,
        annotationElement,
        isViewCommentMode,
        windowWidth,
        isSticky
    ]);
};
module.exports["useCommentSidebarOffset"] = $168172ede45a02b4$export$aca484f2c8185777;

});

parcelRegister("a3q17", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});
const $60a54f1e533f2ef6$export$fc794218ec0a6fa5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: 'direct-comment-data-flow',
    timings: [
        {
            key: 'commentCreationStart',
            startMark: 'commentCreationStart'
        },
        {
            key: 'commentCreationEnd',
            endMark: 'commentCreationEnd'
        },
        {
            key: 'commentDataLoad',
            startMark: 'commentDataLoadStart',
            endMark: 'commentDataLoadEnd'
        }
    ]
});
module.exports["EDITOR_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$52ff686bd4414bc5;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$ac7f79e65475cee7;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_METRIC"] = $60a54f1e533f2ef6$export$321e1f68b293bf76;
module.exports["DIRECT_COMMENT_DATA_FLOW_METRIC"] = $60a54f1e533f2ef6$export$fc794218ec0a6fa5;

});

parcelRegister("B3Avz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lisKW = parcelRequire("lisKW");


var $T1bCI = parcelRequire("T1bCI");


var $hmuev = parcelRequire("hmuev");


var $ccHMk = parcelRequire("ccHMk");


var $1yB28 = parcelRequire("1yB28");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $cbc8g = parcelRequire("cbc8g");


var $hnvzE = parcelRequire("hnvzE");


var $3gadb = parcelRequire("3gadb");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $eToX6 = parcelRequire("eToX6");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $cMvMc = parcelRequire("cMvMc");


var $5fMeR = parcelRequire("5fMeR");


var $3D12W = parcelRequire("3D12W");


var $jvYFk = parcelRequire("jvYFk");


var $3mVfX = parcelRequire("3mVfX");


var $kRW4Y = parcelRequire("kRW4Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $666Tc = parcelRequire("666Tc");


var $aWwYt = parcelRequire("aWwYt");


var $gnkil = parcelRequire("gnkil");


var $8uM2K = parcelRequire("8uM2K");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $6wiaZ = parcelRequire("6wiaZ");


var $bEwJH = parcelRequire("bEwJH");


var $bXQxx = parcelRequire("bXQxx");

const $2cc0402d98a7d80d$export$b8454eaf88df51d0 = (entry, setIsSticky, setSidebarOffset, sidebarOffset)=>{
    if (entry.intersectionRatio === 0) {
        setIsSticky(false);
        setSidebarOffset(sidebarOffset);
    } else {
        setIsSticky(true);
        setSidebarOffset(// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD));
    }
};
const $2cc0402d98a7d80d$var$redesignedViewAllStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.500',
    // This gives us 4px between the X and the comment icon
    top: 'space.150' // This lines us up exactly with X
});
const $2cc0402d98a7d80d$var$viewAllContainerStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.075',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2cc0402d98a7d80d$var$commentHeaderStyle = (0, $ecnYn.xcss)({
    flexDirection: 'column',
    display: 'flex',
    marginTop: 'space.400'
});
const $2cc0402d98a7d80d$var$commentNewHeaderMargin = (0, $ecnYn.xcss)({
    marginTop: 'space.500'
});
const $2cc0402d98a7d80d$var$shadowElementStyle = {
    height: '4px',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.15) 0%, transparent 100%)',
    width: '100%',
    margin: '0',
    padding: '0'
};
const $2cc0402d98a7d80d$var$commentEditorStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $2cc0402d98a7d80d$var$boxWithMaxHeight = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$var$boxWithoutMaxHeight = (0, $ecnYn.xcss)({
    overflowY: 'visible'
});
const $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto = (0, $ecnYn.xcss)({
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$export$d560bdb1ceec916a = ({ pageId: pageId, onClose: onClose, annotationElement: annotationElement, navigationOptions: navigationOptions, isEditor: isEditor, isViewCommentMode: isViewCommentMode, children: children, sidebarOffset: sidebarOffset, commentId: commentId, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, sidebarEl: sidebarEl, annotationId: annotationId, inlineCommentRef: inlineCommentRef = ()=>{}, nudgeRef: nudgeRef, isSticky: isSticky, isFabricPage: isFabricPage, authorName: authorName, setPopupsScrollableElement: setPopupsScrollableElement, onMaxHeightApplied: onMaxHeightApplied })=>{
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [oldIsSticky, setOldIsSticky] = (0, $42omo.useState)(false);
    const [newSidebarOffset, setSidebarOffset] = (0, $42omo.useState)(sidebarOffset);
    const [showA11yAnnouncement, setShowA11yAnnouncement] = (0, $42omo.useState)(false);
    const [isScrolled, setIsScrolled] = (0, $42omo.useState)(false);
    const [isRefSet, setIsRefSet] = (0, $42omo.useState)(false);
    const { commentSidebarContext: commentSidebarContext } = (0, $cZa7r.useAnnotations)();
    // Compute isMaxHeightEnabledForSticky first to pass to hook
    const isMaxHeightEnabledForSticky = (0, $6mKj3.expValEquals)('confluence_comment_enable_maxheight', 'isEnabled', true) || isSticky && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix');
    // Compute hasMaxHeight locally and notify parent via callback
    const { hasMaxHeight: hasMaxHeight, dynamicMaxHeight: dynamicMaxHeight } = (0, $6wiaZ.useHasMaxHeight)({
        sidebarEl: sidebarEl,
        isRefSet: isRefSet,
        isFabricPage: isFabricPage,
        isSticky: isSticky,
        annotationElement: annotationElement,
        isEditor: isEditor,
        sidebarOffset: sidebarOffset,
        isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky
    });
    const applyMaxHeightStyles = hasMaxHeight && isMaxHeightEnabledForSticky;
    // Notify parent when max height styles change
    (0, $42omo.useEffect)(()=>{
        onMaxHeightApplied?.(!!applyMaxHeightStyles);
    }, [
        applyMaxHeightStyles,
        onMaxHeightApplied
    ]);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const shouldHideViewAllCommentsButtonForNativeEmbedUiUpdates = isEmbeddedConfluence && (0, $6mKj3.expValEquals)('cc-maui-experiment', 'isEnabled', true);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        let offset = 0;
        if (annotationElement && !isEditor) {
            let scrollParent;
            if (isEditor) {
                scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
                offset = (0, $aHcFH.calculateElementOffset)(annotationElement, scrollParent);
            } else {
                /*
        There's two cases here: a view comment and a create comment.
        We need the correct scrollParent for each case.
        Since it's not the editor in this logical branch we should use #content as the scrollParent.
        */ scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
                if (scrollParent) {
                    let annotationOffset = 0;
                    if (isViewCommentMode) // If the sidebar is rendering a view comment, we can use the annotationElement directly.
                    annotationOffset = (0, $aHcFH.calculateElementOffset)(annotationElement);
                    else {
                        /*
            If the sidebar is rendering a create comment the annotationElement is actually the wrapperDOM
            we need to find the actual highlight instead. We can find this by looking for the mark because
            there will always be a mark before the create comment button is clicked.
            */ const actualHiglightElement = scrollParent.querySelector(`[data-annotation-draft-mark="true"]`);
                        annotationOffset = (0, $aHcFH.calculateElementOffset)(actualHiglightElement, undefined, true);
                    }
                    offset = annotationOffset + scrollParent.offsetTop;
                }
            }
            setSidebarOffset(offset);
        }
    }, [
        annotationElement,
        isEditor,
        isViewCommentMode
    ]);
    (0, $42omo.useEffect)(()=>{
        // handles media comment scroll
        if (isRefSet && sidebarEl.current && isEditor) {
            if (isOpeningMediaCommentFromToolbar && annotationElement) (0, $i49vP.scrollToElementInEditor)({
                targetElement: annotationElement,
                viewingRoomOffset: -150
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        annotationElement,
        isOpeningMediaCommentFromToolbar,
        commentId,
        isViewCommentMode,
        isEditor
    ]);
    (0, $42omo.useEffect)(()=>{
        let mouseTrap;
        let focusTrap;
        if (isRefSet && sidebarEl.current) {
            mouseTrap = new (0, (/*@__PURE__*/$parcel$interopDefault($lisKW)))(sidebarEl.current);
            // prevent saving via mod+enter from also publishing the page in edit mode
            mouseTrap.bind((0, $gnkil.INLINE_COMMENTS_SHORTCUT), (event)=>{
                event.stopPropagation();
            });
            if (!showA11yAnnouncement) // We need to show this on a timer so the `aria-live` listener will respond with our message
            setTimeout(()=>{
                setShowA11yAnnouncement(true);
            }, 100);
        }
        return ()=>{
            if (mouseTrap) mouseTrap.reset();
            if (focusTrap) focusTrap.deactivate();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isRefSet || !isViewCommentMode || isEditor || !sidebarEl.current || !(0, $6mKj3.expVal)('cc_comments_a11y_auto_focus_view_page_inline_modal', 'isEnabled', false)) return;
        // capture current val to use for cleanup down the line
        const sidebarNode = sidebarEl.current;
        // Both options are important here - by default focus scroll the browser, which can be jarring on clicks
        // We also prevent focus from shifting a lot when clicking buttons for legacy browser support, which causes unexpected focus:visible styling
        // Better for now to prevent it entirely, than to handle each one-off case
        (0, $aHcFH.focusElementAndUpdateTabIndex)(sidebarNode, {
            focusVisible: false,
            preventScroll: true
        });
        if (!annotationId || !(0, $6mKj3.expVal)('cc_comments_a11y_return_focus_to_vew_annotation', 'isEnabled', false)) return;
        // This must happen on keydown instead of focusout. By the time focusout fires,
        // pointer interactions may already be moving focus to another annotation, and restoring
        // focus from the old sidebar can bounce the user back to the previously open thread.
        // Generally speaking, we also can't trust existing focus logic, so can't rely on focus:visible
        // Handling the boundary Tab / Shift+Tab cases here keeps the restore path keyboard-only.
        const handleKeyDown = (e)=>{
            if (e.key !== 'Tab') return;
            const activeElement = document.activeElement;
            if (!(activeElement instanceof HTMLElement) || !sidebarNode.contains(activeElement)) return;
            const isLeavingBackwards = e.shiftKey && (activeElement === sidebarNode || (0, $aHcFH.isFirstTabbableElement)(sidebarNode, activeElement));
            const isLeavingForwards = !e.shiftKey && (0, $aHcFH.isLastTabbableElement)(sidebarNode, activeElement);
            if (!isLeavingBackwards && !isLeavingForwards) return;
            const annotationEl = (0, $aHcFH.getFocusableElementFromMarkerRef)(annotationId);
            if (!annotationEl) return;
            e.preventDefault();
            // Use the default browser focus when leaving the modal, since we don't need
            // to update tabIndex here.
            annotationEl.focus();
        };
        sidebarNode.addEventListener('keydown', handleKeyDown, true);
        return ()=>{
            sidebarNode.removeEventListener('keydown', handleKeyDown, true);
        };
    // No need to have sidebarEL in here - handled by isRefSet
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        isViewCommentMode,
        isEditor,
        annotationId
    ]);
    const handlePropagation = (event)=>{
        /**
     * prevents an event bubbling up to removing focus
     * from the highlight displaying the sidebar
     */ event.stopPropagation();
    };
    const handleOpeningCommentsPanel = (0, $42omo.useCallback)(()=>{
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        if (annotationId) {
            setCurrentlySelectedThreadKey(annotationId);
            (0, $9FoVw.handleCommentsPanelNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentId: commentId,
                commentType: 'INLINE',
                annotationClicked: true
            });
        }
    }, [
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        annotationId,
        commentId
    ]);
    const handleOnClose = (0, $42omo.useCallback)((dialogs, isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(hasContentChanged);
    }, [
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const updatedHandleOnClose = (0, $42omo.useCallback)((isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose?.(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose?.(hasContentChanged);
    }, [
        showModal,
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const handleViewAllClick = (0, $42omo.useCallback)((dialogs)=>{
        handleOnClose(dialogs, true);
    }, [
        handleOnClose
    ]);
    const updatedHandleViewAllClick = (0, $42omo.useCallback)(()=>{
        updatedHandleOnClose(true);
    }, [
        updatedHandleOnClose
    ]);
    const handleScroll = (0, $42omo.useCallback)((event)=>{
        const target = event.currentTarget;
        // Check if the inline-comment-sidebar-wrapper is scrolled
        const scrolled = target.scrollTop > 0;
        setIsScrolled(scrolled);
    }, []);
    const sidebarId = (0, $aHcFH.getSidebarId)(isEditor, isViewCommentMode);
    const mode = isEditor ? 'edit' : 'view';
    const intl = (0, $aXWIB.useIntl)();
    const closeCommentBox = intl.formatMessage((0, $bEwJH.i18n).closeCommentBox);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const sidebarBoundingRect = sidebarEl.current?.getBoundingClientRect();
    const isSidebarExtendedBeyondViewport = (sidebarBoundingRect?.bottom ?? 0) > window.innerHeight;
    /**
   * useEffect to handle sticky comment behavior when attached to a sticky table header.
   * As the user scrolls, the IntersectionObserver triggers the callback the moment the table header starts/stops being sticky
   */ (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
            const stickyHeader = annotationElement?.closest('.pm-table-sticky-wrapper');
            if (stickyHeader && !isSidebarExtendedBeyondViewport) {
                // eslint-disable-next-line no-restricted-syntax
                const observer = new IntersectionObserver(([entry])=>$2cc0402d98a7d80d$export$b8454eaf88df51d0(entry, setOldIsSticky, setSidebarOffset, sidebarOffset), {
                    threshold: 1.0
                });
                observer.observe(stickyHeader);
                return ()=>observer.disconnect();
            }
        }
    }, [
        annotationElement,
        sidebarOffset,
        sidebarEl,
        isSidebarExtendedBeyondViewport
    ]);
    const commentSidebarIsSticky = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? isSticky : oldIsSticky;
    const commentResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_comment_enable_preview_panel_support') ? (0, $eToX6.isInPreviewPanel)() : false;
    const viewAllResidesInPreviewPanel = (0, $eToX6.isInPreviewPanel)();
    /**
   * Below logic to set rightOffset is temporary fix.
   * It is very fragile as there are many conditions in ObjectSidebarControl
   * 	component to show/hide action bar and rovo button.
   * Also values are hardcoded.
   */ const getRightOffset = (0, $42omo.useCallback)(()=>{
        let rightOffset = 0;
        const panelRenderedOutsideMain = (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && (0, $9wGTI.fg)('ads-panel-system-confluence-object-sidebar');
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) // An improved version of getRightOffset()
        {
            if (!commentResidesInPreviewPanel) {
                const baseRightOffset = 112;
                // rendererContent has an extra 40px padding on the right,
                // which we need to add in 'edit' mode to match 'view' mode.
                const extraPadding = 40;
                if (mode === 'edit') rightOffset = extraPadding + (isObjectSidebarShown ? 0 : baseRightOffset);
                else {
                    // `mode === 'view'`
                    if (isObjectSidebarShown) {
                        if (panelRenderedOutsideMain) // Navigation-system Panel already shrinks Main, so only fixed-position
                        // (sticky) inline comments need a viewport-relative offset.
                        rightOffset = commentSidebarIsSticky ? (0, $aWwYt.MIN_PANEL_WIDTH) + extraPadding : 0;
                        else // When `commentSidebarIsSticky === true`, sidebar uses style { position: 'fixed' },
                        // so we need to add extraPadding here to match the `commentSidebarIsSticky === false` case.
                        rightOffset = (0, $aWwYt.MIN_PANEL_WIDTH) + (commentSidebarIsSticky ? extraPadding : 0);
                    } else // `isObjectSidebarShown === false`
                    if (!commentSidebarIsSticky) rightOffset = baseRightOffset;
                    else {
                        // `commentSidebarIsSticky === true`, sidebar uses style { position: 'fixed' }
                        // We set rightOffset to be baseRightOffset + the distance between
                        // the right edge of 'main-content' and the right edge of window
                        // (which includes the 40px padding + any extra e.g. the Rovo panel).
                        // The resulting horizontal position of sidebar should match the
                        // `commentSidebarIsSticky === false` case.
                        const rendererContent = document.getElementById('main-content');
                        const rendererContentRight = rendererContent?.getBoundingClientRect()?.right ?? 0;
                        if (rendererContentRight) {
                            const rendererContentDistanceFromWindowRight = window.innerWidth - rendererContentRight;
                            rightOffset = baseRightOffset + rendererContentDistanceFromWindowRight;
                        } else // rendererContentRight === 0, which shouldn't occur, but
                        // we fall back to a hardcoded rightOffset
                        rightOffset = baseRightOffset;
                    }
                }
            } // if `commentResidesInPreviewPanel === true`, rightOffset will be 0
        } else {
            // The old version of getRightOffset()
            if (mode === 'view' && isObjectSidebarShown) /**
         * Need rightOffset only when container size doesn't change when
         * 	action bar panel (e.g details panel, comments panel).
         * That happens currently only in view page.
         */ rightOffset = panelRenderedOutsideMain ? 0 : (0, $aWwYt.MIN_PANEL_WIDTH);
            else if (/**
       * When action bar or rovo button is shown, need to set rightOffset,
       * 	otherwise long comment sidebar overlaps on it.
       */ !isObjectSidebarShown && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled)) /**
         * Width of action bar is 48px,
         * 	got it from object-sidebar-components/src/ObjectSidebarControl.tsx.
         * This is not ideal solution, as it is hardcoded.
         * check if previewPanel support is enabled
         */ {
                if (!commentResidesInPreviewPanel) {
                    if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
                        rightOffset = 100; // add more offset from the right edge of the page so it doesn't overlap with the object sidebar
                        if (mode === 'view') rightOffset += commentSidebarIsSticky ? 67 : 12;
                        else rightOffset += commentSidebarIsSticky ? 27 : 12;
                    } else rightOffset = 48 + (commentSidebarIsSticky ? 52 : 12);
                }
            }
        }
        return rightOffset;
    }, [
        mode,
        isObjectSidebarShown,
        commentSidebarIsSticky,
        commentResidesInPreviewPanel,
        isRovoButtonEnabled,
        panel
    ]);
    const a11yProps = (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
        role: 'dialog',
        'aria-modal': false,
        'aria-label': intl.formatMessage((0, $bEwJH.i18n).commentSidebarLabel, {
            name: authorName || ''
        })
    } : {};
    const pickedStickyCommentVerticalOffsetView = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD);
    const sidebarContainerOffset = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? commentSidebarIsSticky ? isEditor ? sidebarOffset : pickedStickyCommentVerticalOffsetView : sidebarOffset : newSidebarOffset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: pageId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "comment-sidebar"
        }, commentSidebarContext === 'create' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
            data: {
                commentSidebarContext: 'create'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.SidebarContainer), {
            offset: sidebarContainerOffset,
            rightOffset: getRightOffset(),
            isSticky: commentSidebarIsSticky,
            onClick: handlePropagation,
            id: sidebarId,
            "data-testid": sidebarId,
            "data-cy": sidebarId,
            mode: mode,
            ref: (el)=>{
                sidebarEl.current = el;
                if (nudgeRef) nudgeRef.current = el;
                setIsRefSet(true);
                inlineCommentRef(el);
            },
            ...a11yProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.TopContainer), {
            showNavigation: Boolean(navigationOptions)
        }, annotationId && !shouldHideViewAllCommentsButtonForNativeEmbedUiUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $2cc0402d98a7d80d$var$viewAllContainerStyles,
            testId: "view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? ()=>updatedHandleViewAllClick() : ()=>handleViewAllClick(dialogs),
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    ...iconProps,
                    label: "Comment Icon",
                    color: "var(--ds-icon-subtle)"
                }),
            appearance: "subtle",
            spacing: "compact",
            testId: "comment-sidebar-viewall-button",
            interactionName: "view-comments-menu-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtle"
        }, intl.formatMessage((0, $bEwJH.i18n).viewAllCommentsButtonText)))), navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            isUpdatedStandaloneComment: false,
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? ()=>updatedHandleOnClose() : ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: closeCommentBox,
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            })
        })))), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $2cc0402d98a7d80d$var$commentHeaderStyle,
                $2cc0402d98a7d80d$var$commentNewHeaderMargin,
                !isViewCommentMode && $2cc0402d98a7d80d$var$commentEditorStyle
            ]
        }, navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick
        }), annotationId && !viewAllResidesInPreviewPanel && !shouldHideViewAllCommentsButtonForNativeEmbedUiUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            testId: "redesigned-view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2cc0402d98a7d80d$var$redesignedViewAllStyle,
            onClick: // In order to get rid of the a11y suppression 👆,
            // we need to move this onClick handler from this Box to CommentIconWithUnread's IconButton.
            (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? undefined : (e)=>{
                e.stopPropagation();
                handleViewAllClick(dialogs);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3D12W.CommentPanelButton), {
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? updatedHandleViewAllClick : undefined,
            contentId: pageId,
            testId: "standalone-comment-view-all-button",
            isStandaloneComment: true,
            isViewAllIcon: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? ()=>updatedHandleOnClose() : ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: intl.formatMessage((0, $bEwJH.i18n).closeInlineCommentThread),
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            }),
            isUpdatedStandaloneComment: true
        })))), isScrolled && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: $2cc0402d98a7d80d$var$shadowElementStyle
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "inline-comment-sidebar-wrapper",
            ref: (el)=>{
                if (applyMaxHeightStyles) setPopupsScrollableElement?.(el);
            },
            xcss: [
                applyMaxHeightStyles && !dynamicMaxHeight && $2cc0402d98a7d80d$var$boxWithMaxHeight,
                applyMaxHeightStyles && !!dynamicMaxHeight && $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto,
                !applyMaxHeightStyles && $2cc0402d98a7d80d$var$boxWithoutMaxHeight
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: // xcss only supports static styles
            applyMaxHeightStyles && !!dynamicMaxHeight ? {
                maxHeight: dynamicMaxHeight
            } : undefined,
            onScroll: handleScroll
        }, children))))));
};
module.exports["CommentSidebar"] = $2cc0402d98a7d80d$export$d560bdb1ceec916a;

});

parcelRegister("3D12W", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $1yB28 = parcelRequire("1yB28");


var $jypE9 = parcelRequire("jypE9");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $cMvMc = parcelRequire("cMvMc");


var $ep3mz = parcelRequire("ep3mz");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $iBnoc = parcelRequire("iBnoc");


var $fHAwL = parcelRequire("fHAwL");


var $cZa7r = parcelRequire("cZa7r");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $1ggpj = parcelRequire("1ggpj");


var $8uM2K = parcelRequire("8uM2K");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $404f4d0022b5692a$var$commentIconContainerStyle = null;
const $404f4d0022b5692a$var$i18n = (0, $aXWIB.defineMessages)({
    openCommentsPanelLabel: {
        id: "object-sidebar-components.open.comments.panel.label",
        defaultMessage: "Open Comments Panel"
    },
    viewAllCommentsLabel: {
        id: "object-sidebar-components.view.all.comments",
        defaultMessage: "View all comments"
    },
    showCommentsLabel: {
        id: "object-sidebar-components.show.comments.label",
        defaultMessage: "Show comments"
    }
});
const $404f4d0022b5692a$export$f5ef73dad1bb3f02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(70);
    const { onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: t1, isDisabled: t2, isViewAllIcon: t3 } = t0;
    const isStandaloneComment = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const isViewAllIcon = t3 === undefined ? false : t3;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    let t4;
    if ($[0] !== pageMode) {
        t4 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
        $[0] = pageMode;
        $[1] = t4;
    } else t4 = $[1];
    const eventEmitter = t4;
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [t5] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t5;
    const dataTestId = testId || "object-sidebar-comments-button-id";
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const t6 = pageMode === "edit" || isLiveEditMode;
    let t7;
    if ($[2] !== t6) {
        t7 = {
            shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            isEditorShortcut: t6
        };
        $[2] = t6;
        $[3] = t7;
    } else t7 = $[3];
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t7);
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    let t8;
    if ($[4] !== pageMode) {
        t8 = ()=>{
            (0, $5fMeR.preloadCommentsPanel)(pageMode);
        };
        $[4] = pageMode;
        $[5] = t8;
    } else t8 = $[5];
    const handleMouseEnter = t8;
    let t9;
    if ($[6] !== activeHighlight || $[7] !== closeCommentContainer || $[8] !== editorCreateProps || $[9] !== editorViewProps || $[10] !== eventEmitter || $[11] !== expanded || $[12] !== hideObjectSidebar || $[13] !== hoverProps || $[14] !== newCommentHighlight || $[15] !== panel?.id || $[16] !== selectionOptions || $[17] !== selectionProps || $[18] !== setEditorCreateProps || $[19] !== setEditorViewProps || $[20] !== setHoverProps || $[21] !== setSelectionOptions || $[22] !== setSelectionProps || $[23] !== setShowCreateComponent || $[24] !== setViewProps || $[25] !== showCommentsPanel || $[26] !== showCreateComponent || $[27] !== viewProps) {
        t9 = ()=>{
            if (viewProps) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            }
            if (showCreateComponent && selectionOptions) {
                setShowCreateComponent(false);
                setSelectionOptions(undefined);
            }
            if (editorViewProps) {
                eventEmitter.emit("setselectedannotation", "");
                setEditorViewProps(null);
            }
            if (selectionProps) {
                selectionProps.onClose();
                setSelectionProps(null);
            }
            if (hoverProps) {
                hoverProps.onClose();
                setHoverProps(null);
            }
            if (editorCreateProps) {
                editorCreateProps?.onClose && editorCreateProps.onClose();
                setEditorCreateProps(null);
            }
            if (newCommentHighlight || activeHighlight) window.dispatchEvent(new Event("closeLegacyInlineCommentSidebar"));
            if (expanded && !(0, $9wGTI.fg)("confluence_comment_panel_close_footer")) closeCommentContainer();
            if (panel?.id === "commentsPanel") hideObjectSidebar();
            else showCommentsPanel();
        };
        $[6] = activeHighlight;
        $[7] = closeCommentContainer;
        $[8] = editorCreateProps;
        $[9] = editorViewProps;
        $[10] = eventEmitter;
        $[11] = expanded;
        $[12] = hideObjectSidebar;
        $[13] = hoverProps;
        $[14] = newCommentHighlight;
        $[15] = panel?.id;
        $[16] = selectionOptions;
        $[17] = selectionProps;
        $[18] = setEditorCreateProps;
        $[19] = setEditorViewProps;
        $[20] = setHoverProps;
        $[21] = setSelectionOptions;
        $[22] = setSelectionProps;
        $[23] = setShowCreateComponent;
        $[24] = setViewProps;
        $[25] = showCommentsPanel;
        $[26] = showCreateComponent;
        $[27] = viewProps;
        $[28] = t9;
    } else t9 = $[28];
    const handleCommentClick = t9;
    let t10;
    if ($[29] !== contentTypeFromState || $[30] !== createAnalyticsEvent || $[31] !== handleCommentClick || $[32] !== hasContentChanged || $[33] !== onClick || $[34] !== pageMode || $[35] !== resetContentChanged || $[36] !== resetInitialDataLoadedMap || $[37] !== showModal) {
        t10 = (t11)=>{
            const { triggeredByKeyboardShortcut: t12, isViewAllIcon: t13 } = t11 === undefined ? {} : t11;
            const triggeredByKeyboardShortcut = t12 === undefined ? false : t12;
            const isViewAllIcon_0 = t13 === undefined ? false : t13;
            return ()=>{
                if (isViewAllIcon_0) {
                    onClick?.();
                    return;
                }
                if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        resetContentChanged();
                        handleCommentClick();
                        if ((0, $9wGTI.fg)("confluence_comments_reset_data_on_comment_discard")) resetInitialDataLoadedMap();
                    }
                });
                else handleCommentClick();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "commentsPanel",
                        source: "contentWrapper",
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            contentType: contentTypeFromState,
                            pageMode: pageMode
                        }
                    }
                }).fire();
            };
        };
        $[29] = contentTypeFromState;
        $[30] = createAnalyticsEvent;
        $[31] = handleCommentClick;
        $[32] = hasContentChanged;
        $[33] = onClick;
        $[34] = pageMode;
        $[35] = resetContentChanged;
        $[36] = resetInitialDataLoadedMap;
        $[37] = showModal;
        $[38] = t10;
    } else t10 = $[38];
    const checkUnsavedOnClickCommentsButton = t10;
    let t11;
    if ($[39] !== checkUnsavedOnClickCommentsButton || $[40] !== isLiveViewMode || $[41] !== pageMode) {
        t11 = (pageMode === "view" || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[39] = checkUnsavedOnClickCommentsButton;
        $[40] = isLiveViewMode;
        $[41] = pageMode;
        $[42] = t11;
    } else t11 = $[42];
    let t12;
    if ($[43] !== checkUnsavedOnClickCommentsButton || $[44] !== isLiveEditMode || $[45] !== pageMode) {
        t12 = (pageMode === "edit" || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[43] = checkUnsavedOnClickCommentsButton;
        $[44] = isLiveEditMode;
        $[45] = pageMode;
        $[46] = t12;
    } else t12 = $[46];
    let t13;
    if ($[47] !== t11 || $[48] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t11, t12);
        $[47] = t11;
        $[48] = t12;
        $[49] = t13;
    } else t13 = $[49];
    const shortcutListeners = t13;
    if (collapsed) return shortcutListeners;
    let t14;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $gMc0m.default)([
            "_kqswh2mm"
        ]);
        $[50] = t14;
    } else t14 = $[50];
    let t15;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $404f4d0022b5692a$var$i18n.showCommentsLabel);
        $[51] = t15;
    } else t15 = $[51];
    const t16 = isShortcutTextShown ? commentShortcutStrings : undefined;
    let t17;
    if ($[52] !== allowComments || $[53] !== checkUnsavedOnClickCommentsButton || $[54] !== formatMessage || $[55] !== handleMouseEnter || $[56] !== isDisabled || $[57] !== isRovoButtonEnabled || $[58] !== isStandaloneComment || $[59] !== isViewAllIcon || $[60] !== unreadCommentIDSet?.size) {
        t17 = allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: checkUnsavedOnClickCommentsButton({
                isViewAllIcon: isViewAllIcon
            }),
            onMouseEnter: (0, $6mKj3.expValEquals)("confluence_comments_preload_comments_panel", "isEnabled", true) ? handleMouseEnter : undefined,
            appearance: "subtle",
            spacing: isStandaloneComment ? "compact" : undefined,
            shape: isRovoButtonEnabled ? "default" : "circle",
            icon: isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_panel_icon_update", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            label: formatMessage($404f4d0022b5692a$var$i18n.openCommentsPanelLabel),
            testId: "sidebar-comments-button",
            interactionName: "view-comments-menu-action",
            ...(0, $6mKj3.expVal)("confluence_frontend_comments_a11y_kb_exp", "isEnabled", false) ? {
                ariaLabel: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel)
            } : {},
            isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
        }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null));
        $[52] = allowComments;
        $[53] = checkUnsavedOnClickCommentsButton;
        $[54] = formatMessage;
        $[55] = handleMouseEnter;
        $[56] = isDisabled;
        $[57] = isRovoButtonEnabled;
        $[58] = isStandaloneComment;
        $[59] = isViewAllIcon;
        $[60] = unreadCommentIDSet?.size;
        $[61] = t17;
    } else t17 = $[61];
    const t18 = !isStandaloneComment && shortcutListeners;
    let t19;
    if ($[62] !== t16 || $[63] !== t17 || $[64] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: t15,
            shortcut: t16,
            delay: 0,
            hideTooltipOnClick: true
        }, t17, t18);
        $[62] = t16;
        $[63] = t17;
        $[64] = t18;
        $[65] = t19;
    } else t19 = $[65];
    let t20;
    if ($[66] !== dataTestId || $[67] !== t14 || $[68] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": dataTestId,
            "data-vc": "object-sidebar-comments-button",
            className: t14
        }, t19);
        $[66] = dataTestId;
        $[67] = t14;
        $[68] = t19;
        $[69] = t20;
    } else t20 = $[69];
    return t20;
} : ({ onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: isStandaloneComment = false, isDisabled: isDisabled = false, isViewAllIcon: isViewAllIcon = false })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const dataTestId = testId || 'object-sidebar-comments-button-id';
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' || isLiveEditMode
    });
    // keyboard events do not bubble up to confluence when focus is in the db iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE; // Preload components on hover to improve FMP performance
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        (0, $5fMeR.preloadCommentsPanel)(pageMode);
    }, [
        pageMode
    ]);
    const handleCommentClick = (0, $42omo.useCallback)(()=>{
        // FABRIC PAGES
        // Close the view component if it's open
        if (viewProps) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
            setViewProps(null);
        }
        if (showCreateComponent && selectionOptions) {
            // Inform CreateComment to reset the state
            setShowCreateComponent(false);
            setSelectionOptions(undefined);
        }
        if (editorViewProps) {
            // Inform the editor to de-select the annotation
            eventEmitter.emit('setselectedannotation', ''); // Remove the display of the comment
            setEditorViewProps(null);
        }
        if (selectionProps) {
            selectionProps.onClose();
            setSelectionProps(null);
        }
        if (hoverProps) {
            hoverProps.onClose();
            setHoverProps(null);
        }
        if (editorCreateProps) {
            editorCreateProps?.onClose && editorCreateProps.onClose();
            setEditorCreateProps(null);
        } // LEGACY PAGES
        if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
        window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
         // Should unmount the expanded comment editor
        // standalone reply, object footer comment
        if (expanded && !(0, $9wGTI.fg)('confluence_comment_panel_close_footer')) closeCommentContainer();
        if (panel?.id === 'commentsPanel') hideObjectSidebar();
        else showCommentsPanel();
    }, [
        eventEmitter,
        viewProps,
        editorViewProps,
        selectionProps,
        hoverProps,
        newCommentHighlight,
        activeHighlight,
        setViewProps,
        setEditorViewProps,
        setSelectionProps,
        setHoverProps,
        showCommentsPanel,
        hideObjectSidebar,
        panel,
        editorCreateProps,
        closeCommentContainer,
        expanded,
        setEditorCreateProps,
        showCreateComponent,
        selectionOptions,
        setShowCreateComponent,
        setSelectionOptions
    ]);
    const checkUnsavedOnClickCommentsButton = (0, $42omo.useCallback)(({ triggeredByKeyboardShortcut: triggeredByKeyboardShortcut = false, isViewAllIcon: isViewAllIcon_0 = false } = {})=>()=>{
            // Early return for ViewAll icon - no action needed
            if (isViewAllIcon_0) {
                onClick?.();
                return;
            }
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    handleCommentClick();
                    if ((0, $9wGTI.fg)('confluence_comments_reset_data_on_comment_discard')) resetInitialDataLoadedMap();
                }
            });
            else handleCommentClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'commentsPanel',
                    source: 'contentWrapper',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        contentType: contentTypeFromState,
                        pageMode: pageMode
                    }
                }
            }).fire();
        }, [
        onClick,
        hasContentChanged,
        handleCommentClick,
        resetContentChanged,
        resetInitialDataLoadedMap,
        showModal,
        createAnalyticsEvent,
        contentTypeFromState,
        pageMode
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }), (pageMode === 'edit' || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }));
    if (collapsed) return shortcutListeners;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        "data-vc": "object-sidebar-comments-button",
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $404f4d0022b5692a$var$i18n.showCommentsLabel),
        shortcut: isShortcutTextShown ? commentShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        onMouseEnter: (0, $6mKj3.expValEquals)('confluence_comments_preload_comments_panel', 'isEnabled', true) ? handleMouseEnter : undefined,
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: formatMessage($404f4d0022b5692a$var$i18n.openCommentsPanelLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            ariaLabel: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel)
        } : {},
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null)), !isStandaloneComment && shortcutListeners));
};
module.exports["CommentPanelButton"] = $404f4d0022b5692a$export$f5ef73dad1bb3f02;

});

parcelRegister("iBnoc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0360a9befc1d1e18$export$d101cbe06551091d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1wNs0",
    name: "UnreadIndicator",
    loader: async ()=>(await (parcelRequire("9bA4s"))).UnreadIndicator
});
module.exports["UnreadIndicator"] = $0360a9befc1d1e18$export$d101cbe06551091d;

});

parcelRegister("9bA4s", function(module, exports) {

let $6b011f0f99d5e581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b011f0f99d5e581$var$load("i8hiG").then(()=>parcelRequire('yTrVP'));

});

parcelRegister("6wiaZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $781ef84c6c89584f$export$d1fb14f3b5498c7a = ({ sidebarEl: sidebarEl, isRefSet: isRefSet, isSticky: isSticky, isFabricPage: isFabricPage, annotationElement: annotationElement, isEditor: isEditor, sidebarOffset: sidebarOffset, isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky })=>{
    const [hasMaxHeight, setHasMaxHeight] = (0, $42omo.useState)(false);
    const [dynamicMaxHeight, setDynamicMaxHeight] = (0, $42omo.useState)(undefined);
    // Shared max height check logic
    const checkMaxHeight = (0, $42omo.useCallback)(()=>{
        // Check if annotation is in a sticky table header & on edit mode
        if (annotationElement && isEditor && isMaxHeightEnabledForSticky) {
            const stickyTable = annotationElement.closest('table.pm-table-sticky');
            const inStickyTableHeader = Boolean(stickyTable);
            // Special case: annotation in sticky table header - calculate max height based on where sidebar will be positioned
            // Without this check, long comment threads can sometimes have their bottom permanently below the viewport on small-width pages
            if (inStickyTableHeader && isSticky) {
                const annotationRect = annotationElement.getBoundingClientRect();
                const annotationBottom = annotationRect.bottom;
                // Use the sidebar offset that will be applied (STICKY_COMMENT_VERTICAL_OFFSET_VIEW for view, or sidebarOffset for editor)
                const offset = sidebarOffset ?? 0;
                const sidebarTop = annotationBottom + offset;
                const viewportHeight = window.innerHeight;
                // Calculate max height as distance from where sidebar top will be to bottom of viewport
                const calculatedMaxHeight = viewportHeight - sidebarTop;
                // Only apply if the calculated max height is positive and would actually constrain the sidebar
                // Otherwise, continue to default behavior
                if (calculatedMaxHeight > 0) {
                    setDynamicMaxHeight(`${calculatedMaxHeight}px`);
                    setHasMaxHeight(true);
                    return;
                }
            }
        }
        // Default (i.e. non-special-cate) behavior
        if (!sidebarEl.current) return;
        if (isSticky) {
            setHasMaxHeight(true);
            setDynamicMaxHeight(undefined);
            return;
        }
        const rect = sidebarEl.current.getBoundingClientRect();
        const availableHeight = window.innerHeight - 300;
        setHasMaxHeight(rect.height > availableHeight);
        setDynamicMaxHeight(undefined);
    }, [
        isSticky,
        sidebarEl,
        annotationElement,
        isEditor,
        sidebarOffset,
        isMaxHeightEnabledForSticky
    ]);
    // Max height effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    // Max height effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    return {
        hasMaxHeight: hasMaxHeight,
        dynamicMaxHeight: dynamicMaxHeight
    };
};
module.exports["useHasMaxHeight"] = $781ef84c6c89584f$export$d1fb14f3b5498c7a;

});

parcelRegister("bEwJH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $6015f360c209854c$export$fafb84dd8a714e7a = 5;
const $6015f360c209854c$export$675e64cf259adeff = 125;
const $6015f360c209854c$export$6882b33952f7e4d2 = 122;
const $6015f360c209854c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    closeCommentBox: {
        id: "annotation-provider-inline-comments.closeCommentBox",
        defaultMessage: "Close inline comments"
    },
    closeInlineCommentThread: {
        id: "annotation-provider-inline-comments.close.InlineCommentThread",
        defaultMessage: "Close inline comment thread"
    },
    closeSidebarTooltip: {
        id: "annotation-provider-inline-comments.close.icon.tooltip",
        defaultMessage: "Close comment"
    },
    viewAllCommentsButtonText: {
        id: "annotation-provider-inline-comments.view-all.button.text",
        defaultMessage: "View all"
    },
    commentSidebarLabel: {
        id: "annotation-provider-inline-comments.comment.sidebar.label",
        defaultMessage: "Inline comment by {name}"
    },
    commentSidebarAnnouncement: {
        id: "annotation-provider-inline-comments.comment.sidebar.announcement",
        defaultMessage: "Comment sidebar shown, use Shift + Tab to reach the comment sidebar"
    }
});
module.exports["MAX_UNCOLLAPSED_REPIES"] = $6015f360c209854c$export$fafb84dd8a714e7a;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD"] = $6015f360c209854c$export$675e64cf259adeff;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW"] = $6015f360c209854c$export$6882b33952f7e4d2;
module.exports["i18n"] = $6015f360c209854c$export$a7357cdd1f0b0168;

});

parcelRegister("bXQxx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $7N1sB = parcelRequire("7N1sB");


var $9wGTI = parcelRequire("9wGTI");


var $cZa7r = parcelRequire("cZa7r");


var $3BCCf = parcelRequire("3BCCf");

const $d6eff27ff915f22d$var$positionRightStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    right: 'space.800'
});
const $d6eff27ff915f22d$var$positionLeftStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.150'
});
const $d6eff27ff915f22d$export$c7f093fedf3e73fe = ({ pageId: pageId, commentData: commentData, isEditor: isEditor, onNavigationClick: onNavigationClick })=>{
    const { clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { goToNextInlineComment: originalGoToNext, goToPrevInlineComment: originalGoToPrev } = (0, $3BCCf.useInlineCommentNavigation)({
        isEditor: isEditor,
        pageId: pageId,
        onNavigationClick: onNavigationClick,
        commentData: commentData
    });
    // Wrap navigation functions to clear stored comment data before navigation
    const goToNextInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToNext();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToNext
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToPrev();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToPrev
    ]);
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: [
                !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $d6eff27ff915f22d$var$positionRightStyles,
                (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $d6eff27ff915f22d$var$positionLeftStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment
        })), [
        goToNextInlineComment,
        goToPrevInlineComment
    ]);
};
module.exports["CommentNavigation"] = $d6eff27ff915f22d$export$c7f093fedf3e73fe;

});

parcelRegister("7N1sB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $3gadb = parcelRequire("3gadb");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $9wGTI = parcelRequire("9wGTI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $9QIM2 = parcelRequire("9QIM2");


var $e4o8D = parcelRequire("e4o8D");


var $666Tc = parcelRequire("666Tc");

const $c0db869228662b46$var$i18n = (0, $aXWIB.defineMessages)({
    nextCommentLabel: {
        id: "inline-comments-common.next-comment-label",
        defaultMessage: "Next comment"
    },
    previousCommentLabel: {
        id: "inline-comments-common.previous-comment-label",
        defaultMessage: "Previous comment"
    }
});
const $c0db869228662b46$export$c7f093fedf3e73fe = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t2 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT);
    let t3;
    if ($[0] !== t2) {
        t3 = {
            shortcut: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t3);
    const t4 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT);
    let t5;
    if ($[2] !== t4) {
        t5 = {
            shortcut: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t5);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const noop = $c0db869228662b46$var$_temp;
    const isPageOrDoc = pageClass === "renderer" || pageClass === "editor";
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c0db869228662b46$var$i18n.previousCommentLabel);
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== formatMessage) {
        t8 = formatMessage($c0db869228662b46$var$i18n.previousCommentLabel);
        $[6] = formatMessage;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: t8,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== experienceTracker || $[11] !== goToPrevInlineComment || $[12] !== isPageOrDoc || $[13] !== isSSRFocusedComment || $[14] !== pageClass) {
        t10 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to previous comment via button.");
            return goToPrevInlineComment();
        } : noop;
        $[10] = experienceTracker;
        $[11] = goToPrevInlineComment;
        $[12] = isPageOrDoc;
        $[13] = isSSRFocusedComment;
        $[14] = pageClass;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== isSSRFocusedComment || $[17] !== t10 || $[18] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-previous",
            testId: "comment-navigation-prev",
            iconBefore: t9,
            onClick: t10
        });
        $[16] = isSSRFocusedComment;
        $[17] = t10;
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== prevCommentShortcutStrings || $[21] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t7,
            shortcut: prevCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t11);
        $[20] = prevCommentShortcutStrings;
        $[21] = t11;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c0db869228662b46$var$i18n.nextCommentLabel);
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== formatMessage) {
        t14 = formatMessage($c0db869228662b46$var$i18n.nextCommentLabel);
        $[24] = formatMessage;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: t14,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[26] = t14;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== experienceTracker || $[29] !== goToNextInlineComment || $[30] !== isPageOrDoc || $[31] !== isSSRFocusedComment || $[32] !== pageClass) {
        t16 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to next comment via button.");
            return goToNextInlineComment();
        } : noop;
        $[28] = experienceTracker;
        $[29] = goToNextInlineComment;
        $[30] = isPageOrDoc;
        $[31] = isSSRFocusedComment;
        $[32] = pageClass;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== isSSRFocusedComment || $[35] !== t15 || $[36] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-next",
            testId: "comment-navigation-next",
            iconBefore: t15,
            onClick: t16
        });
        $[34] = isSSRFocusedComment;
        $[35] = t15;
        $[36] = t16;
        $[37] = t17;
    } else t17 = $[37];
    let t18;
    if ($[38] !== nextCommentShortcutStrings || $[39] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t13,
            shortcut: nextCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t17);
        $[38] = nextCommentShortcutStrings;
        $[39] = t17;
        $[40] = t18;
    } else t18 = $[40];
    let t19;
    if ($[41] !== renderServerPlaceholder) {
        t19 = renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: "inline-comment-index"
        }) : null;
        $[41] = renderServerPlaceholder;
        $[42] = t19;
    } else t19 = $[42];
    let t20;
    if ($[43] !== t12 || $[44] !== t18 || $[45] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NavigationContainer), {
            "data-testid": "comment-navigation-container",
            shouldHaveButtonGap: t6
        }, t12, t18, t19);
        $[43] = t12;
        $[44] = t18;
        $[45] = t19;
        $[46] = t20;
    } else t20 = $[46];
    return t20;
};
function $c0db869228662b46$var$_temp() {}
module.exports["CommentNavigation"] = $c0db869228662b46$export$c7f093fedf3e73fe;

});

parcelRegister("3BCCf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9jl6v = parcelRequire("9jl6v");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");

const $33dbfc40da2aecd4$export$248861b924bd617d = ({ pageId: pageId, isEditor: isEditor, onNavigationClick: onNavigationClick, commentData: commentData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    const getCommentIndex = (0, $42omo.useCallback)((currentMarkerRef)=>{
        return orderedActiveAnnotations?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations
    ]);
    const currentInlineMarkerRef = commentData?.location?.inlineMarkerRef ?? '';
    const currentCommentIndex = getCommentIndex(currentInlineMarkerRef);
    const goToNextInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'next',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'previous',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    return (0, $42omo.useMemo)(()=>({
            currentCommentIndex: currentCommentIndex,
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment,
            commentsCount: orderedActiveAnnotations.length
        }), [
        goToNextInlineComment,
        goToPrevInlineComment,
        orderedActiveAnnotations.length,
        currentCommentIndex
    ]);
};
module.exports["useInlineCommentNavigation"] = $33dbfc40da2aecd4$export$248861b924bd617d;

});

parcelRegister("3omFm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gfqXk = parcelRequire("gfqXk");


var $3jwuS = parcelRequire("3jwuS");


var $cZa7r = parcelRequire("cZa7r");


var $9wGTI = parcelRequire("9wGTI");


var $9FoVw = parcelRequire("9FoVw");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $b0EGa = parcelRequire("b0EGa");


var $2UZkz = parcelRequire("2UZkz");

const $554aaf1aa11e07ba$export$aa84ce7cadd60676 = (nextMarkerRef)=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    emitter.emit('setselectedannotation', nextMarkerRef);
};
const $554aaf1aa11e07ba$export$f845437bf1d007fd = ({ annotations: clickedAnnotations, getInlineNodeTypes: getInlineNodeTypes, editorActions: editorActions, onClose: onClose, onDelete: onDelete, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar = false, isOffline: isOffline })=>{
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const supportedCommentActions = !isLivePage ? [
        'edit',
        'resolve'
    ] : [
        'edit',
        'resolve',
        'delete'
    ];
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Hide OmniBar while a comment is selected (standalone or in panel). Only release when comment is fully closed.
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $42omo.useLayoutEffect)(()=>{
        if (clickedAnnotations.length > 0 && (0, $9wGTI.fg)('cc-engagement-omnibar-hide-inline-comments')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        clickedAnnotations.length,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    const [isInlineCommentVisible, setIsInlineCommentVisible] = (0, $42omo.useState)(false);
    const inlineCommentRef = (0, $42omo.useCallback)((node)=>{
        if (node === null) setIsInlineCommentVisible(false);
        else setIsInlineCommentVisible(true);
    }, []);
    const handleResolve = ()=>{
        setEditorViewProps(null);
    };
    const handleDelete = (0, $42omo.useCallback)((id)=>{
        setEditorViewProps(null);
        onDelete && onDelete(id);
    }, [
        setEditorViewProps,
        onDelete
    ]);
    (0, $42omo.useEffect)(()=>{
        const annotationId = clickedAnnotations[0]?.id;
        if (!annotationId) return;
        const shouldScrollCommentsPanelToComment = isCommentsPanelShown && clickedAnnotations.length > 0;
        if (shouldScrollCommentsPanelToComment) {
            setCurrentlySelectedThreadKey(annotationId);
            let expectedView = undefined;
            if (currentView === (0, $3mVfX.ViewValues).RESOLVED || currentView === (0, $3mVfX.ViewValues).DELETED_CONTENT) {
                setCurrentView && setCurrentView((0, $3mVfX.ViewValues).OPEN);
                expectedView = (0, $3mVfX.ViewValues).OPEN;
            }
            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentType: 'INLINE',
                annotationClicked: true,
                expectedView: expectedView
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clickedAnnotations[0]?.id
    ]);
    const handleNavigationClick = (nextMarkerRef)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_arrow_nav')) experienceTracker.updateAttributes({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                annotationId: nextMarkerRef
            }
        });
        $554aaf1aa11e07ba$export$aa84ce7cadd60676(nextMarkerRef);
    };
    const shouldRenderStandaloneInlineComment = clickedAnnotations.length > 0 && !isCommentsPanelShown;
    return shouldRenderStandaloneInlineComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UZkz.InlineComment), {
        isEditor: true,
        annotation: clickedAnnotations[0],
        getInlineNodeTypes: getInlineNodeTypes,
        onClose: onClose,
        editorActions: editorActions,
        onNavigationClick: (nextMarkerRef)=>handleNavigationClick(nextMarkerRef),
        onResolve: handleResolve,
        onDelete: handleDelete,
        supportedTopLevelActions: supportedCommentActions,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        inlineCommentRef: inlineCommentRef,
        isInlineCommentVisible: isInlineCommentVisible,
        isOffline: isOffline,
        key: `inline-comment-${clickedAnnotations[0]?.id}`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
};
module.exports["editorHandleNavigationClick"] = $554aaf1aa11e07ba$export$aa84ce7cadd60676;
module.exports["ViewComponent"] = $554aaf1aa11e07ba$export$f845437bf1d007fd;

});

parcelRegister("2UZkz", function(module, exports) {

var $k67hX = parcelRequire("k67hX");


var $biHX4 = parcelRequire("biHX4");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $7EEGh = parcelRequire("7EEGh");


var $308Wd = parcelRequire("308Wd");


var $gdv5Z = parcelRequire("gdv5Z");


var $9QIM2 = parcelRequire("9QIM2");


var $dANtQ = parcelRequire("dANtQ");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $7aw3q = parcelRequire("7aw3q");


var $g1WP0 = parcelRequire("g1WP0");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $fHAwL = parcelRequire("fHAwL");


var $24amZ = parcelRequire("24amZ");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cZa7r = parcelRequire("cZa7r");


var $2VQ4B = parcelRequire("2VQ4B");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $cQCqE = parcelRequire("cQCqE");


var $jbF1h = parcelRequire("jbF1h");


var $kgNLQ = parcelRequire("kgNLQ");


var $4luml = parcelRequire("4luml");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $ep3mz = parcelRequire("ep3mz");


var $aGjYc = parcelRequire("aGjYc");


var $liGyh = parcelRequire("liGyh");


var $hXzKU = parcelRequire("hXzKU");


var $8z9UY = parcelRequire("8z9UY");


var $afGoD = parcelRequire("afGoD");


var $3B9cR = parcelRequire("3B9cR");


var $1C8XP = parcelRequire("1C8XP");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $lb2Lp = parcelRequire("lb2Lp");


var $zkUcd = parcelRequire("zkUcd");


var $8wupW = parcelRequire("8wupW");


var $c7FK0 = parcelRequire("c7FK0");


var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $daq5m = parcelRequire("daq5m");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");


var $g0DaR = parcelRequire("g0DaR");

var $asNlu = parcelRequire("asNlu");

var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");


var $3ejfs = parcelRequire("3ejfs");


var $aMfLn = parcelRequire("aMfLn");


var $k8e76 = parcelRequire("k8e76");


var $3jwuS = parcelRequire("3jwuS");


var $7W8i8 = parcelRequire("7W8i8");


var $cAdj8 = parcelRequire("cAdj8");


var $3ZsvI = parcelRequire("3ZsvI");


var $8i27m = parcelRequire("8i27m");


var $hl0fg = parcelRequire("hl0fg");


var $7Sm4c = parcelRequire("7Sm4c");


var $en1dX = parcelRequire("en1dX");


var $7aRa9 = parcelRequire("7aRa9");


var $4Svbr = parcelRequire("4Svbr");


var $fy5yb = parcelRequire("fy5yb");


var $7qvmT = parcelRequire("7qvmT");


var $5fMeR = parcelRequire("5fMeR");


var $6faGq = parcelRequire("6faGq");


var $3iaSn = parcelRequire("3iaSn");


var $a3q17 = parcelRequire("a3q17");


var $bEwJH = parcelRequire("bEwJH");


var $B3Avz = parcelRequire("B3Avz");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $dhKx6 = parcelRequire("dhKx6");


var $6Ebso = parcelRequire("6Ebso");

const $f4f7ab8b4171ff8f$var$relativeFilePath = 'annotation-provider-inline-comments/InlineComment';
const $f4f7ab8b4171ff8f$var$InlineCommentDeleteInlineCommentMutationWithStepMutation = (0, $biHX4.default);
const $f4f7ab8b4171ff8f$var$InlineCommentCreateInlineReplyMutation = (0, $k67hX.default);
const $f4f7ab8b4171ff8f$var$i18n = (0, $aXWIB.defineMessages)({
    commentLoadError: {
        id: "annotation-provider-inline-comments.error.comment.load.message",
        defaultMessage: "Something went wrong when loading this comment. Refresh to view the latest updates."
    },
    commentLoadNetworkError: {
        id: "annotation-provider-inline-comments.network.error.message",
        defaultMessage: "This comment wasn't loaded due to a network error. Check your connection and try again."
    },
    commentLoadErrorTitle: {
        id: "annotation-provider-inline-comments.error.comment.load.title",
        defaultMessage: "Unable to load comment"
    },
    commentReplyAriaLabel: {
        id: "annotation-provider-inline-comments.comment.reply.aria-label",
        defaultMessage: "Reply to {name}\u2019s thread"
    },
    commentAriaLabel: {
        id: "annotation-provider-inline-comments.comment.aria-label",
        defaultMessage: "Comment by {displayName}, {timestamp}"
    }
});
const $f4f7ab8b4171ff8f$var$logger = (0, $7W8i8.getLogger)('annotation-provider-inline-comment');
const $f4f7ab8b4171ff8f$var$noop = ()=>{
// This is intentional
};
const $f4f7ab8b4171ff8f$var$InlineCommentComponent = ({ annotation: selectedAnnotation, onResolve: onResolve, deleteOptions: deleteOptions, onClose: onClose, isEditor: isEditor, isArchived: isArchived, onNavigationClick: onNavigationClick, onDelete: onDelete, supportedTopLevelActions: supportedTopLevelActions, getInlineNodeTypes: getInlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, inlineCommentRef: inlineCommentRef = ()=>{}, isInlineCommentVisible: isInlineCommentVisible = false, flags: flags, isOffline: isOffline })=>{
    const pageClass = (0, $9QIM2.usePageClass)();
    const lastSelected = (0, $42omo.useRef)(undefined);
    const { replyToCommentUser: replyToCommentUser } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentView: setCurrentView, setReplyToCommentId: setReplyToCommentId, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, editCommentId: editCommentQueryId } = (0, $liGyh.useInlineCommentQueryParams)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const RENDER_METRIC = isEditor ? (0, $a3q17.EDITOR_INLINE_COMMENT_RENDER_METRIC) : (0, $a3q17.RENDERER_INLINE_COMMENT_RENDER_METRIC);
    if (lastSelected.current !== selectedAnnotation.id) {
        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.start({
            pageClass: pageClass,
            annotationId: selectedAnnotation.id,
            entryPoint: 'unknown:InlineComment'
        });
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) {
            RENDER_METRIC.start();
            const attributes = {
                pageMode: pageMode,
                pageClass: pageClass,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                annotationId: selectedAnnotation.id,
                isEditor: !!isEditor,
                isArchived: !!isArchived,
                isOpeningMediaCommentFromToolbar: !!isOpeningMediaCommentFromToolbar,
                isInlineCommentVisible: !!isInlineCommentVisible,
                isOffline: !!isOffline,
                ...focusedCommentId && {
                    focusedCommentId: focusedCommentId
                },
                ...replyToCommentId && {
                    replyToCommentId: replyToCommentId
                },
                ...editCommentQueryId && {
                    editCommentId: editCommentQueryId
                }
            };
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_extend')) {
                (0, $4EKKB.selectInlineComment).debug(`InlineComment component mounted with annotation id ${selectedAnnotation.id}`);
                experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    attributes: attributes
                });
            } else experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    ...attributes,
                    entryPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
            if (pageClass !== 'renderer' && pageClass !== 'editor') experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: 'Page class is not renderer or editor',
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
        }
        lastSelected.current = selectedAnnotation.id;
    }
    const annotationElementRef = (0, $42omo.useRef)(null);
    const resolveWindowCloseTimeout = (0, $42omo.useRef)();
    const sidebarEl = (0, $42omo.useRef)(null);
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const [eventEmitter] = (0, $42omo.useState)(()=>isEditor ? (0, $gfqXk.getEditorAnnotationEventEmitter)() : (0, $gczDe.getRendererAnnotationEventEmitter)());
    const [shouldFocusNewReply, setShouldFocusNewReply] = (0, $42omo.useState)(false);
    // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
    const pageId = contentId;
    const { addUnresolvedInlineComment: addUnresolvedInlineComment, removeUnresolvedInlineComment: removeUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageId);
    const { handleClose: handleClose, setEditorCreateProps: setEditorCreateProps, setHoverProps: setHoverProps, setSelectionProps: setSelectionProps, setStoredCommentData: setStoredCommentData, clearStoredCommentData: clearStoredCommentData, setCommentSidebarContext: setCommentSidebarContext } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const [editCommentId, setCommentForEdit] = (0, $42omo.useState)('');
    const [resolvedComment, setResolvedComment] = (0, $42omo.useState)(null);
    const [shouldRender, setShouldRender] = (0, $42omo.useState)(false);
    const [isReplyChainCollapsed, setIsReplyChainCollapsed] = (0, $42omo.useState)(true);
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const nudgeRef = (0, $42omo.useRef)(null);
    const [popupsScrollableElement, setPopupsScrollableElement] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const [hasParentMaxHeight, setHasParentMaxHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const { updateReactionInCache: updateReactionInCache } = (0, $4luml.useUpdateReactionInCache)();
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElementRef.current,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: isEditor || false,
        annotationElement: document.getElementById(selectedAnnotation.id),
        isViewCommentMode: true,
        windowWidth: windowWidth,
        isSticky: isSticky
    });
    const apolloCacheCallback = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $g0DaR.updateApolloCacheCallbackForGA) : (0, $g0DaR.updateApolloCacheCallback);
    const handleCloseCreateComment = (0, $42omo.useCallback)(()=>{
        handleClose();
        setHoverProps(null);
        setSelectionProps(null);
        setEditorCreateProps(null);
    }, [
        handleClose,
        setHoverProps,
        setSelectionProps,
        setEditorCreateProps
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        const isReply = editCommentId === '';
        experienceTracker.abort({
            name: isReply ? (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
            reason: 'comment discarded by user'
        });
        // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', isReply ? 'reply' : 'edit');
        setIsReplyChainCollapsed(true);
        setShouldFocusNewReply(false);
        onClose && onClose();
        setActiveHighlight(null);
    }, [
        experienceTracker,
        editCommentId,
        isEditor,
        onClose,
        setActiveHighlight
    ]);
    // For now, this is a function that takes a boolean and returns a function.
    // The mustSetActiveHighlight parameter and the extra layer of nesting can be
    // removed after confluence_comment_resolve_kbs_fix is rolled out and cleaned up.
    const handleOnCloseUnified = (0, $42omo.useCallback)((mustSetActiveHighlight)=>()=>{
            if (isEditor) handleOnClose();
            else {
                onClose && onClose();
                if (mustSetActiveHighlight || (0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setActiveHighlight(null);
            }
        }, [
        isEditor,
        handleOnClose,
        onClose,
        setActiveHighlight
    ]);
    const onlyHasReactionsSummaryErrors = (0, $42omo.useCallback)((error)=>{
        let hasOtherGqlErrors = false;
        if (error.graphQLErrors?.length > 0) error.graphQLErrors.forEach((e)=>{
            if (e.path?.includes('reactionsSummary')) (0, $4EKKB.selectInlineComment).debug('found reactionsSummary graphql error', {
                errorMessage: e.message
            });
            else hasOtherGqlErrors = true;
        });
        return !hasOtherGqlErrors && !error.networkError;
    }, []);
    const handleGqlError = (0, $42omo.useCallback)((error)=>{
        (0, $4EKKB.selectInlineComment).debug('received a gql error', {
            errorMessage: error.message
        });
        if (onlyHasReactionsSummaryErrors(error)) {
            (0, $4EKKB.selectInlineComment).debug('did not receive non-reactionsSummary errors, ignoring');
            return;
        }
        // If the error is reactions based, just set it to null and move on
        if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        else if (!(0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error
        });
        const parsedError = (0, $isdzP.parseError)(error);
        const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message);
        if (translatedError === (0, $9CnRS.i18n).unexpectedError) {
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadError)
            });
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(error);
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.stopOnError({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
        } else {
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $isdzP.isNetworkError)(translatedError) ? $f4f7ab8b4171ff8f$var$i18n.commentLoadNetworkError : translatedError)
            });
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: parsedError.message
            });
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: parsedError.message,
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
        (0, $4EKKB.selectInlineComment).debug('Closing create comment following a gql error');
        // Close the create comment component if there was an error loading the newly created comment
        handleCloseCreateComment();
    }, [
        experienceTracker,
        flags,
        handleCloseCreateComment,
        onlyHasReactionsSummaryErrors
    ]);
    const [{ unreadCommentIDSet: unreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    // Determine if we should use cache-only policy or skip query entirely
    const shouldSkipQuery = Boolean(storedCommentData);
    // When experiment is enabled, use useCommentById with markerRef to find comment directly
    const commentByMarkerRef = (0, $lb2Lp.useCommentById)({
        markerRef: selectedAnnotation.id,
        contentId: pageId,
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
            fetchPolicy: 'cache-first'
        }
    });
    // Use useAllCommentsData to get deleteCommentInCache function
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: pageId,
        options: {
            skip: true
        }
    });
    const { data: data, error: gqlError } = (0, $jMyy4.useQueryInterop)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $1C8XP.ActiveInlineCommentsQuery) : (0, $3B9cR.InlineCommentQuery), {
        variables: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? {
            pageId: pageId,
            inlineMarkerRefList: [
                selectedAnnotation.id
            ],
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        } : {
            pageId: pageId,
            annotationId: selectedAnnotation.id,
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        },
        onError: undefined,
        fetchPolicy: 'cache-and-network',
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        // This allows rendering using data from a partially-successful graphql query.
        // If query receives an error, `gqlError` will be set, while any successfully
        // fetched data will be available in `data` and be rendered.
        errorPolicy: 'all'
    });
    // Use initial comment data, new hook data, or query data
    const effectiveData = (0, $42omo.useMemo)(()=>{
        if (commentByMarkerRef?.comment && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return {
            comments: {
                nodes: [
                    commentByMarkerRef.comment
                ]
            }
        };
        if (shouldSkipQuery) return {
            comments: {
                nodes: [
                    storedCommentData
                ]
            }
        };
        return data;
    }, [
        shouldSkipQuery,
        storedCommentData,
        commentByMarkerRef?.comment,
        data
    ]);
    const [reopenInlineCommentFn] = (0, $308Wd.useMutationInterop)((0, $dhKx6.ResolveInlineCommentMutation));
    // Get the update function for the comments data manager
    const { updateCommentInCache: updateCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { pageInfo: pageInfo, error: pageInfoError } = (0, $cAdj8.usePageInfo)();
    (0, $42omo.useEffect)(()=>{
        if (pageInfoError && (0, $9wGTI.fg)('confluence_frontend_inline_comment_page_info_err')) handleGqlError(pageInfoError);
    }, [
        pageInfoError,
        handleGqlError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (gqlError) handleGqlError(gqlError);
    }, [
        gqlError,
        handleGqlError
    ]);
    // When the selectedAnnotation changes make sure we unset whatever resolved logic exists
    (0, $42omo.useEffect)(()=>{
        setResolvedComment(null);
        clearTimeout(resolveWindowCloseTimeout.current);
        resolveWindowCloseTimeout.current = undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedAnnotation
    ]);
    const [resolveInlineCommentFn] = (0, $308Wd.useMutationInterop)((0, $dhKx6.ResolveInlineCommentMutation));
    const [deleteInlineCommentFn] = (0, $308Wd.useMutationInterop)((0, $6Ebso.DeleteInlineCommentMutation));
    const [deleteInlineCommentWithStepFn] = (0, $308Wd.useMutationInterop)($f4f7ab8b4171ff8f$var$InlineCommentDeleteInlineCommentMutationWithStepMutation);
    const [createReplyFn] = (0, $308Wd.useMutationInterop)($f4f7ab8b4171ff8f$var$InlineCommentCreateInlineReplyMutation);
    const { createInlineReplyInterop: createInlineReplyInterop } = (0, $cQCqE.useCreateInlineReplyMutation)({
        contentId: pageId
    });
    // Tracks pending reply submission for coordinated editor reset (new data manager only).
    // When set, useLayoutEffect will call onReplyProcessed when the expected reply appears in the list.
    const pendingReplyRef = (0, $42omo.useRef)(null);
    // Editor setup
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    // User page permissions
    const operations = pageInfo?.operations || [];
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment');
    // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType);
    // Comment metadata
    let commentData;
    if (commentByMarkerRef?.comment && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) commentData = commentByMarkerRef.comment; // Use comment from useCommentById
    else if (shouldSkipQuery) commentData = storedCommentData; // Use initial comment data directly
    else if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) commentData = effectiveData?.comments?.nodes?.[0];
    else commentData = effectiveData?.comments?.nodes?.[0];
    // Track experiment completion when comment data is loaded and rendered
    (0, $42omo.useEffect)(()=>{
        // Only track when we have comment data and the component is visible
        // And only when the experiment is running
        if (commentData && isInlineCommentVisible) {
            experienceTracker.succeed({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                attributes: {
                    annotationId: selectedAnnotation.id,
                    pageId: pageId,
                    pageMode: isEditor ? (0, $cD1qu.PageMode).EDIT : (0, $cD1qu.PageMode).VIEW,
                    isEditor: Boolean(isEditor)
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).stop();
        }
    }, [
        commentData,
        isInlineCommentVisible,
        storedCommentData,
        selectedAnnotation.id,
        pageId,
        isEditor,
        experienceTracker
    ]);
    const commentStatus = (0, $3iaSn.useGetCommentStatus)({
        resolveProperties: commentData?.location?.inlineResolveProperties || commentData?.location?.commentResolveProperties
    });
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = commentData?.id;
    const createdAt = commentData?.createdAt?.value;
    const createdAtNonLocalized = commentData?.createdAtNonLocalized;
    const when = commentData?.version?.when;
    const versionByDisplayName = commentData?.version?.by?.displayName;
    const isEdited = (commentData?.version?.number || 0) > 1;
    const permissions = commentData?.permissions;
    const content = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const numReplies = commentData?.replies?.length || 0;
    const commentThreadLength = 1 + numReplies; // includes root comment
    const resolveProperties = commentData?.location?.inlineResolveProperties || undefined;
    const resolvedTime = commentData?.location?.inlineResolveProperties?.resolvedTime;
    const resolvedUser = commentData?.location?.inlineResolveProperties?.resolvedUser;
    const commentUrl = isEditor && !isLivePage ? commentData?.links.editui : commentData?.links.webui;
    const reactionsSummary = commentData?.reactionsSummary ?? null;
    const shouldCollapseReplies = isReplyChainCollapsed && numReplies && numReplies > (0, $bEwJH.MAX_UNCOLLAPSED_REPIES);
    // When new data manager is on: detect when the expected reply appears in the list and call onReplyProcessed
    // before paint, so user never sees editor + new reply at the same time.
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        const pending = pendingReplyRef.current;
        if (!pending) return;
        const replies = commentData?.replies ?? [];
        const expectedReplyVisible = replies.some((r)=>r.id === pending.expectedReplyId);
        if (!expectedReplyVisible) return;
        pendingReplyRef.current = null;
        (0, $jTxSS.flushSync)(()=>pending.onReplyProcessed());
    }, [
        commentData?.replies
    ]);
    const [{ commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }, { addReplyToCommentThread: addReplyToCommentThread, handleRemovingComments: handleRemovingComments, deleteParentComment: deleteParentComment, resolveParentComment: resolveParentComment, reopenParentComment: reopenParentComment, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList }] = (0, $8i27m.useCommentsData)();
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) {
            RENDER_METRIC.start();
            experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                id: selectedAnnotation.id,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    mode: pageMode,
                    framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER
                }
            });
        }
    }, [
        RENDER_METRIC,
        selectedAnnotation,
        experienceTracker,
        isEditor,
        pageMode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (commentId) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'inlineCommentsSidebar',
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        mode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        commentsDeckSize: numReplies + 1,
                        commentId: // +1 for the parent comment
                        commentId
                    }
                }
            }).fire();
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) (0, $4EKKB.selectInlineComment).debug(`Comment ID or page ID was updated. Comment ID: ${commentId}, page ID: ${pageId}`);
            else experienceTracker.succeed({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
            });
        }
    // We really only need to depend on these two things and want this to fire when ONLY they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId,
        commentId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (editCommentQueryId) {
            const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(editCommentQueryId);
            if (isReplyToCommentInChain) setIsReplyChainCollapsed(false);
            setCommentForEdit(editCommentQueryId);
        }
    }, [
        editCommentQueryId,
        commentData
    ]);
    (0, $42omo.useEffect)(()=>{
        const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(replyToCommentId);
        setShouldFocusNewReply(Boolean(replyToCommentId) && (isReplyToCommentInChain || replyToCommentId === commentId));
    }, [
        replyToCommentId,
        commentId,
        commentData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldFocusNewReply) {
            // for parent comment
            if (commentData && replyToCommentId === commentData.id) handleReplyToComment(commentData?.id, commentData);
            else {
                const replyObj = commentData?.replies?.find((reply)=>reply?.id === replyToCommentId);
                if (replyObj && replyObj.parentId) handleReplyToComment(replyObj.parentId, replyObj);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldFocusNewReply,
        commentData?.replies
    ]);
    (0, $42omo.useEffect)(()=>{
        if (focusedCommentId) {
            const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(focusedCommentId);
            if (isReplyToCommentInChain) setIsReplyChainCollapsed(false);
        }
    }, [
        focusedCommentId,
        commentData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (effectiveData && pageInfo) {
            (0, $4EKKB.selectInlineComment).debug('Closing create comment as the view component is ready [!apollo_loading]');
            // Close the create comment component when the view component is ready
            handleCloseCreateComment();
            setShouldRender(true);
            (0, $4EKKB.selectInlineComment).debug('Data has loaded. Rendering inline comment sidebar... [apollo_loading]');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        effectiveData,
        pageInfo
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setShouldRender(false);
            (0, $4EKKB.selectInlineComment).debug('Data changed, hiding comment', {
                ...!!commentId && {
                    commentId: commentId
                },
                pageId: pageId,
                selectedAnnotationId: selectedAnnotation.id,
                shouldRender: shouldRender
            });
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) (0, $4EKKB.selectInlineComment).debug(`Data has changed. Selected annotation ID: ${selectedAnnotation?.id}, comment ID: ${commentId}, page ID: ${pageId}, shouldRender: ${shouldRender}. Hiding inline comment sidebar (if open)...`);
            if (shouldRender) {
                (0, $4EKKB.selectInlineCommentCompoundExperience).abort({
                    abortReason: 'Inline comment experience received a new experience while already running'
                });
                if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    reason: `Inline comment component has received new data and is hiding the inline comment sidebar. shouldRender: ${shouldRender}. This is most likely because the user has navigated between inline comments too quickly using the keyboard shortcuts. This is an expected abort experience`,
                    checkForTimeout: true,
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                    }
                });
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commentId,
        pageId,
        selectedAnnotation
    ]);
    // Reset commentSidebarContext when view sidebar unmounts so next open is treated as view
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setCommentSidebarContext(null);
        };
    }, [
        setCommentSidebarContext
    ]);
    (0, $42omo.useEffect)(()=>{
        // if the user has been shown the resolved comment view, but navigated away to another comment
        // we need to cancel the autodismiss functionality, as it will close this entire view and not just the
        // resolved comment notification
        if (commentId !== resolvedComment?.commentId) {
            clearTimeout(resolveWindowCloseTimeout.current);
            resolveWindowCloseTimeout.current = undefined;
        }
    }, [
        commentId,
        resolvedComment,
        resolveWindowCloseTimeout
    ]);
    const toggleCommentMode = (id = '')=>{
        setCommentForEdit(id);
    };
    (0, $42omo.useEffect)(()=>{
        const markerRef = commentData?.location?.inlineMarkerRef;
        if (markerRef) setActiveHighlight(markerRef);
    }, [
        commentData,
        setActiveHighlight
    ]);
    const handleReplyToComment = (id, commentReplyData)=>{
        const referencedData = commentReplyData || commentData;
        setShouldFocusNewReply(true);
        setReplyToCommentId({
            parentCommentId: id,
            location: (0, $i6UMJ.LocationValue).STANDALONE,
            user: {
                displayName: referencedData?.author?.displayName,
                accountId: referencedData?.author?.accountId
            }
        });
    };
    const deleteCommentInCacheOnUpdate = (0, $42omo.useCallback)((removalCommentId)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: err,
                    commentId: removalCommentId
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker
    ]);
    const isOptimisticDeleteEnabled = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false);
    const handleDeleteCommentError = (0, $42omo.useCallback)(({ err: err, isReply: isReply, deletedCommentId: deletedCommentId, deletedReplyComment: deletedReplyComment })=>{
        const parsedError = (0, $isdzP.parseError)(err);
        const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, deletedCommentId);
        if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
            flags.showWarningFlag({
                id: deletedCommentId,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).commentAlreadyDeletedTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), translatedError)
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'alreadyDeleted',
                    actionSubject: 'comment',
                    actionSubjectId: deletedCommentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        commentType: (0, $8i27m.CommentType).INLINE,
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        mode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        isReply: isReply
                    }
                }
            }).fire();
        } else if (isOptimisticDeleteEnabled) // show an error flag to the user when optimistic deletion fails
        flags.showErrorFlag({
            id: deletedCommentId,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).deleteErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).deleteError)
        });
        // If a parent comment, mark the annotation as ACTIVE again
        if (!isReply && isOptimisticDeleteEnabled) (0, $g0DaR.unresolveInlineCommentAnnotation)(selectedAnnotation.id, pageMode, eventEmitter);
        // If a reply was optimistically deleted, add it back to the comment thread
        if (deletedReplyComment && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(selectedAnnotation.id, deletedReplyComment, (0, $8i27m.CommentType).INLINE, true);
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
            error: err,
            commentId: deletedCommentId
        });
    }, [
        eventEmitter,
        experienceTracker,
        flags,
        pageId,
        pageMode,
        selectedAnnotation,
        isOptimisticDeleteEnabled,
        addReplyToCommentThread,
        createAnalyticsEvent
    ]);
    const handleDeleteCommentInRenderer = (0, $42omo.useCallback)((parentId, replyCommentId)=>{
        const isReply = Boolean(parentId);
        let deleteResult;
        let mtnVariables;
        if (isReply) mtnVariables = {
            variables: {
                commentIdToDelete: replyCommentId,
                deleteFrom: (0, $8z9UY.CommentDeletionLocation).LIVE
            }
        };
        else {
            try {
                // Call deleteAnnotation(selectedAnnotation) to get step and any other required variables
                deleteResult = deleteOptions?.deleteAnnotation(selectedAnnotation);
            } catch (e) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: e
                });
                return;
            }
            if (!deleteResult) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: new Error(`Unable to remove annotation ${selectedAnnotation.id} from document`)
                });
                return;
            }
            mtnVariables = {
                variables: {
                    input: {
                        commentId: commentId,
                        step: (0, $aMfLn.constructStepForGql)(deleteResult.step)
                    }
                }
            };
        }
        // After deleting it will not be available, so we need to get the inline node types before deleting.
        const inlineNodeTypes = selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined;
        // top-level comment calls `deleteInlineCommentWithStepFn`
        // reply calls `deleteInlineComment`
        const deleteFn = isReply ? deleteInlineCommentFn : deleteInlineCommentWithStepFn;
        const deletedCommentId = isReply ? replyCommentId : commentId;
        const cacheUpdateCallback = isReply ? apolloCacheCallback('delete', {
            pageId: pageId,
            annotationId: selectedAnnotation.id,
            contentStatus: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
                'DRAFT',
                'CURRENT'
            ] : [
                'CURRENT',
                'DRAFT'
            ]
        }, parentId, replyCommentId) : undefined;
        const optimisticDeleteResponse = isReply ? {
            deleteComment: true
        } : {
            deleteInlineComment: true
        };
        // If a parent comment, optimistically mark the annotation as resolved and
        // simply close the standalone. No need to invoke `deleteParentComment` here.
        if (!isReply && isOptimisticDeleteEnabled) {
            (0, $g0DaR.resolveInlineCommentAnnotation)(selectedAnnotation.id, pageMode, eventEmitter);
            handleOnCloseUnified(false)();
        }
        // If a reply, optimistically delete it.
        const deletedReplyComment = isReply && replyCommentId && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: selectedAnnotation.id,
            commentId: replyCommentId,
            commentType: (0, $8i27m.CommentType).INLINE,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        deleteFn({
            ...mtnVariables,
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(deletedCommentId), cacheUpdateCallback),
            optimisticResponse: isOptimisticDeleteEnabled ? optimisticDeleteResponse : undefined
        }).then((retVal)=>{
            const deleteResultData = isReply ? retVal.data : retVal.data;
            if (!deleteResultData || !isReply && !deleteResultData.deleteInlineComment) throw new Error('No data returned from mutation');
            const deleteAnnotationAndCleanUp = (annotationId)=>{
                // Update storedCommentData if it exists
                if (storedCommentData && clearStoredCommentData) {
                    if (!isReply) // Deleting the main comment, clear all data
                    clearStoredCommentData();
                    else if (replyCommentId) {
                        // Deleting a reply, remove it from the replies array
                        const updatedCommentData = {
                            ...storedCommentData,
                            replies: (storedCommentData.replies || []).filter((reply)=>reply?.id !== replyCommentId)
                        };
                        setStoredCommentData(updatedCommentData);
                    }
                }
                if (!isReply) {
                    // We handle this being false above and can't get here if it is
                    if (deleteResult) deleteOptions?.onDeleteSuccess(deleteResult.doc, annotationId);
                    // Reset the content state on successful deletion on a non-reply
                    resetContentChanged();
                    onClose && onClose();
                    if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) deleteParentComment({
                        threadKey: annotationId,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                } else if (replyCommentId) {
                    if (!isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) handleRemovingComments({
                        threadKey: annotationId,
                        commentId: replyCommentId,
                        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                }
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            (0, $8dA1U.handleDeleteSuccess)({
                commentId: deletedCommentId,
                annotationId: selectedAnnotation?.id,
                pageId: pageId,
                pageMode: pageMode,
                isReply: isReply,
                source: (0, $en1dX.AnalyticsSource).STANDALONE,
                inlineNodeTypes: inlineNodeTypes,
                createAnalyticsEvent: createAnalyticsEvent,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                onSuccess: deleteAnnotationAndCleanUp
            });
        }).catch((err)=>{
            handleDeleteCommentError({
                err: err,
                isReply: isReply,
                deletedCommentId: deletedCommentId,
                deletedReplyComment: deletedReplyComment
            });
        });
    }, [
        commentId,
        createAnalyticsEvent,
        deleteOptions,
        deleteCommentInCacheOnUpdate,
        eventEmitter,
        experienceTracker,
        resetContentChanged,
        onClose,
        pageId,
        apolloCacheCallback,
        storedCommentData,
        clearStoredCommentData,
        setStoredCommentData,
        handleOnCloseUnified,
        isOptimisticDeleteEnabled,
        removeUnresolvedInlineComment,
        selectedAnnotation,
        deleteInlineCommentFn,
        deleteInlineCommentWithStepFn,
        pageMode,
        getInlineNodeTypes,
        handleRemovingComments,
        deleteParentComment,
        commentsDataMap,
        handleDeleteCommentError
    ]);
    const handleDeleteCommentInEditorAndLivePages = (0, $42omo.useCallback)((parentId, replyCommentId)=>{
        const isReply = Boolean(parentId);
        const targetNodeType = (0, $asNlu.getTargetNodeType)(selectedAnnotation.id, true);
        const deletedCommentId = isReply ? replyCommentId : commentId;
        const cacheUpdateCallback = isReply ? apolloCacheCallback('delete', {
            pageId: pageId,
            annotationId: selectedAnnotation.id,
            contentStatus: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
                'DRAFT',
                'CURRENT'
            ] : [
                'CURRENT',
                'DRAFT'
            ]
        }, parentId, replyCommentId) : undefined;
        // If a parent comment, optimistically mark the annotation as resolved and
        // simply close the standalone. No need to invoke `deleteParentComment` here.
        if (!isReply && isOptimisticDeleteEnabled) {
            (0, $g0DaR.resolveInlineCommentAnnotation)(selectedAnnotation.id, pageMode, eventEmitter);
            handleOnCloseUnified(false)();
        }
        // If a reply, optimistically delete it.
        const deletedReplyComment = isReply && replyCommentId && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: selectedAnnotation.id,
            commentId: replyCommentId,
            commentType: (0, $8i27m.CommentType).INLINE,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        // both top-level comments and replies call `deleteInlineComment`
        deleteInlineCommentFn({
            variables: {
                commentIdToDelete: deletedCommentId,
                deleteFrom: isLivePage ? (0, $8z9UY.CommentDeletionLocation).LIVE : (0, $8z9UY.CommentDeletionLocation).EDITOR
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(deletedCommentId), cacheUpdateCallback),
            optimisticResponse: isOptimisticDeleteEnabled ? {
                deleteComment: true
            } : undefined
        }).then((retVal)=>{
            const { data: deleteResultData } = retVal;
            if (!deleteResultData || !isReply && !deleteResultData.deleteComment) throw new Error('No data returned from mutation');
            // Update storedCommentData if it exists
            if (storedCommentData) {
                if (!isReply) // Deleting the main comment, clear all data
                clearStoredCommentData();
                else if (replyCommentId) {
                    // Deleting a reply, remove it from the replies array
                    const updatedCommentData = {
                        ...storedCommentData,
                        replies: (storedCommentData.replies || []).filter((reply)=>reply?.id !== replyCommentId)
                    };
                    setStoredCommentData(updatedCommentData);
                }
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: deletedCommentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: 'editPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        commentType: (0, $8i27m.CommentType).INLINE,
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        pageMode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        inlineNodeTypes: selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined,
                        isReply: isReply,
                        targetNodeType: targetNodeType
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
            });
            if (!isReply) {
                onDelete?.(selectedAnnotation?.id);
                // Remove the comment from the unresolved list
                removeUnresolvedInlineComment(selectedAnnotation?.id);
                // Reset the content state on successful deletion on a non-reply
                resetContentChanged();
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) deleteParentComment({
                    threadKey: selectedAnnotation.id,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
            } else if (replyCommentId) {
                if (!isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) handleRemovingComments({
                    threadKey: selectedAnnotation.id,
                    commentId: replyCommentId,
                    action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
            }
        }).catch((err)=>{
            handleDeleteCommentError({
                err: err,
                isReply: isReply,
                deletedCommentId: deletedCommentId,
                deletedReplyComment: deletedReplyComment
            });
        });
    }, [
        commentId,
        createAnalyticsEvent,
        deleteInlineCommentFn,
        deleteCommentInCacheOnUpdate,
        eventEmitter,
        experienceTracker,
        pageMode,
        pageId,
        onDelete,
        selectedAnnotation,
        getInlineNodeTypes,
        resetContentChanged,
        isLivePage,
        apolloCacheCallback,
        storedCommentData,
        clearStoredCommentData,
        setStoredCommentData,
        handleOnCloseUnified,
        isOptimisticDeleteEnabled,
        removeUnresolvedInlineComment,
        handleRemovingComments,
        deleteParentComment,
        commentsDataMap,
        handleDeleteCommentError
    ]);
    // When handleDeleteComment() is called for a reply, both parentId and replyCommentId are defined
    // When called for a top-level comment, both are undefined
    const handleDeleteComment = (0, $42omo.useCallback)((parentId, replyCommentId)=>{
        if (!isEditor) handleDeleteCommentInRenderer(parentId, replyCommentId);
        else handleDeleteCommentInEditorAndLivePages(parentId, replyCommentId);
    }, [
        isEditor,
        handleDeleteCommentInRenderer,
        handleDeleteCommentInEditorAndLivePages
    ]);
    const handleResolveMutationFailure = (0, $42omo.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
            error: resolveError
        });
    }, [
        experienceTracker
    ]);
    const resolveUpdateFn = (0, $42omo.useCallback)((_dataProxy, mutationResult)=>updateCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveInlineCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    const getReopenUpdateFn = (0, $42omo.useCallback)((onReopenCacheError)=>{
        const reopenUpdateFcn = (_dataProxy, mutationResult)=>updateCommentInCache({
                mutationResult: mutationResult,
                commentId: commentId,
                updateCallback: (0, $kgNLQ.resolveInlineCommentInCacheCallback),
                onError: onReopenCacheError
            });
        return reopenUpdateFcn;
    }, [
        updateCommentInCache,
        commentId
    ]);
    const handleResolveComment = ()=>{
        const mtnOptions = {
            variables: {
                commentId: commentId,
                resolved: true
            },
            ...(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && {
                update: resolveUpdateFn
            }
        };
        const annotationId = selectedAnnotation.id;
        if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
            // No need to set mtnOptions.optimisticResponse since we'll close the
            // standalone comment immediately, as if it is already resolved.
            // Optimistically mark the annotation as resolved
            (0, $g0DaR.resolveInlineCommentAnnotation)(annotationId, pageMode, eventEmitter);
            // Close the standalone comment immediately as if comment is resolved
            handleOnCloseUnified(false)();
        }
        resolveInlineCommentFn(mtnOptions).then(()=>{
            // this will be removed when the prop becomes optional
            onResolve(annotationId);
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: annotationId,
                pageId: pageId,
                pageMode: pageMode,
                eventEmitter: eventEmitter,
                source: (0, $en1dX.AnalyticsSource).STANDALONE,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                createAnalyticsEvent: createAnalyticsEvent,
                getInlineNodeTypes: getInlineNodeTypes,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) resolveParentComment({
                threadKey: annotationId,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== annotationId));
            experienceTracker.succeed({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE)
            });
            if (!(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // If optimistic resolve is enabled, standalone comment should have been closed already.
            handleOnCloseUnified(false)();
            if (allowComments) (0, $zkUcd.showResolvedCommentFlag)({
                commentId: commentId ?? '',
                experienceTracker: experienceTracker,
                flags: flags,
                mode: pageMode,
                annotationId: annotationId,
                formatMessage: formatMessage,
                showCommentsPanel: showCommentsPanel,
                setCurrentView: setCurrentView,
                isCommentsPanelShown: isCommentsPanelShown,
                handleReopenComment: (0, $zkUcd.createHandleReopenComment)({
                    reopenInlineCommentFn: reopenInlineCommentFn,
                    getUpdateFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? getReopenUpdateFn : undefined,
                    commentId: commentId ?? '',
                    annotationId: annotationId,
                    reopenParentComment: reopenParentComment,
                    setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
                    orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
                    highlightReopenedComment: highlightReopenedComment,
                    isEditor: isEditor ?? false,
                    eventEmitter: eventEmitter,
                    setActiveHighlight: setActiveHighlight,
                    experienceTracker: experienceTracker
                }),
                setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey
            });
            // Show the resolved comment window if not in editor
            if (!isEditor) {
                if (commentId) setResolvedComment({
                    commentId: commentId,
                    inlineMarkerRef: annotationId
                });
                // If the comment we just resolved is the same as the one we're currently viewing, set a timeout
                // to auto-close the container as it should be showing the resolved comment notification view
                if (resolvedComment?.commentId === commentData?.id) resolveWindowCloseTimeout.current = setTimeout(()=>{
                    onClose && onClose();
                }, 7500);
            }
        }).catch((err)=>{
            if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                // Undo resolving the annotation when optimistic resolve is enabled
                (0, $g0DaR.unresolveInlineCommentAnnotation)(annotationId, pageMode, eventEmitter);
                // Don't re-open the standalone comment box. Show an error flag instead.
                flags.showErrorFlag({
                    id: commentId,
                    title: formatMessage((0, $9CnRS.i18n).resolveErrorTitle),
                    description: formatMessage((0, $9CnRS.i18n).resolveError)
                });
            }
            handleResolveMutationFailure(err);
        });
    };
    const onCancelComment = ()=>{
        setReplyToCommentId();
        setShouldFocusNewReply(false);
    };
    const handlePublishFail = (0, $42omo.useCallback)((error)=>{
        // Clear pending reply state on failure so useLayoutEffect doesn't
        // incorrectly trigger editor reset on a later unrelated data update
        pendingReplyRef.current = null;
        return (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: error,
            commentId: commentId,
            shouldReturnError: true,
            shouldAbortForExpectedError: true,
            compoundExperienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE)
        });
    }, [
        experienceTracker,
        commentId
    ]);
    const handleCreateReplyUnified = async (adf, onSuccess)=>{
        const parentCommentId = commentId ?? '';
        // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: pageId,
                parentCommentId: parentCommentId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER
            },
            pageId: pageId,
            includeReactions: false
        };
        const queryVariables = {
            annotationId: selectedAnnotation?.id,
            pageId: pageId,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        };
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                parentCommentId: parentCommentId
            }
        });
        // Wrap the createReplyFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const replyCreationInteropWrapper = (options)=>createInlineReplyInterop({
                originalMutationFn: createReplyFn,
                options: options,
                onCacheUpdateError: handlePublishFail
            });
        return replyCreationInteropWrapper({
            variables: variables,
            update: apolloCacheCallback('create', queryVariables, parentCommentId)
        }).then(({ data: data })=>{
            const replyInlineComment = data.replyInlineComment;
            if (!replyInlineComment?.reactionsSummary) replyInlineComment.reactionsSummary = (0, $g0DaR.defaultReactionsSummary);
            const reply = {
                ...replyInlineComment
            };
            // Update storedCommentData if it exists by adding the new reply
            if (storedCommentData && setStoredCommentData) {
                const updatedCommentData = {
                    ...storedCommentData,
                    replies: [
                        ...storedCommentData.replies || [],
                        replyInlineComment
                    ]
                };
                setStoredCommentData(updatedCommentData);
            }
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(selectedAnnotation.id, reply, (0, $8i27m.CommentType).INLINE);
            // reset the replyToCommentUser if any
            replyToCommentUser && setReplyToCommentId();
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) pendingReplyRef.current = {
                expectedReplyId: replyInlineComment.id,
                onReplyProcessed: onSuccess
            };
            (0, $g0DaR.handleCreateReplySuccess)({
                // When new data manager is on, defer onSuccess (resetEditor) to useLayoutEffect
                // so editor collapses in the same paint as the new reply appearing
                onSuccess: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? undefined : onSuccess,
                editCommentQueryId: editCommentQueryId,
                setCommentForEdit: setCommentForEdit,
                data: data,
                createAnalyticsEvent: createAnalyticsEvent,
                pageId: pageId,
                pageType: pageType,
                analyticsSource: (0, $en1dX.AnalyticsSource).STANDALONE,
                commentId: commentId,
                pageMode: pageMode,
                selectedAnnotation: selectedAnnotation,
                getInlineNodeTypes: undefined,
                experienceTracker: experienceTracker,
                isEditor: !!isEditor
            });
        }).catch((error)=>{
            return handlePublishFail(error);
        });
    };
    const updateReactionsCacheFnLegacy = (0, $42omo.useCallback)((emojiId, actionType, objectId, containerId)=>{
        const queryVariables = {
            pageId: containerId,
            annotationId: selectedAnnotation?.id,
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        };
        try {
            const response = (0, $l1uFv.readQueryInterop)({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: queryVariables
            });
            if (!response?.comments?.nodes?.[0]) return;
            const comment = response.comments.nodes[0];
            let cacheReactionsSummary;
            let reply;
            // If the comment matches the comment ID, use it's reactionsSummary
            if (comment.id === objectId) cacheReactionsSummary = comment.reactionsSummary ? {
                ...comment.reactionsSummary
            } : (0, $g0DaR.defaultReactionsSummary);
            else {
                // Otherwise, find the reply that matches
                reply = comment.replies.find((r)=>r?.id === objectId);
                if (reply) cacheReactionsSummary = reply.reactionsSummary ? {
                    ...reply.reactionsSummary
                } : (0, $g0DaR.defaultReactionsSummary);
            }
            if (!cacheReactionsSummary) return;
            const reactionsAri = cacheReactionsSummary.ari || '';
            const reactionsContainerAri = cacheReactionsSummary.containerAri || '';
            let reactionsCount = cacheReactionsSummary.reactionsCount || 0;
            const updatedReactionsSummary = {
                ...cacheReactionsSummary
            };
            const updatedReactionsNodes = [
                ...cacheReactionsSummary.reactionsSummaryForEmoji || []
            ];
            if (actionType === 'add') {
                const reaction = updatedReactionsNodes.find((item)=>item?.emojiId === emojiId);
                // If reaction exists, update its attributes
                if (reaction && !reaction.reacted) {
                    reaction.count++;
                    reaction.reacted = true;
                } else {
                    // Otherwise, create a new reaction
                    const newReaction = {
                        emojiId: emojiId,
                        count: 1,
                        reacted: true,
                        id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`,
                        __typename: 'ReactionsSummaryForEmoji'
                    };
                    updatedReactionsNodes.push(newReaction);
                }
                ++reactionsCount;
            } else if (actionType === 'delete') {
                const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
                // If reaction exists, update its attributes
                if (reactionIdx !== -1) {
                    const reaction = updatedReactionsNodes[reactionIdx];
                    // If we have more than one reaction, remove our user from it and decrement the count
                    if (reaction && reaction.count > 1) {
                        reaction.count--;
                        reaction.reacted = false;
                    } else // Otherwise, remove the reaction entirely
                    updatedReactionsNodes.splice(reactionIdx, 1);
                    --reactionsCount;
                }
            }
            updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
            updatedReactionsSummary.reactionsCount = reactionsCount ?? 0;
            // Create a deep copy of the comment to ensure Apollo detects the change
            const updatedComment = {
                ...comment,
                replies: comment.replies.map((r)=>{
                    if (r?.id === objectId) return {
                        ...r,
                        reactionsSummary: updatedReactionsSummary
                    };
                    return r;
                })
            };
            // Update the comment's reactionsSummary if it's the target comment
            if (comment.id === objectId) // @ts-ignore reactionsCount will always be defined, so the type comparison is wrong
            updatedComment.reactionsSummary = updatedReactionsSummary;
            const newData = {
                comments: {
                    nodes: [
                        updatedComment
                    ],
                    __typename: 'PaginatedCommentList'
                }
            };
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $3B9cR.InlineCommentQuery),
                variables: queryVariables,
                data: newData
            });
        } catch (err) {
            $f4f7ab8b4171ff8f$var$logger.error`An error occurred when updating reactions cache for ${actionType} - ${err}`;
        }
    }, [
        selectedAnnotation,
        isArchived
    ]);
    const updateReactionsCacheFn = (0, $42omo.useCallback)((emojiId, actionType, objectId, containerId, result, onCacheUpdateError)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            // Update the GQL cache when using the new Comments Data Manager
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                // Mutation result should exist, but this check is to satisfy TypeScript
                if (result) return updateReactionInCache({
                    mutationResult: result,
                    commentId: objectId,
                    pageId: pageId || '',
                    contentType: 'page',
                    actionType: actionType,
                    emojiId: emojiId,
                    onError: onCacheUpdateError
                });
            } else // Call the GA function
            (0, $g0DaR.updateReactionsCacheCallbackForGA)(emojiId, actionType, objectId, pageId, selectedAnnotation, isArchived ?? false);
            // Also update storedCommentData if it exists
            if (storedCommentData && setStoredCommentData) {
                const updatedCommentData = {
                    ...storedCommentData
                };
                // Find if this is the main comment or a reply
                if (storedCommentData.id === objectId) {
                    // Update main comment reactions
                    const currentReactions = storedCommentData.reactionsSummary?.reactionsSummaryForEmoji || [];
                    const updatedReactions = [
                        ...currentReactions
                    ];
                    let reactionsCount = storedCommentData.reactionsSummary?.reactionsCount || 0;
                    if (actionType === 'add') {
                        const existingReaction = updatedReactions.find((r)=>r?.emojiId === emojiId);
                        if (existingReaction && !existingReaction.reacted) {
                            existingReaction.count++;
                            existingReaction.reacted = true;
                        } else if (!existingReaction) updatedReactions.push({
                            emojiId: emojiId,
                            count: 1,
                            reacted: true,
                            id: `${storedCommentData.reactionsSummary?.containerAri}|${storedCommentData.reactionsSummary?.ari}|${emojiId}`,
                            __typename: 'ReactionsSummaryForEmoji'
                        });
                        reactionsCount++;
                    } else if (actionType === 'delete') {
                        const reactionIdx = updatedReactions.findIndex((r)=>r?.emojiId === emojiId);
                        if (reactionIdx !== -1) {
                            const reaction = updatedReactions[reactionIdx];
                            if (reaction && reaction.count > 1) {
                                reaction.count--;
                                reaction.reacted = false;
                            } else updatedReactions.splice(reactionIdx, 1);
                            reactionsCount--;
                        }
                    }
                    updatedCommentData.reactionsSummary = {
                        ...storedCommentData.reactionsSummary,
                        reactionsSummaryForEmoji: updatedReactions,
                        reactionsCount: reactionsCount,
                        ari: storedCommentData.reactionsSummary?.ari || ''
                    };
                } else // Update reply reactions
                updatedCommentData.replies = (storedCommentData.replies || []).map((reply)=>{
                    if (reply?.id === objectId) {
                        const currentReactions = reply.reactionsSummary?.reactionsSummaryForEmoji || [];
                        const updatedReactions = [
                            ...currentReactions
                        ];
                        let reactionsCount = reply.reactionsSummary?.reactionsCount || 0;
                        if (actionType === 'add') {
                            const existingReaction = updatedReactions.find((r)=>r?.emojiId === emojiId);
                            if (existingReaction && !existingReaction.reacted) {
                                existingReaction.count++;
                                existingReaction.reacted = true;
                            } else if (!existingReaction) updatedReactions.push({
                                emojiId: emojiId,
                                count: 1,
                                reacted: true,
                                id: `${reply.reactionsSummary?.containerAri}|${reply.reactionsSummary?.ari}|${emojiId}`,
                                __typename: 'ReactionsSummaryForEmoji'
                            });
                            reactionsCount++;
                        } else if (actionType === 'delete') {
                            const reactionIdx = updatedReactions.findIndex((r)=>r?.emojiId === emojiId);
                            if (reactionIdx !== -1) {
                                const reaction = updatedReactions[reactionIdx];
                                if (reaction && reaction.count > 1) {
                                    reaction.count--;
                                    reaction.reacted = false;
                                } else updatedReactions.splice(reactionIdx, 1);
                                reactionsCount--;
                            }
                        }
                        return {
                            ...reply,
                            reactionsSummary: {
                                ...reply.reactionsSummary,
                                reactionsSummaryForEmoji: updatedReactions,
                                reactionsCount: reactionsCount,
                                ari: reply.reactionsSummary?.ari || ''
                            }
                        };
                    }
                    return reply;
                });
                setStoredCommentData(updatedCommentData);
            }
        } else updateReactionsCacheFnLegacy(emojiId, actionType, objectId, containerId);
    }, [
        pageId,
        selectedAnnotation,
        isArchived,
        updateReactionsCacheFnLegacy,
        storedCommentData,
        setStoredCommentData,
        updateReactionInCache
    ]);
    const renderReplies = (0, $42omo.useCallback)((shouldCollapseReplies)=>{
        const replies = effectiveData?.comments?.nodes?.[0]?.replies || [];
        const visibleReplies = shouldCollapseReplies ? replies.slice(-1) : replies;
        return visibleReplies.map((reply)=>{
            if (!reply) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
            const { id: id, permissions: replyPermissions, body: body, reactionsSummary: replyReactionsSummary, createdAtNonLocalized: replyCreatedAtNonLocalized } = reply;
            if (id === editCommentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auGhu.EditComment), {
                key: id,
                commentId: id,
                annotationId: selectedAnnotation.id,
                displayName: reply.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous),
                avatarUrl: reply.author?.profilePicture?.path ?? '',
                pageId: pageId,
                pageType: pageType,
                spaceId: spaceId,
                content: body?.value,
                displayCommentInViewMode: toggleCommentMode,
                mode: isEditor ? 'edit' : 'view',
                isReply: true,
                hasMediaUploadPermissions: hasMediaUploadPermissions,
                getInlineNodeTypes: getInlineNodeTypes,
                commentType: (0, $8i27m.CommentType).INLINE,
                date: reply.version?.when ?? '',
                versionDate: reply.version?.when ?? '',
                hasParentMaxHeight: hasParentMaxHeight
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEmgx.CommentBody), {
                key: id,
                userId: reply.author?.accountId ?? '',
                displayName: reply.author?.displayName,
                avatarUrl: reply.author?.profilePicture?.path,
                date: reply.version?.when ?? '',
                dateUrl: isEditor && !isLivePage ? reply.links.editui ?? undefined : reply.links.webui ?? undefined,
                createdAt: reply.createdAt?.value ?? '',
                createdAtNonLocalized: replyCreatedAtNonLocalized ?? '',
                versionDate: reply.version?.when ?? '',
                versionByDisplayName: reply.version?.by?.displayName,
                commentId: id,
                pageId: pageId,
                pageType: pageType,
                isReply: true,
                isEdited: (reply.version?.number || 0) > 1,
                parentCommentId: reply.parentId,
                permissions: replyPermissions,
                editComment: ()=>toggleCommentMode(id),
                deleteComment: ()=>handleDeleteComment(reply.parentId, id),
                content: reply.body?.value,
                isCommentActive: true,
                mode: isEditor ? 'edit' : 'view',
                permissionType: reply.author?.permissionType ?? undefined,
                supportedActions: [
                    'edit',
                    'delete',
                    'resolve'
                ],
                isFocused: focusedCommentId === id,
                isUnread: unreadCommentIDSet.has(id),
                annotationId: selectedAnnotation?.id,
                annotatedText: annotationElementRef.current?.textContent ?? undefined,
                commentType: (0, $8i27m.CommentType).INLINE,
                inheritedReactionsData: replyReactionsSummary,
                reactionsCacheUpdateFn: updateReactionsCacheFn,
                canAddComments: canAddComments,
                isOffline: isOffline,
                isFabricPage: true
            });
        });
    }, [
        effectiveData,
        editCommentId,
        pageType,
        pageId,
        spaceId,
        selectedAnnotation,
        isEditor,
        focusedCommentId,
        handleDeleteComment,
        isLivePage,
        hasMediaUploadPermissions,
        getInlineNodeTypes,
        updateReactionsCacheFn,
        isOffline,
        canAddComments,
        formatMessage,
        unreadCommentIDSet,
        hasParentMaxHeight
    ]);
    const highlightReopenedComment = (0, $42omo.useCallback)((annotationId)=>{
        // Emit the event to re-highlight the mark
        if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $g0DaR.unresolveInlineCommentAnnotation)(annotationId, pageMode, eventEmitter);
        else eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
            [annotationId]: {
                id: annotationId,
                annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                state: (0, $cUycv.AnnotationMarkStates).ACTIVE
            }
        });
        addUnresolvedInlineComment(annotationId, pageMode);
    }, [
        addUnresolvedInlineComment,
        eventEmitter,
        pageMode
    ]);
    const navigationOptions = (0, $42omo.useMemo)(()=>({
            commentData: commentData,
            onNavigationClick: onNavigationClick
        }), [
        commentData,
        onNavigationClick
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!selectedAnnotation.id) return;
        if (shouldRender === false) {
            // The UI has not started rendering yet, so we don't want to check if it's visible.
            (0, $4EKKB.selectInlineComment).debug(`InlineComment has been rendered, but is returning null due to shouldRender. Selected annotation ID: ${selectedAnnotation?.id}`);
            return;
        }
        const initialTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
        // Add a guard for rapid changes
        let isCancelled = false;
        const timeoutId = setTimeout(()=>{
            // There are multiple apis and effects involved in swapping from the create comment
            // ui to the view comment ui.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            if (isCancelled && (0, $9wGTI.fg)('confluence_frontend_view_inline_is_cancelled')) return;
            requestAnimationFrame(()=>{
                if (isCancelled && (0, $9wGTI.fg)('confluence_frontend_view_inline_is_cancelled')) return;
                const currentTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
                if (!currentTaskId) {
                    // Note -- this should not do anything (as debug points are only added to active experiences)
                    (0, $4EKKB.selectInlineComment).debug('No current task ID');
                    return;
                }
                if (initialTaskId !== currentTaskId) {
                    // The experience has been restarted or has otherwise ended.
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.attachDebugPoint({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        message: `Experience has been restarted or has otherwise ended. initialTaskId: ${initialTaskId}, currentTaskId: ${currentTaskId}`
                    });
                    return;
                }
                if (lastSelected.current !== selectedAnnotation.id) {
                    // The selected annotation has changed, this should have led to an earlier abort
                    // (as an overlapping experience is started)
                    (0, $4EKKB.selectInlineComment).debug(`View inline comment assumed aborted due to selection change. lastSelected.current: ${lastSelected?.current}, selectedAnnotation.id: ${selectedAnnotation?.id}`);
                    return;
                }
                if (!annotationElementRef.current) {
                    // We'd expect the select annotation experience to fail
                    // if no annotation is added to the document
                    // Assume this experience has aborted (or it will timeout)
                    (0, $4EKKB.selectInlineComment).debug('Show inline comment assumed aborted by deselection or selection change. This message indicate an abort failed and something has gone wrong.');
                    (0, $4EKKB.selectInlineCommentCompoundExperience).abort({
                        abortReason: 'No annotation element found for the inline comment ui to attach to.'
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'No annotation element found for the inline comment component to attach to.',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                        }
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_null_annotation_flag')) flags.showWarningFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadError)
                    });
                    return;
                }
                if (!sidebarEl.current) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('Document missing inline comment ui'));
                    if (shouldRender && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.fail({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        error: new Error('Document is missing inline comment sidebar element'),
                        attributes: {
                            stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                        }
                    });
                    return;
                }
                const commentUIVerticalDistanceFromAnnotation = Math.abs(annotationElementRef.current.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top);
                // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                if (commentUIVerticalDistanceFromAnnotation > 40) {
                    const isVisible = sidebarEl.current.checkVisibility();
                    if (isVisible) // if it's fully visible, but misaligned, we don't treat this as a failure
                    (0, $4EKKB.selectInlineComment).debug('View Inline Comment UI too far from annotation', {
                        misalignedBy: commentUIVerticalDistanceFromAnnotation
                    });
                    else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('View Created Comment UI too far from annotation'), {
                            misalignedBy: commentUIVerticalDistanceFromAnnotation
                        });
                        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.fail({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            error: new Error('View inline comment sidebar was rendered too far from annotation'),
                            attributes: {
                                misalignedBy: commentUIVerticalDistanceFromAnnotation,
                                stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                            }
                        });
                        return;
                    }
                }
                if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.succeed({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                    }
                });
                (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.complete('Inline Comment panel comment shown');
            });
        }, 10);
        return ()=>{
            isCancelled = true;
            clearTimeout(timeoutId);
            setShouldRender(false);
            const currentTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
            if (!currentTaskId) // There is no running experience, no need to abort.
            return;
            if (initialTaskId !== currentTaskId) // The experience has been restarted or has otherwise ended.
            return;
            // If a show inline comment experience is still running while this component is in the process of being
            // unmounted, we abort it rather than fail it.
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: 'InlineComment component unmounted'
            });
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: 'Inline comment component unmounted',
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
        };
    }, [
        selectedAnnotation.id,
        shouldRender,
        createAnalyticsEvent,
        experienceTracker,
        flags
    ]);
    const [isStandalonehovered, setisStandalonehovered] = (0, $42omo.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $42omo.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $42omo.useState)(false);
    const handleMouseEnter = (0, $42omo.useCallback)((id)=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        setisStandalonehovered(true);
        if (id) setHoveredCommentId(id);
    }, []);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        setisStandalonehovered(false);
        setHoveredCommentId(undefined);
    }, []);
    const handleFocus = (0, $42omo.useCallback)((event)=>{
        setCommentIsFocused(true);
        event.stopPropagation();
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(false);
    }, [
        setCommentIsFocused
    ]);
    if (!shouldRender) return null;
    const renderComment = ()=>{
        if (commentId === editCommentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auGhu.EditComment), {
            pageId: pageId,
            date: when ?? '',
            createdAtNonLocalized: createdAtNonLocalized ?? '',
            pageType: pageType,
            annotationId: selectedAnnotation.id,
            commentId: commentId,
            spaceId: spaceId,
            content: content ?? '',
            isReply: false,
            displayCommentInViewMode: toggleCommentMode,
            avatarUrl: topCommentUserAvatar ?? '',
            displayName: topCommentDisplayName,
            dateUrl: commentUrl ?? '',
            versionDate: when ?? '',
            isEdited: isEdited,
            resolveProperties: resolveProperties,
            mode: isEditor ? 'edit' : 'view',
            hasMediaUploadPermissions: hasMediaUploadPermissions,
            getInlineNodeTypes: getInlineNodeTypes,
            commentType: (0, $8i27m.CommentType).INLINE,
            isStandaloneComment: true,
            hasParentMaxHeight: hasParentMaxHeight,
            numReplies: numReplies
        });
        else {
            const getDeleteFn = ()=>{
                if (!isLivePage && isEditor) return undefined;
                return handleDeleteComment(undefined);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kEmgx.CommentBody), {
                userId: topCommentUserId,
                avatarUrl: topCommentUserAvatar,
                displayName: topCommentDisplayName,
                date: when ?? '',
                dateUrl: commentUrl ?? '',
                createdAt: createdAt ?? '',
                createdAtNonLocalized: createdAtNonLocalized ?? '',
                versionDate: when ?? '',
                versionByDisplayName: versionByDisplayName,
                pageId: pageId,
                pageType: pageType,
                commentId: commentId ?? '',
                isReply: false,
                isEdited: isEdited,
                permissions: permissions,
                deleteComment: getDeleteFn,
                editComment: ()=>toggleCommentMode(commentId),
                content: content ?? '',
                isCommentActive: true,
                mode: isEditor ? 'edit' : 'view',
                onClose: onClose,
                permissionType: permissionType ?? undefined,
                resolveComment: handleResolveComment,
                supportedActions: supportedTopLevelActions,
                isUnread: unreadCommentIDSet.has(commentId ?? ''),
                numReplies: numReplies,
                commentType: (0, $8i27m.CommentType).INLINE,
                inheritedReactionsData: reactionsSummary,
                reactionsCacheUpdateFn: updateReactionsCacheFn,
                isStandalonehovered: isStandalonehovered,
                isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === commentId || commentIsFocused && (0, $9wGTI.fg)('confluence_comments_hover_state_on_focused_comment'),
                replyToComment: handleReplyToComment,
                hideBranchingStyle: !commentData?.replies || commentData?.replies?.length === 0,
                resolveProperties: resolveProperties,
                isStandaloneComment: true,
                canAddComments: canAddComments,
                isOffline: isOffline,
                isFabricPage: true,
                annotationId: selectedAnnotation?.id,
                annotatedText: annotationElementRef.current?.textContent ?? undefined,
                onRendered: ()=>{
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.attachDebugPoint({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        message: 'Inline comment body rendered'
                    });
                }
            }), !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c7FK0.ReopenedMessage), {
                resolvedUser: resolvedUser ?? undefined,
                resolvedTime: resolvedTime
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
                key: `stop-${commentId}`,
                metric: RENDER_METRIC
            }));
        }
    };
    annotationElementRef.current = document.getElementById(selectedAnnotation.id);
    // Handle case where comment has been deleted
    if (!annotationElementRef.current) {
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) (0, $4EKKB.selectInlineComment).debug('There is no annotation element element, so not rendering InlineComment');
        return null;
    }
    const isCommentAuthor = topCommentUserId === currentUserId;
    const isFirstComment = commentThreadLength === 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $B3Avz.CommentSidebar), {
        nudgeRef: nudgeRef,
        pageId: pageId,
        annotationElement: annotationElementRef.current,
        navigationOptions: navigationOptions,
        onClose: handleOnCloseUnified(true),
        isEditor: isEditor,
        isViewCommentMode: true,
        sidebarOffset: sidebarOffset,
        commentId: commentId,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        annotationId: selectedAnnotation?.id,
        inlineCommentRef: inlineCommentRef,
        ...(0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix') ? {
            setPopupsScrollableElement: setPopupsScrollableElement
        } : {},
        isSticky: isSticky,
        isFabricPage: true,
        authorName: topCommentDisplayName,
        onMaxHeightApplied: setHasParentMaxHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "inline-comment-container",
        onMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : ()=>handleMouseEnter(commentId),
        onMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleMouseLeave,
        onBlur: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleBlur,
        onFocus: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleFocus,
        tabIndex: 0,
        "aria-label": formatMessage($f4f7ab8b4171ff8f$var$i18n.commentAriaLabel, {
            displayName: topCommentDisplayName,
            timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                intl: intl,
                dateString: commentData?.createdAtNonLocalized,
                commentStatus: commentStatus,
                resolveProperties: commentData?.location?.inlineResolveProperties || commentData?.location?.commentResolveProperties
            })
        })
    }, renderComment()), !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && commentData?.replies?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "inline-comment-reply-container"
    }, shouldCollapseReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8wupW.CollapsedReplies), {
        numCollapsedReplies: numReplies - 1,
        onClick: ()=>setIsReplyChainCollapsed(false)
    }), renderReplies(Boolean(shouldCollapseReplies))), commentData?.replies?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Svbr.CommentReplies), {
        flags: (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false) ? flags : undefined,
        parentComment: (0, $3ZsvI.normalizeCommentData)({
            comment: commentData,
            currentUserId: currentUserId ?? '',
            isOpen: true,
            type: (0, $8i27m.CommentType).INLINE
        }),
        pageInfo: pageInfo,
        pageMode: pageMode,
        parentCommentId: commentData.id,
        handleMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $f4f7ab8b4171ff8f$var$noop : handleMouseEnter,
        handleMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $f4f7ab8b4171ff8f$var$noop : handleMouseLeave,
        canAddComments: canAddComments,
        hoveredCommentId: hoveredCommentId ?? '',
        isStandaloneComment: true,
        editCommentQueryId: editCommentQueryId,
        selectedAnnotation: selectedAnnotation,
        key: `standalone-comment-replies-${commentData.id}`,
        deleteStandaloneComment: handleDeleteComment,
        replyToComment: handleReplyToComment,
        updateReactionsCacheFn: updateReactionsCacheFn,
        ...popupsScrollableElement && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix') ? {
            popupsScrollableElement: popupsScrollableElement,
            popupsMountPoint: document.getElementById('editor-comments-sidebar') || document.body
        } : {},
        hasParentMaxHeight: hasParentMaxHeight
    }), !isArchived && canAddComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
        mode: isEditor ? 'edit' : 'view',
        "data-cy": "editor-reply-container",
        "data-testid": "inline-comment-new-reply-container",
        ref: commentContainerElementRef,
        isFabricPage: true,
        isStandaloneComment: true
    }, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        size: "small",
        permissionType: permissionType ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        onCancelComment: onCancelComment,
        content: (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $7qvmT.getAdfForQuickReplyMention)(replyToCommentUser) : undefined,
        appearance: "chromeless",
        EditorComponent: (0, $7EEGh.ChromelessEditor),
        onSaveComment: handleCreateReplyUnified,
        onContentChange: onChange,
        onEditorReady: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE)
            });
        },
        commentMode: "reply",
        commentType: isEditor ? 'edit-inline' : 'inline',
        spaceId: spaceId,
        showCancelButton: true,
        useNewWarningModal: true,
        hideWatchCheckbox: true,
        expandEditor: shouldFocusNewReply,
        pageMode: isEditor ? 'edit' : 'view',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        topLevelCommentId: commentId,
        shouldWarnOnInternalNavigation: true,
        commentContainerElementRef: commentContainerElementRef,
        isStandaloneComment: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        hasParentMaxHeight: hasParentMaxHeight,
        // Needed to remount this component when we change which comment we're viewing
        key: `comment-editor-${commentId}`,
        ...popupsScrollableElement && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix') ? {
            popupsScrollableElement: popupsScrollableElement,
            popupsMountPoint: document.getElementById('editor-comments-sidebar') || document.body
        } : {},
        isOffline: isOffline,
        customAriaLabel: (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? formatMessage($f4f7ab8b4171ff8f$var$i18n.commentReplyAriaLabel, {
            name: topCommentDisplayName
        }) : undefined
    }))), isCommentAuthor && isFirstComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g1WP0.AsyncWrapper), {
        trigger: "inline-comments",
        showImage: false,
        width: 280,
        reference: nudgeRef
    }));
};
const $f4f7ab8b4171ff8f$export$183403b138e102b9 = (0, $7aRa9.withFlags)($f4f7ab8b4171ff8f$var$InlineCommentComponent);
module.exports["InlineComment"] = $f4f7ab8b4171ff8f$export$183403b138e102b9;

});

parcelRegister("k67hX", function(module, exports) {
/**
 * @generated SignedSource<<827e25082359f8d1c2be168ccdff972b>>
 * @relayHash ae101ad519f93d6ee8fda249fac0cfef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5cac25020450d3912c27c74329542bdb8cf44d4e350087e75a57b3b82ebcf566
const $49c2b8adabe9e295$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "when"
    }, v22 = {
        "kind": "ScalarField",
        "name": "number"
    }, v23 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v26 = {
        "condition": "includeReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InlineCommentCreateInlineReplyMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "replyInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v26 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InlineCommentCreateInlineReplyMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "replyInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v11 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v26 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ae101ad519f93d6ee8fda249fac0cfef",
            "id": "5cac25020450d3912c27c74329542bdb8cf44d4e350087e75a57b3b82ebcf566",
            "metadata": {},
            "name": "InlineCommentCreateInlineReplyMutation",
            "operationKind": "mutation",
            "text": "mutation InlineCommentCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!,$includeReactions:Boolean!){replyInlineComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}"
        }
    };
}();
$49c2b8adabe9e295$var$node.hash = "1a07d4cb81840d6ebad5fbdcb4c879da";
var $49c2b8adabe9e295$export$2e2bcd8739ae039 = $49c2b8adabe9e295$var$node;
module.exports["default"] = $49c2b8adabe9e295$export$2e2bcd8739ae039;

});

parcelRegister("biHX4", function(module, exports) {
/**
 * @generated SignedSource<<135cab227952667f0f2fa956f2deef8a>>
 * @relayHash c880fb921a6c530f9fd537747b4c7b37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 444d95b8e718c7484bdbd3853e9b2ae656409de43e3846e73ab5b95f60ecf744
const $68fb440cb1827891$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteInlineComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c880fb921a6c530f9fd537747b4c7b37",
            "id": "444d95b8e718c7484bdbd3853e9b2ae656409de43e3846e73ab5b95f60ecf744",
            "metadata": {},
            "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
            "operationKind": "mutation",
            "text": "mutation InlineCommentDeleteInlineCommentMutationWithStepMutation($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}"
        }
    };
}();
$68fb440cb1827891$var$node.hash = "1aa5c41482c932025b3af698bbf1eaf9";
var $68fb440cb1827891$export$2e2bcd8739ae039 = $68fb440cb1827891$var$node;
module.exports["default"] = $68fb440cb1827891$export$2e2bcd8739ae039;

});

parcelRegister("g1WP0", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $a55d612ff94024a3$var$ThirdPartyNudge = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2jMOC")).then(({ ThirdPartyNudge: ThirdPartyNudge })=>({
            default: ThirdPartyNudge
        })));

const $a55d612ff94024a3$var$NotificationNudge = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2jMOC")).then(({ NotificationNudge: NotificationNudge })=>({
            default: NotificationNudge
        })));
const $a55d612ff94024a3$export$91e508f993b0fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a55d612ff94024a3$var$ThirdPartyNudge, props));
const $a55d612ff94024a3$export$abc42570cc861f1b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a55d612ff94024a3$var$NotificationNudge, null));
module.exports["AsyncWrapper"] = $a55d612ff94024a3$export$91e508f993b0fdc;

});

parcelRegister("2jMOC", function(module, exports) {

let $1b0338df5f930b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b0338df5f930b37$var$load("6wr18"),
    $1b0338df5f930b37$var$load("1TOYq"),
    $1b0338df5f930b37$var$load("ffEVr"),
    $1b0338df5f930b37$var$load("7EorR"),
    $1b0338df5f930b37$var$load("9AXkC"),
    $1b0338df5f930b37$var$load("hhss7"),
    $1b0338df5f930b37$var$load("bCr24")
]).then(()=>parcelRequire('arPKr'));

});

parcelRegister("zkUcd", function(module, exports) {

var $21K7m = parcelRequire("21K7m");


var $irVI7 = parcelRequire("irVI7");


var $24amZ = parcelRequire("24amZ");


var $3mVfX = parcelRequire("3mVfX");


var $8i27m = parcelRequire("8i27m");


var $7W8i8 = parcelRequire("7W8i8");


var $9FoVw = parcelRequire("9FoVw");


var $6mKj3 = parcelRequire("6mKj3");


var $9CnRS = parcelRequire("9CnRS");

const $6153444078ddb7dc$var$logger = (0, $7W8i8.getLogger)('annotation-provider-inline-comment');
const $6153444078ddb7dc$export$ddce50f11b36de55 = (dependencies)=>{
    const { reopenInlineCommentFn: reopenInlineCommentFn, getUpdateFn: getUpdateFn, commentId: commentId, annotationId: annotationId, reopenParentComment: reopenParentComment, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, highlightReopenedComment: highlightReopenedComment, isEditor: isEditor, eventEmitter: eventEmitter, setActiveHighlight: setActiveHighlight, experienceTracker: experienceTracker } = dependencies;
    return ()=>{
        return reopenInlineCommentFn({
            variables: {
                commentId: commentId,
                resolved: false
            },
            update: getUpdateFn?.((cacheError)=>{
                experienceTracker.stopOnError({
                    name: (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE),
                    error: cacheError
                });
            })
        }).then(()=>{
            reopenParentComment({
                threadKey: annotationId,
                commentType: (0, $8i27m.CommentType).INLINE,
                parentCommentId: commentId
            });
            setOrderedActiveAnnotationIdList([
                ...orderedActiveAnnotationIdList.map((status)=>status.threadKey),
                annotationId
            ]);
            highlightReopenedComment(annotationId);
            if (isEditor) {
                eventEmitter.emit('unresolve', annotationId);
                eventEmitter.emit('setselectedannotation', annotationId);
            } else {
                const commentElement = document.getElementById(annotationId);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: commentElement
                });
                setActiveHighlight(annotationId);
            }
            experienceTracker.succeed({
                name: (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE)
            });
        }).catch((err)=>{
            $6153444078ddb7dc$var$logger.error`An error occurred when reopening a comment ${err}`;
            experienceTracker.stopOnError({
                name: (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE),
                error: err
            });
        });
    };
};
const $6153444078ddb7dc$export$c71830b449cacdd = ({ commentId: commentId, experienceTracker: experienceTracker, flags: flags, mode: mode, annotationId: annotationId, handleReopenComment: handleReopenComment, formatMessage: formatMessage, showCommentsPanel: showCommentsPanel, setCurrentView: setCurrentView, isCommentsPanelShown: isCommentsPanelShown, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey })=>{
    flags?.showSuccessCircleFlag({
        id: commentId,
        title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
        isAutoDismiss: true,
        actions: [
            {
                content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                onClick: ()=>{
                    if (!isCommentsPanelShown) {
                        setCurrentlySelectedThreadKey(annotationId);
                        showCommentsPanel({
                            openWithView: (0, $3mVfX.ViewValues).RESOLVED
                        });
                    } else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                    if ((0, $6mKj3.expValEquals)('confluence_comments_scrollto_resolve', 'isEnabled', true)) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                        context: (0, $9FoVw.NavigationContext).PANEL,
                        block: 'center',
                        annotationId: annotationId,
                        commentType: 'INLINE',
                        annotationClicked: true,
                        expectedView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    flags.hideFlag(flags.state.flags[0]?.id);
                }
            },
            {
                content: formatMessage((0, $9CnRS.i18n).undoCTA),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.UNRESOLVE_INLINE_COMMENT_EXPERIENCE),
                        id: commentId,
                        attributes: {
                            mode: mode,
                            framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                            annotationId: annotationId
                        }
                    });
                    handleReopenComment();
                    flags.hideFlag(flags.state.flags[0]?.id);
                }
            }
        ]
    });
};
module.exports["createHandleReopenComment"] = $6153444078ddb7dc$export$ddce50f11b36de55;
module.exports["showResolvedCommentFlag"] = $6153444078ddb7dc$export$c71830b449cacdd;

});

parcelRegister("8wupW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26870287bd8e8ddf$var$CollapsedRepliesContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_x3doia51 _y3gn1h6o _4t3i1pa9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $26870287bd8e8ddf$var$DecorLine = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n7zlia51 _4t3irdoj",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $26870287bd8e8ddf$var$CollapsedRepliesTextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1lry1n0e _t41qmgjw _1r33tlke _1plvvuon _1c5th2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $26870287bd8e8ddf$export$1b7cea81591143c6 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { numCollapsedReplies: numCollapsedReplies, onClick: onClick } = t0;
    let t1;
    if ($[0] !== numCollapsedReplies) {
        t1 = {
            ...(0, $9CnRS.i18n).collapsedRepliesMore,
            values: {
                numCollapsedReplies: numCollapsedReplies
            }
        };
        $[0] = numCollapsedReplies;
        $[1] = t1;
    } else t1 = $[1];
    const message = t1;
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$DecorLine, null);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$DecorLine, null);
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] !== message) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), message);
        $[4] = message;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== onClick || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$CollapsedRepliesContainer, null, t2, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($26870287bd8e8ddf$var$CollapsedRepliesTextContainer, {
            "data-testid": "collapsed-inline-replies",
            onClick: onClick
        }, t4));
        $[6] = onClick;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
module.exports["CollapsedReplies"] = $26870287bd8e8ddf$export$1b7cea81591143c6;

});

parcelRegister("c7FK0", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $1YXTQ = parcelRequire("1YXTQ");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9fae39c0fd447dd4$var$ReopenedMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt412zh _11c8wadc _x3doia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $9fae39c0fd447dd4$export$48d96e04ba74448 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { resolvedUser: resolvedUser, resolvedTime: resolvedTime } = t0;
    let t1;
    if ($[0] !== resolvedTime || $[1] !== resolvedUser) {
        t1 = resolvedUser && resolvedTime ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9fae39c0fd447dd4$var$ReopenedMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "inline-comments-common.reopened.message",
            defaultMessage: "Reopened by {person}",
            values: {
                person: resolvedUser
            }
        }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: resolvedTime
        })) : null;
        $[0] = resolvedTime;
        $[1] = resolvedUser;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ReopenedMessage"] = $9fae39c0fd447dd4$export$48d96e04ba74448;

});

parcelRegister("dhKx6", function(module, exports) {

var $h3RCY = parcelRequire("h3RCY");

const $219365be6e8283d5$export$26ef11a105bd81d = (0, $h3RCY.default);
module.exports["ResolveInlineCommentMutation"] = $219365be6e8283d5$export$26ef11a105bd81d;

});

parcelRegister("h3RCY", function(module, exports) {
/**
 * @generated SignedSource<<a6ada0856c3be004b87e15542188acd3>>
 * @relayHash 7513d6c5923d1609915a8367260c74ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 632c56bba03c212eda7bcb6a40acb5c811be32c9f70880d703b72d84fe6cafdf
const $ffa2a1db328a73be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "resolved"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Literal",
                    "name": "dangling",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "resolved",
                    "variableName": "resolved"
                }
            ],
            "concreteType": "ResolveInlineCommentPayload",
            "kind": "LinkedField",
            "name": "resolveInlineComment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "InlineCommentResolveProperties",
                    "kind": "LinkedField",
                    "name": "resolveProperties",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resolved"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolvedUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isDangling"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolvedFriendlyDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resolvedTime"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ResolveInlineCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ResolveInlineCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7513d6c5923d1609915a8367260c74ea",
            "id": "632c56bba03c212eda7bcb6a40acb5c811be32c9f70880d703b72d84fe6cafdf",
            "metadata": {},
            "name": "ResolveInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ResolveInlineCommentMutation($commentId:ID!,$resolved:Boolean!){resolveInlineComment(commentId:$commentId,resolved:$resolved,dangling:false){status,resolveProperties{resolved,resolvedUser,isDangling,resolvedFriendlyDate,resolvedTime}}}"
        }
    };
}();
$ffa2a1db328a73be$var$node.hash = "9130df4a8889632221ebe5fe5a847d62";
var $ffa2a1db328a73be$export$2e2bcd8739ae039 = $ffa2a1db328a73be$var$node;
module.exports["default"] = $ffa2a1db328a73be$export$2e2bcd8739ae039;

});

parcelRegister("6Ebso", function(module, exports) {

var $bfmeY = parcelRequire("bfmeY");

const $9d5f2b2aa1f9b17f$export$549cff8431cdc668 = (0, $bfmeY.default);
module.exports["DeleteInlineCommentMutation"] = $9d5f2b2aa1f9b17f$export$549cff8431cdc668;

});

parcelRegister("bfmeY", function(module, exports) {
/**
 * @generated SignedSource<<d1b8700b64f74dc73bccc078a2f70e2f>>
 * @relayHash a9d90e15ebce13405ca919353f45763b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aed3d5f7bfb7c2dbcf6552f34205d78e31581555221514979a1f6dd3be14943a
const $b3f7eb06d9ddc8f8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DeleteInlineCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DeleteInlineCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a9d90e15ebce13405ca919353f45763b",
            "id": "aed3d5f7bfb7c2dbcf6552f34205d78e31581555221514979a1f6dd3be14943a",
            "metadata": {},
            "name": "DeleteInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation DeleteInlineCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$b3f7eb06d9ddc8f8$var$node.hash = "e53519cb9cddfbbbedc1b66e8a4b57ee";
var $b3f7eb06d9ddc8f8$export$2e2bcd8739ae039 = $b3f7eb06d9ddc8f8$var$node;
module.exports["default"] = $b3f7eb06d9ddc8f8$export$2e2bcd8739ae039;

});

parcelRegister("4gEXU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $bSvtO = parcelRequire("bSvtO");

function $4ccc472e1abe9fa4$export$b3246a2f66464d01({ onConfirm: onConfirm }) {
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    // This hook enables the new preemptive gate for the editor comment API manager to catch the situation
    // where the user tries to start a draft while there is unsaved content in the editor.
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            if (hasContentChanged) annotationManager.setPreemptiveGate(()=>{
                return new Promise((resolve)=>{
                    showModal((0, $cMvMc.CommentWarningDialog), {
                        onConfirm: ()=>{
                            resetContentChanged();
                            onConfirm();
                            // Allow the draft to be started or the comment viewed.
                            resolve(true);
                        },
                        onCancel: ()=>{
                            // Cancel the start draft or view attempt.
                            resolve(false);
                        },
                        onClose: ()=>{
                            // Just in case the user closes the modal by some other means we need to ensure the
                            // promise is resolved. We do not want to leave the preemptive gate open.
                            resolve(false);
                        }
                    });
                });
            });
            else annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            return ()=>{
                annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            };
        }
    }, [
        hasContentChanged,
        annotationManager,
        showModal,
        resetContentChanged,
        onConfirm
    ]);
}
module.exports["usePreemptiveGate"] = $4ccc472e1abe9fa4$export$b3246a2f66464d01;

});

parcelRegister("8EF7j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a6242f603ec1727a8ab94c75bc410d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64d1f41eb9b7eee3$var$_react = $64d1f41eb9b7eee3$var$_interopRequireDefault((parcelRequire("42omo")));

var $64d1f41eb9b7eee3$var$_baseNew = $64d1f41eb9b7eee3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $64d1f41eb9b7eee3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolMindMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for mind map diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon = (props)=>/*#__PURE__*/ $64d1f41eb9b7eee3$var$_react.default.createElement($64d1f41eb9b7eee3$var$_baseNew.default, Object.assign({
        name: "DiagramSymbolMindMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 13.5h2.5v-2H12zM1.5 9H4V7H1.5zM12 4.5h2.5v-2H12zm4 .125C16 5.385 15.384 6 14.625 6h-2.75c-.76 0-1.375-.616-1.375-1.375V4.25h-1a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h1v-.375c0-.76.616-1.375 1.375-1.375h2.75c.76 0 1.375.616 1.375 1.375v2.25c0 .76-.616 1.375-1.375 1.375h-2.75c-.76 0-1.375-.616-1.375-1.375v-.375h-1a2 2 0 0 1-2-2v-2.5h-2v.375c0 .76-.616 1.375-1.375 1.375h-2.75C.615 10.5 0 9.884 0 9.125v-2.25C0 6.115.616 5.5 1.375 5.5h2.75c.76 0 1.375.616 1.375 1.375v.375h2v-2.5a2 2 0 0 1 2-2h1v-.375c0-.76.616-1.375 1.375-1.375h2.75l.14.007c.694.07 1.235.656 1.235 1.368z"/>`
    }, props));
$64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon.displayName = 'DiagramSymbolMindMapIcon';
var $64d1f41eb9b7eee3$var$_default = module.exports.default = $64d1f41eb9b7eee3$var$DiagramSymbolMindMapIcon;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("2BQQi", function(module, exports) {

var $auRWi = parcelRequire("auRWi");


var $jMyy4 = parcelRequire("jMyy4");

const $513635d9ade3aacb$var$UseInlineHighlightsQuery = (0, $auRWi.default);
const $513635d9ade3aacb$export$7a17e81d6650ad94 = ({ pageId: pageId, shouldFireQuery: shouldFireQuery = true })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($513635d9ade3aacb$var$UseInlineHighlightsQuery, {
        variables: {
            pageId: pageId
        },
        skip: !Boolean(shouldFireQuery)
    });
    let markerRefs = [];
    let markerRefMap = {};
    const comments = data?.comments?.nodes;
    if (comments && Array.isArray(comments)) {
        // We need to create a map that connects markerRefs to commentId, we need commentId to fire analytic event
        // https://github.com/microsoft/TypeScript/issues/17002 - for type casting
        markerRefMap = comments.reduce((inlineRefAccumulator, comment)=>{
            if (!comment) return inlineRefAccumulator;
            const { inlineMarkerRef: inlineMarkerRef } = comment.location;
            // We should always get top-level inline comments, but if this doesn't exist, just return
            if (!inlineMarkerRef) return inlineRefAccumulator;
            inlineRefAccumulator[comment?.id] = inlineMarkerRef;
            comment?.replies?.forEach((reply)=>{
                if (reply) {
                    const { id: replyId } = reply;
                    inlineRefAccumulator[replyId] = inlineMarkerRef;
                }
            });
            return inlineRefAccumulator;
        }, {});
        markerRefs = [
            ...new Set(Object.values(markerRefMap))
        ];
    }
    return {
        markerRefs: markerRefs,
        markerRefMap: markerRefMap,
        loading: loading
    };
};
module.exports["useInlineHighlights"] = $513635d9ade3aacb$export$7a17e81d6650ad94;

});

parcelRegister("auRWi", function(module, exports) {
/**
 * @generated SignedSource<<50c53551550a7a21ac5b3668efbdbabe>>
 * @relayHash 1d98f028d17ad9f621bdfdae3f304d7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d
const $e084fe268cd37421$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v5 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1d98f028d17ad9f621bdfdae3f304d7b",
            "id": "4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d",
            "metadata": {},
            "name": "useInlineHighlightsQuery",
            "operationKind": "query",
            "text": "query useInlineHighlightsQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}},replies{id}}}}"
        }
    };
}();
$e084fe268cd37421$var$node.hash = "2fb3b51eea98e2fd2a940548824e472b";
var $e084fe268cd37421$export$2e2bcd8739ae039 = $e084fe268cd37421$var$node;
module.exports["default"] = $e084fe268cd37421$export$2e2bcd8739ae039;

});

parcelRegister("5YLPl", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $2c444e667b08d230$export$67a466ba61e2b23c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_RENDERER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    timings: [
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'fy23-legacy-tti',
            endMark: 'fy23-legacy-tti'
        }
    ]
});
module.exports["CONTENT_RENDERER_METRIC"] = $2c444e667b08d230$export$67a466ba61e2b23c;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("cFmY8"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("fxWJz"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("cFmY8", function(module, exports) {

let $938b218269ed9e9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $938b218269ed9e9c$var$load("h3ABO"),
    $938b218269ed9e9c$var$load("9GDly"),
    $938b218269ed9e9c$var$load("lg1HU"),
    $938b218269ed9e9c$var$load("7do1E"),
    $938b218269ed9e9c$var$load("77dkW"),
    $938b218269ed9e9c$var$load("3JSgG"),
    $938b218269ed9e9c$var$load("6wr18"),
    $938b218269ed9e9c$var$load("bSSi4"),
    $938b218269ed9e9c$var$load("55w8Y"),
    $938b218269ed9e9c$var$load("2F69B"),
    $938b218269ed9e9c$var$load("99AWA"),
    $938b218269ed9e9c$var$load("2PePB"),
    $938b218269ed9e9c$var$load("lHaTX"),
    $938b218269ed9e9c$var$load("a9w2G"),
    $938b218269ed9e9c$var$load("iGCP8"),
    $938b218269ed9e9c$var$load("4RWFL"),
    $938b218269ed9e9c$var$load("lkOIY"),
    $938b218269ed9e9c$var$load("fPSgL"),
    $938b218269ed9e9c$var$load("8nbmv"),
    $938b218269ed9e9c$var$load("dI1Cd"),
    $938b218269ed9e9c$var$load("jbxHq"),
    $938b218269ed9e9c$var$load("l0dTs"),
    $938b218269ed9e9c$var$load("8YSo7"),
    $938b218269ed9e9c$var$load("4t77a"),
    $938b218269ed9e9c$var$load("9anPW"),
    $938b218269ed9e9c$var$load("421lv"),
    $938b218269ed9e9c$var$load("cyGuT"),
    $938b218269ed9e9c$var$load("ffEVr"),
    $938b218269ed9e9c$var$load("3LP1d"),
    $938b218269ed9e9c$var$load("5Fany"),
    $938b218269ed9e9c$var$load("1cktr"),
    $938b218269ed9e9c$var$load("3Oy4g"),
    $938b218269ed9e9c$var$load("fZt2F"),
    $938b218269ed9e9c$var$load("l1BQC"),
    $938b218269ed9e9c$var$load("jlSF3"),
    $938b218269ed9e9c$var$load("cXoAq"),
    $938b218269ed9e9c$var$load("dP7ao"),
    $938b218269ed9e9c$var$load("hogcU"),
    $938b218269ed9e9c$var$load("31vk5"),
    $938b218269ed9e9c$var$load("4pqtR"),
    $938b218269ed9e9c$var$load("5XqRg"),
    $938b218269ed9e9c$var$load("2uVTT"),
    $938b218269ed9e9c$var$load("fGkaB"),
    $938b218269ed9e9c$var$load("5wC2D"),
    $938b218269ed9e9c$var$load("evYW1"),
    $938b218269ed9e9c$var$load("Wowvf"),
    $938b218269ed9e9c$var$load("5RR9C"),
    $938b218269ed9e9c$var$load("hrqeu"),
    $938b218269ed9e9c$var$load("8ublV"),
    $938b218269ed9e9c$var$load("3DgZV"),
    $938b218269ed9e9c$var$load("9ZB2D"),
    $938b218269ed9e9c$var$load("hhss7"),
    $938b218269ed9e9c$var$load("a8Rqp"),
    $938b218269ed9e9c$var$load("1EWOs"),
    $938b218269ed9e9c$var$load("7EorR"),
    $938b218269ed9e9c$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("fxWJz", function(module, exports) {

let $b5177f7492405cf3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b5177f7492405cf3$var$load("9ZB2D"),
    $b5177f7492405cf3$var$load("6wr18"),
    $b5177f7492405cf3$var$load("j104l"),
    $b5177f7492405cf3$var$load("9OQNK"),
    $b5177f7492405cf3$var$load("1H5IN"),
    $b5177f7492405cf3$var$load("h4Nf7"),
    $b5177f7492405cf3$var$load("ffEVr"),
    $b5177f7492405cf3$var$load("7do1E"),
    $b5177f7492405cf3$var$load("77dkW"),
    $b5177f7492405cf3$var$load("31vk5"),
    $b5177f7492405cf3$var$load("evYW1"),
    $b5177f7492405cf3$var$load("Wowvf"),
    $b5177f7492405cf3$var$load("8ublV"),
    $b5177f7492405cf3$var$load("hhss7"),
    $b5177f7492405cf3$var$load("7EorR"),
    $b5177f7492405cf3$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("ayQVU", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

// editor property is expected to be:
//   1. ""    -> auto conversion will happen
//   2. "v2"  -> explicitly using fabric editor
//   3. "v1"  -> explicitly using tinyMCE editor
// when parsing editor property, if neither of the above data is received,
// then it's an unexpected case and we set it as "unset" for analytics.
function $0e83f72969672585$var$parseEditorProperty(value) {
    if (!value) return '';
    if (value?.includes('v2')) return 'v2';
    if (value?.includes('v1')) return 'v1';
    return 'unset';
}
function $0e83f72969672585$export$a53517c120ec9f4(content) {
    const contentProperties = content?.properties?.nodes;
    const editorInfo = contentProperties?.filter((p)=>p?.key === 'editor');
    const editorPropertieValueRaw = editorInfo?.[0]?.value;
    const editorProperty = $0e83f72969672585$var$parseEditorProperty(editorPropertieValueRaw);
    if (content && 'metadata' in content && content?.metadata?.frontend && 'fabricEditorSupported' in content.metadata.frontend) return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: content?.metadata?.frontend?.fabricEditorSupported,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!content?.metadata?.frontend?.fabricEditorSupported && // For pages migrated from DC, with editor property not set, it's easy,
        // they'll always be auto-converted. We explicitly set the editor property
        // to v1 when reverting back to TinyMCE.
        (editorProperty === '' || // For pages created in cloud, with editor property set to v1, we only want to show
        // the auto-conversion settings when it is initially converted to fabric editor.
        // This means the editor property is still set to TinyMCE (v1) but the page is Fabric Editor.
        editorProperty === 'v1' && content?.body?.dynamic?.representation === 'atlas_doc_format') : undefined
    };
    return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: null,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? false : undefined
    };
}
module.exports["getAutoConvertionInfo"] = $0e83f72969672585$export$a53517c120ec9f4;

});

parcelRegister("1ITQ3", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $a4TK8 = parcelRequire("a4TK8");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $336551b5acc450de$export$e863f5b50b03c8cc = (skipQuery = false)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const VIEWPORT_SIZE_KEY = `${(0, $7Ndnw.FORGE_MODULE_XEN_MACRO)}:viewportSizes:${contentId}`;
    const filteredExtensions = window.__SSR_FORGE_EXTENSIONS__?.[VIEWPORT_SIZE_KEY]?.extensions ?? $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES;
    // Technically here cached value can have length of 0.
    // In this case, we don't want to skip the query as we have no way to tell whether its from cache or just default value.
    const hasCachedValue = filteredExtensions.length > 0;
    const { extensions: extensions, loading: loading, error: error } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO),
        skipQuery: skipQuery || hasCachedValue
    });
    const prevExtensionViewportSizes = (0, $42omo.useRef)(filteredExtensions);
    if (loading || error || !extensions) return filteredExtensions;
    const nextExtensionViewportSizes = extensions.map(({ id: id, properties: properties })=>properties?.viewportSize ? {
            extensionId: id,
            viewportSize: properties.viewportSize
        } : undefined).filter(Boolean);
    if (prevExtensionViewportSizes.current.length !== nextExtensionViewportSizes.length || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevExtensionViewportSizes.current, nextExtensionViewportSizes)) {
        prevExtensionViewportSizes.current = nextExtensionViewportSizes;
        // Write to window object to cache the viewport sizes.
        if (window.__SSR_FORGE_EXTENSIONS__) window.__SSR_FORGE_EXTENSIONS__ = {
            ...window.__SSR_FORGE_EXTENSIONS__,
            [VIEWPORT_SIZE_KEY]: {
                extensions: nextExtensionViewportSizes
            }
        };
    }
    return prevExtensionViewportSizes.current;
};
module.exports["useExtensionViewportSizes"] = $336551b5acc450de$export$e863f5b50b03c8cc;

});

parcelRegister("5wDnm", function(module, exports) {
/**
 * Hook to check whether the Rovo Insights feature is available for the current user.
 */ 
var $16lEl = parcelRequire("16lEl");


var $9eLw5 = parcelRequire("9eLw5");


var $h26dv = parcelRequire("h26dv");

const $fe26d6935a9919e4$export$d191a72e03ff3705 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled })=>{
    const { data: data, isFetching: isFetching } = (0, $9eLw5.useQuery)({
        queryKey: [
            'insightsStatus'
        ],
        enabled: enabled,
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).FETCH_INSIGHTS_STATUS,
                name: (0, $16lEl.ExperienceName).FETCH_INSIGHTS_STATUS
            });
            try {
                const response = await assistanceService.getInsightsStatus();
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_INSIGHTS_STATUS
                });
                return response;
            } catch (error) {
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).FETCH_INSIGHTS_STATUS,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
        }
    });
    return {
        isInsightsAvailable: Boolean(data?.insights_available),
        isLoading: isFetching && data === null
    };
});
module.exports["useInsightsStatus"] = $fe26d6935a9919e4$export$d191a72e03ff3705;

});

parcelRegister("efXed", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $02aebea47caa4c41$export$d158fa15757a1890 = /*#__PURE__*/ (0, $42omo.createContext)(false);
function $02aebea47caa4c41$export$abfcaeeca4ae7a55() {
    return (0, $42omo.useContext)($02aebea47caa4c41$export$d158fa15757a1890);
}
module.exports["HasCustomThemeContext"] = $02aebea47caa4c41$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $02aebea47caa4c41$export$abfcaeeca4ae7a55;

});

parcelRegister("lcVz9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

function $6b6d58426e4ff3f5$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $6b6d58426e4ff3f5$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $6b6d58426e4ff3f5$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $dh538.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $6b6d58426e4ff3f5$export$2e2bcd8739ae039 = $6b6d58426e4ff3f5$var$IconRenderer;
module.exports["default"] = $6b6d58426e4ff3f5$export$2e2bcd8739ae039;

});

parcelRegister("i63G2", function(module, exports) {
/* themed-pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $4jOXe = parcelRequire("4jOXe");

const $c0a568cbd64db8db$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $c0a568cbd64db8db$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $c0a568cbd64db8db$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
const $c0a568cbd64db8db$export$66240319f1f78d74 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ...(0, $4jOXe.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($c0a568cbd64db8db$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $c0a568cbd64db8db$var$styles.rootT26Shape, $c0a568cbd64db8db$var$shapeStyles[shape], hasBorder && $c0a568cbd64db8db$var$styles.border, $c0a568cbd64db8db$var$appearanceStyles[appearance], isSelected && $c0a568cbd64db8db$var$styles.selected, isDisabled && $c0a568cbd64db8db$var$styles.disabled),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $c0a568cbd64db8db$export$66240319f1f78d74;

});

parcelRegister("4jOXe", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $9048d266fac6ebf2$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $9048d266fac6ebf2$export$e4c95325a21f9785;

});

parcelRegister("3BPrE", function(module, exports) {
var $e3661bd3089bf51c$export$7309710dd8a888d9 = /*#__PURE__*/ function(InlineCommentPubSubEvents) {
    InlineCommentPubSubEvents["InlineCommentCreated"] = "avi:confluence:created:inline_comment";
    InlineCommentPubSubEvents["RendererInlineCommentCreated"] = "avi:confluence:created:renderer_inline_comment";
    InlineCommentPubSubEvents["EditorInlineCommentCreated"] = "avi:confluence:created:editor_inline_comment";
    InlineCommentPubSubEvents["InlineCommentDeleted"] = "avi:confluence:deleted:inline_comment";
    InlineCommentPubSubEvents["InlineCommentResolved"] = "avi:confluence:resolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUnresolved"] = "avi:confluence:unresolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUpdated"] = "avi:confluence:updated:inline_comment";
    InlineCommentPubSubEvents["InlineCommentReattached"] = "avi:confluence:reattach:inline_comment";
    return InlineCommentPubSubEvents;
}({});
var $e3661bd3089bf51c$export$d05a35896d8f557d = /*#__PURE__*/ function(InlineCommentSubscriptionEvents) {
    InlineCommentSubscriptionEvents["InlineCommentCreated"] = "inlineCommentCreated";
    InlineCommentSubscriptionEvents["RendererInlineCommentCreated"] = "rendererInlineCommentCreated";
    InlineCommentSubscriptionEvents["EditorInlineCommentCreated"] = "editorInlineCommentCreated";
    InlineCommentSubscriptionEvents["InlineCommentDeleted"] = "inlineCommentDeleted";
    InlineCommentSubscriptionEvents["InlineCommentResolved"] = "inlineCommentResolved";
    InlineCommentSubscriptionEvents["InlineCommentUnresolved"] = "inlineCommentUnresolved";
    InlineCommentSubscriptionEvents["InlineCommentUpdated"] = "inlineCommentUpdated";
    InlineCommentSubscriptionEvents["InlineCommentReattached"] = "inlineCommentReattached";
    return InlineCommentSubscriptionEvents;
}({});
var $e3661bd3089bf51c$export$5d941a2346cc8f6a = /*#__PURE__*/ function(PagePubSubEvents) {
    PagePubSubEvents["PagePublished"] = "avi:confluence:publish:page";
    PagePubSubEvents["BlogPublished"] = "avi:confluence:publish:blogpost";
    return PagePubSubEvents;
}({});
var $e3661bd3089bf51c$export$15c104b3df413bde = /*#__PURE__*/ function(PageSubscriptionEvents) {
    PageSubscriptionEvents["PageUpdated"] = "pageUpdated";
    return PageSubscriptionEvents;
}({});
module.exports["InlineCommentPubSubEvents"] = $e3661bd3089bf51c$export$7309710dd8a888d9;
module.exports["InlineCommentSubscriptionEvents"] = $e3661bd3089bf51c$export$d05a35896d8f557d;
module.exports["PagePubSubEvents"] = $e3661bd3089bf51c$export$5d941a2346cc8f6a;
module.exports["PageSubscriptionEvents"] = $e3661bd3089bf51c$export$15c104b3df413bde;

});

parcelRegister("03oqz", function(module, exports) {

var $8i27m = parcelRequire("8i27m");


var $3B9cR = parcelRequire("3B9cR");


var $1C8XP = parcelRequire("1C8XP");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");

const $895e8bda1c5e4d1e$export$15e2805385ec0eed = (contentId, markerRef)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return (0, $c0rhi.queryInterop)({
        query: (0, $3B9cR.InlineCommentQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            annotationId: markerRef,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }
    });
    else return (0, $c0rhi.queryInterop)({
        query: (0, $1C8XP.ActiveInlineCommentsQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            inlineMarkerRefList: [
                markerRef
            ],
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }
    });
};
const $895e8bda1c5e4d1e$export$90e382997b4dc102 = async (contentId, markerRef)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        const commentThreadDataResult = await (0, $c0rhi.queryInterop)({
            query: (0, $3B9cR.InlineCommentQuery),
            fetchPolicy: 'network-only',
            variables: {
                pageId: contentId,
                annotationId: markerRef,
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }
        });
        return commentThreadDataResult.data;
    } else {
        const commentThreadDataResult = await (0, $c0rhi.queryInterop)({
            query: (0, $1C8XP.ActiveInlineCommentsQuery),
            fetchPolicy: 'network-only',
            variables: {
                pageId: contentId,
                inlineMarkerRefList: [
                    markerRef
                ],
                contentStatus: [
                    'DRAFT',
                    'CURRENT'
                ]
            }
        });
        return commentThreadDataResult.data;
    }
};
const $895e8bda1c5e4d1e$export$e136ff0cd91112e0 = async ({ contentId: contentId, markerRef: markerRef, addNewCommentThreads: addNewCommentThreads })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) addNewCommentThreads && addNewCommentThreads({
        inline: {
            [markerRef]: {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false,
                type: (0, $8i27m.CommentType).INLINE
            }
        },
        general: {}
    });
};
const $895e8bda1c5e4d1e$export$120fd6a8527dd6bd = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, addReplyToCommentThread: addReplyToCommentThread, commentType: commentType, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const replies = comment?.replies;
    const reply = replies?.filter((r)=>r?.id === commentId)[0];
    if (reply) {
        // Update storedCommentData if it exists by adding the new reply
        if (storedCommentData && setStoredCommentData) {
            const updatedCommentData = {
                ...storedCommentData,
                replies: [
                    ...storedCommentData.replies || [],
                    reply
                ]
            };
            // Only update if inlineMarkerRef matches between stored and fetched comment
            if (storedCommentData.location?.inlineMarkerRef === comment?.location?.inlineMarkerRef) setStoredCommentData(updatedCommentData);
        }
        addReplyToCommentThread && addReplyToCommentThread(markerRef, {
            ...reply
        }, commentType);
    }
};
const $895e8bda1c5e4d1e$export$7652b163bd2668c5 = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, updateCommentBody: updateCommentBody })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const targetComment = comment?.id === commentId ? comment : comment?.replies?.find((r)=>r?.id === commentId);
    if (targetComment && updateCommentBody) updateCommentBody(commentId, markerRef, targetComment.body.value, (0, $8i27m.CommentType).INLINE, targetComment.version.by?.displayName);
};
module.exports["refreshCommentThread"] = $895e8bda1c5e4d1e$export$15e2805385ec0eed;
module.exports["handleAddNewCommentThread"] = $895e8bda1c5e4d1e$export$e136ff0cd91112e0;
module.exports["handleAddedReplyInCommentThread"] = $895e8bda1c5e4d1e$export$120fd6a8527dd6bd;
module.exports["handleEditedComment"] = $895e8bda1c5e4d1e$export$7652b163bd2668c5;

});

parcelRegister("62fWd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jIiuI = parcelRequire("jIiuI");

var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");


var $6fRDv = parcelRequire("6fRDv");


var $dh538 = parcelRequire("dh538");

let $3c9dbf4421667f34$var$postRobotOn = null;

// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') $3c9dbf4421667f34$var$postRobotOn = (parcelRequire("eLUTa")).postRobotOn;
const $3c9dbf4421667f34$export$64f0f7e9be5f8ff = ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children, localId: localId, isCustomConfig: isCustomConfig })=>{
    // Listen for analytics events from child iframes (FAUS) - Confluence only
    (0, $42omo.useEffect)(()=>{
        if (product === 'confluence' && localId && $3c9dbf4421667f34$var$postRobotOn && !isCustomConfig && (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus')) try {
            const allowedDomain = (0, $6fRDv.getProductDomain)();
            const listener = $3c9dbf4421667f34$var$postRobotOn(`analyticsFromEmbeddedFAUS_${localId}`, {
                domain: allowedDomain
            }, async ({ data: data })=>{
                // Forward to the product's analytics client using the existing sendEvent utility
                (0, $3Spjc.sendEvent)(analyticsWebClient)(data);
            });
            return ()=>listener.cancel();
        } catch  {
            // eslint-disable-next-line no-console
            console.log('Failed to set up analytics listener');
        }
    }, [
        analyticsWebClient,
        localId,
        isCustomConfig,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jIiuI.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5U2YR.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Spjc.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $3c9dbf4421667f34$export$64f0f7e9be5f8ff;

});

parcelRegister("6fRDv", function(module, exports) {
/**
 * Gets the target window for forwarding messages from FAUS to the product.
 *
 * Current architecture:
 * - Product (Confluence) → Bodied Macro → FAUS → Embedded Macro
 * - FAUS is nested 2 levels deep, so window.parent.parent is the product
 *
 * Future: This can be updated to support multiple nesting levels by checking
 * ancestorOrigins.length or using a more dynamic approach.
 *
 * @returns The product window, or null if not in a nested context
 */ function $1ed0c4b4d8f6d1ca$export$532d4b4b6d3d2c95() {
    // This would need to be changed if we want to support multiple nesting levels
    const targetWindow = window.parent?.parent;
    // Ensure we have a valid target that's not the current window
    if (targetWindow && targetWindow !== window) return targetWindow;
    return null;
}
function $1ed0c4b4d8f6d1ca$export$f0bf9a3931c6275e() {
    return `${window.location.protocol}//${window.location.hostname}`;
}
module.exports["getProductDomain"] = $1ed0c4b4d8f6d1ca$export$f0bf9a3931c6275e;

});

parcelRegister("kmWRd", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3, width: t4 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    const width = t4 === undefined ? 320 : t4;
    let t5;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop || $[6] !== width) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: `${width}px`,
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = width;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("6otn0", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $4a7bc43a0955ef89$var$ch2 = {};
var $4a7bc43a0955ef89$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($4a7bc43a0955ef89$var$ch2[id] || ($4a7bc43a0955ef89$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $4a7bc43a0955ef89$var$u8 = Uint8Array, $4a7bc43a0955ef89$var$u16 = Uint16Array, $4a7bc43a0955ef89$var$i32 = Int32Array;
// fixed length extra bits
var $4a7bc43a0955ef89$var$fleb = new $4a7bc43a0955ef89$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $4a7bc43a0955ef89$var$fdeb = new $4a7bc43a0955ef89$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $4a7bc43a0955ef89$var$clim = new $4a7bc43a0955ef89$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $4a7bc43a0955ef89$var$freb = function(eb, start) {
    var b = new $4a7bc43a0955ef89$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $4a7bc43a0955ef89$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $4a7bc43a0955ef89$var$_a = $4a7bc43a0955ef89$var$freb($4a7bc43a0955ef89$var$fleb, 2), $4a7bc43a0955ef89$var$fl = $4a7bc43a0955ef89$var$_a.b, $4a7bc43a0955ef89$var$revfl = $4a7bc43a0955ef89$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$4a7bc43a0955ef89$var$fl[28] = 258, $4a7bc43a0955ef89$var$revfl[258] = 28;
var $4a7bc43a0955ef89$var$_b = $4a7bc43a0955ef89$var$freb($4a7bc43a0955ef89$var$fdeb, 0), $4a7bc43a0955ef89$var$fd = $4a7bc43a0955ef89$var$_b.b, $4a7bc43a0955ef89$var$revfd = $4a7bc43a0955ef89$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $4a7bc43a0955ef89$var$rev = new $4a7bc43a0955ef89$var$u16(32768);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 32768; ++$4a7bc43a0955ef89$var$i){
    // reverse table algorithm from SO
    var $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$i & 0xAAAA) >> 1 | ($4a7bc43a0955ef89$var$i & 0x5555) << 1;
    $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$x & 0xCCCC) >> 2 | ($4a7bc43a0955ef89$var$x & 0x3333) << 2;
    $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$x & 0xF0F0) >> 4 | ($4a7bc43a0955ef89$var$x & 0x0F0F) << 4;
    $4a7bc43a0955ef89$var$rev[$4a7bc43a0955ef89$var$i] = (($4a7bc43a0955ef89$var$x & 0xFF00) >> 8 | ($4a7bc43a0955ef89$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $4a7bc43a0955ef89$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $4a7bc43a0955ef89$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $4a7bc43a0955ef89$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $4a7bc43a0955ef89$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$4a7bc43a0955ef89$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $4a7bc43a0955ef89$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $4a7bc43a0955ef89$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $4a7bc43a0955ef89$var$flt = new $4a7bc43a0955ef89$var$u8(288);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 144; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 8;
for(var $4a7bc43a0955ef89$var$i = 144; $4a7bc43a0955ef89$var$i < 256; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 9;
for(var $4a7bc43a0955ef89$var$i = 256; $4a7bc43a0955ef89$var$i < 280; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 7;
for(var $4a7bc43a0955ef89$var$i = 280; $4a7bc43a0955ef89$var$i < 288; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 8;
// fixed distance tree
var $4a7bc43a0955ef89$var$fdt = new $4a7bc43a0955ef89$var$u8(32);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 32; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$fdt[$4a7bc43a0955ef89$var$i] = 5;
// fixed length map
var $4a7bc43a0955ef89$var$flm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$flt, 9, 0), $4a7bc43a0955ef89$var$flrm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$flt, 9, 1);
// fixed distance map
var $4a7bc43a0955ef89$var$fdm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$fdt, 5, 0), $4a7bc43a0955ef89$var$fdrm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$fdt, 5, 1);
// find max of array
var $4a7bc43a0955ef89$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $4a7bc43a0955ef89$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $4a7bc43a0955ef89$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $4a7bc43a0955ef89$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $4a7bc43a0955ef89$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $4a7bc43a0955ef89$var$u8(v.subarray(s, e));
};
var $4a7bc43a0955ef89$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $4a7bc43a0955ef89$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $4a7bc43a0955ef89$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $4a7bc43a0955ef89$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $4a7bc43a0955ef89$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $4a7bc43a0955ef89$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $4a7bc43a0955ef89$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $4a7bc43a0955ef89$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $4a7bc43a0955ef89$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $4a7bc43a0955ef89$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $4a7bc43a0955ef89$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $4a7bc43a0955ef89$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $4a7bc43a0955ef89$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $4a7bc43a0955ef89$var$flrm, dm = $4a7bc43a0955ef89$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $4a7bc43a0955ef89$var$bits(dat, pos, 31) + 257, hcLen = $4a7bc43a0955ef89$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $4a7bc43a0955ef89$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $4a7bc43a0955ef89$var$u8(tl);
                // code length tree
                var clt = new $4a7bc43a0955ef89$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$4a7bc43a0955ef89$var$clim[i]] = $4a7bc43a0955ef89$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $4a7bc43a0955ef89$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $4a7bc43a0955ef89$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$4a7bc43a0955ef89$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $4a7bc43a0955ef89$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $4a7bc43a0955ef89$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $4a7bc43a0955ef89$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $4a7bc43a0955ef89$var$max(lt);
                // max dist bits
                dbt = $4a7bc43a0955ef89$var$max(dt);
                lm = $4a7bc43a0955ef89$var$hMap(lt, lbt, 1);
                dm = $4a7bc43a0955ef89$var$hMap(dt, dbt, 1);
            } else $4a7bc43a0955ef89$var$err(1);
            if (pos > tbts) {
                if (noSt) $4a7bc43a0955ef89$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$4a7bc43a0955ef89$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $4a7bc43a0955ef89$var$err(0);
                break;
            }
            if (!c) $4a7bc43a0955ef89$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $4a7bc43a0955ef89$var$fleb[i];
                    add = $4a7bc43a0955ef89$var$bits(dat, pos, (1 << b) - 1) + $4a7bc43a0955ef89$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$4a7bc43a0955ef89$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $4a7bc43a0955ef89$var$err(3);
                pos += d & 15;
                var dt = $4a7bc43a0955ef89$var$fd[dsym];
                if (dsym > 3) {
                    var b = $4a7bc43a0955ef89$var$fdeb[dsym];
                    dt += $4a7bc43a0955ef89$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $4a7bc43a0955ef89$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $4a7bc43a0955ef89$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $4a7bc43a0955ef89$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $4a7bc43a0955ef89$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $4a7bc43a0955ef89$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $4a7bc43a0955ef89$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $4a7bc43a0955ef89$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $4a7bc43a0955ef89$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $4a7bc43a0955ef89$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $4a7bc43a0955ef89$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $4a7bc43a0955ef89$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $4a7bc43a0955ef89$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($4a7bc43a0955ef89$var$ln(n.l, l, d + 1), $4a7bc43a0955ef89$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $4a7bc43a0955ef89$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $4a7bc43a0955ef89$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $4a7bc43a0955ef89$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $4a7bc43a0955ef89$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $4a7bc43a0955ef89$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $4a7bc43a0955ef89$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $4a7bc43a0955ef89$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $4a7bc43a0955ef89$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $4a7bc43a0955ef89$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $4a7bc43a0955ef89$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $4a7bc43a0955ef89$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $4a7bc43a0955ef89$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $4a7bc43a0955ef89$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$4a7bc43a0955ef89$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $4a7bc43a0955ef89$var$clen(lf, $4a7bc43a0955ef89$var$flt) + $4a7bc43a0955ef89$var$clen(df, $4a7bc43a0955ef89$var$fdt) + eb;
    var dtlen = $4a7bc43a0955ef89$var$clen(lf, dlt) + $4a7bc43a0955ef89$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $4a7bc43a0955ef89$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $4a7bc43a0955ef89$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $4a7bc43a0955ef89$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $4a7bc43a0955ef89$var$hMap(dlt, mlb, 0), ll = dlt, dm = $4a7bc43a0955ef89$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $4a7bc43a0955ef89$var$hMap(lct, mlcb, 0);
        $4a7bc43a0955ef89$var$wbits(out, p, nlc - 257);
        $4a7bc43a0955ef89$var$wbits(out, p + 5, ndc - 1);
        $4a7bc43a0955ef89$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$4a7bc43a0955ef89$var$wbits(out, p + 3 * i, lct[$4a7bc43a0955ef89$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $4a7bc43a0955ef89$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $4a7bc43a0955ef89$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $4a7bc43a0955ef89$var$flm, ll = $4a7bc43a0955ef89$var$flt, dm = $4a7bc43a0955ef89$var$fdm, dl = $4a7bc43a0955ef89$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $4a7bc43a0955ef89$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $4a7bc43a0955ef89$var$wbits(out, p, sym >> 23 & 31), p += $4a7bc43a0955ef89$var$fleb[len];
            var dst = sym & 31;
            $4a7bc43a0955ef89$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $4a7bc43a0955ef89$var$wbits16(out, p, sym >> 5 & 8191), p += $4a7bc43a0955ef89$var$fdeb[dst];
        } else $4a7bc43a0955ef89$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $4a7bc43a0955ef89$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $4a7bc43a0955ef89$var$deo = /*#__PURE__*/ new $4a7bc43a0955ef89$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $4a7bc43a0955ef89$var$et = /*#__PURE__*/ new $4a7bc43a0955ef89$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $4a7bc43a0955ef89$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $4a7bc43a0955ef89$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $4a7bc43a0955ef89$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $4a7bc43a0955ef89$var$u16(32768), head = st.h || new $4a7bc43a0955ef89$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $4a7bc43a0955ef89$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $4a7bc43a0955ef89$var$u16(288), df = new $4a7bc43a0955ef89$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $4a7bc43a0955ef89$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $4a7bc43a0955ef89$var$revfl[l] << 18 | $4a7bc43a0955ef89$var$revfd[d];
                    var lin = $4a7bc43a0955ef89$var$revfl[l] & 31, din = $4a7bc43a0955ef89$var$revfd[d] & 31;
                    eb += $4a7bc43a0955ef89$var$fleb[lin] + $4a7bc43a0955ef89$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $4a7bc43a0955ef89$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $4a7bc43a0955ef89$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $4a7bc43a0955ef89$var$slc(o, 0, pre + $4a7bc43a0955ef89$var$shft(pos) + post);
};
// CRC32 table
var $4a7bc43a0955ef89$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $4a7bc43a0955ef89$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $4a7bc43a0955ef89$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $4a7bc43a0955ef89$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $4a7bc43a0955ef89$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $4a7bc43a0955ef89$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $4a7bc43a0955ef89$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $4a7bc43a0955ef89$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $4a7bc43a0955ef89$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $4a7bc43a0955ef89$var$ch = [];
// clone bufs
var $4a7bc43a0955ef89$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $4a7bc43a0955ef89$var$wrkr = function(fns, init, id, cb) {
    if (!$4a7bc43a0955ef89$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $4a7bc43a0955ef89$var$wcln(fns[i], fnStr, td_1);
        $4a7bc43a0955ef89$var$ch[id] = {
            c: $4a7bc43a0955ef89$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $4a7bc43a0955ef89$var$mrg({}, $4a7bc43a0955ef89$var$ch[id].e);
    return $4a7bc43a0955ef89$var$wk($4a7bc43a0955ef89$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $4a7bc43a0955ef89$var$cbfs(td), cb);
};
// base async inflate fn
var $4a7bc43a0955ef89$var$bInflt = function() {
    return [
        $4a7bc43a0955ef89$var$u8,
        $4a7bc43a0955ef89$var$u16,
        $4a7bc43a0955ef89$var$i32,
        $4a7bc43a0955ef89$var$fleb,
        $4a7bc43a0955ef89$var$fdeb,
        $4a7bc43a0955ef89$var$clim,
        $4a7bc43a0955ef89$var$fl,
        $4a7bc43a0955ef89$var$fd,
        $4a7bc43a0955ef89$var$flrm,
        $4a7bc43a0955ef89$var$fdrm,
        $4a7bc43a0955ef89$var$rev,
        $4a7bc43a0955ef89$var$ec,
        $4a7bc43a0955ef89$var$hMap,
        $4a7bc43a0955ef89$var$max,
        $4a7bc43a0955ef89$var$bits,
        $4a7bc43a0955ef89$var$bits16,
        $4a7bc43a0955ef89$var$shft,
        $4a7bc43a0955ef89$var$slc,
        $4a7bc43a0955ef89$var$err,
        $4a7bc43a0955ef89$var$inflt,
        $4a7bc43a0955ef89$export$90366d8b308ba94a,
        $4a7bc43a0955ef89$var$pbf,
        $4a7bc43a0955ef89$var$gopt
    ];
};
var $4a7bc43a0955ef89$var$bDflt = function() {
    return [
        $4a7bc43a0955ef89$var$u8,
        $4a7bc43a0955ef89$var$u16,
        $4a7bc43a0955ef89$var$i32,
        $4a7bc43a0955ef89$var$fleb,
        $4a7bc43a0955ef89$var$fdeb,
        $4a7bc43a0955ef89$var$clim,
        $4a7bc43a0955ef89$var$revfl,
        $4a7bc43a0955ef89$var$revfd,
        $4a7bc43a0955ef89$var$flm,
        $4a7bc43a0955ef89$var$flt,
        $4a7bc43a0955ef89$var$fdm,
        $4a7bc43a0955ef89$var$fdt,
        $4a7bc43a0955ef89$var$rev,
        $4a7bc43a0955ef89$var$deo,
        $4a7bc43a0955ef89$var$et,
        $4a7bc43a0955ef89$var$hMap,
        $4a7bc43a0955ef89$var$wbits,
        $4a7bc43a0955ef89$var$wbits16,
        $4a7bc43a0955ef89$var$hTree,
        $4a7bc43a0955ef89$var$ln,
        $4a7bc43a0955ef89$var$lc,
        $4a7bc43a0955ef89$var$clen,
        $4a7bc43a0955ef89$var$wfblk,
        $4a7bc43a0955ef89$var$wblk,
        $4a7bc43a0955ef89$var$shft,
        $4a7bc43a0955ef89$var$slc,
        $4a7bc43a0955ef89$var$dflt,
        $4a7bc43a0955ef89$var$dopt,
        $4a7bc43a0955ef89$export$21533ff51b8a0b4a,
        $4a7bc43a0955ef89$var$pbf
    ];
};
// gzip extra
var $4a7bc43a0955ef89$var$gze = function() {
    return [
        $4a7bc43a0955ef89$var$gzh,
        $4a7bc43a0955ef89$var$gzhl,
        $4a7bc43a0955ef89$var$wbytes,
        $4a7bc43a0955ef89$var$crc,
        $4a7bc43a0955ef89$var$crct
    ];
};
// gunzip extra
var $4a7bc43a0955ef89$var$guze = function() {
    return [
        $4a7bc43a0955ef89$var$gzs,
        $4a7bc43a0955ef89$var$gzl
    ];
};
// zlib extra
var $4a7bc43a0955ef89$var$zle = function() {
    return [
        $4a7bc43a0955ef89$var$zlh,
        $4a7bc43a0955ef89$var$wbytes,
        $4a7bc43a0955ef89$var$adler
    ];
};
// unzlib extra
var $4a7bc43a0955ef89$var$zule = function() {
    return [
        $4a7bc43a0955ef89$var$zls
    ];
};
// post buf
var $4a7bc43a0955ef89$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $4a7bc43a0955ef89$var$gopt = function(o) {
    return o && {
        out: o.size && new $4a7bc43a0955ef89$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $4a7bc43a0955ef89$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $4a7bc43a0955ef89$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $4a7bc43a0955ef89$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $4a7bc43a0955ef89$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $4a7bc43a0955ef89$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $4a7bc43a0955ef89$var$err(5);
        if (t) strm.ondata($4a7bc43a0955ef89$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $4a7bc43a0955ef89$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $4a7bc43a0955ef89$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $4a7bc43a0955ef89$var$b8 = function(d, b) {
    return $4a7bc43a0955ef89$var$b4(d, b) + $4a7bc43a0955ef89$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $4a7bc43a0955ef89$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $4a7bc43a0955ef89$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $4a7bc43a0955ef89$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $4a7bc43a0955ef89$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $4a7bc43a0955ef89$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $4a7bc43a0955ef89$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $4a7bc43a0955ef89$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $4a7bc43a0955ef89$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $4a7bc43a0955ef89$var$adler();
        h.p(o.dictionary);
        $4a7bc43a0955ef89$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $4a7bc43a0955ef89$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $4a7bc43a0955ef89$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $4a7bc43a0955ef89$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $4a7bc43a0955ef89$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($4a7bc43a0955ef89$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.s.l) $4a7bc43a0955ef89$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $4a7bc43a0955ef89$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.s.l) $4a7bc43a0955ef89$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $4a7bc43a0955ef89$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$ae157b6234afe138(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $4a7bc43a0955ef89$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $4a7bc43a0955ef89$export$21533ff51b8a0b4a(data, opts) {
    return $4a7bc43a0955ef89$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $4a7bc43a0955ef89$var$u8(32768);
        this.p = new $4a7bc43a0955ef89$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.d) $4a7bc43a0955ef89$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $4a7bc43a0955ef89$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $4a7bc43a0955ef89$var$inflt(this.p, this.s, this.o);
        this.ondata($4a7bc43a0955ef89$var$slc(dt, bts, this.s.b), this.d);
        this.o = $4a7bc43a0955ef89$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $4a7bc43a0955ef89$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $4a7bc43a0955ef89$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$90366d8b308ba94a(ev.data[0], $4a7bc43a0955ef89$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $4a7bc43a0955ef89$export$90366d8b308ba94a(data, opts) {
    return $4a7bc43a0955ef89$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $4a7bc43a0955ef89$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $4a7bc43a0955ef89$var$crc();
        this.l = 0;
        this.v = 1;
        $4a7bc43a0955ef89$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $4a7bc43a0955ef89$var$dopt(c, this.o, this.v && $4a7bc43a0955ef89$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $4a7bc43a0955ef89$var$gzh(raw, this.o), this.v = 0;
        if (f) $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 8, this.c.d()), $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $4a7bc43a0955ef89$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            $4a7bc43a0955ef89$var$gze,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138,
                    $4a7bc43a0955ef89$export$8e4b66d280bf8342
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$8e4b66d280bf8342(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $4a7bc43a0955ef89$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt,
        $4a7bc43a0955ef89$var$gze,
        function() {
            return [
                $4a7bc43a0955ef89$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $4a7bc43a0955ef89$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $4a7bc43a0955ef89$var$crc(), l = data.length;
    c.p(data);
    var d = $4a7bc43a0955ef89$var$dopt(data, opts, $4a7bc43a0955ef89$var$gzhl(opts), 8), s = d.length;
    return $4a7bc43a0955ef89$var$gzh(d, opts), $4a7bc43a0955ef89$var$wbytes(d, s - 8, c.d()), $4a7bc43a0955ef89$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $4a7bc43a0955ef89$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $4a7bc43a0955ef89$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $4a7bc43a0955ef89$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $4a7bc43a0955ef89$var$u8(0);
            this.push(new $4a7bc43a0955ef89$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $4a7bc43a0955ef89$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            $4a7bc43a0955ef89$var$guze,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c,
                    $4a7bc43a0955ef89$export$4cb607de6db70415
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $4a7bc43a0955ef89$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt,
        $4a7bc43a0955ef89$var$guze,
        function() {
            return [
                $4a7bc43a0955ef89$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $4a7bc43a0955ef89$export$c80456f7aaba691c(data, opts) {
    var st = $4a7bc43a0955ef89$var$gzs(data);
    if (st + 8 > data.length) $4a7bc43a0955ef89$var$err(6, 'invalid gzip data');
    return $4a7bc43a0955ef89$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $4a7bc43a0955ef89$var$u8($4a7bc43a0955ef89$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $4a7bc43a0955ef89$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $4a7bc43a0955ef89$var$adler();
        this.v = 1;
        $4a7bc43a0955ef89$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $4a7bc43a0955ef89$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $4a7bc43a0955ef89$var$zlh(raw, this.o), this.v = 0;
        if (f) $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $4a7bc43a0955ef89$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            $4a7bc43a0955ef89$var$zle,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138,
                    $4a7bc43a0955ef89$export$4187ccf2467013b9
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$4187ccf2467013b9(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $4a7bc43a0955ef89$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt,
        $4a7bc43a0955ef89$var$zle,
        function() {
            return [
                $4a7bc43a0955ef89$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $4a7bc43a0955ef89$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $4a7bc43a0955ef89$var$adler();
    a.p(data);
    var d = $4a7bc43a0955ef89$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $4a7bc43a0955ef89$var$zlh(d, opts), $4a7bc43a0955ef89$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $4a7bc43a0955ef89$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($4a7bc43a0955ef89$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $4a7bc43a0955ef89$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            $4a7bc43a0955ef89$var$zule,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c,
                    $4a7bc43a0955ef89$export$af2424f875ff1b17
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$af2424f875ff1b17(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $4a7bc43a0955ef89$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt,
        $4a7bc43a0955ef89$var$zule,
        function() {
            return [
                $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(ev.data[0], $4a7bc43a0955ef89$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(data, opts) {
    return $4a7bc43a0955ef89$var$inflt(data.subarray($4a7bc43a0955ef89$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $4a7bc43a0955ef89$export$4cb607de6db70415;
        this.I = $4a7bc43a0955ef89$export$d1de70a877d6e43c;
        this.Z = $4a7bc43a0955ef89$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $4a7bc43a0955ef89$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $4a7bc43a0955ef89$export$d5adcdd968132151;
        this.I = $4a7bc43a0955ef89$export$fff8358d6dbaa9cc;
        this.Z = $4a7bc43a0955ef89$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $4a7bc43a0955ef89$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $4a7bc43a0955ef89$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $4a7bc43a0955ef89$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $4a7bc43a0955ef89$export$cae1ce83fe4a1782(data, opts, cb) : $4a7bc43a0955ef89$export$ca7cbb494e731274(data, opts, cb);
}
function $4a7bc43a0955ef89$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $4a7bc43a0955ef89$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $4a7bc43a0955ef89$export$90366d8b308ba94a(data, opts) : $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $4a7bc43a0955ef89$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $4a7bc43a0955ef89$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $4a7bc43a0955ef89$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $4a7bc43a0955ef89$var$u8(0),
                op
            ];
            $4a7bc43a0955ef89$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $4a7bc43a0955ef89$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $4a7bc43a0955ef89$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $4a7bc43a0955ef89$var$tds = 0;
try {
    $4a7bc43a0955ef89$var$td.decode($4a7bc43a0955ef89$var$et, {
        stream: true
    });
    $4a7bc43a0955ef89$var$tds = 1;
} catch (e) {}
// decode UTF8
var $4a7bc43a0955ef89$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $4a7bc43a0955ef89$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $4a7bc43a0955ef89$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($4a7bc43a0955ef89$var$tds) this.t = new TextDecoder();
        else this.p = $4a7bc43a0955ef89$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $4a7bc43a0955ef89$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $4a7bc43a0955ef89$var$err(4);
        var dat = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $4a7bc43a0955ef89$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $4a7bc43a0955ef89$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $4a7bc43a0955ef89$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.d) $4a7bc43a0955ef89$var$err(4);
        this.ondata($4a7bc43a0955ef89$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $4a7bc43a0955ef89$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $4a7bc43a0955ef89$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($4a7bc43a0955ef89$var$te) return $4a7bc43a0955ef89$var$te.encode(str);
    var l = str.length;
    var ar = new $4a7bc43a0955ef89$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $4a7bc43a0955ef89$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $4a7bc43a0955ef89$var$slc(ar, 0, ai);
}
function $4a7bc43a0955ef89$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($4a7bc43a0955ef89$var$td) return $4a7bc43a0955ef89$var$td.decode(dat);
    else {
        var _a = $4a7bc43a0955ef89$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $4a7bc43a0955ef89$var$err(8);
        return s;
    }
}
// deflate bit flag
var $4a7bc43a0955ef89$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $4a7bc43a0955ef89$var$slzh = function(d, b) {
    return b + 30 + $4a7bc43a0955ef89$var$b2(d, b + 26) + $4a7bc43a0955ef89$var$b2(d, b + 28);
};
// read zip header
var $4a7bc43a0955ef89$var$zh = function(d, b, z) {
    var fnl = $4a7bc43a0955ef89$var$b2(d, b + 28), fn = $4a7bc43a0955ef89$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($4a7bc43a0955ef89$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $4a7bc43a0955ef89$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $4a7bc43a0955ef89$var$z64e(d, es) : [
        bs,
        $4a7bc43a0955ef89$var$b4(d, b + 24),
        $4a7bc43a0955ef89$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $4a7bc43a0955ef89$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $4a7bc43a0955ef89$var$b2(d, b + 30) + $4a7bc43a0955ef89$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $4a7bc43a0955ef89$var$z64e = function(d, b) {
    for(; $4a7bc43a0955ef89$var$b2(d, b) != 1; b += 4 + $4a7bc43a0955ef89$var$b2(d, b + 2));
    return [
        $4a7bc43a0955ef89$var$b8(d, b + 12),
        $4a7bc43a0955ef89$var$b8(d, b + 4),
        $4a7bc43a0955ef89$var$b8(d, b + 20)
    ];
};
// extra field length
var $4a7bc43a0955ef89$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $4a7bc43a0955ef89$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $4a7bc43a0955ef89$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $4a7bc43a0955ef89$var$exfl(ex);
    $4a7bc43a0955ef89$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $4a7bc43a0955ef89$var$err(10);
    $4a7bc43a0955ef89$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $4a7bc43a0955ef89$var$wbytes(d, b, f.crc);
        $4a7bc43a0955ef89$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $4a7bc43a0955ef89$var$wbytes(d, b + 8, f.size);
    }
    $4a7bc43a0955ef89$var$wbytes(d, b + 12, fl);
    $4a7bc43a0955ef89$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $4a7bc43a0955ef89$var$wbytes(d, b, col);
        $4a7bc43a0955ef89$var$wbytes(d, b + 6, f.attrs);
        $4a7bc43a0955ef89$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $4a7bc43a0955ef89$var$wbytes(d, b, +k);
        $4a7bc43a0955ef89$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $4a7bc43a0955ef89$var$wzf = function(o, b, c, d, e) {
    $4a7bc43a0955ef89$var$wbytes(o, b, 0x6054B50); // skip disk
    $4a7bc43a0955ef89$var$wbytes(o, b + 8, c);
    $4a7bc43a0955ef89$var$wbytes(o, b + 10, c);
    $4a7bc43a0955ef89$var$wbytes(o, b + 12, d);
    $4a7bc43a0955ef89$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $4a7bc43a0955ef89$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $4a7bc43a0955ef89$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $4a7bc43a0955ef89$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $4a7bc43a0955ef89$export$2b25194e1767ea06.call(this, filename);
        this.d = new $4a7bc43a0955ef89$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $4a7bc43a0955ef89$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $4a7bc43a0955ef89$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $4a7bc43a0955ef89$export$2b25194e1767ea06.call(this, filename);
        this.d = new $4a7bc43a0955ef89$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $4a7bc43a0955ef89$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $4a7bc43a0955ef89$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($4a7bc43a0955ef89$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $4a7bc43a0955ef89$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($4a7bc43a0955ef89$var$err(11, 0, 1), null, false);
            var header = new $4a7bc43a0955ef89$var$u8(hl_1);
            $4a7bc43a0955ef89$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $4a7bc43a0955ef89$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $4a7bc43a0955ef89$var$u8(16);
                        $4a7bc43a0955ef89$var$wbytes(dd, 0, 0x8074B50);
                        $4a7bc43a0955ef89$var$wbytes(dd, 4, file.crc);
                        $4a7bc43a0955ef89$var$wbytes(dd, 8, cl_1);
                        $4a7bc43a0955ef89$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($4a7bc43a0955ef89$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $4a7bc43a0955ef89$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $4a7bc43a0955ef89$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $4a7bc43a0955ef89$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $4a7bc43a0955ef89$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    var r = {};
    $4a7bc43a0955ef89$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $4a7bc43a0955ef89$var$mt(function() {
            cb(a, b);
        });
    };
    $4a7bc43a0955ef89$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $4a7bc43a0955ef89$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $4a7bc43a0955ef89$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $4a7bc43a0955ef89$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $4a7bc43a0955ef89$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $4a7bc43a0955ef89$var$crc(), size = file.length;
        c.p(file);
        var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $4a7bc43a0955ef89$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $4a7bc43a0955ef89$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($4a7bc43a0955ef89$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $4a7bc43a0955ef89$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($4a7bc43a0955ef89$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $4a7bc43a0955ef89$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $4a7bc43a0955ef89$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $4a7bc43a0955ef89$var$exfl(p.extra);
        if (s > 65535) $4a7bc43a0955ef89$var$err(11);
        var d = compression ? $4a7bc43a0955ef89$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $4a7bc43a0955ef89$var$crc();
        c.p(file);
        files.push($4a7bc43a0955ef89$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $4a7bc43a0955ef89$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $4a7bc43a0955ef89$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $4a7bc43a0955ef89$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $4a7bc43a0955ef89$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $4a7bc43a0955ef89$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $4a7bc43a0955ef89$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $4a7bc43a0955ef89$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $4a7bc43a0955ef89$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $4a7bc43a0955ef89$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $4a7bc43a0955ef89$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $4a7bc43a0955ef89$export$93f81d5bbbb7c6bf
        };
        this.p = $4a7bc43a0955ef89$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $4a7bc43a0955ef89$var$err(5);
        if (!this.p) $4a7bc43a0955ef89$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $4a7bc43a0955ef89$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $4a7bc43a0955ef89$var$b2(buf, i + 6), cmp_1 = $4a7bc43a0955ef89$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $4a7bc43a0955ef89$var$b2(buf, i + 26), es = $4a7bc43a0955ef89$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $4a7bc43a0955ef89$var$b4(buf, i + 18), su_1 = $4a7bc43a0955ef89$var$b4(buf, i + 22);
                        var fn_1 = $4a7bc43a0955ef89$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $4a7bc43a0955ef89$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $4a7bc43a0955ef89$var$err(5);
                                if (!sc_1) file_1.ondata(null, $4a7bc43a0955ef89$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($4a7bc43a0955ef89$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $4a7bc43a0955ef89$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($4a7bc43a0955ef89$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $4a7bc43a0955ef89$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $4a7bc43a0955ef89$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $4a7bc43a0955ef89$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $4a7bc43a0955ef89$var$mt(function() {
            cb(a, b);
        });
    };
    $4a7bc43a0955ef89$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $4a7bc43a0955ef89$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($4a7bc43a0955ef89$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $4a7bc43a0955ef89$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $4a7bc43a0955ef89$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $4a7bc43a0955ef89$var$b4(data, e - 12);
            z = $4a7bc43a0955ef89$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $4a7bc43a0955ef89$var$b4(data, ze + 32);
                o = $4a7bc43a0955ef89$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $4a7bc43a0955ef89$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $4a7bc43a0955ef89$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $4a7bc43a0955ef89$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $4a7bc43a0955ef89$export$90366d8b308ba94a(infl, {
                            out: new $4a7bc43a0955ef89$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($4a7bc43a0955ef89$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $4a7bc43a0955ef89$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $4a7bc43a0955ef89$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $4a7bc43a0955ef89$var$err(13);
    var c = $4a7bc43a0955ef89$var$b2(data, e + 8);
    if (!c) return {};
    var o = $4a7bc43a0955ef89$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $4a7bc43a0955ef89$var$b4(data, e - 12);
        z = $4a7bc43a0955ef89$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $4a7bc43a0955ef89$var$b4(data, ze + 32);
            o = $4a7bc43a0955ef89$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $4a7bc43a0955ef89$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $4a7bc43a0955ef89$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $4a7bc43a0955ef89$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $4a7bc43a0955ef89$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $4a7bc43a0955ef89$var$u8(su)
            });
            else $4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $4a7bc43a0955ef89$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $4a7bc43a0955ef89$export$c80456f7aaba691c;

});

parcelRegister("aF5bm", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== activationId || $[1] !== cloudId) {
        t0 = $3217b30f8fcccab4$export$c922e8420e7a46c9({
            cloudId: cloudId,
            activationId: activationId
        });
        $[0] = activationId;
        $[1] = cloudId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});

parcelRegister("dGzwg", function(module, exports) {
"use strict";
var $9f6ac0077b20b014$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $3u6GG = parcelRequire("3u6GG");

/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $9f6ac0077b20b014$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $3u6GG.async;
    return function(source) {
        return source.lift(new $9f6ac0077b20b014$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $9f6ac0077b20b014$var$debounceTime;
var $9f6ac0077b20b014$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9f6ac0077b20b014$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9f6ac0077b20b014$var$DebounceTimeSubscriber = function(_super) {
    $9f6ac0077b20b014$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($9f6ac0077b20b014$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($axeml.Subscriber);
function $9f6ac0077b20b014$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("4wEOc", function(module, exports) {

var $hGuUS = parcelRequire("hGuUS");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery = (0, $hGuUS.default);
const $17b0e005176b05e7$export$2e6840e38da4c328 = ({ skip: skip = false } = {})=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery, {
        context: {
            single: true
        },
        skip: skip
    });
    const isEnabled = Boolean(data?.isDataClassificationEnabled);
    return {
        isEnabled: isEnabled,
        error: error,
        loading: loading
    };
};
module.exports["useIsDataClassificationEnabledForOrg"] = $17b0e005176b05e7$export$2e6840e38da4c328;

});

parcelRegister("hGuUS", function(module, exports) {
/**
 * @generated SignedSource<<f6dd3a4596d10b8bebdd6d13fa0ce756>>
 * @relayHash 7a459e5b02d70f6bd0fcfe9c6f09aaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe
const $d06bb9e5b53f54be$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "isDataClassificationEnabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7a459e5b02d70f6bd0fcfe9c6f09aaed",
            "id": "f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe",
            "metadata": {},
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "operationKind": "query",
            "text": "query useIsDataClassificationEnabledForOrgQuery{isDataClassificationEnabled}"
        }
    };
}();
$d06bb9e5b53f54be$var$node.hash = "5fefa316f3ebea3d1e92d59f94b250db";
var $d06bb9e5b53f54be$export$2e2bcd8739ae039 = $d06bb9e5b53f54be$var$node;
module.exports["default"] = $d06bb9e5b53f54be$export$2e2bcd8739ae039;

});

parcelRegister("kj1gY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $65a70e5bc153e910$export$3ecbd7f299e957b2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "20b9O",
    name: "ChangesDiffLoader",
    loader: async ()=>(await (parcelRequire("3JBBS"))).ChangesDiff
});
module.exports["ChangesDiffLoader"] = $65a70e5bc153e910$export$3ecbd7f299e957b2;

});

parcelRegister("3JBBS", function(module, exports) {

let $2b82bf9f6bb366aa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b82bf9f6bb366aa$var$load("8OiWl").then(()=>parcelRequire('fQeQL'));

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("hFGQl", function(module, exports) {
const $d3e8bd0515c02c91$export$8b02acc4219d8357 = 'content-metadata-jira';
const $d3e8bd0515c02c91$export$a93781d2f10a1a54 = 'content-metadata-attachments';
const $d3e8bd0515c02c91$export$126027a563ee39b2 = 'content-metadata-page-restrictions';
const $d3e8bd0515c02c91$export$e5b04880f6b7bed = 'draft-status-lozenge';
const $d3e8bd0515c02c91$export$b6c67256b8045624 = 'status-lozenge-scheduled';
const $d3e8bd0515c02c91$export$1b048ac0db68f7ab = 'rte-button-restrictions';
const $d3e8bd0515c02c91$export$607df6eced5a588c = 'inviteToEdit';
const $d3e8bd0515c02c91$export$c8362b8678d6b894 = 'com.addonengine.analytics__analytics-content-byline-item';
const $d3e8bd0515c02c91$export$de7935ab18e02484 = 'com.addonengine.analytics__analytics-content-menu-item';
const $d3e8bd0515c02c91$export$a643e9449b465583 = 'com.addonengine.analytics.moderate__analytics-content-menu-item';
module.exports["CONTENT_METADATA_JIRA_ID"] = $d3e8bd0515c02c91$export$8b02acc4219d8357;
module.exports["CONTENT_METADATA_ATTACHMENTS_ID"] = $d3e8bd0515c02c91$export$a93781d2f10a1a54;
module.exports["CONTENT_METADATA_PAGE_RESTRICTIONS_ID"] = $d3e8bd0515c02c91$export$126027a563ee39b2;
module.exports["DRAFT_STATUS_LOZENGE_ID"] = $d3e8bd0515c02c91$export$e5b04880f6b7bed;
module.exports["SCHEDULED_STATUS_LOZENGE_ID"] = $d3e8bd0515c02c91$export$b6c67256b8045624;
module.exports["EDIT_PAGE_METADATA_RESTRICTIONS_ID"] = $d3e8bd0515c02c91$export$1b048ac0db68f7ab;
module.exports["INVITE_TO_EDIT_ID"] = $d3e8bd0515c02c91$export$607df6eced5a588c;
module.exports["ANALYTICS_ADDON_BYLINE_ID"] = $d3e8bd0515c02c91$export$c8362b8678d6b894;
module.exports["ANALYTICS_ADDON_ACTIONS_MENU_ID"] = $d3e8bd0515c02c91$export$de7935ab18e02484;
module.exports["ANALYTICS_MODERATE_ADDON_ACTIONS_MENU_ID"] = $d3e8bd0515c02c91$export$a643e9449b465583;

});

parcelRegister("4aGJ9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $io723 = parcelRequire("io723");


var $ln0hx = parcelRequire("ln0hx");


var $irVI7 = parcelRequire("irVI7");


var $gw4Bt = parcelRequire("gw4Bt");


var $8bw1z = parcelRequire("8bw1z");

const $67cd68d5c5612721$export$5894b1d1838f517c = (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== props.contentId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
            isCustomStart: true,
            key: props.contentId
        });
        $[0] = props.contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8bw1z.ShareRestrictAndCopyCoordinator), props);
        $[3] = props;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t0 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0, t1, t2);
        $[5] = t0;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ShareAndRestrictButton"] = $67cd68d5c5612721$export$5894b1d1838f517c;

});

parcelRegister("8bw1z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $bedQP = parcelRequire("bedQP");


var $h1ewt = parcelRequire("h1ewt");


var $9gE7g = parcelRequire("9gE7g");


var $cLo2u = parcelRequire("cLo2u");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $lsxnT = parcelRequire("lsxnT");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $ivb8S = parcelRequire("ivb8S");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $kM55L = parcelRequire("kM55L");


var $7aRa9 = parcelRequire("7aRa9");


var $6DT7W = parcelRequire("6DT7W");


var $jQIjE = parcelRequire("jQIjE");


var $2VQ4B = parcelRequire("2VQ4B");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $e4o8D = parcelRequire("e4o8D");


var $hkzol = parcelRequire("hkzol");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $lfFzM = parcelRequire("lfFzM");


var $eoU1C = parcelRequire("eoU1C");


var $d35qt = parcelRequire("d35qt");


var $dA1Sn = parcelRequire("dA1Sn");


var $dPJCf = parcelRequire("dPJCf");


var $foQ4a = parcelRequire("foQ4a");


var $fXr1Y = parcelRequire("fXr1Y");


var $Qy97i = parcelRequire("Qy97i");


var $fdPUP = parcelRequire("fdPUP");


var $gw4Bt = parcelRequire("gw4Bt");


var $ePExc = parcelRequire("ePExc");


var $6vDKR = parcelRequire("6vDKR");


var $5QBqz = parcelRequire("5QBqz");


var $gTPPC = parcelRequire("gTPPC");


var $lT8a1 = parcelRequire("lT8a1");


var $grWYF = parcelRequire("grWYF");

const $d1b365751f35aaca$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $d1b365751f35aaca$var$PUBLIC_LINK_ENROLLED_CONTENT_TYPES = [
    'page',
    'whiteboard'
];
const $d1b365751f35aaca$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    shareButtonSpotlightHeading: {
        id: "share-and-restrict-dialog.spotlight.heading",
        defaultMessage: "Restrictions have moved"
    },
    shareButtonSpotlightText: {
        id: "share-and-restrict-dialog.spotlight.text",
        defaultMessage: "Now you can share and restrict access to your content in one place."
    },
    shareButtonSpotlightLearnMore: {
        id: "share-and-restrict-dialog.spotlight.learn-more",
        defaultMessage: "Learn more"
    },
    shareButtonSpotlightOk: {
        id: "share-and-restrict-dialog.spotlight.ok",
        defaultMessage: "OK"
    },
    shareButtonChangeBoardingFlagHeading: {
        id: "share-and-restrict-dialog.flag.heading",
        defaultMessage: "Your lock icon has moved"
    },
    shareButtonChangeBoardingFlagDescription: {
        id: "share-and-restrict-dialog.flag.message",
        defaultMessage: "The lock icon (where you manage access to your content) is now in the Share button."
    },
    shareButtonChangeBoardingFlagAction: {
        id: "share-and-restrict-dialog.flag.action",
        defaultMessage: "Show me"
    }
});
const $d1b365751f35aaca$var$useRedirectedFromRestrictQueryParam = (0, $dPJCf.createSingleQueryParamHook)('redirectedFromRestrict');
const $d1b365751f35aaca$var$convertPageMode = (mode)=>mode === (0, $cD1qu.PageMode).LIVE ? (0, $cD1qu.PageMode).VIEW : mode;
const $d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID = 'share-restrict-button-changeboarding-flag';
const $d1b365751f35aaca$var$ShareRestrictAndCopyCoordinatorComponent = ({ contentId: contentId, shareeAction: shareeAction = 'view', allowRestrictions: allowRestrictions = true, contentType: contentType, contentSubType: contentSubType, isUnpublishedDraft: isUnpublishedDraft = false, flags: flags, isShareAndRestrictButtonDisabled: // Separate disabled states
isShareAndRestrictButtonDisabled = false, isCopyLinkButtonDisabled: isCopyLinkButtonDisabled = false, // CopyLinkButton props
...copyLinkButtonProps })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [controllerMounted, setControllerMounted] = (0, $42omo.useState)(false);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    // Grant Access query params
    const isRedirectedFromRestrict = $d1b365751f35aaca$var$useRedirectedFromRestrictQueryParam();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)();
    // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    // Hook to store share button click state
    const { setHasClickedShareButton: setHasClickedShareButton, resetHasClickedShareButton: resetHasClickedShareButton } = (0, $5QBqz.useShareAndRestrictButtonActions)();
    // Create a ref for the share button
    const shareButtonRef = (0, $42omo.useRef)(null);
    const isContentTypePublicLinkEligible = $d1b365751f35aaca$var$PUBLIC_LINK_ENROLLED_CONTENT_TYPES.includes(contentType);
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const { icon: // Used here for rendering the button
    icon, isLoading: isLoading, error: error, tooltipMessage: tooltipMessage, refetch: refetch, hasInheritedRestrictions: // Used here for analytics
    hasInheritedRestrictions, hasRestrictions: hasRestrictions, hasViewRestrictions: hasViewRestrictions, isPublicLinkOn: isPublicLinkOn, pageTitle: pageTitle } = (0, $6vDKR.useShareAndRestrictButtonData)(contentId, isContentTypePublicLinkEligible, isUnpublishedDraft);
    const { isNewUser: isNewUser } = (0, $gTPPC.useIsNewUser)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (renderServerPlaceholder) return;
        else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    actionSubject: 'button',
                    actionSubjectId: 'ShareAndRestrictButton',
                    action: 'clicked',
                    attributes: {
                        contentId: contentId,
                        contentSubType: contentSubType,
                        isLivePage: contentSubType === 'live',
                        isDraft: isUnpublishedDraft,
                        contentType: contentType,
                        edition: edition,
                        hasInheritedRestrictions: hasInheritedRestrictions,
                        hasRestrictions: hasRestrictions,
                        hasViewRestrictions: hasViewRestrictions,
                        isPublicLinkOn: isPublicLinkOn,
                        pageMode: shareeAction
                    }
                }
            }).fire();
            refetch();
            setControllerMounted(true);
            //mark has share button click to true
            setHasClickedShareButton();
            //start share and restrict dialog load experience
            experienceTracker.start({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
            });
        }
    }, [
        createAnalyticsEvent,
        contentId,
        contentSubType,
        contentType,
        edition,
        hasInheritedRestrictions,
        hasRestrictions,
        hasViewRestrictions,
        isUnpublishedDraft,
        isPublicLinkOn,
        refetch,
        shareeAction,
        experienceTracker,
        renderServerPlaceholder,
        setHasClickedShareButton
    ]);
    (0, $42omo.useEffect)(()=>{
        resetHasClickedShareButton();
    }, [
        resetHasClickedShareButton
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'ShareAndRestrictButton',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentSubType: contentSubType,
                    isLivePage: contentSubType === 'live',
                    isDraft: isUnpublishedDraft,
                    pageMode: shareeAction
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType,
        contentSubType,
        isUnpublishedDraft,
        shareeAction
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isLoading && !error) experienceTracker.succeed({
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
        else if (!isLoading && error) experienceTracker.fail({
            error: error,
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
    }, [
        error,
        isLoading,
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        if (edition !== (0, $d9tcB.ConfluenceEdition).FREE) (0, $6mKj3.manuallyLogExpExposure)('confluence_contextual_ask_to_edit');
    }, [
        edition
    ]);
    const { data: data, loading: loading, error: spotlightError } = (0, $ivb8S.useGetOnboardingState)((0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $42omo.useEffect)(()=>{
        if (data && !loading && !spotlightError && !error) {
            const spotlightSeen = data?.onboardingState?.find((prop)=>prop.key === (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN)?.value === 'true';
            // Live pages does not want users to see USD button change-boarding
            if (!(contentSubType == 'live' || isNewUser)) // If the spotlight hasn't been seen before
            {
                if (!spotlightSeen) {
                    const markSpotlightAsSeen = ()=>setOnboardingState({
                            key: (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN,
                            value: 'true'
                        });
                    const onFlagDismissClick = ()=>{
                        markSpotlightAsSeen();
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'flag dismissed',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                    };
                    const onFlagShowMeClick = ()=>{
                        setIsSpotlightActive(true);
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'spotlight shown',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                        flags.hideFlag($d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID);
                        markSpotlightAsSeen();
                    };
                    const showFlag = async ()=>{
                        await flags.showFlag({
                            id: $d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID,
                            type: 'custom',
                            title: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagHeading),
                            description: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagDescription),
                            actions: [
                                {
                                    content: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagAction),
                                    onClick: onFlagShowMeClick
                                }
                            ],
                            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
                                label: ""
                            }),
                            onClose: onFlagDismissClick,
                            close: 'auto'
                        });
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'flag shown',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                    };
                    showFlag();
                }
            }
        } else if (spotlightError && !loading) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                actionSubject: 'ShareAndRestrictButton',
                action: 'spotlight failed',
                attributes: {
                    contentId: contentId,
                    contentSubType: contentSubType,
                    isLivePage: contentSubType === 'live',
                    contentType: contentType,
                    edition: edition,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    hasRestrictions: hasRestrictions,
                    hasViewRestrictions: hasViewRestrictions,
                    isPublicLinkOn: isPublicLinkOn,
                    pageMode: shareeAction
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        loading,
        spotlightError,
        error
    ]);
    const endSpotlight = ()=>{
        // Change spotlight state to only show once
        setOnboardingState({
            key: (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN,
            value: 'true'
        });
        setIsSpotlightActive(false);
    };
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const learnMoreClicked = ()=>{
        endSpotlight();
        window.open((0, $fdPUP.SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION), '_blank', 'noreferrer');
    };
    const renderControlledShareButton = ()=>{
        const indicatorRightOffset = icon === 'public' ? 54 : 55;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d35qt.NewAccessRequestIndicator), {
            top: 4,
            right: indicatorRightOffset,
            source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Qy97i.ControlledShareButton), {
            tooltipMessage: tooltipMessage,
            icon: icon,
            onClick: handleClick,
            isDisabled: isShareAndRestrictButtonDisabled || isNetworkDisabled,
            focusRef: shareButtonRef
        }));
    };
    const origPageMode = (0, $aSsfA.useGetPageMode)();
    const pageMode = $d1b365751f35aaca$var$convertPageMode(origPageMode);
    const spaceKey = (0, $cLo2u.useSpaceKey)() ?? '';
    const { shouldShowGrantAccess: shouldShowGrantAccess, clearGrantAccessQueryParams: clearGrantAccessQueryParams } = (0, $jQIjE.useShouldShowGrantAccess)();
    const [initialDialog, setInitialDialog] = (0, $42omo.useState)(shouldShowGrantAccess && edition !== 'FREE' ? 'accessRequests' : undefined);
    (0, $42omo.useLayoutEffect)(()=>{
        if (initialDialog) setControllerMounted(true);
    }, [
        initialDialog
    ]);
    const openAccessRequestsDialog = (0, $42omo.useCallback)(()=>{
        setInitialDialog('accessRequests');
    }, []);
    const clearInitialDialog = (0, $42omo.useCallback)(()=>{
        setInitialDialog(undefined);
        clearGrantAccessQueryParams();
    }, [
        clearGrantAccessQueryParams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "share-button",
        enabled: origPageMode !== (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true),
        ssrPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "share-restrict-and-copy-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1b365751f35aaca$var$RemovedSpotlightTarget, {
        name: "share-button-spotlight-target"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "shareAndRestrictButton"
    }, isRedirectedFromRestrict && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6DT7W.RequestAccessPopupComponent), {
        contentId: contentId
    }), renderControlledShareButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        actions: [
            {
                onClick: endSpotlight,
                text: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightOk)
            },
            {
                onClick: learnMoreClicked,
                text: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightLearnMore)
            }
        ],
        heading: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightHeading),
        target: "shareAndRestrictButton",
        key: "shareAndRestrict-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "bottom right",
        dialogWidth: 275
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        values: {
            bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        },
        ...$d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightText
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $grWYF.OnboardingPagePermissionsSpotlightLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.SHARE_PAGE_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_SHARE_PAGE_SHORTCUT),
        listener: handleClick
    })), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
        metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
        key: contentId,
        customData: {
            shareButtonType: 'ShareAndRestrictButton'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
        contentId: contentId,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        isDisabled: isCopyLinkButtonDisabled,
        ...copyLinkButtonProps
    }))), controllerMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ePExc.ShareAndRestrictDialogController), {
        isExternalCollaborator: isExternalCollaborator,
        contentId: contentId,
        contentType: contentType,
        contentSubType: contentSubType,
        allowRestrictions: allowRestrictions,
        pageTitle: pageTitle,
        pageMode: shareeAction,
        refetchButtonData: refetch,
        onClose: ()=>{
            setControllerMounted(false);
        },
        isUnpublishedDraft: isUnpublishedDraft,
        focusRef: shareButtonRef,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        isSuperAdmin: isSuperAdmin,
        initialDialog: initialDialog,
        onInitialDialogOpen: clearInitialDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fXr1Y.RealtimeAccessRequests), {
        contentId: contentId,
        contentType: contentType,
        pageTitle: pageTitle,
        onReviewRequestsClick: openAccessRequestsDialog
    }));
};
const $d1b365751f35aaca$export$d9b7b2c2d990f8ed = (0, $7aRa9.withFlags)($d1b365751f35aaca$var$ShareRestrictAndCopyCoordinatorComponent);
module.exports["ShareRestrictAndCopyCoordinator"] = $d1b365751f35aaca$export$d9b7b2c2d990f8ed;

});

parcelRegister("6DT7W", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8e77e8dd4ed98ba0$export$8e100eba08cca59e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "C9H24",
    name: "RequestAccessPopupComponent",
    loader: async ()=>(await (parcelRequire("6VZQx"))).RequestAccessPopupComponent
});
module.exports["RequestAccessPopupComponent"] = $8e77e8dd4ed98ba0$export$8e100eba08cca59e;

});

parcelRegister("6VZQx", function(module, exports) {

let $50c80a6022564ab2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $50c80a6022564ab2$var$load("lk4cE").then(()=>parcelRequire('1hgMC'));

});

parcelRegister("jQIjE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dPJCf = parcelRequire("dPJCf");

const $913c9f7b92c5afc8$var$useAccountIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('accountId');
const $913c9f7b92c5afc8$var$useUsernameQueryParam = (0, $dPJCf.createSingleQueryParamHook)('username');
const $913c9f7b92c5afc8$var$useGrantAccessQueryParam = (0, $dPJCf.createSingleQueryParamHook)('grantAccess');
const $913c9f7b92c5afc8$export$2914b3c0c287db = ()=>{
    const accountIdRaw = $913c9f7b92c5afc8$var$useAccountIdQueryParam();
    const username = $913c9f7b92c5afc8$var$useUsernameQueryParam();
    const grantAccess = $913c9f7b92c5afc8$var$useGrantAccessQueryParam();
    const shouldShowGrantAccess = Boolean(grantAccess && accountIdRaw || username);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const clearGrantAccessQueryParams = (0, $42omo.useCallback)(()=>{
        setQueryParams({
            grantAccess: undefined,
            accessType: undefined,
            accountId: undefined,
            username: undefined
        }, true);
    }, [
        setQueryParams
    ]);
    return {
        shouldShowGrantAccess: shouldShowGrantAccess,
        clearGrantAccessQueryParams: clearGrantAccessQueryParams
    };
};
module.exports["useShouldShowGrantAccess"] = $913c9f7b92c5afc8$export$2914b3c0c287db;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<addb5e142aa82e94041daec88a20b086>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("fXr1Y", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $e4o8D = parcelRequire("e4o8D");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $hiMUo = parcelRequire("hiMUo");

const $b7b8f942bb046fc6$var$RealtimeAccessRequestsInternal = (0, $7aRa9.withFlags)(({ cloudId: cloudId, userId: userId, edition: edition, contentType: contentType, contentId: contentId, pageTitle: pageTitle, flags: flags, onReviewRequestsClick: onReviewRequests })=>{
    (0, $hiMUo.useRealtimeAccessRequestsFlags)({
        userId: userId,
        cloudId: cloudId,
        edition: edition,
        onReviewRequests: onReviewRequests,
        contentId: contentId,
        contentType: contentType,
        pageTitle: pageTitle,
        flags: flags
    });
    return null;
});
const $b7b8f942bb046fc6$export$c85837ac639c35b3 = (accessStatus)=>[
        null,
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS,
        (0, $d9tcB.AccessStatus).NOT_PERMITTED,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS
    ].includes(accessStatus);
const $b7b8f942bb046fc6$export$6e9d9c4509b6c805 = (props)=>{
    const $ = (0, $frIzR.c)(5);
    const { cloudId: cloudId, userId: userId, edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isSSR = (0, $e4o8D.useRenderServerPlaceholder)();
    if (isSSR || !cloudId || !userId || !edition || edition === "FREE" || !isLoggedIn || $b7b8f942bb046fc6$export$c85837ac639c35b3(accessStatus)) return null;
    let t0;
    if ($[0] !== cloudId || $[1] !== edition || $[2] !== props || $[3] !== userId) {
        t0 = (0, $6mKj3.expValEquals)("cc_fe_realtime_access_requests", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7b8f942bb046fc6$var$RealtimeAccessRequestsInternal, {
            userId: userId,
            cloudId: cloudId,
            edition: edition,
            ...props
        }) : null;
        $[0] = cloudId;
        $[1] = edition;
        $[2] = props;
        $[3] = userId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
const $b7b8f942bb046fc6$export$6ad2e2265e081d0a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($b7b8f942bb046fc6$export$6e9d9c4509b6c805);
module.exports["RealtimeAccessRequests"] = $b7b8f942bb046fc6$export$6ad2e2265e081d0a;

});

parcelRegister("hiMUo", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $fG2oG = parcelRequire("fG2oG");


var $cmGDN = parcelRequire("cmGDN");


var $9p780 = parcelRequire("9p780");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $a2xFu = parcelRequire("a2xFu");


var $i9VoI = parcelRequire("i9VoI");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $iquRY = parcelRequire("iquRY");


var $8aF6s = parcelRequire("8aF6s");


var $eRpR8 = parcelRequire("eRpR8");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $dwkNQ = parcelRequire("dwkNQ");


var $7QoAs = parcelRequire("7QoAs");


var $f2UnK = parcelRequire("f2UnK");


var $2h8N6 = parcelRequire("2h8N6");


var $azoSh = parcelRequire("azoSh");


var $4PnIU = parcelRequire("4PnIU");

const $e6f9393b1f903716$var$REQUEST_ALREADY_PROCESSED = 'REQUEST_ALREADY_PROCESSED';
const $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG = 'realtime-access-request-flag';
const $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID = `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG}-id`;
const $e6f9393b1f903716$var$SPACE_COLLABORATOR_ROLE_ID = '0c103ff5-44d0-4b2a-b80d-8690442c95f0';
const $e6f9393b1f903716$var$SPACE_VIEWER_ROLE_ID = '26d75a6e-ad72-42c3-bf30-007d3ebae9ed';
const $e6f9393b1f903716$var$NOOP = ()=>{};
const $e6f9393b1f903716$var$i18n = (0, $aXWIB.defineMessages)({
    requestApprovedSuccess: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-approved-success",
        defaultMessage: "Request approved"
    },
    requestDeniedSuccess: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-denied-success",
        defaultMessage: "Request denied"
    },
    denialSuccessDescription: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.denial-success-description",
        defaultMessage: "{displayName}'s access to this content won't change."
    },
    requestAlreadyProcessedTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-already-processed-title",
        defaultMessage: "Someone already responded to this request"
    },
    errorResolvingRequestTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.error-resolving-request-title",
        defaultMessage: "We ran into a problem resolving the access request. Try again later."
    }
});
const $e6f9393b1f903716$var$ResolveRestrictionsDialogWrapper = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwkNQ.ResolveRestrictionsDialog), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $e6f9393b1f903716$var$UseRealtimeAccessRequestsQuery = (0, $9p780.default);
const $e6f9393b1f903716$export$28935defd579c67a = (0, $cmGDN.default);
const $e6f9393b1f903716$var$ResolveRestrictionsMutation = (0, $fG2oG.default);
const $e6f9393b1f903716$export$e14a96ba31dd30b0 = (requests, userId)=>(0, $9wGTI.fg)('cc_fe_realtime_access_requests_show_own_requests') ? requests : requests.filter((request)=>request?.creatorAaid !== userId);
const $e6f9393b1f903716$export$126feeec2567e438 = ({ userId: userId, cloudId: cloudId, edition: edition, contentId: contentId, contentType: contentType, pageTitle: pageTitle, flags: flags, onReviewRequests: onReviewRequests })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isRbacEnabled: isRbacEnabled, loading: rbacStatusLoading } = (0, $iquRY.useSpaceRoleMode)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const [isInitialLoad, setIsInitialLoad] = (0, $42omo.useState)(true);
    const isTabActive = (0, $4PnIU.useDocumentActive)();
    const skipConditions = hasError || rbacStatusLoading || !isTabActive;
    const markAsErrored = (0, $42omo.useCallback)((error)=>{
        setHasError(true);
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, []);
    const fireAnalyticEvent = (0, $42omo.useCallback)((args)=>{
        createAnalyticsEvent({
            type: args.eventType,
            data: {
                source: args.source,
                action: args.action,
                actionSubject: args.actionSubject,
                actionSubjectId: args.actionSubjectId,
                attributes: args.attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const [mutateRequest] = (0, $308Wd.useMutationInterop)($e6f9393b1f903716$export$28935defd579c67a);
    const [resolveRestrictionsForSubjects] = (0, $308Wd.useMutationInterop)($e6f9393b1f903716$var$ResolveRestrictionsMutation);
    const onProcessRequestClick = (0, $42omo.useCallback)(async (request, decision, restrictedUserPrincipalInfo)=>{
        // Purely to satisfy the linter
        if (!request || !request.id || !request.requestAccessType || !request.user || !request.user.id || !request.user.displayName || !request.creatorAaid || !request.creationDateTimestamp) return;
        const result = await mutateRequest({
            variables: {
                cloudId: cloudId,
                updateContentAccessRequestInput: {
                    contentId: contentId,
                    requestId: request.id,
                    accessType: request.requestAccessType,
                    accessRequestedAccountId: request.user.id,
                    approvalDecision: decision
                }
            }
        });
        let successfulMutation = result.data?.confluence_updateContentAccessRequest?.success;
        const requestAlreadyProcessed = result?.data?.confluence_updateContentAccessRequest?.errors?.find((err)=>err?.message === $e6f9393b1f903716$var$REQUEST_ALREADY_PROCESSED);
        // If user is blocked, run mutation to resolve restrictions
        if (successfulMutation && decision === 'APPROVE' && restrictedUserPrincipalInfo) {
            const rbacSpaceRole = request.requestAccessType === 'EDIT' ? $e6f9393b1f903716$var$SPACE_COLLABORATOR_ROLE_ID : $e6f9393b1f903716$var$SPACE_VIEWER_ROLE_ID;
            const spaceRoleId = isRbacEnabled ? rbacSpaceRole : null;
            const subjectId = request.creatorAaid;
            const subjectType = 'USER';
            const result_0 = await resolveRestrictionsForSubjects({
                variables: {
                    contentId: Number(contentId),
                    accessType: request.requestAccessType,
                    subjects: [
                        {
                            subjectId: subjectId,
                            subjectType: subjectType
                        }
                    ],
                    spaceRoleId: spaceRoleId
                }
            });
            successfulMutation = result_0?.data?.resolveRestrictionsForSubjects?.success;
        }
        if (successfulMutation) {
            flags.showSuccessFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_SUCCESS`,
                title: formatMessage(decision === 'APPROVE' ? $e6f9393b1f903716$var$i18n.requestApprovedSuccess : $e6f9393b1f903716$var$i18n.requestDeniedSuccess),
                description: decision === 'APPROVE' ? (0, $azoSh.makeSuccessFlagDescription)(restrictedUserPrincipalInfo, request.user.displayName, request.requestAccessType, formatMessage) : formatMessage($e6f9393b1f903716$var$i18n.denialSuccessDescription, {
                    displayName: request.user.displayName
                }),
                isAutoDismiss: true
            });
            if (decision === 'APPROVE') fireAnalyticEvent({
                eventType: 'sendTrackEvent',
                action: 'granted',
                actionSubject: 'access',
                actionSubjectId: 'grantAccess',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    accessType: request.requestAccessType,
                    processingTime: Date.now() - request.creationDateTimestamp,
                    creationDateTimestamp: request.creationDateTimestamp,
                    ...(0, $azoSh.extractRestrictionInfo)(restrictedUserPrincipalInfo)
                }
            });
            else fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'denyAccess',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    accessType: request.requestAccessType,
                    processingTime: Date.now() - request.creationDateTimestamp,
                    creationDateTimestamp: request.creationDateTimestamp,
                    ...(0, $azoSh.extractRestrictionInfo)(restrictedUserPrincipalInfo)
                }
            });
        } else if (requestAlreadyProcessed) {
            flags.showInfoFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_INFO`,
                title: formatMessage($e6f9393b1f903716$var$i18n.requestAlreadyProcessedTitle),
                isAutoDismiss: true
            });
            fireAnalyticEvent({
                eventType: 'sendTrackEvent',
                action: 'alreadyProcessed',
                actionSubject: 'accessRequestsRealtimeFlagMutation',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    attemptedDecision: decision,
                    accessType: request.requestAccessType,
                    ...(0, $azoSh.extractRestrictionInfo)(restrictedUserPrincipalInfo)
                }
            });
        } else {
            flags.showErrorFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_ERROR`,
                title: formatMessage($e6f9393b1f903716$var$i18n.errorResolvingRequestTitle),
                isAutoDismiss: true
            });
            const err_0 = result?.data?.confluence_updateContentAccessRequest?.errors?.[0];
            const message = err_0?.message || 'unknown';
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'failed',
                actionSubject: 'accessRequestsRealtimeFlagMutation',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    requestId: request.id,
                    contentId: contentId,
                    accessType: request.requestAccessType,
                    accountId: request.creatorAaid,
                    message: message
                }
            });
        }
    }, [
        cloudId,
        contentId,
        isRbacEnabled,
        flags,
        mutateRequest,
        resolveRestrictionsForSubjects,
        formatMessage,
        fireAnalyticEvent
    ]);
    const maybeShowRealtimeFlag = (0, $42omo.useCallback)(async (data, eventName)=>{
        // This is only used for analytics
        const queryTrigger = eventName ?? (isInitialLoad ? 'initialLoad' : 'tabVisible');
        if (isInitialLoad) setIsInitialLoad(false);
        const accessRequests = $e6f9393b1f903716$export$e14a96ba31dd30b0(data.confluence_getLatestPendingRequests?.latestPendingRequest ?? [], userId);
        (0, $eRpR8.NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE).updateIndicatorVisibility(contentId, accessRequests[0]?.creationDateTimestamp ?? 0, eventName === 'contentAccessRequested' ? 'partial' : 'full', accessRequests?.length ?? 0);
        if (accessRequests.length === 0) {
            // If a cached "last seen" timestamp for a realtime flag exists and it's > 5 minutes old
            // Then we can clear the cache to avoid buildup
            (0, $2h8N6.clearLastSeenRealtimeRequestCacheIfExpired)(contentId);
            return;
        }
        // We just need to remove requests older than the "last seen" one in the cache
        // Also ensure all requests have bare minimum info to display flag correctly
        const filteredRequests = accessRequests.filter((request_0)=>{
            const hasAllNecessaryData = request_0?.user?.displayName && request_0?.requestAccessType;
            const requestCreationTimestamp = Number(request_0?.creationDateTimestamp);
            const isMoreRecentThanLastSeenRequest = (0, $2h8N6.isMoreRecentThanCachedRequestTimestamp)(contentId, requestCreationTimestamp);
            return hasAllNecessaryData && isMoreRecentThanLastSeenRequest;
        });
        const latestIncomingRequestCreatedAt = Number(filteredRequests[0]?.creationDateTimestamp);
        if (filteredRequests.length === 0) return;
        // ID of any realtime flag that might be currently displayed
        const EXISTING_FLAG_ID = flags.state.flags.find(({ id: id })=>id.toString().startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG))?.id;
        // ID of the flag that we're about to display.
        // The suffix is a concatenated list of all the request ID-s displayed in the flag.
        // It helps us to know if the existing and new flag are going to be the same. See the edge case below
        const NEXT_FLAG_ID = `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_${(0, $azoSh.makeFlagIdSuffix)(filteredRequests)}`;
        /**
     * EDGE CASE: Flag gets hidden and exact same flag gets shown in its place.
     * This can happen because of tab inactivity monitoring. To reproduce:
     *
     * 1. Existing Realtime flag is showing on a page
     * 2. You click away into another tab.
     * 3. Click back on the original tab with the Realtime flag wihin 16s (autodismiss timeout)
     *    - we refetch all requests because the tab is now active again
     *    - the new request(s) are very likely the same as the ones already displayed in the flag
     *    - The existing flag gets hidden and a new flag with the same request(s) gets shown
     *    - To prevent this we just return early in this case
     *
     * This is likely to happen often as people click back and forth between tabs, so better to address it
     */ if (EXISTING_FLAG_ID === NEXT_FLAG_ID) return;
        /**
     * We cache the request as "seen" when the flag for it gets destroyed
     * However, if another realtime flag was shown WHILE the the current requests's flag is visible
     * Then we don't want to cache the current request to allow the current request to continue
     * showing in the newer flags' stacked display.
     *
     * As a reminder, requirements state that if a current flag is displayed and a new request comes in,
     * then the current flag needs to be replaced by a new flag that shows both of the requests with a facepile
     * for both users.
     *
     * If a third request comes in, then that second flag will get replaced with a third one, with the facepile
     * now showing 3 users, etc.
     *
     * Thus, to allow for this stacking of requests to occur, we only want to cache the last seen request when
     * the last flag in this request overlap sequence gets destroyed.
     * */ const onDestroy = ()=>{
            const skipCachingOfLastSeenFlag = flags.state.flags.find(({ id: id_0 })=>`${id_0}`.startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG) && id_0 !== NEXT_FLAG_ID);
            if (!skipCachingOfLastSeenFlag) (0, $2h8N6.updateLastSeenRealtimeRequestCache)(contentId, latestIncomingRequestCreatedAt);
        };
        let restrictedUserPrincipalInfo_0;
        let resolveRestrictionsDialogProps;
        let onViewDetailsClick = $e6f9393b1f903716$var$NOOP;
        const hideFlag = ()=>{
            flags.hideFlag(NEXT_FLAG_ID);
        };
        const onReviewRequestsClick = ()=>{
            onReviewRequests();
            hideFlag();
            fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'reviewRequests',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    trigger: queryTrigger,
                    requestsDisplayed: filteredRequests.length
                }
            });
        };
        if (filteredRequests.length === 1) {
            const request_1 = filteredRequests[0];
            const user = request_1?.user;
            const accessType = request_1?.requestAccessType ?? 'VIEW';
            const addMode = accessType === 'EDIT' ? 'as-editor' : 'as-viewer';
            const userPrincipal = {
                id: user?.id ?? '',
                name: user?.displayName ?? '',
                avatarUrl: user?.photos?.find((photo)=>photo?.isPrimary)?.value ?? '',
                email: '',
                // not needed
                knownErrors: undefined,
                sitePermissionType: accessType
            };
            // Make the blocked access check
            const [{ showResolveRestrictionsDialog: showResolveRestrictionsDialog, showWarnRestrictionsDialog: showWarnRestrictionsDialog, restrictedUserPrincipals: restrictedUserPrincipals, assignableSpaceRolesIntersection: assignableSpaceRolesIntersection }] = await Promise.all([
                (0, $7QoAs.validateRestrictedPrincipals)({
                    contentId: contentId,
                    cloudId: cloudId,
                    edition: edition,
                    numberOfAncestors: 1,
                    addMode: // not needed, API will error out if < 10 layers of ancestors
                    addMode,
                    stagedUserPrincipals: [
                        userPrincipal
                    ],
                    setMasterState: ()=>{},
                    fireAnalyticEvent: // not needed
                    fireAnalyticEvent
                }),
                (0, $f2UnK.preloadSpaceRoleMode)(cloudId)
            ]);
            /** Early return if user is not empowered to resolve blocked access */ if (showWarnRestrictionsDialog) {
                fireAnalyticEvent({
                    eventType: 'sendUIEvent',
                    action: 'aborted',
                    actionSubject: 'realtimeFlag',
                    source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                    attributes: {
                        trigger: queryTrigger,
                        requestsDisplayed: filteredRequests.length,
                        ...(0, $azoSh.extractRestrictionInfo)(restrictedUserPrincipalInfo_0)
                    }
                });
                return;
            }
            if (showResolveRestrictionsDialog && restrictedUserPrincipals?.[0]) {
                restrictedUserPrincipalInfo_0 = restrictedUserPrincipals?.[0];
                onViewDetailsClick = ()=>{
                    showModal($e6f9393b1f903716$var$ResolveRestrictionsDialogWrapper, resolveRestrictionsDialogProps);
                    hideFlag();
                    fireAnalyticEvent({
                        eventType: 'sendUIEvent',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'viewDetails',
                        source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                        attributes: {
                            trigger: queryTrigger,
                            requestsDisplayed: filteredRequests.length,
                            ...(0, $azoSh.extractRestrictionInfo)(restrictedUserPrincipalInfo_0)
                        }
                    });
                };
                const approveRequest = ()=>{
                    onProcessRequestClick(request_1, 'APPROVE', restrictedUserPrincipalInfo_0);
                    hideFlag();
                };
                resolveRestrictionsDialogProps = {
                    contentId: contentId,
                    restrictedUserPrincipals: restrictedUserPrincipals,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection,
                    pageTitle: pageTitle,
                    addMode: addMode,
                    onComplete: approveRequest,
                    onClose: $e6f9393b1f903716$var$NOOP,
                    onCloseComplete: $e6f9393b1f903716$var$NOOP,
                    onSkip: $e6f9393b1f903716$var$NOOP,
                    showErrorFlag: flags.showErrorFlag,
                    triggeredBy: 'realtimeAccessRequestFlag'
                };
            }
        }
        const onFlagCloseButtonClick = ()=>{
            fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissRealtimeAccessRequestFlag',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    trigger: queryTrigger,
                    requestsDisplayed: filteredRequests.length,
                    ...filteredRequests.length === 1 ? (0, $azoSh.extractRestrictionInfo)(restrictedUserPrincipalInfo_0) : {}
                }
            });
        };
        await flags.showCustomFlag({
            id: NEXT_FLAG_ID,
            isAutoDismiss: true,
            autoDismissSeconds: 16,
            customIcon: (0, $azoSh.makeFlagCustomIcon)(filteredRequests),
            onClose: onFlagCloseButtonClick,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $azoSh.FlagRemovalDetector), {
                onDestroy: onDestroy
            }, (0, $azoSh.makeFlagTitle)(filteredRequests, formatMessage)),
            description: (0, $azoSh.makeFlagDescription)(filteredRequests, formatMessage, restrictedUserPrincipalInfo_0),
            actions: (0, $azoSh.makeFlagActions)(filteredRequests, restrictedUserPrincipalInfo_0, onProcessRequestClick, // Approves / Denies request based on arguments
            onReviewRequestsClick, // Opens USD -> Access Requests
            onViewDetailsClick, // Opens standalone version of Resolve Restrictions Modal
            hideFlag, formatMessage)
        });
        /**
     * Fire flag shown analytic
     */ fireAnalyticEvent({
            eventType: 'sendUIEvent',
            action: 'shown',
            actionSubject: 'realtimeFlag',
            source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
            attributes: {
                trigger: queryTrigger,
                requestsDisplayed: filteredRequests.length,
                ...(0, $azoSh.extractRestrictionInfo)(restrictedUserPrincipalInfo_0)
            }
        });
        /**
     * Only hide any existing flags AFTER the latest flag has been shown
     * This ensures that the onDestroy callback of the existing flag
     * Will realize there's a newer flag on the screen
     * And will thus skip caching the EXISTING_FLAG_ID's request as seen
     * This allows the request to coninue appearing in the facepile of any
     * Newer flags that are displayed after it
     */ if (EXISTING_FLAG_ID) await flags.hideFlag(EXISTING_FLAG_ID);
    }, [
        userId,
        cloudId,
        contentId,
        pageTitle,
        edition,
        onProcessRequestClick,
        onReviewRequests,
        fireAnalyticEvent,
        flags,
        showModal,
        formatMessage,
        isInitialLoad
    ]);
    const { refetch: refetch, error: error_0 } = (0, $jMyy4.useQueryInterop)($e6f9393b1f903716$var$UseRealtimeAccessRequestsQuery, {
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            duration: (0, $2h8N6.ONE_YEAR_IN_MINUTES)
        },
        skip: skipConditions,
        fetchPolicy: 'network-only',
        // This "onCompleted" runs only on initial load.
        onCompleted: maybeShowRealtimeFlag,
        onError: markAsErrored
    });
    if (error_0) {
        (0, $7Sm4c.markErrorAsHandled)(error_0);
        if (hasError === false) setHasError(true);
    }
    const onDataReceived = (0, $42omo.useCallback)(async (eventName_0)=>{
        try {
            /**
       * Decide how far back in time we look to find existing pending requests.
       *
       * Option 1: eventName === 'contentAccessDecisionMade'
       * If it's after an existing request was just approved / denied, we want ALL requests
       * If no requests come back in response to that, then we can remove the 🔵 indicator
       *
       * Option 2: eventName === 'contentAccessRequested'
       * If it's after a new access request was just created, we only want to fetch the last
       * 5 minutes (or whatever short period we decide). This allows us to show a realtime flag
       * only for newly created requests that haven't been seen yet.
       * We cache the last seen realtime request creation date in localStorage.
       */ const lookbackPeriod = eventName_0 === 'contentAccessDecisionMade' ? (0, $2h8N6.ONE_YEAR_IN_MINUTES) : (0, $2h8N6.DEFAULT_MINUTE_LOOKBACK);
            const result_1 = await refetch({
                duration: lookbackPeriod,
                cloudId: cloudId,
                contentId: contentId
            });
            if (result_1.errors) {
                markAsErrored(result_1.errors[0]);
                return;
            }
            await maybeShowRealtimeFlag(result_1.data, eventName_0);
        } catch (e) {
            markAsErrored(e);
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'failed',
                actionSubject: 'onDataReceived',
                actionSubjectId: eventName_0,
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    name: e?.name,
                    message: e?.message
                }
            });
        }
    }, [
        refetch,
        cloudId,
        contentId,
        markAsErrored,
        maybeShowRealtimeFlag,
        fireAnalyticEvent
    ]);
    // Monitor when new pending requests get created
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        delta: 'contentAccessRequested',
        subscriberId: (0, $a2xFu.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString(),
        onDataReceived: onDataReceived,
        skip: skipConditions
    });
    // Monitor the approval / denial of existing pending requests
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        delta: 'contentAccessDecisionMade',
        subscriberId: (0, $a2xFu.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString(),
        onDataReceived: onDataReceived,
        skip: skipConditions
    });
    // Cleanup effect when page is navigated away from
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Subscribers need to be reset when the hook gets killed
            // This usually means that the share button got dismounted
            // And user navigated away from the current content
            (0, $eRpR8.NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE).resetSubscribers();
            // Databases and Whiteboards DON'T hide the flags when leaving the content
            // Live pages, regular pages DO hide the flags when leaving the content
            // Thus we choose to hide the flags everywhere to equalize behavior
            const existingFlagId = flags.state.flags.find(({ id: id_1 })=>id_1.toString().startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG))?.id;
            if (existingFlagId) flags.hideFlag(existingFlagId);
        };
    }, [
        flags
    ]);
};
module.exports["useRealtimeAccessRequestsFlags"] = $e6f9393b1f903716$export$126feeec2567e438;

});

parcelRegister("fG2oG", function(module, exports) {
/**
 * @generated SignedSource<<53a04d15201e5650bed33b34991a35f7>>
 * @relayHash e476390ffa12b3e505bd7e8ac519e061
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21f4290cdcdb12ab3f1c90bcbc8c6b47b7fbcce98706579b8ee723ba26cca755
const $927357fa0afdf6f0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accessType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceRoleId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subjects"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "accessType",
                            "variableName": "accessType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceRoleId",
                            "variableName": "spaceRoleId"
                        },
                        {
                            "kind": "Variable",
                            "name": "subjects",
                            "variableName": "subjects"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ResolveRestrictionsPayload",
            "kind": "LinkedField",
            "name": "resolveRestrictionsForSubjects",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "e476390ffa12b3e505bd7e8ac519e061",
            "id": "21f4290cdcdb12ab3f1c90bcbc8c6b47b7fbcce98706579b8ee723ba26cca755",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "operationKind": "mutation",
            "text": "mutation useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!,$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType,contentId:$contentId,subjects:$subjects,spaceRoleId:$spaceRoleId}){success,errors{message}}}"
        }
    };
}();
$927357fa0afdf6f0$var$node.hash = "20811ee88362a051210b331b739d34c1";
var $927357fa0afdf6f0$export$2e2bcd8739ae039 = $927357fa0afdf6f0$var$node;
module.exports["default"] = $927357fa0afdf6f0$export$2e2bcd8739ae039;

});

parcelRegister("cmGDN", function(module, exports) {
/**
 * @generated SignedSource<<a643fbd3923a094e0b498e1615e92000>>
 * @relayHash 3ba2473df321be430db6c856602e1cfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 276d3b41fdfa3d291bf08ded53ed193db1a7ba6d83bd886ac6ec292d3dabf482
const $b4dea9a5255d2c1f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateContentAccessRequestInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "updateContentAccessRequestInput",
                    "variableName": "updateContentAccessRequestInput"
                }
            ],
            "concreteType": "ConfluenceUpdateContentAccessRequestPayload",
            "kind": "LinkedField",
            "name": "confluence_updateContentAccessRequest",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3ba2473df321be430db6c856602e1cfc",
            "id": "276d3b41fdfa3d291bf08ded53ed193db1a7ba6d83bd886ac6ec292d3dabf482",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "operationKind": "mutation",
            "text": "mutation useRealtimeAccessRequestsFlagsMutation($cloudId:ID!,$updateContentAccessRequestInput:ConfluenceUpdateContentAccessRequestInput!){confluence_updateContentAccessRequest(cloudId:$cloudId,updateContentAccessRequestInput:$updateContentAccessRequestInput){success,errors{message}}}"
        }
    };
}();
$b4dea9a5255d2c1f$var$node.hash = "42de35f8c9cecb62158728d903eff6a2";
var $b4dea9a5255d2c1f$export$2e2bcd8739ae039 = $b4dea9a5255d2c1f$var$node;
module.exports["default"] = $b4dea9a5255d2c1f$export$2e2bcd8739ae039;

});

parcelRegister("9p780", function(module, exports) {
/**
 * @generated SignedSource<<f804e0b7443687c3ffc3e5232ec5712a>>
 * @relayHash cc07dc4570c5f23dcae6dba3e01bc64f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 869aa59f186c59156b49e7fd84b080a9f741fa74d96ee0e9093d8be9fba90884
const $4ea839717298c820$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 5,
            "kind": "LocalArgument",
            "name": "duration"
        },
        {
            "defaultValue": 10,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "duration",
                    "variableName": "duration"
                },
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "ConfluenceLatestPendingRequests",
            "kind": "LinkedField",
            "name": "confluence_getLatestPendingRequests",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceContentAccessRequest",
                    "kind": "LinkedField",
                    "name": "latestPendingRequest",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "requestAccessType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creatorAaid"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationDateTimestamp"
                        },
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "cc07dc4570c5f23dcae6dba3e01bc64f",
            "id": "869aa59f186c59156b49e7fd84b080a9f741fa74d96ee0e9093d8be9fba90884",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "operationKind": "query",
            "text": "query useRealtimeAccessRequestsFlagsQuery($cloudId:ID!,$contentId:ID!,$duration:Int=5,$limit:Int=10,$start:String){confluence_getLatestPendingRequests(cloudId:$cloudId,contentId:$contentId,duration:$duration,limit:$limit,start:$start){latestPendingRequest{id,requestAccessType,creatorAaid,creationDateTimestamp,user{id,displayName,photos{isPrimary,value}}}}}"
        }
    };
}();
$4ea839717298c820$var$node.hash = "b94cab17722d3b349c6aeac7cfa04a8f";
var $4ea839717298c820$export$2e2bcd8739ae039 = $4ea839717298c820$var$node;
module.exports["default"] = $4ea839717298c820$export$2e2bcd8739ae039;

});

parcelRegister("2h8N6", function(module, exports) {

var $1UApO = parcelRequire("1UApO");


var $2Oud5 = parcelRequire("2Oud5");

const $ba14d5ed8e7789e1$export$7e0819e7cb643ce3 = 525600;
const $ba14d5ed8e7789e1$export$c47be26a650fe21 = 5;
const $ba14d5ed8e7789e1$export$e58e41b464377560 = $ba14d5ed8e7789e1$export$c47be26a650fe21 * 60000;
const $ba14d5ed8e7789e1$export$b8de370ad22b4906 = (0, $1UApO.keys).LAST_SHOWN_REALTIME_REQUEST_CREATED_AT;
const $ba14d5ed8e7789e1$export$4000ed65840ab68a = (timestamp)=>{
    return Date.now() - timestamp < $ba14d5ed8e7789e1$export$e58e41b464377560;
};
const $ba14d5ed8e7789e1$export$3dee0973a5558286 = (timestamp)=>!$ba14d5ed8e7789e1$export$4000ed65840ab68a(timestamp);
const $ba14d5ed8e7789e1$export$289c54b917400e1c = (contentId, newTimestamp)=>{
    (0, $2Oud5.setCachedTuple)(contentId, newTimestamp, $ba14d5ed8e7789e1$export$b8de370ad22b4906, $ba14d5ed8e7789e1$export$4000ed65840ab68a);
};
const $ba14d5ed8e7789e1$export$8d67ec31af2e3b08 = (contentId, incomingRequestTimestamp)=>{
    return incomingRequestTimestamp > (0, $2Oud5.getCachedTimestamp)(contentId, $ba14d5ed8e7789e1$export$b8de370ad22b4906) && $ba14d5ed8e7789e1$export$4000ed65840ab68a(incomingRequestTimestamp);
};
const $ba14d5ed8e7789e1$export$37d57e4c435593ab = (contentId)=>{
    (0, $2Oud5.removeCachedTuple)(contentId, $ba14d5ed8e7789e1$export$b8de370ad22b4906, $ba14d5ed8e7789e1$export$3dee0973a5558286);
};
module.exports["ONE_YEAR_IN_MINUTES"] = $ba14d5ed8e7789e1$export$7e0819e7cb643ce3;
module.exports["DEFAULT_MINUTE_LOOKBACK"] = $ba14d5ed8e7789e1$export$c47be26a650fe21;
module.exports["updateLastSeenRealtimeRequestCache"] = $ba14d5ed8e7789e1$export$289c54b917400e1c;
module.exports["isMoreRecentThanCachedRequestTimestamp"] = $ba14d5ed8e7789e1$export$8d67ec31af2e3b08;
module.exports["clearLastSeenRealtimeRequestCacheIfExpired"] = $ba14d5ed8e7789e1$export$37d57e4c435593ab;

});

parcelRegister("azoSh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Pg7f = parcelRequire("2Pg7f");


var $1chEN = parcelRequire("1chEN");

const $1ca745aa2c0dd46c$var$i18n = (0, $aXWIB.defineMessages)({
    singleRequestTitleView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.single-request-title-view",
        defaultMessage: "{name} wants to view this content"
    },
    singleRequestTitleEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.single-request-title-edit",
        defaultMessage: "{name} wants to edit this content"
    },
    twoRequestsTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.two-requests-title",
        defaultMessage: "{firstName} and {secondName} want to access this content"
    },
    multipleRequestsTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.multiple-requests-title",
        defaultMessage: "{firstName} and {remainingCount} others want to access this content"
    },
    spaceAndParentRestriction: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.space-and-parent-restriction",
        defaultMessage: "They'll also need to be added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}."
    },
    spaceRestrictionOnly: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.space-restriction-only",
        defaultMessage: "They'll also need to be added to the space."
    },
    parentRestrictionOnly: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.parent-restriction-only",
        defaultMessage: "They'll also need to be added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}."
    },
    approveButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.approve-button",
        defaultMessage: "Approve"
    },
    viewDetailsButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.view-details-button",
        defaultMessage: "View details"
    },
    denyButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.deny-button",
        defaultMessage: "Deny"
    },
    reviewRequestsButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.review-requests-button",
        defaultMessage: "Review requests"
    },
    successSpaceAndParentRestrictionView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-and-parent-restriction-view",
        defaultMessage: "{displayName} was added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}. They can now view this content."
    },
    successSpaceAndParentRestrictionEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-and-parent-restriction-edit",
        defaultMessage: "{displayName} was added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}. They can now edit this content."
    },
    successSpaceRestrictionOnlyView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-restriction-only-view",
        defaultMessage: "{displayName} was added to the space and can now view this content."
    },
    successSpaceRestrictionOnlyEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-restriction-only-edit",
        defaultMessage: "{displayName} was added to the space and can now edit this content."
    },
    successParentRestrictionOnlyView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-parent-restriction-only-view",
        defaultMessage: "{displayName} was added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}} and can now view this content."
    },
    successParentRestrictionOnlyEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-parent-restriction-only-edit",
        defaultMessage: "{displayName} was added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}} and can now edit this content."
    },
    successNoRestrictionView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-no-restriction-view",
        defaultMessage: "{displayName} can now view this content."
    },
    successNoRestrictionEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-no-restriction-edit",
        defaultMessage: "{displayName} can now edit this content."
    }
});
const $1ca745aa2c0dd46c$export$9ddb107f546f744e = (requests, formatMessage)=>{
    if (requests.length === 1) {
        const onlyRequest = requests[0];
        const name = onlyRequest?.user?.displayName;
        const accessType = onlyRequest?.requestAccessType;
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.singleRequestTitleEdit : $1ca745aa2c0dd46c$var$i18n.singleRequestTitleView;
        return formatMessage(messageKey, {
            name: name
        });
    }
    if (requests.length > 1) {
        const firstName = requests[0]?.user?.displayName;
        if (requests.length === 2) {
            const secondName = requests[1]?.user?.displayName;
            return formatMessage($1ca745aa2c0dd46c$var$i18n.twoRequestsTitle, {
                firstName: firstName,
                secondName: secondName
            });
        }
        const remainingCount = requests.length - 1;
        return formatMessage($1ca745aa2c0dd46c$var$i18n.multipleRequestsTitle, {
            firstName: firstName,
            remainingCount: remainingCount
        });
    }
    // Should not happen, because method gets invoked if there's at least one request
    return '';
};
const $1ca745aa2c0dd46c$export$6fedf4d3a712a334 = (restrictedUserPrincipalInfo)=>{
    const hasSpaceRestriction = restrictedUserPrincipalInfo?.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE) ?? false;
    const parentRestrictionCount = restrictedUserPrincipalInfo?.restrictedResources?.reduce((res, curr)=>{
        const isParentRestriction = curr?.resourceType !== (0, $1chEN.ResourceType).SPACE;
        return res + (isParentRestriction ? 1 : 0);
    }, 0) ?? 0;
    const hasParentRestriction = parentRestrictionCount > 0;
    const isBlocked = hasSpaceRestriction || hasParentRestriction;
    return {
        isBlocked: isBlocked,
        hasSpaceRestriction: hasSpaceRestriction,
        hasParentRestriction: hasParentRestriction,
        parentRestrictionCount: parentRestrictionCount
    };
};
const $1ca745aa2c0dd46c$export$89885fb2503e60cf = (requests, formatMessage, restrictedUserPrincipalInfo)=>{
    if (requests.length === 1 && restrictedUserPrincipalInfo) {
        const { hasSpaceRestriction: hasSpaceRestriction, hasParentRestriction: hasParentRestriction, parentRestrictionCount: parentRestrictionCount } = $1ca745aa2c0dd46c$export$6fedf4d3a712a334(restrictedUserPrincipalInfo);
        if (hasSpaceRestriction && hasParentRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.spaceAndParentRestriction, {
            parentRestrictionCount: parentRestrictionCount
        });
        else if (hasSpaceRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.spaceRestrictionOnly);
        else if (hasParentRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.parentRestrictionOnly, {
            parentRestrictionCount: parentRestrictionCount
        });
    }
    return null;
};
const $1ca745aa2c0dd46c$export$5afde147a40aa32c = (requests)=>{
    const avatarData = requests.flatMap((request)=>request?.user?.displayName && request?.requestAccessType && request?.user?.id ? {
            name: request.user.displayName,
            src: request.user.photos?.find((photo)=>photo?.isPrimary)?.value ?? undefined,
            key: request.user.id
        } : []);
    const maxCount = avatarData.length === 1 ? 1 : 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: avatarData,
        maxCount: maxCount
    });
};
const $1ca745aa2c0dd46c$export$8a8be71612a7c860 = (requests, restrictedUserPrincipalInfo, processRequest, onReview, onViewDetails, hideFlag, formatMessage)=>{
    if (requests.length === 1) {
        const approveRequest = ()=>{
            processRequest(requests[0], 'APPROVE', restrictedUserPrincipalInfo);
            hideFlag();
        };
        const denyRequest = ()=>{
            processRequest(requests[0], 'DENY', undefined);
            hideFlag();
        };
        const primaryAction = {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.approveButton),
            onClick: approveRequest
        };
        const secondaryAction = restrictedUserPrincipalInfo ? {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.viewDetailsButton),
            onClick: onViewDetails
        } : {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.denyButton),
            onClick: denyRequest
        };
        return [
            primaryAction,
            secondaryAction
        ];
    }
    if (requests.length > 1) return [
        {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.reviewRequestsButton),
            onClick: onReview
        }
    ];
    return [];
};
const $1ca745aa2c0dd46c$export$94e073f79b81300f = (restrictedUserPrincipalInfo, displayName, accessType, formatMessage)=>{
    const { hasSpaceRestriction: hasSpaceRestriction, hasParentRestriction: hasParentRestriction, parentRestrictionCount: parentRestrictionCount } = $1ca745aa2c0dd46c$export$6fedf4d3a712a334(restrictedUserPrincipalInfo);
    if (hasSpaceRestriction && hasParentRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successSpaceAndParentRestrictionEdit : $1ca745aa2c0dd46c$var$i18n.successSpaceAndParentRestrictionView;
        return formatMessage(messageKey, {
            displayName: displayName,
            parentRestrictionCount: parentRestrictionCount
        });
    } else if (hasSpaceRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successSpaceRestrictionOnlyEdit : $1ca745aa2c0dd46c$var$i18n.successSpaceRestrictionOnlyView;
        return formatMessage(messageKey, {
            displayName: displayName
        });
    } else if (hasParentRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successParentRestrictionOnlyEdit : $1ca745aa2c0dd46c$var$i18n.successParentRestrictionOnlyView;
        return formatMessage(messageKey, {
            displayName: displayName,
            parentRestrictionCount: parentRestrictionCount
        });
    }
    const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successNoRestrictionEdit : $1ca745aa2c0dd46c$var$i18n.successNoRestrictionView;
    return formatMessage(messageKey, {
        displayName: displayName
    });
};
const $1ca745aa2c0dd46c$export$9ffd6710da84d7ef = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onDestroy: onDestroy, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onDestroy) {
        t1 = ()=>onDestroy;
        t2 = [
            onDestroy
        ];
        $[0] = onDestroy;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    return children;
};
const $1ca745aa2c0dd46c$export$6cbbb5b074df5c76 = (requests)=>requests.reduce((result, current)=>result + (current?.id ?? ''), '');
module.exports["makeFlagTitle"] = $1ca745aa2c0dd46c$export$9ddb107f546f744e;
module.exports["extractRestrictionInfo"] = $1ca745aa2c0dd46c$export$6fedf4d3a712a334;
module.exports["makeFlagDescription"] = $1ca745aa2c0dd46c$export$89885fb2503e60cf;
module.exports["makeFlagCustomIcon"] = $1ca745aa2c0dd46c$export$5afde147a40aa32c;
module.exports["makeFlagActions"] = $1ca745aa2c0dd46c$export$8a8be71612a7c860;
module.exports["makeSuccessFlagDescription"] = $1ca745aa2c0dd46c$export$94e073f79b81300f;
module.exports["FlagRemovalDetector"] = $1ca745aa2c0dd46c$export$9ffd6710da84d7ef;
module.exports["makeFlagIdSuffix"] = $1ca745aa2c0dd46c$export$6cbbb5b074df5c76;

});

parcelRegister("4PnIU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $451ee996e81d8755$export$4e0e446ffa50ddc0 = ()=>{
    const $ = (0, $frIzR.c)(2);
    const [isActive, setIsActive] = (0, $42omo.useState)(document?.visibilityState === "visible");
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            let timer;
            const handleVisibilityChange = ()=>{
                clearTimeout(timer);
                if (document?.visibilityState === "visible") timer = setTimeout(()=>{
                    setIsActive(true);
                }, 8000);
                else setIsActive(false);
            };
            document?.addEventListener("visibilitychange", handleVisibilityChange);
            return ()=>{
                clearTimeout(timer);
                document?.removeEventListener("visibilitychange", handleVisibilityChange);
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useEffect)(t0, t1);
    return isActive;
};
module.exports["useDocumentActive"] = $451ee996e81d8755$export$4e0e446ffa50ddc0;

});

parcelRegister("Qy97i", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $a3fRD = parcelRequire("a3fRD");


var $3gadb = parcelRequire("3gadb");


var $9Q2dU = parcelRequire("9Q2dU");


var $h1ewt = parcelRequire("h1ewt");


var $buthI = parcelRequire("buthI");

const $e65d026078d2a5b9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    share: {
        id: "share-and-restrict-dialog.controlled-share-button.share",
        defaultMessage: "Share"
    },
    shareArialLabel: {
        id: "share-and-restrict-dialog.controlled-share-button.share-aria-label",
        defaultMessage: "Share, {tooltipMessage}"
    }
});
const $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))),
    restricted: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))),
    public: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($a3fRD)))
};
const $e65d026078d2a5b9$var$makeIconProps = (icon, isDisabled)=>{
    if (isDisabled) return {
        color: "var(--ds-icon-disabled, #080F214A)"
    };
    switch(icon){
        case 'error':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        case 'restricted':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        default:
            return {
                color: "var(--ds-icon-subtle, #505258)"
            };
    }
};
const $e65d026078d2a5b9$export$f939f151d984bfc = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { icon: icon, onClick: onClick, tooltipMessage: tooltipMessage, isDisabled: isDisabled, children: children, focusRef: focusRef } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const Icon = $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT[icon];
    let t1;
    if ($[0] !== icon || $[1] !== isDisabled) {
        t1 = $e65d026078d2a5b9$var$makeIconProps(icon, isDisabled);
        $[0] = icon;
        $[1] = isDisabled;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = {
            label: "",
            ...t1
        };
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const iconProps = t2;
    let t3;
    if ($[5] !== formatMessage || $[6] !== tooltipMessage) {
        t3 = formatMessage(tooltipMessage);
        $[5] = formatMessage;
        $[6] = tooltipMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== children) {
        t4 = ()=>!children;
        $[8] = children;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== Icon || $[11] !== iconProps) {
        t5 = (parentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                ...parentProps,
                ...iconProps,
                size: "medium"
            });
        $[10] = Icon;
        $[11] = iconProps;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== formatMessage || $[14] !== tooltipMessage) {
        t6 = formatMessage($e65d026078d2a5b9$export$a7357cdd1f0b0168.shareArialLabel, {
            tooltipMessage: formatMessage(tooltipMessage)
        });
        $[13] = formatMessage;
        $[14] = tooltipMessage;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e65d026078d2a5b9$export$a7357cdd1f0b0168.share);
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== children || $[18] !== focusRef || $[19] !== isDisabled || $[20] !== onClick || $[21] !== t5 || $[22] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            iconBefore: t5,
            onClick: onClick,
            "aria-label": t6,
            isDisabled: isDisabled,
            ref: focusRef,
            testId: "controlled-share-button"
        }, children, t7);
        $[17] = children;
        $[18] = focusRef;
        $[19] = isDisabled;
        $[20] = onClick;
        $[21] = t5;
        $[22] = t6;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t3 || $[25] !== t4 || $[26] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t3,
            position: "bottom",
            canAppear: t4,
            hideTooltipOnMouseDown: true,
            ignoreTooltipPointerEvents: true,
            delay: 100
        }, t8);
        $[24] = t3;
        $[25] = t4;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
};
module.exports["i18n"] = $e65d026078d2a5b9$export$a7357cdd1f0b0168;
module.exports["ControlledShareButton"] = $e65d026078d2a5b9$export$f939f151d984bfc;

});

parcelRegister("6vDKR", function(module, exports) {

var $38Ncj = parcelRequire("38Ncj");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $9wGTI = parcelRequire("9wGTI");


var $fdPUP = parcelRequire("fdPUP");

const $6663c77035b2c619$var$useShareAndRestrictButtonDataQuery = (0, $38Ncj.default);
const $6663c77035b2c619$var$tooltipMessages = (0, $aXWIB.defineMessages)({
    restricted: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.restricted",
        defaultMessage: "Restricted - Only specific people can access"
    },
    inherited: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.inherited",
        defaultMessage: "Restricted by a parent - Anyone on the parent item can access"
    },
    draft: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.draft",
        defaultMessage: "Open - Anyone in the space (with the link) can access"
    },
    openEdit: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.openEdit",
        defaultMessage: "Open - Anyone in the space can edit"
    },
    openView: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.openView",
        defaultMessage: "Open - Anyone in the space can view"
    },
    public: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.public",
        defaultMessage: "Public - Anyone with the link can access"
    },
    error: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.error",
        defaultMessage: "Access level failed to load"
    }
});
const $6663c77035b2c619$var$getIconAndTooltipFromData = (isPublicLinkOn, hasInheritedRestrictions, hasViewRestrictions, isErrored, isUnpublishedDraft, hasRestrictions)=>{
    if (isErrored) return [
        'error',
        $6663c77035b2c619$var$tooltipMessages.error
    ];
    if (isPublicLinkOn) return [
        'public',
        $6663c77035b2c619$var$tooltipMessages.public
    ];
    if (hasViewRestrictions) return [
        'restricted',
        $6663c77035b2c619$var$tooltipMessages.restricted
    ];
    if (hasInheritedRestrictions) return [
        'restricted',
        $6663c77035b2c619$var$tooltipMessages.inherited
    ];
    if (isUnpublishedDraft) return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.draft
    ];
    if (hasRestrictions) return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.openView
    ];
    return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.openEdit
    ];
};
const $6663c77035b2c619$var$EXPECTED_FREE_EDITION_PUBLIC_LINK_ERROR = 'This is a Standard/Premium feature. You are currently subscribed to the Free plan.';
const $6663c77035b2c619$export$9a3aafa686359f8d = (contentId, isContentTypePublicLinkEligible, isUnpublishedDraft)=>{
    const shouldIncludePublicLink = isContentTypePublicLinkEligible && (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? true : isContentTypePublicLinkEligible;
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($6663c77035b2c619$var$useShareAndRestrictButtonDataQuery, {
        variables: {
            contentId: contentId,
            isContentTypePublicLinkEligible: shouldIncludePublicLink
        },
        fetchPolicy: (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? 'cache-and-network' : 'network-only',
        errorPolicy: 'all'
    });
    const errors = [];
    if (error?.message.includes($6663c77035b2c619$var$EXPECTED_FREE_EDITION_PUBLIC_LINK_ERROR)) (0, $7Sm4c.markErrorAsHandled)(error);
    else if (error) errors.push(error);
    const hasRestrictions = Boolean(data?.singleContent?.hasRestrictions);
    const hasInheritedRestrictions = Boolean(data?.singleContent?.hasInheritedRestrictions);
    const hasViewRestrictions = Boolean(data?.singleContent?.hasViewRestrictions);
    const pageTitle = data?.singleContent?.title;
    const isPublicLinkOn = shouldIncludePublicLink ? data?.publicLinkPage?.pageStatus === 'ON' : false;
    const [icon, tooltipMessage] = $6663c77035b2c619$var$getIconAndTooltipFromData(isPublicLinkOn, hasInheritedRestrictions, hasViewRestrictions, Boolean(errors.length), isUnpublishedDraft, hasRestrictions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'shareAndRestrictButtonQuery',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    cause: error?.cause
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent
    ]);
    return {
        icon: icon,
        tooltipMessage: tooltipMessage,
        refetch: ()=>{
            refetch({
                contentId: contentId,
                isContentTypePublicLinkEligible: shouldIncludePublicLink
            });
        },
        // When navigating in SPA, the cache-and-network fetchPolicy will initially return the data
        // from the previous page if the current one has not been visited before. This check ensures
        // that we show the loading state when the data for this content is not actually available.
        isLoading: loading && !Boolean(data?.singleContent?.id === contentId),
        error: errors.length > 0 ? errors[0] : null,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        isPublicLinkOn: isPublicLinkOn,
        pageTitle: pageTitle,
        isUnpublishedDraft: isUnpublishedDraft
    };
};
module.exports["useShareAndRestrictButtonData"] = $6663c77035b2c619$export$9a3aafa686359f8d;

});

parcelRegister("5QBqz", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0e2cc7602bd622b9$var$initialState = {
    hasClickedShareButton: false
};
const $0e2cc7602bd622b9$var$actions = {
    setHasClickedShareButton: ()=>({ setState: setState })=>{
            setState({
                hasClickedShareButton: true
            });
        },
    resetHasClickedShareButton: ()=>({ setState: setState })=>{
            setState({
                hasClickedShareButton: false
            });
        }
};
const $0e2cc7602bd622b9$var$ShareAndRestrictButtonStore = (0, $1P1Tu.createStore)({
    initialState: $0e2cc7602bd622b9$var$initialState,
    actions: $0e2cc7602bd622b9$var$actions,
    name: 'ShareAndRestrictButtonStore'
});
const $0e2cc7602bd622b9$export$15991ed5dace2362 = (0, $9zUhf.createStateHook)($0e2cc7602bd622b9$var$ShareAndRestrictButtonStore);
const $0e2cc7602bd622b9$export$6033af6626ad7b59 = (0, $9zUhf.createActionsHook)($0e2cc7602bd622b9$var$ShareAndRestrictButtonStore);
module.exports["useShareAndRestrictButtonActions"] = $0e2cc7602bd622b9$export$6033af6626ad7b59;

});

parcelRegister("gTPPC", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $bcc2dd382176fa47$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
//THE GA Date of USD, any users onboarding on or after this date are considered new users
const $bcc2dd382176fa47$var$NEW_USER_FROM_DATE = new Date('2025-03-24');
const $bcc2dd382176fa47$export$750d18e9348a361a = ()=>{
    const $ = (0, $frIzR.c)(14);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const t0 = userId ?? "";
    let t1;
    if ($[0] !== cloudId || $[1] !== t0) {
        t1 = {
            cloudId: cloudId,
            userId: t0
        };
        $[0] = cloudId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !userId || !cloudId;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data, loading: loading, error: error } = (0, $gqypm.useExperimentalSiteUserPersonalization)(t3);
    if (loading || error) {
        let t4;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                isNewUser: true
            };
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const attributes = data?.experimentalSiteUserPersonalization?.attributes;
    let firstActiveDate;
    let t4;
    let t5;
    if ($[7] !== attributes) {
        const firstActiveValue = attributes?.find($bcc2dd382176fa47$var$_temp)?.value;
        firstActiveDate = new Date(firstActiveValue ?? "");
        t4 = isNaN;
        t5 = firstActiveDate.getTime();
        $[7] = attributes;
        $[8] = firstActiveDate;
        $[9] = t4;
        $[10] = t5;
    } else {
        firstActiveDate = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    const isValidDate = !t4(t5);
    if (!isValidDate) {
        let t6;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                isNewUser: true
            };
            $[11] = t6;
        } else t6 = $[11];
        return t6;
    }
    const t6 = Boolean(firstActiveDate >= $bcc2dd382176fa47$var$NEW_USER_FROM_DATE);
    let t7;
    if ($[12] !== t6) {
        t7 = {
            isNewUser: t6
        };
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
function $bcc2dd382176fa47$var$_temp(t0) {
    const { name: name } = t0;
    return name === $bcc2dd382176fa47$var$CONFLUENCE_FIRST_ACTIVE_TRAIT;
}
module.exports["useIsNewUser"] = $bcc2dd382176fa47$export$750d18e9348a361a;

});

parcelRegister("lT8a1", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $Qy97i = parcelRequire("Qy97i");

const $1b4f772a0e4dae00$var$iconSkeletonStyle = (0, $ecnYn.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    marginLeft: 'space.050',
    marginRight: 'space.025',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $1b4f772a0e4dae00$var$SkeletonGlyph = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "icon-skeleton",
            xcss: $1b4f772a0e4dae00$var$iconSkeletonStyle
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $1b4f772a0e4dae00$export$b125768944fa8b3 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "default",
            iconBefore: $1b4f772a0e4dae00$var$_temp,
            onClick: $1b4f772a0e4dae00$var$_temp2,
            isDisabled: true,
            testId: "share-and-restrict-button-placeholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $Qy97i.i18n).share));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $1b4f772a0e4dae00$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1b4f772a0e4dae00$var$SkeletonGlyph, null);
}
function $1b4f772a0e4dae00$var$_temp2() {}
module.exports["ShareAndRestrictButtonPlaceholder"] = $1b4f772a0e4dae00$export$b125768944fa8b3;

});

parcelRegister("grWYF", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $2Fndw = parcelRequire("2Fndw");


var $dPJCf = parcelRequire("dPJCf");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");

const $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('journeyId');
function $3a4ed6f24f1b06e9$export$715107a573a5fba6(t0) {
    const $ = (0, $frIzR.c)(11);
    const { onClose: onClose, journeyId: journeyId } = t0;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== journeyId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingPagePermissionsSpotlight",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        journeyId: journeyId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            journeyId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = journeyId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.ok",
            defaultMessage: "Ok"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClose) {
        t4 = [
            {
                onClick: onClose,
                text: t3
            }
        ];
        $[5] = onClose;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.body",
            defaultMessage: "Control who can view, edit, and comment on your pages."
        });
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== Spotlight || $[9] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            actions: t4,
            target: "share-button-spotlight-target",
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "bottom right",
            dialogWidth: 275,
            messageType: "transactional"
        }, t5);
        $[8] = Spotlight;
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
function $3a4ed6f24f1b06e9$export$31f46f470e475335() {
    const $ = (0, $frIzR.c)(10);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const journeyId = $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const hasRun = (0, $42omo.useRef)(false);
    const [cachedJourneyId, setCachedJourneyId] = (0, $42omo.useState)();
    let t0;
    let t1;
    if ($[0] !== journeyId || $[1] !== setQueryParams) {
        t0 = ()=>{
            if (hasRun.current) return;
            hasRun.current = true;
            if (journeyId !== "onboarding-page-permissions") return;
            setCachedJourneyId(journeyId);
            setQueryParams({
                journeyId: null
            });
            setIsSpotlightActive(true);
        };
        t1 = [
            journeyId,
            setQueryParams
        ];
        $[0] = journeyId;
        $[1] = setQueryParams;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsSpotlightActive(false);
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClose = t2;
    let t3;
    if ($[5] !== cachedJourneyId || $[6] !== isSpotlightActive) {
        t3 = isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a4ed6f24f1b06e9$export$715107a573a5fba6, {
            onClose: handleOnClose,
            journeyId: cachedJourneyId
        });
        $[5] = cachedJourneyId;
        $[6] = isSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
}
module.exports["OnboardingPagePermissionsSpotlight"] = $3a4ed6f24f1b06e9$export$715107a573a5fba6;
module.exports["OnboardingPagePermissionsSpotlightLoader"] = $3a4ed6f24f1b06e9$export$31f46f470e475335;

});

parcelRegister("cxCWb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $gaGKC = parcelRequire("gaGKC");


const $56c3dbef55a81b41$export$a1f5ff36b0810fd8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "0sh4s",
    name: "FavouriteButton",
    loader: async ()=>(await (parcelRequire("1Irnp"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});

const $56c3dbef55a81b41$export$4151d732511e5aa6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "m_S4n",
    name: "LazyFavouriteButton",
    loader: async ()=>(await (parcelRequire("1Irnp"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});
module.exports["FavouriteButton"] = $56c3dbef55a81b41$export$a1f5ff36b0810fd8;
module.exports["LazyFavouriteButton"] = $56c3dbef55a81b41$export$4151d732511e5aa6;

});

parcelRegister("gaGKC", function(module, exports) {
/* FavouriteButtonPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $kfYj7 = parcelRequire("kfYj7");

const $97ecf1ddef823285$var$i18n = (0, $aXWIB.defineMessages)({
    starLabel: {
        id: "favourite-button.placeholder.star.label",
        defaultMessage: "Star"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97ecf1ddef823285$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $97ecf1ddef823285$export$d599e45cb4e3913 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($97ecf1ddef823285$var$StyledButton, {
        "data-test-id": "page-favourite-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
            label: formatMessage($97ecf1ddef823285$var$i18n.starLabel),
            color: "currentColor",
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["FavouriteButtonPlaceholder"] = $97ecf1ddef823285$export$d599e45cb4e3913;

});

parcelRegister("1Irnp", function(module, exports) {

let $13ff22e5daed4ae5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $13ff22e5daed4ae5$var$load("lUs3J"),
    $13ff22e5daed4ae5$var$load("6wr18"),
    $13ff22e5daed4ae5$var$load("ffEVr"),
    $13ff22e5daed4ae5$var$load("fZt2F"),
    $13ff22e5daed4ae5$var$load("1sXQt")
]).then(()=>parcelRequire('lDaLP'));

});

parcelRegister("cf6nm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gI8uy = parcelRequire("gI8uy");


var $kfYj7 = parcelRequire("kfYj7");


var $cOrQJ = parcelRequire("cOrQJ");

const $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e = ({ isStarred: isStarred, spacing: spacing = 'spacious' })=>{
    const theme = (0, $cOrQJ.default)();
    const starredColor = theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
        label: "",
        color: starredColor,
        spacing: spacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
        label: "",
        color: "currentColor",
        spacing: spacing
    });
};
module.exports["StarIcon"] = $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e;

});

parcelRegister("77a1U", function(module, exports) {

var $4GiSr = parcelRequire("4GiSr");


var $9fsLe = parcelRequire("9fsLe");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $cfidN = parcelRequire("cfidN");


var $308Wd = parcelRequire("308Wd");

const $280d5b858bf30a19$var$PageStarActionButtonPageStarMutation = (0, $9fsLe.default);
const $280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation = (0, $4GiSr.default);
const $280d5b858bf30a19$var$i18n = (0, $aXWIB.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.content.star.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble starring this"
    },
    unstarErrorTitle: {
        id: "action-buttons.content.unstar.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble unstarring this"
    },
    starSuccessFlagTitle: {
        id: "action-buttons.content.star.success.title",
        defaultMessage: "{contentTitle} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.content.unstar.success.title",
        defaultMessage: "{contentTitle} unstarred"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh the page and try again."
    }
});
const $280d5b858bf30a19$var$useStarAnalytics = (contentId, analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const stringAttrs = JSON.stringify(analytics?.attributes);
    return (0, $42omo.useCallback)((action)=>{
        if (!analytics) return;
        const { source: source, containerId: containerId, attributes: attributes } = analytics;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'favouritePage',
                source: source,
                attributes: attributes,
                objectId: contentId,
                ...containerId && {
                    containerId: containerId
                }
            }
        }).fire();
    }, // Using stringAttrs as dependency instead of analytics.attributes
    // https://github.com/facebook/react/issues/14476
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        createAnalyticsEvent,
        analytics?.source,
        stringAttrs
    ]);
};
const $280d5b858bf30a19$var$PageStarComponent = ({ contentId: contentId, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, contentTitle: contentTitle = '', shouldShowFlags: shouldShowFlags = false })=>{
    const sendAnalyticsEvent = $280d5b858bf30a19$var$useStarAnalytics(contentId, analytics);
    const [star, { error: starError }] = (0, $308Wd.useMutationInterop)($280d5b858bf30a19$var$PageStarActionButtonPageStarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('created');
        },
        optimisticResponse: {
            favouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: {
                                // @ts-ignore TS doesn't recognize __typename which is needed for mutation
                                __typename: 'FavouritedSummary',
                                isFavourite: true,
                                favouritedDate: new Date().toISOString()
                            }
                        }
                    }
                }
            }
        }
    });
    const [unstar, { error: unstarError }] = (0, $308Wd.useMutationInterop)($280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('deleted');
        },
        optimisticResponse: {
            unfavouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            // @ts-ignore TS doesn't recognize __typename which is needed for mutation
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: null
                        }
                    }
                }
            }
        }
    });
    const toggleStar = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) {
            onUnstar && onUnstar(e);
            unstar().then(()=>{
                if (shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        } else {
            onStar && onStar(e);
            star().then(()=>{
                if (shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.starSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        }
    }, [
        isStarred,
        onStar,
        star,
        onUnstar,
        unstar,
        contentTitle,
        flags,
        intl,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.starErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $280d5b858bf30a19$export$110ac8adb8c8c03 = (0, $7aRa9.withFlags)((0, $aXWIB.injectIntl)($280d5b858bf30a19$var$PageStarComponent));
module.exports["PageStar"] = $280d5b858bf30a19$export$110ac8adb8c8c03;

});

parcelRegister("4GiSr", function(module, exports) {
/**
 * @generated SignedSource<<f7e21bb7b4d4c7192a37c7abfbbab20d>>
 * @relayHash d1da572c7c92b4b266a94268aa3424c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5938f592be4f9ebb2a4b0128e9ff6974fda1a9904b1cf83b7ff9a9ab5cf46b5
const $dc0ccf8bb0c1b893$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "unfavouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStarActionButtonPageUnstarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStarActionButtonPageUnstarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d1da572c7c92b4b266a94268aa3424c4",
            "id": "e5938f592be4f9ebb2a4b0128e9ff6974fda1a9904b1cf83b7ff9a9ab5cf46b5",
            "metadata": {},
            "name": "PageStarActionButtonPageUnstarMutation",
            "operationKind": "mutation",
            "text": "mutation PageStarActionButtonPageUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
        }
    };
}();
$dc0ccf8bb0c1b893$var$node.hash = "a57f208826520a57e991955e40d84900";
var $dc0ccf8bb0c1b893$export$2e2bcd8739ae039 = $dc0ccf8bb0c1b893$var$node;
module.exports["default"] = $dc0ccf8bb0c1b893$export$2e2bcd8739ae039;

});

parcelRegister("9fsLe", function(module, exports) {
/**
 * @generated SignedSource<<bbc123c3686e3650592fae2a53a287d9>>
 * @relayHash 893e4cc7292e06a05c8e163bfde7c2d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000
const $6cc5c6f8cf8165a3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "favouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStarActionButtonPageStarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStarActionButtonPageStarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "893e4cc7292e06a05c8e163bfde7c2d8",
            "id": "e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000",
            "metadata": {},
            "name": "PageStarActionButtonPageStarMutation",
            "operationKind": "mutation",
            "text": "mutation PageStarActionButtonPageStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
        }
    };
}();
$6cc5c6f8cf8165a3$var$node.hash = "2fe8e2e773241c74a33b1336ab2db2b2";
var $6cc5c6f8cf8165a3$export$2e2bcd8739ae039 = $6cc5c6f8cf8165a3$var$node;
module.exports["default"] = $6cc5c6f8cf8165a3$export$2e2bcd8739ae039;

});

parcelRegister("cfidN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7aRa9 = parcelRequire("7aRa9");


var $b3j2Y = parcelRequire("b3j2Y");

const $774441f3315c6f72$export$5b6a77363c518c1c = (0, $7aRa9.withFlags)(({ flags: flags, title: title, description: description, error: error })=>{
    (0, $42omo.useEffect)(()=>{
        flags.showErrorFlag({
            id: 'action-button-error',
            title: title,
            description: description
        });
    }, [
        title,
        description,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
});
module.exports["ActionErrorFlag"] = $774441f3315c6f72$export$5b6a77363c518c1c;

});

parcelRegister("9SsRl", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $730f8b16a3d58539$export$8ce793b178574678 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["WATCH_BUTTON_METRIC"] = $730f8b16a3d58539$export$8ce793b178574678;

});

parcelRegister("bl4QJ", function(module, exports) {
/* WatchButtonPlaceholder.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $8cjip = parcelRequire("8cjip");


var $eEA8O = parcelRequire("eEA8O");

const $84156adddab51810$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $84156adddab51810$export$2d7669ced06071f = ({ compact: compact })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($84156adddab51810$export$2d5d2ba3c7c8c40b, {
        testId: "watch-button-placeholder",
        "data-test-id": "watch-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: "WatchIcon",
            spacing: "spacious"
        }),
        isDisabled: true,
        spacing: compact ? 'compact' : 'default'
    });
$84156adddab51810$export$2d7669ced06071f.propTypes = {
    compact: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["WatchButtonPlaceholder"] = $84156adddab51810$export$2d7669ced06071f;

});

parcelRegister("5EoFB", function(module, exports) {
const $41d3d3266b0b22cf$export$6b0a1934b74e691a = {
    PAGE: 0,
    SPACE: 1
};
const $41d3d3266b0b22cf$export$1841061cdd9b445a = 20;
module.exports["MANAGE_WATCHER_TAB_TYPES"] = $41d3d3266b0b22cf$export$6b0a1934b74e691a;

});

parcelRegister("gqsYd", function(module, exports) {
const $bf558bf49003e931$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["CONFLUENCE_EDITION"] = $bf558bf49003e931$export$4b915fb24c39b396;

});

parcelRegister("49Q03", function(module, exports) {

var $jroIa = parcelRequire("jroIa");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4xcIM = parcelRequire("4xcIM");

parcelRequire("irOoi");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gqqjz = parcelRequire("gqqjz");


var $lOkIA = parcelRequire("lOkIA");


var $jmjWc = parcelRequire("jmjWc");


var $2VQ4B = parcelRequire("2VQ4B");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $7zgzO = parcelRequire("7zgzO");


var $g1WP0 = parcelRequire("g1WP0");


var $308Wd = parcelRequire("308Wd");


var $20FI0 = parcelRequire("20FI0");


var $9SsRl = parcelRequire("9SsRl");


var $2REhP = parcelRequire("2REhP");


var $jle6C = parcelRequire("jle6C");


var $6in0A = parcelRequire("6in0A");


const $47908050ea4fd9b1$export$9c5737ae30e94007 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aohZt",
    name: "LazyWatchDialogContent",
    loader: async ()=>(await (parcelRequire("22b11"))).WatchDialogContent,
    loading: ({ shouldSSRWatchButton: shouldSSRWatchButton })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                width: '325px',
                height: '180px'
            }
        }, !shouldSSRWatchButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        }))
});

const $47908050ea4fd9b1$var$LazyWatchDialogShortcut = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gDGxN",
    name: "LazyWatchDialogShortcut",
    loader: async ()=>(await (parcelRequire("a22sU"))).WatchDialogShortcut
});
const $47908050ea4fd9b1$var$i18n = (0, $aXWIB.defineMessages)({
    watchContentDialogLabel: {
        id: "watch-dialog.popup.label",
        defaultMessage: "Watch content dialog"
    }
});
const $47908050ea4fd9b1$export$f521883565cfd8d9 = (0, $jroIa.default);
const $47908050ea4fd9b1$export$4b54507e0234ad87 = (0, $aXWIB.injectIntl)(({ contentId: contentId, spaceId: spaceId, params: params, defaultTab: defaultTab, customPlacement: customPlacement, flagsContainer: flagsContainer, isDisabled: /**
   * This disables the usage of the watch button and dialog.
   *
   * Note: If a `customTrigger` is provided, this will be passed through
   * as `isDisabled`. However, as a fallback, even if the button is not
   * disabled properly, the logic here will continue to be disabled.
   */ isDisabled, customTrigger: customTrigger, useShortcut: useShortcut, shouldSSRWatchButton: shouldSSRWatchButton, skipTrialDetailsQuery: skipTrialDetailsQuery, contentType: contentType, componentLocation: componentLocation, intl: intl })=>{
    const [dialogOpen, setDialogOpen] = (0, $42omo.useState)(false);
    const [shouldOpenWatchDialogFromQueryParams, setShouldOpenWatchDialogFromQueryParams] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const nudgeRef = (0, $42omo.useRef)(null);
    const { isWatchingContent: isWatchingContent, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, isWatchingSpace: isWatchingSpace } = params;
    (0, $42omo.useEffect)(()=>{
        if (isDisabled) return;
        const { openWatchModal: openWatchModal } = getQueryParams();
        setShouldOpenWatchDialogFromQueryParams(openWatchModal === 'true' && (componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).SPACE_OVERVIEW || componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).PAGE));
        if (shouldOpenWatchDialogFromQueryParams) setDialogOpen(true);
    }, [
        isDisabled,
        getQueryParams,
        componentLocation,
        shouldOpenWatchDialogFromQueryParams
    ]);
    const removeOpenModalQueryParams = ()=>{
        const queryParams = getQueryParams();
        if (queryParams.openWatchModal) {
            setQueryParams({
                ...queryParams,
                openWatchModal: undefined
            }, true);
            setShouldOpenWatchDialogFromQueryParams(false);
        }
    };
    const toggleDialog = (0, $42omo.useCallback)(()=>{
        // Do not enable open the dialog if watch is disabled
        if (isDisabled) return;
        setDialogOpen((prevState)=>!prevState);
    }, [
        isDisabled
    ]);
    const isWatching = (0, $42omo.useCallback)(()=>{
        // If watch is disabled, then the user will default to not watching
        return isDisabled ? false : isWatchingContent || isWatchingSpace || isWatchingChildren || hasAncestorWatchingChildren;
    }, [
        isWatchingContent,
        isWatchingChildren,
        hasAncestorWatchingChildren,
        isWatchingSpace,
        isDisabled
    ]);
    const updateQueryHandler = (updateContentType, newDataValue)=>{
        const contentData = (0, $l1uFv.readQueryInterop)({
            query: $47908050ea4fd9b1$export$f521883565cfd8d9,
            variables: {
                contentId: contentId
            }
        });
        switch(updateContentType){
            case (0, $jle6C.UpdateContentType).CONTENT:
                contentData.singleContent.currentUserIsWatching = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).CHILDREN:
                contentData.singleContent.currentUserIsWatchingChildren = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).SPACE:
                contentData.singleContent.space.currentUser.isWatched = newDataValue;
                break;
            default:
                contentData.singleContent.space.currentUser.isWatchingBlogs = newDataValue;
                break;
        }
        (0, $fEmGS.writeQueryInterop)({
            query: $47908050ea4fd9b1$export$f521883565cfd8d9,
            data: contentData
        });
    };
    const fireWatchAnalyticsEvent = (0, $42omo.useCallback)((action, actionSubject)=>{
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            objectId: contentId,
            objectType: contentType,
            source: 'WatchButton'
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const [watchContent] = (0, $308Wd.useMutationInterop)((0, $6in0A.default), {
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
            toggleDialog();
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE),
                error: error.message
            });
        },
        update: (_, { data: { watchContent: watchContentData } })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CONTENT, watchContentData.content.currentUserIsWatching);
        }
    });
    const handleOneClickWatch = (0, $42omo.useCallback)(async ()=>{
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE));
        if (experienceState === null || experienceState.hasStopped) experienceTracker.start({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
        });
        await watchContent({
            variables: {
                id: contentId
            }
        });
    }, [
        watchContent,
        contentId,
        experienceTracker
    ]);
    const handleWatchButtonClick = (0, $42omo.useCallback)(async ()=>{
        if (dialogOpen || isWatching()) toggleDialog();
        else await handleOneClickWatch();
    }, [
        toggleDialog,
        isWatching,
        dialogOpen,
        handleOneClickWatch
    ]);
    const openDialog = ()=>{
        setDialogOpen(true);
    };
    const closeDialog = ()=>{
        setDialogOpen(false);
    };
    const renderPopupTrigger = (triggerProps)=>{
        const TriggerButton = customTrigger || (0, $20FI0.WatchButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TriggerButton, {
            isDisabled: isDisabled,
            isWatching: isWatching(),
            isSelected: dialogOpen,
            onMouseOver: $47908050ea4fd9b1$export$9c5737ae30e94007.preload,
            onClick: handleWatchButtonClick,
            triggerProps: triggerProps,
            shouldSSRWatchButton: shouldSSRWatchButton,
            defaultTab: defaultTab,
            contentId: contentId,
            updateQueryHandler: updateQueryHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE),
            attributes: {
                isWatching: isWatching()
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
        }));
    };
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"}`
            },
            ref: nudgeRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($47908050ea4fd9b1$export$9c5737ae30e94007, {
            contentId: contentId,
            spaceId: spaceId,
            defaultTab: defaultTab,
            params: params,
            closeWatchDialog: closeDialog,
            updateQueryHandler: updateQueryHandler,
            skipTrialDetailsQuery: skipTrialDetailsQuery,
            contentType: contentType,
            shouldOpenWatchDialogFromQueryParams: shouldOpenWatchDialogFromQueryParams,
            removeOpenModalQueryParams: removeOpenModalQueryParams
        })), dialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g1WP0.AsyncWrapper), {
            trigger: "watch-page",
            showImage: false,
            width: 357,
            reference: nudgeRef
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, useShortcut && !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($47908050ea4fd9b1$var$LazyWatchDialogShortcut, {
        contentId: contentId,
        contentType: contentType,
        params: params,
        flagsContainer: flagsContainer,
        openDialog: openDialog,
        updateQueryHandler: updateQueryHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: dialogOpen,
        onClose: closeDialog,
        content: ()=>renderPopupContent(),
        trigger: renderPopupTrigger,
        placement: customPlacement,
        role: "dialog",
        label: intl.formatMessage($47908050ea4fd9b1$var$i18n.watchContentDialogLabel),
        testId: "watch-content-dialog",
        shouldRenderToParent: true
    }));
});
$47908050ea4fd9b1$export$4b54507e0234ad87.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        isWatchingContent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
        isWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
        hasAncestorWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
        isWatchingSpace: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
    }).isRequired,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number.isRequired,
    customPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    flagsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).instanceOf((0, $gqqjz.FlagsStateContainer)),
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    customTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).elementType,
    useShortcut: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    shouldSSRWatchButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    skipTrialDetailsQuery: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number
};
module.exports["WatchDialogComponentWithWatchChildrenQuery"] = $47908050ea4fd9b1$export$f521883565cfd8d9;
module.exports["WatchDialogComponent"] = $47908050ea4fd9b1$export$4b54507e0234ad87;

});

parcelRegister("20FI0", function(module, exports) {
/* WatchButton.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $fCjCI = parcelRequire("fCjCI");


var $8cjip = parcelRequire("8cjip");


var $3gadb = parcelRequire("3gadb");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $cMvQV = parcelRequire("cMvQV");

const $176bef54c656e043$var$i18n = (0, $aXWIB.defineMessages)({
    startWatchingIconLabel: {
        id: "watch-dialog.watch-button.start.watching.label",
        defaultMessage: "Start watching"
    },
    stopWatchingIconLabel: {
        id: "watch-dialog.watch-button.stop.watching.label",
        defaultMessage: "Stop watching"
    },
    watchStopTooltip: {
        id: "watch-dialog.stop.button.tooltip",
        defaultMessage: "Stop watching"
    },
    watchStartTooltip: {
        id: "watch-dialog.start.button.tooltip",
        defaultMessage: "Watch"
    }
});
const $176bef54c656e043$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9",
            __cmplp.className
        ])
    });
});
const $176bef54c656e043$var$WatchButtonComponent = ({ isDisabled: isDisabled, isWatching: isWatching, isSelected: isSelected, onClick: onClick, onMouseOver: onMouseOver, intl: intl, triggerProps: triggerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const fireClickAnalyticsEvent = (0, $42omo.useCallback)(()=>{
        const analyticsData = {
            action: 'clicked',
            actionSubject: 'content-watch-button',
            source: 'viewPageScreen'
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleWatchButtonClick = ()=>{
        onClick();
        fireClickAnalyticsEvent();
    };
    const shortcutContent = isWatching ? intl.formatMessage($176bef54c656e043$var$i18n.watchStopTooltip) : intl.formatMessage($176bef54c656e043$var$i18n.watchStartTooltip);
    const getTooltipContent = ()=>{
        if (isDisabled) return undefined;
        if (isLiveEditMode || isOnEditRoute) return shortcutContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT),
            contentBefore: shortcutContent,
            isTooltip: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        content: getTooltipContent()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($176bef54c656e043$export$2d5d2ba3c7c8c40b, {
        "data-id": "page-watch-button",
        "data-test-id": "page-watch-button",
        testId: "page-watch-button",
        appearance: "subtle",
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleWatchButtonClick,
        onMouseOver: onMouseOver,
        onFocus: onMouseOver,
        iconBefore: isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.stopWatchingIconLabel),
            testId: "watch-filled-icon",
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.startWatchingIconLabel),
            testId: "watch-icon",
            spacing: "spacious"
        }),
        ...triggerProps
    }));
};
$176bef54c656e043$var$WatchButtonComponent.propTypes = {
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isWatching: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    triggerProps: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $176bef54c656e043$export$e149a93a7ac7f896 = (0, $aXWIB.injectIntl)($176bef54c656e043$var$WatchButtonComponent);
module.exports["WatchButton"] = $176bef54c656e043$export$e149a93a7ac7f896;

});

parcelRegister("2REhP", function(module, exports) {
const $215fc810f2773ade$export$613942ed7ac4b968 = {
    PAGE: 0,
    SPACE_OVERVIEW: 1,
    FEED: 2,
    WHITEBOARD: 3
};
module.exports["WATCH_DIALOG_LOCATION"] = $215fc810f2773ade$export$613942ed7ac4b968;

});

parcelRegister("jle6C", function(module, exports) {
var $b11a466056fa4426$export$f8bb0b205e1c369c = /*#__PURE__*/ function(UpdateContentType) {
    UpdateContentType["CONTENT"] = "content";
    UpdateContentType["CHILDREN"] = "children";
    UpdateContentType["BLOGS_IN_SPACE"] = "blogs";
    UpdateContentType["SPACE"] = "space";
    return UpdateContentType;
}({});
var $b11a466056fa4426$export$3b880fb327a46f45 = /*#__PURE__*/ function(UpdateType) {
    UpdateType["WATCH"] = "watch";
    UpdateType["UNWATCH"] = "unwatch";
    return UpdateType;
}({});
module.exports["UpdateContentType"] = $b11a466056fa4426$export$f8bb0b205e1c369c;
module.exports["UpdateType"] = $b11a466056fa4426$export$3b880fb327a46f45;

});

parcelRegister("6in0A", function(module, exports) {
/**
 * @generated SignedSource<<10b298fe390a3da60ae20697e25ba8b5>>
 * @relayHash fd81f231087cf7200e9dc6564487d4ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286
const $e1f35a163a9ce341$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "id"
                        },
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchContentInput"
                }
            ],
            "concreteType": "WatchContentPayload",
            "kind": "LinkedField",
            "name": "watchContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentUserIsWatching"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchDialogContentWatchContentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchDialogContentWatchContentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fd81f231087cf7200e9dc6564487d4ac",
            "id": "8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286",
            "metadata": {},
            "name": "WatchDialogContentWatchContentMutation",
            "operationKind": "mutation",
            "text": "mutation WatchDialogContentWatchContentMutation($id:ID!){watchContent(watchContentInput:{contentId:$id,currentUser:true}){content{id,currentUserIsWatching}}}"
        }
    };
}();
$e1f35a163a9ce341$var$node.hash = "c3af78be0429c7abdaa087ce8a337162";
var $e1f35a163a9ce341$export$2e2bcd8739ae039 = $e1f35a163a9ce341$var$node;
module.exports["default"] = $e1f35a163a9ce341$export$2e2bcd8739ae039;

});

parcelRegister("22b11", function(module, exports) {

let $17b450235cbee487$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17b450235cbee487$var$load("lUs3J"),
    $17b450235cbee487$var$load("9OSao")
]).then(()=>parcelRequire('jjM3c'));

});

parcelRegister("a22sU", function(module, exports) {

let $74dc00dc6e3893df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74dc00dc6e3893df$var$load("8hbZ5").then(()=>parcelRequire('j00wp'));

});

parcelRegister("f9HtC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0896bd7bf351fc8$export$73075fe16d77da88 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ckcO3",
    name: "ManageWatcherDialogLoader",
    loader: async ()=>(await (parcelRequire("feNK0"))).ManageWatcherDialog
});
module.exports["ManageWatcherDialogLoader"] = $b0896bd7bf351fc8$export$73075fe16d77da88;

});

parcelRegister("feNK0", function(module, exports) {

let $b17ebf54def08218$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b17ebf54def08218$var$load("6wr18"),
    $b17ebf54def08218$var$load("c831e"),
    $b17ebf54def08218$var$load("1GCFv"),
    $b17ebf54def08218$var$load("h4Nf7"),
    $b17ebf54def08218$var$load("9hYRW"),
    $b17ebf54def08218$var$load("kpm7S"),
    $b17ebf54def08218$var$load("ffEVr"),
    $b17ebf54def08218$var$load("7EorR"),
    $b17ebf54def08218$var$load("Wowvf"),
    $b17ebf54def08218$var$load("5RR9C"),
    $b17ebf54def08218$var$load("hhss7"),
    $b17ebf54def08218$var$load("iJwzY")
]).then(()=>parcelRequire('45gVm'));

});

parcelRegister("jeQ9x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $3Ttlf = parcelRequire("3Ttlf");


const $476a1a146c5d6cec$export$c41c4f98f15bcd25 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "I7qQB",
    name: "PublishButtonWithMoreOptions",
    loader: async ()=>{
        return (await (parcelRequire("lWizu"))).PublishButtonWithMoreOptions;
    },
    loading: (0, $3Ttlf.PlaceholderPublishButton)
});
module.exports["PublishButtonWithMoreOptions"] = $476a1a146c5d6cec$export$c41c4f98f15bcd25;

});

parcelRegister("3Ttlf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $9gE7g = parcelRequire("9gE7g");


var $buthI = parcelRequire("buthI");


var $9wGTI = parcelRequire("9wGTI");


var $lACKt = parcelRequire("lACKt");

const $6d1be32de0860931$export$a6f3e6c7a6e250cc = ({ publishButtonDisabled: publishButtonDisabled, isUnpublishedDraft: isUnpublishedDraft, shouldShowWorldIcon: shouldShowWorldIcon })=>{
    const intl = (0, $aXWIB.useIntl)();
    if (!isUnpublishedDraft) {
        const WorldIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                label: intl.formatMessage((0, $lACKt.i18nShared).updatePublicContentLabel),
                color: "var(--ds-icon-inverse, #FFFFFF)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), {
            appearance: "primary",
            isDisabled: publishButtonDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            isDisabled: publishButtonDisabled,
            iconBefore: shouldShowWorldIcon ? WorldIcon : undefined
        }, intl.formatMessage((0, $lACKt.i18nShared).updateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader : (0, $lACKt.i18nShared).chevronButtonTooltip)
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $lACKt.i18nShared).publishButton));
};
module.exports["PlaceholderPublishButton"] = $6d1be32de0860931$export$a6f3e6c7a6e250cc;

});

parcelRegister("lACKt", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f823ee887c9ee745$export$54342bba4612eedb = (0, $aXWIB.defineMessages)({
    publishButton: {
        id: "publish-modal.default-publish-button",
        defaultMessage: "Publish..."
    },
    updateButton: {
        id: "publish-modal.update-button",
        defaultMessage: "Update"
    },
    chevronButtonTooltip: {
        id: "publish-modal.split-button-tooltip",
        defaultMessage: "Adjust update settings"
    },
    chevronButtonTooltipObjectHeader: {
        id: "publish-modal.split-button-tooltip.object-header",
        defaultMessage: "Update settings"
    },
    updatePublicContentLabel: {
        id: "publish-modal.update-public-content-label",
        defaultMessage: "Update public content"
    }
});
module.exports["i18nShared"] = $f823ee887c9ee745$export$54342bba4612eedb;

});

parcelRegister("lWizu", function(module, exports) {

let $ff8d6ba76f11cea9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ff8d6ba76f11cea9$var$load("2vQEy"),
    $ff8d6ba76f11cea9$var$load("7do1E"),
    $ff8d6ba76f11cea9$var$load("77dkW"),
    $ff8d6ba76f11cea9$var$load("9AXkC"),
    $ff8d6ba76f11cea9$var$load("4izLy"),
    $ff8d6ba76f11cea9$var$load("6wr18"),
    $ff8d6ba76f11cea9$var$load("6HLQW"),
    $ff8d6ba76f11cea9$var$load("kahM9"),
    $ff8d6ba76f11cea9$var$load("j8Ant"),
    $ff8d6ba76f11cea9$var$load("2F69B"),
    $ff8d6ba76f11cea9$var$load("6m3ID"),
    $ff8d6ba76f11cea9$var$load("5zDuS"),
    $ff8d6ba76f11cea9$var$load("7EorR"),
    $ff8d6ba76f11cea9$var$load("ffEVr"),
    $ff8d6ba76f11cea9$var$load("hhss7"),
    $ff8d6ba76f11cea9$var$load("31vk5"),
    $ff8d6ba76f11cea9$var$load("89b92")
]).then(()=>parcelRequire('6cfXd'));

});

parcelRegister("l7iY7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $7Sm4c = parcelRequire("7Sm4c");


var $ivb8S = parcelRequire("ivb8S");


var $fsF73 = parcelRequire("fsF73");

const $508580e8423e2725$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $508580e8423e2725$export$26f6630e61e959f9 = (isUnpublishedDraft)=>{
    const hasSeenPublishSpotlightRef = (0, $42omo.useRef)(null);
    const showRecap2025QueryParam = $508580e8423e2725$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isUnpublishedDraft;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $fsF73.CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS).HAS_SEEN_PUBLISH_SPOTLIGHT, !isEligible);
    const { hasSeenPublishSpotlight: hasSeenPublishSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // Mark GraphQL errors as handled since we gracefully treat them as "hasn't seen spotlight"
    (0, $42omo.useEffect)(()=>{
        if (onboardingStateError) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
    }, [
        onboardingStateError
    ]);
    // Capture the value once when it first becomes available
    // This ensures state changes during the current render cycle don't affect eligibility
    if (hasSeenPublishSpotlightRef.current === null && !onboardingStateLoading) hasSeenPublishSpotlightRef.current = hasSeenPublishSpotlight;
    if (onboardingStateLoading || onboardingStateError) return false;
    // If user has already seen the spotlight, don't show it again
    if (Boolean(hasSeenPublishSpotlightRef.current)) return false;
    return isEligible;
};
module.exports["useRecapSpotlightEligibility"] = $508580e8423e2725$export$26f6630e61e959f9;

});

parcelRegister("bHd1w", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f760397570928c6$export$28f6951b4656036e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AuHVu",
    name: "MovePageDialog",
    loader: async ()=>(await (parcelRequire("gm8JL"))).MovePageDialog
});
module.exports["MovePageDialog"] = $4f760397570928c6$export$28f6951b4656036e;

});

parcelRegister("gm8JL", function(module, exports) {

let $be857a6add7fe9af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be857a6add7fe9af$var$load("evk5p"),
    $be857a6add7fe9af$var$load("6wr18"),
    $be857a6add7fe9af$var$load("e4XZ1"),
    $be857a6add7fe9af$var$load("2Tk6L"),
    $be857a6add7fe9af$var$load("5ppK3"),
    $be857a6add7fe9af$var$load("an06t"),
    $be857a6add7fe9af$var$load("1v24l"),
    $be857a6add7fe9af$var$load("ajt6g"),
    $be857a6add7fe9af$var$load("4mgLr"),
    $be857a6add7fe9af$var$load("dtpmo"),
    $be857a6add7fe9af$var$load("9pso5"),
    $be857a6add7fe9af$var$load("19uFC"),
    $be857a6add7fe9af$var$load("1GCFv"),
    $be857a6add7fe9af$var$load("28l1x"),
    $be857a6add7fe9af$var$load("5zDuS"),
    $be857a6add7fe9af$var$load("iNa18"),
    $be857a6add7fe9af$var$load("ffEVr"),
    $be857a6add7fe9af$var$load("hogcU"),
    $be857a6add7fe9af$var$load("2vAWg"),
    $be857a6add7fe9af$var$load("7cABH"),
    $be857a6add7fe9af$var$load("31vk5"),
    $be857a6add7fe9af$var$load("4pqtR"),
    $be857a6add7fe9af$var$load("5XqRg"),
    $be857a6add7fe9af$var$load("4izLy"),
    $be857a6add7fe9af$var$load("Wowvf"),
    $be857a6add7fe9af$var$load("5RR9C"),
    $be857a6add7fe9af$var$load("7EorR"),
    $be857a6add7fe9af$var$load("hhss7"),
    $be857a6add7fe9af$var$load("36rXN")
]).then(()=>parcelRequire('4yvcZ'));

});

parcelRegister("iXzFq", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId && (0, $6mKj3.expVal)('confluence_fix_expected_contentid_to_be_string', 'isEnabled', false)) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("aGop9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ccHMk = parcelRequire("ccHMk");


var $efXed = parcelRequire("efXed");


var $17zLw = parcelRequire("17zLw");

const $90c58b5063b4a6d0$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $17zLw.ThemedButton) : (0, $ccHMk.default);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ref: ref,
        ...props
    });
});
module.exports["Button"] = $90c58b5063b4a6d0$export$353f5b6fc5456de1;

});

parcelRegister("17zLw", function(module, exports) {
/* themed-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $lcVz9 = parcelRequire("lcVz9");


var $i63G2 = parcelRequire("i63G2");

const $246516ea69fcef3e$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $246516ea69fcef3e$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $i63G2.ThemedPressable), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $246516ea69fcef3e$var$textButtonStyles.iconBefore
                ]),
                children: (0, $dh538.fg)('platform_themed_button_use_icon_renderer') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lcVz9.default), {
                    icon: IconBefore
                }) : /*#__PURE__*/ (0, $l998X.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $246516ea69fcef3e$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
module.exports["ThemedButton"] = $246516ea69fcef3e$export$f67fb575035cc7d0;

});

parcelRegister("sD2Tz", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $iIczr = parcelRequire("iIczr");


var $1Gu3g = parcelRequire("1Gu3g");


var $4ri4I = parcelRequire("4ri4I");


var $6mKj3 = parcelRequire("6mKj3");


var $58PBI = parcelRequire("58PBI");

// predictive prefetch only runs in browser environments that expose the API.
// Evaluated lazily (as a function) so that test environments can mock window.matchMedia before it is checked.
const $f75716c2560aeeb6$var$getHasMatchMedia = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function'; // Copied from https://foresightjs.com/docs/react/hook
function $f75716c2560aeeb6$var$useForesight(options, enabled) {
    const $ = (0, $frIzR.c)(5);
    const elementRef = (0, $42omo.useRef)(null);
    const registerResults = (0, $42omo.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== enabled || $[1] !== options) {
        t0 = ()=>{
            if (!elementRef.current || !enabled) return;
            if (!$f75716c2560aeeb6$var$getHasMatchMedia()) return;
            (0, $iIczr.ForesightManager).initialize({
                enableMousePrediction: true,
                trajectoryPredictionTime: (0, $6mKj3.expVal)("platform_editor_predictive_collabdraft_prefetch", "trajectoryPredictionTime", 120),
                positionHistorySize: 8
            });
            const currentElement = elementRef.current;
            registerResults.current = (0, $iIczr.ForesightManager).instance.register({
                element: currentElement,
                ...options
            });
            return ()=>{
                (0, $iIczr.ForesightManager).instance?.unregister(currentElement, "useEffect");
            };
        };
        t1 = [
            options,
            enabled
        ];
        $[0] = enabled;
        $[1] = options;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            elementRef: elementRef,
            registerResults: registerResults
        };
        $[4] = t2;
    } else t2 = $[4];
    return t2;
}
const $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS = 15000;
const $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents = new Map();
const $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics = (contentId)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (pendingPrefetch) {
        clearTimeout(pendingPrefetch.timeoutId);
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    }
};
const $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics = ({ contentId: contentId, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent })=>{
    // If there's an existing pending prefetch event for this content that hasn't
    // resolved or timed out yet, fire a prefetchUnused event for it before
    // replacing it with the new one.
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
    if (pendingPrefetch) sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs'
    });
    const firedAt = Date.now();
    const timeoutId = setTimeout(()=>{
        const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
        if (!pendingPrefetch || pendingPrefetch.firedAt !== firedAt) return;
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
        sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
            clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
            prefetchSource: 'foresightjs'
        });
    }, $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.set(contentId, {
        firedAt: firedAt,
        timeoutId: timeoutId
    });
};
const $f75716c2560aeeb6$export$545c7ef2fbcc68a6 = (contentId, sendPrefetchAnalyticsEvent)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (!pendingPrefetch) return;
    const timeToClickMs = Date.now() - pendingPrefetch.firedAt;
    clearTimeout(pendingPrefetch.timeoutId);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    sendPrefetchAnalyticsEvent('prefetchAndClick', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs',
        timeToClickMs: timeToClickMs
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Styling div for hover area only
const $f75716c2560aeeb6$var$HoverAreaWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1tes1bs0 _1kt9b3bt _1cs8stnw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent, predictivelyPrefetch: predictivelyPrefetch })=>{
    const preloader = (0, $42omo.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $42omo.useState)(false);
    const doPreloadRef = (0, $42omo.useRef)(doPreload);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $4ri4I.useEditSource)();
    (0, $42omo.useEffect)(()=>{
        // Keep the ref in sync with the latest doPreload value so that the function returned by
        // cleanup editorPreloadManager always uses the current doPreload value instead of the one before.
        doPreloadRef.current = doPreload;
    }, [
        doPreload
    ]); // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
            if (doPreloadRef.current) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        contentId
    ]); // Register edit-button element with ForesightJS for mouse trajectory prediction
    // Only call useForesight when predictive prefetch is enabled
    const foresightOptions = (0, $42omo.useMemo)(()=>({
            callback: async ()=>{
                if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId) && predictivelyPrefetch) {
                    setDoPreload(true);
                    setEditSource(editSource);
                    $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics({
                        contentId: contentId,
                        sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent
                    });
                }
            },
            name: `edit-button-${contentId}`,
            reactivateAfter: 15000
        }), [
        contentId,
        editSource,
        setEditSource,
        setDoPreload,
        predictivelyPrefetch,
        sendPrefetchAnalyticsEvent
    ]);
    const { elementRef: elementRef } = $f75716c2560aeeb6$var$useForesight(foresightOptions, predictivelyPrefetch); // On hover callback
    const onHover = (0, $42omo.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f75716c2560aeeb6$var$HoverAreaWrapper, {
        ref: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? elementRef : null,
        onMouseEnter: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? undefined : onHover
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: onHover,
        onFocus: onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};
module.exports["resolvePendingPrefetchAnalytics"] = $f75716c2560aeeb6$export$545c7ef2fbcc68a6;
module.exports["EditContentButtonPreloader"] = $f75716c2560aeeb6$export$93fd4db39a89045f;

});

parcelRegister("iIczr", function(module, exports) {

var $cIdzT = parcelRequire("cIdzT");

function $d9f61651076d55f9$var$k() {
    let n = $d9f61651076d55f9$var$E(), e = $d9f61651076d55f9$var$L();
    return {
        isTouchDevice: n,
        isLimitedConnection: e,
        shouldRegister: !e
    };
}
function $d9f61651076d55f9$var$E() {
    return typeof window > "u" || typeof navigator > "u" ? !1 : window.matchMedia("(pointer: coarse)").matches && navigator.maxTouchPoints > 0;
}
function $d9f61651076d55f9$var$L() {
    let n = navigator.connection;
    if (!n) return !1;
    let e = $d9f61651076d55f9$export$1435e6a4c843d234.instance.getManagerData.globalSettings.minimumConnectionType, t = [
        "slow-2g",
        "2g",
        "3g",
        "4g"
    ], i = t.indexOf(n.effectiveType), r = t.indexOf(e);
    return i < r || n.saveData;
}
function $d9f61651076d55f9$var$F(n) {
    if (typeof window > "u" || typeof document > "u") return !1;
    let e = window.innerWidth || document.documentElement.clientWidth, t = window.innerHeight || document.documentElement.clientHeight;
    return n.top < t && n.bottom > 0 && n.left < e && n.right > 0;
}
function $d9f61651076d55f9$var$T() {
    return {
        mouse: {
            hover: 0,
            trajectory: 0
        },
        tab: {
            forwards: 0,
            reverse: 0
        },
        scroll: {
            down: 0,
            left: 0,
            right: 0,
            up: 0
        },
        touch: 0,
        viewport: 0,
        total: 0
    };
}
function $d9f61651076d55f9$var$H() {
    return {
        debug: !1,
        enableManagerLogging: !1,
        enableMousePrediction: !0,
        enableScrollPrediction: !0,
        positionHistorySize: 8,
        trajectoryPredictionTime: 120,
        scrollMargin: 150,
        defaultHitSlop: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        enableTabPrediction: !0,
        tabOffset: 2,
        touchDeviceStrategy: "onTouchStart",
        minimumConnectionType: "3g"
    };
}
function $d9f61651076d55f9$var$R(n, e, t) {
    let { element: i, callback: r, hitSlop: o, name: s, meta: c, reactivateAfter: b } = n, d = i.getBoundingClientRect(), a = o ? (0, $cIdzT.b)(o) : t;
    return {
        id: e,
        element: i,
        callback: r,
        elementBounds: {
            originalRect: d,
            expandedRect: (0, $cIdzT.c)(d, a),
            hitSlop: a
        },
        name: s || i.id || "unnamed",
        isIntersectingWithViewport: $d9f61651076d55f9$var$F(d),
        registerCount: 1,
        meta: c ?? {},
        callbackInfo: {
            callbackFiredCount: 0,
            lastCallbackInvokedAt: void 0,
            lastCallbackCompletedAt: void 0,
            lastCallbackRuntime: void 0,
            lastCallbackStatus: void 0,
            lastCallbackErrorMessage: void 0,
            reactivateAfter: b ?? 1 / 0,
            isCallbackActive: !0,
            isRunningCallback: !1,
            reactivateTimeoutId: void 0
        }
    };
}
var $d9f61651076d55f9$var$f = class {
    addEventListener(e, t, i) {
        if (i?.signal?.aborted) return;
        let r = this.eventListeners.get(e) ?? [];
        r.push(t), this.eventListeners.set(e, r), i?.signal?.addEventListener("abort", ()=>this.removeEventListener(e, t));
    }
    removeEventListener(e, t) {
        let i = this.eventListeners.get(e);
        if (!i) return;
        let r = i.indexOf(t);
        r > -1 && i.splice(r, 1);
    }
    emit(e) {
        let t = this.eventListeners.get(e.type);
        if (!(!t || t.length === 0)) for(let i = 0; i < t.length; i++)try {
            let r = t[i];
            r && r(e);
        } catch (r) {
            console.error(`Error in ForesightManager event listener ${i} for ${e.type}:`, r);
        }
    }
    hasListeners(e) {
        let t = this.eventListeners.get(e);
        return t !== void 0 && t.length > 0;
    }
    getEventListeners() {
        return this.eventListeners;
    }
    constructor(){
        this.eventListeners = new Map;
    }
};
function $d9f61651076d55f9$var$y(n, e) {
    return n !== void 0 && e !== n;
}
var $d9f61651076d55f9$var$I = {
    trajectoryPredictionTime: {
        min: 10,
        max: 200
    },
    positionHistorySize: {
        min: 2,
        max: 30
    },
    scrollMargin: {
        min: 30,
        max: 300
    },
    tabOffset: {
        min: 0,
        max: 20
    }
};
function $d9f61651076d55f9$var$h(n, e, t) {
    if (!$d9f61651076d55f9$var$y(t, n[e])) return !1;
    let { min: i, max: r } = $d9f61651076d55f9$var$I[e];
    return n[e] = (0, $cIdzT.a)(t, i, r, e), !0;
}
function $d9f61651076d55f9$var$m(n, e, t) {
    return $d9f61651076d55f9$var$y(t, n[e]) ? (n[e] = t, !0) : !1;
}
function $d9f61651076d55f9$var$M(n, e) {
    $d9f61651076d55f9$var$h(n, "trajectoryPredictionTime", e.trajectoryPredictionTime), $d9f61651076d55f9$var$h(n, "positionHistorySize", e.positionHistorySize), $d9f61651076d55f9$var$h(n, "scrollMargin", e.scrollMargin), $d9f61651076d55f9$var$h(n, "tabOffset", e.tabOffset), $d9f61651076d55f9$var$m(n, "enableMousePrediction", e.enableMousePrediction), $d9f61651076d55f9$var$m(n, "enableScrollPrediction", e.enableScrollPrediction), $d9f61651076d55f9$var$m(n, "enableTabPrediction", e.enableTabPrediction), $d9f61651076d55f9$var$m(n, "enableManagerLogging", e.enableManagerLogging), e.defaultHitSlop !== void 0 && (n.defaultHitSlop = (0, $cIdzT.b)(e.defaultHitSlop)), e.touchDeviceStrategy !== void 0 && (n.touchDeviceStrategy = e.touchDeviceStrategy), e.minimumConnectionType !== void 0 && (n.minimumConnectionType = e.minimumConnectionType), e.debug !== void 0 && (n.debug = e.debug);
}
function $d9f61651076d55f9$var$D(n, e) {
    let t = [], i = !1, r = !1, o = !1, s = !1, c = !1;
    if (!e) return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
    let b = [
        "trajectoryPredictionTime",
        "positionHistorySize",
        "scrollMargin",
        "tabOffset"
    ];
    for (let a of b){
        let l = n[a];
        $d9f61651076d55f9$var$h(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "positionHistorySize" && (i = !0));
    }
    let d = [
        "enableMousePrediction",
        "enableScrollPrediction",
        "enableTabPrediction"
    ];
    for (let a of d){
        let l = n[a];
        $d9f61651076d55f9$var$m(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "enableScrollPrediction" && (r = !0), a === "enableTabPrediction" && (o = !0));
    }
    if (e.defaultHitSlop !== void 0) {
        let a = n.defaultHitSlop, l = (0, $cIdzT.b)(e.defaultHitSlop);
        (0, $cIdzT.d)(a, l) || (n.defaultHitSlop = l, t.push({
            setting: "defaultHitSlop",
            oldValue: a,
            newValue: l
        }), s = !0);
    }
    if (e.touchDeviceStrategy !== void 0) {
        let a = n.touchDeviceStrategy;
        n.touchDeviceStrategy = e.touchDeviceStrategy, t.push({
            setting: "touchDeviceStrategy",
            oldValue: a,
            newValue: e.touchDeviceStrategy
        }), c = !0;
    }
    if (e.minimumConnectionType !== void 0) {
        let a = n.minimumConnectionType;
        n.minimumConnectionType = e.minimumConnectionType, t.push({
            setting: "minimumConnectionType",
            oldValue: a,
            newValue: e.minimumConnectionType
        });
    }
    return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
}


var $d9f61651076d55f9$export$1435e6a4c843d234 = class n {
    async getOrCreateDesktopHandler() {
        if (!this.desktopHandler) {
            let { DesktopHandler: e } = await (parcelRequire("aRD4p"));
            this.desktopHandler = new e(this.handlerDependencies), this.devLog("DesktopHandler lazy loaded");
        }
        return this.desktopHandler;
    }
    async getOrCreateTouchHandler() {
        if (!this.touchDeviceHandler) {
            let { TouchDeviceHandler: e } = await (parcelRequire("9hxbX"));
            this.touchDeviceHandler = new e(this.handlerDependencies), this.devLog("TouchDeviceHandler lazy loaded");
        }
        return this.touchDeviceHandler;
    }
    static initialize(e) {
        return this.isInitiated || (n.manager = new n(e)), n.manager;
    }
    static get isInitiated() {
        return !!n.manager;
    }
    static get instance() {
        return this.initialize();
    }
    generateId() {
        return `foresight-${++this.idCounter}`;
    }
    get isUsingDesktopHandler() {
        return this.currentDeviceStrategy === "mouse" || this.currentDeviceStrategy === "pen";
    }
    addEventListener(e, t, i) {
        this.eventEmitter.addEventListener(e, t, i);
    }
    removeEventListener(e, t) {
        this.eventEmitter.removeEventListener(e, t);
    }
    hasListeners(e) {
        return this.eventEmitter.hasListeners(e);
    }
    get getManagerData() {
        let e = this.desktopHandler?.loadedPredictors, t = this.touchDeviceHandler?.loadedPredictors;
        return {
            registeredElements: this.elements,
            globalSettings: this._globalSettings,
            globalCallbackHits: this._globalCallbackHits,
            eventListeners: this.eventEmitter.getEventListeners(),
            currentDeviceStrategy: this.currentDeviceStrategy,
            activeElementCount: this.activeElementCount,
            loadedModules: {
                desktopHandler: this.desktopHandler !== null,
                touchHandler: this.touchDeviceHandler !== null,
                predictors: {
                    mouse: e?.mouse ?? !1,
                    tab: e?.tab ?? !1,
                    scroll: e?.scroll ?? !1,
                    viewport: t?.viewport ?? !1,
                    touchStart: t?.touchStart ?? !1
                }
            }
        };
    }
    get registeredElements() {
        return this.elements;
    }
    register(e) {
        let { element: t, ...i } = e;
        return t instanceof NodeList ? Array.from(t, (r)=>this.registerElement({
                ...i,
                element: r
            })) : this.registerElement({
            ...i,
            element: t
        });
    }
    registerElement(e) {
        let { isTouchDevice: t, isLimitedConnection: i, shouldRegister: r } = $d9f61651076d55f9$var$k();
        if (!r) return {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        let o = this.elements.get(e.element);
        if (o) return o.registerCount++, {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        this.isSetup || this.initializeGlobalListeners();
        let s = $d9f61651076d55f9$var$R(e, this.generateId(), this._globalSettings.defaultHitSlop);
        return this.elements.set(e.element, s), this.activeElementCount++, this.updateCheckableStatus(s), this.currentlyActiveHandler?.observeElement(e.element), this.eventEmitter.emit({
            type: "elementRegistered",
            timestamp: Date.now(),
            elementData: s
        }), {
            isTouchDevice: t,
            isLimitedConnection: i,
            isRegistered: !0,
            unregister: ()=>{
                this.unregister(e.element);
            },
            elementData: s
        };
    }
    unregister(e, t) {
        e instanceof NodeList ? e.forEach((i)=>this.unregisterElement(i, t)) : this.unregisterElement(e, t);
    }
    unregisterElement(e, t) {
        let i = this.elements.get(e);
        if (!i) return;
        this.clearReactivateTimeout(i), this.currentlyActiveHandler?.unobserveElement(e), this.elements.delete(e), this.checkableElements.delete(i), i.callbackInfo.isCallbackActive && this.activeElementCount--;
        let r = this.elements.size === 0 && this.isSetup;
        r && (this.devLog("All elements unregistered, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "elementUnregistered",
            elementData: i,
            timestamp: Date.now(),
            unregisterReason: t ?? "by user",
            wasLastRegisteredElement: r
        });
    }
    reactivate(e) {
        e instanceof NodeList ? e.forEach((t)=>this.reactivateElement(t)) : this.reactivateElement(e);
    }
    reactivateElement(e) {
        let t = this.elements.get(e);
        t && (this.isSetup || this.initializeGlobalListeners(), this.clearReactivateTimeout(t), t.callbackInfo.isRunningCallback || (t.callbackInfo.isCallbackActive = !0, this.activeElementCount++, this.updateCheckableStatus(t), this.currentlyActiveHandler?.observeElement(e), this.eventEmitter.emit({
            type: "elementReactivated",
            elementData: t,
            timestamp: Date.now()
        })));
    }
    clearReactivateTimeout(e) {
        clearTimeout(e.callbackInfo.reactivateTimeoutId), e.callbackInfo.reactivateTimeoutId = void 0;
    }
    updateCheckableStatus(e) {
        e.isIntersectingWithViewport && e.callbackInfo.isCallbackActive && !e.callbackInfo.isRunningCallback ? this.checkableElements.add(e) : this.checkableElements.delete(e);
    }
    callCallback(e, t) {
        e.callbackInfo.isRunningCallback || !e.callbackInfo.isCallbackActive || (this.markElementAsRunning(e), this.executeCallbackAsync(e, t));
    }
    markElementAsRunning(e) {
        e.callbackInfo.callbackFiredCount++, e.callbackInfo.lastCallbackInvokedAt = Date.now(), e.callbackInfo.isRunningCallback = !0, this.clearReactivateTimeout(e), this.checkableElements.delete(e);
    }
    async executeCallbackAsync(e, t) {
        this.updateHitCounters(t), this.eventEmitter.emit({
            type: "callbackInvoked",
            timestamp: Date.now(),
            elementData: e,
            hitType: t
        });
        let i = performance.now(), r, o = null;
        try {
            await e.callback(e), r = "success";
        } catch (s) {
            o = s instanceof Error ? s.message : String(s), r = "error", console.error(`Error in callback for element ${e.name}:`, s);
        }
        this.finalizeCallback(e, t, i, r, o);
    }
    finalizeCallback(e, t, i, r, o) {
        e.callbackInfo.lastCallbackCompletedAt = Date.now(), e.callbackInfo.isRunningCallback = !1, e.callbackInfo.isCallbackActive = !1, this.activeElementCount--, this.currentlyActiveHandler?.unobserveElement(e.element), e.callbackInfo.reactivateAfter !== 1 / 0 && (e.callbackInfo.reactivateTimeoutId = setTimeout(()=>{
            this.reactivate(e.element);
        }, e.callbackInfo.reactivateAfter));
        let s = this.activeElementCount === 0;
        s && (this.devLog("All elements unactivated, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "callbackCompleted",
            timestamp: Date.now(),
            elementData: e,
            hitType: t,
            elapsed: e.callbackInfo.lastCallbackRuntime = performance.now() - i,
            status: e.callbackInfo.lastCallbackStatus = r,
            errorMessage: e.callbackInfo.lastCallbackErrorMessage = o,
            wasLastActiveElement: s
        });
    }
    updateHitCounters(e) {
        switch(e.kind){
            case "mouse":
                this._globalCallbackHits.mouse[e.subType]++;
                break;
            case "tab":
                this._globalCallbackHits.tab[e.subType]++;
                break;
            case "scroll":
                this._globalCallbackHits.scroll[e.subType]++;
                break;
            case "touch":
                this._globalCallbackHits.touch++;
                break;
            case "viewport":
                this._globalCallbackHits.viewport++;
                break;
            default:
        }
        this._globalCallbackHits.total++;
    }
    async setDeviceStrategy(e) {
        let t = this.currentDeviceStrategy;
        t !== e && this.devLog(`Switching device strategy from ${t} to ${e}`), this.currentlyActiveHandler?.disconnect(), this.currentlyActiveHandler = e === "mouse" || e === "pen" ? await this.getOrCreateDesktopHandler() : await this.getOrCreateTouchHandler(), this.currentlyActiveHandler.connect();
    }
    initializeGlobalListeners() {
        this.isSetup || typeof document > "u" || (this.devLog("Initializing global listeners (pointermove, MutationObserver)"), this.setDeviceStrategy(this.currentDeviceStrategy), document.addEventListener("pointermove", this.handlePointerMove), this.domObserver = new MutationObserver(this.handleDomMutations), this.domObserver.observe(document.documentElement, {
            childList: !0,
            subtree: !0,
            attributes: !1
        }), this.isSetup = !0);
    }
    removeGlobalListeners() {
        typeof document > "u" || (this.isSetup = !1, this.domObserver?.disconnect(), this.domObserver = null, document.removeEventListener("pointermove", this.handlePointerMove), this.currentlyActiveHandler?.disconnect(), this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null), this.pendingPointerEvent = null);
    }
    alterGlobalSettings(e) {
        let t = $d9f61651076d55f9$var$D(this._globalSettings, e);
        t.positionHistorySizeChanged && this.desktopHandler && this.desktopHandler.trajectoryPositions.positions.resize(this._globalSettings.positionHistorySize), t.scrollPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableScrollPrediction ? this.desktopHandler.connectScrollPredictor() : this.desktopHandler.disconnectScrollPredictor()), t.tabPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableTabPrediction ? this.desktopHandler.connectTabPredictor() : this.desktopHandler.disconnectTabPredictor()), t.hitSlopChanged && this.forceUpdateAllElementBounds(), t.touchStrategyChanged && !this.isUsingDesktopHandler && this.touchDeviceHandler && this.touchDeviceHandler.setTouchPredictor(), t.changedSettings.length > 0 && this.eventEmitter.emit({
            type: "managerSettingsChanged",
            timestamp: Date.now(),
            managerData: this.getManagerData,
            updatedSettings: t.changedSettings
        });
    }
    forceUpdateAllElementBounds() {
        for (let e of this.elements.values())e.isIntersectingWithViewport && this.forceUpdateElementBounds(e);
    }
    forceUpdateElementBounds(e) {
        let t = e.element.getBoundingClientRect(), i = (0, $cIdzT.c)(t, e.elementBounds.hitSlop);
        if (!(0, $cIdzT.d)(i, e.elementBounds.expandedRect)) {
            let r = {
                ...e,
                elementBounds: {
                    ...e.elementBounds,
                    originalRect: t,
                    expandedRect: i
                }
            };
            this.elements.set(e.element, r), this.eventEmitter.emit({
                type: "elementDataUpdated",
                elementData: r,
                updatedProps: [
                    "bounds"
                ]
            });
        }
    }
    devLog(e) {
        this._globalSettings.enableManagerLogging && console.log(`%c\u{1F6E0}\uFE0F ForesightManager: ${e}`, "color: #16a34a; font-weight: bold;");
    }
    constructor(e){
        this.elements = new Map;
        this.checkableElements = new Set;
        this.idCounter = 0;
        this.activeElementCount = 0;
        this.desktopHandler = null;
        this.touchDeviceHandler = null;
        this.currentlyActiveHandler = null;
        this.isSetup = !1;
        this.pendingPointerEvent = null;
        this.rafId = null;
        this.domObserver = null;
        this.currentDeviceStrategy = $d9f61651076d55f9$var$E() ? "touch" : "mouse";
        this.eventEmitter = new $d9f61651076d55f9$var$f;
        this._globalCallbackHits = $d9f61651076d55f9$var$T();
        this._globalSettings = $d9f61651076d55f9$var$H();
        this.handlePointerMove = (e)=>{
            this.pendingPointerEvent = e, e.pointerType !== this.currentDeviceStrategy && (this.eventEmitter.emit({
                type: "deviceStrategyChanged",
                timestamp: Date.now(),
                newStrategy: e.pointerType,
                oldStrategy: this.currentDeviceStrategy
            }), this.currentDeviceStrategy = e.pointerType, this.setDeviceStrategy(this.currentDeviceStrategy)), !this.rafId && (this.rafId = requestAnimationFrame(()=>{
                if (!this.isUsingDesktopHandler) {
                    this.rafId = null;
                    return;
                }
                this.pendingPointerEvent && this.desktopHandler?.processMouseMovement(this.pendingPointerEvent), this.rafId = null;
            }));
        };
        this.handleDomMutations = (e)=>{
            if (!e.length) return;
            this.desktopHandler?.invalidateTabCache();
            let t = !1;
            for(let i = 0; i < e.length; i++){
                let r = e[i];
                if (r && r.type === "childList" && r.removedNodes.length > 0) {
                    t = !0;
                    break;
                }
            }
            if (t) for (let i of this.elements.keys())i.isConnected || this.unregister(i, "disconnected");
        };
        e !== void 0 && $d9f61651076d55f9$var$M(this._globalSettings, e), this.handlerDependencies = {
            elements: this.elements,
            callCallback: this.callCallback.bind(this),
            emit: this.eventEmitter.emit.bind(this.eventEmitter),
            hasListeners: this.eventEmitter.hasListeners.bind(this.eventEmitter),
            settings: this._globalSettings
        }, this.devLog(`ForesightManager initialized with device strategy: ${this.currentDeviceStrategy}`), this.initializeGlobalListeners();
    }
};
module.exports["ForesightManager"] = $d9f61651076d55f9$export$1435e6a4c843d234;

});

parcelRegister("cIdzT", function(module, exports) {
function $941420602caaea91$export$407448d2b89b1813(t, o, e, r) {
    return t < o ? console.warn(`ForesightJS: "${r}" value ${t} is below minimum bound ${o}, clamping to ${o}`) : t > e && console.warn(`ForesightJS: "${r}" value ${t} is above maximum bound ${e}, clamping to ${e}`), Math.min(Math.max(t, o), e);
}
function $941420602caaea91$export$8b22cf2602fb60ce(t) {
    if (typeof t == "number") {
        let o = $941420602caaea91$export$407448d2b89b1813(t, 0, 2e3, "hitslop");
        return {
            top: o,
            left: o,
            right: o,
            bottom: o
        };
    }
    return {
        top: $941420602caaea91$export$407448d2b89b1813(t.top, 0, 2e3, "hitslop - top"),
        left: $941420602caaea91$export$407448d2b89b1813(t.left, 0, 2e3, "hitslop - left"),
        right: $941420602caaea91$export$407448d2b89b1813(t.right, 0, 2e3, "hitslop - right"),
        bottom: $941420602caaea91$export$407448d2b89b1813(t.bottom, 0, 2e3, "hitslop - bottom")
    };
}
function $941420602caaea91$export$db3b6bfb95261072(t, o) {
    return {
        left: t.left - o.left,
        right: t.right + o.right,
        top: t.top - o.top,
        bottom: t.bottom + o.bottom
    };
}
function $941420602caaea91$export$4368d992c4eafac0(t, o) {
    return !t || !o ? t === o : t.left === o.left && t.right === o.right && t.top === o.top && t.bottom === o.bottom;
}
function $941420602caaea91$export$f1e1789686576879(t, o) {
    return t.x >= o.left && t.x <= o.right && t.y >= o.top && t.y <= o.bottom;
}
module.exports["a"] = $941420602caaea91$export$407448d2b89b1813;
module.exports["b"] = $941420602caaea91$export$8b22cf2602fb60ce;
module.exports["c"] = $941420602caaea91$export$db3b6bfb95261072;
module.exports["d"] = $941420602caaea91$export$4368d992c4eafac0;
module.exports["e"] = $941420602caaea91$export$f1e1789686576879;

});

parcelRegister("aRD4p", function(module, exports) {

let $7e8d2920acc7779b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e8d2920acc7779b$var$load("4jw8R").then(()=>parcelRequire('8ASfi'));

});

parcelRegister("9hxbX", function(module, exports) {

let $6c1f72cdbdbe9c79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c1f72cdbdbe9c79$var$load("dhMnK").then(()=>parcelRequire('ei4WU'));

});

parcelRegister("1Gu3g", function(module, exports) {
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();
module.exports["EditorPreloadManager"] = $4fc0e3bf51597bc1$export$369fde9923d909f1;

});

parcelRegister("58PBI", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("k22lL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1988df8ccc55d194$export$8cf79fbd47bc14c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wym_j",
    name: "ArchiveUpsellDialog",
    loader: async ()=>(await (parcelRequire("gjuzk"))).ArchiveUpsellDialog
});
module.exports["ArchiveUpsellDialog"] = $1988df8ccc55d194$export$8cf79fbd47bc14c3;

});

parcelRegister("gjuzk", function(module, exports) {

let $be0621ff04541291$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be0621ff04541291$var$load("cEqm7"),
    $be0621ff04541291$var$load("hOaAV"),
    $be0621ff04541291$var$load("hhss7"),
    $be0621ff04541291$var$load("cPaXL")
]).then(()=>parcelRequire('v2hhG'));

});

parcelRegister("2WH1B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2099f9ed78e06b67$export$baebba9f0bb9158 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ptN9P",
    name: "ArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("aeroW"))).ArchivePagesLoader
});
module.exports["ArchivePagesLoader"] = $2099f9ed78e06b67$export$baebba9f0bb9158;

});

parcelRegister("aeroW", function(module, exports) {

let $7730778684600c35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7730778684600c35$var$load("4pqtR"),
    $7730778684600c35$var$load("5XqRg"),
    $7730778684600c35$var$load("9qfB8"),
    $7730778684600c35$var$load("6wr18"),
    $7730778684600c35$var$load("42aQC"),
    $7730778684600c35$var$load("jyWy1"),
    $7730778684600c35$var$load("7o5Pu"),
    $7730778684600c35$var$load("ffEVr"),
    $7730778684600c35$var$load("Wowvf"),
    $7730778684600c35$var$load("kHOMt"),
    $7730778684600c35$var$load("jXx9i"),
    $7730778684600c35$var$load("hhss7"),
    $7730778684600c35$var$load("3uux1")
]).then(()=>parcelRequire('iYH6z'));

});

parcelRegister("1AbrA", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a94896b24fa6d771$export$833a1d1f1b7e4f0f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "MiFff",
    name: "PageQuickActionAutomationMenu",
    loader: async ()=>(await (parcelRequire("5HVkA"))).PageQuickActionAutomationMenu
});
module.exports["PageQuickActionAutomationMenu"] = $a94896b24fa6d771$export$833a1d1f1b7e4f0f;

});

parcelRegister("5HVkA", function(module, exports) {

let $427d70aacea1c9b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $427d70aacea1c9b3$var$load("4pqtR"),
    $427d70aacea1c9b3$var$load("5XqRg"),
    $427d70aacea1c9b3$var$load("5p0Bu"),
    $427d70aacea1c9b3$var$load("4xZ5N"),
    $427d70aacea1c9b3$var$load("7f9Fz"),
    $427d70aacea1c9b3$var$load("kHOMt"),
    $427d70aacea1c9b3$var$load("7EorR"),
    $427d70aacea1c9b3$var$load("Wowvf"),
    $427d70aacea1c9b3$var$load("5RR9C"),
    $427d70aacea1c9b3$var$load("hhss7"),
    $427d70aacea1c9b3$var$load("9QyoN")
]).then(()=>parcelRequire('bm1ob'));

});

parcelRegister("6ykQV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf5e0ab73c00afb3$export$25f686fb78162d50 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fmQ7C",
    name: "DeleteNestedPagesActionLoader",
    loader: async ()=>(await (parcelRequire("9YUuP"))).DeleteNestedPagesAction
});
module.exports["DeleteNestedPagesActionLoader"] = $cf5e0ab73c00afb3$export$25f686fb78162d50;

});

parcelRegister("9YUuP", function(module, exports) {

let $74458aa56a50ab25$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $74458aa56a50ab25$var$load("lUs3J"),
    $74458aa56a50ab25$var$load("kHOMt"),
    $74458aa56a50ab25$var$load("4pqtR"),
    $74458aa56a50ab25$var$load("5XqRg"),
    $74458aa56a50ab25$var$load("9qfB8"),
    $74458aa56a50ab25$var$load("6wr18"),
    $74458aa56a50ab25$var$load("33ouG"),
    $74458aa56a50ab25$var$load("73HOd"),
    $74458aa56a50ab25$var$load("7o5Pu"),
    $74458aa56a50ab25$var$load("Wowvf"),
    $74458aa56a50ab25$var$load("ffEVr"),
    $74458aa56a50ab25$var$load("jXx9i"),
    $74458aa56a50ab25$var$load("hhss7"),
    $74458aa56a50ab25$var$load("9YGIy")
]).then(()=>parcelRequire('9R4ZE'));

});

parcelRegister("5FwhF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ee4e9cc4db58f73d$export$b3f442789ed34bf1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MHkm",
    name: "CopyPageTreeDialog",
    loader: async ()=>(await (parcelRequire("cjDZH"))).CopyPageTreeContainer
});
module.exports["CopyPageTreeDialog"] = $ee4e9cc4db58f73d$export$b3f442789ed34bf1;

});

parcelRegister("cjDZH", function(module, exports) {

let $8f76486547afdced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8f76486547afdced$var$load("6wr18"),
    $8f76486547afdced$var$load("2Tk6L"),
    $8f76486547afdced$var$load("5ppK3"),
    $8f76486547afdced$var$load("dtpmo"),
    $8f76486547afdced$var$load("9pso5"),
    $8f76486547afdced$var$load("iNa18"),
    $8f76486547afdced$var$load("ffEVr"),
    $8f76486547afdced$var$load("kHOMt"),
    $8f76486547afdced$var$load("jXx9i"),
    $8f76486547afdced$var$load("31vk5"),
    $8f76486547afdced$var$load("4pqtR"),
    $8f76486547afdced$var$load("5XqRg"),
    $8f76486547afdced$var$load("7EorR"),
    $8f76486547afdced$var$load("Wowvf"),
    $8f76486547afdced$var$load("5RR9C"),
    $8f76486547afdced$var$load("hhss7"),
    $8f76486547afdced$var$load("p4ay7")
]).then(()=>parcelRequire('c7g9a'));

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("2cKGu", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1ggpj = parcelRequire("1ggpj");

const $c721ee7829bb57f5$export$f2c6bba4d41ef211 = (contentType, contentMode)=>{
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        // Starring currently doesn't support unpublished drafts (which could be of contentType page or blogpost)
        if (contentMode === 'draft') return false;
        return contentType === 'page' || contentType === 'blogpost' || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
    } else return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
module.exports["useIsStarringEnabled"] = $c721ee7829bb57f5$export$f2c6bba4d41ef211;

});

parcelRegister("3J7TU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $684d40bc929501f2$export$edb822e56299b4ef = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rCmOK",
    name: "CopyPageDialog",
    loader: async ()=>(await (parcelRequire("cdP5d"))).CopyPageDialogContainer
});
module.exports["CopyPageDialog"] = $684d40bc929501f2$export$edb822e56299b4ef;

});

parcelRegister("cdP5d", function(module, exports) {

let $8e5e52f5eb41f8e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e5e52f5eb41f8e7$var$load("6wr18"),
    $8e5e52f5eb41f8e7$var$load("Wowvf"),
    $8e5e52f5eb41f8e7$var$load("ffEVr"),
    $8e5e52f5eb41f8e7$var$load("hhss7"),
    $8e5e52f5eb41f8e7$var$load("aiU5r")
]).then(()=>parcelRequire('dVBJi'));

});

parcelRegister("78wUU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $745e4e253bb54f50$export$fbea3c6f057d30b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "epAoB",
    name: "MoveBlogModalLoader",
    loader: async ()=>(await (parcelRequire("cTCmF"))).MoveBlogModal
});
module.exports["MoveBlogModalLoader"] = $745e4e253bb54f50$export$fbea3c6f057d30b6;

});

parcelRegister("cTCmF", function(module, exports) {

let $9638617f7947c2e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9638617f7947c2e3$var$load("4izLy"),
    $9638617f7947c2e3$var$load("6wr18"),
    $9638617f7947c2e3$var$load("dtpmo"),
    $9638617f7947c2e3$var$load("ffEVr"),
    $9638617f7947c2e3$var$load("Wowvf"),
    $9638617f7947c2e3$var$load("hhss7"),
    $9638617f7947c2e3$var$load("aoUod")
]).then(()=>parcelRequire('fzGQR'));

});

parcelRegister("iVd6X", function(module, exports) {
var $fd8faec801601310$export$6c1ad2d761708c0b = /*#__PURE__*/ function(PublishPageAsBlogSources) {
    PublishPageAsBlogSources["ViewPage"] = "VIEW_PAGE";
    PublishPageAsBlogSources["EditPage"] = "EDIT_PAGE";
    return PublishPageAsBlogSources;
}({});
module.exports["PublishPageAsBlogSources"] = $fd8faec801601310$export$6c1ad2d761708c0b;

});

parcelRegister("lu0E4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hXDOc = parcelRequire("hXDOc");


var $8G1o2 = parcelRequire("8G1o2");


var $dLX9a = parcelRequire("dLX9a");

const $d97c0945857481ee$export$8bc1bc0080a813ff = ({ isPublish: isPublish, contentId: contentId, spaceKey: spaceKey, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, children: children })=>{
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(contentId);
    const publishPreloadUrl = (0, $dLX9a.getPublishPreloadUrl)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    const closePreloadUrl = (0, $42omo.useMemo)(()=>{
        if (!breadcrumbs || breadcrumbs.length === 0) return '';
        return (0, $dLX9a.getClosePreloadUrl)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            breadcrumbs: breadcrumbs,
            isUnpublishedDraft: isUnpublishedDraft
        });
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft,
        breadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "preload-button-wrapper",
        preloadUrl: isPublish ? publishPreloadUrl : closePreloadUrl,
        preloadOptions: (0, $hXDOc.PreloadingPresets).everything
    }, children);
};
module.exports["PreloadButtonWrapper"] = $d97c0945857481ee$export$8bc1bc0080a813ff;

});

parcelRegister("2kB0r", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dAYOx = parcelRequire("dAYOx");


var $40pD8 = parcelRequire("40pD8");

const $6e3699f987da9ca3$var$messages = (0, $aXWIB.defineMessages)({
    classifyContent: {
        id: "data-classification.ellipsis-classification-menu-item.classify-content",
        defaultMessage: "Classify content"
    }
});
const $6e3699f987da9ca3$export$805becd8a04238d2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { elemBefore: elemBefore } = t0;
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    let t1;
    if ($[0] !== setIsClassificationModalOpen) {
        t1 = ()=>{
            setIsClassificationModalOpen(true);
        };
        $[0] = setIsClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const onClick = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6e3699f987da9ca3$var$messages.classifyContent);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== elemBefore || $[4] !== onClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            key: "classify-content",
            onClick: onClick,
            elemBefore: elemBefore
        }, t2);
        $[3] = elemBefore;
        $[4] = onClick;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ elemBefore: elemBefore })=>{
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const onClick = ()=>{
        setIsClassificationModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        key: "classify-content",
        onClick: onClick,
        elemBefore: elemBefore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6e3699f987da9ca3$var$messages.classifyContent));
};
module.exports["EllipsisClassificationMenuItem"] = $6e3699f987da9ca3$export$805becd8a04238d2;

});

parcelRegister("b66o6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f480656426be1312$export$b62abe642254f319 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "O8EvX",
    name: "RevertEditorDialog",
    loader: async ()=>(await (parcelRequire("ixTux"))).RevertEditorDialog
});
module.exports["RevertEditorDialog"] = $f480656426be1312$export$b62abe642254f319;

});

parcelRegister("ixTux", function(module, exports) {

let $d8065a87ac02ac3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d8065a87ac02ac3f$var$load("hhss7"),
    $d8065a87ac02ac3f$var$load("23MlT")
]).then(()=>parcelRequire('1yiQ2'));

});

parcelRegister("BCkug", function(module, exports) {

var $9ieTK = parcelRequire("9ieTK");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $8aF6s = parcelRequire("8aF6s");


var $jv3O2 = parcelRequire("jv3O2");


var $ij4CE = parcelRequire("ij4CE");


var $bN5DJ = parcelRequire("bN5DJ");


var $3FmeR = parcelRequire("3FmeR");




const $f911f42fbae43711$export$652cb536b0ebabdb = (props)=>{
    const { contentId: contentId, spaceId: spaceId, isUnpublishedDraft: isUnpublishedDraft, analyticsSource: analyticsSource, adfOrigin: adfOrigin, onSuccessfulConversion: onSuccessfulConversion, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, saveDraft: saveDraft } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSuccess = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'convertedToLivePage',
                actionSubject: 'page',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        onSuccessfulConversion?.();
        showConvertToLivePageFlag({
            converterWasCurrentUser: true
        });
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        onSuccessfulConversion,
        showConvertToLivePageFlag
    ]);
    const writeSubTypeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $9ieTK.default),
        fragmentArtifact: (0, $9ieTK.default)
    });
    return (0, $42omo.useCallback)(async ()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'switchToLiveEdit',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        if (!isUnpublishedDraft) showModal((0, $bN5DJ.ConvertToLivePageDialog), {
            contentId: contentId,
            onConfirm: onSuccess,
            adfOrigin: adfOrigin,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
        });
        else {
            // Trigger draft sync before converting. If we don't do this and the user recently updated their draft title then quickly converted the draft, draft sync may not have triggered and we may not identify their title conflict.
            await saveDraft?.();
            (0, $3FmeR.convertDraftToLivePage)({
                contentId: contentId,
                spaceId: spaceId,
                onSuccess: onSuccess,
                flags: flags,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                writeSubTypeFragment: writeSubTypeFragment
            });
        }
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        showModal,
        onSuccess,
        adfOrigin,
        retrieveEditorTitleAndContent,
        saveDraft,
        flags,
        writeSubTypeFragment
    ]);
};
module.exports["useSwitchToLivePage"] = $f911f42fbae43711$export$652cb536b0ebabdb;

});

parcelRegister("9ieTK", function(module, exports) {
/**
 * @generated SignedSource<<0b5341fc2e82786f1ace34f095ca618d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5dcf221c9d66892$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSwitchToLivePageSubTypeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$b5dcf221c9d66892$var$node.hash = "83901263f96d64a150282b24a00afaf6";
var $b5dcf221c9d66892$export$2e2bcd8739ae039 = $b5dcf221c9d66892$var$node;
module.exports["default"] = $b5dcf221c9d66892$export$2e2bcd8739ae039;

});

parcelRegister("bN5DJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5b509ab565dd40fa$export$13f6b1ebaf0950f0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_DPHW",
    name: "ConvertToLivePageDialog",
    loader: async ()=>(await (parcelRequire("9R41R"))).ConvertToLivePageDialog
});
module.exports["ConvertToLivePageDialog"] = $5b509ab565dd40fa$export$13f6b1ebaf0950f0;

});

parcelRegister("9R41R", function(module, exports) {

let $72cc305d8e5cd45e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72cc305d8e5cd45e$var$load("6wr18"),
    $72cc305d8e5cd45e$var$load("ffEVr"),
    $72cc305d8e5cd45e$var$load("RU02s")
]).then(()=>parcelRequire('9Pjdf'));

});

parcelRegister("3FmeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");


var $fyUox = parcelRequire("fyUox");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $6s78L = parcelRequire("6s78L");


var $9Yt7A = parcelRequire("9Yt7A");


var $6LFAK = parcelRequire("6LFAK");

const $cb12ca6e6f1d2ae2$var$i18nBase = (0, $aXWIB.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title",
        defaultMessage: "Unable to convert draft to live page"
    },
    genericErrorFlagTitle: {
        id: "live-pages-features.converttolivepage.generic-error.title",
        defaultMessage: "An error occurred"
    }
});
const $cb12ca6e6f1d2ae2$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title.livedocs",
        defaultMessage: "Unable to convert draft to live doc"
    }
});
const $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($cb12ca6e6f1d2ae2$var$i18nBase, $cb12ca6e6f1d2ae2$var$i18nLiveDocs);
const $cb12ca6e6f1d2ae2$var$preloadProperties = async (contentId, spaceId)=>{
    const tasks = [];
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceId,
        fetchPolicy: 'network-only'
    }));
    tasks.push((0, $irrTO.preloadDraftContentAppearance)(contentId, false));
    return Promise.all(tasks);
};
const $cb12ca6e6f1d2ae2$export$a4275df84ffd8722 = async ({ contentId: contentId, spaceId: spaceId = '', onSuccess: onSuccess, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, writeSubTypeFragment: writeSubTypeFragment })=>{
    try {
        const { data: mutationData } = await (0, $6s78L.mutateInterop)({
            mutation: (0, $9Yt7A.default),
            variables: {
                contentId: contentId
            },
            update: (_, { data: data })=>{
                if (data?.convertPageToLiveEditAction?.success) {
                    writeSubTypeFragment({
                        fragmentId: `Content:${contentId}`,
                        data: {
                            __typename: 'Content',
                            subType: 'live'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            }
        });
        const result = mutationData?.convertPageToLiveEditAction;
        if (result?.success) {
            await $cb12ca6e6f1d2ae2$var$preloadProperties(contentId, spaceId).catch(()=>{
            // Since its a preload, we don't want show an error flag
            });
            onSuccess();
            return;
        }
        result?.errors?.forEach(async (error)=>{
            (0, $6LFAK.processError)(error, contentId);
            const flagTitle = error.message === 'Title already exists' ? $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.titleConflictFlagTitle : $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle;
            const flagDescription = (0, $6LFAK.getI18nStringForError)(error.message ?? '');
            const flagDescriptionValues = {};
            if (error.message === 'Title already exists') {
                const { title: pageTitle } = await retrieveEditorTitleAndContent();
                flagDescriptionValues.pageTitle = pageTitle || '';
            }
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), flagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...flagDescription,
                    values: flagDescriptionValues
                }),
                isAutoDismiss: false
            });
        });
    } catch (error) {
        (0, $6LFAK.processError)(error, contentId);
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $6LFAK.i18n).unknownError),
            isAutoDismiss: false
        });
    }
};
const $cb12ca6e6f1d2ae2$export$5c2d46edf58b6daa = $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168;
module.exports["convertDraftToLivePage"] = $cb12ca6e6f1d2ae2$export$a4275df84ffd8722;

});

parcelRegister("9Yt7A", function(module, exports) {
/**
 * @generated SignedSource<<eb8d3f332dabbd6f132badea8ffcf6e3>>
 * @relayHash 603eb09fdbf7e41ae341d58b5067bb0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4a98a70adb646dfa084b35cf854a7b68d474aa44e9927399f73da1aad0d0d1b
const $e053a44ee0757fb3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConvertPageToLiveEditActionPayload",
            "kind": "LinkedField",
            "name": "convertPageToLiveEditAction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertToLivePageMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertToLivePageMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "603eb09fdbf7e41ae341d58b5067bb0a",
            "id": "d4a98a70adb646dfa084b35cf854a7b68d474aa44e9927399f73da1aad0d0d1b",
            "metadata": {},
            "name": "ConvertToLivePageMutation",
            "operationKind": "mutation",
            "text": "mutation ConvertToLivePageMutation($contentId:ID!){convertPageToLiveEditAction(input:{contentId:$contentId}){success,errors{message}}}"
        }
    };
}();
$e053a44ee0757fb3$var$node.hash = "ad615689cf4fc4a255187ebb0a30c32e";
var $e053a44ee0757fb3$export$2e2bcd8739ae039 = $e053a44ee0757fb3$var$node;
module.exports["default"] = $e053a44ee0757fb3$export$2e2bcd8739ae039;

});

parcelRegister("6LFAK", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $422HI = parcelRequire("422HI");


var $jhwJP = parcelRequire("jhwJP");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");


var $7Sm4c = parcelRequire("7Sm4c");

const $49d66c83bc63de25$var$i18nBase = (0, $aXWIB.defineMessages)({
    unknownError: {
        id: "live-pages-features.converttolivepage.modal.error.unknown",
        defaultMessage: "An error occurred. Please try again."
    },
    serverException: {
        id: "live-pages-features.converttolivepage.modal.error.serverException",
        defaultMessage: "An unexpected error occurred. Please try again later."
    },
    pageNotFound: {
        id: "live-pages-features.converttolivepage.modal.error.pageNotFound",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "The page you\u2019re trying to edit doesn\u2018t exist."
    },
    contentServiceException: {
        id: "live-pages-features.converttolivepage.modal.error.contentServiceException",
        defaultMessage: "The requested content is not available."
    },
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive",
        defaultMessage: "This page has already been switched to a live page."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError",
        defaultMessage: "This page can\u2019t be switched to a live page due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions",
        defaultMessage: "You don\u2019t have the necessary permissions to switch this to a live page."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    },
    viewScreenTitleConflict: {
        id: "live-pages-features.converttolivepage.modal.error.view-screen-conversion-title-conflict",
        defaultMessage: "There\u2019s already content with this page\u2019s updated title in the space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive.livedocs",
        defaultMessage: "This page has already been converted to a live doc."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError.livedocs",
        defaultMessage: "This page can\u2019t be converted to a live doc due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions.livedocs",
        defaultMessage: "You don\u2019t have the necessary permissions to convert this to a live doc."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description.livedocs",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($49d66c83bc63de25$var$i18nBase, $49d66c83bc63de25$var$i18nLiveDocs);
const $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY = {
    serverException: 'Some server exception',
    pageNotFound: 'Page not found with provided id',
    contentServiceException: 'Content service exception',
    pageAlreadyLive: 'Page subtype is already set to live',
    legacyPageConversionError: 'Legacy page cannot be converted to live edit',
    noEditPermissions: 'Page cannot be converted without edit permissions',
    draftTitleConflict: 'Title already exists'
};
const $49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE = Object.entries($49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY).reduce((acc, [key, value])=>({
        ...acc,
        [value]: key
    }), {});
const $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES = [
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.draftTitleConflict,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageAlreadyLive,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.noEditPermissions,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageNotFound
];
const $49d66c83bc63de25$export$55d2d97fdb72d6e6 = (errorMessage)=>{
    return $49d66c83bc63de25$export$a7357cdd1f0b0168[$49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE[errorMessage]] || $49d66c83bc63de25$export$a7357cdd1f0b0168.unknownError;
};
const $49d66c83bc63de25$export$ad03839ff2e809af = (error, contentId)=>{
    (0, $fJlJm.setContentErrorAttributes)(error, {
        objectId: contentId
    });
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    });
};
const $49d66c83bc63de25$export$83457a6c00af4df7 = (error, contentId)=>{
    let normalizedError;
    if (error instanceof Error || error instanceof (0, $422HI.ApolloErrorInterop)) normalizedError = error;
    else {
        // NOTE: Mutation errors from conversion have a null prototype, causing some below checks to throw an error because `hasOwnProperty` doesn't exist.
        //       Wrapping in a new Error retains original context and ensures the error contains `hasOwnProperty`, so we can handle the errors we're passed without issue.
        normalizedError = new Error(error?.message || 'Unknown error');
        if ('__typename' in error && error?.__typename) normalizedError.name = error?.__typename;
    }
    const isHandledConversionError = $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES.includes(normalizedError.message);
    if ((0, $1uFM6.isUnauthorizedError)(normalizedError) || (0, $6fil2.containsNetworkError)(normalizedError) || isHandledConversionError) {
        (0, $7Sm4c.markErrorAsHandled)(normalizedError);
        return {
            isHandled: true
        };
    } else {
        $49d66c83bc63de25$export$ad03839ff2e809af(normalizedError, contentId);
        return {
            isHandled: false
        };
    }
};
module.exports["i18n"] = $49d66c83bc63de25$export$a7357cdd1f0b0168;
module.exports["getI18nStringForError"] = $49d66c83bc63de25$export$55d2d97fdb72d6e6;
module.exports["processError"] = $49d66c83bc63de25$export$83457a6c00af4df7;

});

parcelRegister("9BVDK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02b364a2e855ad9d$export$20020b6b9f67a9ec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "N5Ue8",
    name: "ResolvedInlineCommentsCounterLoader",
    loader: async ()=>(await (parcelRequire("1Fl3l"))).ResolvedInlineCommentsCounter
});
module.exports["ResolvedInlineCommentsCounterLoader"] = $02b364a2e855ad9d$export$20020b6b9f67a9ec;

});

parcelRegister("1Fl3l", function(module, exports) {

let $1369f3795a790775$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1369f3795a790775$var$load("aS96v").then(()=>parcelRequire('79cvA'));

});

parcelRegister("l3C2L", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ff94b9918380dc5d$export$cc6c027a319af205 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9P0ef",
    name: "ViewChangesDialogLoader",
    loader: async ()=>(await (parcelRequire("4PsmB"))).ViewChangesDialog
});
module.exports["ViewChangesDialogLoader"] = $ff94b9918380dc5d$export$cc6c027a319af205;

});

parcelRegister("4PsmB", function(module, exports) {

let $3841ed4449494d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3841ed4449494d1e$var$load("lJJQ8").then(()=>parcelRequire('iDTLl'));

});

parcelRegister("d8oE8", function(module, exports) {
const $305fd3cd961d4815$export$bd41ea3025fc88df = (push, contentType, spaceKey, contentId, contentStatus)=>{
    if (!contentType || !contentId) return;
    const isBlogPost = contentType === 'blogpost';
    const isCreate = contentStatus === 'draft';
    if (isBlogPost && !isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`);
    else if (!isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`);
    else push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/create?draftId=${contentId}`);
};
module.exports["onClickPageRevert"] = $305fd3cd961d4815$export$bd41ea3025fc88df;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("1PC5x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $297029061926b2dd$export$77691412571457f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8jq35",
    name: "LinkToThisPageDialog",
    loader: async ()=>(await (parcelRequire("hmLpt"))).LinkToThisPageDialog
});
module.exports["LinkToThisPageDialog"] = $297029061926b2dd$export$77691412571457f;

});

parcelRegister("hmLpt", function(module, exports) {

let $ca49445e97c84b2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ca49445e97c84b2c$var$load("Wowvf"),
    $ca49445e97c84b2c$var$load("kHOMt"),
    $ca49445e97c84b2c$var$load("hhss7"),
    $ca49445e97c84b2c$var$load("dXoLf")
]).then(()=>parcelRequire('gaLJH'));

});

parcelRegister("82Ooj", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3802aca2c5107012$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re editing this live doc"
    },
    livePagesEditModeFlagDescription: {
        id: "live-pages-features.live-pages.edit-mode-flag.description",
        defaultMessage: "Tip: To switch to viewing only, use the keyboard shortcut {keyCombination}."
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re viewing this live doc"
    },
    livePagesViewModeFlagDescription: {
        id: "live-pages-features.live-pages.view-mode-flag.description",
        defaultMessage: "Tip: To start editing, select {keyCombination} on your keyboard."
    }
});
const $3802aca2c5107012$export$f1bb393ced142bbb = (flags)=>{
    const intl = (0, $aXWIB.useIntl)();
    const logger = (0, $7W8i8.getLogger)('editor-mainbuttons-livepage-modechanger');
    const hasLivePageModeFlagBeenShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            return flagsShown[mode] === true;
        } catch (error) {
            logger.error`Error checking if live page mode flag has been shown for mode: "${mode}". Reason: ${error.message}`;
            return false;
        }
    };
    const setLivePageModeFlagAsShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            flagsShown[mode] = true;
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN, JSON.stringify(flagsShown));
        } catch (error) {
            logger.error`Error setting live page mode flag as shown for mode: "${mode}". Reason: ${error.message}`;
        }
    };
    const modeDetails = {
        view: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT), intl.formatMessage)
            })
        },
        edit: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW), intl.formatMessage)
            })
        }
    };
    const showLivePageModeFlag = (newMode)=>{
        const selectedModeDetails = modeDetails[newMode];
        if (selectedModeDetails) {
            if (!hasLivePageModeFlagBeenShown(newMode)) {
                const { title: title, description: description } = selectedModeDetails;
                const flagId = 'live-pages-mode-flag';
                // hide any flags that are currently showing
                flags.hideFlag(flagId);
                flags.showFlag({
                    id: flagId,
                    title: title,
                    description: description,
                    close: 'auto'
                });
                setLivePageModeFlagAsShown(newMode);
            }
        }
    };
    return {
        showLivePageModeFlag: showLivePageModeFlag
    };
};
module.exports["useLivePageModeFlag"] = $3802aca2c5107012$export$f1bb393ced142bbb;

});

parcelRegister("5KL6w", function(module, exports) {
$parcel$export(module.exports, "usePresenterModeContext", () => (parcelRequire("l1b8J")).usePresenterModeContext);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $3HHS0 = parcelRequire("3HHS0");


var $l1b8J = parcelRequire("l1b8J");


const $51949aafbfeff0f9$export$d9be451d5ed0cecd = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qz-Pe",
    name: "PresenterModeContextProvider",
    loader: async ()=>(await Promise.resolve((parcelRequire("l1b8J")))).PresenterModeContextProvider
});

const $51949aafbfeff0f9$export$62fbe81a4ea288fa = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "P5ZKu",
    name: "LazyPresenterModeContextConsumer",
    loader: async ()=>(await Promise.resolve((parcelRequire("l1b8J")))).PresenterModeContextConsumer,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3HHS0.PresentationModePlaceholder), null)
});
module.exports["PresenterModeContextProvider"] = $51949aafbfeff0f9$export$d9be451d5ed0cecd;
module.exports["LazyPresenterModeContextConsumer"] = $51949aafbfeff0f9$export$62fbe81a4ea288fa;

});

parcelRegister("3HHS0", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $667e8b8d9015d9ff$export$a718db6ba6835b50 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '40px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '17px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '10%'
        }
    }));
};
module.exports["PresentationModePlaceholder"] = $667e8b8d9015d9ff$export$a718db6ba6835b50;

});

parcelRegister("l1b8J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7K112 = parcelRequire("7K112");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7J5Uc = parcelRequire("7J5Uc");


var $8uOqu = parcelRequire("8uOqu");

const $fb6fb6e8473a5f8b$var$PresenterModeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    isPresenterModeActive: false,
    isBrowserFullscreen: false,
    hasEnteredPresentMode: false,
    presenterModeContextError: null,
    isPresenterModeEnabled: false,
    enterPresenterMode: ()=>{
    // Intentional no-op
    },
    exitPresenterMode: ()=>{
    // Intentional no-op
    },
    setPresenterModeContextError: ()=>{
    // Intentional no-op
    },
    enterBrowserFullscreen: ()=>{
    // Intentional no-op
    },
    enterSystemFullscreen: ()=>{
    // Intentional no-op
    },
    setIsBrowserFullscreen: ()=>{
    // Intentional no-op
    },
    setHasEnteredPresentMode: ()=>{
    // Intentional no-op
    }
});
const $fb6fb6e8473a5f8b$export$d9be451d5ed0cecd = ({ children: children, contentId: contentId, spaceKey: spaceKey })=>{
    const [isPresenterModeActive, setIsPresenterModeActive] = (0, $42omo.useState)(false);
    const [isBrowserFullscreen, setIsBrowserFullscreen] = (0, $42omo.useState)(false);
    const [presenterModeContextError, setPresenterModeContextError] = (0, $42omo.useState)(null);
    const [hasEnteredPresentMode, setHasEnteredPresentMode] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { restoreThemePreference: restoreThemePreference } = (0, $7J5Uc.useThemingActions)();
    const enterBrowserFullscreen = (0, $42omo.useCallback)(()=>{
        setIsBrowserFullscreen(true);
    }, []);
    const handleFullScreenApiError = (0, $42omo.useCallback)((error)=>{
        enterBrowserFullscreen();
        setPresenterModeContextError(error);
    }, [
        setPresenterModeContextError,
        enterBrowserFullscreen
    ]);
    const fscreenRequestFullscreen = (0, $42omo.useCallback)(()=>{
        return Promise.resolve((0, $7K112.default).requestFullscreen(document.documentElement));
    }, []);
    const fscreenExitFullscreen = (0, $42omo.useCallback)(()=>{
        return Promise.resolve((0, $7K112.default).exitFullscreen());
    }, []);
    const isPresenterModeEnabled = (0, $7K112.default).fullscreenEnabled;
    const enterPresenterMode = (0, $42omo.useCallback)(()=>{
        setHasEnteredPresentMode(true);
        experienceTracker.start({
            name: (0, $irVI7.PRESENTER_MODE_FULLSCREEN_API_EXPERIENCE)
        });
        (0, $7K112.default).addEventListener('fullscreenerror', handleFullScreenApiError, false);
        setIsPresenterModeActive(true);
        setPresenterModeContextError(null);
        if (!isPresenterModeEnabled) {
            const error = new Error('Fullscreen mode is not supported');
            handleFullScreenApiError(error);
            enterBrowserFullscreen();
            return;
        }
        if ((0, $7K112.default).fullscreenElement) fscreenExitFullscreen().then(fscreenRequestFullscreen).then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
        }).catch(enterBrowserFullscreen);
        else fscreenRequestFullscreen().then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
        }).catch(enterBrowserFullscreen);
    }, [
        experienceTracker,
        fscreenRequestFullscreen,
        isPresenterModeEnabled,
        fscreenExitFullscreen,
        handleFullScreenApiError,
        enterBrowserFullscreen,
        setHasEnteredPresentMode
    ]);
    const enterSystemFullscreen = (0, $42omo.useCallback)(()=>{
        setIsBrowserFullscreen(false);
        enterPresenterMode();
    }, [
        enterPresenterMode
    ]);
    const exitPresenterMode = (0, $42omo.useCallback)(()=>{
        setIsPresenterModeActive(false);
        (0, $7K112.default).removeEventListener('fullscreenerror', handleFullScreenApiError, false);
        restoreThemePreference();
    }, [
        setIsPresenterModeActive,
        handleFullScreenApiError,
        restoreThemePreference
    ]);
    const data = (0, $42omo.useMemo)(()=>({
            isPresenterModeActive: isPresenterModeActive,
            isBrowserFullscreen: isBrowserFullscreen,
            hasEnteredPresentMode: hasEnteredPresentMode,
            enterPresenterMode: enterPresenterMode,
            exitPresenterMode: exitPresenterMode,
            isPresenterModeEnabled: isPresenterModeEnabled,
            presenterModeContextError: presenterModeContextError,
            setPresenterModeContextError: setPresenterModeContextError,
            enterBrowserFullscreen: enterBrowserFullscreen,
            setIsBrowserFullscreen: setIsBrowserFullscreen,
            enterSystemFullscreen: enterSystemFullscreen,
            setHasEnteredPresentMode: setHasEnteredPresentMode
        }), [
        isPresenterModeActive,
        isBrowserFullscreen,
        hasEnteredPresentMode,
        enterPresenterMode,
        exitPresenterMode,
        isPresenterModeEnabled,
        presenterModeContextError,
        setPresenterModeContextError,
        enterBrowserFullscreen,
        setIsBrowserFullscreen,
        enterSystemFullscreen,
        setHasEnteredPresentMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fb6fb6e8473a5f8b$var$PresenterModeContext.Provider, {
        value: data
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uOqu.PresenterModeWrapper), {
        contentId: contentId,
        spaceKey: spaceKey
    }));
};
const $fb6fb6e8473a5f8b$export$5b228b85ce187234 = ()=>{
    return (0, $42omo.useContext)($fb6fb6e8473a5f8b$var$PresenterModeContext);
};
const $fb6fb6e8473a5f8b$export$530d225c8bef9444 = ({ children: children })=>{
    const { enterPresenterMode: enterPresenterMode } = $fb6fb6e8473a5f8b$export$5b228b85ce187234();
    return children(enterPresenterMode);
};
module.exports["PresenterModeContextProvider"] = $fb6fb6e8473a5f8b$export$d9be451d5ed0cecd;
module.exports["usePresenterModeContext"] = $fb6fb6e8473a5f8b$export$5b228b85ce187234;
module.exports["PresenterModeContextConsumer"] = $fb6fb6e8473a5f8b$export$530d225c8bef9444;

});

parcelRegister("7K112", function(module, exports) {
var $5a2d9dfb75d453ef$var$key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var $5a2d9dfb75d453ef$var$webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
    '-webkit-full-screen'
];
var $5a2d9dfb75d453ef$var$moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror',
    '-moz-full-screen'
];
var $5a2d9dfb75d453ef$var$ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError',
    '-ms-fullscreen'
];
// so it doesn't throw if no window or document
var $5a2d9dfb75d453ef$var$document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
var $5a2d9dfb75d453ef$var$vendor = 'fullscreenEnabled' in $5a2d9dfb75d453ef$var$document && Object.keys($5a2d9dfb75d453ef$var$key) || $5a2d9dfb75d453ef$var$webkit[0] in $5a2d9dfb75d453ef$var$document && $5a2d9dfb75d453ef$var$webkit || $5a2d9dfb75d453ef$var$moz[0] in $5a2d9dfb75d453ef$var$document && $5a2d9dfb75d453ef$var$moz || $5a2d9dfb75d453ef$var$ms[0] in $5a2d9dfb75d453ef$var$document && $5a2d9dfb75d453ef$var$ms || [];
var $5a2d9dfb75d453ef$var$fscreen = {
    requestFullscreen: function(element) {
        return element[$5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.requestFullscreen]]();
    },
    requestFullscreenFunction: function(element) {
        return element[$5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.requestFullscreen]];
    },
    get exitFullscreen () {
        return $5a2d9dfb75d453ef$var$document[$5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.exitFullscreen]].bind($5a2d9dfb75d453ef$var$document);
    },
    get fullscreenPseudoClass () {
        return ":" + $5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.fullscreen];
    },
    addEventListener: function(type, handler1, options) {
        return $5a2d9dfb75d453ef$var$document.addEventListener($5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key[type]], handler1, options);
    },
    removeEventListener: function(type, handler1, options) {
        return $5a2d9dfb75d453ef$var$document.removeEventListener($5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key[type]], handler1, options);
    },
    get fullscreenEnabled () {
        return Boolean($5a2d9dfb75d453ef$var$document[$5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.fullscreenEnabled]]);
    },
    set fullscreenEnabled (val){},
    get fullscreenElement () {
        return $5a2d9dfb75d453ef$var$document[$5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.fullscreenElement]];
    },
    set fullscreenElement (val){},
    get onfullscreenchange () {
        return $5a2d9dfb75d453ef$var$document[("on" + $5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.fullscreenchange]).toLowerCase()];
    },
    set onfullscreenchange (handler){
        return $5a2d9dfb75d453ef$var$document[("on" + $5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.fullscreenchange]).toLowerCase()] = handler;
    },
    get onfullscreenerror () {
        return $5a2d9dfb75d453ef$var$document[("on" + $5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.fullscreenerror]).toLowerCase()];
    },
    set onfullscreenerror (handler){
        return $5a2d9dfb75d453ef$var$document[("on" + $5a2d9dfb75d453ef$var$vendor[$5a2d9dfb75d453ef$var$key.fullscreenerror]).toLowerCase()] = handler;
    }
};
var $5a2d9dfb75d453ef$export$2e2bcd8739ae039 = $5a2d9dfb75d453ef$var$fscreen;
module.exports["default"] = $5a2d9dfb75d453ef$export$2e2bcd8739ae039;

});

parcelRegister("8uOqu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");


var $l1b8J = parcelRequire("l1b8J");


var $hMdkB = parcelRequire("hMdkB");

const $a1ce8cd657fbddc0$export$2a648297aa723519 = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const { isPresenterModeActive: isPresenterModeActive, isBrowserFullscreen: isBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    if (isPresenterModeActive || isBrowserFullscreen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMdkB.PresenterModePortal), {
            contentId: contentId,
            spaceKey: spaceKey,
            setFlagsVisibility: flags.setFlagsVisibility
        }));
    return null;
};
module.exports["PresenterModeWrapper"] = $a1ce8cd657fbddc0$export$2a648297aa723519;

});

parcelRegister("hMdkB", function(module, exports) {

var $g6TxC = parcelRequire("g6TxC");


var $9HwND = parcelRequire("9HwND");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7K112 = parcelRequire("7K112");


var $5zdke = parcelRequire("5zdke");


var $caX7N = parcelRequire("caX7N");


var $9hlns = parcelRequire("9hlns");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $8rneB = parcelRequire("8rneB");


var $di8q4 = parcelRequire("di8q4");


var $e8Lxy = parcelRequire("e8Lxy");


var $cTIr3 = parcelRequire("cTIr3");


var $euF5O = parcelRequire("euF5O");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $cMvQV = parcelRequire("cMvQV");


var $Qlykt = parcelRequire("Qlykt");


var $ep3mz = parcelRequire("ep3mz");


var $kDhla = parcelRequire("kDhla");


var $chP0Z = parcelRequire("chP0Z");


var $j3Lh2 = parcelRequire("j3Lh2");


var $kXAIp = parcelRequire("kXAIp");


var $2jkzM = parcelRequire("2jkzM");


var $ibtF1 = parcelRequire("ibtF1");


var $7mDnI = parcelRequire("7mDnI");


var $9wGTI = parcelRequire("9wGTI");


var $gnyTR = parcelRequire("gnyTR");


var $l1b8J = parcelRequire("l1b8J");


var $fDEVM = parcelRequire("fDEVM");


var $jMyy4 = parcelRequire("jMyy4");

const $bdd13d294a89f9eb$var$PresenterModePortalPresenterModeContentTitleQuery = (0, $9HwND.default);
const $bdd13d294a89f9eb$var$PresenterModePortalPresenterModeCoverPictureQuery = (0, $g6TxC.default);
const $bdd13d294a89f9eb$var$i18n = (0, $aXWIB.defineMessages)({
    genericErrorMessage: {
        id: "presentation-mode.portal.generic.error.message",
        defaultMessage: "Something\u2019s not right. Refresh and try again."
    }
});
const $bdd13d294a89f9eb$var$presenterModeContainerStyle = null;
const $bdd13d294a89f9eb$var$spacerStyle = null; /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
const $bdd13d294a89f9eb$var$titleFixedSpacingStyle = null; /* eslint-enable @atlaskit/design-system/use-tokens-typography */ 
const $bdd13d294a89f9eb$export$fa29436318a8d949 = 'presenter-mode-zoom-container';
const $bdd13d294a89f9eb$export$e1872a7bb3bd287c = 'presenter-mode-container';
const $bdd13d294a89f9eb$export$158030c0e49f9498 = 'presenter-mode-portal-container';
const $bdd13d294a89f9eb$export$750df9d29fdbd29f = 'presenter-mode-title-text';
const $bdd13d294a89f9eb$export$9439b54f8681bb48 = 'presenter-mode-content-container';
const $bdd13d294a89f9eb$export$4d12947f8edb059f = 'presenter-mode-content-container-bottom-spacer';
(0, $cMvQV.setUserAgent)();
const $bdd13d294a89f9eb$var$legacyMacroRendererContextValue = {
    shouldRefetchMacroQuery: true
}; /**
    * This component encapsulates the actual presenter mode experience. It's responsible
    * for rendering the nav bar and the content itself, which it gets via GraphQL.
    * Everything is placed within a Portal component which is rendered on top of the page.
    */ 
const $bdd13d294a89f9eb$export$c815374aa38c89e7 = ({ contentId: contentId, spaceKey: spaceKey, setFlagsVisibility: setFlagsVisibility })=>{
    const [isCustomCursorActive, setIsCustomCursorActive] = (0, $42omo.useState)(true);
    const [contentRendered, setContentRendered] = (0, $42omo.useState)(false);
    const [editorContent, setEditorContent] = (0, $42omo.useState)();
    const { isBrowserFullscreen: isBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    const [{ fullPageEditorPresetAPI: editorApi }] = (0, $kDhla.useFullPageEditorApi)();
    const intl = (0, $aXWIB.useIntl)();
    const handleSwitchCursor = (newValue)=>setIsCustomCursorActive(newValue); // Prevent scrolling of content underneath the portal
    (0, $j3Lh2.useLockBodyScroll)(); // Handles entering/exiting fullscreen mode
    (0, $chP0Z.useFullscreenMode)();
    (0, $42omo.useEffect)(()=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            setEditorContent(doc);
        });
    }, [
        editorApi
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isBrowserFullscreen) (0, $7K112.default).exitFullscreen();
    }, [
        isBrowserFullscreen
    ]); // Handles hiding flags while in Presenter Mode
    (0, $kXAIp.useHideFlags)(setFlagsVisibility);
    const { data: titleData, loading: titleLoading, error: contentTitleError } = (0, $jMyy4.useQueryInterop)($bdd13d294a89f9eb$var$PresenterModePortalPresenterModeContentTitleQuery, {
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId
        }
    });
    const emojiTitle = (0, $8rneB.getPublishedEmojiId)(titleData);
    const [contentType] = (0, $ep3mz.useContentType)();
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
    const { data: contentData, loading: contentLoading, error: contentUnifiedError } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ chooseContentUnifiedQuery, {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: !contentId || !spaceKey,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: null
        }
    });
    const { data: coverPictureQueryData, loading: coverPictureLoading, error: presenterModeCoverPictureError } = (0, $jMyy4.useQueryInterop)($bdd13d294a89f9eb$var$PresenterModePortalPresenterModeCoverPictureQuery, {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            status: [
                'current'
            ]
        }
    });
    const loading = contentLoading || titleLoading || coverPictureLoading;
    const handleOnRenderedEvent = ()=>setContentRendered(true);
    const isTitleCenterAligned = (0, $fDEVM.useIsTitleCenterAligned)(contentId);
    const hasCoverPicture = !!coverPictureQueryData?.content?.nodes?.[0]?.properties?.nodes?.[0];
    const hasEmoji = !!emojiTitle;
    const [viewportWidth, setViewportWidth] = (0, $42omo.useState)(window.innerWidth);
    (0, $42omo.useEffect)(()=>{
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: 519
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5zdke.default), {
        autoFocus: false,
        returnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.PresenterModePortalContainer), {
        id: $bdd13d294a89f9eb$export$158030c0e49f9498,
        isCustomCursorActive: isCustomCursorActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2jkzM.HeaderPresenterMode), {
        contentRendered: contentRendered,
        onSwitchCursorClick: handleSwitchCursor,
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: $bdd13d294a89f9eb$export$e1872a7bb3bd287c,
        className: (0, $gMc0m.default)([
            "_1bsb1osq"
        ])
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.LoadingContainer), {
        "data-testid": "presenter-mode-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        interactionName: "presenter-mode-portal"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, coverPictureQueryData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ibtF1.HeaderImage), {
        contentId: contentId,
        coverPictureQueryData: coverPictureQueryData
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.NoHeaderImageSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.PresenterModeZoomContainer), {
        "data-testid": "presenter-mode-zoom-container",
        id: $bdd13d294a89f9eb$export$fa29436318a8d949,
        isFirefox: (0, $cMvQV.isFirefox)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.FlagsContainer), null, (contentTitleError || contentUnifiedError || presenterModeCoverPictureError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7mDnI.ErrorFlag), {
        title: intl.formatMessage($bdd13d294a89f9eb$var$i18n.genericErrorMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.TitleContainer), {
        id: $bdd13d294a89f9eb$export$750df9d29fdbd29f,
        "data-testid": "presenter-mode-title-container",
        hasCoverPicture: hasCoverPicture,
        isTitleCenterAligned: isTitleCenterAligned,
        hasEmoji: hasEmoji,
        width: viewportWidth
    }, emojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.EmojiWrapper), {
        hasCoverPicture: hasCoverPicture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emojiTitle,
        height: hasCoverPicture ? (0, $Qlykt.EMOJI_SIZE_LARGE) : (0, $Qlykt.EMOJI_SIZE_MEDIUM),
        hasCoverPicture: hasCoverPicture,
        isPageTitleComponent: true,
        context: "presenterMode",
        showTooltip: true,
        renderResourcedEmoji: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.TitleTextWrapper), {
        "data-testId": "titleTextWrapper",
        shouldAddLeftPadding: hasEmoji && !isTitleCenterAligned && !hasCoverPicture
    }, (0, $9wGTI.fg)('cc_frontend_presentation_title_spacin') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h1", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pbfng _syazi7uo _1nmz1hna _1i4q1hna _1tke1jfw _ca0q12x7 _1e0c1ule _1wybkogo _vwz4izfg _181zckbl _iavl8vuz _1ni8or1b _135cckbl"
        ])
    }, titleData?.content?.nodes?.[0]?.title ?? '') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.Title), null, titleData?.content?.nodes?.[0]?.title ?? ''))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $euF5O.LegacyMacroRendererContext).Provider, {
        value: $bdd13d294a89f9eb$var$legacyMacroRendererContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e8Lxy.PageContentRenderer), {
        contentId: contentId,
        document: editorContent,
        data: contentData,
        onRendered: handleOnRenderedEvent,
        hasInlineComments: false,
        appearance: "full-page",
        stickyHeaders: {
            offsetTop: 0
        },
        spaceKey: spaceKey,
        isPresentational: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: $bdd13d294a89f9eb$export$4d12947f8edb059f,
        className: (0, $gMc0m.default)([
            "_4t3i12am"
        ])
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cTIr3.LazyQRCodeGenerator), {
        contentId: contentId,
        spaceKey: spaceKey
    })))));
};
module.exports["PresenterModeZoomContainerId"] = $bdd13d294a89f9eb$export$fa29436318a8d949;
module.exports["PresenterModeContainerId"] = $bdd13d294a89f9eb$export$e1872a7bb3bd287c;
module.exports["PresenterModePortalContainerId"] = $bdd13d294a89f9eb$export$158030c0e49f9498;
module.exports["PresenterModePageTitleId"] = $bdd13d294a89f9eb$export$750df9d29fdbd29f;
module.exports["PresenterModeBottomSpacerId"] = $bdd13d294a89f9eb$export$4d12947f8edb059f;
module.exports["PresenterModePortal"] = $bdd13d294a89f9eb$export$c815374aa38c89e7;

});

parcelRegister("g6TxC", function(module, exports) {
/**
 * @generated SignedSource<<9e04438ba936c59a87390f36bfd794a1>>
 * @relayHash de4d9d686320df3885759997cb1dea1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 596432b3fe72e76dfac96d97bcdd00fadb3129b5e172d978a8692f0079b1c431
const $43087a03fe0f39ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "de4d9d686320df3885759997cb1dea1b",
            "id": "596432b3fe72e76dfac96d97bcdd00fadb3129b5e172d978a8692f0079b1c431",
            "metadata": {},
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "operationKind": "query",
            "text": "query PresenterModePortalPresenterModeCoverPictureQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$43087a03fe0f39ae$var$node.hash = "06d34d781803b4e8c4ff1a93ae7349df";
var $43087a03fe0f39ae$export$2e2bcd8739ae039 = $43087a03fe0f39ae$var$node;
module.exports["default"] = $43087a03fe0f39ae$export$2e2bcd8739ae039;

});

parcelRegister("9HwND", function(module, exports) {
/**
 * @generated SignedSource<<8348cccdf71c6c48ee459fcd8fdd147f>>
 * @relayHash 71650dfb167b5e53344553c052814f35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8784ffad5fb2dc131a0387a6140976fd26edfa297aa6c8b24de67ea4b167b55d
const $0cb2cdb46393f11b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "alias": "emojiTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-title-published\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "71650dfb167b5e53344553c052814f35",
            "id": "8784ffad5fb2dc131a0387a6140976fd26edfa297aa6c8b24de67ea4b167b55d",
            "metadata": {},
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "operationKind": "query",
            "text": "query PresenterModePortalPresenterModeContentTitleQuery($contentId:ID!){content(id:$contentId){nodes{id,title,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value}}}}}"
        }
    };
}();
$0cb2cdb46393f11b$var$node.hash = "bb4f3c014152c410cb5600c2a10111e8";
var $0cb2cdb46393f11b$export$2e2bcd8739ae039 = $0cb2cdb46393f11b$var$node;
module.exports["default"] = $0cb2cdb46393f11b$export$2e2bcd8739ae039;

});

parcelRegister("cTIr3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fa2236fe735b9be$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $2fa2236fe735b9be$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2fa2236fe735b9be$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large"
    }));

const $2fa2236fe735b9be$export$c545dc5a218e1111 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mUAtU",
    name: "LazyQRCodeGenerator",
    loader: async ()=>(await (parcelRequire("itOeE"))).QRCodeComponent,
    loading: $2fa2236fe735b9be$var$LoadingSpinner
});
module.exports["LazyQRCodeGenerator"] = $2fa2236fe735b9be$export$c545dc5a218e1111;

});

parcelRegister("itOeE", function(module, exports) {

let $d741e72053308290$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d741e72053308290$var$load("6wr18"),
    $d741e72053308290$var$load("ffEVr"),
    $d741e72053308290$var$load("2nHxT")
]).then(()=>parcelRequire('5RnXN'));

});

parcelRegister("chP0Z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7K112 = parcelRequire("7K112");


var $l1b8J = parcelRequire("l1b8J");

const $a7ed65c805684c1a$export$5306b0eb80cf6407 = ()=>{
    const { exitPresenterMode: exitPresenterMode } = (0, $l1b8J.usePresenterModeContext)();
    (0, $42omo.useEffect)(()=>{
        // Event handler for when entering/exiting fullscreen mode
        const handleFullscreenChange = ()=>{
            /**
			 * This handles the case where the user has pressed Esc instead of using
			 * the "Exit" button to close presenter mode. In this case, the browser
			 * will be forced out of fullscreen mode, but presenter mode will still
			 * technically be active, so we need to listen for the event to make
			 * sure we exit presenter mode.
			 */ if (!(0, $7K112.default).fullscreenElement) exitPresenterMode();
        };
        (0, $7K112.default).addEventListener('fullscreenchange', handleFullscreenChange, false);
        return ()=>{
            /**
			 * This handles the common case where the user clicks the "Exit" button to close
			 * presenter mode, which will cause this callback to run.
			 */ if ((0, $7K112.default).fullscreenElement) (0, $7K112.default).exitFullscreen();
            (0, $7K112.default).removeEventListener('fullscreenchange', handleFullscreenChange, false);
        };
    }, [
        exitPresenterMode
    ]);
};
module.exports["useFullscreenMode"] = $a7ed65c805684c1a$export$5306b0eb80cf6407;

});

parcelRegister("j3Lh2", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e231207f12babf5b$export$bd4ec12442706c3d = ()=>{
    (0, $42omo.useLayoutEffect)(()=>{
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.body.style.overflow = originalStyle;
        };
    }, []);
};
module.exports["useLockBodyScroll"] = $e231207f12babf5b$export$bd4ec12442706c3d;

});

parcelRegister("kXAIp", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $731701c7a4a3e42e$export$3fe03aa4ff5dc935 = (setFlagsVisibility)=>{
    (0, $42omo.useEffect)(()=>{
        setFlagsVisibility(false);
        return ()=>{
            setFlagsVisibility(true);
        };
    }, [
        setFlagsVisibility
    ]);
};
module.exports["useHideFlags"] = $731701c7a4a3e42e$export$3fe03aa4ff5dc935;

});

parcelRegister("2jkzM", function(module, exports) {
/* HeaderPresenterMode.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $inPa6 = parcelRequire("inPa6");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $7QM6o = parcelRequire("7QM6o");


var $3IVqo = parcelRequire("3IVqo");


var $gnyTR = parcelRequire("gnyTR");


var $9BWGi = parcelRequire("9BWGi");


var $l1b8J = parcelRequire("l1b8J");

const $66cd5922db697139$export$ef625543408b2447 = 'presenter-mode-control-panel';
const $66cd5922db697139$var$headerContainerStyles = null;
const $66cd5922db697139$var$verticalDividerStyles = null;
const $66cd5922db697139$var$rightControlPanelStyles = null;
const $66cd5922db697139$var$i18n = (0, $aXWIB.defineMessages)({
    exit: {
        id: "presentation-mode.header.exit",
        defaultMessage: "Exit"
    }
});
const $66cd5922db697139$export$c7c42ad700a3285 = ({ onSwitchCursorClick: onSwitchCursorClick, contentRendered: contentRendered, spaceKey: spaceKey, contentId: contentId })=>{
    const { exitPresenterMode: exitPresenterMode, isBrowserFullscreen: isBrowserFullscreen, setIsBrowserFullscreen: setIsBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const [showLazyButtons, setShowLazyButtons] = (0, $42omo.useState)(false);
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $42omo.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setShowLazyButtons(true);
        }, 0);
        return ()=>{
            clearTimeout(timeout);
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewPresentScreen',
                attributes: {
                    objectId: contentId,
                    containerId: spaceId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        spaceId
    ]);
    const exit = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'present',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'close',
                objectId: contentId,
                containerId: spaceId
            }
        }).fire();
        exitPresenterMode();
    }, [
        createAnalyticsEvent,
        exitPresenterMode,
        contentId,
        spaceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3IVqo.ControlPanelContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "presentation-mode-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: $66cd5922db697139$export$ef625543408b2447,
        className: (0, $gMc0m.default)([
            "_1yt4utpp _2rko12b0 _4cvr1h6o _bfhk1bhr _kqsw1n9t _154i1ejb _1xi21ejb _1e0c1txw _1pby9y44 _16qs130s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_18u01wug _1e0c1txw _1bahesu3 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BWGi.LazyNavigation), {
        contentRendered: contentRendered,
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1kl7ia51 _4t3i1tcg _1bsbidpf"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9BWGi.LazySettingsMenu), {
        onSwitchCursorClick: onSwitchCursorClick,
        contentId: contentId,
        spaceKey: spaceKey
    }), contentRendered && showLazyButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.ButtonContainer), {
        id: "presenter-mode-exit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "presentation-mode-button-close",
        onClick: isBrowserFullscreen ? ()=>setIsBrowserFullscreen(false) : exit
    }, intl.formatMessage($66cd5922db697139$var$i18n.exit))))))));
};
module.exports["HeaderControlPanel"] = $66cd5922db697139$export$ef625543408b2447;
module.exports["HeaderPresenterMode"] = $66cd5922db697139$export$c7c42ad700a3285;

});

parcelRegister("3IVqo", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $969cdac05668aa2c$var$ControlPanelContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    isSettingsOpen: false,
    setIsSettingsOpen: ()=>{
    // Intentional no-op
    },
    isNavigationMenuOpen: false,
    setIsNavigationMenuOpen: ()=>{
    // Intentional no-op
    },
    width: '1'
});
const $969cdac05668aa2c$export$a5457ef551a7a8bf = ({ children: children })=>{
    const [isSettingsOpen, setIsSettingsOpen] = (0, $42omo.useState)(false);
    const [isNavigationMenuOpen, setIsNavigationMenuOpen] = (0, $42omo.useState)(false);
    const [width, setWidth] = (0, $42omo.useState)('1');
    const headerWidth = document.getElementById('presenter-mode-control-panel')?.getBoundingClientRect().width || 242;
    (0, $42omo.useEffect)(()=>{
        setWidth(headerWidth.toString());
    }, [
        headerWidth
    ]);
    const data = (0, $42omo.useMemo)(()=>({
            isSettingsOpen: isSettingsOpen,
            setIsSettingsOpen: setIsSettingsOpen,
            isNavigationMenuOpen: isNavigationMenuOpen,
            setIsNavigationMenuOpen: setIsNavigationMenuOpen,
            width: width
        }), [
        isSettingsOpen,
        setIsSettingsOpen,
        isNavigationMenuOpen,
        setIsNavigationMenuOpen,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($969cdac05668aa2c$var$ControlPanelContext.Provider, {
        value: data
    }, children);
};
const $969cdac05668aa2c$export$7a069434e96a0028 = ()=>{
    return (0, $42omo.useContext)($969cdac05668aa2c$var$ControlPanelContext);
};
module.exports["ControlPanelContextProvider"] = $969cdac05668aa2c$export$a5457ef551a7a8bf;
module.exports["useControlPanelContext"] = $969cdac05668aa2c$export$7a069434e96a0028;

});

parcelRegister("gnyTR", function(module, exports) {
/* presenterModeStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $Qlykt = parcelRequire("Qlykt");


var $4yA8P = parcelRequire("4yA8P");

const $72178c9eda154f79$var$screenSizeXS = 1080;
const $72178c9eda154f79$var$screenSizeS = 1280;
const $72178c9eda154f79$var$screenSizeM = 1536;
const $72178c9eda154f79$var$screenSizeL = 2560;
const $72178c9eda154f79$var$screenSizeHeaderImageBreakpoint = 1792;
const $72178c9eda154f79$var$CALCULATE_SCALED_COVER_IMAGE_HEIGHT_PRESENTER_MODE = 'min(max(calc(100vw * (7 / 38)), 140px), 750px)';
const $72178c9eda154f79$export$5aeddb36a71179f1 = -122;
const $72178c9eda154f79$export$18d6dec26df5efab = -104;
const $72178c9eda154f79$export$5cbab9ac5bb5eb6 = -95;
const $72178c9eda154f79$export$9efff5a152b2c8b9 = -82;
const $72178c9eda154f79$var$zoomLevelXSToM = 1.3;
const $72178c9eda154f79$var$zoomLevelL = 2;
const $72178c9eda154f79$var$cursorImage = `url(${(0, (/*@__PURE__*/$parcel$interopDefault($4yA8P)))}), auto`;
const $72178c9eda154f79$var$headerImageMediaQuery = {
    [`@media only screen and (min-width: ${$72178c9eda154f79$var$screenSizeHeaderImageBreakpoint}px)`]: {
        height: '360px'
    },
    [`@media only screen and (min-width: ${$72178c9eda154f79$var$screenSizeM}px) and (max-width: ${$72178c9eda154f79$var$screenSizeHeaderImageBreakpoint}px)`]: {
        height: '240px'
    },
    [`@media only screen and (max-width: ${$72178c9eda154f79$var$screenSizeM}px)`]: {
        height: '240px'
    }
};
const $72178c9eda154f79$export$ec38912285043019 = '1.5';
const $72178c9eda154f79$export$21d0e1ba36d5f647 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCustomCursorActive: isCustomCursorActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1db81y0": (0, $7sObp.default)($72178c9eda154f79$var$cursorImage)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsbauwl _4t3i1kxc _bfhkvuon _kqsw1n9t _154iidpf _1ltvidpf _18m915zi _1reo15vq _1e0c1txw _1bah1h6o _q087glyw _gkx1agmp _1d8vagmp _1wwi1h90 _1ekzagmp _lf671h6o _11e9xy5q _csjz1h6o _1322glyw",
            __cmplp.isCustomCursorActive ? "_80om1jqn" : "_80om1wug",
            __cmplp.isCustomCursorActive ? "_2ht7l61x" : "_2ht71h90",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$4b720caa3a1b5952 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7i8nm _4t3i1s3y _1bsbauwl _otyr1epz _w8m8ze3t _dju1n7od _114rn7od _1b191gwv _1vu6p3fh _uncbp3fh _1iws1osq _16451osq _ajuzn7od _y2u91osq _bs5dze3t _nqf71gwv _1firp3fh _1lntp3fh _11u1p3fh _18le1gwv _1iawp3fh",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$141080fc4b582742 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyrxy5q _4t3i1w81",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$422f3370501bb5d5 = (scale, isFirefox)=>{
    return isFirefox ? `transform: scale(${scale})` : `zoom: ${scale};`;
};
const $72178c9eda154f79$export$354b8b07cc867365 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirefox: isFirefox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _8hrzjp4b _199qukw8 _xrxq95ii _1yyl11bw _1ooqt82k",
            __cmplp.isFirefox ? "_gx1i18ws" : undefined,
            __cmplp.isFirefox ? undefined : "_1s5ecs5v",
            __cmplp.isFirefox ? "_jjcp113p" : undefined,
            __cmplp.isFirefox ? undefined : "_aengbs82",
            __cmplp.isFirefox ? "_a4xx19xa" : undefined,
            __cmplp.isFirefox ? undefined : "_1tkynqt0",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$5e3f251c730829 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _4t3i1kxc",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81npk _1e0c1txw _vchhusvi _1tketudo _1bsb1osq _p12fukw8 _1nmz1hna _slp31hna",
            __cmplp.isTitleCenterAligned ? "_1bah1h6o" : "_1bah4jg8",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isTitleCenterAligned ? "_4cvr1h6o" : "_4cvr1q9y",
            __cmplp.hasCoverPicture || __cmplp.isTitleCenterAligned && __cmplp.hasEmoji ? "_zulppxbi" : "_zulp18uv",
            __cmplp.hasCoverPicture && __cmplp.hasEmoji ? "_19pk1f1f" : "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$f99233281efd08a0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8ze3t _k48p1wq8 _syazi7uo _1nmz1hna _slp31hna _1tke1jfw _ca0q12x7 _1e0c1txw _1wybkogo _1wnx12ln _15cm1wq8 _8lw0ze3t _181zckbl _1ni8or1b",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$f39f7ca4ec945bd5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldAddLeftPadding: shouldAddLeftPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.shouldAddLeftPadding ? "_19bvutpp" : "_19bvn7od",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$var$emojiCoverPictureMaxWidth = (hasCoverPicture)=>hasCoverPicture ? `${0, $Qlykt.EMOJI_SIZE_LARGE}px` : `${0, $Qlykt.EMOJI_SIZE_MEDIUM}px`;
const $72178c9eda154f79$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_mn762q": (0, $7sObp.default)($72178c9eda154f79$var$emojiCoverPictureMaxWidth(__cmplp.hasCoverPicture))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _p12fwy2t _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$1b225d69cabf8532 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1vfx15iw _1ltv1mxl _1ucm1ogm",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0u2gc _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$a87575d1597be323 = (width)=>{
    if (!width || width < $72178c9eda154f79$var$screenSizeXS) return $72178c9eda154f79$export$5aeddb36a71179f1;
    else if (width < $72178c9eda154f79$var$screenSizeM) return $72178c9eda154f79$export$18d6dec26df5efab;
    else if (width < $72178c9eda154f79$var$screenSizeL) return $72178c9eda154f79$export$5cbab9ac5bb5eb6;
    else return $72178c9eda154f79$export$9efff5a152b2c8b9;
};
module.exports["mToLScreenZoomLevel"] = $72178c9eda154f79$export$ec38912285043019;
module.exports["PresenterModePortalContainer"] = $72178c9eda154f79$export$21d0e1ba36d5f647;
module.exports["HeaderImageContainer"] = $72178c9eda154f79$export$4b720caa3a1b5952;
module.exports["NoHeaderImageSpacer"] = $72178c9eda154f79$export$141080fc4b582742;
module.exports["PresenterModeZoomContainer"] = $72178c9eda154f79$export$354b8b07cc867365;
module.exports["LoadingContainer"] = $72178c9eda154f79$export$5e3f251c730829;
module.exports["SpinnerContainer"] = $72178c9eda154f79$export$a5e06607a5ac6158;
module.exports["TitleContainer"] = $72178c9eda154f79$export$35e09ba17cc51c69;
module.exports["Title"] = $72178c9eda154f79$export$f99233281efd08a0;
module.exports["TitleTextWrapper"] = $72178c9eda154f79$export$f39f7ca4ec945bd5;
module.exports["EmojiWrapper"] = $72178c9eda154f79$export$e31a6cc0a4c97f0e;
module.exports["FlagsContainer"] = $72178c9eda154f79$export$1b225d69cabf8532;
module.exports["ButtonContainer"] = $72178c9eda154f79$export$eddf54ea3db8d0f0;

});

parcelRegister("4yA8P", function(module, exports) {
module.exports = new URL("customCursor.8a87402c.svg", import.meta.url).toString();

});

parcelRegister("9BWGi", function(module, exports) {
/* LazyButtons.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");

const $cb3e4c1f9ef026ad$var$spinnerContainerStyles = null;
const $cb3e4c1f9ef026ad$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _1bsbzwfg _2hwxutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: "presentation-mode-lazy-buttons"
    }));

const $cb3e4c1f9ef026ad$export$490f62136438ac6e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9F1oH",
    name: "LazyNavigation",
    loader: async ()=>(await (parcelRequire("eMy3p"))).NavigationPresenterMode,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb3e4c1f9ef026ad$var$LoadingSpinner, null)
});

const $cb3e4c1f9ef026ad$export$37c96b963636f7cc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "60c-p",
    name: "LazySettingsMenu",
    loader: async ()=>(await (parcelRequire("dajss"))).SettingsMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb3e4c1f9ef026ad$var$LoadingSpinner, null)
});
module.exports["LazyNavigation"] = $cb3e4c1f9ef026ad$export$490f62136438ac6e;
module.exports["LazySettingsMenu"] = $cb3e4c1f9ef026ad$export$37c96b963636f7cc;

});

parcelRegister("eMy3p", function(module, exports) {

let $ac2ff6d1c847dcbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ac2ff6d1c847dcbf$var$load("9AXkC"),
    $ac2ff6d1c847dcbf$var$load("6wr18"),
    $ac2ff6d1c847dcbf$var$load("ffEVr"),
    $ac2ff6d1c847dcbf$var$load("7EorR"),
    $ac2ff6d1c847dcbf$var$load("fZt2F"),
    $ac2ff6d1c847dcbf$var$load("hhss7"),
    $ac2ff6d1c847dcbf$var$load("9IaUU")
]).then(()=>parcelRequire('lQ3Oi'));

});

parcelRegister("dajss", function(module, exports) {

let $995b4d8063a7e02e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $995b4d8063a7e02e$var$load("6wr18"),
    $995b4d8063a7e02e$var$load("Wowvf"),
    $995b4d8063a7e02e$var$load("ffEVr"),
    $995b4d8063a7e02e$var$load("62AD8")
]).then(()=>parcelRequire('2JGhm'));

});

parcelRegister("ibtF1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3oWMY = parcelRequire("3oWMY");


var $3WPGR = parcelRequire("3WPGR");


var $1d2ww = parcelRequire("1d2ww");


var $gnyTR = parcelRequire("gnyTR");


var $fDEVM = parcelRequire("fDEVM");

const $647837bde418af85$export$82c94077b89191c5 = 'presenter-mode-header-image-container';
const $647837bde418af85$export$7b5e76b410389064 = ({ contentId: contentId, coverPictureQueryData: coverPictureQueryData })=>{
    const [coverPictureData, setCoverPictureData] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        const publishedCoverPictureProperty = coverPictureQueryData?.content?.nodes?.[0]?.properties?.nodes?.[0] ?? undefined;
        if (!publishedCoverPictureProperty) return;
        const publishedId = (0, $3WPGR.propertyToId)(publishedCoverPictureProperty);
        if (!publishedId) return;
        const coverPic = {
            draft: null,
            published: {
                value: {
                    id: (0, $fDEVM.createHigherResImgSrc)(publishedId?.value?.id),
                    position: publishedId?.value?.position || 0
                },
                version: publishedId?.version
            }
        };
        setCoverPictureData(coverPic);
    }, [
        coverPictureQueryData
    ]);
    if (!coverPictureData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.NoHeaderImageSpacer), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gnyTR.HeaderImageContainer), {
        id: $647837bde418af85$export$82c94077b89191c5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3oWMY.RendererPageCoverPicture), {
        contentId: contentId,
        isPagePreview: false,
        coverPicture: coverPictureData,
        contentAppearance: {
            draft: '',
            published: (0, $1d2ww.ContentAppearanceType).FULL_WIDTH
        },
        isSpaceOverview: false,
        isPresenterMode: true
    }));
};
module.exports["HeaderImageContainerId"] = $647837bde418af85$export$82c94077b89191c5;
module.exports["HeaderImage"] = $647837bde418af85$export$7b5e76b410389064;

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("diAGF"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $jVylI = parcelRequire("jVylI");


var $9wGTI = parcelRequire("9wGTI");


var $75Ax4 = parcelRequire("75Ax4");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, smartSpaceOverviewHeight: smartSpaceOverviewHeight, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_bfhki8nm",
                __cmplp.isFixedWidthImageOption ? "_19pkidpf _2hwx1wug _otyridpf _18u01wug _19pk14id _1bsb1c3h" : "_19pk14id _1bsb14oa _18u09b24",
                __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : "_otyrxy5q",
                __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $be005db184746995$export$e9417b149b0db09d = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride, isSmartSpaceOverview: isSmartSpaceOverview } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview || $[6] !== smartSpaceOverviewHeight) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = smartSpaceOverviewHeight;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("diAGF", function(module, exports) {

let $9ae96a1f4b827730$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9ae96a1f4b827730$var$load("5qNrc"),
    $9ae96a1f4b827730$var$load("4pqtR"),
    $9ae96a1f4b827730$var$load("5XqRg"),
    $9ae96a1f4b827730$var$load("f35QR"),
    $9ae96a1f4b827730$var$load("eVYW1"),
    $9ae96a1f4b827730$var$load("ls0Um"),
    $9ae96a1f4b827730$var$load("020xd"),
    $9ae96a1f4b827730$var$load("eTBsW"),
    $9ae96a1f4b827730$var$load("bYxCZ"),
    $9ae96a1f4b827730$var$load("6HBYC"),
    $9ae96a1f4b827730$var$load("eDqo1"),
    $9ae96a1f4b827730$var$load("lxiFd"),
    $9ae96a1f4b827730$var$load("1oiJ6"),
    $9ae96a1f4b827730$var$load("huUvS"),
    $9ae96a1f4b827730$var$load("8j9XC"),
    $9ae96a1f4b827730$var$load("6vhrJ"),
    $9ae96a1f4b827730$var$load("fxC6e"),
    $9ae96a1f4b827730$var$load("jXx9i"),
    $9ae96a1f4b827730$var$load("l1BQC"),
    $9ae96a1f4b827730$var$load("jlSF3"),
    $9ae96a1f4b827730$var$load("fGkaB"),
    $9ae96a1f4b827730$var$load("h3ABO"),
    $9ae96a1f4b827730$var$load("kC80R"),
    $9ae96a1f4b827730$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});

parcelRegister("fDEVM", function(module, exports) {

var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $hMdkB = parcelRequire("hMdkB");

var $9b92440f7f429369$export$1ef9fc5d7a7ef8e2 = /*#__PURE__*/ function(TYPE_OF_NODE) {
    TYPE_OF_NODE["LAYOUT"] = "layout";
    TYPE_OF_NODE["HR"] = "hr";
    TYPE_OF_NODE["EXPAND"] = "expand";
    TYPE_OF_NODE["HEADING"] = "header";
    TYPE_OF_NODE["EMPTY"] = "empty";
    TYPE_OF_NODE["OTHER"] = "other";
    TYPE_OF_NODE["STICKY_HEADER"] = "stickyHeader";
    TYPE_OF_NODE["TABLE"] = "table";
    TYPE_OF_NODE["MACRO"] = "macro";
    TYPE_OF_NODE["IMAGE"] = "image";
    return TYPE_OF_NODE;
}({});
const $9b92440f7f429369$export$be27aa1bed7edb58 = (scrollUp)=>{
    const scrollContainer = document.getElementById(`${(0, $hMdkB.PresenterModePortalContainerId)}`);
    // Scroll by half the viewport height
    const scrollAmount = window.innerHeight * 0.5 * (scrollUp ? -1 : 1);
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(()=>{
        scrollContainer?.scrollBy({
            top: scrollContainer.getBoundingClientRect().top + scrollAmount,
            behavior: 'smooth'
        });
    });
};
const $9b92440f7f429369$export$8286ea4d39e1c85c = (originalSrc)=>{
    if (!originalSrc.includes('images.unsplash.com')) return originalSrc;
    const baseAndParams = originalSrc.split('?');
    const queryParams = new URLSearchParams(baseAndParams[1]);
    const width = Math.min(document?.documentElement?.clientWidth, 3000);
    queryParams.set('w', width.toString());
    queryParams.delete('q');
    return `${baseAndParams[0]}?${queryParams.toString()}`;
};
const $9b92440f7f429369$export$87b554716dce1db0 = (refNode)=>{
    const getFirstTextNodeIterative = (refNode)=>{
        const stack = [
            refNode
        ];
        while(stack.length > 0){
            const node = stack.pop();
            if (node.nodeType == 3 && node.nodeValue?.trim().length !== 0) return node;
            for(let i = node.childNodes.length - 1; i >= 0; i--)stack.push(node.childNodes[i]);
        }
    };
    return getFirstTextNodeIterative(refNode);
};
const $9b92440f7f429369$export$91dc29669e88d0db = (node)=>{
    return /^([Hh])[0-6].*/.test(node?.tagName);
};
const $9b92440f7f429369$export$dd1bc94b04021eeb = (node)=>{
    const firstTextNode = $9b92440f7f429369$export$87b554716dce1db0(node);
    if ($9b92440f7f429369$export$91dc29669e88d0db(node) && !firstTextNode) return true;
    if ($9b92440f7f429369$export$ed5642f3e4fb7c54(node)) return true;
    const isImage = node.classList.contains('rich-media-item') || !!node.querySelector('img') || !!node.querySelector('svg');
    const isEmptyTextElement = !firstTextNode;
    return !isImage && isEmptyTextElement;
};
const $9b92440f7f429369$export$fb85bc5d6d9ef19b = (node)=>{
    return node.classList.contains('rich-media-item') || !!node.querySelector('img') || !!node.querySelector('svg');
};
const $9b92440f7f429369$export$bf32d97724374086 = (node)=>{
    return !!node.querySelector('.pm-table-sticky-wrapper');
};
const $9b92440f7f429369$export$567a2801b8f40ab5 = (node)=>{
    return node.classList.contains('pm-table-container') || !!node.querySelector('.pm-table-container') && !$9b92440f7f429369$export$bf32d97724374086(node);
};
const $9b92440f7f429369$export$1980ca1f3eaf85fb = (node)=>{
    return node.getAttribute('data-layout-section') === 'true';
};
const $9b92440f7f429369$export$d8bf6fedd3b53772 = (node)=>{
    return node.tagName === 'HR';
};
const $9b92440f7f429369$export$35e907bd866058b8 = (node)=>{
    return node.classList.contains('ak-renderer-extension') || !!node.querySelector('.ak-renderer-extension');
};
const $9b92440f7f429369$export$1d7f19df4bf635f6 = (node)=>{
    return node.classList.contains('code-block') || !!node.querySelector('.code-block');
};
const $9b92440f7f429369$export$ed5642f3e4fb7c54 = (node)=>{
    return node.tagName === 'BR';
};
const $9b92440f7f429369$export$822db98f95375647 = (contentId)=>{
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)({
        contentId: contentId
    });
    return !!(titleContentProperties?.titleLayoutAlignment === (0, $jVylI.TitleAlignmentType).CENTER);
};
module.exports["TYPE_OF_NODE"] = $9b92440f7f429369$export$1ef9fc5d7a7ef8e2;
module.exports["scrollFixedAmount"] = $9b92440f7f429369$export$be27aa1bed7edb58;
module.exports["createHigherResImgSrc"] = $9b92440f7f429369$export$8286ea4d39e1c85c;
module.exports["getFirstTextNode"] = $9b92440f7f429369$export$87b554716dce1db0;
module.exports["isHeading"] = $9b92440f7f429369$export$91dc29669e88d0db;
module.exports["isEmpty"] = $9b92440f7f429369$export$dd1bc94b04021eeb;
module.exports["isImage"] = $9b92440f7f429369$export$fb85bc5d6d9ef19b;
module.exports["isStickyHeaderOfTable"] = $9b92440f7f429369$export$bf32d97724374086;
module.exports["isTable"] = $9b92440f7f429369$export$567a2801b8f40ab5;
module.exports["isLayout"] = $9b92440f7f429369$export$1980ca1f3eaf85fb;
module.exports["isHorizontalRule"] = $9b92440f7f429369$export$d8bf6fedd3b53772;
module.exports["isMacro"] = $9b92440f7f429369$export$35e907bd866058b8;
module.exports["isCodeBlock"] = $9b92440f7f429369$export$1d7f19df4bf635f6;
module.exports["useIsTitleCenterAligned"] = $9b92440f7f429369$export$822db98f95375647;

});

parcelRegister("7mDnI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eCEXz = parcelRequire("eCEXz");


var $a3fRD = parcelRequire("a3fRD");

const $dfd48e08cc962979$export$518ba8e0e60f145f = ({ title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCEXz.default), {
        appearance: "error",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            spacing: "spacious",
            label: "Error"
        }),
        id: "error",
        key: "error",
        title: title
    });
};
module.exports["ErrorFlag"] = $dfd48e08cc962979$export$518ba8e0e60f145f;

});

parcelRegister("jcM8h", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $kN9tW = parcelRequire("kN9tW");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6R5uz = parcelRequire("6R5uz");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $dAYOx = parcelRequire("dAYOx");


var $lGgRw = parcelRequire("lGgRw");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $a6t12 = parcelRequire("a6t12");


var $68BwE = parcelRequire("68BwE");


var $jFm04 = parcelRequire("jFm04");


var $3SLf9 = parcelRequire("3SLf9");


var $jMyy4 = parcelRequire("jMyy4");

const $a26c936fb563039b$var$i18n = (0, $aXWIB.defineMessages)({
    creator: {
        id: "content-ownership.content-owner-popup.creator",
        defaultMessage: "<b>Creator</b>"
    },
    owner: {
        id: "content-ownership.content-owner-popup.owner",
        defaultMessage: "<b>Owner</b>"
    },
    changeOwner: {
        id: "content-ownership.content-owner-popup.change-owner",
        defaultMessage: "Change owner"
    },
    ariaLabel: {
        id: "content-ownership.content-owner-popup.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
// fixed dimensions
const $a26c936fb563039b$var$contentOwnerContainerStyles = (0, $ecnYn.xcss)({
    width: '232px',
    height: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerViewerContainerStyles = (0, $ecnYn.xcss)({
    width: '232px',
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentCreatorItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerChangeItemStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerNameItemStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.025',
    textDecoration: 'underline',
    color: 'color.text',
    ':hover': {
        color: 'color.link',
        cursor: 'pointer'
    }
});
const $a26c936fb563039b$var$ContentOwnerDetailsPanelName = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { userId: userId, fullName: fullName, ariaLabel: ariaLabel } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            0,
            28
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== fullName || $[2] !== userId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            position: "left-start",
            offset: t1,
            fullName: fullName
        }, fullName);
        $[1] = fullName;
        $[2] = userId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== ariaLabel || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
            role: "tooltip",
            "aria-label": ariaLabel
        }, t2);
        $[4] = ariaLabel;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ userId: userId, fullName: fullName, ariaLabel: ariaLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
        role: "tooltip",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        position: "left-start",
        offset: [
            0,
            28
        ],
        fullName: fullName
    }, fullName));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanel = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(32);
    const { ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    let t1;
    if ($[0] !== closePopup || $[1] !== experienceTracker || $[2] !== openModal) {
        t1 = ()=>{
            openModal();
            closePopup();
            experienceTracker.start({
                name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
            });
        };
        $[0] = closePopup;
        $[1] = experienceTracker;
        $[2] = openModal;
        $[3] = t1;
    } else t1 = $[3];
    const onClickChangeOwner = t1;
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    const t2 = isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles;
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$a26c936fb563039b$var$i18n.creator,
            values: {
                b: $a26c936fb563039b$var$_temp
            }
        });
        $[6] = t4;
    } else t4 = $[6];
    const t5 = createdBy.userId;
    const t6 = createdBy.fullName;
    let t7;
    if ($[7] !== createdBy.fullName || $[8] !== intl) {
        t7 = intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        });
        $[7] = createdBy.fullName;
        $[8] = intl;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== createdBy.fullName || $[11] !== createdBy.userId || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $a26c936fb563039b$var$contentCreatorItemStyles
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
            userId: t5,
            fullName: t6,
            ariaLabel: t7
        }));
        $[10] = createdBy.fullName;
        $[11] = createdBy.userId;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$a26c936fb563039b$var$i18n.owner,
            values: {
                b: $a26c936fb563039b$var$_temp2
            }
        });
        $[14] = t9;
    } else t9 = $[14];
    const t10 = ownedBy.userId;
    const t11 = ownedBy.fullName;
    let t12;
    if ($[15] !== intl || $[16] !== ownedBy.fullName) {
        t12 = intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        });
        $[15] = intl;
        $[16] = ownedBy.fullName;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== ownedBy.fullName || $[19] !== ownedBy.userId || $[20] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $a26c936fb563039b$var$contentOwnerItemStyles
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
            userId: t10,
            fullName: t11,
            ariaLabel: t12
        }));
        $[18] = ownedBy.fullName;
        $[19] = ownedBy.userId;
        $[20] = t12;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== intl || $[23] !== isAllowedToChange || $[24] !== onClickChangeOwner || $[25] !== setInitialFocusRef) {
        t14 = isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: onClickChangeOwner,
            appearance: "link",
            spacing: "none",
            ref: setInitialFocusRef
        }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner)));
        $[22] = intl;
        $[23] = isAllowedToChange;
        $[24] = onClickChangeOwner;
        $[25] = setInitialFocusRef;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t13 || $[28] !== t14 || $[29] !== t3 || $[30] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t3
        }, t8, t13, t14);
        $[27] = t13;
        $[28] = t14;
        $[29] = t3;
        $[30] = t8;
        $[31] = t15;
    } else t15 = $[31];
    return t15;
} : ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef })=>{
    const intl = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const onClickChangeOwner = (0, $42omo.useCallback)(()=>{
        openModal();
        closePopup();
        experienceTracker.start({
            name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
        });
    }, [
        closePopup,
        openModal,
        experienceTracker
    ]);
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentCreatorItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$a26c936fb563039b$var$i18n.creator,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: createdBy.userId,
        fullName: createdBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$a26c936fb563039b$var$i18n.owner,
        values: {
            b: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_0)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: ownedBy.userId,
        fullName: ownedBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        })
    })), isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: onClickChangeOwner,
        appearance: "link",
        spacing: "none",
        ref: setInitialFocusRef
    }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner))));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef } = t0;
    if (!ownedBy || !createdBy) return null;
    let t1;
    if ($[0] !== closePopup || $[1] !== createdBy || $[2] !== ownedBy || $[3] !== setInitialFocusRef) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, (t2)=>{
            const { openModal: openModal } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closePopup,
                openModal: openModal,
                setInitialFocusRef: setInitialFocusRef
            });
        });
        $[0] = closePopup;
        $[1] = createdBy;
        $[2] = ownedBy;
        $[3] = setInitialFocusRef;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef })=>{
    if (!ownedBy || !createdBy) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
            ownedBy: ownedBy,
            createdBy: createdBy,
            closePopup: closePopup,
            openModal: openModal,
            setInitialFocusRef: setInitialFocusRef
        }));
};
const $a26c936fb563039b$export$62380b37452323f8 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore } = t0;
    let t1;
    if ($[0] !== onCloseParent || $[1] !== onClosePopup) {
        t1 = ()=>{
            onClosePopup();
            onCloseParent?.();
        };
        $[0] = onCloseParent;
        $[1] = onClosePopup;
        $[2] = t1;
    } else t1 = $[2];
    const closeOwnerDialog = t1;
    let t2;
    if ($[3] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = !contentId;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const { data: ownerHistoryData } = (0, $jMyy4.useQueryInterop)((0, $kN9tW.default), t4);
    const toUserData = $a26c936fb563039b$var$_temp3;
    const t5 = ownerHistoryData?.singleContent?.history?.ownedBy;
    let t6;
    if ($[8] !== t5) {
        t6 = toUserData(t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const ownedBy = t6;
    const t7 = ownerHistoryData?.singleContent?.history?.createdBy;
    let t8;
    if ($[10] !== t7) {
        t8 = toUserData(t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    const createdBy = t8;
    const t9 = `container-${itemId}`;
    let t10;
    if ($[12] !== closeOwnerDialog || $[13] !== createdBy || $[14] !== ownedBy) {
        t10 = (t11)=>{
            const { setInitialFocusRef: setInitialFocusRef } = t11;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            });
        };
        $[12] = closeOwnerDialog;
        $[13] = createdBy;
        $[14] = ownedBy;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== elemBefore || $[17] !== isOpen || $[18] !== itemLabel || $[19] !== onClick || $[20] !== onMouseEnter) {
        t11 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, itemLabel));
        $[16] = elemBefore;
        $[17] = isOpen;
        $[18] = itemLabel;
        $[19] = onClick;
        $[20] = onMouseEnter;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $9wGTI.fg)("should-render-to-parent-should-be-truepage-experie");
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== isOpen || $[24] !== onClosePopup || $[25] !== t10 || $[26] !== t11 || $[27] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            key: t9,
            isOpen: isOpen,
            onClose: onClosePopup,
            onBlur: onClosePopup,
            placement: "left-start",
            content: t10,
            trigger: t11,
            shouldRenderToParent: t12
        });
        $[23] = isOpen;
        $[24] = onClosePopup;
        $[25] = t10;
        $[26] = t11;
        $[27] = t9;
        $[28] = t13;
    } else t13 = $[28];
    return t13;
} : ({ contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore })=>{
    const closeOwnerDialog = ()=>{
        onClosePopup();
        onCloseParent?.();
    };
    const { data: ownerHistoryData } = (0, $jMyy4.useQueryInterop)((0, $kN9tW.default), {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    const toUserData = (user)=>({
            userId: user?.accountId ?? undefined,
            fullName: user?.displayName,
            isAnonymous: !user?.accountId
        });
    const ownedBy = toUserData(ownerHistoryData?.singleContent?.history?.ownedBy);
    const createdBy = toUserData(ownerHistoryData?.singleContent?.history?.createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        key: `container-${itemId}`,
        isOpen: isOpen,
        onClose: onClosePopup,
        // @ts-ignore onBlur not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
        onBlur: onClosePopup,
        placement: "left-start",
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                // @ts-ignore onMouseEnter not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, itemLabel)),
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truepage-experie')
    });
};
function $a26c936fb563039b$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks);
}
function $a26c936fb563039b$var$_temp2(chunks_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_0);
}
function $a26c936fb563039b$var$_temp3(user) {
    return {
        userId: user?.accountId ?? undefined,
        fullName: user?.displayName,
        isAnonymous: !user?.accountId
    };
}
module.exports["ContentOwnerPopupComponent"] = $a26c936fb563039b$export$62380b37452323f8;

});

parcelRegister("kN9tW", function(module, exports) {
/**
 * @generated SignedSource<<524e8f5d7b37a43fd1ca8f5ee906c7ef>>
 * @relayHash 7fe01343636a1cc8e3587d1c0025997f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105
const $cbf179a03b0882d6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7fe01343636a1cc8e3587d1c0025997f",
            "id": "70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105",
            "metadata": {},
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "operationKind": "query",
            "text": "query ContentOwnerPopupComponentContentOwnerQuery($contentId:ID!){singleContent(id:$contentId){id,history{createdBy{__typename,displayName,...on KnownUser{accountId}},ownedBy{__typename,displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$cbf179a03b0882d6$var$node.hash = "ab500ff679b71481a192bc88337cadcd";
var $cbf179a03b0882d6$export$2e2bcd8739ae039 = $cbf179a03b0882d6$var$node;
module.exports["default"] = $cbf179a03b0882d6$export$2e2bcd8739ae039;

});

parcelRegister("3SLf9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5k5SG = parcelRequire("5k5SG");

const $93ff62a422a2769d$export$fe5ee8722fdedf98 = (0, $3u0dr.isReactCompilerActiveV2)() ? (ownedByAccountId)=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    let t0;
    bb0: {
        if (!userId) {
            t0 = false;
            break bb0;
        }
        const isCurrentUserOwner = ownedByAccountId === userId;
        t0 = isSpaceOrSiteAdmin || isCurrentUserOwner;
    }
    return t0;
} : (ownedByAccountId)=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    return (0, $42omo.useMemo)(()=>{
        if (!userId) return false;
        const isCurrentUserOwner = ownedByAccountId === userId;
        return isSpaceOrSiteAdmin || isCurrentUserOwner;
    }, [
        isSpaceOrSiteAdmin,
        ownedByAccountId,
        userId
    ]);
};
module.exports["useIsAllowedToChangeOwner"] = $93ff62a422a2769d$export$fe5ee8722fdedf98;

});

parcelRegister("5nr5P", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");

class $22dbf97de39b4a94$export$8428b29fbe35d5c extends (0, $T1bCI.Container) {
    constructor({ loadUuid: loadUuid = '', contentId: contentId = null, userCanEditRestrictions: userCanEditRestrictions = false, currentUserInfo: currentUserInfo = null, hasInheritedRestrictions: hasInheritedRestrictions = false, hasRestrictions: hasRestrictions = false, isLoaded: isLoaded = false, restrictionsDetails: restrictionsDetails = null, spaceKey: spaceKey = null, spaceContainsExternalCollaborators: spaceContainsExternalCollaborators = false, externalCollaboratorCount: externalCollaboratorCount = 0, operations: operations = null, contentTitle: contentTitle = null, edition: edition = null, isSiteAdmin: isSiteAdmin = false, contentType: contentType = null, contentSubType: contentSubType = null, isExternalShareEnabledForSite: isExternalShareEnabledForSite = false, isPageExternallyShared: isPageExternallyShared = false, isExternalShareVariation: isExternalShareVariation = false, isContentExternallySharable: isContentExternallySharable = false, canEditPublicLink: canEditPublicLink = false, ancestors: ancestors = [] } = {}){
        super();
        this.getData = ()=>{
            return this.state;
        };
        this.resetData = ()=>{
            this.setState({
                loadUuid: '',
                contentId: null,
                contentPermissions: null,
                currentUserInfo: null,
                hasInheritedRestrictions: false,
                hasRestrictions: false,
                isLoaded: false,
                restrictionsDetails: null,
                spaceKey: null,
                spaceContainsExternalCollaborators: false,
                externalCollaboratorCount: 0,
                operations: null,
                contentTitle: null,
                edition: null,
                isSiteAdmin: false,
                contentType: null,
                contentSubType: null,
                contentStatus: undefined,
                isExternalShareEnabledForSite: false,
                isPageExternallyShared: false,
                isExternalShareVariation: false,
                isContentExternallySharable: false,
                canEditPublicLink: false,
                ancestors: []
            });
        };
        this.setData = (data)=>{
            if (Object.keys(data).some((k)=>data[k] !== this.state[k])) this.setState(data);
        };
        this.getIsLoaded = ()=>{
            return this.state.isLoaded;
        };
        this.getContentId = ()=>{
            return this.state.contentId;
        };
        this.getLoadUuid = ()=>{
            return this.state.loadUuid;
        };
        this.state = {
            loadUuid: loadUuid,
            contentId: contentId,
            userCanEditRestrictions: userCanEditRestrictions,
            currentUserInfo: //   currentUserInfo: PropTypes.shape({
            //     id: PropTypes.string.isRequired,
            //     displayName: PropTypes.string.isRequired,
            //     isSuperAdmin: PropTypes.bool,
            //     profilePicture: PropTypes.shape({
            //       path: PropTypes.string
            //     })
            //   }).isRequired,
            currentUserInfo,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasRestrictions: hasRestrictions,
            isLoaded: isLoaded,
            restrictionsDetails: // const restrictionsShape = {
            //   restrictions: PropTypes.shape({
            //     user: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           accountId: PropTypes.string,
            //           displayName: PropTypes.string,
            //           type: PropTypes.string
            //         })
            //       )
            //     }),
            //     group: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           name: PropTypes.string
            //         })
            //       )
            //     })
            //   })
            // };
            restrictionsDetails,
            spaceKey: spaceKey,
            spaceContainsExternalCollaborators: spaceContainsExternalCollaborators,
            externalCollaboratorCount: externalCollaboratorCount,
            operations: operations,
            contentTitle: contentTitle,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            contentType: contentType,
            contentSubType: contentSubType,
            isExternalShareEnabledForSite: isExternalShareEnabledForSite,
            isPageExternallyShared: isPageExternallyShared,
            isExternalShareVariation: isExternalShareVariation,
            isContentExternallySharable: isContentExternallySharable,
            canEditPublicLink: canEditPublicLink,
            ancestors: ancestors
        };
    }
}
module.exports["RestrictionsDataContainer"] = $22dbf97de39b4a94$export$8428b29fbe35d5c;

});

parcelRegister("cuWTe", function(module, exports) {
const $52d439f2e3e46670$export$5d6b4e71896e8f23 = (contentType, isArchived, isDraft, isViewEditOrLive)=>{
    // archived takes priority, since other modes like 'view' can be in this state
    if (isArchived) return 'archived';
    // useGetPageMode *always* returns one of 'live', 'view', or 'edit', but these modes don't apply across all
    // content types - so the content type doesn't have a 'mode' and we should return undefined
    if (contentType === 'page' || contentType === 'blogpost') {
        // then draft takes next priority, since other modes like 'edit' can be in this state
        if (isDraft) return 'draft';
        // technically only pages can be live at the moment, and blogposts wouldn't ever return live, but they *could*
        return isViewEditOrLive;
    } else return undefined;
};
module.exports["getContentMode"] = $52d439f2e3e46670$export$5d6b4e71896e8f23;

});

parcelRegister("lyx2E", function(module, exports) {
/* contentTypesHeaderStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $3d1681a377877e6e$export$e139d3b51c488e9b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFloating: isFloating, hasPointerEvents: hasPointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fwhixl": (0, $7sObp.default)((()=>{
                return __cmplp.isFloating ? 'absolute' : 'relative';
            })()),
            "--_17xabpo": (0, $7sObp.default)((()=>{
                return __cmplp.hasPointerEvents ? 'auto' : 'none';
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bfhk1j28 _kqswlr7h _lcxv12je _1bsb1osq _1e0c11p5",
            __cmplp.className
        ])
    });
});
const $3d1681a377877e6e$var$titleAndBreadcrumbsBaseStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'auto',
    backgroundColor: 'elevation.surface',
    borderRadius: 'radius.small',
    paddingInline: 'space.100',
    paddingBlockEnd: 'space.050',
    display: 'flex',
    flexWrap: 'nowrap',
    paddingBlockStart: 'space.050',
    height: '100%'
});
// Utilized only when the content header is pinned and during the viewing of public whiteboards
const $3d1681a377877e6e$var$alignCenterStyle = (0, $ecnYn.xcss)({
    alignSelf: 'center'
});
const $3d1681a377877e6e$export$b1249ef660098484 = ({ isContentHeaderPinned: isContentHeaderPinned = false, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $3d1681a377877e6e$var$titleAndBreadcrumbsBaseStyles,
            isContentHeaderPinned && $3d1681a377877e6e$var$alignCenterStyle
        ]
    }, children);
};
module.exports["ContentTypesHeaderContainer"] = $3d1681a377877e6e$export$e139d3b51c488e9b;
module.exports["TitleAndBreadcrumbsWrapper"] = $3d1681a377877e6e$export$b1249ef660098484;

});

parcelRegister("deZfn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3af5d746447ab7ac$export$a32ab742d345a2c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "u0VI7",
    name: "ArchivedPageBanner",
    loader: async ()=>(await (parcelRequire("6yFxF"))).ArchivedPageBanner
});
module.exports["ArchivedPageBanner"] = $3af5d746447ab7ac$export$a32ab742d345a2c9;

});

parcelRegister("6yFxF", function(module, exports) {

let $4c66246af05332e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c66246af05332e4$var$load("6rpul").then(()=>parcelRequire('2ZkUh'));

});

parcelRegister("8z0fF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $kC9tB = parcelRequire("kC9tB");


const $fcf77a474368dc3c$export$2626335f65c6c2ab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GPirm",
    name: "EmojiTitleSelection",
    loader: async ()=>(await (parcelRequire("4WU9h"))).EmojiTitleSelection,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kC9tB.EmojiTitleSelectionPlaceholder), props)
});
module.exports["EmojiTitleSelection"] = $fcf77a474368dc3c$export$2626335f65c6c2ab;

});

parcelRegister("kC9tB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $crLHf = parcelRequire("crLHf");

// Altogether, the container width should be equivalent to the width of EmojiTitleSelection once loaded
const $12207dce16c7aead$var$paddingStyle = (0, $ecnYn.xcss)({
    paddingRight: 'space.150',
    // this is the spacing between the emoji button and the title
    paddingLeft: 'space.050' // necessary for left aligning placeholder with emoji button (value comes from from button base)
});
const $12207dce16c7aead$export$f477b16652398d6f = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { hasInitialEmoji: hasInitialEmoji, hasCoverPicture: hasCoverPicture, isTitleCenterAligned: isTitleCenterAligned } = t0;
    const needsPadding = !hasCoverPicture && !isTitleCenterAligned;
    let t1;
    if ($[0] !== hasCoverPicture || $[1] !== hasInitialEmoji || $[2] !== needsPadding) {
        t1 = hasInitialEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: needsPadding ? $12207dce16c7aead$var$paddingStyle : null,
            testId: "emoji-selection-placeholder-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: hasCoverPicture ? 80 : 40
        })) : null;
        $[0] = hasCoverPicture;
        $[1] = hasInitialEmoji;
        $[2] = needsPadding;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["EmojiTitleSelectionPlaceholder"] = $12207dce16c7aead$export$f477b16652398d6f;

});

parcelRegister("4WU9h", function(module, exports) {

let $39a8222a36699d50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39a8222a36699d50$var$load("dlm6q"),
    $39a8222a36699d50$var$load("4pqtR"),
    $39a8222a36699d50$var$load("5XqRg"),
    $39a8222a36699d50$var$load("ajMch"),
    $39a8222a36699d50$var$load("6wr18"),
    $39a8222a36699d50$var$load("ffEVr"),
    $39a8222a36699d50$var$load("kjZZD"),
    $39a8222a36699d50$var$load("5qNrc"),
    $39a8222a36699d50$var$load("4izLy"),
    $39a8222a36699d50$var$load("6KGrg"),
    $39a8222a36699d50$var$load("4hZJd")
]).then(()=>parcelRequire('leLdu'));

});

parcelRegister("lt6Lx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $aXWIB.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { siteTitle: siteTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && document.title) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence")
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    if (typeof document !== 'undefined' && document.title && !contentTitle) {
        // If contentTitle is empty, we're likely setting a generic title (just siteTitle or siteTitle with space)
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title && !isHomePage) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("iAOfI", function(module, exports) {

var $4YBSq = parcelRequire("4YBSq");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $jMyy4 = parcelRequire("jMyy4");


var $9hlns = parcelRequire("9hlns");


var $1iSzD = parcelRequire("1iSzD");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $gkIgp = parcelRequire("gkIgp");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $7aRa9 = parcelRequire("7aRa9");


var $3u7PM = parcelRequire("3u7PM");


var $c4cfx = parcelRequire("c4cfx");


var $7mHcA = parcelRequire("7mHcA");

const $25b07369982b4436$var$EditContentButtonQuery = (0, $4YBSq.default);
const $25b07369982b4436$var$EditContentButtonInner = (0, $7aRa9.withFlags)(({ flags: flags, contentId: contentId, isCompanyHubButton: isCompanyHubButton, ...passThroughProps })=>{
    const { epMigrationOnLoad: epMigrationOnLoad, epMigrationOnClick: epMigrationOnClick } = (0, $7mHcA.useEmbeddedMigrationQuery)(contentId, true);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($25b07369982b4436$var$EditContentButtonQuery, {
        variables: {
            contentId: contentId
        },
        // cache-and-network is required to ensure that the edit button is rendered immediately after page publish
        fetchPolicy: 'cache-and-network'
    });
    const { data: epMigrationOnLoadData, loading: epMigrationOnLoadLoading, error: epMigrationOnLoadError } = epMigrationOnLoad;
    const { migrateEPData: migrateEPData, data: epMigrationOnClickData, loading: epMigrationOnClickLoading, error: epMigrationOnClickError } = epMigrationOnClick;
    const { showNoEditAccessFlag: showNoEditAccessFlag } = (0, $3u7PM.useNoEditAccessFlag)(flags);
    let renderedEditContentButton;
    if (error) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    else if (!data && loading || !epMigrationOnLoadData && epMigrationOnLoadLoading || !epMigrationOnClickData && epMigrationOnClickLoading) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        interactionName: "edit-content-button",
        size: "small"
    });
    else {
        const contentNode = data?.content?.nodes?.[0];
        const operations = contentNode?.operations ?? [];
        const contentType = contentNode?.type ?? undefined;
        const canEdit = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
        if (!canEdit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.EDIT_SHORTCUT),
            listener: showNoEditAccessFlag
        });
        const spaceKey = data?.content?.nodes?.[0]?.space?.key ?? undefined;
        const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
        const isFabricSupported = metadataFrontend?.fabricEditorSupported ?? false;
        const isNCSContent = metadataFrontend?.collabService === (0, $gkIgp.CollabServiceProperty).NCS;
        // 'edit-embed' route (embedded editor) should only be used inside parent product and when page is ncs
        const isEmbeddedContent = ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && isNCSContent) ?? false;
        const embeddedMigrationError = epMigrationOnLoadError || epMigrationOnClickError;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, embeddedMigrationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: embeddedMigrationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4cfx.EditContentButtonComponent), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            isCompanyHubButton: isCompanyHubButton,
            isFabricSupported: isFabricSupported,
            isEmbeddedContent: isEmbeddedContent,
            migrateEPData: !isNCSContent ? migrateEPData : undefined,
            ...passThroughProps
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
    }), renderedEditContentButton);
});
const $25b07369982b4436$export$3df6d768aebb677f = /*#__PURE__*/ (0, $42omo.memo)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($25b07369982b4436$var$EditContentButtonInner));
$25b07369982b4436$export$3df6d768aebb677f.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onRender: (0, $c4cfx.EditContentButtonComponent).propTypes?.onRender
};
module.exports["EditContentButton"] = $25b07369982b4436$export$3df6d768aebb677f;

});

parcelRegister("3u7PM", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3cfcff3140a018ad$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    noEditAccessFlagTitle: {
        id: "edit-features.no-edit-access-flag.title",
        defaultMessage: "This shortcut requires edit access"
    },
    noEditAccessFlagDescription: {
        id: "edit-features.no-edit-access-flag.description",
        defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content."
    }
});
const $3cfcff3140a018ad$export$175b3f54640daa25 = (flags)=>{
    const intl = (0, $aXWIB.useIntl)();
    const showNoEditAccessFlag = ()=>{
        flags.showFlag({
            id: 'live-pages-mode-flag',
            title: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagTitle),
            description: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagDescription),
            close: 'auto'
        });
    };
    return {
        showNoEditAccessFlag: showNoEditAccessFlag
    };
};
module.exports["useNoEditAccessFlag"] = $3cfcff3140a018ad$export$175b3f54640daa25;

});

parcelRegister("c4cfx", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $jTxSS = parcelRequire("jTxSS");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $1Zr9M = parcelRequire("1Zr9M");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $iFjdQ = parcelRequire("iFjdQ");


var $5q601 = parcelRequire("5q601");


var $74Lca = parcelRequire("74Lca");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $emYzJ = parcelRequire("emYzJ");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $39rFu = parcelRequire("39rFu");


var $7NoF3 = parcelRequire("7NoF3");


var $4ri4I = parcelRequire("4ri4I");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");


var $4o1RV = parcelRequire("4o1RV");


var $de2j9 = parcelRequire("de2j9");


var $hl1Kw = parcelRequire("hl1Kw");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $lqy4C = parcelRequire("lqy4C");


var $sD2Tz = parcelRequire("sD2Tz");


var $ca2z9 = parcelRequire("ca2z9");

const $a4b894acf4b5251f$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $4KS7f.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_701w1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a4b894acf4b5251f$var$i18n = (0, $aXWIB.defineMessages)({
    editLabel: {
        id: "edit-button.edit.label",
        defaultMessage: "Edit this content"
    },
    editEmbedLabel: {
        id: "edit-button.edit.embed.label",
        defaultMessage: "Edit this embed"
    },
    editText: {
        id: "edit-button.edit.text",
        defaultMessage: "Edit"
    }
});
const $a4b894acf4b5251f$var$noop = ()=>null;
const $a4b894acf4b5251f$var$EditContentButtonComponentInner = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(117);
    const { contentId: contentId, contentType: contentType, intl: intl, isEmbeddedContent: t1, isFabricSupported: isFabricSupported, onRender: t2, spaceKey: spaceKey, migrateEPData: migrateEPData, isCompanyHubButton: t3 } = t0;
    const isEmbeddedContent = t1 === undefined ? false : t1;
    const onRender = t2 === undefined ? $a4b894acf4b5251f$var$noop : t2;
    const isCompanyHubButton = t3 === undefined ? false : t3;
    const editButtonRef = (0, $42omo.useRef)(null);
    const [localEditSource, setLocalEditSource] = (0, $42omo.useState)("");
    const [isPopupVisible, setIsPopupVisible] = (0, $42omo.useState)(false);
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t4;
    if ($[0] !== createAnalyticsEvent) {
        t4 = (action, analyticsContentId, attributes)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: action,
                    actionSubject: "editButtonCollabDraftPrefetch",
                    actionSubjectId: analyticsContentId,
                    source: "editButton",
                    attributes: attributes
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t4;
    } else t4 = $[1];
    const sendPrefetchAnalyticsEvent = t4;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [t5] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics } = t5;
    const { match: match } = routesContext;
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            source: "page-tree-quick-action-edit"
        };
        $[2] = t6;
    } else t6 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t6);
    let t7;
    if ($[3] !== contentId || $[4] !== isFabricSupported) {
        t7 = {
            contentId: contentId,
            isFabricSupported: isFabricSupported
        };
        $[3] = contentId;
        $[4] = isFabricSupported;
        $[5] = t7;
    } else t7 = $[5];
    const { fabricEditorEligibility: fabricEditorEligibility, isFabricEligibilityLoading: isFabricEligibilityLoading } = (0, $ca2z9.useFabricEligibilityMigrationQuery)(t7);
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            shortcut: (0, $gnkil.EDIT_SHORTCUT)
        };
        $[6] = t8;
    } else t8 = $[6];
    const editShortcutStrings = (0, $4tOXV.useShortcutStrings)(t8);
    const currentRouteName = match?.name;
    const isBlogpost = contentType === "blogpost";
    const t9 = isBlogpost ? "blog" : "pages";
    let t10;
    if ($[7] !== contentId || $[8] !== spaceKey || $[9] !== t9) {
        t10 = {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: t9
        };
        $[7] = contentId;
        $[8] = spaceKey;
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    const linkParams = t10;
    const dataTestId = isFabricSupported ? "fabric-edit-button" : undefined;
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    let routeType;
    if ($[11] !== isBlogpost || $[12] !== isCompanyHubButton || $[13] !== isEmbeddedContent || $[14] !== isFabricSupported) {
        if (isEmbeddedContent && !isBlogpost) routeType = (0, $1NBp8.EDIT_PAGE_EMBED);
        else {
            if (isCompanyHubButton) routeType = (0, $1NBp8.COMPANY_HUB_EDIT);
            else if (isFabricSupported) routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2);
            else routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
        }
        $[11] = isBlogpost;
        $[12] = isCompanyHubButton;
        $[13] = isEmbeddedContent;
        $[14] = isFabricSupported;
        $[15] = routeType;
    } else routeType = $[15];
    let t11;
    let t12;
    if ($[16] !== currentRouteName || $[17] !== isBlogpost || $[18] !== setEditSource) {
        t11 = ()=>{
            let entryPoint = (0, $7NoF3.PAGE_EDIT_BUTTON_CLICK);
            if (isBlogpost) entryPoint = (0, $7NoF3.BLOG_EDIT_BUTTON_CLICK);
            const isSpaceOverview = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
            if (isSpaceOverview) entryPoint = (0, $7NoF3.SPACE_EDIT_BUTTON_CLICK);
            setEditSource(entryPoint);
            setLocalEditSource(entryPoint);
        };
        t12 = [
            isBlogpost,
            setEditSource,
            currentRouteName,
            setLocalEditSource
        ];
        $[16] = currentRouteName;
        $[17] = isBlogpost;
        $[18] = setEditSource;
        $[19] = t11;
        $[20] = t12;
    } else {
        t11 = $[19];
        t12 = $[20];
    }
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>editButtonRef && (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(editButtonRef.current)?.click();
        $[21] = t13;
    } else t13 = $[21];
    const clickEditPencilButton = t13;
    let t14;
    if ($[22] !== currentRouteName || $[23] !== isBlogpost || $[24] !== setEditSource) {
        t14 = (isClick)=>{
            if (!isClick) {
                let entryPoint_0 = (0, $7NoF3.PAGE_EDIT_SHORTCUT_E);
                if (isBlogpost) entryPoint_0 = (0, $7NoF3.BLOG_EDIT_SHORTCUT_E);
                const isSpaceOverview_0 = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
                if (isSpaceOverview_0) entryPoint_0 = (0, $7NoF3.SPACE_EDIT_SHORTCUT_E);
                setEditSource(entryPoint_0);
                setLocalEditSource(entryPoint_0);
            }
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
        };
        $[22] = currentRouteName;
        $[23] = isBlogpost;
        $[24] = setEditSource;
        $[25] = t14;
    } else t14 = $[25];
    const measureEditButtonClickConversion = t14;
    let t15;
    if ($[26] !== contentId || $[27] !== contentType || $[28] !== currentRouteName || $[29] !== isBlogpost || $[30] !== isEmbeddedContent || $[31] !== isFabricSupported || $[32] !== linkParams || $[33] !== loadEditor || $[34] !== measureEditButtonClickConversion || $[35] !== migrateEPData || $[36] !== routePolicy || $[37] !== routeType || $[38] !== routesContext || $[39] !== spaceKey) {
        t15 = (e)=>{
            measureEditButtonClickConversion(e.isTrusted);
            (0, $74Lca.rememberScrolledPosition)(contentId);
            const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
            const routePolicyPushInNewTab = routePolicy && !routePolicy.willPushInSelf(currentRouteName, contentId, routeType.name, contentId);
            if (!isBlogpost && Boolean(migrateEPData) && routePolicyPushInNewTab) {
                e.preventDefault();
                const navigateToEmbeddedEditor = ()=>{
                    routesContext.push((0, $1NBp8.EDIT_PAGE_EMBED).toUrl(linkParams));
                };
                const navigateToClassicEditor = ()=>{
                    routesContext.push(routeType.toUrl(linkParams));
                };
                migrateEPData(navigateToEmbeddedEditor, navigateToClassicEditor);
            }
            if (details?.href && !routePolicyPushInNewTab) {
                e.preventDefault();
                e.stopPropagation();
                if (!e.isTrusted) routesContext.preloadRoute(details.href);
                loadEditor({
                    contentId: contentId,
                    spaceKey: spaceKey,
                    redirectUrl: details.href,
                    contentType: contentType,
                    isFabricSupported: isFabricSupported,
                    isEmbeddedContent: isEmbeddedContent
                });
            }
        };
        $[26] = contentId;
        $[27] = contentType;
        $[28] = currentRouteName;
        $[29] = isBlogpost;
        $[30] = isEmbeddedContent;
        $[31] = isFabricSupported;
        $[32] = linkParams;
        $[33] = loadEditor;
        $[34] = measureEditButtonClickConversion;
        $[35] = migrateEPData;
        $[36] = routePolicy;
        $[37] = routeType;
        $[38] = routesContext;
        $[39] = spaceKey;
        $[40] = t15;
    } else t15 = $[40];
    routeType;
    const onClickEdit = t15;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const mode = match?.query?.mode;
    let t16;
    if ($[41] !== additionalAnalytics || $[42] !== contentId || $[43] !== contentType || $[44] !== isFabricSupported || $[45] !== isOnEditRoute || $[46] !== mode || $[47] !== searchSessionId) {
        t16 = (e_0, analyticsEvent)=>{
            analyticsEvent.update({
                data: {
                    action: "clicked",
                    actionSubject: "editButton",
                    attributes: {
                        componentVersion: "v2",
                        contentType: contentType,
                        contentId: contentId,
                        isFabricSupported: isFabricSupported,
                        navdexPointType: (0, $56QzY.END),
                        searchSessionId: searchSessionId,
                        ...additionalAnalytics,
                        mode: mode,
                        isOnEditRoute: isOnEditRoute
                    },
                    source: e_0.isTrusted ? "editContentButton" : "editShortcut"
                },
                type: "sendTrackEvent"
            }).fire();
        };
        $[41] = additionalAnalytics;
        $[42] = contentId;
        $[43] = contentType;
        $[44] = isFabricSupported;
        $[45] = isOnEditRoute;
        $[46] = mode;
        $[47] = searchSessionId;
        $[48] = t16;
    } else t16 = $[48];
    const fireClickAnalytics = t16;
    let t17;
    if ($[49] !== contentId || $[50] !== contentType || $[51] !== dataTestId || $[52] !== editShortcutStrings || $[53] !== enforceStorageLimit || $[54] !== fabricEditorEligibility || $[55] !== fireClickAnalytics || $[56] !== intl || $[57] !== isEmbeddedContent || $[58] !== isFabricEligibilityLoading || $[59] !== isFabricSupported || $[60] !== isPopupVisible || $[61] !== linkParams || $[62] !== localEditSource || $[63] !== onClickEdit || $[64] !== onRender || $[65] !== routeType || $[66] !== sendMetrics || $[67] !== sendPrefetchAnalyticsEvent || $[68] !== shouldBlockCreate || $[69] !== spaceKey) {
        t17 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const [convertOnEditExpConfig] = (0, $6mKj3.UNSAFE_noExposureExp)("platform_editor_on_edit_convert");
            let t18;
            if ($[71] !== fabricEditorEligibility || $[72] !== isFabricSupported) {
                t18 = !isFabricSupported && typeof fabricEditorEligibility === "string" && [
                    "SUPPORTED",
                    "SUPPORTED_WITH_MIGRATION"
                ].includes(fabricEditorEligibility);
                $[71] = fabricEditorEligibility;
                $[72] = isFabricSupported;
                $[73] = t18;
            } else t18 = $[73];
            const showConvertPagePopup = t18;
            let t19;
            if ($[74] !== contentId || $[75] !== fireClickAnalytics || $[76] !== isEmbeddedContent || $[77] !== onClickEdit || $[78] !== sendMetrics || $[79] !== sendPrefetchAnalyticsEvent || $[80] !== showConvertPagePopup) {
                t19 = (e_1, analyticsEvent_0)=>{
                    (0, $sD2Tz.resolvePendingPrefetchAnalytics)(contentId, sendPrefetchAnalyticsEvent);
                    if (showConvertPagePopup && (0, $6mKj3.expValEquals)("platform_editor_on_edit_convert", "isEnabled", true)) {
                        e_1.preventDefault();
                        setIsPopupVisible($a4b894acf4b5251f$var$_temp);
                        fireClickAnalytics(e_1, analyticsEvent_0);
                    } else {
                        if (isEmbeddedContent) {
                            const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                            const uniqueKey = observableObject?.object?.uniqueKey;
                            sendMetrics({
                                timestamp: Date.now(),
                                ...uniqueKey ? {
                                    customData: {
                                        uniqueKey: uniqueKey
                                    }
                                } : {}
                            }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_EDIT_CLICK)}`);
                        }
                        fireClickAnalytics(e_1, analyticsEvent_0);
                        onClickEdit(e_1);
                    }
                };
                $[74] = contentId;
                $[75] = fireClickAnalytics;
                $[76] = isEmbeddedContent;
                $[77] = onClickEdit;
                $[78] = sendMetrics;
                $[79] = sendPrefetchAnalyticsEvent;
                $[80] = showConvertPagePopup;
                $[81] = t19;
            } else t19 = $[81];
            const handleButtonClick = t19;
            let t20;
            if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
                t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    id: "edit-button.tooltip",
                    defaultMessage: "Edit"
                });
                $[82] = t20;
            } else t20 = $[82];
            let t21;
            if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
                t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)",
                    spacing: (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "none" : "spacious"
                });
                $[83] = t21;
            } else t21 = $[83];
            let t22;
            if ($[84] !== enforceStorageLimit || $[85] !== handleButtonClick) {
                t22 = enforceStorageLimit(handleButtonClick);
                $[84] = enforceStorageLimit;
                $[85] = handleButtonClick;
                $[86] = t22;
            } else t22 = $[86];
            let t23;
            if ($[87] !== linkParams || $[88] !== routeType || $[89] !== shouldBlockCreate) {
                t23 = shouldBlockCreate ? undefined : routeType.toUrl(linkParams);
                $[87] = linkParams;
                $[88] = routeType;
                $[89] = shouldBlockCreate;
                $[90] = t23;
            } else t23 = $[90];
            let t24;
            if ($[91] !== intl) {
                t24 = intl.formatMessage($a4b894acf4b5251f$var$i18n.editLabel);
                $[91] = intl;
                $[92] = t24;
            } else t24 = $[92];
            let t25;
            if ($[93] !== intl) {
                t25 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    align: "center",
                    weight: "medium",
                    "data-vc": "edit-button-text"
                }, intl.formatMessage($a4b894acf4b5251f$var$i18n.editText));
                $[93] = intl;
                $[94] = t25;
            } else t25 = $[94];
            let t26;
            if ($[95] !== dataTestId || $[96] !== t22 || $[97] !== t23 || $[98] !== t24 || $[99] !== t25) {
                t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4b894acf4b5251f$var$StyledButton, {
                    appearance: "subtle",
                    iconBefore: t21,
                    ref: editButtonRef,
                    onClick: t22,
                    href: t23,
                    "data-test-id": dataTestId,
                    id: "editPageLink",
                    "aria-label": t24
                }, t25);
                $[95] = dataTestId;
                $[96] = t22;
                $[97] = t23;
                $[98] = t24;
                $[99] = t25;
                $[100] = t26;
            } else t26 = $[100];
            let t27;
            if ($[101] !== editShortcutStrings || $[102] !== t26) {
                t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    tag: "span",
                    content: t20,
                    shortcut: editShortcutStrings
                }, t26);
                $[101] = editShortcutStrings;
                $[102] = t26;
                $[103] = t27;
            } else t27 = $[103];
            const button = t27;
            if (isFabricEligibilityLoading) {
                let t28;
                if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
                    t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                        interactionName: "edit-content-button-preloader",
                        size: "small",
                        testId: "edit-content-button-preloader"
                    });
                    $[104] = t28;
                } else t28 = $[104];
                t17 = t28;
                break bb0;
            } else {
                let t28;
                if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
                    t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                        accelerator: (0, $gnkil.EDIT_SHORTCUT),
                        listener: clickEditPencilButton
                    });
                    $[105] = t28;
                } else t28 = $[105];
                let t29;
                if ($[106] !== onRender) {
                    t29 = onRender();
                    $[106] = onRender;
                    $[107] = t29;
                } else t29 = $[107];
                const t30 = showConvertPagePopup && convertOnEditExpConfig.get("isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                    isOpen: isPopupVisible,
                    onClose: ()=>setIsPopupVisible(false),
                    placement: "bottom-start",
                    content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $emYzJ.EditPopupEligibleMigration), {
                            onClickEdit: onClickEdit,
                            contentId: contentId,
                            href: shouldBlockCreate ? undefined : routeType.toUrl(linkParams),
                            contentHash: "",
                            contentType: contentType,
                            spaceKey: spaceKey
                        }),
                    offset: [
                        -34,
                        8
                    ],
                    trigger: (t31)=>{
                        const { ref: ref } = t31;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                            ref: ref
                        }, button);
                    },
                    shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-trueenterprise-e")
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, button);
                let t32;
                if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
                    t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
                    });
                    $[108] = t32;
                } else t32 = $[108];
                let t33;
                if ($[109] !== contentId || $[110] !== isEmbeddedContent || $[111] !== localEditSource || $[112] !== sendPrefetchAnalyticsEvent || $[113] !== spaceKey || $[114] !== t29 || $[115] !== t30) {
                    t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
                        key: contentId,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        isEmbeddedEditor: isEmbeddedContent,
                        editSource: localEditSource,
                        sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent,
                        predictivelyPrefetch: true
                    }, t28, t29, t30, t32);
                    $[109] = contentId;
                    $[110] = isEmbeddedContent;
                    $[111] = localEditSource;
                    $[112] = sendPrefetchAnalyticsEvent;
                    $[113] = spaceKey;
                    $[114] = t29;
                    $[115] = t30;
                    $[116] = t33;
                } else t33 = $[116];
                t17 = t33;
                break bb0;
            }
        }
        $[49] = contentId;
        $[50] = contentType;
        $[51] = dataTestId;
        $[52] = editShortcutStrings;
        $[53] = enforceStorageLimit;
        $[54] = fabricEditorEligibility;
        $[55] = fireClickAnalytics;
        $[56] = intl;
        $[57] = isEmbeddedContent;
        $[58] = isFabricEligibilityLoading;
        $[59] = isFabricSupported;
        $[60] = isPopupVisible;
        $[61] = linkParams;
        $[62] = localEditSource;
        $[63] = onClickEdit;
        $[64] = onRender;
        $[65] = routeType;
        $[66] = sendMetrics;
        $[67] = sendPrefetchAnalyticsEvent;
        $[68] = shouldBlockCreate;
        $[69] = spaceKey;
        $[70] = t17;
    } else t17 = $[70];
    if (t17 !== Symbol.for("react.early_return_sentinel")) return t17;
});
const $a4b894acf4b5251f$export$812a4eda75b35614 = (0, $aXWIB.injectIntl)($a4b894acf4b5251f$var$EditContentButtonComponentInner);
$a4b894acf4b5251f$export$812a4eda75b35614.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onRender: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isEmbeddedContent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isFabricSupported: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
function $a4b894acf4b5251f$var$_temp(prev) {
    return !prev;
}
module.exports["EditContentButtonComponent"] = $a4b894acf4b5251f$export$812a4eda75b35614;

});

parcelRegister("74Lca", function(module, exports) {

var $51ADl = parcelRequire("51ADl");


var $1dnxO = parcelRequire("1dnxO");


var $dpqzw = parcelRequire("dpqzw");


var $b1pBe = parcelRequire("b1pBe");

const $7936391e07f83542$export$69c870891d17d6d0 = (contentId)=>{
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    // root page element
    const page = isNav4Enabled ? document?.getElementById((0, $51ADl.NAV_4_MAIN_CONTENT_ID)) || document.documentElement : document.documentElement;
    // get fabric or classic renderer content id
    const pageContent = document.getElementById((0, $dpqzw.FABRIC_PAGE_CONTENT_ID));
    // if there's no page content, do nothing
    if (!pageContent) return;
    // if the user is already at the top of the page, then no need to scroll
    if (page.scrollTop / page.clientHeight < 0.25) return;
    // save closest scrolled element & contentId to localstorage
    (0, $b1pBe.getClosestScrolledElementIndex)(page, pageContent, contentId);
};
module.exports["rememberScrolledPosition"] = $7936391e07f83542$export$69c870891d17d6d0;

});

parcelRegister("51ADl", function(module, exports) {
const $06488191c40cb6cf$export$cd4d46bdb3670fbb = 'AkMainContent';
module.exports["NAV_4_MAIN_CONTENT_ID"] = $06488191c40cb6cf$export$cd4d46bdb3670fbb;

});

parcelRegister("b1pBe", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $dpqzw = parcelRequire("dpqzw");

const $f44449ceafa69a86$export$1df42b18d7384de5 = (page, pageContent, contentId)=>{
    if (!pageContent) return;
    // grab all of the direct children elements from the rendered content view
    const elementCollection = pageContent.querySelector((0, $dpqzw.RENDERED_CONTENT_SELECTOR))?.children || [];
    // set initial index to -1 in case no closest element is found
    let closestElementIndex = -1;
    // go through all direct children elements and see which is closest to the remembered scroll position
    if (elementCollection.length > 0) {
        const childrenElements = Array.from(elementCollection);
        // calculate scroll position based off of how far a user has scrolled the page minus the distance from the renderer content to the top of the page
        const pageScrollTop = page.scrollTop - pageContent.offsetTop;
        childrenElements.reduce((best, elem, index)=>{
            if (Math.abs(pageScrollTop - elem.offsetTop) < Math.abs(pageScrollTop - best.offsetTop)) {
                closestElementIndex = index;
                return elem;
            } else return best;
        });
    }
    // save the closest element's index to local storage
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION, {
        index: closestElementIndex,
        contentId: contentId
    });
};
module.exports["getClosestScrolledElementIndex"] = $f44449ceafa69a86$export$1df42b18d7384de5;

});

parcelRegister("emYzJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $briGH = parcelRequire("briGH");


var $emb8c = parcelRequire("emb8c");

const $1c786d1286cf45c7$var$i18n = (0, $aXWIB.defineMessages)({
    elligibleMigrationModalTitle: {
        id: "fabric-page-optin-migration.elligible-migration-modal.title",
        defaultMessage: "Time to convert your page"
    },
    elligibleMigrationModalDescription: {
        id: "fabric-page-optin-migration.elligible-migration-modal.description",
        defaultMessage: "This page is compatible with the cloud editor. The legacy editor will be phased out soon, find out more in the <link>announcement</link>."
    },
    elligibleMigrationModalUpdateButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.update-button",
        defaultMessage: "Convert page"
    },
    elligibleMigrationModalCancelButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.cancel-button",
        defaultMessage: "Not now"
    },
    elligibleMigrationModalUnsupported: {
        id: "fabric-page-optin-migration.elligible-migration-modal.unsupported",
        defaultMessage: "This page cannot be converted"
    }
});
const $1c786d1286cf45c7$var$popupContainerStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1c786d1286cf45c7$var$topMarginStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $1c786d1286cf45c7$var$buttonContainerStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 'space.200'
});
const $1c786d1286cf45c7$var$widthStyle = (0, $ecnYn.xcss)({
    width: '297px'
});
const $1c786d1286cf45c7$export$4e1bf6f2717dc4c8 = ({ onClickEdit: onClickEdit, contentId: contentId, href: href, contentHash: contentHash, contentType: contentType, spaceKey: spaceKey })=>{
    const [popupMessage, setPopupMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalDescription
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [migratePages] = (0, $emb8c.useExperimentalMigratePagesMutation)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'eligibleMigrationModal'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClickConvert = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'eligibleMigrationModalConvertButton',
                source: 'editPopupEligibleMigration'
            }
        }).fire();
        const response = await migratePages({
            variables: {
                contentId: contentId,
                contentHash: contentHash
            }
        });
        const status = (0, $briGH.getStatusFromResponse)(response);
        if (status === '200' || status === '204') {
            const redirectRoute = contentType === 'page' ? (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: contentId
            }) : (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                contentType: 'blog',
                spaceKey: spaceKey,
                contentId: contentId
            });
            // perform redirect
            push(redirectRoute);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).PAGE_JUST_CONVERTED, contentId);
        } else {
            setPopupMessage($1c786d1286cf45c7$var$i18n.elligibleMigrationModalUnsupported);
            if (response && 'errors' in response && response.errors) (0, $7Sm4c.markErrorAsHandled)(response.errors);
        }
    }, [
        createAnalyticsEvent,
        migratePages,
        contentId,
        contentHash,
        contentType,
        spaceKey,
        push
    ]);
    if (!isLoggedIn || !href) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$popupContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$widthStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        tagName: "h3",
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle,
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...popupMessage,
        tagName: "p",
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks),
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                    href: "https://community.atlassian.com/forums/Confluence-articles/The-Legacy-Editor-is-being-deprecated-in-Confluence-Cloud-Here-s/ba-p/3046832",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1c786d1286cf45c7$var$buttonContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        href: href,
        onClick: onClickEdit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onClickConvert
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalUpdateButton))))));
};
module.exports["EditPopupEligibleMigration"] = $1c786d1286cf45c7$export$4e1bf6f2717dc4c8;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("emb8c", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");


var $hBkCm = parcelRequire("hBkCm");

const $b8f7841fb375e78f$export$bff11ed54317b5ef = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ contentId: contentId, contentHash: contentHash })=>`/wiki/rest/api/content/${contentId}/convert?hash=${contentHash}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON,
            'X-Requested-With': 'XMLHttpRequest'
        },
        parseResult: (response)=>({
                experimentalMigratePages: {
                    status: String(response.status)
                }
            }),
        parseResponseOnSuccess: async (response)=>{
            return {
                status: response.status
            };
        },
        parseResponseOnError: async (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                status: error.response.status
            };
            throw error;
        },
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useExperimentalMigratePagesMutation"] = $b8f7841fb375e78f$export$bff11ed54317b5ef;

});

parcelRegister("ca2z9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2HZwz = parcelRequire("2HZwz");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");

const $a70c768defde6626$var$UseFabricEligibilityMigrationQuery = (0, $2HZwz.default);
const $a70c768defde6626$export$848562a07f990254 = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { contentId: contentId, isFabricSupported: isFabricSupported } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const shouldFetch = isFabricSupported === false;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            fetchPolicy: "cache-first",
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($a70c768defde6626$var$UseFabricEligibilityMigrationQuery, t1);
    let t2;
    if ($[2] !== contentId || $[3] !== createAnalyticsEvent) {
        t2 = (t3)=>{
            const { reason: reason } = t3;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "failed",
                    actionSubject: "fabricEditorEligibilityQuery",
                    attributes: {
                        contentId: contentId,
                        reason: reason
                    },
                    source: "editContentButton"
                }
            }).fire();
        };
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    const fireErrorEvent = t2;
    let t3;
    let t4;
    if ($[5] !== error || $[6] !== fireErrorEvent) {
        t3 = ()=>{
            if (error) fireErrorEvent({
                reason: "APOLLO_ERROR"
            });
        };
        t4 = [
            error,
            fireErrorEvent
        ];
        $[5] = error;
        $[6] = fireErrorEvent;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    bb0: {
        if (!shouldFetch) {
            let t6;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    fabricEditorEligibility: null,
                    contentHash: null,
                    isFabricEligibilityLoading: false
                };
                $[9] = t6;
            } else t6 = $[9];
            t5 = t6;
            break bb0;
        }
        if (!data && shouldFetch) {
            let t6;
            if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[10] = t6;
            } else t6 = $[10];
            t5 = t6;
            break bb0;
        }
        if (!data && loading) {
            let t6;
            if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[11] = t6;
            } else t6 = $[11];
            t5 = t6;
            break bb0;
        }
        if (data) {
            const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
            const fabricEditorEligibility = metadataFrontend?.fabricEditorEligibility;
            const contentHash = metadataFrontend?.contentHash;
            let t6;
            if ($[12] !== contentHash || $[13] !== fabricEditorEligibility) {
                t6 = {
                    fabricEditorEligibility: fabricEditorEligibility,
                    contentHash: contentHash,
                    isFabricEligibilityLoading: false
                };
                $[12] = contentHash;
                $[13] = fabricEditorEligibility;
                $[14] = t6;
            } else t6 = $[14];
            t5 = t6;
            break bb0;
        }
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                fabricEditorEligibility: null,
                contentHash: null,
                isFabricEligibilityLoading: false
            };
            $[15] = t6;
        } else t6 = $[15];
        t5 = t6;
    }
    return t5;
};
module.exports["useFabricEligibilityMigrationQuery"] = $a70c768defde6626$export$848562a07f990254;

});

parcelRegister("2HZwz", function(module, exports) {
/**
 * @generated SignedSource<<4be71935d18a4beb282abc868c9ad915>>
 * @relayHash ec4bb4fc4b91bdd22636b8cd5a8459f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288
const $41339af49efc6ee3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorEligibility"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentHash"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ec4bb4fc4b91bdd22636b8cd5a8459f5",
            "id": "1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288",
            "metadata": {},
            "name": "useFabricEligibilityMigrationQuery",
            "operationKind": "query",
            "text": "query useFabricEligibilityMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{frontend{fabricEditorEligibility,contentHash}}}}}"
        }
    };
}();
$41339af49efc6ee3$var$node.hash = "204d8fbd9ab341cec958fee25e721167";
var $41339af49efc6ee3$export$2e2bcd8739ae039 = $41339af49efc6ee3$var$node;
module.exports["default"] = $41339af49efc6ee3$export$2e2bcd8739ae039;

});

parcelRegister("7mHcA", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $2zRSX = parcelRequire("2zRSX");


var $gkjo6 = parcelRequire("gkjo6");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");

let $6feb6b3d360f0331$var$onMigrationSuccess = ()=>{};
let $6feb6b3d360f0331$var$onMigrationFailure = ()=>{};
const $6feb6b3d360f0331$export$a48339a192545f1f = (contentId, skipOnLoadQuery)=>{
    const $ = (0, $frIzR.c)(27);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent) {
        t0 = (t1)=>{
            const { action: action, actionSubjectId: actionSubjectId, withMigration: withMigration, error: error } = t1;
            return createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: action,
                    actionSubject: "ncsMigrationQuery",
                    actionSubjectId: actionSubjectId,
                    source: "embeddedPageViewScreen",
                    object: {
                        id: contentId,
                        type: "page"
                    },
                    attributes: {
                        withMigration: withMigration,
                        error: error
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const trackMigrationEvent = t0;
    let t1;
    if ($[3] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    let t3;
    if ($[5] !== trackMigrationEvent) {
        t2 = (data)=>{
            if (data?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: true
            });
            else trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: false
            });
        };
        t3 = (err)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnLoad",
                error: err.message
            });
        };
        $[5] = trackMigrationEvent;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    let t4;
    if ($[8] !== skipOnLoadQuery || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
        t4 = {
            variables: t1,
            fetchPolicy: "network-only",
            skip: skipOnLoadQuery,
            onCompleted: t2,
            onError: t3
        };
        $[8] = skipOnLoadQuery;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    const epMigrationOnLoad = (0, $jMyy4.useQueryInterop)((0, $gkjo6.default), t4);
    let t5;
    if ($[13] !== contentId) {
        t5 = {
            contentId: contentId
        };
        $[13] = contentId;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== trackMigrationEvent) {
        t6 = (err_0)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnEditClick",
                error: err_0?.message
            });
            $6feb6b3d360f0331$var$onMigrationFailure(err_0);
        };
        $[15] = trackMigrationEvent;
        $[16] = t6;
    } else t6 = $[16];
    const [migrateData, t7] = (0, $lvOsp.useLazyQueryInterop)((0, $2zRSX.default), {
        variables: t5,
        fetchPolicy: "network-only",
        onCompleted: (data_0)=>{
            if (data_0?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: true
                });
                $6feb6b3d360f0331$var$onMigrationSuccess(onClickData);
            } else {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: false
                });
                $6feb6b3d360f0331$var$onMigrationFailure();
            }
        },
        onError: t6
    });
    const { data: t8, loading: onClickLoading, error: onClickError } = t7;
    const onClickData = t8;
    let t9;
    if ($[17] !== migrateData) {
        t9 = (t10, t11)=>{
            const onSuccess = t10 === undefined ? $6feb6b3d360f0331$var$_temp : t10;
            const onFailure = t11 === undefined ? $6feb6b3d360f0331$var$_temp2 : t11;
            $6feb6b3d360f0331$var$onMigrationSuccess = onSuccess;
            $6feb6b3d360f0331$var$onMigrationFailure = onFailure;
            migrateData();
        };
        $[17] = migrateData;
        $[18] = t9;
    } else t9 = $[18];
    const migrateEPData = t9;
    let t10;
    if ($[19] !== migrateEPData || $[20] !== onClickData || $[21] !== onClickError || $[22] !== onClickLoading) {
        t10 = {
            migrateEPData: migrateEPData,
            data: onClickData,
            loading: onClickLoading,
            error: onClickError
        };
        $[19] = migrateEPData;
        $[20] = onClickData;
        $[21] = onClickError;
        $[22] = onClickLoading;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== epMigrationOnLoad || $[25] !== t10) {
        t11 = {
            epMigrationOnLoad: epMigrationOnLoad,
            epMigrationOnClick: t10
        };
        $[24] = epMigrationOnLoad;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
};
function $6feb6b3d360f0331$var$_temp() {}
function $6feb6b3d360f0331$var$_temp2() {}
module.exports["useEmbeddedMigrationQuery"] = $6feb6b3d360f0331$export$a48339a192545f1f;

});

parcelRegister("2zRSX", function(module, exports) {
/**
 * @generated SignedSource<<5c8046397e989ff4de21e4bf02fde9a0>>
 * @relayHash 8ce6c444a2fa7276cb4da3d1a791d300
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b36d62c169e4fc5c39a3306da79a54ff311e294e3ad79fbb21c36f48abdc74b
const $a67fcf7b0c351cc5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embeddedWithMigration"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ce6c444a2fa7276cb4da3d1a791d300",
            "id": "2b36d62c169e4fc5c39a3306da79a54ff311e294e3ad79fbb21c36f48abdc74b",
            "metadata": {},
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "operationKind": "query",
            "text": "query useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery($contentId:ID!){content(id:$contentId){nodes{id,type,metadata{frontend{embeddedWithMigration}}}}}"
        }
    };
}();
$a67fcf7b0c351cc5$var$node.hash = "e811ca917e234d313519ff2281e9d6fc";
var $a67fcf7b0c351cc5$export$2e2bcd8739ae039 = $a67fcf7b0c351cc5$var$node;
module.exports["default"] = $a67fcf7b0c351cc5$export$2e2bcd8739ae039;

});

parcelRegister("gkjo6", function(module, exports) {
/**
 * @generated SignedSource<<8842e1dd191a43704011a6335f99b74c>>
 * @relayHash 3b2300539134eec5a57f18f298c307e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3fa39827a54818a9014acf891b0b162dcb6f4a289ff487ce4c67d552c5d850ec
const $7dbead30693bf664$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embeddedWithMigration"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3b2300539134eec5a57f18f298c307e4",
            "id": "3fa39827a54818a9014acf891b0b162dcb6f4a289ff487ce4c67d552c5d850ec",
            "metadata": {},
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "operationKind": "query",
            "text": "query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,type,metadata{frontend{embeddedWithMigration}}}}}"
        }
    };
}();
$7dbead30693bf664$var$node.hash = "226895c47be9fed079eb4901c8267e39";
var $7dbead30693bf664$export$2e2bcd8739ae039 = $7dbead30693bf664$var$node;
module.exports["default"] = $7dbead30693bf664$export$2e2bcd8739ae039;

});

parcelRegister("4c4ke", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $bl4QJ = parcelRequire("bl4QJ");


const $6572a38c2b754de3$export$7a3e91558b835213 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G6aNu",
    name: "WatchDialog",
    loader: async ()=>(await (parcelRequire("hPINX"))).WatchDialog,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
module.exports["WatchDialog"] = $6572a38c2b754de3$export$7a3e91558b835213;

});

parcelRegister("hPINX", function(module, exports) {

let $cfb9f46239efc337$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cfb9f46239efc337$var$load("lUs3J"),
    $cfb9f46239efc337$var$load("fZt2F"),
    $cfb9f46239efc337$var$load("6wr18"),
    $cfb9f46239efc337$var$load("ffEVr"),
    $cfb9f46239efc337$var$load("7EorR"),
    $cfb9f46239efc337$var$load("cUtrS")
]).then(()=>parcelRequire('bzo9I'));

});

parcelRegister("hAnPj", function(module, exports) {
$parcel$export(module.exports, "RestrictionsDialogTriggerWrapper", () => (parcelRequire("SAFLR")).RestrictionsDialogTriggerWrapper);
$parcel$export(module.exports, "RestrictionsDialogTrigger", () => (parcelRequire("lEXFh")).RestrictionsDialogTrigger);
$parcel$export(module.exports, "RestrictionsDialogMenuPropsProvider", () => (parcelRequire("lQDcS")).RestrictionsDialogMenuPropsProvider);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $SAFLR = parcelRequire("SAFLR");


var $lEXFh = parcelRequire("lEXFh");


var $lQDcS = parcelRequire("lQDcS");


const $bb619eb96b539cb1$export$8c358bcfa2c0ec3f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qdHUS",
    name: "LazyRestrictionsDialogMountPoint",
    loader: async ()=>(await (parcelRequire("jaWw7"))).RestrictionsDialogMountPoint
});
module.exports["LazyRestrictionsDialogMountPoint"] = $bb619eb96b539cb1$export$8c358bcfa2c0ec3f;

});

parcelRegister("SAFLR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $lEXFh = parcelRequire("lEXFh");

const $84211cd137cf57b0$export$e8086e85d5f7d830 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(5);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    let t0;
    if ($[0] !== hasAccess || $[1] !== props) {
        t0 = hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            key: "restriction-button-start",
            id: props.contentId,
            name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null;
        $[0] = hasAccess;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
            key: "restrictions-dialog-trigger"
        }, t0);
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
        key: "restrictions-dialog-trigger"
    }, hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        key: "restriction-button-start",
        id: props.contentId,
        name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null);
};
module.exports["RestrictionsDialogTriggerWrapper"] = $84211cd137cf57b0$export$e8086e85d5f7d830;

});

parcelRegister("lEXFh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $io723 = parcelRequire("io723");


var $b27bJ = parcelRequire("b27bJ");


var $euL71 = parcelRequire("euL71");


var $5u6LZ = parcelRequire("5u6LZ");


var $8RR7m = parcelRequire("8RR7m");


var $9wGTI = parcelRequire("9wGTI");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $ckmNl = parcelRequire("ckmNl");


var $jLw6A = parcelRequire("jLw6A");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $bVAxT = parcelRequire("bVAxT");


var $14SPd = parcelRequire("14SPd");


var $cSVAY = parcelRequire("cSVAY");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");

const $0b24ce56d1d6b617$var$styles = {
    buttonContainer: "_1e0c1o8l _s7n4jp4b"
};
const $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT = 'bottom-end';
const $0b24ce56d1d6b617$export$4a978df01c3bf89e = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(36);
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || "";
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            grantAccessClicked: false,
            hasAutoOpenedRestrictionDialog: false,
            showFreeRestrictionDialog: false
        };
        $[0] = t0;
    } else t0 = $[0];
    const [state, setState] = (0, $42omo.useState)(t0);
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[1] !== contentId || $[2] !== contentSubType || $[3] !== contentType || $[4] !== edition || $[5] !== experienceTracker || $[6] !== useAnalyticsEventsHook) {
        t1 = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                    ...useAnalyticsEventsHook,
                    actionSubjectId: "restrictionsDialogButton",
                    dialogStateContainer: dialogStateContainer,
                    edition: edition,
                    experienceTracker: experienceTracker,
                    contentType: contentType,
                    contentSubType: contentSubType,
                    contentId: contentId
                });
        $[1] = contentId;
        $[2] = contentSubType;
        $[3] = contentType;
        $[4] = edition;
        $[5] = experienceTracker;
        $[6] = useAnalyticsEventsHook;
        $[7] = t1;
    } else t1 = $[7];
    const makeHandleOpen = t1;
    const getParentData = $0b24ce56d1d6b617$var$_temp;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp2);
        };
        $[8] = t2;
    } else t2 = $[8];
    const handleGrantAccessActionClicked = t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp3);
        };
        $[9] = t3;
    } else t3 = $[9];
    const handleFreeEditionPadlockClicked = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp4);
        };
        $[10] = t4;
    } else t4 = $[10];
    const onFreeDialogClosed = t4;
    let t5;
    if ($[11] !== contentId || $[12] !== makeHandleOpen || $[13] !== props || $[14] !== state) {
        t5 = (dialogStateContainer_0, shouldShowDialog)=>{
            const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
            const shouldSSRViewPageFreeEditionButton = triggeredFrom === "fromView";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, (t6)=>{
                const { loading: loading, error: error, restrictions: restrictions_0 } = t6;
                if (!restrictions_0 && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
                const contentHasRestrictions = Boolean(restrictions_0?.hasRestrictions || restrictions_0?.hasInheritedRestrictions);
                const contentHasInheritedRestrictionsOnly = Boolean(restrictions_0?.hasInheritedRestrictions && !restrictions_0?.hasRestrictions);
                const immediateParentPageIndex = (restrictions_0?.ancestors.length || 0) - 1;
                const isChildPage = immediateParentPageIndex > 0;
                if (contentHasRestrictions) {
                    if (isChildPage && contentHasInheritedRestrictionsOnly) {
                        const parentData = getParentData(restrictions_0);
                        return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                            isOpen: state.showFreeRestrictionDialog,
                            onClose: onFreeDialogClosed,
                            parentData: parentData,
                            isChildPage: isChildPage,
                            placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                            contentId: contentId,
                            isDisabled: isDisabled,
                            onClick: handleFreeEditionPadlockClicked,
                            restrictionsButtonSSRRendered: true,
                            restrictionsButtonSSRLocation: "free inherited",
                            triggeredFrom: triggeredFrom
                        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                            isOpen: state.showFreeRestrictionDialog,
                            onClose: onFreeDialogClosed,
                            parentData: parentData,
                            isChildPage: isChildPage,
                            placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                            contentId: contentId,
                            isDisabled: isDisabled,
                            onClick: handleFreeEditionPadlockClicked,
                            restrictionsButtonSSRLocation: "free inherited",
                            triggeredFrom: triggeredFrom
                        }));
                    }
                    if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                        makeHandleOpen(dialogStateContainer_0)();
                        setState($0b24ce56d1d6b617$var$_temp5);
                    }
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        resetDialogState: ()=>dialogStateContainer_0.initState(),
                        onClick: makeHandleOpen(dialogStateContainer_0),
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free grandfather",
                        triggeredFrom: triggeredFrom
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: makeHandleOpen(dialogStateContainer_0),
                        restrictionsButtonSSRLocation: "free grandfather",
                        triggeredFrom: triggeredFrom
                    });
                }
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                    isOpen: state.showFreeRestrictionDialog,
                    onClose: onFreeDialogClosed,
                    placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: handleFreeEditionPadlockClicked,
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free",
                    triggeredFrom: triggeredFrom
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                    isOpen: state.showFreeRestrictionDialog,
                    onClose: onFreeDialogClosed,
                    placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: handleFreeEditionPadlockClicked,
                    restrictionsButtonSSRLocation: "free",
                    triggeredFrom: triggeredFrom
                }));
            });
        };
        $[11] = contentId;
        $[12] = makeHandleOpen;
        $[13] = props;
        $[14] = state;
        $[15] = t5;
    } else t5 = $[15];
    const renderFreeEditionDialog = t5;
    let t6;
    if ($[16] !== contentId || $[17] !== makeHandleOpen || $[18] !== props) {
        t6 = (dialogStateContainer_1)=>{
            const { isDisabled: isDisabled_0, triggeredFrom: triggeredFrom_0 } = props;
            if (triggeredFrom_0 && triggeredFrom_0 === "fromView") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled_0,
                onClick: makeHandleOpen(dialogStateContainer_1),
                resetDialogState: ()=>dialogStateContainer_1.initState(),
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "default",
                triggeredFrom: triggeredFrom_0
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled_0,
                onClick: makeHandleOpen(dialogStateContainer_1),
                restrictionsButtonSSRLocation: "default",
                triggeredFrom: triggeredFrom_0
            });
        };
        $[16] = contentId;
        $[17] = makeHandleOpen;
        $[18] = props;
        $[19] = t6;
    } else t6 = $[19];
    const renderRestrictionsButton = t6;
    let t7;
    if ($[20] !== contentId || $[21] !== makeHandleOpen || $[22] !== props || $[23] !== renderRestrictionsButton || $[24] !== state) {
        t7 = (getQueryParams, dialogStateContainer_2, shouldShowDialog_0)=>{
            const { isDisabled: isDisabled_1, triggeredFrom: triggeredFrom_1 } = props;
            const queryParams = getQueryParams();
            const shouldSSRGrantAccessRestrictions = triggeredFrom_1 === "fromView";
            if (shouldShowDialog_0 && !state.grantAccessClicked) {
                const accountId = (0, $c3Qwv.getSingleParam)(queryParams, "accountId");
                const legacyUsername = (0, $c3Qwv.getSingleParam)(queryParams, "username") || "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u6LZ.GrantAccessDialogLoader), {
                    isOpen: true,
                    contentId: contentId,
                    onActionClick: handleGrantAccessActionClicked,
                    accessType: (0, $c3Qwv.getSingleParam)(queryParams, "accessType") === "edit" ? "edit" : "view",
                    accountId: accountId || legacyUsername,
                    shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions,
                    buttonPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null)
                }, shouldSSRGrantAccessRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled_1,
                    resetDialogState: ()=>dialogStateContainer_2.initState(),
                    onClick: makeHandleOpen(dialogStateContainer_2),
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "default grant access",
                    triggeredFrom: triggeredFrom_1
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled_1,
                    onClick: makeHandleOpen(dialogStateContainer_2),
                    restrictionsButtonSSRLocation: "default grant access",
                    triggeredFrom: triggeredFrom_1
                }));
            }
            return renderRestrictionsButton(dialogStateContainer_2);
        };
        $[20] = contentId;
        $[21] = makeHandleOpen;
        $[22] = props;
        $[23] = renderRestrictionsButton;
        $[24] = state;
        $[25] = t7;
    } else t7 = $[25];
    const renderGrantAccessDialogAndButton = t7;
    let t8;
    if ($[26] !== contentId || $[27] !== renderRestrictionsButton) {
        t8 = (dialogStateContainer_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderRestrictionsButton(dialogStateContainer_3), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
                contentId: contentId
            }));
        $[26] = contentId;
        $[27] = renderRestrictionsButton;
        $[28] = t8;
    } else t8 = $[28];
    const renderGrantAccessFlagAndButton = t8;
    let t9;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ];
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== contentId || $[31] !== edition || $[32] !== renderFreeEditionDialog || $[33] !== renderGrantAccessDialogAndButton || $[34] !== renderGrantAccessFlagAndButton) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t9
        }, (dialogStateContainer_4)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $0b24ce56d1d6b617$var$styles.buttonContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
                isCustomStart: true,
                key: `start-${contentId}`,
                metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
            }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, (t11)=>{
                const { getQueryParams: getQueryParams_0 } = t11;
                const { accountId: accountId_0, grantAccess: grantAccess, username: username } = getQueryParams_0();
                const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId_0 || username);
                const renderGrantAccessComponent = ()=>(0, $9wGTI.fg)("confluence_frontend_grant_access_flag") ? renderGrantAccessFlagAndButton(dialogStateContainer_4) : renderGrantAccessDialogAndButton(getQueryParams_0, dialogStateContainer_4, shouldShowGrantAccessDialog);
                return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer_4, shouldShowGrantAccessDialog) : renderGrantAccessComponent();
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
        $[30] = contentId;
        $[31] = edition;
        $[32] = renderFreeEditionDialog;
        $[33] = renderGrantAccessDialogAndButton;
        $[34] = renderGrantAccessFlagAndButton;
        $[35] = t10;
    } else t10 = $[35];
    return t10;
} : (props)=>{
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || '';
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [state, setState] = (0, $42omo.useState)({
        grantAccessClicked: false,
        hasAutoOpenedRestrictionDialog: false,
        showFreeRestrictionDialog: false
    });
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeHandleOpen = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                ...useAnalyticsEventsHook,
                actionSubjectId: 'restrictionsDialogButton',
                dialogStateContainer: dialogStateContainer,
                edition: edition,
                experienceTracker: experienceTracker,
                contentType: contentType,
                contentSubType: contentSubType,
                contentId: contentId
            });
    const getParentData = (restrictions)=>{
        const ancestors = restrictions?.ancestors || [];
        for(let i = ancestors.length - 1; i >= 0; i--){
            if (ancestors[i].hasRestrictions) return ancestors[i]; // content
        }
    };
    const handleGrantAccessActionClicked = ()=>{
        setState((state_0)=>({
                ...state_0,
                grantAccessClicked: true
            }));
    };
    const handleFreeEditionPadlockClicked = ()=>{
        setState((state_1)=>({
                ...state_1,
                showFreeRestrictionDialog: true
            }));
    };
    const onFreeDialogClosed = ()=>{
        setState((state_2)=>({
                ...state_2,
                showFreeRestrictionDialog: false
            }));
    };
    const renderFreeEditionDialog = (dialogStateContainer_0, shouldShowDialog)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props; // already free edition
        const shouldSSRViewPageFreeEditionButton = triggeredFrom === 'fromView';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, ({ loading: loading, error: error, restrictions: restrictions_0 })=>{
            if (!restrictions_0 && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
            const contentHasRestrictions = Boolean(restrictions_0?.hasRestrictions || restrictions_0?.hasInheritedRestrictions);
            const contentHasInheritedRestrictionsOnly = Boolean(restrictions_0?.hasInheritedRestrictions && !restrictions_0?.hasRestrictions);
            const immediateParentPageIndex = (restrictions_0?.ancestors.length || 0) - 1;
            const isChildPage = immediateParentPageIndex > 0; // Note: content with restrictions is excluded from the pageRestrictionsExperiment
            if (contentHasRestrictions) {
                if (isChildPage && contentHasInheritedRestrictionsOnly) {
                    const parentData = getParentData(restrictions_0);
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    }));
                }
                if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                    makeHandleOpen(dialogStateContainer_0)();
                    setState((state_3)=>({
                            ...state_3,
                            hasAutoOpenedRestrictionDialog: true
                        }));
                } // grandfathered content
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    resetDialogState: ()=>dialogStateContainer_0.initState(),
                    onClick: makeHandleOpen(dialogStateContainer_0),
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: makeHandleOpen(dialogStateContainer_0),
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                });
            }
            return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            }));
        });
    };
    const renderRestrictionsButton = (dialogStateContainer_1)=>{
        const { isDisabled: isDisabled_0, triggeredFrom: triggeredFrom_0 } = props;
        if (triggeredFrom_0 && triggeredFrom_0 === 'fromView') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
            contentId: contentId,
            isDisabled: isDisabled_0,
            onClick: makeHandleOpen(dialogStateContainer_1),
            resetDialogState: ()=>dialogStateContainer_1.initState(),
            restrictionsButtonSSRRendered: true,
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom_0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
            contentId: contentId,
            isDisabled: isDisabled_0,
            onClick: makeHandleOpen(dialogStateContainer_1),
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom_0
        });
    }; //  accessType=view&grantAccess=true&username=rwu&userFullName=Robin+Wu
    const renderGrantAccessDialogAndButton = (getQueryParams, dialogStateContainer_2, shouldShowDialog_0)=>{
        const { isDisabled: isDisabled_1, triggeredFrom: triggeredFrom_1 } = props;
        const queryParams = getQueryParams();
        const shouldSSRGrantAccessRestrictions = triggeredFrom_1 === 'fromView';
        if (shouldShowDialog_0 && !state.grantAccessClicked) {
            const accountId = (0, $c3Qwv.getSingleParam)(queryParams, 'accountId'); // TODO(brizvash): non-gdpr params, remove when GDPR is on
            // "username" in the URL is actually the accountId in legacy circumstances
            // which we will use to fetch username from backend
            const legacyUsername = (0, $c3Qwv.getSingleParam)(queryParams, 'username') || ''; // render grant access requested user
            // preloading the queries means that isOpen wil always be true in SSR.
            // here, we set isOpen to false during SSR so the modal doesn't open on SSR (since
            // there is no handling for the inner modal clicks)
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u6LZ.GrantAccessDialogLoader // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isOpen: true,
                contentId: contentId,
                onActionClick: handleGrantAccessActionClicked,
                accessType: (0, $c3Qwv.getSingleParam)(queryParams, 'accessType') === 'edit' ? 'edit' : 'view',
                accountId: accountId || legacyUsername,
                shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions,
                buttonPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null)
            }, shouldSSRGrantAccessRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled_1,
                resetDialogState: ()=>dialogStateContainer_2.initState(),
                onClick: makeHandleOpen(dialogStateContainer_2),
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "default grant access",
                triggeredFrom: triggeredFrom_1
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled_1,
                onClick: makeHandleOpen(dialogStateContainer_2),
                restrictionsButtonSSRLocation: "default grant access",
                triggeredFrom: triggeredFrom_1
            }));
        }
        return renderRestrictionsButton(dialogStateContainer_2);
    };
    const renderGrantAccessFlagAndButton = (dialogStateContainer_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderRestrictionsButton(dialogStateContainer_3), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
            contentId: contentId
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer_4)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $0b24ce56d1d6b617$var$styles.buttonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            isCustomStart: true,
            key: `start-${contentId}`,
            metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
        }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams_0 })=>{
            const { accountId: accountId_0, grantAccess: grantAccess, username: // TODO(brizvash): non-gdpr params, remove when GDPR is on
            username } = getQueryParams_0();
            const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId_0 || username);
            const renderGrantAccessComponent = ()=>(0, $9wGTI.fg)('confluence_frontend_grant_access_flag') ? renderGrantAccessFlagAndButton(dialogStateContainer_4) : renderGrantAccessDialogAndButton(getQueryParams_0, dialogStateContainer_4, shouldShowGrantAccessDialog);
            return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer_4, shouldShowGrantAccessDialog) : renderGrantAccessComponent();
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
});
$0b24ce56d1d6b617$export$4a978df01c3bf89e.displayName = 'RestrictionsDialogTrigger';
function $0b24ce56d1d6b617$export$59974e42a4613c7({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, dialogStateContainer: dialogStateContainer, edition: edition, experienceTracker: experienceTracker, triggeredFrom: triggeredFrom, contentType: contentType, contentSubType: contentSubType, contentId: contentId }) {
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            source: 'viewPageScreen',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                source: 'v2',
                triggeredFrom: triggeredFrom,
                edition: edition,
                contentType: contentType,
                isLivePage: contentSubType === 'live'
            }
        }
    }).fire();
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_EXPERIENCE),
        attributes: {
            contentType: contentType
        },
        collect (events, experience) {
            // Fail/Abort RESTRICTIONS_DIALOG as soon as _LOAD or _APPLY fails or aborts:
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && (name === (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE) || name === (0, $irVI7.RESTRICTIONS_DIALOG_APPLY_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    }); //
    // Open RestrictionsDialog:
    //
    dialogStateContainer.setContentId(contentId);
    dialogStateContainer.setIsOpen(true, triggeredFrom);
    (0, $14SPd.RESTRICTIONS_DIALOG_METRIC).start();
}
function $0b24ce56d1d6b617$var$_temp(restrictions) {
    const ancestors = restrictions?.ancestors || [];
    for(let i = ancestors.length - 1; i >= 0; i--){
        if (ancestors[i].hasRestrictions) return ancestors[i];
    }
}
function $0b24ce56d1d6b617$var$_temp2(state_0) {
    return {
        ...state_0,
        grantAccessClicked: true
    };
}
function $0b24ce56d1d6b617$var$_temp3(state_1) {
    return {
        ...state_1,
        showFreeRestrictionDialog: true
    };
}
function $0b24ce56d1d6b617$var$_temp4(state_2) {
    return {
        ...state_2,
        showFreeRestrictionDialog: false
    };
}
function $0b24ce56d1d6b617$var$_temp5(state_3) {
    return {
        ...state_3,
        hasAutoOpenedRestrictionDialog: true
    };
}
module.exports["RestrictionsDialogTrigger"] = $0b24ce56d1d6b617$export$4a978df01c3bf89e;
module.exports["startRestrictionsDialogExperience"] = $0b24ce56d1d6b617$export$59974e42a4613c7;

});

parcelRegister("b27bJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $306758770d5ee79f$export$4556cd06b2dec862 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "PlyJG",
    name: "ChangeEditionInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("cf1NT"))).ChangeEditionInlineDialog
});

const $306758770d5ee79f$export$5902d4a19951b5c3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4GH4a",
    name: "ChangeEditionInlineDialogPaintLoader",
    loader: async ()=>(await (parcelRequire("cf1NT"))).ChangeEditionInlineDialog
});
module.exports["ChangeEditionInlineDialogLoader"] = $306758770d5ee79f$export$4556cd06b2dec862;
module.exports["ChangeEditionInlineDialogPaintLoader"] = $306758770d5ee79f$export$5902d4a19951b5c3;

});

parcelRegister("cf1NT", function(module, exports) {

let $8e9848ecf5f94466$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e9848ecf5f94466$var$load("cEqm7"),
    $8e9848ecf5f94466$var$load("6XCf4"),
    $8e9848ecf5f94466$var$load("5pvpJ"),
    $8e9848ecf5f94466$var$load("1qlDN"),
    $8e9848ecf5f94466$var$load("1yVM6"),
    $8e9848ecf5f94466$var$load("1zoBu")
]).then(()=>parcelRequire('4QNfT'));

});

parcelRegister("5u6LZ", function(module, exports) {

var $e3X7L = parcelRequire("e3X7L");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $b3j2Y = parcelRequire("b3j2Y");


var $jmjWc = parcelRequire("jmjWc");

const $11d9bf397902be9d$var$GrantAccessDialogLoaderQuery = (0, $e3X7L.default);

const $11d9bf397902be9d$export$cc070c4b76bfe85d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "5ag_g",
    name: "GrantAccessDialogPaint",
    loader: async ()=>(await (parcelRequire("8w2QP"))).GrantAccessDialog
});

const $11d9bf397902be9d$export$238288686fd365c4 = ({ contentId: contentId, accountId: accountId, shouldSSRGrantAccessRestrictions: shouldSSRGrantAccessRestrictions, buttonPlaceholder: buttonPlaceholder, ...props })=>{
    const GrantAccessDialog = (0, $jmjWc.LoadableLazy)({
        __loadable_id__: "o997N",
        name: "GrantAccessDialog",
        loader: async ()=>(await (parcelRequire("8w2QP"))).GrantAccessDialog,
        loading: ()=>buttonPlaceholder
    });
    const shouldPreloadGrantAccess = shouldSSRGrantAccessRestrictions && window.__SSR_RENDERED__;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($11d9bf397902be9d$var$GrantAccessDialogLoaderQuery, {
        variables: {
            contentId: contentId || '',
            accountId: accountId
        },
        skip: !contentId || !accountId,
        fetchPolicy: shouldPreloadGrantAccess ? 'cache-first' : 'cache-and-network'
    });
    let profilePhoto = '';
    const photos = data?.user?.photos;
    if (photos?.length) {
        const primary = photos.find((photo)=>photo?.isPrimary);
        const foundPhoto = primary ? primary.value : photos[0]?.value;
        profilePhoto = foundPhoto || '';
    }
    const Component = shouldSSRGrantAccessRestrictions ? $11d9bf397902be9d$export$cc070c4b76bfe85d : GrantAccessDialog;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    else if (!contentId || !data?.user) // If user is not recognized or we have no target contentId, render just the children.
    // User is identified via URL params and it would be easy to pass invalid data.
    // Note: must render the children, as this is how restrictions button is displayed
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        contentId: contentId,
        accountId: accountId,
        contentTitle: data?.singleContent?.title || '',
        displayName: data?.user?.displayName || '',
        profilePhoto: profilePhoto,
        ...props
    });
};
module.exports["GrantAccessDialogLoader"] = $11d9bf397902be9d$export$238288686fd365c4;

});

parcelRegister("8w2QP", function(module, exports) {

let $6333860f7e57e87b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6333860f7e57e87b$var$load("6wr18"),
    $6333860f7e57e87b$var$load("1GCFv"),
    $6333860f7e57e87b$var$load("1H5IN"),
    $6333860f7e57e87b$var$load("h4Nf7"),
    $6333860f7e57e87b$var$load("ffEVr"),
    $6333860f7e57e87b$var$load("7do1E"),
    $6333860f7e57e87b$var$load("77dkW"),
    $6333860f7e57e87b$var$load("9PeA0")
]).then(()=>parcelRequire('3aGPB'));

});

parcelRegister("8RR7m", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1756d5d44ec15fad$export$a83249587a24be5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "960Da",
    name: "GrantAccessFlagLoader",
    loader: async ()=>(await (parcelRequire("eAlvY"))).GrantAccessFlag
});
module.exports["GrantAccessFlagLoader"] = $1756d5d44ec15fad$export$a83249587a24be5;

});

parcelRegister("eAlvY", function(module, exports) {

let $a9e51dd97f779d8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a9e51dd97f779d8e$var$load("6wr18"),
    $a9e51dd97f779d8e$var$load("1H5IN"),
    $a9e51dd97f779d8e$var$load("h4Nf7"),
    $a9e51dd97f779d8e$var$load("ffEVr"),
    $a9e51dd97f779d8e$var$load("7do1E"),
    $a9e51dd97f779d8e$var$load("77dkW"),
    $a9e51dd97f779d8e$var$load("4mWJk")
]).then(()=>parcelRequire('4Cd45'));

});

parcelRegister("cSVAY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");


const $c09757da0c891efc$export$758fc7bfe6cba448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "langk",
    name: "RestrictionsButtonLoaderPaint",
    loader: async ()=>(await (parcelRequire("hbACN"))).RestrictionsButton,
    loading: (0, $fkOJz.RestrictionsButtonLoading)
});

const $c09757da0c891efc$export$92f59ae572209281 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZXc7l",
    name: "RestrictionsButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("hbACN"))).RestrictionsButton,
    loading: (0, $eE3dj.RestrictionsButtonPlaceholder)
});
module.exports["RestrictionsButtonLoaderPaint"] = $c09757da0c891efc$export$758fc7bfe6cba448;
module.exports["RestrictionsButtonLoaderAfterPaint"] = $c09757da0c891efc$export$92f59ae572209281;

});

parcelRegister("eE3dj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $cb1652ec96a3881c$export$f7c9f842c83767d4 = (0, $3u0dr.isReactCompilerActiveV2)() ? function RestrictionsButtonPlaceholder() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "restrictions-button-placeholder",
            "data-test-id": "restrictions-button-placeholder",
            style: {
                width: 32,
                height: 32
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RestrictionsButtonPlaceholder() {
    // The RestrictionsDialog will be positioned based on the initial dimensions of
    // RestrictionsButton, so we need to render a placeholder instead of `null`
    // This placeholder is also used in SSR.
    // All the place that is waiting for data in restrictions package should use this placeholder instead of null.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "restrictions-button-placeholder",
        "data-test-id": "restrictions-button-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 32,
            height: 32
        }
    });
};
module.exports["RestrictionsButtonPlaceholder"] = $cb1652ec96a3881c$export$f7c9f842c83767d4;

});

parcelRegister("fkOJz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eE3dj = parcelRequire("eE3dj");

const $560660f3777cb1ae$export$3375d726052961a6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
};
module.exports["RestrictionsButtonLoading"] = $560660f3777cb1ae$export$3375d726052961a6;

});

parcelRegister("hbACN", function(module, exports) {

let $c82fdfa7a3dc8c52$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c82fdfa7a3dc8c52$var$load("9zOlm"),
    $c82fdfa7a3dc8c52$var$load("lUs3J"),
    $c82fdfa7a3dc8c52$var$load("6wr18"),
    $c82fdfa7a3dc8c52$var$load("ffEVr"),
    $c82fdfa7a3dc8c52$var$load("bfhXH")
]).then(()=>parcelRequire('l5Yc7'));

});

parcelRegister("lQDcS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $1kHsc = parcelRequire("1kHsc");


var $bVAxT = parcelRequire("bVAxT");


var $bQm3c = parcelRequire("bQm3c");


var $lEXFh = parcelRequire("lEXFh");

const $3b0d5969bb769929$var$label = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
    id: "restrictions.dialog.link.text",
    defaultMessage: "Restrictions"
});
const $3b0d5969bb769929$export$b0eaba4fdbbe6e8b = (0, $3u0dr.isReactCompilerActiveV2)() ? function RestrictionsDialogMenuPropsProvider(t0) {
    const $ = (0, $frIzR.c)(6);
    const { children: children, contentId: contentId } = t0;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== children || $[1] !== contentId || $[2] !== edition || $[3] !== experienceTracker || $[4] !== useAnalyticsEventsHook) {
        t1 = children && edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $bVAxT.RestrictionsDialogStateContainer)
            ]
        }, (dialogStateContainer)=>children({
                id: "bm-restrictions-link",
                label: $3b0d5969bb769929$var$label,
                onClick () {
                    (0, $lEXFh.startRestrictionsDialogExperience)({
                        ...useAnalyticsEventsHook,
                        actionSubjectId: "restrictionsDialogLink",
                        dialogStateContainer: dialogStateContainer,
                        edition: edition,
                        experienceTracker: experienceTracker,
                        triggeredFrom: "actionsMenu",
                        contentId: contentId
                    });
                }
            })) : null;
        $[0] = children;
        $[1] = contentId;
        $[2] = edition;
        $[3] = experienceTracker;
        $[4] = useAnalyticsEventsHook;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : function RestrictionsDialogMenuPropsProvider({ children: children, contentId: contentId }) {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const useAnalyticsEventsHook = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Note: this is used for balance A/B testing user cohorts, it will be replaced with real feature flag later.
    return children && edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer)=>children({
            id: 'bm-restrictions-link',
            label: $3b0d5969bb769929$var$label,
            onClick () {
                (0, $lEXFh.startRestrictionsDialogExperience)({
                    ...useAnalyticsEventsHook,
                    actionSubjectId: 'restrictionsDialogLink',
                    dialogStateContainer: dialogStateContainer,
                    edition: edition,
                    experienceTracker: experienceTracker,
                    triggeredFrom: 'actionsMenu',
                    contentId: contentId
                });
            }
        })) : null;
};
module.exports["RestrictionsDialogMenuPropsProvider"] = $3b0d5969bb769929$export$b0eaba4fdbbe6e8b;

});

parcelRegister("jaWw7", function(module, exports) {

let $df5c57bfeabf1dc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5c57bfeabf1dc9$var$load("fno6o").then(()=>parcelRequire('ca7si'));

});

parcelRegister("3dPSK", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $660080b0a61a732e$export$75ba55e1c62d2f65 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
module.exports["useIsWatchDialogEnabled"] = $660080b0a61a732e$export$75ba55e1c62d2f65;

});

parcelRegister("bjZbA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8tdj3 = parcelRequire("8tdj3");


var $1qfLF = parcelRequire("1qfLF");


var $ep3mz = parcelRequire("ep3mz");


var $iXzFq = parcelRequire("iXzFq");

const $b9c78150b710374f$export$692138f5b3745b91 = ()=>{
    const [{ contentId: contentId, contentType: contentType, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const handleClick = ()=>{
        if (!contentId || !contentType || !spaceKey) return;
        const url = (0, $iXzFq.getUrlForContentType)({
            contentType: contentType,
            contentId: contentId,
            spaceKey: spaceKey,
            redirectToEditor: false
        });
        if (!url) return;
        window.open(url, '_blank');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        label: "Open in new window",
        onClick: handleClick,
        testId: "loom-external-open-button"
    });
};
module.exports["LoomExternalOpenButton"] = $b9c78150b710374f$export$692138f5b3745b91;

});

parcelRegister("1kaTo", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $8Z1sH = parcelRequire("8Z1sH");


var $2vY2J = parcelRequire("2vY2J");


var $42omo = parcelRequire("42omo");


var $7uLCZ = parcelRequire("7uLCZ");



var $dlky5 = parcelRequire("dlky5");

var $0f701bba444d03b3$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $8Z1sH.default)(node, c);
    });
};
var $0f701bba444d03b3$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $2vY2J.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $0f701bba444d03b3$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $dlky5.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $0f701bba444d03b3$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $0f701bba444d03b3$var$removeClass(node, baseClassName);
        if (activeClassName) $0f701bba444d03b3$var$removeClass(node, activeClassName);
        if (doneClassName) $0f701bba444d03b3$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $bDniu.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uLCZ.default), (0, $7Q5yr.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$0f701bba444d03b3$var$CSSTransition.defaultProps = {
    classNames: ''
};
$0f701bba444d03b3$var$CSSTransition.propTypes = {};
var $0f701bba444d03b3$export$2e2bcd8739ae039 = $0f701bba444d03b3$var$CSSTransition;
module.exports["default"] = $0f701bba444d03b3$export$2e2bcd8739ae039;

});

parcelRegister("8Z1sH", function(module, exports) {
$parcel$export(module.exports, "default", () => $68a5278fcaf5b873$export$2e2bcd8739ae039);

var $4VBb5 = parcelRequire("4VBb5");

function $68a5278fcaf5b873$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $4VBb5.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});

parcelRegister("4VBb5", function(module, exports) {
$parcel$export(module.exports, "default", () => $39695305b192572b$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $39695305b192572b$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});

parcelRegister("2vY2J", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d4d0d5605c08ce5$export$2e2bcd8739ae039);
function $1d4d0d5605c08ce5$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $1d4d0d5605c08ce5$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $1d4d0d5605c08ce5$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $1d4d0d5605c08ce5$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});

parcelRegister("1Zthr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $86e4d9c8583d266f$export$9c05e92142f10f44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CxVtX",
    name: "UnarchivePagesDialogLoader",
    loader: async ()=>(await (parcelRequire("4jJkW"))).UnarchivePagesLoader
});
module.exports["UnarchivePagesDialogLoader"] = $86e4d9c8583d266f$export$9c05e92142f10f44;

});

parcelRegister("4jJkW", function(module, exports) {

let $324c1ab5b4f19bca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $324c1ab5b4f19bca$var$load("kHOMt"),
    $324c1ab5b4f19bca$var$load("4pqtR"),
    $324c1ab5b4f19bca$var$load("5XqRg"),
    $324c1ab5b4f19bca$var$load("6wr18"),
    $324c1ab5b4f19bca$var$load("42aQC"),
    $324c1ab5b4f19bca$var$load("jyWy1"),
    $324c1ab5b4f19bca$var$load("7o5Pu"),
    $324c1ab5b4f19bca$var$load("9pso5"),
    $324c1ab5b4f19bca$var$load("ffEVr"),
    $324c1ab5b4f19bca$var$load("hhss7"),
    $324c1ab5b4f19bca$var$load("jXx9i"),
    $324c1ab5b4f19bca$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("6eFi0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ad336c78e6fcf61a$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "seFL5",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("36lPd"))).ResolvedInlineCommentsDialog
});
module.exports["ResolvedInlineCommentsDialogLoader"] = $ad336c78e6fcf61a$export$492577bc4a81367b;

});

parcelRegister("36lPd", function(module, exports) {

let $2422dca5165801e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2422dca5165801e6$var$load("3JSgG"),
    $2422dca5165801e6$var$load("5wC2D"),
    $2422dca5165801e6$var$load("6wr18"),
    $2422dca5165801e6$var$load("dUwYW"),
    $2422dca5165801e6$var$load("2PePB"),
    $2422dca5165801e6$var$load("lg1HU"),
    $2422dca5165801e6$var$load("1GCFv"),
    $2422dca5165801e6$var$load("cLmw6"),
    $2422dca5165801e6$var$load("a9w2G"),
    $2422dca5165801e6$var$load("6cnH1"),
    $2422dca5165801e6$var$load("h9Ed7"),
    $2422dca5165801e6$var$load("lkOIY"),
    $2422dca5165801e6$var$load("dI1Cd"),
    $2422dca5165801e6$var$load("jbxHq"),
    $2422dca5165801e6$var$load("l0dTs"),
    $2422dca5165801e6$var$load("8YSo7"),
    $2422dca5165801e6$var$load("g9CVe"),
    $2422dca5165801e6$var$load("5pvpJ"),
    $2422dca5165801e6$var$load("Wowvf"),
    $2422dca5165801e6$var$load("421lv"),
    $2422dca5165801e6$var$load("cyGuT"),
    $2422dca5165801e6$var$load("ffEVr"),
    $2422dca5165801e6$var$load("hhss7"),
    $2422dca5165801e6$var$load("3LP1d"),
    $2422dca5165801e6$var$load("5Fany"),
    $2422dca5165801e6$var$load("jXx9i"),
    $2422dca5165801e6$var$load("1cktr"),
    $2422dca5165801e6$var$load("3Oy4g"),
    $2422dca5165801e6$var$load("l1BQC"),
    $2422dca5165801e6$var$load("jlSF3"),
    $2422dca5165801e6$var$load("cXoAq"),
    $2422dca5165801e6$var$load("5qNrc"),
    $2422dca5165801e6$var$load("dP7ao"),
    $2422dca5165801e6$var$load("hogcU"),
    $2422dca5165801e6$var$load("4pqtR"),
    $2422dca5165801e6$var$load("5XqRg"),
    $2422dca5165801e6$var$load("77NEU"),
    $2422dca5165801e6$var$load("2uVTT"),
    $2422dca5165801e6$var$load("fGkaB"),
    $2422dca5165801e6$var$load("evYW1"),
    $2422dca5165801e6$var$load("8ublV"),
    $2422dca5165801e6$var$load("3DgZV"),
    $2422dca5165801e6$var$load("a8Rqp"),
    $2422dca5165801e6$var$load("1EWOs"),
    $2422dca5165801e6$var$load("h3ABO"),
    $2422dca5165801e6$var$load("kC80R"),
    $2422dca5165801e6$var$load("7EorR"),
    $2422dca5165801e6$var$load("hOsjc")
]).then(()=>parcelRequire('92Mdh'));

});

parcelRegister("4ZXww", function(module, exports) {
const $6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $6699361aa30cfc48$export$461ea60ca403d592 = {
    MORE_ACTIONS_ITEMS: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}more-actions-items`,
    OBJECT_SIDEBAR_CONTROL: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}object-sidebar-control`,
    SIDEBAR_DETAILS_BUTTON: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
module.exports["OBJECT_SIDEBAR_TOUR_TARGETS"] = $6699361aa30cfc48$export$461ea60ca403d592;

});

parcelRegister("bzwhi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $cOrQJ = parcelRequire("cOrQJ");


var $67Foi = parcelRequire("67Foi");


var $lsxnT = parcelRequire("lsxnT");


var $dINOl = parcelRequire("dINOl");


var $dm7Aa = parcelRequire("dm7Aa");


var $eufiU = parcelRequire("eufiU");


var $4TcLf = parcelRequire("4TcLf");


var $4ZXww = parcelRequire("4ZXww");


var $kSwrz = parcelRequire("kSwrz");

var $2347032a59a3f6fa$export$6054829ec0b77d62 = /*#__PURE__*/ function(MoreActionsObjectSidebarTourSteps) {
    MoreActionsObjectSidebarTourSteps[MoreActionsObjectSidebarTourSteps["FIRST"] = 0] = "FIRST";
    return MoreActionsObjectSidebarTourSteps;
}({});
const $2347032a59a3f6fa$var$i18n = (0, $aXWIB.defineMessages)({
    ok: {
        id: "object-sidebar-components.more-actions.tour.ok",
        defaultMessage: "OK"
    },
    getTheDetailsYouNeed: {
        id: "object-sidebar-components.more-actions.tour.get-the-details-you-need",
        defaultMessage: "Get the details you need"
    },
    viewAndManageOwnership: {
        id: "object-sidebar-components.more-actions.tour.view-and-manage-ownership",
        defaultMessage: "View and manage ownership, labels, and more in a single panel."
    }
});
const $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME = 'more-actions-object-sidebar-spotlight';
const $2347032a59a3f6fa$var$useSpotlights = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { end: end } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const theme = (0, $cOrQJ.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($dm7Aa))) : (0, (/*@__PURE__*/$parcel$interopDefault($eufiU)));
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($2347032a59a3f6fa$var$i18n.ok);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== end || $[3] !== t1) {
        t2 = [
            {
                onClick: end,
                text: t1
            }
        ];
        $[2] = end;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== end) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dINOl.CrossIconCloseButton), {
            onClose: end,
            source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
        });
        $[7] = end;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== GetTheDetailsYouNeedGif || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = [
            {
                key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                targetRadius: 3,
                actions: t2,
                image: GetTheDetailsYouNeedGif,
                dialogWidth: 341,
                heading: t3,
                headingAfterElement: t4,
                children: t5
            }
        ];
        $[11] = GetTheDetailsYouNeedGif;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ end: end })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const theme = (0, $cOrQJ.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($dm7Aa))) : (0, (/*@__PURE__*/$parcel$interopDefault($eufiU)));
    return [
        {
            key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            targetRadius: 3,
            actions: [
                {
                    onClick: end,
                    text: formatMessage($2347032a59a3f6fa$var$i18n.ok)
                }
            ],
            image: GetTheDetailsYouNeedGif,
            dialogWidth: 341,
            heading: formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dINOl.CrossIconCloseButton), {
                onClose: end,
                source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
            }),
            children: formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership)
        }
    ];
};
const $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING = 'floatingActionBarChangeboarding';
const $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS = [
    $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING
];
const $2347032a59a3f6fa$export$4ead2825721da9b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { step: step } = t0;
    const [t1, t2] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const { activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex } = t1;
    const { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour } = t2;
    const [messageType] = (0, $42omo.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    let t3;
    if ($[0] !== endTour) {
        t3 = ()=>{
            endTour();
        };
        $[0] = endTour;
        $[1] = t3;
    } else t3 = $[1];
    const concludeTour = t3;
    let t4;
    if ($[2] !== concludeTour) {
        t4 = {
            end: concludeTour
        };
        $[2] = concludeTour;
        $[3] = t4;
    } else t4 = $[3];
    const spotlights = $2347032a59a3f6fa$var$useSpotlights(t4);
    let t5;
    if ($[4] !== Spotlight || $[5] !== activeSpotlightIndex || $[6] !== messageType || $[7] !== spotlights || $[8] !== step) {
        t5 = activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null;
        $[4] = Spotlight;
        $[5] = activeSpotlightIndex;
        $[6] = messageType;
        $[7] = spotlights;
        $[8] = step;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== activeSpotlightIndex || $[11] !== concludeTour || $[12] !== initiateTour || $[13] !== lastActiveSpotlightIndex || $[14] !== resetTour || $[15] !== t5) {
        t6 = {
            activeSpotlight: t5,
            initiateTour: initiateTour,
            concludeTour: concludeTour,
            resetTour: resetTour,
            activeSpotlightIndex: activeSpotlightIndex,
            lastActiveSpotlightIndex: lastActiveSpotlightIndex
        };
        $[10] = activeSpotlightIndex;
        $[11] = concludeTour;
        $[12] = initiateTour;
        $[13] = lastActiveSpotlightIndex;
        $[14] = resetTour;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ step: step })=>{
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex }, { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour }] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const [messageType, _] = (0, $42omo.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $42omo.useCallback)(()=>{
        endTour();
    }, [
        endTour
    ]);
    const spotlights = $2347032a59a3f6fa$var$useSpotlights({
        end: concludeTour
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null,
        initiateTour: initiateTour,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex
    };
};
module.exports["MoreActionsObjectSidebarTourSteps"] = $2347032a59a3f6fa$export$6054829ec0b77d62;
module.exports["useMoreActionsObjectSidebarTour"] = $2347032a59a3f6fa$export$4ead2825721da9b4;

});

parcelRegister("dINOl", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $inPa6 = parcelRequire("inPa6");

const $732e88608cb14d24$export$f56d620db6064703 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onClose: onClose, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose || $[2] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "dismiss",
                    source: source
                }
            }).fire();
            onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = source;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $732e88608cb14d24$var$messages.dismiss);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: $732e88608cb14d24$var$_temp,
            appearance: "subtle",
            label: t2,
            onClick: handleClick
        });
        $[5] = handleClick;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClose: onClose, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: source
            }
        }).fire();
        onClose();
    }, [
        onClose,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }),
        appearance: "subtle",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $732e88608cb14d24$var$messages.dismiss),
        onClick: handleClick
    });
};
const $732e88608cb14d24$var$messages = (0, $aXWIB.defineMessages)({
    dismiss: {
        id: "object-sidebar-components.cross-icon-close-button.dismiss",
        defaultMessage: "Dismiss"
    }
});
function $732e88608cb14d24$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        ...iconProps,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    });
}
module.exports["CrossIconCloseButton"] = $732e88608cb14d24$export$f56d620db6064703;

});

parcelRegister("dm7Aa", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedDark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("eufiU", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedLight.9900190e.gif", import.meta.url).toString();

});

parcelRegister("4TcLf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2cb4928bb9fae204$var$initialState = {
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $2cb4928bb9fae204$var$Store = (0, $1P1Tu.createStore)({
    initialState: $2cb4928bb9fae204$var$initialState,
    actions: {
        goToStep: (nextStep)=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: nextStep
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState($2cb4928bb9fae204$var$initialState);
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $2cb4928bb9fae204$export$2488884e040ac8b3 = (0, $9zUhf.createHook)($2cb4928bb9fae204$var$Store);
const $2cb4928bb9fae204$export$66587c60bfe17f2b = (0, $9zUhf.createActionsHook)($2cb4928bb9fae204$var$Store);
module.exports["useMoreActionsObjectSidebarTourState"] = $2cb4928bb9fae204$export$2488884e040ac8b3;

});

parcelRegister("kSwrz", function(module, exports) {
var $c5d0a4f039ea82e6$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
module.exports["MessageType"] = $c5d0a4f039ea82e6$export$80edbf15fa61a4db;

});

parcelRegister("3eMfQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $4LDXE = parcelRequire("4LDXE");



const $35cdf415560d18a2$export$ecf6343598832c90 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ldI6_",
    name: "LazyContentToolsItem",
    loader: async ()=>(0, $9wGTI.fg)('confluence_link_item_append_trace_context') ? (await (parcelRequire("6Xcb3"))).ContentToolsItemWithRoutesContext : (await (parcelRequire("2FG2u"))).ContentToolsItem
});


const $35cdf415560d18a2$export$3de34eae48b0740b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uFc6G",
    name: "LazyContentToolsItemWithPlaceholder",
    loader: async ()=>(0, $9wGTI.fg)('confluence_link_item_append_trace_context') ? (await (parcelRequire("6Xcb3"))).ContentToolsItemWithRoutesContext : (await (parcelRequire("2FG2u"))).ContentToolsItem,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4LDXE.ContentToolsItemPlaceholder), null)
});
module.exports["LazyContentToolsItem"] = $35cdf415560d18a2$export$ecf6343598832c90;
module.exports["LazyContentToolsItemWithPlaceholder"] = $35cdf415560d18a2$export$3de34eae48b0740b;

});

parcelRegister("4LDXE", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $e6ba7f6f1ee193d5$export$4a15f2daa593cc3 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                height: "40px",
                display: "flex",
                width: "100%",
                padding: "var(--ds-space-100, 8px) var(--ds-space-250, 20px)",
                alignItems: "center",
                boxSizing: "border-box"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                height: "17px",
                width: "100%",
                backgroundColor: "var(--ds-skeleton, #0515240F)",
                borderRadius: "10%"
            }
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentToolsItemPlaceholder"] = $e6ba7f6f1ee193d5$export$4a15f2daa593cc3;

});

parcelRegister("6Xcb3", function(module, exports) {

let $5101b2f217706fda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5101b2f217706fda$var$load("bzc8Q"),
    $5101b2f217706fda$var$load("4TY0p")
]).then(()=>parcelRequire('ebxOW'));

});

parcelRegister("2FG2u", function(module, exports) {

let $1f20053440b39309$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f20053440b39309$var$load("bzc8Q").then(()=>parcelRequire('al4VD'));

});

parcelRegister("kPqqM", function(module, exports) {

var $SF9MR = parcelRequire("SF9MR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $56M4r = parcelRequire("56M4r");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $cf6nm = parcelRequire("cf6nm");


var $iCPvv = parcelRequire("iCPvv");


var $jMyy4 = parcelRequire("jMyy4");

const $3dca15cc31736255$export$f4601f3807dd9177 = ({ isDisabled: isDisabled, className: className, shortcut: shortcut, ...props })=>{
    const TooltipI18n = props.isStarred ? $3dca15cc31736255$var$i18n.Unstar : $3dca15cc31736255$var$i18n.Star;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iCPvv.SpaceStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            testId: "star-menu-item",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: className,
            isDisabled: isDisabled,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            onClick: toggleStar,
            iconAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: shortcut
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), TooltipI18n)));
};
const $3dca15cc31736255$export$e07e4133bf676bf6 = ({ spaceKey: spaceKey })=>{
    const { data: spaceFavouriteStatusData } = (0, $jMyy4.useQueryInterop)((0, $SF9MR.default), {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first'
    });
    const isStarred = spaceFavouriteStatusData?.space?.currentUser?.isFavourited || false;
    const spaceName = spaceFavouriteStatusData?.space?.name || spaceFavouriteStatusData?.space?.alias || spaceFavouriteStatusData?.space?.key || '';
    const spaceId = spaceFavouriteStatusData?.space?.id || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dca15cc31736255$export$f4601f3807dd9177, {
        isStarred: isStarred,
        spaceId: spaceId,
        spaceKey: spaceKey,
        spacing: "none",
        spaceName: spaceName,
        shortcut: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
        shouldShowFlags: true,
        analytics: {
            attributes: {
                isContentWrapper: true,
                spaceId: // as of now, SpaceStarMenuItemWithQuery is only called from object header overflow menu
                spaceId
            },
            source: 'SpaceStarMenuItemOverflowMenu'
        }
    });
};
const $3dca15cc31736255$var$i18n = (0, $aXWIB.defineMessages)({
    Star: {
        id: "action-buttons.space.star.menu.item",
        defaultMessage: "Star space"
    },
    Unstar: {
        id: "action-buttons.space.unstar.menu.item",
        defaultMessage: "Unstar space"
    }
});
module.exports["SpaceStarMenuItem"] = $3dca15cc31736255$export$f4601f3807dd9177;
module.exports["SpaceStarMenuItemWithQuery"] = $3dca15cc31736255$export$e07e4133bf676bf6;

});

parcelRegister("SF9MR", function(module, exports) {
/**
 * @generated SignedSource<<bbf694399b8e85cb4fa07b08aa2c2370>>
 * @relayHash 559bd430fdfdfbcc11a49c9267441232
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872
const $00b16c2e2c56a4ba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "559bd430fdfdfbcc11a49c9267441232",
            "id": "81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872",
            "metadata": {},
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "operationKind": "query",
            "text": "query SpaceStarMenuItemIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id,alias,name,key,currentUser{isFavourited}}}"
        }
    };
}();
$00b16c2e2c56a4ba$var$node.hash = "c77a49dbb962e7ad6bf61d5e4f25b221";
var $00b16c2e2c56a4ba$export$2e2bcd8739ae039 = $00b16c2e2c56a4ba$var$node;
module.exports["default"] = $00b16c2e2c56a4ba$export$2e2bcd8739ae039;

});

parcelRegister("iCPvv", function(module, exports) {

var $h4SYW = parcelRequire("h4SYW");


var $3rcpI = parcelRequire("3rcpI");


var $8DAzB = parcelRequire("8DAzB");


var $iWaZt = parcelRequire("iWaZt");


var $eUlFW = parcelRequire("eUlFW");


var $5j9jt = parcelRequire("5j9jt");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $cTJK3 = parcelRequire("cTJK3");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $308Wd = parcelRequire("308Wd");


var $cfidN = parcelRequire("cfidN");







const $ac59452c65a90798$var$i18n = (0, $aXWIB.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.space.star.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble starring this space"
    },
    unstarErrorTitle: {
        id: "action-buttons.space.unstar.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We're having trouble unstarring this space"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh and try again."
    },
    starSuccessFlagTitle: {
        id: "action-buttons.space.star.success.title",
        defaultMessage: "{spaceName} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.space.unstar.success.title",
        defaultMessage: "{spaceName} unstarred"
    }
});
const $ac59452c65a90798$var$SpaceStarComponent = ({ spaceId: spaceId, spaceKey: spaceKey, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, spaceName: spaceName, shouldShowFlags: shouldShowFlags })=>{
    const readCurrentSpace = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5j9jt.default)
    });
    const readStarredSpaces = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $eUlFW.default)
    });
    const writeUpdateCurrentUserFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $iWaZt.default),
        fragmentArtifact: (0, $iWaZt.default)
    });
    const writeStarredSpacesFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $8DAzB.default),
        fragmentArtifact: (0, $8DAzB.default)
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const modifyStarCache = (0, $42omo.useCallback)((newStarredValue)=>{
        try {
            // The (Un)FavoriteSpaceMutations do not return the updated space, so we need to manually update the cache.
            // This is necessary to update the UI immediately after the user clicks the star button.
            writeUpdateCurrentUserFragment({
                fragmentId: `Space:${spaceId}`,
                data: {
                    currentUser: {
                        isFavourited: newStarredValue,
                        __typename: 'SpaceUserMetadata'
                    },
                    __typename: 'Space'
                }
            });
            // Update the starred spaces list in the Spaces dropdown (and any other consumers of useSpacesData)
            (0, $cTJK3.updateStarredSpacesList)(spaceId, newStarredValue, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment);
        } catch  {}
    }, [
        spaceId,
        readCurrentSpace,
        readStarredSpaces,
        writeStarredSpacesFragment,
        writeUpdateCurrentUserFragment
    ]);
    const [starSpace, { error: starError }] = (0, $308Wd.useMutationInterop)((0, $3rcpI.default), {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(false);
        }
    });
    const [unstarSpace, { error: unstarError }] = (0, $308Wd.useMutationInterop)((0, $h4SYW.default), {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(true);
        }
    });
    const toggleStar = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) onUnstar && onUnstar(e);
        else onStar && onStar(e);
        // Optimistically update the cache
        modifyStarCache(!isStarred);
        const mutation = isStarred ? unstarSpace : starSpace;
        mutation({
            variables: {
                spaceKey: spaceKey
            }
        }).then(()=>{
            if (isStarred && shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
            else if (!isStarred && shouldShowFlags && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.starSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
        }).catch((_)=>{});
        if (analytics) {
            const { source: source, containerId: containerId, attributes: attributes } = analytics;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: isStarred ? 'unstarred' : 'starred',
                    actionSubject: 'space',
                    source: source,
                    attributes: attributes,
                    ...containerId && {
                        containerId: containerId
                    }
                }
            }).fire();
        }
    }, [
        isStarred,
        spaceKey,
        analytics,
        starSpace,
        unstarSpace,
        modifyStarCache,
        onStar,
        onUnstar,
        createAnalyticsEvent,
        flags,
        intl,
        spaceName,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.starErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $ac59452c65a90798$export$4e2eb132a04ae560 = (0, $7aRa9.withFlags)((0, $aXWIB.injectIntl)($ac59452c65a90798$var$SpaceStarComponent));
module.exports["SpaceStar"] = $ac59452c65a90798$export$4e2eb132a04ae560;

});

parcelRegister("h4SYW", function(module, exports) {
/**
 * @generated SignedSource<<1c9c243a57293b8445d24928c3b2eb3b>>
 * @relayHash 9713a87882c5e6383e438ee687952963
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495
const $1e902e1ae2e520ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "FavouriteSpacePayload",
            "kind": "LinkedField",
            "name": "unfavouriteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isSpaceFavourited"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9713a87882c5e6383e438ee687952963",
            "id": "24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495",
            "metadata": {},
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceStarUnfavoriteSpaceMutation($spaceKey:String!){unfavouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
        }
    };
}();
$1e902e1ae2e520ea$var$node.hash = "947f8794b11432ca2dea89537ba4c2d6";
var $1e902e1ae2e520ea$export$2e2bcd8739ae039 = $1e902e1ae2e520ea$var$node;
module.exports["default"] = $1e902e1ae2e520ea$export$2e2bcd8739ae039;

});

parcelRegister("3rcpI", function(module, exports) {
/**
 * @generated SignedSource<<a73bfd0c132bf1e3ab8b2ee74188086c>>
 * @relayHash 74b417d304c57976b899306f93428c4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647
const $55e292c0c31a2a67$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "FavouriteSpacePayload",
            "kind": "LinkedField",
            "name": "favouriteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isSpaceFavourited"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarFavoriteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarFavoriteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74b417d304c57976b899306f93428c4f",
            "id": "b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647",
            "metadata": {},
            "name": "SpaceStarFavoriteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceStarFavoriteSpaceMutation($spaceKey:String!){favouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
        }
    };
}();
$55e292c0c31a2a67$var$node.hash = "9ac5c6d950db28ef929151bfa7f1b419";
var $55e292c0c31a2a67$export$2e2bcd8739ae039 = $55e292c0c31a2a67$var$node;
module.exports["default"] = $55e292c0c31a2a67$export$2e2bcd8739ae039;

});

parcelRegister("8DAzB", function(module, exports) {
/**
 * @generated SignedSource<<c35bfe854b8f0f6806e0c8ea5aad30ed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $edf1f89db5626c55$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarWriteStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$edf1f89db5626c55$var$node.hash = "72f0ab1980fee3d3ebcdbd9647ddc161";
var $edf1f89db5626c55$export$2e2bcd8739ae039 = $edf1f89db5626c55$var$node;
module.exports["default"] = $edf1f89db5626c55$export$2e2bcd8739ae039;

});

parcelRegister("iWaZt", function(module, exports) {
/**
 * @generated SignedSource<<96b0d47a239a4453b03d10a247c9e028>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3dd5c0573ac0253a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarActionButtonSpaceFragment",
    "selections": [
        {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourited"
                }
            ]
        }
    ],
    "type": "Space"
};
$3dd5c0573ac0253a$var$node.hash = "8952ed3b4f2eb093d58223c1da19fdac";
var $3dd5c0573ac0253a$export$2e2bcd8739ae039 = $3dd5c0573ac0253a$var$node;
module.exports["default"] = $3dd5c0573ac0253a$export$2e2bcd8739ae039;

});

parcelRegister("eUlFW", function(module, exports) {
/**
 * @generated SignedSource<<ca5d03f66607b6c228d98140dc6e1389>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae9f5e7e7a9dde99$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarReadStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$ae9f5e7e7a9dde99$var$node.hash = "4a38c9f3868a7bbf44a9931e1d6903ac";
var $ae9f5e7e7a9dde99$export$2e2bcd8739ae039 = $ae9f5e7e7a9dde99$var$node;
module.exports["default"] = $ae9f5e7e7a9dde99$export$2e2bcd8739ae039;

});

parcelRegister("5j9jt", function(module, exports) {
/**
 * @generated SignedSource<<382b155baf2dd9717ad29b61d98587a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b485608b483d3bf6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarCurrentSpaceFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "alias"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ],
    "type": "Space"
};
$b485608b483d3bf6$var$node.hash = "0e7af2ea53ea33a3d76e321d036b891d";
var $b485608b483d3bf6$export$2e2bcd8739ae039 = $b485608b483d3bf6$var$node;
module.exports["default"] = $b485608b483d3bf6$export$2e2bcd8739ae039;

});

parcelRegister("cTJK3", function(module, exports) {
const $a85b49bec4fd02db$export$1c070079c48d3bdd = (spaceId, isStarred, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment)=>{
    const space = readCurrentSpace({
        id: `Space:${spaceId}`
    });
    try {
        const starredSpaces = readStarredSpaces({
            id: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`
        })?.nodes || [];
        let newStarredSpaces;
        if (isStarred) {
            newStarredSpaces = [
                ...starredSpaces,
                space
            ];
            newStarredSpaces.sort((a, b)=>!a?.name || !b?.name ? 0 : a.name.localeCompare(b.name));
        } else newStarredSpaces = starredSpaces.filter((s)=>s?.id !== spaceId);
        writeStarredSpacesFragment({
            fragmentId: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`,
            data: {
                nodes: newStarredSpaces,
                __typename: 'PaginatedSpaceList'
            }
        });
    } catch  {
    // If Apollo throws an error, the starred spaces data was not found in the cache.
    // Errors can be safely ignored as if there is no cache entry, there is no work to be done.
    }
};
module.exports["updateStarredSpacesList"] = $a85b49bec4fd02db$export$1c070079c48d3bdd;

});

parcelRegister("d8J72", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bYLFm = parcelRequire("bYLFm");


var $gjbSq = parcelRequire("gjbSq");


var $b3j2Y = parcelRequire("b3j2Y");


var $3eMfQ = parcelRequire("3eMfQ");

const $6f5c98e13f07416a$export$dc453ea17a7d7b53 = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    let contentId;
    let dialogs;
    let onClick;
    let props;
    let sectionItem;
    let shouldHighlight;
    let spaceKey;
    if ($[0] !== t0) {
        ({ sectionItem: sectionItem, contentId: contentId, spaceKey: spaceKey, dialogs: dialogs, shouldHighlight: shouldHighlight, onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = dialogs;
        $[3] = onClick;
        $[4] = props;
        $[5] = sectionItem;
        $[6] = shouldHighlight;
        $[7] = spaceKey;
    } else {
        contentId = $[1];
        dialogs = $[2];
        onClick = $[3];
        props = $[4];
        sectionItem = $[5];
        shouldHighlight = $[6];
        spaceKey = $[7];
    }
    let t1;
    if ($[8] !== contentId || $[9] !== spaceKey) {
        t1 = {
            contentId: contentId,
            spaceKey: spaceKey
        };
        $[8] = contentId;
        $[9] = spaceKey;
        $[10] = t1;
    } else t1 = $[10];
    const { canConvertPageToFolder: canConvertPageToFolder, contentTitle: contentTitle, error: error } = (0, $gjbSq.useCanConvertPageToFolder)(t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[11] !== contentId || $[12] !== contentTitle || $[13] !== createAnalyticsEvent || $[14] !== dialogs || $[15] !== onClick || $[16] !== spaceKey) {
        t2 = (e)=>{
            onClick?.(e);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "convertPageToFolder",
                    source: "contentToolsItem"
                }
            }).fire();
            dialogs.showDialog((0, $bYLFm.ConvertPageToFolderDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentTitle: contentTitle
            });
        };
        $[11] = contentId;
        $[12] = contentTitle;
        $[13] = createAnalyticsEvent;
        $[14] = dialogs;
        $[15] = onClick;
        $[16] = spaceKey;
        $[17] = t2;
    } else t2 = $[17];
    const openDialog = t2;
    if (!canConvertPageToFolder) {
        let t3;
        if ($[18] !== error) {
            t3 = error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }) : null;
            $[18] = error;
            $[19] = t3;
        } else t3 = $[19];
        return t3;
    }
    let t3;
    if ($[20] !== error) {
        t3 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[20] = error;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== openDialog || $[23] !== props || $[24] !== sectionItem || $[25] !== shouldHighlight) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMfQ.LazyContentToolsItem), {
            key: sectionItem.completeKey,
            ...sectionItem,
            url: "",
            ...props,
            onClick: openDialog,
            shouldHighlight: shouldHighlight
        });
        $[22] = openDialog;
        $[23] = props;
        $[24] = sectionItem;
        $[25] = shouldHighlight;
        $[26] = t4;
    } else t4 = $[26];
    let t5;
    if ($[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4);
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
};
module.exports["ConvertToFolderItem"] = $6f5c98e13f07416a$export$dc453ea17a7d7b53;

});

parcelRegister("bYLFm", function(module, exports) {

var $WfKBt = parcelRequire("WfKBt");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $aoVih = parcelRequire("aoVih");


var $ccHMk = parcelRequire("ccHMk");


var $hArLp = parcelRequire("hArLp");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $dPJCf = parcelRequire("dPJCf");


var $67Foi = parcelRequire("67Foi");


var $1NBp8 = parcelRequire("1NBp8");


var $cb6fO = parcelRequire("cb6fO");


var $b3j2Y = parcelRequire("b3j2Y");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");


var $laFNM = parcelRequire("laFNM");


var $308Wd = parcelRequire("308Wd");

const $ad7bf5a97d16ed21$var$COMPONENT_NAME = 'ConvertPageToFolderDialogModal';
const $ad7bf5a97d16ed21$var$source = 'VIEW_PAGE';
const $ad7bf5a97d16ed21$var$warningMessageStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $ad7bf5a97d16ed21$export$de0fa8bd80a55013 = 241;
const $ad7bf5a97d16ed21$var$ConvertPageToFolderDialogComponent = ({ spaceKey: spaceKey, contentId: contentId, contentTitle: contentTitle, onClose: onClose, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const hasApprovalReview = Boolean(approvalRequest?.review);
    const [isConverting, setIsConverting] = (0, $42omo.useState)(false);
    const [convertPageToFolderMutation, { error: convertPageToFolderError }] = (0, $308Wd.useMutationInterop)((0, $WfKBt.default));
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}CancelButton`,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const convertPageToFolderSuccess = (data)=>{
        setIsConverting(false);
        experienceTracker.succeed({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE)
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                action: 'success',
                attributes: undefined,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        flags.showFlag({
            type: 'success-circle',
            title: formatMessage($ad7bf5a97d16ed21$var$i18n.successFlagTitle),
            description: formatMessage($ad7bf5a97d16ed21$var$i18n.successFlagDescription),
            close: 'auto'
        });
        const contentId = data?.data?.convertToFolder?.content?.id;
        if (contentId) {
            const newlyCreatedFolderUrl = (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                ...(0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false) && {
                    contentSlug: (0, $cb6fO.generateSlug)(contentTitle)
                }
            });
            newlyCreatedFolderUrl && push(newlyCreatedFolderUrl);
        }
        onClose();
    };
    const showErrorFlag = ({ title: title, description: description, actions: actions })=>{
        flags.showFlag({
            type: 'error',
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };
    const abortExperienceOnExpectedError = (error)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
        experienceTracker.abort({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE),
            reason: 'Expected Apollo error'
        });
    };
    const convertPageToFolderFailure = (error)=>{
        if ($ad7bf5a97d16ed21$var$isPageEditRestrictedError(error)) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.editPermissionErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.editPermissionErrorFlagDescription)
            });
            abortExperienceOnExpectedError(error);
        } else if ($ad7bf5a97d16ed21$var$isNameCollisionError(error)) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.nameCollisionErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.nameCollisionErrorFlagDescription)
            });
            abortExperienceOnExpectedError(error);
        } else if ($ad7bf5a97d16ed21$var$isNameLengthLimitError(error) && contentTitle) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.nameLengthLimitErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.nameLengthLimitErrorFlagDescription, {
                    numCharsOverLimit: contentTitle.length - $ad7bf5a97d16ed21$export$de0fa8bd80a55013
                })
            });
            abortExperienceOnExpectedError(error);
        } else {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagDescription),
                actions: [
                    {
                        content: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagAction),
                        onClick: handlePageToFolderConversion
                    }
                ]
            });
            if ((0, $95rLf.isExpectedApolloError)(error)) {
                abortExperienceOnExpectedError(error);
                return;
            }
            (0, $fGzMp.stopExperienceOnError)((0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE), error);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                    action: 'failed',
                    attributes: {
                        error: error
                    },
                    actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}ConvertButton`,
                    source: $ad7bf5a97d16ed21$var$source
                }
            }).fire();
        }
    };
    const handlePageToFolderConversion = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}ConvertButton`,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        setIsConverting(true);
        experienceTracker.start({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE)
        });
        convertPageToFolderMutation({
            variables: {
                id: contentId
            }
        }).then((data)=>{
            convertPageToFolderSuccess(data);
        }).catch((error)=>{
            convertPageToFolderFailure(error);
            setIsConverting(false);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        width: "450px",
        key: "ConvertPageToFolderDialog",
        onClose: handleOnClose,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100"
    }, isPremium && hasApprovalReview && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ad7bf5a97d16ed21$var$warningMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.approvalsWarning))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleOnClose,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handlePageToFolderConversion,
        appearance: "primary",
        isLoading: isConverting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogSubmitText)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
        name: "convertPageToFolderDialogModalScreen",
        id: "convertPageToFolderModalScreenEvent"
    }), convertPageToFolderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: convertPageToFolderError
    }));
};
const $ad7bf5a97d16ed21$var$ConvertPageToFolderDialogWithFlags = (0, $7aRa9.withFlags)($ad7bf5a97d16ed21$var$ConvertPageToFolderDialogComponent);
const $ad7bf5a97d16ed21$export$ae121ae5418ce48b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $laFNM.ApprovalsProvider), {
        contentId: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ad7bf5a97d16ed21$var$ConvertPageToFolderDialogWithFlags, props));
const $ad7bf5a97d16ed21$var$isPageEditRestrictedError = (error)=>error.message.includes('User does not have permissions to perform this action');
const $ad7bf5a97d16ed21$var$isNameCollisionError = (error)=>error.message.includes('A folder exists with the same title in this space');
const $ad7bf5a97d16ed21$var$isNameLengthLimitError = (error)=>error.message.includes('Title cannot be longer than 255 characters');
const $ad7bf5a97d16ed21$var$i18n = (0, $aXWIB.defineMessages)({
    dialogHeader: {
        id: "folder-conversion.convert-page-to-folder.dialog.header",
        defaultMessage: "Convert this page into a folder?"
    },
    dialogDescription: {
        id: "folder-conversion.convert-page-to-folder.dialog.description",
        defaultMessage: "We\u2019ll archive the original page, so you don\u2019t need to worry about losing your work."
    },
    cancel: {
        id: "folder-conversion.convert-page-to-folder.dialog.cancel",
        defaultMessage: "Cancel"
    },
    dialogSubmitText: {
        id: "folder-conversion.convert-page-to-folder.dialog.submit",
        defaultMessage: "Convert"
    },
    approvalsWarning: {
        id: "folder-conversion.convert-page-to-folder.dialog.approvalsWarning.non-final",
        defaultMessage: "This will end an approval."
    },
    successFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.success-message.title",
        defaultMessage: "Conversion complete"
    },
    successFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.success-message.description.placeholder-title",
        defaultMessage: "We\u2019ve finished converting the page to a folder."
    },
    defaultErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.title",
        defaultMessage: "We couldn\u2019t convert the page to a folder"
    },
    defaultErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.description.placeholder-title",
        defaultMessage: "Something went wrong, and we were unable to convert this page to a folder."
    },
    defaultErrorFlagAction: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.action",
        defaultMessage: "Try again"
    },
    editPermissionErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.title",
        defaultMessage: "Request edit and archive access to continue"
    },
    editPermissionErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.description",
        defaultMessage: "To convert this page to a folder, you\u2019ll need permission to edit and archive it."
    },
    nameCollisionErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.title",
        defaultMessage: "Rename this page to continue"
    },
    nameCollisionErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.description",
        defaultMessage: "To avoid duplicate titles, you\u2019ll need to rename this page before we can convert it to a folder and archive the original."
    },
    nameLengthLimitErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.title",
        defaultMessage: "Give this page a shorter title"
    },
    nameLengthLimitErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.description",
        defaultMessage: "Before we can convert this page to a folder, archiving the original, you\u2019ll need to give it a title that is at least {numCharsOverLimit, plural, one {# character} other {# characters}} shorter."
    }
});
module.exports["ConvertPageToFolderDialog"] = $ad7bf5a97d16ed21$export$ae121ae5418ce48b;

});

parcelRegister("WfKBt", function(module, exports) {
/**
 * @generated SignedSource<<6098bcfb3084a477a96c38fe3f9a632e>>
 * @relayHash 4eea0357b0c46bdca044a6b3b9b301ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2
const $c938044c857e7ec1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceConvertContentToFolderPayload",
            "kind": "LinkedField",
            "name": "convertToFolder",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4eea0357b0c46bdca044a6b3b9b301ec",
            "id": "c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2",
            "metadata": {},
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "operationKind": "mutation",
            "text": "mutation ConvertPageToFolderDialogConvertPageToFolderMutation($id:ID!){convertToFolder(id:$id){content{id}}}"
        }
    };
}();
$c938044c857e7ec1$var$node.hash = "9e061c22a3f4cc67b35d81eed7b18a16";
var $c938044c857e7ec1$export$2e2bcd8739ae039 = $c938044c857e7ec1$var$node;
module.exports["default"] = $c938044c857e7ec1$export$2e2bcd8739ae039;

});

parcelRegister("gjbSq", function(module, exports) {

var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $3jwuS = parcelRequire("3jwuS");


var $gEtAQ = parcelRequire("gEtAQ");


var $cEgMD = parcelRequire("cEgMD");


var $jr6cv = parcelRequire("jr6cv");


var $jMyy4 = parcelRequire("jMyy4");

const $8906a897a8abc933$export$cf0b322c7c05f5e9 = 'action-convert-page-to-folder';
const $8906a897a8abc933$export$9009d9583737dc08 = ({ contentId: contentId, spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $jr6cv.default), {
        skip: Boolean(skipQuery) || // Company Hub hides its space from the user, is rather presented to the user as "a new surface", not a page so converting it to a folder wouldn't make sense.
        // Additionally, if this query were to execute, it would break the Company Hub history/version preview, because it doesn't respect the versionOverride query parameter.
        (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey
        }
    });
    const isViewPageRoute = (0, $gEtAQ.isViewPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isPage = data?.singleContent?.type === 'page';
    const isFoldersEnabledForSpace = data?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled;
    const isPublished = data?.singleContent?.status === 'current';
    let canEdit = false;
    let canArchive = false; // need to check archive permission since page is archived as a part of conversion
    data?.singleContent?.operations?.forEach((operationCheckResult)=>{
        if (operationCheckResult?.targetType === 'page') {
            if (operationCheckResult?.operation === 'update') canEdit = true;
            else if (operationCheckResult?.operation === 'archive') canArchive = true;
        }
    });
    const canConvertPageToFolder = Boolean(isViewPageRoute && !isLivePage && isPage && isFoldersEnabledForSpace && isPublished && canEdit && canArchive);
    if ((0, $95rLf.isExpectedApolloError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const contentTitle = data?.singleContent?.title;
    const hasLoaded = $8906a897a8abc933$export$d5c654a6fe10b3c1(Boolean(skipQuery), Boolean(data), Boolean(error), loading);
    return {
        canConvertPageToFolder: canConvertPageToFolder,
        contentTitle: contentTitle,
        loading: loading,
        error: error,
        hasLoaded: hasLoaded
    };
};
const $8906a897a8abc933$export$d5c654a6fe10b3c1 = (skip, hasData, hasError, loading)=>{
    return skip || (hasData || hasError) && !loading;
};
module.exports["CONVERT_PAGE_TO_FOLDER_WEBITEM_ID"] = $8906a897a8abc933$export$cf0b322c7c05f5e9;
module.exports["useCanConvertPageToFolder"] = $8906a897a8abc933$export$9009d9583737dc08;

});

parcelRegister("jr6cv", function(module, exports) {
/**
 * @generated SignedSource<<b6116e9d942f296a4144ecc1dd0bc1dc>>
 * @relayHash 48a9429ef50ceb1df349c422f817239b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d4b264a2064bf474a2da6e6304f03e630787bd8c8a1da86bbb0fe266d4ae062
const $98dc97ed41815985$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertPageToFolderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertPageToFolderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "48a9429ef50ceb1df349c422f817239b",
            "id": "9d4b264a2064bf474a2da6e6304f03e630787bd8c8a1da86bbb0fe266d4ae062",
            "metadata": {},
            "name": "ConvertPageToFolderQuery",
            "operationKind": "query",
            "text": "query ConvertPageToFolderQuery($contentId:ID!,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled}}},singleContent(id:$contentId){id,title,type,status,operations{operation,targetType}}}"
        }
    };
}();
$98dc97ed41815985$var$node.hash = "ed0995bcdb62a84d190715c954ff6018";
var $98dc97ed41815985$export$2e2bcd8739ae039 = $98dc97ed41815985$var$node;
module.exports["default"] = $98dc97ed41815985$export$2e2bcd8739ae039;

});

parcelRegister("k9WFY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $77aec7b4d93beceb$export$c4e96d849cdd6a3d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g6cZS",
    name: "PublishPageAsBlogDialog",
    loader: async ()=>(await (parcelRequire("6IRBy"))).PublishPageAsBlogDialog
});
module.exports["PublishPageAsBlogDialog"] = $77aec7b4d93beceb$export$c4e96d849cdd6a3d;

});

parcelRegister("6IRBy", function(module, exports) {

let $4e506eeba22fecc7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e506eeba22fecc7$var$load("6HLQW"),
    $4e506eeba22fecc7$var$load("dtpmo"),
    $4e506eeba22fecc7$var$load("5zDuS"),
    $4e506eeba22fecc7$var$load("hhss7"),
    $4e506eeba22fecc7$var$load("fJjZJ")
]).then(()=>parcelRequire('8d4o6'));

});

parcelRegister("5G6sa", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $f44739e864265bc9$var$ContentHistoryStore = (0, $1P1Tu.createStore)({
    initialState: {
        wasTransitionedFromEditor: false
    },
    actions: {
        setWasTransitionedFromEditor: (wasTransitionedFromEditor)=>({ setState: setState })=>{
                setState({
                    wasTransitionedFromEditor: wasTransitionedFromEditor
                });
            }
    },
    name: 'newContentHistoryState'
});
const $f44739e864265bc9$export$90587b2a92cba8d5 = (0, $9zUhf.createStateHook)($f44739e864265bc9$var$ContentHistoryStore);
const $f44739e864265bc9$export$9b1a939bc5c5d3b = (0, $9zUhf.createActionsHook)($f44739e864265bc9$var$ContentHistoryStore);
module.exports["useNewContentHistoryState"] = $f44739e864265bc9$export$90587b2a92cba8d5;
module.exports["useNewContentHistoryActions"] = $f44739e864265bc9$export$9b1a939bc5c5d3b;

});

parcelRegister("dE3yd", function(module, exports) {

var $lvvx5 = parcelRequire("lvvx5");

var $cFEpk = parcelRequire("cFEpk");

const $49d42e0354c3a49f$export$29f82b09627f4ff0 = (timestamp)=>{
    if (!timestamp || timestamp.trim() === '') return false;
    const timestampDate = new Date(timestamp);
    if (!(0, $cFEpk.default)(timestampDate)) return false;
    return (0, $lvvx5.default)(new Date(), timestampDate) < 1;
};
module.exports["isWithinLastWeek"] = $49d42e0354c3a49f$export$29f82b09627f4ff0;

});

parcelRegister("hwWwS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9b64448510e1eff4$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $42omo.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};
module.exports["useCoordination"] = $9b64448510e1eff4$export$3c29cca421979b0e;

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("lGoD9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aFUXX = parcelRequire("aFUXX");


var $3ertP = parcelRequire("3ertP");


var $fm4ja = parcelRequire("fm4ja");


var $ijP1H = parcelRequire("ijP1H");


var $3Jily = parcelRequire("3Jily");

const $104d1307b2dc4ae9$export$d34fb9a28e944197 = ({ api: api, config: config })=>{
    // Register the native embed transformers with the card plugin so that
    // embedCard nodes are automatically converted to native embed extensions
    // during URL resolution and appearance switching.
    api?.card?.actions?.registerEmbedCardTransformer({
        embedCardNodeTransformer: (0, $3ertP.cardToNativeEmbedNode),
        createEmbedCardTransformCommand: (0, $3ertP.createCardToNativeEmbedTransform)
    });
    // Register the native embed transformer with the AI plugin so that
    // inserted content nodes can be automatically converted to native embed
    // extensions during AI content insertion.
    api?.aiExperience?.actions?.registerInsertedContentNodeTransformer?.((0, $3ertP.insertedContentToNativeEmbedNode));
    return {
        name: 'editorPluginNativeEmbeds',
        actions: {
            cardToNativeEmbedNode: (0, $3ertP.cardToNativeEmbedNode),
            createCardToNativeEmbedTransform: (0, $3ertP.createCardToNativeEmbedTransform)
        },
        pmPlugins () {
            const analyticsApi = api?.analytics?.actions;
            return [
                {
                    name: 'nativeEmbedsPluginState',
                    plugin: ()=>(0, $fm4ja.createPlugin)(analyticsApi)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pmState = (0, $fm4ja.pluginKey).getState(editorState);
            if (!pmState) return undefined;
            return {
                width: pmState.resizingWidth || (0, $aFUXX.akEditorDefaultLayoutWidth),
                isResizing: pmState.isResizing,
                selectedEmbed: pmState.selectedEmbed
            };
        },
        contentComponent (params) {
            if (!params.editorView) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3Jily.ResizableNativeEmbed), {
                disabled: params.disabled,
                editorView: params.editorView,
                pluginInjectionApi: api,
                appearance: params.appearance,
                containerElement: params.containerElement,
                editorActions: params.editorActions,
                eventDispatcher: params.eventDispatcher,
                popupsMountPoint: params.popupsMountPoint,
                providerFactory: params.providerFactory,
                wrapperElement: params.wrapperElement
            });
        },
        pluginsOptions: {
            floatingToolbar: (0, $ijP1H.getToolbarConfig)({
                api: api,
                linkPickerOptions: config?.linkPickerOptions,
                lpLinkPicker: config?.lpLinkPicker
            })
        }
    };
};
module.exports["nativeEmbedsPlugin"] = $104d1307b2dc4ae9$export$d34fb9a28e944197;

});

parcelRegister("3ertP", function(module, exports) {

var $81OAa = parcelRequire("81OAa");


var $d925B = parcelRequire("d925B");


var $3jQ9y = parcelRequire("3jQ9y");


var $6tl2G = parcelRequire("6tl2G");


var $ks2lK = parcelRequire("ks2lK");


var $6qvTD = parcelRequire("6qvTD");

var $8Yt3t = parcelRequire("8Yt3t");


var $aeAfU = parcelRequire("aeAfU");


var $9I1d6 = parcelRequire("9I1d6");

const $02027a547328b08e$var$LAYOUT_TO_ALIGNMENT = {
    center: 'center',
    'full-width': 'center',
    wide: 'center',
    'wrap-left': 'wrap-left',
    'wrap-right': 'wrap-right',
    'align-start': 'left',
    'align-end': 'right'
};
function $02027a547328b08e$var$mapLayoutToAlignment(layout = 'center') {
    return $02027a547328b08e$var$LAYOUT_TO_ALIGNMENT[layout] ?? 'center';
}
function $02027a547328b08e$export$f7e09b33c87279a2(schema, attrs) {
    if (!(0, $aeAfU.expVal)('cc-maui-experiment', 'isEnabled', false)) return undefined;
    const { url: url, layout: layout = 'center', width: width, originalHeight: originalHeight, originalWidth: originalWidth } = attrs;
    if (!(0, $81OAa.isSafeUrl)(url)) return undefined;
    const manifest = (0, $9I1d6.getNativeEmbedFacade)().getManifestByUrl(url);
    if (!manifest) return undefined;
    const macroParams = (0, $8Yt3t.setParameters)({}, {
        ...(0, $6qvTD.NATIVE_EMBED_PARAMETER_DEFAULTS),
        url: url,
        alignment: $02027a547328b08e$var$mapLayoutToAlignment(layout),
        width: originalWidth ?? width ?? undefined,
        height: originalHeight ?? undefined
    });
    const extensionAdf = {
        type: 'extension',
        attrs: {
            extensionKey: `${(0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY)}:${manifest.id}`,
            extensionType: (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE),
            parameters: {
                ...macroParams,
                macroMetadata: {
                    url: // Preserved data in case of revert.
                    url,
                    layout: layout,
                    width: width ?? undefined,
                    originalHeight: originalHeight ?? undefined,
                    originalWidth: originalWidth ?? undefined
                }
            }
        }
    };
    return (0, $6tl2G.processRawValue)(schema, extensionAdf);
}
function $02027a547328b08e$export$a3e392087da04055(schema, node) {
    if (node.type === schema.nodes.embedCard) return $02027a547328b08e$export$f7e09b33c87279a2(schema, {
        url: node.attrs.url,
        layout: node.attrs.layout,
        width: node.attrs.width,
        originalHeight: node.attrs.originalHeight,
        originalWidth: node.attrs.originalWidth
    });
    if (node.type === schema.nodes.paragraph && node.childCount === 1 && node.firstChild?.isText && node.firstChild.marks.length) {
        const linkMarkType = schema.marks.link;
        const linkMark = linkMarkType ? node.firstChild.marks.find((mark)=>mark.type === linkMarkType) : undefined;
        const url = linkMark?.attrs.href;
        if (url) return $02027a547328b08e$export$f7e09b33c87279a2(schema, {
            url: url,
            layout: 'center',
            width: undefined
        });
    }
    return undefined;
}
function $02027a547328b08e$var$appearanceForNodeType(schema, nodeType) {
    if (nodeType === schema.nodes.inlineCard) return 'inline';
    if (nodeType === schema.nodes.blockCard) return 'block';
    if (nodeType === schema.nodes.embedCard) return 'embed';
    return 'url';
}
function $02027a547328b08e$export$182f08fa3d19e14d(options) {
    if (!(0, $aeAfU.expVal)('cc-maui-experiment', 'isEnabled', false)) return ()=>false;
    const { augmentTransaction: augmentTransaction, editorAnalyticsApi: editorAnalyticsApi } = options ?? {};
    return (state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) return false;
        const url = selectedNode.attrs.url ?? selectedNode.attrs.data?.url;
        if (!url) return false;
        const previousType = $02027a547328b08e$var$appearanceForNodeType(state.schema, selectedNode.type);
        const embedAttrs = {
            url: url,
            layout: selectedNode.attrs.layout ?? 'center',
            width: selectedNode.attrs.width ?? (0, $6qvTD.NATIVE_EMBED_PARAMETER_DEFAULTS).width,
            originalHeight: selectedNode.attrs.originalHeight ?? (0, $6qvTD.NATIVE_EMBED_PARAMETER_DEFAULTS).height,
            originalWidth: selectedNode.attrs.originalWidth ?? (0, $6qvTD.NATIVE_EMBED_PARAMETER_DEFAULTS).width
        };
        const extensionNode = $02027a547328b08e$export$f7e09b33c87279a2(state.schema, embedAttrs);
        if (!extensionNode) return false;
        const { from: from, to: to } = state.selection;
        const tr = state.tr.replaceWith(from, to, extensionNode);
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        augmentTransaction?.(tr, state);
        if (dispatch) {
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_TYPE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    newType: 'nativeEmbed',
                    previousType: previousType
                }
            })(tr);
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
module.exports["cardToNativeEmbedNode"] = $02027a547328b08e$export$f7e09b33c87279a2;
module.exports["insertedContentToNativeEmbedNode"] = $02027a547328b08e$export$a3e392087da04055;
module.exports["createCardToNativeEmbedTransform"] = $02027a547328b08e$export$182f08fa3d19e14d;

});

parcelRegister("fm4ja", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $doRn8 = parcelRequire("doRn8");


var $3jQ9y = parcelRequire("3jQ9y");


var $6fQl1 = parcelRequire("6fQl1");


var $1S4f7 = parcelRequire("1S4f7");


var $kTbzR = parcelRequire("kTbzR");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $8Yt3t = parcelRequire("8Yt3t");


var $i12w8 = parcelRequire("i12w8");

const $217026bcd07aedee$var$getInsertionMethod = (transactions)=>{
    for (const transaction of transactions){
        const { inputMethod: inputMethod } = (0, $doRn8.getLinkMetadataFromTransaction)(transaction);
        if (inputMethod) return inputMethod;
    }
    return (0, $d925B.INPUT_METHOD).MANUAL;
};
const $217026bcd07aedee$export$68fc950519fc9e9f = 'nativeEmbedsPlugin.isResizing';
const $217026bcd07aedee$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('nativeEmbedsPlugin');
/**
 * Walks the document to find all native embed extension nodes and syncs
 * the `data-native-embed-nested` attribute on their DOM `.extension-container`
 * element. This ensures the attribute stays correct after drag-and-drop moves
 * an embed into or out of a nested container.
 *
 * Deferred to a requestAnimationFrame so that the DOM has been fully rebuilt
 * by ProseMirror before we attempt to locate elements.
 */ let $217026bcd07aedee$var$syncRAFHandle = null;
const $217026bcd07aedee$var$syncNativeEmbedNestedAttributes = (view)=>{
    if ($217026bcd07aedee$var$syncRAFHandle !== null) cancelAnimationFrame($217026bcd07aedee$var$syncRAFHandle);
    $217026bcd07aedee$var$syncRAFHandle = requestAnimationFrame(()=>{
        $217026bcd07aedee$var$syncRAFHandle = null;
        if (view.isDestroyed) return;
        const { state: state } = view;
        state.doc.descendants((node, pos)=>{
            if (!(0, $i12w8.isNativeEmbedNode)(node)) return true; // continue traversal
            try {
                // Use view.nodeDOM to get the actual node's DOM element, bypassing
                // decorations (like gap cursors) that share the same position.
                const rawDom = view.nodeDOM(pos);
                const element = rawDom instanceof HTMLElement ? rawDom : rawDom instanceof Node ? rawDom.parentElement : null;
                if (!element) return false;
                const container = element.querySelector('.extension-container') ?? element.closest('.extension-container') ?? element;
                if ((0, $6fQl1.getNestedParentNode)(pos, state) !== null) container.setAttribute('data-native-embed-nested', '');
                else container.removeAttribute('data-native-embed-nested');
            } catch  {
            // DOM may not be available for this position yet — skip
            }
            return false; // no need to descend into extension node
        });
    });
};
const $217026bcd07aedee$export$ae829ec7b2625219 = (editorAnalyticsApi)=>new (0, $1S4f7.SafePlugin)({
        key: $217026bcd07aedee$export$18d4026d1ea86bb1,
        props: {
            handleDOMEvents: {
                // Handle click-inside events dispatched by the native embed iframe
                // extension component. We create a proper ProseMirror NodeSelection
                // so that keyboard interactions (Delete, Backspace) work as expected.
                'native-embed-click-inside': (view, event)=>{
                    const target = event.target;
                    if (!(target instanceof HTMLElement)) return false;
                    // Walk up the DOM from the event target to find the node view
                    // wrapper element (identified by the extensionView-content-wrap
                    // class added by ReactNodeView). This element has a pmViewDesc
                    // that ProseMirror can resolve to a document position.
                    let nodeViewDom = target;
                    while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
                    if (!nodeViewDom || nodeViewDom === view.dom) return false;
                    try {
                        const pos = view.posAtDOM(nodeViewDom, 0);
                        const $pos = view.state.doc.resolve(pos);
                        // For atom nodes (like extension), posAtDOM on the node
                        // view wrapper resolves to the position of the node.
                        // Check nodeAfter at this position.
                        const nodeAfter = $pos.nodeAfter;
                        if (nodeAfter && nodeAfter.type.name === 'extension' && nodeAfter.attrs?.extensionType === (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE) && nodeAfter.attrs?.extensionKey?.includes((0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY))) {
                            const tr = view.state.tr.setSelection((0, $ks2lK.NodeSelection).create(view.state.doc, pos));
                            view.dispatch(tr);
                            if (event.detail?.shouldFocus !== false) view.focus();
                            return true;
                        }
                        // Fallback: walk up the ancestor chain in case the position
                        // resolved inside a wrapper node.
                        for(let d = $pos.depth; d >= 0; d--){
                            const node = $pos.node(d);
                            if (node.type.name === 'extension' && node.attrs?.extensionType === (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY))) {
                                const nodePos = $pos.before(d);
                                const tr = view.state.tr.setSelection((0, $ks2lK.NodeSelection).create(view.state.doc, nodePos));
                                view.dispatch(tr);
                                if (event.detail?.shouldFocus !== false) view.focus();
                                return true;
                            }
                        }
                    } catch  {
                    // posAtDOM can throw if the DOM element is not within the editor
                    }
                    return false;
                },
                'native-embed-request-resize': (view, event)=>{
                    const detail = event.detail;
                    const newWidth = typeof detail?.width === 'number' ? detail.width : undefined;
                    const newHeight = typeof detail?.height === 'number' ? detail.height : undefined;
                    const target = event.target;
                    if (!(target instanceof HTMLElement) || newWidth === undefined && newHeight === undefined) return false;
                    let nodeViewDom = target;
                    while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
                    if (!nodeViewDom || nodeViewDom === view.dom) return false;
                    const buildUpdatedParams = (params)=>{
                        let updated = params ?? {};
                        if (newWidth !== undefined) updated = (0, $8Yt3t.setParameter)(updated, {
                            width: newWidth
                        });
                        if (newHeight !== undefined) updated = (0, $8Yt3t.setParameter)(updated, {
                            height: newHeight
                        });
                        return updated;
                    };
                    try {
                        const pos = view.posAtDOM(nodeViewDom, 0);
                        const $pos = view.state.doc.resolve(pos);
                        const nodeAfter = $pos.nodeAfter;
                        if (nodeAfter && nodeAfter.type.name === 'extension' && nodeAfter.attrs?.extensionType === (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE) && nodeAfter.attrs?.extensionKey?.includes((0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY))) {
                            const updatedParams = buildUpdatedParams(nodeAfter.attrs.parameters);
                            const tr = view.state.tr.setNodeMarkup(pos, undefined, {
                                ...nodeAfter.attrs,
                                parameters: updatedParams
                            });
                            view.dispatch(tr);
                            return true;
                        }
                        for(let d = $pos.depth; d >= 0; d--){
                            const node = $pos.node(d);
                            if (node.type.name === 'extension' && node.attrs?.extensionType === (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY))) {
                                const nodePos = $pos.before(d);
                                const updatedParams = buildUpdatedParams(node.attrs.parameters);
                                const tr = view.state.tr.setNodeMarkup(nodePos, undefined, {
                                    ...node.attrs,
                                    parameters: updatedParams
                                });
                                view.dispatch(tr);
                                return true;
                            }
                        }
                    } catch  {
                    // posAtDOM can throw if the DOM element is not within the editor
                    }
                    return false;
                }
            }
        },
        view: (editorView)=>{
            // Run an initial sync so embeds that are already nested when the
            // editor first mounts get the correct attribute immediately.
            $217026bcd07aedee$var$syncNativeEmbedNestedAttributes(editorView);
            return {
                update: (view, prevState)=>{
                    if (prevState.doc !== view.state.doc) $217026bcd07aedee$var$syncNativeEmbedNestedAttributes(view);
                },
                destroy: ()=>{
                    if ($217026bcd07aedee$var$syncRAFHandle !== null) {
                        cancelAnimationFrame($217026bcd07aedee$var$syncRAFHandle);
                        $217026bcd07aedee$var$syncRAFHandle = null;
                    }
                }
            };
        },
        state: {
            init: ()=>({
                    isResizing: false,
                    selectedEmbed: null,
                    showUrlToolbar: false
                }),
            apply: (tr, state, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta($217026bcd07aedee$export$18d4026d1ea86bb1);
                let nextState = state;
                if (meta?.type === 'SHOW_URL_TOOLBAR') nextState = {
                    ...nextState,
                    showUrlToolbar: true
                };
                if (meta?.type === 'HIDE_URL_TOOLBAR') nextState = {
                    ...nextState,
                    showUrlToolbar: false
                };
                if (meta?.type === 'SET_RESIZING') nextState = {
                    ...nextState,
                    isResizing: meta.isResizing,
                    resizingWidth: meta.width
                };
                const { schema: schema, selection: selection } = newEditorState;
                const selected = (0, $8m4tT.findSelectedNodeOfType)(schema.nodes.extension)(selection);
                const isNativeEmbed = selected && (0, $i12w8.isNativeEmbedNode)(selected.node);
                if (isNativeEmbed) {
                    const newPos = selected.pos;
                    const newAlignment = (0, $8Yt3t.getParameters)(selected.node.attrs.parameters, 'alignment');
                    const newLocalId = selected.node.attrs.localId;
                    const prev = nextState.selectedEmbed;
                    if (newPos !== prev?.pos || newAlignment !== prev?.alignment || newLocalId !== prev?.localId) nextState = {
                        ...nextState,
                        selectedEmbed: {
                            pos: newPos,
                            alignment: newAlignment,
                            localId: newLocalId
                        }
                    };
                } else if (nextState.selectedEmbed !== null) nextState = {
                    ...nextState,
                    selectedEmbed: null
                };
                return nextState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            if (!editorAnalyticsApi) return null;
            if ((0, $2pjJ5.isReplaceDocOperation)(transactions, oldState)) return null;
            const isNotLocalInsert = transactions.some((t)=>{
                const action = (0, $doRn8.getLinkMetadataFromTransaction)(t).action;
                const isRemote = t.getMeta('isRemote');
                return isRemote || !(action === (0, $d925B.ACTION).INSERTED || action === undefined);
            });
            if (isNotLocalInsert) return null;
            const existingLocalIds = new Set();
            oldState.doc.descendants((node)=>{
                if ((0, $i12w8.isNativeEmbedNode)(node) && node.attrs.localId) existingLocalIds.add(node.attrs.localId);
            });
            const insertedEmbeds = transactions.flatMap((tr)=>{
                const inserted = [];
                if (!tr.docChanged) return inserted;
                tr.steps.forEach((step)=>{
                    if ((0, $kTbzR.stepHasSlice)(step)) step.slice.content.descendants((node)=>{
                        if ((0, $i12w8.isNativeEmbedNode)(node) && node.attrs.localId !== null && !existingLocalIds.has(node.attrs.localId)) inserted.push(node);
                    });
                });
                return inserted;
            });
            if (insertedEmbeds.length === 0) return null;
            const tr = newState.tr;
            const payload = {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    insertedCount: insertedEmbeds.length,
                    inputMethod: $217026bcd07aedee$var$getInsertionMethod(transactions)
                }
            };
            editorAnalyticsApi.attachAnalyticsEvent(payload)(tr);
            return tr;
        }
    });
module.exports["pluginKey"] = $217026bcd07aedee$export$18d4026d1ea86bb1;
module.exports["createPlugin"] = $217026bcd07aedee$export$ae829ec7b2625219;

});

parcelRegister("i12w8", function(module, exports) {

var $3jQ9y = parcelRequire("3jQ9y");


var $8m4tT = parcelRequire("8m4tT");

/**
 * Returns the currently selected extension node, if any.
 */ const $8cbe7bc3073df27f$var$getSelectedExtension = (state)=>{
    const { schema: schema, selection: selection } = state;
    return (0, $8m4tT.findSelectedNodeOfType)(schema.nodes.extension)(selection) || undefined;
};
const $8cbe7bc3073df27f$export$a990e9e9e93229aa = (node)=>{
    return node.type.name === 'extension' && node.attrs?.extensionType === (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY));
};
const $8cbe7bc3073df27f$export$1782ddbca43ac707 = (state)=>{
    const selected = $8cbe7bc3073df27f$var$getSelectedExtension(state);
    if (selected && $8cbe7bc3073df27f$export$a990e9e9e93229aa(selected.node)) return selected;
    return undefined;
};
module.exports["isNativeEmbedNode"] = $8cbe7bc3073df27f$export$a990e9e9e93229aa;
module.exports["getSelectedNativeEmbedExtension"] = $8cbe7bc3073df27f$export$1782ddbca43ac707;

});

parcelRegister("ijP1H", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $hkTaH = parcelRequire("hkTaH");

var $eKkkY = parcelRequire("eKkkY");

var $fpEzC = parcelRequire("fpEzC");

var $ckqYV = parcelRequire("ckqYV");

var $gVDfZ = parcelRequire("gVDfZ");

var $7Irim = parcelRequire("7Irim");


var $9fPrY = parcelRequire("9fPrY");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $a6IPc = parcelRequire("a6IPc");


var $kiZiu = parcelRequire("kiZiu");


var $6bJyJ = parcelRequire("6bJyJ");


var $cOZT3 = parcelRequire("cOZT3");


var $6oGZN = parcelRequire("6oGZN");


var $9Ctkw = parcelRequire("9Ctkw");


var $kVA9C = parcelRequire("kVA9C");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $1Zr9M = parcelRequire("1Zr9M");


var $8tdj3 = parcelRequire("8tdj3");


var $9pS9R = parcelRequire("9pS9R");


var $6qvTD = parcelRequire("6qvTD");

var $8Yt3t = parcelRequire("8Yt3t");


var $1oCLl = parcelRequire("1oCLl");


var $9I1d6 = parcelRequire("9I1d6");


var $1uTOu = parcelRequire("1uTOu");


var $fm4ja = parcelRequire("fm4ja");


var $i12w8 = parcelRequire("i12w8");


var $hg9Ir = parcelRequire("hg9Ir");


var $6HRkz = parcelRequire("6HRkz");


var $7TrYk = parcelRequire("7TrYk");


var $ftNR1 = parcelRequire("ftNR1");


var $3yGVx = parcelRequire("3yGVx");

const $6d9c056f42e43409$var$ALIGNMENT_ICONS = {
    left: (0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))),
    center: (0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))),
    right: (0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))),
    'wrap-left': (0, (/*@__PURE__*/$parcel$interopDefault($9Ctkw))),
    'wrap-right': (0, (/*@__PURE__*/$parcel$interopDefault($kVA9C)))
};
const $6d9c056f42e43409$var$getAlignmentLabel = (alignment, intl)=>{
    switch(alignment){
        case 'left':
            return intl.formatMessage((0, $hkTaH.alignmentMessages).alignLeft);
        case 'center':
            return intl.formatMessage((0, $hkTaH.alignmentMessages).alignCenter);
        case 'right':
            return intl.formatMessage((0, $hkTaH.alignmentMessages).alignRight);
        case 'wrap-left':
            return intl.formatMessage((0, $gVDfZ.toolbarMessages).wrapLeft);
        case 'wrap-right':
            return intl.formatMessage((0, $gVDfZ.toolbarMessages).wrapRight);
    }
};
const $6d9c056f42e43409$var$getAlignmentIcon = (alignment, intl)=>{
    const IconComponent = $6d9c056f42e43409$var$ALIGNMENT_ICONS[alignment];
    return /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        color: "currentColor",
        spacing: "spacious",
        label: $6d9c056f42e43409$var$getAlignmentLabel(alignment, intl)
    });
};
const $6d9c056f42e43409$var$NativeEmbedDropdownIcon = ({ icon: IconComponent, label: label })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginRight: "var(--ds-space-negative-100, -8px)"
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
            color: "currentColor",
            label: label,
            spacing: "none"
        })
    });
/**
 * Converts a custom EditorToolbarAction to a FloatingToolbarItem.
 * Uses customActionHandlers from manifest when resolving handler.
 */ function $6d9c056f42e43409$var$convertCustomActionToToolbarItem(action, customActionHandlers) {
    return {
        id: `native-embed-${action.key}`,
        type: 'button',
        title: action.label,
        showTitle: action.showTitle,
        icon: action.icon,
        disabled: action.disabled,
        onClick: ()=>{
            customActionHandlers[action.handlerKey];
            return true;
        },
        focusEditoronEnter: true,
        tabIndex: null
    };
}
/**
 * Creates a registry of built-in toolbar items keyed by their BUILTIN_TOOLBAR_KEYS.
 * Resolves handlers from manifest first, then falls back to default actions.
 */ function $6d9c056f42e43409$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, embedWidth, lineLength, api) {
    // When the embed width is greater than or equal to the layout width,
    // only "center" alignment is valid — disable all other options.
    const shouldDisableNonCenterAlignments = embedWidth !== undefined && lineLength !== undefined && embedWidth >= lineLength;
    const alignmentOptions = (0, $6qvTD.ALIGNMENT_VALUES).map((alignment)=>({
            id: `native-embed-alignment-${alignment}`,
            title: $6d9c056f42e43409$var$getAlignmentLabel(alignment, intl),
            onClick: handlers.onAlignmentClick(alignment),
            selected: parameters.alignment === alignment,
            disabled: shouldDisableNonCenterAlignments && alignment !== 'center',
            icon: $6d9c056f42e43409$var$getAlignmentIcon(alignment, intl)
        }));
    const alignmentDropdownTitle = $6d9c056f42e43409$var$getAlignmentLabel(parameters.alignment, intl);
    const AlignmentIconComponent = $6d9c056f42e43409$var$ALIGNMENT_ICONS[parameters.alignment];
    return {
        ...(0, $1oCLl.expValEquals)('cc-maui-experiment-phase-2', 'isEnabled', true) ? {
            [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO]: {
                type: 'custom',
                fallback: [],
                render: (view)=>view ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6HRkz.AskRovoToolbarButton), {
                        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onClick: ()=>handlers.onAskRovoClick()(view.state, view.dispatch)
                    }) : null
            }
        } : {},
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SUMMARISE]: {
            id: 'native-embed-summarise-button',
            type: 'button',
            title: intl.formatMessage((0, $7Irim.nativeEmbedToolbarMessages).summarise),
            showTitle: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))),
            onClick: handlers.onSummariseClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).REFRESH]: {
            id: 'native-embed-refresh-button',
            type: 'button',
            title: intl.formatMessage((0, $7Irim.nativeEmbedToolbarMessages).refresh),
            showTitle: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9pS9R))),
            onClick: handlers.onRefreshClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EMBED]: {
            ...(0, $hg9Ir.getNativeEmbedAppearanceDropdown)({
                intl: intl,
                onAppearanceClick: handlers.onAppearanceClick
            })
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).BORDER]: {
            id: 'native-embed-change-border-dropdown',
            type: 'dropdown',
            title: ' ',
            iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)($6d9c056f42e43409$var$NativeEmbedDropdownIcon, {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6oGZN))),
                    label: "border"
                }),
            options: [],
            onClick: ()=>{} // TODO: CNS-23805 - Implement Border Change Dropdown
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT]: {
            id: 'native-embed-alignment-dropdown',
            type: 'dropdown',
            tooltip: alignmentDropdownTitle,
            title: ' ',
            iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)($6d9c056f42e43409$var$NativeEmbedDropdownIcon, {
                    icon: AlignmentIconComponent,
                    label: alignmentDropdownTitle
                }),
            options: alignmentOptions
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW]: {
            id: 'native-embed-open-new-window-button',
            type: 'button',
            title: intl.formatMessage((0, $fpEzC.linkMessages).openLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
            onClick: handlers.onOpenInNewWindowClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT_URL]: {
            id: 'native-embed-edit-url-button',
            type: 'button',
            title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
            onClick: handlers.onEditUrlClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EDIT]: {
            id: 'native-embed-edit-button',
            type: 'button',
            title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editDatasourceStandalone),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
            onClick: handlers.onEditClick()
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY]: {
            id: 'native-embed-copy-button',
            type: 'button',
            title: intl.formatMessage((0, $eKkkY.messages).copy),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
            onClick: handlers.onCopyClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        /**
     * @private
     * @deprecated Use COPY instead. Will be removed in a follow-up PR.
     */ [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY_LINK]: {
            id: 'native-embed-copy-link-button',
            type: 'button',
            title: intl.formatMessage((0, $eKkkY.messages).copyLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
            onClick: handlers.onCopyLinkClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE]: {
            id: 'native-embed-delete-button',
            type: 'button',
            title: intl.formatMessage((0, $eKkkY.messages).deleteBlock),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
            onClick: handlers.onDeleteClick(),
            focusEditoronEnter: true,
            tabIndex: null
        }
    };
}
/**
 * Resolves toolbar items from the manifest's items array.
 * Looks up each key in the built-in registry or customActions.
 */ function $6d9c056f42e43409$var$resolveToolbarItemsFromItems(items, builtinRegistry, customActions, editorToolbarHandlers) {
    const resolvedItems = [];
    for (const key of items){
        if (key === (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR) resolvedItems.push({
            type: 'separator',
            fullHeight: true
        });
        else if (key in builtinRegistry) resolvedItems.push(builtinRegistry[key]);
        else if (customActions && key in customActions) resolvedItems.push($6d9c056f42e43409$var$convertCustomActionToToolbarItem(customActions[key], editorToolbarHandlers));
    }
    return resolvedItems;
}
/**
 * Converts manifest-defined toolbar actions to FloatingToolbarItems.
 * Uses `items` array with built-in registry + custom actions.
 */ function $6d9c056f42e43409$var$convertManifestActionsToToolbarItems(manifestActions, handlers, parameters, intl, schema, embedWidth, lineLength, api) {
    if (!manifestActions.items) return [];
    const builtinRegistry = $6d9c056f42e43409$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, embedWidth, lineLength, api);
    return $6d9c056f42e43409$var$resolveToolbarItemsFromItems(manifestActions.items, builtinRegistry, manifestActions.customActions, handlers);
}
/**
 * Returns toolbar sizing configuration when the URL edit toolbar is active.
 */ const $6d9c056f42e43409$var$editUrlToolbarConfig = (showUrlToolbar, lpLinkPicker)=>{
    return showUrlToolbar ? {
        height: lpLinkPicker ? (0, $9fPrY.LINKPICKER_HEIGHT_IN_PX) : (0, $9fPrY.RECENT_SEARCH_HEIGHT_IN_PX),
        width: (0, $9fPrY.RECENT_SEARCH_WIDTH_IN_PX),
        forcePlacement: true
    } : {};
};
/**
 * Default items of toolbar items when no manifest is provided.
 */ const $6d9c056f42e43409$var$DEFAULT_TOOLBAR_ITEMS = [
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).REFRESH,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).EMBED,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).BORDER,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW
];
function $6d9c056f42e43409$export$d8e43bed2cd6707f(node) {
    if (!(node instanceof HTMLElement)) return undefined;
    const container = node.querySelector('.extension-container') ?? node.closest('.extension-container');
    return container instanceof HTMLElement ? container : node;
}
/**
 * Returns the default toolbar items when no manifest actions are provided.
 */ function $6d9c056f42e43409$var$getDefaultToolbarItems(handlers, parameters, intl, schema, embedWidth, lineLength, api) {
    const builtinRegistry = $6d9c056f42e43409$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, embedWidth, lineLength, api);
    return $6d9c056f42e43409$var$resolveToolbarItemsFromItems($6d9c056f42e43409$var$DEFAULT_TOOLBAR_ITEMS, builtinRegistry, undefined, handlers);
}
const $6d9c056f42e43409$export$86ce8f8241c20a3 = ({ api: api, linkPickerOptions: linkPickerOptions, lpLinkPicker: lpLinkPicker })=>(state, intl, providerFactory, _activeConfigs)=>{
        const selectedNativeEmbed = (0, $i12w8.getSelectedNativeEmbedExtension)(state);
        if (!selectedNativeEmbed) return undefined;
        const pluginState = (0, $fm4ja.pluginKey).getState(state);
        const isShowingUrlToolbar = pluginState?.showUrlToolbar ?? false;
        const hoverDecoration = api?.decorations?.actions.hoverDecoration;
        const nodeType = state.schema.nodes.extension;
        const deleteHoverPropsFactory = (nt)=>({
                onMouseEnter: hoverDecoration?.(nt, true),
                onMouseLeave: hoverDecoration?.(nt, false),
                onFocus: hoverDecoration?.(nt, true),
                onBlur: hoverDecoration?.(nt, false)
            });
        const parameters = (0, $8Yt3t.getParameters)(selectedNativeEmbed.node.attrs.parameters);
        // Resolve manifest from facade — try URL first, then fall back to
        // experience ID extracted from the extensionKey. The URL-based lookup
        // can fail when the embed is reinserted (e.g. after a Rovo edit)
        // without macroParams being preserved.
        const facade = (0, $9I1d6.getNativeEmbedFacade)();
        let manifest = parameters.url ? facade.getManifestByUrl(parameters.url) : undefined;
        if (!manifest) {
            const extensionKey = selectedNativeEmbed.node.attrs.extensionKey;
            const experienceId = extensionKey?.split(':')[1];
            if (experienceId) manifest = facade.getManifestById(experienceId);
        }
        const manifestActions = manifest?.uiConfig?.editorToolbarActions;
        // Determine handlers based on manifest, falling back to defaults
        const resolvedHandlers = (0, $3yGVx.buildToolbarHandlers)(selectedNativeEmbed, manifest?.uiConfig.editorToolbarHandlers, api, parameters, intl, state.schema);
        const getDomRef = (view)=>{
            try {
                const node = (0, $8m4tT.findDomRefAtPos)(selectedNativeEmbed.pos, view.domAtPos.bind(view));
                return $6d9c056f42e43409$export$d8e43bed2cd6707f(node);
            } catch  {
                return undefined;
            }
        };
        // If URL toolbar is showing, render the edit URL toolbar instead of normal items
        if (isShowingUrlToolbar) return {
            title: 'Native Embed floating toolbar',
            getDomRef: getDomRef,
            nodeType: state.schema.nodes.extension,
            offset: [
                0,
                8
            ],
            scrollable: false,
            ...$6d9c056f42e43409$var$editUrlToolbarConfig(true, lpLinkPicker),
            items: [
                (0, $7TrYk.buildNativeEmbedEditUrlToolbar)({
                    api: api,
                    linkPickerOptions: linkPickerOptions,
                    lpLinkPicker: lpLinkPicker ?? true,
                    providerFactory: providerFactory,
                    selectedNativeEmbed: selectedNativeEmbed
                })
            ]
        };
        // Determine the embed's current width and the layout line length so we
        // can disable non-center alignment options when the embed is as wide as
        // (or wider than) the layout.
        const widthState = api?.width?.sharedState?.currentState();
        const lineLength = widthState?.lineLength || (0, $aFUXX.akEditorDefaultLayoutWidth);
        const embedWidth = (0, $1uTOu.getWidth)(selectedNativeEmbed.node) ?? lineLength;
        // Convert manifest actions to FloatingToolbarItems, or fall back to default items
        const items = manifestActions ? $6d9c056f42e43409$var$convertManifestActionsToToolbarItems(manifestActions, resolvedHandlers, parameters, intl, state.schema, embedWidth, lineLength, api) : $6d9c056f42e43409$var$getDefaultToolbarItems(resolvedHandlers, parameters, intl, state.schema, embedWidth, lineLength, api);
        // Auto-append the "More Options" dropdown when there are items to show.
        // Default toolbar (no manifest): always show with default items.
        // Manifest toolbar: only show when moreItems is provided with items.
        const showMoreOptions = manifestActions?.moreItems ? Boolean(manifestActions?.moreItems?.length) : true;
        if (showMoreOptions) items.push({
            type: 'separator'
        }, (0, $ftNR1.getMoreOptionsDropdown)(api, selectedNativeEmbed, deleteHoverPropsFactory(nodeType), resolvedHandlers, parameters, intl, manifestActions?.moreItems, manifestActions?.customActions));
        return {
            title: 'Native Embed floating toolbar',
            getDomRef: getDomRef,
            nodeType: state.schema.nodes.extension,
            offset: [
                0,
                8
            ],
            items: items
        };
    };
module.exports["getToolbarConfig"] = $6d9c056f42e43409$export$86ce8f8241c20a3;

});

parcelRegister("1uTOu", function(module, exports) {

var $8Yt3t = parcelRequire("8Yt3t");


var $fm4ja = parcelRequire("fm4ja");

const $9d48f186f00d83f2$export$3c49c185de0c2bfc = (selectedNode)=>{
    return (0, $8Yt3t.getParameters)(selectedNode.attrs.parameters, 'width');
};
const $9d48f186f00d83f2$export$ea9f617f119f6cd3 = (api, width, selectedNode, height)=>()=>{
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>{
            const params = current.attrs?.parameters;
            let updatedParams = (0, $8Yt3t.setParameter)(params, {
                width: width
            });
            if (height !== undefined) updatedParams = (0, $8Yt3t.setParameter)(updatedParams, {
                height: height
            });
            return {
                attrs: {
                    ...current.attrs,
                    parameters: updatedParams
                }
            };
        });
        return true;
    };
const $9d48f186f00d83f2$export$e8152faa2a85727 = (isResizing, width)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = state.tr;
            tr.setMeta((0, $fm4ja.pluginKey), {
                type: 'SET_RESIZING',
                isResizing: isResizing,
                width: width
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
        }
        return true;
    };
module.exports["getWidth"] = $9d48f186f00d83f2$export$3c49c185de0c2bfc;
module.exports["createUpdateWidthCommand"] = $9d48f186f00d83f2$export$ea9f617f119f6cd3;

});

parcelRegister("hg9Ir", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i9vfM = parcelRequire("i9vfM");


var $3RxtY = parcelRequire("3RxtY");

var $ckqYV = parcelRequire("ckqYV");


var $5Yp2m = parcelRequire("5Yp2m");


var $fIcbd = parcelRequire("fIcbd");


var $65WMN = parcelRequire("65WMN");


var $99wB5 = parcelRequire("99wB5");


var $erzkB = parcelRequire("erzkB");


var $56M4r = parcelRequire("56M4r");

var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");

const $508ce93eee6eb6ff$var$APPEARANCE_OPTIONS = [
    'url',
    'inline',
    'block',
    'embed'
];
const $508ce93eee6eb6ff$var$appearanceMetadataMap = {
    url: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Yp2m))),
        message: (0, $3RxtY.messages).urlTitle
    },
    inline: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($erzkB))),
        message: (0, $3RxtY.messages).inlineTitle
    },
    block: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($65WMN))),
        message: (0, $3RxtY.messages).blockTitle
    },
    embed: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($99wB5))),
        message: (0, $3RxtY.messages).embedTitle
    }
};
const $508ce93eee6eb6ff$var$buildAppearanceDropdownOptions = (intl, onAppearanceClick)=>$508ce93eee6eb6ff$var$APPEARANCE_OPTIONS.map((appearance)=>({
            id: `native-embed-appearance-${appearance}`,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($508ce93eee6eb6ff$var$appearanceMetadataMap[appearance].icon, {
                color: 'currentColor',
                label: '',
                spacing: 'spacious'
            }),
            onClick: onAppearanceClick(appearance),
            selected: appearance === 'embed',
            title: intl.formatMessage($508ce93eee6eb6ff$var$appearanceMetadataMap[appearance].message)
        }));
const $508ce93eee6eb6ff$var$NativeEmbedAppearanceMenu = ({ dispatchCommand: dispatchCommand, intl: intl, options: options })=>{
    const preferencesHref = (0, $i9vfM.getLinkPreferencesURLFromENV)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2SlZp.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                children: options.map((option)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        iconBefore: option.icon,
                        /* eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders,@atlassian/perf-linting/no-unstable-inline-props  */ onClick: ()=>dispatchCommand(option.onClick),
                        isSelected: option.selected,
                        children: option.title
                    }, option.id ?? option.title))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    }),
                    href: preferencesHref,
                    target: "_blank",
                    children: intl.formatMessage((0, $ckqYV.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $508ce93eee6eb6ff$export$8777833158c4a88c = ({ intl: intl, onAppearanceClick: onAppearanceClick })=>{
    const options = $508ce93eee6eb6ff$var$buildAppearanceDropdownOptions(intl, onAppearanceClick);
    const dropdownOptions = {
        render: (props)=>/*#__PURE__*/ (0, $l998X.jsx)($508ce93eee6eb6ff$var$NativeEmbedAppearanceMenu, {
                dispatchCommand: props.dispatchCommand,
                intl: intl,
                options: options
            }),
        width: 220,
        height: 260
    };
    const title = intl.formatMessage($508ce93eee6eb6ff$var$appearanceMetadataMap.embed.message);
    const iconBefore = $508ce93eee6eb6ff$var$appearanceMetadataMap.embed.icon;
    return {
        id: 'native-embed-appearance-dropdown',
        type: 'dropdown',
        testId: 'native-embed-appearance-dropdown',
        title: title,
        iconBefore: iconBefore,
        options: dropdownOptions
    };
};
module.exports["getNativeEmbedAppearanceDropdown"] = $508ce93eee6eb6ff$export$8777833158c4a88c;

});

parcelRegister("6HRkz", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $6G33C = parcelRequire("6G33C");

function $c91eb43c9e18a435$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
const $c91eb43c9e18a435$var$buttonWrapperStyles = {
    name: "1tyrre4",
    styles: "& button{&::after{display:none;}}"
};
function $c91eb43c9e18a435$export$cc61d4d88dbc5bf9({ onClick: onClick }) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $c91eb43c9e18a435$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6G33C.ConversationAssistantButtonNav4), {
        isActive: false,
        onClick: onClick,
        siteId: 'stub-site-id',
        productKey: 'confluence'
    }));
}
module.exports["AskRovoToolbarButton"] = $c91eb43c9e18a435$export$cc61d4d88dbc5bf9;

});

parcelRegister("6G33C", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $iPfZG = parcelRequire("iPfZG");

var $hwWwS = parcelRequire("hwWwS");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $4rwCt = parcelRequire("4rwCt");


var $1NxpI = parcelRequire("1NxpI");


var $c6GJD = parcelRequire("c6GJD");


var $lAFHW = parcelRequire("lAFHW");


var $aGop9 = parcelRequire("aGop9");


var $dh538 = parcelRequire("dh538");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");


var $3gadb = parcelRequire("3gadb");


var $kIvLT = parcelRequire("kIvLT");


var $g1Neh = parcelRequire("g1Neh");


var $7TlcC = parcelRequire("7TlcC");


var $eUgVI = parcelRequire("eUgVI");


var $296Il = parcelRequire("296Il");


var $8lvfZ = parcelRequire("8lvfZ");


var $5wDnm = parcelRequire("5wDnm");


var $l0CXZ = parcelRequire("l0CXZ");


var $3HWNm = parcelRequire("3HWNm");

const $723302ad18fc2a4a$var$defaultButtonStyles = {
    paddingInline: "var(--ds-space-100, 8px)"
};
const $723302ad18fc2a4a$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #0515240F)"
};
const $723302ad18fc2a4a$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #17171708)",
    color: "var(--ds-text-disabled, #080F214A)"
};
const $723302ad18fc2a4a$var$conversationAssistantButtonWrapperStyles = null;
const $723302ad18fc2a4a$var$conversationAssistantButtonWrapperNoOverlayStyles = null;
const $723302ad18fc2a4a$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $723302ad18fc2a4a$var$pulseKeyframes = null;
const $723302ad18fc2a4a$var$pulseAnimationStyles = null;
const $723302ad18fc2a4a$var$reduceMotionStyles = null;
const $723302ad18fc2a4a$var$getConversationAssistantButton = (Button = (0, $1NxpI.PrimaryButton))=>/*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, tooltipContent: tooltipContent, shortcut: shortcut, siteId: siteId, productKey: productKey }, ref)=>{
        (0, $fBMbo.di)((0, $hwWwS.useCoordination), (0, $7TlcC.useCoordinationClient), (0, $c6GJD.default), (0, $5wDnm.useInsightsStatus));
        const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
        const { start: start } = (0, $296Il.useConversationAssistantSpotlightActions)(); // Prefetch insights status to warm the cache before the user opens chat.
        // This triggers the backend to generate insights asynchronously if not already cached.
        const isPulseExperimentEnabled = (0, $c6GJD.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
        (0, $5wDnm.useInsightsStatus)({
            enabled: isPulseExperimentEnabled,
            assistanceServiceParams: {
                touchpointSource: 'ask-rovo-button-prefetch',
                product: productKey,
                experienceId: 'ai-mate',
                siteId: siteId
            }
        });
        const [shouldShowMessage, setShouldShowMessage] = (0, $42omo.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $42omo.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey
                }
            });
            return onClickProp?.(...params);
        }, [
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
        const getChildren = ()=>{
            const button = /*#__PURE__*/ (0, $l998X.jsx)(Button, {
                onMouseEnter: ()=>{
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                    children: formatMessage((0, $3HWNm.messages).rovoChatButtonLabel)
                }),
                shortcut: shortcut,
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$723302ad18fc2a4a$var$defaultButtonStyles,
                    ...!isActive && $723302ad18fc2a4a$var$inactiveButtonStyles,
                    ...isDisabled && $723302ad18fc2a4a$var$disabledButtonStyles
                },
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                    size: "xxsmall"
                }),
                interactionName: interactionName,
                ref: ref,
                children: formatMessage((0, $3HWNm.messages).rovoChatButtonLabel)
            });
            if (Button === (0, $1NxpI.PrimaryButton)) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                role: "list",
                children: button
            });
            if (!isActive && !isDisabled) {
                const overlayCohort = (0, $c6GJD.default).getExperimentValue('rovo-chat-nav-button-transparency', 'backgroundColorCohort', 'control');
                if (overlayCohort === 'overlay') return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_7dir1bhr _d32vi7uo _6pup6o2t _4pkpi7uo"
                    ]),
                    children: button
                });
                else if (overlayCohort === 'no-overlay') return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_7dirvuon _d32vi7uo _6pup19i6 _4pkpi7uo"
                    ]),
                    children: button
                });
            }
            return button;
        };
        return shouldUseCoordination ? /*#__PURE__*/ (0, $l998X.jsx)($723302ad18fc2a4a$export$de76c194bfb85689, {
            setShouldShowMessage: setShouldShowMessage,
            messageId: messageId,
            siteId: siteId,
            children: getChildren(),
            shouldShowMessage: shouldShowMessage,
            openRovoChat: openRovoChat
        }) : getChildren();
    });
const $723302ad18fc2a4a$var$Nav4Button = /*#__PURE__*/ (0, $42omo.forwardRef)(({ tooltip: tooltip, shortcut: shortcut, ...props }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltip,
        shortcut: shortcut,
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true,
        children: ({ ref: tooltipRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aGop9.Button), {
                interactionName: props?.interactionName,
                ref: (0, $4rwCt.mergeRefs)([
                    forwardedRef,
                    tooltipRef
                ]),
                ...triggerProps,
                ...props,
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps.onClick?.(event);
                },
                iconBefore: ()=>props.iconBefore || null
            })
    });
});
const $723302ad18fc2a4a$export$7c328c0993982813 = $723302ad18fc2a4a$var$getConversationAssistantButton((0, $1NxpI.PrimaryButton));
const $723302ad18fc2a4a$export$25e85d244cbf7845 = $723302ad18fc2a4a$var$getConversationAssistantButton($723302ad18fc2a4a$var$Nav4Button);
const $723302ad18fc2a4a$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat })=>{
    const { activeSpotlight: activeSpotlight } = (0, $296Il.useConversationAssistantSpotlightState)();
    const coordinationClient = (0, $7TlcC.useCoordinationClient)(siteId);
    const [onboardingStarted, stopOnboarding] = (0, $eUgVI.usePostOfficeCoordination)(coordinationClient, messageId, (0, $dh538.fg)('rovo-chat-agents-spotlight-post-office-migration'));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    (0, $42omo.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l0CXZ.ConditionalWrapper), {
        condition: shouldShowMessage,
        wrapper: (children)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $k7Tf7.PopoverProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a90ar.PopoverTarget), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            activeSpotlight === null && "",
                            activeSpotlight === null && "_2rko12b0 _5sagi11n _tip812c5 _j7hqfamb _1pglmcjr _16qs1peg",
                            "_1bumglyw _sedtglyw"
                        ]),
                        children: [
                            children,
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $8lvfZ.ConversationAssistantOnboardingSpotlight), {
                                onDismiss: onDismissMessage,
                                openRovoChat: openRovoChat
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iPfZG.EngagementSpotlight), {
                                engagementId: (0, $g1Neh.SPOTLIGHT_ONBOARDING_TARGET)
                            })
                        ]
                    })
                })
            }),
        children: children
    });
};
module.exports["ConversationAssistantButtonNav4"] = $723302ad18fc2a4a$export$25e85d244cbf7845;

});

parcelRegister("1NxpI", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $4KS7f = parcelRequire("4KS7f");


var $3gadb = parcelRequire("3gadb");


var $4qrTW = parcelRequire("4qrTW");


var $drbbL = parcelRequire("drbbL");

function $d260874c410d6e1a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $d260874c410d6e1a$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $d260874c410d6e1a$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $d260874c410d6e1a$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $d260874c410d6e1a$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $4qrTW.useTheme)();
    const button = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            [$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$d260874c410d6e1a$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $d260874c410d6e1a$var$buttonBaseStyles,
            isHighlighted && $d260874c410d6e1a$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $drbbL.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $d260874c410d6e1a$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});
module.exports["PrimaryButton"] = $d260874c410d6e1a$export$ac16a6a04d9b7c84;

});

parcelRegister("4qrTW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8K0Og = parcelRequire("8K0Og");

const $14a2b16d436ce3a5$export$93d4e7f90805808f = ()=>(0, $42omo.useContext)((0, $8K0Og.ThemeContext));
module.exports["useTheme"] = $14a2b16d436ce3a5$export$93d4e7f90805808f;

});

parcelRegister("8K0Og", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ahT8g = parcelRequire("ahT8g");

const $64b78fb356e75cc1$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ahT8g.defaultTheme));
const $64b78fb356e75cc1$export$d8964aec282183a3 = $64b78fb356e75cc1$export$2c657da244d00bd6.Provider;
module.exports["ThemeContext"] = $64b78fb356e75cc1$export$2c657da244d00bd6;
module.exports["ThemeProvider"] = $64b78fb356e75cc1$export$d8964aec282183a3;

});

parcelRegister("ahT8g", function(module, exports) {

var $lCH0w = parcelRequire("lCH0w");


var $jeF0t = parcelRequire("jeF0t");

const $245571a50d5c46d4$export$eeee8619e1b91cb0 = (0, $jeF0t.generateTheme)({
    name: (0, $lCH0w.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});
const $245571a50d5c46d4$export$164de7ab8df77ef0 = $245571a50d5c46d4$export$eeee8619e1b91cb0;
module.exports["defaultTheme"] = $245571a50d5c46d4$export$164de7ab8df77ef0;

});

parcelRegister("lCH0w", function(module, exports) {
const $08762123b36e773e$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $08762123b36e773e$var$defaultThemeCopy = JSON.parse(JSON.stringify($08762123b36e773e$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$08762123b36e773e$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $08762123b36e773e$export$77823bc9863eaa03 = $08762123b36e773e$var$defaultThemeCopy;
const $08762123b36e773e$export$2491e13b198e597d = 'atlassian';
var $08762123b36e773e$export$2e2bcd8739ae039 = $08762123b36e773e$var$defaultTheme;
module.exports["defaultThemeBrandRefresh"] = $08762123b36e773e$export$77823bc9863eaa03;
module.exports["DEFAULT_THEME_NAME"] = $08762123b36e773e$export$2491e13b198e597d;

});

parcelRegister("jeF0t", function(module, exports) {

var $lCH0w = parcelRequire("lCH0w");


var $3cLqS = parcelRequire("3cLqS");

const $1ebbdfb973eaad0e$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $1ebbdfb973eaad0e$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $1ebbdfb973eaad0e$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $3cLqS.hexToRGBA)(backgroundColor, 0.65) : (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $3cLqS.hexToRGBA)(backgroundColor, 0.8) : (0, $3cLqS.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $3cLqS.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3cLqS.getBoxShadow)('transparent')
        }
    };
};
const $1ebbdfb973eaad0e$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $3cLqS.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $1ebbdfb973eaad0e$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $3cLqS.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $lCH0w.DEFAULT_THEME_NAME)) return 0, $lCH0w.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $1ebbdfb973eaad0e$var$generateButtonCSSStates($1ebbdfb973eaad0e$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $1ebbdfb973eaad0e$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $3cLqS.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $3cLqS.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $3cLqS.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $3cLqS.getBoxShadow)((0, $3cLqS.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $3cLqS.getContrastColor)(0.1, $1ebbdfb973eaad0e$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
module.exports["generateTheme"] = $1ebbdfb973eaad0e$export$2e4ecffaca289a18;

});

parcelRegister("3cLqS", function(module, exports) {

var $lcPXp = parcelRequire("lcPXp");

const $6a9c68de2b00e336$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $lcPXp.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $6a9c68de2b00e336$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $6a9c68de2b00e336$var$hex = '[a-z0-9]';
const $6a9c68de2b00e336$var$shortHandHexColorPattern = new RegExp(`#(${$6a9c68de2b00e336$var$hex})(${$6a9c68de2b00e336$var$hex})(${$6a9c68de2b00e336$var$hex})`, 'i');
const $6a9c68de2b00e336$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $6a9c68de2b00e336$var$isShortHexColor = (color)=>color && color.length === 4;
const $6a9c68de2b00e336$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$6a9c68de2b00e336$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $6a9c68de2b00e336$var$completeTriplet = (colors)=>`#${$6a9c68de2b00e336$var$repeat(colors[1], 6)}`;
const $6a9c68de2b00e336$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $6a9c68de2b00e336$export$db8d2130677f868c = (color)=>{
    if ($6a9c68de2b00e336$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($6a9c68de2b00e336$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($6a9c68de2b00e336$var$isTriplet(colors)) return $6a9c68de2b00e336$var$completeTriplet(colors);
            else return $6a9c68de2b00e336$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $6a9c68de2b00e336$export$10a10e7cd1193377 = (color)=>{
    const converted = $6a9c68de2b00e336$export$db8d2130677f868c(color);
    return (0, $lcPXp.default).contrastRatio(converted).hex;
};
const $6a9c68de2b00e336$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$6a9c68de2b00e336$export$7229be6d7219ee6a((0, $lcPXp.default).contrast(contrastValue, color).hex, opacityValue);
module.exports["hexToRGBA"] = $6a9c68de2b00e336$export$7229be6d7219ee6a;
module.exports["getBoxShadow"] = $6a9c68de2b00e336$export$bba5a971afe05444;
module.exports["generateTextColor"] = $6a9c68de2b00e336$export$10a10e7cd1193377;
module.exports["getContrastColor"] = $6a9c68de2b00e336$export$77a1051494882576;

});

parcelRegister("drbbL", function(module, exports) {
const $8b859f9800f72dd2$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
module.exports["getPrimaryButtonTheme"] = $8b859f9800f72dd2$export$14dd6915caf431fe;

});

parcelRegister("g1Neh", function(module, exports) {
const $336f4acc34dc02fa$export$12496216771c6bdd = 'rovo-chat-button';
module.exports["SPOTLIGHT_ONBOARDING_TARGET"] = $336f4acc34dc02fa$export$12496216771c6bdd;

});

parcelRegister("7TlcC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5loD0 = parcelRequire("5loD0");

const $7d4ede3d9b3277cd$export$ddc368dc94a41e62 = (cloudId, workspaceId, orgId)=>{
    return (0, $42omo.useMemo)(()=>new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            workspaceId: workspaceId,
            orgId: orgId,
            coordinationOptions: {
                /**
					 * This will prevent conflicting spotlights in products from displaying at the same time
					 */ enableChoreographer: true
            }
        }), [
        cloudId,
        workspaceId,
        orgId
    ]);
};
module.exports["useCoordinationClient"] = $7d4ede3d9b3277cd$export$ddc368dc94a41e62;

});

parcelRegister("eUgVI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hwWwS = parcelRequire("hwWwS");


var $aXjWU = parcelRequire("aXjWU");

const $56b89e4efca2a0ee$export$a890021247f253fb = (coordinationClient, messageId, poMessageRolloutEnabled)=>{
    const [epMessageStarted, epMessageStop] = (0, $hwWwS.useCoordination)(coordinationClient, messageId);
    const { isActive: poIsActive } = (0, $aXjWU.useTrigger)(`${messageId}-started`);
    const { fireTrigger: poRequestMessageStart } = (0, $aXjWU.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: poFireDismissClick } = (0, $aXjWU.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-dismiss`
    });
    (0, $42omo.useEffect)(()=>{
        if (poMessageRolloutEnabled) poRequestMessageStart({
            isActive: true
        });
    }, [
        messageId,
        poMessageRolloutEnabled,
        poRequestMessageStart
    ]);
    const started = poMessageRolloutEnabled ? poIsActive : epMessageStarted;
    const stop = (force)=>{
        if (poMessageRolloutEnabled) poFireDismissClick({
            isActive: true
        });
        else epMessageStop(force);
    };
    return [
        started,
        stop
    ];
};
module.exports["usePostOfficeCoordination"] = $56b89e4efca2a0ee$export$a890021247f253fb;

});

parcelRegister("296Il", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $1c51462f12c0151c$var$initialState = {
    activeSpotlight: null
};
const $1c51462f12c0151c$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $1c51462f12c0151c$var$ConversationAssistantSpotlightStore = (0, $1P1Tu.createStore)({
    initialState: $1c51462f12c0151c$var$initialState,
    actions: $1c51462f12c0151c$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $1c51462f12c0151c$export$283f4929c8863814 = (0, $9zUhf.createActionsHook)($1c51462f12c0151c$var$ConversationAssistantSpotlightStore);
const $1c51462f12c0151c$export$258c2a6b93cdef4a = (0, $9zUhf.createStateHook)($1c51462f12c0151c$var$ConversationAssistantSpotlightStore);
module.exports["useConversationAssistantSpotlightActions"] = $1c51462f12c0151c$export$283f4929c8863814;
module.exports["useConversationAssistantSpotlightState"] = $1c51462f12c0151c$export$258c2a6b93cdef4a;

});

parcelRegister("8lvfZ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $bqAtB = parcelRequire("bqAtB");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");


var $kIvLT = parcelRequire("kIvLT");


var $296Il = parcelRequire("296Il");


var $3rwGI = parcelRequire("3rwGI");

const $dab8d8727c4d4e80$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, onDismiss: onDismiss })=>{
    (0, $fBMbo.di)((0, $296Il.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { end: end } = (0, $296Il.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $296Il.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const handleTryChat = (event, analyticsEvent)=>{
        if (openRovoChat) openRovoChat(event, analyticsEvent);
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            // this is more of 'chatButtonClicked'
            action: 'dismissed',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    const handleDismiss = ()=>{
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissButtonClicked',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: activeSpotlight !== null && /*#__PURE__*/ (0, $l998X.jsx)((0, $bqAtB.PopoverContent), {
            dismiss: handleDismiss,
            isVisible: activeSpotlight !== null,
            placement: "bottom-start",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $71521.SpotlightCard), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $aZQ5F.SpotlightHeader), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $bUJpY.SpotlightHeadline), {
                                children: formatMessage((0, $3rwGI.default).onboardingHeading)
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $aVS0S.SpotlightControls), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2owmo.SpotlightDismissControl), {
                                    onClick: handleDismiss
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $f1UQW.SpotlightBody), {
                        children: formatMessage((0, $3rwGI.default).onboardingDescription)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eopLP.SpotlightFooter), {
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $3chlW.SpotlightActions), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $19Jj3.SpotlightSecondaryAction), {
                                    onClick: handleDismiss,
                                    children: formatMessage((0, $3rwGI.default).dismissOnboarding)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fNcP1.SpotlightPrimaryAction), {
                                    onClick: handleTryChat,
                                    children: formatMessage((0, $3rwGI.default).tryChat)
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
module.exports["ConversationAssistantOnboardingSpotlight"] = $dab8d8727c4d4e80$export$e4abc8af2fc5e2ac;

});

parcelRegister("3rwGI", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $7ff5afd41511b6ae$var$_default_1 = (0, $aXWIB.defineMessages)({
    tryChat: {
        id: "rovo-onboarding-try-chat",
        defaultMessage: "Chat now"
    },
    dismissOnboarding: {
        id: "rovo-onboarding-dismiss",
        defaultMessage: "Dismiss"
    },
    onboardingHeading: {
        id: "rovo-onboarding-heading",
        defaultMessage: "Chat with AI"
    },
    onboardingDescription: {
        id: "rovo-onboarding-description",
        defaultMessage: "With Rovo Chat, use AI to explore company knowledge, create new things, and collaborate on your work."
    }
});
var $7ff5afd41511b6ae$export$2e2bcd8739ae039 = $7ff5afd41511b6ae$var$_default_1;
module.exports["default"] = $7ff5afd41511b6ae$export$2e2bcd8739ae039;

});

parcelRegister("l0CXZ", function(module, exports) {
const $7999a13f5bf93e64$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
module.exports["ConditionalWrapper"] = $7999a13f5bf93e64$export$39aecc95f0365819;

});

parcelRegister("3HWNm", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $172f32843d67db99$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    rovoChatButtonLabel: {
        id: "conversation-assistant-button.ask-rovo-label",
        defaultMessage: "Ask Rovo"
    }
});
module.exports["messages"] = $172f32843d67db99$export$defe85febe8b728c;

});

parcelRegister("7TrYk", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $6YpFi = parcelRequire("6YpFi");


var $8Yt3t = parcelRequire("8Yt3t");


var $iJwOr = parcelRequire("iJwOr");

const $854a2b8ebc196a84$export$dc6224f1e35e5cf8 = ({ api: api, linkPickerOptions: linkPickerOptions, lpLinkPicker: lpLinkPicker, providerFactory: providerFactory, selectedNativeEmbed: selectedNativeEmbed, view: view })=>{
    const currentUrl = (0, $8Yt3t.getParameters)(selectedNativeEmbed.node.attrs.parameters, 'url');
    const currentDisplayText = (0, $8Yt3t.getParameters)(selectedNativeEmbed.node.attrs.parameters, 'displayText');
    const localId = selectedNativeEmbed.node.attrs.localId;
    const onSubmit = (href, _title, displayText)=>{
        (0, $iJwOr.hideUrlToolbar)(view.state, view.dispatch);
        const urlChanged = href !== currentUrl;
        const displayTextChanged = displayText !== currentDisplayText;
        if ((urlChanged || displayTextChanged) && localId) {
            const extensionApi = api?.extension?.actions?.api();
            if (extensionApi?.doc?.update) extensionApi.doc.update(localId, (current)=>({
                    attrs: {
                        ...current.attrs,
                        parameters: (0, $8Yt3t.setParameter)(current.attrs?.parameters, {
                            url: href,
                            displayText: displayText
                        })
                    }
                }));
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6YpFi.HyperlinkAddToolbar), {
        view: view,
        providerFactory: providerFactory,
        linkPickerOptions: linkPickerOptions,
        displayUrl: currentUrl,
        displayText: currentDisplayText,
        lpLinkPicker: lpLinkPicker,
        invokeMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onSubmit: (href, title, displayText)=>onSubmit(href, title, displayText),
        onEscapeCallback: (0, $iJwOr.hideUrlToolbar),
        onClickAwayCallback: (0, $iJwOr.hideUrlToolbar)
    });
};
const $854a2b8ebc196a84$export$13e482484d5c4da9 = (props)=>({
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view)=>view ? /*#__PURE__*/ (0, $l998X.jsx)($854a2b8ebc196a84$export$dc6224f1e35e5cf8, {
                api: props.api,
                linkPickerOptions: props.linkPickerOptions,
                lpLinkPicker: props.lpLinkPicker,
                providerFactory: props.providerFactory,
                selectedNativeEmbed: props.selectedNativeEmbed,
                view: view
            }) : null
    });
module.exports["buildNativeEmbedEditUrlToolbar"] = $854a2b8ebc196a84$export$13e482484d5c4da9;

});

parcelRegister("iJwOr", function(module, exports) {

var $8Yt3t = parcelRequire("8Yt3t");


var $fm4ja = parcelRequire("fm4ja");

const $3b3f6c598d36873f$export$98ee8d0cf866fa75 = (selectedNode)=>{
    return (0, $8Yt3t.getParameters)(selectedNode.attrs.parameters, 'url');
};
const $3b3f6c598d36873f$export$179dd5c00c1b0557 = (selectedNode)=>()=>{
        const url = $3b3f6c598d36873f$export$98ee8d0cf866fa75(selectedNode);
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
        return true;
    };
const $3b3f6c598d36873f$export$fff41c4cbbf6af3e = (selectedNode)=>()=>{
        const url = $3b3f6c598d36873f$export$98ee8d0cf866fa75(selectedNode);
        if (url) navigator.clipboard.writeText(url);
        return true;
    };
const $3b3f6c598d36873f$export$15a48157d97d7f65 = (state, dispatch)=>{
    dispatch?.(state.tr.setMeta((0, $fm4ja.pluginKey), {
        type: 'SHOW_URL_TOOLBAR'
    }));
    return true;
};
const $3b3f6c598d36873f$export$61961fed5a5ec57a = (state, dispatch)=>{
    dispatch?.(state.tr.setMeta((0, $fm4ja.pluginKey), {
        type: 'HIDE_URL_TOOLBAR'
    }));
    return true;
};
module.exports["createOpenInNewWindowCommand"] = $3b3f6c598d36873f$export$179dd5c00c1b0557;
module.exports["createCopyLinkCommand"] = $3b3f6c598d36873f$export$fff41c4cbbf6af3e;
module.exports["showUrlToolbar"] = $3b3f6c598d36873f$export$15a48157d97d7f65;
module.exports["hideUrlToolbar"] = $3b3f6c598d36873f$export$61961fed5a5ec57a;

});

parcelRegister("ftNR1", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $9K4OG = parcelRequire("9K4OG");


var $eKkkY = parcelRequire("eKkkY");

var $7Irim = parcelRequire("7Irim");


var $2MuFw = parcelRequire("2MuFw");


var $6B0jU = parcelRequire("6B0jU");


var $gKvd9 = parcelRequire("gKvd9");


var $8cjip = parcelRequire("8cjip");


var $1bY7o = parcelRequire("1bY7o");


var $6qvTD = parcelRequire("6qvTD");


var $82gXq = parcelRequire("82gXq");


var $14IP7 = parcelRequire("14IP7");

function $6393e0f1b3014e6b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6393e0f1b3014e6b$var$toggleButtonStyles = {
    name: "obigdm",
    styles: "display:flex;align-items:center;cursor:default;&&{background:none;border:none;padding:0;min-height:unset;}"
};
const $6393e0f1b3014e6b$var$createHandlerCommand = (handler)=>()=>{
        handler?.();
        return true;
    };
function $6393e0f1b3014e6b$var$convertCustomActionToDropdownOption(action, parameters, editorToolbarHandlers) {
    const IconComponent = action.icon;
    const handler = editorToolbarHandlers[action.handlerKey];
    return {
        id: `native-embed-${action.key}`,
        title: action.label,
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)(IconComponent, {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        disabled: action.disabled,
        onClick: $6393e0f1b3014e6b$var$createHandlerCommand(handler ? ()=>handler(parameters) : undefined)
    };
}
/**
 * Creates a registry of built-in "More Options" dropdown items.
 */ function $6393e0f1b3014e6b$var$createBuiltinMoreOptionsRegistry(api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, intl) {
    const toggleAlwaysShowTitle = (0, $14IP7.createToggleAlwaysShowTitle)(api, selectedNativeEmbed.node);
    return {
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE]: {
            id: 'native-embed-always-show-title',
            title: intl.formatMessage((0, $7Irim.nativeEmbedToolbarMessages).alwaysShowTitle),
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
                type: "button",
                css: $6393e0f1b3014e6b$var$toggleButtonStyles,
                onClick: (e)=>{
                    e.stopPropagation();
                    toggleAlwaysShowTitle();
                }
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $82gXq.default), {
                isChecked: (0, $14IP7.getAlwaysShowTitleState)(selectedNativeEmbed.node),
                label: intl.formatMessage((0, $7Irim.nativeEmbedToolbarMessages).alwaysShowTitle)
            })),
            onClick: editorToolbarHandlers.onShowTitleClick()
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SET_EMBED_TYPE]: {
            id: 'native-embed-set-embed-type',
            title: intl.formatMessage((0, $7Irim.nativeEmbedToolbarMessages).setEmbedType),
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onSetEmbedTypeClick()
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY]: {
            id: 'native-embed-copy',
            title: intl.formatMessage((0, $eKkkY.messages).copy),
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onCopyClick()
        },
        /**
     * @private
     * @deprecated Use COPY instead. Will be removed in a follow-up PR.
     */ [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY_LINK]: {
            id: 'native-embed-copy-link',
            title: intl.formatMessage((0, $eKkkY.messages).copyLink),
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onCopyLinkClick()
        },
        [(0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE]: {
            id: 'native-embed-delete',
            title: intl.formatMessage((0, $eKkkY.messages).deleteBlock),
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onDeleteClick(),
            ...deleteHoverProps
        }
    };
}
const $6393e0f1b3014e6b$var$DEFAULT_MORE_OPTIONS = [
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SET_EMBED_TYPE,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).DELETE
];
function $6393e0f1b3014e6b$var$resolveMoreOptions(items, builtinRegistry, customActions, parameters, editorToolbarHandlers) {
    const options = [];
    for (const key of items){
        if (key === (0, $6qvTD.BUILTIN_TOOLBAR_KEYS).SEPARATOR) options.push({
            type: 'separator'
        });
        else if (key in builtinRegistry) options.push(builtinRegistry[key]);
        else if (customActions && key in customActions) options.push($6393e0f1b3014e6b$var$convertCustomActionToDropdownOption(customActions[key], parameters, editorToolbarHandlers));
    }
    return options;
}
const $6393e0f1b3014e6b$export$6030df2c7cd7819c = (api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, parameters, intl, moreItems, customActions)=>{
    const builtinRegistry = $6393e0f1b3014e6b$var$createBuiltinMoreOptionsRegistry(api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, intl);
    const items = moreItems ?? $6393e0f1b3014e6b$var$DEFAULT_MORE_OPTIONS;
    const options = $6393e0f1b3014e6b$var$resolveMoreOptions(items, builtinRegistry, customActions, parameters, editorToolbarHandlers);
    return {
        id: 'native-embed-more-options-button',
        testId: 'native-embed-more-options-button',
        type: 'overflow-dropdown',
        dropdownWidth: 250,
        options: options
    };
};
module.exports["getMoreOptionsDropdown"] = $6393e0f1b3014e6b$export$6030df2c7cd7819c;

});

parcelRegister("14IP7", function(module, exports) {

var $8Yt3t = parcelRequire("8Yt3t");

const $9c053b70d7aaa2ca$export$3b3f7272b13b81ea = (selectedNode)=>{
    return (0, $8Yt3t.getParameters)(selectedNode.attrs.parameters, 'alwaysShowTitle');
};
const $9c053b70d7aaa2ca$export$9f930146f49815d = (api, selectedNode)=>()=>{
        const localId = selectedNode.attrs.localId;
        if (!localId) return;
        const extensionApi = api?.extension?.actions?.api();
        if (!extensionApi?.doc?.update) return;
        const current = $9c053b70d7aaa2ca$export$3b3f7272b13b81ea(selectedNode);
        extensionApi.doc.update(localId, (node)=>({
                attrs: {
                    ...node.attrs,
                    parameters: (0, $8Yt3t.setParameter)(node.attrs?.parameters, {
                        alwaysShowTitle: !current
                    })
                }
            }));
    };
module.exports["getAlwaysShowTitleState"] = $9c053b70d7aaa2ca$export$3b3f7272b13b81ea;
module.exports["createToggleAlwaysShowTitle"] = $9c053b70d7aaa2ca$export$9f930146f49815d;

});

parcelRegister("3yGVx", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $6qvTD = parcelRequire("6qvTD");


var $iJwOr = parcelRequire("iJwOr");

var $iobcl = parcelRequire("iobcl");

var $14IP7 = parcelRequire("14IP7");

var $9BKHQ = parcelRequire("9BKHQ");


var $jbMqk = parcelRequire("jbMqk");




const $5f2309d1c848a8f8$var$createHandlerCommand = (handler)=>()=>{
        handler?.();
        return true;
    };
function $5f2309d1c848a8f8$var$wrapManifestHandler(handler, parameters, handlerContext) {
    return ()=>$5f2309d1c848a8f8$var$createHandlerCommand(()=>handler(parameters, handlerContext));
}
function $5f2309d1c848a8f8$var$wrapManifestHandlerWithContext(handler, parameters, handlerContext) {
    return (context)=>$5f2309d1c848a8f8$var$createHandlerCommand(()=>handler(parameters, context, handlerContext));
}
/**
 * Creates a Command that copies the native-embed node to the clipboard.
 * Delegates to the floating-toolbar plugin's `copyNode` command when available,
 * falling back to `createCopyLinkCommand` (copies URL string) when the
 * floating-toolbar plugin is not present.
 */ function $5f2309d1c848a8f8$var$createCopyNodeCommand(selectedNativeEmbed, api) {
    const copyNodeCommand = api?.floatingToolbar?.commands?.copyNode(selectedNativeEmbed.node.type, (0, $d925B.INPUT_METHOD).FLOATING_TB);
    if (copyNodeCommand) return ()=>{
        api?.core?.actions.execute(copyNodeCommand);
        return true;
    };
    // Fallback: copy the URL string when floating-toolbar plugin is unavailable
    return (0, $iJwOr.createCopyLinkCommand)(selectedNativeEmbed.node);
}
function $5f2309d1c848a8f8$export$f4fb53cb783b2797(selectedNativeEmbed, api, intl, schema, parameters) {
    const node = selectedNativeEmbed.node;
    const askRovoButton = api?.aiExperience?.actions?.getAskRovoFloatingToolbarButton?.({
        intl: intl,
        triggeredFor: schema.nodes.extension
    });
    const summariseButton = parameters.url ? api?.aiExperience?.actions?.getSummariseSmartlinkFloatingToolbarButton?.({
        intl: intl,
        smartlinkUrl: parameters.url,
        triggeredFor: schema.nodes.extension
    }) : undefined;
    return {
        onAppearanceClick: (appearance)=>(0, $jbMqk.setNativeEmbedAppearance)(selectedNativeEmbed, appearance, api?.analytics?.actions),
        onAlignmentClick: (alignment)=>(0, $9BKHQ.createUpdateAlignmentCommand)(api, alignment, node),
        onCopyClick: ()=>$5f2309d1c848a8f8$var$createCopyNodeCommand(selectedNativeEmbed, api),
        onCopyLinkClick: ()=>(0, $iJwOr.createCopyLinkCommand)(node),
        onDeleteClick: ()=>(0, $iobcl.createDeleteCommand)(selectedNativeEmbed),
        onShowTitleClick: ()=>$5f2309d1c848a8f8$var$createHandlerCommand((0, $14IP7.createToggleAlwaysShowTitle)(api, node)),
        onOpenInNewWindowClick: ()=>(0, $iJwOr.createOpenInNewWindowCommand)(node),
        onEditUrlClick: ()=>(0, $iJwOr.showUrlToolbar),
        onEditClick: ()=>(0, $iJwOr.showUrlToolbar),
        onAskRovoClick: ()=>askRovoButton?.onClick ?? $5f2309d1c848a8f8$var$createHandlerCommand(()=>{}),
        onSummariseClick: ()=>summariseButton?.onClick ?? $5f2309d1c848a8f8$var$createHandlerCommand(()=>{}),
        onRefreshClick: ()=>$5f2309d1c848a8f8$var$createHandlerCommand(()=>{}),
        onChangeBorderClick: ()=>$5f2309d1c848a8f8$var$createHandlerCommand(()=>{}),
        onSetEmbedTypeClick: ()=>$5f2309d1c848a8f8$var$createHandlerCommand(()=>{})
    };
}
function $5f2309d1c848a8f8$export$dfa1706461ea0aa3(selectedNativeEmbed, manifestHandlers, api, parameters, intl, schema) {
    const defaultHandlers = $5f2309d1c848a8f8$export$f4fb53cb783b2797(selectedNativeEmbed, api, intl, schema, parameters);
    const result = {
        ...defaultHandlers
    };
    const handlerContext = {
        editorApi: api
    };
    for (const key of (0, $6qvTD.EDITOR_TOOLBAR_HANDLER_KEYS)){
        const manifestHandler = manifestHandlers?.[key];
        if (!manifestHandler) continue;
        switch(key){
            case 'onAlignmentClick':
                result.onAlignmentClick = $5f2309d1c848a8f8$var$wrapManifestHandlerWithContext(manifestHandler, parameters, handlerContext);
                break;
            case 'onAppearanceClick':
                result.onAppearanceClick = $5f2309d1c848a8f8$var$wrapManifestHandlerWithContext(manifestHandler, parameters, handlerContext);
                break;
            default:
                result[key] = $5f2309d1c848a8f8$var$wrapManifestHandler(manifestHandler, parameters, handlerContext);
        }
    }
    return result;
}
module.exports["buildToolbarHandlers"] = $5f2309d1c848a8f8$export$dfa1706461ea0aa3;

});

parcelRegister("iobcl", function(module, exports) {
const $fd8f38df26fbb7b0$export$fca8c83126802dc4 = (selectedNativeEmbed)=>(state, dispatch)=>{
        const { pos: pos, node: node } = selectedNativeEmbed;
        if (dispatch) dispatch(state.tr.delete(pos, pos + node.nodeSize));
        return true;
    };
module.exports["createDeleteCommand"] = $fd8f38df26fbb7b0$export$fca8c83126802dc4;

});

parcelRegister("9BKHQ", function(module, exports) {

var $8Yt3t = parcelRequire("8Yt3t");

const $7adc5b057587bf68$export$f0989780f32bfcda = (selectedNode)=>{
    return (0, $8Yt3t.getParameters)(selectedNode.attrs.parameters, 'alignment');
};
const $7adc5b057587bf68$export$c29861a26436e3b2 = (api, alignment, selectedNode)=>()=>{
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: (0, $8Yt3t.setParameter)(current.attrs?.parameters, {
                        alignment: alignment
                    })
                }
            }));
        return true;
    };
module.exports["createUpdateAlignmentCommand"] = $7adc5b057587bf68$export$c29861a26436e3b2;

});

parcelRegister("jbMqk", function(module, exports) {

var $81OAa = parcelRequire("81OAa");


var $d925B = parcelRequire("d925B");


var $8Yt3t = parcelRequire("8Yt3t");

function $cb74c8ad7d86c6f8$var$buildUrlReplacement(schema, url) {
    const { link: link } = schema.marks;
    if (!link) return null;
    const linkContent = schema.text(url, [
        link.create({
            href: url
        })
    ]);
    return schema.nodes.paragraph.create(null, linkContent);
}
function $cb74c8ad7d86c6f8$var$buildCardReplacement(schema, appearance, url) {
    const cardType = appearance === 'inline' ? schema.nodes.inlineCard : schema.nodes.blockCard;
    if (!cardType) return null;
    const cardNode = cardType.create({
        url: url
    });
    return appearance === 'inline' ? schema.nodes.paragraph.create(null, cardNode) : cardNode;
}
const $cb74c8ad7d86c6f8$export$22fb0ae5e9d8c713 = (selected, appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        if (appearance === 'embed') return false;
        const { pos: pos, node: node } = selected;
        const { schema: schema } = state;
        const url = (0, $8Yt3t.getParameter)(node.attrs.parameters, 'url');
        let content = null;
        if (url && (0, $81OAa.isSafeUrl)(url)) {
            if (appearance === 'url') content = $cb74c8ad7d86c6f8$var$buildUrlReplacement(schema, url);
            else if (appearance === 'inline' || appearance === 'block') content = $cb74c8ad7d86c6f8$var$buildCardReplacement(schema, appearance, url);
        }
        if (content && dispatch) {
            const tr = state.tr.replaceWith(pos, pos + node.nodeSize, content).scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_TYPE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    newType: appearance,
                    previousType: 'nativeEmbed'
                }
            })(tr);
            dispatch(tr);
        }
        return true;
    };
module.exports["setNativeEmbedAppearance"] = $cb74c8ad7d86c6f8$export$22fb0ae5e9d8c713;

});

parcelRegister("3Jily", function(module, exports) {
/* ResizableNativeEmbed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $jTxSS = parcelRequire("jTxSS");


var $kHu5n = parcelRequire("kHu5n");

var $kz7Zs = parcelRequire("kz7Zs");

var $6MTPr = parcelRequire("6MTPr");


var $6fQl1 = parcelRequire("6fQl1");


var $8b5jG = parcelRequire("8b5jG");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $8Yt3t = parcelRequire("8Yt3t");


var $9I1d6 = parcelRequire("9I1d6");


var $9BKHQ = parcelRequire("9BKHQ");


var $1uTOu = parcelRequire("1uTOu");


var $dzTOD = parcelRequire("dzTOD");


var $i12w8 = parcelRequire("i12w8");


var $iNSOc = parcelRequire("iNSOc");

const $2fbe46870cea0444$export$fe623d3106c02058 = 'nativeEmbed.resizerNext.testid';
// Styles (compiled CSS)
// ---------------------------------------------------------------------------
const $2fbe46870cea0444$var$resizerWrapperStyles = null;
const $2fbe46870cea0444$var$resizerPlaceholderStyles = null; // TODO: CNS-24595 - use the constants file.
const $2fbe46870cea0444$var$MIN_WIDTH = 200;
const $2fbe46870cea0444$var$SNAP_GAP = 8;
const $2fbe46870cea0444$var$CSS_VAR_NATIVE_EMBED_WIDTH = '--native-embed-width'; /**
                                                            * Maps AlignmentValue to RichMediaLayout for guideline snapping.
                                                            * AlignmentValue uses 'left'/'right', but RichMediaLayout expects 'align-start'/'align-end'.
                                                            */ 
const $2fbe46870cea0444$var$mapAlignmentToLayout = (alignment)=>{
    if (alignment === 'left') return 'align-start';
    if (alignment === 'right') return 'align-end';
     // 'center', 'wrap-left', 'wrap-right' pass through unchanged
    return alignment;
};
const $2fbe46870cea0444$export$e13db278c164b556 = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi, disabled: disabled, editorView: view, appearance: appearance } = props;
    const disableHandles = !!disabled;
    const [selectedNativeEmbed, setSelectedNativeEmbed] = (0, $42omo.useState)(null);
    const [currentAlignment, setCurrentAlignment] = (0, $42omo.useState)('center'); // -----------------------------------------------------------------------
    // Reactive width plugin subscription
    // -----------------------------------------------------------------------
    const [lineLength, setLineLength] = (0, $42omo.useState)(()=>{
        return pluginInjectionApi?.width.sharedState.currentState()?.lineLength || (0, $aFUXX.akEditorDefaultLayoutWidth);
    });
    const [containerWidth, setContainerWidth] = (0, $42omo.useState)(()=>{
        return pluginInjectionApi?.width.sharedState.currentState()?.width || (0, $aFUXX.akEditorDefaultLayoutWidth);
    });
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = pluginInjectionApi?.width.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState) {
                setLineLength(nextSharedState.lineLength || (0, $aFUXX.akEditorDefaultLayoutWidth));
                setContainerWidth(nextSharedState.width || (0, $aFUXX.akEditorDefaultLayoutWidth));
            }
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        pluginInjectionApi
    ]); // -----------------------------------------------------------------------
    // Reactive native embed selection subscription
    // -----------------------------------------------------------------------
    // Single source of truth for the currently selected native embed identity.
    // The plugin state guarantees referential stability — a new object is only
    // created when pos, localId, or alignment actually changes — so the
    // downstream useEffect re-fires exactly when it should.
    const [selectedEmbed, setSelectedEmbed] = (0, $42omo.useState)(()=>{
        return pluginInjectionApi?.editorPluginNativeEmbeds?.sharedState?.currentState()?.selectedEmbed ?? null;
    }); // Guard to prevent shared state updates during resize (PM transactions
    // dispatched during drag would trigger re-renders and position jumps).
    // Also activated on mousedown on resize handles to prevent the editor
    // from deselecting the embed before the drag starts.
    const isResizingRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        const initial = pluginInjectionApi?.editorPluginNativeEmbeds?.sharedState?.currentState();
        setSelectedEmbed(initial?.selectedEmbed ?? null);
        setCurrentAlignment(initial?.selectedEmbed?.alignment ?? 'center');
        const unsub = pluginInjectionApi?.editorPluginNativeEmbeds?.sharedState?.onChange?.(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
            if (isResizingRef.current) return;
            const nextEmbed = nextSharedState?.selectedEmbed ?? null;
            const prevLocalId = prevSharedState?.selectedEmbed?.localId ?? null; // When the embed is deleted (pos goes null) or a different embed
            // slides into the same position (localId changes), reset hover
            // state. The mouse-leave event never fires because the embed DOM
            // element is removed rather than the cursor leaving it.
            if (nextEmbed === null || nextEmbed.localId !== prevLocalId) setIsHoveringResizeSurface(false);
            setSelectedEmbed(nextEmbed);
            if (nextEmbed !== null) setCurrentAlignment(nextEmbed.alignment);
        });
        return ()=>{
            unsub?.();
        };
    }, [
        pluginInjectionApi
    ]);
    (0, $42omo.useEffect)(()=>{
        const selected = view && (0, $i12w8.getSelectedNativeEmbedExtension)(view.state); // Batch all state updates together to avoid chaining
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).flushSync(()=>{
            if (selected) {
                const domNode = (0, $8m4tT.findDomRefAtPos)(selected.pos, view.domAtPos.bind(view));
                const element = domNode instanceof HTMLElement ? domNode : domNode.parentElement;
                if (element) {
                    const container = element.querySelector('.extension-container') ?? element.closest('.extension-container') ?? element; // Also grab the inner EmbedFrameWrapper container so we can
                    // update its inline width/height during drag. Without this
                    // the iframe stays at its old React-prop size until mouseup.
                    innerEmbedContainerRef.current = container.querySelector('[data-testid="native-embed-extension"]') ?? null; // Sync resizeWidth to the actual DOM width so the first drag
                    // starts from where the content visually is, not from the
                    // potentially stale currentWidth (e.g. lineLength fallback).
                    const rect = container.getBoundingClientRect();
                    const newWidth = rect.width > 0 ? Math.round(rect.width) : null;
                    setSelectedNativeEmbed(selected);
                    setEmbedDomElement(container);
                    if (newWidth !== null) {
                        setResizeWidth(newWidth);
                        const facade = (0, $9I1d6.getNativeEmbedFacade)();
                        const nodeUrl = (0, $8Yt3t.getParameters)(selected.node.attrs.parameters, 'url');
                        let manifest = nodeUrl ? facade.getManifestByUrl(nodeUrl) : undefined;
                        if (!manifest) {
                            const extensionKey = selected.node.attrs.extensionKey;
                            const experienceId = extensionKey?.split(':')[1];
                            if (experienceId) manifest = facade.getManifestById(experienceId);
                        }
                        const shouldLockAspectRatio = manifest?.lockResizeAspectRatio ?? true;
                        aspectRatioRef.current = shouldLockAspectRatio ? rect.height / rect.width : null;
                        fixedHeightRef.current = shouldLockAspectRatio ? null : Math.round(rect.height);
                    }
                } else setSelectedNativeEmbed(selected);
            } else if (selectedEmbed !== null) setSelectedNativeEmbed(null);
        });
    }, [
        selectedEmbed,
        view,
        view?.state
    ]);
    // -----------------------------------------------------------------------
    // Derive current width from node attributes (layout-aware)
    // -----------------------------------------------------------------------
    const currentWidth = (0, $42omo.useMemo)(()=>{
        if (!selectedNativeEmbed || !view) return 0, $aFUXX.akEditorDefaultLayoutWidth;
        const node = selectedNativeEmbed.node;
        if (!node) return 0, $aFUXX.akEditorDefaultLayoutWidth;
        const storedWidth = (0, $1uTOu.getWidth)(node);
        if (storedWidth) return storedWidth;
         // TODO: CNS-24595 - review this logic.
        const layout = node.attrs.layout || 'default';
        const paramWidth = node.attrs.parameters?.width; // Always use the persisted parameters.width when available — this is
        // the committed pixel width from the last resize operation.
        if (typeof paramWidth === 'number' && paramWidth > 0) return paramWidth;
         // Fallback when no parameters.width is set (first render / never resized)
        if (layout === 'wide') return Math.ceil(lineLength * (0, $aFUXX.breakoutWideScaleRatio));
        if (layout === 'full-width') return 0, $aFUXX.akEditorFullWidthLayoutWidth;
        return lineLength; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedNativeEmbed,
        lineLength
    ]); // The max width of the parent node of the nested node,
    // OR undefined if the node is not nested
    const nestedMaxWidth = (0, $42omo.useMemo)(()=>{
        if (!selectedNativeEmbed || !view) return undefined;
        return (0, $6fQl1.getParentNodeWidth)(selectedNativeEmbed.pos, view.state, {
            width: containerWidth,
            lineLength: lineLength
        });
    }, [
        selectedNativeEmbed,
        view,
        containerWidth,
        lineLength
    ]);
    const isNested = nestedMaxWidth !== undefined;
    const maxWidth = (0, $42omo.useMemo)(()=>{
        return nestedMaxWidth ?? (0, $iNSOc.calcMaxWidth)(containerWidth, appearance);
    }, [
        nestedMaxWidth,
        containerWidth,
        appearance
    ]); // -----------------------------------------------------------------------
    // Resize state
    // -----------------------------------------------------------------------
    const [isResizing, setIsResizing] = (0, $42omo.useState)(false);
    const [resizeWidth, setResizeWidth] = (0, $42omo.useState)(currentWidth);
    const [snaps, setSnaps] = (0, $42omo.useState)({}); // Sync resizeWidth with currentWidth when not actively resizing.
    // Use a ref to track the last committed width so we don't snap back
    // to a stale currentWidth while the async extension API update propagates.
    const committedWidthRef = (0, $42omo.useRef)(null);
    const aspectRatioRef = (0, $42omo.useRef)(null);
    const fixedHeightRef = (0, $42omo.useRef)(null);
    const lastSnappedGuidelineKeysRef = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        if (!isResizing) {
            // If we have a recently committed width, only sync once currentWidth
            // matches it (meaning the async update has propagated), or if the
            // selection changed entirely.
            if (committedWidthRef.current !== null) {
                if (currentWidth === committedWidthRef.current) // Extension API update has propagated — clear the guard
                committedWidthRef.current = null;
                 // Don't override resizeWidth until propagation completes
                return;
            } // Clamp the display width to maxWidth so that a stored full-width value
            // (e.g. akEditorFullWidthLayoutWidth = 1800) doesn't overflow a narrow
            // viewport — the embed will expand to the full stored width when the
            // viewport is wider.
            setResizeWidth(Math.min(currentWidth, maxWidth));
        }
    }, [
        currentWidth,
        isResizing,
        maxWidth
    ]);
    const [embedDomElement, setEmbedDomElement] = (0, $42omo.useState)(null);
    const innerEmbedContainerRef = (0, $42omo.useRef)(null); // For nested embeds, capture the actual pixel width of the parent container at
    // drag start. nestedMaxWidth is derived from ProseMirror schema attributes and may
    // not match the actual CSS-computed pixel width (e.g. layout columns with implicit
    // widths). This DOM measurement is the source of truth for clamping during drag.
    const nestedContainerWidthRef = (0, $42omo.useRef)(null);
    const [portalTarget, setPortalTarget] = (0, $42omo.useState)(null);
    const [nodeRect, setNodeRect] = (0, $42omo.useState)(null);
    const [overlayHoverSurfaceElement, setOverlayHoverSurfaceElement] = (0, $42omo.useState)(null);
    const [isHoveringResizeSurface, setIsHoveringResizeSurface] = (0, $42omo.useState)(false); // Measure the embed DOM position for overlay positioning.
    // Only runs when selection changes or resize finishes — NOT during drag.
    // During drag, the overlay position is computed live in the render body.
    (0, $42omo.useLayoutEffect)(()=>{
        // Skip during active resize to avoid stale measurements from transform styles
        if (isResizing) return;
        if (!selectedNativeEmbed || !view) {
            setNodeRect(null);
            setPortalTarget(null);
            return;
        }
        try {
            const domNode = (0, $8m4tT.findDomRefAtPos)(selectedNativeEmbed.pos, view.domAtPos.bind(view));
            const element = domNode instanceof HTMLElement ? domNode : domNode.parentElement;
            if (!element) {
                setNodeRect(null);
                setPortalTarget(null);
                return;
            } // Use .extension-container when present (matches floating toolbar anchor logic)
            const measureEl = element.querySelector('.extension-container') ?? element.closest('.extension-container') ?? element; // Use scroll container first, then content area
            const container = view.dom.closest('.fabric-editor-popup-scroll-parent') || view.dom.closest('.ak-editor-content-area') || view.dom.parentElement;
            if (!container) {
                setNodeRect(null);
                setPortalTarget(null);
                return;
            }
            setPortalTarget(container);
            const containerRect = container.getBoundingClientRect();
            const nodeRectRaw = measureEl.getBoundingClientRect();
            setNodeRect({
                top: nodeRectRaw.top - containerRect.top + container.scrollTop,
                left: nodeRectRaw.left - containerRect.left + container.scrollLeft,
                width: nodeRectRaw.width,
                height: nodeRectRaw.height
            });
        } catch  {
            setNodeRect(null);
            setPortalTarget(null);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedNativeEmbed,
        view,
        isResizing
    ]);
    const isWithinResizeSurface = (0, $42omo.useCallback)((target)=>{
        if (!(target instanceof Node)) return false;
        return !!embedDomElement?.contains(target) || !!overlayHoverSurfaceElement?.contains(target);
    }, [
        embedDomElement,
        overlayHoverSurfaceElement
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!embedDomElement && !overlayHoverSurfaceElement) {
            setIsHoveringResizeSurface(false);
            return;
        }
        const handleMouseEnter = ()=>{
            setIsHoveringResizeSurface(true);
        };
        const handleMouseLeave = (event)=>{
            if (isWithinResizeSurface(event.relatedTarget)) return;
            setIsHoveringResizeSurface(false);
        };
        const unbindEmbedDomElement = embedDomElement ? (0, $fFa3V.bindAll)(embedDomElement, [
            {
                type: 'mouseenter',
                listener: handleMouseEnter
            },
            {
                type: 'mouseleave',
                listener: handleMouseLeave
            }
        ]) : null;
        const unbindOverlayHoverSurfaceElement = overlayHoverSurfaceElement ? (0, $fFa3V.bindAll)(overlayHoverSurfaceElement, [
            {
                type: 'mouseenter',
                listener: handleMouseEnter
            },
            {
                type: 'mouseleave',
                listener: handleMouseLeave
            }
        ]) : null;
        return ()=>{
            unbindEmbedDomElement?.();
            unbindOverlayHoverSurfaceElement?.();
        };
    }, [
        embedDomElement,
        overlayHoverSurfaceElement,
        isWithinResizeSurface
    ]); // -----------------------------------------------------------------------
    // Guidelines
    // -----------------------------------------------------------------------
    const defaultGuidelines = (0, $42omo.useMemo)(()=>{
        return isNested ? [] : (0, $kz7Zs.generateDefaultGuidelines)(lineLength, containerWidth, false);
    }, [
        lineLength,
        containerWidth,
        isNested
    ]); // Mutable ref so handleResize can read current guidelines without re-creating
    const guidelinesRef = (0, $42omo.useMemo)(()=>({
            current: defaultGuidelines
        }), [
        defaultGuidelines
    ]);
    const isGuidelineEnabled = (0, $42omo.useMemo)(()=>{
        return !!pluginInjectionApi?.guideline;
    }, [
        pluginInjectionApi
    ]); // -----------------------------------------------------------------------
    // Resize handlers (must be before early return — hooks must run unconditionally)
    // -----------------------------------------------------------------------
    // Prevent mousedown on resize handles from propagating to the editor,
    // which would deselect the native embed and unmount the overlay before
    // the drag can start.
    const handleWrapperMouseDown = (0, $42omo.useCallback)((e)=>{
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;
         // Check if the click originated from within a resize handle element
        const isHandle = target.closest('.resizer-handle') || target.closest('.resizer-handle-thumb') || target.closest('.resizer-handle-track') || target.closest('[class*="resizer-handle"]');
        if (isHandle) {
            // Set the guard early so shared state updates that arrive between
            // mousedown and onResizeStart don't null out selectedEmbed
            isResizingRef.current = true;
            e.stopPropagation();
        }
    }, []);
    const handleResizeStart = (0, $42omo.useCallback)(()=>{
        setIsResizing(true);
        isResizingRef.current = true;
        lastSnappedGuidelineKeysRef.current = []; // Grab a reference to the actual embed DOM element so we can set its
        // width directly during drag for smooth live preview.
        if (selectedNativeEmbed && view) {
            try {
                const domNode = (0, $8m4tT.findDomRefAtPos)(selectedNativeEmbed.pos, view.domAtPos.bind(view));
                const element = domNode instanceof HTMLElement ? domNode : domNode.parentElement;
                if (element) {
                    const container = element.querySelector('.extension-container') ?? element.closest('.extension-container') ?? element;
                    setEmbedDomElement(container); // For nested embeds, capture the actual pixel width of the parent
                    // container at drag start. nestedMaxWidth (from ProseMirror schema)
                    // may not match the CSS-computed pixel width (e.g. layout columns
                    // with implicit widths). We use offsetParent's clientWidth as the
                    // true available width so that clamping during drag matches what
                    // the browser actually renders.
                    if (isNested) {
                        const parentEl = container.offsetParent;
                        if (parentEl) nestedContainerWidthRef.current = Math.round(parentEl.getBoundingClientRect().width);
                    } else nestedContainerWidthRef.current = null;
                     // Also grab the inner EmbedFrameWrapper container so we can
                    // update its inline width/height during drag. Without this
                    // the iframe stays at its old React-prop size until mouseup.
                    innerEmbedContainerRef.current = container.querySelector('[data-testid="native-embed-extension"]') ?? null; // Sync resizeWidth to the actual DOM width so the first drag
                    // starts from where the content visually is, not from the
                    // potentially stale currentWidth (e.g. lineLength fallback).
                    const rect = container.getBoundingClientRect();
                    if (rect.width > 0) {
                        setResizeWidth(Math.round(rect.width));
                        const facade = (0, $9I1d6.getNativeEmbedFacade)();
                        const nodeUrl = (0, $8Yt3t.getParameters)(selectedNativeEmbed.node.attrs.parameters, 'url');
                        let manifest = nodeUrl ? facade.getManifestByUrl(nodeUrl) : undefined;
                        if (!manifest) {
                            const extensionKey = selectedNativeEmbed.node.attrs.extensionKey;
                            const experienceId = extensionKey?.split(':')[1];
                            if (experienceId) manifest = facade.getManifestById(experienceId);
                        }
                        const shouldLockAspectRatio = manifest?.lockResizeAspectRatio ?? true;
                        if (shouldLockAspectRatio) {
                            aspectRatioRef.current = rect.height / rect.width;
                            fixedHeightRef.current = null;
                            container.style.setProperty('--native-embed-aspect-ratio', `${rect.width} / ${rect.height}`);
                        } else {
                            aspectRatioRef.current = null;
                            const currentHeight = Math.round(rect.height);
                            fixedHeightRef.current = currentHeight;
                            container.style.removeProperty('aspect-ratio');
                            container.style.setProperty('height', `${currentHeight}px`);
                            if (innerEmbedContainerRef.current) {
                                innerEmbedContainerRef.current.style.removeProperty('aspect-ratio');
                                innerEmbedContainerRef.current.style.setProperty('height', `${currentHeight}px`);
                            }
                        }
                    }
                }
            } catch  {}
            const { state: state, dispatch: dispatch } = view;
            const tr = state.tr;
            tr.setMeta((0, $dzTOD.NATIVE_EMBED_PLUGIN_IS_RESIZING_KEY), true);
            tr.setMeta('is-resizer-resizing', true);
            tr.setMeta('scrollIntoView', false);
            tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, selectedNativeEmbed.pos));
            dispatch(tr);
        }
    }, [
        view,
        selectedNativeEmbed,
        isNested
    ]);
    const handleResize = (0, $42omo.useCallback)((size, delta)=>{
        const newWidth = Math.round(size.width + delta.width); // Clamp width to maxWidth so the embed never extends past the
        // container boundary — matching media single behaviour.
        // For nested embeds, also clamp against the actual DOM pixel width
        // of the parent container measured at drag start, which is the
        // ground truth (nestedMaxWidth from ProseMirror schema may differ).
        const effectiveMax = isNested && nestedContainerWidthRef.current !== null ? Math.min(maxWidth, nestedContainerWidthRef.current) : maxWidth;
        const clampedWidth = Math.max($2fbe46870cea0444$var$MIN_WIDTH, Math.min(newWidth, effectiveMax));
        setResizeWidth(clampedWidth); // Auto-switch to center alignment when resizing past the threshold
        // while left or right aligned. This ensures the toolbar updates
        // immediately and the resize switches to both-sided behavior.
        const isSideAligned = currentAlignment === 'left' || currentAlignment === 'right' || currentAlignment === 'wrap-left' || currentAlignment === 'wrap-right';
        if (!isNested && isSideAligned && clampedWidth > lineLength) {
            setCurrentAlignment('center');
            if (selectedNativeEmbed?.node && view?.state && view?.dispatch) (0, $9BKHQ.createUpdateAlignmentCommand)(pluginInjectionApi, 'center', selectedNativeEmbed.node)(view?.state, view?.dispatch);
        } // Update active guidelines and track which guidelines are snapped
        // so handleResizeStop can detect full-width snaps.
        if (isGuidelineEnabled) {
            const layoutForGuidelines = $2fbe46870cea0444$var$mapAlignmentToLayout(currentAlignment);
            const guidelineSnaps = (0, $kHu5n.getGuidelineSnaps)(guidelinesRef.current, lineLength, layoutForGuidelines);
            if (guidelineSnaps.snaps.x) {
                const { gap: gap, keys: activeGuidelineKeys } = (0, $kHu5n.findClosestSnap)(clampedWidth, guidelineSnaps.snaps.x, guidelineSnaps.guidelineReference, $2fbe46870cea0444$var$SNAP_GAP);
                lastSnappedGuidelineKeysRef.current = activeGuidelineKeys;
                const nextGuideLines = (0, $6MTPr.getGuidelinesWithHighlights)(gap, $2fbe46870cea0444$var$SNAP_GAP, activeGuidelineKeys, guidelinesRef.current);
                view && pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
                    guidelines: nextGuideLines
                });
            }
            setSnaps({
                x: guidelineSnaps.snaps.x || []
            });
        } // The embed DOM element and inner container are updated via
    // useLayoutEffect (below) rather than here so they stay in sync
    // with the overlay wrapper, which is driven by React state
    // (resizeWidth). Both update in the same commit/paint cycle.
    }, [
        maxWidth,
        isNested,
        lineLength,
        guidelinesRef,
        isGuidelineEnabled,
        currentAlignment,
        selectedNativeEmbed,
        pluginInjectionApi,
        view
    ]); // Sync the embed DOM element and inner container with resizeWidth during
    // drag. This runs as a useLayoutEffect so the imperative DOM update
    // happens in the same commit phase as the React re-render that updates the
    // overlay wrapper — both are painted together, keeping them in sync.
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isResizing) return;
        if (embedDomElement) {
            embedDomElement.style.transition = 'none';
            if (isNested) {
                // For nested embeds, do NOT set an explicit width — doing so would
                // override the parent cell's layout constraints and let the embed
                // overflow. Instead, drive sizing only through maxWidth so CSS
                // and the parent container naturally clamp the visual size.
                embedDomElement.style.width = '';
                embedDomElement.style.minWidth = '';
                embedDomElement.style.maxWidth = `${resizeWidth}px`;
                embedDomElement.style.setProperty($2fbe46870cea0444$var$CSS_VAR_NATIVE_EMBED_WIDTH, `${resizeWidth}px`);
            } else {
                embedDomElement.style.width = `${resizeWidth}px`;
                embedDomElement.style.minWidth = `${resizeWidth}px`;
                embedDomElement.style.maxWidth = `${resizeWidth}px`;
                embedDomElement.style.removeProperty($2fbe46870cea0444$var$CSS_VAR_NATIVE_EMBED_WIDTH);
            }
        }
        const innerContainer = innerEmbedContainerRef.current;
        if (innerContainer) innerContainer.style.width = `${resizeWidth}px`;
    }, [
        isResizing,
        resizeWidth,
        embedDomElement,
        isNested
    ]);
    const handleResizeStop = (0, $42omo.useCallback)((_size, _delta)=>{
        // Determine whether the user snapped to the full-width guideline.
        // When they did, store akEditorFullWidthLayoutWidth (1800) rather
        // than the actual viewport pixel width — this mirrors the media
        // single behaviour so that the embed expands correctly when the
        // viewport grows later.
        const isFullWidthSnap = lastSnappedGuidelineKeysRef.current.some((key)=>key.startsWith('full_width'));
        const committedWidth = !isNested && isFullWidthSnap ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : resizeWidth;
        committedWidthRef.current = committedWidth; // Clear the inline width/minWidth styles set during drag so that
        // the CSS variable (--native-embed-width) and stylesheet rules take over.
        // This allows the embed to respond correctly to future viewport changes.
        // Restore height: auto and max-width to the values that index.tsx sets on
        // the extension-container — clearing them entirely would remove properties
        // that index.tsx expects to persist, causing layout issues after resize.
        // For unlocked-aspect-ratio embeds (e.g. databases), restore the fixed
        // pixel height instead of auto so the height doesn't collapse between
        // handleResizeStop and the React re-render.
        if (embedDomElement) {
            embedDomElement.style.transition = '';
            embedDomElement.style.width = '';
            embedDomElement.style.minWidth = '';
            embedDomElement.style.setProperty('max-width', 'var(--ak-editor-max-container-width)');
            if (fixedHeightRef.current !== null) {
                embedDomElement.style.setProperty('height', `${fixedHeightRef.current}px`);
                embedDomElement.style.removeProperty('aspect-ratio');
            } else embedDomElement.style.setProperty('height', 'auto');
            embedDomElement.style.setProperty($2fbe46870cea0444$var$CSS_VAR_NATIVE_EMBED_WIDTH, `${committedWidth}px`);
        } // Clear inline styles on the inner container too so the iframe
        // fills whatever the CSS-driven container width ends up being.
        // For unlocked-aspect-ratio embeds, preserve the fixed pixel height
        // so the iframe doesn't collapse to 0 before the React re-render.
        const innerContainer = innerEmbedContainerRef.current;
        if (innerContainer) {
            innerContainer.style.width = '';
            if (fixedHeightRef.current !== null) {
                innerContainer.style.height = `${fixedHeightRef.current}px`;
                innerContainer.style.removeProperty('aspect-ratio');
            } else innerContainer.style.height = '';
        }
        innerEmbedContainerRef.current = null; // Clear guidelines and tracked snap keys
        view && pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: []
        });
        lastSnappedGuidelineKeysRef.current = [];
        if (!selectedNativeEmbed || !view) {
            setIsResizing(false);
            isResizingRef.current = false;
            return;
        } // Read the node fresh from the current state (not the stale closure)
        const currentNode = selectedNativeEmbed.node;
        if (!currentNode) {
            setIsResizing(false);
            isResizingRef.current = false;
            return;
        } // Commit width and layout to the document.
        // For locked-aspect-ratio embeds, derive the height from the ratio.
        // For unlocked embeds, commit the fixed height captured at resize start
        // so the ADF node retains the correct height parameter.
        const committedHeight = aspectRatioRef.current !== null ? Math.round(committedWidth * aspectRatioRef.current) : fixedHeightRef.current ?? undefined;
        (0, $1uTOu.createUpdateWidthCommand)(pluginInjectionApi, committedWidth, selectedNativeEmbed.node, committedHeight)(view.state, view.dispatch); // Clear resizing plugin state
        const { state: state, dispatch: dispatch } = view;
        const tr = state.tr;
        tr.setMeta((0, $dzTOD.NATIVE_EMBED_PLUGIN_IS_RESIZING_KEY), false);
        tr.setMeta('is-resizer-resizing', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr); // Release the resize guard after a frame so that the shared state
        // subscription ignores the transaction-triggered updates above.
        // Without this, the subscription would fire immediately with stale
        // DOM measurements, causing the handles to jump back.
        requestAnimationFrame(()=>{
            setIsResizing(false);
            isResizingRef.current = false;
        });
        aspectRatioRef.current = null;
        fixedHeightRef.current = null;
    }, [
        selectedNativeEmbed,
        pluginInjectionApi,
        view,
        embedDomElement,
        resizeWidth,
        isNested
    ]); // -----------------------------------------------------------------------
    // Early return — nothing to render (after all hooks)
    // -----------------------------------------------------------------------
    if (selectedEmbed === null && !isHoveringResizeSurface && !isResizing || !view || !nodeRect || !portalTarget || !selectedNativeEmbed) return null;
    const isRightTypeAligned = currentAlignment === 'right' || currentAlignment === 'wrap-right';
    const isLeftTypeAligned = currentAlignment === 'left' || currentAlignment === 'wrap-left';
    const enableRightHandle = !disableHandles && currentAlignment !== 'right' && currentAlignment !== 'wrap-right';
    const enableLeftHandle = !disableHandles && currentAlignment !== 'left' && currentAlignment !== 'wrap-left'; // -----------------------------------------------------------------------
    // Overlay positioning — center over the embed
    // -----------------------------------------------------------------------
    let wrapperLeft; // overlayWidth drives both the outer wrapper div and the ResizerNext width prop.
    // resizeWidth is already clamped to maxWidth (from ProseMirror schema) in handleResize.
    // For nested embeds we also cap against the actual DOM pixel width of the parent
    // container captured at drag start — this is the ground truth of available width,
    // since nestedMaxWidth (from ProseMirror attrs) may not match the CSS layout width.
    const actualNestedMax = nestedContainerWidthRef.current;
    const overlayWidth = isResizing ? isNested && actualNestedMax !== null ? Math.min(resizeWidth, actualNestedMax) : resizeWidth : Math.round(nodeRect.width);
    if (isResizing && embedDomElement && (isLeftTypeAligned || isRightTypeAligned)) {
        // For left/right aligned embeds during resize, read the actual DOM position
        // to keep handles attached to the iframe edges as width changes
        const portalRect = portalTarget.getBoundingClientRect();
        const embedRect = embedDomElement.getBoundingClientRect();
        wrapperLeft = embedRect.left - portalRect.left + portalTarget.scrollLeft;
    } else if (isResizing && embedDomElement) {
        // For center alignment during resize, read the left edge of the embed from DOM.
        // For non-nested embeds, centerX is derived from the embed's actual DOM center
        // (which tracks the drag symmetrically). For nested embeds, the embed container
        // takes full cell width (its inline width is cleared, only maxWidth is set), so
        // we use the embed's left edge and the resizeWidth to position the overlay so
        // handles track the visible content edges rather than the full cell width.
        const portalRect = portalTarget.getBoundingClientRect();
        const embedRect = embedDomElement.getBoundingClientRect();
        if (isNested) // For nested embeds, the embed container has width:'' + maxWidth:clampedWidth,
        // so embedRect.width = min(cellWidth, clampedWidth). overlayWidth is also
        // derived from embedRect.width (above), so the overlay exactly matches the
        // visible content. Left-align the overlay with the embed's left edge.
        wrapperLeft = embedRect.left - portalRect.left + portalTarget.scrollLeft;
        else {
            const centerX = embedRect.left - portalRect.left + portalTarget.scrollLeft + embedRect.width / 2;
            wrapperLeft = centerX - overlayWidth / 2;
        }
    } else if (isRightTypeAligned || isLeftTypeAligned) // When not resizing, use nodeRect position directly for aligned embeds
    wrapperLeft = nodeRect.left;
    else {
        // Center alignment when not resizing - calculate from nodeRect center
        const centerX = nodeRect.left + nodeRect.width / 2;
        wrapperLeft = centerX - overlayWidth / 2;
    }
    const resizerWrapperDynamicStyles = {
        top: nodeRect.top,
        left: wrapperLeft,
        width: overlayWidth
    };
    const isHandleVisible = !disableHandles && nodeRect.height && (isResizing || isHoveringResizeSurface); /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic overlay positioning from DOM measurements */ 
    const overlay = /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "native-embed-resizer",
        role: "presentation",
        ref: setOverlayHoverSurfaceElement,
        onMouseDown: handleWrapperMouseDown,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: resizerWrapperDynamicStyles,
            "data-testid": "native-embed-resizer-wrapper",
            className: (0, $gMc0m.default)([
                "_kqswstnw _lcxv1wug _w4h2stnw _1oc91wug _6ndbom82 _omtm1t8v"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8b5jG.default /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ ), {
                enable: {
                    left: enableLeftHandle,
                    right: enableRightHandle
                },
                width: overlayWidth,
                minWidth: $2fbe46870cea0444$var$MIN_WIDTH,
                maxWidth: isNested && actualNestedMax !== null ? actualNestedMax : maxWidth,
                handleResizeStart: handleResizeStart,
                handleResize: handleResize,
                handleResizeStop: handleResizeStop,
                snapGap: $2fbe46870cea0444$var$SNAP_GAP,
                snap: snaps,
                resizeRatio: currentAlignment === 'center' ? 2 : 1,
                isHandleVisible: !!isHandleVisible,
                handleHighlight: "full-height",
                "data-testid": $2fbe46870cea0444$export$fe623d3106c02058,
                children: /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic height from DOM
                , {
                    style: {
                        height: isResizing && aspectRatioRef.current !== null ? Math.round(resizeWidth * aspectRatioRef.current) : nodeRect.height || 600
                    },
                    className: (0, $gMc0m.default)([
                        "_1bsb1osq _lcxvglyw"
                    ])
                })
            })
        })
    }); /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(overlay, portalTarget);
};
module.exports["ResizableNativeEmbed"] = $2fbe46870cea0444$export$e13db278c164b556;

});

parcelRegister("dzTOD", function(module, exports) {
const $a4e3d4db73377dce$export$721d3977e29c986e = 'nativeEmbedPlugin.isResizing';
const $a4e3d4db73377dce$export$18e96586e523cafb = 'nativeEmbedPlugin.resizing-width';
module.exports["NATIVE_EMBED_PLUGIN_IS_RESIZING_KEY"] = $a4e3d4db73377dce$export$721d3977e29c986e;

});

parcelRegister("iNSOc", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");

const $07c8e8e34725e585$export$de18d2ff56094455 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $aFUXX.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $aFUXX.akEditorFullWidthLayoutWidth));
};
module.exports["calcMaxWidth"] = $07c8e8e34725e585$export$de18d2ff56094455;

});

parcelRegister("dme7x", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $140a6738094f1583$export$43594b7b1d8b2d04 = new (0, $ks2lK.PluginKey)('contentFormat');
const $140a6738094f1583$export$ae829ec7b2625219 = ({ initialContentMode: initialContentMode })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $140a6738094f1583$export$43594b7b1d8b2d04,
        state: {
            init: ()=>({
                    contentMode: initialContentMode ?? 'standard'
                }),
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($140a6738094f1583$export$43594b7b1d8b2d04);
                if (meta) {
                    const { contentMode: contentMode } = meta;
                    return {
                        contentMode: contentMode ?? currentPluginState.contentMode
                    };
                }
                return currentPluginState;
            }
        }
    });
};
const $140a6738094f1583$export$c0bae1e3feda2109 = ({ config: options })=>{
    let previousContentMode;
    return {
        name: 'contentFormat',
        getSharedState (editorState) {
            if (!editorState) return {
                contentMode: options?.initialContentMode ?? 'standard'
            };
            const pluginState = $140a6738094f1583$export$43594b7b1d8b2d04.getState(editorState);
            return {
                contentMode: pluginState?.contentMode ?? 'standard'
            };
        },
        commands: {
            updateContentMode: (contentMode)=>({ tr: tr })=>{
                    if (contentMode === previousContentMode) return null;
                    previousContentMode = contentMode;
                    return tr.setMeta($140a6738094f1583$export$43594b7b1d8b2d04, {
                        contentMode: contentMode
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'contentFormat',
                    plugin: ()=>$140a6738094f1583$export$ae829ec7b2625219({
                            initialContentMode: options?.initialContentMode ?? 'standard'
                        })
                }
            ];
        }
    };
};
module.exports["contentFormatPlugin"] = $140a6738094f1583$export$c0bae1e3feda2109;

});

parcelRegister("dMGoR", function(module, exports) {

var $7XNmJ = parcelRequire("7XNmJ");

const $52f07778744473c8$export$986a2ab002dbd574 = ()=>({
        name: 'forgeExtension',
        pmPlugins () {
            return [
                {
                    name: 'forgeExtensionUniqueId',
                    plugin: ()=>(0, $7XNmJ.createUniqueLocalIdPlugin)()
                }
            ];
        }
    });
module.exports["forgeEditorPlugin"] = $52f07778744473c8$export$986a2ab002dbd574;

});

parcelRegister("7XNmJ", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $1S4f7 = parcelRequire("1S4f7");


var $3Ter7 = parcelRequire("3Ter7");


var $ks2lK = parcelRequire("ks2lK");


var $31HPn = parcelRequire("31HPn");

function $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node) {
    return node.attrs.extensionType === (0, $31HPn.EXTENSION_NAMESPACE) ? node.attrs.parameters?.localId : undefined;
}
// When Forge extensions are copied, the attrs.localId should be the same as the attrs.parameters.localId.
// Otherwise, it won't be able to use the parameters.localId to locate the node (which is checked against by attrs.localId in editor-plugin-extension/src/pm-plugins/extension-api.ts).
function $10ea5100eae0eecb$var$handleForgeExtensionLocalId({ slice: slice, filterForgeExtensionNode: filterForgeExtensionNode }) {
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (filterForgeExtensionNode(node) && $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node) !== node.attrs.localId) {
            const attrs = {
                ...node.attrs,
                localId: $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node)
            };
            return node.type.create(attrs, node.content, node.marks);
        }
        return node;
    });
}
const $10ea5100eae0eecb$export$cb7a3598b76b7e74 = ()=>new (0, $1S4f7.SafePlugin)({
        key: new (0, $ks2lK.PluginKey)('forgeExtensionUniqueLocalIdPlugin'),
        props: {
            transformPasted: (slice, view)=>{
                const state = view.state;
                const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
                const extensionTypes = new Set([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ]);
                const forgeIdsObserved = new Set();
                const iterateExtensions = (fragment, handler)=>{
                    fragment.descendants((node, pos)=>{
                        if (!!node.type && extensionTypes.has(node.type)) {
                            handler(node, pos);
                            /**
							 * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
							 * since we can have more extension nodes within the contents of that
							 */ return [
                                multiBodiedExtension,
                                bodiedExtension
                            ].includes(node.type);
                        }
                        /**
						 * Otherwise continue traversing, we can encounter extensions nested in
						 * expands/bodiedExtensions
						 */ return true;
                    });
                };
                // Loop through document to see what IDs are already in use
                iterateExtensions(state.doc, (node)=>{
                    const forgeLocalId = $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node);
                    if (forgeLocalId) forgeIdsObserved.add(forgeLocalId);
                });
                // Now, loop through the pasted content and generate new IDs for any that are already in use
                iterateExtensions(slice.content, (node)=>{
                    const forgeLocalId = $10ea5100eae0eecb$var$getForgeLocalIdFromNode(node);
                    if (!forgeLocalId) return;
                    if (!forgeIdsObserved.has(forgeLocalId)) forgeIdsObserved.add(forgeLocalId);
                    else // attrs.localId will be updated in handleLocalId
                    node.attrs.parameters.localId = (0, $fO7hX.uuid).generate();
                });
                function filterForgeExtensionNode(node) {
                    return !!node.type && extensionTypes.has(node.type) && !!$10ea5100eae0eecb$var$getForgeLocalIdFromNode(node);
                }
                slice = $10ea5100eae0eecb$var$handleForgeExtensionLocalId({
                    slice: slice,
                    filterForgeExtensionNode: filterForgeExtensionNode
                });
                return slice;
            }
        }
    });
module.exports["createUniqueLocalIdPlugin"] = $10ea5100eae0eecb$export$cb7a3598b76b7e74;

});

parcelRegister("iHrpD", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $3Ter7 = parcelRequire("3Ter7");


var $1S4f7 = parcelRequire("1S4f7");


var $l6okE = parcelRequire("l6okE");

var $adhil = parcelRequire("adhil");


var $kMORl = parcelRequire("kMORl");

const $e91b9f4cdd3698fb$var$pluginName = 'legacyContentMacroPlugin';
const $e91b9f4cdd3698fb$var$pluginKey = new (0, $ks2lK.PluginKey)($e91b9f4cdd3698fb$var$pluginName);
const $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.type.name === 'extension' && extensionNode.attrs?.extensionType === $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $e91b9f4cdd3698fb$export$a0ccdff7cb069dd7 = ({ config: config })=>{
    const isInnerEditor = !!config?.nodeId;
    return {
        name: $e91b9f4cdd3698fb$var$pluginName,
        pmPlugins () {
            return [
                {
                    name: $e91b9f4cdd3698fb$var$pluginName,
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            key: $e91b9f4cdd3698fb$var$pluginKey,
                            state: {
                                init () {
                                    return {
                                        nodeId: null,
                                        side: null,
                                        arrowKeyPressed: null,
                                        isSelectionAtEdge: null
                                    };
                                },
                                apply: (tr, currentPluginState)=>{
                                    const meta = tr.getMeta($e91b9f4cdd3698fb$var$pluginKey);
                                    if (meta) return {
                                        ...currentPluginState,
                                        ...meta
                                    };
                                    return currentPluginState;
                                }
                            },
                            props: {
                                handleDOMEvents: {
                                    keydown (view, event) {
                                        // If the user selects an LCM node and clicks an arrow, update the state with
                                        // the arrow they clicked and the selected node to use for keyboard navigation
                                        // logic in the extension-handler
                                        // We need to track two events to derive the user intention:
                                        //   1. Arrow key press event when selecting the node, to know whether the user
                                        //      is coming from the left or right gap cursor
                                        //   2. Arrow key press event when the node is selected, to know where to enter
                                        //      the legacy content macro
                                        // All of these keyboard events are only activated in the outer editor because
                                        // you can't have selections on the LCM node in the inner editor
                                        if (event instanceof KeyboardEvent && [
                                            'ArrowUp',
                                            'ArrowDown',
                                            'ArrowLeft',
                                            'ArrowRight'
                                        ].includes(event.key) && !isInnerEditor) {
                                            const { state: state, dispatch: dispatch } = view;
                                            const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(state);
                                            // When hitting the gap cursor before or after an LCM
                                            if (state.selection instanceof (0, $adhil.GapCursorSelection) && (state.selection.side === (0, $adhil.Side).RIGHT && state.selection.$from.nodeBefore !== null && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.$from.nodeBefore) || state.selection.side === (0, $adhil.Side).LEFT && state.selection.$from.nodeAfter !== null && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.$from.nodeAfter))) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                side: state.selection.side
                                            }));
                                            else if (state.selection instanceof (0, $ks2lK.NodeSelection) && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.node) && // Moving from the left into the LCM
                                            (event.key === 'ArrowRight' && pluginState?.side === (0, $adhil.Side).LEFT || // Moving from the right into the LCM
                                            event.key === 'ArrowLeft' && pluginState?.side === (0, $adhil.Side).RIGHT)) {
                                                dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: state.selection.node.attrs.localId,
                                                    arrowKeyPressed: event.key
                                                }));
                                                event.preventDefault();
                                            // When hitting the LCM from below or above
                                            } else if (state.selection instanceof (0, $ks2lK.NodeSelection) && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.node) && [
                                                'ArrowUp',
                                                'ArrowDown'
                                            ].includes(event.key)) {
                                                dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: state.selection.node.attrs.localId,
                                                    // When using the up and down arrow keys intent isn't obvious, so we assume the user wants to enter from the end when coming up and enter from the left when coming down
                                                    side: event.key === 'ArrowUp' ? (0, $adhil.Side).RIGHT : (0, $adhil.Side).LEFT,
                                                    arrowKeyPressed: event.key
                                                }));
                                                event.preventDefault();
                                            }
                                        }
                                        // In the inner editor detect when we try exiting the LCM node and trigger
                                        // selecting the LCM node
                                        if (event instanceof KeyboardEvent && [
                                            'ArrowUp',
                                            'ArrowDown',
                                            'ArrowLeft',
                                            'ArrowRight'
                                        ].includes(event.key) && isInnerEditor) {
                                            const { state: state, dispatch: dispatch } = view;
                                            if (state.selection instanceof (0, $adhil.GapCursorSelection) && // Arrow moving up or left at the initial position of the encapsulating LCM
                                            ((event.key === 'ArrowUp' || event.key === 'ArrowLeft') && (0, $l6okE.atTheBeginningOfDoc)(state) || // Arrow moving down or right at the end position of the encapsulating LCM
                                            (event.key === 'ArrowDown' || event.key === 'ArrowRight') && (0, $l6okE.atTheEndOfDoc)(state))) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                nodeId: config.nodeId,
                                                isSelectionAtEdge: true
                                            }));
                                            else {
                                                const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(state);
                                                if (pluginState?.isSelectionAtEdge) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    isSelectionAtEdge: false
                                                }));
                                            }
                                        }
                                        return false;
                                    },
                                    blur (view) {
                                        // When entering the LCM editor from the outer editor, reset the state
                                        // to avoid unexpected selection issues
                                        if (!isInnerEditor) {
                                            const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(view.state);
                                            if (pluginState?.arrowKeyPressed) {
                                                const { tr: tr } = view.state;
                                                tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: null,
                                                    side: null,
                                                    arrowKeyPressed: null
                                                });
                                                view.dispatch(tr);
                                            }
                                        }
                                    }
                                },
                                handleDrop (_view, _event, slice) {
                                    // Disable drag-and-drop for selections with a legacy content macro extensions
                                    const sliceHasLegacyContentMacro = (0, $3Ter7.hasNode)((node)=>$e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(node))(slice);
                                    return sliceHasLegacyContentMacro;
                                }
                            }
                        });
                    }
                }
            ];
        },
        actions: {
            setSelection: $kMORl.setSelection
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { nodeId: nodeId, side: side, arrowKeyPressed: arrowKeyPressed, isSelectionAtEdge: isSelectionAtEdge } = $e91b9f4cdd3698fb$var$pluginKey.getState(state) ?? {};
            return {
                nodeId: nodeId,
                side: side,
                arrowKeyPressed: arrowKeyPressed,
                isSelectionAtEdge: isSelectionAtEdge
            };
        }
    };
};
module.exports["legacyContentMacroPlugin"] = $e91b9f4cdd3698fb$export$a0ccdff7cb069dd7;

});

parcelRegister("kMORl", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $3ff08e22c2836b71$export$f6e36f80a8190133 = (selection)=>(state, dispatch)=>{
        if (!dispatch) return false;
        const emptySelection = (0, $ks2lK.TextSelection).create(state.doc, 0);
        const tr = state.tr.setSelection(selection ?? emptySelection);
        dispatch(tr);
        return true;
    };
module.exports["setSelection"] = $3ff08e22c2836b71$export$f6e36f80a8190133;

});

parcelRegister("ffQ2A", function(module, exports) {
const $b1b09ff39d31fcf8$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $b1b09ff39d31fcf8$var$idbProxyableTypes;
let $b1b09ff39d31fcf8$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $b1b09ff39d31fcf8$var$getIdbProxyableTypes() {
    return $b1b09ff39d31fcf8$var$idbProxyableTypes || ($b1b09ff39d31fcf8$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $b1b09ff39d31fcf8$var$getCursorAdvanceMethods() {
    return $b1b09ff39d31fcf8$var$cursorAdvanceMethods || ($b1b09ff39d31fcf8$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $b1b09ff39d31fcf8$var$transactionDoneMap = new WeakMap();
const $b1b09ff39d31fcf8$var$transformCache = new WeakMap();
const $b1b09ff39d31fcf8$var$reverseTransformCache = new WeakMap();
function $b1b09ff39d31fcf8$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($b1b09ff39d31fcf8$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $b1b09ff39d31fcf8$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $b1b09ff39d31fcf8$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($b1b09ff39d31fcf8$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $b1b09ff39d31fcf8$var$transactionDoneMap.set(tx, done);
}
let $b1b09ff39d31fcf8$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $b1b09ff39d31fcf8$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $b1b09ff39d31fcf8$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $b1b09ff39d31fcf8$var$replaceTraps(callback) {
    $b1b09ff39d31fcf8$var$idbProxyTraps = callback($b1b09ff39d31fcf8$var$idbProxyTraps);
}
function $b1b09ff39d31fcf8$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($b1b09ff39d31fcf8$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($b1b09ff39d31fcf8$export$debb760848ca95a(this), args);
        return $b1b09ff39d31fcf8$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $b1b09ff39d31fcf8$export$4997ffc0176396a6(func.apply($b1b09ff39d31fcf8$export$debb760848ca95a(this), args));
    };
}
function $b1b09ff39d31fcf8$var$transformCachableValue(value) {
    if (typeof value === 'function') return $b1b09ff39d31fcf8$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $b1b09ff39d31fcf8$var$cacheDonePromiseForTransaction(value);
    if ($b1b09ff39d31fcf8$var$instanceOfAny(value, $b1b09ff39d31fcf8$var$getIdbProxyableTypes())) return new Proxy(value, $b1b09ff39d31fcf8$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $b1b09ff39d31fcf8$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $b1b09ff39d31fcf8$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($b1b09ff39d31fcf8$var$transformCache.has(value)) return $b1b09ff39d31fcf8$var$transformCache.get(value);
    const newValue = $b1b09ff39d31fcf8$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $b1b09ff39d31fcf8$var$transformCache.set(value, newValue);
        $b1b09ff39d31fcf8$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $b1b09ff39d31fcf8$export$debb760848ca95a = (value)=>$b1b09ff39d31fcf8$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $b1b09ff39d31fcf8$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $b1b09ff39d31fcf8$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($b1b09ff39d31fcf8$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $b1b09ff39d31fcf8$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $b1b09ff39d31fcf8$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $b1b09ff39d31fcf8$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $b1b09ff39d31fcf8$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $b1b09ff39d31fcf8$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $b1b09ff39d31fcf8$var$cachedMethods = new Map();
function $b1b09ff39d31fcf8$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($b1b09ff39d31fcf8$var$cachedMethods.get(prop)) return $b1b09ff39d31fcf8$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $b1b09ff39d31fcf8$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $b1b09ff39d31fcf8$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $b1b09ff39d31fcf8$var$cachedMethods.set(prop, method);
    return method;
}
$b1b09ff39d31fcf8$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$b1b09ff39d31fcf8$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$b1b09ff39d31fcf8$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $b1b09ff39d31fcf8$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $b1b09ff39d31fcf8$var$methodMap = {};
const $b1b09ff39d31fcf8$var$advanceResults = new WeakMap();
const $b1b09ff39d31fcf8$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $b1b09ff39d31fcf8$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$b1b09ff39d31fcf8$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $b1b09ff39d31fcf8$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $b1b09ff39d31fcf8$var$methodMap[prop] = function(...args) {
            $b1b09ff39d31fcf8$var$advanceResults.set(this, $b1b09ff39d31fcf8$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $b1b09ff39d31fcf8$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $b1b09ff39d31fcf8$var$cursorIteratorTraps);
    $b1b09ff39d31fcf8$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $b1b09ff39d31fcf8$var$reverseTransformCache.set(proxiedCursor, $b1b09ff39d31fcf8$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($b1b09ff39d31fcf8$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $b1b09ff39d31fcf8$var$advanceResults.delete(proxiedCursor);
    }
}
function $b1b09ff39d31fcf8$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $b1b09ff39d31fcf8$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $b1b09ff39d31fcf8$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$b1b09ff39d31fcf8$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($b1b09ff39d31fcf8$var$isIteratorProp(target, prop)) return $b1b09ff39d31fcf8$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $b1b09ff39d31fcf8$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));
module.exports["unwrap"] = $b1b09ff39d31fcf8$export$debb760848ca95a;
module.exports["openDB"] = $b1b09ff39d31fcf8$export$ca0ed41b1a2af7e;

});

parcelRegister("awSMG", function(module, exports) {
const $4ce470d2dd3584e9$export$6ff460ddb5710005 = 'editor:offline-steps-';
const $4ce470d2dd3584e9$export$7023de141f2ab721 = 'meta';
const $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7 = 'steps';
const $4ce470d2dd3584e9$export$9fd1ded1027f9ea2 = 2;
module.exports["OFFLINE_STEPS_DATABASE_NAME_PREFIX"] = $4ce470d2dd3584e9$export$6ff460ddb5710005;
module.exports["OFFLINE_META_STORE_NAME"] = $4ce470d2dd3584e9$export$7023de141f2ab721;
module.exports["OFFLINE_STEPS_STORE_NAME"] = $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7;
module.exports["OFFLINE_STEPS_DATABASE_VERSION"] = $4ce470d2dd3584e9$export$9fd1ded1027f9ea2;

});

parcelRegister("5wfVt", function(module, exports) {

var $2pjJ5 = parcelRequire("2pjJ5");

const $cadd3bfd971d84fd$export$67504bcc111d98ac = ()=>({
        name: 'empty',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return {
                editorIsEmpty: (0, $2pjJ5.isEmptyDocument)(editorState.doc)
            };
        }
    });
module.exports["emptyStatePlugin"] = $cadd3bfd971d84fd$export$67504bcc111d98ac;

});

parcelRegister("6ysok", function(module, exports) {
/**
 * @generated SignedSource<<4d49c32a869f466fc6b565b519570705>>
 * @relayHash 82f12ac8b34ad91537ec9fdf459226f1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896
const $3ac88c8ffed86645$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "expiryDateTime"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentMediaSessionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentMediaSessionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "82f12ac8b34ad91537ec9fdf459226f1",
            "id": "f65cd186bb1861751eac3934583c401749a09b36b0b45cf1430dc1816d509896",
            "metadata": {},
            "name": "ContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ContentMediaSessionQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value,duration,expiryDateTime},configuration{clientId,fileStoreUrl}}}"
        }
    };
}();
$3ac88c8ffed86645$var$node.hash = "f17b5112a287e607ae81ac1df8d1533e";
var $3ac88c8ffed86645$export$2e2bcd8739ae039 = $3ac88c8ffed86645$var$node;
module.exports["default"] = $3ac88c8ffed86645$export$2e2bcd8739ae039;

});

parcelRegister("dJ5r4", function(module, exports) {
$parcel$export(module.exports, "ViewCommentShortcutListener", () => (parcelRequire("fPcdI")).ViewCommentShortcutListener);

var $fPcdI = parcelRequire("fPcdI");


});

parcelRegister("fPcdI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $liGyh = parcelRequire("liGyh");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $inDu6 = parcelRequire("inDu6");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $gczDe = parcelRequire("gczDe");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $cgy29 = parcelRequire("cgy29");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $c392465906bed01c$var$ViewCommentShortcutListenerComponent = ({ isFabricPage: isFabricPage, contentId: contentId, dialogs: dialogs })=>{
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $42omo.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $42omo.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $42omo.useState)(false);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    // Track previous annotation for difference-based scrolling
    const previousAnnotationRef = (0, $42omo.useRef)(undefined);
    // Update ref whenever activeHighlight changes
    (0, $42omo.useEffect)(()=>{
        // Only update if there's a valid value (not empty string or null)
        if (activeHighlight) previousAnnotationRef.current = activeHighlight;
    }, [
        activeHighlight
    ]);
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $42omo.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                // in SSR, unreadCommentIDSet is undefined
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'viewPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: isFabricPage,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const getCommentIndex = (0, $42omo.useCallback)((currentThreadKey)=>{
        return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((threadKey)=>threadKey === currentThreadKey) : orderedActiveAnnotations?.findIndex((threadKey)=>threadKey === currentThreadKey);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const openInlineComment = (0, $42omo.useCallback)((markerRef)=>{
        if ((pageClass === 'renderer' || pageClass === 'editor') && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                annotationId: markerRef,
                entryPoint: 'comments-shortcuts/ViewCommentShortcutListener',
                pageClass: 'renderer'
            }
        });
        const previousAnnotationId = previousAnnotationRef.current;
        setCurrentlySelectedThreadKey('');
        const commentElement = document.getElementById(markerRef);
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            annotationId: markerRef
        });
        (0, $4EKKB.selectInlineComment).debug(`Keyboard selection now triggering annotation selection for annotation ${markerRef}`);
        emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [
                markerRef
            ],
            eventTarget: commentElement
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: markerRef,
            previousAnnotationId: previousAnnotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass,
        isObjectSidebarShown
    ]);
    const scrollToFooterComment = (0, $42omo.useCallback)((threadKey)=>{
        // Reset previous annotation ref when navigating to footer comment
        previousAnnotationRef.current = undefined;
        setCurrentlySelectedThreadKey(threadKey);
        emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [],
            eventTarget: null
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: 'FOOTER',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const onNavigationClick = (0, $42omo.useCallback)((nextMarkerRef)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                openInlineComment(nextMarkerRef);
            }
        });
        else openInlineComment(nextMarkerRef);
    }, [
        hasContentChanged,
        resetContentChanged,
        showModal,
        openInlineComment
    ]);
    const handlePanelCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Handle panel selection state management in the listener
        setCurrentlySelectedThreadKey(nextRef.ref);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: nextRef.ref,
            commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $42omo.useCallback)(({ action: action, isNavigateToNextUnread: isNavigateToNextUnread })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: false,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        isNextCommentLoading,
        navigateToInlineComment,
        getCommentIndex,
        activeHighlight,
        currentlySelectedThreadKey,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        unreadInlineComments,
        unreadGeneralComments,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap
    ]);
    const handleStandaloneCommentNavigation = (0, $42omo.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: false,
            action: action
        });
        else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (!firstInlineCommentMarkerRef && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? footerCommentThreads.length === 0 : true)) return;
            if (firstInlineCommentMarkerRef) openInlineComment(firstInlineCommentMarkerRef);
            else if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) scrollToFooterComment(footerCommentThreads[0]?.id);
        }
    }, [
        activeHighlight,
        currentlySelectedThreadKey,
        orderedActiveAnnotations,
        handleNextCommentNavigation,
        footerCommentThreads,
        openInlineComment,
        scrollToFooterComment
    ]);
    const handleCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    const handleNextUnreadNavigation = (0, $42omo.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextThreadKey);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextThreadKey,
                commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
                isCommentsPanelOpen: isObjectSidebarShown,
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                shortcutType: (0, $9FoVw.ShortcutType).UNREAD
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) openInlineComment(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        unreadInlineComments,
        activeHighlight,
        openInlineComment,
        scrollToFooterComment,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        footerCommentIds,
        getCommentIndex,
        orderedActiveAnnotations,
        setCurrentlySelectedThreadKey,
        alreadyFetchedInitialData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault();
        // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            if (document.querySelector('[data-testid="highlightActionsPopup"]')) {
                const createButton = document.querySelector('#create-inline-comment-button');
                // if the disabled attribute is there, and comes back as an empty string, it is disabled.
                // If the disabled attribute is not there, it will come back as null
                const createButtonIsDisabled = createButton?.getAttribute('disabled') === '';
                // If createButton is not found or is disabled, do nothing.
                // This handles the case when hovering over media (image/video) objects in renderer.
                // In this scenario, a `highlightActionsPopup` is shown but the Comment button (which
                // has a different id) behaves differently: if any comment exists on the media object,
                // button click opens it as standalone; otherwise button click opens CreateComment.
                // Keyboard shortcut is disabled for this scenario.
                const createButtonIsEnabled = createButton && createButton?.getAttribute('disabled') !== '';
                if ((0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage') ? createButtonIsEnabled : !createButtonIsDisabled) handleCommentButtonClick({
                    dialogs: dialogs,
                    shortcut: shortcut,
                    experienceAttributes: {
                        entryPoint: 'keyboardShortcut',
                        edition: edition
                    }
                });
            } else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutView'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    if (!isFabricPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = document.getElementById('renderer-comments-sidebar') || document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) {
                if ((0, $6mKj3.expVal)('cc_comments_a11y_auto_focus_view_page_inline_modal', 'isEnabled', false)) // Same logic as the else statement below, just a shared function now. Gated for extra safety
                (0, $aHcFH.focusElementAndUpdateTabIndex)(openComment);
                else {
                    openComment.setAttribute('tabIndex', '-1');
                    openComment.focus();
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.NEXT_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to next comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('next');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.PREV_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to previous comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('previous');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('Keyboard navigation to next unread comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleNextUnreadNavigation();
        }
    }), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e)
    }));
};
const $c392465906bed01c$export$c1f9f1253d923bc1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($c392465906bed01c$var$ViewCommentShortcutListenerComponent));
module.exports["ViewCommentShortcutListener"] = $c392465906bed01c$export$c1f9f1253d923bc1;

});

parcelRegister("6pBXK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $95494d62ea246593$export$ffdc57aecb97ae41 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nmqvg",
    name: "ReadingAidsAcronymsHighlighter",
    loader: async ()=>(await (parcelRequire("cnSnX"))).ReadingAidsAcronymsHighlighter
});
module.exports["ReadingAidsAcronymsHighlighter"] = $95494d62ea246593$export$ffdc57aecb97ae41;

});

parcelRegister("cnSnX", function(module, exports) {

let $9041d1d94ad86be6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9041d1d94ad86be6$var$load("6mkG4").then(()=>parcelRequire('6vx1i'));

});

parcelRegister("39nIX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $io723 = parcelRequire("io723");


var $5RuD9 = parcelRequire("5RuD9");


var $jhifQ = parcelRequire("jhifQ");


/* View Mode Exports */ const $166368e9a123fc4e$var$InlineCommentsLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fZs06",
    name: "InlineCommentsLoaderPaint",
    loader: async ()=>(await (parcelRequire("8yjHi"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderLazy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i8DIK",
    name: "InlineCommentsLoaderLazy",
    loader: async ()=>(await (parcelRequire("8yjHi"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vilgC",
    name: "InlineCommentsLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("8yjHi"))).InlineComments
});

const $166368e9a123fc4e$var$InlineCommentsLoaderBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "05zPo",
    name: "InlineCommentsLoaderBackground",
    loader: async ()=>(await (parcelRequire("8yjHi"))).InlineComments
});
const $166368e9a123fc4e$var$loaders = {
    [(0, $398ES.LoadingPriority).LAZY]: $166368e9a123fc4e$var$InlineCommentsLoaderLazy,
    [(0, $398ES.LoadingPriority).PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint
};
const $166368e9a123fc4e$export$bceb71dc98e1c75f = ({ loadingPriority: loadingPriority, focusedCommentId: focusedCommentId, ...rest })=>{
    const CommentsLoader = $166368e9a123fc4e$var$loaders[loadingPriority] || $166368e9a123fc4e$var$InlineCommentsLoaderBackground;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, focusedCommentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        key: `start-${focusedCommentId}`,
        metric: (0, $jhifQ.FOCUSED_INLINE_COMMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CommentsLoader, rest));
};
module.exports["InlineCommentsLoader"] = $166368e9a123fc4e$export$bceb71dc98e1c75f;

});

parcelRegister("5RuD9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8uhVX = parcelRequire("8uhVX");


var $beAZw = parcelRequire("beAZw");

const $58d1b0f1d68392b5$var$checkForSSRFocusedComment = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $58d1b0f1d68392b5$export$d174da0f28ffce9e = ()=>{
    return $58d1b0f1d68392b5$var$checkForSSRFocusedComment() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uhVX.FocusedInlineComment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
};
module.exports["InlineCommentsLoading"] = $58d1b0f1d68392b5$export$d174da0f28ffce9e;

});

parcelRegister("8uhVX", function(module, exports) {
/* FocusedInlineComment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $9wGTI = parcelRequire("9wGTI");


var $2XqLN = parcelRequire("2XqLN");


var $aXWIB = parcelRequire("aXWIB");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");




var $9CnRS = parcelRequire("9CnRS");


var $666Tc = parcelRequire("666Tc");


var $k5dl6 = parcelRequire("k5dl6");



var $f8HSn = parcelRequire("f8HSn");


var $qYtBT = parcelRequire("qYtBT");


var $dQJV7 = parcelRequire("dQJV7");


var $c04ej = parcelRequire("c04ej");

const $d9a6205ec51ab13a$var$parseContent = (0, $2XqLN.default)((content)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch  {
        return null;
    }
});
const $d9a6205ec51ab13a$var$FocusedInlineCommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.SidebarContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_154i1odf _zqk2124n _16tr13gf",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /* Comment Editor CSS*/ 
const $d9a6205ec51ab13a$var$EditorContainerSSRFallback = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_10v51b66 _1fnwia51 _116r1l7b _kv9qfhey _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$EditorContainerSSRTokenized = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_10v51b66 _1fnwia51 _116r12b0 _kv9qfhey _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _1ragidpf _ha8hi7uo",
            __cmplp.isFocused && "_11q71856",
            __cmplp.className
        ])
    });
});
const $d9a6205ec51ab13a$export$622cea445a1c5b7d = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'];
    return 0;
}; // Makes sure to only show focusedInlineCommentSSR if the page was ssr'd
const $d9a6205ec51ab13a$export$db871669e60ed1cb = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $d9a6205ec51ab13a$export$7afb8d400fcdf579 = ()=>{
    const EditorContainerSSR = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $d9a6205ec51ab13a$var$EditorContainerSSRTokenized : $d9a6205ec51ab13a$var$EditorContainerSSRFallback;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const focusedCommentId = match?.query.focusedCommentId;
    const focusedCommentIdString = typeof focusedCommentId === 'string' ? focusedCommentId : ''; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $k5dl6.default), {
        variables: {
            commentId: focusedCommentIdString,
            contentId: contentId
        },
        skip: !(contentId && focusedCommentId)
    });
    let commentData;
    let isTopLevelComment = true; /* If focusedCommentId is a reply grab top-level comment Data from ancestors.
                                 If ancestors is non-empty it means focusedCommentId is a reply*/ 
    if (data?.comments?.nodes?.[0]?.ancestors && data.comments.nodes[0].ancestors.length > 0) {
        commentData = data.comments.nodes[0].ancestors[0];
        isTopLevelComment = false;
    } else commentData = data?.comments?.nodes?.[0];
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['isTopLevelComment'] = isTopLevelComment;
    const content = data?.content?.nodes?.[0];
    const operations = content?.operations || [];
    const canCreateComments = Boolean(operations.find((op)=>op?.operation === 'create' && op?.targetType === 'comment'));
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName;
    const commentId = commentData?.id;
    const when = commentData?.version?.when;
    const commentContent = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const currentUserAvatarUrl = data?.user?.photos?.[0]?.value ?? undefined;
    const currentUserDisplayName = data?.user?.displayName ?? undefined;
    const currentUserId = data?.user?.id;
    const adf = $d9a6205ec51ab13a$var$parseContent(commentContent);
    const renderReplies = ()=>{
        const replies = commentData?.replies || [];
        return replies.map((reply)=>{
            const adf = $d9a6205ec51ab13a$var$parseContent(reply?.body?.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
                key: reply?.id,
                isFocused: focusedCommentId === reply?.id,
                "data-comment-id": reply?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
                commentMode: "view",
                userId: reply?.author?.accountId,
                avatarUrl: reply?.author?.profilePicture?.path,
                displayName: reply?.author?.displayName,
                date: reply?.version?.when,
                permissionType: reply?.author?.permissionType
            }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04ej.CommentRenderer), {
                adf: adf
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQJV7.CommentActions), {
                isReply: true,
                permissions: reply?.permissions
            }));
        });
    }; // Scroll to focusedInlineComment if it's out of the screen
    const scrollOffset = window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'];
    if (scrollOffset) window.scrollTo({
        top: scrollOffset
    });
    if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$FocusedInlineCommentContainer, {
        mode: "view",
        id: "focused-inline-comment-sidebar-skeleton",
        "data-testid": "focused-inline-comment-sidebar-skeleton",
        showSkeleton: $d9a6205ec51ab13a$export$db871669e60ed1cb(),
        offset: $d9a6205ec51ab13a$export$622cea445a1c5b7d()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qYtBT.CommentHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
        tabIndex: -1,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "view",
        userId: topCommentUserId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: when,
        permissionType: permissionType,
        size: "medium"
    }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04ej.CommentRenderer), {
        adf: adf
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQJV7.CommentActions), {
        permissions: commentData?.permissions,
        isReply: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "reply-container"
    }, renderReplies()), canCreateComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EditorContainerSSR, {
        isReply: true,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        avatarUrl: currentUserAvatarUrl,
        displayName: currentUserDisplayName,
        date: when,
        permissionType: permissionType,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        disabled: true,
        placeholder: formatMessage((0, $9CnRS.i18n).replyPlaceholder),
        "aria-label": formatMessage((0, $9CnRS.i18n).replyPlaceholder)
    })))), undefined);
    return null;
};
module.exports["FocusedInlineComment"] = $d9a6205ec51ab13a$export$7afb8d400fcdf579;

});

parcelRegister("f8HSn", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fs6LW = parcelRequire("fs6LW");


var $gvWVt = parcelRequire("gvWVt");


var $1YXTQ = parcelRequire("1YXTQ");


var $7tI6B = parcelRequire("7tI6B");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$DateContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102ewadc _1mil78py _7wy0glyw _1t4pd34b _1plv1j28 _zmp8d34b _9b8id34b _1blwd34b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$var$AuthorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _uvzw1snc _12rjagmp _1vjrvv82 _1dtc4viv _jva41snc _wkreagmp _gcmzvv82 _5xy14viv _1msj4viv",
            __cmplp.commentMode !== 'reply' ? "_18u01i6y" : "_18u01kw7",
            __cmplp.commentMode === 'view' && "_n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$AvatarWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.commentMode === 'view' && "_4t3i1wpv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _4cvr1h6o _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5d34b _1ptk1j28 _19gdazsu _1e6pazsu _1gidazsu _zer61snc _7ec9agmp _1bkkvv82 _z01g4viv _101q1snc _vnv1agmp _94evvv82 _kvyv4viv _18t3x3d0 _1t4p4viv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, displayName: displayName, avatarUrl: avatarUrl, permissionType: permissionType, size: size })=>{
    const isDateShown = commentMode === 'view' && date;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$AuthorContainer, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$AvatarWrapper, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        size: size,
        trigger: "click",
        name: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$ProfileLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, displayName), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: date
    })))));
};
module.exports["CommentAuthor"] = $b0598b16360d1677$export$d05a2f5fbf67a6d7;

});

parcelRegister("qYtBT", function(module, exports) {
/* CommentHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $7N1sB = parcelRequire("7N1sB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9359cd91b07ea16f$var$SidebarHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4ba4q _kqswh2mm _1e0c1txw _4t3i10yn _ca0qutpp _1hadu49m _wzsr12b0 _brspgktf _11pzgktf _p7gl1wug _1p0qutpp _etmr1b66 _13yvyfq0",
            __cmplp.className
        ])
    });
});
const $9359cd91b07ea16f$export$af4e8b81cdb5570a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9359cd91b07ea16f$var$SidebarHeader, {
        "data-testid": "inline-comment-ssr-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
        goToNextInlineComment: ()=>{},
        goToPrevInlineComment: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "overflow-menu-icon",
        color: "var(--ds-icon-disabled, #080F214A)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "close-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "close-icon",
        color: `${"var(--ds-icon-disabled, #080F214A)"}`,
        spacing: "none"
    })));
};
module.exports["CommentHeader"] = $9359cd91b07ea16f$export$af4e8b81cdb5570a;

});

parcelRegister("dQJV7", function(module, exports) {
/* CommentActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $bFPHx = parcelRequire("bFPHx");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6040be4eb93366f$var$ActionsContainerSSR = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.ActionsContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tke10yn _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syaz1rpy _19pk1b66 _xrwlcs5v _144bkb7n _14p1f1ug _ekv6wadc _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _1tzjf4df _8bo21mp2 _nqnu1rpy _d32v1rpy",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$export$e75a036919cd8d68 = ({ isReply: isReply, permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionsContainerSSR, null, permissions.isResolvable && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).resolve))), permissions.isEditable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).edit))), permissions.isRemovable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9CnRS.i18n).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null)));
module.exports["CommentActions"] = $e6040be4eb93366f$export$e75a036919cd8d68;

});

parcelRegister("c04ej", function(module, exports) {
/* CommentRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bzqa9 = parcelRequire("bzqa9");


var $hEeUR = parcelRequire("hEeUR");


var $6mKj3 = parcelRequire("6mKj3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61a27fe9845a1cb4$var$CommentRendererContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});
const $61a27fe9845a1cb4$export$ce6d3ea87eba7794 = ({ adf: adf })=>{
    const eventHandlers = (0, $bzqa9.useEventHandlers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($61a27fe9845a1cb4$var$CommentRendererContainer, {
        id: "ssr-comment-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        document: adf,
        appearance: "comment",
        eventHandlers: eventHandlers,
        ...(0, $6mKj3.expValEquals)('confluence_comments_media_ssr_support', 'isEnabled', true) && {
            media: undefined
        }
    }));
};
module.exports["CommentRenderer"] = $61a27fe9845a1cb4$export$ce6d3ea87eba7794;

});

parcelRegister("beAZw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $rVJpV = parcelRequire("rVJpV");


var $666Tc = parcelRequire("666Tc");

const $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80 = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] && Array.isArray(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'])) return Boolean(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].length);
    return false;
};
const $c9d0ea73f4f989e9$export$e90f33bd7f6da077 = ({ offset: offset = 0 })=>{
    /* For SSR check window object or use offset if passed */ // Previously, clicking on a comment via the inline comment button would still generate an offset.
    // That meant that on transitions, the loading skeleton would still flicker, so we check for window.__SSR_RENDERED__ as well
    /// to prevent the flicker on transitions.
    const sideBarOffset = window.__SSR_RENDERED__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] || offset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.LoadingSkeletonContainer), {
        id: "inline-comment-sidebar-skeleton",
        "data-testid": "inline-comment-sidebar-skeleton",
        showSkeleton: $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80() || Boolean(offset),
        offset: sideBarOffset,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $rVJpV.LoadingSkeletonChildren), null));
};
module.exports["InlineCommentsLoadingSkeleton"] = $c9d0ea73f4f989e9$export$e90f33bd7f6da077;

});

parcelRegister("rVJpV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $9hlns = parcelRequire("9hlns");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $666Tc = parcelRequire("666Tc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4pxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonRow = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_flb7sw": (0, $7sObp.default)(__cmplp.flex),
                "--_11vu6jx": (0, $7sObp.default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _19pk4hp3",
                __cmplp.flex ? "_kkes1ubm" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.useColumnDirection ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$CommentAuthorSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _bfhkizff",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonLine = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_iz5w78": (0, $7sObp.default)(__cmplp.marginBottom, "px"),
                "--_10ib6lf": (0, $7sObp.default)(__cmplp.height, "px"),
                "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rko1l7b _bfhkizff _1bsb1rkg",
                typeof __cmplp.marginBottom === "number" ? "_otyr1s4l" : "_otyrrdoj",
                __cmplp.height ? "_4t3it1jn" : "_4t3iftgi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pku2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SidebarHeader = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41fsj _kqswh2mm _1e0c1txw _1bah1yb4 _4t3i10yn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$CloseButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.InlineHeaderButton) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u014y2 _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$NavContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.NavigationContainer) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$4857ba7068d0bed8 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _otyridpf _kqswh2mm _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$a42ae5e40534ea56 = ()=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 30,
            height: 8,
            marginBottom: 0
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CloseButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: ""
            })
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 5,
            marginTop: 5,
            useColumnDirection: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 81
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 53,
            height: 6
        })))));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium",
            interactionName: "inline-comments-loading-skeleton"
        })));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};
module.exports["LoadingSkeletonChildren"] = $f5ae94c9feb318d8$export$a42ae5e40534ea56;

});

parcelRegister("8yjHi", function(module, exports) {

let $63a0c72a14a99a2e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63a0c72a14a99a2e$var$load("dvUU0"),
    $63a0c72a14a99a2e$var$load("cLmw6"),
    $63a0c72a14a99a2e$var$load("4pqtR"),
    $63a0c72a14a99a2e$var$load("5XqRg"),
    $63a0c72a14a99a2e$var$load("6wr18"),
    $63a0c72a14a99a2e$var$load("dUwYW"),
    $63a0c72a14a99a2e$var$load("lg1HU"),
    $63a0c72a14a99a2e$var$load("lNrIG"),
    $63a0c72a14a99a2e$var$load("cKqFC"),
    $63a0c72a14a99a2e$var$load("6cnH1"),
    $63a0c72a14a99a2e$var$load("h9Ed7"),
    $63a0c72a14a99a2e$var$load("lkOIY"),
    $63a0c72a14a99a2e$var$load("dI1Cd"),
    $63a0c72a14a99a2e$var$load("7EorR"),
    $63a0c72a14a99a2e$var$load("ffEVr"),
    $63a0c72a14a99a2e$var$load("3JSgG"),
    $63a0c72a14a99a2e$var$load("dP7ao"),
    $63a0c72a14a99a2e$var$load("8ublV"),
    $63a0c72a14a99a2e$var$load("a8Rqp"),
    $63a0c72a14a99a2e$var$load("1EWOs"),
    $63a0c72a14a99a2e$var$load("1PFZq")
]).then(()=>parcelRequire('31yzi'));

});

parcelRegister("aXika", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $ep3mz = parcelRequire("ep3mz");


var $4zbo1 = parcelRequire("4zbo1");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $9Q3jD = parcelRequire("9Q3jD");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $1NBp8 = parcelRequire("1NBp8");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $isEtk = parcelRequire("isEtk");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $bQm3c = parcelRequire("bQm3c");


var $2VQ4B = parcelRequire("2VQ4B");


var $io723 = parcelRequire("io723");


var $essql = parcelRequire("essql");


var $gsWjA = parcelRequire("gsWjA");


var $2aFNh = parcelRequire("2aFNh");


var $iuaOs = parcelRequire("iuaOs");

const $50e9068f0df1c4d8$var$pageMap = {
    SPACE_OVERVIEW: {
        route: (0, $1NBp8.SPACE_OVERVIEW),
        errorAttribution: 'next-space-overview',
        name: (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE),
        isContentView: false
    },
    COMPANY_HUB: {
        route: (0, $1NBp8.COMPANY_HUB),
        errorAttribution: 'next-company-hub',
        name: (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE),
        isContentView: false
    },
    page: {
        route: (0, $1NBp8.VIEW_PAGE),
        errorAttribution: 'next-view-page',
        name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
        isContentView: true
    }
};
const $50e9068f0df1c4d8$export$2fe638b9bbc723fb = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, spaceKey: spaceKey, children: children, stickyHeader: stickyHeader, contentScreenStyles: contentScreenStyles, isContainerContentView: isContainerContentView = true, versionOverride: versionOverride = null, customPerfData: customPerfData, isEmbeddedPage: isEmbeddedPage })=>{
    const { setCurrentDocumentVersion: setCurrentDocumentVersion, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const [{ routeName: routeName = '', contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'view'
        }
    });
    const extractDataAndSetPublishedVersion = (0, $42omo.useCallback)(({ refetchContentQueryResult: refetchContentQueryResult })=>{
        const { data: data } = refetchContentQueryResult;
        if (data) {
            const versionNumber = data.content?.nodes?.[0]?.version?.number;
            if (versionNumber !== undefined && versionNumber !== null) setPublishedDocumentVersion(versionNumber);
        }
    }, [
        setPublishedDocumentVersion
    ]);
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
    const contentQueryResult = (0, $j1Ss3.useQuery)(chooseContentUnifiedQuery, {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: !contentId || !spaceKey,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: versionOverride,
            useNewContentTopper: true
        }
    });
    const { route: route, errorAttribution: errorAttribution, name: name, isContentView: isContentView } = $50e9068f0df1c4d8$var$pageMap[routeName] ?? $50e9068f0df1c4d8$var$pageMap['page'];
    const { refetch: refetch } = contentQueryResult;
    (0, $2aFNh.useContentExtensionMetrics)(contentQueryResult?.data?.content?.nodes?.[0]?.body?.dynamic?.value, customPerfData);
    (0, $42omo.useEffect)(()=>{
        // If navigating to a different page, always assume document is up to date.
        // Added for COMMENTS-5327, so when user jumps from an outdated page to another
        // up-to-date page, we won't disable the comment button due to outdated-ness.
        // Caveat: The destination page may not actually be up-to-date, e.g. if the
        // page content was loaded from cache that's saved from the user's previous
        // visit in the same browser tab, and a new version was published since then.
        // Invoking `setDocumentNeedsUpdate(false)` here means `documentNeedsUpdate`
        // may be `false` when page is actually outdated, but this scenario can already
        // occur before this change. COMMENTS-5816 tracks fixing this scenario altogether.
        if ((0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated', 'isEnabled', true)) {
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // With confluence_fe_disable_comment_if_page_outdated_v2 ON,
            // `documentNeedsUpdate` is set to true whenever we set a new
            // `publishedDocumentVersion` IF it's different from `currentDocumentVersion`.
            // This useEffect can be cleaned up after v2 is fully rolled out.
            setDocumentNeedsUpdate(false);
        }
    }, [
        contentId,
        setDocumentNeedsUpdate
    ]);
    // Use this instead of `contentQueryResult.data?.content?.nodes?.[0]?.version?.number`
    // because that field is fetched by other queries too, and thus may become mismatched
    // with the actual version of `body` in GQL cache.
    const contentVersion = contentQueryResult.data?.content?.nodes?.[0]?.body?.dynamic?.content?.version?.number;
    (0, $42omo.useEffect)(()=>{
        if (contentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setCurrentDocumentVersion(contentVersion);
    }, [
        contentVersion,
        setCurrentDocumentVersion
    ]);
    const reload = (0, $42omo.useCallback)(async ()=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
            attributes: {
                contentType: (0, $8Ss4E.routeNameToContentTypeMap)[routeName],
                contentId: contentId,
                isSpaceOverviewNextRendered: true,
                edition: edition,
                quickReload: true //tell exp metrics error came from reload and not primary experience
            }
        });
        try {
            const refetchContentQueryResult = await refetch({
                contentId: contentId,
                timestamp: Date.now()
            });
            extractDataAndSetPublishedVersion({
                refetchContentQueryResult: refetchContentQueryResult
            });
        } catch (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                (0, $fGzMp.getExperienceTracker)().abort({
                    name: name,
                    reason: 'Expected Apollo error'
                });
                return; //if it's an expected GQL failure don't throw or fail the experience
            }
            (0, $fGzMp.stopExperienceOnError)(name, error);
            throw error; //this successfully avoids the success below
        }
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: name
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        refetch,
        contentId
    ]);
    const content = contentQueryResult.data?.content?.nodes?.[0];
    const fabricEditorSupported = contentQueryResult.loading ? null : content?.metadata?.frontend?.fabricEditorSupported ?? null;
    const bodyRepresentation = contentQueryResult.loading ? null : content?.body?.dynamic?.representation ?? null;
    (0, $iuaOs.useContentReloadOnFabricSupportChange)({
        contentId: contentId,
        fabricEditorSupported: fabricEditorSupported,
        bodyRepresentation: bodyRepresentation,
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'content',
        types: [
            (0, $c0urc.ReloadType).content,
            (0, $c0urc.ReloadType).comment
        ],
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'commentsDataManager',
        types: [
            (0, $c0urc.ReloadType).comment
        ],
        reload: async ()=>{
            if ((0, $6mKj3.expValEquals)('cc_comments_pubsub_flag_click_observer', 'isEnabled', true) && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) await (0, $4L9ve.getProcessedCommentsDataState)().refetch?.();
        },
        priority: (0, $c0urc.ReloadPriority).background
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
        key: contentId,
        metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
        contentId: contentId,
        mode: (0, $5kjCz.RENDERER),
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Q3jD.PagePrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $isEtk.ContentStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4zbo1.ContentContainer), {
        fetchTheme: true,
        contentId: contentId,
        spaceKey: spaceKey,
        key: "content-screen",
        errorAttribution: errorAttribution,
        isScreenContentView: isContentView,
        isContainerContentView: isContainerContentView,
        contentScreenStyles: contentScreenStyles,
        stickyHeader: stickyHeader,
        versionOverride: versionOverride,
        isEmbeddedPage: isEmbeddedPage
    }, ({ isThemed: isThemed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("article", null, children && children({
            isThemed: isThemed,
            contentQueryData: contentQueryResult.data,
            contentQueryError: contentQueryResult.error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC),
            customData: {
                isThemed: isThemed
            }
        }))))));
});
module.exports["ViewPageContainer"] = $50e9068f0df1c4d8$export$2fe638b9bbc723fb;

});

parcelRegister("gsWjA", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $4icDV = parcelRequire("4icDV");

var $70LTe = parcelRequire("70LTe");


var $gzdsP = parcelRequire("gzdsP");


var $bQm3c = parcelRequire("bQm3c");


var $iFjdQ = parcelRequire("iFjdQ");


var $lSOAM = parcelRequire("lSOAM");

var $i3c1S = parcelRequire("i3c1S");


var $jX1qB = parcelRequire("jX1qB");

var $5q601 = parcelRequire("5q601");

var $1UCmC = parcelRequire("1UCmC");


var $lXYVJ = parcelRequire("lXYVJ");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");

parcelRequire("1InRL");
var $hlP5l = parcelRequire("hlP5l");


var $5qUgM = parcelRequire("5qUgM");


var $7d41Y = parcelRequire("7d41Y");


var $1q7H7 = parcelRequire("1q7H7");


var $aWrnw = parcelRequire("aWrnw");


var $dpv0X = parcelRequire("dpv0X");


var $5YLPl = parcelRequire("5YLPl");


var $9SsRl = parcelRequire("9SsRl");


var $fgdVB = parcelRequire("fgdVB");


var $itS9i = parcelRequire("itS9i");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");

const $a99ff50c139ee598$var$baseConfig = {
    slo: {
        // based on production p90
        fmp: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        },
        tti: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        }
    },
    histogram: {
        // based on pre-production pollinator and prod p90
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'fy21-legacy-fmp',
            endMark: 'fy21-legacy-fmp'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        },
        {
            key: 'fy21-legacy-tti',
            endMark: 'fy21-legacy-tti'
        },
        {
            key: 'fy23-legacy-tti',
            endMark: 'fy23-legacy-tti'
        }
    ]
};
const $a99ff50c139ee598$var$NOOP = ()=>{};
const $a99ff50c139ee598$export$2d5e2a82ee58820b = ({ isLite: isLite, isAnonymous: isAnonymous, isInitialLoad: isInitialLoad })=>{
    if (isLite) return [
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC)
    ];
    const segments = [
        // New metric adding to this list should also be added to fmpAsUntilStopTimeMetrics
        // See comments in fmpAsUntilStopTimeMetrics for more information
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC),
        $a99ff50c139ee598$export$e190581c76254e9
    ];
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) {
        segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC));
        segments.push((0, $1q7H7.PAGE_TREE_METRIC));
    }
    if (!isAnonymous) // Note: the edit button metric is not currently tracked because there is no
    // guarantee that segment will fire even for authenticated users
    {
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) segments.push((0, $7d41Y.FAVOURITE_BUTTON_METRIC), (0, $9SsRl.WATCH_BUTTON_METRIC));
    }
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics = ({ isLite: isLite })=>{
    if (isLite) return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY)
    ];
    return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY)
    ];
};
const $a99ff50c139ee598$export$acf5746d268ae4ee = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { contentId: contentId, isLite: isLite, customConfig: customConfig } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const pageLoadMetricRef = (0, $42omo.useRef)();
    const sendMetrics = (0, $70LTe.useEmbeddedConfluenceEventMarkers)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== customConfig?.expectedPageLoadSegments || $[2] !== customConfig?.fmpUntilStopTimeMetrics || $[3] !== customConfig?.pageLoadKey || $[4] !== isEmbeddedConfluence || $[5] !== isLite || $[6] !== sendMetrics || $[7] !== userId) {
        t1 = ()=>{
            const _isInitialLoad = (0, $6VdZc.isInitial)();
            const expectedPageSegments = customConfig?.expectedPageLoadSegments ?? $a99ff50c139ee598$export$2d5e2a82ee58820b({
                isAnonymous: Boolean(!userId),
                isInitialLoad: _isInitialLoad,
                isLite: isLite
            });
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.cacheExpectedViewPageSegments)(expectedPageSegments);
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            const untilExperienceMetricNames = customConfig?.fmpUntilStopTimeMetrics ?? $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics({
                isLite: isLite
            });
            const untilPageSegments = expectedPageSegments.map((segment)=>({
                    experience: segment,
                    useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
                }));
            pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
                ...$a99ff50c139ee598$var$baseConfig,
                key: customConfig?.pageLoadKey ?? (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
                timings: [
                    ...$a99ff50c139ee598$var$baseConfig.timings,
                    ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
                ],
                include: expectedPageSegments,
                until: untilPageSegments
            });
            if (!_isInitialLoad) expectedPageSegments.forEach($a99ff50c139ee598$var$_temp);
            pageLoadMetricRef.current.startPageLoad();
            pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
            pageLoadMetricRef.current.onStop((0, $lXYVJ.resetViewTransitionSource), (0, $lXYVJ.resetViewTransitionSource));
            pageLoadMetricRef.current.onStop((data)=>{
                (0, $dpv0X.markLegacyFY23TTI)(pageLoadMetricRef.current, data);
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (isEmbeddedConfluence) {
                    const observableObject = (0, $gzdsP.getIframeObservable_DO_NOT_USE)();
                    const uniqueKey = observableObject?.object?.uniqueKey;
                    sendMetrics({
                        timestamp: Date.now(),
                        customData: {
                            ...uniqueKey ? {
                                uniqueKey: uniqueKey
                            } : {}
                        }
                    }, `${(0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $4icDV.EMBEDDED_VIEW_TTI)}`);
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__)) {
                    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    if (!(0, $9wGTI.fg)("confluence_frontend_sfx_hydration_errors") && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.length > 0) {
                        const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
                        window.__HYDRATION_ERRORS__.forEach((error)=>{
                            if (error.type) {
                                const normalizedType = error.type.startsWith("UNSAFE_") ? error.type.slice(7) : error.type;
                                monitoringClient.incrementCounter("hydrationErrorCount", [
                                    `type:${normalizedType}`,
                                    `route:${route}`
                                ]);
                            }
                        });
                    }
                    if ((0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
                        source: "viewPageCommon",
                        route: route,
                        errorWithRoute: errorWithRoute,
                        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
                    })).fire();
                    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
                        attribution: "hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__) && Boolean(window.__SSR_REACT_STREAMING__) && !(0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) {
                    const { error: errorWithRoute_0 } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute_0, {
                        attribution: "streaming-hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            return ()=>{
                pageLoadMetricRef.current?.cancel();
            };
        };
        $[0] = createAnalyticsEvent;
        $[1] = customConfig?.expectedPageLoadSegments;
        $[2] = customConfig?.fmpUntilStopTimeMetrics;
        $[3] = customConfig?.pageLoadKey;
        $[4] = isEmbeddedConfluence;
        $[5] = isLite;
        $[6] = sendMetrics;
        $[7] = userId;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== contentId || $[10] !== createAnalyticsEvent || $[11] !== customConfig || $[12] !== isEmbeddedConfluence || $[13] !== isLite || $[14] !== sendMetrics || $[15] !== userId) {
        t2 = [
            contentId,
            customConfig,
            userId,
            isLite,
            isEmbeddedConfluence,
            sendMetrics,
            createAnalyticsEvent
        ];
        $[9] = contentId;
        $[10] = createAnalyticsEvent;
        $[11] = customConfig;
        $[12] = isEmbeddedConfluence;
        $[13] = isLite;
        $[14] = sendMetrics;
        $[15] = userId;
        $[16] = t2;
    } else t2 = $[16];
    (0, $42omo.useEffect)(t1, t2);
    return null;
};
const $a99ff50c139ee598$export$e190581c76254e9 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
function $a99ff50c139ee598$var$_temp(m) {
    return m.startFromPageLoad();
}
module.exports["VIEW_PAGE_CONTAINER_METRIC"] = $a99ff50c139ee598$export$e190581c76254e9;
module.exports["StartViewPageLoad"] = $a99ff50c139ee598$export$acf5746d268ae4ee;

});

parcelRegister("1InRL", function(module, exports) {
$parcel$export(module.exports, "BYLINE_METRIC", () => (parcelRequire("hlP5l")).BYLINE_METRIC);
$parcel$export(module.exports, "CONTENT_TITLE_METRIC", () => (parcelRequire("hlP5l")).CONTENT_TITLE_METRIC);

var $hlP5l = parcelRequire("hlP5l");


});

parcelRegister("dpv0X", function(module, exports) {

var $5YLPl = parcelRequire("5YLPl");

const $79e64809bb47109c$export$1d7a42050347be43 = (pageLoadMetric, data)=>{
    const contentRendererLegacyMark = (0, $5YLPl.CONTENT_RENDERER_METRIC).getData().marks['fy23-legacy-tti'] || 0;
    const pageLoadMark = data?.stopTime || 0;
    pageLoadMetric?.mark('fy23-legacy-tti', Math.max(pageLoadMark, contentRendererLegacyMark));
};
module.exports["markLegacyFY23TTI"] = $79e64809bb47109c$export$1d7a42050347be43;

});

parcelRegister("2aFNh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7r2px = parcelRequire("7r2px");

function $73c871442f6e75aa$export$6bbd36bf45aa851e(contentBody, customPerfData) {
    const memoRef = (0, $42omo.useRef)({
        contentBody: undefined,
        contentExtensionMetrics: undefined
    });
    if (customPerfData && (memoRef.current.contentBody !== contentBody || !('contentExtensionMetrics' in customPerfData))) {
        // `retrieveContentExtensionsMetrics` parses the ADF string into JSON, but that's likely to be only one of multiple such parsings.
        // For example, the Atlaskit editor/renderer will very likely parse the ADF string into JSON as well.
        // For large documents (e.g. 16MB) such parsing can take noticeable time which is undesirable especially before rendering.
        // This allows an alternative to `retrieveContentExtensionsMetrics` to optionally perform the computation in a more performant way.
        // But if it doesn't, `retrieveContentExtensionsMetrics` will be the fallback.
        let propertyValue;
        Object.defineProperty(customPerfData, 'contentExtensionMetrics', {
            enumerable: true,
            get () {
                if (propertyValue) return propertyValue;
                memoRef.current.contentBody = contentBody;
                const contentExtensionMetrics = contentBody ? (0, $7r2px.retrieveContentExtensionMetrics)(contentBody) : {};
                memoRef.current.contentExtensionMetrics = contentExtensionMetrics;
                return memoRef.current.contentExtensionMetrics;
            },
            set (value) {
                propertyValue = value;
            }
        });
    }
}
module.exports["useContentExtensionMetrics"] = $73c871442f6e75aa$export$6bbd36bf45aa851e;

});

parcelRegister("iuaOs", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");

const $53a589a30318add1$export$c86a38251c189bb6 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { contentId: contentId, fabricEditorSupported: fabricEditorSupported, bodyRepresentation: bodyRepresentation, reload: reload } = t0;
    const currentContentId = (0, $42omo.useRef)(null);
    const currentFabricEditorSupportedRef = (0, $42omo.useRef)(null);
    const currentBodyRepresentationRef = (0, $42omo.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== bodyRepresentation || $[1] !== contentId || $[2] !== fabricEditorSupported || $[3] !== reload) {
        t1 = ()=>{
            if (!(0, $9wGTI.fg)("confluence_refetch_content_on_fabric_support_chng")) return;
            if (contentId !== currentContentId.current) {
                currentContentId.current = contentId;
                currentFabricEditorSupportedRef.current = fabricEditorSupported;
                currentBodyRepresentationRef.current = bodyRepresentation;
            } else {
                if (fabricEditorSupported === null || currentFabricEditorSupportedRef.current === null || bodyRepresentation === null || currentBodyRepresentationRef.current === null) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                } else if (fabricEditorSupported !== currentFabricEditorSupportedRef.current || bodyRepresentation !== currentBodyRepresentationRef.current) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                    reload();
                }
            }
        };
        t2 = [
            contentId,
            fabricEditorSupported,
            bodyRepresentation,
            reload
        ];
        $[0] = bodyRepresentation;
        $[1] = contentId;
        $[2] = fabricEditorSupported;
        $[3] = reload;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
};
module.exports["useContentReloadOnFabricSupportChange"] = $53a589a30318add1$export$c86a38251c189bb6;

});

parcelRegister("dLc9m", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cZa7r = parcelRequire("cZa7r");


var $cD1qu = parcelRequire("cD1qu");


var $inDu6 = parcelRequire("inDu6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $gfqXk = parcelRequire("gfqXk");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $cgy29 = parcelRequire("cgy29");


var $liGyh = parcelRequire("liGyh");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fHAwL = parcelRequire("fHAwL");


var $3YBks = parcelRequire("3YBks");


var $gtj7V = parcelRequire("gtj7V");


var $bQm3c = parcelRequire("bQm3c");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $7e419a56a8ff4128$var$EditorCommentShortcutListenerComponent = ({ contentId: contentId, viewMode: viewMode, dialogs: dialogs })=>{
    const { navigateToInlineComment: navigateToInlineComment, setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $42omo.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $42omo.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $42omo.useState)(false);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    // Track previous annotation for difference-based scrolling
    const previousAnnotationRef = (0, $42omo.useRef)(undefined);
    // Update ref whenever activeHighlight changes
    (0, $42omo.useEffect)(()=>{
        // Only update if there's a valid value (not empty string or null)
        if (activeHighlight) previousAnnotationRef.current = activeHighlight;
    }, [
        activeHighlight
    ]);
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageClass = (0, $9QIM2.usePageClass)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $42omo.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                // in SSR, unreadCommentIDSet is undefined
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: true,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const onNavigationClick = (0, $42omo.useCallback)((nextMarkerRef)=>{
        const previousAnnotationId = previousAnnotationRef.current;
        setCurrentlySelectedThreadKey('');
        if (!nextMarkerRef) return;
        emitter.emit('setselectedannotation', nextMarkerRef);
        const commentElement = document.getElementById(nextMarkerRef);
        if (commentElement) {
            /*
				 * Don't start the experience if the create sidebar is shown because we can't predict
				 * if the user will close the create sidebar to continue the navigation or create a
				 * new comment. If the user continues the navigation, the experience will be started
				 * by the annotation-provider-inline-comments/editor/ViewManager entrypoint.
				 */ if (document.querySelector('[data-testid="editor-create-sidebar"]') === null && (pageClass === 'renderer' || pageClass === 'editor') && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    annotationId: nextMarkerRef,
                    entryPoint: 'comments-shortcuts/EditorCommentShortcutListener',
                    pageClass: 'editor'
                }
            });
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).EDITOR,
                block: 'center',
                annotationId: nextMarkerRef,
                previousAnnotationId: previousAnnotationId,
                commentType: 'INLINE'
            });
        }
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass
    ]);
    const scrollToFooterComment = (0, $42omo.useCallback)((threadKey)=>{
        // Reset previous annotation ref when navigating to footer comment
        previousAnnotationRef.current = undefined;
        // Close inline comment when keyboard navigating from inline comment to footer comment
        emitter.emit('closeinlinecomment');
        setEditorViewProps(null);
        setCurrentlySelectedThreadKey(threadKey);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: 'FOOTER',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true
        });
        setActiveHighlight(threadKey);
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        setActiveHighlight,
        setEditorViewProps,
        isObjectSidebarShown
    ]);
    const getCommentIndex = (0, $42omo.useCallback)((currentMarkerRef)=>{
        return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((markerRef)=>markerRef === currentMarkerRef) : orderedActiveAnnotations?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const handlePanelCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Handle panel selection state management in the listener
        setCurrentlySelectedThreadKey(nextRef.ref);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: nextRef.ref,
            commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).EDITOR,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $42omo.useCallback)(({ isNavigateToNextUnread: isNavigateToNextUnread, action: action })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: true,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        activeHighlight,
        navigateToInlineComment,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        getCommentIndex,
        isNextCommentLoading,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        unreadInlineComments
    ]);
    const handleStandaloneCommentNavigation = (0, $42omo.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: false,
            action: action
        });
        else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (firstInlineCommentMarkerRef) onNavigationClick(firstInlineCommentMarkerRef);
            else if (pageMode === (0, $cD1qu.PageMode).LIVE && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // Only Live pages have footer comments which is navigable
            {
                if (footerCommentThreads.length > 0) scrollToFooterComment(footerCommentThreads[0]?.id);
            }
        }
    }, [
        activeHighlight,
        onNavigationClick,
        handleNextCommentNavigation,
        scrollToFooterComment,
        footerCommentThreads,
        pageMode,
        currentlySelectedThreadKey,
        orderedActiveAnnotations
    ]);
    const handleCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    const handleNextUnreadNavigation = (0, $42omo.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        if (unreadInlineComments.length + unreadGeneralComments.length === 0) // No unread comments - don't do anything
        return;
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextThreadKey);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextThreadKey,
                commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
                isCommentsPanelOpen: isObjectSidebarShown,
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).EDITOR,
                shortcutType: (0, $9FoVw.ShortcutType).UNREAD
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) onNavigationClick(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        onNavigationClick,
        activeHighlight,
        unreadInlineComments,
        unreadGeneralComments,
        currentlySelectedThreadKey,
        scrollToFooterComment,
        orderedActiveAnnotations,
        getCommentIndex,
        footerCommentIds,
        setCurrentlySelectedThreadKey,
        alreadyFetchedInitialData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e, shortcut)=>{
        e.preventDefault();
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            if (document.querySelector('[data-testid="add-comment-media-button"]') && (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage')) {
                // This is the Comment button for media (image/video) objects in editor, which
                // handles keyboard shortcut separately. So just start the compound experience.
                (0, $3YBks.createInlineCommentCompoundExperience).start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'block',
                        blockType: 'media',
                        entryPoint: 'keyboardShortcut',
                        edition: edition
                    }
                });
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
                // Without this, initExperience will fail since it won't find a draft annotation.
                // So soft-fail it here to avoid failing the entire compound experience.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Media in editor has no draft annotation as expected'));
            } else if (document.querySelector('[data-testid="ak-editor-annotation-toolbar-create-button"]')) handleCommentButtonClick({
                dialogs: dialogs,
                shortcut: shortcut,
                experienceAttributes: {
                    entryPoint: 'keyboardShortcut',
                    edition: edition
                }
            });
            else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutEditor'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = document.getElementById('editor-comments-sidebar') || document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) {
                if ((0, $6mKj3.expVal)('cc_comments_a11y_auto_focus_view_page_inline_modal', 'isEnabled', false)) // Same logic as the else statement below, just a shared function now. Gated for extra safety
                (0, $aHcFH.focusElementAndUpdateTabIndex)(openComment);
                else {
                    openComment.setAttribute('tabIndex', '-1');
                    openComment.focus();
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: viewMode ? (0, $gnkil.PREV_COMMENT_SHORTCUT) : undefined,
        listener: ()=>handleCommentNavigation('previous')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: viewMode ? (0, $gnkil.NEXT_COMMENT_SHORTCUT) : undefined,
        listener: ()=>handleCommentNavigation('next')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: handleNextUnreadNavigation
    }), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e, (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR))
    }));
};
const $7e419a56a8ff4128$export$60fc9509b9a2d030 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($7e419a56a8ff4128$var$EditorCommentShortcutListenerComponent));
module.exports["EditorCommentShortcutListener"] = $7e419a56a8ff4128$export$60fc9509b9a2d030;

});

parcelRegister("1l6y9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8Tj57 = parcelRequire("8Tj57");

const $bf189bcc55d60d3f$export$eff3dda3a84b308a = ()=>{
    const [startingLinks, setStartingLinks] = (0, $42omo.useState)();
    const onEditorReady = (0, $42omo.useCallback)(async (editorActions)=>{
        const adf = await editorActions.getValue();
        const links = (0, $8Tj57.getAllSmartLinks)(adf);
        setStartingLinks(links);
    }, []);
    return {
        onEditorReady: onEditorReady,
        startingLinks: startingLinks
    };
};
module.exports["useInviteFromLinkExperimentEditor"] = $bf189bcc55d60d3f$export$eff3dda3a84b308a;

});


//# sourceMappingURL=FullPageEditorComponent.61c24e85.js.map
